/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2382);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(187);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(2160)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(2266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(2262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(2277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(2263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(2264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(831);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(2265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(2275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(2268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(2269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(2273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(833);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputListDropDown = exports.InputListHasSuggestions = exports.InputList = exports.DropDownTreeSelectOneElement = exports.DropDownTreeMultipleSelect = exports.TextMessage = exports.DropDownMultipleSelect = exports.InputPassword = exports.InputNumber = exports.Text = exports.InputTuKhoa = exports.CheckBox = exports.RadioButton = exports.TextArea = exports.Input = exports.DatePicker = exports.DropDown = undefined;

var _DropDown = __webpack_require__(1512);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _DatePicker = __webpack_require__(501);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Input = __webpack_require__(502);

var _Input2 = _interopRequireDefault(_Input);

var _TextArea = __webpack_require__(1524);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _RadioButton = __webpack_require__(1522);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _CheckBox = __webpack_require__(1511);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _InputTuKhoa = __webpack_require__(1521);

var _InputTuKhoa2 = _interopRequireDefault(_InputTuKhoa);

var _Text = __webpack_require__(1523);

var _Text2 = _interopRequireDefault(_Text);

var _InputNumber = __webpack_require__(1519);

var _InputNumber2 = _interopRequireDefault(_InputNumber);

var _InputPassword = __webpack_require__(1520);

var _InputPassword2 = _interopRequireDefault(_InputPassword);

var _DropDownMultipleSelect = __webpack_require__(1513);

var _DropDownMultipleSelect2 = _interopRequireDefault(_DropDownMultipleSelect);

var _TextMessage = __webpack_require__(1525);

var _TextMessage2 = _interopRequireDefault(_TextMessage);

var _DropDownTreeMultipleSelect = __webpack_require__(1514);

var _DropDownTreeMultipleSelect2 = _interopRequireDefault(_DropDownTreeMultipleSelect);

var _DropDownTreeSelectOneElement = __webpack_require__(1515);

var _DropDownTreeSelectOneElement2 = _interopRequireDefault(_DropDownTreeSelectOneElement);

var _InputList = __webpack_require__(1516);

var _InputList2 = _interopRequireDefault(_InputList);

var _InputListHasSuggestions = __webpack_require__(1518);

var _InputListHasSuggestions2 = _interopRequireDefault(_InputListHasSuggestions);

var _InputListDropDown = __webpack_require__(1517);

var _InputListDropDown2 = _interopRequireDefault(_InputListDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDown = _DropDown2.default;
exports.DatePicker = _DatePicker2.default;
exports.Input = _Input2.default;
exports.TextArea = _TextArea2.default;
exports.RadioButton = _RadioButton2.default;
exports.CheckBox = _CheckBox2.default;
exports.InputTuKhoa = _InputTuKhoa2.default;
exports.Text = _Text2.default;
exports.InputNumber = _InputNumber2.default;
exports.InputPassword = _InputPassword2.default;
exports.DropDownMultipleSelect = _DropDownMultipleSelect2.default;
exports.TextMessage = _TextMessage2.default;
exports.DropDownTreeMultipleSelect = _DropDownTreeMultipleSelect2.default;
exports.DropDownTreeSelectOneElement = _DropDownTreeSelectOneElement2.default;
exports.InputList = _InputList2.default;
exports.InputListHasSuggestions = _InputListHasSuggestions2.default;
exports.InputListDropDown = _InputListDropDown2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFile = exports.validatable = exports.ShowIfCheck = exports.ShowIf = undefined;

var _ShowIf = __webpack_require__(1579);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

var _ShowIfCheck = __webpack_require__(1580);

var _ShowIfCheck2 = _interopRequireDefault(_ShowIfCheck);

var _validatable = __webpack_require__(1582);

var _validatable2 = _interopRequireDefault(_validatable);

var _download = __webpack_require__(1581);

var _download2 = _interopRequireDefault(_download);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ShowIf = _ShowIf2.default;
exports.ShowIfCheck = _ShowIfCheck2.default;
exports.validatable = _validatable2.default;
exports.downloadFile = _download2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaoCaoThanhTra = exports.QuanLyVanBan = exports.QuanLyHoSo = exports.TheoDoiGiamSat = exports.ThanhTra = exports.ThongKeBaoCao = exports.TrangChu = exports.DuLieuHeThong = exports.GiaiQuyetDonThu = exports.Letter = exports.LetterProcessingWorkFlow = exports.LetterProcessing = exports.Reception = exports.User = exports.Danhmuc = undefined;

var _danhMuc = __webpack_require__(941);

var _danhMuc2 = _interopRequireDefault(_danhMuc);

var _users = __webpack_require__(954);

var _users2 = _interopRequireDefault(_users);

var _reception = __webpack_require__(949);

var _reception2 = _interopRequireDefault(_reception);

var _letterProcessing = __webpack_require__(945);

var _letterProcessing2 = _interopRequireDefault(_letterProcessing);

var _letterProcessingWorkFlow = __webpack_require__(946);

var _letterProcessingWorkFlow2 = _interopRequireDefault(_letterProcessingWorkFlow);

var _letter = __webpack_require__(944);

var _letter2 = _interopRequireDefault(_letter);

var _giaiQuyetDonThu = __webpack_require__(943);

var _giaiQuyetDonThu2 = _interopRequireDefault(_giaiQuyetDonThu);

var _duLieuHeThong = __webpack_require__(942);

var _duLieuHeThong2 = _interopRequireDefault(_duLieuHeThong);

var _trangChu = __webpack_require__(953);

var _trangChu2 = _interopRequireDefault(_trangChu);

var _thongKeBaoCao = __webpack_require__(952);

var _thongKeBaoCao2 = _interopRequireDefault(_thongKeBaoCao);

var _thanhtra = __webpack_require__(950);

var _thanhtra2 = _interopRequireDefault(_thanhtra);

var _theodoigiamsat = __webpack_require__(951);

var _theodoigiamsat2 = _interopRequireDefault(_theodoigiamsat);

var _quanLyHoSo = __webpack_require__(947);

var _quanLyHoSo2 = _interopRequireDefault(_quanLyHoSo);

var _quanLyVanBan = __webpack_require__(948);

var _quanLyVanBan2 = _interopRequireDefault(_quanLyVanBan);

var _baoCaoThanhTra = __webpack_require__(940);

var _baoCaoThanhTra2 = _interopRequireDefault(_baoCaoThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Danhmuc = _danhMuc2.default;
exports.User = _users2.default;
exports.Reception = _reception2.default;
exports.LetterProcessing = _letterProcessing2.default;
exports.LetterProcessingWorkFlow = _letterProcessingWorkFlow2.default;
exports.Letter = _letter2.default;
exports.GiaiQuyetDonThu = _giaiQuyetDonThu2.default;
exports.DuLieuHeThong = _duLieuHeThong2.default;
exports.TrangChu = _trangChu2.default;
exports.ThongKeBaoCao = _thongKeBaoCao2.default;
exports.ThanhTra = _thanhtra2.default;
exports.TheoDoiGiamSat = _theodoigiamsat2.default;
exports.QuanLyHoSo = _quanLyHoSo2.default;
exports.QuanLyVanBan = _quanLyVanBan2.default;
exports.BaoCaoThanhTra = _baoCaoThanhTra2.default;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(2248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessibility__ = __webpack_require__(879);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED_CLASS", function() { return __WEBPACK_IMPORTED_MODULE_0__accessibility__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FocusStyleManager", function() { return __WEBPACK_IMPORTED_MODULE_0__accessibility__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(91);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Classes", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Keys", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Utils", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IconClasses", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IconContents", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AbstractComponent", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Colors", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Intent", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Position", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isPositionHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isPositionVertical", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "removeNonHTMLProps", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTetherOptions", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTargetAttachment", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPopoverAttachment", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAttachmentClasses", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["p"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(452);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ContextMenu", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ButtonFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AnchorButton", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AnchorButtonFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Callout", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Elevation", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AnimationStates", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CollapseFrom", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CollapsibleList", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CollapsibleListFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ContextMenuTarget", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DialogFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "EditableText", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "EditableTextFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ControlGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ControlGroupFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Control", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CheckboxFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SwitchFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RadioFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FileUpload", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FileUploadFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InputGroupFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LabelFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NumericInput", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NumericInputFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TextAreaFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Hotkey", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "KeyCombo", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "HotkeysTarget", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "comboMatches", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getKeyCombo", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getKeyComboString", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parseKeyCombo", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hideHotkeysDialog", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setHotkeysDialogProps", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Hotkeys", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MenuFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MenuDivider", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MenuDividerFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "renderMenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MenuItemFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NavbarDivider", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NavbarGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NavbarHeading", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NonIdealState", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NonIdealStateFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Overlay", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "OverlayFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopoverInteractionKind", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopoverFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGPopover", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_20"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGPopoverFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_21"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_22"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_23"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ProgressBarFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_24"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGTooltip", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_25"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGTooltipFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_26"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RangeSlider", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_27"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RangeSliderFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_28"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_29"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SliderFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_30"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_31"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SpinnerFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_32"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGSpinner", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_33"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SVGSpinnerFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_34"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_35"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_36"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_37"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabsFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_38"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabList", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_39"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabListFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_40"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_41"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TabPanelFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_42"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tab2", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_43"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tab2Factory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_44"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Expander", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_45"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tabs2", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_46"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tabs2Factory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_47"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tag", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_48"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TagFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_49"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_50"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ToastFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_51"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Toaster", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_52"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_53"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TooltipFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_54"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_55"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TreeFactory", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_56"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["_57"]; });
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(94);
var hide = __webpack_require__(77);
var redefine = __webpack_require__(78);
var ctx = __webpack_require__(95);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = exports.Header = exports.SingleLayout = exports.MasterLayout = undefined;

var _Header = __webpack_require__(305);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(471);

var _Footer2 = _interopRequireDefault(_Footer);

var _MasterLayout = __webpack_require__(959);

var _MasterLayout2 = _interopRequireDefault(_MasterLayout);

var _SingleLayout = __webpack_require__(960);

var _SingleLayout2 = _interopRequireDefault(_SingleLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MasterLayout = _MasterLayout2.default;
exports.SingleLayout = _SingleLayout2.default;
exports.Header = _Header2.default;
exports.Footer = _Footer2.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var msg = {
  messageDefault: 'Bạn không được bỏ trống trường này.',
  messageLinhVucTT: 'Bạn cần bổ sung lĩnh vực thanh tra.',
  messageHinhThucTT: 'Bạn cần bổ sung hình thức thanh tra.',
  ten: 'Vui lòng điền tên đầy đủ của công dân!',
  tinhThanh: 'Vui lòng chọn tỉnh thành nơi công dân cư trú!',
  quanHuyen: 'Vui lòng chọn quận huyện nơi công dân cư trú!',
  phuongXa: 'Vui lòng chọn phường xã nơi công dân cư trú!',
  toDanPho: 'Vui lòng chọn tổ dân phố nơi công dân cư trú!',
  ngaytn: 'Vui lòng chọn ngày tiếp nhận!',
  loaiNguoiDD: 'Vui lòng chọn loại người đứng đơn!',
  tenCoQuanDD: 'Vui lòng nhập tên cơ quan!',
  diaChiCoQuanDD: 'Vui lòng nhập địa chỉ cơ quan!',
  soDienThoaiCoQuanDD: 'Vui lòng nhập số điện thoại cơ quan!',
  nguoiUQ: 'Vui lòng điền đầy đủ thông tin người ủy quyền!',
  loaiDon: 'Vui lòng chọn loại đơn!',
  huyCTT: 'Đã huỷ thành công!',
  loaiDT: 'Vui lòng chọn loại đối tượng!',
  loaiLV: 'Vui lòng chọn loại lĩnh vực!',
  loaiLVChiTiet: 'Vui lòng chọn loại lĩnh vực chi tiết!',
  noiDungDon: 'Vui lòng nhập tóm tắt nội dung đơn thư!',
  noiDungHXL: 'Vui lòng nhập nội dung',
  dtBiKhieuTo: 'Vui lòng bổ sung thông tin đối tượng bị khiếu tố!',
  loaiDoiTuongBiKT: 'Vui lòng chọn loại đối tượng bị khiếu tố !',
  tenNguoiBiKT: 'Vui lòng nhập tên người bị khiếu tố',
  cqBiKhieuTo: 'Vui lòng điền đầy đủ thông tin cơ quan bị khiếu tố!',
  huongXL: 'Vui lòng chọn hướng xử lý!',
  cTCDTXSucess: 'Tạo đơn tiếp công dân thường xuyên thành công!',
  UTCDTXSucess: 'Cập nhật tiếp công dân thường xuyên thành công!',
  updateSuccess: 'Cập nhật thành công!',
  createSuccess: 'Thêm mới thành công!',
  trinhSuccess: 'Trình đơn thành công!',
  addTurnSucess: 'Thêm lượt tiếp công dân thường xuyên thành công!',
  dTCDTX: 'Xóa sổ tiếp công dân thành công!',
  thoiHanXuLy: 'Vui lòng chọn thời hạn xử lý',
  noiDungTrinhLanhao: 'Vui lòng nhập nội dung trình lãnh đạo',
  //CivilServant
  maCivilServantCivilServant: 'Vui lòng nhập mã công chức !',
  coQuanQuanLyCivilServant: 'Vui lòng chọn cơ quan quản lý !',
  chucVuCivilServant: 'Vui lòng chọn chức vụ !',
  nguoiDungTenDangNhapCivilServant: 'Vui lòng nhập tên đăng nhập !',
  nguoiDungMatKhauCivilServant: 'Vui lòng nhập mật khẩu !',
  vaiTroCivilServant: 'Vui lòng chọn vai trò !',
  vaiTroMacDinhCivilServant: 'Vui lòng chọn vai trò mặc định !',
  //add ReceptionPeriodical
  lanhDaoTiepPeriodical: 'Vui lòng chọn lãnh đạo tiếp !',
  //add Letter
  nguonDon: 'Vui lòng chọn nguồn đơn !',
  datDonPeriodical: 'Vui lòng chọn đơn để thêm mới',
  //list header letters
  tuNgayVsDenNgay: 'Vui lòng chọn đến ngày lớn hơn từ ngày !',
  deleteLetterSucess: 'Xóa đơn thành công',
  // Letter processing
  trinhDon: 'Đơn đã được trình lên lãnh đạo',
  xuLyDon: 'Xử lý đơn thành công',
  //category
  nameCategory: 'Vui lòng nhập tên danh mục',
  codeCategory: 'Vui lòng nhập mã danh mục !',
  addCategorySucess: 'Thêm mới danh mục thành công !',
  updateCategorySucess: 'Cập nhật danh mục thành công!',
  chuyenXLDSucess: 'Chuyển xử lý đơn thành công',
  delCategorySucess: 'Xóa danh mục thành công!',
  codeCategoryAdministrative: 'Vui lòng nhập mã đơn vị hành chính !',
  nameCategoryAdministrative: 'Vui lòng nhập tên đơn vị hành chính !',
  levelCategoryAdministrative: 'Vui lòng chọn cấp đơn vị hành chính !',
  codeCategoryAdministrativeUnits: 'Vui lòng nhập mã cấp đơn vị hành chính !',
  nameCategoryAdministrativeUnits: 'Vui lòng nhập tên cấp đơn vị hành chính !',
  hoVaTen: 'Vui lòng nhập họ và tên !',
  gioiTinh: 'Vui lòng chọn giới tính !',
  soCMNDHoCHieu: 'Vui lòng nhập số CMND/Hộ Chiếu !',
  noiCap: 'Vui lòng chọn nơi cấp CMND/Hộ Chiếu !',
  ngayCap: 'Vui lòng chọn ngày cấp CMND/Hộ Chiếu !',
  diaChi: 'Vui lòng nhập địa chỉ !',
  dienThoai: 'Vui lòng nhập số điện thoại !',
  email: 'Vui lòng nhập Email !',
  ngaySinh: 'Vui lòng chọn ngày sinh !',
  thanhPho: 'Vui lòng chọn Tỉnh !',
  quocTich: 'Vui lòng chọn quốc tịch !',
  danToc: 'Vui lòng chọn dân tộc !',
  //NationCategory
  nameNation: 'Vui lòng nhập tên dân tộc !',
  codeNation: 'Vui lòng nhập mã dân tộc !',
  //OrganizationCategory
  codeOrganization: 'Vui lòng nhập mã cơ quan !',
  nameOrganization: 'Vui lòng nhập tên cơ quan !',
  selectOrganization: 'Vui lòng chọn cấp cơ quan quản lý!',
  cityOrganization: 'Vui lòng chọn đơn vị hành chính Tỉnh !',
  //ParameterCategory
  codeParameter: 'Vui lòng nhập giá trị tham số !',
  nameParameter: 'Vui lòng nhập tên tham số !',
  //ResidentialGroup
  nameResidentialGroup: 'Vui lòng nhập tên tổ dân phố !',
  //Role
  nameRole: 'Vui lòng nhập tên vai trò !',
  selectRole: 'Vui lòng chọn loại vai trò !',
  //TypeOfTimeOut
  nameTypeOfTimeOut: 'Vui lòng chọn loại thời hạn !',
  quyTrinhXuLy: 'Vui Lòng chọn quy trình xử lý !',
  ngayXuLy: 'Vui lòng chọn số ngày xử lý !',
  thamQuyenGiaiQuyet: 'Vui lòng chọn thẩm quyền gỉai quyết !',
  phongBanGiaiQuyet: 'Vui lòng chọn phòng ban gỉai quyết !',
  coQuanTiepNhan: 'Vui lòng chọn cơ quan tiếp nhận !',
  lyDo: 'Vui lòng nhập lý do',
  canBoXuLy: 'Vui lòng chọn công chức xử lý !',
  phongBan: 'Vui lòng chọn phòng ban !',
  noiDungDinhChi: 'Vui lòng điền nội dung đình chỉ!',
  tooltipButtonAdd: 'Thêm lượt',
  tooltipButtonEdit: 'Sửa',
  tooltipButtonDelete: 'Xóa',
  tooltipButttonAction: 'Xử lý',
  tooltipCategoryAdd: 'Thêm mới',
  fileTypeErr: 'Vui lòng chọn file có định dạng: .doc, .docx, .pdf, .rar, .zip, .jpg, .png',
  filePhotoErr: 'Vui lòng chọn file có định dạng: .jpg, .png',
  fileExcel: 'Vui lòng chọn file có định dạng: .xls, .xlsx',
  fileTypeErr2: 'Vui lòng chọn file có định dạng: .doc, .docx, .pdf, .xls, .xlsx, .rar, .zip, .jpg, .png',
  fileVideoTypeErr: 'Vui lòng chọn file có định dạng: .flv, .mp4',
  fileSizeErr: 'Vui lòng chọn file có dung lượng tối đa là 50Mb',
  fileSizeNull: 'Vui lòng tải tập tin có dữ liệu',
  fileVideoSizeErr: 'Vui lòng chọn file có dung lượng tối đa là 5Mb',
  giaiQuyetDon: 'Giải quyết đơn thành công !',
  dateInvalid: 'Định dạng chưa đúng. Vui lòng nhập lại',
  dataExist: 'Dữ liệu này đã tồn tại trong hệ thống',
  dataInvalid: 'Dữ liệu không hợp lệ',
  emailInvalid: 'Email không đúng định dạng',
  uploadRequire: 'Vui lòng đính kèm tệp tin',
  luuGiaiQuyetDonThanhCong: 'Lưu kết quả giải quyết đơn thành công',
  giaHanTTXM: 'Gia hạn thẩm tra xác minh thành công',
  dinhChiDon: 'Đình chỉ đơn thành công',
  rutDon: 'Rút đơn thành công',
  congDanExist: 'Đã chọn công dân này',
  createKHSuccess: 'Thêm mới kế hoạch thanh tra thành công',
  createKHKTSuccess: 'Thêm mới kế hoạch kiểm tra thành công',
  updateKHSuccess: 'Chỉnh sửa kế hoạch thanh tra thành công',
  updateKHKTSuccess: 'Chỉnh sửa kế hoạch kiểm tra thành công',
  removeKHSuccess: 'Xóa kế hoạch thành công',
  removeKHKTSuccess: 'Xóa kế hoạch kiểm tra thành công',
  saveCuocTTSuccess: 'Lưu cuộc thanh tra thành công',
  saveCuocKTSuccess: 'Lưu cuộc kiểm tra thành công',
  confirmBack: 'Đóng sẽ không lưu những thay đổi mà bạn đã thực hiện. Bạn có muốn đóng không ?',
  confirmChangeSaveLoaiDon: 'Khi thay đổi Loại đơn, tất cả tài liệu đính kèm đã tải lên sẽ bị mất. Bạn có đồng ý ?',
  confirmChangeSaveHXL: 'Khi thay đổi Hướng xử lý, tất cả tài liệu đính kèm đã tải lên sẽ bị mất. Bạn có đồng ý ?',
  confirmChange: 'Khi chọn Hướng xử lý khác thì những file đã tải lên sẽ bị mất. Bạn có muốn tiếp tục không ?',
  chuyenKTDX: 'Chuyển kiểm tra đề xuất thành công.',
  gqdGiaoTTXM: 'Chuyển đơn vị thành công',
  gqdLuuHoSo: 'Lưu hồ sơ thành công',
  gqdLuu: 'Lưu thành công',
  gqdTrinhLanhDao: 'Trình đơn thành công',
  gqdGiaoViec: 'Giao việc thành công',
  gqdTraBaoCao: 'Gửi báo cáo thành công',
  gqdLanhDaoGiaoViec: 'Giao việc thành công',
  gqdGuiDuThao: 'Gửi dự thảo thành công',
  gqdChuyenTheoDoi: 'Chuyển theo dõi thực hiện thành công',
  gqdTraDonThanhCong: 'Trả đơn thành công',
  guiBCSuccess: 'Gửi báo cáo thành công',
  ktdxTraBaoCao: 'Gửi báo cáo KTĐX thành công',
  ktdxTrinhLanhDao: 'Trình đơn thành công',
  ktdxLanhDaoGiaoViec: 'Giao việc thành công',
  // XU_LY_DON
  xldLuu: 'Lưu thành công',
  xldTrinhLanhDao: 'Trình đơn thành công',
  xldYeuCauGapLanhDao: 'Gửi yêu cầu thành công',
  xldLanhDaoGiaoViec: 'Giao việc thành công',
  xldTruongPhongGiaoViec: 'Giao việc thành công',
  xldTruongPhongGiaoViecPhoPhong: 'Giao thành công',
  xldChuyenGiaiQuyetDon: 'Chuyển giải quyết đơn thành công',
  xldLuuHoSo: 'Lưu hồ sơ thành công',
  xldChuyenDon: 'Chuyển đơn thành công',
  xldTraDon: 'Trả đơn chuyển không đúng thẩm quyền thành công',
  xuLyYeuCau: 'Xử lý yêu cầu gặp lãnh đạo thành công',
  thuHoiDon: 'Thu hồi đơn thành công',

  //thanh tra
  saveDoiTuongTTSuccess: 'Lưu đối tượng thanh tra thành công',
  addDoiTuongTTSuccess: 'Thêm mới đối tượng thanh tra thành công',
  ttTienHanhThanhTra: 'Tiến hành thanh tra thành công',
  ttTienHanhKiemTra: 'Tiến hành kiểm tra thành công',
  ttKetThucThanhTra: 'Kết thúc thanh tra trực tiếp thành công',
  ttKetThucKiemTra: 'Kết thúc kiểm tra trực tiếp thành công',
  ttChuyenTheoDoi: 'Chuyển theo dõi thực hiện thành công',
  ttLuuHoSo: 'Lưu hồ sơ thành công',

  // theo doi thuc hien
  tdthLuuHoSo: 'Lưu hồ sơ thành công',
  confirmDonDoc: 'Bạn chưa lưu những thao tác vừa thực hiện trên block Đôn đốc, việc thu gọn block sẽ hủy đi những thao tác mà bạn đã thực hiện. Bạn có muốn thu gọn không?',
  confirmExportExcel: 'Những thay đổi của bạn chưa được lưu, hệ thống sẽ tự động lưu báo cáo?',
  //bao cao dinh ky
  dkLuuHoSo: 'Lưu báo cáo thành công',
  guiTTXMLai: 'Gửi thẩm tra xác minh lại thành công',
  delVideoSuccess: 'Xóa video thành công',
  viewPermission: 'Bạn không có quyền xem chi tiết đơn này',
  // thanh tra trùng
  tttGui: 'Gửi đề xuất thành công'
};

exports.msg = msg;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toastr = undefined;

var _toastr = __webpack_require__(1425);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Toastr = _toastr2.default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var widthColumn = 100;
var widthCostColumn = 170;
var widthThongKeBaoCao = 120;

var header = {
  category: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 220 }, { name: 'Danh mục cha', width: 220 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  categoryGroup: {
    competence: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 220 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 170, minWidth: 170 }],
    capNhatNguoiDung: [{ name: 'Stt', width: 45 }, { name: 'Tên công chức' }, { name: 'Vai trò', width: 220 }, { name: 'Thao tác', width: 170, minWidth: 170 }],
    capNhatNguoiDungXLD: [{ name: 'STT', width: 45 }, { name: 'Mã tra cứu', width: 70 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Tình trạng xử lý/Kết quả xử lý', width: 190 }],
    donViNgoai: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 220 }, { name: 'Thao tác', width: 170, minWidth: 170 }],
    documentType: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 220 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 170, minWidth: 170 }],
    letters: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 220 }, { name: 'Lĩnh vực đơn thư cha', width: 220 }, { name: 'Loại đơn' }, { name: 'Mô tả' }, { name: 'Thao tác', width: 150, minWidth: 150 }],
    administrative: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 190 }, { name: 'Đơn vị hành chính cha', width: 190 }, { name: 'Cấp đơn vị hành chính', width: 170 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 130, minWidth: 130 }],
    organizationlevel: [{ name: 'Stt', width: '44px' }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 200 }, { name: 'Cấp cơ quan cha', width: 200 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 130, minWidth: 130 }],
    organization: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 200 }, { name: 'Cơ quan quản lý cha', width: 200 }, { name: 'Cấp cơ quan quản lý', width: 200 }, { name: 'Đơn vị hành chính', width: 200 }, { name: 'Mô tả', minWidth: 200 }, { name: 'Thao tác', width: 150, minWidth: 150 }],
    residentialgroup: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 200 }, { name: 'Đơn vị hành chính', width: 200 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    nation: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên dân tộc', width: 140 }, { name: 'Tên khác', width: 350 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    citizen: [{ name: 'Stt', width: 45 }, { name: 'Họ và tên', width: 160 }, { name: 'Thông tin cá nhân' }, { name: 'Giới tính', width: 70 }, { name: 'CMND/Hộ chiếu', width: 160 }, { name: 'Dân tộc', width: 100 }, { name: 'Quốc tịch', width: 100 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    position: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 300 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    role: [{ name: 'Stt', width: 45 }, { name: 'Tên' }, { name: 'Loại vai trò' }, { name: 'Mô tả', width: 500 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    civilServant: [{ name: 'Stt', width: 45 }, { name: 'Họ và tên', width: 160 }, { name: 'Email/ Điện thoại', width: 210 }, { name: 'Đơn vị công tác', width: 160 }, { name: 'Vai trò', width: 160 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    typeoftimeout: [{ name: 'Stt', width: 45 }, { name: 'Số ngày', width: 100 }, { name: 'Loại thời hạn', width: '' }, { name: 'Thao tác', width: 100 }],
    parameter: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 300 }, { name: 'Giá trị', width: 110 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    quytrinh: [{ name: 'Stt', width: 45 }, { name: 'Tên đơn vị', width: 300 }, { name: 'Tên quy trình', width: 110 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    cauHinhBaoCao: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 200 }, { name: 'Ngày bắt đầu' }, { name: 'Ngày kết thúc' }, { name: 'Năm báo cáo' }, { name: 'Đơn vị gửi' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    video: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 200 }, { name: 'Danh mục' }, { name: 'Loại video' }, { name: 'File' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    coquanthanhtratw: [{ name: 'STT', width: '5%' }, { name: 'Mã', width: '25%' }, { name: 'Tên', width: '30%' }, { name: 'Mô tả', width: '30%' }, { name: 'Thao tác', width: '10%' }]
  },
  administrativeunits: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 190 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  nationality: [{ name: 'Stt', width: 45 }, { name: 'Mã', width: 70 }, { name: 'Tên', width: 300 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  typeoforganizationlevel: [{ name: 'Stt', width: 45 }, { name: 'Tên', width: 300 }, { name: 'Mô tả' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  addReception: {
    groupMember: [{ name: 'STT', width: 44 }, { name: 'Họ và tên', width: 160 }, { name: 'CMND/Hộ chiếu', width: 160 }, { name: 'Địa chỉ', minWidth: 302 }, { name: 'Điện thoại', width: 160 }, { name: 'Thao tác', width: 100 }],
    boSungTaiLieu: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 300 }, { name: 'Tình trạng', width: 201 }, { name: 'Tập tin đính kèm', minWidth: 275, colSpan: 2 }],
    danhSachBangChung: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 165, minWidth: 165 }, { name: 'Tình trạng', width: 200 }, { name: 'Tập tin đính kèm', minWidth: 175 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    searchName: [{ name: 'Stt', width: 45 }, { name: 'Tên người đứng đơn', width: 137 }, { name: 'CMND/Hộ chiếu', width: 115 }, { name: 'Địa chỉ', width: '' }, { name: 'Số điện thoại', width: 85 }, { name: 'Số đơn', width: 58 }, { name: 'Thao tác', width: 230 }]
  },
  detailReception: {
    groupMember: [{ name: 'STT', width: 45 }, { name: 'Họ và tên', width: 165 }, { name: 'CMND/Hộ chiếu', width: 115 }, { name: 'Địa chỉ', minWidth: 300 }, { name: 'Điện thoại', width: 145 }],
    proof: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 400 }, { name: 'Tình trạng', width: 175 }, { name: 'Tập tin đính kèm', minWidth: 280 }],
    boSungTaiLieu: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 400 }, { name: 'Số trang', width: 70 }, { name: 'Loại tài liệu', width: 175 }, { name: 'Tình trạng', width: 175 }, { name: 'Tập tin đính kèm', minWidth: 280, colSpan: 2 }]
  },
  receptionPeriodical: {
    add: [{ name: 'STT', width: 45 }, { name: 'Tên cơ quan, đơn vị', width: 300 }, { name: 'Người đại diện', width: 200 }, { name: 'Chức vụ', width: 200 }, { name: 'Thao tác', width: 53 }],
    listBriefJob: [{ selectAll: true, width: 60 }, { name: 'STT', width: 45 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', width: 235 }, { name: 'Tóm tắt vụ việc', minWidth: 175 }, { name: 'Phân loại đơn/ Số người', width: 185 }, { name: 'Cơ quan đã giải quyết', width: 150 }],
    listHome: [{ name: 'Stt', width: 45 }, { name: 'Ngày tiếp', width: 135 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Lãnh đạo tiếp', width: 140 }, { name: 'Kết quả tiếp dân', width: 125 }, { name: 'Tình trạng xử lý', width: 115 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    listYeuCau: [{ name: 'Stt', width: 45 }, { name: 'Ngày tiếp', width: 110 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Trạng thái', width: 190 }, { name: 'Thao tác', width: 110, minWidth: 110 }]
  },
  listTCD: [{ name: 'Stt', width: 45 }, { name: 'Ngày tiếp', width: 115 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung', minWidth: 140 }, { name: 'Phân loại đơn/ Số người', width: 130 }, { name: 'Cơ quan đã giải quyết', width: 120 }, { name: 'Công chức tiếp dân', width: 110 }, { name: 'Lượt tiếp', width: 72 }, { name: 'Hướng xử lý', width: 104 }, { name: 'Tình trạng xử lý/Kết quả xử lý', width: 160 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  listXLD: [{ name: 'Stt', width: 45 }, { name: 'Mã tra cứu', width: 70 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Tình trạng xử lý/Kết quả xử lý', width: 190 }, { name: 'Lãnh đạo/Công chức xử lý', width: 150 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  listXLDC: [{ name: 'Stt', width: 45 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Loại thông tin đơn', width: 100 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  listTCDDX: [{ name: 'Stt', width: 45 }, { name: 'Ngày tiếp', width: 135 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Lãnh đạo tiếp', width: 140 }, { name: 'Kết quả tiếp dân', width: 125 }, { name: 'Tình trạng xử lý', width: 115 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  listTTXLGQD: [{ name: 'Stt', width: 45 }, { name: 'Đơn vị xử lý', width: 300 }, { name: 'Hướng xử lý', width: 170 }, { name: 'File đính kèm' }],
  detailReceptionPeriodical: {
    organization: [{ name: 'STT', width: 44 }, { name: 'Tên cơ quan, đơn vị' }, { name: 'Người đại diện' }, { name: 'Chức vụ' }],
    proof: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu' }, { name: 'Tình trạng' }, { name: 'Tập tin đính kèm' }],
    attach: [{ name: 'Stt', width: 45 }, { name: 'Tên biểu mẫu', width: 300 }, { name: 'Số quyết định' }, { name: 'Ngày quyết định' }, { name: 'Tập tin đính kèm' }],
    tepDinhKem: [{ name: 'Stt', width: 45 }, { name: 'Tên biểu mẫu' }, { name: 'Loại tệp', width: 100 }, { name: 'Số quyết định', width: 100 }, { name: 'Ngày quyết định', width: 115 }, { name: 'Tập tin đính kèm' }, { name: 'Thao tác', width: 110, minWidth: 110 }]
  },
  home: {
    letterTable: [{ name: 'Stt', width: 45 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', minWidth: 150 }, { name: 'Tóm tắt nội dung', minWidth: 150 }]
  },
  giaiQuyetDon: {
    listGQD: [{ name: 'Stt', width: 45 }, { name: 'Mã tra cứu', width: 70 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Tình trạng giải quyết/Kết quả giải quyết', width: 250 }, { name: 'Lãnh đạo/Công chức giải quyết', width: 190 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    listDonDaGQ: [{ name: 'Stt', width: 45 }, { name: 'Mã tra cứu', width: 70 }, { name: 'Ngày tiếp nhận', width: 110 }, { name: 'Người đứng đơn', width: 170 }, { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 }, { name: 'Phân loại đơn/ Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }, { name: 'Cơ quan đã giải quyết', width: 150 }, { name: 'Tình trạng giải quyết/Kết quả giải quyết', width: 250 }, { name: 'Lãnh đạo/Công chức giải quyết', width: 190 }],
    danhSachTaiLieuDinhKem: [{ name: 'Stt', width: 45 }, { name: 'Tên biểu mẫu', width: 300 }, { name: 'Số quyết định' }, { name: 'Ngày quyết định' }, { name: 'Tài liệu đính kèm' }],
    danhSachTaiLieuDinhKemDC: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 300 }, { name: 'Số văn bản' }, { name: 'Ngày ra văn bản' }, { name: 'Tài liệu đính kèm' }],
    taiLieuDinhKem: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 300 }, { name: 'Số quyết định' }, { name: 'Ngày quyết định' }, { name: 'Tài liệu đính kèm' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
    danhSachBangChung: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu' },
    // {name: 'Số trang', width: 100},
    // {name: 'Loại tài liệu', width: 190},
    { name: 'Tình trạng' }, { name: 'Tập tin đính kèm' }]
  },
  dialogHistory: [{ name: 'Stt', width: 45 }, { name: 'Nội dung', width: 405 }, { name: 'Người xử lý', width: 300 }, { name: 'Thao tác', width: 175 }],
  dialogHistoryXL: [{ name: 'Stt', width: 45 }, { name: 'Nội dung', width: 405 }, { name: 'Người xử lý', width: 300 }, { name: 'Thao tác', width: 175 }],
  dialogHistoryDetail: [{ name: 'Stt', width: 45 }, { name: 'Nội dung', width: 405 }, { name: 'Thông tin cũ', width: 300 }, { name: 'Thông tin mới', width: 300 }],
  thongKeBaoCaoTiepCongDan: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'TIẾP THƯỜNG XUYÊN', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'TIẾP ĐỊNH KỲ VÀ ĐỘT XUẤT CỦA LÃNH ĐẠO', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'NỘI DUNG TIẾP CÔNG DÂN (số vụ việc)', className: 'middle-content', colSpan: 14, rowSpan: 1 }, { name: 'KẾT QUẢ QUA TIẾP DÂN (số vụ việc)', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Lượt', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đoàn đông người', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Lượt', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đoàn đông người', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Khiếu nại', colSpan: 7, rowSpan: 1, className: 'middle-content' }, { name: 'Tố cáo', colSpan: 6, rowSpan: 1, className: 'middle-content' }, { name: 'Phản ánh, kiến nghị, khác', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Chưa được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã được giải quyết', colSpan: 3, rowSpan: 1, className: 'middle-content' }], [{ name: 'Cũ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Mới phát sinh', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Cũ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Mới phát sinh', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Lĩnh vực hành chính', colSpan: 5, rowSpan: 1, className: 'middle-content' }, { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực hành chính', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tham nhũng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực khác', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Chưa có QĐ giải quyết', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã có QĐ giải quyết (lần 1,2, cuối cùng)', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã có bản án của Tòa', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }], [{ name: 'Cũ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Mới phát sinh', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cũ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Mới phát sinh', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Liên quan đến đất đai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về nhà, tài sản', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về chính sách, chế độ CC,VC', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực CT,VH,XH khác', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }]],
  thongKeBaoCaoXuLyDon: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'TIẾP NHẬN', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'PHÂN LOẠI ĐƠN KHIẾU NẠI, TỐ CÁO', className: 'middle-content', colSpan: 18, rowSpan: 1 }, { name: 'ĐƠN KHÁC (kiến nghị, phản ánh, đơn nặc danh)', className: 'middle-content', colSpan: 1, rowSpan: 5, width: widthColumn, minWidth: widthColumn }, { name: 'KẾT QUẢ XỬ LÝ ĐƠN KHIẾU NẠI, TỐ CÁO', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số đơn', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn tiếp nhận trong kỳ', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Đơn kỳ trước chuyển sang', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Đơn đủ điều kiện xử lý', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Theo nội dung', colSpan: 13, rowSpan: 1, className: 'middle-content' }, { name: 'Theo thẩm quyền giải quyết', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Theo trình tự giải quyết', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Số văn bản hướng dẫn', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đơn chuyển cơ quan có thẩm quyền', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số công văn đôn đốc việc giải quyết', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn thuộc thẩm quyền', colSpan: 2, rowSpan: 2, className: 'middle-content' }], [{ name: 'Khiếu nại', colSpan: 7, rowSpan: 1, className: 'middle-content' }, { name: 'Tố cáo', colSpan: 6, rowSpan: 1, className: 'middle-content' }, { name: 'Của các cơ quan hành chính các cấp', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Của cơ quan tư pháp các cấp', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Của cơ quan Đảng', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Chưa được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }], [{ name: 'Đơn có nhiều người đứng tên  ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn một người đứng tên', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn có nhiều người đứng tên  ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn một người đứng tên', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực hành chính', colSpan: 5, rowSpan: 1, className: 'middle-content' }, { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực hành chính', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tham nhũng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực khác', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Khiếu nại', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tố cáo', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }], [{ name: 'Tổng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Liên quan đến  đất đai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về nhà, tài sản', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Về chính sách, chế độ CC,VC', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Lĩnh vực CT,VH,XH khác', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }]],
  thongKeBaoCaoGiaiQuyetDonKN: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'ĐƠN KHIẾU NẠI THUỘC THẨM QUYỀN', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KẾT QUẢ GIẢI QUYẾT', className: 'middle-content', colSpan: 21, rowSpan: 1 }, { name: 'CHẤP THÀNH THỜI GIAN GIẢI QUYẾT THEO QUY ĐỊNH', className: 'middle-content', colSpan: 2, rowSpan: 2 }, { name: 'VIỆC THI HÀNH QUYẾT ĐỊNH GIẢI QUYẾT KHIẾU NẠI', className: 'middle-content', colSpan: 10, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số đơn khiếu nại', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Trong đó', colSpan: 3, rowSpan: 2, className: 'middle-content' }, { name: 'Đã giải quyết', colSpan: 4, rowSpan: 2, className: 'middle-content' }, { name: 'Phân tích kết quả (vụ việc)', colSpan: 6, rowSpan: 1, className: 'middle-content' }, { name: 'Kiến nghị thu hồi cho Nhà nước', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Trả lại cho công dân', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Số người được trả lại quyền lợi', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kiến nghị xử lý hành chính', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra, khởi tố', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số quyết định phải tổ chức thực hiện trong kỳ báo cáo', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đã thực hiện', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Thu hồi cho nhà nước', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Trả lại cho công dân', colSpan: 4, rowSpan: 1, className: 'middle-content' }], [{ name: 'Khiếu nại đúng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Khiếu nại sai', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Khiếu nại đúng một phần', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Giải quyết lần 1', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Giải quyết lần 2', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Số vụ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đối tượng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kết quả', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Số vụ việc giải quyết đúng thời hạn', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Số vụ việc giải quyết quá thời hạn', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Phải thu', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã thu', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Phải trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Đơn nhận trong kỳ báo cáo', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Đơn tồn kỳ trước chuyển sang', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số vụ việc', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Số đơn thuộc thẩm quyền', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Số vụ việc thuộc thẩm quyền', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Số vụ việc giải quyết bằng QĐ hành chính', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Số vụ việc rút đơn thông qua giải thích, thuyết phục', width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Công nhận QĐ g/q lần 1', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Hủy, sửa QĐ g/q lần 1', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng số người', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số người đã bị xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số vụ đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đối tượng đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }]],
  thongKeBaoCaoGiaiQuyetDonTC: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'ĐƠN TỐ CÁO THUỘC THẨM QUYỀN', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KẾT QUẢ GIẢI QUYẾT', className: 'middle-content', colSpan: 16, rowSpan: 1 }, { name: 'CHẤP THÀNH THỜI GIAN GIẢI QUYẾT THEO QUY ĐỊNH', className: 'middle-content', colSpan: 2, rowSpan: 2 }, { name: 'VIỆC THI HÀNH QUYẾT ĐỊNH XỬ LÝ TỐ CÁO', className: 'middle-content', colSpan: 10, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số đơn tố cáo', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Trong đó', colSpan: 3, rowSpan: 2, className: 'middle-content' }, { name: 'Đã giải quyết', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Phân tích kết quả (vụ việc)', colSpan: 3, rowSpan: 2, className: 'middle-content' }, { name: 'Kiến nghị thu hồi cho Nhà nước', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Trả lại cho công dân', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Số người được trả lại quyền lợi', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kiến nghị xử lý hành chính', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra, khởi tố', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số quyết định phải tổ chức thực hiện trong kỳ báo cáo', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã thực hiện xong', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Thu hồi cho nhà nước', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Trả lại cho công dân', colSpan: 4, rowSpan: 1, className: 'middle-content' }], [{ name: 'Số vụ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đối tượng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kết quả', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Số vụ việc giải quyết đúng thời hạn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số vụ việc giải quyết quá thời hạn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Phải thu', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã thu', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Phải trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Đơn nhận trong kỳ báo cáo', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đơn tồn kỳ trước chuyển sang', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng số vụ việc', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đơn thuộc thẩm quyền', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số vụ việc thuộc thẩm quyền', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tố cáo đúng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tố cáo sai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tố cáo đúng một phần', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng số người', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số người đã bị xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số vụ đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số đối tượng đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }]],
  quanLyNhaNuocVeKhieuNaiToCao: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'BAN HÀNH VĂN BẢN QUẢN LÝ, CHỈ ĐẠO (Bộ, ngành, tỉnh, TP) VỀ CÔNG TÁC KNTC', colSpan: 2, rowSpan: 1 }, { name: 'TẬP HUẤN, TUYÊN TRUYỀN, GIÁO DỤC PHÁP LUẬT VỀ KNTC CHO CÁN BỘ, CÔNG CHỨC, VIÊN CHỨC, NHÂN DÂN', colSpan: 2, rowSpan: 1 }, { name: 'THANH TRA, KIỂM TRA TRÁCH NHIỆM', colSpan: 7, rowSpan: 1 }, { name: 'KIỂM TRA VIỆC THỰC HIỆN KẾT LUẬN THANH TRA TRÁCH NHIỆM, QUYẾT ĐỊNH XỬ LÝ', colSpan: 5, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Số văn bản ban hành mới', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Số văn bản được sửa đổi, bổ sung', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Pháp luật về KNTC', colSpan: 2, rowSpan: 1 }, { name: 'Thực hiện pháp luật về KNTC', colSpan: 2, rowSpan: 1 }, { name: 'Số đơn vị có vi phạm', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Kiến  nghị xử lý', colSpan: 4, rowSpan: 1 }, { name: 'Tổng số KLTT và QĐ xử lý đã kiểm tra', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Kết quả kiểm tra', colSpan: 4, rowSpan: 1 }], [{ name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1 }, { name: 'Hành chính', colSpan: 2, rowSpan: 1 }, { name: 'Đã kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1 }, { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1 }], [{ name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }]],
  // Thanh tra hành chính
  thongKeBaoCaoThanhTraHanhChinh: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Số đơn vị được thanh tra theo kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tiền và tài sản quy thành tiền (tr.đ)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }]],
  thongKeBaoCaoThanhTraDatDai: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }]],
  thongKeBaoCaoThanhTraChuyenNganh: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'SỐ CUỘC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 3, rowSpan: 1 }, { name: 'SỐ CÁ NHÂN ĐƯỢC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 }, { name: 'SỐ TỔ CHỨC ĐƯỢC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 }, { name: 'KẾT QUẢ', className: 'middle-content', colSpan: 19, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Thành lập đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Thanh tra độc lập', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Số có vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số QĐ xử phạt hành chính được ban hành', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền kiến nghị thu hồi', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Số tiền xử lý tài sản vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền xử phạt vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền đã thu', colSpan: 3, rowSpan: 1, className: 'middle-content' }], [{ name: 'Thanh tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kiểm tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Thanh tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kiểm tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tịch thu (thành tiền)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiêu hủy (thành tiền)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }]],
  thongKeBaoCaoThucHienKetLuanThanhTraHanhchinh: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Kết luận thanh tra phải thực hiện', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Tiến độ thực hiện kết luận', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Thu hồi về ngân sách nhà nước', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'Xử lý khác về kinh tế', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'Xử lý hành chính', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'Hoàn thiện về cơ chế chính sách (số văn bản)', className: 'middle-content', colSpan: 2, rowSpan: 1 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Trong đó số kết luận chưa thực hiện xong kỳ trước chuyển sang', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Số kết luận đã hoàn thành', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Số kết luận chưa hoàn thành', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số phải xử lý', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Xử lý trong kỳ', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Khởi tố trong kỳ', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số văn bản kiến nghị phải hoàn thiện', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Số văn bản kiến nghị đã thực hiện xong', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }], [{ name: 'Tổng số tiền phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Số tiền đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Tổng số đất phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Số đất đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Tổng số tiền phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Số tiền đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Tổng số đất phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Số đất đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' }]],
  thongKeBaoCaoThanhTraXayDungCoBan: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }]],
  thongKeBaoCaoThanhTraTaiChinhNganSach: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 }, { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' }]],
  thongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 3, rowSpan: 2, width: widthColumn, minWidth: widthColumn }, { name: 'Số cuộc thanh tra, kiểm tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 }, { name: 'Số tổ chức được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 }, { name: 'Số cá nhân được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 }, { name: 'Số tổ chức, cá nhân vi phạm', className: 'middle-content', colSpan: 3, rowSpan: 2 }, { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền) (Tr.đ)', className: 'middle-content', colSpan: 3, rowSpan: 2 }, { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 3, rowSpan: 2 }, { name: 'Số tiền kiến nghị xử lý khác', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 }, { name: 'Quyết định xử phạt hành chính được ban hành', className: 'middle-content', colSpan: 3, rowSpan: 2 }, { name: 'Xử phạt vi phạm hành chính', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 2 }], [{ name: 'Bằng tiền', colSpan: 3, rowSpan: 1, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Bằng hình thức khác', colSpan: 3, rowSpan: 1, width: 100, minWidth: 100, className: 'middle-content' }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Phân loại', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' }], [
  // { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
  // { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
  // { name: 'Thường xuyên', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
  { name: 'Kế hoạch', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }]],
  thongKeBaoCaoThanhTraLai: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'SỐ CUỘC THANH TRA LẠI', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'CĂN CỨ THANH TRA LẠI(SỐ CUỘC)', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'SỐ ĐƠN VỊ ĐÃ THANH TRA LẠI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn }, { name: 'SỐ ĐƠN VỊ CÓ VI PHẠM PHÁT HIỆN QUA THANH TRA LẠI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn }, { name: 'VI PHẠM VỀ KINH TẾ PHÁT HIỆN QUA THANH TRA LẠI', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'KIẾN NGHỊ THU HỒI', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'KIẾN NGHỊ KHÁC', className: 'middle-content', colSpan: 2, rowSpan: 1 }, { name: 'KIẾN NGHỊ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KẾT QUẢ THỰC HIỆN', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đang thực hiện', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Tiến độ', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Vi phạm trình tự, thủ tục dẫn đến sai lệch nghiêm trọng KL', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Nội dung kết luận không phù hợp chứng cứ', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Sai lầm trong áp dụng PL khi KL', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Cố ý làm sai lệch hồ sơ hoặc cố ý KL trái pháp luật, đôn đốc', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Vi phạm nghiêm trọng chưa được phát hiện đầy đủ', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1 }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1 }, { name: 'Tiền đã thu(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất đã thu(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1 }, { name: 'Đã khởi tố', colSpan: 2, rowSpan: 1 }], [{ name: 'Kỳ trước chuyển sang', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Triển khai trong kỳ báo cáo', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kết thúc thanh tra trực tiếp', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã ban hành kết luận', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }]],
  thongKeBaoCaoQuyetDinhXuPhatKiemTraChuyenNganh: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 180, maxWidth: 180, minWidth: 180 }, { name: 'Kết quả thực hiện xử lý vi phạm về kinh tế (Tr,đ)', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'Kết quả thực hiện quyết định xử phạt vi phạm hành chính', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'Đã khởi tố', className: 'middle-content', colSpan: 2, rowSpan: 1 }], [{ name: 'Số tiền vi phạm đã thu hồi (tiền và tài sản quy thành tiền)', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền vi phạm đã xử lý khác', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tiền xử phạt vi phạm hành chính đã thu (Tr.đ)', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Số tổ chức, cá nhân đã thực hiện xử phạt vi phạm hành chính bằng hình thức khác', colSpan: 3, rowSpan: 1, className: 'middle-content' }, { name: 'Vụ', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100, className: 'middle-content' }, { name: 'Đối tượng', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100, className: 'middle-content' }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Về ngân sách nhà nước', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Về tổ chức, đơn vị', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }, { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' }]],
  ketQuaKiemTraChiTietDoanhNghiep: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40, id: 'idColumn' }, { name: 'Tên doanh nghiệp được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 130, maxWidth: 130, minWidth: 130, id: 'nameColumn' }, { name: 'Nội dung thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 130, maxWidth: 130, minWidth: 130 }, { name: 'Thời hạn thanh tra, kiểm tra (ngày)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tóm tắt vi phạm phát hiện (nếu có)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiến nghị thu hồi tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Quyết định xử phạm VPHC', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 270, maxWidth: 270, minWidth: 270 }, { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp...)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 180, maxWidth: 180, minWidth: 180 }], [{ name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Số tiền', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 120, maxWidth: 90, minWidth: 90 }, { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }]],
  ketQuaKiemTraTheoKeHoachDoanhNghiep: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Kế hoạch thanh tra, kiểm tra', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Thực hiện thanh tra, kiểm tra theo kế hoạch', className: 'middle-content', colSpan: 8, rowSpan: 1, width: 400, maxWidth: 400, minWidth: 400 }, { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Quyết định xử phạt hành chính', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 }], [{ name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tỷ lệ thực hiện KH', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }], [{ name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }]],
  ketQuaKiemTraDotXuatDoanhNghiep: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Thực hiện thanh tra, kiểm tra đột xuất', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Thực hiện thanh tra, kiểm tra đột xuất', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 }], [{ name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }], [{ name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }]],
  tongHopKetQuaThanhTra: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 120, maxWidth: 120, minWidth: 120 }, { name: 'Kế hoạch thanh tra, kiểm tra', className: 'middle-content', colSpan: 6, rowSpan: 2, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Thực hiện thanh tra, kiểm tra theo kế hoạch', className: 'middle-content', colSpan: 10, rowSpan: 1, width: 500, maxWidth: 500, minWidth: 500 }, { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Quyết định xử phạt hành chính', className: 'middle-content', colSpan: 3, rowSpan: 2, width: 300, maxWidth: 300, minWidth: 300 }, { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 2, width: 200, maxWidth: 200, minWidth: 200 }], [{ name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Theo kế hoạch', className: 'middle-content', colSpan: 4, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 }, { name: 'Đột xuất', className: 'middle-content', colSpan: 4, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 }], [{ name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }, { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }], [{ name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 }]],
  thongKe: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 50, maxWidth: 50, minWidth: 50 }, { name: 'Mã đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 80, maxWidth: 80, minWidth: 80 }, { name: 'Tên đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 250, maxWidth: 250, minWidth: 250 }, { name: 'Theo kế hoạch', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 600, maxWidth: 600, minWidth: 600 }, { name: 'Thực hiện', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 520, maxWidth: 520, minWidth: 520 }], [{ name: 'Tổng số DN dự kiến TT, KT', className: 'middle-content', colSpan: 5, rowSpan: 1, width: 450, maxWidth: 450, minWidth: 450 }, { name: 'Số lần đối tượng được chọn', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 }, { name: 'Tổng đối tượng đã TT,KT', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 }, { name: 'Số đối tượng có trong kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 }, { name: 'Số đối tượng ngoài kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Doanh nghiệp', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Cá nhân, HTX', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Cơ sở sản xuất kinh doanh cá thể, hộ kinh doanh', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }, { name: 'Cơ quan HC', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 }]],
  thanhTra: {
    DSKHTT: [{ name: 'STT', width: 45 }, { name: 'Năm thanh tra/kiểm tra', minWidth: 125 }, { name: 'Quyết định phê duyệt KHTT/KHKT', width: 145 }, { name: 'Ngày phê duyệt', width: 110 }, { name: 'Số cuộc TT/KT', width: 75 }, { name: 'Trạng thái', width: 150 }, { name: 'Thao tác', width: 135, minWidth: 135 }],
    DSKHTTDPD: [{ name: 'STT', width: 45 }, { name: 'Năm thanh tra/kiểm tra', minWidth: 125 }, { name: 'Quyết định phê duyệt KHTT/KHKT', width: 145 }, { name: 'Ngày phê duyệt', width: 110 }, { name: 'Số cuộc TT/KT', width: 75 }, { name: 'Trạng thái', width: 150 }],
    DKKHTT: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng thanh tra, kiểm tra/Số đối tượng', minWidth: 160 }, { name: 'Nội dung thanh tra/kiểm tra', minWidth: 160 }, { name: 'Thời hạn thanh tra/kiểm tra (ngày)', width: 120 }, { name: 'Thời kỳ thanh tra/kiểm tra', width: 125 }, { name: 'Thời gian tiến hành', width: 120 },
    // { name: 'Đơn vị chủ trì', minWidth: 90},
    // { name: 'Đơn vị phối hợp', minWidth: 140},
    { name: 'Thao tác', minWidth: 95 }],
    DKKHTT3: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng thanh tra, kiểm tra/Số đối tượng', minWidth: 160 }, { name: 'Nội dung thanh tra/kiểm tra', minWidth: 160 }, { name: 'Thời hạn thanh tra/kiểm tra', width: 120 }, { name: 'Thời kỳ thanh tra/kiểm tra', width: 125 }, { name: 'Thời gian tiến hành', width: 120 }],
    DKKHTT2: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra', minWidth: 90 }, { name: 'Nội dung thanh tra', minWidth: 160 }, { name: 'Loại đối tượng/ Hình thức thanh tra', width: 130 }, { name: 'Thời kỳ thanh tra', width: 125 }, { name: 'Thời hạn (ngày làm việc)', width: 120 },
    // { name: 'Đơn vị chủ trì', minWidth: 90},
    // { name: 'Đơn vị phối hợp', minWidth: 140},
    { name: 'Thao tác', minWidth: 95 }],
    TMDTTT: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng' },
    /* { name: 'Loại ĐT'},
    { name: 'SĐT'},
    { name: 'Địa chỉ'},
    { name: 'Ngành/Lĩnh vực'},
    { name: 'Ghi chú'}, */
    { name: 'Nhóm đối tượng' }, { name: 'Mã số thuế' }, { name: 'Thao tác', width: 70, minWidth: 70 }],
    TMDTTT2: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng' }, { name: 'Nhóm đối tượng' }, { name: 'Mã số thuế' }, { name: 'Huyện/TP' }, { name: 'Phường/Xã' }, { name: 'Địa chỉ' }, { name: 'Thao tác', width: 70, minWidth: 70 }],
    KQTKTMDTTT: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng' },
    /* { name: 'Loại ĐT'},
    { name: 'SĐT'},
    { name: 'Địa chỉ'},
    { name: 'Ngành/Lĩnh vực'},
    { name: 'Ghi chú'}, */
    { name: 'Nhóm đối tượng' }, { name: 'Mã số thuế' }],
    KQTKTMDTTT2: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng' }, { name: 'Nhóm đối tượng' }, { name: 'Mã số thuế' }, { name: 'Huyện/TP' }, { name: 'Phường/Xã' }, { name: 'Địa chỉ' }],
    DSCTT: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra, kiểm tra/Số đối tượng', width: 220 }, { name: 'Nội dung thanh tra, kiểm tra', minWidth: 80, width: 170 }, { name: 'Hình thức/Loại hình TT, KT', width: 220 }, { name: 'Số QĐKHTT/QĐKHKT', width: 120 }, { name: 'Số QĐ/ Ngày ra QĐ', width: 130 }, { name: 'Số kết luận TT/Số quyết định XL', width: 220 }, { name: 'Thời hạn TT/KT', width: 100 }, { name: 'Tiến độ', width: 140 }, { name: 'Hoạt động', width: 140 }, { name: 'Thao tác', minWidth: 100, maxWidth: 135, width: 135 }],
    CTCTT: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng thanh tra', minWidth: 160 }, { name: 'Nội dung thanh tra', minWidth: 160 }, { name: 'Chức năng/ Lĩnh vực thanh tra', width: 130 }, { name: 'Thời hạn (ngày làm việc)', width: 120 }, { name: 'Thời kỳ thanh tra', width: 125 }, { name: 'Thời gian tiến hành', width: 120 }],
    DSDTT: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra' }, { name: 'Nội dung thanh tra' }, { name: 'Hình thức' }, { name: 'Thời hạn thanh tra' }, { name: 'Thời kỳ thanh tra' }, { name: 'Thời gian tiến hành' }, { name: 'Đơn vị thanh tra' }, { name: 'Năm thanh tra', width: 150 }],
    CTTVCTT: [{ name: 'STT', width: 45 }, { name: 'Họ và tên' }, { name: 'Ngày sinh' }, { name: 'Đơn vị' }, { name: 'Chức vụ' }, { name: 'Vai trò' }],
    TMTVCTT: [{ name: 'STT', width: 45 }, { name: 'Họ và tên' }, { name: 'Ngày sinh', width: 145, maxWidth: 145, minWidth: 145 }, { name: 'Đơn vị' }, { name: 'Chức vụ' }, { name: 'Vai trò' }, { name: 'Thao tác', width: 70, maxWidth: 70, minWidth: 70 }],
    TMTVCTTV: [{ name: 'STT', width: 45 }, { name: 'Họ và tên' }, { name: 'Ngày sinh', width: 145, maxWidth: 145, minWidth: 145 }, { name: 'Đơn vị' }, { name: 'Chức vụ' }, { name: 'Vai trò' }],
    danhSachDoiTuongViPham: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng vi phạm' }, { name: 'Lĩnh vực' }, { name: 'Tình trạng', width: 145, maxWidth: 145, minWidth: 145 }, { name: 'Thao tác', width: 150, maxWidth: 150, minWidth: 150 }],
    danhSachDoiTuongViPhamView: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng vi phạm' }, { name: 'Lĩnh vực' }, { name: 'Tình trạng', width: 145, maxWidth: 145, minWidth: 145 }],
    DMTTDX: [{ name: 'STT', width: 45 }, { name: 'Đối tượng', width: 175 }, { name: 'Hướng đề xuất của Thanh tra tỉnh', width: 500 }]
  },
  thanhTraTrung: {
    DMCTTT: [{ name: 'STT', width: 30 }, { name: 'Đối tượng thanh tra/kiểm tra', width: 145 }, { name: 'Đơn vị thanh tra/kiểm tra', width: 110 }, { name: 'Kế hoạch thanh tra/kiểm tra', width: 60 }, { name: 'Năm thanh tra/kiểm tra', width: 65 },
    // { name: 'Tên cuộc/Số đối tượng', width: 180 },
    { name: 'Nội dung cuộc thanh tra', width: 215 }, { name: 'Hoạt động', width: 86 }, { name: 'Phạm vi', width: 100 }, { name: 'Thời gian tiến hành', width: 104 }, { name: 'Trạng thái xử lý/Gợi ý ưu tiên', width: 215 }],
    DMTHCTTCDV: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra, kiểm tra/ Số đối tượng', width: 250 }, { name: 'Nội dung thanh tra/kiểm tra', width: 400 }, { name: 'Đơn vị thanh tra/kiểm tra', width: 315 }, { name: 'Năm thanh tra/kiểm tra', width: 90 }, { name: 'Số quyết định KHTT/KHKT', width: 110 }, { name: 'Thời gian gửi KHTT/KHKT', width: 110 }, { name: 'Hoạt động', width: 150 }, { name: 'Tiến độ', width: 150 }],
    CNNDXL: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra', width: 150 }, { name: 'Đơn vị thanh tra', width: 90 }, { name: 'Kế hoạch thanh tra', width: 100 }, { name: 'Năm thanh tra', width: 80 }, { name: 'Tên cuộc/Số đối tượng', width: 230 }, { name: 'Chuyên viên đề xuất', width: 330 }, { name: 'Hoạt động', width: 100 }, { name: 'Phạm vi', width: 100 }, { name: 'Trạng thái xử lý ĐV', width: 100 }, { name: 'Trạng thái xử lý trùng', width: 100 }],
    CNNDXLCT: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra/kiểm tra', width: 150 }, { name: 'Đơn vị thanh tra/kiểm tra', width: 90 }, { name: 'Kế hoạch thanh tra/kiểm tra', width: 100 }, { name: 'Năm thanh tra/kiểm tra', width: 80 }, { name: 'Tên cuộc/Số đối tượng', width: 230 }, { name: 'Chuyên viên đề xuất', width: 330 }, { name: 'Phạm vi', width: 100 }, { name: 'Trạng thái xử lý ĐV', width: 100 }],
    KHTTD: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng thanh tra/Số đối tượng', width: 120 }, { name: 'Nội dung thanh tra/kiểm tra', width: 245 }, { name: 'Thời hạn thanh tra/kiểm tra', width: 75 }, { name: 'Thời kỳ thanh tra/kiểm tra', width: 140 }, { name: 'Thời gian tiến hành', width: 110 }],
    DSTHKHTT: [{ name: 'STT', width: 35 }, { name: 'Năm thanh tra/kiểm tra', width: 500 }, { name: 'Quyết định phê duyệt KHTT/KHKT', width: 200 }, { name: 'Ngày phê duyệt', width: 200 }, { name: 'Đơn vị', width: 300 }, { name: 'Số cuộc TT/KT', width: 200 }, { name: 'Hoạt động', width: 200 }, { name: 'Tiến độ', width: 200 }],
    DSLSXLTTT: [{ name: 'STT', width: 45 }, { name: 'Lần xử lý', width: 150 }, { name: 'Số quyết định' }, { name: 'Ngày ban hành' }, { name: 'Năm thanh tra/kiểm tra' }, { name: 'Thời gian xử lý' }, { name: 'Tài liệu đính kèm' }, { name: 'Thao tác' }],
    DSTB: [{ name: 'STT', width: 35 }, { name: 'Ngày thông báo', width: 120 }, { name: 'Nội dung thông báo' }, { name: 'Phân hệ', width: 100 }, { name: 'Thao tác', width: 100 }]
  },
  theoDoi: {
    tinhHinhXLDDonVi: [[{ name: 'STT', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Tên đơn vị', className: 'txt-left', colSpan: 1, rowSpan: 2 }, { name: 'Đang xử lý', colSpan: 2, rowSpan: 1 }, { name: 'Đã xử lý', colSpan: 2, rowSpan: 1 }, { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }], [{ name: 'Đúng hạn', width: 120, minWidth: 120 }, { name: 'Trễ hạn', width: 120, minWidth: 120 }, { name: 'Đúng hạn', width: 120, minWidth: 120 }, { name: 'Trễ hạn', width: 120, minWidth: 120 }]],
    theoDoiDonDocTheoKy: [[{ name: 'STT', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Đơn vị', colSpan: 1, rowSpan: 2, minWidth: 150 }, { name: 'Tiếp nhận trong kỳ', colSpan: 1, rowSpan: 2 }, { name: 'Kỳ trước chuyển sang', colSpan: 1, rowSpan: 2 }, { name: 'Tổng đơn', colSpan: 1, rowSpan: 2, minWidth: 100 }, { name: 'Đơn đang XLD, GQD', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100 }, { name: 'Đơn đã XLD, GQD', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100 }]],
    danhSachDonTreHan: [{ name: 'STT', width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Mã tra cứu', className: 'txt-center' }, { name: 'Ngày tiếp nhận' }, { name: 'Người đứng đơn', width: 500, maxWidth: 500, minWidth: 300 }, { name: 'Tóm tắt nội dung', width: 600, maxWidth: 600, minWidth: 300 }, { name: 'Đơn vị xử lý, giải quyết', minWidth: 150 }, { name: 'Phân loại đơn/Số người', minWidth: 100 }],
    danhSachThongKeGiamSatDonCu: [{ name: 'STT', width: 40 }, { name: 'Người đứng đơn', className: 'txt-center', width: 150 }, { name: 'Tóm tắt nội dung', width: 400, maxWidth: 600, minWidth: 300 }, { name: 'Phân loại đơn/ Số người', width: 150 }, { name: 'Nguồn đơn', width: 150 }],
    thongKeGiamSatNhapDonCu: [{ name: 'STT', width: 40, maxWidth: 40, minWidth: 40 }, { name: 'Tên đơn vị', className: 'txt-center' }, { name: 'Số đơn đơn giản' }, { name: 'Số đơn phức tạp' }, { name: 'Tổng đơn' }]
  },
  doiTuongThanhTra: [{ name: 'STT', width: 45 }, { name: 'Mã số DN', width: 90 }, { name: 'Tên', width: 200 }, { name: 'Loại đối tượng thanh tra', width: 150 }, { name: 'Địa chỉ', width: 260 }, { name: 'Số điện thoại', width: 150 }, { name: 'Trạng thái', width: 150 }, { name: 'Ghi chú', width: 150 }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  nhomDoiTuongThanhTra: [{ name: 'STT', width: "5%" }, { name: 'Tên nhóm', width: "35%" }, { name: 'Mô tả', width: "45%" }, { name: 'Thao tác', width: "15%", minWidth: "15%" }],
  popUpCongChucSNV: [{ name: 'STT', width: 45 }, { name: 'Tên', width: 200 }, { name: 'Thông tin cá nhân' }, { name: 'Trạng thái' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  popUpDonViSNV: [{ name: 'STT', width: 45 }, { name: 'Tên đơn vị', width: 200 }, { name: 'Tên cấp đơn vị', width: 200 }, { name: 'Tên đơn vị cấp trên' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  listTraCuuTTCP: [{ name: 'STT', width: 44 }, { name: 'Người đứng đơn', width: 200 }, { name: 'Số CMND', width: 150 }, { name: 'Địa chỉ', minWidth: 200 }, { name: 'Nội dung đơn', minWidth: 200 }],
  listTraCuuDon: [{ name: 'STT', width: 44 }, { name: 'Mã tra cứu', width: 100 }, { name: 'Ngày tiếp nhận', width: 95 }, { name: 'Người đứng đơn', minWidth: 150 }, { name: 'Tóm tắt nội dung', minWidth: 120 }, { name: 'Phân loại đơn /Số người', width: 170 }, { name: 'Nguồn đơn', width: 85 }],
  listTraCuuDonCu: [{ name: 'STT', width: '5%' }, { name: 'Người đứng đơn', minWidth: '25%' }, { name: 'Tóm tắt nội dung', minWidth: '35%' }, { name: 'Phân loại đơn /Số người', width: '20%' }, { name: 'Nguồn đơn', width: '15%' }],
  baoCaoDinhKy: [{ name: 'STT', width: 44 }, { name: 'Tên báo cáo', className: 'txt-left' }, { name: 'Kỳ báo cáo', className: 'txt-left' }, { name: 'Năm', className: 'txt-left' }, { name: 'Hạn nộp', className: 'txt-left' }, { name: 'Trạng thái', className: 'txt-left' }, { name: 'Ngày nộp', className: 'txt-left' }],
  baoCaoTongHop: [{ name: 'STT', width: 44 }, { name: 'Tên báo cáo', className: 'txt-left' }, { name: 'Kỳ báo cáo', className: 'txt-left' }, { name: 'Năm', className: 'txt-left' }, { name: 'Đơn vị đã báo cáo', className: 'txt-left' }],
  baoCaoDinhKyChiTiet: [{ name: 'STT', width: 44 }, { name: 'Tên báo cáo', className: 'txt-left' }, { name: 'Ngày chốt báo cáo', className: 'txt-left' }, { name: 'Trạng thái', className: 'txt-left' }, { name: 'Văn bản đính kèm', className: 'txt-left' }],
  baoCaoTongHopDSBC: [{ name: 'STT', width: 44 }, { name: 'Tên báo cáo', className: 'txt-left' }, { name: 'Trạng thái', className: 'txt-left', width: 170 }, { name: 'Ngày tổng hợp', className: 'txt-left', width: 170 }],
  chiTietDonViBCTH: [{ name: 'STT', width: 44 }, { name: 'Tên báo cáo', className: 'txt-left' }, { name: 'Văn bản đính kèm', className: 'txt-left', width: 300 }],
  baoCaoTongHopDSDonVi: [{ name: 'STT', width: 44 }, { name: 'Tên đơn vị', className: 'txt-left' }, { name: 'Hạn nộp báo cáo', className: 'txt-left' }, { name: 'Trạng thái', className: 'txt-left' }, { name: 'Ngày nộp', className: 'txt-left' }, { name: 'Thao tác', className: 'txt-left' }],
  theoDoiThucHien: {
    danhSach: [{ name: 'STT', width: 45 }, { name: 'Đối tượng thanh tra/Số đối tượng', width: 220 }, { name: 'Nội dung thanh tra, kiểm tra', minWidth: 80, width: 170 }, { name: 'Hình thức/Loại hình thanh tra, kiểm tra', width: 220 }, { name: 'Số QĐ/ Ngày ra QĐ', width: 130 }, { name: 'Ngày chuyển theo dõi', width: 150 }, { name: 'Số kết luận', width: 150 }, { name: 'Trạng thái', width: 150 }, { name: 'Thao tác', minWidth: 100, maxWidth: 100, width: 100 }],
    danhSachDoiTuongViPham: [{ name: 'STT', width: 45 }, { name: 'Tên đối tượng vi phạm' }, { name: 'Lĩnh vực', width: 220 }, { name: 'Thời hạn', width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Tiến độ', width: 220, maxWidth: 220, minWidth: 220 }, { name: 'Thao tác', width: 150, maxWidth: 150, minWidth: 150 }]
  },
  searchKHTTDialog: [{ name: 'STT', width: 45 }, { name: 'Quyết định phê duyệt KHTT', width: 145 }, { name: 'Ngày phê duyệt', width: 110 }, { name: 'Năm thanh tra', width: 110 }, { name: 'Chức năng thanh tra', width: 150 }, { name: 'Người ký', width: 150 }, { name: 'Thao tác', minWidth: 200 }],
  nhaNuocVeThanhTra: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'BAN HÀNH VĂN BẢN QUẢN LÝ, CHỈ ĐẠO (BỘ, NGÀNH, TỈNH, TP) VỀ CÔNG TÁC THANH TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 }, { name: 'TẬP HUẤN, TUYÊN TRUYỀN, GIÁO DỤC PHÁP LUẬT VỀ THANH TRA CHO CÁN BỘ, CÔNG CHỨC, VIÊN CHỨC, NHÂN DÂN', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'THANH TRA, KIỂM TRA TRÁCH NHIỆM', className: 'middle-content', colSpan: 9, rowSpan: 1 }, { name: 'KIỂM TRA VIỆC THỰC HIỆN THANH TRA TRÁCH NHIỆM, QUYẾT ĐỊNH XỬ LÝ', className: 'middle-content', colSpan: 5, rowSpan: 1 }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Pháp luật về thanh tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Pháp luật về thanh tra, KNTC, PCTN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Thực hiện pháp luật về thanh tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Thực hiện pháp luật về thanh tra, KNTC, PCTN', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Số đơn vị có vi phạm', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Kiến  nghị xử lý', colSpan: 4, rowSpan: 1, className: 'middle-content' }, { name: 'Tổng số KLTT và QĐ xử lý đã kiểm tra', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Kết quả kiểm tra', colSpan: 4, rowSpan: 1, className: 'middle-content' }], [{ name: 'Số văn bản ban hành mới', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số văn bản được sửa đổi, bổ sung', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }]],
  xayDungLucLuongThanhTra: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'THỰC TRẠNG CÁN BỘ CÔNG CHỨC TRONG KỲ BÁO CÁO', className: 'middle-content', colSpan: 6, rowSpan: 1 }, { name: 'BIẾN ĐỘNG TRONG KỲ BÁO CÁO (SỐ CBCC)', className: 'middle-content', colSpan: 7, rowSpan: 1 }, { name: 'ĐÀO TẠO, BỒI DƯỠNG NGHIỆP VỤ THANH TRA', className: 'middle-content', colSpan: 8, rowSpan: 1 }, { name: 'ĐÀO TẠO LÝ LUẬN CHÍNH TRỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'ĐÀO TẠO KHÁC (NGOẠI NGỮ, TIN HỌC, TRÊN ĐẠI HỌC)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }], [{ name: 'Tổng số', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Trong đó', colSpan: 5, rowSpan: 1, className: 'middle-content' }, { name: 'Tiếp nhận, tuyển dụng', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Nghỉ hưu, chuyển công tác', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Bổ nhiệm chức vụ lãnh đạo', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Bổ nhiệm vào ngạch, nâng ngạch', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Chuyển đổi vị trí công tác', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }, { name: 'Vi phạm kỷ luật', colSpan: 2, rowSpan: 2, className: 'middle-content' }, { name: 'Tổng số', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Trong đó', colSpan: 6, rowSpan: 1, className: 'middle-content' }], [{ name: 'Số TTV cao cấp và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số TTV chính và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số TTV và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số CB, CC, VC trong biên chế', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Số lao động hợp đồng', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Nhu cầu', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Đã thực hiện', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Thanh tra viên', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Thanh tra viên chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Thanh tra viên cao cấp', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Phải xử lý', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Đã xử lý', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }, { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' }]],
  tongHopSoLieu: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'SỐ NGƯỜI PHẢI KÊ KHAI TRONG NĂM', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐÃ KÊ KHAI', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI CÔNG KHAI THEO HÌNH THỨC NIÊM YẾT', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI CÔNG KHAI THEO HÌNH THỨC TỔ CHỨC CUỘC HỌP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐƯỢC XÁC MINH TÀI SẢN, THU NHẬP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐÃ CÓ KẾT LUẬN VỀ VIỆC KÊ KHAI TÀI SẢN, THU NHẬP KHÔNG TRUNG THỰC', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ KỸ LUẬT DO KÊ KHAI TÀI SẢN, THU NHẬP KHÔNG TRUNG THỰC', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ KỸ LUẬT DO CHẬM TỔ CHỨC KÊ KHAI, CHẬM KÊ KHAI, CHẬM TỔNG HỢP, BÁO CÁO KẾT QUẢ MINH BẠCH TÀI SẢN', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ TRÁCH NHIỆM TRONG XÁC MINH TÀI SẢN THU NHẬP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao }, { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 150, maxWidth: 150, minWidth: 150 }]],
  quanLyHoSo: {
    dsQuanLyHoSo: [{ name: 'STT', width: 45 }, { name: 'Mã hồ sơ' }, { name: 'Người lưu hồ sơ' }, { name: 'Cơ quan lưu trữ' }, { name: 'Thời gian lưu hồ sơ' }],
    dsVanBanXuLy: [{ name: 'STT', width: 45 }, { name: 'Tên tài liệu' }, { name: 'Số văn bản' }, { name: 'Ngày ra văn bản' }, { name: 'Tài liệu đính kèm' }]
  },
  quanLyVanBan: {
    dsQuanLyDanhMucVanBan: [{ name: 'STT', width: 45 }, { name: 'Tên văn bản' }, { name: 'Cơ quan ban hành' }, { name: 'Thể loại văn bản' }, { name: 'Lĩnh vực văn bản' }, { name: 'Thao tác', width: 180 }],
    dsTheLoaiVanBan: [{ name: 'STT', width: 45 }, { name: 'Thể loại văn bản' }, { name: 'Mô tả' }, { name: 'Thao tác', width: 180 }],
    dsLinhVucVanBan: [{ name: 'STT', width: 45 }, { name: 'Tên lĩnh vực văn bản' }, { name: 'Thao tác', width: 180 }],
    dsCoQuanBanHanhVanBan: [{ name: 'STT', width: 45 }, { name: 'Tên cơ quan ban hành' }, { name: 'Thao tác', width: 180 }],
    dsNhomHoSo: [{ name: 'STT', width: 45 }, { name: 'Tên nhóm hồ sơ' }, { name: 'Mô tả' }, { name: 'Thao tác', width: 180 }]
  },
  dsCanCuCuocThanhTra: [{ name: 'STT', width: 45 }, { name: 'Tên văn bản' }, { name: 'Cơ quan ban hành' }, { name: 'Thể loại văn bản' }, { name: 'Lĩnh vực văn bản' }, { name: 'Văn bản đính kèm' }, { name: 'Thao tác', width: 100 }],
  dsCanCuCuocThanhTraView: [{ name: 'STT', width: 45 }, { name: 'Tên văn bản' }, { name: 'Cơ quan ban hành' }, { name: 'Thể loại văn bản' }, { name: 'Lĩnh vực văn bản' }, { name: 'Văn bản đính kèm' }],
  taiLieuTrenQLVBDH: [{ name: 'STT', width: 45 }, { name: 'Ngày ban hành', width: 140 }, { name: 'Số ký hiệu', width: 120 }, { name: 'Người lập dự thảo', width: 160 }, { name: 'Cơ quan ban hành', width: 180 }, { name: 'Tài liệu đính kèm', width: 100 }],
  thongKeBaoCaoThanhTraThamNhung: [[{ name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 }, { name: 'ĐƠN VỊ PHÁT HIỆN', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 }, { name: 'SỐ VỤ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn }, { name: 'SỐ NGƯỜI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn }, { name: 'TÀI SẢN THAM NHŨNG', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KIẾN NGHỊ THU HỒI', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'ĐÃ THU', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KIẾN NGHỊ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'KẾT QUẢ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 }, { name: 'XỬ LÝ TRÁCH NHIỆM NGƯỜI ĐỨNG ĐẦU', className: 'middle-content', colSpan: 2, rowSpan: 2 }], [{ name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }, { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' }, { name: 'Đã khởi tố', colSpan: 2, rowSpan: 1, className: 'middle-content' }], [{ name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Kiến nghị', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }, { name: 'Đã xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }]]
};

exports.header = header;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(229)(module)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTableKetQua = undefined;

var _DataTableKetQua = __webpack_require__(958);

var _DataTableKetQua2 = _interopRequireDefault(_DataTableKetQua);

var _DataTable = __webpack_require__(957);

var _DataTable2 = _interopRequireDefault(_DataTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DataTableKetQua = _DataTableKetQua2.default;
exports.default = _DataTable2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = __webpack_require__(939);

var API_URL = config.API_URL || 'http://dev.thanhtratp.greenglobal.vn:9830';
var API_SSO_URL = config.API_SSO_URL || 'http://dev.thanhtratp.greenglobal.vn:9830';
var API_URL_SSO = config.API_URL_SSO || 'https://login.quangngai.gov.vn/oauth2/authorize';
var CLIENT_ID = config.CLIENT_ID || '9yE_BFWfsdSs9OttIu_CY42NJq8a';
var REDIRECT_URI = config.REDIRECT_URI || 'https://quanlythanhtra.quangngai.gov.vn/api/sso/oauth2/callback';
var TimeDelay = 1000;
var LimitFileSize = 50;
var LimitVideoFileSize = 50;
var LimitFileType = ['doc', 'docx', 'pdf', 'rar', 'zip', 'jpg', 'png'];
var LimitFileType2 = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'rar', 'zip', 'jpg', 'png'];
var LimitPhotoType = ['jpg', 'png'];
var LimitVideoType = ['flv', 'mp4'];
var DateFormat = 'DD/MM/YYYY';
var ThanhPhoDN_ID = 9;
var TRACKER_URL = config.TRACKER_URL || 'http://tracker.thanhtratp.greenglobal.vn:9836';
var ENV = config.ENV || 'development';
var FILE_ENV = config.FILE_ENV || 'development';
var FILE_LIVE_ENV = 'live';
var checkServerLive = FILE_LIVE_ENV === FILE_ENV;
var siteKey = config.RECAPTCHA_SITE_KEY;

exports.API_URL = API_URL;
exports.API_SSO_URL = API_SSO_URL;
exports.checkServerLive = checkServerLive;
exports.TimeDelay = TimeDelay;
exports.LimitFileSize = LimitFileSize;
exports.LimitFileType = LimitFileType;
exports.LimitFileType2 = LimitFileType2;
exports.LimitPhotoType = LimitPhotoType;
exports.LimitVideoType = LimitVideoType;
exports.LimitVideoFileSize = LimitVideoFileSize;
exports.DateFormat = DateFormat;
exports.ThanhPhoDN_ID = ThanhPhoDN_ID;
exports.TRACKER_URL = TRACKER_URL;
exports.ENV = ENV;
exports.FILE_LIVE_ENV = FILE_LIVE_ENV;
exports.FILE_ENV = FILE_ENV;
exports.siteKey = siteKey;
exports.API_URL_SSO = API_URL_SSO;
exports.CLIENT_ID = CLIENT_ID;
exports.REDIRECT_URI = REDIRECT_URI;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemFileDinhKem = exports.ContainerFileDinhKem = exports.UploadNonTable = undefined;

var _uploadNontable = __webpack_require__(1578);

var _uploadNontable2 = _interopRequireDefault(_uploadNontable);

var _containerFiledinhkem = __webpack_require__(1577);

var _containerFiledinhkem2 = _interopRequireDefault(_containerFiledinhkem);

var _rowitemFiledinhkem = __webpack_require__(507);

var _rowitemFiledinhkem2 = _interopRequireDefault(_rowitemFiledinhkem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.UploadNonTable = _uploadNontable2.default;
exports.ContainerFileDinhKem = _containerFiledinhkem2.default;
exports.RowItemFileDinhKem = _rowitemFiledinhkem2.default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchKeHoachTT = exports.ChiTietDoiTuongThanhTraDialog = exports.MaTraCuuDialog = exports.ChiTietDonDialog = exports.TruongPhongThuHoiDialog = exports.XuLyYeuCau = exports.ThuHoiDialog = exports.ConfirmDialog = exports.SuspendedDialog = exports.GiaHanDialog = exports.HistoryDialog = exports.DeleteDialog = undefined;

var _DeleteDialog = __webpack_require__(1078);

var _DeleteDialog2 = _interopRequireDefault(_DeleteDialog);

var _HistoryDialog = __webpack_require__(1080);

var _HistoryDialog2 = _interopRequireDefault(_HistoryDialog);

var _GiaHanDialog = __webpack_require__(1079);

var _GiaHanDialog2 = _interopRequireDefault(_GiaHanDialog);

var _SuspendedDialog = __webpack_require__(1083);

var _SuspendedDialog2 = _interopRequireDefault(_SuspendedDialog);

var _ConfirmDialog = __webpack_require__(1077);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _ThuHoiDialog = __webpack_require__(1084);

var _ThuHoiDialog2 = _interopRequireDefault(_ThuHoiDialog);

var _XuLyYeuCau = __webpack_require__(1086);

var _XuLyYeuCau2 = _interopRequireDefault(_XuLyYeuCau);

var _TruongPhongThuHoiDialog = __webpack_require__(1085);

var _TruongPhongThuHoiDialog2 = _interopRequireDefault(_TruongPhongThuHoiDialog);

var _ChiTietDonDialog = __webpack_require__(1076);

var _ChiTietDonDialog2 = _interopRequireDefault(_ChiTietDonDialog);

var _MaTraCuuDialog = __webpack_require__(1081);

var _MaTraCuuDialog2 = _interopRequireDefault(_MaTraCuuDialog);

var _ChiTietDoiTuongThanhTraDialog = __webpack_require__(1075);

var _ChiTietDoiTuongThanhTraDialog2 = _interopRequireDefault(_ChiTietDoiTuongThanhTraDialog);

var _SearchKeHoachTT = __webpack_require__(1082);

var _SearchKeHoachTT2 = _interopRequireDefault(_SearchKeHoachTT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DeleteDialog = _DeleteDialog2.default;
exports.HistoryDialog = _HistoryDialog2.default;
exports.GiaHanDialog = _GiaHanDialog2.default;
exports.SuspendedDialog = _SuspendedDialog2.default;
exports.ConfirmDialog = _ConfirmDialog2.default;
exports.ThuHoiDialog = _ThuHoiDialog2.default;
exports.XuLyYeuCau = _XuLyYeuCau2.default;
exports.TruongPhongThuHoiDialog = _TruongPhongThuHoiDialog2.default;
exports.ChiTietDonDialog = _ChiTietDonDialog2.default;
exports.MaTraCuuDialog = _MaTraCuuDialog2.default;
exports.ChiTietDoiTuongThanhTraDialog = _ChiTietDoiTuongThanhTraDialog2.default;
exports.SearchKeHoachTT = _SearchKeHoachTT2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDownSort = exports.DropDownNguoiKy = exports.DropDownChonCoQuanDieuTra = exports.DropDownMulipleUse = exports.DropDownChonDonViChuTriThanhTra = exports.DropDownQuyTrinh = exports.DropDownChonCanCuThanhTraLai = exports.DropDownChonHinhThucThanhTra = exports.DropDownChonLoaiHinhThanhTra = exports.DropDownChonLinhVucThanhTraMultiple = exports.DropDownChonLinhVucThanhTra = exports.DropDownChonTienDoThanhTra = exports.DropDownChonNganhLinhVuc = exports.DropDownChonLoaiDoiTuongThanhTra = exports.DropDownChonKyThanhTra = exports.DropDownChonKetQuaGiaiQuyet = exports.DropDownChonLoaiThangThongKe = exports.DropDownChonLoaiNamThongKe = exports.DropDownChonLoaiKyThongKe = exports.DropDownChonLoaiQuyThongKe = exports.DropDownChonDonViThongKe = exports.DropDownKetQuaGiaiQuyetDon = exports.DropDownKetQuaGiaiQuyet = exports.DropDownChonStateXuLyDon = exports.DropDownChonTinhTrangTaiLieu = exports.DropDownChonKetQuaThucHien = exports.DropDownChonKetLuanNoiDungKhieuNai = exports.DropDownChonCoQuanTiepNhan = exports.DropDownChonHuongXuLyTheoDon = exports.DropDownChonCanBoXuLy = exports.DropDownChonPhongBanThuocCoQuan = exports.DropDownChonPhoPhong = exports.DropDownChonQuyTrinhGiaiQuyetDon = exports.DropDownChonDonViTTXM = exports.DropDownChonCanBoGiaiQuyet = exports.DropDownTinhTrangGiaiQuyet = exports.DropDownChonHuongXuLyLanhDao = exports.DropDownChonDonViChuTri = exports.DropDownChonHinhThucDaGiaiQuyet = exports.DropDownChonCoQuanDaGiaiQuyet = exports.DropDownChonCapCoQuanDaGiaiQuyet = exports.DropDownChonNhomThamQuyenGiaiQuyet = exports.DropDownChonLinhVucDonThuChiTiet = exports.DropDownChonLinhVucDonThu = exports.DropDownChonLoaiDoiTuong = exports.DropDownChonDanToc = exports.RadioButtonChonTrangThaiKHTT = exports.RadioButtonChonTrangThaiXuLyDon = exports.DropDownChonPhuongXa = exports.DropDownChonNoiCapCMND = exports.DropDownChonQuocTich = exports.DropDownChonQuanHuyen = exports.DropDownChonTinhThanh = exports.DropDownTinhTrangXuLy = exports.DropDownKetQuaTiepDan = exports.DropDownChonKetQuaXuLy = exports.DropDownChonNguonDon = exports.DropDownChonHuongXuLy = exports.DropDownChonLoaiDonThu = undefined;

var _dropdownChonloaidonthu = __webpack_require__(1548);

var _dropdownChonloaidonthu2 = _interopRequireDefault(_dropdownChonloaidonthu);

var _dropdownChonhuongxuly = __webpack_require__(1536);

var _dropdownChonhuongxuly2 = _interopRequireDefault(_dropdownChonhuongxuly);

var _dropdownChonnguondon = __webpack_require__(1554);

var _dropdownChonnguondon2 = _interopRequireDefault(_dropdownChonnguondon);

var _dropdownChonketquaxuly = __webpack_require__(1542);

var _dropdownChonketquaxuly2 = _interopRequireDefault(_dropdownChonketquaxuly);

var _dropdownKetquatiepdan = __webpack_require__(1562);

var _dropdownKetquatiepdan2 = _interopRequireDefault(_dropdownKetquatiepdan);

var _dropdownTinhtrangxuly = __webpack_require__(1570);

var _dropdownTinhtrangxuly2 = _interopRequireDefault(_dropdownTinhtrangxuly);

var _dropdownTinhthanh = __webpack_require__(1568);

var _dropdownTinhthanh2 = _interopRequireDefault(_dropdownTinhthanh);

var _dropdownQuanhuyen = __webpack_require__(1565);

var _dropdownQuanhuyen2 = _interopRequireDefault(_dropdownQuanhuyen);

var _dropdownQuoctich = __webpack_require__(1566);

var _dropdownQuoctich2 = _interopRequireDefault(_dropdownQuoctich);

var _dropdownNoicapCMND = __webpack_require__(1563);

var _dropdownNoicapCMND2 = _interopRequireDefault(_dropdownNoicapCMND);

var _dropdownPhuongxa = __webpack_require__(1564);

var _dropdownPhuongxa2 = _interopRequireDefault(_dropdownPhuongxa);

var _radiobuttonChontrangthaixulydon = __webpack_require__(1572);

var _radiobuttonChontrangthaixulydon2 = _interopRequireDefault(_radiobuttonChontrangthaixulydon);

var _radiobuttonChontrangthaikhtt = __webpack_require__(1571);

var _radiobuttonChontrangthaikhtt2 = _interopRequireDefault(_radiobuttonChontrangthaikhtt);

var _dropdownChondantoc = __webpack_require__(1531);

var _dropdownChondantoc2 = _interopRequireDefault(_dropdownChondantoc);

var _dropdownChonloaidoituong = __webpack_require__(1546);

var _dropdownChonloaidoituong2 = _interopRequireDefault(_dropdownChonloaidoituong);

var _dropdownChonlinhvucdonthu = __webpack_require__(1544);

var _dropdownChonlinhvucdonthu2 = _interopRequireDefault(_dropdownChonlinhvucdonthu);

var _dropdownChonlinhvucdonthuchitiet = __webpack_require__(1545);

var _dropdownChonlinhvucdonthuchitiet2 = _interopRequireDefault(_dropdownChonlinhvucdonthuchitiet);

var _dropdownChonnhomthamquyengiaiquyet = __webpack_require__(1555);

var _dropdownChonnhomthamquyengiaiquyet2 = _interopRequireDefault(_dropdownChonnhomthamquyengiaiquyet);

var _dropdownChoncapcoquandagiaiquyet = __webpack_require__(1528);

var _dropdownChoncapcoquandagiaiquyet2 = _interopRequireDefault(_dropdownChoncapcoquandagiaiquyet);

var _dropdownChoncoquandagiaiquyet = __webpack_require__(1529);

var _dropdownChoncoquandagiaiquyet2 = _interopRequireDefault(_dropdownChoncoquandagiaiquyet);

var _dropdownChonhinhthucdagiaiquyet = __webpack_require__(1535);

var _dropdownChonhinhthucdagiaiquyet2 = _interopRequireDefault(_dropdownChonhinhthucdagiaiquyet);

var _dropdownChondonvichutri = __webpack_require__(1533);

var _dropdownChondonvichutri2 = _interopRequireDefault(_dropdownChondonvichutri);

var _dropdownChonhuongxulylanhdao = __webpack_require__(1537);

var _dropdownChonhuongxulylanhdao2 = _interopRequireDefault(_dropdownChonhuongxulylanhdao);

var _dropdownTinhtranggiaiquyet = __webpack_require__(1569);

var _dropdownTinhtranggiaiquyet2 = _interopRequireDefault(_dropdownTinhtranggiaiquyet);

var _dropdownChoncanbogiaiquyet = __webpack_require__(1526);

var _dropdownChoncanbogiaiquyet2 = _interopRequireDefault(_dropdownChoncanbogiaiquyet);

var _dropdownChondonviTTXM = __webpack_require__(1532);

var _dropdownChondonviTTXM2 = _interopRequireDefault(_dropdownChondonviTTXM);

var _dropdownChonquytrinhgiaiquyetdon = __webpack_require__(1557);

var _dropdownChonquytrinhgiaiquyetdon2 = _interopRequireDefault(_dropdownChonquytrinhgiaiquyetdon);

var _dropdownChonphongbanthuoccoquan = __webpack_require__(1556);

var _dropdownChonphongbanthuoccoquan2 = _interopRequireDefault(_dropdownChonphongbanthuoccoquan);

var _dropdownChoncanboxuly = __webpack_require__(1527);

var _dropdownChoncanboxuly2 = _interopRequireDefault(_dropdownChoncanboxuly);

var _dropdownChonhuongxulytheodon = __webpack_require__(1538);

var _dropdownChonhuongxulytheodon2 = _interopRequireDefault(_dropdownChonhuongxulytheodon);

var _dropdownChoncoquantiepnhan = __webpack_require__(1530);

var _dropdownChoncoquantiepnhan2 = _interopRequireDefault(_dropdownChoncoquantiepnhan);

var _dropdownChonketluannoidungkhieunai = __webpack_require__(1539);

var _dropdownChonketluannoidungkhieunai2 = _interopRequireDefault(_dropdownChonketluannoidungkhieunai);

var _dropdownChonketquathuchien = __webpack_require__(1541);

var _dropdownChonketquathuchien2 = _interopRequireDefault(_dropdownChonketquathuchien);

var _dropdownChontinhtrangtailieu = __webpack_require__(1559);

var _dropdownChontinhtrangtailieu2 = _interopRequireDefault(_dropdownChontinhtrangtailieu);

var _dropdownChonstatexulydon = __webpack_require__(1558);

var _dropdownChonstatexulydon2 = _interopRequireDefault(_dropdownChonstatexulydon);

var _dropdownKetquagiaiquyet = __webpack_require__(1560);

var _dropdownKetquagiaiquyet2 = _interopRequireDefault(_dropdownKetquagiaiquyet);

var _dropdownKetquagiaiquyetdon = __webpack_require__(1561);

var _dropdownKetquagiaiquyetdon2 = _interopRequireDefault(_dropdownKetquagiaiquyetdon);

var _dropdownChondonvithongke = __webpack_require__(1534);

var _dropdownChondonvithongke2 = _interopRequireDefault(_dropdownChondonvithongke);

var _dropdownChonloaiquythongke = __webpack_require__(1551);

var _dropdownChonloaiquythongke2 = _interopRequireDefault(_dropdownChonloaiquythongke);

var _dropdownChonloaikythongke = __webpack_require__(1549);

var _dropdownChonloaikythongke2 = _interopRequireDefault(_dropdownChonloaikythongke);

var _DropDownChonPhoPhong = __webpack_require__(1506);

var _DropDownChonPhoPhong2 = _interopRequireDefault(_DropDownChonPhoPhong);

var _dropdownChonloainamthongke = __webpack_require__(1550);

var _dropdownChonloainamthongke2 = _interopRequireDefault(_dropdownChonloainamthongke);

var _dropdownChonloaithangthongke = __webpack_require__(1552);

var _dropdownChonloaithangthongke2 = _interopRequireDefault(_dropdownChonloaithangthongke);

var _dropdownChonketquagiaiquyet = __webpack_require__(1540);

var _dropdownChonketquagiaiquyet2 = _interopRequireDefault(_dropdownChonketquagiaiquyet);

var _dropdownChonkythanhtra = __webpack_require__(1543);

var _dropdownChonkythanhtra2 = _interopRequireDefault(_dropdownChonkythanhtra);

var _dropdownChonloaidoituongthanhtra = __webpack_require__(1547);

var _dropdownChonloaidoituongthanhtra2 = _interopRequireDefault(_dropdownChonloaidoituongthanhtra);

var _dropdownChonnganhlinhvuc = __webpack_require__(1553);

var _dropdownChonnganhlinhvuc2 = _interopRequireDefault(_dropdownChonnganhlinhvuc);

var _DropDownChonTienDoThanhTra = __webpack_require__(1507);

var _DropDownChonTienDoThanhTra2 = _interopRequireDefault(_DropDownChonTienDoThanhTra);

var _DropDownChonLinhVucThanhTra = __webpack_require__(1503);

var _DropDownChonLinhVucThanhTra2 = _interopRequireDefault(_DropDownChonLinhVucThanhTra);

var _DropDownChonLinhVucThanhTraMultiple = __webpack_require__(1504);

var _DropDownChonLinhVucThanhTraMultiple2 = _interopRequireDefault(_DropDownChonLinhVucThanhTraMultiple);

var _DropDownChonLoaiHinhThanhTra = __webpack_require__(1505);

var _DropDownChonLoaiHinhThanhTra2 = _interopRequireDefault(_DropDownChonLoaiHinhThanhTra);

var _DropDownChonHinhThucThanhTra = __webpack_require__(1502);

var _DropDownChonHinhThucThanhTra2 = _interopRequireDefault(_DropDownChonHinhThucThanhTra);

var _DropDownChonCanCuThanhTraLai = __webpack_require__(1499);

var _DropDownChonCanCuThanhTraLai2 = _interopRequireDefault(_DropDownChonCanCuThanhTraLai);

var _DropDownQuyTrinh = __webpack_require__(1510);

var _DropDownQuyTrinh2 = _interopRequireDefault(_DropDownQuyTrinh);

var _DropDownChonDonViChuTriThanhTra = __webpack_require__(1501);

var _DropDownChonDonViChuTriThanhTra2 = _interopRequireDefault(_DropDownChonDonViChuTriThanhTra);

var _DropDownMulipleUse = __webpack_require__(1508);

var _DropDownMulipleUse2 = _interopRequireDefault(_DropDownMulipleUse);

var _DropDownChonCoQuanDieuTra = __webpack_require__(1500);

var _DropDownChonCoQuanDieuTra2 = _interopRequireDefault(_DropDownChonCoQuanDieuTra);

var _DropDownNguoiKy = __webpack_require__(1509);

var _DropDownNguoiKy2 = _interopRequireDefault(_DropDownNguoiKy);

var _dropdownSort = __webpack_require__(1567);

var _dropdownSort2 = _interopRequireDefault(_dropdownSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownChonLoaiDonThu = _dropdownChonloaidonthu2.default;
exports.DropDownChonHuongXuLy = _dropdownChonhuongxuly2.default;
exports.DropDownChonNguonDon = _dropdownChonnguondon2.default;
exports.DropDownChonKetQuaXuLy = _dropdownChonketquaxuly2.default;
exports.DropDownKetQuaTiepDan = _dropdownKetquatiepdan2.default;
exports.DropDownTinhTrangXuLy = _dropdownTinhtrangxuly2.default;
exports.DropDownChonTinhThanh = _dropdownTinhthanh2.default;
exports.DropDownChonQuanHuyen = _dropdownQuanhuyen2.default;
exports.DropDownChonQuocTich = _dropdownQuoctich2.default;
exports.DropDownChonNoiCapCMND = _dropdownNoicapCMND2.default;
exports.DropDownChonPhuongXa = _dropdownPhuongxa2.default;
exports.RadioButtonChonTrangThaiXuLyDon = _radiobuttonChontrangthaixulydon2.default;
exports.RadioButtonChonTrangThaiKHTT = _radiobuttonChontrangthaikhtt2.default;
exports.DropDownChonDanToc = _dropdownChondantoc2.default;
exports.DropDownChonLoaiDoiTuong = _dropdownChonloaidoituong2.default;
exports.DropDownChonLinhVucDonThu = _dropdownChonlinhvucdonthu2.default;
exports.DropDownChonLinhVucDonThuChiTiet = _dropdownChonlinhvucdonthuchitiet2.default;
exports.DropDownChonNhomThamQuyenGiaiQuyet = _dropdownChonnhomthamquyengiaiquyet2.default;
exports.DropDownChonCapCoQuanDaGiaiQuyet = _dropdownChoncapcoquandagiaiquyet2.default;
exports.DropDownChonCoQuanDaGiaiQuyet = _dropdownChoncoquandagiaiquyet2.default;
exports.DropDownChonHinhThucDaGiaiQuyet = _dropdownChonhinhthucdagiaiquyet2.default;
exports.DropDownChonDonViChuTri = _dropdownChondonvichutri2.default;
exports.DropDownChonHuongXuLyLanhDao = _dropdownChonhuongxulylanhdao2.default;
exports.DropDownTinhTrangGiaiQuyet = _dropdownTinhtranggiaiquyet2.default;
exports.DropDownChonCanBoGiaiQuyet = _dropdownChoncanbogiaiquyet2.default;
exports.DropDownChonDonViTTXM = _dropdownChondonviTTXM2.default;
exports.DropDownChonQuyTrinhGiaiQuyetDon = _dropdownChonquytrinhgiaiquyetdon2.default;
exports.DropDownChonPhoPhong = _DropDownChonPhoPhong2.default;
exports.DropDownChonPhongBanThuocCoQuan = _dropdownChonphongbanthuoccoquan2.default;
exports.DropDownChonCanBoXuLy = _dropdownChoncanboxuly2.default;
exports.DropDownChonHuongXuLyTheoDon = _dropdownChonhuongxulytheodon2.default;
exports.DropDownChonCoQuanTiepNhan = _dropdownChoncoquantiepnhan2.default;
exports.DropDownChonKetLuanNoiDungKhieuNai = _dropdownChonketluannoidungkhieunai2.default;
exports.DropDownChonKetQuaThucHien = _dropdownChonketquathuchien2.default;
exports.DropDownChonTinhTrangTaiLieu = _dropdownChontinhtrangtailieu2.default;
exports.DropDownChonStateXuLyDon = _dropdownChonstatexulydon2.default;
exports.DropDownKetQuaGiaiQuyet = _dropdownKetquagiaiquyet2.default;
exports.DropDownKetQuaGiaiQuyetDon = _dropdownKetquagiaiquyetdon2.default;
exports.DropDownChonDonViThongKe = _dropdownChondonvithongke2.default;
exports.DropDownChonLoaiQuyThongKe = _dropdownChonloaiquythongke2.default;
exports.DropDownChonLoaiKyThongKe = _dropdownChonloaikythongke2.default;
exports.DropDownChonLoaiNamThongKe = _dropdownChonloainamthongke2.default;
exports.DropDownChonLoaiThangThongKe = _dropdownChonloaithangthongke2.default;
exports.DropDownChonKetQuaGiaiQuyet = _dropdownChonketquagiaiquyet2.default;
exports.DropDownChonKyThanhTra = _dropdownChonkythanhtra2.default;
exports.DropDownChonLoaiDoiTuongThanhTra = _dropdownChonloaidoituongthanhtra2.default;
exports.DropDownChonNganhLinhVuc = _dropdownChonnganhlinhvuc2.default;
exports.DropDownChonTienDoThanhTra = _DropDownChonTienDoThanhTra2.default;
exports.DropDownChonLinhVucThanhTra = _DropDownChonLinhVucThanhTra2.default;
exports.DropDownChonLinhVucThanhTraMultiple = _DropDownChonLinhVucThanhTraMultiple2.default;
exports.DropDownChonLoaiHinhThanhTra = _DropDownChonLoaiHinhThanhTra2.default;
exports.DropDownChonHinhThucThanhTra = _DropDownChonHinhThucThanhTra2.default;
exports.DropDownChonCanCuThanhTraLai = _DropDownChonCanCuThanhTraLai2.default;
exports.DropDownQuyTrinh = _DropDownQuyTrinh2.default;
exports.DropDownChonDonViChuTriThanhTra = _DropDownChonDonViChuTriThanhTra2.default;
exports.DropDownMulipleUse = _DropDownMulipleUse2.default;
exports.DropDownChonCoQuanDieuTra = _DropDownChonCoQuanDieuTra2.default;
exports.DropDownNguoiKy = _DropDownNguoiKy2.default;
exports.DropDownSort = _dropdownSort2.default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CheckPermission = function CheckPermission(name) {
  var check = false;

  if (localStorage.getItem('userInfo')) {
    var data = JSON.parse(localStorage.getItem('userInfo'));
    data.roles.map(function (item, i) {
      if (data.vaiTroMacDinhId == item.vaiTroId) {
        var quyens = item.quyen.split(',');
        if (quyens.indexOf(name) != -1) {
          check = true;
        }
      }
    });
  }
  return check;
};

var CheckViewPermission = function CheckViewPermission(data) {
  var check = false;

  if (localStorage.getItem('userInfo')) {
    var userData = JSON.parse(localStorage.getItem('userInfo'));
    if (data.donViXuLyGiaiQuyetInfo && data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userData.donViId || data.donViThamTraXacMinhInfo && data.donViThamTraXacMinhInfo.coQuanQuanLyId == userData.donViId || data.donViTheoDoiThucHienInfo && data.donViTheoDoiThucHienInfo.coQuanQuanLyId == userData.donViId || data.donViKiemTraDeXuatInfo && data.donViKiemTraDeXuatInfo.coQuanQuanLyId == userData.donViId || data.donViXuLyDonChuyenInfo && data.donViXuLyDonChuyenInfo.coQuanQuanLyId == userData.donViId || data.donViTiepDanInfo && data.donViTiepDanInfo.coQuanQuanLyId == userData.donViId || data.donCuId) {
      check = true;
    }
  }
  return check;
};

exports.CheckPermission = CheckPermission;
exports.CheckViewPermission = CheckViewPermission;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["d"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["c"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTIVE", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_LEFT", function() { return ALIGN_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_RIGHT", function() { return ALIGN_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DISABLED", function() { return DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILL", function() { return FILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIXED", function() { return FIXED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIXED_TOP", function() { return FIXED_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INLINE", function() { return INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERACTIVE", function() { return INTERACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LARGE", function() { return LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINIMAL", function() { return MINIMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MULTILINE", function() { return MULTILINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUND", function() { return ROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMALL", function() { return SMALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERTICAL", function() { return VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEVATION_0", function() { return ELEVATION_0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEVATION_1", function() { return ELEVATION_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEVATION_2", function() { return ELEVATION_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEVATION_3", function() { return ELEVATION_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEVATION_4", function() { return ELEVATION_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTENT_PRIMARY", function() { return INTENT_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTENT_SUCCESS", function() { return INTENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTENT_WARNING", function() { return INTENT_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTENT_DANGER", function() { return INTENT_DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_MUTED", function() { return TEXT_MUTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_OVERFLOW_ELLIPSIS", function() { return TEXT_OVERFLOW_ELLIPSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UI_TEXT", function() { return UI_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UI_TEXT_LARGE", function() { return UI_TEXT_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNNING_TEXT", function() { return RUNNING_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUNNING_TEXT_SMALL", function() { return RUNNING_TEXT_SMALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONOSPACE_TEXT", function() { return MONOSPACE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED", function() { return FOCUS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST", function() { return LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST_UNSTYLED", function() { return LIST_UNSTYLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALERT", function() { return ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALERT_BODY", function() { return ALERT_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALERT_CONTENTS", function() { return ALERT_CONTENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALERT_FOOTER", function() { return ALERT_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREADCRUMB", function() { return BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREADCRUMB_CURRENT", function() { return BREADCRUMB_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREADCRUMBS", function() { return BREADCRUMBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREADCRUMBS_COLLAPSED", function() { return BREADCRUMBS_COLLAPSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_GROUP", function() { return BUTTON_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_SPINNER", function() { return BUTTON_SPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_TEXT", function() { return BUTTON_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALLOUT", function() { return CALLOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALLOUT_ICON", function() { return CALLOUT_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALLOUT_TITLE", function() { return CALLOUT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CARD", function() { return CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLAPSE", function() { return COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLAPSE_BODY", function() { return COLLAPSE_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLAPSIBLE_LIST", function() { return COLLAPSIBLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_MENU", function() { return CONTEXT_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_MENU_POPOVER_TARGET", function() { return CONTEXT_MENU_POPOVER_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL", function() { return CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL_GROUP", function() { return CONTROL_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL_INDICATOR", function() { return CONTROL_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG", function() { return DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_CONTAINER", function() { return DIALOG_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_BODY", function() { return DIALOG_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_CLOSE_BUTTON", function() { return DIALOG_CLOSE_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_FOOTER", function() { return DIALOG_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_FOOTER_ACTIONS", function() { return DIALOG_FOOTER_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_HEADER", function() { return DIALOG_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_HEADER_TITLE", function() { return DIALOG_HEADER_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITABLE_TEXT", function() { return EDITABLE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITABLE_TEXT_CONTENT", function() { return EDITABLE_TEXT_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITABLE_TEXT_EDITING", function() { return EDITABLE_TEXT_EDITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITABLE_TEXT_INPUT", function() { return EDITABLE_TEXT_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITABLE_TEXT_PLACEHOLDER", function() { return EDITABLE_TEXT_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLEX_EXPANDER", function() { return FLEX_EXPANDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT", function() { return INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_GROUP", function() { return INPUT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_ACTION", function() { return INPUT_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKBOX", function() { return CHECKBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO", function() { return RADIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCH", function() { return SWITCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_UPLOAD", function() { return FILE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_UPLOAD_INPUT", function() { return FILE_UPLOAD_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_GHOST", function() { return INPUT_GHOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY", function() { return KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_COMBO", function() { return KEY_COMBO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODIFIER_KEY", function() { return MODIFIER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTKEY", function() { return HOTKEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTKEY_LABEL", function() { return HOTKEY_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTKEY_GROUP", function() { return HOTKEY_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTKEY_COLUMN", function() { return HOTKEY_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTKEY_DIALOG", function() { return HOTKEY_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LABEL", function() { return LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORM_GROUP", function() { return FORM_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORM_CONTENT", function() { return FORM_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORM_HELPER_TEXT", function() { return FORM_HELPER_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU", function() { return MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_ITEM", function() { return MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_ITEM_LABEL", function() { return MENU_ITEM_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_SUBMENU", function() { return MENU_SUBMENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_DIVIDER", function() { return MENU_DIVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_HEADER", function() { return MENU_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR", function() { return NAVBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_GROUP", function() { return NAVBAR_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_HEADING", function() { return NAVBAR_HEADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_DIVIDER", function() { return NAVBAR_DIVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE", function() { return NON_IDEAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE_ACTION", function() { return NON_IDEAL_STATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE_DESCRIPTION", function() { return NON_IDEAL_STATE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE_ICON", function() { return NON_IDEAL_STATE_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE_TITLE", function() { return NON_IDEAL_STATE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NON_IDEAL_STATE_VISUAL", function() { return NON_IDEAL_STATE_VISUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NUMERIC_INPUT", function() { return NUMERIC_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY", function() { return OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_BACKDROP", function() { return OVERLAY_BACKDROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_CONTENT", function() { return OVERLAY_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_INLINE", function() { return OVERLAY_INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_OPEN", function() { return OVERLAY_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_SCROLL_CONTAINER", function() { return OVERLAY_SCROLL_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER", function() { return POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_ARROW", function() { return POPOVER_ARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_BACKDROP", function() { return POPOVER_BACKDROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_CONTENT", function() { return POPOVER_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_CONTENT_SIZING", function() { return POPOVER_CONTENT_SIZING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_DISMISS", function() { return POPOVER_DISMISS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_DISMISS_OVERRIDE", function() { return POPOVER_DISMISS_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_OPEN", function() { return POPOVER_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_TARGET", function() { return POPOVER_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPOVER_WRAPPER", function() { return POPOVER_WRAPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSITION_CONTAINER", function() { return TRANSITION_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROGRESS_BAR", function() { return PROGRESS_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROGRESS_METER", function() { return PROGRESS_METER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROGRESS_NO_STRIPES", function() { return PROGRESS_NO_STRIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROGRESS_NO_ANIMATION", function() { return PROGRESS_NO_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PORTAL", function() { return PORTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SKELETON", function() { return SKELETON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLIDER", function() { return SLIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLIDER_HANDLE", function() { return SLIDER_HANDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLIDER_LABEL", function() { return SLIDER_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLIDER_PROGRESS", function() { return SLIDER_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RANGE_SLIDER", function() { return RANGE_SLIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER", function() { return SPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER_HEAD", function() { return SPINNER_HEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER_NO_SPIN", function() { return SPINNER_NO_SPIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER_TRACK", function() { return SPINNER_TRACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER_SVG_CONTAINER", function() { return SPINNER_SVG_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SVG_SPINNER", function() { return SVG_SPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_INDICATOR", function() { return TAB_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_INDICATOR_WRAPPER", function() { return TAB_INDICATOR_WRAPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_LIST", function() { return TAB_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_PANEL", function() { return TAB_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABS", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE", function() { return TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_CONDENSED", function() { return TABLE_CONDENSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_STRIPED", function() { return TABLE_STRIPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_BORDERED", function() { return TABLE_BORDERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG", function() { return TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG_REMOVABLE", function() { return TAG_REMOVABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG_REMOVE", function() { return TAG_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG_INPUT", function() { return TAG_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG_INPUT_ICON", function() { return TAG_INPUT_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG_INPUT_VALUES", function() { return TAG_INPUT_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOAST", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOAST_CONTAINER", function() { return TOAST_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOAST_MESSAGE", function() { return TOAST_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOOLTIP", function() { return TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOOLTIP_INDICATOR", function() { return TOOLTIP_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE", function() { return TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE", function() { return TREE_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_CARET", function() { return TREE_NODE_CARET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_CARET_CLOSED", function() { return TREE_NODE_CARET_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_CARET_NONE", function() { return TREE_NODE_CARET_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_CARET_OPEN", function() { return TREE_NODE_CARET_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_CONTENT", function() { return TREE_NODE_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_EXPANDED", function() { return TREE_NODE_EXPANDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_ICON", function() { return TREE_NODE_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_LABEL", function() { return TREE_NODE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_LIST", function() { return TREE_NODE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_SECONDARY_LABEL", function() { return TREE_NODE_SECONDARY_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_SELECTED", function() { return TREE_NODE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_ROOT", function() { return TREE_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON", function() { return ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_STANDARD", function() { return ICON_STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_LARGE", function() { return ICON_LARGE; });
/* harmony export (immutable) */ __webpack_exports__["iconClass"] = iconClass;
/* harmony export (immutable) */ __webpack_exports__["intentClass"] = intentClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intent__ = __webpack_require__(441);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

// modifiers
var ACTIVE = "pt-active";
var ALIGN_LEFT = "pt-align-left";
var ALIGN_RIGHT = "pt-align-right";
var DARK = "pt-dark";
var DISABLED = "pt-disabled";
var FILL = "pt-fill";
var FIXED = "pt-fixed";
var FIXED_TOP = "pt-fixed-top";
var INLINE = "pt-inline";
var INTERACTIVE = "pt-interactive";
var LARGE = "pt-large";
var LOADING = "pt-loading";
var MINIMAL = "pt-minimal";
var MULTILINE = "pt-multiline";
var ROUND = "pt-round";
var SMALL = "pt-small";
var VERTICAL = "pt-vertical";
var ELEVATION_0 = "pt-elevation-0";
var ELEVATION_1 = "pt-elevation-1";
var ELEVATION_2 = "pt-elevation-2";
var ELEVATION_3 = "pt-elevation-3";
var ELEVATION_4 = "pt-elevation-4";
var INTENT_PRIMARY = "pt-intent-primary";
var INTENT_SUCCESS = "pt-intent-success";
var INTENT_WARNING = "pt-intent-warning";
var INTENT_DANGER = "pt-intent-danger";
// text utilities
var TEXT_MUTED = "pt-text-muted";
var TEXT_OVERFLOW_ELLIPSIS = "pt-text-overflow-ellipsis";
var UI_TEXT = "pt-ui-text";
var UI_TEXT_LARGE = "pt-ui-text-large";
var RUNNING_TEXT = "pt-running-text";
var RUNNING_TEXT_SMALL = "pt-running-text-small";
var MONOSPACE_TEXT = "pt-monospace-text";
var FOCUS_DISABLED = "pt-focus-disabled";
// lists
var LIST = "pt-list";
var LIST_UNSTYLED = "pt-list-unstyled";
// components
var ALERT = "pt-alert";
var ALERT_BODY = "pt-alert-body";
var ALERT_CONTENTS = "pt-alert-contents";
var ALERT_FOOTER = "pt-alert-footer";
var BREADCRUMB = "pt-breadcrumb";
var BREADCRUMB_CURRENT = "pt-breadcrumb-current";
var BREADCRUMBS = "pt-breadcrumbs";
var BREADCRUMBS_COLLAPSED = "pt-breadcrumbs-collapsed";
var BUTTON = "pt-button";
var BUTTON_GROUP = "pt-button-group";
var BUTTON_SPINNER = "pt-button-spinner";
var BUTTON_TEXT = "pt-button-text";
var CALLOUT = "pt-callout";
var CALLOUT_ICON = "pt-callout-icon";
var CALLOUT_TITLE = "pt-callout-title";
var CARD = "pt-card";
var COLLAPSE = "pt-collapse";
var COLLAPSE_BODY = "pt-collapse-body";
var COLLAPSIBLE_LIST = "pt-collapse-list";
var CONTEXT_MENU = "pt-context-menu";
var CONTEXT_MENU_POPOVER_TARGET = "pt-context-menu-popover-target";
var CONTROL = "pt-control";
var CONTROL_GROUP = "pt-control-group";
var CONTROL_INDICATOR = "pt-control-indicator";
var DIALOG = "pt-dialog";
var DIALOG_CONTAINER = "pt-dialog-container";
var DIALOG_BODY = "pt-dialog-body";
var DIALOG_CLOSE_BUTTON = "pt-dialog-close-button";
var DIALOG_FOOTER = "pt-dialog-footer";
var DIALOG_FOOTER_ACTIONS = "pt-dialog-footer-actions";
var DIALOG_HEADER = "pt-dialog-header";
var DIALOG_HEADER_TITLE = "pt-dialog-header-title";
var EDITABLE_TEXT = "pt-editable-text";
var EDITABLE_TEXT_CONTENT = "pt-editable-content";
var EDITABLE_TEXT_EDITING = "pt-editable-editing";
var EDITABLE_TEXT_INPUT = "pt-editable-input";
var EDITABLE_TEXT_PLACEHOLDER = "pt-editable-placeholder";
var FLEX_EXPANDER = "pt-flex-expander";
var INPUT = "pt-input";
var INPUT_GROUP = "pt-input-group";
var INPUT_ACTION = "pt-input-action";
var CHECKBOX = "pt-checkbox";
var RADIO = "pt-radio";
var SWITCH = "pt-switch";
var FILE_UPLOAD = "pt-file-upload";
var FILE_UPLOAD_INPUT = "pt-file-upload-input";
var INPUT_GHOST = "pt-input-ghost";
var KEY = "pt-key";
var KEY_COMBO = "pt-key-combo";
var MODIFIER_KEY = "pt-modifier-key";
var HOTKEY = "pt-hotkey";
var HOTKEY_LABEL = "pt-hotkey-label";
var HOTKEY_GROUP = "pt-hotkey-group";
var HOTKEY_COLUMN = "pt-hotkey-column";
var HOTKEY_DIALOG = "pt-hotkey-dialog";
var LABEL = "pt-label";
var FORM_GROUP = "pt-form-group";
var FORM_CONTENT = "pt-form-content";
var FORM_HELPER_TEXT = "pt-form-helper-text";
var MENU = "pt-menu";
var MENU_ITEM = "pt-menu-item";
var MENU_ITEM_LABEL = "pt-menu-item-label";
var MENU_SUBMENU = "pt-submenu";
var MENU_DIVIDER = "pt-menu-divider";
var MENU_HEADER = "pt-menu-header";
var NAVBAR = "pt-navbar";
var NAVBAR_GROUP = "pt-navbar-group";
var NAVBAR_HEADING = "pt-navbar-heading";
var NAVBAR_DIVIDER = "pt-navbar-divider";
var NON_IDEAL_STATE = "pt-non-ideal-state";
var NON_IDEAL_STATE_ACTION = "pt-non-ideal-state-action";
var NON_IDEAL_STATE_DESCRIPTION = "pt-non-ideal-state-description";
var NON_IDEAL_STATE_ICON = "pt-non-ideal-state-icon";
var NON_IDEAL_STATE_TITLE = "pt-non-ideal-state-title";
var NON_IDEAL_STATE_VISUAL = "pt-non-ideal-state-visual";
var NUMERIC_INPUT = "pt-numeric-input";
var OVERLAY = "pt-overlay";
var OVERLAY_BACKDROP = "pt-overlay-backdrop";
var OVERLAY_CONTENT = "pt-overlay-content";
var OVERLAY_INLINE = "pt-overlay-inline";
var OVERLAY_OPEN = "pt-overlay-open";
var OVERLAY_SCROLL_CONTAINER = "pt-overlay-scroll-container";
var POPOVER = "pt-popover";
var POPOVER_ARROW = "pt-popover-arrow";
var POPOVER_BACKDROP = "pt-popover-backdrop";
var POPOVER_CONTENT = "pt-popover-content";
var POPOVER_CONTENT_SIZING = "pt-popover-content-sizing";
var POPOVER_DISMISS = "pt-popover-dismiss";
var POPOVER_DISMISS_OVERRIDE = "pt-popover-dismiss-override";
var POPOVER_OPEN = "pt-popover-open";
var POPOVER_TARGET = "pt-popover-target";
var POPOVER_WRAPPER = "pt-popover-wrapper";
var TRANSITION_CONTAINER = "pt-transition-container";
var PROGRESS_BAR = "pt-progress-bar";
var PROGRESS_METER = "pt-progress-meter";
var PROGRESS_NO_STRIPES = "pt-no-stripes";
var PROGRESS_NO_ANIMATION = "pt-no-animation";
var PORTAL = "pt-portal";
var SELECT = "pt-select";
var SKELETON = "pt-skeleton";
var SLIDER = "pt-slider";
var SLIDER_HANDLE = "pt-slider-handle";
var SLIDER_LABEL = "pt-slider-label";
var SLIDER_PROGRESS = "pt-slider-progress";
var RANGE_SLIDER = "pt-range-slider";
var SPINNER = "pt-spinner";
var SPINNER_HEAD = "pt-spinner-head";
var SPINNER_NO_SPIN = "pt-no-spin";
var SPINNER_TRACK = "pt-spinner-track";
var SPINNER_SVG_CONTAINER = "pt-spinner-svg-container";
var SVG_SPINNER = "pt-svg-spinner";
var TAB = "pt-tab";
var TAB_INDICATOR = "pt-tab-indicator";
var TAB_INDICATOR_WRAPPER = "pt-tab-indicator-wrapper";
var TAB_LIST = "pt-tab-list";
var TAB_PANEL = "pt-tab-panel";
var TABS = "pt-tabs";
var TABLE = "pt-table";
var TABLE_CONDENSED = "pt-condensed";
var TABLE_STRIPED = "pt-striped";
var TABLE_BORDERED = "pt-bordered";
var TAG = "pt-tag";
var TAG_REMOVABLE = "pt-tag-removable";
var TAG_REMOVE = "pt-tag-remove";
var TAG_INPUT = "pt-tag-input";
var TAG_INPUT_ICON = "pt-tag-input-icon";
var TAG_INPUT_VALUES = "pt-tag-input-values";
var TOAST = "pt-toast";
var TOAST_CONTAINER = "pt-toast-container";
var TOAST_MESSAGE = "pt-toast-message";
var TOOLTIP = "pt-tooltip";
var TOOLTIP_INDICATOR = "pt-tooltip-indicator";
var TREE = "pt-tree";
var TREE_NODE = "pt-tree-node";
var TREE_NODE_CARET = "pt-tree-node-caret";
var TREE_NODE_CARET_CLOSED = "pt-tree-node-caret-closed";
var TREE_NODE_CARET_NONE = "pt-tree-node-caret-none";
var TREE_NODE_CARET_OPEN = "pt-tree-node-caret-open";
var TREE_NODE_CONTENT = "pt-tree-node-content";
var TREE_NODE_EXPANDED = "pt-tree-node-expanded";
var TREE_NODE_ICON = "pt-tree-node-icon";
var TREE_NODE_LABEL = "pt-tree-node-label";
var TREE_NODE_LIST = "pt-tree-node-list";
var TREE_NODE_SECONDARY_LABEL = "pt-tree-node-secondary-label";
var TREE_NODE_SELECTED = "pt-tree-node-selected";
var TREE_ROOT = "pt-tree-root";
var ICON = "pt-icon";
var ICON_STANDARD = "pt-icon-standard";
var ICON_LARGE = "pt-icon-large";
/** Return CSS class for icon, whether or not 'pt-icon-' prefix is included */
function iconClass(iconName) {
    if (iconName == null) {
        return undefined;
    }
    return iconName.indexOf("pt-icon-") === 0 ? iconName : "pt-icon-" + iconName;
}
function intentClass(intent) {
    if (intent === void 0) { intent = __WEBPACK_IMPORTED_MODULE_0__intent__["a" /* Intent */].NONE; }
    if (intent === __WEBPACK_IMPORTED_MODULE_0__intent__["a" /* Intent */].NONE || __WEBPACK_IMPORTED_MODULE_0__intent__["a" /* Intent */][intent] == null) {
        return undefined;
    }
    return "pt-intent-" + __WEBPACK_IMPORTED_MODULE_0__intent__["a" /* Intent */][intent].toLowerCase();
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2343)();
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PRESENTATION_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EVENT_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LEGEND_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findAllByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findChildByType; });
/* unused harmony export withoutType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPresentationAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return filterEventAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return filterEventsOfChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validateWidthHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isSsr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return filterSvgElements; });
/* unused harmony export isSingleChildEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isChildrenEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PureRender__ = __webpack_require__(28);











var PRESENTATION_ATTRIBUTES = {
  alignmentBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  angle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  baselineShift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipPath: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolationFilters: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorProfile: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  cursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ltr', 'rtl', 'inherit']),
  display: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  dominantBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  enableBackground: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fillOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fillRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['nonzero', 'evenodd', 'inherit']),
  filter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  font: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontFamily: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontSizeAdjust: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontStretch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
  fontStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'italic', 'oblique', 'inherit']),
  fontVariant: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'small-caps', 'inherit']),
  fontWeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
  glyphOrientationHorizontal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  glyphOrientationVertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  imageRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
  kerning: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  letterSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  lightingColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerMid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mask: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  opacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  overflow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
  pointerEvents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
  shapeRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
  stopColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  stopOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  stroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeDasharray: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  strokeDashoffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['butt', 'round', 'square', 'inherit']),
  strokeLinejoin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['miter', 'round', 'bevel', 'inherit']),
  strokeMiterlimit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  textAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  textDecoration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
  textRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
  unicodeBidi: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
  visibility: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
  wordSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  writingMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
  transform: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,

  width: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  x: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};

var EVENT_ATTRIBUTES = {
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var LEGEND_TYPES = ['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];

/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */
var getDisplayName = function getDisplayName(Comp) {
  if (!Comp) {
    return '';
  }
  if (typeof Comp === 'string') {
    return Comp;
  }
  return Comp.displayName || Comp.name || 'Component';
};

/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */
var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    var childType = child && child.type && (child.type.displayName || child.type.name);
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });

  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */
var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);

  return result && result[0];
};

/*
 * Create a new array of children excluding the ones matched the type
 */
var withoutType = function withoutType(children, type) {
  var newChildren = [];
  var types = void 0;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
      return;
    }
    newChildren.push(child);
  });

  return newChildren;
};

/**
 * get all the presentation attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */
var getPresentationAttributes = function getPresentationAttributes(el) {
  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }
  return out;
};

/**
 * get all the event attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */
var filterEventAttributes = function filterEventAttributes(el) {
  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }
  return out;
};

var getEventHandler = function getEventHandler(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);

    return null;
  };
};

var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(props[i])) {
      if (!out) out = {};
      out[i] = getEventHandler(props[i], data, index);
    }
  }
  return out;
};

/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */
var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;


  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["j" /* isNumber */])(width) || width <= 0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["j" /* isNumber */])(height) || height <= 0) {
    return false;
  }

  return true;
};

var isSsr = function isSsr() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};

var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */
var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (entry) {
    if (entry && entry.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
      svgElements.push(entry);
    }
  });

  return svgElements;
};

var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return true;
  } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__PureRender__["b" /* shallowEqual */])(nextChild.props, prevChild.props);
  }

  return false;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren) !== __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(prevChildren)) {
    return false;
  }

  var count = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren);

  if (count === 0) {
    return true;
  }
  if (count === 1) {
    return isSingleChildEqual(nextChildren, prevChildren);
  }

  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];

    if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Promise, global, setImmediate) {/*** IMPORTS FROM imports-loader ***/
(function() {

/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

Async.prototype.invokeLater = AsyncInvokeLater;
Async.prototype.invoke = AsyncInvoke;
Async.prototype.settlePromises = AsyncSettlePromises;


function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context,
    enableAsyncHooks, disableAsyncHooks) {
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

var deferUnhandledRejectionCheck;
(function() {
    var promises = [];

    function unhandledRejectionCheck() {
        for (var i = 0; i < promises.length; ++i) {
            promises[i]._notifyUnhandledRejection();
        }
        unhandledRejectionClear();
    }

    function unhandledRejectionClear() {
        promises.length = 0;
    }

    deferUnhandledRejectionCheck = function(promise) {
        promises.push(promise);
        setTimeout(unhandledRejectionCheck, 1);
    };

    es5.defineProperty(Promise, "_unhandledRejectionCheck", {
        value: unhandledRejectionCheck
    });
    es5.defineProperty(Promise, "_unhandledRejectionClear", {
        value: unhandledRejectionClear
    });
})();

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    deferUnhandledRejectionCheck(this);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var context = Promise._getContext();
    possiblyUnhandledRejection = util.contextBind(context, fn);
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var context = Promise._getContext();
    unhandledRejectionHandled = util.contextBind(context, fn);
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};


var legacyHandlers = {
    unhandledrejection: {
        before: function() {
            var ret = util.global.onunhandledrejection;
            util.global.onunhandledrejection = null;
            return ret;
        },
        after: function(fn) {
            util.global.onunhandledrejection = fn;
        }
    },
    rejectionhandled: {
        before: function() {
            var ret = util.global.onrejectionhandled;
            util.global.onrejectionhandled = null;
            return ret;
        },
        after: function(fn) {
            util.global.onrejectionhandled = fn;
        }
    }
};

var fireDomEvent = (function() {
    var dispatch = function(legacy, e) {
        if (legacy) {
            var fn;
            try {
                fn = legacy.before();
                return !util.global.dispatchEvent(e);
            } finally {
                legacy.after(fn);
            }
        } else {
            return !util.global.dispatchEvent(e);
        }
    };
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                var domEvent = new CustomEvent(name, eventData);
                es5.defineProperty(
                    domEvent, "promise", {value: event.promise});
                es5.defineProperty(
                    domEvent, "reason", {value: event.reason});

                return dispatch(legacyHandlers[name], domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = new Event(name, {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return dispatch(legacyHandlers[name], domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name, false, true,
                    event);
                return dispatch(legacyHandlers[name], domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
        var prev = config.asyncHooks;
        var cur = !!opts.asyncHooks;
        if (prev !== cur) {
            config.asyncHooks = cur;
            if (cur) {
                enableAsyncHooks();
            } else {
                disableAsyncHooks();
            }
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = (firstLineError.stack || "").split("\n");
    var lastStackLines = (lastLineError.stack || "").split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false,
    asyncHooks: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    asyncHooks: function() {
        return config.asyncHooks;
    },
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var context = Promise._getContext();
                        holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var context = Promise._getContext();
    this._callback = util.contextBind(context, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
    if (util.isArray(promises)) {
        for (var i = 0; i < promises.length; ++i) {
            var maybePromise = promises[i];
            if (maybePromise instanceof Promise) {
                maybePromise.suppressUnhandledRejections();
            }
        }
    }
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");
util.setReflectHandler(reflectHandler);

var getDomain = function() {
    var domain = process.domain;
    if (domain === undefined) {
        return null;
    }
    return domain;
};
var getContextDefault = function() {
    return null;
};
var getContextDomain = function() {
    return {
        domain: getDomain(),
        async: null
    };
};
var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ?
    _dereq_("async_hooks").AsyncResource : null;
var getContextAsyncHooks = function() {
    return {
        domain: getDomain(),
        async: new AsyncResource("Bluebird::Promise")
    };
};
var getContext = util.isNode ? getContextDomain : getContextDefault;
util.notEnumerableProp(Promise, "_getContext", getContext);
var enableAsyncHooks = function() {
    getContext = getContextAsyncHooks;
    util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
};
var disableAsyncHooks = function() {
    getContext = getContextDomain;
    util.notEnumerableProp(Promise, "_getContext", getContextDomain);
};

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;

var debug = _dereq_("./debuggability")(Promise, Context,
    enableAsyncHooks, disableAsyncHooks);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];

        if (typeof fn !== "function") {
            throw new TypeError("The last argument to .catch() " +
                "must be a function, got " + util.toString(fn));
        }
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var context = getContext();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: util.contextBind(context, handler),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise,
                receiver, context);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    var bitField = this._bitField;
    this._bitField = bitField |
        (((bitField & 536870912) >> 2) ^
        134217728);
};

Promise.prototype._setNoAsyncGuarantee = function() {
    this._bitField = (this._bitField | 536870912) &
        (~134217728);
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    context
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 = util.contextBind(context, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                util.contextBind(context, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);


    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(maybePromise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
        get: function () {
            return "Object";
        }
    });
}

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
Promise.Promise = Promise;
Promise.version = "3.7.2";
_dereq_('./call_get.js')(Promise);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,"async_hooks":undefined}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
        values.suppressUnhandledRejections();
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var context = Promise._getContext();
    this._fn = util.contextBind(context, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined &&
        this._eachValues !== null &&
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    for (var j = i; j < length; ++j) {
        var maybePromise = values[j];
        if (maybePromise instanceof Promise) {
            maybePromise.suppressUnhandledRejections();
        }
    }

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };

            value = value._then(gotAccum, undefined, undefined, ctx, undefined);

            if ((i & 127) === 0) {
                value._setNoAsyncGuarantee();
            }
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova)) &&
          ("classList" in document.documentElement)) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.allSettled = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if (classString(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

var reflectHandler;
function contextBind(ctx, cb) {
    if (ctx === null ||
        typeof cb !== "function" ||
        cb === reflectHandler) {
        return cb;
    }

    if (ctx.domain !== null) {
        cb = ctx.domain.bind(cb);
    }

    var async = ctx.async;
    if (async !== null) {
        var old = cb;
        cb = function() {
            var args = (new Array(2)).concat([].slice.call(arguments));;
            args[0] = old;
            args[1] = this;
            return async.runInAsyncScope.apply(async, args);
        };
    }
    return cb;
}

var ret = {
    setReflectHandler: function(fn) {
        reflectHandler = fn;
    },
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    contextBind: contextBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version;
    if (process.versions && process.versions.node) {
        version = process.versions.node.split(".").map(Number);
    } else if (process.version) {
        version = process.version.split(".").map(Number);
    }
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();
ret.nodeSupportsAsyncResource = ret.isNode && (function() {
    var supportsAsync = false;
    try {
        var res = _dereq_("async_hooks").AsyncResource;
        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
    } catch (e) {
        supportsAsync = false;
    }
    return supportsAsync;
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13,"async_hooks":undefined}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }

/*** EXPORTS FROM exports-loader ***/
module.exports = global.Promise;
}.call(global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120), __webpack_require__(26), __webpack_require__(56), __webpack_require__(2373).setImmediate))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["a"] = pureRenderDecorator;
function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }
  return true;
}

function shouldComponentUpdate(props, state) {
  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
}

function pureRenderDecorator(component) {
  // eslint-disable-next-line no-param-reassign
  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Félix Girault <felix.girault@gmail.com>
 * @license MIT
 */


var warning = __webpack_require__(37);
var shallowEqual = __webpack_require__(272);



/**
 * Tells if a component should update given it's next props
 * and state.
 *
 * @param object nextProps Next props.
 * @param object nextState Next state.
 */
function shouldComponentUpdate(nextProps, nextState) {
  return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
}

/**
 * Returns a text description of the component that can be
 * used to identify it in error messages.
 *
 * @see https://github.com/facebook/react/blob/v15.4.0-rc.3/src/renderers/shared/stack/reconciler/ReactCompositeComponent.js#L1143
 * @param {function} component The component.
 * @return {string} The name of the component.
 */
function getComponentName(component) {
  var constructor = component.prototype && component.prototype.constructor;

  return (
    component.displayName
    || (constructor && constructor.displayName)
    || component.name
    || (constructor && constructor.name)
    || 'a component'
  );
}

/**
 * Makes the given component "pure".
 *
 * @param object component Component.
 */
function pureRenderDecorator(component) {
  if (component.prototype.shouldComponentUpdate !== undefined) {
    // We're not using the condition mecanism of warning()
    // here to avoid useless calls to getComponentName().
    warning(
      false,
      'Cannot decorate `%s` with @pureRenderDecorator, '
      + 'because it already implements `shouldComponentUpdate().',
      getComponentName(component)
    )
  }

  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
  return component;
}



module.exports = pureRenderDecorator;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isNumOrStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uniqueId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPercentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseSpecifiedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return validateCoordinateInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBandSizeOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAnyElementOfObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasDuplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return combineEventHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parseScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkDomainOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getValueByDataKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return findPositionOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return truncateByDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNaN__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3_scale__ = __webpack_require__(259);











var isPercent = function isPercent(value) {
  return __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(value) && value.indexOf('%') === value.length - 1;
};

var isNumber = function isNumber(value) {
  return __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default()(value) && !__WEBPACK_IMPORTED_MODULE_5_lodash_isNaN___default()(value);
};

var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(value);
};

var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;

  return '' + (prefix || '') + id;
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */
var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber(percent) && !__WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(percent)) {
    return defaultValue;
  }

  var value = void 0;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (isNaN(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};

var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([\d]+)$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([\d]+)$/;

var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];

  if (isNumber(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];

    domain[0] = dataDomain[0] - value;
  } else {
    domain[0] = dataDomain[0];
  }

  if (isNumber(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else {
    domain[1] = dataDomain[1];
  }

  return domain;
};

var validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
  if (!scale) {
    return false;
  }

  var range = scale.range();
  var first = range[0];
  var last = range[range.length - 1];
  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;

  return isValidate;
};

/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @return {Number} Size
 */
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    return axis.scale.bandwidth();
  }

  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default()(ticks, function (o) {
      return o.coordinate;
    });
    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];

      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return 0;
};

var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};

var hasDuplicate = function hasDuplicate(ary) {
  if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */
var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler = void 0;

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(childHandler)) {
    customizedHandler = childHandler;
  } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {String}   options.scale The specified scale type
 * @param  {String}   options.type  The type of axis
 * @param  {String}   chartType     The displayName of chart
 * @return {Function}               The scale funcion
 */
var parseScale = function parseScale(_ref, chartType) {
  var scale = _ref.scale,
      type = _ref.type;

  if (scale === 'auto') {
    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
      return __WEBPACK_IMPORTED_MODULE_8_d3_scale__["scalePoint"]();
    } else if (type === 'category') {
      return __WEBPACK_IMPORTED_MODULE_8_d3_scale__["scaleBand"]();
    }

    return __WEBPACK_IMPORTED_MODULE_8_d3_scale__["scaleLinear"]();
  } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(scale)) {
    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);

    return (__WEBPACK_IMPORTED_MODULE_8_d3_scale__[name] || __WEBPACK_IMPORTED_MODULE_8_d3_scale__["scalePoint"])();
  }

  return __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(scale) ? scale : __WEBPACK_IMPORTED_MODULE_8_d3_scale__["scalePoint"]();
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();

  if (!domain || domain.length <= 2) {
    return;
  }

  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);

  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};

var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(obj) || __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(dataKey)) {
    return defaultValue;
  }

  if (isNumOrStr(dataKey)) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(obj, dataKey, defaultValue);
  }

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
};

var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }

  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }

  return null;
};

var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
    return value;
  }

  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);

  var result = [value[0], value[1]];
  if (!isNumber(value[0]) || value[0] < min) {
    result[0] = min;
  }

  if (!isNumber(value[1]) || value[1] > max) {
    result[1] = max;
  }

  if (result[0] > max) {
    result[0] = max;
  }

  if (result[1] < min) {
    result[1] = min;
  }

  return result;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LichSuTrangThaiXuLyGiaiQuyetDon = exports.BlockBaoCaoKQTTXM = exports.BlockBanHanhQuyetDinhView = exports.BlockGiaiQuyetDonInfo = exports.KetQuaTheoDoiThucHien = exports.TruongPhongNhanYeuCauTheoDoiThucHien = exports.CanBoNhanYeuCauTheoDoiThucHien = exports.TruongPhongKiemTraDeXuat = exports.TruongPhongNhanBaoCaoTTXMDonKhieuNai = exports.KetQuaTruongPhongNhanBaoCaoTTXM = exports.KetQuaCanBoGiaiQuyetYeuCauLapDuThao = exports.KetQuaLapDuThaoDonKhieuNaiCanBo = exports.CanBoGiaiQuyetYeuCauLapDuThao = exports.TruongPhongNhanYeuCauDoiThoai = exports.LapDuThaoDonKhieuNaiCanBo = exports.TruongPhongNhanBaoCaoTTXM = exports.KetQuaCanBoKiemTraDeXuat = exports.CanBoKiemTraDeXuat = exports.ConfirmDialog = exports.ThongTinNguoiUyQuyen = exports.InPhieuGiaoTTXMToCao = exports.KetQuaLapDuThaoCanBo = exports.KetQuaNhapThongTinToTTXM = exports.KetQuaGiaiQuyetDonCanBoNhapLieu = exports.KetQuaHoanThanhGiaiQuyetDonCanBo = exports.ThongTinCoQuanDaGiaiQuyet = exports.KetQuaGiaiQuyetDonTruongPhong = exports.LapDuThaoCanBo = exports.NhapThongTinToTTXX = exports.NhiemVuTTXM = exports.GiaiQuyetDonCanBoNhapLieu = exports.GiaiQuyetDonCanBo = exports.GiaiQuyetDonTruongPhong = exports.KetQuaXuLyDon = exports.QuaTrinhXuLy = exports.ThongTinNguoiDungDon = exports.ThongTinDon = exports.ListSearch = exports.DanhSachDoanDongNguoi = exports.DanhSachBangChung = exports.ChiTietDon = undefined;

var _ListSearch = __webpack_require__(1136);

var _ListSearch2 = _interopRequireDefault(_ListSearch);

var _ThongTinDon = __webpack_require__(478);

var _ThongTinDon2 = _interopRequireDefault(_ThongTinDon);

var _ThongTinNguoiDungDon = __webpack_require__(479);

var _ThongTinNguoiDungDon2 = _interopRequireDefault(_ThongTinNguoiDungDon);

var _QuaTrinhXuLy = __webpack_require__(1138);

var _QuaTrinhXuLy2 = _interopRequireDefault(_QuaTrinhXuLy);

var _KetQuaXuLyDon = __webpack_require__(1132);

var _KetQuaXuLyDon2 = _interopRequireDefault(_KetQuaXuLyDon);

var _ChiTietDon = __webpack_require__(1116);

var _ChiTietDon2 = _interopRequireDefault(_ChiTietDon);

var _DanhSachDoanDongNguoi = __webpack_require__(476);

var _DanhSachDoanDongNguoi2 = _interopRequireDefault(_DanhSachDoanDongNguoi);

var _DanhSachBangChung = __webpack_require__(475);

var _DanhSachBangChung2 = _interopRequireDefault(_DanhSachBangChung);

var _GiaiQuyetDonTruongPhong = __webpack_require__(1120);

var _GiaiQuyetDonTruongPhong2 = _interopRequireDefault(_GiaiQuyetDonTruongPhong);

var _GiaiQuyetDonCanBo = __webpack_require__(1118);

var _GiaiQuyetDonCanBo2 = _interopRequireDefault(_GiaiQuyetDonCanBo);

var _GiaiQuyetDonCanBoNhapLieu = __webpack_require__(1119);

var _GiaiQuyetDonCanBoNhapLieu2 = _interopRequireDefault(_GiaiQuyetDonCanBoNhapLieu);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _NhapThongTinToTTXX = __webpack_require__(1137);

var _NhapThongTinToTTXX2 = _interopRequireDefault(_NhapThongTinToTTXX);

var _LapDuThaoCanBo = __webpack_require__(1133);

var _LapDuThaoCanBo2 = _interopRequireDefault(_LapDuThaoCanBo);

var _KetQuaGiaiQuyetDonTruongPhong = __webpack_require__(1125);

var _KetQuaGiaiQuyetDonTruongPhong2 = _interopRequireDefault(_KetQuaGiaiQuyetDonTruongPhong);

var _KetQuaHoanThanhGiaiQuyetDonCanBo = __webpack_require__(1126);

var _KetQuaHoanThanhGiaiQuyetDonCanBo2 = _interopRequireDefault(_KetQuaHoanThanhGiaiQuyetDonCanBo);

var _KetQuaGiaiQuyetDonCanBoNhapLieu = __webpack_require__(1124);

var _KetQuaGiaiQuyetDonCanBoNhapLieu2 = _interopRequireDefault(_KetQuaGiaiQuyetDonCanBoNhapLieu);

var _KetQuaNhapThongTinToTTXM = __webpack_require__(1129);

var _KetQuaNhapThongTinToTTXM2 = _interopRequireDefault(_KetQuaNhapThongTinToTTXM);

var _KetQuaLapDuThaoCanBo = __webpack_require__(1127);

var _KetQuaLapDuThaoCanBo2 = _interopRequireDefault(_KetQuaLapDuThaoCanBo);

var _InPhieuGiaoTTXMToCao = __webpack_require__(1121);

var _InPhieuGiaoTTXMToCao2 = _interopRequireDefault(_InPhieuGiaoTTXMToCao);

var _ThongTinNguoiUyQuyen = __webpack_require__(480);

var _ThongTinNguoiUyQuyen2 = _interopRequireDefault(_ThongTinNguoiUyQuyen);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _CanBoKiemTraDeXuat = __webpack_require__(1114);

var _CanBoKiemTraDeXuat2 = _interopRequireDefault(_CanBoKiemTraDeXuat);

var _KetQuaCanBoKiemTraDeXuat = __webpack_require__(1123);

var _KetQuaCanBoKiemTraDeXuat2 = _interopRequireDefault(_KetQuaCanBoKiemTraDeXuat);

var _TruongPhongNhanBaoCaoTTXM = __webpack_require__(1140);

var _TruongPhongNhanBaoCaoTTXM2 = _interopRequireDefault(_TruongPhongNhanBaoCaoTTXM);

var _LapDuThaoDonKhieuNaiCanBo = __webpack_require__(1134);

var _LapDuThaoDonKhieuNaiCanBo2 = _interopRequireDefault(_LapDuThaoDonKhieuNaiCanBo);

var _TruongPhongNhanYeuCauDoiThoai = __webpack_require__(1142);

var _TruongPhongNhanYeuCauDoiThoai2 = _interopRequireDefault(_TruongPhongNhanYeuCauDoiThoai);

var _CanBoGiaiQuyetYeuCauLapDuThao = __webpack_require__(1113);

var _CanBoGiaiQuyetYeuCauLapDuThao2 = _interopRequireDefault(_CanBoGiaiQuyetYeuCauLapDuThao);

var _KetQuaLapDuThaoDonKhieuNaiCanBo = __webpack_require__(1128);

var _KetQuaLapDuThaoDonKhieuNaiCanBo2 = _interopRequireDefault(_KetQuaLapDuThaoDonKhieuNaiCanBo);

var _KetQuaCanBoGiaiQuyetYeuCauLapDuThao = __webpack_require__(1122);

var _KetQuaCanBoGiaiQuyetYeuCauLapDuThao2 = _interopRequireDefault(_KetQuaCanBoGiaiQuyetYeuCauLapDuThao);

var _KetQuaTruongPhongNhanBaoCaoTTXM = __webpack_require__(1131);

var _KetQuaTruongPhongNhanBaoCaoTTXM2 = _interopRequireDefault(_KetQuaTruongPhongNhanBaoCaoTTXM);

var _TruongPhongNhanBaoCaoTTXMDonKhieuNai = __webpack_require__(1141);

var _TruongPhongNhanBaoCaoTTXMDonKhieuNai2 = _interopRequireDefault(_TruongPhongNhanBaoCaoTTXMDonKhieuNai);

var _TruongPhongKiemTraDeXuat = __webpack_require__(1139);

var _TruongPhongKiemTraDeXuat2 = _interopRequireDefault(_TruongPhongKiemTraDeXuat);

var _ThongTinCoQuanDaGiaiQuyet = __webpack_require__(477);

var _ThongTinCoQuanDaGiaiQuyet2 = _interopRequireDefault(_ThongTinCoQuanDaGiaiQuyet);

var _CanBoNhanYeuCauTheoDoiThucHien = __webpack_require__(1115);

var _CanBoNhanYeuCauTheoDoiThucHien2 = _interopRequireDefault(_CanBoNhanYeuCauTheoDoiThucHien);

var _TruongPhongNhanYeuCauTheoDoiThucHien = __webpack_require__(1143);

var _TruongPhongNhanYeuCauTheoDoiThucHien2 = _interopRequireDefault(_TruongPhongNhanYeuCauTheoDoiThucHien);

var _KetQuaTheoDoiThucHien = __webpack_require__(1130);

var _KetQuaTheoDoiThucHien2 = _interopRequireDefault(_KetQuaTheoDoiThucHien);

var _BlockBaoCaoKQTTXM = __webpack_require__(1111);

var _BlockBaoCaoKQTTXM2 = _interopRequireDefault(_BlockBaoCaoKQTTXM);

var _BlockGiaiQuyetDonInfo = __webpack_require__(1112);

var _BlockGiaiQuyetDonInfo2 = _interopRequireDefault(_BlockGiaiQuyetDonInfo);

var _BlockBanHanhQuyetDinhView = __webpack_require__(1110);

var _BlockBanHanhQuyetDinhView2 = _interopRequireDefault(_BlockBanHanhQuyetDinhView);

var _LichSuTrangThaiXuLyGiaiQuyetDon = __webpack_require__(1135);

var _LichSuTrangThaiXuLyGiaiQuyetDon2 = _interopRequireDefault(_LichSuTrangThaiXuLyGiaiQuyetDon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ChiTietDon = _ChiTietDon2.default;
exports.DanhSachBangChung = _DanhSachBangChung2.default;
exports.DanhSachDoanDongNguoi = _DanhSachDoanDongNguoi2.default;
exports.ListSearch = _ListSearch2.default;
exports.ThongTinDon = _ThongTinDon2.default;
exports.ThongTinNguoiDungDon = _ThongTinNguoiDungDon2.default;
exports.QuaTrinhXuLy = _QuaTrinhXuLy2.default;
exports.KetQuaXuLyDon = _KetQuaXuLyDon2.default;
exports.GiaiQuyetDonTruongPhong = _GiaiQuyetDonTruongPhong2.default;
exports.GiaiQuyetDonCanBo = _GiaiQuyetDonCanBo2.default;
exports.GiaiQuyetDonCanBoNhapLieu = _GiaiQuyetDonCanBoNhapLieu2.default;
exports.NhiemVuTTXM = _NhiemVuTTXM2.default;
exports.NhapThongTinToTTXX = _NhapThongTinToTTXX2.default;
exports.LapDuThaoCanBo = _LapDuThaoCanBo2.default;
exports.KetQuaGiaiQuyetDonTruongPhong = _KetQuaGiaiQuyetDonTruongPhong2.default;
exports.ThongTinCoQuanDaGiaiQuyet = _ThongTinCoQuanDaGiaiQuyet2.default;
exports.KetQuaHoanThanhGiaiQuyetDonCanBo = _KetQuaHoanThanhGiaiQuyetDonCanBo2.default;
exports.KetQuaGiaiQuyetDonCanBoNhapLieu = _KetQuaGiaiQuyetDonCanBoNhapLieu2.default;
exports.KetQuaNhapThongTinToTTXM = _KetQuaNhapThongTinToTTXM2.default;
exports.KetQuaLapDuThaoCanBo = _KetQuaLapDuThaoCanBo2.default;
exports.InPhieuGiaoTTXMToCao = _InPhieuGiaoTTXMToCao2.default;
exports.ThongTinNguoiUyQuyen = _ThongTinNguoiUyQuyen2.default;
exports.ConfirmDialog = _ConfirmDialog2.default;
exports.CanBoKiemTraDeXuat = _CanBoKiemTraDeXuat2.default;
exports.KetQuaCanBoKiemTraDeXuat = _KetQuaCanBoKiemTraDeXuat2.default;
exports.TruongPhongNhanBaoCaoTTXM = _TruongPhongNhanBaoCaoTTXM2.default;
exports.LapDuThaoDonKhieuNaiCanBo = _LapDuThaoDonKhieuNaiCanBo2.default;
exports.TruongPhongNhanYeuCauDoiThoai = _TruongPhongNhanYeuCauDoiThoai2.default;
exports.CanBoGiaiQuyetYeuCauLapDuThao = _CanBoGiaiQuyetYeuCauLapDuThao2.default;
exports.KetQuaLapDuThaoDonKhieuNaiCanBo = _KetQuaLapDuThaoDonKhieuNaiCanBo2.default;
exports.KetQuaCanBoGiaiQuyetYeuCauLapDuThao = _KetQuaCanBoGiaiQuyetYeuCauLapDuThao2.default;
exports.KetQuaTruongPhongNhanBaoCaoTTXM = _KetQuaTruongPhongNhanBaoCaoTTXM2.default;
exports.TruongPhongNhanBaoCaoTTXMDonKhieuNai = _TruongPhongNhanBaoCaoTTXMDonKhieuNai2.default;
exports.TruongPhongKiemTraDeXuat = _TruongPhongKiemTraDeXuat2.default;
exports.CanBoNhanYeuCauTheoDoiThucHien = _CanBoNhanYeuCauTheoDoiThucHien2.default;
exports.TruongPhongNhanYeuCauTheoDoiThucHien = _TruongPhongNhanYeuCauTheoDoiThucHien2.default;
exports.KetQuaTheoDoiThucHien = _KetQuaTheoDoiThucHien2.default;
exports.BlockGiaiQuyetDonInfo = _BlockGiaiQuyetDonInfo2.default;
exports.BlockBanHanhQuyetDinhView = _BlockBanHanhQuyetDinhView2.default;
exports.BlockBaoCaoKQTTXM = _BlockBaoCaoKQTTXM2.default;
exports.LichSuTrangThaiXuLyGiaiQuyetDon = _LichSuTrangThaiXuLyGiaiQuyetDon2.default;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(71);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlockTree = __webpack_require__(590);
var ContentState = __webpack_require__(365);
var EditorBidiService = __webpack_require__(1928);
var Immutable = __webpack_require__(35);
var SelectionState = __webpack_require__(178);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack;


var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record(defaultRecord);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable) {
    _classCallCheck(this, EditorState);

    this._immutable = immutable;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isObject = __webpack_require__(139);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["isNodeEnv"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["isFunction"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["safeInvoke"] = safeInvoke;
/* harmony export (immutable) */ __webpack_exports__["safeInvokeOrValue"] = safeInvokeOrValue;
/* harmony export (immutable) */ __webpack_exports__["elementIsOrContains"] = elementIsOrContains;
/* harmony export (immutable) */ __webpack_exports__["arrayLengthCompare"] = arrayLengthCompare;
/* harmony export (immutable) */ __webpack_exports__["approxEqual"] = approxEqual;
/* harmony export (immutable) */ __webpack_exports__["clamp"] = clamp;
/* harmony export (immutable) */ __webpack_exports__["countDecimalPlaces"] = countDecimalPlaces;
/* harmony export (immutable) */ __webpack_exports__["throttleEvent"] = throttleEvent;
/* harmony export (immutable) */ __webpack_exports__["throttleReactEventCallback"] = throttleReactEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__ = __webpack_require__(882);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "arraysEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shallowCompareKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deepCompareKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getShallowUnequalKeyValues", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getDeepUnequalKeyValues", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_compareUtils__["e"]; });
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */


/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
function isNodeEnv(env) {
    return typeof process !== "undefined" && process.env && "production" === env;
}
/** Returns whether the value is a function. Acts as a type guard. */
// tslint:disable-next-line:ban-types
function isFunction(value) {
    return typeof value === "function";
}
// tslint:disable-next-line:ban-types
function safeInvoke(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isFunction(func)) {
        return func.apply(void 0, args);
    }
}
// tslint:disable-next-line:ban-types
function safeInvokeOrValue(funcOrValue) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return isFunction(funcOrValue) ? funcOrValue.apply(void 0, args) : funcOrValue;
}
function elementIsOrContains(element, testElement) {
    return element === testElement || element.contains(testElement);
}
/**
 * Returns the difference in length between two arrays. A `null` argument is
 * considered an empty list. The return value will be positive if `a` is longer
 * than `b`, negative if the opposite is true, and zero if their lengths are
 * equal.
 */
function arrayLengthCompare(a, b) {
    if (a === void 0) { a = []; }
    if (b === void 0) { b = []; }
    return a.length - b.length;
}
/**
 * Returns true if the two numbers are within the given tolerance of each other.
 * This is useful to correct for floating point precision issues, less useful
 * for integers.
 */
function approxEqual(a, b, tolerance) {
    if (tolerance === void 0) { tolerance = 0.00001; }
    return Math.abs(a - b) <= tolerance;
}
/**
 * Clamps the given number between min and max values. Returns value if within
 * range, or closest bound.
 */
function clamp(val, min, max) {
    if (val == null) {
        return val;
    }
    if (max < min) {
        throw new Error(__WEBPACK_IMPORTED_MODULE_0__errors__["a" /* CLAMP_MIN_MAX */]);
    }
    return Math.min(Math.max(val, min), max);
}
/** Returns the number of decimal places in the given number. */
function countDecimalPlaces(num) {
    if (typeof num !== "number" || Math.floor(num) === num) {
        return 0;
    }
    return num.toString().split(".")[1].length;
}
/**
 * Throttle an event on an EventTarget by wrapping it in a
 * `requestAnimationFrame` call. Returns the event handler that was bound to
 * given eventName so you can clean up after yourself.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/scroll
 */
function throttleEvent(target, eventName, newEventName) {
    var throttledFunc = _throttleHelper(undefined, undefined, function (event) {
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
/**
 * Throttle a callback by wrapping it in a `requestAnimationFrame` call. Returns
 * the throttled function.
 * @see https://www.html5rocks.com/en/tutorials/speed/animations/
 */
function throttleReactEventCallback(callback, options) {
    if (options === void 0) { options = {}; }
    var throttledFunc = _throttleHelper(function (event2) {
        if (options.preventDefault) {
            event2.preventDefault();
        }
    }, function (event2) {
        // prevent React from reclaiming the event object before we
        // reference it
        event2.persist();
    }, function (event2) {
        var otherArgs2 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            otherArgs2[_i - 1] = arguments[_i];
        }
        callback.apply(void 0, [event2].concat(otherArgs2));
    });
    return throttledFunc;
}
function _throttleHelper(onBeforeIsRunningCheck, onAfterIsRunningCheck, onAnimationFrameRequested) {
    var isRunning = false;
    var func = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // don't use safeInvoke, because we might have more than its max number
        // of typed params
        if (isFunction(onBeforeIsRunningCheck)) {
            onBeforeIsRunningCheck.apply(void 0, args);
        }
        if (isRunning) {
            return;
        }
        isRunning = true;
        if (isFunction(onAfterIsRunningCheck)) {
            onAfterIsRunningCheck.apply(void 0, args);
        }
        requestAnimationFrame(function () {
            if (isFunction(onAnimationFrameRequested)) {
                onAnimationFrameRequested.apply(void 0, args);
            }
            isRunning = false;
        });
    };
    return func;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(120)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataTableDoiTuongThanhTra = exports.RowItemCapNhatNguoiDungXLD = exports.RowItemCapNhatNguoiDung = exports.RowItemVideo = exports.RowItemDanhMucVideo = exports.RowItemSearchDonViSoNoiVu = exports.RowItemSearchCongChucSoNoiVu = exports.RowItemDonViNgoai = exports.RowItemNhomDoiTuongThanhTra = exports.RowItemDoiTuongThanhTra = exports.RowItemLinhVucDoiTuongThanhTra = exports.RowItemTypeOfOrganizationLevel = exports.RowItemProcess = exports.RowItemParameter = exports.RowItemTuDongBaoCao = exports.RowItemOrganization = exports.RowItemLetters = exports.RowItemCongChuc = exports.RowItemDanToc = exports.RowItemAdministrative = exports.RowItemRole = exports.RowItemQuocTich = exports.RowItemOrganizationLevel = exports.RowItemPosition = exports.RowItemCapDonViHanhChinh = exports.RowItemLoaiTaiLieu = exports.RowItemThamQuyen = undefined;

var _RowItemThamQuyen = __webpack_require__(1068);

var _RowItemThamQuyen2 = _interopRequireDefault(_RowItemThamQuyen);

var _RowItemLoaiTaiLieu = __webpack_require__(1057);

var _RowItemLoaiTaiLieu2 = _interopRequireDefault(_RowItemLoaiTaiLieu);

var _RowItemOrganizationLevel = __webpack_require__(1060);

var _RowItemOrganizationLevel2 = _interopRequireDefault(_RowItemOrganizationLevel);

var _RowItemCapDonViHanhChinh = __webpack_require__(1047);

var _RowItemCapDonViHanhChinh2 = _interopRequireDefault(_RowItemCapDonViHanhChinh);

var _RowItemPosition = __webpack_require__(1062);

var _RowItemPosition2 = _interopRequireDefault(_RowItemPosition);

var _RowItemQuocTich = __webpack_require__(1064);

var _RowItemQuocTich2 = _interopRequireDefault(_RowItemQuocTich);

var _RowItemDanToc = __webpack_require__(1051);

var _RowItemDanToc2 = _interopRequireDefault(_RowItemDanToc);

var _RowItemRole = __webpack_require__(1065);

var _RowItemRole2 = _interopRequireDefault(_RowItemRole);

var _RowItemCongChuc = __webpack_require__(1050);

var _RowItemCongChuc2 = _interopRequireDefault(_RowItemCongChuc);

var _RowItemAdministrative = __webpack_require__(1046);

var _RowItemAdministrative2 = _interopRequireDefault(_RowItemAdministrative);

var _RowItemLetters = __webpack_require__(1055);

var _RowItemLetters2 = _interopRequireDefault(_RowItemLetters);

var _RowItemOrganization = __webpack_require__(1059);

var _RowItemOrganization2 = _interopRequireDefault(_RowItemOrganization);

var _RowItemTuDongBaoCao = __webpack_require__(1069);

var _RowItemTuDongBaoCao2 = _interopRequireDefault(_RowItemTuDongBaoCao);

var _RowItemParameter = __webpack_require__(1061);

var _RowItemParameter2 = _interopRequireDefault(_RowItemParameter);

var _RowItemProcess = __webpack_require__(1063);

var _RowItemProcess2 = _interopRequireDefault(_RowItemProcess);

var _RowItemTypeOfOrganizationLevel = __webpack_require__(1070);

var _RowItemTypeOfOrganizationLevel2 = _interopRequireDefault(_RowItemTypeOfOrganizationLevel);

var _RowItemLinhVucDoiTuongThanhTra = __webpack_require__(1056);

var _RowItemLinhVucDoiTuongThanhTra2 = _interopRequireDefault(_RowItemLinhVucDoiTuongThanhTra);

var _RowItemDoiTuongThanhTra = __webpack_require__(1053);

var _RowItemDoiTuongThanhTra2 = _interopRequireDefault(_RowItemDoiTuongThanhTra);

var _RowItemNhomDoiTuongThanhTra = __webpack_require__(1058);

var _RowItemNhomDoiTuongThanhTra2 = _interopRequireDefault(_RowItemNhomDoiTuongThanhTra);

var _RowItemDonViNgoai = __webpack_require__(1054);

var _RowItemDonViNgoai2 = _interopRequireDefault(_RowItemDonViNgoai);

var _RowItemCapNhatNguoiDung = __webpack_require__(1048);

var _RowItemCapNhatNguoiDung2 = _interopRequireDefault(_RowItemCapNhatNguoiDung);

var _RowItemSearchCongChucSoNoiVu = __webpack_require__(1066);

var _RowItemSearchCongChucSoNoiVu2 = _interopRequireDefault(_RowItemSearchCongChucSoNoiVu);

var _RowItemSearchDonViSoNoiVu = __webpack_require__(1067);

var _RowItemSearchDonViSoNoiVu2 = _interopRequireDefault(_RowItemSearchDonViSoNoiVu);

var _RowItemDanhMucVideo = __webpack_require__(1052);

var _RowItemDanhMucVideo2 = _interopRequireDefault(_RowItemDanhMucVideo);

var _RowItemVideo = __webpack_require__(1071);

var _RowItemVideo2 = _interopRequireDefault(_RowItemVideo);

var _RowItemCapNhatNguoiDungXLD = __webpack_require__(1049);

var _RowItemCapNhatNguoiDungXLD2 = _interopRequireDefault(_RowItemCapNhatNguoiDungXLD);

var _DataTableDoiTuongThanhTra = __webpack_require__(1045);

var _DataTableDoiTuongThanhTra2 = _interopRequireDefault(_DataTableDoiTuongThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------list-reception-------------*/
exports.RowItemThamQuyen = _RowItemThamQuyen2.default;
exports.RowItemLoaiTaiLieu = _RowItemLoaiTaiLieu2.default;
exports.RowItemCapDonViHanhChinh = _RowItemCapDonViHanhChinh2.default;
exports.RowItemPosition = _RowItemPosition2.default;
exports.RowItemOrganizationLevel = _RowItemOrganizationLevel2.default;
exports.RowItemQuocTich = _RowItemQuocTich2.default;
exports.RowItemRole = _RowItemRole2.default;
exports.RowItemAdministrative = _RowItemAdministrative2.default;
exports.RowItemDanToc = _RowItemDanToc2.default;
exports.RowItemCongChuc = _RowItemCongChuc2.default;
exports.RowItemLetters = _RowItemLetters2.default;
exports.RowItemOrganization = _RowItemOrganization2.default;
exports.RowItemTuDongBaoCao = _RowItemTuDongBaoCao2.default;
exports.RowItemParameter = _RowItemParameter2.default;
exports.RowItemProcess = _RowItemProcess2.default;
exports.RowItemTypeOfOrganizationLevel = _RowItemTypeOfOrganizationLevel2.default;
exports.RowItemLinhVucDoiTuongThanhTra = _RowItemLinhVucDoiTuongThanhTra2.default;
exports.RowItemDoiTuongThanhTra = _RowItemDoiTuongThanhTra2.default;
exports.RowItemNhomDoiTuongThanhTra = _RowItemNhomDoiTuongThanhTra2.default;
exports.RowItemDonViNgoai = _RowItemDonViNgoai2.default;
exports.RowItemSearchCongChucSoNoiVu = _RowItemSearchCongChucSoNoiVu2.default;
exports.RowItemSearchDonViSoNoiVu = _RowItemSearchDonViSoNoiVu2.default;
exports.RowItemDanhMucVideo = _RowItemDanhMucVideo2.default;
exports.RowItemVideo = _RowItemVideo2.default;
exports.RowItemCapNhatNguoiDung = _RowItemCapNhatNguoiDung2.default;
exports.RowItemCapNhatNguoiDungXLD = _RowItemCapNhatNguoiDungXLD2.default;
exports.DataTableDoiTuongThanhTra = _DataTableDoiTuongThanhTra2.default;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(203)('wks');
var uid = __webpack_require__(153);
var Symbol = __webpack_require__(30).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(97);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @fileOverview Layer
 */




var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Layer(props) {
  var children = props.children,
      className = props.className,
      others = _objectWithoutProperties(props, ['children', 'className']);

  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-layer', className);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    _extends({ className: layerClass }, others),
    children
  );
}

Layer.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getParams = getParams;
function getParams(params, id) {
  var dataGiaiQuyetDon = _extends({}, params);

  if (dataGiaiQuyetDon.donViThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViThamTraXacMinhInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.canBoGiaiQuyetInfo) {
    dataGiaiQuyetDon.canBoGiaiQuyet = {
      id: dataGiaiQuyetDon.canBoGiaiQuyetInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.canBoGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.donViTheoDoiThucHienInfo) {
    dataGiaiQuyetDon.donViTheoDoiThucHien = {
      id: dataGiaiQuyetDon.donViTheoDoiThucHienInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViTheoDoiThucHien = null;
  }

  if (dataGiaiQuyetDon.canBoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.canBoThamTraXacMinh = {
      id: dataGiaiQuyetDon.canBoThamTraXacMinhInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.canBoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.coQuanDieuTraInfo) {
    dataGiaiQuyetDon.coQuanDieuTra = {
      id: dataGiaiQuyetDon.coQuanDieuTraInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.coQuanDieuTra = null;
  }

  // if(dataGiaiQuyetDon.coQuanTheoDoiInfo) {
  //   dataGiaiQuyetDon.coQuanTheoDoi = {
  //     id: dataGiaiQuyetDon.coQuanTheoDoiInfo.coQuanQuanLyId
  //   }
  // } else {
  //   dataGiaiQuyetDon.coQuanTheoDoi = null
  // }

  if (dataGiaiQuyetDon.truongDoanTTXMInfo) {
    dataGiaiQuyetDon.truongDoanTTXM = {
      id: dataGiaiQuyetDon.truongDoanTTXMInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.truongDoanTTXM = null;
  }

  if (dataGiaiQuyetDon.canBoXuLyChiDinhInfo) {
    dataGiaiQuyetDon.canBoXuLyChiDinh = {
      id: dataGiaiQuyetDon.canBoXuLyChiDinhInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.canBoXuLyChiDinh = null;
  }

  if (dataGiaiQuyetDon.nextStateInfo) {
    dataGiaiQuyetDon.nextState = {
      id: dataGiaiQuyetDon.nextStateInfo.id
    };
  } else {
    dataGiaiQuyetDon.nextState = null;
  }

  if (dataGiaiQuyetDon.phongBanGiaiQuyetInfo) {
    dataGiaiQuyetDon.phongBanGiaiQuyet = {
      id: dataGiaiQuyetDon.phongBanGiaiQuyetInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.phongBanGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo) {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = {
      id: dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo) {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = {
      id: dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = null;
  }

  delete dataGiaiQuyetDon['_links'];
  delete dataGiaiQuyetDon['nguoiSuaInfo'];
  delete dataGiaiQuyetDon['nguoiTaoInfo'];
  delete dataGiaiQuyetDon['ngaySua'];
  delete dataGiaiQuyetDon['ngayTao'];
  delete dataGiaiQuyetDon['donViThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['donViGiaoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetKetQuaXLDInfo'];
  delete dataGiaiQuyetDon['canBoGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['canBoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['coQuanDieuTraInfo'];
  delete dataGiaiQuyetDon['coQuanTheoDoiInfo'];
  delete dataGiaiQuyetDon['truongDoanTTXMInfo'];
  delete dataGiaiQuyetDon['donId'];
  delete dataGiaiQuyetDon['coQuanDaGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['nguoiBanHanhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['canBoXuLyChiDinhInfo'];
  delete dataGiaiQuyetDon['huongThuLyGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['donViTheoDoiThucHienInfo'];
  delete dataGiaiQuyetDon['ketQuaGiaiQuyetLan2Info'];
  delete dataGiaiQuyetDon['ketQuaXLDGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['nextStateInfo'];

  dataGiaiQuyetDon['don'] = {
    id: Number(id)
  };

  return dataGiaiQuyetDon;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(34)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function(data, filename, mime, bom) {
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React, global.propTypes);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var TextTruncate = function (_Component) {
    _inherits(TextTruncate, _Component);

    function TextTruncate() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, TextTruncate);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextTruncate)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onResize", function () {
        if (_this.rafId) {
          window.cancelAnimationFrame(_this.rafId);
        }

        _this.rafId = window.requestAnimationFrame(_this.update.bind(_assertThisInitialized(_this)));
      });

      _defineProperty(_assertThisInitialized(_this), "onToggled", function (truncated) {
        typeof _this.props.onToggled === 'function' && setTimeout(function () {
          return _this.props.onToggled(truncated);
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "onTruncated", function () {
        typeof _this.props.onTruncated === 'function' && setTimeout(function () {
          return _this.props.onTruncated();
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "onCalculated", function () {
        typeof _this.props.onCalculated === 'function' && setTimeout(function () {
          return _this.props.onCalculated();
        }, 0);
      });

      _defineProperty(_assertThisInitialized(_this), "update", function () {
        var style = window.getComputedStyle(_this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family'], style['letter-spacing']].join(' ');
        _this.canvas.font = font;

        _this.forceUpdate();
      });

      return _this;
    }

    _createClass(TextTruncate, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var canvas = document.createElement('canvas');
        var docFragment = document.createDocumentFragment();
        var style = window.getComputedStyle(this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
        docFragment.appendChild(canvas);
        this.canvas = canvas.getContext('2d');
        this.canvas.font = font;
        this.forceUpdate();
        window.addEventListener('resize', this.onResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);

        if (this.rafId) {
          window.cancelAnimationFrame(this.rafId);
        }
      }
    }, {
      key: "measureWidth",
      value: function measureWidth(text) {
        return Math.ceil(this.canvas.measureText(text).width);
      }
    }, {
      key: "getRenderText",
      value: function getRenderText() {
        var _this$props = this.props,
            containerClassName = _this$props.containerClassName,
            element = _this$props.element,
            line = _this$props.line,
            onCalculated = _this$props.onCalculated,
            onTruncated = _this$props.onTruncated,
            onToggled = _this$props.onToggled,
            text = _this$props.text,
            textElement = _this$props.textElement,
            textTruncateChild = _this$props.textTruncateChild,
            truncateText = _this$props.truncateText,
            maxCalculateTimes = _this$props.maxCalculateTimes,
            props = _objectWithoutProperties(_this$props, ["containerClassName", "element", "line", "onCalculated", "onTruncated", "onToggled", "text", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);

        var scopeWidth = this.scope.getBoundingClientRect().width; // return if display:none

        if (scopeWidth === 0) {
          return null;
        } // return if all of text can be displayed


        if (scopeWidth >= this.measureWidth(text)) {
          this.onToggled(false);
          return (0, _react.createElement)(textElement, props, text);
        }

        var childText = '';

        if (textTruncateChild && typeof textTruncateChild.type === 'string') {
          var type = textTruncateChild.type;

          if (type.indexOf('span') >= 0 || type.indexOf('a') >= 0) {
            childText = textTruncateChild.props.children;
          }
        }

        var currentPos = 1;
        var maxTextLength = text.length;
        var truncatedText = '';
        var splitPos = 0;
        var startPos = 0;
        var displayLine = line;
        var width = 0;
        var lastIsEng = false;
        var isPrevLineWithoutSpace = false;
        var lastPos = 0;
        var lastSpaceIndex = -1;
        var ext = '';
        var loopCnt = 0;

        while (displayLine-- > 0) {
          ext = displayLine ? '' : truncateText + (childText ? ' ' + childText : '');

          while (currentPos <= maxTextLength) {
            truncatedText = text.substr(startPos, currentPos);
            width = this.measureWidth(truncatedText + ext);

            if (width < scopeWidth) {
              splitPos = text.indexOf(' ', currentPos + 1);

              if (splitPos === -1) {
                currentPos += 1;
                lastIsEng = false;
              } else {
                lastIsEng = true;
                currentPos = splitPos;
              }
            } else {
              do {
                if (loopCnt++ >= maxCalculateTimes) {
                  break;
                }

                truncatedText = text.substr(startPos, currentPos);

                if (!displayLine) {
                  currentPos--;
                }

                if (truncatedText[truncatedText.length - 1] === ' ') {
                  truncatedText = text.substr(startPos, currentPos - 1);
                }

                if (lastIsEng) {
                  lastSpaceIndex = truncatedText.lastIndexOf(' ');

                  if (lastSpaceIndex > -1) {
                    currentPos = lastSpaceIndex;

                    if (displayLine) {
                      currentPos++;
                    }

                    truncatedText = text.substr(startPos, currentPos);
                  } else {
                    currentPos--;
                    truncatedText = text.substr(startPos, currentPos);
                  }
                } else {
                  currentPos--;
                  truncatedText = text.substr(startPos, currentPos);
                }

                width = this.measureWidth(truncatedText + ext);
              } while (width >= scopeWidth && truncatedText.length > 0);

              startPos += currentPos;
              break;
            }
          }

          if (currentPos >= maxTextLength) {
            startPos = maxTextLength;
            break;
          }

          if (lastIsEng && !isPrevLineWithoutSpace && text.substr(lastPos, currentPos).indexOf(' ') === -1) {
            isPrevLineWithoutSpace = text.substr(lastPos, currentPos).indexOf(' ') === -1;
            displayLine--;
          }

          lastPos = currentPos + 1;
        }

        if (startPos === maxTextLength) {
          this.onToggled(false);
          return (0, _react.createElement)(textElement, props, text);
        }

        this.onTruncated();
        this.onToggled(true);
        return _react2["default"].createElement("div", props, (0, _react.createElement)(textElement, props, text.substr(0, startPos) + truncateText + ' '), textTruncateChild);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            element = _this$props2.element,
            text = _this$props2.text,
            _this$props2$style = _this$props2.style,
            style = _this$props2$style === void 0 ? {} : _this$props2$style,
            containerClassName = _this$props2.containerClassName,
            line = _this$props2.line,
            onCalculated = _this$props2.onCalculated,
            onTruncated = _this$props2.onTruncated,
            onToggled = _this$props2.onToggled,
            textElement = _this$props2.textElement,
            textTruncateChild = _this$props2.textTruncateChild,
            truncateText = _this$props2.truncateText,
            maxCalculateTimes = _this$props2.maxCalculateTimes,
            props = _objectWithoutProperties(_this$props2, ["element", "text", "style", "containerClassName", "line", "onCalculated", "onTruncated", "onToggled", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);

        var fontWeight = style.fontWeight,
            fontStyle = style.fontStyle,
            fontSize = style.fontSize,
            fontFamily = style.fontFamily;
        var renderText = this.scope && line ? this.getRenderText() : (0, _react.createElement)(textElement, props, text);
        ;
        var rootProps = {
          ref: function ref(el) {
            _this2.scope = el;
          },
          className: containerClassName,
          style: {
            overflow: 'hidden',
            fontWeight: fontWeight,
            fontStyle: fontStyle,
            fontSize: fontSize,
            fontFamily: fontFamily
          }
        };
        this.scope && this.onCalculated();
        return (0, _react.createElement)(element, rootProps, renderText);
      }
    }]);

    return TextTruncate;
  }(_react.Component);

  _defineProperty(TextTruncate, "propTypes", {
    containerClassName: _propTypes2["default"].string,
    element: _propTypes2["default"].string,
    line: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].bool]),
    onCalculated: _propTypes2["default"].func,
    onTruncated: _propTypes2["default"].func,
    onToggled: _propTypes2["default"].func,
    text: _propTypes2["default"].string,
    textElement: _propTypes2["default"].node,
    textTruncateChild: _propTypes2["default"].node,
    truncateText: _propTypes2["default"].string,
    maxCalculateTimes: _propTypes2["default"].number
  });

  _defineProperty(TextTruncate, "defaultProps", {
    element: 'div',
    line: 1,
    text: '',
    textElement: 'span',
    truncateText: '…',
    maxCalculateTimes: 10
  });

  exports.default = TextTruncate;
  ;
  module.exports = exports.default;
});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemCanCuCuocThanhTraView = exports.RowItemCanCuCuocThanhTra = exports.LoadingDataTale = exports.RowItemDoiTuongThanhTraView = exports.RowItemChiTietThanhVienCuocThanhTraView = exports.RowItemDoiTuongThanhTra = exports.RowItemChiTietThanhVienCuocThanhTra = exports.RowItemChiTietCuocThanhTra = exports.RowItemDanhSachDoiTuongTrung = exports.RowItemDanhSachCuocThanhTraPage = exports.RowItemDanhSachCuocThanhTra = exports.RowItemKetQuaTimKiemThanhTra = exports.DataTableAttachElement = exports.DataTableMultipleSelect = exports.RowItemDanhSachThemMoiThanhTra = exports.RowItemDanhSachKeHoachThanhTra = exports.RowItemDanhSachKeHoachThanhTraDaPheDuyet = exports.RowItemThanhTraDeXuat = undefined;

var _RowItemDanhSachKeHoachThanhTra = __webpack_require__(1359);

var _RowItemDanhSachKeHoachThanhTra2 = _interopRequireDefault(_RowItemDanhSachKeHoachThanhTra);

var _RowItemDanhSachKeHoachThanhTraDaPheDuyet = __webpack_require__(1360);

var _RowItemDanhSachKeHoachThanhTraDaPheDuyet2 = _interopRequireDefault(_RowItemDanhSachKeHoachThanhTraDaPheDuyet);

var _RowItemDanhSachThemMoiThanhTra = __webpack_require__(1361);

var _RowItemDanhSachThemMoiThanhTra2 = _interopRequireDefault(_RowItemDanhSachThemMoiThanhTra);

var _DataTableMultipleSelect = __webpack_require__(1349);

var _DataTableMultipleSelect2 = _interopRequireDefault(_DataTableMultipleSelect);

var _DataTableAttachElement = __webpack_require__(1348);

var _DataTableAttachElement2 = _interopRequireDefault(_DataTableAttachElement);

var _RowItemKetQuaTimKiemThanhTra = __webpack_require__(1364);

var _RowItemKetQuaTimKiemThanhTra2 = _interopRequireDefault(_RowItemKetQuaTimKiemThanhTra);

var _RowItemDanhSachCuocThanhTra = __webpack_require__(1356);

var _RowItemDanhSachCuocThanhTra2 = _interopRequireDefault(_RowItemDanhSachCuocThanhTra);

var _RowItemDanhSachCuocThanhTraPage = __webpack_require__(1357);

var _RowItemDanhSachCuocThanhTraPage2 = _interopRequireDefault(_RowItemDanhSachCuocThanhTraPage);

var _RowItemDanhSachDoiTuongTrung = __webpack_require__(1358);

var _RowItemDanhSachDoiTuongTrung2 = _interopRequireDefault(_RowItemDanhSachDoiTuongTrung);

var _RowItemChiTietCuocThanhTra = __webpack_require__(1353);

var _RowItemChiTietCuocThanhTra2 = _interopRequireDefault(_RowItemChiTietCuocThanhTra);

var _RowItemChiTietThanhVienCuocThanhTra = __webpack_require__(1354);

var _RowItemChiTietThanhVienCuocThanhTra2 = _interopRequireDefault(_RowItemChiTietThanhVienCuocThanhTra);

var _RowItemDoiTuongThanhTra = __webpack_require__(1362);

var _RowItemDoiTuongThanhTra2 = _interopRequireDefault(_RowItemDoiTuongThanhTra);

var _RowItemChiTietThanhVienCuocThanhTraView = __webpack_require__(1355);

var _RowItemChiTietThanhVienCuocThanhTraView2 = _interopRequireDefault(_RowItemChiTietThanhVienCuocThanhTraView);

var _RowItemDoiTuongThanhTraView = __webpack_require__(1363);

var _RowItemDoiTuongThanhTraView2 = _interopRequireDefault(_RowItemDoiTuongThanhTraView);

var _RowItemThanhTraDeXuat = __webpack_require__(1365);

var _RowItemThanhTraDeXuat2 = _interopRequireDefault(_RowItemThanhTraDeXuat);

var _LoadingDataTale = __webpack_require__(1350);

var _LoadingDataTale2 = _interopRequireDefault(_LoadingDataTale);

var _RowItemCanCuCuocThanhTra = __webpack_require__(1351);

var _RowItemCanCuCuocThanhTra2 = _interopRequireDefault(_RowItemCanCuCuocThanhTra);

var _RowItemCanCuCuocThanhTraView = __webpack_require__(1352);

var _RowItemCanCuCuocThanhTraView2 = _interopRequireDefault(_RowItemCanCuCuocThanhTraView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemThanhTraDeXuat = _RowItemThanhTraDeXuat2.default;
exports.RowItemDanhSachKeHoachThanhTraDaPheDuyet = _RowItemDanhSachKeHoachThanhTraDaPheDuyet2.default;
exports.RowItemDanhSachKeHoachThanhTra = _RowItemDanhSachKeHoachThanhTra2.default;
exports.RowItemDanhSachThemMoiThanhTra = _RowItemDanhSachThemMoiThanhTra2.default;
exports.DataTableMultipleSelect = _DataTableMultipleSelect2.default;
exports.DataTableAttachElement = _DataTableAttachElement2.default;
exports.RowItemKetQuaTimKiemThanhTra = _RowItemKetQuaTimKiemThanhTra2.default;
exports.RowItemDanhSachCuocThanhTra = _RowItemDanhSachCuocThanhTra2.default;
exports.RowItemDanhSachCuocThanhTraPage = _RowItemDanhSachCuocThanhTraPage2.default;
exports.RowItemDanhSachDoiTuongTrung = _RowItemDanhSachDoiTuongTrung2.default;
exports.RowItemChiTietCuocThanhTra = _RowItemChiTietCuocThanhTra2.default;
exports.RowItemChiTietThanhVienCuocThanhTra = _RowItemChiTietThanhVienCuocThanhTra2.default;
exports.RowItemDoiTuongThanhTra = _RowItemDoiTuongThanhTra2.default;
exports.RowItemChiTietThanhVienCuocThanhTraView = _RowItemChiTietThanhVienCuocThanhTraView2.default;
exports.RowItemDoiTuongThanhTraView = _RowItemDoiTuongThanhTraView2.default;
exports.LoadingDataTale = _LoadingDataTale2.default;
exports.RowItemCanCuCuocThanhTra = _RowItemCanCuCuocThanhTra2.default;
exports.RowItemCanCuCuocThanhTraView = _RowItemCanCuCuocThanhTraView2.default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(517);
var toPrimitive = __webpack_require__(105);
var dP = Object.defineProperty;

exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2164)();
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var DOMProperty = __webpack_require__(183);
var ReactDOMComponentFlags = __webpack_require__(802);

var invariant = __webpack_require__(21);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var processType = {
  dangXuLy: 'DANG_XU_LY',
  daXuLy: 'DA_XU_LY',
  xuLyDon: {
    name: 'XU_LY_DON',
    processing: {
      lanhDaoThuHoi: 'LANH_DAO_THU_HOI',
      truongPhongThuHoi: 'TRUONG_PHONG_THU_HOI',
      yeuCauGapLanhDao: 'YEU_CAU_GAP_LANH_DAO',
      trinhLanhDao: 'TRINH_LANH_DAO',
      trinhTruongPhong: 'TRINH_TRUONG_PHONG',
      lanhDaoGiaoViecTruongPhong: 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG',
      lanhDaoGiaoViecChuyenVien: 'LANH_DAO_GIAO_VIEC_CAN_BO',
      truongPhongGiaoViecChuyenVien: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
      truongPhongGiaoViecPhoPhong: 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG',
      deXuatGiaoViecLai: 'DE_XUAT_GIAO_VIEC_LAI',
      ketThuc: 'KET_THUC',
      dinhChi: 'DINH_CHI'
    },
    huongXuLy: {
      traDonChuyenKhongDungThamQuyen: 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN',
      yeuCauGapLanhDao: 'YEU_CAU_GAP_LANH_DAO',
      traDonVaHuongDan: 'TRA_DON_VA_HUONG_DAN',
      khongDuDieuKienThuLy: 'KHONG_DU_DIEU_KIEN_THU_LY',
      luuDonVaTheoDoi: 'LUU_DON_VA_THEO_DOI',
      khongXuLyNeuLyDo: 'KHONG_XU_LY_NEU_LY_DO',
      huongDanVietLaiDon: 'HUONG_DAN_VIET_LAI_DON',
      chuyenDon: 'CHUYEN_DON',
      deXuatThuLy: 'DE_XUAT_THU_LY'
    }
  },
  giaiQuyetDon: {
    name: 'GIAI_QUYET_DON'
  }

};

exports.processType = processType;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(103);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TongHopKetQua = undefined;

var _TongHopKetQua = __webpack_require__(1403);

var _TongHopKetQua2 = _interopRequireDefault(_TongHopKetQua);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TongHopKetQua = _TongHopKetQua2.default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.load = load;
exports.select = select;
exports.save = save;
exports.remove = remove;
exports.setRawCookie = setRawCookie;
exports.plugToRequest = plugToRequest;

var _cookie = __webpack_require__(2171);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(29);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _isNode = __webpack_require__(2032);

var _isNode2 = _interopRequireDefault(_isNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _rawCookie = {};
var _res = undefined;

function _isResWritable() {
  return _res && !_res.headersSent;
}

function load(name, doNotParse, opt) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie, opt);
  var cookieVal = cookies && cookies[name];

  if (typeof doNotParse === 'undefined') {
    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
  }

  if (!doNotParse) {
    try {
      cookieVal = JSON.parse(cookieVal);
    } catch (e) {
      // Not serialized object
    }
  }

  return cookieVal;
}

function select(regex) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie);

  if (!cookies) {
    return {};
  }

  if (!regex) {
    return cookies;
  }

  return Object.keys(cookies).reduce(function (accumulator, name) {
    if (!regex.test(name)) {
      return accumulator;
    }

    var newCookie = {};
    newCookie[name] = cookies[name];
    return (0, _objectAssign2.default)({}, accumulator, newCookie);
  }, {});
}

function save(name, val, opt) {
  _rawCookie[name] = val;

  // allow you to work with cookies as objects.
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    _rawCookie[name] = JSON.stringify(val);
  }

  // Cookies only work in the browser
  if (!_isNode2.default) {
    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
  }

  if (_isResWritable() && _res.cookie) {
    var expressOpt = _extends({}, opt);
    if (expressOpt.maxAge) {
      // the standard for maxAge is seconds but express uses milliseconds
      expressOpt.maxAge = opt.maxAge * 1000;
    }

    _res.cookie(name, val, opt);
  }
}

function remove(name, opt) {
  delete _rawCookie[name];

  if (typeof opt === 'undefined') {
    opt = {};
  } else if (typeof opt === 'string') {
    // Will be deprecated in future versions
    opt = { path: opt };
  } else {
    // Prevent mutation of opt below
    opt = (0, _objectAssign2.default)({}, opt);
  }

  if (typeof document !== 'undefined') {
    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
    opt.maxAge = 0;
    document.cookie = _cookie2.default.serialize(name, '', opt);
  }

  if (_isResWritable() && _res.clearCookie) {
    _res.clearCookie(name, opt);
  }
}

function setRawCookie(rawCookie) {
  if (rawCookie) {
    _rawCookie = _cookie2.default.parse(rawCookie);
  } else {
    _rawCookie = {};
  }
}

function plugToRequest(req, res) {
  if (req.cookie) {
    _rawCookie = req.cookie;
  } else if (req.cookies) {
    _rawCookie = req.cookies;
  } else if (req.headers && req.headers.cookie) {
    setRawCookie(req.headers.cookie);
  } else {
    _rawCookie = {};
  }

  _res = res;

  return function unplug() {
    _res = null;
    _rawCookie = {};
  };
}

exports.default = {
  setRawCookie: setRawCookie,
  load: load,
  select: select,
  save: save,
  remove: remove,
  plugToRequest: plugToRequest
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2191);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(433)
  , core      = __webpack_require__(431)
  , hide      = __webpack_require__(861)
  , redefine  = __webpack_require__(2323)
  , ctx       = __webpack_require__(2317)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(867);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props, context) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));

    _this.state = {
      tuKhoa: _this.props.parents.state.tuKhoa
    };
    return _this;
  }

  _createClass(Search, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tuKhoa: e.target.value
      });
      var data = {
        target: {
          name: 'tuKhoa',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tuKhoa',
            placeholder: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...',
            className: 'search-input',
            value: this.state.tuKhoa,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return Search;
}(_react2.default.Component);

exports.default = Search;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(41);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */
var AbstractComponent = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AbstractComponent, _super);
    function AbstractComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        /**
         * Clear all known timeouts.
         */
        _this.clearTimeouts = function () {
            if (_this.timeoutIds.length > 0) {
                for (var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++) {
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["isNodeEnv"])("production")) {
            _this.validateProps(_this.props);
        }
        return _this;
    }
    AbstractComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["isNodeEnv"])("production")) {
            this.validateProps(nextProps);
        }
    };
    AbstractComponent.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
    };
    /**
     * Set a timeout and remember its ID.
     * All stored timeouts will be cleared when component unmounts.
     * @returns a "cancel" function that will clear timeout when invoked.
     */
    AbstractComponent.prototype.setTimeout = function (callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function () { return window.clearTimeout(handle); };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * In contrast to propTypes, these runtime checks are _always_ run, not just in development mode.
     */
    AbstractComponent.prototype.validateProps = function (_) {
        // implement in subclass
    };
    return AbstractComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLAMP_MIN_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ALERT_WARN_CANCEL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return COLLAPSIBLE_LIST_INVALID_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONTEXTMENU_WARN_DECORATOR_NO_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return HOTKEYS_HOTKEY_CHILDREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MENU_WARN_CHILDREN_SUBMENU_MUTEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return NUMERIC_INPUT_MIN_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NUMERIC_INPUT_STEP_SIZE_NULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return POPOVER_REQUIRES_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return POPOVER_MODAL_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return POPOVER_WARN_TOO_MANY_CHILDREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return POPOVER_WARN_DOUBLE_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return POPOVER_WARN_DOUBLE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return POPOVER_WARN_EMPTY_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return POPOVER_WARN_MODAL_INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return POPOVER_WARN_DEPRECATED_CONSTRAINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return POPOVER_WARN_INLINE_NO_TETHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return POPOVER_WARN_UNCONTROLLED_ONINTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PORTAL_CONTEXT_CLASS_NAME_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SLIDER_ZERO_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SLIDER_ZERO_LABEL_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RANGESLIDER_NULL_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TABS_FIRST_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TABS_MISMATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TABS_WARN_DEPRECATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOASTER_CREATE_NULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOASTER_WARN_INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOASTER_WARN_LEFT_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DIALOG_WARN_NO_HEADER_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DIALOG_WARN_NO_HEADER_CLOSE_BUTTON; });
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var ns = "[Blueprint]";
var deprec = ns + " DEPRECATION:";
var CLAMP_MIN_MAX = ns + " clamp: max cannot be less than min";
var ALERT_WARN_CANCEL_PROPS = ns + " <Alert> cancelButtonText and onCancel should be set together.";
var COLLAPSIBLE_LIST_INVALID_CHILD = ns + " <CollapsibleList> children must be <MenuItem>s";
var CONTEXTMENU_WARN_DECORATOR_NO_METHOD = ns + " @ContextMenuTarget-decorated class should implement renderContextMenu.";
var HOTKEYS_HOTKEY_CHILDREN = ns + " <Hotkeys> only accepts <Hotkey> children.";
var MENU_WARN_CHILDREN_SUBMENU_MUTEX = ns + " <MenuItem> children and submenu props are mutually exclusive, with children taking priority.";
var NUMERIC_INPUT_MIN_MAX = ns + " <NumericInput> requires min to be strictly less than max if both are defined.";
var NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires minorStepSize to be strictly less than stepSize.";
var NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires majorStepSize to be strictly greater than stepSize.";
var NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
var NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
var NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
var NUMERIC_INPUT_STEP_SIZE_NULL = ns + " <NumericInput> requires stepSize to be defined.";
var POPOVER_REQUIRES_TARGET = ns + " <Popover> requires target prop or at least one child element.";
var POPOVER_MODAL_INTERACTION = ns + " <Popover isModal={true}> requires interactionKind={PopoverInteractionKind.CLICK}.";
var POPOVER_WARN_TOO_MANY_CHILDREN = ns +
    " <Popover> supports one or two children; additional children are ignored." +
    " First child is the target, second child is the content. You may instead supply these two as props.";
var POPOVER_WARN_DOUBLE_CONTENT = ns + " <Popover> with two children ignores content prop; use either prop or children.";
var POPOVER_WARN_DOUBLE_TARGET = ns + " <Popover> with children ignores target prop; use either prop or children.";
var POPOVER_WARN_EMPTY_CONTENT = ns + " Disabling <Popover> with empty/whitespace content...";
var POPOVER_WARN_MODAL_INLINE = ns + " <Popover inline={true}> ignores isModal";
var POPOVER_WARN_DEPRECATED_CONSTRAINTS = ns + " <Popover> constraints and useSmartPositioning are deprecated. Use tetherOptions directly.";
var POPOVER_WARN_INLINE_NO_TETHER = ns + " <Popover inline={true}> ignores tetherOptions, constraints, and useSmartPositioning.";
var POPOVER_WARN_UNCONTROLLED_ONINTERACTION = ns + " <Popover> onInteraction is ignored when uncontrolled.";
var PORTAL_CONTEXT_CLASS_NAME_STRING = ns + " <Portal> context blueprintPortalClassName must be string";
var RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX = ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
var SLIDER_ZERO_STEP = ns + " <Slider> stepSize must be greater than zero.";
var SLIDER_ZERO_LABEL_STEP = ns + " <Slider> labelStepSize must be greater than zero.";
var RANGESLIDER_NULL_VALUE = ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
var TABS_FIRST_CHILD = ns + " First child of <Tabs> component must be a <TabList>";
var TABS_MISMATCH = ns + " Number of <Tab> components must equal number of <TabPanel> components";
var TABS_WARN_DEPRECATED = deprec +
    " <Tabs> is deprecated since v1.11.0; consider upgrading to <Tabs2>." +
    " https://blueprintjs.com/#components.tabs.js";
var TOASTER_CREATE_NULL = ns +
    " Toaster.create() is not supported inside React lifecycle methods in React 16." +
    " See usage example on the docs site.";
var TOASTER_WARN_INLINE = ns + " Toaster.create() ignores inline prop as it always creates a new element.";
var TOASTER_WARN_LEFT_RIGHT = ns + " Toaster does not support LEFT or RIGHT positions.";
var DIALOG_WARN_NO_HEADER_ICON = ns + " <Dialog> iconName is ignored if title is omitted.";
var DIALOG_WARN_NO_HEADER_CLOSE_BUTTON = ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = customFetch;

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _toastr = __webpack_require__(11);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorCatcher = false;
var Promise = __webpack_require__(136).Promise;
function customFetch(url, options) {
  // return a promise of axios
  var at = _reactCookie2.default.load('accessToken');
  if (at) {
    _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + at;
    errorCatcher = false;
  }

  return new Promise(function (resolve, reject) {
    (0, _axios2.default)(url, options).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      if (error.response && error.response.status == 401 && errorCatcher == false) {
        errorCatcher = true;
        _reactCookie2.default.remove('accessToken', { path: '/' });
        localStorage.removeItem('userInfo');
        localStorage.removeItem('thamSo');
        // if (error.response.data && error.response.data.errors.length && error.response.data.errors[0].redirectUrl) {
        //   window.location.replace(error.response.data.errors[0].redirectUrl);
        // } else {
        _reactRouter.browserHistory.push('/dang-nhap');
        // }
        (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
      }
      reject(error);
    });
  });
}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(544);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-void: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = reduxApi;

var _reducerFn = __webpack_require__(2354);

var _reducerFn2 = _interopRequireDefault(_reducerFn);

var _actionFn = __webpack_require__(2349);

var _actionFn2 = _interopRequireDefault(_actionFn);

var _transformers = __webpack_require__(2355);

var _transformers2 = _interopRequireDefault(_transformers);

var _async = __webpack_require__(2350);

var _async2 = _interopRequireDefault(_async);

var _cache = __webpack_require__(437);

var _cache2 = _interopRequireDefault(_cache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export { transformers, async };

/**
 * Default configuration for each endpoint
 * @type {Object}
 */
var defaultEndpointConfig = {
  transformer: _transformers2.default.object
};

var PREFIX = "@@redux-api";
/**
 * Entry api point
 * @param {Object} config Rest api configuration
 * @param {Object} baseConfig baseConfig settings for Rest api
 * @param {Function} fetch Adapter for rest requests
 * @param {Boolean} isServer false by default (fif you want to use it for isomorphic apps)
 * @return {actions, reducers}        { actions, reducers}
 * @example ```js
 *   const api = reduxApi({
 *     test: "/plain/url",
 *     testItem: "/plain/url/:id",
 *     testModify: {
 *       url: "/plain/url/:endpoint",

 *       transformer: (data)=> !data ?
 *          { title: "", message: "" } :
 *          { title: data.title, message: data.message },
 *       options: {
 *         method: "post"
 *         headers: {
 *           "Accept": "application/json",
 *           "Content-Type": "application/json"
 *         }
 *       }
 *     }
 *   });
 *   // register reducers
 *
 *   // call actions
 *   dispatch(api.actions.test());
 *   dispatch(api.actions.testItem({id: 1}));
 *   dispatch(api.actions.testModify({endpoint: "upload-1"}, {
 *     body: JSON.stringify({title: "Hello", message: "World"})
 *   }));
 * ```
 */

function reduxApi(config, baseConfig) {
  config || (config = {});

  var fetchHolder = {
    fetch: null,
    server: false,
    rootUrl: null,
    middlewareParser: null,
    options: {},
    responseHandler: null
  };

  var cfg = {
    use: function use(key, value) {
      fetchHolder[key] = value;

      return this;
    },
    init: function init(fetch) {
      var isServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rootUrl = arguments[2];

      /* eslint no-console: 0 */
      console.warn("Deprecated method, use `use` method");
      this.use("fetch", fetch);
      this.use("server", isServer);
      this.use("rootUrl", rootUrl);
      return this;
    },

    actions: {},
    reducers: {},
    events: {}
  };
  function fnConfigCallback(memo, value, key) {
    var opts = (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" ? _extends({}, defaultEndpointConfig, { reducerName: key }, value) : _extends({}, defaultEndpointConfig, { reducerName: key, url: value });

    if (opts.broadcast !== void 0) {
      /* eslint no-console: 0 */
      console.warn("Deprecated `broadcast` option. you shoud use `events`" + "to catch redux-api events (see https://github.com/lexich/redux-api/blob/master/DOCS.md#Events)");
    }

    var url = opts.url,
        urlOptions = opts.urlOptions,
        options = opts.options,
        transformer = opts.transformer,
        broadcast = opts.broadcast,
        crud = opts.crud,
        reducerName = opts.reducerName,
        prefetch = opts.prefetch,
        postfetch = opts.postfetch,
        validation = opts.validation,
        helpers = opts.helpers;


    var prefix = baseConfig && baseConfig.prefix || "";

    var ACTIONS = {
      actionFetch: PREFIX + "@" + prefix + reducerName,
      actionSuccess: PREFIX + "@" + prefix + reducerName + "_success",
      actionFail: PREFIX + "@" + prefix + reducerName + "_fail",
      actionReset: PREFIX + "@" + prefix + reducerName + "_delete",
      actionCache: PREFIX + "@" + prefix + reducerName + "_cache",
      actionAbort: PREFIX + "@" + prefix + reducerName + "_abort"
    };

    var fetch = opts.fetch ? opts.fetch : function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return fetchHolder.fetch.apply(this, args);
    };

    var meta = {
      holder: fetchHolder,
      virtual: !!opts.virtual,
      actions: memo.actions,
      cache: (0, _cache2.default)(opts.cache),
      urlOptions: urlOptions,
      fetch: fetch,
      broadcast: broadcast,
      reducerName: reducerName,
      prefetch: prefetch,
      postfetch: postfetch,
      validation: validation,
      helpers: helpers,
      transformer: transformer,
      prefix: prefix,
      crud: crud
    };

    memo.actions[key] = (0, _actionFn2.default)(url, key, options, ACTIONS, meta);

    if (!meta.virtual && !memo.reducers[reducerName]) {
      var data = transformer();
      var sync = false;
      var syncing = false;
      var loading = false;
      var initialState = opts.cache ? { sync: sync, syncing: syncing, loading: loading, data: data, pathvars: {}, body: {}, cache: {} } : { sync: sync, syncing: syncing, loading: loading, data: data, pathvars: {}, body: {} };

      var reducer = opts.reducer ? opts.reducer.bind(memo) : null;
      memo.reducers[reducerName] = (0, _reducerFn2.default)(initialState, ACTIONS, reducer);
    }
    memo.events[reducerName] = ACTIONS;
    return memo;
  }

  return Object.keys(config).reduce(function (memo, key) {
    return fnConfigCallback(memo, config[key], key, config);
  }, cfg);
}

reduxApi.transformers = _transformers2.default;
reduxApi.async = _async2.default;
module.exports = exports["default"];
//# sourceMappingURL=index.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    _classCallCheck(this, ConfirmDialog);

    return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).apply(this, arguments));
  }

  _createClass(ConfirmDialog, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.onClose();
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      this.props.onSuccess();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.closeDialog.bind(this),
          title: this.props.title,
          className: 'reception-dialog delete-dialog wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'p',
            { className: 'reception-dialog-text' },
            this.props.content
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom col-100' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              'Kh\xF4ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-green', onClick: this.onSuccess.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u1ED3ng \xFD'
            )
          )
        )
      );
    }
  }]);

  return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.defaultProps = {
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function onSuccess() {
    console.log('Need to assign onSuccess method');
  },
  onClose: function onClose() {
    console.log('Need to assign onClose method');
  }
};

exports.default = ConfirmDialog;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(80);
var ContentStateInlineStyle = __webpack_require__(1913);
var DraftFeatureFlags = __webpack_require__(135);
var Immutable = __webpack_require__(35);

var applyEntityToContentState = __webpack_require__(1932);
var getCharacterRemovalRange = __webpack_require__(1953);
var getContentStateFragment = __webpack_require__(268);
var insertFragmentIntoContentState = __webpack_require__(1958);
var insertTextIntoContentState = __webpack_require__(1959);
var invariant = __webpack_require__(21);
var modifyBlockForContentState = __webpack_require__(1970);
var removeEntitiesAtEdges = __webpack_require__(611);
var removeRangeFromContentState = __webpack_require__(1972);
var splitBlockInContentState = __webpack_require__(1974);

var OrderedSet = Immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);

    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });

    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);

    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);

    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};

module.exports = DraftModifier;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(53);
var createDesc = __webpack_require__(149);
module.exports = __webpack_require__(48) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var hide = __webpack_require__(77);
var has = __webpack_require__(84);
var SRC = __webpack_require__(153)('src');
var $toString = __webpack_require__(1606);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(94).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var fails = __webpack_require__(34);
var defined = __webpack_require__(103);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(35),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__ = __webpack_require__(228);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(/\s+/) : [];
    var wordsWithComputedWidth = words.map(function (word) {
      return { word: word, width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])(word, props.style).width };
    });

    var spaceWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])('\xA0', props.style).width;

    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
  } catch (e) {
    return null;
  }
};

var Text = (_temp2 = _class = function (_Component) {
  _inherits(Text, _Component);

  function Text() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      wordsByLines: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Text, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWordsByLines(this.props, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
      this.updateWordsByLines(nextProps, needCalculate);
    }
  }, {
    key: 'updateWordsByLines',
    value: function updateWordsByLines(props, needCalculate) {
      // Only perform calculations if using features that require them (multiline, scaleToFit)
      if ((props.width || props.scaleToFit) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["h" /* isSsr */])()) {
        if (needCalculate) {
          var wordWidths = calculateWordWidths(props);

          if (wordWidths) {
            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
                spaceWidth = wordWidths.spaceWidth;


            this.wordsWithComputedWidth = wordsWithComputedWidth;
            this.spaceWidth = spaceWidth;
          } else {
            this.updateWordsWithoutCalculate(props);

            return;
          }
        }

        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
        this.setState({ wordsByLines: wordsByLines });
      } else {
        this.updateWordsWithoutCalculate(props);
      }
    }
  }, {
    key: 'updateWordsWithoutCalculate',
    value: function updateWordsWithoutCalculate(props) {
      var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(/\s+/) : [];
      this.setState({ wordsByLines: [{ words: words }] });
    }
  }, {
    key: 'calculateWordsByLines',
    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
      var scaleToFit = this.props.scaleToFit;

      return wordsWithComputedWidth.reduce(function (result, _ref2) {
        var word = _ref2.word,
            width = _ref2.width;

        var currentLine = result[result.length - 1];

        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
          // Word can be added to an existing line
          currentLine.words.push(word);
          currentLine.width += width + spaceWidth;
        } else {
          // Add first word to line or word is too long to scaleToFit on existing line
          var newLine = { words: [word], width: width };
          result.push(newLine);
        }

        return result;
      }, []);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dx = _props.dx,
          dy = _props.dy,
          textAnchor = _props.textAnchor,
          verticalAnchor = _props.verticalAnchor,
          scaleToFit = _props.scaleToFit,
          angle = _props.angle,
          lineHeight = _props.lineHeight,
          capHeight = _props.capHeight,
          className = _props.className,
          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);

      var wordsByLines = this.state.wordsByLines;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["k" /* isNumOrStr */])(textProps.x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["k" /* isNumOrStr */])(textProps.y)) {
        return null;
      }
      var x = textProps.x + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["j" /* isNumber */])(dx) ? dx : 0);
      var y = textProps.y + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["j" /* isNumber */])(dy) ? dy : 0);

      var startDy = void 0;
      switch (verticalAnchor) {
        case 'start':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + capHeight + ')');
          break;
        case 'middle':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
          break;
        default:
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
          break;
      }

      var transforms = [];
      if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        transforms.push('scale(' + this.props.width / lineWidth + ')');
      }
      if (angle) {
        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
      }
      if (transforms.length) {
        textProps.transform = transforms.join(' ');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'text',
        _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(textProps), {
          x: x,
          y: y,
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-text', className),
          textAnchor: textAnchor
        }),
        wordsByLines.map(function (line, index) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tspan',
            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
            line.words.join(' ')
          );
        })
      );
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  scaleToFit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  textAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  verticalAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end']),
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}), _class.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em', // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' }, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(470);
var isBuffer = __webpack_require__(2031);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(202);
var createDesc = __webpack_require__(149);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(105);
var has = __webpack_require__(84);
var IE8_DOM_DEFINE = __webpack_require__(517);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(48) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(84);
var toObject = __webpack_require__(58);
var IE_PROTO = __webpack_require__(342)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(201);
var defined = __webpack_require__(103);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(80);
var Immutable = __webpack_require__(35);

var findRangesImmutable = __webpack_require__(213);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;

var _Animate = __webpack_require__(837);

var _Animate2 = _interopRequireDefault(_Animate);

var _easing = __webpack_require__(838);

var _util = __webpack_require__(289);

var _AnimateGroup = __webpack_require__(2279);

var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.configSpring = _easing.configSpring;
exports.configBezier = _easing.configBezier;
exports.AnimateGroup = _AnimateGroup2.default;
exports.translateStyle = _util.translateStyle;
exports.default = _Animate2.default;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DefaultTooltipContent__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PureRender__ = __webpack_require__(28);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Tooltip
 */









var EPS = 1;

var propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  viewBox: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  separator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  offset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,

  itemStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  cursor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]),

  coordinate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
  })),

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  itemSorter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  active: false,
  offset: 10,
  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
  coordinate: { x: 0, y: 0 },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["h" /* isSsr */])(),
  animationEasing: 'ease',
  animationDuration: 400,
  itemSorter: function itemSorter() {
    return -1;
  }
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(content, props);
  } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DefaultTooltipContent__["a" /* default */], props);
};

var Tooltip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: 'updateBBox',
    value: function updateBBox() {
      var _state = this.state,
          boxWidth = _state.boxWidth,
          boxHeight = _state.boxHeight;


      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          payload = _props.payload,
          isAnimationActive = _props.isAnimationActive,
          animationDuration = _props.animationDuration,
          animationEasing = _props.animationEasing;

      var hasPayload = payload && payload.length && payload.filter(function (entry) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry.value);
      }).length;
      var _props2 = this.props,
          content = _props2.content,
          viewBox = _props2.viewBox,
          coordinate = _props2.coordinate,
          position = _props2.position,
          active = _props2.active,
          offset = _props2.offset,
          wrapperStyle = _props2.wrapperStyle;

      var outerStyle = _extends({
        pointerEvents: 'none',
        visibility: active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0
      }, wrapperStyle);
      var translateX = void 0,
          translateY = void 0;

      if (position && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["j" /* isNumber */])(position.x) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["j" /* isNumber */])(position.y)) {
        translateX = position.x;
        translateY = position.y;
      } else {
        var _state2 = this.state,
            boxWidth = _state2.boxWidth,
            boxHeight = _state2.boxHeight;


        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
          translateX = position && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["j" /* isNumber */])(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);

          translateY = position && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["j" /* isNumber */])(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
        } else {
          outerStyle.visibility = 'hidden';
        }
      }

      outerStyle = _extends({}, outerStyle, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["translateStyle"])({
        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
      }));

      if (isAnimationActive && active) {
        outerStyle = _extends({}, outerStyle, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["translateStyle"])({
          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: 'recharts-tooltip-wrapper',
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        },
        renderContent(content, this.props)
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Classes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstractComponent__ = __webpack_require__(65);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__abstractComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(880);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__colors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intent__ = __webpack_require__(441);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__intent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__position__ = __webpack_require__(109);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__position__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__position__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__position__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__props__ = __webpack_require__(164);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__props__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tetherUtils__ = __webpack_require__(442);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__tetherUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__tetherUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__tetherUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__tetherUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generated_iconClasses__ = __webpack_require__(920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__generated_iconClasses__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__generated_iconStrings__ = __webpack_require__(921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__generated_iconStrings__["a"]; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var Classes = __WEBPACK_IMPORTED_MODULE_6__classes__;
var Keys = __WEBPACK_IMPORTED_MODULE_7__keys__;
var Utils = __WEBPACK_IMPORTED_MODULE_8__utils__;
// NOTE: Errors is not exported in public API




/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhiemVuTTXM = function (_React$Component) {
  _inherits(NhiemVuTTXM, _React$Component);

  function NhiemVuTTXM() {
    _classCallCheck(this, NhiemVuTTXM);

    return _possibleConstructorReturn(this, (NhiemVuTTXM.__proto__ || Object.getPrototypeOf(NhiemVuTTXM)).apply(this, arguments));
  }

  _createClass(NhiemVuTTXM, [{
    key: 'render',
    value: function render() {
      var ngayChuyen = this.props.ngayBatDauTTXM ? (0, _moment2.default)(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : '';
      var tgBaoCao = this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
      var yKien = this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : '';
      if (this.props.donInfo.laTTXMLai) {
        tgBaoCao = this.props.donInfo.ngayHetHanGiaiQuyetLanDau ? (0, _moment2.default)(this.props.donInfo.ngayHetHanGiaiQuyetLanDau).format('DD/MM/YYYY') : '';
        ngayChuyen = this.props.donInfo.ngayBatDauTTXMLanDau ? (0, _moment2.default)(this.props.donInfo.ngayBatDauTTXMLanDau).format('DD/MM/YYYY') : '';
        yKien = this.props.donInfo.noiDungYeuCauTTXMLanDau || '';
      }
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Nhi\u1EC7m v\u1EE5 th\u1EA9m tra x\xE1c minh',
          lb2
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mb15' },
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y chuy\u1EC3n:', value: ngayChuyen }),
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Đơn vị giao ' + lb1 + ':', value: this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: tgBaoCao })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: "Ý kiến của đơn vị giao " + lb1 + ":", value: yKien })
          )
        ),
        this.props.donInfo.laTTXMLai ? _react2.default.createElement(
          'div',
          { className: 'mt15 mb10' },
          _react2.default.createElement(
            'div',
            { className: 'pt5 pb15' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Nhi\u1EC7m v\u1EE5 th\u1EA9m tra x\xE1c minh',
            lb2,
            ' l\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mb15' },
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y chuy\u1EC3n:', value: this.props.ngayBatDauTTXM ? (0, _moment2.default)(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: "Đơn vị giao " + lb1 + ":", value: this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: "Ý kiến của đơn vị giao " + lb1 + ":", value: this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : '' })
            )
          )
        ) : ''
      );
    }
  }]);

  return NhiemVuTTXM;
}(_react2.default.Component);

NhiemVuTTXM.defaultProps = {
  donViGiaoThamTraXacMinh: {
    ten: ''
  },
  ngayHetHanTTXM: '',
  yKienCuaDonViGiaoTTXM: '',
  ngayBatDauTTXM: '',
  donInfo: {}
};

exports.default = NhiemVuTTXM;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(68);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(34);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTimKiemNangCao = exports.InputTuKhoa = undefined;

var _inputTukhoa = __webpack_require__(1313);

var _inputTukhoa2 = _interopRequireDefault(_inputTukhoa);

var _formNangcao = __webpack_require__(1312);

var _formNangcao2 = _interopRequireDefault(_formNangcao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.InputTuKhoa = _inputTukhoa2.default;
exports.FormTimKiemNangCao = _formNangcao2.default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChinhSuaCuocThanhTra = exports.ChiTietCuocThanhTra = exports.ThemMoiCuocThanhTra = exports.ChiTietDoiTuongTrung = exports.DanhSachDoiTuongTrung = exports.DanhSachCuocThanhTra = exports.ThemMoiKeHoachThanhTra = exports.DanhSachKeHoachThanhTraDaPheDuyet = exports.DanhSachKeHoachThanhTra = undefined;

var _DanhSachKeHoachThanhTra = __webpack_require__(1345);

var _DanhSachKeHoachThanhTra2 = _interopRequireDefault(_DanhSachKeHoachThanhTra);

var _DanhSachKeHoachThanhTraDaPheDuyet = __webpack_require__(1346);

var _DanhSachKeHoachThanhTraDaPheDuyet2 = _interopRequireDefault(_DanhSachKeHoachThanhTraDaPheDuyet);

var _ThemMoiKeHoachThanhTra = __webpack_require__(493);

var _ThemMoiKeHoachThanhTra2 = _interopRequireDefault(_ThemMoiKeHoachThanhTra);

var _DanhSachCuocThanhTra = __webpack_require__(1343);

var _DanhSachCuocThanhTra2 = _interopRequireDefault(_DanhSachCuocThanhTra);

var _DanhSachDoiTuongTrung = __webpack_require__(1344);

var _DanhSachDoiTuongTrung2 = _interopRequireDefault(_DanhSachDoiTuongTrung);

var _ChiTietDoiTuongTrung = __webpack_require__(492);

var _ChiTietDoiTuongTrung2 = _interopRequireDefault(_ChiTietDoiTuongTrung);

var _ThemMoiCuocThanhTra = __webpack_require__(1347);

var _ThemMoiCuocThanhTra2 = _interopRequireDefault(_ThemMoiCuocThanhTra);

var _ChiTietCuocThanhTra = __webpack_require__(1341);

var _ChiTietCuocThanhTra2 = _interopRequireDefault(_ChiTietCuocThanhTra);

var _ChinhSuaCuocThanhTra = __webpack_require__(1342);

var _ChinhSuaCuocThanhTra2 = _interopRequireDefault(_ChinhSuaCuocThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhSachKeHoachThanhTra = _DanhSachKeHoachThanhTra2.default;
exports.DanhSachKeHoachThanhTraDaPheDuyet = _DanhSachKeHoachThanhTraDaPheDuyet2.default;
exports.ThemMoiKeHoachThanhTra = _ThemMoiKeHoachThanhTra2.default;
exports.DanhSachCuocThanhTra = _DanhSachCuocThanhTra2.default;
exports.DanhSachDoiTuongTrung = _DanhSachDoiTuongTrung2.default;
exports.ChiTietDoiTuongTrung = _ChiTietDoiTuongTrung2.default;
exports.ThemMoiCuocThanhTra = _ThemMoiCuocThanhTra2.default;
exports.ChiTietCuocThanhTra = _ChiTietCuocThanhTra2.default;
exports.ChinhSuaCuocThanhTra = _ChinhSuaCuocThanhTra2.default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(95);
var IObject = __webpack_require__(201);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(45);
var asc = __webpack_require__(326);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(94);
var fails = __webpack_require__(34);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(36);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var UserAgentData = __webpack_require__(1986);
var VersionRange = __webpack_require__(1987);

var mapObject = __webpack_require__(2000);
var memoizeStringOnly = __webpack_require__(622);

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};

module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(644);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var CallbackQueue = __webpack_require__(800);
var PooledClass = __webpack_require__(160);
var ReactFeatureFlags = __webpack_require__(805);
var ReactReconciler = __webpack_require__(184);
var Transaction = __webpack_require__(285);

var invariant = __webpack_require__(21);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Position; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isPositionHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = isPositionVertical;
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var Position;
(function (Position) {
    Position[Position["TOP_LEFT"] = 0] = "TOP_LEFT";
    Position[Position["TOP"] = 1] = "TOP";
    Position[Position["TOP_RIGHT"] = 2] = "TOP_RIGHT";
    Position[Position["RIGHT_TOP"] = 3] = "RIGHT_TOP";
    Position[Position["RIGHT"] = 4] = "RIGHT";
    Position[Position["RIGHT_BOTTOM"] = 5] = "RIGHT_BOTTOM";
    Position[Position["BOTTOM_RIGHT"] = 6] = "BOTTOM_RIGHT";
    Position[Position["BOTTOM"] = 7] = "BOTTOM";
    Position[Position["BOTTOM_LEFT"] = 8] = "BOTTOM_LEFT";
    Position[Position["LEFT_BOTTOM"] = 9] = "LEFT_BOTTOM";
    Position[Position["LEFT"] = 10] = "LEFT";
    Position[Position["LEFT_TOP"] = 11] = "LEFT_TOP";
})(Position || (Position = {}));
function isPositionHorizontal(position) {
    /* istanbul ignore next */
    return (position === Position.TOP ||
        position === Position.TOP_LEFT ||
        position === Position.TOP_RIGHT ||
        position === Position.BOTTOM ||
        position === Position.BOTTOM_LEFT ||
        position === Position.BOTTOM_RIGHT);
}
function isPositionVertical(position) {
    /* istanbul ignore next */
    return (position === Position.LEFT ||
        position === Position.LEFT_TOP ||
        position === Position.LEFT_BOTTOM ||
        position === Position.RIGHT ||
        position === Position.RIGHT_TOP ||
        position === Position.RIGHT_BOTTOM);
}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListHistoryDetailRowItem = exports.RowItemDanhSachDoanDongNguoi = exports.ListHistoryRowItem = exports.ListAttachTaiLieuRowItem = exports.ListTaiLieuRowItem = exports.DetailTaiLieuRowItem = undefined;

var _DetailTaiLieuRowItem = __webpack_require__(1104);

var _DetailTaiLieuRowItem2 = _interopRequireDefault(_DetailTaiLieuRowItem);

var _ListTaiLieuRowItem = __webpack_require__(1108);

var _ListTaiLieuRowItem2 = _interopRequireDefault(_ListTaiLieuRowItem);

var _ListAttachTaiLieuRowItem = __webpack_require__(1105);

var _ListAttachTaiLieuRowItem2 = _interopRequireDefault(_ListAttachTaiLieuRowItem);

var _ListHistoryRowItem = __webpack_require__(1107);

var _ListHistoryRowItem2 = _interopRequireDefault(_ListHistoryRowItem);

var _RowItemDanhSachDoanDongNguoi = __webpack_require__(1109);

var _RowItemDanhSachDoanDongNguoi2 = _interopRequireDefault(_RowItemDanhSachDoanDongNguoi);

var _ListHistoryDetailRowItem = __webpack_require__(1106);

var _ListHistoryDetailRowItem2 = _interopRequireDefault(_ListHistoryDetailRowItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DetailTaiLieuRowItem = _DetailTaiLieuRowItem2.default;
exports.ListTaiLieuRowItem = _ListTaiLieuRowItem2.default;
exports.ListAttachTaiLieuRowItem = _ListAttachTaiLieuRowItem2.default;
exports.ListHistoryRowItem = _ListHistoryRowItem2.default;
exports.RowItemDanhSachDoanDongNguoi = _RowItemDanhSachDoanDongNguoi2.default;
exports.ListHistoryDetailRowItem = _ListHistoryDetailRowItem2.default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CheckQuyenThaoTacXuLy = function CheckQuyenThaoTacXuLy(canBoDangXuLyInfo) {

  var check = false;

  if (canBoDangXuLyInfo && localStorage.getItem('userInfo')) {

    var data = JSON.parse(localStorage.getItem('userInfo'));

    canBoDangXuLyInfo.map(function (item, i) {
      if (item.donViId == data.donViId) {

        if (item.congChucId) {
          if (item.congChucId == data.id) {
            check = true;
          } else {
            check = false;
          }
        } else {
          check = true;
        }
      }
    });
  }
  return check;
};

exports.CheckQuyenThaoTacXuLy = CheckQuyenThaoTacXuLy;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFile = downloadFile;

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadFile(url) {
  var accessToken = _reactCookie2.default.load('accessToken');
  fetch('' + url, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
      'Origin': '*'
    }
  }).then(function (response) {
    var fileName = response.headers.get('content-disposition').split('filename=')[1].replace('"', '').replace('"', '');
    response.blob().then(function (blob) {
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
  }).catch(function (error) {
    console.error("Error: " + error);
  });
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportExcel = exportExcel;

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exportExcel(url, name) {
  _axios2.default.get(url, {
    headers: {
      "Content-Type": "application/octet-stream",
      "Accept": "application/octet-stream"
    },
    responseType: "blob"
  }).then(function (response) {
    var a = document.createElement("a");
    var url = window.URL.createObjectURL(response.data);
    a.href = url;
    a.download = name;
    a.click();
  }).catch(function (err) {
    console.error("error", err);
  });
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(539);
var $export = __webpack_require__(8);
var shared = __webpack_require__(203)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(543))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(48)) {
  var LIBRARY = __webpack_require__(132);
  var global = __webpack_require__(30);
  var fails = __webpack_require__(34);
  var $export = __webpack_require__(8);
  var $typed = __webpack_require__(253);
  var $buffer = __webpack_require__(347);
  var ctx = __webpack_require__(95);
  var anInstance = __webpack_require__(144);
  var propertyDesc = __webpack_require__(149);
  var hide = __webpack_require__(77);
  var redefineAll = __webpack_require__(150);
  var toInteger = __webpack_require__(97);
  var toLength = __webpack_require__(45);
  var toIndex = __webpack_require__(537);
  var toAbsoluteIndex = __webpack_require__(152);
  var toPrimitive = __webpack_require__(105);
  var has = __webpack_require__(84);
  var classof = __webpack_require__(171);
  var isObject = __webpack_require__(36);
  var toObject = __webpack_require__(58);
  var isArrayIter = __webpack_require__(333);
  var create = __webpack_require__(146);
  var getPrototypeOf = __webpack_require__(86);
  var gOPN = __webpack_require__(147).f;
  var getIterFn = __webpack_require__(349);
  var uid = __webpack_require__(153);
  var wks = __webpack_require__(43);
  var createArrayMethod = __webpack_require__(102);
  var createArrayIncludes = __webpack_require__(241);
  var speciesConstructor = __webpack_require__(204);
  var ArrayIterators = __webpack_require__(350);
  var Iterators = __webpack_require__(172);
  var $iterDetect = __webpack_require__(246);
  var setSpecies = __webpack_require__(151);
  var arrayFill = __webpack_require__(325);
  var arrayCopyWithin = __webpack_require__(509);
  var $DP = __webpack_require__(53);
  var $GOPD = __webpack_require__(85);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(1802);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(1803);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(548);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(549);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(1804);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(1814);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(1815);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(553);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(1806);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(1807);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(1808);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(1809);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(550);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(551);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(1810);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(1811);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(1812);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(1813);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* unused harmony reexport tickIncrement */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(555);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(556);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(1816);
/* unused harmony reexport zip */





























/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var PooledClass = __webpack_require__(160);

var emptyFunction = __webpack_require__(71);
var warning = __webpack_require__(37);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @fileOverview Surface
 */





var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  viewBox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};
function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);

  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-surface', className);
  var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({}, attrs, {
      className: layerClass,
      width: width,
      height: height,
      style: style,
      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
      version: '1.1'
    }),
    children
  );
}

Surface.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Surface);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RADIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polarToCartesian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMaxRadius; });
var RADIAN = Math.PI / 180;

var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN * angle) * radius,
    y: cy + Math.sin(-RADIAN * angle) * radius
  };
};

var getMaxRadius = function getMaxRadius(width, height) {
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0, right: 0, bottom: 0, left: 0
  };
  return Math.min(Math.abs(width - (margin.left || 0) - (margin.right || 0)), Math.abs(height - (margin.left || 0) - (margin.right || 0))) / 2;
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKSPACE", function() { return BACKSPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIFT", function() { return SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ESCAPE", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPACE", function() { return SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_LEFT", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_UP", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_RIGHT", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_DOWN", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE", function() { return DELETE; });
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var BACKSPACE = 8;
var TAB = 9;
var ENTER = 13;
var SHIFT = 16;
var ESCAPE = 27;
var SPACE = 32;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;
var DELETE = 46;


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Icon = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon_1 = Icon;
    Icon.prototype.render = function () {
        if (this.props.iconName == null) {
            return null;
        }
        var _a = this.props, className = _a.className, iconName = _a.iconName, intent = _a.intent, _b = _a.iconSize, iconSize = _b === void 0 ? Icon_1.SIZE_STANDARD : _b, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "iconName", "intent", "iconSize"]);
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(getSizeClass(iconSize), __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].iconClass(iconName), __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].intentClass(intent), className);
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: classes }, restProps));
    };
    Icon.displayName = "Blueprint.Icon";
    Icon.SIZE_STANDARD = 16;
    Icon.SIZE_LARGE = 20;
    Icon.SIZE_INHERIT = "inherit";
    Icon = Icon_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Icon);
    return Icon;
    var Icon_1;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

// NOTE: not using a type alias here so the full union will appear in the interface docs
function getSizeClass(size) {
    switch (size) {
        case Icon.SIZE_STANDARD:
            return __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].ICON_STANDARD;
        case Icon.SIZE_LARGE:
            return __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].ICON_LARGE;
        default:
            return __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].ICON;
    }
}


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSort = undefined;

var _formSort = __webpack_require__(1311);

var _formSort2 = _interopRequireDefault(_formSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FormSort = _formSort2.default;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TinhTrangDon = exports.CanBoNhanKetQuaKiemTraDeXuat = exports.KetQuaTiepCongDan = exports.ThongTinTiepCongDan = exports.ThongTinCaNhan = exports.ThongTinUyQuyen = exports.ThongTinNguoiDungDon = exports.ThongTinDon = exports.ThongTinDoiTuongBiKhieuTo = exports.ThemThanhVienDoan = exports.DetailReception = exports.ListReception = exports.AddReception = exports.AttachmentsFilePopup = exports.ListGroupTypeReception = exports.SearchReception = exports.ListInfoDocumentDialog = exports.SearchListCase = exports.SearchFullNamePopup = undefined;

var _addReception = __webpack_require__(1299);

var _listReception = __webpack_require__(1315);

var _detailReception = __webpack_require__(1310);

var _ThongTinUyQuyen = __webpack_require__(1291);

var _ThongTinUyQuyen2 = _interopRequireDefault(_ThongTinUyQuyen);

var _ThongTinCaNhan = __webpack_require__(488);

var _ThongTinCaNhan2 = _interopRequireDefault(_ThongTinCaNhan);

var _ThongTinTiepCongDan = __webpack_require__(1290);

var _ThongTinTiepCongDan2 = _interopRequireDefault(_ThongTinTiepCongDan);

var _KetQuaTiepCongDan = __webpack_require__(1287);

var _KetQuaTiepCongDan2 = _interopRequireDefault(_KetQuaTiepCongDan);

var _CanBoNhanKetQuaKiemTraDeXuat = __webpack_require__(1285);

var _CanBoNhanKetQuaKiemTraDeXuat2 = _interopRequireDefault(_CanBoNhanKetQuaKiemTraDeXuat);

var _TinhTrangDon = __webpack_require__(1293);

var _TinhTrangDon2 = _interopRequireDefault(_TinhTrangDon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*------------------------list reception-------------------------*/
exports.SearchFullNamePopup = _addReception.SearchFullNamePopup;
exports.SearchListCase = _addReception.SearchListCase;
exports.ListInfoDocumentDialog = _addReception.ListInfoDocumentDialog;
exports.SearchReception = _listReception.SearchReception;
exports.ListGroupTypeReception = _addReception.ListGroupTypeReception;
exports.AttachmentsFilePopup = _addReception.AttachmentsFilePopup;
exports.AddReception = _addReception.AddReception;
exports.ListReception = _listReception.ListReception;
exports.DetailReception = _detailReception.DetailReception;
exports.ThemThanhVienDoan = _addReception.ThemThanhVienDoan;
exports.ThongTinDoiTuongBiKhieuTo = _addReception.ThongTinDoiTuongBiKhieuTo;
exports.ThongTinDon = _addReception.ThongTinDon;
exports.ThongTinNguoiDungDon = _addReception.ThongTinNguoiDungDon;
exports.ThongTinUyQuyen = _ThongTinUyQuyen2.default;
exports.ThongTinCaNhan = _ThongTinCaNhan2.default;
exports.ThongTinTiepCongDan = _ThongTinTiepCongDan2.default;
exports.KetQuaTiepCongDan = _KetQuaTiepCongDan2.default;
exports.CanBoNhanKetQuaKiemTraDeXuat = _CanBoNhanKetQuaKiemTraDeXuat2.default;
exports.TinhTrangDon = _TinhTrangDon2.default;
/*------------------------detail reception-------------------------*/
/*------------------------add reception-------------------------*/

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemDSThongBao = exports.RowItemLichSuXuLy = exports.RowItemDSTongHopKHTTDonVi = exports.RowItemChiTietNoiDungTTT = exports.RowItemDanhMucCuocThanhTra = exports.RowItemXuLyThanhTraTrung = exports.RowItemDanhMucTongHopThanhTra = exports.RowItemDanhMucCuocThanhTraTrung = undefined;

var _RowItemDanhMucCuocThanhTraTrung = __webpack_require__(1337);

var _RowItemDanhMucCuocThanhTraTrung2 = _interopRequireDefault(_RowItemDanhMucCuocThanhTraTrung);

var _RowItemDanhMucTongHopThanhTra = __webpack_require__(1338);

var _RowItemDanhMucTongHopThanhTra2 = _interopRequireDefault(_RowItemDanhMucTongHopThanhTra);

var _RowItemXuLyThanhTraTrung = __webpack_require__(1340);

var _RowItemXuLyThanhTraTrung2 = _interopRequireDefault(_RowItemXuLyThanhTraTrung);

var _RowItemDanhMucCuocThanhTra = __webpack_require__(1336);

var _RowItemDanhMucCuocThanhTra2 = _interopRequireDefault(_RowItemDanhMucCuocThanhTra);

var _RowItemChiTietNoiDungTTT = __webpack_require__(1333);

var _RowItemChiTietNoiDungTTT2 = _interopRequireDefault(_RowItemChiTietNoiDungTTT);

var _RowItemDSTongHopKHTTDonVi = __webpack_require__(1335);

var _RowItemDSTongHopKHTTDonVi2 = _interopRequireDefault(_RowItemDSTongHopKHTTDonVi);

var _RowItemLichSuXuLy = __webpack_require__(1339);

var _RowItemLichSuXuLy2 = _interopRequireDefault(_RowItemLichSuXuLy);

var _RowItemDSThongBao = __webpack_require__(1334);

var _RowItemDSThongBao2 = _interopRequireDefault(_RowItemDSThongBao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemDanhMucCuocThanhTraTrung = _RowItemDanhMucCuocThanhTraTrung2.default;
exports.RowItemDanhMucTongHopThanhTra = _RowItemDanhMucTongHopThanhTra2.default;
exports.RowItemXuLyThanhTraTrung = _RowItemXuLyThanhTraTrung2.default;
exports.RowItemDanhMucCuocThanhTra = _RowItemDanhMucCuocThanhTra2.default;
exports.RowItemChiTietNoiDungTTT = _RowItemChiTietNoiDungTTT2.default;
exports.RowItemDSTongHopKHTTDonVi = _RowItemDSTongHopKHTTDonVi2.default;
exports.RowItemLichSuXuLy = _RowItemLichSuXuLy2.default;
exports.RowItemDSThongBao = _RowItemDSThongBao2.default;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(43)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(77)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(153)('meta');
var isObject = __webpack_require__(36);
var has = __webpack_require__(84);
var setDesc = __webpack_require__(53).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(34)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(1824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(1823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });





/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(1924);

module.exports = DraftFeatureFlags;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120), __webpack_require__(56)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    getRawTag = __webpack_require__(2096),
    objectToString = __webpack_require__(2124);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Dot
 */






var Dot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Dot, _Component);

  function Dot() {
    _classCallCheck(this, Dot);

    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
  }

  _createClass(Dot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          r = _props.r,
          className = _props.className;

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-dot', className);

      if (cx === +cx && cy === +cy && r === +r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          cx: cx,
          cy: cy,
          r: r
        }));
      }

      return null;
    }
  }]);

  return Dot;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Dot', _class2.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Dot);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TuGiaiQuyetDon = exports.XuLyGiaiQuyetDon = exports.ListGiaiQuyetDon = undefined;

var _ListGiaiQuyetDon = __webpack_require__(1101);

var _ListGiaiQuyetDon2 = _interopRequireDefault(_ListGiaiQuyetDon);

var _XuLyGiaiQuyetDon = __webpack_require__(1103);

var _XuLyGiaiQuyetDon2 = _interopRequireDefault(_XuLyGiaiQuyetDon);

var _TuGiaiQuyetDon = __webpack_require__(1102);

var _TuGiaiQuyetDon2 = _interopRequireDefault(_TuGiaiQuyetDon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ListGiaiQuyetDon = _ListGiaiQuyetDon2.default;
exports.XuLyGiaiQuyetDon = _XuLyGiaiQuyetDon2.default;
exports.TuGiaiQuyetDon = _TuGiaiQuyetDon2.default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TongHop = exports.HandleLetters = exports.HandleLettersDetails = exports.AddHandleLetter = undefined;

var _addHandleLetters = __webpack_require__(1156);

var _listHandleLetters = __webpack_require__(1167);

var _detailHandleLetters = __webpack_require__(1160);

var _tongHop = __webpack_require__(1169);

/*-----------------------detail handle letters------------------------*/
/*------------------------add handle letters-------------------------*/
exports.AddHandleLetter = _addHandleLetters.AddHandleLetter;
exports.HandleLettersDetails = _detailHandleLetters.HandleLettersDetails;
exports.HandleLetters = _listHandleLetters.HandleLetters;
exports.TongHop = _tongHop.TongHop;

/*------------------------list handle letters-------------------------*/

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(95);
var call = __webpack_require__(520);
var isArrayIter = __webpack_require__(333);
var anObject = __webpack_require__(27);
var toLength = __webpack_require__(45);
var getIterFn = __webpack_require__(349);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(27);
var dPs = __webpack_require__(526);
var enumBugKeys = __webpack_require__(329);
var IE_PROTO = __webpack_require__(342)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(328)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(331).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(528);
var hiddenKeys = __webpack_require__(329).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(528);
var enumBugKeys = __webpack_require__(329);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(78);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var dP = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(48);
var SPECIES = __webpack_require__(43)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(97);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(80);
var Immutable = __webpack_require__(35);

var findRangesImmutable = __webpack_require__(213);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};

var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck(this, ContentBlock);

    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */



var invariant = __webpack_require__(21);

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

module.exports = UnicodeUtils;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(2022)();
var hasProto = __webpack_require__(2021)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(380);
var hasOwn = __webpack_require__(2024);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2066),
    getValue = __webpack_require__(2099);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Legend
 */








var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(content, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__["a" /* default */], props);
};

var EPS = 1;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["m" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var Legend = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Legend, _Component);

  function Legend() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Legend);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Legend, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: 'getBBox',
    value: function getBBox() {
      var _state = this.state,
          boxWidth = _state.boxWidth,
          boxHeight = _state.boxHeight;


      if (boxWidth >= 0 && boxHeight >= 0) {
        return { width: boxWidth, height: boxHeight };
      }

      return null;
    }
  }, {
    key: 'getDefaultPosition',
    value: function getDefaultPosition(style) {
      var _props = this.props,
          layout = _props.layout,
          align = _props.align,
          verticalAlign = _props.verticalAlign,
          margin = _props.margin,
          chartWidth = _props.chartWidth,
          chartHeight = _props.chartHeight;

      var hPos = void 0,
          vPos = void 0;

      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var box = this.getBBox() || { width: 0 };
          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
        } else {
          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
        }
      }

      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box = this.getBBox() || { height: 0 };
          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
        } else {
          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
        }
      }

      return _extends({}, hPos, vPos);
    }
  }, {
    key: 'updateBBox',
    value: function updateBBox() {
      var _this2 = this;

      var _state2 = this.state,
          boxWidth = _state2.boxWidth,
          boxHeight = _state2.boxHeight;
      var onBBoxUpdate = this.props.onBBoxUpdate;


      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        (function () {
          var box = _this2.wrapperNode.getBoundingClientRect();

          if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
            _this2.setState({
              boxWidth: box.width,
              boxHeight: box.height
            }, function () {
              if (onBBoxUpdate) {
                onBBoxUpdate(box);
              }
            });
          }
        })();
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function () {
          if (onBBoxUpdate) {
            onBBoxUpdate(null);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          content = _props2.content,
          width = _props2.width,
          height = _props2.height,
          wrapperStyle = _props2.wrapperStyle;

      var outerStyle = _extends({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: 'recharts-legend-wrapper',
          style: outerStyle,
          ref: function ref(node) {
            _this3.wrapperNode = node;
          }
        },
        renderContent(content, this.props)
      );
    }
  }], [{
    key: 'getWithHeight',
    value: function getWithHeight(item, chartWidth) {
      var layout = item.props.layout;


      if (layout === 'vertical' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["j" /* isNumber */])(item.props.height)) {
        return {
          height: item.props.height
        };
      } else if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }

      return null;
    }
  }]);

  return Legend;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Legend', _class2.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  iconSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  margin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  payload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["m" /* LEGEND_TYPES */])
  })),
  formatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onBBoxUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class2.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Legend);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(32);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Curve
 */









var CURVE_FACTORIES = {
  curveBasisClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["o" /* curveBasisClosed */], curveBasisOpen: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["p" /* curveBasisOpen */], curveBasis: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["q" /* curveBasis */], curveLinearClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["r" /* curveLinearClosed */], curveLinear: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["s" /* curveLinear */],
  curveMonotoneX: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["t" /* curveMonotoneX */], curveMonotoneY: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["u" /* curveMonotoneY */], curveNatural: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["v" /* curveNatural */], curveStep: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["w" /* curveStep */], curveStepAfter: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["x" /* curveStepAfter */],
  curveStepBefore: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["y" /* curveStepBefore */]
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
  return p.x;
};
var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(type)) {
    return type;
  }

  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
  }
  return CURVE_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_4_d3_shape__["s" /* curveLinear */];
};

var Curve = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Curve, _Component);

  function Curve() {
    _classCallCheck(this, Curve);

    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
  }

  _createClass(Curve, [{
    key: 'getPath',

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _props = this.props,
          type = _props.type,
          points = _props.points,
          baseLine = _props.baseLine,
          layout = _props.layout,
          connectNulls = _props.connectNulls;

      var curveFactory = getCurveFactory(type, layout);
      var formatPoints = connectNulls ? points.filter(function (entry) {
        return defined(entry);
      }) : points;
      var lineFunction = void 0;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(baseLine)) {
        var areaPoints = formatPoints.map(function (entry, index) {
          return _extends({}, entry, { base: baseLine[index] });
        });
        if (layout === 'vertical') {
          lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["z" /* area */])().y(getY).x1(getX).x0(function (d) {
            return d.base.x;
          });
        } else {
          lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["z" /* area */])().x(getX).y1(getY).y0(function (d) {
            return d.base.y;
          });
        }
        lineFunction.defined(defined).curve(curveFactory);

        return lineFunction(areaPoints);
      } else if (layout === 'vertical' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* isNumber */])(baseLine)) {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["z" /* area */])().y(getY).x1(getX).x0(baseLine);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* isNumber */])(baseLine)) {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["z" /* area */])().x(getX).y1(getY).y0(baseLine);
      } else {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["A" /* line */])().x(getX).y(getY);
      }

      lineFunction.defined(defined).curve(curveFactory);

      return lineFunction(formatPoints);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          points = _props2.points,
          pathRef = _props2.pathRef;


      if (!points || !points.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-curve', className),
        d: this.getPath(),
        ref: pathRef
      }));
    }
  }]);

  return Curve;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  connectNulls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  pathRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
}), _class2.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Curve);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Rectangle
 */







var getRectangePath = function getRectangePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var sign = height >= 0 ? 1 : -1;
  var clockWise = height >= 0 ? 1 : 0;
  var path = void 0;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = 'M' + x + ',' + (y + sign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
    }

    path += 'L ' + (x + width - newRadius[1]) + ',' + y;

    if (newRadius[1] > 0) {
      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
    }
    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
    }
    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);

    if (newRadius[3] > 0) {
      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
    }
    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
  } else {
    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
  }

  return path;
};

var Rectangle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Rectangle, _Component);

  function Rectangle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Rectangle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      totalLength: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Rectangle, [{
    key: 'componentDidMount',


    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        var totalLength = this.node.getTotalLength();

        if (totalLength) {
          this.setState({
            totalLength: totalLength
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          x = _props.x,
          y = _props.y,
          width = _props.width,
          height = _props.height,
          radius = _props.radius,
          className = _props.className;
      var totalLength = this.state.totalLength;
      var _props2 = this.props,
          animationEasing = _props2.animationEasing,
          animationDuration = _props2.animationDuration,
          animationBegin = _props2.animationBegin,
          isAnimationActive = _props2.isAnimationActive,
          isUpdateAnimationActive = _props2.isUpdateAnimationActive;


      if (x !== +x || y !== +y || width !== +width || height !== +height) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-rectangle', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getRectangePath(x, y, width, height, radius)
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
        {
          canBegin: totalLength > 0,
          from: { width: width, height: height, x: x, y: y },
          to: { width: width, height: height, x: x, y: y },
          duration: animationDuration,
          animationEasing: animationEasing,
          isActive: isUpdateAnimationActive
        },
        function (_ref2) {
          var currWidth = _ref2.width,
              currHeight = _ref2.height,
              currX = _ref2.x,
              currY = _ref2.y;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
            {
              canBegin: totalLength > 0,
              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
              to: totalLength + 'px 0px',
              attributeName: 'strokeDasharray',
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(_this2.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["i" /* filterEventAttributes */])(_this2.props), {
              className: layerClass,
              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
              ref: function ref(node) {
                _this2.node = node;
              }
            }))
          );
        }
      );
    }
  }]);

  return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Rectangle);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeNonHTMLProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */
var INVALID_PROPS = [
    "active",
    "containerRef",
    "elementRef",
    "iconName",
    "inputRef",
    "intent",
    "inline",
    "loading",
    "leftIconName",
    "onChildrenMount",
    "onRemove",
    "popoverProps",
    "rightElement",
    "rightIconName",
    "text",
];
/**
 * Typically applied to HTMLElements to filter out blacklisted props. When applied to a Component,
 * can filter props from being passed down to the children. Can also filter by a combined list of
 * supplied prop keys and the blacklist (only appropriate for HTMLElements).
 * @param props The original props object to filter down.
 * @param {string[]} invalidProps If supplied, overwrites the default blacklist.
 * @param {boolean} shouldMerge If true, will merge supplied invalidProps and blacklist together.
 */
function removeNonHTMLProps(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) { invalidProps = INVALID_PROPS; }
    if (shouldMerge === void 0) { shouldMerge = false; }
    if (shouldMerge) {
        invalidProps = invalidProps.concat(INVALID_PROPS);
    }
    return invalidProps.reduce(function (prev, curr) {
        if (prev.hasOwnProperty(curr)) {
            delete prev[curr];
        }
        return prev;
    }, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, props));
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverInteractionKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Popover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopoverFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tether__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_tetherUtils__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_utils_isDarkTheme__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__overlay_overlay__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tooltip_tooltip__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__arrows__ = __webpack_require__(906);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
















var SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378" +
    "-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005" +
    "c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
var SMART_POSITIONING = {
    attachment: "together",
    to: "scrollParent",
};
var PopoverInteractionKind;
(function (PopoverInteractionKind) {
    PopoverInteractionKind[PopoverInteractionKind["CLICK"] = 0] = "CLICK";
    PopoverInteractionKind[PopoverInteractionKind["CLICK_TARGET_ONLY"] = 1] = "CLICK_TARGET_ONLY";
    PopoverInteractionKind[PopoverInteractionKind["HOVER"] = 2] = "HOVER";
    PopoverInteractionKind[PopoverInteractionKind["HOVER_TARGET_ONLY"] = 3] = "HOVER_TARGET_ONLY";
})(PopoverInteractionKind || (PopoverInteractionKind = {}));
var Popover = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Popover, _super);
    function Popover(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.hasDarkParent = false;
        // a flag that is set to true while we are waiting for the underlying Portal to complete rendering
        _this.isContentMounting = false;
        _this.refHandlers = {
            popover: function (ref) {
                _this.popoverElement = ref;
                _this.updateTether();
                _this.updateArrowPosition();
            },
            target: function (ref) {
                _this.targetElement = ref;
            },
        };
        _this.handleContentMount = function () {
            if (__WEBPACK_IMPORTED_MODULE_11__common_utils__["isFunction"](_this.props.popoverDidOpen) && _this.isContentMounting) {
                _this.props.popoverDidOpen();
                _this.isContentMounting = false;
            }
        };
        _this.handleTargetFocus = function (e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                _this.handleMouseEnter(e);
            }
        };
        _this.handleTargetBlur = function (e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                // if the next element to receive focus is within the popover, we'll want to leave the
                // popover open. we must do this check *after* the next element focuses, so we use a
                // timeout of 0 to flush the rest of the event queue before proceeding.
                requestAnimationFrame(function () {
                    if (_this.popoverElement == null || !_this.popoverElement.contains(document.activeElement)) {
                        _this.handleMouseLeave(e);
                    }
                });
            }
        };
        _this.handleMouseEnter = function (e) {
            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
            // trigger the mouse leave event, as hovering over the popover shouldn't count.
            if (_this.props.inline &&
                _this.isElementInPopover(e.target) &&
                _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY &&
                !_this.props.openOnTargetFocus) {
                _this.handleMouseLeave(e);
            }
            else if (!_this.props.isDisabled) {
                // only begin opening popover when it is enabled
                _this.setOpenStateByPropCallback(true, e, _this.props.hoverOpenDelay);
            }
        };
        _this.handleMouseLeave = function (e) {
            // user-configurable closing delay is helpful when moving mouse from target to popover
            _this.setOpenStateByPropCallback(false, e, _this.props.hoverCloseDelay);
        };
        _this.handlePopoverClick = function (e) {
            var eventTarget = e.target;
            var shouldDismiss = eventTarget.closest("." + __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_DISMISS"]) != null;
            var overrideDismiss = eventTarget.closest("." + __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_DISMISS_OVERRIDE"]) != null;
            if (shouldDismiss && !overrideDismiss) {
                _this.setOpenStateByPropCallback(false, e);
            }
        };
        _this.handleOverlayClose = function (e) {
            var eventTarget = e.target;
            // if click was in target, target event listener will handle things, so don't close
            if (!__WEBPACK_IMPORTED_MODULE_11__common_utils__["elementIsOrContains"](_this.targetElement, eventTarget) || e.nativeEvent instanceof KeyboardEvent) {
                _this.setOpenStateByPropCallback(false, e);
            }
        };
        _this.handleTargetClick = function (e) {
            // ensure click did not originate from within inline popover before closing
            if (!_this.props.isDisabled && !_this.isElementInPopover(e.target)) {
                if (_this.props.isOpen == null) {
                    _this.setOpenStateDirectly(function (previousIsOpen) { return !previousIsOpen; });
                }
                else {
                    _this.setOpenStateByPropCallback(!_this.props.isOpen, e);
                }
            }
        };
        var isOpen = props.defaultIsOpen && !props.isDisabled;
        if (props.isOpen != null) {
            isOpen = props.isOpen;
        }
        _this.state = {
            ignoreTargetDimensions: false,
            isOpen: isOpen,
            targetHeight: 0,
            targetWidth: 0,
        };
        return _this;
    }
    Popover.prototype.render = function () {
        var className = this.props.className;
        var isOpen = this.state.isOpen;
        var targetProps;
        if (this.isHoverInteractionKind()) {
            targetProps = {
                onBlur: this.handleTargetBlur,
                onFocus: this.handleTargetFocus,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
            };
            // any one of the CLICK* values
        }
        else {
            targetProps = {
                onClick: this.handleTargetClick,
            };
        }
        targetProps.className = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_TARGET"], (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_OPEN"]] = isOpen,
            _a), className);
        targetProps.ref = this.refHandlers.target;
        var children = this.understandChildren();
        var targetTabIndex = this.props.openOnTargetFocus && this.isHoverInteractionKind() ? 0 : undefined;
        var target = __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children.target, 
        // force disable single Tooltip child when popover is open (BLUEPRINT-552)
        isOpen && children.target.type === __WEBPACK_IMPORTED_MODULE_14__tooltip_tooltip__["a" /* Tooltip */]
            ? { isDisabled: true, tabIndex: targetTabIndex }
            : { tabIndex: targetTabIndex });
        var isContentEmpty = children.content == null;
        if (isContentEmpty && !this.props.isDisabled && isOpen !== false && !__WEBPACK_IMPORTED_MODULE_11__common_utils__["isNodeEnv"]("production")) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["l" /* POPOVER_WARN_EMPTY_CONTENT */]);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](this.props.rootElementTag, targetProps, target, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__overlay_overlay__["a" /* Overlay */], { autoFocus: this.props.autoFocus, backdropClassName: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_BACKDROP"], backdropProps: this.props.backdropProps, canEscapeKeyClose: this.props.canEscapeKeyClose, canOutsideClickClose: this.props.interactionKind === PopoverInteractionKind.CLICK, className: this.props.portalClassName, didOpen: this.handleContentMount, enforceFocus: this.props.enforceFocus, hasBackdrop: this.props.isModal, inline: this.props.inline, isOpen: isOpen && !isContentEmpty, lazy: this.props.lazy, onClose: this.handleOverlayClose, transitionDuration: this.props.transitionDuration, transitionName: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER"] }, this.renderPopover(children.content)));
        var _a;
    };
    Popover.prototype.componentDidMount = function () {
        this.componentDOMChange();
    };
    Popover.prototype.componentWillReceiveProps = function (nextProps) {
        _super.prototype.componentWillReceiveProps.call(this, nextProps);
        if (nextProps.isOpen == null && nextProps.isDisabled && !this.props.isDisabled) {
            // ok to use setOpenState here because isDisabled and isOpen are mutex.
            this.setOpenStateByPropCallback(false);
        }
        else if (nextProps.isOpen !== this.props.isOpen) {
            // propagate isOpen prop directly to state, circumventing onInteraction callback
            // (which would be invoked if this went through setOpenState)
            this.setOpenStateDirectly(nextProps.isOpen);
        }
    };
    Popover.prototype.componentWillUpdate = function (_, nextState) {
        if (!this.state.isOpen && nextState.isOpen) {
            this.isContentMounting = true;
            __WEBPACK_IMPORTED_MODULE_11__common_utils__["safeInvoke"](this.props.popoverWillOpen);
        }
        else if (this.state.isOpen && !nextState.isOpen) {
            __WEBPACK_IMPORTED_MODULE_11__common_utils__["safeInvoke"](this.props.popoverWillClose);
        }
    };
    Popover.prototype.componentDidUpdate = function () {
        this.componentDOMChange();
    };
    Popover.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.destroyTether();
    };
    Popover.prototype.validateProps = function (props) {
        if (props.useSmartPositioning || props.constraints != null) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["m" /* POPOVER_WARN_DEPRECATED_CONSTRAINTS */]);
        }
        if (props.isOpen == null && props.onInteraction != null) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["n" /* POPOVER_WARN_UNCONTROLLED_ONINTERACTION */]);
        }
        if (props.inline && (props.useSmartPositioning || props.constraints != null || props.tetherOptions != null)) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["o" /* POPOVER_WARN_INLINE_NO_TETHER */]);
        }
        if (props.isModal && props.inline) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["p" /* POPOVER_WARN_MODAL_INLINE */]);
        }
        if (props.isModal && props.interactionKind !== PopoverInteractionKind.CLICK) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_8__common_errors__["q" /* POPOVER_MODAL_INTERACTION */]);
        }
        var childrenCount = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].count(props.children);
        var hasContentProp = props.content !== undefined;
        var hasTargetProp = props.target !== undefined;
        if (childrenCount === 0 && !hasTargetProp) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_8__common_errors__["r" /* POPOVER_REQUIRES_TARGET */]);
        }
        if (childrenCount > 2) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["s" /* POPOVER_WARN_TOO_MANY_CHILDREN */]);
        }
        if (childrenCount > 0 && hasTargetProp) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["t" /* POPOVER_WARN_DOUBLE_TARGET */]);
        }
        if (childrenCount === 2 && hasContentProp) {
            console.warn(__WEBPACK_IMPORTED_MODULE_8__common_errors__["u" /* POPOVER_WARN_DOUBLE_CONTENT */]);
        }
    };
    Popover.prototype.componentDOMChange = function () {
        if (this.targetElement == null) {
            return;
        }
        if (this.props.useSmartArrowPositioning) {
            this.setState({
                targetHeight: this.targetElement.clientHeight,
                targetWidth: this.targetElement.clientWidth,
            });
        }
        if (!this.props.inline) {
            this.updateTether();
        }
        if (!this.props.inline && this.state.isOpen) {
            this.checkDOMForDarkTheme();
        }
    };
    Popover.prototype.renderPopover = function (content) {
        var _a = this.props, inline = _a.inline, interactionKind = _a.interactionKind;
        var popoverHandlers = {
            // always check popover clicks for dismiss class
            onClick: this.handlePopoverClick,
        };
        if (interactionKind === PopoverInteractionKind.HOVER ||
            (inline && interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY)) {
            popoverHandlers.onMouseEnter = this.handleMouseEnter;
            popoverHandlers.onMouseLeave = this.handleMouseLeave;
        }
        var positionClasses = __WEBPACK_IMPORTED_MODULE_10__common_tetherUtils__["a" /* getAttachmentClasses */](this.props.position).join(" ");
        var containerClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_7__common_classes__["TRANSITION_CONTAINER"], (_b = {}, _b[positionClasses] = inline, _b));
        var popoverClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER"], (_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_7__common_classes__["DARK"]] = this.props.inheritDarkTheme && this.hasDarkParent && !inline,
            _c), this.props.popoverClassName);
        var styles = this.getArrowPositionStyles();
        var transform = { transformOrigin: this.getPopoverTransformOrigin() };
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: containerClasses, ref: this.refHandlers.popover, style: styles.container },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: popoverClasses, style: transform }, popoverHandlers),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_ARROW"], style: styles.arrow },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("svg", { viewBox: "0 0 30 30" },
                        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", { className: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_ARROW"] + "-border", d: SVG_SHADOW_PATH }),
                        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", { className: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_ARROW"] + "-fill", d: SVG_ARROW_PATH }))),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_CONTENT"] }, content))));
        var _b, _c;
    };
    // content and target can be specified as props or as children.
    // this method normalizes the two approaches, preferring child over prop.
    Popover.prototype.understandChildren = function () {
        var _a = this.props, children = _a.children, contentProp = _a.content, targetProp = _a.target;
        // #validateProps asserts that 1 <= children.length <= 2 so content is optional
        var _b = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(children), targetChild = _b[0], contentChild = _b[1];
        return {
            content: ensureElement(contentChild == null ? contentProp : contentChild),
            target: ensureElement(targetChild == null ? targetProp : targetChild),
        };
    };
    Popover.prototype.getArrowPositionStyles = function () {
        if (this.props.useSmartArrowPositioning) {
            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
            return __WEBPACK_IMPORTED_MODULE_15__arrows__["a" /* getArrowPositionStyles */](this.props.position, this.props.arrowSize, this.state.ignoreTargetDimensions, dimensions, this.props.inline);
        }
        else {
            return {};
        }
    };
    Popover.prototype.getPopoverTransformOrigin = function () {
        // if smart positioning is enabled then we must rely on CSS classes to put transform origin
        // on the correct side and cannot override it in JS. (https://github.com/HubSpot/tether/issues/154)
        if (this.props.useSmartArrowPositioning && !this.props.useSmartPositioning) {
            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
            return __WEBPACK_IMPORTED_MODULE_15__arrows__["b" /* getPopoverTransformOrigin */](this.props.position, this.props.arrowSize, dimensions);
        }
        else {
            return undefined;
        }
    };
    Popover.prototype.updateArrowPosition = function () {
        if (this.popoverElement != null) {
            var arrow = this.popoverElement.getElementsByClassName(__WEBPACK_IMPORTED_MODULE_7__common_classes__["POPOVER_ARROW"])[0];
            var centerWidth = (this.state.targetWidth + arrow.clientWidth) / 2;
            var centerHeight = (this.state.targetHeight + arrow.clientHeight) / 2;
            var ignoreWidth = centerWidth > this.popoverElement.clientWidth && __WEBPACK_IMPORTED_MODULE_9__common_position__["b" /* isPositionHorizontal */](this.props.position);
            var ignoreHeight = centerHeight > this.popoverElement.clientHeight && __WEBPACK_IMPORTED_MODULE_9__common_position__["c" /* isPositionVertical */](this.props.position);
            if (!this.state.ignoreTargetDimensions && (ignoreWidth || ignoreHeight)) {
                this.setState({ ignoreTargetDimensions: true });
            }
            else if (this.state.ignoreTargetDimensions && !ignoreWidth && !ignoreHeight) {
                this.setState({ ignoreTargetDimensions: false });
            }
        }
    };
    Popover.prototype.updateTether = function () {
        var _this = this;
        if (this.state.isOpen && !this.props.inline && this.popoverElement != null) {
            var _a = this.props, constraints = _a.constraints, position = _a.position, _b = _a.tetherOptions, tetherOptions = _b === void 0 ? {} : _b, useSmartPositioning = _a.useSmartPositioning;
            // the .pt-popover-target span we wrap the children in won't always be as big as its children
            // so instead, we'll position tether based off of its first child.
            // NOTE: use findDOMNode(this) directly because this.targetElement may not exist yet
            var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this).childNodes[0];
            // constraints is deprecated but must still be supported through tetherOptions until v2.0
            var options = constraints == null && !useSmartPositioning
                ? tetherOptions
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, tetherOptions, { constraints: useSmartPositioning ? [SMART_POSITIONING] : constraints });
            var finalTetherOptions = __WEBPACK_IMPORTED_MODULE_10__common_tetherUtils__["b" /* createTetherOptions */](this.popoverElement, target, position, options);
            if (this.tether == null) {
                this.tether = new __WEBPACK_IMPORTED_MODULE_5_tether__(finalTetherOptions);
            }
            else {
                this.tether.setOptions(finalTetherOptions);
            }
            // if props.position has just changed, Tether unfortunately positions the popover based
            // on the margins from the previous position. delay a frame for styles to catch up.
            setTimeout(function () { return _this.tether.position(); });
        }
        else {
            this.destroyTether();
        }
    };
    Popover.prototype.destroyTether = function () {
        if (this.tether != null) {
            this.tether.destroy();
        }
    };
    // a wrapper around setState({isOpen}) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    Popover.prototype.setOpenStateByPropCallback = function (isOpen, e, timeout) {
        var _this = this;
        // cancel any existing timeout because we have new state
        __WEBPACK_IMPORTED_MODULE_11__common_utils__["safeInvoke"](this.cancelOpenTimeout);
        if (timeout > 0) {
            this.cancelOpenTimeout = this.setTimeout(function () { return _this.setOpenStateByPropCallback(isOpen, e); }, timeout);
        }
        else {
            if (this.props.isOpen == null) {
                this.setOpenStateDirectly(isOpen);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_11__common_utils__["safeInvoke"](this.props.onInteraction, isOpen);
            }
            if (!isOpen) {
                __WEBPACK_IMPORTED_MODULE_11__common_utils__["safeInvoke"](this.props.onClose, e);
            }
        }
    };
    Popover.prototype.setOpenStateDirectly = function (isOpen) {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_11__common_utils__["isFunction"](isOpen)) {
            this.setState(function (previousState) {
                var nextIsOpen = isOpen(previousState.isOpen);
                if (nextIsOpen) {
                    _this.checkDOMForDarkTheme();
                }
                return { isOpen: nextIsOpen };
            });
        }
        else {
            if (isOpen) {
                this.checkDOMForDarkTheme();
            }
            this.setState({ isOpen: isOpen });
        }
    };
    Popover.prototype.isElementInPopover = function (element) {
        return this.popoverElement != null && this.popoverElement.contains(element);
    };
    Popover.prototype.isHoverInteractionKind = function () {
        return (this.props.interactionKind === PopoverInteractionKind.HOVER ||
            this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY);
    };
    // This may cause a preemptive DOM reflow so should be avoided when the tether is not present
    Popover.prototype.checkDOMForDarkTheme = function () {
        this.hasDarkParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_utils_isDarkTheme__["a" /* isDarkTheme */])(this.targetElement);
    };
    Popover.defaultProps = {
        arrowSize: 30,
        className: "",
        defaultIsOpen: false,
        hoverCloseDelay: 300,
        hoverOpenDelay: 150,
        inheritDarkTheme: true,
        inline: false,
        interactionKind: PopoverInteractionKind.CLICK,
        isDisabled: false,
        isModal: false,
        openOnTargetFocus: true,
        popoverClassName: "",
        position: __WEBPACK_IMPORTED_MODULE_9__common_position__["a" /* Position */].RIGHT,
        rootElementTag: "span",
        transitionDuration: 300,
        useSmartArrowPositioning: true,
        useSmartPositioning: false,
    };
    Popover.displayName = "Blueprint.Popover";
    Popover = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Popover);
    return Popover;
}(__WEBPACK_IMPORTED_MODULE_6__common_abstractComponent__["a" /* AbstractComponent */]));

/**
 * Converts a react child to an element: non-empty strings or numbers are wrapped in `<span>`;
 * empty strings are discarded.
 */
function ensureElement(child) {
    // wrap text in a <span> so children are always elements
    if (typeof child === "string") {
        // cull whitespace strings
        return child.trim().length > 0 ? __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, child) : undefined;
    }
    else if (typeof child === "number") {
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, child);
    }
    else {
        return child;
    }
}
var PopoverFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Popover);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(922);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    _classCallCheck(this, ConfirmDialog);

    return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).apply(this, arguments));
  }

  _createClass(ConfirmDialog, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.onClose();
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      this.props.onSuccess();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.closeDialog.bind(this),
          title: this.props.title,
          className: 'reception-dialog delete-dialog wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'p',
            { className: 'reception-dialog-text' },
            this.props.content
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom col-100' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              'Kh\xF4ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-green', onClick: this.onSuccess.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u1ED3ng \xFD'
            )
          )
        )
      );
    }
  }]);

  return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.defaultProps = {
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function onSuccess() {
    console.log('Need to assign onSuccess method');
  },
  onClose: function onClose() {
    console.log('Need to assign onClose method');
  }
};

exports.default = ConfirmDialog;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThongTinNguoiUyQuyen = exports.ThongTinNguoiDungDon = exports.ThongTinDonVuViec = exports.ThongTinCoQuanDaGiaiQuyet = undefined;

var _ThongTinCoQuanDaGiaiQuyet = __webpack_require__(1227);

var _ThongTinCoQuanDaGiaiQuyet2 = _interopRequireDefault(_ThongTinCoQuanDaGiaiQuyet);

var _ThongTinDonVuViec = __webpack_require__(1228);

var _ThongTinDonVuViec2 = _interopRequireDefault(_ThongTinDonVuViec);

var _ThongTinNguoiDungDon = __webpack_require__(1229);

var _ThongTinNguoiDungDon2 = _interopRequireDefault(_ThongTinNguoiDungDon);

var _ThongTinNguoiUyQuyen = __webpack_require__(1230);

var _ThongTinNguoiUyQuyen2 = _interopRequireDefault(_ThongTinNguoiUyQuyen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThongTinCoQuanDaGiaiQuyet = _ThongTinCoQuanDaGiaiQuyet2.default;
exports.ThongTinDonVuViec = _ThongTinDonVuViec2.default;
exports.ThongTinNguoiDungDon = _ThongTinNguoiDungDon2.default;
exports.ThongTinNguoiUyQuyen = _ThongTinNguoiUyQuyen2.default;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DoiTuongKienNghiView = exports.NoiDungKienNghi = exports.DialogChinhSuaCuocThanhTra = exports.Search = exports.DanhSachCuocThanhTra = exports.ThongTinChung = exports.ThemMoiDoiTuongThanhTra = undefined;

var _ThongTinChung = __webpack_require__(1372);

var _ThongTinChung2 = _interopRequireDefault(_ThongTinChung);

var _DanhSachCuocThanhTra = __webpack_require__(1366);

var _DanhSachCuocThanhTra2 = _interopRequireDefault(_DanhSachCuocThanhTra);

var _ThemMoiDoiTuongThanhTra = __webpack_require__(494);

var _ThemMoiDoiTuongThanhTra2 = _interopRequireDefault(_ThemMoiDoiTuongThanhTra);

var _Search = __webpack_require__(1371);

var _Search2 = _interopRequireDefault(_Search);

var _DialogChinhSuaCuocThanhTra = __webpack_require__(1367);

var _DialogChinhSuaCuocThanhTra2 = _interopRequireDefault(_DialogChinhSuaCuocThanhTra);

var _NoiDungKienNghi = __webpack_require__(1370);

var _NoiDungKienNghi2 = _interopRequireDefault(_NoiDungKienNghi);

var _DoiTuongKienNghiView = __webpack_require__(1369);

var _DoiTuongKienNghiView2 = _interopRequireDefault(_DoiTuongKienNghiView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThemMoiDoiTuongThanhTra = _ThemMoiDoiTuongThanhTra2.default;
exports.ThongTinChung = _ThongTinChung2.default;
exports.DanhSachCuocThanhTra = _DanhSachCuocThanhTra2.default;
exports.Search = _Search2.default;
exports.DialogChinhSuaCuocThanhTra = _DialogChinhSuaCuocThanhTra2.default;
exports.NoiDungKienNghi = _NoiDungKienNghi2.default;
exports.DoiTuongKienNghiView = _DoiTuongKienNghiView2.default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.downloadExcel = downloadExcel;

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadExcel(url, name, isReport) {
  _axios2.default.get(url, {
    headers: _extends({
      "Content-Type": "application/octet-stream"
    }, isReport ? { Accept: "application/octet-stream" } : {}),
    responseType: "blob"
  }).then(function (response) {
    var a = document.createElement("a");
    var url = window.URL.createObjectURL(response.data);
    a.href = url;
    a.download = name;
    a.click();
  }).catch(function (err) {
    console.error("error", err);
  });
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(93);
var TAG = __webpack_require__(43)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(53).f;
var has = __webpack_require__(84);
var TAG = __webpack_require__(43)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var defined = __webpack_require__(103);
var fails = __webpack_require__(34);
var spaces = __webpack_require__(345);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(564);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(35);

var Record = Immutable.Record;


var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = function (_SelectionStateRecord) {
  _inherits(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck(this, SelectionState);

    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(137);

var _Actions = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(398);
var setInnerHTML = __webpack_require__(287);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(406);
var setTextContent = __webpack_require__(818);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(2214);
var ReactInstrumentation = __webpack_require__(99);

var warning = __webpack_require__(37);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var ReactBaseClasses = __webpack_require__(841);
var ReactChildren = __webpack_require__(2290);
var ReactDOMFactories = __webpack_require__(2291);
var ReactElement = __webpack_require__(188);
var ReactPropTypes = __webpack_require__(2292);
var ReactVersion = __webpack_require__(2293);

var createReactClass = __webpack_require__(2294);
var onlyChild = __webpack_require__(2298);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(122);

var warning = __webpack_require__(37);
var canDefineProperty = __webpack_require__(845);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(843);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/* harmony default export */ __webpack_exports__["a"] = (function (WrappedComponent) {
  var _class, _temp2;

  var AnimationDecorator = (_temp2 = _class = function (_Component) {
    _inherits(AnimationDecorator, _Component);

    function AnimationDecorator() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, AnimationDecorator);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimationDecorator.__proto__ || Object.getPrototypeOf(AnimationDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        animationId: 0
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AnimationDecorator, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var animationId = this.state.animationId;


        if (this.props.data !== nextProps.data) {
          this.setState({
            animationId: animationId + 1
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { animationId: this.state.animationId }));
      }
    }]);

    return AnimationDecorator;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = 'AnimationDecorator(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ReactUtils__["f" /* getDisplayName */])(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
    data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }), _class.WrappedComponent = WrappedComponent, _class.defaultProps = WrappedComponent.defaultProps, _temp2);


  return AnimationDecorator;
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoCompleteKeHoachTT = exports.AutoSuggest = exports.AutoCompleteSearch = undefined;

var _AutoCompleteSearch = __webpack_require__(970);

var _AutoCompleteSearch2 = _interopRequireDefault(_AutoCompleteSearch);

var _AutoSuggest = __webpack_require__(971);

var _AutoSuggest2 = _interopRequireDefault(_AutoSuggest);

var _AutoCompleteKeHoachTT = __webpack_require__(969);

var _AutoCompleteKeHoachTT2 = _interopRequireDefault(_AutoCompleteKeHoachTT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AutoCompleteSearch = _AutoCompleteSearch2.default;
exports.AutoSuggest = _AutoSuggest2.default;
exports.AutoCompleteKeHoachTT = _AutoCompleteKeHoachTT2.default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemKetQuaXuLyThamNhung = exports.RowItemSLKKXMTS = exports.RowItemQLNNKNTC = exports.RowItemGQDKN = exports.RowItemGQDTC = exports.RowItemXLDKhieuNaiToCao = exports.RowItemKetQuaTiepCongDan = exports.RowItemCongTacXayDung = exports.RowItemCongTacQuanLyThanhTra = exports.RowItemKetQuaThanhTraDatDai = exports.RowItemKetQuaThanhTraChuyenNganh = exports.RowItemKetQuaThanhTraLai = exports.RowItemKetQuaThanhTraTaiChinhNganHang = exports.RowItemKetQuaThanhTraHanhChinh = exports.RowItemChiTietDonViBCTH = exports.RowItemDanhSachBaoCaoBCTH = exports.RowItemDanhSachDonViBCTH = exports.RowItemBaoCaoTongHop = undefined;

var _RowItemBaoCaoTongHop = __webpack_require__(1000);

var _RowItemBaoCaoTongHop2 = _interopRequireDefault(_RowItemBaoCaoTongHop);

var _RowItemDanhSachDonViBCTH = __webpack_require__(1005);

var _RowItemDanhSachDonViBCTH2 = _interopRequireDefault(_RowItemDanhSachDonViBCTH);

var _RowItemDanhSachBaoCaoBCTH = __webpack_require__(1004);

var _RowItemDanhSachBaoCaoBCTH2 = _interopRequireDefault(_RowItemDanhSachBaoCaoBCTH);

var _RowItemChiTietDonViBCTH = __webpack_require__(1001);

var _RowItemChiTietDonViBCTH2 = _interopRequireDefault(_RowItemChiTietDonViBCTH);

var _RowItemKetQuaThanhTraHanhChinh = __webpack_require__(1010);

var _RowItemKetQuaThanhTraHanhChinh2 = _interopRequireDefault(_RowItemKetQuaThanhTraHanhChinh);

var _RowItemKetQuaThanhTraTaiChinhNganHang = __webpack_require__(1012);

var _RowItemKetQuaThanhTraTaiChinhNganHang2 = _interopRequireDefault(_RowItemKetQuaThanhTraTaiChinhNganHang);

var _RowItemKetQuaThanhTraDatDai = __webpack_require__(1009);

var _RowItemKetQuaThanhTraDatDai2 = _interopRequireDefault(_RowItemKetQuaThanhTraDatDai);

var _RowItemKetQuaThanhTraLai = __webpack_require__(1011);

var _RowItemKetQuaThanhTraLai2 = _interopRequireDefault(_RowItemKetQuaThanhTraLai);

var _RowItemKetQuaThanhTraChuyenNganh = __webpack_require__(1008);

var _RowItemKetQuaThanhTraChuyenNganh2 = _interopRequireDefault(_RowItemKetQuaThanhTraChuyenNganh);

var _RowItemKetQuaXuLyThamNhung = __webpack_require__(1014);

var _RowItemKetQuaXuLyThamNhung2 = _interopRequireDefault(_RowItemKetQuaXuLyThamNhung);

var _RowItemCongTacQuanLyThanhTra = __webpack_require__(1002);

var _RowItemCongTacQuanLyThanhTra2 = _interopRequireDefault(_RowItemCongTacQuanLyThanhTra);

var _RowItemCongTacXayDung = __webpack_require__(1003);

var _RowItemCongTacXayDung2 = _interopRequireDefault(_RowItemCongTacXayDung);

var _RowItemKetQuaTiepCongDan = __webpack_require__(1013);

var _RowItemKetQuaTiepCongDan2 = _interopRequireDefault(_RowItemKetQuaTiepCongDan);

var _RowItemXLDKhieuNaiToCao = __webpack_require__(1017);

var _RowItemXLDKhieuNaiToCao2 = _interopRequireDefault(_RowItemXLDKhieuNaiToCao);

var _RowItemGQDKN = __webpack_require__(1006);

var _RowItemGQDKN2 = _interopRequireDefault(_RowItemGQDKN);

var _RowItemGQDTC = __webpack_require__(1007);

var _RowItemGQDTC2 = _interopRequireDefault(_RowItemGQDTC);

var _RowItemQLNNKNTC = __webpack_require__(1015);

var _RowItemQLNNKNTC2 = _interopRequireDefault(_RowItemQLNNKNTC);

var _RowItemSLKKXMTS = __webpack_require__(1016);

var _RowItemSLKKXMTS2 = _interopRequireDefault(_RowItemSLKKXMTS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemBaoCaoTongHop = _RowItemBaoCaoTongHop2.default;
exports.RowItemDanhSachDonViBCTH = _RowItemDanhSachDonViBCTH2.default;
exports.RowItemDanhSachBaoCaoBCTH = _RowItemDanhSachBaoCaoBCTH2.default;
exports.RowItemChiTietDonViBCTH = _RowItemChiTietDonViBCTH2.default;
exports.RowItemKetQuaThanhTraHanhChinh = _RowItemKetQuaThanhTraHanhChinh2.default;
exports.RowItemKetQuaThanhTraTaiChinhNganHang = _RowItemKetQuaThanhTraTaiChinhNganHang2.default;
exports.RowItemKetQuaThanhTraLai = _RowItemKetQuaThanhTraLai2.default;
exports.RowItemKetQuaThanhTraChuyenNganh = _RowItemKetQuaThanhTraChuyenNganh2.default;
exports.RowItemKetQuaThanhTraDatDai = _RowItemKetQuaThanhTraDatDai2.default;
exports.RowItemCongTacQuanLyThanhTra = _RowItemCongTacQuanLyThanhTra2.default;
exports.RowItemCongTacXayDung = _RowItemCongTacXayDung2.default;
exports.RowItemKetQuaTiepCongDan = _RowItemKetQuaTiepCongDan2.default;
exports.RowItemXLDKhieuNaiToCao = _RowItemXLDKhieuNaiToCao2.default;
exports.RowItemGQDTC = _RowItemGQDTC2.default;
exports.RowItemGQDKN = _RowItemGQDKN2.default;
exports.RowItemQLNNKNTC = _RowItemQLNNKNTC2.default;
exports.RowItemSLKKXMTS = _RowItemSLKKXMTS2.default;
exports.RowItemKetQuaXuLyThamNhung = _RowItemKetQuaXuLyThamNhung2.default;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinYeuCauKiemTraDeXuat = function (_React$Component) {
  _inherits(ThongTinYeuCauKiemTraDeXuat, _React$Component);

  function ThongTinYeuCauKiemTraDeXuat(props, context) {
    _classCallCheck(this, ThongTinYeuCauKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (ThongTinYeuCauKiemTraDeXuat.__proto__ || Object.getPrototypeOf(ThongTinYeuCauKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      listTaiLieuVanThuGiaiQuyetDon: _this.props.listTaiLieuVanThuGiaiQuyetDon,
      donViGiaoKTDX: _this.props.donViGiaoKTDX,
      donViPhoiHops: _this.props.donViPhoiHops,
      ngayBaoCaoKQ: _this.props.ngayBaoCaoKQ,
      hideTable: _this.props.hideTable
    };
    return _this;
  }

  _createClass(ThongTinYeuCauKiemTraDeXuat, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: nextProps.listTaiLieuVanThuGiaiQuyetDon,
        donViGiaoKTDX: nextProps.donViGiaoKTDX,
        donViPhoiHops: nextProps.donViPhoiHops,
        ngayBaoCaoKQ: nextProps.ngayBaoCaoKQ,
        hideTable: nextProps.hideTable
      });
    }
  }, {
    key: 'getDonViPhoiHop',
    value: function getDonViPhoiHop(arr) {
      var dataReturn = '';
      arr.map(function (state, i) {
        if (i == 0) {
          dataReturn = dataReturn + state.ten;
        } else {
          dataReturn = dataReturn + ', ' + state.ten;
        }
      });
      return dataReturn;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin y\xEAu c\u1EA7u ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mb15' },
            _react2.default.createElement(_common.Text, { className: 'col-25', label: '\u0110\u01A1n v\u1ECB giao ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t:', value: this.state.donViGiaoKTDX ? this.state.donViGiaoKTDX.ten : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.ngayBaoCaoKQ ? (0, _moment2.default)(this.state.ngayBaoCaoKQ).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideTable },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          )
        )
      );
    }
  }]);

  return ThongTinYeuCauKiemTraDeXuat;
}(_react2.default.Component);

ThongTinYeuCauKiemTraDeXuat.defaultProps = {
  listTaiLieuVanThuGiaiQuyetDon: [],
  donViGiaoKTDX: {},
  donViPhoiHops: [],
  ngayBaoCaoKQ: '',
  hideTable: false
};

exports.default = ThongTinYeuCauKiemTraDeXuat;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CheckQuyenTuXuLy = function CheckQuyenTuXuLy(quyenTuXuLyInfo) {

  var check = false;

  if (quyenTuXuLyInfo && localStorage.getItem('userInfo')) {

    var data = JSON.parse(localStorage.getItem('userInfo'));

    if (data.loaiVaiTroMacDinh == "LANH_DAO" || data.loaiVaiTroMacDinh == "TRUONG_PHONG") {
      quyenTuXuLyInfo.map(function (item, i) {
        if (item.donViId == data.donViId) {
          check = item.quyenTuXuLy;
        }
      });
    }
  }
  return check;
};

exports.CheckQuyenTuXuLy = CheckQuyenTuXuLy;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListAttachReceptionPeriodical = exports.RowItemListProofReceptionPeriodical = exports.RowItemListOrganizationPeriodical = undefined;

var _RowItemListOrganizationPeriodical = __webpack_require__(1266);

var _RowItemListOrganizationPeriodical2 = _interopRequireDefault(_RowItemListOrganizationPeriodical);

var _RowItemListProofReceptionPeriodical = __webpack_require__(1267);

var _RowItemListProofReceptionPeriodical2 = _interopRequireDefault(_RowItemListProofReceptionPeriodical);

var _RowItemListAttachReceptionPeriodical = __webpack_require__(1265);

var _RowItemListAttachReceptionPeriodical2 = _interopRequireDefault(_RowItemListAttachReceptionPeriodical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemListOrganizationPeriodical = _RowItemListOrganizationPeriodical2.default;
exports.RowItemListProofReceptionPeriodical = _RowItemListProofReceptionPeriodical2.default;
exports.RowItemListAttachReceptionPeriodical = _RowItemListAttachReceptionPeriodical2.default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemTheoDoiDonDocTheoKy = exports.RowItemDanhSachThongKeGiamSatDonCu = exports.RowItemThongKeGiamSatNhapDonCu = exports.RowItemDanhSachDon = exports.RowItemTinhHinhXuLyDonTaiDonVi = exports.DataTable = undefined;

var _DataTable = __webpack_require__(1378);

var _DataTable2 = _interopRequireDefault(_DataTable);

var _RowItemTinhHinhXuLyDonTaiDonVi = __webpack_require__(1383);

var _RowItemTinhHinhXuLyDonTaiDonVi2 = _interopRequireDefault(_RowItemTinhHinhXuLyDonTaiDonVi);

var _RowItemDanhSachDon = __webpack_require__(1379);

var _RowItemDanhSachDon2 = _interopRequireDefault(_RowItemDanhSachDon);

var _RowItemThongKeGiamSatNhapDonCu = __webpack_require__(1382);

var _RowItemThongKeGiamSatNhapDonCu2 = _interopRequireDefault(_RowItemThongKeGiamSatNhapDonCu);

var _RowItemDanhSachThongKeGiamSatDonCu = __webpack_require__(1380);

var _RowItemDanhSachThongKeGiamSatDonCu2 = _interopRequireDefault(_RowItemDanhSachThongKeGiamSatDonCu);

var _RowItemTheoDoiDonDocTheoKy = __webpack_require__(1381);

var _RowItemTheoDoiDonDocTheoKy2 = _interopRequireDefault(_RowItemTheoDoiDonDocTheoKy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DataTable = _DataTable2.default;
exports.RowItemTinhHinhXuLyDonTaiDonVi = _RowItemTinhHinhXuLyDonTaiDonVi2.default;
exports.RowItemDanhSachDon = _RowItemDanhSachDon2.default;
exports.RowItemThongKeGiamSatNhapDonCu = _RowItemThongKeGiamSatNhapDonCu2.default;
exports.RowItemDanhSachThongKeGiamSatDonCu = _RowItemDanhSachThongKeGiamSatDonCu2.default;
exports.RowItemTheoDoiDonDocTheoKy = _RowItemTheoDoiDonDocTheoKy2.default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhSachThongKeGiamSatDonCu = exports.ThongKeGiamSatNhapDonCu = exports.DanhSachDonTheoKy = exports.DanhSachDon = exports.TinhHinhXuLyDonTaiDonVi = undefined;

var _TinhHinhXuLyDonTaiDonVi = __webpack_require__(1377);

var _TinhHinhXuLyDonTaiDonVi2 = _interopRequireDefault(_TinhHinhXuLyDonTaiDonVi);

var _DanhSachDonTheoKy = __webpack_require__(1374);

var _DanhSachDonTheoKy2 = _interopRequireDefault(_DanhSachDonTheoKy);

var _DanhSachDon = __webpack_require__(1373);

var _DanhSachDon2 = _interopRequireDefault(_DanhSachDon);

var _ThongKeGiamSatNhapDonCu = __webpack_require__(1376);

var _ThongKeGiamSatNhapDonCu2 = _interopRequireDefault(_ThongKeGiamSatNhapDonCu);

var _DanhSachThongKeGiamSatDonCu = __webpack_require__(1375);

var _DanhSachThongKeGiamSatDonCu2 = _interopRequireDefault(_DanhSachThongKeGiamSatDonCu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TinhHinhXuLyDonTaiDonVi = _TinhHinhXuLyDonTaiDonVi2.default;
exports.DanhSachDon = _DanhSachDon2.default;
exports.DanhSachDonTheoKy = _DanhSachDonTheoKy2.default;
exports.ThongKeGiamSatNhapDonCu = _ThongKeGiamSatNhapDonCu2.default;
exports.DanhSachThongKeGiamSatDonCu = _DanhSachThongKeGiamSatDonCu2.default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToChucLienQuan = exports.DoiTuongKienNghiView = exports.NoiDungKienNghi = exports.DialogChinhSuaCuocThanhTra = exports.Search = exports.DanhSachCuocThanhTra = exports.ThongTinChung = undefined;

var _ThongTinChung = __webpack_require__(1402);

var _ThongTinChung2 = _interopRequireDefault(_ThongTinChung);

var _DanhSachCuocThanhTra = __webpack_require__(1392);

var _DanhSachCuocThanhTra2 = _interopRequireDefault(_DanhSachCuocThanhTra);

var _Search = __webpack_require__(1400);

var _Search2 = _interopRequireDefault(_Search);

var _DialogChinhSuaCuocThanhTra = __webpack_require__(1393);

var _DialogChinhSuaCuocThanhTra2 = _interopRequireDefault(_DialogChinhSuaCuocThanhTra);

var _NoiDungKienNghi = __webpack_require__(1399);

var _NoiDungKienNghi2 = _interopRequireDefault(_NoiDungKienNghi);

var _DoiTuongKienNghiView = __webpack_require__(1395);

var _DoiTuongKienNghiView2 = _interopRequireDefault(_DoiTuongKienNghiView);

var _ToChucLienQuan = __webpack_require__(497);

var _ToChucLienQuan2 = _interopRequireDefault(_ToChucLienQuan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThongTinChung = _ThongTinChung2.default;
exports.DanhSachCuocThanhTra = _DanhSachCuocThanhTra2.default;
exports.Search = _Search2.default;
exports.DialogChinhSuaCuocThanhTra = _DialogChinhSuaCuocThanhTra2.default;
exports.NoiDungKienNghi = _NoiDungKienNghi2.default;
exports.DoiTuongKienNghiView = _DoiTuongKienNghiView2.default;
exports.ToChucLienQuan = _ToChucLienQuan2.default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowIf = function (_React$Component) {
  _inherits(ShowIf, _React$Component);

  function ShowIf() {
    _classCallCheck(this, ShowIf);

    return _possibleConstructorReturn(this, (ShowIf.__proto__ || Object.getPrototypeOf(ShowIf)).apply(this, arguments));
  }

  _createClass(ShowIf, [{
    key: "render",
    value: function render() {
      if (this.props.condition) {
        if (typeof this.props.children.length != "undefined") {
          return _react2.default.createElement(
            "div",
            null,
            this.props.children
          );
        } else return this.props.children;
      } else {
        return null;
      }
    }
  }]);

  return ShowIf;
}(_react2.default.Component);

ShowIf.defaultProps = {
  condition: true
};

exports.default = ShowIf;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DateMask = function DateMask(input) {
  if (input.length == 2 || input.length == 5) {
    input = input + '/';
  }
  return input;
};
var PhoneNumber = function PhoneNumber(input) {
  return input = input.replace(/[^0-9]+/g, "");
};
var CMNDNumber = function CMNDNumber(input) {
  return input = input.replace(/[^0-9a-zA-Z]+/g, "");
};
var checkEmail = function checkEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var checkUnicode = /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/;
  return re.test(email) && email.match(checkUnicode) == null;
};

exports.DateMask = DateMask;
exports.PhoneNumber = PhoneNumber;
exports.CMNDNumber = CMNDNumber;
exports.checkEmail = checkEmail;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(27);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(93);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(94);
var global = __webpack_require__(30);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(132) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(27);
var aFunction = __webpack_require__(68);
var SPECIES = __webpack_require__(43)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__value_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(562);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_js__ = __webpack_require__(355);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed_js__ = __webpack_require__(563);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(565);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete_js__ = __webpack_require__(1836);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue_js__ = __webpack_require__(1839);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_js__ = __webpack_require__(257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__number_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(356);
/* unused harmony reexport interpolateNumberArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__object_js__ = __webpack_require__(566);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__round_js__ = __webpack_require__(1843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__round_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__string_js__ = __webpack_require__(568);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transform_index_js__ = __webpack_require__(1845);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom_js__ = __webpack_require__(1847);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rgb_js__ = __webpack_require__(567);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hsl_js__ = __webpack_require__(1838);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lab_js__ = __webpack_require__(1840);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hcl_js__ = __webpack_require__(1837);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__ = __webpack_require__(1835);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__piecewise_js__ = __webpack_require__(1841);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantize_js__ = __webpack_require__(1842);
/* unused harmony reexport quantize */























/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(1863);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    var d = domain(),
        i = d.length - 1,
        n = count == null ? 10 : count,
        start = d[0],
        stop = d[i],
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickStep */])(start, stop, n);

    if (step) {
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickStep */])(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
      d[0] = Math.floor(start / step) * step;
      d[i] = Math.ceil(stop / step) * step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (var j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * @format
 * 
 */



var Immutable = __webpack_require__(35);

var OrderedMap = Immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

module.exports = BlockMapBuilder;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */



/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(107);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isLength = __webpack_require__(394);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(2369);
var objectAssign = __webpack_require__(29);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var EventPluginRegistry = __webpack_require__(399);
var EventPluginUtils = __webpack_require__(400);
var ReactErrorUtils = __webpack_require__(404);

var accumulateInto = __webpack_require__(811);
var forEachAccumulated = __webpack_require__(812);
var invariant = __webpack_require__(21);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(220);
var EventPluginUtils = __webpack_require__(400);

var accumulateInto = __webpack_require__(811);
var forEachAccumulated = __webpack_require__(812);
var warning = __webpack_require__(37);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

var getEventTarget = __webpack_require__(409);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cross
 */




var Cell = (_temp = _class = function (_Component) {
  _inherits(Cell, _Component);

  function Cell() {
    _classCallCheck(this, Cell);

    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
  }

  _createClass(Cell, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Cell;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = 'Cell', _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */]), _temp);


/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CartesianUtils__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataUtils__ = __webpack_require__(32);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/*
 * ComposedDataDecorator is a wrapper component that calculates expensive,
 * reusable data like ticks of an axis, stores it in state on this component,
 * and passes it in as props to the wrapped component.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var getComposedData = _ref.getComposedData,
      ChildComponent = _ref.ChildComponent;
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(ComposedDataDecorator, _Component);

      function ComposedDataDecorator() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, ComposedDataDecorator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ComposedDataDecorator.__proto__ || Object.getPrototypeOf(ComposedDataDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.calculateExpensiveState({ props: _this.props }), _temp), _possibleConstructorReturn(_this, _ret);
      }

      // static WrappedComponent = WrappedComponent;

      _createClass(ComposedDataDecorator, [{
        key: 'calculateExpensiveState',


        /**
         * @param {Object} props The props object to operate on
         * @return {Object} returnObj
         *  returnObj {Array} axisTicks Used by renderCursor and anything
         *          else that needs the ticks of the axisTicks
         *  returObj {Array} allComposedData An array or arrays.
         *          Each top-level element is the composedData {points, baseLine, layout}
         *          for a given child(graphcalItem) of the overall Chart
         */
        value: function calculateExpensiveState(_ref3) {
          var props = _ref3.props;
          var children = props.children,
              graphicalItems = props.graphicalItems,
              xAxisMap = props.xAxisMap,
              yAxisMap = props.yAxisMap,
              stackGroups = props.stackGroups,
              layout = props.layout,
              offset = props.offset,
              barSize = props.barSize,
              barGap = props.barGap,
              barCategoryGap = props.barCategoryGap,
              globalMaxBarSize = props.maxBarSize;

          // Some charts pre-filter their items into the graphicalItems prop,
          // others filter it in render of the children

          var items = graphicalItems || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["d" /* findAllByType */])(children, ChildComponent);

          var sizeList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__CartesianUtils__["n" /* getBarSizeList */])({ barSize: barSize, stackGroups: stackGroups });

          var axisTicks = void 0;
          var allComposedData = [];
          items.forEach(function (item) {
            var _item$props = item.props,
                xAxisId = _item$props.xAxisId,
                yAxisId = _item$props.yAxisId,
                dataKey = _item$props.dataKey,
                childMaxBarSize = _item$props.maxBarSize;

            var xAxis = void 0,
                yAxis = void 0,
                xTicks = void 0,
                yTicks = void 0,
                barPosition = void 0,
                stackedData = void 0,
                bandSize = void 0;

            if (xAxisMap || yAxisMap) {

              xAxis = xAxisMap[xAxisId];
              yAxis = yAxisMap[yAxisId];

              xTicks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__CartesianUtils__["b" /* getTicksOfAxis */])(xAxis);
              yTicks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__CartesianUtils__["b" /* getTicksOfAxis */])(yAxis);

              // axisTicks is more global - only need to set once
              axisTicks = axisTicks || (layout === 'horizontal' ? xTicks : yTicks);

              var numericAxisId = layout === 'horizontal' ? yAxisId : xAxisId;
              var cateAxisId = layout === 'horizontal' ? xAxisId : yAxisId;
              var cateAxis = layout === 'horizontal' ? xAxis : yAxis;
              var cateTicks = layout === 'horizontal' ? xTicks : yTicks;

              stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__CartesianUtils__["o" /* getStackedDataOfItem */])(item, stackGroups[numericAxisId].stackGroups);

              bandSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__DataUtils__["b" /* getBandSizeOfAxis */])(cateAxis, cateTicks);
              var maxBarSize = __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
              barPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__CartesianUtils__["p" /* getBarPosition */])({
                barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
              });
            }

            var composedData = getComposedData && getComposedData({ props: props,
              xAxis: xAxis, yAxis: yAxis, xTicks: xTicks, yTicks: yTicks, dataKey: dataKey, item: item, bandSize: bandSize, barPosition: barPosition, offset: offset, stackedData: stackedData
            }) || {};
            allComposedData.push(composedData);
          });

          return { axisTicks: axisTicks, allComposedData: allComposedData };
        }
        /*
        * Update the state of the composedData if anything relevant changed
        */
        /* eslint-disable no-unused-vars */

      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var graphicalItems = nextProps.graphicalItems,
              children = nextProps.children,
              chartX = nextProps.chartX,
              chartY = nextProps.chartY,
              activeTooltipIndex = nextProps.activeTooltipIndex,
              activeLabel = nextProps.activeLabel,
              activeCoordinate = nextProps.activeCoordinate,
              activePayload = nextProps.activePayload,
              isTooltipActive = nextProps.isTooltipActive,
              restNextProps = _objectWithoutProperties(nextProps, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);

          var _props = this.props,
              graphicalItemsOld = _props.graphicalItems,
              childrenOld = _props.children,
              chartXOld = _props.chartX,
              chartYOld = _props.chartY,
              aTIOld = _props.activeTooltipIndex,
              aLOld = _props.activeLabel,
              aCOld = _props.activeCoordinate,
              aPOld = _props.activePayload,
              iTAOld = _props.isTooltipActive,
              restOldProps = _objectWithoutProperties(_props, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);

          /* eslint-enable no-unused-vars */


          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(graphicalItems, graphicalItemsOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(children, childrenOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(restNextProps, restOldProps)) {
            this.setState(this.calculateExpensiveState({ props: nextProps }));
          }
        }
        /*
         * Ignore the state generated by calculateExpensiveState when determining
         * whether to update
         */

      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref4, nextState) {
          var graphicalItems = _ref4.graphicalItems,
              restProps = _objectWithoutProperties(_ref4, ['graphicalItems']);

          // props.graphicalItems is sometimes generated every time -
          // check that specially as object equality is likely to fail
          var _props2 = this.props,
              graphicalItemsOld = _props2.graphicalItems,
              restPropsOld = _objectWithoutProperties(_props2, ['graphicalItems']);

          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(graphicalItems, graphicalItemsOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(restProps, restPropsOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PureRender__["b" /* shallowEqual */])(nextState, this.state);
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({}, this.props, this.state));
        }
      }]);

      return ComposedDataDecorator;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = 'ComposedDataDecorator(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["f" /* getDisplayName */])(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
      chartX: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
      chartY: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
      data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
    }), _class.defaultProps = WrappedComponent.defaultProps, _temp2;
  };
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStyleString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStringSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateChartCoordinate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return value + 'px';
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');

  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
    }

    return [].concat(_toConsumableArray(result), [entry]);
  }, []);

  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
  }, '');
};

var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ReactUtils__["h" /* isSsr */])()) {
    return { width: 0, height: 0 };
  }

  var str = '' + text;
  var styleString = getStyleString(style);
  var cacheKey = str + '-' + styleString;

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      document.body.appendChild(measurementSpan);
    }

    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
    measurementSpan.textContent = str;

    var rect = measurementSpan.getBoundingClientRect();
    var result = { width: rect.width, height: rect.height };

    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return { width: 0, height: 0 };
  }
};

var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = { top: 0, left: 0 };

  // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)
  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};

/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */
var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnchorButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AnchorButtonFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_props__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstractButton__ = __webpack_require__(887);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

// HACKHACK: these components should go in separate files
// tslint:disable max-classes-per-file



var Button = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ type: "button" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_props__["a" /* removeNonHTMLProps */])(this.props), this.getCommonButtonProps()), this.renderChildren()));
    };
    Button.displayName = "Blueprint.Button";
    return Button;
}(__WEBPACK_IMPORTED_MODULE_3__abstractButton__["a" /* AbstractButton */]));

var ButtonFactory = __WEBPACK_IMPORTED_MODULE_1_react__["createFactory"](Button);
var AnchorButton = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AnchorButton, _super);
    function AnchorButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnchorButton.prototype.render = function () {
        var _a = this.props, href = _a.href, _b = _a.tabIndex, tabIndex = _b === void 0 ? 0 : _b;
        var commonProps = this.getCommonButtonProps();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ role: "button" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_props__["a" /* removeNonHTMLProps */])(this.props), commonProps, { href: commonProps.disabled ? undefined : href, tabIndex: commonProps.disabled ? undefined : tabIndex }), this.renderChildren()));
    };
    AnchorButton.displayName = "Blueprint.AnchorButton";
    return AnchorButton;
}(__WEBPACK_IMPORTED_MODULE_3__abstractButton__["a" /* AbstractButton */]));

var AnchorButtonFactory = __WEBPACK_IMPORTED_MODULE_1_react__["createFactory"](AnchorButton);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hotkey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyCombo__ = __webpack_require__(451);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */




var Hotkey = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Hotkey, _super);
    function Hotkey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkey.isInstance = function (element) {
        return element != null && element.type === Hotkey;
    };
    Hotkey.prototype.render = function () {
        var _a = this.props, label = _a.label, spreadableProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["label"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "pt-hotkey" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "pt-hotkey-label" }, label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__keyCombo__["a" /* KeyCombo */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, spreadableProps))));
    };
    Hotkey.prototype.validateProps = function (props) {
        if (props.global !== true && props.group == null) {
            throw new Error("non-global <Hotkey>s must define a group");
        }
    };
    Hotkey.defaultProps = {
        allowInInput: false,
        disabled: false,
        global: false,
        preventDefault: false,
        stopPropagation: false,
    };
    return Hotkey;
}(__WEBPACK_IMPORTED_MODULE_2__common__["f" /* AbstractComponent */]));



/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OverlayFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__portal_portal__ = __webpack_require__(457);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var Overlay = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Overlay, _super);
    function Overlay(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refHandlers = {
            container: function (ref) { return (_this.containerElement = ref); },
        };
        _this.handleBackdropMouseDown = function (e) {
            var _a = _this.props, backdropProps = _a.backdropProps, canOutsideClickClose = _a.canOutsideClickClose, enforceFocus = _a.enforceFocus, onClose = _a.onClose;
            if (canOutsideClickClose) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(onClose, e);
            }
            if (enforceFocus) {
                // make sure document.activeElement is updated before bringing the focus back
                _this.bringFocusInsideOverlay();
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(backdropProps.onMouseDown, e);
        };
        _this.handleDocumentClick = function (e) {
            var _a = _this.props, isOpen = _a.isOpen, onClose = _a.onClose;
            var eventTarget = e.target;
            var isClickInOverlay = _this.containerElement != null && _this.containerElement.contains(eventTarget);
            if (isOpen && _this.props.canOutsideClickClose && !isClickInOverlay) {
                // casting to any because this is a native event
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(onClose, e);
            }
        };
        _this.handleContentMount = function () {
            if (_this.props.isOpen) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.didOpen);
            }
            if (_this.props.autoFocus) {
                _this.bringFocusInsideOverlay();
            }
        };
        _this.handleDocumentFocus = function (e) {
            if (_this.props.enforceFocus &&
                _this.containerElement != null &&
                !_this.containerElement.contains(e.target)) {
                // prevent default focus behavior (sometimes auto-scrolls the page)
                e.preventDefault();
                e.stopImmediatePropagation();
                _this.bringFocusInsideOverlay();
            }
        };
        _this.handleKeyDown = function (e) {
            var _a = _this.props, canEscapeKeyClose = _a.canEscapeKeyClose, onClose = _a.onClose;
            if (e.which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ESCAPE"] && canEscapeKeyClose) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(onClose, e);
                // prevent browser-specific escape key behavior (Safari exits fullscreen)
                e.preventDefault();
            }
        };
        _this.state = { hasEverOpened: props.isOpen };
        return _this;
    }
    Overlay_1 = Overlay;
    Overlay.prototype.render = function () {
        // oh snap! no reason to render anything at all if we're being truly lazy
        if (this.props.lazy && !this.state.hasEverOpened) {
            return null;
        }
        var _a = this.props, children = _a.children, className = _a.className, inline = _a.inline, isOpen = _a.isOpen, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
        // add a special class to each child that will automatically set the appropriate
        // CSS position mode under the hood. also, make the container focusable so we can
        // trap focus inside it (via `enforceFocus`).
        var decoratedChildren = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(children, function (child) {
            return __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
                className: __WEBPACK_IMPORTED_MODULE_1_classnames__(child.props.className, __WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_CONTENT"]),
                tabIndex: 0,
            });
        });
        var transitionGroup = (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__, { transitionAppear: true, transitionAppearTimeout: transitionDuration, transitionEnterTimeout: transitionDuration, transitionLeaveTimeout: transitionDuration, transitionName: transitionName },
            this.maybeRenderBackdrop(),
            isOpen ? decoratedChildren : null));
        var mergedClassName = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_OPEN"]] = isOpen,
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_INLINE"]] = inline,
            _b), className);
        var elementProps = {
            className: mergedClassName,
            onKeyDown: this.handleKeyDown,
        };
        if (inline) {
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, elementProps, { ref: this.refHandlers.container }), transitionGroup));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__portal_portal__["a" /* Portal */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, elementProps, { containerRef: this.refHandlers.container, onChildrenMount: this.handleContentMount }), transitionGroup));
        }
        var _b;
    };
    Overlay.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this.overlayWillOpen();
        }
    };
    Overlay.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ hasEverOpened: this.state.hasEverOpened || nextProps.isOpen });
    };
    Overlay.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen && !this.props.isOpen) {
            this.overlayWillClose();
        }
        else if (!prevProps.isOpen && this.props.isOpen) {
            this.overlayWillOpen();
        }
    };
    Overlay.prototype.componentWillUnmount = function () {
        this.overlayWillClose();
    };
    /**
     * @public for testing
     * @internal
     */
    Overlay.prototype.bringFocusInsideOverlay = function () {
        var _this = this;
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(function () {
            // container ref may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            if (_this.containerElement == null || document.activeElement == null || !_this.props.isOpen) {
                return;
            }
            var isFocusOutsideModal = !_this.containerElement.contains(document.activeElement);
            if (isFocusOutsideModal) {
                // element marked autofocus has higher priority than the other clowns
                var autofocusElement = _this.containerElement.querySelector("[autofocus]");
                var wrapperElement = _this.containerElement.querySelector("[tabindex]");
                if (autofocusElement != null) {
                    autofocusElement.focus();
                }
                else if (wrapperElement != null) {
                    wrapperElement.focus();
                }
            }
        });
    };
    Overlay.prototype.maybeRenderBackdrop = function () {
        var _a = this.props, backdropClassName = _a.backdropClassName, backdropProps = _a.backdropProps, hasBackdrop = _a.hasBackdrop, isOpen = _a.isOpen;
        if (hasBackdrop && isOpen) {
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, backdropProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_BACKDROP"], backdropClassName, backdropProps.className), onMouseDown: this.handleBackdropMouseDown, tabIndex: this.props.canOutsideClickClose ? 0 : null })));
        }
        else {
            return undefined;
        }
    };
    Overlay.prototype.overlayWillClose = function () {
        document.removeEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", this.handleDocumentClick);
        var openStack = Overlay_1.openStack;
        var stackIndex = openStack.indexOf(this);
        if (stackIndex !== -1) {
            openStack.splice(stackIndex, 1);
            if (openStack.length > 0) {
                var lastOpenedOverlay = Overlay_1.getLastOpened();
                if (lastOpenedOverlay.props.enforceFocus) {
                    document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
                }
            }
            if (openStack.filter(function (o) { return !o.props.inline && o.props.hasBackdrop; }).length === 0) {
                document.body.classList.remove(__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_OPEN"]);
            }
        }
    };
    Overlay.prototype.overlayWillOpen = function () {
        var openStack = Overlay_1.openStack;
        if (openStack.length > 0) {
            document.removeEventListener("focus", Overlay_1.getLastOpened().handleDocumentFocus, /* useCapture */ true);
        }
        openStack.push(this);
        if (this.props.canOutsideClickClose && !this.props.hasBackdrop) {
            document.addEventListener("mousedown", this.handleDocumentClick);
        }
        if (this.props.enforceFocus) {
            document.addEventListener("focus", this.handleDocumentFocus, /* useCapture */ true);
        }
        if (this.props.inline) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(this.props.didOpen);
            if (this.props.autoFocus) {
                this.bringFocusInsideOverlay();
            }
        }
        else if (this.props.hasBackdrop) {
            // add a class to the body to prevent scrolling of content below the overlay
            document.body.classList.add(__WEBPACK_IMPORTED_MODULE_5__common_classes__["OVERLAY_OPEN"]);
        }
    };
    Overlay.displayName = "Blueprint.Overlay";
    Overlay.defaultProps = {
        autoFocus: true,
        backdropProps: {},
        canEscapeKeyClose: true,
        canOutsideClickClose: true,
        enforceFocus: true,
        hasBackdrop: true,
        inline: false,
        isOpen: false,
        lazy: true,
        transitionDuration: 300,
        transitionName: "pt-overlay",
    };
    Overlay.openStack = [];
    Overlay.getLastOpened = function () { return Overlay_1.openStack[Overlay_1.openStack.length - 1]; };
    Overlay = Overlay_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Overlay);
    return Overlay;
    var Overlay_1;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var OverlayFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Overlay);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemTongHopKeKhai = exports.RowItemCongTacQuanLyNhaNuocKNTC = exports.RowItemXayDungLucLuongThanhTra = exports.ListItemThongKeThanhTraThamNhung = exports.ListItemThongKeThanhTraXayTaiChinhNganSach = exports.ListItemThongKeThanhTraLai = exports.ListItemThongKeThanhTraChuyenNganh = exports.ListItemThongKeThanhTraDatDai = exports.ListItemThongKeThanhTraXayDungCoBan = exports.ListItemThongKeThanhTraHanhChinh = exports.ListItemThongKeXuLyDon = exports.ListItemThongKeGQDTC = exports.ListItemThongKeGQDKN = exports.ListItemThongKeTiepCongDan = exports.RowItemCongTacQuanLyNhaNuoc = exports.RowItemBaoCaoDinhKyChiTiet = exports.RowItemBaoCaoDinhKy = undefined;

var _RowItemBaoCaoDinhKy = __webpack_require__(987);

var _RowItemBaoCaoDinhKy2 = _interopRequireDefault(_RowItemBaoCaoDinhKy);

var _RowItemBaoCaoDinhKyChiTiet = __webpack_require__(988);

var _RowItemBaoCaoDinhKyChiTiet2 = _interopRequireDefault(_RowItemBaoCaoDinhKyChiTiet);

var _RowItemCongTacQuanLyNhaNuoc = __webpack_require__(989);

var _RowItemCongTacQuanLyNhaNuoc2 = _interopRequireDefault(_RowItemCongTacQuanLyNhaNuoc);

var _ListItemThongKeTiepCongDan = __webpack_require__(985);

var _ListItemThongKeTiepCongDan2 = _interopRequireDefault(_ListItemThongKeTiepCongDan);

var _ListItemThongKeGQDKN = __webpack_require__(976);

var _ListItemThongKeGQDKN2 = _interopRequireDefault(_ListItemThongKeGQDKN);

var _ListItemThongKeGQDTC = __webpack_require__(977);

var _ListItemThongKeGQDTC2 = _interopRequireDefault(_ListItemThongKeGQDTC);

var _ListItemThongKeXuLyDon = __webpack_require__(986);

var _ListItemThongKeXuLyDon2 = _interopRequireDefault(_ListItemThongKeXuLyDon);

var _ListItemThongKeThanhTraHanhChinh = __webpack_require__(980);

var _ListItemThongKeThanhTraHanhChinh2 = _interopRequireDefault(_ListItemThongKeThanhTraHanhChinh);

var _ListItemThongKeThanhTraDatDai = __webpack_require__(979);

var _ListItemThongKeThanhTraDatDai2 = _interopRequireDefault(_ListItemThongKeThanhTraDatDai);

var _ListItemThongKeThanhTraXayDungCoBan = __webpack_require__(983);

var _ListItemThongKeThanhTraXayDungCoBan2 = _interopRequireDefault(_ListItemThongKeThanhTraXayDungCoBan);

var _ListItemThongKeThanhTraXayTaiChinhNganSach = __webpack_require__(984);

var _ListItemThongKeThanhTraXayTaiChinhNganSach2 = _interopRequireDefault(_ListItemThongKeThanhTraXayTaiChinhNganSach);

var _ListItemThongKeThanhTraChuyenNganh = __webpack_require__(978);

var _ListItemThongKeThanhTraChuyenNganh2 = _interopRequireDefault(_ListItemThongKeThanhTraChuyenNganh);

var _ListItemThongKeThanhTraLai = __webpack_require__(981);

var _ListItemThongKeThanhTraLai2 = _interopRequireDefault(_ListItemThongKeThanhTraLai);

var _ListItemThongKeThanhTraThamNhung = __webpack_require__(982);

var _ListItemThongKeThanhTraThamNhung2 = _interopRequireDefault(_ListItemThongKeThanhTraThamNhung);

var _RowItemXayDungLucLuongThanhTra = __webpack_require__(992);

var _RowItemXayDungLucLuongThanhTra2 = _interopRequireDefault(_RowItemXayDungLucLuongThanhTra);

var _RowItemCongTacQuanLyNhaNuocKNTC = __webpack_require__(990);

var _RowItemCongTacQuanLyNhaNuocKNTC2 = _interopRequireDefault(_RowItemCongTacQuanLyNhaNuocKNTC);

var _RowItemTongHopKeKhai = __webpack_require__(991);

var _RowItemTongHopKeKhai2 = _interopRequireDefault(_RowItemTongHopKeKhai);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemBaoCaoDinhKy = _RowItemBaoCaoDinhKy2.default;
exports.RowItemBaoCaoDinhKyChiTiet = _RowItemBaoCaoDinhKyChiTiet2.default;
exports.RowItemCongTacQuanLyNhaNuoc = _RowItemCongTacQuanLyNhaNuoc2.default;
exports.ListItemThongKeTiepCongDan = _ListItemThongKeTiepCongDan2.default;
exports.ListItemThongKeGQDKN = _ListItemThongKeGQDKN2.default;
exports.ListItemThongKeGQDTC = _ListItemThongKeGQDTC2.default;
exports.ListItemThongKeXuLyDon = _ListItemThongKeXuLyDon2.default;
exports.ListItemThongKeThanhTraHanhChinh = _ListItemThongKeThanhTraHanhChinh2.default;
exports.ListItemThongKeThanhTraXayDungCoBan = _ListItemThongKeThanhTraXayDungCoBan2.default;
exports.ListItemThongKeThanhTraDatDai = _ListItemThongKeThanhTraDatDai2.default;
exports.ListItemThongKeThanhTraChuyenNganh = _ListItemThongKeThanhTraChuyenNganh2.default;
exports.ListItemThongKeThanhTraLai = _ListItemThongKeThanhTraLai2.default;
exports.ListItemThongKeThanhTraXayTaiChinhNganSach = _ListItemThongKeThanhTraXayTaiChinhNganSach2.default;
exports.ListItemThongKeThanhTraThamNhung = _ListItemThongKeThanhTraThamNhung2.default;
exports.RowItemXayDungLucLuongThanhTra = _RowItemXayDungLucLuongThanhTra2.default;
exports.RowItemCongTacQuanLyNhaNuocKNTC = _RowItemCongTacQuanLyNhaNuocKNTC2.default;
exports.RowItemTongHopKeKhai = _RowItemTongHopKeKhai2.default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonGroup = __webpack_require__(1157);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ButtonGroup2.default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InPhieu = function (_React$Component) {
  _inherits(InPhieu, _React$Component);

  function InPhieu(props, context) {
    _classCallCheck(this, InPhieu);

    var _this = _possibleConstructorReturn(this, (InPhieu.__proto__ || Object.getPrototypeOf(InPhieu)).call(this, props, context));

    _this.state = {
      arrPrint: []
    };
    return _this;
  }

  _createClass(InPhieu, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'ml5 mr5' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
          this.props.loaiDonGiaTri != 'DON_KHIEU_NAI' && this.props.loaiDonGiaTri != 'DON_TO_CAO' && _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "THU_LY") },
            'T\u1EA3i phi\u1EBFu \u0111\u1EC1 xu\u1EA5t th\u1EE5 l\xFD'
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "DU_THAO_THONG_BAO_THU_LY") },
              'T\u1EA3i d\u1EF1 th\u1EA3o th\xF4ng b\xE1o th\u1EE5 l\xFD'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.loaiDonGiaTri == 'DON_TO_CAO' && this.props.trangThaiTTXM == 'GIAO_TTXM' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM") },
              'T\u1EA3i quy\u1EBFt \u0111\u1ECBnh giao nhi\u1EC7m v\u1EE5 x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' && this.props.trangThaiTTXM == 'GIAO_TTXM' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM") },
              'T\u1EA3i quy\u1EBFt \u0111\u1ECBnh giao nhi\u1EC7m v\u1EE5 x\xE1c minh n\u1ED9i dung khi\u1EBFu n\u1EA1i'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' && this.props.trangThaiTTXM == 'GIAO_TTXM' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "PHIEU_GIAO_NHIEM_VU_TTXM") },
              'T\u1EA3i v\u0103n b\u1EA3n giao nhi\u1EC7m v\u1EE5 x\xE1c minh n\u1ED9i dung ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.khongDuDieuKienThuLy && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI") },
            'T\u1EA3i th\xF4ng b\xE1o kh\xF4ng \u0111\u1EE7 \u0111i\u1EC1u ki\u1EC7n th\u1EE5 l\xFD'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.traDonVaHuongDan && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO') },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "HUONG_DAN") },
            'T\u1EA3i v\u0103n b\u1EA3n h\u01B0\u1EDBng d\u1EABn'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.huongDanVietLaiDon && this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH") },
            'T\u1EA3i v\u0103n b\u1EA3n h\u01B0\u1EDBng d\u1EABn'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.chuyenDon && (this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "CHUYEN_DON") },
            'T\u1EA3i phi\u1EBFu chuy\u1EC3n \u0111\u01A1n'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.huongXuLy == _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen && (this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || this.props.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-green-no-bd tt tt-print', onClick: this.props.inPhieu.bind(this, "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN") },
            'T\u1EA3i phi\u1EBFu tr\u1EA3 \u0111\u01A1n chuy\u1EC3n kh\xF4ng \u0111\xFAng th\u1EA9m quy\u1EC1n'
          )
        )
      );
    }
  }]);

  return InPhieu;
}(_react2.default.Component);

InPhieu.defaultProps = {
  huongXuLy: ''
};

exports.default = InPhieu;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LetterHistory = __webpack_require__(1220);

var _LetterHistory2 = _interopRequireDefault(_LetterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LetterHistory2.default;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemDanhMucVanBan = exports.RowItemTheLoaiVanBan = exports.RowItemLinhVucVanBan = exports.RowItemCoQuanBanHanhVanBan = undefined;

var _RowItemCoQuanBanHanhVanBan = __webpack_require__(1256);

var _RowItemCoQuanBanHanhVanBan2 = _interopRequireDefault(_RowItemCoQuanBanHanhVanBan);

var _RowItemLinhVucVanBan = __webpack_require__(1258);

var _RowItemLinhVucVanBan2 = _interopRequireDefault(_RowItemLinhVucVanBan);

var _RowItemTheLoaiVanBan = __webpack_require__(1259);

var _RowItemTheLoaiVanBan2 = _interopRequireDefault(_RowItemTheLoaiVanBan);

var _RowItemDanhMucVanBan = __webpack_require__(1257);

var _RowItemDanhMucVanBan2 = _interopRequireDefault(_RowItemDanhMucVanBan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemCoQuanBanHanhVanBan = _RowItemCoQuanBanHanhVanBan2.default;
exports.RowItemLinhVucVanBan = _RowItemLinhVucVanBan2.default;
exports.RowItemTheLoaiVanBan = _RowItemTheLoaiVanBan2.default;
exports.RowItemDanhMucVanBan = _RowItemDanhMucVanBan2.default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListGroupPeoPleDetailReception = exports.RowItemDocumentDetail = undefined;

var _RowItemDocumentDetail = __webpack_require__(1305);

var _RowItemDocumentDetail2 = _interopRequireDefault(_RowItemDocumentDetail);

var _RowItemListGroupPeoPleDetailReception = __webpack_require__(1306);

var _RowItemListGroupPeoPleDetailReception2 = _interopRequireDefault(_RowItemListGroupPeoPleDetailReception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemDocumentDetail = _RowItemDocumentDetail2.default;
exports.RowItemListGroupPeoPleDetailReception = _RowItemListGroupPeoPleDetailReception2.default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetQuaTheoDoiThucHien = exports.TheoDoiThucHienGQD = exports.XuLyTheoDoiThucHien = exports.DanhSachTheoDoiThucHien = undefined;

var _DanhSachTheoDoiThucHien = __webpack_require__(1384);

var _DanhSachTheoDoiThucHien2 = _interopRequireDefault(_DanhSachTheoDoiThucHien);

var _XuLyTheoDoiThucHien = __webpack_require__(1387);

var _XuLyTheoDoiThucHien2 = _interopRequireDefault(_XuLyTheoDoiThucHien);

var _KetQuaTheoDoiThucHien = __webpack_require__(1385);

var _KetQuaTheoDoiThucHien2 = _interopRequireDefault(_KetQuaTheoDoiThucHien);

var _TheoDoiThucHienGQD = __webpack_require__(1386);

var _TheoDoiThucHienGQD2 = _interopRequireDefault(_TheoDoiThucHienGQD);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhSachTheoDoiThucHien = _DanhSachTheoDoiThucHien2.default;
exports.XuLyTheoDoiThucHien = _XuLyTheoDoiThucHien2.default;
exports.TheoDoiThucHienGQD = _TheoDoiThucHienGQD2.default;
exports.KetQuaTheoDoiThucHien = _KetQuaTheoDoiThucHien2.default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(87);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(152);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(78);
var redefineAll = __webpack_require__(150);
var meta = __webpack_require__(133);
var forOf = __webpack_require__(145);
var anInstance = __webpack_require__(144);
var isObject = __webpack_require__(36);
var fails = __webpack_require__(34);
var $iterDetect = __webpack_require__(246);
var setToStringTag = __webpack_require__(173);
var inheritIfRequired = __webpack_require__(332);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(540);
var redefine = __webpack_require__(78);
var hide = __webpack_require__(77);
var fails = __webpack_require__(34);
var defined = __webpack_require__(103);
var wks = __webpack_require__(43);
var regexpExec = __webpack_require__(340);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(93);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(36);
var cof = __webpack_require__(93);
var MATCH = __webpack_require__(43)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(43)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(132) || !__webpack_require__(34)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(30)[K];
});


/***/ }),
/* 248 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(171);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(68);
var ctx = __webpack_require__(95);
var forOf = __webpack_require__(145);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(97);
var defined = __webpack_require__(103);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var hide = __webpack_require__(77);
var uid = __webpack_require__(153);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDecimalParts;
/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
});

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_js__ = __webpack_require__(1848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path_js__["a"]; });



/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(1849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(1855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(1856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(1857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(1858);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(1859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(1862);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(1864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(1850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(1852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(1853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(1851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1854);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(1860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(1865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(1861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(570);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["c"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 * @format
 * 
 */



var AtomicBlockUtils = __webpack_require__(1911);
var BlockMapBuilder = __webpack_require__(212);
var CharacterMetadata = __webpack_require__(80);
var CompositeDraftDecorator = __webpack_require__(1912);
var ContentBlock = __webpack_require__(156);
var ContentState = __webpack_require__(365);
var DefaultDraftBlockRenderMap = __webpack_require__(366);
var DefaultDraftInlineStyle = __webpack_require__(591);
var DraftEditor = __webpack_require__(1914);
var DraftEditorBlock = __webpack_require__(592);
var DraftEntity = __webpack_require__(266);
var DraftModifier = __webpack_require__(75);
var DraftEntityInstance = __webpack_require__(593);
var EditorState = __webpack_require__(39);
var KeyBindingUtil = __webpack_require__(367);
var RichTextEditorUtil = __webpack_require__(596);
var SelectionState = __webpack_require__(178);

var convertFromDraftStateToRaw = __webpack_require__(1933);
var convertFromHTMLToContentBlocks = __webpack_require__(597);
var convertFromRawToDraftState = __webpack_require__(1934);
var generateRandomKey = __webpack_require__(118);
var getDefaultKeyBinding = __webpack_require__(598);
var getVisibleSelectionRect = __webpack_require__(1957);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,

  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,

  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  SelectionState: SelectionState,

  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};

module.exports = DraftPublic;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */

var DraftEntityInstance = __webpack_require__(593);
var Immutable = __webpack_require__(35);

var invariant = __webpack_require__(21);

var Map = Immutable.Map;


var instances = Map();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

module.exports = DraftEntity;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(610);
var removeEntitiesAtEdges = __webpack_require__(611);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1998);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2110),
    listCacheDelete = __webpack_require__(2111),
    listCacheGet = __webpack_require__(2112),
    listCacheHas = __webpack_require__(2113),
    listCacheSet = __webpack_require__(2114);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(392);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2071),
    baseMatchesProperty = __webpack_require__(2072),
    identity = __webpack_require__(217),
    isArray = __webpack_require__(51),
    property = __webpack_require__(2148);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2107);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(181);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(2089);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var EventPluginRegistry = __webpack_require__(399);
var ReactEventEmitterMixin = __webpack_require__(2206);
var ViewportMetrics = __webpack_require__(810);

var getVendorPrefixedEventName = __webpack_require__(2238);
var isEventSupported = __webpack_require__(410);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(223);
var ViewportMetrics = __webpack_require__(810);

var getEventModifierState = __webpack_require__(408);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);
var DOMNamespaces = __webpack_require__(398);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(406);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2242);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;

var _intersection2 = __webpack_require__(2142);

var _intersection3 = _interopRequireDefault(_intersection2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-console: 0 */
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];

var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
};

var identity = exports.identity = function identity(param) {
  return param;
};

/*
 * @description: convert camel case to dash case
 * string => string
 */
var getDashCase = exports.getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return '-' + v.toLowerCase();
  });
};

/*
 * @description: add compatible style prefix
 * (string, string) => object
 */
var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty({}, name, value);
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;

  return PREFIX_LIST.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
    }

    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
  }, {});
};

var log = exports.log = function log() {
  var _console;

  (_console = console).log.apply(_console, arguments);
};

/*
 * @description: log the value of a varible
 * string => any => any
 */
var debug = exports.debug = function debug(name) {
  return function (item) {
    log(name, item);

    return item;
  };
};

/*
 * @description: log name, args, return value of a function
 * function => function
 */
var debugf = exports.debugf = function debugf(tag, f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var res = f.apply(undefined, args);
    var name = tag || f.name || 'anonymous function';
    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';

    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));

    return res;
  };
};

/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */
var mapObject = exports.mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
  }, {});
};

/*
 * @description: add compatible prefix to style
 * object => object
 */
var translateStyle = exports.translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _extends({}, res, generatePrefixStyle(key, res[key]));
  }, style);
};

var compose = exports.compose = function compose() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse();
  // first function can receive multiply arguments
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);

  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(undefined, arguments));
  };
};

var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
  }).join(',');
};

var isDev = "production" !== 'production';

var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        (function () {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;

          console.warn(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
        })();
      }
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of error bar
*/





var ErrorBar = (_temp = _class = function (_Component) {
  _inherits(ErrorBar, _Component);

  function ErrorBar() {
    _classCallCheck(this, ErrorBar);

    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
  }

  _createClass(ErrorBar, [{
    key: 'renderErrorBars',
    value: function renderErrorBars() {
      var _props = this.props,
          offset = _props.offset,
          layout = _props.layout,
          width = _props.width,
          dataKey = _props.dataKey,
          data = _props.data,
          dataPointFormatter = _props.dataPointFormatter,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis,
          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);

      var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return data.map(function (entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
            x = _dataPointFormatter.x,
            y = _dataPointFormatter.y,
            value = _dataPointFormatter.value,
            errorVal = _dataPointFormatter.errorVal;

        if (!errorVal) {
          return null;
        }

        var xMid = void 0,
            yMid = void 0,
            xMin = void 0,
            yMin = void 0,
            xMax = void 0,
            yMax = void 0,
            scale = void 0,
            coordsTop = void 0,
            coordsMid = void 0,
            coordsBot = void 0,
            lowBound = void 0,
            highBound = void 0;

        if (Array.isArray(errorVal)) {
          lowBound = errorVal[0];
          highBound = errorVal[1];
        } else {
          lowBound = errorVal;
          highBound = errorVal;
        }

        if (layout === 'vertical') {
          scale = xAxis.scale;
          xMid = value;
          yMid = y + offset;
          xMin = scale(xMid - lowBound);
          yMin = yMid + width;
          xMax = scale(xMid + highBound);
          yMax = yMid - width;
          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
        } else if (layout === 'horizontal') {
          scale = yAxis.scale;
          xMid = x + offset;
          yMid = value;
          xMin = xMid - width;
          xMax = xMid + width;
          yMin = scale(yMid - lowBound);
          yMax = scale(yMid + highBound);
          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */],
          _extends({ className: 'recharts-errorBar', key: i }, props),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsTop),
          ';',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsMid),
          ';',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsBot),
          ';'
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */],
        { className: 'recharts-errorBars' },
        this.renderErrorBars()
      );
    }
  }]);

  return ErrorBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  xAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataPointFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stroke: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ErrorBar);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(163);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Line
 */










var ReferenceArea = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceArea, _Component);

  function ReferenceArea() {
    _classCallCheck(this, ReferenceArea);

    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
  }

  _createClass(ReferenceArea, [{
    key: 'getRect',
    value: function getRect(hasX, hasY) {
      var _props = this.props,
          xValue1 = _props.x1,
          xValue2 = _props.x2,
          yValue1 = _props.y1,
          yValue2 = _props.y2,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis;

      var xScale = xAxis.scale;
      var yScale = yAxis.scale;
      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
      var xRange = xScale.range();
      var yRange = yScale.range();
      var x1 = void 0,
          x2 = void 0,
          y1 = void 0,
          y2 = void 0;

      if (hasX && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(xValue1)) {
        x1 = xScale(xValue1) + xOffset;
      } else if (hasY) {
        x1 = xRange[0];
      }
      if (hasX && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(xValue2)) {
        x2 = xScale(xValue2) + xOffset;
      } else if (hasY) {
        x2 = xRange[1];
      }
      if (hasY && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(yValue1)) {
        y1 = yScale(yValue1) + yOffset;
      } else if (hasX) {
        y1 = yRange[0];
      }
      if (hasY && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(yValue2)) {
        y2 = yScale(yValue2) + yOffset;
      } else if (hasX) {
        y2 = yRange[1];
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(x1, xScale) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(x2, xScale) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(y1, yScale) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(y2, yScale)) {
        return {
          x: Math.min(x1, x2),
          y: Math.min(y1, y2),
          width: Math.abs(x2 - x1),
          height: Math.abs(y2 - y1)
        };
      }

      return null;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(_ref) {
      var x = _ref.x,
          y = _ref.y,
          width = _ref.width,
          height = _ref.height;
      var _props2 = this.props,
          label = _props2.label,
          stroke = _props2.stroke;

      var props = _extends({}, label, {
        stroke: 'none',
        fill: stroke,
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle'
      });

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(label, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(label)) {
        return label(props);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'g',
          { className: 'recharts-reference-area-label' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */],
            props,
            label
          )
        );
      }

      return null;
    }
  }, {
    key: 'renderRect',
    value: function renderRect(option, props) {
      var rect = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        rect = option(props);
      } else {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], _extends({}, props, {
          className: 'recharts-reference-area-rect'
        }));
      }

      return rect;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          x1 = _props3.x1,
          x2 = _props3.x2,
          y1 = _props3.y1,
          y2 = _props3.y2;

      var hasX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(x1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(x2);
      var hasY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(y1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(y2);

      if (!hasX && !hasY) {
        return null;
      }

      var rect = this.getRect(hasX, hasY);

      if (!rect) {
        return null;
      }

      var shape = this.props.shape;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-reference-area' },
        this.renderRect(shape, _extends({}, this.props, rect)),
        this.renderLabel(rect)
      );
    }
  }]);

  return ReferenceArea;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),

  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  x2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceArea);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(32);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Line
 */










var ReferenceDot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceDot, _Component);

  function ReferenceDot() {
    _classCallCheck(this, ReferenceDot);

    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
  }

  _createClass(ReferenceDot, [{
    key: 'getCoordinate',
    value: function getCoordinate() {
      var _props = this.props,
          x = _props.x,
          y = _props.y,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis;

      var xScale = xAxis.scale;
      var yScale = yAxis.scale;
      var result = {
        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
      };

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["o" /* validateCoordinateInRange */])(result.cx, xScale) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["o" /* validateCoordinateInRange */])(result.cy, yScale)) {
        return result;
      }

      return null;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(coordinate) {
      var _props2 = this.props,
          label = _props2.label,
          stroke = _props2.stroke;

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(label), {
        stroke: 'none',
        fill: stroke,
        x: coordinate.cx,
        y: coordinate.cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
      });

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(label, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(label)) {
        return label(props);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["k" /* isNumOrStr */])(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'g',
          { className: 'recharts-reference-dot-label' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__component_Text__["a" /* default */],
            props,
            label
          )
        );
      }

      return null;
    }
  }, {
    key: 'renderDot',
    value: function renderDot(option, props) {
      var dot = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Dot__["a" /* default */], _extends({}, props, {
          cx: props.cx,
          cy: props.cy,
          className: 'recharts-reference-dot-dot'
        }));
      }

      return dot;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          x = _props3.x,
          y = _props3.y;

      var isX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["k" /* isNumOrStr */])(x);
      var isY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["k" /* isNumOrStr */])(y);

      if (!isX || !isY) {
        return null;
      }

      var coordinate = this.getCoordinate();

      if (!coordinate) {
        return null;
      }

      var shape = this.props.shape;


      var dotProps = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), coordinate);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-reference-dot' },
        this.renderDot(shape, dotProps),
        this.renderLabel(coordinate)
      );
    }
  }]);

  return ReferenceDot;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  r: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }),
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }),

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceDot);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(32);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Line
 */









var renderLine = function renderLine(option, props) {
  var line = void 0;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
    line = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
    line = option(props);
  } else {
    line = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({}, props, {
      className: 'recharts-reference-line-line'
    }));
  }

  return line;
};

var ReferenceLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceLine, _Component);

  function ReferenceLine() {
    _classCallCheck(this, ReferenceLine);

    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
  }

  _createClass(ReferenceLine, [{
    key: 'getEndPoints',
    value: function getEndPoints(isX, isY) {
      var _props = this.props,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis,
          viewBox = _props.viewBox;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;


      if (isY) {
        var value = this.props.y;
        var scale = yAxis.scale;

        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
        var coord = scale(value) + offset;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(coord, scale)) {
          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
        }
      } else if (isX) {
        var _value = this.props.x;
        var _scale = xAxis.scale;

        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
        var _coord = _scale(_value) + _offset;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["o" /* validateCoordinateInRange */])(_coord, _scale)) {
          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
        }
      }

      return null;
    }
  }, {
    key: 'getLabelProps',
    value: function getLabelProps(isX, isY) {
      var _props2 = this.props,
          xAxis = _props2.xAxis,
          yAxis = _props2.yAxis,
          labelPosition = _props2.labelPosition;


      if (isY) {
        var axis = yAxis;

        if (axis.orientation === 'left' && labelPosition === 'end') {
          return { dx: 6, dy: 6, textAnchor: 'start' };
        }
        if (axis.orientation === 'right' && labelPosition === 'start') {
          return { dx: 6, dy: 6, textAnchor: 'start' };
        }
        return { dx: -6, dy: 6, textAnchor: 'end' };
      } else if (isX) {
        var _axis = xAxis;

        if (_axis.orientation === 'top') {
          return { dy: 6, textAnchor: 'middle' };
        }
        return { dy: -6, textAnchor: 'middle' };
      }

      return null;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(isX, isY, end) {
      var _props3 = this.props,
          label = _props3.label,
          stroke = _props3.stroke;

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(label), {
        stroke: 'none',
        fill: stroke
      }, end, this.getLabelProps(isX, isY));

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(label, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(label)) {
        return label(props);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'g',
          { className: 'recharts-reference-line-label' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */],
            props,
            label
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          x = _props4.x,
          y = _props4.y,
          labelPosition = _props4.labelPosition,
          shape = _props4.shape;

      var isX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(x);
      var isY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["k" /* isNumOrStr */])(y);

      if (!isX && !isY) {
        return null;
      }

      var endPoints = this.getEndPoints(isX, isY);

      if (!endPoints) {
        return null;
      }

      var _endPoints = _slicedToArray(endPoints, 2),
          start = _endPoints[0],
          end = _endPoints[1];

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-reference-line' },
        renderLine(shape, props),
        this.renderLabel(isX, isY, labelPosition === 'start' ? start : end)
      );
    }
  }]);

  return ReferenceLine;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),

  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),

  labelPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'end']),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  labelPosition: 'end'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceLine);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Legend__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_LogUtils__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cartesian_CartesianGrid__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceLine__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceDot__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cartesian_ReferenceArea__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__cartesian_XAxis__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cartesian_YAxis__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_Events__ = __webpack_require__(2313);






var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};

var originCoordinate = { x: 0, y: 0 };

var generateCategoricalChart = function generateCategoricalChart(ChartComponent, GraphicalChild) {
  var _class, _temp;

  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
    _inherits(CategoricalChartWrapper, _Component);

    function CategoricalChartWrapper(props) {
      _classCallCheck(this, CategoricalChartWrapper);

      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));

      _this.handleLegendBBoxUpdate = function (box) {
        if (box && _this.legendInstance) {
          var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex;


          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
          }));
        }
      };

      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
        var _this$props = _this.props,
            syncId = _this$props.syncId,
            layout = _this$props.layout;


        if (syncId === cId && chartId !== _this.uniqueChartId) {
          var dataStartIndex = data.dataStartIndex,
              dataEndIndex = data.dataEndIndex;


          if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(data.dataStartIndex) || !__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(data.dataEndIndex)) {
            _this.setState(_extends({
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex })));
          } else if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(data.activeTooltipIndex)) {
            var chartX = data.chartX,
                chartY = data.chartY,
                activeTooltipIndex = data.activeTooltipIndex;
            var _this$state2 = _this.state,
                offset = _this$state2.offset,
                tooltipTicks = _this$state2.tooltipTicks;

            if (!offset) {
              return;
            }
            var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
            // When a categotical chart is combined with another chart, the value of chartX
            // and chartY may beyond the boundaries.
            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
            var activePayload = _this.getTooltipContent(activeTooltipIndex);
            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
            } : originCoordinate;

            _this.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
          } else {
            _this.setState(data);
          }
        }
      };

      _this.handleBrushChange = function (_ref) {
        var startIndex = _ref.startIndex,
            endIndex = _ref.endIndex;

        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          _this.setState(_extends({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: startIndex, dataEndIndex: endIndex })));

          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var nextState = _extends({}, mouse, { isTooltipActive: true });
          _this.setState(nextState);
          _this.triggerSyncEvent(nextState);

          if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseEnter)) {
            onMouseEnter(nextState, e);
          }
        }
      };

      _this.triggeredAfterMouseMove = function (e) {
        var onMouseMove = _this.props.onMouseMove;

        var mouse = _this.getMouseInfo(e);
        var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };

        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      };

      _this.handleMouseMove = function (e) {
        if (e && __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(e.persist)) {
          e.persist();
          _this.triggeredAfterMouseMove(e);
        }
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;

        var nextState = { isTooltipActive: false };

        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      };

      _this.handleClick = function (e) {
        var onClick = _this.props.onClick;


        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onClick)) {
          var mouse = _this.getMouseInfo(e);

          onClick(mouse, e);
        }
      };

      _this.handleMouseDown = function (e) {
        var onMouseDown = _this.props.onMouseDown;


        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseDown)) {
          var mouse = _this.getMouseInfo(e);

          onMouseDown(mouse, e);
        }
      };

      _this.handleMouseUp = function (e) {
        var onMouseUp = _this.props.onMouseUp;


        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseUp)) {
          var mouse = _this.getMouseInfo(e);

          onMouseUp(mouse, e);
        }
      };

      _this.handleTouchMove = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseMove(e.changedTouches[0]);
        }
      };

      _this.verticalCoordinatesGenerator = function (_ref2) {
        var xAxis = _ref2.xAxis,
            width = _ref2.width,
            height = _ref2.height,
            offset = _ref2.offset;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["a" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__["a" /* default */].defaultProps, xAxis, {
          ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["b" /* getTicksOfAxis */])(xAxis, true),
          viewBox: { x: 0, y: 0, width: width, height: height }
        })), offset.left, offset.left + offset.width);
      };

      _this.horizontalCoordinatesGenerator = function (_ref3) {
        var yAxis = _ref3.yAxis,
            width = _ref3.width,
            height = _ref3.height,
            offset = _ref3.offset;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["a" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__["a" /* default */].defaultProps, yAxis, {
          ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["b" /* getTicksOfAxis */])(yAxis, true),
          viewBox: { x: 0, y: 0, width: width, height: height }
        })), offset.top, offset.top + offset.height);
      };

      _this.axesTicksGenerator = function (axis) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["b" /* getTicksOfAxis */])(axis, true);
      };

      _this.tooltipTicksGenerator = function (_ref4) {
        var layout = _ref4.layout,
            xAxisMap = _ref4.xAxisMap,
            yAxisMap = _ref4.yAxisMap;

        var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
        var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* getAnyElementOfObject */])(axisMap);
        var tooltipTicks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["b" /* getTicksOfAxis */])(axis, false, true);

        return {
          tooltipTicks: tooltipTicks,
          orderedTooltipTicks: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(tooltipTicks, function (o) {
            return o.coordinate;
          }),
          tooltipAxis: axis
        };
      };

      var defaultState = _this.createDefaultState(props);
      _this.state = _extends({}, defaultState, { updateId: 0
      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState)));
      _this.validateAxes();
      _this.uniqueChartId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["c" /* uniqueId */])('recharts');

      if (props.throttleDelay) {
        _this.triggeredAfterMouseMove = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(_this.triggeredAfterMouseMove, props.throttleDelay);
      }
      return _this;
    }

    /* eslint-disable  react/no-did-mount-set-state */


    _createClass(CategoricalChartWrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(this.props.syncId)) {
          this.addListener();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            data = _props.data,
            children = _props.children,
            width = _props.width,
            height = _props.height,
            layout = _props.layout,
            stackOffset = _props.stackOffset,
            margin = _props.margin;


        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_PureRender__["b" /* shallowEqual */])(nextProps.margin, margin)) {
          var defaultState = this.createDefaultState(nextProps);
          this.setState(_extends({}, defaultState, { updateId: this.state.updateId + 1
          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState))));
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["c" /* isChildrenEqual */])(nextProps.children, children)) {
          var _state = this.state,
              dataStartIndex = _state.dataStartIndex,
              dataEndIndex = _state.dataEndIndex;
          // Don't update brush

          var _defaultState = _extends({}, this.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
          });
          this.setState(_extends({}, _defaultState, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, _defaultState))));
        }
        // add syncId
        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(this.props.syncId) && !__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(nextProps.syncId)) {
          this.addListener();
        }
        // remove syncId
        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(this.props.syncId) && __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(nextProps.syncId)) {
          this.removeListener();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(this.props.syncId)) {
          this.removeListener();
        }
        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
          this.triggeredAfterMouseMove.cancel();
        }
      }
      /**
      * Get the configuration of all x-axis or y-axis
      * @param  {Object} props          Latest props
      * @param  {String} axisType       The type of axis
      * @param  {Array}  graphicalItems The instances of item
      * @param  {Object} stackGroups    The items grouped by axisId and stackId
      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
      * @return {Object}          Configuration
      */

    }, {
      key: 'getAxisMap',
      value: function getAxisMap(props, _ref5) {
        var _ref5$axisType = _ref5.axisType,
            axisType = _ref5$axisType === undefined ? 'xAxis' : _ref5$axisType,
            graphicalItems = _ref5.graphicalItems,
            stackGroups = _ref5.stackGroups,
            dataStartIndex = _ref5.dataStartIndex,
            dataEndIndex = _ref5.dataEndIndex;
        var children = props.children;

        var Axis = axisType === 'xAxis' ? __WEBPACK_IMPORTED_MODULE_19__cartesian_XAxis__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_20__cartesian_YAxis__["a" /* default */];
        var axisIdKey = axisType === 'xAxis' ? 'xAxisId' : 'yAxisId';
        // Get all the instance of Axis
        var axes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, Axis);

        var axisMap = {};

        if (axes && axes.length) {
          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
        } else if (graphicalItems && graphicalItems.length) {
          axisMap = this.getAxisMapByItems(props, { graphicalItems: graphicalItems, Axis: Axis, axisType: axisType, axisIdKey: axisIdKey,
            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
        }

        return axisMap;
      }

      /**
       * Get the configuration of axis by the options of axis instance
       * @param  {Object} props         Latest props
       * @param {Array}  axes           The instance of axes
       * @param  {Array} graphicalItems The instances of item
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}      Configuration
       */

    }, {
      key: 'getAxisMapByAxes',
      value: function getAxisMapByAxes(props, _ref6) {
        var axes = _ref6.axes,
            graphicalItems = _ref6.graphicalItems,
            axisType = _ref6.axisType,
            axisIdKey = _ref6.axisIdKey,
            stackGroups = _ref6.stackGroups,
            dataStartIndex = _ref6.dataStartIndex,
            dataEndIndex = _ref6.dataEndIndex;
        var layout = props.layout,
            children = props.children,
            data = props.data,
            stackOffset = props.stackOffset;

        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
        var len = displayedData.length;
        var isCategorial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["c" /* isCategorialAxis */])(layout, axisType);

        // Eliminate duplicated axes
        var axisMap = axes.reduce(function (result, child) {
          var _child$props = child.props,
              type = _child$props.type,
              dataKey = _child$props.dataKey,
              allowDataOverflow = _child$props.allowDataOverflow,
              scale = _child$props.scale;

          var axisId = child.props[axisIdKey];

          if (!result[axisId]) {
            var domain = void 0,
                duplicateDomain = void 0,
                categoricalDomain = void 0;

            if (dataKey) {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["d" /* getDomainOfDataByKey */])(displayedData, dataKey, type);

              if (type === 'category' && isCategorial) {
                var duplicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["d" /* hasDuplicate */])(domain);
                duplicateDomain = duplicate ? domain : null;

                // When category axis has duplicated text, serial numbers are used to generate scale
                domain = duplicate ? __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, len) : domain;
              } else if (type === 'category') {
                // eliminate undefined or null or empty string
                domain = domain.filter(function (entry) {
                  return entry !== '' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(entry);
                });
              }

              if (isCategorial && (type === 'number' || scale !== 'auto')) {
                categoricalDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["d" /* getDomainOfDataByKey */])(displayedData, dataKey, 'category');
              }
            } else if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
              domain = stackOffset === 'expand' ? [0, 1] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["e" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            } else {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["f" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (entry) {
                return entry.props[axisIdKey] === axisId;
              }), type, true);
            }
            if (type === 'number') {
              // To detect wether there is any reference lines whose props alwaysShow is true
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["g" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);

              if (child.props.domain) {
                domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["e" /* parseSpecifiedDomain */])(child.props.domain, domain, allowDataOverflow);
              }
            }

            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
              axisType: axisType,
              domain: domain,
              categoricalDomain: categoricalDomain,
              duplicateDomain: duplicateDomain,
              originalDomain: child.props.domain,
              isCategorial: isCategorial
            })));
          }

          return result;
        }, {});
        return axisMap;
      }

      /**
       * Get the configuration of axis by the options of item,
       * this kind of axis does not display in chart
       * @param  {Object} props         Latest props
       * @param  {Array} graphicalItems The instances of item
       * @param  {ReactElement} Axis    Axis Component
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}               Configuration
       */

    }, {
      key: 'getAxisMapByItems',
      value: function getAxisMapByItems(props, _ref7) {
        var graphicalItems = _ref7.graphicalItems,
            Axis = _ref7.Axis,
            axisType = _ref7.axisType,
            axisIdKey = _ref7.axisIdKey,
            stackGroups = _ref7.stackGroups,
            dataStartIndex = _ref7.dataStartIndex,
            dataEndIndex = _ref7.dataEndIndex;
        var layout = props.layout,
            children = props.children,
            data = props.data;

        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
        var len = displayedData.length;
        var isCategorial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["c" /* isCategorialAxis */])(layout, axisType);
        var index = -1;

        // The default type of x-axis is category axis,
        // The default contents of x-axis is the serial numbers of data
        // The default type of y-axis is number axis
        // The default contents of y-axis is the domain of data
        var axisMap = graphicalItems.reduce(function (result, child) {
          var axisId = child.props[axisIdKey];

          if (!result[axisId]) {
            index++;
            var domain = void 0;

            if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["e" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["g" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            } else {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["e" /* parseSpecifiedDomain */])(Axis.defaultProps.domain, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["f" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (entry) {
                return entry.props[axisIdKey] === axisId;
              }), 'number'), Axis.defaultProps.allowDataOverflow);
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["g" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            }

            return _extends({}, result, _defineProperty({}, axisId, _extends({
              axisType: axisType
            }, Axis.defaultProps, {
              hide: true,
              orientation: ORIENT_MAP[axisType][index % 2],
              domain: domain,
              originalDomain: Axis.defaultProps.domain,
              isCategorial: isCategorial
            })));
          }

          return result;
        }, {});

        return axisMap;
      }
      /**
       * Calculate the scale function, position, width, height of axes
       * @param  {Object} props    Latest props
       * @param  {Object} axisMap  The configuration of axes
       * @param  {Object} offset   The offset of main part in the svg element
       * @param  {Object} axisType The type of axes, x-axis or y-axis
       * @return {Object} Configuration
       */

    }, {
      key: 'getFormatAxisMap',
      value: function getFormatAxisMap(props, axisMap, offset, axisType) {
        var width = props.width,
            height = props.height,
            layout = props.layout;

        var displayName = this.constructor.displayName;
        var ids = Object.keys(axisMap);
        var steps = {
          left: offset.left,
          leftMirror: offset.left,
          right: width - offset.right,
          rightMirror: width - offset.right,
          top: offset.top,
          topMirror: offset.top,
          bottom: height - offset.bottom,
          bottomMirror: height - offset.bottom
        };

        return ids.reduce(function (result, id) {
          var axis = axisMap[id];
          var orientation = axis.orientation,
              domain = axis.domain,
              _axis$padding = axis.padding,
              padding = _axis$padding === undefined ? {} : _axis$padding,
              mirror = axis.mirror,
              reversed = axis.reversed;

          var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');

          var range = void 0,
              x = void 0,
              y = void 0,
              needSpace = void 0;

          if (axisType === 'xAxis') {
            range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
          } else {
            range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
          }

          if (reversed) {
            range = [range[1], range[0]];
          }

          var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["f" /* parseScale */])(axis, displayName);
          scale.domain(domain).range(range);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["g" /* checkDomainOfScale */])(scale);
          var ticks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["h" /* getTicksOfScale */])(scale, axis);

          if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
          } else {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
          }

          var finalAxis = _extends({}, axis, ticks, {
            range: range, x: x, y: y, scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
          });
          if (!axis.hide && axisType === 'xAxis') {
            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
          } else if (!axis.hide) {
            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
          }

          return _extends({}, result, _defineProperty({}, id, finalAxis));
        }, {});
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {Object} event    The event object
       * @return {Object}          Mouse data
       */

    }, {
      key: 'getMouseInfo',
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }

        var offset = this.state.offset;

        var containerOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["a" /* getOffset */])(this.container);
        var e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["b" /* calculateChartCoordinate */])(event, containerOffset);
        var isIn = e.chartX >= offset.left && e.chartX <= offset.left + offset.width && e.chartY >= offset.top && e.chartY <= offset.top + offset.height;

        if (!isIn) {
          return null;
        }

        var layout = this.props.layout;
        var _state2 = this.state,
            ticks = _state2.orderedTooltipTicks,
            axis = _state2.tooltipAxis,
            tooltipTicks = _state2.tooltipTicks;

        var pos = layout === 'horizontal' ? e.chartX : e.chartY;
        var activeIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["i" /* calculateActiveTickIndex */])(pos, ticks, axis);

        if (activeIndex >= 0) {
          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
          var activePayload = this.getTooltipContent(activeIndex);
          var activeCoordinate = tooltipTicks[activeIndex] ? {
            x: layout === 'horizontal' ? tooltipTicks[activeIndex].coordinate : e.chartX,
            y: layout === 'horizontal' ? e.chartY : tooltipTicks[activeIndex].coordinate
          } : originCoordinate;

          return _extends({}, e, {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
          });
        }

        return null;
      }
      /**
       * Get the content to be displayed in the tooltip
       * @param  {Number} activeIndex    Active index of data
       * @return {Array}                 The content of tooltip
       */

    }, {
      key: 'getTooltipContent',
      value: function getTooltipContent(activeIndex) {
        var _state3 = this.state,
            dataStartIndex = _state3.dataStartIndex,
            dataEndIndex = _state3.dataEndIndex,
            graphicalItems = _state3.graphicalItems;

        var data = this.props.data.slice(dataStartIndex, dataEndIndex + 1);

        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= data.length) {
          return null;
        }

        return graphicalItems.map(function (child) {
          var _child$props2 = child.props,
              dataKey = _child$props2.dataKey,
              name = _child$props2.name,
              unit = _child$props2.unit,
              formatter = _child$props2.formatter;


          return _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(child), {
            dataKey: dataKey, unit: unit, formatter: formatter,
            name: name || dataKey,
            color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["j" /* getMainColorOfGraphicItem */])(child),
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["h" /* getValueByDataKey */])(data[activeIndex], dataKey),
            payload: data[activeIndex]
          });
        });
      }

      /**
       * The AxisMaps are expensive to render on large data sets
       * so provide the ability to store them in state and only update them when necessary
       * they are dependent upon the start and end index of
       * the brush so it's important that this method is called _after_
       * the state is updated with any new start/end indices
       *
       * @param {Object} props The props object to be used for updating the axismaps
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex The end index of the data series when a brush is applied
       * @return {Object} state New state to set
       */

    }, {
      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
        var props = _ref8.props,
            dataStartIndex = _ref8.dataStartIndex,
            dataEndIndex = _ref8.dataEndIndex;
        var data = props.data;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["e" /* validateWidthHeight */])({ props: props }) || !data || !data.length) {
          return null;
        }

        var children = props.children,
            layout = props.layout,
            stackOffset = props.stackOffset;

        var numericIdName = layout === 'horizontal' ? 'yAxis' : 'xAxis';
        var cateIdName = layout === 'horizontal' ? 'xAxis' : 'yAxis';
        var graphicalItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, GraphicalChild);
        var stackGroups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["k" /* getStackGroupsByAxisId */])(data, graphicalItems, numericIdName + 'Id', cateIdName + 'Id', stackOffset);

        var xAxisMap = this.getAxisMap(props, {
          axisType: 'xAxis',
          graphicalItems: graphicalItems,
          stackGroups: numericIdName === 'xAxis' && stackGroups,
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex
        });

        var yAxisMap = this.getAxisMap(props, {
          axisType: 'yAxis',
          graphicalItems: graphicalItems,
          stackGroups: numericIdName === 'yAxis' && stackGroups,
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex
        });

        var offset = this.calculateOffset(props, graphicalItems, xAxisMap, yAxisMap);

        xAxisMap = this.getFormatAxisMap(props, xAxisMap, offset, 'xAxis');
        yAxisMap = this.getFormatAxisMap(props, yAxisMap, offset, 'yAxis');

        var ticksObj = this.tooltipTicksGenerator({
          layout: layout, xAxisMap: xAxisMap, yAxisMap: yAxisMap
        });

        return _extends({ graphicalItems: graphicalItems, xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset, stackGroups: stackGroups }, ticksObj);
      }

      /* eslint-disable  no-underscore-dangle */

    }, {
      key: 'addListener',
      value: function addListener() {
        __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].on(__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */]._maxListeners + 1);
        }
      }
    }, {
      key: 'removeListener',
      value: function removeListener() {
        __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].removeListener(__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */]._maxListeners - 1);
        }
      }
      /**
       * Returns default, reset state for the categorical chart.
       * @param {Object} props Props object to use when creating the default state
       * @return {Object} Whole new state
       */

    }, {
      key: 'createDefaultState',
      value: function createDefaultState(props) {
        var children = props.children;

        var brushItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
        var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
        var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
        return {
          chartX: 0,
          chartY: 0,
          dataStartIndex: startIndex,
          dataEndIndex: endIndex,
          activeTooltipIndex: -1,
          isTooltipActive: false
        };
      }
      /**
       * Calculate the offset of main part in the svg element
       * @param  {Object} props          Latest props
       * @param  {Array}  graphicalItems The instances of item
       * @param  {Object} xAxisMap       The configuration of x-axis
       * @param  {Object} yAxisMap       The configuration of y-axis
       * @return {Object} The offset of main part in the svg element
       */

    }, {
      key: 'calculateOffset',
      value: function calculateOffset(props, graphicalItems, xAxisMap, yAxisMap) {
        var width = props.width,
            height = props.height,
            children = props.children;

        var margin = props.margin || {};
        var brushItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
        var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Legend__["a" /* default */]);

        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
          var entry = yAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
          }

          return result;
        }, { left: margin.left || 0, right: margin.right || 0 });

        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
          var entry = xAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
          }

          return result;
        }, { top: margin.top || 0, bottom: margin.bottom || 0 });

        var offset = _extends({}, offsetV, offsetH);

        var brushBottom = offset.bottom;

        if (brushItem) {
          offset.bottom += brushItem.props.height || __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */].defaultProps.height;
        }

        if (legendItem && this.legendInstance) {
          var legendBox = this.legendInstance.getBBox();
          offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["l" /* appendOffsetOfLegend */])(offset, graphicalItems, props, legendBox);
        }

        return _extends({
          brushBottom: brushBottom
        }, offset, {
          width: width - offset.left - offset.right,
          height: height - offset.top - offset.bottom
        });
      }
      /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */


      /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */

      /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */

    }, {
      key: 'validateAxes',
      value: function validateAxes() {
        var _props2 = this.props,
            layout = _props2.layout,
            children = _props2.children;

        var xAxes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_19__cartesian_XAxis__["a" /* default */]);
        var yAxes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_20__cartesian_YAxis__["a" /* default */]);

        if (layout === 'horizontal' && xAxes && xAxes.length) {
          xAxes.forEach(function (axis) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_LogUtils__["a" /* warn */])(axis.props.type === 'category' || axis.props.type === 'number' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(axis.props.dataKey), 'x-axis should be a category axis or a number axis which has specifed dataKey\n             when the layout is horizontal');
          });
        } else if (layout === 'vertical') {
          var displayName = this.constructor.displayName;

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_LogUtils__["a" /* warn */])(yAxes && yAxes.length, 'You should add <YAxis type="number" /> in ' + displayName + '.\n           The layout is vertical now, y-axis should be category axis,\n           but y-axis is number axis when no YAxis is added.');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_LogUtils__["a" /* warn */])(xAxes && xAxes.length, 'You should add <XAxis /> in ' + displayName + '.\n          The layout is vertical now, x-axis is category when no XAxis is added.');

          if (yAxes && yAxes.length) {
            yAxes.forEach(function (axis) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_LogUtils__["a" /* warn */])(axis.props.type === 'category' || axis.props.type === 'number' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(axis.props.dataKey), 'y-axis should be a category axis or a number axis which has specifed dataKey\n               when the layout is vertical');
            });
          }
        }

        return null;
      }
    }, {
      key: 'triggerSyncEvent',
      value: function triggerSyncEvent(data) {
        var syncId = this.props.syncId;


        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(syncId)) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* eventCenter */].emit(__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* SYNC_EVENT */], syncId, this.uniqueChartId, data);
        }
      }
    }, {
      key: 'renderAxes',


      /**
       * Draw axes
       * @param {Object} axisMap The configuration of all x-axes or y-axes
       * @param {String} name    The name of axes
       * @return {ReactElement}  The instance of x-axes
       */
      value: function renderAxes(axisMap, name) {
        var _props3 = this.props,
            width = _props3.width,
            height = _props3.height;

        var ids = axisMap && Object.keys(axisMap);

        if (ids && ids.length) {
          var axes = [];

          for (var i = 0, len = ids.length; i < len; i++) {
            var axis = axisMap[ids[i]];

            if (!axis.hide) {

              axes.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__cartesian_CartesianAxis__["a" /* default */], _extends({}, axis, {
                key: name + '-' + ids[i],
                viewBox: { x: 0, y: 0, width: width, height: height },
                ticksGenerator: this.axesTicksGenerator
              })));
            }
          }

          return axes.length ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
            { key: name + '-layer', className: 'recharts-' + name },
            axes
          ) : null;
        }

        return null;
      }

      /**
       * Draw grid
       * @return {ReactElement} The instance of grid
       */

    }, {
      key: 'renderGrid',
      value: function renderGrid() {
        var _state4 = this.state,
            xAxisMap = _state4.xAxisMap,
            yAxisMap = _state4.yAxisMap,
            offset = _state4.offset;
        var _props4 = this.props,
            children = _props4.children,
            width = _props4.width,
            height = _props4.height;

        var gridItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_15__cartesian_CartesianGrid__["a" /* default */]);

        if (!gridItem) {
          return null;
        }

        var xAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* getAnyElementOfObject */])(xAxisMap);
        var yAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* getAnyElementOfObject */])(yAxisMap);

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(gridItem, {
          key: 'grid',
          x: offset.left,
          y: offset.top,
          width: offset.width,
          height: offset.height,
          xAxis: xAxis,
          yAxis: yAxis,
          offset: offset,
          chartWidth: width,
          chartHeight: height,
          verticalCoordinatesGenerator: this.verticalCoordinatesGenerator,
          horizontalCoordinatesGenerator: this.horizontalCoordinatesGenerator
        });
      }
      /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */

    }, {
      key: 'renderLegend',
      value: function renderLegend() {
        var _this2 = this;

        var graphicalItems = this.state.graphicalItems;
        var _props5 = this.props,
            children = _props5.children,
            width = _props5.width,
            height = _props5.height;

        var margin = this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_CartesianUtils__["m" /* getLegendProps */])(children, graphicalItems, legendWidth, legendHeight);

        if (!props) {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__component_Legend__["a" /* default */], _extends({}, props, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          ref: function ref(legend) {
            _this2.legendInstance = legend;
          },
          onBBoxUpdate: this.handleLegendBBoxUpdate
        }));
      }

      /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */

    }, {
      key: 'renderTooltip',
      value: function renderTooltip() {
        var children = this.props.children;

        var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

        if (!tooltipItem) {
          return null;
        }

        var _state5 = this.state,
            isTooltipActive = _state5.isTooltipActive,
            activeCoordinate = _state5.activeCoordinate,
            activePayload = _state5.activePayload,
            activeLabel = _state5.activeLabel,
            offset = _state5.offset;


        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(tooltipItem, {
          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
          active: isTooltipActive,
          label: activeLabel,
          payload: isTooltipActive ? activePayload : [],
          coordinate: activeCoordinate
        });
      }
    }, {
      key: 'renderBrush',
      value: function renderBrush() {
        var _props6 = this.props,
            children = _props6.children,
            margin = _props6.margin,
            data = _props6.data;
        var _state6 = this.state,
            offset = _state6.offset,
            dataStartIndex = _state6.dataStartIndex,
            dataEndIndex = _state6.dataEndIndex,
            updateId = _state6.updateId;

        var brushItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);

        if (!brushItem) {
          return null;
        }

        // TODO: update brush when children update
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(brushItem, {
          onChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* combineEventHandlers */])(this.handleBrushChange, null, brushItem.props.onChange),
          data: data,
          x: offset.left,
          y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: 'brush-' + updateId
        });
      }
    }, {
      key: 'renderReferenceElements',
      value: function renderReferenceElements(isFront, Compt) {
        var children = this.props.children;

        var elements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, Compt);

        if (!elements || !elements.length) {
          return null;
        }

        var _state7 = this.state,
            xAxisMap = _state7.xAxisMap,
            yAxisMap = _state7.yAxisMap,
            offset = _state7.offset;

        var keyPrefix = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["f" /* getDisplayName */])(Compt) + '-' + (isFront ? 'front' : 'back');

        return elements.filter(function (entry) {
          return isFront === entry.props.isFront;
        }).map(function (entry, i) {
          var _entry$props = entry.props,
              xAxisId = _entry$props.xAxisId,
              yAxisId = _entry$props.yAxisId;


          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(entry, {
            key: keyPrefix + '-' + i,
            xAxis: xAxisMap[xAxisId],
            yAxis: yAxisMap[yAxisId],
            viewBox: {
              x: offset.left,
              y: offset.top,
              width: offset.width,
              height: offset.height
            }
          });
        });
      }
    }, {
      key: 'renderChart',
      value: function renderChart() {
        var _props7 = this.props,
            children = _props7.children,
            width = _props7.width,
            height = _props7.height,
            others = _objectWithoutProperties(_props7, ['children', 'width', 'height']);

        var _state8 = this.state,
            xAxisMap = _state8.xAxisMap,
            yAxisMap = _state8.yAxisMap;

        var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderGrid(),
          this.renderReferenceElements(false, __WEBPACK_IMPORTED_MODULE_18__cartesian_ReferenceArea__["a" /* default */]),
          this.renderReferenceElements(false, __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceLine__["a" /* default */]),
          this.renderReferenceElements(false, __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceDot__["a" /* default */]),
          this.renderAxes(xAxisMap, 'x-axis'),
          this.renderAxes(yAxisMap, 'y-axis'),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChartComponent, _extends({}, this.props, this.state)),
          this.renderReferenceElements(true, __WEBPACK_IMPORTED_MODULE_18__cartesian_ReferenceArea__["a" /* default */]),
          this.renderReferenceElements(true, __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceLine__["a" /* default */]),
          this.renderReferenceElements(true, __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceDot__["a" /* default */]),
          this.renderBrush(),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["g" /* filterSvgElements */])(children)
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var data = this.props.data;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["e" /* validateWidthHeight */])(this) || !data || !data.length) {
          return null;
        }

        var _props8 = this.props,
            className = _props8.className,
            width = _props8.width,
            height = _props8.height,
            style = _props8.style,
            compact = _props8.compact;


        var events = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleClick,
          onMouseDown: this.handleMouseDown,
          onMouseUp: this.handleMouseUp,
          onTouchMove: this.handleTouchMove
        };

        // The "compact" mode is mainly used as the panorama within Brush
        if (compact) {
          return this.renderChart();
        }

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('recharts-wrapper', className),
            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
          }, events, {
            ref: function ref(node) {
              _this3.container = node;
            }
          }),
          this.renderChart(),
          this.renderLegend(),
          this.renderTooltip()
        );
      }
    }]);

    return CategoricalChartWrapper;
  }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]), _class.displayName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["f" /* getDisplayName */])(ChartComponent), _class.propTypes = _extends({}, ChartComponent.propTypes, {
    syncId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
    compact: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
    layout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical']),
    stackOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
    throttleDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    margin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      top: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
      right: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
      bottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
      left: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
    }),
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }), _class.defaultProps = {
    layout: 'horizontal',
    stackOffset: 'none',
    margin: { top: 5, right: 5, bottom: 5, left: 5 }
  }, _temp);


  return CategoricalChartWrapper;
};

/* harmony default export */ __webpack_exports__["a"] = (generateCategoricalChart);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export offsetSign */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return detectReferenceElementsDomain; });
/* unused harmony export getStackedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStackGroupsByAxisId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStackedDataOfItem; });
/* unused harmony export calculateDomainOfTicks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDomainOfDataByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDomainOfStackGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDomainOfItemsWithSameAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCategorialAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCoordinatesOfGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTicksOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return calculateActiveTickIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMainColorOfGraphicItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getLegendProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTicksOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getBarSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getBarPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return appendOffsetOfLegend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recharts_scale__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recharts_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recharts_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_shape__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesian_ReferenceDot__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartesian_ReferenceLine__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cartesian_ReferenceArea__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Legend__ = __webpack_require__(161);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











/* eslint no-param-reassign: 0 */
var offsetSign = function offsetSign(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
    }
  }
};

var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: __WEBPACK_IMPORTED_MODULE_3_d3_shape__["a" /* stackOffsetExpand */],
  none: __WEBPACK_IMPORTED_MODULE_3_d3_shape__["b" /* stackOffsetNone */],
  silhouette: __WEBPACK_IMPORTED_MODULE_3_d3_shape__["c" /* stackOffsetSilhouette */],
  wiggle: __WEBPACK_IMPORTED_MODULE_3_d3_shape__["d" /* stackOffsetWiggle */]
};

var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
  var lines = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_7__cartesian_ReferenceLine__["a" /* default */]);
  var dots = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_6__cartesian_ReferenceDot__["a" /* default */]);
  var elements = lines.concat(dots);
  var areas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_8__cartesian_ReferenceArea__["a" /* default */]);
  var idKey = axisType + 'Id';
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && el.props.alwaysShow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])(el.props[valueKey])) {
        var value = el.props[valueKey];

        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }

  if (areas.length) {
    (function () {
      var key1 = valueKey + '1';
      var key2 = valueKey + '2';

      finalDomain = areas.reduce(function (result, el) {
        if (el.props[idKey] === axisId && el.props.alwaysShow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])(el.props[key1]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])(el.props[key2])) {
          var value1 = el.props[key1];
          var value2 = el.props[key2];

          return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
        }
        return result;
      }, finalDomain);
    })();
  }

  return finalDomain;
};

var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_shape__["e" /* stack */])().keys(dataKeys).value(function (d, key) {
    return +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* getValueByDataKey */])(d, key, 0);
  }).order(__WEBPACK_IMPORTED_MODULE_3_d3_shape__["f" /* stackOrderNone */]).offset(STACK_OFFSET_MAP[offsetType]);

  return stack(data);
};

var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
  var stackGroups = items.reduce(function (result, item) {
    var stackId = item.props.stackId;

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["k" /* isNumOrStr */])(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
      };

      childGroup.items = [item].concat(childGroup.items);

      parentGroup.hasStack = true;

      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["c" /* uniqueId */])('_stackId_')] = {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
      };
    }

    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
  }, {});

  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];

        return _extends({}, res, _defineProperty({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, {});
    }

    return _extends({}, result, _defineProperty({}, axisId, group));
  }, {});
};

var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["k" /* isNumOrStr */])(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};
/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */
var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
  }

  return ticks;
};

/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */
var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = data.reduce(function (result, entry) {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["h" /* getValueByDataKey */])(entry, key);

    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(value)) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
    }

    return [].concat(_toConsumableArray(result), [value]);
  }, []);

  if (type === 'number') {
    var domain = flattenData.filter(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */]);

    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry);
  }) : flattenData;

  return validateData.map(function (entry) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["k" /* isNumOrStr */])(entry) ? entry : '';
  });
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [Math.min.apply(null, entry.concat([result[0]]).filter(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])), Math.max.apply(null, entry.concat([result[1]]).filter(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */]))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;

    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));

      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);

    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};

/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    return getDomainOfDataByKey(data, item.props.dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {};
  // Get the union set of category axis
  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;

        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};

var isCategorialAxis = function isCategorialAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis';
};
/**
* Calculate the Coordinates of grid
* @param  {Array} ticks The ticks in axis
* @param {Number} min   The minimun value of axis
* @param {Number} max   The maximun value of axis
* @return {Array}       Coordinates
*/
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin = void 0,
      hasMax = void 0;

  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }
    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }
  if (!hasMax) {
    values.push(max);
  }

  return values;
};

/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type,
      domain = axis.domain;

  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;

  // The ticks setted by user should only affect the ticks adjacent to axis line
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;

      return {
        coordinate: scale(scaleContent) + offset,
        value: entry
      };
    });
  }

  if (axis.isCategorial && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry),
        value: entry,
        index: index
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return { coordinate: scale(entry) + offset, value: entry };
    });
  }

  // When axis has duplicated text, serial numbers are used to generate scale
  return (duplicateDomain || domain).map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: entry,
      index: index
    };
  });
};

var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
  var index = -1;
  var len = ticks.length;

  if (len > 1) {
    for (var i = 0; i < len; i++) {
      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
        index = ticks[i].index;
        break;
      }
    }
  } else {
    index = 0;
  }

  return index;
};

/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var displayName = item.type.displayName;
  var result = void 0;

  switch (displayName) {
    case 'Line':
    case 'Area':
      result = item.props.stroke;
      break;
    default:
      result = item.props.fill;
      break;
  }

  return result;
};

var getLegendProps = function getLegendProps(children, graphicItems, width) {
  var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Legend__["a" /* default */]);

  if (!legendItem) {
    return null;
  }

  var legendData = legendItem.props && legendItem.props.payload || graphicItems.map(function (child) {
    var _child$props = child.props,
        dataKey = _child$props.dataKey,
        name = _child$props.name,
        legendType = _child$props.legendType;


    return {
      dataKey: dataKey,
      type: legendItem.props.iconType || legendType || 'square',
      color: getMainColorOfGraphicItem(child),
      value: name || dataKey,
      payload: child.props
    };
  });

  return _extends({}, legendItem.props, __WEBPACK_IMPORTED_MODULE_9__component_Legend__["a" /* default */].getWithHeight(legendItem, width), {
    payload: legendData
  });
};
/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */
var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;


  if (opts.scale !== 'auto' && opts.scale !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    var tickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_recharts_scale__["getNiceTickValues"])(domain, tickCount, allowDecimals);

    scale.domain(calculateDomainOfTicks(tickValues, type));

    return { niceTicks: tickValues };
  } else if (tickCount && type === 'number') {
    var _domain = scale.domain();
    var _tickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_recharts_scale__["getTickValuesFixedDomain"])(_domain, tickCount, allowDecimals);

    return { niceTicks: _tickValues };
  }

  return null;
};

/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */
var getBarSizeList = function getBarSizeList(_ref) {
  var globalSize = _ref.barSize,
      _ref$stackGroups = _ref.stackGroups,
      stackGroups = _ref$stackGroups === undefined ? {} : _ref$stackGroups;

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;


      var barItems = items.filter(function (item) {
        return item.type.displayName === 'Bar';
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;

        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};

/**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandSize  The size of each category
   * @param  {sizeList} sizeList  The size of all groups
   * @param  {maxBarSize} maxBarSize The maximum size of bar
   * @return {Number} The size of each bar and the gap between two bars
   */
var getBarPosition = function getBarPosition(_ref2) {
  var barGap = _ref2.barGap,
      barCategoryGap = _ref2.barCategoryGap,
      bandSize = _ref2.bandSize,
      _ref2$sizeList = _ref2.sizeList,
      sizeList = _ref2$sizeList === undefined ? [] : _ref2$sizeList,
      maxBarSize = _ref2.maxBarSize;

  var len = sizeList.length;
  if (len < 1) return null;

  var realBarGap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["l" /* getPercentValue */])(barGap, bandSize, 0, true);
  var result = void 0;

  // whether or not is barSize setted by user
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    (function () {
      var useFull = false;
      var fullBarSize = bandSize / len;
      var sum = sizeList.reduce(function (res, entry) {
        return res + entry.barSize || 0;
      }, 0);
      sum += (len - 1) * realBarGap;

      if (sum >= bandSize) {
        sum -= (len - 1) * realBarGap;
        realBarGap = 0;
      }
      if (sum >= bandSize && fullBarSize > 0) {
        useFull = true;
        fullBarSize *= 0.9;
        sum = len * fullBarSize;
      }

      var offset = (bandSize - sum) / 2 >> 0;
      var prev = { offset: offset - realBarGap, size: 0 };

      result = sizeList.reduce(function (res, entry) {
        var newRes = [].concat(_toConsumableArray(res), [{
          item: entry.item,
          position: {
            offset: prev.offset + prev.size + realBarGap,
            size: useFull ? fullBarSize : entry.barSize
          }
        }]);

        prev = newRes[newRes.length - 1].position;

        if (entry.stackList && entry.stackList.length) {
          entry.stackList.forEach(function (item) {
            newRes.push({ item: item, position: prev });
          });
        }
        return newRes;
      }, []);
    })();
  } else {
    (function () {
      var offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["l" /* getPercentValue */])(barCategoryGap, bandSize, 0, true);

      if (bandSize - 2 * offset - (len - 1) * realBarGap <= 0) {
        realBarGap = 0;
      }

      var originalSize = (bandSize - 2 * offset - (len - 1) * realBarGap) / len;
      if (originalSize > 1) {
        originalSize >>= 0;
      }
      var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;

      result = sizeList.reduce(function (res, entry, i) {
        var newRes = [].concat(_toConsumableArray(res), [{
          item: entry.item,
          position: {
            offset: offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
            size: size
          }
        }]);

        if (entry.stackList && entry.stackList.length) {
          entry.stackList.forEach(function (item) {
            newRes.push({ item: item, position: newRes[newRes.length - 1].position });
          });
        }
        return newRes;
      }, []);
    })();
  }

  return result;
};

var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      height = props.height,
      margin = props.margin;

  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps(children, items, legendWidth, legendHeight);
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;


    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])(offset[align])) {
      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["j" /* isNumber */])(offset[verticalAlign])) {
      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
  }

  return newOffset;
};

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyCodes */
/* unused harmony export Modifiers */
/* unused harmony export ModifierBitMasks */
/* unused harmony export Aliases */
/* unused harmony export ShiftKeys */
/* harmony export (immutable) */ __webpack_exports__["a"] = comboMatches;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseKeyCombo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKeyComboString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getKeyCombo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return normalizeKeyCombo; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var KeyCodes = {
    8: "backspace",
    9: "tab",
    13: "enter",
    20: "capslock",
    27: "esc",
    32: "space",
    33: "pageup",
    34: "pagedown",
    35: "end",
    36: "home",
    37: "left",
    38: "up",
    39: "right",
    40: "down",
    45: "ins",
    46: "del",
    // number keys
    48: "0",
    49: "1",
    50: "2",
    51: "3",
    52: "4",
    53: "5",
    54: "6",
    55: "7",
    56: "8",
    57: "9",
    // alphabet
    65: "a",
    66: "b",
    67: "c",
    68: "d",
    69: "e",
    70: "f",
    71: "g",
    72: "h",
    73: "i",
    74: "j",
    75: "k",
    76: "l",
    77: "m",
    78: "n",
    79: "o",
    80: "p",
    81: "q",
    82: "r",
    83: "s",
    84: "t",
    85: "u",
    86: "v",
    87: "w",
    88: "x",
    89: "y",
    90: "z",
    // punctuation
    106: "*",
    107: "+",
    109: "-",
    110: ".",
    111: "/",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'",
};
var Modifiers = {
    16: "shift",
    17: "ctrl",
    18: "alt",
    91: "meta",
    93: "meta",
    224: "meta",
};
var ModifierBitMasks = {
    alt: 1,
    ctrl: 2,
    meta: 4,
    shift: 8,
};
var Aliases = {
    cmd: "meta",
    command: "meta",
    escape: "esc",
    minus: "-",
    mod: isMac() ? "meta" : "ctrl",
    option: "alt",
    plus: "+",
    return: "enter",
    win: "meta",
};
// alph sorting is unintuitive here
// tslint:disable object-literal-sort-keys
var ShiftKeys = {
    "~": "`",
    "!": "1",
    "@": "2",
    "#": "3",
    $: "4",
    "%": "5",
    "^": "6",
    "&": "7",
    "*": "8",
    "(": "9",
    ")": "0",
    _: "-",
    "+": "=",
    "{": "[",
    "}": "]",
    "|": "\\",
    ":": ";",
    '"': "'",
    "<": ",",
    ">": ".",
    "?": "/",
};
// tslint:enable object-literal-sort-keys
// Function keys
for (var i = 1; i <= 12; ++i) {
    KeyCodes[111 + i] = "f" + i;
}
// Numpad
for (var i = 0; i <= 9; ++i) {
    KeyCodes[96 + i] = "num" + i.toString();
}
function comboMatches(a, b) {
    return a.modifiers === b.modifiers && a.key === b.key;
}
/**
 * Converts a key combo string into a key combo object. Key combos include
 * zero or more modifier keys, such as `shift` or `alt`, and exactly one
 * action key, such as `A`, `enter`, or `left`.
 *
 * For action keys that require a shift, e.g. `@` or `|`, we inlude the
 * necessary `shift` modifier and automatically convert the action key to the
 * unshifted version. For example, `@` is equivalent to `shift+2`.
 */
var parseKeyCombo = function (combo) {
    var pieces = combo
        .replace(/\s/g, "")
        .toLowerCase()
        .split("+");
    var modifiers = 0;
    var key = null;
    for (var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++) {
        var piece = pieces_1[_i];
        if (piece === "") {
            throw new Error("Failed to parse key combo \"" + combo + "\".\n                Valid key combos look like \"cmd + plus\", \"shift+p\", or \"!\"");
        }
        if (Aliases[piece] != null) {
            piece = Aliases[piece];
        }
        if (ModifierBitMasks[piece] != null) {
            modifiers += ModifierBitMasks[piece];
        }
        else if (ShiftKeys[piece] != null) {
            // tslint:disable-next-line no-string-literal
            modifiers += ModifierBitMasks["shift"];
            key = ShiftKeys[piece];
        }
        else {
            key = piece.toLowerCase();
        }
    }
    return { modifiers: modifiers, key: key };
};
/**
 * PhantomJS's webkit totally messes up keyboard events, so we have do this
 * fancy little dance with the event data to determine which key was pressed
 * for unit tests.
 */
var normalizeKeyCode = function (e) {
    return e.which === 0 && e.key != null ? e.key.charCodeAt(0) : e.which;
};
/**
 * Converts a keyboard event into a valid combo prop string
 */
var getKeyComboString = function (e) {
    var keys = [];
    // modifiers first
    if (e.ctrlKey) {
        keys.push("ctrl");
    }
    if (e.altKey) {
        keys.push("alt");
    }
    if (e.shiftKey) {
        keys.push("shift");
    }
    if (e.metaKey) {
        keys.push("meta");
    }
    var which = normalizeKeyCode(e);
    if (Modifiers[which] != null) {
        // no action key
    }
    else if (KeyCodes[which] != null) {
        keys.push(KeyCodes[which]);
    }
    else {
        keys.push(String.fromCharCode(which).toLowerCase());
    }
    // join keys with plusses
    return keys.join(" + ");
};
/**
 * Determines the key combo object from the given keyboard event. Again, a key
 * combo includes zero or more modifiers (represented by a bitmask) and one
 * action key, which we determine from the `e.which` property of the keyboard
 * event.
 */
var getKeyCombo = function (e) {
    var key = null;
    var which = normalizeKeyCode(e);
    if (Modifiers[which] != null) {
        // keep key null
    }
    else if (KeyCodes[which] != null) {
        key = KeyCodes[which];
    }
    else {
        key = String.fromCharCode(which).toLowerCase();
    }
    var modifiers = 0;
    // tslint:disable no-string-literal
    if (e.altKey) {
        modifiers += ModifierBitMasks["alt"];
    }
    if (e.ctrlKey) {
        modifiers += ModifierBitMasks["ctrl"];
    }
    if (e.metaKey) {
        modifiers += ModifierBitMasks["meta"];
    }
    if (e.shiftKey) {
        modifiers += ModifierBitMasks["shift"];
    }
    // tslint:enable
    return { modifiers: modifiers, key: key };
};
/**
 * Splits a key combo string into its constituent key values and looks up
 * aliases, such as `return` -> `enter`.
 *
 * Unlike the parseKeyCombo method, this method does NOT convert shifted
 * action keys. So `"@"` will NOT be converted to `["shift", "2"]`).
 */
var normalizeKeyCombo = function (combo, platformOverride) {
    var keys = combo.replace(/\s/g, "").split("+");
    return keys.map(function (key) {
        var keyName = Aliases[key] != null ? Aliases[key] : key;
        return keyName === "meta" ? (isMac(platformOverride) ? "cmd" : "ctrl") : keyName;
    });
};
/* tslint:enable:no-string-literal */
function isMac(platformOverride) {
    var platform = platformOverride != null ? platformOverride : typeof navigator !== "undefined" ? navigator.platform : undefined;
    return platform == null ? false : /Mac|iPod|iPhone|iPad/.test(platform);
}


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */




var Menu = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["MENU"], this.props.className), ref: this.props.ulRef }, this.props.children));
    };
    Menu.displayName = "Blueprint.Menu";
    return Menu;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

var MenuFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Menu);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var SPINNER_TRACK = "M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89";
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var PATH_LENGTH = 280;
var Spinner = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, className = _a.className, intent = _a.intent, value = _a.value;
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["SPINNER"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), {
            "pt-no-spin": value != null,
        }, className);
        var style = {
            strokeDasharray: PATH_LENGTH + " " + PATH_LENGTH,
            // default to quarter-circle when indeterminate
            // IE11: CSS transitions on SVG elements are Not Supported :(
            strokeDashoffset: PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["clamp"])(value, 0, 1)),
        };
        // HACKHACK to squash error regarding React.SVGProps missing prop pathLength
        var svgPathAttributes = {
            className: "pt-spinner-head",
            d: SPINNER_TRACK,
            pathLength: PATH_LENGTH,
            style: style,
        };
        return this.renderContainer(classes, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("svg", { viewBox: classes.indexOf(__WEBPACK_IMPORTED_MODULE_4__common_classes__["SMALL"]) >= 0 ? "-15 -15 130 130" : "0 0 100 100" },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", { className: "pt-spinner-track", d: SPINNER_TRACK }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, svgPathAttributes))));
    };
    // abstract away the container elements so SVGSpinner can do its own thing
    Spinner.prototype.renderContainer = function (classes, content) {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-spinner-svg-container" }, content)));
    };
    Spinner.displayName = "Blueprint.Spinner";
    Spinner = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Spinner);
    return Spinner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var SpinnerFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Spinner);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TooltipFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popover_popover__ = __webpack_require__(165);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */







var Tooltip = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, intent = _a.intent, openOnTargetFocus = _a.openOnTargetFocus, tooltipClassName = _a.tooltipClassName;
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TOOLTIP"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), tooltipClassName);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__popover_popover__["b" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this.props, { arrowSize: 22, autoFocus: false, canEscapeKeyClose: false, enforceFocus: false, interactionKind: __WEBPACK_IMPORTED_MODULE_6__popover_popover__["a" /* PopoverInteractionKind */].HOVER_TARGET_ONLY, lazy: true, openOnTargetFocus: openOnTargetFocus, popoverClassName: classes }), children));
    };
    Tooltip.defaultProps = {
        hoverCloseDelay: 0,
        hoverOpenDelay: 100,
        isDisabled: false,
        openOnTargetFocus: true,
        position: __WEBPACK_IMPORTED_MODULE_5__common_position__["a" /* Position */].TOP,
        rootElementTag: "span",
        transitionDuration: 100,
        useSmartArrowPositioning: true,
        useSmartPositioning: false,
    };
    Tooltip.displayName = "Blueprint.Tooltip";
    Tooltip = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tooltip);
    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var TooltipFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tooltip);


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(83);
var normalizeHeaderName = __webpack_require__(936);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(466);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(466);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MultipleLeverMenu = __webpack_require__(963);

var _MultipleLeverMenu2 = _interopRequireDefault(_MultipleLeverMenu);

var _reactRouter = __webpack_require__(2);

var _Profile = __webpack_require__(964);

var _Profile2 = _interopRequireDefault(_Profile);

var _HotLine = __webpack_require__(961);

var _HotLine2 = _interopRequireDefault(_HotLine);

var _Logo = __webpack_require__(962);

var _Logo2 = _interopRequireDefault(_Logo);

var _NotificationTTT = __webpack_require__(1327);

var _NotificationTTT2 = _interopRequireDefault(_NotificationTTT);

var _CheckPermission = __webpack_require__(20);

var _api = __webpack_require__(5);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _utils = __webpack_require__(4);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Notification from './Notification.jsx';


var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      thanhTraThanhPhoId: ''
    };
    return _this;
  }

  _createClass(Header, [{
    key: 'changePage',
    value: function changePage(pageName) {
      _reactRouter.browserHistory.push(pageName);
    }
  }, {
    key: 'handleMouseClick',
    value: function handleMouseClick() {
      if (_reactCookie2.default.load('accessToken') && window.CALL_API == false) {
        window.CALL_API = true;
        setTimeout(function () {
          window.CALL_API = false;
        }, 180000);
        _api.User.actions.updateSession.request();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkDonVi();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.checkDonVi();
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var thanhTraThanhPhoId = ThamSo.filter(function (item) {
        return item.ten == 'CQQL_THANH_TRA_THANH_PHO';
      });
      this.setState({ thanhTraThanhPhoId: thanhTraThanhPhoId.length ? thanhTraThanhPhoId[0].giaTri : '' });
    }
  }, {
    key: 'render',
    value: function render() {
      return (
        // <div className={`header-container ${this.props.routerName === 'congDanTraCuu' || CheckPermission('GIAM_SAT_TRA_CUU_LIETKE') ? 'tc' : ''}`}>
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('header-container', { 'tc': this.props.routerName === 'congDanTraCuu' || (0, _CheckPermission.CheckPermission)('GIAM_SAT_TRA_CUU_LIETKE') }) },
          _react2.default.createElement(
            'div',
            { className: 'header' },
            _react2.default.createElement(
              'div',
              { className: 'center' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-header-top' },
                _react2.default.createElement(_Logo2.default, null),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-content-header ' + (this.props.routerName == 'congDanTraCuu' ? 'tc' : '') },
                    _react2.default.createElement(_HotLine2.default, { routerName: this.props.routerName }),
                    this.props.routerName !== 'congDanTraCuu' && _react2.default.createElement(_NotificationTTT2.default, null),
                    this.props.routerName !== 'congDanTraCuu' && _react2.default.createElement(_Profile2.default, null)
                  ),
                  this.props.routerName !== 'congDanTraCuu' && _react2.default.createElement(
                    'div',
                    { className: 'mt40', onMouseUp: this.handleMouseClick.bind(this) },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: (0, _CheckPermission.CheckPermission)('XULYDON_LIETKE') },
                      _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'tc-bt small', onClick: this.changePage.bind(this, '/can-bo-tra-cuu') },
                        _react2.default.createElement(
                          'span',
                          null,
                          'Tra c\u1EE9u \u0111\u01A1n'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'button',
                      { type: 'button', className: 'tc-bt help small mr10', onClick: this.changePage.bind(this, '/huong-dan-su-dung') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng'
                      )
                    )
                  )
                )
              )
            )
          ),
          this.props.routerName !== 'congDanTraCuu' && !(0, _CheckPermission.CheckPermission)('GIAM_SAT_TRA_CUU_LIETKE') ? _react2.default.createElement(
            'div',
            { className: 'menu-container', onMouseUp: this.handleMouseClick.bind(this) },
            _react2.default.createElement(
              'div',
              { className: 'center' },
              _react2.default.createElement(_MultipleLeverMenu2.default, { routerName: this.props.routerName, thanhTraThanhPhoId: this.state.thanhTraThanhPhoId })
            )
          ) : ''
        )
      );
    }
  }]);

  return Header;
}(_react2.default.Component);

exports.default = Header;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingData = function (_React$Component) {
  _inherits(LoadingData, _React$Component);

  function LoadingData(props, context) {
    _classCallCheck(this, LoadingData);

    var _this = _possibleConstructorReturn(this, (LoadingData.__proto__ || Object.getPrototypeOf(LoadingData)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(LoadingData, [{
    key: "render",
    value: function render() {
      var LoadingContent = _react2.default.createElement("div", { className: "loading-content" });
      return _react2.default.createElement(
        "div",
        { className: "loading-data" },
        _react2.default.createElement(
          "div",
          { className: "box-items" },
          _react2.default.createElement(
            "div",
            { className: "box-forward " },
            _react2.default.createElement(
              "div",
              { className: "group-box" },
              _react2.default.createElement(
                "div",
                { className: "items-form" },
                _react2.default.createElement(
                  "div",
                  { className: "rows" },
                  _react2.default.createElement(
                    "div",
                    { className: "col-input" },
                    LoadingContent
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "group-box" },
          _react2.default.createElement(
            "div",
            { className: "inline-bottom" },
            _react2.default.createElement(
              "div",
              { className: "items-form" },
              _react2.default.createElement(
                "div",
                { className: "rows" },
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "items-form" },
              _react2.default.createElement(
                "div",
                { className: "rows" },
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "items-form" },
              _react2.default.createElement(
                "div",
                { className: "rows" },
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement(
                  "div",
                  { className: "col-input" },
                  LoadingContent
                ),
                _react2.default.createElement("div", { className: "clearfix" })
              )
            )
          )
        )
      );
    }
  }]);

  return LoadingData;
}(_react2.default.Component);

exports.default = LoadingData;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableKetQuaPhongChongThamNhung = function (_React$Component) {
  _inherits(TableKetQuaPhongChongThamNhung, _React$Component);

  function TableKetQuaPhongChongThamNhung(props, context) {
    _classCallCheck(this, TableKetQuaPhongChongThamNhung);

    var _this = _possibleConstructorReturn(this, (TableKetQuaPhongChongThamNhung.__proto__ || Object.getPrototypeOf(TableKetQuaPhongChongThamNhung)).call(this, props, context));

    _this.state = {
      dataList: _this.props.dataList || [],
      dataSum: _this.props.dataSum || {},
      header: [{ ms: null, content: 'CHÍNH SÁCH, PHÁP LUẬT', className: 'txt-bold', unit: null }, { ms: 1, content: 'Số văn bản ban hành mới để thực hiện Luật PCTN và các văn bản hướng dẫn thi hành Luật PCTN', className: '', unit: 'Văn bản', field: 'chinhSachPhapLuatSoVanBanBanHanh' }, { ms: 2, content: 'Số văn bản được sửa đổi, bổ sung để thực hiện Luật PCTN và các văn bản hướng dẫn thi hành', className: '', unit: 'Văn bản', field: 'chinhSachPhapLuatSoVanBanDuocSuaDoi' }, { ms: null, content: 'TUYÊN TRUYỀN, PHỔ BIẾN, GIÁO DỤC PHÁP LUẬT VỀ PCTN', className: 'txt-bold', unit: null }, { ms: 3, content: 'Số lượt cán bộ, công chức, viên chức, nhân dân tham gia các lớp tập huấn, quán triệt pháp luật về PCTN', className: '', unit: 'Lượt người', field: 'tuyenTruyenPBGDPLVePCTNSoLuotCanBo' }, { ms: 4, content: 'Số lớp tuyên truyền, quán triệt pháp luật về phòng, chống tham nhũng được tổ chức', className: '', unit: 'Lớp', field: 'tuyenTruyenPBGDPLVePCTNSoLop' }, { ms: 5, content: 'Số lượng đầu sách, tài liệu về pháp luật phòng, chống tham nhũng được xuất bản', className: '', unit: 'Tài liệu', field: 'tuyenTruyenPBGDPLVePCTNSoLuongDauSach' }, { ms: null, content: 'THỰC HIỆN CÁC BIỆN PHÁP PHÒNG NGỪA THAM NHŨNG', className: 'txt-bold', unit: null }, { ms: null, content: 'Công khai, minh bạch trong hoạt động của cơ quan, tổ chức, đơn vị (gọi chung là đơn vị)', className: 'txt-bold', unit: null }, { ms: 6, content: 'Số cơ quan, tổ chức, đơn vị được kiểm tra việc thực hiện các quy định về công khai, minh bạch', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVDuocKiemTra' }, { ms: 7, content: 'Số cơ quan, tổ chức, đơn vị bị phát hiện có vi phạm quy định về công khai, minh bạch hoạt động', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVBiPhatHien' }, { ms: null, content: 'Xây dựng và thực hiện các chế độ, định mức, tiêu chuẩn', className: 'txt-bold', unit: null }, { ms: 8, content: 'Số văn bản về chế độ, định mức, tiêu chuẩn đã được ban hành mới', className: '', unit: 'Văn bản', field: 'thucHienCacBPPNTNSoVanBanDuocBanHanhMoi' }, { ms: 9, content: 'Số văn bản về chế độ, định mức, tiêu chuẩn đã được sửa đổi, bổ sung cho phù hợp', className: '', unit: 'Văn bản', field: 'thucHienCacBPPNTNSoVanBanDuocSuaDoiBoSungChoPhuHop' }, { ms: 10, content: 'Số cuộc kiểm tra việc thực hiện các quy định về chế độ, định mức, tiêu chuẩn', className: '', unit: 'Cuộc', field: 'thucHienCacBPPNTNSoCuocKiemTra' }, { ms: 11, content: 'Số vụ vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã được phát hiện và xử lý', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuViPham' }, { ms: 12, content: 'Số người bị phát hiện đã vi phạm các quy định về chế độ, định mức, tiêu chuẩn', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiBiPhatHienDaViPham' }, { ms: 13, content: 'Số người vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã bị xử lý kỷ luật', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiViPhamDaBiXuLyKyLuat' }, { ms: 14, content: 'Số người vi phạm các quy định về chế độ, định mức, tiêu chuẩn đã bị xử lý hình sự', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiViPhamDaBiXuLyHinhSu' }, { ms: 15, content: 'Tổng giá trị các vi phạm về chế độ, định mức, tiêu chuẩn được kiến nghị thu hồi và bồi thường (nếu là ngoại tệ, tài sản thì quy đổi thành tiền).', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTongGiaTriDuocKienNghi' }, { ms: 16, content: 'Tổng giá trị vi phạm chế độ, định mức, tiêu chuẩn đã được thu hồi và bồi thường', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTongGiaTriDuocThuHoiVaBoiThuong' }, { ms: 17, content: 'Số người đã nộp lại quà tặng cho đơn vị', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDaNopLaiQuaTang' }, { ms: 18, content: 'Giá trị quà tặng đã được nộp lại (Nếu là ngoại tệ, tài sản thì quy đổi thành tiền)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNGiaTriQuaTang' }, { ms: null, content: 'Thực hiện quy tắc ứng xử, chuyển đổi vị trí công tác của cán bộ, công chức, viên chức', className: 'txt-bold', unit: null }, { ms: 19, content: 'Số cơ quan, tổ chức, đơn vị đã được kiểm tra việc thực hiện quy tắc ứng xử của cán bộ, công chức', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDVThucHienQuyTacUngXu' }, { ms: 20, content: 'Số cán bộ, công chức, viên chức vi phạm quy tắc ứng xử, quy tắc đạo đức nghề nghiệp đã bị xử lý', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoViPhamQuyTacUngXu' }, { ms: 21, content: 'Số cán bộ, công chức, viên chức được chuyển đổi vị trí công tác nhằm phòng ngừa tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoDuocChuyenDoiVTCTPNTN' }, { ms: null, content: 'Thực hiện các quy định về minh bạch tài sản, thu nhập', className: 'txt-bold', unit: null }, { ms: 22, content: 'Số người được xác minh việc kê khai tài sản, thu nhập', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDuocXMViecKeKhaiTSThuNhap' }, { ms: 23, content: 'Số người bị kết luận kê khai không trung thực', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiBiKetLuanKKHKhongTrungThuc' }, { ms: null, content: 'Trách nhiệm của người đứng đầu các cơ quan, tổ chức, đơn vị khi để xẩy ra tham nhũng', className: 'txt-bold', unit: null }, { ms: 24, content: 'Số người đứng đầu bị kết luận là thiếu trách nhiệm để xẩy ra hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDBiKLThieuTrachNhiem' }, { ms: 25, content: 'Số người đứng đầu đã bị xử lý hình sự do thiếu trách nhiệm để xẩy ra hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDDaBiXLHSThieuTrachNhiem' }, { ms: 26, content: 'Số người đứng đầu bị xử lý kỷ luật do thiếu trách nhiệm để xảy ra tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDDBiKLKyLuat' }, { ms: null, content: 'Cải cách hành chính, đổi mới công nghệ quản lý và phương thức thanh toán', className: 'txt-bold', unit: null }, { ms: 27, content: 'Số cơ quan, tổ chức đã áp dụng ISO trong quản lý hành chính', className: '', unit: 'CQ, TC, ĐV', field: 'thucHienCacBPPNTNSoCoQuanTCDaApDungISO' }, { ms: 28, content: 'Tỷ lệ cơ quan, tổ chức đã chi trả lương qua tài khoản trên tổng số cơ quan, đơn vị trực thuộc', className: '', unit: '%', field: 'thucHienCacBPPNTNTyLeCoQuanTCDaChiTraLuong' }, { ms: null, content: 'PHÁT HIỆN CÁC VỤ VIỆC THAM NHŨNG', className: 'txt-bold', unit: null }, { ms: null, content: 'Qua việc tự kiểm tra nội bộ', className: 'txt-bold', unit: null }, { ms: 29, content: 'Số vụ tham nhũng đã được phát hiện qua việc tự kiểm tra nội bộ', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDaDuocPhatHienQuaKTNoiBo' }, { ms: 30, content: 'Số đối tượng có hành vi tham nhũng được phát hiện qua việc tự kiểm tra nội bộ', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungDuocPhatHienQuaKTNoiBo' }, { ms: null, content: 'Qua hoạt động thanh tra ', className: 'txt-bold', unit: null }, { ms: 31, content: 'Số vụ tham nhũng được phát hiện qua công tác thanh tra', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDuocPhatHienQuaCTThanhTra' }, { ms: 32, content: 'Số đối tượng có hành vi tham nhũng bị phát hiện qua công tác thanh tra', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiPhatHienQuaCTThanhTra' }, { ms: null, content: 'Qua công tác giải quyết khiếu nại, tố cáo', className: 'txt-bold', unit: null }, { ms: 33, content: 'Số đơn tố cáo về tham nhũng thuộc thẩm quyền giải quyết của các cơ quan, tổ chức', className: '', unit: 'Đơn', field: 'thucHienCacBPPNTNSoDonToCaoThamNhungThuocTQGQCuaCacCQTC' }, { ms: 34, content: 'Số đơn tố cáo về tham nhũng đã được giải quyết', className: '', unit: 'Đơn', field: 'thucHienCacBPPNTNSoDonToCaoThamNhungDaDuocGiaiQuyet' }, { ms: 35, content: 'Số vụ tham nhũng được phát hiện thông qua giải quyết khiếu nại, tố cáo', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuThamNhungDuocPhatHienQuaGQKNTC' }, { ms: 36, content: 'Số đối tượng có hành vi tham nhũng bị phát hiện qua giải quyết khiếu nại, tố cáo', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiPhatHienQuaGQKNTC' }, { ms: null, content: 'Qua điều tra tội phạm ', className: 'txt-bold', unit: null }, { ms: 37, content: 'Số vụ án tham nhũng (thuộc phạm vi quản lý) đã được cơ quan chức năng khởi tố', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuAnThamNhungDuocCoQuanCNKhoiTo' }, { ms: 38, content: 'Số đối tượng tham nhũng (thuộc phạm vi quản lý) đã bị cơ quan chức năng khởi tố', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungBiCoQuanCNKhoiTo' }, { ms: null, content: 'XỬ LÝ CÁC HÀNH VI THAM NHŨNG ', className: 'txt-bold', unit: null }, { ms: 39, content: 'Số vụ án tham nhũng đã đưa ra xét xử (địa phương thống kê kết quả xét xử sơ thẩm của toà án; bộ, ngành thống kê theo kết quả xét xử sơ thẩm đối với các vụ án xảy ra trong phạm vi quản lý trực tiếp)', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuAnThamNhungDaDuaRaXetXu' }, { ms: 40, content: 'Số đối tượng bị kết án tham nhũng (địa phương thống kê kết quả xét xử sơ thẩm của toà án; bộ, ngành thống kê theo kết quả xét xử sơ thẩm đối với các vụ án xảy ra trong phạm vi quản lý trực tiếp)', className: '', unit: 'Người', field: 'soDoiTuongBiKetAnThamNhung' }, { ms: null, content: 'Trong đó:', className: '', unit: null }, { ms: 41, content: '+ Số đối tượng phạm tội tham nhũng ít nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongBiKetAnThamNhungItNghiemTrong' }, { ms: 42, content: '+ Số đối tượng phạm tội tham nhũng nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungNghiemTrong' }, { ms: 43, content: '+ Số đối tượng phạm tội tham nhũng rất nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungRatNghiemTrong' }, { ms: 44, content: '+ Số đối tượng phạm tội tham nhũng đặc biệt nghiêm trọng', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongPhamToiThamNhungDacBietNghiemTrong' }, { ms: 45, content: 'Số vụ việc tham nhũng đã được xử lý hành chính', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSVuViecThamNhungDuocXLHanhChinh' }, { ms: 46, content: 'Số cán bộ, công chức, viên chức bị xử lý kỷ luật hành chính về hành vi tham nhũng', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoCanBoCCVCBiKyLuatHCHanhViThamNhung' }, { ms: 47, content: 'Số vụ việc tham nhũng đã được phát hiện, đang được xem xét để xử lý (chưa có kết quả xử lý)', className: '', unit: 'Vụ', field: 'thucHienCacBPPNTNSoVuViecThamNhungDuocPhatHienXemXetXuLy' }, { ms: 48, content: 'Số đối tượng tham nhũng đã được phát hiện, đang được xem xét để xử lý (chưa có kết quả xử lý)', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoDoiTuongThamNhungDuocPhatHienDangXemXetXuLy' }, { ms: null, content: 'Tài sản bị tham nhũng, gây thiệt hại do tham nhũng đã phát hiện được', className: 'txt-bold', unit: null }, { ms: 49, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungPhatHienDuocBangTien' }, { ms: 50, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungPhatHienDuocBangDatDai' }, { ms: null, content: 'Tài sản tham nhũng, gây thiệt hại do tham nhũng đã được thu hồi, bồi thường', className: 'txt-bold', unit: null }, { ms: 51, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungDuocThuHoiBangTien' }, { ms: 52, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungDuocThuHoiBangTien' }, { ms: null, content: 'Tài sản tham nhũng, gây thiệt hại do tham nhũng không thể thu hồi, khắc phục được', className: 'txt-bold', unit: null }, { ms: 53, content: '+ Bằng tiền (tiền Việt Nam + ngoại tệ, tài sản khác được quy đổi ra tiền Việt Nam)', className: '', unit: 'Triệu đồng', field: 'thucHienCacBPPNTNTaiSanThamNhungKhongTheThuHoiBangTien' }, { ms: 54, content: '+ Đất đai ', className: '', unit: 'm2', field: 'thucHienCacBPPNTNTaiSanThamNhungKhongTheThuHoiBangTien' }, { ms: null, content: 'Bảo vệ người tố cáo, phát hiện tham nhũng', className: 'txt-bold', unit: null }, { ms: 55, content: 'Số người tố cáo hành vi tham nhũng đã bị trả thù', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiToCaoHanhViThamNhungBiTraThu' }, { ms: 56, content: 'Số người tố cáo hành vi tham nhũng đã được khen, thưởng, trong đó:', className: '', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiToCaoHanhViThamNhungDuocKhenThuong' }, { ms: 57, content: '+ Tặng Bằng khen của Thủ tướng Chính phủ', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiDuocTangBangKhenCuaThuTuongChinhPhu' }, { ms: 58, content: '+ Tặng Bằng khen của Bộ, ngành, địa phương', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiTangBangKhenCuaBoNganhDiaPhuong' }, { ms: 59, content: '+ Tặng Giấy khen', className: 'pl30', unit: 'Người', field: 'thucHienCacBPPNTNSoNguoiTangGiayKhen' }],
      down: false,
      scrollLeft: '',
      scrollTop: '',
      x: '',
      y: ''
    };
    return _this;
  }

  _createClass(TableKetQuaPhongChongThamNhung, [{
    key: 'handleDown',
    value: function handleDown(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        document.getElementById('scrollItem').classList.add("scrolling");
        this.state.down = true;
        this.state.scrollLeft = Item.scrollLeft;
        this.state.scrollTop = Item.scrollTop;
        this.state.x = e.clientX;
        this.state.y = e.clientY;
      }
    }
  }, {
    key: 'handleUp',
    value: function handleUp() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        if (this.state.down == true) {
          Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
          Item.scrollTop = this.state.scrollTop + this.state.y - e.clientY;
        }
      }
    }
  }, {
    key: 'handleLeave',
    value: function handleLeave() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.dataList != nextProps.dataList) {
        this.setState({
          dataList: nextProps.dataList
        });
      }
      this.setState({
        dataSum: nextProps.dataSum
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'addNewItem',
    value: function addNewItem() {
      this.props.addNewItem();
    }
  }, {
    key: 'checkScroll',
    value: function checkScroll() {
      var scrollContainer = document.getElementById('scrollItem');

      document.getElementById("tableFixed").style.cssText = "top: " + -1 * scrollContainer.scrollTop + 'px';
      document.getElementById("tableHeaderFixed").style.cssText = "left: " + (-1 * scrollContainer.scrollLeft + 1) + 'px';
    }
  }, {
    key: 'onChange',
    value: function onChange(name, index, e) {
      var _this2 = this;

      this.state.dataList[index][name] = e.target.value;
      this.setState(_extends({}, this.state), function () {
        _this2.props.pushData(_this2.state.dataList);
      });
    }
  }, {
    key: 'onChangeHeader',
    value: function onChangeHeader(index, e) {
      var _this3 = this;

      this.state.dataList[index].donVi = {
        id: null,
        ten: e.target.value
      };
      this.state.dataList[index].tenDonVi = e.target.value;
      this.setState(_extends({}, this.state), function () {
        _this3.props.pushData(_this3.state.dataList);
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      this.props.handleExport();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'wrapper-tkbc table-custom' },
        _react2.default.createElement(
          'div',
          {
            className: 'table-container ' + (this.props.touchMove == true ? 'touch-move' : ''),
            onMouseUp: this.handleUp.bind(this),
            onMouseDown: this.handleDown.bind(this),
            onMouseMove: this.handleMove.bind(this),
            onMouseLeave: this.handleLeave.bind(this),
            onScroll: this.checkScroll.bind(this),
            id: 'scrollItem' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-fixed-table', style: { overflowY: 'scroll' } },
            _react2.default.createElement(
              'table',
              { className: 'table-header-fixed', id: 'tableHeaderFixed' },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    { style: { width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden' }, className: 'middle-content' },
                    'MS'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                    'N\u1ED9i dung'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                    '\u0110\u01A1n v\u1ECB t\xEDnh'
                  ),
                  this.state.dataList.map(function (item, index) {
                    if (typeof item.donVi != 'undefined' && item.donVi.id) {
                      return _react2.default.createElement(
                        'th',
                        { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: index, className: 'middle-content txt-left' },
                        item && item.donVi && item.donVi.ten ? item.donVi.ten : ''
                      );
                    } else {
                      return _react2.default.createElement(
                        'th',
                        { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: index, className: 'middle-content txt-left' },
                        _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChangeHeader.bind(_this4, index), triggeOnBlur: true, value: item && item.donVi && item.donVi.ten ? item.donVi.ten : '' })
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.addNew == true },
                    _react2.default.createElement(
                      'th',
                      { style: { minWidth: 150 }, className: 'middle-content txt-left' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                        _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                        'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.dataList.length > 1 },
                    _react2.default.createElement(
                      'th',
                      { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'middle-content txt-left' },
                      'T\u1ED5ng c\u1ED9ng'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-fixed-table' },
            _react2.default.createElement(
              'table',
              { className: 'table-content-fixed' },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    { style: { width: 40, minWidth: 40, maxWidth: 40 }, className: 'middle-content' },
                    'MS'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 600, minWidth: 600, maxWidth: 600 }, className: 'middle-content txt-left' },
                    'N\u1ED9i dung'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'middle-content txt-left' },
                    '\u0110\u01A1n v\u1ECB t\xEDnh'
                  ),
                  this.state.dataList.map(function (item, index) {
                    if (typeof item.donVi != 'undefined' && item.donVi.id) {
                      return _react2.default.createElement(
                        'th',
                        { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: index, className: 'middle-content txt-left' },
                        item && item.donVi && item.donVi.ten ? item.donVi.ten : ''
                      );
                    } else {
                      return _react2.default.createElement(
                        'td',
                        { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: index, className: 'txt-left' },
                        _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChangeHeader.bind(_this4, index), triggeOnBlur: true, value: item && item.donVi && item.donVi.ten ? item.donVi.ten : '' })
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.addNew == true },
                    _react2.default.createElement(
                      'th',
                      { style: { minWidth: 150, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                        _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                        'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.dataList.length > 1 },
                    _react2.default.createElement(
                      'th',
                      { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                      'T\u1ED5ng c\u1ED9ng'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                { style: { opacity: 0, visibility: 'hidden' } },
                this.state.header.map(function (item, index) {
                  return _react2.default.createElement(
                    'tr',
                    { key: index },
                    _react2.default.createElement(
                      'td',
                      { style: { width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden' } },
                      item.ms ? item.ms : ''
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden' }, className: 'txt-left ' + (item.className ? item.className : '') },
                      item.content ? item.content : ''
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'txt-left' },
                      item.unit ? item.unit : ''
                    ),
                    _this4.state.dataList.map(function (data, i) {
                      if (typeof data.donVi != 'undefined' && data.donVi.id || item.ms == null) {
                        return _react2.default.createElement(
                          'td',
                          { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: i, className: 'txt-left' },
                          data && data[item.field] ? data[item.field] : item.ms ? 0 : ''
                        );
                      } else {
                        return _react2.default.createElement(
                          'td',
                          { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: i, className: 'txt-left' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChange.bind(_this4, item.field, i), type: 'sdt', triggeOnBlur: true, value: data && data[item.field] ? data[item.field] : 0 })
                        );
                      }
                    }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: _this4.props.addNew == true },
                      _react2.default.createElement(
                        'td',
                        { style: { minWidth: 150 } },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\xA0'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: _this4.state.dataList.length > 1 },
                      _react2.default.createElement(
                        'td',
                        { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'txt-left' },
                        _this4.state.dataSum[item.field] ? _this4.state.dataSum[item.field] : item.ms ? 0 : ''
                      )
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'table',
              { className: 'table-fixed', id: 'tableFixed' },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    { style: { width: 40, minWidth: 40, maxWidth: 40 }, className: 'middle-content' },
                    'MS'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 600, minWidth: 600, maxWidth: 600 }, className: 'middle-content txt-left' },
                    'N\u1ED9i dung'
                  ),
                  _react2.default.createElement(
                    'th',
                    { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'middle-content txt-left' },
                    '\u0110\u01A1n v\u1ECB t\xEDnh'
                  ),
                  this.state.dataList.map(function (item, index) {
                    if (typeof item.donVi != 'undefined' && item.donVi.id) {
                      return _react2.default.createElement(
                        'th',
                        { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: index, className: 'middle-content txt-left' },
                        item && item.donVi && item.donVi.ten ? item.donVi.ten : ''
                      );
                    } else {
                      return _react2.default.createElement(
                        'td',
                        { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: index, className: 'txt-left' },
                        _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChangeHeader.bind(_this4, index), triggeOnBlur: true, value: item && item.donVi && item.donVi.ten ? item.donVi.ten : '' })
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.addNew == true },
                    _react2.default.createElement(
                      'th',
                      { style: { minWidth: 150, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                        _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                        'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.dataList.length > 1 },
                    _react2.default.createElement(
                      'th',
                      { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                      'T\u1ED5ng c\u1ED9ng'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.header.map(function (item, index) {
                  return _react2.default.createElement(
                    'tr',
                    { key: index },
                    _react2.default.createElement(
                      'td',
                      { style: { width: 40, minWidth: 40, maxWidth: 40 } },
                      item.ms ? item.ms : ''
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { width: 600, minWidth: 600, maxWidth: 600 }, className: 'txt-left ' + (item.className ? item.className : '') },
                      item.content ? item.content : ''
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'txt-left' },
                      item.unit ? item.unit : ''
                    ),
                    _this4.state.dataList.map(function (data, i) {
                      if (item.ms == null) {
                        return _react2.default.createElement(
                          'td',
                          { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: i, className: 'txt-left' },
                          data && data[item.field] ? data[item.field] : item.ms ? 0 : ''
                        );
                      } else {
                        return _react2.default.createElement(
                          'td',
                          { style: { minWidth: 150, maxWidth: 150, width: 150, opacity: 0, visibility: 'hidden' }, key: i, className: 'txt-left' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChange.bind(_this4, item.field, i), value: data && data[item.field] ? data[item.field] : 0 })
                        );
                      }
                    })
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'table',
            { className: 'table-scroll' },
            _react2.default.createElement(
              'thead',
              { className: 'table-header', style: { opacity: 0, visibility: 'hidden' } },
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  { style: { width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden' }, className: 'middle-content' },
                  'MS'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                  'N\u1ED9i dung'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'middle-content txt-left' },
                  '\u0110\u01A1n v\u1ECB t\xEDnh'
                ),
                this.state.dataList.map(function (item, index) {
                  if (typeof item.donVi != 'undefined' && item.donVi.id) {
                    return _react2.default.createElement(
                      'th',
                      { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: index, className: 'middle-content txt-left' },
                      item && item.donVi && item.donVi.ten ? item.donVi.ten : ''
                    );
                  } else {
                    return _react2.default.createElement(
                      'td',
                      { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: index, className: 'txt-left' },
                      _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChangeHeader.bind(_this4, index), triggeOnBlur: true, value: item && item.donVi && item.donVi.ten ? item.donVi.ten : '' })
                    );
                  }
                }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.addNew == true },
                  _react2.default.createElement(
                    'th',
                    { style: { minWidth: 150 }, className: 'middle-content txt-left' },
                    _react2.default.createElement(
                      'span',
                      { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                      _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                      'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.dataList.length > 1 },
                  _react2.default.createElement(
                    'th',
                    { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'middle-content txt-left' },
                    'T\u1ED5ng c\u1ED9ng'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              this.state.header.map(function (item, index) {
                return _react2.default.createElement(
                  'tr',
                  { key: index },
                  _react2.default.createElement(
                    'td',
                    { style: { width: 40, minWidth: 40, maxWidth: 40, opacity: 0, visibility: 'hidden' } },
                    item.ms ? item.ms : ''
                  ),
                  _react2.default.createElement(
                    'td',
                    { style: { width: 600, minWidth: 600, maxWidth: 600, opacity: 0, visibility: 'hidden' }, className: 'txt-left ' + (item.className ? item.className : '') },
                    item.content ? item.content : ''
                  ),
                  _react2.default.createElement(
                    'td',
                    { style: { width: 110, minWidth: 110, maxWidth: 110, opacity: 0, visibility: 'hidden' }, className: 'txt-left' },
                    item.unit ? item.unit : ''
                  ),
                  _this4.state.dataList.map(function (data, i) {
                    if (item.ms == null) {
                      return _react2.default.createElement(
                        'td',
                        { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: i, className: 'txt-left' },
                        data && data[item.field] ? data[item.field] : item.ms ? 0 : ''
                      );
                    } else {
                      return _react2.default.createElement(
                        'td',
                        { style: { minWidth: 150, maxWidth: 150, width: 150 }, key: i, className: 'txt-left' },
                        _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', onChange: _this4.onChange.bind(_this4, item.field, i), type: 'sdt', triggeOnBlur: true, value: data && data[item.field] ? data[item.field] : 0 })
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: _this4.props.addNew == true },
                    _react2.default.createElement(
                      'td',
                      { style: { minWidth: 150 } },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\xA0'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: _this4.state.dataList.length > 1 },
                    _react2.default.createElement(
                      'td',
                      { style: { width: 110, minWidth: 110, maxWidth: 110 }, className: 'txt-left' },
                      _this4.state.dataSum[item.field] ? _this4.state.dataSum[item.field] : item.ms ? 0 : ''
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.props.hideExport },
          _react2.default.createElement(
            'div',
            { className: 'pagination-wrap' },
            _react2.default.createElement(_core.Button, { className: 'btn-green tt-export', text: this.props.exporttext, onClick: this.handleExport.bind(this) })
          )
        )
      );
    }
  }]);

  return TableKetQuaPhongChongThamNhung;
}(_react2.default.Component);

exports.default = TableKetQuaPhongChongThamNhung;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoSungThongTinChuyenDon = exports.BoSungThongTin = undefined;

var _BoSungThongTin = __webpack_require__(1019);

var _BoSungThongTin2 = _interopRequireDefault(_BoSungThongTin);

var _BoSungThongTinChuyenDon = __webpack_require__(1020);

var _BoSungThongTinChuyenDon2 = _interopRequireDefault(_BoSungThongTinChuyenDon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BoSungThongTin = _BoSungThongTin2.default;
exports.BoSungThongTinChuyenDon = _BoSungThongTinChuyenDon2.default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleLettersOldDetails = exports.HandleLettersOld = exports.AddHandleLetterOld = undefined;

var _addHandleLettersOld = __webpack_require__(1145);

var _listHandleLettersOld = __webpack_require__(1151);

var _detailHandleLettersOld = __webpack_require__(1149);

/*------------------------list handle letters-------------------------*/
exports.AddHandleLetterOld = _addHandleLettersOld.AddHandleLetterOld;
exports.HandleLettersOld = _listHandleLettersOld.HandleLettersOld;
exports.HandleLettersOldDetails = _detailHandleLettersOld.HandleLettersOldDetails;
/*-----------------------detail handle letters------------------------*/
/*------------------------add handle letters-------------------------*/

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanBoNhanYeuCauTheoDoiThucHien = exports.LanhDaoGiaoViecTheoDoiGiamSat = exports.LanhDaoGiaoViecTheoDoiGiamSatView = exports.TrinhLanhDaoTheoDoiThucHienView = exports.TrinhLanhDaoTheoDoiThucHien = exports.CanBoGiaiQuyetYeuCauLapDuThao = exports.LapDuThaoCanBo = exports.GiaiQuyetDonCanBo = exports.LapDuThaoDonKhieuNaiCanBo = exports.KetQuaLapDuThaoCanBo = exports.KetQuaHoanThanhGiaiQuyetDonCanBo = exports.NhapThongTinToTTXMView = exports.LanhDaoGiaoViecTTXMView = exports.TrinhLanhDaoTTXMView = exports.NhiemVuTTXM = exports.NhapThongTinToTTXM = exports.LanhDaoGiaoViecTTXM = exports.TrinhLanhDaoTTXM = undefined;

var _TrinhLanhDaoTTXM = __webpack_require__(1174);

var _TrinhLanhDaoTTXM2 = _interopRequireDefault(_TrinhLanhDaoTTXM);

var _LanhDaoGiaoViecTTXM = __webpack_require__(1188);

var _LanhDaoGiaoViecTTXM2 = _interopRequireDefault(_LanhDaoGiaoViecTTXM);

var _NhiemVuTTXM = __webpack_require__(1173);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _NhapThongTinToTTXM = __webpack_require__(1185);

var _NhapThongTinToTTXM2 = _interopRequireDefault(_NhapThongTinToTTXM);

var _TrinhLanhDaoTTXMView = __webpack_require__(1175);

var _TrinhLanhDaoTTXMView2 = _interopRequireDefault(_TrinhLanhDaoTTXMView);

var _LanhDaoGiaoViecTTXMView = __webpack_require__(1189);

var _LanhDaoGiaoViecTTXMView2 = _interopRequireDefault(_LanhDaoGiaoViecTTXMView);

var _NhapThongTinToTTXMView = __webpack_require__(1186);

var _NhapThongTinToTTXMView2 = _interopRequireDefault(_NhapThongTinToTTXMView);

var _KetQuaHoanThanhGiaiQuyetDonCanBo = __webpack_require__(1181);

var _KetQuaHoanThanhGiaiQuyetDonCanBo2 = _interopRequireDefault(_KetQuaHoanThanhGiaiQuyetDonCanBo);

var _KetQuaLapDuThaoCanBo = __webpack_require__(1182);

var _KetQuaLapDuThaoCanBo2 = _interopRequireDefault(_KetQuaLapDuThaoCanBo);

var _GiaiQuyetDonCanBo = __webpack_require__(1180);

var _GiaiQuyetDonCanBo2 = _interopRequireDefault(_GiaiQuyetDonCanBo);

var _CanBoGiaiQuyetYeuCauLapDuThao = __webpack_require__(1178);

var _CanBoGiaiQuyetYeuCauLapDuThao2 = _interopRequireDefault(_CanBoGiaiQuyetYeuCauLapDuThao);

var _LapDuThaoDonKhieuNaiCanBo = __webpack_require__(1184);

var _LapDuThaoDonKhieuNaiCanBo2 = _interopRequireDefault(_LapDuThaoDonKhieuNaiCanBo);

var _LapDuThaoCanBo = __webpack_require__(1183);

var _LapDuThaoCanBo2 = _interopRequireDefault(_LapDuThaoCanBo);

var _TrinhLanhDaoTheoDoiThucHien = __webpack_require__(1176);

var _TrinhLanhDaoTheoDoiThucHien2 = _interopRequireDefault(_TrinhLanhDaoTheoDoiThucHien);

var _TrinhLanhDaoTheoDoiThucHienView = __webpack_require__(1177);

var _TrinhLanhDaoTheoDoiThucHienView2 = _interopRequireDefault(_TrinhLanhDaoTheoDoiThucHienView);

var _LanhDaoGiaoViecTheoDoiGiamSat = __webpack_require__(1190);

var _LanhDaoGiaoViecTheoDoiGiamSat2 = _interopRequireDefault(_LanhDaoGiaoViecTheoDoiGiamSat);

var _LanhDaoGiaoViecTheoDoiGiamSatView = __webpack_require__(1191);

var _LanhDaoGiaoViecTheoDoiGiamSatView2 = _interopRequireDefault(_LanhDaoGiaoViecTheoDoiGiamSatView);

var _CanBoNhanYeuCauTheoDoiThucHien = __webpack_require__(1179);

var _CanBoNhanYeuCauTheoDoiThucHien2 = _interopRequireDefault(_CanBoNhanYeuCauTheoDoiThucHien);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TrinhLanhDaoTTXM = _TrinhLanhDaoTTXM2.default;
exports.LanhDaoGiaoViecTTXM = _LanhDaoGiaoViecTTXM2.default;
exports.NhapThongTinToTTXM = _NhapThongTinToTTXM2.default;
exports.NhiemVuTTXM = _NhiemVuTTXM2.default;
exports.TrinhLanhDaoTTXMView = _TrinhLanhDaoTTXMView2.default;
exports.LanhDaoGiaoViecTTXMView = _LanhDaoGiaoViecTTXMView2.default;
exports.NhapThongTinToTTXMView = _NhapThongTinToTTXMView2.default;
exports.KetQuaHoanThanhGiaiQuyetDonCanBo = _KetQuaHoanThanhGiaiQuyetDonCanBo2.default;
exports.KetQuaLapDuThaoCanBo = _KetQuaLapDuThaoCanBo2.default;
exports.LapDuThaoDonKhieuNaiCanBo = _LapDuThaoDonKhieuNaiCanBo2.default;
exports.GiaiQuyetDonCanBo = _GiaiQuyetDonCanBo2.default;
exports.LapDuThaoCanBo = _LapDuThaoCanBo2.default;
exports.CanBoGiaiQuyetYeuCauLapDuThao = _CanBoGiaiQuyetYeuCauLapDuThao2.default;
exports.TrinhLanhDaoTheoDoiThucHien = _TrinhLanhDaoTheoDoiThucHien2.default;
exports.TrinhLanhDaoTheoDoiThucHienView = _TrinhLanhDaoTheoDoiThucHienView2.default;
exports.LanhDaoGiaoViecTheoDoiGiamSatView = _LanhDaoGiaoViecTheoDoiGiamSatView2.default;
exports.LanhDaoGiaoViecTheoDoiGiamSat = _LanhDaoGiaoViecTheoDoiGiamSat2.default;
exports.CanBoNhanYeuCauTheoDoiThucHien = _CanBoNhanYeuCauTheoDoiThucHien2.default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanBoKiemTraDeXuat = exports.CanBoKiemTraDeXuatView = exports.ThongTinYeuCauKTDX = exports.LanhDaoGiaoViecKTDXView = exports.LanhDaoGiaoViecKTDX = exports.TrinhLanhDaoKTDXView = exports.TrinhLanhDaoKTDX = undefined;

var _TrinhLanhDaoKTDX = __webpack_require__(1193);

var _TrinhLanhDaoKTDX2 = _interopRequireDefault(_TrinhLanhDaoKTDX);

var _TrinhLanhDaoKTDXView = __webpack_require__(1194);

var _TrinhLanhDaoKTDXView2 = _interopRequireDefault(_TrinhLanhDaoKTDXView);

var _LanhDaoGiaoViecKTDX = __webpack_require__(1198);

var _LanhDaoGiaoViecKTDX2 = _interopRequireDefault(_LanhDaoGiaoViecKTDX);

var _LanhDaoGiaoViecKTDXView = __webpack_require__(1199);

var _LanhDaoGiaoViecKTDXView2 = _interopRequireDefault(_LanhDaoGiaoViecKTDXView);

var _ThongTinYeuCauKTDX = __webpack_require__(1192);

var _ThongTinYeuCauKTDX2 = _interopRequireDefault(_ThongTinYeuCauKTDX);

var _CanBoKiemTraDeXuatView = __webpack_require__(1196);

var _CanBoKiemTraDeXuatView2 = _interopRequireDefault(_CanBoKiemTraDeXuatView);

var _CanBoKiemTraDeXuat = __webpack_require__(1195);

var _CanBoKiemTraDeXuat2 = _interopRequireDefault(_CanBoKiemTraDeXuat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TrinhLanhDaoKTDX = _TrinhLanhDaoKTDX2.default;
exports.TrinhLanhDaoKTDXView = _TrinhLanhDaoKTDXView2.default;
exports.LanhDaoGiaoViecKTDX = _LanhDaoGiaoViecKTDX2.default;
exports.LanhDaoGiaoViecKTDXView = _LanhDaoGiaoViecKTDXView2.default;
exports.ThongTinYeuCauKTDX = _ThongTinYeuCauKTDX2.default;
exports.CanBoKiemTraDeXuatView = _CanBoKiemTraDeXuatView2.default;
exports.CanBoKiemTraDeXuat = _CanBoKiemTraDeXuat2.default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormXuLyHoacGiaiQuyet = undefined;

var _FormXuLyHoacGiaiQuyet = __webpack_require__(1170);

var _FormXuLyHoacGiaiQuyet2 = _interopRequireDefault(_FormXuLyHoacGiaiQuyet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FormXuLyHoacGiaiQuyet = _FormXuLyHoacGiaiQuyet2.default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = undefined;

var _Loading = __webpack_require__(1231);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Loading = _Loading2.default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GetTrangThaiDonTheoDonVi = function GetTrangThaiDonTheoDonVi(trangThaiDonInfo) {

  var trangThaiDon = {};

  if (trangThaiDonInfo && localStorage.getItem('userInfo')) {

    var data = JSON.parse(localStorage.getItem('userInfo'));

    trangThaiDonInfo.map(function (item) {
      if (item.donViId == data.donViId) {
        trangThaiDon = item;
      }
    });
  }
  return trangThaiDon;
};

exports.GetTrangThaiDonTheoDonVi = GetTrangThaiDonTheoDonVi;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemNhomHoSo = exports.RowItemVanBanXuLy = exports.RowItemDSQuanLyHoSo = exports.RowItemCanCuCuocThanhTra = undefined;

var _RowItemDSQuanLyHoSo = __webpack_require__(1244);

var _RowItemDSQuanLyHoSo2 = _interopRequireDefault(_RowItemDSQuanLyHoSo);

var _RowItemVanBanXuLy = __webpack_require__(1246);

var _RowItemVanBanXuLy2 = _interopRequireDefault(_RowItemVanBanXuLy);

var _RowItemNhomHoSo = __webpack_require__(1245);

var _RowItemNhomHoSo2 = _interopRequireDefault(_RowItemNhomHoSo);

var _RowItemCanCuCuocThanhTra = __webpack_require__(1243);

var _RowItemCanCuCuocThanhTra2 = _interopRequireDefault(_RowItemCanCuCuocThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemCanCuCuocThanhTra = _RowItemCanCuCuocThanhTra2.default;
exports.RowItemDSQuanLyHoSo = _RowItemDSQuanLyHoSo2.default;
exports.RowItemVanBanXuLy = _RowItemVanBanXuLy2.default;
exports.RowItemNhomHoSo = _RowItemNhomHoSo2.default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimKiemYeuCau = exports.FormTimKiemNangCao = exports.InputTuKhoa = undefined;

var _inputTukhoa = __webpack_require__(1274);

var _inputTukhoa2 = _interopRequireDefault(_inputTukhoa);

var _formNangcao = __webpack_require__(1273);

var _formNangcao2 = _interopRequireDefault(_formNangcao);

var _TimKiemYeuCau = __webpack_require__(1272);

var _TimKiemYeuCau2 = _interopRequireDefault(_TimKiemYeuCau);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.InputTuKhoa = _inputTukhoa2.default;
exports.FormTimKiemNangCao = _formNangcao2.default;
exports.TimKiemYeuCau = _TimKiemYeuCau2.default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemCoQuanTiepDan = exports.RowItemListSearchPeople = exports.RowItemListGroupTypeReception = exports.RowItemListDocumentSearchPopup = exports.RowItemDocumentDetail = undefined;

var _RowItemListDocumentSearchPopup = __webpack_require__(1302);

var _RowItemListDocumentSearchPopup2 = _interopRequireDefault(_RowItemListDocumentSearchPopup);

var _RowItemListGroupTypeReception = __webpack_require__(1303);

var _RowItemListGroupTypeReception2 = _interopRequireDefault(_RowItemListGroupTypeReception);

var _RowItemListSearchPeople = __webpack_require__(1304);

var _RowItemListSearchPeople2 = _interopRequireDefault(_RowItemListSearchPeople);

var _RowItemDocumentDetail = __webpack_require__(1301);

var _RowItemDocumentDetail2 = _interopRequireDefault(_RowItemDocumentDetail);

var _RowItemCoQuanTiepDan = __webpack_require__(1300);

var _RowItemCoQuanTiepDan2 = _interopRequireDefault(_RowItemCoQuanTiepDan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemDocumentDetail = _RowItemDocumentDetail2.default;
exports.RowItemListDocumentSearchPopup = _RowItemListDocumentSearchPopup2.default;
exports.RowItemListGroupTypeReception = _RowItemListGroupTypeReception2.default;
exports.RowItemListSearchPeople = _RowItemListSearchPeople2.default;
exports.RowItemCoQuanTiepDan = _RowItemCoQuanTiepDan2.default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

var _datatable = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTable = function (_React$Component) {
  _inherits(DataTable, _React$Component);

  function DataTable(props, context) {
    _classCallCheck(this, DataTable);

    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props, context));

    _this.state = {
      export: 'btn-green tt-export',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      divHeight: 195,
      down: false,
      scrollLeft: '',
      x: '',
      ie: false
    };

    return _this;
  }

  _createClass(DataTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      if (this.props.parent && this.props.parent.handleChangePageSize) {
        this.props.parent.handleChangePageSize.bind(this.props.parent, size);
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      if (this.props.parent && this.props.parent.handlePageC1lick) {
        this.props.parent.handlePageClick.bind(this.props.parent, page);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkIe();
      if (this.props.hideExport) {
        this.setState({
          export: 'btn-green tt-export disable'
        });
      }

      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'checkIe',
    value: function checkIe() {
      var ua = window.navigator.userAgent;
      var isIE = /MSIE|Trident/.test(ua);
      this.setState({
        ie: isIE
      });
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {}
  }, {
    key: 'handleExport',
    value: function handleExport() {
      this.props.handleExport();
    }
  }, {
    key: 'getItemNull',
    value: function getItemNull() {
      return this.props.children;
    }
  }, {
    key: 'handleDown',
    value: function handleDown(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        document.getElementById('scrollItem').classList.add("scrolling");
        this.state.down = true;
        this.state.scrollLeft = Item.scrollLeft;
        this.state.x = e.clientX;
      }
    }
  }, {
    key: 'handleUp',
    value: function handleUp() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        if (this.state.down == true) {
          Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
        }
      }
    }
  }, {
    key: 'handleLeave',
    value: function handleLeave() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.props.openDialog();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue() {
      this.props.handleContinue();
    }
  }, {
    key: 'onCheck',
    value: function onCheck() {
      this.props.onCheck();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;
      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this2.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item,
          parent: _this2.props.parent
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table' },
        this.props.displayCount ? _react2.default.createElement(
          'div',
          { className: 'tc-total' },
          'C\xF3 ',
          _react2.default.createElement(
            'span',
            null,
            this.props.pageData.totalElements
          ),
          ' k\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm ph\xF9 h\u1EE3p v\u1EDBi y\xEAu c\u1EA7u'
        ) : '',
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('table-container', {
              'touch-move': this.props.touchMove,
              'checktracuu': this.props.checkTraCuu,
              'checktdgs': this.props.checkTDGS
            }),
            id: 'scrollItem',
            onMouseUp: this.handleUp.bind(this),
            onMouseDown: this.handleDown.bind(this),
            onMouseMove: this.handleMove.bind(this),
            onMouseLeave: this.handleLeave.bind(this)
          },
          _react2.default.createElement(
            'div',
            { className: 'scrollTTT', id: 'scrollTTT' },
            _react2.default.createElement(
              'table',
              { className: 'table-content thanh-tra-trung' },
              _react2.default.createElement(
                'thead',
                { className: 'table-header hd' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.onDisableCheck !== true },
                    _react2.default.createElement(
                      'th',
                      { className: 'table-header-col table-checkbox', style: { width: 40 } },
                      _react2.default.createElement(
                        'label',
                        { className: 'pt-control pt-checkbox pt-large' },
                        _react2.default.createElement('input', { type: 'checkbox', className: 'pt-large', name: '', onChange: this.onCheck.bind(this), checked: this.props.selectAllStatus }),
                        _react2.default.createElement('span', { className: 'pt-control-indicator' })
                      )
                    )
                  ),
                  this.props.header.map(function (item, i) {
                    return _react2.default.createElement(
                      'th',
                      { key: i, className: (0, _classnames2.default)('table-header-col ' + (item.className ? item.className : ''), {
                          'ie': _this2.state.ie
                        }), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                      item.name
                    );
                  })
                )
              ),
              (0, _lodash.isArray)(this.props.dataList) && this.props.dataList.length === 0 && !this.props.tableLoading && _react2.default.createElement(
                'tbody',
                { className: 'table-body' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + this.props.plusColum },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              this.props.tableLoading ? _react2.default.createElement(
                'tbody',
                { className: 'table-body' },
                _react2.default.createElement(
                  'tr',
                  { className: 'table-loading' },
                  _react2.default.createElement(_datatable.LoadingDataTale, { countLoading: 12, colSpan: this.props.header.length + 1 })
                )
              ) : dataListItem
            )
          ),
          !this.props.hidePagination && this.props.dataList.length > 0 ? _react2.default.createElement(
            'div',
            { className: 'pagination-wrap' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thanhTra || !this.props.hideButtonExport },
              _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
            ),
            !this.props.hideButtonExport ? _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExportExcel.bind(this) }) : _react2.default.createElement('div', null),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.showXuLy === true },
              this.props.btnTiepTuc ? _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleContinue.bind(this), className: 'btn-action btn-move action-todo mg-0' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Ti\u1EBFp t\u1EE5c x\u1EED l\xFD'
                )
              ) : _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.openDialog.bind(this), className: 'btn-action btn-move action-todo mg-0' },
                _react2.default.createElement(
                  'span',
                  null,
                  'X\u1EED l\xFD'
                )
              )
            )
          ) : null
        )
      );
    }
  }]);

  return DataTable;
}(_react2.default.Component);

exports.default = DataTable;

DataTable.defaultProps = {
  onChangeHeader: function onChangeHeader() {},
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  titleAddmore: 'Thêm mới',
  ThongKeBaoCao: false,
  LapBaoCao: false,
  addNew: false,
  addNewItem: function addNewItem() {},
  dataList: [],
  header: [],
  plusColum: 0,
  displayCount: false,
  emptyMsg: 'Chưa có dữ liệu'
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _DonDocDoiTuong = __webpack_require__(1396);

var _DonDocDoiTuong2 = _interopRequireDefault(_DonDocDoiTuong);

var _DonDocDoiTuongView = __webpack_require__(1397);

var _DonDocDoiTuongView2 = _interopRequireDefault(_DonDocDoiTuongView);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListDonDoc = function (_React$Component) {
  _inherits(ListDonDoc, _React$Component);

  function ListDonDoc(props, context) {
    _classCallCheck(this, ListDonDoc);

    var _this = _possibleConstructorReturn(this, (ListDonDoc.__proto__ || Object.getPrototypeOf(ListDonDoc)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      data: [],
      dataPost: [],
      dataPatch: [],
      dataDelete: [],
      dataKetQuaThucHienDonDoc: [],
      dataHinhThucDonDoc: []
    };
    return _this;
  }

  _createClass(ListDonDoc, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
      this.getDonDocDoiTuongs();
      this.getKetQuaThucHienDonDoc();
      this.getHinhThucDonDocs();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.id != nextProps.id) {
        this.setState({
          id: nextProps.id
        }, function () {
          _this2.getDonDocDoiTuongs();
        });
      }
    }
  }, {
    key: 'addLanDonDoc',
    value: function addLanDonDoc() {
      var _this3 = this;

      var newItem = {
        coQuanBanHanhCuongChe: '',
        coQuanBanHanhHuyCuongChe: '',
        doiTuongViPham: '',
        ghiChu: '',
        hinhThucCuongChe: '',
        hinhThucDonDoc: null,
        huyCuongChe: false,
        ketQuaThucHien: null,
        ngayBanHanh: '',
        ngayBanHanhCuongChe: '',
        ngayBanHanhHuyCuongChe: '',
        ngayBatDauDonDoc: '',
        ngayHetHanDonDoc: '',
        soQuyetDinhCuongChe: '',
        soQuyetDinhHuyCuongChe: '',
        soTienCuongChe: '',
        soVanBan: '',
        thoiGianThucHienCuongChe: '',
        thoiGianThucHienHuyCuongChe: '',
        thoiHanDonDoc: '',
        thoiHanNgayLamViecDonDoc: '',
        tinhHinhTienDoThucHienCuongChe: '',
        tinhHinhTienDoThucHienKetLuan: '',
        toChucTinDungThucHienCuongChe: '',
        toChucTinDungThucHienHuyCuongChe: ''
      };
      this.setState({
        dataPost: [].concat(_toConsumableArray(this.state.dataPost), [newItem])
      }, function () {
        if (_this3.state.data.length > 0 || _this3.state.dataPost.length > 1) {
          _this3.props.onChangeData();
        }
      });
    }
  }, {
    key: 'getDonDocDoiTuongs',
    value: function getDonDocDoiTuongs() {
      var _this4 = this;

      var params = {
        doiTuongViPhamId: this.state.id
      };
      _api.ThanhTra.actions.donDocDoiTuongs.request(params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            data: res.data._embedded.donDocDoiTuongs
          });
        } else {
          _this4.addLanDonDoc();
        }
      });
    }
  }, {
    key: 'getKetQuaThucHienDonDoc',
    value: function getKetQuaThucHienDonDoc() {
      var _this5 = this;

      _api.ThanhTra.actions.ketQuaThucHienDonDoc.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            dataKetQuaThucHienDonDoc: res.data
          });
        }
      });
    }
  }, {
    key: 'getHinhThucDonDocs',
    value: function getHinhThucDonDocs() {
      var _this6 = this;

      _api.ThanhTra.actions.hinhThucDonDocs.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataHinhThucDonDoc: res.data
          });
        }
      });
    }
  }, {
    key: 'onChangeData',
    value: function onChangeData(state, id) {
      var data = [].concat(_toConsumableArray(this.state.dataPatch));

      var index = data.findIndex(function (x) {
        return x.donDocDoiTuongId == id;
      });
      if (index == -1) {
        this.setState({
          dataPatch: [].concat(_toConsumableArray(this.state.dataPatch), [state])
        });
      } else {
        this.state.dataPatch[index] = state;
        this.setState({
          dataPatch: this.state.dataPatch
        });
      }
      this.props.onChangeData();
    }
  }, {
    key: 'onChangeDataPost',
    value: function onChangeDataPost(data, index) {
      this.state.dataPost[index] = data;
      this.setState({
        dataPost: this.state.dataPost
      });
      this.props.onChangeData();
    }
  }, {
    key: 'onRemoveData',
    value: function onRemoveData(index, id) {
      var newData = [].concat(_toConsumableArray(this.state.data));

      newData.splice(index, 1);
      this.state.data = newData;
      var itemDelete = {
        id: id
      };
      this.setState({
        data: this.state.data,
        dataDelete: [].concat(_toConsumableArray(this.state.dataDelete), [itemDelete])
      });
      this.props.onChangeData();
    }
  }, {
    key: 'onRemoveDataPost',
    value: function onRemoveDataPost(index) {
      var newData = [].concat(_toConsumableArray(this.state.dataPost));
      newData.splice(index, 1);
      this.state.dataPost = newData;
      this.setState({
        dataPost: this.state.dataPost
      });
      this.props.onChangeData();
    }
  }, {
    key: 'handleSave',
    value: function handleSave(callback) {
      var _this7 = this;

      this.postDonDoc(function () {
        _this7.patchDonDoc(function () {
          _this7.deleteDonDoc(function () {
            callback();
          });
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'patchDonDoc',
    value: function patchDonDoc(callback) {
      var _this8 = this;

      if (this.state.dataPatch.length > 0) {
        var donDocDoiTuongPatch = [];
        this.state.dataPatch.map(function (item) {
          var itemPost = item;
          if (itemPost.ngayBanHanh) {
            itemPost.ngayBanHanh = (0, _moment2.default)(new Date(itemPost.ngayBanHanh)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanh = null;
          }
          if (itemPost.ngayBanHanhCuongChe) {
            itemPost.ngayBanHanhCuongChe = (0, _moment2.default)(new Date(itemPost.ngayBanHanhCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanhCuongChe = null;
          }
          if (itemPost.ngayBanHanhHuyCuongChe) {
            itemPost.ngayBanHanhHuyCuongChe = (0, _moment2.default)(new Date(itemPost.ngayBanHanhHuyCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanhHuyCuongChe = null;
          }
          if (itemPost.ngayBatDauDonDoc) {
            itemPost.ngayBatDauDonDoc = (0, _moment2.default)(new Date(itemPost.ngayBatDauDonDoc)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBatDauDonDoc = null;
          }
          if (itemPost.ngayHetHanDonDoc) {
            itemPost.ngayHetHanDonDoc = (0, _moment2.default)(new Date(itemPost.ngayHetHanDonDoc)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayHetHanDonDoc = null;
          }
          if (itemPost.thoiGianThucHienCuongChe) {
            itemPost.thoiGianThucHienCuongChe = (0, _moment2.default)(new Date(itemPost.thoiGianThucHienCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.thoiGianThucHienCuongChe = null;
          }
          if (itemPost.thoiGianThucHienHuyCuongChe) {
            itemPost.thoiGianThucHienHuyCuongChe = (0, _moment2.default)(new Date(itemPost.thoiGianThucHienHuyCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.thoiGianThucHienHuyCuongChe = null;
          }

          itemPost.ketQuaThucHien = itemPost.ketQuaThucHien ? itemPost.ketQuaThucHien : null;
          itemPost.hinhThucDonDoc = itemPost.hinhThucDonDoc ? itemPost.hinhThucDonDoc : null;

          itemPost.doiTuongViPham = {
            id: Number(_this8.state.id)
          };

          donDocDoiTuongPatch[donDocDoiTuongPatch.length] = itemPost;
        });
        var params = {
          donDocDoiTuongs: [].concat(donDocDoiTuongPatch)
        };
        _api.ThanhTra.actions.patchDonDoc.request('', params).then(function (res) {
          callback();
        }).catch(function (err) {});
      } else {
        callback();
      }
    }
  }, {
    key: 'postDonDoc',
    value: function postDonDoc(callback) {
      var _this9 = this;

      if (this.state.dataPost.length > 0) {
        var donDocDoiTuongs = [];
        this.state.dataPost.map(function (item) {
          var itemPost = item;
          if (itemPost.ngayBanHanh) {
            itemPost.ngayBanHanh = (0, _moment2.default)(new Date(itemPost.ngayBanHanh)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanh = null;
          }
          if (itemPost.ngayBanHanhCuongChe) {
            itemPost.ngayBanHanhCuongChe = (0, _moment2.default)(new Date(itemPost.ngayBanHanhCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanhCuongChe = null;
          }
          if (itemPost.ngayBanHanhHuyCuongChe) {
            itemPost.ngayBanHanhHuyCuongChe = (0, _moment2.default)(new Date(itemPost.ngayBanHanhHuyCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBanHanhHuyCuongChe = null;
          }
          if (itemPost.ngayBatDauDonDoc) {
            itemPost.ngayBatDauDonDoc = (0, _moment2.default)(new Date(itemPost.ngayBatDauDonDoc)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayBatDauDonDoc = null;
          }
          if (itemPost.ngayHetHanDonDoc) {
            itemPost.ngayHetHanDonDoc = (0, _moment2.default)(new Date(itemPost.ngayHetHanDonDoc)).add(7, 'hours').toISOString();
          } else {
            itemPost.ngayHetHanDonDoc = null;
          }
          if (itemPost.thoiGianThucHienCuongChe) {
            itemPost.thoiGianThucHienCuongChe = (0, _moment2.default)(new Date(itemPost.thoiGianThucHienCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.thoiGianThucHienCuongChe = null;
          }
          if (itemPost.thoiGianThucHienHuyCuongChe) {
            itemPost.thoiGianThucHienHuyCuongChe = (0, _moment2.default)(new Date(itemPost.thoiGianThucHienHuyCuongChe)).add(7, 'hours').toISOString();
          } else {
            itemPost.thoiGianThucHienHuyCuongChe = null;
          }

          itemPost.ketQuaThucHien = itemPost.ketQuaThucHien ? itemPost.ketQuaThucHien : null;
          itemPost.hinhThucDonDoc = itemPost.hinhThucDonDoc ? itemPost.hinhThucDonDoc : null;

          itemPost.doiTuongViPham = {
            id: Number(_this9.state.id)
          };

          donDocDoiTuongs[donDocDoiTuongs.length] = itemPost;
        });
        var params = {
          donDocDoiTuongs: donDocDoiTuongs
        };

        _api.ThanhTra.actions.postDonDoc.request('', params).then(function (res) {
          callback();
        }).catch(function (err) {});
      } else {
        callback();
      }
    }
  }, {
    key: 'deleteDonDoc',
    value: function deleteDonDoc(callback) {
      if (this.state.dataDelete.length > 0) {
        var params = {
          donDocDoiTuongs: [].concat(_toConsumableArray(this.state.dataDelete))
        };
        _api.ThanhTra.actions.deleteDonDoc.request('', params).then(function (res) {
          callback();
        }).catch(function (err) {});
      } else {
        callback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      return _react2.default.createElement(
        'div',
        { className: 'pl15 pr15' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view != true },
          _react2.default.createElement(
            'div',
            null,
            this.state.data.map(function (item, index) {
              if (_this10.state.dataPost.length == 0 && index == _this10.state.data.length - 1) {
                return _react2.default.createElement(_DonDocDoiTuong2.default, _extends({ toChucLienQuan: _this10.props.toChucLienQuan }, item, { dataDetail: item, doiTuongViPhamId: _this10.state.id, key: index, indexItem: index, enableDelete: true, countItem: _this10.state.data.length + _this10.state.dataPost.length, bindValidator: _this10, index: index, onRemove: _this10.onRemoveData.bind(_this10), onChange: _this10.onChangeData.bind(_this10), dataHinhThucDonDoc: _this10.state.dataHinhThucDonDoc, dataKetQuaThucHienDonDoc: _this10.state.dataKetQuaThucHienDonDoc }));
              } else {
                return _react2.default.createElement(_DonDocDoiTuong2.default, _extends({ toChucLienQuan: _this10.props.toChucLienQuan }, item, { dataDetail: item, doiTuongViPhamId: _this10.state.id, key: index, indexItem: index, countItem: _this10.state.data.length + _this10.state.dataPost.length, bindValidator: _this10, index: index, onRemove: _this10.onRemoveData.bind(_this10), onChange: _this10.onChangeData.bind(_this10), dataHinhThucDonDoc: _this10.state.dataHinhThucDonDoc, dataKetQuaThucHienDonDoc: _this10.state.dataKetQuaThucHienDonDoc }));
              }
            }),
            this.state.dataPost.map(function (item, index) {
              if (index == _this10.state.dataPost.length - 1) {
                return _react2.default.createElement(_DonDocDoiTuong2.default, _extends({ toChucLienQuan: _this10.props.toChucLienQuan }, item, { dataDetail: item, doiTuongViPhamId: _this10.state.id, key: index, indexItem: index, enableDelete: true, countItem: _this10.state.data.length + _this10.state.dataPost.length, bindValidator: _this10, index: _this10.state.data.length + index, onRemove: _this10.onRemoveDataPost.bind(_this10), onChange: _this10.onChangeDataPost.bind(_this10), dataHinhThucDonDoc: _this10.state.dataHinhThucDonDoc, dataKetQuaThucHienDonDoc: _this10.state.dataKetQuaThucHienDonDoc }));
              } else {
                return _react2.default.createElement(_DonDocDoiTuong2.default, _extends({ toChucLienQuan: _this10.props.toChucLienQuan }, item, { dataDetail: item, doiTuongViPhamId: _this10.state.id, key: index, indexItem: index, countItem: _this10.state.data.length + _this10.state.dataPost.length, bindValidator: _this10, index: _this10.state.data.length + index, onRemove: _this10.onRemoveDataPost.bind(_this10), onChange: _this10.onChangeDataPost.bind(_this10), dataHinhThucDonDoc: _this10.state.dataHinhThucDonDoc, dataKetQuaThucHienDonDoc: _this10.state.dataKetQuaThucHienDonDoc }));
              }
            })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view === true },
          this.state.data.map(function (item, index) {
            return _react2.default.createElement(_DonDocDoiTuongView2.default, _extends({ toChucLienQuan: _this10.props.toChucLienQuan }, item, { dataDetail: item, key: index, countItem: index + 1, index: index, dataHinhThucDonDoc: _this10.state.dataHinhThucDonDoc, dataKetQuaThucHienDonDoc: _this10.state.dataKetQuaThucHienDonDoc }));
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view != true },
          _react2.default.createElement(
            'div',
            { className: 'mt5 mb15' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-green', onClick: this.addLanDonDoc.bind(this) },
              ' ',
              _react2.default.createElement('i', { className: 'tt tt-addfile' }),
              'Th\xEAm l\u1EA7n \u0111\xF4n \u0111\u1ED1c'
            )
          )
        )
      );
    }
  }]);

  return ListDonDoc;
}(_react2.default.Component);

exports.default = (0, _utils.validatable)(ListDonDoc);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LanNopTien = __webpack_require__(1398);

var _LanNopTien2 = _interopRequireDefault(_LanNopTien);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListLanNopTien = function (_React$Component) {
  _inherits(ListLanNopTien, _React$Component);

  function ListLanNopTien(props, context) {
    _classCallCheck(this, ListLanNopTien);

    var _this = _possibleConstructorReturn(this, (ListLanNopTien.__proto__ || Object.getPrototypeOf(ListLanNopTien)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(ListLanNopTien, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: 'addLanNopTien',
    value: function addLanNopTien() {
      var _this2 = this;

      var newItem = {
        ngayNopTien: null,
        soTien: '',
        tongCong: '',
        conPhaiThu: ''
      };
      this.setState({
        data: [].concat(_toConsumableArray(this.state.data), [newItem])
      }, function () {
        var data = {
          target: {
            value: _this2.state.data
          }
        };
        _this2.props.onChange(data);
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(data, index) {
      var _this3 = this;

      this.state.data[index] = data;
      this.setState({
        data: this.state.data
      }, function () {
        var data = {
          target: {
            value: _this3.state.data
          }
        };
        _this3.props.onChange(data);
      });
    }
  }, {
    key: 'onRemove',
    value: function onRemove(index) {
      var _this4 = this;

      var newData = [].concat(_toConsumableArray(this.state.data));
      newData.splice(index, 1);
      this.state.data = newData;

      this.setState({
        data: this.state.data
      }, function () {
        var data = {
          target: {
            value: _this4.state.data
          }
        };
        _this4.props.onChange(data);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-100' },
        this.state.data.map(function (item, i) {
          return _react2.default.createElement(_LanNopTien2.default, _extends({ key: i }, item, { view: _this5.props.view, onChange: _this5.onChange.bind(_this5), onRemove: _this5.onRemove.bind(_this5), index: i + 1 }));
        }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view != true },
          _react2.default.createElement(
            'div',
            { className: 'mt5 mb15' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-green', onClick: this.addLanNopTien.bind(this) },
              ' ',
              _react2.default.createElement('i', { className: 'tt tt-addfile' }),
              'Th\xEAm ng\xE0y n\u1ED9p ti\u1EC1n'
            )
          )
        )
      );
    }
  }]);

  return ListLanNopTien;
}(_react2.default.Component);

ListLanNopTien.defaultProps = {
  data: []
};

exports.default = ListLanNopTien;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateRomanNumeralsObject = generateRomanNumeralsObject;
function convertToRoman(num) {
  var romanNumeralsMap = [{ value: 1000, numeral: 'M' }, { value: 900, numeral: 'CM' }, { value: 500, numeral: 'D' }, { value: 400, numeral: 'CD' }, { value: 100, numeral: 'C' }, { value: 90, numeral: 'XC' }, { value: 50, numeral: 'L' }, { value: 40, numeral: 'XL' }, { value: 10, numeral: 'X' }, { value: 9, numeral: 'IX' }, { value: 5, numeral: 'V' }, { value: 4, numeral: 'IV' }, { value: 1, numeral: 'I' }];

  var result = '';

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = romanNumeralsMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _step.value,
          value = _step$value.value,
          numeral = _step$value.numeral;

      while (num >= value) {
        result += numeral;
        num -= value;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

function generateRomanNumeralsObject(limit) {
  var romanNumerals = {};

  for (var i = 1; i <= limit; i++) {
    romanNumerals[i] = convertToRoman(i);
  }

  return romanNumerals;
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayObjectIndexOf = arrayObjectIndexOf;
exports.getAllChildren = getAllChildren;
exports.removeAllChildren = removeAllChildren;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function arrayObjectIndexOf(myArray, searchTerm, property) {
  return objectIndexOf(myArray, searchTerm, property);
}

function objectIndexOf(myArray, searchTerm, property) {
  var result = -1;
  myArray.forEach(function (item, i) {
    if (result == -1 && item[property] == searchTerm) {
      result = i;
    }
  });
  return result;
}

function getAllChildren(dataAray, myArray, propertyParent, propertyChildren) {
  //propertyParent: donViHanhChinhID
  //propertyChildren: donViHanhChinhCha
  var dataResult = [].concat(_toConsumableArray(myArray));

  myArray.forEach(function (item) {
    var Result = getChildren(dataAray, myArray, item.value, propertyParent, propertyChildren);
    dataResult = [].concat(_toConsumableArray(dataResult), _toConsumableArray(Result));
  });
  return dataResult;
}

function removeAllChildren(inputArray) {
  //propertyParent: donViHanhChinhID
  //propertyChildren: donViHanhChinhCha
  var outputArray = inputArray.filter(function (item) {
    return item.isChild != true;
  });
  return outputArray;
}

function getChildren(dataAray, myArray, value, propertyParent, propertyChildren) {
  var dataResult = dataAray.filter(function (item) {
    return item[propertyChildren] && item[propertyChildren][propertyParent] == value;
  });
  var dataReturn = [];
  if (dataResult.length > 0) {
    dataResult.forEach(function (item) {
      if (objectIndexOf(myArray, item[propertyParent], 'value') == -1) {
        dataReturn = [].concat(_toConsumableArray(dataReturn), [{
          value: item[propertyParent],
          label: item.ten,
          isChild: true
        }]);
      }
      var dataReGet = getChildren(dataAray, myArray, item[propertyParent], propertyParent, propertyChildren);
      if (dataReGet.length > 0) {
        dataReturn = [].concat(_toConsumableArray(dataReturn), _toConsumableArray(dataReGet));
      }
    });
  }

  return dataReturn;
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkThamSo = checkThamSo;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function checkThamSo() {
  var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
  var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
  if (ThamSo.length > 0 && userInfo != {}) {
    var data = [].concat(_toConsumableArray(ThamSo));
    var dataFilter = data.filter(function (state) {
      return Number(state.giaTri) == Number(userInfo.coQuanQuanLyId);
    });
    if (dataFilter.length > 0) {
      return dataFilter[0].ten;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(252)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(152);
var toLength = __webpack_require__(45);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1602);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(53);
var createDesc = __webpack_require__(149);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var document = __webpack_require__(30).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 329 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(43)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(30).document;
module.exports = document && document.documentElement;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var setPrototypeOf = __webpack_require__(341).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(172);
var ITERATOR = __webpack_require__(43)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(146);
var descriptor = __webpack_require__(149);
var setToStringTag = __webpack_require__(173);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(77)(IteratorPrototype, __webpack_require__(43)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(132);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(78);
var hide = __webpack_require__(77);
var Iterators = __webpack_require__(172);
var $iterCreate = __webpack_require__(334);
var setToStringTag = __webpack_require__(173);
var getPrototypeOf = __webpack_require__(86);
var ITERATOR = __webpack_require__(43)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var macrotask = __webpack_require__(346).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(93)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(68);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(200);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(36);
var anObject = __webpack_require__(27);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(95)(Function.call, __webpack_require__(85).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(203)('keys');
var uid = __webpack_require__(153);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(245);
var defined = __webpack_require__(103);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(97);
var defined = __webpack_require__(103);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(95);
var invoke = __webpack_require__(518);
var html = __webpack_require__(331);
var cel = __webpack_require__(328);
var global = __webpack_require__(30);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(93)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var DESCRIPTORS = __webpack_require__(48);
var LIBRARY = __webpack_require__(132);
var $typed = __webpack_require__(253);
var hide = __webpack_require__(77);
var redefineAll = __webpack_require__(150);
var fails = __webpack_require__(34);
var anInstance = __webpack_require__(144);
var toInteger = __webpack_require__(97);
var toLength = __webpack_require__(45);
var toIndex = __webpack_require__(537);
var gOPN = __webpack_require__(147).f;
var dP = __webpack_require__(53).f;
var arrayFill = __webpack_require__(325);
var setToStringTag = __webpack_require__(173);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(94);
var LIBRARY = __webpack_require__(132);
var wksExt = __webpack_require__(538);
var defineProperty = __webpack_require__(53).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(171);
var ITERATOR = __webpack_require__(43)('iterator');
var Iterators = __webpack_require__(172);
module.exports = __webpack_require__(94).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(131);
var step = __webpack_require__(521);
var Iterators = __webpack_require__(172);
var toIObject = __webpack_require__(87);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(335)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(205);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(354);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumberArray;
/* harmony default export */ __webpack_exports__["b"] = (function(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
});

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(356);










/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant_js__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string_js__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date_js__["a" /* default */]
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__numberArray_js__["a" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_8__numberArray_js__["b" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array_js__["a" /* genericArray */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object_js__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */])(a, b);
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(1866);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(1885);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_radialArea__ = __webpack_require__(1886);
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_radialLine__ = __webpack_require__(578);
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_symbol__ = __webpack_require__(1888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__src_symbol__["a"]; });
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__ = __webpack_require__(581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__ = __webpack_require__(582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__ = __webpack_require__(1868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__ = __webpack_require__(1869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basis__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_bundle__ = __webpack_require__(1870);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_cardinalClosed__ = __webpack_require__(574);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_cardinalOpen__ = __webpack_require__(575);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinal__ = __webpack_require__(262);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_catmullRomClosed__ = __webpack_require__(1871);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_catmullRomOpen__ = __webpack_require__(1872);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRom__ = __webpack_require__(360);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__ = __webpack_require__(1873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__ = __webpack_require__(1874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__ = __webpack_require__(1875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_step__ = __webpack_require__(1876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_stack__ = __webpack_require__(1887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_29__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__ = __webpack_require__(1879);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_30__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_offset_none__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_31__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__ = __webpack_require__(1880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_order_ascending__ = __webpack_require__(362);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_order_descending__ = __webpack_require__(1882);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_order_insideOut__ = __webpack_require__(1883);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_none__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_reverse__ = __webpack_require__(1884);
/* unused harmony reexport stackOrderReverse */












































/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(262);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(577);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(211);


/* harmony default export */ __webpack_exports__["b"] = (function(series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(588);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond_js__ = __webpack_require__(1892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second_js__ = __webpack_require__(1895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute_js__ = __webpack_require__(1893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__minute_js__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour_js__ = __webpack_require__(1891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__hour_js__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_js__ = __webpack_require__(1890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__day_js__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week_js__ = __webpack_require__(1902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month_js__ = __webpack_require__(1894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__month_js__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year_js__ = __webpack_require__(1903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__year_js__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__ = __webpack_require__(1898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour_js__ = __webpack_require__(1897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour_js__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay_js__ = __webpack_require__(1896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay_js__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__ = __webpack_require__(1900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__ = __webpack_require__(1899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear_js__ = __webpack_require__(1901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear_js__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(212);
var CharacterMetadata = __webpack_require__(80);
var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var DraftEntity = __webpack_require__(266);
var DraftFeatureFlags = __webpack_require__(135);
var Immutable = __webpack_require__(35);
var SelectionState = __webpack_require__(178);

var generateRandomKey = __webpack_require__(118);
var sanitizeDraftText = __webpack_require__(371);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var ContentStateRecord = Record(defaultRecord);

var ContentState = function (_ContentStateRecord) {
  _inherits(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * @format
 * 
 */



var _require = __webpack_require__(35),
    Map = _require.Map;

var React = __webpack_require__(0);

var cx = __webpack_require__(179);

var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @format
 * 
 */



var UserAgent = __webpack_require__(106);

var isOSX = UserAgent.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

module.exports = KeyBindingUtil;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @format
 * 
 */



var getSelectionOffsetKeyForNode = __webpack_require__(604);

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */



/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */



var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getStyleProperty = __webpack_require__(1994);

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

module.exports = Style;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var invariant = __webpack_require__(21);

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

module.exports = UnicodeBidiDirection;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var getDocumentScrollElement = __webpack_require__(1990);
var getUnboundedScrollPosition = __webpack_require__(620);

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18a974d4609cd913fe351472fd526642.png";

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce77f36df6503d014cae1242748d294b.png";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(2020);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(180);

var _DOMUtils = __webpack_require__(274);

var _DOMStateStorage = __webpack_require__(627);

var _PathUtils = __webpack_require__(137);

var _ExecutionEnvironment = __webpack_require__(382);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(2025);

var _PathUtils = __webpack_require__(137);

var _runTransitionHook = __webpack_require__(384);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(273);

var _LocationUtils = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159),
    root = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2115),
    mapCacheDelete = __webpack_require__(2116),
    mapCacheGet = __webpack_require__(2117),
    mapCacheHas = __webpack_require__(2118),
    mapCacheSet = __webpack_require__(2119);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(642),
    toKey = __webpack_require__(281);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2063),
    isObjectLike = __webpack_require__(119);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(181);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2062),
    isObjectLike = __webpack_require__(119);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(2050),
    baseKeys = __webpack_require__(2068),
    isArrayLike = __webpack_require__(218);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(182);
var Danger = __webpack_require__(2183);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactInstrumentation = __webpack_require__(99);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(406);
var setInnerHTML = __webpack_require__(287);
var setTextContent = __webpack_require__(818);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactErrorUtils = __webpack_require__(404);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactPropTypesSecret = __webpack_require__(2212);
var propTypesFactory = __webpack_require__(795);

var React = __webpack_require__(187);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(122);
var ReactInstanceMap = __webpack_require__(222);
var ReactInstrumentation = __webpack_require__(99);
var ReactUpdates = __webpack_require__(108);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var emptyFunction = __webpack_require__(71);
var warning = __webpack_require__(37);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PaginationBoxView = __webpack_require__(2246);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef !== 'undefined';

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(32);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Area
 */













var Area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Area, _Component);

  function Area() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Area);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["c" /* uniqueId */])('recharts-area-'), _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Area, [{
    key: 'renderCurve',
    value: function renderCurve() {
      var _props = this.props,
          layout = _props.layout,
          type = _props.type,
          stroke = _props.stroke,
          points = _props.points,
          baseLine = _props.baseLine,
          connectNulls = _props.connectNulls,
          isRange = _props.isRange;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'g',
        null,
        stroke !== 'none' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
          className: 'recharts-area-curve',
          layout: layout,
          type: type,
          connectNulls: connectNulls,
          fill: 'none',
          points: points
        })),
        stroke !== 'none' && isRange && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
          className: 'recharts-area-curve',
          layout: layout,
          type: type,
          connectNulls: connectNulls,
          fill: 'none',
          points: baseLine
        })),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, this.props, {
          stroke: 'none',
          className: 'recharts-area-area'
        }))
      );
    }
  }, {
    key: 'renderHorizontalRect',
    value: function renderHorizontalRect(alpha) {
      var _props2 = this.props,
          baseLine = _props2.baseLine,
          points = _props2.points,
          strokeWidth = _props2.strokeWidth;

      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);
      var maxY = Math.max.apply(null, points.map(function (entry) {
        return entry.y || 0;
      }));

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* isNumber */])(baseLine)) {
        maxY = Math.max(baseLine, maxY);
      } else {
        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        x: startX < endX ? startX : startX - width,
        y: 0,
        width: width,
        height: maxY + (strokeWidth || 1)
      });
    }
  }, {
    key: 'renderVerticalRect',
    value: function renderVerticalRect(alpha) {
      var _props3 = this.props,
          baseLine = _props3.baseLine,
          points = _props3.points,
          strokeWidth = _props3.strokeWidth;

      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);
      var maxX = Math.max.apply(null, points.map(function (entry) {
        return entry.x || 0;
      }));

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* isNumber */])(baseLine)) {
        maxX = Math.max(baseLine, maxX);
      } else {
        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        x: 0,
        y: startY < endY ? startY : startY - height,
        width: maxX + (strokeWidth || 1),
        height: height
      });
    }
  }, {
    key: 'renderClipRect',
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;


      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }

      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: 'renderClipPath',
    value: function renderClipPath() {
      var _this2 = this;

      var _props4 = this.props,
          isAnimationActive = _props4.isAnimationActive,
          animationDuration = _props4.animationDuration,
          animationEasing = _props4.animationEasing,
          animationBegin = _props4.animationBegin,
          animationId = _props4.animationId;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'defs',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'clipPath',
          { id: 'animationClipPath-' + this.id },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_smooth___default.a,
            {
              easing: animationEasing,
              isActive: isAnimationActive,
              duration: animationDuration,
              key: animationId,
              animationBegin: animationBegin,
              onAnimationStart: this.handleAnimationStart,
              onAnimationEnd: this.handleAnimationEnd,
              from: { alpha: 0 },
              to: { alpha: 1 }
            },
            function (_ref2) {
              var alpha = _ref2.alpha;
              return _this2.renderClipRect(alpha);
            }
          )
        )
      );
    }
  }, {
    key: 'renderDotItem',
    value: function renderDotItem(option, props) {
      var dotItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-area-dot' }));
      }

      return dotItem;
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var _this3 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props5 = this.props,
          dot = _props5.dot,
          points = _props5.points;

      var areaProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(dot);

      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, areaProps, customDotProps, {
          cx: entry.x,
          cy: entry.y,
          index: i,
          value: entry.value,
          payload: entry.payload
        });

        return _this3.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-area-dots' },
        dots
      );
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      var labelItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        labelItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        labelItem = option(props);
      } else {
        labelItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          _extends({
            key: props.key
          }, props, {
            className: 'recharts-area-label'
          }),
          __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value) ? value[1] : value
        );
      }

      return labelItem;
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels() {
      var _this4 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props6 = this.props,
          points = _props6.points,
          label = _props6.label;

      var areaProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(label);

      var labels = points.map(function (entry, i) {
        var labelProps = _extends({
          textAnchor: 'middle'
        }, entry, areaProps, customLabelProps, {
          index: i,
          key: 'label-' + i,
          value: entry.value,
          payload: entry.payload
        });

        return _this4.renderLabelItem(label, labelProps, entry.value);
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-area-labels' },
        labels
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          dot = _props7.dot,
          label = _props7.label,
          points = _props7.points,
          className = _props7.className,
          top = _props7.top,
          left = _props7.left,
          xAxis = _props7.xAxis,
          yAxis = _props7.yAxis,
          width = _props7.width,
          height = _props7.height;


      if (!points || !points.length) {
        return null;
      }

      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-area', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + this.id },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        !hasSinglePoint ? this.renderClipPath() : null,
        !hasSinglePoint ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            { clipPath: 'url(#animationClipPath-' + this.id + ')' },
            this.renderCurve()
          )
        ) : null,
        (dot || hasSinglePoint) && this.renderDots(),
        label && this.renderLabels()
      );
    }
  }]);

  return Area;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Area', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  legendType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  connectNulls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  activeDot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  // dot configuration
  dot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),

  // have curve configuration
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
  isRange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  label: false,
  activeDot: true,

  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Area);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Rectangle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__ = __webpack_require__(25);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of bar
 */













var Bar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Bar, _Component);

  function Bar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["c" /* uniqueId */])('recharts-bar-'), _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Bar, [{
    key: 'renderRectangle',
    value: function renderRectangle(option, props) {
      var rectangle = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        rectangle = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        rectangle = option(props);
      } else {
        rectangle = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Rectangle__["a" /* default */], props);
      }

      return rectangle;
    }
  }, {
    key: 'renderRectangles',
    value: function renderRectangles() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          shape = _props.shape,
          layout = _props.layout,
          isAnimationActive = _props.isAnimationActive,
          animationBegin = _props.animationBegin,
          animationDuration = _props.animationDuration,
          animationEasing = _props.animationEasing,
          animationId = _props.animationId;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var getStyle = function getStyle(isBegin) {
        return {
          transform: 'scale' + (layout === 'vertical' ? 'X' : 'Y') + '(' + (isBegin ? 0 : 1) + ')'
        };
      };

      return data.map(function (entry, index) {
        var x = entry.x,
            y = entry.y,
            width = entry.width,
            height = entry.height;

        var props = _extends({}, baseProps, entry, { index: index });

        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(entry.value) || !isAnimationActive) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({
              className: 'recharts-bar-rectangle'
            }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, index), {
              key: 'rectangle-' + index
            }),
            _this2.renderRectangle(shape, props)
          );
        }

        var transformOrigin = '';

        if (layout === 'vertical') {
          transformOrigin = x + 'px ' + (y + height / 2) + 'px';
        } else {
          transformOrigin = x + width / 2 + 'px ' + (y + height) + 'px';
        }

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_smooth___default.a,
          {
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing,
            from: getStyle(true),
            to: getStyle(false),
            key: 'rectangle-' + index + '-' + animationId,
            onAnimationEnd: _this2.handleAnimationEnd,
            onAnimationStart: _this2.handleAnimationStart
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({
              className: 'recharts-bar-rectangle',
              style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["translateStyle"])({ transformOrigin: transformOrigin })
            }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, index), {
              key: 'rectangle-' + index
            }),
            _this2.renderRectangle(shape, props)
          )
        );
      });
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      var labelItem = null;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        labelItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        labelItem = option(props);
      } else {
        labelItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          _extends({}, props, {
            key: props.key,
            className: 'recharts-bar-label'
          }),
          __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value) ? value[1] : value
        );
      }

      return labelItem;
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels() {
      var _this3 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props2 = this.props,
          data = _props2.data,
          label = _props2.label,
          layout = _props2.layout;

      var barProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(label);

      var labels = data.map(function (entry, i) {
        var textAnchor = 'middle';
        var dominantBaseline = 'central';
        var x = 0;
        var y = 0;

        if (layout === 'vertical') {
          textAnchor = entry.width < 0 ? 'end' : 'start';
          x = entry.x + entry.width + (entry.width < 0 ? -1 : 1) * 5;
          y = entry.y + entry.height / 2;
        } else {
          dominantBaseline = entry.height < 0 ? 'hanging' : 'inherit';
          x = entry.x + entry.width / 2;
          y = entry.y - (entry.height < 0 ? -1 : 1) * 5;
        }

        var labelProps = _extends({
          dominantBaseline: dominantBaseline,
          textAnchor: textAnchor
        }, barProps, entry, customLabelProps, {
          x: x,
          y: y,
          index: i,
          key: 'label-' + i,
          payload: entry.payload
        });

        var labelValue = entry.value;
        if (label === true && entry.value && labelProps.label) {
          labelValue = labelProps.label;
        }
        return _this3.renderLabelItem(label, labelProps, labelValue);
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-bar-labels' },
        labels
      );
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props3 = this.props,
          data = _props3.data,
          xAxis = _props3.xAxis,
          yAxis = _props3.yAxis,
          layout = _props3.layout,
          children = _props3.children;

      var errorBarItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItem) {
        return null;
      }

      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["h" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(errorBarItem, {
        data: data,
        xAxis: xAxis,
        yAxis: yAxis,
        layout: layout,
        offset: offset,
        dataPointFormatter: dataPointFormatter
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          data = _props4.data,
          className = _props4.className,
          label = _props4.label,
          xAxis = _props4.xAxis,
          yAxis = _props4.yAxis,
          left = _props4.left,
          top = _props4.top,
          width = _props4.width,
          height = _props4.height;


      if (!data || !data.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-bar', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + this.id },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          {
            className: 'recharts-bar-rectangles',
            clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
          },
          this.renderRectangles()
        ),
        label && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          { className: 'recharts-bar-rectangle-labels' },
          this.renderLabels()
        ),
        this.renderErrorBar()
      );
    }
  }]);

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['vertical', 'horizontal']),
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  yAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  barSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  minPointSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,

  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]),
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Bar);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DOMUtils__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(32);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cartesian Axis
 */










var CartesianAxis = (_temp = _class = function (_Component) {
  _inherits(CartesianAxis, _Component);

  function CartesianAxis() {
    _classCallCheck(this, CartesianAxis);

    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
  }

  _createClass(CartesianAxis, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref, state) {
      var viewBox = _ref.viewBox,
          restProps = _objectWithoutProperties(_ref, ['viewBox']);

      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _props = this.props,
          viewBoxOld = _props.viewBox,
          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["b" /* shallowEqual */])(viewBox, viewBoxOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["b" /* shallowEqual */])(restProps, restPropsOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["b" /* shallowEqual */])(state, this.state);
    }

    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */

  }, {
    key: 'getTickLineCoord',
    value: function getTickLineCoord(data) {
      var _props2 = this.props,
          x = _props2.x,
          y = _props2.y,
          width = _props2.width,
          height = _props2.height,
          orientation = _props2.orientation,
          tickSize = _props2.tickSize,
          mirror = _props2.mirror;

      var x1 = void 0,
          x2 = void 0,
          y1 = void 0,
          y2 = void 0,
          tx = void 0,
          ty = void 0;

      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* isNumber */])(data.tickCoord) ? data.tickCoord : data.coordinate;

      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + !mirror * height;
          y1 = ty = y2 - sign * finalTickSize;
          tx = tickCoord;
          break;
        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + !mirror * width;
          x1 = tx = x2 - sign * finalTickSize;
          ty = tickCoord;
          break;
        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + mirror * width;
          x1 = tx = x2 + sign * finalTickSize;
          ty = tickCoord;
          break;
        default:
          x1 = x2 = data.coordinate;
          y2 = y + mirror * height;
          y1 = ty = y2 + sign * finalTickSize;
          tx = tickCoord;
          break;
      }

      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
    }
  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor() {
      var _props3 = this.props,
          orientation = _props3.orientation,
          mirror = _props3.mirror;

      var textAnchor = void 0;

      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;
        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: 'getTickVerticalAnchor',
    value: function getTickVerticalAnchor() {
      var _props4 = this.props,
          orientation = _props4.orientation,
          mirror = _props4.mirror;

      var verticalAnchor = 'end';

      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;
        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;
        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }

      return verticalAnchor;
    }
  }, {
    key: 'getLabelProps',
    value: function getLabelProps() {
      var _props5 = this.props,
          x = _props5.x,
          y = _props5.y,
          width = _props5.width,
          height = _props5.height,
          orientation = _props5.orientation;


      switch (orientation) {
        case 'left':
          return { x: x + width, y: y - 6, textAnchor: 'middle' };
        case 'right':
          return { x: x, y: y - 6, textAnchor: 'middle' };
        case 'top':
          return { x: x + width + 6, y: y + height + 6, textAnchor: 'start' };
        default:
          return { x: x + width + 6, y: y + 6, textAnchor: 'start' };
      }
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props6 = this.props,
          x = _props6.x,
          y = _props6.y,
          width = _props6.width,
          height = _props6.height,
          orientation = _props6.orientation,
          axisLine = _props6.axisLine,
          mirror = _props6.mirror;

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(axisLine));

      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        props = _extends({}, props, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        props = _extends({}, props, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-cartesian-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }

    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */

  }, {
    key: 'renderTicks',
    value: function renderTicks(ticks) {
      var _this2 = this;

      var _props7 = this.props,
          tickLine = _props7.tickLine,
          stroke = _props7.stroke,
          tick = _props7.tick,
          tickFormatter = _props7.tickFormatter;

      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(tick);
      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(tickLine));
      var items = finalTicks.map(function (entry, i) {
        var _getTickLineCoord = _this2.getTickLineCoord(entry),
            lineCoord = _getTickLineCoord.line,
            tickCoord = _getTickLineCoord.tick;

        var tickProps = _extends({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, tickCoord, {
          index: i, payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-cartesian-axis-tick',
            key: 'tick-' + i
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, i)),
          tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({
            className: 'recharts-cartesian-axis-tick-line'
          }, tickLineProps, lineCoord)),
          tick && _this2.renderTickItem(tick, tickProps, __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value)
        );
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-axis-ticks' },
        items
      );
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _props8 = this.props,
          label = _props8.label,
          stroke = _props8.stroke,
          orientation = _props8.orientation,
          viewBox = _props8.viewBox;

      var presentation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(label)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(label, _extends({}, presentation, { orientation: orientation, viewBox: viewBox }));
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(label)) {
        return label(this.props);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["k" /* isNumOrStr */])(label)) {
        var props = _extends({}, presentation, {
          stroke: 'none',
          fill: stroke
        }, this.getLabelProps());

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'g',
          { className: 'recharts-cartesian-axis-label' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__component_Text__["a" /* default */],
            props,
            label
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props9 = this.props,
          axisLine = _props9.axisLine,
          width = _props9.width,
          height = _props9.height,
          ticksGenerator = _props9.ticksGenerator;

      var _props10 = this.props,
          ticks = _props10.ticks,
          noTicksProps = _objectWithoutProperties(_props10, ['ticks']);

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(ticksGenerator)) {
        ticks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }

      if (width <= 0 || height <= 0 || !ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: 'recharts-cartesian-axis' },
        axisLine && this.renderAxisLine(),
        this.renderTicks(ticks),
        this.renderLabel()
      );
    }
  }], [{
    key: 'getTicks',
    value: function getTicks(props) {
      var ticks = props.ticks,
          viewBox = props.viewBox,
          minTickGap = props.minTickGap,
          orientation = props.orientation,
          interval = props.interval,
          tickFormatter = props.tickFormatter;


      if (!ticks || !ticks.length) {
        return [];
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* isNumber */])(interval) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["h" /* isSsr */])()) {
        return CartesianAxis.getNumberIntervalTicks(ticks, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* isNumber */])(interval) ? interval : 0);
      }

      if (interval === 'preserveStartEnd') {
        return CartesianAxis.getTicksStart({
          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
        }, true);
      } else if (interval === 'preserveStart') {
        return CartesianAxis.getTicksStart({
          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
        });
      }

      return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
    }
  }, {
    key: 'getNumberIntervalTicks',
    value: function getNumberIntervalTicks(ticks, interval) {
      return ticks.filter(function (entry, i) {
        return i % (interval + 1) === 0;
      });
    }
  }, {
    key: 'getTicksStart',
    value: function getTicksStart(_ref2, preserveEnd) {
      var ticks = _ref2.ticks,
          tickFormatter = _ref2.tickFormatter,
          viewBox = _ref2.viewBox,
          orientation = _ref2.orientation,
          minTickGap = _ref2.minTickGap;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;

      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;

      var start = void 0,
          end = void 0;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(tail.value) : tail.value;
        var tailSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DOMUtils__["c" /* getStringSize */])(tailContent)[sizeKey];
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _extends({}, tail, {
          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });

        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

        if (isTailShow) {
          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
          result[len - 1] = _extends({}, tail, { isShow: true });
        }
      }

      var count = preserveEnd ? len - 1 : len;
      for (var i = 0; i < count; i++) {
        var entry = result[i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey];

        if (i === 0) {
          var gap = sign * (entry.coordinate - sign * size / 2 - start);
          result[i] = entry = _extends({}, entry, {
            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          start = entry.tickCoord + sign * (size / 2 + minTickGap);
          result[i] = _extends({}, entry, { isShow: true });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: 'getTicksEnd',
    value: function getTicksEnd(_ref3) {
      var ticks = _ref3.ticks,
          tickFormatter = _ref3.tickFormatter,
          viewBox = _ref3.viewBox,
          orientation = _ref3.orientation,
          minTickGap = _ref3.minTickGap;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;

      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;

      var start = void 0,
          end = void 0;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      for (var i = len - 1; i >= 0; i--) {
        var entry = result[i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey];

        if (i === len - 1) {
          var gap = sign * (entry.coordinate + sign * size / 2 - end);
          result[i] = entry = _extends({}, entry, {
            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          end = entry.tickCoord - sign * (size / 2 + minTickGap);
          result[i] = _extends({}, entry, { isShow: true });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }]);

  return CartesianAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right']),
  // The viewBox of svg
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  mirror: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  minTickGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  ticksGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  interval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
}), _class.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: { x: 0, y: 0, width: 0, height: 0 },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],

  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,

  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  interval: 'preserveEnd'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (CartesianAxis);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(25);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cartesian Grid
 */






var CartesianGrid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(CartesianGrid, _Component);

  function CartesianGrid() {
    _classCallCheck(this, CartesianGrid);

    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
  }

  _createClass(CartesianGrid, [{
    key: 'renderLineItem',
    value: function renderLineItem(option, props) {
      var lineItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        lineItem = option(props);
      } else {
        var x1 = props.x1,
            y1 = props.y1,
            x2 = props.x2,
            y2 = props.y2,
            key = props.key,
            fill = props.fill,
            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key', 'fill']);

        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(others), {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          fill: 'none',
          key: key
        }));
      }

      return lineItem;
    }

    /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */

  }, {
    key: 'renderHorizontal',
    value: function renderHorizontal(horizontalPoints) {
      var _this2 = this;

      var _props = this.props,
          x = _props.x,
          width = _props.width,
          horizontal = _props.horizontal;


      if (!horizontalPoints || !horizontalPoints.length) {
        return null;
      }

      var items = horizontalPoints.map(function (entry, i) {
        var props = _extends({}, _this2.props, {
          x1: x,
          y1: entry,
          x2: x + width,
          y2: entry,
          key: 'line-' + i,
          index: i
        });

        return _this2.renderLineItem(horizontal, props);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid-horizontal' },
        items
      );
    }

    /**
     * Draw vertical grid lines
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical lines
     */

  }, {
    key: 'renderVertical',
    value: function renderVertical(verticalPoints) {
      var _this3 = this;

      var _props2 = this.props,
          y = _props2.y,
          height = _props2.height,
          vertical = _props2.vertical;


      if (!verticalPoints || !verticalPoints.length) {
        return null;
      }

      var items = verticalPoints.map(function (entry, i) {
        var props = _extends({}, _this3.props, {
          x1: entry,
          y1: y,
          x2: entry,
          y2: y + height,
          key: 'line-' + i,
          index: i
        });

        return _this3.renderLineItem(vertical, props);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid-vertical' },
        items
      );
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground() {
      var fill = this.props.fill;


      if (!fill || fill === 'none') {
        return null;
      }

      var _props3 = this.props,
          fillOpacity = _props3.fillOpacity,
          x = _props3.x,
          y = _props3.y,
          width = _props3.width,
          height = _props3.height;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: 'none',
        fill: fill,
        fillOpacity: fillOpacity,
        className: 'recharts-cartesian-grid-bg'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          x = _props4.x,
          y = _props4.y,
          width = _props4.width,
          height = _props4.height,
          horizontal = _props4.horizontal,
          vertical = _props4.vertical,
          horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
          verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
          xAxis = _props4.xAxis,
          yAxis = _props4.yAxis,
          offset = _props4.offset,
          chartWidth = _props4.chartWidth,
          chartHeight = _props4.chartHeight;


      if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
        return null;
      }

      var _props5 = this.props,
          horizontalPoints = _props5.horizontalPoints,
          verticalPoints = _props5.verticalPoints;


      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(horizontalCoordinatesGenerator)) {
        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
          height: chartHeight, offset: offset });
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(verticalCoordinatesGenerator)) {
        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
          height: chartHeight, offset: offset });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid' },
        this.renderBackground(),
        horizontal && this.renderHorizontal(horizontalPoints),
        vertical && this.renderVertical(verticalPoints)
      );
    }
  }]);

  return CartesianGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  vertical: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  horizontalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  verticalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  horizontalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  verticalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
}), _class2.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],

  stroke: '#ccc',
  fill: 'none'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (CartesianGrid);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__ = __webpack_require__(25);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Line
 */














var FACTOR = 1.0000001;

var Line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Line, _Component);

  function Line() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    }, _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["c" /* uniqueId */])('recharts-line-'), _this.pathRef = function (node) {
      _this.animate = node;
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Line, [{
    key: 'componentDidMount',


    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      var isAnimationActive = this.props.isAnimationActive;


      if (!isAnimationActive) {
        return;
      }

      var totalLength = this.getTotalLength();

      this.setState({ totalLength: totalLength });
    }

    /* eslint-disable  react/no-did-update-set-state */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var animationId = this.props.animationId;


      if (animationId !== prevProps.animationId) {
        var cur = this.getTotalLength();
        var totalLength = prevState.totalLength;
        // A hack method to trigger animation

        this.setState({
          totalLength: cur === totalLength ? cur * FACTOR : cur
        });
      }
    }
  }, {
    key: 'getTotalLength',
    value: function getTotalLength() {
      var curveDom = this.animate;
      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;

      return totalLength;
    }
  }, {
    key: 'getStrokeDasharray',
    value: function getStrokeDasharray(length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });

      var count = parseInt(length / lineLength, 10);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;

      var remainLines = [];
      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }

      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];

      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
        return line + 'px';
      }).join(', ');
    }
  }, {
    key: 'repeat',
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
      var result = [];

      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
      }

      return result;
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      var labelItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        labelItem = option(props);
      } else {
        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          _extends({
            key: props.key
          }, props, {
            className: 'recharts-line-label'
          }),
          value
        );
      }

      return labelItem;
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels() {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props = this.props,
          points = _props.points,
          label = _props.label;

      var lineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(label);

      var labels = points.map(function (entry, i) {
        var labelProps = _extends({
          textAnchor: 'middle'
        }, entry, lineProps, customLabelProps, {
          index: i,
          key: 'label-' + i
        });

        return _this2.renderLabelItem(label, labelProps, entry.value);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-line-labels' },
        labels
      );
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props2 = this.props,
          points = _props2.points,
          xAxis = _props2.xAxis,
          yAxis = _props2.yAxis,
          layout = _props2.layout,
          children = _props2.children;

      var errorBarItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItem) {
        return null;
      }

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["h" /* getValueByDataKey */])(dataPoint.payload, dataKey)
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(errorBarItem, {
        data: points,
        xAxis: xAxis,
        yAxis: yAxis,
        layout: layout,
        dataPointFormatter: dataPointFormatter
      });
    }
  }, {
    key: 'renderDotItem',
    value: function renderDotItem(option, props) {
      var dotItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-line-dot' }));
      }

      return dotItem;
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var _this3 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _props3 = this.props,
          dot = _props3.dot,
          points = _props3.points;

      var lineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, lineProps, customDotProps, {
          value: entry.value,
          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
        });

        return _this3.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-line-dots', key: 'dots' },
        dots
      );
    }
  }, {
    key: 'renderCurve',
    value: function renderCurve(needClip) {
      var _this4 = this;

      var _props4 = this.props,
          points = _props4.points,
          strokeDasharray = _props4.strokeDasharray,
          isAnimationActive = _props4.isAnimationActive,
          animationBegin = _props4.animationBegin,
          animationDuration = _props4.animationDuration,
          animationEasing = _props4.animationEasing,
          onClick = _props4.onClick,
          onMouseEnter = _props4.onMouseEnter,
          onMouseLeave = _props4.onMouseLeave,
          other = _objectWithoutProperties(_props4, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'onClick', 'onMouseEnter', 'onMouseLeave']);

      var totalLength = this.state.totalLength;

      var animationProps = {
        isActive: isAnimationActive,
        begin: animationBegin,
        canBegin: totalLength > 0,
        easing: animationEasing,
        duration: animationDuration,
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart,
        shouldReAnimate: true,
        pathRef: this.pathRef
      };
      var curveProps = _extends({}, other, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
        onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, points: points
      });

      if (!isAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, curveProps, { strokeDasharray: strokeDasharray }));
      }

      if (strokeDasharray && totalLength) {
        var _ret2 = function () {
          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
            return parseFloat(num);
          });

          return {
            v: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
              _extends({}, animationProps, {
                from: { curveLen: 0 },
                to: { curveLen: totalLength }
              }),
              function (_ref2) {
                var curveLen = _ref2.curveLen;
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, curveProps, {
                  strokeDasharray: _this4.getStrokeDasharray(curveLen, totalLength, lines)
                }));
              }
            )
          };
        }();

        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
      } else if (strokeDasharray) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], _extends({}, curveProps, {
          pathRef: this.pathRef,
          strokeDasharray: strokeDasharray
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
        _extends({}, animationProps, {
          from: '0px ' + (totalLength === 0 ? 1 : totalLength) + 'px',
          to: totalLength + 'px 0px',
          attributeName: 'strokeDasharray'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Curve__["a" /* default */], curveProps)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          dot = _props5.dot,
          points = _props5.points,
          label = _props5.label,
          className = _props5.className,
          xAxis = _props5.xAxis,
          yAxis = _props5.yAxis,
          top = _props5.top,
          left = _props5.left,
          width = _props5.width,
          height = _props5.height;


      if (!points || !points.length) {
        return null;
      }

      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-line', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + this.id },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        !hasSinglePoint && this.renderCurve(needClip),
        this.renderErrorBar(),
        (hasSinglePoint || dot) && this.renderDots(),
        label && this.renderLabels()
      );
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Line', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  legendType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  connectNulls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  // whether have dot in line
  activeDot: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  dot: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),

  top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  points: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.value
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  animationId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview X Axis
 */




var XAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(XAxis, _Component);

  function XAxis() {
    _classCallCheck(this, XAxis);

    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
  }

  _createClass(XAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return XAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'XAxis', _class2.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of x-axis
  xAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The width of axis which is usually calculated internally
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis, which need to be setted by user
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: { left: 0, right: 0 },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (XAxis);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Y Axis
 */




var YAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(YAxis, _Component);

  function YAxis() {
    _classCallCheck(this, YAxis);

    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
  }

  _createClass(YAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return YAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'YAxis', _class2.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of y-axis
  yAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // The width of axis, which need to be setted by user
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis which is usually calculated in Chart
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: { top: 0, bottom: 0 },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (YAxis);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container_Surface__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Surface", function() { return __WEBPACK_IMPORTED_MODULE_1__container_Surface__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Layer", function() { return __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Legend__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Legend", function() { return __WEBPACK_IMPORTED_MODULE_3__component_Legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__ = __webpack_require__(2311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsiveContainer", function() { return __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Cell__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cell", function() { return __WEBPACK_IMPORTED_MODULE_6__component_Cell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_7__component_Text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Sector__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sector", function() { return __WEBPACK_IMPORTED_MODULE_8__shape_Sector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Curve__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Curve", function() { return __WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Polygon__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return __WEBPACK_IMPORTED_MODULE_11__shape_Polygon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Dot__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dot", function() { return __WEBPACK_IMPORTED_MODULE_12__shape_Dot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Cross__ = __webpack_require__(860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cross", function() { return __WEBPACK_IMPORTED_MODULE_13__shape_Cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Symbols__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Symbols", function() { return __WEBPACK_IMPORTED_MODULE_14__shape_Symbols__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__polar_PolarGrid__ = __webpack_require__(856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarGrid", function() { return __WEBPACK_IMPORTED_MODULE_15__polar_PolarGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__polar_PolarRadiusAxis__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarRadiusAxis", function() { return __WEBPACK_IMPORTED_MODULE_16__polar_PolarRadiusAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__polar_PolarAngleAxis__ = __webpack_require__(855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PolarAngleAxis", function() { return __WEBPACK_IMPORTED_MODULE_17__polar_PolarAngleAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__polar_Pie__ = __webpack_require__(854);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pie", function() { return __WEBPACK_IMPORTED_MODULE_18__polar_Pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__polar_Radar__ = __webpack_require__(858);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radar", function() { return __WEBPACK_IMPORTED_MODULE_19__polar_Radar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__polar_RadialBar__ = __webpack_require__(859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialBar", function() { return __WEBPACK_IMPORTED_MODULE_20__polar_RadialBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__ = __webpack_require__(848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Brush", function() { return __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__cartesian_ReferenceLine__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceLine", function() { return __WEBPACK_IMPORTED_MODULE_22__cartesian_ReferenceLine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__cartesian_ReferenceDot__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceDot", function() { return __WEBPACK_IMPORTED_MODULE_23__cartesian_ReferenceDot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cartesian_ReferenceArea__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReferenceArea", function() { return __WEBPACK_IMPORTED_MODULE_24__cartesian_ReferenceArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cartesian_CartesianAxis__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CartesianAxis", function() { return __WEBPACK_IMPORTED_MODULE_25__cartesian_CartesianAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__cartesian_CartesianGrid__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CartesianGrid", function() { return __WEBPACK_IMPORTED_MODULE_26__cartesian_CartesianGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cartesian_Line__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_27__cartesian_Line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cartesian_Area__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Area", function() { return __WEBPACK_IMPORTED_MODULE_28__cartesian_Area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cartesian_Bar__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Bar", function() { return __WEBPACK_IMPORTED_MODULE_29__cartesian_Bar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cartesian_Scatter__ = __webpack_require__(849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scatter", function() { return __WEBPACK_IMPORTED_MODULE_30__cartesian_Scatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cartesian_XAxis__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XAxis", function() { return __WEBPACK_IMPORTED_MODULE_31__cartesian_XAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cartesian_YAxis__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YAxis", function() { return __WEBPACK_IMPORTED_MODULE_32__cartesian_YAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__cartesian_ZAxis__ = __webpack_require__(850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ZAxis", function() { return __WEBPACK_IMPORTED_MODULE_33__cartesian_ZAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cartesian_ErrorBar__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBar", function() { return __WEBPACK_IMPORTED_MODULE_34__cartesian_ErrorBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__chart_LineChart__ = __webpack_require__(853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LineChart", function() { return __WEBPACK_IMPORTED_MODULE_35__chart_LineChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__chart_BarChart__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChart", function() { return __WEBPACK_IMPORTED_MODULE_36__chart_BarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__chart_PieChart__ = __webpack_require__(2303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PieChart", function() { return __WEBPACK_IMPORTED_MODULE_37__chart_PieChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__chart_Treemap__ = __webpack_require__(2308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Treemap", function() { return __WEBPACK_IMPORTED_MODULE_38__chart_Treemap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__chart_Sankey__ = __webpack_require__(2306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sankey", function() { return __WEBPACK_IMPORTED_MODULE_39__chart_Sankey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__chart_RadarChart__ = __webpack_require__(2304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadarChart", function() { return __WEBPACK_IMPORTED_MODULE_40__chart_RadarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chart_ScatterChart__ = __webpack_require__(2307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScatterChart", function() { return __WEBPACK_IMPORTED_MODULE_41__chart_ScatterChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__chart_AreaChart__ = __webpack_require__(851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AreaChart", function() { return __WEBPACK_IMPORTED_MODULE_42__chart_AreaChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__chart_RadialBarChart__ = __webpack_require__(2305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialBarChart", function() { return __WEBPACK_IMPORTED_MODULE_43__chart_RadialBarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__chart_ComposedChart__ = __webpack_require__(2302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ComposedChart", function() { return __WEBPACK_IMPORTED_MODULE_44__chart_ComposedChart__["a"]; });



























































































/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Polygon
 */






var getPolygonPoints = function getPolygonPoints(points) {
  return points.reduce(function (result, entry) {
    if (entry.x === +entry.x && entry.y === +entry.y) {
      result.push([entry.x, entry.y]);
    }

    return result;
  }, []).join(' ');
};

var Polygon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Polygon, _Component);

  function Polygon() {
    _classCallCheck(this, Polygon);

    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
  }

  _createClass(Polygon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          points = _props.points,
          className = _props.className;


      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-polygon', className);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        points: getPolygonPoints(points)
      }));
    }
  }]);

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  points: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }))
}), _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Polygon);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Sector
 */








var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Math.sign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);

  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius;

  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["c" /* RADIAN */];
  var centerAngle = angle + sign * theta;
  var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, centerRadius, centerAngle);
  // The coordinate of point which is tangent to the circle
  var circleTangency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, centerAngle);
  // The coordinate of point which is tangent to the radius line
  var lineTangency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, centerRadius * Math.cos(theta * __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["c" /* RADIAN */]), angle);

  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;

  var angle = getDeltaAngle(startAngle, endAngle);

  // When the angle of sector equals to 360, star point and end point coincide
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, startAngle);
  var outerEndPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, tempEndAngle);

  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';

  if (innerRadius > 0) {
    var innerStartPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, startAngle);
    var innerEndPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, tempEndAngle);
    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
  } else {
    path += 'L ' + cx + ',' + cy + ' Z';
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;

  var sign = Math.sign(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    return getSectorPath({
      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
    });
  }

  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0) {
      return path + 'L' + cx + ',' + cy + 'Z';
    }

    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
  } else {
    path += 'L' + cx + ',' + cy + 'Z';
  }

  return path;
};

var Sector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Sector, _Component);

  function Sector() {
    _classCallCheck(this, Sector);

    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
  }

  _createClass(Sector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          innerRadius = _props.innerRadius,
          outerRadius = _props.outerRadius,
          cornerRadius = _props.cornerRadius,
          startAngle = _props.startAngle,
          endAngle = _props.endAngle,
          className = _props.className;


      if (outerRadius < innerRadius || startAngle === endAngle) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-sector', className);
      var deltaRadius = outerRadius - innerRadius;
      var cr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["l" /* getPercentValue */])(cornerRadius, deltaRadius, 0, true);
      var path = void 0;

      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
        path = getSectorWithCorner({
          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
          cornerRadius: Math.min(cr, deltaRadius / 2),
          startAngle: startAngle, endAngle: endAngle
        });
      } else {
        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        d: path
      }));
    }
  }]);

  return Sector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Sector);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Curve
 */







var SYMBOL_FACTORIES = {
  symbolCircle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["g" /* symbolCircle */], symbolCross: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["h" /* symbolCross */], symbolDiamond: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["i" /* symbolDiamond */],
  symbolSquare: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["j" /* symbolSquare */], symbolStar: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["k" /* symbolStar */], symbolTriangle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["l" /* symbolTriangle */], symbolWye: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["m" /* symbolWye */]
};
var RADIAN = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);

  return SYMBOL_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_2_d3_shape__["g" /* symbolCircle */];
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;
    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);
    case 'square':
      return size * size;
    case 'star':
      {
        var angle = 18 * RADIAN;

        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }
    case 'triangle':
      return Math.sqrt(3) * size * size / 4;
    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Symbols, _Component);

  function Symbols() {
    _classCallCheck(this, Symbols);

    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
  }

  _createClass(Symbols, [{
    key: 'getPath',


    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _props = this.props,
          size = _props.size,
          sizeType = _props.sizeType,
          type = _props.type;

      var symbolFactory = getSymbolFactory(type);
      var symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["n" /* symbol */])().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));

      return symbol();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          cx = _props2.cx,
          cy = _props2.cy,
          size = _props2.size;


      if (cx === +cx && cy === +cy && size === +size) {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["i" /* filterEventAttributes */])(this.props), {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-symbols', className),
          transform: 'translate(' + cx + ', ' + cy + ')',
          d: this.getPath()
        }));
      }

      return null;
    }
  }]);

  return Symbols;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  sizeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['area', 'diameter'])
}), _class2.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Symbols);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warn; });
/* eslint no-console: 0 */
var isDev = "production" !== 'production';

var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        (function () {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;

          console.warn(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
        })();
      }
    }
  }
};

/***/ }),
/* 431 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(296)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setExpire = setExpire;
exports.getCacheManager = getCacheManager;

exports.default = function (cache) {
  if (!cache) {
    return null;
  }
  if (cache === true) {
    return Manager;
  } else {
    return _extends({}, Manager, cache);
  }
};

var MockNowDate = exports.MockNowDate = {
  date: undefined,
  push: function push(date) {
    this.date = date;
  },
  pop: function pop() {
    if (this.date) {
      var d = this.date;
      this.date = undefined;
      return new Date(d);
    } else {
      return new Date();
    }
  }
};

var Manager = exports.Manager = {
  expire: false,
  getData: function getData(cache) {
    if (!cache) {
      return;
    }
    var expire = cache.expire,
        data = cache.data;

    if (expire === false || expire === undefined || expire === null) {
      return data;
    }
    if (expire instanceof Date) {
      if (expire.valueOf() > MockNowDate.pop().valueOf()) {
        return data;
      }
    }
  },
  id: function id(params) {
    if (!params) {
      return "";
    }
    return Object.keys(params).reduce(function (memo, key) {
      return memo + (key + "=" + params[key] + ";");
    }, "");
  }
};

function setExpire(value, oldDate) {
  var expire = value;
  if (typeof expire === "number" || expire instanceof Number) {
    var d = MockNowDate.pop();
    d.setSeconds(d.getSeconds() + expire);
    expire = d;
  }
  if (oldDate instanceof Date && expire instanceof Date) {
    if (expire.valueOf() < oldDate.valueOf()) {
      expire = oldDate;
    }
  }
  return expire;
}

function getCacheManager(expire, cache) {
  if (expire !== undefined) {
    var ret = _extends({}, Manager, cache);
    if (ret.expire !== false) {
      ret.expire = setExpire(expire, ret.expire);
    }
    return ret;
  } else if (cache) {
    return _extends({}, Manager, cache);
  } else {
    return null;
  }
}
//# sourceMappingURL=cache.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(877);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Intent; });
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
/**
 * The four basic intents.
 */
var Intent;
(function (Intent) {
    Intent[Intent["NONE"] = -1] = "NONE";
    Intent[Intent["PRIMARY"] = 0] = "PRIMARY";
    Intent[Intent["SUCCESS"] = 1] = "SUCCESS";
    Intent[Intent["WARNING"] = 2] = "WARNING";
    Intent[Intent["DANGER"] = 3] = "DANGER";
})(Intent || (Intent = {}));


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createTetherOptions;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTargetAttachment;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPopoverAttachment;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAttachmentClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position__ = __webpack_require__(109);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */


// per https://github.com/HubSpot/tether/pull/204, Tether now exposes a `bodyElement` option that,
// when present, gets the tethered element injected into *it* instead of into the document body.
// but both approaches still cause React to freak out, because it loses its handle on the DOM
// element. thus, we pass a fake HTML bodyElement to Tether, with a no-op `appendChild` function
// (the only function the library uses from bodyElement).
var fakeHtmlElement = {
    appendChild: function () {
        /* No-op */
    },
};
/** @internal */
function createTetherOptions(element, target, position, tetherOptions) {
    if (tetherOptions === void 0) { tetherOptions = {}; }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, tetherOptions, { attachment: getPopoverAttachment(position), bodyElement: fakeHtmlElement, classPrefix: "pt-tether", element: element,
        target: target, targetAttachment: getTargetAttachment(position) });
}
/** @internal */
function getTargetAttachment(position) {
    var attachments = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP_LEFT] = "top left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP] = "top center",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP_RIGHT] = "top right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT_TOP] = "top right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT] = "middle right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT_BOTTOM] = "bottom right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM_RIGHT] = "bottom right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM] = "bottom center",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM_LEFT] = "bottom left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT_BOTTOM] = "bottom left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT] = "middle left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT_TOP] = "top left",
        _a);
    return attachments[position];
    var _a;
}
/** @internal */
function getPopoverAttachment(position) {
    var attachments = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP_LEFT] = "bottom left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP] = "bottom center",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].TOP_RIGHT] = "bottom right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT_TOP] = "top left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT] = "middle left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].RIGHT_BOTTOM] = "bottom left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM_RIGHT] = "top right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM] = "top center",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].BOTTOM_LEFT] = "top left",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT_BOTTOM] = "bottom right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT] = "middle right",
        _a[__WEBPACK_IMPORTED_MODULE_1__position__["a" /* Position */].LEFT_TOP] = "top right",
        _a);
    return attachments[position];
    var _a;
}
/** @internal */
function getAttachmentClasses(position) {
    // this essentially reimplements the Tether logic for attachment classes so the same styles
    // can be reused outside of Tether-based popovers.
    return expandAttachmentClasses(getPopoverAttachment(position), "pt-tether-element-attached").concat(expandAttachmentClasses(getTargetAttachment(position), "pt-tether-target-attached"));
}
function expandAttachmentClasses(attachments, prefix) {
    var _a = attachments.split(" "), verticalAlign = _a[0], horizontalAlign = _a[1];
    return [prefix + "-" + verticalAlign, prefix + "-" + horizontalAlign];
}


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDarkTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(91);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

function isDarkTheme(element) {
    return element.closest("." + __WEBPACK_IMPORTED_MODULE_0____["a" /* Classes */].DARK) != null;
}


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Collapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var AnimationStates;
(function (AnimationStates) {
    AnimationStates[AnimationStates["CLOSED"] = 0] = "CLOSED";
    AnimationStates[AnimationStates["OPENING"] = 1] = "OPENING";
    AnimationStates[AnimationStates["OPEN"] = 2] = "OPEN";
    AnimationStates[AnimationStates["CLOSING_START"] = 3] = "CLOSING_START";
    AnimationStates[AnimationStates["CLOSING_END"] = 4] = "CLOSING_END";
})(AnimationStates || (AnimationStates = {}));
/*
 * A collapse can be in one of 5 states:
 * CLOSED
 * When in this state, the contents of the collapse is not rendered, the collapse height is 0,
 * and the body Y is at -height (so that the bottom of the body is at Y=0).
 *
 * OPEN
 * When in this state, the collapse height is set to auto, and the body Y is set to 0 (so the element can be seen
 * as normal).
 *
 * CLOSING_START
 * When in this state, height has been changed from auto to the measured height of the body to prepare for the
 * closing animation in CLOSING_END.
 *
 * CLOSING_END
 * When in this state, the height is set to 0 and the body Y is at -height. Both of these properties are transformed,
 * and then after the animation is complete, the state changes to CLOSED.
 *
 * OPENING
 * When in this state, the body is re-rendered, height is set to the measured body height and the body Y is set to 0.
 * This is all animated, and on complete, the state changes to OPEN.
 *
 * When changing the isOpen prop, the following happens to the states:
 * isOpen = true : CLOSED -> OPENING -> OPEN
 * isOpen = false: OPEN -> CLOSING_START -> CLOSING_END -> CLOSED
 * These are all animated.
 */
var Collapse = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Collapse, _super);
    function Collapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            animationState: AnimationStates.OPEN,
            height: "0px",
        };
        // The most recent non-0 height (once a height has been measured - is 0 until then)
        _this.height = 0;
        _this.contentsRefHandler = function (el) {
            _this.contents = el;
            if (el != null) {
                _this.height = _this.contents.clientHeight;
                _this.setState({
                    animationState: _this.props.isOpen ? AnimationStates.OPEN : AnimationStates.CLOSED,
                    height: _this.height + "px",
                });
            }
        };
        return _this;
    }
    Collapse.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.contents != null && this.contents.clientHeight !== 0) {
            this.height = this.contents.clientHeight;
        }
        if (this.props.isOpen !== nextProps.isOpen) {
            this.clearTimeouts();
            if (this.state.animationState !== AnimationStates.CLOSED && !nextProps.isOpen) {
                this.setState({
                    animationState: AnimationStates.CLOSING_START,
                    height: this.height + "px",
                });
            }
            else if (this.state.animationState !== AnimationStates.OPEN && nextProps.isOpen) {
                this.setState({
                    animationState: AnimationStates.OPENING,
                    height: this.height + "px",
                });
                this.setTimeout(function () { return _this.onDelayedStateChange(); }, this.props.transitionDuration);
            }
        }
    };
    Collapse.prototype.render = function () {
        var isContentVisible = this.state.animationState !== AnimationStates.CLOSED;
        var shouldRenderChildren = isContentVisible || this.props.keepChildrenMounted;
        var displayWithTransform = isContentVisible && this.state.animationState !== AnimationStates.CLOSING_END;
        var isAutoHeight = this.state.height === "auto";
        var containerStyle = {
            height: isContentVisible ? this.state.height : undefined,
            overflowY: (isAutoHeight ? "visible" : undefined),
            transition: isAutoHeight ? "none" : undefined,
        };
        var contentsStyle = {
            transform: displayWithTransform ? "translateY(0)" : "translateY(-" + this.height + "px)",
            transition: isAutoHeight ? "none" : undefined,
        };
        // HACKHACK: type cast because there's no single overload that supports all
        // three ReactTypes (string | ComponentClass | StatelessComponent)
        return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](this.props.component, {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["COLLAPSE"], this.props.className),
            style: containerStyle,
        }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: "pt-collapse-body", ref: this.contentsRefHandler, style: contentsStyle, "aria-hidden": !isContentVisible && this.props.keepChildrenMounted }, shouldRenderChildren ? this.props.children : null));
    };
    Collapse.prototype.componentDidMount = function () {
        this.forceUpdate();
        if (this.props.isOpen) {
            this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
        }
        else {
            this.setState({ animationState: AnimationStates.CLOSED });
        }
    };
    Collapse.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.animationState === AnimationStates.CLOSING_START) {
            this.setTimeout(function () {
                return _this.setState({
                    animationState: AnimationStates.CLOSING_END,
                    height: "0px",
                });
            });
            this.setTimeout(function () { return _this.onDelayedStateChange(); }, this.props.transitionDuration);
        }
    };
    Collapse.prototype.onDelayedStateChange = function () {
        switch (this.state.animationState) {
            case AnimationStates.OPENING:
                this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
                break;
            case AnimationStates.CLOSING_END:
                this.setState({ animationState: AnimationStates.CLOSED });
                break;
            default:
                break;
        }
    };
    Collapse.displayName = "Blueprint.Collapse";
    Collapse.defaultProps = {
        component: "div",
        isOpen: false,
        keepChildrenMounted: false,
        transitionDuration: 200,
    };
    return Collapse;
}(__WEBPACK_IMPORTED_MODULE_3__common_abstractComponent__["a" /* AbstractComponent */]));



/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["show"] = show;
/* harmony export (immutable) */ __webpack_exports__["hide"] = hide;
/* harmony export (immutable) */ __webpack_exports__["isOpen"] = isOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__popover_popover__ = __webpack_require__(165);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var TETHER_OPTIONS = {
    constraints: [{ attachment: "together", pin: true, to: "window" }],
};
var TRANSITION_DURATION = 100;
/* istanbul ignore next */
var ContextMenu = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.cancelContextMenu = function (e) { return e.preventDefault(); };
        _this.handleBackdropContextMenu = function (e) {
            // React function to remove from the event pool, useful when using a event within a callback
            e.persist();
            e.preventDefault();
            // wait for backdrop to disappear so we can find the "real" element at event coordinates.
            // timeout duration is equivalent to transition duration so we know it's animated out.
            _this.setTimeout(function () {
                // retrigger context menu event at the element beneath the backdrop.
                // if it has a `contextmenu` event handler then it'll be invoked.
                // if it doesn't, no native menu will show (at least on OSX) :(
                var newTarget = document.elementFromPoint(e.clientX, e.clientY);
                newTarget.dispatchEvent(new MouseEvent("contextmenu", e));
            }, TRANSITION_DURATION);
        };
        _this.handlePopoverInteraction = function (nextOpenState) {
            if (!nextOpenState) {
                // delay the actual hiding till the event queue clears
                // to avoid flicker of opening twice
                requestAnimationFrame(function () { return _this.hide(); });
            }
        };
        return _this;
    }
    ContextMenu.prototype.render = function () {
        // prevent right-clicking in a context menu
        var content = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onContextMenu: this.cancelContextMenu }, this.state.menu);
        var popoverClassName = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["MINIMAL"], (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_5__common_classes__["DARK"]] = this.state.isDarkTheme, _a));
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__popover_popover__["b" /* Popover */], { backdropProps: { onContextMenu: this.handleBackdropContextMenu }, content: content, enforceFocus: false, isModal: true, isOpen: this.state.isOpen, onInteraction: this.handlePopoverInteraction, position: __WEBPACK_IMPORTED_MODULE_6__common_position__["a" /* Position */].RIGHT_TOP, popoverClassName: popoverClassName, useSmartArrowPositioning: false, tetherOptions: TETHER_OPTIONS, transitionDuration: TRANSITION_DURATION },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["CONTEXT_MENU_POPOVER_TARGET"], style: this.state.offset })));
        var _a;
    };
    ContextMenu.prototype.show = function (menu, offset, onClose, isDarkTheme) {
        this.setState({ isOpen: true, menu: menu, offset: offset, onClose: onClose, isDarkTheme: isDarkTheme });
    };
    ContextMenu.prototype.hide = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(this.state.onClose);
        this.setState({ isOpen: false, onClose: undefined });
    };
    return ContextMenu;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));
var contextMenu;
/**
 * Show the given menu element at the given offset from the top-left corner of the viewport.
 * The menu will appear below-right of this point and will flip to below-left if there is not enough
 * room onscreen. The optional callback will be invoked when this menu closes.
 */
function show(menu, offset, onClose, isDarkTheme) {
    if (contextMenu == null) {
        var contextMenuElement = document.createElement("div");
        contextMenuElement.classList.add(__WEBPACK_IMPORTED_MODULE_5__common_classes__["CONTEXT_MENU"]);
        document.body.appendChild(contextMenuElement);
        contextMenu = __WEBPACK_IMPORTED_MODULE_3_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ContextMenu, null), contextMenuElement);
    }
    contextMenu.show(menu, offset, onClose, isDarkTheme);
}
/** Hide the open context menu. */
function hide() {
    if (contextMenu != null) {
        contextMenu.hide();
    }
}
/** Return whether a context menu is currently open. */
function isOpen() {
    return contextMenu != null && contextMenu.state.isOpen;
}


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DialogFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_icon__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__overlay_overlay__ = __webpack_require__(232);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var Dialog = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleContainerMouseDown = function (evt) {
            // quick re-implementation of canOutsideClickClose because .pt-dialog-container covers the backdrop
            var isClickOutsideDialog = evt.target.closest("." + __WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG"]) == null;
            if (isClickOutsideDialog && _this.props.canOutsideClickClose) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils__["safeInvoke"])(_this.props.onClose, evt);
            }
        };
        return _this;
    }
    Dialog.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__overlay_overlay__["a" /* Overlay */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this.props, { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["OVERLAY_SCROLL_CONTAINER"], hasBackdrop: true }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG_CONTAINER"], onMouseDown: this.handleContainerMouseDown },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG"], this.props.className), style: this.props.style },
                    this.maybeRenderHeader(),
                    this.props.children))));
    };
    Dialog.prototype.validateProps = function (props) {
        if (props.title == null) {
            if (props.iconName != null) {
                console.warn(__WEBPACK_IMPORTED_MODULE_5__common_errors__["F" /* DIALOG_WARN_NO_HEADER_ICON */]);
            }
            if (props.isCloseButtonShown != null) {
                console.warn(__WEBPACK_IMPORTED_MODULE_5__common_errors__["G" /* DIALOG_WARN_NO_HEADER_CLOSE_BUTTON */]);
            }
        }
    };
    Dialog.prototype.maybeRenderCloseButton = function () {
        // for now, show close button if prop is undefined or null
        // this gives us a behavior as if the default value were `true`
        if (this.props.isCloseButtonShown !== false) {
            var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG_CLOSE_BUTTON"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["iconClass"]("small-cross"));
            return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("button", { "aria-label": "Close", className: classes, onClick: this.props.onClose });
        }
        else {
            return undefined;
        }
    };
    Dialog.prototype.maybeRenderHeader = function () {
        var _a = this.props, iconName = _a.iconName, title = _a.title;
        if (title == null) {
            return undefined;
        }
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG_HEADER"] },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__icon_icon__["a" /* Icon */], { iconName: iconName, iconSize: 20 }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("h5", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["DIALOG_HEADER_TITLE"] }, title),
            this.maybeRenderCloseButton()));
    };
    Dialog.defaultProps = {
        canOutsideClickClose: true,
        isOpen: false,
    };
    Dialog.displayName = "Blueprint.Dialog";
    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_3__common_abstractComponent__["a" /* AbstractComponent */]));

var DialogFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Dialog);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Control; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Checkbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Radio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CheckboxFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SwitchFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RadioFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_props__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

// HACKHACK: these components should go in separate files
// tslint:disable max-classes-per-file
// we need some empty interfaces to show up in docs
// tslint:disable no-empty-interface





var INVALID_PROPS = [
    // we spread props to `<input>` but render `children` as its sibling
    "children",
    "defaultIndeterminate",
    "indeterminate",
    "labelElement",
];
/** Base Component class for all Controls */
var Control = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Control, _super);
    function Control() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // generates control markup for given input type.
    // optional inputRef in case the component needs reference for itself (don't forget to invoke the prop!).
    Control.prototype.renderControl = function (type, typeClassName, inputRef) {
        if (inputRef === void 0) { inputRef = this.props.inputRef; }
        var className = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["CONTROL"], typeClassName, (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_3__common_classes__["DISABLED"]] = this.props.disabled,
            _a[__WEBPACK_IMPORTED_MODULE_3__common_classes__["INLINE"]] = this.props.inline,
            _a), this.props.className);
        var inputProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_props__["a" /* removeNonHTMLProps */])(this.props, INVALID_PROPS, true);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("label", { className: className, style: this.props.style },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, inputProps, { ref: inputRef, type: type })),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["CONTROL_INDICATOR"] }),
            this.props.label,
            this.props.labelElement,
            this.props.children));
        var _a;
    };
    return Control;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

var Checkbox = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputRef = function (ref) {
            _this.input = ref;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["safeInvoke"])(_this.props.inputRef, ref);
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        return this.renderControl("checkbox", "pt-checkbox", this.handleInputRef);
    };
    Checkbox.prototype.componentDidMount = function () {
        if (this.props.defaultIndeterminate != null) {
            this.input.indeterminate = this.props.defaultIndeterminate;
        }
        this.updateIndeterminate();
    };
    Checkbox.prototype.componentDidUpdate = function () {
        this.updateIndeterminate();
    };
    Checkbox.prototype.updateIndeterminate = function () {
        if (this.props.indeterminate != null) {
            this.input.indeterminate = this.props.indeterminate;
        }
    };
    Checkbox.displayName = "Blueprint.Checkbox";
    return Checkbox;
}(Control));

var Switch = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Switch, _super);
    function Switch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switch.prototype.render = function () {
        return this.renderControl("checkbox", "pt-switch");
    };
    Switch.displayName = "Blueprint.Switch";
    return Switch;
}(Control));

var Radio = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function () {
        return this.renderControl("radio", "pt-radio");
    };
    Radio.displayName = "Blueprint.Radio";
    return Radio;
}(Control));

var CheckboxFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Checkbox);
var SwitchFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Switch);
var RadioFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Radio);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InputGroupFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_props__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_icon__ = __webpack_require__(127);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */







var InputGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](InputGroup, _super);
    function InputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            rightElementWidth: 30,
        };
        _this.refHandlers = {
            rightElement: function (ref) { return (_this.rightElement = ref); },
        };
        return _this;
    }
    InputGroup.prototype.render = function () {
        var _a = this.props, className = _a.className, intent = _a.intent, leftIconName = _a.leftIconName;
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["INPUT_GROUP"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["DISABLED"]] = this.props.disabled,
            _b), className);
        var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this.props.style, { paddingRight: this.state.rightElementWidth });
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icon_icon__["a" /* Icon */], { iconName: leftIconName, iconSize: "inherit" }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ type: "text" }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_props__["a" /* removeNonHTMLProps */])(this.props), { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["INPUT"], ref: this.props.inputRef, style: style })),
            this.maybeRenderRightElement()));
        var _b;
    };
    InputGroup.prototype.componentDidMount = function () {
        this.updateInputWidth();
    };
    InputGroup.prototype.componentDidUpdate = function () {
        this.updateInputWidth();
    };
    InputGroup.prototype.maybeRenderRightElement = function () {
        var rightElement = this.props.rightElement;
        if (rightElement == null) {
            return undefined;
        }
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: "pt-input-action", ref: this.refHandlers.rightElement }, rightElement));
    };
    InputGroup.prototype.updateInputWidth = function () {
        if (this.rightElement != null) {
            var clientWidth = this.rightElement.clientWidth;
            // small threshold to prevent infinite loops
            if (Math.abs(clientWidth - this.state.rightElementWidth) > 2) {
                this.setState({ rightElementWidth: clientWidth });
            }
        }
        else {
            this.setState({ rightElementWidth: 0 });
        }
    };
    InputGroup.displayName = "Blueprint.InputGroup";
    InputGroup = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], InputGroup);
    return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var InputGroupFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](InputGroup);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Hotkeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hotkey__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__hotkey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyCombo__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__keyCombo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hotkeysTarget__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__hotkeysTarget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hotkeyParser__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__hotkeyParser__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__hotkeyParser__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__hotkeyParser__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__hotkeyParser__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hotkeysDialog__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__hotkeysDialog__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__hotkeysDialog__["b"]; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */










var Hotkeys = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Hotkeys, _super);
    function Hotkeys() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkeys.prototype.render = function () {
        var hotkeys = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(this.props.children, function (child) { return child.props; });
        // sort by group label alphabetically, globals first
        hotkeys.sort(function (a, b) {
            if (a.global) {
                return b.global ? 0 : -1;
            }
            if (b.global) {
                return 1;
            }
            return a.group.localeCompare(b.group);
        });
        var lastGroup = null;
        var elems = [];
        for (var _i = 0, hotkeys_1 = hotkeys; _i < hotkeys_1.length; _i++) {
            var hotkey = hotkeys_1[_i];
            var groupLabel = hotkey.group;
            if (groupLabel !== lastGroup) {
                elems.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4", { key: "group-" + elems.length, className: "pt-hotkey-group" }, groupLabel));
                lastGroup = groupLabel;
            }
            elems.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__hotkey__["a" /* Hotkey */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ key: elems.length }, hotkey)));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "pt-hotkey-column" }, elems);
    };
    Hotkeys.prototype.validateProps = function (props) {
        __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(props.children, function (child) {
            if (!__WEBPACK_IMPORTED_MODULE_4__hotkey__["a" /* Hotkey */].isInstance(child)) {
                throw new Error(__WEBPACK_IMPORTED_MODULE_3__common_errors__["w" /* HOTKEYS_HOTKEY_CHILDREN */]);
            }
        });
    };
    Hotkeys.defaultProps = {
        tabIndex: 0,
    };
    return Hotkeys;
}(__WEBPACK_IMPORTED_MODULE_2__common__["f" /* AbstractComponent */]));



/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isHotkeysDialogShowing;
/* harmony export (immutable) */ __webpack_exports__["b"] = setHotkeysDialogProps;
/* harmony export (immutable) */ __webpack_exports__["e"] = showHotkeysDialog;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideHotkeysDialog;
/* harmony export (immutable) */ __webpack_exports__["d"] = hideHotkeysDialogAfterDelay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hotkey__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hotkeys__ = __webpack_require__(449);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








/**
 * The delay before showing or hiding the dialog. Should be long enough to
 * allow all registered hotkey listeners to execute first.
 */
var DELAY_IN_MS = 10;
var HotkeysDialog = (function () {
    function HotkeysDialog() {
        var _this = this;
        this.componentProps = {
            globalHotkeysGroup: "Global hotkeys",
        };
        this.hotkeysQueue = [];
        this.isDialogShowing = false;
        this.show = function () {
            _this.isDialogShowing = true;
            _this.render();
        };
        this.hide = function () {
            _this.isDialogShowing = false;
            _this.render();
        };
    }
    HotkeysDialog.prototype.render = function () {
        if (this.container == null) {
            this.container = this.getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_3_react_dom__["render"](this.renderComponent(), this.container);
    };
    HotkeysDialog.prototype.unmount = function () {
        if (this.container != null) {
            __WEBPACK_IMPORTED_MODULE_3_react_dom__["unmountComponentAtNode"](this.container);
            this.container.remove();
            delete this.container;
        }
    };
    /**
     * Because hotkeys can be registered globally and locally and because
     * event ordering cannot be guaranteed, we use this debouncing method to
     * allow all hotkey listeners to fire and add their hotkeys to the dialog.
     *
     * 10msec after the last listener adds their hotkeys, we render the dialog
     * and clear the queue.
     */
    HotkeysDialog.prototype.enqueueHotkeysForDisplay = function (hotkeys) {
        this.hotkeysQueue.push(hotkeys);
        // reset timeout for debounce
        window.clearTimeout(this.showTimeoutToken);
        this.showTimeoutToken = window.setTimeout(this.show, DELAY_IN_MS);
    };
    HotkeysDialog.prototype.hideAfterDelay = function () {
        window.clearTimeout(this.hideTimeoutToken);
        this.hideTimeoutToken = window.setTimeout(this.hide, DELAY_IN_MS);
    };
    HotkeysDialog.prototype.isShowing = function () {
        return this.isDialogShowing;
    };
    HotkeysDialog.prototype.getContainer = function () {
        if (this.container == null) {
            this.container = document.createElement("div");
            this.container.classList.add(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].PORTAL);
            document.body.appendChild(this.container);
        }
        return this.container;
    };
    HotkeysDialog.prototype.renderComponent = function () {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components__["r" /* Dialog */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this.componentProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(this.componentProps.className, "pt-hotkey-dialog"), isOpen: this.isDialogShowing, onClose: this.hide }),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].DIALOG_BODY }, this.renderHotkeys())));
    };
    HotkeysDialog.prototype.renderHotkeys = function () {
        var _this = this;
        var hotkeys = this.emptyHotkeyQueue();
        var elements = hotkeys.map(function (hotkey, index) {
            var group = hotkey.global === true && hotkey.group == null ? _this.componentProps.globalHotkeysGroup : hotkey.group;
            return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__hotkey__["a" /* Hotkey */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ key: index }, hotkey, { group: group }));
        });
        return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__hotkeys__["j" /* Hotkeys */], null, elements);
    };
    HotkeysDialog.prototype.emptyHotkeyQueue = function () {
        // flatten then empty the hotkeys queue
        var hotkeys = this.hotkeysQueue.reduce(function (arr, queued) { return arr.concat(queued); }, []);
        this.hotkeysQueue.length = 0;
        return hotkeys;
    };
    return HotkeysDialog;
}());
// singleton instance
var HOTKEYS_DIALOG = new HotkeysDialog();
function isHotkeysDialogShowing() {
    return HOTKEYS_DIALOG.isShowing();
}
function setHotkeysDialogProps(props) {
    for (var key in props) {
        if (props.hasOwnProperty(key)) {
            HOTKEYS_DIALOG.componentProps[key] = props[key];
        }
    }
}
function showHotkeysDialog(hotkeys) {
    HOTKEYS_DIALOG.enqueueHotkeysForDisplay(hotkeys);
}
function hideHotkeysDialog() {
    HOTKEYS_DIALOG.hide();
}
/**
 * Use this function instead of `hideHotkeysDialog` if you need to ensure that all hotkey listeners
 * have time to execute with the dialog in a consistent open state. This can avoid flickering the
 * dialog between open and closed states as successive listeners fire.
 */
function hideHotkeysDialogAfterDelay() {
    HOTKEYS_DIALOG.hideAfterDelay();
}


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyCombo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hotkeyParser__ = __webpack_require__(300);
/**
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



var KeyIcons = {
    alt: "pt-icon-key-option",
    cmd: "pt-icon-key-command",
    ctrl: "pt-icon-key-control",
    delete: "pt-icon-key-delete",
    down: "pt-icon-arrow-down",
    enter: "pt-icon-key-enter",
    left: "pt-icon-arrow-left",
    meta: "pt-icon-key-command",
    right: "pt-icon-arrow-right",
    shift: "pt-icon-key-shift",
    up: "pt-icon-arrow-up",
};
var KeyCombo = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](KeyCombo, _super);
    function KeyCombo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyCombo.prototype.render = function () {
        var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hotkeyParser__["e" /* normalizeKeyCombo */])(this.props.combo);
        var components = [];
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var icon = KeyIcons[key];
            if (icon != null) {
                components.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("kbd", { className: "pt-key pt-modifier-key", key: "key-" + i },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "pt-icon-standard " + icon }),
                    key));
            }
            else {
                if (key.length === 1) {
                    key = key.toUpperCase();
                }
                components.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("kbd", { className: "pt-key", key: "key-" + i }, key));
            }
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "pt-key-combo" }, components);
    };
    return KeyCombo;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_menu_contextMenu__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_alert__ = __webpack_require__(885);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__alert_alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs_breadcrumb__ = __webpack_require__(886);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs_breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_buttons__ = __webpack_require__(230);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__button_buttons__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__button_buttons__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__button_buttons__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__button_buttons__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_buttonGroup__ = __webpack_require__(888);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__button_buttonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__callout_callout__ = __webpack_require__(889);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__callout_callout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_card__ = __webpack_require__(890);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__card_card__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__card_card__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__collapse_collapse__ = __webpack_require__(444);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__collapse_collapse__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__collapse_collapse__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__collapsible_list_collapsibleList__ = __webpack_require__(891);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__collapsible_list_collapsibleList__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__collapsible_list_collapsibleList__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__collapsible_list_collapsibleList__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_menu_contextMenuTarget__ = __webpack_require__(892);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__context_menu_contextMenuTarget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialog_dialog__ = __webpack_require__(446);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_10__dialog_dialog__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_10__dialog_dialog__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editable_text_editableText__ = __webpack_require__(893);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_11__editable_text_editableText__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_11__editable_text_editableText__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_controlGroup__ = __webpack_require__(894);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_12__forms_controlGroup__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_12__forms_controlGroup__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_controls__ = __webpack_require__(447);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_13__forms_controls__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forms_fileUpload__ = __webpack_require__(895);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_14__forms_fileUpload__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_14__forms_fileUpload__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_formGroup__ = __webpack_require__(896);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_15__forms_formGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__forms_inputGroup__ = __webpack_require__(448);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_16__forms_inputGroup__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_16__forms_inputGroup__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__forms_label__ = __webpack_require__(897);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_17__forms_label__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_17__forms_label__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__forms_numericInput__ = __webpack_require__(898);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_18__forms_numericInput__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_18__forms_numericInput__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__forms_radioGroup__ = __webpack_require__(899);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_19__forms_radioGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__forms_textArea__ = __webpack_require__(900);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_20__forms_textArea__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_20__forms_textArea__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__ = __webpack_require__(449);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_21__hotkeys_hotkeys__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__icon_icon__ = __webpack_require__(127);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_22__icon_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__menu_menu__ = __webpack_require__(301);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_23__menu_menu__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_23__menu_menu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__menu_menuDivider__ = __webpack_require__(903);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_24__menu_menuDivider__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_24__menu_menuDivider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__menu_menuItem__ = __webpack_require__(453);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_25__menu_menuItem__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_25__menu_menuItem__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_25__menu_menuItem__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__navbar_navbar__ = __webpack_require__(904);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_26__navbar_navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__navbar_navbarDivider__ = __webpack_require__(454);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_27__navbar_navbarDivider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__navbar_navbarGroup__ = __webpack_require__(455);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_28__navbar_navbarGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__navbar_navbarHeading__ = __webpack_require__(456);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_29__navbar_navbarHeading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__non_ideal_state_nonIdealState__ = __webpack_require__(905);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_30__non_ideal_state_nonIdealState__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_30__non_ideal_state_nonIdealState__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__overlay_overlay__ = __webpack_require__(232);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_31__overlay_overlay__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_31__overlay_overlay__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__text_text__ = __webpack_require__(916);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_32__text_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__popover_popover__ = __webpack_require__(165);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_33__popover_popover__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_33__popover_popover__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_33__popover_popover__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__popover_svgPopover__ = __webpack_require__(907);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_34__popover_svgPopover__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_34__popover_svgPopover__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__portal_portal__ = __webpack_require__(457);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_35__portal_portal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__progress_progressBar__ = __webpack_require__(908);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_36__progress_progressBar__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_36__progress_progressBar__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__tooltip_svgTooltip__ = __webpack_require__(918);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_37__tooltip_svgTooltip__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_37__tooltip_svgTooltip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__slider_rangeSlider__ = __webpack_require__(909);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_38__slider_rangeSlider__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_38__slider_rangeSlider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__slider_slider__ = __webpack_require__(910);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_39__slider_slider__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_39__slider_slider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__spinner_spinner__ = __webpack_require__(302);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_40__spinner_spinner__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_40__spinner_spinner__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__spinner_svgSpinner__ = __webpack_require__(911);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_41__spinner_svgSpinner__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_41__spinner_svgSpinner__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tabs_tab__ = __webpack_require__(460);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_42__tabs_tab__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_42__tabs_tab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__tabs_tabs__ = __webpack_require__(912);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_43__tabs_tabs__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_43__tabs_tabs__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tabs_tabList__ = __webpack_require__(461);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_44__tabs_tabList__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_44__tabs_tabList__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__tabs_tabPanel__ = __webpack_require__(462);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_45__tabs_tabPanel__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_45__tabs_tabPanel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__tabs2_tab2__ = __webpack_require__(463);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_46__tabs2_tab2__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_46__tabs2_tab2__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__tabs2_tabs2__ = __webpack_require__(914);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_47__tabs2_tabs2__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_47__tabs2_tabs2__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_47__tabs2_tabs2__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__tag_tag__ = __webpack_require__(915);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_48__tag_tag__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_48__tag_tag__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__toast_toast__ = __webpack_require__(464);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_49__toast_toast__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_49__toast_toast__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__toast_toaster__ = __webpack_require__(917);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_50__toast_toaster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__tooltip_tooltip__ = __webpack_require__(303);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_51__tooltip_tooltip__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_51__tooltip_tooltip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__tree_tree__ = __webpack_require__(919);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_52__tree_tree__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_52__tree_tree__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__tree_treeNode__ = __webpack_require__(465);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_53__tree_treeNode__["a"]; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
if (typeof window !== "undefined" && typeof document !== "undefined") {
    // we're in browser
    // tslint:disable-next-line:no-var-requires
    __webpack_require__(1910); // only import actual dom4 if we're in the browser (not server-compatible)
    // we'll still need dom4 types for the TypeScript to compile, these are included in package.json
}

var ContextMenu = __WEBPACK_IMPORTED_MODULE_0__context_menu_contextMenu__;























































/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
/* harmony export (immutable) */ __webpack_exports__["b"] = renderMenuItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuItemFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__popover_popover__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menu__ = __webpack_require__(301);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */










var REACT_CONTEXT_TYPES = {
    alignLeft: function (obj, key) {
        if (obj[key] != null && typeof obj[key] !== "boolean") {
            return new Error("[Blueprint] MenuItem context alignLeft must be boolean");
        }
        return undefined;
    },
};
var MenuItem = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            alignLeft: false,
        };
        _this.liRefHandler = function (r) { return (_this.liElement = r); };
        _this.measureSubmenu = function (el) {
            if (el != null) {
                var submenuRect = __WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](el).getBoundingClientRect();
                var parentWidth = _this.liElement.parentElement.getBoundingClientRect().width;
                var adjustmentWidth = submenuRect.width + parentWidth;
                // this ensures that the left and right measurements represent a submenu opened to the right
                var submenuLeft = submenuRect.left;
                var submenuRight = submenuRect.right;
                if (_this.state.alignLeft) {
                    submenuLeft += adjustmentWidth;
                    submenuRight += adjustmentWidth;
                }
                var _a = _this.props.submenuViewportMargin.left, left = _a === void 0 ? 0 : _a;
                var _b = _this.props.submenuViewportMargin.right, right = _b === void 0 ? 0 : _b;
                if (typeof document !== "undefined" &&
                    typeof document.documentElement !== "undefined" &&
                    Number(document.documentElement.clientWidth)) {
                    // we're in a browser context and the clientWidth is available,
                    // use it to set calculate 'right'
                    right = document.documentElement.clientWidth - right;
                }
                // uses context to prioritize the previous positioning
                var alignLeft = _this.context.alignLeft || false;
                if (alignLeft) {
                    if (submenuLeft - adjustmentWidth <= left) {
                        alignLeft = false;
                    }
                }
                else {
                    if (submenuRight >= right) {
                        alignLeft = true;
                    }
                }
                _this.setState({ alignLeft: alignLeft });
            }
        };
        _this.renderChildren = function () {
            var _a = _this.props, children = _a.children, submenu = _a.submenu;
            if (children != null) {
                var childProps_1 = _this.cascadeProps();
                if (Object.keys(childProps_1).length === 0) {
                    return children;
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
                        return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, childProps_1);
                    });
                }
            }
            else if (submenu != null) {
                return submenu.map(_this.cascadeProps).map(renderMenuItem);
            }
            else {
                return undefined;
            }
        };
        /**
         * Evalutes this.props and cascades prop values into new props when:
         * - submenuViewportMargin is defined, but is undefined for the supplied input.
         * - useSmartPositioning is false, but is undefined for the supplied input.
         * @param {IMenuItemProps} newProps If supplied, object will be modified, otherwise, defaults to an empty object.
         * @returns An object to be used as child props.
         */
        _this.cascadeProps = function (newProps) {
            if (newProps === void 0) { newProps = {}; }
            var _a = _this.props, submenuViewportMargin = _a.submenuViewportMargin, useSmartPositioning = _a.useSmartPositioning;
            if (submenuViewportMargin != null && newProps.submenuViewportMargin == null) {
                newProps.submenuViewportMargin = submenuViewportMargin;
            }
            if (useSmartPositioning === false && newProps.useSmartPositioning == null) {
                newProps.useSmartPositioning = useSmartPositioning;
            }
            return newProps;
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var _a = this.props, children = _a.children, disabled = _a.disabled, label = _a.label, submenu = _a.submenu, popoverProps = _a.popoverProps;
        var hasSubmenu = children != null || submenu != null;
        var liClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__((_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["MENU_SUBMENU"]] = hasSubmenu,
            _b));
        var anchorClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["MENU_ITEM"], __WEBPACK_IMPORTED_MODULE_5__common_classes__["intentClass"](this.props.intent), (_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_5__common_classes__["DISABLED"]] = disabled,
            // prevent popover from closing when clicking on submenu trigger or disabled item
            _c[__WEBPACK_IMPORTED_MODULE_5__common_classes__["POPOVER_DISMISS"]] = this.props.shouldDismissPopover && !disabled && !hasSubmenu,
            _c), __WEBPACK_IMPORTED_MODULE_5__common_classes__["iconClass"](this.props.iconName), this.props.className);
        var labelElement;
        if (label != null) {
            labelElement = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: "pt-menu-item-label" }, label);
        }
        var content = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("a", { className: anchorClasses, href: disabled ? undefined : this.props.href, onClick: disabled ? undefined : this.props.onClick, tabIndex: disabled ? undefined : 0, target: this.props.target },
            labelElement,
            this.props.text));
        if (hasSubmenu) {
            var measureSubmenu = this.props.useSmartPositioning ? this.measureSubmenu : null;
            var submenuElement = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__menu__["a" /* Menu */], { ref: measureSubmenu }, this.renderChildren());
            var popoverClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["MINIMAL"], __WEBPACK_IMPORTED_MODULE_5__common_classes__["MENU_SUBMENU"], popoverProps.popoverClassName, (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_5__common_classes__["ALIGN_LEFT"]] = this.state.alignLeft,
                _d));
            content = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__popover_popover__["b" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ isDisabled: disabled, enforceFocus: false, hoverCloseDelay: 0, inline: true, interactionKind: __WEBPACK_IMPORTED_MODULE_8__popover_popover__["a" /* PopoverInteractionKind */].HOVER, position: this.state.alignLeft ? __WEBPACK_IMPORTED_MODULE_7__common_position__["a" /* Position */].LEFT_TOP : __WEBPACK_IMPORTED_MODULE_7__common_position__["a" /* Position */].RIGHT_TOP, useSmartArrowPositioning: false }, popoverProps, { content: submenuElement, popoverClassName: popoverClasses }), content));
        }
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: liClasses, ref: this.liRefHandler }, content));
        var _b, _c, _d;
    };
    MenuItem.prototype.getChildContext = function () {
        return { alignLeft: this.state.alignLeft };
    };
    MenuItem.prototype.validateProps = function (props) {
        if (props.children != null && props.submenu != null) {
            console.warn(__WEBPACK_IMPORTED_MODULE_6__common_errors__["v" /* MENU_WARN_CHILDREN_SUBMENU_MUTEX */]);
        }
    };
    MenuItem.defaultProps = {
        disabled: false,
        popoverProps: {},
        shouldDismissPopover: true,
        submenuViewportMargin: {},
        text: "",
        useSmartPositioning: true,
    };
    MenuItem.displayName = "Blueprint.MenuItem";
    MenuItem.contextTypes = REACT_CONTEXT_TYPES;
    MenuItem.childContextTypes = REACT_CONTEXT_TYPES;
    return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));

function renderMenuItem(props, key) {
    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](MenuItem, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ key: key }, props));
}
var MenuItemFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](MenuItem);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarDivider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var NavbarDivider = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NavbarDivider, _super);
    function NavbarDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarDivider.prototype.render = function () {
        var _a = this.props, className = _a.className, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className"]);
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NAVBAR_DIVIDER"], className) }, htmlProps));
    };
    NavbarDivider.displayName = "Blueprint.NavbarDivider";
    NavbarDivider = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], NavbarDivider);
    return NavbarDivider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var NavbarGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NavbarGroup, _super);
    function NavbarGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarGroup.prototype.render = function () {
        var _a = this.props, align = _a.align, children = _a.children, propsClassName = _a.className, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["align", "children", "className"]);
        var className = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NAVBAR_GROUP"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["ALIGN_LEFT"]] = align === "left",
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["ALIGN_RIGHT"]] = align === "right",
            _b), propsClassName);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: className }, htmlProps), children));
        var _b;
    };
    NavbarGroup.displayName = "Blueprint.NavbarGroup";
    NavbarGroup.defaultProps = {
        align: "left",
    };
    NavbarGroup = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], NavbarGroup);
    return NavbarGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var NavbarHeading = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NavbarHeading, _super);
    function NavbarHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarHeading.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["children", "className"]);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NAVBAR_HEADING"], className) }, htmlProps), children));
    };
    NavbarHeading.displayName = "Blueprint.NavbarHeading";
    NavbarHeading = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], NavbarHeading);
    return NavbarHeading;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_props__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */







var REACT_CONTEXT_TYPES = {
    blueprintPortalClassName: function (obj, key) {
        if (obj[key] != null && typeof obj[key] !== "string") {
            return new Error(__WEBPACK_IMPORTED_MODULE_4__common_errors__["k" /* PORTAL_CONTEXT_CLASS_NAME_STRING */]);
        }
        return undefined;
    },
};
/**
 * This component detaches its contents and re-attaches them to document.body.
 * Use it when you need to circumvent DOM z-stacking (for dialogs, popovers, etc.).
 * Any class names passed to this element will be propagated to the new container element on document.body.
 */
var Portal = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Portal.prototype.render = function () {
        return null;
    };
    Portal.prototype.componentDidMount = function () {
        var targetElement = document.createElement("div");
        targetElement.classList.add(__WEBPACK_IMPORTED_MODULE_3__common_classes__["PORTAL"]);
        var blueprintPortalClassName = this.context.blueprintPortalClassName;
        if (blueprintPortalClassName != null && blueprintPortalClassName !== "") {
            (_a = targetElement.classList).add.apply(_a, blueprintPortalClassName.split(" "));
        }
        document.body.appendChild(targetElement);
        this.targetElement = targetElement;
        this.componentDidUpdate();
        var _a;
    };
    Portal.prototype.componentDidUpdate = function () {
        var _this = this;
        // use special render function to preserve React context, in case children need it
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_renderSubtreeIntoContainer"](
        /* parentComponent */ this, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_props__["a" /* removeNonHTMLProps */])(this.props), { ref: this.props.containerRef }), this.props.children), this.targetElement, function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils__["safeInvoke"])(_this.props.onChildrenMount); });
    };
    Portal.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.targetElement);
        this.targetElement.remove();
    };
    Portal.displayName = "Blueprint.Portal";
    Portal.contextTypes = REACT_CONTEXT_TYPES;
    return Portal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoreSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








var CoreSlider = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CoreSlider, _super);
    function CoreSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.className = __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER"];
        _this.refHandlers = {
            track: function (el) { return (_this.trackElement = el); },
        };
        _this.maybeHandleTrackClick = function (event) {
            if (_this.canHandleTrackEvent(event)) {
                _this.handleTrackClick(event);
            }
        };
        _this.maybeHandleTrackTouch = function (event) {
            if (_this.canHandleTrackEvent(event)) {
                _this.handleTrackTouch(event);
            }
        };
        _this.canHandleTrackEvent = function (event) {
            var target = event.target;
            // ensure event does not come from inside the handle
            return !_this.props.disabled && target.closest("." + __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER_HANDLE"]) == null;
        };
        _this.state = {
            labelPrecision: _this.getLabelPrecision(props),
            tickSize: 0,
        };
        return _this;
    }
    CoreSlider.prototype.render = function () {
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(this.className, (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_5__common_classes__["DISABLED"]] = this.props.disabled,
            _a[__WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER"] + "-unlabeled"] = this.props.renderLabel === false,
            _a[__WEBPACK_IMPORTED_MODULE_5__common_classes__["VERTICAL"]] = this.props.vertical,
            _a), this.props.className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes, onMouseDown: this.maybeHandleTrackClick, onTouchStart: this.maybeHandleTrackTouch },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER"] + "-track", ref: this.refHandlers.track }),
            this.maybeRenderFill(),
            this.maybeRenderAxis(),
            this.renderHandles()));
        var _a;
    };
    CoreSlider.prototype.componentDidMount = function () {
        this.updateTickSize();
    };
    CoreSlider.prototype.componentDidUpdate = function () {
        this.updateTickSize();
    };
    CoreSlider.prototype.componentWillReceiveProps = function (props) {
        _super.prototype.componentWillReceiveProps.call(this, props);
        this.setState({ labelPrecision: this.getLabelPrecision(props) });
    };
    CoreSlider.prototype.formatLabel = function (value) {
        var renderLabel = this.props.renderLabel;
        if (renderLabel === false) {
            return undefined;
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["isFunction"])(renderLabel)) {
            return renderLabel(value);
        }
        else {
            return value.toFixed(this.state.labelPrecision);
        }
    };
    CoreSlider.prototype.validateProps = function (props) {
        if (props.stepSize <= 0) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_6__common_errors__["h" /* SLIDER_ZERO_STEP */]);
        }
        if (props.labelStepSize <= 0) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_6__common_errors__["i" /* SLIDER_ZERO_LABEL_STEP */]);
        }
    };
    CoreSlider.prototype.getTrackInitialPixel = function () {
        if (this.trackElement == null) {
            return undefined;
        }
        var trackRect = this.trackElement.getBoundingClientRect();
        // for vertical tracks, the initial (lowest-`value`) pixel is on the bottom.
        return this.props.vertical ? trackRect.top + trackRect.height : trackRect.left;
    };
    CoreSlider.prototype.maybeRenderAxis = function () {
        // explicit typedefs are required because tsc (rightly) assumes that props might be overriden with different
        // types in subclasses
        var max = this.props.max;
        var min = this.props.min;
        var labelStepSize = this.props.labelStepSize;
        if (this.props.renderLabel === false) {
            return undefined;
        }
        var stepSize = Math.round(this.state.tickSize * labelStepSize);
        var labels = [];
        // tslint:disable-next-line:one-variable-per-declaration ban-comma-operator
        for (var i = min, offset = 0; i < max || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["approxEqual"])(i, max); i += labelStepSize, offset += stepSize) {
            var style = this.props.vertical ? { bottom: offset } : { left: offset };
            labels.push(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER"] + "-label", key: i, style: style }, this.formatLabel(i)));
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER"] + "-axis" }, labels);
    };
    CoreSlider.prototype.maybeRenderFill = function () {
        if (this.props.showTrackFill && this.trackElement != null) {
            return this.renderFill();
        }
        return undefined;
    };
    CoreSlider.prototype.getLabelPrecision = function (_a) {
        var labelPrecision = _a.labelPrecision, stepSize = _a.stepSize;
        // infer default label precision from stepSize because that's how much the handle moves.
        return labelPrecision == null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["countDecimalPlaces"])(stepSize) : labelPrecision;
    };
    CoreSlider.prototype.updateTickSize = function () {
        if (this.trackElement != null) {
            var trackSize = this.props.vertical ? this.trackElement.clientHeight : this.trackElement.clientWidth;
            var tickSize = trackSize / (this.props.max - this.props.min);
            this.setState({ tickSize: tickSize });
        }
    };
    CoreSlider = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], CoreSlider);
    return CoreSlider;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));



/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








// props that require number values, for validation
var NUMBER_PROPS = ["max", "min", "stepSize", "tickSize", "value"];
var Handle = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMoving: false,
        };
        _this.refHandlers = {
            handle: function (el) { return (_this.handleElement = el); },
        };
        _this.beginHandleMovement = function (event) {
            document.addEventListener("mousemove", _this.handleHandleMovement);
            document.addEventListener("mouseup", _this.endHandleMovement);
            _this.setState({ isMoving: true });
            _this.changeValue(_this.clientToValue(_this.mouseEventClientOffset(event)));
        };
        _this.beginHandleTouchMovement = function (event) {
            document.addEventListener("touchmove", _this.handleHandleTouchMovement);
            document.addEventListener("touchend", _this.endHandleTouchMovement);
            document.addEventListener("touchcancel", _this.endHandleTouchMovement);
            _this.setState({ isMoving: true });
            _this.changeValue(_this.clientToValue(_this.touchEventClientOffset(event)));
        };
        _this.endHandleMovement = function (event) {
            _this.handleMoveEndedAt(_this.mouseEventClientOffset(event));
        };
        _this.endHandleTouchMovement = function (event) {
            _this.handleMoveEndedAt(_this.touchEventClientOffset(event));
        };
        _this.handleMoveEndedAt = function (clientPixel) {
            _this.removeDocumentEventListeners();
            _this.setState({ isMoving: false });
            // not using changeValue because we want to invoke the handler regardless of current prop value
            var onRelease = _this.props.onRelease;
            var finalValue = _this.clamp(_this.clientToValue(clientPixel));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(onRelease, finalValue);
        };
        _this.handleHandleMovement = function (event) {
            _this.handleMovedTo(_this.mouseEventClientOffset(event));
        };
        _this.handleHandleTouchMovement = function (event) {
            _this.handleMovedTo(_this.touchEventClientOffset(event));
        };
        _this.handleMovedTo = function (clientPixel) {
            if (_this.state.isMoving && !_this.props.disabled) {
                _this.changeValue(_this.clientToValue(clientPixel));
            }
        };
        _this.handleKeyDown = function (event) {
            var _a = _this.props, stepSize = _a.stepSize, value = _a.value;
            var which = event.which;
            if (which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_DOWN"] || which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_LEFT"]) {
                _this.changeValue(value - stepSize);
                // this key event has been handled! prevent browser scroll on up/down
                event.preventDefault();
            }
            else if (which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_UP"] || which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_RIGHT"]) {
                _this.changeValue(value + stepSize);
                event.preventDefault();
            }
        };
        _this.handleKeyUp = function (event) {
            if ([__WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_UP"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_DOWN"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_LEFT"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_RIGHT"]].indexOf(event.which) >= 0) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.onRelease, _this.props.value);
            }
        };
        return _this;
    }
    Handle.prototype.render = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, label = _a.label, min = _a.min, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
        var isMoving = this.state.isMoving;
        var handleMidpoint = this.getHandleMidpointAndOffset(this.handleElement, true).handleMidpoint;
        var offset = Math.round((value - min) * tickSize - handleMidpoint);
        var style = vertical ? { bottom: offset } : { left: offset };
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER_HANDLE"], (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["ACTIVE"]] = isMoving, _b), className), onKeyDown: disabled ? null : this.handleKeyDown, onKeyUp: disabled ? null : this.handleKeyUp, onMouseDown: disabled ? null : this.beginHandleMovement, onTouchStart: disabled ? null : this.beginHandleTouchMovement, ref: this.refHandlers.handle, style: style, tabIndex: 0 }, label == null ? null : __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["SLIDER_LABEL"] }, label)));
        var _b;
    };
    Handle.prototype.componentWillUnmount = function () {
        this.removeDocumentEventListeners();
    };
    /** Convert client pixel to value between min and max. */
    Handle.prototype.clientToValue = function (clientPixel) {
        var _a = this.props, stepSize = _a.stepSize, tickSize = _a.tickSize, value = _a.value, vertical = _a.vertical;
        if (this.handleElement == null) {
            return value;
        }
        // #1769: this logic doesn't work perfectly when the tick size is
        // smaller than the handle size; it may be off by a tick or two.
        var clientPixelNormalized = vertical ? window.innerHeight - clientPixel : clientPixel;
        var handleCenterPixel = this.getHandleElementCenterPixel(this.handleElement);
        var pixelDelta = clientPixelNormalized - handleCenterPixel;
        // convert pixels to range value in increments of `stepSize`
        var valueDelta = Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
        return value + valueDelta;
    };
    Handle.prototype.mouseEventClientOffset = function (event) {
        return this.props.vertical ? event.clientY : event.clientX;
    };
    Handle.prototype.touchEventClientOffset = function (event) {
        var touch = event.changedTouches[0];
        return this.props.vertical ? touch.clientY : touch.clientX;
    };
    Handle.prototype.validateProps = function (props) {
        for (var _i = 0, NUMBER_PROPS_1 = NUMBER_PROPS; _i < NUMBER_PROPS_1.length; _i++) {
            var prop = NUMBER_PROPS_1[_i];
            if (typeof props[prop] !== "number") {
                throw new Error("[Blueprint] <Handle> requires number value for " + prop + " prop");
            }
        }
    };
    /** Clamp value and invoke callback if it differs from current value */
    Handle.prototype.changeValue = function (newValue, callback) {
        if (callback === void 0) { callback = this.props.onChange; }
        newValue = this.clamp(newValue);
        if (!isNaN(newValue) && this.props.value !== newValue) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(callback, newValue);
        }
    };
    /** Clamp value between min and max props */
    Handle.prototype.clamp = function (value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["clamp"])(value, this.props.min, this.props.max);
    };
    Handle.prototype.getHandleElementCenterPixel = function (handleElement) {
        var _a = this.getHandleMidpointAndOffset(handleElement), handleMidpoint = _a.handleMidpoint, handleOffset = _a.handleOffset;
        return handleOffset + handleMidpoint;
    };
    Handle.prototype.getHandleMidpointAndOffset = function (handleElement, useOppositeDimension) {
        if (useOppositeDimension === void 0) { useOppositeDimension = false; }
        if (handleElement == null) {
            return { handleMidpoint: 0, handleOffset: 0 };
        }
        var vertical = this.props.vertical;
        // getBoundingClientRect().height includes border size; clientHeight does not.
        var handleRect = handleElement.getBoundingClientRect();
        var sizeKey = vertical
            ? useOppositeDimension ? "width" : "height"
            : useOppositeDimension ? "height" : "width";
        // "bottom" value seems to be consistently incorrect, so explicitly
        // calculate it using the window offset instead.
        var handleOffset = vertical ? window.innerHeight - (handleRect.top + handleRect[sizeKey]) : handleRect.left;
        return { handleMidpoint: handleRect[sizeKey] / 2, handleOffset: handleOffset };
    };
    Handle.prototype.removeDocumentEventListeners = function () {
        document.removeEventListener("mousemove", this.handleHandleMovement);
        document.removeEventListener("mouseup", this.endHandleMovement);
        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
        document.removeEventListener("touchend", this.endHandleTouchMovement);
        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
    };
    Handle.displayName = "Blueprint.SliderHandle";
    Handle = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Handle);
    return Handle;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));



/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Tab = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tab.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("li", { "aria-controls": this.props.panelId, "aria-disabled": this.props.isDisabled, "aria-expanded": this.props.isSelected, "aria-selected": this.props.isSelected, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB"], this.props.className), id: this.props.id, role: "tab", tabIndex: this.props.isDisabled ? null : 0 }, this.props.children));
    };
    Tab.defaultProps = {
        isDisabled: false,
        isSelected: false,
    };
    Tab.displayName = "Blueprint.Tab";
    Tab = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tab);
    return Tab;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var TabFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tab);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabListFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var TabList = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TabList, _super);
    function TabList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shouldAnimate: false,
        };
        return _this;
    }
    TabList.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["TAB_LIST"], this.props.className), role: "tablist" },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("pt-tab-indicator-wrapper", { "pt-no-animation": !this.state.shouldAnimate }), style: this.props.indicatorWrapperStyle },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-tab-indicator" })),
            this.props.children));
    };
    TabList.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.indicatorWrapperStyle == null) {
            this.setTimeout(function () { return _this.setState({ shouldAnimate: true }); });
        }
    };
    TabList.displayName = "Blueprint.TabList";
    TabList = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], TabList);
    return TabList;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));

var TabListFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](TabList);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabPanelFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var TabPanel = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TabPanel, _super);
    function TabPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPanel.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { "aria-labelledby": this.props._tabId, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB_PANEL"], this.props.className), id: this.props._id, role: "tabpanel" }, this.props.children));
    };
    TabPanel.displayName = "Blueprint.TabPanel";
    TabPanel = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], TabPanel);
    return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var TabPanelFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](TabPanel);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tab2Factory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Tab2 = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tab2, _super);
    function Tab2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see Tabs2#renderTabPanel()
    /* istanbul ignore next */
    Tab2.prototype.render = function () {
        var _a = this.props, className = _a.className, panel = _a.panel;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB_PANEL"], className), role: "tablist" }, panel));
    };
    Tab2.defaultProps = {
        disabled: false,
        id: undefined,
    };
    Tab2.displayName = "Blueprint.Tab2";
    Tab2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tab2);
    return Tab2;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var Tab2Factory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tab2);


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToastFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__button_buttons__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_icon__ = __webpack_require__(127);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var Toast = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleActionClick = function (e) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils__["safeInvoke"])(_this.props.action.onClick, e);
            _this.triggerDismiss(false);
        };
        _this.handleCloseClick = function () { return _this.triggerDismiss(false); };
        _this.startTimeout = function () {
            if (_this.props.timeout > 0) {
                _this.setTimeout(function () { return _this.triggerDismiss(true); }, _this.props.timeout);
            }
        };
        return _this;
    }
    Toast.prototype.render = function () {
        var _a = this.props, className = _a.className, iconName = _a.iconName, intent = _a.intent, message = _a.message;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["TOAST"], __WEBPACK_IMPORTED_MODULE_5__common_classes__["intentClass"](intent), className), onBlur: this.startTimeout, onFocus: this.clearTimeouts, onMouseEnter: this.clearTimeouts, onMouseLeave: this.startTimeout, tabIndex: 0 },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__icon_icon__["a" /* Icon */], { iconName: iconName }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["TOAST_MESSAGE"] }, message),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["BUTTON_GROUP"], __WEBPACK_IMPORTED_MODULE_5__common_classes__["MINIMAL"]) },
                this.maybeRenderActionButton(),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__button_buttons__["a" /* Button */], { iconName: "cross", onClick: this.handleCloseClick }))));
    };
    Toast.prototype.componentDidMount = function () {
        this.startTimeout();
    };
    Toast.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.timeout <= 0 && this.props.timeout > 0) {
            this.startTimeout();
        }
        else if (prevProps.timeout > 0 && this.props.timeout <= 0) {
            this.clearTimeouts();
        }
    };
    Toast.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
    };
    Toast.prototype.maybeRenderActionButton = function () {
        var action = this.props.action;
        if (action == null) {
            return undefined;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__button_buttons__["c" /* AnchorButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, action, { intent: undefined, onClick: this.handleActionClick }));
        }
    };
    Toast.prototype.triggerDismiss = function (didTimeoutExpire) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils__["safeInvoke"])(this.props.onDismiss, didTimeoutExpire);
        this.clearTimeouts();
    };
    Toast.defaultProps = {
        className: "",
        message: "",
        timeout: 5000,
    };
    Toast.displayName = "Blueprint.Toast";
    Toast = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Toast);
    return Toast;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));

var ToastFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Toast);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse_collapse__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_icon__ = __webpack_require__(127);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */







var TreeNode = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCaretClick = function (e) {
            e.stopPropagation();
            var _a = _this.props, isExpanded = _a.isExpanded, onCollapse = _a.onCollapse, onExpand = _a.onExpand;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["safeInvoke"])(isExpanded ? onCollapse : onExpand, _this, e);
        };
        _this.handleClick = function (e) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["safeInvoke"])(_this.props.onClick, _this, e);
        };
        _this.handleContentRef = function (element) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["safeInvoke"])(_this.props.contentRef, _this, element);
        };
        _this.handleContextMenu = function (e) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["safeInvoke"])(_this.props.onContextMenu, _this, e);
        };
        _this.handleDoubleClick = function (e) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["safeInvoke"])(_this.props.onDoubleClick, _this, e);
        };
        return _this;
    }
    TreeNode.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, hasCaret = _a.hasCaret, iconName = _a.iconName, isExpanded = _a.isExpanded, isSelected = _a.isSelected, label = _a.label;
        var showCaret = hasCaret == null ? __WEBPACK_IMPORTED_MODULE_2_react__["Children"].count(children) > 0 : hasCaret;
        var caretClass = showCaret ? __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_CARET"] : __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_CARET_NONE"];
        var caretStateClass = isExpanded ? __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_CARET_OPEN"] : __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_CARET_CLOSED"];
        var caretClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(caretClass, __WEBPACK_IMPORTED_MODULE_3__common_classes__["ICON_STANDARD"], (_b = {},
            _b[caretStateClass] = showCaret,
            _b));
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE"], (_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_SELECTED"]] = isSelected,
            _c[__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_EXPANDED"]] = isExpanded,
            _c), className);
        var contentClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_CONTENT"], "pt-tree-node-content-" + this.props.depth);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: classes },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: contentClasses, onClick: this.handleClick, onContextMenu: this.handleContextMenu, onDoubleClick: this.handleDoubleClick, ref: this.handleContentRef },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: caretClasses, onClick: showCaret ? this.handleCaretClick : null }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icon_icon__["a" /* Icon */], { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_ICON"], iconName: iconName }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_LABEL"] }, label),
                this.maybeRenderSecondaryLabel()),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__collapse_collapse__["b" /* Collapse */], { isOpen: isExpanded }, children)));
        var _b, _c;
    };
    TreeNode.prototype.maybeRenderSecondaryLabel = function () {
        if (this.props.secondaryLabel != null) {
            return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_SECONDARY_LABEL"] }, this.props.secondaryLabel);
        }
        else {
            return undefined;
        }
    };
    return TreeNode;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));



/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(83);
var settle = __webpack_require__(928);
var buildURL = __webpack_require__(931);
var parseHeaders = __webpack_require__(937);
var isURLSameOrigin = __webpack_require__(935);
var createError = __webpack_require__(469);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(930);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(933);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(927);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "footer",
        { className: "footer-container" },
        _react2.default.createElement(
          "div",
          { className: "title" },
          "Thanh tra t\u1EC9nh Qu\u1EA3ng Ng\xE3i"
        ),
        _react2.default.createElement(
          "div",
          { className: "address" },
          "\u0110\u1ECBa ch\u1EC9: S\u1ED1 99 H\xF9ng V\u01B0\u01A1ng - TP Qu\u1EA3ng Ng\xE3i - t\u1EC9nh Qu\u1EA3ng Ng\xE3i"
        )
      );
    }
  }]);

  return Footer;
}(_react2.default.Component);

exports.default = Footer;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CauHinhKHTT = function (_Component) {
  _inherits(CauHinhKHTT, _Component);

  function CauHinhKHTT(props) {
    _classCallCheck(this, CauHinhKHTT);

    var _this = _possibleConstructorReturn(this, (CauHinhKHTT.__proto__ || Object.getPrototypeOf(CauHinhKHTT)).call(this, props));

    _this.state = {
      denNgayKHTT: (0, _moment2.default)(),
      tuNgayKHTT: (0, _moment2.default)(),
      tuNgayTTDX: (0, _moment2.default)(),
      denNgayTTDX: (0, _moment2.default)(),
      choPhepChinhSuaKeHoachTuNgay: (0, _moment2.default)(),
      switch: false
    };
    return _this;
  }

  _createClass(CauHinhKHTT, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInfoCauHinh();
    }
  }, {
    key: 'getInfoCauHinh',
    value: function getInfoCauHinh() {
      var _this2 = this;

      _api.ThanhTra.actions.getCauHinhKeHoachThanhTra.request().then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this2.setState({
            switch: data.hienThiButtonThemMoi,
            tuNgayKHTT: (0, _moment2.default)(data.tuNgayKHTT, '').format('DD/MM/YYYY'),
            denNgayKHTT: (0, _moment2.default)(data.denNgayKHTT, '').format('DD/MM/YYYY'),
            tuNgayTTDX: (0, _moment2.default)(data.tuNgayCuocThanhTra, '').format('DD/MM/YYYY'),
            denNgayTTDX: (0, _moment2.default)(data.denNgayCuocThanhTra, '').format('DD/MM/YYYY'),
            choPhepChinhSuaKeHoachTuNgay: data.choPhepChinhSuaKeHoachTuNgay ? (0, _moment2.default)(data.choPhepChinhSuaKeHoachTuNgay, '').format('DD/MM/YYYY') : null
          });
        }
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'saveCauHinhThanhTra',
    value: function saveCauHinhThanhTra() {
      var _this3 = this;

      if (this.validateSubmitForm()) {
        var params = {
          hienThiButtonThemMoi: this.state.switch,
          tuNgayKHTT: (0, _moment2.default)(this.state.tuNgayKHTT, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          denNgayKHTT: (0, _moment2.default)(this.state.denNgayKHTT, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          tuNgayCuocThanhTra: (0, _moment2.default)(this.state.tuNgayTTDX, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          denNgayCuocThanhTra: (0, _moment2.default)(this.state.denNgayTTDX, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          choPhepChinhSuaKeHoachTuNgay: (0, _moment2.default)(this.state.choPhepChinhSuaKeHoachTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString()
        };
        _api.ThanhTra.actions.patchCauHinhKeHoachThanhTra.request({ id: 1 }, params).then(function (res) {
          if (!(0, _lodash.isEmpty)(res.data)) {
            (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
            _this3.goBack();
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.setState(_defineProperty({}, name, e));
    }
  }, {
    key: 'onSwitch',
    value: function onSwitch(e) {
      this.setState({
        switch: e.target.checked
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center cauhinh-khtt' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'h2',
                null,
                'C\u1EA5u h\xECnh k\u1EBF ho\u1EA1ch thanh tra'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'div',
              { className: 'container-chtt' },
              _react2.default.createElement(
                'div',
                { className: 'mb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-6' },
                  _react2.default.createElement(
                    'div',
                    { className: 'button-switch' },
                    _react2.default.createElement(
                      'label',
                      { className: 'description-chtt' },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Hi\u1EC3n th\u1ECB th\xEAm m\u1EDBi KHTT :'
                      )
                    ),
                    _react2.default.createElement(
                      'label',
                      { className: 'switch' },
                      _react2.default.createElement('input', { type: 'checkbox', checked: this.state.switch, onChange: this.onSwitch.bind(this) }),
                      _react2.default.createElement('span', { className: 'slider round' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title-chtt' },
                _react2.default.createElement(
                  'span',
                  null,
                  'K\u1EBF ho\u1EA1ch thanh tra :'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap-input-chtt' },
                _react2.default.createElement(_common.DatePicker, {
                  require: true,
                  bindValidator: this,
                  className: 'col-input col-25',
                  label: 'T\u1EEB ng\xE0y',
                  channel: 'formTaoDon',
                  name: 'tuNgayKHTT',
                  dateFormat: 'DD/MM/YYYY',
                  value: this.state.tuNgayKHTT,
                  onChange: this.handleChangeDate.bind(this, 'tuNgayKHTT'),
                  maxLength: 18
                }),
                _react2.default.createElement(
                  'span',
                  { className: 'hyphen' },
                  ' - '
                ),
                _react2.default.createElement(_common.DatePicker, {
                  require: true,
                  bindValidator: this,
                  channel: 'formTaoDon',
                  className: 'col-input col-25',
                  label: '\u0110\u1EBFn ng\xE0y',
                  name: 'denNgayKHTT',
                  dateFormat: 'DD/MM/YYYY',
                  value: this.state.denNgayKHTT,
                  onChange: this.handleChangeDate.bind(this, 'denNgayKHTT'),
                  maxLength: 18
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title-chtt' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Cu\u1ED9c thanh tra \u0111\u1ED9t xu\u1EA5t:'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap-input-chtt' },
                _react2.default.createElement(_common.DatePicker, {
                  require: true,
                  bindValidator: this,
                  className: 'col-input col-25',
                  label: 'T\u1EEB ng\xE0y',
                  channel: 'formTaoDon',
                  name: 'tuNgayTTDX',
                  dateFormat: 'DD/MM/YYYY',
                  value: this.state.tuNgayTTDX,
                  onChange: this.handleChangeDate.bind(this, 'tuNgayTTDX'),
                  maxLength: 18
                }),
                _react2.default.createElement(
                  'span',
                  { className: 'hyphen' },
                  ' - '
                ),
                _react2.default.createElement(_common.DatePicker, {
                  require: true,
                  bindValidator: this,
                  className: 'col-input col-25',
                  label: '\u0110\u1EBFn ng\xE0y',
                  channel: 'formTaoDon',
                  name: 'denNgayTTDX',
                  dateFormat: 'DD/MM/YYYY',
                  value: this.state.denNgayTTDX,
                  onChange: this.handleChangeDate.bind(this, 'denNgayTTDX'),
                  maxLength: 18
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title-chtt' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Ng\xE0y ch\u1EC9nh s\u1EEDa k\u1EBF ho\u1EA1ch thanh tra:'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap-input-chtt' },
                _react2.default.createElement(_common.DatePicker, {
                  require: true,
                  bindValidator: this,
                  className: 'col-input col-25',
                  label: 'Ng\xE0y ch\u1EC9nh s\u1EEDa',
                  channel: 'formTaoDon',
                  name: 'choPhepChinhSuaKeHoachTuNgay',
                  dateFormat: 'DD/MM/YYYY',
                  value: this.state.choPhepChinhSuaKeHoachTuNgay,
                  onChange: this.handleChangeDate.bind(this, 'choPhepChinhSuaKeHoachTuNgay'),
                  maxLength: 18
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'button-group mt10' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.goBack.bind(this), className: 'btn-action btn-close' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-save', onClick: this.saveCauHinhThanhTra.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CauHinhKHTT;
}(_react.Component);

CauHinhKHTT.defaultProps = {
  validators: {}
};

exports.default = CauHinhKHTT;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Parameter = function (_React$Component) {
  _inherits(Parameter, _React$Component);

  function Parameter(props, context) {
    _classCallCheck(this, Parameter);

    var _this = _possibleConstructorReturn(this, (Parameter.__proto__ || Object.getPrototypeOf(Parameter)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      moTa: '',
      giaTri: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      isValid: true
    };
    return _this;
  }

  _createClass(Parameter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getThamSo.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.thamSoes,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this3 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        }) }, function () {
        _this3.getListData();
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this4 = this;

      if (this.validateSubmitForm()) {
        var params = {
          ten: this.state.ten,
          moTa: this.state.moTa,
          giaTri: this.state.giaTri
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateThamSo({ id: this.state.categoryId }, params).then(function (res) {
            _this4.getListData();
            _this4.closeDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this4.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this4.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postThamSo('', params).then(function (res) {
            _this4.getListData();
            _this4.closeDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this4.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this4.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          number: page.selected
        }) }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this6 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteThamSo({ id: categoryId }).then(function (res) {
          _this6.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this6.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this6.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      //
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        addType: 0,
        ten: '',
        moTa: '',
        giaTri: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.openDialog();
      this.setState({
        addType: 2,
        ten: item.ten,
        moTa: item.moTa,
        giaTri: item.giaTri,
        categoryId: item.thamSoId,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Tham S\u1ED1'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('THAMSO_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.parameter,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemParameter, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa tham số' : 'Thêm mới tham số',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 255, onChange: this.onChange.bind(this, 'ten') }),
              _react2.default.createElement(_common.Input, { className: '', label: 'Gi\xE1 tr\u1ECB', value: this.state.giaTri, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 255, onChange: this.onChange.bind(this, 'giaTri') }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, maxLength: 255, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Parameter;
}(_react2.default.Component);

Parameter.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(Parameter);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _layout = __webpack_require__(9);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Process = function (_React$Component) {
  _inherits(Process, _React$Component);

  function Process(props, context) {
    _classCallCheck(this, Process);

    var _this = _possibleConstructorReturn(this, (Process.__proto__ || Object.getPrototypeOf(Process)).call(this, props, context));

    _this.state = {
      data: [],
      dataOptions: [],
      dataSelected: [],
      dataCapDonViQuyTrinhs: [],
      capDonViQuyTrinhs: '',
      donViCon: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      moTa: '',
      giaTri: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      isValid: true
    };
    return _this;
  }

  _createClass(Process, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getListDV();
      this.getCapDonViQuyTrinh();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'DonVi') {
        this.setState({
          dataSelected: e
        });
      } else if (name === 'donViCon') {
        this.setState({ donViCon: !this.state.donViCon });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      _api.Danhmuc.actions.getListQuyTrinh.request(null, params).then(function (res) {
        if (res && res.data && res.data._embedded.medial_DonViQuyTrinhInfoes) {
          _this2.setState({
            data: res.data._embedded.medial_DonViQuyTrinhInfoes,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this3 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        }) }, function () {
        _this3.getListData();
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this4 = this;

      if (this.validateSubmitForm()) {
        var params = {
          capDonVi: this.state.capDonViQuyTrinhs || ''
        };

        if (this.state.dataSelected && this.state.dataSelected.length > 0) {
          var ids = [];
          this.state.dataSelected.forEach(function (item) {
            ids.push(item.value);
          });
          params.donViIds = ids;
        }
        this.setState({ buttonLoading: true });
        this.props.danhMuc.postQuyTrinh('', params).then(function (res) {
          _this4.getListData();
          _this4.closeDialog();
          (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
          _this4.setState({
            dataSelected: [],
            capDonViQuyTrinhs: '',
            buttonLoading: false
          });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          number: page.selected
        }) }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this6 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteQuyTrinh({ idDonVi: categoryId }).then(function (res) {
          _this6.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this6.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this6.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        dataSelected: [],
        capDonViQuyTrinhs: '',
        isValid: true
      });
    }
  }, {
    key: 'getListDV',
    value: function getListDV() {
      var _this7 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      _api.DuLieuHeThong.actions.getCoQuanQuanLy.request().then(function (res) {
        if (res && res.data && res.data._embedded) {
          var dataDonVi = [].concat(_toConsumableArray(res.data._embedded.coQuanQuanLies));
          var DonVi = dataDonVi.filter(function (state) {
            return state.coQuanQuanLyId === userInfo.donViId;
          });
          _this7.setState({
            dataSelected: [{ value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }],
            dataOptions: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getCapDonViQuyTrinh',
    value: function getCapDonViQuyTrinh() {
      var _this8 = this;

      _api.DuLieuHeThong.actions.getCapDonViQuyTrinhs.request().then(function (res) {
        if (res && res.data) {
          _this8.setState({ dataCapDonViQuyTrinhs: res.data });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Qu\u1EA3n l\xFD quy tr\xECnh'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('PROCESS_THEM') && _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.quytrinh,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemProcess, { buttonLoading: this.state.buttonLoading })
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: 'Th\xEAm m\u1EDBi quy tr\xECnh',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'div',
                { className: 'col-min-83 no-gutter clear-left' },
                _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected col-min-83', label: '\u0110\u01A1n v\u1ECB', dataOptions: this.state.dataOptions, dataSelected: this.state.dataSelected, onChange: this.onChange.bind(this, 'DonVi'), selectAllChildren: this.state.donViCon, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', bindValidator: this, channel: 'formTaoDon', require: true }),
                _react2.default.createElement(_ttForms.DropDownQuyTrinh, { className: 'tree-selected col-min-83', label: 'C\u1EA5p \u0111\u01A1n v\u1ECB', data: this.state.dataCapDonViQuyTrinhs, selectedValue: this.state.capDonViQuyTrinhs, onChange: this.onChange.bind(this, 'capDonViQuyTrinhs'), name: 'capDonViQuyTrinhs', bindValidator: this, channel: 'formTaoDon', require: true })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: (0, _classnames2.default)('btn-action btn-save', { 'btn-loading': this.state.buttonLoading }), onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Th\xEAm m\u1EDBi'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Process;
}(_react2.default.Component);

Process.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(Process);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

var _table = __webpack_require__(12);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachBangChung = function (_React$Component) {
  _inherits(DanhSachBangChung, _React$Component);

  function DanhSachBangChung() {
    _classCallCheck(this, DanhSachBangChung);

    return _possibleConstructorReturn(this, (DanhSachBangChung.__proto__ || Object.getPrototypeOf(DanhSachBangChung)).apply(this, arguments));
  }

  _createClass(DanhSachBangChung, [{
    key: 'render',
    value: function render() {
      var dataLTL = [];
      var check = false;
      if (this.props.listTaiLieuBangChung && this.props.listTaiLieuBangChung.length > 0) {
        dataLTL = this.props.listTaiLieuBangChung;
        check = true;
      } else if (this.props.listTLBC && this.props.listTLBC.length > 0) {
        dataLTL = this.props.listTLBC;
        check = true;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'Danh s\xE1ch t\xE0i li\u1EC7u k\xE8m theo'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('items-form white-table', { checktdgs: check }) },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.giaiQuyetDon.danhSachBangChung,
                  dataList: dataLTL,
                  type: 'handle-letter-detail', hidePagination: true,
                  checkTDGS: this.props.checkTDGS,
                  hiddenButtonExport: true },
                _react2.default.createElement(_rowItem.DetailTaiLieuRowItem, null)
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachBangChung;
}(_react2.default.Component);

DanhSachBangChung.defaultProps = {
  listTaiLieuBangChung: []
};

exports.default = DanhSachBangChung;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDoanDongNguoi = function (_React$Component) {
  _inherits(DanhSachDoanDongNguoi, _React$Component);

  function DanhSachDoanDongNguoi() {
    _classCallCheck(this, DanhSachDoanDongNguoi);

    return _possibleConstructorReturn(this, (DanhSachDoanDongNguoi.__proto__ || Object.getPrototypeOf(DanhSachDoanDongNguoi)).apply(this, arguments));
  }

  _createClass(DanhSachDoanDongNguoi, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'Danh s\xE1ch \u0111o\xE0n'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form white-table' },
          _react2.default.createElement(
            'div',
            { className: 'rows mb15' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.detailReception.groupMember,
                  dataList: this.props.listDoanDiCung,
                  hidePagination: true,
                  hideExport: true },
                _react2.default.createElement(_rowItem.RowItemDanhSachDoanDongNguoi, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl20 pr20 mb20 pt5' },
            _react2.default.createElement('div', { className: 'line-border' })
          )
        )
      );
    }
  }]);

  return DanhSachDoanDongNguoi;
}(_react2.default.Component);

DanhSachDoanDongNguoi.defaultProps = {
  listDoanDiCung: []
};

exports.default = DanhSachDoanDongNguoi;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _detail = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinCoQuanDaGiaiQuyet = function (_React$Component) {
  _inherits(ThongTinCoQuanDaGiaiQuyet, _React$Component);

  function ThongTinCoQuanDaGiaiQuyet() {
    _classCallCheck(this, ThongTinCoQuanDaGiaiQuyet);

    return _possibleConstructorReturn(this, (ThongTinCoQuanDaGiaiQuyet.__proto__ || Object.getPrototypeOf(ThongTinCoQuanDaGiaiQuyet)).apply(this, arguments));
  }

  _createClass(ThongTinCoQuanDaGiaiQuyet, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'container-box' },
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows mt20' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    this.props.title
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb0' },
              _react2.default.createElement(
                'div',
                { className: 'rows mb10' },
                _react2.default.createElement(_common.Text, { className: 'col-25', label: 'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt:', value: this.props.coQuanDaGiaiQuyetDonThu || '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.props.soVanBanDaGiaiQuyet }),
                _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh:', value: (0, _moment2.default)(this.props.ngayBanHanhVanBanDaGiaiQuyet).format("DD/MM/YYYY") })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form white-table mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.detailReceptionPeriodical.attach,
                      dataList: this.props.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet,
                      hidePagination: true },
                    _react2.default.createElement(_detail.RowItemListAttachReceptionPeriodical, null)
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinCoQuanDaGiaiQuyet;
}(_react2.default.Component);

ThongTinCoQuanDaGiaiQuyet.defaultProps = {
  coQuanDaGiaiQuyetDon: {},
  thamQuyenGiaiQuyetInfo: {},
  hinhThucGiaiQuyetInfo: {},
  soVanBanDaGiaiQuyet: '',
  ngayBanHanhVanBanDaGiaiQuyet: '',
  listTaiLieuVanThuBlockCoQuanDaGiaiQuyet: []
};

exports.default = ThongTinCoQuanDaGiaiQuyet;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _DanhSachBangChung = __webpack_require__(475);

var _DanhSachBangChung2 = _interopRequireDefault(_DanhSachBangChung);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinDon = function (_React$Component) {
  _inherits(ThongTinDon, _React$Component);

  function ThongTinDon(props, context) {
    _classCallCheck(this, ThongTinDon);

    var _this = _possibleConstructorReturn(this, (ThongTinDon.__proto__ || Object.getPrototypeOf(ThongTinDon)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ThongTinDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var Item = this.props;
      return _react2.default.createElement(
        'div',
        { className: 'box-forward wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'container-box' },
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.props.isOpen },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'h3',
                      { className: 'title-14' },
                      this.props.title
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows mb10' },
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0:', value: Item.loaiDonText }),
                  Item.loaiDon == 'DON_KHIEU_NAI' || Item.loaiDon == "DON_TO_CAO" ? _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng' + (Item.loaiDon == "DON_TO_CAO" ? ' bị tố cáo' : '') + ':', value: Item.loaiDoiTuongInfo ? Item.loaiDoiTuongInfo.ten : '' }) : null,
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'L\u0129nh v\u1EF1c:', value: Item && Item.linhVucDonThuDon ? Item.linhVucDonThuDon.ten : '' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-input ' + (Item && Item.linhVucDonThuChiTietDon ? '' : 'hidden') },
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-label' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'L\u0129nh v\u1EF1c chi ti\u1EBFt:'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: Item && Item.chiTietLinhVucDonThuChiTietDon ? 'val-content arrow-to-dispute' : 'val-content' },
                      Item && Item.linhVucDonThuChiTietDon ? Item.linhVucDonThuChiTietDon.ten : ''
                    )
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-input ' + (Item && Item.chiTietLinhVucDonThuChiTietDon ? '' : 'hidden'), label: '\xA0', value: Item && Item.chiTietLinhVucDonThuChiTietDon ? Item.chiTietLinhVucDonThuChiTietDon.ten : '' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows mb10' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-12', label: 'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0:', value: Item && Item.noiDung ? Item.noiDung : '' })
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.props.isOpen },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_common.Text, { className: 'col-input mb10', label: 'Lo\u1EA1i v\u1EE5 vi\u1EC7c:', value: Item && Item.loaiVuViecInfo ? Item.loaiVuViecInfo.ten : '' }),
                _react2.default.createElement(_DanhSachBangChung2.default, { listTLBC: this.props.listTLBC, checkTDGS: this.props.checkTDGS, listTaiLieuBangChung: this.props.listTaiLieuBangChung })
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinDon;
}(_react2.default.Component);

exports.default = ThongTinDon;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _DanhSachDoanDongNguoi = __webpack_require__(476);

var _DanhSachDoanDongNguoi2 = _interopRequireDefault(_DanhSachDoanDongNguoi);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinNguoiDungDon = function (_React$Component) {
  _inherits(ThongTinNguoiDungDon, _React$Component);

  function ThongTinNguoiDungDon() {
    _classCallCheck(this, ThongTinNguoiDungDon);

    return _possibleConstructorReturn(this, (ThongTinNguoiDungDon.__proto__ || Object.getPrototypeOf(ThongTinNguoiDungDon)).apply(this, arguments));
  }

  _createClass(ThongTinNguoiDungDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ListNguoiDungDon = '';
      if (this.props.listNguoiDungDon) {
        ListNguoiDungDon = this.props.listNguoiDungDon.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { key: i },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _this2.props.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" },
              _react2.default.createElement(
                'div',
                { className: 'items-form mb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-4',
                    label: 'T\xEAn c\u01A1 quan/T\u1ED5 ch\u1EE9c:',
                    value: item.tenCoQuan ? item.tenCoQuan : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-4',
                    label: '\u0110\u1ECBa ch\u1EC9 c\u01A1 quan:',
                    value: item.diaChiCoQuan ? item.diaChiCoQuan : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-4',
                    label: '\u0110i\u1EC7n tho\u1EA1i c\u01A1 quan:',
                    value: item.soDienThoaiCoQuan ? item.soDienThoaiCoQuan : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _this2.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI" },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: _this2.props.listNguoiDungDon.length == 1 },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 txt-heading mb15 pl5 pr5' },
                  'Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: _this2.props.listNguoiDungDon.length > 1 },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 txt-heading mb15 pl5 pr5' },
                  'Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ',
                  i + 1
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _this2.props.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 txt-heading mb15 pl5 pr5' },
                'Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _this2.props.loaiNguoiDungDon == "CA_NHAN" },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: _this2.props.listNguoiDungDon.length == 1 },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 txt-heading mb15 pl5 pr5' },
                  'Ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: _this2.props.listNguoiDungDon.length > 1 },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 txt-heading mb15 pl5 pr5' },
                  'Ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n ',
                  i + 1
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows mb10' },
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'H\u1ECD v\xE0 t\xEAn:', value: item.hoVaTen }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ng\xE0y sinh:', value: item.ngaySinh ? (0, _moment2.default)(item.ngaySinh).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:', value: item.soDienThoai }),
                  _react2.default.createElement(_common.Text, { className: 'col-40', label: 'Gi\u1EDBi t\xEDnh:', value: item.gioiTinh ? 'Nam' : 'Nữ' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows mb10' },
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu:', value: item.soCMNDHoChieu }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ng\xE0y c\u1EA5p:', value: item.ngayCap ? (0, _moment2.default)(item.ngayCap).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'N\u01A1i c\u1EA5p:', value: item.noiCapCMNDInfo ? item.noiCapCMNDInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Qu\u1ED1c t\u1ECBch:', value: item.quocTichCongDan ? item.quocTichCongDan.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'D\xE2n t\u1ED9c:', value: item.danTocCongDan ? item.danTocCongDan.ten : '' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'T\u1EC9nh:', value: item.tinhThanhCongDan ? item.tinhThanhCongDan.ten : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: item.quanHuyenCongDan != null || item.phuongXaCongDan != null || item.toThon != '' && item.toThon != null },
                    _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Qu\u1EADn/Huy\u1EC7n:', value: item.quanHuyenCongDan ? item.quanHuyenCongDan.ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ph\u01B0\u1EDDng/X\xE3:', value: item.phuongXaCongDan ? item.phuongXaCongDan.ten : '' })
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-w40', label: '\u0110\u1ECBa ch\u1EC9:', value: item.diaChi || '' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pl5 pr5 pt10 mb15' },
                _react2.default.createElement('div', { className: 'line-border' })
              )
            )
          );
        });
      } else {
        ListNguoiDungDon = _react2.default.createElement('div', null);
      }
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows pt5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'mb15' },
                    'TH\xD4NG TIN NG\u01AF\u1EDCI \u0110\u1EE8NG \u0110\u01A0N/V\u1EE4 VI\u1EC6C'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box no-border' },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows mb10' },
                  _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Lo\u1EA1i ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n:', value: this.props.loaiNguoiDungDonInfo ? this.props.loaiNguoiDungDonInfo.ten : '' }),
                  this.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.soNguoi) }),
                    _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n:', value: String(this.props.listNguoiDungDon.length) })
                  ) : null
                )
              )
            ),
            ListNguoiDungDon,
            this.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? _react2.default.createElement(_DanhSachDoanDongNguoi2.default, { listDoanDiCung: this.props.listDoanDiCung }) : null
          )
        )
      );
    }
  }]);

  return ThongTinNguoiDungDon;
}(_react2.default.Component);

exports.default = ThongTinNguoiDungDon;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _detail = __webpack_require__(238);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinNguoiUyQuyen = function (_React$Component) {
  _inherits(ThongTinNguoiUyQuyen, _React$Component);

  function ThongTinNguoiUyQuyen() {
    _classCallCheck(this, ThongTinNguoiUyQuyen);

    return _possibleConstructorReturn(this, (ThongTinNguoiUyQuyen.__proto__ || Object.getPrototypeOf(ThongTinNguoiUyQuyen)).apply(this, arguments));
  }

  _createClass(ThongTinNguoiUyQuyen, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'group-box' },
          _react2.default.createElement(
            'div',
            { className: 'items-form' },
            _react2.default.createElement(
              'div',
              { className: 'rows mb10' },
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'H\u1ECD v\xE0 t\xEAn:', value: this.props.nguoiDuocUyQuyen.hoVaTen || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ng\xE0y sinh:', value: this.props.nguoiDuocUyQuyen.ngaySinh ? (0, _moment2.default)(this.props.nguoiDuocUyQuyen.ngaySinh).format("DD/MM/YYYY") : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:', value: this.props.nguoiDuocUyQuyen.soDienThoai || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Gi\u1EDBi t\xEDnh:', value: this.props.nguoiDuocUyQuyen.gioiTinh ? 'Nam' : "Nữ" })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'items-form' },
            _react2.default.createElement(
              'div',
              { className: 'rows mb10' },
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu:', value: this.props.nguoiDuocUyQuyen.soCMNDHoChieu || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ng\xE0y c\u1EA5p:', value: this.props.nguoiDuocUyQuyen.ngayCap ? (0, _moment2.default)(this.props.nguoiDuocUyQuyen.ngayCap).format("DD/MM/YYYY") : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'N\u01A1i c\u1EA5p:', value: this.props.nguoiDuocUyQuyen.noiCapCMNDInfo ? this.props.nguoiDuocUyQuyen.noiCapCMNDInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Qu\u1ED1c t\u1ECBch:', value: this.props.nguoiDuocUyQuyen.quocTichCongDan ? this.props.nguoiDuocUyQuyen.quocTichCongDan.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'D\xE2n t\u1ED9c:', value: this.props.nguoiDuocUyQuyen.danTocCongDan ? this.props.nguoiDuocUyQuyen.danTocCongDan.ten : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'items-form' },
            _react2.default.createElement(
              'div',
              { className: 'rows mb10' },
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'T\u1EC9nh:', value: this.props.nguoiDuocUyQuyen.tinhThanhCongDan ? this.props.nguoiDuocUyQuyen.tinhThanhCongDan.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Qu\u1EADn/Huy\u1EC7n:', value: this.props.nguoiDuocUyQuyen.quanHuyenCongDan ? this.props.nguoiDuocUyQuyen.quanHuyenCongDan.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ph\u01B0\u1EDDng/X\xE3:', value: this.props.nguoiDuocUyQuyen.phuongXaCongDan ? this.props.nguoiDuocUyQuyen.phuongXaCongDan.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-w40', label: '\u0110\u1ECBa ch\u1EC9:', value: this.props.nguoiDuocUyQuyen.diaChi || '' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.listTepUyQuyen && this.props.listTepUyQuyen.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows mb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label mb5' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'Gi\u1EA5y \u1EE7y quy\u1EC1n: '
                    )
                  ),
                  this.props.listTepUyQuyen.map(function (item, i) {
                    return _react2.default.createElement(
                      'p',
                      { className: 'info-document mb5', key: i },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: !_config.checkServerLive },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile), className: 'name_upload text-13 txt-blue' },
                          item.tenFile
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: _config.checkServerLive },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { onClick: function onClick() {
                              (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                            }, className: 'name_upload text-13 txt-blue' },
                          item.tenFile
                        )
                      )
                    );
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.nguoiDuocUyQuyen.luatSu },
            _react2.default.createElement(
              'div',
              { className: 'items-form title mb15' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-input' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Lu\u1EADt s\u01B0'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'rows mb10' },
                _react2.default.createElement(_common.Text, { className: 'col-input', label: 'S\u1ED1 th\u1EBB:', value: this.props.nguoiDuocUyQuyen.soTheLuatSu }),
                _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Ng\xE0y c\u1EA5p:', value: this.props.nguoiDuocUyQuyen.ngayCapTheLuatSu ? (0, _moment2.default)(this.props.nguoiDuocUyQuyen.ngayCapTheLuatSu).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-input', label: 'N\u01A1i c\u1EA5p:', value: this.props.nguoiDuocUyQuyen.noiCapTheLuatSu }),
                _react2.default.createElement(_common.Text, { className: 'col-input', label: 'Th\xF4ng tin gi\u1EDBi thi\u1EC7u:', value: this.props.nguoiDuocUyQuyen.thongTinGioiThieu })
              ),
              this.props.checkTDGS === false && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Danh s\xE1ch t\xE0i li\u1EC7u k\xE8m theo'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.detailReception.proof,
                          dataList: this.props.listTaiLieuBangChungLuatSu,
                          hidePagination: true },
                        _react2.default.createElement(_detail.RowItemDocumentDetail, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.listTepChungChiHanhNghe && this.props.listTepChungChiHanhNghe.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows mb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label mb5' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'Ch\u1EE9ng ch\u1EC9 h\xE0nh ngh\u1EC1:'
                    )
                  ),
                  this.props.listTepChungChiHanhNghe.map(function (item, i) {
                    return _react2.default.createElement(
                      'p',
                      { className: 'info-document mb5', key: i },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: !_config.checkServerLive },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'name_upload text-13 txt-blue', onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile) },
                          item.tenFile
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: _config.checkServerLive },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'name_upload text-13 txt-blue', onClick: function onClick() {
                              (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                            } },
                          item.tenFile
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinNguoiUyQuyen;
}(_react2.default.Component);

ThongTinNguoiUyQuyen.defaultProps = {
  nguoiDuocUyQuyen: [],
  listTepUyQuyen: [],
  listTepChungChiHanhNghe: [],
  listTaiLieuBangChungLuatSu: []
};

exports.default = ThongTinNguoiUyQuyen;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListHandleLetters = undefined;

var _RowItemListHandleLetters = __webpack_require__(1158);

var _RowItemListHandleLetters2 = _interopRequireDefault(_RowItemListHandleLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemListHandleLetters = _RowItemListHandleLetters2.default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.ConvertParams = ConvertParams;
function ConvertParams(data, donId) {

  var dataGiaiQuyetDon = _extends({}, data);

  if (dataGiaiQuyetDon.truongDoanTTXMInfo) {
    dataGiaiQuyetDon.truongDoanTTXM = {
      id: dataGiaiQuyetDon.truongDoanTTXMInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.truongDoanTTXM = null;
  }

  // if (dataGiaiQuyetDon.canBoXuLyChiDinhInfo  && !dataGiaiQuyetDon.canBoXuLyChiDinh) {

  //   dataGiaiQuyetDon.canBoXuLyChiDinh ={
  //     id: dataGiaiQuyetDon.canBoXuLyChiDinhInfo.id
  //   }
  // } else {
  //   // dataGiaiQuyetDon.canBoXuLyChiDinh = null;
  // }

  // if (dataGiaiQuyetDon.phongBanGiaiQuyetInfo) {
  //   dataGiaiQuyetDon.phongBanGiaiQuyet ={
  //     id: dataGiaiQuyetDon.phongBanGiaiQuyetInfo.coQuanQuanLyId
  //   }
  // } else {
  //   dataGiaiQuyetDon.phongBanGiaiQuyet = null;
  // }

  // if (dataGiaiQuyetDon.nextStateInfo) {
  //   dataGiaiQuyetDon.nextState = {
  //     id: dataGiaiQuyetDon.nextStateInfo.id,
  //     type: dataGiaiQuyetDon.nextStateInfo.type
  //   }
  // } else {
  //   dataGiaiQuyetDon.nextState = null;
  // }

  if (dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViGiaoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo) {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = {
      id: dataGiaiQuyetDon.coQuanDaGiaiQuyetInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.coQuanDaGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.donViThamTraXacMinhInfo) {
    dataGiaiQuyetDon.donViThamTraXacMinh = {
      id: dataGiaiQuyetDon.donViThamTraXacMinhInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.canBoGiaiQuyetInfo) {
    dataGiaiQuyetDon.canBoGiaiQuyet = {
      id: dataGiaiQuyetDon.canBoGiaiQuyetInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.canBoGiaiQuyet = null;
  }

  if (dataGiaiQuyetDon.canBoThamTraXacMinhInfo) {
    dataGiaiQuyetDon.canBoThamTraXacMinh = {
      id: dataGiaiQuyetDon.canBoThamTraXacMinhInfo.congChucId
    };
  } else {
    dataGiaiQuyetDon.canBoThamTraXacMinh = null;
  }

  if (dataGiaiQuyetDon.coQuanDieuTraInfo) {
    dataGiaiQuyetDon.coQuanDieuTra = {
      id: dataGiaiQuyetDon.coQuanDieuTraInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.coQuanDieuTra = null;
  }

  if (dataGiaiQuyetDon.donViTheoDoiThucHienInfo) {
    dataGiaiQuyetDon.donViTheoDoiThucHien = {
      id: dataGiaiQuyetDon.donViTheoDoiThucHienInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.donViTheoDoiThucHien = null;
  }

  if (dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo) {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = {
      id: dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLDInfo.coQuanQuanLyId
    };
  } else {
    dataGiaiQuyetDon.phongBanGiaiQuyetKetQuaXLD = null;
  }

  // if (dataGiaiQuyetDon.coQuanTheoDoiInfo) {
  //   dataGiaiQuyetDon.coQuanTheoDoi = {
  //     id: dataGiaiQuyetDon.coQuanTheoDoiInfo.coQuanQuanLyId
  //   }
  // } else {
  //   dataGiaiQuyetDon.coQuanTheoDoi = null;
  // }

  delete dataGiaiQuyetDon['_links'];
  delete dataGiaiQuyetDon['nguoiSuaInfo'];
  delete dataGiaiQuyetDon['nguoiTaoInfo'];
  delete dataGiaiQuyetDon['ngaySua'];
  delete dataGiaiQuyetDon['canBoXuLyChiDinhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['ngayTao'];
  delete dataGiaiQuyetDon['donViThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['donViGiaoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['phongBanGiaiQuyetKetQuaXLDInfo'];
  delete dataGiaiQuyetDon['canBoGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['nguoiBanHanhInfo'];
  delete dataGiaiQuyetDon['canBoThamTraXacMinhInfo'];
  delete dataGiaiQuyetDon['coQuanDieuTraInfo'];
  delete dataGiaiQuyetDon['donViTheoDoiThucHienInfo'];
  delete dataGiaiQuyetDon['huongXuLyGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['coQuanTheoDoiInfo'];
  delete dataGiaiQuyetDon['truongDoanTTXMInfo'];
  delete dataGiaiQuyetDon['nextStateInfo'];
  delete dataGiaiQuyetDon['coQuanDaGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['ketQuaXLDGiaiQuyetInfo'];
  delete dataGiaiQuyetDon['donId'];

  dataGiaiQuyetDon.don = {
    id: Number(donId)
  };

  return dataGiaiQuyetDon;
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TuXuLy = exports.KhongCoQuyTrinh = exports.HuongXuLyView = exports.HuongXuLy = exports.LanhDaoGiaoViecView = exports.LanhDaoGiaoViec = exports.TruongPhongGiaoViecView = exports.TruongPhongGiaoViec = exports.TrinhLanhDaoView = exports.TrinhLanhDao = undefined;

var _TrinhLanhDao = __webpack_require__(1200);

var _TrinhLanhDao2 = _interopRequireDefault(_TrinhLanhDao);

var _TrinhLanhDaoView = __webpack_require__(1201);

var _TrinhLanhDaoView2 = _interopRequireDefault(_TrinhLanhDaoView);

var _TruongPhongGiaoViec = __webpack_require__(1207);

var _TruongPhongGiaoViec2 = _interopRequireDefault(_TruongPhongGiaoViec);

var _TruongPhongGiaoViecView = __webpack_require__(1208);

var _TruongPhongGiaoViecView2 = _interopRequireDefault(_TruongPhongGiaoViecView);

var _LanhDaoGiaoViec = __webpack_require__(1205);

var _LanhDaoGiaoViec2 = _interopRequireDefault(_LanhDaoGiaoViec);

var _LanhDaoGiaoViecView = __webpack_require__(1206);

var _LanhDaoGiaoViecView2 = _interopRequireDefault(_LanhDaoGiaoViecView);

var _HuongXuLy = __webpack_require__(1202);

var _HuongXuLy2 = _interopRequireDefault(_HuongXuLy);

var _HuongXuLyView = __webpack_require__(1203);

var _HuongXuLyView2 = _interopRequireDefault(_HuongXuLyView);

var _KhongCoQuyTrinh = __webpack_require__(1204);

var _KhongCoQuyTrinh2 = _interopRequireDefault(_KhongCoQuyTrinh);

var _TuXuLy = __webpack_require__(1209);

var _TuXuLy2 = _interopRequireDefault(_TuXuLy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TrinhLanhDao = _TrinhLanhDao2.default;
exports.TrinhLanhDaoView = _TrinhLanhDaoView2.default;
exports.TruongPhongGiaoViec = _TruongPhongGiaoViec2.default;
exports.TruongPhongGiaoViecView = _TruongPhongGiaoViecView2.default;
exports.LanhDaoGiaoViec = _LanhDaoGiaoViec2.default;
exports.LanhDaoGiaoViecView = _LanhDaoGiaoViecView2.default;
exports.HuongXuLy = _HuongXuLy2.default;
exports.HuongXuLyView = _HuongXuLyView2.default;
exports.KhongCoQuyTrinh = _KhongCoQuyTrinh2.default;
exports.TuXuLy = _TuXuLy2.default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = exports.Help = exports.Page403 = exports.LettersTable = exports.CircleChart = exports.MultipleChart = exports.LettersCount = exports.Home = undefined;

var _Home = __webpack_require__(1213);

var _Home2 = _interopRequireDefault(_Home);

var _LettersCount = __webpack_require__(1214);

var _LettersCount2 = _interopRequireDefault(_LettersCount);

var _MultipleChart = __webpack_require__(1216);

var _MultipleChart2 = _interopRequireDefault(_MultipleChart);

var _CircleChart = __webpack_require__(1211);

var _CircleChart2 = _interopRequireDefault(_CircleChart);

var _LettersTable = __webpack_require__(1215);

var _LettersTable2 = _interopRequireDefault(_LettersTable);

var _Page = __webpack_require__(1217);

var _Page2 = _interopRequireDefault(_Page);

var _Help = __webpack_require__(1212);

var _Help2 = _interopRequireDefault(_Help);

var _Card = __webpack_require__(1210);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Home = _Home2.default;
exports.LettersCount = _LettersCount2.default;
exports.MultipleChart = _MultipleChart2.default;
exports.CircleChart = _CircleChart2.default;
exports.LettersTable = _LettersTable2.default;
exports.Page403 = _Page2.default;
exports.Help = _Help2.default;
exports.Card = _Card2.default;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LetterInformation = __webpack_require__(1222);

var _LetterInformation2 = _interopRequireDefault(_LetterInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LetterInformation2.default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemYeuCau = exports.RowItemReception = undefined;

var _RowItemReception = __webpack_require__(1268);

var _RowItemReception2 = _interopRequireDefault(_RowItemReception);

var _RowItemYeuCau = __webpack_require__(1269);

var _RowItemYeuCau2 = _interopRequireDefault(_RowItemYeuCau);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemReception = _RowItemReception2.default;
exports.RowItemYeuCau = _RowItemYeuCau2.default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailReception = undefined;

var _DetailReception = __webpack_require__(1279);

var _DetailReception2 = _interopRequireDefault(_DetailReception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DetailReception = _DetailReception2.default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _autoComplete = __webpack_require__(190);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Promise = __webpack_require__(136).Promise;

var ThongTinCaNhan = function (_React$Component) {
  _inherits(ThongTinCaNhan, _React$Component);

  function ThongTinCaNhan(props, context) {
    _classCallCheck(this, ThongTinCaNhan);

    var _this = _possibleConstructorReturn(this, (ThongTinCaNhan.__proto__ || Object.getPrototypeOf(ThongTinCaNhan)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      typingTimeout: 0,
      autoCompleteData: [],
      autoCompletePage: '',
      confirmIndex: '',
      confirmData: {},
      isOpenConfirm: false,
      checked: false,
      noiCapList: [],
      ofs: false
    };
    return _this;
  }

  _createClass(ThongTinCaNhan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch({
        type: 'DISPLAY_FORM',
        value: !(0, _lodash.get)(this.props, 'isDonCu')
      });
      if (this.props.noiCapCMND.length == 0) {
        _api.DuLieuHeThong.actions.getNoiCap.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'noiCapCMND',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
      if (this.props.noiCapCMND.length) {
        this.props.noiCapCMND.map(function (item) {
          _this2.state.noiCapList.push({ value: item.coQuanQuanLyId, label: item.ten });
        });
      }
      this.setState(_extends({}, this.state));
      if (!localStorage.getItem('tpdnId')) {
        this.props.dispatch({
          type: 'GET_TPID',
          value: true
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var value = e.target ? e.target.value : e;

      var newData = _extends({}, this.state.data, _defineProperty({}, name, value));

      if (name == 'tinhThanhId' || name == 'quanHuyenId' || name == 'phuongXaId') {
        newData.toThon = '';
        if (name == 'tinhThanhId' || name == 'quanHuyenId') {
          newData.phuongXaId = '';
          if (name == 'tinhThanhId') {
            newData.diaChi = '';
            newData.quanHuyenId = '';
            newData.tinhThanhCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
          } else {
            newData.quanHuyenCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
          }
        } else {
          newData.phuongXaCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
        }
      }

      this.setState({
        data: newData
      });

      this.props.onChange(newData);

      if ((name == 'soCMNDHoChieu' || name == 'diaChi') && !this.props.uyQuyen) {
        this.checkCongDanExist(newData);
      }
    }
  }, {
    key: 'checkCongDanExist',
    value: function checkCongDanExist(data) {
      var _this3 = this;

      if (data.hoVaTen && data.soCMNDHoChieu && data.diaChi) {
        var params = {
          tuKhoa: data.hoVaTen.trim(),
          soCMND: data.soCMNDHoChieu.trim(),
          diaChi: data.diaChi.trim()
        };
        _api.Reception.actions.getCongDanExist.request(null, params).then(function (res) {
          if (res.data) {
            _this3.setState({
              isOpenConfirm: true,
              confirmIndex: _this3.props.index,
              confirmData: res.data
            });
          }
        });
      } else if (data.soCMNDHoChieu && !this.state.checked) {
        _api.Reception.actions.getCMNDExist.request(null, {
          soCMND: data.soCMNDHoChieu
        }).then(function (res) {
          if (res.data) {
            _this3.state.checked = true;
            (0, _toastr.Toastr)(_message.msg.dataExist, 'warning');
          }
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      if (this.props.noiCapCMND != nextProps.noiCapCMND && nextProps.noiCapCMND.length) {
        this.state.noiCapList = [];
        nextProps.noiCapCMND.map(function (item) {
          _this4.state.noiCapList.push({ value: item.coQuanQuanLyId, label: item.ten });
        });
      }
      this.state.data = nextProps.data;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'searchCongDan',
    value: function searchCongDan(hoVaTen) {
      var inputParams = {
        size: 3,
        page: 0
      };

      inputParams.tuKhoa = hoVaTen;

      return _api.Reception.actions.searchCongDan.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          return Promise.resolve({
            result: res.data._embedded.congDans,
            page: res.data.page
          });
        } else {
          return Promise.resolve(null);
        }
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state.data);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.setState({
        data: newData
      });

      this.props.onChange(newData);
    }
  }, {
    key: 'replaceThongTinCaNhan',
    value: function replaceThongTinCaNhan() {
      this.props.dispatch({
        type: 'CHON_CONG_DAN',
        data: this.state.confirmData,
        index: this.state.confirmIndex
      });
      this.closeDialogConfirm();
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      var state = this.state;
      state.isOpenConfirm = false;
      this.setState(state);
      this.props.dispatch({
        type: 'DISPLAY_FIELD',
        value: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dnId = localStorage.getItem('tpdnId') || '';
      var idDonCD = null;
      var checkUQ = false;
      if (this.props && this.props.data && this.props.data.donCongDanId) {
        idDonCD = this.props.data.donCongDanId;
      }
      if (this.props && this.props.uyQuyen === true) {
        checkUQ = true;
      }
      var getHoTen = '';
      if (this.props && this.props.data && this.props.data.hoVaTen) {
        getHoTen = this.props.data.hoVaTen;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.isOpenConfirm, onClose: this.closeDialogConfirm.bind(this), onSuccess: this.replaceThongTinCaNhan.bind(this) }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != "" },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h4',
                  null,
                  this.props.label,
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.isRemoveable },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'link-remove itt-delete', onClick: this.props.handleRemove },
                      'X\xF3a'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === false },
              _react2.default.createElement(_autoComplete.AutoCompleteSearch, {
                label: 'H\u1ECD v\xE0 t\xEAn',
                isRequired: true,
                onSearch: this.searchCongDan,
                onChange: this.onChange.bind(this, 'hoVaTen'),
                value: this.state.data.hoVaTen,
                maxLength: 50,
                index: this.props.index,
                bindValidator: this,
                channel: 'formTaoDon',
                name: 'hoVaTen',
                disabled: getHoTen && this.props.nguoiDaiDien && this.props.nguoiDaiDien.length > 0 && this.props.nguoiDaiDien[this.props.index] && this.props.nguoiDaiDien[this.props.index].congDanId && !this.props.isDonCu ? true : this.props.showForm,
                idDonCD: idDonCD,
                showField: getHoTen
              })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === true },
              _react2.default.createElement(_common.Input, { label: 'H\u1ECD v\xE0 t\xEAn', className: 'col-input', name: 'hoVaTen', maxLength: 40, value: this.state.data.hoVaTen, onChange: this.onChange.bind(this, 'hoVaTen'), bindValidator: this,
                channel: 'formTaoDon', require: true }),
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y sinh', name: 'ngaySinh', endDate: new Date(), value: this.state.data.ngaySinh, onChange: this.handleChangeDate.bind(this, 'ngaySinh') })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === false },
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y sinh', name: 'ngaySinh', endDate: new Date(), value: this.state.data.ngaySinh, onChange: this.handleChangeDate.bind(this, 'ngaySinh'), disabled: this.props.showForm }),
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i', disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm, className: 'col-input', name: 'soDienThoai', type: 'sdt', maxLength: 15, value: this.state.data.soDienThoai, onChange: this.onChange.bind(this, 'soDienThoai') }),
              _react2.default.createElement(
                'div',
                { className: 'col-4' },
                _react2.default.createElement(
                  _core.RadioGroup,
                  {
                    label: 'Gi\u1EDBi t\xEDnh',
                    name: this.props.index,
                    className: 'radio-gender val-title-radio-group',
                    onChange: this.onChange.bind(this, 'gioiTinh'),
                    selectedValue: this.state.data.gioiTinh,
                    disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm
                  },
                  _react2.default.createElement(_core.Radio, { label: 'Nam', value: 'male', className: 'pt-large', disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
                  _react2.default.createElement(_core.Radio, { label: 'N\u1EEF', value: 'female', className: 'pt-large', disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === true },
              _react2.default.createElement(
                'div',
                { className: 'col-4' },
                _react2.default.createElement(
                  _core.RadioGroup,
                  {
                    label: 'Gi\u1EDBi t\xEDnh',
                    name: this.props.index,
                    className: 'radio-gender val-title-radio-group',
                    onChange: this.onChange.bind(this, 'gioiTinh'),
                    selectedValue: this.state.data.gioiTinh
                  },
                  _react2.default.createElement(_core.Radio, { label: 'Nam', value: 'male', className: 'pt-large' }),
                  _react2.default.createElement(_core.Radio, { label: 'N\u1EEF', value: 'female', className: 'pt-large' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === true },
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 CMND/H\u1ED9 chi\u1EBFu/CCCD', name: 'soCMND', className: 'col-input', type: 'cmnd', maxLength: 15, value: this.state.data.soCMNDHoChieu, onChange: this.onChange.bind(this, 'soCMNDHoChieu') }),
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\u1EA5p', name: 'ngayCap', endDate: new Date(), value: this.state.data.ngayCap, onChange: this.handleChangeDate.bind(this, 'ngayCap') }),
              _react2.default.createElement(_common.DropDownMultipleSelect, { multi: false, name: 'DropDownChonNoiCapCMND', className: 'col-input', label: 'N\u01A1i c\u1EA5p', options: this.state.noiCapList, placeholder: { key: '', text: '--Chọn--' }, value: this.state.data.noiCap, onChange: this.onChange.bind(this, 'noiCap') }),
              _react2.default.createElement(_ttForms.DropDownChonQuocTich, { selectedValue: this.state.data.quocTichId, onChange: this.onChange.bind(this, 'quocTichId') }),
              _react2.default.createElement(_ttForms.DropDownChonDanToc, { selectedValue: this.state.data.danTocId, onChange: this.onChange.bind(this, 'danTocId'), quocTichID: this.state.data.quocTichId })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === false },
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 CMND/H\u1ED9 chi\u1EBFu/CCCD', name: 'soCMND', className: 'col-input', type: 'cmnd', maxLength: 15, value: this.state.data.soCMNDHoChieu, onChange: this.onChange.bind(this, 'soCMNDHoChieu'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\u1EA5p', name: 'ngayCap', endDate: new Date(), value: this.state.data.ngayCap, onChange: this.handleChangeDate.bind(this, 'ngayCap'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              _react2.default.createElement(_common.DropDownMultipleSelect, { multi: false, name: 'DropDownChonNoiCapCMND', className: 'col-input', label: 'N\u01A1i c\u1EA5p', options: this.state.noiCapList, placeholder: { key: '', text: '--Chọn--' }, value: this.state.data.noiCap, onChange: this.onChange.bind(this, 'noiCap'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              _react2.default.createElement(_ttForms.DropDownChonQuocTich, { selectedValue: this.state.data.quocTichId, onChange: this.onChange.bind(this, 'quocTichId'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              _react2.default.createElement(_ttForms.DropDownChonDanToc, { selectedValue: this.state.data.danTocId, onChange: this.onChange.bind(this, 'danTocId'), quocTichID: this.state.data.quocTichId, disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === false },
              _react2.default.createElement(_ttForms.DropDownChonTinhThanh, { placeholder: null, selectedValue: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'tinhThanhId'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              parseInt(this.state.data.tinhThanhId) === parseInt(dnId) && _react2.default.createElement(_ttForms.DropDownChonQuanHuyen, { selectedValue: this.state.data.quanHuyenId, thanhPhoID: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'quanHuyenId'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              parseInt(this.state.data.tinhThanhId) === parseInt(dnId) && _react2.default.createElement(_ttForms.DropDownChonPhuongXa, { selectedValue: this.state.data.phuongXaId, quanHuyenId: this.state.data.quanHuyenId, thanhPhoID: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'phuongXaId'), disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm }),
              _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa ch\u1EC9(S\u1ED1 nh\xE0/T\xEAn \u0111\u01B0\u1EDDng/T\u1ED5, th\xF4n)', className: 'col-w40', name: 'diaChi', type: 'text', maxLength: 999, value: this.state.data.diaChi, onChange: this.onChange.bind(this, 'diaChi'), bindValidator: this,
                channel: 'formTaoDon', require: true, disabled: getHoTen && !this.props.isDonCu ? false : this.props.showForm })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkUQ === true },
              _react2.default.createElement(_ttForms.DropDownChonTinhThanh, { placeholder: null, selectedValue: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'tinhThanhId') }),
              parseInt(this.state.data.tinhThanhId) === parseInt(dnId) && _react2.default.createElement(_ttForms.DropDownChonQuanHuyen, { selectedValue: this.state.data.quanHuyenId, thanhPhoID: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'quanHuyenId') }),
              parseInt(this.state.data.tinhThanhId) === parseInt(dnId) && _react2.default.createElement(_ttForms.DropDownChonPhuongXa, { selectedValue: this.state.data.phuongXaId, quanHuyenId: this.state.data.quanHuyenId, thanhPhoID: this.state.data.tinhThanhId, onChange: this.onChange.bind(this, 'phuongXaId') }),
              _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa ch\u1EC9(S\u1ED1 nh\xE0/T\xEAn \u0111\u01B0\u1EDDng/T\u1ED5, th\xF4n)', className: 'col-w40', name: 'diaChi', type: 'text', maxLength: 999, value: this.state.data.diaChi, onChange: this.onChange.bind(this, 'diaChi'), bindValidator: this,
                channel: 'formTaoDon', require: true })
            ),
            _react2.default.createElement('div', { className: 'clearfix' })
          )
        )
      );
    }
  }]);

  return ThongTinCaNhan;
}(_react2.default.Component);

ThongTinCaNhan.defaultProps = {
  handleRemove: function handleRemove() {
    console.log('Need to assign onChange method');
  },
  uyQuyen: false,
  noiCapCMND: []
};

function bindStateToProps(state) {
  return {
    noiCapCMND: state.duLieuHeThong.noiCapCMND,
    showForm: state.duLieuHeThong.showForm,
    showField: state.formDataTiepCongDan.showField,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinCaNhan));

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _table = __webpack_require__(12);

var _reactRedux = __webpack_require__(6);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinDon = function (_React$Component) {
  _inherits(ThongTinDon, _React$Component);

  function ThongTinDon(props, context) {
    _classCallCheck(this, ThongTinDon);

    var _this = _possibleConstructorReturn(this, (ThongTinDon.__proto__ || Object.getPrototypeOf(ThongTinDon)).call(this, props, context));

    _this.state = {
      loaiDoiTuongId: '',
      linhVucCap1Id: '',
      linhVucCap2Id: '',
      linhVucChiTietKhac: '',
      loaiDonId: '',
      noiDung: '',
      flagCQDaGiaiQuyet: false,
      coQuanDaGiaiQuyetDonThu: '',
      soVanBan: '',
      ngayBanHanh: '',
      loaiDonText: '',
      dsBangChung: [],
      dsBangChungRemove: [],
      dsFileCoQuan: [],
      dsFileCoQuanRemove: [],
      listTaiLieuBangChungTiepNhan: [],
      listTaiLieuBangChung: [],
      listFileCoQuan: [],
      loaiVuViecId: 'MOI_PHAT_SINH',
      loaiVuViecText: '',
      displayTbKhac: false,
      received: false,
      layVuViecCu: false,
      loaiDon: '',
      tarGetValue: '',
      tarGetText: '',
      isChangeLoaiDon: true
    };
    return _this;
  }

  _createClass(ThongTinDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getLoaiVuViec();
      if (this.state.listTaiLieuBangChungTiepNhan && this.state.listTaiLieuBangChungTiepNhan.length === 0) {
        var state = this.state;
        state.listTaiLieuBangChungTiepNhan[0] = {
          ten: 'Đơn công dân/Biên bản TCD',
          required: true,
          tenFile: '',
          duongDan: '',
          tinhTrang: '',
          taiLieuBangChungId: ''
        };
        this.setState(_extends({}, state));
      }
      if (this.state.listTaiLieuBangChung.length == 0) {
        this.state.listTaiLieuBangChung[0] = {
          ten: 'Đơn công dân/Biên bản TCD',
          required: false,
          tenFile: '',
          duongDan: '',
          tinhTrang: '',
          taiLieuBangChungId: ''
        };
        if (this.props.xuLyDon) {
          var _state = this.state;
          _state.listTaiLieuBangChung[0].ten = 'Đơn của công dân';
          _state.listTaiLieuBangChung[0].required = true;
          this.setState(_extends({}, _state));
        }
        if (this.props.loaiVuViecList) {
          this.props.loaiVuViecList.map(function (item) {
            if (item.giaTri == _this2.state.loaiVuViecId) {
              _this2.state.loaiVuViecText = item.ten;
            }
          });
        }
        this.setState(_extends({}, this.state));
        this.props.onInit({ thongTinDon: this.state });
      }
    }
  }, {
    key: 'getLoaiVuViec',
    value: function getLoaiVuViec() {
      var _this3 = this;

      if (this.props.loaiVuViecList.length == 0) {
        _api.DuLieuHeThong.actions.getLoaiVuViec.request().then(function (res) {
          _this3.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'loaiVuViecList',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch({
        type: 'RESET_FORM'
      });
    }
  }, {
    key: 'onOpen',
    value: function onOpen(name, e) {
      var state = this.state;
      if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
        this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: true
        });
      } else {
        this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: false
        });
      }
      state.loaiDon = name;
      state.tarGetValue = e.target.value;
      state.tarGetText = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
      this.setState(state);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this4 = this;

      var state = this.state;
      var checkLD = this.props && this.props.editData || {};
      var checkBoxvalue = e.nativeEvent.target[e.nativeEvent.target.selectedIndex] && e.nativeEvent.target[e.nativeEvent.target.selectedIndex].value || state.noiDung;

      if (name === 'loaiDonId') {
        state.linhVucCap1Id = '';
        state.linhVucCap2Id = '';
        state.loaiDoiTuongId = '';
        state.linhVucChiTietKhac = '';
        state.displayTbKhac = false;
        state.loaiDonText = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
        if (checkLD.loaiDon === checkBoxvalue) {
          state.noiDung = this.props.editData.noiDung;
        } else {
          state.noiDung = '';
        }
      }
      if (name === 'linhVucCap1Id') {
        if (e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text === 'Khác') {
          state.displayTbKhac = true;
        } else {
          state.linhVucCap2Id = '';
          state.linhVucChiTietKhac = '';
          state.displayTbKhac = false;
        }
      }
      if (name === 'linhVucCap2Id') {
        if (e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text === 'Khác') {
          state.displayTbKhac = true;
        } else {
          state.displayTbKhac = false;
          state.linhVucChiTietKhac = '';
        }
      }

      if (name === 'loaiDonId') {
        this.setState({
          isChangeLoaiDon: false
        });
      } else {
        this.setState({
          isChangeLoaiDon: true
        });
      }
      state[name] = e.target.value;
      this.setState({ state: state }, function () {
        _this4.props.onChange({ thongTinDon: state }, _this4.state.isChangeLoaiDon);
      });
    }
  }, {
    key: 'onCheck',
    value: function onCheck(name) {
      this.state[name] = !this.state[name];
      this.setState(_extends({}, this.state));
      this.props.onChange({ thongTinDon: this.state });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this5 = this;

      var state = this.state;
      if (nextProps.thongTinDon.donCuId && nextProps.thongTinDon.donCuId !== this.props.thongTinDon.donCuId || nextProps.thongTinDon.donId && nextProps.thongTinDon.donId !== this.props.thongTinDon.donId || nextProps.editData !== this.props.editData) {
        var data = Object.keys(nextProps.thongTinDon) && Object.keys(nextProps.thongTinDon).length > 0 ? nextProps.thongTinDon : nextProps.editData;
        if (state.received !== true) {
          if (data && data.listTaiLieuBangChung && data.listTaiLieuBangChung.length > 0) {
            data.listTaiLieuBangChung.map(function (item) {
              item.tinhTrang = item.tinhTrangTaiLieu || '';
            });
          }
          if (data && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.length > 0) {
            data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.map(function (item) {
              item.tinhTrang = item.tinhTrangTaiLieu || '';
            });
          }
          if (data && data.listTaiLieuBangChung && data.listTaiLieuBangChung.length > 0) {
            state.listTaiLieuBangChung = state.dsBangChung = state.listTaiLieuBangChungTiepNhan = [].concat(_toConsumableArray(data.listTaiLieuBangChung));
          }
          if (data && data.listTaiLieuBangChungTiepNhan && data.listTaiLieuBangChungTiepNhan.length > 0) {
            state.listTaiLieuBangChungTiepNhan = state.listTaiLieuBangChung = state.dsBangChung = [].concat(_toConsumableArray(data.listTaiLieuBangChung));
          }
          if (data && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.length > 0) {
            state.listFileCoQuan = [].concat(_toConsumableArray(data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet));
          }
        }

        state.layVuViecCu = data.layVuViecCu || false;
        state.loaiDoiTuongId = data.loaiDoiTuong || '';
        state.linhVucCap1Id = data.linhVucDonThuDon ? data.linhVucDonThuDon.linhVucDonThuId : '';
        state.linhVucCap2Id = data.linhVucDonThuChiTietDon ? data.linhVucDonThuChiTietDon.linhVucDonThuId : '';
        if (data.linhVucDonThuChiTietDon && data.linhVucDonThuChiTietDon.ten == 'Khác') {
          state.displayTbKhac = true;
        }
        state.linhVucChiTietKhac = data.linhVucChiTietKhac || '';

        state.loaiDonId = data.loaiDon || '';
        if (Object.keys(nextProps.thongTinDon) && Object.keys(nextProps.thongTinDon).length > 0) {
          if (nextProps.thongTinDon.thongTinGiaiQuyetDonInfo && nextProps.thongTinDon.thongTinGiaiQuyetDonInfo.soVanBan) {
            state.loaiVuViecId = 'MOI_PHAT_SINH';
          } else {
            state.loaiVuViecId = 'CU';
          }
          this.props.loaiVuViecList.map(function (item) {
            if (item.giaTri === state.loaiVuViecId) {
              state.loaiVuViecText = item.ten;
            }
          });
        } else if (data && data.loaiVuViecInfo && data.loaiVuViecInfo.length > 0) {
          state.loaiVuViecId = data.loaiVuViec;
          state.loaiVuViecText = data.loaiVuViecInfo.ten;
        }
        state.noiDung = data.noiDung;
        if (data.coThongTinCoQuanDaGiaiQuyet === true) {
          state.flagCQDaGiaiQuyet = data.coThongTinCoQuanDaGiaiQuyet;
          if (state.flagCQDaGiaiQuyet) {
            state.coQuanDaGiaiQuyetDonThu = data.coQuanDaGiaiQuyetDonThu || null;
            state.soVanBan = data.soVanBanDaGiaiQuyet || null;
            state.ngayBanHanh = data.ngayBanHanhVanBanDaGiaiQuyet ? new Date(data.ngayBanHanhVanBanDaGiaiQuyet) : '';
          }
        } else {
          if (this.props.isDonCu === false && data && data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo) {
            state.flagCQDaGiaiQuyet = data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo;
            if (state.flagCQDaGiaiQuyet && data.thongTinGiaiQuyetDonInfo !== null) {
              state.coQuanDaGiaiQuyetDonThu = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten || null;
              state.soVanBan = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.soVanBan || null;
              state.ngayBanHanh = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.ngayBanHanh ? new Date(data.thongTinGiaiQuyetDonInfo.ngayBanHanh) : '';
            }
          } else {
            state.flagCQDaGiaiQuyet = false;
            state.coQuanDaGiaiQuyetDonThu = null;
            state.soVanBan = null;
            state.ngayBanHanh = '';
          }
        }
        this.props.onInit({ thongTinDon: state });
      }
      if (this.props.loaiVuViecList != nextProps.loaiVuViecList) {
        nextProps.loaiVuViecList.map(function (item) {
          if (item.giaTri === state.loaiVuViecId) {
            _this5.setState({ loaiVuViecText: item.ten });
          }
        });
      }
      if (this.props.huongXuLy !== nextProps.huongXuLy && state.listTaiLieuBangChung.length) {
        state.listTaiLieuBangChung[0].required = nextProps.huongXuLy !== 'TU_CHOI' && nextProps.huongXuLy !== 'KHAC' && nextProps.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && nextProps.huongXuLy !== 'TRA_DON_VA_HUONG_DAN' && nextProps.huongXuLy !== "GIAI_QUYET_NGAY" && nextProps.huongXuLy !== "CHO_GIAI_QUYET";
      }
      var optionKhac = 63;
      if (this.state.linhVucCap1Id === optionKhac) {
        state.displayTbKhac = true;
      }
      if (this.props.xuLyDon) {
        var _state2 = this.state;
        _state2.listTaiLieuBangChung[0].required = true;
        this.setState(_extends({}, _state2));
      }
      this.setState(state);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.setState(_extends({}, newData));
      this.props.onChange({ thongTinDon: newData });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dsBangChungRemove = [].concat(_toConsumableArray(this.state.dsBangChungRemove), [id]);
      this.state.dsBangChung = data;
      this.setState(_extends({}, this.state));
      this.props.onChange({ thongTinDon: this.state }, true);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.state.dsBangChung = data;
      this.setState(_extends({}, this.state));
      this.props.onChange({ thongTinDon: this.state }, true);
    }
  }, {
    key: 'onFileRemoveDGQ',
    value: function onFileRemoveDGQ(id, data) {
      this.state.dsFileCoQuanRemove = [].concat(_toConsumableArray(this.state.dsFileCoQuanRemove), [id]);
      this.state.dsFileCoQuan = data;
      this.setState(_extends({}, this.state));
      this.props.onChange({ thongTinDon: this.state });
    }
  }, {
    key: 'onFileChangeDGQ',
    value: function onFileChangeDGQ(data) {
      this.state.dsFileCoQuan = data;
      this.setState(_extends({}, this.state));
      this.props.onChange({ thongTinDon: this.state });
    }
  }, {
    key: 'confirmSaveLoaiDon',
    value: function confirmSaveLoaiDon(next) {
      var state = this.state;
      if (next) {
        if (this.state.loaiDon === 'loaiDonId') {
          state.linhVucCap1Id = '';
          state.linhVucCap2Id = '';
          state.loaiDoiTuongId = '';
          state.linhVucChiTietKhac = '';
          state.displayTbKhac = false;
          state.loaiDonText = state.tarGetText;
          state[state.loaiDon] = state.tarGetValue;
          this.props.dispatch({
            type: 'CHANGE_STATE_LOAIDON',
            data: false
          });
          this.props.dispatch({
            type: 'REMOVE_LOAIDON_EDIT_FORM',
            data: []
          });
          this.props.soTiepCongDan.listTaiLieuVanThu.forEach(function (item) {
            _api.Reception.actions.deleteTepDinhKem.request({
              id: item.taiLieuVanThuId
            });
          });
          this.setState({ state: state });
          this.props.onChange({ thongTinDon: state });
        }
      } else {
        this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isRequire = this.state.listTaiLieuBangChung[0] && this.state.listTaiLieuBangChung[0].required;
      var isLoaiDon = this.state.loaiDonId !== 'DON_KHIEU_NAI' && this.state.loaiDonId !== 'DON_TO_CAO' ? false : true;
      return _react2.default.createElement(
        'div',
        { className: 'box-items' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows pl5 pr5 mt15' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Th\xF4ng tin \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.isDonCu === true && this.props.isKiemTraTCD === false },
                    _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { require: true, bindValidator: this, selectedValue: this.state.loaiDonId, label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', onChange: this.onChange.bind(this, 'loaiDonId'), name: 'dropdownChonLoaiDonThu', isDonCu: true, isTraCuu: false })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.isTraCuu === true && this.props.isKiemTraTCD === undefined },
                    _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { require: true, bindValidator: this, selectedValue: this.state.loaiDonId, label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', onChange: this.onChange.bind(this, 'loaiDonId'), name: 'dropdownChonLoaiDonThu', isTraCuu: true, isDonCu: false })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.isTraCuu === true && this.props.isKiemTraTCD === true },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0 },
                      _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChangeSaveLoaiDon, open: this.props.popupConfirmSaveLoaiDon, onClose: this.confirmSaveLoaiDon.bind(this, false), onSuccess: this.confirmSaveLoaiDon.bind(this, true) }),
                      _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { require: isRequire ? true : false, bindValidator: this, selectedValue: this.state.loaiDonId, label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', onChange: this.onChange.bind(this, 'loaiDonId'), name: 'dropdownChonLoaiDonThu', isTraCuu: true, isDonCu: false })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length === 0 },
                      _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { require: isRequire ? true : false, bindValidator: this, selectedValue: this.state.loaiDonId, label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', onChange: this.onChange.bind(this, 'loaiDonId'), name: 'dropdownChonLoaiDonThu', isTraCuu: true, isDonCu: false })
                    )
                  ),
                  _react2.default.createElement(_ttForms.DropDownChonLoaiDoiTuong, { require: isRequire ? isLoaiDon : false, loaiDonThuID: this.state.loaiDonId, bindValidator: this, selectedValue: this.state.loaiDoiTuongId, onChange: this.onChange.bind(this, 'loaiDoiTuongId'), name: 'dropdownChonLoaiDoiTuong', className: this.state.loaiDonId != 'DON_KHIEU_NAI' && this.state.loaiDonId != 'DON_TO_CAO' ? 'hidden' : '' }),
                  _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThu, { require: isRequire ? true : false, bindValidator: this, selectedValue: this.state.linhVucCap1Id, loaiDonThuID: this.state.loaiDonId, onChange: this.onChange.bind(this, 'linhVucCap1Id'), name: 'dropdownChonLinhVucDonThu' }),
                  _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThuChiTiet, { loaiDonThuID: this.state.loaiDonId, require: isRequire ? true : false, bindValidator: this, selectedValue: this.state.linhVucCap2Id, linhVucDonThuID: this.state.linhVucCap1Id, onChange: this.onChange.bind(this, 'linhVucCap2Id'), name: 'dropdownChonLinhVucCap2Id' }),
                  this.state.displayTbKhac && _react2.default.createElement(_common.Input, { label: 'L\u0129nh v\u1EF1c kh\xE1c', type: 'text', value: this.state.linhVucChiTietKhac, onChange: this.onChange.bind(this, 'linhVucChiTietKhac') }),
                  _react2.default.createElement(_common.TextArea, { bindValidator: this, channel: 'formTaoDon', label: 'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0', require: isRequire ? true : false, value: this.state.noiDung, onChange: this.onChange.bind(this, 'noiDung'), name: 'textareaTomTatNoiDung' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.isDonCu === false },
                    _react2.default.createElement(_common.TextMessage, { className: 'input-group mb10', label: 'Lo\u1EA1i v\u1EE5 vi\u1EC7c:', value: this.state.loaiVuViecText })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows pl5 pr5' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'mb0-18' },
                    'Danh s\xE1ch t\xE0i li\u1EC7u k\xE8m theo'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form  inline-bottom container-filedinhkem' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    this.props.huongXuLy === "TIEP_NHAN_DON" && this.state.dsBangChung && this.state.dsBangChung.length === 0 ? _react2.default.createElement(_upload.ContainerFileDinhKem, { checkValidate: this.props.checkValidate, name: 'fileDon', ref: 'containerFileDinhKem', type: 'TAI_LIEU_BO_SUNG', header: _table.header.addReception.danhSachBangChung, data: this.state.listTaiLieuBangChungTiepNhan, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), bindValidator: this, onSave: this.props.onSave }) : _react2.default.createElement(_upload.ContainerFileDinhKem, {
                      checkValidate: this.props.checkValidate,
                      name: 'fileDon',
                      ref: 'containerFileDinhKem',
                      type: 'TAI_LIEU_BO_SUNG',
                      header: _table.header.addReception.danhSachBangChung,
                      data: this.state.listTaiLieuBangChung,
                      onFileRemove: this.onFileRemove.bind(this),
                      onFileChange: this.onFileChange.bind(this),
                      bindValidator: this,
                      onSave: this.props.onSave })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.isDonCu === false },
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows pl5 pr5' },
                    _react2.default.createElement(
                      _core.Checkbox,
                      { className: 'pt-large', name: 'flagCQDaGiaiQuyet', checked: this.state.flagCQDaGiaiQuyet, onChange: this.onCheck.bind(this, 'flagCQDaGiaiQuyet') },
                      _react2.default.createElement(
                        'span',
                        { className: 'name_checkbox' },
                        'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.flagCQDaGiaiQuyet },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(_common.Input, { label: 'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt', type: 'text', value: this.state.coQuanDaGiaiQuyetDonThu, onChange: this.onChange.bind(this, 'coQuanDaGiaiQuyetDonThu') }),
                    _react2.default.createElement(_common.Input, { label: 'S\u1ED1 v\u0103n b\u1EA3n', type: 'text', value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh') })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'items-form container-filedinhkem' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'fileCoQuanDaGQ', ref: 'containerFileDinhKem', data: this.state.listFileCoQuan, onFileRemove: this.onFileRemoveDGQ.bind(this), onFileChange: this.onFileChangeDGQ.bind(this), bindValidator: this, onSave: this.props.onSave })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinDon;
}(_react2.default.Component);

ThongTinDon.defaultProps = {
  editData: {},
  onSave: false,
  huongXuLy: '',
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  loaiVuViecList: []
};

function bindStateToProps(state) {
  return {
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    editData: state.formDataTiepCongDan.editData,
    loaiVuViecList: state.duLieuHeThong.loaiVuViecList,
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    popupConfirmSaveLoaiDon: state.formDataTiepCongDan.popupConfirmSaveLoaiDon,
    popupConfirmSaveHuongXuLy: state.formDataTiepCongDan.popupConfirmSaveHuongXuLy
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinDon));

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _reception = __webpack_require__(129);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinNguoiDungDon = function (_React$Component) {
  _inherits(ThongTinNguoiDungDon, _React$Component);

  function ThongTinNguoiDungDon(props, context) {
    _classCallCheck(this, ThongTinNguoiDungDon);

    var _this = _possibleConstructorReturn(this, (ThongTinNguoiDungDon.__proto__ || Object.getPrototypeOf(ThongTinNguoiDungDon)).call(this, props, context));

    _this.state = {
      flagUyQuyen: false,
      loaiNguoiDungDonId: 'CA_NHAN',
      tenCoQuan: '',
      diaChiCoQuan: '',
      soDienThoai: '',
      soNguoi: '',
      soNguoiDaiDien: '',
      phanLoaiNguoiDungDonList: _this.props.phanLoaiNguoiDungDonList
    };
    return _this;
  }

  _createClass(ThongTinNguoiDungDon, [{
    key: 'onChangeCheckBox',
    value: function onChangeCheckBox(name, e) {
      this.state[name] = !this.state[name];
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.phanLoaiNguoiDungDonList.length == 0) {
        _api.DuLieuHeThong.actions.getLoaiDungDon.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'phanLoaiNguoiDungDonList',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.state[name] = e.target.value;
      if (name == 'loaiNguoiDungDonId' && e.target.value == 'CO_QUAN_TO_CHUC') {
        this.props.dispatch({
          type: 'INIT_NGUOI_DAI_DIEN_CO_QUAN'
        });
      }
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'addNguoiDaiDien',
    value: function addNguoiDaiDien() {
      this.props.dispatch({
        type: 'THEM_NGUOI_DUNG_DON'
      });

      this.props.onChange(this.state);
    }
  }, {
    key: 'onChangeDoanDongNguoi',
    value: function onChangeDoanDongNguoi(data) {
      var newState = _extends({}, this.state, {
        doanDongNguoi: data
      });
      this.props.onChange(newState);
    }
  }, {
    key: 'onChangeThongTinUyQuyen',
    value: function onChangeThongTinUyQuyen(data, isInit) {
      var newState = _extends({}, this.state, {
        uyQuyen: data
      });
      if (isInit) {
        this.props.onInit(newState);
      } else {
        this.props.onChange(newState);
      }
    }
  }, {
    key: 'getThongTinCaNhan',
    value: function getThongTinCaNhan(index, thongTinCaNhan) {
      this.props.dispatch({
        type: 'CAP_NHAT_THONG_TIN_CA_NHAN',
        data: thongTinCaNhan,
        index: index
      });
      this.props.onChange(this.state);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(data) {
      this.props.dispatch({
        type: 'XOA_NGUOI_DUNG_DON',
        data: data
      });
      this.props.onRemove('CONG_DAN', data);
      this.props.onChange(this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.editData != this.props.editData) {
        var data = nextProps.editData;
        this.state.flagUyQuyen = data.coUyQuyen;
        this.state.loaiNguoiDungDonId = data.loaiNguoiDungDon;
        this.state.soNguoi = data.soNguoi;
        this.state.soNguoiDaiDien = data.listNguoiDungDon.length;
        if (data.loaiNguoiDungDon == 'CO_QUAN_TO_CHUC') {
          this.state.tenCoQuan = data.listNguoiDungDon[0].tenCoQuan;
          this.state.diaChiCoQuan = data.listNguoiDungDon[0].diaChiCoQuan;
          this.state.soDienThoai = data.listNguoiDungDon[0].soDienThoaiCoQuan;
        }
        this.setState(_extends({}, this.state));
        this.props.onInit(this.state);
      }
      if (nextProps.phanLoaiNguoiDungDonList != this.props.phanLoaiNguoiDungDonList) {
        this.state.phanLoaiNguoiDungDonList = nextProps.phanLoaiNguoiDungDonList;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'box-items' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12 mt15' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'items-form inline-bottom' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.DropDown, { label: 'Ph\xE2n lo\u1EA1i ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n', require: true, options: this.state.phanLoaiNguoiDungDonList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.loaiNguoiDungDonId, onChange: this.onChange.bind(this, 'loaiNguoiDungDonId'), placeholder: null, className: 'col-input', name: 'dropdownLoaiNguoiDungDonId' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_common.Input, { className: 'col-input', label: 'T\xEAn c\u01A1 quan/ T\u1ED5 ch\u1EE9c', name: 'tenCoQuan', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.tenCoQuan, onChange: this.onChange.bind(this, 'tenCoQuan') }),
                      _react2.default.createElement(_common.Input, { className: 'col-input', label: '\u0110\u1ECBa ch\u1EC9 c\u01A1 quan', require: true, name: 'diaChiCoQuan', bindValidator: this, channel: 'formTaoDon', value: this.state.diaChiCoQuan, onChange: this.onChange.bind(this, 'diaChiCoQuan') }),
                      _react2.default.createElement(_common.Input, { className: 'col-input', type: 'sdt', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i c\u01A1 quan', require: true, name: 'soDienThoaiCoQuan', bindValidator: this, channel: 'formTaoDon', value: this.state.soDienThoai, onChange: this.onChange.bind(this, 'soDienThoai') })
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_common.Input, { className: 'col-input', type: 'sdt', maxLength: 2, label: 'S\u1ED1 ng\u01B0\u1EDDi', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soNguoi, onChange: this.onChange.bind(this, 'soNguoi'), name: 'soNguoi' }),
                      _react2.default.createElement(_common.Input, { className: 'col-input', type: 'sdt', maxLength: 2, name: 'soNguoiDaiDien', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soNguoiDaiDien, onChange: this.onChange.bind(this, 'soNguoiDaiDien') })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              this.props.nguoiDaiDien.map(function (item, i) {
                var label = "";
                if (_this3.props.nguoiDaiDien.length > 1) {
                  label = _this3.state.loaiNguoiDungDonId == 'CA_NHAN' ? 'NG\u01AF\u1EDCI \u0110\u1EE8NG \u0110\u01A0N ' + (i + 1) : 'NG\u01AF\u1EDCI \u0110\u1EA0I DI\u1EC6N ' + (i + 1);
                } else {
                  label = _this3.state.loaiNguoiDungDonId == 'CA_NHAN' ? "NGƯỜI ĐỨNG ĐƠN" : "NGƯỜI ĐẠI DIỆN";
                }

                return _react2.default.createElement(_reception.ThongTinCaNhan, {
                  key: i,
                  index: i,
                  data: item,
                  label: label,
                  onChange: _this3.getThongTinCaNhan.bind(_this3, i),
                  handleRemove: _this3.handleRemove.bind(_this3, item),
                  isRemoveable: _this3.props.nguoiDaiDien.length > 1,
                  bindValidator: _this3,
                  isDonCu: _this3.props.isDonCu
                });
              }),
              this.props.nguoiDaiDien.length < 4 && this.state.loaiNguoiDungDonId == 'CA_NHAN' || this.props.nguoiDaiDien.length < 10 && this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI' ? _react2.default.createElement(
                'div',
                { className: 'items-form inline-bottom' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'add-items-form' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { onClick: this.addNguoiDaiDien.bind(this), title: '' },
                      this.state.loaiNguoiDungDonId != 'CA_NHAN' ? 'Thêm người đại diện' : 'Thêm người đứng đơn'
                    )
                  )
                )
              ) : _react2.default.createElement('div', { className: 'items-form inline-bottom' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI' },
                _react2.default.createElement(_reception.ListGroupTypeReception, { onChange: this.onChangeDoanDongNguoi.bind(this), data: this.props.editData, onRemove: this.props.onRemove })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(_common.CheckBox, {
                ten: 'C\xF3 \u1EE7y quy\u1EC1n',
                isChecked: this.state.flagUyQuyen,
                onChange: this.onChangeCheckBox.bind(this, 'flagUyQuyen'),
                componentFill: _react2.default.createElement(_reception.ThongTinUyQuyen, { onChange: this.onChangeThongTinUyQuyen.bind(this), isDonCu: this.props.isDonCu, onRemove: this.props.onRemove, data: this.props.editData, bindValidator: this, onSave: this.props.onSave }) })
            )
          )
        )
      );
    }
  }]);

  return ThongTinNguoiDungDon;
}(_react2.default.Component);

ThongTinNguoiDungDon.defaultProps = {
  editData: {},
  onSave: false,
  phanLoaiNguoiDungDonList: []
};

function bindStateToProps(state) {
  return {
    phanLoaiNguoiDungDonList: state.duLieuHeThong.phanLoaiNguoiDungDonList,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon,
    editData: state.formDataTiepCongDan.editData,
    showField: state.formDataTiepCongDan.showField
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinNguoiDungDon));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhMucTongHopThanhTra = exports.DanhMucCuocThanhTraTrung = undefined;

var _DanhMucCuocThanhTraTrung = __webpack_require__(1319);

var _DanhMucCuocThanhTraTrung2 = _interopRequireDefault(_DanhMucCuocThanhTraTrung);

var _DanhMucTongHopThanhTra = __webpack_require__(1320);

var _DanhMucTongHopThanhTra2 = _interopRequireDefault(_DanhMucTongHopThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhMucCuocThanhTraTrung = _DanhMucCuocThanhTraTrung2.default;
exports.DanhMucTongHopThanhTra = _DanhMucTongHopThanhTra2.default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _datatable = __webpack_require__(52);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietDoiTuongTrung = function (_React$Component) {
  _inherits(ChiTietDoiTuongTrung, _React$Component);

  function ChiTietDoiTuongTrung(props, context) {
    _classCallCheck(this, ChiTietDoiTuongTrung);

    var _this = _possibleConstructorReturn(this, (ChiTietDoiTuongTrung.__proto__ || Object.getPrototypeOf(ChiTietDoiTuongTrung)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      allowDelete: true,
      detail: {
        cuocThanhTras: [],
        cuocThanhTraCus: [],
        listTaiLieuVanThu: [],
        donViInfo: {},
        enableEdit: true,
        activeTaoCuocThanhTra: true
      },
      thanhTraThanhPhoId: '',
      activeTaoCuocThanhTra: false,
      sendToThanhTra: false,
      posting: false
    };
    return _this;
  }

  _createClass(ChiTietDoiTuongTrung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params && this.props.params.id) {
        this.getDetailKHTT(this.props.params.id);
      }
      this.checkDonVi();
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'getDetailKHTT',
    value: function getDetailKHTT(idKH) {
      var _this3 = this;

      _api.ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(function (res) {
        if (res.data) {
          _this3.state.detail = res.data;
          _this3.state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
          _this3.state.sendToThanhTra = res.data.saveTamKeHoachTT;
          _this3.state.enableEdit = res.data.cuocThanhTras.length == 0;
          res.data.cuocThanhTras.map(function (item2) {
            if (item2.tienDoThanhTraInfo == null) {
              _this3.state.enableEdit = true;
            }
          });
          _this3.setState(_extends({}, _this3.state));
        }
      });
    }
  }, {
    key: 'taoCuocThanhTra',
    value: function taoCuocThanhTra() {
      this.state.activeTaoCuocThanhTra = true;
      this.handleSave();
    }
  }, {
    key: 'guiThanhTraTP',
    value: function guiThanhTraTP() {
      this.state.sendToThanhTra = true;
      this.handleSave();
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this4 = this;

      var params = {
        keHoachThanhTra: {
          activeTaoCuocThanhTra: this.state.activeTaoCuocThanhTra,
          ghiChu: this.state.detail.ghiChu || '',
          namThanhTra: this.state.detail.namThanhTra || new Date().getFullYear() + 1,
          nguoiKy: this.state.detail.nguoiKy || '',
          quyetDinhPheDuyetKTTT: this.state.detail.quyetDinhPheDuyetKTTT || ''
        },
        sendToThanhTra: this.state.sendToThanhTra
      };
      if (this.state.detail.cuocThanhTras.length) {
        params.cuocThanhTras = [];
      }
      if (this.state.detail.chucNangKeHoachThanhTra) {
        params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.detail.chucNangKeHoachThanhTra;
      }
      if (this.state.detail.ngayRaQuyetDinh) {
        params.keHoachThanhTra.ngayRaQuyetDinh = (0, _moment2.default)(this.state.detail.ngayRaQuyetDinh).add(7, 'hours').toISOString();
      }
      this.state.detail.cuocThanhTras.map(function (item) {
        var pushID = [];
        if (item.doiTuongThanhTraInfo == null) {
          item.listDoiTuongThanhTra.forEach(function (items) {
            pushID.push(items.doiTuongThanhTraId);
          });
        }

        var itemParams = {
          doiTuongThanhTraId: item.doiTuongThanhTraInfo != null ? item.doiTuongThanhTraInfo.doiTuongThanhTraId : pushID,
          donViChuTriId: item.donViChuTriInfo.coQuanQuanLyId,
          donViPhoiHop: item.donViPhoiHop ? item.donViPhoiHop : '',
          kyThanhTra: item.kyThanhTra ? item.kyThanhTra : '',
          linhVucThanhTra: item.linhVucThanhTraInfo ? item.linhVucThanhTraInfo.type : '',
          noiDungThanhTra: item.noiDungThanhTra ? item.noiDungThanhTra : '',
          thoiHanThanhTra: item.thoiHanThanhTra ? Number(item.thoiHanThanhTra) : 0
        };
        if (item.id) {
          itemParams.id = item.id;
        }
        params.cuocThanhTras.push(itemParams);
      });

      this.setState({ posting: true });
      _api.ThanhTra.actions.updateKeHoachThanhTra.request({ id: this.state.detail.keHoachThanhTraId }, params).then(function (res) {
        if (res.data) {
          (0, _toastr.Toastr)(_message.msg.updateKHSuccess, 'success');
          setTimeout(function () {
            _reactRouter.browserHistory.goBack();
          }, 1000);
        }
        _this4.setState({ posting: false });
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this4.setState({
          posting: false
        });
      });
    }
  }, {
    key: 'onSave',
    value: function onSave(data, index) {
      this.state.data[index] = data;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(item, index) {
      if (item.id) {
        this.props.onRemove(item.id);
      }
      this.state.data.splice(index, 1);
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.props.dispatch({ type: 'DSTT_GO_BACK' });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = (0, _lodash.get)(this.state, 'detail.loaiKeHoach.value') === 'KIEM_TRA';
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var info = this.state.detail || {};
      var oldInfo = info.keHoacThanhTraCuInfo;
      var displayButtonEdit = this.state.enableEdit && userInfo.donViId === info.donViInfo.coQuanQuanLyId && !info.daCoKeHoachBoSung && !info.activeTaoCuocThanhTra;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleClose.bind(this), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'K\u1EBF ho\u1EA1ch ',
              this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra',
              ' n\u0103m ',
              info.namThanhTra,
              ' ',
              oldInfo ? '(Sửa đổi, bổ sung lần 1)' : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl20 pr20 pt10', labelClass: 'txt-inline-block mr5', contentClass: 'txt-inline-block', label: 'H\xECnh th\u1EE9c:',
                  value: oldInfo ? 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' s\u1EEDa \u0111\u1ED5i, b\u1ED5 sung' : 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' m\u1EDBi' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement('span', { className: 'big-border mt5' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                oldInfo ? _react2.default.createElement(
                  'h2',
                  { className: 'title-14 col-100 pt20 pl20 pr20 pb15' },
                  '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch s\u1EEDa \u0111\u1ED5i, b\u1ED5 sung'
                ) : _react2.default.createElement(
                  'h2',
                  { className: 'title-14 col-100 pt20 pl20 pr20 pb15' },
                  '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch th\xEAm m\u1EDBi'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl25 pr25' },
                _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: oldInfo ? 'Số quyết định SĐ, BS' : 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + (this.checkIsKiemTra() ? 'KHKT' : 'KHTT') + ':', value: info.quyetDinhPheDuyetKTTT }),
                _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'Ng\xE0y ph\xEA duy\u1EC7t:', value: info.ngayRaQuyetDinh ? (0, _moment2.default)(info.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !oldInfo },
                  _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'N\u0103m ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', value: 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + info.namThanhTra }),
                  info.chucNangKeHoachThanhTraInfo && _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'Ch\u1EE9c n\u0103ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', value: info.chucNangKeHoachThanhTraInfo ? info.chucNangKeHoachThanhTraInfo.text : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'show-lich-su-right' },
                  _react2.default.createElement(_dialog.HistoryDialog, { title: 'L\u1ECBch s\u1EED \u0111i\u1EC1u ch\u1EC9nh', type: 'ke-hoach', donId: this.props.params.id })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !oldInfo },
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'T\xF3m t\u1EAFt k\u1EBF ho\u1EA1ch:', value: info.ghiChu })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement('span', { className: 'line-border mt5 mb20' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: oldInfo },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-13 col-100 pl20 pr20 pb15' },
                    '1.1 Th\xF4ng tin k\u1EBF ho\u1EA1ch ',
                    this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra',
                    ' c\u0169'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl25 pr25' },
                  _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT:', value: oldInfo ? oldInfo.quyetDinhPheDuyetKTTT : '' }),
                  _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'Ng\xE0y ph\xEA duy\u1EC7t:', value: oldInfo && oldInfo.ngayRaQuyetDinh ? (0, _moment2.default)(oldInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'N\u0103m ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', value: oldInfo && oldInfo.namThanhTra ? 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + oldInfo.namThanhTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'input-group mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: oldInfo ? oldInfo.nguoiKy : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'T\xF3m t\u1EAFt k\u1EBF ho\u1EA1ch:', value: oldInfo ? oldInfo.ghiChu : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement('span', { className: 'line-border mt5 mb20' })
                )
              )
            ),
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 heading-addnew-dttt' },
                oldInfo ? _react2.default.createElement(
                  'h2',
                  { className: 'title-13 col-100 pl20 pr20' },
                  '1.2 Danh m\u1EE5c cu\u1ED9c ',
                  this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                ) : _react2.default.createElement(
                  'h2',
                  { className: 'title-13 col-100 pl20 pr20' },
                  '1.1 Danh m\u1EE5c cu\u1ED9c ',
                  this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 ' },
                _react2.default.createElement(
                  _dataTable2.default,
                  { header: _table.header.thanhTra.DKKHTT3, dataList: [].concat(_toConsumableArray(info.cuocThanhTraCus), _toConsumableArray(info.cuocThanhTras)), hideButtonExport: true, hidePagination: true, pageData: this.state.pageData, parent: this, search: this.state.search,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemDanhSachCuocThanhTra, { checkCT: true, onSave: this.onSave.bind(this), isSubmit: this.props.isSubmit })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement('span', { className: 'big-border mt5 mb20' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '2. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', hideDescription: true, disableTopLine: true, disableAttachFile: true, dataShow: info.listTaiLieuVanThu })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt35 pb5' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.handleClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.route.readonly },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: displayButtonEdit },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-edit', to: '/thanh-tra/chinh-sua-ke-hoach/' + info.keHoachThanhTraId },
                    _react2.default.createElement(
                      'span',
                      null,
                      'S\u1EEDa'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietDoiTuongTrung;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(ChiTietDoiTuongTrung);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(169);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _layout = __webpack_require__(9);

var _ttForms = __webpack_require__(19);

var _lodash = __webpack_require__(14);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemMoiKeHoachThanhTra = function (_React$Component) {
  _inherits(ThemMoiKeHoachThanhTra, _React$Component);

  function ThemMoiKeHoachThanhTra(props, context) {
    _classCallCheck(this, ThemMoiKeHoachThanhTra);

    var _this = _possibleConstructorReturn(this, (ThemMoiKeHoachThanhTra.__proto__ || Object.getPrototypeOf(ThemMoiKeHoachThanhTra)).call(this, props, context));

    _this.state = {
      isKiemTra: false,
      noiDungError: '',
      maCodeError: '',
      dataFileDinhKem: {
        dieuChinh: [],
        vanBan: []
      },
      inputFileDinhKem: [],
      dataFileDinhKemDelete: [],
      cuocThanhTra: [],
      doiTuongThanhTras: [],
      chucNangCuocThanhTra: '',
      thongTinChung: {},
      thongTinBS: {},
      posting: false,
      titlePage: 'X\xE2y d\u1EF1ng k\u1EBF ho\u1EA1ch ' + (_this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
      oldData: {
        quyetDinhPheDuyetKTTT: ''
      },
      detail: {
        keHoachThanhTraId: '',
        activeTaoCuocThanhTra: false
      },
      removeCuocTTList: [],
      showUpload: false,
      hasChange: false,
      backConfirm: false,
      isSubmit: false,
      tabType: _this.props.route.type,
      sendToThanhTra: false,
      activeTaoCuocThanhTra: false,
      thanhTraThanhPhoId: '',
      searchKeyKHTT: '',
      isOpenSearchKHTT: false,
      loading: false,
      trangthaiKHTT: 'NHAP_DU_THAO',
      tableLoading: false,
      hasChangeCuocThanhTra: false,
      isOpen: false
    };
    return _this;
  }

  _createClass(ThemMoiKeHoachThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var checkKHDCQD = this.props.location && this.props.location.state && this.props.location.state.keHoachDaCoQuyetDinh;
      if (!checkKHDCQD && (this.props.route.type == 'edit' || this.props.route.type == 'old') && this.props.params && this.props.params.id) {
        this.setState({ titlePage: this.props.route.type == 'edit' ? 'C\u1EADp nh\u1EADt k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : 'Thêm mới kế hoạch bổ sung' });
        this.getDetailKHTT(this.props.params.id);
      } else if (checkKHDCQD) {
        this.setState({ titlePage: 'C\u1EADp nh\u1EADt k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' \u0111\xE3 c\xF3 quy\u1EBFt \u0111\u1ECBnh' });
        this.getDetailKHTT(this.props.params.id);
      } else {
        this.setState({ showUpload: true });
      }
      this.checkDonVi();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isKiemTra !== this.state.isKiemTra) {
        var checkKHDCQD = this.props.location && this.props.location.state && this.props.location.state.keHoachDaCoQuyetDinh;
        if (!checkKHDCQD && (this.props.route.type == 'edit' || this.props.route.type == 'old') && this.props.params && this.props.params.id) {
          this.setState({ titlePage: this.props.route.type == 'edit' ? 'C\u1EADp nh\u1EADt k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : 'Thêm mới kế hoạch bổ sung' });
        } else if (checkKHDCQD) {
          this.setState({ titlePage: 'C\u1EADp nh\u1EADt k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' \u0111\xE3 c\xF3 quy\u1EBFt \u0111\u1ECBnh' });
        } else {}
      }
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = this.props.location.pathname.includes('kiem-tra') || (0, _lodash.get)(this.state, 'isKiemTra');
      return result;
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type === 'DIEU_CHINH_KE_HOACH_THANH_TRA') {
        dataFileDinhKem.dieuChinh = data;
      } else {
        dataFileDinhKem.vanBan = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem,
        hasChange: true
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dataFileDinhKemDelete = [].concat(_toConsumableArray(this.state.dataFileDinhKemDelete), [id]);
      this.state.dataFileDinhKem = data;
      this.state.hasChange = true;
      this.forceUpdate();
    }
  }, {
    key: 'guiThanhTraTP',
    value: function guiThanhTraTP() {
      if (this.validateSubmitForm() && this.checkThongTinKHTT()) {
        this.state.sendToThanhTra = true;
        this.handleSave();
      }
    }
  }, {
    key: 'taoCuocThanhTra',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.validateSubmitForm() && this.checkThongTinKHTT())) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.setState({
                  activeTaoCuocThanhTra: true,
                  posting: true
                });

              case 3:
                this.handleSave();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function taoCuocThanhTra() {
        return _ref.apply(this, arguments);
      }

      return taoCuocThanhTra;
    }()
  }, {
    key: 'checkThongTinKHTT',
    value: function checkThongTinKHTT() {
      var _this3 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if ((userInfo.donViId == this.state.thanhTraThanhPhoId || this.state.sendToThanhTra || this.state.activeTaoCuocThanhTra) && !this.state.cuocThanhTra.length) {
        (0, _toastr.Toastr)('Vui l\xF2ng th\xEAm \xEDt nh\u1EA5t m\u1ED9t cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + '!', 'warning');
        this.setState({
          sendToThanhTra: false,
          posting: false
        });
        return false;
      } else {
        var pass = true;
        this.state.cuocThanhTra.map(function (item) {
          if ((item.linhVucThanhTraInfo == null || item.linhVucThanhTraInfo.type == '') && _this3.state.thongTinChung.chucNangKeHoachThanhTra == 'HANH_CHINH' || (item.hinhThucThanhTraChuyenNganhInfo == null || item.hinhThucThanhTraChuyenNganhInfo.type == '') && _this3.state.thongTinChung.chucNangKeHoachThanhTra == 'CHUYEN_NGANH' || !item.donViChuTriInfo.coQuanQuanLyId) {
            pass = false;
          }
        });

        if (!pass) {
          this.state.isSubmit = true;
          this.setState(_extends({}, this.state));
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(name) {
      var _this4 = this;

      if (this.checkThongTinKHTT()) {
        var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        var TTTrungUong = 19;
        var params = {
          keHoachThanhTra: {
            activeTaoCuocThanhTra: this.state.activeTaoCuocThanhTra,
            ghiChu: this.state.thongTinChung.ghiChu || '',
            namThanhTra: this.state.thongTinChung.namThanhTra || new Date().getFullYear() + 1,
            nguoiKy: this.state.thongTinChung.nguoiKy || '',
            quyetDinhPheDuyetKTTT: (0, _lodash.get)(this.state.thongTinChung, 'quyetDinhPheDuyetKTTT') || '',
            soVanBanDieuChinh: (0, _lodash.get)(this.state.thongTinChung, 'soVanBanDieuChinh') || undefined,
            ngayQuyetDinhDieuChinh: (0, _lodash.get)(this.state.thongTinChung, 'ngayQuyetDinhDieuChinh') || undefined,
            lyDoDieuChinh: (0, _lodash.get)(this.state.thongTinChung, 'lyDoDieuChinh') || undefined,
            loaiKeHoach: this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA'
          }
        };

        if (userInfo.capCoQuanQuanLyId === TTTrungUong) {
          params.keHoachThanhTra.trangThaiThanhTraTWPheDuyet = this.state.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' ? true : false;
        }

        if (name === 'luuTam') {
          params.sendToThanhTra = false;
        } else {
          params.sendToThanhTra = true;
        }
        if (this.state.cuocThanhTra.length) {
          params.cuocThanhTras = [];
        }

        if (this.state.thongTinChung.chucNangKeHoachThanhTra) {
          params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.thongTinChung.chucNangKeHoachThanhTra;
        }
        if (this.state.thongTinChung.ngayRaQuyetDinh) {
          params.keHoachThanhTra.ngayRaQuyetDinh = (0, _moment2.default)(this.state.thongTinChung.ngayRaQuyetDinh).toISOString();
        }
        if (this.state.oldData.keHoachThanhTraId) {
          params.keHoachThanhTra.keHoachThanhTraCu = { id: this.state.oldData.keHoachThanhTraId };
          params.keHoachThanhTra.quyetDinhPheDuyetKTTT = this.state.thongTinBS.quyetDinhPheDuyetKTTT || '';
          params.keHoachThanhTra.nguoiKy = this.state.thongTinBS.nguoiKy || '';
          params.keHoachThanhTra.ghiChu = this.state.thongTinBS.ghiChu || '';
          params.keHoachThanhTra.namThanhTra = this.state.oldData.namThanhTra || '';
          if (this.state.oldData.chucNangKeHoachThanhTra) {
            params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.oldData.chucNangKeHoachThanhTra;
          }
          if (this.state.thongTinBS.ngayRaQuyetDinh) {
            params.keHoachThanhTra.ngayRaQuyetDinh = (0, _moment2.default)(this.state.thongTinBS.ngayRaQuyetDinh).toISOString();
          }
        }
        this.state.cuocThanhTra.map(function (item) {
          var itemPushId = [];
          if (!(0, _lodash.isEmpty)(item.doiTuongThanhTraImport)) {
            item.doiTuongThanhTraImport.forEach(function (doiTuong) {
              itemPushId.push({
                id: doiTuong.id
              });
            });
          }
          if (item.cuocThanhTraNhieuDoiTuong) {
            if (!item.doiTuongThanhTras) {
              item.listDoiTuongThanhTra.forEach(function (items) {
                itemPushId.push({
                  id: items.doiTuongThanhTraId
                });
              });
            } else {
              item.doiTuongThanhTras.forEach(function (items) {
                itemPushId.push({
                  id: items.doiTuongThanhTraId || items.id
                });
              });
            }
          } else if (!item.doiTuongThanhTras && item.listDoiTuongThanhTra !== null) {
            item.listDoiTuongThanhTra.forEach(function (items) {
              itemPushId.push({
                id: items.doiTuongThanhTraId
              });
            });
          } else if (item.cuocThanhTraNhieuDoiTuong === false && item.doiTuongThanhTras && item.doiTuongThanhTras.length > 0) {
            item.doiTuongThanhTras.forEach(function (items) {
              itemPushId.push({
                id: items.doiTuongThanhTraId || items.id
              });
            });
          }
          var itemParams = {
            ten: item.ten,
            donViChuTriId: item.donViChuTriInfo.coQuanQuanLyId,
            donViPhoiHop: item.donViPhoiHop,
            thoiGianTienHanh: item.thoiGianTienHanh,
            cuocThanhTraNhieuDoiTuong: item.cuocThanhTraNhieuDoiTuong,
            cuocThanhTraMotDoiTuong: item.cuocThanhTraMotDoiTuong,
            doiTuongThanhTras: itemPushId,
            tenNhieuDoiTuongThanhTra: item.tenNhieuDoiTuongThanhTra ? item.tenNhieuDoiTuongThanhTra : '',
            kyThanhTra: item.kyThanhTra,
            linhVucThanhTraList: item.linhVucThanhTraList ? item.linhVucThanhTraList.map(function (item) {
              return (0, _lodash.isString)(item) ? item : item.giaTri;
            }) : null,
            chucNangCuocThanhTra: item.chucNangCuocThanhTraInfo && item.chucNangCuocThanhTraInfo.type ? item.chucNangCuocThanhTraInfo.type : null,
            noiDungThanhTra: item.noiDungThanhTra,
            kyTruocChuyenSang: item.kyTruocChuyenSang || false,
            daCoKetQuaDeXuat: false,
            phoiHopXuLy: item.phoiHopXuLy || false,
            thoiHanThanhTra: item.thoiHanThanhTra ? Number(item.thoiHanThanhTra) : 0,
            hinhThucThanhTraChuyenNganh: item.hinhThucThanhTraChuyenNganhInfo && item.hinhThucThanhTraChuyenNganhInfo.type ? item.hinhThucThanhTraChuyenNganhInfo.type : null,
            thucHienPhapLuatVeThanhTraList: item.linhVucThanhTraList && item.linhVucThanhTraList.map(function (item) {
              return (0, _lodash.isString)(item) ? item : item.giaTri;
            }).includes('THANH_TRA_TRACH_NHIEM') && item.thucHienPhapLuatVeThanhTraList ? item.thucHienPhapLuatVeThanhTraList.map(function (item) {
              return (0, _lodash.isString)(item) ? item : item.giaTri;
            }) : null,
            chiTietLinhVuc: item.chiTietLinhVuc ? item.chiTietLinhVuc : ''
          };

          if (item.id) {
            itemParams.id = item.id;
            _this4.props.dataDoiTuong.forEach(function (items) {
              if (items.idCTT === item.id) {
                itemParams.doiTuongThanhTraThemMoiIds = items.arrDoiTuongThemMoi;
                itemParams.doiTuongThanhTraDaXoaIds = items.arrDoiTuongXoa;
              }
            });
            _this4.props.dataDeXuat.forEach(function (items) {
              if (items.idDeXuatOld === item.id) {
                itemParams.daCoKetQuaDeXuat = items.hasDeXuatXuLy;
              }
            });
          }
          if (!item.tienDoThanhTraInfo && (item.isOld || item.keHoachThanhTraCuInfo) && _this4.state.oldData.keHoachThanhTraId) {
            itemParams.resetValue = true;
            itemParams.keHoachThanhTraCu = { id: _this4.state.oldData.keHoachThanhTraId };
          }
          params.cuocThanhTras.push(itemParams);
        });
        this.setState({ posting: true });
        if (this.state.detail.keHoachThanhTraId) {
          _api.ThanhTra.actions.updateKeHoachThanhTra.request({ id: this.state.detail.keHoachThanhTraId }, params).then(function (res) {
            if (res && res.data) {
              _this4.createDSTepDinhKem(res.data);
              _this4.removeFileDinhKem();
              _this4.props.dispatch({
                type: 'RESET_DATA'
              });
              (0, _toastr.Toastr)(_this4.checkIsKiemTra() ? _message.msg.updateKHKTSuccess : _message.msg.updateKHSuccess, 'success');
              setTimeout(function () {
                _reactRouter.browserHistory.goBack();
              }, 1000);
            }
            if (_this4.state.removeCuocTTList.length) {
              _api.ThanhTra.actions.deleteCuocThanhTraKHTT.request({ id: _this4.state.detail.keHoachThanhTraId }, { cuocThanhTras: _this4.state.removeCuocTTList }).then(function (res) {});
            }
            _this4.setState({ posting: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this4.setState({ posting: false });
          });
        } else if (params.keHoachThanhTra.keHoachThanhTraCu) {
          _api.ThanhTra.actions.postKeHoachThanhTra.request(null, params).then(function (res) {
            if (res && res.data) {
              _this4.createDSTepDinhKem(res.data);
              _this4.props.dispatch({
                type: 'RESET_DATA'
              });
              (0, _toastr.Toastr)(_this4.checkIsKiemTra() ? _message.msg.createKHKTSuccess : _message.msg.createKHSuccess, 'success');
              setTimeout(function () {
                _reactRouter.browserHistory.goBack();
              }, 1000);
            }
            _this4.setState({ posting: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this4.setState({ posting: false });
          });
        } else {
          var d = new Date();
          var getNam = d.getFullYear() + 1;
          _api.ThanhTra.actions.getValidateKeHoachThanhTra.request({
            id: '',
            namThanhTra: getNam,
            isKeHoachBoSung: false,
            loaiKeHoach: this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA'
          }).then(function (res) {
            if (res && res.status === 204) {
              _api.ThanhTra.actions.postKeHoachThanhTra.request(null, params).then(function (res) {
                if (res && res.data) {
                  _this4.createDSTepDinhKem(res.data);
                  _this4.props.dispatch({
                    type: 'RESET_DATA'
                  });
                  (0, _toastr.Toastr)(_this4.checkIsKiemTra() ? _message.msg.createKHKTSuccess : _message.msg.createKHSuccess, 'success');
                  setTimeout(function () {
                    _reactRouter.browserHistory.goBack();
                  }, 1000);
                }
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                }
                _this4.setState({ posting: false });
              });
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this4.setState({ posting: false });
            }
          });
        }
      }
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var data = this.state.dataFileDinhKem;

      if (!(0, _lodash.isEmpty)(data.dieuChinh)) {
        dataFileDinhKem = (0, _lodash.concat)(dataFileDinhKem, data.dieuChinh);
      }
      if (!(0, _lodash.isEmpty)(data.vanBan)) {
        dataFileDinhKem = (0, _lodash.concat)(dataFileDinhKem, data.vanBan);
      }
      return dataFileDinhKem;
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(data) {
      var listAddNew = [];
      var listUpdate = [];
      var dataFileDinhKem = this.getListDataFileDinhKem();
      if (!(0, _lodash.isEmpty)(dataFileDinhKem)) {
        dataFileDinhKem.map(function (item, i) {
          if (item.ten && item.duongDan) {
            var params = {
              keHoachThanhTra: { id: data.keHoachThanhTraId },
              loaiQuyTrinh: item.phanLoaiQuyTrinh === 'DIEU_CHINH_KE_HOACH_THANH_TRA' || item.loaiQuyTrinh === 'DIEU_CHINH_KE_HOACH_THANH_TRA' ? 'DIEU_CHINH_KE_HOACH_THANH_TRA' : 'KE_HOACH_THANH_TRA',
              nhomHoSo: item.nhomHoSo ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
            if (item.ten) {
              params.ten = item.ten;
            }
            if (item.tenFile) {
              params.tenFile = item.tenFile;
            }
            if (item.duongDan) {
              params.duongDan = item.duongDan;
            }
            if (item.typeRequired) {
              params.typeRequired = item.typeRequired;
            }
            if (item.required) {
              params.required = item.required;
            }
            if (item.soQuyetDinh) {
              params.soQuyetDinh = item.soQuyetDinh;
            }
            if (item.ngayQuyetDinh) {
              params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
            }
            if (item.taiLieuVanThuId) {
              params.id = item.taiLieuVanThuId;
              listUpdate.push(params);
            } else {
              listAddNew.push(params);
            }
          }
        });
        if (listAddNew.length) {
          _api.Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
        }
        if (listUpdate.length) {
          _api.Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
        }
      }
    }
  }, {
    key: 'removeFileDinhKem',
    value: function removeFileDinhKem() {
      this.state.dataFileDinhKemDelete.map(function (item) {
        _api.Reception.actions.deleteTepDinhKem.request({
          id: item
        });
      });
    }
  }, {
    key: 'handleChangeThongTinChung',
    value: function handleChangeThongTinChung(data) {
      this.setState({
        thongTinChung: data,
        hasChange: true
      });
    }
  }, {
    key: 'handleChangeThongTinBS',
    value: function handleChangeThongTinBS(data, isInit) {
      this.state.thongTinBS = data;
      if (!isInit) {
        this.state.hasChange = true;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeCuocThanhTra',
    value: function handleChangeCuocThanhTra(data) {
      this.setState({
        cuocThanhTra: data,
        hasChange: true,
        isSubmit: false,
        hasChangeCuocThanhTra: true
      });
    }
  }, {
    key: 'handleRemoveCuocTT',
    value: function handleRemoveCuocTT(idCTT) {
      this.state.removeCuocTTList.push({ id: idCTT });
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.state.isSubmit = true;
      this.setState(_extends({}, this.state));
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        this.props.dispatch({ type: 'DSTT_GO_BACK' });
        this.props.dispatch({ type: 'RESET_DATA' });
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.props.dispatch({ type: 'DSTT_GO_BACK' });
          this.props.dispatch({ type: 'RESET_DATA' });
          this.props.dispatch({ type: 'RESET_DEXUAT' });
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'getDetailKHTT',
    value: function getDetailKHTT(idKH) {
      var _this5 = this;

      this.setState({ loading: true });
      _api.ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(function (res) {
        if (res.data) {
          if (_this5.props.route.type == 'old') {
            res.data.cuocThanhTras.map(function (item) {
              item.isOld = true;
            });
            _this5.state.oldData = res.data;
            _this5.state.cuocThanhTra = res.data.cuocThanhTras;
          } else {
            _this5.state.detail = res.data;
            _this5.state.cuocThanhTra = res.data.cuocThanhTras;
            if (res.data.keHoacThanhTraCuInfo) {
              _this5.state.thongTinBS = res.data;
              _this5.state.oldData = res.data.keHoacThanhTraCuInfo;
              _this5.state.tabType = 'old';
            } else {
              _this5.state.thongTinChung = res.data;
            }
            _this5.state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
            _this5.state.saveTamKeHoachTT = res.data.saveTamKeHoachTT;
          }
          if (res.data.trangThaiThanhTraTWPheDuyet === true) {
            _this5.state.trangthaiKHTT = 'NHAP_KHTT_PHE_DUYET';
          }
          _this5.state.showUpload = true;
          res.data.listTaiLieuVanThu.map(function (item, i) {
            _this5.state.inputFileDinhKem[i] = {
              taiLieuVanThuId: item.taiLieuVanThuId,
              ten: item.ten,
              tenFile: item.tenFile,
              required: item.required || false,
              duongDan: item.duongDan,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).toISOString() : '',
              soQuyetDinh: item.soQuyetDinh || '',
              loaiTepDinhKem: item.loaiTepDinhKem || '',
              nhomHoSoInfo: item.nhomHoSoInfo || null
            };
          });
          _this5.setState(_extends({}, _this5.state, { isKiemTra: (0, _lodash.get)(res, 'data.loaiKeHoach.value') === 'KIEM_TRA' }));
        }
        _this5.setState({ loading: false });
      }).catch(function (err) {
        _this5.setState({ loading: false });
      });
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      this.state[name] = status;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'viewAllKeHoachTT',
    value: function viewAllKeHoachTT(searchKey) {
      this.state.searchKeyKHTT = searchKey;
      this.toggleDialog('isOpenSearchKHTT', true);
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.props.dispatch({ type: 'DSTT_GO_BACK' });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'handleChangeTrangThaiKHTT',
    value: function handleChangeTrangThaiKHTT(e) {
      this.setState({
        trangthaiKHTT: e.target.value
      });
    }
  }, {
    key: 'handleHoanThanh',
    value: function handleHoanThanh() {
      if (this.validateSubmitForm()) {
        this.handleSave();
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      if (this.state.hasChangeCuocThanhTra) {
        this.setState({
          isOpen: true
        });
      } else {
        var detail = this.state.detail;

        var keHoachId = (0, _lodash.get)(detail, 'keHoachThanhTraId');
        var URL = String(_config.API_URL) + '/keHoachThanhTras/cuocThanhTras/xuatExcel?id=' + keHoachId;
        (0, _exportExcel.exportExcel)(URL, 'danh-muc-cuoc-thanh-tra.xlsx');
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var getThongTinKHTTDCQD = this.props.location && this.props.location.state;
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var displayButtonCreate = (this.state.detail.saveTamKeHoachTT == false || this.state.tabType == 'old') && (this.state.thongTinChung.quyetDinhPheDuyetKTTT || this.state.thongTinBS.quyetDinhPheDuyetKTTT) && (this.state.thongTinChung.ngayRaQuyetDinh || this.state.thongTinBS.ngayRaQuyetDinh) && this.state.activeTaoCuocThanhTra == false;
      var displayButtonSent = Number(userInfo.donViId) !== Number(this.state.thanhTraThanhPhoId) && this.state.sendToThanhTra === false && this.state.tabType !== 'old';
      var TTTrungUong = 19;
      var detail = this.state.detail;

      var isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong ? true : false;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container panel-page' },
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.isOpen,
              onClose: this.closeDialog.bind(this, 'isOpen'),
              title: 'Th\xF4ng b\xE1o',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'p',
                { className: 'reception-dialog-text' },
                'B\u1EA1n c\u1EA7n l\u01B0u nh\u1EEFng thay \u0111\u1ED5i tr\u01B0\u1EDBc khi xu\u1EA5t file excel'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-footer-actions reception-delete-confirm' },
                _react2.default.createElement(_core.Button, {
                  onClick: this.closeDialog.bind(this),
                  text: '\u0110\xF3ng',
                  className: 'btn-default'
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleClose.bind(this), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading tttu-content' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              this.state.titlePage
            ),
            isTTTW && this.state.tabType === 'new' && _react2.default.createElement(
              'div',
              { className: 'tttu-right-content' },
              _react2.default.createElement(_ttForms.RadioButtonChonTrangThaiKHTT, { disable: this.state.tableLoading, selectedValue: this.state.trangthaiKHTT, onChange: this.handleChangeTrangThaiKHTT.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content main_page' },
            _react2.default.createElement(_subView.ThongTinChung, { isKiemTra: this.checkIsKiemTra(), isTTTW: isTTTW, bindValidator: this, trangthaiKHTT: this.state.trangthaiKHTT, keHoach: getThongTinKHTTDCQD, onChange: this.handleChangeThongTinChung.bind(this), onChangeBS: this.handleChangeThongTinBS.bind(this), dataDC: this.state.thongTinChung, data: this.state.detail, tabType: this.state.tabType, onFileChange: this.onFileChange.bind(this), onFileRemove: this.onFileRemove.bind(this) }),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement('span', { className: 'line-border mt5 mb20' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.tabType == 'old' },
              _react2.default.createElement(
                'section',
                { className: 'wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-13 col-100 pl20 pr20 pb15' },
                    '1.1 Th\xF4ng tin k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' c\u0169'
                  )
                ),
                this.state.oldData.quyetDinhPheDuyetKTTT != '' ? _react2.default.createElement(
                  'div',
                  { className: 'row pl25 pr25' },
                  _react2.default.createElement(_common.TextMessage, {
                    label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT:',
                    value: this.state.oldData.quyetDinhPheDuyetKTTT || '' }),
                  _react2.default.createElement(_common.TextMessage, {
                    label: 'Ng\xE0y ph\xEA duy\u1EC7t:',
                    value: this.state.oldData.ngayRaQuyetDinh ? (0, _moment2.default)(this.state.oldData.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.TextMessage, {
                    label: 'N\u0103m ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':',
                    value: this.state.oldData.namThanhTra || '' }),
                  _react2.default.createElement(_common.TextMessage, {
                    label: 'Ng\u01B0\u1EDDi k\xFD:',
                    value: this.state.oldData.nguoiKy || '' })
                ) : ''
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement('span', { className: 'line-border mt5 mb20' })
              )
            ),
            _react2.default.createElement(_subView.DanhSachCuocThanhTra, {
              keHoach: getThongTinKHTTDCQD,
              namKeHoachThanhTra: this.state.thongTinChung.namThanhTra ? this.state.thongTinChung.namThanhTra : this.state.oldData.namThanhTra,
              bindValidator: this,
              onRemove: this.handleRemoveCuocTT.bind(this),
              tabType: this.state.tabType,
              onChange: this.handleChangeCuocThanhTra.bind(this),
              data: this.state.detail,
              oldData: this.state.oldData,
              isSubmit: this.state.isSubmit,
              chucNangKeHoachThanhTra: this.state.thongTinChung.chucNangKeHoachThanhTra,
              handleExport: this.handleExport.bind(this),
              isKiemTra: this.checkIsKiemTra()
            }),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement('span', { className: 'big-border mt5 mb20' })
            ),
            this.state.showUpload ? _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { isDsVanBanXuLy: true, label: '2. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, bindValidator: this, data: this.state.inputFileDinhKem, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            ) : ''
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt35 pb5' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !(0, _lodash.get)(getThongTinKHTTDCQD, 'keHoachDaCoQuyetDinh') },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-save btn-green ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.handleSave.bind(this, 'luuTam') },
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: displayButtonCreate && this.state.loading == false || this.state.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' && (0, _lodash.get)(detail, 'trangThaiKeHoachThanhTra') !== "DA_CO_QUYET_DINH" },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { style: { right: 0 }, className: 'btn-action btn-green warning right ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.taoCuocThanhTra.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    'Tri\u1EC3n khai KHTT'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: displayButtonSent && this.state.loading == false && this.state.trangthaiKHTT !== 'NHAP_KHTT_PHE_DUYET' && (0, _lodash.get)(detail, 'trangThaiKeHoachThanhTra') !== "CHO_RA_QUYET_DINH" && (0, _lodash.get)(detail, 'trangThaiKeHoachThanhTra') !== "DA_CO_QUYET_DINH" },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', style: { right: 0 }, className: 'btn-action btn-move btn-green right ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.guiThanhTraTP.bind(this) },
                  'G\u1EEDi Thanh tra t\u1EC9nh'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tabType === 'edit' && (0, _lodash.get)(detail, 'trangThaiKeHoachThanhTra') === "DA_CO_QUYET_DINH" },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', style: { right: 0 }, className: 'btn-action btn-move btn-green right ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.handleHoanThanh.bind(this) },
                  'Ho\xE0n th\xE0nh'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThemMoiKeHoachThanhTra;
}(_react2.default.Component);

ThemMoiKeHoachThanhTra.defaultProps = {
  validators: {},
  dataDoiTuong: []
};

function bindStateToProps(state) {
  return {
    dataDeXuat: state.dataCuocThanhTra.dataDXOld,
    dataDoiTuong: state.dataCuocThanhTra.dataDoiTuong
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ThemMoiKeHoachThanhTra);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _datatable = __webpack_require__(52);

var _toastr = __webpack_require__(11);

var _ttForms = __webpack_require__(19);

var _lodash = __webpack_require__(14);

var _message = __webpack_require__(10);

var _config = __webpack_require__(16);

var _downloadExcel = __webpack_require__(170);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _exportExcel = __webpack_require__(113);

__webpack_require__(372);

var _common2 = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemMoiDoiTuongThanhTra = function (_React$Component) {
  _inherits(ThemMoiDoiTuongThanhTra, _React$Component);

  function ThemMoiDoiTuongThanhTra(props, context) {
    _classCallCheck(this, ThemMoiDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (ThemMoiDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(ThemMoiDoiTuongThanhTra)).call(this, props, context));

    _this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    _this.state = {
      checked: false,
      // checkDonViPhoiHop: false,
      namThanhTra: '',
      duongDan: '',
      tenFile: '',
      isOpen: false,
      isOpenThongBao: false,
      getTenDoiTuong: [],
      getDSDTDeXuatXuLys: [],
      idPushCoQuan: [],
      isOpenDT: false,
      loading: false,
      isOpenThanhTra: false,
      linhVucId: '',
      nhomDoiTuongThanhTraId: '',
      tuKhoa: '',
      maSoThue: '',
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      hinhThucKHTTList: [],
      dataLinhVucThanhTra: [],
      type: _this.props.type,
      showDoiTuongThanhTra: false,
      danhSachDonViPhoiHop: [],
      dataDoiTuongViPhamHienTai: [],
      doiTuongThanhTra: '',
      donViPhoiHop: '',
      kyThanhTra: '',
      doiTuongThanhTras: [],
      data: {
        doiTuongThanhTraInfo: {},
        ten: '',
        doiTuongThanhTra: '',
        doiTuongThanhTras: [],
        tenNhieuDoiTuongThanhTra: '',
        thoiGianTienHanh: '',
        cuocThanhTraNhieuDoiTuong: false,
        tenMotDoiTuongThanhTra: '',
        cuocThanhTraNhieuDoiTuongList: {
          text: (_this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra') + ' nhi\u1EC1u \u0111\u1ED1i t\u01B0\u1EE3ng',
          type: 'true'
        },
        linhVucThanhTraList: [],
        thucHienPhapLuatVeThanhTraList: [],
        chiTietLinhVuc: '',
        hinhThucThanhTraChuyenNganhInfo: {
          text: '',
          type: ''
        },
        chucNangCuocThanhTraInfo: {
          text: 'Hành Chính',
          type: 'HANH_CHINH'
        },
        donViPhoiHop: '',
        donViChuTri: _this.userInfo.donViId,
        tenDonViChuTriInfo: _this.userInfo.tenCoQuanQuanLy,
        donViChuTriInfo: {
          coQuanQuanLyId: _this.userInfo.donViId,
          ten: _this.userInfo.tenCoQuanQuanLy
        }
      },
      noiDungThanhTra: '',
      thoiHanThanhTra: '',
      kyTruocChuyenSang: false,
      linhVucList: [],
      nhomDTList: [],
      dataDonViChuTri: [],
      hinhThucThanhTraChuyenNganhList: [],
      chucNangKeHoachThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      doiTuongThanhTraImport: [],

      //confirm
      confirmDoiTuongViPham: false,
      tenDoiTuongViPhamConfirm: '',
      confirmDoiTuongLienQuan: false,
      tenDoiTuongLienQuanConfirm: '',
      thucHienPhapLuatVeThanhTraListCombobox: [],
      cuocThanhTraNhieuDoiTuongList: [{
        giaTri: 'true',
        ten: (_this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra') + ' nhi\u1EC1u \u0111\u1ED1i t\u01B0\u1EE3ng'
      }, {
        giaTri: 'false',
        ten: (_this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra') + ' m\u1ED9t \u0111\u1ED1i t\u01B0\u1EE3ng'
      }],
      doiTuongSelected: [],
      newTempDoiTuongSelected: [],
      loadingImport: false,
      errorImport: false,
      numberUnsuccess: 0,
      base64Content: '',
      fileName: '',
      mineType: '',
      validLinhVucThanhTra: true
    };
    return _this;
  }

  _createClass(ThemMoiDoiTuongThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVuc();
      this.getNhomDoiTuong();
      this.getDonViChuTri();
      this.getHinhThucThanhTraChuyenNganh();
      this.getThucHienPhapLuatVeTT();
      this.determinativeVaiTro();
      this.getChucNangCuocThanhTra();
      this.getHinhThucKeHoachThanhTra();
      this.getLinhVucThanhTra();
      this.getDoiTuongThanhTra();
      this.getDSDTDeXuatXuLy();
      this.getQuanHuyen();
    }
  }, {
    key: 'getDSDTDeXuatXuLy',
    value: function getDSDTDeXuatXuLy() {
      var _this2 = this;

      _api.ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: 0 }).then(function (res) {
        var getDSDTDeXuatXuLys = [];
        if (res && res.data) {
          res.data.map(function (item) {
            if (item) {
              getDSDTDeXuatXuLys.push(item.dttt.id);
            }
          });
        }
        _this2.setState({ getDSDTDeXuatXuLys: getDSDTDeXuatXuLys });
      });
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      if (typeof this.userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.state.data.donViChuTri = this.userInfo.donViId;
      }
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataLinhVucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getHinhThucKeHoachThanhTra',
    value: function getHinhThucKeHoachThanhTra() {
      var _this4 = this;

      _api.ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(function (res) {
        if (res.data) {
          _this4.state.hinhThucKHTTList = res.data;
        } else {
          _this4.state.hinhThucKHTTList = [];
        }
        _this4.setState(_extends({}, _this4.state));
      });
    }
  }, {
    key: 'showDoiTuongThanhTra',
    value: function showDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: true
      });
    }
  }, {
    key: 'hideDoiTuongThanhTra',
    value: function hideDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: false
      });
    }
  }, {
    key: 'setDoiTuongViPhamHienTai',
    value: function setDoiTuongViPhamHienTai(data) {
      this.setState({
        dataDoiTuongViPhamHienTai: data
      });
    }
  }, {
    key: 'handleConfirmDoiTuongViPham',
    value: function handleConfirmDoiTuongViPham(state) {
      var data = [].concat(_toConsumableArray(this.state.dataDoiTuongViPhamHienTai));
      var dataFilter = data.filter(function (item) {
        return state.ten == item.ten;
      });

      if (dataFilter.length > 0) {
        this.setState({
          confirmDoiTuongViPham: true,
          tenDoiTuongViPhamConfirm: state.ten
        });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this5 = this;

      if (nextProps.data) {
        this.state.data = {};
        this.state.data = _extends({}, nextProps.data, {
          donViChuTriInfo: _extends({}, nextProps.data.donViChuTriInfo),
          linhVucThanhTraInfo: _extends({}, nextProps.data.linhVucThanhTraInfo),
          doiTuongThanhTras: nextProps.data.doiTuongThanhTras ? [].concat(_toConsumableArray(nextProps.data.doiTuongThanhTras)) : [],
          hinhThucThanhTraChuyenNganhInfo: _extends({}, nextProps.data.hinhThucThanhTraChuyenNganhInfo),
          thucHienPhapLuatVeThanhTraInfo: _extends({}, nextProps.data.thucHienPhapLuatVeThanhTraInfo)
        });
        this.state.chucNangKeHoachThanhTra = nextProps.data.chucNangKeHoachThanhTra || '';
        var arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(',') : [];
        this.state.danhSachDonViPhoiHop = [];
        arrDv.map(function (item) {
          _this5.state.danhSachDonViPhoiHop.push({ ten: item });
        });
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this6 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data._embedded) {
          _this6.setState({
            dataDonViChuTri: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThanhTraChuyenNganh',
    value: function getHinhThucThanhTraChuyenNganh() {
      var _this7 = this;

      _api.ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(function (res) {
        if (res.data) {
          _this7.setState({
            hinhThucThanhTraChuyenNganhList: res.data
          });
        }
      });
    }
  }, {
    key: 'getThucHienPhapLuatVeTT',
    value: function getThucHienPhapLuatVeTT() {
      var _this8 = this;

      _api.ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            thucHienPhapLuatVeThanhTraListCombobox: res.data
          });
        }
      });
    }
  }, {
    key: 'suggesttion',
    value: function suggesttion(dataSearch) {
      var _this9 = this;

      this.setState({
        isSearch: true
      }, function () {
        var params = {
          tuKhoa: dataSearch
        };

        if (_this9.state.doiTuongThanhTra) {
          params.doiTuongIds = _this9.state.doiTuongThanhTra;
        }
        _api.Danhmuc.actions.getDoiTuongThanhTra.request(params).then(function (res) {
          if (res.data._embedded) {
            _this9.setState({
              dataSuggest: res.data._embedded.doiTuongThanhTras,
              isSearch: false
            });
          } else {
            _this9.setState({
              dataSuggest: [],
              isSearch: false
            });
          }
        });
      });
    }
  }, {
    key: 'getDoiTuongThanhTra',
    value: function getDoiTuongThanhTra() {
      var _this10 = this;

      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      _api.ThanhTra.actions.getDoiTuongThanhTra.request({ namThanhTra: getNamTT }).then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
          });
        }
      });
    }
  }, {
    key: 'getQuanHuyen',
    value: function getQuanHuyen() {
      var _this11 = this;

      _api.DuLieuHeThong.actions.getQuanHuyen.request().then(function (res) {
        if (res.data._embedded) {
          _this11.setState({
            dsQuanHuyen: res.data._embedded.donViHanhChinhs
          });
        }
      });
    }
  }, {
    key: 'getPhuongXa',
    value: function getPhuongXa() {
      var _this12 = this;

      var quanHuyenId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (quanHuyenId) {
        _api.DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(function (res) {
          _this12.setState({
            dsPhuongXa: (0, _lodash.get)(res, 'data._embedded.donViHanhChinhs') || []
          });
        });
      }
    }
  }, {
    key: 'getLinhVuc',
    value: function getLinhVuc() {
      var _this13 = this;

      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this13.state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
        } else {
          _this13.state.linhVucList = [];
        }
        _this13.setState(_extends({}, _this13.state));
      });
    }
  }, {
    key: 'getNhomDoiTuong',
    value: function getNhomDoiTuong() {
      var _this14 = this;

      _api.ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(function (res) {
        var nhomDTList = [];
        if (res.data && res.data._embedded) {
          nhomDTList = res.data._embedded.nhomDoiTuongThanhTras;
        }
        _this14.setState({ nhomDTList: nhomDTList });
      });
    }
  }, {
    key: 'changeCheckbox',
    value: function changeCheckbox(e) {
      this.state.data[e.target.name] = e.target.checked;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'timKiem',
    value: function timKiem(statusTimKiem) {
      var _this15 = this;

      this.state.checkAll = false;
      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      var pageData = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      var params = {
        pageData: pageData,
        namThanhTra: getNamTT
      };

      if (statusTimKiem) {
        params.pageData.page = 0;
      }

      if (!(0, _lodash.isEmpty)(this.state.doiTuongThanhTras)) {
        var idsDoiTuong = this.state.doiTuongThanhTras.map(function (item) {
          return item.id;
        });
        this.state.doiTuongSelectedList.forEach(function (item) {
          idsDoiTuong.push(item.doiTuongThanhTraId);
        });
        params.idDoiTuongDaCoCuocs = idsDoiTuong;
      } else {
        var _idsDoiTuong = [];
        this.state.doiTuongSelectedList.forEach(function (item) {
          _idsDoiTuong.push(item.doiTuongThanhTraId);
        });
        params.idDoiTuongDaCoCuocs = _idsDoiTuong;
      }

      if (this.state.tuKhoa) {
        params.tenDoiTuong = this.state.tuKhoa;
      }
      if (this.state.linhVucId) {
        params.linhVucId = this.state.linhVucId;
      }
      if (this.state.nhomDoiTuongThanhTraId) {
        params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
      }
      if (this.state.diaChi) {
        params.tuKhoa = this.state.diaChi;
      }
      if (this.state.quanHuyenId) {
        params.quanHuyenId = Number(this.state.quanHuyenId);
      }
      if (this.state.phuongXaId) {
        params.phuongXaId = Number(this.state.phuongXaId);
      }
      if (!(0, _lodash.isEmpty)(this.state.maSoThue)) {
        params.maSoThue = this.state.maSoThue;
      }

      this.setState({ tableLoading: true });
      _api.Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(function (res) {
        if (res.data._embedded) {
          var data = (0, _lodash.get)(res, 'data._embedded.doiTuongThanhTras');
          if (!(0, _lodash.isEmpty)(_this15.state.totalSelectedList) && (0, _lodash.isArray)(_this15.state.totalSelectedList)) {
            var newData = data.map(function (item) {
              _this15.state.totalSelectedList.forEach(function (itemDoiTuong) {
                if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                  item.selected = true;
                }
              });
              return item;
            });
            data = newData;
          }
          _this15.setState({
            ketQuaTimKiemList: data,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this15.setState({
            ketQuaTimKiemList: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      var newTempDoiTuongSelected = [];
      var doiTuongSelectedList = [];
      this.setState(_defineProperty({
        newTempDoiTuongSelected: newTempDoiTuongSelected,
        doiTuongSelectedList: doiTuongSelectedList
      }, name, false));
    }
  }, {
    key: 'closeDialogThongBao',
    value: function closeDialogThongBao() {
      this.setState({
        isOpenThongBao: false
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.timKiem(true);
      this.state.totalSelectedList = [];
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'openDialogThanhTra',
    value: function openDialogThanhTra() {
      this.setState({
        isOpenThanhTra: true,
        validLinhVucThanhTra: true
      });
    }
  }, {
    key: 'onChangeMaSoThue',
    value: function onChangeMaSoThue(e) {
      this.state.maSoThue = e.target.value;
    }
  }, {
    key: 'onChangeTuKhoa',
    value: function onChangeTuKhoa(e) {
      this.state.tuKhoa = e.target.value;
    }
  }, {
    key: 'onChangeDiaChi',
    value: function onChangeDiaChi(e) {
      this.state.diaChi = e.target.value;
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var state = this.state;
      this.props.validators['thanhTra'] = [];
      if (name == 'ten') {
        state.data.ten = e.target.value;
      } else if (name == 'chiTietLinhVuc') {
        state.data.chiTietLinhVuc = e.target.value;
      } else if (name == 'linhVucId') {
        state.linhVucId = e.target.value;
      } else if (name == 'nhomDoiTuongThanhTraId') {
        state.nhomDoiTuongThanhTraId = e.target.value;
      } else if (name == 'tenNhieuDoiTuongThanhTra') {
        state.data.tenNhieuDoiTuongThanhTra = e.target.value;
      } else if (name == 'doiTuongThanhTra') {
        state.data.doiTuongThanhTra = e.target.value;
      } else if (name == 'donViPhoiHop') {
        state.donViPhoiHop = e.target.value;
      } else if (name == 'phamViThanhTra') {
        state.kyThanhTra = e.target.value;
      } else if (name == 'thoiGianTienHanh') {
        state.data.thoiGianTienHanh = e.target.value;
      } else if (name == 'thoiHanThanhTra') {
        state.thoiHanThanhTra = e.target.value;
      } else if (name == 'noiDungThanhTra') {
        state.noiDungThanhTra = e.target.value;
      } else if (name == 'donViChuTri') {
        state.data.donViChuTri = e.target.value;
        _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
          if (res.data && res.data._embedded) {
            res.data._embedded.coQuanQuanLies.map(function (item) {
              if (item.coQuanQuanLyId == e.target.value) {
                state.data.donViChuTriInfo.ten = item.ten;
              }
            });
          }
        });
      } else if (name == 'chucNangCuocThanhTra') {
        state.data.chucNangCuocThanhTraInfo.type = e.target.value;
      } else if (name == 'hinhThucThanhTraChuyenNganh') {
        state.data.hinhThucThanhTraChuyenNganhInfo.type = e.target.value;
      } else if (name == 'linhVucThanhTraList') {
        state.data.linhVucThanhTraList = e.map(function (item) {
          return item.value;
        });
        state.validLinhVucThanhTra = true;
      } else if (name == 'thucHienPhapLuatVeThanhTraList') {
        state.data.thucHienPhapLuatVeThanhTraList = e.map(function (item) {
          return item.value;
        });
      } else if (name == 'quanHuyenId') {
        if (!e.target.value) {
          state.quanHuyenId = e.target.value;
          state.phuongXaId = '';
          state.dsPhuongXa = [];
        } else {
          state.quanHuyenId = e.target.value;
          state.phuongXaId = '';
          this.getPhuongXa(e.target.value);
        }
      } else if (name == 'phuongXaId') {
        state.phuongXaId = e.target.value;
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      this.setState(state);
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['thanhTra'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(arr, value, e) {
      var _this16 = this;

      if (arr === 'doiTuongThanhTras' && typeof value != 'undefined') {
        value.preventDefault();
      } else if (arr === 'danhSachDonViPhoiHop' && typeof e != 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == _this16.state[value];
      });

      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState4;

          var newItem = {
            ten: this.state[value]
          };
          this.setState((_setState4 = {}, _defineProperty(_setState4, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState4, value, ''), _setState4));
        }
      }
      return;
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.timKiem();
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.timKiem();
    }
  }, {
    key: 'hanldeRemove',
    value: function hanldeRemove(index) {
      this.state.doiTuongSelectedList.splice(index, 1);
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(arr, index) {
      var newData = [].concat(_toConsumableArray(this.state[arr]));
      newData.splice(index, 1);
      if (arr === 'doiTuongThanhTras' && newData.length > 1) {
        this.state.data.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.data.cuocThanhTraNhieuDoiTuong = false;
      }
      this.setState(_extends({}, this.state, _defineProperty({}, arr, newData)));
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['editCuocTT'].map(function (validator) {
        if (pass) pass = validator.validate();else {
          validator.validate();
        }
      });
      if (this.state.doiTuongThanhTras.length === 0 && this.state.doiTuongThanhTraImport.length === 0) {
        (0, _toastr.Toastr)('Ph\u1EA3i ch\u1ECDn \xEDt nh\u1EA5t m\u1ED9t \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), 'error');
        pass = false;
      }
      if (this.state.data.chucNangCuocThanhTraInfo.type === 'HANH_CHINH' && (0, _lodash.isEmpty)(this.state.data.linhVucThanhTraList)) {
        this.setState({ validLinhVucThanhTra: false });
        pass = false;
      }
      return pass;
    }
  }, {
    key: 'handleSaveThanhTra',
    value: function handleSaveThanhTra() {
      var _this17 = this;

      if (this.validateSubmitForm()) {
        var newItem = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
        var newItems = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
        var newListDoiTuong = [];
        var doiTuongSelected = this.state.doiTuongSelected;

        var getNewItems = [];
        this.state.doiTuongSelectedList.forEach(function (items) {
          newItem.push({
            id: items.doiTuongThanhTraId,
            ten: items.ten
          });
        });

        var listDV = [];
        if (this.state.danhSachDonViPhoiHop) {
          this.state.danhSachDonViPhoiHop.forEach(function (item) {
            listDV.push(item.ten);
          });
          this.state.data.donViPhoiHop = listDV.join('; ');
        }

        //hinhThucThanhTraChuyenNganh
        var checkHTTTCN = this.state.hinhThucThanhTraChuyenNganhList.findIndex(function (item) {
          return item.giaTri == _this17.state.data.hinhThucThanhTraChuyenNganhInfo.type;
        });
        if (checkHTTTCN !== -1) this.state.data.hinhThucThanhTraChuyenNganhInfo.text = this.state.hinhThucThanhTraChuyenNganhList[checkHTTTCN].ten;
        //ChucNangCuocThanhTra
        var checkCNCTT = this.state.dataChucNangCuocThanhTra.findIndex(function (item) {
          return item.giaTri == _this17.state.data.chucNangCuocThanhTraInfo.type;
        });
        if (checkCNCTT !== -1) this.state.data.chucNangCuocThanhTraInfo.text = this.state.dataChucNangCuocThanhTra[checkCNCTT].ten;
        //get doiTuongThanhTra
        if (this.state.data.cuocThanhTraNhieuDoiTuong === false) {
          var indexItem = this.state.dataDoiTuongThanhTra.findIndex(function (item) {
            return item.doiTuongThanhTraId === (0, _lodash.get)(newItem, '[0].id');
          });
          if (indexItem !== -1) {
            this.state.data.doiTuongThanhTraInfo = this.state.dataDoiTuongThanhTra[indexItem];
          }
        } else {
          this.state.data.doiTuongThanhTraInfo = null;
          newItems.map(function (item) {
            var itemIndex = _this17.state.dataDoiTuongThanhTra.filter(function (tempItem) {
              return tempItem.doiTuongThanhTraId === item.id || tempItem.doiTuongThanhTraId === item.doiTuongThanhTraId;
            });
            if (itemIndex.length > 0) {
              getNewItems.push(itemIndex[0]);
            }
          });
        }

        if (!(0, _lodash.isEmpty)(newItem)) {
          doiTuongSelected.forEach(function (item) {
            newItem.forEach(function (newItem) {
              if (item.doiTuongThanhTraId === newItem.id) {
                newListDoiTuong.push(item);
              }
            });
          });
        }

        var itemParams = {
          // Data import đối tượng thanh tra this.state.doiTuongThanhTraImport
          doiTuongThanhTraImport: this.state.doiTuongThanhTraImport,
          duongDan: this.state.duongDan,
          tenFile: this.state.tenFile,
          cuocThanhTraNhieuDoiTuong: this.state.data.cuocThanhTraNhieuDoiTuong,
          ten: this.state.data.ten ? this.state.data.ten : '',
          tenNhieuDoiTuongThanhTra: this.state.data.tenNhieuDoiTuongThanhTra ? this.state.data.tenNhieuDoiTuongThanhTra : '',
          tenMotDoiTuongThanhTra: this.state.data.tenMotDoiTuongThanhTra ? this.state.data.tenMotDoiTuongThanhTra : '',
          doiTuongThanhTras: newItem,
          doiTuongThanhTrasList: newListDoiTuong,
          donViChuTriId: this.state.data.donViChuTri,
          tenDonViChuTriInfo: this.state.data.donViChuTriInfo.ten ? this.state.data.donViChuTriInfo.ten : '',
          donViPhoiHop: this.state.data.donViPhoiHop ? this.state.data.donViPhoiHop : '',
          kyThanhTra: this.state.kyThanhTra,
          doiTuongThanhTraInfo: this.state.data.doiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo : null,
          thoiGianTienHanh: this.state.data.thoiGianTienHanh ? this.state.data.thoiGianTienHanh : '',
          linhVucThanhTraList: this.state.data.linhVucThanhTraList ? this.state.data.linhVucThanhTraList : null,
          noiDungThanhTra: this.state.noiDungThanhTra,
          kyTruocChuyenSang: this.state.kyTruocChuyenSang || false,
          thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
          chucNangCuocThanhTraInfo: this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo : {},
          hinhThucThanhTraChuyenNganh: this.state.hinhThucThanhTraChuyenNganhInfo && this.state.hinhThucThanhTraChuyenNganhInfo.type ? this.state.hinhThucThanhTraChuyenNganhInfo.type : null,
          hinhThucThanhTraChuyenNganhInfo: this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo : {},
          thucHienPhapLuatVeThanhTraInfo: this.state.data.thucHienPhapLuatVeThanhTraInfo ? this.state.data.thucHienPhapLuatVeThanhTraInfo : {},
          thucHienPhapLuatVeThanhTra: this.state.data.thucHienPhapLuatVeThanhTraInfo && this.state.data.thucHienPhapLuatVeThanhTraInfo.type ? this.state.data.thucHienPhapLuatVeThanhTraInfo.type : null,
          thucHienPhapLuatVeThanhTraList: this.state.data.thucHienPhapLuatVeThanhTraList ? this.state.data.thucHienPhapLuatVeThanhTraList : null,
          chiTietLinhVuc: this.state.data.chiTietLinhVuc ? this.state.data.chiTietLinhVuc : ''
        };
        this.props.saveThanhTra(itemParams);

        // dataDoiTuongThanhTras
        this.setState({
          noiDungThanhTra: '',
          thucHienPhapLuatVeThanhTra: '',
          hinhThucThanhTraChuyenNganh: '',
          danhSachDonViPhoiHop: [],
          kyTruocChuyenSang: false,
          doiTuongThanhTraImport: [],
          duongDan: '',
          tenFile: '',
          donViPhoiHop: '',
          donViChuTriInfo: {
            coQuanQuanLyId: null,
            ten: ''
          },
          isOpenThanhTra: false,
          chucNangKeHoachThanhTra: '',
          doiTuongThanhTras: [],
          data: {
            ten: '',
            doiTuongThanhTras: [],
            doiTuongThanhTra: '',
            tenNhieuDoiTuongThanhTra: '',
            thoiGianTienHanh: '',
            cuocThanhTraNhieuDoiTuongList: {
              text: (this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra') + ' nhi\u1EC1u \u0111\u1ED1i t\u01B0\u1EE3ng',
              type: 'true'
            },
            chucNangCuocThanhTraInfo: {
              text: 'Hành Chính',
              type: 'HANH_CHINH'
            },
            linhVucThanhTraList: [],
            thucHienPhapLuatVeThanhTraList: [],
            chiTietLinhVuc: '',
            hinhThucThanhTraChuyenNganhInfo: {
              text: '',
              type: ''
            },
            donViChuTri: this.userInfo.donViId,
            tenDonViChuTriInfo: this.userInfo.tenCoQuanQuanLy,
            donViChuTriInfo: {
              coQuanQuanLyId: this.userInfo.donViId,
              ten: this.userInfo.tenCoQuanQuanLy
            }
          },
          thoiHanThanhTra: '',
          kyThanhTra: '',
          linhVucId: '',
          nhomDoiTuongThanhTraId: '',
          tuKhoa: '',
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          ketQuaTimKiemList: [],
          tableLoading: false,
          doiTuongSelectedList: [],
          checkAll: false,
          totalSelectedList: []
        });
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var newItem = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
      var newTempDoiTuongSelected = [].concat(_toConsumableArray(this.state.newTempDoiTuongSelected));
      this.state.doiTuongSelectedList.forEach(function (items) {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });
      if (newItem.length > 1) {
        this.state.data.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.data.cuocThanhTraNhieuDoiTuong = false;
      }
      this.setState({
        doiTuongSelected: newTempDoiTuongSelected,
        doiTuongThanhTras: newItem,
        isOpen: false
      });
      this.state.doiTuongSelectedList = [];
    }
  }, {
    key: 'kiemTraTenDoiTuong',
    value: function kiemTraTenDoiTuong(idDoiTuong, check) {
      var _this18 = this;

      var d = new Date();
      var getNam = d.getFullYear() + 1;
      var getTenDoiTuong = '';
      _api.ThanhTra.actions.getKiemTraDoiTuongTT.request({
        doiTuongThanhTraId: idDoiTuong,
        namThanhTra: getNam
      }).then(function (res) {
        if (res && res.data) {
          var idPushCoQuan = [];
          res.data._embedded.coQuanQuanLies.map(function (items) {
            idPushCoQuan.push(items.ten);
          });
          var tenDoituong = _this18.state.ketQuaTimKiemList.find(function (items) {
            return items.doiTuongThanhTraId === idDoiTuong;
          });
          if (_this18.state.checked && check) {
            _this18.setState({
              isOpenDT: true,
              getTenDoiTuong: (0, _lodash.get)(tenDoituong, 'ten'),
              idPushCoQuan: idPushCoQuan
            });
          }
          if (check === false) {
            var msgWarning = '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (_this18.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' ' + getTenDoiTuong + (' \u0111\xE3 \u0111\u01B0\u1EE3c ch\u1ECDn l\xE0m \u0111\u1ED1i t\u01B0\u1EE3ng ' + (_this18.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' t\u1EA1i \u0111\u01A1n v\u1ECB: ') + idPushCoQuan;
            (0, _toastr.Toastr)(msgWarning, 'thongbao');
          }
        }
      });
      return 0;
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var check, newtotalSelectedList, newTempDoiTuongSelected, _newtotalSelectedList, _newTempDoiTuongSelected;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                check = true;

                item.selected = !item.selected;

                if (!item.selected) {
                  _context.next = 13;
                  break;
                }

                newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));
                newTempDoiTuongSelected = [].concat(_toConsumableArray(this.state.newTempDoiTuongSelected));

                if (item.daTrung === true) {
                  this.setState({
                    doiTuongThanhTraId: item.doiTuongThanhTraId
                  });
                }
                newTempDoiTuongSelected.push(item);
                newtotalSelectedList.push(item);
                _context.next = 10;
                return this.setState({
                  checked: item.selected,
                  totalSelectedList: newtotalSelectedList,
                  newTempDoiTuongSelected: newTempDoiTuongSelected
                });

              case 10:
                this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
                _context.next = 18;
                break;

              case 13:
                _newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));
                _newTempDoiTuongSelected = [].concat(_toConsumableArray(this.state.newTempDoiTuongSelected));

                _newtotalSelectedList.map(function (value, index) {
                  if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
                    _newtotalSelectedList.splice(index, 1);
                    _newTempDoiTuongSelected.splice(index, 1);
                  }
                });
                (0, _toastr.Toastr)(null, 'resetclear');
                this.setState({
                  newTempDoiTuongSelected: _newTempDoiTuongSelected,
                  totalSelectedList: _newtotalSelectedList
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()
  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var _this19 = this;

      var check = false;
      this.state.checkAll = !this.state.checkAll;
      this.state.ketQuaTimKiemList.map(function (item) {
        item.selected = _this19.state.checkAll;
        if (_this19.state.checkAll) {
          _this19.state.totalSelectedList.push(item);
          _this19.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
        } else {
          _this19.state.totalSelectedList = [];
          (0, _toastr.Toastr)(null, 'resetclear');
        }
      });
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'themVaoCuocTT',
    value: function themVaoCuocTT() {
      this.state.doiTuongSelectedList = [].concat(_toConsumableArray(this.state.doiTuongSelectedList), _toConsumableArray(this.state.totalSelectedList));
      this.state.totalSelectedList = [];
      this.setState(_extends({}, this.state));
      this.timKiem();
    }
  }, {
    key: 'getChucNangCuocThanhTra',
    value: function getChucNangCuocThanhTra() {
      var _this20 = this;

      _api.ThanhTra.actions.getChucNangCuocThanhTra.request().then(function (res) {
        if (res.data) {
          _this20.setState({
            dataChucNangCuocThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'closeDialogDT',
    value: function closeDialogDT(name) {
      var _this21 = this;

      var state = this.state;
      var newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));
      var newketQuaTimKiemList = [].concat(_toConsumableArray(this.state.ketQuaTimKiemList));
      if (this.state.doiTuongThanhTraId) {
        newtotalSelectedList.map(function (value, index) {
          if (value.doiTuongThanhTraId == _this21.state.doiTuongThanhTraId) {
            newtotalSelectedList.splice(index, 1);
          }
        });
      }
      newketQuaTimKiemList.map(function (item) {
        if (item.doiTuongThanhTraId === _this21.state.doiTuongThanhTraId) {
          item.selected = false;
        }
      });
      state.isOpenDT = false;
      this.setState({
        totalSelectedList: newtotalSelectedList,
        ketQuaTimKiemList: newketQuaTimKiemList,
        isOpenDT: false
      });
    }
  }, {
    key: 'openDialogDT',
    value: function openDialogDT() {
      this.setState({
        isOpenDT: true
      });
    }
  }, {
    key: 'onCloseDT',
    value: function onCloseDT() {
      this.setState({
        isOpenDT: false
      });
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this22 = this;

      if (this.refs.btnUpload.files[0]) {
        var fileName = this.refs.btnUpload.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        var listExcel = ['xls', 'xlsx'];
        if (!(0, _lodash.includes)(listExcel, ext)) {
          (0, _toastr.Toastr)(_message.msg.fileExcel, 'warning');
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: this.refs.btnUpload.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this22.setState({ progress: progressBar });
          };
          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var checkURL = '';
            if (res && res.data && !_config.checkServerLive) {
              checkURL = res.data;
            } else if (res && res.data && _config.checkServerLive) {
              checkURL = res.data.id;
            }
            _this22.setState(_extends({}, _this22.state, {
              progress: 0,
              tenFile: fileName,
              duongDan: checkURL,
              isError: false
            }), function () {
              _this22.addDoiTuongThanhTra(params);
            });
          }).catch(function (error) {
            _this22.setState({
              progress: 0,
              isError: true
            });
          });
        }
      }
    }
  }, {
    key: 'addDoiTuongThanhTra',
    value: function addDoiTuongThanhTra(params) {
      var _this23 = this;

      this.setState({
        loadingImport: true
      });
      _api.Reception.actions.importFileDoiTuong.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var _res$data = res.data,
              doiTuongThanhTraExists = _res$data.doiTuongThanhTraExists,
              numberUnsuccess = _res$data.numberUnsuccess,
              doiTuongThanhTraNotExists = _res$data.doiTuongThanhTraNotExists;


          _this23.setState({
            // doiTuongThanhTraImport: doiTuongThanhTraExists.map(item => ({ id: item.id })),
            errorImport: false,
            data: _extends({}, _this23.state.data, {
              cuocThanhTraNhieuDoiTuong: doiTuongThanhTraExists.length > 1 || _this23.state.data.cuocThanhTraNhieuDoiTuong
            }),
            base64Content: (0, _lodash.get)(doiTuongThanhTraNotExists, 'base64Content') || '',
            fileName: (0, _lodash.get)(doiTuongThanhTraNotExists, 'fileName') || '',
            mineType: (0, _lodash.get)(doiTuongThanhTraNotExists, 'mineType') || '',
            numberUnsuccess: numberUnsuccess,
            doiTuongThanhTras: [].concat(_toConsumableArray(_this23.state.doiTuongThanhTras), _toConsumableArray(doiTuongThanhTraExists))
          });
        }
      }).catch(function (error) {
        var message = (0, _lodash.get)(error, 'response.data.errors[0].description');
        _this23.setState({
          errorImport: true,
          duongDan: '',
          tenFile: '',
          data: _extends({}, _this23.state.data, {
            cuocThanhTraNhieuDoiTuong: false
          })
        }, function () {
          (0, _toastr.Toastr)(message, 'error');
        });
      }).finally(function () {
        _this23.setState({
          loadingImport: false,
          isOpenThongBao: _this23.state.numberUnsuccess > 0
        });
      });
    }
  }, {
    key: 'convertEndCode',
    value: function convertEndCode(data) {
      var result = encodeURIComponent(data);
      return result;
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/doi-tuong-thanh-tra/download-import-template";
      (0, _exportExcel.exportExcel)(URL, 'import-template.xlsx');
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra') || (0, _lodash.get)(this.props, 'isKiemTra');
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this24 = this;

      var checkKeHoach = this.props.keHoach;
      var tenTieuDe = 'Th\xEAm m\u1EDBi cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra');
      var tenTDFull = '';
      if (checkKeHoach) {
        tenTieuDe = 'B\u1ED5 sung KH' + (this.checkIsKiemTra() ? 'KT' : 'TT');
        tenTDFull = 'B\u1ED5 sung k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra');
      }
      return _react2.default.createElement(
        'div',
        { className: 'reception-container' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'btn-green btn-pullright', onClick: this.openDialogThanhTra.bind(this) },
          _react2.default.createElement('i', { className: 'tt tt-addfile' }),
          tenTieuDe
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenDT,
            onClose: this.closeDialogDT.bind(this, 'isOpenDT'),
            title: 'Th\xF4ng b\xE1o',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0 hlDialog' },
            _react2.default.createElement(
              'div',
              { className: 'pt10 txt-center' },
              '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
              _react2.default.createElement(
                'h2',
                null,
                ' "' + this.state.getTenDoiTuong + '" '
              ),
              '\u0111\xE3 \u0111\u01B0\u1EE3c ch\u1ECDn l\xE0m \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' c\u1EE7a',
              ' ',
              ' ',
              this.state.idPushCoQuan.join(', ')
            ),
            _react2.default.createElement(
              'div',
              { className: 'pb20 txt-center' },
              'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD th\xEAm',
              _react2.default.createElement(
                'h2',
                null,
                ' "' + this.state.getTenDoiTuong + '" '
              ),
              _react2.default.createElement(
                'span',
                null,
                'v\xE0o k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' kh\xF4ng?'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogDT.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-green action-todo', onClick: this.onCloseDT.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenThanhTra,
            onClose: this.closeDialog.bind(this, 'isOpenThanhTra'),
            title: checkKeHoach ? tenTDFull : 'Th\xEAm m\u1EDBi cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
            className: 'dialog-them-moi-dttt dialog-default wrap-block'
          },
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement('h2', { className: 'title-14 p20' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(
                'form',
                { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'doiTuongThanhTras') },
                _react2.default.createElement(_common.TextArea, { triggerOnblur: true, label: 'T\xEAn cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', value: this.state.data.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten', require: true, bindValidator: this, channel: 'editCuocTT', maxLength: 500 }),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25 mrt22' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'col-100 no-gutter btn-green btn-pullleft', onClick: this.openDialog.bind(this) },
                      _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                      '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                      this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25 mrt22' },
                    _react2.default.createElement(
                      'div',
                      { className: 'upload_file_content pt10' },
                      _react2.default.createElement('input', { type: 'file', name: 'uploadFile', className: 'upload btn-green btn-pullleft', ref: 'btnUpload', onChange: this.uploadFile.bind(this) }),
                      _react2.default.createElement(
                        'span',
                        { htmlFor: 'file' },
                        (0, _lodash.isEmpty)(this.state.duongDan) && !this.state.errorImport ? 'Tải lên Danh sách đối tượng' : 'Tải lại danh sách đối tượng'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-25 mrt22' },
                    _react2.default.createElement(
                      'div',
                      { className: 'download_file_content pt10 download-example-file', onClick: this.handleExport.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'T\u1EA3i file m\u1EABu'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25 mrt22' },
                    _config.checkServerLive && !this.state.errorImport && !this.state.loadingImport && _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: function onClick() {
                          (0, _utils.downloadFile)(_this24.state.duongDan, _this24.state.tenFile);
                        } },
                      this.state.tenFile
                    ),
                    !_config.checkServerLive && !this.state.errorImport && !this.state.loadingImport && _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: _downloadExcel.downloadExcel.bind(this, this.state.duongDan, this.state.tenFile) },
                      this.state.tenFile
                    ),
                    this.state.loadingImport && _react2.default.createElement('span', { className: 'icon-loader mt10' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 mb18' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ds-tt-dvph' },
                      this.state.doiTuongThanhTras.map(function (item, i) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'tt-dvph-item', key: i },
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-icon', onClick: _this24.removeDonVi.bind(_this24, 'doiTuongThanhTras', i) },
                            '\xD7'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-value' },
                            item.ten
                          )
                        );
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Ho\u1EA1t \u0111\u1ED9ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), keyName: 'giaTri', confirm: true, placeholder: null, valueName: 'ten', className: 'col-25', data: this.state.dataChucNangCuocThanhTra, selectedValue: this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo.type : '', onChange: this.onChange.bind(this, 'chucNangCuocThanhTra'), name: 'chucNangCuocThanhTra' }),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' },
                  _react2.default.createElement(_ttForms.DropDownChonLinhVucThanhTraMultiple, {
                    label: 'L\u0129nh v\u1EF1c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                    confirm: true,
                    placeholder: null,
                    className: 'col-25',
                    data: this.state.dataLinhVucThanhTra.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    selectedValue: this.state.linhVucThanhTraList,
                    onChange: this.onChange.bind(this, 'linhVucThanhTraList'),
                    name: 'linhVucThanhTraList',
                    require: true,
                    validLinhVucThanhTra: this.state.validLinhVucThanhTra
                  })
                ),
                this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' && _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'H\xECnh th\u1EE9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' chuy\xEAn ng\xE0nh', placeholder: true, options: this.state.hinhThucThanhTraChuyenNganhList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo.type : '', onChange: this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh'), name: 'hinhThucThanhTraChuyenNganh', bindValidator: this, channel: 'editCuocTT', require: true }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && this.state.data.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') },
                  _react2.default.createElement(_common2.DropDownMultipleSelect, {
                    label: ' ',
                    className: 'col-25 mt16',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    value: this.state.thucHienPhapLuatVeThanhTraList,
                    options: this.state.thucHienPhapLuatVeThanhTraListCombobox.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    onChange: this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList'),
                    placeholder: '',
                    closeMenuOnSelect: false
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' },
                  _react2.default.createElement(_common.Input, {
                    className: 'col-25',
                    label: 'Chi ti\u1EBFt l\u0129nh v\u1EF1c',
                    placeholder: 'Nh\u1EADp...',
                    value: this.state.chiTietLinhVuc,
                    onChange: this.onChange.bind(this, 'chiTietLinhVuc'),
                    name: 'chiTietLinhVuc',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    maxLength: 255
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi k\u1EF3 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), value: this.state.kyThanhTra, onChange: this.onChange.bind(this, 'phamViThanhTra'), name: 'phamViThanhTra', className: 'col-25', require: true, bindValidator: this, channel: 'editCuocTT' }),
              _react2.default.createElement(_common.InputNumber, { label: 'Th\u1EDDi h\u1EA1n (ng\xE0y)', value: this.state.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra'), name: 'thoiHanThanhTra', className: 'col-25' }),
              _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi gian ti\u1EBFn h\xE0nh', value: this.state.data.thoiGianTienHanh, onChange: this.onChange.bind(this, 'thoiGianTienHanh'), name: 'thoiGianTienHanh', className: 'col-25', maxLength: 255 }),
              _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), value: this.state.noiDungThanhTra, onChange: this.onChange.bind(this, 'noiDungThanhTra'), name: 'noiDungThanhTra', rows: 3, placeholder: 'Nh\u1EADp...', require: true, bindValidator: this, channel: 'editCuocTT', maxLength: 500 })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpenThanhTra') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: (0, _classnames2.default)('btn-action btn-save', {
                    'btn-loading-inline': this.state.loadingImport
                  }),
                  onClick: this.handleSaveThanhTra.bind(this)
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this, 'isOpen'),
            title: 'Th\xEAm \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
            className: 'dialog-them-moi-dttt dialog-default wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'row pl30 pr30' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt20 pb15' },
                '1. T\xECm ki\u1EBFm \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            ),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ED1i t\u01B0\u1EE3ng', value: this.state.tuKhoa, onChange: this.onChangeTuKhoa.bind(this), name: 'tuKhoa', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...' }),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: 'M\xE3 s\u1ED1 thu\u1EBF', value: this.state.maSoThue, onChange: this.onChangeMaSoThue.bind(this), name: 'maSoThue', placeholder: 'Nh\u1EADp m\xE3 s\u1ED1 thu\u1EBF...' }),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-28',
              label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng',
              selectedValue: this.state.nhomDoiTuongThanhTraId,
              onChange: this.onChange.bind(this, 'nhomDoiTuongThanhTraId'),
              name: 'nhomDoiTuongThanhTraId',
              placeholder: true,
              options: this.state.nhomDTList, keyName: 'nhomDoiTuongThanhTraId', valueName: 'ten'
            }),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-28',
              label: 'Huy\u1EC7n/TP',
              selectedValue: this.state.quanHuyenId,
              onChange: this.onChange.bind(this, 'quanHuyenId'),
              name: 'quanHuyenId',
              placeholder: true,
              options: this.state.dsQuanHuyen, keyName: 'donViHanhChinhId', valueName: 'ten'
            }),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-28',
              label: 'Ph\u01B0\u1EDDng/X\xE3',
              selectedValue: this.state.phuongXaId,
              onChange: this.onChange.bind(this, 'phuongXaId'),
              name: 'phuongXaId',
              placeholder: true,
              options: this.state.dsPhuongXa, keyName: 'donViHanhChinhId', valueName: 'ten'
            }),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ECBa ch\u1EC9', value: this.state.diaChi, onChange: this.onChangeDiaChi.bind(this), name: 'diaChi', placeholder: 'Nh\u1EADp' }),
            _react2.default.createElement(
              'div',
              { className: 'col-15 mt22' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green ml10', onClick: this.timKiem.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt-search' }),
                'T\xECm ki\u1EBFm'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.1 K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _datatable.DataTableMultipleSelect,
                { onDisableCheck: true, onCheck: this.handleSelectedAll.bind(this), selectAllStatus: this.state.checkAll, header: _table.header.thanhTra.KQTKTMDTTT2, dataList: this.state.ketQuaTimKiemList, tableLoading: this.state.tableLoading, pageData: this.state.pageData, parent: this },
                _react2.default.createElement(_datatable.RowItemKetQuaTimKiemThanhTra, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb20 pt10 txt-center' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.themVaoCuocTT.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'row pl40 pr40' },
              _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.2 Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng s\u1EBD \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _dataTable2.default,
                { header: _table.header.thanhTra.TMDTTT2, dataList: this.state.doiTuongSelectedList, hideButtonExport: true, hidePagination: true, parent: this, emptyMsg: 'Ch\u01B0a c\xF3 \u0111\u1ED1i t\u01B0\u1EE3ng \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c thanh tra' },
                _react2.default.createElement(_datatable.RowItemDanhSachThemMoiThanhTra, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpen') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-save', onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenThongBao,
            onClose: this.closeDialogThongBao.bind(this),
            title: 'Thông báo',
            className: 'panel-popup category' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            'Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' v\u1EEBa t\u1EA3i l\xEAn c\xF3',
            _react2.default.createElement(
              'a',
              { className: 'txt-underline', download: this.state.fileName, href: 'data:' + this.state.mineType + ';base64,' + this.state.base64Content },
              ' ',
              this.state.numberUnsuccess,
              ' '
            ),
            '\u0111\u1ED1i t\u01B0\u1EE3ng ch\u01B0a c\xF3 trong h\u1EC7 th\u1ED1ng. Vui l\xF2ng b\u1EA5m v\xE0o link S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng \u0111\u1EC3 t\u1EA3i xu\u1ED1ng v\xE0 ki\u1EC3m tra l\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.closeDialogThongBao.bind(this), className: 'btn-action btn-close' },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return ThemMoiDoiTuongThanhTra;
}(_react2.default.Component);

ThemMoiDoiTuongThanhTra.defaultProps = {
  validators: []
};

exports.default = ThemMoiDoiTuongThanhTra;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemDoiTuongThanhTraView = exports.RowItemDoiTuongThanhTra = exports.RowItemDanhSachTheoDoiThucHien = undefined;

var _RowItemDanhSachTheoDoiThucHien = __webpack_require__(1388);

var _RowItemDanhSachTheoDoiThucHien2 = _interopRequireDefault(_RowItemDanhSachTheoDoiThucHien);

var _RowItemDoiTuongThanhTra = __webpack_require__(1389);

var _RowItemDoiTuongThanhTra2 = _interopRequireDefault(_RowItemDoiTuongThanhTra);

var _RowItemDoiTuongThanhTraView = __webpack_require__(1390);

var _RowItemDoiTuongThanhTraView2 = _interopRequireDefault(_RowItemDoiTuongThanhTraView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemDanhSachTheoDoiThucHien = _RowItemDanhSachTheoDoiThucHien2.default;
exports.RowItemDoiTuongThanhTra = _RowItemDoiTuongThanhTra2.default;
exports.RowItemDoiTuongThanhTraView = _RowItemDoiTuongThanhTraView2.default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoiDungKienNghiDoiTuongThanhTra = function (_React$Component) {
  _inherits(NoiDungKienNghiDoiTuongThanhTra, _React$Component);

  function NoiDungKienNghiDoiTuongThanhTra() {
    _classCallCheck(this, NoiDungKienNghiDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (NoiDungKienNghiDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(NoiDungKienNghiDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(NoiDungKienNghiDoiTuongThanhTra, [{
    key: 'render',
    value: function render() {
      var CountCaNhanCoSaiPham = 0;
      var CountToChucCoSaiPham = 0;
      if (this.props.toChucCoSaiPham) {
        CountToChucCoSaiPham = this.props.toChucCoSaiPham.split('; ').length;
      }
      if (this.props.caNhanCoSaiPham) {
        CountCaNhanCoSaiPham = this.props.caNhanCoSaiPham.split('; ').length;
      }
      return _react2.default.createElement(
        'div',
        { className: 'wrap-items-content' },
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'h2',
            { className: 'title-12 col-100 mb10' },
            '1.1. Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'txt-bold txt-upper col-100 mb10' },
              'Thu h\u1ED3i v\u1EC1 NSNN'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'V\u1EC1 ti\u1EC1n (\u0111):', value: this.props.tienDaThuHoiVeNganSachNhaNuoc }),
            _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'V\u1EC1 \u0111\u1EA5t (m2):', value: this.props.datDaThuHoiVeNganSachNhaNuoc })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'txt-bold txt-upper col-100 mb10' },
              'Thu h\u1ED3i v\u1EC1 t\u1ED5 ch\u1EE9c, \u0111\u01A1n v\u1ECB'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'V\u1EC1 ti\u1EC1n (\u0111):', value: this.props.tienDaThuTrongQuaTrinhThanhTra }),
            _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'V\u1EC1 \u0111\u1EA5t (m2):', value: this.props.datDaThuTrongQuaTrinhThanhTra })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 pb15' },
          _react2.default.createElement('div', { className: 'line-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'h2',
            { className: 'title-12 col-100 mb15' },
            '1.2 Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kh\xE1c v\u1EC1 kinh t\u1EBF'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'V\u1EC1 ti\u1EC1n (\u0111):', value: this.props.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'V\u1EC1 \u0111\u1EA5t (m2):', value: this.props.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 pb15' },
          _react2.default.createElement('div', { className: 'line-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'h2',
            { className: 'title-12 col-100 mb10' },
            '1.3. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD v\u1EC1 h\xE0nh ch\xEDnh'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m:', value: this.props.toChucCoSaiPham }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng ti\u1EC1n (\u0111):', value: this.props.kienNghiXuLyHanhChinhToChucBangTien }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c:', value: this.props.hinhThucKienNghiToChuc }),
          _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m:', value: this.props.caNhanCoSaiPham }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng ti\u1EC1n (\u0111):', value: this.props.kienNghiXuLyHanhChinhCaNhanBangTien }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c:', value: this.props.hinhThucKienNghiCaNhan })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 pb15' },
          _react2.default.createElement('div', { className: 'line-border' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 col-100 mb10' },
              this.props.linhVucThanhTra === 'DAT_DAI' ? '1.5. Kiến nghị chuyển cơ quan điều tra' : '1.4. Kiến nghị chuyển cơ quan điều tra'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: this.props.soVuViecKienNghiChuyenCoQuanDieuTra }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.chuyenCoQuanDieuTra === true },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-attach col-100 mb10' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: this.props.soQuyetDinhChuyenCoQuanDieuTra }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi ra quy\u1EBFt \u0111\u1ECBnh:', value: this.props.nguoiRaQuyetDinhChuyenCoQuanDieuTra })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\xEAn c\u01A1 quan:', value: this.props.coQuanDieuTraThanhTraInfo ? this.props.coQuanDieuTraThanhTraInfo.text : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.coQuanDieuTraThanhTra === 'KHAC' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan \u0111i\u1EC1u tra kh\xE1c:', value: this.props.coQuanDieuTraKhac })
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5:', value: this.props.soVuChuyenCoQuanDieuTra })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb15' },
            _react2.default.createElement('div', { className: 'line-border' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'h2',
            { className: 'title-12 col-100 mb10' },
            this.props.linhVucThanhTra === 'DAT_DAI' ? '1.6. Kiến nghị hoàn thiện cơ chế chính sách' : '1.5. Kiến nghị hoàn thiện cơ chế chính sách'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-30 mb10', label: 'S\u1ED1 ki\u1EBFn ngh\u1ECB ho\xE0n thi\u1EC7n c\u01A1 ch\u1EBF ch\xEDnh s\xE1ch:', value: this.props.soHoanThienCoCheChinhSach })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 pb15' },
          _react2.default.createElement('div', { className: 'line-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'h2',
            { className: 'title-12 col-100 mb10' },
            this.props.chucNangCuocThanhTra != 'CHUYEN_NGANH' ? this.props.linhVucThanhTra === 'DAT_DAI' ? '1.7. Kiến nghị xử lý khác' : '1.6. Kiến nghị xử lý khác' : '1.5. Kiến nghị xử lý khác'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111):', value: this.props.tienKienNghiXuLyKhac }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.chucNangCuocThanhTra !== 'CHUYEN_NGANH' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2):', value: this.props.datKienNghiXuLyKhac }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'N\u1ED9i dung ki\u1EBFn ngh\u1ECB kh\xE1c:', value: this.props.noiDungKienNghiXuLyKhac })
          )
        )
      );
    }
  }]);

  return NoiDungKienNghiDoiTuongThanhTra;
}(_react2.default.Component);

exports.default = NoiDungKienNghiDoiTuongThanhTra;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _lodash = __webpack_require__(14);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _ListDonDoc = __webpack_require__(319);

var _ListDonDoc2 = _interopRequireDefault(_ListDonDoc);

var _ListLanNopTien = __webpack_require__(320);

var _ListLanNopTien2 = _interopRequireDefault(_ListLanNopTien);

var _style = __webpack_require__(269);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(269);

var loaiQuyTrinh = 'THANH_TRA';

var ToChucLienQuan = function (_React$Component) {
  _inherits(ToChucLienQuan, _React$Component);

  function ToChucLienQuan(props, context) {
    _classCallCheck(this, ToChucLienQuan);

    var _this = _possibleConstructorReturn(this, (ToChucLienQuan.__proto__ || Object.getPrototypeOf(ToChucLienQuan)).call(this, props, context));

    _this.state = {
      dataDetail: {},
      style: _style2.default,
      showFile: true,
      isOpen: _this.props.isOpen,
      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      getThoiHanKiemTra: false,
      donDocChange: false,
      confirmDonDoc: false,
      showDialogConfirm: false,
      btnLoading: false,
      btnSaveLoading: false,
      enableTheoDoi: true,
      enableDonDoc: false,
      enableKiemTra: false,
      backConfirm: false,
      hasChange: false,
      idCuocThanhTra: _this.props.idCuocThanhTra,
      id: _this.props.id,

      ten: '',
      linhVucKetQuaThanhTra: '',
      theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiDatDaThuHoiVeNganSachNhaNuoc: '',
      tienDaThuTrongQuaTrinhThanhTra: '',
      datDaThuTrongQuaTrinhThanhTra: '',
      saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',

      linhVucThanhTra: _this.props.linhVucThanhTra,
      listDoiTuongViPham: _this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: _this.props.chucNangCuocThanhTra,

      listLinhVucThanhTra: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataCoQuanDieuTraThanhTra: [],
      dataHinhThucKienNghi: [],
      dsTaiLieuKienNghiHoanThienCoCheChinhSach: [],

      listTaiLieuVanThuGiaHan: [],
      danhSachDonViPhoiHop: [],
      listTaiLieuVanThu: [],
      donViPhoiHop: '',
      trangThaiDoiTuongViPham: '',

      //data option

      dataKetQuaTheoDoiSaiPham: [],
      dataKetQuaChuyenCoQuanDieuTra: [],
      dataKetLuanVeNoiDungKiemTra: [],
      dataDoiTuongThanhTra: [],

      //Theo doi thuc hien

      theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
      theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

      soQuyetDinhTheoDoiXuLyHanhChinh: '',

      theoDoiToChucCoSaiPham: '',
      theoDoiToChucCoSaiPhamInit: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',
      toChucTheoDoiSaiPham: '',

      theoDoiCaNhanCoSaiPham: '',
      theoDoiCaNhanCoSaiPhamInit: '',
      caNhanTheoDoiSaiPham: '',

      // xử lý về kinh tế

      tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

      listTheoDoiLanNopTien: [],

      lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

      lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamKhacTheoDoiXuLyVeKinhTe: '',

      // xử lý về hình sự
      vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
      ketQuaChuyenCoQuanDieuTra: '',
      soVuViecTheoDoiXuLyHinhSu: '',

      soDoiTuongTheoDoiXuLyHinhSuInit: '',
      soDoiTuongTheoDoiXuLyHinhSu: '',

      ghiChuTheoDoiXuLyHinhSu: '',

      kienNghiTienTheoDoiXuLyKhac: '',
      kienNghiDatTheoDoiXuLyKhac: '',
      ketQuaThucHienTheoDoiXuLyKhac: '',
      // end theo dõi thực hiện

      // Kết quả kiểm tra

      soQuyetDinhKiemTra: '',
      ngayBanHanhKiemTra: '',
      ngayBatDauKiemTra: '',
      thoiHanKiemTra: '',
      ngayHetHanKiemTra: '',
      ngayHetHanKiemTraISO: '',
      canCuKiemTra: '',
      tinhHinhKiemTra: '',
      ketQuaKiemTra: '',

      soKienNghiDaThucHienXong: ''

      // end kết quả kiểm tra
    };
    return _this;
  }

  _createClass(ToChucLienQuan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanDieuTraThanhTra();
      this.getHinhThucKienNghi();
      this.ketQuaTheoDoiSaiPham();
      this.ketQuaChuyenCoQuanDieuTra();
      this.getKetLuanVeNoiDungKiemTra();
      this.getDoiTuongThanhTra();
      this.getListLinhVucThanhTra();
      if (this.state.id) {
        this.getChiTietDoiTuongTraThanhTra(this.state.id);
      } else {
        this.setState({
          enableTheoDoi: true,
          enableDonDoc: false,
          enableKiemTra: false
        });
      }
    }
  }, {
    key: 'ketQuaTheoDoiSaiPham',
    value: function ketQuaTheoDoiSaiPham() {
      var _this2 = this;

      _api.ThanhTra.actions.ketQuaTheoDoiSaiPham.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            dataKetQuaTheoDoiSaiPham: res.data
          });
        }
      });
    }
  }, {
    key: 'ketQuaChuyenCoQuanDieuTra',
    value: function ketQuaChuyenCoQuanDieuTra() {
      var _this3 = this;

      _api.ThanhTra.actions.ketQuaChuyenCoQuanDieuTra.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataKetQuaChuyenCoQuanDieuTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDoiTuongThanhTra',
    value: function getDoiTuongThanhTra() {
      var _this4 = this;

      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      var params = {
        namThanhTra: getNamTT,
        approved: true
      };
      _api.ThanhTra.actions.getDoiTuongThanhTra.request(params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
          });
        }
      });
    }
  }, {
    key: 'getListLinhVucThanhTra',
    value: function getListLinhVucThanhTra() {
      var _this5 = this;

      _api.ThanhTra.actions.getDsLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            listLinhVucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getChiTietDoiTuongTraThanhTra',
    value: function getChiTietDoiTuongTraThanhTra(id) {
      var _this6 = this;

      _api.ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this6.setState({
            dataDetail: res.data,
            doiTuongViPhamId: res.data.doiTuongViPhamId,

            ten: res.data.ten,
            // theo doi thuc hien
            theoDoiTienDaThuTrongQuaTrinhThanhTra: res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra : '',
            theoDoiDatDaThuTrongQuaTrinhThanhTra: res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra : '',

            soQuyetDinhTheoDoiXuLyHanhChinh: res.data.soQuyetDinhTheoDoiXuLyHanhChinh ? res.data.soQuyetDinhTheoDoiXuLyHanhChinh : '',

            theoDoiToChucCoSaiPham: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
            theoDoiToChucCoSaiPhamInit: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
            theoDoiKienNghiXuLyHanhChinhToChucBangTien: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '',
            theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '',
            theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '',
            theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '',
            toChucTheoDoiSaiPham: res.data.toChucTheoDoiSaiPham ? res.data.toChucTheoDoiSaiPham : '',

            theoDoiCaNhanCoSaiPham: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
            theoDoiCaNhanCoSaiPhamInit: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
            caNhanTheoDoiSaiPham: res.data.caNhanTheoDoiSaiPham ? res.data.caNhanTheoDoiSaiPham : '',

            listTheoDoiLanNopTien: res.data.listTheoDoiLanNopTien ? res.data.listTheoDoiLanNopTien : [],

            tongSoTienThuHoiTheoDoiXuLyVeKinhTe: res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '',

            lyDoThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe : '',

            saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '',
            saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '',
            saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '',

            lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '',

            saiPhamKhacTheoDoiXuLyVeKinhTe: res.data.saiPhamKhacTheoDoiXuLyVeKinhTe ? res.data.saiPhamKhacTheoDoiXuLyVeKinhTe : '',

            vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '',
            ketQuaChuyenCoQuanDieuTra: res.data.ketQuaChuyenCoQuanDieuTra ? res.data.ketQuaChuyenCoQuanDieuTra : '',

            soVuViecTheoDoiXuLyHinhSu: res.data.soVuViecTheoDoiXuLyHinhSu ? res.data.soVuViecTheoDoiXuLyHinhSu : '',

            soDoiTuongTheoDoiXuLyHinhSu: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',
            soDoiTuongTheoDoiXuLyHinhSuInit: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',

            ghiChuTheoDoiXuLyHinhSu: res.data.ghiChuTheoDoiXuLyHinhSu ? res.data.ghiChuTheoDoiXuLyHinhSu : '',

            kienNghiTienTheoDoiXuLyKhac: res.data.kienNghiTienTheoDoiXuLyKhac ? res.data.kienNghiTienTheoDoiXuLyKhac : '',
            kienNghiDatTheoDoiXuLyKhac: res.data.kienNghiDatTheoDoiXuLyKhac ? res.data.kienNghiDatTheoDoiXuLyKhac : '',
            ketQuaThucHienTheoDoiXuLyKhac: res.data.ketQuaThucHienTheoDoiXuLyKhac ? res.data.ketQuaThucHienTheoDoiXuLyKhac : '',

            listTaiLieuVanThu: res.data.listTaiLieuVanThu,

            //end theo doi

            // ket qua kiem tra
            soQuyetDinhKiemTra: res.data.soQuyetDinhKiemTra ? res.data.soQuyetDinhKiemTra : '',
            ngayBanHanhKiemTra: res.data.ngayBanHanhKiemTra ? new Date(res.data.ngayBanHanhKiemTra) : '',
            ngayBatDauKiemTra: res.data.ngayBatDauKiemTra ? new Date(res.data.ngayBatDauKiemTra) : '',
            thoiHanKiemTra: res.data.thoiHanKiemTra ? res.data.thoiHanKiemTra : 0,
            ngayHetHanKiemTra: res.data.ngayHetHanKiemTra ? (0, _moment2.default)(res.data.ngayHetHanKiemTra).format('DD/MM/YYYY') : '',
            ngayHetHanKiemTraISO: res.data.ngayHetHanKiemTra ? res.data.ngayHetHanKiemTra : null,
            canCuKiemTra: res.data.canCuKiemTra ? res.data.canCuKiemTra : '',
            tinhHinhKiemTra: res.data.tinhHinhKiemTra ? res.data.tinhHinhKiemTra : '',
            ketQuaKiemTra: res.data.ketQuaKiemTra ? res.data.ketQuaKiemTra : '',
            soKienNghiDaThucHienXong: res.data.soKienNghiDaThucHienXong ? res.data.soKienNghiDaThucHienXong : '',

            linhVucKetQuaThanhTra: res.data.linhVucKetQuaThanhTra ? res.data.linhVucKetQuaThanhTra.giaTri : '',
            theoDoiTienDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '',
            theoDoiDatDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '',
            tienDaThuTrongQuaTrinhThanhTra: res.data.tienDaThuTrongQuaTrinhThanhTra ? res.data.tienDaThuTrongQuaTrinhThanhTra : '',
            datDaThuTrongQuaTrinhThanhTra: res.data.datDaThuTrongQuaTrinhThanhTra ? res.data.datDaThuTrongQuaTrinhThanhTra : '',
            saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: res.data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? res.data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
            saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: res.data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? res.data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
            saiPhamVeTienKienNghiKhacXuLyVeKinhTe: res.data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? res.data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '',
            saiPhamVeDatKienNghiKhacXuLyVeKinhTe: res.data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? res.data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '',
            dsTaiLieuKienNghiHoanThienCoCheChinhSach: res.data.dsTaiLieuKienNghiHoanThienCoCheChinhSach ? res.data.dsTaiLieuKienNghiHoanThienCoCheChinhSach : []
          }, function () {
            _this6.checkTienDo();
          });
        }
      });
    }
  }, {
    key: 'checkTienDo',
    value: function checkTienDo() {
      var DataDetail = _extends({}, this.state.dataDetail);
      if (DataDetail.tinhTrangThoiHanInfo && DataDetail.tinhTrangThoiHanInfo.type === 'DAY' && DataDetail.tinhTrangThoiHanInfo.value < 1) {
        switch (DataDetail.tienDo) {
          case 'THEO_DOI':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: false
            });
            break;
          case 'DON_DOC':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
          case 'HOAN_THANH':
          case 'KIEM_TRA':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
        }
      } else {
        switch (DataDetail.tienDo) {
          case 'THEO_DOI':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: false,
              enableKiemTra: false
            });
            break;
          case 'DON_DOC':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: false
            });
            break;
          case 'HOAN_THANH':
          case 'KIEM_TRA':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
        }
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = this.state.dataDetail;
      if (this.state.listTheoDoiLanNopTien.length > 0) {
        var listTheoDoiLanNopTien = [];
        this.state.listTheoDoiLanNopTien.map(function (state) {
          var item = {
            ngayNopTien: state.ngayNopTien ? (0, _moment2.default)(new Date(state.ngayNopTien)).add(7, 'hours').toISOString() : null,
            soTien: state.soTien ? state.soTien : '',
            tongCong: state.tongCong ? state.tongCong : '',
            conPhaiThu: state.conPhaiThu ? state.conPhaiThu : ''
          };

          listTheoDoiLanNopTien[listTheoDoiLanNopTien.length] = item;
        });
        params.listTheoDoiLanNopTien = listTheoDoiLanNopTien;
      } else {
        params.listTheoDoiLanNopTien = [];
      }

      if (this.state.id) {
        params.id = this.state.id;
      }

      params.loaiDoiTuongViPham = 'CO_QUAN_TO_CHUC_LIEN_QUAN';

      params.ten = this.state.ten ? this.state.ten : '';

      params.cuocThanhTra = {
        id: Number(this.state.idCuocThanhTra)
      };

      params.theoDoiTienDaThuTrongQuaTrinhThanhTra = this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra : '';
      params.theoDoiDatDaThuTrongQuaTrinhThanhTra = this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra : '';

      params.soQuyetDinhTheoDoiXuLyHanhChinh = this.state.soQuyetDinhTheoDoiXuLyHanhChinh ? this.state.soQuyetDinhTheoDoiXuLyHanhChinh : '';
      params.soKienNghiDaThucHienXong = this.state.soKienNghiDaThucHienXong ? this.state.soKienNghiDaThucHienXong : '';

      params.theoDoiToChucCoSaiPham = this.state.theoDoiToChucCoSaiPham ? this.state.theoDoiToChucCoSaiPham : '';
      params.toChucTheoDoiSaiPham = this.state.toChucTheoDoiSaiPham ? this.state.toChucTheoDoiSaiPham : null;

      params.theoDoiCaNhanCoSaiPham = this.state.theoDoiCaNhanCoSaiPham ? this.state.theoDoiCaNhanCoSaiPham : '';
      params.caNhanTheoDoiSaiPham = this.state.caNhanTheoDoiSaiPham ? this.state.caNhanTheoDoiSaiPham : null;

      // xử lý về kinh tế

      params.tongSoTienThuHoiTheoDoiXuLyVeKinhTe = this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '';

      params.lyDoThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe : '';

      params.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '';
      params.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '';
      params.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '';

      params.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '';

      params.saiPhamKhacTheoDoiXuLyVeKinhTe = this.state.saiPhamKhacTheoDoiXuLyVeKinhTe ? this.state.saiPhamKhacTheoDoiXuLyVeKinhTe : '';

      // xử lý về hình sự
      params.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu = this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '';
      params.ketQuaChuyenCoQuanDieuTra = this.state.ketQuaChuyenCoQuanDieuTra ? this.state.ketQuaChuyenCoQuanDieuTra : null;

      params.soVuViecTheoDoiXuLyHinhSu = this.state.soVuViecTheoDoiXuLyHinhSu ? this.state.soVuViecTheoDoiXuLyHinhSu : '';

      params.soDoiTuongTheoDoiXuLyHinhSu = this.state.soDoiTuongTheoDoiXuLyHinhSu ? this.state.soDoiTuongTheoDoiXuLyHinhSu : '';

      params.ghiChuTheoDoiXuLyHinhSu = this.state.ghiChuTheoDoiXuLyHinhSu ? this.state.ghiChuTheoDoiXuLyHinhSu : '';

      params.kienNghiTienTheoDoiXuLyKhac = this.state.kienNghiTienTheoDoiXuLyKhac ? this.state.kienNghiTienTheoDoiXuLyKhac : '';
      params.kienNghiDatTheoDoiXuLyKhac = this.state.kienNghiDatTheoDoiXuLyKhac ? this.state.kienNghiDatTheoDoiXuLyKhac : '';
      params.ketQuaThucHienTheoDoiXuLyKhac = this.state.ketQuaThucHienTheoDoiXuLyKhac ? this.state.ketQuaThucHienTheoDoiXuLyKhac : '';

      // ket qua kiem tra

      params.soQuyetDinhKiemTra = this.state.soQuyetDinhKiemTra ? this.state.soQuyetDinhKiemTra : '';
      params.ngayBanHanhKiemTra = this.state.ngayBanHanhKiemTra ? (0, _moment2.default)(this.state.ngayBanHanhKiemTra).add(7, 'hours').toISOString() : null;
      params.ngayBatDauKiemTra = this.state.ngayBatDauKiemTra ? (0, _moment2.default)(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString() : null;
      params.thoiHanKiemTra = this.state.thoiHanKiemTra ? this.state.thoiHanKiemTra : 0;
      params.ngayHetHanKiemTra = this.state.ngayHetHanKiemTraISO ? this.state.ngayHetHanKiemTraISO : null;
      params.canCuKiemTra = this.state.canCuKiemTra ? this.state.canCuKiemTra : '';
      params.tinhHinhKiemTra = this.state.tinhHinhKiemTra ? this.state.tinhHinhKiemTra : '';
      params.ketQuaKiemTra = this.state.ketQuaKiemTra ? this.state.ketQuaKiemTra : null;

      params.linhVucKetQuaThanhTra = this.state.linhVucKetQuaThanhTra ? this.state.linhVucKetQuaThanhTra : '';
      params.theoDoiTienDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '';
      params.theoDoiDatDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '';
      params.tienDaThuTrongQuaTrinhThanhTra = this.state.tienDaThuTrongQuaTrinhThanhTra ? this.state.tienDaThuTrongQuaTrinhThanhTra : '';
      params.datDaThuTrongQuaTrinhThanhTra = this.state.datDaThuTrongQuaTrinhThanhTra ? this.state.datDaThuTrongQuaTrinhThanhTra : '';
      params.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '';
      params.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '';
      params.saiPhamVeTienKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '';
      params.saiPhamVeDatKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '';

      // Xử lý về hành chính
      params.theoDoiKienNghiXuLyHanhChinhToChucBangTien = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '';
      params.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '';
      params.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '';
      params.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '';
      params.soKienNghiDaThucHienXong = this.state.soKienNghiDaThucHienXong ? this.state.soKienNghiDaThucHienXong : '';

      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['cuocThanhTraId'];
      delete params['doiTuongViPhamId'];
      delete params['listTaiLieuVanThuChuyenCoQuanDieuTra'];
      delete params['listTaiLieuVanThuKienNghiXuLyKhac'];
      delete params['trangThaiDoiTuongViPhamInfo'];
      delete params['coQuanDieuTraThanhTraInfo'];
      delete params['loaiDoiTuongInfo'];
      delete params['tienDoInfo'];
      delete params['tinhTrangThoiHanInfo'];
      delete params['toChucTheoDoiSaiPhamInfo'];
      delete params['caNhanTheoDoiSaiPhamInfo'];
      delete params['coQuanDieuTraInfo'];
      delete params['ketQuaChuyenCoQuanDieuTraInfo'];
      delete params['ketQuaKiemTraInfo'];
      delete params['donDocDoiTuongs'];
      delete params['listTaiLieuVanThu'];
      delete params['theoDoiLanNopTien'];
      delete params['dsTaiLieuKienNghiHoanThienCoCheChinhSach'];

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this7 = this;

      if (this.state.id) {
        var params = this.getParams();
        this.pushTaiLieu(this.state.doiTuongViPhamId);
        this.setState({
          showNoiDungKienNghi: true,
          showNoiDungTheoDoi: true,
          showNoiDungDonDoc: true,
          showNoiDungKiemTra: true,
          btnLoading: true,
          btnSaveLoading: true
        }, function () {
          if (_this7.state.enableDonDoc) {
            _this7.donDoc.handleSave(function () {
              _this7.updateDoiTuongViPham(params);
            });
          } else {
            _this7.updateDoiTuongViPham(params);
          }
        });
      } else {
        if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
          (0, _toastr.Toastr)('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
        } else {
          var _params = this.getParams();
          _params.tienDo = 'THEO_DOI';
          this.setState({
            showNoiDungKienNghi: true,
            btnLoading: true,
            btnSaveLoading: true
          }, function () {
            _this7.postDoiTuongViPham(_params);
          });
        }
      }
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this8 = this;

      if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
        (0, _toastr.Toastr)('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
      } else {
        this.setState({
          showNoiDungKienNghi: true,
          showNoiDungTheoDoi: true,
          showNoiDungDonDoc: true,
          showNoiDungKiemTra: true
        }, function () {
          var self = _this8;
          setTimeout(function () {
            if (self.validateSubmitForm()) {
              self.setState({
                showDialogConfirm: true
              });
            }
          }, 100);
        });
      }
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        showDialogConfirm: false
      });
    }
  }, {
    key: 'onClickConfirmKetThuc',
    value: function onClickConfirmKetThuc() {
      var _this9 = this;

      this.setState({
        showDialogConfirm: false,
        btnLoading: true
      }, function () {
        var params = _this9.getParams();
        params.tienDo = 'HOAN_THANH';
        _this9.pushTaiLieu(_this9.state.doiTuongViPhamId);
        if (_this9.state.enableDonDoc) {
          _this9.donDoc.handleSave(function () {
            var message = 'Hoàn thành theo dõi thực hiện đối với ' + _this9.state.ten;
            _this9.updateDoiTuongViPham(params, message);
          });
        } else {
          var message = 'Hoàn thành theo dõi thực hiện đối với ' + _this9.state.ten;
          _this9.updateDoiTuongViPham(params, message);
        }
      });
    }
  }, {
    key: 'postDoiTuongViPham',
    value: function postDoiTuongViPham(data) {
      var _this10 = this;

      var params = {
        doiTuongViPhams: [data]
      };
      _api.ThanhTra.actions.postDoiTuongViPham.request('', params).then(function (res) {
        //do something
        _this10.pushTaiLieu(res.data.doiTuongViPhams[0].doiTuongViPhamId);
        (0, _toastr.Toastr)(_message.msg.addDoiTuongTTSuccess, 'success');
        _this10.handleBack(true);
        _this10.props.getListDaTa();
      });
    }
  }, {
    key: 'updateDoiTuongViPham',
    value: function updateDoiTuongViPham(data, message) {
      var _this11 = this;

      var params = {
        doiTuongViPhams: [data]
      };
      _api.ThanhTra.actions.updateDoiTuongViPham.request('', params).then(function (res) {
        //do something
        (0, _toastr.Toastr)(message ? message : _message.msg.saveDoiTuongTTSuccess, 'success');
        _this11.handleBack(true);
        _this11.props.getListDaTa();
      });
    }
  }, {
    key: 'getCoQuanDieuTraThanhTra',
    value: function getCoQuanDieuTraThanhTra() {
      var _this12 = this;

      _api.ThanhTra.actions.getCoQuanDieuTraThanhTra.request().then(function (res) {
        if (res.data) {
          _this12.setState({
            dataCoQuanDieuTraThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getHinhThucKienNghi',
    value: function getHinhThucKienNghi() {
      var _this13 = this;

      _api.ThanhTra.actions.getHinhThucKienNghi.request().then(function (res) {
        if (res.data) {
          _this13.setState({
            dataHinhThucKienNghi: res.data
          });
        }
      });
    }
  }, {
    key: 'getKetLuanVeNoiDungKiemTra',
    value: function getKetLuanVeNoiDungKiemTra() {
      var _this14 = this;

      _api.ThanhTra.actions.ketLuanVeNoiDungKiemTra.request().then(function (res) {
        if (res.data) {
          _this14.setState({
            dataKetLuanVeNoiDungKiemTra: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this15 = this;

      this.setState({
        linhVucThanhTra: nextProps.linhVucThanhTra,
        listDoiTuongViPham: nextProps.listDoiTuongViPham,
        idCuocThanhTra: nextProps.idCuocThanhTra,
        chucNangCuocThanhTra: nextProps.chucNangCuocThanhTra,
        id: nextProps.id,
        isOpen: nextProps.isOpen
      }, function () {
        if (_this15.state.id && _this15.state.isOpen === true) {
          _this15.getChiTietDoiTuongTraThanhTra(_this15.state.id);
        } else {
          _this15.setState({
            enableTheoDoi: true,
            enableDonDoc: false,
            enableKiemTra: false
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this16 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        if (name === 'thoiHanKiemTra') {
          _this16.getThoiHanKiemTra();
        }
      });
      if (name == 'coQuanDieuTraThanhTra') {}
      this.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.setState({
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      this.setState({
        dataFileDinhKem: data
      });

      this.handleChangeData();
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id) {
      var dataFileDinhKem = this.state.dataFileDinhKem;

      if (dataFileDinhKem.length > 0) {
        var taiLieuVanThu = [];
        var taiLieuVanThuUpdate = [];
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            taiLieuVanThuUpdate[taiLieuVanThuUpdate.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo && (0, _lodash.isString)(item.nhomHoSo) ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          } else {
            taiLieuVanThu[taiLieuVanThu.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo && (0, _lodash.isString)(item.nhomHoSo) ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          }
        });
        if (taiLieuVanThu.length > 0) {
          var params = {
            taiLieuVanThus: taiLieuVanThu
          };
          this.postTaiLieuVanThu(params);
        }
        if (taiLieuVanThuUpdate.length > 0) {
          var _params2 = {
            taiLieuVanThus: taiLieuVanThuUpdate
          };
          console.log(_params2);
          // this.updateTaiLieuVanThu(params);
        }
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        var taiLieuVanThuDelete = [];
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          taiLieuVanThuDelete[taiLieuVanThuDelete.length] = { id: item };
        });
        if (taiLieuVanThuDelete.length > 0) {
          var _params3 = {
            taiLieuVanThus: taiLieuVanThuDelete
          };
          console.log(_params3);
          // this.deleteTaiLieuVanThu(params);
        }
      }
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      var _setState2;

      this.setState((_setState2 = {}, _defineProperty(_setState2, name, e), _defineProperty(_setState2, 'showFile', false), _setState2));
      if (!e) {}
      this.handleChangeData();
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this17 = this;

      this.setState({
        idCuocThanhTra: '',
        id: '',

        taiLieuVanThu: [],
        taiLieuVanThuUpdate: [],
        taiLieuVanThuDelete: [],
        dataFileDinhKem: [],
        dataTaiLieuVanThuDelete: [],
        listTaiLieuVanThu: [],

        btnLoading: false,
        btnSaveLoading: false,

        enableTheoDoi: false,
        enableDonDoc: false,
        enableKiemTra: false,

        backConfirm: false,
        hasChange: false,

        ten: '',
        theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
        theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

        linhVucKetQuaThanhTra: '',
        theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
        theoDoiDatDaThuHoiVeNganSachNhaNuoc: '',
        tienDaThuTrongQuaTrinhThanhTra: '',
        datDaThuTrongQuaTrinhThanhTra: '',
        saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
        saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
        saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
        saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',

        soQuyetDinhTheoDoiXuLyHanhChinh: '',
        soKienNghiDaThucHienXong: '',

        theoDoiToChucCoSaiPham: '',
        theoDoiToChucCoSaiPhamInit: '',
        theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
        theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
        theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
        theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',
        toChucTheoDoiSaiPham: '',

        theoDoiCaNhanCoSaiPham: '',
        theoDoiCaNhanCoSaiPhamInit: '',
        caNhanTheoDoiSaiPham: '',

        // xử lý về kinh tế

        tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

        listTheoDoiLanNopTien: [],

        lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

        saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
        saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
        saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

        lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

        saiPhamKhacTheoDoiXuLyVeKinhTe: '',

        // xử lý về hình sự
        vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
        ketQuaChuyenCoQuanDieuTra: '',
        soVuViecTheoDoiXuLyHinhSu: '',

        soDoiTuongTheoDoiXuLyHinhSuInit: '',
        soDoiTuongTheoDoiXuLyHinhSu: '',

        ghiChuTheoDoiXuLyHinhSu: '',

        kienNghiTienTheoDoiXuLyKhac: '',
        kienNghiDatTheoDoiXuLyKhac: '',
        ketQuaThucHienTheoDoiXuLyKhac: '',

        soQuyetDinhKiemTra: '',
        ngayBanHanhKiemTra: '',
        ngayBatDauKiemTra: '',
        thoiHanKiemTra: '',
        ngayHetHanKiemTra: '',
        ngayHetHanKiemTraISO: '',
        canCuKiemTra: '',
        tinhHinhKiemTra: '',
        ketQuaKiemTra: '',

        dsTaiLieuKienNghiHoanThienCoCheChinhSach: []
      }, function () {
        _this17.props.closeDialog();
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse(name) {
      if (name === 'showNoiDungDonDoc' && this.state.donDocChange === true) {
        this.setState({
          confirmDonDoc: true
        });
      } else {
        this.setState(_defineProperty({}, name, !this.state[name]));
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this18 = this;

      if (e && e._d) {
        if (name === 'ngayBatDauKiemTra') {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this18.getThoiHanKiemTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e._d));
        }
      } else {
        if (name === 'ngayBatDauKiemTra') {
          this.setState(_defineProperty({}, name, e), function () {
            _this18.getThoiHanKiemTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e));
        }
      }
      this.handleChangeData();
    }
  }, {
    key: 'getThoiHanKiemTra',
    value: function getThoiHanKiemTra() {
      var _this19 = this;

      if (this.state.ngayBatDauKiemTra) {
        this.setState({
          getThoiHanKiemTra: true
        });
        var params = {
          thoiHanThanhTra: this.state.thoiHanKiemTra ? Number(this.state.thoiHanKiemTra) : 0,
          ngayCongBoQD: (0, _moment2.default)(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString()
        };
        _api.ThanhTra.actions.getThoiHanThanhTra.request('', params).then(function (res) {
          if (res.data) {
            _this19.setState({
              ngayHetHanKiemTra: (0, _moment2.default)(new Date(res.data)).format('DD/MM/YYYY'),
              ngayHetHanKiemTraISO: res.data
            }, function () {
              _this19.setState({
                getThoiHanKiemTra: false
              });
              _this19.pushData();
            });
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this19.setState({
            getThoiHanKiemTra: false
          });
        });
      } else {
        this.setState({
          ngayHetHanKiemTra: '',
          ngayHetHanKiemTraISO: null
        });
      }
    }
  }, {
    key: 'onChangeDataDonDoc',
    value: function onChangeDataDonDoc() {
      this.setState({
        donDocChange: true
      });
      this.handleChangeData();
    }
  }, {
    key: 'confirmDonDoc',
    value: function confirmDonDoc() {
      this.setState({
        confirmDonDoc: false,
        showNoiDungDonDoc: false,
        donDocChange: false
      });
    }
  }, {
    key: 'closeDialogDonDoc',
    value: function closeDialogDonDoc() {
      this.setState({
        confirmDonDoc: false
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack == true) {
        this.resetData();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.resetData();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this20 = this;

      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.state.isOpen,
          onClose: this.handleBack.bind(this),
          title: this.props.title,
          className: 'dialog-default wrap-block' },
        _react2.default.createElement(
          'section',
          { className: 'wrap-dtkn' },
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableTheoDoi },
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungTheoDoi ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungTheoDoi') },
                  '1. Theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungTheoDoi },
                _react2.default.createElement(
                  'div',
                  { className: 'pl15 pr15 mt10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { bindValidator: this, channel: 'formTaoDon', require: true, data: this.state.dataDoiTuongThanhTra, keyName: 'ten', valueName: 'ten', className: 'col-50 has-heading', label: '1.1 T\xEAn c\u01A1 quan, t\u1ED5 ch\u1EE9c c\xF3 li\xEAn quan', placeholder: 'Nh\u1EADp...', selectedValue: this.state.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Lo\u1EA1i l\u0129nh v\u1EF1c', className: 'col-25', data: this.state.listLinhVucThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.linhVucKetQuaThanhTra, onChange: this.onChange.bind(this, 'linhVucKetQuaThanhTra'), name: 'linhVucKetQuaThanhTra' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10 mt15' },
                    '1.2. X\u1EED l\xFD thu h\u1ED3i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 pl0 pr0' },
                      _react2.default.createElement(
                        'p',
                        { className: 'title-group-input' },
                        'THU H\u1ED2I V\u1EC0 NSNN'
                      ),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'theoDoiTienDaThuHoiVeNganSachNhaNuoc'), name: 'theoDoiTienDaThuHoiVeNganSachNhaNuoc' }),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'theoDoiDatDaThuHoiVeNganSachNhaNuoc'), name: 'theoDoiDatDaThuHoiVeNganSachNhaNuoc' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 pl0 pr0' },
                      _react2.default.createElement(
                        'p',
                        { className: 'title-group-input' },
                        'THU H\u1ED2I V\u1EC0 T\u1ED4 CH\u1EE8C, \u0110\u01A0N V\u1ECA'
                      ),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'theoDoiTienDaThuTrongQuaTrinhThanhTra'), name: 'theoDoiTienDaThuTrongQuaTrinhThanhTra' }),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'theoDoiDatDaThuTrongQuaTrinhThanhTra'), name: 'theoDoiDatDaThuTrongQuaTrinhThanhTra' })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '1.3. X\u1EED l\xFD v\u1EC1 kinh t\u1EBF'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\u1ED5ng s\u1ED1 ti\u1EC1n ph\u1EA3i thu h\u1ED3i (\u0111)', placeholder: 'Nh\u1EADp...', value: this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'tongSoTienThuHoiTheoDoiXuLyVeKinhTe'), name: 'tongSoTienThuHoiTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_ListLanNopTien2.default, { data: this.state.listTheoDoiLanNopTien, onChange: this.onChange.bind(this, 'listTheoDoiLanNopTien'), name: 'listTheoDoiLanNopTien' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'lyDoThuHoiTheoDoiXuLyVeKinhTe'), name: 'lyDoThuHoiTheoDoiXuLyVeKinhTe', maxLength: 1000 }),
                    _react2.default.createElement(
                      'h2',
                      { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                      'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\xE3 thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'C\xF2n ph\u1EA3i thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe'), name: 'lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe', maxLength: 1000 }),
                    _react2.default.createElement(
                      'h2',
                      { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                      'Sai ph\u1EA1m kh\xE1c'
                    ),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung sai ph\u1EA1m kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamKhacTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamKhacTheoDoiXuLyVeKinhTe'), name: 'saiPhamKhacTheoDoiXuLyVeKinhTe', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '1.4. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD v\u1EC1 h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD h\xE0nh ch\xEDnh', placeholder: 'Nh\u1EADp...', bindValidator: this, channel: 'formTaoDon', value: this.state.soQuyetDinhTheoDoiXuLyHanhChinh, onChange: this.onChange.bind(this, 'soQuyetDinhTheoDoiXuLyHanhChinh'), name: 'soQuyetDinhTheoDoiXuLyHanhChinh', maxLength: 255 }),
                    _react2.default.createElement(_common.InputList, { label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m', hasCount: true, countUnit: 't\u1ED5 ch\u1EE9c', data: this.state.theoDoiToChucCoSaiPhamInit, onChange: this.onChange.bind(this, 'theoDoiToChucCoSaiPham'), name: 'theoDoiToChucCoSaiPham' }),
                    _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangTien'), name: 'theoDoiKienNghiXuLyHanhChinhToChucBangTien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac'), name: 'theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac', maxLength: 255 }),
                    _react2.default.createElement(_common.InputList, { label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m', hasCount: true, countUnit: 'c\xE1 nh\xE2n', data: this.state.theoDoiCaNhanCoSaiPhamInit, onChange: this.onChange.bind(this, 'theoDoiCaNhanCoSaiPham'), name: 'theoDoiCaNhanCoSaiPham' }),
                    _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangTien'), name: 'theoDoiKienNghiXuLyHanhChinhCaNhanBangTien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac'), name: 'theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac', maxLength: 255 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '1.5. X\u1EED l\xFD v\u1EC1 h\xECnh s\u1EF1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'V\u0103n b\u1EA3n \u0111\xF4n \u0111\u1ED1c c\u01A1 quan \u0111i\u1EC1u tra', placeholder: 'Nh\u1EADp...', value: this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu, onChange: this.onChange.bind(this, 'vanBanDonDocCoQuanDieuTraTheoDoiHinhSu'), name: 'vanBanDonDocCoQuanDieuTraTheoDoiHinhSu', maxLength: 255 }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataKetQuaChuyenCoQuanDieuTra, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'K\u1EBFt qu\u1EA3 chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra', selectedValue: this.state.ketQuaChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'ketQuaChuyenCoQuanDieuTra'), name: 'ketQuaChuyenCoQuanDieuTra' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c', placeholder: 'Nh\u1EADp...', value: this.state.soVuViecTheoDoiXuLyHinhSu, onChange: this.onChange.bind(this, 'soVuViecTheoDoiXuLyHinhSu'), name: 'soVuViecTheoDoiXuLyHinhSu' }),
                    _react2.default.createElement(_common.InputList, { label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', hasCount: true, countUnit: '\u0111\u1ED1i t\u01B0\u1EE3ng', data: this.state.soDoiTuongTheoDoiXuLyHinhSuInit, onChange: this.onChange.bind(this, 'soDoiTuongTheoDoiXuLyHinhSu'), name: 'soDoiTuongTheoDoiXuLyHinhSu' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'Ghi ch\xFA', placeholder: 'Nh\u1EADp...', value: this.state.ghiChuTheoDoiXuLyHinhSu, onChange: this.onChange.bind(this, 'ghiChuTheoDoiXuLyHinhSu'), name: 'ghiChuTheoDoiXuLyHinhSu', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '1.6 Ki\u1EBFn ngh\u1ECB ho\xE0n thi\u1EC7n c\u01A1 ch\u1EBF ch\xEDnh s\xE1ch'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', label: 'S\u1ED1 ki\u1EBFn ngh\u1ECB \u0111\xE3 th\u1EF1c hi\u1EC7n xong', placeholder: 'Nh\u1EADp...', value: this.state.soKienNghiDaThucHienXong, onChange: this.onChange.bind(this, 'soKienNghiDaThucHienXong'), name: 'soKienNghiDaThucHienXong', maxLength: 255 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '1.7. X\u1EED l\xFD kh\xE1c'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111)', placeholder: 'Nh\u1EADp...', value: this.state.kienNghiTienTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'kienNghiTienTheoDoiXuLyKhac'), name: 'kienNghiTienTheoDoiXuLyKhac' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2)', placeholder: 'Nh\u1EADp...', value: this.state.kienNghiDatTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'kienNghiDatTheoDoiXuLyKhac'), name: 'kienNghiDatTheoDoiXuLyKhac' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n ki\u1EBFn ngh\u1ECB kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.ketQuaThucHienTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoiXuLyKhac'), name: 'ketQuaThucHienTheoDoiXuLyKhac', maxLength: 1000 })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableDonDoc },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn custom-collapse' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungDonDoc ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungDonDoc') },
                  '2. \u0110\xF4n \u0111\u1ED1c'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungDonDoc },
                _react2.default.createElement(_ListDonDoc2.default, { toChucLienQuan: true, bindValidator: this, id: this.state.id, onChangeData: this.onChangeDataDonDoc.bind(this), onRef: function onRef(donDoc) {
                    return _this20.donDoc = donDoc;
                  } })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableKiemTra },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn custom-collapse' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungKiemTra ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungKiemTra') },
                  '3. Ki\u1EC3m Tra'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungKiemTra },
                _react2.default.createElement(
                  'div',
                  { className: 'pl15 pr15 pt15' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinhKiemTra, onChange: this.onChange.bind(this, 'soQuyetDinhKiemTra'), name: 'soQuyetDinhKiemTra', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), value: this.state.ngayBanHanhKiemTra, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhKiemTra'), name: 'ngayBanHanhKiemTra' }),
                    _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u', className: 'col-25', value: this.state.ngayBatDauKiemTra, onChange: this.handleChangeDate.bind(this, 'ngayBatDauKiemTra'), name: 'ngayBatDauKiemTra', require: true, bindValidator: this, channel: 'formTaoDon' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-thoihan col-25' },
                      _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n ki\u1EC3m tra (ng\xE0y l\xE0m vi\u1EC7c)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanKiemTra, onChange: this.onChange.bind(this, 'thoiHanKiemTra'), name: 'thoiHanKiemTra' }),
                      _react2.default.createElement(
                        'span',
                        { className: 'thoihan-value' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: !this.state.getThoiHanKiemTra },
                          _react2.default.createElement(
                            'span',
                            null,
                            this.state.ngayHetHanKiemTra ? this.state.ngayHetHanKiemTra : ''
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.getThoiHanKiemTra },
                          _react2.default.createElement('span', { className: 'icon-loader' })
                        )
                      )
                    ),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'C\u0103n c\u1EE9 ki\u1EC3m tra', value: this.state.canCuKiemTra, onChange: this.onChange.bind(this, 'canCuKiemTra'), name: 'canCuKiemTra' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'T\xECnh h\xECnh ki\u1EC3m tra', value: this.state.tinhHinhKiemTra, onChange: this.onChange.bind(this, 'tinhHinhKiemTra'), name: 'tinhHinhKiemTra' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataKetLuanVeNoiDungKiemTra, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'K\u1EBFt lu\u1EADn v\u1EC1 n\u1ED9i dung ki\u1EC3m tra', selectedValue: this.state.ketQuaKiemTra, onChange: this.onChange.bind(this, 'ketQuaKiemTra'), name: 'ketQuaKiemTra' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn pl15 pr15 pb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showFile },
              _react2.default.createElement(_upload.ContainerFileDinhKem, {
                label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                name: 'taiLieuVanThuToChucLienQuan',
                bindValidator: this,
                data: this.state.listTaiLieuVanThu,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'pr10 pl10' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.handleBack.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete btn-right-position action-todo btn-disable" : 'btn-action btn-complete btn-right-position action-todo btn-loading-inline' : "btn-action btn-complete btn-right-position action-todo", onClick: this.handleKetThuc.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Ho\xE0n Th\xE0nh'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.confirmDonDoc,
              onClose: this.closeDialogDonDoc.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body mb0' },
              _react2.default.createElement(
                'p',
                { className: 'pt10 pb20 txt-center' },
                _message.msg.confirmDonDoc
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogDonDoc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-green action-todo', onClick: this.confirmDonDoc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.showDialogConfirm,
              onClose: this.closeDialogConfirm.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body mb0' },
              _react2.default.createElement(
                'p',
                { className: 'pt10 pb20 txt-center' },
                'Sau khi ho\xE0n th\xE0nh theo d\xF5i th\u1EF1c hi\u1EC7n, b\u1EA1n s\u1EBD kh\xF4ng c\u1EADp nh\u1EADt \u0111\u01B0\u1EE3c th\xF4ng tin cho ' + this.state.ten
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-green action-todo', onClick: this.onClickConfirmKetThuc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ToChucLienQuan;
}(_react2.default.Component);

ToChucLienQuan.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: '',
  listDoiTuongViPham: []
};

exports.default = (0, _utils.validatable)(ToChucLienQuan);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemThongKeThanhTraThamNhung = exports.ListItemKetQuaTongHopKetQuaThanhTra = exports.ListItemKetQuaKiemTraDotXuat = exports.ListItemKetQuaKiemTraTheoKeHoach = exports.ListItemKetQuaKiemTraChiTiet = exports.ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh = exports.ListItemKetQuaThucHienKetLuanThanhTraHanhChinh = exports.ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh = exports.ListItemThongKeThanhTraXayTaiChinhNganSach = exports.ListItemThongKeThanhTraLai = exports.ListItemThongKeThanhTraChuyenNganh = exports.ListItemThongKeThanhTraDatDai = exports.ListItemThongKeThanhTraXayDungCoBan = exports.ListItemThongKeThanhTraHanhChinh = exports.ListItemThongKeXuLyDon = exports.ListItemThongKeGQDTC = exports.ListItemThongKeGQDKN = exports.ListItemThongKeTiepCongDan = undefined;

var _ListItemThongKeTiepCongDan = __webpack_require__(1419);

var _ListItemThongKeTiepCongDan2 = _interopRequireDefault(_ListItemThongKeTiepCongDan);

var _ListItemThongKeGQDKN = __webpack_require__(1409);

var _ListItemThongKeGQDKN2 = _interopRequireDefault(_ListItemThongKeGQDKN);

var _ListItemThongKeGQDTC = __webpack_require__(1410);

var _ListItemThongKeGQDTC2 = _interopRequireDefault(_ListItemThongKeGQDTC);

var _ListItemThongKeXuLyDon = __webpack_require__(1420);

var _ListItemThongKeXuLyDon2 = _interopRequireDefault(_ListItemThongKeXuLyDon);

var _ListItemThongKeThanhTraHanhChinh = __webpack_require__(1414);

var _ListItemThongKeThanhTraHanhChinh2 = _interopRequireDefault(_ListItemThongKeThanhTraHanhChinh);

var _ListItemThongKeThanhTraDatDai = __webpack_require__(1413);

var _ListItemThongKeThanhTraDatDai2 = _interopRequireDefault(_ListItemThongKeThanhTraDatDai);

var _ListItemThongKeThanhTraXayDungCoBan = __webpack_require__(1417);

var _ListItemThongKeThanhTraXayDungCoBan2 = _interopRequireDefault(_ListItemThongKeThanhTraXayDungCoBan);

var _ListItemThongKeThanhTraXayTaiChinhNganSach = __webpack_require__(1418);

var _ListItemThongKeThanhTraXayTaiChinhNganSach2 = _interopRequireDefault(_ListItemThongKeThanhTraXayTaiChinhNganSach);

var _ListItemThongKeThanhTraChuyenNganh = __webpack_require__(1412);

var _ListItemThongKeThanhTraChuyenNganh2 = _interopRequireDefault(_ListItemThongKeThanhTraChuyenNganh);

var _ListItemThongKeThanhTraLai = __webpack_require__(1415);

var _ListItemThongKeThanhTraLai2 = _interopRequireDefault(_ListItemThongKeThanhTraLai);

var _ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh = __webpack_require__(1421);

var _ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh2 = _interopRequireDefault(_ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh);

var _ListItemKetQuaThucHienKetLuanThanhTraHanhChinh = __webpack_require__(1407);

var _ListItemKetQuaThucHienKetLuanThanhTraHanhChinh2 = _interopRequireDefault(_ListItemKetQuaThucHienKetLuanThanhTraHanhChinh);

var _ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh = __webpack_require__(1411);

var _ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh2 = _interopRequireDefault(_ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh);

var _ListItemKetQuaKiemTraChiTiet = __webpack_require__(1404);

var _ListItemKetQuaKiemTraChiTiet2 = _interopRequireDefault(_ListItemKetQuaKiemTraChiTiet);

var _ListItemKetQuaKiemTraTheoKeHoach = __webpack_require__(1406);

var _ListItemKetQuaKiemTraTheoKeHoach2 = _interopRequireDefault(_ListItemKetQuaKiemTraTheoKeHoach);

var _ListItemKetQuaKiemTraDotXuat = __webpack_require__(1405);

var _ListItemKetQuaKiemTraDotXuat2 = _interopRequireDefault(_ListItemKetQuaKiemTraDotXuat);

var _ListItemKetQuaTongHopKetQuaThanhTra = __webpack_require__(1408);

var _ListItemKetQuaTongHopKetQuaThanhTra2 = _interopRequireDefault(_ListItemKetQuaTongHopKetQuaThanhTra);

var _ListItemThongKeThanhTraThamNhung = __webpack_require__(1416);

var _ListItemThongKeThanhTraThamNhung2 = _interopRequireDefault(_ListItemThongKeThanhTraThamNhung);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ListItemThongKeTiepCongDan = _ListItemThongKeTiepCongDan2.default;
exports.ListItemThongKeGQDKN = _ListItemThongKeGQDKN2.default;
exports.ListItemThongKeGQDTC = _ListItemThongKeGQDTC2.default;
exports.ListItemThongKeXuLyDon = _ListItemThongKeXuLyDon2.default;
exports.ListItemThongKeThanhTraHanhChinh = _ListItemThongKeThanhTraHanhChinh2.default;
exports.ListItemThongKeThanhTraXayDungCoBan = _ListItemThongKeThanhTraXayDungCoBan2.default;
exports.ListItemThongKeThanhTraDatDai = _ListItemThongKeThanhTraDatDai2.default;
exports.ListItemThongKeThanhTraChuyenNganh = _ListItemThongKeThanhTraChuyenNganh2.default;
exports.ListItemThongKeThanhTraLai = _ListItemThongKeThanhTraLai2.default;
exports.ListItemThongKeThanhTraXayTaiChinhNganSach = _ListItemThongKeThanhTraXayTaiChinhNganSach2.default;
exports.ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh = _ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh2.default;
exports.ListItemKetQuaThucHienKetLuanThanhTraHanhChinh = _ListItemKetQuaThucHienKetLuanThanhTraHanhChinh2.default;
exports.ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh = _ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh2.default;
exports.ListItemKetQuaKiemTraChiTiet = _ListItemKetQuaKiemTraChiTiet2.default;
exports.ListItemKetQuaKiemTraTheoKeHoach = _ListItemKetQuaKiemTraTheoKeHoach2.default;
exports.ListItemKetQuaKiemTraDotXuat = _ListItemKetQuaKiemTraDotXuat2.default;
exports.ListItemKetQuaTongHopKetQuaThanhTra = _ListItemKetQuaTongHopKetQuaThanhTra2.default;
exports.ListItemThongKeThanhTraThamNhung = _ListItemThongKeThanhTraThamNhung2.default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDocumentDetail = function (_React$Component) {
  _inherits(RowItemDocumentDetail, _React$Component);

  function RowItemDocumentDetail(props, context) {
    _classCallCheck(this, RowItemDocumentDetail);

    var _this = _possibleConstructorReturn(this, (RowItemDocumentDetail.__proto__ || Object.getPrototypeOf(RowItemDocumentDetail)).call(this, props, context));

    _this.state = {
      disable: false
    };
    return _this;
  }

  _createClass(RowItemDocumentDetail, [{
    key: 'handleDownload',
    value: function handleDownload() {
      try {
        this.setState({ disable: true });
        var taiLieuVanThu = this.props.item.listTaiLieuVanThus[0];
        (0, _utils.downloadFile)(taiLieuVanThu.duongDan, taiLieuVanThu.tenFile, null, undefined, true);
      } catch (err) {
        console.error(err);
      } finally {
        setTimeout(function () {
          this.setState({ disable: false });
        }.bind(this), 2000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var taiLieuVanThu = (0, _lodash.isArray)((0, _lodash.get)(this.props.item, 'listTaiLieuVanThus')) && this.props.item.listTaiLieuVanThus.length > 0 ? (0, _lodash.get)(this.props.item, 'listTaiLieuVanThus[0]') : null;
      var _props$item = this.props.item,
          donViXuLyInfo = _props$item.donViXuLyInfo,
          tenInfo = _props$item.tenInfo;

      if (!this.props.item) {
        return null;
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(donViXuLyInfo, 'ten')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(tenInfo, 'ten')
        ),
        _react2.default.createElement(
          'td',
          null,
          taiLieuVanThu && _react2.default.createElement(
            _reactRouter.Link,
            {
              className: (0, _classnames2.default)('txt-underline', {
                isDisable: this.state.disable
              }),
              onClick: _config.checkServerLive ? this.handleDownload.bind(this) : _jsFileDownload2.default.bind(this, taiLieuVanThu.duongDan, taiLieuVanThu.tenFile)
            },
            (0, _lodash.get)(taiLieuVanThu, 'tenFile')
          )
        )
      );
    }
  }]);

  return RowItemDocumentDetail;
}(_react2.default.Component);

exports.default = RowItemDocumentDetail;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaTraCuu = function (_React$Component) {
  _inherits(RowItemKetQuaTraCuu, _React$Component);

  function RowItemKetQuaTraCuu() {
    _classCallCheck(this, RowItemKetQuaTraCuu);

    return _possibleConstructorReturn(this, (RowItemKetQuaTraCuu.__proto__ || Object.getPrototypeOf(RowItemKetQuaTraCuu)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaTraCuu, [{
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;
      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon(thoiHanXuLy) {
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showCanBoDangXuLy',
    value: function showCanBoDangXuLy() {
      var _this2 = this;

      this.props.item.canBoDangXuLyInfo.filter(function (item) {
        return item.donViId == _this2.props.userInfo.donViId;
      }).map(function (child, i) {
        if (child.hoVaTen != "") _this2.setState({
          canBoXuLy: child.hoVaTen
        });
      });
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      if (data) {
        if (data.diaChi) {
          address.push(data.diaChi);
        }
        if (data.toThon) {
          address.push(data.toThon);
        }
        if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
          address.push(data.phuongXaCongDan.ten);
        }
        if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
          address.push(data.quanHuyenCongDan.ten);
        }
        if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
          address.push(data.tinhThanhCongDan.ten);
        }
      }
      return address.join(", ");
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo) {
        var dataNguonDon = (0, _lodash.isArray)(this.props.item.nguonDonInfo) && this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });
        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else if (this.props.isDonCu) {
          nguonDonText = (0, _lodash.get)(this.props.item, 'nguonDonInfo.ten');
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type === 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type === 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type === 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var donDate = this.props.item.ngayTiepNhanDon ? (0, _moment2.default)(this.props.item.ngayTiepNhanDon).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhanDon ? (0, _moment2.default)(this.props.item.ngayTiepNhanDon).format('HH:mm') : '';
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      var loaiDon = function loaiDon() {
        var tenLoaiDon = '';
        if (_this3.props.isDonCu) {
          tenLoaiDon = (0, _lodash.get)(_this3.props.item, 'loaiDonInfo.ten');
        }
        if (_this3.props.item.loaiDonThuInfo) {
          tenLoaiDon = (0, _lodash.get)(_this3.props.item, 'loaiDonThuInfo.ten');
        }
        return tenLoaiDon;
      };
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        !this.props.isDonCu && _react2.default.createElement(
          'td',
          null,
          this.props.item.maHoSo || ''
        ),
        !this.props.isDonCu && _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.isDonCu ? _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: {
                    pathname: '/chi-tiet-don-cu/' + (0, _lodash.get)(this.props.item, 'donCuId'),
                    state: { phamVi: this.props.phamVi }
                  } },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              ) : _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: {
                    pathname: '/chi-tiet-tra-cuu/' + (0, _lodash.get)(this.props.item, 'maHoSo'),
                    state: { phamVi: this.props.phamVi }
                  } },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            this.props.item.trangThaiDonType !== 'DA_XU_LY' && this.props.item.trangThaiDonType !== 'DA_GIAI_QUYET' && this.props.item.thoiHanInfo ? _react2.default.createElement(
              'li',
              null,
              this.showThoiHanXuLyDon(this.props.item.thoiHanInfo)
            ) : ''
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              loaiDon()
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.phamVi === 'SCOPE' ? _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            nguonDonDonVi !== '' && nguonDonDonVi !== null && _react2.default.createElement(
              'li',
              { className: 'txt-italic' },
              nguonDonDonVi
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          ) : _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.isDonCu ? (0, _lodash.get)(this.props.item, 'nguonDonInfo.ten') : (0, _lodash.get)(this.props.item, 'nguonDon')
            )
          )
        )
      );
    }
  }]);

  return RowItemKetQuaTraCuu;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemKetQuaTraCuu);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _message = __webpack_require__(10);

var _reactDatetime = __webpack_require__(2172);

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

__webpack_require__(396);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props, context) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props, context));

    _this.state = {
      isValid: true,
      value: _this.props.value,
      startDate: _this.props.startDate,
      endDate: _this.props.endDate,
      message: ''
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'onChange',
    value: function onChange(e) {
      var inputDate = e;
      if (e._d) {
        inputDate = e._d;
      }

      this.setState({
        value: inputDate
      });
      this.props.onChange(inputDate);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.startDate != this.state.startDate) {
        this.setState({
          startDate: nextProps.startDate
        });
      }

      if (nextProps.endDate != this.state.endDate) {
        this.setState({
          endDate: nextProps.endDate
        });
      }

      if (nextProps.value != this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }

      if (!this.state.isValid && nextProps.require && !nextProps.value) {
        this.setState({
          isValid: false,
          message: this.props.requireMessage
        });
      } else if (nextProps.value && !(0, _moment2.default)(nextProps.value, CONFIG.DateFormat).isValid()) {
        this.setState({
          isValid: false,
          message: this.props.errMessage
        });
      } else if (!nextProps.require && (0, _moment2.default)(nextProps.value, CONFIG.DateFormat).isValid() || nextProps.require && nextProps.value && (0, _moment2.default)(nextProps.value, CONFIG.DateFormat).isValid()) {
        this.setState({
          isValid: true
        });
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (this.state.isValid) {
        return 'calendar_icon';
      } else {
        return 'calendar_icon pt-datepicker-danger';
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.props.value != this.state.value) {
        this.props.onChange(this.state.value);
      }
      var isValid = typeof this.state.value == 'string' && this.state.value.trim() == '' || (0, _moment2.default)(this.state.value, CONFIG.DateFormat).isValid();

      this.setState({ isValid: isValid });

      if (this.props.require && typeof this.state.value == 'string' && this.state.value.trim() == '') {
        this.setState({
          // TODO: Need to check if date string is valid, eg: '20/07/32ab'
          isValid: false,
          message: this.props.requireMessage
        });
        this.input.focus();
        return false;
      } else if (!isValid) {
        this.setState({
          // TODO: Need to check if date string is valid, eg: '20/07/32ab'
          isValid: false,
          message: this.props.errMessage
        });
        this.input.focus();
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      var _this2 = this;

      setTimeout(function () {
        _this2.validate();
      }, 500);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt-label mb0' },
          _react2.default.createElement(_reactDatetime2.default, {
            className: this.classNames(),
            onChange: this.onChange.bind(this),
            dateFormat: this.props.dateFormat,
            closeOnSelect: !this.props.timeFormat ? true : false,
            timeFormat: this.props.timeFormat,
            value: this.state.value,
            isValidDate: this.props.isValidDate.bind(this),
            onBlur: this.handleBlur.bind(this),
            inputProps: { placeholder: this.props.placeholder, maxLength: this.props.maxLength, name: this.props.name, autoComplete: 'off', disabled: this.props.disabled },
            locale: 'vi',
            renderMonth: function renderMonth(props, month) {
              return _react2.default.createElement(
                'td',
                props,
                'T ',
                month + 1
              );
            }
          }),
          _react2.default.createElement('input', { className: 'hidden-input', ref: function ref(input) {
              _this3.input = input;
            } })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            this.state.message
          )
        )
      );
    }
  }]);

  return DatePicker;
}(_react2.default.Component);

function isValidDate(current) {
  var validBefore = true,
      validAfter = true;

  if ((0, _moment2.default)(this.state.startDate, CONFIG.DateFormat).isValid()) {
    validBefore = !current.isBefore((0, _moment2.default)(this.state.startDate, CONFIG.DateFormat));
  }

  if ((0, _moment2.default)(this.state.endDate, CONFIG.DateFormat).isValid()) {
    validAfter = !current.isAfter((0, _moment2.default)(this.state.endDate, CONFIG.DateFormat));
  }

  return validBefore && validAfter;
}

DatePicker.defaultProps = {
  className: 'input-group',
  label: '',
  timeFormat: false,
  dateFormat: CONFIG.DateFormat,
  placeholder: 'dd/MM/yyyy',
  maxLength: 10,
  value: '',
  require: false,
  errMessage: _message.msg.dateInvalid,
  requireMessage: _message.msg.messageDefault,
  onChange: function onChange() {
    console.log('Please assign onChange method');
  },
  startDate: '',
  endDate: '',
  isValidDate: isValidDate,
  name: '',
  disabled: false
};

exports.default = (0, _utils.validatable)(DatePicker);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _validate = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props, context) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      isValid: true
    };
    return _this;
  }

  _createClass(Input, [{
    key: 'onChange',
    value: function onChange(e) {
      if (this.props.type == 'sdt') {
        e.target.value = (0, _validate.PhoneNumber)(e.target.value);
      } else if (this.props.type == 'cmnd') {
        e.target.value = (0, _validate.CMNDNumber)(e.target.value);
      }
      this.setState({
        value: e.target.value,
        isValid: true
      });
      if (this.props.triggeOnBlur != true) {
        this.props.onChange(e);
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      e.target.value = e.target.value.trim();
      if (this.props.triggeOnBlur == true) {
        if (this.props.type == 'sdt') {
          e.target.value = (0, _validate.PhoneNumber)(e.target.value);
        } else if (this.props.type == 'cmnd') {
          e.target.value = (0, _validate.CMNDNumber)(e.target.value);
        }
        this.setState({
          value: e.target.value
        });
        this.props.onChange(e);
      }
      this.props.onBlur();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      this.setState({
        value: nextProps.value
      });
      if (nextProps.require && typeof nextProps.value == 'string' && nextProps.value.trim()) {
        this.setState({
          isValid: true
        });
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (this.state.isValid) {
        return 'pt-input';
      } else {
        return 'pt-input pt-intent-danger';
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if ((typeof this.state.value == 'string' && this.state.value.trim() == '' || this.props.type == 'sdt' && this.state.value == 0) && this.props.require) {
        this.setState({
          isValid: false
        });
        this.input.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      e.target.select();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement('input', { disabled: this.props.disabled, onBlur: this.handleBlur.bind(this), onFocus: this.handleFocus.bind(this), style: { textAlign: this.props.align }, type: 'text', className: this.classNames(), ref: function ref(input) {
            _this2.input = input;
          }, maxLength: this.props.maxLength > 0 ? this.props.maxLength : this.props.type == 'sdt' ? 15 : 255, value: this.state.value, onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: this.props.name, onKeyDown: this.props.onKeyDown }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && this.state.value.trim() == '' },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && this.state.value.trim() != '' && this.state.value == 0 },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.dataInvalid
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.trungMa === true },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            'M\xE3 doanh nghi\u1EC7p \u0111\xE3 t\u1ED3n t\u1EA1i trong h\u1EC7 th\u1ED1ng'
          )
        )
      );
    }
  }]);

  return Input;
}(_react2.default.Component);

Input.defaultProps = {
  type: '',
  className: 'input-group',
  label: '',
  align: 'left',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  placeholder: null,
  require: false,
  maxLength: 0,
  name: '',
  triggeOnBlur: false,
  disabled: false,
  trungMa: false
};

exports.default = (0, _utils.validatable)(Input);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ItemSelected = __webpack_require__(1573);

var _ItemSelected2 = _interopRequireDefault(_ItemSelected);

var _ShowIf = __webpack_require__(198);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataSelected = function (_React$Component) {
  _inherits(DataSelected, _React$Component);

  function DataSelected(props, context) {
    _classCallCheck(this, DataSelected);

    var _this = _possibleConstructorReturn(this, (DataSelected.__proto__ || Object.getPrototypeOf(DataSelected)).call(this, props, context));

    _this.state = {
      data: _this.props.dataSelected,
      value: _this.props.value,
      only: _this.props.only,
      dataOptions: _this.props.dataOptions,
      thanhTraCQQL: _this.props.thanhTraCQQL,
      keyName: _this.props.keyName
    };
    return _this;
  }

  _createClass(DataSelected, [{
    key: 'removeSelected',
    value: function removeSelected(index) {
      var dataPush = {
        value: this.state.data[index].value,
        label: this.state.data[index].label
      };
      this.props.removeSelected(dataPush);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.dataSelected,
        dataOptions: nextProps.dataOptions,
        thanhTraCQQL: this.props.thanhTraCQQL,
        only: nextProps.only,
        value: nextProps.value,
        keyName: nextProps.keyName
      });
    }
  }, {
    key: 'toggleOption',
    value: function toggleOption(e) {
      this.props.toggleOption();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dataSelected = this.state.data.map(function (state, index) {
        var getQuanHuyen = '';
        var check = _this2.props.dataOptions.findIndex(function (item) {
          return item.coQuanQuanLyCha && item.coQuanQuanLyCha.capCoQuanQuanLyId === parseInt(_this2.props.thanhTraCQQL) && item.coQuanQuanLyId === state.value;
        });
        if (check !== -1) {
          getQuanHuyen = ' - ' + _this2.props.dataOptions[check].coQuanQuanLyCha.ten;
        }
        return _react2.default.createElement(_ItemSelected2.default, { key: index, only: _this2.state.only, capQuanHuyen: getQuanHuyen, thanhTraCQQL: _this2.props.thanhTraCQQL, label: state.label, value: state.value, index: index, removeSelected: _this2.removeSelected.bind(_this2, index) });
      });
      var dataOptions = [].concat(_toConsumableArray(this.state.dataOptions));
      var value = dataOptions.filter(function (state) {
        return state[_this2.state.keyName] == _this2.state.value;
      });
      return _react2.default.createElement(
        'section',
        { className: 'rs-wrap-selected' },
        _react2.default.createElement(
          'div',
          { className: 'rs-data-selected' },
          _react2.default.createElement('span', { className: 'rs-data-selected-background', name: this.props.name, onClick: this.toggleOption.bind(this) }),
          _react2.default.createElement(
            _ShowIf2.default,
            { condition: this.state.only },
            _react2.default.createElement(
              'span',
              { className: 'rs-place-holder rs-value' },
              value.length > 0 ? value[0].ten : ''
            )
          ),
          _react2.default.createElement(
            _ShowIf2.default,
            { condition: !this.state.only },
            dataSelected
          )
        )
      );
    }
  }]);

  return DataSelected;
}(_react2.default.Component);

DataSelected.defaultProps = {
  dataSelected: [],
  dataOptions: [],
  value: '',
  only: false,
  keyName: '',
  name: ''
};

exports.default = DataSelected;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ShowIf = __webpack_require__(198);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

var _method = __webpack_require__(322);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemChildren = function (_React$Component) {
  _inherits(ItemChildren, _React$Component);

  function ItemChildren(props, context) {
    _classCallCheck(this, ItemChildren);

    var _this = _possibleConstructorReturn(this, (ItemChildren.__proto__ || Object.getPrototypeOf(ItemChildren)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      label: _this.props.label,
      dataSelected: _this.props.dataSelected,
      dataQuan: _this.props.dataQuan,
      thanhTraQuanHuyenId: '',
      status: false,
      showChildren: false,
      only: _this.props.only,
      itemSelected: _this.props.value,
      selected: false
    };
    return _this;
  }

  _createClass(ItemChildren, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkDataSelected();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.setState({
        value: nextProps.value,
        label: nextProps.label,
        dataSelected: nextProps.dataSelected,
        dataQuan: nextProps.dataQuan,
        itemSelected: nextProps.itemSelected
      }, function () {
        _this2.checkDataSelected();
      });
    }
  }, {
    key: 'onCheck',
    value: function onCheck() {
      var _this3 = this;

      this.setState({
        status: !this.state.status
      }, function () {
        _this3.pushOutData();
      });
    }
  }, {
    key: 'pushOutData',
    value: function pushOutData() {
      if (this.state.only) {
        var dataPush = this.state.value;
        this.props.selectedOption(dataPush);
      } else {
        var _dataPush = {
          value: this.state.value,
          label: this.state.label
        };
        if (this.state.status) {
          this.props.selectedOption(_dataPush);
        } else {
          this.props.removeOption(_dataPush);
        }
      }
    }
  }, {
    key: 'toggleChilden',
    value: function toggleChilden() {
      this.setState({
        showChildren: !this.state.showChildren
      });
    }
  }, {
    key: 'checkDataSelected',
    value: function checkDataSelected() {
      if (this.state.only) {
        if (this.state.value == this.state.itemSelected) {
          this.setState({
            selected: true
          });
        } else {
          this.setState({
            selected: false
          });
        }
      } else {
        if ((0, _method.arrayObjectIndexOf)(this.state.dataSelected, this.state.value, 'value') == -1) {
          this.setState({
            status: false
          });
        } else {
          this.setState({
            status: true
          });
        }
      }
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this4 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CCQQL_UBND_QUAN_HUYEN' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this4.setState({ thanhTraQuanHuyenId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var getQuan = '';
      if (this.props.dataQuan && this.props.dataQuan.capCoQuanQuanLyId && this.props.dataQuan.capCoQuanQuanLyId === parseInt(this.state.thanhTraQuanHuyenId)) {
        getQuan = ' - ' + this.props.dataQuan.ten;
      }
      return _react2.default.createElement(
        'div',
        { className: this.props.children && this.props.children.length > 0 ? 'rs-children has-children pl25' : 'rs-children pl25' },
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: !this.state.only },
          _react2.default.createElement(
            'span',
            { className: 'rs-wrap-ckeckbox' },
            _react2.default.createElement('input', { type: 'checkbox', checked: this.state.status, value: this.state.status, onChange: this.onCheck.bind(this) }),
            _react2.default.createElement('span', { className: 'rs-checked-icon' })
          )
        ),
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: typeof this.props.children != 'undefined' && this.props.children.length > 0 },
          _react2.default.createElement('span', { className: this.state.showChildren ? 'rs-toggle-children showed' : 'rs-toggle-children', onClick: this.toggleChilden.bind(this) })
        ),
        _react2.default.createElement(
          'span',
          { className: this.state.selected ? 'rs-label rs-selected' : 'rs-label', onClick: this.onCheck.bind(this) },
          this.state.label + getQuan
        ),
        _react2.default.createElement(
          'div',
          { className: this.state.showChildren ? '' : 'hidden' },
          this.props.children
        )
      );
    }
  }]);

  return ItemChildren;
}(_react2.default.Component);

ItemChildren.defaultProps = {
  value: '',
  label: '',
  dataSelected: [],
  only: false,
  itemSelected: ''
};

exports.default = ItemChildren;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ShowIf = __webpack_require__(198);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

var _method = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemParents = function (_React$Component) {
  _inherits(ItemParents, _React$Component);

  function ItemParents(props, context) {
    _classCallCheck(this, ItemParents);

    var _this = _possibleConstructorReturn(this, (ItemParents.__proto__ || Object.getPrototypeOf(ItemParents)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      label: _this.props.label,
      dataSelected: _this.props.dataSelected,
      status: false,
      showChildren: false,
      only: _this.props.only,
      itemSelected: _this.props.value,
      selected: false
    };
    return _this;
  }

  _createClass(ItemParents, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkDataSelected();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.setState({
        value: nextProps.value,
        label: nextProps.label,
        dataSelected: nextProps.dataSelected,
        itemSelected: nextProps.itemSelected
      }, function () {
        _this2.checkDataSelected();
      });
    }
  }, {
    key: 'onCheck',
    value: function onCheck() {
      var _this3 = this;

      this.setState({
        status: !this.state.status
      }, function () {
        _this3.pushOutData();
      });
    }
  }, {
    key: 'pushOutData',
    value: function pushOutData() {
      if (this.state.only) {
        var dataPush = this.state.value;
        this.props.selectedOption(dataPush);
      } else {
        var _dataPush = {
          value: this.state.value,
          label: this.state.label
        };
        if (this.state.status) {
          this.props.selectedOption(_dataPush);
        } else {
          this.props.removeOption(_dataPush);
        }
      }
    }
  }, {
    key: 'toggleChilden',
    value: function toggleChilden() {
      this.setState({
        showChildren: !this.state.showChildren
      });
    }
  }, {
    key: 'checkDataSelected',
    value: function checkDataSelected() {
      if (this.state.only) {
        if (this.state.value == this.state.itemSelected) {
          this.setState({
            selected: true
          });
        } else {
          this.setState({
            selected: false
          });
        }
      } else {
        if ((0, _method.arrayObjectIndexOf)(this.state.dataSelected, this.state.value, 'value') == -1) {
          this.setState({
            status: false
          });
        } else {
          this.setState({
            status: true
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.children && this.props.children.length > 0 ? 'rs-parents has-children pl25' : 'rs-parents pl25' },
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: !this.state.only },
          _react2.default.createElement(
            'span',
            { className: 'rs-wrap-ckeckbox' },
            _react2.default.createElement('input', { type: 'checkbox', checked: this.state.status, value: this.state.status, onChange: this.onCheck.bind(this) }),
            _react2.default.createElement('span', { className: 'rs-checked-icon' })
          )
        ),
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: typeof this.props.children != 'undefined' && this.props.children.length > 0 },
          _react2.default.createElement('span', { className: this.state.showChildren ? 'rs-toggle-children showed' : 'rs-toggle-children', onClick: this.toggleChilden.bind(this) })
        ),
        _react2.default.createElement(
          'span',
          { className: this.state.selected ? 'rs-label rs-selected' : 'rs-label', onClick: this.onCheck.bind(this) },
          this.state.label
        ),
        _react2.default.createElement(
          'div',
          { className: this.state.showChildren ? '' : 'hidden' },
          this.props.children
        )
      );
    }
  }]);

  return ItemParents;
}(_react2.default.Component);

ItemParents.defaultProps = {
  value: '',
  label: '',
  dataSelected: [],
  only: false,
  itemSelected: ''
};

exports.default = ItemParents;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactTreeSelectOneElement = exports.ReactTreeSelect = undefined;

var _ReactTreeSelect = __webpack_require__(1574);

var _ReactTreeSelect2 = _interopRequireDefault(_ReactTreeSelect);

var _ReactTreeSelectOneElement = __webpack_require__(1575);

var _ReactTreeSelectOneElement2 = _interopRequireDefault(_ReactTreeSelectOneElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ReactTreeSelect = _ReactTreeSelect2.default;
exports.ReactTreeSelectOneElement = _ReactTreeSelectOneElement2.default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _checkLimitFile = __webpack_require__(1583);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _lodash = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemFileDinhKem = function (_React$Component) {
  _inherits(RowItemFileDinhKem, _React$Component);

  function RowItemFileDinhKem(props, context) {
    _classCallCheck(this, RowItemFileDinhKem);

    var _this = _possibleConstructorReturn(this, (RowItemFileDinhKem.__proto__ || Object.getPrototypeOf(RowItemFileDinhKem)).call(this, props, context));

    _this.state = {
      hasChangeDate: false,
      type: _this.props.type,
      taiLieuVanThuId: _this.props.taiLieuVanThuId,
      taiLieuBaoCaoId: _this.props.taiLieuBaoCaoId,
      ten: _this.props.ten,
      tenFile: _this.props.tenFile,
      tenFileds: _this.props.tenFileds,
      ngayQuyetDinh: _this.props.ngayQuyetDinh || '',
      soQuyetDinh: _this.props.soQuyetDinh,
      progress: 0,
      duongDan: _this.props.duongDan,
      isValid: true,
      required: _this.props.required,
      typeRequired: _this.props.typeRequired,
      newFile: _this.props.newFile,

      loaiTepDinhKem: _this.props.loaiTepDinhKem,
      loaiQuyTrinh: _this.props.loaiQuyTrinh,

      tinhTrang: _this.props.tinhTrang,
      taiLieuBangChungId: _this.props.taiLieuBangChungId,
      count: _this.props.count,

      buocGiaiQuyet: _this.props.buocGiaiQuyet,

      phanLoaiQuyTrinh: _this.props.phanLoaiQuyTrinh,
      onSave: _this.props.onSave,
      isError: false,
      nhomHoSo: (0, _lodash.get)(_this.props, 'nhomHoSoInfo.nhomHoSoId'),
      isDsVanBanXuLy: _this.props.isDsVanBanXuLy
    };
    return _this;
  }

  _createClass(RowItemFileDinhKem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.openUpLoad();
      }
    }
  }, {
    key: 'openUpLoad',
    value: function openUpLoad() {
      this.refs.btnUpload.click();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.type == 'TAI_LIEU_DINH_KEM') {
        var getDate = function getDate() {
          var ngayQuyetDinh = nextProps.ngayQuyetDinh;
          if (!_this2.state.hasChangeDate) {
            if ((0, _moment2.default)(nextProps.ngayQuyetDinh).isValid()) {
              if (!nextProps.unSetNgayBanHanh) {
                ngayQuyetDinh = (0, _moment2.default)(nextProps.ngayQuyetDinh);
              } else {
                if ((0, _moment2.default)(nextProps.ngayQuyetDinh).isValid()) {
                  ngayQuyetDinh = (0, _moment2.default)(nextProps.ngayQuyetDinh);
                } else {
                  ngayQuyetDinh = new Date(nextProps.ngayQuyetDinh);
                }
              }
            }
          }
          return ngayQuyetDinh;
        };
        this.setState({
          ten: nextProps.ten,
          unSetNgayBanHanh: nextProps.unSetNgayBanHanh,
          tenFile: nextProps.tenFile,
          tenFileds: nextProps.tenFileds,
          soQuyetDinh: nextProps.soQuyetDinh,
          ngayQuyetDinh: getDate(),
          taiLieuVanThuId: nextProps.taiLieuVanThuId,
          taiLieuBaoCaoId: nextProps.taiLieuBaoCaoId,
          progress: 0,
          loaiTepDinhKem: nextProps.loaiTepDinhKem,
          loaiQuyTrinh: nextProps.loaiQuyTrinh,
          duongDan: nextProps.duongDan,
          required: nextProps.required,
          typeRequired: nextProps.typeRequired,
          newFile: nextProps.newFile,
          buocGiaiQuyet: nextProps.buocGiaiQuyet,
          phanLoaiQuyTrinh: nextProps.phanLoaiQuyTrinh,
          onSave: nextProps.onSave
        });
      } else {
        this.setState({
          ten: nextProps.ten,
          tenFile: nextProps.tenFile,
          tenFileds: nextProps.tenFileds,
          tinhTrang: nextProps.tinhTrang,
          taiLieuVanThuId: nextProps.taiLieuVanThuId,
          taiLieuBaoCaoId: nextProps.taiLieuBaoCaoId,
          duongDan: nextProps.duongDan,
          taiLieuBangChungId: nextProps.taiLieuBangChungId,
          progress: 0,
          required: nextProps.required,
          typeRequired: nextProps.typeRequired,
          newFile: nextProps.newFile,
          buocGiaiQuyet: nextProps.buocGiaiQuyet,
          phanLoaiQuyTrinh: nextProps.phanLoaiQuyTrinh,
          onSave: nextProps.onSave
        });
      }

      if (nextProps.resetRequired || nextProps.onSave || this.props.isTiepNhanDon !== undefined && nextProps.isTiepNhanDon != this.props.isTiepNhanDon) {
        this.setState({
          isValid: true
        });
      }
      if (this.state.typeRequired == 'QDGQ_TTT' || this.state.typeRequired == 'QDGQ_LDT' || this.state.typeRequired == nextProps.loaiVanBanSuggest) {
        if (this.props.ngayQuyetDinhSuggest != nextProps.ngayQuyetDinhSuggest) {
          var newState = _extends({}, this.state, {
            ngayQuyetDinh: nextProps.ngayQuyetDinhSuggest
          });

          this.setState(_extends({}, newState));
          if (nextProps.ngayQuyetDinhSuggest != this.state.ngayQuyetDinh) {
            this.pushData(newState);
          }
        }
        if (this.props.soVanBanSuggest != nextProps.soVanBanSuggest) {
          var _newState = _extends({}, this.state, {
            soQuyetDinh: nextProps.soVanBanSuggest
          });

          this.setState(_extends({}, _newState));

          this.pushData(_newState);
        }
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, e) {
        var newData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newData = _extends({}, this.state);


                if (e && e._d) {
                  newData[name] = e._d;
                } else {
                  newData[name] = e;
                }
                _context.next = 4;
                return this.setState(_extends({}, newData, {
                  hasChangeDate: true
                }));

              case 4:
                this.pushData(newData);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleChangeDate(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleChangeDate;
    }()
  }, {
    key: 'pushData',
    value: function pushData(newState) {
      if (this.state.type == 'TAI_LIEU_DINH_KEM') {
        var params = {
          unSetNgayBanHanh: newState.unSetNgayBanHanh,
          ten: newState.ten,
          tenFile: newState.tenFile,
          tenFileds: newState.tenFileds,
          ngayQuyetDinh: newState.ngayQuyetDinh || '',
          soQuyetDinh: newState.soQuyetDinh,
          taiLieuVanThuId: newState.taiLieuVanThuId,
          taiLieuBaoCaoId: newState.taiLieuBaoCaoId,
          progress: 0,
          loaiTepDinhKem: newState.loaiTepDinhKem,
          loaiQuyTrinh: newState.loaiQuyTrinh,
          duongDan: newState.duongDan,
          required: newState.required,
          typeRequired: newState.typeRequired,
          newFile: newState.newFile,
          buocGiaiQuyet: newState.buocGiaiQuyet,
          phanLoaiQuyTrinh: newState.phanLoaiQuyTrinh,
          isValid: newState.isValid,
          nhomHoSo: newState.nhomHoSo
        };
        this.props.onFileChange(params);
      } else {
        var _params = {
          ten: newState.ten,
          tenFile: newState.tenFile,
          tenFileds: newState.tenFileds,
          taiLieuVanThuId: newState.taiLieuVanThuId,
          taiLieuBaoCaoId: newState.taiLieuBaoCaoId,
          tinhTrang: newState.tinhTrang,
          duongDan: newState.duongDan,
          taiLieuBangChungId: newState.taiLieuBangChungId,
          progress: 0,
          required: newState.required,
          typeRequired: newState.typeRequired,
          newFile: newState.newFile,
          buocGiaiQuyet: newState.buocGiaiQuyet,
          phanLoaiQuyTrinh: newState.phanLoaiQuyTrinh,
          isValid: newState.isValid,
          nhomHoSo: newState.nhomHoSo
        };
        this.props.onFileChange(_params);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.state.isValid = true;
      var value = e.target ? e.target.value : e;

      var newState = _extends({}, this.state, _defineProperty({}, name, value));

      this.setState(_extends({}, newState));
      this.pushData(newState);
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.props.handleReset();
      var pass = false;
      if (this.state.ten == 'Văn bản đính kèm khác' && this.state.duongDan == '' || this.props.isTiepNhanDon !== undefined && this.props.isTiepNhanDon === false) {
        pass = true;
      } else if (this.validateSubmitForm()) {
        if (this.state.ngayQuyetDinh && !(0, _moment2.default)(this.state.ngayQuyetDinh, CONFIG.DateFormat).isValid()) {
          pass = false;
        } else if (this.state.onSave) {
          pass = true;
        } else if (!this.state.duongDan) {
          this.state.isValid = false;
          this.setState(_extends({}, this.state));
          this.refs.btnUpload.focus();
          pass = false;
        } else {
          this.state.isValid = true;
          this.setState(_extends({}, this.state));
          pass = true;
        }
      } else {
        pass = false;
      }
      return pass;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var _this3 = this;

      var pass = true;
      if (this.props.validators['formDinhKem'] && this.props.validators['formDinhKem'].length) {
        this.props.validators['formDinhKem'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else if (!_this3.state.duongDan) {
            _this3.state.isValid = false;
            _this3.setState(_extends({}, _this3.state));
            _this3.refs.btnUpload.focus();
            validator.validate();
            pass = false;
          } else {
            _this3.state.isValid = false;
            _this3.setState(_extends({}, _this3.state));
            validator.validate();
          }
        });
      }
      return pass;
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this4 = this;

      if (e.target.files[0]) {
        this.props.onUpdateUploading && this.props.onUpdateUploading(true);
        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        var fileTypeErrorMsg = this.props.allowExcelFile ? _message.msg.fileTypeErr2 : _message.msg.fileTypeErr;
        if (!(0, _checkLimitFile.checkLimitFile)(ext, this.props.allowExcelFile)) {
          (0, _toastr.Toastr)(fileTypeErrorMsg, 'warning');
          this.props.onUpdateUploading(false);
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
          this.props.onUpdateUploading(false);
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
          this.props.onUpdateUploading(false);
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this4.setState({ progress: progressBar });
          };

          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var url = res.data.id;
            var newState = _extends({}, _this4.state, {
              progress: 0,
              tenFile: fileName,
              duongDan: url,
              isError: false
            });

            _this4.setState(_extends({}, newState));

            _this4.pushData(newState);
            _this4.props.onUpdateUploading && _this4.props.onUpdateUploading(false);
          }).catch(function (error) {
            _this4.setState({
              progress: 0,
              isError: true
            });
            _this4.props.onUpdateUploading(false);
          });
        }
      }
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove() {
      this.props.validators['formDinhKem'] = [];
      this.props.onRemove();
    }
  }, {
    key: 'checkRequire',
    value: function checkRequire() {
      if (this.state.required && (this.state.typeRequired == 'BB_DOI_THOAI' || (this.state.ten === 'Dự thảo quyết định về việc giải quyết khiếu nại' || this.state.ten === 'Dự thảo quyết định về việc giải quyết') && this.state.typeRequired == 'DT_KL_GQKN')) {
        return false;
      } else if (this.state.required) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'tr',
        { className: 'tr-middle-content attach-file-rows' },
        _react2.default.createElement(
          'td',
          { style: { width: 45, minWidth: 45, maxWidth: 45 } },
          this.props.index + this.state.count + 1
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.isDsVanBanXuLy },
          _react2.default.createElement(
            'td',
            { style: { width: 200, minWidth: 200, maxWidth: 200 }, className: this.checkRequire() ? 'required-attach input-attach' : '' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.checkRequire() },
                _react2.default.createElement(
                  'span',
                  { className: 'label-required-attach' },
                  '*'
                )
              ),
              _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18',
                require: this.checkRequire() ? true : false,
                bindValidator: this, channel: 'formDinhKem',
                placeholder: 'T\xEAn v\u0103n b\u1EA3n', value: this.state.ten, minWidth: 50,
                onChange: this.onChange.bind(this, 'ten'),
                name: this.props.name + 'TenTaiLieu' + this.props.index,
                maxLength: 255
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.required && !this.state.isDsVanBanXuLy },
          _react2.default.createElement(
            'td',
            { className: 'input-attach', style: { width: 200, minWidth: 200, maxWidth: 200 } },
            _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', placeholder: this.state.ten, value: this.state.ten,
              onChange: this.onChange.bind(this, 'ten'), name: this.props.name + 'TenTaiLieu' + this.props.index, maxLength: 255 })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.required && !this.state.isDsVanBanXuLy },
          _react2.default.createElement(
            'td',
            { className: 'required-attach input-attach', style: { width: 200, minWidth: 200, maxWidth: 200 } },
            _react2.default.createElement(
              'span',
              { className: 'val-content pt10' },
              this.state.ten,
              _react2.default.createElement(
                'span',
                { className: 'pt-form-helper-text' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type != 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 180, minWidth: 180, maxWidth: 180 } },
            _react2.default.createElement(_ttForms.DropDownChonTinhTrangTaiLieu, { className: 'col-100 mb0-18 no-gutter', name: this.props.name + 'TinhTrang' + this.props.index, selectedValue: this.state.tinhTrang, onChange: this.onChange.bind(this, 'tinhTrang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 130, minWidth: 130, maxWidth: 130 }, className: this.checkRequire() ? 'required-attach input-attach' : '' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.checkRequire() },
                _react2.default.createElement(
                  'span',
                  { className: 'label-required-attach' },
                  '*'
                )
              ),
              _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18',
                require: this.checkRequire() ? true : false,
                bindValidator: this, channel: 'formDinhKem',
                placeholder: 'S\u1ED1 v\u0103n b\u1EA3n', value: this.state.soQuyetDinh, minWidth: 50,
                onChange: this.onChange.bind(this, 'soQuyetDinh'),
                name: this.props.name + 'SoVanBan' + this.props.index,
                maxLength: 255
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 201, minWidth: 201, maxWidth: 201 }, className: this.checkRequire() ? 'required-attach input-attach' : '' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.checkRequire() },
              _react2.default.createElement(
                'span',
                { className: 'label-required-attach' },
                '*'
              )
            ),
            _react2.default.createElement(_common.DatePicker, { className: 'col-100 no-gutter mb0-18', value: this.state.ngayQuyetDinh,
              onChange: this.handleChangeDate.bind(this, 'ngayQuyetDinh'),
              endDate: new Date(),
              require: this.checkRequire() ? true : false,
              bindValidator: this, channel: 'formDinhKem',
              name: this.props.name + 'NgayQuyetDinh' + this.props.index
            })
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'none-boder' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.progress === 0 },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !_config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(this, this.state.duongDan, this.state.tenFile) },
                this.state.tenFile
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: function onClick() {
                    (0, _utils.downloadFile)(_this5.state.duongDan, _this5.state.tenFile);
                  } },
                this.state.tenFile
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.isValid && !this.state.tenFile && this.state.progress == 0 },
            _react2.default.createElement(
              'div',
              { className: 'pt-form-helper-text mt10' },
              _message.msg.uploadRequire
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.progress == 0 && !this.state.tenFile && this.state.isValid && !this.state.isError },
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              _react2.default.createElement(
                'i',
                { className: 'attach-file-description' },
                'B\u1EA1n ch\u01B0a t\u1EA3i l\xEAn t\u1EADp tin'
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.progress == 0 && !this.state.tenFile && this.state.isValid && this.state.isError },
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              _react2.default.createElement(
                'i',
                { className: 'attach-file-description error-description' },
                'T\u1EADp tin t\u1EA3i l\xEAn kh\xF4ng th\xE0nh c\xF4ng. Vui l\xF2ng th\u1EED l\u1EA1i!'
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.progress > 0 },
            _react2.default.createElement(
              'div',
              { className: 'pt-progress-bar progress-upload pt-intent-primary' },
              _react2.default.createElement('div', { className: 'pt-progress-meter', style: { width: this.state.progress + '%' } })
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 160, minWidth: 160, maxWidth: 160 }, className: this.checkRequire() ? 'required-attach' : '' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.checkRequire() },
              _react2.default.createElement(
                'span',
                { className: 'label-required-attach' },
                '*'
              )
            ),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-100',
              options: this.props.listNhomHoSo,
              keyName: 'giaTri',
              valueName: 'ten',
              placeholder: 'Ch\u1ECDn',
              selectedValue: (0, _lodash.get)(this.state, 'nhomHoSo') || (0, _lodash.get)(this.props, 'nhomHoSoInfo.nhomHoSoId'),
              onChange: this.onChange.bind(this, 'nhomHoSo'),
              bindValidator: this,
              channel: 'formDinhKem',
              require: this.checkRequire() ? true : false
            })
          )
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 120 } },
          _react2.default.createElement(
            'div',
            { className: 'wrap-link-todo link-attach' },
            _react2.default.createElement(
              'div',
              { className: 'upload_file_content' },
              _react2.default.createElement('input', { type: 'file', name: this.props.name + 'ButtonUpload' + this.props.index, className: 'upload' + (this.state.progress || this.props.disabled ? ' disabled-element' : ''), ref: 'btnUpload', onChange: this.uploadFile.bind(this), disabled: this.state.progress !== 0 || this.props.disabled, onClick: function onClick(event) {
                  event.target.value = null;
                } }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tenFile.length == 0 },
                _react2.default.createElement(
                  'span',
                  { htmlFor: 'file' },
                  'T\u1EA3i l\xEAn t\u1EADp tin'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tenFile.length > 0 },
                _react2.default.createElement(
                  'span',
                  { htmlFor: 'file' },
                  'T\u1EA3i l\u1EA1i t\u1EADp tin'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.required && !this.props.disabled || this.state.isDsVanBanXuLy },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-delete', onClick: this.handleRemove.bind(this) },
                'X\xF3a'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.required && this.props.disabled },
              _react2.default.createElement(
                'span',
                { className: 'itt-delete disabled-element' },
                'X\xF3a'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemFileDinhKem;
}(_react2.default.Component);

RowItemFileDinhKem.defaultProps = {
  index: null,
  ngayQuyetDinhSuggest: '',
  soVanBanSuggest: '',
  loaiVanBanSuggest: '',
  validators: {},
  onRemove: function onRemove() {
    console.log('Please implement "onRemove()" method');
  },
  type: 'TAI_LIEU_DINH_KEM',
  isValid: true,
  required: false,
  typeRequired: '',
  newFile: false,
  phanLoaiQuyTrinh: '',
  onSave: false,
  name: '',
  disabled: false
};

exports.default = (0, _utils.validatable)(RowItemFileDinhKem);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(93);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(152);
var toLength = __webpack_require__(45);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(145);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(68);
var toObject = __webpack_require__(58);
var IObject = __webpack_require__(201);
var toLength = __webpack_require__(45);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(68);
var isObject = __webpack_require__(36);
var invoke = __webpack_require__(518);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(53).f;
var create = __webpack_require__(146);
var redefineAll = __webpack_require__(150);
var ctx = __webpack_require__(95);
var anInstance = __webpack_require__(144);
var forOf = __webpack_require__(145);
var $iterDefine = __webpack_require__(335);
var step = __webpack_require__(521);
var setSpecies = __webpack_require__(151);
var DESCRIPTORS = __webpack_require__(48);
var fastKey = __webpack_require__(133).fastKey;
var validate = __webpack_require__(154);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(171);
var from = __webpack_require__(510);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(150);
var getWeak = __webpack_require__(133).getWeak;
var anObject = __webpack_require__(27);
var isObject = __webpack_require__(36);
var anInstance = __webpack_require__(144);
var forOf = __webpack_require__(145);
var createArrayMethod = __webpack_require__(102);
var $has = __webpack_require__(84);
var validate = __webpack_require__(154);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(244);
var isObject = __webpack_require__(36);
var toLength = __webpack_require__(45);
var ctx = __webpack_require__(95);
var IS_CONCAT_SPREADABLE = __webpack_require__(43)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(48) && !__webpack_require__(34)(function () {
  return Object.defineProperty(__webpack_require__(328)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 518 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(36);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(27);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(337);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 523 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 524 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(48);
var getKeys = __webpack_require__(148);
var gOPS = __webpack_require__(248);
var pIE = __webpack_require__(202);
var toObject = __webpack_require__(58);
var IObject = __webpack_require__(201);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(53);
var anObject = __webpack_require__(27);
var getKeys = __webpack_require__(148);

module.exports = __webpack_require__(48) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(87);
var gOPN = __webpack_require__(147).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(84);
var toIObject = __webpack_require__(87);
var arrayIndexOf = __webpack_require__(241)(false);
var IE_PROTO = __webpack_require__(342)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(48);
var getKeys = __webpack_require__(148);
var toIObject = __webpack_require__(87);
var isEnum = __webpack_require__(202).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(147);
var gOPS = __webpack_require__(248);
var anObject = __webpack_require__(27);
var Reflect = __webpack_require__(30).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(30).parseFloat;
var $trim = __webpack_require__(174).trim;

module.exports = 1 / $parseFloat(__webpack_require__(345) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(30).parseInt;
var $trim = __webpack_require__(174).trim;
var ws = __webpack_require__(345);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var isObject = __webpack_require__(36);
var newPromiseCapability = __webpack_require__(339);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(45);
var repeat = __webpack_require__(344);
var defined = __webpack_require__(103);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(97);
var toLength = __webpack_require__(45);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(43);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(513);
var validate = __webpack_require__(154);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(242)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(340);
__webpack_require__(8)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(48) && /./g.flags != 'g') __webpack_require__(53).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(200)
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(513);
var validate = __webpack_require__(154);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(242)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var each = __webpack_require__(102)(0);
var redefine = __webpack_require__(78);
var meta = __webpack_require__(133);
var assign = __webpack_require__(525);
var weak = __webpack_require__(515);
var isObject = __webpack_require__(36);
var validate = __webpack_require__(154);
var NATIVE_WEAK_MAP = __webpack_require__(154);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(242)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(547);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(175);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(556);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tickIncrement */
/* harmony export (immutable) */ __webpack_exports__["b"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(550);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(205);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(256);


var prefixExponent;

/* harmony default export */ __webpack_exports__["b"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* unused harmony export FormatSpecifier */
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(1825);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(561);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"]; });
/* unused harmony reexport FormatSpecifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__ = __webpack_require__(1832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__ = __webpack_require__(1833);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__ = __webpack_require__(1834);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"]; });








/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(1831);









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a" /* default */])(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a" /* default */])(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a" /* default */])(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["a" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genericArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberArray_js__ = __webpack_require__(356);



/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__numberArray_js__["a" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_1__numberArray_js__["b" /* default */] : genericArray)(a, b);
});

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(355);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis_js__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(357);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed_js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_js__ = __webpack_require__(176);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color_js__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis_js__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed_js__["a" /* default */]);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(257);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(155);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(569);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(577);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(262);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(262);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(263);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = radialLine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(361);



function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return radialLine(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]));
});


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(209);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */]);
  }
});


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(209);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(363);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(588);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat_js__ = __webpack_require__(587);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse_js__ = __webpack_require__(1889);
/* unused harmony reexport isoParse */






/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(363);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(364);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["o" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * @format
 * 
 */



var Immutable = __webpack_require__(35);

var emptyFunction = __webpack_require__(71);
var findRangesImmutable = __webpack_require__(213);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;


var returnTrue = emptyFunction.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */



module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorLeaf = __webpack_require__(1920);
var DraftOffsetKey = __webpack_require__(267);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(61);
var Scroll = __webpack_require__(615);
var Style = __webpack_require__(374);
var UnicodeBidi = __webpack_require__(616);
var UnicodeBidiDirection = __webpack_require__(375);

var cx = __webpack_require__(179);
var getElementPosition = __webpack_require__(1991);
var getScrollPosition = __webpack_require__(377);
var getViewportDimensions = __webpack_require__(1995);
var invariant = __webpack_require__(21);
var nullthrows = __webpack_require__(98);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck(this, DraftEditorBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);

      return React.createElement(
        DecoratorComponent,
        _extends({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * @legacyServerCallableInstance
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(35);

var Record = Immutable.Record;


var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck(this, DraftEntityInstance);

    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @format
 * 
 */



var TokenizeUtil = __webpack_require__(1983);

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

module.exports = DraftRemovableWord;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */



var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

module.exports = DraftStringKey;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var SelectionState = __webpack_require__(178);

var adjustBlockDepthForContentState = __webpack_require__(1930);
var nullthrows = __webpack_require__(98);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

module.exports = RichTextEditorUtil;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @format
 * 
 */



var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl,
    _assign = __webpack_require__(29);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(80);
var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var DefaultDraftBlockRenderMap = __webpack_require__(366);
var DraftEntity = __webpack_require__(266);
var DraftFeatureFlags = __webpack_require__(135);
var Immutable = __webpack_require__(35);

var _require = __webpack_require__(35),
    Set = _require.Set;

var URI = __webpack_require__(1984);

var cx = __webpack_require__(179);
var generateRandomKey = __webpack_require__(118);
var getSafeBodyFromHTML = __webpack_require__(603);
var invariant = __webpack_require__(21);
var sanitizeDraftText = __webpack_require__(371);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    OrderedSet = Immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey();

        var textNode = new ContentBlockNode({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @format
 * 
 */



var KeyBindingUtil = __webpack_require__(367);
var Keys = __webpack_require__(373);
var UserAgent = __webpack_require__(106);

var isOSX = UserAgent.isPlatform('Mac OS X');
var isWindows = UserAgent.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @format
 * 
 */



var findAncestorOffsetKey = __webpack_require__(368);
var getSelectionOffsetKeyForNode = __webpack_require__(604);
var getUpdatedSelectionState = __webpack_require__(606);
var invariant = __webpack_require__(21);
var nullthrows = __webpack_require__(98);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(268);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var ContentBlockNode = __webpack_require__(88);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @format
 * 
 */



var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(21);

var isChrome = UserAgent.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

module.exports = getRangeClientRects;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * @format
 * 
 */



var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(21);

var isOldIE = UserAgent.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */



/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * @format
 * 
 */



var invariant = __webpack_require__(21);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * @format
 * 
 */



var DraftOffsetKey = __webpack_require__(267);

var nullthrows = __webpack_require__(98);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());
  if (false) {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */
      return selection;
    }
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */



/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */



function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

module.exports = moveSelectionForward;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(88);
var Immutable = __webpack_require__(35);

var generateRandomKey = __webpack_require__(118);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(80);

var findRangesImmutable = __webpack_require__(213);
var invariant = __webpack_require__(21);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var PhotosMimeType = __webpack_require__(1982);

var createArrayFromMixed = __webpack_require__(618);
var emptyFunction = __webpack_require__(71);

var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(71);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

module.exports = Scroll;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var UnicodeBidiDirection = __webpack_require__(375);

var invariant = __webpack_require__(21);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }
  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

module.exports = UnicodeBidi;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(21);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de50e2e9ca0fc52b57dbe9600b542e19.gif";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5e5bd7ec2df63e2b21d094312e631d6.svg";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(158);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(158);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(384);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(219);

var _runTransitionHook = __webpack_require__(384);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(180);

var _PathUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(288);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(35),__webpack_require__(265)):"function"==typeof define&&define.amd?define(["immutable","draft-js"],t):"object"==typeof exports?exports.htmlToDraftjs=t(require("immutable"),require("draft-js")):e.htmlToDraftjs=t(e.immutable,e["draft-js"])}(window,function(n,r){return o={},i.m=a=[function(e,t){e.exports=n},function(e,t){e.exports=r},function(e,t,n){e.exports=n(3)},function(e,t,n){"use strict";n.r(t);var v=n(1),u=n(0),s=function(e){var t,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((t=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=e,n=t.getElementsByTagName("body")[0]),n},x=function(e,t,n){var r,i=e.textContent;return""===i.trim()?{chunk:(r=n,{text:" ",inlines:[new u.OrderedSet],entities:[r],blocks:[]})}:{chunk:{text:i,inlines:Array(i.length).fill(t),entities:Array(i.length).fill(n),blocks:[]}}},M=function(){return{text:"\n",inlines:[new u.OrderedSet],entities:new Array(1),blocks:[]}},k=function(){return{text:"",inlines:[],entities:[],blocks:[]}},E=function(e,t){return{text:"",inlines:[],entities:[],blocks:[{type:e,depth:0,data:t||new u.Map({})}]}},w=function(e,t,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:e,depth:Math.max(0,Math.min(4,t)),data:n||new u.Map({})}]}},T=function(e){return{text:"\r ",inlines:[new u.OrderedSet],entities:[e],blocks:[{type:"atomic",depth:0,data:new u.Map({})}]}},L=function(e,t){return{text:e.text+t.text,inlines:e.inlines.concat(t.inlines),entities:e.entities.concat(t.entities),blocks:e.blocks.concat(t.blocks)}},A=new u.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}});var O={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function S(e){return e.style.textAlign?new u.Map({"text-align":e.style.textAlign}):e.style.marginLeft?new u.Map({"margin-left":e.style.marginLeft}):void 0}var _=function(e){var t=void 0;if(e instanceof HTMLAnchorElement){var n={};t=e.dataset&&void 0!==e.dataset.mention?(n.url=e.href,n.text=e.innerHTML,n.value=e.dataset.value,v.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=e.getAttribute&&e.getAttribute("href")||e.href,n.title=e.innerHTML,n.targetOption=e.target,v.Entity.__create("LINK","MUTABLE",n))}return t};n.d(t,"default",function(){return r});var d=" ",f=new RegExp("&nbsp;","g"),j=!0;function I(e,t,n,r,i,a){var o=e.nodeName.toLowerCase();if(a){var l=a(o,e);if(l){var c=v.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:T(c)}}}if("#text"===o&&"\n"!==e.textContent)return x(e,t,i);if("br"===o)return{chunk:M()};if("img"===o&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var s=v.Entity.__create("IMAGE","MUTABLE",u);return{chunk:T(s)}}if("video"===o&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=v.Entity.__create("VIDEO","MUTABLE",d);return{chunk:T(f)}}if("iframe"===o&&e instanceof HTMLIFrameElement){var m={};m.src=e.getAttribute&&e.getAttribute("src")||e.src,m.height=e.height,m.width=e.width;var p=v.Entity.__create("EMBEDDED_LINK","MUTABLE",m);return{chunk:T(p)}}var h,y=function(t,n){var e=A.filter(function(e){return e.element===t&&(!e.wrapper||e.wrapper===n)||e.wrapper===t||e.aliasedElements&&-1<e.aliasedElements.indexOf(t)}).keySeq().toSet().toArray();if(1===e.length)return e[0]}(o,r);y&&("ul"===o||"ol"===o?(r=o,n+=1):("unordered-list-item"!==y&&"ordered-list-item"!==y&&(r="",n=-1),j?(h=E(y,S(e)),j=!1):h=w(y,n,S(e)))),h=h||k(),t=function(e,t,n){var r,i=O[e];if(i)r=n.add(i).toOrderedSet();else if(t instanceof HTMLElement){var c=t;r=(r=n).withMutations(function(e){var t=c.style.color,n=c.style.backgroundColor,r=c.style.fontSize,i=c.style.fontFamily.replace(/^"|"$/g,""),a=c.style.fontWeight,o=c.style.textDecoration,l=c.style.fontStyle;t&&e.add("color-".concat(t.replace(/ /g,""))),n&&e.add("bgcolor-".concat(n.replace(/ /g,""))),r&&e.add("fontsize-".concat(r.replace(/px$/g,""))),i&&e.add("fontfamily-".concat(i)),"bold"===a&&e.add(O.strong),"underline"===o&&e.add(O.ins),"italic"===l&&e.add(O.em)}).toOrderedSet()}return r}(o,e,t);for(var b=e.firstChild;b;){var g=I(b,t,n,r,_(b)||i,a).chunk;h=L(h,g),b=b.nextSibling}return{chunk:h}}function r(e,t){var n,r,i,a=(n=t,r=e.trim().replace(f,d),(i=s(r))?(j=!0,{chunk:I(i,new u.OrderedSet,-1,"",void 0,n).chunk}):null);if(a){var o=a.chunk,l=new u.OrderedMap({});o.entities&&o.entities.forEach(function(e){e&&(l=l.set(e,v.Entity.__get(e)))});var c=0;return{contentBlocks:o.text.split("\r").map(function(e,t){var n=c+e.length,r=o&&o.inlines.slice(c,n),i=o&&o.entities.slice(c,n),a=new u.List(r.map(function(e,t){var n={style:e,entity:null};return i[t]&&(n.entity=i[t]),v.CharacterMetadata.create(n)}));return c=n,new v.ContentBlock({key:Object(v.genKey)(),type:o&&o.blocks[t]&&o.blocks[t].type||"unstyled",depth:o&&o.blocks[t]&&o.blocks[t].depth,data:o&&o.blocks[t]&&o.blocks[t].data||new u.Map({}),text:e,characterList:a})}),entityMap:l}}return null}}],i.c=o,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},i.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=2);function i(e){if(o[e])return o[e].exports;var t=o[e]={i:e,l:!1,exports:{}};return a[e].call(t.exports,t,t.exports,i),t.l=!0,t.exports}var a,o});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(2039);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(2040);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(386),
    setCacheAdd = __webpack_require__(2126),
    setCacheHas = __webpack_require__(2127);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(275),
    stackClear = __webpack_require__(2131),
    stackDelete = __webpack_require__(2132),
    stackGet = __webpack_require__(2133),
    stackHas = __webpack_require__(2134),
    stackSet = __webpack_require__(2135);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(2056),
    createBaseEach = __webpack_require__(2087);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(181);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(217),
    overRest = __webpack_require__(2125),
    setToString = __webpack_require__(2129);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(51),
    isKey = __webpack_require__(391),
    stringToPath = __webpack_require__(2137),
    toString = __webpack_require__(2154);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(634),
    arraySome = __webpack_require__(2051),
    cacheHas = __webpack_require__(641);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(392),
    isArrayLike = __webpack_require__(218),
    isIndex = __webpack_require__(390),
    isObject = __webpack_require__(139);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139),
    now = __webpack_require__(2147),
    toNumber = __webpack_require__(660);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(387);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(107),
    stubFalse = __webpack_require__(2150);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module)))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(388);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    getPrototype = __webpack_require__(2095),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isArray = __webpack_require__(51),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2067),
    baseUnary = __webpack_require__(389),
    nodeUtil = __webpack_require__(2123);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(639),
    baseGt = __webpack_require__(2058),
    baseIteratee = __webpack_require__(278);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(2054),
    baseOrderBy = __webpack_require__(2073),
    baseRest = __webpack_require__(640),
    isIterateeCall = __webpack_require__(645);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(2082),
    isObject = __webpack_require__(139),
    isSymbol = __webpack_require__(181);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(2165);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2162)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(160);

var invariant = __webpack_require__(21);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(183);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactInstrumentation = __webpack_require__(99);

var quoteAttributeValueForBrowser = __webpack_require__(2239);
var warning = __webpack_require__(37);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var LinkedValueUtils = __webpack_require__(402);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactUpdates = __webpack_require__(108);

var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(2199);

var containsNode = __webpack_require__(270);
var focusNode = __webpack_require__(619);
var getActiveElement = __webpack_require__(271);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var DOMLazyTree = __webpack_require__(182);
var DOMProperty = __webpack_require__(183);
var React = __webpack_require__(187);
var ReactBrowserEventEmitter = __webpack_require__(283);
var ReactCurrentOwner = __webpack_require__(122);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactDOMContainerInfo = __webpack_require__(2193);
var ReactDOMFeatureFlags = __webpack_require__(2195);
var ReactFeatureFlags = __webpack_require__(805);
var ReactInstanceMap = __webpack_require__(222);
var ReactInstrumentation = __webpack_require__(99);
var ReactMarkupChecksum = __webpack_require__(2209);
var ReactReconciler = __webpack_require__(184);
var ReactUpdateQueue = __webpack_require__(405);
var ReactUpdates = __webpack_require__(108);

var emptyObject = __webpack_require__(376);
var instantiateReactComponent = __webpack_require__(816);
var invariant = __webpack_require__(21);
var setInnerHTML = __webpack_require__(287);
var shouldUpdateReactComponent = __webpack_require__(411);
var warning = __webpack_require__(37);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var React = __webpack_require__(187);

var invariant = __webpack_require__(21);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(809);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(55);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var ReactCompositeComponent = __webpack_require__(2190);
var ReactEmptyComponent = __webpack_require__(804);
var ReactHostComponent = __webpack_require__(806);

var getNextDebugID = __webpack_require__(2296);
var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);
var escapeTextContentForBrowser = __webpack_require__(286);
var setInnerHTML = __webpack_require__(287);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(122);
var REACT_ELEMENT_TYPE = __webpack_require__(2205);

var getIteratorFn = __webpack_require__(2236);
var invariant = __webpack_require__(21);
var KeyEscapeUtils = __webpack_require__(401);
var warning = __webpack_require__(37);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(265),__webpack_require__(35)):"function"==typeof define&&define.amd?define(["react","draft-js","immutable"],e):"object"==typeof exports?exports.reactDraftWysiwyg=e(require("react"),require("draft-js"),require("immutable")):t.reactDraftWysiwyg=e(t.react,t["draft-js"],t.immutable)}(window,function(n,o,r){return a={},i.m=c=[function(t,e,n){t.exports=n(10)()},function(t,e){t.exports=n},function(t,e,n){var o;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";var c={}.hasOwnProperty;function a(){for(var t=[],e=0;e<arguments.length;e++){var n=arguments[e];if(n){var o=typeof n;if("string"==o||"number"==o)t.push(n);else if(Array.isArray(n)&&n.length){var r=a.apply(null,n);r&&t.push(r)}else if("object"==o)for(var i in n)c.call(n,i)&&n[i]&&t.push(i)}}return t.join(" ")}t.exports?(a.default=a,t.exports=a):void 0===(o=function(){return a}.apply(e,[]))||(t.exports=o)}()},function(t,e){t.exports=o},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(3),i=n(5),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var M=n(0),i=n(1);function j(t){var e=t.getSelection(),n=t.getCurrentContent(),o=e.getStartKey(),r=e.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(t,e){return e===o}).takeUntil(function(t,e){return e===r}).concat([[r,i.get(r)]])}function u(t){return j(t).toList()}function l(t){if(t)return u(t).get(0)}function o(t){if(t){var n=l(t),e=t.getCurrentContent().getBlockMap().toSeq().toList(),o=0;if(e.forEach(function(t,e){t.get("key")===n.get("key")&&(o=e-1)}),-1<o)return e.get(o)}}function r(t){return t?t.getCurrentContent().getBlockMap().toList():new i.List}function c(t){var e=u(t);if(!e.some(function(t){return t.type!==e.get(0).type}))return e.get(0).type}function a(t){var e=M.RichUtils.tryToRemoveBlockStyle(t);return e?M.EditorState.push(t,e,"change-block-type"):t}function s(t){var e="",n=t.getSelection(),o=n.getAnchorOffset(),r=n.getFocusOffset(),i=u(t);if(0<i.size){if(n.getIsBackward()){var c=o;o=r,r=c}for(var a=0;a<i.size;a+=1){var l=0===a?o:0,s=a===i.size-1?r:i.get(a).getText().length;e+=i.get(a).getText().slice(l,s)}}return e}function p(t){var e=t.getCurrentContent(),n=t.getSelection(),o=M.Modifier.removeRange(e,n,"forward"),r=o.getSelectionAfter(),i=o.getBlockForKey(r.getStartKey());return o=M.Modifier.insertText(o,r,"\n",i.getInlineStyleAt(r.getStartOffset()),null),M.EditorState.push(t,o,"insert-fragment")}function d(t){var e=M.Modifier.splitBlock(t.getCurrentContent(),t.getSelection());return a(M.EditorState.push(t,e,"split-block"))}function f(t){var e=t.getCurrentContent().getBlockMap().toList(),n=t.getSelection().merge({anchorKey:e.first().get("key"),anchorOffset:0,focusKey:e.last().get("key"),focusOffset:e.last().getLength()}),o=M.Modifier.removeRange(t.getCurrentContent(),n,"forward");return M.EditorState.push(t,o,"remove-range")}function y(t,e){var n=M.Modifier.setBlockData(t.getCurrentContent(),t.getSelection(),e);return M.EditorState.push(t,n,"change-block-data")}function m(t){var o=new i.Map({}),e=u(t);if(e&&0<e.size)for(var n=function(t){var n=e.get(t).getData();if(!n||0===n.size)return o=o.clear(),"break";if(0===t)o=n;else if(o.forEach(function(t,e){n.get(e)&&n.get(e)===t||(o=o.delete(e))}),0===o.size)return o=o.clear(),"break"},r=0;r<e.size&&"break"!==n(r);r+=1);return o}var g=Object(i.Map)({code:{element:"pre"}}),b=M.DefaultDraftBlockRenderMap.merge(g);function h(t){if(t){var e=t.getType();return"unordered-list-item"===e||"ordered-list-item"===e}return!1}function v(t,e,n){var o,r=t.getSelection();o=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var i=t.getCurrentContent(),c=i.getBlockForKey(o),a=c.getType();if("unordered-list-item"!==a&&"ordered-list-item"!==a)return t;var l=i.getBlockBefore(o);if(!l)return t;if(l.getType()!==a)return t;var s=c.getDepth();if(1===e&&s===n)return t;var u,p,d,f,y,m,g,b=Math.min(l.getDepth()+1,n),h=(p=e,d=b,f=(u=t).getSelection(),y=u.getCurrentContent(),m=y.getBlockMap(),g=j(u).map(function(t){var e=t.getDepth()+p;return e=Math.max(0,Math.min(e,d)),t.set("depth",e)}),m=m.merge(g),y.merge({blockMap:m,selectionBefore:f,selectionAfter:f}));return M.EditorState.push(t,h,"adjust-depth")}function N(t,e){var n;return 13===(n=e).which&&(n.getModifierState("Shift")||n.getModifierState("Alt")||n.getModifierState("Control"))?t.getSelection().isCollapsed()?M.RichUtils.insertSoftNewline(t):p(t):function(t){var e=t.getSelection();if(e.isCollapsed()){var n=t.getCurrentContent(),o=e.getStartKey(),r=n.getBlockForKey(o);if(!h(r)&&"unstyled"!==r.getType()&&r.getLength()===e.getStartOffset())return d(t);if(h(r)&&0===r.getLength()){var i=r.getDepth();if(0===i)return a(t);if(0<i)return v(t,-1,i)}}}(t)}function E(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function S(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function w(t){return(w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function C(t){var e=t.getSelection();if(e.isCollapsed()){var n={},o=t.getCurrentInlineStyle().toList().toJS();if(o)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=0<=o.indexOf(t)}),n}var c=e.getStartOffset(),a=e.getEndOffset(),l=u(t);if(0<l.size){var r=function(){for(var n={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},o=0;o<l.size;o+=1){var t=0===o?c:0,e=o===l.size-1?a:l.get(o).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var r=function(t){var e=l.get(o).getInlineStyleAt(t);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=n[t]&&e.get(t)===t})},i=t;i<e;i+=1)r(i)}return{v:n}}();if("object"===w(r))return r.v}return{}}function L(t){var e,n=t.getSelection(),o=n.getStartOffset(),r=n.getEndOffset();o===r&&0===o?r=1:o===r&&--o;for(var i=l(t),c=o;c<r;c+=1){var a=i.getEntityAt(c);if(!a){e=void 0;break}if(c===o)e=a;else if(e!==a){e=void 0;break}}return e}function D(t,e){var n,o=l(t);return o.findEntityRanges(function(t){return t.get("entity")===e},function(t,e){n={start:t,end:e,text:o.get("text").slice(t,e)}}),n}function k(t,e,n){x[t]["".concat(t.toLowerCase(),"-").concat(n)]=S({},"".concat(e),n)}function O(){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E(Object(n),!0).forEach(function(t){S(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},x.color,{},x.bgcolor,{},x.fontSize,{},x.fontFamily,{CODE:x.CODE,SUPERSCRIPT:x.SUPERSCRIPT,SUBSCRIPT:x.SUBSCRIPT})}var x={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}};function I(t,e,n){var o=t.getSelection(),r=Object.keys(x[e]).reduce(function(t,e){return M.Modifier.removeInlineStyle(t,o,e)},t.getCurrentContent()),i=M.EditorState.push(t,r,"changeinline-style"),c=t.getCurrentInlineStyle();if(o.isCollapsed()&&(i=c.reduce(function(t,e){return M.RichUtils.toggleInlineStyle(t,e)},i)),"SUPERSCRIPT"===e||"SUBSCRIPT"==e)c.has(n)||(i=M.RichUtils.toggleInlineStyle(i,n));else{var a="bgcolor"===e?"backgroundColor":e;c.has("".concat(a,"-").concat(n))||(i=M.RichUtils.toggleInlineStyle(i,"".concat(e.toLowerCase(),"-").concat(n)),k(e,a,n))}return i}function T(t){t&&t.getCurrentContent().getBlockMap().map(function(t){return t.get("characterList")}).toList().flatten().forEach(function(t){t&&0===t.indexOf("color-")?k("color","color",t.substr(6)):t&&0===t.indexOf("bgcolor-")?k("bgcolor","backgroundColor",t.substr(8)):t&&0===t.indexOf("fontsize-")?k("fontSize","fontSize",+t.substr(9)):t&&0===t.indexOf("fontfamily-")&&k("fontFamily","fontFamily",t.substr(11))})}function A(t,e,n){var o=t.getInlineStyleAt(n).toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(o&&0<o.size)return o.get(0)}function z(o,s){if(o&&s&&0<s.length){var t=function(){var t=o.getSelection(),i={};if(t.isCollapsed())return s.forEach(function(t){i[t]=function(t,e){var n=t.getCurrentInlineStyle().toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(n&&0<n.size)return n.get(0)}(o,t)}),{v:i};var c=t.getStartOffset(),a=t.getEndOffset(),l=u(o);if(0<l.size){for(var e=function(n){var t=0===n?c:0,e=n===l.size-1?a:l.get(n).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var o=function(e){e===t?s.forEach(function(t){i[t]=A(l.get(n),t,e)}):s.forEach(function(t){i[t]&&i[t]!==A(l.get(n),t,e)&&(i[t]=void 0)})},r=t;r<e;r+=1)o(r)},n=0;n<l.size;n+=1)e(n);return{v:i}}}();if("object"===w(t))return t.v}return{}}function _(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=M.Modifier.removeInlineStyle(n,e.getSelection(),t)}),M.EditorState.push(e,n,"change-inline-style")}n.d(e,"isListBlock",function(){return h}),n.d(e,"changeDepth",function(){return v}),n.d(e,"handleNewLine",function(){return N}),n.d(e,"getEntityRange",function(){return D}),n.d(e,"getCustomStyleMap",function(){return O}),n.d(e,"toggleCustomInlineStyle",function(){return I}),n.d(e,"getSelectionEntity",function(){return L}),n.d(e,"extractInlineStyle",function(){return T}),n.d(e,"removeAllInlineStyles",function(){return _}),n.d(e,"getSelectionInlineStyle",function(){return C}),n.d(e,"getSelectionCustomInlineStyle",function(){return z}),n.d(e,"getSelectedBlocksMap",function(){return j}),n.d(e,"getSelectedBlocksList",function(){return u}),n.d(e,"getSelectedBlock",function(){return l}),n.d(e,"getBlockBeforeSelectedBlock",function(){return o}),n.d(e,"getAllBlocks",function(){return r}),n.d(e,"getSelectedBlocksType",function(){return c}),n.d(e,"removeSelectedBlocksStyle",function(){return a}),n.d(e,"getSelectionText",function(){return s}),n.d(e,"addLineBreakRemovingSelection",function(){return p}),n.d(e,"insertNewUnstyledBlock",function(){return d}),n.d(e,"clearEditorContent",function(){return f}),n.d(e,"setBlockData",function(){return y}),n.d(e,"getSelectedBlocksMetadata",function(){return m}),n.d(e,"blockRenderMap",function(){return b})}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e){t.exports=r},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(5),i=n(3),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var j=n(1),s=n(0),v=function(t,e,n){var o,r=t.textContent;return""===r.trim()?{chunk:(o=n,{text:" ",inlines:[new s.OrderedSet],entities:[o],blocks:[]})}:{chunk:{text:r,inlines:Array(r.length).fill(e),entities:Array(r.length).fill(n),blocks:[]}}},N=function(){return{text:"\n",inlines:[new s.OrderedSet],entities:new Array(1),blocks:[]}},E=function(){return{text:"",inlines:[],entities:[],blocks:[]}},S=function(t,e){return{text:"",inlines:[],entities:[],blocks:[{type:t,depth:0,data:e||new s.Map({})}]}},w=function(t,e,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:t,depth:Math.max(0,Math.min(4,e)),data:n||new s.Map({})}]}},C=function(t){return{text:"\r ",inlines:[new s.OrderedSet],entities:[t],blocks:[{type:"atomic",depth:0,data:new s.Map({})}]}},L=function(t,e){return{text:t.text+e.text,inlines:t.inlines.concat(e.inlines),entities:t.entities.concat(e.entities),blocks:t.blocks.concat(e.blocks)}},D=new s.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}}),k={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function O(t){return t.style.textAlign?new s.Map({"text-align":t.style.textAlign}):t.style.marginLeft?new s.Map({"margin-left":t.style.marginLeft}):void 0}var x=function(t){var e=void 0;if(t instanceof HTMLAnchorElement){var n={};e=t.dataset&&void 0!==t.dataset.mention?(n.url=t.href,n.text=t.innerHTML,n.value=t.dataset.value,j.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=t.getAttribute&&t.getAttribute("href")||t.href,n.title=t.innerHTML,n.targetOption=t.target,j.Entity.__create("LINK","MUTABLE",n))}return e};n.d(e,"default",function(){return o});var u=" ",p=new RegExp("&nbsp;","g"),I=!0;function o(t,e){var n,o,r,i=(n=e,o=t.trim().replace(p,u),(r=function(t){var e,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((e=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=t,n=e.getElementsByTagName("body")[0]),n}(o))?(I=!0,{chunk:function t(e,n,o,r,i,c){var a=e.nodeName.toLowerCase();if(c){var l=c(a,e);if(l){var s=j.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:C(s)}}}if("#text"===a&&"\n"!==e.textContent)return v(e,n,i);if("br"===a)return{chunk:N()};if("img"===a&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var p=j.Entity.__create("IMAGE","MUTABLE",u);return{chunk:C(p)}}if("video"===a&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=j.Entity.__create("VIDEO","MUTABLE",d);return{chunk:C(f)}}if("iframe"===a&&e instanceof HTMLIFrameElement){var y={};y.src=e.getAttribute&&e.getAttribute("src")||e.src,y.height=e.height,y.width=e.width;var m=j.Entity.__create("EMBEDDED_LINK","MUTABLE",y);return{chunk:C(m)}}var g,b=function(e,n){var t=D.filter(function(t){return t.element===e&&(!t.wrapper||t.wrapper===n)||t.wrapper===e||t.aliasedElements&&-1<t.aliasedElements.indexOf(e)}).keySeq().toSet().toArray();if(1===t.length)return t[0]}(a,r);b&&("ul"===a||"ol"===a?(r=a,o+=1):("unordered-list-item"!==b&&"ordered-list-item"!==b&&(r="",o=-1),I?(g=S(b,O(e)),I=!1):g=w(b,o,O(e)))),g=g||E(),n=function(t,e,n){var o,r=k[t];if(r)o=n.add(r).toOrderedSet();else if(e instanceof HTMLElement){var l=e;o=(o=n).withMutations(function(t){var e=l.style.color,n=l.style.backgroundColor,o=l.style.fontSize,r=l.style.fontFamily.replace(/^"|"$/g,""),i=l.style.fontWeight,c=l.style.textDecoration,a=l.style.fontStyle;e&&t.add("color-".concat(e.replace(/ /g,""))),n&&t.add("bgcolor-".concat(n.replace(/ /g,""))),o&&t.add("fontsize-".concat(o.replace(/px$/g,""))),r&&t.add("fontfamily-".concat(r)),"bold"===i&&t.add(k.strong),"underline"===c&&t.add(k.ins),"italic"===a&&t.add(k.em)}).toOrderedSet()}return o}(a,e,n);for(var h=e.firstChild;h;){var M=t(h,n,o,r,x(h)||i,c).chunk;g=L(g,M),h=h.nextSibling}return{chunk:g}}(r,new s.OrderedSet,-1,"",void 0,n).chunk}):null);if(i){var c=i.chunk,a=new s.OrderedMap({});c.entities&&c.entities.forEach(function(t){t&&(a=a.set(t,j.Entity.__get(t)))});var l=0;return{contentBlocks:c.text.split("\r").map(function(t,e){var n=l+t.length,o=c&&c.inlines.slice(l,n),r=c&&c.entities.slice(l,n),i=new s.List(o.map(function(t,e){var n={style:t,entity:null};return r[e]&&(n.entity=r[e]),j.CharacterMetadata.create(n)}));return l=n,new j.ContentBlock({key:Object(j.genKey)(),type:c&&c.blocks[e]&&c.blocks[e].type||"unstyled",depth:c&&c.blocks[e]&&c.blocks[e].depth,data:c&&c.blocks[e]&&c.blocks[e].data||new s.Map({}),text:t,characterList:i})}),entityMap:a}}return null}}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e,l){"use strict";function o(n){return Array.prototype.slice.call(arguments,1).forEach(function(e){e&&Object.keys(e).forEach(function(t){n[t]=e[t]})}),n}function s(t){return Object.prototype.toString.call(t)}function u(t){return"[object Function]"===s(t)}function p(t){return t.replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}var r={fuzzyLink:!0,fuzzyEmail:!0,fuzzyIP:!1};var i={"http:":{validate:function(t,e,n){var o=t.slice(e);return n.re.http||(n.re.http=new RegExp("^\\/\\/"+n.re.src_auth+n.re.src_host_port_strict+n.re.src_path,"i")),n.re.http.test(o)?o.match(n.re.http)[0].length:0}},"https:":"http:","ftp:":"http:","//":{validate:function(t,e,n){var o=t.slice(e);return n.re.no_http||(n.re.no_http=new RegExp("^"+n.re.src_auth+"(?:localhost|(?:(?:"+n.re.src_domain+")\\.)+"+n.re.src_domain_root+")"+n.re.src_port+n.re.src_host_terminator+n.re.src_path,"i")),n.re.no_http.test(o)?3<=e&&":"===t[e-3]?0:3<=e&&"/"===t[e-3]?0:o.match(n.re.no_http)[0].length:0}},"mailto:":{validate:function(t,e,n){var o=t.slice(e);return n.re.mailto||(n.re.mailto=new RegExp("^"+n.re.src_email_name+"@"+n.re.src_host_strict,"i")),n.re.mailto.test(o)?o.match(n.re.mailto)[0].length:0}}},d="a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",c="biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");function f(){return function(t,e){e.normalize(t)}}function a(r){var e=r.re=l(21)(r.__opts__),t=r.__tlds__.slice();function n(t){return t.replace("%TLDS%",e.src_tlds)}r.onCompile(),r.__tlds_replaced__||t.push(d),t.push(e.src_xn),e.src_tlds=t.join("|"),e.email_fuzzy=RegExp(n(e.tpl_email_fuzzy),"i"),e.link_fuzzy=RegExp(n(e.tpl_link_fuzzy),"i"),e.link_no_ip_fuzzy=RegExp(n(e.tpl_link_no_ip_fuzzy),"i"),e.host_fuzzy_test=RegExp(n(e.tpl_host_fuzzy_test),"i");var i=[];function c(t,e){throw new Error('(LinkifyIt) Invalid schema "'+t+'": '+e)}r.__compiled__={},Object.keys(r.__schemas__).forEach(function(t){var e=r.__schemas__[t];if(null!==e){var o,n={validate:null,link:null};if(r.__compiled__[t]=n,"[object Object]"===s(e))return"[object RegExp]"===s(e.validate)?n.validate=(o=e.validate,function(t,e){var n=t.slice(e);return o.test(n)?n.match(o)[0].length:0}):u(e.validate)?n.validate=e.validate:c(t,e),void(u(e.normalize)?n.normalize=e.normalize:e.normalize?c(t,e):n.normalize=f());if("[object String]"!==s(e))c(t,e);else i.push(t)}}),i.forEach(function(t){r.__compiled__[r.__schemas__[t]]&&(r.__compiled__[t].validate=r.__compiled__[r.__schemas__[t]].validate,r.__compiled__[t].normalize=r.__compiled__[r.__schemas__[t]].normalize)}),r.__compiled__[""]={validate:null,normalize:f()};var o,a=Object.keys(r.__compiled__).filter(function(t){return 0<t.length&&r.__compiled__[t]}).map(p).join("|");r.re.schema_test=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","i"),r.re.schema_search=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","ig"),r.re.pretest=RegExp("("+r.re.schema_test.source+")|("+r.re.host_fuzzy_test.source+")|@","i"),(o=r).__index__=-1,o.__text_cache__=""}function y(t,e){var n=t.__index__,o=t.__last_index__,r=t.__text_cache__.slice(n,o);this.schema=t.__schema__.toLowerCase(),this.index=n+e,this.lastIndex=o+e,this.raw=r,this.text=r,this.url=r}function m(t,e){var n=new y(t,e);return t.__compiled__[n.schema].normalize(n,t),n}function g(t,e){if(!(this instanceof g))return new g(t,e);var n;e||(n=t,Object.keys(n||{}).reduce(function(t,e){return t||r.hasOwnProperty(e)},!1)&&(e=t,t={})),this.__opts__=o({},r,e),this.__index__=-1,this.__last_index__=-1,this.__schema__="",this.__text_cache__="",this.__schemas__=o({},i,t),this.__compiled__={},this.__tlds__=c,this.__tlds_replaced__=!1,this.re={},a(this)}g.prototype.add=function(t,e){return this.__schemas__[t]=e,a(this),this},g.prototype.set=function(t){return this.__opts__=o(this.__opts__,t),this},g.prototype.test=function(t){if(this.__text_cache__=t,this.__index__=-1,!t.length)return!1;var e,n,o,r,i,c,a,l;if(this.re.schema_test.test(t))for((a=this.re.schema_search).lastIndex=0;null!==(e=a.exec(t));)if(r=this.testSchemaAt(t,e[2],a.lastIndex)){this.__schema__=e[2],this.__index__=e.index+e[1].length,this.__last_index__=e.index+e[0].length+r;break}return this.__opts__.fuzzyLink&&this.__compiled__["http:"]&&0<=(l=t.search(this.re.host_fuzzy_test))&&(this.__index__<0||l<this.__index__)&&null!==(n=t.match(this.__opts__.fuzzyIP?this.re.link_fuzzy:this.re.link_no_ip_fuzzy))&&(i=n.index+n[1].length,(this.__index__<0||i<this.__index__)&&(this.__schema__="",this.__index__=i,this.__last_index__=n.index+n[0].length)),this.__opts__.fuzzyEmail&&this.__compiled__["mailto:"]&&0<=t.indexOf("@")&&null!==(o=t.match(this.re.email_fuzzy))&&(i=o.index+o[1].length,c=o.index+o[0].length,(this.__index__<0||i<this.__index__||i===this.__index__&&c>this.__last_index__)&&(this.__schema__="mailto:",this.__index__=i,this.__last_index__=c)),0<=this.__index__},g.prototype.pretest=function(t){return this.re.pretest.test(t)},g.prototype.testSchemaAt=function(t,e,n){return this.__compiled__[e.toLowerCase()]?this.__compiled__[e.toLowerCase()].validate(t,n,this):0},g.prototype.match=function(t){var e=0,n=[];0<=this.__index__&&this.__text_cache__===t&&(n.push(m(this,e)),e=this.__last_index__);for(var o=e?t.slice(e):t;this.test(o);)n.push(m(this,e)),o=o.slice(this.__last_index__),e+=this.__last_index__;return n.length?n:null},g.prototype.tlds=function(t,e){return t=Array.isArray(t)?t:[t],e?this.__tlds__=this.__tlds__.concat(t).sort().filter(function(t,e,n){return t!==n[e-1]}).reverse():(this.__tlds__=t.slice(),this.__tlds_replaced__=!0),a(this),this},g.prototype.normalize=function(t){t.schema||(t.url="http://"+t.url),"mailto:"!==t.schema||/^mailto:/i.test(t.url)||(t.url="mailto:"+t.url)},g.prototype.onCompile=function(){},t.exports=g},function(t,e,n){t.exports=n(40)},function(t,e,n){},function(t,e,n){"use strict";var a=n(11);function o(){}function r(){}r.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,r,i){if(i!==a){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function e(){return t}var n={array:t.isRequired=t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,o){"use strict";t.exports=function(t){var e={};e.src_Any=o(22).source,e.src_Cc=o(23).source,e.src_Z=o(24).source,e.src_P=o(25).source,e.src_ZPCc=[e.src_Z,e.src_P,e.src_Cc].join("|"),e.src_ZCc=[e.src_Z,e.src_Cc].join("|");var n="[><｜]";return e.src_pseudo_letter="(?:(?![><｜]|"+e.src_ZPCc+")"+e.src_Any+")",e.src_ip4="(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",e.src_auth="(?:(?:(?!"+e.src_ZCc+"|[@/\\[\\]()]).)+@)?",e.src_port="(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?",e.src_host_terminator="(?=$|[><｜]|"+e.src_ZPCc+")(?!-|_|:\\d|\\.-|\\.(?!$|"+e.src_ZPCc+"))",e.src_path="(?:[/?#](?:(?!"+e.src_ZCc+"|"+n+"|[()[\\]{}.,\"'?!\\-]).|\\[(?:(?!"+e.src_ZCc+"|\\]).)*\\]|\\((?:(?!"+e.src_ZCc+"|[)]).)*\\)|\\{(?:(?!"+e.src_ZCc+'|[}]).)*\\}|\\"(?:(?!'+e.src_ZCc+'|["]).)+\\"|\\\'(?:(?!'+e.src_ZCc+"|[']).)+\\'|\\'(?="+e.src_pseudo_letter+"|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!"+e.src_ZCc+"|[.]).|"+(t&&t["---"]?"\\-(?!--(?:[^-]|$))(?:-*)|":"\\-+|")+"\\,(?!"+e.src_ZCc+").|\\!(?!"+e.src_ZCc+"|[!]).|\\?(?!"+e.src_ZCc+"|[?]).)+|\\/)?",e.src_email_name='[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*',e.src_xn="xn--[a-z0-9\\-]{1,59}",e.src_domain_root="(?:"+e.src_xn+"|"+e.src_pseudo_letter+"{1,63})",e.src_domain="(?:"+e.src_xn+"|(?:"+e.src_pseudo_letter+")|(?:"+e.src_pseudo_letter+"(?:-|"+e.src_pseudo_letter+"){0,61}"+e.src_pseudo_letter+"))",e.src_host="(?:(?:(?:(?:"+e.src_domain+")\\.)*"+e.src_domain+"))",e.tpl_host_fuzzy="(?:"+e.src_ip4+"|(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%)))",e.tpl_host_no_ip_fuzzy="(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%))",e.src_host_strict=e.src_host+e.src_host_terminator,e.tpl_host_fuzzy_strict=e.tpl_host_fuzzy+e.src_host_terminator,e.src_host_port_strict=e.src_host+e.src_port+e.src_host_terminator,e.tpl_host_port_fuzzy_strict=e.tpl_host_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_port_no_ip_fuzzy_strict=e.tpl_host_no_ip_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_fuzzy_test="localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:"+e.src_ZPCc+"|>|$))",e.tpl_email_fuzzy='(^|[><｜]|"|\\(|'+e.src_ZCc+")("+e.src_email_name+"@"+e.tpl_host_fuzzy_strict+")",e.tpl_link_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_fuzzy_strict+e.src_path+")",e.tpl_link_no_ip_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_no_ip_fuzzy_strict+e.src_path+")",e}},function(t,e){t.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/},function(t,e){t.exports=/[\0-\x1F\x7F-\x9F]/},function(t,e){t.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/},function(t,e){t.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){"use strict";n.r(e),n.d(e,"Editor",function(){return ar});var f=n(1),N=n.n(f),o=n(0),y=n.n(o),E=n(3),S=n(4),r=n(2),w=n.n(r);function i(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function c(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var a=c(function t(){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.callBacks=[],this.suggestionCallback=void 0,this.editorFlag=!1,this.suggestionFlag=!1,this.closeAllModals=function(e){n.callBacks.forEach(function(t){t(e)})},this.init=function(t){var e=document.getElementById(t);e&&e.addEventListener("click",function(){n.editorFlag=!0}),document&&(document.addEventListener("click",function(){n.editorFlag?n.editorFlag=!1:(n.closeAllModals(),n.suggestionCallback&&n.suggestionCallback())}),document.addEventListener("keydown",function(t){"Escape"===t.key&&n.closeAllModals()}))},this.onEditorClick=function(){n.closeModals(),!n.suggestionFlag&&n.suggestionCallback?n.suggestionCallback():n.suggestionFlag=!1},this.closeModals=function(t){n.closeAllModals(t)},this.registerCallBack=function(t){n.callBacks.push(t)},this.deregisterCallBack=function(e){n.callBacks=n.callBacks.filter(function(t){return t!==e})},this.setSuggestionCallback=function(t){n.suggestionCallback=t},this.removeSuggestionCallback=function(){n.suggestionCallback=void 0},this.onSuggestionClick=function(){n.suggestionFlag=!0}});function l(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function s(t,e,n){return e&&l(t.prototype,e),n&&l(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var u,p=s(function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.inputFocused=!1,this.editorMouseDown=!1,this.onEditorMouseDown=function(){e.editorFocused=!0},this.onInputMouseDown=function(){e.inputFocused=!0},this.isEditorBlur=function(t){return"INPUT"!==t.target.tagName&&"LABEL"!==t.target.tagName&&"TEXTAREA"!==t.target.tagName||e.editorFocused?!("INPUT"===t.target.tagName&&"LABEL"===t.target.tagName&&"TEXTAREA"===t.target.tagName||e.inputFocused)&&!(e.editorFocused=!1):!(e.inputFocused=!1)},this.isEditorFocused=function(){return!e.inputFocused||(e.inputFocused=!1)},this.isToolbarFocused=function(){return!e.editorFocused||(e.editorFocused=!1)},this.isInputFocused=function(){return e.inputFocused}}),d=[],C={onKeyDown:function(e){d.forEach(function(t){t(e)})},registerCallBack:function(t){d.push(t)},deregisterCallBack:function(e){d=d.filter(function(t){return t!==e})}},m=function(){u=!0},g=function(){u=!1},b=function(){return u};function L(t){var e=t.getData()&&t.getData().get("text-align");return e?"rdw-".concat(e,"-aligned-block"):""}function h(t,e){if(t)for(var n in t)!{}.hasOwnProperty.call(t,n)||e(n,t[n])}function M(t,e){var n=!1;if(t)for(var o in t)if({}.hasOwnProperty.call(t,o)&&e===o){n=!0;break}return n}function j(t){t.stopPropagation()}function v(t){return t[t.options[0]].icon}function D(t,o){if(t&&void 0===o)return t;var r={};return h(t,function(t,e){var n;n=e,"[object Object]"===Object.prototype.toString.call(n)?r[t]=D(e,o[t]):r[t]=void 0!==o[t]?o[t]:e}),r}var k=n(6),O=n.n(k),x=n(5);n(9);function I(t){return(I="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function A(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function z(t,e){return(z=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function _(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=P(o);if(r){var n=P(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===I(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function P(t){return(P=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var R=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&z(t,e)}(i,f["Component"]);var t,e,n,o=_(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).onClick=function(){var t=r.props,e=t.disabled,n=t.onClick,o=t.value;e||n(o)},r}return t=i,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.className,r=e.activeClassName,i=e.active,c=e.disabled,a=e.title;return N.a.createElement("div",{className:w()("rdw-option-wrapper",o,(T(t={},"rdw-option-active ".concat(r),i),T(t,"rdw-option-disabled",c),t)),onClick:this.onClick,"aria-selected":i,title:a},n)}}])&&A(t.prototype,e),n&&A(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();R.propTypes={onClick:y.a.func.isRequired,children:y.a.any,value:y.a.string,className:y.a.string,activeClassName:y.a.string,active:y.a.bool,disabled:y.a.bool,title:y.a.string},R.defaultProps={activeClassName:""};n(12);function U(t){return(U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function B(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function F(t,e){return(F=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Y(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Q(o);if(r){var n=Q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===U(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Q(t){return(Q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var H=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&F(t,e)}(i,f["Component"]);var t,e,n,r=Y(i);function i(){var o;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(o=r.call.apply(r,[this].concat(e))).state={highlighted:-1},o.onChange=function(t){var e=o.props.onChange;e&&e(t),o.toggleExpansion()},o.setHighlighted=function(t){o.setState({highlighted:t})},o.toggleExpansion=function(){var t=o.props,e=t.doExpand,n=t.doCollapse;t.expanded?n():e()},o}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.expanded;t.expanded&&!e&&this.setState({highlighted:-1})}},{key:"render",value:function(){var n=this,t=this.props,e=t.expanded,o=t.children,r=t.className,i=t.optionWrapperClassName,c=t.ariaLabel,a=t.onExpandEvent,l=t.title,s=this.state.highlighted,u=o.slice(1,o.length);return N.a.createElement("div",{className:w()("rdw-dropdown-wrapper",r),"aria-expanded":e,"aria-label":c||"rdw-dropdown"},N.a.createElement("a",{className:"rdw-dropdown-selectedtext",onClick:a,title:l},o[0],N.a.createElement("div",{className:w()({"rdw-dropdown-carettoclose":e,"rdw-dropdown-carettoopen":!e})})),e?N.a.createElement("ul",{className:w()("rdw-dropdown-optionwrapper",i),onClick:j},N.a.Children.map(u,function(t,e){return t&&N.a.cloneElement(t,{onSelect:n.onChange,highlighted:s===e,setHighlighted:n.setHighlighted,index:e})})):void 0)}}])&&B(t.prototype,e),n&&B(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();H.propTypes={children:y.a.any,onChange:y.a.func,className:y.a.string,expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,optionWrapperClassName:y.a.string,ariaLabel:y.a.string,title:y.a.string};n(13);function Z(t){return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function W(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function G(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function J(t,e){return(J=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function V(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=q(o);if(r){var n=q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Z(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function q(t){return(q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var K=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&J(t,e)}(r,f["Component"]);var t,e,n,o=V(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).onClick=function(t){var e=i.props,n=e.onSelect,o=e.onClick,r=e.value;e.disabled||(n&&n(r),o&&(t.stopPropagation(),o(r)))},i.setHighlighted=function(){var t=i.props;(0,t.setHighlighted)(t.index)},i.resetHighlighted=function(){(0,i.props.setHighlighted)(-1)},i}return t=r,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.active,r=e.disabled,i=e.highlighted,c=e.className,a=e.activeClassName,l=e.disabledClassName,s=e.highlightedClassName,u=e.title;return N.a.createElement("li",{className:w()("rdw-dropdownoption-default",c,(W(t={},"rdw-dropdownoption-active ".concat(a),o),W(t,"rdw-dropdownoption-highlighted ".concat(s),i),W(t,"rdw-dropdownoption-disabled ".concat(l),r),t)),onMouseEnter:this.setHighlighted,onMouseLeave:this.resetHighlighted,onClick:this.onClick,title:u},n)}}])&&G(t.prototype,e),n&&G(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();K.propTypes={children:y.a.any,value:y.a.any,onClick:y.a.func,onSelect:y.a.func,setHighlighted:y.a.func,index:y.a.number,disabled:y.a.bool,active:y.a.bool,highlighted:y.a.bool,className:y.a.string,activeClassName:y.a.string,disabledClassName:y.a.string,highlightedClassName:y.a.string,title:y.a.string},K.defaultProps={activeClassName:"",disabledClassName:"",highlightedClassName:""};n(14);function X(t){return(X="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function tt(t,e){return(tt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function et(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=nt(o);if(r){var n=nt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===X(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var ot=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&tt(t,e)}(r,f["Component"]);var t,e,n,o=et(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,n=t.config,o=t.currentState,r=t.onChange,i=t.translations;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n.className),"aria-label":"rdw-inline-control"},n.options.map(function(t,e){return N.a.createElement(R,{key:e,value:t,onClick:r,className:w()(n[t].className),active:!0===o[t]||"MONOSPACE"===t&&o.CODE,title:n[t].title||i["components.controls.inline.".concat(t)]},N.a.createElement("img",{alt:"",src:n[t].icon}))}))}},{key:"renderInDropDown",value:function(){var t=this.props,n=t.config,e=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=t.onChange,l=t.translations,s=n.className,u=n.dropdownClassName,p=n.title;return N.a.createElement(H,{className:w()("rdw-inline-dropdown",s),optionWrapperClassName:w()(u),onChange:a,expanded:e,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-inline-control",title:p},N.a.createElement("img",{src:v(n),alt:""}),n.options.map(function(t,e){return N.a.createElement(K,{key:e,value:t,className:w()("rdw-inline-dropdownoption",n[t].className),active:!0===c[t]||"MONOSPACE"===t&&c.CODE,title:n[t].title||l["components.controls.inline.".concat(t)]},N.a.createElement("img",{src:n[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&$(t.prototype,e),n&&$(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function rt(t){return(rt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function it(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ct(t,e){return(ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function at(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=lt(o);if(r){var n=lt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===rt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function lt(t){return(lt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}ot.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var st=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ct(t,e)}(i,f["Component"]);var t,e,n,r=at(i);function i(t){var l;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(l=r.call(this,t)).onExpandEvent=function(){l.signalExpanded=!l.state.expanded},l.expandCollapse=function(){l.setState({expanded:l.signalExpanded}),l.signalExpanded=!1},l.toggleInlineStyle=function(t){var e="monospace"===t?"CODE":t.toUpperCase(),n=l.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleInlineStyle(o,e);if("subscript"===t||"superscript"===t){var c="subscript"===t?"SUPERSCRIPT":"SUBSCRIPT",a=E.Modifier.removeInlineStyle(i.getCurrentContent(),i.getSelection(),c);i=E.EditorState.push(i,a,"change-inline-style")}i&&r(i)},l.changeKeys=function(t){if(t){var n={};return h(t,function(t,e){n["CODE"===t?"monospace":t.toLowerCase()]=e}),n}},l.doExpand=function(){l.setState({expanded:!0})},l.doCollapse=function(){l.setState({expanded:!1})};var e=l.props,n=e.editorState,o=e.modalHandler;return l.state={currentStyles:n?l.changeKeys(Object(S.getSelectionInlineStyle)(n)):{}},o.registerCallBack(l.expandCollapse),l}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentStyles:this.changeKeys(Object(S.getSelectionInlineStyle)(e))})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentStyles,c=e.component||ot;return N.a.createElement(c,{config:e,translations:n,currentState:i,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.toggleInlineStyle})}}])&&it(t.prototype,e),n&&it(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();st.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(15);function ut(t){return(ut="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function dt(t,e){return(dt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ft(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=yt(o);if(r){var n=yt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ut(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function yt(t){return(yt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var mt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&dt(t,e)}(r,f["Component"]);var t,e,n,o=ft(r);function r(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(e=o.call(this,t)).getBlockTypes=function(t){return[{label:"Normal",displayName:t["components.controls.blocktype.normal"]},{label:"H1",displayName:t["components.controls.blocktype.h1"]},{label:"H2",displayName:t["components.controls.blocktype.h2"]},{label:"H3",displayName:t["components.controls.blocktype.h3"]},{label:"H4",displayName:t["components.controls.blocktype.h4"]},{label:"H5",displayName:t["components.controls.blocktype.h5"]},{label:"H6",displayName:t["components.controls.blocktype.h6"]},{label:"Blockquote",displayName:t["components.controls.blocktype.blockquote"]},{label:"Code",displayName:t["components.controls.blocktype.code"]}]},e.state={blockTypes:e.getBlockTypes(t.translations)},e}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.translations;e!==t.translations&&this.setState({blockTypes:this.getBlockTypes(e)})}},{key:"renderFlat",value:function(t){var e=this.props,n=e.config.className,o=e.onChange,r=e.currentState.blockType;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n)},t.map(function(t,e){return N.a.createElement(R,{key:e,value:t.label,active:r===t.label,onClick:o},t.displayName)}))}},{key:"renderInDropdown",value:function(t){var e=this.props,n=e.config,o=n.className,r=n.dropdownClassName,i=n.title,c=e.currentState.blockType,a=e.expanded,l=e.doExpand,s=e.onExpandEvent,u=e.doCollapse,p=e.onChange,d=e.translations,f=this.state.blockTypes.filter(function(t){return t.label===c}),y=f&&f[0]&&f[0].displayName;return N.a.createElement("div",{className:"rdw-block-wrapper","aria-label":"rdw-block-control"},N.a.createElement(H,{className:w()("rdw-block-dropdown",o),optionWrapperClassName:w()(r),onChange:p,expanded:a,doExpand:l,doCollapse:u,onExpandEvent:s,title:i||d["components.controls.blocktype.blocktype"]},N.a.createElement("span",null,y||d["components.controls.blocktype.blocktype"]),t.map(function(t,e){return N.a.createElement(K,{active:c===t.label,value:t.label,key:e},t.displayName)})))}},{key:"render",value:function(){var n=this.props.config,t=n.inDropdown,e=this.state.blockTypes.filter(function(t){var e=t.label;return-1<n.options.indexOf(e)});return t?this.renderInDropdown(e):this.renderFlat(e)}}])&&pt(t.prototype,e),n&&pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();mt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var gt=mt;function bt(t){return(bt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Mt(t,e){return(Mt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function jt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=vt(o);if(r){var n=vt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===bt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function vt(t){return(vt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Nt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Mt(t,e)}(r,f["Component"]);var t,e,n,o=jt(r);function r(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(c=o.call(this,t)).onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.blocksTypes=[{label:"Normal",style:"unstyled"},{label:"H1",style:"header-one"},{label:"H2",style:"header-two"},{label:"H3",style:"header-three"},{label:"H4",style:"header-four"},{label:"H5",style:"header-five"},{label:"H6",style:"header-six"},{label:"Blockquote",style:"blockquote"},{label:"Code",style:"code"}],c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleBlockType=function(e){var t=c.blocksTypes.find(function(t){return t.label===e}).style,n=c.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleBlockType(o,t);i&&r(i)};var e=t.editorState,n=t.modalHandler;return c.state={expanded:!1,currentBlockType:e?Object(S.getSelectedBlocksType)(e):"unstyled"},n.registerCallBack(c.expandCollapse),c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlockType:Object(S.getSelectedBlocksType)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentBlockType,c=e.component||gt,a=this.blocksTypes.find(function(t){return t.style===i});return N.a.createElement(c,{config:e,translations:n,currentState:{blockType:a&&a.label},onChange:this.toggleBlockType,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&ht(t.prototype,e),n&&ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Nt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Et=Nt;n(16);function St(t){return(St="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Ct(t,e){return(Ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Dt(o);if(r){var n=Dt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===St(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Dt(t){return(Dt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var kt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Ct(t,e)}(i,f["Component"]);var t,e,n,r=Lt(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontSize:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-size");e=e.substring(0,e.length-2),this.setState({defaultFontSize:e})}}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.dropdownClassName,i=e.options,c=e.title,a=t.onChange,l=t.expanded,s=t.doCollapse,u=t.onExpandEvent,p=t.doExpand,d=t.translations,f=this.props.currentState.fontSize,y=this.state.defaultFontSize;return y=Number(y),f=f||i&&0<=i.indexOf(y)&&y,N.a.createElement("div",{className:"rdw-fontsize-wrapper","aria-label":"rdw-font-size-control"},N.a.createElement(H,{className:w()("rdw-fontsize-dropdown",o),optionWrapperClassName:w()(r),onChange:a,expanded:l,doExpand:p,doCollapse:s,onExpandEvent:u,title:c||d["components.controls.fontsize.fontsize"]},f?N.a.createElement("span",null,f):N.a.createElement("img",{src:n,alt:""}),i.map(function(t,e){return N.a.createElement(K,{className:"rdw-fontsize-option",active:f===t,value:t,key:e},t)})))}}])&&wt(t.prototype,e),n&&wt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function Ot(t){return(Ot="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function It(t,e){return(It=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Tt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=At(o);if(r){var n=At(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ot(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function At(t){return(At=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}kt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var zt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&It(t,e)}(r,f["Component"]);var t,e,n,o=Tt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontSize=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontSize",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontSize:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontSize:Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontSize,c=e.component||kt,a=i&&Number(i.substring(9));return N.a.createElement(c,{config:e,translations:n,currentState:{fontSize:a},onChange:this.toggleFontSize,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&xt(t.prototype,e),n&&xt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();zt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(17);function _t(t){return(_t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rt(t,e){return(Rt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ut(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bt(o);if(r){var n=Bt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_t(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bt(t){return(Bt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ft=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rt(t,e)}(i,f["Component"]);var t,e,n,r=Ut(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontFamily:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-family");this.setState({defaultFontFamily:e})}}},{key:"render",value:function(){var e=this.state.defaultFontFamily,t=this.props,n=t.config,o=n.className,r=n.dropdownClassName,i=n.options,c=n.title,a=t.translations,l=t.onChange,s=t.expanded,u=t.doCollapse,p=t.onExpandEvent,d=t.doExpand,f=this.props.currentState.fontFamily;return f=f||i&&e&&i.some(function(t){return t.toLowerCase()===e.toLowerCase()})&&e,N.a.createElement("div",{className:"rdw-fontfamily-wrapper","aria-label":"rdw-font-family-control"},N.a.createElement(H,{className:w()("rdw-fontfamily-dropdown",o),optionWrapperClassName:w()("rdw-fontfamily-optionwrapper",r),onChange:l,expanded:s,doExpand:d,doCollapse:u,onExpandEvent:p,title:c||a["components.controls.fontfamily.fontfamily"]},N.a.createElement("span",{className:"rdw-fontfamily-placeholder"},f||a["components.controls.fontfamily.fontfamily"]),i.map(function(t,e){return N.a.createElement(K,{active:f===t,value:t,key:e},t)})))}}])&&Pt(t.prototype,e),n&&Pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Ft.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var Yt=Ft;function Qt(t){return(Qt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Zt(t,e){return(Zt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Wt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Gt(o);if(r){var n=Gt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Qt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Gt(t){return(Gt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Jt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Zt(t,e)}(r,f["Component"]);var t,e,n,o=Wt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontFamily=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontFamily",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontFamily:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontFamily:Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontFamily,c=e.component||Yt,a=i&&i.substring(11);return N.a.createElement(c,{translations:n,config:e,currentState:{fontFamily:a},onChange:this.toggleFontFamily,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Ht(t.prototype,e),n&&Ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Jt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(18);function Vt(t){return(Vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Kt(t,e){return(Kt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Xt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=$t(o);if(r){var n=$t(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function $t(t){return($t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var te=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Kt(t,e)}(i,f["Component"]);var t,e,n,r=Xt(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).options=["unordered","ordered","indent","outdent"],e.toggleBlockType=function(t){(0,e.props.onChange)(t)},e.indent=function(){(0,e.props.onChange)("indent")},e.outdent=function(){(0,e.props.onChange)("outdent")},e}return t=i,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=t.currentState.listType,o=t.translations,r=t.indentDisabled,i=t.outdentDisabled,c=e.options,a=e.unordered,l=e.ordered,s=e.indent,u=e.outdent,p=e.className;return N.a.createElement("div",{className:w()("rdw-list-wrapper",p),"aria-label":"rdw-list-control"},0<=c.indexOf("unordered")&&N.a.createElement(R,{value:"unordered",onClick:this.toggleBlockType,className:w()(a.className),active:"unordered"===n,title:a.title||o["components.controls.list.unordered"]},N.a.createElement("img",{src:a.icon,alt:""})),0<=c.indexOf("ordered")&&N.a.createElement(R,{value:"ordered",onClick:this.toggleBlockType,className:w()(l.className),active:"ordered"===n,title:l.title||o["components.controls.list.ordered"]},N.a.createElement("img",{src:l.icon,alt:""})),0<=c.indexOf("indent")&&N.a.createElement(R,{onClick:this.indent,disabled:r,className:w()(s.className),title:s.title||o["components.controls.list.indent"]},N.a.createElement("img",{src:s.icon,alt:""})),0<=c.indexOf("outdent")&&N.a.createElement(R,{onClick:this.outdent,disabled:i,className:w()(u.className),title:u.title||o["components.controls.list.outdent"]},N.a.createElement("img",{src:u.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var n=this,t=this.props,o=t.config,e=t.expanded,r=t.doCollapse,i=t.doExpand,c=t.onExpandEvent,a=t.onChange,l=t.currentState.listType,s=t.translations,u=o.options,p=o.className,d=o.dropdownClassName,f=o.title;return N.a.createElement(H,{className:w()("rdw-list-dropdown",p),optionWrapperClassName:w()(d),onChange:a,expanded:e,doExpand:i,doCollapse:r,onExpandEvent:c,"aria-label":"rdw-list-control",title:f||s["components.controls.list.list"]},N.a.createElement("img",{src:v(o),alt:""}),this.options.filter(function(t){return 0<=u.indexOf(t)}).map(function(t,e){return N.a.createElement(K,{key:e,value:t,disabled:n.props["".concat(t,"Disabled")],className:w()("rdw-list-dropdownOption",o[t].className),active:l===t,title:o[t].title||s["components.controls.list.".concat(t)]},N.a.createElement("img",{src:o[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&qt(t.prototype,e),n&&qt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function ee(t){return(ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ne(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function oe(t,e){return(oe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ie(o);if(r){var n=ie(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ee(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ie(t){return(ie=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}te.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object,indentDisabled:y.a.bool,outdentDisabled:y.a.bool};var ce=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&oe(t,e)}(c,f["Component"]);var t,e,n,r=re(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){"unordered"===t?i.toggleBlockType("unordered-list-item"):"ordered"===t?i.toggleBlockType("ordered-list-item"):"indent"===t?i.adjustDepth(1):i.adjustDepth(-1)},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleBlockType=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=E.RichUtils.toggleBlockType(o,t);r&&n(r)},i.adjustDepth=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=Object(S.changeDepth)(o,t,4);r&&n(r)},i.isIndentDisabled=function(){var t=i.props.editorState,e=i.state.currentBlock,n=Object(S.getBlockBeforeSelectedBlock)(t);return!n||!Object(S.isListBlock)(e)||n.get("type")!==e.get("type")||n.get("depth")<e.get("depth")},i.isOutdentDisabled=function(){var t=i.state.currentBlock;return!t||!Object(S.isListBlock)(t)||t.get("depth")<=0};var e=i.props,n=e.editorState,o=e.modalHandler;return i.state={expanded:!1,currentBlock:n?Object(S.getSelectedBlock)(n):void 0},o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlock:Object(S.getSelectedBlock)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t,e=this.props,n=e.config,o=e.translations,r=this.state,i=r.expanded,c=r.currentBlock,a=n.component||te;"unordered-list-item"===c.get("type")?t="unordered":"ordered-list-item"===c.get("type")&&(t="ordered");var l=this.isIndentDisabled(),s=this.isOutdentDisabled();return N.a.createElement(a,{config:n,translations:o,currentState:{listType:t},expanded:i,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange,indentDisabled:l,outdentDisabled:s})}}])&&ne(t.prototype,e),n&&ne(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();ce.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(19);function ae(t){return(ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function se(t,e){return(se=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ue(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=pe(o);if(r){var n=pe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ae(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function pe(t){return(pe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var de=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&se(t,e)}(r,f["Component"]);var t,e,n,o=ue(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.left,r=e.center,i=e.right,c=e.justify,a=e.className,l=t.onChange,s=t.currentState.textAlignment,u=t.translations;return N.a.createElement("div",{className:w()("rdw-text-align-wrapper",a),"aria-label":"rdw-textalign-control"},0<=n.indexOf("left")&&N.a.createElement(R,{value:"left",className:w()(o.className),active:"left"===s,onClick:l,title:o.title||u["components.controls.textalign.left"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("center")&&N.a.createElement(R,{value:"center",className:w()(r.className),active:"center"===s,onClick:l,title:r.title||u["components.controls.textalign.center"]},N.a.createElement("img",{src:r.icon,alt:""})),0<=n.indexOf("right")&&N.a.createElement(R,{value:"right",className:w()(i.className),active:"right"===s,onClick:l,title:i.title||u["components.controls.textalign.right"]},N.a.createElement("img",{src:i.icon,alt:""})),0<=n.indexOf("justify")&&N.a.createElement(R,{value:"justify",className:w()(c.className),active:"justify"===s,onClick:l,title:c.title||u["components.controls.textalign.justify"]},N.a.createElement("img",{src:c.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState.textAlignment,a=t.onChange,l=t.translations,s=e.options,u=e.left,p=e.center,d=e.right,f=e.justify,y=e.className,m=e.dropdownClassName,g=e.title;return N.a.createElement(H,{className:w()("rdw-text-align-dropdown",y),optionWrapperClassName:w()(m),onChange:a,expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-textalign-control",title:g||l["components.controls.textalign.textalign"]},N.a.createElement("img",{src:c&&e[c]&&e[c].icon||v(e),alt:""}),0<=s.indexOf("left")&&N.a.createElement(K,{value:"left",active:"left"===c,className:w()("rdw-text-align-dropdownOption",u.className),title:u.title||l["components.controls.textalign.left"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("center")&&N.a.createElement(K,{value:"center",active:"center"===c,className:w()("rdw-text-align-dropdownOption",p.className),title:p.title||l["components.controls.textalign.center"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=s.indexOf("right")&&N.a.createElement(K,{value:"right",active:"right"===c,className:w()("rdw-text-align-dropdownOption",d.className),title:d.title||l["components.controls.textalign.right"]},N.a.createElement("img",{src:d.icon,alt:""})),0<=s.indexOf("justify")&&N.a.createElement(K,{value:"justify",active:"justify"===c,className:w()("rdw-text-align-dropdownOption",f.className),title:f.title||l["components.controls.textalign.justify"]},N.a.createElement("img",{src:f.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&le(t.prototype,e),n&&le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function fe(t){return(fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ye(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function me(t,e){return(me=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ge(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=be(o);if(r){var n=be(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===fe(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function be(t){return(be=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}de.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var he=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&me(t,e)}(i,f["Component"]);var t,e,n,o=ge(i);function i(t){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(r=o.call(this,t)).onExpandEvent=function(){r.signalExpanded=!r.state.expanded},r.expandCollapse=function(){r.setState({expanded:r.signalExpanded}),r.signalExpanded=!1},r.doExpand=function(){r.setState({expanded:!0})},r.doCollapse=function(){r.setState({expanded:!1})},r.addBlockAlignmentData=function(t){var e=r.props,n=e.editorState,o=e.onChange;o(r.state.currentTextAlignment!==t?Object(S.setBlockData)(n,{"text-align":t}):Object(S.setBlockData)(n,{"text-align":void 0}))};var e=r.props.modalHandler;return r.state={currentTextAlignment:void 0},e.registerCallBack(r.expandCollapse),r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e!==t.editorState&&this.setState({currentTextAlignment:Object(S.getSelectedBlocksMetadata)(e).get("text-align")})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentTextAlignment,c=e.component||de;return N.a.createElement(c,{config:e,translations:n,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{textAlignment:i},onChange:this.addBlockAlignmentData})}}])&&ye(t.prototype,e),n&&ye(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();he.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(20);function Me(t){return(Me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function je(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ve(t,e){return(ve=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ne(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ee(o);if(r){var n=Ee(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Me(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ee(t){return(Ee=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Se=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ve(t,e)}(r,f["Component"]);var t,e,n,o=Ne(r);function r(){var u;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(u=o.call.apply(o,[this].concat(e))).state={currentStyle:"color"},u.onChange=function(t){(0,u.props.onChange)(u.state.currentStyle,t)},u.setCurrentStyleColor=function(){u.setState({currentStyle:"color"})},u.setCurrentStyleBgcolor=function(){u.setState({currentStyle:"bgcolor"})},u.renderModal=function(){var t=u.props,e=t.config,n=e.popupClassName,o=e.colors,r=t.currentState,i=r.color,c=r.bgColor,a=t.translations,l=u.state.currentStyle,s="color"===l?i:c;return N.a.createElement("div",{className:w()("rdw-colorpicker-modal",n),onClick:j},N.a.createElement("span",{className:"rdw-colorpicker-modal-header"},N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"color"===l}),onClick:u.setCurrentStyleColor},a["components.controls.colorpicker.text"]),N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"bgcolor"===l}),onClick:u.setCurrentStyleBgcolor},a["components.controls.colorpicker.background"])),N.a.createElement("span",{className:"rdw-colorpicker-modal-options"},o.map(function(t,e){return N.a.createElement(R,{value:t,key:e,className:"rdw-colorpicker-option",activeClassName:"rdw-colorpicker-option-active",active:s===t,onClick:u.onChange},N.a.createElement("span",{style:{backgroundColor:t},className:"rdw-colorpicker-cube"}))})))},u}return t=r,(e=[{key:"componentDidUpdate",value:function(t){this.props.expanded&&!t.expanded&&this.setState({currentStyle:"color"})}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-colorpicker-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-color-picker",title:r||a["components.controls.colorpicker.colorpicker"]},N.a.createElement(R,{onClick:c,className:w()(o)},N.a.createElement("img",{src:n,alt:""})),i?this.renderModal():void 0)}}])&&je(t.prototype,e),n&&je(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Se.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var we=Se;function Ce(t){return(Ce="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function De(t,e){return(De=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ke(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Oe(o);if(r){var n=Oe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ce(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Oe(t){return(Oe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&De(t,e)}(i,f["Component"]);var t,e,n,r=ke(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).state={expanded:!1,currentColor:void 0,currentBgColor:void 0},c.onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleColor=function(t,e){var n=c.props,o=n.editorState,r=n.onChange,i=Object(S.toggleCustomInlineStyle)(o,t,e);i&&r(i),c.doCollapse()};var e=t.editorState,n=t.modalHandler,o={expanded:!1,currentColor:void 0,currentBgColor:void 0};return e&&(o.currentColor=Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,o.currentBgColor=Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR),c.state=o,n.registerCallBack(c.expandCollapse),c}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentColor:Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,currentBgColor:Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.currentColor,i=o.currentBgColor,c=o.expanded,a=e.component||we,l=r&&r.substring(6),s=i&&i.substring(8);return N.a.createElement(a,{config:e,translations:n,onChange:this.toggleColor,expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{color:l,bgColor:s}})}}])&&Le(t.prototype,e),n&&Le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();xe.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Ie=xe,Te=n(7),Ae=n.n(Te);n(26);function ze(t){return(ze="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function _e(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Pe(t,e){return(Pe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ue(o);if(r){var n=Ue(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ze(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ue(t){return(Ue=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Be=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Pe(t,e)}(r,f["Component"]);var t,e,n,o=Re(r);function r(){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:c.props.config.defaultTargetOption},c.removeLink=function(){(0,c.props.onChange)("unlink")},c.addLink=function(){var t=c.props.onChange,e=c.state;t("link",e.linkTitle,e.linkTarget,e.linkTargetOption)},c.updateValue=function(t){var e,n,o;c.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},c.updateTargetOption=function(t){c.setState({linkTargetOption:t.target.checked?"_blank":"_self"})},c.hideModal=function(){c.setState({showModal:!1})},c.signalExpandShowModal=function(){var t=c.props,e=t.onExpandEvent,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target||"",linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c.forceExpandAndShowModal=function(){var t=c.props,e=t.doExpand,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target,linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){t.expanded&&!this.props.expanded&&this.setState({showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:this.props.config.defaultTargetOption})}},{key:"renderAddLinkModal",value:function(){var t=this.props,e=t.config.popupClassName,n=t.doCollapse,o=t.translations,r=this.state,i=r.linkTitle,c=r.linkTarget,a=r.linkTargetOption;return N.a.createElement("div",{className:w()("rdw-link-modal",e),onClick:j},N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTitle"},o["components.controls.link.linkTitle"]),N.a.createElement("input",{id:"linkTitle",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTitle",value:i}),N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTarget"},o["components.controls.link.linkTarget"]),N.a.createElement("input",{id:"linkTarget",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTarget",value:c}),N.a.createElement("label",{className:"rdw-link-modal-target-option",htmlFor:"openLinkInNewWindow"},N.a.createElement("input",{id:"openLinkInNewWindow",type:"checkbox",defaultChecked:"_blank"===a,value:"_blank",onChange:this.updateTargetOption}),N.a.createElement("span",null,o["components.controls.link.linkTargetOption"])),N.a.createElement("span",{className:"rdw-link-modal-buttonsection"},N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:this.addLink,disabled:!c||!i},o["generic.add"]),N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:n},o["generic.cancel"])))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.link,r=e.unlink,i=e.className,c=t.currentState,a=t.expanded,l=t.translations,s=this.state.showModal;return N.a.createElement("div",{className:w()("rdw-link-wrapper",i),"aria-label":"rdw-link-control"},0<=n.indexOf("link")&&N.a.createElement(R,{value:"unordered-list-item",className:w()(o.className),onClick:this.signalExpandShowModal,"aria-haspopup":"true","aria-expanded":s,title:o.title||l["components.controls.link.link"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("unlink")&&N.a.createElement(R,{disabled:!c.link,value:"ordered-list-item",className:w()(r.className),onClick:this.removeLink,title:r.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:r.icon,alt:""})),a&&s?this.renderAddLinkModal():void 0)}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.expanded,n=t.onExpandEvent,o=t.doCollapse,r=t.doExpand,i=t.onChange,c=t.config,a=t.currentState,l=t.translations,s=c.options,u=c.link,p=c.unlink,d=c.className,f=c.dropdownClassName,y=c.title,m=this.state.showModal;return N.a.createElement("div",{className:"rdw-link-wrapper","aria-haspopup":"true","aria-label":"rdw-link-control","aria-expanded":e,title:y},N.a.createElement(H,{className:w()("rdw-link-dropdown",d),optionWrapperClassName:w()(f),onChange:i,expanded:e&&!m,doExpand:r,doCollapse:o,onExpandEvent:n},N.a.createElement("img",{src:v(c),alt:""}),0<=s.indexOf("link")&&N.a.createElement(K,{onClick:this.forceExpandAndShowModal,className:w()("rdw-link-dropdownoption",u.className),title:u.title||l["components.controls.link.link"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("unlink")&&N.a.createElement(K,{onClick:this.removeLink,disabled:!a.link,className:w()("rdw-link-dropdownoption",p.className),title:p.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:p.icon,alt:""}))),e&&m?this.renderAddLinkModal():void 0)}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&_e(t.prototype,e),n&&_e(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Be.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var Fe=Be;function Ye(t){return(Ye="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Qe(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function He(t,e){return(He=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ze(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=We(o);if(r){var n=We(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ye(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function We(t){return(We=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ge(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ge(Object(n),!0).forEach(function(t){Ve(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ge(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function Ve(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function qe(t){var e=Ke.match(t.target);return Je(Je({},t),{},{target:e&&e[0]&&e[0].url||t.target})}var Ke=Ae()(),Xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&He(t,e)}(i,f["Component"]);var t,e,n,r=Ze(i);function i(t){var d;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(d=r.call(this,t)).onExpandEvent=function(){d.signalExpanded=!d.state.expanded},d.onChange=function(t,e,n,o){var r=d.props.config.linkCallback;if("link"===t){var i=(r||qe)({title:e,target:n,targetOption:o});d.addLink(i.title,i.target,i.targetOption)}else d.removeLink()},d.getCurrentValues=function(){var t=d.props.editorState,e=d.state.currentEntity,n=t.getCurrentContent(),o={};if(e&&"LINK"===n.getEntity(e).get("type")){o.link={};var r=e&&Object(S.getEntityRange)(t,e);o.link.target=e&&n.getEntity(e).get("data").url,o.link.targetOption=e&&n.getEntity(e).get("data").targetOption,o.link.title=r&&r.text}return o.selectionText=Object(S.getSelectionText)(t),o},d.doExpand=function(){d.setState({expanded:!0})},d.expandCollapse=function(){d.setState({expanded:d.signalExpanded}),d.signalExpanded=!1},d.doCollapse=function(){d.setState({expanded:!1})},d.removeLink=function(){var t=d.props,e=t.editorState,n=t.onChange,o=d.state.currentEntity,r=e.getSelection();if(o){var i=Object(S.getEntityRange)(e,o);r=r.getIsBackward()?r.merge({anchorOffset:i.end,focusOffset:i.start}):r.merge({anchorOffset:i.start,focusOffset:i.end}),n(E.RichUtils.toggleLink(e,r,null))}},d.addLink=function(t,e,n){var o=d.props,r=o.editorState,i=o.onChange,c=d.state.currentEntity,a=r.getSelection();if(c){var l=Object(S.getEntityRange)(r,c);a=a.getIsBackward()?a.merge({anchorOffset:l.end,focusOffset:l.start}):a.merge({anchorOffset:l.start,focusOffset:l.end})}var s=r.getCurrentContent().createEntity("LINK","MUTABLE",{url:e,targetOption:n}).getLastCreatedEntityKey(),u=E.Modifier.replaceText(r.getCurrentContent(),a,"".concat(t),r.getCurrentInlineStyle(),s),p=E.EditorState.push(r,u,"insert-characters");a=p.getSelection().merge({anchorOffset:a.get("anchorOffset")+t.length,focusOffset:a.get("anchorOffset")+t.length}),p=E.EditorState.acceptSelection(p,a),u=E.Modifier.insertText(p.getCurrentContent(),a," ",p.getCurrentInlineStyle(),void 0),i(E.EditorState.push(p,u,"insert-characters")),d.doCollapse()};var e=d.props,n=e.editorState,o=e.modalHandler;return d.state={expanded:!1,link:void 0,selectionText:void 0,currentEntity:n?Object(S.getSelectionEntity)(n):void 0},o.registerCallBack(d.expandCollapse),d}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentEntity:Object(S.getSelectionEntity)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=this.getCurrentValues(),i=r.link,c=r.selectionText,a=e.component||Fe;return N.a.createElement(a,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{link:i,selectionText:c},onChange:this.onChange})}}])&&Qe(t.prototype,e),n&&Qe(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Xe.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var $e=Xe;n(27);function tn(t){return(tn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function en(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function nn(t,e){return(nn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function on(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=rn(o);if(r){var n=rn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===tn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function rn(t){return(rn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&nn(t,e)}(i,f["Component"]);var t,e,n,o=on(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={embeddedLink:"",height:r.props.config.defaultSize.height,width:r.props.config.defaultSize.width},r.onChange=function(){var t=r.props.onChange,e=r.state;t(e.embeddedLink,e.height,e.width)},r.updateValue=function(t){var e,n,o;r.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props,n=e.expanded,o=e.config;if(!n&&t.expanded){var r=o.defaultSize,i=r.height,c=r.width;this.setState({embeddedLink:"",height:i,width:c})}}},{key:"rendeEmbeddedLinkModal",value:function(){var t=this.state,e=t.embeddedLink,n=t.height,o=t.width,r=this.props,i=r.config.popupClassName,c=r.doCollapse,a=r.translations;return N.a.createElement("div",{className:w()("rdw-embedded-modal",i),onClick:j},N.a.createElement("div",{className:"rdw-embedded-modal-header"},N.a.createElement("span",{className:"rdw-embedded-modal-header-option"},a["components.controls.embedded.embeddedlink"],N.a.createElement("span",{className:"rdw-embedded-modal-header-label"}))),N.a.createElement("div",{className:"rdw-embedded-modal-link-section"},N.a.createElement("span",{className:"rdw-embedded-modal-link-input-wrapper"},N.a.createElement("input",{className:"rdw-embedded-modal-link-input",placeholder:a["components.controls.embedded.enterlink"],onChange:this.updateValue,onBlur:this.updateValue,value:e,name:"embeddedLink"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("div",{className:"rdw-embedded-modal-size"},N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:n,name:"height",className:"rdw-embedded-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:o,name:"width",className:"rdw-embedded-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")))),N.a.createElement("span",{className:"rdw-embedded-modal-btn-section"},N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:this.onChange,disabled:!e||!n||!o},a["generic.add"]),N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:c},a["generic.cancel"])))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-embedded-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-embedded-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.embedded.embedded"]},N.a.createElement("img",{src:n,alt:""})),i?this.rendeEmbeddedLinkModal():void 0)}}])&&en(t.prototype,e),n&&en(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object,doCollapse:y.a.func};var an=cn;function ln(t){return(ln="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function sn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function un(t,e){return(un=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function pn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=dn(o);if(r){var n=dn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ln(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function dn(t){return(dn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&un(t,e)}(r,f["Component"]);var t,e,n,o=pn(r);function r(){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(s=o.call.apply(o,[this].concat(e))).state={expanded:!1},s.onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.addEmbeddedLink=function(t,e,n){var o=s.props,r=o.editorState,i=o.onChange,c=o.config.embedCallback,a=c?c(t):t,l=r.getCurrentContent().createEntity("EMBEDDED_LINK","MUTABLE",{src:a,height:e,width:n}).getLastCreatedEntityKey();i(E.AtomicBlockUtils.insertAtomicBlock(r,l," ")),s.doCollapse()},s}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||an;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmbeddedLink,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&sn(t.prototype,e),n&&sn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var yn=fn;n(28);function mn(t){return(mn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function gn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function bn(t,e){return(bn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function hn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Mn(o);if(r){var n=Mn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===mn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Mn(t){return(Mn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var jn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&bn(t,e)}(i,f["Component"]);var t,e,n,r=hn(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t.target.innerHTML)},e}return t=i,(e=[{key:"renderEmojiModal",value:function(){var n=this,t=this.props.config,e=t.popupClassName,o=t.emojis;return N.a.createElement("div",{className:w()("rdw-emoji-modal",e),onClick:j},o.map(function(t,e){return N.a.createElement("span",{key:e,className:"rdw-emoji-icon",alt:"",onClick:n.onChange},t)}))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-emoji-wrapper","aria-haspopup":"true","aria-label":"rdw-emoji-control","aria-expanded":i,title:r||a["components.controls.emoji.emoji"]},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c},N.a.createElement("img",{src:n,alt:""})),i?this.renderEmojiModal():void 0)}}])&&gn(t.prototype,e),n&&gn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();jn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var vn=jn;function Nn(t){return(Nn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function En(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Sn(t,e){return(Sn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function wn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Cn(o);if(r){var n=Cn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Nn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Cn(t){return(Cn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ln=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Sn(t,e)}(r,f["Component"]);var t,e,n,o=wn(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={expanded:!1},i.onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.addEmoji=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());o(E.EditorState.push(n,r,"insert-characters")),i.doCollapse()},i}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||vn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmoji,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onCollpase:this.closeModal})}}])&&En(t.prototype,e),n&&En(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Ln.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Dn(){return N.a.createElement("div",{className:"rdw-spinner"},N.a.createElement("div",{className:"rdw-bounce1"}),N.a.createElement("div",{className:"rdw-bounce2"}),N.a.createElement("div",{className:"rdw-bounce3"}))}n(29),n(30);function kn(t){return(kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function On(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function xn(t,e){return(xn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function In(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Tn(o);if(r){var n=Tn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Tn(t){return(Tn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var An=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&xn(t,e)}(r,f["Component"]);var t,e,n,o=In(r);function r(){var a;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))).state={imgSrc:"",dragEnter:!1,uploadHighlighted:a.props.config.uploadEnabled&&!!a.props.config.uploadCallback,showImageLoading:!1,height:a.props.config.defaultSize.height,width:a.props.config.defaultSize.width,alt:""},a.onDragEnter=function(t){a.stopPropagation(t),a.setState({dragEnter:!0})},a.onImageDrop=function(t){var e,n;t.preventDefault(),t.stopPropagation(),a.setState({dragEnter:!1}),n=t.dataTransfer.items?(e=t.dataTransfer.items,!0):(e=t.dataTransfer.files,!1);for(var o=0;o<e.length;o+=1)if((!n||"file"===e[o].kind)&&e[o].type.match("^image/")){var r=n?e[o].getAsFile():e[o];a.uploadImage(r)}},a.showImageUploadOption=function(){a.setState({uploadHighlighted:!0})},a.addImageFromState=function(){var t=a.state,e=t.imgSrc,n=t.alt,o=a.state,r=o.height,i=o.width,c=a.props.onChange;isNaN(r)||(r+="px"),isNaN(i)||(i+="px"),c(e,r,i,n)},a.showImageURLOption=function(){a.setState({uploadHighlighted:!1})},a.toggleShowImageLoading=function(){var t=!a.state.showImageLoading;a.setState({showImageLoading:t})},a.updateValue=function(t){var e,n,o;a.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},a.selectImage=function(t){t.target.files&&0<t.target.files.length&&a.uploadImage(t.target.files[0])},a.uploadImage=function(t){a.toggleShowImageLoading(),(0,a.props.config.uploadCallback)(t).then(function(t){var e=t.data;a.setState({showImageLoading:!1,dragEnter:!1,imgSrc:e.link||e.url}),a.fileUpload=!1}).catch(function(){a.setState({showImageLoading:!1,dragEnter:!1})})},a.fileUploadClick=function(t){a.fileUpload=!0,t.stopPropagation()},a.stopPropagation=function(t){a.fileUpload?a.fileUpload=!1:(t.preventDefault(),t.stopPropagation())},a}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.config;t.expanded&&!this.props.expanded?this.setState({imgSrc:"",dragEnter:!1,uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback,showImageLoading:!1,height:e.defaultSize.height,width:e.defaultSize.width,alt:""}):e.uploadCallback===t.config.uploadCallback&&e.uploadEnabled===t.config.uploadEnabled||this.setState({uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback})}},{key:"renderAddImageModal",value:function(){var t=this.state,e=t.imgSrc,n=t.uploadHighlighted,o=t.showImageLoading,r=t.dragEnter,i=t.height,c=t.width,a=t.alt,l=this.props,s=l.config,u=s.popupClassName,p=s.uploadCallback,d=s.uploadEnabled,f=s.urlEnabled,y=s.previewImage,m=s.inputAccept,g=s.alt,b=l.doCollapse,h=l.translations;return N.a.createElement("div",{className:w()("rdw-image-modal",u),onClick:this.stopPropagation},N.a.createElement("div",{className:"rdw-image-modal-header"},d&&p&&N.a.createElement("span",{onClick:this.showImageUploadOption,className:"rdw-image-modal-header-option"},h["components.controls.image.fileUpload"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":n})})),f&&N.a.createElement("span",{onClick:this.showImageURLOption,className:"rdw-image-modal-header-option"},h["components.controls.image.byURL"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":!n})}))),n?N.a.createElement("div",{onClick:this.fileUploadClick},N.a.createElement("div",{onDragEnter:this.onDragEnter,onDragOver:this.stopPropagation,onDrop:this.onImageDrop,className:w()("rdw-image-modal-upload-option",{"rdw-image-modal-upload-option-highlighted":r})},N.a.createElement("label",{htmlFor:"file",className:"rdw-image-modal-upload-option-label"},y&&e?N.a.createElement("img",{src:e,alt:e,className:"rdw-image-modal-upload-option-image-preview"}):e||h["components.controls.image.dropFileText"])),N.a.createElement("input",{type:"file",id:"file",accept:m,onChange:this.selectImage,className:"rdw-image-modal-upload-option-input"})):N.a.createElement("div",{className:"rdw-image-modal-url-section"},N.a.createElement("input",{className:"rdw-image-modal-url-input",placeholder:h["components.controls.image.enterlink"],name:"imgSrc",onChange:this.updateValue,onBlur:this.updateValue,value:e}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),g.present&&N.a.createElement("div",{className:"rdw-image-modal-size"},N.a.createElement("span",{className:"rdw-image-modal-alt-lbl"},"Alt Text"),N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:a,name:"alt",className:"rdw-image-modal-alt-input",placeholder:"alt"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},g.mandatory&&"*")),N.a.createElement("div",{className:"rdw-image-modal-size"},"↕ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:i,name:"height",className:"rdw-image-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")," ↔ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:c,name:"width",className:"rdw-image-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",{className:"rdw-image-modal-btn-section"},N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:this.addImageFromState,disabled:!e||!i||!c||g.mandatory&&!a},h["generic.add"]),N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:b},h["generic.cancel"])),o?N.a.createElement("div",{className:"rdw-image-modal-spinner"},N.a.createElement(Dn,null)):void 0)}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-image-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-image-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.image.image"]},N.a.createElement("img",{src:n,alt:""})),i?this.renderAddImageModal():void 0)}}])&&On(t.prototype,e),n&&On(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();An.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var zn=An;function _n(t){return(_n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rn(t,e){return(Rn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Un(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bn(o);if(r){var n=Bn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_n(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bn(t){return(Bn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rn(t,e)}(r,f["Component"]);var t,e,n,o=Un(r);function r(t){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(s=o.call(this,t)).onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.addImage=function(t,e,n,o){var r=s.props,i=r.editorState,c=r.onChange,a={src:t,height:e,width:n};r.config.alt.present&&(a.alt=o);var l=i.getCurrentContent().createEntity("IMAGE","MUTABLE",a).getLastCreatedEntityKey();c(E.AtomicBlockUtils.insertAtomicBlock(i,l," ")),s.doCollapse()};var e=s.props.modalHandler;return s.state={expanded:!1},e.registerCallBack(s.expandCollapse),s}return t=r,(e=[{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||zn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addImage,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Pn(t.prototype,e),n&&Pn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Yn(t){var e=t.config,n=t.onChange,o=t.translations,r=e.icon,i=e.className,c=e.title;return N.a.createElement("div",{className:"rdw-remove-wrapper","aria-label":"rdw-remove-control"},N.a.createElement(R,{className:w()(i),onClick:n,title:c||o["components.controls.remove.remove"]},N.a.createElement("img",{src:r,alt:""})))}var Qn=Fn;n(31);Yn.propTypes={onChange:y.a.func,config:y.a.object,translations:y.a.object};var Hn=Yn;function Zn(t){return(Zn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Gn(t,e){return(Gn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Jn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Vn(o);if(r){var n=Vn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Zn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Vn(t){return(Vn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var qn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Gn(t,e)}(i,f["Component"]);var t,e,n,r=Jn(i);function i(){var n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))).state={expanded:!1},n.onExpandEvent=function(){n.signalExpanded=!n.state.expanded},n.expandCollapse=function(){n.setState({expanded:n.signalExpanded}),n.signalExpanded=!1},n.removeInlineStyles=function(){var t=n.props,e=t.editorState;(0,t.onChange)(n.removeAllInlineStyles(e))},n.removeAllInlineStyles=function(n){var o=n.getCurrentContent();return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","MONOSPACE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){o=E.Modifier.removeInlineStyle(o,n.getSelection(),t)}),h(Object(S.getSelectionCustomInlineStyle)(n,["FONTSIZE","FONTFAMILY","COLOR","BGCOLOR"]),function(t,e){e&&(o=E.Modifier.removeInlineStyle(o,n.getSelection(),e))}),E.EditorState.push(n,o,"change-inline-style")},n.doExpand=function(){n.setState({expanded:!0})},n.doCollapse=function(){n.setState({expanded:!1})},n}return t=i,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||Hn;return N.a.createElement(r,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.removeInlineStyles})}}])&&Wn(t.prototype,e),n&&Wn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();qn.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,config:y.a.object,translations:y.a.object,modalHandler:y.a.object};n(32);function Kn(t){return(Kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function $n(t,e){return($n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function to(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=eo(o);if(r){var n=eo(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function eo(t){return(eo=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var no=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&$n(t,e)}(i,f["Component"]);var t,e,n,r=to(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t)},e}return t=i,(e=[{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations,u=e.options,p=e.undo,d=e.redo,f=e.className,y=e.dropdownClassName,m=e.title;return N.a.createElement(H,{className:w()("rdw-history-dropdown",f),optionWrapperClassName:w()(y),expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-history-control",title:m||s["components.controls.history.history"]},N.a.createElement("img",{src:v(e),alt:""}),0<=u.indexOf("undo")&&N.a.createElement(K,{value:"undo",onClick:this.onChange,disabled:a,className:w()("rdw-history-dropdownoption",p.className),title:p.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=u.indexOf("redo")&&N.a.createElement(K,{value:"redo",onClick:this.onChange,disabled:l,className:w()("rdw-history-dropdownoption",d.className),title:d.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:d.icon,alt:""})))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.undo,r=e.redo,i=e.className,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations;return N.a.createElement("div",{className:w()("rdw-history-wrapper",i),"aria-label":"rdw-history-control"},0<=n.indexOf("undo")&&N.a.createElement(R,{value:"undo",onClick:this.onChange,className:w()(o.className),disabled:a,title:o.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("redo")&&N.a.createElement(R,{value:"redo",onClick:this.onChange,className:w()(r.className),disabled:l,title:r.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:r.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&Xn(t.prototype,e),n&&Xn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function oo(t){return(oo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ro(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function io(t,e){return(io=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function co(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ao(o);if(r){var n=ao(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===oo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ao(t){return(ao=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}no.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var lo=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&io(t,e)}(c,f["Component"]);var t,e,n,r=co(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.EditorState[t](n);r&&o(r)},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})};var e={expanded:!(i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1}),undoDisabled:!1,redoDisabled:!1},n=t.editorState,o=t.modalHandler;return n&&(e.undoDisabled=0===n.getUndoStack().size,e.redoDisabled=0===n.getRedoStack().size),i.state=e,o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&t.editorState!==e&&this.setState({undoDisabled:0===e.getUndoStack().size,redoDisabled:0===e.getRedoStack().size})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.undoDisabled,i=o.redoDisabled,c=o.expanded,a=e.component||no;return N.a.createElement(a,{config:e,translations:n,currentState:{undoDisabled:r,redoDisabled:i},expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange})}}])&&ro(t.prototype,e),n&&ro(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();lo.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var so={inline:st,blockType:Et,fontSize:zt,fontFamily:Jt,list:ce,textAlign:he,colorPicker:Ie,link:$e,embedded:yn,emoji:Ln,image:Qn,remove:qn,history:lo},uo=/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,po=/^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;function fo(t){return String(t).replace(uo,"").match(po)?t:"#"}n(33);function yo(t){return(yo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function mo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function go(t,e){return(go=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function bo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ho(o);if(r){var n=ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===yo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ho(t){return(ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Mo(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"LINK"===n.getEntity(e).getType()},e)}function jo(t){var e,a=t.showOpenOptionOnHover;return(e=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&go(t,e)}(i,f["Component"]);var t,e,n,o=bo(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={showPopOver:!1},r.openLink=function(){var t=r.props,e=t.entityKey,n=t.contentState.getEntity(e).getData().url,o=window.open(fo(n),"blank");o&&o.focus()},r.toggleShowPopOver=function(){var t=!r.state.showPopOver;r.setState({showPopOver:t})},r}return t=i,(e=[{key:"render",value:function(){var t=this.props,e=t.children,n=t.entityKey,o=t.contentState.getEntity(n).getData(),r=o.url,i=o.targetOption,c=this.state.showPopOver;return N.a.createElement("span",{className:"rdw-link-decorator-wrapper",onMouseEnter:this.toggleShowPopOver,onMouseLeave:this.toggleShowPopOver},N.a.createElement("a",{href:fo(r),target:i},e),c&&a?N.a.createElement("img",{src:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuMDcyIDBIOC45MTVhLjkyNS45MjUgMCAwIDAgMCAxLjg0OWgyLjkyNUw2Ljk2MSA2LjcyN2EuOTE4LjkxOCAwIDAgMC0uMjcuNjU0YzAgLjI0Ny4wOTUuNDguMjcuNjU0YS45MTguOTE4IDAgMCAwIC42NTQuMjcuOTE4LjkxOCAwIDAgMCAuNjUzLS4yN2w0Ljg4LTQuODh2Mi45MjZhLjkyNS45MjUgMCAwIDAgMS44NDggMFYuOTI0QS45MjUuOTI1IDAgMCAwIDE0LjA3MiAweiIvPjxwYXRoIGQ9Ik0xMC42MjMgMTMuNDExSDEuNTg1VjQuMzcyaDYuNzk4bDEuNTg0LTEuNTg0SC43OTJBLjc5Mi43OTIgMCAwIDAgMCAzLjU4djEwLjYyNGMwIC40MzcuMzU1Ljc5Mi43OTIuNzkyaDEwLjYyNGEuNzkyLjc5MiAwIDAgMCAuNzkyLS43OTJWNS4wMjlsLTEuNTg1IDEuNTg0djYuNzk4eiIvPjwvZz48L3N2Zz4=",alt:"",onClick:this.openLink,className:"rdw-link-decorator-icon"}):void 0)}}])&&mo(t.prototype,e),n&&mo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}()).propTypes={entityKey:y.a.string.isRequired,children:y.a.array,contentState:y.a.object},e}n(34);function vo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function No(t,e,n){return e&&vo(t.prototype,e),n&&vo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var Eo=No(function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getMentionComponent=function(){function t(t){var e=t.entityKey,n=t.children,o=t.contentState.getEntity(e).getData(),r=o.url,i=o.value;return N.a.createElement("a",{href:r||i,className:w()("rdw-mention-link",c)},n)}var c=n.className;return t.propTypes={entityKey:y.a.number,children:y.a.array,contentState:y.a.object},t},this.getMentionDecorator=function(){return{strategy:n.findMentionEntities,component:n.getMentionComponent()}},this.className=e});Eo.prototype.findMentionEntities=function(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"MENTION"===n.getEntity(e).getType()},e)};var So=Eo;n(35);function wo(t){return(wo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Co(t,e){return(Co=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Do(o);if(r){var n=Do(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===wo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Do(t){return(Do=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ko(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Oo(t,e,n){return e&&ko(t.prototype,e),n&&ko(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function xo(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var Io=Oo(function t(e){var p=this;xo(this,t),this.findSuggestionEntities=function(t,e){if(p.config.getEditorState()){var n=p.config,o=n.separator,r=n.trigger,i=n.getSuggestions,c=(0,n.getEditorState)().getSelection();if(c.get("anchorKey")===t.get("key")&&c.get("anchorKey")===c.get("focusKey")){var a=t.getText(),l=(a=a.substr(0,c.get("focusOffset")===a.length-1?a.length:c.get("focusOffset")+1)).lastIndexOf(o+r),s=o+r;if((void 0===l||l<0)&&a[0]===r&&(l=0,s=r),0<=l){var u=a.substr(l+s.length,a.length);i().some(function(t){return!!t.value&&(p.config.caseSensitive?0<=t.value.indexOf(u):0<=t.value.toLowerCase().indexOf(u&&u.toLowerCase()))})&&e(0===l?0:l+1,a.length)}}}},this.getSuggestionComponent=function(){var t,a=this.config;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Co(t,e)}(r,f["Component"]);var o=Lo(r);function r(){var c;xo(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={style:{left:15},activeOption:-1,showSuggestions:!0},c.onEditorKeyDown=function(t){var e=c.state.activeOption,n={};"ArrowDown"===t.key?(t.preventDefault(),e===c.filteredSuggestions.length-1?n.activeOption=0:n.activeOption=e+1):"ArrowUp"===t.key?n.activeOption=e<=0?c.filteredSuggestions.length-1:e-1:"Escape"===t.key?(n.showSuggestions=!1,g()):"Enter"===t.key&&c.addMention(),c.setState(n)},c.onOptionMouseEnter=function(t){var e=t.target.getAttribute("data-index");c.setState({activeOption:e})},c.onOptionMouseLeave=function(){c.setState({activeOption:-1})},c.setSuggestionReference=function(t){c.suggestion=t},c.setDropdownReference=function(t){c.dropdown=t},c.closeSuggestionDropdown=function(){c.setState({showSuggestions:!1})},c.filteredSuggestions=[],c.filterSuggestions=function(t){var e=t.children[0].props.text.substr(1),n=a.getSuggestions();c.filteredSuggestions=n&&n.filter(function(t){return!e||0===e.length||(a.caseSensitive?0<=t.value.indexOf(e):0<=t.value.toLowerCase().indexOf(e&&e.toLowerCase()))})},c.addMention=function(){var t=c.state.activeOption,e=a.getEditorState(),n=a.onChange,o=a.separator,r=a.trigger,i=c.filteredSuggestions[t];i&&function(t,e,n,o,r){var i=r.value,c=r.url,a=t.getCurrentContent().createEntity("MENTION","IMMUTABLE",{text:"".concat(o).concat(i),value:i,url:c}).getLastCreatedEntityKey(),l=Object(S.getSelectedBlock)(t).getText(),s=t.getSelection().focusOffset,u=(l.lastIndexOf(n+o,s)||0)+1,p=!1;l.length===u+1&&(s=l.length)," "===l[s]&&(p=!0);var d=t.getSelection().merge({anchorOffset:u,focusOffset:s}),f=E.EditorState.acceptSelection(t,d),y=E.Modifier.replaceText(f.getCurrentContent(),d,"".concat(o).concat(i),f.getCurrentInlineStyle(),a);f=E.EditorState.push(f,y,"insert-characters"),p||(d=f.getSelection().merge({anchorOffset:u+i.length+o.length,focusOffset:u+i.length+o.length}),f=E.EditorState.acceptSelection(f,d),y=E.Modifier.insertText(f.getCurrentContent(),d," ",f.getCurrentInlineStyle(),void 0)),e(E.EditorState.push(f,y,"insert-characters"))}(e,n,o,r,i)},c}return Oo(r,[{key:"componentDidMount",value:function(){var t,e,n,o=a.getWrapperRef().getBoundingClientRect(),r=this.suggestion.getBoundingClientRect(),i=this.dropdown.getBoundingClientRect();o.width<r.left-o.left+i.width?e=15:t=15,o.bottom<i.bottom&&(n=0),this.setState({style:{left:t,right:e,bottom:n}}),C.registerCallBack(this.onEditorKeyDown),m(),a.modalHandler.setSuggestionCallback(this.closeSuggestionDropdown),this.filterSuggestions(this.props)}},{key:"componentDidUpdate",value:function(t){this.props.children!==t.children&&(this.filterSuggestions(t),this.setState({showSuggestions:!0}))}},{key:"componentWillUnmount",value:function(){C.deregisterCallBack(this.onEditorKeyDown),g(),a.modalHandler.removeSuggestionCallback()}},{key:"render",value:function(){var n=this,t=this.props.children,e=this.state,o=e.activeOption,r=e.showSuggestions,i=a.dropdownClassName,c=a.optionClassName;return N.a.createElement("span",{className:"rdw-suggestion-wrapper",ref:this.setSuggestionReference,onClick:a.modalHandler.onSuggestionClick,"aria-haspopup":"true","aria-label":"rdw-suggestion-popup"},N.a.createElement("span",null,t),r&&N.a.createElement("span",{className:w()("rdw-suggestion-dropdown",i),contentEditable:"false",suppressContentEditableWarning:!0,style:this.state.style,ref:this.setDropdownReference},this.filteredSuggestions.map(function(t,e){return N.a.createElement("span",{key:e,spellCheck:!1,onClick:n.addMention,"data-index":e,onMouseEnter:n.onOptionMouseEnter,onMouseLeave:n.onOptionMouseLeave,className:w()("rdw-suggestion-option",c,{"rdw-suggestion-option-active":e===o})},t.text)})))}}]),r}()).propTypes={children:y.a.array},t}.bind(this),this.getSuggestionDecorator=function(){return{strategy:p.findSuggestionEntities,component:p.getSuggestionComponent()}};var n=e.separator,o=e.trigger,r=e.getSuggestions,i=e.onChange,c=e.getEditorState,a=e.getWrapperRef,l=e.caseSensitive,s=e.dropdownClassName,u=e.optionClassName,d=e.modalHandler;this.config={separator:n,trigger:o,getSuggestions:r,onChange:i,getEditorState:c,getWrapperRef:a,caseSensitive:l,dropdownClassName:s,optionClassName:u,modalHandler:d}}),To=function(t){return[new So(t.mentionClassName).getMentionDecorator(),new Io(t).getSuggestionDecorator()]};n(36);function Ao(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function zo(t,e,n){return e&&Ao(t.prototype,e),n&&Ao(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function _o(t){var e=t.block,n=t.contentState.getEntity(e.getEntityAt(0)).getData(),o=n.src,r=n.height,i=n.width;return N.a.createElement("iframe",{height:r,width:i,src:o,frameBorder:"0",allowFullScreen:!0,title:"Wysiwyg Embedded Content"})}var Po=zo(function t(e){var a=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getHashtagComponent=function(){function t(t){var e=t.children,n=e[0].props.text;return N.a.createElement("a",{href:n,className:w()("rdw-hashtag-link",o)},e)}var o=a.className;return t.propTypes={children:y.a.object},t},this.findHashtagEntities=function(t,e){for(var n=t.getText(),o=0,r=0;0<n.length&&0<=o;)if(n[0]===a.hashCharacter?(r=o=0,n=n.substr(a.hashCharacter.length)):0<=(o=n.indexOf(a.separator+a.hashCharacter))&&(n=n.substr(o+(a.separator+a.hashCharacter).length),r+=o+a.separator.length),0<=o){var i=0<=n.indexOf(a.separator)?n.indexOf(a.separator):n.length,c=n.substr(0,i);c&&0<c.length&&(e(r,r+c.length+a.hashCharacter.length),r+=a.hashCharacter.length)}},this.getHashtagDecorator=function(){return{strategy:a.findHashtagEntities,component:a.getHashtagComponent()}},this.className=e.className,this.hashCharacter=e.hashCharacter||"#",this.separator=e.separator||" "}),Ro=function(t){return new Po(t).getHashtagDecorator()};_o.propTypes={block:y.a.object,contentState:y.a.object};var Uo=_o;n(37);function Bo(t){return(Bo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Fo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Yo(t,e){return(Yo=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Qo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ho(o);if(r){var n=Ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Bo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ho(t){return(Ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Zo=function(d){var t;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Yo(t,e)}(r,f["Component"]);var t,e,n,o=Qo(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={hovered:!1},i.setEntityAlignmentLeft=function(){i.setEntityAlignment("left")},i.setEntityAlignmentRight=function(){i.setEntityAlignment("right")},i.setEntityAlignmentCenter=function(){i.setEntityAlignment("none")},i.setEntityAlignment=function(t){var e=i.props,n=e.block,o=e.contentState,r=n.getEntityAt(0);o.mergeEntityData(r,{alignment:t}),d.onChange(E.EditorState.push(d.getEditorState(),o,"change-block-data")),i.setState({dummy:!0})},i.toggleHovered=function(){var t=!i.state.hovered;i.setState({hovered:t})},i}return t=r,(e=[{key:"renderAlignmentOptions",value:function(t){return N.a.createElement("div",{className:w()("rdw-image-alignment-options-popup",{"rdw-image-alignment-options-popup-right":"right"===t})},N.a.createElement(R,{onClick:this.setEntityAlignmentLeft,className:"rdw-image-alignment-option"},"L"),N.a.createElement(R,{onClick:this.setEntityAlignmentCenter,className:"rdw-image-alignment-option"},"C"),N.a.createElement(R,{onClick:this.setEntityAlignmentRight,className:"rdw-image-alignment-option"},"R"))}},{key:"render",value:function(){var t=this.props,e=t.block,n=t.contentState,o=this.state.hovered,r=d.isReadOnly,i=d.isImageAlignmentEnabled,c=n.getEntity(e.getEntityAt(0)).getData(),a=c.src,l=c.alignment,s=c.height,u=c.width,p=c.alt;return N.a.createElement("span",{onMouseEnter:this.toggleHovered,onMouseLeave:this.toggleHovered,className:w()("rdw-image-alignment",{"rdw-image-left":"left"===l,"rdw-image-right":"right"===l,"rdw-image-center":!l||"none"===l})},N.a.createElement("span",{className:"rdw-image-imagewrapper"},N.a.createElement("img",{src:a,alt:p,style:{height:s,width:u}}),!r()&&o&&i()?this.renderAlignmentOptions(l):void 0))}}])&&Fo(t.prototype,e),n&&Fo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}()).propTypes={block:y.a.object,contentState:y.a.object},t},Wo=function(o,r){return function(t){if("function"==typeof r){var e=r(t,o,o.getEditorState);if(e)return e}if("atomic"===t.getType()){var n=o.getEditorState().getCurrentContent().getEntity(t.getEntityAt(0));if(n&&"IMAGE"===n.type)return{component:Zo(o),editable:!1};if(n&&"EMBEDDED_LINK"===n.type)return{component:Uo,editable:!1}}}},Go={options:["inline","blockType","fontSize","fontFamily","list","textAlign","colorPicker","link","embedded","emoji","image","remove","history"],inline:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["bold","italic","underline","strikethrough","monospace","superscript","subscript"],bold:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMjM2IDBjMS42NTIgMCAyLjk0LjI5OCAzLjg2Ni44OTMuOTI1LjU5NSAxLjM4OCAxLjQ4NSAxLjM4OCAyLjY2OSAwIC42MDEtLjE3MyAxLjEzOS0uNTE2IDEuNjEtLjM0My40NzQtLjg0NC44My0xLjQ5OSAxLjA2OC44NDMuMTY3IDEuNDc0LjUyMyAxLjg5NSAxLjA3MS40MTkuNTUuNjMgMS4xODMuNjMgMS45MDMgMCAxLjI0NS0uNDQ0IDIuMTg3LTEuMzMgMi44MjUtLjg4Ni42NDEtMi4xNDQuOTYxLTMuNzY5Ljk2MUgwdi0yLjE2N2gxLjQ5NFYyLjE2N0gwVjBoNi4yMzZ6TTQuMzA4IDUuNDQ2aDIuMDI0Yy43NTIgMCAxLjMzLS4xNDMgMS43MzQtLjQzLjQwNS0uMjg1LjYwOC0uNzAxLjYwOC0xLjI1IDAtLjYtLjIwNC0xLjA0NC0uNjEyLTEuMzMtLjQwOC0uMjg2LTEuMDE2LS40MjctMS44MjYtLjQyN0g0LjMwOHYzLjQzN3ptMCAxLjgwNFYxMWgyLjU5M2MuNzQ3IDAgMS4zMTQtLjE1MiAxLjcwNy0uNDUyLjM5LS4zLjU4OC0uNzQ1LjU4OC0xLjMzNCAwLS42MzYtLjE2OC0xLjEyNC0uNS0xLjQ2LS4zMzYtLjMzNS0uODY0LS41MDQtMS41ODItLjUwNEg0LjMwOHoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},italic:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTcgM1YyaDR2MUg5Ljc1M2wtMyAxMEg4djFINHYtMWgxLjI0N2wzLTEwSDd6Ii8+PC9zdmc+",className:void 0,title:void 0},underline:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTYuMDQ1IDJ2Ljk5Mkw0Ljc4NSAzdjUuMTcyYzAgLjg1OS4yNDMgMS41MTIuNzI3IDEuOTU3czEuMTI0LjY2OCAxLjkxOC42NjhjLjgzNiAwIDEuNTA5LS4yMjEgMi4wMTktLjY2NC41MTEtLjQ0Mi43NjYtMS4wOTYuNzY2LTEuOTYxVjNsLTEuMjYtLjAwOFYySDEzdi45OTJMMTEuNzM5IDN2NS4xNzJjMCAxLjIzNC0uMzk4IDIuMTgxLTEuMTk1IDIuODQtLjc5Ny42NTktMS44MzUuOTg4LTMuMTE0Ljk4OC0xLjI0MiAwLTIuMjQ4LS4zMjktMy4wMTctLjk4OC0uNzY5LS42NTktMS4xNTItMS42MDUtMS4xNTItMi44NFYzTDIgMi45OTJWMmg0LjA0NXpNMiAxM2gxMXYxSDJ6Ii8+PC9zdmc+",className:void 0,title:void 0},strikethrough:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4wNCA1Ljk1NGg2LjIxNWE3LjQxMiA3LjQxMiAwIDAgMC0uNzk1LS40MzggMTEuOTA3IDExLjkwNyAwIDAgMC0xLjQ0Ny0uNTU3Yy0xLjE4OC0uMzQ4LTEuOTY2LS43MTEtMi4zMzQtMS4wODgtLjM2OC0uMzc3LS41NTItLjc3LS41NTItMS4xODEgMC0uNDk1LjE4Ny0uOTA2LjU2LTEuMjMyLjM4LS4zMzEuODg3LS40OTcgMS41MjMtLjQ5Ny42OCAwIDEuMjY2LjI1NSAxLjc1Ny43NjcuMjk1LjMxNS41ODIuODkxLjg2MSAxLjczbC4xMTcuMDE2LjcwMy4wNS4xLS4wMjRjLjAyOC0uMTUyLjA0Mi0uMjc5LjA0Mi0uMzggMC0uMzM3LS4wMzktLjg1Mi0uMTE3LTEuNTQ0YTkuMzc0IDkuMzc0IDAgMCAwLS4xNzYtLjk5NUM5Ljg4LjM3OSA5LjM4NS4yNDQgOS4wMTcuMTc2IDguMzY1LjA3IDcuODk5LjAxNiA3LjYyLjAxNmMtMS40NSAwLTIuNTQ1LjM1Ny0zLjI4NyAxLjA3MS0uNzQ3LjcyLTEuMTIgMS41ODktMS4xMiAyLjYwNyAwIC41MTEuMTMzIDEuMDQuNCAxLjU4Ni4xMjkuMjUzLjI3LjQ3OC40MjcuNjc0ek04LjI4IDguMTE0Yy41NzUuMjM2Ljk1Ny40MzYgMS4xNDcuNTk5LjQ1MS40MS42NzcuODUyLjY3NyAxLjMyNCAwIC4zODMtLjEzLjc0NS0uMzkzIDEuMDg4LS4yNS4zMzgtLjU5LjU4LTEuMDIuNzI2YTMuNDE2IDMuNDE2IDAgMCAxLTEuMTYzLjIyOGMtLjQwNyAwLS43NzUtLjA2Mi0xLjEwNC0uMTg2YTIuNjk2IDIuNjk2IDAgMCAxLS44NzgtLjQ4IDMuMTMzIDMuMTMzIDAgMCAxLS42Ny0uNzk0IDEuNTI3IDEuNTI3IDAgMCAxLS4xMDQtLjIyNyA1Ny41MjMgNTcuNTIzIDAgMCAwLS4xODgtLjQ3MyAyMS4zNzEgMjEuMzcxIDAgMCAwLS4yNTEtLjU5OWwtLjg1My4wMTd2LjM3MWwtLjAxNy4zMTNhOS45MiA5LjkyIDAgMCAwIDAgLjU3M2MuMDExLjI3LjAxNy43MDkuMDE3IDEuMzE2di4xMWMwIC4wNzkuMDIyLjE0LjA2Ny4xODUuMDgzLjA2OC4yODQuMTQ3LjYwMi4yMzdsMS4xNy4zMzdjLjQ1Mi4xMy45OTYuMTk0IDEuNjMyLjE5NC42ODYgMCAxLjI1Mi0uMDU5IDEuNjk4LS4xNzdhNC42OTQgNC42OTQgMCAwIDAgMS4yOC0uNTU3Yy40MDEtLjI1OS43MDUtLjQ4Ni45MTEtLjY4My4yNjgtLjI3Ni40NjYtLjU2OC41OTQtLjg3OGE0Ljc0IDQuNzQgMCAwIDAgLjM0My0xLjc4OGMwLS4yOTgtLjAyLS41NTctLjA1OC0uNzc2SDguMjgxek0xNC45MTQgNi41N2EuMjYuMjYgMCAwIDAtLjE5My0uMDc2SC4yNjhhLjI2LjI2IDAgMCAwLS4xOTMuMDc2LjI2NC4yNjQgMCAwIDAtLjA3NS4xOTR2LjU0YzAgLjA3OS4wMjUuMTQzLjA3NS4xOTRhLjI2LjI2IDAgMCAwIC4xOTMuMDc2SDE0LjcyYS4yNi4yNiAwIDAgMCAuMTkzLS4wNzYuMjY0LjI2NCAwIDAgMCAuMDc1LS4xOTR2LS41NGEuMjY0LjI2NCAwIDAgMC0uMDc1LS4xOTR6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},monospace:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ0NCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS4wMjEgMi45MDZjLjE4NiAxLjIxOS4zNzIgMS41LjM3MiAyLjcxOUMxLjM5MyA2LjM3NSAwIDcuMDMxIDAgNy4wMzF2LjkzOHMxLjM5My42NTYgMS4zOTMgMS40MDZjMCAxLjIxOS0uMTg2IDEuNS0uMzcyIDIuNzE5Qy43NDMgMTQuMDYzIDEuNzY0IDE1IDIuNjkzIDE1aDEuOTV2LTEuODc1cy0xLjY3Mi4xODgtMS42NzItLjkzOGMwLS44NDMuMTg2LS44NDMuMzcyLTIuNzE4LjA5My0uODQ0LS40NjQtMS41LTEuMDIyLTEuOTY5LjU1OC0uNDY5IDEuMTE1LTEuMDMxIDEuMDIyLTEuODc1QzMuMDY0IDMuNzUgMi45NyAzLjc1IDIuOTcgMi45MDZjMC0xLjEyNSAxLjY3Mi0xLjAzMSAxLjY3Mi0xLjAzMVYwaC0xLjk1QzEuNjcgMCAuNzQzLjkzOCAxLjAyIDIuOTA2ek0xMS45NzkgMi45MDZjLS4xODYgMS4yMTktLjM3MiAxLjUtLjM3MiAyLjcxOSAwIC43NSAxLjM5MyAxLjQwNiAxLjM5MyAxLjQwNnYuOTM4cy0xLjM5My42NTYtMS4zOTMgMS40MDZjMCAxLjIxOS4xODYgMS41LjM3MiAyLjcxOS4yNzggMS45NjktLjc0MyAyLjkwNi0xLjY3MiAyLjkwNmgtMS45NXYtMS44NzVzMS42NzIuMTg4IDEuNjcyLS45MzhjMC0uODQzLS4xODYtLjg0My0uMzcyLTIuNzE4LS4wOTMtLjg0NC40NjQtMS41IDEuMDIyLTEuOTY5LS41NTgtLjQ2OS0xLjExNS0xLjAzMS0xLjAyMi0xLjg3NS4xODYtMS44NzUuMzcyLTEuODc1LjM3Mi0yLjcxOSAwLTEuMTI1LTEuNjcyLTEuMDMxLTEuNjcyLTEuMDMxVjBoMS45NWMxLjAyMiAwIDEuOTUuOTM4IDEuNjcyIDIuOTA2eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},superscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzA1IDEwLjE2NUwxMS44NjUgMTVIOS4wNTdsLTMuMTkyLTMuNTM2TDIuNzQ2IDE1SDBsNC41MjMtNC44MzVMLjIxOCA1LjYwM2gyLjc3TDUuOTg2IDguOTEgOS4wMSA1LjYwM2gyLjY0OWwtNC4zNTQgNC41NjJ6bTYuMjM0LTMuMjY5bDEuODc5LTEuMzA2Yy42NC0uNDE2IDEuMDYyLS44MDEgMS4yNjQtMS4xNTcuMjAxLS4zNTYuMzAyLS43MzguMzAyLTEuMTQ4IDAtLjY2OS0uMjM3LTEuMjEtLjcxLTEuNjItLjQ3NC0uNDExLTEuMDk3LS42MTctMS44NjgtLjYxNy0uNzQ0IDAtMS4zNC4yMDgtMS43ODUuNjI0LS40NDcuNDE2LS42NyAxLjA0My0uNjcgMS44ODFoMS40MzZjMC0uNS4wOTQtLjg0Ni4yODEtMS4wMzguMTg4LS4xOTEuNDQ1LS4yODcuNzcyLS4yODdzLjU4NS4wOTcuNzc3LjI5MmMuMTkuMTk1LjI4Ni40MzcuMjg2LjcyNiAwIC4yOS0uMDg5LjU1LS4yNjYuNzg1cy0uNjcuNjI4LTEuNDc5IDEuMTg0Yy0uNjkxLjQ3Ny0xLjYyNy45MjctMS45MDggMS4zNWwuMDE0IDEuNTY5SDE3VjYuODk2aC0zLjQ2MXoiLz48L3N2Zz4=",className:void 0,title:void 0},subscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjg2NiAxMS42NDZIOS4wNkw1Ljg2NyA3Ljk0MmwtMy4xMjEgMy43MDRIMGw0LjUyNC01LjA2NEwuMjE4IDEuODA0aDIuNzdsMyAzLjQ2NCAzLjAyMy0zLjQ2NGgyLjY1TDcuMzA2IDYuNTgybDQuNTYgNS4wNjR6bTEuNzI1IDIuMDU4bDEuODI3LTEuMzY4Yy42NC0uNDM1IDEuMDYyLS44NCAxLjI2NC0xLjIxMi4yMDItLjM3Mi4zMDItLjc3My4zMDItMS4yMDIgMC0uNy0uMjM3LTEuMjY2LS43MS0xLjY5Ni0uNDc0LS40MzEtMS4wOTctLjY0Ni0xLjg2OS0uNjQ2LS43NDQgMC0xLjM0LjIxOC0xLjc4NS42NTMtLjQ0Ni40MzYtLjY3IDEuMDkyLS42NyAxLjk3aDEuNDM2YzAtLjUyNC4wOTQtLjg4Ni4yODEtMS4wODcuMTg4LS4yLjQ0NS0uMzAxLjc3Mi0uMzAxcy41ODYuMTAyLjc3Ny4zMDZjLjE5LjIwNC4yODYuNDU4LjI4Ni43NiAwIC4zMDMtLjA4OC41NzctLjI2Ni44MjItLjE3Ny4yNDUtLjY3LjY1OC0xLjQ3OCAxLjI0LS42OTIuNS0xLjYyOC45NzEtMS45MSAxLjQxM0wxMS44NjQgMTVIMTd2LTEuMjk2aC0zLjQxeiIvPjwvc3ZnPg==",className:void 0,title:void 0}},blockType:{inDropdown:!0,options:["Normal","H1","H2","H3","H4","H5","H6","Blockquote","Code"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontSize:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4=",options:[8,9,10,11,12,14,16,18,24,30,36,48,60,72,96],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontFamily:{options:["Arial","Georgia","Impact","Tahoma","Times New Roman","Verdana"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},list:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["unordered","ordered","indent","outdent"],unordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS43MiAzLjQyN2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3LjAxIDEuNzIuMDFDLjc3LjAwOCAwIC43NzUgMCAxLjcxNWMwIC45NC43NzQgMS43MTEgMS43MiAxLjcxMXptMC0yLjYyNWMuNTEgMCAuOTIyLjQxMi45MjIuOTE0YS45Mi45MiAwIDAgMS0xLjg0MiAwIC45Mi45MiAwIDAgMSAuOTItLjkxNHpNMS43MiA4LjcwM2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3IDUuMjg3IDEuNzIgNS4yODdDLjc3IDUuMjg3IDAgNi4wNTIgMCA2Ljk5NXMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjJjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAwIDEtMS44NDIgMGMwLS41MDUuNDE1LS45MTQuOTItLjkxNHpNMS43MiAxMy45ODJjLjk1MSAwIDEuNzIyLS43NjggMS43MjItMS43MDggMC0uOTQzLS43NzQtMS43MDgtMS43MjEtMS43MDgtLjk0NyAwLTEuNzIxLjc2OC0xLjcyMSAxLjcwOHMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjVjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAxIDEtMS44NDIgMCAuOTIuOTIgMCAwIDEgLjkyLS45MTR6TTUuNzQ0IDIuMTE1aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OS40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDcuMzk0aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOThINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OC40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDEyLjY3aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjQuNC40IDAgMCAwIC40MDIuMzk4eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},ordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4yMDIgMS40NjZoOC4xNWMuMzM4IDAgLjYxMi0uMzIyLjYxMi0uNzIgMC0uMzk3LS4yNzQtLjcyLS42MTItLjcyaC04LjE1Yy0uMzM4IDAtLjYxMS4zMjMtLjYxMS43MiAwIC4zOTguMjczLjcyLjYxLjcyek0xMi4zNTIgNS43ODNoLTguMTVjLS4zMzggMC0uNjExLjMyMi0uNjExLjcyIDAgLjM5Ny4yNzMuNzIuNjEuNzJoOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5OC0uMjc0LS43Mi0uNjEyLS43MnpNMTIuMzUyIDExLjU0aC04LjE1Yy0uMzM4IDAtLjYxMS4zMjItLjYxMS43MiAwIC4zOTYuMjczLjcxOS42MS43MTloOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5Ny0uMjc0LS43Mi0uNjEyLS43MnpNLjc2NyAxLjI0OXYxLjgwMmMwIC4xOTUuMTM2LjM0My4zMTUuMzQzLjE3NiAwIC4zMTUtLjE1LjMxNS0uMzQzVi4zNTZjMC0uMTktLjEzMy0uMzM5LS4zMDItLjMzOS0uMTQ4IDAtLjIyMy4xMTgtLjI0Ny4xNTZhLjIyOC4yMjggMCAwIDAtLjAwMy4wMDVMLjU3OS42MjFhLjQ3NC40NzQgMCAwIDAtLjA5OC4yNzNjMCAuMTk0LjEyOC4zNTEuMjg2LjM1NXpNLjM1MiA4LjE5SDEuNTVjLjE1NyAwIC4yODUtLjE2Mi4yODUtLjM2MiAwLS4xOTgtLjEyOC0uMzU5LS4yODUtLjM1OUguNjh2LS4wMDZjMC0uMTA3LjIxLS4yODEuMzc4LS40MjIuMzM2LS4yNzguNzUzLS42MjUuNzUzLTEuMjI2IDAtLjU3LS4zNzYtMS0uODc0LTEtLjQ3NyAwLS44MzYuMzg1LS44MzYuODk3IDAgLjI5Ny4xNjQuNDAyLjMwNS40MDIuMiAwIC4zMjEtLjE3Ni4zMjEtLjM0NiAwLS4xMDYuMDIzLS4yMjguMjA0LS4yMjguMjQzIDAgLjI1LjI1NC4yNS4yODMgMCAuMjI4LS4yNTIuNDQyLS40OTUuNjQ5LS4zMDEuMjU1LS42NDIuNTQ0LS42NDIuOTkydi4zODRjMCAuMjA1LjE1OS4zNDMuMzA4LjM0M3pNMS43NyAxMC41NDNjMC0uNTkyLS4yOTYtLjkzMS0uODE0LS45MzEtLjY4IDAtLjg1OS41Ny0uODU5Ljg3MiAwIC4zNTEuMjIyLjM5LjMxOC4zOS4xODUgMCAuMzEtLjE0OC4zMS0uMzY2IDAtLjA4NC4wMjYtLjE4MS4yMjQtLjE4MS4xNDIgMCAuMi4wMjQuMi4yNjcgMCAuMjM3LS4wNDMuMjYzLS4yMTMuMjYzLS4xNjQgMC0uMjg4LjE1Mi0uMjg4LjM1NCAwIC4yLjEyNS4zNS4yOTEuMzUuMjI1IDAgLjI3LjEwOC4yNy4yODN2LjA3NWMwIC4yOTQtLjA5Ny4zNS0uMjc3LjM1LS4yNDggMC0uMjY3LS4xNS0uMjY3LS4xOTcgMC0uMTc0LS4wOTgtLjM1LS4zMTctLjM1LS4xOTIgMC0uMzA3LjE0MS0uMzA3LjM3OCAwIC40My4zMTMuODg4Ljg5NS44ODguNTY0IDAgLjkwMS0uNC45MDEtMS4wN3YtLjA3NGMwLS4yNzQtLjA3NC0uNTAyLS4yMTQtLjY2Ni4wOTYtLjE2My4xNDgtLjM4LjE0OC0uNjM1eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},indent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS43MTYgMy4yMTFIMTd2MS4xOTdINS43MTZ6TTAgLjAyaDE3djEuMTk3SDB6TTAgMTIuNzgzaDE3djEuMTk3SDB6TTUuNzE2IDkuNTkzSDE3djEuMTk3SDUuNzE2ek01LjcxNiA2LjQwMkgxN3YxLjE5N0g1LjcxNnpNLjE4NyA5LjQ5MUwyLjUyIDcgLjE4NyA0LjUwOXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},outdent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS4zOTYgMy4xOTNoMTAuNTczVjQuMzlINS4zOTZ6TS4wMzkuMDAzaDE1LjkzVjEuMkguMDM5ek0uMDM5IDEyLjc2NmgxNS45M3YxLjE5N0guMDM5ek01LjM5NiA5LjU3NWgxMC41NzN2MS4xOTdINS4zOTZ6TTUuMzk2IDYuMzg0aDEwLjU3M3YxLjE5N0g1LjM5NnpNMi4xODcgNC40OTFMMCA2Ljk4M2wyLjE4NyAyLjQ5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},title:void 0},textAlign:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["left","center","right","justify"],left:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOC40OTMgMTQuODg3SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4IDEwLjE2MkguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1M2gxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUzek04LjQ5MyA1LjQzNUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOC43MDlILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTJoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},center:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuNTU2IDE0Ljg4N0gzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTggMTAuMTYySC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUzaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6TTExLjU1NiA1LjQzNUgzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTguNzA5SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTJ6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},right:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjE4IDE0Ljg4N0g2LjQ1YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOCAxMC4xNjJILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTNoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1M3pNMTQuNjE4IDUuNDM1SDYuNDVhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4LjcwOUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1MmgxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyeiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},justify:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjIgMTQuODg4SC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgMTAuMTYySC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgNS40MzZILjMyNWEuMzI2LjMyNiAwIDAgMSAwLS42NTJIMTQuNjJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42Mi43MUguMzI1YS4zMjYuMzI2IDAgMCAxIDAtLjY1M0gxNC42MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},title:void 0},colorPicker:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+",className:void 0,component:void 0,popupClassName:void 0,colors:["rgb(97,189,109)","rgb(26,188,156)","rgb(84,172,210)","rgb(44,130,201)","rgb(147,101,184)","rgb(71,85,119)","rgb(204,204,204)","rgb(65,168,95)","rgb(0,168,133)","rgb(61,142,185)","rgb(41,105,176)","rgb(85,57,130)","rgb(40,50,78)","rgb(0,0,0)","rgb(247,218,100)","rgb(251,160,38)","rgb(235,107,86)","rgb(226,80,65)","rgb(163,143,132)","rgb(239,239,239)","rgb(255,255,255)","rgb(250,197,28)","rgb(243,121,52)","rgb(209,72,65)","rgb(184,49,47)","rgb(124,112,107)","rgb(209,213,216)"],title:void 0},link:{inDropdown:!1,className:void 0,component:void 0,popupClassName:void 0,dropdownClassName:void 0,showOpenOptionOnHover:!0,defaultTargetOption:"_self",options:["link","unlink"],link:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjk2Ny45NUEzLjIyNiAzLjIyNiAwIDAgMCAxMS42Ny4wMDJjLS44NyAwLTEuNjg2LjMzNy0yLjI5Ny45NDhMNy4xMDUgMy4yMThBMy4yNDcgMy4yNDcgMCAwIDAgNi4yNCA2LjI0YTMuMjI1IDMuMjI1IDAgMCAwLTMuMDIyLjg2NUwuOTUgOS4zNzNhMy4yNTMgMy4yNTMgMCAwIDAgMCA0LjU5NCAzLjIyNiAzLjIyNiAwIDAgMCAyLjI5Ny45NDhjLjg3IDAgMS42ODYtLjMzNiAyLjI5OC0uOTQ4TDcuODEyIDExLjdhMy4yNDcgMy4yNDcgMCAwIDAgLjg2NS0zLjAyMyAzLjIyNSAzLjIyNSAwIDAgMCAzLjAyMi0uODY1bDIuMjY4LTIuMjY3YTMuMjUyIDMuMjUyIDAgMCAwIDAtNC41OTV6TTcuMTA1IDEwLjk5M0w0LjgzNyAxMy4yNmEyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NSAyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LS42NTUgMi4yNTIgMi4yNTIgMCAwIDEgMC0zLjE4bDIuMjY4LTIuMjY4YTIuMjMyIDIuMjMyIDAgMCAxIDEuNTktLjY1NWMuNDMgMCAuODQxLjEyIDEuMTk1LjM0M0w0Ljc3MiA5LjQzOGEuNS41IDAgMSAwIC43MDcuNzA3bDEuOTM5LTEuOTM4Yy41NDUuODY4LjQ0MiAyLjAzLS4zMTMgMi43ODV6bTYuMTU1LTYuMTU1bC0yLjI2OCAyLjI2N2EyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NWMtLjQzMSAwLS44NDEtLjEyLTEuMTk1LS4zNDNsMS45MzgtMS45MzhhLjUuNSAwIDEgMC0uNzA3LS43MDdMNy40OTkgNi43MWEyLjI1MiAyLjI1MiAwIDAgMSAuMzEzLTIuNzg1bDIuMjY3LTIuMjY4YTIuMjMzIDIuMjMzIDAgMCAxIDEuNTktLjY1NSAyLjIzMyAyLjIzMyAwIDAgMSAyLjI0NiAyLjI0NWMwIC42MDMtLjIzMiAxLjE2OC0uNjU1IDEuNTl6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=",className:void 0,title:void 0},unlink:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTMuOTU2IDEuMDM3YTMuNTUgMy41NSAwIDAgMC01LjAxNCAwTDYuNDM2IDMuNTQ0YS41NDUuNTQ1IDAgMSAwIC43Ny43N2wyLjUwOC0yLjUwNmEyLjQzOCAyLjQzOCAwIDAgMSAxLjczNS0uNzE1Yy42NTggMCAxLjI3NS4yNTQgMS43MzYuNzE1LjQ2LjQ2MS43MTUgMS4wNzguNzE1IDEuNzM2IDAgLjY1OC0uMjU0IDEuMjc0LS43MTUgMS43MzVMOS45MDcgOC41NThhMi40NTggMi40NTggMCAwIDEtMy40NzIgMCAuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3MSAzLjUzNCAzLjUzNCAwIDAgMCAyLjUwNyAxLjAzN2MuOTA4IDAgMS44MTYtLjM0NiAyLjUwNy0xLjAzN2wzLjI3OC0zLjI3OGEzLjUyIDMuNTIgMCAwIDAgMS4wMzUtMi41MDdjMC0uOTUtLjM2Ny0xLjg0LTEuMDM1LTIuNTA3eiIvPjxwYXRoIGQ9Ik03LjQgMTEuMDY1bC0yLjEyMiAyLjEyYTIuNDM3IDIuNDM3IDAgMCAxLTEuNzM1LjcxNiAyLjQzNyAyLjQzNyAwIDAgMS0xLjczNi0uNzE1IDIuNDU3IDIuNDU3IDAgMCAxIDAtMy40NzFsMy4wODYtMy4wODZhMi40MzggMi40MzggMCAwIDEgMS43MzUtLjcxNWMuNjU4IDAgMS4yNzUuMjU0IDEuNzM2LjcxNWEuNTQ1LjU0NSAwIDEgMCAuNzcxLS43NzEgMy41NSAzLjU1IDAgMCAwLTUuMDE0IDBMMS4wMzYgOC45NDRBMy41MiAzLjUyIDAgMCAwIDAgMTEuNDVjMCAuOTUuMzY3IDEuODQgMS4wMzUgMi41MDdhMy41MiAzLjUyIDAgMCAwIDIuNTA2IDEuMDM1Yy45NSAwIDEuODQtLjM2OCAyLjUwNy0xLjAzNWwyLjEyMi0yLjEyMWEuNTQ1LjU0NSAwIDAgMC0uNzcxLS43NzF6TTkuMjc0IDEyLjAwMmEuNTQ2LjU0NiAwIDAgMC0uNTQ2LjU0NXYxLjYzN2EuNTQ2LjU0NiAwIDAgMCAxLjA5MSAwdi0xLjYzN2EuNTQ1LjU0NSAwIDAgMC0uNTQ1LS41NDV6TTExLjIzIDExLjYxNmEuNTQ1LjU0NSAwIDEgMC0uNzcyLjc3MmwxLjE1NyAxLjE1NmEuNTQzLjU0MyAwIDAgMCAuNzcxIDAgLjU0NS41NDUgMCAwIDAgMC0uNzdsLTEuMTU2LTEuMTU4ek0xMi41MzcgOS44MkgxMC45YS41NDYuNTQ2IDAgMCAwIDAgMS4wOTFoMS42MzdhLjU0Ni41NDYgMCAwIDAgMC0xLjA5ek00LjkxIDMuNTQ3YS41NDYuNTQ2IDAgMCAwIC41NDUtLjU0NVYxLjM2NmEuNTQ2LjU0NiAwIDAgMC0xLjA5IDB2MS42MzZjMCAuMzAxLjI0NC41NDUuNTQ1LjU0NXpNMi44ODggMy45MzNhLjU0My41NDMgMCAwIDAgLjc3MSAwIC41NDUuNTQ1IDAgMCAwIDAtLjc3MUwyLjUwMiAyLjAwNWEuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3bDEuMTU3IDEuMTU4ek0xLjYyOCA1LjczaDEuNjM2YS41NDYuNTQ2IDAgMCAwIDAtMS4wOTJIMS42MjhhLjU0Ni41NDYgMCAwIDAgMCAxLjA5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},linkCallback:void 0},emoji:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,emojis:["😀","😁","😂","😃","😉","😋","😎","😍","😗","🤗","🤔","😣","😫","😴","😌","🤓","😛","😜","😠","😇","😷","😈","👻","😺","😸","😹","😻","😼","😽","🙀","🙈","🙉","🙊","👼","👮","🕵","💂","👳","🎅","👸","👰","👲","🙍","🙇","🚶","🏃","💃","⛷","🏂","🏌","🏄","🚣","🏊","⛹","🏋","🚴","👫","💪","👈","👉","👆","🖕","👇","🖖","🤘","🖐","👌","👍","👎","✊","👊","👏","🙌","🙏","🐵","🐶","🐇","🐥","🐸","🐌","🐛","🐜","🐝","🍉","🍄","🍔","🍤","🍨","🍪","🎂","🍰","🍾","🍷","🍸","🍺","🌍","🚑","⏰","🌙","🌝","🌞","⭐","🌟","🌠","🌨","🌩","⛄","🔥","🎄","🎈","🎉","🎊","🎁","🎗","🏀","🏈","🎲","🔇","🔈","📣","🔔","🎵","🎷","💰","🖊","📅","✅","❎","💯"],title:void 0},embedded:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNzA4IDYuNjE1YS40MzYuNDM2IDAgMCAwLS41NDMuMjkxbC0xLjgzIDYuMDQ1YS40MzYuNDM2IDAgMCAwIC44MzMuMjUyTDcgNy4xNmEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHpNOC45MzEgNi42MTVhLjQzNi40MzYgMCAwIDAtLjU0My4yOTFsLTEuODMgNi4wNDVhLjQzNi40MzYgMCAwIDAgLjgzNC4yNTJsMS44My02LjA0NGEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHoiLz48cGF0aCBkPSJNMTYuNTY0IDBILjQzNkEuNDM2LjQzNiAwIDAgMCAwIC40MzZ2MTYuMTI4YzAgLjI0LjE5NS40MzYuNDM2LjQzNmgxNi4xMjhjLjI0IDAgLjQzNi0uMTk1LjQzNi0uNDM2Vi40MzZBLjQzNi40MzYgMCAwIDAgMTYuNTY0IDB6TTMuNDg3Ljg3MmgxMC4wMjZ2MS43NDNIMy40ODdWLjg3MnptLTIuNjE1IDBoMS43NDN2MS43NDNILjg3MlYuODcyem0xNS4yNTYgMTUuMjU2SC44NzJWMy40ODhoMTUuMjU2djEyLjY0em0wLTEzLjUxM2gtMS43NDNWLjg3MmgxLjc0M3YxLjc0M3oiLz48Y2lyY2xlIGN4PSI5My44NjciIGN5PSIyNDUuMDY0IiByPSIxMy4xMjgiIHRyYW5zZm9ybT0ibWF0cml4KC4wMzMyIDAgMCAuMDMzMiAwIDApIi8+PGNpcmNsZSBjeD0iOTMuODY3IiBjeT0iMzYwLjU5MiIgcj0iMTMuMTI4IiB0cmFuc2Zvcm09Im1hdHJpeCguMDMzMiAwIDAgLjAzMzIgMCAwKSIvPjxwYXRoIGQ9Ik0xNC4yNTQgMTIuNjQxSDEwLjJhLjQzNi40MzYgMCAwIDAgMCAuODcyaDQuMDU0YS40MzYuNDM2IDAgMCAwIDAtLjg3MnoiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,embedCallback:void 0,defaultSize:{height:"auto",width:"auto"},title:void 0},image:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,urlEnabled:!0,uploadEnabled:!0,previewImage:!1,alignmentEnabled:!0,uploadCallback:void 0,inputAccept:"image/gif,image/jpeg,image/jpg,image/png,image/svg",alt:{present:!1,mandatory:!1},defaultSize:{height:"auto",width:"auto"},title:void 0},remove:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOC4xIDE0bDYuNC03LjJjLjYtLjcuNi0xLjgtLjEtMi41bC0yLjctMi43Yy0uMy0uNC0uOC0uNi0xLjMtLjZIOC42Yy0uNSAwLTEgLjItMS40LjZMLjUgOS4yYy0uNi43LS42IDEuOS4xIDIuNWwyLjcgMi43Yy4zLjQuOC42IDEuMy42SDE2di0xSDguMXptLTEuMy0uMXMwLS4xIDAgMGwtMi43LTIuN2MtLjQtLjQtLjQtLjkgMC0xLjNMNy41IDZoLTFsLTMgMy4zYy0uNi43LS42IDEuNy4xIDIuNEw1LjkgMTRINC42Yy0uMiAwLS40LS4xLS42LS4yTDEuMiAxMWMtLjMtLjMtLjMtLjggMC0xLjFMNC43IDZoMS44TDEwIDJoMUw3LjUgNmwzLjEgMy43LTMuNSA0Yy0uMS4xLS4yLjEtLjMuMnoiLz48L3N2Zz4=",className:void 0,component:void 0,title:void 0},history:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["undo","redo"],undo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMTQuODc1YzIuNjcyIDAgNC44NDYtMi4xNDUgNC44NDYtNC43ODEgMC0yLjYzNy0yLjE3NC00Ljc4MS00Ljg0Ni00Ljc4MVY4LjVMMS42MTUgNC4yNSA3IDB2My4xODhjMy44NiAwIDcgMy4wOTggNyA2LjkwNlMxMC44NiAxNyA3IDE3cy03LTMuMDk4LTctNi45MDZoMi4xNTRjMCAyLjYzNiAyLjE3NCA0Ljc4MSA0Ljg0NiA0Ljc4MXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},redo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNTA0IDEzLjk3N2E0LjQ5NyA0LjQ5NyAwIDAgMS00LjQ5Mi00LjQ5MiA0LjQ5NyA0LjQ5NyAwIDAgMSA0LjQ5Mi00LjQ5M3YyLjk5NWw0Ljk5LTMuOTkzTDYuNTA0IDB2Mi45OTVhNi40OTYgNi40OTYgMCAwIDAtNi40ODggNi40OWMwIDMuNTc4IDIuOTEgNi40OSA2LjQ4OCA2LjQ5YTYuNDk2IDYuNDk2IDAgMCAwIDYuNDg3LTYuNDloLTEuOTk2YTQuNDk3IDQuNDk3IDAgMCAxLTQuNDkxIDQuNDkyeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+",className:void 0,title:void 0},title:void 0}},Jo={en:{"generic.add":"Add","generic.cancel":"Cancel","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Block Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Color Picker","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Highlight","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Embedded Link","components.controls.embedded.enterlink":"Enter link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Font","components.controls.fontsize.fontsize":"Font Size","components.controls.history.history":"History","components.controls.history.undo":"Undo","components.controls.history.redo":"Redo","components.controls.image.image":"Image","components.controls.image.fileUpload":"File Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop the file or click to upload","components.controls.inline.bold":"Bold","components.controls.inline.italic":"Italic","components.controls.inline.underline":"Underline","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Link Title","components.controls.link.linkTarget":"Link Target","components.controls.link.linkTargetOption":"Open link in new window","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"List","components.controls.list.unordered":"Unordered","components.controls.list.ordered":"Ordered","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Remove","components.controls.textalign.textalign":"Text Align","components.controls.textalign.left":"Left","components.controls.textalign.center":"Center","components.controls.textalign.right":"Right","components.controls.textalign.justify":"Justify"},fr:{"generic.add":"Ok","generic.cancel":"Annuler","components.controls.blocktype.h1":"Titre 1","components.controls.blocktype.h2":"Titre 2","components.controls.blocktype.h3":"Titre 3","components.controls.blocktype.h4":"Titre 4","components.controls.blocktype.h5":"Titre 5","components.controls.blocktype.h6":"Titre 6","components.controls.blocktype.blockquote":"Citation","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Type bloc","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Palette de couleur","components.controls.colorpicker.text":"Texte","components.controls.colorpicker.background":"Fond","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Lien iFrame","components.controls.embedded.enterlink":"Entrer le lien","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Police","components.controls.fontsize.fontsize":"Taille de police","components.controls.history.history":"Historique","components.controls.history.undo":"Précédent","components.controls.history.redo":"Suivant","components.controls.image.image":"Image","components.controls.image.fileUpload":"Téléchargement","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Glisser une image ou cliquer pour télécharger","components.controls.inline.bold":"Gras","components.controls.inline.italic":"Italique","components.controls.inline.underline":"Souligner","components.controls.inline.strikethrough":"Barrer","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Exposant","components.controls.inline.subscript":"Indice","components.controls.link.linkTitle":"Titre du lien","components.controls.link.linkTarget":"Cible du lien","components.controls.link.linkTargetOption":"Ouvrir le lien dans une nouvelle fenêtre","components.controls.link.link":"Lier","components.controls.link.unlink":"Délier","components.controls.list.list":"Liste","components.controls.list.unordered":"Désordonnée","components.controls.list.ordered":"Ordonnée","components.controls.list.indent":"Augmenter le retrait","components.controls.list.outdent":"Diminuer le retrait","components.controls.remove.remove":"Supprimer","components.controls.textalign.textalign":"Alignement du texte","components.controls.textalign.left":"Gauche","components.controls.textalign.center":"Centre","components.controls.textalign.right":"Droite","components.controls.textalign.justify":"Justifier"},zh:{"generic.add":"添加","generic.cancel":"取消","components.controls.blocktype.h1":"标题1","components.controls.blocktype.h2":"标题2","components.controls.blocktype.h3":"标题3","components.controls.blocktype.h4":"标题4","components.controls.blocktype.h5":"标题5","components.controls.blocktype.h6":"标题6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"源码","components.controls.blocktype.blocktype":"样式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"选色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"内嵌","components.controls.embedded.embeddedlink":"内嵌网页","components.controls.embedded.enterlink":"输入网页地址","components.controls.emoji.emoji":"表情符号","components.controls.fontfamily.fontfamily":"字体","components.controls.fontsize.fontsize":"字号","components.controls.history.history":"历史","components.controls.history.undo":"撤销","components.controls.history.redo":"恢复","components.controls.image.image":"图片","components.controls.image.fileUpload":"来自文件","components.controls.image.byURL":"在线图片","components.controls.image.dropFileText":"点击或者拖拽文件上传","components.controls.inline.bold":"粗体","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下划线","components.controls.inline.strikethrough":"删除线","components.controls.inline.monospace":"等宽字体","components.controls.inline.superscript":"上标","components.controls.inline.subscript":"下标","components.controls.link.linkTitle":"超链接","components.controls.link.linkTarget":"输入链接地址","components.controls.link.linkTargetOption":"在新窗口中打开链接","components.controls.link.link":"链接","components.controls.link.unlink":"删除链接","components.controls.list.list":"列表","components.controls.list.unordered":"项目符号","components.controls.list.ordered":"编号","components.controls.list.indent":"增加缩进量","components.controls.list.outdent":"减少缩进量","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文本对齐","components.controls.textalign.left":"文本左对齐","components.controls.textalign.center":"居中","components.controls.textalign.right":"文本右对齐","components.controls.textalign.justify":"两端对齐"},ru:{"generic.add":"Добавить","generic.cancel":"Отменить","components.controls.blocktype.h1":"Заголовок 1","components.controls.blocktype.h2":"Заголовок 2","components.controls.blocktype.h3":"Заголовок 3","components.controls.blocktype.h4":"Заголовок 4","components.controls.blocktype.h5":"Заголовок 5","components.controls.blocktype.h6":"Заголовок 6","components.controls.blocktype.blockquote":"Цитата","components.controls.blocktype.code":"Код","components.controls.blocktype.blocktype":"Форматирование","components.controls.blocktype.normal":"Обычный","components.controls.colorpicker.colorpicker":"Выбор цвета","components.controls.colorpicker.text":"Текст","components.controls.colorpicker.background":"Фон","components.controls.embedded.embedded":"Встраивание","components.controls.embedded.embeddedlink":"Ссылка в iFrame","components.controls.embedded.enterlink":"Вставьте ссылку","components.controls.emoji.emoji":"Эмодзи","components.controls.fontfamily.fontfamily":"Шрифт","components.controls.fontsize.fontsize":"Размер шрифта","components.controls.history.history":"История","components.controls.history.undo":"Отменить","components.controls.history.redo":"Вернуть","components.controls.image.image":"Изображение","components.controls.image.fileUpload":"Файлы","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Переместите в эту область файлы или кликните для загрузки","components.controls.inline.bold":"Жирный","components.controls.inline.italic":"Курсив","components.controls.inline.underline":"Подчеркивание","components.controls.inline.strikethrough":"Зачеркивание","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Верхний индекс","components.controls.inline.subscript":"Нижний индекс","components.controls.link.linkTitle":"Текст","components.controls.link.linkTarget":"Адрес ссылки","components.controls.link.linkTargetOption":"Открывать в новом окне","components.controls.link.link":"Ссылка","components.controls.link.unlink":"Убрать ссылку","components.controls.list.list":"Список","components.controls.list.unordered":"Неупорядоченный","components.controls.list.ordered":"Упорядоченный","components.controls.list.indent":"Отступ","components.controls.list.outdent":"Выступ","components.controls.remove.remove":"Удалить","components.controls.textalign.textalign":"Выравнивание текста","components.controls.textalign.left":"Слева","components.controls.textalign.center":"По центру","components.controls.textalign.right":"Справа","components.controls.textalign.justify":"Выравнить"},pt:{"generic.add":"Ok","generic.cancel":"Cancelar","components.controls.blocktype.h1":"Título 1","components.controls.blocktype.h2":"Título 2","components.controls.blocktype.h3":"Título 3","components.controls.blocktype.h4":"Título 4","components.controls.blocktype.h5":"Título 5","components.controls.blocktype.h6":"Título 6","components.controls.blocktype.blockquote":"Citação","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Estilo","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Paleta de cores","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Fundo","components.controls.embedded.embedded":"Embarcado","components.controls.embedded.embeddedlink":"Link embarcado","components.controls.embedded.enterlink":"Coloque o link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonte","components.controls.fontsize.fontsize":"Tamanho da Fonte","components.controls.history.history":"Histórico","components.controls.history.undo":"Desfazer","components.controls.history.redo":"Refazer","components.controls.image.image":"Imagem","components.controls.image.fileUpload":"Carregar arquivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arraste uma imagem aqui ou clique para carregar","components.controls.inline.bold":"Negrito","components.controls.inline.italic":"Itálico","components.controls.inline.underline":"Sublinhado","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobrescrito","components.controls.inline.subscript":"Subscrito","components.controls.link.linkTitle":"Título do link","components.controls.link.linkTarget":"Alvo do link","components.controls.link.linkTargetOption":"Abrir link em outra janela","components.controls.link.link":"Adicionar Link","components.controls.link.unlink":"Remover link","components.controls.list.list":"Lista","components.controls.list.unordered":"Sem ordenção","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Aumentar recuo","components.controls.list.outdent":"Diminuir recuo","components.controls.remove.remove":"Remover","components.controls.textalign.textalign":"Alinhamento do texto","components.controls.textalign.left":"À Esquerda","components.controls.textalign.center":"Centralizado","components.controls.textalign.right":"À Direita","components.controls.textalign.justify":"Justificado"},ko:{"generic.add":"입력","generic.cancel":"취소","components.controls.blocktype.h1":"제목1","components.controls.blocktype.h2":"제목2","components.controls.blocktype.h3":"제목3","components.controls.blocktype.h4":"제목4","components.controls.blocktype.h5":"제목5","components.controls.blocktype.h6":"제목6","components.controls.blocktype.blockquote":"인용","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"블록","components.controls.blocktype.normal":"표준","components.controls.colorpicker.colorpicker":"색상 선택","components.controls.colorpicker.text":"글꼴색","components.controls.colorpicker.background":"배경색","components.controls.embedded.embedded":"임베드","components.controls.embedded.embeddedlink":"임베드 링크","components.controls.embedded.enterlink":"주소를 입력하세요","components.controls.emoji.emoji":"이모지","components.controls.fontfamily.fontfamily":"글꼴","components.controls.fontsize.fontsize":"글꼴 크기","components.controls.history.history":"히스토리","components.controls.history.undo":"실행 취소","components.controls.history.redo":"다시 실행","components.controls.image.image":"이미지","components.controls.image.fileUpload":"파일 업로드","components.controls.image.byURL":"주소","components.controls.image.dropFileText":"클릭하거나 파일을 드롭하여 업로드하세요","components.controls.inline.bold":"굵게","components.controls.inline.italic":"기울임꼴","components.controls.inline.underline":"밑줄","components.controls.inline.strikethrough":"취소선","components.controls.inline.monospace":"고정 너비","components.controls.inline.superscript":"위 첨자","components.controls.inline.subscript":"아래 첨자","components.controls.link.linkTitle":"링크 제목","components.controls.link.linkTarget":"링크 타겟","components.controls.link.linkTargetOption":"새창으로 열기","components.controls.link.link":"링크","components.controls.link.unlink":"링크 제거","components.controls.list.list":"리스트","components.controls.list.unordered":"일반 리스트","components.controls.list.ordered":"순서 리스트","components.controls.list.indent":"들여쓰기","components.controls.list.outdent":"내어쓰기","components.controls.remove.remove":"삭제","components.controls.textalign.textalign":"텍스트 정렬","components.controls.textalign.left":"왼쪽","components.controls.textalign.center":"중앙","components.controls.textalign.right":"오른쪽","components.controls.textalign.justify":"양쪽"},it:{"generic.add":"Aggiungi","generic.cancel":"Annulla","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Citazione","components.controls.blocktype.code":"Codice","components.controls.blocktype.blocktype":"Stili","components.controls.blocktype.normal":"Normale","components.controls.colorpicker.colorpicker":"Colore testo","components.controls.colorpicker.text":"Testo","components.controls.colorpicker.background":"Evidenziazione","components.controls.embedded.embedded":"Incorpora","components.controls.embedded.embeddedlink":"Incorpora link","components.controls.embedded.enterlink":"Inserisci link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Carattere","components.controls.fontsize.fontsize":"Dimensione carattere","components.controls.history.history":"Modifiche","components.controls.history.undo":"Annulla","components.controls.history.redo":"Ripristina","components.controls.image.image":"Immagine","components.controls.image.fileUpload":"Carica immagine","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Trascina il file o clicca per caricare","components.controls.inline.bold":"Grassetto","components.controls.inline.italic":"Corsivo","components.controls.inline.underline":"Sottolineato","components.controls.inline.strikethrough":"Barrato","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Apice","components.controls.inline.subscript":"Pedice","components.controls.link.linkTitle":"Testo","components.controls.link.linkTarget":"Link","components.controls.link.linkTargetOption":"Apri link in una nuova finestra","components.controls.link.link":"Inserisci link","components.controls.link.unlink":"Rimuovi link","components.controls.list.list":"Lista","components.controls.list.unordered":"Elenco puntato","components.controls.list.ordered":"Elenco numerato","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Rimuovi formattazione","components.controls.textalign.textalign":"Allineamento del testo","components.controls.textalign.left":"Allinea a sinistra","components.controls.textalign.center":"Allinea al centro","components.controls.textalign.right":"Allinea a destra","components.controls.textalign.justify":"Giustifica"},nl:{"generic.add":"Toevoegen","generic.cancel":"Annuleren","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Blocktype","components.controls.blocktype.normal":"Normaal","components.controls.colorpicker.colorpicker":"Kleurkiezer","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Achtergrond","components.controls.embedded.embedded":"Ingevoegd","components.controls.embedded.embeddedlink":"Ingevoegde link","components.controls.embedded.enterlink":"Voeg link toe","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Lettertype","components.controls.fontsize.fontsize":"Lettergrootte","components.controls.history.history":"Geschiedenis","components.controls.history.undo":"Ongedaan maken","components.controls.history.redo":"Opnieuw","components.controls.image.image":"Afbeelding","components.controls.image.fileUpload":"Bestand uploaden","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop het bestand hier of klik om te uploaden","components.controls.inline.bold":"Dikgedrukt","components.controls.inline.italic":"Schuingedrukt","components.controls.inline.underline":"Onderstrepen","components.controls.inline.strikethrough":"Doorstrepen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Linktitel","components.controls.link.linkTarget":"Link bestemming","components.controls.link.linkTargetOption":"Open link in een nieuw venster","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"Lijst","components.controls.list.unordered":"Ongeordend","components.controls.list.ordered":"Geordend","components.controls.list.indent":"Inspringen","components.controls.list.outdent":"Inspringen verkleinen","components.controls.remove.remove":"Verwijderen","components.controls.textalign.textalign":"Tekst uitlijnen","components.controls.textalign.left":"Links","components.controls.textalign.center":"Gecentreerd","components.controls.textalign.right":"Rechts","components.controls.textalign.justify":"Uitgelijnd"},de:{"generic.add":"Hinzufügen","generic.cancel":"Abbrechen","components.controls.blocktype.h1":"Überschrift 1","components.controls.blocktype.h2":"Überschrift 2","components.controls.blocktype.h3":"Überschrift 3","components.controls.blocktype.h4":"Überschrift 4","components.controls.blocktype.h5":"Überschrift 5","components.controls.blocktype.h6":"Überschrift 6","components.controls.blocktype.blockquote":"Zitat","components.controls.blocktype.code":"Quellcode","components.controls.blocktype.blocktype":"Blocktyp","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farbauswahl","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Hintergrund","components.controls.embedded.embedded":"Eingebettet","components.controls.embedded.embeddedlink":"Eingebetteter Link","components.controls.embedded.enterlink":"Link eingeben","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Schriftart","components.controls.fontsize.fontsize":"Schriftgröße","components.controls.history.history":"Historie","components.controls.history.undo":"Zurücknehmen","components.controls.history.redo":"Wiederholen","components.controls.image.image":"Bild","components.controls.image.fileUpload":"Datei-Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Dateien ziehen und ablegen, oder klicken zum Hochladen","components.controls.inline.bold":"Fett","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Unterstreichen","components.controls.inline.strikethrough":"Durchstreichen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hochgestellt","components.controls.inline.subscript":"Tiefgestellt","components.controls.link.linkTitle":"Link-Titel","components.controls.link.linkTarget":"Link-Ziel","components.controls.link.linkTargetOption":"Link in neuem Fenster öffnen","components.controls.link.link":"Link","components.controls.link.unlink":"Aufheben","components.controls.list.list":"Liste","components.controls.list.unordered":"Aufzählung","components.controls.list.ordered":"Nummerierte Liste","components.controls.list.indent":"Einzug vergrößern","components.controls.list.outdent":"Einzug reduzieren","components.controls.remove.remove":"Entfernen","components.controls.textalign.textalign":"Textausrichtung","components.controls.textalign.left":"Linksbündig","components.controls.textalign.center":"Zentrieren","components.controls.textalign.right":"Rechtsbündig","components.controls.textalign.justify":"Blocksatz"},da:{"generic.add":"Tilføj","generic.cancel":"Annuller","components.controls.blocktype.h1":"Overskrift 1","components.controls.blocktype.h2":"Overskrift 2","components.controls.blocktype.h3":"Overskrift 3","components.controls.blocktype.h4":"Overskrift 4","components.controls.blocktype.h5":"Overskrift 5","components.controls.blocktype.h6":"Overskrift 6","components.controls.blocktype.blockquote":"Blokcitat","components.controls.blocktype.code":"Kode","components.controls.blocktype.blocktype":"Blok Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farver","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Baggrund","components.controls.embedded.embedded":"Indlejre","components.controls.embedded.embeddedlink":"Indlejre Link","components.controls.embedded.enterlink":"Indtast link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonttype","components.controls.fontsize.fontsize":"Fontstørrelser","components.controls.history.history":"Historie","components.controls.history.undo":"Fortryd","components.controls.history.redo":"Gendan","components.controls.image.image":"Billede","components.controls.image.fileUpload":"Filoverførsel","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop filen eller klik for at uploade","components.controls.inline.bold":"Fed","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Understrege","components.controls.inline.strikethrough":"Gennemstreget","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hævet","components.controls.inline.subscript":"Sænket","components.controls.link.linkTitle":"Link Titel","components.controls.link.linkTarget":"Link Mål","components.controls.link.linkTargetOption":"Åbn link i nyt vindue","components.controls.link.link":"Link","components.controls.link.unlink":"Fjern link","components.controls.list.list":"Liste","components.controls.list.unordered":"Uordnet","components.controls.list.ordered":"Ordnet","components.controls.list.indent":"Indrykning","components.controls.list.outdent":"Udrykning","components.controls.remove.remove":"Fjern","components.controls.textalign.textalign":"Tekstjustering","components.controls.textalign.left":"Venstre","components.controls.textalign.center":"Center","components.controls.textalign.right":"Højre","components.controls.textalign.justify":"Margener"},zh_tw:{"generic.add":"新增","generic.cancel":"取消","components.controls.blocktype.h1":"標題1","components.controls.blocktype.h2":"標題2","components.controls.blocktype.h3":"標題3","components.controls.blocktype.h4":"標題4","components.controls.blocktype.h5":"標題5","components.controls.blocktype.h6":"標題6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"程式碼","components.controls.blocktype.blocktype":"樣式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"選色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"內嵌","components.controls.embedded.embeddedlink":"內嵌網頁","components.controls.embedded.enterlink":"輸入網頁地址","components.controls.emoji.emoji":"表情符號","components.controls.fontfamily.fontfamily":"字體","components.controls.fontsize.fontsize":"字體大小","components.controls.history.history":"歷史紀錄","components.controls.history.undo":"復原","components.controls.history.redo":"重做","components.controls.image.image":"圖片","components.controls.image.fileUpload":"檔案上傳","components.controls.image.byURL":"網址","components.controls.image.dropFileText":"點擊或拖曳檔案上傳","components.controls.inline.bold":"粗體","components.controls.inline.italic":"斜體","components.controls.inline.underline":"底線","components.controls.inline.strikethrough":"刪除線","components.controls.inline.monospace":"等寬字體","components.controls.inline.superscript":"上標","components.controls.inline.subscript":"下標","components.controls.link.linkTitle":"超連結","components.controls.link.linkTarget":"輸入連結位址","components.controls.link.linkTargetOption":"在新視窗打開連結","components.controls.link.link":"連結","components.controls.link.unlink":"刪除連結","components.controls.list.list":"列表","components.controls.list.unordered":"項目符號","components.controls.list.ordered":"編號","components.controls.list.indent":"增加縮排","components.controls.list.outdent":"減少縮排","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文字對齊","components.controls.textalign.left":"文字向左對齊","components.controls.textalign.center":"文字置中","components.controls.textalign.right":"文字向右對齊","components.controls.textalign.justify":"兩端對齊"},pl:{"generic.add":"Dodaj","generic.cancel":"Anuluj","components.controls.blocktype.h1":"Nagłówek 1","components.controls.blocktype.h2":"Nagłówek 2","components.controls.blocktype.h3":"Nagłówek 3","components.controls.blocktype.h4":"Nagłówek 4","components.controls.blocktype.h5":"Nagłówek 5","components.controls.blocktype.h6":"Nagłówek 6","components.controls.blocktype.blockquote":"Cytat","components.controls.blocktype.code":"Kod","components.controls.blocktype.blocktype":"Format","components.controls.blocktype.normal":"Normalny","components.controls.colorpicker.colorpicker":"Kolor","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Tło","components.controls.embedded.embedded":"Osadź","components.controls.embedded.embeddedlink":"Osadź odnośnik","components.controls.embedded.enterlink":"Wprowadź odnośnik","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Krój czcionki","components.controls.fontsize.fontsize":"Rozmiar czcionki","components.controls.history.history":"Historia","components.controls.history.undo":"Cofnij","components.controls.history.redo":"Ponów","components.controls.image.image":"Obrazek","components.controls.image.fileUpload":"Prześlij plik","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Upuść plik lub kliknij, aby przesłać","components.controls.inline.bold":"Pogrubienie","components.controls.inline.italic":"Kursywa","components.controls.inline.underline":"Podkreślenie","components.controls.inline.strikethrough":"Przekreślenie","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Indeks górny","components.controls.inline.subscript":"Indeks dolny","components.controls.link.linkTitle":"Tytuł odnośnika","components.controls.link.linkTarget":"Adres odnośnika","components.controls.link.linkTargetOption":"Otwórz odnośnik w nowej karcie","components.controls.link.link":"Wstaw odnośnik","components.controls.link.unlink":"Usuń odnośnik","components.controls.list.list":"Lista","components.controls.list.unordered":"Lista nieuporządkowana","components.controls.list.ordered":"Lista uporządkowana","components.controls.list.indent":"Zwiększ wcięcie","components.controls.list.outdent":"Zmniejsz wcięcie","components.controls.remove.remove":"Usuń","components.controls.textalign.textalign":"Wyrównaj tekst","components.controls.textalign.left":"Do lewej","components.controls.textalign.center":"Do środka","components.controls.textalign.right":"Do prawej","components.controls.textalign.justify":"Wyjustuj"},es:{"generic.add":"Añadir","generic.cancel":"Cancelar","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Código","components.controls.blocktype.blocktype":"Tipo de bloque","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Seleccionar color","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Subrayado","components.controls.embedded.embedded":"Adjuntar","components.controls.embedded.embeddedlink":"Adjuntar Link","components.controls.embedded.enterlink":"Introducir link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fuente","components.controls.fontsize.fontsize":"Tamaño de fuente","components.controls.history.history":"Histórico","components.controls.history.undo":"Deshacer","components.controls.history.redo":"Rehacer","components.controls.image.image":"Imagen","components.controls.image.fileUpload":"Subir archivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arrastra el archivo o haz click para subirlo","components.controls.inline.bold":"Negrita","components.controls.inline.italic":"Cursiva","components.controls.inline.underline":"Subrayado","components.controls.inline.strikethrough":"Tachado","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobreíndice","components.controls.inline.subscript":"Subíndice","components.controls.link.linkTitle":"Título del enlace","components.controls.link.linkTarget":"Objetivo del enlace","components.controls.link.linkTargetOption":"Abrir en nueva ventana","components.controls.link.link":"Enlazar","components.controls.link.unlink":"Desenlazar","components.controls.list.list":"Lista","components.controls.list.unordered":"Desordenada","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Indentada","components.controls.list.outdent":"Dentada","components.controls.remove.remove":"Eliminar","components.controls.textalign.textalign":"Alineación del texto","components.controls.textalign.left":"Izquierda","components.controls.textalign.center":"Centrado","components.controls.textalign.right":"Derecha","components.controls.textalign.justify":"Justificado"},ja:{"generic.add":"追加","generic.cancel":"キャンセル","components.controls.blocktype.h1":"見出し1","components.controls.blocktype.h2":"見出し2","components.controls.blocktype.h3":"見出し3","components.controls.blocktype.h4":"見出し4","components.controls.blocktype.h5":"見出し5","components.controls.blocktype.h6":"見出し6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"コード","components.controls.blocktype.blocktype":"スタイル","components.controls.blocktype.normal":"標準テキスト","components.controls.colorpicker.colorpicker":"テキストの色","components.controls.colorpicker.text":"テキスト","components.controls.colorpicker.background":"ハイライト","components.controls.embedded.embedded":"埋め込み","components.controls.embedded.embeddedlink":"埋め込みリンク","components.controls.embedded.enterlink":"リンクを入力してください","components.controls.emoji.emoji":"絵文字","components.controls.fontfamily.fontfamily":"フォント","components.controls.fontsize.fontsize":"フォントサイズ","components.controls.history.history":"履歴","components.controls.history.undo":"元に戻す","components.controls.history.redo":"やり直し","components.controls.image.image":"画像","components.controls.image.fileUpload":"ファイルをアップロード","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"ここに画像をドラッグするか、クリックしてください","components.controls.inline.bold":"太字","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下線","components.controls.inline.strikethrough":"取り消し線","components.controls.inline.monospace":"等幅フォント","components.controls.inline.superscript":"上付き文字","components.controls.inline.subscript":"下付き文字","components.controls.link.linkTitle":"リンクタイトル","components.controls.link.linkTarget":"リンク対象","components.controls.link.linkTargetOption":"新しいウィンドウで開く","components.controls.link.link":"リンク","components.controls.link.unlink":"リンクを解除","components.controls.list.list":"リスト","components.controls.list.unordered":"箇条書き","components.controls.list.ordered":"番号付き","components.controls.list.indent":"インデント増","components.controls.list.outdent":"インデント減","components.controls.remove.remove":"書式をクリア","components.controls.textalign.textalign":"整列","components.controls.textalign.left":"左揃え","components.controls.textalign.center":"中央揃え","components.controls.textalign.right":"右揃え","components.controls.textalign.justify":"両端揃え"}};n(38),n(39);function Vo(t){return(Vo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qo(){return(qo=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function Ko(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Xo(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ko(Object(n),!0).forEach(function(t){$o(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ko(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function $o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function tr(t){return function(t){if(Array.isArray(t))return er(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return er(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return er(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function er(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function nr(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function or(t,e){return(or=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function rr(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ir(o);if(r){var n=ir(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ir(t){return(ir=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cr=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&or(t,e)}(i,f["Component"]);var t,e,n,r=rr(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).onEditorBlur=function(){c.setState({editorFocused:!1})},c.onEditorFocus=function(t){var e=c.props.onFocus;c.setState({editorFocused:!0});var n=c.focusHandler.isEditorFocused();e&&n&&e(t)},c.onEditorMouseDown=function(){c.focusHandler.onEditorMouseDown()},c.keyBindingFn=function(t){if("Tab"!==t.key)return"ArrowUp"!==t.key&&"ArrowDown"!==t.key||b()&&t.preventDefault(),Object(E.getDefaultKeyBinding)(t);var e=c.props.onTab;if(!e||!e(t)){var n=Object(S.changeDepth)(c.state.editorState,t.shiftKey?-1:1,4);n&&n!==c.state.editorState&&(c.onChange(n),t.preventDefault())}return null},c.onToolbarFocus=function(t){var e=c.props.onFocus;e&&c.focusHandler.isToolbarFocused()&&e(t)},c.onWrapperBlur=function(t){var e=c.props.onBlur;e&&c.focusHandler.isEditorBlur(t)&&e(t,c.getEditorState())},c.onChange=function(t){var e=c.props,n=e.readOnly,o=e.onEditorStateChange;n||"atomic"===Object(S.getSelectedBlocksType)(t)&&t.getSelection().isCollapsed||(o&&o(t,c.props.wrapperId),M(c.props,"editorState")?c.afterChange(t):c.setState({editorState:t},c.afterChange(t)))},c.setWrapperReference=function(t){c.wrapper=t},c.setEditorReference=function(t){c.props.editorRef&&c.props.editorRef(t),c.editor=t},c.getCompositeDecorator=function(t){var e=[].concat(tr(c.props.customDecorators),[{strategy:Mo,component:jo({showOpenOptionOnHover:t.link.showOpenOptionOnHover})}]);return c.props.mention&&e.push.apply(e,tr(To(Xo(Xo({},c.props.mention),{},{onChange:c.onChange,getEditorState:c.getEditorState,getSuggestions:c.getSuggestions,getWrapperRef:c.getWrapperRef,modalHandler:c.modalHandler})))),c.props.hashtag&&e.push(Ro(c.props.hashtag)),new E.CompositeDecorator(e)},c.getWrapperRef=function(){return c.wrapper},c.getEditorState=function(){return c.state?c.state.editorState:null},c.getSuggestions=function(){return c.props.mention&&c.props.mention.suggestions},c.afterChange=function(o){setTimeout(function(){var t=c.props,e=t.onChange,n=t.onContentStateChange;e&&e(Object(E.convertToRaw)(o.getCurrentContent())),n&&n(Object(E.convertToRaw)(o.getCurrentContent()))})},c.isReadOnly=function(){return c.props.readOnly},c.isImageAlignmentEnabled=function(){return c.state.toolbar.image.alignmentEnabled},c.createEditorState=function(t){var e;if(M(c.props,"editorState"))c.props.editorState&&(e=E.EditorState.set(c.props.editorState,{decorator:t}));else if(M(c.props,"defaultEditorState"))c.props.defaultEditorState&&(e=E.EditorState.set(c.props.defaultEditorState,{decorator:t}));else if(M(c.props,"contentState")){if(c.props.contentState){var n=Object(E.convertFromRaw)(c.props.contentState);e=E.EditorState.createWithContent(n,t),e=E.EditorState.moveSelectionToEnd(e)}}else if(M(c.props,"defaultContentState")||M(c.props,"initialContentState")){var o=c.props.defaultContentState||c.props.initialContentState;o&&(o=Object(E.convertFromRaw)(o),e=E.EditorState.createWithContent(o,t),e=E.EditorState.moveSelectionToEnd(e))}return e=e||E.EditorState.createEmpty(t)},c.filterEditorProps=function(t){return e=t,n=["onChange","onEditorStateChange","onContentStateChange","initialContentState","defaultContentState","contentState","editorState","defaultEditorState","locale","localization","toolbarOnFocus","toolbar","toolbarCustomButtons","toolbarClassName","editorClassName","toolbarHidden","wrapperClassName","toolbarStyle","editorStyle","wrapperStyle","uploadCallback","onFocus","onBlur","onTab","mention","hashtag","ariaLabel","customBlockRenderFunc","customDecorators","handlePastedText","customStyleMap"],o=Object.keys(e).filter(function(t){return n.indexOf(t)<0}),r={},o&&0<o.length&&o.forEach(function(t){r[t]=e[t]}),r;var e,n,o,r},c.getStyleMap=function(t){return Xo(Xo({},Object(S.getCustomStyleMap)()),t.customStyleMap)},c.changeEditorState=function(t){var e=Object(E.convertFromRaw)(t),n=c.state.editorState;return n=E.EditorState.push(n,e,"insert-characters"),n=E.EditorState.moveSelectionToEnd(n)},c.focusEditor=function(){setTimeout(function(){c.editor.focus()})},c.handleKeyCommand=function(t){var e=c.state,n=e.editorState,o=e.toolbar.inline;if(o&&0<=o.options.indexOf(t)){var r=E.RichUtils.handleKeyCommand(n,t);if(r)return c.onChange(r),!0}return!1},c.handleReturn=function(t){if(b())return!0;var e=c.state.editorState,n=Object(S.handleNewLine)(e,t);return!!n&&(c.onChange(n),!0)},c.handlePastedTextFn=function(t,e){var n=c.state.editorState,o=c.props,r=o.handlePastedText,i=o.stripPastedStyles;return r?r(t,e,n,c.onChange):!i&&function(t,e,n,o){var r=Object(S.getSelectedBlock)(n);if(r&&"code"===r.type){var i=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());return o(E.EditorState.push(n,i,"insert-characters")),!0}if(e){var c=O()(e),a=n.getCurrentContent();return c.entityMap.forEach(function(t,e){a=a.mergeEntityData(e,t)}),a=E.Modifier.replaceWithFragment(a,n.getSelection(),new x.List(c.contentBlocks)),o(E.EditorState.push(n,a,"insert-characters")),!0}return!1}(t,e,n,c.onChange)},c.preventDefault=function(t){"INPUT"===t.target.tagName||"LABEL"===t.target.tagName||"TEXTAREA"===t.target.tagName?c.focusHandler.onInputMouseDown():t.preventDefault()};var e=D(Go,t.toolbar),n=t.wrapperId?t.wrapperId:Math.floor(1e4*Math.random());c.wrapperId="rdw-wrapper-".concat(n),c.modalHandler=new a,c.focusHandler=new p,c.blockRendererFn=Wo({isReadOnly:c.isReadOnly,isImageAlignmentEnabled:c.isImageAlignmentEnabled,getEditorState:c.getEditorState,onChange:c.onChange},t.customBlockRenderFunc),c.editorProps=c.filterEditorProps(t),c.customStyleMap=c.getStyleMap(t),c.compositeDecorator=c.getCompositeDecorator(e);var o=c.createEditorState(c.compositeDecorator);return Object(S.extractInlineStyle)(o),c.state={editorState:o,editorFocused:!1,toolbar:e},c}return t=i,(e=[{key:"componentDidMount",value:function(){this.modalHandler.init(this.wrapperId)}},{key:"componentDidUpdate",value:function(t){if(t!==this.props){var e={},n=this.props,o=n.editorState,r=n.contentState;if(!this.state.toolbar){var i=D(Go,i);e.toolbar=i}if(M(this.props,"editorState")&&o!==t.editorState)e.editorState=o?E.EditorState.set(o,{decorator:this.compositeDecorator}):E.EditorState.createEmpty(this.compositeDecorator);else if(M(this.props,"contentState")&&r!==t.contentState)if(r){var c=this.changeEditorState(r);c&&(e.editorState=c)}else e.editorState=E.EditorState.createEmpty(this.compositeDecorator);t.editorState===o&&t.contentState===r||Object(S.extractInlineStyle)(e.editorState),Object.keys(e).length&&this.setState(e),this.editorProps=this.filterEditorProps(this.props),this.customStyleMap=this.getStyleMap(this.props)}}},{key:"render",value:function(){var t=this.state,e=t.editorState,n=t.editorFocused,r=t.toolbar,o=this.props,i=o.locale,c=o.localization,a=c.locale,l=c.translations,s=o.toolbarCustomButtons,u=o.toolbarOnFocus,p=o.toolbarClassName,d=o.toolbarHidden,f=o.editorClassName,y=o.wrapperClassName,m=o.toolbarStyle,g=o.editorStyle,b=o.wrapperStyle,h=o.uploadCallback,M=o.ariaLabel,j={modalHandler:this.modalHandler,editorState:e,onChange:this.onChange,translations:Xo(Xo({},Jo[i||a]),l)},v=n||this.focusHandler.isInputFocused()||!u;return N.a.createElement("div",{id:this.wrapperId,className:w()(y,"rdw-editor-wrapper"),style:b,onClick:this.modalHandler.onEditorClick,onBlur:this.onWrapperBlur,"aria-label":"rdw-wrapper"},!d&&N.a.createElement("div",{className:w()("rdw-editor-toolbar",p),style:Xo({visibility:v?"visible":"hidden"},m),onMouseDown:this.preventDefault,"aria-label":"rdw-toolbar","aria-hidden":(!n&&u).toString(),onFocus:this.onToolbarFocus},r.options.map(function(t,e){var n=so[t],o=r[t];return"image"===t&&h&&(o.uploadCallback=h),N.a.createElement(n,qo({key:e},j,{config:o}))}),s&&s.map(function(t,e){return N.a.cloneElement(t,Xo({key:e},j))})),N.a.createElement("div",{ref:this.setWrapperReference,className:w()(f,"rdw-editor-main"),style:g,onClick:this.focusEditor,onFocus:this.onEditorFocus,onBlur:this.onEditorBlur,onKeyDown:C.onKeyDown,onMouseDown:this.onEditorMouseDown},N.a.createElement(E.Editor,qo({ref:this.setEditorReference,keyBindingFn:this.keyBindingFn,editorState:e,onChange:this.onChange,blockStyleFn:L,customStyleMap:this.getStyleMap(this.props),handleReturn:this.handleReturn,handlePastedText:this.handlePastedTextFn,blockRendererFn:this.blockRendererFn,handleKeyCommand:this.handleKeyCommand,ariaLabel:M||"rdw-editor",blockRenderMap:S.blockRenderMap},this.editorProps))))}}])&&nr(t.prototype,e),n&&nr(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cr.propTypes={onChange:y.a.func,onEditorStateChange:y.a.func,onContentStateChange:y.a.func,initialContentState:y.a.object,defaultContentState:y.a.object,contentState:y.a.object,editorState:y.a.object,defaultEditorState:y.a.object,toolbarOnFocus:y.a.bool,spellCheck:y.a.bool,stripPastedStyles:y.a.bool,toolbar:y.a.object,toolbarCustomButtons:y.a.array,toolbarClassName:y.a.string,toolbarHidden:y.a.bool,locale:y.a.string,localization:y.a.object,editorClassName:y.a.string,wrapperClassName:y.a.string,toolbarStyle:y.a.object,editorStyle:y.a.object,wrapperStyle:y.a.object,uploadCallback:y.a.func,onFocus:y.a.func,onBlur:y.a.func,onTab:y.a.func,mention:y.a.object,hashtag:y.a.object,textAlignment:y.a.string,readOnly:y.a.bool,tabIndex:y.a.number,placeholder:y.a.string,ariaLabel:y.a.string,ariaOwneeID:y.a.string,ariaActiveDescendantID:y.a.string,ariaAutoComplete:y.a.string,ariaDescribedBy:y.a.string,ariaExpanded:y.a.string,ariaHasPopup:y.a.string,customBlockRenderFunc:y.a.func,wrapperId:y.a.number,customDecorators:y.a.array,editorRef:y.a.func,handlePastedText:y.a.func},cr.defaultProps={toolbarOnFocus:!1,toolbarHidden:!1,stripPastedStyles:!1,localization:{locale:"en",translations:{}},customDecorators:[]};var ar=cr}],i.c=a,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(n,o,function(t){return e[t]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=8);function i(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}var c,a});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    className: _propTypes2.default.string,
    onloadCallbackName: _propTypes2.default.string,
    elementID: _propTypes2.default.string,
    onloadCallback: _propTypes2.default.func,
    verifyCallback: _propTypes2.default.func,
    expiredCallback: _propTypes2.default.func,
    render: _propTypes2.default.string,
    sitekey: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    type: _propTypes2.default.string,
    verifyCallbackName: _propTypes2.default.string,
    expiredCallbackName: _propTypes2.default.string,
    size: _propTypes2.default.string,
    tabindex: _propTypes2.default.string,
    hl: _propTypes2.default.string,
    badge: _propTypes2.default.string
};

var defaultProps = {
    elementID: 'g-recaptcha',
    onloadCallback: undefined,
    onloadCallbackName: 'onloadCallback',
    verifyCallback: undefined,
    verifyCallbackName: 'verifyCallback',
    expiredCallback: undefined,
    expiredCallbackName: 'expiredCallback',
    render: 'onload',
    theme: 'light',
    type: 'image',
    size: 'normal',
    tabindex: '0',
    hl: 'en',
    badge: 'bottomright'
};

var isReady = function isReady() {
    return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
};

var readyCheck = void 0;

var ReCaptcha = function (_Component) {
    _inherits(ReCaptcha, _Component);

    function ReCaptcha(props) {
        _classCallCheck(this, ReCaptcha);

        var _this = _possibleConstructorReturn(this, (ReCaptcha.__proto__ || Object.getPrototypeOf(ReCaptcha)).call(this, props));

        _this._renderGrecaptcha = _this._renderGrecaptcha.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.execute = _this.execute.bind(_this);
        _this.state = {
            ready: isReady(),
            widget: null
        };

        if (!_this.state.ready) {
            readyCheck = setInterval(_this._updateReadyState.bind(_this), 1000);
        }
        return _this;
    }

    _createClass(ReCaptcha, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!!this.state.ready) {
                this._renderGrecaptcha();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _props = this.props,
                render = _props.render,
                onloadCallback = _props.onloadCallback;


            if (render === 'explicit' && onloadCallback && this.state.ready && !prevState.ready) {
                this._renderGrecaptcha();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(readyCheck);
        }
    }, {
        key: 'reset',
        value: function reset() {
            var _state = this.state,
                ready = _state.ready,
                widget = _state.widget;

            if (ready && widget !== null) {
                grecaptcha.reset(widget);
            }
        }
    }, {
        key: 'execute',
        value: function execute() {
            var _state2 = this.state,
                ready = _state2.ready,
                widget = _state2.widget;

            if (ready && widget !== null) {
                grecaptcha.execute(widget);
            }
        }
    }, {
        key: '_updateReadyState',
        value: function _updateReadyState() {
            if (isReady()) {
                this.setState({
                    ready: true
                });

                clearInterval(readyCheck);
            }
        }
    }, {
        key: '_renderGrecaptcha',
        value: function _renderGrecaptcha() {
            this.state.widget = grecaptcha.render(this.props.elementID, {
                sitekey: this.props.sitekey,
                callback: this.props.verifyCallback ? this.props.verifyCallback : undefined,
                theme: this.props.theme,
                type: this.props.type,
                size: this.props.size,
                tabindex: this.props.tabindex,
                hl: this.props.hl,
                badge: this.props.badge,
                'expired-callback': this.props.expiredCallback ? this.props.expiredCallback : undefined
            });

            if (this.props.onloadCallback) {
                this.props.onloadCallback();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.render === 'explicit' && this.props.onloadCallback) {
                return _react2.default.createElement('div', { id: this.props.elementID,
                    'data-onloadcallbackname': this.props.onloadCallbackName,
                    'data-verifycallbackname': this.props.verifyCallbackName
                });
            } else {

                return _react2.default.createElement('div', { id: this.props.elementID,
                    className: 'g-recaptcha',
                    'data-sitekey': this.props.sitekey,
                    'data-theme': this.props.theme,
                    'data-type': this.props.type,
                    'data-size': this.props.size,
                    'data-badge': this.props.badge,
                    'data-tabindex': this.props.tabindex
                });
            }
        }
    }]);

    return ReCaptcha;
}(_react.Component);

ReCaptcha.propTypes = propTypes;
ReCaptcha.defaultProps = defaultProps;

exports.default = ReCaptcha;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadReCaptcha = function loadReCaptcha() {
    var script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = "https://www.google.com/recaptcha/api.js";
    document.body.appendChild(script);
};

exports.default = loadReCaptcha;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _ReCaptcha = __webpack_require__(6);

var _ReCaptcha2 = _interopRequireDefault(_ReCaptcha);

var _loadReCaptcha = __webpack_require__(7);

var _loadReCaptcha2 = _interopRequireDefault(_loadReCaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  ReCaptcha: _ReCaptcha2.default,
  loadReCaptcha: _loadReCaptcha2.default
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(5);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(5);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(10);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(11)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(824);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(825);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(414);


function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(828);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(826);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(2261);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(2260);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(416);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ current: __WEBPACK_IMPORTED_MODULE_2_prop_types__["elementType"] })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(224);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(836);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(2276);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqual2 = __webpack_require__(653);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AnimateManager = __webpack_require__(2281);

var _AnimateManager2 = _interopRequireDefault(_AnimateManager);

var _PureRender = __webpack_require__(2282);

var _PureRender2 = _interopRequireDefault(_PureRender);

var _easing = __webpack_require__(838);

var _configUpdate = __webpack_require__(2283);

var _configUpdate2 = _interopRequireDefault(_configUpdate);

var _util = __webpack_require__(289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(Animate, _Component);

  function Animate(props, context) {
    _classCallCheck(this, Animate);

    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));

    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;


    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
    _this.changeStyle = _this.changeStyle.bind(_this);

    if (!isActive) {
      _this.state = { style: {} };

      // if children is a function and animation is not active, set style to 'to'
      if (typeof children === 'function') {
        _this.state = { style: to };
      }

      return _possibleConstructorReturn(_this);
    }

    if (steps && steps.length) {
      _this.state = { style: steps[0].style };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };

        return _possibleConstructorReturn(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      };
    } else {
      _this.state = { style: {} };
    }
    return _this;
  }

  _createClass(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isActive = _props.isActive,
          canBegin = _props.canBegin;


      this.mounted = true;

      if (!isActive || !canBegin) {
        return;
      }

      this.runAnimation(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isActive = nextProps.isActive,
          canBegin = nextProps.canBegin,
          attributeName = nextProps.attributeName,
          shouldReAnimate = nextProps.shouldReAnimate;


      if (!canBegin) {
        return;
      }

      if (!isActive) {
        this.setState({
          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
        });

        return;
      }

      var animateProps = ['to', 'canBegin', 'isActive'];

      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
        return;
      }

      var isTriggered = !this.props.canBegin || !this.props.isActive;

      if (this.manager) {
        this.manager.stop();
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }

      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;

      this.setState({
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      });

      this.runAnimation(_extends({}, nextProps, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.unSubscribe) {
        this.unSubscribe();
      }

      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
    }
  }, {
    key: 'runJSAnimation',
    value: function runJSAnimation(props) {
      var _this2 = this;

      var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;

      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);

      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };

      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: 'runStepAnimation',
    value: function runStepAnimation(props) {
      var _this3 = this;

      var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;


      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }

        var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;


        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);

        if (typeof easing === 'function' || easing === 'spring') {
          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }

        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
        var newStyle = _extends({}, preItem.style, style, {
          transition: transition
        });

        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
      };

      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: 'runAnimation',
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = (0, _AnimateManager2.default)();
      }
      var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsFrom = props.from,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;


      var manager = this.manager;

      this.unSubscribe = manager.subscribe(this.handleStyleChange);

      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }

      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }

      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);

      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
    }
  }, {
    key: 'handleStyleChange',
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: 'changeStyle',
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          begin = _props2.begin,
          duration = _props2.duration,
          attributeName = _props2.attributeName,
          easing = _props2.easing,
          isActive = _props2.isActive,
          steps = _props2.steps,
          from = _props2.from,
          to = _props2.to,
          canBegin = _props2.canBegin,
          onAnimationEnd = _props2.onAnimationEnd,
          shouldReAnimate = _props2.shouldReAnimate,
          onAnimationReStart = _props2.onAnimationReStart,
          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);

      var count = _react.Children.count(children);
      var stateStyle = (0, _util.translateStyle)(this.state.style);

      if (typeof children === 'function') {
        return children(stateStyle);
      }

      if (!isActive || count === 0) {
        return children;
      }

      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === undefined ? {} : _container$props$styl,
            className = _container$props.className;


        var res = (0, _react.cloneElement)(container, _extends({}, others, {
          style: _extends({}, style, stateStyle),
          className: className
        }));
        return res;
      };

      if (count === 1) {
        var onlyChild = _react.Children.only(children);

        return cloneContainer(_react.Children.only(children));
      }

      return _react2.default.createElement(
        'div',
        null,
        _react.Children.map(children, function (child) {
          return cloneContainer(child);
        })
      );
    }
  }]);

  return Animate;
}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
  from: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  to: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  attributeName: _react.PropTypes.string,
  // animation duration
  duration: _react.PropTypes.number,
  begin: _react.PropTypes.number,
  easing: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  steps: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    duration: _react.PropTypes.number.isRequired,
    style: _react.PropTypes.object.isRequired,
    easing: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _react.PropTypes.func]),
    // transition css properties(dash case), optional
    properties: _react.PropTypes.arrayOf('string'),
    onAnimationEnd: _react.PropTypes.func
  })),
  children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
  isActive: _react.PropTypes.bool,
  canBegin: _react.PropTypes.bool,
  onAnimationEnd: _react.PropTypes.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: _react.PropTypes.bool,
  onAnimationStart: _react.PropTypes.func,
  onAnimationReStart: _react.PropTypes.func
}, _class2.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
}, _temp)) || _class;

exports.default = Animate;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configEasing = exports.configSpring = exports.configBezier = undefined;

var _util = __webpack_require__(289);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);

    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
      return param * i;
    }).slice(1)), [0]);

    return multyTime(newParams, t);
  };
};

// calculate cubic-bezier using Newton's method
var configBezier = exports.configBezier = function configBezier() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];


  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;

        break;
      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      default:
        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
    }
  }

  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);

  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;

  return bezier;
};

var configSpring = exports.configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === undefined ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === undefined ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === undefined ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;

  return stepper;
};

var configEasing = exports.configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];


  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);
      case 'spring':
        return configSpring();
      default:
        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);

  return null;
};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1599);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(225),
    _assign = __webpack_require__(29);

var ReactNoopUpdateQueue = __webpack_require__(844);

var canDefineProperty = __webpack_require__(845);
var emptyObject = __webpack_require__(376);
var invariant = __webpack_require__(21);
var lowPriorityWarning = __webpack_require__(2297);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(225);

var ReactCurrentOwner = __webpack_require__(122);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(37);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNiceTickValues = __webpack_require__(2300);

Object.defineProperty(exports, 'getTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValues;
  }
});
Object.defineProperty(exports, 'getNiceTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getNiceTickValues;
  }
});
Object.defineProperty(exports, 'getTickValuesFixedDomain', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValuesFixedDomain;
  }
});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = exports.PLACE_HOLDER = {
  '@@functional/placeholder': true
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(undefined, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(undefined, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });

      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
    }));
  });
};

var curry = exports.curry = function curry(fn) {
  return curryN(fn.length, fn);
};

var range = exports.range = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};

var map = exports.map = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});

var compose = exports.compose = function compose() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse();
  // first function can receive multiply arguments
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);

  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(undefined, arguments));
  };
};

var reverse = exports.reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  }

  // can be string
  return arr.split('').reverse.join('');
};

var memoize = exports.memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;

  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(undefined, args);

    return lastResult;
  };
};

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__ = __webpack_require__(25);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Brush
 */











var Brush = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Brush, _Component);

  function Brush(props) {
    _classCallCheck(this, Brush);

    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
    };

    if (props.data && props.data.length) {
      _this.updateScale(props);
    } else {
      _this.state = {};
    }
    return _this;
  }

  _createClass(Brush, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          width = _props.width,
          x = _props.x,
          travellerWidth = _props.travellerWidth,
          updateId = _props.updateId;


      if (nextProps.data !== data || nextProps.updateId !== updateId) {
        this.updateScale(nextProps);
      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
        this.scaleValues = this.scale.domain().map(function (entry) {
          return _this2.scale(entry);
        });

        this.setState({
          startX: this.scale(nextProps.startIndex),
          endX: this.scale(nextProps.endIndex)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.scale = null;
      this.scaleValues = null;

      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
    }
  }, {
    key: 'getIndexInRange',
    value: function getIndexInRange(range, x) {
      var len = range.length;
      var start = 0;
      var end = len - 1;

      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);

        if (range[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }

      return x >= range[end] ? end : start;
    }
  }, {
    key: 'getIndex',
    value: function getIndex(_ref) {
      var startX = _ref.startX,
          endX = _ref.endX;

      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = this.getIndexInRange(this.scaleValues, min);
      var maxIndex = this.getIndexInRange(this.scaleValues, max);

      return {
        startIndex: minIndex,
        endIndex: maxIndex
      };
    }
  }, {
    key: 'getTextOfTick',
    value: function getTextOfTick(index) {
      var _props2 = this.props,
          data = _props2.data,
          tickFormatter = _props2.tickFormatter,
          dataKey = _props2.dataKey;

      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["h" /* getValueByDataKey */])(data[index], dataKey, index);

      return __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(tickFormatter) ? tickFormatter(text) : text;
    }
  }, {
    key: 'handleSlideDrag',
    value: function handleSlideDrag(e) {
      var _state = this.state,
          slideMoveStartX = _state.slideMoveStartX,
          startX = _state.startX,
          endX = _state.endX;
      var _props3 = this.props,
          x = _props3.x,
          width = _props3.width,
          travellerWidth = _props3.travellerWidth,
          startIndex = _props3.startIndex,
          endIndex = _props3.endIndex,
          onChange = _props3.onChange;

      var delta = e.pageX - slideMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });

      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }

      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: 'handleTravellerDragStart',
    value: function handleTravellerDragStart(id, e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
    }
  }, {
    key: 'handleTravellerMove',
    value: function handleTravellerMove(e) {
      var _setState;

      var _state2 = this.state,
          brushMoveStartX = _state2.brushMoveStartX,
          movingTravellerId = _state2.movingTravellerId;

      var prevValue = this.state[movingTravellerId];
      var _props4 = this.props,
          x = _props4.x,
          width = _props4.width,
          travellerWidth = _props4.travellerWidth,
          onChange = _props4.onChange;


      var params = { startX: this.state.startX, endX: this.state.endX };
      var delta = e.pageX - brushMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }

      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);

      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
        if (onChange) {
          onChange(newIndex);
        }
      });
    }
  }, {
    key: 'updateScale',
    value: function updateScale(props) {
      var _this3 = this;

      var data = props.data,
          startIndex = props.startIndex,
          endIndex = props.endIndex,
          x = props.x,
          width = props.width,
          travellerWidth = props.travellerWidth;


      if (data && data.length) {
        var len = data.length;
        this.scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["scalePoint"])().domain(__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, len)).range([x, x + width - travellerWidth]);
        this.scaleValues = this.scale.domain().map(function (entry) {
          return _this3.scale(entry);
        });
        this.state = {
          isTextActive: false,
          isSlideMoving: false,
          isTravellerMoving: false,
          startX: this.scale(startIndex),
          endX: this.scale(endIndex)
        };
      }
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground() {
      var _props5 = this.props,
          x = _props5.x,
          y = _props5.y,
          width = _props5.width,
          height = _props5.height,
          fill = _props5.fill,
          stroke = _props5.stroke;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: 'renderPanorama',
    value: function renderPanorama() {
      var _props6 = this.props,
          x = _props6.x,
          y = _props6.y,
          width = _props6.width,
          height = _props6.height,
          data = _props6.data,
          children = _props6.children,
          padding = _props6.padding;

      var chartElement = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].only(children);

      if (!chartElement) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: 'renderTraveller',
    value: function renderTraveller(startX, id) {
      var _props7 = this.props,
          y = _props7.y,
          travellerWidth = _props7.travellerWidth,
          height = _props7.height,
          stroke = _props7.stroke;

      var lineY = Math.floor(y + height / 2) - 1;
      var x = Math.max(startX, this.props.x);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        {
          className: 'recharts-brush-traveller',
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.travellerDragStartHandlers[id],
          onTouchStart: this.travellerDragStartHandlers[id],
          style: { cursor: 'col-resize' }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
          x: x,
          y: y,
          width: travellerWidth,
          height: height,
          fill: stroke,
          stroke: 'none'
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('line', {
          x1: x + 1,
          y1: lineY,
          x2: x + travellerWidth - 1,
          y2: lineY,
          fill: 'none',
          stroke: '#fff'
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('line', {
          x1: x + 1,
          y1: lineY + 2,
          x2: x + travellerWidth - 1,
          y2: lineY + 2,
          fill: 'none',
          stroke: '#fff'
        })
      );
    }
  }, {
    key: 'renderSlide',
    value: function renderSlide(startX, endX) {
      var _props8 = this.props,
          y = _props8.y,
          height = _props8.height,
          stroke = _props8.stroke;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        className: 'recharts-brush-slide',
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: { cursor: 'move' },
        stroke: 'none',
        fill: stroke,
        fillOpacity: 0.2,
        x: Math.min(startX, endX),
        y: y,
        width: Math.abs(endX - startX),
        height: height
      });
    }
  }, {
    key: 'renderText',
    value: function renderText() {
      var _props9 = this.props,
          startIndex = _props9.startIndex,
          endIndex = _props9.endIndex,
          y = _props9.y,
          height = _props9.height,
          travellerWidth = _props9.travellerWidth,
          stroke = _props9.stroke;
      var _state3 = this.state,
          startX = _state3.startX,
          endX = _state3.endX;

      var offset = 5;
      var style = {
        pointerEvents: 'none',
        fill: stroke
      };

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-brush-texts' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          {
            textAnchor: 'end',
            verticalAnchor: 'middle',
            style: style,
            x: Math.min(startX, endX) - offset,
            y: y + height / 2
          },
          this.getTextOfTick(startIndex)
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          {
            textAnchor: 'start',
            verticalAnchor: 'middle',
            style: style,
            x: Math.max(startX, endX) + travellerWidth + offset,
            y: y + height / 2
          },
          this.getTextOfTick(endIndex)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props10 = this.props,
          data = _props10.data,
          className = _props10.className,
          children = _props10.children;
      var _state4 = this.state,
          startX = _state4.startX,
          endX = _state4.endX,
          isTextActive = _state4.isTextActive,
          isSlideMoving = _state4.isSlideMoving,
          isTravellerMoving = _state4.isTravellerMoving;


      if (!data || !data.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-brush', className);
      var isPanoramic = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        {
          className: layerClass,
          onMouseMove: this.handleDrag,
          onMouseLeave: this.handleLeaveWrapper,
          onMouseUp: this.handleDragEnd,
          onTouchEnd: this.handleDragEnd,
          onTouchMove: this.handleTouchMove
        },
        this.renderBackground(),
        isPanoramic && this.renderPanorama(),
        this.renderSlide(startX, endX),
        this.renderTraveller(startX, 'startX'),
        this.renderTraveller(endX, 'endX'),
        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
      );
    }
  }]);

  return Brush;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Brush', _class2.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  travellerWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  padding: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  startIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  endIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  updateId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number])
}, _class2.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 40,
  travellerWidth: 5,
  fill: '#fff',
  stroke: '#666',
  padding: { top: 1, right: 1, bottom: 1, left: 1 }
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Brush);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Symbols__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__ = __webpack_require__(189);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of scatters
 */














var Scatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__["a" /* default */])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Scatter, _Component);

  function Scatter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["c" /* uniqueId */])('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scatter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var animationDuration = this.props.animationDuration;

      window.setTimeout(function () {
        return _this2.setState({ isAnimationFinished: true });
      }, animationDuration);
    }
  }, {
    key: 'renderSymbolItem',
    value: function renderSymbolItem(option, props) {
      var symbol = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        symbol = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        symbol = option(props);
      } else {
        symbol = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Symbols__["a" /* default */], _extends({}, props, { type: option }));
      }

      return symbol;
    }
  }, {
    key: 'renderSymbols',
    value: function renderSymbols() {
      var _this3 = this;

      var _props = this.props,
          points = _props.points,
          shape = _props.shape,
          activeShape = _props.activeShape,
          activeIndex = _props.activeIndex,
          animationBegin = _props.animationBegin,
          animationDuration = _props.animationDuration,
          isAnimationActive = _props.isAnimationActive,
          animationEasing = _props.animationEasing,
          animationId = _props.animationId;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);

      return points.map(function (entry, i) {
        var props = _extends({
          key: 'symbol-' + i
        }, baseProps, entry);
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-scatter-symbol'
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* filterEventsOfChild */])(_this3.props, entry, i), {
            key: 'symbol-' + i
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
            {
              from: { size: 0 },
              to: { size: props.size },
              duration: animationDuration,
              begin: animationBegin,
              isActive: isAnimationActive,
              key: animationId,
              easing: animationEasing
            },
            function (_ref2) {
              var size = _ref2.size;

              var finalProps = _extends({}, props, { size: size });

              return _this3.renderSymbolItem(activeIndex === i ? activeShape : shape, finalProps);
            }
          )
        );
      });
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      if (!this.state.isAnimationFinished) {
        return null;
      }

      var _props2 = this.props,
          points = _props2.points,
          xAxis = _props2.xAxis,
          yAxis = _props2.yAxis,
          children = _props2.children;

      var errorBarItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatterY(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.y,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["h" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      function dataPointFormatterX(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.x,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["h" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        var direction = item.props.direction;


        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(item, {
          key: i,
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
        });
      });
    }
  }, {
    key: 'renderLine',
    value: function renderLine() {
      var _props3 = this.props,
          points = _props3.points,
          line = _props3.line,
          lineType = _props3.lineType,
          lineJointType = _props3.lineJointType;

      var scatterProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(line);
      var linePoints = void 0,
          lineItem = void 0;

      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return { x: entry.cx, y: entry.cy };
        });
      }
      var lineProps = _extends({}, scatterProps, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps, {
        points: linePoints
      });

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(line)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(line, lineProps);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Curve__["a" /* default */], _extends({}, lineProps, { type: lineJointType }));
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
        lineItem
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          points = _props4.points,
          line = _props4.line,
          className = _props4.className,
          xAxis = _props4.xAxis,
          yAxis = _props4.yAxis,
          left = _props4.left,
          top = _props4.top,
          width = _props4.width,
          height = _props4.height;


      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-scatter', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        {
          className: layerClass,
          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
        },
        needClip ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + this.id },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        line && this.renderLine(),
        this.renderErrorBar(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { key: 'recharts-scatter-symbols' },
          this.renderSymbols()
        )
      );
    }
  }]);

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {

  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  zAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  line: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  lineType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['fitting', 'joint']),
  lineJointType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  legendType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

  activeIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  activeShape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  points: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
      y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
      z: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
    }),
    payload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
  })),

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',

  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
}, _temp2)) || _class) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Scatter);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Z Axis
 */




var ZAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ZAxis, _Component);

  function ZAxis() {
    _classCallCheck(this, ZAxis);

    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
  }

  _createClass(ZAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ZAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'ZAxis', _class2.propTypes = {
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of z-axis
  zAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The range of axis
  range: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
}, _class2.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ZAxis);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AreaChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_CartesianUtils__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__generateCategoricalChart__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cartesian_Area__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_AnimationDecorator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ComposedDataDecorator__ = __webpack_require__(227);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Area Chart
 */
















var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["h" /* getValueByDataKey */])(entry, axis.dataKey);

  return !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? axis.scale(value) : null;
};

var getBaseValue = function getBaseValue(props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["j" /* isNumber */])(baseValue)) {
    return baseValue;
  }

  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numberAxis.scale.domain();

  if (numberAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }
    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }
  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
};

/**
 * Compose the data of each area
 * @param {Object} props The props that are passed to the component
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {String} dataKey     The unique key of a group
 * @param {Array} stackedData If the area is stacked,
 * the stackedData is an array of min value and max value
 * @return {Array} Composed data
 */
var getComposedData = function getComposedData(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xTicks = _ref2.xTicks,
      yTicks = _ref2.yTicks,
      bandSize = _ref2.bandSize,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
  var hasStack = stackedData && stackedData.length;
  var baseValue = getBaseValue(props, xAxis, yAxis);
  var isRange = false;

  var points = data.map(function (entry, index) {
    var value = void 0;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    if (layout === 'horizontal') {
      return {
        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
        y: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value[1]) ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value[1]) ? null : xAxis.scale(value[1]),
      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });

  var baseLine = void 0;
  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      return {
        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return { points: points, baseLine: baseLine, layout: layout, isRange: isRange };
};

var AreaChart = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ComposedDataDecorator__["a" /* default */])({ getComposedData: getComposedData }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_AnimationDecorator__["a" /* default */])(_class = _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(AreaChart, _Component);

  function AreaChart() {
    _classCallCheck(this, AreaChart);

    return _possibleConstructorReturn(this, (AreaChart.__proto__ || Object.getPrototypeOf(AreaChart)).apply(this, arguments));
  }

  _createClass(AreaChart, [{
    key: 'renderCursor',
    value: function renderCursor(_ref3) {
      var offset = _ref3.offset;
      var _props = this.props,
          children = _props.children,
          isTooltipActive = _props.isTooltipActive,
          layout = _props.layout,
          activeTooltipIndex = _props.activeTooltipIndex,
          axisTicks = _props.axisTicks;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__["a" /* default */]);

      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
        return null;
      }

      var ticks = axisTicks;

      if (!ticks || !ticks[activeTooltipIndex]) {
        return null;
      }

      var start = ticks[activeTooltipIndex].coordinate;
      var x1 = layout === 'horizontal' ? start : offset.left;
      var y1 = layout === 'horizontal' ? offset.top : start;
      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
      var cursorProps = _extends({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["b" /* getPresentationAttributes */])(tooltipItem.props.cursor), {
        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(tooltipItem.props.cursor) ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(tooltipItem.props.cursor, cursorProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a" /* default */], _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
    }
  }, {
    key: 'renderActiveDot',
    value: function renderActiveDot(option, props, childIndex) {
      var dot = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Dot__["a" /* default */], props);
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_smooth___default.a,
        {
          from: 'scale(0)',
          to: 'scale(1)',
          duration: 400,
          key: 'dot-' + childIndex + '-' + props.pointType,
          attributeName: 'transform'
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { style: { transformOrigin: 'center center' } },
          dot
        )
      );
    }

    /**
     * Draw the main part of area chart
     * @param  {Array} items     React elements of Area
     * @param  {Object} xAxisMap The configuration of all x-axis
     * @param  {Object} yAxisMap The configuration of all y-axis
     * @param  {Object} offset   The offset of main part in the svg element
     * @param  {Array} allComposedData The array of pre-created composedData
     *                                 {points, basedLine, layout} for each item
     * @return {ReactComponent} The instances of Area
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items, xAxisMap, yAxisMap, offset, allComposedData) {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          layout = _props2.layout,
          isTooltipActive = _props2.isTooltipActive,
          activeTooltipIndex = _props2.activeTooltipIndex;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__["a" /* default */]);
      var hasDot = tooltipItem && isTooltipActive;
      var dotItems = [];
      var animationId = this.props.animationId;


      var areaItems = items.reduce(function (result, child, i) {
        var _child$props = child.props,
            dataKey = _child$props.dataKey,
            activeDot = _child$props.activeDot;

        var currentComposedData = allComposedData[i];
        var isRange = currentComposedData.isRange;

        var activePoint = currentComposedData.points && currentComposedData.points[activeTooltipIndex];
        var basePoint = isRange && currentComposedData.baseLine && currentComposedData.baseLine[activeTooltipIndex];

        if (hasDot && activeDot && activePoint) {
          var dotProps = _extends({
            index: activeTooltipIndex,
            dataKey: dataKey,
            animationId: animationId,
            cx: activePoint.x, cy: activePoint.y, r: 4,
            fill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_CartesianUtils__["j" /* getMainColorOfGraphicItem */])(child),
            strokeWidth: 2, stroke: '#fff',
            payload: activePoint.payload,
            value: activePoint.value,
            pointType: 'activePoint'
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["b" /* getPresentationAttributes */])(activeDot));

          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));

          if (basePoint) {
            dotItems.push(_this2.renderActiveDot(activeDot, _extends({}, dotProps, {
              cx: basePoint.x,
              cy: basePoint.y,
              pointType: 'basePoint'
            }), i));
          }
        }

        var area = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _extends({
          key: child.key || 'area-' + i
        }, currentComposedData, offset, {
          animationId: animationId,
          layout: layout,
          xAxis: xAxisMap[child.props.xAxisId],
          yAxis: yAxisMap[child.props.yAxisId]
        }));

        return [].concat(_toConsumableArray(result), [area]);
      }, []);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: 'recharts-area-chart-group' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-area-chart-shapes' },
          areaItems
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-area-chart-dots' },
          dotItems
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          isComposed = _props3.isComposed,
          graphicalItems = _props3.graphicalItems,
          xAxisMap = _props3.xAxisMap,
          yAxisMap = _props3.yAxisMap,
          offset = _props3.offset,
          allComposedData = _props3.allComposedData;


      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: 'recharts-area-graphical' },
        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset, allComposedData)
      );
    }
  }]);

  return AreaChart;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'AreaChart', _class2.propTypes = {
  allComposedData: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  axisTicks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  layout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  dataStartIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  dataEndIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  isTooltipActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  activeTooltipIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  xAxisMap: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  yAxisMap: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  graphicalItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  stackGroups: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  baseValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['dataMin', 'dataMax', 'auto'])]),
  // used internally
  isComposed: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
}, _class2.defaultProps = {
  baseValue: 'auto'
}, _temp)) || _class) || _class);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__generateCategoricalChart__["a" /* default */])(AreaChart, __WEBPACK_IMPORTED_MODULE_14__cartesian_Area__["a" /* default */]));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BarChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Rectangle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Cell__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cartesian_Bar__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ComposedDataDecorator__ = __webpack_require__(227);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Bar Chart
 */














var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      offset = _ref.offset,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }

  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["h" /* getValueByDataKey */])(entry, axis.dataKey);

  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};

var getBaseValue = function getBaseValue(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis;
  var layout = props.layout;

  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numberAxis.scale.domain();

  if (numberAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);

    if (min <= 0 && max >= 0) {
      return 0;
    }
    if (max < 0) {
      return max;
    }

    return min;
  }

  return domain[0];
};

/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */
var getComposedData = function getComposedData(_ref3) {
  var props = _ref3.props,
      item = _ref3.item,
      barPosition = _ref3.barPosition,
      bandSize = _ref3.bandSize,
      xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      xTicks = _ref3.xTicks,
      yTicks = _ref3.yTicks,
      stackedData = _ref3.stackedData;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;
  var _item$props = item.props,
      dataKey = _item$props.dataKey,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;

  var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["m" /* findPositionOfBar */])(barPosition, item);
  var stackedDomain = stackedData && layout === 'horizontal' ? yAxis.scale.domain() : xAxis.scale.domain();

  if (!pos) {
    return [];
  }

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
  var baseValue = getBaseValue({ props: props, xAxis: xAxis, yAxis: yAxis });
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Cell__["a" /* default */]);

  return data.map(function (entry, index) {
    var value = void 0,
        x = void 0,
        y = void 0,
        width = void 0,
        height = void 0;

    if (stackedData) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["n" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'horizontal') {
      x = getCategoryAxisCoordinate({
        axis: xAxis,
        ticks: xTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = yAxis.scale(value[1]);
      width = pos.size;
      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);

      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = Math.sign(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));

        y -= delta;
        height += delta;
      }
    } else {
      x = xAxis.scale(value[0]);
      y = getCategoryAxisCoordinate({
        axis: yAxis,
        ticks: yTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
      height = pos.size;

      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = Math.sign(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }

    return _extends({}, entry, {
      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
};

var BarChart = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ComposedDataDecorator__["a" /* default */])({ getComposedData: getComposedData }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__["a" /* default */])(_class = _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(BarChart, _Component);

  function BarChart() {
    _classCallCheck(this, BarChart);

    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
  }

  _createClass(BarChart, [{
    key: 'renderCursor',
    value: function renderCursor(_ref4) {
      var xAxisMap = _ref4.xAxisMap,
          yAxisMap = _ref4.yAxisMap,
          offset = _ref4.offset;
      var _props = this.props,
          children = _props.children,
          isTooltipActive = _props.isTooltipActive,
          layout = _props.layout,
          activeTooltipIndex = _props.activeTooltipIndex,
          axisTicks = _props.axisTicks;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__["a" /* default */]);
      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
        return null;
      }

      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
      var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["a" /* getAnyElementOfObject */])(axisMap);
      var ticks = axisTicks;

      if (!ticks || !ticks[activeTooltipIndex]) {
        return null;
      }

      var bandSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["b" /* getBandSizeOfAxis */])(axis);
      var start = ticks[activeTooltipIndex].coordinate;
      var cursorProps = _extends({
        fill: '#f1f1f1'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(tooltipItem.props.cursor), {
        x: layout === 'horizontal' ? start : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : start,
        width: layout === 'horizontal' ? bandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : bandSize
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(tooltipItem.props.cursor) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(tooltipItem.props.cursor, cursorProps) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Rectangle__["a" /* default */], _extends({}, cursorProps, { className: 'recharts-bar-cursor' }));
    }

    /**
     * Draw the main part of bar chart
     * @param  {Array} items     All the instance of Bar
     * @param  {Object} offset   The offset of main part in the svg element
     * @return {ReactComponent}  All the instances of Bar
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items, offset) {
      if (!items || !items.length) {
        return null;
      }

      var _props2 = this.props,
          layout = _props2.layout,
          xAxisMap = _props2.xAxisMap,
          yAxisMap = _props2.yAxisMap;
      var _props3 = this.props,
          animationId = _props3.animationId,
          allComposedData = _props3.allComposedData;


      return items.map(function (child, i) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, _extends({
          key: child.key || 'bar-' + i,
          layout: layout,
          animationId: animationId
        }, offset, {
          data: allComposedData[i],
          xAxis: xAxisMap[child.props.xAxisId],
          yAxis: yAxisMap[child.props.yAxisId]
        }));
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          isComposed = _props4.isComposed,
          graphicalItems = _props4.graphicalItems,
          xAxisMap = _props4.xAxisMap,
          yAxisMap = _props4.yAxisMap,
          offset = _props4.offset;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-bar-graphical' },
        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
        this.renderItems(graphicalItems, offset)
      );
    }
  }]);

  return BarChart;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'BarChart', _class2.propTypes = {
  allComposedData: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  axisTicks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  dataStartIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  dataEndIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  isTooltipActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  activeTooltipIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  xAxisMap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  yAxisMap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  graphicalItems: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  stackGroups: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  barCategoryGap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  barGap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  barSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  maxBarSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  // used internally
  isComposed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
}, _class2.defaultProps = {
  barCategoryGap: '10%',
  barGap: 4
}, _temp)) || _class) || _class);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__["a" /* default */])(BarChart, __WEBPACK_IMPORTED_MODULE_11__cartesian_Bar__["a" /* default */]));


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LineChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cartesian_Line__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ComposedDataDecorator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_DataUtils__ = __webpack_require__(32);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Line Chart
 */















var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, axis.dataKey);

  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(value) ? axis.scale(value) : null;
};
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */
var getComposedData = function getComposedData(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xTicks = _ref2.xTicks,
      yTicks = _ref2.yTicks,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);

  return data.map(function (entry, index) {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
        y: __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(value) ? null : xAxis.scale(value),
      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });
};

var LineChart = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ComposedDataDecorator__["a" /* default */])({ getComposedData: getComposedData }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_AnimationDecorator__["a" /* default */])(_class = _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(LineChart, _Component);

  function LineChart() {
    _classCallCheck(this, LineChart);

    return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
  }

  _createClass(LineChart, [{
    key: 'renderCursor',
    value: function renderCursor(_ref3) {
      var offset = _ref3.offset;
      var _props = this.props,
          children = _props.children,
          isTooltipActive = _props.isTooltipActive,
          layout = _props.layout,
          activeTooltipIndex = _props.activeTooltipIndex,
          axisTicks = _props.axisTicks;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_6__component_Tooltip__["a" /* default */]);

      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
        return null;
      }

      var ticks = axisTicks;

      if (!ticks || !ticks[activeTooltipIndex]) {
        return null;
      }

      var start = ticks[activeTooltipIndex].coordinate;
      var x1 = layout === 'horizontal' ? start : offset.left;
      var y1 = layout === 'horizontal' ? offset.top : start;
      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
      var cursorProps = _extends({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(tooltipItem.props.cursor), {
        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(tooltipItem.props.cursor) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(tooltipItem.props.cursor, cursorProps) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Curve__["a" /* default */], _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
    }
  }, {
    key: 'renderActiveDot',
    value: function renderActiveDot(option, props, childIndex) {
      var dot = void 0;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-line-active-dot' }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
        {
          from: 'scale(0)',
          to: 'scale(1)',
          duration: 400,
          key: 'dot-' + childIndex,
          attributeName: 'transform'
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
          { style: { transformOrigin: 'center center' } },
          dot
        )
      );
    }
    /**
     * Draw the main part of line chart
     * @param  {Array} items     All the instance of Line
     * @param  {Object} xAxisMap The configuration of all x-axes
     * @param  {Object} yAxisMap The configuration of all y-axes
     * @param  {Object} offset   The offset of main part in the svg element
     * @return {ReactComponent}  All the instances of Line
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items, xAxisMap, yAxisMap, offset) {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          layout = _props2.layout,
          isTooltipActive = _props2.isTooltipActive,
          activeTooltipIndex = _props2.activeTooltipIndex,
          animationId = _props2.animationId,
          allComposedData = _props2.allComposedData;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_6__component_Tooltip__["a" /* default */]);
      var hasDot = tooltipItem && isTooltipActive;
      var dotItems = [];

      var lineItems = items.map(function (child, i) {
        var _child$props = child.props,
            dataKey = _child$props.dataKey,
            stroke = _child$props.stroke,
            activeDot = _child$props.activeDot;

        var points = allComposedData[i];
        var activePoint = points[activeTooltipIndex];

        if (hasDot && activeDot && activePoint) {
          var dotProps = _extends({
            index: activeTooltipIndex,
            dataKey: dataKey,
            cx: activePoint.x, cy: activePoint.y, r: 4,
            fill: stroke, strokeWidth: 2, stroke: '#fff',
            payload: activePoint.payload,
            value: activePoint.value
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(activeDot));
          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, _extends({
          key: child.key || 'line-' + i
        }, offset, {
          layout: layout,
          points: points,
          animationId: animationId,
          xAxis: xAxisMap[child.props.xAxisId],
          yAxis: yAxisMap[child.props.yAxisId]
        }));
      }, this);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: 'recharts-line-chart-wrapper' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
          { className: 'recharts-line-chart' },
          lineItems
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
          { className: 'recharts-line-chart-dot' },
          dotItems
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          isComposed = _props3.isComposed,
          xAxisMap = _props3.xAxisMap,
          yAxisMap = _props3.yAxisMap,
          offset = _props3.offset,
          graphicalItems = _props3.graphicalItems;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: 'recharts-line-graphical' },
        !isComposed && this.renderCursor({ offset: offset }),
        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset)
      );
    }
  }]);

  return LineChart;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'LineChart', _class2.propTypes = {
  allComposedData: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  axisTicks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  dataStartIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  dataEndIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  isTooltipActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  activeTooltipIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  xAxisMap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  yAxisMap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  graphicalItems: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  // used internally
  isComposed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
}, _temp)) || _class) || _class);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__["a" /* default */])(LineChart, __WEBPACK_IMPORTED_MODULE_10__cartesian_Line__["a" /* default */]));

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Sector__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Curve__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_AnimationDecorator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_DataUtils__ = __webpack_require__(32);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render sectors of a pie
 */















var Pie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_AnimationDecorator__["a" /* default */])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Pie, _Component);

  function Pie() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["c" /* uniqueId */])('recharts-pie-'), _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pie, [{
    key: 'getDeltaAngle',
    value: function getDeltaAngle() {
      var _props = this.props,
          startAngle = _props.startAngle,
          endAngle = _props.endAngle;

      var sign = Math.sign(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

      return sign * deltaAngle;
    }
  }, {
    key: 'getSectors',
    value: function getSectors(data) {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          innerRadius = _props2.innerRadius,
          outerRadius = _props2.outerRadius,
          cornerRadius = _props2.cornerRadius,
          startAngle = _props2.startAngle,
          paddingAngle = _props2.paddingAngle,
          minAngle = _props2.minAngle,
          nameKey = _props2.nameKey,
          valueKey = _props2.valueKey;

      var len = data.length;
      var deltaAngle = this.getDeltaAngle();
      var absDeltaAngle = Math.abs(deltaAngle);
      var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
      var sum = data.reduce(function (result, entry) {
        return result + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, valueKey, 0);
      }, 0);

      var sectors = [];
      var prev = void 0;

      if (sum > 0) {
        sectors = data.map(function (entry, i) {
          var percent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, valueKey, 0) / sum;

          var tempStartAngle = void 0;

          if (i) {
            tempStartAngle = (deltaAngle < 0 ? prev.endAngle : prev.startAngle) + Math.sign(deltaAngle) * paddingAngle;
          } else {
            tempStartAngle = startAngle;
          }

          var tempEndAngle = tempStartAngle + Math.sign(deltaAngle) * (minAngle + percent * (absDeltaAngle - len * minAngle - totalPadingAngle));

          prev = _extends({
            percent: percent,
            cornerRadius: cornerRadius
          }, entry, {
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, nameKey),
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, valueKey),
            startAngle: deltaAngle < 0 ? tempStartAngle : tempEndAngle,
            endAngle: deltaAngle < 0 ? tempEndAngle : tempStartAngle,
            midAngle: (tempStartAngle + tempEndAngle) / 2
          });

          return prev;
        });
      }

      return sectors;
    }
  }, {
    key: 'getTextAnchor',
    value: function getTextAnchor(x, cx) {
      if (x > cx) {
        return 'start';
      } else if (x < cx) {
        return 'end';
      }

      return 'middle';
    }
  }, {
    key: 'isActiveIndex',
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;


      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: 'renderClipPath',
    value: function renderClipPath() {
      var _props3 = this.props,
          cx = _props3.cx,
          cy = _props3.cy,
          maxRadius = _props3.maxRadius,
          startAngle = _props3.startAngle,
          isAnimationActive = _props3.isAnimationActive,
          animationDuration = _props3.animationDuration,
          animationEasing = _props3.animationEasing,
          animationBegin = _props3.animationBegin,
          animationId = _props3.animationId;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'defs',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'clipPath',
          { id: this.id },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
            {
              easing: animationEasing,
              isActive: isAnimationActive,
              duration: animationDuration,
              key: animationId,
              animationBegin: animationBegin,
              onAnimationEnd: this.handleAnimationEnd,
              from: {
                endAngle: startAngle
              },
              to: {
                outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
                innerRadius: 0,
                endAngle: this.props.endAngle
              }
            },
            function (_ref2) {
              var outerRadius = _ref2.outerRadius,
                  innerRadius = _ref2.innerRadius,
                  endAngle = _ref2.endAngle;
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Sector__["a" /* default */], {
                cx: cx,
                cy: cy,
                outerRadius: outerRadius,
                innerRadius: innerRadius,
                startAngle: startAngle,
                endAngle: endAngle
              });
            }
          )
        )
      );
    }
  }, {
    key: 'renderLabelLineItem',
    value: function renderLabelLineItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a" /* default */], _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      }
      var label = value;
      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        label = option(props);
        if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(label)) {
          return label;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__component_Text__["a" /* default */],
        _extends({}, props, {
          alignmentBaseline: 'middle',
          className: 'recharts-pie-label-text'
        }),
        label
      );
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels(sectors) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _props4 = this.props,
          label = _props4.label,
          labelLine = _props4.labelLine,
          valueKey = _props4.valueKey;

      var pieProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(label);
      var customLabelLineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(labelLine);
      var offsetRadius = label && label.offsetRadius || 20;

      var labels = sectors.map(function (entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__["a" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = _extends({}, pieProps, entry, {
          stroke: 'none'
        }, customLabelProps, {
          index: i,
          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = _extends({}, pieProps, entry, {
          fill: 'none',
          stroke: entry.fill
        }, customLabelLineProps, {
          points: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__["a" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
        });

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
          { key: 'label-' + i },
          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
          _this2.renderLabelItem(label, labelProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["h" /* getValueByDataKey */])(entry, valueKey))
        );
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
        { className: 'recharts-pie-labels' },
        labels
      );
    }
  }, {
    key: 'renderSectorItem',
    value: function renderSectorItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        return option(props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Sector__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Sector__["a" /* default */], props);
    }
  }, {
    key: 'renderSectors',
    value: function renderSectors(sectors) {
      var _this3 = this;

      var activeShape = this.props.activeShape;


      return sectors.map(function (entry, i) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-pie-sector'
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["l" /* filterEventsOfChild */])(_this3.props, entry, i), {
            key: 'sector-' + i
          }),
          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          data = _props5.data,
          composedData = _props5.composedData,
          className = _props5.className,
          label = _props5.label,
          cx = _props5.cx,
          cy = _props5.cy,
          innerRadius = _props5.innerRadius,
          outerRadius = _props5.outerRadius;

      var pieData = composedData || data;

      if (!pieData || !pieData.length || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["j" /* isNumber */])(cx) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["j" /* isNumber */])(cy) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["j" /* isNumber */])(innerRadius) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["j" /* isNumber */])(outerRadius)) {
        return null;
      }

      var sectors = this.getSectors(pieData);
      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-pie', className);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
        { className: layerClass },
        this.renderClipPath(),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'g',
          { clipPath: 'url(#' + this.id + ')' },
          this.renderSectors(sectors)
        ),
        label && this.renderLabels(sectors)
      );
    }
  }]);

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  cx: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  cy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  startAngle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  paddingAngle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  cornerRadius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  nameKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  valueKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  composedData: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  minAngle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  legendType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  maxRadius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,

  labelLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    offsetRadius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  activeShape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number)]),

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
}), _class2.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  // The abscissa of pole
  cx: '50%',
  // The ordinate of pole
  cy: '50%',
  // The start angle of first sector
  startAngle: 0,
  // The direction of drawing sectors
  endAngle: 360,
  // The inner radius of sectors
  innerRadius: 0,
  // The outer radius of sectors
  outerRadius: '80%',
  paddingAngle: 0,
  nameKey: 'name',
  valueKey: 'value',
  labelLine: true,
  data: [],
  minAngle: 0,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _temp2)) || _class) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Pie);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Polygon__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(124);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Axis of radial direction
 */











var RADIAN = Math.PI / 180;
var eps = 1e-5;

var PolarAngleAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarAngleAxis, _Component);

  function PolarAngleAxis() {
    _classCallCheck(this, PolarAngleAxis);

    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
  }

  _createClass(PolarAngleAxis, [{
    key: 'getTickLineCoord',


    /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */
    value: function getTickLineCoord(data) {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          radius = _props.radius,
          orientation = _props.orientation,
          tickLine = _props.tickLine;

      var tickLineSize = tickLine && tickLine.size || 8;
      var p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, data.angle);
      var p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.angle);

      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
    }
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */

  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;

      var cos = Math.cos(-data.angle * RADIAN);
      var textAnchor = void 0;

      if (cos > eps) {
        textAnchor = orientation === 'outer' ? 'start' : 'end';
      } else if (cos < -eps) {
        textAnchor = orientation === 'outer' ? 'end' : 'start';
      } else {
        textAnchor = 'middle';
      }

      return textAnchor;
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          radius = _props2.radius,
          axisLine = _props2.axisLine,
          axisLineType = _props2.axisLineType;

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(axisLine));

      if (axisLineType === 'circle') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Dot__["a" /* default */], _extends({
          className: 'recharts-polar-angle-axis-line'
        }, props, {
          cx: cx,
          cy: cy,
          r: radius
        }));
      }
      var ticks = this.props.ticks;

      var points = ticks.map(function (entry) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, entry.angle);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Polygon__["a" /* default */], _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-polar-angle-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }
  }, {
    key: 'renderTicks',
    value: function renderTicks() {
      var _this2 = this;

      var _props3 = this.props,
          ticks = _props3.ticks,
          tick = _props3.tick,
          tickLine = _props3.tickLine,
          tickFormatter = _props3.tickFormatter,
          stroke = _props3.stroke;

      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(tick);
      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(tickLine));

      var items = ticks.map(function (entry, i) {
        var lineCoord = _this2.getTickLineCoord(entry);
        var textAnchor = _this2.getTickTextAnchor(entry);
        var tickProps = _extends({
          textAnchor: textAnchor
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, {
          index: i, payload: entry,
          x: lineCoord.x2, y: lineCoord.y2
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-polar-angle-axis-tick',
            key: 'tick-' + i
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, i)),
          tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({
            className: 'recharts-polar-angle-axis-tick-line'
          }, tickLineProps, lineCoord)),
          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
        );
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-polar-angle-axis-ticks' },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          ticks = _props4.ticks,
          radius = _props4.radius,
          axisLine = _props4.axisLine;


      if (radius <= 0 || !ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-polar-angle-axis' },
        axisLine && this.renderAxisLine(),
        this.renderTicks()
      );
    }
  }]);

  return PolarAngleAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'PolarAngleAxis', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  hide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  axisLineType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['polygon', 'circle']),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })),
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['inner', 'outer']),
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tick: true,
  hide: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarAngleAxis);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Polar Grid
 */






var PolarGrid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarGrid, _Component);

  function PolarGrid() {
    _classCallCheck(this, PolarGrid);

    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
  }

  _createClass(PolarGrid, [{
    key: 'getPolygonPath',
    value: function getPolygonPath(radius) {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          polarAngles = _props.polarAngles;


      var path = '';

      polarAngles.forEach(function (angle, i) {
        var point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, angle);

        if (i) {
          path += 'L ' + point.x + ',' + point.y;
        } else {
          path += 'M ' + point.x + ',' + point.y;
        }
      });
      path += 'Z';

      return path;
    }
    /**
     * Draw axis of radial line
     * @return {[type]} The lines
     */

  }, {
    key: 'renderPolarAngles',
    value: function renderPolarAngles() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          innerRadius = _props2.innerRadius,
          outerRadius = _props2.outerRadius,
          polarAngles = _props2.polarAngles;


      if (!polarAngles || !polarAngles.length) {
        return null;
      }
      var props = _extends({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid-angle' },
        polarAngles.map(function (entry, i) {
          var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, entry);
          var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, entry);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, props, {
            key: 'line-' + i,
            x1: start.x,
            y1: start.y,
            x2: end.x,
            y2: end.y
          }));
        })
      );
    }
    /**
     * Draw concentric circles
     * @param {Number} radius The radius of circle
     * @param {Number} index  The index of circle
     * @param {Object} extraProps Extra props
     * @return {ReactElement} circle
     */

  }, {
    key: 'renderConcentricCircle',
    value: function renderConcentricCircle(radius, index, extraProps) {
      var _props3 = this.props,
          cx = _props3.cx,
          cy = _props3.cy;

      var props = _extends({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({}, props, {
        className: 'recharts-polar-grid-concentric-circle',
        key: 'circle-' + index,
        cx: cx,
        cy: cy,
        r: radius
      }));
    }
    /**
     * Draw concentric polygons
     * @param {Number} radius     The radius of polygon
     * @param {Number} index      The index of polygon
     * @param {Object} extraProps Extra props
     * @return {ReactElement} polygon
     */

  }, {
    key: 'renderConcentricPolygon',
    value: function renderConcentricPolygon(radius, index, extraProps) {
      var props = _extends({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, props, {
        className: 'recharts-polar-grid-concentric-polygon',
        key: 'path-' + index,
        d: this.getPolygonPath(radius)
      }));
    }

    /**
     * Draw concentric axis
     * @return {ReactElement} Concentric axis
     * @todo Optimize the name
     */

  }, {
    key: 'renderConcentricPath',
    value: function renderConcentricPath() {
      var _this2 = this;

      var _props4 = this.props,
          polarRadius = _props4.polarRadius,
          gridType = _props4.gridType;


      if (!polarRadius || !polarRadius.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid-concentric' },
        polarRadius.map(function (entry, i) {
          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var outerRadius = this.props.outerRadius;


      if (outerRadius <= 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid' },
        this.renderPolarAngles(),
        this.renderConcentricPath()
      );
    }
  }]);

  return PolarGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  polarAngles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  polarRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  gridType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['polygon', 'circle'])
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarGrid);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_maxBy__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Text__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(32);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview The axis of polar coordinate system
 */










var PolarRadiusAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarRadiusAxis, _Component);

  function PolarRadiusAxis() {
    _classCallCheck(this, PolarRadiusAxis);

    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
  }

  _createClass(PolarRadiusAxis, [{
    key: 'getTickValueCoord',


    /**
     * Calculate the coordinate of tick
     * @param  {Object} radius The data of a simple tick
     * @return {Object} (x, y)
     */
    value: function getTickValueCoord(_ref) {
      var radius = _ref.radius;
      var _props = this.props,
          angle = _props.angle,
          cx = _props.cx,
          cy = _props.cy;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, angle);
    }
  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;

      var textAnchor = void 0;

      switch (orientation) {
        case 'left':
          textAnchor = 'end';
          break;
        case 'right':
          textAnchor = 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          angle = _props2.angle,
          ticks = _props2.ticks,
          axisLine = _props2.axisLine,
          others = _objectWithoutProperties(_props2, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);

      var extent = ticks.reduce(function (result, entry) {
        return [Math.min(result[0], entry.radius), Math.max(result[1], entry.radius)];
      }, [Infinity, -Infinity]);
      var point0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, extent[0], angle);
      var point1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, extent[1], angle);

      var props = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(others), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(axisLine), {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-polar-radius-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }
  }, {
    key: 'renderTicks',
    value: function renderTicks() {
      var _this2 = this;

      var _props3 = this.props,
          ticks = _props3.ticks,
          tick = _props3.tick,
          angle = _props3.angle,
          tickFormatter = _props3.tickFormatter,
          stroke = _props3.stroke,
          others = _objectWithoutProperties(_props3, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);

      var textAnchor = this.getTickTextAnchor();
      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(others);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* getPresentationAttributes */])(tick);

      var items = ticks.map(function (entry, i) {
        var coord = _this2.getTickValueCoord(entry);
        var tickProps = _extends({
          textAnchor: textAnchor,
          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, {
          index: i
        }, coord, {
          payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-polar-radius-axis-tick',
            key: 'tick-' + i
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, i)),
          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
        );
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: 'recharts-polar-radius-axis-ticks' },
        items
      );
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var label = this.props.label;

      var _props4 = this.props,
          ticks = _props4.ticks,
          angle = _props4.angle,
          stroke = _props4.stroke,
          others = _objectWithoutProperties(_props4, ['ticks', 'angle', 'stroke']);

      var maxRadiusTick = __WEBPACK_IMPORTED_MODULE_0_lodash_maxBy___default()(ticks, function (entry) {
        return entry.radius || 0;
      });
      var radius = maxRadiusTick.radius || 0;
      var coord = this.getTickValueCoord({ radius: radius + 10 });
      var props = _extends({}, others, {
        stroke: 'none',
        fill: stroke
      }, coord, {
        textAnchor: 'middle',
        transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
      });

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(label)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(label, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
        return label(props);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["k" /* isNumOrStr */])(label)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-polar-radius-axis-label' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */],
            props,
            label
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          ticks = _props5.ticks,
          axisLine = _props5.axisLine,
          tick = _props5.tick;


      if (!ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: 'recharts-polar-radius-axis' },
        axisLine && this.renderAxisLine(),
        tick && this.renderTicks(),
        this.renderLabel()
      );
    }
  }]);

  return PolarRadiusAxis;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'PolarRadiusAxis', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  cx: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  angle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  tickCount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    radius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.value
  })),
  orientation: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['left', 'right', 'middle']),
  axisLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  domain: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  scale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  domain: [0, 'auto'],
  allowDataOverflow: false,
  scale: 'auto'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarRadiusAxis);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Polygon__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Dot__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Text__ = __webpack_require__(82);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Radar
 */












var Radar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Radar, _Component);

  function Radar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Radar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;


      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    }, _this.handleMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;


      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Radar, [{
    key: 'renderPolygon',
    value: function renderPolygon() {
      /* eslint-disable no-unused-vars */
      var _props = this.props,
          shape = _props.shape,
          points = _props.points,
          animationDuration = _props.animationDuration,
          animationEasing = _props.animationEasing,
          animationBegin = _props.animationBegin,
          isAnimationActive = _props.isAnimationActive,
          animationId = _props.animationId,
          dataKey = _props.dataKey,
          className = _props.className,
          others = _objectWithoutProperties(_props, ['shape', 'points', 'animationDuration', 'animationEasing', 'animationBegin', 'isAnimationActive', 'animationId', 'dataKey', 'className']);
      /* eslint-enable no-unused-vars */

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(shape)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(shape, _extends({}, others, { points: points }));
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(shape)) {
        return shape(this.props);
      }

      var point = points[0];
      var transformPoints = points.map(function (p) {
        return { x: p.x - point.cx, y: p.y - point.cy };
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: 'recharts-radar-polygon', transform: 'translate(' + point.cx + ', ' + point.cy + ')' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
          {
            from: 'scale(0)',
            to: 'scale(1)',
            attributeName: 'transform',
            isActive: isAnimationActive,
            begin: animationBegin,
            easing: animationEasing,
            duration: animationDuration,
            key: animationId
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Polygon__["a" /* default */], _extends({
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
            points: transformPoints
          }))
        )
      );
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      var labelItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        labelItem = option(props);
      } else {
        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__component_Text__["a" /* default */],
          _extends({
            key: props.key
          }, props, {
            className: 'recharts-radar-label'
          }),
          value
        );
      }

      return labelItem;
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels() {
      var _this2 = this;

      var _props2 = this.props,
          points = _props2.points,
          label = _props2.label;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(label);

      var labels = points.map(function (entry, i) {
        var labelProps = _extends({
          textAnchor: 'middle'
        }, baseProps, {
          stroke: 'none',
          fill: baseProps && baseProps.stroke || '#666'
        }, customLabelProps, entry, {
          index: i,
          key: 'label-' + i,
          payload: entry
        });

        return _this2.renderLabelItem(label, labelProps, entry.value);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: 'recharts-radar-labels' },
        labels
      );
    }
  }, {
    key: 'renderDotItem',
    value: function renderDotItem(option, props) {
      var dotItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-radar-dot' }));
      }

      return dotItem;
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var _this3 = this;

      var _props3 = this.props,
          dot = _props3.dot,
          points = _props3.points;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* getPresentationAttributes */])(dot);

      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, baseProps, customDotProps, {
          cx: entry.x,
          cy: entry.y,
          index: i,
          playload: entry
        });

        return _this3.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: 'recharts-radar-dots' },
        dots
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          className = _props4.className,
          points = _props4.points,
          label = _props4.label,
          dot = _props4.dot;


      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-radar', className);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: layerClass },
        this.renderPolygon(),
        label && this.renderLabels(),
        dot && this.renderDots()
      );
    }
  }]);

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired,

  points: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    payload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  dot: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  legendType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["m" /* LEGEND_TYPES */]),

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  dot: false,
  label: false,
  legendType: 'rect',
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Radar);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Sector__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DataUtils__ = __webpack_require__(32);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of radial bar
 */













var RADIAN = Math.PI / 180;

var RadialBar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(RadialBar, _Component);

  function RadialBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: false
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadialBar, [{
    key: 'getDeltaAngle',
    value: function getDeltaAngle() {
      var _props = this.props,
          startAngle = _props.startAngle,
          endAngle = _props.endAngle;

      var sign = Math.sign(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

      return sign * deltaAngle;
    }
  }, {
    key: 'getSectors',
    value: function getSectors() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          startAngle = _props2.startAngle,
          data = _props2.data,
          minAngle = _props2.minAngle,
          maxAngle = _props2.maxAngle;

      var maxValue = Math.max.apply(null, data.map(function (entry) {
        return Math.abs(entry.value);
      }));
      var absMinAngle = Math.abs(minAngle);
      var absMaxAngle = Math.abs(maxAngle);
      var deltaAngle = this.getDeltaAngle();
      var gapAngle = Math.min(Math.abs(absMaxAngle - absMinAngle), 360);

      var sectors = data.map(function (entry) {
        var value = entry.value;
        var tempEndAngle = maxValue === 0 ? startAngle : startAngle + Math.sign(value * deltaAngle) * (absMinAngle + gapAngle * Math.abs(entry.value) / maxValue);

        return _extends({}, entry, {
          cx: cx, cy: cy,
          startAngle: startAngle,
          endAngle: tempEndAngle,
          payload: entry
        });
      });

      return sectors;
    }
  }, {
    key: 'getLabelPathArc',
    value: function getLabelPathArc(data, labelContent, style) {
      var label = this.props.label;

      var labelProps = __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(label) ? label.props : label;
      var offsetRadius = labelProps.offsetRadius || 2;
      var orientation = labelProps.orientation || 'inner';
      var cx = data.cx,
          cy = data.cy,
          innerRadius = data.innerRadius,
          outerRadius = data.outerRadius,
          startAngle = data.startAngle,
          endAngle = data.endAngle;

      var clockWise = this.getDeltaAngle() < 0 && data.value > 0;
      var radius = clockWise ? innerRadius + offsetRadius : Math.max(outerRadius - offsetRadius, 0);

      if (radius <= 0) {
        return '';
      }

      var labelSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])(labelContent, style);
      var deltaAngle = labelSize.width / (radius * RADIAN);
      var tempStartAngle = void 0,
          tempEndAngle = void 0;

      if (clockWise) {
        tempStartAngle = orientation === 'inner' ? Math.min(endAngle + deltaAngle, startAngle) : endAngle;
        tempEndAngle = tempStartAngle - deltaAngle;
      } else {
        tempStartAngle = orientation === 'inner' ? Math.max(endAngle - deltaAngle, startAngle) : endAngle;
        tempEndAngle = tempStartAngle + deltaAngle;
      }

      var startPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, tempStartAngle);
      var endPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, tempEndAngle);

      return 'M' + startPoint.x + ',' + startPoint.y + '\n            A' + radius + ',' + radius + ',0,\n            ' + (deltaAngle >= 180 ? 1 : 0) + ',\n            ' + (clockWise ? 1 : 0) + ',\n            ' + endPoint.x + ',' + endPoint.y;
    }
  }, {
    key: 'renderSectorShape',
    value: function renderSectorShape(shape, props) {
      var sectorShape = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(shape)) {
        sectorShape = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(shape, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(shape)) {
        sectorShape = shape(props);
      } else {
        sectorShape = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Sector__["a" /* default */], props);
      }

      return sectorShape;
    }
  }, {
    key: 'renderSectors',
    value: function renderSectors(sectors) {
      var _this2 = this;

      var _props3 = this.props,
          shape = _props3.shape,
          activeShape = _props3.activeShape,
          activeIndex = _props3.activeIndex,
          cornerRadius = _props3.cornerRadius;
      var _props4 = this.props,
          animationEasing = _props4.animationEasing,
          animationDuration = _props4.animationDuration,
          animationBegin = _props4.animationBegin,
          isAnimationActive = _props4.isAnimationActive;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);

      return sectors.map(function (entry, i) {
        var startAngle = entry.startAngle,
            endAngle = entry.endAngle;


        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
          {
            from: { angle: startAngle },
            to: { angle: endAngle },
            begin: animationBegin,
            isActive: isAnimationActive,
            duration: animationDuration,
            easing: animationEasing,
            shouldReAnimate: true,
            key: 'aniamte-' + i,
            onAnimationStart: _this2.handleAnimationStart,
            onAnimationEnd: _this2.handleAnimationEnd
          },
          function (_ref2) {
            var angle = _ref2.angle;

            var props = _extends({}, baseProps, {
              cornerRadius: cornerRadius
            }, entry, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, i), {
              endAngle: angle,
              key: 'sector-' + i,
              className: 'recharts-radial-bar-sector'
            });

            return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
          }
        );
      });
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground(sectors) {
      var _this3 = this;

      var _props5 = this.props,
          startAngle = _props5.startAngle,
          endAngle = _props5.endAngle,
          background = _props5.background,
          cornerRadius = _props5.cornerRadius;

      var backgroundProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(background);

      return sectors.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            rest = _objectWithoutProperties(entry, ['value']);

        var props = _extends({
          cornerRadius: cornerRadius
        }, rest, {
          fill: '#eee'
        }, backgroundProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["l" /* filterEventsOfChild */])(_this3.props, entry, i), {
          startAngle: startAngle,
          endAngle: endAngle,
          index: i,
          key: 'sector-' + i,
          className: 'recharts-radial-bar-background-sector'
        });

        return _this3.renderSectorShape(background, props);
      });
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      var labelItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        labelItem = option(props);
      } else {
        var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["c" /* uniqueId */])('recharts-defs-');
        var filteredProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(props);
        var path = this.getLabelPathArc(props, value, filteredProps);

        labelItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'text',
          _extends({}, filteredProps, { key: props.key, className: 'recharts-radial-bar-label' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'defs',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { id: id, d: path })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'textPath',
            { xlinkHref: '#' + id },
            value
          )
        );
      }

      return labelItem;
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels(sectors) {
      var _this4 = this;

      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var label = this.props.label;


      return sectors.map(function (entry, i) {
        var props = _extends({
          fontSize: 10
        }, entry, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(label), {
          index: i,
          key: 'label-' + i
        });

        return _this4.renderLabelItem(label, props, entry.value);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          data = _props6.data,
          className = _props6.className,
          background = _props6.background,
          label = _props6.label;


      if (!data || !data.length) {
        return null;
      }

      var sectors = this.getSectors();
      var layerClass = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-area', className);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: layerClass },
        background && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-radial-bar-background' },
          this.renderBackground(sectors)
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-radial-bar-sectors' },
          this.renderSectors(sectors)
        ),
        label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          { className: 'recharts-radial-bar-labels' },
          this.renderLabels(sectors)
        )
      );
    }
  }]);

  return RadialBar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  activeShape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

  cornerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  maxAngle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  minAngle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    innerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    outerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.value
  })),
  legendType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["m" /* LEGEND_TYPES */]),
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  background: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
}), _class2.defaultProps = {
  startAngle: 180,
  endAngle: 0,
  maxAngle: 135,
  minAngle: 0,
  legendType: 'rect',
  data: [],
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (RadialBar);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cross
 */







var Cross = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Cross, _Component);

  function Cross() {
    _classCallCheck(this, Cross);

    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
  }

  _createClass(Cross, [{
    key: 'getPath',
    value: function getPath(x, y, width, height, top, left) {
      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          x = _props.x,
          y = _props.y,
          width = _props.width,
          height = _props.height,
          top = _props.top,
          left = _props.left,
          className = _props.className;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(y) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(height) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(top) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["j" /* isNumber */])(left)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-cross', className),
        d: this.getPath(x, y, width, height, top, left)
      }));
    }
  }]);

  return Cross;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}), _class2.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Cross);

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(2321)
  , createDesc = __webpack_require__(2322);
module.exports = __webpack_require__(432) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergePair = mergePair;

exports.default = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.length ? args.reduce(mergePair) : null;
};

/* eslint no-void: 0 */
var toString = Object.prototype.toString;
var OBJECT = "[object Object]";
var ARRAY = "[object Array]";

function mergePair(a, b) {
  if (a === void 0) {
    return b;
  }
  if (b === void 0) {
    return a;
  }

  var aType = toString.call(a);
  var bType = toString.call(b);
  if (aType === ARRAY) {
    return a.concat(b);
  }
  if (bType === ARRAY) {
    return [a].concat(b);
  }
  if (aType !== OBJECT || bType !== OBJECT) {
    return b;
  }
  return Object.keys(b).reduce(function (memo, key) {
    memo[key] = mergePair(a[key], b[key]);
    return memo;
  }, a);
}
//# sourceMappingURL=merge.js.map

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(2370);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(120)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(438);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(2167);

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(2376);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1595);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(61);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(2);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _routes = __webpack_require__(1594);

var _routes2 = _interopRequireDefault(_routes);

var _reduxThunk = __webpack_require__(2362);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(1592);

var _reactRouterRedux = __webpack_require__(827);

__webpack_require__(1978);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_reducers.rootReducer, (0, _redux.applyMiddleware)(_reduxThunk2.default));
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var childRoutes = (0, _routes2.default)(store);

// Create an enhanced history that syncs navigation events with the store

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(_reactRouter.Router, { children: childRoutes, history: history })
), document.getElementById('root'));

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOCUS_DISABLED_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FocusStyleManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_interactionMode__ = __webpack_require__(881);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

var FOCUS_DISABLED_CLASS = "pt-focus-disabled";
var fakeFocusEngine = {
    isActive: function () { return true; },
    start: function () { return true; },
    stop: function () { return true; },
};
var focusEngine = typeof document !== "undefined"
    ? new __WEBPACK_IMPORTED_MODULE_0__common_interactionMode__["a" /* InteractionModeEngine */](document.documentElement, FOCUS_DISABLED_CLASS)
    : fakeFocusEngine;
var FocusStyleManager = {
    alwaysShowFocus: function () { return focusEngine.stop(); },
    isActive: function () { return focusEngine.isActive(); },
    onlyShowFocusOnTabs: function () { return focusEngine.start(); },
};


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusStyleManager__ = __webpack_require__(878);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__focusStyleManager__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__focusStyleManager__["b"]; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Colors; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var Colors = {
    BLACK: "#10161A",
    BLUE1: "#0E5A8A",
    BLUE2: "#106BA3",
    BLUE3: "#137CBD",
    BLUE4: "#2B95D6",
    BLUE5: "#48AFF0",
    COBALT1: "#1F4B99",
    COBALT2: "#2458B3",
    COBALT3: "#2965CC",
    COBALT4: "#4580E6",
    COBALT5: "#669EFF",
    DARK_GRAY1: "#182026",
    DARK_GRAY2: "#202B33",
    DARK_GRAY3: "#293742",
    DARK_GRAY4: "#30404D",
    DARK_GRAY5: "#394B59",
    FOREST1: "#1D7324",
    FOREST2: "#238C2C",
    FOREST3: "#29A634",
    FOREST4: "#43BF4D",
    FOREST5: "#62D96B",
    GOLD1: "#A67908",
    GOLD2: "#BF8C0A",
    GOLD3: "#D99E0B",
    GOLD4: "#F2B824",
    GOLD5: "#FFC940",
    GRAY1: "#5C7080",
    GRAY2: "#738694",
    GRAY3: "#8A9BA8",
    GRAY4: "#A7B6C2",
    GRAY5: "#BFCCD6",
    GREEN1: "#0A6640",
    GREEN2: "#0D8050",
    GREEN3: "#0F9960",
    GREEN4: "#15B371",
    GREEN5: "#3DCC91",
    INDIGO1: "#5642A6",
    INDIGO2: "#634DBF",
    INDIGO3: "#7157D9",
    INDIGO4: "#9179F2",
    INDIGO5: "#AD99FF",
    LIGHT_GRAY1: "#CED9E0",
    LIGHT_GRAY2: "#D8E1E8",
    LIGHT_GRAY3: "#E1E8ED",
    LIGHT_GRAY4: "#EBF1F5",
    LIGHT_GRAY5: "#F5F8FA",
    LIME1: "#728C23",
    LIME2: "#87A629",
    LIME3: "#9BBF30",
    LIME4: "#B6D94C",
    LIME5: "#D1F26D",
    ORANGE1: "#A66321",
    ORANGE2: "#BF7326",
    ORANGE3: "#D9822B",
    ORANGE4: "#F29D49",
    ORANGE5: "#FFB366",
    RED1: "#A82A2A",
    RED2: "#C23030",
    RED3: "#DB3737",
    RED4: "#F55656",
    RED5: "#FF7373",
    ROSE1: "#A82255",
    ROSE2: "#C22762",
    ROSE3: "#DB2C6F",
    ROSE4: "#F5498B",
    ROSE5: "#FF66A1",
    SEPIA1: "#63411E",
    SEPIA2: "#7D5125",
    SEPIA3: "#96622D",
    SEPIA4: "#B07B46",
    SEPIA5: "#C99765",
    TURQUOISE1: "#008075",
    TURQUOISE2: "#00998C",
    TURQUOISE3: "#00B3A4",
    TURQUOISE4: "#14CCBD",
    TURQUOISE5: "#2EE6D6",
    VERMILION1: "#9E2B0E",
    VERMILION2: "#B83211",
    VERMILION3: "#D13913",
    VERMILION4: "#EB532D",
    VERMILION5: "#FF6E4A",
    VIOLET1: "#5C255C",
    VIOLET2: "#752F75",
    VIOLET3: "#8F398F",
    VIOLET4: "#A854A8",
    VIOLET5: "#C274C2",
    WHITE: "#FFFFFF",
};


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InteractionModeEngine; });
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var TAB_KEY_CODE = 9;
/* istanbul ignore next */
/**
 * A nifty little class that maintains event handlers to add a class to the container element
 * when entering "mouse mode" (on a `mousedown` event) and remove it when entering "keyboard mode"
 * (on a `tab` key `keydown` event).
 */
var InteractionModeEngine = (function () {
    // tslint:disable-next-line:no-constructor-vars
    function InteractionModeEngine(container, className) {
        var _this = this;
        this.container = container;
        this.className = className;
        this.isRunning = false;
        this.handleKeyDown = function (e) {
            if (e.which === TAB_KEY_CODE) {
                _this.reset();
                _this.container.addEventListener("mousedown", _this.handleMouseDown);
            }
        };
        this.handleMouseDown = function () {
            _this.reset();
            _this.container.classList.add(_this.className);
            _this.container.addEventListener("keydown", _this.handleKeyDown);
        };
    }
    /** Returns whether the engine is currently running. */
    InteractionModeEngine.prototype.isActive = function () {
        return this.isRunning;
    };
    /** Enable behavior which applies the given className when in mouse mode. */
    InteractionModeEngine.prototype.start = function () {
        this.container.addEventListener("mousedown", this.handleMouseDown);
        this.isRunning = true;
    };
    /** Disable interaction mode behavior and remove className from container. */
    InteractionModeEngine.prototype.stop = function () {
        this.reset();
        this.isRunning = false;
    };
    InteractionModeEngine.prototype.reset = function () {
        this.container.classList.remove(this.className);
        this.container.removeEventListener("keydown", this.handleKeyDown);
        this.container.removeEventListener("mousedown", this.handleMouseDown);
    };
    return InteractionModeEngine;
}());



/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arraysEqual;
/* harmony export (immutable) */ __webpack_exports__["b"] = shallowCompareKeys;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepCompareKeys;
/* harmony export (immutable) */ __webpack_exports__["d"] = getShallowUnequalKeyValues;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDeepUnequalKeyValues;
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
/**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */
function arraysEqual(arrA, arrB, compare) {
    if (compare === void 0) { compare = function (a, b) { return a === b; }; }
    // treat `null` and `undefined` as the same
    if (arrA == null && arrB == null) {
        return true;
    }
    else if (arrA == null || arrB == null || arrA.length !== arrB.length) {
        return false;
    }
    else {
        return arrA.every(function (a, i) { return compare(a, arrB[i]); });
    }
}
/**
 * Shallow comparison between objects. If `keys` is provided, just that subset
 * of keys will be compared; otherwise, all keys will be compared.
 */
function shallowCompareKeys(objA, objB, keys) {
    // treat `null` and `undefined` as the same
    if (objA == null && objB == null) {
        return true;
    }
    else if (objA == null || objB == null) {
        return false;
    }
    else if (Array.isArray(objA) || Array.isArray(objB)) {
        return false;
    }
    else if (keys != null) {
        return _shallowCompareKeys(objA, objB, keys);
    }
    else {
        // shallowly compare all keys from both objects
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        return (_shallowCompareKeys(objA, objB, { include: keysA }) && _shallowCompareKeys(objA, objB, { include: keysB }));
    }
}
/**
 * Deep comparison between objects. If `keys` is provided, just that subset of
 * keys will be compared; otherwise, all keys will be compared.
 */
function deepCompareKeys(objA, objB, keys) {
    if (objA === objB) {
        return true;
    }
    else if (objA == null && objB == null) {
        // treat `null` and `undefined` as the same
        return true;
    }
    else if (objA == null || objB == null) {
        return false;
    }
    else if (Array.isArray(objA) || Array.isArray(objB)) {
        return arraysEqual(objA, objB, deepCompareKeys);
    }
    else if (_isSimplePrimitiveType(objA) || _isSimplePrimitiveType(objB)) {
        return objA === objB;
    }
    else if (keys != null) {
        return _deepCompareKeys(objA, objB, keys);
    }
    else if (objA.constructor !== objB.constructor) {
        return false;
    }
    else {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA == null || keysB == null) {
            return false;
        }
        if (keysA.length === 0 && keysB.length === 0) {
            return true;
        }
        return arraysEqual(keysA, keysB) && _deepCompareKeys(objA, objB, keysA);
    }
}
/**
 * Returns a descriptive object for each key whose values are shallowly unequal
 * between two provided objects. Useful for debugging shouldComponentUpdate.
 */
function getShallowUnequalKeyValues(objA, objB, keys) {
    // default param values let null values pass through, so we have to take
    // this more thorough approach
    var definedObjA = objA == null ? {} : objA;
    var definedObjB = objB == null ? {} : objB;
    var filteredKeys = _filterKeys(definedObjA, definedObjB, keys == null ? { exclude: [] } : keys);
    return _getUnequalKeyValues(definedObjA, definedObjB, filteredKeys, function (a, b, key) {
        return shallowCompareKeys(a, b, { include: [key] });
    });
}
/**
 * Returns a descriptive object for each key whose values are deeply unequal
 * between two provided objects. Useful for debugging shouldComponentUpdate.
 */
function getDeepUnequalKeyValues(objA, objB, keys) {
    if (objA === void 0) { objA = {}; }
    if (objB === void 0) { objB = {}; }
    var filteredKeys = keys == null ? _unionKeys(objA, objB) : keys;
    return _getUnequalKeyValues(objA, objB, filteredKeys, function (a, b, key) {
        return deepCompareKeys(a, b, [key]);
    });
}
// Private helpers
// ===============
/**
 * Partial shallow comparison between objects using the given list of keys.
 */
function _shallowCompareKeys(objA, objB, keys) {
    return _filterKeys(objA, objB, keys).every(function (key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
    });
}
/**
 * Partial deep comparison between objects using the given list of keys.
 */
function _deepCompareKeys(objA, objB, keys) {
    return keys.every(function (key) {
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && deepCompareKeys(objA[key], objB[key]);
    });
}
function _isSimplePrimitiveType(value) {
    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
}
function _filterKeys(objA, objB, keys) {
    if (_isWhitelist(keys)) {
        return keys.include;
    }
    else {
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        // merge keys from both objects into a big set for quick access
        var keySet_1 = _arrayToObject(keysA.concat(keysB));
        // delete blacklisted keys from the key set
        keys.exclude.forEach(function (key) { return delete keySet_1[key]; });
        // return the remaining keys as an array
        return Object.keys(keySet_1);
    }
}
function _isWhitelist(keys) {
    return keys != null && keys.include != null;
}
function _arrayToObject(arr) {
    return arr.reduce(function (obj, element) {
        obj[element] = true;
        return obj;
    }, {});
}
function _getUnequalKeyValues(objA, objB, keys, compareFn) {
    var unequalKeys = keys.filter(function (key) { return !compareFn(objA, objB, key); });
    var unequalKeyValues = unequalKeys.map(function (key) { return ({
        key: key,
        valueA: objA[key],
        valueB: objB[key],
    }); });
    return unequalKeyValues;
}
function _unionKeys(objA, objB) {
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    var concatKeys = keysA.concat(keysB);
    var keySet = _arrayToObject(concatKeys);
    return Object.keys(keySet);
}


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Browser; });
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
var browser = {
    isEdge: !!userAgent.match(/Edge/),
    isInternetExplorer: !!userAgent.match(/Trident/) || !!userAgent.match(/rv:11/),
    isWebkit: !!userAgent.match(/AppleWebKit/),
};
var Browser = {
    isEdge: function () { return browser.isEdge; },
    isInternetExplorer: function () { return browser.isInternetExplorer; },
    isWebkit: function () { return browser.isWebkit; },
};


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser__ = __webpack_require__(883);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__browser__["a"]; });
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_buttons__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialog_dialog__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_icon__ = __webpack_require__(127);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








var Alert = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Alert, _super);
    function Alert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Alert.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, iconName = _a.iconName, intent = _a.intent, isOpen = _a.isOpen, confirmButtonText = _a.confirmButtonText, onConfirm = _a.onConfirm, style = _a.style;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__dialog_dialog__["a" /* Dialog */], { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* Classes */].ALERT, className), isOpen: isOpen, style: style },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__common__["a" /* Classes */].ALERT_BODY },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__icon_icon__["a" /* Icon */], { iconName: iconName, iconSize: "inherit", intent: __WEBPACK_IMPORTED_MODULE_3__common__["h" /* Intent */].DANGER }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__common__["a" /* Classes */].ALERT_CONTENTS }, children)),
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__common__["a" /* Classes */].ALERT_FOOTER },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_buttons__["a" /* Button */], { intent: intent, text: confirmButtonText, onClick: onConfirm }),
                this.maybeRenderSecondaryAction())));
    };
    Alert.prototype.validateProps = function (props) {
        if ((props.cancelButtonText != null && props.onCancel == null) ||
            (props.cancelButtonText == null && props.onCancel != null)) {
            console.warn(__WEBPACK_IMPORTED_MODULE_4__common_errors__["J" /* ALERT_WARN_CANCEL_PROPS */]);
        }
    };
    Alert.prototype.maybeRenderSecondaryAction = function () {
        if (this.props.cancelButtonText != null) {
            return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__button_buttons__["a" /* Button */], { text: this.props.cancelButtonText, onClick: this.props.onCancel });
        }
        return undefined;
    };
    Alert.defaultProps = {
        confirmButtonText: "OK",
        isOpen: false,
        onConfirm: null,
    };
    Alert.displayName = "Blueprint.Alert";
    return Alert;
}(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* AbstractComponent */]));



/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



var Breadcrumb = function (breadcrumbProps) {
    var classes = __WEBPACK_IMPORTED_MODULE_0_classnames__(__WEBPACK_IMPORTED_MODULE_2__common_classes__["BREADCRUMB"], (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_2__common_classes__["DISABLED"]] = breadcrumbProps.disabled,
        _a), breadcrumbProps.className);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: classes, href: breadcrumbProps.href, onClick: breadcrumbProps.disabled ? null : breadcrumbProps.onClick, tabIndex: breadcrumbProps.disabled ? null : 0, target: breadcrumbProps.target }, breadcrumbProps.text));
    var _a;
};


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_icon__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__spinner_spinner__ = __webpack_require__(302);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








var AbstractButton = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](AbstractButton, _super);
    function AbstractButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false,
        };
        _this.refHandlers = {
            button: function (ref) {
                _this.buttonRef = ref;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["safeInvoke"])(_this.props.elementRef, ref);
            },
        };
        _this.currentKeyDown = null;
        // we're casting as `any` to get around a somewhat opaque safeInvoke error
        // that "Type argument candidate 'KeyboardEvent<T>' is not a valid type
        // argument because it is not a supertype of candidate
        // 'KeyboardEvent<HTMLElement>'."
        _this.handleKeyDown = function (e) {
            if (isKeyboardClick(e.which)) {
                e.preventDefault();
                if (e.which !== _this.currentKeyDown) {
                    _this.setState({ isActive: true });
                }
            }
            _this.currentKeyDown = e.which;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["safeInvoke"])(_this.props.onKeyDown, e);
        };
        _this.handleKeyUp = function (e) {
            if (isKeyboardClick(e.which)) {
                _this.setState({ isActive: false });
                _this.buttonRef.click();
            }
            _this.currentKeyDown = null;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["safeInvoke"])(_this.props.onKeyUp, e);
        };
        return _this;
    }
    AbstractButton.prototype.getCommonButtonProps = function () {
        var disabled = this.props.disabled || this.props.loading;
        var className = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["BUTTON"], (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_3__common_classes__["ACTIVE"]] = this.state.isActive || this.props.active,
            _a[__WEBPACK_IMPORTED_MODULE_3__common_classes__["DISABLED"]] = disabled,
            _a[__WEBPACK_IMPORTED_MODULE_3__common_classes__["LOADING"]] = this.props.loading,
            _a), __WEBPACK_IMPORTED_MODULE_3__common_classes__["iconClass"](this.props.iconName), __WEBPACK_IMPORTED_MODULE_3__common_classes__["intentClass"](this.props.intent), this.props.className);
        return {
            className: className,
            disabled: disabled,
            onClick: disabled ? undefined : this.props.onClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            ref: this.refHandlers.button,
        };
        var _a;
    };
    AbstractButton.prototype.renderChildren = function () {
        var _a = this.props, loading = _a.loading, rightIconName = _a.rightIconName, text = _a.text;
        var children = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(this.props.children, function (child, index) {
            if (child === "") {
                // render as undefined to avoid extra space after icon
                return undefined;
            }
            else if (typeof child === "string") {
                // must wrap string children in spans so loading prop can hide them
                return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { key: "text-" + index }, child);
            }
            return child;
        });
        return [
            loading ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__spinner_spinner__["a" /* Spinner */], { className: "pt-small pt-button-spinner", key: "spinner" }) : undefined,
            text != null ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { key: "text" }, text) : undefined
        ].concat(children, [
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icon_icon__["a" /* Icon */], { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["ALIGN_RIGHT"], iconName: rightIconName, key: "icon" }),
        ]);
    };
    return AbstractButton;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

function isKeyboardClick(keyCode) {
    return keyCode === __WEBPACK_IMPORTED_MODULE_4__common_keys__["ENTER"] || keyCode === __WEBPACK_IMPORTED_MODULE_4__common_keys__["SPACE"];
}


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var ButtonGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ButtonGroup, _super);
    function ButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonGroup.prototype.render = function () {
        var _a = this.props, className = _a.className, fill = _a.fill, minimal = _a.minimal, large = _a.large, vertical = _a.vertical, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "fill", "minimal", "large", "vertical"]);
        var buttonGroupClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["BUTTON_GROUP"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["FILL"]] = fill,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["MINIMAL"]] = minimal,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["LARGE"]] = large,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["VERTICAL"]] = vertical,
            _b), className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, htmlProps, { className: buttonGroupClasses }), this.props.children));
        var _b;
    };
    ButtonGroup.displayName = "Blueprint.ButtonGroup";
    ButtonGroup = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], ButtonGroup);
    return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Callout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Callout = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Callout, _super);
    function Callout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Callout.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, iconName = _a.iconName, intent = _a.intent, title = _a.title, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "children", "iconName", "intent", "title"]);
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].CALLOUT, __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].intentClass(intent), __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].iconClass(iconName), className);
        var maybeTitle = title === undefined ? undefined : __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("h5", { className: __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].CALLOUT_TITLE }, title);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: classes }, htmlProps),
            maybeTitle,
            children));
    };
    Callout = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Callout);
    return Callout;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Elevation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Elevation;
(function (Elevation) {
    Elevation[Elevation["ZERO"] = 0] = "ZERO";
    Elevation[Elevation["ONE"] = 1] = "ONE";
    Elevation[Elevation["TWO"] = 2] = "TWO";
    Elevation[Elevation["THREE"] = 3] = "THREE";
    Elevation[Elevation["FOUR"] = 4] = "FOUR";
})(Elevation || (Elevation = {}));
var ELEVATION_CLASSES = [
    __WEBPACK_IMPORTED_MODULE_4__common_classes__["ELEVATION_0"],
    __WEBPACK_IMPORTED_MODULE_4__common_classes__["ELEVATION_1"],
    __WEBPACK_IMPORTED_MODULE_4__common_classes__["ELEVATION_2"],
    __WEBPACK_IMPORTED_MODULE_4__common_classes__["ELEVATION_3"],
    __WEBPACK_IMPORTED_MODULE_4__common_classes__["ELEVATION_4"],
];
var Card = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: this.getClassName(), onClick: this.props.onClick }, this.props.children));
    };
    Card.prototype.getClassName = function () {
        var _a = this.props, elevation = _a.elevation, interactive = _a.interactive, className = _a.className;
        return __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["CARD"], (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["INTERACTIVE"]] = interactive, _b), ELEVATION_CLASSES[elevation], className);
        var _b;
    };
    Card.displayName = "Blueprint.Card";
    Card.defaultProps = {
        elevation: Elevation.ZERO,
        interactive: false,
    };
    Card = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Card);
    return Card;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapseFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CollapsibleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CollapsibleListFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu_menu__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menu_menuItem__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__popover_popover__ = __webpack_require__(165);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var CollapseFrom;
(function (CollapseFrom) {
    CollapseFrom[CollapseFrom["START"] = 0] = "START";
    CollapseFrom[CollapseFrom["END"] = 1] = "END";
})(CollapseFrom || (CollapseFrom = {}));
var CollapsibleList = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](CollapsibleList, _super);
    function CollapsibleList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsibleList.prototype.render = function () {
        var _this = this;
        var collapseFrom = this.props.collapseFrom;
        var childrenLength = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].count(this.props.children);
        var _a = this.partitionChildren(), visibleChildren = _a[0], collapsedChildren = _a[1];
        var visibleItems = visibleChildren.map(function (child, index) {
            var absoluteIndex = collapseFrom === CollapseFrom.START ? childrenLength - 1 - index : index;
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: _this.props.visibleItemClassName, key: absoluteIndex }, _this.props.renderVisibleItem(child.props, absoluteIndex)));
        });
        if (collapseFrom === CollapseFrom.START) {
            // reverse START list so separators appear before items
            visibleItems.reverse();
        }
        // construct dropdown menu for collapsed items
        var collapsedPopover;
        if (collapsedChildren.length > 0) {
            var position = collapseFrom === CollapseFrom.END ? __WEBPACK_IMPORTED_MODULE_5__common_position__["a" /* Position */].BOTTOM_RIGHT : __WEBPACK_IMPORTED_MODULE_5__common_position__["a" /* Position */].BOTTOM_LEFT;
            collapsedPopover = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: this.props.visibleItemClassName },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__popover_popover__["b" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ content: __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__menu_menu__["a" /* Menu */], null, collapsedChildren), position: position }, this.props.dropdownProps), this.props.dropdownTarget)));
        }
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["COLLAPSIBLE_LIST"], this.props.className) },
            collapseFrom === CollapseFrom.START ? collapsedPopover : null,
            visibleItems,
            collapseFrom === CollapseFrom.END ? collapsedPopover : null));
    };
    // splits the list of children into two arrays: visible and collapsed
    CollapsibleList.prototype.partitionChildren = function () {
        if (this.props.children == null) {
            return [[], []];
        }
        var childrenArray = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(this.props.children, function (child, index) {
            if (child.type !== __WEBPACK_IMPORTED_MODULE_7__menu_menuItem__["a" /* MenuItem */]) {
                throw new Error(__WEBPACK_IMPORTED_MODULE_4__common_errors__["I" /* COLLAPSIBLE_LIST_INVALID_CHILD */]);
            }
            return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, { key: "visible-" + index });
        });
        if (this.props.collapseFrom === CollapseFrom.START) {
            // reverse START list so we can always slice visible items from the front of the list
            childrenArray.reverse();
        }
        var visibleItemCount = this.props.visibleItemCount;
        return [childrenArray.slice(0, visibleItemCount), childrenArray.slice(visibleItemCount)];
    };
    CollapsibleList.displayName = "Blueprint.CollapsibleList";
    CollapsibleList.defaultProps = {
        collapseFrom: CollapseFrom.START,
        dropdownTarget: null,
        renderVisibleItem: null,
        visibleItemCount: 3,
    };
    return CollapsibleList;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

var CollapsibleListFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](CollapsibleList);


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextMenuTarget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_isDarkTheme__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contextMenu__ = __webpack_require__(445);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






function ContextMenuTarget(constructor) {
    var _a = constructor.prototype, render = _a.render, renderContextMenu = _a.renderContextMenu, onContextMenuClose = _a.onContextMenuClose;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils__["isFunction"])(renderContextMenu)) {
        console.warn(__WEBPACK_IMPORTED_MODULE_2__common_errors__["H" /* CONTEXTMENU_WARN_DECORATOR_NO_METHOD */]);
    }
    // patching classes like this requires preserving function context
    // tslint:disable-next-line only-arrow-functions
    constructor.prototype.render = function () {
        var _this = this;
        /* tslint:disable:no-invalid-this */
        var element = render.call(this);
        if (element == null) {
            // always return `element` in case caller is distinguishing between `null` and `undefined`
            return element;
        }
        var oldOnContextMenu = element.props.onContextMenu;
        var onContextMenu = function (e) {
            // support nested menus (inner menu target would have called preventDefault())
            if (e.defaultPrevented) {
                return;
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils__["isFunction"])(_this.renderContextMenu)) {
                var menu = _this.renderContextMenu(e);
                if (menu != null) {
                    var htmlElement = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this);
                    var darkTheme = htmlElement != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_isDarkTheme__["a" /* isDarkTheme */])(htmlElement);
                    e.preventDefault();
                    __WEBPACK_IMPORTED_MODULE_5__contextMenu__["show"](menu, { left: e.clientX, top: e.clientY }, onContextMenuClose, darkTheme);
                }
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils__["safeInvoke"])(oldOnContextMenu, e);
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](element, { onContextMenu: onContextMenu });
        /* tslint:enable:no-invalid-this */
    };
}


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditableText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditableTextFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__compatibility__ = __webpack_require__(884);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */









var BUFFER_WIDTH_EDGE = 5;
var BUFFER_WIDTH_IE = 30;
var EditableText = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](EditableText, _super);
    function EditableText(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refHandlers = {
            content: function (spanElement) {
                _this.valueElement = spanElement;
            },
            input: function (input) {
                if (input != null) {
                    input.focus();
                    var length_1 = input.value.length;
                    input.setSelectionRange(_this.props.selectAllOnFocus ? 0 : length_1, length_1);
                    if (!_this.props.selectAllOnFocus) {
                        input.scrollLeft = input.scrollWidth;
                    }
                }
            },
        };
        _this.cancelEditing = function () {
            var _a = _this.state, lastValue = _a.lastValue, value = _a.value;
            _this.setState({ isEditing: false, value: lastValue });
            if (value !== lastValue) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.onChange, lastValue);
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.onCancel, lastValue);
        };
        _this.toggleEditing = function () {
            if (_this.state.isEditing) {
                var value = _this.state.value;
                _this.setState({ isEditing: false, lastValue: value });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.onConfirm, value);
            }
            else if (!_this.props.disabled) {
                _this.setState({ isEditing: true });
            }
        };
        _this.handleFocus = function () {
            if (!_this.props.disabled) {
                _this.setState({ isEditing: true });
            }
        };
        _this.handleTextChange = function (event) {
            var value = event.target.value;
            // state value should be updated only when uncontrolled
            if (_this.props.value == null) {
                _this.setState({ value: value });
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(_this.props.onChange, value);
        };
        _this.handleKeyEvent = function (event) {
            var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, which = event.which;
            if (which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ESCAPE"]) {
                _this.cancelEditing();
                return;
            }
            var hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
            if (which === __WEBPACK_IMPORTED_MODULE_6__common_keys__["ENTER"]) {
                // prevent IE11 from full screening with alt + enter
                // shift + enter adds a newline by default
                if (altKey || shiftKey) {
                    event.preventDefault();
                }
                if (_this.props.confirmOnEnterKey && _this.props.multiline) {
                    if (event.target != null && hasModifierKey) {
                        insertAtCaret(event.target, "\n");
                        _this.handleTextChange(event);
                    }
                    else {
                        _this.toggleEditing();
                    }
                }
                else if (!_this.props.multiline || hasModifierKey) {
                    _this.toggleEditing();
                }
            }
        };
        var value = props.value == null ? props.defaultValue : props.value;
        _this.state = {
            inputHeight: 0,
            inputWidth: 0,
            isEditing: props.isEditing === true && props.disabled === false,
            lastValue: value,
            value: value,
        };
        return _this;
    }
    EditableText.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, multiline = _a.multiline;
        var value = this.props.value == null ? this.state.value : this.props.value;
        var hasValue = value != null && value !== "";
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["EDITABLE_TEXT"], __WEBPACK_IMPORTED_MODULE_5__common_classes__["intentClass"](this.props.intent), (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["DISABLED"]] = disabled,
            _b["pt-editable-editing"] = this.state.isEditing,
            _b["pt-editable-placeholder"] = !hasValue,
            _b["pt-multiline"] = multiline,
            _b), this.props.className);
        var contentStyle;
        if (multiline) {
            // set height only in multiline mode when not editing
            // otherwise we're measuring this element to determine appropriate height of text
            contentStyle = { height: !this.state.isEditing ? this.state.inputHeight : null };
        }
        else {
            // minWidth only applies in single line mode (multiline == width 100%)
            contentStyle = {
                height: this.state.inputHeight,
                lineHeight: this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
                minWidth: this.props.minWidth,
            };
        }
        // make enclosing div focusable when not editing, so it can still be tabbed to focus
        // (when editing, input itself is focusable so div doesn't need to be)
        var tabIndex = this.state.isEditing || disabled ? null : 0;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes, onFocus: this.handleFocus, tabIndex: tabIndex },
            this.maybeRenderInput(value),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: "pt-editable-content", ref: this.refHandlers.content, style: contentStyle }, hasValue ? value : this.props.placeholder)));
        var _b;
    };
    EditableText.prototype.componentDidMount = function () {
        this.updateInputDimensions();
    };
    EditableText.prototype.componentDidUpdate = function (_, prevState) {
        if (this.state.isEditing && !prevState.isEditing) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"])(this.props.onEdit);
        }
        this.updateInputDimensions();
    };
    EditableText.prototype.componentWillReceiveProps = function (nextProps) {
        var state = {};
        if (nextProps.value != null) {
            state.value = nextProps.value;
        }
        if (nextProps.isEditing != null) {
            state.isEditing = nextProps.isEditing;
        }
        if (nextProps.disabled || (nextProps.disabled == null && this.props.disabled)) {
            state.isEditing = false;
        }
        this.setState(state);
    };
    EditableText.prototype.maybeRenderInput = function (value) {
        var _a = this.props, maxLength = _a.maxLength, multiline = _a.multiline;
        if (!this.state.isEditing) {
            return undefined;
        }
        var props = {
            className: "pt-editable-input",
            maxLength: maxLength,
            onBlur: this.toggleEditing,
            onChange: this.handleTextChange,
            onKeyDown: this.handleKeyEvent,
            ref: this.refHandlers.input,
            style: {
                height: this.state.inputHeight,
                lineHeight: !multiline && this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
                width: multiline ? "100%" : this.state.inputWidth,
            },
            value: value,
        };
        return multiline ? __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("textarea", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, props)) : __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ type: "text" }, props));
    };
    EditableText.prototype.updateInputDimensions = function () {
        if (this.valueElement != null) {
            var _a = this.props, maxLines = _a.maxLines, minLines = _a.minLines, minWidth = _a.minWidth, multiline = _a.multiline;
            var _b = this.valueElement, parentElement_1 = _b.parentElement, textContent = _b.textContent;
            var _c = this.valueElement, scrollHeight_1 = _c.scrollHeight, scrollWidth = _c.scrollWidth;
            var lineHeight = getLineHeight(this.valueElement);
            // add one line to computed <span> height if text ends in newline
            // because <span> collapses that trailing whitespace but <textarea> shows it
            if (multiline && this.state.isEditing && /\n$/.test(textContent)) {
                scrollHeight_1 += lineHeight;
            }
            if (lineHeight > 0) {
                // line height could be 0 if the isNaN block from getLineHeight kicks in
                scrollHeight_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils__["clamp"])(scrollHeight_1, minLines * lineHeight, maxLines * lineHeight);
            }
            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
            scrollHeight_1 = Math.max(scrollHeight_1, getFontSize(this.valueElement) + 1, getLineHeight(parentElement_1));
            // IE11 & Edge needs a small buffer so text does not shift prior to resizing
            if (__WEBPACK_IMPORTED_MODULE_8__compatibility__["a" /* Browser */].isEdge()) {
                scrollWidth += BUFFER_WIDTH_EDGE;
            }
            else if (__WEBPACK_IMPORTED_MODULE_8__compatibility__["a" /* Browser */].isInternetExplorer()) {
                scrollWidth += BUFFER_WIDTH_IE;
            }
            this.setState({
                inputHeight: scrollHeight_1,
                inputWidth: Math.max(scrollWidth, minWidth),
            });
            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
            if (multiline && this.state.isEditing) {
                this.setTimeout(function () { return (parentElement_1.style.height = scrollHeight_1 + "px"); });
            }
        }
    };
    EditableText.defaultProps = {
        confirmOnEnterKey: false,
        defaultValue: "",
        disabled: false,
        maxLines: Infinity,
        minLines: 1,
        minWidth: 80,
        multiline: false,
        placeholder: "Click to Edit",
    };
    EditableText = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], EditableText);
    return EditableText;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));

function getFontSize(element) {
    var fontSize = getComputedStyle(element).fontSize;
    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
}
function getLineHeight(element) {
    // getComputedStyle() => 18.0001px => 18
    var lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
    // this check will be true if line-height is a keyword like "normal"
    if (isNaN(lineHeight)) {
        // @see http://stackoverflow.com/a/18430767/6342931
        var line = document.createElement("span");
        line.innerHTML = "<br>";
        element.appendChild(line);
        var singleLineHeight = element.offsetHeight;
        line.innerHTML = "<br><br>";
        var doubleLineHeight = element.offsetHeight;
        element.removeChild(line);
        // this can return 0 in edge cases
        lineHeight = doubleLineHeight - singleLineHeight;
    }
    return lineHeight;
}
function insertAtCaret(el, text) {
    var selectionEnd = el.selectionEnd, selectionStart = el.selectionStart, value = el.value;
    if (selectionStart >= 0) {
        var before_1 = value.substring(0, selectionStart);
        var after_1 = value.substring(selectionEnd, value.length);
        var len = text.length;
        el.value = "" + before_1 + text + after_1;
        el.selectionStart = selectionStart + len;
        el.selectionEnd = selectionStart + len;
    }
}
var EditableTextFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](EditableText);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ControlGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ControlGroupFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var ControlGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ControlGroup, _super);
    function ControlGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, fill = _a.fill, vertical = _a.vertical, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["children", "className", "fill", "vertical"]);
        var rootClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["CONTROL_GROUP"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["FILL"]] = fill,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["VERTICAL"]] = vertical,
            _b), className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, htmlProps, { className: rootClasses }), children));
        var _b;
    };
    ControlGroup.displayName = "Blueprint.ControlGroup";
    ControlGroup = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], ControlGroup);
    return ControlGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var ControlGroupFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](ControlGroup);


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FileUploadFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






// TODO: write tests (ignoring for now to get a build passing quickly)
/* istanbul ignore next */
var FileUpload = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputChange = function (e) {
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onInputChange, e);
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.inputProps.onChange, e);
        };
        return _this;
    }
    FileUpload.prototype.render = function () {
        var _a = this.props, className = _a.className, fill = _a.fill, disabled = _a.disabled, inputProps = _a.inputProps, onInputChange = _a.onInputChange, large = _a.large, text = _a.text, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "fill", "disabled", "inputProps", "onInputChange", "large", "text"]);
        var rootClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["FILE_UPLOAD"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["DISABLED"]] = disabled,
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["FILL"]] = fill,
            _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["LARGE"]] = large,
            _b), className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("label", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, htmlProps, { className: rootClasses }),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, inputProps, { onChange: this.handleInputChange, type: "file", disabled: disabled })),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_5__common_classes__["FILE_UPLOAD_INPUT"] }, text)));
        var _b;
    };
    FileUpload.displayName = "Blueprint.FileUpload";
    FileUpload.defaultProps = {
        inputProps: {},
        text: "Choose file...",
    };
    FileUpload = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], FileUpload);
    return FileUpload;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var FileUploadFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](FileUpload);


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var FormGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](FormGroup, _super);
    function FormGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroup_1 = FormGroup;
    FormGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, label = _a.label, labelFor = _a.labelFor;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: this.getClassName() },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("label", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["LABEL"], htmlFor: labelFor },
                label,
                this.maybeRenderRequiredLabel()),
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["FORM_CONTENT"] },
                children,
                this.maybeRenderHelperText())));
    };
    FormGroup.prototype.getClassName = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, inline = _a.inline, intent = _a.intent;
        return __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["FORM_GROUP"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["DISABLED"]] = disabled,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["INLINE"]] = inline,
            _b), className);
        var _b;
    };
    FormGroup.prototype.maybeRenderRequiredLabel = function () {
        var requiredLabel = this.props.requiredLabel;
        return requiredLabel === true ? FormGroup_1.DEFAULT_REQUIRED_CONTENT : requiredLabel;
    };
    FormGroup.prototype.maybeRenderHelperText = function () {
        var helperText = this.props.helperText;
        if (!helperText) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["FORM_HELPER_TEXT"] }, helperText);
    };
    /**
     * Element used to render `required` message when a boolean value is provided for that prop.
     * Modifying the value of this property will change the default globally in your app.
     *
     * Defaults to `<span class="pt-text-muted">(required)</span>`.
     */
    FormGroup.DEFAULT_REQUIRED_CONTENT = __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["TEXT_MUTED"] }, "(required)");
    FormGroup = FormGroup_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], FormGroup);
    return FormGroup;
    var FormGroup_1;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LabelFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var Label = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, helperText = _a.helperText, text = _a.text, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["children", "className", "disabled", "helperText", "text"]);
        var rootClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["LABEL"], (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["DISABLED"]] = disabled,
            _b), className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, htmlProps, { className: rootClasses }),
            text,
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TEXT_MUTED"]) }, helperText),
            children));
        var _b;
    };
    Label.displayName = "Blueprint.Label";
    Label = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Label);
    return Label;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var LabelFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Label);


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumericInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NumericInputFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button_buttons__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inputGroup__ = __webpack_require__(448);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








var IncrementDirection;
(function (IncrementDirection) {
    IncrementDirection[IncrementDirection["DOWN"] = -1] = "DOWN";
    IncrementDirection[IncrementDirection["UP"] = 1] = "UP";
})(IncrementDirection || (IncrementDirection = {}));
var NumericInput = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NumericInput, _super);
    function NumericInput(props, context) {
        var _this = _super.call(this, props, context) || this;
        // updating these flags need not trigger re-renders, so don't include them in this.state.
        _this.didPasteEventJustOccur = false;
        _this.shouldSelectAfterUpdate = false;
        _this.inputRef = function (input) {
            _this.inputElement = input;
        };
        // Callbacks - Buttons
        // ===================
        _this.handleDecrementButtonClick = function (e) {
            var delta = _this.getIncrementDelta(IncrementDirection.DOWN, e.shiftKey, e.altKey);
            var nextValue = _this.incrementValue(delta);
            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
        };
        _this.handleIncrementButtonClick = function (e) {
            var delta = _this.getIncrementDelta(IncrementDirection.UP, e.shiftKey, e.altKey);
            var nextValue = _this.incrementValue(delta);
            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
        };
        _this.handleButtonFocus = function () {
            _this.setState({ isButtonGroupFocused: true });
        };
        _this.handleButtonBlur = function () {
            _this.setState({ isButtonGroupFocused: false });
        };
        _this.handleButtonKeyUp = function (e, onClick) {
            if (e.keyCode === __WEBPACK_IMPORTED_MODULE_4__common__["b" /* Keys */].SPACE || e.keyCode === __WEBPACK_IMPORTED_MODULE_4__common__["b" /* Keys */].ENTER) {
                // prevent the page from scrolling (this is the default browser
                // behavior for shift + space or alt + space).
                e.preventDefault();
                // trigger a click event to update the input value appropriately,
                // based on the active modifier keys.
                var fakeClickEvent = {
                    altKey: e.altKey,
                    currentTarget: e.currentTarget,
                    shiftKey: e.shiftKey,
                    target: e.target,
                };
                onClick(fakeClickEvent);
            }
        };
        // Callbacks - Input
        // =================
        _this.handleInputFocus = function (e) {
            _this.shouldSelectAfterUpdate = _this.props.selectAllOnFocus;
            _this.setState({ isInputGroupFocused: true });
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onFocus, e);
        };
        _this.handleInputBlur = function (e) {
            // explicitly set `shouldSelectAfterUpdate` to `false` to prevent focus
            // hoarding on IE11 (#704)
            _this.shouldSelectAfterUpdate = false;
            var baseStateChange = { isInputGroupFocused: false };
            if (_this.props.clampValueOnBlur) {
                var value = e.target.value;
                var sanitizedValue = _this.getSanitizedValue(value);
                _this.setState(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, baseStateChange, { value: sanitizedValue }));
                if (value !== sanitizedValue) {
                    _this.invokeValueCallback(sanitizedValue, _this.props.onValueChange);
                }
            }
            else {
                _this.setState(baseStateChange);
            }
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onBlur, e);
        };
        _this.handleInputKeyDown = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var keyCode = e.keyCode;
            var direction;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_4__common__["b" /* Keys */].ARROW_UP) {
                direction = IncrementDirection.UP;
            }
            else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__common__["b" /* Keys */].ARROW_DOWN) {
                direction = IncrementDirection.DOWN;
            }
            if (direction != null) {
                // when the input field has focus, some key combinations will modify
                // the field's selection range. we'll actually want to select all
                // text in the field after we modify the value on the following
                // lines. preventing the default selection behavior lets us do that
                // without interference.
                e.preventDefault();
                var delta = _this.getIncrementDelta(direction, e.shiftKey, e.altKey);
                _this.incrementValue(delta);
            }
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onKeyDown, e);
        };
        _this.handleInputKeyPress = function (e) {
            // we prohibit keystrokes in onKeyPress instead of onKeyDown, because
            // e.key is not trustworthy in onKeyDown in all browsers.
            if (_this.props.allowNumericCharactersOnly && _this.isKeyboardEventDisabledForBasicNumericEntry(e)) {
                e.preventDefault();
            }
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onKeyPress, e);
        };
        _this.handleInputPaste = function (e) {
            _this.didPasteEventJustOccur = true;
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onPaste, e);
        };
        _this.handleInputChange = function (e) {
            var value = e.target.value;
            var nextValue;
            if (_this.props.allowNumericCharactersOnly && _this.didPasteEventJustOccur) {
                _this.didPasteEventJustOccur = false;
                var valueChars = value.split("");
                var sanitizedValueChars = valueChars.filter(_this.isFloatingPointNumericCharacter);
                var sanitizedValue = sanitizedValueChars.join("");
                nextValue = sanitizedValue;
            }
            else {
                nextValue = value;
            }
            _this.shouldSelectAfterUpdate = false;
            _this.setState({ value: nextValue });
            _this.invokeValueCallback(nextValue, _this.props.onValueChange);
        };
        _this.state = {
            stepMaxPrecision: _this.getStepMaxPrecision(props),
            value: _this.getValueOrEmptyValue(props.value),
        };
        return _this;
    }
    NumericInput_1 = NumericInput;
    NumericInput.prototype.componentWillReceiveProps = function (nextProps) {
        _super.prototype.componentWillReceiveProps.call(this, nextProps);
        var value = this.getValueOrEmptyValue(nextProps.value);
        var didMinChange = nextProps.min !== this.props.min;
        var didMaxChange = nextProps.max !== this.props.max;
        var didBoundsChange = didMinChange || didMaxChange;
        var sanitizedValue = value !== NumericInput_1.VALUE_EMPTY
            ? this.getSanitizedValue(value, /* delta */ 0, nextProps.min, nextProps.max)
            : NumericInput_1.VALUE_EMPTY;
        var stepMaxPrecision = this.getStepMaxPrecision(nextProps);
        // if a new min and max were provided that cause the existing value to fall
        // outside of the new bounds, then clamp the value to the new valid range.
        if (didBoundsChange && sanitizedValue !== this.state.value) {
            this.setState({ stepMaxPrecision: stepMaxPrecision, value: sanitizedValue });
            this.invokeValueCallback(sanitizedValue, this.props.onValueChange);
        }
        else {
            this.setState({ stepMaxPrecision: stepMaxPrecision, value: value });
        }
    };
    NumericInput.prototype.render = function () {
        var _a = this.props, buttonPosition = _a.buttonPosition, className = _a.className, large = _a.large;
        var inputGroupHtmlProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["l" /* removeNonHTMLProps */])(this.props, [
            "allowNumericCharactersOnly",
            "buttonPosition",
            "clampValueOnBlur",
            "className",
            "large",
            "majorStepSize",
            "minorStepSize",
            "onButtonClick",
            "onValueChange",
            "selectAllOnFocus",
            "selectAllOnIncrement",
            "stepSize",
        ], true);
        var inputGroup = (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__inputGroup__["a" /* InputGroup */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ autoComplete: "off" }, inputGroupHtmlProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames__((_b = {}, _b[__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].LARGE] = large, _b)), intent: this.props.intent, inputRef: this.inputRef, key: "input-group", leftIconName: this.props.leftIconName, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, onKeyPress: this.handleInputKeyPress, onPaste: this.handleInputPaste, value: this.state.value })));
        // the strict null check here is intentional; an undefined value should
        // fall back to the default button position on the right side.
        if (buttonPosition === "none" || buttonPosition === null) {
            // If there are no buttons, then the control group will render the
            // text field with squared border-radii on the left side, causing it
            // to look weird. This problem goes away if we simply don't nest within
            // a control group.
            return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: className }, inputGroup);
        }
        else {
            var incrementButton = this.renderButton(NumericInput_1.INCREMENT_KEY, NumericInput_1.INCREMENT_ICON_NAME, this.handleIncrementButtonClick);
            var decrementButton = this.renderButton(NumericInput_1.DECREMENT_KEY, NumericInput_1.DECREMENT_ICON_NAME, this.handleDecrementButtonClick);
            var buttonGroup = (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { key: "button-group", className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].BUTTON_GROUP, __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].VERTICAL, __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].FIXED) },
                incrementButton,
                decrementButton));
            var inputElems = buttonPosition === __WEBPACK_IMPORTED_MODULE_4__common__["i" /* Position */].LEFT ? [buttonGroup, inputGroup] : [inputGroup, buttonGroup];
            var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].NUMERIC_INPUT, __WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].CONTROL_GROUP, (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].LARGE] = large,
                _c), className);
            return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes }, inputElems);
        }
        var _b, _c;
    };
    NumericInput.prototype.componentDidUpdate = function () {
        if (this.shouldSelectAfterUpdate) {
            this.inputElement.setSelectionRange(0, this.state.value.length);
        }
    };
    NumericInput.prototype.validateProps = function (nextProps) {
        var majorStepSize = nextProps.majorStepSize, max = nextProps.max, min = nextProps.min, minorStepSize = nextProps.minorStepSize, stepSize = nextProps.stepSize;
        if (min != null && max != null && min >= max) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["y" /* NUMERIC_INPUT_MIN_MAX */]);
        }
        if (stepSize == null) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["z" /* NUMERIC_INPUT_STEP_SIZE_NULL */]);
        }
        if (stepSize <= 0) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["A" /* NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE */]);
        }
        if (minorStepSize && minorStepSize <= 0) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["B" /* NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE */]);
        }
        if (majorStepSize && majorStepSize <= 0) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["C" /* NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE */]);
        }
        if (minorStepSize && minorStepSize > stepSize) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["D" /* NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND */]);
        }
        if (majorStepSize && majorStepSize < stepSize) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_5__common_errors__["E" /* NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND */]);
        }
    };
    // Render Helpers
    // ==============
    NumericInput.prototype.renderButton = function (key, iconName, onClick) {
        var _this = this;
        // respond explicitly on key *up*, because onKeyDown triggers multiple
        // times and doesn't always receive modifier-key flags, leading to an
        // unintuitive/out-of-control incrementing experience.
        var onKeyUp = function (e) {
            _this.handleButtonKeyUp(e, onClick);
        };
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__button_buttons__["a" /* Button */], { disabled: this.props.disabled || this.props.readOnly, iconName: iconName, intent: this.props.intent, key: key, onBlur: this.handleButtonBlur, onClick: onClick, onFocus: this.handleButtonFocus, onKeyUp: onKeyUp }));
    };
    NumericInput.prototype.invokeValueCallback = function (value, callback) {
        __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(callback, +value, value);
    };
    // Value Helpers
    // =============
    NumericInput.prototype.incrementValue = function (delta) {
        // pretend we're incrementing from 0 if currValue is empty
        var currValue = this.state.value || NumericInput_1.VALUE_ZERO;
        var nextValue = this.getSanitizedValue(currValue, delta);
        this.shouldSelectAfterUpdate = this.props.selectAllOnIncrement;
        this.setState({ value: nextValue });
        this.invokeValueCallback(nextValue, this.props.onValueChange);
        return nextValue;
    };
    NumericInput.prototype.getIncrementDelta = function (direction, isShiftKeyPressed, isAltKeyPressed) {
        var _a = this.props, majorStepSize = _a.majorStepSize, minorStepSize = _a.minorStepSize, stepSize = _a.stepSize;
        if (isShiftKeyPressed && majorStepSize != null) {
            return direction * majorStepSize;
        }
        else if (isAltKeyPressed && minorStepSize != null) {
            return direction * minorStepSize;
        }
        else {
            return direction * stepSize;
        }
    };
    NumericInput.prototype.getSanitizedValue = function (value, delta, min, max) {
        if (delta === void 0) { delta = 0; }
        if (min === void 0) { min = this.props.min; }
        if (max === void 0) { max = this.props.max; }
        if (!this.isValueNumeric(value)) {
            return NumericInput_1.VALUE_EMPTY;
        }
        var nextValue = this.toMaxPrecision(parseFloat(value) + delta);
        // defaultProps won't work if the user passes in null, so just default
        // to +/- infinity here instead, as a catch-all.
        var adjustedMin = min != null ? min : -Infinity;
        var adjustedMax = max != null ? max : Infinity;
        nextValue = __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].clamp(nextValue, adjustedMin, adjustedMax);
        return nextValue.toString();
    };
    NumericInput.prototype.getValueOrEmptyValue = function (value) {
        return value != null ? value.toString() : NumericInput_1.VALUE_EMPTY;
    };
    NumericInput.prototype.isValueNumeric = function (value) {
        // checking if a string is numeric in Typescript is a big pain, because
        // we can't simply toss a string parameter to isFinite. below is the
        // essential approach that jQuery uses, which involves subtracting a
        // parsed numeric value from the string representation of the value. we
        // need to cast the value to the `any` type to allow this operation
        // between dissimilar types.
        return value != null && value - parseFloat(value) + 1 >= 0;
    };
    NumericInput.prototype.isKeyboardEventDisabledForBasicNumericEntry = function (e) {
        // unit tests may not include e.key. don't bother disabling those events.
        if (e.key == null) {
            return false;
        }
        // allow modified key strokes that may involve letters and other
        // non-numeric/invalid characters (Cmd + A, Cmd + C, Cmd + V, Cmd + X).
        if (e.ctrlKey || e.altKey || e.metaKey) {
            return false;
        }
        // keys that print a single character when pressed have a `key` name of
        // length 1. every other key has a longer `key` name (e.g. "Backspace",
        // "ArrowUp", "Shift"). since none of those keys can print a character
        // to the field--and since they may have important native behaviors
        // beyond printing a character--we don't want to disable their effects.
        var isSingleCharKey = e.key.length === 1;
        if (!isSingleCharKey) {
            return false;
        }
        // now we can simply check that the single character that wants to be printed
        // is a floating-point number character that we're allowed to print.
        return !this.isFloatingPointNumericCharacter(e.key);
    };
    NumericInput.prototype.isFloatingPointNumericCharacter = function (character) {
        return NumericInput_1.FLOATING_POINT_NUMBER_CHARACTER_REGEX.test(character);
    };
    NumericInput.prototype.getStepMaxPrecision = function (props) {
        if (props.minorStepSize != null) {
            return __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].countDecimalPlaces(props.minorStepSize);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].countDecimalPlaces(props.stepSize);
        }
    };
    NumericInput.prototype.toMaxPrecision = function (value) {
        // round the value to have the specified maximum precision (toFixed is the wrong choice,
        // because it would show trailing zeros in the decimal part out to the specified precision)
        // source: http://stackoverflow.com/a/18358056/5199574
        var scaleFactor = Math.pow(10, this.state.stepMaxPrecision);
        return Math.round(value * scaleFactor) / scaleFactor;
    };
    NumericInput.displayName = "Blueprint.NumericInput";
    NumericInput.VALUE_EMPTY = "";
    NumericInput.VALUE_ZERO = "0";
    NumericInput.defaultProps = {
        allowNumericCharactersOnly: true,
        buttonPosition: __WEBPACK_IMPORTED_MODULE_4__common__["i" /* Position */].RIGHT,
        clampValueOnBlur: false,
        large: false,
        majorStepSize: 10,
        minorStepSize: 0.1,
        selectAllOnFocus: false,
        selectAllOnIncrement: false,
        stepSize: 1,
        value: NumericInput_1.VALUE_EMPTY,
    };
    NumericInput.DECREMENT_KEY = "decrement";
    NumericInput.INCREMENT_KEY = "increment";
    NumericInput.DECREMENT_ICON_NAME = "chevron-down";
    NumericInput.INCREMENT_ICON_NAME = "chevron-up";
    /**
     * A regex that matches a string of length 1 (i.e. a standalone character)
     * if and only if it is a floating-point number character as defined by W3C:
     * https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
     *
     * Floating-point number characters are the only characters that can be
     * printed within a default input[type="number"]. This component should
     * behave the same way when this.props.allowNumericCharactersOnly = true.
     * See here for the input[type="number"].value spec:
     * https://www.w3.org/TR/2012/WD-html-markup-20120329/input.number.html#input.number.attrs.value
     */
    NumericInput.FLOATING_POINT_NUMBER_CHARACTER_REGEX = /^[Ee0-9\+\-\.]$/;
    NumericInput = NumericInput_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], NumericInput);
    return NumericInput;
    var NumericInput_1;
}(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* AbstractComponent */]));

var NumericInputFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](NumericInput);


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controls__ = __webpack_require__(447);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var counter = 0;
function nextName() {
    return RadioGroup.displayName + "-" + counter++;
}
var RadioGroup = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // a unique name for this group, which can be overridden by `name` prop.
        _this.autoGroupName = nextName();
        return _this;
    }
    RadioGroup.prototype.render = function () {
        var label = this.props.label;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.props.className },
            label == null ? null : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["LABEL"] }, label),
            Array.isArray(this.props.options) ? this.renderOptions() : this.renderChildren()));
    };
    RadioGroup.prototype.validateProps = function () {
        if (this.props.children != null && this.props.options != null) {
            console.warn(__WEBPACK_IMPORTED_MODULE_4__common_errors__["x" /* RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX */]);
        }
    };
    RadioGroup.prototype.renderChildren = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(this.props.children, function (child) {
            if (isRadio(child)) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, _this.getRadioProps(child.props));
            }
            else {
                return child;
            }
        });
    };
    RadioGroup.prototype.renderOptions = function () {
        var _this = this;
        return this.props.options.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__controls__["d" /* Radio */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, option, _this.getRadioProps(option), { key: option.value }))); });
    };
    RadioGroup.prototype.getRadioProps = function (optionProps) {
        var name = this.props.name;
        var value = optionProps.value, disabled = optionProps.disabled;
        return {
            checked: value === this.props.selectedValue,
            disabled: disabled || this.props.disabled,
            inline: this.props.inline,
            name: name == null ? this.autoGroupName : name,
            onChange: this.props.onChange,
        };
    };
    RadioGroup.displayName = "Blueprint.RadioGroup";
    return RadioGroup;
}(__WEBPACK_IMPORTED_MODULE_2__common_abstractComponent__["a" /* AbstractComponent */]));

function isRadio(child) {
    return child != null && child.type === __WEBPACK_IMPORTED_MODULE_5__controls__["d" /* Radio */];
}


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextAreaFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var TextArea = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TextArea, _super);
    function TextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, className = _a.className, fill = _a.fill, intent = _a.intent, large = _a.large, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "fill", "intent", "large"]);
        var rootClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["INPUT"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["FILL"]] = fill,
            _b[__WEBPACK_IMPORTED_MODULE_4__common_classes__["LARGE"]] = large,
            _b), className);
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("textarea", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, htmlProps, { className: rootClasses }));
        var _b;
    };
    TextArea.displayName = "Blueprint.TextArea";
    TextArea = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], TextArea);
    return TextArea;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var TextAreaFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](TextArea);


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HotkeyScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HotkeysEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hotkey__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hotkeyParser__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__ = __webpack_require__(450);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var SHOW_DIALOG_KEY = "?";
var HotkeyScope;
(function (HotkeyScope) {
    HotkeyScope[HotkeyScope["LOCAL"] = 0] = "LOCAL";
    HotkeyScope[HotkeyScope["GLOBAL"] = 1] = "GLOBAL";
})(HotkeyScope || (HotkeyScope = {}));
var HotkeysEvents = (function () {
    function HotkeysEvents(scope) {
        var _this = this;
        this.scope = scope;
        this.actions = [];
        this.handleKeyDown = function (e) {
            var combo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["b" /* getKeyCombo */])(e);
            var isTextInput = _this.isTextInput(e);
            if (!isTextInput && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["a" /* comboMatches */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["d" /* parseKeyCombo */])(SHOW_DIALOG_KEY), combo)) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__["c" /* isHotkeysDialogShowing */])()) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__["d" /* hideHotkeysDialogAfterDelay */])();
                }
                else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__["e" /* showHotkeysDialog */])(_this.actions.map(function (action) { return action.props; }));
                }
                return;
            }
            else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__["c" /* isHotkeysDialogShowing */])()) {
                return;
            }
            _this.invokeNamedCallbackIfComboRecognized(combo, "onKeyDown", e);
        };
        this.handleKeyUp = function (e) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hotkeysDialog__["c" /* isHotkeysDialogShowing */])()) {
                return;
            }
            _this.invokeNamedCallbackIfComboRecognized(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["b" /* getKeyCombo */])(e), "onKeyUp", e);
        };
    }
    HotkeysEvents.prototype.count = function () {
        return this.actions.length;
    };
    HotkeysEvents.prototype.clear = function () {
        this.actions = [];
    };
    HotkeysEvents.prototype.setHotkeys = function (props) {
        var _this = this;
        var actions = [];
        __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(props.children, function (child) {
            if (__WEBPACK_IMPORTED_MODULE_2__hotkey__["a" /* Hotkey */].isInstance(child) && _this.isScope(child.props)) {
                actions.push({
                    combo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["d" /* parseKeyCombo */])(child.props.combo),
                    props: child.props,
                });
            }
        });
        this.actions = actions;
    };
    HotkeysEvents.prototype.invokeNamedCallbackIfComboRecognized = function (combo, callbackName, e) {
        var isTextInput = this.isTextInput(e);
        for (var _i = 0, _a = this.actions; _i < _a.length; _i++) {
            var action = _a[_i];
            var shouldIgnore = (isTextInput && !action.props.allowInInput) || action.props.disabled;
            if (!shouldIgnore && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hotkeyParser__["a" /* comboMatches */])(action.combo, combo)) {
                if (action.props.preventDefault) {
                    e.preventDefault();
                }
                if (action.props.stopPropagation) {
                    // set a flag just for unit testing. not meant to be referenced in feature work.
                    e.isPropagationStopped = true;
                    e.stopPropagation();
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["safeInvoke"])(action.props[callbackName], e);
            }
        }
    };
    HotkeysEvents.prototype.isScope = function (props) {
        return (props.global ? HotkeyScope.GLOBAL : HotkeyScope.LOCAL) === this.scope;
    };
    HotkeysEvents.prototype.isTextInput = function (e) {
        var elem = e.target;
        // we check these cases for unit testing, but this should not happen
        // during normal operation
        if (elem == null || elem.closest == null) {
            return false;
        }
        var editable = elem.closest("input, textarea, [contenteditable=true]");
        if (editable == null) {
            return false;
        }
        // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
        if (editable.tagName.toLowerCase() === "input") {
            var inputType = editable.type;
            if (inputType === "checkbox" || inputType === "radio") {
                return false;
            }
        }
        // don't let read-only fields prevent hotkey behavior
        if (editable.readOnly) {
            return false;
        }
        return true;
    };
    return HotkeysEvents;
}());



/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HotkeysTarget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hotkeysEvents__ = __webpack_require__(901);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



function HotkeysTarget(constructor) {
    var _a = constructor.prototype, componentWillMount = _a.componentWillMount, componentDidMount = _a.componentDidMount, componentWillUnmount = _a.componentWillUnmount, render = _a.render, renderHotkeys = _a.renderHotkeys;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["isFunction"])(renderHotkeys)) {
        throw new Error("@HotkeysTarget-decorated class must implement `renderHotkeys`. " + constructor);
    }
    // tslint:disable no-invalid-this only-arrow-functions
    constructor.prototype.componentWillMount = function () {
        this.localHotkeysEvents = new __WEBPACK_IMPORTED_MODULE_2__hotkeysEvents__["a" /* HotkeysEvents */](__WEBPACK_IMPORTED_MODULE_2__hotkeysEvents__["b" /* HotkeyScope */].LOCAL);
        this.globalHotkeysEvents = new __WEBPACK_IMPORTED_MODULE_2__hotkeysEvents__["a" /* HotkeysEvents */](__WEBPACK_IMPORTED_MODULE_2__hotkeysEvents__["b" /* HotkeyScope */].GLOBAL);
        if (componentWillMount != null) {
            componentWillMount.call(this);
        }
    };
    constructor.prototype.componentDidMount = function () {
        // attach global key event listeners
        document.addEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
        document.addEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
        if (componentDidMount != null) {
            componentDidMount.call(this);
        }
    };
    constructor.prototype.componentWillUnmount = function () {
        // detach global key event listeners
        document.removeEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
        document.removeEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
        this.globalHotkeysEvents.clear();
        this.localHotkeysEvents.clear();
        if (componentWillUnmount != null) {
            componentWillUnmount.call(this);
        }
    };
    constructor.prototype.render = function () {
        var _this = this;
        var element = render.call(this);
        var hotkeys = renderHotkeys.call(this);
        this.localHotkeysEvents.setHotkeys(hotkeys.props);
        this.globalHotkeysEvents.setHotkeys(hotkeys.props);
        // attach local key event listeners
        if (element != null && this.localHotkeysEvents.count() > 0) {
            var tabIndex = hotkeys.props.tabIndex === undefined ? 0 : hotkeys.props.tabIndex;
            var existingKeyDown_1 = element.props.onKeyDown;
            var onKeyDown = function (e) {
                _this.localHotkeysEvents.handleKeyDown(e.nativeEvent);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["safeInvoke"])(existingKeyDown_1, e);
            };
            var existingKeyUp_1 = element.props.onKeyUp;
            var onKeyUp = function (e) {
                _this.localHotkeysEvents.handleKeyUp(e.nativeEvent);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["safeInvoke"])(existingKeyUp_1, e);
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](element, { tabIndex: tabIndex, onKeyDown: onKeyDown, onKeyUp: onKeyUp });
        }
        else {
            return element;
        }
    };
    // tslint:enable
}


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuDivider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuDividerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */




var MenuDivider = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](MenuDivider, _super);
    function MenuDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuDivider.prototype.render = function () {
        var _a = this.props, className = _a.className, title = _a.title;
        if (title == null) {
            // simple divider
            return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["MENU_DIVIDER"], className) });
        }
        else {
            // section header with title
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("li", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["MENU_HEADER"], className) },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("h6", null, title)));
        }
    };
    MenuDivider.displayName = "Blueprint.MenuDivider";
    return MenuDivider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

var MenuDividerFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](MenuDivider);


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Navbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbarDivider__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbarGroup__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbarHeading__ = __webpack_require__(456);
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








// this component is simple enough that tests would be purely tautological.
/* istanbul ignore next */
var Navbar = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Navbar, _super);
    function Navbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Navbar.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, htmlProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["children", "className"]);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NAVBAR"], className) }, htmlProps), children));
    };
    Navbar.displayName = "Blueprint.Navbar";
    Navbar.Divider = __WEBPACK_IMPORTED_MODULE_5__navbarDivider__["a" /* NavbarDivider */];
    Navbar.Group = __WEBPACK_IMPORTED_MODULE_6__navbarGroup__["a" /* NavbarGroup */];
    Navbar.Heading = __WEBPACK_IMPORTED_MODULE_7__navbarHeading__["a" /* NavbarHeading */];
    Navbar = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Navbar);
    return Navbar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NonIdealState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NonIdealStateFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_icon__ = __webpack_require__(127);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var NonIdealState = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](NonIdealState, _super);
    function NonIdealState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NonIdealState.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE"], this.props.className) },
            this.maybeRenderVisual(),
            this.maybeRenderTitle(),
            this.maybeRenderDescription(),
            this.maybeRenderAction()));
    };
    NonIdealState.prototype.maybeRenderAction = function () {
        if (this.props.action == null) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_ACTION"] }, this.props.action);
    };
    NonIdealState.prototype.maybeRenderDescription = function () {
        if (this.props.description == null) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_DESCRIPTION"] }, this.props.description);
    };
    NonIdealState.prototype.maybeRenderTitle = function () {
        if (this.props.title == null) {
            return undefined;
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("h4", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_TITLE"] }, this.props.title);
    };
    NonIdealState.prototype.maybeRenderVisual = function () {
        var visual = this.props.visual;
        if (visual == null) {
            return undefined;
        }
        else if (typeof visual === "string") {
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_VISUAL"], __WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_ICON"]) },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__icon_icon__["a" /* Icon */], { iconName: visual, iconSize: "inherit" })));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__common_classes__["NON_IDEAL_STATE_VISUAL"] }, visual);
        }
    };
    NonIdealState = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], NonIdealState);
    return NonIdealState;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var NonIdealStateFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](NonIdealState);


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MIN_ARROW_SPACING */
/* unused harmony export computeArrowOffset */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopoverTransformOrigin;
/* harmony export (immutable) */ __webpack_exports__["a"] = getArrowPositionStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_position__ = __webpack_require__(109);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

// this value causes popover and target edges to line up on 50px targets
var MIN_ARROW_SPACING = 18;
function computeArrowOffset(sideLength, arrowSize, minimum) {
    if (minimum === void 0) { minimum = MIN_ARROW_SPACING; }
    return Math.max(Math.round((sideLength - arrowSize) / 2), minimum);
}
function getPopoverTransformOrigin(position, arrowSize, targetDimensions) {
    var offsetX = computeArrowOffset(targetDimensions.width, arrowSize);
    var offsetY = computeArrowOffset(targetDimensions.height, arrowSize);
    switch (position) {
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].TOP_LEFT:
            return offsetX + "px bottom";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].TOP_RIGHT:
            return "calc(100% - " + offsetX + "px) bottom";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].BOTTOM_LEFT:
            return offsetX + "px top";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].BOTTOM_RIGHT:
            return "calc(100% - " + offsetX + "px) top";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].LEFT_TOP:
            return "right " + offsetY + "px";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].LEFT_BOTTOM:
            return "right calc(100% - " + offsetY + "px)";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].RIGHT_TOP:
            return "left " + offsetY + "px";
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].RIGHT_BOTTOM:
            return "left calc(100% - " + offsetY + "px)";
        default:
            return undefined;
    }
}
function getArrowPositionStyles(position, arrowSize, ignoreTargetDimensions, targetDimensions, inline) {
    // compute the offset to center an arrow with given hypotenuse in a side of the given length
    var popoverOffset = function (sideLength) {
        var offset = computeArrowOffset(sideLength, arrowSize, 0);
        return offset < MIN_ARROW_SPACING ? MIN_ARROW_SPACING - offset : 0;
    };
    var popoverOffsetX = popoverOffset(targetDimensions.width);
    var popoverOffsetY = popoverOffset(targetDimensions.height);
    // TOP, RIGHT, BOTTOM, LEFT are handled purely in CSS because of centering transforms
    switch (position) {
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].TOP_LEFT:
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].BOTTOM_LEFT:
            return {
                arrow: ignoreTargetDimensions ? {} : { left: computeArrowOffset(targetDimensions.width, arrowSize) },
                container: { marginLeft: -popoverOffsetX },
            };
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].TOP_RIGHT:
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].BOTTOM_RIGHT:
            return {
                arrow: ignoreTargetDimensions ? {} : { right: computeArrowOffset(targetDimensions.width, arrowSize) },
                container: { marginLeft: popoverOffsetX },
            };
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].RIGHT_TOP:
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].LEFT_TOP:
            return {
                arrow: ignoreTargetDimensions ? {} : { top: computeArrowOffset(targetDimensions.height, arrowSize) },
                container: inline ? { top: -popoverOffsetY } : { marginTop: -popoverOffsetY },
            };
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].RIGHT_BOTTOM:
        case __WEBPACK_IMPORTED_MODULE_0__common_position__["a" /* Position */].LEFT_BOTTOM:
            return {
                arrow: ignoreTargetDimensions ? {} : { bottom: computeArrowOffset(targetDimensions.height, arrowSize) },
                container: inline ? { bottom: -popoverOffsetY } : { marginTop: popoverOffsetY },
            };
        default:
            return {};
    }
}


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVGPopover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SVGPopoverFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover__ = __webpack_require__(165);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



var SVGPopover = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SVGPopover, _super);
    function SVGPopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPopover.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__popover__["b" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ rootElementTag: "g" }, this.props), this.props.children));
    };
    return SVGPopover;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var SVGPopoverFactory = __WEBPACK_IMPORTED_MODULE_1_react__["createFactory"](SVGPopover);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProgressBarFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(41);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var ProgressBar = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ProgressBar, _super);
    function ProgressBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressBar.prototype.render = function () {
        var _a = this.props, className = _a.className, intent = _a.intent, value = _a.value;
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__("pt-progress-bar", __WEBPACK_IMPORTED_MODULE_4__common_classes__["intentClass"](intent), className);
        // don't set width if value is null (rely on default CSS value)
        var width = value == null ? null : 100 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["clamp"])(value, 0, 1) + "%";
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-progress-meter", style: { width: width } })));
    };
    ProgressBar.displayName = "Blueprint.ProgressBar";
    ProgressBar = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], ProgressBar);
    return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var ProgressBarFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](ProgressBar);


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RangeSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RangeSliderFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coreSlider__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handle__ = __webpack_require__(459);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */








var RangeIndex;
(function (RangeIndex) {
    RangeIndex[RangeIndex["START"] = 0] = "START";
    RangeIndex[RangeIndex["END"] = 1] = "END";
})(RangeIndex || (RangeIndex = {}));
var RangeSlider = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](RangeSlider, _super);
    function RangeSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["SLIDER"], __WEBPACK_IMPORTED_MODULE_3__common_classes__["RANGE_SLIDER"]);
        _this.handles = [];
        _this.addHandleRef = function (ref) {
            if (ref != null) {
                _this.handles.push(ref);
            }
        };
        _this.getHandlerForIndex = function (index, callback) { return function (newValue) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["isFunction"])(callback)) {
                var _a = _this.props.value, startValue = _a[0], endValue = _a[1];
                if (index === RangeIndex.START) {
                    callback([Math.min(newValue, endValue), endValue]);
                }
                else {
                    callback([startValue, Math.max(newValue, startValue)]);
                }
            }
        }; };
        _this.handleChange = function (newValue) {
            var _a = _this.props.value, startValue = _a[0], endValue = _a[1];
            var newStartValue = newValue[0], newEndValue = newValue[1];
            if ((startValue !== newStartValue || endValue !== newEndValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils__["isFunction"])(_this.props.onChange)) {
                _this.props.onChange(newValue);
            }
        };
        return _this;
    }
    RangeSlider.prototype.renderFill = function () {
        var tickSize = this.state.tickSize;
        var _a = this.props.value, startValue = _a[0], endValue = _a[1];
        if (startValue === endValue) {
            return undefined;
        }
        // expand by 1px in each direction so it sits under the handle border
        var offset = Math.round((startValue - this.props.min) * tickSize) - 1;
        var size = Math.round((endValue - startValue) * tickSize) + 2;
        if (size < 0) {
            offset += size;
            size = Math.abs(size);
        }
        var style = this.props.vertical
            ? { bottom: offset, height: size }
            : { left: offset, width: size };
        return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__common_classes__["SLIDER"] + "-progress", style: style });
    };
    RangeSlider.prototype.renderHandles = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, max = _a.max, min = _a.min, onRelease = _a.onRelease, stepSize = _a.stepSize, value = _a.value, vertical = _a.vertical;
        return value.map(function (val, index) { return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__handle__["a" /* Handle */], { disabled: disabled, key: index, label: _this.formatLabel(val), max: max, min: min, onChange: _this.getHandlerForIndex(index, _this.handleChange), onRelease: _this.getHandlerForIndex(index, onRelease), ref: _this.addHandleRef, stepSize: stepSize, tickSize: _this.state.tickSize, value: val, vertical: vertical })); });
    };
    RangeSlider.prototype.handleTrackClick = function (event) {
        var _this = this;
        this.handles
            .reduce(function (min, handle) {
            // find closest handle to the mouse position
            var offset = handle.mouseEventClientOffset(event);
            var value = handle.clientToValue(offset);
            return _this.nearestHandleForValue(value, min, handle);
        })
            .beginHandleMovement(event);
    };
    RangeSlider.prototype.handleTrackTouch = function (event) {
        var _this = this;
        this.handles
            .reduce(function (min, handle) {
            // find closest handle to the touch position
            var value = handle.clientToValue(handle.touchEventClientOffset(event));
            return _this.nearestHandleForValue(value, min, handle);
        })
            .beginHandleTouchMovement(event);
    };
    RangeSlider.prototype.nearestHandleForValue = function (value, firstHandle, secondHandle) {
        var firstHandleValue = firstHandle.props.value;
        var firstDistance = Math.abs(value - firstHandleValue);
        var secondDistance = Math.abs(value - secondHandle.props.value);
        if (firstDistance < secondDistance) {
            return firstHandle;
        }
        else if (secondDistance < firstDistance) {
            return secondHandle;
        }
        else {
            // if the values are equal, return the handle that is *able* to move
            // in the necessary direction.
            return value < firstHandleValue ? firstHandle : secondHandle;
        }
    };
    RangeSlider.prototype.validateProps = function (props) {
        var value = props.value;
        if (value == null || value[RangeIndex.START] == null || value[RangeIndex.END] == null) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_4__common_errors__["j" /* RANGESLIDER_NULL_VALUE */]);
        }
    };
    RangeSlider.defaultProps = {
        disabled: false,
        labelStepSize: 1,
        max: 10,
        min: 0,
        showTrackFill: true,
        stepSize: 1,
        value: [0, 10],
        vertical: false,
    };
    RangeSlider.displayName = "Blueprint.RangeSlider";
    return RangeSlider;
}(__WEBPACK_IMPORTED_MODULE_6__coreSlider__["a" /* CoreSlider */]));

var RangeSliderFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](RangeSlider);


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SliderFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coreSlider__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle__ = __webpack_require__(459);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var Slider = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:enable member-ordering
        _this.handleHandleRef = function (ref) {
            _this.handle = ref;
        };
        return _this;
    }
    Slider.prototype.renderFill = function () {
        var tickSize = this.state.tickSize;
        var initialValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils__["clamp"])(this.props.initialValue, this.props.min, this.props.max);
        var offset = Math.round((initialValue - this.props.min) * tickSize);
        var size = Math.round((this.props.value - initialValue) * tickSize);
        if (size < 0) {
            offset += size;
            size = Math.abs(size);
        }
        var style = this.props.vertical
            ? { bottom: offset, height: size }
            : { left: offset, width: size };
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__common_classes__["SLIDER"] + "-progress", style: style });
    };
    Slider.prototype.renderHandles = function () {
        // make sure to *not* pass this.props.className to handle
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__handle__["a" /* Handle */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this.props, this.state, { className: "", label: this.formatLabel(this.props.value), ref: this.handleHandleRef })));
    };
    Slider.prototype.handleTrackClick = function (event) {
        if (this.handle != null) {
            this.handle.beginHandleMovement(event);
        }
    };
    Slider.prototype.handleTrackTouch = function (event) {
        if (this.handle != null) {
            this.handle.beginHandleTouchMovement(event);
        }
    };
    Slider.defaultProps = {
        disabled: false,
        initialValue: 0,
        labelStepSize: 1,
        max: 10,
        min: 0,
        showTrackFill: true,
        stepSize: 1,
        value: 0,
        vertical: false,
    };
    return Slider;
}(__WEBPACK_IMPORTED_MODULE_4__coreSlider__["a" /* CoreSlider */]));

var SliderFactory = __WEBPACK_IMPORTED_MODULE_1_react__["createFactory"](Slider);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVGSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SVGSpinnerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner__ = __webpack_require__(302);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */




// import * to avoid "cannot be named" error on factory

var SVGSpinner = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SVGSpinner, _super);
    function SVGSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGSpinner.prototype.renderContainer = function (classes, content) {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("g", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["SVG_SPINNER"], classes) },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("g", { className: "pt-svg-spinner-transform-group" }, content)));
    };
    return SVGSpinner;
}(__WEBPACK_IMPORTED_MODULE_4__spinner__["a" /* Spinner */]));

var SVGSpinnerFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](SVGSpinner);


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabsFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tab__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tabList__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tabPanel__ = __webpack_require__(462);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */













var TAB_CSS_SELECTOR = "li[role=tab]";
var Tabs = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tabs, _super);
    function Tabs(props, context) {
        var _this = _super.call(this, props, context) || this;
        // state is initialized in the constructor but getStateFromProps needs state defined
        _this.state = {};
        _this.panelIds = [];
        _this.tabIds = [];
        _this.handleClick = function (e) {
            _this.handleTabSelectingEvent(e);
        };
        _this.handleKeyPress = function (e) {
            var insideTab = e.target.closest("." + __WEBPACK_IMPORTED_MODULE_6__common_classes__["TAB"]) != null;
            if (insideTab && (e.which === __WEBPACK_IMPORTED_MODULE_8__common_keys__["SPACE"] || e.which === __WEBPACK_IMPORTED_MODULE_8__common_keys__["ENTER"])) {
                e.preventDefault();
                _this.handleTabSelectingEvent(e);
            }
        };
        _this.handleKeyDown = function (e) {
            // don't want to handle keyDown events inside a tab panel
            var insideTabList = e.target.closest("." + __WEBPACK_IMPORTED_MODULE_6__common_classes__["TAB_LIST"]) != null;
            if (!insideTabList) {
                return;
            }
            var focusedTabIndex = _this.getFocusedTabIndex();
            if (focusedTabIndex === -1) {
                return;
            }
            if (e.which === __WEBPACK_IMPORTED_MODULE_8__common_keys__["ARROW_LEFT"]) {
                e.preventDefault();
                // find previous tab that isn't disabled
                var newTabIndex = focusedTabIndex - 1;
                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
                while (tabIsDisabled && newTabIndex !== -1) {
                    newTabIndex--;
                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
                }
                if (newTabIndex !== -1) {
                    _this.focusTab(newTabIndex);
                }
            }
            else if (e.which === __WEBPACK_IMPORTED_MODULE_8__common_keys__["ARROW_RIGHT"]) {
                e.preventDefault();
                // find next tab that isn't disabled
                var tabsCount = _this.getTabsCount();
                var newTabIndex = focusedTabIndex + 1;
                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
                while (tabIsDisabled && newTabIndex !== tabsCount) {
                    newTabIndex++;
                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
                }
                if (newTabIndex !== tabsCount) {
                    _this.focusTab(newTabIndex);
                }
            }
        };
        _this.handleTabSelectingEvent = function (e) {
            var tabElement = e.target.closest(TAB_CSS_SELECTOR);
            // select only if Tab is one of us and is enabled
            if (tabElement != null &&
                _this.tabIds.indexOf(tabElement.id) >= 0 &&
                tabElement.getAttribute("aria-disabled") !== "true") {
                var index = tabElement.parentElement.queryAll(TAB_CSS_SELECTOR).indexOf(tabElement);
                _this.setSelectedTabIndex(index);
            }
        };
        _this.state = _this.getStateFromProps(_this.props);
        if (!__WEBPACK_IMPORTED_MODULE_9__common_utils__["isNodeEnv"]("production")) {
            console.warn(__WEBPACK_IMPORTED_MODULE_7__common_errors__["e" /* TABS_WARN_DEPRECATED */]);
        }
        return _this;
    }
    Tabs.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_6__common_classes__["TABS"], this.props.className), onClick: this.handleClick, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown }, this.getChildren()));
    };
    Tabs.prototype.componentWillReceiveProps = function (newProps) {
        var newState = this.getStateFromProps(newProps);
        this.setState(newState);
    };
    Tabs.prototype.componentDidMount = function () {
        var _this = this;
        var selectedTab = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.refs["tabs-" + this.state.selectedTabIndex]);
        this.setTimeout(function () { return _this.moveIndicator(selectedTab); });
    };
    Tabs.prototype.componentDidUpdate = function (_, prevState) {
        var _this = this;
        var newIndex = this.state.selectedTabIndex;
        if (newIndex !== prevState.selectedTabIndex) {
            var tabElement_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.refs["tabs-" + newIndex]);
            // need to measure on the next frame in case the Tab children simultaneously change
            this.setTimeout(function () { return _this.moveIndicator(tabElement_1); });
        }
    };
    Tabs.prototype.validateProps = function (props) {
        if (__WEBPACK_IMPORTED_MODULE_3_react__["Children"].count(props.children) > 0) {
            var child = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(props.children)[0];
            if (child != null && child.type !== __WEBPACK_IMPORTED_MODULE_11__tabList__["a" /* TabList */]) {
                throw new Error(__WEBPACK_IMPORTED_MODULE_7__common_errors__["f" /* TABS_FIRST_CHILD */]);
            }
            if (this.getTabsCount() !== this.getPanelsCount()) {
                throw new Error(__WEBPACK_IMPORTED_MODULE_7__common_errors__["g" /* TABS_MISMATCH */]);
            }
        }
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */
    Tabs.prototype.moveIndicator = function (_a) {
        var clientHeight = _a.clientHeight, clientWidth = _a.clientWidth, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop;
        var indicatorWrapperStyle = {
            height: clientHeight,
            transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
            width: clientWidth,
        };
        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
    };
    /**
     * Most of the component logic lives here. We clone the children provided by the user to set up refs,
     * accessibility attributes, and selection props correctly.
     */
    Tabs.prototype.getChildren = function () {
        var _this = this;
        for (var unassignedTabs = this.getTabsCount() - this.tabIds.length; unassignedTabs > 0; unassignedTabs--) {
            this.tabIds.push(generateTabId());
            this.panelIds.push(generatePanelId());
        }
        var childIndex = 0;
        return __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(this.props.children, function (child) {
            var result;
            // can be null if conditionally rendering TabList / TabPanel
            if (child == null) {
                return null;
            }
            if (childIndex === 0) {
                // clone TabList / Tab elements
                result = _this.cloneTabList(child);
            }
            else {
                var tabPanelIndex = childIndex - 1;
                var shouldRenderTabPanel = _this.state.selectedTabIndex === tabPanelIndex;
                result = shouldRenderTabPanel ? _this.cloneTabPanel(child, tabPanelIndex) : null;
            }
            childIndex++;
            return result;
        });
    };
    Tabs.prototype.cloneTabList = function (child) {
        var _this = this;
        var tabIndex = 0;
        var tabs = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(child.props.children, function (tab) {
            // can be null if conditionally rendering Tab
            if (tab == null) {
                return null;
            }
            var clonedTab = __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](tab, {
                id: _this.tabIds[tabIndex],
                isSelected: _this.state.selectedTabIndex === tabIndex,
                panelId: _this.panelIds[tabIndex],
                ref: "tabs-" + tabIndex,
            });
            tabIndex++;
            return clonedTab;
        });
        // tslint:disable-next-line no-object-literal-type-assertion
        return __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
            children: tabs,
            indicatorWrapperStyle: this.state.indicatorWrapperStyle,
            ref: "tablist",
        });
    };
    Tabs.prototype.cloneTabPanel = function (child, tabIndex) {
        return __WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
            id: this.panelIds[tabIndex],
            isSelected: this.state.selectedTabIndex === tabIndex,
            ref: "panels-" + tabIndex,
            tabId: this.tabIds[tabIndex],
        });
    };
    Tabs.prototype.focusTab = function (index) {
        var ref = "tabs-" + index;
        var tab = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.refs[ref]);
        tab.focus();
    };
    Tabs.prototype.getFocusedTabIndex = function () {
        var focusedElement = document.activeElement;
        if (focusedElement != null && focusedElement.classList.contains(__WEBPACK_IMPORTED_MODULE_6__common_classes__["TAB"])) {
            var tabId = focusedElement.id;
            return this.tabIds.indexOf(tabId);
        }
        return -1;
    };
    Tabs.prototype.getTabs = function () {
        if (this.props.children == null) {
            return [];
        }
        var tabs = [];
        if (__WEBPACK_IMPORTED_MODULE_3_react__["Children"].count(this.props.children) > 0) {
            var firstChild = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(this.props.children)[0];
            if (firstChild != null) {
                __WEBPACK_IMPORTED_MODULE_3_react__["Children"].forEach(firstChild.props.children, function (tabListChild) {
                    if (tabListChild.type === __WEBPACK_IMPORTED_MODULE_10__tab__["a" /* Tab */]) {
                        tabs.push(tabListChild);
                    }
                });
            }
        }
        return tabs;
    };
    Tabs.prototype.getTabsCount = function () {
        return this.getTabs().length;
    };
    Tabs.prototype.getPanelsCount = function () {
        if (this.props.children == null) {
            return 0;
        }
        var index = 0;
        var panelCount = 0;
        __WEBPACK_IMPORTED_MODULE_3_react__["Children"].forEach(this.props.children, function (child) {
            if (child.type === __WEBPACK_IMPORTED_MODULE_12__tabPanel__["a" /* TabPanel */]) {
                panelCount++;
            }
            index++;
        });
        return panelCount;
    };
    Tabs.prototype.getStateFromProps = function (props) {
        var selectedTabIndex = props.selectedTabIndex, initialSelectedTabIndex = props.initialSelectedTabIndex;
        if (this.isValidTabIndex(selectedTabIndex)) {
            return { selectedTabIndex: selectedTabIndex };
        }
        else if (this.isValidTabIndex(initialSelectedTabIndex) && this.state.selectedTabIndex == null) {
            return { selectedTabIndex: initialSelectedTabIndex };
        }
        else {
            return this.state;
        }
    };
    Tabs.prototype.isTabDisabled = function (index) {
        var tab = this.getTabs()[index];
        return tab != null && tab.props.isDisabled;
    };
    Tabs.prototype.isValidTabIndex = function (index) {
        return index != null && index >= 0 && index < this.getTabsCount();
    };
    /**
     * Updates the component's state if uncontrolled and calls onChange.
     */
    Tabs.prototype.setSelectedTabIndex = function (index) {
        if (index === this.state.selectedTabIndex || !this.isValidTabIndex(index)) {
            return;
        }
        var prevSelectedIndex = this.state.selectedTabIndex;
        if (this.props.selectedTabIndex == null) {
            this.setState({
                selectedTabIndex: index,
            });
        }
        if (__WEBPACK_IMPORTED_MODULE_9__common_utils__["isFunction"](this.props.onChange)) {
            this.props.onChange(index, prevSelectedIndex);
        }
    };
    Tabs.defaultProps = {
        initialSelectedTabIndex: 0,
    };
    Tabs.displayName = "Blueprint.Tabs";
    Tabs = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tabs);
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5__common_abstractComponent__["a" /* AbstractComponent */]));

var globalTabCount = 0;
function generateTabId() {
    return "pt-tab-" + globalTabCount++;
}
var globalPanelCount = 0;
function generatePanelId() {
    return "pt-tab-panel-" + globalPanelCount++;
}
var TabsFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tabs);


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TabTitle; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generateTabPanelId;
/* harmony export (immutable) */ __webpack_exports__["a"] = generateTabTitleId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var TabTitle = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](TabTitle, _super);
    function TabTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) { return _this.props.onClick(_this.props.id, e); };
        return _this;
    }
    TabTitle.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, id = _a.id, parentId = _a.parentId, selected = _a.selected;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { "aria-controls": generateTabPanelId(parentId, id), "aria-disabled": disabled, "aria-expanded": selected, "aria-selected": selected, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB"], this.props.className), "data-tab-id": id, id: generateTabTitleId(parentId, id), onClick: disabled ? undefined : this.handleClick, role: "tab", tabIndex: disabled ? undefined : 0 },
            this.props.title,
            this.props.children));
    };
    TabTitle.displayName = "Blueprint.TabTitle";
    TabTitle = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], TabTitle);
    return TabTitle;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

function generateTabPanelId(parentId, tabId) {
    return __WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB_PANEL"] + "_" + parentId + "_" + tabId;
}
function generateTabTitleId(parentId, tabId) {
    return __WEBPACK_IMPORTED_MODULE_4__common_classes__["TAB"] + "-title_" + parentId + "_" + tabId;
}


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expander; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tabs2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Tabs2Factory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tab2__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tabTitle__ = __webpack_require__(913);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */










var Expander = function () { return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-flex-expander" }); };
var TAB_SELECTOR = "." + __WEBPACK_IMPORTED_MODULE_5__common_classes__["TAB"];
var Tabs2 = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tabs2, _super);
    function Tabs2(props) {
        var _this = _super.call(this, props) || this;
        _this.refHandlers = {
            tablist: function (tabElement) { return (_this.tablistElement = tabElement); },
        };
        _this.handleKeyDown = function (e) {
            var focusedElement = document.activeElement.closest(TAB_SELECTOR);
            // rest of this is potentially expensive and futile, so bail if no tab is focused
            if (focusedElement == null) {
                return;
            }
            // must rely on DOM state because we have no way of mapping `focusedElement` to a JSX.Element
            var enabledTabElements = _this.getTabElements().filter(function (el) { return el.getAttribute("aria-disabled") === "false"; });
            var focusedIndex = enabledTabElements.indexOf(focusedElement);
            var direction = _this.getKeyCodeDirection(e);
            if (focusedIndex >= 0 && direction !== undefined) {
                e.preventDefault();
                var length_1 = enabledTabElements.length;
                // auto-wrapping at 0 and `length`
                var nextFocusedIndex = (focusedIndex + direction + length_1) % length_1;
                enabledTabElements[nextFocusedIndex].focus();
            }
        };
        _this.handleKeyPress = function (e) {
            var targetTabElement = e.target.closest(TAB_SELECTOR);
            if (targetTabElement != null && isEventKeyCode(e, __WEBPACK_IMPORTED_MODULE_6__common_keys__["SPACE"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ENTER"])) {
                e.preventDefault();
                targetTabElement.click();
            }
        };
        _this.handleTabClick = function (newTabId, event) {
            __WEBPACK_IMPORTED_MODULE_7__common_utils__["safeInvoke"](_this.props.onChange, newTabId, _this.state.selectedTabId, event);
            if (_this.props.selectedTabId === undefined) {
                _this.setState({ selectedTabId: newTabId });
            }
        };
        _this.renderTabPanel = function (tab) {
            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id;
            if (panel === undefined) {
                return undefined;
            }
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { "aria-labelledby": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tabTitle__["a" /* generateTabTitleId */])(_this.props.id, id), "aria-hidden": id !== _this.state.selectedTabId, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["TAB_PANEL"], className), id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tabTitle__["b" /* generateTabPanelId */])(_this.props.id, id), key: id, role: "tabpanel" }, panel));
        };
        _this.renderTabTitle = function (tab) {
            var id = tab.props.id;
            return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__tabTitle__["c" /* TabTitle */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, tab.props, { parentId: _this.props.id, onClick: _this.handleTabClick, selected: id === _this.state.selectedTabId })));
        };
        var selectedTabId = _this.getInitialSelectedTabId();
        _this.state = { selectedTabId: selectedTabId };
        return _this;
    }
    Tabs2.prototype.render = function () {
        var _this = this;
        var _a = this.state, indicatorWrapperStyle = _a.indicatorWrapperStyle, selectedTabId = _a.selectedTabId;
        var tabTitles = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(this.props.children, function (child) { return (isTab(child) ? _this.renderTabTitle(child) : child); });
        var tabPanels = this.getTabChildren()
            .filter(this.props.renderActiveTabPanelOnly ? function (tab) { return tab.props.id === selectedTabId; } : function () { return true; })
            .map(this.renderTabPanel);
        var tabIndicator = this.props.animate ? (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-tab-indicator-wrapper", style: indicatorWrapperStyle },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: "pt-tab-indicator" }))) : (undefined);
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["TABS"], (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_5__common_classes__["VERTICAL"]] = this.props.vertical, _b), this.props.className);
        var tabListClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_5__common_classes__["TAB_LIST"], (_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_5__common_classes__["LARGE"]] = this.props.large,
            _c));
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: tabListClasses, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, ref: this.refHandlers.tablist, role: "tablist" },
                tabIndicator,
                tabTitles),
            tabPanels));
        var _b, _c;
    };
    Tabs2.prototype.componentDidMount = function () {
        this.moveSelectionIndicator();
    };
    Tabs2.prototype.componentWillReceiveProps = function (_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) {
            // keep state in sync with controlled prop, so state is canonical source of truth
            this.setState({ selectedTabId: selectedTabId });
        }
    };
    Tabs2.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) {
            this.moveSelectionIndicator();
        }
        else if (prevState.selectedTabId != null) {
            // comparing React nodes is difficult to do with simple logic, so
            // shallowly compare just their props as a workaround.
            var didChildrenChange = !__WEBPACK_IMPORTED_MODULE_7__common_utils__["arraysEqual"](this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), __WEBPACK_IMPORTED_MODULE_7__common_utils__["shallowCompareKeys"]);
            if (didChildrenChange) {
                this.moveSelectionIndicator();
            }
        }
    };
    Tabs2.prototype.getInitialSelectedTabId = function () {
        // NOTE: providing an unknown ID will hide the selection
        var _a = this.props, defaultSelectedTabId = _a.defaultSelectedTabId, selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) {
            return selectedTabId;
        }
        else if (defaultSelectedTabId !== undefined) {
            return defaultSelectedTabId;
        }
        else {
            // select first tab in absence of user input
            var tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    };
    Tabs2.prototype.getKeyCodeDirection = function (e) {
        if (isEventKeyCode(e, __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_LEFT"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_UP"])) {
            return -1;
        }
        else if (isEventKeyCode(e, __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_RIGHT"], __WEBPACK_IMPORTED_MODULE_6__common_keys__["ARROW_DOWN"])) {
            return 1;
        }
        return undefined;
    };
    Tabs2.prototype.getTabChildrenProps = function (props) {
        if (props === void 0) { props = this.props; }
        return this.getTabChildren(props).map(function (child) { return child.props; });
    };
    /** Filters children to only `<Tab>`s */
    Tabs2.prototype.getTabChildren = function (props) {
        if (props === void 0) { props = this.props; }
        return __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(props.children).filter(isTab);
    };
    /** Queries root HTML element for all `.pt-tab`s with optional filter selector */
    Tabs2.prototype.getTabElements = function (subselector) {
        if (subselector === void 0) { subselector = ""; }
        if (this.tablistElement == null) {
            return [];
        }
        return this.tablistElement.queryAll(TAB_SELECTOR + subselector);
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */
    Tabs2.prototype.moveSelectionIndicator = function () {
        if (this.tablistElement === undefined || !this.props.animate) {
            return;
        }
        var tabIdSelector = TAB_SELECTOR + "[data-tab-id=\"" + this.state.selectedTabId + "\"]";
        var selectedTabElement = this.tablistElement.query(tabIdSelector);
        var indicatorWrapperStyle = { display: "none" };
        if (selectedTabElement != null) {
            var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
                width: clientWidth,
            };
        }
        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
    };
    /** Insert a `Tabs2.Expander` between any two children to right-align all subsequent children. */
    Tabs2.Expander = Expander;
    Tabs2.Tab = __WEBPACK_IMPORTED_MODULE_8__tab2__["a" /* Tab2 */];
    Tabs2.defaultProps = {
        animate: true,
        large: false,
        renderActiveTabPanelOnly: false,
        vertical: false,
    };
    Tabs2.displayName = "Blueprint.Tabs2";
    Tabs2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tabs2);
    return Tabs2;
}(__WEBPACK_IMPORTED_MODULE_4__common_abstractComponent__["a" /* AbstractComponent */]));

var Tabs2Factory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tabs2);
function isEventKeyCode(e) {
    var codes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        codes[_i - 1] = arguments[_i];
    }
    return codes.indexOf(e.which) >= 0;
}
function isTab(child) {
    return child != null && child.type === __WEBPACK_IMPORTED_MODULE_8__tab2__["a" /* Tab2 */];
}


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TagFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_props__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */







var Tag = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tag, _super);
    function Tag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRemoveClick = function (e) {
            __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].safeInvoke(_this.props.onRemove, e, _this.props);
        };
        return _this;
    }
    Tag.prototype.render = function () {
        var _a = this.props, active = _a.active, className = _a.className, intent = _a.intent, onRemove = _a.onRemove;
        var tagClasses = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_6__common_classes__["TAG"], __WEBPACK_IMPORTED_MODULE_6__common_classes__["intentClass"](intent), (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_6__common_classes__["TAG_REMOVABLE"]] = onRemove != null,
            _b[__WEBPACK_IMPORTED_MODULE_6__common_classes__["ACTIVE"]] = active,
            _b), className);
        var button = __WEBPACK_IMPORTED_MODULE_4__common__["c" /* Utils */].isFunction(onRemove) ? (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("button", { type: "button", className: __WEBPACK_IMPORTED_MODULE_6__common_classes__["TAG_REMOVE"], onClick: this.onRemoveClick })) : (undefined);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_props__["a" /* removeNonHTMLProps */])(this.props), { className: tagClasses }),
            this.props.children,
            button));
        var _b;
    };
    Tag.displayName = "Blueprint.Tag";
    Tag = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Tag);
    return Tag;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));

var TagFactory = __WEBPACK_IMPORTED_MODULE_3_react__["createFactory"](Tag);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_classes__ = __webpack_require__(23);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





var Text = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isContentOverflowing: false,
            textContent: "",
        };
        _this.refHandlers = {
            text: function (overflowElement) { return (_this.textRef = overflowElement); },
        };
        return _this;
    }
    Text.prototype.componentDidMount = function () {
        this.update();
    };
    Text.prototype.componentDidUpdate = function () {
        this.update();
    };
    Text.prototype.render = function () {
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__((_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_4__common_classes__["TEXT_OVERFLOW_ELLIPSIS"]] = this.props.ellipsize,
            _a), this.props.className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: classes, ref: this.refHandlers.text, title: this.state.isContentOverflowing ? this.state.textContent : undefined }, this.props.children));
        var _a;
    };
    Text.prototype.update = function () {
        var newState = {
            isContentOverflowing: this.props.ellipsize && this.textRef.scrollWidth > this.textRef.clientWidth,
            textContent: this.textRef.textContent,
        };
        this.setState(newState);
    };
    Text = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Text);
    return Text;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));



/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toaster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_abstractComponent__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_errors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_keys__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_position__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__overlay_overlay__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__toast__ = __webpack_require__(464);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */













var Toaster = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Toaster, _super);
    function Toaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toasts: [],
        };
        // auto-incrementing identifier for un-keyed toasts
        _this.toastId = 0;
        _this.getDismissHandler = function (toast) { return function (timeoutExpired) {
            _this.dismiss(toast.key, timeoutExpired);
        }; };
        _this.handleClose = function (e) {
            // NOTE that `e` isn't always a KeyboardEvent but that's the only type we care about
            if (e.which === __WEBPACK_IMPORTED_MODULE_8__common_keys__["ESCAPE"]) {
                _this.clear();
            }
        };
        return _this;
    }
    Toaster_1 = Toaster;
    /**
     * Create a new `Toaster` instance that can be shared around your application.
     * The `Toaster` will be rendered into a new element appended to the given container.
     */
    Toaster.create = function (props, container) {
        if (container === void 0) { container = document.body; }
        if (props != null && props.inline != null && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_utils__["isNodeEnv"])("production")) {
            console.warn(__WEBPACK_IMPORTED_MODULE_7__common_errors__["b" /* TOASTER_WARN_INLINE */]);
        }
        var containerElement = document.createElement("div");
        container.appendChild(containerElement);
        var toaster = __WEBPACK_IMPORTED_MODULE_4_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Toaster_1, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, props, { inline: true })), containerElement);
        if (toaster == null) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_7__common_errors__["c" /* TOASTER_CREATE_NULL */]);
        }
        return toaster;
    };
    Toaster.prototype.show = function (props) {
        var options = this.createToastOptions(props);
        this.setState(function (prevState) { return ({
            toasts: [options].concat(prevState.toasts),
        }); });
        return options.key;
    };
    Toaster.prototype.update = function (key, props) {
        var options = this.createToastOptions(props, key);
        this.setState(function (prevState) { return ({
            toasts: prevState.toasts.map(function (t) { return (t.key === key ? options : t); }),
        }); });
    };
    Toaster.prototype.dismiss = function (key, timeoutExpired) {
        if (timeoutExpired === void 0) { timeoutExpired = false; }
        this.setState(function (_a) {
            var toasts = _a.toasts;
            return ({
                toasts: toasts.filter(function (t) {
                    var matchesKey = t.key === key;
                    if (matchesKey) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_utils__["safeInvoke"])(t.onDismiss, timeoutExpired);
                    }
                    return !matchesKey;
                }),
            });
        });
    };
    Toaster.prototype.clear = function () {
        this.state.toasts.map(function (t) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_utils__["safeInvoke"])(t.onDismiss, false); });
        this.setState({ toasts: [] });
    };
    Toaster.prototype.getToasts = function () {
        return this.state.toasts;
    };
    Toaster.prototype.render = function () {
        // $pt-transition-duration * 3 + $pt-transition-duration / 2
        var classes = __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_6__common_classes__["TOAST_CONTAINER"], this.getPositionClasses(), this.props.className);
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__overlay_overlay__["a" /* Overlay */], { autoFocus: this.props.autoFocus, canEscapeKeyClose: this.props.canEscapeKeyClear, canOutsideClickClose: false, className: classes, enforceFocus: false, hasBackdrop: false, inline: this.props.inline, isOpen: this.state.toasts.length > 0, onClose: this.handleClose, transitionDuration: 350, transitionName: "pt-toast" }, this.state.toasts.map(this.renderToast, this)));
    };
    Toaster.prototype.validateProps = function (props) {
        if (props.position === __WEBPACK_IMPORTED_MODULE_9__common_position__["a" /* Position */].LEFT || props.position === __WEBPACK_IMPORTED_MODULE_9__common_position__["a" /* Position */].RIGHT) {
            console.warn(__WEBPACK_IMPORTED_MODULE_7__common_errors__["d" /* TOASTER_WARN_LEFT_RIGHT */]);
        }
    };
    Toaster.prototype.renderToast = function (toast) {
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__toast__["a" /* Toast */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, toast, { onDismiss: this.getDismissHandler(toast) }));
    };
    Toaster.prototype.createToastOptions = function (props, key) {
        if (key === void 0) { key = "toast-" + this.toastId++; }
        // clone the object before adding the key prop to avoid leaking the mutation
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, props, { key: key });
    };
    Toaster.prototype.getPositionClasses = function () {
        var positions = __WEBPACK_IMPORTED_MODULE_9__common_position__["a" /* Position */][this.props.position].split("_");
        // NOTE that there is no -center class because that's the default style
        return positions.map(function (p) { return __WEBPACK_IMPORTED_MODULE_6__common_classes__["TOAST_CONTAINER"] + "-" + p.toLowerCase(); });
    };
    Toaster.defaultProps = {
        autoFocus: false,
        canEscapeKeyClear: true,
        inline: false,
        position: __WEBPACK_IMPORTED_MODULE_9__common_position__["a" /* Position */].TOP,
    };
    Toaster = Toaster_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_pure_render_decorator__
    ], Toaster);
    return Toaster;
    var Toaster_1;
}(__WEBPACK_IMPORTED_MODULE_5__common_abstractComponent__["a" /* AbstractComponent */]));



/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVGTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SVGTooltipFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip__ = __webpack_require__(303);
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



var SVGTooltip = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](SVGTooltip, _super);
    function SVGTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGTooltip.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__tooltip__["a" /* Tooltip */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({ rootElementTag: "g" }, this.props), this.props.children));
    };
    return SVGTooltip;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var SVGTooltipFactory = __WEBPACK_IMPORTED_MODULE_1_react__["createFactory"](SVGTooltip);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TreeFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_classes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__treeNode__ = __webpack_require__(465);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var Tree = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nodeRefs = {};
        _this.handleNodeCollapse = function (node, e) {
            _this.handlerHelper(_this.props.onNodeCollapse, node, e);
        };
        _this.handleNodeClick = function (node, e) {
            _this.handlerHelper(_this.props.onNodeClick, node, e);
        };
        _this.handleContentRef = function (node, element) {
            if (element != null) {
                _this.nodeRefs[node.props.id] = element;
            }
            else {
                // don't want our object to get bloated with old keys
                delete _this.nodeRefs[node.props.id];
            }
        };
        _this.handleNodeContextMenu = function (node, e) {
            _this.handlerHelper(_this.props.onNodeContextMenu, node, e);
        };
        _this.handleNodeDoubleClick = function (node, e) {
            _this.handlerHelper(_this.props.onNodeDoubleClick, node, e);
        };
        _this.handleNodeExpand = function (node, e) {
            _this.handlerHelper(_this.props.onNodeExpand, node, e);
        };
        return _this;
    }
    Tree.nodeFromPath = function (path, treeNodes) {
        if (path.length === 1) {
            return treeNodes[path[0]];
        }
        else {
            return Tree.nodeFromPath(path.slice(1), treeNodes[path[0]].childNodes);
        }
    };
    Tree.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE"], this.props.className) }, this.renderNodes(this.props.contents, [], __WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_ROOT"])));
    };
    /**
     * Returns the underlying HTML element of the `Tree` node with an id of `nodeId`.
     * This element does not contain the children of the node, only its label and controls.
     * If the node is not currently mounted, `undefined` is returned.
     */
    Tree.prototype.getNodeContentElement = function (nodeId) {
        return this.nodeRefs[nodeId];
    };
    Tree.prototype.renderNodes = function (treeNodes, currentPath, className) {
        var _this = this;
        if (treeNodes == null) {
            return null;
        }
        var nodeItems = treeNodes.map(function (node, i) {
            var elementPath = currentPath.concat(i);
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__treeNode__["a" /* TreeNode */], __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, node, { key: node.id, contentRef: _this.handleContentRef, depth: elementPath.length - 1, onClick: _this.handleNodeClick, onContextMenu: _this.handleNodeContextMenu, onCollapse: _this.handleNodeCollapse, onDoubleClick: _this.handleNodeDoubleClick, onExpand: _this.handleNodeExpand, path: elementPath }), _this.renderNodes(node.childNodes, elementPath)));
        });
        return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("ul", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(__WEBPACK_IMPORTED_MODULE_3__common_classes__["TREE_NODE_LIST"], className) }, nodeItems);
    };
    Tree.prototype.handlerHelper = function (handlerFromProps, node, e) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils__["isFunction"])(handlerFromProps)) {
            var nodeData = Tree.nodeFromPath(node.props.path, this.props.contents);
            handlerFromProps(nodeData, node.props.path, e);
        }
    };
    return Tree;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));

var TreeFactory = __WEBPACK_IMPORTED_MODULE_2_react__["createFactory"](Tree);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconClasses; });
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 */
// tslint:disable:object-literal-sort-keys
var IconClasses = {
    BLANK: "pt-icon-blank",
    STYLE: "pt-icon-style",
    ALIGN_LEFT: "pt-icon-align-left",
    ALIGN_CENTER: "pt-icon-align-center",
    ALIGN_RIGHT: "pt-icon-align-right",
    ALIGN_JUSTIFY: "pt-icon-align-justify",
    BOLD: "pt-icon-bold",
    ITALIC: "pt-icon-italic",
    UNDERLINE: "pt-icon-underline",
    SEARCH_AROUND: "pt-icon-search-around",
    GRAPH_REMOVE: "pt-icon-graph-remove",
    GROUP_OBJECTS: "pt-icon-group-objects",
    MERGE_LINKS: "pt-icon-merge-links",
    LAYOUT: "pt-icon-layout",
    LAYOUT_AUTO: "pt-icon-layout-auto",
    LAYOUT_CIRCLE: "pt-icon-layout-circle",
    LAYOUT_HIERARCHY: "pt-icon-layout-hierarchy",
    LAYOUT_GRID: "pt-icon-layout-grid",
    LAYOUT_GROUP_BY: "pt-icon-layout-group-by",
    LAYOUT_SKEW_GRID: "pt-icon-layout-skew-grid",
    GEOSEARCH: "pt-icon-geosearch",
    HEATMAP: "pt-icon-heatmap",
    DRIVE_TIME: "pt-icon-drive-time",
    SELECT: "pt-icon-select",
    PREDICTIVE_ANALYSIS: "pt-icon-predictive-analysis",
    LAYERS: "pt-icon-layers",
    LOCATE: "pt-icon-locate",
    BOOKMARK: "pt-icon-bookmark",
    CITATION: "pt-icon-citation",
    TAG: "pt-icon-tag",
    CLIPBOARD: "pt-icon-clipboard",
    SELECTION: "pt-icon-selection",
    TIMELINE_EVENTS: "pt-icon-timeline-events",
    TIMELINE_LINE_CHART: "pt-icon-timeline-line-chart",
    TIMELINE_BAR_CHART: "pt-icon-timeline-bar-chart",
    APPLICATIONS: "pt-icon-applications",
    PROJECTS: "pt-icon-projects",
    CHANGES: "pt-icon-changes",
    NOTIFICATIONS: "pt-icon-notifications",
    LOCK: "pt-icon-lock",
    UNLOCK: "pt-icon-unlock",
    USER: "pt-icon-user",
    SEARCH_TEMPLATE: "pt-icon-search-template",
    INBOX: "pt-icon-inbox",
    MORE: "pt-icon-more",
    HELP: "pt-icon-help",
    CALENDAR: "pt-icon-calendar",
    MEDIA: "pt-icon-media",
    LINK: "pt-icon-link",
    SHARE: "pt-icon-share",
    DOWNLOAD: "pt-icon-download",
    DOCUMENT: "pt-icon-document",
    PROPERTIES: "pt-icon-properties",
    IMPORT: "pt-icon-import",
    EXPORT: "pt-icon-export",
    MINIMIZE: "pt-icon-minimize",
    MAXIMIZE: "pt-icon-maximize",
    TICK: "pt-icon-tick",
    CROSS: "pt-icon-cross",
    PLUS: "pt-icon-plus",
    MINUS: "pt-icon-minus",
    ARROW_LEFT: "pt-icon-arrow-left",
    ARROW_RIGHT: "pt-icon-arrow-right",
    EXCHANGE: "pt-icon-exchange",
    COMPARISON: "pt-icon-comparison",
    LIST: "pt-icon-list",
    FILTER: "pt-icon-filter",
    CONFIRM: "pt-icon-confirm",
    FORK: "pt-icon-fork",
    TRASH: "pt-icon-trash",
    PERSON: "pt-icon-person",
    PEOPLE: "pt-icon-people",
    ADD: "pt-icon-add",
    REMOVE: "pt-icon-remove",
    GEOLOCATION: "pt-icon-geolocation",
    ZOOM_IN: "pt-icon-zoom-in",
    ZOOM_OUT: "pt-icon-zoom-out",
    REFRESH: "pt-icon-refresh",
    DELETE: "pt-icon-delete",
    COG: "pt-icon-cog",
    FLAG: "pt-icon-flag",
    PIN: "pt-icon-pin",
    WARNING_SIGN: "pt-icon-warning-sign",
    ERROR: "pt-icon-error",
    INFO_SIGN: "pt-icon-info-sign",
    CREDIT_CARD: "pt-icon-credit-card",
    EDIT: "pt-icon-edit",
    HISTORY: "pt-icon-history",
    SEARCH: "pt-icon-search",
    LOG_OUT: "pt-icon-log-out",
    STAR: "pt-icon-star",
    STAR_EMPTY: "pt-icon-star-empty",
    SORT_ALPHABETICAL: "pt-icon-sort-alphabetical",
    SORT_NUMERICAL: "pt-icon-sort-numerical",
    SORT: "pt-icon-sort",
    FOLDER_OPEN: "pt-icon-folder-open",
    FOLDER_CLOSE: "pt-icon-folder-close",
    FOLDER_SHARED: "pt-icon-folder-shared",
    CARET_UP: "pt-icon-caret-up",
    CARET_RIGHT: "pt-icon-caret-right",
    CARET_DOWN: "pt-icon-caret-down",
    CARET_LEFT: "pt-icon-caret-left",
    MENU_OPEN: "pt-icon-menu-open",
    MENU_CLOSED: "pt-icon-menu-closed",
    FEED: "pt-icon-feed",
    TWO_COLUMNS: "pt-icon-two-columns",
    ONE_COLUMN: "pt-icon-one-column",
    DOT: "pt-icon-dot",
    PROPERTY: "pt-icon-property",
    TIME: "pt-icon-time",
    DISABLE: "pt-icon-disable",
    UNPIN: "pt-icon-unpin",
    FLOWS: "pt-icon-flows",
    NEW_TEXT_BOX: "pt-icon-new-text-box",
    NEW_LINK: "pt-icon-new-link",
    NEW_OBJECT: "pt-icon-new-object",
    PATH_SEARCH: "pt-icon-path-search",
    AUTOMATIC_UPDATES: "pt-icon-automatic-updates",
    PAGE_LAYOUT: "pt-icon-page-layout",
    CODE: "pt-icon-code",
    MAP: "pt-icon-map",
    SEARCH_TEXT: "pt-icon-search-text",
    ENVELOPE: "pt-icon-envelope",
    PAPERCLIP: "pt-icon-paperclip",
    LABEL: "pt-icon-label",
    GLOBE: "pt-icon-globe",
    HOME: "pt-icon-home",
    TH: "pt-icon-th",
    TH_LIST: "pt-icon-th-list",
    TH_DERIVED: "pt-icon-th-derived",
    CIRCLE: "pt-icon-circle",
    DRAW: "pt-icon-draw",
    INSERT: "pt-icon-insert",
    HELPER_MANAGEMENT: "pt-icon-helper-management",
    SEND_TO: "pt-icon-send-to",
    EYE_OPEN: "pt-icon-eye-open",
    FOLDER_SHARED_OPEN: "pt-icon-folder-shared-open",
    SOCIAL_MEDIA: "pt-icon-social-media",
    ARROW_UP: "pt-icon-arrow-up",
    ARROW_DOWN: "pt-icon-arrow-down",
    ARROWS_HORIZONTAL: "pt-icon-arrows-horizontal",
    ARROWS_VERTICAL: "pt-icon-arrows-vertical",
    RESOLVE: "pt-icon-resolve",
    GRAPH: "pt-icon-graph",
    BRIEFCASE: "pt-icon-briefcase",
    DOLLAR: "pt-icon-dollar",
    NINJA: "pt-icon-ninja",
    DELTA: "pt-icon-delta",
    BARCODE: "pt-icon-barcode",
    TORCH: "pt-icon-torch",
    WIDGET: "pt-icon-widget",
    UNRESOLVE: "pt-icon-unresolve",
    OFFLINE: "pt-icon-offline",
    ZOOM_TO_FIT: "pt-icon-zoom-to-fit",
    ADD_TO_ARTIFACT: "pt-icon-add-to-artifact",
    MAP_MARKER: "pt-icon-map-marker",
    CHART: "pt-icon-chart",
    CONTROL: "pt-icon-control",
    MULTI_SELECT: "pt-icon-multi-select",
    DIRECTION_LEFT: "pt-icon-direction-left",
    DIRECTION_RIGHT: "pt-icon-direction-right",
    DATABASE: "pt-icon-database",
    PIE_CHART: "pt-icon-pie-chart",
    FULL_CIRCLE: "pt-icon-full-circle",
    SQUARE: "pt-icon-square",
    PRINT: "pt-icon-print",
    PRESENTATION: "pt-icon-presentation",
    UNGROUP_OBJECTS: "pt-icon-ungroup-objects",
    CHAT: "pt-icon-chat",
    COMMENT: "pt-icon-comment",
    CIRCLE_ARROW_RIGHT: "pt-icon-circle-arrow-right",
    CIRCLE_ARROW_LEFT: "pt-icon-circle-arrow-left",
    CIRCLE_ARROW_UP: "pt-icon-circle-arrow-up",
    CIRCLE_ARROW_DOWN: "pt-icon-circle-arrow-down",
    UPLOAD: "pt-icon-upload",
    ASTERISK: "pt-icon-asterisk",
    CLOUD: "pt-icon-cloud",
    CLOUD_DOWNLOAD: "pt-icon-cloud-download",
    CLOUD_UPLOAD: "pt-icon-cloud-upload",
    REPEAT: "pt-icon-repeat",
    MOVE: "pt-icon-move",
    CHEVRON_LEFT: "pt-icon-chevron-left",
    CHEVRON_RIGHT: "pt-icon-chevron-right",
    CHEVRON_UP: "pt-icon-chevron-up",
    CHEVRON_DOWN: "pt-icon-chevron-down",
    RANDOM: "pt-icon-random",
    FULLSCREEN: "pt-icon-fullscreen",
    LOG_IN: "pt-icon-log-in",
    HEART: "pt-icon-heart",
    OFFICE: "pt-icon-office",
    DUPLICATE: "pt-icon-duplicate",
    BAN_CIRCLE: "pt-icon-ban-circle",
    CAMERA: "pt-icon-camera",
    MOBILE_VIDEO: "pt-icon-mobile-video",
    VIDEO: "pt-icon-video",
    FILM: "pt-icon-film",
    SETTINGS: "pt-icon-settings",
    VOLUME_OFF: "pt-icon-volume-off",
    VOLUME_DOWN: "pt-icon-volume-down",
    VOLUME_UP: "pt-icon-volume-up",
    MUSIC: "pt-icon-music",
    STEP_BACKWARD: "pt-icon-step-backward",
    FAST_BACKWARD: "pt-icon-fast-backward",
    PAUSE: "pt-icon-pause",
    STOP: "pt-icon-stop",
    PLAY: "pt-icon-play",
    FAST_FORWARD: "pt-icon-fast-forward",
    STEP_FORWARD: "pt-icon-step-forward",
    EJECT: "pt-icon-eject",
    RECORD: "pt-icon-record",
    DESKTOP: "pt-icon-desktop",
    PHONE: "pt-icon-phone",
    LIGHTBULB: "pt-icon-lightbulb",
    GLASS: "pt-icon-glass",
    TINT: "pt-icon-tint",
    FLASH: "pt-icon-flash",
    FONT: "pt-icon-font",
    HEADER: "pt-icon-header",
    SAVED: "pt-icon-saved",
    FLOPPY_DISK: "pt-icon-floppy-disk",
    BOOK: "pt-icon-book",
    HAND_RIGHT: "pt-icon-hand-right",
    HAND_UP: "pt-icon-hand-up",
    HAND_DOWN: "pt-icon-hand-down",
    HAND_LEFT: "pt-icon-hand-left",
    THUMBS_UP: "pt-icon-thumbs-up",
    THUMBS_DOWN: "pt-icon-thumbs-down",
    BOX: "pt-icon-box",
    COMPRESSED: "pt-icon-compressed",
    SHOPPING_CART: "pt-icon-shopping-cart",
    SHOP: "pt-icon-shop",
    LAYOUT_LINEAR: "pt-icon-layout-linear",
    UNDO: "pt-icon-undo",
    REDO: "pt-icon-redo",
    CODE_BLOCK: "pt-icon-code-block",
    DOUBLE_CARET_VERTICAL: "pt-icon-double-caret-vertical",
    DOUBLE_CARET_HORIZONTAL: "pt-icon-double-caret-horizontal",
    SORT_ALPHABETICAL_DESC: "pt-icon-sort-alphabetical-desc",
    SORT_NUMERICAL_DESC: "pt-icon-sort-numerical-desc",
    TAKE_ACTION: "pt-icon-take-action",
    CONTRAST: "pt-icon-contrast",
    EYE_OFF: "pt-icon-eye-off",
    TIMELINE_AREA_CHART: "pt-icon-timeline-area-chart",
    DOUGHNUT_CHART: "pt-icon-doughnut-chart",
    LAYER: "pt-icon-layer",
    GRID: "pt-icon-grid",
    POLYGON_FILTER: "pt-icon-polygon-filter",
    ADD_TO_FOLDER: "pt-icon-add-to-folder",
    LAYOUT_BALLOON: "pt-icon-layout-balloon",
    LAYOUT_SORTED_CLUSTERS: "pt-icon-layout-sorted-clusters",
    SORT_ASC: "pt-icon-sort-asc",
    SORT_DESC: "pt-icon-sort-desc",
    SMALL_CROSS: "pt-icon-small-cross",
    SMALL_TICK: "pt-icon-small-tick",
    POWER: "pt-icon-power",
    COLUMN_LAYOUT: "pt-icon-column-layout",
    ARROW_TOP_LEFT: "pt-icon-arrow-top-left",
    ARROW_TOP_RIGHT: "pt-icon-arrow-top-right",
    ARROW_BOTTOM_RIGHT: "pt-icon-arrow-bottom-right",
    ARROW_BOTTOM_LEFT: "pt-icon-arrow-bottom-left",
    MUGSHOT: "pt-icon-mugshot",
    HEADSET: "pt-icon-headset",
    TEXT_HIGHLIGHT: "pt-icon-text-highlight",
    HAND: "pt-icon-hand",
    CHEVRON_BACKWARD: "pt-icon-chevron-backward",
    CHEVRON_FORWARD: "pt-icon-chevron-forward",
    ROTATE_DOCUMENT: "pt-icon-rotate-document",
    ROTATE_PAGE: "pt-icon-rotate-page",
    BADGE: "pt-icon-badge",
    GRID_VIEW: "pt-icon-grid-view",
    FUNCTION: "pt-icon-function",
    WATERFALL_CHART: "pt-icon-waterfall-chart",
    STACKED_CHART: "pt-icon-stacked-chart",
    PULSE: "pt-icon-pulse",
    NEW_PERSON: "pt-icon-new-person",
    EXCLUDE_ROW: "pt-icon-exclude-row",
    PIVOT_TABLE: "pt-icon-pivot-table",
    SEGMENTED_CONTROL: "pt-icon-segmented-control",
    HIGHLIGHT: "pt-icon-highlight",
    FILTER_LIST: "pt-icon-filter-list",
    CUT: "pt-icon-cut",
    ANNOTATION: "pt-icon-annotation",
    PIVOT: "pt-icon-pivot",
    RING: "pt-icon-ring",
    HEAT_GRID: "pt-icon-heat-grid",
    GANTT_CHART: "pt-icon-gantt-chart",
    VARIABLE: "pt-icon-variable",
    MANUAL: "pt-icon-manual",
    ADD_ROW_TOP: "pt-icon-add-row-top",
    ADD_ROW_BOTTOM: "pt-icon-add-row-bottom",
    ADD_COLUMN_LEFT: "pt-icon-add-column-left",
    ADD_COLUMN_RIGHT: "pt-icon-add-column-right",
    REMOVE_ROW_TOP: "pt-icon-remove-row-top",
    REMOVE_ROW_BOTTOM: "pt-icon-remove-row-bottom",
    REMOVE_COLUMN_LEFT: "pt-icon-remove-column-left",
    REMOVE_COLUMN_RIGHT: "pt-icon-remove-column-right",
    DOUBLE_CHEVRON_LEFT: "pt-icon-double-chevron-left",
    DOUBLE_CHEVRON_RIGHT: "pt-icon-double-chevron-right",
    DOUBLE_CHEVRON_UP: "pt-icon-double-chevron-up",
    DOUBLE_CHEVRON_DOWN: "pt-icon-double-chevron-down",
    KEY_CONTROL: "pt-icon-key-control",
    KEY_COMMAND: "pt-icon-key-command",
    KEY_SHIFT: "pt-icon-key-shift",
    KEY_BACKSPACE: "pt-icon-key-backspace",
    KEY_DELETE: "pt-icon-key-delete",
    KEY_ESCAPE: "pt-icon-key-escape",
    KEY_ENTER: "pt-icon-key-enter",
    CALCULATOR: "pt-icon-calculator",
    HORIZONTAL_BAR_CHART: "pt-icon-horizontal-bar-chart",
    SMALL_PLUS: "pt-icon-small-plus",
    SMALL_MINUS: "pt-icon-small-minus",
    STEP_CHART: "pt-icon-step-chart",
    EURO: "pt-icon-euro",
    DRAG_HANDLE_VERTICAL: "pt-icon-drag-handle-vertical",
    DRAG_HANDLE_HORIZONTAL: "pt-icon-drag-handle-horizontal",
    MOBILE_PHONE: "pt-icon-mobile-phone",
    SIM_CARD: "pt-icon-sim-card",
    TRENDING_UP: "pt-icon-trending-up",
    TRENDING_DOWN: "pt-icon-trending-down",
    CURVED_RANGE_CHART: "pt-icon-curved-range-chart",
    VERTICAL_BAR_CHART_DESC: "pt-icon-vertical-bar-chart-desc",
    HORIZONTAL_BAR_CHART_DESC: "pt-icon-horizontal-bar-chart-desc",
    DOCUMENT_OPEN: "pt-icon-document-open",
    DOCUMENT_SHARE: "pt-icon-document-share",
    HORIZONTAL_DISTRIBUTION: "pt-icon-horizontal-distribution",
    VERTICAL_DISTRIBUTION: "pt-icon-vertical-distribution",
    ALIGNMENT_LEFT: "pt-icon-alignment-left",
    ALIGNMENT_VERTICAL_CENTER: "pt-icon-alignment-vertical-center",
    ALIGNMENT_RIGHT: "pt-icon-alignment-right",
    ALIGNMENT_TOP: "pt-icon-alignment-top",
    ALIGNMENT_HORIZONTAL_CENTER: "pt-icon-alignment-horizontal-center",
    ALIGNMENT_BOTTOM: "pt-icon-alignment-bottom",
    GIT_PULL: "pt-icon-git-pull",
    GIT_MERGE: "pt-icon-git-merge",
    GIT_BRANCH: "pt-icon-git-branch",
    GIT_COMMIT: "pt-icon-git-commit",
    GIT_PUSH: "pt-icon-git-push",
    BUILD: "pt-icon-build",
    SYMBOL_CIRCLE: "pt-icon-symbol-circle",
    SYMBOL_SQUARE: "pt-icon-symbol-square",
    SYMBOL_DIAMOND: "pt-icon-symbol-diamond",
    SYMBOL_CROSS: "pt-icon-symbol-cross",
    SYMBOL_TRIANGLE_UP: "pt-icon-symbol-triangle-up",
    SYMBOL_TRIANGLE_DOWN: "pt-icon-symbol-triangle-down",
    WRENCH: "pt-icon-wrench",
    APPLICATION: "pt-icon-application",
    SEND_TO_GRAPH: "pt-icon-send-to-graph",
    SEND_TO_MAP: "pt-icon-send-to-map",
    JOIN_TABLE: "pt-icon-join-table",
    DERIVE_COLUMN: "pt-icon-derive-column",
    IMAGE_ROTATE_LEFT: "pt-icon-image-rotate-left",
    IMAGE_ROTATE_RIGHT: "pt-icon-image-rotate-right",
    KNOWN_VEHICLE: "pt-icon-known-vehicle",
    UNKNOWN_VEHICLE: "pt-icon-unknown-vehicle",
    SCATTER_PLOT: "pt-icon-scatter-plot",
    OIL_FIELD: "pt-icon-oil-field",
    RIG: "pt-icon-rig",
    MAP_CREATE: "pt-icon-map-create",
    KEY_OPTION: "pt-icon-key-option",
    LIST_DETAIL_VIEW: "pt-icon-list-detail-view",
    SWAP_VERTICAL: "pt-icon-swap-vertical",
    SWAP_HORIZONTAL: "pt-icon-swap-horizontal",
    NUMBERED_LIST: "pt-icon-numbered-list",
    NEW_GRID_ITEM: "pt-icon-new-grid-item",
    GIT_REPO: "pt-icon-git-repo",
    GIT_NEW_BRANCH: "pt-icon-git-new-branch",
    MANUALLY_ENTERED_DATA: "pt-icon-manually-entered-data",
    AIRPLANE: "pt-icon-airplane",
    MERGE_COLUMNS: "pt-icon-merge-columns",
    SPLIT_COLUMNS: "pt-icon-split-columns",
    DASHBOARD: "pt-icon-dashboard",
    PUBLISH_FUNCTION: "pt-icon-publish-function",
    PATH: "pt-icon-path",
    MOON: "pt-icon-moon",
    REMOVE_COLUMN: "pt-icon-remove-column",
    NUMERICAL: "pt-icon-numerical",
    KEY_TAB: "pt-icon-key-tab",
    REGRESSION_CHART: "pt-icon-regression-chart",
    TRANSLATE: "pt-icon-translate",
    EYE_ON: "pt-icon-eye-on",
    VERTICAL_BAR_CHART_ASC: "pt-icon-vertical-bar-chart-asc",
    HORIZONTAL_BAR_CHART_ASC: "pt-icon-horizontal-bar-chart-asc",
    GROUPED_BAR_CHART: "pt-icon-grouped-bar-chart",
    FULL_STACKED_CHART: "pt-icon-full-stacked-chart",
    ENDORSED: "pt-icon-endorsed",
    FOLLOWER: "pt-icon-follower",
    FOLLOWING: "pt-icon-following",
    MENU: "pt-icon-menu",
    COLLAPSE_ALL: "pt-icon-collapse-all",
    EXPAND_ALL: "pt-icon-expand-all",
    INTERSECTION: "pt-icon-intersection",
    BLOCKED_PERSON: "pt-icon-blocked-person",
    SLASH: "pt-icon-slash",
    PERCENTAGE: "pt-icon-percentage",
    SATELLITE: "pt-icon-satellite",
    PARAGRAPH: "pt-icon-paragraph",
    BANK_ACCOUNT: "pt-icon-bank-account",
    CELL_TOWER: "pt-icon-cell-tower",
    ID_NUMBER: "pt-icon-id-number",
    IP_ADDRESS: "pt-icon-ip-address",
    ERASER: "pt-icon-eraser",
    ISSUE: "pt-icon-issue",
    ISSUE_NEW: "pt-icon-issue-new",
    ISSUE_CLOSED: "pt-icon-issue-closed",
    PANEL_STATS: "pt-icon-panel-stats",
    PANEL_TABLE: "pt-icon-panel-table",
    TICK_CIRCLE: "pt-icon-tick-circle",
    PRESCRIPTION: "pt-icon-prescription",
    NEW_PRESCRIPTION: "pt-icon-new-prescription",
    FILTER_KEEP: "pt-icon-filter-keep",
    FILTER_REMOVE: "pt-icon-filter-remove",
    KEY: "pt-icon-key",
    FEED_SUBSCRIBED: "pt-icon-feed-subscribed",
    WIDGET_BUTTON: "pt-icon-widget-button",
    WIDGET_HEADER: "pt-icon-widget-header",
    WIDGET_FOOTER: "pt-icon-widget-footer",
    HEADER_ONE: "pt-icon-header-one",
    HEADER_TWO: "pt-icon-header-two",
    FORM: "pt-icon-form",
    SERIES_ADD: "pt-icon-series-add",
    SERIES_SEARCH: "pt-icon-series-search",
    SERIES_FILTERED: "pt-icon-series-filtered",
    SERIES_DERIVED: "pt-icon-series-derived",
    SERIES_CONFIGURATION: "pt-icon-series-configuration",
    CONSOLE: "pt-icon-console",
    COMPASS: "pt-icon-compass",
    WALK: "pt-icon-walk",
    TAXI: "pt-icon-taxi",
    TRAIN: "pt-icon-train",
    HEART_BROKEN: "pt-icon-heart-broken",
    INNER_JOIN: "pt-icon-inner-join",
    LEFT_JOIN: "pt-icon-left-join",
    RIGHT_JOIN: "pt-icon-right-join",
    STRIKETHROUGH: "pt-icon-strikethrough",
    UPDATED: "pt-icon-updated",
    OUTDATED: "pt-icon-outdated",
    FLAME: "pt-icon-flame",
    FOLDER_NEW: "pt-icon-folder-new",
    MOUNTAIN: "pt-icon-mountain",
    SHIELD: "pt-icon-shield",
    DIAGRAM_TREE: "pt-icon-diagram-tree",
    CROWN: "pt-icon-crown",
    GLOBE_NETWORK: "pt-icon-globe-network",
    SNOWFLAKE: "pt-icon-snowflake",
    TREE: "pt-icon-tree",
    NOTIFICATIONS_UPDATED: "pt-icon-notifications-updated",
    LIST_COLUMNS: "pt-icon-list-columns",
    FLOW_LINEAR: "pt-icon-flow-linear",
    FLOW_BRANCH: "pt-icon-flow-branch",
    FLOW_REVIEW: "pt-icon-flow-review",
    FLOW_REVIEW_BRANCH: "pt-icon-flow-review-branch",
    FLOW_END: "pt-icon-flow-end",
};


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconContents; });
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 */
// tslint:disable:object-literal-sort-keys
var IconContents = {
    BLANK: "\ue900",
    STYLE: "\ue601",
    ALIGN_LEFT: "\ue602",
    ALIGN_CENTER: "\ue603",
    ALIGN_RIGHT: "\ue604",
    ALIGN_JUSTIFY: "\ue605",
    BOLD: "\ue606",
    ITALIC: "\ue607",
    UNDERLINE: "\u2381",
    SEARCH_AROUND: "\ue608",
    GRAPH_REMOVE: "\ue609",
    GROUP_OBJECTS: "\ue60a",
    MERGE_LINKS: "\ue60b",
    LAYOUT: "\ue60c",
    LAYOUT_AUTO: "\ue60d",
    LAYOUT_CIRCLE: "\ue60e",
    LAYOUT_HIERARCHY: "\ue60f",
    LAYOUT_GRID: "\ue610",
    LAYOUT_GROUP_BY: "\ue611",
    LAYOUT_SKEW_GRID: "\ue612",
    GEOSEARCH: "\ue613",
    HEATMAP: "\ue614",
    DRIVE_TIME: "\ue615",
    SELECT: "\ue616",
    PREDICTIVE_ANALYSIS: "\ue617",
    LAYERS: "\ue618",
    LOCATE: "\ue619",
    BOOKMARK: "\ue61a",
    CITATION: "\ue61b",
    TAG: "\ue61c",
    CLIPBOARD: "\ue61d",
    SELECTION: "\u29bf",
    TIMELINE_EVENTS: "\ue61e",
    TIMELINE_LINE_CHART: "\ue61f",
    TIMELINE_BAR_CHART: "\ue620",
    APPLICATIONS: "\ue621",
    PROJECTS: "\ue622",
    CHANGES: "\ue623",
    NOTIFICATIONS: "\ue624",
    LOCK: "\ue625",
    UNLOCK: "\ue626",
    USER: "\ue627",
    SEARCH_TEMPLATE: "\ue628",
    INBOX: "\ue629",
    MORE: "\ue62a",
    HELP: "\u003F",
    CALENDAR: "\ue62b",
    MEDIA: "\ue62c",
    LINK: "\ue62d",
    SHARE: "\ue62e",
    DOWNLOAD: "\ue62f",
    DOCUMENT: "\ue630",
    PROPERTIES: "\ue631",
    IMPORT: "\ue632",
    EXPORT: "\ue633",
    MINIMIZE: "\ue634",
    MAXIMIZE: "\ue635",
    TICK: "\u2713",
    CROSS: "\u2717",
    PLUS: "\u002b",
    MINUS: "\u2212",
    ARROW_LEFT: "\u2190",
    ARROW_RIGHT: "\u2192",
    EXCHANGE: "\ue636",
    COMPARISON: "\ue637",
    LIST: "\u2630",
    FILTER: "\ue638",
    CONFIRM: "\ue639",
    FORK: "\ue63a",
    TRASH: "\ue63b",
    PERSON: "\ue63c",
    PEOPLE: "\ue63d",
    ADD: "\ue63e",
    REMOVE: "\ue63f",
    GEOLOCATION: "\ue640",
    ZOOM_IN: "\ue641",
    ZOOM_OUT: "\ue642",
    REFRESH: "\ue643",
    DELETE: "\ue644",
    COG: "\ue645",
    FLAG: "\u2691",
    PIN: "\ue646",
    WARNING_SIGN: "\ue647",
    ERROR: "\ue648",
    INFO_SIGN: "\u2139",
    CREDIT_CARD: "\ue649",
    EDIT: "\u270E",
    HISTORY: "\ue64a",
    SEARCH: "\ue64b",
    LOG_OUT: "\ue64c",
    STAR: "\u2605",
    STAR_EMPTY: "\u2606",
    SORT_ALPHABETICAL: "\ue64d",
    SORT_NUMERICAL: "\ue64e",
    SORT: "\ue64f",
    FOLDER_OPEN: "\ue651",
    FOLDER_CLOSE: "\ue652",
    FOLDER_SHARED: "\ue653",
    CARET_UP: "\u2303",
    CARET_RIGHT: "\u232A",
    CARET_DOWN: "\u2304",
    CARET_LEFT: "\u2329",
    MENU_OPEN: "\ue654",
    MENU_CLOSED: "\ue655",
    FEED: "\ue656",
    TWO_COLUMNS: "\ue657",
    ONE_COLUMN: "\ue658",
    DOT: "\u2022",
    PROPERTY: "\ue65a",
    TIME: "\u23F2",
    DISABLE: "\ue600",
    UNPIN: "\ue650",
    FLOWS: "\ue659",
    NEW_TEXT_BOX: "\ue65b",
    NEW_LINK: "\ue65c",
    NEW_OBJECT: "\ue65d",
    PATH_SEARCH: "\ue65e",
    AUTOMATIC_UPDATES: "\ue65f",
    PAGE_LAYOUT: "\ue660",
    CODE: "\ue661",
    MAP: "\ue662",
    SEARCH_TEXT: "\ue663",
    ENVELOPE: "\u2709",
    PAPERCLIP: "\ue664",
    LABEL: "\ue665",
    GLOBE: "\ue666",
    HOME: "\u2302",
    TH: "\ue667",
    TH_LIST: "\ue668",
    TH_DERIVED: "\ue669",
    CIRCLE: "\ue66a",
    DRAW: "\ue66b",
    INSERT: "\ue66c",
    HELPER_MANAGEMENT: "\ue66d",
    SEND_TO: "\ue66e",
    EYE_OPEN: "\ue66f",
    FOLDER_SHARED_OPEN: "\ue670",
    SOCIAL_MEDIA: "\ue671",
    ARROW_UP: "\u2191 ",
    ARROW_DOWN: "\u2193 ",
    ARROWS_HORIZONTAL: "\u2194 ",
    ARROWS_VERTICAL: "\u2195 ",
    RESOLVE: "\ue672",
    GRAPH: "\ue673",
    BRIEFCASE: "\ue674",
    DOLLAR: "\u0024",
    NINJA: "\ue675",
    DELTA: "\u0394",
    BARCODE: "\ue676",
    TORCH: "\ue677",
    WIDGET: "\ue678",
    UNRESOLVE: "\ue679",
    OFFLINE: "\ue67a",
    ZOOM_TO_FIT: "\ue67b",
    ADD_TO_ARTIFACT: "\ue67c",
    MAP_MARKER: "\ue67d",
    CHART: "\ue67e",
    CONTROL: "\ue67f",
    MULTI_SELECT: "\ue680",
    DIRECTION_LEFT: "\ue681",
    DIRECTION_RIGHT: "\ue682",
    DATABASE: "\ue683",
    PIE_CHART: "\ue684",
    FULL_CIRCLE: "\ue685",
    SQUARE: "\ue686",
    PRINT: "\u2399",
    PRESENTATION: "\ue687",
    UNGROUP_OBJECTS: "\ue688",
    CHAT: "\ue689",
    COMMENT: "\ue68a",
    CIRCLE_ARROW_RIGHT: "\ue68b",
    CIRCLE_ARROW_LEFT: "\ue68c",
    CIRCLE_ARROW_UP: "\ue68d",
    CIRCLE_ARROW_DOWN: "\ue68e",
    UPLOAD: "\ue68f",
    ASTERISK: "\u002a",
    CLOUD: "\u2601",
    CLOUD_DOWNLOAD: "\ue690",
    CLOUD_UPLOAD: "\ue691",
    REPEAT: "\ue692",
    MOVE: "\ue693",
    CHEVRON_LEFT: "\ue694",
    CHEVRON_RIGHT: "\ue695",
    CHEVRON_UP: "\ue696",
    CHEVRON_DOWN: "\ue697",
    RANDOM: "\ue698",
    FULLSCREEN: "\ue699",
    LOG_IN: "\ue69a",
    HEART: "\u2665",
    OFFICE: "\ue69b",
    DUPLICATE: "\ue69c",
    BAN_CIRCLE: "\ue69d",
    CAMERA: "\ue69e",
    MOBILE_VIDEO: "\ue69f",
    VIDEO: "\ue6a0",
    FILM: "\ue6a1",
    SETTINGS: "\ue6a2",
    VOLUME_OFF: "\ue6a3",
    VOLUME_DOWN: "\ue6a4",
    VOLUME_UP: "\ue6a5",
    MUSIC: "\ue6a6",
    STEP_BACKWARD: "\ue6a7",
    FAST_BACKWARD: "\ue6a8",
    PAUSE: "\ue6a9",
    STOP: "\ue6aa",
    PLAY: "\ue6ab",
    FAST_FORWARD: "\ue6ac",
    STEP_FORWARD: "\ue6ad",
    EJECT: "\u23cf",
    RECORD: "\ue6ae",
    DESKTOP: "\ue6af",
    PHONE: "\u260e",
    LIGHTBULB: "\ue6b0",
    GLASS: "\ue6b1",
    TINT: "\ue6b2",
    FLASH: "\ue6b3",
    FONT: "\ue6b4",
    HEADER: "\ue6b5",
    SAVED: "\ue6b6",
    FLOPPY_DISK: "\ue6b7",
    BOOK: "\ue6b8",
    HAND_RIGHT: "\ue6b9",
    HAND_UP: "\ue6ba",
    HAND_DOWN: "\ue6bb",
    HAND_LEFT: "\ue6bc",
    THUMBS_UP: "\ue6bd",
    THUMBS_DOWN: "\ue6be",
    BOX: "\ue6bf",
    COMPRESSED: "\ue6c0",
    SHOPPING_CART: "\ue6c1",
    SHOP: "\ue6c2",
    LAYOUT_LINEAR: "\ue6c3",
    UNDO: "\u238c",
    REDO: "\ue6c4",
    CODE_BLOCK: "\ue6c5",
    DOUBLE_CARET_VERTICAL: "\ue6c6",
    DOUBLE_CARET_HORIZONTAL: "\ue6c7",
    SORT_ALPHABETICAL_DESC: "\ue6c8",
    SORT_NUMERICAL_DESC: "\ue6c9",
    TAKE_ACTION: "\ue6ca",
    CONTRAST: "\ue6cb",
    EYE_OFF: "\ue6cc",
    TIMELINE_AREA_CHART: "\ue6cd",
    DOUGHNUT_CHART: "\ue6ce",
    LAYER: "\ue6cf",
    GRID: "\ue6d0",
    POLYGON_FILTER: "\ue6d1",
    ADD_TO_FOLDER: "\ue6d2",
    LAYOUT_BALLOON: "\ue6d3",
    LAYOUT_SORTED_CLUSTERS: "\ue6d4",
    SORT_ASC: "\ue6d5",
    SORT_DESC: "\ue6d6",
    SMALL_CROSS: "\ue6d7",
    SMALL_TICK: "\ue6d8",
    POWER: "\ue6d9",
    COLUMN_LAYOUT: "\ue6da",
    ARROW_TOP_LEFT: "\u2196",
    ARROW_TOP_RIGHT: "\u2197",
    ARROW_BOTTOM_RIGHT: "\u2198",
    ARROW_BOTTOM_LEFT: "\u2199",
    MUGSHOT: "\ue6db",
    HEADSET: "\ue6dc",
    TEXT_HIGHLIGHT: "\ue6dd",
    HAND: "\ue6de",
    CHEVRON_BACKWARD: "\ue6df",
    CHEVRON_FORWARD: "\ue6e0",
    ROTATE_DOCUMENT: "\ue6e1",
    ROTATE_PAGE: "\ue6e2",
    BADGE: "\ue6e3",
    GRID_VIEW: "\ue6e4",
    FUNCTION: "\ue6e5",
    WATERFALL_CHART: "\ue6e6",
    STACKED_CHART: "\ue6e7",
    PULSE: "\ue6e8",
    NEW_PERSON: "\ue6e9",
    EXCLUDE_ROW: "\ue6ea",
    PIVOT_TABLE: "\ue6eb",
    SEGMENTED_CONTROL: "\ue6ec",
    HIGHLIGHT: "\ue6ed",
    FILTER_LIST: "\ue6ee",
    CUT: "\ue6ef",
    ANNOTATION: "\ue6f0",
    PIVOT: "\ue6f1",
    RING: "\ue6f2",
    HEAT_GRID: "\ue6f3",
    GANTT_CHART: "\ue6f4",
    VARIABLE: "\ue6f5",
    MANUAL: "\ue6f6",
    ADD_ROW_TOP: "\ue6f7",
    ADD_ROW_BOTTOM: "\ue6f8",
    ADD_COLUMN_LEFT: "\ue6f9",
    ADD_COLUMN_RIGHT: "\ue6fa",
    REMOVE_ROW_TOP: "\ue6fb",
    REMOVE_ROW_BOTTOM: "\ue6fc",
    REMOVE_COLUMN_LEFT: "\ue6fd",
    REMOVE_COLUMN_RIGHT: "\ue6fe",
    DOUBLE_CHEVRON_LEFT: "\ue6ff",
    DOUBLE_CHEVRON_RIGHT: "\ue701",
    DOUBLE_CHEVRON_UP: "\ue702",
    DOUBLE_CHEVRON_DOWN: "\ue703",
    KEY_CONTROL: "\ue704",
    KEY_COMMAND: "\ue705",
    KEY_SHIFT: "\ue706",
    KEY_BACKSPACE: "\ue707",
    KEY_DELETE: "\ue708",
    KEY_ESCAPE: "\ue709",
    KEY_ENTER: "\ue70a",
    CALCULATOR: "\ue70b",
    HORIZONTAL_BAR_CHART: "\ue70c",
    SMALL_PLUS: "\ue70d",
    SMALL_MINUS: "\ue70e",
    STEP_CHART: "\ue70f",
    EURO: "\u20ac",
    DRAG_HANDLE_VERTICAL: "\ue715",
    DRAG_HANDLE_HORIZONTAL: "\ue716",
    MOBILE_PHONE: "\ue717",
    SIM_CARD: "\ue718",
    TRENDING_UP: "\ue719",
    TRENDING_DOWN: "\ue71a",
    CURVED_RANGE_CHART: "\ue71b",
    VERTICAL_BAR_CHART_DESC: "\ue71c",
    HORIZONTAL_BAR_CHART_DESC: "\ue71d",
    DOCUMENT_OPEN: "\ue71e",
    DOCUMENT_SHARE: "\ue71f",
    HORIZONTAL_DISTRIBUTION: "\ue720",
    VERTICAL_DISTRIBUTION: "\ue721",
    ALIGNMENT_LEFT: "\ue722",
    ALIGNMENT_VERTICAL_CENTER: "\ue723",
    ALIGNMENT_RIGHT: "\ue724",
    ALIGNMENT_TOP: "\ue725",
    ALIGNMENT_HORIZONTAL_CENTER: "\ue726",
    ALIGNMENT_BOTTOM: "\ue727",
    GIT_PULL: "\ue728",
    GIT_MERGE: "\ue729",
    GIT_BRANCH: "\ue72a",
    GIT_COMMIT: "\ue72b",
    GIT_PUSH: "\ue72c",
    BUILD: "\ue72d",
    SYMBOL_CIRCLE: "\ue72e",
    SYMBOL_SQUARE: "\ue72f",
    SYMBOL_DIAMOND: "\ue730",
    SYMBOL_CROSS: "\ue731",
    SYMBOL_TRIANGLE_UP: "\ue732",
    SYMBOL_TRIANGLE_DOWN: "\ue733",
    WRENCH: "\ue734",
    APPLICATION: "\ue735",
    SEND_TO_GRAPH: "\ue736",
    SEND_TO_MAP: "\ue737",
    JOIN_TABLE: "\ue738",
    DERIVE_COLUMN: "\ue739",
    IMAGE_ROTATE_LEFT: "\ue73a",
    IMAGE_ROTATE_RIGHT: "\ue73b",
    KNOWN_VEHICLE: "\ue73c",
    UNKNOWN_VEHICLE: "\ue73d",
    SCATTER_PLOT: "\ue73e",
    OIL_FIELD: "\ue73f",
    RIG: "\ue740",
    MAP_CREATE: "\ue741",
    KEY_OPTION: "\ue742",
    LIST_DETAIL_VIEW: "\ue743",
    SWAP_VERTICAL: "\ue744",
    SWAP_HORIZONTAL: "\ue745",
    NUMBERED_LIST: "\ue746",
    NEW_GRID_ITEM: "\ue747",
    GIT_REPO: "\ue748",
    GIT_NEW_BRANCH: "\ue749",
    MANUALLY_ENTERED_DATA: "\ue74a",
    AIRPLANE: "\ue74b",
    MERGE_COLUMNS: "\ue74f",
    SPLIT_COLUMNS: "\ue750",
    DASHBOARD: "\ue751",
    PUBLISH_FUNCTION: "\ue752",
    PATH: "\ue753",
    MOON: "\ue754",
    REMOVE_COLUMN: "\ue755",
    NUMERICAL: "\ue756",
    KEY_TAB: "\ue757",
    REGRESSION_CHART: "\ue758",
    TRANSLATE: "\ue759",
    EYE_ON: "\ue75a",
    VERTICAL_BAR_CHART_ASC: "\ue75b",
    HORIZONTAL_BAR_CHART_ASC: "\ue75c",
    GROUPED_BAR_CHART: "\ue75d",
    FULL_STACKED_CHART: "\ue75e",
    ENDORSED: "\ue75f",
    FOLLOWER: "\ue760",
    FOLLOWING: "\ue761",
    MENU: "\ue762",
    COLLAPSE_ALL: "\ue763",
    EXPAND_ALL: "\ue764",
    INTERSECTION: "\ue765",
    BLOCKED_PERSON: "\ue768",
    SLASH: "\ue769",
    PERCENTAGE: "\ue76a",
    SATELLITE: "\ue76b",
    PARAGRAPH: "\ue76c",
    BANK_ACCOUNT: "\ue76f",
    CELL_TOWER: "\ue770",
    ID_NUMBER: "\ue771",
    IP_ADDRESS: "\ue772",
    ERASER: "\ue773",
    ISSUE: "\ue774",
    ISSUE_NEW: "\ue775",
    ISSUE_CLOSED: "\ue776",
    PANEL_STATS: "\ue777",
    PANEL_TABLE: "\ue778",
    TICK_CIRCLE: "\ue779",
    PRESCRIPTION: "\ue78a",
    NEW_PRESCRIPTION: "\ue78b",
    FILTER_KEEP: "\ue78c",
    FILTER_REMOVE: "\ue78d",
    KEY: "\ue78e",
    FEED_SUBSCRIBED: "\ue78f",
    WIDGET_BUTTON: "\ue790",
    WIDGET_HEADER: "\ue791",
    WIDGET_FOOTER: "\ue792",
    HEADER_ONE: "\ue793",
    HEADER_TWO: "\ue794",
    FORM: "\ue795",
    SERIES_ADD: "\ue796",
    SERIES_SEARCH: "\ue797",
    SERIES_FILTERED: "\ue798",
    SERIES_DERIVED: "\ue799",
    SERIES_CONFIGURATION: "\ue79a",
    CONSOLE: "\ue79b",
    COMPASS: "\ue79c",
    WALK: "\ue79d",
    TAXI: "\ue79e",
    TRAIN: "\ue79f",
    HEART_BROKEN: "\ue7a2",
    INNER_JOIN: "\ue7a3",
    LEFT_JOIN: "\ue7a4",
    RIGHT_JOIN: "\ue7a5",
    STRIKETHROUGH: "\ue7a6",
    UPDATED: "\ue7a7",
    OUTDATED: "\ue7a8",
    FLAME: "\ue7a9",
    FOLDER_NEW: "\ue7b0",
    MOUNTAIN: "\ue7b1",
    SHIELD: "\ue7b2",
    DIAGRAM_TREE: "\ue7b3",
    CROWN: "\ue7b4",
    GLOBE_NETWORK: "\ue7b5",
    SNOWFLAKE: "\ue7b6",
    TREE: "\ue7b7",
    NOTIFICATIONS_UPDATED: "\ue7b8",
    LIST_COLUMNS: "\ue7b9",
    FLOW_LINEAR: "\ue7c0",
    FLOW_BRANCH: "\ue7c1",
    FLOW_REVIEW: "\ue7c2",
    FLOW_REVIEW_BRANCH: "\ue7c3",
    FLOW_END: "\ue7c4",
};


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(83);
var bind = __webpack_require__(470);
var Axios = __webpack_require__(924);
var defaults = __webpack_require__(304);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(467);
axios.CancelToken = __webpack_require__(923);
axios.isCancel = __webpack_require__(468);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(938);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var Cancel = __webpack_require__(467);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var defaults = __webpack_require__(304);
var utils = __webpack_require__(83);
var InterceptorManager = __webpack_require__(925);
var dispatchRequest = __webpack_require__(926);
var isAbsoluteURL = __webpack_require__(934);
var combineURLs = __webpack_require__(932);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

var utils = __webpack_require__(83);
var transformData = __webpack_require__(929);
var isCancel = __webpack_require__(468);
var defaults = __webpack_require__(304);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(469);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(83);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  // Dev
  API_URL: 'https://demo-ttqn.e-gov.com.vn/api',
  REDIRECT_URL: 'https://demo-ttqn.e-gov.com.vn',
  API_URL_AUTH: 'https://demo-ttqn.e-gov.com.vn/api',

  // Live
  // API_URL: 'https://csdlthanhtra.danang.gov.vn/thanh-tra-api',
  // REDIRECT_URL: 'https://csdlthanhtra.danang.gov.vn',
  // API_URL_AUTH: 'https://csdlthanhtra.danang.gov.vn/api',

  // PROD_API_URL: 'https://csdlthanhtra.danang.gov.vn/api',
  // API_SSO_URL:'https://csdlthanhtra.danang.gov.vn/cas/token',
  // STAGING_API_URL: 'http://csdlthanhtra.danang.gov.vn:8089/api',
  // ERROR_TRACKER_URL: 'http://tracker.thanhtratp.greenglobal.vn:9836',
  FILE_ENV: 'live'

};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var convertParams = function convertParams(_paramsDate, key) {
  return _extends({}, _paramsDate ? _defineProperty({}, key, (0, _moment2.default)(_paramsDate).format('YYYY-MM-DD')) : {});
};

exports.default = (0, _reduxApi2.default)({
  getTongHopKetQuaThanhTraHanhChinh: {
    url: _config.API_URL + '/thong-ke-bao-cao/01-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getKetQuaThucHienKetLuanThanhTraHanhChinh: {
    url: _config.API_URL + '/thong-ke-bao-cao/02-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getThongKeThanhTraXayDungCoBan: {
    url: _config.API_URL + '/thong-ke-bao-cao/03-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getThongKeThanhTraTaiChinhNganSach: {
    url: _config.API_URL + '/thong-ke-bao-cao/04-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getThongKeThanhTraDatDai: {
    url: _config.API_URL + '/thong-ke-bao-cao/05-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getKiemTraChuyenNganh: {
    url: _config.API_URL + '/thong-ke-bao-cao/06-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getXuPhatKiemTraChuyenNganh: {
    url: _config.API_URL + '/thong-ke-bao-cao/07-TT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getKiemTraChiTietDoanhNghiep: {
    url: _config.API_URL + '/thong-ke-bao-cao/01-KQTKT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getKiemTraTheoKeHoachDoanhNghiep: {
    url: _config.API_URL + '/thong-ke-bao-cao/02-KQTKT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getKiemTraDotXuat: {
    url: _config.API_URL + '/thong-ke-bao-cao/03-KQTKT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getTongHopKetQuaThanhTra: {
    url: _config.API_URL + '/thong-ke-bao-cao/04-KQTKT',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _extends({}, _params, convertParams(_params.startDate, 'startDate'), convertParams(_params.endDate, 'endDate'))
      };
    }
  },
  getThongKe: {
    url: _config.API_URL + '/thong-ke-bao-cao/KHTH',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Example
exports.default = (0, _reduxApi2.default)({
  postThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLoaiTaiLieu: {
    url: _config.API_URL + '/loaiTaiLieus',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCapDonViHanhChinh: {
    url: _config.API_URL + '/capDonViHanhChinhs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postChucVu: {
    url: _config.API_URL + '/chucVus',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postQuocTich: {
    url: _config.API_URL + '/quocTichs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postVaiTro: {
    url: _config.API_URL + '/vaiTros',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postDanToc: {
    url: _config.API_URL + '/danTocs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCongChuc: {
    url: _config.API_URL + '/congChucs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postThamSo: {
    url: _config.API_URL + '/thamSos',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postQuyTrinh: {
    url: _config.API_URL + '/maTran/donVi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLoaiCapCoQuan: {
    url: _config.API_URL + '/loaiCoQuanQuanLys',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postHuongDanSuDung: {
    url: _config.API_URL + '/huongDanSuDungs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateHuongDanSuDung: {
    url: _config.API_URL + '/huongDanSuDungs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getHuongDanSuDung: {
    url: _config.API_URL + '/huongDanSuDungs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiTaiLieu: {
    url: _config.API_URL + '/loaiTaiLieus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapDonViHanhChinh: {
    url: _config.API_URL + '/capDonViHanhChinhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getInfoDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getChucVu: {
    url: _config.API_URL + '/chucVus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListChucVu: {
    url: _config.API_URL + '/chucVus?page=:0size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: _config.API_URL + '/quocTichs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCMND: {
    url: _config.API_URL + '/coQuanQuanLys/noiCapCMNDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuyen: {
    url: _config.API_URL + '/quyens?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListVaiTro: {
    url: _config.API_URL + '/vaiTros/combobox?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListVaiTrotheoDV: {
    url: _config.API_URL + '/vaiTros/comboboxTheoDonVi?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListLoaiVaiTro: {
    url: _config.API_URL + '/loaiVaiTros?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getVaiTro: {
    url: _config.API_URL + '/vaiTros',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTW: {
    url: _config.API_URL + '/coQuanQuanLys/capTrungUong',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanQuanLyTW: {
    url: _config.API_URL + '/capCoQuanQuanLys/capCoQuanTW',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiCoQuanQL: {
    url: _config.API_URL + '/loaiCoQuanQuanLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/donVis?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViTrucThuoc: {
    url: _config.API_URL + '/coQuanQuanLys/donViTrucThuocs?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanToc: {
    url: _config.API_URL + '/danTocs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCongChuc: {
    url: _config.API_URL + '/congChucs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getToDanPho: {
    url: _config.API_URL + '/toDanPhos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getcapQuanHuyen: {
    url: _config.API_URL + '/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,desc&cha=:cha',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getcapTinhThanhPho: {
    url: _config.API_URL + '/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getThamSo: {
    url: _config.API_URL + '/thamSos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListQuyTrinh: {
    url: _config.API_URL + '/maTran/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiCapCoQuan: {
    url: _config.API_URL + '/loaiCoQuanQuanLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLoaiTaiLieu: {
    url: _config.API_URL + '/loaiTaiLieus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCapDonViHanhChinh: {
    url: _config.API_URL + '/capDonViHanhChinhs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteChucVu: {
    url: _config.API_URL + '/chucVus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteQuocTich: {
    url: _config.API_URL + '/quocTichs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteVaiTro: {
    url: _config.API_URL + '/vaiTros/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDanToc: {
    url: _config.API_URL + '/danTocs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        params: _params
      };
    }
  },
  deleteCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteToDanPho: {
    url: _config.API_URL + '/toDanPhos/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCongChuc: {
    url: _config.API_URL + '/congChucs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteThamSo: {
    url: _config.API_URL + '/thamSos/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteQuyTrinh: {
    url: _config.API_URL + '//maTran/:idDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLoaiCapCoQuan: {
    url: _config.API_URL + '/loaiCoQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  updateVaiTro: {
    url: _config.API_URL + '/vaiTros/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLoaiTaiLieu: {
    url: _config.API_URL + '/loaiTaiLieus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCapDonViHanhChinh: {
    url: _config.API_URL + '/capDonViHanhChinhs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateChucVu: {
    url: _config.API_URL + '/chucVus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateQuocTich: {
    url: _config.API_URL + '/quocTichs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateDanToc: {
    url: _config.API_URL + '/danTocs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateToDanPho: {
    url: _config.API_URL + '/toDanPhos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCongChuc: {
    url: _config.API_URL + '/congChucs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateThamSo: {
    url: _config.API_URL + '/thamSos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLoaiCapCoQuan: {
    url: _config.API_URL + '/loaiCoQuanQuanLys/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postLinhVucDoiTuongThanhTra: {
    url: _config.API_URL + '/linhVucDoiTuongThanhTras',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getLinhVucDoiTuongThanhTra: {
    url: _config.API_URL + '/linhVucDoiTuongThanhTras?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateLinhVucDoiTuongThanhTra: {
    url: _config.API_URL + '/linhVucDoiTuongThanhTras/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteLinhVucDoiTuongThanhTra: {
    url: _config.API_URL + '/linhVucDoiTuongThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  // Đối tượng thanh tra
  postDoiTuongThanhTra: {
    url: _config.API_URL + '/doiTuongThanhTras',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getDoiTuongThanhTra: {
    url: _config.API_URL + '/doiTuongThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateDoiTuongThanhTra: {
    url: _config.API_URL + '/doiTuongThanhTras/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteDoiTuongThanhTra: {
    url: _config.API_URL + '/doiTuongThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  // End đối tượng thanh tra
  // Nhóm đối tượng thanh tra 
  getNhomDoiTuongThanhTra: {
    url: _config.API_URL + '/nhomDoiTuongThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomDoiTuongThanhTra: {
    url: _config.API_URL + '/nhomDoiTuongThanhTras',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateNhomDoiTuongThanhTra: {
    url: _config.API_URL + '/nhomDoiTuongThanhTras/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deletenhomDoiTuongThanhTras: {
    url: _config.API_URL + '/nhomDoiTuongThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  // End nhóm đối tượng thanh tra
  getLoaiDoiTuongThanhTra: {
    url: _config.API_URL + '/loaiDoiTuongThanhTras?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThuTimKiem: {
    url: _config.API_URL + '/linhVucDonThus/linhVucDonThuTimKiems?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViHanhChinhTimKiem: {
    url: _config.API_URL + '/donViHanhChinhs/danhSachDonViTimKiems?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapDonViHanhChinhTimKiem: {
    url: _config.API_URL + '/capDonViHanhChinhs/capDonViHanhChinhTimKiems?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanQuanLyTimKiem: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanQuanLyTimKiems?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanQuanLyTimKiem: {
    url: _config.API_URL + '/capCoQuanQuanLys/capCoQuanQuanLyTimKiems?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViNgoai: {
    url: _config.API_URL + '/donViNgoaiHeThongs?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDonViNgoai: {
    url: _config.API_URL + '/donViNgoaiHeThongs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDonViNgoai: {
    url: _config.API_URL + '/donViNgoaiHeThongs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteDonViNgoai: {
    url: _config.API_URL + '/donViNgoaiHeThongs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getTrangThaiThayDoiNguoiDung: {
    url: _config.API_URL + '/nguoiDung/trangThaiThayDoiNguoiDung?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiBaoCao: {
    url: _config.API_URL + '/loaiBaoCaoTongHops?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCauHinhBaoCao: {
    url: _config.API_URL + '/cauHinhBaoCaos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateCauHinhBaoCao: {
    url: _config.API_URL + '/cauHinhBaoCaos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postCauHinhBaoCao: {
    url: _config.API_URL + '/cauHinhBaoCaos',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  deleteCauHinhBaoCao: {
    url: _config.API_URL + '/cauHinhBaoCaos/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getCapNhatNguoiDung: {
    url: _config.API_URL + '/timKiemDanhSachCanBoDangXuLys/canBo',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachXuLy: {
    url: _config.API_URL + '/dons/cong-chuc-tham-gia',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonTheoDonVi: {
    url: _config.API_URL + '/dons/danh-sach-by-don-vi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteDonTrongDonVi: {
    url: _config.API_URL + '/dons/delete-theo-don-vi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: !(0, _lodash.isEmpty)(params.donIds) ? [].concat(_toConsumableArray(params.donIds)) : []
      };
    }
  },
  switchCongChuc: {
    url: _config.API_URL + '/dons/swtich-cong-chuc',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCongChucSoNoiVu: {
    url: _config.API_URL + '/congChucSoNoiVus/local',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViSoNoiVu: {
    url: _config.API_URL + '/donViSoNoiVus/local',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateCapNhatNguoiDung: {
    url: _config.API_URL + '/capNhatThayDoiCanBoDangXuLys',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getDanhMucVideo: {
    url: _config.API_URL + '/danhMucVideos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDanhMucVideo: {
    url: _config.API_URL + '/danhMucVideos',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDanhMucVideo: {
    url: _config.API_URL + '/danhMucVideos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteDanhMucVideo: {
    url: _config.API_URL + '/danhMucVideos/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getLoaiVideo: {
    url: _config.API_URL + '/loaiVideos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getVideo: {
    url: _config.API_URL + '/videos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postVideo: {
    url: _config.API_URL + '/videos',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateVideo: {
    url: _config.API_URL + '/videos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteVideo: {
    url: _config.API_URL + '/videos/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  doiTuongThanhTraChuaCoCuoc: {
    url: _config.API_URL + '/timDoiTuongThanhTrasChuaCoCuocThanhTra',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        params: params.pageData,
        data: params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Example
exports.default = (0, _reduxApi2.default)({

  getThoiHanXuLyMacDinh: {
    url: _config.API_URL + '/dons/ngayMacDinhThoiHanXuLyDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getTongDonDinhKy: {
    url: _config.API_URL + '/soTiepCongDan/layTongSoDonSoTiepCongDanDinhKy',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getTongDonDotXuat: {
    url: _config.API_URL + '/soTiepCongDan/layTongSoDonSoTiepCongDanDotXuat',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getTongDonYeuCauGapLanhDao: {
    url: _config.API_URL + '/soTiepCongDan/layTongSoDonDanhSachYeuCauGapLanhDao',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonXLD: {
    url: _config.API_URL + '/dons/layTongSoDonDangXuLy',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonGQD: {
    url: _config.API_URL + '/dons/layTongSoDonDangGiaiQuyet',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTongDonTDTH: {
    url: _config.API_URL + '/dons/layTongSoDonDangTGTH',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getThoiHanTTXMMacDinh: {
    url: _config.API_URL + '/dons/ngayMacDinhThoiHanTTXM',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getThoiHanGQDonMacDinh: {
    url: _config.API_URL + '/dons/ngayMacDinhThoiHanGiaiQuyetDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getThoiGianHienTai: {
    url: _config.API_URL + '/layNgayGioHienTai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getHuongXuLyTheoDon: {
    url: _config.API_URL + '/huongXuLys/don?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanTiepNhan: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanTiepNhans?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDiaBanTiepNhan: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanTiepNhanGiamSatTraCuus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhongBanThuocCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/phongBansTheoDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQuanLy: {
    url: _config.API_URL + '/coQuanQuanLys/donViQuyTrinhs?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQuanLytheoDV: {
    url: _config.API_URL + '/coQuanQuanLys/vaiTro?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapDonViQuyTrinhs: {
    url: _config.API_URL + '/capDonViQuyTrinhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChuyenVienThuocPhongBan: {
    url: _config.API_URL + '/congChucs/vaiTro',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapTinhThanhPho: {
    url: _config.API_URL + '/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: _config.API_URL + '/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: _config.API_URL + '/quocTichs/combobox',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNoiCap: {
    url: _config.API_URL + '/coQuanQuanLys/noiCapCMNDs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: _config.API_URL + '/danTocs?page=0&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: _config.API_URL + '/loaiDoiTuongs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThuCombobox?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNhomThamQuyenGiaiQuyet: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNhomThamQuyenCombobox: {
    url: _config.API_URL + '/thamQuyenGiaiQuyetsCombobox',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapCoQuanDaGiaiQuyet: {
    url: _config.API_URL + '/capCoQuanQuanLys/capCoQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiVuViec: {
    url: _config.API_URL + '/vuViecs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanDaGiaiQuyet: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucDaGiaiQuyet: {
    url: _config.API_URL + '/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: _config.API_URL + '/thamSos?tuKhoa=DVHC_TP_DA_NANG',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangGiaiQuyet: {
    url: _config.API_URL + '/tinhTrangGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViChuTri: {
    url: _config.API_URL + '/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getCapDonViHanhChinh: {
    url: _config.API_URL + '/capDonViHanhChinhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongGiaiQuyetLD: {
    url: _config.API_URL + '/huongGiaiQuyetCuaLanhDaoTCDs?page=0&size=1000&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViTTXM: {
    url: _config.API_URL + '/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTruongDoanTTXM: {
    url: _config.API_URL + '/congChucs/truongDoanTTXMs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetLuanNoiDungKhieuNai: {
    url: _config.API_URL + '/ketLuanNoiDungKhieuNais?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucTheoDoi: {
    url: _config.API_URL + '/hinhThucTheoDois?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaThucHien: {
    url: _config.API_URL + '/ketQuaThucHiens?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: _config.API_URL + '/lanhDaoTiepCongDans?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangTaiLieu: {
    url: _config.API_URL + '/tinhTrangTaiLieus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiTepDK: {
    url: _config.API_URL + '/loaiTepDinhKems?page=0&size=1000&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViHanhChinh: {
    url: _config.API_URL + '/donViHanhChinhs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanTiepDan: {
    url: _config.API_URL + '/coQuanQuanLys/danhSachCoQuanCungThamGiaTiepDanComboBox?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTrangThaiDon: {
    url: _config.API_URL + '/trangThaiDonToanHTs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyet: {
    url: _config.API_URL + '/ketQuaGiaiQuyetToanHTs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetDon: {
    url: _config.API_URL + '/ketQuaGiaiQuyetTheoDons?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiKyThongKe: {
    url: _config.API_URL + '/thongKeBaoCao/loaiKy?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiThongKe: {
    url: _config.API_URL + '/enumerations/statistic-types',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiQuyThongKe: {
    url: _config.API_URL + '/enumerations/quarters',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViThongKe: {
    url: _config.API_URL + '/coQuanQuanLys/donViThongKes?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNamThongKe: {
    url: _config.API_URL + '/thongKeBaoCao/years?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getThangThongKe: {
    url: _config.API_URL + '/enumerations/months',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetLanHai: {
    url: _config.API_URL + '/ketQuaGiaiQuyetLan2s?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanDieuTra: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanDieuTras?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViTTXMNew: {
    url: _config.API_URL + '/coQuanQuanLys/donViNhanTTXMs?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  checkHanGiaiQuyet: {
    url: _config.API_URL + '/dons/validateThoiHan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThamSoHeThong: {
    url: _config.API_URL + '/thamSoMulti',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTongSoDon: {
    url: _config.API_URL + '/dons/layTongSoDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiThongTinDon: {
    url: _config.API_URL + '/loaiThongTinDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getQuanHuyen: {
    url: _config.API_URL + '/donViHanhChinhs/capQuanHuyen',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs/capPhuongXa',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNamThanhTra: {
    url: _config.API_URL + '/namThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  getGiaiQuyetDon: {
    url: _config.API_URL + '/danhSachGiaiQuyetDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuGiaiQuyetDon: {
    url: _config.API_URL + '/giaiQuyetDons/thongTinGiaiQuyetDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTheoDoiEnumn: {
    url: _config.API_URL + '/giaiQuyetDon/donViTheoDoi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhongBanThuocCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/phongBanKhacPhongBanHienTaiTheoDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNgayHetHanLapDuThao: {
    url: _config.API_URL + '/dons/ngayMacDinhThoiHanGiaoLapDuThao',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetDon: {
    url: _config.API_URL + '/ketQuaGiaiQuyetTheoDons?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTheoDoi: {
    url: _config.API_URL + '/coQuanQuanLys/donViTheoDois',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNguonDon: {
    url: _config.API_URL + '/nguonTiepNhanDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiDonThu: {
    url: _config.API_URL + '/loaiDonThus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongXuLy: {
    url: _config.API_URL + '/huongXuLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCurrentForm: {
    url: _config.API_URL + '/currentForm',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCongChuc: {
    url: _config.API_URL + '/congChucs/vaiTro?',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCongChucByEmail: {
    url: _config.API_URL + '/congChucs/by-email',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListDonViNhanTDTH: {
    url: _config.API_URL + '/coQuanQuanLys/donViNhanTGTHs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonViNhanTDTH: {
    url: _config.API_URL + '/coQuanQuanLys/donViDuocPhepNhanTheoDoiThucHiens',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListPhongBanNhanTDTH: {
    url: _config.API_URL + '/coQuanQuanLys/tatCaPhongBanNhanTGTHs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhongBanNhanTDTH: {
    url: _config.API_URL + '/coQuanQuanLys/phongBanThanhTraNhanTGTHs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViTTXM: {
    url: _config.API_URL + '/coQuanQuanLys/donViChuTris',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getThongTinGiaiQuyetDon: {
    url: _config.API_URL + '/thongTinGiaiQuyetDons/:id',
    options: function options(url, params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangGiaiQuyet: {
    url: _config.API_URL + '/tinhTrangGiaiQuyets',
    options: function options(url, params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  postGiaiQuyetDon: {
    url: _config.API_URL + '/giaiQuyetDons',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  deleteTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  postTaiLieuDinhKemDon: {
    url: _config.API_URL + '/taiLieuVanThus',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  tuGiaiQuyetDon: {
    url: _config.API_URL + '/giaiQuyetDons/tuXuLy',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuDinhKemDon: {
    url: _config.API_URL + '/taiLieuVanThus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteTaiLieuDinhKemDon: {
    url: _config.API_URL + '/taiLieuVanThus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getTaiLieuDinhKemDon: {
    url: _config.API_URL + '/taiLieuVanThus',
    options: function options(url, params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  updateGiaiQuyetDon: {
    url: _config.API_URL + '/thongTinGiaiQuyetDons/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  dinhChiGiaiQuyetDon: {
    url: _config.API_URL + '/giaiQuyetDons/:id/dinhChi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  inPhieuGiaoNhiemVuXacMinhKhieuNai: {
    url: _config.API_URL + '/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  inPhieuGiaoNhiemVuXacMinhToCao: {
    url: _config.API_URL + '/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListTheoDoiThucHienGQD: {
    url: _config.API_URL + '/theoDoiThucHiens',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListDonDaGiaiQuyet: {
    url: _config.API_URL + '/donDaGiaiQuyets',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListNguoiBanHanh: {
    url: _config.API_URL + '/congChucs/nguoiBanHanhs',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListNguoiBanHanhKTTT: {
    url: _config.API_URL + '/congChucs/nguoiBanHanhs/cuocThanhTra',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({

  updateDonVaTrinh: {
    url: _config.API_URL + '/dons/luuDonVaTrinh/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  getThoiHanXuLyMacDinh: {
    url: _config.API_URL + '/dons/ngayMacDinhThoiHanXuLyDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getThoiHanXuLy: {
    url: _config.API_URL + '/thoiHans?loaiThoiHan=THOIHAN_XULYDON&page=0&size=1000&sort=soNgay,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNguonDon: {
    url: _config.API_URL + '/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonDetail: {
    url: _config.API_URL + '/dons/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDonCuDetail: {
    url: _config.API_URL + '/donCus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getphanLoaiNguoiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  deleteDonCongDan: {
    url: _config.API_URL + '/donCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  updateDon: {
    url: _config.API_URL + '/dons/:id',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  deleteDon: {
    url: _config.API_URL + '/dons/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getDetailReception: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBKT: {
    url: _config.API_URL + '/loaiDoiTuongBiKhieuTos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyTCD: {
    url: _config.API_URL + '/huongXuLyTCDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: _config.API_URL + '/lanhDaoTiepCongDans?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DINH_KY&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: _config.API_URL + '/quocTichs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: _config.API_URL + '/danTocs?page=0&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getToDanPho: {
    url: _config.API_URL + '/toDanPhos?page=0&size=1000&sort=ten,desc&donViHanhChinh=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,desc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListCapPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs?page=0page&size=1000&sort=ten,desc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: _config.API_URL + '/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,desc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapTinhThanhPho: {
    url: _config.API_URL + '/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: _config.API_URL + '/loaiDonThus?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLy: {
    url: _config.API_URL + '/huongXuLyTCDs?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: _config.API_URL + '/loaiDoiTuongs?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus?page=0&size=1000&sort=ten,desc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNoiCap: {
    url: _config.API_URL + '/coQuanQuanLys/noiCapCMNDs?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHinhThucGiaiQuyet: {
    url: _config.API_URL + '/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: _config.API_URL + '/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchCongDan: {
    url: _config.API_URL + '/congDanBySuggests?page=:page&size=:size&tuKhoa=:name&soCMNND=:cmnd&diaChi=:diaChi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  postDonVaTrinh: {
    url: _config.API_URL + '/dons/taoDonMoiVaTrinhDon',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },

  postDon: {
    url: _config.API_URL + '/dons',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  postDonCongDan: {
    url: _config.API_URL + '/donCongDans',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCongDan: {
    url: _config.API_URL + '/congDans',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postSoTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateSoTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDan/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCongchucOfUser: {
    url: _config.API_URL + '/congChucs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanDetail: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  deleteTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys?page=0&size=1000&sort=ten,desc&capCoQuanQuanLy=:capCQID',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuDon: {
    url: _config.API_URL + '/dons/:id/lichSus?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuKeHoach: {
    url: _config.API_URL + '/kehoachthanhtras/:id/lichSus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTrangThaiDon: {
    url: _config.API_URL + '/dons/:id/trangThaiDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDetail: {
    url: _config.API_URL + '/coQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: _config.API_URL + '/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  deleteDon: {
    url: _config.API_URL + '/xoaDon/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonCu: {
    url: _config.API_URL + '/donCus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  getNguonDon: {
    url: _config.API_URL + '/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: _config.API_URL + '/loaiDonThus?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLy: {
    url: _config.API_URL + '/huongXuLys?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyDon: {
    url: _config.API_URL + '/huongXuLyXLDs/vaiTro?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  capCoQuanQuanLy: {
    url: _config.API_URL + '/capCoQuanQuanLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postXuLyDon: {
    url: _config.API_URL + '/xuLyDons',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateXuLyDonVanThu: {
    url: _config.API_URL + '/xuLyDons/:id',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  dinhChiDon: {
    url: _config.API_URL + '/xuLyDons/dinhChiDon?id=:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getThoiHanXuLy: {
    url: _config.API_URL + '/thoiHans?loaiThoiHan=THOIHAN_XULYDON&page=0&size=1000&sort=soNgay,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListXuLyDon: {
    url: _config.API_URL + '/danhSachXuLyDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getDonCusInfo: {
    url: _config.API_URL + '/donCus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanXuLy: {
    url: _config.API_URL + '/thongKes/danhSachDonTreHanXuLyTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanXuLyTaiDiaBan: {
    url: _config.API_URL + '/thongKes/danhSachDonTreHanXuLyTaiDiaBan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanGiaiQuyet: {
    url: _config.API_URL + '/thongKes/danhSachDonTreHanGiaiQuyetTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getListDonTreHanGiaiQuyetTaiDiaBan: {
    url: _config.API_URL + '/thongKes/danhSachDonTreHanGiaiQuyetTaiDiaBan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        param: _params
      };
    }
  },
  getPhieuChuyenDonKNPA: {
    url: _config.API_URL + '/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuChuyenDonToCao: {
    url: _config.API_URL + '/xuLyDons/inPhieuChuyenDonToCao?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuDeXuatThuLy: {
    url: _config.API_URL + '/xuLyDons/inPhieuDeXuatThuLy?loaiDon=:loaiDon&ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuKhongDuDieuKienThuLyKN: {
    url: _config.API_URL + '/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&diaChi=:diaChi&noiDung=:noiDung&lyDoDinhChi=:lyDoDinhChi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhieuTraDonVaHuongDanKN: {
    url: _config.API_URL + '/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?ngayTiepNhan=:ngayTiepNhan&nguoiDungDon=:nguoiDungDon&noiDung=:noiDung&coQuanTiepNhan=:coQuanTiepNhan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuyTrinhXuLyGiaoViec: {
    url: _config.API_URL + '/quyTrinhXuLyXLDs/giaoViec?vaiTro=CHUYEN_VIEN',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getPhongBan: {
    url: _config.API_URL + '/coQuanQuanLys?cha=:cha&notCha=false',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getCoQuanQLTPDN: {
    url: _config.API_URL + '/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys?page=0&size=1000&sort=ten,asc&capCoQuanQuanLy=:capCQID',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getCongChuc: {
    url: _config.API_URL + '/congChucs?coQuanQuanLyId=:coQuanQuanLyId',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCongChucVaiTro: {
    url: _config.API_URL + '/congChucs?vaiTro=:vaiTro&coQuanQuanLyId=:coQuanQuanLyId',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getQuyTrinhXuLy: {
    url: _config.API_URL + '/quyTrinhXuLyXLDs/giaoViec?vaiTro=:vaiTro',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getcoQuanQuanLyInfo: {
    url: _config.API_URL + '/coQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: _config.API_URL + '/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: _config.API_URL + '/loaiDoiTuongs?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiNguoiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getphongBanXuLy: {
    url: _config.API_URL + '/coQuanQuanLys/phongBanGiaiQuyets',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({

  getNguonDon: {
    url: _config.API_URL + '/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getHuongXuLyDonSearch: {
    url: _config.API_URL + '/huongXuLys?page=0&size=1000&sort=ten,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getQuyTrinhXuLyHistory: {
    url: _config.API_URL + '/lichSuQuaTrinhXuLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getThongTinXuLy: {
    url: _config.API_URL + '/xuLyDons/thongTinXuLyDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getCurrentForm: {

    url: _config.API_URL + '/currentForm',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getTrangThaiTTXM: {
    url: _config.API_URL + '/trangThaiTTXMs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  postTuXuLyDon: {

    url: _config.API_URL + '/xuLyDons/tuXuLy',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },

  patchTuXuLy: {
    url: _config.API_URL + '/xuLyDons/tuXuLy/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  postXuLyDon: {

    url: _config.API_URL + '/xuLyDons',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },

  patchXuLyDon: {
    url: _config.API_URL + '/xuLyDons/:id',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },

  patchDinhChiDon: {

    url: _config.API_URL + '/xuLyDons/:id/dinhChiDon',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  getDonDetail: {
    url: _config.API_URL + '/dons/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getDonCuDetail: {
    url: _config.API_URL + '/donCus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  }

}).use('fetch', _axios2.default);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  getDsQuanLyHoSo: {
    url: _config.API_URL + '/ho-so-thanh-tra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietQuanLyHoSo: {
    url: _config.API_URL + '/ho-so-thanh-tra/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Danh mục nhóm hồ sơ
  getNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  // Api quản lý danh mục văn bản
  getDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  getChiTietDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  getListDanhMucVanBan: {
    url: _config.API_URL + '/danh-muc-van-ban/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Api quản lý loại văn bản
  getLoaiVanBan: {
    url: _config.API_URL + '/loai-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postLoaiVanBan: {
    url: _config.API_URL + '/loai-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putLoaiVanBan: {
    url: _config.API_URL + '/loai-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteLoaiVanBan: {
    url: _config.API_URL + '/loai-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },

  // Quản lý lĩnh vực văn bản
  getLinhVucVanBan: {
    url: _config.API_URL + '/linh-vuc-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postLinhVucVanBan: {
    url: _config.API_URL + '/linh-vuc-van-ban',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putLinhVucVanBan: {
    url: _config.API_URL + '/linh-vuc-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteLinhVucVanBan: {
    url: _config.API_URL + '/linh-vuc-van-ban/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },

  // Quản lý cơ quan ban hành văn bản
  getCoQuanBanHanhVanBan: {
    url: _config.API_URL + '/co-quan-ban-hanh',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postCoQuanBanHanhVanBan: {
    url: _config.API_URL + '/co-quan-ban-hanh',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putCoQuanBanHanhVanBan: {
    url: _config.API_URL + '/co-quan-ban-hanh/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteCoQuanBanHanhVanBan: {
    url: _config.API_URL + '/co-quan-ban-hanh/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  // Danh mục nhóm file
  getNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  getListNhomHoSo: {
    url: _config.API_URL + '/nhom-ho-so/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Api combobox
  getListLoaiVanBan: {
    url: _config.API_URL + '/loai-van-ban/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListLinhVucVanBan: {
    url: _config.API_URL + '/linh-vuc-van-ban/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListCoQuanBanHanh: {
    url: _config.API_URL + '/co-quan-ban-hanh/list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Example
exports.default = (0, _reduxApi2.default)({
  getDetailReception: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getphanLoaiNguoiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLichSuTrangThaiXLGQDons: {
    url: _config.API_URL + '/lichSuTrangThaiXuLyGiaiQuyetDonTheoDoiDonDocs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBKT: {
    url: _config.API_URL + '/loaiDoiTuongBiKhieuTos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyTCD: {
    url: _config.API_URL + '/huongXuLyTCDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongGiaiQuyet: {
    url: _config.API_URL + '/huongGiaiQuyetCuaLanhDaoTCDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=id,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  gethoSoVuViec: {
    url: _config.API_URL + '/hoSoVuViecYeuCauGapLanhDaos?page=:page&size=:size&sort=ngayTiepNhan,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiTepDK: {
    url: _config.API_URL + '/loaiTepDinhKems?page=0&size=1000&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: _config.API_URL + '/lanhDaoTiepCongDans?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHuongGiaiQuyetLD: {
    url: _config.API_URL + '/huongGiaiQuyetCuaLanhDaoTCDs?page=0&size=1000&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=id,desc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangTaiLieu: {
    url: _config.API_URL + '/tinhTrangTaiLieus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangXuLy: {
    url: _config.API_URL + '/tinhTrangXuLyCuaLanhDaoTCDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKetQuaTiepDan: {
    url: _config.API_URL + '/huongGiaiQuyetCuaLanhDaoTCDs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKetQuaTiepDanSearch: {
    url: _config.API_URL + '/huongGiaiQuyetCuaLanhDaoTCDs/timKiem',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  searchTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DINH_KY&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDotXuat: {
    url: _config.API_URL + '/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: _config.API_URL + '/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: _config.API_URL + '/danTocs?page=0&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getToDanPho: {
    url: _config.API_URL + '/toDanPhos?page=0&size=1000&sort=ten,asc&donViHanhChinh=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getListCapPhuongXa: {
    url: _config.API_URL + '/donViHanhChinhs?page=0page&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: _config.API_URL + '/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,asc&cha=:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCapTinhThanhPho: {
    url: _config.API_URL + '/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: _config.API_URL + '/loaiDonThus?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHuongXuLy: {
    url: _config.API_URL + '/huongXuLyTCDs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: _config.API_URL + '/loaiDoiTuongs?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLinhVucDonThu: {
    url: _config.API_URL + '/linhVucDonThus?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuan: {
    url: _config.API_URL + '/capCoQuanQuanLys/capCoQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViChuTri: {
    url: _config.API_URL + '/coQuanQuanLys/donViChuTris?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getLichSuTrangThaiXuLyGiaiQuyetDon: {
    url: _config.API_URL + '/lichSuTrangThaiXuLyGiaiQuyetDons',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  getCoQuan: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanDaGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDetail: {
    url: _config.API_URL + '/coQuanQuanLys/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: _config.API_URL + '/thamSos?tuKhoa=DVHC_TP_DA_NANG',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuanQLTPDN: {
    url: _config.API_URL + '/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },

  getThamQuyen: {
    url: _config.API_URL + '/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getCongDanExist: {
    url: _config.API_URL + '/congDanExists',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCMNDExist: {
    url: _config.API_URL + '/cmndExists',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucGiaiQuyet: {
    url: _config.API_URL + '/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: _config.API_URL + '/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,asc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  searchCongDan: {
    url: _config.API_URL + '/congDanBySuggests',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDon: {
    url: _config.API_URL + '/dons',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  postDonCu: {
    url: _config.API_URL + '/donCus',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDon: {
    url: _config.API_URL + '/dons/:id',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateDonCu: {
    url: _config.API_URL + '/donCus/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postDonCongDan: {
    url: _config.API_URL + '/donCongDans',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDonCongDan: {
    url: _config.API_URL + '/donCongDans/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postCongDan: {
    url: _config.API_URL + '/congDans',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateCongDan: {
    url: _config.API_URL + '/congDans/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postSoTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateSoTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDan/:id',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo ? userInfo.donViId : '',
          congChucId: userInfo ? userInfo.id : ''
        })
      };
    }
  },
  getCongchucOfUser: {
    url: _config.API_URL + '/congChucs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getNguoiDaiDienCoQuan: {
    url: _config.API_URL + '/congChucs/:id/thuocDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanDetail: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanInfo: {
    url: _config.API_URL + '/soTiepCongDan/:id/infos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonInfo: {
    url: _config.API_URL + '/dons/:id/infos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonCuInfo: {
    url: _config.API_URL + '/donCus/:id/infos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getcongDan: {
    url: _config.API_URL + '/congDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDanhSachDonCDId: {
    url: _config.API_URL + '/congDans/:id/danhSachDons?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getDanhSachDonCuCDId: {
    url: _config.API_URL + '/congDans/:id/danhSachDonCus?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  deleteTiepCongDan: {
    url: _config.API_URL + '/soTiepCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTiepCongDanDinhKy: {
    url: _config.API_URL + '/soTiepCongDans/:id/huyCuocTiepDanDinhKyCuaLanhDao',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonCongDan: {
    url: _config.API_URL + '/donCongDans/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTaiLieuBangChung: {
    url: _config.API_URL + '/taiLieuBangChungs/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTepDinhKem: {
    url: _config.API_URL + '/taiLieuVanThus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTepDinhKemUyQuyen: {
    url: _config.API_URL + '/tepDinhKems/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  updateTaiLieuVanThu: {
    url: _config.API_URL + '/taiLieuVanThus/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'PATCH',
        data: _params
      };
    }
  },
  postTaiLieuVanThu: {
    url: _config.API_URL + '/taiLieuVanThus',
    options: function options(url, _params, getState) {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  postFileUpload: {
    url: _config.API_URL + '/documents/uploadfile',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function onUploadProgress(progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postFileUploadExcelData: {
    url: _config.API_URL + '/cuoc-thanh-kiem-tra/process-excel-data',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData
      };
    }
  },
  postImportDoiTuongThanhTra: {
    url: _config.API_URL + '/doi-tuong-thanh-tra/import',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function onUploadProgress(progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postDownloadDsLoiDoiTuongThanhTra: {
    url: _config.API_URL + '/doi-tuong-thanh-tra/import',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        responseType: "blob",
        onUploadProgress: function onUploadProgress(progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postImportCuocKiemTra: {
    url: _config.API_URL + '/cuoc-thanh-kiem-tra/validation-export',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        responseType: "blob",
        onUploadProgress: function onUploadProgress(progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postFileUploadHDSD: {
    url: _config.API_URL + '/documents/uploadHDSD',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData,
        onUploadProgress: function onUploadProgress(progressEvent) {
          _params.progress(progressEvent);
        }
      };
    }
  },
  postDonCongDanMulti: {
    url: _config.API_URL + '/donCongDans/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  postDoanDiCungMulti: {
    url: _config.API_URL + '/doanDiCungs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuBangChungMulti: {
    url: _config.API_URL + '/taiLieuBangChungs/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateDonCongDanMulti: {
    url: _config.API_URL + '/donCongDans/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateDoanDiCungMulti: {
    url: _config.API_URL + '/doanDiCungs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteDoanDiCungMulti: {
    url: _config.API_URL + '/doanDiCungs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  deleteTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  updateTaiLieuBangChungMulti: {
    url: _config.API_URL + '/taiLieuBangChungs/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  postTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  postTepDinhKemMulti: {
    url: _config.API_URL + '/tepDinhKems/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTepDinhKemMulti: {
    url: _config.API_URL + '/tepDinhKems/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  getTrangThaiYeuCau: {
    url: _config.API_URL + '/tiepCongDan/trangThaiYeuCauGapLanhDao?page=0&size=1000',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachYeuCau: {
    url: _config.API_URL + '/danhSachYeuCauGapLanhDaoDinhKys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateXuLyYeuCau: {
    url: _config.API_URL + '/soTiepCongDan/:id/capNhatTrangThaiYeuCauGapLanhDao',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getDonViNgoaiHeThong: {
    url: _config.API_URL + '/donViNgoaiHeThongs/danhSachDonViTimKiems',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  importFileDoiTuong: {
    url: _config.API_URL + '/doiTuongThanhTra/import-excel',
    options: function options(url, _params, getState) {
      var formData = new FormData();
      formData.append(_params.field, _params.file);
      return {
        method: 'POST',
        data: formData
      };
    }

  }
}).use('fetch', _axios2.default);

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxApi2 = __webpack_require__(73);

var _reduxApi3 = _interopRequireDefault(_reduxApi2);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _reduxApi3.default)((_reduxApi = {
  getNamThanhTra: {
    url: _config.API_URL + '/namThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHienThiKeHoachThanhTra: {
    url: _config.API_URL + '/keHoachThanhTras/isHienThiKeHoachThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  postTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  updateTaiLieuVanThuMulti: {
    url: _config.API_URL + '/taiLieuVanThus/multi',
    options: function options(url, params, getState) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: _extends({}, params, {
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        })
      };
    }
  },
  getHinhThucKeHoachThanhTra: {
    url: _config.API_URL + '/chucNangKeHoachThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThucHienPhapLuatVeTT: {
    url: _config.API_URL + '/thucHienPhapLuatVeThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucThanhTraChuyenNganh: {
    url: _config.API_URL + '/hinhThucThanhTraChuyenNganhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChucNangCuocThanhTra: {
    url: _config.API_URL + '/chucNangCuocThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTra: {
    url: _config.API_URL + '/keHoachThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTraOld: {
    url: _config.API_URL + '/keHoachThanhTraOld',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKeHoachThanhTraDetail: {
    url: _config.API_URL + '/keHoachThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucThanhTra: {
    url: _config.API_URL + '/linhVucThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViChuTri: {
    url: _config.API_URL + '/coQuanQuanLys/donViChuTris/cuocThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViKHTT: {
    url: _config.API_URL + '/coQuanQuanLys/donViKeHoachThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKiemTraDoiTuongTT: {
    url: _config.API_URL + '/cuocThanhTras/validateTrungDoiTuongThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDoiTuongDaDeXuatXuLy: {
    url: _config.API_URL + '/danhSachDoiTuongDaDeXuatXuLy',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNhomDoiTuongThanhTras: {
    url: _config.API_URL + '/nhomDoiTuongThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  nhomHinhThucCuocThanhTraPhanLoai: {
    url: _config.API_URL + '/hinhThucCuocThanhTraPhanLoai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCanCuThanhTraLai: {
    url: _config.API_URL + '/canCuThanhTraLais',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTienDoThanhTra: {
    url: _config.API_URL + '/tienDoThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDieuTra: {
    url: _config.API_URL + '/coQuanQuanLys/coQuanDieuTras/cuocThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDieuTraThanhTra: {
    url: _config.API_URL + '/coQuanDieuTraThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietDoiTuongTraThanhTra: {
    url: _config.API_URL + '/doiTuongViPhams/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getHinhThucKienNghi: {
    url: _config.API_URL + '/hinhThucKienNghi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViBanHanh: {
    url: _config.API_URL + '/donViBanHanhs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListDonViBanHanh: {
    url: _config.API_URL + '/coQuanQuanLy/get-list',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiHinhThanhTra: {
    url: _config.API_URL + '/loaiHinhThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDoiTuongThanhTra: {
    url: _config.API_URL + '/doiTuongThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCuocThanhTra: {
    url: _config.API_URL + '/cuocThanhTras',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCuocThanhTraTheoDoi: {
    url: _config.API_URL + '/cuocThanhTraTheoDois',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietCuocThanhTra: {
    url: _config.API_URL + '/cuocThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getChiTietLienQuanCuocThanhTra: {
    url: _config.API_URL + '/cuocThanhTras/:id/infos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getVaiTroThanhVienDoan: {
    url: _config.API_URL + '/vaiTroThanhVienDoans',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThoiHanThanhTra: {
    url: _config.API_URL + '/cuocThanhTras/thoiHanThanhTra',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getHinhThucThanhTra: {
    url: _config.API_URL + '/hinhThucCuocThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDoiTuongViPham: {
    url: _config.API_URL + '/doiTuongViPhams',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postCuocThanhTra: {
    url: _config.API_URL + '/cuocThanhTras',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params,
        params: {
          loaiCuoc: params.loaiCuoc
        }
      };
    }
  },
  patchCuocThanhTra: {
    url: _config.API_URL + '/cuocThanhTras/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params,
        params: {
          loaiCuoc: params.loaiCuoc
        }
      };
    }
  },
  deleteKeHoachThanhTra: {
    url: _config.API_URL + '/keHoachThanhTras/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCuocThanhTraHuy: {
    url: _config.API_URL + '/cuocThanhTras/:id/huy',
    options: function options(url, _params, getState) {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  }
}, _defineProperty(_reduxApi, 'postTaiLieuVanThuMulti', {
  url: _config.API_URL + '/taiLieuVanThus/multi',
  options: function options(url, params, getState) {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    return {
      method: 'POST',
      data: _extends({}, params, {
        donViId: userInfo.donViId,
        congChucId: userInfo.id
      })
    };
  }
}), _defineProperty(_reduxApi, 'resetBuocGiaiQuyet', {
  url: _config.API_URL + '/taiLieuVanThus/resetBuocGiaiQuyet',
  options: function options(url, _params, getState) {
    return {
      method: 'DELETE',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'deleteCuocThanhTraKHTT', {
  url: _config.API_URL + '/keHoachThanhTras/:id/cuocThanhTras',
  options: function options(url, _params, getState) {
    return {
      method: 'DELETE',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'deleteCuocThanhTra', {
  url: _config.API_URL + '/cuocThanhTras/:id',
  options: function options(url, _params, getState) {
    return {
      method: 'DELETE'
    };
  }
}), _defineProperty(_reduxApi, 'deleteDoiTuongViPham', {
  url: _config.API_URL + '/doiTuongViPhams/multi',
  options: function options(url, _params, getState) {
    return {
      method: 'DELETE',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'postKeHoachThanhTra', {
  url: _config.API_URL + '/keHoachThanhTras',
  options: function options(url, params, getState) {
    return {
      method: 'POST',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'getValidateKeHoachThanhTra', {
  url: _config.API_URL + '/keHoachThanhTras/checkExistsData',
  options: function options(url, params, getState) {
    return {
      method: 'GET',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'postDoiTuongViPham', {
  url: _config.API_URL + '/doiTuongViPhams/multi',
  options: function options(url, params, getState) {
    return {
      method: 'POST',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'updateDoiTuongViPham', {
  url: _config.API_URL + '/doiTuongViPhams/multi',
  options: function options(url, params, getState) {
    return {
      method: 'PATCH',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'updateKeHoachThanhTra', {
  url: _config.API_URL + '/keHoachThanhTras/:id',
  options: function options(url, params, getState) {
    return {
      method: 'PATCH',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'getCuocThanhTraTrung', {
  url: _config.API_URL + '/cuocThanhTraTrungs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'ketQuaTheoDoiSaiPham', {
  url: _config.API_URL + '/ketQuaTheoDoiSaiPham',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'ketQuaChuyenCoQuanDieuTra', {
  url: _config.API_URL + '/ketQuaChuyenCoQuanDieuTra',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'ketQuaThucHienDonDoc', {
  url: _config.API_URL + '/ketQuaThucHienDonDoc',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'hinhThucDonDocs', {
  url: _config.API_URL + '/hinhThucDonDocs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'donDocDoiTuongs', {
  url: _config.API_URL + '/donDocDoiTuongs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'ketLuanVeNoiDungKiemTra', {
  url: _config.API_URL + '/ketLuanVeNoiDungKiemTra',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'postDonDoc', {
  url: _config.API_URL + '/donDocDoiTuongs/multi',
  options: function options(url, _params, getState) {
    return {
      method: 'POST',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'patchDonDoc', {
  url: _config.API_URL + '/donDocDoiTuongs/multi',
  options: function options(url, _params, getState) {
    return {
      method: 'PATCH',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'deleteDonDoc', {
  url: _config.API_URL + '/donDocDoiTuong/multi',
  options: function options(url, _params, getState) {
    return {
      method: 'DELETE',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'getDSCuocThanhTraTrung', {
  url: _config.API_URL + '/cuocThanhTraTrungs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getLichSuXuLyCTTTrung', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getLichSuXuLyCTTTrungChiTiet', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungs/:id',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'postDonViDeXuat', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungs/donViHeThongDeXuat',
  options: function options(url, _data, getState) {
    return {
      method: 'POST',
      data: _data.params
    };
  }
}), _defineProperty(_reduxApi, 'postXuLyTTT', {
  url: _config.API_URL + '/XuLyCTTTrungs/xu-ly',
  options: function options(url, _params, getState) {
    return {
      method: 'POST',
      data: _params
    };
  }
}), _defineProperty(_reduxApi, 'patchXuLyTTT', {
  url: _config.API_URL + '/XuLyCTTTrungs/xu-ly/:id',
  options: function options(url, params, getState) {
    return {
      method: 'PATCH',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'getTrangThaiXuLyTTT', {
  url: _config.API_URL + '/trangThaiXuLyCuocThanhTraTrungs',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getlichSuXuLyCTTTrungCurrent', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungCurrent',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getTrangThaoXuLyTrungTaiDV', {
  url: _config.API_URL + '/trangThaiXuLyTrungCuaDonVis',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getTrangThaiThanhTraRutGon', {
  url: _config.API_URL + '/trangThaiThanhTraRutGons',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getLichSuXuLyCTTTrungCu', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungCu',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getCuocThanhTraTrungXuLy', {
  url: _config.API_URL + '/cuocThanhTraTrungs/xuly',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getKHTTDonVi', {
  url: _config.API_URL + '/capCoQuanQuanLys/timKiemKeHoachVaCuoc',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'xuatExcelXuLyTrung', {
  url: _config.API_URL + '/lichSuXuLyCTTTrungs/donViHeThongDeXuat',
  options: function options(url, params, getState) {
    return {
      method: 'POST',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'patchCauHinhKeHoachThanhTra', {
  url: _config.API_URL + '/cauHinhKeHoachThanhTra/:id',
  options: function options(url, params, getState) {
    return {
      method: 'PATCH',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'getCauHinhKeHoachThanhTra', {
  url: _config.API_URL + '/cauHinhKeHoachThanhTra',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getDsQuanLyHoSo', {
  url: _config.API_URL + '/ho-so-thanh-tra',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getCheckTrungMaDoanhNghiep', {
  url: _config.API_URL + '/doi-tuong-thanh-tra/double-check',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'approveDoiTuongThanhTra', {
  url: _config.API_URL + '/doi-tuong-thanh-tra/approve',
  options: function options(url, params, getState) {
    return {
      method: 'PATCH',
      data: params
    };
  }
}), _defineProperty(_reduxApi, 'getDsLinhVucThanhTra', {
  url: _config.API_URL + '/linh-vuc-thanh-tra',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _defineProperty(_reduxApi, 'getDsLoaiDoiTuong', {
  url: _config.API_URL + '/loaiDoiTuongThanhTras',
  options: function options(url, _params, getState) {
    return {
      method: 'GET',
      params: _params
    };
  }
}), _reduxApi)).use('fetch', _axios2.default);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  getTinhHinhXuLyDonCacDonVi: {
    url: _config.API_URL + '/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhHinhXuLyDonCacDonViCon: {
    url: _config.API_URL + '/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonViCon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeSoLieuDonCuTheoDonVi: {
    url: _config.API_URL + '/theoDoiGiamSats/thongKeSoLieuDonCuTheoDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeSoLieuDonCuTheoDonViCon: {
    url: _config.API_URL + '/theoDoiGiamSats/thongKeSoLieuDonCuTheoDonViCon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonDungHanTreHanTaiDonVi: {
    url: _config.API_URL + '/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTenDonViTaiDanhSachDungHanTreHan: {
    url: _config.API_URL + '/theoDoiGiamSats/layTenDonViTaiDanhSachDungHanTreHan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonDungHanTreHanTaiDonViXuatExcel: {
    url: _config.API_URL + '/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi/xuatExcel',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhanHe: {
    url: _config.API_URL + '/theoDoiGiamSat/phanHes',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiDonThu: {
    url: _config.API_URL + '/theoDoiGiamSat/loaiDonThus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTypeTimKiem: {
    url: _config.API_URL + '/theoDoiGiamSat/ngayThangNams',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhHinhXuLyDonCacDonViTheoKy: {
    url: _config.API_URL + '/theoDoiGiamSatTheoKys/tinhHinhXuLyDonTaiCacDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonTaiDonVi: {
    url: _config.API_URL + '/theoDoiGiamSatTheoKys/danhSachDonTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  getThongKeTiepCongDan: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaTiepCongDan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeGQDKN: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaGiaiQuyetDonKhieuNai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeGQDTC: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaGiaiQuyetDonToCao',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeXuLyDon: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaBaoCaoXuLyDon',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraHanhChinh: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraTheoHanhChinh',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraDatDai: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDatDai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraChuyenNganh: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraTheoChuyenNganh',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraXayDungCoBan: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDauTuXayDungCoBan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraTaiChinhNganSach: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraTheoTaiChinhNganSach',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKePhatHienThamNhungQuaThanhTra: {
    url: _config.API_URL + '/thong-ke-bao-cao/BCTN',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeKetQuaThanhTraLai: {
    url: _config.API_URL + '/thongKeBaoCaos/tongHopKetQuaThanhTraLai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanThongKe: {
    url: _config.API_URL + '/capCoQuanQuanLys/thongKeBaoCao',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getHinhThucThongKe: {
    url: _config.API_URL + '/enumerations/hinh-thuc-thong-ke',
    options: function options(url, _params, getState) {
      return {
        method: 'GET'
      };
    }
  },
  getBaoCaoTongHop: {
    url: _config.API_URL + '/baoCaoTongHops',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopChiTiet: {
    url: _config.API_URL + '/baoCaoTongHops/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKyBaoCao: {
    url: _config.API_URL + '/thongKeBaoCaoTongHop/loaiKy',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopDSDonVi: {
    url: _config.API_URL + '/baoCaoTongHops/:id/donVis',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopDSBaoCao: {
    url: _config.API_URL + '/baoCaoTongHops/:id/chiTiets',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKy: {
    url: _config.API_URL + '/baoCaoDonVis',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKyChiTiet: {
    url: _config.API_URL + '/baoCaoDonVis/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKyLoaiDon: {
    url: _config.API_URL + '/baoCaoDonVis/:id/chiTiets',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDonViChiTiet: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDonViChiTietRow: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/:id/duLieuDaChots',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  guiBaoCaoDinhKy: {
    url: _config.API_URL + '/baoCaoDonVis/:id/traKetQua',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateBaoCaoDonVi: {
    url: _config.API_URL + '/baoCaoDonVis/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getLapBaoCaoDinhKyChiTiet: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoDinhKyChiTiet: {
    url: _config.API_URL + '/baoCaoDonViChiTietTams/:idBaoCaoDonViChiTiet',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getItemHeThongLapBaoCaoDinhKyChiTiet: {
    url: _config.API_URL + '/baoCaoDonViChiTietTams/:idBaoCaoDonViChiTiet/themDonVi/:idDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViLapBaoCaoDinhKy: {
    url: _config.API_URL + '/coQuanQuanLys/donViConTrucThuocThuongKes',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postBaoCao: {
    url: _config.API_URL + '/baoCaoDonViChiTietTams/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  patchBaoCao: {
    url: _config.API_URL + '/baoCaoDonViChiTietTams/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteBaoCao: {
    url: _config.API_URL + '/baoCaoDonViChiTietTams/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getTaiLieuBaoCao: {
    url: _config.API_URL + '/taiLieuBaoCaos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  updateTaiLieuBaoCao: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postTaiLieuBaoCao: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  deleteTaiLieuBaoCao: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  updateTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  deleteTaiLieuDinhKem: {
    url: _config.API_URL + '/taiLieuBaoCaos/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  // bao cao tong hop
  getLapBaoCaoTongHopChiTiet: {
    url: _config.API_URL + '/baoCaoTongHopChiTiets/:id',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoTongHopChiTiet: {
    url: _config.API_URL + '/baoCaoTongHopChiTiets/:id/chiTiets',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoTongHopChiTietKhac: {
    url: _config.API_URL + '/baoCaoTongHopChiTietKhacs/:idBaoCaoTongHopChiTiet',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getItemHeThongLapBaoCaoTongHopChiTiet: {
    url: _config.API_URL + '/baoCaoTongHopChiTietKhacs/:idBaoCaoTongHopChiTiet/themDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  laySoLieuTongHop: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/:id/laySoLieu',
    options: function options(url, _params, getState) {
      return {
        method: 'PATCH',
        params: _params
      };
    }
  },
  postBaoCaoTongHop: {
    url: _config.API_URL + '/baoCaoTongHopChiTietKhacs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  patchBaoCaoTongHopKhac: {
    url: _config.API_URL + '/baoCaoTongHopChiTietKhacs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchBaoCaoTongHop: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/multi',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchChotSoLieuDonVi: {
    url: _config.API_URL + '/baoCaoDonViChiTiets/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchChotSoLieuTongHop: {
    url: _config.API_URL + '/baoCaoTongHopChiTiets/:id',
    options: function options(url, params, getState) {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteBaoCaoTongHop: {
    url: _config.API_URL + '/baoCaoTongHopChiTietKhacs/multi',
    options: function options(url, params, getState) {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getLoaiDonTraCuu: {
    url: _config.API_URL + '/loaiDonTraCuus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonCuThongKe: {
    url: _config.API_URL + '/donCus',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxApi2.default)({
  getThongKeDonTaiDonVi: {
    url: _config.API_URL + '/thongKes/thongKeDonTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonXuLyTaiDonVi: {
    url: _config.API_URL + '/thongKes/thongKeDonXuLyGiaiQuyetTaiDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuTrangThaiXLGQDons: {
    url: _config.API_URL + '/lichSuTrangThaiXuLyGiaiQuyetDonCongDans',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuTrangThaiXLGQDonTaiDonVis: {
    url: _config.API_URL + '/lichSuTrangThaiXuLyGiaiQuyetDonTaiDonVis',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getlichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs: {
    url: _config.API_URL + '/lichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonTaiDiaBan: {
    url: _config.API_URL + '/thongKes/thongKeDonTaiDiaBan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonCuaNam: {
    url: _config.API_URL + '/thongKes/thongKeBieuDoDonCuaNam',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonTheoPhanLoai: {
    url: _config.API_URL + '/thongKes/thongKeBieuDoDonTheoPhanLoai',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonTheoLinhVuc: {
    url: _config.API_URL + '/thongKes/thongKeBieuDoDonTheoLinhVuc',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonTreHan: {
    url: _config.API_URL + '/thongKes/thongKeDonTreHan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonMoiNhat: {
    url: _config.API_URL + '/thongKes/thongKeDonMoiNhat',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonCongDan: {
    url: _config.API_URL + '/traCuuDons/congDan',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonCanBo: {
    url: _config.API_URL + '/traCuuDons/canBo',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonTTCP: {
    url: _config.API_URL + '/donTTCPs',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhTrangTraCuuDon: {
    url: _config.API_URL + '/tinhTrangXuLys',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongBao: {
    url: _config.API_URL + '/thongBaos',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getUnreadNotify: {
    url: _config.API_URL + '/thongBaos/soLuongChuaXem',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateNotify: {
    url: _config.API_URL + '/thongBaos/:id',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getChiTietThongBao: {
    url: _config.API_URL + '/thongBao/:id',
    options: function options(url, params, getState) {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getCountKeHoachThanhTra: {
    url: _config.API_URL + '/thongKes/countKeHoachThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountDanhMucCuocThanhTra: {
    url: _config.API_URL + '/thongKes/countDanhMucCuocThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountTheoDoiCuocThanhTra: {
    url: _config.API_URL + '/thongKes/countTheoDoiCuocThanhTra',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountTheoDoiCuocThanhTraTheoNam: {
    url: _config.API_URL + '/thongKes/countCuocThanhTraTheoNam',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCheckLuaChonDonVi: {
    url: _config.API_URL + '/thongKes/luaChonDonVi',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApi = __webpack_require__(73);

var _reduxApi2 = _interopRequireDefault(_reduxApi);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Example
exports.default = (0, _reduxApi2.default)({
  signin: {
    url: _config.API_URL + '/auth/login',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: {},
        headers: params
      };
    }
  },
  logout: {
    url: _config.API_URL + '/auth/logout',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: {}
      };
    }
  },
  logoutSSO: {
    url: _config.API_URL + '/logout',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  sendCode: {
    url: _config.API_URL + '/auth/sendEmail',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  changePassword: {
    url: _config.API_URL + '/auth/changePassword',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateSession: {
    url: _config.API_URL + '/auth/updateSession',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: {}
      };
    }
  },
  resetPassword: {
    url: _config.API_URL + '/auth/resetPassword',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  confirmCode: {
    url: _config.API_URL + '/auth/confirmCode',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postSwitchRole: {
    url: _config.API_URL + '/auth/switchRole',
    options: function options(url, params, getState) {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getInfoFromToken: {
    url: _config.API_URL + '/auth/me',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  loginSSO: {
    url: _config.API_URL + '/sso/userinfo',
    options: function options(url, _params, getState) {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', _axios2.default);

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _api = __webpack_require__(5);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Socket from './Socket.jsx';


var Promise = __webpack_require__(136).Promise;
window.debug = false;

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props, context) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));

    _this.state = {
      loading: false,
      initData: false,
      fails: ''
    };
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initData();
    }
  }, {
    key: 'initData',
    value: function initData() {
      var _this2 = this;

      if (_reactCookie2.default.load('accessToken')) {
        this.state.loading = true;
        this.setState(_extends({}, this.state));
        var self = this;
        setTimeout(function () {
          self.setState({ loading: false });
        }, 9000);
        localStorage.removeItem('thamSo');
        this.getTongSoDon();
        // preload data
        Promise.all([this.getThamSoHeThong('init'), this.getLoaiDonThu('init'), this.getHuongXuLyDon('init'), this.getKetQuaTiepDan('init'), this.getDiaBanTiepNhan('init'), this.getCoQuanQuanLy('init'), this.getKetLuanNoiDungKhieuNai('init'), this.getKetQuaThucHien('init'), this.getLanhDaoTiepDan('init')]).then(function (responses) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: responses
          });
          _this2.props.dispatch({
            type: 'INIT_DULIEU',
            value: false
          });
          _this2.setState({ loading: false, initData: true });
        });
      }
    }
  }, {
    key: 'checkSystemData',
    value: function checkSystemData() {
      if (_reactCookie2.default.load('accessToken') && this.state.fails != '') {
        this.getThamSoHeThong(true);
        this.getLoaiDonThu(true);
        this.getHuongXuLyDon(true);
        this.getKetQuaTiepDan(true);
        this.getCoQuanQuanLy(true);
        this.getDiaBanTiepNhan(true);
        this.getKetLuanNoiDungKhieuNai(true);
        this.getKetQuaThucHien(true);
        this.getLanhDaoTiepDan(true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.init != this.props.init && nextProps.init) {
        this.setState({
          initData: false
        }, function () {
          _this3.initData();
        });
      }
      if (nextProps.refreshMenu != this.props.refreshMenu && nextProps.refreshMenu) {
        this.getTongSoDon();
      }
    }
  }, {
    key: 'getTongSoDon',
    value: function getTongSoDon() {
      var _this4 = this;

      _api.DuLieuHeThong.actions.getTongSoDon.request().then(function (res) {
        if (res && res.data) {
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongXLD',
            value: res.data.tongSoDonDangXuLy
          });
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonTDTH',
            value: res.data.tongSoDonDangTDTH
          });
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonDK',
            value: res.data.tongSoDonSoTiepCongDanDinhKy
          });
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongGQD',
            value: res.data.tongSoDonDangGQ
          });
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonDX',
            value: res.data.tongSoDonSoTiepCongDanDotXuat
          });
          _this4.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonYC',
            value: res.data.tongSoDonYeuCauGapLanhDaoDinhKy
          });
          _this4.props.dispatch({
            type: 'REFRESH_MENU',
            value: false
          });
        }
      });
    }
  }, {
    key: 'getThamSoHeThong',
    value: function getThamSoHeThong(type) {
      var _this5 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && localStorage.getItem('thamSo') && JSON.parse(localStorage.getItem('thamSo')).length == 0 && this.state.fails == 'thamSo') {
        var params = {
          tuKhoa: 'CQQL_BAN_TIEP_CONG_DAN,CQQL_PHONG_NOI_CHINH,CQQL_VAN_PHONG_UBND_THANH_PHO,CCQQL_UBND_QUAN_HUYEN,DVHC_TP_DA_NANG,TQGQ_HANH_CHINH,CQQL_THANH_TRA_THANH_PHO,CQQL_BAN_NOI_CHINH_THANH_UY'
        };
        _api.DuLieuHeThong.actions.getThamSoHeThong.request(null, params).then(function (res) {
          if (res && res.data && res.data._embedded) {
            var Data = res.data._embedded.thamSoes;
            Data.map(function (item) {
              if (item.ten == 'DVHC_TP_DA_NANG') {
                localStorage.setItem('tpdnId', item.giaTri);
              } else if (item.ten == 'TQGQ_HANH_CHINH') {
                localStorage.setItem('thamQuyenHanhChinhId', item.giaTri);
              } else {
                var ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
                ts = [].concat(_toConsumableArray(ts), [{ ten: item.ten, giaTri: Number(item.giaTri) }]);
                localStorage.setItem('thamSo', JSON.stringify(ts));
              }
            });
            _this5.props.dispatch({
              type: 'CAPNHAT_DULIEUHETHONG',
              duLieuHeThong: [{
                key: 'thamSo',
                data: Data
              }]
            });
          }
          _this5.setState({ fails: '' });
        });
      } else if (type == 'init') {
        var _params = {
          tuKhoa: 'CQQL_BAN_TIEP_CONG_DAN,CQQL_PHONG_NOI_CHINH,CQQL_VAN_PHONG_UBND_THANH_PHO,CCQQL_UBND_QUAN_HUYEN,DVHC_TP_DA_NANG,TQGQ_HANH_CHINH,CQQL_THANH_TRA_THANH_PHO,CQQL_BAN_NOI_CHINH_THANH_UY'
        };
        return _api.DuLieuHeThong.actions.getThamSoHeThong.request(null, _params).then(function (res) {
          if (res && res.data && res.data._embedded) {
            var Data = res.data._embedded.thamSoes;
            Data.map(function (item) {
              if (item.ten == 'DVHC_TP_DA_NANG') {
                localStorage.setItem('tpdnId', item.giaTri);
              } else if (item.ten == 'TQGQ_HANH_CHINH') {
                localStorage.setItem('thamQuyenHanhChinhId', item.giaTri);
              } else {
                var ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
                ts = [].concat(_toConsumableArray(ts), [{ ten: item.ten, giaTri: Number(item.giaTri) }]);
                localStorage.setItem('thamSo', JSON.stringify(ts));
              }
            });
            return Promise.resolve({
              key: 'thamSo',
              data: Data
            });
          }
        }).catch(function (err) {
          _this5.setState({ fails: 'thamSo' });
          return Promise.resolve({
            key: 'thamSo',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getLoaiDonThu',
    value: function getLoaiDonThu(type) {
      var _this6 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.loaiDonThu.length == 0 && this.state.fails == 'loaiDonThu') {
        _api.Reception.actions.getLoaiDonThu.request().then(function (res) {
          _this6.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'loaiDonThu',
              data: res.data
            }]
          });
          _this6.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.Reception.actions.getLoaiDonThu.request().then(function (res) {
          return Promise.resolve({
            key: 'loaiDonThu',
            data: res.data
          });
        }).catch(function (err) {
          _this6.setState({ fails: 'loaiDonThu' });
          return Promise.resolve({
            key: 'loaiDonThu',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getHuongXuLyDon',
    value: function getHuongXuLyDon(type) {
      var _this7 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.huongXuLyDon.length == 0 && this.state.fails == 'huongXuLyDon') {
        _api.LetterProcessingWorkFlow.actions.getHuongXuLyDonSearch.request().then(function (res) {
          _this7.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'huongXuLyDon',
              data: res.data
            }]
          });
          _this7.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.LetterProcessingWorkFlow.actions.getHuongXuLyDonSearch.request().then(function (res) {
          return Promise.resolve({
            key: 'huongXuLyDon',
            data: res.data
          });
        }).catch(function (err) {
          _this7.setState({ fails: 'huongXuLyDon' });
          return Promise.resolve({
            key: 'huongXuLyDon',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getKetQuaTiepDan',
    value: function getKetQuaTiepDan(type) {
      var _this8 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.ketQuaTiepDan.length == 0 && this.state.fails == 'ketQuaTiepDan') {
        _api.Reception.actions.getKetQuaTiepDan.request().then(function (res) {
          _this8.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'ketQuaTiepDan',
              data: res.data
            }]
          });
          _this8.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.Reception.actions.getKetQuaTiepDan.request().then(function (res) {
          return Promise.resolve({
            key: 'ketQuaTiepDan',
            data: res.data
          });
        }).catch(function (err) {
          _this8.setState({ fails: 'ketQuaTiepDan' });
          return Promise.resolve({
            key: 'ketQuaTiepDan',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getCoQuanQuanLy',
    value: function getCoQuanQuanLy(type) {
      var _this9 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.coQuanTiepNhan.length == 0 && this.state.fails == 'coQuanTiepNhan') {
        _api.DuLieuHeThong.actions.getCoQuanTiepNhan.request().then(function (res) {
          _this9.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'coQuanTiepNhan',
              data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
            }]
          });
          _this9.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.DuLieuHeThong.actions.getCoQuanTiepNhan.request().then(function (res) {
          return Promise.resolve({
            key: 'coQuanTiepNhan',
            data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
          });
        }).catch(function (err) {
          _this9.setState({ fails: 'coQuanTiepNhan' });
          return Promise.resolve({
            key: 'coQuanTiepNhan',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getDiaBanTiepNhan',
    value: function getDiaBanTiepNhan(type) {
      var _this10 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.coQuanTiepNhan.length === 0 && this.state.fails == 'diaBanTiepNhan') {
        _api.DuLieuHeThong.actions.getDiaBanTiepNhan.request().then(function (res) {
          _this10.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'diaBanTiepNhan',
              data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
            }]
          });
          _this10.setState({ fails: '' });
        });
      } else if (type === 'init') {
        return _api.DuLieuHeThong.actions.getDiaBanTiepNhan.request().then(function (res) {
          return Promise.resolve({
            key: 'diaBanTiepNhan',
            data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
          });
        }).catch(function (err) {
          _this10.setState({ fails: 'diaBanTiepNhan' });
          return Promise.resolve({
            key: 'diaBanTiepNhan',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getKetLuanNoiDungKhieuNai',
    value: function getKetLuanNoiDungKhieuNai(type) {
      var _this11 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.state.fails === 'ketLuanNoiDungKhieuNai') {
        var params = {
          loaiDon: 'DON_KIEN_NGHI_PHAN_ANH'
        };
        _api.DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request('', params).then(function (res) {
          _this11.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'ketLuanNoiDungKhieuNai',
              data: res.data || []
            }]
          });
          _this11.setState({ fails: '' });
        });
      } else if (type === 'init') {
        var _params2 = {
          loaiDon: 'DON_KIEN_NGHI_PHAN_ANH'
        };
        return _api.DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request('', _params2).then(function (res) {
          return Promise.resolve({
            key: 'ketLuanNoiDungKhieuNai',
            data: res.data
          });
        }).catch(function (err) {
          _this11.setState({ fails: 'ketLuanNoiDungKhieuNai' });
          return Promise.resolve({
            key: 'ketLuanNoiDungKhieuNai',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getKetQuaThucHien',
    value: function getKetQuaThucHien(type) {
      var _this12 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.ketQuaThucHien.length == 0 && this.state.fails == 'ketQuaThucHien') {
        _api.DuLieuHeThong.actions.getKetQuaThucHien.request().then(function (res) {
          _this12.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'ketQuaThucHien',
              data: res.data || []
            }]
          });
          _this12.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.DuLieuHeThong.actions.getKetQuaThucHien.request().then(function (res) {
          return Promise.resolve({
            key: 'ketQuaThucHien',
            data: res.data
          });
        }).catch(function (err) {
          _this12.setState({ fails: 'ketQuaThucHien' });
          return Promise.resolve({
            key: 'ketQuaThucHien',
            data: []
          });
        });
      }
    }
  }, {
    key: 'getLanhDaoTiepDan',
    value: function getLanhDaoTiepDan(type) {
      var _this13 = this;

      if (type == true && this.state.initData === true && _reactCookie2.default.load('accessToken') && this.props.lanhDaoList.length == 0 && this.state.fails == 'lanhDaoList') {
        _api.DuLieuHeThong.actions.getListLanhDao.request().then(function (res) {
          _this13.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'lanhDaoList',
              data: res.data._embedded ? res.data._embedded.congChucs : []
            }]
          });
          _this13.setState({ fails: '' });
        });
      } else if (type == 'init') {
        return _api.DuLieuHeThong.actions.getListLanhDao.request().then(function (res) {
          return Promise.resolve({
            key: 'lanhDaoList',
            data: res.data._embedded ? res.data._embedded.congChucs : []
          });
        }).catch(function (err) {
          _this13.setState({ fails: 'lanhDaoList' });
          return Promise.resolve({
            key: 'lanhDaoList',
            data: []
          });
        });
      }
    }
  }, {
    key: 'onMessage',
    value: function onMessage(msg) {
      this.props.dispatch({
        type: 'NEW_MSG',
        data: msg
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var CheckSystemData = this.checkSystemData();
      return _react2.default.createElement(
        'div',
        { className: this.state.loading === true ? "wrapper lock" : "wrapper" },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.loading === true },
          _react2.default.createElement(
            'div',
            { className: 'wrap-loading' },
            _react2.default.createElement('img', { src: __webpack_require__(623) })
          )
        ),
        this.props.children
      );
    }
  }]);

  return App;
}(_react2.default.Component);

App.defaultProps = {
  init: false,
  refreshMenu: false
};
function bindStateToProps(state) {
  return {
    init: state.duLieuHeThong.init,
    initIDTP: state.duLieuHeThong.initIDTP,
    refreshMenu: state.duLieuHeThong.refreshMenu,
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    huongXuLyDon: state.duLieuHeThong.huongXuLyDon,
    ketQuaTiepDan: state.duLieuHeThong.ketQuaTiepDan,
    coQuanTiepNhan: state.duLieuHeThong.coQuanTiepNhan,
    ketLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    thamSo: state.duLieuHeThong.thamSo
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(App);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _App = __webpack_require__(955);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _App2.default;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _reactRouter = __webpack_require__(2);

var _reactPaginate = __webpack_require__(413);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _common = __webpack_require__(3);

var _downloadFile = __webpack_require__(112);

var _lodash = __webpack_require__(14);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTable = function (_React$Component) {
  _inherits(DataTable, _React$Component);

  function DataTable(props, context) {
    _classCallCheck(this, DataTable);

    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props, context));

    _this.state = {
      export: 'btn-green tt-export',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      divHeight: 195,
      down: false,
      scrollLeft: '',
      x: ''
    };

    return _this;
  }

  _createClass(DataTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      if (this.props.parent && this.props.parent.handleChangePageSize) {
        this.props.parent.handleChangePageSize.bind(this.props.parent, size);
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      if (this.props.parent && this.props.parent.handlePageC1lick) {
        this.props.parent.handlePageClick.bind(this.props.parent, page);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hideExport) {
        this.setState({
          export: 'btn-green tt-export disable'
        });
      }

      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {

      if (this.props.typeExport == 'TIEP_CONG_DAN') {

        if (this.props.parent.state.advanceSearch == true) {
          var startDate = this.props.parent.state.startDate ? (0, _moment2.default)(this.props.parent.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';
          var endDate = this.props.parent.state.endDate ? (0, _moment2.default)(this.props.parent.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';

          var URL = String(_config.API_URL) + "/soTiepCongDans/excel?tuNgay=" + startDate + "&denNgay=" + endDate + "&loaiTiepCongDan=" + this.props.type + "&huongXuLy=" + (this.props.parent.state.handleRedirect ? this.props.parent.state.handleRedirect : '') + "&phanLoaiDon=" + this.props.parent.state.receptionType + "&coQuanQuanLyId=" + this.state.userInfo.donViId + "&lanhDaoId=" + (this.props.parent.state.lanhDaoTiepDan ? this.props.parent.state.lanhDaoTiepDan : '') + "&ketQuaTiepDan=" + (this.props.parent.state.ketQuaTiepDan ? this.props.parent.state.ketQuaTiepDan : '') + "&tinhTrangXuLy=" + (this.props.parent.state.tinhTrangXuLy ? this.props.parent.state.tinhTrangXuLy : '') + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + '&tuKhoa=' + this.props.parent.state.searchKey + '' + '&sort=' + this.props.sortBy;
          window.open(URL, "_self");
        } else {
          var _URL = String(_config.API_URL) + "/soTiepCongDans/excel?loaiTiepCongDan=" + this.props.type + "&coQuanQuanLyId=" + this.state.userInfo.donViId + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + '&sort=' + this.props.sortBy + '&tuKhoa=' + this.props.parent.state.searchKey;
          window.open(_URL, "_self");
        }
      } else if (this.props.typeExport == 'XU_LY_DON') {

        var _URL2 = String(_config.API_URL) + "/dons/xuatExcel?donViXuLyXLD=" + this.state.userInfo.donViId + "&phongBanXuLyXLD=" + this.state.userInfo.coQuanQuanLyId + "&vaiTro=" + this.state.userInfo.loaiVaiTroMacDinh + "&canBoXuLyXLD=" + this.state.userInfo.id + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + "&thanhLapDon=true" + "&trangThaiDon=" + this.props.parent.state.trangThaiXuLyDon;

        if (this.props.sortBy) {
          _URL2 = _URL2 + "&sort=" + this.props.sortBy;
        }

        if (this.props.parent.state.advanceSearch) {

          if (this.props.searchData) {

            if (this.props.searchData.searchKey) {
              _URL2 = _URL2 + "&tuKhoa=" + this.props.searchData.searchKey;
            }

            if (this.props.searchData.startDate) {
              var _startDate = (0, _moment2.default)(this.props.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              _URL2 = _URL2 + "&tiepNhanTuNgay=" + _startDate;
            }

            if (this.props.searchData.endDate) {
              var _endDate = (0, _moment2.default)(this.props.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              _URL2 = _URL2 + "&tiepNhanDenNgay=" + _endDate;
            }

            if (this.props.searchData.maDon) {
              _URL2 = _URL2 + "&maDon=" + this.props.searchData.maDon;
            }

            if (this.props.searchData.nguonDon) {
              _URL2 = _URL2 + "&nguonDon=" + this.props.searchData.nguonDon;
            }

            if (this.props.searchData.phanLoaiDon) {
              _URL2 = _URL2 + "&phanLoaiDon=" + this.props.searchData.phanLoaiDon;
            }

            if (this.props.searchData.tinhTrangXuLy) {
              _URL2 = _URL2 + "&trangThaiDonToanHT=" + this.props.searchData.tinhTrangXuLy;
            }

            if (this.props.searchData.ketQuaXuLy) {
              _URL2 = _URL2 + "&ketQuaToanHT=" + this.props.searchData.ketQuaXuLy;
            }
          }
        } else {
          if (this.props.searchData && this.props.searchData.searchKey) {
            _URL2 = _URL2 + "&tuKhoa=" + this.props.searchData.searchKey;
          }
        }

        window.open(_URL2, "_self");
      } else if (this.props.typeExport == 'DS_YEU_CAU') {

        var _URL3 = String(_config.API_URL) + "/soTiepCongDans/danhSachYeuCauGapLanhDao/excel?donViId=" + this.state.userInfo.donViId;
        if (this.props.parent.state.tuKhoa) {
          _URL3 = _URL3 + "&tuKhoa=" + this.props.parent.state.tuKhoa;
        }
        if (this.props.sortBy) {
          _URL3 = _URL3 + "&sort=" + this.props.sortBy;
        }
        if (this.props.parent.state.advanceSearch) {

          if (this.props.parent.state.tuNgay) {
            var _startDate2 = (0, _moment2.default)(this.props.parent.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            _URL3 = _URL3 + "&tuNgay=" + _startDate2;
          }

          if (this.props.parent.state.denNgay) {
            var _endDate2 = (0, _moment2.default)(this.props.parent.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            _URL3 = _URL3 + "&denNgay=" + _endDate2;
          }

          if (this.props.parent.state.phanLoai) {
            _URL3 = _URL3 + "&phanLoai=" + this.props.parent.state.phanLoai;
          }

          if (this.props.parent.state.nguonDon) {
            _URL3 = _URL3 + "&nguonDon=" + this.props.parent.state.nguonDon;
          }

          if (this.props.parent.state.trangThai) {
            _URL3 = _URL3 + "&trangThai=" + this.props.parent.state.trangThai;
          }
        }

        (0, _downloadFile.downloadFile)(_URL3);
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      this.props.handleExport();
    }
  }, {
    key: 'handleExportExampleKiemTra',
    value: function handleExportExampleKiemTra() {
      this.props.handleExportExampleKiemTra();
    }
  }, {
    key: 'handleImportEmxampleKiemTra',
    value: function handleImportEmxampleKiemTra(e) {
      var _this2 = this;

      var params = {
        field: 'file', file: e.target.files[0]
      };
      _api.Reception.actions.postFileUploadExcelData.request('', params).then(function (res) {
        _this2.props.handleImportEmxampleKiemTra(res, params);
      }).catch(function (error) {
        (0, _toastr.Toastr)((0, _lodash.get)(error, 'response.data.errors[0].detail'), 'error');
      });
    }
  }, {
    key: 'getItemTongSoThongKe',
    value: function getItemTongSoThongKe() {
      var pageNumber = (0, _lodash.get)(this.props.pageData, 'number') || 0;
      var pageSize = (0, _lodash.get)(this.props.pageData, 'size') || 0;
      var dataSum = {};
      if (this.props.dataSum) {
        dataSum = _extends({}, this.props.dataSum);
      }
      dataSum.donVi = {
        id: 'TONG_CONG',
        ten: 'Tổng cộng'
      };
      dataSum.ghiChu = '';
      return _react2.default.cloneElement(this.props.children, {
        count: pageNumber * pageSize + this.props.dataList.length + 1,
        item: dataSum,
        sum: true
      });
    }
  }, {
    key: 'getItemTongDonTrung',
    value: function getItemTongDonTrung() {
      var pageNumber = (0, _lodash.get)(this.props.pageData, 'number') || 0;
      var pageSize = (0, _lodash.get)(this.props.pageData, 'size') || 0;
      var dataDonTrung = {};
      if (this.props.dataDonTrung) {
        dataDonTrung = _extends({}, this.props.dataDonTrung);
      }
      dataDonTrung.donVi = {
        id: 'TONG_TRUNG',
        ten: 'Tổng Trùng'
      };
      dataDonTrung.ghiChu = '';
      return _react2.default.cloneElement(this.props.children, {
        count: pageNumber * pageSize + this.props.dataList.length + 1,
        item: dataDonTrung,
        sum: true
      });
    }
  }, {
    key: 'getItemNull',
    value: function getItemNull() {
      return this.props.children;
    }
  }, {
    key: 'handleDown',
    value: function handleDown(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        document.getElementById('scrollItem').classList.add("scrolling");
        this.state.down = true;
        this.state.scrollLeft = Item.scrollLeft;
        this.state.x = e.clientX;
      }
    }
  }, {
    key: 'handleUp',
    value: function handleUp() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        if (this.state.down == true) {
          Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
        }
      }
    }
  }, {
    key: 'handleLeave',
    value: function handleLeave() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(index, e) {
      this.props.onChangeHeader(index, e);
    }
  }, {
    key: 'addNewItem',
    value: function addNewItem() {
      this.props.addNewItem();
    }
  }, {
    key: 'addNewVanBanCanCu',
    value: function addNewVanBanCanCu() {
      this.props.addNewVanBanCanCu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;
      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this3.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item,
          parent: _this3.props.parent
        });
      });

      var childrenNull = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, { nullElement: true });
      });

      var ItemLoading = _react2.default.createElement(
        'div',
        { className: 'loading-content' },
        _react2.default.createElement('span', { className: 'shape1' }),
        _react2.default.createElement('span', { className: 'shape2' }),
        _react2.default.createElement('span', { className: 'shape3' }),
        _react2.default.createElement('span', { className: 'shape4' }),
        _react2.default.createElement('span', { className: 'shape5' }),
        _react2.default.createElement('span', { className: 'shape6' }),
        _react2.default.createElement('span', { className: 'shape7' }),
        _react2.default.createElement('span', { className: 'shape8' }),
        _react2.default.createElement('span', { className: 'shape9' }),
        _react2.default.createElement('span', { className: 'shape10' }),
        _react2.default.createElement('span', { className: 'shape11' }),
        _react2.default.createElement('span', { className: 'shape12' }),
        _react2.default.createElement('span', { className: 'shape13' })
      );

      return _react2.default.createElement(
        'div',
        { className: this.props.ThongKeBaoCao ? 'wrapper-table wrapper-tkbc' : 'wrapper-table' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.ThongKeBaoCao },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.LapBaoCao == false },
            _react2.default.createElement(
              'div',
              { className: 'header-table-wrap', style: { height: this.state.divHeight } },
              _react2.default.createElement(
                'div',
                { className: 'header-stt' },
                'STT'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-name' },
                '\u0110\u01A0N V\u1ECA'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-ms' },
                'MS'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.tableLoading },
                _react2.default.createElement(
                  'div',
                  { className: 'value-column-fixed-wrap' },
                  this.props.dataList.map(function (item, i) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap', key: i },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-ghichu' },
                        item.ghiChu ? item.ghiChu : ''
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-stt' },
                        i + 1
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-name' },
                        item.model && item.model.name
                      )
                    );
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.dataList.length > 1 && !this.props.isReport },
                    this.props.showTongDonTrung && _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng \u0111\u01A1n tr\xF9ng'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng c\u1ED9ng'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.LapBaoCao == true },
            _react2.default.createElement(
              'div',
              { className: 'header-table-wrap', style: { height: this.state.divHeight } },
              _react2.default.createElement(
                'div',
                { className: 'header-stt' },
                'STT'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-name' },
                '\u0110\u01A0N V\u1ECA'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-ms' },
                'MS'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.tableLoading },
                _react2.default.createElement(
                  'div',
                  { className: 'value-column-fixed-wrap' },
                  this.props.dataList.map(function (item, i) {
                    if (item.donVi && item.donVi.id) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'fixed-column-wrap', key: i },
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-ghichu tt-ghichu-has-bb' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', defaultvalue: item.ghiChu ? item.ghiChu : '' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-stt txt-bold ' + (item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red') },
                          i + 1
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-name txt-bold ' + (item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red') },
                          item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
                        )
                      );
                    } else {
                      return _react2.default.createElement(
                        'div',
                        { className: 'fixed-column-wrap', key: i },
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-ghichu tt-ghichu-has-bb' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', defaultvalue: item.ghiChu ? item.ghiChu : '' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-stt' },
                          i + 1
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-name' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : '', onChange: _this3.onChange.bind(_this3, i) })
                        )
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.addNew == true },
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                        _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                        'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.dataList.length > 1 },
                    this.props.showTongDonTrung && _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng \u0111\u01A1n tr\xF9ng'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng c\u1ED9ng'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        this.props.displayCount ? _react2.default.createElement(
          'div',
          { className: 'tc-total' },
          'C\xF3 ',
          _react2.default.createElement(
            'span',
            null,
            this.props.pageData.totalElements
          ),
          ' k\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm ph\xF9 h\u1EE3p v\u1EDBi y\xEAu c\u1EA7u'
        ) : '',
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('table-container', {
              'touch-move': this.props.touchMove,
              'checktracuu': this.props.checkTraCuu,
              'checktdgs': this.props.checkTDGS
            }),
            id: 'scrollItem',
            onMouseUp: this.handleUp.bind(this),
            onMouseDown: this.handleDown.bind(this),
            onMouseMove: this.handleMove.bind(this),
            onMouseLeave: this.handleLeave.bind(this)
          },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.props.ThongKeBaoCao },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                _react2.default.createElement(
                  'tr',
                  null,
                  this.props.header.map(function (item, i) {
                    return _react2.default.createElement(
                      'th',
                      { key: i, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                      item.name
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.ThongKeBaoCao },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                this.props.header.map(function (headerItems, i) {
                  var items = [];
                  items = [].concat(_toConsumableArray(headerItems));
                  return _react2.default.createElement(
                    'tr',
                    { key: i },
                    items.map(function (item, j) {
                      return _react2.default.createElement(
                        'th',
                        { key: j, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, rowSpan: item.rowSpan, style: { maxWidth: item.maxWidth, width: item.width, minWidth: item.minWidth } },
                        item.name
                      );
                    }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: _this3.props.lapBaoCaoTongHop == true && i == 0 },
                      _react2.default.createElement(
                        'th',
                        { className: 'table-header-col middle-content', colSpan: 1, rowSpan: _this3.props.header.length, style: { width: 120, minWidth: 120 } },
                        'THAO T\xC1C'
                      )
                    )
                  );
                }),
                _react2.default.createElement(
                  'tr',
                  null,
                  Array.from(Array(this.props.numberColumnHeader).keys()).map(function (item, i) {
                    return _react2.default.createElement(
                      'th',
                      { className: 'txt-center', key: i },
                      item - 1
                    );
                  })
                )
              )
            ),
            this.props.tableLoading ? _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              _react2.default.createElement(
                'tr',
                { className: 'table-loading' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !this.props.ThongKeBaoCao },
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length },
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.ThongKeBaoCao },
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    ItemLoading,
                    ItemLoading,
                    ItemLoading
                  )
                )
              )
            ) : _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              dataListItem,
              this.props.ThongKeBaoCao == true && this.props.LapBaoCao == true && this.props.addNew == true ? childrenNull : null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + this.props.plusColum },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + this.props.plusColum },
                    this.props.emptyMsg
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.showAddMore == true },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { className: 'multipe-column', colSpan: this.props.header.length },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-addfile itt-Them-Moi', onClick: this.props.addMore },
                      this.props.titleAddmore
                    )
                  )
                )
              ),
              this.props.thongKeDonCu && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: 2, className: 'txt-left' },
                  _react2.default.createElement(
                    'span',
                    { className: 'title-12' },
                    'T\u1ED5ng \u0111\u01A1n'
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDonDonGian
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDonPhucTap
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDon
                )
              ),
              this.props.isTableCanCuCuocThanhTra && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'multipe-column', colSpan: this.props.header.length },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-addfile itt-Them-Moi', onClick: this.addNewVanBanCanCu.bind(this) },
                    'Th\xEAm m\u1EDBi v\u0103n b\u1EA3n'
                  )
                )
              )
            )
          ),
          !this.props.hidePagination && this.props.dataList.length > 0 && !this.props.ThongKeBaoCao ? _react2.default.createElement(
            'div',
            { className: 'pagination-wrap' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thanhTra || !this.props.hideButtonExport },
              _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
            ),
            this.props.pageData && this.props.pageData.totalElements && this.props.pageData.totalElements > this.props.pageData.size ? _react2.default.createElement(_reactPaginate2.default, {
              pageCount: this.props.pageData ? this.props.pageData.totalPages : 1,
              marginPagesDisplayed: 1, pageRangeDisplayed: 2, previousLabel: "<", nextLabel: ">",
              breakLabel: _react2.default.createElement(
                'a',
                { href: 'javascript:void(0)' },
                '...'
              ), breakClassName: "item",
              onPageChange: this.props.parent.handlePageClick.bind(this.props.parent),
              containerClassName: "pagination-list", pageClassName: 'item',
              subContainerClassName: "pages pagination", previousClassName: 'item',
              nextClassName: 'item', activeClassName: "active",
              forcePage: this.props.pageData ? this.props.pageData.number : 0 }) : null,
            '(' + (pageNumber * pageSize + 1) + '-' + (this.props.pageData.totalElements < (pageNumber + 1) * pageSize ? this.props.pageData.totalElements : (pageNumber + 1) * pageSize) + '/' + this.props.pageData.totalElements + ') Tr\xEAn 1 trang: ',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 10 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 10) },
              '10'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 25 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 25) },
              '25'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 50 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 50) },
              '50'
            )
          ) : null,
          this.props.isKiemTra && _react2.default.createElement(
            'div',
            { className: 'wrap-import-kiem-tra' },
            _react2.default.createElement(
              'div',
              { className: 'download_file_content pt10 download-example-file', onClick: this.handleExportExampleKiemTra.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'T\u1EA3i file import m\u1EABu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-input-tt-dvph' },
              _react2.default.createElement(
                'div',
                { className: 'upload_file_content pt10' },
                _react2.default.createElement('input', { type: 'file', accept: '.xls, .xlsx', name: 'uploadFile', className: 'upload btn-green btn-pullleft', ref: 'btnUpload', onChange: this.handleImportEmxampleKiemTra.bind(this) }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { htmlFor: 'file', className: 'btn-orange', onClick: this.handleImportEmxampleKiemTra.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-document-import' }),
                  'Import cu\u1ED9c ki\u1EC3m tra'
                )
              )
            )
          )
        ),
        this.props.ThongKeBaoCao && !this.props.hideExport ? _react2.default.createElement(
          'div',
          { className: 'pagination-wrap' },
          _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
        ) : null
      );
    }
  }]);

  return DataTable;
}(_react2.default.Component);

exports.default = DataTable;

DataTable.defaultProps = {
  onChangeHeader: function onChangeHeader() {},
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  titleAddmore: 'Thêm mới',
  ThongKeBaoCao: false,
  LapBaoCao: false,
  addNew: false,
  addNewItem: function addNewItem() {},
  dataList: [],
  header: [],
  plusColum: 0,
  displayCount: false,
  emptyMsg: 'Chưa có dữ liệu'
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTableKetQua = function (_React$Component) {
  _inherits(DataTableKetQua, _React$Component);

  function DataTableKetQua(props, context) {
    _classCallCheck(this, DataTableKetQua);

    var _this = _possibleConstructorReturn(this, (DataTableKetQua.__proto__ || Object.getPrototypeOf(DataTableKetQua)).call(this, props, context));

    _this.state = {
      divHeight: 195
    };
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated


  _createClass(DataTableKetQua, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'renderHeaderTable',
    value: function renderHeaderTable(_ref) {
      var header = _ref.header,
          numberColumnHeader = _ref.numberColumnHeader;

      var column = header.map(function (headerItems, i) {
        var items = [];
        items = [].concat(_toConsumableArray(headerItems));

        return _react2.default.createElement(
          'tr',
          { key: i },
          items.map(function (item, j) {
            return _react2.default.createElement(
              'th',
              {
                key: j,
                className: 'table-header-col ' + (item.className || ''),
                colSpan: item.colSpan || 1,
                rowSpan: item.rowSpan || 1,
                style: {
                  maxWidth: item.maxWidth,
                  width: item.width,
                  minWidth: item.minWidth
                }
              },
              item.name
            );
          })
        );
      });

      var numberColumn = _react2.default.createElement(
        'tr',
        null,
        Array.from(Array(numberColumnHeader).keys()).map(function (item, i) {
          return _react2.default.createElement(
            'th',
            { className: 'txt-center', key: i },
            item + 1
          );
        })
      );

      return _react2.default.createElement(
        'thead',
        { className: 'table-header' },
        column,
        numberColumnHeader && numberColumn
      );
    }
  }, {
    key: 'renderContentTable',
    value: function renderContentTable(_ref2) {
      var tableLoading = _ref2.tableLoading,
          children = _ref2.children,
          header = _ref2.header;

      var renderLoading = _react2.default.createElement(
        'div',
        { className: 'loading-content' },
        _react2.default.createElement('span', { className: 'shape1' }),
        _react2.default.createElement('span', { className: 'shape2' }),
        _react2.default.createElement('span', { className: 'shape3' }),
        _react2.default.createElement('span', { className: 'shape4' }),
        _react2.default.createElement('span', { className: 'shape5' }),
        _react2.default.createElement('span', { className: 'shape6' }),
        _react2.default.createElement('span', { className: 'shape7' }),
        _react2.default.createElement('span', { className: 'shape8' }),
        _react2.default.createElement('span', { className: 'shape9' }),
        _react2.default.createElement('span', { className: 'shape10' }),
        _react2.default.createElement('span', { className: 'shape11' }),
        _react2.default.createElement('span', { className: 'shape12' }),
        _react2.default.createElement('span', { className: 'shape13' })
      );

      return _react2.default.createElement(
        'tbody',
        { className: 'table-body' },
        tableLoading ? _react2.default.createElement(
          'tr',
          { className: 'table-loading' },
          _react2.default.createElement(
            'td',
            { colSpan: header.length },
            renderLoading,
            renderLoading,
            renderLoading
          )
        ) : children
      );
    }
  }, {
    key: 'handleDown',
    value: function handleDown(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        document.getElementById('scrollItem').classList.add('scrolling');
        this.state.down = true;
        this.state.scrollLeft = Item.scrollLeft;
        this.state.x = e.clientX;
      }
    }
  }, {
    key: 'handleUp',
    value: function handleUp() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove('scrolling');
        this.state.down = false;
      }
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        if (this.state.down == true) {
          Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
        }
      }
    }
  }, {
    key: 'handleLeave',
    value: function handleLeave() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove('scrolling');
        this.state.down = false;
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      this.props.handleExport();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          touchMove = _props.touchMove,
          children = _props.children,
          tableLoading = _props.tableLoading,
          numberColumnHeader = _props.numberColumnHeader,
          exportText = _props.exportText;
      var renderHeaderTable = this.renderHeaderTable,
          renderContentTable = this.renderContentTable;


      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table wrapper-tkbc' },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('table-container', {
              'touch-move': touchMove
            }),
            style: { overflowY: 'clip' },
            id: 'scrollItem',
            onMouseUp: this.handleUp.bind(this),
            onMouseDown: this.handleDown.bind(this),
            onMouseMove: this.handleMove.bind(this),
            onMouseLeave: this.handleLeave.bind(this)
          },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            renderHeaderTable({ header: header, numberColumnHeader: numberColumnHeader }),
            renderContentTable({ tableLoading: tableLoading, children: children, header: header })
          )
        ),
        exportText && _react2.default.createElement(_core.Button, {
          className: 'btn-green tt-export mt15',
          text: exportText || 'Xuất Excel',
          onClick: this.handleExport.bind(this)
        })
      );
    }
  }]);

  return DataTableKetQua;
}(_react2.default.Component);

exports.default = DataTableKetQua;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Header = __webpack_require__(305);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(471);

var _Footer2 = _interopRequireDefault(_Footer);

var _api = __webpack_require__(5);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.CALL_API = false;

var MasterLayout = function (_React$Component) {
  _inherits(MasterLayout, _React$Component);

  function MasterLayout() {
    _classCallCheck(this, MasterLayout);

    return _possibleConstructorReturn(this, (MasterLayout.__proto__ || Object.getPrototypeOf(MasterLayout)).apply(this, arguments));
  }

  _createClass(MasterLayout, [{
    key: 'handleMouseClick',
    value: function handleMouseClick() {
      if (_reactCookie2.default.load('accessToken') && window.CALL_API == false) {
        window.CALL_API = true;
        setTimeout(function () {
          window.CALL_API = false;
        }, 180000);
        _api.User.actions.updateSession.request();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {});
      });
      return _react2.default.createElement(
        'div',
        { className: 'wrapper-container' },
        _react2.default.createElement(_Header2.default, { routerName: this.props.routerName }),
        _react2.default.createElement(
          'main',
          {
            className: (0, _classnames2.default)('main-container', {
              'tc': this.props.routerName == 'congDanTraCuu' || this.props.routerName === 'giamSatTraCuu',
              'no-bg': this.props.type == 'ketQua'
            }),
            onMouseUp: this.handleMouseClick.bind(this) },
          childrenWithProps
        ),
        _react2.default.createElement(_Footer2.default, null)
      );
    }
  }]);

  return MasterLayout;
}(_react2.default.Component);

MasterLayout.defaultProps = {
  type: ''
};

exports.default = MasterLayout;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Header = __webpack_require__(305);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SingleLayout = function (_React$Component) {
  _inherits(SingleLayout, _React$Component);

  function SingleLayout() {
    _classCallCheck(this, SingleLayout);

    return _possibleConstructorReturn(this, (SingleLayout.__proto__ || Object.getPrototypeOf(SingleLayout)).apply(this, arguments));
  }

  _createClass(SingleLayout, [{
    key: 'render',
    value: function render() {
      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {});
      });
      return _react2.default.createElement(
        'div',
        { className: 'wrapper-container' },
        _react2.default.createElement(_Header2.default, null),
        _react2.default.createElement(
          'main',
          { className: 'main-container' },
          childrenWithProps
        )
      );
    }
  }]);

  return SingleLayout;
}(_react2.default.Component);

exports.default = SingleLayout;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconPhone = __webpack_require__(2012);
var iconPhoneLg = __webpack_require__(2011);

var HotLine = function (_React$Component) {
  _inherits(HotLine, _React$Component);

  function HotLine() {
    _classCallCheck(this, HotLine);

    return _possibleConstructorReturn(this, (HotLine.__proto__ || Object.getPrototypeOf(HotLine)).apply(this, arguments));
  }

  _createClass(HotLine, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'hotline-wrap' },
        this.props.routerName == 'congDanTraCuu' ? _react2.default.createElement('img', { src: iconPhoneLg, alt: 'iconPhoneLg', className: 'phone-ico' }) : _react2.default.createElement('img', { src: iconPhone, alt: 'iconPhone', className: 'phone-ico' }),
        _react2.default.createElement(
          'div',
          { className: 'hotline-content' },
          _react2.default.createElement(
            'span',
            { className: 'hotline-number' },
            '0255 3824 185'
          )
        )
      );
    }
  }]);

  return HotLine;
}(_react2.default.Component);

exports.default = HotLine;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logoImg = __webpack_require__(2010);

var Logo = function (_React$Component) {
  _inherits(Logo, _React$Component);

  function Logo() {
    _classCallCheck(this, Logo);

    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
  }

  _createClass(Logo, [{
    key: 'render',
    value: function render() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTW = 19;
      return _react2.default.createElement(
        'div',
        { className: 'logo-wrap' },
        _react2.default.createElement(
          'h1',
          { className: 'logo', id: 'logo' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: userInfo.capCoQuanQuanLyId !== TTTW ? '/' : '/thanh-tra', className: 'logo-link' },
            _react2.default.createElement('img', { src: logoImg, alt: '', className: 'logo-image' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'logo-text' },
          'Ph\u1EA7n m\u1EC1m v\xE0 x\xE2y d\u1EF1ng c\u01A1 s\u1EDF d\u1EEF li\u1EC7u ho\u1EA1t \u0111\u1ED9ng thanh tra tr\xEAn \u0111\u1ECBa b\xE0n T\u1EC9nh Qu\u1EA3ng Ng\xE3i'
        )
      );
    }
  }]);

  return Logo;
}(_react2.default.Component);

exports.default = Logo;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _menu = __webpack_require__(968);

var TMenu = _interopRequireWildcard(_menu);

var _menuConfig = __webpack_require__(1584);

var _menuConfig2 = _interopRequireDefault(_menuConfig);

var _CheckPermission = __webpack_require__(20);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var homeIcon = __webpack_require__(2009);
var tcdIcon = __webpack_require__(2014);
var xldIcon = __webpack_require__(2019);
var gdqIcon = __webpack_require__(2008);
var ttIcon = __webpack_require__(2017);
var thbcIcon = __webpack_require__(2016);
var tdgsIcon = __webpack_require__(2015);
var qthtIcon = __webpack_require__(2013);
var folderIcon = __webpack_require__(2002);
var paperDocument = __webpack_require__(2004);
var statistical = __webpack_require__(2003);
var baoCaoThamNhungIcon = __webpack_require__(2005);

var MultipleLeverMenu = function (_React$Component) {
  _inherits(MultipleLeverMenu, _React$Component);

  function MultipleLeverMenu(props, context) {
    _classCallCheck(this, MultipleLeverMenu);

    var _this = _possibleConstructorReturn(this, (MultipleLeverMenu.__proto__ || Object.getPrototypeOf(MultipleLeverMenu)).call(this, props, context));

    _this.state = {
      displaySystemMenu: false,
      displaySystemMenuDanhMuc: false,
      displaySystemMenuDonVi: false,
      displaySystemMenuNguoiDung: false,
      displaySystemMenuCauHinh: false,
      tongSoDonXLD: 0,
      tongSoDonGQD: 0,
      tongSoDonDinhKy: 0,
      tongSoDonDotXuat: 0,
      tongSoDonYeuCau: 0,
      tongSoDonTDTH: 0,
      isMenuAdmin: false
    };
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated


  _createClass(MultipleLeverMenu, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkPermissionMenu();
    }

    // eslint-disable-next-line react/no-deprecated

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // this.checkDonVi();
      if (nextProps.notifyTongXLD) {
        this.setState({ tongSoDonXLD: nextProps.notifyTongXLD.tongSoDon });
      }
      if (nextProps.notifyTongDonDK) {
        this.setState({ tongSoDonDinhKy: nextProps.notifyTongDonDK.tongSoDon });
      }
      if (nextProps.notifyTongDonDX) {
        this.setState({ tongSoDonDotXuat: nextProps.notifyTongDonDX.tongSoDon });
      }
      if (nextProps.notifyTongDonYC) {
        this.setState({ tongSoDonYeuCau: nextProps.notifyTongDonYC.tongSoDon });
      }
      if (nextProps.notifyTongGQD) {
        this.setState({ tongSoDonGQD: nextProps.notifyTongGQD.tongSoDon });
      }
      if (nextProps.notifyTongDonTDTH) {
        this.setState({ tongSoDonTDTH: nextProps.notifyTongDonTDTH.tongSoDon });
      }
    }

    // checkDonVi() {
    //   let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    //   let thanhTraThanhPhoId = ThamSo.filter(item => item.ten == 'CQQL_THANH_TRA_THANH_PHO');
    //   if (this.refs.menuBar) {
    //     this.setState({thanhTraThanhPhoId: thanhTraThanhPhoId.length ? thanhTraThanhPhoId[0].giaTri : ''});
    //   }
    // }

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var items = document.getElementsByClassName('menu-list')[0].children;
      var isMenuAdmin = false;
      if (items.length > 6) {
        isMenuAdmin = true;
      } else {
        isMenuAdmin = false;
      }
      this.setState({ isMenuAdmin: isMenuAdmin });

      // this.checkDonVi();
      if (typeof _reactCookie2.default.load('accessToken') === 'undefined') {
        _reactRouter.browserHistory.push('/dang-nhap');
      } else {
        if (this.props.notifyTongXLD) {
          this.setState({ tongSoDonXLD: this.props.notifyTongXLD.tongSoDon });
        }
        if (this.props.notifyTongDonDK) {
          this.setState({ tongSoDonDinhKy: this.props.notifyTongDonDK.tongSoDon });
        }
        if (this.props.notifyTongDonDX) {
          this.setState({ tongSoDonDotXuat: this.props.notifyTongDonDX.tongSoDon });
        }
        if (this.props.notifyTongDonYC) {
          this.setState({ tongSoDonYeuCau: this.props.notifyTongDonYC.tongSoDon });
        }
        if (this.props.notifyTongGQD) {
          this.setState({ tongSoDonGQD: this.props.notifyTongGQD.tongSoDon });
        }
        if (this.props.notifyTongDonTDTH) {
          this.setState({ tongSoDonTDTH: this.props.notifyTongDonTDTH.tongSoDon });
        }
      }
    }
  }, {
    key: 'checkPermissionMenu',
    value: function checkPermissionMenu() {
      var _this2 = this;

      _menuConfig2.default.quanLyDanhMuc.map(function (item, i) {
        if ((0, _CheckPermission.CheckPermission)(item.key)) {
          _this2.setState({ displaySystemMenuDanhMuc: true, displaySystemMenu: true });
        }
      });
      _menuConfig2.default.quanLyDonVi.map(function (item, i) {
        if ((0, _CheckPermission.CheckPermission)(item.key)) {
          _this2.setState({ displaySystemMenuDonVi: true, displaySystemMenu: true });
        }
      });
      _menuConfig2.default.quanLyNguoiDung.map(function (item, i) {
        if ((0, _CheckPermission.CheckPermission)(item.key)) {
          _this2.setState({ displaySystemMenuNguoiDung: true, displaySystemMenu: true });
        }
      });
      _menuConfig2.default.cauHinhHeThong.map(function (item, i) {
        if ((0, _CheckPermission.CheckPermission)(item.key)) {
          _this2.setState({ displaySystemMenuCauHinh: true, displaySystemMenu: true });
        }
      });
    }
  }, {
    key: 'onMessage',
    value: function onMessage(msg) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var idList = msg.listIdUser.split(';');
      if (idList.indexOf(String(userInfo.id)) != -1 && msg.soLuong != 'KHONG') {
        switch (msg.type) {
          // case 'TB_DON_XL':
          //   if (msg.soLuong == 'TANG') {
          //     this.state.tongSoDonXLD += 1;
          //   } else {
          //     this.state.tongSoDonXLD -= 1;
          //   }
          //   this.props.dispatch({
          //     type: 'UPDATE_TONGDON',
          //     key: 'notifyTongXLD',
          //     value: this.state.tongSoDonXLD
          //   });
          // break;
          case 'TB_DON_TCD_LANH_DAO':
            if (msg.soLuong == 'TANG') {
              this.state.tongSoDonYeuCau += 1;
            } else {
              this.state.tongSoDonYeuCau -= 1;
            }
            this.props.dispatch({
              type: 'UPDATE_TONGDON',
              key: 'notifyTongDonYC',
              value: this.state.tongSoDonYeuCau
            });
            break;
          case 'TB_DON_TCD_DINH_KY':
            if (msg.soLuong == 'TANG') {
              this.state.tongSoDonDinhKy += 1;
            } else {
              this.state.tongSoDonDinhKy -= 1;
            }
            this.props.dispatch({
              type: 'UPDATE_TONGDON',
              key: 'notifyTongDonDK',
              value: this.state.tongSoDonDinhKy
            });
            break;
          case 'TB_DON_TCD_DOT_XUAT':
            if (msg.soLuong == 'TANG') {
              this.state.tongSoDonDotXuat += 1;
            } else {
              this.state.tongSoDonDotXuat -= 1;
            }
            this.props.dispatch({
              type: 'UPDATE_TONGDON',
              key: 'notifyTongDonDX',
              value: this.state.tongSoDonDotXuat
            });
            break;
          case 'TB_DON_GQ':
            if (msg.soLuong == 'TANG') {
              this.state.tongSoDonGQD += 1;
            } else {
              this.state.tongSoDonGQD -= 1;
            }
            this.props.dispatch({
              type: 'UPDATE_TONGDON',
              key: 'notifyTongGQD',
              value: this.state.tongSoDonGQD
            });
            break;
          case 'TB_DON_TDTH':
            if (msg.soLuong == 'TANG') {
              this.state.tongSoDonTDTH += 1;
            } else {
              this.state.tongSoDonTDTH -= 1;
            }
            this.props.dispatch({
              type: 'UPDATE_TONGDON',
              key: 'notifyTongDonTDTH',
              value: this.state.tongSoDonTDTH
            });
            break;
        }
        if (this.refs.menuBar) {
          this.setState(_extends({}, this.state));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var tcdNofifyCount = this.state.tongSoDonYeuCau + this.state.tongSoDonDinhKy + this.state.tongSoDonDotXuat;
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTW = 19;
      return _react2.default.createElement(
        'nav',
        { className: 'menu-top', ref: 'menuBar' },
        _react2.default.createElement(
          TMenu.Menu,
          null,
          userInfo.capCoQuanQuanLyId !== TTTW && userInfo.loaiVaiTroMacDinh !== 'NHAP_LIEU_DON_CU' && _react2.default.createElement(
            'li',
            { className: 'menu-items ' + (this.props.routerName == 'home' ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/', className: 'item-link', id: 'menuTrangChu' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: homeIcon, alt: 'trang-chu' })
              ),
              'Trang ch\u1EE7'
            )
          ),
          (0, _CheckPermission.CheckPermission)('THANHTRA_LIETKE') && _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName.indexOf('thanhtra') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuThanhTra' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: ttIcon, alt: 'thanh-tra' })
              ),
              'Thanh tra'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'sub-menu ' },
              _react2.default.createElement(
                'li',
                { className: (0, _classnames2.default)('menu-items', { 'sub-menu-haschildren': this.props.thanhTraThanhPhoId === userInfo.donViId }) },
                this.props.thanhTraThanhPhoId === userInfo.donViId ? _react2.default.createElement(
                  'span',
                  { className: 'item-link' },
                  'Danh s\xE1ch k\u1EBF ho\u1EA1ch thanh tra'
                ) : _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra', id: 'menuDanhSachKeHoachTT', className: 'item-link' },
                  'Danh s\xE1ch k\u1EBF ho\u1EA1ch thanh tra'
                ),
                this.props.thanhTraThanhPhoId === userInfo.donViId && _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu sub-menu-thongke' },
                  _react2.default.createElement(TMenu.MenuItem, { path: '/thanh-tra', id: 'menuKHTT_0', name: 'Danh s\xE1ch KHTT t\u1EA1i Thanh tra t\u1EC9nh', key: 0 }),
                  _react2.default.createElement(TMenu.MenuItem, { path: '/thanh-tra/danh-sach-tong-hop-khtt-cua-cac-don-vi', id: 'menuKHTT_1', name: 'Danh s\xE1ch KHTT c\u1EE7a c\xE1c \u0111\u01A1n v\u1ECB', key: 1 })
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra-da-phe-duyet', id: 'menuDanhSachKeHoachTTDPD', className: 'item-link' },
                  'Danh s\xE1ch k\u1EBF ho\u1EA1ch \u0111\xE3 ph\xEA duy\u1EC7t'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: (0, _classnames2.default)('menu-items', { 'sub-menu-haschildren': this.props.thanhTraThanhPhoId === userInfo.donViId }) },
                this.props.thanhTraThanhPhoId === userInfo.donViId ? _react2.default.createElement(
                  'span',
                  { className: 'item-link' },
                  'Danh m\u1EE5c cu\u1ED9c TT, KT'
                ) : _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra/danh-sach-cuoc-thanh-tra', id: 'menuDanhSachCuocTT', className: 'item-link' },
                  'Danh m\u1EE5c cu\u1ED9c TT, KT'
                ),
                this.props.thanhTraThanhPhoId === userInfo.donViId && _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu sub-menu-thongke' },
                  _react2.default.createElement(TMenu.MenuItem, { path: '/thanh-tra/danh-sach-cuoc-thanh-tra', id: 'menuCTT_0', name: 'Danh m\u1EE5c cu\u1ED9c TT, KT t\u1EA1i Thanh tra t\u1EC9nh', key: 0 }),
                  _react2.default.createElement(TMenu.MenuItem, { path: '/thanh-tra/danh-muc-tong-hop-thanh-tra-cua-cac-don-vi', id: 'menuCTT_1', name: 'Danh m\u1EE5c cu\u1ED9c TT, KT c\u1EE7a c\xE1c \u0111\u01A1n v\u1ECB', key: 1 })
                )
              ),
              (0, _CheckPermission.CheckPermission)('CUOCTHANHTRATRUNG_XEM') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra/danh-muc-cuoc-thanh-tra-trung', id: 'menuDanhSachDoiTuongTT', className: 'item-link' },
                  'Danh m\u1EE5c cu\u1ED9c thanh tra tr\xF9ng'
                )
              ),
              userInfo.donViId === this.props.thanhTraThanhPhoId && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra/danh-sach-lich-su-ttt', id: 'menuDanhSachDoiTuongTT', className: 'item-link' },
                  'Danh s\xE1ch l\u1ECBch s\u1EED x\u1EED l\xFD tr\xF9ng'
                )
              )
            )
          ),
          ((0, _CheckPermission.CheckPermission)('THEODOIGIAMSAT_LIETKE') || (0, _CheckPermission.CheckPermission)('THEO_DOI_THUC_HIEN_LIETKE') || (0, _CheckPermission.CheckPermission)('THEODOITHUCHIENSAUGIAIQUYET_LIETKE')) && _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName == 'theodoi' ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuTheoDoiGiamSat' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: tdgsIcon, alt: 'theo-doi' }),
                this.state.tongSoDonTDTH > 0 ? this.state.tongSoDonTDTH > 99 ? _react2.default.createElement(
                  'span',
                  { className: 'menu-notification mid' },
                  '99',
                  _react2.default.createElement(
                    'sup',
                    null,
                    '+'
                  )
                ) : _react2.default.createElement(
                  'span',
                  { className: 'menu-notification mid' },
                  this.state.tongSoDonTDTH
                ) : null
              ),
              'Theo d\xF5i'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'sub-menu ', style: { width: '245px' } },
              (0, _CheckPermission.CheckPermission)('THEODOIGIAMSAT_LIETKE') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi', id: 'menuTD_GS' },
                  'Ki\u1EC3m tra theo d\xF5i \u0111\xF4n \u0111\u1ED1c'
                )
              ),
              (0, _CheckPermission.CheckPermission)('THEO_DOI_THUC_HIEN_LIETKE') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/danh-sach-theo-doi-thuc-hien', id: 'menuTD_TH' },
                  'Theo d\xF5i th\u1EF1c hi\u1EC7n sau thanh tra'
                )
              ),
              (0, _CheckPermission.CheckPermission)('THEODOITHUCHIENSAUGIAIQUYET_LIETKE') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/theo-doi-thuc-hien-giai-quyet-don', id: 'menuTD_TH_GQD' },
                  this.state.tongSoDonTDTH > 0 ? this.state.tongSoDonTDTH > 99 ? _react2.default.createElement(
                    'span',
                    { className: 'menu-notification child' },
                    '99',
                    _react2.default.createElement(
                      'sup',
                      null,
                      '+'
                    )
                  ) : _react2.default.createElement(
                    'span',
                    { className: 'menu-notification child' },
                    this.state.tongSoDonTDTH
                  ) : null,
                  'Theo d\xF5i th\u1EF1c hi\u1EC7n gi\u1EA3i quy\u1EBFt \u0111\u01A1n'
                )
              )
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName.indexOf('quanlyhoso') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuQuanLyHoSo' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: folderIcon, alt: 'quan-ly-ho-so' })
              ),
              'Qu\u1EA3n l\xFD h\u1ED3 s\u01A1'
            ),
            _react2.default.createElement(
              'ul',
              { className: (0, _classnames2.default)('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin }) },
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-ho-so/danh-sach-ho-so', id: 'menuDSHS' },
                  'Danh s\xE1ch h\u1ED3 s\u01A1'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-ho-so/danh-muc-nhom-ho-so', id: 'menuDMNHS' },
                  'Danh m\u1EE5c nh\xF3m h\u1ED3 s\u01A1'
                )
              )
            )
          ),
          (0, _CheckPermission.CheckPermission)('TONGHOPBAOCAO_LIETKE') && _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName.indexOf('thongkebaocao') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuTongHopBC' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: thbcIcon, alt: 'tongHopBaoCao' })
              ),
              'T\u1ED5ng h\u1EE3p b\xE1o c\xE1o'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'sub-menu ' },
              _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuBCThanhTra' },
                  'B\xE1o c\xE1o thanh tra'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu sub-menu-thongke' },
                  _menuConfig2.default.thongKeBaoCaoThanhTra.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuBCThanhTra' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuBCThanhTra' },
                  'B\xE1o c\xE1o ki\u1EC3m tra'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu sub-menu-thongke' },
                  _menuConfig2.default.baoCaoKiemTra.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuBCThanhTra' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              )
            )
          ),
          (0, _CheckPermission.CheckPermission)('DONCU_LIETKE') && _react2.default.createElement(
            'li',
            { className: (0, _classnames2.default)('menu-items', { 'is-active': this.props.routerName === 'xulydoncu' }) },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/xu-ly-don-cu', className: 'item-link', id: 'menuXuLyDon' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement(
                  'span',
                  { className: 'wrap-notification' },
                  _react2.default.createElement('img', { src: xldIcon, alt: 'xu-ly-don-cu' })
                )
              ),
              'Nh\u1EADp li\u1EC7u \u0111\u01A1n c\u0169'
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName.indexOf('vanban') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuLyVanBan' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: paperDocument, alt: 'quan-ly-van-ban' })
              ),
              'Qu\u1EA3n l\xFD v\u0103n b\u1EA3n'
            ),
            _react2.default.createElement(
              'ul',
              { className: (0, _classnames2.default)('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin }) },
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-van-ban/danh-sach-van-ban', id: 'menuQLDMVB' },
                  'Qu\u1EA3n l\xFD danh m\u1EE5c v\u0103n b\u1EA3n'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-van-ban/the-loai-van-ban', id: 'menuQLVB' },
                  'Th\u1EC3 lo\u1EA1i v\u0103n b\u1EA3n'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-van-ban/linh-vuc-van-ban', id: 'menuLVVB' },
                  'L\u0129nh v\u1EF1c v\u0103n b\u1EA3n'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', to: '/quan-ly-van-ban/co-quan-ban-hanh-van-ban', id: 'menuCQBHVB' },
                  'C\u01A1 quan ban h\xE0nh v\u0103n b\u1EA3n'
                )
              )
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'menu-items ' + (this.props.routerName.indexOf('thongKe') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/thong-ke', className: 'item-link', id: 'menuThongKe' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: statistical, alt: 'thong-ke' })
              ),
              'Th\u1ED1ng k\xEA'
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'menu-items ' + (this.props.routerName == 'baocaothamnhung' ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/bao-cao-tham-nhung', className: 'item-link', id: 'menuTrangChu' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: baoCaoThamNhungIcon, alt: 'bao-cao-tham-nhung' })
              ),
              'B\xE1o c\xE1o tham nh\u0169ng'
            )
          ),
          this.state.displaySystemMenu && _react2.default.createElement(
            'li',
            { className: 'menu-items menu-haschildren ' + (this.props.routerName.indexOf('danhmuc') != -1 ? 'is-active' : '') },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'item-link', id: 'menuQuanTriHeThong' },
              _react2.default.createElement(
                'span',
                { className: 'wrap-img-mn' },
                _react2.default.createElement('img', { src: qthtIcon, alt: 'quan-tri-ht' })
              ),
              'Qu\u1EA3n tr\u1ECB h\u1EC7 th\u1ED1ng'
            ),
            _react2.default.createElement(
              'ul',
              { className: (0, _classnames2.default)('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin }) },
              this.state.displaySystemMenuDanhMuc && _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuQuanLyDanhMuc' },
                  'Qu\u1EA3n l\xFD danh m\u1EE5c'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu' },
                  _menuConfig2.default.quanLyDanhMuc.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuQuanLyDanhMuc' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              ),
              this.state.displaySystemMenuDonVi && _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuQuanLyDonVi' },
                  'Qu\u1EA3n l\xFD \u0111\u01A1n v\u1ECB'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu' },
                  _menuConfig2.default.quanLyDonVi.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuQuanLyDonVi' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              ),
              this.state.displaySystemMenuNguoiDung && _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuQuanLyNguoiDung' },
                  'Qu\u1EA3n l\xFD ng\u01B0\u1EDDi d\xF9ng'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu' },
                  _menuConfig2.default.quanLyNguoiDung.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuQuanLyNguoiDung' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              ),
              this.state.displaySystemMenuCauHinh && _react2.default.createElement(
                'li',
                { className: 'menu-items sub-menu-haschildren' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'item-link', id: 'menuCauHinhHeThong' },
                  'C\u1EA5u h\xECnh h\u1EC7 th\u1ED1ng'
                ),
                _react2.default.createElement(
                  'ul',
                  { className: 'sub-menu' },
                  _menuConfig2.default.cauHinhHeThong.map(function (menuItem, index) {
                    if ((0, _CheckPermission.CheckPermission)(menuItem.key)) {
                      return _react2.default.createElement(TMenu.MenuItem, { path: menuItem.path, id: 'menuCauHinhHeThong' + index, name: menuItem.name, key: index });
                    }
                  })
                )
              ),
              (0, _CheckPermission.CheckPermission)('THAYDOICANBO_LIETKE') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/quan-ly-danh-muc/cap-nhat-nguoi-dung', className: 'item-link', id: 'menuCapNhatNguoiDung' },
                  'C\u1EADp nh\u1EADt ng\u01B0\u1EDDi d\xF9ng'
                )
              ),
              (0, _CheckPermission.CheckPermission)('THAYDOICANBOXULYDON_LIETKE') && _react2.default.createElement(
                'li',
                { className: 'menu-items' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/quan-ly-danh-muc/danh-sach-don-theo-cong-chuc', className: 'item-link', id: 'menuCapNhatNguoiDung' },
                  'Thay \u0111\u1ED5i ng\u01B0\u1EDDi d\xF9ng x\u1EED l\xFD'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return MultipleLeverMenu;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    notifyTongXLD: state.duLieuHeThong.notifyTongXLD,
    notifyTongDonDK: state.duLieuHeThong.notifyTongDonDK,
    notifyTongGQD: state.duLieuHeThong.notifyTongGQD,
    notifyTongDonDX: state.duLieuHeThong.notifyTongDonDX,
    notifyTongDonYC: state.duLieuHeThong.notifyTongDonYC,
    notifyTongDonTDTH: state.duLieuHeThong.notifyTongDonTDTH
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(MultipleLeverMenu);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import {checkThamSo} from "constants/checkThamSo";


var userIcon = __webpack_require__(2018);

var Profile = function (_React$Component) {
  _inherits(Profile, _React$Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'clearAllCookie',


    // checkVaiTro() {
    //   let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    //   let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    //   if (ThamSo.length > 0 && userInfo != {}) {
    //     if (checkThamSo() != null) {
    //       return false
    //     } else {
    //       return true
    //     }
    //   } else {
    //     return true
    //   }
    // }

    value: function clearAllCookie() {
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    }
  }, {
    key: 'handleLogOut',
    value: function handleLogOut() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      _api.User.actions.logout.request().then(function (res) {
        if ((0, _lodash.get)(userInfo, 'sso')) {
          _reactCookie2.default.remove('accessToken', { path: '/' });
          _this2.props.dispatch({
            type: 'RESET_DLHT'
          });
          _this2.clearAllCookie();
          localStorage.removeItem('userInfo');
          localStorage.removeItem('thamSo');
          window.location.href = 'https://login.quangngai.gov.vn/oidc/logout?post_logout_redirect_uri=https://quanlythanhtra.quangngai.gov.vn/api/sso/logout&id_token_hint=' + (0, _lodash.get)(userInfo, 'ssoIdToken');
        } else {
          _reactCookie2.default.remove('accessToken', { path: '/' });
          _this2.props.dispatch({
            type: 'RESET_DLHT'
          });
          _this2.clearAllCookie();
          localStorage.removeItem('userInfo');
          localStorage.removeItem('thamSo');
          _reactRouter.browserHistory.push('/dang-nhap');
        }
      });
    }
  }, {
    key: 'handleSwitchRole',
    value: function handleSwitchRole(item) {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'profile-wrap' },
        _react2.default.createElement(
          'div',
          { className: 'profile-list' },
          _react2.default.createElement(
            'div',
            { className: 'profile-item item-has-children', style: { zIndex: 3 } },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'wrap-name' },
              _react2.default.createElement('img', { src: userIcon, className: 'user-ico', alt: 'user-icon' }),
              _react2.default.createElement(
                'span',
                { className: 'user-name' },
                this.props.userInfo.name,
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.userInfo.chucVu != '' && this.props.userInfo.chucVu != null },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'hide-small' },
                      ' - '
                    ),
                    _react2.default.createElement('br', null),
                    this.props.userInfo.chucVu
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'sub-profile' },
              _react2.default.createElement(
                'div',
                { className: 'item' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thay-doi-mat-khau' },
                  '\u0110\u1ED5i m\u1EADt kh\u1EA9u'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'item', onClick: this.handleLogOut.bind(this) },
                _react2.default.createElement(
                  _reactRouter.Link,
                  null,
                  '\u0110\u0103ng xu\u1EA5t'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Profile;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLogin: typeof _reactCookie2.default.load('accessToken') != 'undefined' ? true : false,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Profile);

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = function (_React$Component) {
	_inherits(Menu, _React$Component);

	function Menu() {
		_classCallCheck(this, Menu);

		return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	}

	_createClass(Menu, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"ul",
				{ className: "menu-list" },
				this.props.children
			);
		}
	}]);

	return Menu;
}(_react2.default.Component);

exports.default = Menu;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var MenuItem = function (_React$Component) {
	_inherits(MenuItem, _React$Component);

	function MenuItem() {
		_classCallCheck(this, MenuItem);

		return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
	}

	_createClass(MenuItem, [{
		key: 'getChildRoutes',
		value: function getChildRoutes(children) {
			var _this2 = this;

			var routes = [];
			if (children && children.length) {
				children.forEach(function (item) {
					if (item.props.path) routes.push(item.props.path);

					if (item.props.children) {
						routes = routes.concat(_this2.getChildRoutes(item.props.children));
					}
				});
			} else {
				if (children.props.path) routes.push(children.props.path);

				if (children.props.children) {
					routes = routes.concat(this.getChildRoutes(children.props.children));
				}
			}

			return routes;
		}
	}, {
		key: 'render',
		value: function render() {
			//  className={`menu-items menu-haschildren ${this.props.routerName=='tiepcongdan' ? 'is-active' : ''}`}
			var menuClass = ['menu-items'];
			if (this.props.children) {
				menuClass.push('menu-haschildren');
			}

			// if current route is same with this.props.path
			if (this.props.path == this.props.routePath) {
				menuClass.push('is-active');
			}

			return _react2.default.createElement(
				'li',
				{ className: classNames(menuClass) },
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: this.props.path, id: this.props.id, className: 'item-link' },
					this.props.icon ? _react2.default.createElement(
						'div',
						{ className: 'wrap-img-mn' },
						_react2.default.createElement('img', { src: this.props.icon, alt: 'menuIcon' })
					) : '',
					this.props.name
				),
				this.props.children
			);
		}
	}]);

	return MenuItem;
}(_react2.default.Component);

MenuItem.defaultProps = {
	id: ''
};

var mapStateToProps = function mapStateToProps(state) {
	return {
		routePath: state.routing.locationBeforeTransitions.pathName
	};
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(MenuItem);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubMenu = function (_React$Component) {
	_inherits(SubMenu, _React$Component);

	function SubMenu() {
		_classCallCheck(this, SubMenu);

		return _possibleConstructorReturn(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).apply(this, arguments));
	}

	_createClass(SubMenu, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"ul",
				{ className: "sub-menu" },
				this.props.children
			);
		}
	}], [{
		key: "getRoutes",
		value: function getRoutes() {}
	}]);

	return SubMenu;
}(_react2.default.Component);

exports.default = SubMenu;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenu = exports.MenuItem = exports.Menu = undefined;

var _Menu = __webpack_require__(965);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(966);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SubMenu = __webpack_require__(967);

var _SubMenu2 = _interopRequireDefault(_SubMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu2.default;
exports.MenuItem = _MenuItem2.default;
exports.SubMenu = _SubMenu2.default;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoCompleteKeHoachTT = function (_React$Component) {
  _inherits(AutoCompleteKeHoachTT, _React$Component);

  function AutoCompleteKeHoachTT(props, context) {
    _classCallCheck(this, AutoCompleteKeHoachTT);

    var _this = _possibleConstructorReturn(this, (AutoCompleteKeHoachTT.__proto__ || Object.getPrototypeOf(AutoCompleteKeHoachTT)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    };
    return _this;
  }

  _createClass(AutoCompleteKeHoachTT, [{
    key: 'validate',
    value: function validate() {
      if (!this.state.value.trim()) {
        this.setState({
          isValid: false
        });
        this.textInput.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.value != nextProps.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.refs.autoCompleteKHTT) {
          return;
        }
        _this2.setState({
          openSuggest: false
        });
      }, 500);
    }
  }, {
    key: 'handleTyping',
    value: function handleTyping(e) {
      var _this3 = this;

      var value = e.target.value;

      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }
      this.setState({
        value: value
      });
      if (!value) {
        this.state.openSuggest = false;
      } else {
        this.typingTimeout = setTimeout(function () {
          _this3.setState({ searching: true });
          var params = {
            size: 3,
            page: 0,
            soQuyetDinh: value,
            keHoachCurrentId: _this3.props.keHoachCurrentId
          };
          _api.ThanhTra.actions.getKeHoachThanhTraOld.request('', params).then(function (res) {
            if (!_this3.refs.autoCompleteKHTT) {
              return;
            }
            if (res.data && res.data._embedded) {
              _this3.setState({
                result: res.data._embedded.keHoachThanhTras,
                page: res.data.page,
                openSuggest: true,
                searching: false
              });
            } else {
              _this3.setState({
                result: [],
                searching: false,
                page: { totalElements: 0 }
              });
            }
          }).catch(function (err) {
            _this3.setState({
              result: [],
              searching: false,
              page: { totalElements: 0 }
            });
          });
        }, 1000);
      }
    }
  }, {
    key: 'selectItemAction',
    value: function selectItemAction(item) {
      this.props.onSelect(item);
      this.setState({ openSuggest: false });
    }
  }, {
    key: 'viewAllResult',
    value: function viewAllResult(keyword) {
      this.props.onViewAll(keyword);
      this.setState({ openSuggest: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-input autocomplete-box', ref: 'autoCompleteKHTT' },
        _react2.default.createElement(
          'label',
          { className: 'pt-label wrap-autocomplete' },
          _react2.default.createElement(
            'span',
            { className: 'val-title' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.isRequired },
              _react2.default.createElement(
                'span',
                { className: 'text-required pt-text-muted' },
                ' *'
              )
            )
          ),
          _react2.default.createElement('input', { ref: function ref(input) {
              _this4.textInput = input;
            },
            className: 'pt-input ' + (this.state.searching ? 'tt-loading' : '') + ' ' + (!this.state.isValid && !this.state.value.trim() ? 'pt-intent-danger' : ''), maxLength: this.props.maxLength,
            value: this.state.value, onBlur: this.handleBlur.bind(this),
            onChange: this.handleTyping.bind(this), type: 'text', autoComplete: 'off',
            name: this.props.name
          }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.searching },
            _react2.default.createElement(_reactRouter.Link, { onClick: this.viewAllResult.bind(this, this.state.value), className: 'search-autocomplete' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.isValid && !this.state.value.trim() },
            _react2.default.createElement(
              'div',
              { className: 'pt-form-helper-text' },
              _message.msg.messageDefault
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'autocomplete-container' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.openSuggest },
            _react2.default.createElement(
              'ul',
              null,
              this.state.result.map(function (item, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i, className: 'item-person', onClick: _this4.selectItemAction.bind(_this4, item) },
                  _react2.default.createElement(
                    'div',
                    { className: 'list-items' },
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-header' },
                      item.quyetDinhPheDuyetKTTT
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-content' },
                      _react2.default.createElement(
                        'span',
                        { className: 'title-content' },
                        'Ng\xE0y ph\xEA duy\u1EC7t:\xA0'
                      ),
                      (0, _moment2.default)(item.ngayRaQuyetDinh).format('DD/MM/YYYY')
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-content' },
                      _react2.default.createElement(
                        'span',
                        { className: 'title-content' },
                        'N\u0103m thanh tra:\xA0'
                      ),
                      item.namThanhTra
                    ),
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-control pt-radio pt5 pt-large checkbox-autocomplete' },
                      _react2.default.createElement('input', { type: 'radio', name: 'docs-radio-regular' }),
                      _react2.default.createElement('span', { className: 'pt-control-indicator' })
                    )
                  )
                );
              }),
              this.state.page.totalElements > 3 ? _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-view-more', onClick: this.viewAllResult.bind(this, this.state.value) },
                  'Xem th\xEAm ',
                  this.state.page.totalElements - 3,
                  ' k\u1EBFt qu\u1EA3'
                )
              ) : null
            )
          )
        )
      );
    }
  }]);

  return AutoCompleteKeHoachTT;
}(_react2.default.Component);

AutoCompleteKeHoachTT.defaultProps = {
  isRequired: false,
  name: '',
  label: 'Quyết định phê duyệt KHTT'
};

exports.default = (0, _utils.validatable)(AutoCompleteKeHoachTT);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoCompleteSearch = function (_React$Component) {
  _inherits(AutoCompleteSearch, _React$Component);

  function AutoCompleteSearch(props, context) {
    _classCallCheck(this, AutoCompleteSearch);

    var _this = _possibleConstructorReturn(this, (AutoCompleteSearch.__proto__ || Object.getPrototypeOf(AutoCompleteSearch)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    };
    return _this;
  }

  _createClass(AutoCompleteSearch, [{
    key: 'validate',
    value: function validate() {
      if (!this.state.value.trim()) {
        this.setState({
          isValid: false
        });
        this.textInput.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          openSuggest: false
        });
      }, 500);
    }
  }, {
    key: 'handleTyping',
    value: function handleTyping(e) {
      var _this3 = this;

      var value = e.target.value;

      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }

      if (!value) {
        this.state.openSuggest = false;
      } else {
        this.setState({
          value: value
        });

        this.typingTimeout = setTimeout(function () {
          _this3.setState({ searching: true });
          _this3.props.onSearch(value).then(function (response) {
            if (response != null) {
              _this3.setState({
                result: response.result,
                page: response.page,
                openSuggest: true,
                searching: false
              });
            } else {
              _this3.setState({
                result: [],
                searching: false,
                page: { totalElements: 0 }
              });
            }
          }).catch(function (err) {});
        }, 1000);
      }
      this.props.onChange(value);
    }
  }, {
    key: 'chonCongDan',
    value: function chonCongDan(item) {
      this.props.dispatch({
        type: 'CHON_CONG_DAN',
        data: item,
        index: this.props.index
      });
      this.state.openSuggest = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'viewAllResult',
    value: function viewAllResult(keyword) {
      this.props.dispatch({
        type: 'TOGGLE_DIALOG',
        data: {
          name: 'PopupViewAllResult',
          status: true
        },
        keyword: keyword,
        index: this.props.index
      });

      this.state.openSuggest = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-input autocomplete-box' },
        _react2.default.createElement(
          'label',
          { className: 'pt-label wrap-autocomplete' },
          _react2.default.createElement(
            'span',
            { className: 'val-title' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.isRequired },
              _react2.default.createElement(
                'span',
                { className: 'text-required pt-text-muted' },
                ' *'
              )
            )
          ),
          _react2.default.createElement('input', { ref: function ref(input) {
              _this4.textInput = input;
            },
            className: (0, _classnames2.default)('pt-input', {
              'bd-timkiem': !this.props.showField,
              'tt-loading': this.props.searching,
              'pt-intent-danger': !this.state.isValid && !this.state.value.trim()
            }),
            maxLength: this.props.maxLength,
            value: this.state.value, onBlur: this.handleBlur.bind(this),
            onChange: this.handleTyping.bind(this), type: 'text', autoComplete: 'off',
            name: this.props.name,
            placeholder: 'Vui lòng tìm kiếm',
            disabled: this.props.disabled
          }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.searching },
            _react2.default.createElement(_reactRouter.Link, { onClick: !this.props.idDonCD && !this.props.showField ? this.viewAllResult.bind(this, this.state.value) : null, className: 'search-autocomplete' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.isValid && !this.state.value.trim() },
            _react2.default.createElement(
              'div',
              { className: 'pt-form-helper-text' },
              _message.msg.messageDefault
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'autocomplete-container' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.openSuggest },
            _react2.default.createElement(
              'ul',
              null,
              this.state.result.map(function (item, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i, className: 'item-person', onClick: _this4.chonCongDan.bind(_this4, item) },
                  _react2.default.createElement(
                    'div',
                    { className: 'list-items' },
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-header' },
                      item.hoVaTen
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-content' },
                      _react2.default.createElement(
                        'span',
                        { className: 'title-content' },
                        'CMND:\xA0'
                      ),
                      item.soCMNDHoChieu
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-content' },
                      _react2.default.createElement(
                        'span',
                        { className: 'title-content' },
                        '\u0110\u1ECBa ch\u1EC9:\xA0'
                      ),
                      item.diaChi
                    ),
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-control pt-radio pt5 pt-large checkbox-autocomplete' },
                      _react2.default.createElement('input', { type: 'radio', name: 'docs-radio-regular' }),
                      _react2.default.createElement('span', { className: 'pt-control-indicator' })
                    )
                  )
                );
              }),
              this.state.page.totalElements > 3 ? _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-view-more', onClick: this.viewAllResult.bind(this, this.state.value) },
                  'Xem th\xEAm ',
                  this.state.page.totalElements - 3,
                  ' k\u1EBFt qu\u1EA3'
                )
              ) : null
            )
          )
        )
      );
    }
  }]);

  return AutoCompleteSearch;
}(_react2.default.Component);

AutoCompleteSearch.defaultProps = {
  isRequired: false,
  name: '',
  disabled: false
};

exports.default = (0, _reactRedux.connect)()((0, _utils.validatable)(AutoCompleteSearch));

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoSuggest = function (_React$Component) {
  _inherits(AutoSuggest, _React$Component);

  function AutoSuggest(props, context) {
    _classCallCheck(this, AutoSuggest);

    var _this = _possibleConstructorReturn(this, (AutoSuggest.__proto__ || Object.getPrototypeOf(AutoSuggest)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    };
    return _this;
  }

  _createClass(AutoSuggest, [{
    key: 'validate',
    value: function validate() {
      if (!this.state.value.trim()) {
        this.setState({
          isValid: false
        });
        this.textInput.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          openSuggest: false
        });
      }, 500);
    }
  }, {
    key: 'handleTyping',
    value: function handleTyping(e) {
      var _this3 = this;

      var value = e.target.value;

      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }

      if (!value) {
        this.state.openSuggest = false;
      } else {
        this.setState({
          value: value
        });

        this.typingTimeout = setTimeout(function () {
          _this3.setState({ searching: true });
          _this3.props.onSearch(value).then(function (response) {
            if (response != null) {
              _this3.setState({
                result: response.result,
                page: response.page,
                openSuggest: true,
                searching: false
              });
            } else {
              _this3.setState({
                result: [],
                searching: false,
                page: { totalElements: 0 }
              });
            }
          }).catch(function (err) {});
        }, 1000);
      }
      this.props.onChange(value);
    }
  }, {
    key: 'itemSelected',
    value: function itemSelected(item) {
      this.props.onSelected(item);
      this.state.openSuggest = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'autocomplete-box ' + this.props.className },
        _react2.default.createElement(
          'label',
          { className: 'pt-label wrap-autocomplete' },
          _react2.default.createElement(
            'span',
            { className: 'val-title' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.isRequired },
              _react2.default.createElement(
                'span',
                { className: 'text-required pt-text-muted' },
                ' *'
              )
            )
          ),
          _react2.default.createElement('input', { ref: function ref(input) {
              _this4.textInput = input;
            },
            className: 'pt-input ' + (this.state.searching ? 'tt-loading' : '') + ' ' + (!this.state.isValid && !this.state.value.trim() ? 'pt-intent-danger' : ''),
            maxLength: this.props.maxLength,
            name: this.props.name,
            placeholder: this.props.placeholder,
            value: this.state.value, onBlur: this.handleBlur.bind(this),
            onChange: this.handleTyping.bind(this), type: 'text', autoComplete: 'off'
          }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.isValid && !this.state.value.trim() },
            _react2.default.createElement(
              'div',
              { className: 'pt-form-helper-text' },
              _message.msg.messageDefault
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'autocomplete-container', style: { top: '0px' } },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.openSuggest },
            _react2.default.createElement(
              'ul',
              null,
              this.state.result.map(function (item, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i, className: 'item-person', onClick: _this4.itemSelected.bind(_this4, item) },
                  _react2.default.createElement(
                    'div',
                    { className: 'list-items' },
                    _react2.default.createElement(
                      'p',
                      { className: 'mb10 item-text' },
                      item.ten
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AutoSuggest;
}(_react2.default.Component);

AutoSuggest.defaultProps = {
  name: 'coQuanKhac',
  className: '',
  label: '',
  isRequired: false,
  placeholder: ''
};

exports.default = (0, _reactRedux.connect)()((0, _utils.validatable)(AutoSuggest));

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _ttForms = __webpack_require__(19);

var _utils = __webpack_require__(4);

var _datatable = __webpack_require__(233);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaoCaoDinhKy = function (_React$Component) {
  _inherits(BaoCaoDinhKy, _React$Component);

  function BaoCaoDinhKy(props, context) {
    _classCallCheck(this, BaoCaoDinhKy);

    var _this = _possibleConstructorReturn(this, (BaoCaoDinhKy.__proto__ || Object.getPrototypeOf(BaoCaoDinhKy)).call(this, props, context));

    _this.state = {
      data: [],
      searchLoading: false,
      loaiKy: 'THEO_QUY',
      tuNgay: '',
      denNgay: '',
      quy: _this.getQuy(new Date().getMonth() + 1),
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      tableLoading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      kyBaoCaoList: []
    };
    return _this;
  }

  _createClass(BaoCaoDinhKy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.goBack) {
        var dataSearch = this.props.dataSearch;
        this.state.pageData.number = dataSearch.page || 0;
        this.state.pageData.size = dataSearch.size || 10;
        this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY';
        this.state.quy = dataSearch.quy || this.getQuy(new Date().getMonth() + 1);
        this.state.year = dataSearch.year || new Date().getFullYear();
        this.state.month = dataSearch.month || new Date().getMonth() + 1;
        this.setState(_extends({}, this.state));
        this.getListData(false, true);
      } else {
        this.getListData();
      }
      this.getKyBaoCaoData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.goBack) {
        var dataSearch = nextProps.dataSearch;
        this.state.pageData.number = dataSearch.page || 0;
        this.state.pageData.size = dataSearch.size || 0;
        this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY';
        this.state.quy = dataSearch.quy || this.getQuy(new Date().getMonth() + 1);
        this.state.year = dataSearch.year || new Date().getFullYear();
        this.state.month = dataSearch.month || new Date().getMonth() + 1;
        this.setState(_extends({}, this.state));
        this.getListData(false, true);
      }
    }
  }, {
    key: 'getQuy',
    value: function getQuy(month) {
      if (month > 0 && month < 4) {
        return 1;
      } else if (month > 3 && month < 7) {
        return 2;
      } else if (month > 6 && month < 10) {
        return 3;
      } else if (month > 9 && month < 13) {
        return 4;
      }
    }
  }, {
    key: 'getKyBaoCaoData',
    value: function getKyBaoCaoData() {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getKyBaoCao.request().then(function (res) {
        if (res.data) {
          _this2.setState({ kyBaoCaoList: res.data });
        } else {
          _this2.setState({ kyBaoCaoList: [] });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData(false, true);
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData(false, true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch, pageClick) {
      var _this3 = this;

      this.props.dispatch({ type: 'BCDK_RESET_GO_BACK' });
      if (isSearch) {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }

      var params = {
        loaiKy: this.state.loaiKy,
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (this.state.loaiKy != 'TUY_CHON' && this.state.year) {
        params.year = this.state.year;
      }
      if (this.state.loaiKy == 'THEO_QUY' && this.state.quy) {
        params.quy = this.state.quy;
      }
      if (this.state.loaiKy == 'THEO_THANG' && this.state.month) {
        params.month = this.state.month;
      }
      if (this.state.loaiKy === 'TUY_CHON' && this.state.tuNgay) {
        params.tuNgay = this.state.tuNgay;
      }
      if (this.state.loaiKy === 'TUY_CHON' && this.state.denNgay) {
        params.denNgay = this.state.denNgay;
      }
      if (isSearch || pageClick) {
        this.props.dispatch({ type: 'BCDK_UPDATE_DATA_SEARCH', dataSearch: params });
      }
      _api.ThongKeBaoCao.actions.getBaoCaoDinhKy.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            data: res.data._embedded.baoCaoDonVis,
            pageData: res.data.page
          });
        } else {
          _this3.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'loaiKy') {
        var _setState3;

        this.setState((_setState3 = {}, _defineProperty(_setState3, name, e.target.value), _defineProperty(_setState3, 'tuNgay', ''), _defineProperty(_setState3, 'denNgay', ''), _defineProperty(_setState3, 'year', new Date().getFullYear()), _defineProperty(_setState3, 'month', 1), _defineProperty(_setState3, 'quy', 1), _setState3));
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'B\xE1o c\xE1o \u0111\u1ECBnh k\u1EF3'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl25 pr25 pt15 super-search' },
              _react2.default.createElement(
                'div',
                { className: 'col-83 no-gutter' },
                _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'K\u1EF3 b\xE1o c\xE1o', options: this.state.kyBaoCaoList, keyName: 'giaTri', valueName: 'ten', placeholder: null, selectedValue: this.state.loaiKy, onChange: this.onChange.bind(this, 'loaiKy') }),
                this.state.loaiKy != 'TUY_CHON' && _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'year'), selectedValue: this.state.year }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy == 'THEO_QUY' },
                  _react2.default.createElement(_ttForms.DropDownChonLoaiQuyThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'quy'), selectedValue: this.state.quy })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy == 'THEO_THANG' },
                  _react2.default.createElement(_ttForms.DropDownChonLoaiThangThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'month'), selectedValue: this.state.month })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy === 'TUY_CHON' },
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'T\u1EEB ng\xE0y', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, require: true, bindValidator: this, channel: 'formTaoDon' }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: '\u0110\u1EBFn ng\xE0y', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, require: true, bindValidator: this, channel: 'formTaoDon' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-16 btn-thongke clear-right' },
                _react2.default.createElement(_core.Button, { className: this.state.tableLoading ? this.state.searchLoading ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable' : 'btn-green tt-search', text: 'Xem k\u1EBFt qu\u1EA3', onClick: this.getListData.bind(this, true) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.baoCaoDinhKy,
                  dataList: this.state.data,
                  pageData: this.state.pageData,
                  parent: this,
                  hideExport: true,
                  search: this.state.searchLoading,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemBaoCaoDinhKy, null)
              )
            )
          )
        )
      );
    }
  }]);

  return BaoCaoDinhKy;
}(_react2.default.Component);

BaoCaoDinhKy.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'TIEP_CONG_DAN',
  dataSearch: {},
  goBack: false
};

function BindStateToProps(state) {
  return {
    dataSearch: state.baoCaoDinhKy.dataSearch,
    goBack: state.baoCaoDinhKy.goBack
  };
}

exports.default = (0, _reactRedux.connect)(BindStateToProps)(BaoCaoDinhKy);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(233);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dialog = __webpack_require__(18);

var _message = __webpack_require__(10);

var _toastr = __webpack_require__(11);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaoCaoDinhKyChiTiet = function (_React$Component) {
  _inherits(BaoCaoDinhKyChiTiet, _React$Component);

  function BaoCaoDinhKyChiTiet(props, context) {
    _classCallCheck(this, BaoCaoDinhKyChiTiet);

    var _this = _possibleConstructorReturn(this, (BaoCaoDinhKyChiTiet.__proto__ || Object.getPrototypeOf(BaoCaoDinhKyChiTiet)).call(this, props, context));

    _this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {},
        trangThaiBaoCao: false
      },
      loaiBaoCao: [],
      taiLieuBaoCao: [],
      taiLieuBaoCaoUpdate: [],
      taiLieuBaoCaoDelete: [],
      dataFileDinhKemDelete: [],
      tableLoading: false,
      dataFileDinhKem: [],
      hasChange: false,
      backConfirm: false
    };
    return _this;
  }

  _createClass(BaoCaoDinhKyChiTiet, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.id != this.props.params.id) {
        this.getInfo(nextProps.params.id);
        this.getLoaiBaoCaoList(nextProps.params.id);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.id) {
        this.getInfo(this.props.params.id);
        this.getLoaiBaoCaoList(this.props.params.id);
      }
    }
  }, {
    key: 'getInfo',
    value: function getInfo(idBC) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getBaoCaoDinhKyChiTiet.request({ id: idBC }).then(function (res) {
        if (res.data) {
          res.data.listTaiLieuBaoCao.map(function (item) {
            item.soQuyetDinh = item.soVanBan;
            item.ngayQuyetDinh = item.ngayRaVanBan;
            return item;
          });
          _this2.setState({
            data: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiBaoCaoList',
    value: function getLoaiBaoCaoList(idBC) {
      var _this3 = this;

      this.setState({ tableLoading: true });
      _api.ThongKeBaoCao.actions.getBaoCaoDinhKyLoaiDon.request({ id: idBC }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            loaiBaoCao: res.data._embedded.baoCaoDonViChiTiets,
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data,
        hasChange: true
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dataFileDinhKemDelete = [].concat(_toConsumableArray(this.state.dataFileDinhKemDelete), [id]);
      this.state.dataFileDinhKem = data;
      this.state.hasChange = true;
      this.forceUpdate();
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        this.props.dispatch({ type: 'BCDK_GO_BACK' });
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.props.dispatch({ type: 'BCDK_GO_BACK' });
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'guiBaoCao',
    value: function guiBaoCao() {
      var _this4 = this;

      this.setState({ posting: true });
      this.pushTaiLieuDinhKem();
      _api.ThongKeBaoCao.actions.guiBaoCaoDinhKy.request({ id: this.state.data.baoCaoDonViId }).then(function (res) {
        if (res.data) {
          (0, _toastr.Toastr)(_message.msg.guiBCSuccess, 'success');
          setTimeout(function () {
            _reactRouter.browserHistory.goBack();
          }, 1000);
        }
        _this4.setState({ posting: false });
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this4.setState({
          posting: false
        });
      });
    }
  }, {
    key: 'postTaiLieuBC',
    value: function postTaiLieuBC(params) {
      _api.ThongKeBaoCao.actions.postTaiLieuBaoCao.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'updateTaiLieuBC',
    value: function updateTaiLieuBC(params) {
      _api.ThongKeBaoCao.actions.updateTaiLieuBaoCao.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deletetaiLieuBC',
    value: function deletetaiLieuBC(params) {
      _api.ThongKeBaoCao.actions.deleteTaiLieuBaoCao.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'LuuBaoCao',
    value: function LuuBaoCao(type) {
      this.pushTaiLieuDinhKem();
      this.handleBack(true);
      (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
    }
  }, {
    key: 'pushTaiLieuDinhKem',
    value: function pushTaiLieuDinhKem() {
      var _this5 = this;

      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuBaoCaoId) {
            _this5.state.taiLieuBaoCaoUpdate[_this5.state.taiLieuBaoCaoUpdate.length] = {
              baoCaoDonVi: {
                id: Number(_this5.props.params.id)
              },
              id: item.taiLieuBaoCaoId,
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : '',
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this5.state.taiLieuBaoCao[_this5.state.taiLieuBaoCao.length] = {
              baoCaoDonVi: {
                id: Number(_this5.props.params.id)
              },
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : '',
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }
      if (this.state.dataFileDinhKemDelete.length > 0) {
        this.state.dataFileDinhKemDelete.map(function (item, index) {
          _this5.state.taiLieuBaoCaoDelete[index] = {
            id: item
          };
        });
      }
      if (this.state.taiLieuBaoCao.length > 0) {
        var params = {
          taiLieuBaoCaos: this.state.taiLieuBaoCao
        };
        this.postTaiLieuBC(params);
      }
      if (this.state.taiLieuBaoCaoUpdate.length > 0) {
        var _params = {
          taiLieuBaoCaos: this.state.taiLieuBaoCaoUpdate
        };
        this.updateTaiLieuBC(_params);
      }

      if (this.state.taiLieuBaoCaoDelete.length > 0) {
        var _params2 = {
          taiLieuBaoCaos: this.state.taiLieuBaoCaoDelete
        };
        this.deletetaiLieuBC(_params2);
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.props.dispatch({ type: 'BCDK_GO_BACK' });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              'span',
              { className: 'arrow-left txt-blue txt-underline', onClick: this.goBack.bind(this) },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'B\xE1o c\xE1o \u0111\u1ECBnh k\u1EF3 ',
                this.state.data.baoCaoTongHopInfo.kyBaoCaoInfo || '',
                ' n\u0103m ',
                this.state.data.baoCaoTongHopInfo.namBaoCao || ''
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pt20 pl20 pr20' },
                '1. Danh s\xE1ch bi\u1EC3u m\u1EABu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.baoCaoDinhKyChiTiet,
                  dataList: this.state.loaiBaoCao,
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemBaoCaoDinhKyChiTiet, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '2. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, bindValidator: this, data: this.state.data.listTaiLieuBaoCao, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), disableAttachFile: this.state.data.trangThaiBaoCao == 'DA_GUI' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              !this.state.readOnly && this.state.data.trangThaiBaoCao != 'DA_GUI' && _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-save btn-green ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.LuuBaoCao.bind(this, 'save') },
                'L\u01B0u'
              ),
              this.state.data.daTongHopDu && this.state.data.trangThaiBaoCao != 'DA_GUI' && _react2.default.createElement(
                _core.Button,
                { type: 'button', style: { right: 0 }, className: 'btn-action btn-move btn-green right ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.guiBaoCao.bind(this) },
                'G\u1EEDi b\xE1o c\xE1o'
              )
            )
          )
        )
      );
    }
  }]);

  return BaoCaoDinhKyChiTiet;
}(_react2.default.Component);

BaoCaoDinhKyChiTiet.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = (0, _reactRedux.connect)()(BaoCaoDinhKyChiTiet);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _LapBaoCaoDinhKyPage = __webpack_require__(975);

var _LapBaoCaoDinhKyPage2 = _interopRequireDefault(_LapBaoCaoDinhKyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LapBaoCaoDinhKy = function (_React$Component) {
  _inherits(LapBaoCaoDinhKy, _React$Component);

  function LapBaoCaoDinhKy() {
    _classCallCheck(this, LapBaoCaoDinhKy);

    return _possibleConstructorReturn(this, (LapBaoCaoDinhKy.__proto__ || Object.getPrototypeOf(LapBaoCaoDinhKy)).apply(this, arguments));
  }

  _createClass(LapBaoCaoDinhKy, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_LapBaoCaoDinhKyPage2.default, { params: this.props.params })
      );
    }
  }]);

  return LapBaoCaoDinhKy;
}(_react2.default.Component);

exports.default = LapBaoCaoDinhKy;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dialog = __webpack_require__(18);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _TableKetQuaPhongChongThamNhung = __webpack_require__(307);

var _TableKetQuaPhongChongThamNhung2 = _interopRequireDefault(_TableKetQuaPhongChongThamNhung);

var _datatable = __webpack_require__(233);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LapBaoCaoDinhKyPage = function (_React$Component) {
  _inherits(LapBaoCaoDinhKyPage, _React$Component);

  function LapBaoCaoDinhKyPage(props, context) {
    _classCallCheck(this, LapBaoCaoDinhKyPage);

    var _this = _possibleConstructorReturn(this, (LapBaoCaoDinhKyPage.__proto__ || Object.getPrototypeOf(LapBaoCaoDinhKyPage)).call(this, props, context));

    _this.state = {
      data: [],
      dataDelete: [],
      loaiBaoCao: [],
      tableLoading: false,
      update: false,
      showFile: false,
      listTaiLieuBaoCao: [],
      listTaiLieuVanThu: [],
      listTaiLieuVanThuShow: [],
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      thongTinBaoCao: {},
      headerTable: [],
      donViConsInfo: [],
      trangThaiBaoCao: '',
      baoCaoDonViChiTietId: '',
      hasChange: false,
      backConfirm: false,
      checkComponent: false,
      numberColumnHeader: 40,
      convertData: false,
      openDialog: false,
      dataSum: { donVi: { id: 'DATA_SUM' } },
      dataDonTrung: {},
      dataOption: [],
      popupChotBaoCao: false,
      ngayKetThucBC: '',
      readOnly: false
    };
    return _this;
  }

  _createClass(LapBaoCaoDinhKyPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDataLapBaoCaoDinhKyChiTiet(this.props.params.id);
      this.getLapBaoCaoDinhKyChiTiet(this.props.params.id);
      this.getDonViLapBaoCaoDinhKy();
    }
  }, {
    key: 'getDonViLapBaoCaoDinhKy',
    value: function getDonViLapBaoCaoDinhKy() {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getDonViLapBaoCaoDinhKy.request().then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataOption: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDataLapBaoCaoDinhKyChiTiet',
    value: function getDataLapBaoCaoDinhKyChiTiet(id) {
      var _this3 = this;

      _api.ThongKeBaoCao.actions.getDataLapBaoCaoDinhKyChiTiet.request({ idBaoCaoDonViChiTiet: id }).then(function (res) {
        if (res.data && res.data._embedded) {
          var data = [].concat(_toConsumableArray(res.data._embedded.baoCaoDonViChiTietTams));
          var newData = [];
          var dataDonTrung = {};
          data.map(function (item) {
            var itemDetail = item.soLieuBaoCaoInfo || {};
            itemDetail.donVi = {
              id: item.baoCaoDonViChiTietInfo ? item.baoCaoDonViChiTietInfo.donViId : null,
              ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
            };
            itemDetail.id = item.baoCaoDonViChiTietTamId;
            dataDonTrung = itemDetail.soLieuTrung;
            newData.push(itemDetail);
          });
          if (data.length > 0) {
            _this3.state.chaID = data[0].baoCaoDonViChiTietInfo ? data[0].baoCaoDonViChiTietInfo.chaId : '';
          }
          _this3.setState({
            data: newData,
            dataDonTrung: dataDonTrung
          });
          _this3.checkSum(newData);
        }
      });
    }
  }, {
    key: 'CheckNullObj',
    value: function CheckNullObj(obj) {
      var newObj = _extends({}, obj);
      delete newObj['donVi'];
      delete newObj['addNew'];
      delete newObj['id'];
      for (var member in newObj) {
        if (newObj[member] != null && newObj[member] != 0 && newObj[member] != '') {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'checkSum',
    value: function checkSum(arr) {
      if (arr.length > 0) {
        var newObj = arr[0];
        var dataSum = {
          donVi: {
            id: 'DATA_SUM',
            ten: 'dataSum'
          }
        };
        for (var member in newObj) {
          if (member != 'id' && member != 'donVi' && member != 'tenDonVi' && member != 'ghiChu') {
            var sum = this.checkSumElement(arr, member);
            dataSum[member] = sum;
          }
        }
        this.setState({
          dataSum: dataSum
        });
      }
    }
  }, {
    key: 'checkSumElement',
    value: function checkSumElement(arr, field) {
      var sum = 0;
      if (arr.length > 0) {
        arr.map(function (item) {
          if (!(0, _lodash.isEmpty)(item.soLieuTrung)) {
            sum = sum + Number(item[field]) - Number(item.soLieuTrung[field]);
          } else {
            sum = sum + Number(item[field]);
          }
        });
      }
      return sum;
    }
  }, {
    key: 'getLapBaoCaoDinhKyChiTiet',
    value: function getLapBaoCaoDinhKyChiTiet(id) {
      var _this4 = this;

      _api.ThongKeBaoCao.actions.getLapBaoCaoDinhKyChiTiet.request({ id: id }).then(function (res) {
        if (res.data) {
          var data = res.data;
          data.listTaiLieuBaoCao = data.listTaiLieuBaoCao.map(function (item) {
            return item = _extends({}, item, {
              soQuyetDinh: item.soVanBan,
              ngayQuyetDinh: item.ngayRaVanBan
            });
          });
          var donViConsInfo = [];
          _this4.state.baoCaoDonViChiTietId = data.baoCaoDonViChiTietId ? data.baoCaoDonViChiTietId : '';
          _this4.state.trangThaiBaoCao = data.trangThaiBaoCao ? data.trangThaiBaoCao : '';
          _this4.state.listTaiLieuBaoCao = data.listTaiLieuBaoCao ? data.listTaiLieuBaoCao : [];
          data.donViConsInfo.map(function (item) {
            var newItem = {
              ten: item.ten,
              coQuanQuanLyId: item.donViId
            };
            donViConsInfo.push(newItem);
          });
          _this4.state.ngayKetThucBC = data.baoCaoDonViInfo && data.baoCaoDonViInfo.ngayKetThucBC ? data.baoCaoDonViInfo.ngayKetThucBC : '';
          _this4.state.donViConsInfo = donViConsInfo;
          _this4.state.thongTinBaoCao = data.thongTinBaoCaoInfo ? data.thongTinBaoCaoInfo : {};
          _this4.state.tenBaoCao = data.loaiBaoCaoInfo ? data.loaiBaoCaoInfo.ten : '';
          _this4.state.nameRowItem = data.loaiBaoCao ? data.loaiBaoCao : '';
          _this4.state.readOnly = data.baoCaoDonViInfo && data.baoCaoDonViInfo.trangThaiBaoCaoInfo && data.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri == 'DA_GUI' || data.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri == 'KHOA_BAO_CAO';
        }
        _this4.setState(_extends({}, _this4.state), function () {
          if (!_this4.state.readOnly) {
            _this4.checkFileRequire();
          } else {
            _this4.setState({ listTaiLieuVanThuShow: _this4.state.listTaiLieuBaoCao, showFile: true });
          }
        });
      });
    }
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      var data = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));

      var dataFilter = data.filter(function (state) {
        return state.typeRequired == 'BCDK_TLVT';
      });

      if (dataFilter.length > 0) {
        var dataOld = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));
        var newData = [];
        dataOld.map(function (item) {
          var newItem = {
            ten: item.ten,
            soQuyetDinh: item.soVanBan,
            required: item.required,
            typeRequired: item.typeRequired,
            tenFile: item.tenFile,
            taiLieuVanThuId: item.taiLieuBaoCaoId,
            ngayQuyetDinh: item.ngayRaVanBan,
            duongDan: item.urlFile
          };
          newData.push(newItem);
        });
        this.state.listTaiLieuVanThu = newData;
        this.state.showFile = true;
      } else {
        var _dataOld = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));
        var _newData = [];
        _dataOld.map(function (item) {
          var newItem = {
            ten: item.ten,
            soQuyetDinh: item.soVanBan,
            required: item.required,
            typeRequired: item.typeRequired,
            tenFile: item.tenFile,
            taiLieuVanThuId: item.taiLieuBaoCaoId,
            ngayQuyetDinh: item.ngayRaVanBan,
            duongDan: item.urlFile
          };
          _newData.push(newItem);
        });

        var itemRequired = {
          ten: 'Văn bản báo cáo',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BCDK_TLVT',
          newFile: true
        };
        this.state.listTaiLieuVanThu = [].concat(_newData, [itemRequired]);
        this.state.showFile = true;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data,
        hasChange: true
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dataFileDinhKemDelete = [].concat(_toConsumableArray(this.state.dataFileDinhKemDelete), [id]);
      this.state.dataFileDinhKem = data;
      this.state.hasChange = true;
      this.forceUpdate();
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack == true || this.state.readOnly) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.setState({ backConfirm: true });
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({ backConfirm: false });
    }
  }, {
    key: 'guiBaoCao',
    value: function guiBaoCao(type) {
      var _this5 = this;

      if (type == 'export' || this.validateSubmitForm()) {
        this.pushTaiLieuDinhKem();
        var paramsPost = this.getParams('POST');
        var paramsPatch = this.getParams('PATCH');
        this.checkDelete(paramsPost, paramsPatch, type, function () {
          _this5.checkCreate(paramsPost, paramsPatch, type, function () {
            _this5.checkEdit(paramsPatch, type, function () {
              if (type == 'export') {
                var URL = _config.API_URL + "/baoCaoDonViChiTietTams/xuatExcel?" + "idBaoCaoDonViChiTiet=" + Number(_this5.props.params.id);
                window.open(URL, "_self");
              }
            });
          });
        });

        if (paramsPost.length == 0 && paramsPatch.length == 0 && this.state.dataDelete.length == 0) {
          if (type != 'export') {
            this.handleBack(true);
          }
          (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
        }
      }
    }
  }, {
    key: 'checkDelete',
    value: function checkDelete(paramsPost, paramsPatch, type, callBack) {
      var _this6 = this;

      if (this.state.dataDelete.length > 0) {
        var params = {
          baoCaoDonViChiTietTams: [].concat(_toConsumableArray(this.state.dataDelete))
        };
        _api.ThongKeBaoCao.actions.deleteBaoCao.request('', params).then(function (res) {
          if (paramsPost.length == 0 && paramsPatch.length == 0) {
            if (type != 'export') {
              _this6.handleBack(true);
            }
            callBack();
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
          } else {
            callBack();
          }
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'checkCreate',
    value: function checkCreate(paramsPost, paramsPatch, type, callBack) {
      var _this7 = this;

      if (paramsPost.length > 0) {
        var params = {
          baoCaoDonViChiTietTams: [].concat(_toConsumableArray(paramsPost))
        };
        _api.ThongKeBaoCao.actions.postBaoCao.request('', params).then(function (res) {
          if (paramsPatch.length == 0) {
            if (type != 'export') {
              _this7.handleBack(true);
            }
            callBack();
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
          } else {
            callBack();
          }
          _this7.getDataLapBaoCaoDinhKyChiTiet(_this7.props.params.id);
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'checkEdit',
    value: function checkEdit(paramsPatch, type, callBack) {
      var _this8 = this;

      if (paramsPatch.length > 0) {
        var params = {
          baoCaoDonViChiTietTams: [].concat(_toConsumableArray(paramsPatch))
        };
        _api.ThongKeBaoCao.actions.patchBaoCao.request('', params).then(function (res) {
          if (type != 'export') {
            _this8.handleBack(true);
          }
          callBack();
          (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'pushTaiLieuDinhKem',
    value: function pushTaiLieuDinhKem() {
      var _this9 = this;

      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      var taiLieuVanThuUpdate = [];
      var taiLieuVanThu = [];
      var taiLieuVanThuDelete = [];
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            taiLieuVanThuUpdate = [].concat(_toConsumableArray(taiLieuVanThuUpdate), [{
              baoCaoDonViChiTiet: {
                id: Number(_this9.props.params.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            }]);
          } else {
            taiLieuVanThu = [].concat(_toConsumableArray(taiLieuVanThu), [{
              baoCaoDonViChiTiet: {
                id: Number(_this9.props.params.id)
              },
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            }]);
          }
        });
      }

      if (this.state.dataFileDinhKemDelete.length > 0) {
        this.state.dataFileDinhKemDelete.map(function (item) {
          taiLieuVanThuDelete = [].concat(_toConsumableArray(taiLieuVanThuDelete), [{
            id: item
          }]);
        });
      }

      if (taiLieuVanThu.length > 0) {
        var params = {
          taiLieuBaoCaos: taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }

      if (taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuBaoCaos: taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }

      if (taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuBaoCaos: taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
      this.setState({ dataFileDinhKem: [] });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      var _this10 = this;

      _api.ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
        if (res.data) {
          _this10.getLapBaoCaoDinhKyChiTiet(_this10.props.params.id);
        }
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'getParams',
    value: function getParams(type) {
      var _this11 = this;

      var data = [].concat(_toConsumableArray(this.state.data));
      if (type == 'POST') {
        var dataPost = [];
        var dataPostFilter = data.filter(function (state) {
          return state.addNew == true;
        });
        dataPostFilter.map(function (state) {
          if (_this11.CheckNullObj(state)) {
            // do nothing
          } else {
            var item = {
              baoCaoDonViChiTiet: {
                cha: {
                  id: Number(_this11.state.chaID)
                },
                trangThaiBaoCao: _this11.state.trangThaiBaoCao ? _this11.state.trangThaiBaoCao : null,
                loaiBaoCao: _this11.state.nameRowItem ? _this11.state.nameRowItem : null
              },
              soLieuBaoCao: _extends({}, state)
            };

            if (state.donVi.id) {
              item.baoCaoDonViChiTiet.donVi = {
                id: state.donVi.id
              };
            }
            delete item.soLieuBaoCao['donVi'];
            delete item.soLieuBaoCao['addNew'];
            dataPost.push(item);
          }
        });

        return dataPost;
      } else {
        var dataPatch = [];
        var dataPatchFilter = data.filter(function (state) {
          return state.addNew != true;
        });
        dataPatchFilter.map(function (state) {
          if (_this11.CheckNullObj(state)) {
            var itemDelete = {
              id: state.id
            };
            _this11.state.dataDelete.push(itemDelete);
          } else {
            var item = {
              baoCaoDonViChiTiet: {
                cha: {
                  id: Number(_this11.state.baoCaoDonViChiTietId)
                },
                trangThaiBaoCao: _this11.state.trangThaiBaoCao ? _this11.state.trangThaiBaoCao : null,
                loaiBaoCao: _this11.state.nameRowItem ? _this11.state.nameRowItem : null
              },
              soLieuBaoCao: _extends({}, state)
            };
            if (state.id) {
              item.baoCaoDonViChiTietTamId = state.id;
            }
            if (state.donVi.id) {
              item.baoCaoDonViChiTiet.donVi = {
                id: state.donVi.id
              };
            }
            delete item.soLieuBaoCao['donVi'];
            delete item.soLieuBaoCao['addNew'];
            delete item.soLieuBaoCao['id'];
            dataPatch.push(item);
          }
        });
        return dataPatch;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {}
  }, {
    key: 'onAddItem',
    value: function onAddItem(id) {
      var _this12 = this;

      var params = {
        idBaoCaoDonViChiTiet: this.props.params.id,
        idDonVi: id
      };
      _api.ThongKeBaoCao.actions.getItemHeThongLapBaoCaoDinhKyChiTiet.request(params).then(function (res) {
        if (res.data) {
          var item = res.data;
          var newItem = item.soLieuBaoCaoInfo;
          newItem.donVi = {
            id: item.baoCaoDonViChiTietInfo.donViId,
            ten: item.soLieuBaoCaoInfo.tenDonVi
          };
          newItem.addNew = true;
          _this12.setState({
            data: [].concat(_toConsumableArray(_this12.state.data), [newItem])
          }, function () {
            _this12.checkSum(_this12.state.data);
          });
        }
      });
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'addNewItem',
    value: function addNewItem() {
      var _this13 = this;

      var params = {
        idBaoCaoDonViChiTiet: this.props.params.id
      };
      _api.ThongKeBaoCao.actions.getItemHeThongLapBaoCaoDinhKyChiTiet.request(params).then(function (res) {
        if (res.data) {
          var item = res.data;
          var newItem = item.soLieuBaoCaoInfo;
          newItem.donVi = {
            id: null,
            ten: ''
          };
          newItem.addNew = true;
          _this13.setState({
            data: [].concat(_toConsumableArray(_this13.state.data), [newItem])
          });
        }
      });
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onRemoveItem',
    value: function onRemoveItem(id) {
      var _this14 = this;

      var data = [].concat(_toConsumableArray(this.state.data));
      var index = data.findIndex(function (x) {
        return x.donVi.id == id;
      });
      if (index != -1) {
        var itemDelete = {
          id: data[index].id
        };
        this.state.dataDelete.push(itemDelete);
        data.splice(index, 1);
        this.state.data = data;
        this.setState(_extends({}, this.state), function () {
          _this14.checkSum(_this14.state.data);
        });
      }
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onChangeHeader',
    value: function onChangeHeader(index, e) {
      this.state.data[index].tenDonVi = e.target.value;
      this.state.data[index].donVi = {
        id: null,
        ten: e.target.value
      };
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onItemChange',
    value: function onItemChange(index, data) {
      var _this15 = this;

      this.state.data[index] = _extends({}, this.state.data[index], data);
      this.state.hasChange = true;
      this.setState(_extends({}, this.state), function () {
        _this15.checkSum(_this15.state.data);
      });
    }
  }, {
    key: 'reciveData',
    value: function reciveData(data) {
      var _this16 = this;

      this.state.data = data;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state), function () {
        _this16.checkSum(_this16.state.data);
      });
    }
  }, {
    key: 'exportExcel',
    value: function exportExcel(type) {
      if (type == 'export') {
        this.setState({
          openDialog: false,
          hasChange: false
        });
        this.guiBaoCao('export');
        this.setState({ popupChotBaoCao: true });
      } else if (this.state.hasChange == true) {
        this.setState({
          openDialog: true
        });
      } else {
        this.guiBaoCao('export');
        this.setState({ popupChotBaoCao: true });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'chotBaoCao',
    value: function chotBaoCao(inputId) {
      var _this17 = this;

      _api.ThongKeBaoCao.actions.patchChotSoLieuDonVi.request({ id: inputId }).then(function (res) {
        _this17.closeDialog('popupChotBaoCao');
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var ngayChot = (0, _moment2.default)().format('DD/MM/YYYY');
      if (this.state.ngayKetThucBC && (0, _moment2.default)().date() > (0, _moment2.default)(this.state.ngayKetThucBC).date()) {
        ngayChot = (0, _moment2.default)(this.state.ngayKetThucBC).format('DD/MM/YYYY');
      }
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.exportExcel.bind(this, 'export'),
          title: _message.msg.confirmExportExcel }),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.popupChotBaoCao, onClose: this.closeDialog.bind(this, 'popupChotBaoCao'), onSuccess: this.chotBaoCao.bind(this, this.props.params.id),
          title: 'S\u1ED1 li\u1EC7u b\xE1o c\xE1o s\u1EBD \u0111\u01B0\u1EE3c ch\u1ED1t ng\xE0y ' + ngayChot }),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' qu\xFD ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' th\xE1ng ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao != 'THEO_THANG' && this.state.thongTinBaoCao.kyBaoCao != 'THEO_QUY' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content thongke-content' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 col-100 pt20 pl20 pr20' },
              '1. Th\xF4ng tin b\xE1o c\xE1o'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl25 pt10 pr25' },
            _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'Bi\u1EC3u m\u1EABu:', value: this.state.tenBaoCao ? this.state.tenBaoCao : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'K\u1EF3 b\xE1o c\xE1o:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'N\u0103m b\xE1o c\xE1o:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Qu\xFD:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\xE1ng:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl25 pr25' },
            _react2.default.createElement(_common.InputListDropDown, {
              label: '\u0110\u01A1n v\u1ECB',
              dataOption: this.state.dataOption,
              data: this.state.donViConsInfo,
              keyName: 'coQuanQuanLyId', valueName: 'ten',
              onChange: this.onChange.bind(this, 'donViConsInfo'),
              onAddItem: this.onAddItem.bind(this),
              onRemoveItem: this.onRemoveItem.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-table clear-left' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_HANH_CHINH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraHanhChinh,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideExport: this.state.readOnly,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 33,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraHanhChinh, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraXayDungCoBan,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 33,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayDungCoBan, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraTaiChinhNganSach,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideExport: this.state.readOnly,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 27,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayTaiChinhNganSach, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraDatDai,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideExport: this.state.readOnly,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 43,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraDatDai, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_LAI' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraLai,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 31,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraLai, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraChuyenNganh,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideExport: this.state.readOnly,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 29,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraChuyenNganh, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoThanhTraThamNhung,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  hideExport: this.state.readOnly,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 27,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraThamNhung, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.nhaNuocVeThanhTra,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 23,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.RowItemCongTacQuanLyNhaNuoc, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.xayDungLucLuongThanhTra,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideExport: this.state.readOnly,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 26,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.RowItemXayDungLucLuongThanhTra, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_TIEP_CONG_DAN' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoTiepCongDan,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 37,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeTiepCongDan, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoXuLyDon,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  dataDonTrung: this.state.dataDonTrung,
                  parent: this,
                  hideButtonExport: true,
                  hideExport: this.state.readOnly,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 33,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this),
                  showTongDonTrung: true
                },
                _react2.default.createElement(_datatable.ListItemThongKeXuLyDon, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoGiaiQuyetDonKN,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 40,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeGQDKN, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_TO_CAO' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 35,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.ListItemThongKeGQDTC, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.quanLyNhaNuocVeKhieuNaiToCao,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 19,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.RowItemCongTacQuanLyNhaNuocKNTC, { onChange: this.onItemChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG' },
              _react2.default.createElement(_TableKetQuaPhongChongThamNhung2.default, {
                touchMove: true,
                addNew: !this.state.readOnly,
                addNewItem: this.addNewItem.bind(this),
                header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                dataList: this.state.data,
                exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                handleExport: this.exportExcel.bind(this),
                hidePagination: true,
                parent: this,
                hideExport: this.state.readOnly,
                hideButtonExport: true,
                ThongKeBaoCao: true,
                LapBaoCao: true,
                numberColumnHeader: this.state.numberColumnHeader,
                dataSum: this.state.dataSum,
                tableLoading: this.state.tableLoading,
                pushData: this.reciveData.bind(this),
                onChangeHeader: this.onChangeHeader.bind(this)
              })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nameRowItem == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  touchMove: true,
                  addNew: !this.state.readOnly,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.tongHopSoLieu,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  hideExport: this.state.readOnly,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 12,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  onChangeHeader: this.onChangeHeader.bind(this)
                },
                _react2.default.createElement(_datatable.RowItemTongHopKeKhai, { onChange: this.onItemChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '3. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, bindValidator: this, dataShow: this.state.listTaiLieuVanThuShow, data: this.state.listTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), disableAttachFile: this.state.readOnly, allowExcelFile: true })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt30' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            !this.state.readOnly && _react2.default.createElement(
              _core.Button,
              { type: 'button', className: 'btn-action btn-save btn-green ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.guiBaoCao.bind(this, 'save') },
              'L\u01B0u'
            )
          )
        )
      );
    }
  }]);

  return LapBaoCaoDinhKyPage;
}(_react2.default.Component);

LapBaoCaoDinhKyPage.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = LapBaoCaoDinhKyPage;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListitemThongKeGQDKN = function (_React$Component) {
  _inherits(ListitemThongKeGQDKN, _React$Component);

  function ListitemThongKeGQDKN(props, context) {
    _classCallCheck(this, ListitemThongKeGQDKN);

    var _this = _possibleConstructorReturn(this, (ListitemThongKeGQDKN.__proto__ || Object.getPrototypeOf(ListitemThongKeGQDKN)).call(this, props, context));

    _this.state = {
      tongSoDonKhieuNai: _this.props.item && _this.props.item.tongSoDonKhieuNai ? _this.props.item.tongSoDonKhieuNai : 0,
      donNhanTrongKyBaoCao: _this.props.item && _this.props.item.donNhanTrongKyBaoCao ? _this.props.item.donNhanTrongKyBaoCao : 0,
      donTonKyTruocChuyenSang: _this.props.item && _this.props.item.donTonKyTruocChuyenSang ? _this.props.item.donTonKyTruocChuyenSang : 0,
      tongSoVuViec: _this.props.item && _this.props.item.tongSoVuViec ? _this.props.item.tongSoVuViec : 0,
      soDonThuocThamQuyen: _this.props.item && _this.props.item.soDonThuocThamQuyen ? _this.props.item.soDonThuocThamQuyen : 0,
      soVuViecThuocThamQuyen: _this.props.item && _this.props.item.soVuViecThuocThamQuyen ? _this.props.item.soVuViecThuocThamQuyen : 0,
      soVuViecGiaiQuyetBangQDHanhChinh: _this.props.item && _this.props.item.soVuViecGiaiQuyetBangQDHanhChinh ? _this.props.item.soVuViecGiaiQuyetBangQDHanhChinh : 0,
      soVuViecRutDonThongQuaGiaiThichThuyetPhuc: _this.props.item && _this.props.item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? _this.props.item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : 0,
      khieuNaiDung: _this.props.item && _this.props.item.khieuNaiDung ? _this.props.item.khieuNaiDung : 0,
      khieuNaiSai: _this.props.item && _this.props.item.khieuNaiSai ? _this.props.item.khieuNaiSai : 0,
      khieuNaiDungMotPhan: _this.props.item && _this.props.item.khieuNaiDungMotPhan ? _this.props.item.khieuNaiDungMotPhan : 0,
      giaiQuyetLan1: _this.props.item && _this.props.item.giaiQuyetLan1 ? _this.props.item.giaiQuyetLan1 : 0,
      congNhanQuyetDinhGiaiQuyetLan1: _this.props.item && _this.props.item.congNhanQuyetDinhGiaiQuyetLan1 ? _this.props.item.congNhanQuyetDinhGiaiQuyetLan1 : 0,
      huySuaQuyetDinhGiaiQuyetLan1: _this.props.item && _this.props.item.huySuaQuyetDinhGiaiQuyetLan1 ? _this.props.item.huySuaQuyetDinhGiaiQuyetLan1 : 0,
      kienNghiThuHoiChoNhaNuocTien: _this.props.item && _this.props.item.kienNghiThuHoiChoNhaNuocTien ? _this.props.item.kienNghiThuHoiChoNhaNuocTien : 0,
      kienNghiThuHoiChoNhaNuocDat: _this.props.item && _this.props.item.kienNghiThuHoiChoNhaNuocDat ? _this.props.item.kienNghiThuHoiChoNhaNuocDat : 0,
      traLaiChoCongDanTien: _this.props.item && _this.props.item.traLaiChoCongDanTien ? _this.props.item.traLaiChoCongDanTien : 0,
      traLaiChoCongDanDat: _this.props.item && _this.props.item.traLaiChoCongDanDat ? _this.props.item.traLaiChoCongDanDat : 0,
      soNguoiDuocTraLaiQuyenLoi: _this.props.item && _this.props.item.soNguoiDuocTraLaiQuyenLoi ? _this.props.item.soNguoiDuocTraLaiQuyenLoi : 0,
      kienNghiXuLyHanhChinhTongSoNguoi: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhTongSoNguoi ? _this.props.item.kienNghiXuLyHanhChinhTongSoNguoi : 0,
      kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? _this.props.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
      soVuChuyenCoQuanDieuTra: _this.props.item && _this.props.item.soVuChuyenCoQuanDieuTra ? _this.props.item.soVuChuyenCoQuanDieuTra : 0,
      soDoiTuongChuyenCoQuanDieuTra: _this.props.item && _this.props.item.soDoiTuongChuyenCoQuanDieuTra ? _this.props.item.soDoiTuongChuyenCoQuanDieuTra : 0,
      soVuDaKhoiTo: _this.props.item && _this.props.item.soVuDaKhoiTo ? _this.props.item.soVuDaKhoiTo : 0,
      soDoiTuongDaKhoiTo: _this.props.item && _this.props.item.soDoiTuongDaKhoiTo ? _this.props.item.soDoiTuongDaKhoiTo : 0,
      soVuViecGiaiQuyetDungThoiHan: _this.props.item && _this.props.item.soVuViecGiaiQuyetDungThoiHan ? _this.props.item.soVuViecGiaiQuyetDungThoiHan : 0,
      soVuViecGiaiQuyetQuaThoiHan: _this.props.item && _this.props.item.soVuViecGiaiQuyetQuaThoiHan ? _this.props.item.soVuViecGiaiQuyetQuaThoiHan : 0,
      tongSoQuyetDinhPhaiToChucThucHien: _this.props.item && _this.props.item.tongSoQuyetDinhPhaiToChucThucHien ? _this.props.item.tongSoQuyetDinhPhaiToChucThucHien : 0,
      tongSoQuyetDinhPhaiToChucThucHienDaThucHien: _this.props.item && _this.props.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? _this.props.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
      tienPhaiThuChoNhaNuoc: _this.props.item && _this.props.item.tienPhaiThuChoNhaNuoc ? _this.props.item.tienPhaiThuChoNhaNuoc : 0,
      datPhaiThuChoNhaNuoc: _this.props.item && _this.props.item.datPhaiThuChoNhaNuoc ? _this.props.item.datPhaiThuChoNhaNuoc : 0,
      tienDaThuChoNhaNuoc: _this.props.item && _this.props.item.tienDaThuChoNhaNuoc ? _this.props.item.tienDaThuChoNhaNuoc : 0,
      datDaThuChoNhaNuoc: _this.props.item && _this.props.item.datDaThuChoNhaNuoc ? _this.props.item.datDaThuChoNhaNuoc : 0,
      tienPhaiTraChoCongDan: _this.props.item && _this.props.item.tienPhaiTraChoCongDan ? _this.props.item.tienPhaiTraChoCongDan : 0,
      datPhaiTraChoCongDan: _this.props.item && _this.props.item.datPhaiTraChoCongDan ? _this.props.item.datPhaiTraChoCongDan : 0,
      tienDaTraChoCongDan: _this.props.item && _this.props.item.tienDaTraChoCongDan ? _this.props.item.tienDaTraChoCongDan : 0,
      datDaTraChoCongDan: _this.props.item && _this.props.item.datDaTraChoCongDan ? _this.props.item.datDaTraChoCongDan : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : '',
      tenDonVi: _this.props.item && _this.props.item.tenDonVi ? _this.props.item.tenDonVi : ''
    };
    return _this;
  }

  _createClass(ListitemThongKeGQDKN, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tongSoDonKhieuNai: nextProps.item && nextProps.item.tongSoDonKhieuNai ? nextProps.item.tongSoDonKhieuNai : 0,
        donNhanTrongKyBaoCao: nextProps.item && nextProps.item.donNhanTrongKyBaoCao ? nextProps.item.donNhanTrongKyBaoCao : 0,
        donTonKyTruocChuyenSang: nextProps.item && nextProps.item.donTonKyTruocChuyenSang ? nextProps.item.donTonKyTruocChuyenSang : 0,
        tongSoVuViec: nextProps.item && nextProps.item.tongSoVuViec ? nextProps.item.tongSoVuViec : 0,
        soDonThuocThamQuyen: nextProps.item && nextProps.item.soDonThuocThamQuyen ? nextProps.item.soDonThuocThamQuyen : 0,
        soVuViecThuocThamQuyen: nextProps.item && nextProps.item.soVuViecThuocThamQuyen ? nextProps.item.soVuViecThuocThamQuyen : 0,
        soVuViecGiaiQuyetBangQDHanhChinh: nextProps.item && nextProps.item.soVuViecGiaiQuyetBangQDHanhChinh ? nextProps.item.soVuViecGiaiQuyetBangQDHanhChinh : 0,
        soVuViecRutDonThongQuaGiaiThichThuyetPhuc: nextProps.item && nextProps.item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? nextProps.item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : 0,
        khieuNaiDung: nextProps.item && nextProps.item.khieuNaiDung ? nextProps.item.khieuNaiDung : 0,
        khieuNaiSai: nextProps.item && nextProps.item.khieuNaiSai ? nextProps.item.khieuNaiSai : 0,
        khieuNaiDungMotPhan: nextProps.item && nextProps.item.khieuNaiDungMotPhan ? nextProps.item.khieuNaiDungMotPhan : 0,
        giaiQuyetLan1: nextProps.item && nextProps.item.giaiQuyetLan1 ? nextProps.item.giaiQuyetLan1 : 0,
        congNhanQuyetDinhGiaiQuyetLan1: nextProps.item && nextProps.item.congNhanQuyetDinhGiaiQuyetLan1 ? nextProps.item.congNhanQuyetDinhGiaiQuyetLan1 : 0,
        huySuaQuyetDinhGiaiQuyetLan1: nextProps.item && nextProps.item.huySuaQuyetDinhGiaiQuyetLan1 ? nextProps.item.huySuaQuyetDinhGiaiQuyetLan1 : 0,
        kienNghiThuHoiChoNhaNuocTien: nextProps.item && nextProps.item.kienNghiThuHoiChoNhaNuocTien ? nextProps.item.kienNghiThuHoiChoNhaNuocTien : 0,
        kienNghiThuHoiChoNhaNuocDat: nextProps.item && nextProps.item.kienNghiThuHoiChoNhaNuocDat ? nextProps.item.kienNghiThuHoiChoNhaNuocDat : 0,
        traLaiChoCongDanTien: nextProps.item && nextProps.item.traLaiChoCongDanTien ? nextProps.item.traLaiChoCongDanTien : 0,
        traLaiChoCongDanDat: nextProps.item && nextProps.item.traLaiChoCongDanDat ? nextProps.item.traLaiChoCongDanDat : 0,
        soNguoiDuocTraLaiQuyenLoi: nextProps.item && nextProps.item.soNguoiDuocTraLaiQuyenLoi ? nextProps.item.soNguoiDuocTraLaiQuyenLoi : 0,
        kienNghiXuLyHanhChinhTongSoNguoi: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhTongSoNguoi ? nextProps.item.kienNghiXuLyHanhChinhTongSoNguoi : 0,
        kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? nextProps.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
        soVuChuyenCoQuanDieuTra: nextProps.item && nextProps.item.soVuChuyenCoQuanDieuTra ? nextProps.item.soVuChuyenCoQuanDieuTra : 0,
        soDoiTuongChuyenCoQuanDieuTra: nextProps.item && nextProps.item.soDoiTuongChuyenCoQuanDieuTra ? nextProps.item.soDoiTuongChuyenCoQuanDieuTra : 0,
        soVuDaKhoiTo: nextProps.item && nextProps.item.soVuDaKhoiTo ? nextProps.item.soVuDaKhoiTo : 0,
        soDoiTuongDaKhoiTo: nextProps.item && nextProps.item.soDoiTuongDaKhoiTo ? nextProps.item.soDoiTuongDaKhoiTo : 0,
        soVuViecGiaiQuyetDungThoiHan: nextProps.item && nextProps.item.soVuViecGiaiQuyetDungThoiHan ? nextProps.item.soVuViecGiaiQuyetDungThoiHan : 0,
        soVuViecGiaiQuyetQuaThoiHan: nextProps.item && nextProps.item.soVuViecGiaiQuyetQuaThoiHan ? nextProps.item.soVuViecGiaiQuyetQuaThoiHan : 0,
        tongSoQuyetDinhPhaiToChucThucHien: nextProps.item && nextProps.item.tongSoQuyetDinhPhaiToChucThucHien ? nextProps.item.tongSoQuyetDinhPhaiToChucThucHien : 0,
        tongSoQuyetDinhPhaiToChucThucHienDaThucHien: nextProps.item && nextProps.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? nextProps.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
        tienPhaiThuChoNhaNuoc: nextProps.item && nextProps.item.tienPhaiThuChoNhaNuoc ? nextProps.item.tienPhaiThuChoNhaNuoc : 0,
        datPhaiThuChoNhaNuoc: nextProps.item && nextProps.item.datPhaiThuChoNhaNuoc ? nextProps.item.datPhaiThuChoNhaNuoc : 0,
        tienDaThuChoNhaNuoc: nextProps.item && nextProps.item.tienDaThuChoNhaNuoc ? nextProps.item.tienDaThuChoNhaNuoc : 0,
        datDaThuChoNhaNuoc: nextProps.item && nextProps.item.datDaThuChoNhaNuoc ? nextProps.item.datDaThuChoNhaNuoc : 0,
        tienPhaiTraChoCongDan: nextProps.item && nextProps.item.tienPhaiTraChoCongDan ? nextProps.item.tienPhaiTraChoCongDan : 0,
        datPhaiTraChoCongDan: nextProps.item && nextProps.item.datPhaiTraChoCongDan ? nextProps.item.datPhaiTraChoCongDan : 0,
        tienDaTraChoCongDan: nextProps.item && nextProps.item.tienDaTraChoCongDan ? nextProps.item.tienDaTraChoCongDan : 0,
        datDaTraChoCongDan: nextProps.item && nextProps.item.datDaTraChoCongDan ? nextProps.item.datDaTraChoCongDan : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : '',
        tenDonVi: nextProps.item && nextProps.item.tenDonVi ? nextProps.item.tenDonVi : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoDonKhieuNai: this.state.tongSoDonKhieuNai ? this.state.tongSoDonKhieuNai : 0,
        donNhanTrongKyBaoCao: this.state.donNhanTrongKyBaoCao ? this.state.donNhanTrongKyBaoCao : 0,
        donTonKyTruocChuyenSang: this.state.donTonKyTruocChuyenSang ? this.state.donTonKyTruocChuyenSang : 0,
        tongSoVuViec: this.state.tongSoVuViec ? this.state.tongSoVuViec : 0,
        soDonThuocThamQuyen: this.state.soDonThuocThamQuyen ? this.state.soDonThuocThamQuyen : 0,
        soVuViecThuocThamQuyen: this.state.soVuViecThuocThamQuyen ? this.state.soVuViecThuocThamQuyen : 0,
        soVuViecGiaiQuyetBangQDHanhChinh: this.state.soVuViecGiaiQuyetBangQDHanhChinh ? this.state.soVuViecGiaiQuyetBangQDHanhChinh : 0,
        soVuViecRutDonThongQuaGiaiThichThuyetPhuc: this.state.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? this.state.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : 0,
        khieuNaiDung: this.state.khieuNaiDung ? this.state.khieuNaiDung : 0,
        khieuNaiSai: this.state.khieuNaiSai ? this.state.khieuNaiSai : 0,
        khieuNaiDungMotPhan: this.state.khieuNaiDungMotPhan ? this.state.khieuNaiDungMotPhan : 0,
        giaiQuyetLan1: this.state.giaiQuyetLan1 ? this.state.giaiQuyetLan1 : 0,
        congNhanQuyetDinhGiaiQuyetLan1: this.state.congNhanQuyetDinhGiaiQuyetLan1 ? this.state.congNhanQuyetDinhGiaiQuyetLan1 : 0,
        huySuaQuyetDinhGiaiQuyetLan1: this.state.huySuaQuyetDinhGiaiQuyetLan1 ? this.state.huySuaQuyetDinhGiaiQuyetLan1 : 0,
        kienNghiThuHoiChoNhaNuocTien: this.state.kienNghiThuHoiChoNhaNuocTien ? this.state.kienNghiThuHoiChoNhaNuocTien : 0,
        kienNghiThuHoiChoNhaNuocDat: this.state.kienNghiThuHoiChoNhaNuocDat ? this.state.kienNghiThuHoiChoNhaNuocDat : 0,
        traLaiChoCongDanTien: this.state.traLaiChoCongDanTien ? this.state.traLaiChoCongDanTien : 0,
        traLaiChoCongDanDat: this.state.traLaiChoCongDanDat ? this.state.traLaiChoCongDanDat : 0,
        soNguoiDuocTraLaiQuyenLoi: this.state.soNguoiDuocTraLaiQuyenLoi ? this.state.soNguoiDuocTraLaiQuyenLoi : 0,
        kienNghiXuLyHanhChinhTongSoNguoi: this.state.kienNghiXuLyHanhChinhTongSoNguoi ? this.state.kienNghiXuLyHanhChinhTongSoNguoi : 0,
        kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
        soVuChuyenCoQuanDieuTra: this.state.soVuChuyenCoQuanDieuTra ? this.state.soVuChuyenCoQuanDieuTra : 0,
        soDoiTuongChuyenCoQuanDieuTra: this.state.soDoiTuongChuyenCoQuanDieuTra ? this.state.soDoiTuongChuyenCoQuanDieuTra : 0,
        soVuDaKhoiTo: this.state.soVuDaKhoiTo ? this.state.soVuDaKhoiTo : 0,
        soDoiTuongDaKhoiTo: this.state.soDoiTuongDaKhoiTo ? this.state.soDoiTuongDaKhoiTo : 0,
        soVuViecGiaiQuyetDungThoiHan: this.state.soVuViecGiaiQuyetDungThoiHan ? this.state.soVuViecGiaiQuyetDungThoiHan : 0,
        soVuViecGiaiQuyetQuaThoiHan: this.state.soVuViecGiaiQuyetQuaThoiHan ? this.state.soVuViecGiaiQuyetQuaThoiHan : 0,
        tongSoQuyetDinhPhaiToChucThucHien: this.state.tongSoQuyetDinhPhaiToChucThucHien ? this.state.tongSoQuyetDinhPhaiToChucThucHien : 0,
        tongSoQuyetDinhPhaiToChucThucHienDaThucHien: this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
        tienPhaiThuChoNhaNuoc: this.state.tienPhaiThuChoNhaNuoc ? this.state.tienPhaiThuChoNhaNuoc : 0,
        datPhaiThuChoNhaNuoc: this.state.datPhaiThuChoNhaNuoc ? this.state.datPhaiThuChoNhaNuoc : 0,
        tienDaThuChoNhaNuoc: this.state.tienDaThuChoNhaNuoc ? this.state.tienDaThuChoNhaNuoc : 0,
        datDaThuChoNhaNuoc: this.state.datDaThuChoNhaNuoc ? this.state.datDaThuChoNhaNuoc : 0,
        tienPhaiTraChoCongDan: this.state.tienPhaiTraChoCongDan ? this.state.tienPhaiTraChoCongDan : 0,
        datPhaiTraChoCongDan: this.state.datPhaiTraChoCongDan ? this.state.datPhaiTraChoCongDan : 0,
        tienDaTraChoCongDan: this.state.tienDaTraChoCongDan ? this.state.tienDaTraChoCongDan : 0,
        datDaTraChoCongDan: this.state.datDaTraChoCongDan ? this.state.datDaTraChoCongDan : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item && item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoDonKhieuNai ? item.tongSoDonKhieuNai : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.donNhanTrongKyBaoCao ? item.donNhanTrongKyBaoCao : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.donTonKyTruocChuyenSang ? item.donTonKyTruocChuyenSang : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoVuViec ? item.tongSoVuViec : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soDonThuocThamQuyen ? item.soDonThuocThamQuyen : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuViecThuocThamQuyen ? item.soVuViecThuocThamQuyen : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuViecGiaiQuyetBangQDHanhChinh ? item.soVuViecGiaiQuyetBangQDHanhChinh : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.khieuNaiDung ? item.khieuNaiDung : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.khieuNaiSai ? item.khieuNaiSai : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.khieuNaiDungMotPhan ? item.khieuNaiDungMotPhan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.giaiQuyetLan1 ? item.giaiQuyetLan1 : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.congNhanQuyetDinhGiaiQuyetLan1 ? item.congNhanQuyetDinhGiaiQuyetLan1 : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.huySuaQuyetDinhGiaiQuyetLan1 ? item.huySuaQuyetDinhGiaiQuyetLan1 : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.kienNghiThuHoiChoNhaNuocTien ? item.kienNghiThuHoiChoNhaNuocTien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.kienNghiThuHoiChoNhaNuocDat ? item.kienNghiThuHoiChoNhaNuocDat : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.traLaiChoCongDanTien ? item.traLaiChoCongDanTien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.traLaiChoCongDanDat ? item.traLaiChoCongDanDat : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDuocTraLaiQuyenLoi ? item.soNguoiDuocTraLaiQuyenLoi : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhTongSoNguoi ? item.kienNghiXuLyHanhChinhTongSoNguoi : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuChuyenCoQuanDieuTra ? item.soVuChuyenCoQuanDieuTra : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soDoiTuongChuyenCoQuanDieuTra ? item.soDoiTuongChuyenCoQuanDieuTra : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuDaKhoiTo ? item.soVuDaKhoiTo : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soDoiTuongDaKhoiTo ? item.soDoiTuongDaKhoiTo : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuViecGiaiQuyetDungThoiHan ? item.soVuViecGiaiQuyetDungThoiHan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVuViecGiaiQuyetQuaThoiHan ? item.soVuViecGiaiQuyetQuaThoiHan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoQuyetDinhPhaiToChucThucHien ? item.tongSoQuyetDinhPhaiToChucThucHien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.tienPhaiThuChoNhaNuoc ? item.tienPhaiThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.datPhaiThuChoNhaNuoc ? item.datPhaiThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.tienDaThuChoNhaNuoc ? item.tienDaThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.datDaThuChoNhaNuoc ? item.datDaThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.tienPhaiTraChoCongDan ? item.tienPhaiTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.datPhaiTraChoCongDan ? item.datPhaiTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.tienDaTraChoCongDan ? item.tienDaTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item && item.datDaTraChoCongDan ? item.datDaTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNai, onChange: this.onChange.bind(this, 'tongSoDonKhieuNai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donNhanTrongKyBaoCao, onChange: this.onChange.bind(this, 'donNhanTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donTonKyTruocChuyenSang, onChange: this.onChange.bind(this, 'donTonKyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoVuViec, onChange: this.onChange.bind(this, 'tongSoVuViec') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonThuocThamQuyen, onChange: this.onChange.bind(this, 'soDonThuocThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecThuocThamQuyen, onChange: this.onChange.bind(this, 'soVuViecThuocThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecGiaiQuyetBangQDHanhChinh, onChange: this.onChange.bind(this, 'soVuViecGiaiQuyetBangQDHanhChinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecRutDonThongQuaGiaiThichThuyetPhuc, onChange: this.onChange.bind(this, 'soVuViecRutDonThongQuaGiaiThichThuyetPhuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.khieuNaiDung, onChange: this.onChange.bind(this, 'khieuNaiDung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.khieuNaiSai, onChange: this.onChange.bind(this, 'khieuNaiSai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.khieuNaiDungMotPhan, onChange: this.onChange.bind(this, 'khieuNaiDungMotPhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.giaiQuyetLan1, onChange: this.onChange.bind(this, 'giaiQuyetLan1') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.congNhanQuyetDinhGiaiQuyetLan1, onChange: this.onChange.bind(this, 'congNhanQuyetDinhGiaiQuyetLan1') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.huySuaQuyetDinhGiaiQuyetLan1, onChange: this.onChange.bind(this, 'huySuaQuyetDinhGiaiQuyetLan1') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiChoNhaNuocTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiChoNhaNuocTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiChoNhaNuocDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiChoNhaNuocDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.traLaiChoCongDanTien, onChange: this.onChange.bind(this, 'traLaiChoCongDanTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.traLaiChoCongDanDat, onChange: this.onChange.bind(this, 'traLaiChoCongDanDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhTongSoNguoi, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhTongSoNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhSoNguoiDaBiXuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuChuyenCoQuanDieuTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDoiTuongChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soDoiTuongChuyenCoQuanDieuTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuDaKhoiTo, onChange: this.onChange.bind(this, 'soVuDaKhoiTo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDoiTuongDaKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongDaKhoiTo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecGiaiQuyetDungThoiHan, onChange: this.onChange.bind(this, 'soVuViecGiaiQuyetDungThoiHan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecGiaiQuyetQuaThoiHan, onChange: this.onChange.bind(this, 'soVuViecGiaiQuyetQuaThoiHan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoQuyetDinhPhaiToChucThucHien, onChange: this.onChange.bind(this, 'tongSoQuyetDinhPhaiToChucThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien, onChange: this.onChange.bind(this, 'tongSoQuyetDinhPhaiToChucThucHienDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienPhaiThuChoNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datPhaiThuChoNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienDaThuChoNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datDaThuChoNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienPhaiTraChoCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datPhaiTraChoCongDan, onChange: this.onChange.bind(this, 'datPhaiTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienDaTraChoCongDan, onChange: this.onChange.bind(this, 'tienDaTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datDaTraChoCongDan, onChange: this.onChange.bind(this, 'datDaTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListitemThongKeGQDKN;
}(_react2.default.Component);

exports.default = ListitemThongKeGQDKN;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeGQDTC = function (_React$Component) {
  _inherits(ListItemThongKeGQDTC, _React$Component);

  function ListItemThongKeGQDTC(props, context) {
    _classCallCheck(this, ListItemThongKeGQDTC);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeGQDTC.__proto__ || Object.getPrototypeOf(ListItemThongKeGQDTC)).call(this, props, context));

    _this.state = {
      tongSoDonToCao: _this.props.item && _this.props.item.tongSoDonToCao ? _this.props.item.tongSoDonToCao : 0,
      donNhanTrongKyBaoCao: _this.props.item && _this.props.item.donNhanTrongKyBaoCao ? _this.props.item.donNhanTrongKyBaoCao : 0,
      donTonKyTruocChuyenSang: _this.props.item && _this.props.item.donTonKyTruocChuyenSang ? _this.props.item.donTonKyTruocChuyenSang : 0,
      tongSoVuViec: _this.props.item && _this.props.item.tongSoVuViec ? _this.props.item.tongSoVuViec : 0,
      soDonThuocThamQuyen: _this.props.item && _this.props.item.soDonThuocThamQuyen ? _this.props.item.soDonThuocThamQuyen : 0,
      soVuViecThuocThamQuyen: _this.props.item && _this.props.item.soVuViecThuocThamQuyen ? _this.props.item.soVuViecThuocThamQuyen : 0,
      toCaoDung: _this.props.item && _this.props.item.toCaoDung ? _this.props.item.toCaoDung : 0,
      toCaoSai: _this.props.item && _this.props.item.toCaoSai ? _this.props.item.toCaoSai : 0,
      toCaoDungMotPhan: _this.props.item && _this.props.item.toCaoDungMotPhan ? _this.props.item.toCaoDungMotPhan : 0,
      kienNghiThuHoiChoNhaNuocTien: _this.props.item && _this.props.item.kienNghiThuHoiChoNhaNuocTien ? _this.props.item.kienNghiThuHoiChoNhaNuocTien : 0,
      kienNghiThuHoiChoNhaNuocDat: _this.props.item && _this.props.item.kienNghiThuHoiChoNhaNuocDat ? _this.props.item.kienNghiThuHoiChoNhaNuocDat : 0,
      traLaiChoCongDanTien: _this.props.item && _this.props.item.traLaiChoCongDanTien ? _this.props.item.traLaiChoCongDanTien : 0,
      traLaiChoCongDanDat: _this.props.item && _this.props.item.traLaiChoCongDanDat ? _this.props.item.traLaiChoCongDanDat : 0,
      soNguoiDuocTraLaiQuyenLoi: _this.props.item && _this.props.item.soNguoiDuocTraLaiQuyenLoi ? _this.props.item.soNguoiDuocTraLaiQuyenLoi : 0,
      kienNghiXuLyHanhChinhTongSoNguoi: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhTongSoNguoi ? _this.props.item.kienNghiXuLyHanhChinhTongSoNguoi : 0,
      kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? _this.props.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
      soVuChuyenCoQuanDieuTra: _this.props.item && _this.props.item.soVuChuyenCoQuanDieuTra ? _this.props.item.soVuChuyenCoQuanDieuTra : 0,
      soDoiTuongChuyenCoQuanDieuTra: _this.props.item && _this.props.item.soDoiTuongChuyenCoQuanDieuTra ? _this.props.item.soDoiTuongChuyenCoQuanDieuTra : 0,
      soVuDaKhoiTo: _this.props.item && _this.props.item.soVuDaKhoiTo ? _this.props.item.soVuDaKhoiTo : 0,
      soDoiTuongDaKhoiTo: _this.props.item && _this.props.item.soDoiTuongDaKhoiTo ? _this.props.item.soDoiTuongDaKhoiTo : 0,
      soVuViecGiaiQuyetDungThoiHan: _this.props.item && _this.props.item.soVuViecGiaiQuyetDungThoiHan ? _this.props.item.soVuViecGiaiQuyetDungThoiHan : 0,
      soVuViecGiaiQuyetQuaThoiHan: _this.props.item && _this.props.item.soVuViecGiaiQuyetQuaThoiHan ? _this.props.item.soVuViecGiaiQuyetQuaThoiHan : 0,
      tongSoQuyetDinhPhaiToChucThucHien: _this.props.item && _this.props.item.tongSoQuyetDinhPhaiToChucThucHien ? _this.props.item.tongSoQuyetDinhPhaiToChucThucHien : 0,
      tongSoQuyetDinhPhaiToChucThucHienDaThucHien: _this.props.item && _this.props.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? _this.props.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
      tienPhaiThuChoNhaNuoc: _this.props.item && _this.props.item.tienPhaiThuChoNhaNuoc ? _this.props.item.tienPhaiThuChoNhaNuoc : 0,
      datPhaiThuChoNhaNuoc: _this.props.item && _this.props.item.datPhaiThuChoNhaNuoc ? _this.props.item.datPhaiThuChoNhaNuoc : 0,
      tienDaThuChoNhaNuoc: _this.props.item && _this.props.item.tienDaThuChoNhaNuoc ? _this.props.item.tienDaThuChoNhaNuoc : 0,
      datDaThuChoNhaNuoc: _this.props.item && _this.props.item.datDaThuChoNhaNuoc ? _this.props.item.datDaThuChoNhaNuoc : 0,
      tienPhaiTraChoCongDan: _this.props.item && _this.props.item.tienPhaiTraChoCongDan ? _this.props.item.tienPhaiTraChoCongDan : 0,
      datPhaiTraChoCongDan: _this.props.item && _this.props.item.datPhaiTraChoCongDan ? _this.props.item.datPhaiTraChoCongDan : 0,
      tienDaTraChoCongDan: _this.props.item && _this.props.item.tienDaTraChoCongDan ? _this.props.item.tienDaTraChoCongDan : 0,
      datDaTraChoCongDan: _this.props.item && _this.props.item.datDaTraChoCongDan ? _this.props.item.datDaTraChoCongDan : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeGQDTC, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tongSoDonToCao: nextProps.item && nextProps.item.tongSoDonToCao ? nextProps.item.tongSoDonToCao : 0,
        donNhanTrongKyBaoCao: nextProps.item && nextProps.item.donNhanTrongKyBaoCao ? nextProps.item.donNhanTrongKyBaoCao : 0,
        donTonKyTruocChuyenSang: nextProps.item && nextProps.item.donTonKyTruocChuyenSang ? nextProps.item.donTonKyTruocChuyenSang : 0,
        tongSoVuViec: nextProps.item && nextProps.item.tongSoVuViec ? nextProps.item.tongSoVuViec : 0,
        soDonThuocThamQuyen: nextProps.item && nextProps.item.soDonThuocThamQuyen ? nextProps.item.soDonThuocThamQuyen : 0,
        soVuViecThuocThamQuyen: nextProps.item && nextProps.item.soVuViecThuocThamQuyen ? nextProps.item.soVuViecThuocThamQuyen : 0,
        toCaoDung: nextProps.item && nextProps.item.toCaoDung ? nextProps.item.toCaoDung : 0,
        toCaoSai: nextProps.item && nextProps.item.toCaoSai ? nextProps.item.toCaoSai : 0,
        toCaoDungMotPhan: nextProps.item && nextProps.item.toCaoDungMotPhan ? nextProps.item.toCaoDungMotPhan : 0,
        kienNghiThuHoiChoNhaNuocTien: nextProps.item && nextProps.item.kienNghiThuHoiChoNhaNuocTien ? nextProps.item.kienNghiThuHoiChoNhaNuocTien : 0,
        kienNghiThuHoiChoNhaNuocDat: nextProps.item && nextProps.item.kienNghiThuHoiChoNhaNuocDat ? nextProps.item.kienNghiThuHoiChoNhaNuocDat : 0,
        traLaiChoCongDanTien: nextProps.item && nextProps.item.traLaiChoCongDanTien ? nextProps.item.traLaiChoCongDanTien : 0,
        traLaiChoCongDanDat: nextProps.item && nextProps.item.traLaiChoCongDanDat ? nextProps.item.traLaiChoCongDanDat : 0,
        soNguoiDuocTraLaiQuyenLoi: nextProps.item && nextProps.item.soNguoiDuocTraLaiQuyenLoi ? nextProps.item.soNguoiDuocTraLaiQuyenLoi : 0,
        kienNghiXuLyHanhChinhTongSoNguoi: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhTongSoNguoi ? nextProps.item.kienNghiXuLyHanhChinhTongSoNguoi : 0,
        kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? nextProps.item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
        soVuChuyenCoQuanDieuTra: nextProps.item && nextProps.item.soVuChuyenCoQuanDieuTra ? nextProps.item.soVuChuyenCoQuanDieuTra : 0,
        soDoiTuongChuyenCoQuanDieuTra: nextProps.item && nextProps.item.soDoiTuongChuyenCoQuanDieuTra ? nextProps.item.soDoiTuongChuyenCoQuanDieuTra : 0,
        soVuDaKhoiTo: nextProps.item && nextProps.item.soVuDaKhoiTo ? nextProps.item.soVuDaKhoiTo : 0,
        soDoiTuongDaKhoiTo: nextProps.item && nextProps.item.soDoiTuongDaKhoiTo ? nextProps.item.soDoiTuongDaKhoiTo : 0,
        soVuViecGiaiQuyetDungThoiHan: nextProps.item && nextProps.item.soVuViecGiaiQuyetDungThoiHan ? nextProps.item.soVuViecGiaiQuyetDungThoiHan : 0,
        soVuViecGiaiQuyetQuaThoiHan: nextProps.item && nextProps.item.soVuViecGiaiQuyetQuaThoiHan ? nextProps.item.soVuViecGiaiQuyetQuaThoiHan : 0,
        tongSoQuyetDinhPhaiToChucThucHien: nextProps.item && nextProps.item.tongSoQuyetDinhPhaiToChucThucHien ? nextProps.item.tongSoQuyetDinhPhaiToChucThucHien : 0,
        tongSoQuyetDinhPhaiToChucThucHienDaThucHien: nextProps.item && nextProps.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? nextProps.item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
        tienPhaiThuChoNhaNuoc: nextProps.item && nextProps.item.tienPhaiThuChoNhaNuoc ? nextProps.item.tienPhaiThuChoNhaNuoc : 0,
        datPhaiThuChoNhaNuoc: nextProps.item && nextProps.item.datPhaiThuChoNhaNuoc ? nextProps.item.datPhaiThuChoNhaNuoc : 0,
        tienDaThuChoNhaNuoc: nextProps.item && nextProps.item.tienDaThuChoNhaNuoc ? nextProps.item.tienDaThuChoNhaNuoc : 0,
        datDaThuChoNhaNuoc: nextProps.item && nextProps.item.datDaThuChoNhaNuoc ? nextProps.item.datDaThuChoNhaNuoc : 0,
        tienPhaiTraChoCongDan: nextProps.item && nextProps.item.tienPhaiTraChoCongDan ? nextProps.item.tienPhaiTraChoCongDan : 0,
        datPhaiTraChoCongDan: nextProps.item && nextProps.item.datPhaiTraChoCongDan ? nextProps.item.datPhaiTraChoCongDan : 0,
        tienDaTraChoCongDan: nextProps.item && nextProps.item.tienDaTraChoCongDan ? nextProps.item.tienDaTraChoCongDan : 0,
        datDaTraChoCongDan: nextProps.item && nextProps.item.datDaTraChoCongDan ? nextProps.item.datDaTraChoCongDan : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoDonToCao: this.state.tongSoDonToCao ? this.state.tongSoDonToCao : 0,
        donNhanTrongKyBaoCao: this.state.donNhanTrongKyBaoCao ? this.state.donNhanTrongKyBaoCao : 0,
        donTonKyTruocChuyenSang: this.state.donTonKyTruocChuyenSang ? this.state.donTonKyTruocChuyenSang : 0,
        tongSoVuViec: this.state.tongSoVuViec ? this.state.tongSoVuViec : 0,
        soDonThuocThamQuyen: this.state.soDonThuocThamQuyen ? this.state.soDonThuocThamQuyen : 0,
        soVuViecThuocThamQuyen: this.state.soVuViecThuocThamQuyen ? this.state.soVuViecThuocThamQuyen : 0,
        toCaoDung: this.state.toCaoDung ? this.state.toCaoDung : 0,
        toCaoSai: this.state.toCaoSai ? this.state.toCaoSai : 0,
        toCaoDungMotPhan: this.state.toCaoDungMotPhan ? this.state.toCaoDungMotPhan : 0,
        kienNghiThuHoiChoNhaNuocTien: this.state.kienNghiThuHoiChoNhaNuocTien ? this.state.kienNghiThuHoiChoNhaNuocTien : 0,
        kienNghiThuHoiChoNhaNuocDat: this.state.kienNghiThuHoiChoNhaNuocDat ? this.state.kienNghiThuHoiChoNhaNuocDat : 0,
        traLaiChoCongDanTien: this.state.traLaiChoCongDanTien ? this.state.traLaiChoCongDanTien : 0,
        traLaiChoCongDanDat: this.state.traLaiChoCongDanDat ? this.state.traLaiChoCongDanDat : 0,
        soNguoiDuocTraLaiQuyenLoi: this.state.soNguoiDuocTraLaiQuyenLoi ? this.state.soNguoiDuocTraLaiQuyenLoi : 0,
        kienNghiXuLyHanhChinhTongSoNguoi: this.state.kienNghiXuLyHanhChinhTongSoNguoi ? this.state.kienNghiXuLyHanhChinhTongSoNguoi : 0,
        kienNghiXuLyHanhChinhSoNguoiDaBiXuLy: this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0,
        soVuChuyenCoQuanDieuTra: this.state.soVuChuyenCoQuanDieuTra ? this.state.soVuChuyenCoQuanDieuTra : 0,
        soDoiTuongChuyenCoQuanDieuTra: this.state.soDoiTuongChuyenCoQuanDieuTra ? this.state.soDoiTuongChuyenCoQuanDieuTra : 0,
        soVuDaKhoiTo: this.state.soVuDaKhoiTo ? this.state.soVuDaKhoiTo : 0,
        soDoiTuongDaKhoiTo: this.state.soDoiTuongDaKhoiTo ? this.state.soDoiTuongDaKhoiTo : 0,
        soVuViecGiaiQuyetDungThoiHan: this.state.soVuViecGiaiQuyetDungThoiHan ? this.state.soVuViecGiaiQuyetDungThoiHan : 0,
        soVuViecGiaiQuyetQuaThoiHan: this.state.soVuViecGiaiQuyetQuaThoiHan ? this.state.soVuViecGiaiQuyetQuaThoiHan : 0,
        tongSoQuyetDinhPhaiToChucThucHien: this.state.tongSoQuyetDinhPhaiToChucThucHien ? this.state.tongSoQuyetDinhPhaiToChucThucHien : 0,
        tongSoQuyetDinhPhaiToChucThucHienDaThucHien: this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0,
        tienPhaiThuChoNhaNuoc: this.state.tienPhaiThuChoNhaNuoc ? this.state.tienPhaiThuChoNhaNuoc : 0,
        datPhaiThuChoNhaNuoc: this.state.datPhaiThuChoNhaNuoc ? this.state.datPhaiThuChoNhaNuoc : 0,
        tienDaThuChoNhaNuoc: this.state.tienDaThuChoNhaNuoc ? this.state.tienDaThuChoNhaNuoc : 0,
        datDaThuChoNhaNuoc: this.state.datDaThuChoNhaNuoc ? this.state.datDaThuChoNhaNuoc : 0,
        tienPhaiTraChoCongDan: this.state.tienPhaiTraChoCongDan ? this.state.tienPhaiTraChoCongDan : 0,
        datPhaiTraChoCongDan: this.state.datPhaiTraChoCongDan ? this.state.datPhaiTraChoCongDan : 0,
        tienDaTraChoCongDan: this.state.tienDaTraChoCongDan ? this.state.tienDaTraChoCongDan : 0,
        datDaTraChoCongDan: this.state.datDaTraChoCongDan ? this.state.datDaTraChoCongDan : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCao ? item.tongSoDonToCao : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donNhanTrongKyBaoCao ? item.donNhanTrongKyBaoCao : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donTonKyTruocChuyenSang ? item.donTonKyTruocChuyenSang : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoVuViec ? item.tongSoVuViec : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonThuocThamQuyen ? item.soDonThuocThamQuyen : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVuViecThuocThamQuyen ? item.soVuViecThuocThamQuyen : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.toCaoDung ? item.toCaoDung : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.toCaoSai ? item.toCaoSai : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.toCaoDungMotPhan ? item.toCaoDungMotPhan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiChoNhaNuocTien ? item.kienNghiThuHoiChoNhaNuocTien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiChoNhaNuocDat ? item.kienNghiThuHoiChoNhaNuocDat : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.traLaiChoCongDanTien ? item.traLaiChoCongDanTien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.traLaiChoCongDanDat ? item.traLaiChoCongDanDat : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soNguoiDuocTraLaiQuyenLoi ? item.soNguoiDuocTraLaiQuyenLoi : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXuLyHanhChinhTongSoNguoi ? item.kienNghiXuLyHanhChinhTongSoNguoi : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVuChuyenCoQuanDieuTra ? item.soVuChuyenCoQuanDieuTra : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDoiTuongChuyenCoQuanDieuTra ? item.soDoiTuongChuyenCoQuanDieuTra : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVuDaKhoiTo ? item.soVuDaKhoiTo : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDoiTuongDaKhoiTo ? item.soDoiTuongDaKhoiTo : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVuViecGiaiQuyetDungThoiHan ? item.soVuViecGiaiQuyetDungThoiHan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVuViecGiaiQuyetQuaThoiHan ? item.soVuViecGiaiQuyetQuaThoiHan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoQuyetDinhPhaiToChucThucHien ? item.tongSoQuyetDinhPhaiToChucThucHien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tienPhaiThuChoNhaNuoc ? item.tienPhaiThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.datPhaiThuChoNhaNuoc ? item.datPhaiThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tienDaThuChoNhaNuoc ? item.tienDaThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.datDaThuChoNhaNuoc ? item.datDaThuChoNhaNuoc : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tienPhaiTraChoCongDan ? item.tienPhaiTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.datPhaiTraChoCongDan ? item.datPhaiTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tienDaTraChoCongDan ? item.tienDaTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.datDaTraChoCongDan ? item.datDaTraChoCongDan : this.props.nullElement ? ' ' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCao, onChange: this.onChange.bind(this, 'tongSoDonToCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donNhanTrongKyBaoCao, onChange: this.onChange.bind(this, 'donNhanTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donTonKyTruocChuyenSang, onChange: this.onChange.bind(this, 'donTonKyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoVuViec, onChange: this.onChange.bind(this, 'tongSoVuViec') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonThuocThamQuyen, onChange: this.onChange.bind(this, 'soDonThuocThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecThuocThamQuyen, onChange: this.onChange.bind(this, 'soVuViecThuocThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.toCaoDung, onChange: this.onChange.bind(this, 'toCaoDung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.toCaoSai, onChange: this.onChange.bind(this, 'toCaoSai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.toCaoDungMotPhan, onChange: this.onChange.bind(this, 'toCaoDungMotPhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiChoNhaNuocTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiChoNhaNuocTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiChoNhaNuocDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiChoNhaNuocDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.traLaiChoCongDanTien, onChange: this.onChange.bind(this, 'traLaiChoCongDanTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.traLaiChoCongDanDat, onChange: this.onChange.bind(this, 'traLaiChoCongDanDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhTongSoNguoi, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhTongSoNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhSoNguoiDaBiXuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuChuyenCoQuanDieuTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDoiTuongChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soDoiTuongChuyenCoQuanDieuTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuDaKhoiTo, onChange: this.onChange.bind(this, 'soVuDaKhoiTo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDoiTuongDaKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongDaKhoiTo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecGiaiQuyetDungThoiHan, onChange: this.onChange.bind(this, 'soVuViecGiaiQuyetDungThoiHan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVuViecGiaiQuyetQuaThoiHan, onChange: this.onChange.bind(this, 'soVuViecGiaiQuyetQuaThoiHan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoQuyetDinhPhaiToChucThucHien, onChange: this.onChange.bind(this, 'tongSoQuyetDinhPhaiToChucThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoQuyetDinhPhaiToChucThucHienDaThucHien, onChange: this.onChange.bind(this, 'tongSoQuyetDinhPhaiToChucThucHienDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienPhaiThuChoNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datPhaiThuChoNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienDaThuChoNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datDaThuChoNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuChoNhaNuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienPhaiTraChoCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datPhaiTraChoCongDan, onChange: this.onChange.bind(this, 'datPhaiTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tienDaTraChoCongDan, onChange: this.onChange.bind(this, 'tienDaTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datDaTraChoCongDan, onChange: this.onChange.bind(this, 'datDaTraChoCongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeGQDTC;
}(_react2.default.Component);

exports.default = ListItemThongKeGQDTC;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraChuyenNganh = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraChuyenNganh, _React$Component);

  function ListItemThongKeThanhTraChuyenNganh(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraChuyenNganh);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraChuyenNganh.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraChuyenNganh)).call(this, props, context));

    _this.state = {
      soCuocTTKTTongSo: _this.props.item && _this.props.item.soCuocTTKTTongSo ? _this.props.item.soCuocTTKTTongSo : 0,
      thanhLapDoan: _this.props.item && _this.props.item.thanhLapDoan ? _this.props.item.thanhLapDoan : 0,
      thanhTraDocLap: _this.props.item && _this.props.item.thanhTraDocLap ? _this.props.item.thanhTraDocLap : 0,
      caNhanDuocThanhTra: _this.props.item && _this.props.item.caNhanDuocThanhTra ? _this.props.item.caNhanDuocThanhTra : 0,
      caNhanDuocKiemTra: _this.props.item && _this.props.item.caNhanDuocKiemTra ? _this.props.item.caNhanDuocKiemTra : 0,
      toChucDuocThanhTra: _this.props.item && _this.props.item.toChucDuocThanhTra ? _this.props.item.toChucDuocThanhTra : 0,
      toChucDuocKiemTra: _this.props.item && _this.props.item.toChucDuocKiemTra ? _this.props.item.toChucDuocKiemTra : 0,
      soCoViPhamTongSo: _this.props.item && _this.props.item.soCoViPhamTongSo ? _this.props.item.soCoViPhamTongSo : 0,
      soCoViPhamCaNhan: _this.props.item && _this.props.item.soCoViPhamCaNhan ? _this.props.item.soCoViPhamCaNhan : 0,
      soCoViPhanToChuc: _this.props.item && _this.props.item.soCoViPhanToChuc ? _this.props.item.soCoViPhanToChuc : 0,
      soQDXuPhatHanhChinhTongSo: _this.props.item && _this.props.item.soQDXuPhatHanhChinhTongSo ? _this.props.item.soQDXuPhatHanhChinhTongSo : 0,
      soQDXuPhatHanhChinhCaNhan: _this.props.item && _this.props.item.soQDXuPhatHanhChinhCaNhan ? _this.props.item.soQDXuPhatHanhChinhCaNhan : 0,
      soQDXuPhatHanhChinhToChuc: _this.props.item && _this.props.item.soQDXuPhatHanhChinhToChuc ? _this.props.item.soQDXuPhatHanhChinhToChuc : 0,
      soTienViPhamTongSo: _this.props.item && _this.props.item.soTienViPhamTongSo ? _this.props.item.soTienViPhamTongSo : 0,
      soTienViPhamCaNhan: _this.props.item && _this.props.item.soTienViPhamCaNhan ? _this.props.item.soTienViPhamCaNhan : 0,
      soTienViPhamToChuc: _this.props.item && _this.props.item.soTienViPhamToChuc ? _this.props.item.soTienViPhamToChuc : 0,
      soTienKienNghiThuHoi: _this.props.item && _this.props.item.soTienKienNghiThuHoi ? _this.props.item.soTienKienNghiThuHoi : 0,
      soTienXuLyTaiSanTongSo: _this.props.item && _this.props.item.soTienXuLyTaiSanTongSo ? _this.props.item.soTienXuLyTaiSanTongSo : 0,
      soTienXuLyTaiSanTichThu: _this.props.item && _this.props.item.soTienXuLyTaiSanTichThu ? _this.props.item.soTienXuLyTaiSanTichThu : 0,
      soTienXuLyTaiSanTieuHuy: _this.props.item && _this.props.item.soTienXuLyTaiSanTieuHuy ? _this.props.item.soTienXuLyTaiSanTieuHuy : 0,
      soTienXuLyViPhamTongSo: _this.props.item && _this.props.item.soTienXuLyViPhamTongSo ? _this.props.item.soTienXuLyViPhamTongSo : 0,
      soTienXuLyViPhamCaNhan: _this.props.item && _this.props.item.soTienXuLyViPhamCaNhan ? _this.props.item.soTienXuLyViPhamCaNhan : 0,
      soTienXuLyViPhamToChuc: _this.props.item && _this.props.item.soTienXuLyViPhamToChuc ? _this.props.item.soTienXuLyViPhamToChuc : 0,
      soTienDaThuTongSo: _this.props.item && _this.props.item.soTienDaThuTongSo ? _this.props.item.soTienDaThuTongSo : 0,
      soTienDaThuCaNhan: _this.props.item && _this.props.item.soTienDaThuCaNhan ? _this.props.item.soTienDaThuCaNhan : 0,
      soTienDaThuToChuc: _this.props.item && _this.props.item.soTienDaThuToChuc ? _this.props.item.soTienDaThuToChuc : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraChuyenNganh, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        soCuocTTKTTongSo: nextProps.item && nextProps.item.soCuocTTKTTongSo ? nextProps.item.soCuocTTKTTongSo : 0,
        thanhLapDoan: nextProps.item && nextProps.item.thanhLapDoan ? nextProps.item.thanhLapDoan : 0,
        thanhTraDocLap: nextProps.item && nextProps.item.thanhTraDocLap ? nextProps.item.thanhTraDocLap : 0,
        caNhanDuocThanhTra: nextProps.item && nextProps.item.caNhanDuocThanhTra ? nextProps.item.caNhanDuocThanhTra : 0,
        caNhanDuocKiemTra: nextProps.item && nextProps.item.caNhanDuocKiemTra ? nextProps.item.caNhanDuocKiemTra : 0,
        toChucDuocThanhTra: nextProps.item && nextProps.item.toChucDuocThanhTra ? nextProps.item.toChucDuocThanhTra : 0,
        toChucDuocKiemTra: nextProps.item && nextProps.item.toChucDuocKiemTra ? nextProps.item.toChucDuocKiemTra : 0,
        soCoViPhamTongSo: nextProps.item && nextProps.item.soCoViPhamTongSo ? nextProps.item.soCoViPhamTongSo : 0,
        soCoViPhamCaNhan: nextProps.item && nextProps.item.soCoViPhamCaNhan ? nextProps.item.soCoViPhamCaNhan : 0,
        soCoViPhanToChuc: nextProps.item && nextProps.item.soCoViPhanToChuc ? nextProps.item.soCoViPhanToChuc : 0,
        soQDXuPhatHanhChinhTongSo: nextProps.item && nextProps.item.soQDXuPhatHanhChinhTongSo ? nextProps.item.soQDXuPhatHanhChinhTongSo : 0,
        soQDXuPhatHanhChinhCaNhan: nextProps.item && nextProps.item.soQDXuPhatHanhChinhCaNhan ? nextProps.item.soQDXuPhatHanhChinhCaNhan : 0,
        soQDXuPhatHanhChinhToChuc: nextProps.item && nextProps.item.soQDXuPhatHanhChinhToChuc ? nextProps.item.soQDXuPhatHanhChinhToChuc : 0,
        soTienViPhamTongSo: nextProps.item && nextProps.item.soTienViPhamTongSo ? nextProps.item.soTienViPhamTongSo : 0,
        soTienViPhamCaNhan: nextProps.item && nextProps.item.soTienViPhamCaNhan ? nextProps.item.soTienViPhamCaNhan : 0,
        soTienViPhamToChuc: nextProps.item && nextProps.item.soTienViPhamToChuc ? nextProps.item.soTienViPhamToChuc : 0,
        soTienKienNghiThuHoi: nextProps.item && nextProps.item.soTienKienNghiThuHoi ? nextProps.item.soTienKienNghiThuHoi : 0,
        soTienXuLyTaiSanTongSo: nextProps.item && nextProps.item.soTienXuLyTaiSanTongSo ? nextProps.item.soTienXuLyTaiSanTongSo : 0,
        soTienXuLyTaiSanTichThu: nextProps.item && nextProps.item.soTienXuLyTaiSanTichThu ? nextProps.item.soTienXuLyTaiSanTichThu : 0,
        soTienXuLyTaiSanTieuHuy: nextProps.item && nextProps.item.soTienXuLyTaiSanTieuHuy ? nextProps.item.soTienXuLyTaiSanTieuHuy : 0,
        soTienXuLyViPhamTongSo: nextProps.item && nextProps.item.soTienXuLyViPhamTongSo ? nextProps.item.soTienXuLyViPhamTongSo : 0,
        soTienXuLyViPhamCaNhan: nextProps.item && nextProps.item.soTienXuLyViPhamCaNhan ? nextProps.item.soTienXuLyViPhamCaNhan : 0,
        soTienXuLyViPhamToChuc: nextProps.item && nextProps.item.soTienXuLyViPhamToChuc ? nextProps.item.soTienXuLyViPhamToChuc : 0,
        soTienDaThuTongSo: nextProps.item && nextProps.item.soTienDaThuTongSo ? nextProps.item.soTienDaThuTongSo : 0,
        soTienDaThuCaNhan: nextProps.item && nextProps.item.soTienDaThuCaNhan ? nextProps.item.soTienDaThuCaNhan : 0,
        soTienDaThuToChuc: nextProps.item && nextProps.item.soTienDaThuToChuc ? nextProps.item.soTienDaThuToChuc : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        soCuocTTKTTongSo: this.state.soCuocTTKTTongSo ? this.state.soCuocTTKTTongSo : 0,
        thanhLapDoan: this.state.thanhLapDoan ? this.state.thanhLapDoan : 0,
        thanhTraDocLap: this.state.thanhTraDocLap ? this.state.thanhTraDocLap : 0,
        caNhanDuocThanhTra: this.state.caNhanDuocThanhTra ? this.state.caNhanDuocThanhTra : 0,
        caNhanDuocKiemTra: this.state.caNhanDuocKiemTra ? this.state.caNhanDuocKiemTra : 0,
        toChucDuocThanhTra: this.state.toChucDuocThanhTra ? this.state.toChucDuocThanhTra : 0,
        toChucDuocKiemTra: this.state.toChucDuocKiemTra ? this.state.toChucDuocKiemTra : 0,
        soCoViPhamTongSo: this.state.soCoViPhamTongSo ? this.state.soCoViPhamTongSo : 0,
        soCoViPhamCaNhan: this.state.soCoViPhamCaNhan ? this.state.soCoViPhamCaNhan : 0,
        soCoViPhanToChuc: this.state.soCoViPhanToChuc ? this.state.soCoViPhanToChuc : 0,
        soQDXuPhatHanhChinhTongSo: this.state.soQDXuPhatHanhChinhTongSo ? this.state.soQDXuPhatHanhChinhTongSo : 0,
        soQDXuPhatHanhChinhCaNhan: this.state.soQDXuPhatHanhChinhCaNhan ? this.state.soQDXuPhatHanhChinhCaNhan : 0,
        soQDXuPhatHanhChinhToChuc: this.state.soQDXuPhatHanhChinhToChuc ? this.state.soQDXuPhatHanhChinhToChuc : 0,
        soTienViPhamTongSo: this.state.soTienViPhamTongSo ? this.state.soTienViPhamTongSo : 0,
        soTienViPhamCaNhan: this.state.soTienViPhamCaNhan ? this.state.soTienViPhamCaNhan : 0,
        soTienViPhamToChuc: this.state.soTienViPhamToChuc ? this.state.soTienViPhamToChuc : 0,
        soTienKienNghiThuHoi: this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0,
        soTienXuLyTaiSanTongSo: this.state.soTienXuLyTaiSanTongSo ? this.state.soTienXuLyTaiSanTongSo : 0,
        soTienXuLyTaiSanTichThu: this.state.soTienXuLyTaiSanTichThu ? this.state.soTienXuLyTaiSanTichThu : 0,
        soTienXuLyTaiSanTieuHuy: this.state.soTienXuLyTaiSanTieuHuy ? this.state.soTienXuLyTaiSanTieuHuy : 0,
        soTienXuLyViPhamTongSo: this.state.soTienXuLyViPhamTongSo ? this.state.soTienXuLyViPhamTongSo : 0,
        soTienXuLyViPhamCaNhan: this.state.soTienXuLyViPhamCaNhan ? this.state.soTienXuLyViPhamCaNhan : 0,
        soTienXuLyViPhamToChuc: this.state.soTienXuLyViPhamToChuc ? this.state.soTienXuLyViPhamToChuc : 0,
        soTienDaThuTongSo: this.state.soTienDaThuTongSo ? this.state.soTienDaThuTongSo : 0,
        soTienDaThuCaNhan: this.state.soTienDaThuCaNhan ? this.state.soTienDaThuCaNhan : 0,
        soTienDaThuToChuc: this.state.soTienDaThuToChuc ? this.state.soTienDaThuToChuc : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soCuocTTKTTongSo ? item.soCuocTTKTTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.thanhLapDoan ? item.thanhLapDoan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.thanhTraDocLap ? item.thanhTraDocLap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.caNhanDuocThanhTra ? item.caNhanDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.caNhanDuocKiemTra ? item.caNhanDuocKiemTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.toChucDuocThanhTra ? item.toChucDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.toChucDuocKiemTra ? item.toChucDuocKiemTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soCoViPhamTongSo ? item.soCoViPhamTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soCoViPhamCaNhan ? item.soCoViPhamCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soCoViPhanToChuc ? item.soCoViPhanToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soQDXuPhatHanhChinhTongSo ? item.soQDXuPhatHanhChinhTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soQDXuPhatHanhChinhCaNhan ? item.soQDXuPhatHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soQDXuPhatHanhChinhToChuc ? item.soQDXuPhatHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienViPhamTongSo ? item.soTienViPhamTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienViPhamCaNhan ? item.soTienViPhamCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienViPhamToChuc ? item.soTienViPhamToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienKienNghiThuHoi ? item.soTienKienNghiThuHoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyTaiSanTongSo ? item.soTienXuLyTaiSanTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyTaiSanTichThu ? item.soTienXuLyTaiSanTichThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyTaiSanTieuHuy ? item.soTienXuLyTaiSanTieuHuy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyViPhamTongSo ? item.soTienXuLyViPhamTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyViPhamCaNhan ? item.soTienXuLyViPhamCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienXuLyViPhamToChuc ? item.soTienXuLyViPhamToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienDaThuTongSo ? item.soTienDaThuTongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienDaThuCaNhan ? item.soTienDaThuCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienDaThuToChuc ? item.soTienDaThuToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soCuocTTKTTongSo, onChange: this.onChange.bind(this, 'soCuocTTKTTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhLapDoan, onChange: this.onChange.bind(this, 'thanhLapDoan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraDocLap, onChange: this.onChange.bind(this, 'thanhTraDocLap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.caNhanDuocThanhTra, onChange: this.onChange.bind(this, 'caNhanDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.caNhanDuocKiemTra, onChange: this.onChange.bind(this, 'caNhanDuocKiemTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.toChucDuocThanhTra, onChange: this.onChange.bind(this, 'toChucDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.toChucDuocKiemTra, onChange: this.onChange.bind(this, 'toChucDuocKiemTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soCoViPhamTongSo, onChange: this.onChange.bind(this, 'soCoViPhamTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soCoViPhamCaNhan, onChange: this.onChange.bind(this, 'soCoViPhamCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soCoViPhanToChuc, onChange: this.onChange.bind(this, 'soCoViPhanToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soQDXuPhatHanhChinhTongSo, onChange: this.onChange.bind(this, 'soQDXuPhatHanhChinhTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soQDXuPhatHanhChinhCaNhan, onChange: this.onChange.bind(this, 'soQDXuPhatHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soQDXuPhatHanhChinhToChuc, onChange: this.onChange.bind(this, 'soQDXuPhatHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienViPhamTongSo, onChange: this.onChange.bind(this, 'soTienViPhamTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienViPhamCaNhan, onChange: this.onChange.bind(this, 'soTienViPhamCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienViPhamToChuc, onChange: this.onChange.bind(this, 'soTienViPhamToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienKienNghiThuHoi, onChange: this.onChange.bind(this, 'soTienKienNghiThuHoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyTaiSanTongSo, onChange: this.onChange.bind(this, 'soTienXuLyTaiSanTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyTaiSanTichThu, onChange: this.onChange.bind(this, 'soTienXuLyTaiSanTichThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyTaiSanTieuHuy, onChange: this.onChange.bind(this, 'soTienXuLyTaiSanTieuHuy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyViPhamTongSo, onChange: this.onChange.bind(this, 'soTienXuLyViPhamTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyViPhamCaNhan, onChange: this.onChange.bind(this, 'soTienXuLyViPhamCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienXuLyViPhamToChuc, onChange: this.onChange.bind(this, 'soTienXuLyViPhamToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienDaThuTongSo, onChange: this.onChange.bind(this, 'soTienDaThuTongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienDaThuCaNhan, onChange: this.onChange.bind(this, 'soTienDaThuCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienDaThuToChuc, onChange: this.onChange.bind(this, 'soTienDaThuToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraChuyenNganh;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraChuyenNganh;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraDatDai = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraDatDai, _React$Component);

  function ListItemThongKeThanhTraDatDai(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraDatDai);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraDatDai.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraDatDai)).call(this, props, context));

    _this.state = {
      tongSoCuocThanhTra: _this.props.item && _this.props.item.tongSoCuocThanhTra ? _this.props.item.tongSoCuocThanhTra : 0,
      kyTruocChuyenSang: _this.props.item && _this.props.item.kyTruocChuyenSang ? _this.props.item.kyTruocChuyenSang : 0,
      trienKhaiTrongKyBaoCao: _this.props.item && _this.props.item.trienKhaiTrongKyBaoCao ? _this.props.item.trienKhaiTrongKyBaoCao : 0,
      theoKeHoach: _this.props.item && _this.props.item.theoKeHoach ? _this.props.item.theoKeHoach : 0,
      dotXuat: _this.props.item && _this.props.item.dotXuat ? _this.props.item.dotXuat : 0,
      ketThucThanhTraTrucTiep: _this.props.item && _this.props.item.ketThucThanhTraTrucTiep ? _this.props.item.ketThucThanhTraTrucTiep : 0,
      daBanHanhKetLuan: _this.props.item && _this.props.item.daBanHanhKetLuan ? _this.props.item.daBanHanhKetLuan : 0,
      soDonViDuocThanhTra: _this.props.item && _this.props.item.soDonViDuocThanhTra ? _this.props.item.soDonViDuocThanhTra : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      tongViPhamTien: _this.props.item && _this.props.item.tongViPhamTien ? _this.props.item.tongViPhamTien : 0,
      tongViPhamDat: _this.props.item && _this.props.item.tongViPhamDat ? _this.props.item.tongViPhamDat : 0,
      datLanChiem: _this.props.item && _this.props.item.datLanChiem ? _this.props.item.datLanChiem : 0,
      giaoDatCapDatSaiDoiTuong: _this.props.item && _this.props.item.giaoDatCapDatSaiDoiTuong ? _this.props.item.giaoDatCapDatSaiDoiTuong : 0,
      capBanDatTraiThamQuyen: _this.props.item && _this.props.item.capBanDatTraiThamQuyen ? _this.props.item.capBanDatTraiThamQuyen : 0,
      capGCNQSDDSai: _this.props.item && _this.props.item.capGCNQSDDSai ? _this.props.item.capGCNQSDDSai : 0,
      chuyenNhuongChoThueKhongDungQuyDinh: _this.props.item && _this.props.item.chuyenNhuongChoThueKhongDungQuyDinh ? _this.props.item.chuyenNhuongChoThueKhongDungQuyDinh : 0,
      suDungDatKhongDungMucDich: _this.props.item && _this.props.item.suDungDatKhongDungMucDich ? _this.props.item.suDungDatKhongDungMucDich : 0,
      boHoangHoa: _this.props.item && _this.props.item.boHoangHoa ? _this.props.item.boHoangHoa : 0,
      viPhamKhac: _this.props.item && _this.props.item.viPhamKhac ? _this.props.item.viPhamKhac : 0,
      kienNghiThuHoiTien: _this.props.item && _this.props.item.kienNghiThuHoiTien ? _this.props.item.kienNghiThuHoiTien : 0,
      kienNghiThuHoiDat: _this.props.item && _this.props.item.kienNghiThuHoiDat ? _this.props.item.kienNghiThuHoiDat : 0,
      kienNghiThuHoiQDGiaoDat: _this.props.item && _this.props.item.kienNghiThuHoiQDGiaoDat ? _this.props.item.kienNghiThuHoiQDGiaoDat : 0,
      kienNghiKhacTien: _this.props.item && _this.props.item.kienNghiKhacTien ? _this.props.item.kienNghiKhacTien : 0,
      kienNghiKhacDat: _this.props.item && _this.props.item.kienNghiKhacDat ? _this.props.item.kienNghiKhacDat : 0,
      hanhChinhToChuc: _this.props.item && _this.props.item.hanhChinhToChuc ? _this.props.item.hanhChinhToChuc : 0,
      hanhChinhCaNhan: _this.props.item && _this.props.item.hanhChinhCaNhan ? _this.props.item.hanhChinhCaNhan : 0,
      chuyenCoQuanDieuTraVu: _this.props.item && _this.props.item.chuyenCoQuanDieuTraVu ? _this.props.item.chuyenCoQuanDieuTraVu : 0,
      chuyenCoQuanDieuTraDoiTuong: _this.props.item && _this.props.item.chuyenCoQuanDieuTraDoiTuong ? _this.props.item.chuyenCoQuanDieuTraDoiTuong : 0,
      daThuTien: _this.props.item && _this.props.item.daThuTien ? _this.props.item.daThuTien : 0,
      daThuDat: _this.props.item && _this.props.item.daThuDat ? _this.props.item.daThuDat : 0,
      daThuQdGiaoDat: _this.props.item && _this.props.item.daThuQdGiaoDat ? _this.props.item.daThuQdGiaoDat : 0,
      tongSoKLTTVaQDXLDaKTDD: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKTDD ? _this.props.item.tongSoKLTTVaQDXLDaKTDD : 0,
      ketQuaKiemTraDonDocTienPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienPhaiThu ? _this.props.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
      ketQuaKiemTraDonDocTienDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienDaThu ? _this.props.item.ketQuaKiemTraDonDocTienDaThu : 0,
      ketQuaKiemTraDonDocDatPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatPhaiThu ? _this.props.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
      ketQuaKiemTraDonDocDatDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatDaThu ? _this.props.item.ketQuaKiemTraDonDocDatDaThu : 0,
      daXuLyHanhChinhToChuc: _this.props.item && _this.props.item.daXuLyHanhChinhToChuc ? _this.props.item.daXuLyHanhChinhToChuc : 0,
      daXuLyHanhChinhCaNhan: _this.props.item && _this.props.item.daXuLyHanhChinhCaNhan ? _this.props.item.daXuLyHanhChinhCaNhan : 0,
      daKhoiToVu: _this.props.item && _this.props.item.daKhoiToVu ? _this.props.item.daKhoiToVu : 0,
      daKhoiToDoiTuong: _this.props.item && _this.props.item.daKhoiToDoiTuong ? _this.props.item.daKhoiToDoiTuong : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraDatDai, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tongSoCuocThanhTra: nextProps.item && nextProps.item.tongSoCuocThanhTra ? nextProps.item.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: nextProps.item && nextProps.item.kyTruocChuyenSang ? nextProps.item.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: nextProps.item && nextProps.item.trienKhaiTrongKyBaoCao ? nextProps.item.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: nextProps.item && nextProps.item.theoKeHoach ? nextProps.item.theoKeHoach : 0,
        dotXuat: nextProps.item && nextProps.item.dotXuat ? nextProps.item.dotXuat : 0,
        ketThucThanhTraTrucTiep: nextProps.item && nextProps.item.ketThucThanhTraTrucTiep ? nextProps.item.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: nextProps.item && nextProps.item.daBanHanhKetLuan ? nextProps.item.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: nextProps.item && nextProps.item.soDonViDuocThanhTra ? nextProps.item.soDonViDuocThanhTra : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        tongViPhamTien: nextProps.item && nextProps.item.tongViPhamTien ? nextProps.item.tongViPhamTien : 0,
        tongViPhamDat: nextProps.item && nextProps.item.tongViPhamDat ? nextProps.item.tongViPhamDat : 0,
        datLanChiem: nextProps.item && nextProps.item.datLanChiem ? nextProps.item.datLanChiem : 0,
        giaoDatCapDatSaiDoiTuong: nextProps.item && nextProps.item.giaoDatCapDatSaiDoiTuong ? nextProps.item.giaoDatCapDatSaiDoiTuong : 0,
        capBanDatTraiThamQuyen: nextProps.item && nextProps.item.capBanDatTraiThamQuyen ? nextProps.item.capBanDatTraiThamQuyen : 0,
        capGCNQSDDSai: nextProps.item && nextProps.item.capGCNQSDDSai ? nextProps.item.capGCNQSDDSai : 0,
        chuyenNhuongChoThueKhongDungQuyDinh: nextProps.item && nextProps.item.chuyenNhuongChoThueKhongDungQuyDinh ? nextProps.item.chuyenNhuongChoThueKhongDungQuyDinh : 0,
        suDungDatKhongDungMucDich: nextProps.item && nextProps.item.suDungDatKhongDungMucDich ? nextProps.item.suDungDatKhongDungMucDich : 0,
        boHoangHoa: nextProps.item && nextProps.item.boHoangHoa ? nextProps.item.boHoangHoa : 0,
        viPhamKhac: nextProps.item && nextProps.item.viPhamKhac ? nextProps.item.viPhamKhac : 0,
        kienNghiThuHoiTien: nextProps.item && nextProps.item.kienNghiThuHoiTien ? nextProps.item.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: nextProps.item && nextProps.item.kienNghiThuHoiDat ? nextProps.item.kienNghiThuHoiDat : 0,
        kienNghiThuHoiQDGiaoDat: nextProps.item && nextProps.item.kienNghiThuHoiQDGiaoDat ? nextProps.item.kienNghiThuHoiQDGiaoDat : 0,
        kienNghiKhacTien: nextProps.item && nextProps.item.kienNghiKhacTien ? nextProps.item.kienNghiKhacTien : 0,
        kienNghiKhacDat: nextProps.item && nextProps.item.kienNghiKhacDat ? nextProps.item.kienNghiKhacDat : 0,
        hanhChinhToChuc: nextProps.item && nextProps.item.hanhChinhToChuc ? nextProps.item.hanhChinhToChuc : 0,
        hanhChinhCaNhan: nextProps.item && nextProps.item.hanhChinhCaNhan ? nextProps.item.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: nextProps.item && nextProps.item.chuyenCoQuanDieuTraVu ? nextProps.item.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: nextProps.item && nextProps.item.chuyenCoQuanDieuTraDoiTuong ? nextProps.item.chuyenCoQuanDieuTraDoiTuong : 0,
        daThuTien: nextProps.item && nextProps.item.daThuTien ? nextProps.item.daThuTien : 0,
        daThuDat: nextProps.item && nextProps.item.daThuDat ? nextProps.item.daThuDat : 0,
        daThuQdGiaoDat: nextProps.item && nextProps.item.daThuQdGiaoDat ? nextProps.item.daThuQdGiaoDat : 0,
        tongSoKLTTVaQDXLDaKTDD: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKTDD ? nextProps.item.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienPhaiThu ? nextProps.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienDaThu ? nextProps.item.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatPhaiThu ? nextProps.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatDaThu ? nextProps.item.ketQuaKiemTraDonDocDatDaThu : 0,
        daXuLyHanhChinhToChuc: nextProps.item && nextProps.item.daXuLyHanhChinhToChuc ? nextProps.item.daXuLyHanhChinhToChuc : 0,
        daXuLyHanhChinhCaNhan: nextProps.item && nextProps.item.daXuLyHanhChinhCaNhan ? nextProps.item.daXuLyHanhChinhCaNhan : 0,
        daKhoiToVu: nextProps.item && nextProps.item.daKhoiToVu ? nextProps.item.daKhoiToVu : 0,
        daKhoiToDoiTuong: nextProps.item && nextProps.item.daKhoiToDoiTuong ? nextProps.item.daKhoiToDoiTuong : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoCuocThanhTra: this.state.tongSoCuocThanhTra ? this.state.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: this.state.trienKhaiTrongKyBaoCao ? this.state.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: this.state.theoKeHoach ? this.state.theoKeHoach : 0,
        dotXuat: this.state.dotXuat ? this.state.dotXuat : 0,
        ketThucThanhTraTrucTiep: this.state.ketThucThanhTraTrucTiep ? this.state.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: this.state.daBanHanhKetLuan ? this.state.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: this.state.soDonViDuocThanhTra ? this.state.soDonViDuocThanhTra : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        tongViPhamTien: this.state.tongViPhamTien ? this.state.tongViPhamTien : 0,
        tongViPhamDat: this.state.tongViPhamDat ? this.state.tongViPhamDat : 0,
        datLanChiem: this.state.datLanChiem ? this.state.datLanChiem : 0,
        giaoDatCapDatSaiDoiTuong: this.state.giaoDatCapDatSaiDoiTuong ? this.state.giaoDatCapDatSaiDoiTuong : 0,
        capBanDatTraiThamQuyen: this.state.capBanDatTraiThamQuyen ? this.state.capBanDatTraiThamQuyen : 0,
        capGCNQSDDSai: this.state.capGCNQSDDSai ? this.state.capGCNQSDDSai : 0,
        chuyenNhuongChoThueKhongDungQuyDinh: this.state.chuyenNhuongChoThueKhongDungQuyDinh ? this.state.chuyenNhuongChoThueKhongDungQuyDinh : 0,
        suDungDatKhongDungMucDich: this.state.suDungDatKhongDungMucDich ? this.state.suDungDatKhongDungMucDich : 0,
        boHoangHoa: this.state.boHoangHoa ? this.state.boHoangHoa : 0,
        viPhamKhac: this.state.viPhamKhac ? this.state.viPhamKhac : 0,
        kienNghiThuHoiTien: this.state.kienNghiThuHoiTien ? this.state.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: this.state.kienNghiThuHoiDat ? this.state.kienNghiThuHoiDat : 0,
        kienNghiThuHoiQDGiaoDat: this.state.kienNghiThuHoiQDGiaoDat ? this.state.kienNghiThuHoiQDGiaoDat : 0,
        kienNghiKhacTien: this.state.kienNghiKhacTien ? this.state.kienNghiKhacTien : 0,
        kienNghiKhacDat: this.state.kienNghiKhacDat ? this.state.kienNghiKhacDat : 0,
        hanhChinhToChuc: this.state.hanhChinhToChuc ? this.state.hanhChinhToChuc : 0,
        hanhChinhCaNhan: this.state.hanhChinhCaNhan ? this.state.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: this.state.chuyenCoQuanDieuTraVu ? this.state.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: this.state.chuyenCoQuanDieuTraDoiTuong ? this.state.chuyenCoQuanDieuTraDoiTuong : 0,
        daThuTien: this.state.daThuTien ? this.state.daThuTien : 0,
        daThuDat: this.state.daThuDat ? this.state.daThuDat : 0,
        daThuQdGiaoDat: this.state.daThuQdGiaoDat ? this.state.daThuQdGiaoDat : 0,
        tongSoKLTTVaQDXLDaKTDD: this.state.tongSoKLTTVaQDXLDaKTDD ? this.state.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: this.state.ketQuaKiemTraDonDocTienPhaiThu ? this.state.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: this.state.ketQuaKiemTraDonDocTienDaThu ? this.state.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: this.state.ketQuaKiemTraDonDocDatPhaiThu ? this.state.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: this.state.ketQuaKiemTraDonDocDatDaThu ? this.state.ketQuaKiemTraDonDocDatDaThu : 0,
        daXuLyHanhChinhToChuc: this.state.daXuLyHanhChinhToChuc ? this.state.daXuLyHanhChinhToChuc : 0,
        daXuLyHanhChinhCaNhan: this.state.daXuLyHanhChinhCaNhan ? this.state.daXuLyHanhChinhCaNhan : 0,
        daKhoiToVu: this.state.daKhoiToVu ? this.state.daKhoiToVu : 0,
        daKhoiToDoiTuong: this.state.daKhoiToDoiTuong ? this.state.daKhoiToDoiTuong : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoCuocThanhTra ? item.tongSoCuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kyTruocChuyenSang ? item.kyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.trienKhaiTrongKyBaoCao ? item.trienKhaiTrongKyBaoCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.theoKeHoach ? item.theoKeHoach : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.dotXuat ? item.dotXuat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketThucThanhTraTrucTiep ? item.ketThucThanhTraTrucTiep : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daBanHanhKetLuan ? item.daBanHanhKetLuan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViDuocThanhTra ? item.soDonViDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamTien ? item.tongViPhamTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamDat ? item.tongViPhamDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.datLanChiem ? item.datLanChiem : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.giaoDatCapDatSaiDoiTuong ? item.giaoDatCapDatSaiDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.capBanDatTraiThamQuyen ? item.capBanDatTraiThamQuyen : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.capGCNQSDDSai ? item.capGCNQSDDSai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.chuyenNhuongChoThueKhongDungQuyDinh ? item.chuyenNhuongChoThueKhongDungQuyDinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.suDungDatKhongDungMucDich ? item.suDungDatKhongDungMucDich : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.boHoangHoa ? item.boHoangHoa : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.viPhamKhac ? item.viPhamKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTien ? item.kienNghiThuHoiTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiDat ? item.kienNghiThuHoiDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiThuHoiQDGiaoDat ? item.kienNghiThuHoiQDGiaoDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacTien ? item.kienNghiKhacTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacDat ? item.kienNghiKhacDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhToChuc ? item.hanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhCaNhan ? item.hanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraVu ? item.chuyenCoQuanDieuTraVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraDoiTuong ? item.chuyenCoQuanDieuTraDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTien ? item.daThuTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuDat ? item.daThuDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daThuQdGiaoDat ? item.daThuQdGiaoDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoKLTTVaQDXLDaKTDD ? item.tongSoKLTTVaQDXLDaKTDD : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienPhaiThu ? item.ketQuaKiemTraDonDocTienPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienDaThu ? item.ketQuaKiemTraDonDocTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatPhaiThu ? item.ketQuaKiemTraDonDocDatPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatDaThu ? item.ketQuaKiemTraDonDocDatDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daXuLyHanhChinhToChuc ? item.daXuLyHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daXuLyHanhChinhCaNhan ? item.daXuLyHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daKhoiToVu ? item.daKhoiToVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daKhoiToDoiTuong ? item.daKhoiToDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoCuocThanhTra, onChange: this.onChange.bind(this, 'tongSoCuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kyTruocChuyenSang, onChange: this.onChange.bind(this, 'kyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.trienKhaiTrongKyBaoCao, onChange: this.onChange.bind(this, 'trienKhaiTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.theoKeHoach, onChange: this.onChange.bind(this, 'theoKeHoach') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.dotXuat, onChange: this.onChange.bind(this, 'dotXuat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketThucThanhTraTrucTiep, onChange: this.onChange.bind(this, 'ketThucThanhTraTrucTiep') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daBanHanhKetLuan, onChange: this.onChange.bind(this, 'daBanHanhKetLuan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViDuocThanhTra, onChange: this.onChange.bind(this, 'soDonViDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamTien, onChange: this.onChange.bind(this, 'tongViPhamTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamDat, onChange: this.onChange.bind(this, 'tongViPhamDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.datLanChiem, onChange: this.onChange.bind(this, 'datLanChiem') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.giaoDatCapDatSaiDoiTuong, onChange: this.onChange.bind(this, 'giaoDatCapDatSaiDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.capBanDatTraiThamQuyen, onChange: this.onChange.bind(this, 'capBanDatTraiThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.capGCNQSDDSai, onChange: this.onChange.bind(this, 'capGCNQSDDSai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenNhuongChoThueKhongDungQuyDinh, onChange: this.onChange.bind(this, 'chuyenNhuongChoThueKhongDungQuyDinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.suDungDatKhongDungMucDich, onChange: this.onChange.bind(this, 'suDungDatKhongDungMucDich') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.boHoangHoa, onChange: this.onChange.bind(this, 'boHoangHoa') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamKhac, onChange: this.onChange.bind(this, 'viPhamKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiQDGiaoDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiQDGiaoDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacTien, onChange: this.onChange.bind(this, 'kienNghiKhacTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacDat, onChange: this.onChange.bind(this, 'kienNghiKhacDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhToChuc, onChange: this.onChange.bind(this, 'hanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhCaNhan, onChange: this.onChange.bind(this, 'hanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraVu, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraDoiTuong, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTien, onChange: this.onChange.bind(this, 'daThuTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuDat, onChange: this.onChange.bind(this, 'daThuDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuQdGiaoDat, onChange: this.onChange.bind(this, 'daThuQdGiaoDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKTDD, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKTDD') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXuLyHanhChinhToChuc, onChange: this.onChange.bind(this, 'daXuLyHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXuLyHanhChinhCaNhan, onChange: this.onChange.bind(this, 'daXuLyHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daKhoiToVu, onChange: this.onChange.bind(this, 'daKhoiToVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daKhoiToDoiTuong, onChange: this.onChange.bind(this, 'daKhoiToDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraDatDai;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraDatDai;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraHanhChinh = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraHanhChinh, _React$Component);

  function ListItemThongKeThanhTraHanhChinh(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraHanhChinh);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraHanhChinh.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraHanhChinh)).call(this, props, context));

    _this.state = {
      tenDonVi: _this.props.item && _this.props.item.tenDonVi ? _this.props.item.tenDonVi : '',
      tongSoCuocThanhTra: _this.props.item && _this.props.item.tongSoCuocThanhTra ? _this.props.item.tongSoCuocThanhTra : 0,
      kyTruocChuyenSang: _this.props.item && _this.props.item.kyTruocChuyenSang ? _this.props.item.kyTruocChuyenSang : 0,
      trienKhaiTrongKyBaoCao: _this.props.item && _this.props.item.trienKhaiTrongKyBaoCao ? _this.props.item.trienKhaiTrongKyBaoCao : 0,
      theoKeHoach: _this.props.item && _this.props.item.theoKeHoach ? _this.props.item.theoKeHoach : 0,
      dotXuat: _this.props.item && _this.props.item.dotXuat ? _this.props.item.dotXuat : 0,
      ketThucThanhTraTrucTiep: _this.props.item && _this.props.item.ketThucThanhTraTrucTiep ? _this.props.item.ketThucThanhTraTrucTiep : 0,
      daBanHanhKetLuan: _this.props.item && _this.props.item.daBanHanhKetLuan ? _this.props.item.daBanHanhKetLuan : 0,
      soDonViDuocThanhTra: _this.props.item && _this.props.item.soDonViDuocThanhTra ? _this.props.item.soDonViDuocThanhTra : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      tongViPhamTien: _this.props.item && _this.props.item.tongViPhamTien ? _this.props.item.tongViPhamTien : 0,
      tongViPhamDat: _this.props.item && _this.props.item.tongViPhamDat ? _this.props.item.tongViPhamDat : 0,
      kienNghiThuHoiTien: _this.props.item && _this.props.item.kienNghiThuHoiTien ? _this.props.item.kienNghiThuHoiTien : 0,
      kienNghiThuHoiDat: _this.props.item && _this.props.item.kienNghiThuHoiDat ? _this.props.item.kienNghiThuHoiDat : 0,
      kienNghiKhacTien: _this.props.item && _this.props.item.kienNghiKhacTien ? _this.props.item.kienNghiKhacTien : 0,
      kienNghiKhacDat: _this.props.item && _this.props.item.kienNghiKhacDat ? _this.props.item.kienNghiKhacDat : 0,
      kienNghiXLHanhChinhToChuc: _this.props.item && _this.props.item.kienNghiXLHanhChinhToChuc ? _this.props.item.kienNghiXLHanhChinhToChuc : 0,
      kienNghiXLHanhChinhCaNhan: _this.props.item && _this.props.item.kienNghiXLHanhChinhCaNhan ? _this.props.item.kienNghiXLHanhChinhCaNhan : 0,
      kienNghiXLVu: _this.props.item && _this.props.item.kienNghiXLVu ? _this.props.item.kienNghiXLVu : 0,
      kienNghiXLDoiTuong: _this.props.item && _this.props.item.kienNghiXLDoiTuong ? _this.props.item.kienNghiXLDoiTuong : 0,
      daThuTien: _this.props.item && _this.props.item.daThuTien ? _this.props.item.daThuTien : 0,
      daThuDat: _this.props.item && _this.props.item.daThuDat ? _this.props.item.daThuDat : 0,
      tongSoKLTTVaQDXLDaKTDD: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKTDD ? _this.props.item.tongSoKLTTVaQDXLDaKTDD : 0,
      ketQuaKiemTraDonDocTienPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienPhaiThu ? _this.props.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
      ketQuaKiemTraDonDocTienDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienDaThu ? _this.props.item.ketQuaKiemTraDonDocTienDaThu : 0,
      ketQuaKiemTraDonDocDatPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatPhaiThu ? _this.props.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
      ketQuaKiemTraDonDocDatDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatDaThu ? _this.props.item.ketQuaKiemTraDonDocDatDaThu : 0,
      ketQuaKiemTraDonDocDaXuLyHCToChuc: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
      ketQuaKiemTraDonDocDaXuLyHCCaNhan: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
      ketQuaKiemTraDonDocDaKhoiToVu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
      ketQuaKiemTraDonDocDaKhoiToDoiTuong: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraHanhChinh, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tenDonVi: nextProps.item && nextProps.item.tenDonVi ? nextProps.item.tenDonVi : '',
        tongSoCuocThanhTra: nextProps.item && nextProps.item.tongSoCuocThanhTra ? nextProps.item.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: nextProps.item && nextProps.item.kyTruocChuyenSang ? nextProps.item.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: nextProps.item && nextProps.item.trienKhaiTrongKyBaoCao ? nextProps.item.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: nextProps.item && nextProps.item.theoKeHoach ? nextProps.item.theoKeHoach : 0,
        dotXuat: nextProps.item && nextProps.item.dotXuat ? nextProps.item.dotXuat : 0,
        ketThucThanhTraTrucTiep: nextProps.item && nextProps.item.ketThucThanhTraTrucTiep ? nextProps.item.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: nextProps.item && nextProps.item.daBanHanhKetLuan ? nextProps.item.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: nextProps.item && nextProps.item.soDonViDuocThanhTra ? nextProps.item.soDonViDuocThanhTra : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        tongViPhamTien: nextProps.item && nextProps.item.tongViPhamTien ? nextProps.item.tongViPhamTien : 0,
        tongViPhamDat: nextProps.item && nextProps.item.tongViPhamDat ? nextProps.item.tongViPhamDat : 0,
        kienNghiThuHoiTien: nextProps.item && nextProps.item.kienNghiThuHoiTien ? nextProps.item.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: nextProps.item && nextProps.item.kienNghiThuHoiDat ? nextProps.item.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: nextProps.item && nextProps.item.kienNghiKhacTien ? nextProps.item.kienNghiKhacTien : 0,
        kienNghiKhacDat: nextProps.item && nextProps.item.kienNghiKhacDat ? nextProps.item.kienNghiKhacDat : 0,
        kienNghiXLHanhChinhToChuc: nextProps.item && nextProps.item.kienNghiXLHanhChinhToChuc ? nextProps.item.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: nextProps.item && nextProps.item.kienNghiXLHanhChinhCaNhan ? nextProps.item.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXLVu: nextProps.item && nextProps.item.kienNghiXLVu ? nextProps.item.kienNghiXLVu : 0,
        kienNghiXLDoiTuong: nextProps.item && nextProps.item.kienNghiXLDoiTuong ? nextProps.item.kienNghiXLDoiTuong : 0,
        daThuTien: nextProps.item && nextProps.item.daThuTien ? nextProps.item.daThuTien : 0,
        daThuDat: nextProps.item && nextProps.item.daThuDat ? nextProps.item.daThuDat : 0,
        tongSoKLTTVaQDXLDaKTDD: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKTDD ? nextProps.item.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienPhaiThu ? nextProps.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienDaThu ? nextProps.item.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatPhaiThu ? nextProps.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatDaThu ? nextProps.item.ketQuaKiemTraDonDocDatDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoCuocThanhTra: this.state.tongSoCuocThanhTra ? this.state.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: this.state.trienKhaiTrongKyBaoCao ? this.state.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: this.state.theoKeHoach ? this.state.theoKeHoach : 0,
        dotXuat: this.state.dotXuat ? this.state.dotXuat : 0,
        ketThucThanhTraTrucTiep: this.state.ketThucThanhTraTrucTiep ? this.state.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: this.state.daBanHanhKetLuan ? this.state.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: this.state.soDonViDuocThanhTra ? this.state.soDonViDuocThanhTra : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        tongViPhamTien: this.state.tongViPhamTien ? this.state.tongViPhamTien : 0,
        tongViPhamDat: this.state.tongViPhamDat ? this.state.tongViPhamDat : 0,
        kienNghiThuHoiTien: this.state.kienNghiThuHoiTien ? this.state.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: this.state.kienNghiThuHoiDat ? this.state.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: this.state.kienNghiKhacTien ? this.state.kienNghiKhacTien : 0,
        kienNghiKhacDat: this.state.kienNghiKhacDat ? this.state.kienNghiKhacDat : 0,
        kienNghiXLHanhChinhToChuc: this.state.kienNghiXLHanhChinhToChuc ? this.state.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: this.state.kienNghiXLHanhChinhCaNhan ? this.state.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXLVu: this.state.kienNghiXLVu ? this.state.kienNghiXLVu : 0,
        kienNghiXLDoiTuong: this.state.kienNghiXLDoiTuong ? this.state.kienNghiXLDoiTuong : 0,
        daThuTien: this.state.daThuTien ? this.state.daThuTien : 0,
        daThuDat: this.state.daThuDat ? this.state.daThuDat : 0,
        tongSoKLTTVaQDXLDaKTDD: this.state.tongSoKLTTVaQDXLDaKTDD ? this.state.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: this.state.ketQuaKiemTraDonDocTienPhaiThu ? this.state.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: this.state.ketQuaKiemTraDonDocTienDaThu ? this.state.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: this.state.ketQuaKiemTraDonDocDatPhaiThu ? this.state.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: this.state.ketQuaKiemTraDonDocDatDaThu ? this.state.ketQuaKiemTraDonDocDatDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc ? this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: this.state.ketQuaKiemTraDonDocDaKhoiToVu ? this.state.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoCuocThanhTra ? item.tongSoCuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kyTruocChuyenSang ? item.kyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.trienKhaiTrongKyBaoCao ? item.trienKhaiTrongKyBaoCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.theoKeHoach ? item.theoKeHoach : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.dotXuat ? item.dotXuat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketThucThanhTraTrucTiep ? item.ketThucThanhTraTrucTiep : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daBanHanhKetLuan ? item.daBanHanhKetLuan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViDuocThanhTra ? item.soDonViDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamTien ? item.tongViPhamTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamDat ? item.tongViPhamDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTien ? item.kienNghiThuHoiTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiDat ? item.kienNghiThuHoiDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacTien ? item.kienNghiKhacTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacDat ? item.kienNghiKhacDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhToChuc ? item.kienNghiXLHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhCaNhan ? item.kienNghiXLHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLVu ? item.kienNghiXLVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLDoiTuong ? item.kienNghiXLDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTien ? item.daThuTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuDat ? item.daThuDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoKLTTVaQDXLDaKTDD ? item.tongSoKLTTVaQDXLDaKTDD : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienPhaiThu ? item.ketQuaKiemTraDonDocTienPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienDaThu ? item.ketQuaKiemTraDonDocTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatPhaiThu ? item.ketQuaKiemTraDonDocDatPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatDaThu ? item.ketQuaKiemTraDonDocDatDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? item.ketQuaKiemTraDonDocDaXuLyHCToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToVu ? item.ketQuaKiemTraDonDocDaKhoiToVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', defaultValue: this.state.tenDonVi })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoCuocThanhTra, onChange: this.onChange.bind(this, 'tongSoCuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kyTruocChuyenSang, onChange: this.onChange.bind(this, 'kyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.trienKhaiTrongKyBaoCao, onChange: this.onChange.bind(this, 'trienKhaiTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.theoKeHoach, onChange: this.onChange.bind(this, 'theoKeHoach') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.dotXuat, onChange: this.onChange.bind(this, 'dotXuat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketThucThanhTraTrucTiep, onChange: this.onChange.bind(this, 'ketThucThanhTraTrucTiep') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daBanHanhKetLuan, onChange: this.onChange.bind(this, 'daBanHanhKetLuan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViDuocThanhTra, onChange: this.onChange.bind(this, 'soDonViDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamTien, onChange: this.onChange.bind(this, 'tongViPhamTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamDat, onChange: this.onChange.bind(this, 'tongViPhamDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacTien, onChange: this.onChange.bind(this, 'kienNghiKhacTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacDat, onChange: this.onChange.bind(this, 'kienNghiKhacDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhToChuc, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhCaNhan, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLVu, onChange: this.onChange.bind(this, 'kienNghiXLVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLDoiTuong, onChange: this.onChange.bind(this, 'kienNghiXLDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTien, onChange: this.onChange.bind(this, 'daThuTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuDat, onChange: this.onChange.bind(this, 'daThuDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKTDD, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKTDD') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToVu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraHanhChinh;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraHanhChinh;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraLai = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraLai, _React$Component);

  function ListItemThongKeThanhTraLai(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraLai);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraLai.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraLai)).call(this, props, context));

    _this.state = {
      tenDonVi: _this.props.item && _this.props.item.tenDonVi ? _this.props.item.tenDonVi : '',
      tongSoCuocThanhTraLai: _this.props.item && _this.props.item.tongSoCuocThanhTraLai ? _this.props.item.tongSoCuocThanhTraLai : 0,
      kyTruocChuyenSang: _this.props.item && _this.props.item.kyTruocChuyenSang ? _this.props.item.kyTruocChuyenSang : 0,
      trienKhaiTrongKyBaoCao: _this.props.item && _this.props.item.trienKhaiTrongKyBaoCao ? _this.props.item.trienKhaiTrongKyBaoCao : 0,
      ketThucThanhTraTrucTiep: _this.props.item && _this.props.item.ketThucThanhTraTrucTiep ? _this.props.item.ketThucThanhTraTrucTiep : 0,
      daBanHanhKetLuan: _this.props.item && _this.props.item.daBanHanhKetLuan ? _this.props.item.daBanHanhKetLuan : 0,
      viPhamTrinhTu: _this.props.item && _this.props.item.viPhamTrinhTu ? _this.props.item.viPhamTrinhTu : 0,
      ketLuanKhongPhuHop: _this.props.item && _this.props.item.ketLuanKhongPhuHop ? _this.props.item.ketLuanKhongPhuHop : 0,
      saiLamApDungPhapLuat: _this.props.item && _this.props.item.saiLamApDungPhapLuat ? _this.props.item.saiLamApDungPhapLuat : 0,
      coYLamSaiLechHoSo: _this.props.item && _this.props.item.coYLamSaiLechHoSo ? _this.props.item.coYLamSaiLechHoSo : 0,
      viPhamNghiemTrong: _this.props.item && _this.props.item.viPhamNghiemTrong ? _this.props.item.viPhamNghiemTrong : 0,
      soDonViDaThanhTraLai: _this.props.item && _this.props.item.soDonViDaThanhTraLai ? _this.props.item.soDonViDaThanhTraLai : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      viPhamVeKinhTeTien: _this.props.item && _this.props.item.viPhamVeKinhTeTien ? _this.props.item.viPhamVeKinhTeTien : 0,
      viPhamVeKinhTeDat: _this.props.item && _this.props.item.viPhamVeKinhTeDat ? _this.props.item.viPhamVeKinhTeDat : 0,
      kienNghiThuHoiTien: _this.props.item && _this.props.item.kienNghiThuHoiTien ? _this.props.item.kienNghiThuHoiTien : 0,
      kienNghiThuHoiDat: _this.props.item && _this.props.item.kienNghiThuHoiDat ? _this.props.item.kienNghiThuHoiDat : 0,
      kienNghiKhacTien: _this.props.item && _this.props.item.kienNghiKhacTien ? _this.props.item.kienNghiKhacTien : 0,
      kienNghiKhacDat: _this.props.item && _this.props.item.kienNghiKhacDat ? _this.props.item.kienNghiKhacDat : 0,
      hanhChinhToChuc: _this.props.item && _this.props.item.hanhChinhToChuc ? _this.props.item.hanhChinhToChuc : 0,
      hanhChinhCaNhan: _this.props.item && _this.props.item.hanhChinhCaNhan ? _this.props.item.hanhChinhCaNhan : 0,
      chuyenCoQuanDieuTraVu: _this.props.item && _this.props.item.chuyenCoQuanDieuTraVu ? _this.props.item.chuyenCoQuanDieuTraVu : 0,
      chuyenCoQuanDieuTraDoiTuong: _this.props.item && _this.props.item.chuyenCoQuanDieuTraDoiTuong ? _this.props.item.chuyenCoQuanDieuTraDoiTuong : 0,
      ketQuaThucHienTienDaThu: _this.props.item && _this.props.item.ketQuaThucHienTienDaThu ? _this.props.item.ketQuaThucHienTienDaThu : 0,
      ketQuaThucHienDatDaThu: _this.props.item && _this.props.item.ketQuaThucHienDatDaThu ? _this.props.item.ketQuaThucHienDatDaThu : 0,
      ketQuaThucHienToChuc: _this.props.item && _this.props.item.ketQuaThucHienToChuc ? _this.props.item.ketQuaThucHienToChuc : 0,
      ketQuaThucHienCaNhan: _this.props.item && _this.props.item.ketQuaThucHienCaNhan ? _this.props.item.ketQuaThucHienCaNhan : 0,
      ketQuaThucHienVu: _this.props.item && _this.props.item.ketQuaThucHienVu ? _this.props.item.ketQuaThucHienVu : 0,
      ketQuaThucHienDoiTuong: _this.props.item && _this.props.item.ketQuaThucHienDoiTuong ? _this.props.item.ketQuaThucHienDoiTuong : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraLai, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tenDonVi: nextProps.item && nextProps.item.tenDonVi ? nextProps.item.tenDonVi : '',
        tongSoCuocThanhTraLai: nextProps.item && nextProps.item.tongSoCuocThanhTraLai ? nextProps.item.tongSoCuocThanhTraLai : 0,
        kyTruocChuyenSang: nextProps.item && nextProps.item.kyTruocChuyenSang ? nextProps.item.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: nextProps.item && nextProps.item.trienKhaiTrongKyBaoCao ? nextProps.item.trienKhaiTrongKyBaoCao : 0,
        ketThucThanhTraTrucTiep: nextProps.item && nextProps.item.ketThucThanhTraTrucTiep ? nextProps.item.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: nextProps.item && nextProps.item.daBanHanhKetLuan ? nextProps.item.daBanHanhKetLuan : 0,
        viPhamTrinhTu: nextProps.item && nextProps.item.viPhamTrinhTu ? nextProps.item.viPhamTrinhTu : 0,
        ketLuanKhongPhuHop: nextProps.item && nextProps.item.ketLuanKhongPhuHop ? nextProps.item.ketLuanKhongPhuHop : 0,
        saiLamApDungPhapLuat: nextProps.item && nextProps.item.saiLamApDungPhapLuat ? nextProps.item.saiLamApDungPhapLuat : 0,
        coYLamSaiLechHoSo: nextProps.item && nextProps.item.coYLamSaiLechHoSo ? nextProps.item.coYLamSaiLechHoSo : 0,
        viPhamNghiemTrong: nextProps.item && nextProps.item.viPhamNghiemTrong ? nextProps.item.viPhamNghiemTrong : 0,
        soDonViDaThanhTraLai: nextProps.item && nextProps.item.soDonViDaThanhTraLai ? nextProps.item.soDonViDaThanhTraLai : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        viPhamVeKinhTeTien: nextProps.item && nextProps.item.viPhamVeKinhTeTien ? nextProps.item.viPhamVeKinhTeTien : 0,
        viPhamVeKinhTeDat: nextProps.item && nextProps.item.viPhamVeKinhTeDat ? nextProps.item.viPhamVeKinhTeDat : 0,
        kienNghiThuHoiTien: nextProps.item && nextProps.item.kienNghiThuHoiTien ? nextProps.item.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: nextProps.item && nextProps.item.kienNghiThuHoiDat ? nextProps.item.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: nextProps.item && nextProps.item.kienNghiKhacTien ? nextProps.item.kienNghiKhacTien : 0,
        kienNghiKhacDat: nextProps.item && nextProps.item.kienNghiKhacDat ? nextProps.item.kienNghiKhacDat : 0,
        hanhChinhToChuc: nextProps.item && nextProps.item.hanhChinhToChuc ? nextProps.item.hanhChinhToChuc : 0,
        hanhChinhCaNhan: nextProps.item && nextProps.item.hanhChinhCaNhan ? nextProps.item.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: nextProps.item && nextProps.item.chuyenCoQuanDieuTraVu ? nextProps.item.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: nextProps.item && nextProps.item.chuyenCoQuanDieuTraDoiTuong ? nextProps.item.chuyenCoQuanDieuTraDoiTuong : 0,
        ketQuaThucHienTienDaThu: nextProps.item && nextProps.item.ketQuaThucHienTienDaThu ? nextProps.item.ketQuaThucHienTienDaThu : 0,
        ketQuaThucHienDatDaThu: nextProps.item && nextProps.item.ketQuaThucHienDatDaThu ? nextProps.item.ketQuaThucHienDatDaThu : 0,
        ketQuaThucHienToChuc: nextProps.item && nextProps.item.ketQuaThucHienToChuc ? nextProps.item.ketQuaThucHienToChuc : 0,
        ketQuaThucHienCaNhan: nextProps.item && nextProps.item.ketQuaThucHienCaNhan ? nextProps.item.ketQuaThucHienCaNhan : 0,
        ketQuaThucHienVu: nextProps.item && nextProps.item.ketQuaThucHienVu ? nextProps.item.ketQuaThucHienVu : 0,
        ketQuaThucHienDoiTuong: nextProps.item && nextProps.item.ketQuaThucHienDoiTuong ? nextProps.item.ketQuaThucHienDoiTuong : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoCuocThanhTraLai: this.state.tongSoCuocThanhTraLai ? this.state.tongSoCuocThanhTraLai : 0,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: this.state.trienKhaiTrongKyBaoCao ? this.state.trienKhaiTrongKyBaoCao : 0,
        ketThucThanhTraTrucTiep: this.state.ketThucThanhTraTrucTiep ? this.state.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: this.state.daBanHanhKetLuan ? this.state.daBanHanhKetLuan : 0,
        viPhamTrinhTu: this.state.viPhamTrinhTu ? this.state.viPhamTrinhTu : 0,
        ketLuanKhongPhuHop: this.state.ketLuanKhongPhuHop ? this.state.ketLuanKhongPhuHop : 0,
        saiLamApDungPhapLuat: this.state.saiLamApDungPhapLuat ? this.state.saiLamApDungPhapLuat : 0,
        coYLamSaiLechHoSo: this.state.coYLamSaiLechHoSo ? this.state.coYLamSaiLechHoSo : 0,
        viPhamNghiemTrong: this.state.viPhamNghiemTrong ? this.state.viPhamNghiemTrong : 0,
        soDonViDaThanhTraLai: this.state.soDonViDaThanhTraLai ? this.state.soDonViDaThanhTraLai : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        viPhamVeKinhTeTien: this.state.viPhamVeKinhTeTien ? this.state.viPhamVeKinhTeTien : 0,
        viPhamVeKinhTeDat: this.state.viPhamVeKinhTeDat ? this.state.viPhamVeKinhTeDat : 0,
        kienNghiThuHoiTien: this.state.kienNghiThuHoiTien ? this.state.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: this.state.kienNghiThuHoiDat ? this.state.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: this.state.kienNghiKhacTien ? this.state.kienNghiKhacTien : 0,
        kienNghiKhacDat: this.state.kienNghiKhacDat ? this.state.kienNghiKhacDat : 0,
        hanhChinhToChuc: this.state.hanhChinhToChuc ? this.state.hanhChinhToChuc : 0,
        hanhChinhCaNhan: this.state.hanhChinhCaNhan ? this.state.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: this.state.chuyenCoQuanDieuTraVu ? this.state.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: this.state.chuyenCoQuanDieuTraDoiTuong ? this.state.chuyenCoQuanDieuTraDoiTuong : 0,
        ketQuaThucHienTienDaThu: this.state.ketQuaThucHienTienDaThu ? this.state.ketQuaThucHienTienDaThu : 0,
        ketQuaThucHienDatDaThu: this.state.ketQuaThucHienDatDaThu ? this.state.ketQuaThucHienDatDaThu : 0,
        ketQuaThucHienToChuc: this.state.ketQuaThucHienToChuc ? this.state.ketQuaThucHienToChuc : 0,
        ketQuaThucHienCaNhan: this.state.ketQuaThucHienCaNhan ? this.state.ketQuaThucHienCaNhan : 0,
        ketQuaThucHienVu: this.state.ketQuaThucHienVu ? this.state.ketQuaThucHienVu : 0,
        ketQuaThucHienDoiTuong: this.state.ketQuaThucHienDoiTuong ? this.state.ketQuaThucHienDoiTuong : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoCuocThanhTraLai ? item.tongSoCuocThanhTraLai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kyTruocChuyenSang ? item.kyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.trienKhaiTrongKyBaoCao ? item.trienKhaiTrongKyBaoCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketThucThanhTraTrucTiep ? item.ketThucThanhTraTrucTiep : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daBanHanhKetLuan ? item.daBanHanhKetLuan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.viPhamTrinhTu ? item.viPhamTrinhTu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketLuanKhongPhuHop ? item.ketLuanKhongPhuHop : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.saiLamApDungPhapLuat ? item.saiLamApDungPhapLuat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.coYLamSaiLechHoSo ? item.coYLamSaiLechHoSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.viPhamNghiemTrong ? item.viPhamNghiemTrong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViDaThanhTraLai ? item.soDonViDaThanhTraLai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.viPhamVeKinhTeTien ? item.viPhamVeKinhTeTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.viPhamVeKinhTeDat ? item.viPhamVeKinhTeDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTien ? item.kienNghiThuHoiTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiDat ? item.kienNghiThuHoiDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacTien ? item.kienNghiKhacTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacDat ? item.kienNghiKhacDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhToChuc ? item.hanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhCaNhan ? item.hanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraVu ? item.chuyenCoQuanDieuTraVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraDoiTuong ? item.chuyenCoQuanDieuTraDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaThucHienTienDaThu ? item.ketQuaThucHienTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaThucHienDatDaThu ? item.ketQuaThucHienDatDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaThucHienToChuc ? item.ketQuaThucHienToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaThucHienCaNhan ? item.ketQuaThucHienCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaThucHienVu ? item.ketQuaThucHienVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaThucHienDoiTuong ? item.ketQuaThucHienDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoCuocThanhTraLai, onChange: this.onChange.bind(this, 'tongSoCuocThanhTraLai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kyTruocChuyenSang, onChange: this.onChange.bind(this, 'kyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.trienKhaiTrongKyBaoCao, onChange: this.onChange.bind(this, 'trienKhaiTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketThucThanhTraTrucTiep, onChange: this.onChange.bind(this, 'ketThucThanhTraTrucTiep') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daBanHanhKetLuan, onChange: this.onChange.bind(this, 'daBanHanhKetLuan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamTrinhTu, onChange: this.onChange.bind(this, 'viPhamTrinhTu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketLuanKhongPhuHop, onChange: this.onChange.bind(this, 'ketLuanKhongPhuHop') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.saiLamApDungPhapLuat, onChange: this.onChange.bind(this, 'saiLamApDungPhapLuat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.coYLamSaiLechHoSo, onChange: this.onChange.bind(this, 'coYLamSaiLechHoSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamNghiemTrong, onChange: this.onChange.bind(this, 'viPhamNghiemTrong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViDaThanhTraLai, onChange: this.onChange.bind(this, 'soDonViDaThanhTraLai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamVeKinhTeTien, onChange: this.onChange.bind(this, 'viPhamVeKinhTeTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamVeKinhTeDat, onChange: this.onChange.bind(this, 'viPhamVeKinhTeDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacTien, onChange: this.onChange.bind(this, 'kienNghiKhacTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacDat, onChange: this.onChange.bind(this, 'kienNghiKhacDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhToChuc, onChange: this.onChange.bind(this, 'hanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhCaNhan, onChange: this.onChange.bind(this, 'hanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraVu, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraDoiTuong, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienTienDaThu, onChange: this.onChange.bind(this, 'ketQuaThucHienTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienDatDaThu, onChange: this.onChange.bind(this, 'ketQuaThucHienDatDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienToChuc, onChange: this.onChange.bind(this, 'ketQuaThucHienToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienCaNhan, onChange: this.onChange.bind(this, 'ketQuaThucHienCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienVu, onChange: this.onChange.bind(this, 'ketQuaThucHienVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaThucHienDoiTuong, onChange: this.onChange.bind(this, 'ketQuaThucHienDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraLai;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraLai;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraThamNhung = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraThamNhung, _React$Component);

  function ListItemThongKeThanhTraThamNhung(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraThamNhung);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraThamNhung.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraThamNhung)).call(this, props, context));

    _this.state = {
      donVi: _this.props.item && _this.props.item.donVi ? _this.props.item.donVi : 0,
      soVu: _this.props.item && _this.props.item.soVu ? _this.props.item.soVu : 0,
      soNguoi: _this.props.item && _this.props.item.soNguoi ? _this.props.item.soNguoi : 0,
      taiSanThamNhungTongTien: _this.props.item && _this.props.item.taiSanThamNhungTongTien ? _this.props.item.taiSanThamNhungTongTien : 0,
      taiSanThamNhungTien: _this.props.item && _this.props.item.taiSanThamNhungTien ? _this.props.item.taiSanThamNhungTien : 0,
      taiSanThamNhungTaiSanKhac: _this.props.item && _this.props.item.taiSanThamNhungTaiSanKhac ? _this.props.item.taiSanThamNhungTaiSanKhac : 0,
      taiSanThamNhungDat: _this.props.item && _this.props.item.taiSanThamNhungDat ? _this.props.item.taiSanThamNhungDat : 0,
      kienNghiThuHoiTongTien: _this.props.item && _this.props.item.kienNghiThuHoiTongTien ? _this.props.item.kienNghiThuHoiTongTien : 0,
      kienNghiThuHoiTien: _this.props.item && _this.props.item.kienNghiThuHoiTien ? _this.props.item.kienNghiThuHoiTien : 0,
      kienNghiThuHoiTaiSanKhac: _this.props.item && _this.props.item.kienNghiThuHoiTaiSanKhac ? _this.props.item.kienNghiThuHoiTaiSanKhac : 0,
      kienNghiThuHoiDat: _this.props.item && _this.props.item.kienNghiThuHoiDat ? _this.props.item.kienNghiThuHoiDat : 0,
      daThuTongTien: _this.props.item && _this.props.item.daThuTongTien ? _this.props.item.daThuTongTien : 0,
      daThuTien: _this.props.item && _this.props.item.daThuTien ? _this.props.item.daThuTien : 0,
      daThuTaiSanKhac: _this.props.item && _this.props.item.daThuTaiSanKhac ? _this.props.item.daThuTaiSanKhac : 0,
      daThuDat: _this.props.item && _this.props.item.daThuDat ? _this.props.item.daThuDat : 0,
      hanhChinhToChuc: _this.props.item && _this.props.item.hanhChinhToChuc ? _this.props.item.hanhChinhToChuc : 0,
      hanhChinhCaNhan: _this.props.item && _this.props.item.hanhChinhCaNhan ? _this.props.item.hanhChinhCaNhan : 0,
      chuyenCoQuanDieuTraVu: _this.props.item && _this.props.item.chuyenCoQuanDieuTraVu ? _this.props.item.chuyenCoQuanDieuTraVu : 0,
      chuyenCoQuanDieuTraDoiTuong: _this.props.item && _this.props.item.chuyenCoQuanDieuTraDoiTuong ? _this.props.item.chuyenCoQuanDieuTraDoiTuong : 0,
      daXuLyHanhChinhToChuc: _this.props.item && _this.props.item.daXuLyHanhChinhToChuc ? _this.props.item.daXuLyHanhChinhToChuc : 0,
      daXuLyHanhChinhCaNhan: _this.props.item && _this.props.item.daXuLyHanhChinhCaNhan ? _this.props.item.daXuLyHanhChinhCaNhan : 0,
      daKhoiToVu: _this.props.item && _this.props.item.daKhoiToVu ? _this.props.item.daKhoiToVu : 0,
      daKhoiToDoiTuong: _this.props.item && _this.props.item.daKhoiToDoiTuong ? _this.props.item.daKhoiToDoiTuong : 0,
      xuLyTrachNhiemNguoiDungDauKienNghi: _this.props.item && _this.props.item.xuLyTrachNhiemNguoiDungDauKienNghi ? _this.props.item.xuLyTrachNhiemNguoiDungDauKienNghi : 0,
      xuLyTrachNhiemNguoiDungDauDaXuLy: _this.props.item && _this.props.item.xuLyTrachNhiemNguoiDungDauDaXuLy ? _this.props.item.xuLyTrachNhiemNguoiDungDauDaXuLy : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraThamNhung, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        donVi: nextProps.item && nextProps.item.donVi ? nextProps.item.donVi : 0,
        soVu: nextProps.item && nextProps.item.soVu ? nextProps.item.soVu : 0,
        soNguoi: nextProps.item && nextProps.item.soNguoi ? nextProps.item.soNguoi : 0,
        taiSanThamNhungTongTien: nextProps.item && nextProps.item.taiSanThamNhungTongTien ? nextProps.item.taiSanThamNhungTongTien : 0,
        taiSanThamNhungTien: nextProps.item && nextProps.item.taiSanThamNhungTien ? nextProps.item.taiSanThamNhungTien : 0,
        taiSanThamNhungTaiSanKhac: nextProps.item && nextProps.item.taiSanThamNhungTaiSanKhac ? nextProps.item.taiSanThamNhungTaiSanKhac : 0,
        taiSanThamNhungDat: nextProps.item && nextProps.item.taiSanThamNhungDat ? nextProps.item.taiSanThamNhungDat : 0,
        kienNghiThuHoiTongTien: nextProps.item && nextProps.item.kienNghiThuHoiTongTien ? nextProps.item.kienNghiThuHoiTongTien : 0,
        kienNghiThuHoiTien: nextProps.item && nextProps.item.kienNghiThuHoiTien ? nextProps.item.kienNghiThuHoiTien : 0,
        kienNghiThuHoiTaiSanKhac: nextProps.item && nextProps.item.kienNghiThuHoiTaiSanKhac ? nextProps.item.kienNghiThuHoiTaiSanKhac : 0,
        kienNghiThuHoiDat: nextProps.item && nextProps.item.kienNghiThuHoiDat ? nextProps.item.kienNghiThuHoiDat : 0,
        daThuTongTien: nextProps.item && nextProps.item.daThuTongTien ? nextProps.item.daThuTongTien : 0,
        daThuTien: nextProps.item && nextProps.item.daThuTien ? nextProps.item.daThuTien : 0,
        daThuTaiSanKhac: nextProps.item && nextProps.item.daThuTaiSanKhac ? nextProps.item.daThuTaiSanKhac : 0,
        daThuDat: nextProps.item && nextProps.item.daThuDat ? nextProps.item.daThuDat : 0,
        hanhChinhToChuc: nextProps.item && nextProps.item.hanhChinhToChuc ? nextProps.item.hanhChinhToChuc : 0,
        hanhChinhCaNhan: nextProps.item && nextProps.item.hanhChinhCaNhan ? nextProps.item.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: nextProps.item && nextProps.item.chuyenCoQuanDieuTraVu ? nextProps.item.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: nextProps.item && nextProps.item.chuyenCoQuanDieuTraDoiTuong ? nextProps.item.chuyenCoQuanDieuTraDoiTuong : 0,
        daXuLyHanhChinhToChuc: nextProps.item && nextProps.item.daXuLyHanhChinhToChuc ? nextProps.item.daXuLyHanhChinhToChuc : 0,
        daXuLyHanhChinhCaNhan: nextProps.item && nextProps.item.daXuLyHanhChinhCaNhan ? nextProps.item.daXuLyHanhChinhCaNhan : 0,
        daKhoiToVu: nextProps.item && nextProps.item.daKhoiToVu ? nextProps.item.daKhoiToVu : 0,
        daKhoiToDoiTuong: nextProps.item && nextProps.item.daKhoiToDoiTuong ? nextProps.item.daKhoiToDoiTuong : 0,
        xuLyTrachNhiemNguoiDungDauKienNghi: nextProps.item && nextProps.item.xuLyTrachNhiemNguoiDungDauKienNghi ? nextProps.item.xuLyTrachNhiemNguoiDungDauKienNghi : 0,
        xuLyTrachNhiemNguoiDungDauDaXuLy: nextProps.item && nextProps.item.xuLyTrachNhiemNguoiDungDauDaXuLy ? nextProps.item.xuLyTrachNhiemNguoiDungDauDaXuLy : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        soVu: this.state.soVu ? this.state.soVu : 0,
        soNguoi: this.state.soNguoi ? this.state.soNguoi : 0,
        taiSanThamNhungTongTien: this.state.taiSanThamNhungTongTien ? this.state.taiSanThamNhungTongTien : 0,
        taiSanThamNhungTien: this.state.taiSanThamNhungTien ? this.state.taiSanThamNhungTien : 0,
        taiSanThamNhungTaiSanKhac: this.state.taiSanThamNhungTaiSanKhac ? this.state.taiSanThamNhungTaiSanKhac : 0,
        taiSanThamNhungDat: this.state.taiSanThamNhungDat ? this.state.taiSanThamNhungDat : 0,
        kienNghiThuHoiTongTien: this.state.kienNghiThuHoiTongTien ? this.state.kienNghiThuHoiTongTien : 0,
        kienNghiThuHoiTien: this.state.kienNghiThuHoiTien ? this.state.kienNghiThuHoiTien : 0,
        kienNghiThuHoiTaiSanKhac: this.state.kienNghiThuHoiTaiSanKhac ? this.state.kienNghiThuHoiTaiSanKhac : 0,
        kienNghiThuHoiDat: this.state.kienNghiThuHoiDat ? this.state.kienNghiThuHoiDat : 0,
        daThuTongTien: this.state.daThuTongTien ? this.state.daThuTongTien : 0,
        daThuTien: this.state.daThuTien ? this.state.daThuTien : 0,
        daThuTaiSanKhac: this.state.daThuTaiSanKhac ? this.state.daThuTaiSanKhac : 0,
        daThuDat: this.state.daThuDat ? this.state.daThuDat : 0,
        hanhChinhToChuc: this.state.hanhChinhToChuc ? this.state.hanhChinhToChuc : 0,
        hanhChinhCaNhan: this.state.hanhChinhCaNhan ? this.state.hanhChinhCaNhan : 0,
        chuyenCoQuanDieuTraVu: this.state.chuyenCoQuanDieuTraVu ? this.state.chuyenCoQuanDieuTraVu : 0,
        chuyenCoQuanDieuTraDoiTuong: this.state.chuyenCoQuanDieuTraDoiTuong ? this.state.chuyenCoQuanDieuTraDoiTuong : 0,
        daXuLyHanhChinhToChuc: this.state.daXuLyHanhChinhToChuc ? this.state.daXuLyHanhChinhToChuc : 0,
        daXuLyHanhChinhCaNhan: this.state.daXuLyHanhChinhCaNhan ? this.state.daXuLyHanhChinhCaNhan : 0,
        daKhoiToVu: this.state.daKhoiToVu ? this.state.daKhoiToVu : 0,
        daKhoiToDoiTuong: this.state.daKhoiToDoiTuong ? this.state.daKhoiToDoiTuong : 0,
        xuLyTrachNhiemNguoiDungDauKienNghi: this.state.xuLyTrachNhiemNguoiDungDauKienNghi ? this.state.xuLyTrachNhiemNguoiDungDauKienNghi : 0,
        xuLyTrachNhiemNguoiDungDauDaXuLy: this.state.xuLyTrachNhiemNguoiDungDauDaXuLy ? this.state.xuLyTrachNhiemNguoiDungDauDaXuLy : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      var hasDonVi = typeof item.donVi != 'undefined' && item.donVi.id != '' && item.donVi.id != null;
      var isView = typeof item.donVi != 'undefined' && item.donVi.id && this.props.sum || this.props.nullElement == true;
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soVu ? item.soVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soNguoi ? item.soNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.taiSanThamNhungTongTien ? item.taiSanThamNhungTongTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.taiSanThamNhungTien ? item.taiSanThamNhungTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.taiSanThamNhungTaiSanKhac ? item.taiSanThamNhungTaiSanKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.taiSanThamNhungDat ? item.taiSanThamNhungDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTongTien ? item.kienNghiThuHoiTongTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTien ? item.kienNghiThuHoiTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTaiSanKhac ? item.kienNghiThuHoiTaiSanKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiDat ? item.kienNghiThuHoiDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTongTien ? item.daThuTongTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTien ? item.daThuTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTaiSanKhac ? item.daThuTaiSanKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuDat ? item.daThuDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhToChuc ? item.hanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.hanhChinhCaNhan ? item.hanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraVu ? item.chuyenCoQuanDieuTraVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuyenCoQuanDieuTraDoiTuong ? item.chuyenCoQuanDieuTraDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daXuLyHanhChinhToChuc ? item.daXuLyHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daXuLyHanhChinhCaNhan ? item.daXuLyHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daKhoiToVu ? item.daKhoiToVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daKhoiToDoiTuong ? item.daKhoiToDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.xuLyTrachNhiemNguoiDungDauKienNghi ? item.xuLyTrachNhiemNguoiDungDauKienNghi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.xuLyTrachNhiemNguoiDungDauDaXuLy ? item.xuLyTrachNhiemNguoiDungDauDaXuLy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVu, onChange: this.onChange.bind(this, 'soVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoi, onChange: this.onChange.bind(this, 'soNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.taiSanThamNhungTongTien, onChange: this.onChange.bind(this, 'taiSanThamNhungTongTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.taiSanThamNhungTien, onChange: this.onChange.bind(this, 'taiSanThamNhungTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.taiSanThamNhungTaiSanKhac, onChange: this.onChange.bind(this, 'taiSanThamNhungTaiSanKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.taiSanThamNhungDat, onChange: this.onChange.bind(this, 'taiSanThamNhungDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTongTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTongTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTaiSanKhac, onChange: this.onChange.bind(this, 'kienNghiThuHoiTaiSanKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTongTien, onChange: this.onChange.bind(this, 'daThuTongTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTien, onChange: this.onChange.bind(this, 'daThuTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTaiSanKhac, onChange: this.onChange.bind(this, 'daThuTaiSanKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuDat, onChange: this.onChange.bind(this, 'daThuDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhToChuc, onChange: this.onChange.bind(this, 'hanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.hanhChinhCaNhan, onChange: this.onChange.bind(this, 'hanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraVu, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenCoQuanDieuTraDoiTuong, onChange: this.onChange.bind(this, 'chuyenCoQuanDieuTraDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXuLyHanhChinhToChuc, onChange: this.onChange.bind(this, 'daXuLyHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXuLyHanhChinhCaNhan, onChange: this.onChange.bind(this, 'daXuLyHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daKhoiToVu, onChange: this.onChange.bind(this, 'daKhoiToVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daKhoiToDoiTuong, onChange: this.onChange.bind(this, 'daKhoiToDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.xuLyTrachNhiemNguoiDungDauKienNghi, onChange: this.onChange.bind(this, 'xuLyTrachNhiemNguoiDungDauKienNghi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.xuLyTrachNhiemNguoiDungDauDaXuLy, onChange: this.onChange.bind(this, 'xuLyTrachNhiemNguoiDungDauDaXuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraThamNhung;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraThamNhung;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraXayDungCoBan = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraXayDungCoBan, _React$Component);

  function ListItemThongKeThanhTraXayDungCoBan(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraXayDungCoBan);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraXayDungCoBan.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraXayDungCoBan)).call(this, props, context));

    _this.state = {
      donVi: _this.props.item && _this.props.item.donVi ? _this.props.item.donVi : 0,
      tongSoCuocThanhTra: _this.props.item && _this.props.item.tongSoCuocThanhTra ? _this.props.item.tongSoCuocThanhTra : 0,
      kyTruocChuyenSang: _this.props.item && _this.props.item.kyTruocChuyenSang ? _this.props.item.kyTruocChuyenSang : 0,
      trienKhaiTrongKyBaoCao: _this.props.item && _this.props.item.trienKhaiTrongKyBaoCao ? _this.props.item.trienKhaiTrongKyBaoCao : 0,
      theoKeHoach: _this.props.item && _this.props.item.theoKeHoach ? _this.props.item.theoKeHoach : 0,
      dotXuat: _this.props.item && _this.props.item.dotXuat ? _this.props.item.dotXuat : 0,
      ketThucThanhTraTrucTiep: _this.props.item && _this.props.item.ketThucThanhTraTrucTiep ? _this.props.item.ketThucThanhTraTrucTiep : 0,
      daBanHanhKetLuan: _this.props.item && _this.props.item.daBanHanhKetLuan ? _this.props.item.daBanHanhKetLuan : 0,
      soDonViDuocThanhTra: _this.props.item && _this.props.item.soDonViDuocThanhTra ? _this.props.item.soDonViDuocThanhTra : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      tongViPhamTien: _this.props.item && _this.props.item.tongViPhamTien ? _this.props.item.tongViPhamTien : 0,
      tongViPhamDat: _this.props.item && _this.props.item.tongViPhamDat ? _this.props.item.tongViPhamDat : 0,
      kienNghiThuHoiTien: _this.props.item && _this.props.item.kienNghiThuHoiTien ? _this.props.item.kienNghiThuHoiTien : 0,
      kienNghiThuHoiDat: _this.props.item && _this.props.item.kienNghiThuHoiDat ? _this.props.item.kienNghiThuHoiDat : 0,
      kienNghiKhacTien: _this.props.item && _this.props.item.kienNghiKhacTien ? _this.props.item.kienNghiKhacTien : 0,
      kienNghiKhacDat: _this.props.item && _this.props.item.kienNghiKhacDat ? _this.props.item.kienNghiKhacDat : 0,
      kienNghiXLHanhChinhToChuc: _this.props.item && _this.props.item.kienNghiXLHanhChinhToChuc ? _this.props.item.kienNghiXLHanhChinhToChuc : 0,
      kienNghiXLHanhChinhCaNhan: _this.props.item && _this.props.item.kienNghiXLHanhChinhCaNhan ? _this.props.item.kienNghiXLHanhChinhCaNhan : 0,
      kienNghiXLVu: _this.props.item && _this.props.item.kienNghiXLVu ? _this.props.item.kienNghiXLVu : 0,
      kienNghiXLDoiTuong: _this.props.item && _this.props.item.kienNghiXLDoiTuong ? _this.props.item.kienNghiXLDoiTuong : 0,
      daThuTien: _this.props.item && _this.props.item.daThuTien ? _this.props.item.daThuTien : 0,
      daThuDat: _this.props.item && _this.props.item.daThuDat ? _this.props.item.daThuDat : 0,
      tongSoKLTTVaQDXLDaKTDD: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKTDD ? _this.props.item.tongSoKLTTVaQDXLDaKTDD : 0,
      ketQuaKiemTraDonDocTienPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienPhaiThu ? _this.props.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
      ketQuaKiemTraDonDocTienDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocTienDaThu ? _this.props.item.ketQuaKiemTraDonDocTienDaThu : 0,
      ketQuaKiemTraDonDocDatPhaiThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatPhaiThu ? _this.props.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
      ketQuaKiemTraDonDocDatDaThu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDatDaThu ? _this.props.item.ketQuaKiemTraDonDocDatDaThu : 0,
      ketQuaKiemTraDonDocDaXuLyHCToChuc: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
      ketQuaKiemTraDonDocDaXuLyHCCaNhan: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
      ketQuaKiemTraDonDocDaKhoiToVu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
      ketQuaKiemTraDonDocDaKhoiToDoiTuong: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraXayDungCoBan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        donVi: nextProps.item && nextProps.item.donVi ? nextProps.item.donVi : 0,
        tongSoCuocThanhTra: nextProps.item && nextProps.item.tongSoCuocThanhTra ? nextProps.item.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: nextProps.item && nextProps.item.kyTruocChuyenSang ? nextProps.item.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: nextProps.item && nextProps.item.trienKhaiTrongKyBaoCao ? nextProps.item.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: nextProps.item && nextProps.item.theoKeHoach ? nextProps.item.theoKeHoach : 0,
        dotXuat: nextProps.item && nextProps.item.dotXuat ? nextProps.item.dotXuat : 0,
        ketThucThanhTraTrucTiep: nextProps.item && nextProps.item.ketThucThanhTraTrucTiep ? nextProps.item.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: nextProps.item && nextProps.item.daBanHanhKetLuan ? nextProps.item.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: nextProps.item && nextProps.item.soDonViDuocThanhTra ? nextProps.item.soDonViDuocThanhTra : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        tongViPhamTien: nextProps.item && nextProps.item.tongViPhamTien ? nextProps.item.tongViPhamTien : 0,
        tongViPhamDat: nextProps.item && nextProps.item.tongViPhamDat ? nextProps.item.tongViPhamDat : 0,
        kienNghiThuHoiTien: nextProps.item && nextProps.item.kienNghiThuHoiTien ? nextProps.item.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: nextProps.item && nextProps.item.kienNghiThuHoiDat ? nextProps.item.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: nextProps.item && nextProps.item.kienNghiKhacTien ? nextProps.item.kienNghiKhacTien : 0,
        kienNghiKhacDat: nextProps.item && nextProps.item.kienNghiKhacDat ? nextProps.item.kienNghiKhacDat : 0,
        kienNghiXLHanhChinhToChuc: nextProps.item && nextProps.item.kienNghiXLHanhChinhToChuc ? nextProps.item.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: nextProps.item && nextProps.item.kienNghiXLHanhChinhCaNhan ? nextProps.item.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXLVu: nextProps.item && nextProps.item.kienNghiXLVu ? nextProps.item.kienNghiXLVu : 0,
        kienNghiXLDoiTuong: nextProps.item && nextProps.item.kienNghiXLDoiTuong ? nextProps.item.kienNghiXLDoiTuong : 0,
        daThuTien: nextProps.item && nextProps.item.daThuTien ? nextProps.item.daThuTien : 0,
        daThuDat: nextProps.item && nextProps.item.daThuDat ? nextProps.item.daThuDat : 0,
        tongSoKLTTVaQDXLDaKTDD: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKTDD ? nextProps.item.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienPhaiThu ? nextProps.item.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocTienDaThu ? nextProps.item.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatPhaiThu ? nextProps.item.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDatDaThu ? nextProps.item.ketQuaKiemTraDonDocDatDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoCuocThanhTra: this.state.tongSoCuocThanhTra ? this.state.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: this.state.trienKhaiTrongKyBaoCao ? this.state.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: this.state.theoKeHoach ? this.state.theoKeHoach : 0,
        dotXuat: this.state.dotXuat ? this.state.dotXuat : 0,
        ketThucThanhTraTrucTiep: this.state.ketThucThanhTraTrucTiep ? this.state.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: this.state.daBanHanhKetLuan ? this.state.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: this.state.soDonViDuocThanhTra ? this.state.soDonViDuocThanhTra : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        tongViPhamTien: this.state.tongViPhamTien ? this.state.tongViPhamTien : 0,
        tongViPhamDat: this.state.tongViPhamDat ? this.state.tongViPhamDat : 0,
        kienNghiThuHoiTien: this.state.kienNghiThuHoiTien ? this.state.kienNghiThuHoiTien : 0,
        kienNghiThuHoiDat: this.state.kienNghiThuHoiDat ? this.state.kienNghiThuHoiDat : 0,
        kienNghiKhacTien: this.state.kienNghiKhacTien ? this.state.kienNghiKhacTien : 0,
        kienNghiKhacDat: this.state.kienNghiKhacDat ? this.state.kienNghiKhacDat : 0,
        kienNghiXLHanhChinhToChuc: this.state.kienNghiXLHanhChinhToChuc ? this.state.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: this.state.kienNghiXLHanhChinhCaNhan ? this.state.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXLVu: this.state.kienNghiXLVu ? this.state.kienNghiXLVu : 0,
        kienNghiXLDoiTuong: this.state.kienNghiXLDoiTuong ? this.state.kienNghiXLDoiTuong : 0,
        daThuTien: this.state.daThuTien ? this.state.daThuTien : 0,
        daThuDat: this.state.daThuDat ? this.state.daThuDat : 0,
        tongSoKLTTVaQDXLDaKTDD: this.state.tongSoKLTTVaQDXLDaKTDD ? this.state.tongSoKLTTVaQDXLDaKTDD : 0,
        ketQuaKiemTraDonDocTienPhaiThu: this.state.ketQuaKiemTraDonDocTienPhaiThu ? this.state.ketQuaKiemTraDonDocTienPhaiThu : 0,
        ketQuaKiemTraDonDocTienDaThu: this.state.ketQuaKiemTraDonDocTienDaThu ? this.state.ketQuaKiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDatPhaiThu: this.state.ketQuaKiemTraDonDocDatPhaiThu ? this.state.ketQuaKiemTraDonDocDatPhaiThu : 0,
        ketQuaKiemTraDonDocDatDaThu: this.state.ketQuaKiemTraDonDocDatDaThu ? this.state.ketQuaKiemTraDonDocDatDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc ? this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: this.state.ketQuaKiemTraDonDocDaKhoiToVu ? this.state.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoCuocThanhTra ? item.tongSoCuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kyTruocChuyenSang ? item.kyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.trienKhaiTrongKyBaoCao ? item.trienKhaiTrongKyBaoCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.theoKeHoach ? item.theoKeHoach : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.dotXuat ? item.dotXuat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketThucThanhTraTrucTiep ? item.ketThucThanhTraTrucTiep : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daBanHanhKetLuan ? item.daBanHanhKetLuan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViDuocThanhTra ? item.soDonViDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamTien ? item.tongViPhamTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.tongViPhamDat ? item.tongViPhamDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiTien ? item.kienNghiThuHoiTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiThuHoiDat ? item.kienNghiThuHoiDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacTien ? item.kienNghiKhacTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhacDat ? item.kienNghiKhacDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhToChuc ? item.kienNghiXLHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhCaNhan ? item.kienNghiXLHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLVu ? item.kienNghiXLVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLDoiTuong ? item.kienNghiXLDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuTien ? item.daThuTien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.daThuDat ? item.daThuDat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoKLTTVaQDXLDaKTDD ? item.tongSoKLTTVaQDXLDaKTDD : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienPhaiThu ? item.ketQuaKiemTraDonDocTienPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocTienDaThu ? item.ketQuaKiemTraDonDocTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatPhaiThu ? item.ketQuaKiemTraDonDocDatPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.ketQuaKiemTraDonDocDatDaThu ? item.ketQuaKiemTraDonDocDatDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? item.ketQuaKiemTraDonDocDaXuLyHCToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToVu ? item.ketQuaKiemTraDonDocDaKhoiToVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoCuocThanhTra, onChange: this.onChange.bind(this, 'tongSoCuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kyTruocChuyenSang, onChange: this.onChange.bind(this, 'kyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.trienKhaiTrongKyBaoCao, onChange: this.onChange.bind(this, 'trienKhaiTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.theoKeHoach, onChange: this.onChange.bind(this, 'theoKeHoach') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.dotXuat, onChange: this.onChange.bind(this, 'dotXuat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketThucThanhTraTrucTiep, onChange: this.onChange.bind(this, 'ketThucThanhTraTrucTiep') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daBanHanhKetLuan, onChange: this.onChange.bind(this, 'daBanHanhKetLuan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViDuocThanhTra, onChange: this.onChange.bind(this, 'soDonViDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamTien, onChange: this.onChange.bind(this, 'tongViPhamTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongViPhamDat, onChange: this.onChange.bind(this, 'tongViPhamDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiTien, onChange: this.onChange.bind(this, 'kienNghiThuHoiTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiThuHoiDat, onChange: this.onChange.bind(this, 'kienNghiThuHoiDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacTien, onChange: this.onChange.bind(this, 'kienNghiKhacTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhacDat, onChange: this.onChange.bind(this, 'kienNghiKhacDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhToChuc, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhCaNhan, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLVu, onChange: this.onChange.bind(this, 'kienNghiXLVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLDoiTuong, onChange: this.onChange.bind(this, 'kienNghiXLDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuTien, onChange: this.onChange.bind(this, 'daThuTien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daThuDat, onChange: this.onChange.bind(this, 'daThuDat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKTDD, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKTDD') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocTienDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatPhaiThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDatDaThu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDatDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToVu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraXayDungCoBan;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraXayDungCoBan;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraXayTaiChinhNganSach = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraXayTaiChinhNganSach, _React$Component);

  function ListItemThongKeThanhTraXayTaiChinhNganSach(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraXayTaiChinhNganSach);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraXayTaiChinhNganSach.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraXayTaiChinhNganSach)).call(this, props, context));

    _this.state = {
      donVi: _this.props.item && _this.props.item.donVi ? _this.props.item.donVi : '',
      tongSoCuocThanhTra: _this.props.item && _this.props.item.tongSoCuocThanhTra ? _this.props.item.tongSoCuocThanhTra : 0,
      kyTruocChuyenSang: _this.props.item && _this.props.item.kyTruocChuyenSang ? _this.props.item.kyTruocChuyenSang : 0,
      trienKhaiTrongKyBaoCao: _this.props.item && _this.props.item.trienKhaiTrongKyBaoCao ? _this.props.item.trienKhaiTrongKyBaoCao : 0,
      theoKeHoach: _this.props.item && _this.props.item.theoKeHoach ? _this.props.item.theoKeHoach : 0,
      dotXuat: _this.props.item && _this.props.item.dotXuat ? _this.props.item.dotXuat : 0,
      ketThucThanhTraTrucTiep: _this.props.item && _this.props.item.ketThucThanhTraTrucTiep ? _this.props.item.ketThucThanhTraTrucTiep : 0,
      daBanHanhKetLuan: _this.props.item && _this.props.item.daBanHanhKetLuan ? _this.props.item.daBanHanhKetLuan : 0,
      soDonViDuocThanhTra: _this.props.item && _this.props.item.soDonViDuocThanhTra ? _this.props.item.soDonViDuocThanhTra : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      soTienViPham: _this.props.item && _this.props.item.soTienViPham ? _this.props.item.soTienViPham : 0,
      soTienKienNghiThuHoi: _this.props.item && _this.props.item.soTienKienNghiThuHoi ? _this.props.item.soTienKienNghiThuHoi : 0,
      kienNghiKhac: _this.props.item && _this.props.item.kienNghiKhac ? _this.props.item.kienNghiKhac : 0,
      kienNghiXLHanhChinhToChuc: _this.props.item && _this.props.item.kienNghiXLHanhChinhToChuc ? _this.props.item.kienNghiXLHanhChinhToChuc : 0,
      kienNghiXLHanhChinhCaNhan: _this.props.item && _this.props.item.kienNghiXLHanhChinhCaNhan ? _this.props.item.kienNghiXLHanhChinhCaNhan : 0,
      kienNghiXuLyVu: _this.props.item && _this.props.item.kienNghiXuLyVu ? _this.props.item.kienNghiXuLyVu : 0,
      kienNghiXuLyDoiTuong: _this.props.item && _this.props.item.kienNghiXuLyDoiTuong ? _this.props.item.kienNghiXuLyDoiTuong : 0,
      soTienDaThu: _this.props.item && _this.props.item.soTienDaThu ? _this.props.item.soTienDaThu : 0,
      tongSoKLTTVaQDXLDaKTDD: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKTDD ? _this.props.item.tongSoKLTTVaQDXLDaKTDD : 0,
      kiemTraDonDocTienPhaiThu: _this.props.item && _this.props.item.kiemTraDonDocTienPhaiThu ? _this.props.item.kiemTraDonDocTienPhaiThu : 0,
      kiemTraDonDocTienDaThu: _this.props.item && _this.props.item.kiemTraDonDocTienDaThu ? _this.props.item.kiemTraDonDocTienDaThu : 0,
      ketQuaKiemTraDonDocDaXuLyHCToChuc: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
      ketQuaKiemTraDonDocDaXuLyHCCaNhan: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? _this.props.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
      ketQuaKiemTraDonDocDaKhoiToVu: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
      ketQuaKiemTraDonDocDaKhoiToDoiTuong: _this.props.item && _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? _this.props.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeThanhTraXayTaiChinhNganSach, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        donVi: nextProps.item && nextProps.item.donVi ? nextProps.item.donVi : '',
        tongSoCuocThanhTra: nextProps.item && nextProps.item.tongSoCuocThanhTra ? nextProps.item.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: nextProps.item && nextProps.item.kyTruocChuyenSang ? nextProps.item.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: nextProps.item && nextProps.item.trienKhaiTrongKyBaoCao ? nextProps.item.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: nextProps.item && nextProps.item.theoKeHoach ? nextProps.item.theoKeHoach : 0,
        dotXuat: nextProps.item && nextProps.item.dotXuat ? nextProps.item.dotXuat : 0,
        ketThucThanhTraTrucTiep: nextProps.item && nextProps.item.ketThucThanhTraTrucTiep ? nextProps.item.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: nextProps.item && nextProps.item.daBanHanhKetLuan ? nextProps.item.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: nextProps.item && nextProps.item.soDonViDuocThanhTra ? nextProps.item.soDonViDuocThanhTra : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        soTienViPham: nextProps.item && nextProps.item.soTienViPham ? nextProps.item.soTienViPham : 0,
        soTienKienNghiThuHoi: nextProps.item && nextProps.item.soTienKienNghiThuHoi ? nextProps.item.soTienKienNghiThuHoi : 0,
        kienNghiKhac: nextProps.item && nextProps.item.kienNghiKhac ? nextProps.item.kienNghiKhac : 0,
        kienNghiXLHanhChinhToChuc: nextProps.item && nextProps.item.kienNghiXLHanhChinhToChuc ? nextProps.item.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: nextProps.item && nextProps.item.kienNghiXLHanhChinhCaNhan ? nextProps.item.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXuLyVu: nextProps.item && nextProps.item.kienNghiXuLyVu ? nextProps.item.kienNghiXuLyVu : 0,
        kienNghiXuLyDoiTuong: nextProps.item && nextProps.item.kienNghiXuLyDoiTuong ? nextProps.item.kienNghiXuLyDoiTuong : 0,
        soTienDaThu: nextProps.item && nextProps.item.soTienDaThu ? nextProps.item.soTienDaThu : 0,
        tongSoKLTTVaQDXLDaKTDD: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKTDD ? nextProps.item.tongSoKLTTVaQDXLDaKTDD : 0,
        kiemTraDonDocTienPhaiThu: nextProps.item && nextProps.item.kiemTraDonDocTienPhaiThu ? nextProps.item.kiemTraDonDocTienPhaiThu : 0,
        kiemTraDonDocTienDaThu: nextProps.item && nextProps.item.kiemTraDonDocTienDaThu ? nextProps.item.kiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? nextProps.item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: nextProps.item && nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? nextProps.item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoCuocThanhTra: this.state.tongSoCuocThanhTra ? this.state.tongSoCuocThanhTra : 0,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : 0,
        trienKhaiTrongKyBaoCao: this.state.trienKhaiTrongKyBaoCao ? this.state.trienKhaiTrongKyBaoCao : 0,
        theoKeHoach: this.state.theoKeHoach ? this.state.theoKeHoach : 0,
        dotXuat: this.state.dotXuat ? this.state.dotXuat : 0,
        ketThucThanhTraTrucTiep: this.state.ketThucThanhTraTrucTiep ? this.state.ketThucThanhTraTrucTiep : 0,
        daBanHanhKetLuan: this.state.daBanHanhKetLuan ? this.state.daBanHanhKetLuan : 0,
        soDonViDuocThanhTra: this.state.soDonViDuocThanhTra ? this.state.soDonViDuocThanhTra : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        soTienViPham: this.state.soTienViPham ? this.state.soTienViPham : 0,
        soTienKienNghiThuHoi: this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0,
        kienNghiKhac: this.state.kienNghiKhac ? this.state.kienNghiKhac : 0,
        kienNghiXLHanhChinhToChuc: this.state.kienNghiXLHanhChinhToChuc ? this.state.kienNghiXLHanhChinhToChuc : 0,
        kienNghiXLHanhChinhCaNhan: this.state.kienNghiXLHanhChinhCaNhan ? this.state.kienNghiXLHanhChinhCaNhan : 0,
        kienNghiXuLyVu: this.state.kienNghiXuLyVu ? this.state.kienNghiXuLyVu : 0,
        kienNghiXuLyDoiTuong: this.state.kienNghiXuLyDoiTuong ? this.state.kienNghiXuLyDoiTuong : 0,
        soTienDaThu: this.state.soTienDaThu ? this.state.soTienDaThu : 0,
        tongSoKLTTVaQDXLDaKTDD: this.state.tongSoKLTTVaQDXLDaKTDD ? this.state.tongSoKLTTVaQDXLDaKTDD : 0,
        kiemTraDonDocTienPhaiThu: this.state.kiemTraDonDocTienPhaiThu ? this.state.kiemTraDonDocTienPhaiThu : 0,
        kiemTraDonDocTienDaThu: this.state.kiemTraDonDocTienDaThu ? this.state.kiemTraDonDocTienDaThu : 0,
        ketQuaKiemTraDonDocDaXuLyHCToChuc: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc ? this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc : 0,
        ketQuaKiemTraDonDocDaXuLyHCCaNhan: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan : 0,
        ketQuaKiemTraDonDocDaKhoiToVu: this.state.ketQuaKiemTraDonDocDaKhoiToVu ? this.state.ketQuaKiemTraDonDocDaKhoiToVu : 0,
        ketQuaKiemTraDonDocDaKhoiToDoiTuong: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoCuocThanhTra ? item.tongSoCuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kyTruocChuyenSang ? item.kyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.trienKhaiTrongKyBaoCao ? item.trienKhaiTrongKyBaoCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.theoKeHoach ? item.theoKeHoach : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.dotXuat ? item.dotXuat : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketThucThanhTraTrucTiep ? item.ketThucThanhTraTrucTiep : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daBanHanhKetLuan ? item.daBanHanhKetLuan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViDuocThanhTra ? item.soDonViDuocThanhTra : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienViPham ? item.soTienViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienKienNghiThuHoi ? item.soTienKienNghiThuHoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kienNghiKhac ? item.kienNghiKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhToChuc ? item.kienNghiXLHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXLHanhChinhCaNhan ? item.kienNghiXLHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXuLyVu ? item.kienNghiXuLyVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.kienNghiXuLyDoiTuong ? item.kienNghiXuLyDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.soTienDaThu ? item.soTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoKLTTVaQDXLDaKTDD ? item.tongSoKLTTVaQDXLDaKTDD : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kiemTraDonDocTienPhaiThu ? item.kiemTraDonDocTienPhaiThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            item.kiemTraDonDocTienDaThu ? item.kiemTraDonDocTienDaThu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCToChuc ? item.ketQuaKiemTraDonDocDaXuLyHCToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaXuLyHCCaNhan ? item.ketQuaKiemTraDonDocDaXuLyHCCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToVu ? item.ketQuaKiemTraDonDocDaKhoiToVu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.ketQuaKiemTraDonDocDaKhoiToDoiTuong ? item.ketQuaKiemTraDonDocDaKhoiToDoiTuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoCuocThanhTra, onChange: this.onChange.bind(this, 'tongSoCuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kyTruocChuyenSang, onChange: this.onChange.bind(this, 'kyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.trienKhaiTrongKyBaoCao, onChange: this.onChange.bind(this, 'trienKhaiTrongKyBaoCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.theoKeHoach, onChange: this.onChange.bind(this, 'theoKeHoach') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.dotXuat, onChange: this.onChange.bind(this, 'dotXuat') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketThucThanhTraTrucTiep, onChange: this.onChange.bind(this, 'ketThucThanhTraTrucTiep') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daBanHanhKetLuan, onChange: this.onChange.bind(this, 'daBanHanhKetLuan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViDuocThanhTra, onChange: this.onChange.bind(this, 'soDonViDuocThanhTra') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienViPham, onChange: this.onChange.bind(this, 'soTienViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienKienNghiThuHoi, onChange: this.onChange.bind(this, 'soTienKienNghiThuHoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiKhac, onChange: this.onChange.bind(this, 'kienNghiKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhToChuc, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXLHanhChinhCaNhan, onChange: this.onChange.bind(this, 'kienNghiXLHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyVu, onChange: this.onChange.bind(this, 'kienNghiXuLyVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyDoiTuong, onChange: this.onChange.bind(this, 'kienNghiXuLyDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTienDaThu, onChange: this.onChange.bind(this, 'soTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKTDD, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKTDD') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kiemTraDonDocTienPhaiThu, onChange: this.onChange.bind(this, 'kiemTraDonDocTienPhaiThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-right' },
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kiemTraDonDocTienDaThu, onChange: this.onChange.bind(this, 'kiemTraDonDocTienDaThu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCToChuc, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaXuLyHCCaNhan, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaXuLyHCCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToVu, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToVu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKiemTraDonDocDaKhoiToDoiTuong, onChange: this.onChange.bind(this, 'ketQuaKiemTraDonDocDaKhoiToDoiTuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraXayTaiChinhNganSach;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraXayTaiChinhNganSach;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeTiepCongDan = function (_React$Component) {
  _inherits(ListItemThongKeTiepCongDan, _React$Component);

  function ListItemThongKeTiepCongDan(props, context) {
    _classCallCheck(this, ListItemThongKeTiepCongDan);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeTiepCongDan.__proto__ || Object.getPrototypeOf(ListItemThongKeTiepCongDan)).call(this, props, context));

    _this.state = {
      tenDonVi: _this.props.item && _this.props.item.tenDonVi ? _this.props.item.tenDonVi : '',
      tiepCongDanThuongXuyenLuot: _this.props.item && _this.props.item.tiepCongDanThuongXuyenLuot ? _this.props.item.tiepCongDanThuongXuyenLuot : 0,
      tiepCongDanThuongXuyenNguoi: _this.props.item && _this.props.item.tiepCongDanThuongXuyenNguoi ? _this.props.item.tiepCongDanThuongXuyenNguoi : 0,
      tiepCongDanThuongXuyenVuViecCu: _this.props.item && _this.props.item.tiepCongDanThuongXuyenVuViecCu ? _this.props.item.tiepCongDanThuongXuyenVuViecCu : 0,
      tiepCongDanThuongXuyenVuViecMoiPhatSinh: _this.props.item && _this.props.item.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? _this.props.item.tiepCongDanThuongXuyenVuViecMoiPhatSinh : 0,
      tiepCongDanThuongXuyenDoanDongNguoiSoDoan: _this.props.item && _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : 0,
      tiepCongDanThuongXuyenDoanDongNguoiSoNguoi: _this.props.item && _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : 0,
      tiepCongDanThuongXuyenDoanDongNguoiVuViecCu: _this.props.item && _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : 0,
      tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh: _this.props.item && _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? _this.props.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoLuot: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : 0,
      tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh: _this.props.item && _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? _this.props.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : 0,
      tongVuViecDonKhieuNaiLinhVucHanhChinh: _this.props.item && _this.props.item.tongVuViecDonKhieuNaiLinhVucHanhChinh ? _this.props.item.tongVuViecDonKhieuNaiLinhVucHanhChinh : 0,
      donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: _this.props.item && _this.props.item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? _this.props.item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
      donKhieuNaiLinhVucHanhChinhVeNhaTaiSan: _this.props.item && _this.props.item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? _this.props.item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : 0,
      donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC: _this.props.item && _this.props.item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? _this.props.item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : 0,
      donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac: _this.props.item && _this.props.item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? _this.props.item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : 0,
      donKhieuNaiLinhVucTuPhap: _this.props.item && _this.props.item.donKhieuNaiLinhVucTuPhap ? _this.props.item.donKhieuNaiLinhVucTuPhap : 0,
      donKhieuNaiLinhVucVeDang: _this.props.item && _this.props.item.donKhieuNaiLinhVucVeDang ? _this.props.item.donKhieuNaiLinhVucVeDang : 0,
      tongVuViecDonToCao: _this.props.item && _this.props.item.tongVuViecDonToCao ? _this.props.item.tongVuViecDonToCao : 0,
      donToCaoLinhVucHanhChinh: _this.props.item && _this.props.item.donToCaoLinhVucHanhChinh ? _this.props.item.donToCaoLinhVucHanhChinh : 0,
      donToCaoLinhVucTuPhap: _this.props.item && _this.props.item.donToCaoLinhVucTuPhap ? _this.props.item.donToCaoLinhVucTuPhap : 0,
      donToCaoLinhVucThamNhung: _this.props.item && _this.props.item.donToCaoLinhVucThamNhung ? _this.props.item.donToCaoLinhVucThamNhung : 0,
      donToCaoLinhVucVeDang: _this.props.item && _this.props.item.donToCaoLinhVucVeDang ? _this.props.item.donToCaoLinhVucVeDang : 0,
      donToCaoLinhVucKhac: _this.props.item && _this.props.item.donToCaoLinhVucKhac ? _this.props.item.donToCaoLinhVucKhac : 0,
      phanAnhKienNghiKhac: _this.props.item && _this.props.item.phanAnhKienNghiKhac ? _this.props.item.phanAnhKienNghiKhac : 0,
      chuaDuocGiaiQuyet: _this.props.item && _this.props.item.chuaDuocGiaiQuyet ? _this.props.item.chuaDuocGiaiQuyet : 0,
      chuaCoQuyetDinhGiaiQuyet: _this.props.item && _this.props.item.chuaCoQuyetDinhGiaiQuyet ? _this.props.item.chuaCoQuyetDinhGiaiQuyet : 0,
      daCoQuyetDinhGiaiQuyet: _this.props.item && _this.props.item.daCoQuyetDinhGiaiQuyet ? _this.props.item.daCoQuyetDinhGiaiQuyet : 0,
      daCoBanAnCuaToa: _this.props.item && _this.props.item.daCoBanAnCuaToa ? _this.props.item.daCoBanAnCuaToa : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeTiepCongDan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        tenDonVi: nextProps.item && nextProps.item.tenDonVi ? nextProps.item.tenDonVi : '',
        tiepCongDanThuongXuyenLuot: nextProps.item && nextProps.item.tiepCongDanThuongXuyenLuot ? nextProps.item.tiepCongDanThuongXuyenLuot : 0,
        tiepCongDanThuongXuyenNguoi: nextProps.item && nextProps.item.tiepCongDanThuongXuyenNguoi ? nextProps.item.tiepCongDanThuongXuyenNguoi : 0,
        tiepCongDanThuongXuyenVuViecCu: nextProps.item && nextProps.item.tiepCongDanThuongXuyenVuViecCu ? nextProps.item.tiepCongDanThuongXuyenVuViecCu : 0,
        tiepCongDanThuongXuyenVuViecMoiPhatSinh: nextProps.item && nextProps.item.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? nextProps.item.tiepCongDanThuongXuyenVuViecMoiPhatSinh : 0,
        tiepCongDanThuongXuyenDoanDongNguoiSoDoan: nextProps.item && nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : 0,
        tiepCongDanThuongXuyenDoanDongNguoiSoNguoi: nextProps.item && nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : 0,
        tiepCongDanThuongXuyenDoanDongNguoiVuViecCu: nextProps.item && nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : 0,
        tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh: nextProps.item && nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? nextProps.item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoLuot: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh: nextProps.item && nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? nextProps.item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : 0,
        tongVuViecDonKhieuNaiLinhVucHanhChinh: nextProps.item && nextProps.item.tongVuViecDonKhieuNaiLinhVucHanhChinh ? nextProps.item.tongVuViecDonKhieuNaiLinhVucHanhChinh : 0,
        donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: nextProps.item && nextProps.item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? nextProps.item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
        donKhieuNaiLinhVucHanhChinhVeNhaTaiSan: nextProps.item && nextProps.item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? nextProps.item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : 0,
        donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC: nextProps.item && nextProps.item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? nextProps.item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : 0,
        donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac: nextProps.item && nextProps.item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? nextProps.item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : 0,
        donKhieuNaiLinhVucTuPhap: nextProps.item && nextProps.item.donKhieuNaiLinhVucTuPhap ? nextProps.item.donKhieuNaiLinhVucTuPhap : 0,
        donKhieuNaiLinhVucVeDang: nextProps.item && nextProps.item.donKhieuNaiLinhVucVeDang ? nextProps.item.donKhieuNaiLinhVucVeDang : 0,
        tongVuViecDonToCao: nextProps.item && nextProps.item.tongVuViecDonToCao ? nextProps.item.tongVuViecDonToCao : 0,
        donToCaoLinhVucHanhChinh: nextProps.item && nextProps.item.donToCaoLinhVucHanhChinh ? nextProps.item.donToCaoLinhVucHanhChinh : 0,
        donToCaoLinhVucTuPhap: nextProps.item && nextProps.item.donToCaoLinhVucTuPhap ? nextProps.item.donToCaoLinhVucTuPhap : 0,
        donToCaoLinhVucThamNhung: nextProps.item && nextProps.item.donToCaoLinhVucThamNhung ? nextProps.item.donToCaoLinhVucThamNhung : 0,
        donToCaoLinhVucVeDang: nextProps.item && nextProps.item.donToCaoLinhVucVeDang ? nextProps.item.donToCaoLinhVucVeDang : 0,
        donToCaoLinhVucKhac: nextProps.item && nextProps.item.donToCaoLinhVucKhac ? nextProps.item.donToCaoLinhVucKhac : 0,
        phanAnhKienNghiKhac: nextProps.item && nextProps.item.phanAnhKienNghiKhac ? nextProps.item.phanAnhKienNghiKhac : 0,
        chuaDuocGiaiQuyet: nextProps.item && nextProps.item.chuaDuocGiaiQuyet ? nextProps.item.chuaDuocGiaiQuyet : 0,
        chuaCoQuyetDinhGiaiQuyet: nextProps.item && nextProps.item.chuaCoQuyetDinhGiaiQuyet ? nextProps.item.chuaCoQuyetDinhGiaiQuyet : 0,
        daCoQuyetDinhGiaiQuyet: nextProps.item && nextProps.item.daCoQuyetDinhGiaiQuyet ? nextProps.item.daCoQuyetDinhGiaiQuyet : 0,
        daCoBanAnCuaToa: nextProps.item && nextProps.item.daCoBanAnCuaToa ? nextProps.item.daCoBanAnCuaToa : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tiepCongDanThuongXuyenLuot: this.state.tiepCongDanThuongXuyenLuot ? this.state.tiepCongDanThuongXuyenLuot : 0,
        tiepCongDanThuongXuyenNguoi: this.state.tiepCongDanThuongXuyenNguoi ? this.state.tiepCongDanThuongXuyenNguoi : 0,
        tiepCongDanThuongXuyenVuViecCu: this.state.tiepCongDanThuongXuyenVuViecCu ? this.state.tiepCongDanThuongXuyenVuViecCu : 0,
        tiepCongDanThuongXuyenVuViecMoiPhatSinh: this.state.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? this.state.tiepCongDanThuongXuyenVuViecMoiPhatSinh : 0,
        tiepCongDanThuongXuyenDoanDongNguoiSoDoan: this.state.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? this.state.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : 0,
        tiepCongDanThuongXuyenDoanDongNguoiSoNguoi: this.state.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? this.state.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : 0,
        tiepCongDanThuongXuyenDoanDongNguoiVuViecCu: this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : 0,
        tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh: this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoLuot: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : 0,
        tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : 0,
        tongVuViecDonKhieuNaiLinhVucHanhChinh: this.state.tongVuViecDonKhieuNaiLinhVucHanhChinh ? this.state.tongVuViecDonKhieuNaiLinhVucHanhChinh : 0,
        donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: this.state.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? this.state.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
        donKhieuNaiLinhVucHanhChinhVeNhaTaiSan: this.state.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? this.state.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : 0,
        donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC: this.state.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? this.state.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : 0,
        donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac: this.state.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? this.state.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : 0,
        donKhieuNaiLinhVucTuPhap: this.state.donKhieuNaiLinhVucTuPhap ? this.state.donKhieuNaiLinhVucTuPhap : 0,
        donKhieuNaiLinhVucVeDang: this.state.donKhieuNaiLinhVucVeDang ? this.state.donKhieuNaiLinhVucVeDang : 0,
        tongVuViecDonToCao: this.state.tongVuViecDonToCao ? this.state.tongVuViecDonToCao : 0,
        donToCaoLinhVucHanhChinh: this.state.donToCaoLinhVucHanhChinh ? this.state.donToCaoLinhVucHanhChinh : 0,
        donToCaoLinhVucTuPhap: this.state.donToCaoLinhVucTuPhap ? this.state.donToCaoLinhVucTuPhap : 0,
        donToCaoLinhVucThamNhung: this.state.donToCaoLinhVucThamNhung ? this.state.donToCaoLinhVucThamNhung : 0,
        donToCaoLinhVucVeDang: this.state.donToCaoLinhVucVeDang ? this.state.donToCaoLinhVucVeDang : 0,
        donToCaoLinhVucKhac: this.state.donToCaoLinhVucKhac ? this.state.donToCaoLinhVucKhac : 0,
        phanAnhKienNghiKhac: this.state.phanAnhKienNghiKhac ? this.state.phanAnhKienNghiKhac : 0,
        chuaDuocGiaiQuyet: this.state.chuaDuocGiaiQuyet ? this.state.chuaDuocGiaiQuyet : 0,
        chuaCoQuyetDinhGiaiQuyet: this.state.chuaCoQuyetDinhGiaiQuyet ? this.state.chuaCoQuyetDinhGiaiQuyet : 0,
        daCoQuyetDinhGiaiQuyet: this.state.daCoQuyetDinhGiaiQuyet ? this.state.daCoQuyetDinhGiaiQuyet : 0,
        daCoBanAnCuaToa: this.state.daCoBanAnCuaToa ? this.state.daCoBanAnCuaToa : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenLuot ? item.tiepCongDanThuongXuyenLuot : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenNguoi ? item.tiepCongDanThuongXuyenNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenVuViecCu ? item.tiepCongDanThuongXuyenVuViecCu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? item.tiepCongDanThuongXuyenVuViecMoiPhatSinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongVuViecDonKhieuNaiLinhVucHanhChinh ? item.tongVuViecDonKhieuNaiLinhVucHanhChinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucTuPhap ? item.donKhieuNaiLinhVucTuPhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donKhieuNaiLinhVucVeDang ? item.donKhieuNaiLinhVucVeDang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongVuViecDonToCao ? item.tongVuViecDonToCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donToCaoLinhVucHanhChinh ? item.donToCaoLinhVucHanhChinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donToCaoLinhVucTuPhap ? item.donToCaoLinhVucTuPhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donToCaoLinhVucThamNhung ? item.donToCaoLinhVucThamNhung : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donToCaoLinhVucVeDang ? item.donToCaoLinhVucVeDang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.donToCaoLinhVucKhac ? item.donToCaoLinhVucKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.phanAnhKienNghiKhac ? item.phanAnhKienNghiKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuaDuocGiaiQuyet ? item.chuaDuocGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.chuaCoQuyetDinhGiaiQuyet ? item.chuaCoQuyetDinhGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daCoQuyetDinhGiaiQuyet ? item.daCoQuyetDinhGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.daCoBanAnCuaToa ? item.daCoBanAnCuaToa : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenLuot, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenLuot') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenNguoi, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenVuViecCu, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenVuViecCu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenVuViecMoiPhatSinh, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenVuViecMoiPhatSinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenDoanDongNguoiSoDoan, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenDoanDongNguoiSoDoan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenDoanDongNguoiSoNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenDoanDongNguoiVuViecCu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh, onChange: this.onChange.bind(this, 'tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoLuot') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh, onChange: this.onChange.bind(this, 'tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongVuViecDonKhieuNaiLinhVucHanhChinh, onChange: this.onChange.bind(this, 'tongVuViecDonKhieuNaiLinhVucHanhChinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucHanhChinhVeNhaTaiSan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucTuPhap, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucTuPhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donKhieuNaiLinhVucVeDang, onChange: this.onChange.bind(this, 'donKhieuNaiLinhVucVeDang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongVuViecDonToCao, onChange: this.onChange.bind(this, 'tongVuViecDonToCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donToCaoLinhVucHanhChinh, onChange: this.onChange.bind(this, 'donToCaoLinhVucHanhChinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donToCaoLinhVucTuPhap, onChange: this.onChange.bind(this, 'donToCaoLinhVucTuPhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donToCaoLinhVucThamNhung, onChange: this.onChange.bind(this, 'donToCaoLinhVucThamNhung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donToCaoLinhVucVeDang, onChange: this.onChange.bind(this, 'donToCaoLinhVucVeDang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donToCaoLinhVucKhac, onChange: this.onChange.bind(this, 'donToCaoLinhVucKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phanAnhKienNghiKhac, onChange: this.onChange.bind(this, 'phanAnhKienNghiKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuaDuocGiaiQuyet, onChange: this.onChange.bind(this, 'chuaDuocGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuaCoQuyetDinhGiaiQuyet, onChange: this.onChange.bind(this, 'chuaCoQuyetDinhGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daCoQuyetDinhGiaiQuyet, onChange: this.onChange.bind(this, 'daCoQuyetDinhGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daCoBanAnCuaToa, onChange: this.onChange.bind(this, 'daCoBanAnCuaToa') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeTiepCongDan;
}(_react2.default.Component);

exports.default = ListItemThongKeTiepCongDan;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeXuLyDon = function (_React$Component) {
  _inherits(ListItemThongKeXuLyDon, _React$Component);

  function ListItemThongKeXuLyDon(props, context) {
    _classCallCheck(this, ListItemThongKeXuLyDon);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeXuLyDon.__proto__ || Object.getPrototypeOf(ListItemThongKeXuLyDon)).call(this, props, context));

    _this.state = {
      donVi: _this.props.item && _this.props.item.donVi ? _this.props.item.donVi : '',
      tongSoDonTiepNhanXLDTCD: _this.props.item && _this.props.item.tongSoDonTiepNhanXLDTCD ? _this.props.item.tongSoDonTiepNhanXLDTCD : 0,
      tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: _this.props.item && _this.props.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? _this.props.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
      tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: _this.props.item && _this.props.item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? _this.props.item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
      tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: _this.props.item && _this.props.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? _this.props.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
      tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: _this.props.item && _this.props.item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? _this.props.item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
      tongSoDonDuDieuKienThuLy: _this.props.item && _this.props.item.tongSoDonDuDieuKienThuLy ? _this.props.item.tongSoDonDuDieuKienThuLy : 0,
      tongSoDonKhieuNaiLinhVucHanhChinh: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinh ? _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinh : 0,
      tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
      tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : 0,
      tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : 0,
      tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? _this.props.item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : 0,
      tongSoDonKhieuNaiLinhVucTuPhap: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucTuPhap ? _this.props.item.tongSoDonKhieuNaiLinhVucTuPhap : 0,
      tongSoDonKhieuNaiLinhVucVeDang: _this.props.item && _this.props.item.tongSoDonKhieuNaiLinhVucVeDang ? _this.props.item.tongSoDonKhieuNaiLinhVucVeDang : 0,
      tongSoDonLinhVucToCao: _this.props.item && _this.props.item.tongSoDonLinhVucToCao ? _this.props.item.tongSoDonLinhVucToCao : 0,
      tongSoDonToCaoLinhVucHanhChinh: _this.props.item && _this.props.item.tongSoDonToCaoLinhVucHanhChinh ? _this.props.item.tongSoDonToCaoLinhVucHanhChinh : 0,
      tongSoDonToCaoLinhVucTuPhap: _this.props.item && _this.props.item.tongSoDonToCaoLinhVucTuPhap ? _this.props.item.tongSoDonToCaoLinhVucTuPhap : 0,
      tongSoDonToCaoLinhVucThamNhung: _this.props.item && _this.props.item.tongSoDonToCaoLinhVucThamNhung ? _this.props.item.tongSoDonToCaoLinhVucThamNhung : 0,
      tongSoDonToCaoLinhVucVeDang: _this.props.item && _this.props.item.tongSoDonToCaoLinhVucVeDang ? _this.props.item.tongSoDonToCaoLinhVucVeDang : 0,
      tongSoDonToCaoLinhVucKhac: _this.props.item && _this.props.item.tongSoDonToCaoLinhVucKhac ? _this.props.item.tongSoDonToCaoLinhVucKhac : 0,
      tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap: _this.props.item && _this.props.item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? _this.props.item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : 0,
      tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap: _this.props.item && _this.props.item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? _this.props.item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : 0,
      tongSoDonTheoTQGQCuaCoQuanDang: _this.props.item && _this.props.item.tongSoDonTheoTQGQCuaCoQuanDang ? _this.props.item.tongSoDonTheoTQGQCuaCoQuanDang : 0,
      tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet: _this.props.item && _this.props.item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? _this.props.item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : 0,
      tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet: _this.props.item && _this.props.item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? _this.props.item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : 0,
      tongSoDonXLDDonKienNghiPhanAnh: _this.props.item && _this.props.item.tongSoDonXLDDonKienNghiPhanAnh ? _this.props.item.tongSoDonXLDDonKienNghiPhanAnh : 0,
      tongSoDonXLDSoVanBanHuongDan: _this.props.item && _this.props.item.tongSoDonXLDSoVanBanHuongDan ? _this.props.item.tongSoDonXLDSoVanBanHuongDan : 0,
      tongSoDonChuyenCQCoThamQuyen: _this.props.item && _this.props.item.tongSoDonChuyenCQCoThamQuyen ? _this.props.item.tongSoDonChuyenCQCoThamQuyen : 0,
      tongSoDonCoSoCongVanDonDocViecGiaiQuyet: _this.props.item && _this.props.item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? _this.props.item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : 0,
      tongSoDonThuocThamQuyenKhieuNai: _this.props.item && _this.props.item.tongSoDonThuocThamQuyenKhieuNai ? _this.props.item.tongSoDonThuocThamQuyenKhieuNai : 0,
      tongSoDonThuocThamQuyenToCao: _this.props.item && _this.props.item.tongSoDonThuocThamQuyenToCao ? _this.props.item.tongSoDonThuocThamQuyenToCao : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : ''
    };
    return _this;
  }

  _createClass(ListItemThongKeXuLyDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        donVi: nextProps.item && nextProps.item.donVi ? nextProps.item.donVi : '',
        tongSoDonTiepNhanXLDTCD: nextProps.item && nextProps.item.tongSoDonTiepNhanXLDTCD ? nextProps.item.tongSoDonTiepNhanXLDTCD : 0,
        tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: nextProps.item && nextProps.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? nextProps.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
        tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: nextProps.item && nextProps.item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? nextProps.item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
        tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: nextProps.item && nextProps.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? nextProps.item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
        tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: nextProps.item && nextProps.item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? nextProps.item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
        tongSoDonDuDieuKienThuLy: nextProps.item && nextProps.item.tongSoDonDuDieuKienThuLy ? nextProps.item.tongSoDonDuDieuKienThuLy : 0,
        tongSoDonKhieuNaiLinhVucHanhChinh: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinh ? nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinh : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? nextProps.item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : 0,
        tongSoDonKhieuNaiLinhVucTuPhap: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucTuPhap ? nextProps.item.tongSoDonKhieuNaiLinhVucTuPhap : 0,
        tongSoDonKhieuNaiLinhVucVeDang: nextProps.item && nextProps.item.tongSoDonKhieuNaiLinhVucVeDang ? nextProps.item.tongSoDonKhieuNaiLinhVucVeDang : 0,
        tongSoDonLinhVucToCao: nextProps.item && nextProps.item.tongSoDonLinhVucToCao ? nextProps.item.tongSoDonLinhVucToCao : 0,
        tongSoDonToCaoLinhVucHanhChinh: nextProps.item && nextProps.item.tongSoDonToCaoLinhVucHanhChinh ? nextProps.item.tongSoDonToCaoLinhVucHanhChinh : 0,
        tongSoDonToCaoLinhVucTuPhap: nextProps.item && nextProps.item.tongSoDonToCaoLinhVucTuPhap ? nextProps.item.tongSoDonToCaoLinhVucTuPhap : 0,
        tongSoDonToCaoLinhVucThamNhung: nextProps.item && nextProps.item.tongSoDonToCaoLinhVucThamNhung ? nextProps.item.tongSoDonToCaoLinhVucThamNhung : 0,
        tongSoDonToCaoLinhVucVeDang: nextProps.item && nextProps.item.tongSoDonToCaoLinhVucVeDang ? nextProps.item.tongSoDonToCaoLinhVucVeDang : 0,
        tongSoDonToCaoLinhVucKhac: nextProps.item && nextProps.item.tongSoDonToCaoLinhVucKhac ? nextProps.item.tongSoDonToCaoLinhVucKhac : 0,
        tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap: nextProps.item && nextProps.item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? nextProps.item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : 0,
        tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap: nextProps.item && nextProps.item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? nextProps.item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : 0,
        tongSoDonTheoTQGQCuaCoQuanDang: nextProps.item && nextProps.item.tongSoDonTheoTQGQCuaCoQuanDang ? nextProps.item.tongSoDonTheoTQGQCuaCoQuanDang : 0,
        tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet: nextProps.item && nextProps.item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? nextProps.item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : 0,
        tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet: nextProps.item && nextProps.item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? nextProps.item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : 0,
        tongSoDonXLDDonKienNghiPhanAnh: nextProps.item && nextProps.item.tongSoDonXLDDonKienNghiPhanAnh ? nextProps.item.tongSoDonXLDDonKienNghiPhanAnh : 0,
        tongSoDonXLDSoVanBanHuongDan: nextProps.item && nextProps.item.tongSoDonXLDSoVanBanHuongDan ? nextProps.item.tongSoDonXLDSoVanBanHuongDan : 0,
        tongSoDonChuyenCQCoThamQuyen: nextProps.item && nextProps.item.tongSoDonChuyenCQCoThamQuyen ? nextProps.item.tongSoDonChuyenCQCoThamQuyen : 0,
        tongSoDonCoSoCongVanDonDocViecGiaiQuyet: nextProps.item && nextProps.item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? nextProps.item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : 0,
        tongSoDonThuocThamQuyenKhieuNai: nextProps.item && nextProps.item.tongSoDonThuocThamQuyenKhieuNai ? nextProps.item.tongSoDonThuocThamQuyenKhieuNai : 0,
        tongSoDonThuocThamQuyenToCao: nextProps.item && nextProps.item.tongSoDonThuocThamQuyenToCao ? nextProps.item.tongSoDonThuocThamQuyenToCao : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : ''
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        tongSoDonTiepNhanXLDTCD: this.state.tongSoDonTiepNhanXLDTCD ? this.state.tongSoDonTiepNhanXLDTCD : 0,
        tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
        tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy: this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0,
        tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
        tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang: this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0,
        tongSoDonDuDieuKienThuLy: this.state.tongSoDonDuDieuKienThuLy ? this.state.tongSoDonDuDieuKienThuLy : 0,
        tongSoDonKhieuNaiLinhVucHanhChinh: this.state.tongSoDonKhieuNaiLinhVucHanhChinh ? this.state.tongSoDonKhieuNaiLinhVucHanhChinh : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai: this.state.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? this.state.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan: this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC: this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : 0,
        tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac: this.state.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? this.state.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : 0,
        tongSoDonKhieuNaiLinhVucTuPhap: this.state.tongSoDonKhieuNaiLinhVucTuPhap ? this.state.tongSoDonKhieuNaiLinhVucTuPhap : 0,
        tongSoDonKhieuNaiLinhVucVeDang: this.state.tongSoDonKhieuNaiLinhVucVeDang ? this.state.tongSoDonKhieuNaiLinhVucVeDang : 0,
        tongSoDonLinhVucToCao: this.state.tongSoDonLinhVucToCao ? this.state.tongSoDonLinhVucToCao : 0,
        tongSoDonToCaoLinhVucHanhChinh: this.state.tongSoDonToCaoLinhVucHanhChinh ? this.state.tongSoDonToCaoLinhVucHanhChinh : 0,
        tongSoDonToCaoLinhVucTuPhap: this.state.tongSoDonToCaoLinhVucTuPhap ? this.state.tongSoDonToCaoLinhVucTuPhap : 0,
        tongSoDonToCaoLinhVucThamNhung: this.state.tongSoDonToCaoLinhVucThamNhung ? this.state.tongSoDonToCaoLinhVucThamNhung : 0,
        tongSoDonToCaoLinhVucVeDang: this.state.tongSoDonToCaoLinhVucVeDang ? this.state.tongSoDonToCaoLinhVucVeDang : 0,
        tongSoDonToCaoLinhVucKhac: this.state.tongSoDonToCaoLinhVucKhac ? this.state.tongSoDonToCaoLinhVucKhac : 0,
        tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap: this.state.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? this.state.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : 0,
        tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap: this.state.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? this.state.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : 0,
        tongSoDonTheoTQGQCuaCoQuanDang: this.state.tongSoDonTheoTQGQCuaCoQuanDang ? this.state.tongSoDonTheoTQGQCuaCoQuanDang : 0,
        tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet: this.state.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? this.state.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : 0,
        tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet: this.state.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? this.state.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : 0,
        tongSoDonXLDDonKienNghiPhanAnh: this.state.tongSoDonXLDDonKienNghiPhanAnh ? this.state.tongSoDonXLDDonKienNghiPhanAnh : 0,
        tongSoDonXLDSoVanBanHuongDan: this.state.tongSoDonXLDSoVanBanHuongDan ? this.state.tongSoDonXLDSoVanBanHuongDan : 0,
        tongSoDonChuyenCQCoThamQuyen: this.state.tongSoDonChuyenCQCoThamQuyen ? this.state.tongSoDonChuyenCQCoThamQuyen : 0,
        tongSoDonCoSoCongVanDonDocViecGiaiQuyet: this.state.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? this.state.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : 0,
        tongSoDonThuocThamQuyenKhieuNai: this.state.tongSoDonThuocThamQuyenKhieuNai ? this.state.tongSoDonThuocThamQuyenKhieuNai : 0,
        tongSoDonThuocThamQuyenToCao: this.state.tongSoDonThuocThamQuyenToCao ? this.state.tongSoDonThuocThamQuyenToCao : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : ''
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed txt-bold' },
            item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTiepNhanXLDTCD ? item.tongSoDonTiepNhanXLDTCD : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonDuDieuKienThuLy ? item.tongSoDonDuDieuKienThuLy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucHanhChinh ? item.tongSoDonKhieuNaiLinhVucHanhChinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucTuPhap ? item.tongSoDonKhieuNaiLinhVucTuPhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonKhieuNaiLinhVucVeDang ? item.tongSoDonKhieuNaiLinhVucVeDang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonLinhVucToCao ? item.tongSoDonLinhVucToCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCaoLinhVucHanhChinh ? item.tongSoDonToCaoLinhVucHanhChinh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCaoLinhVucTuPhap ? item.tongSoDonToCaoLinhVucTuPhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCaoLinhVucThamNhung ? item.tongSoDonToCaoLinhVucThamNhung : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCaoLinhVucVeDang ? item.tongSoDonToCaoLinhVucVeDang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonToCaoLinhVucKhac ? item.tongSoDonToCaoLinhVucKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTheoTQGQCuaCoQuanDang ? item.tongSoDonTheoTQGQCuaCoQuanDang : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonXLDDonKienNghiPhanAnh ? item.tongSoDonXLDDonKienNghiPhanAnh : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonXLDSoVanBanHuongDan ? item.tongSoDonXLDSoVanBanHuongDan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonChuyenCQCoThamQuyen ? item.tongSoDonChuyenCQCoThamQuyen : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonThuocThamQuyenKhieuNai ? item.tongSoDonThuocThamQuyenKhieuNai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item.tongSoDonThuocThamQuyenToCao ? item.tongSoDonThuocThamQuyenToCao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'column-name-fixed' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTiepNhanXLDTCD, onChange: this.onChange.bind(this, 'tongSoDonTiepNhanXLDTCD') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy, onChange: this.onChange.bind(this, 'tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy, onChange: this.onChange.bind(this, 'tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang, onChange: this.onChange.bind(this, 'tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang, onChange: this.onChange.bind(this, 'tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonDuDieuKienThuLy, onChange: this.onChange.bind(this, 'tongSoDonDuDieuKienThuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucHanhChinh, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucHanhChinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucTuPhap, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucTuPhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonKhieuNaiLinhVucVeDang, onChange: this.onChange.bind(this, 'tongSoDonKhieuNaiLinhVucVeDang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonLinhVucToCao, onChange: this.onChange.bind(this, 'tongSoDonLinhVucToCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCaoLinhVucHanhChinh, onChange: this.onChange.bind(this, 'tongSoDonToCaoLinhVucHanhChinh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCaoLinhVucTuPhap, onChange: this.onChange.bind(this, 'tongSoDonToCaoLinhVucTuPhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCaoLinhVucThamNhung, onChange: this.onChange.bind(this, 'tongSoDonToCaoLinhVucThamNhung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCaoLinhVucVeDang, onChange: this.onChange.bind(this, 'tongSoDonToCaoLinhVucVeDang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonToCaoLinhVucKhac, onChange: this.onChange.bind(this, 'tongSoDonToCaoLinhVucKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap, onChange: this.onChange.bind(this, 'tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap, onChange: this.onChange.bind(this, 'tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTheoTQGQCuaCoQuanDang, onChange: this.onChange.bind(this, 'tongSoDonTheoTQGQCuaCoQuanDang') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet, onChange: this.onChange.bind(this, 'tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet, onChange: this.onChange.bind(this, 'tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonXLDDonKienNghiPhanAnh, onChange: this.onChange.bind(this, 'tongSoDonXLDDonKienNghiPhanAnh') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonXLDSoVanBanHuongDan, onChange: this.onChange.bind(this, 'tongSoDonXLDSoVanBanHuongDan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonChuyenCQCoThamQuyen, onChange: this.onChange.bind(this, 'tongSoDonChuyenCQCoThamQuyen') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonCoSoCongVanDonDocViecGiaiQuyet, onChange: this.onChange.bind(this, 'tongSoDonCoSoCongVanDonDocViecGiaiQuyet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonThuocThamQuyenKhieuNai, onChange: this.onChange.bind(this, 'tongSoDonThuocThamQuyenKhieuNai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDonThuocThamQuyenToCao, onChange: this.onChange.bind(this, 'tongSoDonThuocThamQuyenToCao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return ListItemThongKeXuLyDon;
}(_react2.default.Component);

exports.default = ListItemThongKeXuLyDon;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemBaoCaoDinhKy = function (_React$Component) {
  _inherits(RowItemBaoCaoDinhKy, _React$Component);

  function RowItemBaoCaoDinhKy() {
    _classCallCheck(this, RowItemBaoCaoDinhKy);

    return _possibleConstructorReturn(this, (RowItemBaoCaoDinhKy.__proto__ || Object.getPrototypeOf(RowItemBaoCaoDinhKy)).apply(this, arguments));
  }

  _createClass(RowItemBaoCaoDinhKy, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thong-ke-bao-cao/bao-cao-dinh-ky-chi-tiet/' + this.props.item.baoCaoDonViId },
            this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.tenBaoCao : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.kyBaoCaoInfo : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.baoCaoTongHopInfo ? this.props.item.baoCaoTongHopInfo.namBaoCao : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.hanBaoCao ? (0, _moment2.default)(this.props.item.hanBaoCao).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.ngayGui ? (0, _moment2.default)(this.props.item.ngayGui).format('DD/MM/YYYY') : ''
        )
      );
    }
  }]);

  return RowItemBaoCaoDinhKy;
}(_react2.default.Component);

exports.default = RowItemBaoCaoDinhKy;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemBaoCaoDinhKyChiTiet = function (_React$Component) {
  _inherits(RowItemBaoCaoDinhKyChiTiet, _React$Component);

  function RowItemBaoCaoDinhKyChiTiet() {
    _classCallCheck(this, RowItemBaoCaoDinhKyChiTiet);

    return _possibleConstructorReturn(this, (RowItemBaoCaoDinhKyChiTiet.__proto__ || Object.getPrototypeOf(RowItemBaoCaoDinhKyChiTiet)).apply(this, arguments));
  }

  _createClass(RowItemBaoCaoDinhKyChiTiet, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thong-ke-bao-cao/lap-bao-cao-dinh-ky/' + this.props.item.baoCaoDonViChiTietId },
            this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.ngayNop ? (0, _moment2.default)(this.props.item.ngayNop).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : '',
          !this.props.item.soLieuMoiNhat ? _react2.default.createElement(
            _core.Popover,
            {
              interactionKind: _core.PopoverInteractionKind.HOVER,
              position: _core.Position.BOTTOM
            },
            _react2.default.createElement('span', { className: 'pt-icon-standard pt-icon-error ml10' }),
            _react2.default.createElement(
              'div',
              { className: 'popover-content' },
              'Bi\u1EC3u m\u1EABu ch\u01B0a \u0111\u01B0\u1EE3c ch\u1ED1t ',
              _react2.default.createElement('br', null),
              ' v\u1EDBi phi\xEAn b\u1EA3n m\u1EDBi nh\u1EA5t'
            )
          ) : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.props.item.listTaiLieuBaoCao.map(function (item, i) {
              if (item.required) {
                if (!_config.checkServerLive) {
                  return _react2.default.createElement(
                    'li',
                    { key: i },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile) },
                      item.tenFile
                    )
                  );
                }
                if (_config.checkServerLive) {
                  return _react2.default.createElement(
                    'li',
                    { key: i },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: function onClick() {
                          (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                        } },
                      item.tenFile
                    )
                  );
                }
              } else {
                return null;
              }
            })
          )
        )
      );
    }
  }]);

  return RowItemBaoCaoDinhKyChiTiet;
}(_react2.default.Component);

exports.default = RowItemBaoCaoDinhKyChiTiet;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCongTacQuanLyNhaNuoc = function (_React$Component) {
  _inherits(RowItemCongTacQuanLyNhaNuoc, _React$Component);

  function RowItemCongTacQuanLyNhaNuoc(props, context) {
    _classCallCheck(this, RowItemCongTacQuanLyNhaNuoc);

    var _this = _possibleConstructorReturn(this, (RowItemCongTacQuanLyNhaNuoc.__proto__ || Object.getPrototypeOf(RowItemCongTacQuanLyNhaNuoc)).call(this, props, context));

    _this.state = {
      daXLHanhChinhCaNhan: _this.props.item && _this.props.item.daXLHanhChinhCaNhan ? _this.props.item.daXLHanhChinhCaNhan : 0,
      daXLHanhChinhToChuc: _this.props.item && _this.props.item.daXLHanhChinhToChuc ? _this.props.item.daXLHanhChinhToChuc : 0,
      ketQuaKTDaKiemDiemRutKNCaNhan: _this.props.item && _this.props.item.ketQuaKTDaKiemDiemRutKNCaNhan ? _this.props.item.ketQuaKTDaKiemDiemRutKNCaNhan : 0,
      ketQuaKTDaKiemDiemRutKNToChuc: _this.props.item && _this.props.item.ketQuaKTDaKiemDiemRutKNToChuc ? _this.props.item.ketQuaKTDaKiemDiemRutKNToChuc : 0,
      kienNghiXuLyHanhChinhCaNhan: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhCaNhan ? _this.props.item.kienNghiXuLyHanhChinhCaNhan : 0,
      kienNghiXuLyHanhChinhToChuc: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhToChuc ? _this.props.item.kienNghiXuLyHanhChinhToChuc : 0,
      kienNghiXuLyKiemDiemRutKNCaNhan: _this.props.item && _this.props.item.kienNghiXuLyKiemDiemRutKNCaNhan ? _this.props.item.kienNghiXuLyKiemDiemRutKNCaNhan : 0,
      kienNghiXuLyKiemDiemRutKNToChuc: _this.props.item && _this.props.item.kienNghiXuLyKiemDiemRutKNToChuc ? _this.props.item.kienNghiXuLyKiemDiemRutKNToChuc : 0,
      phapLuatVeTTLop: _this.props.item && _this.props.item.phapLuatVeTTLop ? _this.props.item.phapLuatVeTTLop : 0,
      phapLuatVeTTNguoi: _this.props.item && _this.props.item.phapLuatVeTTNguoi ? _this.props.item.phapLuatVeTTNguoi : 0,
      phapLuatVeTT_KNTC_PCTN_Lop: _this.props.item && _this.props.item.phapLuatVeTT_KNTC_PCTN_Lop ? _this.props.item.phapLuatVeTT_KNTC_PCTN_Lop : 0,
      phapLuatVeTT_KNTC_PCTN_Nguoi: _this.props.item && _this.props.item.phapLuatVeTT_KNTC_PCTN_Nguoi ? _this.props.item.phapLuatVeTT_KNTC_PCTN_Nguoi : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      soVanBanBanHanhMoi: _this.props.item && _this.props.item.soVanBanBanHanhMoi ? _this.props.item.soVanBanBanHanhMoi : 0,
      soVanBanDuaSuaDoiBoSung: _this.props.item && _this.props.item.soVanBanDuaSuaDoiBoSung ? _this.props.item.soVanBanDuaSuaDoiBoSung : 0,
      tenDonVi: _this.props.item && _this.props.item.tenDonVi ? _this.props.item.tenDonVi : '',
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : '',
      thucHienPLVeThanhTraKNTCPCTNSoCuoc: _this.props.item && _this.props.item.thucHienPLVeThanhTraKNTCPCTNSoCuoc ? _this.props.item.thucHienPLVeThanhTraKNTCPCTNSoCuoc : 0,
      thucHienPLVeThanhTraKNTCPCTNSoDonVi: _this.props.item && _this.props.item.thucHienPLVeThanhTraKNTCPCTNSoDonVi ? _this.props.item.thucHienPLVeThanhTraKNTCPCTNSoDonVi : 0,
      thucHienPLVeThanhTraSoCuoc: _this.props.item && _this.props.item.thucHienPLVeThanhTraSoCuoc ? _this.props.item.thucHienPLVeThanhTraSoCuoc : 0,
      thucHienPLVeThanhTraSoDonVi: _this.props.item && _this.props.item.thucHienPLVeThanhTraSoDonVi ? _this.props.item.thucHienPLVeThanhTraSoDonVi : 0,
      tongSoKLTTVaQDXLDaKiemDiem: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKiemDiem ? _this.props.item.tongSoKLTTVaQDXLDaKiemDiem : 0
    };
    return _this;
  }

  _createClass(RowItemCongTacQuanLyNhaNuoc, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        daXLHanhChinhCaNhan: nextProps.item && nextProps.item.daXLHanhChinhCaNhan ? nextProps.item.daXLHanhChinhCaNhan : 0,
        daXLHanhChinhToChuc: nextProps.item && nextProps.item.daXLHanhChinhToChuc ? nextProps.item.daXLHanhChinhToChuc : 0,
        ketQuaKTDaKiemDiemRutKNCaNhan: nextProps.item && nextProps.item.ketQuaKTDaKiemDiemRutKNCaNhan ? nextProps.item.ketQuaKTDaKiemDiemRutKNCaNhan : 0,
        ketQuaKTDaKiemDiemRutKNToChuc: nextProps.item && nextProps.item.ketQuaKTDaKiemDiemRutKNToChuc ? nextProps.item.ketQuaKTDaKiemDiemRutKNToChuc : 0,
        kienNghiXuLyHanhChinhCaNhan: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhCaNhan ? nextProps.item.kienNghiXuLyHanhChinhCaNhan : 0,
        kienNghiXuLyHanhChinhToChuc: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhToChuc ? nextProps.item.kienNghiXuLyHanhChinhToChuc : 0,
        kienNghiXuLyKiemDiemRutKNCaNhan: nextProps.item && nextProps.item.kienNghiXuLyKiemDiemRutKNCaNhan ? nextProps.item.kienNghiXuLyKiemDiemRutKNCaNhan : 0,
        kienNghiXuLyKiemDiemRutKNToChuc: nextProps.item && nextProps.item.kienNghiXuLyKiemDiemRutKNToChuc ? nextProps.item.kienNghiXuLyKiemDiemRutKNToChuc : 0,
        phapLuatVeTTLop: nextProps.item && nextProps.item.phapLuatVeTTLop ? nextProps.item.phapLuatVeTTLop : 0,
        phapLuatVeTTNguoi: nextProps.item && nextProps.item.phapLuatVeTTNguoi ? nextProps.item.phapLuatVeTTNguoi : 0,
        phapLuatVeTT_KNTC_PCTN_Lop: nextProps.item && nextProps.item.phapLuatVeTT_KNTC_PCTN_Lop ? nextProps.item.phapLuatVeTT_KNTC_PCTN_Lop : 0,
        phapLuatVeTT_KNTC_PCTN_Nguoi: nextProps.item && nextProps.item.phapLuatVeTT_KNTC_PCTN_Nguoi ? nextProps.item.phapLuatVeTT_KNTC_PCTN_Nguoi : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        soVanBanBanHanhMoi: nextProps.item && nextProps.item.soVanBanBanHanhMoi ? nextProps.item.soVanBanBanHanhMoi : 0,
        soVanBanDuaSuaDoiBoSung: nextProps.item && nextProps.item.soVanBanDuaSuaDoiBoSung ? nextProps.item.soVanBanDuaSuaDoiBoSung : 0,
        tenDonVi: nextProps.item && nextProps.item.tenDonVi ? nextProps.item.tenDonVi : '',
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : '',
        thucHienPLVeThanhTraKNTCPCTNSoCuoc: nextProps.item && nextProps.item.thucHienPLVeThanhTraKNTCPCTNSoCuoc ? nextProps.item.thucHienPLVeThanhTraKNTCPCTNSoCuoc : 0,
        thucHienPLVeThanhTraKNTCPCTNSoDonVi: nextProps.item && nextProps.item.thucHienPLVeThanhTraKNTCPCTNSoDonVi ? nextProps.item.thucHienPLVeThanhTraKNTCPCTNSoDonVi : 0,
        thucHienPLVeThanhTraSoCuoc: nextProps.item && nextProps.item.thucHienPLVeThanhTraSoCuoc ? nextProps.item.thucHienPLVeThanhTraSoCuoc : 0,
        thucHienPLVeThanhTraSoDonVi: nextProps.item && nextProps.item.thucHienPLVeThanhTraSoDonVi ? nextProps.item.thucHienPLVeThanhTraSoDonVi : 0,
        tongSoKLTTVaQDXLDaKiemDiem: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKiemDiem ? nextProps.item.tongSoKLTTVaQDXLDaKiemDiem : 0
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        daXLHanhChinhCaNhan: this.state.daXLHanhChinhCaNhan ? Number(this.state.daXLHanhChinhCaNhan) : 0,
        daXLHanhChinhToChuc: this.state.daXLHanhChinhToChuc ? Number(this.state.daXLHanhChinhToChuc) : 0,
        ketQuaKTDaKiemDiemRutKNCaNhan: this.state.ketQuaKTDaKiemDiemRutKNCaNhan ? Number(this.state.ketQuaKTDaKiemDiemRutKNCaNhan) : 0,
        ketQuaKTDaKiemDiemRutKNToChuc: this.state.ketQuaKTDaKiemDiemRutKNToChuc ? Number(this.state.ketQuaKTDaKiemDiemRutKNToChuc) : 0,
        kienNghiXuLyHanhChinhCaNhan: this.state.kienNghiXuLyHanhChinhCaNhan ? Number(this.state.kienNghiXuLyHanhChinhCaNhan) : 0,
        kienNghiXuLyHanhChinhToChuc: this.state.kienNghiXuLyHanhChinhToChuc ? Number(this.state.kienNghiXuLyHanhChinhToChuc) : 0,
        kienNghiXuLyKiemDiemRutKNCaNhan: this.state.kienNghiXuLyKiemDiemRutKNCaNhan ? Number(this.state.kienNghiXuLyKiemDiemRutKNCaNhan) : 0,
        kienNghiXuLyKiemDiemRutKNToChuc: this.state.kienNghiXuLyKiemDiemRutKNToChuc ? Number(this.state.kienNghiXuLyKiemDiemRutKNToChuc) : 0,
        phapLuatVeTTLop: this.state.phapLuatVeTTLop ? Number(this.state.phapLuatVeTTLop) : 0,
        phapLuatVeTTNguoi: this.state.phapLuatVeTTNguoi ? Number(this.state.phapLuatVeTTNguoi) : 0,
        phapLuatVeTT_KNTC_PCTN_Lop: this.state.phapLuatVeTT_KNTC_PCTN_Lop ? Number(this.state.phapLuatVeTT_KNTC_PCTN_Lop) : 0,
        phapLuatVeTT_KNTC_PCTN_Nguoi: this.state.phapLuatVeTT_KNTC_PCTN_Nguoi ? Number(this.state.phapLuatVeTT_KNTC_PCTN_Nguoi) : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? Number(this.state.soDonViCoViPham) : 0,
        soVanBanBanHanhMoi: this.state.soVanBanBanHanhMoi ? Number(this.state.soVanBanBanHanhMoi) : 0,
        soVanBanDuaSuaDoiBoSung: this.state.soVanBanDuaSuaDoiBoSung ? Number(this.state.soVanBanDuaSuaDoiBoSung) : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : '',
        thucHienPLVeThanhTraKNTCPCTNSoCuoc: this.state.thucHienPLVeThanhTraKNTCPCTNSoCuoc ? Number(this.state.thucHienPLVeThanhTraKNTCPCTNSoCuoc) : 0,
        thucHienPLVeThanhTraKNTCPCTNSoDonVi: this.state.thucHienPLVeThanhTraKNTCPCTNSoDonVi ? Number(this.state.thucHienPLVeThanhTraKNTCPCTNSoDonVi) : 0,
        thucHienPLVeThanhTraSoCuoc: this.state.thucHienPLVeThanhTraSoCuoc ? Number(this.state.thucHienPLVeThanhTraSoCuoc) : 0,
        thucHienPLVeThanhTraSoDonVi: this.state.thucHienPLVeThanhTraSoDonVi ? Number(this.state.thucHienPLVeThanhTraSoDonVi) : 0,
        tongSoKLTTVaQDXLDaKiemDiem: this.state.tongSoKLTTVaQDXLDaKiemDiem ? Number(this.state.tongSoKLTTVaQDXLDaKiemDiem) : 0
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      var hasDonVi = typeof item.donVi != 'undefined' && item.donVi.id != '' && item.donVi.id != null;
      var isView = typeof item.donVi != 'undefined' && item.donVi.id && this.props.sum || this.props.nullElement == true;
      // let isEdit = (typeof item.donVi != 'undefined' && !item.donVi.id) && this.props.nullElement != true;
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left txt-bold' },
            item && item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVanBanBanHanhMoi ? item.soVanBanBanHanhMoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVanBanDuaSuaDoiBoSung ? item.soVanBanDuaSuaDoiBoSung : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeTTLop ? item.phapLuatVeTTLop : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeTTNguoi ? item.phapLuatVeTTNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeTT_KNTC_PCTN_Lop ? item.phapLuatVeTT_KNTC_PCTN_Lop : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeTT_KNTC_PCTN_Nguoi ? item.phapLuatVeTT_KNTC_PCTN_Nguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeThanhTraSoCuoc ? item.thucHienPLVeThanhTraSoCuoc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeThanhTraSoDonVi ? item.thucHienPLVeThanhTraSoDonVi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeThanhTraKNTCPCTNSoCuoc ? item.thucHienPLVeThanhTraKNTCPCTNSoCuoc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeThanhTraKNTCPCTNSoDonVi ? item.thucHienPLVeThanhTraKNTCPCTNSoDonVi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyKiemDiemRutKNToChuc ? item.kienNghiXuLyKiemDiemRutKNToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyKiemDiemRutKNCaNhan ? item.kienNghiXuLyKiemDiemRutKNCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhToChuc ? item.kienNghiXuLyHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhCaNhan ? item.kienNghiXuLyHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoKLTTVaQDXLDaKiemDiem ? item.tongSoKLTTVaQDXLDaKiemDiem : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ketQuaKTDaKiemDiemRutKNToChuc ? item.ketQuaKTDaKiemDiemRutKNToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ketQuaKTDaKiemDiemRutKNCaNhan ? item.ketQuaKTDaKiemDiemRutKNCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daXLHanhChinhToChuc ? item.daXLHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daXLHanhChinhCaNhan ? item.daXLHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVanBanBanHanhMoi, onChange: this.onChange.bind(this, 'soVanBanBanHanhMoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVanBanDuaSuaDoiBoSung, onChange: this.onChange.bind(this, 'soVanBanDuaSuaDoiBoSung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeTTLop, onChange: this.onChange.bind(this, 'phapLuatVeTTLop') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeTTNguoi, onChange: this.onChange.bind(this, 'phapLuatVeTTNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeTT_KNTC_PCTN_Lop, onChange: this.onChange.bind(this, 'phapLuatVeTT_KNTC_PCTN_Lop') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeTT_KNTC_PCTN_Nguoi, onChange: this.onChange.bind(this, 'phapLuatVeTT_KNTC_PCTN_Nguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', disabled: hasDonVi, triggeOnBlur: true, value: this.state.thucHienPLVeThanhTraSoCuoc, onChange: this.onChange.bind(this, 'thucHienPLVeThanhTraSoCuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thucHienPLVeThanhTraSoDonVi, onChange: this.onChange.bind(this, 'thucHienPLVeThanhTraSoDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thucHienPLVeThanhTraKNTCPCTNSoCuoc, onChange: this.onChange.bind(this, 'thucHienPLVeThanhTraKNTCPCTNSoCuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thucHienPLVeThanhTraKNTCPCTNSoDonVi, onChange: this.onChange.bind(this, 'thucHienPLVeThanhTraKNTCPCTNSoDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyKiemDiemRutKNToChuc, onChange: this.onChange.bind(this, 'kienNghiXuLyKiemDiemRutKNToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyKiemDiemRutKNCaNhan, onChange: this.onChange.bind(this, 'kienNghiXuLyKiemDiemRutKNCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhToChuc, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhCaNhan, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKiemDiem, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKiemDiem') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKTDaKiemDiemRutKNToChuc, onChange: this.onChange.bind(this, 'ketQuaKTDaKiemDiemRutKNToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKTDaKiemDiemRutKNCaNhan, onChange: this.onChange.bind(this, 'ketQuaKTDaKiemDiemRutKNCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXLHanhChinhToChuc, onChange: this.onChange.bind(this, 'daXLHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXLHanhChinhCaNhan, onChange: this.onChange.bind(this, 'daXLHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemCongTacQuanLyNhaNuoc;
}(_react2.default.Component);

RowItemCongTacQuanLyNhaNuoc.defaultProps = {
  nullElement: false,
  onChange: function onChange() {}
};

exports.default = RowItemCongTacQuanLyNhaNuoc;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCongTacQuanLyNhaNuocKNTC = function (_React$Component) {
  _inherits(RowItemCongTacQuanLyNhaNuocKNTC, _React$Component);

  function RowItemCongTacQuanLyNhaNuocKNTC(props, context) {
    _classCallCheck(this, RowItemCongTacQuanLyNhaNuocKNTC);

    var _this = _possibleConstructorReturn(this, (RowItemCongTacQuanLyNhaNuocKNTC.__proto__ || Object.getPrototypeOf(RowItemCongTacQuanLyNhaNuocKNTC)).call(this, props, context));

    _this.state = {
      daXLHanhChinhCaNhan: _this.props.item && _this.props.item.daXLHanhChinhCaNhan ? _this.props.item.daXLHanhChinhCaNhan : 0,
      daXLHanhChinhToChuc: _this.props.item && _this.props.item.daXLHanhChinhToChuc ? _this.props.item.daXLHanhChinhToChuc : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : "",
      ketQuaKTDaKiemDiemRutKNCaNhan: _this.props.item && _this.props.item.ketQuaKTDaKiemDiemRutKNCaNhan ? _this.props.item.ketQuaKTDaKiemDiemRutKNCaNhan : 0,
      ketQuaKTDaKiemDiemRutKNToChuc: _this.props.item && _this.props.item.ketQuaKTDaKiemDiemRutKNToChuc ? _this.props.item.ketQuaKTDaKiemDiemRutKNToChuc : 0,
      kienNghiXuLyHanhChinhCaNhan: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhCaNhan ? _this.props.item.kienNghiXuLyHanhChinhCaNhan : 0,
      kienNghiXuLyHanhChinhToChuc: _this.props.item && _this.props.item.kienNghiXuLyHanhChinhToChuc ? _this.props.item.kienNghiXuLyHanhChinhToChuc : 0,
      kienNghiXuLyKiemDiemRutKNCaNhan: _this.props.item && _this.props.item.kienNghiXuLyKiemDiemRutKNCaNhan ? _this.props.item.kienNghiXuLyKiemDiemRutKNCaNhan : 0,
      kienNghiXuLyKiemDiemRutKNToChuc: _this.props.item && _this.props.item.kienNghiXuLyKiemDiemRutKNToChuc ? _this.props.item.kienNghiXuLyKiemDiemRutKNToChuc : 0,
      phapLuatVeKNTCLop: _this.props.item && _this.props.item.phapLuatVeKNTCLop ? _this.props.item.phapLuatVeKNTCLop : 0,
      phapLuatVeKNTCNguoi: _this.props.item && _this.props.item.phapLuatVeKNTCNguoi ? _this.props.item.phapLuatVeKNTCNguoi : 0,
      soCuoc: _this.props.item && _this.props.item.soCuoc ? _this.props.item.soCuoc : 0,
      soDonVi: _this.props.item && _this.props.item.soDonVi ? _this.props.item.soDonVi : 0,
      soDonViCoViPham: _this.props.item && _this.props.item.soDonViCoViPham ? _this.props.item.soDonViCoViPham : 0,
      soVanBanBanHanhMoi: _this.props.item && _this.props.item.soVanBanBanHanhMoi ? _this.props.item.soVanBanBanHanhMoi : 0,
      soVanBanDuaSuaDoiBoSung: _this.props.item && _this.props.item.soVanBanDuaSuaDoiBoSung ? _this.props.item.soVanBanDuaSuaDoiBoSung : 0,
      thucHienPLVeKNTCSoCuoc: _this.props.item && _this.props.item.thucHienPLVeKNTCSoCuoc ? _this.props.item.thucHienPLVeKNTCSoCuoc : 0,
      thucHienPLVeKNTCSoDonVi: _this.props.item && _this.props.item.thucHienPLVeKNTCSoDonVi ? _this.props.item.thucHienPLVeKNTCSoDonVi : 0,
      tongSoKLTTVaQDXLDaKiemDiem: _this.props.item && _this.props.item.tongSoKLTTVaQDXLDaKiemDiem ? _this.props.item.tongSoKLTTVaQDXLDaKiemDiem : 0
    };
    return _this;
  }

  _createClass(RowItemCongTacQuanLyNhaNuocKNTC, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        daXLHanhChinhCaNhan: nextProps.item && nextProps.item.daXLHanhChinhCaNhan ? nextProps.item.daXLHanhChinhCaNhan : 0,
        daXLHanhChinhToChuc: nextProps.item && nextProps.item.daXLHanhChinhToChuc ? nextProps.item.daXLHanhChinhToChuc : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : "",
        ketQuaKTDaKiemDiemRutKNCaNhan: nextProps.item && nextProps.item.ketQuaKTDaKiemDiemRutKNCaNhan ? nextProps.item.ketQuaKTDaKiemDiemRutKNCaNhan : 0,
        ketQuaKTDaKiemDiemRutKNToChuc: nextProps.item && nextProps.item.ketQuaKTDaKiemDiemRutKNToChuc ? nextProps.item.ketQuaKTDaKiemDiemRutKNToChuc : 0,
        kienNghiXuLyHanhChinhCaNhan: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhCaNhan ? nextProps.item.kienNghiXuLyHanhChinhCaNhan : 0,
        kienNghiXuLyHanhChinhToChuc: nextProps.item && nextProps.item.kienNghiXuLyHanhChinhToChuc ? nextProps.item.kienNghiXuLyHanhChinhToChuc : 0,
        kienNghiXuLyKiemDiemRutKNCaNhan: nextProps.item && nextProps.item.kienNghiXuLyKiemDiemRutKNCaNhan ? nextProps.item.kienNghiXuLyKiemDiemRutKNCaNhan : 0,
        kienNghiXuLyKiemDiemRutKNToChuc: nextProps.item && nextProps.item.kienNghiXuLyKiemDiemRutKNToChuc ? nextProps.item.kienNghiXuLyKiemDiemRutKNToChuc : 0,
        phapLuatVeKNTCLop: nextProps.item && nextProps.item.phapLuatVeKNTCLop ? nextProps.item.phapLuatVeKNTCLop : 0,
        phapLuatVeKNTCNguoi: nextProps.item && nextProps.item.phapLuatVeKNTCNguoi ? nextProps.item.phapLuatVeKNTCNguoi : 0,
        soCuoc: nextProps.item && nextProps.item.soCuoc ? nextProps.item.soCuoc : 0,
        soDonVi: nextProps.item && nextProps.item.soDonVi ? nextProps.item.soDonVi : 0,
        soDonViCoViPham: nextProps.item && nextProps.item.soDonViCoViPham ? nextProps.item.soDonViCoViPham : 0,
        soVanBanBanHanhMoi: nextProps.item && nextProps.item.soVanBanBanHanhMoi ? nextProps.item.soVanBanBanHanhMoi : 0,
        soVanBanDuaSuaDoiBoSung: nextProps.item && nextProps.item.soVanBanDuaSuaDoiBoSung ? nextProps.item.soVanBanDuaSuaDoiBoSung : 0,
        thucHienPLVeKNTCSoCuoc: nextProps.item && nextProps.item.thucHienPLVeKNTCSoCuoc ? nextProps.item.thucHienPLVeKNTCSoCuoc : 0,
        thucHienPLVeKNTCSoDonVi: nextProps.item && nextProps.item.thucHienPLVeKNTCSoDonVi ? nextProps.item.thucHienPLVeKNTCSoDonVi : 0,
        tongSoKLTTVaQDXLDaKiemDiem: nextProps.item && nextProps.item.tongSoKLTTVaQDXLDaKiemDiem ? nextProps.item.tongSoKLTTVaQDXLDaKiemDiem : 0
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        daXLHanhChinhCaNhan: this.state.daXLHanhChinhCaNhan ? this.state.daXLHanhChinhCaNhan : 0,
        daXLHanhChinhToChuc: this.state.daXLHanhChinhToChuc ? this.state.daXLHanhChinhToChuc : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : "",
        ketQuaKTDaKiemDiemRutKNCaNhan: this.state.ketQuaKTDaKiemDiemRutKNCaNhan ? this.state.ketQuaKTDaKiemDiemRutKNCaNhan : 0,
        ketQuaKTDaKiemDiemRutKNToChuc: this.state.ketQuaKTDaKiemDiemRutKNToChuc ? this.state.ketQuaKTDaKiemDiemRutKNToChuc : 0,
        kienNghiXuLyHanhChinhCaNhan: this.state.kienNghiXuLyHanhChinhCaNhan ? this.state.kienNghiXuLyHanhChinhCaNhan : 0,
        kienNghiXuLyHanhChinhToChuc: this.state.kienNghiXuLyHanhChinhToChuc ? this.state.kienNghiXuLyHanhChinhToChuc : 0,
        kienNghiXuLyKiemDiemRutKNCaNhan: this.state.kienNghiXuLyKiemDiemRutKNCaNhan ? this.state.kienNghiXuLyKiemDiemRutKNCaNhan : 0,
        kienNghiXuLyKiemDiemRutKNToChuc: this.state.kienNghiXuLyKiemDiemRutKNToChuc ? this.state.kienNghiXuLyKiemDiemRutKNToChuc : 0,
        phapLuatVeKNTCLop: this.state.phapLuatVeKNTCLop ? this.state.phapLuatVeKNTCLop : 0,
        phapLuatVeKNTCNguoi: this.state.phapLuatVeKNTCNguoi ? this.state.phapLuatVeKNTCNguoi : 0,
        soCuoc: this.state.soCuoc ? this.state.soCuoc : 0,
        soDonVi: this.state.soDonVi ? this.state.soDonVi : 0,
        soDonViCoViPham: this.state.soDonViCoViPham ? this.state.soDonViCoViPham : 0,
        soVanBanBanHanhMoi: this.state.soVanBanBanHanhMoi ? this.state.soVanBanBanHanhMoi : 0,
        soVanBanDuaSuaDoiBoSung: this.state.soVanBanDuaSuaDoiBoSung ? this.state.soVanBanDuaSuaDoiBoSung : 0,
        thucHienPLVeKNTCSoCuoc: this.state.thucHienPLVeKNTCSoCuoc ? this.state.thucHienPLVeKNTCSoCuoc : 0,
        thucHienPLVeKNTCSoDonVi: this.state.thucHienPLVeKNTCSoDonVi ? this.state.thucHienPLVeKNTCSoDonVi : 0,
        tongSoKLTTVaQDXLDaKiemDiem: this.state.tongSoKLTTVaQDXLDaKiemDiem ? this.state.tongSoKLTTVaQDXLDaKiemDiem : 0
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      var hasDonVi = typeof item.donVi != 'undefined' && item.donVi.id != '' && item.donVi.id != null;
      var isView = typeof item.donVi != 'undefined' && item.donVi.id && this.props.sum || this.props.nullElement == true;
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left txt-bold' },
            item && item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVanBanBanHanhMoi ? item.soVanBanBanHanhMoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soVanBanDuaSuaDoiBoSung ? item.soVanBanDuaSuaDoiBoSung : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeKNTCLop ? item.phapLuatVeKNTCLop : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.phapLuatVeKNTCNguoi ? item.phapLuatVeKNTCNguoi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeKNTCSoCuoc ? item.thucHienPLVeKNTCSoCuoc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thucHienPLVeKNTCSoDonVi ? item.thucHienPLVeKNTCSoDonVi : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soDonViCoViPham ? item.soDonViCoViPham : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyKiemDiemRutKNToChuc ? item.kienNghiXuLyKiemDiemRutKNToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyKiemDiemRutKNCaNhan ? item.kienNghiXuLyKiemDiemRutKNCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhToChuc ? item.kienNghiXuLyHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.kienNghiXuLyHanhChinhCaNhan ? item.kienNghiXuLyHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoKLTTVaQDXLDaKiemDiem ? item.tongSoKLTTVaQDXLDaKiemDiem : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ketQuaKTDaKiemDiemRutKNToChuc ? item.ketQuaKTDaKiemDiemRutKNToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ketQuaKTDaKiemDiemRutKNCaNhan ? item.ketQuaKTDaKiemDiemRutKNCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daXLHanhChinhToChuc ? item.daXLHanhChinhToChuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daXLHanhChinhCaNhan ? item.daXLHanhChinhCaNhan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVanBanBanHanhMoi, onChange: this.onChange.bind(this, 'soVanBanBanHanhMoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soVanBanDuaSuaDoiBoSung, onChange: this.onChange.bind(this, 'soVanBanDuaSuaDoiBoSung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeKNTCLop, onChange: this.onChange.bind(this, 'phapLuatVeKNTCLop') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.phapLuatVeKNTCNguoi, onChange: this.onChange.bind(this, 'phapLuatVeKNTCNguoi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thucHienPLVeKNTCSoCuoc, onChange: this.onChange.bind(this, 'thucHienPLVeKNTCSoCuoc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', disabled: hasDonVi, className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thucHienPLVeKNTCSoDonVi, onChange: this.onChange.bind(this, 'thucHienPLVeKNTCSoDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soDonViCoViPham, onChange: this.onChange.bind(this, 'soDonViCoViPham') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyKiemDiemRutKNToChuc, onChange: this.onChange.bind(this, 'kienNghiXuLyKiemDiemRutKNToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyKiemDiemRutKNCaNhan, onChange: this.onChange.bind(this, 'kienNghiXuLyKiemDiemRutKNCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhToChuc, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.kienNghiXuLyHanhChinhCaNhan, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoKLTTVaQDXLDaKiemDiem, onChange: this.onChange.bind(this, 'tongSoKLTTVaQDXLDaKiemDiem') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKTDaKiemDiemRutKNToChuc, onChange: this.onChange.bind(this, 'ketQuaKTDaKiemDiemRutKNToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ketQuaKTDaKiemDiemRutKNCaNhan, onChange: this.onChange.bind(this, 'ketQuaKTDaKiemDiemRutKNCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXLHanhChinhToChuc, onChange: this.onChange.bind(this, 'daXLHanhChinhToChuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daXLHanhChinhCaNhan, onChange: this.onChange.bind(this, 'daXLHanhChinhCaNhan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemCongTacQuanLyNhaNuocKNTC;
}(_react2.default.Component);

RowItemCongTacQuanLyNhaNuocKNTC.defaultProps = {
  nullElement: false,
  onChange: function onChange() {}
};

exports.default = RowItemCongTacQuanLyNhaNuocKNTC;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTongHopKeKhai = function (_React$Component) {
  _inherits(RowItemTongHopKeKhai, _React$Component);

  function RowItemTongHopKeKhai(props, context) {
    _classCallCheck(this, RowItemTongHopKeKhai);

    var _this = _possibleConstructorReturn(this, (RowItemTongHopKeKhai.__proto__ || Object.getPrototypeOf(RowItemTongHopKeKhai)).call(this, props, context));

    _this.state = {
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : "",
      soNguoiCongKhaiTheoHTNiemYet: _this.props.item && _this.props.item.soNguoiCongKhaiTheoHTNiemYet ? _this.props.item.soNguoiCongKhaiTheoHTNiemYet : 0,
      soNguoiCongKhaiTheoHTTCHoiHop: _this.props.item && _this.props.item.soNguoiCongKhaiTheoHTTCHoiHop ? _this.props.item.soNguoiCongKhaiTheoHTTCHoiHop : 0,
      soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan: _this.props.item && _this.props.item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan ? _this.props.item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan : 0,
      soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc: _this.props.item && _this.props.item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc ? _this.props.item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc : 0,
      soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap: _this.props.item && _this.props.item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap ? _this.props.item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap : 0,
      soNguoiDaCoKLVVKKHTSTNKhongTrungThuc: _this.props.item && _this.props.item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc ? _this.props.item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc : 0,
      soNguoiDaKeKhai: _this.props.item && _this.props.item.soNguoiDaKeKhai ? _this.props.item.soNguoiDaKeKhai : 0,
      soNguoiDuocXMTSThuNhap: _this.props.item && _this.props.item.soNguoiDuocXMTSThuNhap ? _this.props.item.soNguoiDuocXMTSThuNhap : 0,
      soNguoiPhaiKeKhaiTrongNam: _this.props.item && _this.props.item.soNguoiPhaiKeKhaiTrongNam ? _this.props.item.soNguoiPhaiKeKhaiTrongNam : 0
    };
    return _this;
  }

  _createClass(RowItemTongHopKeKhai, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : "",
        soNguoiCongKhaiTheoHTNiemYet: nextProps.item && nextProps.item.soNguoiCongKhaiTheoHTNiemYet ? nextProps.item.soNguoiCongKhaiTheoHTNiemYet : 0,
        soNguoiCongKhaiTheoHTTCHoiHop: nextProps.item && nextProps.item.soNguoiCongKhaiTheoHTTCHoiHop ? nextProps.item.soNguoiCongKhaiTheoHTTCHoiHop : 0,
        soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan: nextProps.item && nextProps.item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan ? nextProps.item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan : 0,
        soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc: nextProps.item && nextProps.item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc ? nextProps.item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc : 0,
        soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap: nextProps.item && nextProps.item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap ? nextProps.item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap : 0,
        soNguoiDaCoKLVVKKHTSTNKhongTrungThuc: nextProps.item && nextProps.item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc ? nextProps.item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc : 0,
        soNguoiDaKeKhai: nextProps.item && nextProps.item.soNguoiDaKeKhai ? nextProps.item.soNguoiDaKeKhai : 0,
        soNguoiDuocXMTSThuNhap: nextProps.item && nextProps.item.soNguoiDuocXMTSThuNhap ? nextProps.item.soNguoiDuocXMTSThuNhap : 0,
        soNguoiPhaiKeKhaiTrongNam: nextProps.item && nextProps.item.soNguoiPhaiKeKhaiTrongNam ? nextProps.item.soNguoiPhaiKeKhaiTrongNam : 0
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        ghiChu: this.state.ghiChu ? this.state.ghiChu : "",
        soNguoiCongKhaiTheoHTNiemYet: this.state.soNguoiCongKhaiTheoHTNiemYet ? this.state.soNguoiCongKhaiTheoHTNiemYet : 0,
        soNguoiCongKhaiTheoHTTCHoiHop: this.state.soNguoiCongKhaiTheoHTTCHoiHop ? this.state.soNguoiCongKhaiTheoHTTCHoiHop : 0,
        soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan: this.state.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan ? this.state.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan : 0,
        soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc: this.state.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc ? this.state.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc : 0,
        soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap: this.state.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap ? this.state.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap : 0,
        soNguoiDaCoKLVVKKHTSTNKhongTrungThuc: this.state.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc ? this.state.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc : 0,
        soNguoiDaKeKhai: this.state.soNguoiDaKeKhai ? this.state.soNguoiDaKeKhai : 0,
        soNguoiDuocXMTSThuNhap: this.state.soNguoiDuocXMTSThuNhap ? this.state.soNguoiDuocXMTSThuNhap : 0,
        soNguoiPhaiKeKhaiTrongNam: this.state.soNguoiPhaiKeKhaiTrongNam ? this.state.soNguoiPhaiKeKhaiTrongNam : 0
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      var isView = typeof item.donVi != 'undefined' && item.donVi.id && this.props.sum || this.props.nullElement == true;
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left txt-bold' },
            item && item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiPhaiKeKhaiTrongNam ? item.soNguoiPhaiKeKhaiTrongNam : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDaKeKhai ? item.soNguoiDaKeKhai : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiCongKhaiTheoHTNiemYet ? item.soNguoiCongKhaiTheoHTNiemYet : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiCongKhaiTheoHTTCHoiHop ? item.soNguoiCongKhaiTheoHTTCHoiHop : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDuocXMTSThuNhap ? item.soNguoiDuocXMTSThuNhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc ? item.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc ? item.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan ? item.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap ? item.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiPhaiKeKhaiTrongNam, onChange: this.onChange.bind(this, 'soNguoiPhaiKeKhaiTrongNam') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDaKeKhai, onChange: this.onChange.bind(this, 'soNguoiDaKeKhai') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiCongKhaiTheoHTNiemYet, onChange: this.onChange.bind(this, 'soNguoiCongKhaiTheoHTNiemYet') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiCongKhaiTheoHTTCHoiHop, onChange: this.onChange.bind(this, 'soNguoiCongKhaiTheoHTTCHoiHop') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDuocXMTSThuNhap, onChange: this.onChange.bind(this, 'soNguoiDuocXMTSThuNhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc, onChange: this.onChange.bind(this, 'soNguoiDaCoKLVVKKHTSTNKhongTrungThuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc, onChange: this.onChange.bind(this, 'soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan, onChange: this.onChange.bind(this, 'soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !isView },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap, onChange: this.onChange.bind(this, 'soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemTongHopKeKhai;
}(_react2.default.Component);

RowItemTongHopKeKhai.defaultProps = {
  nullElement: false,
  onChange: function onChange() {}
};

exports.default = RowItemTongHopKeKhai;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemXayDungLucLuongThanhTra = function (_React$Component) {
  _inherits(RowItemXayDungLucLuongThanhTra, _React$Component);

  function RowItemXayDungLucLuongThanhTra(props, context) {
    _classCallCheck(this, RowItemXayDungLucLuongThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemXayDungLucLuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemXayDungLucLuongThanhTra)).call(this, props, context));

    _this.state = {
      boNhiemChucVuLanhDao: _this.props.item && _this.props.item.boNhiemChucVuLanhDao ? _this.props.item.boNhiemChucVuLanhDao : 0,
      boNhiemVaoNgachNangNgach: _this.props.item && _this.props.item.boNhiemVaoNgachNangNgach ? _this.props.item.boNhiemVaoNgachNangNgach : 0,
      chuyenDoiViTriCongTac: _this.props.item && _this.props.item.chuyenDoiViTriCongTac ? _this.props.item.chuyenDoiViTriCongTac : 0,
      daoTaoKhac: _this.props.item && _this.props.item.daoTaoKhac ? _this.props.item.daoTaoKhac : 0,
      daoTaoLyLuanChinhTri: _this.props.item && _this.props.item.daoTaoLyLuanChinhTri ? _this.props.item.daoTaoLyLuanChinhTri : 0,
      ghiChu: _this.props.item && _this.props.item.ghiChu ? _this.props.item.ghiChu : '',
      nghiHuuChuyenCongTac: _this.props.item && _this.props.item.nghiHuuChuyenCongTac ? _this.props.item.nghiHuuChuyenCongTac : 0,
      soCBCCVCTrongBienChe: _this.props.item && _this.props.item.soCBCCVCTrongBienChe ? _this.props.item.soCBCCVCTrongBienChe : 0,
      soLaoDongHopDong: _this.props.item && _this.props.item.soLaoDongHopDong ? _this.props.item.soLaoDongHopDong : 0,
      soTTVCaoCapVaTuongDuong: _this.props.item && _this.props.item.soTTVCaoCapVaTuongDuong ? _this.props.item.soTTVCaoCapVaTuongDuong : 0,
      soTTVChinhVaTuongDuong: _this.props.item && _this.props.item.soTTVChinhVaTuongDuong ? _this.props.item.soTTVChinhVaTuongDuong : 0,
      soTTVVaTuongDuong: _this.props.item && _this.props.item.soTTVVaTuongDuong ? _this.props.item.soTTVVaTuongDuong : 0,
      thanhTraVienCaoCapDaThucHien: _this.props.item && _this.props.item.thanhTraVienCaoCapDaThucHien ? _this.props.item.thanhTraVienCaoCapDaThucHien : 0,
      thanhTraVienCaoCapNhuCau: _this.props.item && _this.props.item.thanhTraVienCaoCapNhuCau ? _this.props.item.thanhTraVienCaoCapNhuCau : 0,
      thanhTraVienChinhDaThucHien: _this.props.item && _this.props.item.thanhTraVienChinhDaThucHien ? _this.props.item.thanhTraVienChinhDaThucHien : 0,
      thanhTraVienChinhNhuCau: _this.props.item && _this.props.item.thanhTraVienChinhNhuCau ? _this.props.item.thanhTraVienChinhNhuCau : 0,
      thanhTraVienDaThucHien: _this.props.item && _this.props.item.thanhTraVienDaThucHien ? _this.props.item.thanhTraVienDaThucHien : 0,
      thanhTraVienNhuCau: _this.props.item && _this.props.item.thanhTraVienNhuCau ? _this.props.item.thanhTraVienNhuCau : 0,
      tiepNhanTuyenDung: _this.props.item && _this.props.item.tiepNhanTuyenDung ? _this.props.item.tiepNhanTuyenDung : 0,
      tongSo: _this.props.item && _this.props.item.tongSo ? _this.props.item.tongSo : 0,
      tongSoDaThucHien: _this.props.item && _this.props.item.tongSoDaThucHien ? _this.props.item.tongSoDaThucHien : 0,
      tongSoNhuCau: _this.props.item && _this.props.item.tongSoNhuCau ? _this.props.item.tongSoNhuCau : 0,
      viPhamKLDaXuLy: _this.props.item && _this.props.item.viPhamKLDaXuLy ? _this.props.item.viPhamKLDaXuLy : 0,
      viPhamKLPhaiXuLy: _this.props.item && _this.props.item.viPhamKLPhaiXuLy ? _this.props.item.viPhamKLPhaiXuLy : 0
    };
    return _this;
  }

  _createClass(RowItemXayDungLucLuongThanhTra, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        boNhiemChucVuLanhDao: nextProps.item && nextProps.item.boNhiemChucVuLanhDao ? nextProps.item.boNhiemChucVuLanhDao : 0,
        boNhiemVaoNgachNangNgach: nextProps.item && nextProps.item.boNhiemVaoNgachNangNgach ? nextProps.item.boNhiemVaoNgachNangNgach : 0,
        chuyenDoiViTriCongTac: nextProps.item && nextProps.item.chuyenDoiViTriCongTac ? nextProps.item.chuyenDoiViTriCongTac : 0,
        daoTaoKhac: nextProps.item && nextProps.item.daoTaoKhac ? nextProps.item.daoTaoKhac : 0,
        daoTaoLyLuanChinhTri: nextProps.item && nextProps.item.daoTaoLyLuanChinhTri ? nextProps.item.daoTaoLyLuanChinhTri : 0,
        ghiChu: nextProps.item && nextProps.item.ghiChu ? nextProps.item.ghiChu : '',
        nghiHuuChuyenCongTac: nextProps.item && nextProps.item.nghiHuuChuyenCongTac ? nextProps.item.nghiHuuChuyenCongTac : 0,
        soCBCCVCTrongBienChe: nextProps.item && nextProps.item.soCBCCVCTrongBienChe ? nextProps.item.soCBCCVCTrongBienChe : 0,
        soLaoDongHopDong: nextProps.item && nextProps.item.soLaoDongHopDong ? nextProps.item.soLaoDongHopDong : 0,
        soTTVCaoCapVaTuongDuong: nextProps.item && nextProps.item.soTTVCaoCapVaTuongDuong ? nextProps.item.soTTVCaoCapVaTuongDuong : 0,
        soTTVChinhVaTuongDuong: nextProps.item && nextProps.item.soTTVChinhVaTuongDuong ? nextProps.item.soTTVChinhVaTuongDuong : 0,
        soTTVVaTuongDuong: nextProps.item && nextProps.item.soTTVVaTuongDuong ? nextProps.item.soTTVVaTuongDuong : 0,
        thanhTraVienCaoCapDaThucHien: nextProps.item && nextProps.item.thanhTraVienCaoCapDaThucHien ? nextProps.item.thanhTraVienCaoCapDaThucHien : 0,
        thanhTraVienCaoCapNhuCau: nextProps.item && nextProps.item.thanhTraVienCaoCapNhuCau ? nextProps.item.thanhTraVienCaoCapNhuCau : 0,
        thanhTraVienChinhDaThucHien: nextProps.item && nextProps.item.thanhTraVienChinhDaThucHien ? nextProps.item.thanhTraVienChinhDaThucHien : 0,
        thanhTraVienChinhNhuCau: nextProps.item && nextProps.item.thanhTraVienChinhNhuCau ? nextProps.item.thanhTraVienChinhNhuCau : 0,
        thanhTraVienDaThucHien: nextProps.item && nextProps.item.thanhTraVienDaThucHien ? nextProps.item.thanhTraVienDaThucHien : 0,
        thanhTraVienNhuCau: nextProps.item && nextProps.item.thanhTraVienNhuCau ? nextProps.item.thanhTraVienNhuCau : 0,
        tiepNhanTuyenDung: nextProps.item && nextProps.item.tiepNhanTuyenDung ? nextProps.item.tiepNhanTuyenDung : 0,
        tongSo: nextProps.item && nextProps.item.tongSo ? nextProps.item.tongSo : 0,
        tongSoDaThucHien: nextProps.item && nextProps.item.tongSoDaThucHien ? nextProps.item.tongSoDaThucHien : 0,
        tongSoNhuCau: nextProps.item && nextProps.item.tongSoNhuCau ? nextProps.item.tongSoNhuCau : 0,
        viPhamKLDaXuLy: nextProps.item && nextProps.item.viPhamKLDaXuLy ? nextProps.item.viPhamKLDaXuLy : 0,
        viPhamKLPhaiXuLy: nextProps.item && nextProps.item.viPhamKLPhaiXuLy ? nextProps.item.viPhamKLPhaiXuLy : 0
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        boNhiemChucVuLanhDao: this.state.boNhiemChucVuLanhDao ? this.state.boNhiemChucVuLanhDao : 0,
        boNhiemVaoNgachNangNgach: this.state.boNhiemVaoNgachNangNgach ? this.state.boNhiemVaoNgachNangNgach : 0,
        chuyenDoiViTriCongTac: this.state.chuyenDoiViTriCongTac ? this.state.chuyenDoiViTriCongTac : 0,
        daoTaoKhac: this.state.daoTaoKhac ? this.state.daoTaoKhac : 0,
        daoTaoLyLuanChinhTri: this.state.daoTaoLyLuanChinhTri ? this.state.daoTaoLyLuanChinhTri : 0,
        ghiChu: this.state.ghiChu ? this.state.ghiChu : '',
        nghiHuuChuyenCongTac: this.state.nghiHuuChuyenCongTac ? this.state.nghiHuuChuyenCongTac : 0,
        soCBCCVCTrongBienChe: this.state.soCBCCVCTrongBienChe ? this.state.soCBCCVCTrongBienChe : 0,
        soLaoDongHopDong: this.state.soLaoDongHopDong ? this.state.soLaoDongHopDong : 0,
        soTTVCaoCapVaTuongDuong: this.state.soTTVCaoCapVaTuongDuong ? this.state.soTTVCaoCapVaTuongDuong : 0,
        soTTVChinhVaTuongDuong: this.state.soTTVChinhVaTuongDuong ? this.state.soTTVChinhVaTuongDuong : 0,
        soTTVVaTuongDuong: this.state.soTTVVaTuongDuong ? this.state.soTTVVaTuongDuong : 0,
        thanhTraVienCaoCapDaThucHien: this.state.thanhTraVienCaoCapDaThucHien ? this.state.thanhTraVienCaoCapDaThucHien : 0,
        thanhTraVienCaoCapNhuCau: this.state.thanhTraVienCaoCapNhuCau ? this.state.thanhTraVienCaoCapNhuCau : 0,
        thanhTraVienChinhDaThucHien: this.state.thanhTraVienChinhDaThucHien ? this.state.thanhTraVienChinhDaThucHien : 0,
        thanhTraVienChinhNhuCau: this.state.thanhTraVienChinhNhuCau ? this.state.thanhTraVienChinhNhuCau : 0,
        thanhTraVienDaThucHien: this.state.thanhTraVienDaThucHien ? this.state.thanhTraVienDaThucHien : 0,
        thanhTraVienNhuCau: this.state.thanhTraVienNhuCau ? this.state.thanhTraVienNhuCau : 0,
        tiepNhanTuyenDung: this.state.tiepNhanTuyenDung ? this.state.tiepNhanTuyenDung : 0,
        tongSo: this.state.tongSo ? this.state.tongSo : 0,
        tongSoDaThucHien: this.state.tongSoDaThucHien ? this.state.tongSoDaThucHien : 0,
        tongSoNhuCau: this.state.tongSoNhuCau ? this.state.tongSoNhuCau : 0,
        viPhamKLDaXuLy: this.state.viPhamKLDaXuLy ? this.state.viPhamKLDaXuLy : 0,
        viPhamKLPhaiXuLy: this.state.viPhamKLPhaiXuLy ? this.state.viPhamKLPhaiXuLy : 0
      };
      if (this.props.item.addNew) {
        data.addNew = true;
      }
      if (this.props.item.id) {
        data.id = this.props.item.id;
      }
      this.props.onChange(this.props.count - 1, data);
    }
  }, {
    key: 'importData',
    value: function importData() {
      this.props.importData(this.props.count - 1, this.props.item.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left txt-bold' },
            item && item.tenDonVi ? item.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSo ? item.tongSo : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soTTVCaoCapVaTuongDuong ? item.soTTVCaoCapVaTuongDuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soTTVChinhVaTuongDuong ? item.soTTVChinhVaTuongDuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soTTVVaTuongDuong ? item.soTTVVaTuongDuong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soCBCCVCTrongBienChe ? item.soCBCCVCTrongBienChe : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.soLaoDongHopDong ? item.soLaoDongHopDong : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tiepNhanTuyenDung ? item.tiepNhanTuyenDung : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.nghiHuuChuyenCongTac ? item.nghiHuuChuyenCongTac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.boNhiemChucVuLanhDao ? item.boNhiemChucVuLanhDao : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.boNhiemVaoNgachNangNgach ? item.boNhiemVaoNgachNangNgach : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.chuyenDoiViTriCongTac ? item.chuyenDoiViTriCongTac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.viPhamKLPhaiXuLy ? item.viPhamKLPhaiXuLy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.viPhamKLDaXuLy ? item.viPhamKLDaXuLy : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoNhuCau ? item.tongSoNhuCau : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.tongSoDaThucHien ? item.tongSoDaThucHien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienNhuCau ? item.thanhTraVienNhuCau : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienDaThucHien ? item.thanhTraVienDaThucHien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienChinhNhuCau ? item.thanhTraVienChinhNhuCau : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienChinhDaThucHien ? item.thanhTraVienChinhDaThucHien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienCaoCapNhuCau ? item.thanhTraVienCaoCapNhuCau : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.thanhTraVienCaoCapDaThucHien ? item.thanhTraVienCaoCapDaThucHien : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daoTaoLyLuanChinhTri ? item.daoTaoLyLuanChinhTri : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && item.donVi.id || this.props.nullElement == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.daoTaoKhac ? item.daoTaoKhac : this.props.nullElement ? '' : 0
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tenDonVi, onChange: this.onChange.bind(this, 'tenDonVi') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSo, onChange: this.onChange.bind(this, 'tongSo') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTTVCaoCapVaTuongDuong, onChange: this.onChange.bind(this, 'soTTVCaoCapVaTuongDuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTTVChinhVaTuongDuong, onChange: this.onChange.bind(this, 'soTTVChinhVaTuongDuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soTTVVaTuongDuong, onChange: this.onChange.bind(this, 'soTTVVaTuongDuong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soCBCCVCTrongBienChe, onChange: this.onChange.bind(this, 'soCBCCVCTrongBienChe') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.soLaoDongHopDong, onChange: this.onChange.bind(this, 'soLaoDongHopDong') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tiepNhanTuyenDung, onChange: this.onChange.bind(this, 'tiepNhanTuyenDung') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.nghiHuuChuyenCongTac, onChange: this.onChange.bind(this, 'nghiHuuChuyenCongTac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.boNhiemChucVuLanhDao, onChange: this.onChange.bind(this, 'boNhiemChucVuLanhDao') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.boNhiemVaoNgachNangNgach, onChange: this.onChange.bind(this, 'boNhiemVaoNgachNangNgach') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.chuyenDoiViTriCongTac, onChange: this.onChange.bind(this, 'chuyenDoiViTriCongTac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamKLPhaiXuLy, onChange: this.onChange.bind(this, 'viPhamKLPhaiXuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.viPhamKLDaXuLy, onChange: this.onChange.bind(this, 'viPhamKLDaXuLy') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoNhuCau, onChange: this.onChange.bind(this, 'tongSoNhuCau') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.tongSoDaThucHien, onChange: this.onChange.bind(this, 'tongSoDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienNhuCau, onChange: this.onChange.bind(this, 'thanhTraVienNhuCau') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienDaThucHien, onChange: this.onChange.bind(this, 'thanhTraVienDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienChinhNhuCau, onChange: this.onChange.bind(this, 'thanhTraVienChinhNhuCau') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienChinhDaThucHien, onChange: this.onChange.bind(this, 'thanhTraVienChinhDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienCaoCapNhuCau, onChange: this.onChange.bind(this, 'thanhTraVienCaoCapNhuCau') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.thanhTraVienCaoCapDaThucHien, onChange: this.onChange.bind(this, 'thanhTraVienCaoCapDaThucHien') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daoTaoLyLuanChinhTri, onChange: this.onChange.bind(this, 'daoTaoLyLuanChinhTri') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: typeof item.donVi != 'undefined' && !item.donVi.id && this.props.nullElement != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.daoTaoKhac, onChange: this.onChange.bind(this, 'daoTaoKhac') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement == true || this.props.sum == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            item && item.ghiChu ? item.ghiChu : ''
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.nullElement != true && this.props.sum != true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left' },
            _react2.default.createElement(_common.Input, { placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu') })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lapBaoCaoTongHop == true },
          _react2.default.createElement(
            'td',
            { className: 'txt-left middle-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: item.laySoLieu == false && item.donVi && item.donVi.id != 'TONG_CONG' && item.donVi.trangThaiBaoCao == 'KHOA_BAO_CAO' },
              _react2.default.createElement(
                'span',
                { className: 'pointer txt-blue', onClick: this.importData.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon pt-icon-log-out mr5' }),
                'l\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemXayDungLucLuongThanhTra;
}(_react2.default.Component);

RowItemXayDungLucLuongThanhTra.defaultProps = {
  nullElement: false,
  onChange: function onChange() {}
};

exports.default = RowItemXayDungLucLuongThanhTra;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaoCaoDinhKy = __webpack_require__(972);

var _BaoCaoDinhKy2 = _interopRequireDefault(_BaoCaoDinhKy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaoCaoDinhKy2.default;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _ttForms = __webpack_require__(19);

var _utils = __webpack_require__(4);

var _datatable = __webpack_require__(191);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaoCaoTongHop = function (_React$Component) {
  _inherits(BaoCaoTongHop, _React$Component);

  function BaoCaoTongHop(props, context) {
    _classCallCheck(this, BaoCaoTongHop);

    var _this = _possibleConstructorReturn(this, (BaoCaoTongHop.__proto__ || Object.getPrototypeOf(BaoCaoTongHop)).call(this, props, context));

    _this.state = {
      data: [],
      searchLoading: false,
      loaiKy: 'THEO_QUY',
      tuNgay: '',
      denNgay: '',
      quy: _this.getQuy(new Date().getMonth() + 1),
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      tableLoading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      kyBaoCaoList: []
    };
    return _this;
  }

  _createClass(BaoCaoTongHop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.goBack) {
        var dataSearch = this.props.dataSearch;
        this.state.pageData.number = dataSearch.page || 0;
        this.state.pageData.size = dataSearch.size || 10;
        this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY';
        this.state.quy = dataSearch.quy || this.getQuy(new Date().getMonth() + 1);
        this.state.year = dataSearch.year || new Date().getFullYear();
        this.state.month = dataSearch.month || new Date().getMonth() + 1;
        this.setState(_extends({}, this.state));
        this.getListData(false, true);
      } else {
        this.getListData();
      }
      this.getKyBaoCaoData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.goBack) {
        var dataSearch = nextProps.dataSearch;
        this.state.pageData.number = dataSearch.page || 0;
        this.state.pageData.size = dataSearch.size || 0;
        this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY';
        this.state.quy = dataSearch.quy || this.getQuy(new Date().getMonth() + 1);
        this.state.year = dataSearch.year || new Date().getFullYear();
        this.state.month = dataSearch.month || new Date().getMonth() + 1;
        this.setState(_extends({}, this.state));
        this.getListData(false, true);
      }
    }
  }, {
    key: 'getKyBaoCaoData',
    value: function getKyBaoCaoData() {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getKyBaoCao.request().then(function (res) {
        if (res.data) {
          _this2.setState({ kyBaoCaoList: res.data });
        } else {
          _this2.setState({ kyBaoCaoList: [] });
        }
      });
    }
  }, {
    key: 'getQuy',
    value: function getQuy(month) {
      if (month > 0 && month < 4) {
        return 1;
      } else if (month > 3 && month < 7) {
        return 2;
      } else if (month > 6 && month < 10) {
        return 3;
      } else if (month > 9 && month < 13) {
        return 4;
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData(false, true);
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData(false, true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch, pageClick) {
      var _this3 = this;

      this.props.dispatch({ type: 'BCTH_RESET_GO_BACK' });
      if (isSearch) {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }

      var params = {
        loaiKy: this.state.loaiKy,
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (this.state.loaiKy != 'TUY_CHON' && this.state.year) {
        params.year = this.state.year;
      }
      if (this.state.loaiKy == 'THEO_QUY' && this.state.quy) {
        params.quy = this.state.quy;
      }
      if (this.state.loaiKy == 'THEO_THANG' && this.state.month) {
        params.month = this.state.month;
      }
      if (isSearch || pageClick) {
        this.props.dispatch({ type: 'BCTH_UPDATE_DATA_SEARCH', dataSearch: params });
      }
      if (this.state.loaiKy === 'TUY_CHON' && this.state.tuNgay) {
        params.tuNgay = this.state.tuNgay;
      }
      if (this.state.loaiKy === 'TUY_CHON' && this.state.denNgay) {
        params.denNgay = this.state.denNgay;
      }
      _api.ThongKeBaoCao.actions.getBaoCaoTongHop.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            data: res.data._embedded.baoCaoTongHops,
            pageData: res.data.page
          });
        } else {
          _this3.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'loaiKy') {
        var _setState;

        this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'year', new Date().getFullYear()), _defineProperty(_setState, 'month', 1), _defineProperty(_setState, 'quy', 1), _setState));
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p b\xE1o c\xE1o'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl25 pr25 pt15 super-search' },
              _react2.default.createElement(
                'div',
                { className: 'col-83 no-gutter' },
                _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'K\u1EF3 b\xE1o c\xE1o', options: this.state.kyBaoCaoList, keyName: 'giaTri', valueName: 'ten', placeholder: null, selectedValue: this.state.loaiKy, onChange: this.onChange.bind(this, 'loaiKy') }),
                this.state.loaiKy != 'TUY_CHON' && _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'year'), selectedValue: this.state.year }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy == 'THEO_QUY' },
                  _react2.default.createElement(_ttForms.DropDownChonLoaiQuyThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'quy'), selectedValue: this.state.quy })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy == 'THEO_THANG' },
                  _react2.default.createElement(_ttForms.DropDownChonLoaiThangThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'month'), selectedValue: this.state.month })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiKy === 'TUY_CHON' },
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'T\u1EEB ng\xE0y', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, require: true, bindValidator: this, channel: 'formTaoDon' }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: '\u0110\u1EBFn ng\xE0y', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, require: true, bindValidator: this, channel: 'formTaoDon' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-16 btn-thongke clear-right' },
                _react2.default.createElement(_core.Button, { className: this.state.tableLoading ? this.state.searchLoading ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable' : 'btn-green tt-search', text: 'Xem k\u1EBFt qu\u1EA3', onClick: this.getListData.bind(this, true) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.baoCaoTongHop,
                  dataList: this.state.data,
                  pageData: this.state.pageData,
                  parent: this,
                  hideExport: true,
                  search: this.state.searchLoading,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemBaoCaoTongHop, null)
              )
            )
          )
        )
      );
    }
  }]);

  return BaoCaoTongHop;
}(_react2.default.Component);

BaoCaoTongHop.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function BindStateToProps(state) {
  return {
    dataSearch: state.baoCaoTongHop.dataSearch,
    goBack: state.baoCaoTongHop.goBack
  };
}

exports.default = (0, _reactRedux.connect)(BindStateToProps)(BaoCaoTongHop);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(191);

var _TableKetQuaPhongChongThamNhung = __webpack_require__(307);

var _TableKetQuaPhongChongThamNhung2 = _interopRequireDefault(_TableKetQuaPhongChongThamNhung);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietBaoCaoTaiDonVi = function (_React$Component) {
  _inherits(ChiTietBaoCaoTaiDonVi, _React$Component);

  function ChiTietBaoCaoTaiDonVi(props, context) {
    _classCallCheck(this, ChiTietBaoCaoTaiDonVi);

    var _this = _possibleConstructorReturn(this, (ChiTietBaoCaoTaiDonVi.__proto__ || Object.getPrototypeOf(ChiTietBaoCaoTaiDonVi)).call(this, props, context));

    _this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {},
        donViConsInfo: []
      },
      rowData: [],
      tableLoading: false,
      totalCol: 0,
      header: [],
      dataSum: {}
    };
    return _this;
  }

  _createClass(ChiTietBaoCaoTaiDonVi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.id) {
        this.getInfo(this.props.params.id);
        this.getRowDuLieu(this.props.params.id);
      }
    }
  }, {
    key: 'getInfo',
    value: function getInfo(idBC) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getBaoCaoDonViChiTiet.request({ id: idBC }).then(function (res) {
        if (res.data) {
          res.data.listTaiLieuBaoCao = res.data.listTaiLieuBaoCao.map(function (item) {
            return item = _extends({}, item, {
              soQuyetDinh: item.soVanBan,
              ngayQuyetDinh: item.ngayRaVanBan
            });
          });
          _this2.state.data = res.data;
          _this2.state.dataSum = res.data;
          _this2.setState(_extends({}, _this2.state));
        }
      });
    }
  }, {
    key: 'getRowDuLieu',
    value: function getRowDuLieu(idBC) {
      var _this3 = this;

      this.setState({ tableLoading: true });
      _api.ThongKeBaoCao.actions.getBaoCaoDonViChiTietRow.request({ id: idBC }).then(function (res) {
        if (res.data && res.data._embedded) {
          res.data._embedded.baoCaoDonViChiTiets.map(function (item) {
            item.donVi = {
              ten: item.soLieuBaoCaoInfo.tenDonVi,
              id: item.donViInfo ? item.donViInfo.donViId : ''
            };
          });
          _this3.setState({
            rowData: res.data._embedded.baoCaoDonViChiTiets,
            tableLoading: false
          });
        } else {
          _this3.setState({
            rowData: [],
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: _reactRouter.browserHistory.goBack },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_QUY' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : '') + ' qu\xFD ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.quyBaoCao : '') + ' n\u0103m ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : '')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_THANG' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : '') + ' th\xE1ng ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.thangBaoCao : '') + ' n\u0103m ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : '')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao != 'THEO_THANG' && this.state.data.thongTinBaoCaoInfo.kyBaoCao != 'THEO_QUY' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : '') + ' ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.kyBaoCaoText : '') + ' n\u0103m ' + (this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : '')
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pt20 pl20 pr20' },
                '1. Th\xF4ng tin b\xE1o c\xE1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl25 pr25' },
              _react2.default.createElement(_common.Text, { className: 'col-100 mt15', label: 'Bi\u1EC3u m\u1EABu:', value: this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input mt15', label: 'K\u1EF3 b\xE1o c\xE1o:', value: this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.kyBaoCaoText : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-input mt15', label: 'N\u0103m b\xE1o c\xE1o:', value: this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_QUY' },
                _react2.default.createElement(_common.Text, { className: 'col-input mt15', label: 'Qu\xFD:', value: this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.quyBaoCao : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_THANG' },
                _react2.default.createElement(_common.Text, { className: 'col-input mt15', label: 'Th\xE1ng:', value: this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.thangBaoCao + 1 : '' })
              ),
              _react2.default.createElement(_common.Text, { className: 'col-100 mt15 mb15', label: '\u0110\u01A1n v\u1ECB:', value: this.state.data.baoCaoDonViInfo ? this.state.data.baoCaoDonViInfo.tenDonVi : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pl20 pr20' },
                '2. S\u1ED1 li\u1EC7u b\xE1o c\xE1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_HANH_CHINH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraHanhChinh,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 33,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraHanhChinh, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraXayDungCoBan,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 33,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraHanhChinh, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraTaiChinhNganSach,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 27,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraTaiChinhNganHang, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraDatDai,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 43,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraDatDai, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_LAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraLai,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 31,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraLai, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraChuyenNganh,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 29,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaThanhTraChuyenNganh, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoThanhTraThamNhung,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 27,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaXuLyThamNhung, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.nhaNuocVeThanhTra,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 23,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemCongTacQuanLyThanhTra, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.xayDungLucLuongThanhTra,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 26,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemCongTacXayDung, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_TIEP_CONG_DAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoTiepCongDan,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 37,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemKetQuaTiepCongDan, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoXuLyDon,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 33,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemXLDKhieuNaiToCao, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoGiaiQuyetDonKN,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 40,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemGQDKN, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_GIAI_QUYET_DON_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 35,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemGQDTC, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.quanLyNhaNuocVeKhieuNaiToCao,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 19,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemQLNNKNTC, null)
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG' },
                _react2.default.createElement(_TableKetQuaPhongChongThamNhung2.default, {
                  addNew: false,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                  dataList: this.state.rowData,
                  hidePagination: true,
                  parent: this,
                  hideExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: 33,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data.loaiBaoCao == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    header: _table.header.tongHopSoLieu,
                    dataSum: this.state.dataSum,
                    hidePagination: true,
                    numberColumnHeader: 12,
                    ThongKeBaoCao: true,
                    dataList: this.state.rowData,
                    hideExport: true,
                    parent: this,
                    tableLoading: this.state.tableLoading },
                  _react2.default.createElement(_datatable.RowItemSLKKXMTS, null)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '3. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, disableAttachFile: true, dataShow: this.state.data.listTaiLieuBaoCao })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: _reactRouter.browserHistory.goBack },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietBaoCaoTaiDonVi;
}(_react2.default.Component);

exports.default = ChiTietBaoCaoTaiDonVi;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(191);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietDonViBCTH = function (_React$Component) {
  _inherits(ChiTietDonViBCTH, _React$Component);

  function ChiTietDonViBCTH(props, context) {
    _classCallCheck(this, ChiTietDonViBCTH);

    var _this = _possibleConstructorReturn(this, (ChiTietDonViBCTH.__proto__ || Object.getPrototypeOf(ChiTietDonViBCTH)).call(this, props, context));

    _this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false
    };
    return _this;
  }

  _createClass(ChiTietDonViBCTH, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.id) {
        this.getInfo(this.props.params.id);
        this.getLoaiBaoCaoList(this.props.params.id);
      }
    }
  }, {
    key: 'getInfo',
    value: function getInfo(idBC) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getBaoCaoDinhKyChiTiet.request({ id: idBC }).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiBaoCaoList',
    value: function getLoaiBaoCaoList(idBC) {
      var _this3 = this;

      this.setState({ tableLoading: true });
      _api.ThongKeBaoCao.actions.getBaoCaoDinhKyLoaiDon.request({ id: idBC }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            loaiBaoCao: res.data._embedded.baoCaoDonViChiTiets,
            tableLoading: false
          });
        } else {
          _this3.setState({
            loaiBaoCao: [],
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: _reactRouter.browserHistory.goBack },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                this.state.data.baoCaoTongHopInfo ? this.state.data.baoCaoTongHopInfo.tenBaoCao : '',
                ' n\u0103m ',
                this.state.data.baoCaoTongHopInfo ? this.state.data.baoCaoTongHopInfo.namBaoCao : '',
                ' c\u1EE7a ',
                this.state.data.donViInfo ? this.state.data.donViInfo.ten : ''
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pt20 pl20 pr20' },
                '1. Danh s\xE1ch bi\u1EC3u m\u1EABu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.chiTietDonViBCTH,
                  dataList: this.state.loaiBaoCao,
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemChiTietDonViBCTH, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '2. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, disableAttachFile: true, dataShow: this.state.data.listTaiLieuBaoCao })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: _reactRouter.browserHistory.goBack },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietDonViBCTH;
}(_react2.default.Component);

exports.default = ChiTietDonViBCTH;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(191);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachBaoCaoBCTH = function (_React$Component) {
  _inherits(DanhSachBaoCaoBCTH, _React$Component);

  function DanhSachBaoCaoBCTH(props, context) {
    _classCallCheck(this, DanhSachBaoCaoBCTH);

    var _this = _possibleConstructorReturn(this, (DanhSachBaoCaoBCTH.__proto__ || Object.getPrototypeOf(DanhSachBaoCaoBCTH)).call(this, props, context));

    _this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false,
      dataFileDinhKem: [],
      dataFileDinhKemDelete: []
    };
    return _this;
  }

  _createClass(DanhSachBaoCaoBCTH, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.id) {
        this.getInfo(this.props.params.id);
        this.getLoaiBaoCaoList(this.props.params.id);
      }
    }
  }, {
    key: 'getInfo',
    value: function getInfo(idBC) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getBaoCaoTongHopChiTiet.request({ id: idBC }).then(function (res) {
        if (res.data) {
          res.data.listTaiLieuBaoCao.map(function (item) {
            item.soQuyetDinh = item.soVanBan;
            item.ngayQuyetDinh = item.ngayRaVanBan;
            return item;
          });
          _this2.setState({
            data: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiBaoCaoList',
    value: function getLoaiBaoCaoList(idBC) {
      var _this3 = this;

      this.setState({ tableLoading: true });
      _api.ThongKeBaoCao.actions.getBaoCaoTongHopDSBaoCao.request({ id: idBC }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            loaiBaoCao: res.data._embedded.baoCaoTongHopChiTiets,
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'pushTaiLieuDinhKem',
    value: function pushTaiLieuDinhKem() {
      var _this4 = this;

      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      var taiLieuVanThuUpdate = [];
      var taiLieuVanThuPost = [];
      var taiLieuVanThuDelete = [];

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            taiLieuVanThuUpdate = [].concat(_toConsumableArray(taiLieuVanThuUpdate), [{
              baoCaoTongHop: {
                id: Number(_this4.props.params.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            }]);
          } else {
            taiLieuVanThuPost = [].concat(_toConsumableArray(taiLieuVanThuPost), [{
              baoCaoTongHop: {
                id: Number(_this4.props.params.id)
              },
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            }]);
          }
        });
      }

      this.state.dataFileDinhKemDelete.forEach(function (item) {
        taiLieuVanThuDelete = [].concat(_toConsumableArray(taiLieuVanThuDelete), [{
          id: item
        }]);
      });

      this.postTaiLieuVanThu(taiLieuVanThuPost, function () {
        _this4.updateTaiLieuVanThu(taiLieuVanThuUpdate, function () {
          _this4.deleteTaiLieuVanThu(taiLieuVanThuDelete, function () {
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
            _reactRouter.browserHistory.goBack();
          });
        });
      });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(files, callback) {
      if (files.length) {
        var params = {
          taiLieuBaoCaos: files
        };
        _api.ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          callback();
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(files, callback) {
      if (files.length) {
        var params = {
          taiLieuBaoCaos: files
        };
        _api.ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          callback();
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(files, callback) {
      if (files.length) {
        var params = {
          taiLieuBaoCaos: files
        };
        _api.ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          callback();
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dataFileDinhKemDelete = [].concat(_toConsumableArray(this.state.dataFileDinhKemDelete), [id]);
      this.state.dataFileDinhKem = data;
      this.forceUpdate();
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.pushTaiLieuDinhKem();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: _reactRouter.browserHistory.goBack },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p ',
                this.state.data.tenBaoCao,
                ' n\u0103m ',
                this.state.data.namBaoCao
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pt20 pl20 pr20' },
                '1. Danh s\xE1ch bi\u1EC3u m\u1EABu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.baoCaoTongHopDSBC,
                  dataList: this.state.loaiBaoCao,
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemDanhSachBaoCaoBCTH, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 ' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '2. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, bindValidator: this, data: this.state.data.listTaiLieuBaoCao, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), allowExcelFile: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: _reactRouter.browserHistory.goBack },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-save btn-green', onClick: this.handleSave.bind(this) },
                'L\u01B0u'
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachBaoCaoBCTH;
}(_react2.default.Component);

exports.default = DanhSachBaoCaoBCTH;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(191);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDonViBCTH = function (_React$Component) {
  _inherits(DanhSachDonViBCTH, _React$Component);

  function DanhSachDonViBCTH(props, context) {
    _classCallCheck(this, DanhSachDonViBCTH);

    var _this = _possibleConstructorReturn(this, (DanhSachDonViBCTH.__proto__ || Object.getPrototypeOf(DanhSachDonViBCTH)).call(this, props, context));

    _this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false,
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      hasChange: false,
      backConfirm: false,
      showTHButton: false
    };
    return _this;
  }

  _createClass(DanhSachDonViBCTH, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.id) {
        this.getInfo(this.props.params.id);
        this.getDonViBaoCaoList(this.props.params.id);
      }
    }
  }, {
    key: 'getInfo',
    value: function getInfo(idBC) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getBaoCaoTongHopChiTiet.request({ id: idBC }).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViBaoCaoList',
    value: function getDonViBaoCaoList(idBC) {
      var _this3 = this;

      this.setState({ tableLoading: true });
      _api.ThongKeBaoCao.actions.getBaoCaoTongHopDSDonVi.request({ id: idBC }).then(function (res) {
        if (res.data && res.data._embedded) {
          res.data._embedded.baoCaoDonVis.forEach(function (item) {
            if (item.trangThaiBaoCao !== 'DANG_SOAN') {
              _this3.setState({ showTHButton: true });
            }
          });
          _this3.setState({ loaiBaoCao: res.data._embedded.baoCaoDonVis });
        } else {
          _this3.setState({ loaiBaoCao: [], showTHButton: false });
        }
        _this3.setState({ tableLoading: false });
      }).catch(function (err) {
        _this3.setState({ tableLoading: false });
      });
    }
  }, {
    key: 'goToPage',
    value: function goToPage() {
      _reactRouter.browserHistory.push('/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-bao-cao/' + this.props.params.id);
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.props.dispatch({ type: 'BCTH_GO_BACK' });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'handleLock',
    value: function handleLock(item) {
      var _this4 = this;

      var params = {
        daKhoa: true
      };
      if (!item.isLock) {
        params.daKhoa = false;
        params.hanBaoCao = (0, _moment2.default)(item.thoiHan, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.ThongKeBaoCao.actions.updateBaoCaoDonVi.request({ id: item.baoCaoDonViId }, params).then(function (res) {
        if (res.data) {
          (0, _toastr.Toastr)('Khóa báo cáo thành công', 'success');
          _this4.getDonViBaoCaoList(_this4.props.params.id);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              'span',
              { className: 'arrow-left txt-blue txt-underline', onClick: this.goBack.bind(this) },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'Danh s\xE1ch \u0111\u01A1n v\u1ECB ',
                this.state.data.tenBaoCao,
                ' n\u0103m ',
                this.state.data.namBaoCao
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.baoCaoTongHopDSDonVi,
                  dataList: this.state.loaiBaoCao,
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  tableLoading: this.state.tableLoading
                },
                _react2.default.createElement(_datatable.RowItemDanhSachDonViBCTH, { onLock: this.handleLock.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: this.goBack.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              this.state.showTHButton && _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-green', onClick: this.goToPage.bind(this) },
                _react2.default.createElement('span', { className: 'pt-icon-standard pt-icon-layers' }),
                ' T\u1ED5ng h\u1EE3p'
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachDonViBCTH;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(DanhSachDonViBCTH);

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _layout = __webpack_require__(9);

var _core = __webpack_require__(7);

var _dialog = __webpack_require__(18);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _TableKetQuaPhongChongThamNhung = __webpack_require__(307);

var _TableKetQuaPhongChongThamNhung2 = _interopRequireDefault(_TableKetQuaPhongChongThamNhung);

var _datatable = __webpack_require__(233);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LapBaoCaoTongHop = function (_React$Component) {
  _inherits(LapBaoCaoTongHop, _React$Component);

  function LapBaoCaoTongHop(props, context) {
    _classCallCheck(this, LapBaoCaoTongHop);

    var _this = _possibleConstructorReturn(this, (LapBaoCaoTongHop.__proto__ || Object.getPrototypeOf(LapBaoCaoTongHop)).call(this, props, context));

    _this.state = {
      data: [],
      dataDelete: [],
      loaiBaoCao: [],
      tableLoading: false,
      update: false,
      showFile: false,
      listTaiLieuBaoCao: [],
      listTaiLieuVanThu: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      dataTaiLieuVanThuDelete: [],
      thongTinBaoCao: {},
      headerTable: [],
      trangThaiBaoCao: '',
      baoCaoTongHopChiTietId: '',
      hasChange: false,
      backConfirm: false,
      checkComponent: false,
      numberColumnHeader: 50,
      convertData: false,
      openDialog: false,
      dataSum: { donVi: { id: 'DATA_SUM' } },
      dataOption: [],
      popupChotBaoCao: false
    };
    return _this;
  }

  _createClass(LapBaoCaoTongHop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDataLapBaoCaoTongHopChiTiet(this.props.params.id);
      this.getLapBaoCaoTongHopChiTiet(this.props.params.id);
    }
  }, {
    key: 'getDataLapBaoCaoTongHopChiTietKhac',
    value: function getDataLapBaoCaoTongHopChiTietKhac(id) {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getDataLapBaoCaoTongHopChiTietKhac.request({ idBaoCaoTongHopChiTiet: id }).then(function (res) {
        if (res.data && res.data._embedded) {
          var data = [].concat(_toConsumableArray(res.data._embedded.baoCaoTongHopChiTietKhacs));
          var newData = [].concat(_toConsumableArray(_this2.state.data));
          data.map(function (item) {
            var itemDetail = item.soLieuBaoCaoInfo || {};
            itemDetail.donVi = {
              id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
              ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
            };
            itemDetail.id = item.baoCaoTongHopChiTietKhacId;
            newData.push(itemDetail);
          });
          _this2.setState({
            data: newData
          });
          _this2.checkSum(newData);
        } else {
          _this2.checkSum(_this2.state.data);
        }
      });
    }
  }, {
    key: 'getDataLapBaoCaoTongHopChiTiet',
    value: function getDataLapBaoCaoTongHopChiTiet(id) {
      var _this3 = this;

      _api.ThongKeBaoCao.actions.getDataLapBaoCaoTongHopChiTiet.request({ id: id }).then(function (res) {
        if (res.data && res.data._embedded) {
          var data = [].concat(_toConsumableArray(res.data._embedded.baoCaoDonViChiTiets));
          var newData = [];
          data.map(function (item) {
            var itemDetail = item.soLieuBaoCaoInfo || {};
            itemDetail.donVi = {
              id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
              ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : '',
              trangThaiBaoCao: item.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri ? item.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri : ''
            };
            itemDetail.id = item.baoCaoDonViChiTietId;
            itemDetail.laySoLieu = item.laySoLieu;
            itemDetail.trangThaiBaoCao = item.trangThaiBaoCao;
            newData.push(itemDetail);
          });
          _this3.setState({
            data: newData
          }, function () {
            _this3.getDataLapBaoCaoTongHopChiTietKhac(id);
          });
        }
      });
    }
  }, {
    key: 'importData',
    value: function importData(index, id) {
      var _this4 = this;

      _api.ThongKeBaoCao.actions.laySoLieuTongHop.request({ id: id }).then(function (res) {
        if (res.data) {
          var item = res.data;
          var itemDetail = item.soLieuBaoCaoInfo || {};
          itemDetail.donVi = {
            id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
            ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
          };
          itemDetail.id = item.baoCaoDonViChiTietId;
          itemDetail.laySoLieu = item.laySoLieu;
          _this4.state.data[index] = itemDetail;

          _this4.setState(_extends({}, _this4.state), function () {
            _this4.checkSum(_this4.state.data);
          });
          var message = 'Dữ liệu của ' + itemDetail.tenDonVi + ' đã được cập nhật';
          (0, _toastr.Toastr)(message, 'success');
        }
      });
    }
  }, {
    key: 'CheckNullObj',
    value: function CheckNullObj(obj) {
      var newObj = _extends({}, obj);
      delete newObj['donVi'];
      delete newObj['addNew'];
      delete newObj['id'];
      for (var member in newObj) {
        if (newObj[member] != null && newObj[member] != 0 && newObj[member] != '') {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'checkSum',
    value: function checkSum(arr) {
      if (arr.length > 0) {
        var newObj = arr[0];
        var dataSum = {
          donVi: {
            id: 'DATA_SUM',
            ten: 'dataSum'
          }
        };
        for (var member in newObj) {
          if (member != 'id' && member != 'donVi' && member != 'tenDonVi' && member != 'ghiChu') {
            var sum = this.checkSumElement(arr, member);
            dataSum[member] = sum;
          }
        }
        this.setState({
          dataSum: dataSum
        });
      }
    }
  }, {
    key: 'checkSumElement',
    value: function checkSumElement(arr, field) {
      var sum = 0;
      if (arr.length > 0) {
        arr.map(function (item) {
          sum = sum + Number(item[field]);
        });
      }
      return sum;
    }
  }, {
    key: 'getLapBaoCaoTongHopChiTiet',
    value: function getLapBaoCaoTongHopChiTiet(id) {
      var _this5 = this;

      _api.ThongKeBaoCao.actions.getLapBaoCaoTongHopChiTiet.request({ id: id }).then(function (res) {
        if (res.data) {
          var data = res.data;
          _this5.state.baoCaoTongHopChiTietId = data.baoCaoTongHopChiTietId ? data.baoCaoTongHopChiTietId : '';
          _this5.state.trangThaiBaoCao = data.trangThaiBaoCao ? data.trangThaiBaoCao : '';
          _this5.state.listTaiLieuBaoCao = data.listTaiLieuBaoCao ? data.listTaiLieuBaoCao : [];
          _this5.state.thongTinBaoCao = data.thongTinBaoCaoInfo ? data.thongTinBaoCaoInfo : {};
          _this5.state.tenBaoCao = data.loaiBaoCaoInfo ? data.loaiBaoCaoInfo.ten : '';
          _this5.state.nameRowItem = data.loaiBaoCao ? data.loaiBaoCao : '';
        }
        _this5.setState(_extends({}, _this5.state), function () {
          _this5.checkFileRequire();
        });
      });
    }
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      var data = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));

      var dataFilter = data.filter(function (state) {
        return state.typeRequired == 'BCDK_TLVT';
      });

      if (dataFilter.length > 0) {
        var dataOld = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));
        var newData = [];
        dataOld.map(function (item) {
          var newItem = {
            ten: item.ten,
            soQuyetDinh: item.soVanBan,
            required: item.required,
            typeRequired: item.typeRequired,
            tenFile: item.tenFile,
            taiLieuVanThuId: item.taiLieuBaoCaoId,
            ngayQuyetDinh: item.ngayRaVanBan,
            duongDan: item.urlFile
          };
          newData.push(newItem);
        });
        this.state.listTaiLieuVanThu = newData;
        this.state.showFile = true;
      } else {
        var _dataOld = [].concat(_toConsumableArray(this.state.listTaiLieuBaoCao));
        var _newData = [];
        _dataOld.map(function (item) {
          var newItem = {
            ten: item.ten,
            soQuyetDinh: item.soVanBan,
            required: item.required,
            typeRequired: item.typeRequired,
            tenFile: item.tenFile,
            taiLieuVanThuId: item.taiLieuBaoCaoId,
            ngayQuyetDinh: item.ngayRaVanBan,
            duongDan: item.urlFile
          };
          _newData.push(newItem);
        });

        var itemRequired = {
          ten: 'Văn bản báo cáo',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BCDK_TLVT',
          newFile: true
        };
        this.state.listTaiLieuVanThu = [].concat(_newData, [itemRequired]);
        this.state.showFile = true;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data,
        hasChange: true
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dataFileDinhKemDelete = [].concat(_toConsumableArray(this.state.dataFileDinhKemDelete), [id]);
      this.state.dataFileDinhKem = data;
      this.state.hasChange = true;
      this.forceUpdate();
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack == true) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.setState({ backConfirm: true });
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({ backConfirm: false });
    }
  }, {
    key: 'guiBaoCao',
    value: function guiBaoCao(type) {
      var _this6 = this;

      if (type == 'export' || this.validateSubmitForm()) {
        this.pushTaiLieuDinhKem();
        var paramsPost = this.getParams('POST');
        var paramsPatch = this.getParams('PATCH');
        var paramsPatchKhac = this.getParams('PATCH_KHAC');
        this.checkDelete(paramsPost, paramsPatch, paramsPatchKhac, type, function () {
          _this6.checkCreate(paramsPost, paramsPatch, paramsPatchKhac, type, function () {
            _this6.checkOtherEdit(paramsPatch, paramsPatchKhac, type, function () {
              _this6.checkEdit(paramsPatch, type, function () {
                if (type == 'export') {
                  var URL = _config.API_URL + "/baoCaoTongHopChiTiets/xuatExcel?" + "idBaoCaoTongHopChiTiet=" + Number(_this6.props.params.id);
                  window.open(URL, "_self");
                }
              });
            });
          });
        });

        if (paramsPost.length == 0 && paramsPatchKhac.length == 0 && this.state.dataDelete.length == 0 && paramsPatch.length == 0) {
          if (type != 'export') {
            this.handleBack(true);
          }
          (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
        }
      }
    }
  }, {
    key: 'checkEdit',
    value: function checkEdit(paramsPatch, type, callBack) {
      var _this7 = this;

      if (paramsPatch.length > 0) {
        var params = {
          baoCaoDonViChiTiets: [].concat(_toConsumableArray(paramsPatch))
        };
        _api.ThongKeBaoCao.actions.patchBaoCaoTongHop.request('', params).then(function (res) {
          if (type != 'export') {
            _this7.handleBack(true);
          }
          callBack();
          (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'checkOtherEdit',
    value: function checkOtherEdit(paramsPatch, paramsPatchKhac, type, callBack) {
      var _this8 = this;

      if (paramsPatchKhac.length > 0) {
        var params = {
          baoCaoTongHopChiTietKhacs: [].concat(_toConsumableArray(paramsPatchKhac))
        };
        _api.ThongKeBaoCao.actions.patchBaoCaoTongHopKhac.request('', params).then(function (res) {
          if (paramsPatch.length == 0) {
            if (type != 'export') {
              _this8.handleBack(true);
            }
            callBack();
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
          } else {
            callBack();
          }
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'checkCreate',
    value: function checkCreate(paramsPost, paramsPatch, paramsPatchKhac, type, callBack) {
      var _this9 = this;

      if (paramsPost.length > 0) {
        var params = {
          baoCaoTongHopChiTietKhacs: [].concat(_toConsumableArray(paramsPost))
        };
        _api.ThongKeBaoCao.actions.postBaoCaoTongHop.request('', params).then(function (res) {
          if (paramsPatchKhac.length == 0 && paramsPatch.length == 0) {
            if (type != 'export') {
              _this9.handleBack(true);
            }
            callBack();
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
          } else {
            callBack();
          }
          _this9.getDataLapBaoCaoTongHopChiTiet(_this9.props.params.id);
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'checkDelete',
    value: function checkDelete(paramsPost, paramsPatch, paramsPatchKhac, type, callBack) {
      var _this10 = this;

      if (this.state.dataDelete.length > 0) {
        var params = {
          baoCaoTongHopChiTietKhacs: [].concat(_toConsumableArray(this.state.dataDelete))
        };
        _api.ThongKeBaoCao.actions.deleteBaoCaoTongHop.request('', params).then(function (res) {
          if (paramsPost.length == 0 && paramsPatch.length == 0 && paramsPatchKhac.length == 0) {
            if (type != 'export') {
              _this10.handleBack(true);
            }
            callBack();
            (0, _toastr.Toastr)(_message.msg.dkLuuHoSo, 'success');
          } else {
            callBack();
          }
        }).catch(function (err) {
          callBack();
        });
      } else {
        callBack();
      }
    }
  }, {
    key: 'pushTaiLieuDinhKem',
    value: function pushTaiLieuDinhKem() {
      var _this11 = this;

      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this11.state.taiLieuVanThuUpdate[_this11.state.taiLieuVanThuUpdate.length] = {
              baoCaoTongHopChiTiet: {
                id: Number(_this11.props.params.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this11.state.taiLieuVanThu[_this11.state.taiLieuVanThu.length] = {
              baoCaoTongHopChiTiet: {
                id: Number(_this11.props.params.id)
              },
              ten: item.ten,
              soVanBan: item.soQuyetDinh,
              ngayRaVanBan: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              urlFile: item.duongDan,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this11.state.taiLieuVanThuDelete[_this11.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuBaoCaos: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }

      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuBaoCaos: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }

      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuBaoCaos: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
      this.setState({ dataFileDinhKem: [] });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'getParams',
    value: function getParams(type) {
      var _this12 = this;

      var data = [].concat(_toConsumableArray(this.state.data));
      if (type == 'POST') {
        var dataPost = [];
        var dataPostFilter = data.filter(function (state) {
          return state.addNew == true;
        });
        dataPostFilter.map(function (state) {
          if (_this12.CheckNullObj(state)) {
            // do nothing
          } else {
            var item = {
              baoCaoTongHopChiTiet: {
                id: Number(_this12.props.params.id)
              },
              soLieuBaoCao: _extends({}, state)
            };
            delete item.soLieuBaoCao['donVi'];
            delete item.soLieuBaoCao['addNew'];
            dataPost.push(item);
          }
        });

        return dataPost;
      } else if (type == 'PATCH') {
        var dataPatch = [];
        var dataPatchFilter = data.filter(function (state) {
          return state.addNew != true && state.donVi.id;
        });
        dataPatchFilter.map(function (state) {
          var item = {
            soLieuBaoCao: _extends({}, state)
          };
          if (state.id) {
            item.baoCaoDonViChiTietId = state.id;
          }
          delete item.soLieuBaoCao['donVi'];
          delete item.soLieuBaoCao['addNew'];
          delete item.soLieuBaoCao['id'];
          delete item.soLieuBaoCao['laySoLieu'];
          delete item.soLieuBaoCao['trangThaiBaoCao'];
          dataPatch.push(item);
        });
        return dataPatch;
      } else {
        var _dataPatch = [];
        var _dataPatchFilter = data.filter(function (state) {
          return state.addNew != true && !state.donVi.id;
        });
        _dataPatchFilter.map(function (state) {
          if (_this12.CheckNullObj(state)) {
            var itemDelete = {
              id: state.id
            };
            _this12.state.dataDelete.push(itemDelete);
          } else {
            var item = {
              baoCaoTongHopChiTiet: {
                id: Number(_this12.props.params.id)
              },
              soLieuBaoCao: _extends({}, state)
            };
            if (state.id) {
              item.baoCaoTongHopChiTietKhacId = state.id;
            }
            delete item.soLieuBaoCao['donVi'];
            delete item.soLieuBaoCao['addNew'];
            delete item.soLieuBaoCao['id'];
            delete item.soLieuBaoCao['laySoLieu'];
            delete item.soLieuBaoCao['trangThaiBaoCao'];
            _dataPatch.push(item);
          }
        });
        return _dataPatch;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {}
  }, {
    key: 'addNewItem',
    value: function addNewItem() {
      var _this13 = this;

      _api.ThongKeBaoCao.actions.getItemHeThongLapBaoCaoTongHopChiTiet.request({ idBaoCaoTongHopChiTiet: this.props.params.id }).then(function (res) {
        if (res.data) {
          var item = res.data;
          var newItem = item.soLieuBaoCaoInfo;
          newItem.donVi = {
            id: null,
            ten: ''
          };
          newItem.addNew = true;
          _this13.setState({
            data: [].concat(_toConsumableArray(_this13.state.data), [newItem])
          });
        }
      });
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onRemoveItem',
    value: function onRemoveItem(id) {
      var _this14 = this;

      var data = [].concat(_toConsumableArray(this.state.data));
      var index = data.findIndex(function (x) {
        return x.donVi.id == id;
      });
      if (index != -1) {
        var itemDelete = {
          id: data[index].id
        };
        this.state.dataDelete.push(itemDelete);
        data.splice(index, 1);
        this.state.data = data;
        this.setState(_extends({}, this.state), function () {
          _this14.checkSum(_this14.state.data);
        });
      }
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onChangeHeader',
    value: function onChangeHeader(index, e) {
      this.state.data[index].tenDonVi = e.target.value;
      this.state.data[index].donVi = {
        id: null,
        ten: e.target.value
      };
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onItemChange',
    value: function onItemChange(index, data) {
      var _this15 = this;

      this.state.data[index] = _extends({}, this.state.data[index], data);
      this.state.hasChange = true;
      this.setState(_extends({}, this.state), function () {
        _this15.checkSum(_this15.state.data);
      });
    }
  }, {
    key: 'reciveData',
    value: function reciveData(data) {
      var _this16 = this;

      this.state.data = data;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state), function () {
        _this16.checkSum(_this16.state.data);
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'exportExcel',
    value: function exportExcel(type) {
      if (type == 'export') {
        this.setState({
          openDialog: false,
          hasChange: false
        });
        this.guiBaoCao('export');
        this.setState({ popupChotBaoCao: true });
      } else if (this.state.hasChange == true) {
        this.setState({
          openDialog: true
        });
      } else {
        this.guiBaoCao('export');
        this.setState({ popupChotBaoCao: true });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'chotBaoCao',
    value: function chotBaoCao(inputId) {
      var _this17 = this;

      _api.ThongKeBaoCao.actions.patchChotSoLieuTongHop.request({ id: inputId }).then(function (res) {
        _this17.closeDialog('popupChotBaoCao');
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var ngayChot = (0, _moment2.default)().format('DD/MM/YYYY');
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: _reactRouter.browserHistory.goBack },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.exportExcel.bind(this, 'export'),
            title: _message.msg.confirmExportExcel }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.popupChotBaoCao, onClose: this.closeDialog.bind(this, 'popupChotBaoCao'), onSuccess: this.chotBaoCao.bind(this, this.props.params.id),
            title: 'S\u1ED1 li\u1EC7u b\xE1o c\xE1o s\u1EBD \u0111\u01B0\u1EE3c ch\u1ED1t ng\xE0y ' + ngayChot }),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' qu\xFD ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' th\xE1ng ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao + 1 : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao != 'THEO_THANG' && this.state.thongTinBaoCao.kyBaoCao != 'THEO_QUY' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                  'T\u1ED5ng h\u1EE3p ' + (this.state.tenBaoCao ? this.state.tenBaoCao : '') + ' ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : '') + ' n\u0103m ' + (this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '')
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 pt20 pl20 pr20' },
                '1. Th\xF4ng tin b\xE1o c\xE1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl25 pt10 pr25' },
              _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'Bi\u1EC3u m\u1EABu:', value: this.state.tenBaoCao ? this.state.tenBaoCao : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'K\u1EF3 b\xE1o c\xE1o:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'N\u0103m b\xE1o c\xE1o:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Qu\xFD:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\xE1ng:', value: this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao + 1 : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-table clear-left' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_HANH_CHINH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraHanhChinh,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 34,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraHanhChinh, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraXayDungCoBan,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 34,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayDungCoBan, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraTaiChinhNganSach,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 28,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayTaiChinhNganSach, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraDatDai,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 44,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraDatDai, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_LAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraLai,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 32,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraLai, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraChuyenNganh,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 30,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraChuyenNganh, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoThanhTraThamNhung,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 28,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeThanhTraThamNhung, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.nhaNuocVeThanhTra,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 24,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.RowItemCongTacQuanLyNhaNuoc, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.xayDungLucLuongThanhTra,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 27,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.RowItemXayDungLucLuongThanhTra, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_TIEP_CONG_DAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoTiepCongDan,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 38,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeTiepCongDan, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoXuLyDon,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 34,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeXuLyDon, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoGiaiQuyetDonKN,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 41,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeGQDKN, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 36,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.ListItemThongKeGQDTC, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.quanLyNhaNuocVeKhieuNaiToCao,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 20,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.RowItemCongTacQuanLyNhaNuocKNTC, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG' },
                _react2.default.createElement(_TableKetQuaPhongChongThamNhung2.default, {
                  addNew: true,
                  touchMove: true,
                  addNewItem: this.addNewItem.bind(this),
                  header: _table.header.thongKeBaoCaoGiaiQuyetDonTC,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  handleExport: this.exportExcel.bind(this),
                  hidePagination: true,
                  parent: this,
                  hideButtonExport: true,
                  ThongKeBaoCao: true,
                  LapBaoCao: true,
                  numberColumnHeader: this.state.numberColumnHeader,
                  dataSum: this.state.dataSum,
                  tableLoading: this.state.tableLoading,
                  pushData: this.reciveData.bind(this),
                  onChangeHeader: this.onChangeHeader.bind(this)
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nameRowItem == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN' },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    touchMove: true,
                    lapBaoCaoTongHop: true,
                    addNew: true,
                    addNewItem: this.addNewItem.bind(this),
                    header: _table.header.tongHopSoLieu,
                    dataList: this.state.data,
                    exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                    handleExport: this.exportExcel.bind(this),
                    hidePagination: true,
                    parent: this,
                    hideButtonExport: true,
                    ThongKeBaoCao: true,
                    LapBaoCao: true,
                    numberColumnHeader: 12,
                    dataSum: this.state.dataSum,
                    tableLoading: this.state.tableLoading,
                    onChangeHeader: this.onChangeHeader.bind(this)
                  },
                  _react2.default.createElement(_datatable.RowItemTongHopKeKhai, { importData: this.importData.bind(this), onChange: this.onItemChange.bind(this), lapBaoCaoTongHop: true })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showFile },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30 ' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { label: '3. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', labelClass: 'title-14', disableTopLine: true, bindValidator: this, data: this.state.listTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), allowExcelFile: true })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt30' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _core.Button,
                { type: 'button', className: 'btn-action btn-save btn-green ' + (this.state.posting ? 'btn-loading-inline' : ''), onClick: this.guiBaoCao.bind(this, 'save') },
                'L\u01B0u'
              )
            )
          )
        )
      );
    }
  }]);

  return LapBaoCaoTongHop;
}(_react2.default.Component);

LapBaoCaoTongHop.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = LapBaoCaoTongHop;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemBaoCaoTongHop = function (_React$Component) {
  _inherits(RowItemBaoCaoTongHop, _React$Component);

  function RowItemBaoCaoTongHop() {
    _classCallCheck(this, RowItemBaoCaoTongHop);

    return _possibleConstructorReturn(this, (RowItemBaoCaoTongHop.__proto__ || Object.getPrototypeOf(RowItemBaoCaoTongHop)).apply(this, arguments));
  }

  _createClass(RowItemBaoCaoTongHop, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-don-vi/' + this.props.item.baoCaoTongHopId },
            this.props.item.tenBaoCao
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.kyBaoCaoInfo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.namBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.soDonViDaBaoCao,
          ' \u0111\u01A1n v\u1ECB'
        )
      );
    }
  }]);

  return RowItemBaoCaoTongHop;
}(_react2.default.Component);

exports.default = RowItemBaoCaoTongHop;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemChiTietDonViBCTH = function (_React$Component) {
  _inherits(RowItemChiTietDonViBCTH, _React$Component);

  function RowItemChiTietDonViBCTH() {
    _classCallCheck(this, RowItemChiTietDonViBCTH);

    return _possibleConstructorReturn(this, (RowItemChiTietDonViBCTH.__proto__ || Object.getPrototypeOf(RowItemChiTietDonViBCTH)).apply(this, arguments));
  }

  _createClass(RowItemChiTietDonViBCTH, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/chi-tiet-bao-cao-tong-hop-cua-don-vi/' + this.props.item.baoCaoDonViChiTietId },
            this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.props.item.listTaiLieuBaoCao.map(function (item, index) {
              if (!_config.checkServerLive) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile) },
                    item.tenFile
                  )
                );
              }
              if (_config.checkServerLive) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'txt-blue txt-underline', onClick: function onClick() {
                        (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                      } },
                    item.tenFile
                  )
                );
              }
            })
          )
        )
      );
    }
  }]);

  return RowItemChiTietDonViBCTH;
}(_react2.default.Component);

exports.default = RowItemChiTietDonViBCTH;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCongTacQuanLyThanhTra = function (_React$Component) {
  _inherits(RowItemCongTacQuanLyThanhTra, _React$Component);

  function RowItemCongTacQuanLyThanhTra() {
    _classCallCheck(this, RowItemCongTacQuanLyThanhTra);

    return _possibleConstructorReturn(this, (RowItemCongTacQuanLyThanhTra.__proto__ || Object.getPrototypeOf(RowItemCongTacQuanLyThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemCongTacQuanLyThanhTra, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVanBanBanHanhMoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVanBanDuaSuaDoiBoSung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeTTLop
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeTTNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeTT_KNTC_PCTN_Lop
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeTT_KNTC_PCTN_Nguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeThanhTraSoCuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeThanhTraSoDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeThanhTraKNTCPCTNSoCuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeThanhTraKNTCPCTNSoDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyKiemDiemRutKNToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyKiemDiemRutKNCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoKLTTVaQDXLDaKiemDiem
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKTDaKiemDiemRutKNToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKTDaKiemDiemRutKNCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXLHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXLHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemCongTacQuanLyThanhTra;
}(_react2.default.Component);

exports.default = RowItemCongTacQuanLyThanhTra;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCongTacXayDung = function (_React$Component) {
  _inherits(RowItemCongTacXayDung, _React$Component);

  function RowItemCongTacXayDung() {
    _classCallCheck(this, RowItemCongTacXayDung);

    return _possibleConstructorReturn(this, (RowItemCongTacXayDung.__proto__ || Object.getPrototypeOf(RowItemCongTacXayDung)).apply(this, arguments));
  }

  _createClass(RowItemCongTacXayDung, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTTVCaoCapVaTuongDuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTTVChinhVaTuongDuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTTVVaTuongDuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soCBCCVCTrongBienChe
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soLaoDongHopDong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepNhanTuyenDung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.nghiHuuChuyenCongTac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.boNhiemChucVuLanhDao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.boNhiemVaoNgachNangNgach
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenDoiViTriCongTac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamKLPhaiXuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamKLDaXuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoNhuCau
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienNhuCau
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienChinhNhuCau
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienChinhDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienCaoCapNhuCau
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraVienCaoCapDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daoTaoLyLuanChinhTri
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daoTaoKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemCongTacXayDung;
}(_react2.default.Component);

exports.default = RowItemCongTacXayDung;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachBaoCaoBCTH = function (_React$Component) {
  _inherits(RowItemDanhSachBaoCaoBCTH, _React$Component);

  function RowItemDanhSachBaoCaoBCTH() {
    _classCallCheck(this, RowItemDanhSachBaoCaoBCTH);

    return _possibleConstructorReturn(this, (RowItemDanhSachBaoCaoBCTH.__proto__ || Object.getPrototypeOf(RowItemDanhSachBaoCaoBCTH)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachBaoCaoBCTH, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thong-ke-bao-cao/lap-bao-cao-tong-hop/' + this.props.item.baoCaoTongHopChiTietId },
            this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.ngayTongHop ? (0, _moment2.default)(this.props.item.ngayTongHop).format('DD/MM/YYYY') : ''
        )
      );
    }
  }]);

  return RowItemDanhSachBaoCaoBCTH;
}(_react2.default.Component);

exports.default = RowItemDanhSachBaoCaoBCTH;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachDonViBCTH = function (_React$Component) {
  _inherits(RowItemDanhSachDonViBCTH, _React$Component);

  function RowItemDanhSachDonViBCTH(props, context) {
    _classCallCheck(this, RowItemDanhSachDonViBCTH);

    var _this = _possibleConstructorReturn(this, (RowItemDanhSachDonViBCTH.__proto__ || Object.getPrototypeOf(RowItemDanhSachDonViBCTH)).call(this, props, context));

    _this.state = {
      confirmDialog: false,
      thoiHan: '',
      withTime: false,
      title: ''
    };
    return _this;
  }

  _createClass(RowItemDanhSachDonViBCTH, [{
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      this.setState(_defineProperty({}, name, status));
    }
  }, {
    key: 'handleLock',
    value: function handleLock() {
      var item = this.props.item;
      item.isLock = !this.state.withTime;
      item.thoiHan = this.state.thoiHan;
      this.props.onLock(item);
      this.toggleDialog('confirmDialog', false);
    }
  }, {
    key: 'moBaoCao',
    value: function moBaoCao() {
      this.setState({
        title: '\u0110\u1EC3 m\u1EDF b\xE1o c\xE1o t\u1EA1i \u0111\u01A1n v\u1ECB <span>' + this.props.item.donViInfo.ten + '</span> <br/>vui l\xF2ng ch\u1ECDn l\u1EA1i th\u1EDDi h\u1EA1n b\xE1o c\xE1o.',
        withTime: true,
        confirmDialog: true
      });
    }
  }, {
    key: 'khoaBaoCao',
    value: function khoaBaoCao() {
      this.setState({
        title: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD kh\xF3a b\xE1o c\xE1o t\u1EA1i \u0111\u01A1n v\u1ECB <br/> <span>' + this.props.item.donViInfo.ten + '</span> kh\xF4ng?',
        withTime: false,
        confirmDialog: true
      });
    }
  }, {
    key: 'onChangeDate',
    value: function onChangeDate(date) {
      this.setState({ thoiHan: date });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(_dialog.ConfirmDialog, { title: this.state.title, withTime: this.state.withTime, open: this.state.confirmDialog, onChangeDate: this.onChangeDate.bind(this),
          onClose: this.toggleDialog.bind(this, 'confirmDialog', false), onSuccess: this.handleLock.bind(this) }),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thong-ke-bao-cao/bao-cao-tong-hop/chi-tiet-don-vi/' + this.props.item.baoCaoDonViId },
            this.props.item.donViInfo ? this.props.item.donViInfo.ten : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.hanBaoCao ? (0, _moment2.default)(this.props.item.hanBaoCao).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-left' },
          this.props.item.ngayGui ? (0, _moment2.default)(this.props.item.ngayGui).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.daKhoa ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'link-action primary', onClick: this.moBaoCao.bind(this) },
            ' ',
            _react2.default.createElement('span', { className: 'pt-icon-standard pt-icon-unlock' }),
            ' M\u1EDF b\xE1o c\xE1o'
          ) : _react2.default.createElement(
            _reactRouter.Link,
            { className: 'link-action danger', onClick: this.khoaBaoCao.bind(this) },
            ' ',
            _react2.default.createElement('span', { className: 'pt-icon-standard pt-icon-lock' }),
            ' Kh\xF3a b\xE1o c\xE1o'
          )
        )
      );
    }
  }]);

  return RowItemDanhSachDonViBCTH;
}(_react2.default.Component);

exports.default = RowItemDanhSachDonViBCTH;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemGQDKN = function (_React$Component) {
  _inherits(RowItemGQDKN, _React$Component);

  function RowItemGQDKN() {
    _classCallCheck(this, RowItemGQDKN);

    return _possibleConstructorReturn(this, (RowItemGQDKN.__proto__ || Object.getPrototypeOf(RowItemGQDKN)).apply(this, arguments));
  }

  _createClass(RowItemGQDKN, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donNhanTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donTonKyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoVuViec
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonThuocThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecThuocThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecGiaiQuyetBangQDHanhChinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecRutDonThongQuaGiaiThichThuyetPhuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.khieuNaiDung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.khieuNaiSai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.khieuNaiDungMotPhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.giaiQuyetLan1
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.congNhanQuyetDinhGiaiQuyetLan1
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.huySuaQuyetDinhGiaiQuyetLan1
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiChoNhaNuocTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiChoNhaNuocDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.traLaiChoCongDanTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.traLaiChoCongDanDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDuocTraLaiQuyenLoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhTongSoNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuChuyenCoQuanDieuTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDoiTuongChuyenCoQuanDieuTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuDaKhoiTo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDoiTuongDaKhoiTo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecGiaiQuyetDungThoiHan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecGiaiQuyetQuaThoiHan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoQuyetDinhPhaiToChucThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoQuyetDinhPhaiToChucThucHienDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienPhaiThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datPhaiThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienDaThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datDaThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienPhaiTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datPhaiTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienDaTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datDaTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemGQDKN;
}(_react2.default.Component);

exports.default = RowItemGQDKN;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemGQDTC = function (_React$Component) {
  _inherits(RowItemGQDTC, _React$Component);

  function RowItemGQDTC() {
    _classCallCheck(this, RowItemGQDTC);

    return _possibleConstructorReturn(this, (RowItemGQDTC.__proto__ || Object.getPrototypeOf(RowItemGQDTC)).apply(this, arguments));
  }

  _createClass(RowItemGQDTC, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donNhanTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donTonKyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoVuViec
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonThuocThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecThuocThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.toCaoDung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.toCaoSai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.toCaoDungMotPhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiChoNhaNuocTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiChoNhaNuocDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.traLaiChoCongDanTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.traLaiChoCongDanDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDuocTraLaiQuyenLoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhTongSoNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuChuyenCoQuanDieuTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDoiTuongChuyenCoQuanDieuTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuDaKhoiTo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDoiTuongDaKhoiTo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecGiaiQuyetDungThoiHan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVuViecGiaiQuyetQuaThoiHan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoQuyetDinhPhaiToChucThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoQuyetDinhPhaiToChucThucHienDaThucHien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienPhaiThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datPhaiThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienDaThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datDaThuChoNhaNuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienPhaiTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datPhaiTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tienDaTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datDaTraChoCongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemGQDTC;
}(_react2.default.Component);

exports.default = RowItemGQDTC;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaThanhTraChuyenNganh = function (_React$Component) {
  _inherits(RowItemKetQuaThanhTraChuyenNganh, _React$Component);

  function RowItemKetQuaThanhTraChuyenNganh() {
    _classCallCheck(this, RowItemKetQuaThanhTraChuyenNganh);

    return _possibleConstructorReturn(this, (RowItemKetQuaThanhTraChuyenNganh.__proto__ || Object.getPrototypeOf(RowItemKetQuaThanhTraChuyenNganh)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaThanhTraChuyenNganh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soCuocTTKTTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhLapDoan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thanhTraDocLap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.caNhanDuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.caNhanDuocKiemTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.toChucDuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.toChucDuocKiemTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soCoViPhamTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soCoViPhamCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soCoViPhanToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soQDXuPhatHanhChinhTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soQDXuPhatHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soQDXuPhatHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienViPhamTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienViPhamCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienViPhamToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienKienNghiThuHoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyTaiSanTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyTaiSanTichThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyTaiSanTieuHuy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyViPhamTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyViPhamCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienXuLyViPhamToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienDaThuTongSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienDaThuCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienDaThuToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaThanhTraChuyenNganh;
}(_react2.default.Component);

exports.default = RowItemKetQuaThanhTraChuyenNganh;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaThanhTraDatDai = function (_React$Component) {
  _inherits(RowItemKetQuaThanhTraDatDai, _React$Component);

  function RowItemKetQuaThanhTraDatDai() {
    _classCallCheck(this, RowItemKetQuaThanhTraDatDai);

    return _possibleConstructorReturn(this, (RowItemKetQuaThanhTraDatDai.__proto__ || Object.getPrototypeOf(RowItemKetQuaThanhTraDatDai)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaThanhTraDatDai, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoCuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.trienKhaiTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.theoKeHoach
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.dotXuat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketThucThanhTraTrucTiep
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daBanHanhKetLuan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViDuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongViPhamTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongViPhamDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.datLanChiem
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.giaoDatCapDatSaiDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.capBanDatTraiThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.capGCNQSDDSai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenNhuongChoThueKhongDungQuyDinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.suDungDatKhongDungMucDich
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.boHoangHoa
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiQDGiaoDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuQdGiaoDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoKLTTVaQDXLDaKTDD
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocTienPhaiThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocTienDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDatPhaiThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDatDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXuLyHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXuLyHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daKhoiToVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daKhoiToDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaThanhTraDatDai;
}(_react2.default.Component);

exports.default = RowItemKetQuaThanhTraDatDai;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaThanhTraHanhChinh = function (_React$Component) {
  _inherits(RowItemKetQuaThanhTraHanhChinh, _React$Component);

  function RowItemKetQuaThanhTraHanhChinh() {
    _classCallCheck(this, RowItemKetQuaThanhTraHanhChinh);

    return _possibleConstructorReturn(this, (RowItemKetQuaThanhTraHanhChinh.__proto__ || Object.getPrototypeOf(RowItemKetQuaThanhTraHanhChinh)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaThanhTraHanhChinh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoCuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.trienKhaiTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.theoKeHoach
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.dotXuat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketThucThanhTraTrucTiep
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daBanHanhKetLuan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViDuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongViPhamTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongViPhamDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoKLTTVaQDXLDaKTDD
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocTienPhaiThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocTienDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDatPhaiThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDatDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaXuLyHCToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaXuLyHCCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaKhoiToVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaKhoiToDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaThanhTraHanhChinh;
}(_react2.default.Component);

exports.default = RowItemKetQuaThanhTraHanhChinh;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaThanhTraLai = function (_React$Component) {
  _inherits(RowItemKetQuaThanhTraLai, _React$Component);

  function RowItemKetQuaThanhTraLai() {
    _classCallCheck(this, RowItemKetQuaThanhTraLai);

    return _possibleConstructorReturn(this, (RowItemKetQuaThanhTraLai.__proto__ || Object.getPrototypeOf(RowItemKetQuaThanhTraLai)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaThanhTraLai, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoCuocThanhTraLai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.trienKhaiTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketThucThanhTraTrucTiep
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daBanHanhKetLuan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamTrinhTu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketLuanKhongPhuHop
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.saiLamApDungPhapLuat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.coYLamSaiLechHoSo
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamNghiemTrong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViDaThanhTraLai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamVeKinhTeTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.viPhamVeKinhTeDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhacDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienTienDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienDatDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaThucHienDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaThanhTraLai;
}(_react2.default.Component);

exports.default = RowItemKetQuaThanhTraLai;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaThanhTraTaiChinhNganHang = function (_React$Component) {
  _inherits(RowItemKetQuaThanhTraTaiChinhNganHang, _React$Component);

  function RowItemKetQuaThanhTraTaiChinhNganHang() {
    _classCallCheck(this, RowItemKetQuaThanhTraTaiChinhNganHang);

    return _possibleConstructorReturn(this, (RowItemKetQuaThanhTraTaiChinhNganHang.__proto__ || Object.getPrototypeOf(RowItemKetQuaThanhTraTaiChinhNganHang)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaThanhTraTaiChinhNganHang, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoCuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.trienKhaiTrongKyBaoCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.theoKeHoach
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.dotXuat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketThucThanhTraTrucTiep
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daBanHanhKetLuan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViDuocThanhTra
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienKienNghiThuHoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXLHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soTienDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoKLTTVaQDXLDaKTDD
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kiemTraDonDocTienPhaiThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kiemTraDonDocTienDaThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaXuLyHCToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaXuLyHCCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaKhoiToVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKiemTraDonDocDaKhoiToDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaThanhTraTaiChinhNganHang;
}(_react2.default.Component);

exports.default = RowItemKetQuaThanhTraTaiChinhNganHang;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaTiepCongDan = function (_React$Component) {
  _inherits(RowItemKetQuaTiepCongDan, _React$Component);

  function RowItemKetQuaTiepCongDan() {
    _classCallCheck(this, RowItemKetQuaTiepCongDan);

    return _possibleConstructorReturn(this, (RowItemKetQuaTiepCongDan.__proto__ || Object.getPrototypeOf(RowItemKetQuaTiepCongDan)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaTiepCongDan, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenLuot
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenVuViecCu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenVuViecMoiPhatSinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenDoanDongNguoiSoDoan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongVuViecDonKhieuNaiLinhVucHanhChinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucTuPhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donKhieuNaiLinhVucVeDang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongVuViecDonToCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donToCaoLinhVucHanhChinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donToCaoLinhVucTuPhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donToCaoLinhVucThamNhung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donToCaoLinhVucVeDang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.donToCaoLinhVucKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phanAnhKienNghiKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuaDuocGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuaCoQuyetDinhGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daCoQuyetDinhGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daCoBanAnCuaToa
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaTiepCongDan;
}(_react2.default.Component);

exports.default = RowItemKetQuaTiepCongDan;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaXuLyThamNhung = function (_React$Component) {
  _inherits(RowItemKetQuaXuLyThamNhung, _React$Component);

  function RowItemKetQuaXuLyThamNhung() {
    _classCallCheck(this, RowItemKetQuaXuLyThamNhung);

    return _possibleConstructorReturn(this, (RowItemKetQuaXuLyThamNhung.__proto__ || Object.getPrototypeOf(RowItemKetQuaXuLyThamNhung)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaXuLyThamNhung, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.taiSanThamNhungTongTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.taiSanThamNhungTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.taiSanThamNhungTaiSanKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.taiSanThamNhungDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTongTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiTaiSanKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiThuHoiDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuTongTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuTien
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuTaiSanKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daThuDat
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.hanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.chuyenCoQuanDieuTraDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXuLyHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daXuLyHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daKhoiToVu
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.daKhoiToDoiTuong
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.xuLyTrachNhiemNguoiDungDauKienNghi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.xuLyTrachNhiemNguoiDungDauDaXuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemKetQuaXuLyThamNhung;
}(_react2.default.Component);

exports.default = RowItemKetQuaXuLyThamNhung;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemQLNNKNTC = function (_React$Component) {
  _inherits(RowItemQLNNKNTC, _React$Component);

  function RowItemQLNNKNTC() {
    _classCallCheck(this, RowItemQLNNKNTC);

    return _possibleConstructorReturn(this, (RowItemQLNNKNTC.__proto__ || Object.getPrototypeOf(RowItemQLNNKNTC)).apply(this, arguments));
  }

  _createClass(RowItemQLNNKNTC, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVanBanBanHanhMoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soVanBanDuaSuaDoiBoSung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeKNTCLop
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.phapLuatVeKNTCNguoi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeKNTCSoCuoc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.thucHienPLVeKNTCSoDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soDonViCoViPham
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyKiemDiemRutKNToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyKiemDiemRutKNCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoKLTTVaQDXLDaKiemDiem
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKTDaKiemDiemRutKNToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.ketQuaKTDaKiemDiemRutKNCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhToChuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.kienNghiXuLyHanhChinhCaNhan
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemQLNNKNTC;
}(_react2.default.Component);

exports.default = RowItemQLNNKNTC;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemSLKKXMTS = function (_React$Component) {
  _inherits(RowItemSLKKXMTS, _React$Component);

  function RowItemSLKKXMTS() {
    _classCallCheck(this, RowItemSLKKXMTS);

    return _possibleConstructorReturn(this, (RowItemSLKKXMTS.__proto__ || Object.getPrototypeOf(RowItemSLKKXMTS)).apply(this, arguments));
  }

  _createClass(RowItemSLKKXMTS, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiPhaiKeKhaiTrongNam
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDaKeKhai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiCongKhaiTheoHTNiemYet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiCongKhaiTheoHTTCHoiHop
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDuocXMTSThuNhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemSLKKXMTS;
}(_react2.default.Component);

exports.default = RowItemSLKKXMTS;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemXLDKhieuNaiToCao = function (_React$Component) {
  _inherits(RowItemXLDKhieuNaiToCao, _React$Component);

  function RowItemXLDKhieuNaiToCao() {
    _classCallCheck(this, RowItemXLDKhieuNaiToCao);

    return _possibleConstructorReturn(this, (RowItemXLDKhieuNaiToCao.__proto__ || Object.getPrototypeOf(RowItemXLDKhieuNaiToCao)).apply(this, arguments));
  }

  _createClass(RowItemXLDKhieuNaiToCao, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      var data = Item ? Item.soLieuBaoCaoInfo : {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          data.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTiepNhanXLDTCD
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonDuDieuKienThuLy
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucHanhChinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucTuPhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonKhieuNaiLinhVucVeDang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonLinhVucToCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCaoLinhVucHanhChinh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCaoLinhVucTuPhap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCaoLinhVucThamNhung
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCaoLinhVucVeDang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonToCaoLinhVucKhac
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTheoTQGQCuaCoQuanDang
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonXLDDonKienNghiPhanAnh
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonXLDSoVanBanHuongDan
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonChuyenCQCoThamQuyen
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonCoSoCongVanDonDocViecGiaiQuyet
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonThuocThamQuyenKhieuNai
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          data.tongSoDonThuocThamQuyenToCao
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          data.ghiChu
        )
      );
    }
  }]);

  return RowItemXLDKhieuNaiToCao;
}(_react2.default.Component);

exports.default = RowItemXLDKhieuNaiToCao;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaoCaoTongHop = __webpack_require__(994);

var _BaoCaoTongHop2 = _interopRequireDefault(_BaoCaoTongHop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaoCaoTongHop2.default;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _subView = __webpack_require__(33);

var _GetParams = __webpack_require__(47);

var _upload = __webpack_require__(17);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';
var buocGiaiQuyet = 'BO_SUNG_SAU_KHI_LUU_HO_SO';

var BoSungThongTin = function (_React$Component) {
  _inherits(BoSungThongTin, _React$Component);

  function BoSungThongTin(props, context) {
    _classCallCheck(this, BoSungThongTin);

    var _this = _possibleConstructorReturn(this, (BoSungThongTin.__proto__ || Object.getPrototypeOf(BoSungThongTin)).call(this, props, context));

    _this.state = {
      id: _this.props.params.id,
      nameComponent: '',
      isOpen: true,
      backConfirm: false,
      hasChange: false,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      showAttachFile: false,
      onSave: true,
      typeComponent: '',
      data: {},
      dataLoaiNguoiDD: [],
      dataLoaiDonThu: [],
      dataLoaiDoiTuong: [],
      dataLichSuQuaTrinhXuLy: [],
      dataDonViTTXM: [],
      dsTepDinhKem: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      noiDungBoSungHoSo: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: 'DON_KHIEU_NAI',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      hideQuaTrinhXuLy: false,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuBoSungHoSo: []
    };
    return _this;
  }

  _createClass(BoSungThongTin, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          coQuanQuanLyNguoiDung: _extends({}, this.state.coQuanQuanLyNguoiDung, {
            id: userInfo.coQuanQuanLyId,
            ten: userInfo.tenCoQuanQuanLy
          }),
          donViGiaoTTXM: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDonDetail();
      this.getQuyTrinhXuLyHistory();
      if (window.debug) {
        console.log('modules/bo-sung-thong-tin/BoSungThongTin');
      }
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory() {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
        }
      });
    }
  }, {
    key: 'getDonDetail',
    value: function getDonDetail() {
      var _this3 = this;

      var params = {
        id: this.state.id
      };
      _api.Letter.actions.getDonDetail.request(params).then(function (res) {
        if (res.data) {
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _api.Reception.actions.getDonInfo.request({ id: _this3.state.id }).then(function (res1) {
              if (res1.data) {
                res.data = _extends({}, res.data, res1.data);
              }
              var dataKetQuaXuLyDon = {
                thamQuyenGiaiQuyet: res.data.thamQuyenGiaiQuyetInfo ? res.data.thamQuyenGiaiQuyetInfo.ten : ''
              };
              _this3.setState({
                data: res.data,
                loaiDon: res.data.loaiDon,
                dataKetQuaXuLyDon: dataKetQuaXuLyDon,
                listTaiLieuVanThuBoSungHoSo: res.data.listTaiLieuVanThuBoSungHoSo
              }, function () {
                _this3.getLichSuGiaiQuyetDon(_this3.state.id);
              });
            });
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }
  }, {
    key: 'getLichSuGiaiQuyetDon',
    value: function getLichSuGiaiQuyetDon(id) {
      var _this4 = this;

      var params = {
        id: id
      };
      _api.GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(function (res) {
        var dataKQXLD = _extends({}, _this4.state.dataKetQuaXuLyDon);
        dataKQXLD.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo ? res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon : '';
        dataKQXLD.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.ten : '';
        _this4.setState({
          dataLichSuGiaiQuyet: res.data,
          nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
          typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
          dataKetQuaXuLyDon: dataKQXLD,
          dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo,
          noiDungBoSungHoSo: res.data.thongTinGiaiQuyetDonInfo.noiDungBoSungHoSo,
          showAttachFile: true
        }, function () {
          _this4.checkHideKetQuaXuLyDon();
        });
      });
    }
  }, {
    key: 'renderWorkFollow',
    value: function renderWorkFollow() {
      switch (this.state.nameComponent) {
        case 'TruongPhongNhanDuThaoVaGiaoViec':
          return _react2.default.createElement(_subView.KetQuaLapDuThaoDonKhieuNaiCanBo, _extends({
            nhanDuThao: true,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo
          }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            loaiDon: this.state.loaiDon,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            boSungThongTin: true
          }));
        case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
          if (this.state.typeComponent == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
            return _react2.default.createElement(_subView.KetQuaLapDuThaoDonKhieuNaiCanBo, _extends({
              listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
              listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo
            }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
              loaiDon: this.state.loaiDon,
              donInfo: this.state.data,
              thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
              boSungThongTin: true
            }));
          }
          break;
        case 'CanBoGiaiQuyetDonAction':
          return _react2.default.createElement(_subView.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
            loaiDon: this.state.loaiDon,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            boSungThongTin: true }));
        case 'CanBoGiaiQuyetDonKhongQuyTrinh':
          return _react2.default.createElement(_subView.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
            loaiDon: this.state.loaiDon,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            boSungThongTin: true }));
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
          return _react2.default.createElement(_subView.KetQuaLapDuThaoDonKhieuNaiCanBo, _extends({
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo
          }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            nhanDuThao: true,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            loaiDon: this.state.loaiDon,
            boSungThongTin: true
          }));
        case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
        case 'CanBoGiaiQuyetDonLapDuThaoAction':
          if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            return _react2.default.createElement(_subView.KetQuaLapDuThaoDonKhieuNaiCanBo, _extends({
              listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
              listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo
            }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
              donInfo: this.state.data,
              thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
              loaiDon: this.state.loaiDon,
              boSungThongTin: true
            }));
          } else {
            return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
              listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
              listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo
            }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
              donInfo: this.state.data,
              thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
              loaiDon: this.state.loaiDon,
              boSungThongTin: true
            }));
          }
        case 'canBoKiemTraDeXuatKhongQuyTrinh':
        case 'canBoKiemTraDeXuat':
          return _react2.default.createElement(_subView.KetQuaCanBoKiemTraDeXuat, _extends({
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
            dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
          }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
            boSungThongTin: true
          }));
        case 'canBoTDTHKhongQuyTrinh':
        case 'TruongPhongTDTHAction':
        case 'CanBoTDTHAction':
          return _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
            dataKiemTraDeXuat: this.state.dataKiemTraDeXuat
          }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
            loaiDon: this.state.loaiDon,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
            thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
            boSungThongTin: true
          }));
      }
    }
  }, {
    key: 'checkHideKetQuaXuLyDon',
    value: function checkHideKetQuaXuLyDon() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.state.data.donViThamTraXacMinhInfo && this.state.data.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        this.setState({
          hideKetQuaXuLyDon: true
        });
      }
      if (this.state.nameComponent == 'canBoKiemTraDeXuat' || this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh' || this.state.nameComponent == 'truongPhongKiemTraDeXuat' || this.state.nameComponent == 'canBoTDTHKhongQuyTrinh' || this.state.nameComponent == 'TruongPhongTDTHAction' || this.state.nameComponent == 'CanBoTDTHAction') {
        this.setState({
          hideKetQuaXuLyDon: true
        });
      }
      this.setState({
        formGiaiQuyet: this.renderWorkFollow()
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id]),
        dataFileDinhKem: data
      });
      this.handleChangeData();
      //
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.data.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this5.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.setState({ backConfirm: true });
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this6 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        this.state.dataFileDinhKem.map(function (item, i) {
          if (item.duongDan == '') {
            // DO nothing
          } else if (item.taiLieuVanThuId) {
            _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              buocGiaiQuyet: buocGiaiQuyet,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        if (this.state.taiLieuVanThu.length > 0) {
          var _params = {
            taiLieuVanThus: this.state.taiLieuVanThu
          };
          this.postTaiLieuVanThu(_params);
        }

        if (this.state.taiLieuVanThuUpdate.length > 0) {
          var _params2 = {
            taiLieuVanThus: this.state.taiLieuVanThuUpdate
          };
          this.updateTaiLieuVanThu(_params2);
        }

        if (this.state.taiLieuVanThuDelete.length > 0) {

          var _params3 = {
            taiLieuVanThus: this.state.taiLieuVanThuDelete
          };
          this.deleteTaiLieuVanThu(_params3);
        }

        var params = (0, _GetParams.getParams)(this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, this.state.id);
        params.noiDungBoSungHoSo = this.state.noiDungBoSungHoSo;

        this.saveGiaiQuyetDon(params, 'gqdLuu');
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.handleChangeData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center' },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleBack.bind(this, false), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-detail' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_subView.ChiTietDon, { isOpen: this.state.isOpen, donId: this.state.id, loaiDon: this.state.loaiDon, dataGiaiQuyet: this.state.dataLichSuGiaiQuyet, data: this.state.data }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.hideQuaTrinhXuLy != true },
            _react2.default.createElement(_subView.QuaTrinhXuLy, { parents: this })
          )
        ),
        !this.state.hideKetQuaXuLyDon ? _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_subView.KetQuaXuLyDon, _extends({ donInfo: this.state.data, status: this.state.hideKetQuaXuLyDon }, this.state.dataKetQuaXuLyDon, { dataGiaiQuyet: this.state.dataLichSuGiaiQuyet }))
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          this.state.formGiaiQuyet
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper mb30' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'B\u1ED5 sung th\xF4ng tin'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, { value: this.state.noiDungBoSungHoSo, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do b\u1ED5 sung', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'noiDungBoSungHoSo'), name: '', maxLength: 1000 }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showAttachFile },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuBoSungHoSo, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDao != true },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.handleBack.bind(this, false) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.lanhDao == true },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom pt10 mb40' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.handleBack.bind(this, false) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u'
              )
            )
          )
        )
      );
    }
  }]);

  return BoSungThongTin;
}(_react2.default.Component);

BoSungThongTin.defaultProps = {
  lanhDao: false,
  validators: {
    formTaoDon: []
  }
};

exports.default = BoSungThongTin;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(33);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _CheckPermission = __webpack_require__(20);

var _formXuLy = __webpack_require__(483);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = "QUYET_DINH";
var loaiQuyTrinh = "XU_LY_DON";
var buocGiaiQuyet = "BO_SUNG_SAU_KHI_CHUYEN_DON_LUU_HO_SO";

var BoSungThongTinChuyenDon = function (_Component) {
  _inherits(BoSungThongTinChuyenDon, _Component);

  function BoSungThongTinChuyenDon(props, context) {
    _classCallCheck(this, BoSungThongTinChuyenDon);

    var _this = _possibleConstructorReturn(this, (BoSungThongTinChuyenDon.__proto__ || Object.getPrototypeOf(BoSungThongTinChuyenDon)).call(this, props, context));

    _this.state = {
      id: _this.props.params.id,
      data: {},
      dataLichSuQuaTrinhXuLy: [],
      dataKetQuaXuLyDon: {},
      loaiDon: 'DON_KHIEU_NAI',
      isOpen: true,
      backConfirm: false,
      listTaiLieuVanThuBoSungHoSo: [],
      hideQuaTrinhXuLy: false,
      thongTinXuLyGiaiQuyet: {},
      title: 'Thông tin đã xử lý',
      listTaiLieuVanThu: [],
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      taiLieuVanThu: [],
      dataFileDinhKem: [],
      listTaiLieuVanThuChuyenDonBoSungHoSo: [],
      dataLichSuGiaiQuyet: []
    };
    return _this;
  }

  _createClass(BoSungThongTinChuyenDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDonDetail();
      this.getQuyTrinhXuLyHistory();
    }
  }, {
    key: 'getDonDetail',
    value: function getDonDetail() {
      var _this2 = this;

      var params = {
        id: this.state.id
      };
      _api.Letter.actions.getDonDetail.request(params).then(function (res) {
        if (res.data) {
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _api.Reception.actions.getDonInfo.request({ id: _this2.state.id }).then(function (resDonInfo) {
              if (resDonInfo.data) {
                res.data = _extends({}, res.data, resDonInfo.data);
              }
              var dataKetQuaXuLyDon = {
                thamQuyenGiaiQuyet: res.data.thamQuyenGiaiQuyetInfo ? res.data.thamQuyenGiaiQuyetInfo.ten : ''
              };
              var donId = res.data.donId;
              _this2.getThongTinXuLyHoacGiaiQuyet(donId);
              _this2.setState({
                data: res.data,
                loaiDon: res.data.loaiDon,
                dataKetQuaXuLyDon: dataKetQuaXuLyDon,
                listTaiLieuVanThuChuyenDonBoSungHoSo: res.data.listTaiLieuVanThuChuyenDonBoSungHoSo,
                listTaiLieuVanThuBoSungHoSo: res.data.listTaiLieuVanThuBoSungHoSo,
                listTaiLieuVanThu: res.data.taiLieuVanThus || []
              });
            });
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory() {
      var _this3 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
        }
      });
    }
  }, {
    key: 'getThongTinXuLyHoacGiaiQuyet',
    value: function getThongTinXuLyHoacGiaiQuyet(donId) {
      var _this4 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {

          var info = res.data;

          _this4.setState({
            thongTinXuLyGiaiQuyet: info.thongTinXuLyInfo
          });
        }
      }).catch(function (error) {});
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.setState({ backConfirm: true });
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id]),
        dataFileDinhKem: data
      });
      this.handleChangeData();
      //
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.state.dataFileDinhKem.map(function (item, i) {
        if (item.duongDan === '') {
          // DO nothing
        } else if (item.taiLieuVanThuId) {
          var state = _this5.state;
          state.taiLieuVanThuUpdate[state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(_this5.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
          _this5.setState({ state: state });
        } else {
          var _state = _this5.state;
          _state.taiLieuVanThu[_state.taiLieuVanThu.length] = {
            don: {
              id: Number(_this5.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            buocGiaiQuyet: buocGiaiQuyet,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
          _this5.setState({ state: _state });
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }
      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }
      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
      this.saveGiaiQuyetDon('gqdLuu');
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(message) {
      this.onClickClose();
      (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleBack.bind(this, false), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-detail' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_subView.ChiTietDon, { isOpen: this.state.isOpen, donId: this.state.id, loaiDon: this.state.loaiDon, dataGiaiQuyet: this.state.dataLichSuGiaiQuyet, data: this.state.data })
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.hideQuaTrinhXuLy != true },
            _react2.default.createElement(_subView.QuaTrinhXuLy, { parents: this })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pl20' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb25 pt10' },
              this.state.title
            )
          ),
          _react2.default.createElement(_formXuLy.HuongXuLyView, {
            loaiDonGiaTri: this.state.loaiDon,
            thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
            thongTinGQD: this.state.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
            donInfo: this.state.data,
            listTaiLieuVanThu: this.state.listTaiLieuVanThu })
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper mb30' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'B\u1ED5 sung th\xF4ng tin'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuChuyenDonBoSungHoSo, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom pt10 mb40' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.handleBack.bind(this, false) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\xF3ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              'L\u01B0u'
            )
          )
        )
      );
    }
  }]);

  return BoSungThongTinChuyenDon;
}(_react.Component);

exports.default = BoSungThongTinChuyenDon;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _formTimkiem = __webpack_require__(100);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Administrative = function (_React$Component) {
  _inherits(Administrative, _React$Component);

  function Administrative(props, context) {
    _classCallCheck(this, Administrative);

    var _this = _possibleConstructorReturn(this, (Administrative.__proto__ || Object.getPrototypeOf(Administrative)).call(this, props, context));

    _this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ma: '',
      ten: '',
      parentCategory: '',
      moTa: '',
      maTTCP: '',
      categoryId: 0,
      capDonViHanhChinhID: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      isValid: true,
      donViHanhChinhList: [],
      capDonViHanhChinhList: [],
      donViHanhChinhFilter: [],
      capDonViHanhChinhFilter: '',
      timKiemNangCao: false
    };
    return _this;
  }

  _createClass(Administrative, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getDonViHanhChinh();
      this.getCapDonViHanhChinh();
    }
  }, {
    key: 'getDonViHanhChinh',
    value: function getDonViHanhChinh() {
      var _this2 = this;

      _api.Danhmuc.actions.getDonViHanhChinhTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.state.donViHanhChinhList = res.data._embedded.donViHanhChinhs;
          _this2.setState(_extends({}, _this2.state));
        }
      });
    }
  }, {
    key: 'getCapDonViHanhChinh',
    value: function getCapDonViHanhChinh() {
      var _this3 = this;

      _api.Danhmuc.actions.getCapDonViHanhChinhTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.state.capDonViHanhChinhList = res.data._embedded.capDonViHanhChinhs;
          _this3.setState(_extends({}, _this3.state));
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'donViHanhChinhFilter') {
        this.state.donViHanhChinhFilter = e;
      } else {
        this.state[name] = e.target.value;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.state.search = true;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.ten = this.state.tuKhoa.trim();
      }
      if (this.state.timKiemNangCao) {
        if (this.state.capDonViHanhChinhFilter) {
          params.listCapDonVis = this.state.capDonViHanhChinhFilter;
        }
        if (this.state.donViHanhChinhFilter.length) {
          var ids = [];
          this.state.donViHanhChinhFilter.map(function (item) {
            ids.push(item.value);
          });
          params.listDonVis = ids.join();
        }
      }
      _api.Danhmuc.actions.getDonViHanhChinh.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            data: res.data._embedded.donViHanhChinhs,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this4.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this5 = this;

      if (this.checkValidate()) {
        var params = {
          ma: this.state.ma.trim(),
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim(),
          maTTCP: this.state.maTTCP.trim(),
          capDonViHanhChinh: { id: this.state.capDonViHanhChinhID }
        };
        if (this.state.parentCategory) {
          params.cha = {
            id: this.state.parentCategory.donViHanhChinhId
          };
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateDonViHanhChinh.request({ id: this.state.categoryId }, params).then(function (res) {
            _this5.getListData();
            _this5.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postDonViHanhChinh.request('', params).then(function (res) {
            _this5.getListData();
            _this5.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this6 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteDonViHanhChinh.request({ id: categoryId }).then(function (res) {
          _this6.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this6.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {

      this.toggleDialog();
      this.setState({
        addType: 0,
        ma: '',
        ten: '',
        moTa: '',
        maTTCP: '',
        parentCategory: '',
        categoryId: 0,
        capDonViHanhChinhID: 0,
        isValid: true
      });
    }
  }, {
    key: 'openAddMoreCategory',
    value: function openAddMoreCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 1,
        ma: '',
        ten: '',
        parentCategory: item,
        moTa: '',
        maTTCP: '',
        capDonViHanhChinhID: item.capDonViHanhChinhDVHC.capDonViHanhChinhId,
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        ma: item.ma,
        ten: item.ten,
        parentCategory: item.donViHanhChinhCha,
        moTa: item.moTa,
        maTTCP: item.maTTCP,
        categoryId: item.donViHanhChinhId,
        capDonViHanhChinhID: item.capDonViHanhChinhDVHC.capDonViHanhChinhId,
        isValid: true
      });
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch(status) {
      if (status) {
        this.state.timKiemNangCao = true;
      } else {
        this.state.timKiemNangCao = false;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                '\u0110\u01A1n v\u1ECB h\xE0nh ch\xEDnh'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DONVIHANHCHINH_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(_common.DropDown, { label: 'C\u1EA5p \u0111\u01A1n v\u1ECB h\xE0nh ch\xEDnh', selectedValue: this.state.capDonViHanhChinhFilter, onChange: this.onChange.bind(this, 'capDonViHanhChinhFilter'), options: this.state.capDonViHanhChinhList, keyName: 'capDonViHanhChinhId', valueName: 'ten', placeholder: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                ),
                this.state.timKiemNangCao ? _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected', label: '\u0110\u01A1n v\u1ECB h\xE0nh ch\xEDnh', dataOptions: this.state.donViHanhChinhList, dataSelected: this.state.donViHanhChinhFilter, onChange: this.onChange.bind(this, 'donViHanhChinhFilter'), selectAllChildren: false, propertyChildren: 'donViHanhChinhCha', propertyParent: 'donViHanhChinhId' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'input-group', style: { float: 'right' } },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.toggleSearch.bind(this, false) },
                      _react2.default.createElement('i', { className: 'tt tt-delete' }),
                      'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
                    )
                  )
                ) : ''
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.toggleSearch.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.administrative,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemAdministrative, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa đơn vị hành chính' : 'Thêm mới đơn vị hành chính',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3', value: this.state.ma, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ma'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3 TTCP', value: this.state.maTTCP, require: false, maxLength: 40, onChange: this.onChange.bind(this, 'maTTCP'), channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              this.state.parentCategory ? _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  '\u0110\u01A1n v\u1ECB h\xE0nh ch\xEDnh cha: ',
                  this.state.parentCategory.ten
                )
              ) : null,
              _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'C\u1EA5p \u0111\u01A1n v\u1ECB h\xE0nh ch\xEDnh', require: true, selectedValue: this.state.capDonViHanhChinhID, onChange: this.onChange.bind(this, 'capDonViHanhChinhID'), bindValidator: this, channel: 'danhMuc', placeholder: { key: '', text: 'Chọn...' }, options: this.state.capDonViHanhChinhList, keyName: 'capDonViHanhChinhId', valueName: 'ten' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: 'col-12' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Administrative;
}(_react2.default.Component);

Administrative.defaultProps = {
  validators: {}
};

exports.default = (0, _reactRedux.connect)()(Administrative);

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CapDonViHanhChinh = function (_React$Component) {
  _inherits(CapDonViHanhChinh, _React$Component);

  function CapDonViHanhChinh(props, context) {
    _classCallCheck(this, CapDonViHanhChinh);

    var _this = _possibleConstructorReturn(this, (CapDonViHanhChinh.__proto__ || Object.getPrototypeOf(CapDonViHanhChinh)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ma: '',
      isValid: true,
      ten: '',
      moTa: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(CapDonViHanhChinh, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.ten = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getCapDonViHanhChinh.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.capDonViHanhChinhs,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ma: this.state.ma.trim(),
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim()
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateCapDonViHanhChinh({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postCapDonViHanhChinh('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteCapDonViHanhChinh({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        ma: '',
        ten: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        ma: item.ma,
        ten: item.ten,
        moTa: item.moTa,
        isValid: true,
        categoryId: item.capDonViHanhChinhId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'C\u1EA5p \u0111\u01A1n v\u1ECB h\xE0nh ch\xEDnh'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('CAPDONVIHANHCHINH_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.administrativeunits,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemCapDonViHanhChinh, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa cấp đơn vị hành chính' : 'Thêm mới cấp đơn vị hành chính',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'M\xE3', value: this.state.ma, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ma'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, maxLength: 255, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CapDonViHanhChinh;
}(_react2.default.Component);

CapDonViHanhChinh.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(CapDonViHanhChinh);

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _list = __webpack_require__(42);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _utils = __webpack_require__(4);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CapNhatNguoiDung = function (_React$Component) {
  _inherits(CapNhatNguoiDung, _React$Component);

  function CapNhatNguoiDung(props, context) {
    _classCallCheck(this, CapNhatNguoiDung);

    var _this = _possibleConstructorReturn(this, (CapNhatNguoiDung.__proto__ || Object.getPrototypeOf(CapNhatNguoiDung)).call(this, props, context));

    _this.state = {
      data: [],
      dataNguoiDungThayThe: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      maHoSo: '',
      hoTen: '',
      tableLoading: false,
      searchLoading: false,
      buttonLoading: false,
      search: false,
      nguoiDungHienTai: '',
      idNguoiDungHienTai: '',
      vaiTroNguoiDungHienTai: '',
      nguoiDungThayThe: '',
      maHoSoTraCuu: '',
      hoTenTraCuu: ''
    };
    return _this;
  }

  _createClass(CapNhatNguoiDung, [{
    key: 'getListCongChuc',
    value: function getListCongChuc(vaiTro, coQuanQuanLyId, idNguoiDungHienTai) {
      var _this2 = this;

      var params = {
        vaiTro: vaiTro,
        coQuanQuanLyId: coQuanQuanLyId,
        congChucHienTaiId: Number(idNguoiDungHienTai)
      };
      _api.GiaiQuyetDonThu.actions.getCongChuc.request(params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataNguoiDungThayThe: res.data._embedded.congChucs
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData(this.state.maHoSoTraCuu, this.state.hoTenTraCuu);
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData(this.state.maHoSoTraCuu, this.state.hoTenTraCuu);
    }
  }, {
    key: 'getListData',
    value: function getListData(maHoSo, hoTen) {
      var _this3 = this;

      if (this.validateSubmitForm()) {
        this.state.search = true;
        this.state.tableLoading = true;
        this.state.searchLoading = true;
        this.setState(_extends({}, this.state));
        var params = {
          page: this.state.pageData.number,
          size: this.state.pageData.size
        };
        if (hoTen) {
          params.hoTen = hoTen;
          this.setState({
            hoTenTraCuu: hoTen
          });
        } else if (this.state.hoTen) {
          params.hoTen = this.state.hoTen;
          this.setState({
            hoTenTraCuu: this.state.hoTen
          });
        }
        if (maHoSo) {
          params.maHoSo = maHoSo;
          this.setState({
            maHoSoTraCuu: maHoSo
          });
        } else if (this.state.maHoSo) {
          params.maHoSo = this.state.maHoSo;
          this.setState({
            maHoSoTraCuu: this.state.maHoSo
          });
        }
        _api.Danhmuc.actions.getCapNhatNguoiDung.request(null, params).then(function (res) {
          if (res.data._embedded) {
            _this3.state.data = res.data._embedded.congChucs;
            _this3.state.tableLoading = false;
            _this3.state.searchLoading = false;
            _this3.state.pageData = res.data.page;
            _this3.setState(_extends({}, _this3.state));
          } else {
            _this3.setState({
              data: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              },
              searchLoading: false,
              tableLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog(vaiTro, coQuanQuanLyId, nguoiDungHienTai, vaiTroNguoiDungHienTai, idNguoiDungHienTai) {
      this.getListCongChuc(vaiTro, coQuanQuanLyId, idNguoiDungHienTai);
      this.state.isOpen = true;
      this.state.nguoiDungHienTai = nguoiDungHienTai;
      this.state.idNguoiDungHienTai = idNguoiDungHienTai;
      this.state.vaiTroNguoiDungHienTai = vaiTroNguoiDungHienTai;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.state.isOpen = false;
      this.state.nguoiDungThayThe = '';
      this.state.idNguoiDungHienTai = '';
      this.state.dataNguoiDungThayThe = [];
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'updateUser',
    value: function updateUser() {
      var _this4 = this;

      if (this.validateUpdateForm()) {
        this.state.buttonLoading = true;
        this.setState(_extends({}, this.state));
        var params = {
          maHoSo: this.state.maHoSoTraCuu,
          canBoXuLyThayTheId: Number(this.state.nguoiDungThayThe),
          canBoDangXuLyId: Number(this.state.idNguoiDungHienTai)
        };
        _api.Danhmuc.actions.updateCapNhatNguoiDung.request(params).then(function (res) {
          _this4.closeDialog();
          _this4.state.buttonLoading = false;
          _this4.setState(_extends({}, _this4.state));
          _this4.getListData(_this4.state.maHoSoTraCuu, _this4.state.hoTenTraCuu);
          (0, _toastr.Toastr)('Thay thế người dùng thành công', 'success');
        }).catch(function (err) {
          _this4.state.buttonLoading = false;
          _this4.setState(_extends({}, _this4.state));
          (0, _toastr.Toastr)('Lỗi hệ thống', 'error');
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'validateUpdateForm',
    value: function validateUpdateForm() {
      var pass = true;
      this.props.validators['formCapNhat'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'C\u1EADp nh\u1EADt ng\u01B0\u1EDDi d\xF9ng'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'row pt20 pl25 pr25 pb5' },
              _react2.default.createElement(_common.Input, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.maHoSo, onChange: this.onChange.bind(this, 'maHoSo'), name: 'maHoSo', label: 'M\xE3 h\u1ED3 s\u01A1', placeholder: 'Nh\u1EADp...' }),
              _react2.default.createElement(_common.Input, { className: 'col-25', value: this.state.hoTen, onChange: this.onChange.bind(this, 'hoTen'), name: 'hoTen', label: 'H\u1ECD t\xEAn', placeholder: 'Nh\u1EADp...' }),
              _react2.default.createElement(
                'div',
                { className: 'col-25 mt22' },
                _react2.default.createElement(
                  'button',
                  { onClick: this.getListData.bind(this, null, null), className: 'pt-button btn-green tt-search ' + (this.state.searchLoading ? 'btn-loading-inline' : '') },
                  'T\xECm ki\u1EBFm'
                )
              )
            ),
            _react2.default.createElement('div', { className: 'line-border' }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.capNhatNguoiDung,
                dataList: this.state.data,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                tableLoading: this.state.searchLoading,
                search: this.state.search
              },
              _react2.default.createElement(_list.RowItemCapNhatNguoiDung, { openDialog: this.openDialog.bind(this) })
            ),
            _react2.default.createElement(
              _core.Dialog,
              {
                isOpen: this.state.isOpen,
                onClose: this.closeDialog.bind(this),
                title: 'X\xE1c nh\u1EADn',
                className: 'panel-popup category' },
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-body' },
                _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Ng\u01B0\u1EDDi d\xF9ng hi\u1EC7n t\u1EA1i:', value: this.state.nguoiDungHienTai }),
                _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Vai tr\xF2:', value: this.state.vaiTroNguoiDungHienTai }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.dataNguoiDungThayThe.length == 0 },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-center text-13 txt-bold col-100 mb18' },
                    'Kh\xF4ng c\xF3 t\xE0i kho\u1EA3n c\xF9ng vai tr\xF2 \u0111\u1EC3 thay th\u1EBF'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.dataNguoiDungThayThe.length > 0 },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-50', label: 'Ng\u01B0\u1EDDi d\xF9ng thay th\u1EBF', channel: 'formCapNhat', require: true, bindValidator: this, selectedValue: this.state.nguoiDungThayThe, onChange: this.onChange.bind(this, 'nguoiDungThayThe'), name: 'nguoiDungThayThe', data: this.state.dataNguoiDungThayThe, keyName: 'congChucId', valueName: 'hoVaTen' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-footer' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.dataNguoiDungThayThe.length > 0 },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-green ' + (this.state.buttonLoading ? "btn-loading-inline" : ""), onClick: this.updateUser.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u0110\u1ED3ng \xFD'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CapNhatNguoiDung;
}(_react2.default.Component);

CapNhatNguoiDung.defaultProps = {
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
};

exports.default = CapNhatNguoiDung;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

__webpack_require__(439);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _utils = __webpack_require__(4);

var _formTimkiem = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CongChuc = function (_React$Component) {
  _inherits(CongChuc, _React$Component);

  function CongChuc(props, context) {
    _classCallCheck(this, CongChuc);

    var _this = _possibleConstructorReturn(this, (CongChuc.__proto__ || Object.getPrototypeOf(CongChuc)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      DataSelectCoQuanQuanLy: [],
      DataSelectChucVu: [],
      DataSelectVaiTro: [],
      DataSelectVaiTrotheoDV: [],
      DataTrangThaiThayDoi: [],
      vaiTroId: '',
      vaiTroIdS: '',
      donViTrucThuocList: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataSNV: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      popupChonDonVi: false,
      addType: 0,
      hoVaTen: '',
      dienThoai: '',
      email: '',
      gender: 'male',
      coQuanQuanLyID: null,
      chucVu: '',
      nguoiDungActive: false,
      nguoiDungHinhDaiDien: '',
      nguoiDungVaitrosID: [],
      nguoiDungMatKhau: '',
      nguoiDungID: '',
      noiCapCMND: '',
      tableLoading: false,
      buttonLoading: false,
      donViTrucThuocId: '',
      searchLoading: false,
      tuKhoa: '',
      nhomVaiTroId: '',
      search: false,
      congChucId: '',
      chonDonViId: '',
      chonDonViText: '',
      validateDonVi: true,
      chuyenVienNhapLieu: false,
      chuyenVienNhapLieus: false,
      traCuuDonToCao: false,
      boSungThongTin: false,
      congChucThayDoi: '',
      lyDoThayDoi: '',
      emailNguoiDungCu: '',
      listCongChucSNV: [],
      congChucSoNoiVu: '',
      tuKhoaSoNV: '',
      popUpSoNoiVu: false,
      loadingSNV: false,
      timKiemNangCao: false,
      coQuanQuanLyFilter: [],
      capCoQuanQuanLyFilter: [],
      coQuanQuanLyList: [],
      capCoQuanQuanLyList: [],
      getVaiTroInfo: ''
    };
    return _this;
  }

  _createClass(CongChuc, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getListCV();
      this.getListCQQL();
      this.getListVT();
      this.getCoQuanQuanLy();
      this.getCapCoQuanQuanLy();
      this.getTrangThaiThayDoi();
      this.getListVTtheoDonVi();
      if (window.debug) {
        console.log('category/CongChuc');
      }
    }
  }, {
    key: 'getCoQuanQuanLy',
    value: function getCoQuanQuanLy() {
      var _this2 = this;

      var params = {};
      _api.Danhmuc.actions.getCoQuanQuanLyTimKiem.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ coQuanQuanLyList: res.data._embedded.coQuanQuanLies });
        }
      });
    }
  }, {
    key: 'getCapCoQuanQuanLy',
    value: function getCapCoQuanQuanLy() {
      var _this3 = this;

      _api.Danhmuc.actions.getCapCoQuanQuanLyTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ capCoQuanQuanLyList: res.data._embedded.capCoQuanQuanLies });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this4 = this;

      e.preventDefault();
      this.setState({
        search: true,
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        }
      }, function () {
        _this4.getListData(true);
      });
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this5 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        chuyenviennhaplieu: this.state.chuyenVienNhapLieus,
        traCuuDonToCao: this.state.traCuuDonToCao,
        boSungThongTin: this.state.boSungThongTin,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      if (this.state.timKiemNangCao) {
        if (this.state.vaiTroIdS) {
          params.nhomVaiTroId = this.state.vaiTroIdS;
        }
        if (this.state.capCoQuanQuanLyFilter.length) {
          var ids = [];
          this.state.capCoQuanQuanLyFilter.map(function (item) {
            ids.push(item.value);
          });
          params.listCapCoQuanQuanLys = ids.join();
        }
        if (this.state.coQuanQuanLyFilter.length) {
          var ids2 = [];
          this.state.coQuanQuanLyFilter.map(function (item) {
            ids2.push(item.value);
          });
          params.listCoQuanQuanLys = ids2.join();
        }
      }
      _api.Danhmuc.actions.getCongChuc.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this5.setState({
            data: res.data._embedded.congChucs,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this5.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'getTrangThaiThayDoi',
    value: function getTrangThaiThayDoi() {
      var _this6 = this;

      _api.Danhmuc.actions.getTrangThaiThayDoiNguoiDung.request().then(function (res) {
        if (res.data) {
          _this6.setState({ DataTrangThaiThayDoi: res.data });
        }
      });
    }
  }, {
    key: 'getListCQQL',
    value: function getListCQQL() {
      var _this7 = this;

      _api.Danhmuc.actions.getListCoQuan.request().then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            DataSelectCoQuanQuanLy: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDonViTrucThuoc',
    value: function getDonViTrucThuoc(id) {
      var _this8 = this;

      if (id) {
        _api.Danhmuc.actions.getDonViTrucThuoc.request(null, { cha: id }).then(function (res) {
          if (res.data && res.data._embedded) {
            _this8.setState({
              donViTrucThuocList: res.data._embedded.coQuanQuanLies
            });
          } else {
            _this8.setState({
              donViTrucThuocList: []
            });
          }
        });
      } else {
        this.setState({
          donViTrucThuocList: []
        });
      }
    }
  }, {
    key: 'getListCV',
    value: function getListCV() {
      var _this9 = this;

      this.props.danhMuc.getListChucVu().then(function (res) {
        if (res.data._embedded) {
          _this9.setState({
            DataSelectChucVu: res.data._embedded.chucVus
          });
        }
      });
    }
  }, {
    key: 'getListVT',
    value: function getListVT() {
      var _this10 = this;

      this.props.danhMuc.getListVaiTro().then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            DataSelectVaiTro: res.data._embedded.vaiTroes
          });
        }
      });
    }
  }, {
    key: 'getListVTtheoDonVi',
    value: function getListVTtheoDonVi() {
      var _this11 = this;

      this.props.danhMuc.getListVaiTrotheoDV().then(function (res) {
        if (res && res.data && res.data._embedded) {
          _this11.setState({ DataSelectVaiTrotheoDV: res.data._embedded.vaiTroes });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      if (this.state.popUpSoNoiVu) {
        this.state.pageDataSNV.number = page.selected;
        this.timKiemCongChucSNV();
      } else {
        this.state.pageData.number = page.selected;
        this.getListData();
      }
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      if (this.state.popUpSoNoiVu) {
        this.state.pageDataSNV.size = size;
        this.state.pageDataSNV.number = 0;
        this.timKiemCongChucSNV();
      } else {
        this.state.pageData.size = size;
        this.state.pageData.number = 0;
        this.getListData();
      }
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this12 = this;

      if (this.validateSubmitForm()) {
        var params = {
          hoVaTen: this.state.hoVaTen.trim(),
          dienThoai: this.state.dienThoai.trim(),
          gioiTinh: this.state.gender == 'male' ? true : false,
          chucVu: this.state.chucVu,
          nguoiDung: {
            email: this.state.email.trim(),
            active: true,
            traCuuDonToCao: this.state.traCuuDonToCao,
            boSungThongTin: this.state.boSungThongTin,
            hinhDaiDien: this.state.nguoiDungHinhDaiDien,
            vaiTroMacDinh: { id: this.state.vaiTroId },
            vaiTros: [{ id: this.state.vaiTroId }],
            matKhau: this.state.nguoiDungMatKhau
          },
          coQuanQuanLy: { id: this.state.chonDonViId }
        };

        if (this.state.vaiTroId == 3) {
          params.nguoiDung.chuyenVienNhapLieu = this.state.chuyenVienNhapLieu;
        }

        if (this.state.congChucThayDoi) {
          params.nguoiDung.congChucThayDoi = this.state.congChucThayDoi;
        }
        if (this.state.lyDoThayDoi) {
          params.nguoiDung.lyDoThayDoi = this.state.lyDoThayDoi;
        }
        if (this.state.emailNguoiDungCu) {
          params.nguoiDung.emailNguoiDungCu = this.state.emailNguoiDungCu;
        }
        if (this.state.congChucSoNoiVu) {
          params.soNoiVuId = this.state.congChucSoNoiVu.congChucSoNoiVuId;
        }

        this.setState({ buttonLoading: true });
        if (this.state.congChucId) {
          params.nguoiDung.id = this.state.nguoiDungID;
          _api.Danhmuc.actions.updateCongChuc.request({ id: this.state.congChucId }, params).then(function (res) {
            _this12.getListData();
            _this12.callDialog('popupAddCategory', false);
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this12.setState({ buttonLoading: false, congChucSoNoiVu: '' });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this12.setState({ buttonLoading: false, congChucSoNoiVu: '' });
            }
          });
        } else {
          _api.Danhmuc.actions.postCongChuc.request(null, params).then(function (res) {
            _this12.getListData();
            _this12.callDialog('popupAddCategory', false);
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this12.setState({ buttonLoading: false, congChucSoNoiVu: '' });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this12.setState({ buttonLoading: false, congChucSoNoiVu: '' });
            }
          });
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      this.state.validateDonVi = this.state.chonDonViId != '';
      this.setState(_extends({}, this.state));
      if (pass) {
        pass = this.state.validateDonVi;
      }

      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      //
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(congChucId) {
      var _this13 = this;

      if (congChucId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteCongChuc({ id: congChucId }).then(function (res) {
          _this13.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this13.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this13.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var newState = _extends({}, this.state);
      if (name == 'coQuanQuanLyFilter') {
        newState.coQuanQuanLyFilter = e;
      } else if (name == 'capCoQuanQuanLyFilter') {
        newState.capCoQuanQuanLyFilter = e;
      } else {
        newState[name] = e.target.value;
      }
      this.setState(_extends({}, newState));

      if (name == 'coQuanQuanLyID') {
        this.getDonViTrucThuoc(e.target.value);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'callDialog',
    value: function callDialog(name, status) {
      this.state[name] = status;
      if (!status && name == 'popupAddCategory') {
        //
        this.state.chonDonViId = '';
        this.state.chonDonViText = '';
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.callDialog('popupAddCategory', true);
      this.setState({
        addType: 0,
        hoVaTen: '',
        dienThoai: '',
        email: '',
        gender: 'male',
        coQuanQuanLyID: null,
        coQuanQuanLyCMNDId: '',
        chucVu: '',
        nguoiDungActive: false,
        nguoiDungHinhDaiDien: '',
        nguoiDungVaitrosID: [],
        nguoiDungMatKhau: '',
        congChucId: 0,
        donViTrucThuocId: '',
        donViTrucThuocList: [],
        validateDonVi: true,
        congChucThayDoi: '',
        lyDoThayDoi: '',
        emailNguoiDungCu: '',
        congChucSoNoiVu: '',
        getVaiTroInfo: '',
        popUpSoNoiVu: false
      });
      this.timKiemCongChucSNV();
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({ isSubmit: false });
      this.callDialog('popupAddCategory', true);
      var getVaiTro = '';
      if (item.donViCongChuc && item.donViCongChuc.cha) {
        this.state.chonDonViId = item.donViCongChuc.coQuanQuanLyId;
        this.state.chonDonViText = item.donViCongChuc.ten + ' thu\u1ED9c ' + item.donViCongChuc.cha.ten;
      } else if (item.donViCongChuc) {
        this.state.chonDonViId = item.donViCongChuc.coQuanQuanLyId;
        this.state.chonDonViText = item.donViCongChuc.ten;
      }
      if (item.soNoiVuId) {
        this.state.congChucSoNoiVu = { congChucSoNoiVuId: item.soNoiVuId, hoVaTen: 'Đã liên kết' };
      } else {
        this.state.congChucSoNoiVu = '';
      }
      if (item && item.nguoiDungCongChuc && item.nguoiDungCongChuc.vaiTroMacDinhInfo && item.nguoiDungCongChuc.vaiTroMacDinhInfo.listCoQuanQuanLy && item.nguoiDungCongChuc.vaiTroMacDinhInfo.listCoQuanQuanLy.length === 0) {
        getVaiTro = item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten;
      }

      this.setState({
        addType: 2,
        congChucId: item.congChucId,
        hoVaTen: item.hoVaTen,
        dienThoai: item.dienThoai,
        email: item.nguoiDungCongChuc.email,
        gender: item.gioiTinh ? 'male' : 'female',
        chucVu: item.chucVu || '',
        nguoiDungActive: item.nguoiDungCongChuc.active,
        nguoiDungHinhDaiDien: item.nguoiDungCongChuc.hinhDaiDien,
        nguoiDungID: item.nguoiDungCongChuc.nguoiDungId,
        nguoiDungMatKhau: '',
        chonDonViId: this.state.chonDonViId,
        chonDonViText: this.state.chonDonViText,
        traCuuDonToCao: item.nguoiDungCongChuc.traCuuDonToCao,
        boSungThongTin: item.nguoiDungCongChuc.boSungThongTin,
        donViTrucThuocId: '',
        chuyenVienNhapLieu: item.nguoiDungCongChuc.chuyenVienNhapLieu,
        coQuanQuanLyID: null,
        donViTrucThuocList: [],
        validateDonVi: true,
        vaiTroId: item.nguoiDungCongChuc && item.nguoiDungCongChuc.vaiTroNguoiDung ? item.nguoiDungCongChuc.vaiTroNguoiDung[0].vaiTroId : '',
        congChucThayDoi: item.nguoiDungCongChuc.congChucThayDoiInfo ? item.nguoiDungCongChuc.congChucThayDoiInfo.giaTri : '',
        lyDoThayDoi: item.nguoiDungCongChuc.lyDoThayDoi || '',
        emailNguoiDungCu: item.nguoiDungCongChuc.emailNguoiDungCu || '',
        getVaiTroInfo: getVaiTro
      });
      this.timKiemCongChucSNV();
    }
  }, {
    key: 'chonDonVi',
    value: function chonDonVi() {
      var _this14 = this;

      if (this.state.donViTrucThuocId) {
        this.state.chonDonViId = this.state.donViTrucThuocId;
        this.state.donViTrucThuocList.map(function (item) {
          if (item.coQuanQuanLyId == _this14.state.donViTrucThuocId) {
            _this14.state.chonDonViText = item.ten + ' thuộc ';
          }
        });
        this.state.DataSelectCoQuanQuanLy.map(function (item) {
          if (item.coQuanQuanLyId == _this14.state.coQuanQuanLyID) {
            _this14.state.chonDonViText += item.ten;
          }
        });
      } else if (this.state.coQuanQuanLyID) {
        this.state.chonDonViId = this.state.coQuanQuanLyID;
        this.state.DataSelectCoQuanQuanLy.map(function (item) {
          if (item.coQuanQuanLyId == _this14.state.coQuanQuanLyID) {
            _this14.state.chonDonViText = item.ten;
          }
        });
      }
      this.callDialog('popupChonDonVi', false);
      this.state.validateDonVi = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'changeCheckbox',
    value: function changeCheckbox(name, e) {
      this.setState(_defineProperty({}, name, e.target.checked));
    }
  }, {
    key: 'timKiemCongChucSNV',
    value: function timKiemCongChucSNV() {
      var _this15 = this;

      var params = {
        page: this.state.pageDataSNV.number,
        size: this.state.pageDataSNV.size,
        tuKhoa: this.state.tuKhoaSoNV.trim()
      };
      this.setState({ loadingSNV: true });
      _api.Danhmuc.actions.getCongChucSoNoiVu.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this15.setState({
            listCongChucSNV: res.data._embedded.congChucSoNoiVus,
            pageDataSNV: res.data.page
          });
        } else {
          _this15.setState({ listCongChucSNV: [],
            pageDataSNV: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
        _this15.setState({ loadingSNV: false });
      }).catch(function (e) {
        _this15.setState({ loadingSNV: false });
      });
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch(status) {
      if (status) {
        this.setState({ timKiemNangCao: true });
      } else {
        this.setState({ timKiemNangCao: false });
      }
    }
  }, {
    key: 'handleSelectSNV',
    value: function handleSelectSNV(item) {
      this.state.congChucSoNoiVu = item;
      this.state.email = item.email;
      this.state.hoVaTen = item.hoVaTen;
      this.state.chucVu = item.tenChucVu;
      this.callDialog('popUpSoNoiVu', false);
    }
  }, {
    key: 'render',
    value: function render() {
      var adminId = 1;
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh s\xE1ch ng\u01B0\u1EDDi d\xF9ng'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('CONGCHUC_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                ),
                this.state.timKiemNangCao && _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { style: { marginTop: '10px' }, className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.toggleSearch.bind(this, false) },
                    _react2.default.createElement('i', { className: 'tt tt-delete' }),
                    'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
                  )
                ),
                this.state.timKiemNangCao && _react2.default.createElement(
                  'div',
                  { className: 'clear-left display-flex' },
                  _react2.default.createElement(_common.DropDown, { className: 'col-25 mb0-18', label: 'Nh\xF3m vai tr\xF2', bindValidator: this, channel: 'formTaoDon', require: false, options: this.state.DataSelectVaiTro, placeholder: true, keyName: 'vaiTroId', valueName: 'ten', selectedValue: this.state.vaiTroIdS, onChange: this.onChange.bind(this, 'vaiTroIdS') }),
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'col-25 tree-selected', label: 'C\u1EA5p c\u01A1 quan qu\u1EA3n l\xFD', dataOptions: this.state.capCoQuanQuanLyList, dataSelected: this.state.capCoQuanQuanLyFilter, onChange: this.onChange.bind(this, 'capCoQuanQuanLyFilter'), selectAllChildren: false, propertyChildren: 'capCoQuanQuanLyCha', propertyParent: 'capCoQuanQuanLyId' }),
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'col-25 tree-selected', label: 'C\u01A1 quan qu\u1EA3n l\xFD', dataOptions: this.state.coQuanQuanLyList, dataSelected: this.state.coQuanQuanLyFilter, onChange: this.onChange.bind(this, 'coQuanQuanLyFilter'), selectAllChildren: false, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
                  _react2.default.createElement(
                    _core.Checkbox,
                    { className: 'cb-cvnl pt-position-button tree-selected pt-large', name: 'chuyenVienNhapLieus', checked: this.state.chuyenVienNhapLieus ? true : false, onChange: this.changeCheckbox.bind(this, 'chuyenVienNhapLieus') },
                    _react2.default.createElement(
                      'span',
                      { className: 'span-checkbox span-position-label' },
                      'Chuy\xEAn vi\xEAn nh\u1EADp li\u1EC7u'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.toggleSearch.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.civilServant,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideExport: true,
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemCongChuc, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupChonDonVi,
              onClose: this.callDialog.bind(this, 'popupChonDonVi', false),
              title: 'Ch\u1ECDn \u0111\u01A1n v\u1ECB',
              className: 'reception-dialog delete-dialog'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: '\u0110\u01A1n v\u1ECB', className: 'col-6 mb0-18 tree-selected', placeholder: true, dataOptions: this.state.DataSelectCoQuanQuanLy, value: this.state.coQuanQuanLyID, onChange: this.onChange.bind(this, 'coQuanQuanLyID'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
                _react2.default.createElement(_common.DropDown, { className: 'col-6 mb0-18', label: 'Ph\xF2ng ban', options: this.state.donViTrucThuocList, keyName: 'coQuanQuanLyId', valueName: 'ten', placeholder: { key: '', text: 'Chọn...' }, selectedValue: this.state.donViTrucThuocId, onChange: this.onChange.bind(this, 'donViTrucThuocId') })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-save', onClick: this.chonDonVi.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Ch\u1ECDn'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.callDialog.bind(this, 'popupAddCategory', false),
              title: this.state.addType == 2 ? 'Chỉnh sửa người dùng' : 'Thêm mới người dùng',
              iconName: 'add-new',
              className: 'panel-popup civilServant' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.popUpSoNoiVu },
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-body' },
                _react2.default.createElement(
                  'div',
                  { className: 'civilservant-wrapper' },
                  _react2.default.createElement(
                    'form',
                    { className: 'form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'container-box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                              'h3',
                              { className: 'title-civilservant' },
                              'Th\xF4ng tin ng\u01B0\u1EDDi d\xF9ng'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'group-box mb5' },
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(_common.Input, { label: 'H\u1ECD v\xE0 T\xEAn', className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.hoVaTen, onChange: this.onChange.bind(this, 'hoVaTen') }),
                            _react2.default.createElement(_common.Input, { label: '\u0110i\u1EC7n tho\u1EA1i', className: 'col-25', type: 'sdt', value: this.state.dienThoai, onChange: this.onChange.bind(this, 'dienThoai') }),
                            _react2.default.createElement(
                              'div',
                              { className: 'col-input autocomplete-box' },
                              _react2.default.createElement(
                                'div',
                                { className: 'rows' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'radio-gender' },
                                  _react2.default.createElement(
                                    'label',
                                    { className: 'pt-label' },
                                    'Gi\u1EDBi t\xEDnh'
                                  ),
                                  _react2.default.createElement(
                                    _core.RadioGroup,
                                    { name: 'gender', onChange: this.onChange.bind(this, 'gender'), selectedValue: this.state.gender },
                                    _react2.default.createElement(_core.Radio, { label: 'Nam', value: 'male', className: 'pt-large small-title' }),
                                    _react2.default.createElement(_core.Radio, { label: 'N\u1EEF', value: 'female', className: 'pt-large small-title' })
                                  )
                                )
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl15 pr15 mb10' },
                              _react2.default.createElement(
                                'div',
                                { className: this.state.chonDonViText ? 'col-6' : 'col-25' },
                                _react2.default.createElement(
                                  'label',
                                  { className: 'ip-label' },
                                  '\u0110\u01A1n v\u1ECB ',
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'text-required' },
                                    '\xA0*'
                                  )
                                ),
                                this.state.chonDonViText ? _react2.default.createElement(
                                  'label',
                                  { className: 'val-content pr15' },
                                  this.state.chonDonViText
                                ) : '',
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { className: 'btn-green', onClick: this.callDialog.bind(this, 'popupChonDonVi', true) },
                                  _react2.default.createElement(
                                    'span',
                                    null,
                                    'Ch\u1ECDn \u0110\u01A1n v\u1ECB'
                                  )
                                ),
                                !this.state.validateDonVi ? _react2.default.createElement(
                                  'div',
                                  { className: 'pt-form-helper-text' },
                                  'B\u1EA1n kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng tr\u01B0\u1EDDng n\xE0y.'
                                ) : ''
                              ),
                              _react2.default.createElement(_common.Input, { label: 'Ch\u1EE9c v\u1EE5', className: 'col-25', value: this.state.chucVu, onChange: this.onChange.bind(this, 'chucVu') })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'group-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(_common.Input, { label: 'Email', className: 'col-25 mb0-18', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.email, onChange: this.onChange.bind(this, 'email') }),
                            this.state.getVaiTroInfo ? _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement(
                                'label',
                                { className: 'ip-label' },
                                'Nh\xF3m vai tr\xF2 ',
                                _react2.default.createElement(
                                  'span',
                                  { className: 'text-required' },
                                  '\xA0*'
                                )
                              ),
                              _react2.default.createElement(
                                'label',
                                { className: 'val-content pr15' },
                                this.state.getVaiTroInfo
                              )
                            ) : _react2.default.createElement(_common.DropDown, { className: 'col-25 mb0-18', label: 'Nh\xF3m vai tr\xF2', bindValidator: this, channel: 'formTaoDon', require: true, options: this.state.DataSelectVaiTrotheoDV, placeholder: true, keyName: 'vaiTroId', valueName: 'ten', selectedValue: this.state.vaiTroId, onChange: this.onChange.bind(this, 'vaiTroId') }),
                            this.state.vaiTroId == 3 ? _react2.default.createElement(
                              'div',
                              { className: 'col-25', style: { paddingTop: '32px' } },
                              _react2.default.createElement('input', { type: 'checkbox', id: 'isCVNL', className: 'input-cb', name: 'chuyenVienNhapLieu', checked: this.state.chuyenVienNhapLieu ? true : false, onChange: this.changeCheckbox.bind(this, 'chuyenVienNhapLieu') }),
                              _react2.default.createElement(
                                'label',
                                { htmlFor: 'isCVNL' },
                                'Chuy\xEAn vi\xEAn nh\u1EADp li\u1EC7u'
                              )
                            ) : ''
                          )
                        ),
                        this.state.addType === 2 && _react2.default.createElement(
                          'div',
                          { className: 'items-form mt15' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'Lo\u1EA1i thay \u0111\u1ED5i', options: this.state.DataTrangThaiThayDoi, keyName: 'giaTri', valueName: 'ten', placeholder: { key: '', text: 'Chọn...' }, selectedValue: this.state.congChucThayDoi, onChange: this.onChange.bind(this, 'congChucThayDoi') }),
                            _react2.default.createElement(_common.Input, { label: 'Email ng\u01B0\u1EDDi d\xF9ng c\u0169', className: 'col-25 mb0-18', value: this.state.emailNguoiDungCu, onChange: this.onChange.bind(this, 'emailNguoiDungCu') }),
                            _react2.default.createElement(_common.TextArea, { label: 'L\xFD do thay \u0111\u1ED5i', rows: 5, value: this.state.lyDoThayDoi, onChange: this.onChange.bind(this, 'lyDoThayDoi'), className: 'col-100 mb0-18', maxLength: 1000 })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-footer pb15' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.callDialog.bind(this, 'popupAddCategory', false), className: 'btn-action btn-close' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.popUpSoNoiVu },
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-body' },
                _react2.default.createElement(
                  'div',
                  { className: 'back-foward mt0' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { onClick: this.callDialog.bind(this, 'popUpSoNoiVu', false) },
                    'V\u1EC1 trang tr\u01B0\u1EDBc'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { id: 'list-people-search', className: 'search-name-container' },
                  _react2.default.createElement(
                    'form',
                    { className: 'items-form', onSubmit: this.timKiemCongChucSNV.bind(this), action: 'javascript:void(0)' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_common.Input, { label: 'T\u1EEB kh\xF3a', className: 'col-80', value: this.state.tuKhoaSoNV, onChange: this.onChange.bind(this, 'tuKhoaSoNV') }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-2' },
                        _react2.default.createElement(
                          'label',
                          { className: 'seacrh-people' },
                          _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-search', text: 'T\xECm ki\u1EBFm' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.popUpCongChucSNV,
                      dataList: this.state.listCongChucSNV,
                      hideButtonExport: true,
                      pageData: this.state.pageDataSNV,
                      parent: this,
                      tableLoading: this.state.loadingSNV
                    },
                    _react2.default.createElement(_list.RowItemSearchCongChucSoNoiVu, { onSelect: this.handleSelectSNV.bind(this) })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CongChuc;
}(_react2.default.Component);

CongChuc.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(CongChuc);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanToc = function (_React$Component) {
  _inherits(DanToc, _React$Component);

  function DanToc(props, context) {
    _classCallCheck(this, DanToc);

    var _this = _possibleConstructorReturn(this, (DanToc.__proto__ || Object.getPrototypeOf(DanToc)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryCode: '',
      categoryDesc: '',
      maTTCP: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(DanToc, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getDanToc.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.danTocs,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          if (_this2.state.pageData.number > 0) {
            _this2.state.pageData.number -= 1;
            _this2.getListData();
          }
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.validateSubmitForm()) {
        var params = {
          ten: this.state.categoryName.trim(),
          ma: this.state.categoryCode.trim(),
          tenKhac: this.state.categoryNameOther.trim(),
          moTa: this.state.categoryDesc.trim(),
          maTTCP: this.state.maTTCP.trim()
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateDanToc({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.closeDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postDanToc('', params).then(function (res) {
            _this3.getListData();
            _this3.closeDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteDanToc({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      //
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        addType: 0,
        categoryName: '',
        categoryCode: '',
        categoryNameOther: '',
        categoryDesc: '',
        maTTCP: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.openDialog();
      this.setState({
        addType: 2,
        categoryId: item.danTocId,
        categoryName: item.ten,
        categoryCode: item.ma,
        categoryNameOther: item.tenKhac,
        categoryDesc: item.moTa,
        maTTCP: item.maTTCP,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'D\xE2n t\u1ED9c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DANTOC_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.nation,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemDanToc, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa dân tộc' : 'Thêm mới dân tộc',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'T\xEAn', value: this.state.categoryName, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName') }),
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3', value: this.state.categoryCode, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryCode') }),
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3 TTCP', value: this.state.maTTCP, require: false, maxLength: 40, onChange: this.onChange.bind(this, 'maTTCP'), channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'T\xEAn kh\xE1c', value: this.state.categoryNameOther, maxLength: 40, onChange: this.onChange.bind(this, 'categoryNameOther') }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, maxLength: 255, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: 'col-12' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DanToc;
}(_react2.default.Component);

DanToc.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(DanToc);

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucVideo = function (_React$Component) {
  _inherits(DanhMucVideo, _React$Component);

  function DanhMucVideo(props, context) {
    _classCallCheck(this, DanhMucVideo);

    var _this = _possibleConstructorReturn(this, (DanhMucVideo.__proto__ || Object.getPrototypeOf(DanhMucVideo)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(DanhMucVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getDanhMucVideo.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.danhMucVideos,
            pageData: res.data.page,
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateDanhMucVideo.request({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postDanhMucVideo.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteDanhMucVideo.request({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 0,
        categoryName: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 2,
        categoryId: item.danhMucVideoId,
        categoryName: item.ten,
        categoryDesc: item.moTa,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh m\u1EE5c video'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DANHMUCVIDEO_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.competence,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemDanhMucVideo, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa danh mục video' : 'Thêm mới danh mục video',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DanhMucVideo;
}(_react2.default.Component);

DanhMucVideo.defaultProps = {
  validators: {}
};

exports.default = DanhMucVideo;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(12);

var _list = __webpack_require__(42);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _utils = __webpack_require__(4);

var _layout = __webpack_require__(9);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _datatable = __webpack_require__(52);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDonTheoCongChuc = function (_Component) {
  _inherits(DanhSachDonTheoCongChuc, _Component);

  function DanhSachDonTheoCongChuc(props) {
    _classCallCheck(this, DanhSachDonTheoCongChuc);

    var _this = _possibleConstructorReturn(this, (DanhSachDonTheoCongChuc.__proto__ || Object.getPrototypeOf(DanhSachDonTheoCongChuc)).call(this, props));

    _this.state = {
      dataTable: [],
      tenEmail: '',
      nguoiDungThayThe: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      dataNguoiDungThayThe: [],
      congChucInfo: {},
      listCheckedId: [],
      isOpen: false,
      loadingTable: false,
      checkAll: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(DanhSachDonTheoCongChuc, [{
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }

    // Validate Form

  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this2 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size
        })
      }, function () {
        _this2.getListData();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this3 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this3.getListData();
      });
    }

    // Get thông tin công chức

  }, {
    key: 'getCongChucInfo',
    value: function getCongChucInfo() {
      var _this4 = this;

      this.setState({
        loadingTable: true
      });
      var params = {
        email: this.state.tenEmail || ''
      };
      _api.GiaiQuyetDonThu.actions.getCongChucByEmail.request(params).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this4.setState({
            congChucInfo: _extends({}, data)
          });
        } else {
          _this4.setState({
            congChucInfo: {},
            dataTable: []
          });
        }
      }).catch(function (error) {}).finally(function () {
        _this4.setState({
          listCheckedId: [],
          checkAll: false
        });
        _this4.getListData();
      });
    }
  }, {
    key: 'handleSearch',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!this.validateSubmitForm()) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.getCongChucInfo();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSearch(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSearch;
    }()

    // Get dữ liệu table

  }, {
    key: 'getListData',
    value: function getListData() {
      var _this5 = this;

      this.setState({
        loadingTable: true
      });
      var params = {
        congChucId: this.state.congChucInfo && this.state.congChucInfo.id || '',
        donViId: this.state.congChucInfo && this.state.congChucInfo.donViId || '',
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngayTiepNhan,desc'
      };
      _api.Danhmuc.actions.getDanhSachXuLy.request(null, params).then(function (res) {
        var pageData = (0, _lodash.get)(res, 'data.page');
        var data = (0, _lodash.get)(res, 'data._embedded.dons', []);
        _this5.setState({
          dataTable: data,
          pageData: pageData
        });
      }).catch(function (error) {}).finally(function () {
        setTimeout(function () {
          _this5.setState({
            loadingTable: false
          });
        }, 1500);
      });
    }

    // Get danh sách công chức cùng vai trò

  }, {
    key: 'getListCongChucThayDoi',
    value: function getListCongChucThayDoi() {
      var _this6 = this;

      var congChucInfo = this.state.congChucInfo;

      var params = {
        vaiTro: (0, _lodash.get)(congChucInfo, 'loaiVaiTro'),
        coQuanQuanLyId: (0, _lodash.get)(congChucInfo, 'coQuanQuanLyId'),
        congChucHienTaiId: (0, _lodash.get)(congChucInfo, 'id')
      };
      _api.GiaiQuyetDonThu.actions.getCongChuc.request(params).then(function (res) {
        if (res.data._embedded) {
          _this6.setState({
            dataNguoiDungThayThe: res.data._embedded.congChucs
          });
        }
      });
    }

    // Chọn một đơn

  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var donIdSelect, listCheckedId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                item.selected = !item.selected;
                donIdSelect = item.donId;
                listCheckedId = this.state.listCheckedId;

                if (item.selected) {
                  listCheckedId.push(donIdSelect);
                } else {
                  listCheckedId = listCheckedId.filter(function (item) {
                    return item !== donIdSelect;
                  });
                }
                this.setState({
                  listCheckedId: listCheckedId
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()

    // Chọn tất cả đơn

  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var itemCheck = !this.state.checkAll;
      var _state = this.state,
          listCheckedId = _state.listCheckedId,
          dataTable = _state.dataTable;

      if (itemCheck) {
        listCheckedId = dataTable.map(function (item) {
          return item.donId;
        });
      } else {
        listCheckedId = [];
      }
      dataTable = dataTable.map(function (item) {
        return _extends({}, item, {
          selected: itemCheck
        });
      });

      this.setState({
        checkAll: itemCheck,
        dataTable: dataTable,
        listCheckedId: listCheckedId
      });
    }

    // Handle xử lý

  }, {
    key: 'handleSwitch',
    value: function handleSwitch() {
      if (!(0, _lodash.isEmpty)(this.state.congChucInfo) && !(0, _lodash.isEmpty)(this.state.listCheckedId)) {
        this.getListCongChucThayDoi();
        this.openDialog();
      }
    }
  }, {
    key: 'updateUser',
    value: function updateUser() {
      var _this7 = this;

      var _state2 = this.state,
          congChucInfo = _state2.congChucInfo,
          nguoiDungThayThe = _state2.nguoiDungThayThe,
          listCheckedId = _state2.listCheckedId;

      this.setState({
        buttonLoading: true
      });
      var params = {
        congChucId: congChucInfo.id,
        donIds: listCheckedId,
        toCongChucId: nguoiDungThayThe ? Number(nguoiDungThayThe) : undefined
      };
      _api.Danhmuc.actions.switchCongChuc.request(null, params).then(function (res) {
        _this7.getListData();
        _this7.setState({
          listCheckedId: []
        });
      }).catch(function (error) {
        (0, _toastr.Toastr)('Lỗi hệ thống', 'error');
      }).finally(function () {
        _this7.setState({
          nguoiDungThayThe: '',
          buttonLoading: false
        });
        _this7.closeDialog();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state3 = this.state,
          congChucInfo = _state3.congChucInfo,
          listCheckedId = _state3.listCheckedId,
          searchLoading = _state3.searchLoading,
          dataNguoiDungThayThe = _state3.dataNguoiDungThayThe;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Thay \u0111\u1ED5i ng\u01B0\u1EDDi \u0111ang x\u1EED l\xFD v\xE0 gi\u1EA3i quy\u1EBFt \u0111\u01A1n'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'form',
              { className: '', onSubmit: this.handleSearch.bind(this) },
              _react2.default.createElement(
                'div',
                { className: 'row pt20 pl25 pr25 pb5' },
                _react2.default.createElement(_common.Input, { className: 'col-50', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.tenEmail, onChange: this.onChange.bind(this, 'tenEmail'), name: 'tenEmail', label: 'T\xEAn email ng\u01B0\u1EDDi d\xF9ng', placeholder: 'Nh\u1EADp email ng\u01B0\u1EDDi d\xF9ng...' }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mt22' },
                  _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'pt-button btn-green tt-search ' + (this.state.loadingTable ? 'btn-loading-inline' : '') },
                    'T\xECm ki\u1EBFm'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: 'line-border' }),
            _react2.default.createElement(
              'div',
              { className: 'button-wrap-container' },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: (0, _classnames2.default)('btn-action btn-move action-todo mr0', {
                    'btn-disable-tttp': (0, _lodash.isEmpty)(listCheckedId),
                    'btn-loading-inline': searchLoading
                  }),
                  onClick: this.handleSwitch.bind(this)
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'X\u1EED l\xFD'
                )
              )
            ),
            _react2.default.createElement(
              _datatable.DataTableMultipleSelect,
              {
                header: _table.header.categoryGroup.capNhatNguoiDungXLD,
                dataList: this.state.dataTable,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                onDisableCheck: (0, _lodash.isEmpty)(this.state.dataTable),
                tableLoading: this.state.loadingTable,
                onCheck: this.handleSelectedAll.bind(this),
                selectAllStatus: this.state.checkAll
              },
              _react2.default.createElement(_list.RowItemCapNhatNguoiDungXLD, null)
            ),
            _react2.default.createElement(
              _core.Dialog,
              {
                isOpen: this.state.isOpen,
                onClose: this.closeDialog.bind(this),
                title: 'X\xE1c nh\u1EADn',
                className: 'panel-popup category' },
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-body' },
                _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Ng\u01B0\u1EDDi d\xF9ng hi\u1EC7n t\u1EA1i:', value: (0, _lodash.get)(congChucInfo, 'hoVaTen') }),
                _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Vai tr\xF2:', value: (0, _lodash.get)(congChucInfo, 'tenVaiTro') }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: (0, _lodash.isEmpty)(dataNguoiDungThayThe) },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-center text-13 txt-bold col-100 mb18' },
                    'Kh\xF4ng c\xF3 t\xE0i kho\u1EA3n c\xF9ng vai tr\xF2 \u0111\u1EC3 thay th\u1EBF'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !(0, _lodash.isEmpty)(dataNguoiDungThayThe) },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-50', label: 'Ng\u01B0\u1EDDi d\xF9ng thay th\u1EBF', channel: 'formCapNhat', require: true, bindValidator: this, selectedValue: this.state.nguoiDungThayThe, onChange: this.onChange.bind(this, 'nguoiDungThayThe'), name: 'nguoiDungThayThe', data: this.state.dataNguoiDungThayThe, keyName: 'congChucId', valueName: 'hoVaTen' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pt-dialog-footer' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !(0, _lodash.isEmpty)(dataNguoiDungThayThe) },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-green ' + (this.state.buttonLoading ? "btn-loading-inline" : ""), onClick: this.updateUser.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u0110\u1ED3ng \xFD'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachDonTheoCongChuc;
}(_react.Component);

DanhSachDonTheoCongChuc.defaultProps = {
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
};

exports.default = DanhSachDonTheoCongChuc;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(12);

var _list = __webpack_require__(42);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _lodash = __webpack_require__(14);

var _datatable = __webpack_require__(52);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _core = __webpack_require__(7);

var _toastr = __webpack_require__(11);

var _ttForms = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listTrangThaiThanhLap = [{
  ten: 'Thành lập',
  giaTri: true
}, {
  ten: 'Chưa thành lập',
  giaTri: false
}];

var DanhSachDonTheoDonVi = function (_Component) {
  _inherits(DanhSachDonTheoDonVi, _Component);

  function DanhSachDonTheoDonVi(props) {
    _classCallCheck(this, DanhSachDonTheoDonVi);

    var _this = _possibleConstructorReturn(this, (DanhSachDonTheoDonVi.__proto__ || Object.getPrototypeOf(DanhSachDonTheoDonVi)).call(this, props));

    _this.state = {
      dataTable: [],
      tenEmail: '',
      nguoiDungThayThe: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      openDialog: false,
      loadingTable: false,
      checkAll: false,
      searchLoading: false,
      loadingSelect: false,
      selectedOption: null,
      maHoSo: '',
      dataOptions: [],
      message: 'Xóa các đơn đã chọn',
      statusThanhLapDon: '',
      nam: ''
    };
    return _this;
  }

  _createClass(DanhSachDonTheoDonVi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanQuanLy();
    }

    // Get data select đơn vịe

  }, {
    key: 'getCoQuanQuanLy',
    value: function getCoQuanQuanLy() {
      var _this2 = this;

      this.setState({
        loadingSelect: true
      });
      var params = {};
      _api.Danhmuc.actions.getCoQuanQuanLyTimKiem.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          var coQuanQuanLies = res.data._embedded.coQuanQuanLies;

          var dataOptions = coQuanQuanLies.map(function (item) {
            return {
              label: item.ten || item.ma,
              value: item.coQuanQuanLyId || ''
            };
          });
          _this2.setState({
            dataOptions: dataOptions
          });
        }
      }).catch(function (error) {}).finally(function () {
        _this2.setState({
          loadingSelect: false
        });
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(selectedOption) {
      var _this3 = this;

      this.setState({ selectedOption: selectedOption }, function () {
        _this3.getDataList();
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        openDialog: true
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }

    // Validate Form

  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this4 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size
        })
      }, function () {
        _this4.getDataList();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this5.getDataList();
      });
    }

    // Get data table

  }, {
    key: 'getDataList',
    value: function getDataList() {
      var _this6 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          loadingTable: true
        });
        var params = {
          donViId: this.state.selectedOption && this.state.selectedOption.value || '',
          maHoSo: this.state.maHoSo || undefined,
          nam: this.state.nam || undefined,
          thanhLapDon: this.state.statusThanhLapDon || undefined,
          page: this.state.pageData.number,
          size: this.state.pageData.size,
          sort: 'ngayTiepNhan,desc'
        };
        _api.Danhmuc.actions.getDanhSachDonTheoDonVi.request(params).then(function (res) {
          var newData = !(0, _lodash.isEmpty)(res, 'data._embedded') ? (0, _lodash.get)(res, 'data._embedded.dons') : [];
          var pageData = (0, _lodash.get)(res, 'data.page');
          _this6.setState({
            dataTable: newData,
            pageData: pageData
          });
        }).catch(function (error) {}).finally(function () {
          _this6.setState({
            listCheckedId: [],
            loadingTable: false,
            checkAll: false
          });
        });
      }
    }
  }, {
    key: 'handleSearch',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _context.next = 3;
                return this.getDataList();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSearch(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSearch;
    }()

    // Chọn một đơn

  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var donIdSelect, listCheckedId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                item.selected = !item.selected;
                donIdSelect = item.donId;
                listCheckedId = this.state.listCheckedId;

                if (item.selected) {
                  listCheckedId.push(donIdSelect);
                } else {
                  listCheckedId = listCheckedId.filter(function (item) {
                    return item !== donIdSelect;
                  });
                }
                this.setState({
                  listCheckedId: listCheckedId
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()

    // Chọn tất cả đơn

  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var itemCheck = !this.state.checkAll;
      var _state = this.state,
          listCheckedId = _state.listCheckedId,
          dataTable = _state.dataTable;

      if (itemCheck) {
        listCheckedId = dataTable.map(function (item) {
          return item.donId;
        });
      } else {
        listCheckedId = [];
      }
      dataTable = dataTable.map(function (item) {
        return _extends({}, item, {
          selected: itemCheck
        });
      });
      this.setState({
        checkAll: itemCheck,
        dataTable: dataTable,
        listCheckedId: listCheckedId
      });
    }

    // Handle xóa đơn

  }, {
    key: 'handleDelete',
    value: function handleDelete() {
      if (!(0, _lodash.isEmpty)(this.state.listCheckedId)) {
        this.openDialog();
      }
    }
  }, {
    key: 'onConfirmDialog',
    value: function onConfirmDialog() {
      var _this7 = this;

      var listCheckedId = this.state.listCheckedId;

      if (!(0, _lodash.isEmpty)(listCheckedId)) {
        this.setState({
          buttonLoading: true
        });
        var params = {
          donIds: listCheckedId
        };
        _api.Danhmuc.actions.deleteDonTrongDonVi.request(null, params).then(function (res) {
          _this7.getDataList();
          _this7.setState({
            checkAll: false,
            listCheckedId: []
          });
          (0, _toastr.Toastr)('Xóa thành công', 'success');
        }).catch(function (error) {
          (0, _toastr.Toastr)('Lỗi hệ thống', 'error');
        }).finally(function () {
          _this7.setState({
            nguoiDungThayThe: '',
            buttonLoading: false
          });
          _this7.closeDialog();
        });
      } else {
        (0, _toastr.Toastr)('Chưa chọn đơn', 'thongbao');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          dataOptions = _state2.dataOptions,
          searchLoading = _state2.searchLoading,
          listCheckedId = _state2.listCheckedId;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh s\xE1ch \u0111\u01A1n trong \u0111\u01A1n v\u1ECB'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'form',
              { className: '', onSubmit: this.handleSearch.bind(this) },
              _react2.default.createElement(
                'div',
                { className: 'row pt20 pl25 pr25' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50' },
                  _react2.default.createElement(_common.DropDownMultipleSelect, {
                    isSearchable: true,
                    multi: false,
                    className: 'input-20',
                    label: '\u0110\u01A1n v\u1ECB',
                    bindValidator: this,
                    require: true,
                    channel: 'formTaoDon',
                    placeholder: { key: '', text: '--Chọn--' },
                    loading: this.state.loadingSelect,
                    options: dataOptions,
                    onChange: this.handleChange.bind(this) })
                ),
                _react2.default.createElement(_common.Input, { className: 'col-25', value: this.state.maHoSo, onChange: this.onChange.bind(this, 'maHoSo'), name: 'maHoSo', label: 'M\xE3 h\u1ED3 s\u01A1', placeholder: 'Nh\u1EADp m\xE3 h\u1ED3 s\u01A1...' }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mt22' },
                  _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'pt-button btn-green tt-search ' + (this.state.loadingTable ? 'btn-loading-inline' : '') },
                    'T\xECm ki\u1EBFm'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl25 pr25 pb5' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25', label: 'Tr\u1EA1ng th\xE1i', data: listTrangThaiThanhLap, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.statusThanhLapDon, onChange: this.onChange.bind(this, 'statusThanhLapDon') }),
                _react2.default.createElement(_common.Input, { className: 'col-25', value: this.state.nam, onChange: this.onChange.bind(this, 'nam'), name: 'nam', label: 'N\u0103m', placeholder: 'Nh\u1EADp n\u0103m...' })
              )
            ),
            _react2.default.createElement('div', { className: 'line-border' }),
            _react2.default.createElement(
              'div',
              { className: 'button-wrap-container' },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: (0, _classnames2.default)('btn-action btn-delete mr0', {
                    'btn-disable-tttp': (0, _lodash.isEmpty)(listCheckedId),
                    'btn-loading-inline': searchLoading
                  }),
                  onClick: this.handleDelete.bind(this)
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'X\xF3a \u0111\u01A1n ch\u1ECDn'
                )
              )
            ),
            _react2.default.createElement(
              _datatable.DataTableMultipleSelect,
              {
                header: _table.header.categoryGroup.capNhatNguoiDungXLD,
                dataList: this.state.dataTable,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                onDisableCheck: (0, _lodash.isEmpty)(this.state.dataTable),
                tableLoading: this.state.loadingTable,
                onCheck: this.handleSelectedAll.bind(this),
                selectAllStatus: this.state.checkAll
              },
              _react2.default.createElement(_list.RowItemCapNhatNguoiDungXLD, null)
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.openDialog,
            onClose: this.closeDialog.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onConfirmDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachDonTheoDonVi;
}(_react.Component);

DanhSachDonTheoDonVi.defaultProps = {
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
};

exports.default = DanhSachDonTheoDonVi;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layout = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _formTimkiem = __webpack_require__(100);

var _lodash = __webpack_require__(14);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DoiTuongThanhTra = function (_React$Component) {
  _inherits(DoiTuongThanhTra, _React$Component);

  function DoiTuongThanhTra(props, context) {
    _classCallCheck(this, DoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (DoiTuongThanhTra.__proto__ || Object.getPrototypeOf(DoiTuongThanhTra)).call(this, props, context));

    _this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      ma: '',
      loaiDoiTuongTT: 'CA_NHAN',
      loaiDoiTuongTTList: [],
      linhVucDoiTuongTT: '',
      linhVucDoiTuongTTList: [],
      nhomDoiTuongThanhTraId: 2,
      doiTuongTT: '',
      diaChi: '',
      soDienThoai: '',
      ghiChu: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      loaiDoiTuongFilter: '',
      linhVucDoiTuongFilter: '',
      timKiemNangCao: false,
      dsQuanHuyen: [],
      dsPhuongXa: [],
      quanHuyenId: '',
      phuongXaId: '',
      showDialogDuLieuLoi: false,
      paramsRequestDuLieuLoi: null,
      doiTuongSelecteds: [],
      thanhTraThanhPhoId: '',
      isTTTP: false
    };
    return _this;
  }

  _createClass(DoiTuongThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVucDoiTuongTTList();
      this.getLoaiDoiTuongThanhTraList();
      this.getNhomDoiTuongThanhTra();
      this.getListData();
      this.getQuanHuyen();
      this.checkDonVi();
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(function (res) {
        var data = res.data;

        _this2.setState(_extends({}, _this2.state, {
          isTTTP: data
        }));
      });
    }
  }, {
    key: 'getNhomDoiTuongThanhTra',
    value: function getNhomDoiTuongThanhTra() {
      var _this3 = this;

      var params = {
        page: 0,
        size: 1000,
        sort: 'ngaySua,asc'
      };
      _api.Danhmuc.actions.getNhomDoiTuongThanhTra.request(null, params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded.nhomDoiTuongThanhTras)) {
          _this3.setState({
            listNhomDoiTuong: res.data._embedded.nhomDoiTuongThanhTras
          });
        } else {
          _this3.setState({
            listNhomDoiTuong: []
          });
        }
      });
    }
  }, {
    key: 'getQuanHuyen',
    value: function getQuanHuyen() {
      var _this4 = this;

      _api.DuLieuHeThong.actions.getQuanHuyen.request().then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dsQuanHuyen: (0, _lodash.get)(res, 'data._embedded.donViHanhChinhs')
          });
        }
      });
    }
  }, {
    key: 'getPhuongXa',
    value: function getPhuongXa() {
      var _this5 = this;

      var quanHuyenId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (quanHuyenId) {
        _api.DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(function (res) {
          _this5.setState({
            dsPhuongXa: (0, _lodash.get)(res, 'data._embedded.donViHanhChinhs') || []
          });
        });
      }
    }
  }, {
    key: 'getCheckTrungMaDoanhNghiep',
    value: function getCheckTrungMaDoanhNghiep(id, code) {
      var _this6 = this;

      _api.ThanhTra.actions.getCheckTrungMaDoanhNghiep.request({ id: id || undefined, code: code.trim() }).then(function (res) {
        _this6.setState(_extends({}, _this6.state, {
          isTrungMa: res.data
        }));
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name === 'quanHuyenId') {
        this.getPhuongXa(e.target.value);
        if (!e.target.value) {
          this.setState({
            phuongXaId: '',
            dsPhuongXa: []
          });
        } else {
          this.setState({
            phuongXaId: ''
          });
        }
      }
      if (name === 'ma') {
        this.setState({
          isTrungMa: false
        });
      }
    }
  }, {
    key: 'onChangeInput',
    value: function onChangeInput(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.state.search = true;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));
      this.getListData(true);
    }
  }, {
    key: 'getLinhVucDoiTuongTTList',
    value: function getLinhVucDoiTuongTTList() {
      var _this7 = this;

      var params = {
        page: 0,
        size: 1000,
        sort: 'ngaySua,asc'
      };
      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this7.state.linhVucDoiTuongTTList = res.data._embedded.linhVucDoiTuongThanhTras;
        } else {
          _this7.state.linhVucDoiTuongTTList = [];
        }
        _this7.setState(_extends({}, _this7.state));
      });
    }
  }, {
    key: 'getLoaiDoiTuongThanhTraList',
    value: function getLoaiDoiTuongThanhTraList() {
      var _this8 = this;

      var params = {
        page: 0,
        size: 1000,
        sort: 'ngaySua,asc'
      };
      _api.Danhmuc.actions.getLoaiDoiTuongThanhTra.request(null, params).then(function (res) {
        if (res.data) {
          _this8.state.loaiDoiTuongTTList = res.data;
          _this8.state.loaiDoiTuongTT = res.data[0].giaTri;
        } else {
          _this8.state.loaiDoiTuongTTList = [];
        }
        _this8.setState(_extends({}, _this8.state));
      });
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this9 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      if (this.state.maSoThue) {
        params.maSoThue = this.state.maSoThue.trim();
      }
      if (this.state.timKiemNangCao) {
        if (this.state.loaiDoiTuongFilter) {
          params.loaiDoiTuongThanhTra = this.state.loaiDoiTuongFilter;
        }
        if (this.state.linhVucDoiTuongFilter) {
          params.linhVucId = this.state.linhVucDoiTuongFilter;
        }
      }
      _api.Danhmuc.actions.getDoiTuongThanhTra.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this9.setState({
            data: res.data._embedded.doiTuongThanhTras,
            pageData: res.data.page,
            tableLoading: false
            // doiTuongSelecteds: res.data._embedded.doiTuongThanhTras.filter(item => item.approved).map(item => item.doiTuongThanhTraId)
          });
        } else {
          if (_this9.state.pageData.number > 0) {
            _this9.state.pageData.number -= 1;
            _this9.getListData();
          }
          _this9.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'checkValidate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pass;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pass = true;

                this.props.validators['danhMuc'].map(function (validator) {
                  if (pass) pass = validator.validate();else validator.validate();
                });

                if (!this.state.ma) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this.getCheckTrungMaDoanhNghiep(this.state.doiTuongTT, this.state.ma);

              case 5:
                if (this.state.isTrungMa) {
                  pass = false;
                }

              case 6:
                return _context.abrupt('return', pass);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkValidate() {
        return _ref.apply(this, arguments);
      }

      return checkValidate;
    }()
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this10 = this;

      this.checkValidate().then(function (data) {
        if (data) {
          var params = {
            ten: _this10.state.ten.trim(),
            loaiDoiTuongThanhTra: _this10.state.loaiDoiTuongTT
          };
          if (_this10.state.ma) {
            params.ma = _this10.state.ma.trim();
          }
          if (_this10.state.linhVucDoiTuongTT) {
            params.linhVucDoiTuongThanhTra = { id: _this10.state.linhVucDoiTuongTT };
          }
          if (_this10.state.diaChi) {
            params.diaChi = _this10.state.diaChi.trim();
          }
          if (_this10.state.ghiChu) {
            params.ghiChu = _this10.state.ghiChu.trim();
          }
          if (_this10.state.soDienThoai) {
            params.soDienThoai = _this10.state.soDienThoai.trim();
          }
          if (_this10.state.nhomDoiTuongThanhTraId) {
            params.nhomDoiTuongThanhTra = { id: _this10.state.nhomDoiTuongThanhTraId };
          }
          if (_this10.state.quanHuyenId) {
            params.quanHuyen = { id: Number(_this10.state.quanHuyenId) };
          }
          if (_this10.state.phuongXaId) {
            params.phuongXa = { id: Number(_this10.state.phuongXaId) };
          }
          params.approved = _this10.state.approved;
          _this10.setState({ buttonLoading: true });
          if (_this10.state.addType == 2) {
            _api.Danhmuc.actions.updateDoiTuongThanhTra.request({ id: _this10.state.doiTuongTT }, params).then(function (res) {
              _this10.getListData();
              _this10.toggleDialog();
              (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
              _this10.setState({ buttonLoading: false });
            }).catch(function (error) {
              if (error.response) {
                _this10.setState({ buttonLoading: false });
              }
            });
          } else {
            _api.Danhmuc.actions.postDoiTuongThanhTra.request('', params).then(function (res) {
              _this10.getListData();
              _this10.toggleDialog();
              (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
              _this10.setState({ buttonLoading: false });
            }).catch(function (error) {
              if (error.response) {
                _this10.setState({ buttonLoading: false });
              }
            });
          }
          _this10.props.validators['danhMuc'] = [];
        }
      });
    }
  }, {
    key: 'onApprove',
    value: function onApprove() {
      var _this11 = this;

      this.checkValidate().then(function (data) {
        if (data) {
          var params = {
            ten: _this11.state.ten.trim(),
            loaiDoiTuongThanhTra: _this11.state.loaiDoiTuongTT
          };
          if (_this11.state.ma) {
            params.ma = _this11.state.ma.trim();
          }
          if (_this11.state.linhVucDoiTuongTT) {
            params.linhVucDoiTuongThanhTra = { id: _this11.state.linhVucDoiTuongTT };
          }
          if (_this11.state.diaChi) {
            params.diaChi = _this11.state.diaChi.trim();
          }
          if (_this11.state.ghiChu) {
            params.ghiChu = _this11.state.ghiChu.trim();
          }
          if (_this11.state.soDienThoai) {
            params.soDienThoai = _this11.state.soDienThoai.trim();
          }
          if (_this11.state.nhomDoiTuongThanhTraId) {
            params.nhomDoiTuongThanhTra = { id: _this11.state.nhomDoiTuongThanhTraId };
          }
          if (_this11.state.quanHuyenId) {
            params.quanHuyen = { id: Number(_this11.state.quanHuyenId) };
          }
          if (_this11.state.phuongXaId) {
            params.phuongXa = { id: Number(_this11.state.phuongXaId) };
          }
          params.approved = true;
          _this11.setState({ buttonLoading: true });
          if (_this11.state.addType == 2) {
            _api.Danhmuc.actions.updateDoiTuongThanhTra.request({ id: _this11.state.doiTuongTT }, params).then(function (res) {
              _this11.getListData();
              _this11.toggleDialog();
              (0, _toastr.Toastr)('Duyệt đối tượng thanh tra thành công', 'success');
              _this11.setState({ buttonLoading: false });
            }).catch(function (error) {
              if (error.response) {
                _this11.setState({ buttonLoading: false });
              }
            });
          } else {
            _api.Danhmuc.actions.postDoiTuongThanhTra.request('', params).then(function (res) {
              _this11.getListData();
              _this11.toggleDialog();
              (0, _toastr.Toastr)('Duyệt đối tượng thanh tra thành công', 'success');
              _this11.setState({ buttonLoading: false });
            }).catch(function (error) {
              if (error.response) {
                _this11.setState({ buttonLoading: false });
              }
            });
          }
          _this11.props.validators['danhMuc'] = [];
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.setState(_extends({}, this.state, {
        doiTuongSelecteds: []
      }));
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this12 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteDoiTuongThanhTra.request({ id: categoryId }).then(function (res) {
          _this12.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this12.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this12.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        isTrungMa: false,
        addType: 0,
        ma: '',
        ten: '',
        doiTuongTT: '',
        soDienThoai: '',
        diaChi: '',
        ghiChu: '',
        linhVucDoiTuongTT: '',
        nhomDoiTuongThanhTraId: 2,
        loaiDoiTuongTT: this.state.loaiDoiTuongTTList.length ? this.state.loaiDoiTuongTTList[0].giaTri : '',
        quanHuyenId: '',
        phuongXaId: ''
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({
        isTrungMa: false,
        approved: (0, _lodash.get)(item, 'approved'),
        popupAddCategory: true,
        addType: 2,
        doiTuongTT: (0, _lodash.get)(item, 'doiTuongThanhTraId'),
        ma: (0, _lodash.get)(item, 'ma'),
        ten: (0, _lodash.get)(item, 'ten'),
        diaChi: (0, _lodash.get)(item, 'diaChi'),
        soDienThoai: (0, _lodash.get)(item, 'soDienThoai'),
        ghiChu: (0, _lodash.get)(item, 'ghiChu'),
        loaiDoiTuongTT: (0, _lodash.get)(item, 'loaiDoiTuongThanhTra'),
        nhomDoiTuongThanhTraId: (0, _lodash.get)(item, 'nhomDoiTuongThanhTraInfo.nhomDoiTuongThanhTraId'),
        quanHuyenId: (0, _lodash.get)(item, 'quanHuyenInfo.id'),
        phuongXaId: (0, _lodash.get)(item, 'phuongXaInfo.id')
      });
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch(status) {
      if (status) {
        this.state.timKiemNangCao = true;
      } else {
        this.state.timKiemNangCao = false;
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onBlurMa',
    value: function onBlurMa(e) {
      if (this.state.ma) {
        this.getCheckTrungMaDoanhNghiep(this.state.doiTuongTT, this.state.ma);
      }
    }
  }, {
    key: 'handleImportDoiTuongThanhTra',
    value: function handleImportDoiTuongThanhTra(e) {
      var _this13 = this;

      var params = {
        field: 'file',
        file: e.target.files[0]
      };
      _api.Reception.actions.postImportDoiTuongThanhTra.request('', params).then(function (res) {
        var data = res.data;
        if (data === '') {
          (0, _toastr.Toastr)('Import thành công', 'success');
          _this13.getListData();
        } else {
          _this13.getListData();
          _this13.toggleDialogDuLieuLoi(params);
        }
      }).catch(function (error) {
        (0, _toastr.Toastr)((0, _lodash.get)(error, 'response.data.errors[0].detail'), 'error');
      });
    }
  }, {
    key: 'toggleDialogDuLieuLoi',
    value: function toggleDialogDuLieuLoi(params) {
      this.setState(_extends({}, this.state, {
        showDialogDuLieuLoi: !this.state.showDialogDuLieuLoi,
        paramsRequestDuLieuLoi: params
      }));
    }
  }, {
    key: 'handleDownloadDuLieuLoi',
    value: function handleDownloadDuLieuLoi() {
      _api.Reception.actions.postDownloadDsLoiDoiTuongThanhTra.request('', this.state.paramsRequestDuLieuLoi).then(function (res) {
        if (res.data) {
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(res.data);
          a.href = url;
          a.download = 'filedulieuloi.xlsx';
          a.click();
        }
      }).catch(function (error) {
        (0, _toastr.Toastr)((0, _lodash.get)(error, 'response.data.errors[0].detail'), 'error');
      });
    }
  }, {
    key: 'onCheckAll',
    value: function onCheckAll(e) {
      if (e.target.checked) {
        this.setState(_extends({}, this.state, {
          doiTuongSelecteds: this.state.data.filter(function (i) {
            return !i.approved;
          }).map(function (item) {
            return item.doiTuongThanhTraId;
          })
        }));
      } else {
        this.setState(_extends({}, this.state, {
          doiTuongSelecteds: []
        }));
      }
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function handleSelectedDoiTuong(e, item) {
      var checked = e.target.checked;
      var id = item.doiTuongThanhTraId;
      var result = this.state.doiTuongSelecteds;
      if (checked) {
        this.setState(_extends({}, this.state, {
          doiTuongSelecteds: [].concat(_toConsumableArray(result), [id])
        }));
      } else {
        this.setState(_extends({}, this.state, {
          doiTuongSelecteds: this.state.doiTuongSelecteds.filter(function (item) {
            return item !== id;
          })
        }));
      }
    }

    // handleApprove() {
    //   this.checkValidate().then((data) => {
    //     if(data) {
    //       ThanhTra.actions.approveDoiTuongThanhTra.request('', { ids: [this.state.doiTuongTT] }).then(res => {
    //         this.getListData()
    //         Toastr('Duyệt đối tượng thanh tra thành công', 'success');
    //         this.toggleDialog()
    //       }).catch(error => {
    //         if (error.response) {
    //           Toastr(error.response.data.errors[0].detail, 'error');
    //         }
    //       });
    //       this.props.validators['danhMuc'] = [];
    //     }
    //   })
    //   }

  }, {
    key: 'render',
    value: function render() {
      var idNhomCoQuanHanhChinh = (0, _lodash.get)((0, _lodash.head)((0, _lodash.get)(this.state, 'listNhomDoiTuong', []).filter(function (item) {
        return item.ten === 'Cơ quan hành chính';
      })), 'nhomDoiTuongThanhTraId');
      var isDisabledCheckAll = this.state.data.every(function (item) {
        return item.approved;
      });
      var totalApproved = this.state.data.filter(function (item) {
        return item.approved;
      }).length;
      var isCheckedAll = this.state.data.length > 0 && this.state.doiTuongSelecteds.length > 0 && totalApproved + this.state.doiTuongSelecteds.length === this.state.data.length;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content d-flex' },
              _react2.default.createElement(
                'div',
                { className: 'upload_file_content width-auto' },
                _react2.default.createElement('input', { type: 'file', accept: '.xls, .xlsx', name: 'uploadFile', className: 'upload btn-green', ref: 'btnUpload', onChange: this.handleImportDoiTuongThanhTra.bind(this) }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { htmlFor: 'file', className: 'btn-blue', onClick: this.handleImportDoiTuongThanhTra.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-upload-big-arrow-white mr5' }),
                  'Import \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra'
                )
              ),
              (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                this.state.timKiemNangCao ? _react2.default.createElement(_common.Input, { label: 'T\u1EEB kh\xF3a', value: this.state.tuKhoa, onChange: this.onChangeInput.bind(this, 'tuKhoa'), placeholder: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }) : _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(_common.Input, { label: 'M\xE3 s\u1ED1 thu\u1EBF', value: this.state.maSoThue, onChange: this.onChangeInput.bind(this, 'maSoThue'), placeholder: 'Nh\u1EADp m\xE3 s\u1ED1 thu\u1EBF...' }),
                _react2.default.createElement(_common.DropDown, { label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra', selectedValue: this.state.loaiDoiTuongFilter, onChange: this.onChange.bind(this, 'loaiDoiTuongFilter'), options: this.state.loaiDoiTuongTTList, keyName: 'giaTri', valueName: 'ten', placeholder: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                ),
                this.state.timKiemNangCao ? _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(
                    'div',
                    { className: 'input-group', style: { float: 'right' } },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.toggleSearch.bind(this, false) },
                      _react2.default.createElement('i', { className: 'tt tt-delete' }),
                      'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
                    )
                  )
                ) : ''
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.toggleSearch.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _list.DataTableDoiTuongThanhTra,
              {
                header: _table.header.doiTuongThanhTra,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading,
                showCheckbox: true,
                selectAllStatus: isCheckedAll,
                isDisabledCheckAll: isDisabledCheckAll,
                onCheck: this.onCheckAll.bind(this),
                doiTuongSelecteds: this.state.doiTuongSelecteds,
                isTTTP: this.state.isTTTP,
                getListData: this.getListData.bind(this)
              },
              _react2.default.createElement(_list.RowItemDoiTuongThanhTra, {
                parent: this,
                doiTuongSelecteds: this.state.doiTuongSelecteds,
                isTTTP: this.state.isTTTP
              })
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa đối tượng thanh tra' : 'Thêm mới đối tượng thanh tra',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body row' },
              _react2.default.createElement(_common.Input, {
                trungMa: this.state.isTrungMa,
                className: 'col-12',
                label: 'M\xE3 s\u1ED1 doanh nghi\u1EC7p',
                onBlur: this.onBlurMa.bind(this),
                value: this.state.ma,
                require: Number(this.state.nhomDoiTuongThanhTraId) !== idNhomCoQuanHanhChinh,
                maxLength: 255,
                onChange: this.onChange.bind(this, 'ma'),
                bindValidator: this,
                channel: 'danhMuc'
              }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 255, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.DropDown, { className: 'col-12', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra', selectedValue: this.state.nhomDoiTuongThanhTraId, placeholder: null, onChange: this.onChange.bind(this, 'nhomDoiTuongThanhTraId'), options: this.state.listNhomDoiTuong, valueName: 'ten', keyName: 'nhomDoiTuongThanhTraId' }),
              _react2.default.createElement(_common.DropDown, { className: 'col-12', label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra', selectedValue: this.state.loaiDoiTuongTT, placeholder: null, onChange: this.onChange.bind(this, 'loaiDoiTuongTT'), options: this.state.loaiDoiTuongTTList, valueName: 'ten', keyName: 'giaTri' }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: '\u0110\u1ECBa ch\u1EC9', value: this.state.diaChi, maxLength: 255, onChange: this.onChange.bind(this, 'diaChi') }),
              _react2.default.createElement(_common.DropDown, {
                className: 'col-12',
                label: 'Huy\u1EC7n/TP',
                selectedValue: this.state.quanHuyenId,
                onChange: this.onChange.bind(this, 'quanHuyenId'),
                name: 'quanHuyenId',
                placeholder: true,
                options: this.state.dsQuanHuyen, keyName: 'donViHanhChinhId', valueName: 'ten'
              }),
              _react2.default.createElement(_common.DropDown, {
                className: 'col-12',
                label: 'Ph\u01B0\u1EDDng/X\xE3',
                selectedValue: this.state.phuongXaId,
                onChange: this.onChange.bind(this, 'phuongXaId'),
                name: 'phuongXaId',
                placeholder: true,
                options: this.state.dsPhuongXa, keyName: 'donViHanhChinhId', valueName: 'ten'
              }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i', value: this.state.soDienThoai, maxLength: 40, onChange: this.onChange.bind(this, 'soDienThoai') }),
              _react2.default.createElement(_common.TextArea, { label: 'Ghi ch\xFA', maxLength: 1000, rows: 5, value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), className: 'col-12' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.addType == 2 && this.state.isTTTP && !this.state.approved },
                _react2.default.createElement(_core.Button, { style: { width: '100px' }, className: 'btn-blue tt-approve-double-check', text: 'Duy\u1EC7t', onClick: this.onApprove.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.showDialogDuLieuLoi,
              onClose: this.toggleDialogDuLieuLoi.bind(this),
              title: 'Th\xF4ng b\xE1o',
              className: 'panel-popup category medium',
              style: { width: 350 }
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              'Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra v\u1EEBa t\u1EA3i l\xEAn c\xF3 \u0111\u1ED1i t\u01B0\u1EE3ng b\u1ECB l\u1ED7i. Vui l\xF2ng b\u1EA5m t\u1EA3i xu\u1ED1ng danh s\xE1ch l\u1ED7i \u0111\u1EC3 ki\u1EC3m tra l\u1EA1i'
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialogDuLieuLoi.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: "btn-action btn-save", onClick: this.handleDownloadDuLieuLoi.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'T\u1EA3i xu\u1ED1ng danh s\xE1ch l\u1ED7i'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DoiTuongThanhTra;
}(_react2.default.Component);

DoiTuongThanhTra.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {};
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(DoiTuongThanhTra);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layout = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DonViNgoai = function (_React$Component) {
  _inherits(DonViNgoai, _React$Component);

  function DonViNgoai(props, context) {
    _classCallCheck(this, DonViNgoai);

    var _this = _possibleConstructorReturn(this, (DonViNgoai.__proto__ || Object.getPrototypeOf(DonViNgoai)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      ten: '',
      donViNgoaiHeThongId: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(DonViNgoai, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getDonViNgoai.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.donViNgoaiHeThongs,
            pageData: res.data.page,
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.ten.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.donViNgoaiHeThongId) {
          this.props.danhMuc.updateDonViNgoai({ id: this.state.donViNgoaiHeThongId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postDonViNgoai('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteDonViNgoai({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        ten: '',
        donViNgoaiHeThongId: ''
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        donViNgoaiHeThongId: item.donViNgoaiHeThongId,
        ten: item.ten
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                '\u0110\u01A1n v\u1ECB ngo\xE0i h\u1EC7 th\u1ED1ng'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DONVINGOAIHETHONG_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.donViNgoai,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemDonViNgoai, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.donViNgoaiHeThongId != '' ? 'Chỉnh sửa đơn vị' : 'Thêm mới đơn vị',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'),
                bindValidator: this, channel: 'danhMuc' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.donViNgoaiHeThongId != '' ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DonViNgoai;
}(_react2.default.Component);

DonViNgoai.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(DonViNgoai);

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _draftJs = __webpack_require__(265);

var _reactDraftWysiwyg = __webpack_require__(820);

var _draftjsToHtml = __webpack_require__(1976);

var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);

var _htmlToDraftjs = __webpack_require__(631);

var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);

var _config = __webpack_require__(16);

var _copyToClipboard = __webpack_require__(1600);

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomOption = function (_React$Component) {
  _inherits(CustomOption, _React$Component);

  function CustomOption(props, context) {
    _classCallCheck(this, CustomOption);

    var _this = _possibleConstructorReturn(this, (CustomOption.__proto__ || Object.getPrototypeOf(CustomOption)).call(this, props, context));

    _this.state = {
      progress: 0
    };
    return _this;
  }

  _createClass(CustomOption, [{
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this2 = this;

      if (e.target.files[0]) {
        var fileSize = e.target.files[0].size;
        if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this2.setState({ progress: progressBar });
          };

          _api.Reception.actions.postFileUploadHDSD.request('', params).then(function (res) {
            _this2.setState({ progress: 0 });
            (0, _copyToClipboard2.default)(res.data);
            (0, _toastr.Toastr)('Đường dẫn đã được copy vào clipboard', 'success');
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo link-attach', style: { paddingTop: '7px' } },
        _react2.default.createElement(
          'div',
          { className: 'upload_file_content' },
          _react2.default.createElement('input', { type: 'file', name: 'uploadFile', className: 'upload', ref: 'btnUpload', onChange: this.uploadFile.bind(this) }),
          _react2.default.createElement(
            'span',
            { htmlFor: 'file' },
            'T\u1EA3i l\xEAn t\u1EADp tin'
          )
        ),
        this.state.progress > 0 && _react2.default.createElement(
          'div',
          { className: 'pt-progress-bar progress-upload pt-intent-primary' },
          _react2.default.createElement('div', { className: 'pt-progress-meter', style: { width: this.state.progress + '%' } })
        )
      );
    }
  }]);

  return CustomOption;
}(_react2.default.Component);

var HuongDanSuDung = function (_React$Component2) {
  _inherits(HuongDanSuDung, _React$Component2);

  function HuongDanSuDung(props, context) {
    _classCallCheck(this, HuongDanSuDung);

    var _this3 = _possibleConstructorReturn(this, (HuongDanSuDung.__proto__ || Object.getPrototypeOf(HuongDanSuDung)).call(this, props, context));

    _this3.state = {
      isSubmit: false,
      data: [],
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryId: 0,
      buttonLoading: false,
      categoryDesc: _draftJs.EditorState.createEmpty()
    };
    _this3.onEditorStateChange = _this3.onEditorStateChange.bind(_this3);
    return _this3;
  }

  _createClass(HuongDanSuDung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this4 = this;

      _api.Danhmuc.actions.getHuongDanSuDung.request().then(function (res) {
        if (res.data._embedded) {
          var contentBlock = (0, _htmlToDraftjs2.default)(res.data._embedded.huongDanSuDungs[0].noiDung);
          var contentState = _draftJs.ContentState.createFromBlockArray(contentBlock.contentBlocks);
          var editorState = _draftJs.EditorState.createWithContent(contentState);
          _this4.setState({
            categoryId: res.data._embedded.huongDanSuDungs[0].huongDanSuDungId,
            categoryName: res.data._embedded.huongDanSuDungs[0].ten,
            categoryDesc: editorState,
            addType: 2
          });
        }
      });
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this5 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          noiDung: (0, _draftjsToHtml2.default)((0, _draftJs.convertToRaw)(this.state.categoryDesc.getCurrentContent()))
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateHuongDanSuDung({ id: this.state.categoryId }, params).then(function (res) {
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postHuongDanSuDung('', params).then(function (res) {
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'onEditorStateChange',
    value: function onEditorStateChange(categoryDesc) {
      this.setState({ categoryDesc: categoryDesc });
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.setState({
        addType: 0,
        categoryName: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'uploadImageCallBack',
    value: function uploadImageCallBack(file) {
      return new Promise(function (resolve, reject) {
        var params = {
          field: 'file', file: file
        };
        params.progress = function (progress) {};
        _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
          if (res.data) {
            var output = {
              data: {
                link: res.data
              }
            };
            resolve(output);
          }
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'section',
              { className: 'page-wrapper' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 999, onChange: this.onChange.bind(this, 'categoryName'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_reactDraftWysiwyg.Editor, {
                editorState: this.state.categoryDesc,
                wrapperClassName: 'wrapper-editor mb18',
                editorClassName: 'container-editor',
                editorStyle: {
                  minHeight: 350,
                  border: "1px solid #d8d8d8",
                  padding: 5,
                  borderRadius: 2,
                  height: "auto"
                },
                toolbar: {
                  options: ['blockType', 'inline', 'list', 'link', 'image', 'colorPicker', 'textAlign'],
                  blockType: {
                    inDropdown: true,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code']
                  },
                  inline: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['bold', 'italic', 'underline']
                  },
                  list: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: ['unordered', 'ordered', 'indent', 'outdent']
                  },
                  link: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    dropdownClassName: undefined,
                    showOpenOptionOnHover: true,
                    defaultTargetOption: '_self',
                    options: ['link', 'unlink']
                  },
                  image: {
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    urlEnabled: true,
                    uploadEnabled: true,
                    alignmentEnabled: true,
                    uploadCallback: this.uploadImageCallBack,
                    previewImage: true,
                    inputAccept: 'image/*',
                    alt: { present: false, mandatory: false },
                    defaultSize: {
                      height: 'auto',
                      width: 'auto'
                    }
                  }
                },
                onEditorStateChange: this.onEditorStateChange,
                toolbarCustomButtons: [_react2.default.createElement(CustomOption, null)]
              }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-save ' + (this.state.buttonLoading == true && 'btn-loading'), onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return HuongDanSuDung;
}(_react2.default.Component);

HuongDanSuDung.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(HuongDanSuDung);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layout = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _formTimkiem = __webpack_require__(100);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Letters = function (_React$Component) {
  _inherits(Letters, _React$Component);

  function Letters(props, context) {
    _classCallCheck(this, Letters);

    var _this = _possibleConstructorReturn(this, (Letters.__proto__ || Object.getPrototypeOf(Letters)).call(this, props, context));

    _this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      maTTCP: '',
      isValid: true,
      parentCategory: '',
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      loaiDonId: '',
      searchLoading: false,
      tuKhoa: '',
      search: false,
      timKiemNangCao: false,
      loaiDonFilter: '',
      linhVucFilter: [],
      linhVucTimKiemList: [],
      dialogConfirm: false,
      dialogConfirmContent: '',
      idDeleteConfirm: ''
    };
    return _this;
  }

  _createClass(Letters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getLinhVucDonThuSearch();
    }
  }, {
    key: 'getLinhVucDonThuSearch',
    value: function getLinhVucDonThuSearch() {
      var _this2 = this;

      _api.Danhmuc.actions.getLinhVucDonThuTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ linhVucTimKiemList: res.data._embedded.linhVucDonThus });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'linhVucTimKiem') {
        this.setState({ linhVucFilter: e });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this3 = this;

      e.preventDefault();
      this.setState({
        search: true,
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        }
      }, function () {
        _this3.getListData(true);
      });
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      if (this.state.timKiemNangCao) {
        if (this.state.loaiDonFilter) {
          params.loaiDon = this.state.loaiDonFilter;
        }
        if (this.state.linhVucFilter.length) {
          var ids = [];
          this.state.linhVucFilter.map(function (item) {
            ids.push(item.value);
          });
          params.listLinhVucs = ids.join();
        }
      }
      _api.Danhmuc.actions.getLinhVucDonThu.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            data: res.data._embedded.linhVucDonThus,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          if (_this4.state.pageData.number > 0) {
            _this4.setState({ pageData: _extends({}, _this4.state.pageData, {
                number: _this4.state.pageData.number - 1
              }) }, function () {
              _this4.getListData();
            });
          }
          _this4.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this6 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim(),
          loaiDon: this.state.loaiDonId,
          maTTCP: this.state.maTTCP
        };
        if (this.state.parentCategory) {
          params.cha = {
            id: this.state.parentCategory.linhVucDonThuId
          };
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateLinhVucDonThu.request({ id: this.state.categoryId }, params).then(function (res) {
            _this6.getListData();
            _this6.toggleDialog('popupAddCategory', false);
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this6.setState({ buttonLoading: false });
            _this6.getLinhVucDonThuSearch();
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this6.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postLinhVucDonThu.request('', params).then(function (res) {
            _this6.getListData();
            _this6.toggleDialog('popupAddCategory', false);
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this6.setState({ buttonLoading: false });
            _this6.getLinhVucDonThuSearch();
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this6.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this7 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this7.getListData();
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this8 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        var params = {};
        if (this.state.idDeleteConfirm) {
          params.delAll = true;
        }
        _api.Danhmuc.actions.deleteLinhVucDonThu.request({ id: categoryId }, params).then(function (res) {
          _this8.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this8.setState({ buttonLoading: false, idDeleteConfirm: '', dialogConfirm: false });
          _this8.getLinhVucDonThuSearch();
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data.errors[0].code == 'NOTIFY_CONFIRM') {
              _this8.setState({
                idDeleteConfirm: categoryId,
                buttonLoading: false,
                dialogConfirmContent: error.response.data.errors[0].detail,
                dialogConfirm: true
              });
            } else {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this8.setState({ buttonLoading: false });
            }
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      this.setState(_defineProperty({}, name, status));
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog('popupAddCategory', true);
      this.setState({
        addType: 0,
        categoryName: '',
        maTTCP: '',
        parentCategory: '',
        categoryDesc: '',
        isValid: true,
        loaiDonId: this.props.loaiDonThu.length ? this.props.loaiDonThu[0].giaTri : ''
      });
    }
  }, {
    key: 'openAddMoreCategory',
    value: function openAddMoreCategory(item) {
      this.toggleDialog('popupAddCategory', true);
      this.setState({
        addType: 1,
        categoryId: '',
        categoryName: '',
        parentCategory: item,
        categoryDesc: '',
        isValid: true,
        loaiDonId: item.loaiDon,
        maTTCP: ''
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({
        popupAddCategory: true,
        addType: 2,
        categoryId: item.linhVucDonThuId,
        categoryName: item.ten,
        maTTCP: item.maTTCP,
        parentCategory: item.linhVucDonThuCha,
        categoryDesc: item.moTa,
        loaiDonId: item.loaiDon,
        isValid: true
      });
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch(status) {
      if (status) {
        this.setState({ timKiemNangCao: true });
      } else {
        this.setState({ timKiemNangCao: false });
      }
    }
  }, {
    key: 'onConfirmDelete',
    value: function onConfirmDelete() {
      this.handleDelete(this.state.idDeleteConfirm);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'L\u0129nh v\u1EF1c \u0111\u01A1n th\u01B0'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('LINHVUCDONTHU_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(_common.DropDown, { label: 'Lo\u1EA1i \u0111\u01A1n', selectedValue: this.state.loaiDonFilter, onChange: this.onChange.bind(this, 'loaiDonFilter'), options: this.props.loaiDonThu, keyName: 'giaTri', valueName: 'ten', placeholder: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                ),
                this.state.timKiemNangCao ? _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected', label: 'L\u0129nh v\u1EF1c \u0111\u01A1n th\u01B0', dataOptions: this.state.linhVucTimKiemList, dataSelected: this.state.linhVucFilter, onChange: this.onChange.bind(this, 'linhVucTimKiem'), selectAllChildren: false, propertyChildren: 'linhVucDonThuCha', propertyParent: 'linhVucDonThuId' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'input-group', style: { float: 'right' } },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.toggleSearch.bind(this, false) },
                      _react2.default.createElement('i', { className: 'tt tt-delete' }),
                      'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
                    )
                  )
                ) : ''
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.toggleSearch.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.letters,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemLetters, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this, 'popupAddCategory', false),
              title: this.state.addType == 2 ? 'Chỉnh sửa lĩnh vực đơn thư' : 'Thêm mới lĩnh vực đơn thư',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body row' },
              _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { className: 'col-12', label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', selectedValue: this.state.loaiDonId, placeholder: null, onChange: this.onChange.bind(this, 'loaiDonId') }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'M\xE3 TTCP', value: this.state.maTTCP, require: false, maxLength: 40, onChange: this.onChange.bind(this, 'maTTCP'), channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'), bindValidator: this, channel: 'danhMuc' }),
              this.state.parentCategory ? _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  'L\u0129nh v\u1EF1c \u0111\u01A1n th\u01B0 cha: ',
                  this.state.parentCategory.ten
                )
              ) : null,
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: 'col-12' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this, 'popupAddCategory', false), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          ),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.dialogConfirm, onClose: this.toggleDialog.bind(this, 'dialogConfirm', false), onSuccess: this.onConfirmDelete.bind(this), title: this.state.dialogConfirmContent })
        )
      );
    }
  }]);

  return Letters;
}(_react2.default.Component);

Letters.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {
    loaiDonThu: state.duLieuHeThong.loaiDonThu
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(Letters);

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layout = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinhVucDoiTuongThanhTra = function (_React$Component) {
  _inherits(LinhVucDoiTuongThanhTra, _React$Component);

  function LinhVucDoiTuongThanhTra(props, context) {
    _classCallCheck(this, LinhVucDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (LinhVucDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(LinhVucDoiTuongThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(LinhVucDoiTuongThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.linhVucDoiTuongThanhTras,
            pageData: res.data.page,
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateLinhVucDoiTuongThanhTra.request({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postLinhVucDoiTuongThanhTra.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteLinhVucDoiTuongThanhTra.request({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        categoryName: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        categoryId: item.linhVucDoiTuongThanhTraId,
        categoryName: item.ten,
        categoryDesc: item.moTa || '',
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'L\u0129nh v\u1EF1c \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('LINHVUCDOITUONGTHANHTRA_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.competence,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemLinhVucDoiTuongThanhTra, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa lĩnh vực đối tượng thanh tra' : 'Thêm mới lĩnh vực đối tượng thanh tra',
              iconName: 'add-new',
              className: 'panel-popup category medium' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LinhVucDoiTuongThanhTra;
}(_react2.default.Component);

LinhVucDoiTuongThanhTra.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LinhVucDoiTuongThanhTra);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoaiTaiLieu = function (_React$Component) {
  _inherits(LoaiTaiLieu, _React$Component);

  function LoaiTaiLieu(props, context) {
    _classCallCheck(this, LoaiTaiLieu);

    var _this = _possibleConstructorReturn(this, (LoaiTaiLieu.__proto__ || Object.getPrototypeOf(LoaiTaiLieu)).call(this, props, context));

    _this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(LoaiTaiLieu, [{
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getLoaiTaiLieu.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.loaiTaiLieus,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateLoaiTaiLieu({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postLoaiTaiLieu('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteLoaiTaiLieu({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }_this4.setState({ buttonLoading: false });
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {

      this.toggleDialog();
      this.setState({
        addType: 0,
        categoryName: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {

      this.toggleDialog();
      this.setState({
        addType: 2,
        categoryId: item.loaiTaiLieuId,
        categoryName: item.ten,
        categoryDesc: item.moTa,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Lo\u1EA1i t\xE0i li\u1EC7u'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('LOAITAILIEU_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.documentType,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                labelPagination: 'S\u1ED1 b\u1EA3n ghi',
                parent: this,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemLoaiTaiLieu, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa loại tài liệu' : 'Thêm mới loại tài liệu',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, maxLength: 255, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LoaiTaiLieu;
}(_react2.default.Component);

LoaiTaiLieu.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(LoaiTaiLieu);

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _formTimkiem = __webpack_require__(100);

var _lodash = __webpack_require__(14);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhomDoiTuongThanhTra = function (_Component) {
  _inherits(NhomDoiTuongThanhTra, _Component);

  function NhomDoiTuongThanhTra(props, context) {
    _classCallCheck(this, NhomDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (NhomDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(NhomDoiTuongThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      doiTuongTT: '',
      moTa: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      timKiemNangCao: false
    };
    return _this;
  }

  _createClass(NhomDoiTuongThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.state.search = true;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getNhomDoiTuongThanhTra.request(null, params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          _this2.setState({
            data: res.data._embedded.nhomDoiTuongThanhTras,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this3 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this3.getListData();
      });
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this4 = this;

      var editNum = 2;
      if (this.checkValidate()) {
        var params = {
          ten: this.state.ten.trim()
        };
        if (this.state.moTa) {
          params.moTa = this.state.moTa;
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType === editNum) {
          _api.Danhmuc.actions.updateNhomDoiTuongThanhTra.request({ id: this.state.doiTuongTT }, params).then(function (res) {
            _this4.getListData();
            _this4.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this4.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (!(0, _lodash.isEmpty)(error.response)) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this4.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postNhomDoiTuongThanhTra.request('', params).then(function (res) {
            _this4.getListData();
            _this4.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this4.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (!(0, _lodash.isEmpty)(error.response)) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this4.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this6 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deletenhomDoiTuongThanhTras.request({ id: categoryId }).then(function (res) {
          _this6.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this6.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (!(0, _lodash.isEmpty)(error.response)) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this6.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        ten: '',
        moTa: ''
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({
        popupAddCategory: true,
        addType: 2,
        ten: item.ten,
        moTa: item.moTa,
        doiTuongTT: item.nhomDoiTuongThanhTraId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var editNum = 2;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh s\xE1ch nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_THEM') && _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                )
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.nhomDoiTuongThanhTra,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_list.RowItemNhomDoiTuongThanhTra, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType === editNum ? 'Chỉnh sửa đối tượng thanh tra' : 'Thêm mới đối tượng thanh tra',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body row' },
              _react2.default.createElement(_common.Input, { className: 'col-12', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 255, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: 'col-12' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: (0, _classnames2.default)('btn-action btn-save', {
                    'btn-loading': this.state.buttonLoading
                  }), onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType === editNum ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NhomDoiTuongThanhTra;
}(_react.Component);

NhomDoiTuongThanhTra.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {};
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(NhomDoiTuongThanhTra);

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _formTimkiem = __webpack_require__(100);

var _layout = __webpack_require__(9);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Organization = function (_React$Component) {
  _inherits(Organization, _React$Component);

  function Organization(props, context) {
    _classCallCheck(this, Organization);

    var _this = _possibleConstructorReturn(this, (Organization.__proto__ || Object.getPrototypeOf(Organization)).call(this, props, context));

    _this.state = {
      idSoBanNganh: '',
      data: [],
      dataSelectDVHC: [],
      dataSelectCCQQL: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataSNV: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      DataSelectLoaiCoQuanQL: [],
      ThanhPhoId: '',
      QuanHuyenId: '',
      PhuongXaId: '',
      categoryId: 0,
      ma: '',
      ten: '',
      moTa: '',
      maTTCP: '',
      parentCategory: '',
      capCoQuanQuanLyID: '',
      loaiCoQuanQuanLyId: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      isValid: true,
      coQuanQuanLyList: [],
      capCoQuanQuanLyList: [],
      coQuanQuanLyFilter: [],
      capCoQuanQuanLyFilter: [],
      timKiemNangCao: false,
      donViNhanTTXM: false,
      donViThucHienThanhTra: false,
      donViNhanTheoDoiThucHien: false,
      donViTmp: false,
      phongBanTheoDoiThucHien: false,
      donViNhanTTXMCheck: false,
      donViThucHienThanhTraCheck: false,
      donViNhanTheoDoiThucHienCheck: false,
      donViTmpCheck: false,
      phongBanTheoDoiThucHienCheck: false,
      donViSoNoiVu: {},
      showTimKiemDonVi: false,
      listDonViSNV: [],
      loadingSNV: false,
      tuKhoaDonViSNV: '',
      checkButton: '',
      isTTTW: false
    };
    return _this;
  }

  _createClass(Organization, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.route.type === "trung-uong") {
        this.getListDataTW();
        this.getCapCoQuanQuanLyTW();
        this.setState({
          isTTTW: true
        });
      } else {
        this.getListData();
        this.getListSelectBoxCCQQL();
        this.setState({
          isTTTW: false
        });
      }
      this.getCapCoQuanQuanLy();
      this.getListLoaiCoQuanQL();
      this.getCoQuanQuanLy();
      this.checkSoBanNganh();
      this.checkSoBanNganhMulti();
      if (window.debug) {
        console.log('category/Organization');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.route.type === "trung-uong") {
        this.getListDataTW();
        this.getCapCoQuanQuanLyTW();
        this.setState({
          isTTTW: true
        });
      } else {
        this.getListData();
        this.getListSelectBoxCCQQL();
        this.setState({
          isTTTW: false
        });
      }
    }
  }, {
    key: 'getListDataTW',
    value: function getListDataTW() {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getCoQuanTW.request(null, params).then(function (res) {
        if (res.data._embedded.coQuanQuanLies) {
          var data = res.data._embedded.coQuanQuanLies;
          _this2.setState({
            data: data,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'getCapCoQuanQuanLyTW',
    value: function getCapCoQuanQuanLyTW() {
      var _this3 = this;

      _api.Danhmuc.actions.getCapCoQuanQuanLyTW.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataSelectCCQQL: [res.data]
          });
        }
      });
    }
  }, {
    key: 'checkSoBanNganhMulti',
    value: function checkSoBanNganhMulti() {
      var _this4 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var getGiaTri = '';
      var params = {
        tuKhoa: 'CQQL_UBNDTP_DA_NANG,CQQL_THANH_TRA_THANH_PHO'
      };
      _api.DuLieuHeThong.actions.getThamSoHeThong.request(null, params).then(function (res) {
        if (res && res.data && res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          getGiaTri = res.data._embedded.thamSoes.findIndex(function (item) {
            return parseInt(item.giaTri) === userInfo.donViId && item.ten === 'CQQL_UBNDTP_DA_NANG' || parseInt(item.giaTri) === userInfo.donViId && item.ten === 'CQQL_THANH_TRA_THANH_PHO';
          });
          _this4.setState({ checkButton: getGiaTri });
        }
      });
    }
  }, {
    key: 'checkSoBanNganh',
    value: function checkSoBanNganh() {
      var _this5 = this;

      var params = {
        tuKhoa: 'CCQQL_SO_BAN_NGANH'
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res && res.data && res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          _this5.setState({ idSoBanNganh: res.data._embedded.thamSoes[0].giaTri });
        }
      });
    }
  }, {
    key: 'getCoQuanQuanLy',
    value: function getCoQuanQuanLy() {
      var _this6 = this;

      _api.Danhmuc.actions.getCoQuanQuanLyTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this6.setState({ coQuanQuanLyList: res.data._embedded.coQuanQuanLies });
        }
      });
    }
  }, {
    key: 'getCapCoQuanQuanLy',
    value: function getCapCoQuanQuanLy() {
      var _this7 = this;

      _api.Danhmuc.actions.getCapCoQuanQuanLyTimKiem.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this7.setState({ capCoQuanQuanLyList: res.data._embedded.capCoQuanQuanLies });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var newState = _extends({}, this.state);
      if (name == 'coQuanQuanLyFilter') {
        newState.coQuanQuanLyFilter = e;
      } else if (name == 'capCoQuanQuanLyFilter') {
        newState.capCoQuanQuanLyFilter = e;
      } else {
        newState[name] = e.target.value;
        if (name == 'ThanhPhoId') {
          newState.QuanHuyenId = '';
          newState.PhuongXaId = '';
        } else if (name == 'QuanHuyenId') {
          newState.PhuongXaId = '';
        }
      }
      this.setState(_extends({}, newState));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this8 = this;

      e.preventDefault();
      this.setState({
        search: true,
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        }
      }, function () {
        if (_this8.state.isTTTW) {
          _this8.getListDataTW();
        } else {
          _this8.getListData(true);
        }
      });
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this9 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        donViNhanTTXM: this.state.donViNhanTTXMCheck,
        donViThucHienThanhTra: this.state.donViThucHienThanhTraCheck,
        donViNhanTheoDoiThucHien: this.state.donViNhanTheoDoiThucHienCheck,
        donViTmp: this.state.donViTmpCheck,
        phongBanTheoDoiThucHien: this.state.phongBanTheoDoiThucHienCheck,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      if (this.state.timKiemNangCao) {
        if (this.state.capCoQuanQuanLyFilter.length) {
          var ids = [];
          this.state.capCoQuanQuanLyFilter.map(function (item) {
            ids.push(item.value);
          });
          params.listCapCoQuanQuanLys = ids.join();
        }
        if (this.state.coQuanQuanLyFilter.length) {
          var ids2 = [];
          this.state.coQuanQuanLyFilter.map(function (item) {
            ids2.push(item.value);
          });
          params.listCoQuanQuanLys = ids2.join();
        }
      }
      _api.Danhmuc.actions.getCoQuan.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this9.setState({
            data: res.data._embedded.coQuanQuanLies,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this9.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'getListLoaiCoQuanQL',
    value: function getListLoaiCoQuanQL() {
      var _this10 = this;

      _api.Danhmuc.actions.getLoaiCoQuanQL.request().then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            DataSelectLoaiCoQuanQL: res.data._embedded.loaiCoQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getListSelectBoxDVHC',
    value: function getListSelectBoxDVHC() {
      var _this11 = this;

      _api.Danhmuc.actions.getDonViHanhChinh.request().then(function (res) {
        if (res.data._embedded) {
          _this11.setState({
            dataSelectDVHC: res.data._embedded.donViHanhChinhs
          });
        }
      });
    }
  }, {
    key: 'getListSelectBoxCCQQL',
    value: function getListSelectBoxCCQQL() {
      var _this12 = this;

      _api.Danhmuc.actions.getCapCoQuan.request().then(function (res) {
        if (res.data._embedded) {
          _this12.setState({
            dataSelectCCQQL: res.data._embedded.capCoQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this13 = this;

      if (this.checkValidate()) {
        var params = {
          ma: this.state.ma.trim(),
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim(),
          maTTCP: this.state.maTTCP.trim(),
          capCoQuanQuanLy: { id: this.state.capCoQuanQuanLyID },
          donViNhanTTXM: this.state.donViNhanTTXM,
          donViThucHienThanhTra: this.state.donViThucHienThanhTra,
          donViNhanTheoDoiThucHien: this.state.donViNhanTheoDoiThucHien,
          donViTmp: this.state.donViTmp,
          phongBanTheoDoiThucHien: this.state.phongBanTheoDoiThucHien
        };
        if (this.state.PhuongXaId) {
          params.donViHanhChinh = { id: this.state.PhuongXaId };
        } else if (this.state.QuanHuyenId) {
          params.donViHanhChinh = { id: this.state.QuanHuyenId };
        } else {
          params.donViHanhChinh = { id: this.state.ThanhPhoId };
        }
        if (this.state.loaiCoQuanQuanLyId) {
          params.loaiCoQuanQuanLy = { id: this.state.loaiCoQuanQuanLyId };
        }
        if (this.state.parentCategory) {
          params.cha = {
            id: this.state.parentCategory.coQuanQuanLyId
          };
        }
        if (this.state.donViSoNoiVu) {
          params.soNoiVuId = this.state.donViSoNoiVu.donViSoNoiVuId;
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateCoQuan.request({ id: this.state.categoryId }, params).then(function (res) {
            if (_this13.state.isTTTW) {
              _this13.getListDataTW();
            } else {
              _this13.getListData();
            }
            _this13.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this13.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this13.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postCoQuan.request('', params).then(function (res) {
            if (_this13.state.isTTTW) {
              _this13.getListDataTW();
            } else {
              _this13.getListData();
            }
            _this13.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this13.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this13.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this14 = this;

      if (this.state.showTimKiemDonVi) {
        this.setState({
          pageDataSNV: _extends({}, this.state.pageDataSNV, {
            number: page.selected
          })
        }, function () {
          _this14.timKiemDonViSNV();
        });
      } else {
        this.setState({
          pageData: _extends({}, this.state.pageData, {
            number: page.selected
          })
        }, function () {
          if (_this14.state.isTTTW) {
            _this14.getListDataTW();
          } else {
            _this14.getListData();
          }
        });
      }
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this15 = this;

      if (this.state.showTimKiemDonVi) {
        this.setState({
          pageDataSNV: _extends({}, this.state.pageDataSNV, {
            size: size,
            number: 0
          })
        }, function () {
          _this15.timKiemDonViSNV();
        });
      } else {
        this.setState({
          pageData: _extends({}, this.state.pageData, {
            size: size,
            number: 0
          })
        }, function () {
          if (_this15.state.isTTTW) {
            _this15.getListDataTW();
          } else {
            _this15.getListData();
          }
        });
      }
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this16 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteCoQuan.request({ id: categoryId }).then(function (res) {
          if (_this16.state.isTTTW) {
            _this16.getListDataTW();
          } else {
            _this16.getListData();
          }
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this16.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this16.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        ma: '',
        ten: '',
        moTa: '',
        maTTCP: '',
        parentCategory: '',
        capCoQuanQuanLyID: '',
        ThanhPhoId: '',
        QuanHuyenId: '',
        PhuongXaId: '',
        donViNhanTTXM: false,
        donViThucHienThanhTra: false,
        donViNhanTheoDoiThucHien: false,
        donViTmp: false,
        phongBanTheoDoiThucHien: false,
        loaiCoQuanQuanLyId: '',
        isValid: true,
        donViSoNoiVu: {}
      });
      this.timKiemDonViSNV();
    }
  }, {
    key: 'openAddMoreCategory',
    value: function openAddMoreCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 1,
        ma: '',
        ten: '',
        parentCategory: item,
        moTa: '',
        maTTCP: '',
        capCoQuanQuanLyID: '',
        ThanhPhoId: '',
        QuanHuyenId: '',
        PhuongXaId: '',
        loaiCoQuanQuanLyId: '',
        isValid: true
      });
      if (item.soNoiVuId) {
        this.state.donViSoNoiVu = { donViSoNoiVuId: item.donViSoNoiVuId, tenDonVi: 'Đã liên kết' };
      } else {
        this.state.donViSoNoiVu = {};
      }
      this.getInfoQuanFromPhuong(item.donViHanhChinhCQQL.donViHanhChinhId);
      this.timKiemDonViSNV();
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      if (item.loaiCoQuanQuanLyInfo != null) {
        this.setState({ loaiCoQuanQuanLyId: item.loaiCoQuanQuanLyInfo.loaiCoQuanQuanLyId });
      }

      this.setState({
        addType: 2,
        ma: item.ma,
        ten: item.ten,
        moTa: item.moTa,
        maTTCP: item.maTTCP || '',
        parentCategory: item.coQuanQuanLyCha,
        capCoQuanQuanLyID: item.capCoQuanQuanLyCQQL.capCoQuanQuanLyId,
        categoryId: item.coQuanQuanLyId,
        QuanHuyenId: '',
        ThanhPhoId: '',
        PhuongXaId: '',
        donViNhanTTXM: item.donViNhanTTXM,
        donViThucHienThanhTra: item.donViThucHienThanhTra,
        donViNhanTheoDoiThucHien: item.donViNhanTheoDoiThucHien,
        donViTmp: item.donViTmp,
        phongBanTheoDoiThucHien: item.phongBanTheoDoiThucHien,
        isValid: true
      });
      if (item.soNoiVuId) {
        this.state.donViSoNoiVu = { donViSoNoiVuId: item.donViSoNoiVuId, tenDonVi: 'Đã liên kết' };
      } else {
        this.state.donViSoNoiVu = {};
      }
      this.timKiemDonViSNV();
      this.getInfoQuanFromPhuong(item.donViHanhChinhCQQL.donViHanhChinhId);
    }
  }, {
    key: 'getInfoQuanFromPhuong',
    value: function getInfoQuanFromPhuong(ItemID) {
      var _this17 = this;

      _api.Danhmuc.actions.getInfoDonViHanhChinh.request({ id: ItemID }).then(function (res) {
        if (res.data) {
          if (res.data.donViHanhChinhCha == null) {
            _this17.setState({
              ThanhPhoId: ItemID,
              QuanHuyenId: ''
            });
          } else {
            _this17.getInfoThanhPhoFromQuan(res.data.donViHanhChinhCha.donViHanhChinhId, ItemID);
            _this17.setState({ QuanHuyenId: res.data.donViHanhChinhCha.donViHanhChinhId });
          }
        }
      });
    }
  }, {
    key: 'getInfoThanhPhoFromQuan',
    value: function getInfoThanhPhoFromQuan(ParentsId, ChildrenId) {
      var _this18 = this;

      _api.Danhmuc.actions.getInfoDonViHanhChinh.request({ id: ParentsId }).then(function (res) {
        if (res.data) {
          if (res.data.donViHanhChinhCha == null) {
            _this18.setState({
              ThanhPhoId: ParentsId,
              QuanHuyenId: ChildrenId,
              PhuongXaId: ''
            });
          } else {
            _this18.setState({
              ThanhPhoId: res.data.donViHanhChinhCha.donViHanhChinhId,
              QuanHuyenId: ParentsId,
              PhuongXaId: ChildrenId
            });
          }
        }
      });
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch(status) {
      if (status) {
        this.setState({ timKiemNangCao: true });
      } else {
        this.setState({ timKiemNangCao: false });
      }
    }
  }, {
    key: 'changeCheckbox',
    value: function changeCheckbox(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.checked));
    }
  }, {
    key: 'setValue',
    value: function setValue(name, value) {
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: 'timKiemDonViSNV',
    value: function timKiemDonViSNV() {
      var _this19 = this;

      var params = {
        page: this.state.pageDataSNV.number,
        size: this.state.pageDataSNV.size,
        tuKhoa: this.state.tuKhoaDonViSNV.trim()
      };
      this.setState({ loadingSNV: true });
      _api.Danhmuc.actions.getDonViSoNoiVu.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this19.setState({
            listDonViSNV: res.data._embedded.donViSoNoiVus,
            pageDataSNV: res.data.page
          });
        } else {
          _this19.setState({ listDonViSNV: [],
            pageDataSNV: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
        _this19.setState({ loadingSNV: false });
      }).catch(function (e) {
        _this19.setState({ loadingSNV: false });
      });
    }
  }, {
    key: 'handleSelectSNV',
    value: function handleSelectSNV(item) {
      this.state.donViSoNoiVu = item;
      this.setValue('showTimKiemDonVi', false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this20 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataCheckbox = [{
        name: 'donViNhanTTXMCheck',
        checked: this.state.donViNhanTTXMCheck ? true : false,
        text: 'Đơn vị nhận thẩm tra xác minh'
      }, {
        name: 'donViNhanTheoDoiThucHienCheck',
        checked: this.state.donViNhanTheoDoiThucHienCheck ? true : false,
        text: 'Đơn vị nhận theo dõi thực hiện'
      }, {
        name: 'donViTmpCheck',
        checked: this.state.donViTmpCheck ? true : false,
        text: 'Đơn vị nhận TTXM-KNPA'
      }, {
        name: 'phongBanTheoDoiThucHienCheck',
        checked: this.state.phongBanTheoDoiThucHienCheck ? true : false,
        text: 'Phòng ban nhận theo dõi thực hiện'
      }, {
        name: 'donViThucHienThanhTraCheck',
        checked: this.state.donViThucHienThanhTraCheck ? true : false,
        text: 'Đơn vị thực hiện thanh tra'
      }];
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                ' ',
                this.state.isTTTW ? 'Danh sách cơ quan thanh tra trung ương tại Tỉnh' : 'Cơ quan quản lý'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },

              // CheckPermission('COQUANQUANLY_THEM') && this.state.checkButton !== -1 ?
              (0, _CheckPermission.CheckPermission)('COQUANQUANLY_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(
                'form',
                { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(_formTimkiem.InputTuKhoa, { value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), placeholderText: 'Nh\u1EADp t\u1EEB kh\xF3a \u0111\u1EC3 t\xECm ki\u1EBFm...' }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(_core.Button, { className: 'btn-green tt-search', text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
                ),
                this.state.timKiemNangCao && _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { style: { marginTop: '10px' }, className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.toggleSearch.bind(this, false) },
                    _react2.default.createElement('i', { className: 'tt tt-delete' }),
                    'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
                  )
                ),
                this.state.timKiemNangCao && _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected', label: 'C\u1EA5p c\u01A1 quan qu\u1EA3n l\xFD', dataOptions: this.state.capCoQuanQuanLyList, dataSelected: this.state.capCoQuanQuanLyFilter, onChange: this.onChange.bind(this, 'capCoQuanQuanLyFilter'), selectAllChildren: false, propertyChildren: 'capCoQuanQuanLyCha', propertyParent: 'capCoQuanQuanLyId' }),
                  _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected', label: 'C\u01A1 quan qu\u1EA3n l\xFD', dataOptions: this.state.coQuanQuanLyList, dataSelected: this.state.coQuanQuanLyFilter, onChange: this.onChange.bind(this, 'coQuanQuanLyFilter'), selectAllChildren: false, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: userInfo.id === 1 },
                    dataCheckbox && dataCheckbox.map(function (item, index) {
                      return _react2.default.createElement(
                        _core.Checkbox,
                        { key: index, className: 'pt-position-button tree-selected pt-large', name: item.name, checked: item.checked, onChange: _this20.changeCheckbox.bind(_this20) },
                        _react2.default.createElement(
                          'span',
                          { className: 'span-checkbox span-position-label' },
                          item.text
                        )
                      );
                    })
                  )
                )
              ),
              !this.state.isTTTW && _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.toggleSearch.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: this.state.isTTTW ? _table.header.categoryGroup.coquanthanhtratw : _table.header.categoryGroup.organization,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideExport: true,
                parent: this,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_list.RowItemOrganization, { isTTTW: this.state.isTTTW })
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa cơ quan quản lý' : 'Thêm mới cơ quan quản lý',
              iconName: 'add-new',
              className: 'panel-popup category organization-content' },
            !this.state.showTimKiemDonVi && _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3', value: this.state.ma, require: true, onChange: this.onChange.bind(this, 'ma'), bindValidator: this, channel: 'danhMuc' }),
              !this.state.isTTTW && _react2.default.createElement(_common.Input, { className: 'col-6', label: 'M\xE3 TTCP', value: this.state.maTTCP, require: false, maxLength: 40, onChange: this.onChange.bind(this, 'maTTCP'), channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'T\xEAn', value: this.state.ten, require: true, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              !this.state.isTTTW && _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'Lo\u1EA1i c\u01A1 quan qu\u1EA3n l\xFD', options: this.state.DataSelectLoaiCoQuanQL, keyName: 'loaiCoQuanQuanLyId', valueName: 'ten',
                selectedValue: this.state.loaiCoQuanQuanLyId, placeholder: { key: '', text: 'Chọn...' }, onChange: this.onChange.bind(this, 'loaiCoQuanQuanLyId') }),
              _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'C\u1EA5p c\u01A1 quan qu\u1EA3n l\xFD', require: true, options: this.state.dataSelectCCQQL, keyName: 'capCoQuanQuanLyId', valueName: 'ten',
                selectedValue: this.state.capCoQuanQuanLyID, placeholder: { key: '', text: 'Chọn...' }, onChange: this.onChange.bind(this, 'capCoQuanQuanLyID'), bindValidator: this, channel: 'danhMuc' }),
              !this.state.isTTTW && _react2.default.createElement(
                'div',
                { className: 'col-12' },
                this.state.parentCategory ? _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  '\u0110\u01A1n v\u1ECB h\xE0nh ch\xEDnh cha: ',
                  this.state.parentCategory.ten
                ) : null
              ),
              !this.state.isTTTW && _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  '\u0110\u01A0N V\u1ECA H\xC0NH CH\xCDNH'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-12 mlr-5' },
                _react2.default.createElement(_ttForms.DropDownChonTinhThanh, { className: 'col-4', require: true, selectedValue: this.state.ThanhPhoId,
                  onChange: this.onChange.bind(this, 'ThanhPhoId'), bindValidator: this }),
                _react2.default.createElement(_ttForms.DropDownChonQuanHuyen, { className: 'col-4', selectedValue: this.state.QuanHuyenId,
                  thanhPhoID: this.state.ThanhPhoId, onChange: this.onChange.bind(this, 'QuanHuyenId') }),
                _react2.default.createElement(_ttForms.DropDownChonPhuongXa, { className: 'col-4', selectedValue: this.state.PhuongXaId,
                  quanHuyenId: this.state.QuanHuyenId, onChange: this.onChange.bind(this, 'PhuongXaId'),
                  thanhPhoID: this.state.ThanhPhoId })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.isTTTW && userInfo.id === 1 },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 mb5' },
                  _react2.default.createElement('input', { type: 'checkbox', id: 'dvTHTT', className: 'input-cb', name: 'donViThucHienThanhTra', checked: this.state.donViThucHienThanhTra, value: this.state.donViThucHienThanhTra, onChange: this.changeCheckbox.bind(this) }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'dvTHTT' },
                    '\u0110\u01A1n v\u1ECB th\u1EF1c hi\u1EC7n thanh tra'
                  )
                )
              ),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: 'col-12' })
            ),
            !this.state.showTimKiemDonVi && _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            ),
            this.state.showTimKiemDonVi && _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'div',
                { className: 'back-foward mt0' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.setValue.bind(this, 'showTimKiemDonVi', false) },
                  'V\u1EC1 trang tr\u01B0\u1EDBc'
                )
              ),
              _react2.default.createElement(
                'div',
                { id: 'list-people-search', className: 'search-name-container' },
                _react2.default.createElement(
                  'form',
                  { className: 'items-form', onSubmit: this.timKiemDonViSNV.bind(this), action: 'javascript:void(0)' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(_common.Input, { label: 'T\u1EEB kh\xF3a', className: 'col-80', value: this.state.tuKhoaDonViSNV, onChange: this.onChange.bind(this, 'tuKhoaDonViSNV') }),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-2' },
                      _react2.default.createElement(
                        'label',
                        { className: 'seacrh-people' },
                        _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-search', text: 'T\xECm ki\u1EBFm' })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    header: _table.header.popUpDonViSNV,
                    dataList: this.state.listDonViSNV,
                    hideButtonExport: true,
                    pageData: this.state.pageDataSNV,
                    parent: this,
                    tableLoading: this.state.loadingSNV },
                  _react2.default.createElement(_list.RowItemSearchDonViSoNoiVu, { onSelect: this.handleSelectSNV.bind(this) })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Organization;
}(_react2.default.Component);

Organization.defaultProps = {
  validators: {}
};
function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(Organization);

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrganizationLevel = function (_React$Component) {
  _inherits(OrganizationLevel, _React$Component);

  function OrganizationLevel(props, context) {
    _classCallCheck(this, OrganizationLevel);

    var _this = _possibleConstructorReturn(this, (OrganizationLevel.__proto__ || Object.getPrototypeOf(OrganizationLevel)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryCode: '',
      parentCategory: '',
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(OrganizationLevel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getCapCoQuan.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.capCoQuanQuanLies,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          if (_this2.state.pageData.number > 0) {
            _this2.state.pageData.number -= 1;
            _this2.getListData();
          }
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ma: this.state.categoryCode.trim(),
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim()
        };
        if (this.state.parentCategory) {
          params.cha = {
            id: this.state.parentCategory.capCoQuanQuanLyId
          };
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateCapCoQuan({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postCapCoQuan('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteCapCoQuan({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {

      this.toggleDialog();
      this.setState({
        addType: 0,
        categoryCode: '',
        categoryName: '',
        parentCategory: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openAddMoreCategory',
    value: function openAddMoreCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 1,
        categoryId: '',
        categoryCode: '',
        categoryName: '',
        parentCategory: item,
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        categoryId: item.capCoQuanQuanLyId,
        categoryCode: item.ma,
        categoryName: item.ten,
        parentCategory: item.capCoQuanQuanLyCha,
        categoryDesc: item.moTa,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'C\u1EA5p c\u01A1 quan'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('CAPCOQUANQUANLY_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.organizationlevel,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemOrganizationLevel, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa cấp cơ quan' : 'Thêm mới cấp cơ quan',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'), bindValidator: this, channel: 'danhMuc' }),
              this.state.parentCategory ? _react2.default.createElement(
                'label',
                { className: 'pt-label' },
                'C\u1EA5p c\u01A1 quan cha: ',
                this.state.parentCategory.ten
              ) : null,
              _react2.default.createElement(_common.Input, { className: '', label: 'M\xE3', value: this.state.categoryCode, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryCode'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return OrganizationLevel;
}(_react2.default.Component);

OrganizationLevel.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(OrganizationLevel);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      isValid: true,
      moTa: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(Position, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.ten = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getChucVu.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.chucVus,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.validateSubmitForm()) {
        var params = {
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim()
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateChucVu({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.closeDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postChucVu('', params).then(function (res) {
            _this3.getListData();
            _this3.closeDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteChucVu({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      //
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        addType: 0,
        ten: '',
        isValid: true,
        moTa: ''
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.openDialog();
      this.setState({
        addType: 2,
        ten: item.ten,
        moTa: item.moTa,
        isValid: true,
        categoryId: item.chucVuId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Ch\u1EE9c v\u1EE5'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('CHUCVU_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.position,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemPosition, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa chức vụ' : 'Thêm mới chức vụ',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 40,
                onChange: this.onChange.bind(this, 'ten') }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, maxLength: 255, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Position;
}(_react2.default.Component);

Position.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(Position);

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuocTich = function (_React$Component) {
  _inherits(QuocTich, _React$Component);

  function QuocTich(props, context) {
    _classCallCheck(this, QuocTich);

    var _this = _possibleConstructorReturn(this, (QuocTich.__proto__ || Object.getPrototypeOf(QuocTich)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ma: '',
      isValid: true,
      ten: '',
      moTa: '',
      maTTCP: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(QuocTich, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getQuocTich.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.quocTiches,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ma: this.state.ma.trim(),
          ten: this.state.ten.trim(),
          maTTCP: this.state.maTTCP.trim(),
          moTa: this.state.moTa.trim()
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateQuocTich({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postQuocTich('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteQuocTich({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 0,
        ma: '',
        ten: '',
        moTa: '',
        maTTCP: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 2,
        ma: item.ma,
        ten: item.ten,
        moTa: item.moTa,
        maTTCP: item.maTTCP,
        isValid: true,
        categoryId: item.quocTichId
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Qu\u1ED1c t\u1ECBch'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('QUOCTICH_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.nationality,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemQuocTich, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa quốc tịch' : 'Thêm quốc tịch',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'M\xE3', value: this.state.ma, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ma'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: '', label: 'M\xE3 TTCP', value: this.state.maTTCP, require: false, maxLength: 40, onChange: this.onChange.bind(this, 'maTTCP'), channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return QuocTich;
}(_react2.default.Component);

QuocTich.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(QuocTich);

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Role = function (_React$Component) {
  _inherits(Role, _React$Component);

  function Role(props, context) {
    _classCallCheck(this, Role);

    var _this = _possibleConstructorReturn(this, (Role.__proto__ || Object.getPrototypeOf(Role)).call(this, props, context));

    _this.state = {
      data: [],
      dataRole: [],
      roleSelected: [],
      DataLoaiVaiTro: [],
      dataOptions: [],
      dataSelected: [],
      donViCon: false,
      LoaiVaiTro: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      isValid: true,
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      moTa: '',
      phoPhong: false
    };
    return _this;
  }

  _createClass(Role, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getListRole();
      this.getListVaiTro();
      this.getListDV();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'DonVi') {
        this.setState({
          dataSelected: e
        });
      } else if (name === 'donViCon') {
        this.setState({ donViCon: !this.state.donViCon });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getVaiTro.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.vaiTroes,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'getListRole',
    value: function getListRole() {
      var _this3 = this;

      this.props.danhMuc.getQuyen().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataRole: res.data
          });
        } else {
          _this3.setState({
            dataRole: []
          });
        }
      });
    }
  }, {
    key: 'getListVaiTro',
    value: function getListVaiTro() {
      var _this4 = this;

      this.props.danhMuc.getListLoaiVaiTro({ page: this.state.pageData.number, size: this.state.pageData.size }).then(function (res) {
        if (res.data) {
          _this4.setState({
            DataLoaiVaiTro: res.data,
            LoaiVaiTro: res.data[0].giaTri
          });
        }
      });
    }
  }, {
    key: 'getListVaiTrotheoDV',
    value: function getListVaiTrotheoDV() {
      var _this5 = this;

      this.props.danhMuc.getListVaiTrotheoDV({ page: this.state.pageData.number, size: this.state.pageData.size }).then(function (res) {
        if (res && res.data) {
          _this5.setState({
            DataLoaiVaiTro: res.data,
            LoaiVaiTro: res.data[0].giaTri
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this6 = this;

      if (this.validateSubmitForm()) {
        var params = {
          phoPhong: this.state.phoPhong,
          ten: this.state.ten.trim(),
          loaiVaiTro: this.state.LoaiVaiTro,
          moTa: this.state.moTa,
          quyen: this.state.roleSelected.join(',')
        };
        if (this.state.dataSelected && this.state.dataSelected.length > 0) {
          var ids = [];
          this.state.dataSelected.forEach(function (item) {
            ids.push({ id: item.value });
          });
          params.coQuanQuanLys = ids;
        }
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateVaiTro({ id: this.state.categoryId }, params).then(function (res) {
            _this6.getListData();
            _this6.closeDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this6.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this6.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postVaiTro('', params).then(function (res) {
            _this6.getListData();
            _this6.closeDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this6.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this6.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this7 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteVaiTro({ id: categoryId }).then(function (res) {
          _this7.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this7.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this7.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(e) {
      if (this.state.roleSelected.indexOf(e.target.value) > -1) {
        this.state.roleSelected.splice(this.state.roleSelected.indexOf(e.target.value), 1);
        e.target.checked = false;
      } else {
        this.state.roleSelected.push(e.target.value);
        e.target.checked = true;
      }
      this.setState({
        dataRole: this.state.dataRole
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory, isSubmit: false });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory, isSubmit: false });
      //
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        phoPhong: false,
        addType: 0,
        ten: '',
        moTa: '',
        LoaiVaiTro: '',
        roleSelected: [],
        dataSelected: [],
        isValid: true
      });
      this.getListVaiTro();
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.openDialog();
      var ids = [];
      if (item && item.listCoQuanQuanLy && item.listCoQuanQuanLy.length > 0) {
        item.listCoQuanQuanLy.forEach(function (item) {
          ids.push({ value: item.coQuanQuanLyId, label: item.ten });
        });
      }
      this.setState({
        phoPhong: item.phoPhong,
        addType: 2,
        ten: item.ten,
        moTa: item.moTa,
        categoryId: item.vaiTroId,
        LoaiVaiTro: item.loaiVaiTro,
        isValid: true,
        roleSelected: item.quyen ? item.quyen.split(',') : [],
        dataSelected: item.listCoQuanQuanLy ? ids : []
      });
    }
  }, {
    key: 'handleCheckBox',
    value: function handleCheckBox(e) {
      this.setState({
        phoPhong: e.target.checked
      });
    }
  }, {
    key: 'getListDV',
    value: function getListDV() {
      var _this8 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      _api.DuLieuHeThong.actions.getCoQuanQuanLytheoDV.request().then(function (res) {
        if (res && res.data && res.data._embedded) {
          var dataDonVi = [].concat(_toConsumableArray(res.data._embedded.coQuanQuanLies));
          var DonVi = dataDonVi.filter(function (state) {
            return state.coQuanQuanLyId === userInfo.donViId;
          });
          _this8.setState({
            dataSelected: [{ value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }],
            dataOptions: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var RoleItem = this.state.dataRole.map(function (item, i) {
        var RoleName = item.tenQuyen.split(',');
        var RoleValue = item.giaTriQuyen.split(',');
        item.RoleDetail = [];
        RoleName.map(function (NameItem, j) {
          var Data = {
            name: NameItem,
            value: RoleValue[j],
            status: false
          };
          item.RoleDetail.push(Data);
        });
        var SubRoleItems = item.RoleDetail.map(function (item, j) {
          item.status = _this9.state.roleSelected.indexOf(item.value) > -1 ? true : false;
          return _react2.default.createElement(
            'li',
            { key: j },
            _react2.default.createElement(
              'label',
              { className: 'pt-control pt-checkbox' },
              _react2.default.createElement('input', { type: 'checkbox', checked: item.status, value: item.value, onChange: _this9.handleCheckBoxClick.bind(_this9) }),
              _react2.default.createElement('span', { className: 'pt-control-indicator' }),
              item.name
            )
          );
        });
        return _react2.default.createElement(
          'ul',
          { className: 'list-role-items', key: i },
          _react2.default.createElement(
            'li',
            { className: 'role-name' },
            _react2.default.createElement(
              'label',
              { className: 'role-title' },
              item.tenChucNang
            ),
            _react2.default.createElement(
              'ul',
              { className: 'sub-role-items' },
              SubRoleItems
            )
          )
        );
      });
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Nh\xF3m vai tr\xF2'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('VAITRO_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.role,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemRole, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa nhóm vai trò' : 'Thêm mới nhóm vai trò',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: 'col-6', label: 'T\xEAn', value: this.state.ten, bindValidator: this, channel: 'formTaoDon', require: true,
                onChange: this.onChange.bind(this, 'ten') }),
              _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'Lo\u1EA1i vai tr\xF2', bindValidator: this, channel: 'formTaoDon', require: true,
                options: this.state.DataLoaiVaiTro, keyName: 'giaTri', valueName: 'ten', placeholder: { key: '', text: 'Chọn...' },
                selectedValue: this.state.LoaiVaiTro, onChange: this.onChange.bind(this, 'LoaiVaiTro') }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.LoaiVaiTro === "TRUONG_PHONG" },
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'ip-label' },
                    'Ph\xF3 ph\xF2ng'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'label',
                          { className: 'pt-control pt-checkbox pt-large' },
                          _react2.default.createElement('input', { type: 'checkbox', id: 'isPP', className: 'pt-large', name: 'phoPhong', value: this.state.phoPhong, checked: this.state.phoPhong ? true : false, onChange: this.handleCheckBox.bind(this) }),
                          _react2.default.createElement('span', { className: 'tp-checkbox' }),
                          _react2.default.createElement('span', { className: 'name_checkbox' })
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'tree-selected-nhomvaitro col-min-83', label: '\u0110\u01A1n v\u1ECB', dataOptions: this.state.dataOptions, dataSelected: this.state.dataSelected, onChange: this.onChange.bind(this, 'DonVi'), selectAllChildren: this.state.donViCon, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', bindValidator: this, channel: 'formTaoDon', require: true }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 99999, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: 'col-12' }),
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  'Ph\xE2n quy\u1EC1n ch\u1EE9c n\u0103ng'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'list-role-wrap' },
                  RoleItem
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Role;
}(_react2.default.Component);

Role.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(Role);

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThamQuyen = function (_React$Component) {
  _inherits(ThamQuyen, _React$Component);

  function ThamQuyen(props, context) {
    _classCallCheck(this, ThamQuyen);

    var _this = _possibleConstructorReturn(this, (ThamQuyen.__proto__ || Object.getPrototypeOf(ThamQuyen)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      isValid: true,
      categoryDesc: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(ThamQuyen, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getThamQuyen.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.thamQuyenGiaiQuyets,
            pageData: res.data.page,
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.categoryName.trim(),
          moTa: this.state.categoryDesc.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateThamQuyen({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postThamQuyen('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteThamQuyen({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 0,
        categoryName: '',
        categoryDesc: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.setState({ isSubmit: false });
      this.toggleDialog();
      this.setState({
        addType: 2,
        categoryId: item.thamQuyenGiaiQuyetId,
        categoryName: item.ten,
        categoryDesc: item.moTa,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('THAMQUYENGIAIQUYET_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.competence,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemThamQuyen, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa thẩm quyền giải quyết' : 'Thêm mới thẩm quyền giải quyết',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.categoryName, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'categoryName'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.categoryDesc, onChange: this.onChange.bind(this, 'categoryDesc'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThamQuyen;
}(_react2.default.Component);

ThamQuyen.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(ThamQuyen);

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _layout = __webpack_require__(9);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TuDongBaoCao = function (_React$Component) {
  _inherits(TuDongBaoCao, _React$Component);

  function TuDongBaoCao(props, context) {
    _classCallCheck(this, TuDongBaoCao);

    var _this = _possibleConstructorReturn(this, (TuDongBaoCao.__proto__ || Object.getPrototypeOf(TuDongBaoCao)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      popupViewCategory: false,
      addType: 0,

      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      isValid: true,
      donViNhan: [],
      donViGui: null,
      listDonVi: [],
      listLoaiBaoCao: [],
      danhSachBaoCao: [],
      tenBaoCao: '',
      ngayBatDauBC: '',
      ngayKetThucBC: '',
      hanBaoCao: '',
      soNgayTuDongGui: 0,
      namBaoCao: '',
      thangBaoCao: '',
      quyBaoCao: '',
      kyBaoCao: 'THEO_QUY',
      idTTTP: ''
    };
    return _this;
  }

  _createClass(TuDongBaoCao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getListDV();
      this.getLoaiBaoCao();
      this.checkDonVi();
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ idTTTP: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'getListDV',
    value: function getListDV() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getDonViThongKe.request().then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            listDonVi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getLoaiBaoCao',
    value: function getLoaiBaoCao() {
      var _this4 = this;

      _api.Danhmuc.actions.getLoaiBaoCao.request().then(function (res) {
        if (res.data) {
          _this4.setState({ listLoaiBaoCao: res.data });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'DonViNhan') {
        this.setState({
          donViNhan: e
        });
      } else if (name == 'danhSachBaoCao') {
        this.setState({
          danhSachBaoCao: e
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this5 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getCauHinhBaoCao.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this5.setState({
            data: res.data._embedded.cauHinhBaoCaos,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this5.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this6 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        }) }, function () {
        _this6.getListData();
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this7 = this;

      if (this.validateSubmitForm()) {
        var params = {
          tenBaoCao: this.state.tenBaoCao
        };
        var dsBaoCao = [];
        this.state.danhSachBaoCao.forEach(function (item) {
          dsBaoCao = [].concat(_toConsumableArray(dsBaoCao), [item.value]);
        });
        params.danhSachBaoCao = dsBaoCao.join(';');
        params.ngayBatDauBC = (0, _moment2.default)(this.state.ngayBatDauBC).add(7, 'hours').toISOString();
        params.ngayKetThucBC = (0, _moment2.default)(this.state.ngayKetThucBC).add(7, 'hours').toISOString();
        params.hanBaoCao = this.state.hanBaoCao ? (0, _moment2.default)(this.state.hanBaoCao).add(7, 'hours').toISOString() : '';
        params.kyBaoCao = this.state.kyBaoCao || '';
        params.namBaoCao = this.state.namBaoCao || '';
        params.soNgayTuDongGui = this.state.soNgayTuDongGui || 0;
        params.donViGui = { id: this.state.donViGui };
        params.donViNhans = [];
        this.state.donViNhan.map(function (item) {
          params.donViNhans = [].concat(_toConsumableArray(params.donViNhans), [{ id: item.value }]);
        });
        if (this.state.kyBaoCao == 'THEO_QUY') {
          params.quyBaoCao = this.state.quyBaoCao;
        }
        if (this.state.kyBaoCao == 'THEO_THANG') {
          params.thangBaoCao = this.state.thangBaoCao;
        }

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.Danhmuc.actions.updateCauHinhBaoCao.request({ id: this.state.categoryId }, params).then(function (res) {
            _this7.getListData();
            _this7.closeDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this7.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this7.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postCauHinhBaoCao.request('', params).then(function (res) {
            _this7.getListData();
            _this7.closeDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this7.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this7.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this8 = this;

      this.setState({ pageData: _extends({}, this.state.pageData, {
          number: page.selected
        }) }, function () {
        _this8.getListData();
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this9 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteCauHinhBaoCao.request({ id: categoryId }).then(function (res) {
          _this9.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this9.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this9.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      //
    }
  }, {
    key: 'openView',
    value: function openView() {
      this.setState({ popupViewCategory: !this.state.popupViewCategory });
    }
  }, {
    key: 'closeView',
    value: function closeView() {
      this.setState({ popupViewCategory: !this.state.popupViewCategory });
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.openDialog();
      this.setState({
        addType: 0,
        tableLoading: false,
        buttonLoading: false,
        searchLoading: false,
        donViNhan: [],
        donViGui: this.state.idTTTP || null,
        danhSachBaoCao: [],
        tenBaoCao: '',
        ngayBatDauBC: '',
        ngayKetThucBC: '',
        hanBaoCao: '',
        soNgayTuDongGui: 0,
        namBaoCao: '',
        thangBaoCao: '',
        quyBaoCao: '',
        kyBaoCao: 'THEO_QUY',
        isValid: true
      });
    }
  }, {
    key: 'viewUpdateCategory',
    value: function viewUpdateCategory(item) {
      var _this10 = this;

      this.openView();
      var dvNhan = [];
      dvNhan = item.donViNhanInfo.map(function (item) {
        return ' ' + item.ten;
      });

      var arrDSBC = [];
      var dsBaoCao = item.danhSachBaoCao.split(';');
      dsBaoCao.forEach(function (itemBC) {
        var dsLoaiBaoCao = [];
        _this10.state.listLoaiBaoCao.forEach(function (itemLBC) {
          if (itemLBC.giaTri === itemBC) {
            dsLoaiBaoCao.push({ label: itemLBC.ten, value: itemLBC.giaTri });
          }
        });
        arrDSBC = arrDSBC.concat(dsLoaiBaoCao);
      });

      _api.DuLieuHeThong.actions.getLoaiKyThongKe.request().then(function (res) {
        if (res && res.data) {
          var check = res.data.findIndex(function (items) {
            return items.giaTri === item.kyBaoCao;
          });
          if (check !== -1) {
            _this10.setState({ kyBaoCao: res.data[check].ten });
          }
        }
      });

      this.setState({
        addType: 2,
        donViNhan: dvNhan,
        donViGui: item.donViGuiInfo ? item.donViGuiInfo.ten : null,
        danhSachBaoCao: arrDSBC,
        tenBaoCao: item.tenBaoCao,
        ngayBatDauBC: new Date(item.ngayBatDauBC),
        ngayKetThucBC: new Date(item.ngayKetThucBC),
        hanBaoCao: item.hanBaoCao ? new Date(item.hanBaoCao) : '',
        soNgayTuDongGui: item.soNgayTuDongGui || 0,
        namBaoCao: item.namBaoCao || '',
        thangBaoCao: item.thangBaoCao || '',
        quyBaoCao: item.quyBaoCao || '',
        kyBaoCao: item.kyBaoCao || 'THEO_QUY',
        categoryId: item.cauHinhBaoCaoId,
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      var _this11 = this;

      this.openDialog();
      var dvNhan = [];
      item.donViNhanInfo.map(function (item) {
        dvNhan = [].concat(_toConsumableArray(dvNhan), [{ label: item.ten, value: item.id }]);
      });
      var arrDSBC = [];
      item.danhSachBaoCao.split(';').forEach(function (item) {
        var findItem = _this11.state.listLoaiBaoCao.filter(function (item1) {
          return item1.giaTri == item;
        }).map(function (item1) {
          return item1 = { label: item1.ten, value: item1.giaTri };
        });
        if (findItem.length > 0) {
          arrDSBC = [].concat(_toConsumableArray(arrDSBC), _toConsumableArray(findItem));
        }
      });

      this.setState({
        addType: 2,
        donViNhan: dvNhan,
        donViGui: item.donViGuiInfo ? item.donViGuiInfo.id : null,
        danhSachBaoCao: arrDSBC,
        tenBaoCao: item.tenBaoCao,
        ngayBatDauBC: new Date(item.ngayBatDauBC),
        ngayKetThucBC: new Date(item.ngayKetThucBC),
        hanBaoCao: item.hanBaoCao ? new Date(item.hanBaoCao) : '',
        soNgayTuDongGui: item.soNgayTuDongGui || 0,
        namBaoCao: item.namBaoCao || '',
        thangBaoCao: item.thangBaoCao || '',
        quyBaoCao: item.quyBaoCao || '',
        kyBaoCao: item.kyBaoCao || 'THEO_QUY',
        categoryId: item.cauHinhBaoCaoId,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var danhSachBC = [];
      if (this.state.danhSachBaoCao) {
        danhSachBC = this.state.danhSachBaoCao.map(function (item) {
          return ' ' + item.label;
        });
      }
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'C\u1EA5u h\xECnh b\xE1o c\xE1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('CAUHINHBAOCAO_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.cauHinhBaoCao,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemTuDongBaoCao, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupViewCategory,
              onClose: this.closeView.bind(this),
              title: 'Th\xF4ng tin c\u1EA5u h\xECnh b\xE1o c\xE1o',
              iconName: 'add-new',
              className: 'panel-popup wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Text, { className: 'col-100', label: 'T\xEAn b\xE1o c\xE1o', value: this.state.tenBaoCao }),
              _react2.default.createElement(_common.Text, { className: 'col-100', label: 'Danh s\xE1ch bi\u1EC3u m\u1EABu', value: danhSachBC }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'K\u1EF3 b\xE1o c\xE1o', value: this.state.kyBaoCao }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'N\u0103m b\xE1o c\xE1o', value: this.state.namBaoCao }),
              this.state.kyBaoCao == 'THEO_QUY' && _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Qu\xFD b\xE1o c\xE1o', value: this.state.quyBaoCao }),
              this.state.kyBaoCao == 'THEO_THANG' && _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Th\xE1ng b\xE1o c\xE1o', value: this.state.thangBaoCao }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u b\xE1o c\xE1o', value: (0, _moment2.default)(this.state.ngayBatDauBC).format('DD/MM/YYYY') }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y k\u1EBFt th\xFAc b\xE1o c\xE1o', value: (0, _moment2.default)(this.state.ngayKetThucBC).format('DD/MM/YYYY') }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'H\u1EA1n b\xE1o c\xE1o', value: (0, _moment2.default)(this.state.hanBaoCao).format('DD/MM/YYYY') }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'S\u1ED1 ng\xE0y t\u1EF1 \u0111\u1ED9ng g\u1EEDi', value: this.state.soNgayTuDongGui }),
              _react2.default.createElement(_common.Text, { className: 'col-100', label: '\u0110\u01A1n v\u1ECB g\u1EEDi', value: this.state.donViGui }),
              _react2.default.createElement(_common.Text, { className: 'col-100', label: '\u0110\u01A1n v\u1ECB nh\u1EADn', value: this.state.donViNhan })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer mb18' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeView.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.closeDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa cấu hình báo cáo' : 'Thêm mới cấu hình báo cáo',
              iconName: 'add-new',
              className: 'panel-popup wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: 'col-100', label: 'T\xEAn b\xE1o c\xE1o', value: this.state.tenBaoCao, bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 255, onChange: this.onChange.bind(this, 'tenBaoCao') }),
              _react2.default.createElement(_common.DropDownTreeMultipleSelect, { disable: true, className: 'col-100', label: 'Danh s\xE1ch bi\u1EC3u m\u1EABu', bindValidator: this, channel: 'formTaoDon', require: true, dataOptions: this.state.listLoaiBaoCao, dataSelected: this.state.danhSachBaoCao, onChange: this.onChange.bind(this, 'danhSachBaoCao'), propertyParent: 'giaTri' }),
              _react2.default.createElement(_ttForms.DropDownChonLoaiKyThongKe, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, placeholder: null, onChange: this.onChange.bind(this, 'kyBaoCao'), selectedValue: this.state.kyBaoCao }),
              _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, onChange: this.onChange.bind(this, 'namBaoCao'), selectedValue: this.state.namBaoCao }),
              this.state.kyBaoCao == 'THEO_QUY' && _react2.default.createElement(_ttForms.DropDownChonLoaiQuyThongKe, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, onChange: this.onChange.bind(this, 'quyBaoCao'), selectedValue: this.state.quyBaoCao }),
              this.state.kyBaoCao == 'THEO_THANG' && _react2.default.createElement(_ttForms.DropDownChonLoaiThangThongKe, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, onChange: this.onChange.bind(this, 'thangBaoCao'), selectedValue: this.state.thangBaoCao }),
              _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u b\xE1o c\xE1o', endDate: this.state.ngayKetThucBC, bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBatDauBC, onChange: this.handleChangeDate.bind(this, 'ngayBatDauBC'), name: 'ngayBatDauBC', min: true }),
              _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y k\u1EBFt th\xFAc b\xE1o c\xE1o', bindValidator: this, channel: 'formTaoDon', startDate: this.state.ngayBatDauBC, endDate: this.state.hanBaoCao, require: true, value: this.state.ngayKetThucBC, onChange: this.handleChangeDate.bind(this, 'ngayKetThucBC'), name: 'ngayKetThucBC' }),
              _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'H\u1EA1n b\xE1o c\xE1o', startDate: this.state.ngayKetThucBC, bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.hanBaoCao, onChange: this.handleChangeDate.bind(this, 'hanBaoCao'), name: 'hanBaoCao' }),
              _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 ng\xE0y t\u1EF1 \u0111\u1ED9ng g\u1EEDi', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soNgayTuDongGui, maxLength: 255, onChange: this.onChange.bind(this, 'soNgayTuDongGui') }),
              _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: '\u0110\u01A1n v\u1ECB g\u1EEDi', className: 'col-100', bindValidator: this, channel: 'formTaoDon', require: true, dataOptions: this.state.listDonVi, value: this.state.donViGui, onChange: this.onChange.bind(this, 'donViGui'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
              _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'col-100', label: '\u0110\u01A1n v\u1ECB nh\u1EADn', bindValidator: this, channel: 'formTaoDon', require: true, dataOptions: this.state.listDonVi, dataSelected: this.state.donViNhan, onChange: this.onChange.bind(this, 'DonViNhan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer mb18' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TuDongBaoCao;
}(_react2.default.Component);

TuDongBaoCao.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = TuDongBaoCao;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _layout = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _redux = __webpack_require__(63);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeOfOrganizationLevel = function (_React$Component) {
  _inherits(TypeOfOrganizationLevel, _React$Component);

  function TypeOfOrganizationLevel(props, context) {
    _classCallCheck(this, TypeOfOrganizationLevel);

    var _this = _possibleConstructorReturn(this, (TypeOfOrganizationLevel.__proto__ || Object.getPrototypeOf(TypeOfOrganizationLevel)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      isValid: true,
      moTa: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false
    };
    return _this;
  }

  _createClass(TypeOfOrganizationLevel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.ten = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getLoaiCapCoQuan.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.loaiCoQuanQuanLies,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim()
        };
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          this.props.danhMuc.updateLoaiCapCoQuan({ id: this.state.categoryId }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          this.props.danhMuc.postLoaiCapCoQuan('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this4 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        this.props.danhMuc.deleteLoaiCapCoQuan({ id: categoryId }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        ten: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        ten: item.ten,
        moTa: item.moTa,
        categoryId: item.loaiCoQuanQuanLyId,
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'h2',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Lo\u1EA1i c\u01A1 quan qu\u1EA3n l\xFD'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('LOAICOQUANQUANLY_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.typeoforganizationlevel,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemTypeOfOrganizationLevel, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa loại cơ quan quản lý' : 'Thêm mới loại cơ quan quản lý',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'), bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { label: 'M\xF4 t\u1EA3', rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), maxLength: 255, className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TypeOfOrganizationLevel;
}(_react2.default.Component);

TypeOfOrganizationLevel.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: (0, _redux.bindActionCreators)(_api.Danhmuc.actions, dispatch)
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps, bindDispatchToProps)(TypeOfOrganizationLevel);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(42);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _Search = __webpack_require__(64);

var _Search2 = _interopRequireDefault(_Search);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video(props, context) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      isValid: true,
      videoId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,

      danhMucVideoList: [],
      danhMucVideo: '',
      loaiVideoList: [],
      loaiVideo: '',
      progressAvatar: 0,
      progressVideo: 0,
      ten: '',
      tenFileAvatar: '',
      tenFileVideo: '',
      urlFileAvatar: '',
      urlFileVideo: '',
      videoAvatarInvalid: false,
      videoFileInvalid: false
    };
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getDanhMucVideo();
      this.getLoaiVideo();
    }
  }, {
    key: 'getLoaiVideo',
    value: function getLoaiVideo() {
      var _this2 = this;

      var params = {
        page: 0,
        size: 999
      };
      _api.Danhmuc.actions.getLoaiVideo.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({ loaiVideoList: res.data });
        } else {
          _this2.setState({ loaiVideoList: [] });
        }
      });
    }
  }, {
    key: 'getDanhMucVideo',
    value: function getDanhMucVideo() {
      var _this3 = this;

      var params = {
        page: 0,
        size: 999
      };
      _api.Danhmuc.actions.getDanhMucVideo.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ danhMucVideoList: res.data._embedded.danhMucVideos });
        } else {
          _this3.setState({ danhMucVideoList: [] });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa.trim();
      }
      _api.Danhmuc.actions.getVideo.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            data: res.data._embedded.videos,
            pageData: res.data.page,
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this4.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this5 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.ten.trim(),
          danhMucVideo: { id: this.state.danhMucVideo },
          loaiVideo: this.state.loaiVideo
        };
        if (this.state.tenFileAvatar) {
          params.tenFileAvatar = this.state.tenFileAvatar;
          params.urlFileAvatar = this.state.urlFileAvatar;
        }
        if (this.state.tenFileVideo) {
          params.tenFileVideo = this.state.tenFileVideo;
          params.urlFileVideo = this.state.urlFileVideo;
        }

        this.setState({ buttonLoading: true });
        if (this.state.videoId) {
          _api.Danhmuc.actions.updateVideo.request({ id: this.state.videoId }, params).then(function (res) {
            _this5.getListData();
            _this5.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.Danhmuc.actions.postVideo.request('', params).then(function (res) {
            _this5.getListData();
            _this5.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this5.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this5.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(categoryId) {
      var _this6 = this;

      if (categoryId) {
        this.setState({ buttonLoading: true });
        _api.Danhmuc.actions.deleteVideo.request({ id: categoryId }).then(function (res) {
          _this6.getListData();
          (0, _toastr.Toastr)(_message.msg.delVideoSuccess, 'success');
          _this6.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this6.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      if (!this.state.tenFileVideo) {
        pass = false;
        this.setState({ videoFileInvalid: true });
      }
      if (!this.state.tenFileAvatar) {
        pass = false;
        this.setState({ videoAvatarInvalid: true });
      }
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        isValid: true,
        videoId: '',
        ten: '',
        danhMucVideo: '',
        loaiVideo: '',
        progressAvatar: 0,
        progressVideo: 0,
        tenFileAvatar: '',
        tenFileVideo: '',
        urlFileAvatar: '',
        urlFileVideo: '',
        videoFileInvalid: false,
        videoAvatarInvalid: false
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        videoId: item.videoId,
        ten: item.ten,
        danhMucVideo: item.danhMucVideoInfo ? item.danhMucVideoInfo.danhMucVideoId : '',
        loaiVideo: item.loaiVideo,
        progressAvatar: 0,
        progressVideo: 0,
        tenFileAvatar: item.tenFileAvatar,
        tenFileVideo: item.tenFileVideo,
        urlFileAvatar: item.urlFileAvatar,
        urlFileVideo: item.urlFileVideo,
        isValid: true,
        videoFileInvalid: false,
        videoAvatarInvalid: false
      });
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(type, e) {
      var _this7 = this;

      if (e.target.files[0]) {
        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        if (type == 'video' && _config.LimitVideoType.indexOf(ext) == -1 || type == 'avatar' && _config.LimitPhotoType.indexOf(ext) == -1) {
          if (type == 'avatar') (0, _toastr.Toastr)(_message.msg.filePhotoErr, 'warning');else (0, _toastr.Toastr)(_message.msg.fileVideoTypeErr, 'warning');
        } else if (type == 'avatar' && fileSize > _config.LimitFileSize * 1024 * 1024 || type == 'video' && fileSize > _config.LimitVideoFileSize * 1024 * 1024) {
          if (type == 'avatar') (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');else (0, _toastr.Toastr)(_message.msg.fileVideoSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);
            if (type == 'video') {
              _this7.setState({ progressVideo: progressBar });
            } else {
              _this7.setState({ progressAvatar: progressBar });
            }
          };

          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var checkURL = '';
            if (res && res.data && !_config.checkServerLive) {
              checkURL = res.data;
            } else if (res && res.data && _config.checkServerLive) {
              checkURL = res.data.id;
            }
            if (type == 'video') {
              _this7.setState({
                progressVideo: 0,
                tenFileVideo: fileName,
                urlFileVideo: checkURL
              });
            } else {
              _this7.setState({
                progressAvatar: 0,
                tenFileAvatar: fileName,
                urlFileAvatar: checkURL
              });
            }
          });
        }
      }
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(type) {
      if (type == 'video') {
        this.setState({ tenFileVideo: '', urlFileVideo: '' });
      } else {
        this.setState({ tenFileAvatar: '', urlFileAvatar: '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Video'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('DANHMUCVIDEO_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_Search2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.categoryGroup.video,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemVideo, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa video' : 'Thêm mới video',
              iconName: 'add-new',
              className: 'panel-popup category' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'Danh m\u1EE5c:', options: this.state.danhMucVideoList, keyName: 'danhMucVideoId', valueName: 'ten', placeholder: true, selectedValue: this.state.danhMucVideo,
                onChange: this.onChange.bind(this, 'danhMucVideo'), bindValidator: this, require: true, channel: 'danhMuc' }),
              _react2.default.createElement(_common.DropDown, { className: 'col-6', label: 'Lo\u1EA1i video:', options: this.state.loaiVideoList, keyName: 'giaTri', valueName: 'ten', placeholder: true, selectedValue: this.state.loaiVideo,
                onChange: this.onChange.bind(this, 'loaiVideo'), bindValidator: this, require: true, channel: 'danhMuc' }),
              _react2.default.createElement(_common.Input, { className: 'col-100', label: 'T\xEAn', value: this.state.ten, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'ten'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(
                'div',
                { className: 'col-100 mb18' },
                _react2.default.createElement(
                  'label',
                  { className: 'ip-label' },
                  'H\xECnh \u0111\u1EA1i di\u1EC7n c\u1EE7a video:',
                  _react2.default.createElement(
                    'span',
                    { className: 'text-required' },
                    '\xA0*'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tenFileAvatar == '' && this.state.progressAvatar == 0 },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-link-todo link-attach col-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'upload_file_content' },
                      _react2.default.createElement('input', { type: 'file', className: 'upload', onChange: this.uploadFile.bind(this, 'avatar') }),
                      _react2.default.createElement(
                        'span',
                        { htmlFor: 'file' },
                        'T\u1EA3i l\xEAn t\u1EADp tin'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tenFileAvatar != '' },
                  _react2.default.createElement(
                    'div',
                    { className: 'link-attach' },
                    this.state.tenFileAvatar,
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'itt-delete ml5', onClick: this.handleRemove.bind(this, 'avatar') },
                      'X\xF3a'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.progressAvatar > 0 },
                  _react2.default.createElement(
                    'div',
                    { className: 'pt-progress-bar progress-upload pt-intent-primary' },
                    _react2.default.createElement('div', { className: 'pt-progress-meter', style: { width: this.state.progressAvatar + '%' } })
                  )
                )
              ),
              this.state.videoAvatarInvalid && this.state.tenFileAvatar == '' && _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text ml5 mb18' },
                'B\u1EA1n kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng tr\u01B0\u1EDDng n\xE0y.'
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 mb18' },
                _react2.default.createElement(
                  'label',
                  { className: 'ip-label' },
                  'T\u1EC7p Video:',
                  _react2.default.createElement(
                    'span',
                    { className: 'text-required' },
                    '\xA0*'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tenFileVideo == '' && this.state.progressVideo == 0 },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-link-todo link-attach col-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'upload_file_content' },
                      _react2.default.createElement('input', { type: 'file', className: 'upload', onChange: this.uploadFile.bind(this, 'video') }),
                      _react2.default.createElement(
                        'span',
                        { htmlFor: 'file' },
                        'T\u1EA3i l\xEAn t\u1EADp tin'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tenFileVideo != '' },
                  _react2.default.createElement(
                    'div',
                    { className: 'link-attach' },
                    this.state.tenFileVideo,
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'itt-delete ml5', onClick: this.handleRemove.bind(this, 'video') },
                      'X\xF3a'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.progressVideo > 0 },
                  _react2.default.createElement(
                    'div',
                    { className: 'pt-progress-bar progress-upload pt-intent-primary' },
                    _react2.default.createElement('div', { className: 'pt-progress-meter', style: { width: this.state.progressVideo + '%' } })
                  )
                )
              ),
              this.state.videoFileInvalid && this.state.tenFileVideo == '' && _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text ml5 mb18' },
                'B\u1EA1n kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng tr\u01B0\u1EDDng n\xE0y.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.videoId ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Video;
}(_react2.default.Component);

Video.defaultProps = {
  validators: {}
};

exports.default = Video;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _reactRouter = __webpack_require__(2);

var _reactPaginate = __webpack_require__(413);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _common = __webpack_require__(3);

var _downloadFile = __webpack_require__(112);

var _lodash = __webpack_require__(14);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTableDoiTuongThanhTra = function (_React$Component) {
  _inherits(DataTableDoiTuongThanhTra, _React$Component);

  function DataTableDoiTuongThanhTra(props, context) {
    _classCallCheck(this, DataTableDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (DataTableDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(DataTableDoiTuongThanhTra)).call(this, props, context));

    _this.state = {
      export: 'btn-green tt-export',
      approved: 'btn-green tt-approve-double-check',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      divHeight: 195,
      down: false,
      scrollLeft: '',
      x: ''
    };

    return _this;
  }

  _createClass(DataTableDoiTuongThanhTra, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      if (this.props.parent && this.props.parent.handleChangePageSize) {
        this.props.parent.handleChangePageSize.bind(this.props.parent, size);
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      if (this.props.parent && this.props.parent.handlePageC1lick) {
        this.props.parent.handlePageClick.bind(this.props.parent, page);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hideExport) {
        this.setState({
          export: 'btn-green tt-export disable'
        });
      }

      var divHeight = 0;
      var obj = document.getElementsByClassName('table-header')[0];

      if (obj && obj.offsetHeight) {
        divHeight = obj.offsetHeight;
      } else if (obj && obj.style.pixelHeight) {
        divHeight = obj.style.pixelHeight;
      }
      this.setState({
        divHeight: divHeight + 2
      });
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {

      if (this.props.typeExport == 'TIEP_CONG_DAN') {

        if (this.props.parent.state.advanceSearch == true) {
          var startDate = this.props.parent.state.startDate ? (0, _moment2.default)(this.props.parent.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';
          var endDate = this.props.parent.state.endDate ? (0, _moment2.default)(this.props.parent.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';

          var URL = String(_config.API_URL) + "/soTiepCongDans/excel?tuNgay=" + startDate + "&denNgay=" + endDate + "&loaiTiepCongDan=" + this.props.type + "&huongXuLy=" + (this.props.parent.state.handleRedirect ? this.props.parent.state.handleRedirect : '') + "&phanLoaiDon=" + this.props.parent.state.receptionType + "&coQuanQuanLyId=" + this.state.userInfo.donViId + "&lanhDaoId=" + (this.props.parent.state.lanhDaoTiepDan ? this.props.parent.state.lanhDaoTiepDan : '') + "&ketQuaTiepDan=" + (this.props.parent.state.ketQuaTiepDan ? this.props.parent.state.ketQuaTiepDan : '') + "&tinhTrangXuLy=" + (this.props.parent.state.tinhTrangXuLy ? this.props.parent.state.tinhTrangXuLy : '') + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + '&tuKhoa=' + this.props.parent.state.searchKey + '' + '&sort=' + this.props.sortBy;
          window.open(URL, "_self");
        } else {
          var _URL = String(_config.API_URL) + "/soTiepCongDans/excel?loaiTiepCongDan=" + this.props.type + "&coQuanQuanLyId=" + this.state.userInfo.donViId + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + '&sort=' + this.props.sortBy + '&tuKhoa=' + this.props.parent.state.searchKey;
          window.open(_URL, "_self");
        }
      } else if (this.props.typeExport == 'XU_LY_DON') {

        var _URL2 = String(_config.API_URL) + "/dons/xuatExcel?donViXuLyXLD=" + this.state.userInfo.donViId + "&phongBanXuLyXLD=" + this.state.userInfo.coQuanQuanLyId + "&vaiTro=" + this.state.userInfo.loaiVaiTroMacDinh + "&canBoXuLyXLD=" + this.state.userInfo.id + "&page=" + this.props.pageData.number + "&size=" + this.props.pageData.size + "&thanhLapDon=true" + "&trangThaiDon=" + this.props.parent.state.trangThaiXuLyDon;

        if (this.props.sortBy) {
          _URL2 = _URL2 + "&sort=" + this.props.sortBy;
        }

        if (this.props.parent.state.advanceSearch) {

          if (this.props.searchData) {

            if (this.props.searchData.searchKey) {
              _URL2 = _URL2 + "&tuKhoa=" + this.props.searchData.searchKey;
            }

            if (this.props.searchData.startDate) {
              var _startDate = (0, _moment2.default)(this.props.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              _URL2 = _URL2 + "&tiepNhanTuNgay=" + _startDate;
            }

            if (this.props.searchData.endDate) {
              var _endDate = (0, _moment2.default)(this.props.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              _URL2 = _URL2 + "&tiepNhanDenNgay=" + _endDate;
            }

            if (this.props.searchData.maDon) {
              _URL2 = _URL2 + "&maDon=" + this.props.searchData.maDon;
            }

            if (this.props.searchData.nguonDon) {
              _URL2 = _URL2 + "&nguonDon=" + this.props.searchData.nguonDon;
            }

            if (this.props.searchData.phanLoaiDon) {
              _URL2 = _URL2 + "&phanLoaiDon=" + this.props.searchData.phanLoaiDon;
            }

            if (this.props.searchData.tinhTrangXuLy) {
              _URL2 = _URL2 + "&trangThaiDonToanHT=" + this.props.searchData.tinhTrangXuLy;
            }

            if (this.props.searchData.ketQuaXuLy) {
              _URL2 = _URL2 + "&ketQuaToanHT=" + this.props.searchData.ketQuaXuLy;
            }
          }
        } else {
          if (this.props.searchData && this.props.searchData.searchKey) {
            _URL2 = _URL2 + "&tuKhoa=" + this.props.searchData.searchKey;
          }
        }

        window.open(_URL2, "_self");
      } else if (this.props.typeExport == 'DS_YEU_CAU') {

        var _URL3 = String(_config.API_URL) + "/soTiepCongDans/danhSachYeuCauGapLanhDao/excel?donViId=" + this.state.userInfo.donViId;
        if (this.props.parent.state.tuKhoa) {
          _URL3 = _URL3 + "&tuKhoa=" + this.props.parent.state.tuKhoa;
        }
        if (this.props.sortBy) {
          _URL3 = _URL3 + "&sort=" + this.props.sortBy;
        }
        if (this.props.parent.state.advanceSearch) {

          if (this.props.parent.state.tuNgay) {
            var _startDate2 = (0, _moment2.default)(this.props.parent.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            _URL3 = _URL3 + "&tuNgay=" + _startDate2;
          }

          if (this.props.parent.state.denNgay) {
            var _endDate2 = (0, _moment2.default)(this.props.parent.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            _URL3 = _URL3 + "&denNgay=" + _endDate2;
          }

          if (this.props.parent.state.phanLoai) {
            _URL3 = _URL3 + "&phanLoai=" + this.props.parent.state.phanLoai;
          }

          if (this.props.parent.state.nguonDon) {
            _URL3 = _URL3 + "&nguonDon=" + this.props.parent.state.nguonDon;
          }

          if (this.props.parent.state.trangThai) {
            _URL3 = _URL3 + "&trangThai=" + this.props.parent.state.trangThai;
          }
        }

        (0, _downloadFile.downloadFile)(_URL3);
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      this.props.handleExport();
    }
  }, {
    key: 'handleExportExampleKiemTra',
    value: function handleExportExampleKiemTra() {
      this.props.handleExportExampleKiemTra();
    }
  }, {
    key: 'handleImportEmxampleKiemTra',
    value: function handleImportEmxampleKiemTra(e) {
      var _this2 = this;

      var params = {
        field: 'file', file: e.target.files[0]
      };
      _api.Reception.actions.postFileUploadExcelData.request('', params).then(function (res) {
        _this2.props.handleImportEmxampleKiemTra(res);
      }).catch(function (error) {
        (0, _toastr.Toastr)((0, _lodash.get)(error, 'response.data.errors[0].detail'), 'error');
      });
    }
  }, {
    key: 'getItemTongSoThongKe',
    value: function getItemTongSoThongKe() {
      var pageNumber = (0, _lodash.get)(this.props.pageData, 'number') || 0;
      var pageSize = (0, _lodash.get)(this.props.pageData, 'size') || 0;
      var dataSum = {};
      if (this.props.dataSum) {
        dataSum = _extends({}, this.props.dataSum);
      }
      dataSum.donVi = {
        id: 'TONG_CONG',
        ten: 'Tổng cộng'
      };
      dataSum.ghiChu = '';
      return _react2.default.cloneElement(this.props.children, {
        count: pageNumber * pageSize + this.props.dataList.length + 1,
        item: dataSum,
        sum: true
      });
    }
  }, {
    key: 'getItemTongDonTrung',
    value: function getItemTongDonTrung() {
      var pageNumber = (0, _lodash.get)(this.props.pageData, 'number') || 0;
      var pageSize = (0, _lodash.get)(this.props.pageData, 'size') || 0;
      var dataDonTrung = {};
      if (this.props.dataDonTrung) {
        dataDonTrung = _extends({}, this.props.dataDonTrung);
      }
      dataDonTrung.donVi = {
        id: 'TONG_TRUNG',
        ten: 'Tổng Trùng'
      };
      dataDonTrung.ghiChu = '';
      return _react2.default.cloneElement(this.props.children, {
        count: pageNumber * pageSize + this.props.dataList.length + 1,
        item: dataDonTrung,
        sum: true
      });
    }
  }, {
    key: 'getItemNull',
    value: function getItemNull() {
      return this.props.children;
    }
  }, {
    key: 'handleDown',
    value: function handleDown(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        document.getElementById('scrollItem').classList.add("scrolling");
        this.state.down = true;
        this.state.scrollLeft = Item.scrollLeft;
        this.state.x = e.clientX;
      }
    }
  }, {
    key: 'handleUp',
    value: function handleUp() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'handleMove',
    value: function handleMove(e) {
      if (this.props.touchMove) {
        var Item = document.getElementById('scrollItem');
        if (this.state.down == true) {
          Item.scrollLeft = this.state.scrollLeft + this.state.x - e.clientX;
        }
      }
    }
  }, {
    key: 'handleLeave',
    value: function handleLeave() {
      if (this.props.touchMove) {
        document.getElementById('scrollItem').classList.remove("scrolling");
        this.state.down = false;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(index, e) {
      this.props.onChangeHeader(index, e);
    }
  }, {
    key: 'addNewItem',
    value: function addNewItem() {
      this.props.addNewItem();
    }
  }, {
    key: 'addNewVanBanCanCu',
    value: function addNewVanBanCanCu() {
      this.props.addNewVanBanCanCu();
    }
  }, {
    key: 'handleApprove',
    value: function handleApprove() {
      var _this3 = this;

      _api.ThanhTra.actions.approveDoiTuongThanhTra.request('', { ids: this.props.doiTuongSelecteds }).then(function (res) {
        _this3.props.getListData();
        (0, _toastr.Toastr)('Duyệt đối tượng thanh tra thành công', 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;
      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this4.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item,
          parent: _this4.props.parent
        });
      });

      var childrenNull = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, { nullElement: true });
      });

      var ItemLoading = _react2.default.createElement(
        'div',
        { className: 'loading-content' },
        _react2.default.createElement('span', { className: 'shape1' }),
        _react2.default.createElement('span', { className: 'shape2' }),
        _react2.default.createElement('span', { className: 'shape3' }),
        _react2.default.createElement('span', { className: 'shape4' }),
        _react2.default.createElement('span', { className: 'shape5' }),
        _react2.default.createElement('span', { className: 'shape6' }),
        _react2.default.createElement('span', { className: 'shape7' }),
        _react2.default.createElement('span', { className: 'shape8' }),
        _react2.default.createElement('span', { className: 'shape9' }),
        _react2.default.createElement('span', { className: 'shape10' }),
        _react2.default.createElement('span', { className: 'shape11' }),
        _react2.default.createElement('span', { className: 'shape12' }),
        _react2.default.createElement('span', { className: 'shape13' })
      );
      return _react2.default.createElement(
        'div',
        { className: this.props.ThongKeBaoCao ? 'wrapper-table wrapper-tkbc' : 'wrapper-table' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.ThongKeBaoCao },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.LapBaoCao == false },
            _react2.default.createElement(
              'div',
              { className: 'header-table-wrap', style: { height: this.state.divHeight } },
              _react2.default.createElement(
                'div',
                { className: 'header-stt' },
                'STT'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-name' },
                '\u0110\u01A0N V\u1ECA'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-ms' },
                'MS'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.tableLoading },
                _react2.default.createElement(
                  'div',
                  { className: 'value-column-fixed-wrap' },
                  this.props.dataList.map(function (item, i) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap', key: i },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-ghichu' },
                        item.ghiChu ? item.ghiChu : ''
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-stt' },
                        i + 1
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-name' },
                        item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
                      )
                    );
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.dataList.length > 1 },
                    this.props.showTongDonTrung && _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng \u0111\u01A1n tr\xF9ng'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng c\u1ED9ng'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.LapBaoCao == true },
            _react2.default.createElement(
              'div',
              { className: 'header-table-wrap', style: { height: this.state.divHeight } },
              _react2.default.createElement(
                'div',
                { className: 'header-stt' },
                'STT'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-name' },
                '\u0110\u01A0N V\u1ECA'
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-ms' },
                'MS'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.tableLoading },
                _react2.default.createElement(
                  'div',
                  { className: 'value-column-fixed-wrap' },
                  this.props.dataList.map(function (item, i) {
                    if (item.donVi && item.donVi.id) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'fixed-column-wrap', key: i },
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-ghichu tt-ghichu-has-bb' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', defaultvalue: item.ghiChu ? item.ghiChu : '' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-stt txt-bold ' + (item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red') },
                          i + 1
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-name txt-bold ' + (item && item.laySoLieu == false && item.trangThaiBaoCao != 'DANG_SOAN' && item.trangThaiBaoCao != 'DA_GUI' ? '' : 'val-content-red') },
                          item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : ''
                        )
                      );
                    } else {
                      return _react2.default.createElement(
                        'div',
                        { className: 'fixed-column-wrap', key: i },
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-ghichu tt-ghichu-has-bb' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', defaultvalue: item.ghiChu ? item.ghiChu : '' })
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-stt' },
                          i + 1
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tr-name' },
                          _react2.default.createElement(_common.Input, { className: 'col-100 no-gutter mb0-18', triggeOnBlur: true, value: item.donVi ? item.donVi.ten : item.capDonVi ? item.capDonVi.ten : '', onChange: _this4.onChange.bind(_this4, i) })
                        )
                      );
                    }
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.addNew == true },
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name txt-blue pointer', onClick: this.addNewItem.bind(this) },
                        _react2.default.createElement('i', { className: 'tt tt-addfile tt-custom' }),
                        'Th\xEAm m\u1EDBi \u0111\u01A1n v\u1ECB'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.dataList.length > 1 },
                    this.props.showTongDonTrung && _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng \u0111\u01A1n tr\xF9ng'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'fixed-column-wrap sum' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tr-sum-name' },
                        'T\u1ED5ng c\u1ED9ng'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        this.props.displayCount ? _react2.default.createElement(
          'div',
          { className: 'tc-total' },
          'C\xF3 ',
          _react2.default.createElement(
            'span',
            null,
            this.props.pageData.totalElements
          ),
          ' k\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm ph\xF9 h\u1EE3p v\u1EDBi y\xEAu c\u1EA7u'
        ) : '',
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('table-container', {
              'touch-move': this.props.touchMove,
              'checktracuu': this.props.checkTraCuu,
              'checktdgs': this.props.checkTDGS
            }),
            id: 'scrollItem',
            onMouseUp: this.handleUp.bind(this),
            onMouseDown: this.handleDown.bind(this),
            onMouseMove: this.handleMove.bind(this),
            onMouseLeave: this.handleLeave.bind(this)
          },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.props.ThongKeBaoCao },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.showCheckbox && this.props.isTTTP },
                    _react2.default.createElement(
                      'th',
                      { className: 'table-header-col table-checkbox', style: { width: 40 } },
                      _react2.default.createElement(
                        'label',
                        { className: 'pt-control pt-checkbox pt-large' },
                        _react2.default.createElement('input', { type: 'checkbox', className: 'pt-large', name: '', onChange: this.props.onCheck.bind(this), checked: this.props.selectAllStatus, disabled: this.props.isDisabledCheckAll }),
                        _react2.default.createElement('span', { className: 'pt-control-indicator' })
                      )
                    )
                  ),
                  this.props.header.map(function (item, i) {
                    return _react2.default.createElement(
                      'th',
                      { key: i, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                      item.name
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.ThongKeBaoCao },
              _react2.default.createElement(
                'thead',
                { className: 'table-header' },
                this.props.header.map(function (headerItems, i) {
                  var items = [];
                  items = [].concat(_toConsumableArray(headerItems));
                  return _react2.default.createElement(
                    'tr',
                    { key: i },
                    items.map(function (item, j) {
                      return _react2.default.createElement(
                        'th',
                        { key: j, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, rowSpan: item.rowSpan, style: { maxWidth: item.maxWidth, width: item.width, minWidth: item.minWidth } },
                        item.name
                      );
                    }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: _this4.props.lapBaoCaoTongHop == true && i == 0 },
                      _react2.default.createElement(
                        'th',
                        { className: 'table-header-col middle-content', colSpan: 1, rowSpan: _this4.props.header.length, style: { width: 120, minWidth: 120 } },
                        'THAO T\xC1C'
                      )
                    )
                  );
                }),
                _react2.default.createElement(
                  'tr',
                  null,
                  Array.from(Array(this.props.numberColumnHeader).keys()).map(function (item, i) {
                    return _react2.default.createElement(
                      'th',
                      { className: 'txt-center', key: i },
                      item - 1
                    );
                  })
                )
              )
            ),
            this.props.tableLoading ? _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              _react2.default.createElement(
                'tr',
                { className: 'table-loading' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !this.props.ThongKeBaoCao },
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length },
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading,
                    ItemLoading
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.ThongKeBaoCao },
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    ItemLoading,
                    ItemLoading,
                    ItemLoading
                  )
                )
              )
            ) : _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              dataListItem,
              this.props.ThongKeBaoCao == true && this.props.LapBaoCao == true && this.props.addNew == true ? childrenNull : null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.ThongKeBaoCao && this.props.dataList.length > 1 && this.props.showTongDonTrung },
                this.getItemTongDonTrung()
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.ThongKeBaoCao && this.props.dataList.length > 1 },
                this.getItemTongSoThongKe()
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + this.props.plusColum },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + this.props.plusColum },
                    this.props.emptyMsg
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == true && this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataList.length == 0 && !this.props.showAddMore && this.props.search == false && this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.showAddMore == true },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { className: 'multipe-column', colSpan: this.props.header.length },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-addfile itt-Them-Moi', onClick: this.props.addMore },
                      this.props.titleAddmore
                    )
                  )
                )
              ),
              this.props.thongKeDonCu && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: 2, className: 'txt-left' },
                  _react2.default.createElement(
                    'span',
                    { className: 'title-12' },
                    'T\u1ED5ng \u0111\u01A1n'
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDonDonGian
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDonPhucTap
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'black-val' },
                  this.props.tongSoDon
                )
              ),
              this.props.isTableCanCuCuocThanhTra && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'multipe-column', colSpan: this.props.header.length },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-addfile itt-Them-Moi', onClick: this.addNewVanBanCanCu.bind(this) },
                    'Th\xEAm m\u1EDBi v\u0103n b\u1EA3n'
                  )
                )
              )
            )
          ),
          !this.props.hidePagination && this.props.dataList.length > 0 && !this.props.ThongKeBaoCao ? _react2.default.createElement(
            'div',
            { className: 'pagination-wrap' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !(0, _lodash.isEmpty)(this.props.doiTuongSelecteds) && this.props.isTTTP },
              _react2.default.createElement(_core.Button, { className: this.state.approved, text: 'Duy\u1EC7t \u0111\u1ED1i t\u01B0\u1EE3ng', onClick: this.handleApprove.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thanhTra || !this.props.hideButtonExport },
              _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
            ),
            !this.props.hideButtonExport ? _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExportExcel.bind(this) }) : _react2.default.createElement('div', null),
            this.props.pageData && this.props.pageData.totalElements && this.props.pageData.totalElements > this.props.pageData.size ? _react2.default.createElement(_reactPaginate2.default, {
              pageCount: this.props.pageData ? this.props.pageData.totalPages : 1,
              marginPagesDisplayed: 1, pageRangeDisplayed: 2, previousLabel: "<", nextLabel: ">",
              breakLabel: _react2.default.createElement(
                'a',
                { href: 'javascript:void(0)' },
                '...'
              ), breakClassName: "item",
              onPageChange: this.props.parent.handlePageClick.bind(this.props.parent),
              containerClassName: "pagination-list", pageClassName: 'item',
              subContainerClassName: "pages pagination", previousClassName: 'item',
              nextClassName: 'item', activeClassName: "active",
              forcePage: this.props.pageData ? this.props.pageData.number : 0 }) : null,
            '(' + (pageNumber * pageSize + 1) + '-' + (this.props.pageData.totalElements < (pageNumber + 1) * pageSize ? this.props.pageData.totalElements : (pageNumber + 1) * pageSize) + '/' + this.props.pageData.totalElements + ') Tr\xEAn 1 trang: ',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 10 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 10) },
              '10'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 25 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 25) },
              '25'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 50 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 50) },
              '50'
            )
          ) : null,
          this.props.isKiemTra && _react2.default.createElement(
            'div',
            { className: 'wrap-import-kiem-tra' },
            _react2.default.createElement(
              'div',
              { className: 'download_file_content pt10 download-example-file', onClick: this.handleExportExampleKiemTra.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'T\u1EA3i file import m\u1EABu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-input-tt-dvph' },
              _react2.default.createElement(
                'div',
                { className: 'upload_file_content pt10' },
                _react2.default.createElement('input', { accept: '.xls, .xlsx', type: 'file', name: 'uploadFile', className: 'upload btn-green btn-pullleft', ref: 'btnUpload', onChange: this.handleImportEmxampleKiemTra.bind(this) }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { htmlFor: 'file', className: 'btn-orange', onClick: this.handleImportEmxampleKiemTra.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-document-import' }),
                  'Import cu\u1ED9c ki\u1EC3m tra'
                )
              )
            )
          )
        ),
        this.props.ThongKeBaoCao && !this.props.hideExport ? _react2.default.createElement(
          'div',
          { className: 'pagination-wrap' },
          _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
        ) : null
      );
    }
  }]);

  return DataTableDoiTuongThanhTra;
}(_react2.default.Component);

exports.default = DataTableDoiTuongThanhTra;

DataTableDoiTuongThanhTra.defaultProps = {
  onChangeHeader: function onChangeHeader() {},
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  titleAddmore: 'Thêm mới',
  ThongKeBaoCao: false,
  LapBaoCao: false,
  addNew: false,
  addNewItem: function addNewItem() {},
  dataList: [],
  header: [],
  plusColum: 0,
  displayCount: false,
  emptyMsg: 'Chưa có dữ liệu'
};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemAdministrative = function (_React$Component) {
  _inherits(RowItemAdministrative, _React$Component);

  function RowItemAdministrative() {
    _classCallCheck(this, RowItemAdministrative);

    return _possibleConstructorReturn(this, (RowItemAdministrative.__proto__ || Object.getPrototypeOf(RowItemAdministrative)).apply(this, arguments));
  }

  _createClass(RowItemAdministrative, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ma
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donViHanhChinhCha ? this.props.item.donViHanhChinhCha.ten : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.capDonViHanhChinhDVHC.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DONVIHANHCHINH_THEM') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-add',
                onClick: this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item) },
              'Th\xEAm \u0111\u01A1n v\u1ECB con'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DONVIHANHCHINH_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DONVIHANHCHINH_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.donViHanhChinhId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemAdministrative;
}(_react2.default.Component);

exports.default = RowItemAdministrative;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCapDonViHanhChinh = function (_React$Component) {
  _inherits(RowItemCapDonViHanhChinh, _React$Component);

  function RowItemCapDonViHanhChinh() {
    _classCallCheck(this, RowItemCapDonViHanhChinh);

    return _possibleConstructorReturn(this, (RowItemCapDonViHanhChinh.__proto__ || Object.getPrototypeOf(RowItemCapDonViHanhChinh)).apply(this, arguments));
  }

  _createClass(RowItemCapDonViHanhChinh, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ma
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('CAPDONVIHANHCHINH_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('CAPDONVIHANHCHINH_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.capDonViHanhChinhId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemCapDonViHanhChinh;
}(_react2.default.Component);

exports.default = RowItemCapDonViHanhChinh;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCapNhatNguoiDung = function (_React$Component) {
  _inherits(RowItemCapNhatNguoiDung, _React$Component);

  function RowItemCapNhatNguoiDung(props, context) {
    _classCallCheck(this, RowItemCapNhatNguoiDung);

    var _this = _possibleConstructorReturn(this, (RowItemCapNhatNguoiDung.__proto__ || Object.getPrototypeOf(RowItemCapNhatNguoiDung)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(RowItemCapNhatNguoiDung, [{
    key: 'openDialog',
    value: function openDialog() {
      var vaiTro = this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.loaiVaiTro;
      var coQuanQuanLyId = this.props.item.donViCongChuc.coQuanQuanLyId;
      var nguoiDungHienTai = this.props.item.hoVaTen;
      var vaiTroNguoiDungHienTai = this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten;
      var idNguoiDungHienTai = this.props.item.congChucId;
      this.props.openDialog(vaiTro, coQuanQuanLyId, nguoiDungHienTai, vaiTroNguoiDungHienTai, idNguoiDungHienTai);
    }
  }, {
    key: 'render',
    value: function render() {
      var Item = this.props.item;
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.hoVaTen ? this.props.item.hoVaTen : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Item.nguoiDungCongChuc && Item.nguoiDungCongChuc.vaiTroMacDinhInfo ? Item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { className: 'itt-redirect pointer', onClick: this.openDialog.bind(this) },
            'X\u1EED l\xFD'
          )
        )
      );
    }
  }]);

  return RowItemCapNhatNguoiDung;
}(_react2.default.Component);

exports.default = RowItemCapNhatNguoiDung;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _utils = __webpack_require__(4);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _lodash = __webpack_require__(14);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCapNhatNguoiDungXLD = function (_React$Component) {
  _inherits(RowItemCapNhatNguoiDungXLD, _React$Component);

  function RowItemCapNhatNguoiDungXLD(props) {
    _classCallCheck(this, RowItemCapNhatNguoiDungXLD);

    var _this = _possibleConstructorReturn(this, (RowItemCapNhatNguoiDungXLD.__proto__ || Object.getPrototypeOf(RowItemCapNhatNguoiDungXLD)).call(this, props));

    _this.state = {
      trangThaiDonText: '',
      ketQuaStr: '',
      ketQuaType: ''
    };
    return _this;
  }

  _createClass(RowItemCapNhatNguoiDungXLD, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!(0, _lodash.isEmpty)(this.props.item.trangThaiDonInfo)) {
        var _props$item$trangThai = _slicedToArray(this.props.item.trangThaiDonInfo, 1),
            trangThaiData = _props$item$trangThai[0];

        this.setState({
          ketQuaStr: trangThaiData.ketQuaType == 'DINH_CHI' ? 'Rút đơn' : trangThaiData.ketQuaStr,
          ketQuaType: trangThaiData.ketQuaType,
          trangThaiDonText: trangThaiData.trangThaiDonText,
          trangThaiDonType: trangThaiData.trangThaiDonType
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.type && this.props.type != nextProps.type) {
        this.setState({
          type: nextProps.type
        });
      }
      if (!(0, _lodash.isEmpty)(nextProps.item.trangThaiDonInfo)) {
        var _nextProps$item$trang = _slicedToArray(nextProps.item.trangThaiDonInfo, 1),
            trangThaiData = _nextProps$item$trang[0];

        this.setState({
          ketQuaStr: trangThaiData.ketQuaType == 'DINH_CHI' ? 'Rút đơn' : trangThaiData.ketQuaStr,
          ketQuaType: trangThaiData.ketQuaType,
          trangThaiDonText: trangThaiData.trangThaiDonText,
          trangThaiDonType: trangThaiData.trangThaiDonType
        });
      }
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = '';
      var listNguoiDungDon = this.props.item.listNguoiDungDon;

      if (!(0, _lodash.isEmpty)(listNguoiDungDon)) {
        size = listNguoiDungDon.length;
      }
      if (!size) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'li',
          { className: 'txt-bold' },
          (0, _lodash.get)(listNguoiDungDon, '[0].hoVaTen')
        ),
        _react2.default.createElement(
          'li',
          null,
          this.getLocal((0, _lodash.get)(listNguoiDungDon, '[0]'))
        ),
        _react2.default.createElement(
          'li',
          null,
          (0, _lodash.get)(listNguoiDungDon, '[0].soDienThoai')
        )
      );
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      var checkAddressData = function checkAddressData(addressData) {
        if (!(0, _lodash.isEmpty)(addressData)) {
          address.push(addressData);
        }
      };
      checkAddressData((0, _lodash.get)(data, 'diaChi'));
      checkAddressData((0, _lodash.get)(data, 'toThon'));
      checkAddressData((0, _lodash.get)(data, 'phuongXaCongDan.ten'));
      checkAddressData((0, _lodash.get)(data, 'quanHuyenCongDan.ten'));
      checkAddressData((0, _lodash.get)(data, 'tinhThanhCongDan.ten'));
      return address.join(", ");
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonInfo = this.props.item.nguonDonInfo;

      var result = '';
      if (!(0, _lodash.isEmpty)(nguonDonInfo)) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (!(0, _lodash.isEmpty)(dataNguonDon)) {
          switch (type) {
            case 'nguonDonText':
              result = (0, _lodash.get)(dataNguonDon, '[0].nguonDonText', '');
              return result;
            case 'nguonDonDonVi':
              result = (0, _lodash.get)(dataNguonDon, '[0].donViChuyenText', '');
              return result;
            default:
              return result;
          }
        }
      }
      return result;
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if ((0, _lodash.get)(this.props.item, 'donViThamTraXacMinhInfo.coQuanQuanLyId') === (0, _lodash.get)(userInfo, 'donViId')) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      var _props$item = this.props.item,
          soNguoi = _props$item.soNguoi,
          ngayTiepNhan = _props$item.ngayTiepNhan,
          loaiDonInfo = _props$item.loaiDonInfo,
          canBoDangXuLyInfo = _props$item.canBoDangXuLyInfo,
          ma = _props$item.ma,
          maHoSo = _props$item.maHoSo;

      var donDate = ngayTiepNhan ? (0, _moment2.default)(ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = ngayTiepNhan ? (0, _moment2.default)(ngayTiepNhan).format('HH:mm') : '';
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'table-checkbox' },
          _react2.default.createElement(
            'label',
            { className: 'pt-control pt-checkbox pt-large' },
            _react2.default.createElement('input', {
              type: 'checkbox',
              checked: this.props.item.selected || false,
              className: 'pt-large',
              onChange: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item),
              name: 'checkboxKetQua'
            }),
            _react2.default.createElement('span', { className: 'pt-control-indicator' })
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          ma || maHoSo
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !(0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(canBoDangXuLyInfo) },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(loaiDonInfo, 'ten', '')
            ),
            _react2.default.createElement(
              'li',
              null,
              soNguoi ? soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !(0, _lodash.isEmpty)(nguonDonDonVi) },
              _react2.default.createElement(
                'li',
                { className: 'txt-italic' },
                nguonDonDonVi
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.trangThaiDonText != null && this.state.trangThaiDonText != '' },
              _react2.default.createElement(
                'li',
                null,
                this.state.trangThaiDonText
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaStr != null && this.state.ketQuaStr != '' },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: this.state.ketQuaStr || '' })
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemCapNhatNguoiDungXLD;
}(_react2.default.Component);

exports.default = RowItemCapNhatNguoiDungXLD;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCongChuc = function (_React$Component) {
  _inherits(RowItemCongChuc, _React$Component);

  function RowItemCongChuc() {
    _classCallCheck(this, RowItemCongChuc);

    return _possibleConstructorReturn(this, (RowItemCongChuc.__proto__ || Object.getPrototypeOf(RowItemCongChuc)).apply(this, arguments));
  }

  _createClass(RowItemCongChuc, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.hoVaTen
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.nguoiDungCongChuc.email
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.dienThoai
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donViCongChuc.ten
            ),
            _react2.default.createElement(
              'li',
              { style: { fontStyle: 'italic' } },
              this.props.item.donViCongChuc.cha ? this.props.item.donViCongChuc.cha.ten : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.nguoiDungCongChuc && this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo ? this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('CONGCHUC_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('CONGCHUC_XOA') && this.props.item.congChucId != 1 ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xo\xE1 ng\u01B0\u1EDDi d\xF9ng',
              content: 'B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n xo\xE1 c\xF4ng ch\u1EE9c n\xE0y?',
              redux: this.props.parent,
              deleteId: this.props.item.congChucId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemCongChuc;
}(_react2.default.Component);

exports.default = RowItemCongChuc;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanToc = function (_React$Component) {
  _inherits(RowItemDanToc, _React$Component);

  function RowItemDanToc() {
    _classCallCheck(this, RowItemDanToc);

    return _possibleConstructorReturn(this, (RowItemDanToc.__proto__ || Object.getPrototypeOf(RowItemDanToc)).apply(this, arguments));
  }

  _createClass(RowItemDanToc, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenKhac
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DANTOC_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DANTOC_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.danTocId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemDanToc;
}(_react2.default.Component);

exports.default = RowItemDanToc;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhMucVideo = function (_React$Component) {
  _inherits(RowItemDanhMucVideo, _React$Component);

  function RowItemDanhMucVideo() {
    _classCallCheck(this, RowItemDanhMucVideo);

    return _possibleConstructorReturn(this, (RowItemDanhMucVideo.__proto__ || Object.getPrototypeOf(RowItemDanhMucVideo)).apply(this, arguments));
  }

  _createClass(RowItemDanhMucVideo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DANHMUCVIDEO_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DANHMUCVIDEO_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.danhMucVideoId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemDanhMucVideo;
}(_react2.default.Component);

exports.default = RowItemDanhMucVideo;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDoiTuongThanhTra = function (_React$Component) {
  _inherits(RowItemDoiTuongThanhTra, _React$Component);

  function RowItemDoiTuongThanhTra() {
    _classCallCheck(this, RowItemDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (RowItemDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemDoiTuongThanhTra, [{
    key: 'onSelectedDoiTuong',
    value: function onSelectedDoiTuong(e) {
      this.props.parent.handleSelectedDoiTuong(e, this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        this.props.isTTTP && _react2.default.createElement(
          'td',
          { className: 'table-checkbox' },
          _react2.default.createElement(
            'label',
            { className: 'pt-control pt-checkbox pt-large' },
            _react2.default.createElement('input', {
              type: 'checkbox',
              disabled: this.props.item.approved,
              checked: this.props.doiTuongSelecteds.includes(this.props.item.doiTuongThanhTraId) && !this.props.item.approved,
              className: 'pt-large',
              onChange: this.onSelectedDoiTuong.bind(this),
              name: 'checkboxKetQua'
            }),
            _react2.default.createElement('span', { className: 'pt-control-indicator' })
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.loaiDoiTuongThanhTraInfo ? this.props.item.loaiDoiTuongThanhTraInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.diaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soDienThoai
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.approved ? 'Đã duyệt' : 'Chưa duyệt'
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ghiChu
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.doiTuongThanhTraId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemDoiTuongThanhTra;
}(_react2.default.Component);

exports.default = RowItemDoiTuongThanhTra;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDonViNgoai = function (_React$Component) {
  _inherits(RowItemDonViNgoai, _React$Component);

  function RowItemDonViNgoai(props, context) {
    _classCallCheck(this, RowItemDonViNgoai);

    var _this = _possibleConstructorReturn(this, (RowItemDonViNgoai.__proto__ || Object.getPrototypeOf(RowItemDonViNgoai)).call(this, props, context));

    _this.state = {};

    return _this;
  }

  _createClass(RowItemDonViNgoai, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DONVINGOAIHETHONG_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('DONVINGOAIHETHONG_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá đơn vị',
              content: 'Bạn chắc chắn muốn xoá đơn vị này?',
              redux: this.props.parent,
              deleteId: this.props.item.donViNgoaiHeThongId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemDonViNgoai;
}(_react2.default.Component);

exports.default = RowItemDonViNgoai;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLetters = function (_React$Component) {
  _inherits(RowItemLetters, _React$Component);

  function RowItemLetters() {
    _classCallCheck(this, RowItemLetters);

    return _possibleConstructorReturn(this, (RowItemLetters.__proto__ || Object.getPrototypeOf(RowItemLetters)).apply(this, arguments));
  }

  _createClass(RowItemLetters, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.linhVucDonThuCha ? this.props.item.linhVucDonThuCha.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('LINHVUCDONTHU_THEM') && this.props.item.level < 3 ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-add',
                onClick: this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)
              },
              'Th\xEAm l\u0129nh v\u1EF1c con'
            ) : null,
            (0, _CheckPermission.CheckPermission)('LINHVUCDONTHU_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('LINHVUCDONTHU_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.linhVucDonThuId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemLetters;
}(_react2.default.Component);

exports.default = RowItemLetters;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLinhVucDoiTuongThanhTra = function (_React$Component) {
  _inherits(RowItemLinhVucDoiTuongThanhTra, _React$Component);

  function RowItemLinhVucDoiTuongThanhTra() {
    _classCallCheck(this, RowItemLinhVucDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (RowItemLinhVucDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemLinhVucDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemLinhVucDoiTuongThanhTra, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('LINHVUCDOITUONGTHANHTRA_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('LINHVUCDOITUONGTHANHTRA_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.linhVucDoiTuongThanhTraId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemLinhVucDoiTuongThanhTra;
}(_react2.default.Component);

exports.default = RowItemLinhVucDoiTuongThanhTra;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLoaiTaiLieu = function (_React$Component) {
  _inherits(RowItemLoaiTaiLieu, _React$Component);

  function RowItemLoaiTaiLieu() {
    _classCallCheck(this, RowItemLoaiTaiLieu);

    return _possibleConstructorReturn(this, (RowItemLoaiTaiLieu.__proto__ || Object.getPrototypeOf(RowItemLoaiTaiLieu)).apply(this, arguments));
  }

  _createClass(RowItemLoaiTaiLieu, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('LOAITAILIEU_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('LOAITAILIEU_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.loaiTaiLieuId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemLoaiTaiLieu;
}(_react2.default.Component);

exports.default = RowItemLoaiTaiLieu;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemNhomDoiTuongThanhTra = function (_Component) {
  _inherits(RowItemNhomDoiTuongThanhTra, _Component);

  function RowItemNhomDoiTuongThanhTra() {
    _classCallCheck(this, RowItemNhomDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (RowItemNhomDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemNhomDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemNhomDoiTuongThanhTra, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'ten')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'moTa')
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_SUA') && _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            (0, _CheckPermission.CheckPermission)('DOITUONGTHANHTRA_XOA') && _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xo\xE1 danh m\u1EE5c',
              content: 'B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n xo\xE1 danh m\u1EE5c n\xE0y?',
              redux: this.props.parent,
              deleteId: this.props.item.nhomDoiTuongThanhTraId
            })
          )
        )
      );
    }
  }]);

  return RowItemNhomDoiTuongThanhTra;
}(_react.Component);

exports.default = RowItemNhomDoiTuongThanhTra;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemOrganization = function (_React$Component) {
  _inherits(RowItemOrganization, _React$Component);

  function RowItemOrganization() {
    _classCallCheck(this, RowItemOrganization);

    return _possibleConstructorReturn(this, (RowItemOrganization.__proto__ || Object.getPrototypeOf(RowItemOrganization)).apply(this, arguments));
  }

  _createClass(RowItemOrganization, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        !this.props.isTTTW && _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanQuanLyCha ? this.props.item.coQuanQuanLyCha.ten : ''
        ),
        !this.props.isTTTW && _react2.default.createElement(
          'td',
          null,
          this.props.item.capCoQuanQuanLyCQQL.ten
        ),
        !this.props.isTTTW && _react2.default.createElement(
          'td',
          null,
          this.props.item.donViHanhChinhCQQL.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            !this.props.isTTTW && (0, _CheckPermission.CheckPermission)('COQUANQUANLY_THEM') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-add',
                onClick: this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)
              },
              'Th\xEAm c\u01A1 quan con'
            ) : null,
            (0, _CheckPermission.CheckPermission)('COQUANQUANLY_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('COQUANQUANLY_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.coQuanQuanLyId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemOrganization;
}(_react2.default.Component);

exports.default = RowItemOrganization;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemOrganizationLevel = function (_React$Component) {
  _inherits(RowItemOrganizationLevel, _React$Component);

  function RowItemOrganizationLevel() {
    _classCallCheck(this, RowItemOrganizationLevel);

    return _possibleConstructorReturn(this, (RowItemOrganizationLevel.__proto__ || Object.getPrototypeOf(RowItemOrganizationLevel)).apply(this, arguments));
  }

  _createClass(RowItemOrganizationLevel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.capCoQuanQuanLyCha ? this.props.item.capCoQuanQuanLyCha.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('CAPCOQUANQUANLY_THEM') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-add',
                onClick: this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)
              },
              'Th\xEAm c\u1EA5p con'
            ) : null,
            (0, _CheckPermission.CheckPermission)('CAPCOQUANQUANLY_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('CAPCOQUANQUANLY_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.capCoQuanQuanLyId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemOrganizationLevel;
}(_react2.default.Component);

exports.default = RowItemOrganizationLevel;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemParameter = function (_React$Component) {
  _inherits(RowItemParameter, _React$Component);

  function RowItemParameter() {
    _classCallCheck(this, RowItemParameter);

    return _possibleConstructorReturn(this, (RowItemParameter.__proto__ || Object.getPrototypeOf(RowItemParameter)).apply(this, arguments));
  }

  _createClass(RowItemParameter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          { style: { width: '300px', wordBreak: 'break-all' } },
          this.props.item.giaTri
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('THAMSO_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('THAMSO_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.thamSoId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemParameter;
}(_react2.default.Component);

exports.default = RowItemParameter;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemPosition = function (_React$Component) {
  _inherits(RowItemPosition, _React$Component);

  function RowItemPosition() {
    _classCallCheck(this, RowItemPosition);

    return _possibleConstructorReturn(this, (RowItemPosition.__proto__ || Object.getPrototypeOf(RowItemPosition)).apply(this, arguments));
  }

  _createClass(RowItemPosition, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('CHUCVU_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('CHUCVU_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.chucVuId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemPosition;
}(_react2.default.Component);

exports.default = RowItemPosition;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemProcess = function (_React$Component) {
  _inherits(RowItemProcess, _React$Component);

  function RowItemProcess() {
    _classCallCheck(this, RowItemProcess);

    return _possibleConstructorReturn(this, (RowItemProcess.__proto__ || Object.getPrototypeOf(RowItemProcess)).apply(this, arguments));
  }

  _createClass(RowItemProcess, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item && this.props.item.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          { style: { width: '300px', wordBreak: 'break-all' } },
          this.props.item && this.props.item.loaiQuyTrinhInfo && this.props.item.loaiQuyTrinhInfo.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('PROCESS_XOA') && _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.donViId,
              buttonLoading: this.props.buttonLoading
            })
          )
        )
      );
    }
  }]);

  return RowItemProcess;
}(_react2.default.Component);

exports.default = RowItemProcess;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemQuocTich = function (_React$Component) {
  _inherits(RowItemQuocTich, _React$Component);

  function RowItemQuocTich() {
    _classCallCheck(this, RowItemQuocTich);

    return _possibleConstructorReturn(this, (RowItemQuocTich.__proto__ || Object.getPrototypeOf(RowItemQuocTich)).apply(this, arguments));
  }

  _createClass(RowItemQuocTich, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ma
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('QUOCTICH_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('QUOCTICH_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.quocTichId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemQuocTich;
}(_react2.default.Component);

exports.default = RowItemQuocTich;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemRole = function (_React$Component) {
  _inherits(RowItemRole, _React$Component);

  function RowItemRole() {
    _classCallCheck(this, RowItemRole);

    return _possibleConstructorReturn(this, (RowItemRole.__proto__ || Object.getPrototypeOf(RowItemRole)).apply(this, arguments));
  }

  _createClass(RowItemRole, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var TenLoaiVaiTro = this.props.parent.state.DataLoaiVaiTro.map(function (item, i) {
        if (_this2.props.item.loaiVaiTro == item.giaTri) {
          return _react2.default.createElement(
            'p',
            { key: i },
            item.ten
          );
        }
      });

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          TenLoaiVaiTro
        ),
        _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: this.props.item.moTa.replace(/\n/gi, '<br/>') } }),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('VAITRO_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('VAITRO_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.vaiTroId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemRole;
}(_react2.default.Component);

exports.default = RowItemRole;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemSearchCongChucSoNoiVu = function (_React$Component) {
  _inherits(RowItemSearchCongChucSoNoiVu, _React$Component);

  function RowItemSearchCongChucSoNoiVu() {
    _classCallCheck(this, RowItemSearchCongChucSoNoiVu);

    return _possibleConstructorReturn(this, (RowItemSearchCongChucSoNoiVu.__proto__ || Object.getPrototypeOf(RowItemSearchCongChucSoNoiVu)).apply(this, arguments));
  }

  _createClass(RowItemSearchCongChucSoNoiVu, [{
    key: 'chonCongChuc',
    value: function chonCongChuc() {
      this.props.onSelect(this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.hoVaTen
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Email: ',
            this.props.item.email
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u0110\u01A1n v\u1ECB: ',
            this.props.item.tenDonVi
          ),
          _react2.default.createElement(
            'p',
            null,
            'Ph\xF2ng: ',
            this.props.item.tenPhong
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenTrangThai
        ),
        _react2.default.createElement(
          'td',
          { className: 'action-center' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'icon-check-file', onClick: this.chonCongChuc.bind(this) },
            'Ch\u1ECDn'
          )
        )
      );
    }
  }]);

  return RowItemSearchCongChucSoNoiVu;
}(_react2.default.Component);

exports.default = RowItemSearchCongChucSoNoiVu;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemSearchDonViSoNoiVu = function (_React$Component) {
  _inherits(RowItemSearchDonViSoNoiVu, _React$Component);

  function RowItemSearchDonViSoNoiVu() {
    _classCallCheck(this, RowItemSearchDonViSoNoiVu);

    return _possibleConstructorReturn(this, (RowItemSearchDonViSoNoiVu.__proto__ || Object.getPrototypeOf(RowItemSearchDonViSoNoiVu)).apply(this, arguments));
  }

  _createClass(RowItemSearchDonViSoNoiVu, [{
    key: 'chonDonVi',
    value: function chonDonVi() {
      this.props.onSelect(this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenDonVi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenCapDonVi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenDonViCapTren
        ),
        _react2.default.createElement(
          'td',
          { className: 'action-center' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'icon-check-file', onClick: this.chonDonVi.bind(this) },
            'Ch\u1ECDn'
          )
        )
      );
    }
  }]);

  return RowItemSearchDonViSoNoiVu;
}(_react2.default.Component);

exports.default = RowItemSearchDonViSoNoiVu;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemThamQuyen = function (_React$Component) {
  _inherits(RowItemThamQuyen, _React$Component);

  function RowItemThamQuyen(props, context) {
    _classCallCheck(this, RowItemThamQuyen);

    var _this = _possibleConstructorReturn(this, (RowItemThamQuyen.__proto__ || Object.getPrototypeOf(RowItemThamQuyen)).call(this, props, context));

    _this.state = {};

    return _this;
  }

  _createClass(RowItemThamQuyen, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('THAMQUYENGIAIQUYET_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('THAMQUYENGIAIQUYET_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.thamQuyenGiaiQuyetId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemThamQuyen;
}(_react2.default.Component);

exports.default = RowItemThamQuyen;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTuDongBaoCao = function (_React$Component) {
  _inherits(RowItemTuDongBaoCao, _React$Component);

  function RowItemTuDongBaoCao() {
    _classCallCheck(this, RowItemTuDongBaoCao);

    return _possibleConstructorReturn(this, (RowItemTuDongBaoCao.__proto__ || Object.getPrototypeOf(RowItemTuDongBaoCao)).apply(this, arguments));
  }

  _createClass(RowItemTuDongBaoCao, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.props.parent.viewUpdateCategory.bind(this.props.parent, this.props.item) },
            this.props.item.tenBaoCao
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayBatDauBC ? (0, _moment2.default)(this.props.item.ngayBatDauBC).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayKetThucBC ? (0, _moment2.default)(this.props.item.ngayKetThucBC).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.namBaoCao
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.donViGuiInfo ? this.props.item.donViGuiInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('THAMSO_SUA') && !this.props.item.daTuDongGui && _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            (0, _CheckPermission.CheckPermission)('THAMSO_XOA') && !this.props.item.daTuDongGui && _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.cauHinhBaoCaoId
            })
          )
        )
      );
    }
  }]);

  return RowItemTuDongBaoCao;
}(_react2.default.Component);

exports.default = RowItemTuDongBaoCao;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTypeOfOrganizationLevel = function (_React$Component) {
  _inherits(RowItemTypeOfOrganizationLevel, _React$Component);

  function RowItemTypeOfOrganizationLevel() {
    _classCallCheck(this, RowItemTypeOfOrganizationLevel);

    return _possibleConstructorReturn(this, (RowItemTypeOfOrganizationLevel.__proto__ || Object.getPrototypeOf(RowItemTypeOfOrganizationLevel)).apply(this, arguments));
  }

  _createClass(RowItemTypeOfOrganizationLevel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.moTa
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('LOAICOQUANQUANLY_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)
              },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('LOAICOQUANQUANLY_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.loaiCoQuanQuanLyId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemTypeOfOrganizationLevel;
}(_react2.default.Component);

exports.default = RowItemTypeOfOrganizationLevel;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemVideo = function (_React$Component) {
  _inherits(RowItemVideo, _React$Component);

  function RowItemVideo() {
    _classCallCheck(this, RowItemVideo);

    return _possibleConstructorReturn(this, (RowItemVideo.__proto__ || Object.getPrototypeOf(RowItemVideo)).apply(this, arguments));
  }

  _createClass(RowItemVideo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.danhMucVideoInfo ? this.props.item.danhMucVideoInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.loaiVideoInfo ? this.props.item.loaiVideoInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(this, this.props.item.urlFileVideo, this.props.item.tenFileVideo) },
              this.props.item.tenFileVideo
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-blue txt-underline', onClick: function onClick() {
                  (0, _utils.downloadFile)(_this2.props.item.urlFileVideo, _this2.props.item.tenFileVideo);
                } },
              this.props.item.tenFileVideo
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('VIDEO_SUA') ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ) : null,
            (0, _CheckPermission.CheckPermission)('VIDEO_XOA') ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá video này?',
              redux: this.props.parent,
              deleteId: this.props.item.videoId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemVideo;
}(_react2.default.Component);

exports.default = RowItemVideo;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhSachDonTheoDonVi = exports.DanhSachDonTheoCongChuc = exports.CapNhatNguoiDung = exports.Video = exports.DanhMucVideo = exports.DonViNgoai = exports.NhomDoiTuongThanhTra = exports.DoiTuongThanhTra = exports.LinhVucDoiTuongThanhTra = exports.TypeOfOrganizationLevel = exports.Process = exports.CauHinhKHTT = exports.Parameter = exports.Organization = exports.Letters = exports.Administrative = exports.CongChuc = exports.Role = exports.QuocTich = exports.DanToc = exports.CapDonViHanhChinh = exports.OrganizationLevel = exports.Position = exports.LoaiTaiLieu = exports.HuongDanSuDung = exports.ThamQuyen = undefined;

var _LoaiTaiLieu = __webpack_require__(1034);

var _LoaiTaiLieu2 = _interopRequireDefault(_LoaiTaiLieu);

var _ThamQuyen = __webpack_require__(1041);

var _ThamQuyen2 = _interopRequireDefault(_ThamQuyen);

var _HuongDanSuDung = __webpack_require__(1031);

var _HuongDanSuDung2 = _interopRequireDefault(_HuongDanSuDung);

var _OrganizationLevel = __webpack_require__(1037);

var _OrganizationLevel2 = _interopRequireDefault(_OrganizationLevel);

var _CapDonViHanhChinh = __webpack_require__(1022);

var _CapDonViHanhChinh2 = _interopRequireDefault(_CapDonViHanhChinh);

var _Position = __webpack_require__(1038);

var _Position2 = _interopRequireDefault(_Position);

var _QuocTich = __webpack_require__(1039);

var _QuocTich2 = _interopRequireDefault(_QuocTich);

var _DanToc = __webpack_require__(1025);

var _DanToc2 = _interopRequireDefault(_DanToc);

var _Role = __webpack_require__(1040);

var _Role2 = _interopRequireDefault(_Role);

var _CongChuc = __webpack_require__(1024);

var _CongChuc2 = _interopRequireDefault(_CongChuc);

var _Administrative = __webpack_require__(1021);

var _Administrative2 = _interopRequireDefault(_Administrative);

var _Letters = __webpack_require__(1032);

var _Letters2 = _interopRequireDefault(_Letters);

var _Organization = __webpack_require__(1036);

var _Organization2 = _interopRequireDefault(_Organization);

var _Parameter = __webpack_require__(473);

var _Parameter2 = _interopRequireDefault(_Parameter);

var _CauHinhKHTT = __webpack_require__(472);

var _CauHinhKHTT2 = _interopRequireDefault(_CauHinhKHTT);

var _Process = __webpack_require__(474);

var _Process2 = _interopRequireDefault(_Process);

var _TypeOfOrganizationLevel = __webpack_require__(1043);

var _TypeOfOrganizationLevel2 = _interopRequireDefault(_TypeOfOrganizationLevel);

var _LinhVucDoiTuongThanhTra = __webpack_require__(1033);

var _LinhVucDoiTuongThanhTra2 = _interopRequireDefault(_LinhVucDoiTuongThanhTra);

var _DoiTuongThanhTra = __webpack_require__(1029);

var _DoiTuongThanhTra2 = _interopRequireDefault(_DoiTuongThanhTra);

var _NhomDoiTuongThanhTra = __webpack_require__(1035);

var _NhomDoiTuongThanhTra2 = _interopRequireDefault(_NhomDoiTuongThanhTra);

var _DonViNgoai = __webpack_require__(1030);

var _DonViNgoai2 = _interopRequireDefault(_DonViNgoai);

var _CapNhatNguoiDung = __webpack_require__(1023);

var _CapNhatNguoiDung2 = _interopRequireDefault(_CapNhatNguoiDung);

var _DanhSachDonTheoCongChuc = __webpack_require__(1027);

var _DanhSachDonTheoCongChuc2 = _interopRequireDefault(_DanhSachDonTheoCongChuc);

var _DanhSachDonTheoDonVi = __webpack_require__(1028);

var _DanhSachDonTheoDonVi2 = _interopRequireDefault(_DanhSachDonTheoDonVi);

var _DanhMucVideo = __webpack_require__(1026);

var _DanhMucVideo2 = _interopRequireDefault(_DanhMucVideo);

var _Video = __webpack_require__(1044);

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThamQuyen = _ThamQuyen2.default;
exports.HuongDanSuDung = _HuongDanSuDung2.default;
exports.LoaiTaiLieu = _LoaiTaiLieu2.default;
exports.Position = _Position2.default;
exports.OrganizationLevel = _OrganizationLevel2.default;
exports.CapDonViHanhChinh = _CapDonViHanhChinh2.default;
exports.DanToc = _DanToc2.default;
exports.QuocTich = _QuocTich2.default;
exports.Role = _Role2.default;
exports.CongChuc = _CongChuc2.default;
exports.Administrative = _Administrative2.default;
exports.Letters = _Letters2.default;
exports.Organization = _Organization2.default;
exports.Parameter = _Parameter2.default;
exports.CauHinhKHTT = _CauHinhKHTT2.default;
exports.Process = _Process2.default;
exports.TypeOfOrganizationLevel = _TypeOfOrganizationLevel2.default;
exports.LinhVucDoiTuongThanhTra = _LinhVucDoiTuongThanhTra2.default;
exports.DoiTuongThanhTra = _DoiTuongThanhTra2.default;
exports.NhomDoiTuongThanhTra = _NhomDoiTuongThanhTra2.default;
exports.DonViNgoai = _DonViNgoai2.default;
exports.DanhMucVideo = _DanhMucVideo2.default;
exports.Video = _Video2.default;
exports.CapNhatNguoiDung = _CapNhatNguoiDung2.default;
exports.DanhSachDonTheoCongChuc = _DanhSachDonTheoCongChuc2.default;
exports.DanhSachDonTheoDonVi = _DanhSachDonTheoDonVi2.default;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _toastr = __webpack_require__(11);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangePassword = function (_React$Component) {
  _inherits(ChangePassword, _React$Component);

  function ChangePassword(props, context) {
    _classCallCheck(this, ChangePassword);

    var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this, props, context));

    _this.state = {
      currentPassword: '',
      password: '',
      passwordConfirmation: ''
    };
    return _this;
  }

  _createClass(ChangePassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'closeChangePassword',
    value: function closeChangePassword() {
      _reactRouter.browserHistory.push('/');
    }
  }, {
    key: 'handleChangePassword',
    value: function handleChangePassword() {
      var _this2 = this;

      if (this.validateSubmitForm()) {
        if (this.state.password != this.state.passwordConfirmation) {
          (0, _toastr.Toastr)('Xác nhận mật khẩu không đúng.', 'error');
        } else {
          var params = {
            oldPassword: this.state.currentPassword,
            newPassword: this.state.password,
            newPasswordAgain: this.state.passwordConfirmation
          };
          _api.User.actions.changePassword.request(null, params).then(function (res) {
            (0, _toastr.Toastr)('Đổi mật khẩu thành công.', 'success');
            _reactRouter.browserHistory.push('/');
          }).catch(function (error) {
            _this2.setState({ loading: false });
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container', ref: 'tcdTX' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Thay \u0111\u1ED5i m\u1EADt kh\u1EA9u'
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { className: 'formChangePassword', noValidate: true },
            _react2.default.createElement(
              'div',
              { className: 'bottom-content' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-block pl15 pr15 pt20' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.InputPassword, { className: 'cp-input col-40', label: 'M\u1EADt kh\u1EA9u c\u0169', value: this.state.currentPassword, onChange: this.handleChange.bind(this, 'currentPassword'), name: 'currentPassword', channel: 'formTaoDon', require: true, bindValidator: this, placeholder: 'Nh\u1EADp...' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.InputPassword, { className: 'cp-input col-40', label: 'M\u1EADt kh\u1EA9u m\u1EDBi', value: this.state.password, onChange: this.handleChange.bind(this, 'password'), name: 'password', channel: 'formTaoDon', require: true, bindValidator: this, placeholder: 'Nh\u1EADp...' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.InputPassword, { className: 'cp-input col-40', label: 'X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u m\u1EDBi', value: this.state.passwordConfirmation, onChange: this.handleChange.bind(this, 'passwordConfirmation'), bindValidator: this, name: 'passwordConfirmation', channel: 'formTaoDon', require: true, placeholder: 'Nh\u1EADp...' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt30 mb30' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.closeChangePassword.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-save', onClick: this.handleChangePassword.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChangePassword;
}(_react2.default.Component);

ChangePassword.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = ChangePassword;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChangePassword = __webpack_require__(1073);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ChangePassword2.default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietDoiTuongThanhTraDialog = function (_React$Component) {
  _inherits(ChiTietDoiTuongThanhTraDialog, _React$Component);

  function ChiTietDoiTuongThanhTraDialog() {
    _classCallCheck(this, ChiTietDoiTuongThanhTraDialog);

    return _possibleConstructorReturn(this, (ChiTietDoiTuongThanhTraDialog.__proto__ || Object.getPrototypeOf(ChiTietDoiTuongThanhTraDialog)).apply(this, arguments));
  }

  _createClass(ChiTietDoiTuongThanhTraDialog, [{
    key: 'render',
    value: function render() {
      var Data = this.props.data || {};
      var getChiTietMotDoiTuong = null;
      var getChiTietNhieuDoiTuong = [];
      if ((Data.doiTuongThanhTraInfo || Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) && Data.cuocThanhTraNhieuDoiTuong === false) {
        getChiTietMotDoiTuong = Data.doiTuongThanhTraInfo || Data.listDoiTuongThanhTra[0];
      } else if (Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === true) {
        getChiTietNhieuDoiTuong = Data.doiTuongThanhTras || [];
      } else if (Data.doiTuongThanhTraInfo && Data.cuocThanhTraNhieuDoiTuong === false) {
        getChiTietMotDoiTuong = Data.doiTuongThanhTraInfo;
      }
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.props.onClose,
          title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra',
          className: 'dialog-default wrap-block'
        },
        getChiTietMotDoiTuong !== null ? _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30 pt20' },
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:',
            value: getChiTietMotDoiTuong.ten || '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:',
            value: getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? getChiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten : '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'Huy\u1EC7n/TP:',
            value: (0, _lodash.get)(getChiTietMotDoiTuong, 'quanHuyenInfo.name') }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'Ph\u01B0\u1EDDng/X\xE3:',
            value: (0, _lodash.get)(getChiTietMotDoiTuong, 'phuongXaInfo.name') }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: '\u0110\u1ECBa ch\u1EC9:',
            value: getChiTietMotDoiTuong.diaChi || '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:',
            value: getChiTietMotDoiTuong.soDienThoai || '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-50 mb10',
            label: 'Ghi ch\xFA:',
            value: getChiTietMotDoiTuong.ghiChu || '' })
        ) : getChiTietNhieuDoiTuong.length > 0 ? _react2.default.createElement(
          'table',
          { className: 'blueTable' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { style: { width: '35px' } },
                'STT'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '300px' } },
                'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Huy\u1EC7n/TP'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Ph\u01B0\u1EDDng/X\xE3'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '375px' } },
                '\u0110\u1ECBa ch\u1EC9'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '135px' } },
                'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            getChiTietNhieuDoiTuong.map(function (item, index) {
              return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                  'td',
                  null,
                  index + 1
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.ten
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _lodash.get)(item, 'quanHuyenInfo.name')
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _lodash.get)(item, 'phuongXaInfo.name')
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.diaChi
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.soDienThoai || ''
                )
              );
            })
          )
        ) : this.props.data.listDoiTuongThanhTra ? _react2.default.createElement(
          'table',
          { className: 'blueTable' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { style: { width: '35px' } },
                'STT'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '300px' } },
                'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Huy\u1EC7n/TP'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '165px' } },
                'Ph\u01B0\u1EDDng/X\xE3'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '375px' } },
                '\u0110\u1ECBa ch\u1EC9'
              ),
              _react2.default.createElement(
                'th',
                { style: { width: '135px' } },
                'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.props.data.listDoiTuongThanhTra && this.props.data.listDoiTuongThanhTra.map(function (item, index) {
              return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                  'td',
                  null,
                  index + 1
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.ten
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _lodash.get)(item, 'quanHuyenInfo.name')
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _lodash.get)(item, 'phuongXaInfo.name')
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.diaChi
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  item.soDienThoai || ''
                )
              );
            })
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt20' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: this.props.onClose },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietDoiTuongThanhTraDialog;
}(_react2.default.Component);

ChiTietDoiTuongThanhTraDialog.defaultProps = {
  data: {}
};

exports.default = ChiTietDoiTuongThanhTraDialog;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _bind = __webpack_require__(240);

var _bind2 = _interopRequireDefault(_bind);

var _subView = __webpack_require__(33);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _detail = __webpack_require__(194);

var _RowItemDocumentDetail = __webpack_require__(1087);

var _RowItemDocumentDetail2 = _interopRequireDefault(_RowItemDocumentDetail);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietDonDialog = function (_React$Component) {
  _inherits(ChiTietDonDialog, _React$Component);

  function ChiTietDonDialog(props, context) {
    _classCallCheck(this, ChiTietDonDialog);

    var _this = _possibleConstructorReturn(this, (ChiTietDonDialog.__proto__ || Object.getPrototypeOf(ChiTietDonDialog)).call(this, props, context));

    _this.state = {
      isOpen: true,
      data: _this.props.item,
      isOpenDialog: false,
      donId: _this.props.donId,
      dataGiaiQuyet: '',
      trangThaiGiaiQuyet: '',
      dataLichSuTrangThaiXuLyGiaiQuyetDon: [],
      lichSuTrangThaiXLGQDons: []
    };
    return _this;
  }

  _createClass(ChiTietDonDialog, [{
    key: 'openDialog',
    value: function openDialog() {
      var _this2 = this;

      _api.Reception.actions.getDonInfo.request({ id: this.props.item.donId }).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: _extends({}, _this2.props.item, res.data)
          });
        }
      });
      this.getQuyTrinhXuLyHistory(this.props.item.donId);
      this.setState({
        isOpenDialog: !this.state.isOpenDialog
      });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory(inputId) {
      var _this3 = this;

      _api.Reception.actions.getLichSuTrangThaiXLGQDons.request({ donId: inputId }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
        } else {
          _this3.setState({ lichSuTrangThaiXLGQDons: [] });
        }
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({ isOpenDialog: !this.state.isOpenDialog });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'txt-underline', onClick: this.openDialog.bind(this) },
          _react2.default.createElement(_reactTextTruncate2.default, {
            line: 3,
            truncateText: '\u2026',
            text: this.state.data.noiDung
          })
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenDialog,
            onClose: this.closeDialog.bind(this),
            title: 'TH\xD4NG TIN \u0110\u01A0N',
            className: 'dialog-gh wrap-block chiTietDon-dialog' },
          _react2.default.createElement(
            'div',
            { className: 'body-dialog-gh' },
            _react2.default.createElement(
              'div',
              { className: 'panel-page' },
              _react2.default.createElement(
                'div',
                { className: 'page-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-wrap content-gqd background-detail' },
                  _react2.default.createElement(
                    'div',
                    { className: (0, _bind2.default)('header-redirect background-detail', { 'no-border-bottom': !this.state.isOpen }) },
                    _react2.default.createElement(
                      'div',
                      { className: 'row-col' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.data.maHoSo !== '' },
                        _react2.default.createElement(
                          'div',
                          { className: 'header-col pl15' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold' },
                            'M\xE3 \u0111\u01A1n:'
                          ),
                          this.state.data.maHoSo || ''
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: (0, _bind2.default)('header-col', { 'pl15': !this.state.data.ma }) },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold' },
                          'Ng\xE0y ti\u1EBFp nh\u1EADn:'
                        ),
                        this.state.data.ngayTiepNhan ? (0, _moment2.default)(this.state.data.ngayTiepNhan).format('DD/MM/YYYY') : ''
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'header-col' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold' },
                          'Ngu\u1ED3n \u0111\u01A1n:'
                        ),
                        this.state.data.nguonDonText
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'header-col pr15' },
                        _react2.default.createElement(_core.Button, { onClick: this.handleClick.bind(this), className: (0, _bind2.default)('btn-collap', { 'active': this.state.isOpen }) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.coQuanToChucTiepDan && this.props.coQuanToChucTiepDan.length },
                    _react2.default.createElement(
                      'div',
                      { className: 'wrapper_box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-items mb0-18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'box-forward' },
                          _react2.default.createElement(
                            'div',
                            { className: 'container-box' },
                            _react2.default.createElement(
                              'div',
                              { className: 'group-box pt-20 pl10 pr10' },
                              _react2.default.createElement(
                                'div',
                                { className: 'title' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'rows' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'col-12' },
                                    _react2.default.createElement(
                                      'h3',
                                      null,
                                      'Danh s\xE1ch c\u01A1 quan, c\xE1c \u0111\u01A1n v\u1ECB c\xF9ng tham gia ti\u1EBFp c\xF4ng d\xE2n'
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'items-form' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'rows' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'col-12' },
                                    _react2.default.createElement(
                                      _dataTable2.default,
                                      {
                                        header: _table.header.detailReceptionPeriodical.organization,
                                        dataList: this.props.coQuanToChucTiepDan,
                                        hidePagination: true,
                                        tableLoading: false },
                                      _react2.default.createElement(_detail.RowItemListOrganizationPeriodical, null)
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrapper_box pb0 pl10 pr10 pt10' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.data },
                      _react2.default.createElement(
                        _core.Collapse,
                        { isOpen: this.state.isOpen },
                        _react2.default.createElement(_subView.ThongTinNguoiDungDon, _extends({
                          title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
                        }, this.state.data))
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.data.coUyQuyen },
                        _react2.default.createElement(
                          _core.Collapse,
                          { isOpen: this.state.isOpen },
                          _react2.default.createElement(
                            'div',
                            { className: 'box-items mb0 mt20' },
                            _react2.default.createElement(_subView.ThongTinNguoiUyQuyen, _extends({
                              checkTDGS: this.props.checkTDGS,
                              title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n'
                            }, this.state.data))
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'pl5 pr5 pt0 mb15' },
                            _react2.default.createElement('div', { className: 'line-border' })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: (0, _bind2.default)('box-items', { 'no-margin': !this.state.isOpen }) },
                        _react2.default.createElement(_subView.ThongTinDon, _extends({
                          checkTDGS: true,
                          title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                          isOpen: this.state.isOpen
                        }, this.state.data))
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.data.coThongTinCoQuanDaGiaiQuyet },
                        _react2.default.createElement(
                          _core.Collapse,
                          { isOpen: this.state.isOpen },
                          _react2.default.createElement(
                            'div',
                            { className: 'pl5 pr5 pt0 mb15' },
                            _react2.default.createElement('div', { className: 'line-border' })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: (0, _bind2.default)('box-items', { 'no-margin': !this.state.isOpen }) },
                            _react2.default.createElement(_subView.ThongTinCoQuanDaGiaiQuyet, _extends({
                              title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                            }, this.state.data))
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length },
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items no-border' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                              'h3',
                              null,
                              'Qu\xE1 tr\xECnh x\u1EED l\xFD'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'items-form' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                              _dataTable2.default,
                              {
                                header: _table.header.listTTXLGQD,
                                dataList: this.state.lichSuTrangThaiXLGQDons,
                                hidePagination: true },
                              _react2.default.createElement(_RowItemDocumentDetail2.default, null)
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom mt20' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietDonDialog;
}(_react2.default.Component);

ChiTietDonDialog.defaultProps = {
  dataGiaiQuyet: [],
  coQuanToChucTiepDan: []
};

exports.default = ChiTietDonDialog;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  function ConfirmDialog(props, context) {
    _classCallCheck(this, ConfirmDialog);

    var _this = _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this, props, context));

    _this.state = {
      loading: _this.props.loading,
      thoiHan: ''
    };
    return _this;
  }

  _createClass(ConfirmDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        loading: nextProps.loading
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.state[name] = e._d;
      } else {
        this.state[name] = e;
      }
      this.setState(_extends({}, this.state));
      this.props.onChangeDate(this.state[name]);
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess() {
      if (this.props.withTime) {
        if (this.validateSubmitForm()) {
          this.props.onSuccess();
        }
      } else {
        this.props.onSuccess();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.props.onClose,
          title: 'X\xE1c nh\u1EADn',
          className: 'reception-dialog delete-dialog wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement('p', { className: 'reception-dialog-text', dangerouslySetInnerHTML: { __html: this.props.title } }),
          this.props.withTime ? _react2.default.createElement(_common.DatePicker, { className: 'dpk-inline mb0-18', require: true, label: 'Th\u1EDDi h\u1EA1n b\xE1o c\xE1o', bindValidator: this, channel: 'formTaoDon', value: this.state.thoiHan, onChange: this.handleChangeDate.bind(this, 'thoiHan') }) : ''
        ),
        this.props.withTime ? _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement('span', { className: 'line-border mb20' })
        ) : '',
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer-actions reception-delete-confirm' },
            _react2.default.createElement(_core.Button, {
              onClick: this.props.onClose,
              text: 'Kh\xF4ng',
              className: 'btn-default'
            }),
            _react2.default.createElement(_core.Button, {
              onClick: this.handleSuccess.bind(this),
              text: '\u0110\u1ED3ng \xFD',
              className: 'btn-green ' + (this.props.loading === true ? 'btn-loading-inline' : '')
            })
          )
        )
      );
    }
  }]);

  return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.defaultProps = {
  title: 'Dữ liệu này đã tồn tại trong hệ thống. Bạn muốn sử dụng dữ liệu có sẵn?',
  loading: false,
  withTime: false,
  validators: {}
};

exports.default = ConfirmDialog;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteDialog = function (_React$Component) {
  _inherits(DeleteDialog, _React$Component);

  function DeleteDialog(props, context) {
    _classCallCheck(this, DeleteDialog);

    var _this = _possibleConstructorReturn(this, (DeleteDialog.__proto__ || Object.getPrototypeOf(DeleteDialog)).call(this, props, context));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(DeleteDialog, [{
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'okAction',
    value: function okAction() {
      if (typeof this.props.redux != 'undefined') {
        this.props.redux.handleDelete(this.props.deleteId);
        this.setState(_extends({}, this.state, {
          isOpen: false
        }));
      }
      if (typeof this.props.onSuccess == 'function') {
        this.setState(_extends({}, this.state, {
          isOpen: false
        }));
        this.props.onSuccess();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-delete', onClick: this.toggleDialog.bind(this) },
          this.props.textHuy === true ? 'Huỷ' : this.props.labelButton
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.toggleDialog.bind(this),
            title: this.props.title,
            className: 'reception-dialog delete-dialog'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.props.content
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer-actions reception-delete-confirm' },
              _react2.default.createElement(_core.Button, {
                onClick: this.toggleDialog.bind(this),
                text: 'Kh\xF4ng',
                className: 'btn-default'
              }),
              _react2.default.createElement(_core.Button, {
                onClick: this.okAction.bind(this),
                text: '\u0110\u1ED3ng \xFD',
                className: (0, _classnames2.default)('btn-green', { 'btn-loading': this.props.buttonLoading })
              })
            )
          )
        )
      );
    }
  }]);

  return DeleteDialog;
}(_react2.default.Component);

DeleteDialog.defaultProps = {
  labelButton: 'Xoá'
};

exports.default = DeleteDialog;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _config = __webpack_require__(16);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _GetParams = __webpack_require__(47);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var buocGiaiQuyet = 'GIA_HAN';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var GiaHanDialog = function (_React$Component) {
  _inherits(GiaHanDialog, _React$Component);

  function GiaHanDialog(props, context) {
    _classCallCheck(this, GiaHanDialog);

    var _this = _possibleConstructorReturn(this, (GiaHanDialog.__proto__ || Object.getPrototypeOf(GiaHanDialog)).call(this, props, context));

    _this.state = {
      isOpen: false,
      isValid: false,
      btnLoading: false,
      dataGiaiQuyetDon: [],
      soQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',

      soQuyetDinhGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',

      id: _this.props.id,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      loaiTepDinhKem: loaiTepDinhKem,
      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',
      idFile: '',
      idFileRemove: ''
    };
    return _this;
  }

  _createClass(GiaHanDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
        id: nextProps.id
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isValid: false,
        btnLoading: false,
        soQuyetDinhGiaHanTTXM: '',
        ngayHetHanSauKhiGiaHanTTXM: '',
        ngayRaQuyetDinhGiaHanTTXM: '',
        lyDoGiaHanTTXM: '',

        soQuyetDinhGiaHanGiaiQuyet: '',
        lyDoGiaHanGiaiQuyet: '',
        ngayHetHanSauKhiGiaHanGiaiQuyet: '',
        ngayRaQuyetDinhGiaHanGiaiQuyet: '',

        tenFile: '',
        urlFile: '',
        progress: 0,
        duongDan: '',

        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.getTaiLieuVanThu();
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      if (typeof id != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this2.setState({
              dataGiaiQuyetDon: res.data,
              soQuyetDinhGiaHanTTXM: res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? new Date(res.data.ngayHetHanSauKhiGiaHanTTXM) : '',
              ngayRaQuyetDinhGiaHanTTXM: res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',

              soQuyetDinhGiaHanGiaiQuyet: res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? new Date(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet) : '',
              ngayRaQuyetDinhGiaHanGiaiQuyet: res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',

              isOpen: !_this2.state.isOpen
            });
          }
        });
      }
    }
  }, {
    key: 'getTaiLieuVanThu',
    value: function getTaiLieuVanThu() {
      var _this3 = this;

      var params = {
        donId: this.state.id,
        loaiQuyTrinh: loaiQuyTrinh,
        buocGiaiQuyet: buocGiaiQuyet
      };
      _api.GiaiQuyetDonThu.actions.getTaiLieuDinhKemDon.request(params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            tenFile: res.data._embedded.taiLieuVanThus[0].tenFile,
            duongDan: res.data._embedded.taiLieuVanThus[0].duongDan,
            idFile: res.data._embedded.taiLieuVanThus[0].taiLieuVanThuId
          });
        } else {
          _this3.setState({
            tenFile: '',
            duongDan: '',
            idFile: ''
          });
        }
      });
    }
  }, {
    key: 'handleGiaHan',
    value: function handleGiaHan() {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var params = (0, _GetParams.getParams)(this.state.dataGiaiQuyetDon, this.state.id);

        if (this.props.loaiDon == 'DON_TO_CAO') {
          params.soQuyetDinhGiaHanGiaiQuyet = this.state.soQuyetDinhGiaHanGiaiQuyet;
          params.lyDoGiaHanGiaiQuyet = this.state.lyDoGiaHanGiaiQuyet;
          params.ngayHetHanSauKhiGiaHanGiaiQuyet = (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).add(7, 'hours').toISOString();
          params.ngayRaQuyetDinhGiaHanGiaiQuyet = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
          params.giaHanGiaiQuyet = true;
        } else {
          params.soQuyetDinhGiaHanTTXM = this.state.soQuyetDinhGiaHanTTXM;
          params.lyDoGiaHanTTXM = this.state.lyDoGiaHanTTXM;
          params.ngayHetHanSauKhiGiaHanTTXM = (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanTTXM).add(7, 'hours').toISOString();
          params.ngayRaQuyetDinhGiaHanTTXM = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
          params.giaHanTTXM = true;
        }

        params['don'] = {
          id: this.state.id
        };

        if (this.state.idFile == '' && this.state.duongDan != '') {
          var _params = {
            buocGiaiQuyet: buocGiaiQuyet,
            don: {
              id: this.state.id
            },
            duongDan: this.state.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            loaiTepDinhKem: loaiTepDinhKem,

            tenFile: this.state.tenFile
          };
          if (this.props.loaiDon == 'DON_KHIEU_NAI') {
            _params.ngayQuyetDinh = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
            _params.soQuyetDinh = this.state.soQuyetDinhGiaHanTTXM;
            _params.ten = 'Quyết định về việc gia hạn thời gian xác minh';
          }

          if (this.props.loaiDon == 'DON_TO_CAO') {
            _params.ngayQuyetDinh = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
            _params.soQuyetDinh = this.state.soQuyetDinhGiaHanGiaiQuyet;

            _params.ten = 'Quyết định về việc gia hạn giải quyết tố cáo';
          }
          this.postTaiLieuVanThu(_params);
        }

        if (this.state.idFile != '' && this.state.duongDan != '') {
          var _params2 = {
            buocGiaiQuyet: buocGiaiQuyet,
            don: {
              id: this.state.id
            },
            duongDan: this.state.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            loaiTepDinhKem: loaiTepDinhKem,
            tenFile: this.state.tenFile
          };

          if (this.props.loaiDon == 'DON_KHIEU_NAI') {
            _params2.ngayQuyetDinh = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
            _params2.soQuyetDinh = this.state.soQuyetDinhGiaHanTTXM;
            _params2.ten = 'Quyết định về việc gia hạn thời gian xác minh';
          }

          if (this.props.loaiDon == 'DON_TO_CAO') {
            _params2.ngayQuyetDinh = (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
            _params2.soQuyetDinh = this.state.soQuyetDinhGiaHanGiaiQuyet;
            _params2.ten = 'Quyết định về việc gia hạn giải quyết tố cáo';
          }
          this.updateTaiLieuVanThu(_params2);
        }

        if (this.state.idFile != '' && this.state.duongDan == '') {
          this.deleteTaiLieuVanThu(this.state.idFile);
        }

        this.updateGiaiQuyetDon(params);
      }
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params) {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.giaHanTTXM, 'success');
        _this4.setState({
          isOpen: !_this4.state.isOpen,
          btnLoading: false
        });
        _this4.props.getListData();
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this4.setState({
          btnLoading: false
        });
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else if (e.target) {
        this.setState(_defineProperty({}, name, e.target.value));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this5 = this;

      if (e.target.files[0]) {
        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        if (_config.LimitFileType.indexOf(ext) == -1) {
          (0, _toastr.Toastr)(_message.msg.fileTypeErr, 'warning');
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);
            _this5.setState({ progress: progressBar });
          };
          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var checkURL = '';
            if (res && res.data && !_config.checkServerLive) {
              checkURL = res.data;
            } else if (res && res.data && _config.checkServerLive) {
              checkURL = res.data.id;
            }
            _this5.setState({
              progress: 0,
              tenFile: fileName,
              duongDan: checkURL
            });
          });
        }
      }
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove() {
      this.setState({
        duongDan: '',
        tenFile: '',
        progress: 0
      });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKemDon.request({ id: this.state.idFile }, params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKemDon.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(id) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKemDon.request({ id: id }).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-clock', onClick: this.openDialog.bind(this) },
          'Gia h\u1EA1n'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this),
            title: 'gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c',
            className: 'dialog-gh wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'body-dialog-gh' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pt20' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.Input, { className: 'col-33', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp s\u1ED1 quy\u1EBFt \u0111\u1ECBnh...', bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'soQuyetDinhGiaHanTTXM'), value: this.state.soQuyetDinhGiaHanTTXM, maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'ngayRaQuyetDinhGiaHanTTXM'), value: this.state.ngayRaQuyetDinhGiaHanTTXM }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y', startDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'ngayHetHanSauKhiGiaHanTTXM'), value: this.state.ngayHetHanSauKhiGiaHanTTXM }),
                  _react2.default.createElement(_common.TextArea, { label: 'L\xFD do gia h\u1EA1n', bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, placeholder: 'Nh\u1EADp l\xFD do...', onChange: this.onChange.bind(this, 'lyDoGiaHanTTXM'), value: this.state.lyDoGiaHanTTXM, maxLength: 1000 })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_TO_CAO' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.Input, { className: 'col-33', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp s\u1ED1 quy\u1EBFt \u0111\u1ECBnh...', bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'soQuyetDinhGiaHanGiaiQuyet'), value: this.state.soQuyetDinhGiaHanGiaiQuyet, maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'ngayRaQuyetDinhGiaHanGiaiQuyet'), value: this.state.ngayRaQuyetDinhGiaHanGiaiQuyet }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y', startDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, onChange: this.onChange.bind(this, 'ngayHetHanSauKhiGiaHanGiaiQuyet'), value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet }),
                  _react2.default.createElement(_common.TextArea, { label: 'L\xFD do gia h\u1EA1n', bindValidator: this, channel: 'formTaoDon', require: true, isValid: this.state.isValid, placeholder: 'Nh\u1EADp l\xFD do...', onChange: this.onChange.bind(this, 'lyDoGiaHanGiaiQuyet'), value: this.state.lyDoGiaHanGiaiQuyet, maxLength: 1000 })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-12 txt-bold txt-upper mb10 mt0' },
                  'Quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'desc mb10' },
                  _react2.default.createElement(
                    'p',
                    { style: { marginLeft: 0 } },
                    '\u0110\u1ECBnh d\u1EA1ng t\u1EADp tin \u0111\xEDnh k\xE8m: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung l\u01B0\u1EE3ng t\u1ED1i \u0111a: 50mb'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'result-upload mb20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'items-upload mb10' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.progress > 0 },
                      _react2.default.createElement(
                        'div',
                        { className: 'pt-progress-bar progress-upload pt-intent-primary' },
                        _react2.default.createElement('div', { className: 'pt-progress-meter',
                          style: { width: this.state.progress + '%' } })
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.progress <= 0 },
                      _react2.default.createElement(
                        'div',
                        { className: 'item-upload' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.duongDan !== '' },
                          _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              _utils.ShowIf,
                              { condition: !_config.checkServerLive },
                              _react2.default.createElement(
                                _reactRouter.Link,
                                { onClick: _jsFileDownload2.default.bind(this, this.state.urlFile, this.state.tenFile), className: 'txt-blue txt-underline mr20 name-file-upload' },
                                this.state.tenFile
                              )
                            ),
                            _react2.default.createElement(
                              _utils.ShowIf,
                              { condition: _config.checkServerLive },
                              _react2.default.createElement(
                                _reactRouter.Link,
                                { onClick: function onClick() {
                                    (0, _utils.downloadFile)(_this6.state.urlFile, _this6.state.tenFile);
                                  }, className: 'txt-blue txt-underline mr20 name-file-upload' },
                                this.state.tenFile
                              )
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'wrap-upload-item mr15' },
                              'T\u1EA3i l\u1EA1i',
                              _react2.default.createElement('input', { type: 'file', title: '', className: 'btn-reupload', onChange: this.uploadFile.bind(this) })
                            ),
                            _react2.default.createElement(
                              _reactRouter.Link,
                              { className: 'itt-delete', onClick: this.handleRemove.bind(this) },
                              'X\xF3a'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.duongDan === '' },
                          _react2.default.createElement(
                            'div',
                            { className: 'wrap-upload-item mr15' },
                            'T\u1EA3i l\xEAn',
                            _react2.default.createElement('input', { type: 'file', title: '', className: 'btn-reupload', onChange: this.uploadFile.bind(this) })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom col-100' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Kh\xF4ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo", onClick: this.handleGiaHan.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\u1ED3ng \xFD'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return GiaHanDialog;
}(_react2.default.Component);

GiaHanDialog.defaultProps = {
  validators: {}
};

exports.default = GiaHanDialog;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _rowItem = __webpack_require__(110);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HistoryDialog = function (_React$Component) {
  _inherits(HistoryDialog, _React$Component);

  function HistoryDialog(props, context) {
    _classCallCheck(this, HistoryDialog);

    var _this = _possibleConstructorReturn(this, (HistoryDialog.__proto__ || Object.getPrototypeOf(HistoryDialog)).call(this, props, context));

    _this.state = {
      isOpen: false,
      DataLichSuQuaTrinhXuLy: [],
      showDetail: false,
      itemSelected: { listThongTinThayDoi: [] },
      isVanBan: false
    };
    return _this;
  }

  _createClass(HistoryDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.type === 'ke-hoach') {
        this.getLichSuKeHoach();
      } else {
        this.getQuyTrinhXuLyHistory();
      }
    }
  }, {
    key: 'getLichSuKeHoach',
    value: function getLichSuKeHoach() {
      var _this2 = this;

      _api.Letter.actions.getLichSuKeHoach.request({ id: this.props.donId }).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = (0, _lodash.get)(res, "data._embedded.lichSuThayDois");
          _this2.setState({ DataLichSuQuaTrinhXuLy: data });
        } else {
          _this2.setState({ DataLichSuQuaTrinhXuLy: [] });
        }
      });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory() {
      var _this3 = this;

      _api.Letter.actions.getLichSuDon.request({ id: this.props.donId }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuThayDois });
        } else {
          _this3.setState({ DataLichSuQuaTrinhXuLy: [] });
        }
      });
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ isOpen: !this.state.isOpen, showDetail: false });
    }
  }, {
    key: 'handleBack',
    value: function handleBack() {
      this.setState({ showDetail: false });
    }
  }, {
    key: 'handleViewDetail',
    value: function handleViewDetail(item) {
      var isVanBan = false;
      if (item.noiDung === "Văn bản điều chỉnh") {
        isVanBan = true;
      }
      this.setState({
        itemSelected: item,
        showDetail: true,
        isVanBan: isVanBan
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-history' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-history', onClick: this.toggleDialog.bind(this) },
          this.props.title || "Lịch sử xử lý"
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.toggleDialog.bind(this),
            title: this.props.title || "Lịch sử xử lý",
            className: 'dialog-history wrap-block panel-popup'
          },
          _react2.default.createElement(
            'div',
            { className: 'body-dialog-gh' },
            this.state.showDetail ? _react2.default.createElement(
              'div',
              { className: 'back-foward pl25 mb0' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleBack.bind(this) },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ) : '',
            !this.state.showDetail ? _react2.default.createElement(
              'div',
              { className: 'row pl20 pr20' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.dialogHistory,
                  dataList: this.state.DataLichSuQuaTrinhXuLy,
                  hidePagination: true,
                  ma: this.props.ma
                },
                _react2.default.createElement(_rowItem.ListHistoryRowItem, { handleViewDetail: this.handleViewDetail.bind(this) })
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'row pl20 pr20' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.dialogHistoryDetail,
                  dataList: this.state.itemSelected.listThongTinThayDoi,
                  hidePagination: true
                },
                _react2.default.createElement(_rowItem.ListHistoryDetailRowItem, { isVanBan: this.state.isVanBan })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100 mt5' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.toggleDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return HistoryDialog;
}(_react2.default.Component);

exports.default = HistoryDialog;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MaTraCuuDialog = function (_React$Component) {
  _inherits(MaTraCuuDialog, _React$Component);

  function MaTraCuuDialog(props, context) {
    _classCallCheck(this, MaTraCuuDialog);

    var _this = _possibleConstructorReturn(this, (MaTraCuuDialog.__proto__ || Object.getPrototypeOf(MaTraCuuDialog)).call(this, props, context));

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(MaTraCuuDialog, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.props.onClose,
          className: "reception-dialog popup-tc wrap-block"
        },
        _react2.default.createElement(
          "div",
          { className: "pt-dialog-body" },
          _react2.default.createElement(
            "p",
            { className: "reception-dialog-text" },
            "M\xE3 tra c\u1EE9u \u0111\u01A1n"
          ),
          _react2.default.createElement(
            "p",
            { className: "ma-tc" },
            this.props.code
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "pt-dialog-footer" },
          _react2.default.createElement(
            "div",
            { className: "pt-dialog-footer-actions reception-delete-confirm" },
            _react2.default.createElement(_core.Button, {
              onClick: this.props.onClose,
              text: "\u0110\xF3ng",
              name: "closeDialog",
              className: "btn-default"
            })
          )
        )
      );
    }
  }]);

  return MaTraCuuDialog;
}(_react2.default.Component);

MaTraCuuDialog.defaultProps = {
  code: ''
};

exports.default = MaTraCuuDialog;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _RowItemKeHoachResult = __webpack_require__(1088);

var _RowItemKeHoachResult2 = _interopRequireDefault(_RowItemKeHoachResult);

var _table = __webpack_require__(12);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchKeHoachTT = function (_React$Component) {
  _inherits(SearchKeHoachTT, _React$Component);

  function SearchKeHoachTT(props, context) {
    _classCallCheck(this, SearchKeHoachTT);

    var _this = _possibleConstructorReturn(this, (SearchKeHoachTT.__proto__ || Object.getPrototypeOf(SearchKeHoachTT)).call(this, props, context));

    _this.state = {
      pageData: {
        number: 0,
        size: 10
      },
      isOpen: false,
      soQuyetDinh: _this.props.searchKey,
      loading: false,
      dataList: []
    };
    return _this;
  }

  _createClass(SearchKeHoachTT, [{
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.searchData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.isOpen) {
        this.setState({ soQuyetDinh: nextProps.searchKey }, function () {
          _this2.searchData();
        });
      }
    }
  }, {
    key: 'searchData',
    value: function searchData() {
      var _this3 = this;

      this.setState({
        loading: true
      });
      var inputParams = {
        size: this.state.pageData.size,
        page: this.state.pageData.number,
        keHoachCurrentId: this.props.keHoachCurrentId
      };
      if (this.state.soQuyetDinh) {
        inputParams.soQuyetDinh = this.state.soQuyetDinh;
      }

      _api.ThanhTra.actions.getKeHoachThanhTraOld.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            dataList: res.data._embedded.keHoachThanhTras,
            pageData: res.data.page
          });
        } else {
          _this3.setState({
            dataList: [],
            pageData: {
              number: 0,
              size: 10
            }
          });
        }
        _this3.setState({
          loading: false
        });
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.searchData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.searchData();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        { className: 'panel-popup dialog-search-result', inline: false, isOpen: this.props.isOpen, onClose: this.props.onClose, title: 'Danh s\xE1ch k\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm' },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'div',
            { id: 'list-people-search', className: 'search-name-container' },
            _react2.default.createElement(
              'form',
              { className: 'items-form', onSubmit: this.searchData.bind(this), action: 'javascript:void(0)' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Input, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT/KHKT', className: 'col-w22', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), maxLength: 255 }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-2' },
                  _react2.default.createElement(
                    'label',
                    { className: 'seacrh-people' },
                    _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-search', text: 'T\xECm ki\u1EBFm' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.searchKHTTDialog,
                dataList: this.state.dataList,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                tableLoading: this.state.loading },
              _react2.default.createElement(_RowItemKeHoachResult2.default, { onSelected: this.props.onSelected })
            )
          )
        )
      );
    }
  }]);

  return SearchKeHoachTT;
}(_react2.default.Component);

exports.default = SearchKeHoachTT;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var buocGiaiQuyet = 'DINH_CHI_DON';
var loaiQuyTrinh = 'GIAI_QUYET_DON';
var ten = 'Phiếu đình chỉ';

var SuspendedDialog = function (_React$Component) {
  _inherits(SuspendedDialog, _React$Component);

  function SuspendedDialog(props, context) {
    _classCallCheck(this, SuspendedDialog);

    var _this = _possibleConstructorReturn(this, (SuspendedDialog.__proto__ || Object.getPrototypeOf(SuspendedDialog)).call(this, props, context));

    _this.state = {
      isOpen: false,
      isValid: false,
      btnLoading: false,
      soQuyetDinhDinhChi: '',
      ngayQuyetDinhDinhChi: '',
      ngayRutDon: '',
      lyDoDinhChi: '',
      id: _this.props.id,
      type: _this.props.type,

      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',
      emptyFile: false
    };
    return _this;
  }

  _createClass(SuspendedDialog, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isValid: false,
        btnLoading: false,
        soQuyetDinhDinhChi: '',
        ngayQuyetDinhDinhChi: '',
        lyDoDinhChi: '',
        tenFile: '',
        urlFile: '',
        progress: 0,
        duongDan: '',
        emptyFile: false,
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'handleDinhChi',
    value: function handleDinhChi() {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var params = {
          lyDoDinhChi: this.state.lyDoDinhChi,
          ngayQuyetDinhDinhChi: (0, _moment2.default)(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
          soQuyetDinhDinhChi: this.state.soQuyetDinhDinhChi
        };
        if (this.state.type == 'GIAI_QUYET_DON') {
          if (this.state.duongDan != '' && this.props.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH') {
            var _params = {
              buocGiaiQuyet: buocGiaiQuyet,
              don: {
                id: this.state.id
              },
              duongDan: this.state.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              loaiTepDinhKem: loaiTepDinhKem,

              tenFile: this.state.tenFile,
              ten: ten,
              ngayQuyetDinh: (0, _moment2.default)(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
              soQuyetDinh: this.state.soQuyetDinhDinhChi
            };
            if (this.props.loaiDon == 'DON_KHIEU_NAI') {
              _params.ten = 'Quyết định về việc đình chỉ giải quyết khiếu nại';
            } else if (this.props.loaiDon == 'DON_TO_CAO') {
              _params.ten = 'Quyết định đình chỉ tố cáo';
            } else {
              _params.ten = ten;
            }
            this.postTaiLieuVanThu(_params);
          }
        }

        if (this.state.type == "XU_LY_DON") {

          if (this.state.duongDan != '') {
            var _params2 = {
              buocGiaiQuyet: buocGiaiQuyet,
              don: {
                id: this.state.id
              },
              duongDan: this.state.duongDan,
              loaiQuyTrinh: 'XU_LY_DON',
              loaiTepDinhKem: loaiTepDinhKem,

              tenFile: this.state.tenFile,
              ngayQuyetDinh: (0, _moment2.default)(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
              soQuyetDinh: this.state.soQuyetDinhDinhChi
            };
            if (this.props.trangThaiDon == 'DANG_XU_LY') {
              _params2.ten = 'Đơn xin rút đơn';
            } else {
              if (this.props.loaiDon == 'DON_KHIEU_NAI') {
                _params2.ten = 'Quyết định về việc đình chỉ giải quyết khiếu nại';
              } else if (this.props.loaiDon == 'DON_TO_CAO') {
                _params2.ten = 'Quyết định đình chỉ tố cáo';
              } else {
                _params2.ten = ten;
              }
            }
            this.postTaiLieuVanThu(_params2);
          }

          params.yKienXuLy = params.lyDoDinhChi;
          params.don = {
            id: this.state.id
          };
          delete params['lyDoDinhChi'];
          this.dinhChiXuLyDon(params);
        } else {
          this.dinhChiGiaiQuyetDon(params);
        }
      }
    }
  }, {
    key: 'dinhChiXuLyDon',
    value: function dinhChiXuLyDon(params) {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.patchDinhChiDon.request({ id: this.state.id }, params).then(function (res) {
        if (_this2.props.trangThaiDon == 'DANG_XU_LY') {
          (0, _toastr.Toastr)(_message.msg.rutDon, 'success');
        } else {
          (0, _toastr.Toastr)(_message.msg.dinhChiDon, 'success');
        }
        _this2.setState({
          isOpen: !_this2.state.isOpen,
          btnLoading: false
        });
        _this2.props.getListData();
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this2.setState({
          btnLoading: false
        });
      });
    }
  }, {
    key: 'dinhChiGiaiQuyetDon',
    value: function dinhChiGiaiQuyetDon(params) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.dinhChiGiaiQuyetDon.request({ id: this.state.id }, params).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.dinhChiDon, 'success');
        _this3.setState({
          isOpen: !_this3.state.isOpen,
          btnLoading: false
        });
        _this3.props.getListData();
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this3.setState({
          btnLoading: false
        });
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else if (e.target) {
        this.setState(_defineProperty({}, name, e.target.value));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' && this.props.trangThaiDon == 'DANG_GIAI_QUYET') {
        //do nothing
      } else {
        if (this.state.duongDan == '') {
          pass = false;
          this.setState({
            emptyFile: true
          });
        }
      }
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this4 = this;

      if (e.target.files[0]) {
        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        if (_config.LimitFileType.indexOf(ext) == -1) {
          (0, _toastr.Toastr)(_message.msg.fileTypeErr, 'warning');
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this4.setState({ progress: progressBar });
          };

          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var checkURL = '';
            if (res && res.data && !_config.checkServerLive) {
              checkURL = res.data;
            } else if (res && res.data && _config.checkServerLive) {
              checkURL = res.data.id;
            }
            _this4.setState({
              progress: 0,
              tenFile: fileName,
              duongDan: res.data ? res.data.id : ''
            });
          });
        }
      }
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKemDon.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index) {
      this.setState({
        duongDan: '',
        tenFile: '',
        progress: 0
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-rutdon', onClick: this.openDialog.bind(this) },
          'R\xFAt \u0111\u01A1n'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this),
            title: 'R\xFAt \u0111\u01A1n',
            className: 'dialog-gh wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'body-dialog-gh' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pt20' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.trangThaiDon == 'DANG_XU_LY' },
                _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Ng\xE0y r\xFAt \u0111\u01A1n', bindValidator: this, channel: 'formTaoDon', onChange: this.onChange.bind(this, 'ngayRutDon'), value: this.state.ngayRutDon, endDate: new Date() }),
                _react2.default.createElement(_common.TextArea, { label: 'L\xFD do r\xFAt \u0111\u01A1n',
                  placeholder: 'Nh\u1EADp l\xFD do...', onChange: this.onChange.bind(this, 'lyDoDinhChi'), value: this.state.lyDoDinhChi, maxLength: 1000 })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.trangThaiDon != 'DANG_XU_LY' },
                _react2.default.createElement(_common.Input, {
                  className: 'col-33',
                  label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh',
                  bindValidator: this,
                  channel: 'formTaoDon',
                  require: true,
                  onChange: this.onChange.bind(this, 'soQuyetDinhDinhChi'),
                  value: this.state.soQuyetDinhDinhChi,
                  maxLength: 255
                }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-33', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, onChange: this.onChange.bind(this, 'ngayQuyetDinhDinhChi'), value: this.state.ngayQuyetDinhDinhChi }),
                _react2.default.createElement(_common.TextArea, { label: 'L\xFD do r\xFAt \u0111\u01A1n',
                  bindValidator: this, channel: 'formTaoDon', require: true, placeholder: 'Nh\u1EADp l\xFD do...', onChange: this.onChange.bind(this, 'lyDoDinhChi'), value: this.state.lyDoDinhChi, maxLength: 1000 })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-12 txt-bold txt-upper mb10 mt0' },
                  '\u0110\u01A1n xin r\xFAt \u0111\u01A1n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'desc mb10' },
                  _react2.default.createElement(
                    'p',
                    { style: { marginLeft: 0 } },
                    '\u0110\u1ECBnh d\u1EA1ng t\u1EADp tin \u0111\xEDnh k\xE8m: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung l\u01B0\u1EE3ng t\u1ED1i \u0111a: 50MB'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'result-upload mb20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'items-upload mb10' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.progress > 0 },
                      _react2.default.createElement(
                        'div',
                        { className: 'pt-progress-bar progress-upload pt-intent-primary' },
                        _react2.default.createElement('div', { className: 'pt-progress-meter',
                          style: { width: this.state.progress + '%' } })
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.progress <= 0 },
                      _react2.default.createElement(
                        'div',
                        { className: 'item-upload' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.emptyFile && this.state.duongDan == '' },
                          _react2.default.createElement(
                            'span',
                            { className: 'pt-form-helper-text' },
                            'Vui l\xF2ng \u0111\xEDnh k\xE8m t\xE0i li\u1EC7u \xA0'
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.duongDan != '' },
                          _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              _reactRouter.Link,
                              { onClick: function onClick() {
                                  (0, _utils.downloadFile)(_this5.state.urlFile, _this5.state.tenFile);
                                }, className: 'txt-blue txt-underline mr20 name-file-upload' },
                              this.state.tenFile
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'wrap-upload-item mr15' },
                              'T\u1EA3i l\u1EA1i',
                              _react2.default.createElement('input', { type: 'file', className: 'btn-reupload', onChange: this.uploadFile.bind(this) })
                            ),
                            _react2.default.createElement(
                              _reactRouter.Link,
                              { className: 'itt-delete', onClick: this.handleRemove.bind(this) },
                              'X\xF3a'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.duongDan == '' },
                          _react2.default.createElement(
                            'div',
                            { className: 'wrap-upload-item mr15' },
                            'T\u1EA3i l\xEAn',
                            _react2.default.createElement('input', { type: 'file', className: 'btn-reupload', onChange: this.uploadFile.bind(this) })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom col-100' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Kh\xF4ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo", onClick: this.handleDinhChi.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\u1ED3ng \xFD'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SuspendedDialog;
}(_react2.default.Component);

SuspendedDialog.defaultProps = {
  validators: {},
  type: "GIAI_QUYET_DON"
};

exports.default = (0, _reactRedux.connect)()(SuspendedDialog);

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _thuHoiForm = __webpack_require__(1095);

var _ParamsGiaiQuyetDon = __webpack_require__(482);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThuHoiDialog = function (_React$Component) {
  _inherits(ThuHoiDialog, _React$Component);

  function ThuHoiDialog(props, context) {
    _classCallCheck(this, ThuHoiDialog);

    var _this = _possibleConstructorReturn(this, (ThuHoiDialog.__proto__ || Object.getPrototypeOf(ThuHoiDialog)).call(this, props, context));

    _this.state = {

      isThuHoi: false,
      donId: _this.props.donId,
      content: '',
      params: {},
      noticeMsg: 'Thu hồi đơn thành công',
      processTypeValue: '',
      // Tai GUI
      alias: '',
      listNextStates: '',
      nextState: '',

      isOpen: false
    };
    return _this;
  }

  _createClass(ThuHoiDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'getState',
    value: function getState(listNextStates, type) {

      var stateId = null;

      listNextStates.map(function (item, i) {

        if (item.type == type) {

          stateId = item.stateId;
          return stateId;
        }
      });
      return stateId;
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(donId) {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(function (res) {
        if (res.data) {
          var info = res.data;
          var content = '';
          if (info.currentForm.alias == 'ThuHoiDonAction' || info.currentForm.alias == 'ThuHoiDonGQAction' || info.currentForm.alias == 'ThuHoiDonTDTHaction') {
            content = 'Sau khi xác nhận thu hồi, đơn sẽ được chuyển đến trang "Công việc đang xử lý"';
          } else {
            content = 'Đơn đã thu hồi sẽ được giao cho';
          }

          _this2.setState({
            alias: info.currentForm.alias,
            listNextStates: info.listNextStates,
            processTypeValue: info.currentForm.processTypeInfo.giaTri,
            content: content
          });
        }
      }).catch(function (error) {

        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postXuLyDon',
    value: function postXuLyDon() {
      var _this3 = this;

      if (this.validateSubmitForm()) {

        var params = this.state.params;

        params.don = {
          id: Number(this.state.donId)
        };
        // this.setState({
        //   btnLoading: true,
        // });

        _api.LetterProcessingWorkFlow.actions.postXuLyDon.request('', params).then(function (res) {

          (0, _toastr.Toastr)(_this3.state.noticeMsg, 'success');

          if (_this3.state.alias == 'ThuHoiDonAction' && !_this3.state.isThuHoi) {

            _this3.setState({
              isThuHoi: true
            });

            _this3.getCurrentForm(_this3.state.donId);
          } else {
            _this3.toggleDialog();
          }
          _this3.props.dispatch({
            type: 'REFRESH_MENU',
            value: true
          });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          // this.setState({
          //   btnLoading: false,
          // });
        });
      }
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon() {
      var _this4 = this;

      if (this.validateSubmitForm()) {

        // this.setState({
        //   btnLoading: true,
        // });

        var paramsPost = this.state.params.paramsPost;

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', paramsPost).then(function (res) {
          (0, _toastr.Toastr)(_this4.state.noticeMsg, 'success');

          if ((_this4.state.alias == 'ThuHoiDonGQAction' || _this4.state.alias == 'ThuHoiDonTDTHaction') && !_this4.state.isThuHoi) {

            _this4.setState({
              isThuHoi: true
            });

            _this4.getCurrentForm(_this4.state.donId);
          } else {
            _this4.toggleDialog();
          }
          _this4.props.dispatch({
            type: 'REFRESH_MENU',
            value: true
          });
        }).catch(function (error) {

          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    }
  }, {
    key: 'patchGiaiQuyetDon',
    value: function patchGiaiQuyetDon() {
      var _this5 = this;

      if (this.validateSubmitForm()) {

        // this.setState({
        //   btnLoading: true,
        //   btnSaveLoading: true
        // });
        var paramsPatch = (0, _ParamsGiaiQuyetDon.ConvertParams)(this.state.params.paramsPatch, this.state.donId);

        _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.props.thongTinGiaiQuyetDonId }, paramsPatch).then(function (res) {
          _this5.postGiaiQuyetDon();
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    }
  }, {
    key: 'onPostClick',
    value: function onPostClick() {
      if (this.state.processTypeValue == 'XU_LY_DON') {
        this.postXuLyDon();
      } else {
        this.patchGiaiQuyetDon();
      }
    }
  }, {
    key: 'handleDataForm',
    value: function handleDataForm(state) {
      var noticeMsg = state.notice;
      var nextState = '';
      if (state.nextStateType) {
        nextState = state.nextStateType;
      }
      delete state.messege;

      this.setState({
        params: state,
        noticeMsg: noticeMsg,
        nextState: nextState
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (typeof this.props.validators['formTaoDon'] != 'undefined') {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else validator.validate();
        });
      }
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {

      if (!this.state.isOpen) {
        this.getCurrentForm(this.state.donId);
      }
      this.setState({ isOpen: !this.state.isOpen });

      // get lai danh sach du lieu
      if (this.state.isThuHoi) {
        this.props.getListData();
      }
    }
  }, {
    key: 'gotoPage',
    value: function gotoPage() {
      _reactRouter.browserHistory.push('/thu-hoi-xu-ly-don/xu-ly/dang/' + this.state.donId);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-thu-hoi', onClick: this.toggleDialog.bind(this) },
          'Thu h\u1ED3i'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.toggleDialog.bind(this),
            title: this.props.title,
            className: 'reception-dialog delete-dialog' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'ThuHoiDonAction' },
            _react2.default.createElement(_thuHoiForm.ThuHoiPU, {
              donId: this.state.donId,
              content: this.state.content,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'ThuHoiDonGQAction' || this.state.alias == 'ThuHoiDonTDTHaction' },
            _react2.default.createElement(_thuHoiForm.ThuHoiGQ, {
              donId: this.state.donId,
              content: this.state.content,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this,
              thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'ManagerAction' },
            _react2.default.createElement(_thuHoiForm.LanhDaoGiaoViecPU, {
              content: this.state.content,
              donId: this.state.donId,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'LeaderAction' },
            _react2.default.createElement(_thuHoiForm.TruongPhongGiaoViecPU, {
              content: this.state.content,
              donId: this.state.donId,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'lanhDaoKiemTraDeXuat' },
            _react2.default.createElement(_thuHoiForm.LanhDaoGiaoViecKTDXPU, {
              donId: this.state.donId,
              content: this.state.content,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this,
              thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId
            })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.alias == 'LanhDaoTTXMAction' || this.state.alias == 'LanhDaoTDTHAction' },
            _react2.default.createElement(_thuHoiForm.LanhDaoGiaoViecTTXMPU, {
              donId: this.state.donId,
              content: this.state.content,
              onChange: this.handleDataForm.bind(this),
              listNextStates: this.state.listNextStates,
              getState: this.getState.bind(this),
              bindValidator: this,
              thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer-actions reception-delete-confirm' },
              _react2.default.createElement(_core.Button, {
                onClick: this.toggleDialog.bind(this),
                text: 'Kh\xF4ng',
                className: 'btn-default'
              }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.alias != 'LeaderAction' || this.state.nextState != 'KET_THUC' },
                _react2.default.createElement(_core.Button, {
                  onClick: this.onPostClick.bind(this),
                  text: '\u0110\u1ED3ng \xFD',
                  className: 'btn-green'
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.alias == 'LeaderAction' && this.state.nextState == 'KET_THUC' },
                _react2.default.createElement(_core.Button, {
                  onClick: this.gotoPage.bind(this),
                  text: 'X\xE1c nh\u1EADn',
                  className: 'btn-green'
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ThuHoiDialog;
}(_react2.default.Component);

ThuHoiDialog.defaultProps = {
  validators: []
};

exports.default = (0, _reactRedux.connect)()((0, _utils.validatable)(ThuHoiDialog));

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TruongPhongThuHoiDialog = function (_React$Component) {
  _inherits(TruongPhongThuHoiDialog, _React$Component);

  function TruongPhongThuHoiDialog(props, context) {
    _classCallCheck(this, TruongPhongThuHoiDialog);

    var _this = _possibleConstructorReturn(this, (TruongPhongThuHoiDialog.__proto__ || Object.getPrototypeOf(TruongPhongThuHoiDialog)).call(this, props, context));

    _this.state = {

      donId: _this.props.id,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      content: '',
      params: {},
      noticeMsg: 'Thu hồi đơn thành công',
      coQuanQuanLyNguoiDung: {},

      // Tai GUI
      alias: '',
      listNextStates: '',
      nextState: '',
      canBoGiaiQuyet: '',
      phongBanGiaiQuyet: '',

      isOpen: false,
      confirm: false,
      btnLoading: false,
      showData: false,
      dataPhongBan: []
    };
    return _this;
  }

  _createClass(TruongPhongThuHoiDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          coQuanQuanLyNguoiDung: {
            id: userInfo.coQuanQuanLyId,
            ten: userInfo.tenCoQuanQuanLy
          }
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'getPhongBanThuocCoQuan',
    value: function getPhongBanThuocCoQuan() {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataPhongBan: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getState',
    value: function getState(listNextStates, type) {

      var stateId = null;

      listNextStates.map(function (item, i) {

        if (item.type == type) {

          stateId = item.stateId;
          return stateId;
        }
      });
      return stateId;
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(donId) {
      var _this3 = this;

      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(function (res) {
        if (res.data) {

          var info = res.data;
          var dataNextStateFilter = [];

          if (info.listNextStates) {
            var data = [].concat(_toConsumableArray(info.listNextStates));
            var dataFilter = data.filter(function (props) {
              return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
            });
            var dataNextState = [].concat(_toConsumableArray(dataFilter));
            dataNextState.map(function (item) {
              var newItem = item;
              if (item.type == 'KET_THUC' || item.type == 'CAN_BO_TDTH_LUU_DON' || item.type == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' || item.type == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' || item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
                newItem.tenVietTat = 'Tự xử lý';
                newItem.ten = 'Trưởng phòng tự xử lý';
              }
              dataNextStateFilter[dataNextStateFilter.length] = newItem;
            });
          }
          var invalidTypes = ['KET_THUC', 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN', 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH'];
          var getPhongBan = dataNextStateFilter.find(function (state) {
            return state.type === "NHANTTXM_GIAO_PHONG_CUNG_CAP";
          });
          if (getPhongBan) {
            var phoPhong = {
              stateId: getPhongBan.stateId,
              ten: "Trưởng phòng giao việc phó phòng",
              tenVietTat: "Giao việc phó phòng",
              type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
            };
            dataNextStateFilter.push(phoPhong);
          }
          dataNextStateFilter = dataNextStateFilter.filter(function (item) {
            return item && !invalidTypes.includes(item.type);
          });
          _this3.setState({
            alias: info.currentForm.alias,
            listNextStates: dataNextStateFilter,
            showData: true
          });
        }
      }).catch(function (error) {

        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon() {
      var _this4 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });

        var selectedState = this.state.listNextStates.filter(function (state) {
          return state.type == _this4.state.nextState;
        });

        var params = {
          don: {
            id: Number(this.state.donId)
          },
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          }
        };

        if (this.state.phongBanGiaiQuyet) {
          params.phongBanGiaiQuyet = {
            id: Number(this.state.phongBanGiaiQuyet)
          };
        }

        if (this.state.canBoGiaiQuyet) {
          params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoGiaiQuyet)
          };
        }

        if (this.state.listNextStates && this.state.listNextStates.length == 1) {
          params.nextState = {
            id: this.state.listNextStates[0].stateId
          };
        } else if (selectedState.length > 0) {
          params.nextState = {
            id: selectedState[0].stateId
          };
        }

        _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
          (0, _toastr.Toastr)(_message.msg.gqdGiaoViec, 'success');
          _this4.closeDialog();
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this4.setState({
            btnLoading: false
          });
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (typeof this.props.validators['formTaoDon'] != 'undefined') {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else validator.validate();
        });
      }
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        isOpen: true,
        confirm: false,
        btnLoading: false
      });
      this.getCurrentForm(this.state.donId);
      this.getPhongBanThuocCoQuan();
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
      if (this.state.confirm) {
        this.props.getListData();
      }
    }
  }, {
    key: 'confirm',
    value: function confirm() {
      var _this5 = this;

      this.setState({
        btnLoading: true
      });
      var params = {
        don: {
          id: Number(this.state.donId)
        },
        nextState: {
          id: this.getState(this.state.listNextStates, this.state.listNextStates.length > 0 ? this.state.listNextStates[0].type : 'TRUONG_PHONG_THU_HOI')
        },
        thongTinGiaiQuyetDon: {
          id: Number(this.state.thongTinGiaiQuyetDonId)
        }
      };

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        (0, _toastr.Toastr)(_this5.state.noticeMsg, 'success');
        _this5.setState({
          confirm: true,
          btnLoading: false,
          showData: false
        });
        _this5.getCurrentForm(_this5.state.donId);
        _this5.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this5.setState({
          btnLoading: false
        });
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'nextState') {
        this.setState({
          phongBanGiaiQuyet: '',
          canBoGiaiQuyet: ''
        });
      }
    }
  }, {
    key: 'goToGiaiQuyetDon',
    value: function goToGiaiQuyetDon() {
      _reactRouter.browserHistory.push('/tpth-giai-quyet-don/giai-quyet/' + this.state.donId);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-link-todo' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'itt-thu-hoi', onClick: this.openDialog.bind(this) },
          'Thu h\u1ED3i'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this),
            title: 'Thu h\u1ED3i',
            className: 'reception-dialog delete-dialog' },
          _react2.default.createElement(
            'div',
            { className: 'items-form' },
            _react2.default.createElement(
              'div',
              { className: 'row pr15 pl15' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.confirm },
                _react2.default.createElement(
                  'span',
                  { className: 'col-100 text-13 txt-center pt25 pb25' },
                  'Sau khi x\xE1c nh\u1EADn thu h\u1ED3i, \u0111\u01A1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n \u0111\u1EBFn trang "C\xF4ng vi\u1EC7c \u0111ang gi\u1EA3i quy\u1EBFt"'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.confirm },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.listNextStates.length == 1 },
                  _react2.default.createElement(
                    'span',
                    { className: 'col-100 text-13 pt25 pl25 pb10' },
                    '\u0110\u01A1n \u0111\xE3 thu h\u1ED3i s\u1EBD \u0111\u01B0\u1EE3c giao cho:'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.listNextStates.length > 1 },
                  _react2.default.createElement('div', { className: 'pt20' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pl15 pb20 pr15' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.listNextStates.length > 1 },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      className: 'col-50 mb-18',
                      donId: this.state.id,
                      require: true,
                      isValid: this.state.validate,
                      data: this.state.listNextStates,
                      bindValidator: this,
                      selectedValue: this.state.nextState,
                      label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                      keyName: 'type',
                      name: 'huongGiaiQuyet',
                      valueName: 'tenVietTat',
                      onChange: this.onChange.bind(this, 'nextState')
                    })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' || this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      selectedValue: this.state.phongBanGiaiQuyet,
                      require: true,
                      bindValidator: this,
                      className: 'col-50 mb-18',
                      keyName: 'coQuanQuanLyId',
                      valueName: 'ten',
                      label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt',
                      data: this.state.dataPhongBan,
                      onChange: this.onChange.bind(this, 'phongBanGiaiQuyet')
                    })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState === 'GQDTTTXM_GIAO_PHONG_CUNG_CAP' || this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP" },
                    _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                      className: 'col-50 mb0-18',
                      require: true,
                      bindValidator: this,
                      selectedValue: this.state.phongBanGiaiQuyet,
                      isValid: this.props.validate,
                      onChange: this.onChange.bind(this, 'phongBanGiaiQuyet'),
                      name: 'dropdownChonPhongBanThuocCoQuan' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' || this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
                    _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                      selectedValue: this.state.canBoGiaiQuyet,
                      require: true,
                      coQuanQuanLyId: this.state.phongBanGiaiQuyet ? this.state.phongBanGiaiQuyet : this.state.coQuanQuanLyNguoiDung.id,
                      vaiTro: this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ? 'TRUONG_PHONG' : this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' ? 'PHO_PHONG' : 'CHUYEN_VIEN',
                      bindValidator: this,
                      className: 'col-50 mb0-18',
                      label: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' ? "Chọn phó phòng" : "Công chức giải quyết",
                      onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                      name: 'dropdownChonCanBoGiaiQuyet'
                    })
                  )
                )
              )
            ),
            _react2.default.createElement('span', { className: 'line-border mb20' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer-actions reception-delete-confirm' },
              _react2.default.createElement(_core.Button, {
                onClick: this.closeDialog.bind(this),
                text: 'Kh\xF4ng',
                className: 'btn-default'
              }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.confirm },
                _react2.default.createElement(_core.Button, {
                  onClick: this.confirm.bind(this),
                  text: '\u0110\u1ED3ng \xFD',
                  className: this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.confirm && this.state.nextState != '' },
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'KET_THUC' || this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' || this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' || this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' },
                    _react2.default.createElement(_core.Button, {
                      onClick: this.goToGiaiQuyetDon.bind(this),
                      text: 'X\xE1c nh\u1EADn',
                      className: this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'
                    })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState != 'KET_THUC' && this.state.nextState != 'CAN_BO_TDTH_LUU_DON' && this.state.nextState != 'CAN_BO_PHONG_TDTH_LUU_HO_SO' && this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' && this.state.nextState != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' && this.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' },
                    _react2.default.createElement(_core.Button, {
                      onClick: this.postGiaiQuyetDon.bind(this),
                      text: 'Giao Vi\u1EC7c',
                      className: this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TruongPhongThuHoiDialog;
}(_react2.default.Component);

TruongPhongThuHoiDialog.defaultProps = {
  validators: []
};

exports.default = (0, _reactRedux.connect)()((0, _utils.validatable)(TruongPhongThuHoiDialog));

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XuLyYeuCau = function (_React$Component) {
  _inherits(XuLyYeuCau, _React$Component);

  function XuLyYeuCau(props, context) {
    _classCallCheck(this, XuLyYeuCau);

    var _this = _possibleConstructorReturn(this, (XuLyYeuCau.__proto__ || Object.getPrototypeOf(XuLyYeuCau)).call(this, props, context));

    _this.state = {
      trangThaiList: [],
      loading: false,
      trangThai: '',
      lyDo: ''
    };
    return _this;
  }

  _createClass(XuLyYeuCau, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getTrangThai();
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.onClose();
    }
  }, {
    key: 'getTrangThai',
    value: function getTrangThai() {
      var _this2 = this;

      if (this.props.trangThaiList) {
        var trangThaiList = this.props.trangThaiList;
        trangThaiList.map(function (item, index) {
          if ((_this2.props.data.trangThaiYeuCauGapLanhDao == 'CHO_XIN_Y_KIEN' || _this2.props.data.trangThaiYeuCauGapLanhDao == 'KHONG_DONG_Y') && item.giaTri == 'DONG_Y') {
            trangThaiList.splice(index, 1);
          }
        });
        this.setState({
          trangThaiList: trangThaiList
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['YeuCau'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.getTrangThai();
      }
    }
  }, {
    key: 'xuLyYeuCau',
    value: function xuLyYeuCau() {
      var _this3 = this;

      var state = this.state;
      if (this.validateSubmitForm()) {
        state.loading = true;
        var params = {
          trangThaiYeuCauGapLanhDao: this.state.trangThai,
          lyDoThayDoiTTYeuCauGapLanhDao: this.state.lyDo
        };
        _api.Reception.actions.updateXuLyYeuCau.request({ id: this.props.data.donId }, params).then(function (res) {
          if (res.data) {
            state.loading = false;
            (0, _toastr.Toastr)(_message.msg.xuLyYeuCau, 'success');
            _this3.closeDialog();
            _this3.props.onSuccess();
          }
        });
      }
      this.setState(state);
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.closeDialog.bind(this),
          title: 'Xác nhận',
          className: 'panel-popup category' },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(_common.DropDown, { label: '\xDD ki\u1EBFn l\xE3nh \u0111\u1EA1o',
            selectedValue: this.state.trangThai,
            className: 'input-default',
            options: this.state.trangThaiList,
            keyName: 'giaTri', valueName: 'ten',
            require: true,
            bindValidator: this,
            channel: 'YeuCau',
            onChange: this.handleChangeData.bind(this, 'trangThai'),
            placeholder: true }),
          _react2.default.createElement(_common.TextArea, { label: 'L\xFD do', className: 'pl0 pr0', rows: 5, placeholder: 'Nh\u1EADp...', bindValidator: this,
            channel: 'YeuCau', maxLength: 1000, value: this.state.lyDo, onChange: this.handleChangeData.bind(this, 'lyDo'), require: true, name: 'textareaLydo' }),
          this.state.trangThai == 'KHONG_DONG_Y' && this.props.data.trangThaiYeuCauGapLanhDao == 'DONG_Y' ? _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text pt0' },
            'Ch\u1ECDn "Kh\xF4ng \u0111\u1ED3ng \xFD", \u0111\u01A1n n\xE0y s\u1EBD b\u1ECB h\u1EE7y kh\u1ECFi danh s\xE1ch ti\u1EBFp \u0111\u1ECBnh k\u1EF3 c\u1EE7a l\xE3nh \u0111\u1EA1o'
          ) : '',
          this.state.trangThai == 'CHO_XIN_Y_KIEN' && this.props.data.trangThaiYeuCauGapLanhDao == 'DONG_Y' ? _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text pt0' },
            'Ch\u1ECDn "Ch\u1EDD xin \xFD ki\u1EBFn", \u0111\u01A1n n\xE0y s\u1EBD b\u1ECB h\u1EE7y kh\u1ECFi danh s\xE1ch ti\u1EBFp \u0111\u1ECBnh k\u1EF3 c\u1EE7a l\xE3nh \u0111\u1EA1o'
          ) : ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-footer' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.closeDialog.bind(this), className: 'btn-action btn-close' },
            _react2.default.createElement(
              'span',
              null,
              'Kh\xF4ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: this.state.loading ? "btn-action btn-save btn-loading-inline" : "btn-action btn-save", onClick: this.xuLyYeuCau.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u1ED3ng \xFD'
            )
          )
        )
      );
    }
  }]);

  return XuLyYeuCau;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()((0, _utils.validatable)(XuLyYeuCau));

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDocumentDetail = function (_React$Component) {
  _inherits(RowItemDocumentDetail, _React$Component);

  function RowItemDocumentDetail(props, context) {
    _classCallCheck(this, RowItemDocumentDetail);

    return _possibleConstructorReturn(this, (RowItemDocumentDetail.__proto__ || Object.getPrototypeOf(RowItemDocumentDetail)).call(this, props, context));
  }

  _createClass(RowItemDocumentDetail, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.item) {
        return null;
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.donViXuLyInfo && this.props.item.donViXuLyInfo.ten || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tenInfo && this.props.item.tenInfo.ten || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.listTaiLieuVanThus && this.props.item.listTaiLieuVanThus.length > 0 },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !_config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: _jsFileDownload2.default.bind(this, this.props.item.listTaiLieuVanThus[0].duongDan, this.props.item.listTaiLieuVanThus[0].tenFile) },
                this.props.item.listTaiLieuVanThus[0].tenFile || ''
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: function onClick() {
                    (0, _utils.downloadFile)(_this2.props.item.listTaiLieuVanThus[0].duongDan, _this2.props.item.listTaiLieuVanThus[0].tenFile);
                  } },
                this.props.item.listTaiLieuVanThus[0].tenFile || ''
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDocumentDetail;
}(_react2.default.Component);

exports.default = RowItemDocumentDetail;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKeHoachResult = function (_React$Component) {
  _inherits(RowItemKeHoachResult, _React$Component);

  function RowItemKeHoachResult() {
    _classCallCheck(this, RowItemKeHoachResult);

    return _possibleConstructorReturn(this, (RowItemKeHoachResult.__proto__ || Object.getPrototypeOf(RowItemKeHoachResult)).apply(this, arguments));
  }

  _createClass(RowItemKeHoachResult, [{
    key: 'onSelected',
    value: function onSelected() {
      this.props.onSelected(this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { textAlign: 'center' } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.quyetDinhPheDuyetKTTT
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayRaQuyetDinh ? (0, _moment2.default)(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.namThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.chucNangKeHoachThanhTraInfo ? this.props.item.chucNangKeHoachThanhTraInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.nguoiKy
        ),
        _react2.default.createElement(
          'td',
          { className: 'action-center' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'icon-check-file', onClick: this.onSelected.bind(this) },
            'L\u1EA5y th\xF4ng tin k\u1EBF ho\u1EA1ch'
          )
        )
      );
    }
  }]);

  return RowItemKeHoachResult;
}(_react2.default.Component);

exports.default = RowItemKeHoachResult;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _processType = __webpack_require__(57);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

var LanhDaoGiaoViecKTDXPU = function (_React$Component) {
  _inherits(LanhDaoGiaoViecKTDXPU, _React$Component);

  function LanhDaoGiaoViecKTDXPU(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecKTDXPU);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecKTDXPU.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecKTDXPU)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhongKTDX: false,
      form_GiaoViecCanBoKTDX: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      noiDung: '',
      phongBanGiaiQuyet: '',
      truongPhongChiDinh: '',
      canBoChiDinh: ''

    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecKTDXPU, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {
            case 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhongKTDX: true
              });
              break;

            case 'LANH_DAO_GIAO_VIEC_CAN_BO':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBoKTDX: true
              });
              break;
            default:
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          var info = res.data;

          _this3.setState({
            dataGiaiQuyetDon: info,
            nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
            phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState));
      } else {
        this.trigger(this.state);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanGiaiQuyet: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var paramsPatch = this.state.dataGiaiQuyetDon;
        var paramsPost = {};

        paramsPatch.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPatch.yKienGiaiQuyet = newState.noiDung;
        paramsPost.yKienGiaiQuyet = newState.noiDung;

        if (newState.phongBanGiaiQuyet) {

          paramsPatch.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
          paramsPost.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
        }

        if (newState.form_GiaoViecTruongPhongKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG') {

          if (newState.truongPhongChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
          }
        } else if (newState.form_GiaoViecCanBoKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO') {

          if (newState.canBoChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        }

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.ktdxLanhDaoGiaoViec
        };

        this.props.onChange(params);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'body-dialog-gh' },
        _react2.default.createElement(
          'span',
          { className: 'col-100 text-13 pt25 pl20 pb10' },
          this.props.content
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30 pt20' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              className: 'col-50',
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              isValid: this.props.validate,
              bindValidator: this,
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhongKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              className: 'col-50',
              bindValidator: this,
              selectedValue: this.state.phongBanGiaiQuyet,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhongKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, {
              label: 'L\xE3nh \u0111\u1EA1o ph\xF2ng',
              className: 'col-50',
              vaiTro: 'TRUONG_PHONG',
              selectedValue: this.state.truongPhongChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'truongPhongChiDinh'),
              name: 'dropdownChonCanBoXuLyTruongPhong' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBoKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              bindValidator: this,
              className: 'col-50',
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        )
      );
    }
  }]);

  return LanhDaoGiaoViecKTDXPU;
}(_react2.default.Component);

LanhDaoGiaoViecKTDXPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecKTDXPU));

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _processType = __webpack_require__(57);

var _message = __webpack_require__(10);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

var LanhDaoGiaoViecPU = function (_React$Component) {
  _inherits(LanhDaoGiaoViecPU, _React$Component);

  function LanhDaoGiaoViecPU(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecPU);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecPU.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecPU)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhong: false,
      form_GiaoViecCanBo: false,

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      thoiHanXuLy: new Date(),
      noiDung: '',
      phongBanChiDinh: '',
      truongPhongChiDinh: '',
      canBoChiDinh: ''

    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecPU, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhong: true
              });
              break;

            case _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBo: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.onlyOneState();
      if (this.state.donId == 0) {
        this.getThoiHanXuLyMacDinh();
      } else {
        this.getThongTinXuLy(this.state.donId);
      }
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'getThoiHanXuLyMacDinh',
    value: function getThoiHanXuLyMacDinh() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getThoiHanXuLyMacDinh.request().then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this3.setState({
          thoiHanXuLy: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this4 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          var info = res.data.thongTinXuLyInfo;

          var newState = _extends({}, _this4.state);

          if (info.thoiHanXuLy != null) newState = _extends({}, _this4.state, {
            thoiHanXuLy: (0, _moment2.default)(info.thoiHanXuLy)
          });

          if (info.nextState != null) {

            newState = _extends({}, _this4.state, {
              nextState: info.nextState.type,
              phongBanChiDinh: info.phongBanXuLyChiDinh.id,
              noiDung: info.yKienXuLy,
              thoiHanXuLy: (0, _moment2.default)(info.thoiHanXuLy),
              truongPhongChiDinh: info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ? info.canBoXuLyChiDinh.id : '',
              canBoChiDinh: info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' ? info.canBoXuLyChiDinh.id : ''
            });
          }

          _this4.setState(_extends({}, newState));

          _this4.trigger(newState, true);
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanChiDinh: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanChiDinh') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {

      if (typeof e.format == 'function') {
        var newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));

        this.setState(_extends({}, newState), this.trigger(newState));
      } else {

        var _newState = _extends({}, this.state, _defineProperty({}, name, e));

        this.setState(_extends({}, _newState), this.trigger(_newState));
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var params = {
          thoiHanXuLy: (0, _moment2.default)(newState.thoiHanXuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          noiDungYeuCauXuLy: newState.noiDung,
          nextState: {
            id: Number(stateId),
            type: newState.nextState
          }
        };

        if (newState.phongBanChiDinh) {
          params.phongBanXuLyChiDinh = {
            id: Number(newState.phongBanChiDinh)
          };
        }

        // Them param theo dieu kien huong xu ly
        if (newState.form_GiaoViecTruongPhong && newState.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong) {

          params.notice = _message.msg.xldLanhDaoGiaoViec;

          if (newState.truongPhongChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
          }
        } else if (newState.form_GiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien) {

          params.notice = _message.msg.xldLanhDaoGiaoViec;

          if (newState.canBoChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        }

        this.props.onChange(params, isInit);
      } else {

        var _params = {
          noiDungYeuCauXuLy: newState.noiDung
        };

        this.props.onChange(_params, isInit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'body-dialog-gh' },
        _react2.default.createElement(
          'span',
          { className: 'col-100 text-13 pt25 pl20 pb10' },
          this.props.content
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30 pt20' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              className: 'col-50',
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(_common.DatePicker, { require: true,
            className: 'col-50',
            bindValidator: this,
            channel: 'formTaoDon',
            isValid: this.props.validate,
            label: 'H\u1EA1n x\u1EED l\xFD',
            value: this.state.thoiHanXuLy,
            startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
            onChange: this.handleChangeDate.bind(this, 'thoiHanXuLy') })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhong && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong || this.state.form_GiaoViecCanBo && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              className: 'col-50',
              bindValidator: this,
              selectedValue: this.state.phongBanChiDinh,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanChiDinh'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBo && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien && this.state.phongBanChiDinh != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              className: 'col-50',
              bindValidator: this,
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanChiDinh,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        )
      );
    }
  }]);

  return LanhDaoGiaoViecPU;
}(_react2.default.Component);

LanhDaoGiaoViecPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecPU));

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

var _processType = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

var LanhDaoGiaoViecTTXM = function (_React$Component) {
  _inherits(LanhDaoGiaoViecTTXM, _React$Component);

  function LanhDaoGiaoViecTTXM(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecTTXM);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecTTXM.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecTTXM)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhong: false,
      form_GiaoViecCanBo: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      noiDung: '',
      phongBanGiaiQuyet: '',
      truongPhongChiDinh: '',
      canBoChiDinh: ''
    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecTTXM, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {
            case 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhong: true
              });
              break;
            case 'LANH_DAO_GIAO_VIEC_CAN_BO':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBo: true
              });
              break;
            default:
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {

          var info = res.data;

          _this3.setState({
            dataGiaiQuyetDon: info,
            nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
            phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      } else {
        this.trigger(this.state, true);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanGiaiQuyet: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var paramsPatch = this.state.dataGiaiQuyetDon;
        var paramsPost = {};

        paramsPatch.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPatch.yKienGiaiQuyet = newState.noiDung;
        paramsPost.yKienGiaiQuyet = newState.noiDung;

        if (newState.phongBanGiaiQuyet) {

          paramsPatch.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
          paramsPost.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
        }

        if (newState.form_GiaoViecTruongPhong && newState.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG') {

          if (newState.truongPhongChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
          }
        } else if (newState.form_GiaoViecCanBo && newState.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO') {
          if (newState.canBoChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        }

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.gqdLanhDaoGiaoViec
        };

        this.props.onChange(params, isInit);
      } else {

        var _params = {
          notice: _message.msg.gqdLanhDaoGiaoViec
        };

        this.props.onChange(_params, isInit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'body-dialog-gh' },
        _react2.default.createElement(
          'span',
          { className: 'col-100 text-13 pt25 pl20 pb10' },
          this.props.content
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30 pt20' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              className: 'col-50',
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhong && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              className: 'col-50',
              bindValidator: this,
              selectedValue: this.state.phongBanGiaiQuyet,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhong && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, {
              label: 'L\xE3nh \u0111\u1EA1o ph\xF2ng',
              className: 'col-50',
              vaiTro: 'TRUONG_PHONG',
              selectedValue: this.state.truongPhongChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'truongPhongChiDinh'),
              name: 'dropdownChonCanBoXuLyTruongPhong' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              bindValidator: this,
              className: 'col-50',
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        )
      );
    }
  }]);

  return LanhDaoGiaoViecTTXM;
}(_react2.default.Component);

LanhDaoGiaoViecTTXM.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecTTXM));

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoThuHoi, _processType.processType.xuLyDon.processing.truongPhongThuHoi];

var ThuHoiGQ = function (_React$Component) {
  _inherits(ThuHoiGQ, _React$Component);

  function ThuHoiGQ(props, context) {
    _classCallCheck(this, ThuHoiGQ);

    var _this = _possibleConstructorReturn(this, (ThuHoiGQ.__proto__ || Object.getPrototypeOf(ThuHoiGQ)).call(this, props, context));

    _this.state = {
      form_ThuHoi: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      content: _this.props.content
    };
    return _this;
  }

  _createClass(ThuHoiGQ, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {
            case _processType.processType.xuLyDon.processing.truongPhongThuHoi:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_ThuHoi: true
              });
              break;
            case _processType.processType.xuLyDon.processing.lanhDaoThuHoi:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_ThuHoi: true
              });
              break;
            default:
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          var info = res.data;

          _this3.setState({
            dataGiaiQuyetDon: info,
            nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
            phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type === 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type === 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState));
      } else {
        this.trigger(this.state);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name === 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanGiaiQuyet: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name === 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var paramsPatch = this.state.dataGiaiQuyetDon;
        var paramsPost = {};

        paramsPatch.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.thuHoiDon
        };
        this.props.onChange(params);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'pt-dialog-body' },
        _react2.default.createElement(
          'p',
          { className: 'reception-dialog-text' },
          this.state.content
        )
      );
    }
  }]);

  return ThuHoiGQ;
}(_react2.default.Component);

ThuHoiGQ.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThuHoiGQ));

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoThuHoi, _processType.processType.xuLyDon.processing.truongPhongThuHoi];

var ThuHoiPU = function (_React$Component) {
  _inherits(ThuHoiPU, _React$Component);

  function ThuHoiPU(props, context) {
    _classCallCheck(this, ThuHoiPU);

    var _this = _possibleConstructorReturn(this, (ThuHoiPU.__proto__ || Object.getPrototypeOf(ThuHoiPU)).call(this, props, context));

    _this.state = {
      form_ThuHoi: false,

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      content: _this.props.content
    };
    return _this;
  }

  _createClass(ThuHoiPU, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {
        if (_this2.props.getState(_this2.props.listNextStates, item)) {
          onlyState = item;
          numberState++;
          switch (item) {
            case _processType.processType.xuLyDon.processing.truongPhongThuHoi:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_ThuHoi: true
              });
              break;
            case _processType.processType.xuLyDon.processing.lanhDaoThuHoi:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_ThuHoi: true
              });
              break;
            default:
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.onlyOneState();
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var params = {
          nextState: {
            id: Number(stateId)
          }
        };

        if (newState.form_ThuHoi) {
          params.notice = _message.msg.thuHoiDon;
        }

        this.props.onChange(params, isInit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'pt-dialog-body' },
        _react2.default.createElement(
          'p',
          { className: 'reception-dialog-text' },
          this.state.content
        )
      );
    }
  }]);

  return ThuHoiPU;
}(_react2.default.Component);

ThuHoiPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThuHoiPU));

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _processType = __webpack_require__(57);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien, _processType.processType.xuLyDon.processing.deXuatGiaoViecLai];

var TruongPhongGiaoViecPU = function (_React$Component) {
  _inherits(TruongPhongGiaoViecPU, _React$Component);

  function TruongPhongGiaoViecPU(props, context) {
    _classCallCheck(this, TruongPhongGiaoViecPU);

    var _this = _possibleConstructorReturn(this, (TruongPhongGiaoViecPU.__proto__ || Object.getPrototypeOf(TruongPhongGiaoViecPU)).call(this, props, context));

    _this.state = {
      form_TruongPhongGiaoViecCanBo: false,
      form_DeXuatGiaoViecLai: false,

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      phongBan: _this.props.userInfo.coQuanQuanLyId,
      canBoChiDinh: '',
      listNextStates: []
    };
    return _this;
  }

  _createClass(TruongPhongGiaoViecPU, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {
        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {
            case _processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TruongPhongGiaoViecCanBo: true
              });
              break;
            case _processType.processType.xuLyDon.processing.deXuatGiaoViecLai:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_DeXuatGiaoViecLai: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.onlyOneState();
      if (this.state.donId != 0) {
        this.getThongTinXuLy(this.state.donId);
      }

      if (this.props.listNextStates) {
        var data = [].concat(_toConsumableArray(this.props.listNextStates));
        var dataFilter = data.filter(function (props) {
          return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
        });

        var dataNextState = [].concat(_toConsumableArray(dataFilter));
        var dataNextStateFilter = [];

        dataNextState.map(function (item) {
          var newItem = item;
          if (item.type == 'KET_THUC') {
            newItem.tenVietTat = 'Tự xử lý';
            newItem.ten = 'Trưởng phòng tự xử lý';
          }
          dataNextStateFilter[dataNextStateFilter.length] = newItem;
        });
        this.setState({
          listNextStates: dataNextStateFilter
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.listNextStates) {
        var data = [].concat(_toConsumableArray(nextProps.listNextStates));
        var dataFilter = data.filter(function (props) {
          return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
        });

        var dataNextState = [].concat(_toConsumableArray(dataFilter));
        var dataNextStateFilter = [];

        dataNextState.map(function (item) {
          var newItem = item;
          if (item.type == 'KET_THUC') {
            newItem.tenVietTat = 'Tự xử lý';
            newItem.ten = 'Trưởng phòng tự xử lý';
          }
          dataNextStateFilter[dataNextStateFilter.length] = newItem;
        });
        this.setState({
          listNextStates: dataNextStateFilter
        });
      }
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this3 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          var info = res.data.thongTinXuLyInfo;

          var newState = _extends({}, _this3.state);

          if (typeof info.nextState != 'undefined') {
            newState = _extends({}, _this3.state, {
              canBoChiDinh: '',
              noiDung: ''
            });
          }

          _this3.setState(_extends({}, newState));

          _this3.trigger(newState, true);
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this4 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      this.setState(_extends({}, newState), function () {
        if (name == 'nextState') {}
        _this4.trigger(newState, false);
      });
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var params = {
          nextState: {
            id: Number(stateId)
          },
          nextStateType: newState.nextState
        };

        if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien) {

          params.notice = _message.msg.xldTruongPhongGiaoViec;

          if (newState.canBoChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        } else if (newState.form_DeXuatGiaoViecLai && newState.nextState == _processType.processType.xuLyDon.processing.deXuatGiaoViecLai) {
          params.notice = _message.msg.xldTruongPhongGiaoViec;
        }

        this.props.onChange(params, isInit);
      } else {

        var _params = {};

        this.props.onChange(_params, isInit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'body-dialog-gh' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.listNextStates.length == 1 },
          _react2.default.createElement(
            'span',
            { className: 'col-100 text-13 pt25 pl20 pb10' },
            this.props.content
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30 pt20' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.listNextStates.length > 1 },
            _react2.default.createElement(_ttForms.DropDownMulipleUse, {
              className: 'col-50',
              require: true,
              data: this.state.listNextStates,
              bindValidator: this,
              selectedValue: this.state.nextState,
              label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
              name: 'huongGiaiQuyet',
              keyName: 'type',
              valueName: 'tenVietTat',
              onChange: this.handleChange.bind(this, 'nextState')
            })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              className: 'col-50',
              bindValidator: this,
              isValid: this.props.validate,
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBan,
              vaiTro: 'CHUYEN_VIEN',
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownTruongPhongChonCanBoXuLy' })
          )
        )
      );
    }
  }]);

  return TruongPhongGiaoViecPU;
}(_react2.default.Component);

TruongPhongGiaoViecPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TruongPhongGiaoViecPU));

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThuHoiGQ = exports.LanhDaoGiaoViecTTXMPU = exports.LanhDaoGiaoViecKTDXPU = exports.ThuHoiPU = exports.TruongPhongGiaoViecPU = exports.LanhDaoGiaoViecPU = undefined;

var _LanhDaoGiaoViecPU = __webpack_require__(1090);

var _LanhDaoGiaoViecPU2 = _interopRequireDefault(_LanhDaoGiaoViecPU);

var _TruongPhongGiaoViecPU = __webpack_require__(1094);

var _TruongPhongGiaoViecPU2 = _interopRequireDefault(_TruongPhongGiaoViecPU);

var _ThuHoiPU = __webpack_require__(1093);

var _ThuHoiPU2 = _interopRequireDefault(_ThuHoiPU);

var _LanhDaoGiaoViecKTDXPU = __webpack_require__(1089);

var _LanhDaoGiaoViecKTDXPU2 = _interopRequireDefault(_LanhDaoGiaoViecKTDXPU);

var _LanhDaoGiaoViecTTXMPU = __webpack_require__(1091);

var _LanhDaoGiaoViecTTXMPU2 = _interopRequireDefault(_LanhDaoGiaoViecTTXMPU);

var _ThuHoiGQ = __webpack_require__(1092);

var _ThuHoiGQ2 = _interopRequireDefault(_ThuHoiGQ);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LanhDaoGiaoViecPU = _LanhDaoGiaoViecPU2.default;
exports.TruongPhongGiaoViecPU = _TruongPhongGiaoViecPU2.default;
exports.ThuHoiPU = _ThuHoiPU2.default;
exports.LanhDaoGiaoViecKTDXPU = _LanhDaoGiaoViecKTDXPU2.default;
exports.LanhDaoGiaoViecTTXMPU = _LanhDaoGiaoViecTTXMPU2.default;
exports.ThuHoiGQ = _ThuHoiGQ2.default;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _subView = __webpack_require__(33);

var _RowItemDonDGQ = __webpack_require__(1097);

var _RowItemDonDGQ2 = _interopRequireDefault(_RowItemDonDGQ);

var _formSort = __webpack_require__(128);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DonDaGiaiQuyet = function (_React$Component) {
  _inherits(DonDaGiaiQuyet, _React$Component);

  function DonDaGiaiQuyet(props, context) {
    _classCallCheck(this, DonDaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DonDaGiaiQuyet.__proto__ || Object.getPrototypeOf(DonDaGiaiQuyet)).call(this, props, context));

    _this.state = {
      advanceSearch: false,
      tuKhoa: '',
      maDon: '',
      nguonDon: '',
      phanLoaiDon: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      tinhTrangGiaiQuyet: '',
      ketQuaGiaiQuyet: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepNhan,desc',
      data: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(DonDaGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('donDaGQ') ? JSON.parse(localStorage.getItem('donDaGQ')) : {};
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.tuKhoa = data.hoTen || '';
      if (this.state.advanceSearch) {
        this.state.nguonDon = data.nguonDon || '';
        this.state.maDon = data.maDon || '';
        this.state.phanLoaiDon = data.phanLoaiDon || '';
        this.state.tinhTrangGiaiQuyet = data.trangThaiDonToanHT || '';
        this.state.ketQuaGiaiQuyet = data.ketQuaToanHT || '';
        this.state.tiepNhanTuNgay = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.tiepNhanDenNgay = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.state.advanceSearch = true;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('donDaGQ') ? JSON.parse(localStorage.getItem('donDaGQ')) : {};
      data.advanceSearch = true;
      localStorage.setItem('donDaGQ', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.state.advanceSearch = false;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('donDaGQ') ? JSON.parse(localStorage.getItem('donDaGQ')) : {};
      data.advanceSearch = false;
      localStorage.setItem('donDaGQ', JSON.stringify(data));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.tiepNhanTuNgay, searchData.tiepNhanDenNgay].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this2 = this;

      var params = {
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('donDaGQ', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getListDonDaGiaiQuyet.request(params).then(function (res) {
        if (_this2.refs.listGQD) {
          if (res.data._embedded) {
            _this2.setState({
              data: res.data._embedded.dons,
              pageData: res.data.page
            });
          } else {
            _this2.setState({
              data: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this2.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this3 = this;

      var params = {
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });
      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('donDaGQ', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getListDonDaGiaiQuyet.request(params).then(function (res) {
        if (_this3.refs.listGQD) {
          if (res.data._embedded) {
            _this3.setState({
              data: res.data._embedded.dons,
              pageData: res.data.page
            });
          } else {
            _this3.setState({
              data: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this3.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { ref: 'listGQD' },
          _react2.default.createElement(
            'div',
            { className: 'center reception-container gqd-container' },
            _react2.default.createElement(
              'div',
              { className: 'top-content' },
              _react2.default.createElement(
                'div',
                { className: 'left-content' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-18' },
                  _react2.default.createElement('i', { className: 'tt tt-reception' }),
                  '\u0110\u01A1n \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'bottom-content' },
              _react2.default.createElement(
                'div',
                { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
                _react2.default.createElement(_subView.ListSearch, { ref: 'listSearch', advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, cookieName: 'donDaGQ' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                  'T\xECm ki\u1EBFm n\xE2ng cao'
                )
              ),
              _react2.default.createElement(_formSort.FormSort, {
                type: 'donDaGiaiQuyet',
                pageDetail: this.state.pageData,
                selectedValue: this.state.sortBy,
                onChange: this.handleChange.bind(this, 'sortBy')
              }),
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.giaiQuyetDon.listDonDaGQ,
                  dataList: this.state.data,
                  pageData: this.state.pageData,
                  parent: this,
                  hideButtonExport: true,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_RowItemDonDGQ2.default, { type: this.state.trangThaiGiaiQuyetDon, getListData: this.getListData.bind(this) })
              )
            )
          )
        )
      );
    }
  }]);

  return DonDaGiaiQuyet;
}(_react2.default.Component);

exports.default = DonDaGiaiQuyet;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDonDGQ = function (_React$Component) {
  _inherits(RowItemDonDGQ, _React$Component);

  function RowItemDonDGQ(props, context) {
    _classCallCheck(this, RowItemDonDGQ);

    var _this = _possibleConstructorReturn(this, (RowItemDonDGQ.__proto__ || Object.getPrototypeOf(RowItemDonDGQ)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: ''
    };
    return _this;
  }

  _createClass(RowItemDonDGQ, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (this.props.item.trangThaiDonInfo) {
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == userInfo.donViId;
        }).map(function (child, i) {
          _this2.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType
          });
        });
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(diachi) {
      var dungDon = [];
      if (diachi.diaChi) {
        dungDon.push(diachi.diaChi);
      }
      if (diachi.toThon) {
        dungDon.push(diachi.toThon);
      }
      if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
        dungDon.push(diachi.phuongXaCongDan.ten);
      }
      if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
        dungDon.push(diachi.quanHuyenCongDan.ten);
      }
      if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
        dungDon.push(diachi.tinhThanhCongDan.ten);
      }
      return dungDon.join(", ");
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;

      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this3 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var thoiHanXuLy = {};
      if (this.checkDonViTTXM() && this.state.ketQuaType == 'DANG_LAP_DU_THAO') {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userInfo.donViId) {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == userInfo.donViId;
          }).map(function (child, i) {

            if (child.trangThaiDonType == 'DANG_XU_LY') thoiHanXuLy = _this3.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType == 'DANG_GIAI_QUYET') thoiHanXuLy = _this3.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showThoiHanLapDuThao',
    value: function showThoiHanLapDuThao() {
      var thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      this.props.getListData();
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type == 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type == 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type == 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'getThoiHanThamTraXacMinh',
    value: function getThoiHanThamTraXacMinh() {
      var thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataNguonDon = this.props.item.trangThaiDonInfo.filter(function (nguonDon) {
        return nguonDon.donViId == userInfo.donViId;
      });

      var donId = this.props.item.donId;
      var linkToDetailPage = '/don-da-giai-quyet/da/' + donId;
      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';
      var thongTinCongDan = this.showThongTinCongDan();
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');

      var loaiDonThu = this.props.dataLoaiDonThu.filter(function (state) {
        return state.giaTri == _this4.props.item.loaiDon;
      });

      var listCanBoGiaiQuyet = this.props.item.canBoDangXuLyInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });

      var trangThaiDon = this.props.item.trangThaiDonInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });
      return _react2.default.createElement(
        'tr',
        { ref: 'itemGQD' },
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma ? this.props.item.ma : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            thongTinCongDan
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: linkToDetailPage },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (!this.checkDonViTTXM() || trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM') && (!this.checkDonViTTXM() || trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO') && trangThaiDon[0].ketQuaType != 'LUU_HO_SO' },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanXuLyDon()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: nguonDonDonVi != '' && nguonDonDonVi != null },
              _react2.default.createElement(
                'li',
                { className: 'txt-italic' },
                nguonDonDonVi
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                dataNguonDon.length > 0 ? dataNguonDon[0].trangThaiDonText : ''
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: dataNguonDon.length > 0 ? dataNguonDon[0].ketQuaType == 'DINH_CHI' ? 'Đình chỉ' : dataNguonDon[0].ketQuaStr : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_TTXM' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.getThoiHanThamTraXacMinh()
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanLapDuThao()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          listCanBoGiaiQuyet.length > 0 ? listCanBoGiaiQuyet[0].hoVaTen : ''
        )
      );
    }
  }]);

  return RowItemDonDGQ;
}(_react2.default.Component);

RowItemDonDGQ.defaultProps = {
  dataLoaiDonThu: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemDonDGQ);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonDaGiaiQuyet = undefined;

var _DonDaGiaiQuyet = __webpack_require__(1096);

var _DonDaGiaiQuyet2 = _interopRequireDefault(_DonDaGiaiQuyet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DonDaGiaiQuyet = _DonDaGiaiQuyet2.default;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _validate = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loginBg = __webpack_require__(378);

var ForgotPassword = function (_React$Component) {
  _inherits(ForgotPassword, _React$Component);

  function ForgotPassword(props, context) {
    _classCallCheck(this, ForgotPassword);

    var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props, context));

    _this.state = {
      Username: '',
      loading: false,
      isSubmit: false,
      emailValid: true
    };
    return _this;
  }

  _createClass(ForgotPassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof _reactCookie2.default.load('accessToken') != 'undefined') {
        _reactRouter.browserHistory.push('/');
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, e.target.name, e.target.value), _defineProperty(_setState, 'isSubmit', false), _defineProperty(_setState, 'emailValid', true), _setState));
    }
  }, {
    key: 'handleForgotPassword',
    value: function handleForgotPassword(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.handleValidate()) {
        var params = {
          email: this.state.Username
        };
        this.setState({ loading: true });
        _api.User.actions.sendCode.request(null, params).then(function (res) {
          _this2.setState({ loading: false });
          (0, _toastr.Toastr)('Gửi yêu cầu thành công. Vui lòng kiểm tra hộp thư điện tử để lấy lại mật khẩu.', 'success');
        }).catch(function (error) {
          _this2.setState({ loading: false });
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate() {
      this.setState({ isSubmit: true });
      var pass = true;
      if (!this.state.Username) {
        pass = false;
      } else if (!(0, _validate.checkEmail)(this.state.Username)) {
        pass = false;
        this.setState({ emailValid: false });
      }
      return pass;
    }
  }, {
    key: 'render',
    value: function render() {
      var logoImg = __webpack_require__(379);
      return _react2.default.createElement(
        'div',
        { className: 'login', style: { backgroundImage: 'url(' + loginBg + ')' } },
        _react2.default.createElement(
          'div',
          { className: 'login-block' },
          _react2.default.createElement(
            'h1',
            { className: 'logo-login' },
            _react2.default.createElement('img', { src: logoImg, alt: '', className: 'login-logo-image' }),
            _react2.default.createElement(
              'span',
              { className: 'login-logo-caption' },
              'Ph\u1EA7n m\u1EC1m v\xE0 x\xE2y d\u1EF1ng c\u01A1 s\u1EDF d\u1EEF li\u1EC7u ho\u1EA1t \u0111\u1ED9ng thanh tra tr\xEAn \u0111\u1ECBa b\xE0n T\u1EC9nh Qu\u1EA3ng Ng\xE3i'
            )
          ),
          _react2.default.createElement(
            'form',
            { className: 'login-form', onSubmit: this.handleForgotPassword.bind(this), noValidate: true },
            _react2.default.createElement(
              'h2',
              { className: 'title-login txt-blue' },
              'Qu\xEAn m\u1EADt kh\u1EA9u'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group sub-title-login' },
              'Vui l\xF2ng nh\u1EADp \u0111\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED v\xE0o \xF4 b\xEAn d\u01B0\u1EDBi \u0111\u1EC3 nh\u1EADn \u0111\u01B0\u1EE3c gi\xFAp \u0111\u1EE1'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement('span', { className: 'tt-login-mail' }),
              _react2.default.createElement('input', { className: 'login-input pt-input ' + (this.state.isSubmit && !this.state.Username ? 'pt-intent-danger' : ''),
                type: 'text', placeholder: '\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED', name: 'Username', value: this.state.Username,
                onChange: this.handleChange.bind(this), autoFocus: true, autoComplete: 'off',
                maxLength: 40 }),
              this.state.isSubmit && !this.state.Username ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.messageDefault
              ) : null,
              this.state.isSubmit && !this.state.emailValid ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.emailInvalid
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-login ' + (this.state.loading ? 'btn-loading-inline' : ''), text: 'G\u1EEDi y\xEAu c\u1EA7u' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(
                'p',
                { className: 'txt-center' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/dang-nhap', className: 'text-14 txt-blue' },
                  '\u0110\u0103ng nh\u1EADp'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ForgotPassword;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(ForgotPassword);

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgotPassword = __webpack_require__(1099);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForgotPassword2.default;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _core = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _formSort = __webpack_require__(128);

var _subView = __webpack_require__(33);

var _rowItem = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListGiaiQuyetDon = function (_React$Component) {
  _inherits(ListGiaiQuyetDon, _React$Component);

  function ListGiaiQuyetDon(props, context) {
    _classCallCheck(this, ListGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (ListGiaiQuyetDon.__proto__ || Object.getPrototypeOf(ListGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      vaiTro: '',
      trangThaiGiaiQuyetDon: 'DANG_GIAI_QUYET',
      advanceSearch: false,
      tuKhoa: '',
      maDon: '',
      nguonDon: '',
      sortBy: 'ngayTiepNhan,desc',
      isSaveTemp: false,
      phanLoaiDon: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      tinhTrangGiaiQuyet: '',
      ketQuaGiaiQuyet: '',
      phongBanXuLyXLD: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      data: _this.props.data,
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(ListGiaiQuyetDon, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var data = localStorage.getItem('gqdData') ? JSON.parse(localStorage.getItem('gqdData')) : {};
      this.state.trangThaiGiaiQuyetDon = data.trangThaiDon || 'DANG_GIAI_QUYET';
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.tuKhoa = data.hoTen || '';
      if (this.state.advanceSearch) {
        this.state.isSaveTemp = data.isSaveTemp;
        this.state.nguonDon = data.nguonDon || '';
        this.state.maDon = data.maDon || '';
        this.state.phanLoaiDon = data.phanLoaiDon || '';
        this.state.tinhTrangGiaiQuyet = data.trangThaiDonToanHT || '';
        this.state.ketQuaGiaiQuyet = data.ketQuaToanHT || '';
        this.state.tiepNhanTuNgay = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.tiepNhanDenNgay = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({ phongBanXuLyXLD: userInfo.coQuanQuanLyId });
        var vaiTro = userInfo.vaiTroMacDinh;
        this.setState({ vaiTro: vaiTro }, function () {
          _this2.getListData();
        });
      }
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.state.advanceSearch = true;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('gqdData') ? JSON.parse(localStorage.getItem('gqdData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('gqdData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.state.advanceSearch = false;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('gqdData') ? JSON.parse(localStorage.getItem('gqdData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('gqdData', JSON.stringify(data));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.tiepNhanTuNgay, searchData.tiepNhanDenNgay].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this3 = this;

      var params = {
        trangThaiDon: this.state.trangThaiGiaiQuyetDon,
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.isSaveTemp) {
        params.isSaveTemp = this.state.isSaveTemp;
      }

      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('gqdData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getGiaiQuyetDon.request(params).then(function (res) {
        if (_this3.refs.listGQD) {
          var Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons;
            _this3.setState({
              pageData: res.data.page
            });
          } else {
            _this3.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this3.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listGQD', data: Data });
          _this3.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      }).catch(function (err) {
        _this3.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.scroll(0, 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(donId) {
      var _this4 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.dTCDTX, 'success');
        _this4.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        _this4.getListData();
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this5 = this;

      var params = {
        trangThaiDon: this.state.trangThaiGiaiQuyetDon,
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });
      if (this.state.isSaveTemp) {
        params.isSaveTemp = this.state.isSaveTemp;
      }

      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('gqdData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getGiaiQuyetDon.request(params).then(function (res) {
        if (_this5.refs.listGQD) {
          var Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons;
            _this5.setState({
              pageData: res.data.page
            });
          } else {
            _this5.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this5.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listGQD', data: Data });
          _this5.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      }).catch(function (err) {
        _this5.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      });
    }
  }, {
    key: 'handleChangeTrangThaiGiaiQuyet',
    value: function handleChangeTrangThaiGiaiQuyet(e) {
      var _this6 = this;

      if (e.target.name == 'trangThaiGiaiQuyetDon') {
        var _setState2;

        localStorage.setItem('gqd.currentTab', e.target.value);
        this.setState((_setState2 = {}, _defineProperty(_setState2, e.target.name, e.target.value), _defineProperty(_setState2, 'advanceSearch', false), _defineProperty(_setState2, 'pageData', {
          number: 0,
          size: 10,
          totalElements: 0
        }), _setState2), function () {
          _this6.getListData();
        });
        this.refs.listSearch.resetData();
      } else {
        this.setState(_defineProperty({}, e.target.name, e.target.value));
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: 'listGQD' },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container gqd-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                _core.RadioGroup,
                {
                  name: 'trangThaiGiaiQuyetDon',
                  className: 'radio-gender',
                  onChange: this.handleChangeTrangThaiGiaiQuyet.bind(this),
                  selectedValue: this.state.trangThaiGiaiQuyetDon },
                _react2.default.createElement(_core.Radio, { label: 'C\xD4NG VI\u1EC6C \u0110ANG GI\u1EA2I QUY\u1EBET', value: 'DANG_GIAI_QUYET', className: 'pt-large txt-bold radio-header' }),
                _react2.default.createElement(_core.Radio, { label: 'C\xD4NG VI\u1EC6C \u0110\xC3 GI\u1EA2I QUY\u1EBET', value: 'DA_GIAI_QUYET', className: 'pt-large txt-bold radio-header' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_subView.ListSearch, { onStatus: this.state.trangThaiGiaiQuyetDon, ref: 'listSearch', advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'giaiQuyetDon',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.giaiQuyetDon.listGQD,
                dataList: this.state.data,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                search: this.state.search,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_rowItem.ListTaiLieuRowItem, { type: this.state.trangThaiGiaiQuyetDon, getListData: this.getListData.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return ListGiaiQuyetDon;
}(_react2.default.Component);

ListGiaiQuyetDon.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listGQD
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ListGiaiQuyetDon);

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _subView = __webpack_require__(33);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _dialog = __webpack_require__(18);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TuGiaiQuyetDon = function (_React$Component) {
  _inherits(TuGiaiQuyetDon, _React$Component);

  function TuGiaiQuyetDon(props, context) {
    _classCallCheck(this, TuGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (TuGiaiQuyetDon.__proto__ || Object.getPrototypeOf(TuGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      id: _this.props.params.id,
      isOpen: true,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      nameComponent: '',
      typeComponent: '',
      data: {},
      dataLichSuQuaTrinhXuLy: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: '',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      backConfirm: false,
      hasChange: false
    };
    return _this;
  }

  _createClass(TuGiaiQuyetDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDonDetail();
      this.getQuyTrinhXuLyHistory();
    }
  }, {
    key: 'getDonDetail',
    value: function getDonDetail() {
      var _this2 = this;

      var params = {
        id: this.state.id
      };

      _api.Letter.actions.getDonDetail.request(params).then(function (res) {
        if (res.data) {
          var resData = res.data;
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _api.Reception.actions.getDonInfo.request({ id: _this2.state.id }).then(function (res1) {
              if (res1.data) {
                resData = _extends({}, resData, res1.data);
              }

              _this2.setState({
                data: resData,
                loaiDon: resData.loaiDon,
                dataKetQuaXuLyDon: {
                  thamQuyenGiaiQuyet: resData.thamQuyenGiaiQuyetInfo ? resData.thamQuyenGiaiQuyetInfo.ten : ''
                }
              });
              _this2.getLichSuGiaiQuyetDon(_this2.state.id);
            });
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory() {
      var _this3 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(function (res) {
        _this3.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'getLichSuGiaiQuyetDon',
    value: function getLichSuGiaiQuyetDon(id) {
      var _this4 = this;

      var params = {
        id: id
      };
      _api.GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(function (res) {
        _this4.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
        _this4.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
        _this4.setState({
          dataLichSuGiaiQuyet: res.data
        }, function () {
          _this4.setState({
            nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
            typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
            dataKetQuaXuLyDon: _this4.state.dataKetQuaXuLyDon,
            dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo
          });
        });
        _this4.checkHideKetQuaXuLyDon();
      });
    }
  }, {
    key: 'renderWorkFollow',
    value: function renderWorkFollow() {
      switch (this.state.nameComponent) {
        case 'CanBoGiaiQuyetDonAction':
          return _react2.default.createElement(_subView.GiaiQuyetDonCanBo, {
            handleChangeData: this.handleChangeData.bind(this),
            handleBack: this.handleBack.bind(this),
            id: this.state.id,
            tuGiaiQuyet: true,
            dataGiaiQuyet: this.state.dataLichSuGiaiQuyet,
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon,
            listTaiLieuVanThuGiaiQuyetDonView: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
            dataNextStates: this.state.dataNextStates,
            coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
            updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            noiDungDonThu: this.state.data.noiDung,
            listNguoiDungDon: this.state.data.listNguoiDungDon,
            coQuanDangQuyetInfo: this.state.data.coQuanDangQuyetInfo,
            donViGiaoTTXM: this.state.donViGiaoTTXM });
        case 'CanBoTTXMAction':
          return _react2.default.createElement(_subView.NhapThongTinToTTXX, {
            handleChangeData: this.handleChangeData.bind(this),
            handleBack: this.handleBack.bind(this),
            id: this.state.id,
            tuGiaiQuyet: true,
            donInfo: this.state.data,
            dataNextStates: this.state.dataNextStates,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon });

        case 'CanBoGiaiQuyetDonLapDuThaoAction':
          if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            return _react2.default.createElement(_subView.LapDuThaoDonKhieuNaiCanBo, {
              handleChangeData: this.handleChangeData.bind(this),
              handleBack: this.handleBack.bind(this),
              id: this.state.id,
              dataNextStates: this.state.dataNextStates,
              listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
              tuGiaiQuyet: true,
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
              donInfo: this.state.data,
              thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
              isTTXMLai: this.state.data.laTTXMLai,
              updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
              thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
              saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
              loaiDon: this.state.loaiDon });
          } else {
            return _react2.default.createElement(_subView.LapDuThaoCanBo, {
              handleChangeData: this.handleChangeData.bind(this),
              handleBack: this.handleBack.bind(this),
              id: this.state.id,
              dataNextStates: this.state.dataNextStates,
              listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
              tuGiaiQuyet: true,
              listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
              listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
              listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
              listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
              donInfo: this.state.data,
              thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
              isTTXMLai: this.state.data.laTTXMLai,
              updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
              thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
              saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
              loaiDon: this.state.loaiDon });
          }

        case 'CanBoTDTHAction':
          return _react2.default.createElement(_subView.CanBoNhanYeuCauTheoDoiThucHien, {
            handleChangeData: this.handleChangeData.bind(this),
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            handleBack: this.handleBack.bind(this),
            dataNextStates: this.state.dataNextStates,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
            tuGiaiQuyet: true,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            id: this.state.id,
            postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
            updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon
          });
        case 'canBoKiemTraDeXuat':
          return _react2.default.createElement(_subView.CanBoKiemTraDeXuat, {
            handleChangeData: this.handleChangeData.bind(this),
            handleBack: this.handleBack.bind(this),
            id: this.state.id,
            tuGiaiQuyet: true,
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
            dataNextStates: this.state.dataNextStates,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
            coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
            postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon
          });
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
          return _react2.default.createElement(_subView.LapDuThaoDonKhieuNaiCanBo, {
            handleChangeData: this.handleChangeData.bind(this),
            handleBack: this.handleBack.bind(this),
            id: this.state.id,
            nhanDuThao: true,
            tuGiaiQuyet: true,
            dataNextStates: this.state.dataNextStates,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,

            updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon });
        case 'CanBoTTXMChuyenDuThaoAction':
          return _react2.default.createElement(_subView.CanBoGiaiQuyetYeuCauLapDuThao, {
            handleChangeData: this.handleChangeData.bind(this),
            handleBack: this.handleBack.bind(this),
            id: this.state.id,

            nhanDuThao: true,
            tuGiaiQuyet: true,
            donInfo: this.state.data,
            thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
            coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
            dataNextStates: this.state.dataNextStates,
            listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,

            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,

            updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
            thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
            saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
            loaiDon: this.state.loaiDon });
        default:
          return _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15 wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line pt5 pb20' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          );
      }
    }
  }, {
    key: 'checkHideKetQuaXuLyDon',
    value: function checkHideKetQuaXuLyDon() {
      var dataComponents = ['CanBoTTXMAction', 'canBoKiemTraDeXuat', 'CanBoTDTHAction', 'CanBoTTXMChuyenDuThaoAction'];
      if (dataComponents.indexOf(this.state.nameComponent) != -1) {
        this.setState({
          hideKetQuaXuLyDon: true
        });
      }
      this.setState({
        formGiaiQuyet: this.renderWorkFollow()
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.data.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this5.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.data.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this6.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      // browserHistory.goBack();
      if (this.props.fromXLD == true) {
        _reactRouter.browserHistory.push('/xu-ly-don');
      } else if (this.props.fromTDTHGQD == true) {
        _reactRouter.browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
      } else {
        _reactRouter.browserHistory.push('/giai-quyet-don');
      }
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.tuGiaiQuyetDon.request('', params).then(function (res) {
        _this7.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center' },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleBack.bind(this, false), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-detail' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_subView.ChiTietDon, { isOpen: this.state.isOpen, donId: this.state.id, loaiDon: this.state.loaiDon, dataGiaiQuyet: this.state.dataLichSuGiaiQuyet, data: this.state.data }),
          _react2.default.createElement(_subView.QuaTrinhXuLy, { parents: this })
        ),
        !this.state.hideKetQuaXuLyDon ? _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_subView.KetQuaXuLyDon, _extends({ donInfo: this.state.data, status: this.state.hideKetQuaXuLyDon }, this.state.dataKetQuaXuLyDon, { dataGiaiQuyet: this.state.dataLichSuGiaiQuyet }))
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper mb30' },
          this.state.formGiaiQuyet
        )
      );
    }
  }]);

  return TuGiaiQuyetDon;
}(_react2.default.Component);

TuGiaiQuyetDon.defaultProps = {
  fromXLD: false,
  fromTDTHGQD: false
};

exports.default = (0, _reactRedux.connect)()(TuGiaiQuyetDon);

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _subView = __webpack_require__(33);

var _upload = __webpack_require__(17);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _layout = __webpack_require__(9);

var _loading = __webpack_require__(313);

var _CheckPermission = __webpack_require__(20);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XuLyGiaiQuyetDon = function (_React$Component) {
  _inherits(XuLyGiaiQuyetDon, _React$Component);

  function XuLyGiaiQuyetDon(props, context) {
    _classCallCheck(this, XuLyGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (XuLyGiaiQuyetDon.__proto__ || Object.getPrototypeOf(XuLyGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      pageLoading: false,
      id: _this.props.params.id,
      type: _this.props.params.type,
      status: '',
      isOpen: true,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      nameComponent: '',
      typeComponent: '',
      data: {
        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: []
      },
      dataLoaiNguoiDD: [],
      dataLoaiDonThu: [],
      dataLoaiDoiTuong: [],
      dataLichSuQuaTrinhXuLy: [],
      dataDonViTTXM: [],
      dsTepDinhKem: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: 'DON_KHIEU_NAI',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      backConfirm: false,
      hasChange: false,
      hideQuaTrinhXuLy: false
    };
    return _this;
  }

  _createClass(XuLyGiaiQuyetDon, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          coQuanQuanLyNguoiDung: _extends({}, this.state.coQuanQuanLyNguoiDung, {
            id: userInfo.coQuanQuanLyId,
            ten: userInfo.tenCoQuanQuanLy
          }),
          donViGiaoTTXM: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.type == 'giai-quyet') {
        this.setState({
          isOpen: false
        });
      }
      this.getDonDetail(this.state.id);
      this.getQuyTrinhXuLyHistory(this.state.id);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.id != this.props.params.id) {
        this.getDonDetail(nextProps.params.id);
        this.getQuyTrinhXuLyHistory(nextProps.params.id);
      }
    }
  }, {
    key: 'getTrangThaiDonHienTai',
    value: function getTrangThaiDonHienTai(donId, processType) {
      var _this2 = this;

      _api.Letter.actions.getTrangThaiDon.request({ id: donId }, { quyTrinh: processType }).then(function (res) {
        if (res.data) {
          _this2.setState({ status: res.data.trangThaiDon }, function () {
            _this2.getLichSuGiaiQuyetDon(_this2.state.id);
          });
        }
        _this2.setState({ pageLoading: false });
      }).catch(function (e) {
        _this2.setState({ status: 'DA_GIAI_QUYET' });
        _this2.getLichSuGiaiQuyetDon(_this2.state.id);
        _this2.setState({ pageLoading: false });
      });
    }
  }, {
    key: 'getDonDetail',
    value: function getDonDetail(inputId) {
      var _this3 = this;

      var params = {
        id: inputId
      };
      this.setState({ pageLoading: true });
      _api.Letter.actions.getDonDetail.request(params).then(function (res) {
        if (res.data) {
          var resData = res.data;
          if (resData.canBoDangXuLyInfo) {
            _this3.setState({
              canBoDangXuLyInfo: resData.canBoDangXuLyInfo || ''
            });
          }
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _api.Reception.actions.getDonInfo.request({ id: inputId }).then(function (res1) {
              if (res1.data) {
                resData = _extends({}, resData, res1.data);
              }
              _this3.getTrangThaiDonHienTai(inputId, resData.processType);
              var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
              if (res.data.donViThamTraXacMinhInfo && res.data.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
                _this3.setState({
                  hideKetQuaXuLyDon: true
                });
              }
              _this3.setState({
                data: resData,
                loaiDon: resData.loaiDon,
                dataKetQuaXuLyDon: {
                  thamQuyenGiaiQuyet: resData.thamQuyenGiaiQuyetInfo ? resData.thamQuyenGiaiQuyetInfo.ten : ''
                }
              });
            });
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory(inputId) {
      var _this4 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: inputId }).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
        }
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'getLichSuGiaiQuyetDon',
    value: function getLichSuGiaiQuyetDon(id) {
      var _this5 = this;

      var params = {
        id: id
      };
      _api.GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(function (res) {
        _this5.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo ? res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon : '';
        _this5.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.ten : '';
        _this5.setState({
          dataLichSuGiaiQuyet: res.data,
          dataKetQuaXuLyDon: _this5.state.dataKetQuaXuLyDon,
          dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo
        }, function () {
          if (_this5.state.status == 'DA_GIAI_QUYET') {
            _this5.setState({
              nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
              typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : ''
            });
          } else {
            _this5.getCurrentForm(_this5.state.id);
          }
        });
        if (_this5.state.status == 'DA_GIAI_QUYET') {
          _this5.checkHideKetQuaXuLyDon();
        }
      });
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(id) {
      var _this6 = this;

      var params = {
        donId: id
      };
      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request(params).then(function (res) {
        if (_this6.state.data.laTTXMLai) {
          res.data.listNextStates = res.data.listNextStates.filter(function (item) {
            return item.type != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN';
          });
        }
        _this6.setState({
          nameComponent: res.data.currentForm.alias,
          dataNextStates: res.data.listNextStates
        });
        _this6.checkHideKetQuaXuLyDon();
      });
    }
  }, {
    key: 'checkAllowHandle',
    value: function checkAllowHandle() {
      var pass = (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.state.canBoDangXuLyInfo);
      return pass;
    }
  }, {
    key: 'renderWorkFollow',
    value: function renderWorkFollow() {
      var allowHandle = this.checkAllowHandle();
      if (this.state.data.trangThaiDonInfo && this.state.data.trangThaiDonInfo[0].ketQuaType != 'DINH_CHI') {
        switch (this.state.nameComponent) {
          case 'TruongPhongGiaiQuyetDonAction':
            if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
              var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
              var trangThaiDonInfo = this.state.data && this.state.data.trangThaiDonInfo && this.state.data.trangThaiDonInfo[0];
              if (trangThaiDonInfo.donViId === userInfo.donViId && (trangThaiDonInfo.ketQuaType === "LUU_HO_SO" || trangThaiDonInfo.ketQuaType === "DANG_TDTH" || trangThaiDonInfo.ketQuaType === "GIAO_TDTH")) {
                var listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView = this.state.data && this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView;
                var thongTinGiaiQuyetDonInfo = this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo;
                return _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
                  listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  dataKiemTraDeXuat: this.state.dataKiemTraDeXuat
                }, thongTinGiaiQuyetDonInfo, {
                  loaiDon: this.state.loaiDon,
                  donInfo: this.state.data,
                  thongTinGQD: thongTinGiaiQuyetDonInfo,
                  handleBack: this.handleBack.bind(this),
                  listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                  thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo
                }));
              }
              return _react2.default.createElement(_subView.KetQuaGiaiQuyetDonTruongPhong, {
                roleGQ: 'truongPhongGiaiQuyetDon',
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                dataLichSuGiaiQuyet: this.state.dataLichSuGiaiQuyet,
                dataKetQuaXuLyDon: this.state.dataKetQuaXuLyDon,
                handleBack: this.handleBack.bind(this)
              });
            } else {
              return _react2.default.createElement(_subView.GiaiQuyetDonTruongPhong, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                roleGQ: 'truongPhongGiaiQuyetDon',
                id: this.state.id,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon,
                listTaiLieuVanThuGiaiQuyetDonView: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                dataNextStates: this.state.dataNextStates,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon
              });
            }

          case 'TruongPhongNhanDuThaoVaGiaoViec':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                nhanDuThao: true,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.TruongPhongNhanBaoCaoTTXMDonKhieuNai, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                roleGQ: 'truongPhongGiaiQuyetDon',
                id: this.state.id,
                nhanDuThao: true,
                truongPhongThuHoi: this.props.truongPhongThuHoi,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                dataNextStates: this.state.dataNextStates,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                isTTXMLai: this.state.data.laTTXMLai,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon
              });
            }
          case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
            if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
              if (this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo && (this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') || this.state.typeComponent === 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
                return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                  listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
                }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  handleBack: this.handleBack.bind(this),
                  loaiDon: this.state.loaiDon
                }));
              } else {
                return _react2.default.createElement(_subView.KetQuaTruongPhongNhanBaoCaoTTXM, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  phongBanGiaiQuyetChiDinhInfo: this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetChiDinhInfo,
                  phongBanGiaiQuyetInfo: this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetInfo,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  yKienGiaoPhongBan: this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  handleBack: this.handleBack.bind(this),
                  loaiDon: this.state.loaiDon
                }));
              }
            } else {
              if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === "DON_TRANH_CHAP_DAT") {
                return _react2.default.createElement(_subView.TruongPhongNhanBaoCaoTTXMDonKhieuNai, {
                  handleChangeData: this.handleChangeData.bind(this),
                  handleBack: this.handleBack.bind(this),
                  roleGQ: 'truongPhongBanTiepCongDan',
                  id: this.state.id,
                  thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                  dataNextStates: this.state.dataNextStates,
                  truongPhongThuHoi: this.props.truongPhongThuHoi,
                  coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  isTTXMLai: this.state.data.laTTXMLai,
                  updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                  postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                  saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                  loaiDon: this.state.loaiDon
                });
              } else {
                return _react2.default.createElement(_subView.TruongPhongNhanBaoCaoTTXM, {
                  handleChangeData: this.handleChangeData.bind(this),
                  handleBack: this.handleBack.bind(this),
                  roleGQ: 'truongPhongGiaiQuyetDon',
                  truongPhongThuHoi: this.props.truongPhongThuHoi,
                  id: this.state.id,
                  thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                  dataNextStates: this.state.dataNextStates,
                  coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  isTTXMLai: this.state.data.laTTXMLai,
                  updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                  postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                  saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                  loaiDon: this.state.loaiDon
                });
              }
            }
          case 'TruongPhongNhanBaoCaoTTXMLaiVaGiaoViec':
            if (this.state.status == 'DA_GIAI_QUYET') {
              // if (this.state.typeComponent != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
              if (this.state.dataLichSuGiaiQuyet && this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo && (this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') || this.state.typeComponent === 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
                // if (this.state.loaiDon == 'DON_KHIEU_NAI') {
                //   return (
                //     <KetQuaLapDuThaoDonKhieuNaiCanBo
                //     listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
                //     listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                //     {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                //     handleBack = {this.handleBack.bind(this)}
                //     donInfo={this.state.data}
                //     thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
                //     loaiDon={this.state.loaiDon}
                //     />
                //   )
                // } else {
                return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                  listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
                }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  handleBack: this.handleBack.bind(this),
                  loaiDon: this.state.loaiDon
                }));
                // }
              } else {
                return _react2.default.createElement(_subView.KetQuaTruongPhongNhanBaoCaoTTXM, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  phongBanGiaiQuyetChiDinhInfo: this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetChiDinhInfo,
                  phongBanGiaiQuyetInfo: this.state.dataLichSuGiaiQuyet.phongBanGiaiQuyetInfo,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  yKienGiaoPhongBan: this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  handleBack: this.handleBack.bind(this),
                  loaiDon: this.state.loaiDon
                }));
              }
              // } else {
              //   return(
              //     <KetQuaLapDuThaoDonKhieuNaiCanBo
              //       listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              //       {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //       loaiDon={this.state.loaiDon}
              //       donInfo={this.state.data}
              //       thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //       handleBack = {this.handleBack.bind(this)}
              //     />
              //   )
              // }
            } else {
              if (this.state.loaiDon == 'DON_KHIEU_NAI') {
                return _react2.default.createElement(_subView.TruongPhongNhanBaoCaoTTXMDonKhieuNai, {
                  handleChangeData: this.handleChangeData.bind(this),
                  handleBack: this.handleBack.bind(this),
                  roleGQ: 'truongPhongGiaiQuyetDon',
                  id: this.state.id,
                  thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                  dataNextStates: this.state.dataNextStates,
                  truongPhongThuHoi: this.props.truongPhongThuHoi,
                  coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  isTTXMLai: this.state.data.laTTXMLai,
                  updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                  postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                  saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                  loaiDon: this.state.loaiDon
                });
              } else {
                return _react2.default.createElement(_subView.TruongPhongNhanBaoCaoTTXM, {
                  handleChangeData: this.handleChangeData.bind(this),
                  handleBack: this.handleBack.bind(this),
                  roleGQ: 'truongPhongGiaiQuyetDon',
                  truongPhongThuHoi: this.props.truongPhongThuHoi,
                  id: this.state.id,
                  thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                  dataNextStates: this.state.dataNextStates,
                  coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  donInfo: this.state.data,
                  thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  isTTXMLai: this.state.data.laTTXMLai,
                  updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                  postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                  saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                  loaiDon: this.state.loaiDon
                });
              }
            }
          case 'CanBoGiaiQuyetDonAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                loaiDon: this.state.loaiDon }));
            } else {
              return _react2.default.createElement(_subView.GiaiQuyetDonCanBo, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataGiaiQuyet: this.state.dataLichSuGiaiQuyet,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon,
                listTaiLieuVanThuGiaiQuyetDonView: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                dataNextStates: this.state.dataNextStates,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                noiDungDonThu: this.state.data.noiDung,
                listNguoiDungDon: this.state.data.listNguoiDungDon,
                coQuanDangQuyetInfo: this.state.data.coQuanDangQuyetInfo,
                donViGiaoTTXM: this.state.donViGiaoTTXM });
            }
          case 'CanBoGiaiQuyetDonKhongQuyTrinh':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                loaiDon: this.state.loaiDon }));
            } else {
              return _react2.default.createElement(_subView.GiaiQuyetDonCanBo, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataGiaiQuyet: this.state.dataLichSuGiaiQuyet,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon,
                listTaiLieuVanThuGiaiQuyetDonView: this.state.data.listTaiLieuVanThuGiaiQuyetDonView,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                dataNextStates: this.state.dataNextStates,
                nameComponent: this.state.nameComponent,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                noRule: true,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                noiDungDonThu: this.state.data.noiDung,
                listNguoiDungDon: this.state.data.listNguoiDungDon,
                coQuanDangQuyetInfo: this.state.data.coQuanDangQuyetInfo,
                donViGiaoTTXM: this.state.donViGiaoTTXM });
            }
          case 'CanBoNhapLieuGiaiQuyetDonAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaGiaiQuyetDonCanBoNhapLieu, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                yKienGiaiQuyet: this.state.dataLichSuGiaiQuyet.yKienGiaiQuyet,
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                handleBack: this.handleBack.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon }));
            } else {
              return _react2.default.createElement(_subView.GiaiQuyetDonCanBoNhapLieu, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                dataNextStates: this.state.dataNextStates,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDon,
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this)
              });
            }
          case 'LanhDaoTTXMAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaGiaiQuyetDonTruongPhong, _extends({
                roleGQ: 'truongPhongTTXM',
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                handleBack: this.handleBack.bind(this),
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                listTaiLieuVanThu: this.state.data.listTaiLieuVanThu,
                dataLichSuGiaiQuyet: this.state.dataLichSuGiaiQuyet
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                loaiDon: this.state.loaiDon
              }));
            }
            break;
          case 'TruongPhongTTXMAction':
            if (!allowHandle || this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaGiaiQuyetDonTruongPhong, _extends({
                roleGQ: 'truongPhongTTXM',
                id: this.state.id,
                handleBack: this.handleBack.bind(this)
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                dataLichSuGiaiQuyet: this.state.dataLichSuGiaiQuyet,
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.GiaiQuyetDonTruongPhong, {
                alias: this.state.nameComponent,
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                truongPhongThuHoi: this.props.truongPhongThuHoi,
                roleGQ: 'truongPhongTTXM',
                id: this.state.id,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                dataNextStates: this.state.dataNextStates,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                loaiDon: this.state.loaiDon
              });
            }
          case 'CanBoTTXMAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaNhapThongTinToTTXM, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.NhapThongTinToTTXX, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                loaiDon: this.state.loaiDon });
            }
          case 'CanBoTTXMKhongQuyTrinh':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaNhapThongTinToTTXM, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.NhapThongTinToTTXX, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataNextStates: this.state.dataNextStates,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            }

          case 'CanBoTTXMChuyenDuThaoKhongQuyTrinh':
          case 'CanBoTTXMChuyenDuThaoAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaCanBoGiaiQuyetYeuCauLapDuThao, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
              }));
            } else {
              return _react2.default.createElement(_subView.CanBoGiaiQuyetYeuCauLapDuThao, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,

                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            }
          case 'TruongPhongTTXMNhanYeuCauVaGiaoViecAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaCanBoGiaiQuyetYeuCauLapDuThao, _extends({}, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.TruongPhongNhanYeuCauDoiThoai, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                truongPhongThuHoi: this.props.truongPhongThuHoi,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,

                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            }
          case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
          case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                nhanDuThao: true,
                loaiDon: this.state.loaiDon
              }));
            } else {
              return _react2.default.createElement(_subView.LapDuThaoDonKhieuNaiCanBo, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                nhanDuThao: true,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            }

          case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
          case 'CanBoGiaiQuyetDonLapDuThaoAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              // if (this.state.loaiDon == 'DON_KHIEU_NAI') {
              //   return (
              //     <KetQuaLapDuThaoDonKhieuNaiCanBo
              //       listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
              //       handleBack = {this.handleBack.bind(this)}
              //       donInfo={this.state.data}
              //       thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //       listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              //       {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //       loaiDon={this.state.loaiDon}
              //     />
              //   )
              // } else {
              return _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                loaiDon: this.state.loaiDon
              }));
              // }
            } else if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon === "DON_TRANH_CHAP_DAT") {
              return _react2.default.createElement(_subView.LapDuThaoDonKhieuNaiCanBo, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                isTTXMLai: this.state.data.laTTXMLai,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            } else {
              return _react2.default.createElement(_subView.LapDuThaoCanBo, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                dataNextStates: this.state.dataNextStates,
                postTaiLieuVanThu: this.postTaiLieuVanThu.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                isTTXMLai: this.state.data.laTTXMLai,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon });
            }
          case 'truongPhongKiemTraDeXuat':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaGiaiQuyetDonTruongPhong, _extends({
                roleGQ: 'truongPhongKiemTraDeXuat',
                id: this.state.id,
                handleBack: this.handleBack.bind(this),
                loaiDon: this.state.loaiDon,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                dataLichSuGiaiQuyet: this.state.dataLichSuGiaiQuyet,
                dataKetQuaXuLyDon: this.state.dataKetQuaXuLyDon
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo));
            } else {
              return _react2.default.createElement(_subView.TruongPhongKiemTraDeXuat, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                roleGQ: 'truongPhongKiemTraDeXuat',
                id: this.state.id,
                truongPhongThuHoi: this.props.truongPhongThuHoi,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataNextStates: this.state.dataNextStates,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon
              });
            }
          case 'canBoKiemTraDeXuatKhongQuyTrinh':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaCanBoKiemTraDeXuat, _extends({
                loaiDon: this.state.loaiDon,
                handleBack: this.handleBack.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo
              }));
            } else {
              return _react2.default.createElement(_subView.CanBoKiemTraDeXuat, {
                khongQuyTrinh: true,
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataNextStates: this.state.dataNextStates,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon
              });
            }
          case 'canBoTDTHKhongQuyTrinh':
          case 'CanBoTDTHAction':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                handleBack: this.handleBack.bind(this)
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo
              }));
            } else {
              return _react2.default.createElement(_subView.CanBoNhanYeuCauTheoDoiThucHien, {
                handleChangeData: this.handleChangeData.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                handleBack: this.handleBack.bind(this),
                dataNextStates: this.state.dataNextStates,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                dataDetail: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                loaiDon: this.state.loaiDon
              });
            }
          case 'TruongPhongTDTHAction':
            if (!allowHandle || this.state.status === 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                loaiDon: this.state.loaiDon,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                handleBack: this.handleBack.bind(this),
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo
              }));
            } else {
              return _react2.default.createElement(_subView.TruongPhongNhanYeuCauTheoDoiThucHien, {
                handleChangeData: this.handleChangeData.bind(this),
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                handleBack: this.handleBack.bind(this),
                truongPhongThuHoi: this.props.truongPhongThuHoi,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                dataNextStates: this.state.dataNextStates,
                updateGiaiQuyetDon: this.updateGiaiQuyetDon.bind(this),
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                dataDetail: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                loaiDon: this.state.loaiDon
              });
            }
          case 'canBoKiemTraDeXuat':
            if (this.state.status == 'DA_GIAI_QUYET') {
              return _react2.default.createElement(_subView.KetQuaCanBoKiemTraDeXuat, _extends({
                loaiDon: this.state.loaiDon,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                handleBack: this.handleBack.bind(this),
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo
              }, this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuBoSungHoSo: this.state.data.listTaiLieuVanThuBoSungHoSo,
                thongTinYeuCauKiemTraDeXuat: this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo
              }));
            } else {
              return _react2.default.createElement(_subView.CanBoKiemTraDeXuat, {
                handleChangeData: this.handleChangeData.bind(this),
                handleBack: this.handleBack.bind(this),
                id: this.state.id,
                donInfo: this.state.data,
                thongTinGQD: this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo,
                thongTinGiaiQuyetDonId: this.state.data.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.state.data.listTaiLieuVanThuKiemTraDeXuat,
                dataNextStates: this.state.dataNextStates,
                dataKiemTraDeXuat: this.state.dataKiemTraDeXuat,
                coQuanQuanLyNguoiDung: this.state.coQuanQuanLyNguoiDung,
                postGiaiQuyetDon: this.postGiaiQuyetDon.bind(this),
                saveGiaiQuyetDon: this.saveGiaiQuyetDon.bind(this),
                loaiDon: this.state.loaiDon
              });
            }
          default:
            return _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb20' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom col-100' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                )
              )
            );
        }
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15 wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Th\xF4ng tin \u0111\xE3 gi\u1EA3i quy\u1EBFt'
          ),
          _react2.default.createElement(
            'div',
            { className: 'txt-bold text-13 mb15 txt-upper' },
            '\u0110\xECnh ch\u1EC9'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mb10' },
            _react2.default.createElement(_common.Text, { className: 'col-100 mb5', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: this.state.data.lyDoDinhChi }),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.state.data.listTaiLieuVanThu, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mb20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        );
      }
    }
  }, {
    key: 'checkHideKetQuaXuLyDon',
    value: function checkHideKetQuaXuLyDon() {
      if (this.state.nameComponent == 'canBoKiemTraDeXuat' || this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh' || this.state.nameComponent == 'truongPhongKiemTraDeXuat') {
        this.setState({
          hideKetQuaXuLyDon: true
        });
      }
      if (this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh') {
        this.setState({
          hideQuaTrinhXuLy: true
        });
      }
      this.setState({
        formGiaiQuyet: this.renderWorkFollow()
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.data.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this7.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.data.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this8.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      if (this.props.route.name == 'theodoi') {
        _reactRouter.browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
      } else if (this.props.route.name == 'dagiaiquyet') {
        _reactRouter.browserHistory.push('/don-da-giai-quyet');
      } else {
        _reactRouter.browserHistory.push('/giai-quyet-don');
      }
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this9.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        this.onClickClose();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.onClickClose();
        }
      }
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          null,
          this.state.pageLoading ? _react2.default.createElement(_loading.Loading, null) : '',
          _react2.default.createElement(
            'div',
            { className: 'center ' + (this.state.pageLoading ? 'hidden' : '') },
            _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
              title: _message.msg.confirmBack }),
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleBack.bind(this, false), title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-detail' },
                'Th\xF4ng tin gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'page-wrapper' },
              _react2.default.createElement(_subView.ChiTietDon, { listTLBC: this.props.listTLBC, isOpen: this.state.isOpen, donId: this.state.id, loaiDon: this.state.loaiDon, dataGiaiQuyet: this.state.dataLichSuGiaiQuyet, data: this.state.data }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.hideQuaTrinhXuLy != true },
                _react2.default.createElement(_subView.QuaTrinhXuLy, { parents: this })
              )
            ),
            !this.state.hideKetQuaXuLyDon ? _react2.default.createElement(
              'div',
              { className: 'page-wrapper' },
              _react2.default.createElement(_subView.KetQuaXuLyDon, _extends({ donInfo: this.state.data, status: this.state.hideKetQuaXuLyDon }, this.state.dataKetQuaXuLyDon, { dataGiaiQuyet: this.state.dataLichSuGiaiQuyet }))
            ) : null,
            _react2.default.createElement(
              'div',
              { className: 'page-wrapper mb30' },
              this.renderWorkFollow()
            )
          )
        )
      );
    }
  }]);

  return XuLyGiaiQuyetDon;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(XuLyGiaiQuyetDon);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailTaiLieuRowItem = function (_React$Component) {
  _inherits(DetailTaiLieuRowItem, _React$Component);

  function DetailTaiLieuRowItem(props, context) {
    _classCallCheck(this, DetailTaiLieuRowItem);

    var _this = _possibleConstructorReturn(this, (DetailTaiLieuRowItem.__proto__ || Object.getPrototypeOf(DetailTaiLieuRowItem)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DetailTaiLieuRowItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'tinhTrangTaiLieuList',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var TinhTrangTaiLieu = this.state.data.filter(function (state) {
        return state.giaTri == _this3.props.item.tinhTrangTaiLieu;
      });
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count ? this.props.count : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          TinhTrangTaiLieu.length > 0 ? TinhTrangTaiLieu[0].ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: _jsFileDownload2.default.bind(this, this.props.item.duongDan, this.props.item.tenFile) },
              this.props.item.tenFile ? this.props.item.tenFile : '',
              ' '
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: function onClick() {
                  (0, _utils.downloadFile)(_this3.props.item.duongDan, _this3.props.item.tenFile);
                } },
              this.props.item.tenFile ? this.props.item.tenFile : '',
              ' '
            )
          )
        )
      );
    }
  }]);

  return DetailTaiLieuRowItem;
}(_react2.default.Component);

DetailTaiLieuRowItem.defaultProps = {
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.tinhTrangTaiLieuList
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DetailTaiLieuRowItem);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListAttachTaiLieuRowItem = function (_React$Component) {
  _inherits(ListAttachTaiLieuRowItem, _React$Component);

  function ListAttachTaiLieuRowItem() {
    _classCallCheck(this, ListAttachTaiLieuRowItem);

    return _possibleConstructorReturn(this, (ListAttachTaiLieuRowItem.__proto__ || Object.getPrototypeOf(ListAttachTaiLieuRowItem)).apply(this, arguments));
  }

  _createClass(ListAttachTaiLieuRowItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count ? this.props.count : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soQuyetDinh ? this.props.item.soQuyetDinh : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayQuyetDinh ? (0, _moment2.default)(this.props.item.ngayQuyetDinh).format("DD/MM/YYYY") : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: _jsFileDownload2.default.bind(this, this.props.item.duongDan, this.props.item.tenFile) },
              this.props.item.tenFile ? this.props.item.tenFile : '',
              ' '
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: function onClick() {
                  (0, _utils.downloadFile)(_this2.props.item.duongDan, _this2.props.item.tenFile);
                } },
              this.props.item.tenFile ? this.props.item.tenFile : '',
              ' '
            )
          )
        )
      );
    }
  }]);

  return ListAttachTaiLieuRowItem;
}(_react2.default.Component);

exports.default = ListAttachTaiLieuRowItem;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListHistoryDetailRowItem = function (_React$Component) {
  _inherits(ListHistoryDetailRowItem, _React$Component);

  function ListHistoryDetailRowItem(props, context) {
    _classCallCheck(this, ListHistoryDetailRowItem);

    var _this = _possibleConstructorReturn(this, (ListHistoryDetailRowItem.__proto__ || Object.getPrototypeOf(ListHistoryDetailRowItem)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListHistoryDetailRowItem, [{
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          oldValue = _props$item.oldValue,
          newValue = _props$item.newValue,
          propertyName = _props$item.propertyName;

      var fileNameOld = oldValue.substr(0, oldValue.indexOf("tcx@"));
      var fileNameNew = newValue.substr(0, newValue.indexOf("tcx@"));
      var oldValueLen = oldValue.length;
      var newValueLen = newValue.length;
      var oldValueDuongDan = oldValue.substr(oldValue.indexOf("http://"), oldValueLen);
      var newValueDuongDan = newValue.substr(newValue.indexOf("http://"), newValueLen);
      return _react2.default.createElement(
        'tr',
        { className: 'row-list-items-giaiquyetdon' },
        _react2.default.createElement(
          'td',
          null,
          this.props.count ? this.props.count : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          propertyName
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.isVanBan },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !_config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(this, oldValueDuongDan, fileNameOld) },
                fileNameOld
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: function onClick() {
                    (0, _utils.downloadFile)(oldValueDuongDan, fileNameOld);
                  } },
                fileNameOld
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.isVanBan },
            oldValue === 'null' ? '' : oldValue
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.isVanBan },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !_config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(this, newValueDuongDan, fileNameNew) },
                fileNameNew
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: _config.checkServerLive },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-blue txt-underline', onClick: function onClick() {
                    (0, _utils.downloadFile)(newValueDuongDan, fileNameNew);
                  } },
                fileNameNew
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.isVanBan },
            newValue
          )
        )
      );
    }
  }]);

  return ListHistoryDetailRowItem;
}(_react2.default.Component);

exports.default = ListHistoryDetailRowItem;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListHistoryRowItem = function (_React$Component) {
  _inherits(ListHistoryRowItem, _React$Component);

  function ListHistoryRowItem(props, context) {
    _classCallCheck(this, ListHistoryRowItem);

    var _this = _possibleConstructorReturn(this, (ListHistoryRowItem.__proto__ || Object.getPrototypeOf(ListHistoryRowItem)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListHistoryRowItem, [{
    key: 'handleClickDetail',
    value: function handleClickDetail() {
      this.props.handleViewDetail(this.props.item);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        { className: 'row-list-items-giaiquyetdon' },
        _react2.default.createElement(
          'td',
          null,
          this.props.count ? this.props.count : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.noiDung
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.hoTenCongChucThayDoi,
          _react2.default.createElement('br', null),
          '\u0110\u01A1n v\u1ECB: ',
          this.props.item.donViCongChucThayDoi,
          _react2.default.createElement('br', null),
          'V\xE0o l\xFAc ',
          (0, _moment2.default)(this.props.item.ngaySua).format('HH:mm:ss [ngày] DD/MM/YYYY')
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleClickDetail.bind(this) },
            'Xem chi ti\u1EBFt'
          )
        )
      );
    }
  }]);

  return ListHistoryRowItem;
}(_react2.default.Component);

exports.default = ListHistoryRowItem;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _utils = __webpack_require__(4);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _CheckQuyenTuXuLy = __webpack_require__(193);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListTaiLieuRowItem = function (_React$Component) {
  _inherits(ListTaiLieuRowItem, _React$Component);

  function ListTaiLieuRowItem(props, context) {
    _classCallCheck(this, ListTaiLieuRowItem);

    var _this = _possibleConstructorReturn(this, (ListTaiLieuRowItem.__proto__ || Object.getPrototypeOf(ListTaiLieuRowItem)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: ''
    };
    return _this;
  }

  _createClass(ListTaiLieuRowItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (this.props.item.trangThaiDonInfo) {
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == userInfo.donViId;
        }).map(function (child, i) {
          _this2.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType
          });
        });
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(diachi) {
      var dungDon = [];
      if (diachi.diaChi) {
        dungDon.push(diachi.diaChi);
      }
      if (diachi.toThon) {
        dungDon.push(diachi.toThon);
      }
      if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
        dungDon.push(diachi.phuongXaCongDan.ten);
      }
      if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
        dungDon.push(diachi.quanHuyenCongDan.ten);
      }
      if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
        dungDon.push(diachi.tinhThanhCongDan.ten);
      }
      return dungDon.join(", ");
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;

      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this3 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var thoiHanXuLy = {};
      if (this.checkDonViTTXM() && this.state.ketQuaType == 'DANG_LAP_DU_THAO') {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userInfo.donViId) {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == userInfo.donViId;
          }).map(function (child, i) {

            if (child.trangThaiDonType == 'DANG_XU_LY') thoiHanXuLy = _this3.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType == 'DANG_GIAI_QUYET') thoiHanXuLy = _this3.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showThoiHanLapDuThao',
    value: function showThoiHanLapDuThao() {
      var thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      this.props.getListData();
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type == 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type == 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type == 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'checkAllowHandle',
    value: function checkAllowHandle() {
      var pass = (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.item.canBoDangXuLyInfo);
      return pass;
    }
  }, {
    key: 'getThoiHanThamTraXacMinh',
    value: function getThoiHanThamTraXacMinh() {
      var thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkQuyenBoSungThongTin',
    value: function checkQuyenBoSungThongTin() {
      var data = [].concat(_toConsumableArray(this.props.item.listLichSuCanBoXuLy));
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataCheck = data.filter(function (state) {
        return state.congChucId == userInfo.id;
      });

      if (dataCheck.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataNguonDon = this.props.item.trangThaiDonInfo.filter(function (nguonDon) {
        return nguonDon.donViId == userInfo.donViId;
      });

      var allowHandle = this.checkAllowHandle();

      var donId = this.props.item.donId;
      var linkToDetailPage = '/giai-quyet-don/chi-tiet/' + donId;
      var linkToHandle = '/giai-quyet-don/giai-quyet/' + donId;
      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';
      var thongTinCongDan = this.showThongTinCongDan();
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      var nguonDontype = this.checkNguonDon('nguonDontype');

      var loaiDonThu = this.props.dataLoaiDonThu.filter(function (state) {
        return state.giaTri == _this4.props.item.loaiDon;
      });
      var showDelete = this.props.item.donViXuLyGiaiQuyetInfo && userInfo.donViId == this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId;
      var listCanBoGiaiQuyet = this.props.item.canBoDangXuLyInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });

      var trangThaiDon = this.props.item.trangThaiDonInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });
      return _react2.default.createElement(
        'tr',
        { ref: 'itemGQD' },
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma ? this.props.item.ma : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            thongTinCongDan
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: linkToDetailPage },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (!this.checkDonViTTXM() || trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM' && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM_LAI') && (!this.checkDonViTTXM() || trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO') && trangThaiDon[0].ketQuaType != 'LUU_HO_SO' },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanXuLyDon()
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.lyDoQuaHan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: nguonDonDonVi != '' && nguonDonDonVi != null },
              _react2.default.createElement(
                'li',
                { className: 'txt-italic' },
                nguonDonDonVi
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                dataNguonDon.length > 0 ? dataNguonDon[0].trangThaiDonText : ''
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: dataNguonDon.length > 0 ? dataNguonDon[0].ketQuaType == 'DINH_CHI' ? 'Đình chỉ' : dataNguonDon[0].ketQuaStr : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_TTXM' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.getThoiHanThamTraXacMinh()
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanLapDuThao()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          listCanBoGiaiQuyet.length > 0 ? listCanBoGiaiQuyet[0].hoVaTen : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.huongXuLyXLD != 'DINH_CHI' && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'LUU_HO_SO' && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DINH_CHI' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: allowHandle && this.props.type != 'DA_GIAI_QUYET' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'itt-redirect', to: linkToHandle },
                    'X\u1EED l\xFD'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.tuGiaiQuyet && this.props.type == 'DA_GIAI_QUYET' && (0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(this.props.item.quyenTuXuLyInfo) },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'itt-redirect', to: '/tu-giai-quyet-don/' + this.props.item.donId },
                    'T\u1EF1 x\u1EED l\xFD'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.type == 'DA_GIAI_QUYET' && this.props.item.canBoCoTheThuHoiInfo != null && this.props.item.canBoCoTheThuHoiInfo.giaTri == userInfo.id },
                _react2.default.createElement(_dialog.TruongPhongThuHoiDialog, { id: donId, thongTinGiaiQuyetDonId: this.props.item.thongTinGiaiQuyetDonId, loaiDon: this.props.item.loaiDon, getListData: this.getListData.bind(this) })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nguonDontype != 'GIAO_TTXM' && !this.props.item.dangGiaoKTDX && this.props.item.processType != 'THEO_DOI_THUC_HIEN' && this.props.item.processType == 'GIAI_QUYET_DON' && trangThaiDon.length > 0 && trangThaiDon[0].trangThaiDonType != 'DA_GIAI_QUYET' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.item.loaiDon == 'DON_TO_CAO' },
                  _react2.default.createElement(_dialog.GiaHanDialog, { id: donId, thongTinGiaiQuyetDonId: this.props.item.thongTinGiaiQuyetDonId, loaiDon: this.props.item.loaiDon, getListData: this.getListData.bind(this) })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.item.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH' && !this.props.item.ma },
                  _react2.default.createElement(_dialog.SuspendedDialog, { id: donId, loaiDon: this.props.item.loaiDon, getListData: this.getListData.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.huongXuLyXLD != 'DINH_CHI' && this.checkQuyenBoSungThongTin() && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType == 'LUU_HO_SO' && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DINH_CHI' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: '/bo-sung-thong-tin-giai-quyet-don/' + this.props.item.donId },
                  'B\u1ED5 sung th\xF4ng tin'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('GIAIQUYETDON_XOA') && showDelete },
              _react2.default.createElement(
                'div',
                { className: 'mt10' },
                _react2.default.createElement(_dialog.DeleteDialog, {
                  title: 'Xoá đơn thư',
                  content: 'Bạn có đồng ý xóa đơn thư này không?',
                  redux: this.props.parent,
                  deleteId: this.props.item.donId
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ListTaiLieuRowItem;
}(_react2.default.Component);

ListTaiLieuRowItem.defaultProps = {
  dataLoaiDonThu: [],
  tuGiaiQuyet: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ListTaiLieuRowItem);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachDoanDongNguoi = function (_React$Component) {
  _inherits(RowItemDanhSachDoanDongNguoi, _React$Component);

  function RowItemDanhSachDoanDongNguoi() {
    _classCallCheck(this, RowItemDanhSachDoanDongNguoi);

    return _possibleConstructorReturn(this, (RowItemDanhSachDoanDongNguoi.__proto__ || Object.getPrototypeOf(RowItemDanhSachDoanDongNguoi)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachDoanDongNguoi, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { textAlign: 'center' } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.hoVaTen
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.cmndHoChieu
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.diaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soDienThoai
        )
      );
    }
  }]);

  return RowItemDanhSachDoanDongNguoi;
}(_react2.default.Component);

exports.default = RowItemDanhSachDoanDongNguoi;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockBanHanhQuyetDinhView = function (_React$Component) {
  _inherits(BlockBanHanhQuyetDinhView, _React$Component);

  function BlockBanHanhQuyetDinhView() {
    _classCallCheck(this, BlockBanHanhQuyetDinhView);

    return _possibleConstructorReturn(this, (BlockBanHanhQuyetDinhView.__proto__ || Object.getPrototypeOf(BlockBanHanhQuyetDinhView)).apply(this, arguments));
  }

  _createClass(BlockBanHanhQuyetDinhView, [{
    key: 'render',
    value: function render() {
      var DataDetail = this.props.thongTinGQD || {};
      var donInfo = this.props.donInfo || {};
      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == DataDetail.ketLuanNoiDungKhieuNai;
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: donInfo.loaiDon == 'DON_TO_CAO' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: donInfo.loaiDon == 'DON_KHIEU_NAI' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: donInfo.loaiDon != 'DON_TO_CAO' && donInfo.loaiDon != 'DON_KHIEU_NAI' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mb15' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: DataDetail.soVuGiaiQuyetKhieuNai || 0 }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: donInfo.loaiDon == 'DON_KHIEU_NAI' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: donInfo.loaiDon == 'DON_TO_CAO' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: donInfo.loaiDon != 'DON_TO_CAO' && donInfo.loaiDon != 'DON_KHIEU_NAI' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB ph\u1EA3n \xE1nh:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: DataDetail.ketQuaGiaiQuyetKhac ? DataDetail.ketQuaGiaiQuyetKhac : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mb5' },
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: DataDetail.tienPhaiThuNhaNuocQDGQ || 0 }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: DataDetail.datPhaiThuNhaNuocQDGQ || 0 })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: DataDetail.tienPhaiTraCongDanQDGQ || 0 }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: DataDetail.datPhaiTraCongDanQDGQ || 0 })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'X\u1EED l\xFD h\xE0nh ch\xEDnh'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: DataDetail.tongSoNguoiXuLyHanhChinh || 0 }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: DataDetail.soNguoiDaBiXuLyHanhChinh || 0 }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: DataDetail.soNguoiDuocTraLaiQuyenLoi || 0 })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 mb5' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: DataDetail.soVuGiaoCoQuanDieuTra || 0 }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: DataDetail.soDoiTuongGiaoCoQuanDieuTra || 0 })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.khoiTo },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 mb5' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Kh\u1EDFi t\u1ED1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: DataDetail.soVuBiKhoiTo || 0 }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: DataDetail.soDoiTuongBiKhoiTo || 0 })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
          _react2.default.createElement(
            'h3',
            { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
            'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-25 pl0 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: DataDetail.soVanBan || '' }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: DataDetail.ngayBanHanh ? (0, _moment2.default)(DataDetail.ngayBanHanh).format('DD/MM/YYYY') : '' }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: DataDetail.nguoiBanHanhInfo ? DataDetail.nguoiBanHanhInfo.hoVaTen : '' }),
          _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl0 mb15', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: DataDetail.lyDoBanHanhQuyetDinhDinhChi || '' }),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        )
      );
    }
  }]);

  return BlockBanHanhQuyetDinhView;
}(_react2.default.Component);

BlockBanHanhQuyetDinhView.defaultProps = {
  donInfo: {},
  thongTinGQD: {}
};

exports.default = BlockBanHanhQuyetDinhView;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockBaoCaoKQTTXM = function (_React$Component) {
  _inherits(BlockBaoCaoKQTTXM, _React$Component);

  function BlockBaoCaoKQTTXM() {
    _classCallCheck(this, BlockBaoCaoKQTTXM);

    return _possibleConstructorReturn(this, (BlockBaoCaoKQTTXM.__proto__ || Object.getPrototypeOf(BlockBaoCaoKQTTXM)).apply(this, arguments));
  }

  _createClass(BlockBaoCaoKQTTXM, [{
    key: 'render',
    value: function render() {
      var donInfo = this.props.donInfo ? this.props.donInfo : {};
      var thongTinGQD = this.props.thongTinGQD ? this.props.thongTinGQD : {};
      var _noiDung = thongTinGQD.noiDung ? thongTinGQD.noiDung : '';
      var _ngayBaoCaoKQ = thongTinGQD.ngayTraBaoCaoTTXM ? (0, _moment2.default)(thongTinGQD.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '';
      var _tgBaoCaoKQ = thongTinGQD.ngayHetHanTTXM ? (0, _moment2.default)(thongTinGQD.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
      if (donInfo.laTTXMLai) {
        _ngayBaoCaoKQ = donInfo.ngayTraBaoCaoTTXMLanDau ? (0, _moment2.default)(donInfo.ngayTraBaoCaoTTXMLanDau).format('DD/MM/YYYY') : '';
        _tgBaoCaoKQ = donInfo.ngayHetHanTTXMLanDau ? (0, _moment2.default)(donInfo.ngayHetHanTTXMLanDau).format('DD/MM/YYYY') : '';
        _noiDung = thongTinGQD.noiDungTraBaoCaoTTXMLan1 || '';
      }
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var showKQTTXMLai = false;

      if (donInfo.trangThaiDonInfo.length) {
        donInfo.trangThaiDonInfo.map(function (item) {
          if (userInfo.donViId == item.donViId && item.ketQuaType != 'DANG_TTXM') {
            showKQTTXMLai = true;
          }
        });
      }
      var lb1 = donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất:' : 'TTXM:';
      var lb2 = donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'div',
        { className: !thongTinGQD.donViThamTraXacMinhInfo ? 'hidden' : '' },
        _react2.default.createElement(
          'h3',
          { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
          lb2
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 mb10 no-gutter' },
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Đơn vị ' + lb1, value: thongTinGQD.donViThamTraXacMinhInfo ? thongTinGQD.donViThamTraXacMinhInfo.ten : '' }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: _tgBaoCaoKQ }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: _ngayBaoCaoKQ }),
          _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: _noiDung })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: donInfo.laTTXMLai == true && showKQTTXMLai },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter pt10 pb10' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'h3',
            { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
            'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
            lb2,
            ' l\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 mb10 no-gutter' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Đơn vị ' + lb1, value: thongTinGQD.donViThamTraXacMinhInfo ? thongTinGQD.donViThamTraXacMinhInfo.ten : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: thongTinGQD.ngayHetHanTTXM ? (0, _moment2.default)(thongTinGQD.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: thongTinGQD.ngayTraBaoCaoTTXM ? (0, _moment2.default)(thongTinGQD.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: thongTinGQD.noiDungTraBaoCaoTTXMLan2 || '' })
          )
        )
      );
    }
  }]);

  return BlockBaoCaoKQTTXM;
}(_react2.default.Component);

BlockBaoCaoKQTTXM.defaultProps = {
  donInfo: {}
};

exports.default = BlockBaoCaoKQTTXM;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockGiaiQuyetDonInfo = function (_React$Component) {
  _inherits(BlockGiaiQuyetDonInfo, _React$Component);

  function BlockGiaiQuyetDonInfo() {
    _classCallCheck(this, BlockGiaiQuyetDonInfo);

    return _possibleConstructorReturn(this, (BlockGiaiQuyetDonInfo.__proto__ || Object.getPrototypeOf(BlockGiaiQuyetDonInfo)).apply(this, arguments));
  }

  _createClass(BlockGiaiQuyetDonInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('modules/giai-quyet-don/subView/BlockGiaiQuyetDonInfo');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.props.thongTinGQD;
      var donInfo = this.props.donInfo || {};
      var showBaoCaoTTXM = false;
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (DataDetail.donViGiaoThamTraXacMinhInfo && userInfo.donViId == DataDetail.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId) {
        showBaoCaoTTXM = true;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: DataDetail.huongThuLyGiaiQuyet != 'TU_TTXM' && showBaoCaoTTXM },
          _react2.default.createElement(
            'div',
            { className: 'mlr-5' },
            _react2.default.createElement(_subView.BlockBaoCaoKQTTXM, { donInfo: this.props.donInfo, thongTinGQD: this.props.thongTinGQD })
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: donInfo.loaiDon == 'DON_TO_CAO' && DataDetail.giaHanGiaiQuyet },
          _react2.default.createElement(
            'div',
            { className: 'mlr-5' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h3',
                { className: 'title-12 mb10 mt0' },
                'Gia h\u1EA1n x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o:'
              )
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n:', value: DataDetail.soQuyetDinhGiaHanGiaiQuyet ? DataDetail.soQuyetDinhGiaHanGiaiQuyet : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet ? (0, _moment2.default)(DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb15', red: true, label: 'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u1EBFn ng\xE0y:', value: DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'L\xFD do gia h\u1EA1n:', value: DataDetail.lyDoGiaHanGiaiQuyet ? DataDetail.lyDoGiaHanGiaiQuyet : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: donInfo.saveTmp === false && DataDetail.doiThoai === true && (donInfo.loaiDon === 'DON_KHIEU_NAI' || donInfo.loaiDon === 'DON_TRANH_CHAP_DAT') },
          _react2.default.createElement(
            'div',
            { className: 'col-100 mlr-5 pb10' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb15' },
              '\u0110\u1ED1i tho\u1EA1i'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.thoiGianDoiThoai ? (0, _moment2.default)(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: DataDetail.diaDiemDoiThoai ? DataDetail.diaDiemDoiThoai : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: donInfo.saveTmp === false && DataDetail.ngayHetHanGiaoLapDuThao },
          _react2.default.createElement(
            'div',
            { className: 'col-100 mlr-5 pb10' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb15' },
              'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', red: true, value: DataDetail.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props && DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: DataDetail.ngayKetThucGiaoLapDuThao },
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb10 mlr-5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb15' },
              'D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y tr\xECnh d\u1EF1 th\u1EA3o:', value: DataDetail.ngayKetThucGiaoLapDuThao ? (0, _moment2.default)(DataDetail.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.noiDungKetLuanDuThao ? DataDetail.noiDungKetLuanDuThao : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        )
      );
    }
  }]);

  return BlockGiaiQuyetDonInfo;
}(_react2.default.Component);

BlockGiaiQuyetDonInfo.defaultProps = {
  donInfo: {}
};

exports.default = BlockGiaiQuyetDonInfo;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var CanBoGiaiQuyetYeuCauLapDuThao = function (_React$Component) {
  _inherits(CanBoGiaiQuyetYeuCauLapDuThao, _React$Component);

  function CanBoGiaiQuyetYeuCauLapDuThao(props, context) {
    _classCallCheck(this, CanBoGiaiQuyetYeuCauLapDuThao);

    var _this = _possibleConstructorReturn(this, (CanBoGiaiQuyetYeuCauLapDuThao.__proto__ || Object.getPrototypeOf(CanBoGiaiQuyetYeuCauLapDuThao)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: _this.props.id,
      role: _this.props.role,
      loaiDon: _this.props.loaiDon,
      validate: false,
      showAttach: false,
      yKienGiaiQuyet: '',
      noiDungKetLuanDuThao: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: []
    };
    return _this;
  }

  _createClass(CanBoGiaiQuyetYeuCauLapDuThao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        loaiDon: nextProps.loaiDon
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'nextState') {}
      this.props.handleChangeData();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this2.setState({
              dataGiaiQuyetDon: res.data,
              canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
              noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX) : ''
            }, function () {
              _this2.renderAttachFile();
            });
          }
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;

      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao;
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(type) {
      var _this3 = this;

      this.setState({
        onSave: true
      }, function () {

        _this3.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this3.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this3.state.taiLieuVanThuUpdate[_this3.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this3.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this3.state.taiLieuVanThu[_this3.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this3.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this3.state.dataTaiLieuVanThuDelete.length > 0) {
          _this3.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this3.state.taiLieuVanThuDelete[_this3.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this3.getParams();

        params.noiDungKetLuanDuThao = _this3.state.noiDungKetLuanDuThao;
        _this3.postTaiLieuVanThu(_this3.state.taiLieuVanThu, function () {
          _this3.updateTaiLieuVanThu(_this3.state.taiLieuVanThuUpdate, function () {
            _this3.deleteTaiLieuVanThu(_this3.state.taiLieuVanThuDelete, function () {
              _this3.props.saveGiaiQuyetDon(params);
            });
          });
        });
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this4 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this4.validateSubmitForm()) {
          _this4.setState({
            isOpen: false,
            btnLoading: true
          });
          var dataFileDinhKem = _this4.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this4.state.taiLieuVanThuUpdate[_this4.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this4.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this4.state.taiLieuVanThu[_this4.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this4.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this4.state.dataTaiLieuVanThuDelete.length > 0) {
            _this4.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this4.state.taiLieuVanThuDelete[_this4.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this4.getParams();
          var params = {};
          if (_this4.props.tuGiaiQuyet == true) {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this4.state.thongTinGiaiQuyetDonId)
              },
              actionType: 'TTXM_GUI_DU_THAO',
              yKienGiaiQuyet: _this4.state.noiDungKetLuanDuThao
            };
          } else {
            var selectedState = _this4.props.dataNextStates.filter(function (state) {
              return state.type == _this4.state.nextState;
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this4.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this4.state.noiDungKetLuanDuThao
            };
          }
          _this4.postTaiLieuVanThu(_this4.state.taiLieuVanThu, function () {
            _this4.updateTaiLieuVanThu(_this4.state.taiLieuVanThuUpdate, function () {
              _this4.deleteTaiLieuVanThu(_this4.state.taiLieuVanThuDelete, function () {
                _this4.props.updateGiaiQuyetDon(_params, params, 'gqdGuiDuThao');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this5 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this5.compareDate(new Date(state.ngayTao), new Date(_this5.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this5.compareDate(new Date(_this5.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
      });

      var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
      var dataCheck = data.filter(function (item) {
        return item.required && item.typeRequired == 'DT_KL_GQKN';
      });
      if (dataCheck.length > 0) {
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        });
      } else {
        var DT_KL = {
          ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Dự thảo quyết định về việc giải quyết' : 'Dự thảo quyết định về việc giải quyết khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        };
        var TT_KL = {
          ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Tờ trình đề nghị ban hành QĐGQ' : 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        };
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDon), [TT_KL, DT_KL]),
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        });
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM,
          donInfo: this.props.donInfo
        }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, { value: this.state.noiDungKetLuanDuThao, className: 'areal-wrap col-100', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'noiDungKetLuanDuThao'), name: 'textareaChonCanBoGiaiQuyet' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showAttach },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, data: this.state.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this, 'truongPhongGiaiQuyetDon') },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'G\u1EEDi d\u1EF1 th\u1EA3o'
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " dự thảo của đơn/vụ việc này không?" })
          )
        )
      );
    }
  }]);

  return CanBoGiaiQuyetYeuCauLapDuThao;
}(_react2.default.Component);

CanBoGiaiQuyetYeuCauLapDuThao.defaultProps = {
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CanBoGiaiQuyetYeuCauLapDuThao);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(192);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'KIEM_TRA_DE_XUAT';

var CanBoKiemTraDeXuat = function (_React$Component) {
  _inherits(CanBoKiemTraDeXuat, _React$Component);

  function CanBoKiemTraDeXuat(props, context) {
    _classCallCheck(this, CanBoKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (CanBoKiemTraDeXuat.__proto__ || Object.getPrototypeOf(CanBoKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      showAttachFile: false,
      onSave: false,
      id: _this.props.id,
      donViId: '',
      yKienGiaiQuyet: '',
      dataGiaiQuyetDon: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      nextState: 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataKiemTraDeXuat: _this.props.dataKiemTraDeXuat,

      listTaiLieuVanThuShow: [],
      listTaiLieuVanThu: []
    };
    return _this;
  }

  _createClass(CanBoKiemTraDeXuat, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
      });
      // this.checkFileRequired();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.checkFileRequired();
      this.setState({
        dataKiemTraDeXuat: this.props.dataKiemTraDeXuat
      });
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this2 = this;

      if (this.props.listTaiLieuVanThuGiaiQuyetDon) {
        var ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
          return state.nguoiTaoInfo.donViId == _this2.state.donViId;
        });
        var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
          return state.nguoiTaoInfo.donViId != _this2.state.donViId;
        });

        if (ListTaiLieuVanThuShow.length > 0) {
          this.setState({
            listTaiLieuVanThuShow: ListTaiLieuVanThuShow
          });
        }

        var newArray = [].concat(_toConsumableArray(ListTaiLieuVanThu));
        if (newArray.length == 0) {
          var newItem = {
            ten: 'Báo cáo kết quả KTĐX',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BC_KTDX'
          };
          this.setState({
            listTaiLieuVanThu: [].concat(_toConsumableArray(ListTaiLieuVanThu), [newItem])
          }, function () {
            _this2.setState({
              showAttachFile: true
            });
          });
        } else {
          var dataCheck = newArray.filter(function (state) {
            return state.required && state.typeRequired == 'BC_KTDX';
          });
          if (dataCheck.length == 0) {
            var _newItem = {
              ten: 'Báo cáo kết quả KTĐX',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'BC_KTDX'
            };
            this.setState({
              listTaiLieuVanThu: [].concat(_toConsumableArray(ListTaiLieuVanThu), [_newItem])
            }, function () {
              _this2.setState({
                showAttachFile: true
              });
            });
          } else {
            this.setState({
              listTaiLieuVanThu: ListTaiLieuVanThu
            }, function () {
              _this2.setState({
                showAttachFile: true
              });
            });
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.props.handleChangeData();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this3 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this3.setState({
              dataGiaiQuyetDon: res.data,
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
            });
          }
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this4 = this;

      this.setState({
        onSave: true
      }, function () {

        _this4.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        _this4.state.dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this4.state.taiLieuVanThuUpdate[_this4.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this4.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this4.state.taiLieuVanThu[_this4.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this4.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (_this4.state.dataTaiLieuVanThuDelete.length > 0) {
          _this4.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this4.state.taiLieuVanThuDelete[_this4.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this4.getParams();

        params.yKienGiaiQuyet = _this4.state.yKienGiaiQuyet;

        _this4.postTaiLieuVanThu(_this4.state.taiLieuVanThu, function () {
          _this4.updateTaiLieuVanThu(_this4.state.taiLieuVanThuUpdate, function () {
            _this4.deleteTaiLieuVanThu(_this4.state.taiLieuVanThuDelete, function () {
              _this4.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this5 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this5.validateSubmitForm()) {
          _this5.state.dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (_this5.state.dataTaiLieuVanThuDelete.length > 0) {
            _this5.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
          var params = {};
          if (_this5.props.tuGiaiQuyet) {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this5.props.thongTinGiaiQuyetDonId)
              },
              yKienGiaiQuyet: _this5.state.yKienGiaiQuyet,
              actionType: 'TU_KTDX'
            };
          } else {
            var selectedState = _this5.props.dataNextStates.filter(function (state) {
              return state.type == _this5.state.nextState;
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this5.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this5.state.yKienGiaiQuyet
            };
          }
          _this5.postTaiLieuVanThu(_this5.state.taiLieuVanThu, function () {
            _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
              _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
                _this5.props.postGiaiQuyetDon(params, 'ktdxTraBaoCao');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id]),
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Xác nhận giao xác minh đề xuất' : 'Xác nhận giao TTXM';
      var tenCoQuan = this.props.dataKiemTraDeXuat && this.props.dataKiemTraDeXuat.donViGiaoKTDX ? this.props.dataKiemTraDeXuat.donViGiaoKTDX.ten : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.showAttachFile },
          _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, _extends({ khongQuyTrinh: this.props.khongQuyTrinh, listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon }, this.state.dataKiemTraDeXuat, { hideTable: true, donInfo: this.props.donInfo }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 ki\u1EC3m tra'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: '' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showAttachFile },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuShow, data: this.state.listTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'G\u1EEDi b\xE1o c\xE1o KT\u0110X'
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: lb1, content: 'Bạn có đồng ý chuyển cho ' + tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?' })
          )
        )
      );
    }
  }]);

  return CanBoKiemTraDeXuat;
}(_react2.default.Component);

CanBoKiemTraDeXuat.defaultProps = {
  validators: {}
};

exports.default = CanBoKiemTraDeXuat;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

var _common = __webpack_require__(3);

var _subView = __webpack_require__(33);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var CanBoNhanYeuCauTheoDoiThucHien = function (_React$Component) {
  _inherits(CanBoNhanYeuCauTheoDoiThucHien, _React$Component);

  function CanBoNhanYeuCauTheoDoiThucHien(props, context) {
    _classCallCheck(this, CanBoNhanYeuCauTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (CanBoNhanYeuCauTheoDoiThucHien.__proto__ || Object.getPrototypeOf(CanBoNhanYeuCauTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      dataDetail: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      id: _this.props.id,
      loaiDon: _this.props.loaiDon,
      nextState: '',
      khoiTo: false,
      openDialog: false,
      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,
      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',
      ketQuaThucHienKhac: '',
      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,
      ketQuaGiaiQuyetLan2: '',
      soLanGiaiQuyetLai: '',
      noiDungKetLuanGiaiQuyetLai: '',
      soVuGiaiQuyetKhieuNai: '',
      ketLuanNoiDungKhieuNai: '',
      ketQuaGiaiQuyetKhac: '',
      tienPhaiThuNhaNuocQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',
      soNguoiDuocTraLaiQuyenLoi: '',
      nguoiBanHanh: ''
    };
    return _this;
  }

  _createClass(CanBoNhanYeuCauTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanTheoDoiEnumn();
      if (this.props.dataNextStates && this.props.dataNextStates.length > 0) {
        this.checkOnlyState(this.props.dataNextStates);
      }
      this.getDetail(this.state.thongTinGiaiQuyetDonId);
      if (window.debug) {
        console.log('giai-quyet-don/subView/CanBoNhanYeuCauTheoDoiThucHien');
      }
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this2 = this;

      if (typeof id != 'undefined') {
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: id }).then(function (res) {
          if (res.data) {
            _this2.setState({
              dataDetail: res.data,
              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : ''
            }, function () {
              _this2.checkFileDinhKem();
              if (_this2.props.dataNextStates && _this2.props.dataNextStates.length > 0) {
                _this2.checkOnlyState(_this2.props.dataNextStates);
              }
            });
          }
        });
      }
    }
  }, {
    key: 'checkFileDinhKem',
    value: function checkFileDinhKem() {
      var _this3 = this;

      var data = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var dataView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
        return _this3.compareDate(new Date(state.ngayTao), new Date(_this3.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(function (state) {
        return _this3.compareDate(new Date(_this3.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
      });
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
      }, function () {
        _this3.setState({
          showFile: true
        });
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState(dataNextStates) {
      this.setState({
        nextState: dataNextStates[0].type
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        loaiDon: nextProps.loaiDon
      });
      if (this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
        this.checkOnlyState(nextProps.dataNextStates);
      }
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
        this.setState({
          noiDungKetLuanGiaiQuyetLai: ''
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleKetThuc();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGQD = this.state.dataDetail;
      var params = (0, _GetParams.getParams)(dataGQD, this.state.id);

      if (params.giaoCoQuanDieuTra && this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      params.theoDoiThucHien = true;
      params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
      if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
        params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
      } else {
        params.coQuanTheoDoi = null;
      }
      params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
      params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

      params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
      params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
      params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
      params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

      params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
      params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
      params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
      params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;
      var isQDGQ = dataGQD.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
      params.soLanGiaiQuyetLai = isQDGQ && this.props.loaiDon == 'DON_KHIEU_NAI' ? Number(this.state.soLanGiaiQuyetLai) : 0;
      params.ketQuaGiaiQuyetLan2 = Number(this.state.soLanGiaiQuyetLai) > 1 ? this.state.ketQuaGiaiQuyetLan2 : null;
      params.noiDungKetLuanGiaiQuyetLai = this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' ? this.state.noiDungKetLuanGiaiQuyetLai : '';
      params.soVuGiaiQuyetKhieuNai = isQDGQ ? Number(this.state.soVuGiaiQuyetKhieuNai) : 0;
      params.ketLuanNoiDungKhieuNai = isQDGQ ? this.state.ketLuanNoiDungKhieuNai : null;
      params.ketQuaGiaiQuyetKhac = isQDGQ ? this.state.ketQuaGiaiQuyetKhac : '';
      params.tienPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.tienPhaiThuNhaNuocQDGQ) : 0;
      params.datPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.datPhaiThuNhaNuocQDGQ) : 0;
      params.tienPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.tienPhaiTraCongDanQDGQ) : 0;
      params.datPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.datPhaiTraCongDanQDGQ) : 0;
      params.tongSoNguoiXuLyHanhChinh = isQDGQ ? Number(this.state.tongSoNguoiXuLyHanhChinh) : 0;
      params.soNguoiDaBiXuLyHanhChinh = isQDGQ ? Number(this.state.soNguoiDaBiXuLyHanhChinh) : 0;
      params.soNguoiDuocTraLaiQuyenLoi = isQDGQ ? Number(this.state.soNguoiDuocTraLaiQuyenLoi) : 0;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this5 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var _params = this.getParams();
        var params = {};
        if (this.props.tuGiaiQuyet == true) {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            }
          };
          if (this.state.dataDetail.huongThuLyGiaiQuyet == 'TU_TTXM') {
            params.actionType = 'QGD_TU_LUU_HO_SO_TDTH';
          } else {
            params.actionType = 'TRUONG_PHONG_TU_TDTH';
          }
        } else {
          var selectedState = this.props.dataNextStates.filter(function (state) {
            return state.type == _this5.state.nextState;
          });
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            }
          };
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
            _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
              _this5.props.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
            });
          });
        });
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this6 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      var params = this.getParams();
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
        _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
          _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
            _this6.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      this.setState({
        dataFileDinhKem: data
      });

      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.state.dataDetail;
      var ketLuanNDKhieuNaiLabel = this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : this.props.loaiDon == 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh";
      var labelQD = this.state.loaiDon == 'DON_TO_CAO' ? 'Quyết định giải quyết tố cáo' : this.state.loaiDon == 'DON_KHIEU_NAI' ? 'Quyết định giải quyết khiếu nại' : 'Văn bản giải quyết kiến nghị, phản ánh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        DataDetail.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: DataDetail.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: DataDetail.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: DataDetail.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: DataDetail.ngayHetHanTTXM,
          donInfo: this.props.donInfo
        }),
        DataDetail.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataDetail }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 mt5 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb10' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || DataDetail.ketQuaXLDGiaiQuyet == 'DANG_TDTH' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              labelQD
            ),
            /*Block edit thong tin quyet dinh giai quyet*/
            DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.props.loaiDon == 'DON_KHIEU_NAI' && _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.soLanGiaiQuyetLai > 1 },
                _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1 },
                _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
              )
            ),
            DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVu', value: this.state.soVuGiaiQuyetKhieuNai, onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai') }),
              _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.props.loaiDon, label: ketLuanNDKhieuNaiLabel, className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
              _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
            ),
            DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'div',
                { className: 'col-50 no-gutter mb20' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                ),
                _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', name: 'tienPhaiThuNhaNuocQDGQ', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ') }),
                _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuocQDGQ', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-50 no-gutter mb20' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                ),
                _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'tienPhaiTraCongDanQDGQ', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ') }),
                _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', name: 'datPhaiTraCongDanQDGQ', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                ),
                _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'tongSoNguoiXuLyHanhChinh', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh') }),
                _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDaBiXuLyHanhChinh', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh') }),
                _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDuocTraLaiQuyenLoi', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
              )
            )
            /*End block edit thong tin quyet dinh giai quyet*/
            ,
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line pt5 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mt5' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb15' },
                'Theo d\xF5i th\u1EF1c hi\u1EC7n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.giaoCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(DataDetail.soVuGiaoCoQuanDieuTra) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(DataDetail.soDoiTuongGiaoCoQuanDieuTra) })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Kh\u1EDFi t\u1ED1'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'N\u1ED9i dung Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), name: 'coQuanTheoDoi', data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac'), name: 'ketQuaThucHienKhac' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc'), name: 'tienPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc'), name: 'datPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc'), name: 'tienDaThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc'), name: 'datDaThuTheoDoiThucHien' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan'), name: 'tienPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan'), name: 'datPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan'), name: 'tienDaTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan'), name: 'datDaTraTheoDoiThucHien' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 pl0 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: DataDetail.soVanBan || '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: DataDetail.ngayBanHanh ? (0, _moment2.default)(DataDetail.ngayBanHanh).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: DataDetail.nguoiBanHanhInfo ? DataDetail.nguoiBanHanhInfo.hoVaTen : '' }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl0 mb15', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: DataDetail.lyDoBanHanhQuyetDinhDinhChi || '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, {
                name: 'GiaoCQDT',
                label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView,
                data: this.state.listTaiLieuVanThuGiaiQuyetDon,
                onSave: this.state.onSave,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'luuHoSo') },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u h\u1ED3 s\u01A1'
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' })
            )
          )
        )
      );
    }
  }]);

  return CanBoNhanYeuCauTheoDoiThucHien;
}(_react2.default.Component);

CanBoNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CanBoNhanYeuCauTheoDoiThucHien);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ThongTinNguoiDungDon = __webpack_require__(479);

var _ThongTinNguoiDungDon2 = _interopRequireDefault(_ThongTinNguoiDungDon);

var _ThongTinDon = __webpack_require__(478);

var _ThongTinDon2 = _interopRequireDefault(_ThongTinDon);

var _ThongTinNguoiUyQuyen = __webpack_require__(480);

var _ThongTinNguoiUyQuyen2 = _interopRequireDefault(_ThongTinNguoiUyQuyen);

var _ThongTinCoQuanDaGiaiQuyet = __webpack_require__(477);

var _ThongTinCoQuanDaGiaiQuyet2 = _interopRequireDefault(_ThongTinCoQuanDaGiaiQuyet);

var _core = __webpack_require__(7);

var _dialog = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _utils = __webpack_require__(4);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _detail = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietDon = function (_React$Component) {
  _inherits(ChiTietDon, _React$Component);

  function ChiTietDon(props, context) {
    _classCallCheck(this, ChiTietDon);

    var _this = _possibleConstructorReturn(this, (ChiTietDon.__proto__ || Object.getPrototypeOf(ChiTietDon)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      isOpen: _this.props.isOpen,
      donId: _this.props.donId,
      dataGiaiQuyet: _this.props.dataGiaiQuyet,
      trangThaiGiaiQuyet: ''
    };
    return _this;
  }

  _createClass(ChiTietDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.isOpen != nextProps.isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      }

      if (nextProps.data.trangThaiDonInfo && nextProps.userInfo) {

        nextProps.data.trangThaiDonInfo.filter(function (item) {
          return item.donViId == nextProps.userInfo.donViId;
        }).map(function (child, i) {
          _this2.setState({
            trangThaiGiaiQuyet: child.trangThaiDonText
          });
        });
      }
      this.setState({
        data: nextProps.data,
        dataGiaiQuyet: nextProps.dataGiaiQuyet
      });
    }
  }, {
    key: 'showHanXuLy',
    value: function showHanXuLy() {
      var hanXuLy = '';
      if (this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
        hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX;
      } else {
        if (this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          if (this.props.loaiDon == 'DON_KHIEU_NAI') {

            if (this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanTTXM) {

              hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanTTXM;
            } else {

              hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM;
            }
          } else {

            hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM;
          }
        }

        if (this.state.data.donViXuLyGiaiQuyetInfo && this.state.data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          if (this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyet && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet) {

            hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet;
          } else {
            hanXuLy = this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo && this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet ? this.state.dataGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet : '';
          }
        }
      }
      return hanXuLy ? (0, _moment2.default)(hanXuLy).format('DD/MM/YYYY') : '';
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'content-wrap content-gqd background-detail panel-page' },
        _react2.default.createElement(
          'div',
          { className: this.state.isOpen ? 'header-redirect background-detail' : 'background-detail header-redirect no-border-bottom' },
          _react2.default.createElement(
            'div',
            { className: 'row-col' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.data.ma != '' },
              _react2.default.createElement(
                'div',
                { className: 'header-col pl15' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold' },
                  'M\xE3 \u0111\u01A1n:'
                ),
                this.state.data.ma ? this.state.data.ma : ''
              )
            ),
            _react2.default.createElement(
              'div',
              { className: this.state.data.ma ? "header-col" : "header-col pl15" },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold' },
                'Ng\xE0y ti\u1EBFp nh\u1EADn:'
              ),
              this.state.data.ngayTiepNhan ? (0, _moment2.default)(this.state.data.ngayTiepNhan).format('DD/MM/YYYY') : ''
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold' },
                'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt:'
              ),
              this.state.data.coThongTinCoQuanDaGiaiQuyet && this.state.data.coQuanDaGiaiQuyetDon ? this.state.data.coQuanDaGiaiQuyetDon.ten : this.state.data.coQuanDaGiaiQuyetDonThu
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold' },
                'C\u01A1 quan \u0111ang gi\u1EA3i quy\u1EBFt:'
              ),
              this.state.data.coQuanDangQuyetInfo ? this.state.data.coQuanDangQuyetInfo.ten : ''
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold' },
                'Tr\u1EA1ng th\xE1i gi\u1EA3i quy\u1EBFt:'
              ),
              this.state.trangThaiGiaiQuyet
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold' },
                'H\u1EA1n gi\u1EA3i quy\u1EBFt:'
              ),
              this.showHanXuLy()
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col' },
              _react2.default.createElement(_dialog.HistoryDialog, { donId: this.state.donId })
            ),
            _react2.default.createElement(
              'div',
              { className: 'header-col pr15' },
              _react2.default.createElement(_core.Button, { onClick: this.handleClick.bind(this), className: this.state.isOpen ? "btn-collap active" : "btn-collap" })
            )
          )
        ),
        this.props.coQuanToChucTiepDan.length ? _react2.default.createElement(
          'div',
          { className: 'wrapper_box' },
          _react2.default.createElement(
            'div',
            { className: 'box-items mb0-18' },
            _react2.default.createElement(
              'div',
              { className: 'box-forward' },
              _react2.default.createElement(
                'div',
                { className: 'container-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'group-box pt-20 pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Danh s\xE1ch c\u01A1 quan, c\xE1c \u0111\u01A1n v\u1ECB c\xF9ng tham gia ti\u1EBFp c\xF4ng d\xE2n'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          _dataTable2.default,
                          {
                            header: _table.header.detailReceptionPeriodical.organization,
                            dataList: this.props.coQuanToChucTiepDan,
                            hidePagination: true,
                            tableLoading: false },
                          _react2.default.createElement(_detail.RowItemListOrganizationPeriodical, null)
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ) : '',
        _react2.default.createElement(
          'div',
          { className: 'wrapper_box pb0 pl10 pr10 pt10' },
          _react2.default.createElement(
            _core.Collapse,
            { isOpen: this.state.isOpen },
            _react2.default.createElement(_ThongTinNguoiDungDon2.default, _extends({
              title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
            }, this.state.data))
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.data.coUyQuyen },
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.isOpen },
              _react2.default.createElement(
                'div',
                { className: 'box-items mb0 mt20' },
                _react2.default.createElement(_ThongTinNguoiUyQuyen2.default, _extends({
                  title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n'
                }, this.state.data))
              ),
              _react2.default.createElement(
                'div',
                { className: 'pl5 pr5 pt0 mb15' },
                _react2.default.createElement('div', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: this.state.isOpen ? "box-items" : "box-items no-margin" },
            _react2.default.createElement(_ThongTinDon2.default, _extends({
              listTLBC: this.props.listTLBC,
              title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
              isOpen: this.state.isOpen
            }, this.state.data))
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.data.coThongTinCoQuanDaGiaiQuyet },
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.isOpen },
              _react2.default.createElement(
                'div',
                { className: 'pl5 pr5 pt0 mb15' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: this.props.isOpen ? "box-items" : "box-items no-margin" },
                _react2.default.createElement(_ThongTinCoQuanDaGiaiQuyet2.default, _extends({
                  title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                }, this.state.data))
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietDon;
}(_react2.default.Component);

ChiTietDon.defaultProps = {
  dataGiaiQuyet: [],
  coQuanToChucTiepDan: [],
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
};

exports.default = ChiTietDon;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachTaiLieuDinhKem = function (_React$Component) {
  _inherits(DanhSachTaiLieuDinhKem, _React$Component);

  function DanhSachTaiLieuDinhKem() {
    _classCallCheck(this, DanhSachTaiLieuDinhKem);

    return _possibleConstructorReturn(this, (DanhSachTaiLieuDinhKem.__proto__ || Object.getPrototypeOf(DanhSachTaiLieuDinhKem)).apply(this, arguments));
  }

  _createClass(DanhSachTaiLieuDinhKem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'tldk-block' },
        _react2.default.createElement(
          'div',
          { className: 'block-file-attach' },
          _react2.default.createElement(
            'h3',
            { className: 'txt-upper txt-blue title-12 mt10' },
            'danh s\xE1ch T\xE0i li\u1EC7u \u0111\xEDnh k\xE8m'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line white-table' },
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.giaiQuyetDon.danhSachTaiLieuDinhKem,
              dataList: this.props.listTaiLieuVanThuGiaiQuyetDon,
              type: 'list-attach',
              hidePagination: true,
              hiddenButtonExport: true
            },
            _react2.default.createElement(_rowItem.ListAttachTaiLieuRowItem, null)
          )
        )
      );
    }
  }]);

  return DanhSachTaiLieuDinhKem;
}(_react2.default.Component);

DanhSachTaiLieuDinhKem.defaultProps = {
  listTaiLieuVanThuGiaiQuyetDon: []
};

exports.default = DanhSachTaiLieuDinhKem;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _core = __webpack_require__(7);

var _GetParams = __webpack_require__(47);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var GiaiQuyetDonCanBo = function (_React$Component) {
  _inherits(GiaiQuyetDonCanBo, _React$Component);

  function GiaiQuyetDonCanBo(props, context) {
    _classCallCheck(this, GiaiQuyetDonCanBo);

    var _this = _possibleConstructorReturn(this, (GiaiQuyetDonCanBo.__proto__ || Object.getPrototypeOf(GiaiQuyetDonCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogLuuHoSo: false,
      componentsLoading: true,
      isValid: false,
      loaiDon: _this.props.loaiDon,
      tTXMRequired: false,
      open: false,
      showFile: false,

      lapToDoanXacMinh: false,
      giaHanGiaiQuyet: false,
      giaHanTTXM: false,
      doiThoai: false,
      giaoCoQuanDieuTra: false,
      quyetDinhGiaiQuyetKhieuNai: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,
      onSave: false,
      allowAttachGiaoCoQuanDieuTra: false,
      khongCoCoQuanTheoDoiThucHien: false,
      checkThanhTraThanhPho: false,
      isThanhTraThanhPho: false,

      //dialog
      btnText: '',
      titleDialog: '',
      contentDialog: '',
      //end

      isPhongBanThanhTra: false,
      checkPhongBanThanhTra: false,

      valueKetQua: '',

      donViThamTraXacMinh: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        baoCaoKetQuaTTXM: [],
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      dataCoQuanTheoDoi: [],
      nextState: '',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNai: '',
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',

      //DON_KHIEU_NAI
      soQuyetDinhGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanGia: '',

      //DON_TO_CAO
      soQuyetDinhGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      soVuGiaiQuyetKhieuNai: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      yKienGiaiQuyet: '',

      tienPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      soNguoiDuocTraLaiQuyenLoi: '',

      noiDungDoiThoai: '',
      soLanGiaiQuyetLai: '',
      ketQuaThucHienKhac: '',
      ketQuaKhac: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',
      listTaiLieuVanThuGiaiQuyetDonView: _this.props.listTaiLieuVanThuGiaiQuyetDonView,
      listTaiLieuVanThuGiaiQuyetDon: [],
      gqText: _this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDon == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      allowAttach: false,
      isSoBanNganh: false,
      checkSoBanNganh: false,
      dataDonViTheoDoi: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      ngayBanHanhSuggest: '',
      huongGiaiQuyet: '',
      tenDonViTheoDoiThucHien: '',
      ketQuaXLDGiaiQuyet: '',
      dataKetQuaGiaiQuyetDon: [],
      tienDoDoiThoai: '',
      message: 'Chọn "' + _this.gqText + '" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      coQuanTheoDoiThucHien: {},
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      allowTDTH: false,
      tenCoQuan: _this.props.tenCoQuan
    };
    return _this;
  }

  _createClass(GiaiQuyetDonCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      this.getListPhongBanNhanTDTH();
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('giai-quyet-don/subView/GiaiQuyetDonCanBo');
      }
      if (this.props.tenCoQuan.length == 0) {
        _api.DuLieuHeThong.actions.getDonViTTXM.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViTTXM',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.tenCoQuan != this.props.tenCoQuan) {
        this.state.tenCoQuan = nextProps.tenCoQuan;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'getDonViNhanTheoDoiTH',
    value: function getDonViNhanTheoDoiTH() {
      var _this3 = this;

      var params = {
        donId: this.props.id,
        tuTTXM: true,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request(params).then(function (res) {
        if (res.data) {
          _this3.setState({ coQuanTheoDoiThucHien: res.data, allowTDTH: true });
        }
        _this3.initButton();
      }).catch(function (err) {
        _this3.initButton();
      });
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this4 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this4.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'checkSoBanNganh',
    value: function checkSoBanNganh() {
      var _this5 = this;

      var params = {
        tuKhoa: 'CCQQL_SO_BAN_NGANH'
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
          if (Number(userInfo.capCoQuanQuanLyCuaDonViId) == Number(res.data._embedded.thamSoes[0].giaTri)) {
            _this5.setState({
              isSoBanNganh: true,
              checkSoBanNganh: true
            }, function () {
              _this5.checkThanhTraThanhPho();
            });
          } else {
            _this5.setState({
              isSoBanNganh: false,
              isPhongBanThanhTra: false,
              checkPhongBanThanhTra: true,
              checkSoBanNganh: true,
              checkThanhTraThanhPho: true,
              isThanhTraThanhPho: false
            });
            _this5.getDonViNhanTheoDoiTH();
          }
        }
      }).catch(function (err) {
        _this5.setState({
          isSoBanNganh: false,
          isPhongBanThanhTra: false,
          checkPhongBanThanhTra: true,
          checkSoBanNganh: true,
          checkThanhTraThanhPho: true,
          isThanhTraThanhPho: false
        });
        _this5.getDonViNhanTheoDoiTH();
      });
    }
  }, {
    key: 'checkThanhTraThanhPho',
    value: function checkThanhTraThanhPho() {
      var _this6 = this;

      var params = {
        tuKhoa: 'CQQL_THANH_TRA_THANH_PHO'
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
          _this6.setState({
            checkThanhTraThanhPho: true,
            isThanhTraThanhPho: Number(userInfo.donViId) == Number(res.data._embedded.thamSoes[0].giaTri)
          }, function () {
            _this6.getPhongBanNhanTDTH();
          });
        }
      }).catch(function (err) {
        _this6.setState({
          checkThanhTraThanhPho: true,
          isThanhTraThanhPho: false
        }, function () {
          _this6.getPhongBanNhanTDTH();
        });
      });
    }
  }, {
    key: 'getListPhongBanNhanTDTH',
    value: function getListPhongBanNhanTDTH() {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.getListPhongBanNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            dataPhongBanNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getPhongBanNhanTDTH',
    value: function getPhongBanNhanTDTH() {
      var _this8 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var idQuan = ts.filter(function (item) {
        return item.ten == 'CCQQL_UBND_QUAN_HUYEN';
      });

      _api.GiaiQuyetDonThu.actions.getPhongBanNhanTDTH.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten,
            checkPhongBanThanhTra: true,
            allowTDTH: true
          });
        }
        _this8.initButton();
      }).catch(function (err) {
        // if (idQuan.length && userInfo.capCoQuanQuanLyCuaDonViChaId != idQuan[0].giaTri && this.state.isThanhTraThanhPho == false) {
        //   Toastr('Không có cơ quan tiếp nhận theo dõi thực hiện', 'error');
        // }
        _this8.setState({
          checkPhongBanThanhTra: true,
          khongCoCoQuanTheoDoiThucHien: true
        });
        _this8.initButton();
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this10 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'initButton',
    value: function initButton() {
      var _this11 = this;

      var coQuanQuanLyId = this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId;
      var _nextState = 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH';
      var _btnText = 'Chuyển theo dõi thực hiện';
      var _titleDialog = 'Xác nhận';
      var _contentDialog = 'Không có đơn vị nhận theo dõi thực hiện?';
      if (this.state.donViTheoDoiThucHien == coQuanQuanLyId || this.state.isThanhTraThanhPho || !this.state.allowTDTH) {
        _nextState = 'KET_THUC';
        _btnText = 'Lưu hồ sơ';
        _titleDialog = 'Xác nhận lưu hồ sơ';
        _contentDialog = 'Bạn có muốn lưu hồ sơ này?';
      } else if (!this.state.khongCoCoQuanTheoDoiThucHien) {
        if (this.state.isSoBanNganh) {
          _contentDialog = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?';
        } else {
          _contentDialog = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.coQuanTheoDoiThucHien.ten + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?';
        }
      }

      this.setState({
        nextState: _nextState,
        tTXMRequired: true,
        btnText: _btnText,
        titleDialog: _titleDialog,
        contentDialog: _contentDialog
      }, function () {
        _this11.setState({
          componentsLoading: false
        });
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this12 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this12.setState({
              dataGiaiQuyetDon: res.data,
              soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
              truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
              ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',

              giaHanTTXM: res.data.giaHanTTXM,
              soQuyetDinhGiaHanTTXM: res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
              ngayRaQuyetDinhGiaHanTTXM: res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',
              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? new Date(res.data.ngayHetHanSauKhiGiaHanTTXM) : '',
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',

              giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,
              soQuyetDinhGiaHanGiaiQuyet: res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
              ngayRaQuyetDinhGiaHanGiaiQuyet: res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? new Date(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet) : '',
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              ngayBanHanhSuggest: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              lapToDoanXacMinh: res.data.lapToDoanXacMinh,
              doiThoai: res.data.doiThoai,
              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              donViThamTraXacMinh: res.data.donViThamTraXacMinhInfo ? res.data.donViThamTraXacMinhInfo.coQuanQuanLyId : '',
              ngayHetHanTTXM: res.data.ngayHetHanTTXM ? new Date(res.data.ngayHetHanTTXM) : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              tienDoDoiThoai: 'KHONG_DOI_THOAI',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? true : false,

              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              showFile: true,
              allowAttach: true
            }, function () {
              _this12.checkFileCoQuanDieuTra();
            });
          }
          _this12.checkSoBanNganh();
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this13 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this13.state.giaoCoQuanDieuTra == false) {
          _this13.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this13.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this13.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this13.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this13.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        var setNgayBanHanh = {};
        if (name === 'ngayBanHanhSuggest') {
          setNgayBanHanh.ngayBanHanh = e._d;
        }
        this.setState(_extends({}, setNgayBanHanh, _defineProperty({}, name, e._d)));
      } else {
        var _setNgayBanHanh = {};
        if (name === 'ngayBanHanhSuggest') {
          _setNgayBanHanh.ngayBanHanh = e;
        }
        this.setState(_extends({}, _setNgayBanHanh, _defineProperty({}, name, e)));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else if (name == 'nextState') {
        if (e.target.value == 'KET_THUC') {
          this.setState(_defineProperty({
            tTXMRequired: true
          }, name, e.target.value));
        } else {
          this.checkFileRequired(e.target.value);
        }
      } else {

        this.setState(_defineProperty({}, name, e.target.value));

        if (name == 'tienDoDoiThoai' && e.target.value != 'KHONG_DOI_THOAI') {
          this.state.tienDoDoiThoai = e.target.value;
          this.state.ketQuaXLDGiaiQuyet = '';
          this.setState(_extends({}, this.state));
        }

        if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          this.setState({
            ketQuaGiaiQuyetLan2: ''
          });
        }

        if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }

        if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_DON_VI_TTXM') {
          this.setState({
            tTXMRequired: false
          });
        }
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired(data) {
      this.setState({
        showFile: false
      });
      var listTaiLieuVanThuGiaiQuyetDonView = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView));

      var dataCheckFileRequired = listTaiLieuVanThuGiaiQuyetDonView.filter(function (state) {
        return state.required && state.typeRequired == 'QD_GTTXM';
      });

      if (dataCheckFileRequired.length > 0) {
        // do nothing
        this.setState({
          showFile: true
        });
      } else {
        var fileRequired = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'QD_GTTXM'
        };
        if (this.state.loaiDon == 'DON_KHIEU_NAI') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
        } else if (this.state.loaiDon == 'DON_TO_CAO') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung tố cáo';
        } else {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung kiến nghị phản ánh';
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDonView: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView), [fileRequired]),
          showFile: true
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'BAO_CAO_KET_QUA_TTXM') {
        dataFileDinhKem.baoCaoKetQuaTTXM = data;
      } else if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_TTT';
        });
        if (!(0, _lodash.isEmpty)(fileQD) && fileQD[0].unSetNgayBanHanh) {
          this.setState({ ngayBanHanhSuggest: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
        }
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem(type) {
      if (type == 'GIAO_TTXM') {
        return this.state.dataFileDinhKem.data;
      } else {
        var dataFileDinhKem = [];
        var Data = this.state.dataFileDinhKem;
        if (Data.baoCaoKetQuaTTXM.length > 0) {
          Data.baoCaoKetQuaTTXM.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.data.length > 0) {
          Data.data.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
          Data.quyetDinhGiaiQuyet.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
          Data.giaoCoQuanDieuTra.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
          Data.giaHan.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        return dataFileDinhKem;
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
          params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanhSuggest ? (0, _moment2.default)(this.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
        params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 || null;

        if (this.props.loaiDon == 'DON_KHIEU_NAI') {
          params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);
          if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
          } else {
            params.noiDungKetLuanGiaiQuyetLai = '';
          }
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanhSuggest ? (0, _moment2.default)(this.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }
      var coQuanQuanLyId = this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId;

      if (!(this.state.isSoBanNganh && this.state.donViTheoDoiThucHien != coQuanQuanLyId && !this.state.isThanhTraThanhPho)) {
        if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          params.theoDoiThucHien = true;
          params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
          if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
            params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
          } else {
            params.coQuanTheoDoi = null;
          }
          params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
          params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

          params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
          params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
          params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
          params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

          params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
          params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
          params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
          params.datDaTraCongDan = Number(this.state.datDaTraCongDan);
        } else {
          params.theoDoiThucHien = false;
          params.ketQuaThucHienKhac = '';
          params.hinhThucTheoDoi = null;
          params.coQuanTheoDoi = null;
          params.ketQuaThucHienTheoDoi = null;

          params.tienDaThuNhaNuoc = 0;
          params.datDaThuNhaNuoc = 0;
          params.tienDaTraCongDan = 0;
          params.datDaTraCongDan = 0;

          params.tienPhaiThuNhaNuoc = 0;
          params.datPhaiThuNhaNuoc = 0;
          params.tienPhaiTraCongDan = 0;
          params.datPhaiTraCongDan = 0;
        }
      } else {
        params.theoDoiThucHien = false;
        params.ketQuaThucHienKhac = '';
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;

        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;
      }

      params.ketQuaXLDGiaiQuyet = this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' && this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

      if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
        if (this.state.doiThoai) {
          params.doiThoai = true;
          params.thoiGianDoiThoai = (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString();
          params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
          params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        } else {
          params.doiThoai = false;
          params.thoiGianDoiThoai = null;
          params.diaDiemDoiThoai = '';
          params.noiDungDoiThoai = '';
        }
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }

      params.donViThamTraXacMinh = null;
      params.ngayHetHanTTXM = null;
      params.yKienGiaiQuyet = '';

      params.don = {
        id: Number(this.state.id)
      };
      params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM ? this.state.ketLuanNoiDungKhieuNaiGiaoTTXM : null;

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this14 = this;

      this.setState({
        onSave: true
      }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dataFileDinhKem, _taiLieuVanThuUpdate, _taiLieuVanThu, dataFile, _dataFile, params;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this14.setState({
                  btnLoading: true,
                  btnSaveLoading: true
                });
                dataFileDinhKem = _this14.getListDataFileDinhKem('KET_THUC');

                if (!(dataFileDinhKem.length > 0)) {
                  _context.next = 8;
                  break;
                }

                _taiLieuVanThuUpdate = [];
                _taiLieuVanThu = [];

                dataFileDinhKem.forEach(function (item) {
                  if (item.taiLieuVanThuId) {
                    _taiLieuVanThuUpdate[_taiLieuVanThuUpdate.length] = {
                      don: {
                        id: Number(_this14.state.id)
                      },
                      id: item.taiLieuVanThuId,
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: item.loaiTepDinhKem,
                      loaiQuyTrinh: item.loaiQuyTrinh,
                      buocGiaiQuyet: item.buocGiaiQuyet,
                      required: item.required,
                      typeRequired: item.typeRequired || ''
                    };
                  } else {
                    _taiLieuVanThu[_taiLieuVanThu.length] = {
                      don: {
                        id: Number(_this14.state.id)
                      },
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: loaiTepDinhKem,
                      loaiQuyTrinh: loaiQuyTrinh,
                      buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                      required: item.required,
                      typeRequired: item.typeRequired || ''
                    };
                  }
                });
                _context.next = 8;
                return _this14.setState({
                  taiLieuVanThuUpdate: _taiLieuVanThuUpdate,
                  taiLieuVanThu: _taiLieuVanThu
                });

              case 8:
                if (_this14.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this14.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
                  dataFile = [].concat(_toConsumableArray(_this14.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));

                  dataFile.map(function (item) {
                    _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                      id: item.taiLieuVanThuId
                    };
                  });
                }
                if (!_this14.state.giaoCoQuanDieuTra) {
                  _dataFile = [].concat(_toConsumableArray(_this14.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));

                  _dataFile.map(function (item) {
                    _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                      id: item.taiLieuVanThuId
                    };
                  });
                }
                if (_this14.state.dataTaiLieuVanThuDelete.length > 0) {
                  _this14.state.dataTaiLieuVanThuDelete.map(function (item) {
                    _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                      id: item
                    };
                  });
                }
                params = _this14.getParams();

                _this14.postTaiLieuVanThu(_this14.state.taiLieuVanThu, function () {
                  _this14.updateTaiLieuVanThu(_this14.state.taiLieuVanThuUpdate, function () {
                    _this14.deleteTaiLieuVanThu(_this14.state.taiLieuVanThuDelete, function () {
                      _this14.props.saveGiaiQuyetDon(params, 'gqdLuu');
                    });
                  });
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this14);
      })));
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc(name) {
      var _this15 = this;

      if (this.state.khongCoCoQuanTheoDoiThucHien == true && this.state.isSoBanNganh && this.state.isThanhTraThanhPho != true && this.props.nameComponent !== 'CanBoGiaiQuyetDonKhongQuyTrinh') {
        //do nothing
        (0, _toastr.Toastr)('Không có đơn vị nhận theo dõi thực hiện', 'error');
        return;
      } else {
        this.setState({
          onSave: false
        }, function () {
          if (_this15.validateSubmitForm()) {
            _this15.setState({
              btnLoading: true
            });
            var dataFileDinhKem = _this15.getListDataFileDinhKem('KET_THUC');

            if (dataFileDinhKem.length > 0) {
              dataFileDinhKem.map(function (item, i) {
                if (item.taiLieuVanThuId) {
                  _this15.state.taiLieuVanThuUpdate[_this15.state.taiLieuVanThuUpdate.length] = {
                    don: {
                      id: Number(_this15.state.id)
                    },
                    id: item.taiLieuVanThuId,
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: item.loaiTepDinhKem,
                    loaiQuyTrinh: item.loaiQuyTrinh,
                    buocGiaiQuyet: item.buocGiaiQuyet,
                    required: item.required,
                    typeRequired: item.typeRequired || ''
                  };
                } else {
                  _this15.state.taiLieuVanThu[_this15.state.taiLieuVanThu.length] = {
                    don: {
                      id: Number(_this15.state.id)
                    },
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: loaiTepDinhKem,
                    loaiQuyTrinh: loaiQuyTrinh,
                    buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                    required: item.required,
                    typeRequired: item.typeRequired || ''
                  };
                }
              });
            }

            if (_this15.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this15.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
              var dataFile = [].concat(_toConsumableArray(_this15.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
              dataFile.map(function (item) {
                _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }

            if (!_this15.state.giaoCoQuanDieuTra) {
              var _dataFile2 = [].concat(_toConsumableArray(_this15.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
              _dataFile2.map(function (item) {
                _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }

            if (_this15.state.dataTaiLieuVanThuDelete.length > 0) {
              _this15.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }

            var _params = _this15.getParams();
            var coQuanQuanLyId = _this15.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId;
            var params = {};
            var msgName = '';

            if (_this15.state.isSoBanNganh && _this15.state.donViTheoDoiThucHien != coQuanQuanLyId && !_this15.state.isThanhTraThanhPho) {
              if (_this15.props.tuGiaiQuyet) {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this15.props.thongTinGiaiQuyetDonId)
                  },
                  phongBanGiaiQuyet: {
                    id: Number(_this15.state.donViTheoDoiThucHien)
                  },
                  actionType: 'QGD_GIAO_PHONG_BAN_KHAC_TDTH'
                };
                params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhDinhChi;
                if (_this15.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                  params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhGiaiQuyet;
                }
              } else {
                var selectedState = _this15.props.dataNextStates.filter(function (state) {
                  return state.type == _this15.state.nextState;
                });
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this15.props.thongTinGiaiQuyetDonId)
                  },
                  phongBanGiaiQuyet: {
                    id: Number(_this15.state.donViTheoDoiThucHien)
                  },
                  nextState: {
                    id: Number(selectedState[0].stateId)
                  }
                };
                params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhDinhChi;
                if (_this15.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                  params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhGiaiQuyet;
                }
              }
              msgName = 'gqdChuyenTheoDoi';
            } else if (_this15.state.nextState == 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH') {
              if (_this15.state.coQuanTheoDoiThucHien) {
                _params.donViTheoDoiThucHien = {
                  id: _this15.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                };
              }
              var _selectedState = _this15.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
              });

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this15.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: _this15.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                },
                nextState: {
                  id: Number(_selectedState[0].stateId)
                }
              };
              params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhDinhChi;
              if (_this15.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = _this15.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
              msgName = 'gqdChuyenTheoDoi';
            } else {
              if (_this15.props.tuGiaiQuyet) {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this15.props.thongTinGiaiQuyetDonId)
                  },
                  actionType: 'QGD_TU_TTXM'
                };
              } else {
                var _selectedState2 = _this15.props.dataNextStates.filter(function (state) {
                  return state.type == _this15.state.nextState;
                });
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this15.props.thongTinGiaiQuyetDonId)
                  },
                  nextState: {
                    id: Number(_selectedState2[0].stateId)
                  }
                };
              }
              msgName = 'gqdLuuHoSo';
            }
            _this15.postTaiLieuVanThu(_this15.state.taiLieuVanThu, function () {
              _this15.updateTaiLieuVanThu(_this15.state.taiLieuVanThuUpdate, function () {
                _this15.deleteTaiLieuVanThu(_this15.state.taiLieuVanThuDelete, function () {
                  _this15.props.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          }
        });
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type == 'BAO_CAO_KET_QUA_TTXM') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.baoCaoKetQuaTTXM = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'QUYET_DINH_GIAI_QUYET') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      } else {
        var _dataFileDinhKem4 = this.state.dataFileDinhKem;

        _dataFileDinhKem4.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem4
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'inPhieuGiaoTTXMKhieuNai',
    value: function inPhieuGiaoTTXMKhieuNai() {
      var _this16 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId == _this16.state.donViThamTraXacMinh;
      });

      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?" + "tenCoQuanThuLyGQKN=" + (this.props.coQuanDangQuyetInfo ? this.props.coQuanDangQuyetInfo.ten : '') + "&tenCoQuanDuocGiaoNhiemVuXM=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&donViXuLyId=" + userInfo.donViId + "&donId=" + this.state.thongTinGiaiQuyetDonId + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') + "&hoTenNguoiKhieuNai=" + (this.props.listNguoiDungDon ? this.props.listNguoiDungDon[0].hoVaTen : '') + "&noiDungTTXM=" + this.props.noiDungDonThu;
      window.open(URL, "_self");
    }
  }, {
    key: 'inPhieuGiaoTTXMToCao',
    value: function inPhieuGiaoTTXMToCao() {
      var _this17 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId == _this17.state.donViThamTraXacMinh;
      });

      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?" + "tenCoQuan=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&donViXuLyId=" + userInfo.donViId + "&noiDungDonThu=" + this.props.noiDungDonThu + "&donId=" + this.state.thongTinGiaiQuyetDonId + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY');
      window.open(URL, "_self");
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.closeDialog(name);
      this.handleKetThuc(name);
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this18 = this;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this18.state.ketQuaXLDGiaiQuyet;
      });
      var ketLuanNDKhieuNaiLabel = this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : this.props.loaiDon == 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh";
      var coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : '';
      // let textLabel = this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.huongThuLyGiaiQuyet == 'TU_TTXM' ? 'tự' : 'giao';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.componentsLoading != false },
          _react2.default.createElement('div', { className: 'component-loading' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.componentsLoading == false },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: true },
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                    lb2
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pb5' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.allowAttach },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BaoCaoKQTTXM', onSave: this.state.onSave, loaiDon: this.props.loaiDon, phanLoaiQuyTrinh: 'BAO_CAO_KET_QUA_TTXM', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', tTXMText: 'TTXM_TTT', tTXMRequired: true, bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5' },
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 pb15' },
                            _react2.default.createElement('span', { className: 'line-border' })
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                          ),
                          _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                          _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 pb5' },
                            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaHanGQTC', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIA_HAN', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'p',
                      { className: 'attach-file-description mb10 pl5 pr5' },
                      'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: !this.state.showTienDoGiaiQuyet },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.showTienDoGiaiQuyet },
                      _react2.default.createElement(_common.Text, { className: 'col-25', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: /*this.props.loaiDon == 'DON_TO_CAO' || */this.props.loaiDon == 'DON_KHIEU_NAI' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        _utils.ShowIfCheck,
                        { label: '\u0110\u1ED1i tho\u1EA1i', onChange: this.handleCheck.bind(this, 'doiThoai'), checked: this.state.doiThoai },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mt5' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            '\u0110\u1ED1i tho\u1EA1i'
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', bindValidator: this, channel: 'formTaoDon', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                            _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                            _react2.default.createElement(_common.TextArea, { className: 'col-100', require: true, bindValidator: this, channel: 'formTaoDon', name: 'ketQuaDoiThoai', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mb5 mt5' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_TO_CAO' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-25', name: 'inputSoVanBan', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                        _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), name: 'inputNgayBanHanh', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanhSuggest, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhSuggest') }),
                        _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                        this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }) : null,
                        this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }) : null,
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.allowAttach },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100' },
                            _react2.default.createElement(_upload.ContainerFileDinhKem, { unSetNgayBanHanh: true, quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, loaiVanBanSuggest: 'QDGQ_TTT', name: 'ThuHoiChoNN', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_TTT', qDGQRequired: this.state.tTXMRequired, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pt10 pb20' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                        this.props.donInfo.layVuViecCu === true && _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') }),
                          this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVu', value: this.state.soVuGiaiQuyetKhieuNai, onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai') }),
                          _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.props.loaiDon, label: ketLuanNDKhieuNaiLabel, className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter mb20' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', name: 'tienPhaiThuNhaNuocQDGQ', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ') }),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuocQDGQ', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter mb20' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'tienPhaiTraCongDanQDGQ', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ') }),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', name: 'datPhaiTraCongDanQDGQ', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                            ),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'tongSoNguoiXuLyHanhChinh', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDaBiXuLyHanhChinh', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDuocTraLaiQuyenLoi', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter pt5 pb15' },
                          _react2.default.createElement('span', { className: 'line-border' })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: (this.state.donViTheoDoiThucHien == coQuanQuanLyId || this.state.isThanhTraThanhPho || this.props.noRule) && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5 pb20' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10 mb20' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                          _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), name: 'coQuanTheoDoi', data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10 mb20' },
                        _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac'), name: 'ketQuaThucHienKhac' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mb20' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                          ),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienPhaiThuNhaNuoc', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuoc', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienDaThuNhaNuoc', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'datDaThuNhaNuoc', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc') })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                          ),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienPhaiTraCongDan', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'datPhaiTraCongDan', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienDaTraCongDan', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', name: 'datDaTraCongDan', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan') })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    _utils.ShowIfCheck,
                    { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25', label: 'T\xEAn c\u01A1 quan', bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5', name: 'soVuGiaoCoQuanDieuTra', value: this.state.soVuGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', name: 'soDoiTuongGiaoCoQuanDieuTra', value: this.state.soDoiTuongGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 })
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter pb5' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        _utils.ShowIfCheck,
                        { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mt5' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'Kh\u1EDFi t\u1ED1'
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-50 no-gutter mb20' },
                              _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVuBiKhoiTo', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                              _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', name: 'soDoiTuongBiKhoiTo', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showFile },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'KetThuc', onSave: this.state.onSave, phanLoaiQuyTrinh: '', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, data: this.state.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogLuuHoSo') },
                  _react2.default.createElement(
                    'span',
                    null,
                    this.state.btnText
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this, 'openDialogLuuHoSo'), onSuccess: this.onSuccess.bind(this, 'openDialogLuuHoSo'), title: this.state.titleDialog, content: this.state.contentDialog })
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return GiaiQuyetDonCanBo;
}(_react2.default.Component);

GiaiQuyetDonCanBo.defaultProps = {
  validators: {},
  tenCoQuan: [],
  ketQuaGiaiQuyetDon: [],
  donInfo: {},
  noRule: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    tenCoQuan: state.duLieuHeThong.donViTTXM,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(GiaiQuyetDonCanBo);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _DanhSachTaiLieuDinhKem = __webpack_require__(1117);

var _DanhSachTaiLieuDinhKem2 = _interopRequireDefault(_DanhSachTaiLieuDinhKem);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiaiQuyetDonCanBoNhapLieu = function (_React$Component) {
  _inherits(GiaiQuyetDonCanBoNhapLieu, _React$Component);

  function GiaiQuyetDonCanBoNhapLieu(props, context) {
    _classCallCheck(this, GiaiQuyetDonCanBoNhapLieu);

    var _this = _possibleConstructorReturn(this, (GiaiQuyetDonCanBoNhapLieu.__proto__ || Object.getPrototypeOf(GiaiQuyetDonCanBoNhapLieu)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      btnLoading: false,
      thongTinGiaiQuyetDon: _this.props.thongTinGiaiQuyetDonId,
      nextState: 'VAN_THU_CHUYEN_DON_VI_TTXM',
      yKienGiaiQuyet: '',
      listTaiLieuVanThuGiaiQuyetDon: _this.props.listTaiLieuVanThuGiaiQuyetDon,
      donViThamTraXacMinhInfo: [],
      ngayHetHanTTXM: ''
    };
    return _this;
  }

  _createClass(GiaiQuyetDonCanBoNhapLieu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDon);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.props.handleChangeData();
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      var params = {
        id: id
      };
      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this2.setState({
            donViThamTraXacMinhInfo: res.data.donViThamTraXacMinhInfo,
            ngayHetHanTTXM: new Date(res.data.ngayHetHanTTXM)
          });
        }
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this3 = this;

      this.setState({
        btnLoading: true
      });
      var selectedState = this.props.dataNextStates.filter(function (state) {
        return state.type == _this3.state.nextState;
      });
      var params = {
        thongTinGiaiQuyetDon: {
          id: Number(this.state.thongTinGiaiQuyetDon)
        },
        nextState: {
          id: Number(selectedState[0].stateId)
        },
        yKienGiaiQuyet: this.state.yKienGiaiQuyet
      };
      this.props.postGiaiQuyetDon(params);
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_ttForms.DropDownChonQuyTrinhGiaiQuyetDon, { className: 'clear-left', donId: this.state.id, require: true, isValid: this.state.isValid, selectedValue: this.state.nextState, onChange: this.onChange.bind(this, 'nextState') }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'col-25' },
              _react2.default.createElement(
                'span',
                { className: 'val-title-bold' },
                '\u0110\u01A1n v\u1ECB ',
                lb1,
                ':'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                this.state.donViThamTraXacMinhInfo ? this.state.donViThamTraXacMinhInfo.ten : ''
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-25' },
              _react2.default.createElement(
                'span',
                { className: 'val-title-bold' },
                'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                this.state.ngayHetHanTTXM ? (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') : ''
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(_DanhSachTaiLieuDinhKem2.default, { listTaiLieuVanThuGiaiQuyetDon: this.state.listTaiLieuVanThuGiaiQuyetDon })
          ),
          _react2.default.createElement(_common.TextArea, { label: '\xDD ki\u1EBFn x\u1EED l\xFD', onChange: this.onChange.bind(this, 'yKienGiaiQuyet') }),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? "btn-action btn-move action-todo btn-loading-inline" : "btn-action btn-move action-todo", onClick: this.handleGiaiQuyetDon.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Chuy\u1EC3n'
              )
            )
          )
        )
      );
    }
  }]);

  return GiaiQuyetDonCanBoNhapLieu;
}(_react2.default.Component);

exports.default = GiaiQuyetDonCanBoNhapLieu;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(192);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

var _checkThamSo = __webpack_require__(323);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vaiTro = 'CHUYEN_VIEN';
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
var buocGiaiQuyet = null;

var GiaiQuyetDonTruongPhong = function (_React$Component) {
  _inherits(GiaiQuyetDonTruongPhong, _React$Component);

  function GiaiQuyetDonTruongPhong(props, context) {
    _classCallCheck(this, GiaiQuyetDonTruongPhong);

    var gqText = '';
    if (props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
      gqText = 'Ban hành văn bản giải quyết';
    } else {
      if (props.loaiDon == 'DON_TO_CAO') {
        gqText = 'Ban hành kết luận nội dung tố cáo';
      } else {
        gqText = 'Ban hành quyết định giải quyết';
      }
    }

    var _this = _possibleConstructorReturn(this, (GiaiQuyetDonTruongPhong.__proto__ || Object.getPrototypeOf(GiaiQuyetDonTruongPhong)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTraDon: false,
      openDialogTruongPhongTTXM: false,
      focused: false,
      loaiDon: _this.props.loaiDon,
      id: _this.props.id,
      role: _this.props.roleGQ,
      validate: false,
      showAttach: false,
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      onSave: false,
      canBoGiaiQuyet: '',
      ngayHetHanKTDX: '',
      dataGiaiQuyetDon: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataNextState: [],
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      lyDoQuaHan: '',
      phongBanChiDinh: '',
      openDialogLuuHoSo: false,
      componentsLoading: true,
      isValid: false,
      tTXMRequired: false,
      open: false,
      showFile: false,
      lapToDoanXacMinh: false,
      giaHanGiaiQuyet: false,
      giaHanTTXM: false,
      doiThoai: false,
      giaoCoQuanDieuTra: false,
      quyetDinhGiaiQuyetKhieuNai: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,
      allowAttachGiaoCoQuanDieuTra: false,
      khongCoCoQuanTheoDoiThucHien: false,
      checkThanhTraThanhPho: false,
      isThanhTraThanhPho: false,

      //dialog
      btnText: '',
      titleDialog: '',
      contentDialog: '',
      //end

      isPhongBanThanhTra: false,
      checkPhongBanThanhTra: false,
      valueKetQua: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      dataFileDinhKem: {
        baoCaoKetQuaTTXM: [],
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      dataCoQuanTheoDoi: [],

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNai: '',

      //DON_KHIEU_NAI
      soQuyetDinhGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanGia: '',

      //DON_TO_CAO
      soQuyetDinhGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      soVuGiaiQuyetKhieuNai: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      yKienGiaiQuyet: '',

      tienPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      soNguoiDuocTraLaiQuyenLoi: '',

      noiDungDoiThoai: '',
      soLanGiaiQuyetLai: '',
      ketQuaThucHienKhac: '',
      ketQuaKhac: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',
      listTaiLieuVanThuGiaiQuyetDonView: _this.props.listTaiLieuVanThuGiaiQuyetDonView,
      allowAttach: false,
      isSoBanNganh: false,
      checkSoBanNganh: false,
      dataDonViTheoDoi: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      huongGiaiQuyet: '',
      ngayBanHanhSuggest: '',
      tenDonViTheoDoiThucHien: '',
      ketQuaXLDGiaiQuyet: '',
      dataKetQuaGiaiQuyetDon: [],
      tienDoDoiThoai: '',
      message: 'Ch\u1ECDn "' + _this.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?',
      coQuanTheoDoiThucHien: {},
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      allowTDTH: false,
      tenCoQuan: _this.props.tenCoQuan,
      gqText: gqText
    };
    return _this;
  }

  _createClass(GiaiQuyetDonTruongPhong, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.initHuongXuLyData(this.props.dataNextStates, 'dataNextState');
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      this.getListPhongBanNhanTDTH();
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('giai-quyet-don/subView/GiaiQuyetDonCanBo');
      }
      if (this.props.tenCoQuan.length === 0) {
        _api.DuLieuHeThong.actions.getDonViTTXM.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViTTXM',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'initHuongXuLyData',
    value: function initHuongXuLyData(inputData, name) {
      var ttxmText = this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var ttxmText1 = this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' ? ttxmText + ' và dự thảo văn bản GQ' : ttxmText;
      var getPhongBan = [].concat(_toConsumableArray(inputData)).filter(function (item) {
        if (item.type === "GQDTTTXM_GIAO_PHONG_CUNG_CAP" || item.type === "NHANTTXM_GIAO_PHONG_CUNG_CAP") {
          return item;
        }
      });
      if (getPhongBan.length) {
        var phoPhong = {
          stateId: getPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        inputData.push(phoPhong);
      }
      var outputData = [].concat(_toConsumableArray(inputData));
      outputData = outputData.map(function (item) {
        if (item.type === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          return item = _extends({}, item, {
            tenVietTat: 'G\u1EEDi b\xE1o c\xE1o ' + ttxmText1,
            ten: 'G\u1EEDi b\xE1o c\xE1o ' + ttxmText1
          });
        }
        if (item.type === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          return item = _extends({}, item, {
            tenVietTat: 'Tr\u1EA3 \u0111\u01A1n do chuy\u1EC3n ' + ttxmText + ' kh\xF4ng \u0111\xFAng',
            ten: 'Tr\u1EA3 \u0111\u01A1n do chuy\u1EC3n ' + ttxmText + ' kh\xF4ng \u0111\xFAng'
          });
        }
        if (item.type === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || item.type === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") {
          return item = _extends({}, item, {
            tenVietTat: "Tự giải quyết",
            ten: "Tự giải quyết"
          });
        }

        return item;
      });
      var getTheoDoiThucHien = outputData.find(function (item) {
        return item.type === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH";
      });
      if (getTheoDoiThucHien) {
        outputData = outputData.filter(function (item) {
          return item.type !== "KET_THUC" && item.type !== "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN";
        });
      } else {
        outputData = outputData.filter(function (item) {
          return item.type !== "KET_THUC";
        });
      }
      this.setState(_defineProperty({}, name, outputData));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataNextStates && nextProps.dataNextStates !== this.props.dataNextStates) {
        this.initHuongXuLyData(nextProps.dataNextStates, 'dataNextState');
      }
      if (nextProps.tenCoQuan !== this.props.tenCoQuan) {
        this.setState(_extends({}, this.state, {
          tenCoQuan: nextProps.tenCoQuan
        }));
      }
    }
  }, {
    key: 'getDonViNhanTheoDoiTH',
    value: function getDonViNhanTheoDoiTH() {
      var _this3 = this;

      var params = {
        donId: this.props.id,
        tuTTXM: true,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request(params).then(function (res) {
        if (res.data) {
          _this3.setState({ coQuanTheoDoiThucHien: res.data, allowTDTH: true });
        }
        _this3.initButton();
      }).catch(function (err) {
        _this3.initButton();
      });
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this4 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this4.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'checkSoBanNganh',
    value: function checkSoBanNganh() {
      var _this5 = this;

      var params = {
        tuKhoa: 'CCQQL_SO_BAN_NGANH'
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
          if (Number(userInfo.capCoQuanQuanLyCuaDonViId) === Number(res.data._embedded.thamSoes[0].giaTri)) {
            _this5.setState({
              isSoBanNganh: true,
              checkSoBanNganh: true
            }, function () {
              _this5.checkThanhTraThanhPho();
            });
          } else {
            _this5.setState({
              isSoBanNganh: false,
              isPhongBanThanhTra: false,
              checkPhongBanThanhTra: true,
              checkSoBanNganh: true,
              checkThanhTraThanhPho: true,
              isThanhTraThanhPho: false
            });
            _this5.getDonViNhanTheoDoiTH();
          }
        }
      }).catch(function (err) {
        _this5.setState({
          isSoBanNganh: false,
          isPhongBanThanhTra: false,
          checkPhongBanThanhTra: true,
          checkSoBanNganh: true,
          checkThanhTraThanhPho: true,
          isThanhTraThanhPho: false
        });
        _this5.getDonViNhanTheoDoiTH();
      });
    }
  }, {
    key: 'checkThanhTraThanhPho',
    value: function checkThanhTraThanhPho() {
      var _this6 = this;

      var params = {
        tuKhoa: 'CQQL_THANH_TRA_THANH_PHO'
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res.data._embedded && res.data._embedded.thamSoes && res.data._embedded.thamSoes.length > 0) {
          var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
          _this6.setState({
            checkThanhTraThanhPho: true,
            isThanhTraThanhPho: Number(userInfo.donViId) === Number(res.data._embedded.thamSoes[0].giaTri)
          }, function () {
            _this6.getPhongBanNhanTDTH();
          });
        }
      }).catch(function (err) {
        _this6.setState({
          checkThanhTraThanhPho: true,
          isThanhTraThanhPho: false
        }, function () {
          _this6.getPhongBanNhanTDTH();
        });
      });
    }
  }, {
    key: 'getListPhongBanNhanTDTH',
    value: function getListPhongBanNhanTDTH() {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.getListPhongBanNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            dataPhongBanNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getPhongBanNhanTDTH',
    value: function getPhongBanNhanTDTH() {
      var _this8 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var idQuan = ts.filter(function (item) {
        return item.ten === 'CCQQL_UBND_QUAN_HUYEN';
      });

      _api.GiaiQuyetDonThu.actions.getPhongBanNhanTDTH.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten,
            checkPhongBanThanhTra: true,
            allowTDTH: true
          });
        }
        _this8.initButton();
      }).catch(function (err) {
        // if (idQuan.length && userInfo.capCoQuanQuanLyCuaDonViChaId !== idQuan[0].giaTri && this.state.isThanhTraThanhPho === false) {
        //   Toastr('Không có cơ quan tiếp nhận theo dõi thực hiện', 'error');
        // }
        _this8.setState({
          checkPhongBanThanhTra: true,
          khongCoCoQuanTheoDoiThucHien: true
        });
        _this8.initButton();
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this10 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'initButton',
    value: function initButton() {
      var _this11 = this;

      var coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : '';
      var _btnText = 'Chuyển theo dõi thực hiện';
      var _titleDialog = 'Xác nhận';
      var _contentDialog = 'Không có đơn vị nhận theo dõi thực hiện?';
      if (this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.donViTheoDoiThucHien === this.props.coQuanQuanLyNguoiDung.id || this.state.isThanhTraThanhPho || !this.state.allowTDTH) {
        _btnText = 'Lưu hồ sơ';
        _titleDialog = 'Xác nhận lưu hồ sơ';
        _contentDialog = 'Bạn có muốn lưu hồ sơ này?';
      } else if (!this.state.khongCoCoQuanTheoDoiThucHien) {
        if (this.state.isSoBanNganh) {
          _contentDialog = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?';
        } else {
          _contentDialog = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.coQuanTheoDoiThucHien.ten + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?';
        }
      }

      this.setState({
        tTXMRequired: true,
        btnText: _btnText,
        titleDialog: _titleDialog,
        contentDialog: _contentDialog
      }, function () {
        _this11.setState({
          componentsLoading: false
        });
      });
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this12 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this12.state.giaoCoQuanDieuTra === false) {
          _this12.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra)) || [];
          var data = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra)) || [];
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired === 'GIAO_CO_QUAN_DIEU_TRA';
          });
          if (dataCheck.length > 0) {
            _this12.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this12.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this13 = this;

      var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      var getUserInfoId = userInfo.id;
      if (name === 'nextState' && e.target.value === 'KET_THUC') {
        this.setState({
          canBoGiaiQuyet: getUserInfoId
        });
      }
      if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        this.setState(_defineProperty({
          showAttach: false,
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: ''
        }, name, e.target.value), function () {
          _this13.checkFileRequired();
        });
      } else if (name == 'nextState' && (e.target.value == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || e.target.value == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN')) {
        this.setState(_defineProperty({
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: '',
          showAttach: false
        }, name, e.target.value), function () {
          _this13.filterFileRequired();
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }

      if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.setState(_extends({}, this.state, {
          message: 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?',
          open: true,
          valueKetQua: e.target.value
        }));
      } else if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.setState(_extends({}, this.state, {
          message: 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
          open: true,
          valueKetQua: e.target.value
        }));
      } else if (name === 'nextState') {
        if (e.target.value === 'KET_THUC') {
          this.setState(_defineProperty({
            tTXMRequired: true
          }, name, e.target.value));
        } else {
          this.checkFileRequired(e.target.value);
        }
      } else {
        var _setState6;

        if (name == 'tienDoDoiThoai' && e.target.value !== 'KHONG_DOI_THOAI') {
          this.state.tienDoDoiThoai = e.target.value;
          this.state.ketQuaXLDGiaiQuyet = '';
          this.setState(_extends({}, this.state));
        }
        var state = this.state;
        if (name === 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          state.ketQuaGiaiQuyetLan2 = '';
        }

        if (name === 'ketQuaGiaiQuyetLan2' && Number(e.target.value) !== 'HUY_SUA_QDGQ_LAN_I') {
          state.noiDungKetLuanGiaiQuyetLai = '';
        }

        if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_DON_VI_TTXM') {
          state.tTXMRequired = false;
        }
        this.setState((_setState6 = {}, _defineProperty(_setState6, name, e.target.value), _defineProperty(_setState6, 'state', state), _setState6));
      }
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this14 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this14.setState({
              dataGiaiQuyetDon: res.data,
              phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
              lyDoQuaHan: res.data.lyDoQuaHan || '',
              noiDung: res.data.noiDung ? res.data.noiDung : '',
              giaHanTTXM: res.data.giaHanTTXM,
              giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,
              nextStateInfo: res.data.nextStateInfo,
              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : _this14.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' : '',
              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? (0, _moment2.default)(res.data.ngayHetHanSauKhiGiaHanTTXM).format('DD/MM/YYYY') : '',
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '',
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',
              soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
              truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',
              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
              soQuyetDinhGiaHanTTXM: res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
              ngayRaQuyetDinhGiaHanTTXM: res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',
              soQuyetDinhGiaHanGiaiQuyet: res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
              ngayRaQuyetDinhGiaHanGiaiQuyet: res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              ngayBanHanhSuggest: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,
              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra,
              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
              lapToDoanXacMinh: res.data.lapToDoanXacMinh,
              doiThoai: res.data.doiThoai,
              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',
              donViThamTraXacMinh: res.data.donViThamTraXacMinhInfo ? res.data.donViThamTraXacMinhInfo.coQuanQuanLyId : '',
              ngayHetHanTTXM: res.data.ngayHetHanTTXM ? new Date(res.data.ngayHetHanTTXM) : '',
              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              tienDoDoiThoai: 'KHONG_DOI_THOAI',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? true : false,
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              showFile: true,
              allowAttach: true
            }, function () {
              _this14.checkOnlyState();
              if (_this14.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
                _this14.checkFileRequired();
              } else {
                _this14.filterFileRequired();
              }
              _this14.checkFileCoQuanDieuTra();
            });
          }
          _this14.checkSoBanNganh();
        });
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState() {
      var _this15 = this;

      if (this.props.dataNextStates.length == 1) {
        this.setState({
          nextState: this.props.dataNextStates[0].type
        }, function () {
          if (_this15.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            _this15.checkFileRequired();
          }
          if (_this15.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
            _this15.filterFileRequired();
          }
        });
      }
    }
  }, {
    key: 'filterFileRequired',
    value: function filterFileRequired() {
      var _this16 = this;

      var dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this16.state.donViId;
      });
      dataShow = dataShow.filter(function (state) {
        return state.typeRequired != 'BC_KQTTXM' && state.typeRequired != 'KQTTXM_DTVBGQ';
      });
      if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
        dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM;
      }
      this.setState({
        ListTaiLieuVanThuShow: dataShow,
        showAttach: true
      });
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this17 = this;

      this.setState({
        showFile: false
      });
      var listTaiLieuVanThuGiaiQuyetDonView = this.state.listTaiLieuVanThuGiaiQuyetDonView ? [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView)) : [];
      var dataCheckFileRequired = listTaiLieuVanThuGiaiQuyetDonView.filter(function (state) {
        return state.required && state.typeRequired === 'QD_GTTXM';
      });
      var data = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM.filter(function (state) {
        return state.nguoiTaoInfo.donViId === _this17.state.donViId;
      });
      var dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId !== _this17.state.donViId;
      });
      if (dataCheckFileRequired.length > 0) {
        // do nothing
        this.setState({
          showFile: true
        });
      } else {
        var fileRequired = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'QD_GTTXM'
        };
        if (this.state.loaiDon === 'DON_KHIEU_NAI') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
        } else if (this.state.loaiDon === 'DON_TO_CAO') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung tố cáo';
        } else {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung kiến nghị phản ánh';
        }
        var _listTaiLieuVanThuGiaiQuyetDonView = this.state.listTaiLieuVanThuGiaiQuyetDonView ? [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView), [fileRequired]) : [];
        this.setState({
          listTaiLieuVanThuGiaiQuyetDonView: _listTaiLieuVanThuGiaiQuyetDonView,
          showFile: true
        });
      }
      if (this.props.loaiDon === 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO' || this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
        var isTTXML = this.props.donInfo && this.props.donInfo.laTTXMLai ? true : false;
        if (isTTXML === true) {
          dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView.filter(function (item) {
            return item.typeRequired != 'BC_KQTTXM_L';
          });
          data = data.filter(function (item) {
            return item.typeRequired !== 'BC_KQTTXM' && item.typeRequired !== 'KQTTXM_DTVBGQ';
          });
        }
        var checkKQTTXM = data.filter(function (item) {
          if (isTTXML === true) return item.typeRequired == 'BC_KQTTXM_L';else return item.typeRequired == 'BC_KQTTXM';
        });
        if (checkKQTTXM.length === 0) {
          var itemKQTTXM = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: isTTXML == true ? 'BC_KQTTXM_L' : 'BC_KQTTXM',
            newFile: true
          };
          if (this.props.loaiDon === 'DON_TO_CAO') {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo' + (isTTXML == true ? ' (Lần 2)' : '');
          } else if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
            itemKQTTXM.ten = 'Văn bản xác minh đề xuất' + (isTTXML === true ? ' (Lần 2)' : '');
          } else {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại' + (isTTXML === true ? ' (Lần 2)' : '');
          }
          data = [].concat(_toConsumableArray(data), [itemKQTTXM]);
        }

        if ((this.props.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || this.props.loaiDon == 'DON_TO_CAO') && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          var checkDTVBGQ = data.filter(function (item) {
            if (isTTXML == true) return item.typeRequired == 'KQTTXM_DTVBGQ_L';else return item.typeRequired == 'KQTTXM_DTVBGQ';
          });
          if (checkDTVBGQ.length === 0) {
            var itemDTVBGQ = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              ten: this.props.loaiDon == 'DON_TO_CAO' ? 'Dự thảo kết luận nội dung tố cáo' : 'Dự thảo văn bản giải quyết',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: isTTXML == true ? 'KQTTXM_DTVBGQ_L' : 'KQTTXM_DTVBGQ',
              newFile: true
            };
            data = [].concat(_toConsumableArray(data), [itemDTVBGQ]);
          }
        }
      }
      this.setState({
        ListTaiLieuVanThu: data,
        ListTaiLieuVanThuShow: dataShow,
        showAttach: true
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        var setNgayBanHanh = {};
        if (name === 'ngayBanHanhSuggest') {
          setNgayBanHanh.ngayBanHanh = e._d;
        }
        this.setState(_extends({}, setNgayBanHanh, _defineProperty({}, name, e._d)));
      } else {
        var _setNgayBanHanh = {};
        if (name === 'ngayBanHanhSuggest') {
          _setNgayBanHanh.ngayBanHanh = e;
        }
        this.setState(_extends({}, _setNgayBanHanh, _defineProperty({}, name, e)));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this18 = this;

      this.setState({
        onSave: true
      }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dataFileDinhKem, _taiLieuVanThuUpdate, _taiLieuVanThu, dataFile, _dataFile, params, selectedState, _params2, _selectedState, _params3, _selectedState2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this18.setState({
                  btnLoading: true,
                  btnSaveLoading: true
                });
                dataFileDinhKem = _this18.getListDataFileDinhKem('KET_THUC');

                if (!(dataFileDinhKem.length > 0)) {
                  _context.next = 8;
                  break;
                }

                _taiLieuVanThuUpdate = [];
                _taiLieuVanThu = [];

                dataFileDinhKem.forEach(function (item) {
                  if (item.taiLieuVanThuId) {
                    _taiLieuVanThuUpdate[_taiLieuVanThuUpdate.length] = {
                      don: {
                        id: Number(_this18.state.id)
                      },
                      id: item.taiLieuVanThuId,
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: item.loaiTepDinhKem,
                      loaiQuyTrinh: item.loaiQuyTrinh,
                      buocGiaiQuyet: item.buocGiaiQuyet,
                      required: item.required,
                      typeRequired: item.typeRequired || ''
                    };
                  } else {
                    _taiLieuVanThu[_taiLieuVanThu.length] = {
                      don: {
                        id: Number(_this18.state.id)
                      },
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: loaiTepDinhKem,
                      loaiQuyTrinh: loaiQuyTrinh,
                      buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                      required: item.required,
                      typeRequired: item.typeRequired || ''
                    };
                  }
                });
                _context.next = 8;
                return _this18.setState({
                  taiLieuVanThuUpdate: _taiLieuVanThuUpdate,
                  taiLieuVanThu: _taiLieuVanThu
                });

              case 8:
                if (_this18.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this18.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
                  dataFile = _this18.props.listTaiLieuVanThuGiaiQuyetDon ? [].concat(_toConsumableArray(_this18.props.listTaiLieuVanThuGiaiQuyetDon)) : [];

                  dataFile.forEach(function (item) {
                    _this18.setState({
                      taiLieuVanThuDelete: {
                        id: item.taiLieuVanThuId || ''
                      }
                    });
                  });
                }

                if (!_this18.state.giaoCoQuanDieuTra) {
                  _dataFile = _this18.props.listTaiLieuVanThuGiaiQuyetDon ? [].concat(_toConsumableArray(_this18.props.listTaiLieuVanThuGiaiQuyetDon)) : [];

                  _dataFile.forEach(function (item) {
                    _this18.setState({
                      taiLieuVanThuDelete: {
                        id: item.taiLieuVanThuId || ''
                      }
                    });
                  });
                }

                if (_this18.state.dataTaiLieuVanThuDelete && _this18.state.dataTaiLieuVanThuDelete.length > 0) {
                  _this18.state.dataTaiLieuVanThuDelete.map(function (item) {
                    _this18.setState({
                      taiLieuVanThuDelete: {
                        id: item || ''
                      }
                    });
                  });
                }

                if (_this18.state.role === 'truongPhongGiaiQuyetDon') {
                  params = _this18.getParams(_this18.state.dataGiaiQuyetDon, _this18.state.id);

                  if (_this18.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
                    params.phoPhong = true;
                  } else {
                    params.phoPhong = false;
                  }
                  if (_this18.state.nextState) {
                    selectedState = _this18.state.dataNextState.filter(function (state) {
                      return state.type == _this18.state.nextState;
                    });

                    params.nextState = {
                      id: selectedState[0].stateId
                    };
                  } else {
                    params.nextState = null;
                  }
                  if (_this18.state.canBoGiaiQuyet) {
                    params.canBoXuLyChiDinh = {
                      id: Number(_this18.state.canBoGiaiQuyet)
                    };
                  }
                  params.ngayHetHanGiaiQuyet = (0, _moment2.default)(_this18.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
                  params.yKienGiaiQuyet = _this18.state.yKienGiaiQuyet;
                  if (_this18.state.ketQuaXLDGiaiQuyet) {
                    params.ketQuaXLDGiaiQuyet = _this18.state.ketQuaXLDGiaiQuyet;
                  }
                  if (_this18.state.soVanBan) {
                    params.soVanBan = _this18.state.soVanBan;
                  }
                  if (_this18.state.ngayBanHanhSuggest) {
                    params.ngayBanHanh = _this18.state.ngayBanHanhSuggest ? (0, _moment2.default)(_this18.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;;
                  }
                  if (_this18.state.nguoiBanHanh) {
                    params.nguoiBanHanh = {
                      id: Number(_this18.state.nguoiBanHanh)
                    };
                  }
                  if (_this18.state.ketLuanNoiDungKhieuNai) {
                    params.ketLuanNoiDungKhieuNai = _this18.state.ketLuanNoiDungKhieuNai;
                  }
                  if (_this18.state.phongBanChiDinh) {
                    params.phongBanGiaiQuyet = {
                      id: Number(_this18.state.phongBanChiDinh)
                    };
                  }
                  _this18.postTaiLieuVanThu(_this18.state.taiLieuVanThu, function () {
                    _this18.updateTaiLieuVanThu(_this18.state.taiLieuVanThuUpdate, function () {
                      _this18.deleteTaiLieuVanThu(_this18.state.taiLieuVanThuDelete, function () {
                        _this18.props.saveGiaiQuyetDon(params, 'gqdLuu');
                      });
                    });
                  });
                } else if (_this18.state.role === 'truongPhongKiemTraDeXuat') {
                  _params2 = _this18.getParams(_this18.state.dataGiaiQuyetDon, _this18.state.id);

                  if (_this18.state.nextState) {
                    _selectedState = _this18.state.dataNextState.filter(function (state) {
                      return state.type === _this18.state.nextState;
                    });

                    _params2.nextState = {
                      id: _selectedState[0].stateId
                    };
                  } else {
                    _params2.nextState = null;
                  }
                  _params2.canBoXuLyChiDinh = {
                    id: Number(_this18.state.canBoGiaiQuyet)
                  };
                  _params2.yKienGiaiQuyet = _this18.state.yKienGiaiQuyet;
                  _this18.postTaiLieuVanThu(_this18.state.taiLieuVanThu, function () {
                    _this18.updateTaiLieuVanThu(_this18.state.taiLieuVanThuUpdate, function () {
                      _this18.deleteTaiLieuVanThu(_this18.state.taiLieuVanThuDelete, function () {
                        _this18.props.saveGiaiQuyetDon(_params2, 'gqdLuu');
                      });
                    });
                  });
                } else {
                  _params3 = _this18.getParams(_this18.state.dataGiaiQuyetDon, _this18.state.id);

                  if (_this18.state.nextState) {
                    _selectedState2 = _this18.state.dataNextState.filter(function (state) {
                      return state.type === _this18.state.nextState;
                    });

                    _params3.nextState = {
                      id: _selectedState2[0].stateId
                    };
                  } else {
                    _params3.nextState = null;
                  }
                  _params3.canBoXuLyChiDinh = {
                    id: Number(_this18.state.canBoGiaiQuyet)
                  };
                  _params3.yKienGiaiQuyet = _this18.state.yKienGiaiQuyet;
                  _this18.postTaiLieuVanThu(_this18.state.taiLieuVanThu, function () {
                    _this18.updateTaiLieuVanThu(_this18.state.taiLieuVanThuUpdate, function () {
                      _this18.deleteTaiLieuVanThu(_this18.state.taiLieuVanThuDelete, function () {
                        _this18.props.saveGiaiQuyetDon(_params3, 'gqdLuu');
                      });
                    });
                  });
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this18);
      })));
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc(name) {
      var _this19 = this;

      if (this.state.khongCoCoQuanTheoDoiThucHien === true && this.state.isSoBanNganh && this.state.isThanhTraThanhPho !== true) {
        //do nothing
        (0, _toastr.Toastr)('Không có đơn vị nhận theo dõi thực hiện', 'error');
        return;
      } else {
        this.setState({
          onSave: false
        }, function () {
          if (_this19.validateSubmitForm()) {
            _this19.setState({
              btnLoading: true
            });
            var dataFileDinhKem = _this19.getListDataFileDinhKem('KET_THUC');
            if (dataFileDinhKem.length > 0) {
              dataFileDinhKem.forEach(function (item) {
                if (item.taiLieuVanThuId) {
                  var _state = _this19.state;
                  _state.taiLieuVanThuUpdate[_state.taiLieuVanThuUpdate.length] = {
                    don: {
                      id: Number(_this19.state.id)
                    },
                    id: item.taiLieuVanThuId,
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: item.loaiTepDinhKem,
                    loaiQuyTrinh: item.loaiQuyTrinh,
                    buocGiaiQuyet: item.buocGiaiQuyet,
                    required: item.required,
                    typeRequired: item.typeRequired || ''
                  };
                  _this19.setState({ state: _state });
                } else {
                  var _state2 = _this19.state;
                  _state2.taiLieuVanThu[_state2.taiLieuVanThu.length] = {
                    don: {
                      id: Number(_this19.state.id)
                    },
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: loaiTepDinhKem,
                    loaiQuyTrinh: loaiQuyTrinh,
                    buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                    required: item.required,
                    typeRequired: item.typeRequired || ''
                  };
                  _this19.setState({ state: _state2 });
                }
              });
            }
            var state = _this19.state;
            if (_this19.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this19.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
              var dataFile = [].concat(_toConsumableArray(_this19.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
              dataFile.forEach(function (item) {
                state.taiLieuVanThuDelete = {
                  id: item.taiLieuVanThuId
                };
              });
            }
            if (!_this19.state.giaoCoQuanDieuTra) {
              var _dataFile2 = _this19.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra ? [].concat(_toConsumableArray(_this19.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra)) : [];
              _dataFile2.map(function (item) {
                _this19.state.taiLieuVanThuDelete[_this19.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }
            if (_this19.state.dataTaiLieuVanThuDelete && _this19.state.dataTaiLieuVanThuDelete.length > 0) {
              _this19.state.dataTaiLieuVanThuDelete.forEach(function (item) {
                state.taiLieuVanThuDelete = {
                  id: item
                };
              });
            }
            _this19.setState(state);
            var _params = _this19.getParams();
            var coQuanQuanLyId = _this19.props.dataGiaiQuyet && _this19.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && _this19.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? _this19.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : {};
            var params = {};
            var msgName = '';
            var coQuanQuanLyNguoiDungId = _this19.state.coQuanQuanLyNguoiDung && _this19.state.coQuanQuanLyNguoiDung.id;

            if (_this19.state.isSoBanNganh && _this19.state.donViTheoDoiThucHien !== coQuanQuanLyId && !_this19.state.isThanhTraThanhPho && _this19.state.donViTheoDoiThucHien !== coQuanQuanLyNguoiDungId) {
              if (_this19.props.tuGiaiQuyet) {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  phongBanGiaiQuyet: {
                    id: Number(_this19.state.donViTheoDoiThucHien)
                  },
                  actionType: 'QGD_GIAO_PHONG_BAN_KHAC_TDTH'
                };
                params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhDinhChi;
                if (_this19.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                  params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhGiaiQuyet;
                }
              } else {
                var selectedState = _this19.props.dataNextStates.filter(function (state) {
                  return state.type == _this19.state.nextState;
                });
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  phongBanGiaiQuyet: {
                    id: Number(_this19.state.donViTheoDoiThucHien)
                  },
                  nextState: {
                    id: Number(selectedState[0].stateId)
                  }
                };
                params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhDinhChi;
                if (_this19.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                  params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhGiaiQuyet;
                }
              }
              msgName = 'gqdChuyenTheoDoi';
            } else if ((_this19.state.nextState === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || _this19.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") && _this19.state.donViTheoDoiThucHien !== coQuanQuanLyNguoiDungId) {
              var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
              var tttp = 'CQQL_THANH_TRA_THANH_PHO';
              var isThanhTraThanhPho = ThamSo.find(function (state) {
                return state.ten === tttp;
              });
              var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
              if (isThanhTraThanhPho && isThanhTraThanhPho.giaTri === userInfo.donViId) {
                var stateKetThuc = 8;
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  nextState: {
                    id: stateKetThuc
                  }
                };
                msgName = 'gqdLuuHoSo';
              } else {
                if (_this19.state.coQuanTheoDoiThucHien) {
                  _params.donViTheoDoiThucHien = {
                    id: _this19.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                  };
                }
                var _selectedState3 = _this19.props.dataNextStates.filter(function (state) {
                  return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
                });

                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  donViTheoDoiThucHien: {
                    id: _this19.state.coQuanTheoDoiThucHien.coQuanQuanLyId
                  },
                  nextState: {
                    id: Number(_selectedState3[0].stateId)
                  }
                };
                msgName = 'gqdChuyenTheoDoi';
              }
              params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhDinhChi;
              if (_this19.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = _this19.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
            } else {
              if (_this19.props.tuGiaiQuyet) {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  actionType: 'QGD_TU_TTXM'
                };
              } else if (_this19.state.donViTheoDoiThucHien === coQuanQuanLyNguoiDungId && _this19.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH") {
                var _selectedState4 = _this19.props.dataNextStates.find(function (state) {
                  return state.type === "KET_THUC";
                });
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  nextState: {
                    id: Number(_selectedState4.stateId)
                  }
                };
                msgName = 'gqdLuuHoSo';
              } else {
                var _selectedState5 = _this19.props.dataNextStates.filter(function (state) {
                  return state.type == _this19.state.nextState;
                });
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this19.props.thongTinGiaiQuyetDonId)
                  },
                  nextState: {
                    id: Number(_selectedState5[0].stateId)
                  }
                };
              }
              msgName = 'gqdLuuHoSo';
            }
            _this19.postTaiLieuVanThu(_this19.state.taiLieuVanThu, function () {
              _this19.updateTaiLieuVanThu(_this19.state.taiLieuVanThuUpdate, function () {
                _this19.deleteTaiLieuVanThu(_this19.state.taiLieuVanThuDelete, function () {
                  _this19.props.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          }
        });
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name === 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this20 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var selectedState = this.state.dataNextState.filter(function (state) {
          return state.type === _this20.state.nextState;
        });
        if (this.state.role === 'truongPhongGiaiQuyetDon') {
          if (this.state.nextState === 'GQDTTTXM_GIAO_PHONG_CUNG_CAP') {
            var _params = (0, _GetParams.getParams)(this.state.dataGiaiQuyetDon, this.state.id);
            _params.ngayHetHanGiaiQuyet = (0, _moment2.default)(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
            var params = {
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet,
              phongBanGiaiQuyet: {
                id: Number(this.state.phongBanChiDinh)
              }
            };
            /* if (this.state.canBoGiaiQuyet) {
              params.canBoXuLyChiDinh = {
                id: Number(this.state.canBoGiaiQuyet)
              };
            } */
            this.props.updateGiaiQuyetDon(_params, params, 'gqdGiaoViec');
          } else if (this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
            var _params4 = (0, _GetParams.getParams)(this.state.dataGiaiQuyetDon, this.state.id);
            _params4.ngayHetHanGiaiQuyet = (0, _moment2.default)(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
            var _params5 = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              phoPhong: true,
              yKienGiaiQuyet: this.state.yKienGiaiQuyet,
              phongBanGiaiQuyet: {
                id: Number(this.state.coQuanQuanLyNguoiDung.id)
              }
            };
            this.props.updateGiaiQuyetDon(_params4, _params5, 'gqdGiaoViec');
          } else {
            var _params6 = (0, _GetParams.getParams)(this.state.dataGiaiQuyetDon, this.state.id);
            _params6.ngayHetHanGiaiQuyet = (0, _moment2.default)(this.state.ngayHetHanGiaiQuyet).add(7, 'hours').toISOString();
            var _params7 = {
              canBoXuLyChiDinh: {
                id: Number(this.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(this.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: this.state.yKienGiaiQuyet
            };
            this.props.updateGiaiQuyetDon(_params6, _params7, 'gqdGiaoViec');
          }
        } else if (this.state.role === 'truongPhongKiemTraDeXuat') {

          var _params8 = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          this.props.postGiaiQuyetDon(_params8, 'gqdGiaoViec');
        } else {
          var _params9 = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          this.props.postGiaiQuyetDon(_params9, 'gqdGiaoViec');
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      if (this.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH" || this.state.nextState === 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN') {
        this.closeDialog(name);
        this.handleKetThuc(name);
      } else {
        this.closeDialog(name);
        this.truongPhongGQD();
      }
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      });
    }
  }, {
    key: 'saveTruongPhongGQD',
    value: function saveTruongPhongGQD() {
      var _this21 = this;

      this.setState({
        onSave: true
      }, function () {
        _this21.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDelete = [];
        if (_this21.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this21.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          if (_this21.state.dataFileDinhKem && Array.isArray(_this21.state.dataFileDinhKem.data)) {
            _this21.state.dataFileDinhKem.data.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this21.state.taiLieuVanThuUpdate[_this21.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this21.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this21.state.taiLieuVanThu[_this21.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this21.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: _this21.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (Array.isArray(_this21.state.dataTaiLieuVanThuDelete)) {
              _this21.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this21.state.taiLieuVanThuDelete[_this21.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          }
        } else {
          var data = [].concat(_toConsumableArray(_this21.props.listTaiLieuVanThuGiaiQuyetDon));
          data.filter(function (state) {
            return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
          }).map(function (item) {
            dataFileDelete[dataFileDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        var params = (0, _GetParams.getParams)(_this21.state.dataGiaiQuyetDon, _this21.state.id);
        var isQuaHan = _this21.props.donInfo.thoiHanTTXMInfo && _this21.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
        if (isQuaHan == true) {
          params.lyDoQuaHan = _this21.state.lyDoQuaHan;
        }
        if (_this21.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
          params.phoPhong = true;
        } else {
          params.phoPhong = false;
        }
        var selectedState = _this21.state.dataNextState.filter(function (state) {
          return state.type == _this21.state.nextState;
        });

        if (selectedState.length > 0) {
          params.nextState = {
            id: selectedState[0].stateId
          };
        }

        if (_this21.state.canBoGiaiQuyet) {
          params.canBoXuLyChiDinh = {
            id: Number(_this21.state.canBoGiaiQuyet)
          };
        } else {
          params.canBoXuLyChiDinh = null;
        }

        if (_this21.state.ketLuanNoiDungKhieuNaiGiaoTTXM) {
          params.ketLuanNoiDungKhieuNaiGiaoTTXM = _this21.state.ketLuanNoiDungKhieuNaiGiaoTTXM;
        } else {
          params.ketLuanNoiDungKhieuNaiGiaoTTXM = null;
        }

        params.yKienGiaiQuyet = _this21.state.yKienGiaiQuyet ? _this21.state.yKienGiaiQuyet : '';
        params.noiDung = _this21.state.noiDung ? _this21.state.noiDung : '';
        if (_this21.state.phongBanChiDinh) {
          params.phongBanGiaiQuyet = {
            id: Number(_this21.state.phongBanChiDinh)
          };
        }
        if (_this21.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this21.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          _this21.postTaiLieuVanThu(_this21.state.taiLieuVanThu, function () {
            _this21.updateTaiLieuVanThu(_this21.state.taiLieuVanThuUpdate, function () {
              _this21.deleteTaiLieuVanThu(_this21.state.taiLieuVanThuDelete, function () {
                _this21.props.saveGiaiQuyetDon(params, 'gqdLuu');
              });
            });
          });
        } else {
          _this21.deleteTaiLieuVanThu(dataFileDelete, function () {
            _this21.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        }
      });
    }
  }, {
    key: 'truongPhongGQD',
    value: function truongPhongGQD() {
      var _this22 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this22.validateSubmitForm()) {
          _this22.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          var dataFileDelete = [];
          if (_this22.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this22.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
            if (_this22.state.dataFileDinhKem && Array.isArray(_this22.state.dataFileDinhKem.data)) {
              _this22.state.dataFileDinhKem.data.map(function (item, i) {
                if (item.taiLieuVanThuId) {
                  _this22.state.taiLieuVanThuUpdate[_this22.state.taiLieuVanThuUpdate.length] = {
                    don: {
                      id: Number(_this22.state.id)
                    },
                    id: item.taiLieuVanThuId,
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: item.loaiTepDinhKem,
                    loaiQuyTrinh: item.loaiQuyTrinh,
                    buocGiaiQuyet: item.buocGiaiQuyet,
                    required: item.required,
                    typeRequired: item.typeRequired ? item.typeRequired : ''
                  };
                } else {
                  _this22.state.taiLieuVanThu[_this22.state.taiLieuVanThu.length] = {
                    don: {
                      id: Number(_this22.state.id)
                    },
                    ten: item.ten,
                    soQuyetDinh: item.soQuyetDinh,
                    ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                    tenFile: item.tenFile,
                    duongDan: item.duongDan,
                    loaiTepDinhKem: loaiTepDinhKem,
                    loaiQuyTrinh: _this22.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                    buocGiaiQuyet: buocGiaiQuyet,
                    required: item.required,
                    typeRequired: item.typeRequired ? item.typeRequired : ''
                  };
                }
              });

              if (Array.isArray(_this22.state.dataTaiLieuVanThuDelete)) {
                _this22.state.dataTaiLieuVanThuDelete.map(function (item) {
                  _this22.state.taiLieuVanThuDelete[_this22.state.taiLieuVanThuDelete.length] = {
                    id: item
                  };
                });
              }
            }
          } else {
            var data = [].concat(_toConsumableArray(_this22.props.listTaiLieuVanThuGiaiQuyetDon));
            if (_this22.props.donInfo && _this22.props.donInfo.laTTXMLai) {
              data.filter(function (state) {
                return state.required && state.typeRequired == 'BC_KQTTXM_GQKN_L';
              }).map(function (item) {
                dataFileDelete = [].concat(_toConsumableArray(dataFileDelete), [{ id: item.taiLieuVanThuId }]);
              });
            } else {
              data.filter(function (state) {
                return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
              }).map(function (item) {
                dataFileDelete = [].concat(_toConsumableArray(dataFileDelete), [{ id: item.taiLieuVanThuId }]);
              });
            }
          }
          var _params = (0, _GetParams.getParams)(_this22.state.dataGiaiQuyetDon, _this22.state.id);
          var selectedState = _this22.state.dataNextState.filter(function (state) {
            return state.type == _this22.state.nextState;
          });
          var msgName = '';
          var params = {};
          var isQuaHan = _this22.props.donInfo.thoiHanTTXMInfo && _this22.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
          if (selectedState.length > 0) {
            _params.nextState = {
              id: selectedState[0].stateId
            };
          }

          if (_this22.state.canBoXuLyChiDinh) {
            _params.canBoXuLyChiDinh = {
              id: Number(_this22.state.canBoGiaiQuyet)
            };
          } else {
            _params.canBoXuLyChiDinh = null;
          }

          if (_this22.state.ketLuanNoiDungKhieuNaiGiaoTTXM) {
            _params.ketLuanNoiDungKhieuNaiGiaoTTXM = _this22.state.ketLuanNoiDungKhieuNaiGiaoTTXM;
          } else {
            _params.ketLuanNoiDungKhieuNaiGiaoTTXM = null;
          }

          _params.yKienGiaiQuyet = _this22.state.yKienGiaiQuyet ? _this22.state.yKienGiaiQuyet : _this22.state.noiDung ? _this22.state.noiDung : '';
          _params.noiDung = _this22.state.noiDung ? _this22.state.noiDung : '';

          if (_this22.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this22.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this22.state.noiDung
            };
            if (isQuaHan == true) {
              params.lyDoQuaHan = _this22.state.lyDoQuaHan;
            }
            msgName = 'gqdTraBaoCao';
          } else if (_this22.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this22.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this22.state.yKienGiaiQuyet
            };
            msgName = 'gqdTraDonThanhCong';
          } else if (_this22.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP") {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this22.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              phongBanGiaiQuyet: {
                id: Number(_this22.state.phongBanChiDinh)
              },
              yKienGiaiQuyet: _this22.state.yKienGiaiQuyet
            };
            if (_this22.state.canBoGiaiQuyet) {
              params.canBoXuLyChiDinh = {
                id: Number(_this22.state.canBoGiaiQuyet)
              };
            }
            msgName = 'gqdGiaoViec';
          } else if (_this22.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
            params = {
              canBoXuLyChiDinh: {
                id: Number(_this22.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this22.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              phoPhong: true,
              phongBanGiaiQuyet: {
                id: Number(_this22.state.coQuanQuanLyNguoiDung.id)
              },
              yKienGiaiQuyet: _this22.state.yKienGiaiQuyet
            };
            msgName = 'gqdGiaoViec';
          } else {
            params = {
              canBoXuLyChiDinh: {
                id: Number(_this22.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this22.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this22.state.yKienGiaiQuyet
            };
            msgName = 'gqdGiaoViec';
          }
          if (_this22.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this22.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
            _this22.postTaiLieuVanThu(_this22.state.taiLieuVanThu, function () {
              _this22.updateTaiLieuVanThu(_this22.state.taiLieuVanThuUpdate, function () {
                _this22.deleteTaiLieuVanThu(_this22.state.taiLieuVanThuDelete, function () {
                  _this22.props.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          } else {
            _this22.deleteTaiLieuVanThu(dataFileDelete, function () {
              _this22.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          }
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      switch (type) {
        case 'BAO_CAO_KET_QUA_TTXM':
          dataFileDinhKem.baoCaoKetQuaTTXM = data;
          break;
        case 'QUYET_DINH_GIAI_QUYET':
          dataFileDinhKem.quyetDinhGiaiQuyet = data;
          var fileQD = data.filter(function (item) {
            return item.typeRequired === 'QDGQ_TTT';
          });
          if (!(0, _lodash.isEmpty)(fileQD) && fileQD[0].unSetNgayBanHanh) {
            this.setState({
              ngayBanHanhSuggest: fileQD[0].ngayQuyetDinh,
              soVanBan: fileQD[0].soQuyetDinh
            });
          }
          break;
        case 'GIAO_CO_QUAN_DIEU_TRA':
          dataFileDinhKem.giaoCoQuanDieuTra = data;
          break;
        case 'GIA_HAN':
          dataFileDinhKem.giaHan = data;
          break;
        default:
          dataFileDinhKem.data = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem(type) {
      if (type === 'GIAO_TTXM') {
        return this.state.dataFileDinhKem.data;
      }
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;
      if (Data.baoCaoKetQuaTTXM.length > 0) {
        Data.baoCaoKetQuaTTXM.forEach(function (item) {
          dataFileDinhKem[dataFileDinhKem.length] = item;
        });
      }

      if (Data.data && Data.data.length > 0) {
        Data.data.forEach(function (item) {
          dataFileDinhKem[dataFileDinhKem.length] = item;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.forEach(function (item) {
          dataFileDinhKem[dataFileDinhKem.length] = item;
        });
      }

      if (Data.giaoCoQuanDieuTra && Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.forEach(function (item) {
          dataFileDinhKem[dataFileDinhKem.length] = item;
        });
      }

      if (Data.giaHan && Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.forEach(function (item) {
          dataFileDinhKem[dataFileDinhKem.length] = item;
        });
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
          params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soVanBan = this.state.soVanBan || '';
        params.ngayBanHanh = this.state.ngayBanHanhSuggest ? (0, _moment2.default)(this.state.ngayBanHanhSuggest).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

        if (this.props.loaiDon === 'DON_KHIEU_NAI') {
          params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

          if (Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 || null;
          } else {
            params.ketQuaGiaiQuyetLan2 = null;
          }

          if (this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
          } else {
            params.noiDungKetLuanGiaiQuyetLai = '';
          }
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }
      var coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : {};
      if (!this.state.isSoBanNganh || this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.isThanhTraThanhPho || this.state.ketQuaThucHienTheoDoi) {
        if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          params.theoDoiThucHien = true;
          params.hinhThucTheoDoi = this.state.hinhThucTheoDoi || null;
          if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
            params.coQuanTheoDoi = this.state.coQuanTheoDoi || null;
          } else {
            params.coQuanTheoDoi = null;
          };
          params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi || null;
          params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac || '';
          params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
          params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
          params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
          params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);
          params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
          params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
          params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
          params.datDaTraCongDan = Number(this.state.datDaTraCongDan);
        } else {
          params.theoDoiThucHien = false;
          params.ketQuaThucHienKhac = '';
          params.hinhThucTheoDoi = null;
          params.coQuanTheoDoi = null;
          params.ketQuaThucHienTheoDoi = null;
          params.tienDaThuNhaNuoc = 0;
          params.datDaThuNhaNuoc = 0;
          params.tienDaTraCongDan = 0;
          params.datDaTraCongDan = 0;
          params.tienPhaiThuNhaNuoc = 0;
          params.datPhaiThuNhaNuoc = 0;
          params.tienPhaiTraCongDan = 0;
          params.datPhaiTraCongDan = 0;
        }
      } else {
        params.theoDoiThucHien = false;
        params.ketQuaThucHienKhac = '';
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;
        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;
      }
      params.ketQuaXLDGiaiQuyet = this.state.tienDoDoiThoai === 'KHONG_DOI_THOAI' && this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;
      if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO') {
        if (this.state.doiThoai) {
          params.doiThoai = true;
          params.thoiGianDoiThoai = (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString();
          params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
          params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        } else {
          params.doiThoai = false;
          params.thoiGianDoiThoai = null;
          params.diaDiemDoiThoai = '';
          params.noiDungDoiThoai = '';
        }
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }

      params.donViThamTraXacMinh = null;
      params.ngayHetHanTTXM = null;
      params.yKienGiaiQuyet = '';

      params.don = {
        id: Number(this.state.id)
      };
      params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM || null;
      return params;
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      switch (type) {
        case 'BAO_CAO_KET_QUA_TTXM':
          var dataFileDinhKem = this.state.dataFileDinhKem;
          dataFileDinhKem.baoCaoKetQuaTTXM = data;
          this.setState({
            dataFileDinhKem: dataFileDinhKem
          });
          break;
        case 'QUYET_DINH_GIAI_QUYET':
          dataFileDinhKem.quyetDinhGiaiQuyet = data;
          this.setState({
            dataFileDinhKem: dataFileDinhKem
          });
          break;
        case 'GIAO_CO_QUAN_DIEU_TRA':
          dataFileDinhKem.giaoCoQuanDieuTra = data;
          this.setState({
            dataFileDinhKem: dataFileDinhKem
          });
          break;
        case 'GIA_HAN':
          dataFileDinhKem.giaHan = data;
          this.setState({
            dataFileDinhKem: dataFileDinhKem
          });
          break;
        default:
          dataFileDinhKem.data = data;
          this.setState({
            dataFileDinhKem: dataFileDinhKem
          });
      }
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'inPhieuGiaoTTXMKhieuNai',
    value: function inPhieuGiaoTTXMKhieuNai() {
      var _this23 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId === _this23.state.donViThamTraXacMinh;
      });
      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?" + "tenCoQuanThuLyGQKN=" + (this.props.coQuanDangQuyetInfo ? this.props.coQuanDangQuyetInfo.ten : '') + "&tenCoQuanDuocGiaoNhiemVuXM=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&donViXuLyId=" + userInfo.donViId + "&donId=" + this.state.thongTinGiaiQuyetDonId + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') + "&hoTenNguoiKhieuNai=" + (this.props.listNguoiDungDon ? this.props.listNguoiDungDon[0].hoVaTen : '') + "&noiDungTTXM=" + this.props.noiDungDonThu;
      window.open(URL, "_self");
    }
  }, {
    key: 'inPhieuGiaoTTXMToCao',
    value: function inPhieuGiaoTTXMToCao() {
      var _this24 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId === _this24.state.donViThamTraXacMinh;
      });
      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?" + "tenCoQuan=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&donViXuLyId=" + userInfo.donViId + "&noiDungDonThu=" + this.props.noiDungDonThu + "&donId=" + this.state.thongTinGiaiQuyetDonId + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY');
      window.open(URL, "_self");
    }
  }, {
    key: 'render',
    value: function render() {
      var _this25 = this;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this25.state.ketQuaXLDGiaiQuyet;
      });
      var ketLuanNDKhieuNaiLabel = this.props.loaiDon === 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : this.props.loaiDon === 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh";
      var coQuanQuanLyId = this.props.dataGiaiQuyet && this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo ? this.props.dataGiaiQuyet.phongBanGiaiQuyetInfo.coQuanQuanLyId : '';
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      var lb3 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      var lbGuiTTXM = 'Gửi báo cáo ' + lb1;
      var txtTuGQ = 'Tự giải quyết';
      var lbTraTTXM = 'Trả đơn do chuyển ' + lb1 + ' không đúng';
      var isQuaHan = this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
      var coQuanQuanLyNguoiDungId = this.props.coQuanQuanLyNguoiDung && this.props.coQuanQuanLyNguoiDung.id;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.role === 'truongPhongTTXM' },
          _react2.default.createElement(_NhiemVuTTXM2.default, {
            donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
            ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
            yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
            ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM,
            donInfo: this.props.donInfo
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.role === 'truongPhongKiemTraDeXuat' },
          _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, _extends({
            listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon
          }, this.props.dataKiemTraDeXuat, {
            donInfo: this.props.donInfo
          }))
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.alias === "TruongPhongTTXMAction" },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        this.props.alias === 'TruongPhongTTXMAction' && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' ? _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
          lb2
        ) : _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.alias !== 'TruongPhongTTXMAction' },
          _react2.default.createElement(
            'form',
            { className: 'form-action' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon === 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet && this.props.roleGQ === 'truongPhongGiaiQuyetDon' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content pt17' },
                      this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.roleGQ === 'truongPhongKiemTraDeXuat' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 mb10' },
                  _react2.default.createElement(
                    'span',
                    { className: 'val-title-inline-bold' },
                    'Ph\xF2ng: \xA0'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'val-content-inline' },
                    typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  onRef: function onRef(select) {
                    return _this25.select = select;
                  },
                  className: 'col-25',
                  donId: this.state.id,
                  require: true,
                  isValid: this.state.validate,
                  data: this.state.dataNextState,
                  keyName: 'type',
                  disable: this.state.ketQuaXLDGiaiQuyet !== '' ? true : false,
                  valueName: 'tenVietTat',
                  label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                  bindValidator: this,
                  name: 'huongGiaiQuyet',
                  selectedValue: this.state.nextState,
                  onChange: this.onChange.bind(this, 'nextState') })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet && this.state.showTienDoGiaiQuyet },
                _react2.default.createElement(
                  'p',
                  { className: 'attach-file-description mb10 pl5 pr5' },
                  'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25', label: '', value: txtTuGQ })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' || this.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN" },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                      lb2
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pb5' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.allowAttach },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BaoCaoKQTTXM', onSave: this.state.onSave, loaiDon: this.props.loaiDon, phanLoaiQuyTrinh: 'BAO_CAO_KET_QUA_TTXM', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', tTXMText: 'TTXM_TTT', tTXMRequired: true, bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mt5' },
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-100 pb15' },
                              _react2.default.createElement('span', { className: 'line-border' })
                            ),
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                            ),
                            _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                            _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                            _react2.default.createElement('div', { className: 'col-100 pb5' })
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    ),
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb10' },
                      'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'p',
                        { className: 'attach-file-description mb10 pl5 pr5' },
                        'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: !this.state.showTienDoGiaiQuyet },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.tienDoDoiThoai === 'KHONG_DOI_THOAI' },
                          _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet !== '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.showTienDoGiaiQuyet },
                        _react2.default.createElement(_common.Text, { className: 'col-25', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.loaiDon === 'DON_KHIEU_NAI' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          _utils.ShowIfCheck,
                          { label: '\u0110\u1ED1i tho\u1EA1i', onChange: this.handleCheck.bind(this, 'doiThoai'), checked: this.state.doiThoai },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter mt5' },
                            _react2.default.createElement(
                              'h2',
                              { className: 'title-12 mb15' },
                              '\u0110\u1ED1i tho\u1EA1i'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10' },
                              _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', bindValidator: this, channel: 'formTaoDon', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                              _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                              _react2.default.createElement(_common.TextArea, { className: 'col-100', require: true, bindValidator: this, channel: 'formTaoDon', name: 'ketQuaDoiThoai', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pt5 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mb5 mt5' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet !== 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon === 'DON_TO_CAO' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon !== 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-25', name: 'inputSoVanBan', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                          _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), name: 'inputNgayBanHanh', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanhSuggest, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhSuggest') }),
                          _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                          this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }),
                          this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' && _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }),
                          _react2.default.createElement(
                            _utils.ShowIf,
                            { condition: this.state.allowAttach },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-100' },
                              _react2.default.createElement(_upload.ContainerFileDinhKem, { unSetNgayBanHanh: true, quyetDinh: this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, loaiVanBanSuggest: 'QDGQ_TTT', name: 'ThuHoiChoNN', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_TTT', qDGQRequired: this.state.tTXMRequired, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter pt10 pb20' },
                          _react2.default.createElement('span', { className: 'line-border' })
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                          this.props.donInfo.layVuViecCu === true && _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') }),
                            this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVu', value: this.state.soVuGiaiQuyetKhieuNai, onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai') }),
                            _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.props.loaiDon, label: ketLuanNDKhieuNaiLabel, className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-50 no-gutter mb20' },
                              _react2.default.createElement(
                                'p',
                                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                                'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                              ),
                              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', name: 'tienPhaiThuNhaNuocQDGQ', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ') }),
                              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuocQDGQ', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ') })
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'col-50 no-gutter mb20' },
                              _react2.default.createElement(
                                'p',
                                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                                'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                              ),
                              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'tienPhaiTraCongDanQDGQ', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ') }),
                              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', name: 'datPhaiTraCongDanQDGQ', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ') })
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'col-100 no-gutter' },
                              _react2.default.createElement(
                                'p',
                                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                                'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                              ),
                              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'tongSoNguoiXuLyHanhChinh', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh') }),
                              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDaBiXuLyHanhChinh', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh') }),
                              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDuocTraLaiQuyenLoi', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter pt5 pb15' },
                            _react2.default.createElement('span', { className: 'line-border' })
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: (this.state.donViTheoDoiThucHien === coQuanQuanLyId || this.state.donViTheoDoiThucHien === coQuanQuanLyNguoiDungId || this.state.isThanhTraThanhPho || this.props.noRule) && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5 pb20' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10 mb20' },
                          _react2.default.createElement(
                            _utils.ShowIf,
                            { condition: this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                            _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), name: 'coQuanTheoDoi', data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10 mb20' },
                          _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac'), name: 'ketQuaThucHienKhac' })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter mb20' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienPhaiThuNhaNuoc', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuoc', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienDaThuNhaNuoc', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'datDaThuNhaNuoc', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienPhaiTraCongDan', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'datPhaiTraCongDan', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', name: 'tienDaTraCongDan', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan') }),
                            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', name: 'datDaTraCongDan', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan') })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pt5 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25', label: 'T\xEAn c\u01A1 quan', bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5', name: 'soVuGiaoCoQuanDieuTra', value: this.state.soVuGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', name: 'soDoiTuongGiaoCoQuanDieuTra', value: this.state.soDoiTuongGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 })
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter pb5' },
                            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pt5 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          _utils.ShowIfCheck,
                          { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter mt5' },
                            _react2.default.createElement(
                              'h2',
                              { className: 'title-12 mb15' },
                              'Kh\u1EDFi t\u1ED1'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-50 no-gutter mb20' },
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVuBiKhoiTo', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', name: 'soDoiTuongBiKhoiTo', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "GQDTTTXM_GIAO_PHONG_CUNG_CAP" },
                _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                  className: 'col-25',
                  require: true,
                  bindValidator: this,
                  selectedValue: this.state.phongBanChiDinh,
                  isValid: this.props.validate,
                  onChange: this.onChange.bind(this, 'phongBanChiDinh'),
                  name: 'dropdownChonPhongBanThuocCoQuan' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_CAN_BO" },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: vaiTro,
                  bindValidator: this,
                  className: 'col-25',
                  label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  vaiTro: 'PHO_PHONG',
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  bindValidator: this,
                  className: 'col-25',
                  label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.roleGQ === 'truongPhongKiemTraDeXuat' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'H\u1EA1n x\u1EED l\xFD:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content pt17 txt-danger' },
                      this.state.ngayHetHanKTDX ? (0, _moment2.default)(this.state.ngayHetHanKTDX).format('DD/MM/YYYY') : ''
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState !== "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH" },
                _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'KetThuc', onSave: this.state.onSave, phanLoaiQuyTrinh: '', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.role === 'truongPhongGiaiQuyetDon' },
                _react2.default.createElement(
                  'span',
                  { className: 'wrap-link' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this, 'truongPhongGiaiQuyetDon') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u t\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: (this.state.nextState === "CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH" || this.state.nextState === "CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN") && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialogLuuHoSo') },
                      _react2.default.createElement(
                        'span',
                        null,
                        this.state.btnText
                      )
                    )
                  ),
                  _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this, 'openDialogLuuHoSo'), onSuccess: this.onSuccess.bind(this, 'openDialogLuuHoSo'), title: this.state.titleDialog, content: this.state.contentDialog }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState !== '' && this.state.nextState !== 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH' && this.state.nextState !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'truongPhongGiaiQuyetDon') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Giao vi\u1EC7c'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.role === 'truongPhongKiemTraDeXuat' },
                _react2.default.createElement(
                  'span',
                  { className: 'wrap-link' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this, 'truongPhongKiemTraDeXuat') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u t\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'truongPhongKiemTraDeXuat') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Giao vi\u1EC7c'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.alias === 'TruongPhongTTXMAction' },
          _react2.default.createElement(
            'form',
            { className: 'form-action' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                    ),
                    _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb15', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.dataNextStates && this.props.dataNextStates.length > 1 },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  onRef: function onRef(select) {
                    return _this25.select = select;
                  },
                  className: 'col-25',
                  donId: this.state.id,
                  require: true,
                  isValid: this.state.validate,
                  data: this.state.dataNextState,
                  keyName: 'type',
                  valueName: 'tenVietTat',
                  label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                  bindValidator: this,
                  name: 'huongGiaiQuyet',
                  selectedValue: this.state.nextState,
                  onChange: this.onChange.bind(this, 'nextState') })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  vaiTro: 'PHO_PHONG',
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  bindValidator: this,
                  className: 'col-25',
                  label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                }),
                _react2.default.createElement(_common.TextArea, { className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: vaiTro,
                  bindValidator: this,
                  className: 'col-25',
                  label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                }),
                _react2.default.createElement(_common.TextArea, { className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP" },
                _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                  className: 'col-25',
                  require: true,
                  bindValidator: this,
                  selectedValue: this.state.phongBanChiDinh,
                  isValid: this.props.validate,
                  onChange: this.onChange.bind(this, 'phongBanChiDinh'),
                  name: 'dropdownChonPhongBanThuocCoQuan' }),
                _react2.default.createElement(_common.TextArea, { className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: 'L\xFD do', bindValidator: this, channel: 'formTaoDon', require: true, placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet', maxLength: 1000 })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(_common.TextArea, { className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', value: this.state.noiDung, onChange: this.onChange.bind(this, 'noiDung'), name: 'textareaCanBoKetLuanNoiDung' }),
                isQuaHan === true && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do qu\xE1 h\u1EA1n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.lyDoQuaHan, placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'lyDoQuaHan'), name: 'TextAreaLyDoQuaHan', maxLength: 1000 })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach && this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'CanBoChuyenVeDVGQ', onSave: this.state.onSave, bindValidator: this, dataShow: this.state.ListTaiLieuVanThuShow, data: this.state.ListTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach && this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'ListTaiLieuVanThu', hideDescription: true, dataShow: this.state.ListTaiLieuVanThuShow, disableAttachFile: this.state.nextState != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
                    onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState != '' },
                _react2.default.createElement(
                  'span',
                  { className: 'wrap-link' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.saveTruongPhongGQD.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u t\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" || this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP" },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.truongPhongGQD.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Giao vi\u1EC7c'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState === 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialog') },
                      _react2.default.createElement(
                        'span',
                        null,
                        lbGuiTTXM
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState === 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialogTraDon') },
                      _react2.default.createElement(
                        'span',
                        null,
                        lbTraTTXM
                      )
                    )
                  ),
                  _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this, 'openDialog'), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " báo cáo " + lb3 + " của đơn/vụ việc này không?" }),
                  _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogTraDon, onClose: this.closeDialog.bind(this, 'openDialogTraDon'), onSuccess: this.onSuccess.bind(this, 'openDialogTraDon'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD tr\u1EA3 \u0111\u01A1n/v\u1EE5 vi\u1EC7c chuy\u1EC3n ' + lb1 + ' kh\xF4ng \u0111\xFAng n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + ' kh\xF4ng?' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return GiaiQuyetDonTruongPhong;
}(_react2.default.Component);

GiaiQuyetDonTruongPhong.defaultProps = {
  validators: {},
  tenCoQuan: [],
  ketQuaGiaiQuyetDon: [],
  donInfo: {},
  noRule: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    tenCoQuan: state.duLieuHeThong.donViTTXM,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(GiaiQuyetDonTruongPhong);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InPhieuGiaoTTXMToCao = function (_React$Component) {
  _inherits(InPhieuGiaoTTXMToCao, _React$Component);

  function InPhieuGiaoTTXMToCao(props, context) {
    _classCallCheck(this, InPhieuGiaoTTXMToCao);

    var _this = _possibleConstructorReturn(this, (InPhieuGiaoTTXMToCao.__proto__ || Object.getPrototypeOf(InPhieuGiaoTTXMToCao)).call(this, props, context));

    _this.state = {
      isOpen: false,
      tenCoQuan: '',
      ghiChu: '',
      noiDungDonThu: ''
    };
    return _this;
  }

  _createClass(InPhieuGiaoTTXMToCao, [{
    key: 'inPhieuGiaoTTXMToCao',
    value: function inPhieuGiaoTTXMToCao() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?" + "tenCoQuan=" + this.state.tenCoQuan + "&donViXuLyId=" + userInfo.donViId + "&ghiChu=" + this.state.ghiChu;
      window.open(URL, "_self");
      this.toggleDialog();
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({
        isOpen: !this.state.isOpen,
        tenCoQuan: '',
        ghiChu: '',
        noiDungDonThu: ''
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'col-50 pb15' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'btn-green tt-print', onClick: this.toggleDialog.bind(this) },
          'T\u1EA3i quy\u1EBFt \u0111\u1ECBnh giao nhi\u1EC7m v\u1EE5 x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.toggleDialog.bind(this),
            title: 'Th\xF4ng tin quy\u1EBFt \u0111\u1ECBnh giao nhi\u1EC7m v\u1EE5 x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o',
            className: 'dialog-history dialog-print wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'body-dialog-gh' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pt15' },
              _react2.default.createElement(_common.Input, { className: 'col-25', label: 'T\xEAn c\u01A1 quan', value: this.state.tenCoQuan, onChange: this.onChange.bind(this, 'tenCoQuan') }),
              _react2.default.createElement(_common.TextArea, { label: 'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0', value: this.state.noiDungDonThu, onChange: this.onChange.bind(this, 'noiDungDonThu') }),
              _react2.default.createElement(_common.TextArea, { label: 'Ghi ch\xFA', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), maxLength: 1000 })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom gqd-wrap col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.toggleDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green tt-print', onClick: this.inPhieuGiaoTTXMToCao.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'T\u1EA3i quy\u1EBFt \u0111\u1ECBnh'
              )
            )
          )
        )
      );
    }
  }]);

  return InPhieuGiaoTTXMToCao;
}(_react2.default.Component);

exports.default = InPhieuGiaoTTXMToCao;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaCanBoGiaiQuyetYeuCauLapDuThao = function (_React$Component) {
  _inherits(KetQuaCanBoGiaiQuyetYeuCauLapDuThao, _React$Component);

  function KetQuaCanBoGiaiQuyetYeuCauLapDuThao(props, context) {
    _classCallCheck(this, KetQuaCanBoGiaiQuyetYeuCauLapDuThao);

    var _this = _possibleConstructorReturn(this, (KetQuaCanBoGiaiQuyetYeuCauLapDuThao.__proto__ || Object.getPrototypeOf(KetQuaCanBoGiaiQuyetYeuCauLapDuThao)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      role: _this.props.role,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      data: _this.props.dataLichSuGiaiQuyet
    };
    return _this;
  }

  _createClass(KetQuaCanBoGiaiQuyetYeuCauLapDuThao, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.id != nextProps.id && nextProps.id) {
        this.setState({
          id: nextProps.id,
          role: nextProps.role,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
          data: nextProps.dataLichSuGiaiQuyet
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.props.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.props.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.props.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.props.ngayHetHanTTXM,
          donInfo: this.props.donInfo,
          lanhDaoView: this.props.lanhDaoView == true ? true : false
        }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.props.thongTinGQD }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.role != 'truongPhongKiemTraDeXuat' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextMessage, { className: 'col-100 mt5 mb10', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.props.noiDungKetLuanDuThao ? this.props.noiDungKetLuanDuThao : '' }),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDaoView != true },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaCanBoGiaiQuyetYeuCauLapDuThao;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(KetQuaCanBoGiaiQuyetYeuCauLapDuThao);

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(192);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaCanBoKiemTraDeXuat = function (_React$Component) {
  _inherits(KetQuaCanBoKiemTraDeXuat, _React$Component);

  function KetQuaCanBoKiemTraDeXuat() {
    _classCallCheck(this, KetQuaCanBoKiemTraDeXuat);

    return _possibleConstructorReturn(this, (KetQuaCanBoKiemTraDeXuat.__proto__ || Object.getPrototypeOf(KetQuaCanBoKiemTraDeXuat)).apply(this, arguments));
  }

  _createClass(KetQuaCanBoKiemTraDeXuat, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('giai-quyet-don/subView/KetQuaCanBoKiemTraDeXuat');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, _extends({ listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon }, this.props.dataKiemTraDeXuat, {
          hideTable: true, donInfo: this.props.donInfo })),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 ki\u1EC3m tra'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, { value: this.props.thongTinYeuCauKiemTraDeXuat.yKienXuLy ? this.props.thongTinYeuCauKiemTraDeXuat.yKienXuLy : '', className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:' }),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BaoCaoKQKT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaCanBoKiemTraDeXuat;
}(_react2.default.Component);

KetQuaCanBoKiemTraDeXuat.defaultProps = {
  listTaiLieuVanThuBoSungHoSo: [],
  boSungThongTin: false,
  validators: {}
};

exports.default = KetQuaCanBoKiemTraDeXuat;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaGiaiQuyetDonCanBoNhapLieu = function (_React$Component) {
  _inherits(KetQuaGiaiQuyetDonCanBoNhapLieu, _React$Component);

  function KetQuaGiaiQuyetDonCanBoNhapLieu() {
    _classCallCheck(this, KetQuaGiaiQuyetDonCanBoNhapLieu);

    return _possibleConstructorReturn(this, (KetQuaGiaiQuyetDonCanBoNhapLieu.__proto__ || Object.getPrototypeOf(KetQuaGiaiQuyetDonCanBoNhapLieu)).apply(this, arguments));
  }

  _createClass(KetQuaGiaiQuyetDonCanBoNhapLieu, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: "Đơn vị " + lb1 + ":", value: this.props.donViThamTraXacMinhInfo ? this.props.donViThamTraXacMinhInfo.ten : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', red: true, value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props.yKienGiaiQuyet ? this.props.yKienGiaiQuyet : '' }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaGiaiQuyetDonCanBoNhapLieu;
}(_react2.default.Component);

exports.default = KetQuaGiaiQuyetDonCanBoNhapLieu;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(192);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaGiaiQuyetDonTruongPhong = function (_React$Component) {
  _inherits(KetQuaGiaiQuyetDonTruongPhong, _React$Component);

  function KetQuaGiaiQuyetDonTruongPhong(props, context) {
    _classCallCheck(this, KetQuaGiaiQuyetDonTruongPhong);

    var _this = _possibleConstructorReturn(this, (KetQuaGiaiQuyetDonTruongPhong.__proto__ || Object.getPrototypeOf(KetQuaGiaiQuyetDonTruongPhong)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      role: _this.props.roleGQ,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      data: _this.props.dataLichSuGiaiQuyet
    };
    return _this;
  }

  _createClass(KetQuaGiaiQuyetDonTruongPhong, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.id != nextProps.id && nextProps.id) {
        this.setState({
          id: nextProps.id,
          role: nextProps.roleGQ,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
          data: nextProps.dataLichSuGiaiQuyet
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.role == 'truongPhongTTXM' },
          _react2.default.createElement(_NhiemVuTTXM2.default, {
            donViGiaoThamTraXacMinh: this.props.donViGiaoThamTraXacMinhInfo,
            ngayBatDauTTXM: this.props.ngayBatDauTTXM,
            yKienCuaDonViGiaoTTXM: this.props.yKienCuaDonViGiaoTTXM,
            ngayHetHanTTXM: this.props.ngayHetHanTTXM,
            donInfo: this.props.donInfo
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.role == 'truongPhongKiemTraDeXuat' },
          _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, _extends({
            listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon
          }, this.props.dataKiemTraDeXuat, {
            donInfo: this.props.donInfo
          }))
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.roleGQ !== "truongPhongGiaiQuyetDon" },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.role != 'truongPhongKiemTraDeXuat' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.role == 'truongPhongKiemTraDeXuat' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Th\xF4ng tin \u0111\u1EC1 xu\u1EA5t'
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.role == 'truongPhongKiemTraDeXuat' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mb10' },
                _react2.default.createElement(
                  'span',
                  { className: 'val-title-inline-bold' },
                  'Ph\xF2ng: \xA0'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'val-content-inline' },
                  typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.role == 'truongPhongTTXM' },
              _react2.default.createElement(_common.Text, { label: 'Ph\xF2ng ban:', value: typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : '' })
            ),
            _react2.default.createElement(_common.Text, { label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt:', value: this.state.data.canBoXuLyChiDinhInfo ? this.state.data.canBoXuLyChiDinhInfo.hoVaTen : '' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.role == 'truongPhongGiaiQuyetDon' },
              _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n gi\u1EA3i quy\u1EBFt:', red: true, value: this.state.data.thongTinGiaiQuyetDonInfo && this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet ? (0, _moment2.default)(this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.role == 'truongPhongKiemTraDeXuat' },
              _react2.default.createElement(_common.Text, { label: 'H\u1EA1n x\u1EED l\xFD:', red: true, value: this.state.data.thongTinGiaiQuyetDonInfo && this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX ? (0, _moment2.default)(this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.props.role == 'truongPhongGiaiQuyetDon' },
              _react2.default.createElement(_common.Text, { value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet, red: true, className: 'col-25', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_KHIEU_NAI' && this.props.role == 'truongPhongGiaiQuyetDon' },
              _react2.default.createElement(_common.Text, { value: this.state.ngayHetHanSauKhiGiaHanTTXM, red: true, className: 'col-25', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:' })
            ),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100 mt5 mb5', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.data.yKienGiaiQuyet }),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaGiaiQuyetDonTruongPhong;
}(_react2.default.Component);

exports.default = KetQuaGiaiQuyetDonTruongPhong;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaHoanThanhGiaiQuyetDonCanBo = function (_React$Component) {
  _inherits(KetQuaHoanThanhGiaiQuyetDonCanBo, _React$Component);

  function KetQuaHoanThanhGiaiQuyetDonCanBo(props, context) {
    _classCallCheck(this, KetQuaHoanThanhGiaiQuyetDonCanBo);

    var _this = _possibleConstructorReturn(this, (KetQuaHoanThanhGiaiQuyetDonCanBo.__proto__ || Object.getPrototypeOf(KetQuaHoanThanhGiaiQuyetDonCanBo)).call(this, props, context));

    _this.state = {
      donViThamTraXacMinhInfo: _this.props.donViThamTraXacMinhInfo,
      ngayHetHanTTXM: _this.props.ngayHetHanTTXM,
      dataKetQuaGiaiQuyetDon: []
    };
    return _this;
  }

  _createClass(KetQuaHoanThanhGiaiQuyetDonCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('giai-quyet-don/subView/KetQuaHoanThanhGiaiQuyetDonCanBo');
      }
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this2 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this2.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, nextProps));
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == _this3.props.ketLuanNoiDungKhieuNai;
      });
      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == _this3.props.ketQuaThucHienTheoDoi;
      });
      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this3.props.ketQuaXLDGiaiQuyet;
      });

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.loaiDon == 'DON_TO_CAO' && this.props.giaHanGiaiQuyet },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5 pb20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb15 pl5 pr5' },
                'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n:', value: this.props.soQuyetDinhGiaHanGiaiQuyet }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: this.props.ngayRaQuyetDinhGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u1EBFn ng\xE0y:', value: this.props.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'L\xFD do gia h\u1EA1n:', value: this.props.lyDoGiaHanGiaiQuyet })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: ketQuaGiaiQuyetDon.length > 0 },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mt5 no-gutter' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'p',
                    { className: 'attach-file-description mb10 pl5 pr5' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: /*this.props.loaiDon == 'DON_TO_CAO' || */this.props.loaiDon == 'DON_KHIEU_NAI' && this.props.doiThoai },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    '\u0110\u1ED1i tho\u1EA1i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.props.thoiGianDoiThoai ? (0, _moment2.default)(this.props.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.props.diaDiemDoiThoai }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.props.noiDungDoiThoai ? this.props.noiDungDoiThoai : '' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.quyetDinhGiaiQuyetKhieuNai },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_TO_CAO' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10 mb15' },
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaiQuyetKhieuNai) }),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                          _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon == 'DON_TO_CAO' },
                          _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                          _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                        ),
                        _react2.default.createElement(_common.Text, { label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', className: 'col-25', value: this.props.ketQuaGiaiQuyetKhac })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-50 no-gutter mb20' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuocQDGQ) }),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuocQDGQ) })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-50 no-gutter mb20' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDanQDGQ) }),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDanQDGQ) })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.tongSoNguoiXuLyHanhChinh) }),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(this.props.soNguoiDaBiXuLyHanhChinh) }),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(this.props.soNguoiDuocTraLaiQuyenLoi) })
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.theoDoiThucHien },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10 mb15' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.ketQuaThucHienKhac })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mb15' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.tienDaThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.datDaThuNhaNuoc) })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienDaTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datDaTraCongDan) })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.giaoCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaoCoQuanDieuTra) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongGiaoCoQuanDieuTra) })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.khoiTo },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Kh\u1EDFi t\u1ED1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuBiKhoiTo) }),
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongBiKhoiTo) })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true, hideDescription: true })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'DSVanBanBS', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDaoView != true && !this.props.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaHoanThanhGiaiQuyetDonCanBo;
}(_react2.default.Component);

KetQuaHoanThanhGiaiQuyetDonCanBo.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaHoanThanhGiaiQuyetDonCanBo);

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaLapDuThaoCanBo = function (_React$Component) {
  _inherits(KetQuaLapDuThaoCanBo, _React$Component);

  function KetQuaLapDuThaoCanBo() {
    _classCallCheck(this, KetQuaLapDuThaoCanBo);

    return _possibleConstructorReturn(this, (KetQuaLapDuThaoCanBo.__proto__ || Object.getPrototypeOf(KetQuaLapDuThaoCanBo)).apply(this, arguments));
  }

  _createClass(KetQuaLapDuThaoCanBo, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('giai-quyet-don/subView/KetQuaLapDuThaoCanBo');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == _this2.props.ketLuanNoiDungKhieuNai;
      });

      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == _this2.props.ketQuaThucHienTheoDoi;
      });

      var thongTinGQD = this.props.thongTinGQD;


      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: thongTinGQD }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyetInfo },
            _react2.default.createElement(
              'div',
              { className: 'col-100 mt5 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb10' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'p',
                  { className: 'attach-file-description mb10 pl5 pr5' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: this.props.ketQuaXLDGiaiQuyetInfo ? this.props.ketQuaXLDGiaiQuyetInfo.text : '' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : '', label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt:', className: 'col-25 mb10' }),
              _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', className: 'col-25 mb10' }),
              _react2.default.createElement(_common.Text, { value: this.props.yKienCuaDonViGiaoTTXM || '', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', className: 'col-100 mb10' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_TO_CAO' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                )
              ),
              thongTinGQD && thongTinGQD.ketQuaGiaiQuyetLan2Info && _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb15' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt:', value: thongTinGQD.ketQuaGiaiQuyetLan2Info.text })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb15' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaiQuyetKhieuNai) }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                  _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon == 'DON_TO_CAO' },
                  _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                  _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB ph\u1EA3n \xE1nh:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: this.props.ketQuaGiaiQuyetKhac ? this.props.ketQuaGiaiQuyetKhac : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuocQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuocQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDanQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDanQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.tongSoNguoiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(this.props.soNguoiDaBiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(this.props.soNguoiDuocTraLaiQuyenLoi) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 pl0 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.props.soVanBan || '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.props.ngayBanHanh ? (0, _moment2.default)(this.props.ngayBanHanh).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: this.props.nguoiBanHanhInfo ? this.props.nguoiBanHanhInfo.hoVaTen : '' }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl0 mb15', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: this.props.lyDoBanHanhQuyetDinhDinhChi || '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.theoDoiThucHien && this.props.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb15' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.ketQuaThucHienKhac ? this.props.ketQuaThucHienKhac : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.tienDaThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.datDaThuNhaNuoc) })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienDaTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datDaTraCongDan) })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaoCoQuanDieuTra) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongGiaoCoQuanDieuTra) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.khoiTo },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Kh\u1EDFi t\u1ED1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuBiKhoiTo) }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongBiKhoiTo) })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5 no-gutter' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDaoView != true && !this.props.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaLapDuThaoCanBo;
}(_react2.default.Component);

KetQuaLapDuThaoCanBo.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaLapDuThaoCanBo);

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaLapDuThaoDonKhieuNaiCanBo = function (_React$Component) {
  _inherits(KetQuaLapDuThaoDonKhieuNaiCanBo, _React$Component);

  function KetQuaLapDuThaoDonKhieuNaiCanBo() {
    _classCallCheck(this, KetQuaLapDuThaoDonKhieuNaiCanBo);

    return _possibleConstructorReturn(this, (KetQuaLapDuThaoDonKhieuNaiCanBo.__proto__ || Object.getPrototypeOf(KetQuaLapDuThaoDonKhieuNaiCanBo)).apply(this, arguments));
  }

  _createClass(KetQuaLapDuThaoDonKhieuNaiCanBo, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('giai-quyet-don/subView/KetQuaLapDuThaoDonKhieuNaiCanBo');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == _this2.props.ketLuanNoiDungKhieuNai;
      });

      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == _this2.props.ketQuaThucHienTheoDoi;
      });

      var thongTinGQD = this.props.thongTinGQD;


      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: thongTinGQD }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 mt5 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb10' },
              'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: this.props.ketQuaXLDGiaiQuyetInfo ? this.props.ketQuaXLDGiaiQuyetInfo.text : '' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : '', label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt:', className: 'col-25 mb10' }),
              _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', className: 'col-25 mb10' }),
              _react2.default.createElement(_common.Text, { value: this.props.yKienCuaDonViGiaoTTXM || '', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', className: 'col-100 mb10' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
              ),
              thongTinGQD && thongTinGQD.ketQuaGiaiQuyetLan2Info && _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb15' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt:', value: thongTinGQD.ketQuaGiaiQuyetLan2Info.text })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb15' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaiQuyetKhieuNai) }),
                _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: this.props.ketQuaGiaiQuyetKhac ? this.props.ketQuaGiaiQuyetKhac : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuocQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuocQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDanQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDanQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.tongSoNguoiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(this.props.soNguoiDaBiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(this.props.soNguoiDuocTraLaiQuyenLoi) })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 pl0 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.props.soVanBan || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.props.ngayBanHanh ? (0, _moment2.default)(this.props.ngayBanHanh).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: this.props.nguoiBanHanhInfo ? this.props.nguoiBanHanhInfo.hoVaTen : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl0 mb15', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: this.props.lyDoBanHanhQuyetDinhDinhChi || '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.theoDoiThucHien && this.props.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10 mb15' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.ketQuaThucHienKhac ? this.props.ketQuaThucHienKhac : '' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mb20' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.tienDaThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.datDaThuNhaNuoc) })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienDaTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datDaTraCongDan) })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.giaoCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaoCoQuanDieuTra) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongGiaoCoQuanDieuTra) })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.khoiTo },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Kh\u1EDFi t\u1ED1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuBiKhoiTo) }),
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongBiKhoiTo) })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5 no-gutter' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDaoView != true && !this.props.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaLapDuThaoDonKhieuNaiCanBo;
}(_react2.default.Component);

KetQuaLapDuThaoDonKhieuNaiCanBo.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaLapDuThaoDonKhieuNaiCanBo);

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaNhapThongTinToTTXM = function (_React$Component) {
  _inherits(KetQuaNhapThongTinToTTXM, _React$Component);

  function KetQuaNhapThongTinToTTXM() {
    _classCallCheck(this, KetQuaNhapThongTinToTTXM);

    return _possibleConstructorReturn(this, (KetQuaNhapThongTinToTTXM.__proto__ || Object.getPrototypeOf(KetQuaNhapThongTinToTTXM)).apply(this, arguments));
  }

  _createClass(KetQuaNhapThongTinToTTXM, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.props.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.props.ngayBatDauTTXM,
          donInfo: this.props.donInfo,
          yKienCuaDonViGiaoTTXM: this.props.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.props.ngayHetHanTTXM }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb15' },
                'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                lb2
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 no-gutter', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props.noiDungTraBaoCaoTTXMLan2 ? this.props.noiDungTraBaoCaoTTXMLan2 : this.props.noiDungTraBaoCaoTTXMLan1 })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line mt10 mb20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaNhapThongTinToTTXM;
}(_react2.default.Component);

KetQuaNhapThongTinToTTXM.defaultProps = {
  dataKetLuanNoiDungKhieuNai: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaNhapThongTinToTTXM);

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _subView = __webpack_require__(33);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaTheoDoiThucHien = function (_React$Component) {
  _inherits(KetQuaTheoDoiThucHien, _React$Component);

  function KetQuaTheoDoiThucHien() {
    _classCallCheck(this, KetQuaTheoDoiThucHien);

    return _possibleConstructorReturn(this, (KetQuaTheoDoiThucHien.__proto__ || Object.getPrototypeOf(KetQuaTheoDoiThucHien)).apply(this, arguments));
  }

  _createClass(KetQuaTheoDoiThucHien, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('giai-quyet-don/subView/KetQuaTheoDoiThucHien');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.props;
      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == DataDetail.ketLuanNoiDungKhieuNai;
      });

      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == DataDetail.ketQuaThucHienTheoDoi;
      });
      var ketQuaType = DataDetail.donInfo && DataDetail.donInfo.trangThaiDonInfo && DataDetail.donInfo.trangThaiDonInfo[0] && DataDetail.donInfo.trangThaiDonInfo[0].ketQuaType;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        DataDetail.thongTinGQD.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: DataDetail.thongTinGQD.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: DataDetail.thongTinGQD.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: DataDetail.thongTinGQD.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: DataDetail.thongTinGQD.ngayHetHanTTXM,
          donInfo: this.props.donInfo
        }),
        DataDetail.thongTinGQD.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.props.thongTinGQD }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 mt5 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb10' },
                'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
                'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 mb15' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(DataDetail.soVuGiaiQuyetKhieuNai) }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_TO_CAO' },
                _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: DataDetail.ketQuaGiaiQuyetKhac ? DataDetail.ketQuaGiaiQuyetKhac : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 mb5' },
              _react2.default.createElement(
                'div',
                { className: 'col-50 no-gutter mb20' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(DataDetail.tienPhaiThuNhaNuocQDGQ) }),
                _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(DataDetail.datPhaiThuNhaNuocQDGQ) })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-50 no-gutter mb20' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(DataDetail.tienPhaiTraCongDanQDGQ) }),
                _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(DataDetail.datPhaiTraCongDanQDGQ) })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'p',
                  { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                  'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(DataDetail.tongSoNguoiXuLyHanhChinh) }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(DataDetail.soNguoiDaBiXuLyHanhChinh) }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(DataDetail.soNguoiDuocTraLaiQuyenLoi) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line pt5 pb15' },
              _react2.default.createElement('span', { className: 'big-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' && (ketQuaType !== "DANG_TDTH" || ketQuaType !== "DANG_TDTH") },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mt5' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb15' },
                'Theo d\xF5i th\u1EF1c hi\u1EC7n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(DataDetail.soVuGiaoCoQuanDieuTra) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(DataDetail.soDoiTuongGiaoCoQuanDieuTra) })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.khoiTo },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Kh\u1EDFi t\u1ED1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuBiKhoiTo) }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongBiKhoiTo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && (ketQuaType !== "DANG_TDTH" || ketQuaType !== "DANG_TDTH") },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'N\u1ED9i dung Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb15' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.ketQuaThucHienKhac ? this.props.ketQuaThucHienKhac : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.tienDaThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.datDaThuNhaNuoc) })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienDaTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datDaTraCongDan) })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 pl0 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: DataDetail.soVanBan || '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: DataDetail.ngayBanHanh ? (0, _moment2.default)(DataDetail.ngayBanHanh).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi k\xFD:', value: DataDetail.nguoiBanHanhInfo ? DataDetail.nguoiBanHanhInfo.hoVaTen : '' }),
            _react2.default.createElement(_common.TextMessage, { className: 'col-100 pl0 mb15', label: 'L\xFD do \u0111\xECnh ch\u1EC9:', value: DataDetail.lyDoBanHanhQuyetDinhDinhChi || '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5 no-gutter' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.lanhDaoView != true && !this.props.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaTheoDoiThucHien;
}(_react2.default.Component);

KetQuaTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaTheoDoiThucHien);

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaTruongPhongNhanBaoCaoTTXM = function (_React$Component) {
  _inherits(KetQuaTruongPhongNhanBaoCaoTTXM, _React$Component);

  function KetQuaTruongPhongNhanBaoCaoTTXM() {
    _classCallCheck(this, KetQuaTruongPhongNhanBaoCaoTTXM);

    return _possibleConstructorReturn(this, (KetQuaTruongPhongNhanBaoCaoTTXM.__proto__ || Object.getPrototypeOf(KetQuaTruongPhongNhanBaoCaoTTXM)).apply(this, arguments));
  }

  _createClass(KetQuaTruongPhongNhanBaoCaoTTXM, [{
    key: 'onClickClose',
    value: function onClickClose() {
      if (typeof this.props.handleBack == 'function') {
        this.props.handleBack();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Đơn vị xác minh đề xuất:' : 'Đơn vị TTXM:';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      var getPhongBanGiaiQuyet = this.props.phongBanGiaiQuyetInfo ? this.props.phongBanGiaiQuyetInfo.ten : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
              'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
              lb2
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 mb15 no-gutter' },
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: lb1, value: this.props.donViThamTraXacMinhInfo ? this.props.donViThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.ngayTraBaoCaoTTXM ? (0, _moment2.default)(this.props.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props.noiDung ? this.props.noiDung : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.props.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.props.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.props.lyDoGiaHanGiaiQuyet ? this.props.lyDoGiaHanGiaiQuyet : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.nhanDuThao == true },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      '\u0110\u1ED1i tho\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.props && this.props.thoiGianDoiThoai ? (0, _moment2.default)(this.props.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.props && this.props.diaDiemDoiThoai ? this.props.diaDiemDoiThoai : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.props && this.props.noiDungDoiThoai ? this.props.noiDungDoiThoai : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      ' D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y tr\xECnh d\u1EF1 th\u1EA3o:', value: this.props && this.props.ngayKetThucGiaoLapDuThao ? (0, _moment2.default)(this.props.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.props && this.props.noiDungKetLuanDuThao ? this.props.noiDungKetLuanDuThao : '' })
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        this.props.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' ? _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, { value: this.props.ketQuaXLDGiaiQuyetInfo ? this.props.ketQuaXLDGiaiQuyetInfo.text : '', label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt:', className: 'col-100 mb10' }),
          _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : '', label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt:', className: 'col-25 mb10' }),
          _react2.default.createElement(_common.Text, { value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', className: 'col-25 mb10' }),
          _react2.default.createElement(_common.Text, { value: this.props.yKienCuaDonViGiaoTTXM || '', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', className: 'col-100 mb10' }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon })
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, { value: this.props.phongBanGiaiQuyetChiDinhInfo ? this.props.phongBanGiaiQuyetChiDinhInfo.ten : getPhongBanGiaiQuyet, label: 'Ph\xF2ng ban \u0111\u01B0\u1EE3c giao vi\u1EC7c:', className: 'col-25 mb10' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.phongBanGiaiQuyetChiDinhInfo },
            _react2.default.createElement(_common.Text, { value: this.props.canBoGiaiQuyetInfo ? this.props.canBoGiaiQuyetInfo.hoVaTen : '', label: 'Ph\xF3 ph\xF2ng \u0111\u01B0\u1EE3c giao vi\u1EC7c:', className: 'col-25 mb10' })
          ),
          _react2.default.createElement(_common.TextMessage, { value: this.props.yKienGiaoPhongBan ? this.props.yKienGiaoPhongBan : '', className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:' }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\xF3ng'
            )
          )
        )
      );
    }
  }]);

  return KetQuaTruongPhongNhanBaoCaoTTXM;
}(_react2.default.Component);

KetQuaTruongPhongNhanBaoCaoTTXM.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaTruongPhongNhanBaoCaoTTXM);

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaXuLyDon = function (_React$Component) {
  _inherits(KetQuaXuLyDon, _React$Component);

  function KetQuaXuLyDon(props, context) {
    _classCallCheck(this, KetQuaXuLyDon);

    var _this = _possibleConstructorReturn(this, (KetQuaXuLyDon.__proto__ || Object.getPrototypeOf(KetQuaXuLyDon)).call(this, props, context));

    _this.state = {
      data: _this.props.dataGiaiQuyet.thongTinGiaiQuyetDonInfo
    };
    return _this;
  }

  _createClass(KetQuaXuLyDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.dataGiaiQuyet.thongTinGiaiQuyetDonInfo
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Đơn vị xác minh đề xuất:' : 'Đơn vị TTXM:';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.props.status },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15 txt-upper txt-blue' },
            'K\u1EBFt qu\u1EA3 x\u1EED l\xFD \u0111\u01A1n'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(_common.Text, { label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt:', className: 'col-25', value: this.props.thamQuyenGiaiQuyet || '' }),
              _react2.default.createElement(_common.Text, { label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt:', className: 'col-25', value: this.state.data && this.state.data.phongBanGiaiQuyetKetQuaXLDInfo ? this.state.data.phongBanGiaiQuyetKetQuaXLDInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { red: true, label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt:', className: 'col-25', value: this.state.data && this.state.data.ngayHetHanGiaiQuyet ? (0, _moment2.default)(this.state.data.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(_common.Text, { label: 'Quy tr\xECnh gi\u1EA3i quy\u1EBFt:', className: 'col-25', value: this.state.data && this.state.data.huongThuLyGiaiQuyetInfo ? this.state.data.huongThuLyGiaiQuyetInfo.text : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.data && this.state.data.huongThuLyGiaiQuyet == 'GIAO_TTXM' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.Text, { label: lb1, className: 'col-25', value: this.state.data && this.state.data.donViThamTraXacMinhInfo ? this.state.data.donViThamTraXacMinhInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', className: 'col-25 mb10', value: this.state.data && this.state.data.ngayHetHanTTXM ? (0, _moment2.default)(this.state.data.ngayHetHanTTXM).format('DD/MM/YYYY') : '' })
                )
              )
            ),
            _react2.default.createElement(_common.TextMessage, { label: '\xDD ki\u1EBFn x\u1EED l\xFD:', className: 'col-100', value: this.props.yKienXuLy ? this.props.yKienXuLy : '' })
          )
        )
      );
    }
  }]);

  return KetQuaXuLyDon;
}(_react2.default.Component);

KetQuaXuLyDon.defaultProps = {
  dataGiaiQuyet: {
    thongTinGiaiQuyetDonInfo: {}
  },
  thamQuyenGiaiQuyet: '',
  phongBanGiaiQuyet: '',
  yKienXuLy: '',
  hideBorder: false
};

exports.default = KetQuaXuLyDon;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var LapDuThaoCanBo = function (_React$Component) {
  _inherits(LapDuThaoCanBo, _React$Component);

  function LapDuThaoCanBo(props, context) {
    _classCallCheck(this, LapDuThaoCanBo);

    var _this = _possibleConstructorReturn(this, (LapDuThaoCanBo.__proto__ || Object.getPrototypeOf(LapDuThaoCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      open: false,
      onSave: false,
      loaiDon: _this.props.loaiDon,
      gqText: _this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDon == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      tenDonViTheoDoiThucHien: '',
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      donViTheoDoiThucHien: '',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',
      noiDungDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataCoQuanTheoDoi: [],
      dataDonViNhanTDTH: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      openDialogGiaoTTXML: false,
      message: '',
      dataKetQuaGiaiQuyetDon: [],
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(LapDuThaoCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      this.getListDonViNhanTDTH();
      this.getDonViNhanTDTH();
      this.getThoiHanGQDonMacDinh();
      this.getThoiHanTTXMMacDinh();
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('giai-quyet-don/subView/LapDuThaoCanBo');
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, { type: this.props.loaiDon }).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this2.setState({
          ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this3 = this;

      var params = {
        type: this.props.loaiDon
      };
      if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this3.setState({
          ngayHetHanTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this4 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this4.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'getListDonViNhanTDTH',
    value: function getListDonViNhanTDTH() {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this5.setState({
            dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDonViNhanTDTH',
    value: function getDonViNhanTDTH() {
      var _this6 = this;

      var params = {
        donId: Number(this.state.id),
        loaiDon: this.state.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(function (res) {
        if (res.data) {
          _this6.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten
          });
        }
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this7.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this8.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          role: nextProps.role,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this9 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this9.setState({
              dataGiaiQuyetDon: res.data,
              nextState: 'KET_THUC',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false,

              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || ''
            }, function () {
              _this9.renderAttachFile();
              _this9.checkFileCoQuanDieuTra();
            });
            if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
              _this9.setState({ ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai) });
            }
            if (res.data.ngayHetHanTTXMLai) {
              _this9.setState({ ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai) });
            }
          }
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this10 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this10.state.giaoCoQuanDieuTra == false) {
          _this10.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this10.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this10.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this11 = this;

      var date = e;
      if (e && e._d) {
        date = e._d;
      }
      this.setState(_defineProperty({}, name, date), function () {
        if (name == 'ngayRaThongBaoTTXM') {
          _this11.setState({
            loaiVanBanSuggest: 'VB_GTTXML',
            ngayQuyetDinhSuggest: _this11.state.ngayRaThongBaoTTXM
          });
          _this11.getThoiHanTTXMMacDinh();
        }
        _this11.props.handleChangeData();
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this12 = this;

      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
      } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
      } else {
        this.setState(_defineProperty({}, name, e.target.value));

        if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi') {}
      }
      if (name == 'ketQuaXLDGiaiQuyet') {
        this.setState({
          allowAttach: false
        }, function () {
          _this12.renderAttachFile();
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({ ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
        var ttxmlDate = data.filter(function (item) {
          return item.typeRequired == 'VB_GTTXML';
        });
        if (ttxmlDate.length) {
          this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
        }
        this.getThoiHanTTXMMacDinh();
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.giaoCoQuanDieuTra) {

        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

        if (this.props.donInfo.layVuViecCu === true) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && this.props.donInfo.layVuViecCu === true) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;
        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;
        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }

      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.soVuGiaiQuyetKhieuNai = this.state.soVuGiaiQuyetKhieuNai;

      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      if (this.state.loaiDon == 'DON_TO_CAO') {
        if (this.state.doiThoai) {
          params.doiThoai = true;
          params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
          params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
          params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        } else {
          params.doiThoai = false;
          params.thoiGianDoiThoai = null;
          params.diaDiemDoiThoai = '';
          params.noiDungDoiThoai = '';
        }
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }
      if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
        params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
        params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
      }
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this13 = this;

      this.setState({
        onSave: true
      }, function () {

        _this13.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this13.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this13.state.taiLieuVanThuUpdate[_this13.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this13.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this13.state.taiLieuVanThu[_this13.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this13.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this13.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          var dataFile = [].concat(_toConsumableArray(_this13.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          dataFile.map(function (item) {
            _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!_this13.state.giaoCoQuanDieuTra) {
          var _dataFile = [].concat(_toConsumableArray(_this13.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          _dataFile.map(function (item) {
            _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this13.state.dataTaiLieuVanThuDelete.length > 0) {
          _this13.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this13.getParams();

        _this13.postTaiLieuVanThu(_this13.state.taiLieuVanThu, function () {
          _this13.updateTaiLieuVanThu(_this13.state.taiLieuVanThuUpdate, function () {
            _this13.deleteTaiLieuVanThu(_this13.state.taiLieuVanThuDelete, function () {
              _this13.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc(name) {
      var _this14 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this14.validateSubmitForm()) {
          _this14.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this14.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this14.state.taiLieuVanThuUpdate[_this14.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this14.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this14.state.taiLieuVanThu[_this14.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this14.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this14.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this14.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            var dataFile = [].concat(_toConsumableArray(_this14.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this14.state.giaoCoQuanDieuTra) {
            var _dataFile2 = [].concat(_toConsumableArray(_this14.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile2.map(function (item) {
              _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this14.state.dataTaiLieuVanThuDelete.length > 0) {
            _this14.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this14.getParams();
          var params = {};
          var msgName = '';

          if (_this14.props.tuGiaiQuyet) {
            if (name == 'openDialogGiaoTTXML') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this14.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_GIAO_TTXM_LAI'
              };
              msgName = 'guiTTXMLai';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this14.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: Number(_this14.state.donViTheoDoiThucHien)
                },
                // actionType: 'GQD_NHAN_BAO_CAO_TTXM' => bước này lưu hồ sơ
                actionType: 'QGD_GUI_YEU_CAU_TDTH'
              };
              _params.donViTheoDoiThucHien = {
                id: Number(_this14.state.donViTheoDoiThucHien)
              };
              msgName = 'gqdLuuHoSo';
            }
          } else {
            if (name == 'openDialog') {
              var selectedState = _this14.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
              });
              _params.donViTheoDoiThucHien = {
                id: Number(_this14.state.donViTheoDoiThucHien)
              };

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this14.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: Number(_this14.state.donViTheoDoiThucHien)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                }
              };
              params.yKienGiaiQuyet = _this14.state.lyDoBanHanhQuyetDinhDinhChi;
              if (_this14.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = _this14.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
              msgName = 'gqdChuyenTheoDoi';
            } else if (name == 'openDialogGiaoTTXML') {
              var _selectedState = _this14.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GIAO_TTXM_LAI';
              });
              params = {
                nextState: {
                  id: Number(_selectedState[0].stateId)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this14.props.thongTinGiaiQuyetDonId)
                },
                yKienGiaiQuyet: _this14.state.noiDungGiaoTTXMLai
              };
              msgName = 'guiTTXMLai';
              if (_this14.state.ngayRaThongBaoTTXM) {
                params.ngayRaThongBaoTTXM = (0, _moment2.default)(_this14.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
              }
            }
          }
          _this14.postTaiLieuVanThu(_this14.state.taiLieuVanThu, function () {
            _this14.updateTaiLieuVanThu(_this14.state.taiLieuVanThuUpdate, function () {
              _this14.deleteTaiLieuVanThu(_this14.state.taiLieuVanThuDelete, function () {
                _this14.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      this.props.handleChangeData();
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.closeDialog(name);
      this.handleKetThuc(name);
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      var _this15 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      }, function () {
        _this15.renderAttachFile();
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      var _this16 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      }, function () {
        _this16.renderAttachFile();
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this17 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this17.compareDate(new Date(state.ngayTao), new Date(_this17.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this17.compareDate(new Date(_this17.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
      });

      var dataTTXML = DataTaiLieuVanThu.filter(function (item) {
        return item.typeRequired == 'VB_GTTXML';
      });

      if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
        listTaiLieuVanThuGiaiQuyetDon = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon), [{
          ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'VB_GTTXML',
          newFile: true
        }]);
      }

      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this18 = this;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this18.state.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_subView.BlockBaoCaoKQTTXM, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb10' },
              'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showTienDoGiaiQuyet == false },
                _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { name: 'tienDoGiaiQuyet', disable: this.state.ketQuaXLDGiaiQuyet != '' && this.state.ketQuaXLDGiaiQuyet != 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false, confirm: true, className: 'col-25', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet'), isTTXMLai: this.props.isTTXMLai, loaiDon: this.props.loaiDon })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showTienDoGiaiQuyet == true },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai },
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayHetHanGiaiQuyetTTXMLai,
              label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
              name: 'ngayHetHanGiaiQuyetTTXMLai',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            this.props.loaiDon == 'DON_TO_CAO' && _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayRaThongBaoTTXM,
              label: 'Ng\xE0y ra v\u0103n b\u1EA3n ' + lb1 + ' l\u1EA1i',
              name: 'ngayRaThongBaoTTXM',
              onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayHetHanTTXMLai,
              label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3',
              name: 'ngayHetHanTTXMLai',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              rows: '3',
              placeholder: 'Nh\u1EADp \xFD ki\u1EBFn',
              value: this.state.noiDungGiaoTTXMLai,
              onChange: this.onChange.bind(this, 'noiDungGiaoTTXMLai'),
              name: 'textareaYKienTTXM' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-25', name: 'inputSoVanBan', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
              _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
              _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
              this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }) : null,
              this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, className: 'areal-wrap col-100', bindValidator: this, channel: 'formTaoDon', require: true, label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }) : null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.allowAttach },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt15' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, name: 'QuyetDinhGiaiQuyet', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt10 pb20' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              this.props.donInfo.layVuViecCu === true && _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') }),
                this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon == 'DON_TO_CAO' },
                  _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon != 'DON_TO_CAO' },
                  _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB ph\u1EA3n \xE1nh', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') })
                ),
                _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt10 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soVuGiaoCoQuanDieuTra', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soDoiTuongGiaoCoQuanDieuTra', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt15' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    _utils.ShowIfCheck,
                    { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5 pb20' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        'Kh\u1EDFi t\u1ED1'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-50 no-gutter' },
                          _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.allowAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'TaiLieuVTGQD', onSave: this.state.onSave, bindValidator: this, data: this.state.listTaiLieuVanThuGiaiQuyetDon, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom no-gutter gqd-wrap col-100' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line mt10 mb20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialog') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Chuy\u1EC3n theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoTTXML') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Giao ',
                  lb1,
                  ' l\u1EA1i'
                )
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this, 'openDialog'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?' }),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoTTXML, onClose: this.closeDialog.bind(this, 'openDialogGiaoTTXML'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoTTXML'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' ' + lb2 + ' l\u1EA1i kh\xF4ng?' })
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return LapDuThaoCanBo;
}(_react2.default.Component);

LapDuThaoCanBo.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LapDuThaoCanBo);

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var LapDuThaoDonKhieuNaiCanBo = function (_React$Component) {
  _inherits(LapDuThaoDonKhieuNaiCanBo, _React$Component);

  function LapDuThaoDonKhieuNaiCanBo(props, context) {
    _classCallCheck(this, LapDuThaoDonKhieuNaiCanBo);

    var _this = _possibleConstructorReturn(this, (LapDuThaoDonKhieuNaiCanBo.__proto__ || Object.getPrototypeOf(LapDuThaoDonKhieuNaiCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      open: false,
      onSave: false,
      loaiDon: _this.props.loaiDon,
      gqText: _this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDon == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataKetQuaGiaiQuyetDon: [],
      dataCoQuanTheoDoi: [],
      dataDonViNhanTDTH: [],
      donViTheoDoiThucHien: '',
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      tenDonViTheoDoiThucHien: '',
      tienDoDoiThoai: '',
      message: 'Chọn "' + _this.gqText + '" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      openDialogGiaoTTXML: false,
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(LapDuThaoDonKhieuNaiCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      this.getListDonViNhanTDTH();
      this.getDonViNhanTDTH();
      this.getKetQuaGiaiQuyetDon();
      this.getThoiHanGQDonMacDinh();
      this.getThoiHanTTXMMacDinh();
      if (window.debug) {
        console.log('giai-quyet-don/subView/LapDuThaoDonKhieuNaiCanBo');
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, { type: this.props.loaiDon }).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this2.setState({
          ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this3 = this;

      var params = {
        type: this.props.loaiDon
      };
      if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this3.setState({
          ngayHetHanTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getListDonViNhanTDTH',
    value: function getListDonViNhanTDTH() {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDonViNhanTDTH',
    value: function getDonViNhanTDTH() {
      var _this5 = this;

      var params = {
        donId: Number(this.state.id),
        loaiDon: this.state.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(function (res) {
        if (res.data) {
          _this5.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten
          });
        }
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this7 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this7.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this8.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          role: nextProps.role,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this9 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this9.setState({
              dataGiaiQuyetDon: res.data,
              nextState: 'KET_THUC',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM || '',

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              tienDoDoiThoai: _this9.props.isTTXMLai && res.data.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' ? '' : res.data.ketQuaXLDGiaiQuyet || '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? true : false,

              noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || '',
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              noiDungGiaoLapDuThao: res.data.noiDungGiaoLapDuThao ? res.data.noiDungGiaoLapDuThao : ''
            }, function () {
              _this9.renderAttachFile();
              _this9.getNgayHetHanLapDuThao();
              _this9.checkFileCoQuanDieuTra();
            });
            if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
              _this9.setState({ ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai) });
            }
            if (res.data.ngayHetHanTTXMLai) {
              _this9.setState({ ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai) });
            }
          }
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this10 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this10.state.giaoCoQuanDieuTra == false) {
          _this10.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this10.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this10.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'getNgayHetHanLapDuThao',
    value: function getNgayHetHanLapDuThao() {
      var _this11 = this;

      _api.GiaiQuyetDonThu.actions.getNgayHetHanLapDuThao.request().then(function (res) {
        if (res.data) {
          _this11.setState({
            ngayHetHanGiaoLapDuThao: res.data
          });
        } else {
          _this11.setState({
            ngayHetHanGiaoLapDuThao: ''
          });
        }
      });
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this12 = this;

      this.setState({

        coQuanDieuTra: '',
        soVuGiaoCoQuanDieuTra: 0,
        soDoiTuongGiaoCoQuanDieuTra: 0,

        tienPhaiThuNhaNuoc: 0,
        datPhaiThuNhaNuoc: 0,
        tienPhaiTraCongDan: 0,
        datPhaiTraCongDan: 0,
        tongSoNguoiXuLyHanhChinh: 0,
        soNguoiDaBiXuLyHanhChinh: 0,

        hinhThucTheoDoi: '',
        coQuanTheoDoi: '',
        ketQuaThucHienTheoDoi: '',

        soVanBan: '',
        ngayBanHanh: '',
        nguoiBanHanh: '',

        khoiTo: false,
        soVuBiKhoiTo: 0,
        soDoiTuongBiKhoiTo: 0,

        tienDaThuNhaNuoc: 0,
        datDaThuNhaNuoc: 0,
        tienDaTraCongDan: 0,
        datDaTraCongDan: 0,

        giaoCoQuanDieuTra: false,
        quyetDinhGiaiQuyetKhieuNai: false,
        theoDoiThucHien: false,

        tienPhaiThuNhaNuocQDGQ: 0,
        tienPhaiTraCongDanQDGQ: 0,
        datPhaiThuNhaNuocQDGQ: 0,
        datPhaiTraCongDanQDGQ: 0,
        soNguoiDuocTraLaiQuyenLoi: 0,

        soVuGiaiQuyetKhieuNai: 0,

        soLanGiaiQuyetLai: 0,
        ketQuaGiaiQuyetLan2: '',
        noiDungKetLuanGiaiQuyetLai: '',

        ketQuaGiaiQuyetKhac: '',
        ketQuaThucHienKhac: ''
      }, function () {
        _this12.renderAttachFile();
        _this12.getNgayHetHanLapDuThao();
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this13 = this;

      var date = e;
      if (e && e._d) {
        date = e._d;
      }
      this.setState(_defineProperty({}, name, date), function () {
        if (name == 'ngayRaThongBaoTTXM') {
          _this13.setState({
            loaiVanBanSuggest: 'VB_GTTXML',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoTTXM
          });
          _this13.getThoiHanTTXMMacDinh();
        }
        _this13.props.handleChangeData();
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this14 = this;

      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.allowAttach = false;
        this.state.valueKetQua = e.target.value;

        this.setState(_extends({}, this.state));
        this.resetData();
      } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.allowAttach = false;
        this.state.valueKetQua = e.target.value;

        this.setState(_extends({}, this.state));
        this.resetData();
      } else {
        var _setState2;

        this.setState((_setState2 = {}, _defineProperty(_setState2, name, e.target.value), _defineProperty(_setState2, 'valueKetQua', ''), _setState2));

        if (name == 'tienDoDoiThoai') {
          this.state.ketQuaXLDGiaiQuyet = '';
          this.state[name] = e.target.value;
          this.setState(_extends({}, this.state));
          this.resetData();
        }

        if (name == 'ketQuaXLDGiaiQuyet') {
          this.resetData();
        }

        if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }
      }
      if (name == 'ketQuaXLDGiaiQuyet') {
        this.setState({
          allowAttach: false
        }, function () {
          _this14.renderAttachFile();
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({
          ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '',
          soVanBan: fileQD.length ? fileQD[0].soQuyetDinh : ''
        });
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
        var ttxmlDate = data.filter(function (item) {
          return item.typeRequired == 'VB_GTTXML';
        });
        if (ttxmlDate.length) {
          this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
        }
        this.getThoiHanTTXMMacDinh();
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

        if (this.props.donInfo.layVuViecCu === true) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && this.props.donInfo.layVuViecCu === true) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.theoDoiThucHien = false;
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;

        params.ketQuaThucHienKhac = '';

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;

        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }

      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      if (this.state.tienDoDoiThoai == 'DOI_THOAI') {
        params.doiThoai = true;
        params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        params.noiDungGiaoLapDuThao = this.state.noiDungGiaoLapDuThao;
        params.ngayHetHanGiaoLapDuThao = this.state.ngayHetHanGiaoLapDuThao;
      } else if (this.props.nhanDuThao != true) {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
        params.noiDungGiaoLapDuThao = '';
        params.ngayHetHanGiaoLapDuThao = null;
      }
      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : this.state.tienDoDoiThoai ? this.state.tienDoDoiThoai : null;
      if (this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
        params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
        params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
      }

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this15 = this;

      this.setState({
        onSave: true
      }, function () {

        _this15.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this15.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this15.state.taiLieuVanThuUpdate[_this15.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this15.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this15.state.taiLieuVanThu[_this15.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this15.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this15.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this15.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          var dataFile = [].concat(_toConsumableArray(_this15.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          dataFile.map(function (item) {
            _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!_this15.state.giaoCoQuanDieuTra) {
          var _dataFile = [].concat(_toConsumableArray(_this15.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          _dataFile.map(function (item) {
            _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this15.state.dataTaiLieuVanThuDelete.length > 0) {
          _this15.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this15.state.taiLieuVanThuDelete[_this15.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this15.getParams();

        _this15.postTaiLieuVanThu(_this15.state.taiLieuVanThu, function () {
          _this15.updateTaiLieuVanThu(_this15.state.taiLieuVanThuUpdate, function () {
            _this15.deleteTaiLieuVanThu(_this15.state.taiLieuVanThuDelete, function () {
              _this15.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc(type) {
      var _this16 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this16.validateSubmitForm()) {
          _this16.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this16.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this16.state.taiLieuVanThuUpdate[_this16.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this16.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this16.state.taiLieuVanThu[_this16.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this16.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this16.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this16.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            var dataFile = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this16.state.giaoCoQuanDieuTra) {
            var _dataFile2 = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile2.map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this16.state.dataTaiLieuVanThuDelete.length > 0) {
            _this16.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this16.getParams();
          var params = {};
          var msgName = '';

          if (_this16.props.tuGiaiQuyet == true) {
            if (type == 'openDialogLuuHoSo') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: Number(_this16.state.donViTheoDoiThucHien)
                },
                // actionType: 'GQD_NHAN_BAO_CAO_TTXM' => bước này lưu hồ sơ
                actionType: 'QGD_GUI_YEU_CAU_TDTH'
              };
              _params.donViTheoDoiThucHien = {
                id: Number(_this16.state.donViTheoDoiThucHien)
              };
              params.yKienGiaiQuyet = _this16.state.lyDoBanHanhQuyetDinhDinhChi;
              if (_this16.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = _this16.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
              msgName = 'gqdChuyenTheoDoi';
            } else if (type == 'openDialogGiaoTTXML') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_GIAO_TTXM_LAI',
                yKienGiaiQuyet: _this16.state.noiDungGiaoTTXMLai
              };
              msgName = 'guiTTXMLai';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_NHAN_BAO_CAO_TTXM_GUI_DU_THAO'
              };
              msgName = 'gqdGuiDuThao';
            }
          } else {
            if (type == 'openDialogLuuHoSo') {
              var selectedState = _this16.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
              });
              _params.donViTheoDoiThucHien = {
                id: Number(_this16.state.donViTheoDoiThucHien)
              };

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                donViTheoDoiThucHien: {
                  id: Number(_this16.state.donViTheoDoiThucHien)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                }
              };
              params.yKienGiaiQuyet = _this16.state.lyDoBanHanhQuyetDinhDinhChi;
              if (_this16.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
                params.yKienGiaiQuyet = _this16.state.lyDoBanHanhQuyetDinhGiaiQuyet;
              }
              msgName = 'gqdChuyenTheoDoi';
            } else if (type == 'openDialogGiaoTTXML') {
              var _selectedState = _this16.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GIAO_TTXM_LAI';
              });
              params = {
                nextState: {
                  id: Number(_selectedState[0].stateId)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                yKienGiaiQuyet: _this16.state.noiDungGiaoTTXMLai
              };
              msgName = 'guiTTXMLai';
              if (_this16.state.ngayRaThongBaoTTXM) {
                params.ngayRaThongBaoTTXM = (0, _moment2.default)(_this16.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
              }
            } else {
              var _selectedState2 = _this16.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
              });

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this16.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(_selectedState2[0].stateId)
                },
                yKienGiaiQuyet: _this16.state.noiDungGiaoLapDuThao ? _this16.state.noiDungGiaoLapDuThao : ''
              };
              msgName = 'gqdGuiDuThao';
            }
          }
          _this16.postTaiLieuVanThu(_this16.state.taiLieuVanThu, function () {
            _this16.updateTaiLieuVanThu(_this16.state.taiLieuVanThuUpdate, function () {
              _this16.deleteTaiLieuVanThu(_this16.state.taiLieuVanThuDelete, function () {
                _this16.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      this.props.handleChangeData();
    }
  }, {
    key: 'openDialog',
    value: function openDialog(type) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, type, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(type) {
      this.setState(_defineProperty({}, type, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(type) {
      this.closeDialog(type);
      this.handleKetThuc(type);
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      var _this17 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      }, function () {
        _this17.renderAttachFile();
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      var _this18 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      }, function () {
        _this18.renderAttachFile();
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();
      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this19 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = [];

      var listTaiLieuVanThuGiaiQuyetDonView = [];

      if (this.props.nhanDuThao == true) {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this19.compareDate(new Date(state.ngayTao), new Date(_this19.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this19.compareDate(new Date(_this19.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), new Date(state.ngayTao), 'show');
        });
      } else {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this19.compareDate(new Date(state.ngayTao), new Date(_this19.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this19.compareDate(new Date(_this19.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
        });
      }
      if (this.props.nhanDuThao != true) {
        if (this.state.tienDoDoiThoai == 'DOI_THOAI' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
          var dataCheck = data.filter(function (item) {
            return item.required && item.typeRequired == 'BB_DOI_THOAI';
          });
          if (!dataCheck.length) {
            listTaiLieuVanThuGiaiQuyetDon[listTaiLieuVanThuGiaiQuyetDon.length] = {
              ten: 'Biên bản đối thoại',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'BB_DOI_THOAI',
              newFile: true
            };
          }

          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            allowAttach: true
          });
        } else {
          this.setState({
            allowAttach: false
          });
          var _data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));

          var dataFillter = _data.filter(function (item) {
            return item.typeRequired != 'BB_DOI_THOAI';
          });
          var dataTTXML = _data.filter(function (item) {
            return item.typeRequired == 'VB_GTTXML';
          });

          var _dataCheck = _data.filter(function (item) {
            return item.taiLieuVanThuId && item.typeRequired == 'BB_DOI_THOAI';
          });
          if (_dataCheck.length > 0) {
            _dataCheck.map(function (item) {
              _this19.state.taiLieuVanThuDelete = [].concat(_toConsumableArray(_this19.state.taiLieuVanThuDelete), [{ id: item.taiLieuVanThuId }]);
            });
          }
          if (this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
            dataFillter = [].concat(_toConsumableArray(dataFillter), [{
              ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'VB_GTTXML',
              newFile: true
            }]);
          }
          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: dataFillter,
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            allowAttach: true
          });
        }
      } else {
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this20 = this;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this20.state.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb10' },
              'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true },
                _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { disable: this.state.ketQuaXLDGiaiQuyet != '' && this.state.ketQuaXLDGiaiQuyet != 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false, name: 'tienDoDoiThoai', className: 'col-25', selectedValue: this.state.tienDoDoiThoai, onChange: this.onChange.bind(this, 'tienDoDoiThoai'), isTTXMLai: this.props.isTTXMLai, loaiDon: this.props.loaiDon }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao == true },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showTienDoGiaiQuyet },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' },
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayHetHanGiaiQuyetTTXMLai,
              label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
              name: 'ngayHetHanGiaiQuyetTTXMLai',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayRaThongBaoTTXM,
              label: 'Ngày ra văn bản ' + lb1 + ' lại',
              name: 'ngayRaThongBaoTTXM',
              onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.ngayHetHanTTXMLai,
              label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3',
              name: 'ngayHetHanTTXMLai',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai'),
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              rows: '3',
              placeholder: 'Nh\u1EADp \xFD ki\u1EBFn',
              value: this.state.noiDungGiaoTTXMLai,
              onChange: this.onChange.bind(this, 'noiDungGiaoTTXMLai'),
              name: 'textareaYKienTTXM' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.tienDoDoiThoai == 'DOI_THOAI' && !this.props.nhanDuThao },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  '\u0110\u1ED1i tho\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                  _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                  _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', channel: 'formTaoDon', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', name: 'ketQuaDoiThoai', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.tienDoDoiThoai == 'DOI_THOAI' && !this.props.nhanDuThao },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', value: this.state.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '', red: true }),
                  _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD', value: this.state.noiDungGiaoLapDuThao, onChange: this.onChange.bind(this, 'noiDungGiaoLapDuThao'), name: 'noiDungGiaoLapDuThao' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Input, { triggeOnBlur: true, name: 'inputSoVanBan', className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
                _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }) : null,
                this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }) : null,
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.allowAttach },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 pt15' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, name: 'QuyetDinhGQ', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt10 pb20' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                this.props.donInfo.layVuViecCu === true && _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') }),
                  this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                  _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: this.props.loaiDon === "DON_TRANH_CHAP_DAT" ? "Kết luận nội dung tranh chấp đất" : "Kết luận nội dung khiếu nại", className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb5' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                    _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                    _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                    ),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt10 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb5' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soVuGiaoCoQuanDieuTra', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soDoiTuongGiaoCoQuanDieuTra', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 pt15' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5 pb20' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Kh\u1EDFi t\u1ED1'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter' },
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.allowAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'TaiLieuVTGQD', onSave: this.state.onSave, bindValidator: this, data: this.state.listTaiLieuVanThuGiaiQuyetDon, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom no-gutter gqd-wrap col-100' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line mt10 mb20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogLuuHoSo') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Chuy\u1EC3n theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.tienDoDoiThoai == 'DOI_THOAI' && !this.props.nhanDuThao },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoDoiThoai') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Chuy\u1EC3n \u0111\u01A1n v\u1ECB ',
                  lb1
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoTTXML') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Giao ',
                  lb1,
                  ' l\u1EA1i'
                )
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this, 'openDialogLuuHoSo'), onSuccess: this.onSuccess.bind(this, 'openDialogLuuHoSo'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?' }),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoDoiThoai, onClose: this.closeDialog.bind(this, 'openDialogGiaoDoiThoai'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoDoiThoai'), title: 'X\xE1c nh\u1EADn', content: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' lập dự thảo không?' }),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoTTXML, onClose: this.closeDialog.bind(this, 'openDialogGiaoTTXML'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoTTXML'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' ' + lb2 + ' l\u1EA1i kh\xF4ng?' })
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return LapDuThaoDonKhieuNaiCanBo;
}(_react2.default.Component);

LapDuThaoDonKhieuNaiCanBo.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  listTaiLieuVanThuGiaiQuyetDon: [],
  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: [],
  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LapDuThaoDonKhieuNaiCanBo);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LichSuTrangThaiXuLyGiaiQuyetDon = function (_React$Component) {
  _inherits(LichSuTrangThaiXuLyGiaiQuyetDon, _React$Component);

  function LichSuTrangThaiXuLyGiaiQuyetDon(props, context) {
    _classCallCheck(this, LichSuTrangThaiXuLyGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (LichSuTrangThaiXuLyGiaiQuyetDon.__proto__ || Object.getPrototypeOf(LichSuTrangThaiXuLyGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      isOpen: true
    };
    return _this;
  }

  _createClass(LichSuTrangThaiXuLyGiaiQuyetDon, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'showTinhTrangXuLyDon',
    value: function showTinhTrangXuLyDon(tinhTrangInfo) {
      if (tinhTrangInfo.type === 'DAY') {
        if (tinhTrangInfo.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (tinhTrangInfo.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            tinhTrangInfo.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(tinhTrangInfo.value),
            ' ng\xE0y'
          );
        }
      } else if (tinhTrangInfo.type === 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          tinhTrangInfo.value
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var LichSuTrangThaiXuLyGiaiQuyetDon = '';
      if (this.props.dataLichSuTrangThaiXuLyGiaiQuyetDon) {
        LichSuTrangThaiXuLyGiaiQuyetDon = this.props.dataLichSuTrangThaiXuLyGiaiQuyetDon.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { className: 'history-items', key: i },
            _react2.default.createElement(
              'div',
              { className: 'radio-column' },
              _react2.default.createElement(_core.Radio, { defaultChecked: true })
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold txt-upper' },
                item.tenInfo.ten ? item.tenInfo.ten : null
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.ngayBatDauInfo ? (0, _moment2.default)(item.ngayBatDauInfo).format('DD/MM/YYYY - HH:mm') : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                'Th\u1EDDi h\u1EA1n:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.thoiHanInfo ? (0, _moment2.default)(item.thoiHanInfo).format('DD/MM/YYYY') : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                'T\xECnh tr\u1EA1ng:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.tinhTrangInfo.status ? item.tinhTrangInfo.status : _this2.showTinhTrangXuLyDon(item.tinhTrangInfo)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                '\u0110\u01A1n v\u1ECB x\u1EED l\xFD:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.donViXuLyInfo ? item.donViXuLyInfo.ten : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                'Ng\u01B0\u1EDDi x\u1EED l\xFD:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.nguoiXuLyInfo ? item.nguoiXuLyInfo.hoVaTen : null
              )
            )
          );
        });
      } else {
        LichSuTrangThaiXuLyGiaiQuyetDon = _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'container-box' },
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    this.props.title
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form white-table mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-history wrap-history-cols' },
                    LichSuTrangThaiXuLyGiaiQuyetDon
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LichSuTrangThaiXuLyGiaiQuyetDon;
}(_react2.default.Component);

exports.default = LichSuTrangThaiXuLyGiaiQuyetDon;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var ListSearch = function (_React$Component) {
  _inherits(ListSearch, _React$Component);

  function ListSearch(props, context) {
    _classCallCheck(this, ListSearch);

    var _this = _possibleConstructorReturn(this, (ListSearch.__proto__ || Object.getPrototypeOf(ListSearch)).call(this, props, context));

    _this.state = {
      tuKhoa: '',
      maDon: '',
      phanLoaiDon: '',
      isSaveTemp: false,
      nguonDon: '',
      tinhTrangGiaiQuyet: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      ketQuaGiaiQuyet: '',

      searching: _this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(ListSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem(this.props.cookieName) ? JSON.parse(localStorage.getItem(this.props.cookieName)) : {};
      this.state.tuKhoa = data.hoTen || '';
      if (data.advanceSearch) {
        this.state.isSaveTemp = data.isSaveTemp;
        this.state.maDon = data.maDon || '';
        this.state.nguonDon = data.nguonDon || '';
        this.state.phanLoaiDon = data.phanLoaiDon || '';
        this.state.tinhTrangXuLy = data.trangThaiDonToanHT || '';
        this.state.ketQuaXuLy = data.ketQuaToanHT || '';
        this.state.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      if (!this.props.advanceSearch) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      } else {
        if (this.validateSubmitForm()) {
          this.setState({
            doSearch: true
          });
          this.props.handleSearch(this.state, e);
        }
      }
      return;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      // if (!this.refs.containerFileDinhKem.validate()) {
      //   pass = false;
      // }
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      if (name === "isSaveTemp") {
        this.setState({ isSaveTemp: !this.state.isSaveTemp });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        isSaveTemp: false,
        tuKhoa: '',
        maDon: '',
        phanLoaiDon: '',
        nguonDon: '',
        tinhTrangGiaiQuyet: '',

        tiepNhanTuNgay: '',
        tiepNhanDenNgay: '',

        ketQuaGiaiQuyet: '',

        searching: false,
        spSearch: false,
        search: false,
        doSearch: false,
        searchLoading: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');
      }
      if (this.state.doSearch) {
        classes.push('btn-loading');
      }

      var btnClasses = classNames(classes);

      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(_common.InputTuKhoa, {
          label: 'T\u1EEB kho\xE1',
          className: this.state.spSearch ? 'col-40' : 'input-group-show',
          value: this.state.tuKhoa,
          onChange: this.handleChange.bind(this, 'tuKhoa'),
          placeholder: 'Nh\u1EADp t\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n \u0111\u1EC3 t\xECm ki\u1EBFm...', maxLength: 255 }),
        _react2.default.createElement(_common.DatePicker, { className: 'input-20', label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.tiepNhanDenNgay, onChange: this.handleChangeDate.bind(this, 'tiepNhanTuNgay'), value: this.state.tiepNhanTuNgay }),
        _react2.default.createElement(_common.DatePicker, { className: 'input-20', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tiepNhanTuNgay, onChange: this.handleChangeDate.bind(this, 'tiepNhanDenNgay'), value: this.state.tiepNhanDenNgay }),
        _react2.default.createElement(_common.Input, { label: 'M\xE3 \u0111\u01A1n', value: this.state.maDon, className: 'input-20', onChange: this.handleChange.bind(this, 'maDon'), placeholder: 'Nh\u1EADp m\xE3 \u0111\u01A1n...' }),
        _react2.default.createElement(
          'div',
          { className: 'btn-wrap-20' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(_ttForms.DropDownChonNguonDon, { selectedValue: this.state.nguonDon, className: 'input-20 clear-left', onChange: this.handleChange.bind(this, 'nguonDon') }),
        _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, className: 'input-20', onChange: this.handleChange.bind(this, 'phanLoaiDon') }),
        _react2.default.createElement(_ttForms.DropDownTinhTrangGiaiQuyet, { selectedValue: this.state.tinhTrangGiaiQuyet, label: 'T\xECnh tr\u1EA1ng x\u1EED l\xFD', className: 'input-20', onChange: this.handleChange.bind(this, 'tinhTrangGiaiQuyet') }),
        _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyet, { selectedValue: this.state.ketQuaGiaiQuyet, className: 'input-20', onChange: this.handleChange.bind(this, 'ketQuaGiaiQuyet') }),
        _react2.default.createElement(
          'div',
          { className: 'input-20' },
          _react2.default.createElement(
            _reactRouter.Link,
            {
              className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search",
              onClick: this.cancel.bind(this) },
            _react2.default.createElement('i', { className: 'tt tt-delete' }),
            'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
          )
        ),
        this.props.onStatus === 'DANG_GIAI_QUYET' && _react2.default.createElement(
          'div',
          { className: 'input-20 checkbox-luutam' },
          _react2.default.createElement(
            _core.Checkbox,
            { className: 'pt-large', checked: this.state.isSaveTemp, onChange: this.handleChange.bind(this, 'isSaveTemp'), name: 'donLuuTam' },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u01A1n \u0111\xE3 l\u01B0u t\u1EA1m'
            )
          )
        )
      );
    }
  }]);

  return ListSearch;
}(_react2.default.Component);

ListSearch.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },
  cookieName: 'gqdData',
  disabled: false,
  searching: false
};

exports.default = ListSearch;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
var buocGiaiQuyet = null;

var NhapThongTinToTTXX = function (_React$Component) {
  _inherits(NhapThongTinToTTXX, _React$Component);

  function NhapThongTinToTTXX(props, context) {
    _classCallCheck(this, NhapThongTinToTTXX);

    var _this = _possibleConstructorReturn(this, (NhapThongTinToTTXX.__proto__ || Object.getPrototypeOf(NhapThongTinToTTXX)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      loaiDon: _this.props.loaiDon,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTraDon: false,
      onSave: false,

      lapToDoanXacMinh: false,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      nextState: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      yKienGiaiQuyet: '',

      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      donViId: '',
      giaHanTTXM: false,
      giaHanGiaiQuyet: false,
      dataNextStatesTXL: [],
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      dataNextState: [],
      showAttach: false,
      lyDoQuaHan: ''
    };
    return _this;
  }

  _createClass(NhapThongTinToTTXX, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.initHuongXuLyData(this.props.dataNextStates, 'dataNextState');
      if (this.props.tuGiaiQuyet == true && !this.props.donInfo.laTTXMLai) {
        this.initHuongXuLyData(this.props.dataNextStatesTXL, 'dataNextStatesTXL');
      }
    }
  }, {
    key: 'initHuongXuLyData',
    value: function initHuongXuLyData(inputData, name) {
      var ttxmText = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var ttxmText1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ttxmText + ' và dự thảo văn bản GQ' : ttxmText;
      var outputData = [].concat(_toConsumableArray(inputData));
      outputData = outputData.map(function (item) {
        if (item.type == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          return item = _extends({}, item, {
            tenVietTat: 'Gửi báo cáo ' + ttxmText1,
            ten: 'Gửi báo cáo ' + ttxmText1
          });
        }
        if (item.type == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          return item = _extends({}, item, {
            tenVietTat: 'Trả đơn do chuyển ' + ttxmText + ' không đúng',
            ten: 'Trả đơn do chuyển ' + ttxmText + ' không đúng'
          });
        }
        return item;
      });
      this.setState(_defineProperty({}, name, outputData));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
      if (nextProps.dataNextStates != this.props.dataNextStates) {
        this.initHuongXuLyData(nextProps.dataNextStates, 'dataNextState');
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            var _noiDung = res.data.noiDung || '';
            if (_this2.props.donInfo && _this2.props.donInfo.laTTXMLai) {
              _noiDung = res.data.noiDungTraBaoCaoTTXMLan2 || '';
            }
            _this2.setState({
              dataGiaiQuyetDon: res.data,

              lapToDoanXacMinh: res.data.lapToDoanXacMinh,
              soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
              truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

              ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',
              lyDoQuaHan: res.data.lyDoQuaHan || '',
              noiDung: _noiDung,
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

              giaHanTTXM: res.data.giaHanTTXM,
              giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,

              nextState: res.data.nextStateInfo ? res.data.nextStateInfo.type : 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',

              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? (0, _moment2.default)(res.data.ngayHetHanSauKhiGiaHanTTXM).format('DD/MM/YYYY') : '',
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '',
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : ''
            }, function () {
              if (_this2.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
                _this2.checkFileRequired();
              }
              if (_this2.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
                _this2.filterFileRequired();
              }
            });
          }
        });
      }
    }
  }, {
    key: 'filterFileRequired',
    value: function filterFileRequired() {
      var _this3 = this;

      var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this3.state.donViId;
      });

      var dataFilter = ListTaiLieuVanThuShow.filter(function (state) {
        return state.typeRequired != 'BC_KQTTXM';
      });
      var dataFilter2 = this.state.ListTaiLieuVanThu.filter(function (state) {
        return state.typeRequired != 'BC_KQTTXM' && state.typeRequired != 'KQTTXM_DTVBGQ';
      });

      this.setState({
        ListTaiLieuVanThuShow: dataFilter,
        ListTaiLieuVanThu: dataFilter2,
        showAttach: true
      });
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this4 = this;

      var data = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM.filter(function (state) {
        return state.nguoiTaoInfo.donViId == _this4.state.donViId;
      });

      var dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this4.state.donViId;
      });
      if (this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO' || this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {

        var isTTXML = this.props.donInfo && this.props.donInfo.laTTXMLai ? true : false;
        if (isTTXML == true) {
          dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView.filter(function (item) {
            return item.typeRequired != 'BC_KQTTXM_L';
          });
          data = data.filter(function (item) {
            return item.typeRequired != 'BC_KQTTXM' && item.typeRequired != 'KQTTXM_DTVBGQ';
          });
        }
        var checkKQTTXM = data.filter(function (item) {
          if (isTTXML == true) return item.typeRequired == 'BC_KQTTXM_L';else return item.typeRequired == 'BC_KQTTXM';
        });
        if (checkKQTTXM.length == 0) {
          var itemKQTTXM = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            required: false,
            progress: 0,
            typeRequired: isTTXML == true ? 'BC_KQTTXM_L' : 'BC_KQTTXM',
            newFile: true
          };
          if (this.props.loaiDon == 'DON_TO_CAO') {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo' + (isTTXML == true ? ' (Lần 2)' : '');
          } else if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
            itemKQTTXM.ten = 'Văn bản xác minh đề xuất' + (isTTXML == true ? ' (Lần 2)' : '');
          } else {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại' + (isTTXML == true ? ' (Lần 2)' : '');
          }
          data = [].concat(_toConsumableArray(data), [itemKQTTXM]);
        }

        if ((this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' || this.props.loaiDon == 'DON_TO_CAO') && this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          var checkDTVBGQ = data.filter(function (item) {
            if (isTTXML == true) return item.typeRequired == 'KQTTXM_DTVBGQ_L';else return item.typeRequired == 'KQTTXM_DTVBGQ';
          });
          if (checkDTVBGQ.length == 0) {
            var itemDTVBGQ = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              ten: this.props.loaiDon == 'DON_TO_CAO' ? 'Dự thảo kết luận nội dung tố cáo' : 'Dự thảo văn bản giải quyết',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: isTTXML == true ? 'KQTTXM_DTVBGQ_L' : 'KQTTXM_DTVBGQ',
              newFile: true
            };
            data = [].concat(_toConsumableArray(data), [itemDTVBGQ]);
          }
        }
      }
      this.setState({
        ListTaiLieuVanThu: data,
        ListTaiLieuVanThuShow: dataShow,
        showAttach: true
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      this.setState({
        onSave: true
      }, function () {

        _this5.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDelete = [];
        if (_this5.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this5.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          _this5.state.dataFileDinhKem.forEach(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: _this5.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                buocGiaiQuyet: buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (_this5.state.dataTaiLieuVanThuDelete.length > 0) {
            _this5.state.dataTaiLieuVanThuDelete.forEach(function (item) {
              _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        } else {
          var data = [].concat(_toConsumableArray(_this5.props.listTaiLieuVanThuGiaiQuyetDon));
          data.filter(function (state) {
            return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
          }).map(function (item) {
            dataFileDelete[dataFileDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        var params = _this5.getParams();

        if (_this5.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this5.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          _this5.postTaiLieuVanThu(_this5.state.taiLieuVanThu, function () {
            _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
              _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
                _this5.props.saveGiaiQuyetDon(params, 'gqdLuu');
              });
            });
          });
        } else {
          _this5.deleteTaiLieuVanThu(dataFileDelete, function () {
            _this5.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        }
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this6 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this6.validateSubmitForm()) {
          _this6.setState({
            btnLoading: true
          });
          var dataFileDelete = [];
          if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this6.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
            _this6.state.dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: _this6.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' ? 'XU_LY_DON' : loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (_this6.state.dataTaiLieuVanThuDelete.length > 0) {
              _this6.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          } else {
            var data = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDon));
            data.filter(function (state) {
              return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
            }).forEach(function (item) {
              dataFileDelete[dataFileDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          var _params = _this6.getParams();
          var params = {};
          var msgName = '';
          var isQuaHan = _this6.props.donInfo.thoiHanTTXMInfo && _this6.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;

          if (_this6.props.tuGiaiQuyet) {
            if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'TTXM_GUI_DON_VI_GIAI_QUYET',
                yKienGiaiQuyet: _this6.state.noiDung
              };
              if (isQuaHan == true) {
                params.lyDoQuaHan = _this6.state.lyDoQuaHan;
              }
              msgName = 'gqdTraBaoCao';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
                yKienGiaiQuyet: _this6.state.yKienGiaiQuyet
              };
              msgName = 'gqdTraDonThanhCong';
            }
          } else {
            var selectedState = _this6.props.dataNextStates.filter(function (state) {
              return state.type == _this6.state.nextState;
            });
            if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this6.state.noiDung
              };
              if (isQuaHan == true) {
                params.lyDoQuaHan = _this6.state.lyDoQuaHan;
              }
              msgName = 'gqdTraBaoCao';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this6.state.yKienGiaiQuyet
              };
              msgName = 'gqdTraDonThanhCong';
            }
          }
          if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || _this6.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
            _this6.postTaiLieuVanThu(_this6.state.taiLieuVanThu, function () {
              _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
                _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
                  _this6.props.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          } else {
            _this6.deleteTaiLieuVanThu(dataFileDelete, function () {
              _this6.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          }
        }
      });
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this7 = this;

      if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        this.setState(_defineProperty({
          showAttach: false,
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: ''
        }, name, e.target.value), function () {
          _this7.checkFileRequired();
        });
      } else if (name == 'nextState' && e.target.value == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        this.setState(_defineProperty({
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: '',
          showAttach: false
        }, name, e.target.value), function () {
          _this7.filterFileRequired();
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      if (name == 'nextState') {}
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this8 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM || null;
      if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
        params.noiDungTraBaoCaoTTXMLan2 = this.state.noiDung;
      } else {
        params.noiDung = this.state.noiDung || '';
      }
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet || '';
      if (this.props.tuGiaiQuyet != true) {
        if (this.state.nextState) {
          var selectedState = this.props.dataNextStates.filter(function (state) {
            return state.type == _this8.state.nextState;
          });
          params.nextState = {
            id: selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
      } else {
        if (this.state.nextState) {
          var _selectedState = this.props.dataNextStatesTXL.filter(function (state) {
            return state.type == _this8.state.nextState;
          });
          params.nextState = {
            id: _selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
      }
      var isQuaHan = this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
      if (isQuaHan == true) {
        params.lyDoQuaHan = this.state.lyDoQuaHan;
      }

      return params;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState(_defineProperty({}, name, false));
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      var lb3 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      var lbGuiTTXM = 'Gửi báo cáo ' + lb1;
      var lbTraTTXM = 'Trả đơn do chuyển ' + lb1 + ' không đúng';
      var isQuaHan = this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
          donInfo: this.props.donInfo,
          ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                  lb2
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                      ),
                      _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb15', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.dataNextState.length > 1 },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      onRef: function onRef(select) {
                        return _this9.select = select;
                      },
                      className: 'col-25',
                      donId: this.state.id,
                      isValid: this.state.validate,
                      data: this.state.dataNextState,
                      placeholder: null,
                      keyName: 'type',
                      valueName: 'tenVietTat',
                      label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                      name: 'huongGiaiQuyet',
                      selectedValue: this.state.nextState,
                      onChange: this.onChange.bind(this, 'nextState') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.tuGiaiQuyet == true && !this.props.donInfo.laTTXMLai },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      onRef: function onRef(select) {
                        return _this9.select = select;
                      },
                      className: 'col-25',
                      donId: this.state.id,
                      isValid: this.state.validate,
                      data: this.state.dataNextStatesTXL,
                      placeholder: null,
                      keyName: 'type',
                      valueName: 'tenVietTat',
                      label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                      name: 'huongGiaiQuyet',
                      selectedValue: this.state.nextState,
                      onChange: this.onChange.bind(this, 'nextState') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', value: this.state.noiDung, placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'noiDung'), name: 'textareaCanBoKetLuanNoiDung' }),
                    isQuaHan == true && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do qu\xE1 h\u1EA1n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.lyDoQuaHan, placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'lyDoQuaHan'), name: 'TextAreaLyDoQuaHan', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                    _react2.default.createElement(_common.TextArea, { bindValidator: this, channel: 'formTaoDon', require: true, className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung', maxLength: 1000 })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' || this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, dataShow: this.state.ListTaiLieuVanThuShow, data: this.state.ListTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' && this.state.nextState != 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { dataShow: this.state.ListTaiLieuVanThuShow, hideDescription: true, disableAttachFile: true })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialog') },
                  _react2.default.createElement(
                    'span',
                    null,
                    lbGuiTTXM
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialogTraDon') },
                  _react2.default.createElement(
                    'span',
                    null,
                    lbTraTTXM
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this, 'openDialog'), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " báo cáo " + lb3 + " của đơn/vụ việc này không?" }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogTraDon, onClose: this.closeDialog.bind(this, 'openDialogTraDon'), onSuccess: this.onSuccess.bind(this, 'openDialogTraDon'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD tr\u1EA3 \u0111\u01A1n/v\u1EE5 vi\u1EC7c chuy\u1EC3n ' + lb1 + ' kh\xF4ng \u0111\xFAng n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + ' kh\xF4ng?' })
            )
          )
        )
      );
    }
  }]);

  return NhapThongTinToTTXX;
}(_react2.default.Component);

NhapThongTinToTTXX.defaultProps = {
  validators: { formTaoDon: [] },
  dataNextStatesTXL: [{
    type: 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
    stateId: 39,
    tenVietTat: 'Trả đơn do chuyển TTXM không đúng'
  }, {
    type: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
    stateId: 15,
    tenVietTat: 'Gửi báo cáo TTXM'
  }],
  donInfo: {},
  listTaiLieuVanThuGiaiQuyetDon: []
};

exports.default = NhapThongTinToTTXX;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuaTrinhXuLy = function (_React$Component) {
  _inherits(QuaTrinhXuLy, _React$Component);

  function QuaTrinhXuLy(props, context) {
    _classCallCheck(this, QuaTrinhXuLy);

    var _this = _possibleConstructorReturn(this, (QuaTrinhXuLy.__proto__ || Object.getPrototypeOf(QuaTrinhXuLy)).call(this, props, context));

    _this.state = {
      isOpen: true
    };
    return _this;
  }

  _createClass(QuaTrinhXuLy, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var QuaTrinhXuLy = '';
      if (this.props.parents.state.dataLichSuQuaTrinhXuLy) {
        QuaTrinhXuLy = this.props.parents.state.dataLichSuQuaTrinhXuLy.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { className: 'history-items', key: i },
            _react2.default.createElement(
              'div',
              { className: 'radio-column' },
              _react2.default.createElement(_core.Radio, { defaultChecked: true })
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold txt-upper' },
                item.ten ? item.ten : null
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.ngayXuLy ? (0, _moment2.default)(item.ngayXuLy).format('DD/MM/YYYY - HH:mm') : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                'Ng\u01B0\u1EDDi x\u1EED l\xFD:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.nguoiXuLyText ? item.nguoiXuLyText : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'group-val' },
              _react2.default.createElement(
                'span',
                { className: 'txt-bold' },
                'N\u1ED9i dung:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'val-content' },
                item.noiDung ? item.noiDung : null
              )
            )
          );
        });
      } else {
        QuaTrinhXuLy = _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'section',
        { className: 'wrap-history gqd-history' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pl20' },
          _react2.default.createElement(
            'h2',
            { className: this.state.isOpen ? " collapse-title mb25 pt10 collapse-open" : "collapse-title mb25 pt10 collapse-close" },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'title-14', onClick: this.handleCollapse.bind(this) },
              'Qu\xE1 tr\xECnh x\u1EED l\xFD'
            )
          )
        ),
        _react2.default.createElement(
          _core.Collapse,
          { className: 'wrap-collapses', isOpen: this.state.isOpen },
          QuaTrinhXuLy
        )
      );
    }
  }]);

  return QuaTrinhXuLy;
}(_react2.default.Component);

exports.default = QuaTrinhXuLy;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(192);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vaiTro = 'CHUYEN_VIEN';
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
var buocGiaiQuyet = null;

var TruongPhongKiemTraDeXuat = function (_React$Component) {
  _inherits(TruongPhongKiemTraDeXuat, _React$Component);

  function TruongPhongKiemTraDeXuat(props, context) {
    _classCallCheck(this, TruongPhongKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (TruongPhongKiemTraDeXuat.__proto__ || Object.getPrototypeOf(TruongPhongKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      focused: false,
      id: _this.props.id,
      role: _this.props.roleGQ,
      validate: false,
      showAttach: false,
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      onSave: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      dataGiaiQuyetDon: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataNextState: [],
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
      dataKiemTraDeXuat: _this.props.dataKiemTraDeXuat,
      phongBanChiDinh: ''
    };
    return _this;
  }

  _createClass(TruongPhongKiemTraDeXuat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      var dataNextState = [].concat(_toConsumableArray(this.props.dataNextStates));
      var getPhongBan = [].concat(_toConsumableArray(dataNextState)).filter(function (item) {
        return item.type === "KTDX_GIAO_PHONG_CUNG_CAP";
      });
      if (getPhongBan.length) {
        var phoPhong = {
          stateId: getPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        dataNextState.push(phoPhong);
      }
      var dataNextStateFilter = [];
      dataNextState.map(function (item) {
        var newItem = item;
        if (item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          newItem.tenVietTat = 'Tự xử lý';
          newItem.ten = 'Trưởng phòng tự xử lý';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      });
      this.setState({
        dataNextState: dataNextStateFilter,
        dataKiemTraDeXuat: this.props.dataKiemTraDeXuat
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dataNextState = [].concat(_toConsumableArray(nextProps.dataNextStates));
      var dataNextStateFilter = [];
      var getPhongBan = [].concat(_toConsumableArray(dataNextState)).filter(function (item) {
        return item.type === "KTDX_GIAO_PHONG_CUNG_CAP";
      });
      var getPhoPhong = [].concat(_toConsumableArray(dataNextState)).filter(function (item) {
        return item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG";
      });
      if (!getPhoPhong.length && getPhongBan.length) {
        var phoPhong = {
          stateId: getPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        dataNextState.push(phoPhong);
      }
      dataNextState.map(function (item) {
        var newItem = item;
        if (item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          newItem.tenVietTat = 'Tự kiểm tra đề xuất';
          newItem.ten = 'Trưởng phòng tự kiểm tra đề xuất';
        }
        dataNextStateFilter[dataNextStateFilter.length] = newItem;
      });
      this.setState({
        dataNextState: dataNextStateFilter,
        dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        this.setState(_defineProperty({
          showAttach: false,
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: ''
        }, name, e.target.value), function () {
          _this2.checkFileRequired();
        });
      } else if (name == 'nextState' && e.target.value != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        this.setState(_defineProperty({
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: ''
        }, name, e.target.value));
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      if (name == 'nextState') {}
      this.props.handleChangeData();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this3 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this3.setState({
              dataGiaiQuyetDon: res.data,
              phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
              ngayHetHanKTDX: res.data.ngayHetHanKTDX ? res.data.ngayHetHanKTDX : '',
              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : _this3.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'
            }, function () {
              _this3.checkOnlyState();
              _this3.checkFileRequired();
            });
          }
        });
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState() {
      var _this4 = this;

      if (this.props.dataNextStates.length == 1) {
        this.setState({
          nextState: this.props.dataNextStates[0].type
        }, function () {
          _this4.checkFileRequired();
        });
      }
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this5 = this;

      var ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId == _this5.state.donViId;
      });

      var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this5.state.donViId;
      });

      if (ListTaiLieuVanThuShow.length > 0) {
        this.setState({
          listTaiLieuVanThuShow: ListTaiLieuVanThuShow
        });
      }

      if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        var data = [].concat(_toConsumableArray(ListTaiLieuVanThu));
        var dataFilter = data.filter(function (state) {
          return state.typeRequired == 'BC_KTDX';
        });

        if (dataFilter.length > 0) {
          this.setState({
            listTaiLieuVanThu: ListTaiLieuVanThu,
            showAttachFile: true
          });
        } else {
          var newItem = {
            ten: 'Báo cáo kết quả KTĐX',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BC_KTDX'
          };
          this.setState({
            listTaiLieuVanThu: [].concat(_toConsumableArray(ListTaiLieuVanThu), [newItem]),
            showAttachFile: true
          });
        }
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this6 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      var selectedState = this.props.dataNextStates.filter(function (state) {
        return state.type == _this6.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        };
      } else {
        params.nextState = null;
      }

      if (this.state.yKienGiaiQuyet) {
        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      } else {
        params.yKienGiaiQuyet = null;
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoGiaiQuyet = {
          id: Number(this.state.canBoGiaiQuyet)
        };
      } else {
        params.canBoGiaiQuyet = null;
      }

      if (this.state.phongBanChiDinh) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanChiDinh)
        };
      }

      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }

      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this7 = this;

      this.setState({
        onSave: true
      }, function () {

        _this7.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDelete = [];
        if (_this7.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          _this7.state.dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this7.state.taiLieuVanThuUpdate[_this7.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this7.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this7.state.taiLieuVanThu[_this7.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this7.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: _this7.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ? 'KIEM_TRA_DE_XUAT' : loaiQuyTrinh,
                buocGiaiQuyet: buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (_this7.state.dataTaiLieuVanThuDelete.length > 0) {
            _this7.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        } else {
          var data = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDon));
          data.filter(function (state) {
            return state.required && state.typeRequired == 'BC_KTDX';
          }).map(function (item) {
            dataFileDelete[dataFileDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        var params = _this7.getParams();
        if (_this7.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          _this7.postTaiLieuVanThu(_this7.state.taiLieuVanThu, function () {
            _this7.updateTaiLieuVanThu(_this7.state.taiLieuVanThuUpdate, function () {
              _this7.deleteTaiLieuVanThu(_this7.state.taiLieuVanThuDelete, function () {
                _this7.props.saveGiaiQuyetDon(params, 'gqdLuu');
              });
            });
          });
        } else {
          _this7.deleteTaiLieuVanThu(dataFileDelete, function () {
            _this7.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        }
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this8 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this8.validateSubmitForm()) {
          _this8.setState({
            btnLoading: true
          });
          var dataFileDelete = [];
          if (_this8.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
            _this8.state.dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this8.state.taiLieuVanThuUpdate[_this8.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this8.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this8.state.taiLieuVanThu[_this8.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this8.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: _this8.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ? 'KIEM_TRA_DE_XUAT' : loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (_this8.state.dataTaiLieuVanThuDelete.length > 0) {
              _this8.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          } else {
            var data = [].concat(_toConsumableArray(_this8.props.listTaiLieuVanThuGiaiQuyetDon));
            data.filter(function (state) {
              return state.required && state.typeRequired == 'BC_KTDX';
            }).map(function (item) {
              dataFileDelete[dataFileDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          var _params = _this8.getParams();
          var params = {};
          var msgName = '';
          var selectedState = _this8.state.dataNextState.filter(function (state) {
            return state.type == _this8.state.nextState;
          });

          if (_this8.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this8.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this8.state.yKienGiaiQuyet
            };
            msgName = 'ktdxTraBaoCao';
          } else if (_this8.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP") {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this8.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this8.state.yKienGiaiQuyet,
              phongBanGiaiQuyet: {
                id: Number(_this8.state.phongBanChiDinh)
              }
            };
            msgName = 'gqdGiaoViec';
          } else if (_this8.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
            params = {
              canBoXuLyChiDinh: {
                id: Number(_this8.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this8.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this8.state.yKienGiaiQuyet,
              phoPhong: true,
              phongBanGiaiQuyet: {
                id: Number(_this8.state.coQuanQuanLyNguoiDung.id)
              }
            };
            msgName = 'gqdGiaoViec';
          } else {
            params = {
              canBoXuLyChiDinh: {
                id: Number(_this8.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this8.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this8.state.yKienGiaiQuyet
            };
            msgName = 'gqdGiaoViec';
          }
          if (_this8.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
            _this8.postTaiLieuVanThu(_this8.state.taiLieuVanThu, function () {
              _this8.updateTaiLieuVanThu(_this8.state.taiLieuVanThuUpdate, function () {
                _this8.deleteTaiLieuVanThu(_this8.state.taiLieuVanThuDelete, function () {
                  _this8.props.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          } else {
            _this8.deleteTaiLieuVanThu(dataFileDelete, function () {
              _this8.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          }
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var tenCoQuan = this.props.dataKiemTraDeXuat && this.props.dataKiemTraDeXuat.donViGiaoKTDX ? this.props.dataKiemTraDeXuat.donViGiaoKTDX.ten : '';
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, _extends({
          listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon
        }, this.state.dataKiemTraDeXuat, {
          hideTable: true,
          donInfo: this.props.donInfo
        })),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.nextState != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 mb15' },
            'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 ki\u1EC3m tra'
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.dataNextStates && this.props.dataNextStates.length > 1 },
              _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                onRef: function onRef(select) {
                  return _this9.select = select;
                },
                className: 'col-25',
                donId: this.state.id,
                require: true,
                isValid: this.state.validate,
                data: this.state.dataNextState,
                keyName: 'type',
                valueName: 'tenVietTat',
                label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                name: 'huongGiaiQuyet',
                bindValidator: this,
                selectedValue: this.state.nextState,
                onChange: this.onChange.bind(this, 'nextState') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: 'PHO_PHONG',
                  bindValidator: this,
                  className: 'col-25',
                  label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                }),
                _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP" },
                _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                  require: true,
                  bindValidator: this,
                  selectedValue: this.state.phongBanChiDinh,
                  isValid: this.props.validate,
                  onChange: this.onChange.bind(this, 'phongBanChiDinh'),
                  name: 'dropdownChonPhongBanThuocCoQuan' }),
                _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoGiaiQuyet,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: vaiTro,
                  bindValidator: this,
                  className: 'col-25',
                  label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                  onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                  name: 'dropdownChonCanBoGiaiQuyet'
                }),
                _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP" },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'TruongPhongGVCB', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' },
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttachFile },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'CanBoChuyenKQDVG', onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuShow, data: this.state.listTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this, 'truongPhongGiaiQuyetDon') },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP" },
              _react2.default.createElement(
                _reactRouter.Link,
                { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'truongPhongGiaiQuyetDon') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Giao vi\u1EC7c'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' },
              _react2.default.createElement(
                _reactRouter.Link,
                { style: { right: 0 }, className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'G\u1EEDi b\xE1o c\xE1o KT\u0110X'
                )
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: "Xác nhận giao " + lb1, content: 'Bạn có đồng ý chuyển cho ' + tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?' })
          )
        )
      );
    }
  }]);

  return TruongPhongKiemTraDeXuat;
}(_react2.default.Component);

TruongPhongKiemTraDeXuat.defaultProps = {
  validators: {}
};

exports.default = TruongPhongKiemTraDeXuat;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

var _checkThamSo = __webpack_require__(323);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vaiTro = 'CHUYEN_VIEN';
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var TruongPhongNhanBaoCaoTTXM = function (_React$Component) {
  _inherits(TruongPhongNhanBaoCaoTTXM, _React$Component);

  function TruongPhongNhanBaoCaoTTXM(props, context) {
    _classCallCheck(this, TruongPhongNhanBaoCaoTTXM);

    var _this = _possibleConstructorReturn(this, (TruongPhongNhanBaoCaoTTXM.__proto__ || Object.getPrototypeOf(TruongPhongNhanBaoCaoTTXM)).call(this, props, context));

    _this.state = {
      open: false,
      onSave: false,
      validate: false,
      id: _this.props.id,
      role: _this.props.roleGQ,
      loaiDon: _this.props.loaiDon,
      gqText: _this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDon == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      btnLoading: false,
      btnSaveLoading: false,
      focused: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      openDialogNoiChinh: false,
      openDialogVanPhong: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },

      dataNextStates: [],
      dataNextStatesFilter: [],
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataPhongBan: [],
      dataPhongBanFilter: [],
      dataCanBoGiaiQuyet: [],
      dataThamSo: -1,

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',
      ketQuaXLDGiaiQuyetInit: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThuGiaoCoQuanDieuTra: [],

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowHuongGiaiQuyetFillter: false,
      allowAttachGiaoCoQuanDieuTra: false,
      checkDonViPhongBanKhac: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      dataDonViTheoDoi: [],
      dataCoQuanTheoDoi: [],
      dataDonViNhanTDTH: [],
      donViTheoDoiThucHien: '',
      tenDonViTheoDoiThucHien: '',
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      setHuongGiaiQuyet: false,
      typeButton: '',
      isUBND: false,
      checkUBND: false,
      setDataCanBo: false,
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      openDialogGiaoTTXML: false,
      valueKetQua: '',
      message: '',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(TruongPhongNhanBaoCaoTTXM, [{
    key: 'checkVaiTro',
    value: function checkVaiTro() {
      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (ThamSo.length > 0 && userInfo != {}) {
        if ((0, _checkThamSo.checkThamSo)() != null) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }, {
    key: 'getCanBoGiaiQuyet',
    value: function getCanBoGiaiQuyet() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var params = {
        coQuanQuanLyId: userInfo.coQuanQuanLyId,
        vaiTro: vaiTro,
        page: 0,
        size: 1000,
        sort: 'ten,desc'
      };

      _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataCanBoGiaiQuyet: res.data._embedded.congChucs
          }, function () {
            _this2.setState({
              setDataCanBo: true
            });
          });
        } else {
          _this2.setState({
            setDataCanBo: true
          });
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCanBoGiaiQuyet();
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getPhongBanThuocCoQuan();
      this.getCoQuanTheoDoiEnumn();
      this.getDonViNhanTDTH();
      this.getListDonViNhanTDTH();
      this.getThoiHanGQDonMacDinh();
      this.getThoiHanTTXMMacDinh();
      if (this.props.nhanDuThao == true) {
        this.setState({
          nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO'
        });
      }
      if (this.props.dataNextStates) {
        var data = [].concat(_toConsumableArray(this.props.dataNextStates));
        data = data.filter(function (props) {
          return props.type !== 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' && props.type !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' && props.type !== 'CAN_BO_GIAO_TTXM_LAI';
        });
        /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
          data = data.filter(props => {
            return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
          });
        } */
        if ((0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN') {
          data = data.filter(function (props) {
            return props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM";
          });
        } else {
          var getPhongBan = data.find(function (item) {
            return item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
          });
          if (getPhongBan) {
            var phoPhong = {
              stateId: getPhongBan.stateId,
              ten: "Trưởng phòng giao việc phó phòng",
              tenVietTat: "Giao việc phó phòng",
              type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
            };
            data.push(phoPhong);
          }
        }
        data.map(function (item) {
          if (item.type == 'KET_THUC') {
            item.tenVietTat = 'Tự giải quyết';
            item.ten = 'Trưởng phòng tự giải quyết';
          }
        });
        this.setState({
          dataNextStates: data,
          dataNextStatesFilter: data
        });
      }

      this.getThamSo('CQQL_UBNDTP_DA_NANG');

      if (window.debug) {
        console.log('giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXM');
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, { type: this.props.loaiDon }).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this3.setState({
          ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this4 = this;

      var params = {
        type: this.props.loaiDon
      };
      if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this4.setState({
          ngayHetHanTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getDonViNhanTDTH',
    value: function getDonViNhanTDTH() {
      var _this5 = this;

      var params = {
        donId: Number(this.state.id),
        loaiDon: this.state.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(function (res) {
        if (res.data) {
          _this5.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten
          });
        }
      });
    }
  }, {
    key: 'getListDonViNhanTDTH',
    value: function getListDonViNhanTDTH() {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this6.setState({
            dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getThamSo',
    value: function getThamSo(thamSo) {
      var _this7 = this;

      var params = {
        tuKhoa: thamSo
      };
      _api.Danhmuc.actions.getThamSo.request(params).then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            dataThamSo: Number(res.data._embedded.thamSoes[0].giaTri)
          }, function () {
            _this7.checkThamSoUBND();
          });
        }
      });
    }
  }, {
    key: 'checkThamSoUBND',
    value: function checkThamSoUBND() {
      var _this8 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var isUBND = false;
      if (userInfo.donViId == this.state.dataThamSo) {
        isUBND = true;
      }
      this.setState({
        isUBND: isUBND
      }, function () {
        _this8.setState({
          checkUBND: true
        });
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }

      if (this.state.checkDonViPhongBanKhac == true) {
        var dataOption = this.state.dataNextStates;
        var indexOption = dataOption.findIndex(function (x) {
          return x.type == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM';
        });
        if (indexOption != -1 && this.state.dataPhongBan.length == 0) {
          var newOption = [].concat(_toConsumableArray(this.state.dataNextStates));
          newOption.splice(indexOption, 1);
          this.state.dataNextStates = newOption;
          this.setState(_extends({}, this.state));
        }
      }

      this.checkHuongGiaiQuyet();
    }
  }, {
    key: 'getPhongBanThuocCoQuan',
    value: function getPhongBanThuocCoQuan() {
      var _this10 = this;

      _api.GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(function (res) {
        if (res.data._embedded) {
          var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
          var dataThamSo = [];
          var dataFilter = [];
          ThamSo.map(function (item) {
            dataThamSo[dataThamSo.length] = item.giaTri;
          });
          if (ThamSo.length > 0) {
            var data = [].concat(_toConsumableArray(res.data._embedded.coQuanQuanLies));
            dataFilter = data.filter(function (state) {
              return dataThamSo.indexOf(state.coQuanQuanLyId) == -1;
            });
          }
          _this10.state.dataPhongBan = res.data._embedded.coQuanQuanLies;
          _this10.state.dataPhongBanFilter = dataFilter;
          _this10.state.checkDonViPhongBanKhac = true;
          _this10.setState(_extends({}, _this10.state));
        } else {
          _this10.state.checkDonViPhongBanKhac = true;
          _this10.setState(_extends({}, _this10.state));
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataNextStates) {
        var data = [].concat(_toConsumableArray(nextProps.dataNextStates));
        data = data.filter(function (props) {
          return props.type !== 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' && props.type !== 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' && props.type !== 'CAN_BO_GIAO_TTXM_LAI';
        });
        /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
          data = data.filter(props => {
            return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
          });
        } */
        if ((0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN') {
          data = data.filter(function (props) {
            return props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM";
          });
        } else {
          var getPhongBan = data.find(function (item) {
            return item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
          });
          var getPhoPhong = data.find(function (item) {
            return item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG";
          });
          if (getPhongBan && !getPhoPhong) {
            var phoPhong = {
              stateId: getPhongBan.stateId,
              ten: "Trưởng phòng giao việc phó phòng",
              tenVietTat: "Giao việc phó phòng",
              type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
            };
            data.push(phoPhong);
          }
        }

        data.map(function (item) {
          if (item.type == 'KET_THUC') {
            item.tenVietTat = 'Tự giải quyết';
            item.ten = 'Trưởng phòng tự giải quyết';
          }
        });
        this.setState({
          dataNextStates: data,
          dataNextStatesFilter: data
        });
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        canBoGiaiQuyet: '',

        thoiGianDoiThoai: '',
        diaDiemDoiThoai: '',
        ketQuaXLDGiaiQuyet: '',
        coQuanDieuTra: '',
        soVuGiaoCoQuanDieuTra: 0,
        soDoiTuongGiaoCoQuanDieuTra: 0,

        tienPhaiThuNhaNuoc: 0,
        datPhaiThuNhaNuoc: 0,
        tienPhaiTraCongDan: 0,
        datPhaiTraCongDan: 0,
        tongSoNguoiXuLyHanhChinh: 0,
        soNguoiDaBiXuLyHanhChinh: 0,

        hinhThucTheoDoi: '',
        coQuanTheoDoi: '',
        ketQuaThucHienTheoDoi: '',

        soVanBan: '',
        ngayBanHanh: '',
        nguoiBanHanh: '',

        soVuBiKhoiTo: 0,
        soDoiTuongBiKhoiTo: 0,

        tienDaThuNhaNuoc: 0,
        datDaThuNhaNuoc: 0,
        tienDaTraCongDan: 0,
        datDaTraCongDan: 0,

        khoiTo: false,
        doiThoai: false,
        giaoCoQuanDieuTra: false,
        quyetDinhGiaiQuyetKhieuNai: false,
        theoDoiThucHien: false,

        tienPhaiThuNhaNuocQDGQ: 0,
        tienPhaiTraCongDanQDGQ: 0,
        datPhaiThuNhaNuocQDGQ: 0,
        datPhaiTraCongDanQDGQ: 0,
        soNguoiDuocTraLaiQuyenLoi: 0,

        soVuGiaiQuyetKhieuNai: 0,

        soLanGiaiQuyetLai: 0,
        ketQuaGiaiQuyetLan2: '',
        noiDungKetLuanGiaiQuyetLai: '',

        ketQuaGiaiQuyetKhac: '',
        ketQuaThucHienKhac: '',
        noiDungDoiThoai: '',
        noiDungGiaoLapDuThao: '',

        yKienGiaiQuyet: ''
      });
      this.renderAttachFile();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this11 = this;

      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi') {}
          if (name == 'ketQuaXLDGiaiQuyet' && _this11.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
            _this11.renderAttachFile();
          }
          if (name == 'nextState') {
            _this11.resetData();
          }
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({ ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
        var ttxmlDate = data.filter(function (item) {
          return item.typeRequired == 'VB_GTTXML';
        });
        if (ttxmlDate.length) {
          this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
        }
        this.getThoiHanTTXMMacDinh();
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this12 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this12.setState({
              dataGiaiQuyetDon: res.data,

              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : _this12.props.truongPhongThuHoi == true ? 'KET_THUC' : '',

              canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM || '',

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
              phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
              ketQuaXLDGiaiQuyetInit: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false,
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              setHuongGiaiQuyet: false,
              noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || ''
            }, function () {
              _this12.checkOnlyState();
              _this12.renderAttachFile();
              _this12.checkFileCoQuanDieuTra();
            });
            if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
              _this12.setState({ ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai) });
            }
            if (res.data.ngayHetHanTTXMLai) {
              _this12.setState({ ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai) });
            }
          }
        });
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState() {
      var _this13 = this;

      if (this.props.dataNextStates.length == 1) {
        this.setState({
          nextState: this.props.dataNextStates[0].type
        }, function () {
          _this13.renderAttachFile();
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this14 = this;

      var date = e;
      if (e && e._d) {
        date = e._d;
      }
      this.setState(_defineProperty({}, name, date), function () {
        if (name == 'ngayRaThongBaoTTXM') {
          _this14.setState({
            loaiVanBanSuggest: 'VB_GTTXML',
            ngayQuyetDinhSuggest: _this14.state.ngayRaThongBaoTTXM
          });
          _this14.getThoiHanTTXMMacDinh();
        }
        _this14.props.handleChangeData();
      });
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this15 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.doiThoai && this.state.loaiDon == 'DON_TO_CAO') {
        params.doiThoai = true;
        params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;
        params.soVanBan = '';
        params.ngayBanHanh = null;
        params.nguoiBanHanh = null;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }

      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        params.coQuanDieuTra = {
          id: Number(this.state.coQuanDieuTra)
        };
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet) {
        params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet;
      } else {
        params.ketQuaXLDGiaiQuyet = null;
      }
      if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM') {
        params.ketQuaXLDGiaiQuyet = null;
      }
      var selectedState = this.state.dataNextStates.filter(function (state) {
        return state.type == _this15.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        };
      } else {
        params.nextState = null;
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoGiaiQuyet = {
          id: Number(this.state.canBoGiaiQuyet)
        };
      } else {
        params.canBoGiaiQuyet = null;
      }

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      } else {
        params.phongBanGiaiQuyet = null;
      }
      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }

      if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
        params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
        params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
      }
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(type) {
      var _this16 = this;

      this.setState({
        onSave: true
      }, function () {

        _this16.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this16.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this16.state.taiLieuVanThuUpdate[_this16.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this16.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this16.state.taiLieuVanThu[_this16.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this16.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (!_this16.state.giaoCoQuanDieuTra) {
          var dataGCCDT = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          dataGCCDT.filter(function (state) {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
        if (_this16.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          var dataQDGQ = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          dataQDGQ.filter(function (state) {
            return state.typeRequired == 'QDGQ_LDT';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this16.state.dataTaiLieuVanThuDelete.length > 0) {
          _this16.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this16.getParams();

        params.yKienGiaiQuyet = _this16.state.yKienGiaiQuyet;
        _this16.postTaiLieuVanThu(_this16.state.taiLieuVanThu, function () {
          _this16.updateTaiLieuVanThu(_this16.state.taiLieuVanThuUpdate, function () {
            _this16.deleteTaiLieuVanThu(_this16.state.taiLieuVanThuDelete, function () {
              _this16.props.saveGiaiQuyetDon(params);
            });
          });
        });
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this17 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this17.validateSubmitForm()) {
          _this17.setState({
            isOpen: false,
            btnLoading: true
          });

          var dataFileDinhKem = _this17.getListDataFileDinhKem();
          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this17.state.taiLieuVanThuUpdate[_this17.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this17.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this17.state.taiLieuVanThu[_this17.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this17.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (!_this17.state.giaoCoQuanDieuTra) {
            var dataGCCDT = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            dataGCCDT.filter(function (state) {
              return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this17.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this17.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            var dataQDGQ = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataQDGQ.filter(function (state) {
              return state.typeRequired == 'QDGQ_LDT';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this17.state.dataTaiLieuVanThuDelete.length > 0) {
            _this17.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this17.getParams();
          var params = {};
          var msgName = '';

          var selectedState = _this17.state.dataNextStates.filter(function (state) {
            return state.type == _this17.state.nextState;
          });

          if (type == 'giaoCanBo') {
            if (_this17.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
              params = {
                canBoXuLyChiDinh: {
                  id: Number(_this17.state.canBoGiaiQuyet)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this17.state.thongTinGiaiQuyetDonId)
                },
                phongBanGiaiQuyet: {
                  id: Number(_this17.state.coQuanQuanLyNguoiDung.id)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                phoPhong: true,
                yKienGiaiQuyet: _this17.state.yKienGiaiQuyet
              };
              msgName = 'gqdGiaoViec';
            } else {
              params = {
                canBoXuLyChiDinh: {
                  id: Number(_this17.state.canBoGiaiQuyet)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this17.state.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this17.state.yKienGiaiQuyet
              };
              msgName = 'gqdGiaoViec';
            }
          } else if (type == 'openDialog') {
            selectedState = _this17.props.dataNextStates.filter(function (state) {
              return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
            });
            _params.donViTheoDoiThucHien = {
              id: Number(_this17.state.donViTheoDoiThucHien)
            };
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              donViTheoDoiThucHien: {
                id: Number(_this17.state.donViTheoDoiThucHien)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              }
            };
            params.yKienGiaiQuyet = _this17.state.lyDoBanHanhQuyetDinhDinhChi;
            if (_this17.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
              params.yKienGiaiQuyet = _this17.state.lyDoBanHanhQuyetDinhGiaiQuyet;
            }
            msgName = 'gqdChuyenTheoDoi';
          } else if (type == 'openDialogNoiChinh' || type == 'openDialogVanPhong' || type == 'giaoPhongBan') {
            params = {
              phongBanGiaiQuyet: {
                id: Number(_this17.state.phongBanGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this17.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this17.state.yKienGiaiQuyet
            };
            msgName = 'xldChuyenDon';
          } else if (type == 'openDialogGiaoTTXML') {
            selectedState = _this17.props.dataNextStates.filter(function (state) {
              return state.type == 'CAN_BO_GIAO_TTXM_LAI';
            });
            params = {
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              yKienGiaiQuyet: _this17.state.noiDungGiaoTTXMLai
            };
            msgName = 'guiTTXMLai';
            if (_this17.state.ngayRaThongBaoTTXM) {
              params.ngayRaThongBaoTTXM = (0, _moment2.default)(_this17.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
            }
          }
          _this17.postTaiLieuVanThu(_this17.state.taiLieuVanThu, function () {
            _this17.updateTaiLieuVanThu(_this17.state.taiLieuVanThuUpdate, function () {
              _this17.deleteTaiLieuVanThu(_this17.state.taiLieuVanThuDelete, function () {
                _this17.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this18 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this18.state.giaoCoQuanDieuTra == false) {
          _this18.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this18.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this18.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this18.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this18.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      this.props.handleChangeData();
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.closeDialog(name);
      this.handleGiaiQuyetDon(name);
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      var _this19 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      }, function () {
        _this19.renderAttachFile();
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this20 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this20.compareDate(new Date(state.ngayTao), new Date(_this20.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this20.compareDate(new Date(_this20.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
      });
      var dataTTXML = DataTaiLieuVanThu.filter(function (item) {
        return item.typeRequired == 'VB_GTTXML';
      });
      if (this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
        listTaiLieuVanThuGiaiQuyetDon = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon), [{
          ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'VB_GTTXML',
          newFile: true
        }]);
      }

      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      });
    }
  }, {
    key: 'checkHuongGiaiQuyet',
    value: function checkHuongGiaiQuyet() {
      var _this21 = this;

      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.state.nextState != '') {
        if (ThamSo.length > 0 && userInfo != {} && this.state.checkUBND && this.state.setDataCanBo && this.state.setHuongGiaiQuyet == false && (this.state.loaiDon === 'DON_TO_CAO' || this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH')) {

          if (this.state.isUBND && (0, _checkThamSo.checkThamSo)() === null && this.state.dataCanBoGiaiQuyet.length == 0) {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false
            });
          } else if (this.state.isUBND && (0, _checkThamSo.checkThamSo)() === null) {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false,
              allowHuongGiaiQuyetFillter: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() === null && this.props.dataNextStates.length > 1) {

            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN') {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false
            }, function () {
              _this21.checkPhongBan();
            });
          } else if ((0, _checkThamSo.checkThamSo)() === 'CQQL_PHONG_NOI_CHINH') {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() === 'CQQL_VAN_PHONG_UBND_THANH_PHO') {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          }
        }
      } else {
        if (ThamSo.length > 0 && userInfo != {} && this.state.checkUBND && this.state.setDataCanBo && this.state.setHuongGiaiQuyet == false && (this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH')) {

          if (this.state.isUBND && (0, _checkThamSo.checkThamSo)() == null && this.state.dataCanBoGiaiQuyet.length == 0) {
            this.setState({
              nextState: 'KET_THUC',
              ketQuaXLDGiaiQuyet: 'DA_CO_QUYET_DINH_GIAI_QUYET',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false
            });
          } else if (this.state.isUBND && (0, _checkThamSo.checkThamSo)() == null) {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false,
              allowHuongGiaiQuyetFillter: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() == null && this.props.dataNextStates.length > 1) {
            this.setState({
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() == 'CQQL_BAN_TIEP_CONG_DAN') {
            this.setState({
              nextState: 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: false,
              allowHuongGiaiQuyetFillter: true
            }, function () {
              _this21.checkPhongBan();
            });
          } else if ((0, _checkThamSo.checkThamSo)() == 'CQQL_PHONG_NOI_CHINH') {
            this.setState({
              nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          } else if ((0, _checkThamSo.checkThamSo)() == 'CQQL_VAN_PHONG_UBND_THANH_PHO') {
            this.setState({
              nextState: 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          }
        }
      }
    }
  }, {
    key: 'checkPhongBan',
    value: function checkPhongBan() {
      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      if (this.state.loaiDon == 'DON_TO_CAO') {
        var dataFilter = ThamSo.filter(function (state) {
          return state.ten == 'CQQL_PHONG_NOI_CHINH';
        });

        if (dataFilter.length > 0) {
          this.setState({
            phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
            typeButton: 'PHONG_NOI_CHINH'
          });
        }
      } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
        var _dataFilter = ThamSo.filter(function (state) {
          return state.ten == 'CQQL_VAN_PHONG_UBND_THANH_PHO';
        });

        if (_dataFilter.length > 0) {
          this.setState({
            phongBanGiaiQuyet: Number(_dataFilter[0].giaTri),
            typeButton: 'VAN_PHONG_UBND'
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this22 = this;

      var ketQuaGiaiQuyetDon = this.state.dataGiaiQuyetDon.ketQuaXLDGiaiQuyetInfo ? this.state.dataGiaiQuyetDon.ketQuaXLDGiaiQuyetInfo.text : '';
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_subView.BlockBaoCaoKQTTXM, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.allowHuongGiaiQuyet && this.state.ketQuaXLDGiaiQuyetInit != 'DA_CO_QUYET_DINH_GIAI_QUYET' },
              _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                onRef: function onRef(select) {
                  return _this22.select = select;
                },
                className: 'col-25',
                donId: this.state.id,
                require: true,
                isValid: this.state.validate,
                data: this.state.dataNextStates,
                bindValidator: this,
                disable: this.state.ketQuaXLDGiaiQuyet !== '' && this.state.ketQuaXLDGiaiQuyet !== 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false,
                selectedValue: this.state.nextState,
                label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                keyName: 'type',
                name: 'huongGiaiQuyet',
                valueName: 'tenVietTat',
                onChange: this.onChange.bind(this, 'nextState') })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.showTienDoGiaiQuyet },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.allowHuongGiaiQuyetFillter },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  onRef: function onRef(select) {
                    return _this22.select = select;
                  },
                  className: 'col-25',
                  donId: this.state.id,
                  require: true,
                  isValid: this.state.validate,
                  data: this.state.dataNextStatesFilter,
                  bindValidator: this,
                  selectedValue: this.state.nextState,
                  label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                  disable: this.state.ketQuaXLDGiaiQuyet !== '' && this.state.ketQuaXLDGiaiQuyet !== 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false,
                  keyName: 'type',
                  name: 'huongGiaiQuyet',
                  valueName: 'tenVietTat',
                  onChange: this.onChange.bind(this, 'nextState') })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showTienDoGiaiQuyet },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: 'T\u1EF1 gi\u1EA3i quy\u1EBFt' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' && (0, _checkThamSo.checkThamSo)() != 'CQQL_VAN_PHONG_UBND_THANH_PHO' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  selectedValue: this.state.phongBanGiaiQuyet,
                  require: true,
                  bindValidator: this,
                  className: 'col-25',
                  keyName: 'coQuanQuanLyId',
                  valueName: 'ten',
                  name: 'phongBanGiaiQuyet',
                  label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt',
                  data: this.state.dataPhongBan,
                  onChange: this.onChange.bind(this, 'phongBanGiaiQuyet')
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: (0, _checkThamSo.checkThamSo)() == 'CQQL_VAN_PHONG_UBND_THANH_PHO' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  selectedValue: this.state.phongBanGiaiQuyet,
                  require: true,
                  bindValidator: this,
                  className: 'col-25',
                  keyName: 'coQuanQuanLyId',
                  valueName: 'ten',
                  name: 'phongBanGiaiQuyet',
                  label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt',
                  data: this.state.dataPhongBanFilter,
                  onChange: this.onChange.bind(this, 'phongBanGiaiQuyet')
                })
              ),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                vaiTro: vaiTro,
                bindValidator: this,
                className: 'col-25',
                label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                isValid: this.state.validate,
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                vaiTro: 'PHO_PHONG',
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                bindvaiTroValidator: this,
                className: 'col-25',
                label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'KET_THUC' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'p',
                    { className: 'attach-file-description mb10 pl5 pr5' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !this.state.showTienDoGiaiQuyet },
                    _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { name: 'tienDoDoiThoai', disable: this.state.ketQuaXLDGiaiQuyet != '' && this.state.ketQuaXLDGiaiQuyet != 'GIAO_THAM_TRA_XAC_MINH_LAI' ? true : false, confirm: true, className: 'col-25', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet'), isTTXMLai: this.props.isTTXMLai, loaiDon: this.props.loaiDon })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showTienDoGiaiQuyet },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon })
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai },
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayHetHanGiaiQuyetTTXMLai,
                  label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
                  name: 'ngayHetHanGiaiQuyetTTXMLai',
                  startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                  onChange: this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                this.props.loaiDon == 'DON_TO_CAO' && _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayRaThongBaoTTXM,
                  label: 'Ngày ra văn bản ' + lb1 + ' lại',
                  name: 'ngayRaThongBaoTTXM',
                  onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayHetHanTTXMLai,
                  label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3',
                  name: 'ngayHetHanTTXMLai',
                  startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                  onChange: this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                _react2.default.createElement(_common.TextArea, {
                  label: '\xDD ki\u1EBFn x\u1EED l\xFD',
                  rows: '3',
                  placeholder: 'Nh\u1EADp \xFD ki\u1EBFn',
                  value: this.state.noiDungGiaoTTXMLai,
                  onChange: this.onChange.bind(this, 'noiDungGiaoTTXMLai'),
                  name: 'textareaYKienTTXM' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 mb5' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.loaiDon == 'DON_TO_CAO' },
                    _react2.default.createElement(
                      'h3',
                      { className: 'txt-upper title-14 mt0 mb15' },
                      'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.loaiDon != 'DON_TO_CAO' },
                    _react2.default.createElement(
                      'h3',
                      { className: 'txt-upper title-14 mt0 mb15' },
                      'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { triggeOnBlur: true, name: 'inputSoVanBan', className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
                    _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                    _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttach },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt15' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', name: 'QuyetDinhGiaiQuyet', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt10 pb20' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.loaiDon == 'DON_TO_CAO' },
                      _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai'), name: 'DropDownChonKetLuanNoiDungKhieuNai' })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.props.loaiDon != 'DON_TO_CAO' },
                      _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, name: 'DropDownChonKetLuanNoiDungKhieuNai', label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') })
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10 mb5' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter mb20' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                      _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter mb20' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                      _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                      ),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    _utils.ShowIfCheck,
                    { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5 pb5' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soVuGiaoCoQuanDieuTra', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soDoiTuongGiaoCoQuanDieuTra', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 pt15' },
                            _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100' },
                      _react2.default.createElement(
                        _utils.ShowIfCheck,
                        { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mt5 pb20' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            'Kh\u1EDFi t\u1ED1'
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-50 no-gutter' },
                              _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                              _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'txt-upper title-14 mt0 mb15' },
                    'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-25', name: 'inputSoVanBan', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
                    _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                    _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), bindValidator: this, channel: 'formTaoDon', require: true, name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttach },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt15' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', name: 'QuyetDinhDinhChi', quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt10 pb20' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5 pb5' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soVuGiaoCoQuanDieuTra', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soDoiTuongGiaoCoQuanDieuTra', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                          _react2.default.createElement(
                            _utils.ShowIf,
                            { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-100 pt15' },
                              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt5 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100' },
                        _react2.default.createElement(
                          _utils.ShowIfCheck,
                          { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter mt5 pb20' },
                            _react2.default.createElement(
                              'h2',
                              { className: 'title-12 mb15' },
                              'Kh\u1EDFi t\u1ED1'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-50 no-gutter' },
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.allowAttach },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'TaiLieuVTGQD', onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                  ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest, data: this.state.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100 gqd-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialog') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Chuy\u1EC3n theo d\xF5i th\u1EF1c hi\u1EC7n'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'giaoCanBo') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Giao vi\u1EC7c'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.typeButton == 'PHONG_NOI_CHINH' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogNoiChinh') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Chuy\u1EC3n cho ph\xF2ng N\u1ED9i ch\xEDnh'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.typeButton == 'VAN_PHONG_UBND' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogVanPhong') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Chuy\u1EC3n cho VP UBND T\u1EC9nh'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'giaoPhongBan') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Giao vi\u1EC7c'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'KET_THUC' && this.state.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !this.props.isTTXMLai },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoTTXML') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Giao ',
                    lb1,
                    ' l\u1EA1i'
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this, 'openDialog'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogNoiChinh, onClose: this.closeDialog.bind(this, 'openDialogNoiChinh'), onSuccess: this.onSuccess.bind(this, 'openDialogNoiChinh'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ph\xF2ng N\u1ED9i ch\xEDnh kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogVanPhong, onClose: this.closeDialog.bind(this, 'openDialogVanPhong'), onSuccess: this.onSuccess.bind(this, 'openDialogVanPhong'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho VP UBND T\u1EC9nh kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoTTXML, onClose: this.closeDialog.bind(this, 'openDialogGiaoTTXML'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoTTXML'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' ' + lb2 + ' l\u1EA1i kh\xF4ng?' })
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.open,
              onClose: this.closeDialogConfirm.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'p',
                { className: 'reception-dialog-text' },
                this.state.message
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TruongPhongNhanBaoCaoTTXM;
}(_react2.default.Component);

TruongPhongNhanBaoCaoTTXM.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TruongPhongNhanBaoCaoTTXM);

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _bind = __webpack_require__(240);

var _bind2 = _interopRequireDefault(_bind);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

var _checkThamSo = __webpack_require__(323);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vaiTro = 'CHUYEN_VIEN';
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var TruongPhongNhanBaoCaoTTXMDonKhieuNai = function (_React$Component) {
  _inherits(TruongPhongNhanBaoCaoTTXMDonKhieuNai, _React$Component);

  function TruongPhongNhanBaoCaoTTXMDonKhieuNai(props, context) {
    _classCallCheck(this, TruongPhongNhanBaoCaoTTXMDonKhieuNai);

    var _this = _possibleConstructorReturn(this, (TruongPhongNhanBaoCaoTTXMDonKhieuNai.__proto__ || Object.getPrototypeOf(TruongPhongNhanBaoCaoTTXMDonKhieuNai)).call(this, props, context));

    _this.state = {
      open: false,
      onSave: false,
      validate: false,
      id: _this.props.id,
      role: _this.props.roleGQ,
      loaiDon: _this.props.loaiDon,
      gqText: _this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDon == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      btnLoading: false,
      btnSaveLoading: false,
      focused: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      openDialogNoiChinh: false,
      openDialogVanPhong: false,
      openDialogGiaoTTXML: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },

      dataNextStates: [],
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      ketQuaXLDGiaiQuyetInit: '',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataPhongBan: [],

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThuGiaoCoQuanDieuTra: [],

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,
      checkDonViPhongBanKhac: false,
      phoPhong: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',
      tienDoDoiThoai: '',

      dataDonViTheoDoi: [],
      dataKetQuaGiaiQuyetDon: [],
      dataCoQuanTheoDoi: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      setHuongGiaiQuyet: false,
      typeButton: '',
      donViTheoDoiThucHien: '',
      dataDonViNhanTDTH: [],
      nextStateInit: '',
      message: 'Chọn "' + _this.gqText + '" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: '',
      valueSelectBox: '',
      dataSelectBox: [{
        "giaTri": "TU_GIAI_QUYET",
        "ten": "Tự giải quyết"
      }, {
        "giaTri": "CHUYEN_PHONG_BAN_KHAC",
        "ten": "Chuyển phòng ban khác"
      }]
    };
    return _this;
  }

  _createClass(TruongPhongNhanBaoCaoTTXMDonKhieuNai, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getPhongBanThuocCoQuan();
      this.getCoQuanTheoDoiEnumn();
      this.getDonViNhanTDTH();
      this.getListDonViNhanTDTH();
      this.getKetQuaGiaiQuyetDon();
      this.getThoiHanGQDonMacDinh();
      this.getThoiHanTTXMMacDinh();
      if (this.props.nhanDuThao == true) {
        this.setState({
          nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO'
        });
      }

      if (this.props.dataNextStates) {
        var data = [].concat(_toConsumableArray(this.props.dataNextStates));
        data = data.filter(function (props) {
          return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' && props.type != 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' && props.type != 'CAN_BO_GIAO_TTXM_LAI';
        });
        /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
          data = data.filter(props => {
            return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
          });
        } */
        if ((0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
          data = data.filter(function (props) {
            return props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM";
          });
        } else {
          var getPhongBan = data.find(function (item) {
            return item.type === "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP" || item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
          });
          if (getPhongBan) {
            var phoPhong = {
              stateId: getPhongBan.stateId,
              ten: "Trưởng phòng giao việc phó phòng",
              tenVietTat: "Giao việc phó phòng",
              type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
            };
            data.push(phoPhong);
          }
        }
        data.map(function (item) {
          if (item.type == 'KET_THUC') {
            item.tenVietTat = 'Tự giải quyết';
            item.ten = 'Trưởng phòng tự giải quyết';
          }
        });
        this.setState({
          dataNextStates: data
        });
      }

      if (window.debug) {
        console.log('giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXMDonKhieuNai');
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, { type: this.props.loaiDon }).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this2.setState({
          ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this3 = this;

      var params = {
        type: this.props.loaiDon
      };
      if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = new Date(res.data);
        _this3.setState({
          ngayHetHanTTXMLai: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getDonViNhanTDTH',
    value: function getDonViNhanTDTH() {
      var _this4 = this;

      var params = {
        donId: Number(this.state.id),
        loaiDon: this.state.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(function (res) {
        if (res.data) {
          _this4.setState({
            donViTheoDoiThucHien: res.data.coQuanQuanLyId,
            tenDonViTheoDoiThucHien: res.data.ten
          });
        }
      });
    }
  }, {
    key: 'getListDonViNhanTDTH',
    value: function getListDonViNhanTDTH() {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(function (res) {
        if (res.data._embedded) {
          _this5.setState({
            dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
      /* if (this.state.checkDonViPhongBanKhac == true) {
        let dataOption = this.state.dataNextStates;
        let indexOption = dataOption.findIndex(x => x.type == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM')
        if (indexOption != -1 && this.state.dataPhongBan.length == 0) {
          let newOption = [...this.state.dataNextStates];
          newOption.splice(indexOption, 1);
          this.state.dataNextStates = newOption;
          this.setState({
            ...this.state
          })
        }
       } */
      this.checkHuongGiaiQuyet();
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this7 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this7.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'getPhongBanThuocCoQuan',
    value: function getPhongBanThuocCoQuan() {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(function (res) {
        if (res.data._embedded) {
          _this8.state.checkDonViPhongBanKhac = true;
          _this8.state.dataPhongBan = res.data._embedded.coQuanQuanLies;
          _this8.setState(_extends({}, _this8.state));
        } else {
          _this8.state.checkDonViPhongBanKhac = true;
          _this8.setState(_extends({}, _this8.state));
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataNextStates) {
        var data = [].concat(_toConsumableArray(nextProps.dataNextStates));
        data = data.filter(function (props) {
          return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' && props.type != 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' && props.type != 'CAN_BO_GIAO_TTXM_LAI';
        });
        /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
          data = data.filter(props => {
            return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
          });
        } */
        if ((0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
          data = data.filter(function (props) {
            return props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM";
          });
        } else {
          var getPhongBan = data.find(function (item) {
            return item.type === "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP" || item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
          });
          if (getPhongBan) {
            var phoPhong = {
              stateId: getPhongBan.stateId,
              ten: "Trưởng phòng giao việc phó phòng",
              tenVietTat: "Giao việc phó phòng",
              type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
            };
            data.push(phoPhong);
          }
        }
        data.map(function (item) {
          if (item.type == 'KET_THUC') {
            item.tenVietTat = 'Tự giải quyết';
            item.ten = 'Trưởng phòng tự giải quyết';
          }
        });
        this.setState({
          dataNextStates: data
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'resetData',
    value: function resetData(type) {
      var _this9 = this;

      if (type == 'nextState') {
        this.setState({
          ketQuaXLDGiaiQuyet: '',
          tienDoDoiThoai: ''
        });
      }
      this.setState({
        canBoGiaiQuyet: '',
        thoiGianDoiThoai: '',
        diaDiemDoiThoai: '',

        coQuanDieuTra: '',
        soVuGiaoCoQuanDieuTra: 0,
        soDoiTuongGiaoCoQuanDieuTra: 0,

        tienPhaiThuNhaNuoc: 0,
        datPhaiThuNhaNuoc: 0,
        tienPhaiTraCongDan: 0,
        datPhaiTraCongDan: 0,
        tongSoNguoiXuLyHanhChinh: 0,
        soNguoiDaBiXuLyHanhChinh: 0,

        hinhThucTheoDoi: '',
        coQuanTheoDoi: '',
        ketQuaThucHienTheoDoi: '',

        khoiTo: false,
        soVuBiKhoiTo: 0,
        soDoiTuongBiKhoiTo: 0,

        soVanBan: '',
        ngayBanHanh: '',
        nguoiBanHanh: '',

        tienDaThuNhaNuoc: 0,
        datDaThuNhaNuoc: 0,
        tienDaTraCongDan: 0,
        datDaTraCongDan: 0,

        giaoCoQuanDieuTra: false,
        quyetDinhGiaiQuyetKhieuNai: false,
        theoDoiThucHien: false,

        tienPhaiThuNhaNuocQDGQ: 0,
        tienPhaiTraCongDanQDGQ: 0,
        datPhaiThuNhaNuocQDGQ: 0,
        datPhaiTraCongDanQDGQ: 0,
        soNguoiDuocTraLaiQuyenLoi: 0,

        soVuGiaiQuyetKhieuNai: 0,

        soLanGiaiQuyetLai: 0,
        ketQuaGiaiQuyetLan2: '',
        noiDungKetLuanGiaiQuyetLai: '',

        ketQuaGiaiQuyetKhac: '',
        ketQuaThucHienKhac: '',
        noiDungDoiThoai: '',
        noiDungGiaoLapDuThao: '',

        yKienGiaiQuyet: '',
        allowAttach: false
      }, function () {
        _this9.renderAttachFile();
        _this9.getNgayHetHanLapDuThao();
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.allowAttach = false;
        this.state.valueKetQua = e.target.value;

        this.setState(_extends({}, this.state));
        this.resetData();
      } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.allowAttach = false;
        this.state.valueKetQua = e.target.value;

        this.setState(_extends({}, this.state));
        this.resetData();
      } else {
        this.state[name] = e.target.value;
        this.state.valueKetQua = '';
        this.setState(_extends({}, this.state));

        if (name == 'ketQuaXLDGiaiQuyet') {
          this.resetData();
        }

        if (name == 'tienDoDoiThoai' && e.target.value != 'KHONG_DOI_THOAI') {
          this.state.ketQuaXLDGiaiQuyet = '';
          this.setState(_extends({}, this.state));
          this.resetData();
        }

        if (name === 'tienDoDoiThoai' && e.target.value === 'KHONG_DOI_THOAI') {
          this.resetData();
        }

        if (name == 'tienDoDoiThoai' || name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi' || name == 'soLanGiaiQuyetLai' || name == 'ketQuaGiaiQuyetLan2') {}

        if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          this.setState({
            ketQuaGiaiQuyetLan2: ''
          });
        }

        if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }
      }

      if (name === 'valueSelectBox' && e.target.value === 'TU_GIAI_QUYET') {
        this.setState({
          nextState: "KET_THUC"
        });
      }
      if (name === 'valueSelectBox' && e.target.value === 'CHUYEN_PHONG_BAN_KHAC') {
        this.setState({
          nextState: "TRUONG_PHONG_NHAN_KET_QUA_TTXM"
        });
        this.resetData();
      }
      if (name === 'nextState') {
        this.resetData('nextState');
      }

      if (name === 'valueSelectBox' && e.target.value === "CHUYEN_PHONG_BAN_KHAC") {
        var chuyenPhongBanKhac = this.state.dataNextStates.find(function (state) {
          return state.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
        });
        var tempState = '';
        if (chuyenPhongBanKhac) {
          tempState = "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
        } else {
          tempState = "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP";
        }
        this.setState({
          nextState: tempState
        });
        this.resetData('nextState');
      }

      if (name === 'valueSelectBox' && e.target.value === "TU_GIAI_QUYET") {
        this.setState({
          nextState: "KET_THUC"
        });
        this.resetData();
      }

      this.props.handleChangeData();
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this10 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this10.setState({
              dataGiaiQuyetDon: res.data,
              canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
              phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX) : '',
              phoPhong: res.data.phoPhong,

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM || '',

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : _this10.props.truongPhongThuHoi == true ? 'KET_THUC' : '',
              nextStateInit: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              tienDoDoiThoai: _this10.props.isTTXMLai && res.data.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' ? '' : res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet == 'DOI_THOAI' ? 'DOI_THOAI' : 'KHONG_DOI_THOAI' : '',

              ketQuaXLDGiaiQuyetInit: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? true : false,
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || '',
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              noiDungGiaoLapDuThao: res.data.noiDungGiaoLapDuThao ? res.data.noiDungGiaoLapDuThao : '',
              setHuongGiaiQuyet: false
            }, function () {
              _this10.checkOnlyState();
              _this10.renderAttachFile();
              _this10.getNgayHetHanLapDuThao();
              _this10.checkFileCoQuanDieuTra();
            });
            if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
              _this10.setState({ ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai) });
            }
            if (res.data.ngayHetHanTTXMLai) {
              _this10.setState({ ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai) });
            }
          }
        });
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState() {
      var _this11 = this;

      if (this.props.dataNextStates.length == 1) {
        this.setState({
          nextState: this.props.dataNextStates[0].type
        }, function () {
          _this11.renderAttachFile();
          _this11.checkFileCoQuanDieuTra();
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this12 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this12.state.giaoCoQuanDieuTra == false) {
          _this12.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this12.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };

            _this12.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'getNgayHetHanLapDuThao',
    value: function getNgayHetHanLapDuThao() {
      var _this13 = this;

      _api.GiaiQuyetDonThu.actions.getNgayHetHanLapDuThao.request().then(function (res) {
        if (res.data) {
          _this13.setState({
            ngayHetHanGiaoLapDuThao: res.data
          });
        } else {
          _this13.setState({
            ngayHetHanGiaoLapDuThao: ''
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this14 = this;

      var date = e;
      if (e && e._d) {
        date = e._d;
      }
      this.setState(_defineProperty({}, name, date), function () {
        if (name == 'ngayRaThongBaoTTXM') {
          _this14.setState({
            loaiVanBanSuggest: 'VB_GTTXML',
            ngayQuyetDinhSuggest: _this14.state.ngayRaThongBaoTTXM
          });
          _this14.getThoiHanTTXMMacDinh();
        }
        _this14.props.handleChangeData();
      });
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this15 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

        if (this.state.giaoCoQuanDieuTra) {
          params.giaoCoQuanDieuTra = true;
          if (this.state.coQuanDieuTra) {
            params.coQuanDieuTra = {
              id: Number(this.state.coQuanDieuTra)
            };
          }
          params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
          params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
          if (this.state.khoiTo) {
            params.khoiTo = true;
            params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
            params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
          } else {
            params.khoiTo = false;
            params.soVuBiKhoiTo = 0;
            params.soDoiTuongBiKhoiTo = 0;
          }
        } else {
          params.giaoCoQuanDieuTra = false;
          params.coQuanDieuTra = null;
          params.soVuGiaoCoQuanDieuTra = 0;
          params.soDoiTuongGiaoCoQuanDieuTra = 0;

          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }

        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

        if (Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.soVanBan = '';
        params.ngayBanHanh = null;
        params.nguoiBanHanh = null;

        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.theoDoiThucHien = false;
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;

        params.ketQuaThucHienKhac = '';

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;

        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }

      var selectedState = this.props.dataNextStates.filter(function (state) {
        return state.type == _this15.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        };
      } else {
        params.nextState = null;
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoGiaiQuyet = {
          id: Number(this.state.canBoGiaiQuyet)
        };
      } else {
        params.canBoGiaiQuyet = null;
      }

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      } else {
        params.phongBanGiaiQuyet = null;
      }

      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }

      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : this.state.tienDoDoiThoai ? this.state.tienDoDoiThoai : null;
      if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM') {
        params.ketQuaXLDGiaiQuyet = null;
      }

      if (this.state.tienDoDoiThoai == 'DOI_THOAI') {
        params.doiThoai = true;
        params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        params.noiDungGiaoLapDuThao = this.state.noiDungGiaoLapDuThao;
        params.ngayHetHanGiaoLapDuThao = this.state.ngayHetHanGiaoLapDuThao;
      } else if (this.props.nhanDuThao != true) {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
        params.noiDungGiaoLapDuThao = '';
        params.ngayHetHanGiaoLapDuThao = null;
      }

      if (this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
        params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
        params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? (0, _moment2.default)(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
        params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
      }

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(type) {
      var _this16 = this;

      this.setState({
        onSave: true
      }, function () {

        _this16.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this16.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this16.state.taiLieuVanThuUpdate[_this16.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this16.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this16.state.taiLieuVanThu[_this16.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this16.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this16.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO') {

          var dataQDGQ = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          dataQDGQ.filter(function (state) {
            return state.typeRequired == 'QDGQ_LDT';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          var dataGCCDT = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          dataGCCDT.filter(function (state) {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this16.state.nextState != 'KET_THUC' && _this16.props.nhanDuThao != true) {
          var dataGiaiQuyetDon = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDon));
          dataGiaiQuyetDon.filter(function (state) {
            return state.typeRequired == 'BB_DOI_THOAI';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          var _dataQDGQ = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          _dataQDGQ.filter(function (state) {
            return state.typeRequired == 'QDGQ_LDT';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          var _dataGCCDT = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          _dataGCCDT.filter(function (state) {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          }).map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        } else {
          if (_this16.state.ketQuaXLDGiaiQuyet != 'DOI_THOAI' && _this16.props.nhanDuThao != true) {
            var _dataGiaiQuyetDon = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDon));
            _dataGiaiQuyetDon.filter(function (state) {
              return state.typeRequired == 'BB_DOI_THOAI';
            }).map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          if (!_this16.state.giaoCoQuanDieuTra) {
            var _dataGCCDT2 = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataGCCDT2.filter(function (state) {
              return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
            }).map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          if (_this16.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this16.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            var _dataQDGQ2 = [].concat(_toConsumableArray(_this16.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            _dataQDGQ2.filter(function (state) {
              return state.typeRequired == 'QDGQ_LDT';
            }).map(function (item) {
              _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
        }

        if (_this16.state.dataTaiLieuVanThuDelete.length > 0) {
          _this16.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this16.state.taiLieuVanThuDelete[_this16.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this16.getParams();
        params.yKienGiaiQuyet = _this16.state.yKienGiaiQuyet;
        _this16.postTaiLieuVanThu(_this16.state.taiLieuVanThu, function () {
          _this16.updateTaiLieuVanThu(_this16.state.taiLieuVanThuUpdate, function () {
            _this16.deleteTaiLieuVanThu(_this16.state.taiLieuVanThuDelete, function () {
              _this16.props.saveGiaiQuyetDon(params);
            });
          });
        });
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this17 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this17.validateSubmitForm()) {
          _this17.setState({
            isOpen: false,
            btnLoading: true
          });
          var dataFileDinhKem = _this17.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this17.state.taiLieuVanThuUpdate[_this17.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this17.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this17.state.taiLieuVanThu[_this17.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this17.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this17.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO') {
            var dataQDGQ = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataQDGQ.filter(function (state) {
              return state.typeRequired == 'QDGQ_LDT';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });

            var dataGCCDT = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            dataGCCDT.filter(function (state) {
              return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this17.state.nextState != 'KET_THUC' && _this17.props.nhanDuThao != true) {
            var dataGiaiQuyetDon = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDon));
            dataGiaiQuyetDon.filter(function (state) {
              return state.typeRequired == 'BB_DOI_THOAI';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });

            var _dataQDGQ3 = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            _dataQDGQ3.filter(function (state) {
              return state.typeRequired == 'QDGQ_LDT';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });

            var _dataGCCDT3 = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataGCCDT3.filter(function (state) {
              return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
            }).map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          } else {
            if (_this17.state.ketQuaXLDGiaiQuyet != 'DOI_THOAI' && _this17.props.nhanDuThao != true) {
              var _dataGiaiQuyetDon2 = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDon));
              _dataGiaiQuyetDon2.filter(function (state) {
                return state.typeRequired == 'BB_DOI_THOAI';
              }).map(function (item) {
                _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }
            if (!_this17.state.giaoCoQuanDieuTra) {
              var _dataGCCDT4 = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
              _dataGCCDT4.filter(function (state) {
                return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
              }).map(function (item) {
                _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }
            if (_this17.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this17.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
              var _dataQDGQ4 = [].concat(_toConsumableArray(_this17.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
              _dataQDGQ4.filter(function (state) {
                return state.typeRequired == 'QDGQ_LDT';
              }).map(function (item) {
                _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                  id: item.taiLieuVanThuId
                };
              });
            }
          }

          if (_this17.state.dataTaiLieuVanThuDelete.length > 0) {
            _this17.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
          var _params = _this17.getParams();
          var selectedState = _this17.state.dataNextStates.filter(function (state) {
            return state.type == _this17.state.nextState;
          });
          var params = {};
          var msgName = '';
          if (type == 'giaoCanBo') {
            params = {
              canBoXuLyChiDinh: {
                id: Number(_this17.state.canBoGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this17.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this17.state.yKienGiaiQuyet
            };
            msgName = 'gqdGiaoViec';
            if (_this17.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
              params = _extends({}, params, {
                phoPhong: true,
                phongBanGiaiQuyet: {
                  id: Number(_this17.state.coQuanQuanLyNguoiDung.id)
                }
              });
            }
          } else if (type == 'openDialogVanPhong' || type == 'openDialogNoiChinh') {
            params = {
              phongBanGiaiQuyet: {
                id: Number(_this17.state.phongBanGiaiQuyet)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this17.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this17.state.yKienGiaiQuyet
            };
            msgName = 'xldChuyenDon';
          } else if (type == 'openDialogLuuHoSo') {
            if (_this17.state.donViTheoDoiThucHien) {
              _params.donViTheoDoiThucHien = {
                id: Number(_this17.state.donViTheoDoiThucHien)
              };
            }
            selectedState = _this17.props.dataNextStates.filter(function (state) {
              return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN';
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              donViTheoDoiThucHien: {
                id: Number(_this17.state.donViTheoDoiThucHien)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              }
            };
            params.yKienGiaiQuyet = _this17.state.lyDoBanHanhQuyetDinhDinhChi;
            if (_this17.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
              params.yKienGiaiQuyet = _this17.state.lyDoBanHanhQuyetDinhGiaiQuyet;
            }
            msgName = 'gqdChuyenTheoDoi';
          } else if (type == 'openDialogGiaoTTXML') {
            selectedState = _this17.props.dataNextStates.filter(function (state) {
              return state.type === 'CAN_BO_GIAO_TTXM_LAI';
            });
            params = {
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              yKienGiaiQuyet: _this17.state.noiDungGiaoTTXMLai
            };
            msgName = 'guiTTXMLai';
            if (_this17.state.ngayRaThongBaoTTXM) {
              params.ngayRaThongBaoTTXM = (0, _moment2.default)(_this17.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
            }
          } else if (type === 'giaoPhongBan') {
            selectedState = _this17.props.dataNextStates.find(function (state) {
              return state.type === _this17.state.nextState;
            });
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              yKienGiaiQuyet: _this17.state.yKienGiaiQuyet || ''
            };

            if (selectedState && selectedState.stateId) {
              params.nextState = { id: Number(selectedState.stateId) };
            }
            if (_this17.state.phongBanGiaiQuyet) {
              params.phongBanGiaiQuyet = { id: Number(_this17.state.phongBanGiaiQuyet) };
            }
            msgName = 'gqdGiaoViec';
          } else {
            selectedState = _this17.props.dataNextStates.filter(function (state) {
              return state.type == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this17.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this17.state.noiDungGiaoLapDuThao ? _this17.state.noiDungGiaoLapDuThao : ''
            };
            msgName = 'gqdGuiDuThao';
          }
          _this17.postTaiLieuVanThu(_this17.state.taiLieuVanThu, function () {
            _this17.updateTaiLieuVanThu(_this17.state.taiLieuVanThuUpdate, function () {
              _this17.deleteTaiLieuVanThu(_this17.state.taiLieuVanThuDelete, function () {
                _this17.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({
          ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '',
          soVanBan: fileQD.length ? fileQD[0].soQuyetDinh : ''
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
        var ttxmlDate = data.filter(function (item) {
          return item.typeRequired == 'VB_GTTXML';
        });
        if (ttxmlDate.length) {
          this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
        }
        this.getThoiHanTTXMMacDinh();
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(type) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, type, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(type) {
      this.setState(_defineProperty({}, type, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(type) {
      this.closeDialog(type);
      this.handleGiaiQuyetDon(type);
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      var _this18 = this;

      this.state.open = false;
      this.state.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet;
      this.setState(_extends({}, this.state), function () {
        _this18.renderAttachFile();
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      var _this19 = this;

      this.state.open = false;
      this.state.ketQuaXLDGiaiQuyet = this.state.valueKetQua;
      this.setState(_extends({}, this.state), function () {
        _this19.renderAttachFile();
      });
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this20 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = [];

      var listTaiLieuVanThuGiaiQuyetDonView = [];

      if (this.props.nhanDuThao == true) {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this20.compareDate(new Date(state.ngayTao), new Date(_this20.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this20.compareDate(new Date(_this20.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), new Date(state.ngayTao), 'show');
        });
      } else {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this20.compareDate(new Date(state.ngayTao), new Date(_this20.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this20.compareDate(new Date(_this20.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
        });
      }
      if (this.state.tienDoDoiThoai == 'DOI_THOAI' && this.state.nextState == 'KET_THUC' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
        var dataCheck = data.filter(function (item) {
          return item.required && item.typeRequired == 'BB_DOI_THOAI';
        });
        if (dataCheck.length > 0) {
          //Do nothing
        } else {
          listTaiLieuVanThuGiaiQuyetDon[listTaiLieuVanThuGiaiQuyetDon.length] = {
            ten: 'Biên bản đối thoại',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BB_DOI_THOAI',
            newFile: true
          };
        }

        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        });
      } else {
        this.setState({
          allowAttach: false
        });
        var _data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
        var dataForFillter = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));

        var dataFillter = dataForFillter.filter(function (item) {
          return item.typeRequired != 'BB_DOI_THOAI';
        });
        var dataTTXML = dataForFillter.filter(function (item) {
          return item.typeRequired == 'VB_GTTXML';
        });

        var _dataCheck = _data.filter(function (item) {
          return item.taiLieuVanThuId && item.typeRequired == 'BB_DOI_THOAI';
        });
        if (_dataCheck.length > 0) {
          _dataCheck.map(function (item) {
            _this20.state.taiLieuVanThuDelete[_this20.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
        //check file TTXM Lai
        if ((this.state.nextState == 'KET_THUC' || this.state.valueSelectBox === 'TU_GIAI_QUYET') && this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
          dataFillter = [].concat(_toConsumableArray(dataFillter), [{
            ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'VB_GTTXML',
            newFile: true
          }]);
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: dataFillter,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        });
      }
    }
  }, {
    key: 'checkHuongGiaiQuyet',
    value: function checkHuongGiaiQuyet() {
      var _this21 = this;

      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (ThamSo.length > 0 && this.state.nextStateInit == '' && userInfo != {} && this.state.setHuongGiaiQuyet == false && (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH')) {

        if ((0, _checkThamSo.checkThamSo)() == null && this.props.dataNextStates.length > 1) {
          this.setState({
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          });
        } else if ((0, _checkThamSo.checkThamSo)() == 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
          this.setState({
            // nextState: this.props.roleGQ === 'truongPhongBanTiepCongDan' ? 'KET_THUC' : 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: false
          }, function () {
            _this21.checkPhongBan();
          });
        } else if ((0, _checkThamSo.checkThamSo)() == 'CQQL_PHONG_NOI_CHINH') {
          var dataNextStates = [].concat(_toConsumableArray(this.props.dataNextStates));
          var dataFilter = dataNextStates.filter(function (state) {
            return state.type == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM';
          });

          if (dataFilter.length > 0) {
            this.setState({
              nextState: this.state.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : this.props.truongPhongThuHoi == true ? 'KET_THUC' : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          } else {
            this.setState({
              nextState: this.state.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO',
              setHuongGiaiQuyet: true,
              allowHuongGiaiQuyet: true
            });
          }
        }
      }
    }
  }, {
    key: 'checkPhongBan',
    value: function checkPhongBan() {
      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
        var dataFilter = ThamSo.filter(function (state) {
          return state.ten == 'CQQL_PHONG_NOI_CHINH';
        });

        if (dataFilter.length > 0) {
          this.setState({
            phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
            typeButton: 'PHONG_NOI_CHINH'
          });
        }
      } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
        var _dataFilter = ThamSo.filter(function (state) {
          return state.ten == 'CQQL_VAN_PHONG_UBND_THANH_PHO';
        });

        if (_dataFilter.length > 0) {
          this.setState({
            phongBanGiaiQuyet: Number(_dataFilter[0].giaTri),
            typeButton: 'VAN_PHONG_UBND'
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this22 = this,
          _React$createElement;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this22.state.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      var txtTuGQ = "Tự giải quyết";
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_subView.BlockBaoCaoKQTTXM, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.nhanDuThao == true },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      '\u0110\u1ED1i tho\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', red: true, value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y tr\xECnh d\u1EF1 th\u1EA3o:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao ? this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao : '' })
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.showTienDoGiaiQuyet },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon !== "DON_TRANH_CHAP_DAT" && !this.state.allowHuongGiaiQuyet && (0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan" },
              _react2.default.createElement(_common.DropDown, (_React$createElement = {
                require: true,
                label: '',
                selectedValue: this.state.valueSelectBox,
                options: this.state.dataSelectBox,
                keyName: 'giaTri'
              }, _defineProperty(_React$createElement, 'label', 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt'), _defineProperty(_React$createElement, 'valueName', 'ten'), _defineProperty(_React$createElement, 'disable', this.state.ketQuaXLDGiaiQuyet !== '' ? true : false), _defineProperty(_React$createElement, 'className', 'col-25'), _defineProperty(_React$createElement, 'onChange', this.onChange.bind(this, 'valueSelectBox')), _defineProperty(_React$createElement, 'placeholder', '--Ch\u1ECDn--'), _defineProperty(_React$createElement, 'name', 'valueSelectBox'), _React$createElement))
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.showTienDoGiaiQuyet },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.allowHuongGiaiQuyet && this.state.ketQuaXLDGiaiQuyetInit !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyetInit !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  onRef: function onRef(select) {
                    return _this22.select = select;
                  },
                  className: 'col-25',
                  donId: this.state.id,
                  require: true,
                  isValid: this.state.validate,
                  data: this.state.dataNextStates,
                  disable: this.state.ketQuaXLDGiaiQuyet !== '' ? true : false,
                  bindValidator: this,
                  selectedValue: this.state.nextState,
                  label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                  keyName: 'type',
                  name: 'huongGiaiQuyet',
                  valueName: 'tenVietTat',
                  onChange: this.onChange.bind(this, 'nextState') })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showTienDoGiaiQuyet },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: txtTuGQ })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                  selectedValue: this.state.phongBanGiaiQuyet,
                  require: true,
                  bindValidator: this,
                  className: 'col-25',
                  keyName: 'coQuanQuanLyId',
                  valueName: 'ten',
                  name: 'phongBanGiaiQuyet',
                  label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt',
                  data: this.state.dataPhongBan,
                  onChange: this.onChange.bind(this, 'phongBanGiaiQuyet')
                })
              ),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP' && this.state.typeButton !== "PHONG_NOI_CHINH" },
              _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                className: 'col-25',
                require: true,
                bindValidator: this,
                selectedValue: this.state.phongBanGiaiQuyet,
                isValid: this.props.validate,
                onChange: this.onChange.bind(this, 'phongBanGiaiQuyet'),
                name: 'dropdownChonPhongBanThuocCoQuan' }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                isValid: this.state.validate,
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                vaiTro: 'PHO_PHONG',
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                bindvaiTroValidator: this,
                className: 'col-25',
                label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                vaiTro: vaiTro,
                bindValidator: this,
                className: 'col-25',
                label: (0, _checkThamSo.checkThamSo)() == 'CQQL_VAN_PHONG_UBND_THANH_PHO' ? 'Phòng ban giải quyết' : 'Công chức giải quyết',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'KET_THUC' && this.state.valueSelectBox === "" || (0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox === 'TU_GIAI_QUYET' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'p',
                    { className: 'attach-file-description mb10 pl5 pr5' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true },
                    _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoDoiThoai', className: 'col-25', selectedValue: this.state.tienDoDoiThoai, onChange: this.onChange.bind(this, 'tienDoDoiThoai'), isTTXMLai: this.props.isTTXMLai, loaiDon: this.props.loaiDon }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' },
                      _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao == true },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showTienDoGiaiQuyet },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' },
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayHetHanGiaiQuyetTTXMLai,
                  label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
                  name: 'ngayHetHanGiaiQuyetTTXMLai',
                  startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                  onChange: this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayRaThongBaoTTXM,
                  label: 'Ngày ra văn bản ' + lb1 + ' lại',
                  name: 'ngayRaThongBaoTTXM',
                  onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayHetHanTTXMLai,
                  label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3',
                  name: 'ngayHetHanTTXMLai',
                  startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                  onChange: this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai'),
                  bindValidator: this,
                  channel: 'formTaoDon' }),
                _react2.default.createElement(_common.TextArea, {
                  label: '\xDD ki\u1EBFn x\u1EED l\xFD',
                  rows: '3',
                  placeholder: 'Nh\u1EADp \xFD ki\u1EBFn',
                  value: this.state.noiDungGiaoTTXMLai,
                  onChange: this.onChange.bind(this, 'noiDungGiaoTTXMLai'),
                  name: 'textareaYKienTTXM' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tienDoDoiThoai == 'DOI_THOAI' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5 pb20' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        '\u0110\u1ED1i tho\u1EA1i'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                        _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                        _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', channel: 'formTaoDon', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', name: 'ketQuaDoiThoai', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tienDoDoiThoai == 'DOI_THOAI' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5 pb20' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 mb15' },
                        'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', value: this.state.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '', red: true }),
                        _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD', value: this.state.noiDungGiaoLapDuThao, onChange: this.onChange.bind(this, 'noiDungGiaoLapDuThao'), name: 'noiDungGiaoLapDuThao' })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    _react2.default.createElement(
                      'h3',
                      { className: 'txt-upper title-14 mt0 mb15' },
                      'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    _react2.default.createElement(
                      'h3',
                      { className: 'txt-upper title-14 mt0 mb15' },
                      'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-25', name: 'inputSoVanBan', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
                    _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                    this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }) : null,
                    this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }) : null,
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttach },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt15' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', name: 'QuyetDinhGiaiQuyet', quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt10 pb20' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    this.props.donInfo.layVuViecCu === true && _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') }),
                      this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                      _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.props.loaiDon, name: 'DropDownChonKetLuanNoiDungKhieuNai', label: this.props.loaiDon === "DON_TRANH_CHAP_DAT" ? "Kết luận nội dung tranh chấp đất" : "Kết luận nội dung khiếu nại", className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb5' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter mb20' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                        _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter mb20' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                        _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                        ),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 pt10 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5 pb5' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { name: 'DropDownChonCoQuanDieuTra', className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soVuGiaoCoQuanDieuTra', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', name: 'soDoiTuongGiaoCoQuanDieuTra', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                          _react2.default.createElement(
                            _utils.ShowIf,
                            { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-100 pt15' },
                              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pt5 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100' },
                        _react2.default.createElement(
                          _utils.ShowIfCheck,
                          { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter mt5 pb20' },
                            _react2.default.createElement(
                              'h2',
                              { className: 'title-12 mb15' },
                              'Kh\u1EDFi t\u1ED1'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-50 no-gutter' },
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                                _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.allowAttach },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'TaiLieuVTGQD',
                  onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this,
                  dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView,
                  data: this.state.listTaiLieuVanThuGiaiQuyetDon,
                  loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                  ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest,
                  onFileRemove: this.onFileRemove.bind(this),
                  onFileChange: this.onFileChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100 gqd-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                'span',
                { className: 'wrap-link' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this, 'truongPhongGiaiQuyetDon') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'giaoCanBo') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Giao vi\u1EC7c'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.nextState === 'TRUONG_PHONG_NHAN_KET_QUA_TTXM' || this.state.nextState === 'KET_THUC' || this.state.nextState === 'NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.typeButton === 'PHONG_NOI_CHINH' && (0, _checkThamSo.checkThamSo)() !== 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _bind2.default)('btn-action btn-complete action-todo', { 'btn-disable': this.state.btnSaveLoading, 'btn-loading-inline': !this.state.btnSaveLoading }), onClick: this.openDialog.bind(this, 'openDialogNoiChinh') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n cho ph\xF2ng n\u1ED9i ch\xEDnh'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.typeButton === 'PHONG_NOI_CHINH' && (0, _checkThamSo.checkThamSo)() === 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox === 'CHUYEN_PHONG_BAN_KHAC' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogNoiChinh') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n cho ph\xF2ng n\u1ED9i ch\xEDnh'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.typeButton == 'VAN_PHONG_UBND' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogVanPhong') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n cho VP UBND T\u1EC9nh'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' && this.state.nextState !== "KET_THUC" },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.handleGiaiQuyetDon.bind(this, 'giaoPhongBan') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Giao vi\u1EC7c'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogLuuHoSo') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Chuy\u1EC3n theo d\xF5i th\u1EF1c hi\u1EC7n'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.tienDoDoiThoai === 'DOI_THOAI' && this.state.nextState === 'KET_THUC' && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC' && this.props.roleGQ === "truongPhongBanTiepCongDan" },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoDoiThoai') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Chuy\u1EC3n \u0111\u01A1n v\u1ECB ',
                      lb1
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.nextState === 'KET_THUC' && this.state.tienDoDoiThoai === 'GIAO_THAM_TRA_XAC_MINH_LAI' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'openDialogGiaoTTXML') },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Giao ',
                      lb1,
                      ' l\u1EA1i'
                    )
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this, 'openDialogLuuHoSo'), onSuccess: this.onSuccess.bind(this, 'openDialogLuuHoSo'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + this.state.tenDonViTheoDoiThucHien + ' theo d\xF5i th\u1EF1c hi\u1EC7n kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoDoiThoai, onClose: this.closeDialog.bind(this, 'openDialogGiaoDoiThoai'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoDoiThoai'), title: 'X\xE1c nh\u1EADn', content: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' lập dự thảo không ?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogNoiChinh, onClose: this.closeDialog.bind(this, 'openDialogNoiChinh'), onSuccess: this.onSuccess.bind(this, 'openDialogNoiChinh'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ph\xF2ng N\u1ED9i ch\xEDnh kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogVanPhong, onClose: this.closeDialog.bind(this, 'openDialogVanPhong'), onSuccess: this.onSuccess.bind(this, 'openDialogVanPhong'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho VP UBND T\u1EC9nh kh\xF4ng?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoTTXML, onClose: this.closeDialog.bind(this, 'openDialogGiaoTTXML'), onSuccess: this.onSuccess.bind(this, 'openDialogGiaoTTXML'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' ' + lb2 + ' l\u1EA1i kh\xF4ng?' })
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.open,
              onClose: this.closeDialogConfirm.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(
                'p',
                { className: 'reception-dialog-text' },
                this.state.message
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TruongPhongNhanBaoCaoTTXMDonKhieuNai;
}(_react2.default.Component);

TruongPhongNhanBaoCaoTTXMDonKhieuNai.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TruongPhongNhanBaoCaoTTXMDonKhieuNai);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vaiTro = 'CHUYEN_VIEN';
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var TruongPhongNhanYeuCauDoiThoai = function (_React$Component) {
  _inherits(TruongPhongNhanYeuCauDoiThoai, _React$Component);

  function TruongPhongNhanYeuCauDoiThoai(props, context) {
    _classCallCheck(this, TruongPhongNhanYeuCauDoiThoai);

    var _this = _possibleConstructorReturn(this, (TruongPhongNhanYeuCauDoiThoai.__proto__ || Object.getPrototypeOf(TruongPhongNhanYeuCauDoiThoai)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: _this.props.id,
      role: _this.props.role,
      loaiDon: _this.props.loaiDon,
      validate: false,
      showAttach: false,
      focused: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataNextStates: []
    };
    return _this;
  }

  _createClass(TruongPhongNhanYeuCauDoiThoai, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      if (this.props.dataNextStates) {
        var data = [].concat(_toConsumableArray(this.props.dataNextStates));
        var getGiaoPhongBan = data.find(function (state) {
          return state.type === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP";
        });
        if (getGiaoPhongBan) {
          var phoPhong = {
            stateId: getGiaoPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          };
          data.push(phoPhong);
        }
        var dataNextStateFilter = [];

        data.map(function (item) {
          var newItem = item;
          if (item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
            newItem.tenVietTat = 'Tự giải quyết';
            newItem.ten = 'Trưởng phòng tự giải quyết';
          }
          dataNextStateFilter[dataNextStateFilter.length] = newItem;
        });
        this.setState({
          dataNextStates: dataNextStateFilter
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataNextStates) {
        var data = [].concat(_toConsumableArray(nextProps.dataNextStates));
        var dataNextStateFilter = [];
        var getGiaoPhongBan = data.find(function (state) {
          return state.type === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP";
        });
        if (getGiaoPhongBan) {
          var phoPhong = {
            stateId: getGiaoPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          };
          data.push(phoPhong);
        }
        data.map(function (item) {
          var newItem = item;
          if (item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
            newItem.tenVietTat = 'Tự giải quyết';
            newItem.ten = 'Trưởng phòng tự giải quyết';
          }
          dataNextStateFilter[dataNextStateFilter.length] = newItem;
        });

        this.setState({
          dataNextStates: dataNextStateFilter
        });
      }
      this.setState({
        loaiDon: nextProps.loaiDon
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'nextState') {
        this.resetData();
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this2 = this;

      this.setState({
        canBoGiaiQuyet: '',
        yKienGiaiQuyet: '',
        noiDungKetLuanDuThao: '',
        showAttach: false
      }, function () {
        _this2.renderAttachFile();
      });
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this3 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this3.setState({
              dataGiaiQuyetDon: res.data,
              phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : _this3.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' : '',
              noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX) : ''
            }, function () {
              _this3.checkOnlyState();
              _this3.renderAttachFile();
            });
          }
        });
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState() {
      var _this4 = this;

      if (this.props.dataNextStates.length == 1) {
        this.setState({
          nextState: this.props.dataNextStates[0].type
        }, function () {
          _this4.renderAttachFile();
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this5 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      var selectedState = this.props.dataNextStates.filter(function (state) {
        return state.type == _this5.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        };
      } else {
        params.nextState = null;
      }

      if (this.state.yKienGiaiQuyet) {
        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      } else {
        params.yKienGiaiQuyet = '';
      }

      if (this.state.noiDungKetLuanDuThao) {
        params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao;
      } else {
        params.noiDungKetLuanDuThao = '';
      }
      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoGiaiQuyet = {
          id: this.state.canBoGiaiQuyet
        };
      } else {
        params.canBoGiaiQuyet = null;
      }

      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave(type) {
      var _this6 = this;

      this.setState({
        onSave: true
      }, function () {

        _this6.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var dataFileDinhKem = _this6.getListDataFileDinhKem();
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this6.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this6.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this6.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
          var dataDT = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDon));
          dataDT.filter(function (state) {
            return state.typeRequired == 'DT_KL_GQKN';
          }).map(function (item) {
            _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this6.state.dataTaiLieuVanThuDelete.length > 0) {
          _this6.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this6.getParams();

        _this6.postTaiLieuVanThu(_this6.state.taiLieuVanThu, function () {
          _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
            _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
              _this6.props.saveGiaiQuyetDon(params);
            });
          });
        });
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this7 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this7.validateSubmitForm()) {
          _this7.setState({
            isOpen: false,
            btnLoading: true
          });

          var dataFileDinhKem = _this7.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this7.state.taiLieuVanThuUpdate[_this7.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this7.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this7.state.taiLieuVanThu[_this7.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this7.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this7.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
            var dataDT = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDon));
            dataDT.filter(function (state) {
              return state.typeRequired == 'DT_KL_GQKN';
            }).map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this7.state.dataTaiLieuVanThuDelete.length > 0) {
            _this7.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this7.getParams();
          var params = {};
          var msgName = '';
          if (type == 'giaoCanBo') {
            var selectedState = _this7.state.dataNextStates.find(function (state) {
              return state.type === _this7.state.nextState;
            });
            if (_this7.state.nextState === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP") {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this7.state.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState.stateId)
                },
                phongBanGiaiQuyet: {
                  id: Number(_this7.state.phongBanGiaiQuyet)
                },
                yKienGiaiQuyet: _this7.state.yKienGiaiQuyet
              };
            } else if (_this7.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
              params = {
                canBoXuLyChiDinh: {
                  id: Number(_this7.state.canBoGiaiQuyet)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this7.state.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState.stateId)
                },
                phongBanGiaiQuyet: {
                  id: Number(_this7.state.coQuanQuanLyNguoiDung.id)
                },
                phoPhong: true,
                yKienGiaiQuyet: _this7.state.yKienGiaiQuyet
              };
            } else {
              params = {
                canBoXuLyChiDinh: {
                  id: Number(_this7.state.canBoGiaiQuyet)
                },
                thongTinGiaiQuyetDon: {
                  id: Number(_this7.state.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState.stateId)
                },
                yKienGiaiQuyet: _this7.state.yKienGiaiQuyet
              };
            }
            msgName = 'gqdGiaoViec';
          } else if (type == 'tuGiaiQuyet') {
            var _selectedState = _this7.props.dataNextStates.filter(function (state) {
              return state.type == _this7.state.nextState;
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this7.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(_selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this7.state.noiDungKetLuanDuThao
            };
            msgName = 'gqdGuiDuThao';
          }
          _this7.postTaiLieuVanThu(_this7.state.taiLieuVanThu, function () {
            _this7.updateTaiLieuVanThu(_this7.state.taiLieuVanThuUpdate, function () {
              _this7.deleteTaiLieuVanThu(_this7.state.taiLieuVanThuDelete, function () {
                _this7.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon('tuGiaiQuyet');
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this8 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this8.compareDate(new Date(state.ngayTao), new Date(_this8.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this8.compareDate(new Date(_this8.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
      });

      if (this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET') {
        var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
        var dataCheck = data.filter(function (item) {
          return item.required && item.typeRequired == 'DT_KL_GQKN';
        });
        if (dataCheck.length > 0) {
          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            showAttach: true
          });
        } else {
          var DT_KL = {
            ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Dự thảo quyết định về việc giải quyết' : 'Dự thảo quyết định về việc giải quyết khiếu nại',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'DT_KL_GQKN',
            newFile: true
          };
          var TT_KL = {
            ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Tờ trình đề nghị ban hành QĐGQ' : 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'DT_KL_GQKN',
            newFile: true
          };
          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDon), [TT_KL, DT_KL]),
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            showAttach: true
          });
        }
      } else {
        var _data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
        var _dataCheck = _data.filter(function (item) {
          return item.typeRequired != 'DT_KL_GQKN';
        });
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: _dataCheck,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM,
          donInfo: this.props.donInfo
        }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataGiaiQuyetDon }),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_ttForms.DropDownMulipleUse, {
              onRef: function onRef(select) {
                return _this9.select = select;
              },
              className: 'col-25',
              donId: this.state.id,
              require: true,
              isValid: this.state.validate,
              data: this.state.dataNextStates,
              bindValidator: this,
              selectedValue: this.state.nextState,
              label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
              name: 'huongGiaiQuyet',
              keyName: 'type',
              valueName: 'tenVietTat',
              onChange: this.onChange.bind(this, 'nextState') }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                vaiTro: 'PHO_PHONG',
                bindValidator: this,
                className: 'col-25',
                label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState === 'NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP' },
              _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                require: true,
                className: 'col-25',
                bindValidator: this,
                selectedValue: this.state.phongBanGiaiQuyet,
                isValid: this.props.validate,
                onChange: this.onChange.bind(this, 'phongBanGiaiQuyet'),
                name: 'dropdownChonPhongBanThuocCoQuan' }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                selectedValue: this.state.canBoGiaiQuyet,
                require: true,
                coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                vaiTro: vaiTro,
                bindValidator: this,
                className: 'col-25',
                label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                onChange: this.onChange.bind(this, 'canBoGiaiQuyet'),
                name: 'dropdownChonCanBoGiaiQuyet'
              }),
              _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' },
              _react2.default.createElement(_common.TextArea, { value: this.state.noiDungKetLuanDuThao, className: 'areal-wrap col-100', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'noiDungKetLuanDuThao'), name: 'textareaChonCanBoGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showAttach },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, data: this.state.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-save action-todo ' + (this.state.btnLoading ? this.state.btnSaveLoading ? 'btn-loading-inline' : 'btn-disable' : ''), onClick: this.handleSave.bind(this, 'truongPhongGiaiQuyetDon') },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO' || this.state.nextState === "NHANLAPDUTHAO_GIAO_PHONG_CUNG_CAP" || this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" },
              _react2.default.createElement(
                _reactRouter.Link,
                { style: { right: 0 }, className: 'btn-action btn-move right action-todo ' + (this.state.btnLoading ? this.state.btnSaveLoading ? 'btn-disable' : 'btn-loading-inline' : ''), onClick: this.handleGiaiQuyetDon.bind(this, 'giaoCanBo') },
                _react2.default.createElement(
                  'span',
                  null,
                  'Giao vi\u1EC7c'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET' },
              _react2.default.createElement(
                _reactRouter.Link,
                { style: { right: 0 }, className: 'btn-action btn-move right action-todo ' + (this.state.btnLoading ? this.state.btnSaveLoading ? 'btn-disable' : 'btn-loading-inline' : ''), onClick: this.openDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'G\u1EEDi d\u1EF1 th\u1EA3o'
                )
              )
            ),
            _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " dự thảo của đơn/vụ việc này không?" })
          )
        )
      );
    }
  }]);

  return TruongPhongNhanYeuCauDoiThoai;
}(_react2.default.Component);

TruongPhongNhanYeuCauDoiThoai.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TruongPhongNhanYeuCauDoiThoai);

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _ConfirmDialog = __webpack_require__(74);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _NhiemVuTTXM = __webpack_require__(92);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _GetParams = __webpack_require__(47);

var _common = __webpack_require__(3);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var TruongPhongNhanYeuCauTheoDoiThucHien = function (_React$Component) {
  _inherits(TruongPhongNhanYeuCauTheoDoiThucHien, _React$Component);

  function TruongPhongNhanYeuCauTheoDoiThucHien(props, context) {
    _classCallCheck(this, TruongPhongNhanYeuCauTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (TruongPhongNhanYeuCauTheoDoiThucHien.__proto__ || Object.getPrototypeOf(TruongPhongNhanYeuCauTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      focused: false,
      dataDetail: [],
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],
      dataNextStates: [],
      dataCongChuc: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      dataTaiLieuVanThuGiaiQuyetDon: _this.props.listTaiLieuVanThuGiaiQuyetDon,

      id: _this.props.id,
      loaiDon: _this.props.loaiDon,
      nextState: '',
      khoiToInit: '',
      soVuBiKhoiToInit: '',
      soDoiTuongBiKhoiToInit: '',
      khoiTo: false,
      openDialog: false,
      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,
      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',
      ketQuaThucHienKhac: '',
      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,
      canBoXuLyChiDinh: '',
      getDetail: false,
      getCongChucPhongBan: false,
      checkState: false,
      textNextState: '',
      ketQuaGiaiQuyetLan2: '',
      soLanGiaiQuyetLai: '',
      noiDungKetLuanGiaiQuyetLai: '',
      soVuGiaiQuyetKhieuNai: '',
      ketLuanNoiDungKhieuNai: '',
      ketQuaGiaiQuyetKhac: '',
      tienPhaiThuNhaNuocQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',
      soNguoiDuocTraLaiQuyenLoi: '',
      nguoiBanHanh: '',
      phongBanChiDinh: ''
    };
    return _this;
  }

  _createClass(TruongPhongNhanYeuCauTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanTheoDoiEnumn();
      this.getDetail(this.state.thongTinGiaiQuyetDonId);
      if (this.props.dataNextStates.length > 0) {
        this.filterState(this.props.dataNextStates);
      }
      if (this.state.coQuanQuanLyNguoiDung && this.state.coQuanQuanLyNguoiDung.id) {
        this.getCongChucPhongBan(this.state.coQuanQuanLyNguoiDung.id);
      }
      if (window.debug) {
        console.log('giai-quyet-don/subView/TruongPhongNhanYeuCauTheoDoiThucHien');
      }
    }
  }, {
    key: 'getCongChucPhongBan',
    value: function getCongChucPhongBan(id) {
      var _this2 = this;

      var params = {
        coQuanQuanLyId: id,
        vaiTro: 'CHUYEN_VIEN',
        page: 0,
        size: 1000,
        sort: 'ten,desc'
      };

      _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataCongChuc: res.data._embedded.congChucs
          }, function () {
            _this2.setState({
              getCongChucPhongBan: true
            });
          });
        }
      });
    }
  }, {
    key: 'filterState',
    value: function filterState(data) {
      var dataNextStates = [];
      var getGiaoPhongBan = [].concat(_toConsumableArray(data)).filter(function (item) {
        return item.type === "NHANTDTH_GIAO_PHONG_CUNG_CAP";
      });
      if (getGiaoPhongBan.length) {
        var phoPhong = {
          stateId: getGiaoPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        data.push(phoPhong);
      }
      data.map(function (item) {
        var Item = _extends({}, item);
        if (Item.type == "CAN_BO_TDTH_LUU_DON" || Item.type == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
          Item.tenVietTat = 'Tự xử lý';
        }
        dataNextStates[dataNextStates.length] = Item;
      });
      this.setState({
        dataNextStates: dataNextStates
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this3 = this;

      if (typeof id != 'undefined') {
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: id }).then(function (res) {
          if (res.data) {
            _this3.setState({
              dataDetail: res.data,
              khoiToInit: res.data.khoiTo,
              soVuBiKhoiToInit: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiToInit: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
              phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
              canBoXuLyChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
              nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
              showFile: false,
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0
            }, function () {
              if (_this3.state.nextState == 'CAN_BO_TDTH_LUU_DON' || _this3.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
                _this3.checkFileDinhKem();
              } else {
                _this3.filterFileDinhKem();
              }
              _this3.setState({
                getDetail: true
              });
            });
          }
        });
      }
    }
  }, {
    key: 'filterFileDinhKem',
    value: function filterFileDinhKem() {
      var _this4 = this;

      var data = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
        return state.typeRequired != 'DON_VI_THEO_DOI_THUC_HIEN';
      });
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon
      }, function () {
        _this4.setState({
          showFile: true
        });
      });
    }
  }, {
    key: 'checkFileDinhKem',
    value: function checkFileDinhKem() {
      var _this5 = this;

      var data = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var dataView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
        return _this5.compareDate(new Date(state.ngayTao), new Date(_this5.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(function (state) {
        return _this5.compareDate(new Date(_this5.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
      });
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
      }, function () {
        _this5.setState({
          showFile: true
        });
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();
      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
        loaiDon: nextProps.loaiDon
      });
      if (this.props.listTaiLieuVanThuGiaiQuyetDon != nextProps.listTaiLieuVanThuGiaiQuyetDon) {
        this.setState({
          dataTaiLieuVanThuGiaiQuyetDon: nextProps.listTaiLieuVanThuGiaiQuyetDon
        });
      }
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.handleBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this7 = this;

      if (name == 'nextState') {
        var data = [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuGiaiQuyetDon));
        var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
          return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
        });
        if (listTaiLieuVanThuGiaiQuyetDon.length > 0 || this.state.dataFileDinhKem.length > 0) {
          this.resetData();
          this.setState({
            confirm: true,
            textNextState: e.target.value
          });
        } else {
          var _setState3;

          this.setState((_setState3 = {}, _defineProperty(_setState3, name, e.target.value), _defineProperty(_setState3, 'showFile', false), _setState3), function () {
            _this7.resetData();
            if (_this7.state.nextState == 'CAN_BO_TDTH_LUU_DON' || _this7.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
              _this7.checkFileDinhKem();
            } else {
              _this7.filterFileDinhKem();
            }
          });
        }
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
        this.setState({
          noiDungKetLuanGiaiQuyetLai: ''
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onConfirm',
    value: function onConfirm() {
      var _this8 = this;

      this.setState({
        confirm: false,
        dataFileDinhKem: [],
        nextState: this.state.textNextState,
        showFile: false
      }, function () {
        _this8.resetData();
        if (_this8.state.nextState == 'CAN_BO_TDTH_LUU_DON' || _this8.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
          _this8.checkFileDinhKem();
        } else {
          _this8.filterFileDinhKem();
          var data = [].concat(_toConsumableArray(_this8.state.dataTaiLieuVanThuGiaiQuyetDon));
          var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
            return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
          });
          var dataFilter = [].concat(_toConsumableArray(_this8.state.dataTaiLieuVanThuGiaiQuyetDon));
          var listTaiLieuVanThuGiaiQuyetDonFilter = [];
          listTaiLieuVanThuGiaiQuyetDonFilter = dataFilter.filter(function (state) {
            return state.typeRequired != 'DON_VI_THEO_DOI_THUC_HIEN';
          });

          if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
            listTaiLieuVanThuGiaiQuyetDon.map(function (item) {
              _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this8.state.taiLieuVanThuDelete.length > 0) {
            _this8.deleteTaiLieuVanThu(_this8.state.taiLieuVanThuDelete, function () {});
            _this8.setState({
              dataTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDonFilter,
              taiLieuVanThuDelete: []

            });
          }
        }
      });
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        khoiTo: this.state.khoiToInit,
        soVuBiKhoiTo: this.state.soVuBiKhoiToInit,
        soDoiTuongBiKhoiTo: this.state.soDoiTuongBiKhoiToInit,
        hinhThucTheoDoi: '',
        coQuanTheoDoi: '',
        ketQuaThucHienTheoDoi: '',
        ketQuaThucHienKhac: '',
        tienPhaiThuNhaNuoc: 0,
        datPhaiThuNhaNuoc: 0,
        tienDaThuNhaNuoc: 0,
        datDaThuNhaNuoc: 0,
        tienPhaiTraCongDan: 0,
        datPhaiTraCongDan: 0,
        tienDaTraCongDan: 0,
        datDaTraCongDan: 0,
        canBoXuLyChiDinh: ''
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleKetThuc();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this9 = this;

      var dataGQD = this.state.dataDetail;
      var params = (0, _GetParams.getParams)(dataGQD, this.state.id);

      if (this.state.nextState == 'CAN_BO_TDTH_LUU_DON') {
        if (params.giaoCoQuanDieuTra && this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
          params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      }

      params.theoDoiThucHien = true;
      params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
      if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
        params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
      } else {
        params.coQuanTheoDoi = null;
      }
      params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
      params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

      params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
      params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
      params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
      params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

      params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
      params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
      params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
      params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;

      var selectedState = this.state.dataNextStates.filter(function (state) {
        return state.type == _this9.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        };
      } else {
        params.nextState = null;
      }

      if (this.state.canBoXuLyChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoXuLyChiDinh)
        };
      } else {
        params.canBoXuLyChiDinh = null;
      }

      if (this.state.phongBanChiDinh) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanChiDinh)
        };
      }

      if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
      } else {
        params.phoPhong = false;
      }

      var isQDGQ = dataGQD.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
      params.soLanGiaiQuyetLai = isQDGQ && this.props.loaiDon == 'DON_KHIEU_NAI' ? Number(this.state.soLanGiaiQuyetLai) : 0;
      params.ketQuaGiaiQuyetLan2 = Number(this.state.soLanGiaiQuyetLai) > 1 ? this.state.ketQuaGiaiQuyetLan2 : null;
      params.noiDungKetLuanGiaiQuyetLai = this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' ? this.state.noiDungKetLuanGiaiQuyetLai : '';
      params.soVuGiaiQuyetKhieuNai = isQDGQ ? Number(this.state.soVuGiaiQuyetKhieuNai) : 0;
      params.ketLuanNoiDungKhieuNai = isQDGQ ? this.state.ketLuanNoiDungKhieuNai : null;
      params.ketQuaGiaiQuyetKhac = isQDGQ ? this.state.ketQuaGiaiQuyetKhac : '';
      params.tienPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.tienPhaiThuNhaNuocQDGQ) : 0;
      params.datPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.datPhaiThuNhaNuocQDGQ) : 0;
      params.tienPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.tienPhaiTraCongDanQDGQ) : 0;
      params.datPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.datPhaiTraCongDanQDGQ) : 0;
      params.tongSoNguoiXuLyHanhChinh = isQDGQ ? Number(this.state.tongSoNguoiXuLyHanhChinh) : 0;
      params.soNguoiDaBiXuLyHanhChinh = isQDGQ ? Number(this.state.soNguoiDaBiXuLyHanhChinh) : 0;
      params.soNguoiDuocTraLaiQuyenLoi = isQDGQ ? Number(this.state.soNguoiDuocTraLaiQuyenLoi) : 0;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this10 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        if (this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
          var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this10.state.taiLieuVanThuUpdate[_this10.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this10.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this10.state.taiLieuVanThu[_this10.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this10.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
                };
              }
            });
          }

          if (this.state.dataTaiLieuVanThuDelete.length > 0) {
            this.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this10.state.taiLieuVanThuDelete[_this10.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        } else {
          var data = [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuGiaiQuyetDon));
          var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
            return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
          });

          if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
            listTaiLieuVanThuGiaiQuyetDon.map(function (item) {
              _this10.state.taiLieuVanThuDelete[_this10.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
        }

        var _params = this.getParams();
        var selectedState = this.state.dataNextStates.filter(function (state) {
          return state.type == _this10.state.nextState;
        });
        var params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.props.thongTinGiaiQuyetDonId)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          }
        };
        var msgName = '';
        if (this.state.canBoXuLyChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoXuLyChiDinh)
          };
          msgName = 'gqdGiaoViec';
        } else {
          msgName = 'gqdLuuHoSo';
        }
        if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
          params.phongBanGiaiQuyet = {
            id: Number(this.state.coQuanQuanLyNguoiDung.id)
          };
          params.phoPhong = true;
        }
        if (this.state.nextState === 'NHANTDTH_GIAO_PHONG_CUNG_CAP') {
          params.phongBanGiaiQuyet = {
            id: Number(this.state.phongBanChiDinh)
          };
        }
        if (this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
          this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
            _this10.updateTaiLieuVanThu(_this10.state.taiLieuVanThuUpdate, function () {
              _this10.deleteTaiLieuVanThu(_this10.state.taiLieuVanThuDelete, function () {
                _this10.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        } else {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, function () {
            _this10.props.updateGiaiQuyetDon(_params, params, msgName);
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this11 = this;

      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
      if (this.state.getCongChucPhongBan == true && this.state.getDetail == true && this.state.checkState == false) {
        if (this.state.dataDetail.huongThuLyGiaiQuyet == 'TU_TTXM') {
          if (this.state.nextState) {
            // do nothing
            this.setState({
              checkState: true
            });
          } else if (this.state.dataCongChuc.length == 0 || this.props.truongPhongThuHoi == true) {
            this.setState({
              nextState: 'CAN_BO_PHONG_TDTH_LUU_HO_SO',
              checkState: true
            });
          } else if (this.props.dataNextStates.length > 1) {
            this.setState({
              nextState: 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO',
              checkState: true
            });
          } else if (this.props.dataNextStates.length == 1) {
            this.setState({
              nextState: this.state.dataNextStates[0].type,
              checkState: true
            });
          }
        } else {
          if (this.state.nextState) {
            // do nothing
            this.setState({
              checkState: true
            });
          } else if (this.state.dataCongChuc.length == 0 || this.props.truongPhongThuHoi == true) {
            this.setState({
              nextState: 'CAN_BO_TDTH_LUU_DON',
              checkState: true
            }, function () {
              _this11.checkFileDinhKem();
            });
          } else if (this.props.dataNextStates.length > 1) {
            this.setState({
              // nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
              checkState: true
            });
          } else if (this.props.dataNextStates.length == 1) {
            this.setState({
              nextState: this.state.dataNextStates[0].type,
              checkState: true
            });
          }
        }
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this12 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      if (this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this12.state.taiLieuVanThuUpdate[_this12.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this12.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this12.state.taiLieuVanThu[_this12.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this12.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this12.state.taiLieuVanThuDelete[_this12.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
      } else {
        var data = [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuGiaiQuyetDon));
        var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
          return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
        });

        if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
          listTaiLieuVanThuGiaiQuyetDon.map(function (item) {
            _this12.state.taiLieuVanThuDelete[_this12.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
      }

      var params = this.getParams();
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      if (this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this12.updateTaiLieuVanThu(_this12.state.taiLieuVanThuUpdate, function () {
            _this12.deleteTaiLieuVanThu(_this12.state.taiLieuVanThuDelete, function () {
              _this12.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, function () {
          _this12.props.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      this.setState({
        dataFileDinhKem: data
      });

      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var _state = this.state,
          nextState = _state.nextState,
          dataDetail = _state.dataDetail;

      var ketLuanNDKhieuNaiLabel = this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : this.props.loaiDon == 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh";
      var labelQD = this.props.loaiDon == 'DON_TO_CAO' ? 'Quyết định giải quyết tố cáo' : this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Quyết định giải quyết khiếu nại' : 'Văn bản giải quyết kiến nghị, phản ánh';
      var dk1 = (nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && dataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        dataDetail.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: dataDetail.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: dataDetail.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: dataDetail.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: dataDetail.ngayHetHanTTXM,
          donInfo: this.props.donInfo
        }),
        dataDetail.donViGiaoThamTraXacMinhInfo != null && _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb15' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: dataDetail }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          dataDetail.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(_subView.BlockBanHanhQuyetDinhView, { donInfo: this.props.donInfo, thongTinGQD: dataDetail, dataKetLuanNoiDungKhieuNai: this.props.dataKetLuanNoiDungKhieuNai }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 mt5 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb10' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.dataCongChuc.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                className: 'col-25',
                label: 'Giao x\u1EED l\xFD',
                onRef: function onRef(select) {
                  return _this13.select = select;
                },
                onChange: this.onChange.bind(this, 'nextState'),
                selectedValue: nextState,
                data: this.state.dataNextStates,
                keyName: 'type',
                valueName: 'tenVietTat',
                require: true,
                name: 'huongXuLyTheoDoiThucHien',
                confirm: true,
                bindValidator: this }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO' },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoXuLyChiDinh,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: 'CHUYEN_VIEN',
                  bindValidator: this,
                  className: 'col-25',
                  label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt',
                  onChange: this.onChange.bind(this, 'canBoXuLyChiDinh'),
                  name: 'DropDownChonCanBoGiaiQuyet'
                }),
                _react2.default.createElement(_common.TextArea, { className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nextState == 'NHANTDTH_GIAO_PHONG_CUNG_CAP' },
                _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
                  require: true,
                  bindValidator: this,
                  selectedValue: this.state.phongBanChiDinh,
                  isValid: this.props.validate,
                  onChange: this.onChange.bind(this, 'phongBanChiDinh'),
                  name: 'dropdownChonPhongBanThuocCoQuan' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' },
                _react2.default.createElement(_ttForms.DropDownChonCanBoGiaiQuyet, {
                  isValid: this.state.validate,
                  selectedValue: this.state.canBoXuLyChiDinh,
                  require: true,
                  coQuanQuanLyId: this.state.coQuanQuanLyNguoiDung.id,
                  vaiTro: 'PHO_PHONG',
                  bindValidator: this,
                  className: 'col-25',
                  label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
                  onChange: this.onChange.bind(this, 'canBoXuLyChiDinh'),
                  name: 'DropDownChonCanBoGiaiQuyet'
                })
              )
            )
          ),
          dk1 && _react2.default.createElement(
            'h3',
            { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
            labelQD
          ),
          /*Block edit thong tin quyet dinh giai quyet*/
          dk1 && this.props.loaiDon == 'DON_KHIEU_NAI' && _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.soLanGiaiQuyetLai > 1 },
              _react2.default.createElement(_ttForms.DropDownChonKetQuaGiaiQuyet, { className: 'col-25', name: 'ketQuaGiaiQuyetLan2', require: true, bindValidator: this, label: 'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt', selectedValue: this.state.ketQuaGiaiQuyetLan2, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetLan2') })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1 },
              _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.noiDungKetLuanGiaiQuyetLai, onChange: this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai'), name: 'noiDungKetLuanGiaiQuyetLai', maxLength: 1000 })
            )
          ),
          dk1 && _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', name: 'soVu', value: this.state.soVuGiaiQuyetKhieuNai, onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai') }),
            _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.props.loaiDon, label: ketLuanNDKhieuNaiLabel, className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
            _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
          ),
          dk1 && _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
              ),
              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', name: 'tienPhaiThuNhaNuocQDGQ', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ') }),
              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'datPhaiThuNhaNuocQDGQ', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
              ),
              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', name: 'tienPhaiTraCongDanQDGQ', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ') }),
              _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', name: 'datPhaiTraCongDanQDGQ', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'X\u1EED l\xFD h\xE0nh ch\xEDnh'
              ),
              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'tongSoNguoiXuLyHanhChinh', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh') }),
              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDaBiXuLyHanhChinh', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh') }),
              _react2.default.createElement(_common.InputNumber, { className: 'col-25', name: 'soNguoiDuocTraLaiQuyenLoi', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
            )
          ),
          dk1 && _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mt5' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb15' },
                'Theo d\xF5i th\u1EF1c hi\u1EC7n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && (dataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || dataDetail.ketQuaXLDGiaiQuyet == 'DANG_TDTH') },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12' },
                  'N\u1ED9i dung Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), name: 'coQuanTheoDoi', data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac'), name: 'ketQuaThucHienKhac' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc'), name: 'tienPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc'), name: 'datPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc'), name: 'tienDaThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc'), name: 'datDaThuTheoDoiThucHien' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan'), name: 'tienPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan'), name: 'datPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan'), name: 'tienDaTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan'), name: 'datDaTraTheoDoiThucHien' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, {
                name: 'GiaoCQDT',
                label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView,
                data: this.state.listTaiLieuVanThuGiaiQuyetDon,
                onSave: this.state.onSave,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: nextState != 'CAN_BO_TDTH_LUU_DON' && nextState != 'CAN_BO_PHONG_TDTH_LUU_HO_SO' && this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !dataDetail.boSungThongTin && dataDetail.noiDungBoSungHoSo != '' && dataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(dataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: dataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: dataDetail.lanhDaoView != true && !dataDetail.boSungThongTin },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line mt10 mb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { style: { right: 0, top: 'auto' }, className: 'right btn-action btn-complete action-todo ' + (this.state.btnLoading ? this.state.btnSaveLoading ? "btn-disable" : 'btn-loading-inline' : ''), onClick: this.openDialog.bind(this, 'openDialog') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || nextState === 'NHANTDTH_GIAO_PHONG_CUNG_CAP' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { style: { right: 0, top: 'auto' }, className: 'right btn-action btn-move action-todo ' + (this.state.btnLoading ? this.state.btnSaveLoading ? "btn-disable" : 'btn-loading-inline' : ''), onClick: this.handleKetThuc.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Giao vi\u1EC7c'
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.confirm, onClose: this.closeDialog.bind(this, 'confirm'), onSuccess: this.onConfirm.bind(this), title: 'X\xE1c nh\u1EADn', content: _message.msg.confirmChange })
            )
          )
        )
      );
    }
  }]);

  return TruongPhongNhanYeuCauTheoDoiThucHien;
}(_react2.default.Component);

TruongPhongNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TruongPhongNhanYeuCauTheoDoiThucHien);

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reception = __webpack_require__(129);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingData = __webpack_require__(306);

var _LoadingData2 = _interopRequireDefault(_LoadingData);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _buttonGroup = __webpack_require__(234);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _upload = __webpack_require__(17);

var _dialog = __webpack_require__(18);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddHandleLetterOld = function (_React$Component) {
  _inherits(AddHandleLetterOld, _React$Component);

  function AddHandleLetterOld(props, context) {
    _classCallCheck(this, AddHandleLetterOld);

    var _this = _possibleConstructorReturn(this, (AddHandleLetterOld.__proto__ || Object.getPrototypeOf(AddHandleLetterOld)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      btnDisable: false,
      title: 'THÔNG TIN XỬ LÝ',
      huongXuLy: '',
      donId: _this.props.params.id ? _this.props.params.id : 0,
      alias: '',
      params: {},
      data: {},
      validate: false,
      processType: '',

      dataLoading: false,
      taskDelete: [],
      doanDongNguoi: [],
      loadingSave: false,
      thanhLapDon: false,

      nguonDon: 'BUU_CHINH',
      loaiNguoiDungDonId: 'CA_NHAN',

      listTaiLieuVanThu: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dsTaiLieuBoSungRemove: [],
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      hasChange: false,
      dsTepDinhKemInputTaiLieu: [],
      noticeMsg: '',
      openConfirmDialog: false,
      backConfirm: false,
      isSave: false,
      saveTmp: true,
      nguonDonKhac: '',
      daLayThongTinDonId: '',
      noiCapCMNDList: _this.props.noiCapCMNDList
    };
    return _this;
  }

  _createClass(AddHandleLetterOld, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch({
        type: 'RESET_FORM'
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.params && this.props.params.id) {
        this.getDonInfo(this.props.params.id);
      }
      if (this.props.noiCapCMNDList && this.props.noiCapCMNDList.length === 0) {
        _api.DuLieuHeThong.actions.getNoiCap.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'noiCapCMND',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.state;
      if (nextProps.removeDonCongDanId) {
        state.taskDelete.push({
          type: 'CONG_DAN',
          id: nextProps.removeDonCongDanId
        });
      }
      if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
        state.daLayThongTinDonId = nextProps.thongTinDon.donId;
      }
      if (nextProps.noiCapCMNDList !== this.props.noiCapCMNDList) {
        state.noiCapCMNDList = nextProps.noiCapCMNDList;
      }
      var getItem = [];
      if (nextProps.editData !== this.props.editData) {
        if (nextProps.editData && nextProps.editData.listTaiLieuVanThu && nextProps.editData.listTaiLieuVanThu.length > 0) {
          getItem = nextProps.editData.listTaiLieuVanThu.filter(function (item) {
            return item.loaiQuyTrinh === 'THONG_TIN_DON';
          });
          state.dsTepDinhKemInputTaiLieu = getItem;
        }
      } else {
        if (this.props.editData && this.props.editData.listTaiLieuVanThu && this.props.editData.listTaiLieuVanThu.length > 0) {
          getItem = this.props.editData.listTaiLieuVanThu.filter(function (item) {
            return item.loaiQuyTrinh === 'THONG_TIN_DON';
          });
          state.dsTepDinhKemInputTaiLieu = getItem;
        }
      }

      this.setState(state);
    }
  }, {
    key: 'onChangeData',
    value: function onChangeData(data, resetTepDinhKem) {
      var _this3 = this;

      var checkDataBaoCao = '';
      var checkDataQuyetDinh = '';
      var checkDataBoSung = '';
      var loaiDon = data && data.thongTinDon && data.thongTinDon.loaiDonId;
      if (loaiDon === 'DON_TO_CAO') {
        checkDataBaoCao = 'Báo cáo kết quả xác minh nội dung tố cáo';
        checkDataQuyetDinh = 'Văn bản kết luận, giải quyết tố cáo';
        checkDataBoSung = 'Thông báo kết quả giải quyết tố cáo';
      } else if (loaiDon === 'DON_KHIEU_NAI') {
        checkDataBaoCao = 'Báo cáo kết quả xác minh nội dung khiếu nại';
        checkDataQuyetDinh = 'Quyết định giải quyết khiếu nại';
      } else if (loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
        checkDataBaoCao = 'Văn bản xác minh đề xuất';
        checkDataQuyetDinh = 'Văn bản giải quyết kiến nghị, phản ánh';
      } else if (loaiDon === 'DON_TRANH_CHAP_DAT') {
        checkDataBaoCao = 'Báo cáo xác minh';
        checkDataQuyetDinh = 'Văn bản giải quyết';
      }
      this.setState(_extends({}, data, {
        hasChange: true
      }));
      if (!resetTepDinhKem) {
        if (loaiDon === '') {
          this.setState({
            dsTepDinhKemInputTaiLieu: []
          }, function () {
            _this3.onFileChange(_this3.state.dsTepDinhKemInputTaiLieu);
          });
        }
        if (loaiDon === 'DON_TO_CAO') {
          this.setState({
            dsTepDinhKemInputTaiLieu: [{
              taiLieuVanThuId: '',
              ten: checkDataBoSung,
              required: false,
              checkValid: true,
              resetRequired: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }, {
              taiLieuVanThuId: '',
              ten: checkDataBaoCao,
              required: false,
              tenFile: '',
              checkValid: true,
              tenFileds: '',
              resetRequired: true,
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }, {
              taiLieuVanThuId: '',
              ten: checkDataQuyetDinh,
              required: false,
              checkValid: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              resetRequired: true,
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }]
          }, function () {
            _this3.onFileChange(_this3.state.dsTepDinhKemInputTaiLieu);
          });
        }
        if (loaiDon === 'DON_KHIEU_NAI' || loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || loaiDon === 'DON_TRANH_CHAP_DAT') {
          this.setState({
            dsTepDinhKemInputTaiLieu: [{
              taiLieuVanThuId: '',
              ten: checkDataQuyetDinh,
              required: false,
              checkValid: true,
              resetRequired: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }, {
              taiLieuVanThuId: '',
              ten: checkDataBaoCao,
              required: false,
              checkValid: true,
              tenFile: '',
              tenFileds: '',
              resetRequired: true,
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }]
          }, function () {
            _this3.onFileChange(_this3.state.dsTepDinhKemInputTaiLieu);
          });
        }
      }
    }
  }, {
    key: 'removeListTaiLieuVanThu',
    value: function removeListTaiLieuVanThu(data) {
      data.forEach(function (item) {
        _api.Reception.actions.deleteTepDinhKem.request({
          id: item.taiLieuVanThuId
        });
      });
    }
  }, {
    key: 'onInitComponent',
    value: function onInitComponent(data) {
      var newData = _extends({}, data);
      this.setState(_extends({}, newData));
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'hasChange', true), _setState));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var state = this.state;
      state[e.target.name] = e.target.value;
      state.hasChange = true;
      this.setState(state);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var state = this.state;
      if (typeof e.format === 'function') {
        state[name] = e.format(_config.DateFormat);
      } else {
        state[name] = e;
      }
      state.hasChange = true;
      this.setState(state);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(name, data) {
      var state = this.state;
      if (name === 'DOAN_DI_CUNG' && data.doanDiCungId) {
        state.taskDelete.push({
          type: 'DOAN_DI_CUNG',
          id: data.doanDiCungId
        });
      } else if (name === 'CONG_DAN' && data.donCongDanId) {
        state.taskDelete.push({
          type: 'CONG_DAN',
          id: data.donCongDanId
        });
      } else if (name === 'BANG_CHUNG' && data.taiLieuBangChungId) {
        state.taskDelete.push({
          type: 'BANG_CHUNG',
          id: data.taiLieuBangChungId
        });
      } else if (name === 'TEP_DINH_KEM' && data.taiLieuVanThuId) {
        state.taskDelete.push({
          type: 'TEP_DINH_KEM',
          id: data.taiLieuVanThuId
        });
      }
      state.hasChange = true;
      this.setState(state);
    }
  }, {
    key: 'phanLoaiDonCongDan',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(donId, onlySave) {
        var _this4 = this;

        var state, plusData, AddNewDCDList, UpdateDCDList, AddNewTLList, UpdateTLList, AddNewDDCList, UpdateDDCList, nddData, donCdData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = this.state;
                plusData = {};
                AddNewDCDList = [];
                UpdateDCDList = [];
                AddNewTLList = [];
                UpdateTLList = [];
                AddNewDDCList = [];
                UpdateDDCList = [];


                if (state.loaiNguoiDungDonId === 'CO_QUAN_TO_CHUC') {
                  plusData = {
                    tenCoQuan: state.tenCoQuan,
                    diaChiCoQuan: state.diaChiCoQuan,
                    soDienThoaiCoQuan: state.soDienThoai
                  };
                }

                if (this.props.nguoiDungDon) {
                  this.props.nguoiDungDon.forEach(function (item, i) {
                    if (item.hoVaTen) {
                      var nddData = _this4.createCongDan(item, 'NGUOI_DUNG_DON');
                      var donCdData = _this4.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
                      if (donCdData.id) {
                        UpdateDCDList.push(donCdData);
                      } else {
                        AddNewDCDList.push(donCdData);
                      }
                    }
                  });
                }

                state.doanDongNguoi.forEach(function (item, i) {
                  if (item.hoVaTen) {
                    var ddcData = _this4.createItemDoanDiCung(item, donId);
                    if (ddcData.id) {
                      UpdateDDCList.push(ddcData);
                    } else {
                      AddNewDDCList.push(ddcData);
                    }
                  }
                });
                this.createDSTepDinhKem(donId, state.dsTepDinhKem);
                if (state.flagUyQuyen) {
                  if (state.uyQuyen && state.uyQuyen.flagLuatSu) {
                    plusData.luatSu = state.uyQuyen.flagLuatSu;
                    if (state.uyQuyen.luatSu.soTheLuatSu) {
                      plusData.soTheLuatSu = state.uyQuyen.luatSu.soTheLuatSu;
                    }
                    if (state.uyQuyen.luatSu.ngayCapTheLuatSu) {
                      plusData.ngayCapTheLuatSu = (0, _moment2.default)(state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
                    }
                    if (state.uyQuyen.luatSu.noiCapTheLuatSu) {
                      plusData.noiCapTheLuatSu = state.uyQuyen.luatSu.noiCapTheLuatSu;
                    }
                    if (state.uyQuyen.luatSu.thongTinGioiThieu) {
                      plusData.thongTinGioiThieu = state.uyQuyen.luatSu.thongTinGioiThieu;
                    }
                    if (state.uyQuyen && state.uyQuyen.luatSu && state.uyQuyen.luatSu.dsGiayUyQuyen) {
                      state.uyQuyen.luatSu.dsGiayUyQuyen.forEach(function (item, i) {
                        var tlParams = _this4.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
                        if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
                      });
                    }
                  } else {
                    plusData.luatSu = false;
                  }
                  nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
                  donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');

                  if (donCdData.id) UpdateDCDList.push(donCdData);else AddNewDCDList.push(donCdData);
                }

                if (state.thongTinDon && state.thongTinDon.dsBangChung) {
                  state.thongTinDon.dsBangChung.forEach(function (item, i) {
                    var tlParams = _this4.createTaiLieuBangChung(item, donId);
                    if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
                  });
                }

                if (!AddNewDCDList.length) {
                  _context.next = 17;
                  break;
                }

                _context.next = 17;
                return _api.Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(function () {
                  _this4.onClickClose();
                });

              case 17:
                if (!UpdateDCDList.length) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return _api.Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(function () {
                  _this4.onClickClose();
                });

              case 20:

                if (AddNewTLList.length) {
                  _api.Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
                }
                if (UpdateTLList.length) {
                  _api.Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
                }
                if (AddNewDDCList.length) {
                  _api.Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
                }
                if (UpdateDDCList.length) {
                  _api.Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
                }

                this.setState(state);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function phanLoaiDonCongDan(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return phanLoaiDonCongDan;
    }()
  }, {
    key: 'createTaiLieuBangChung',
    value: function createTaiLieuBangChung(item, donID, stcdId) {
      var buocGQ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'TAI_LIEU_KEM_THEO';

      var params = {
        donCu: {
          id: donID
        },
        buocGiaiQuyet: buocGQ
      };
      if (item.ten) {
        params.ten = item.ten;
        params.tenFileds = item.ten;
      }
      if (item.tinhTrang) {
        params.tinhTrangTaiLieu = item.tinhTrang;
      }
      if (item.tenFile) {
        params.tenFile = item.tenFile;
      }
      if (item.duongDan) {
        params.duongDan = item.duongDan;
      }
      if (item.required) {
        params.required = true;
      }
      if (stcdId) {
        params.soTiepCongDan = {
          id: stcdId
        };
      }
      if (item.taiLieuBangChungId) {
        params.id = item.taiLieuBangChungId;
      }
      return params;
    }
  }, {
    key: 'createDonCongDan',
    value: function createDonCongDan(cdData, donID, plusData, loaiCD) {
      var param = {
        phanLoaiCongDan: loaiCD,
        donCu: {
          id: donID
        }
      };
      if (cdData) {
        param = Object.assign(param, cdData);
      }
      if (plusData) {
        param = Object.assign(param, plusData);
      }
      return param;
    }
  }, {
    key: 'createItemDoanDiCung',
    value: function createItemDoanDiCung(data, donId) {
      var params = {
        hoVaTen: data.hoVaTen,
        donCu: {
          id: donId
        }
      };
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.cmndHoChieu) {
        params.cmndHoChieu = data.cmndHoChieu;
      }
      if (data.doanDiCungId) {
        params.id = data.doanDiCungId;
      }
      return params;
    }
  }, {
    key: 'createCongDan',
    value: function createCongDan(data, type) {
      var params = {
        hoVaTen: data.hoVaTen
      };
      if (data.tinhThanhId) {
        params.tinhThanh = {
          id: data.tinhThanhId
        };
      }
      if (data.quanHuyenId) {
        params.quanHuyen = {
          id: data.quanHuyenId
        };
      }
      if (data.phuongXaId) {
        params.phuongXa = {
          id: data.phuongXaId
        };
      }
      if (data.toThon) {
        params.toThon = data.toThon;
      }
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.soCMNDHoChieu) {
        params.soCMNDHoChieu = data.soCMNDHoChieu;
      }
      if (data.noiCap) {
        params.noiCapCMND = {
          id: data.noiCap.value
        };
      }
      if (data.ngaySinh) {
        params.ngaySinh = (0, _moment2.default)(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.ngayCap) {
        params.ngayCap = (0, _moment2.default)(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.gioiTinh) {
        params.gioiTinh = data.gioiTinh === 'male' ? true : false;
      }
      if (data.quocTichId) {
        params.quocTich = {
          id: data.quocTichId
        };
      }
      if (data.danTocId) {
        params.danToc = {
          id: data.danTocId
        };
      }
      if (data.donCongDanId) {
        params.id = data.donCongDanId;
      }
      if (data.congDanId && type !== 'NGUOI_DUOC_UY_QUYEN') {
        params.congDan = {
          id: data.congDanId
        };
      }
      return params;
    }
  }, {
    key: 'runDeleteTask',
    value: function runDeleteTask() {
      var ddnParams = [];
      this.state.taskDelete.forEach(function (item, i) {
        if (item.type === 'CONG_DAN') {
          _api.Reception.actions.deleteDonCongDan.request({
            id: item.id
          });
        } else if (item.type === 'DOAN_DI_CUNG') {
          ddnParams.push({
            id: item.id
          });
        }
      });
      if (this.state.thongTinDon && this.state.thongTinDon.dsBangChungRemove) {
        this.state.thongTinDon.dsBangChungRemove.forEach(function (item) {
          _api.Reception.actions.deleteTaiLieuBangChung.request({
            id: item
          });
        });
      }
      if (this.state.dsTepDinhKemRemove) {
        this.state.dsTepDinhKemRemove.forEach(function (item) {
          _api.Reception.actions.deleteTepDinhKem.request({
            id: item
          });
        });
      }
      if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
        this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.forEach(function (item) {
          _api.Reception.actions.deleteTaiLieuBangChung.request({
            id: item
          });
        });
      }

      if (ddnParams.length) {
        _api.Reception.actions.deleteDoanDiCungMulti.request(null, {
          doanDiCungs: ddnParams
        });
      }
    }
  }, {
    key: 'createDon',
    value: function createDon(onlySave) {
      var _this5 = this;

      if (this.validateSubmitForm()) {
        this.setState({ isSave: onlySave }, function () {
          _this5.setState({
            btnSaving: onlySave,
            btnLoading: true,
            btnSaveLoading: true
          });
          var params = {
            coUyQuyen: _this5.state.flagUyQuyen,
            noiDung: _this5.state.thongTinDon.noiDung,
            loaiVuViec: _this5.state.thongTinDon.loaiVuViecId,
            nguonTiepNhanDon: _this5.state.nguonDon || null,
            loaiNguoiDungDon: _this5.state.loaiNguoiDungDonId,
            thanhLapDon: true,
            canBoXuLy: { id: _this5.props.userInfo.id },
            soNguoi: _this5.props.nguoiDungDon.length
          };

          if (_this5.state.daLayThongTinDonId) {
            params.daLayThongTinDonId = _this5.state.daLayThongTinDonId;
          }

          if (_this5.state.nguonDon === 'KHAC') {
            params.nguonDonKhac = _this5.state.nguonDonKhac;
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'loaiDoiTuongId')) {
            params.loaiDoiTuong = (0, _lodash.get)(_this5.state.thongTinDon, 'loaiDoiTuongId');
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'loaiDonId')) {
            params.loaiDon = (0, _lodash.get)(_this5.state.thongTinDon, 'loaiDonId');
          }

          if (!_this5.state.saveTmp) {
            params.saveTmp = _this5.state.saveTmp;
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'layVuViecCu')) {
            params.layVuViecCu = (0, _lodash.get)(_this5.state.thongTinDon, 'layVuViecCu');
          }

          if (_this5.state.loaiNguoiDungDonId === 'DOAN_DONG_NGUOI') {
            params.soNguoi = _this5.state.soNguoi;
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'linhVucCap1Id')) {
            params.linhVucDonThu = { id: (0, _lodash.get)(_this5.state.thongTinDon, 'linhVucCap1Id') };
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'linhVucCap2Id')) {
            params.linhVucDonThuChiTiet = { id: (0, _lodash.get)(_this5.state.thongTinDon, 'linhVucCap2Id') };
          }
          if ((0, _lodash.get)(_this5.state.thongTinDon, 'linhVucChiTietKhac')) {
            params.linhVucChiTietKhac = (0, _lodash.get)(_this5.state.thongTinDon, 'linhVucChiTietKhac');
          }

          if ((0, _lodash.get)(_this5.state.thongTinDon, 'flagCQDaGiaiQuyet')) {
            if ((0, _lodash.get)(_this5.state.thongTinDon, 'coQuanDaGiaiQuyetDonThu')) {
              params.coQuanDaGiaiQuyetDonThu = (0, _lodash.get)(_this5.state.thongTinDon, 'coQuanDaGiaiQuyetDonThu');
            }
            if ((0, _lodash.get)(_this5.state.thongTinDon, 'soVanBan')) {
              params.soVanBanDaGiaiQuyet = (0, _lodash.get)(_this5.state.thongTinDon, 'soVanBan');
            }
            if ((0, _lodash.get)(_this5.state.thongTinDon, 'ngayBanHanh')) {
              params.ngayBanHanhVanBanDaGiaiQuyet = (0, _moment2.default)((0, _lodash.get)(_this5.state.thongTinDon, 'ngayBanHanh'), 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }
          }
          if (_this5.props.editData && (0, _lodash.get)(_this5.props.editData, 'listTaiLieuVanThu') && JSON.stringify(_this5.state.dsTepDinhKemInputTaiLieu) !== JSON.stringify((0, _lodash.get)(_this5.props.editData, 'listTaiLieuVanThu'))) {
            _this5.removeListTaiLieuVanThu((0, _lodash.get)(_this5.props.editData, 'listTaiLieuVanThu'));
          }
          _this5.runDeleteTask();
          if ((0, _lodash.get)(_this5.props.params, 'id') !== undefined) {
            return _api.Reception.actions.updateDonCu.request({ id: (0, _lodash.get)(_this5.props.params, 'id') }, params).then(function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if ((0, _lodash.isEmpty)(res.data)) {
                          _context2.next = 9;
                          break;
                        }

                        _context2.next = 3;
                        return _this5.setState({ donId: res.data.donCuId });

                      case 3:
                        _context2.next = 5;
                        return _this5.phanLoaiDonCongDan(res.data.donCuId, onlySave);

                      case 5:
                        _context2.next = 7;
                        return (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');

                      case 7:
                        _context2.next = 9;
                        return _this5.onClickClose();

                      case 9:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this5);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()).catch(function (error) {
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              }
              _this5.setState({ loadingSave: false });
            });
          }
          return _api.Reception.actions.postDonCu.request(null, params).then(function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if ((0, _lodash.isEmpty)(res.data)) {
                        _context3.next = 9;
                        break;
                      }

                      _context3.next = 3;
                      return _this5.setState({ donId: res.data.donCuId });

                    case 3:
                      _context3.next = 5;
                      return _this5.phanLoaiDonCongDan(res.data.donCuId, onlySave);

                    case 5:
                      _context3.next = 7;
                      return (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');

                    case 7:
                      _context3.next = 9;
                      return _this5.onClickClose();

                    case 9:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, _this5);
            }));

            return function (_x5) {
              return _ref3.apply(this, arguments);
            };
          }()).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this5.setState({ loadingSave: false });
          });
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].forEach(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
        if (!validator.validate() && (0, _lodash.get)(validator, 'props.checkValid')) {
          pass = true;
        }
      });
      return pass;
    }

    /* XULYDON */

  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.push('/xu-ly-don-cu');
    }
  }, {
    key: 'handleDataForm',
    value: function handleDataForm(state) {

      var noticeMsg = state.notice;
      delete state.messege;
      this.state.params = state;
      this.state.noticeMsg = noticeMsg;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'getMoreDonInfo',
    value: function getMoreDonInfo(donData) {
      var _this6 = this;

      var newState = this.state;
      _api.Reception.actions.getDonCuInfo.request({ id: donData.donCuId }).then(function (res) {
        if (res.data) {
          donData = _extends({}, donData, res.data);
        }
        newState.listTaiLieuVanThu = donData.listTaiLieuVanThu;

        var info = donData;
        newState.nguonDon = info.nguonDonInfo.giaTri;
        info.listNguoiDungDon.forEach(function (item, i) {
          _this6.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: item,
            donCongDanId: item.donCongDanId,
            index: i
          });
        });

        if (info.coUyQuyen) {
          _this6.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: info.nguoiDuocUyQuyen,
            donCongDanId: info.nguoiDuocUyQuyen.donCongDanId,
            index: -1
          });
        }
        newState.donId = info.donId;
        newState.loaiNguoiDungDonId = info.loaiNguoiDungDon;

        _this6.props.dispatch({
          type: 'INIT_EDIT_FORM',
          data: donData
        });
      });
      this.setState(newState);
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(donId) {
      var _this7 = this;

      _api.LetterProcessingWorkFlow.actions.getDonCuDetail.request({ id: donId }).then(function (res) {
        if (res.data) {
          _this7.getMoreDonInfo(res.data);
        }
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        return _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      }
      return callback();
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        return _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      }
      return callback();
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        return _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      }
      return callback();
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(donId, data) {
      var listAddNew = [];
      var listUpdate = [];

      data.forEach(function (item, i) {
        var params = {
          donCu: { id: donId },
          loaiQuyTrinh: 'THONG_TIN_DON',
          loaiTepDinhKem: 'QUYET_DINH'
        };
        if (item.ten) {
          params.ten = item.ten;
          params.tenFileds = item.ten;
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (item.typeRequired) {
          params.typeRequired = item.typeRequired;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
        }
        if (item.taiLieuVanThuId) {
          params.id = item.taiLieuVanThuId;
          listUpdate.push(params);
        } else {
          listAddNew.push(params);
        }
      });

      if (listAddNew.length) {
        _api.Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
      if (listUpdate.length) {
        _api.Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
      }
    }
  }, {
    key: 'saveTepDinhKem',
    value: function saveTepDinhKem(donId, callback) {
      var _this8 = this;

      if (this.state.dataFileDinhKem && this.state.dataFileDinhKem.length > 0) {
        this.state.dataFileDinhKem.forEach(function (item, i) {
          if (item.taiLieuVanThuId && _this8.state.taiLieuVanThuUpdate) {
            _this8.state.taiLieuVanThuUpdate[_this8.state.taiLieuVanThuUpdate.length] = {
              donCu: {
                id: Number(donId)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              tenFileds: item.ten,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else if (_this8.state.taiLieuVanThu) {
            _this8.state.taiLieuVanThu[_this8.state.taiLieuVanThu.length] = {
              donCu: {
                id: Number(donId)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              tenFileds: item.ten,
              duongDan: item.duongDan,
              loaiTepDinhKem: _this8.state.loaiTepDinhKem,
              loaiQuyTrinh: _this8.state.loaiQuyTrinh,
              buocGiaiQuyet: null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }
      if (this.state.dataTaiLieuVanThuDelete && this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.forEach(function (item) {
          _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
        _this8.updateTaiLieuVanThu(_this8.state.taiLieuVanThuUpdate, function () {
          _this8.deleteTaiLieuVanThu(_this8.state.taiLieuVanThuDelete, function () {
            callback();
          });
        });
      });
    }
  }, {
    key: 'onChangeTepDinhKem',
    value: function onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
      this.setState({
        loaiQuyTrinh: loaiQuyTrinh,
        loaiTepDinhKem: loaiTepDinhKem,
        dataFileDinhKem: tepDinhKem,
        dataTaiLieuVanThuDelete: deleteTepDinhKem
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      var state = this.state;
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (state.hasChange) {
          state.backConfirm = true;
          this.setState(state);
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      var state = this.state;
      state.backConfirm = false;
      this.setState(state);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      var state = this.state;
      if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
        state.dsTaiLieuBoSungRemove = [].concat(_toConsumableArray(state.dsTaiLieuBoSungRemove), [id]);
        state.dsTaiLieuBoSung = data;
      } else {
        state.dsTepDinhKemRemove = [].concat(_toConsumableArray(state.dsTepDinhKemRemove), [id]);
        state.dsTepDinhKem = data;
      }
      this.setState(state);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      var state = this.state;
      if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
        state.dsTaiLieuBoSung = data;
      } else {
        state.dsTepDinhKem = data;
      }
      this.setState(state);
    }
  }, {
    key: 'handleInitDataForm',
    value: function handleInitDataForm(state) {
      this.setState({
        params: state
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var valid = function valid(current) {
        return current.isBefore((0, _moment2.default)());
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reception.SearchFullNamePopup, { self: this.state }),
        _react2.default.createElement(_reception.ListInfoDocumentDialog, { self: this.state, checkDSDC: true }),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { id: 'page', className: 'add-reception panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleBack.bind(this, false), title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-add' },
                this.props.params.type == 'them-moi' ? 'THÊM MỚI ĐƠN/ VỤ VIỆC' : '',
                this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA ĐƠN/ VỤ VIỆC' : ''
              )
            ),
            this.state.dataLoading ? _react2.default.createElement(_LoadingData2.default, null) : _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'form',
                { className: 'form' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward ' },
                      _react2.default.createElement(
                        'div',
                        { className: 'container-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form' },
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10 box-top' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(_ttForms.DropDownChonNguonDon, {
                                  selectedValue: this.state.nguonDon,
                                  bindValidator: this,
                                  exceptNguonDon: 'GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH',
                                  onChange: this.onChange.bind(this, 'nguonDon'),
                                  className: 'col-input mb0-18'
                                }),
                                this.state.nguonDon == 'KHAC' && _react2.default.createElement(_common.Input, { className: 'col-input mb0-18 mt21', name: 'nguonDonKhac', placeholder: 'Nh\u1EADp ngu\u1ED3n \u0111\u01A1n kh\xE1c...', maxLength: 255, value: this.state.nguonDonKhac, onChange: this.onChange.bind(this, 'nguonDonKhac') })
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_reception.ThongTinNguoiDungDon, {
                    onChange: this.onChangeData.bind(this),
                    onInit: this.onInitComponent.bind(this),
                    bindValidator: this,
                    isDonCu: true,
                    onSave: this.state.isSave,
                    onRemove: this.handleRemove.bind(this) }),
                  _react2.default.createElement(_reception.ThongTinDon, {
                    onChange: this.onChangeData.bind(this),
                    onInit: this.onInitComponent.bind(this),
                    onSave: this.state.isSave,
                    bindValidator: this,
                    isDonCu: true,
                    isKiemTraTCD: false
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items' },
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form pldoncu prdoncu' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows box-top' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.dsTepDinhKemInputTaiLieu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), name: 'fileDinhKemTraDon', onSave: this.props.onSave })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt30 mb30' },
                  _react2.default.createElement(_buttonGroup2.default, {
                    alias: 'DONCU',
                    donId: this.state.donId,
                    params: this.state.params,
                    processType: 'XULYDONCU',
                    onClose: this.handleBack.bind(this, false),
                    onSave: this.createDon.bind(this, true),
                    btnLoading: this.state.btnLoading,
                    btnSaveLoading: this.state.btnSaveLoading,
                    onClickSaveFile: this.saveTepDinhKem.bind(this),
                    onChange: this.handleDataForm.bind(this),
                    onInit: this.handleInitDataForm.bind(this),
                    validate: this.state.validate,
                    validateSubmitForm: this.validateSubmitForm.bind(this),
                    bindValidator: this,
                    trangThaiDonDonVi: {},
                    btnSaving: this.state.btnSaving
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddHandleLetterOld;
}(_react2.default.Component);

AddHandleLetterOld.defaultProps = {
  validators: {},
  noiCapCMNDList: []
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    noiCapCMNDList: state.duLieuHeThong.noiCapCMND,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId,
    editData: state.formDataTiepCongDan.editData,
    onSave: false
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(AddHandleLetterOld);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddHandleLetterOld = undefined;

var _AddHandleLetterOld = __webpack_require__(1144);

var _AddHandleLetterOld2 = _interopRequireDefault(_AddHandleLetterOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddHandleLetterOld = _AddHandleLetterOld2.default;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _CheckPermission = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListHandleOldLetters = function (_React$Component) {
  _inherits(RowItemListHandleOldLetters, _React$Component);

  function RowItemListHandleOldLetters(props, context) {
    _classCallCheck(this, RowItemListHandleOldLetters);

    var _this = _possibleConstructorReturn(this, (RowItemListHandleOldLetters.__proto__ || Object.getPrototypeOf(RowItemListHandleOldLetters)).call(this, props, context));

    _this.state = {
      type: _this.props.type
    };
    return _this;
  }

  _createClass(RowItemListHandleOldLetters, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.type && this.props.type !== nextProps.type) {
        this.setState({ type: nextProps.type });
      }
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = '';
      if (this.props.item && this.props.item.listNguoiDungDon && this.props.item.listNguoiDungDon.length) {
        size = this.props.item.listNguoiDungDon.length;
      }
      if (!size) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'li',
          { className: 'txt-bold' },
          this.props.item.listNguoiDungDon[0].hoVaTen
        ),
        _react2.default.createElement(
          'li',
          null,
          this.getLocal(this.props.item.listNguoiDungDon[0])
        ),
        _react2.default.createElement(
          'li',
          null,
          this.props.item.listNguoiDungDon[0].soDienThoai
        )
      );
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDontype = '';
      var result = '';
      if (this.props.item && this.props.item.nguonDonInfo) {
        var dataNguonDon = this.props.item.nguonDonInfo;
        nguonDonText = dataNguonDon.ten;
        nguonDontype = dataNguonDon.type;
      }
      if (type === 'nguonDonText') {
        result = nguonDonText;
      }
      if (type === 'nguonDontype') {
        result = nguonDontype;
      }
      return result;
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      if (data) {
        if (data.diaChi) {
          address.push(data.diaChi);
        }
        if (data.toThon) {
          address.push(data.toThon);
        }
        if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
          address.push(data.phuongXaCongDan.ten);
        }
        if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
          address.push(data.quanHuyenCongDan.ten);
        }
        if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
          address.push(data.tinhThanhCongDan.ten);
        }
      }
      return address.join(", ");
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.item;
      if (!data) {
        return null;
      }
      var donId = data.donCuId;
      var linkToDetailPage = '/chi-tiet-don-cu/' + donId;
      var linkToProcessPage = '';
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDontype = this.checkNguonDon('nguonDontype');
      var types = ['TRUC_TIEP', 'CHUYEN_DON', 'GIAO_TTXM', 'GIAO_KTDX', 'GIAO_TDTH'];
      if (!types.includes(nguonDontype) && !data.trinhLanhDao) {
        linkToProcessPage = '/xu-ly-don-cu/chinh-sua/' + donId;
      }
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var showDelete = data.donViXuLyGiaiQuyetInfo && userInfo.donViId === data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId;
      var loaiThongTinDonInfo = this.props.item.loaiThongTinDonInfo;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: linkToDetailPage },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(loaiThongTinDonInfo, 'ten')
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('DONCU_SUA') },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: linkToProcessPage },
                  'Ch\u1EC9nh s\u1EEDa'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('DONCU_XOA') && showDelete },
              _react2.default.createElement(_dialog.DeleteDialog, {
                title: 'Xoá đơn thư',
                content: 'Bạn có đồng ý xóa đơn thư này không?',
                redux: this.props.parent,
                deleteId: this.props.item.donCuId
              })
            )
          )
        )
      );
    }
  }]);

  return RowItemListHandleOldLetters;
}(_react2.default.Component);

RowItemListHandleOldLetters.defaultProps = {
  dataLoaiDonThu: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemListHandleOldLetters);

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListHandleOldLetters = undefined;

var _RowItemListHandleOldLetters = __webpack_require__(1146);

var _RowItemListHandleOldLetters2 = _interopRequireDefault(_RowItemListHandleOldLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemListHandleOldLetters = _RowItemListHandleOldLetters2.default;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _letterHistory = __webpack_require__(236);

var _letterHistory2 = _interopRequireDefault(_letterHistory);

var _letterInformation = __webpack_require__(485);

var _letterInformation2 = _interopRequireDefault(_letterInformation);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _buttonGroup = __webpack_require__(234);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _CheckPermission = __webpack_require__(20);

var _GetTrangThaiDonTheoDonVi = __webpack_require__(314);

var _subView = __webpack_require__(33);

var _CheckQuyenTuXuLy = __webpack_require__(193);

var _dialog = __webpack_require__(18);

var _giaiQuyetDon = __webpack_require__(142);

var _layout = __webpack_require__(9);

var _loading = __webpack_require__(313);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLettersOldDetails = function (_React$Component) {
  _inherits(HandleLettersOldDetails, _React$Component);

  function HandleLettersOldDetails(props, context) {
    _classCallCheck(this, HandleLettersOldDetails);

    var _this = _possibleConstructorReturn(this, (HandleLettersOldDetails.__proto__ || Object.getPrototypeOf(HandleLettersOldDetails)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      pageLoading: false,
      // URL param
      typePage: _this.props.params.typePage,

      donId: _this.props.params.id,
      alias: '',
      params: [],
      data: [],
      processTypeValue: '',

      // Thong tin nguoi dung don
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],

      // Thong tin nguoi duoc uy quyen
      coUyQuyen: false,
      dataNguoiDuocUyQuyen: [],
      listTepUyQuyen: [],
      luatSu: false,
      listTepChungChiHanhNghe: [],

      // ThongTinDonVuViec
      nguonDon: '',
      noiDung: '',
      loaiDon: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      linhVucChiTietKhac: '',
      // Tai lieu kem theo
      listTaiLieuVanThu: [],
      listTaiLieuBangChung: [],

      // Thong tin co quan dang giai quyet
      coThongTinCoQuanDangGiaiQuyet: false,
      dataCoQuanDangGiaiQuyet: {},

      // Thong tin co quan da giai quyet
      coThongTinCoQuanDaGiaiQuyet: false,
      dataCoQuanDaGiaiQuyet: {},
      lanhDaoDuyet: true,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      initTaiLieuVanThu: [],

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',
      noticeMsg: '',
      backConfirm: false,
      hasChange: false
    };
    return _this;
  }

  _createClass(HandleLettersOldDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetail(this.props.params.id);
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }

    // Gan du lieu xu ly don hoac giai quyet don

  }, {
    key: 'handleDataForm',
    value: function handleDataForm(state) {
      var noticeMsg = state.notice;
      delete state.messege;

      this.setState({
        params: state,
        noticeMsg: noticeMsg,
        hasChange: true
      });
    }
  }, {
    key: 'getDonInfo',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(donData) {
        var state;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = this.state;
                _context.next = 3;
                return _api.Reception.actions.getDonCuInfo.request({ id: donData.donCuId }).then(function (res) {
                  if (res.data) {
                    donData = _extends({}, donData, res.data);
                  }
                  state.data = donData;
                  // Thong tin nguoi dung don
                  state.loaiNguoiDungDon = donData.loaiNguoiDungDon ? donData.loaiNguoiDungDon : '';
                  state.dataNguoiDungDon = donData.listNguoiDungDon ? donData.listNguoiDungDon : [];
                  state.dataDoanDiCung = donData.loaiNguoiDungDon === 'DOAN_DONG_NGUOI' ? donData.listDoanDiCung ? donData.listDoanDiCung : [] : [];
                  //
                  // Thong tin nguoi duoc uy quyen
                  state.coUyQuyen = donData.coUyQuyen;
                  state.dataNguoiDuocUyQuyen = donData.coUyQuyen ? donData.nguoiDuocUyQuyen : [];
                  //
                  state.luatSu = donData.coUyQuyen && donData.nguoiDuocUyQuyen ? donData.nguoiDuocUyQuyen.luatSu : false;

                  // ThongTinDonVuViec
                  state.loaiDonGiaTri = donData.loaiDon ? donData.loaiDon : '';
                  state.nguonDon = donData.nguonDonText ? donData.nguonDonText : '';
                  state.noiDung = donData.noiDung ? donData.noiDung : '';
                  state.loaiDon = donData.loaiDonInfo && donData.loaiDonInfo.ten ? donData.loaiDonInfo.ten : '';
                  state.loaiDoiTuong = donData.loaiDoiTuongInfo ? donData.loaiDoiTuongInfo : '';
                  state.linhVuc = donData.linhVucDonThuDon ? donData.linhVucDonThuDon.ten : '';
                  state.linhVucChiTiet = donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon ? donData.linhVucDonThuChiTietDon.ten : '';
                  state.linhVucChiTietSub = donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon && donData.chiTietLinhVucDonThuChiTietDon ? donData.chiTietLinhVucDonThuChiTietDon.ten : '';
                  state.linhVucChiTietKhac = donData.linhVucChiTietKhac ? donData.linhVucChiTietKhac : '';
                  // Tai lieu kem theo
                  // HuongXuLy.jsx
                  state.listTaiLieuVanThu = donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [];
                  state.initTaiLieuVanThu = donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [];

                  state.listTaiLieuBangChung = [].concat(_toConsumableArray(donData.listTaiLieuBangChung), _toConsumableArray(donData.listTaiLieuBangChungLuatSu));

                  state.listTaiLieuVanThuBoSungHoSo = donData.listTaiLieuVanThuBoSungHoSo ? donData.listTaiLieuVanThuBoSungHoSo : [];

                  state.pageLoading = false;
                }).catch(function (e) {
                  state.pageLoading = false;
                });

              case 3:
                this.setState(state);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDonInfo(_x) {
        return _ref.apply(this, arguments);
      }

      return getDonInfo;
    }()
  }, {
    key: 'getDetail',
    value: function getDetail(inputId) {
      var _this2 = this;

      this.setState({ pageLoading: true });
      _api.Letter.actions.getDonCuDetail.request({ id: inputId }).then(function (res) {
        if (res.data) {
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _this2.getDonInfo(res.data);
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (typeof this.props.validators['formTaoDon'] != 'undefined') {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else {
            validator.validate();
          }
        });
      }

      return pass;
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      var state = this.state;
      if (allowBack) {
        this.onClickClose();
      } else {
        if (state.hasChange) {
          state.backConfirm = true;
        } else {
          this.onClickClose();
        }
      }
      this.setState(state);
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({ backConfirm: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { id: 'page', className: 'panel-page document-detail-page' },
            _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true), title: _message.msg.confirmBack }),
            this.state.pageLoading && _react2.default.createElement(_loading.Loading, null),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('center', { 'hidden': this.state.pageLoading }) },
              _react2.default.createElement(
                'div',
                { className: 'back-foward' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.handleBack.bind(this, false), title: '' },
                  'V\u1EC1 trang tr\u01B0\u1EDBc'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'heading' },
                _react2.default.createElement(
                  'h2',
                  { className: 'heading-title icon-detail' },
                  'Chi ti\u1EBFt \u0111\u01A1n/ v\u1EE5 vi\u1EC7c'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'page-wrapper' },
                _react2.default.createElement(_letterInformation2.default, {
                  checkXLDC: true,
                  parent: this.state,
                  donId: this.state.donId,
                  typePage: this.state.typePage,
                  checkDonCu: true
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'center mb30 mt30' },
              _react2.default.createElement(_buttonGroup2.default, {
                pageType: 'DONCU',
                alias: this.state.alias,
                donId: this.state.donId,
                donInfo: this.state.data,
                onClose: this.handleBack.bind(this, false),
                params: this.state.params,
                processType: this.state.processTypeValue,
                btnLoading: this.state.btnLoading,
                btnSaveLoading: this.state.btnSaveLoading,
                validateSubmitForm: this.validateSubmitForm.bind(this),
                bindValidator: this,
                onChange: this.handleDataForm.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return HandleLettersOldDetails;
}(_react2.default.Component);

HandleLettersOldDetails.defaultProps = {
  validators: []
};

exports.default = (0, _reactRedux.connect)()(HandleLettersOldDetails);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleLettersOldDetails = undefined;

var _HandleLettersOldDetails = __webpack_require__(1148);

var _HandleLettersOldDetails2 = _interopRequireDefault(_HandleLettersOldDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HandleLettersOldDetails = _HandleLettersOldDetails2.default;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _config = __webpack_require__(16);

var _downloadFile = __webpack_require__(112);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _listHandleLettersSearch = __webpack_require__(1154);

var _list = __webpack_require__(1147);

var _utils = __webpack_require__(4);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLettersOld = function (_React$Component) {
  _inherits(HandleLettersOld, _React$Component);

  function HandleLettersOld(props, context) {
    _classCallCheck(this, HandleLettersOld);

    var _this = _possibleConstructorReturn(this, (HandleLettersOld.__proto__ || Object.getPrototypeOf(HandleLettersOld)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,

      searchData: {},
      search: false,
      tableLoading: false,
      searchLoading: false,
      resetFormSearch: false
    };
    return _this;
  }

  _createClass(HandleLettersOld, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = this.state;
                data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};

                state.advanceSearch = data.advanceSearch || false;
                state.pageData.number = data.page || 0;
                state.pageData.size = data.size || 10;
                if (state.advanceSearch) {
                  state.searchData.tuKhoa = data.tuKhoa || '';
                  state.searchData.nguonDon = data.nguonDon || '';
                  state.searchData.maDon = data.maDon || '';
                  state.searchData.phanLoaiDon = data.phanLoaiDon || '';
                  state.searchData.tinhTrangXuLy = data.trangThaiDonToanHT || '';
                  state.searchData.ketQuaXuLy = data.ketQuaToanHT || '';
                  state.searchData.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
                  state.searchData.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
                }
                _context.next = 8;
                return this.setState(state);

              case 8:
                _context.next = 10;
                return this.getListData();

              case 10:
                _context.next = 12;
                return this.props.dispatch({
                  type: 'REFRESH_MENU',
                  value: true
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('xldData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('xldData', JSON.stringify(data));
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(donId) {
      var _this2 = this;

      _api.LetterProcessing.actions.deleteDonCu.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.deleteLetterSucess, 'success');
        _this2.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        _this2.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listXLD',
          idKey: 'donId',
          id: donId
        });
        _this2.getListData();
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.forEach(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }

    // Note: ThuHoiDon

  }, {
    key: 'handleThuHoi',
    value: function handleThuHoi(donId) {
      var _this3 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.thuHoiDon, 'success');
        _this3.getListData();
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleChangeTrangThaiXuLyDon',
    value: function handleChangeTrangThaiXuLyDon(e) {
      var _this4 = this;

      this.setState({
        trangThaiXuLyDon: e.target.value,
        advanceSearch: false,
        searchData: {},
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        },
        resetFormSearch: true
      }, function () {
        _this4.getListData();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var state = this.state;
      state.pageData.size = size;
      state.pageData.number = 0;
      this.getListData();
      this.setState(state);
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      var state = this.state;
      state.search = true;
      state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      if (!state.advanceSearch) {
        searchData = {
          tuKhoa: searchData.tuKhoa
        };
      }
      state.searchData = searchData;
      this.getListData();
      this.setState(state);
    }
  }, {
    key: 'getListData',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this5 = this;

        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  thanhLapDon: true,
                  page: this.state.pageData.number,
                  size: this.state.pageData.size
                };


                this.setState({
                  searching: true,
                  tableLoading: true,
                  searchLoading: true,
                  resetFormSearch: false
                });

                if (this.state.searchData.tuKhoa) {
                  params.tuKhoa = this.state.searchData.tuKhoa;
                }

                if (this.state.advanceSearch) {
                  if (this.state.searchData.nguonDon) {
                    params.nguonDon = this.state.searchData.nguonDon;
                  }

                  if (this.state.searchData.phanLoaiDon) {
                    params.phanLoaiDon = this.state.searchData.phanLoaiDon;
                  }

                  if (!(0, _lodash.isEmpty)(this.state.searchData.loaiThongTinDon)) {
                    params.loaiThongTinDon = (0, _lodash.get)(this.state, 'searchData.loaiThongTinDon');
                  }
                }

                _context2.next = 6;
                return _api.LetterProcessing.actions.getDonCusInfo.request(params).then(function (res) {
                  if (_this5.refs.listXLD) {
                    var Data = [];
                    if (res.data._embedded) {
                      Data = res.data._embedded.donCus;
                      _this5.setState({ pageData: res.data.page });
                    } else {
                      _this5.setState({
                        pageData: {
                          number: 0,
                          size: 10,
                          totalElements: 0
                        }
                      });
                    }
                    _this5.setState({
                      tableLoading: false,
                      searchLoading: false,
                      searching: false,
                      search: false
                    }, function () {
                      _this5.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
                    });
                  }
                }).catch(function (err) {
                  _this5.setState({
                    tableLoading: false,
                    searchLoading: false,
                    searching: false,
                    search: false
                  });
                });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getListData() {
        return _ref2.apply(this, arguments);
      }

      return getListData;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.data !== this.props.data) {
        this.setState({ data: this.props.data });
        this.forceUpdate();
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var _state$searchData = this.state.searchData,
          tuKhoa = _state$searchData.tuKhoa,
          phanLoaiDon = _state$searchData.phanLoaiDon,
          loaiThongTinDon = _state$searchData.loaiThongTinDon,
          nguonDon = _state$searchData.nguonDon;

      var URL = String(_config.API_URL) + '/donCus/xuatExcel?thanhLapDon=true';
      if (!(0, _lodash.isEmpty)(tuKhoa)) {
        URL = URL + '&tuKhoa=' + tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (!(0, _lodash.isEmpty)(phanLoaiDon)) {
          URL = URL + '&phanLoaiDon=' + phanLoaiDon;
        }
        if (!(0, _lodash.isEmpty)(loaiThongTinDon)) {
          URL = URL + '&loaiThongTinDon=' + loaiThongTinDon;
        }
        if (!(0, _lodash.isEmpty)(nguonDon)) {
          URL = URL + '&nguonDon=' + nguonDon;
        }
      }
      (0, _downloadFile.downloadFile)(URL);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: 'listXLD' },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content right-button' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('DONCU_THEM') },
              _react2.default.createElement(
                'div',
                { className: 'right-content' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-green', to: '/xu-ly-don-cu/them-moi' },
                  _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                  'Th\xEAm m\u1EDBi'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)({
                  'search-container super-search': this.state.advanceSearch,
                  'search-container': !this.state.advanceSearch
                }) },
              _react2.default.createElement(_listHandleLettersSearch.FormSearch, { exceptNguonDon: 'GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH', advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, resetForm: this.state.resetFormSearch }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              { header: _table.header.listXLDC,
                dataList: this.state.data,
                searchData: this.state.searchData,
                pageData: this.state.pageData,
                hideButtonExport: true,
                thanhTra: true,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                parent: this,
                search: this.state.search,
                redux: this,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_list.RowItemListHandleOldLetters, {
                getListData: this.getListData.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return HandleLettersOld;
}(_react2.default.Component);

HandleLettersOld.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(HandleLettersOld);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleLettersOld = undefined;

var _HandleLettersOld = __webpack_require__(1150);

var _HandleLettersOld2 = _interopRequireDefault(_HandleLettersOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HandleLettersOld = _HandleLettersOld2.default;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var FormSearch = function (_React$Component) {
  _inherits(FormSearch, _React$Component);

  function FormSearch(props, context) {
    _classCallCheck(this, FormSearch);

    var _this = _possibleConstructorReturn(this, (FormSearch.__proto__ || Object.getPrototypeOf(FormSearch)).call(this, props, context));

    _this.state = {
      tuKhoa: '',
      nguonDon: '',
      phanLoaiDon: '',
      loaiThongTinDon: '',
      searching: _this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false,
      listLoaiThongTinDon: []
    };
    return _this;
  }

  _createClass(FormSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListLoaiThongTinDon();
      var state = this.state;
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      state.tuKhoa = data.tuKhoa || '';
      if (data.advanceSearch) {
        state.nguonDon = data.nguonDon || '';
        state.phanLoaiDon = data.phanLoaiDon || '';
      }
      this.setState(state);
    }
  }, {
    key: 'getListLoaiThongTinDon',
    value: function getListLoaiThongTinDon() {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getLoaiThongTinDon.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this2.setState({
            listLoaiThongTinDon: res.data
          });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.setState({ doSearch: true });
      this.props.handleSearch(this.state, e);
    }
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.resetForm) {
        this.resetData();
      } else {
        this.setState({
          searching: nextProps.disabled,
          doSearch: nextProps.search
        });
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        tuKhoa: '',
        nguonDon: '',
        phanLoaiDon: '',
        spSearch: false,
        search: false,
        doSearch: false,
        searchLoading: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];
      if (this.state.searching) {
        classes.push('btn-disable');
      }
      if (this.state.doSearch) {
        classes.push('btn-loading');
      }
      var classesInput = [];
      if (this.props.advanceSearch) {
        classesInput.push('input-20');
      } else {
        classesInput.push('input-show-group');
      }
      var inputClasses = classNames(classesInput);
      var btnClasses = classNames(classes);
      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(_common.InputTuKhoa, {
          onChange: this.handleChange.bind(this, 'tuKhoa'),
          value: this.state.tuKhoa,
          channel: 'formTaoDon', className: inputClasses }),
        _react2.default.createElement(_ttForms.DropDownChonNguonDon, { exceptNguonDon: this.props.exceptNguonDon, selectedValue: this.state.nguonDon, onChange: this.handleChange.bind(this, 'nguonDon'), className: 'input-20' }),
        _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, onChange: this.handleChange.bind(this, 'phanLoaiDon'), className: 'input-20', isDonCu: true }),
        _react2.default.createElement(_common.DropDown, {
          className: 'input-20',
          label: 'Lo\u1EA1i th\xF4ng tin \u0111\u01A1n',
          bindValidator: this,
          channel: 'formTaoDon',
          require: false,
          options: this.state.listLoaiThongTinDon,
          selectedValue: this.state.loaiThongTinDon,
          placeholder: true,
          keyName: 'giaTri',
          valueName: 'ten',
          onChange: this.handleChange.bind(this, 'loaiThongTinDon')
        }),
        _react2.default.createElement(
          'div',
          { className: 'btn-wrap-20' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'input-20 ps-huytimkiem' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: classNames({
                'disable-super-search btn-disable-transparent': this.state.tableLoading,
                'disable-super-search': !this.state.tableLoading
              }), onClick: this.cancel.bind(this) },
            _react2.default.createElement('i', { className: 'tt tt-delete' }),
            'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
          )
        )
      );
    }
  }]);

  return FormSearch;
}(_react2.default.Component);

FormSearch.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
};

exports.default = FormSearch;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: "onChange",
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: this.props.className },
        _react2.default.createElement(
          "label",
          { className: "ip-label" },
          this.props.title
        ),
        _react2.default.createElement("input", { type: "text", name: this.props.name, placeholder: this.props.placehoderText, className: "search-input", onChange: this.onChange.bind(this) })
      );
    }
  }]);

  return Input;
}(_react2.default.Component);

Input.defaultProps = {
  title: 'Từ khóa',
  className: 'input-group-show',
  name: 'searchKey',
  placehoderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function onChange() {
    console.log('Please assign onChange function');
  }
};

exports.default = Input;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.FormSearch = undefined;

var _FormSearch = __webpack_require__(1152);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _Input = __webpack_require__(1153);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FormSearch = _FormSearch2.default;
exports.Input = _Input2.default;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reception = __webpack_require__(129);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingData = __webpack_require__(306);

var _LoadingData2 = _interopRequireDefault(_LoadingData);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _xuLyDon = __webpack_require__(312);

var _buttonGroup = __webpack_require__(234);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _letterHistory = __webpack_require__(236);

var _letterHistory2 = _interopRequireDefault(_letterHistory);

var _utils = __webpack_require__(4);

var _dialog = __webpack_require__(18);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddHandleLetter = function (_React$Component) {
  _inherits(AddHandleLetter, _React$Component);

  function AddHandleLetter(props, context) {
    _classCallCheck(this, AddHandleLetter);

    var _this = _possibleConstructorReturn(this, (AddHandleLetter.__proto__ || Object.getPrototypeOf(AddHandleLetter)).call(this, props, context));

    _this.state = {

      btnLoading: false,
      btnSaveLoading: false,
      btnDisable: false,
      // Thong tin nguoi xu ly
      canBoDangXuLy: [],
      donDangXuLy: true,
      title: 'THÔNG TIN XỬ LÝ',
      huongXuLy: '',
      donId: _this.props.params.id ? _this.props.params.id : 0,
      alias: '',
      listNextStates: [],
      params: {},
      data: {},
      validate: false,
      processType: '',
      thongTinXuLy: {},
      showHistory: true,

      dataLoading: false,
      thoiHan: '',
      ngayTiepNhan: (0, _moment2.default)(),
      taskDelete: [],
      doanDongNguoi: [],
      loadingSave: false,
      loadingXLD: false,
      thanhLapDon: false,
      soThuTuLuotTiep: 1,
      tongSoLuotTCD: 1,

      lanhDaoId: 0,
      isFinish: false,
      openConfirmDialog: false,
      confirmIndex: '',
      confirmData: {},
      isValid: true,
      nguonDon: 'BUU_CHINH',
      loaiNguoiDungDonId: 'CA_NHAN',

      listTaiLieuVanThu: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      noticeMsg: '',
      backConfirm: false,
      hasChange: false,
      isSave: false,
      saveTmp: true,
      maTraCuuDialog: false,
      maTraCuu: '',
      nguonDonKhac: '',
      daLayThongTinDonId: '',
      noiCapCMNDList: _this.props.noiCapCMNDList,
      checkValidate: false
    };
    return _this;
  }

  _createClass(AddHandleLetter, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {

      this.props.dispatch({
        type: 'RESET_FORM'
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.params.id) {
        this.getDonInfo(this.props.params.id);
        this.getCurrentForm(this.state.donId);
        this.getThongTinXuLy(this.state.donId);
      } else {
        this.getCurrentForm(null);
      }
      if (this.props.noiCapCMNDList.length == 0) {
        _api.DuLieuHeThong.actions.getNoiCap.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'noiCapCMND',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.removeDonCongDanId) {
        this.state.taskDelete.push({
          type: 'CONG_DAN',
          id: nextProps.removeDonCongDanId
        });
      }
      if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
        this.setState({ daLayThongTinDonId: nextProps.thongTinDon.donId });
      }
      if (nextProps.noiCapCMNDList != this.props.noiCapCMNDList) {
        this.state.noiCapCMNDList = nextProps.noiCapCMNDList;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChangeData',
    value: function onChangeData(data) {

      var newData = _extends({}, this.state, data);
      this.state = newData;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onInitComponent',
    value: function onInitComponent(data) {
      var newData = _extends({}, this.state, data);
      this.state = newData;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'hasChange', true), _setState));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.state[e.target.name] = e.target.value;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
      if (e.target.name == 'huongXuLy') {
        this.setState({
          ghiChuXuLy: ''
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (typeof e.format == 'function') {
        this.state[name] = e.format(_config.DateFormat);
      } else {
        this.state[name] = e;
      }
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(name, data) {
      if (name == 'DOAN_DI_CUNG' && data.doanDiCungId) {
        this.state.taskDelete.push({
          type: 'DOAN_DI_CUNG',
          id: data.doanDiCungId
        });
      } else if (name == 'CONG_DAN' && data.donCongDanId) {
        this.state.taskDelete.push({
          type: 'CONG_DAN',
          id: data.donCongDanId
        });
      } else if (name == 'BANG_CHUNG' && data.taiLieuBangChungId) {
        this.state.taskDelete.push({
          type: 'BANG_CHUNG',
          id: data.taiLieuBangChungId
        });
      } else if (name == 'TEP_DINH_KEM' && data.taiLieuVanThuId) {
        this.state.taskDelete.push({
          type: 'TEP_DINH_KEM',
          id: data.taiLieuVanThuId
        });
      }
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'phanLoaiDonCongDan',
    value: function phanLoaiDonCongDan(donId, onlySave) {
      var _this3 = this;

      var plusData = {};
      var AddNewDCDList = [];
      var UpdateDCDList = [];
      var AddNewTLList = [];
      var UpdateTLList = [];
      var AddNewDDCList = [];
      var UpdateDDCList = [];

      if (this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC') {
        plusData = {
          tenCoQuan: this.state.tenCoQuan,
          diaChiCoQuan: this.state.diaChiCoQuan,
          soDienThoaiCoQuan: this.state.soDienThoai
        };
      }

      this.props.nguoiDungDon.map(function (item, i) {
        if (item.hoVaTen) {
          var nddData = _this3.createCongDan(item, 'NGUOI_DUNG_DON');
          var donCdData = _this3.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
          if (donCdData.id) {
            UpdateDCDList.push(donCdData);
          } else {
            AddNewDCDList.push(donCdData);
          }
        }
      });

      this.state.doanDongNguoi.map(function (item, i) {
        if (item.hoVaTen) {
          var ddcData = _this3.createItemDoanDiCung(item, donId);
          if (ddcData.id) UpdateDDCList.push(ddcData);else AddNewDDCList.push(ddcData);
        }
      });
      if (this.state.flagUyQuyen) {
        if (this.state.uyQuyen && this.state.uyQuyen.flagLuatSu) {
          plusData.luatSu = this.state.uyQuyen.flagLuatSu;
          if (this.state.uyQuyen.luatSu.soTheLuatSu) {
            plusData.soTheLuatSu = this.state.uyQuyen.luatSu.soTheLuatSu;
          }
          if (this.state.uyQuyen.luatSu.ngayCapTheLuatSu) {
            plusData.ngayCapTheLuatSu = (0, _moment2.default)(this.state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
          }
          if (this.state.uyQuyen.luatSu.noiCapTheLuatSu) {
            plusData.noiCapTheLuatSu = this.state.uyQuyen.luatSu.noiCapTheLuatSu;
          }
          if (this.state.uyQuyen.luatSu.thongTinGioiThieu) {
            plusData.thongTinGioiThieu = this.state.uyQuyen.luatSu.thongTinGioiThieu;
          }

          this.state.uyQuyen.luatSu.dsGiayUyQuyen.map(function (item, i) {
            var tlParams = _this3.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
            if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
          });
        } else {
          plusData.luatSu = false;
        }

        var nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
        var donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');
        if (donCdData.id) UpdateDCDList.push(donCdData);else AddNewDCDList.push(donCdData);
      }

      this.state.thongTinDon.dsBangChung.map(function (item, i) {
        var tlParams = _this3.createTaiLieuBangChung(item, donId);
        if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
      });

      if (AddNewDCDList.length) {
        _api.Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(function () {
          if (_this3.state.donDangXuLy) {
            if (onlySave) _this3.patchXuLyDon(donId, _this3.state.params);else _this3.postXuLyDon(donId, _this3.state.params);
          } else {
            _this3.onClickClose();
            (0, _toastr.Toastr)(_message.msg.xuLyDon, 'success');
          }
        });
      }

      if (UpdateDCDList.length) {
        _api.Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(function () {
          if (_this3.state.donDangXuLy) {
            if (onlySave) _this3.patchXuLyDon(donId, _this3.state.params);else _this3.postXuLyDon(donId, _this3.state.params);
          } else {
            _this3.onClickClose();
            (0, _toastr.Toastr)(_message.msg.xuLyDon, 'success');
          }
        });
      }

      if (AddNewTLList.length) {
        _api.Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
      }
      if (UpdateTLList.length) {
        _api.Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
      }
      if (AddNewDDCList.length) {
        _api.Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
      }
      if (UpdateDDCList.length) {
        _api.Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
      }

      if (!AddNewDCDList.length && !UpdateDCDList.length) {
        if (this.state.donDangXuLy) {
          if (onlySave) {
            this.patchXuLyDon(donId, this.state.params);
          } else {
            this.postXuLyDon(donId, this.state.params);
          }
        } else {
          this.onClickClose();
          (0, _toastr.Toastr)(_message.msg.xuLyDon, 'success');
        }
      }
      this.createDSTepDinhKem(donId, this.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET');
    }
  }, {
    key: 'createTaiLieuBangChung',
    value: function createTaiLieuBangChung(item, donID, stcdId) {
      var buocGQ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'TAI_LIEU_KEM_THEO';

      var params = {
        don: {
          id: donID
        },
        buocGiaiQuyet: buocGQ
      };
      if (item.ten) {
        params.ten = item.ten;
      }
      if (item.tinhTrang) {
        params.tinhTrangTaiLieu = item.tinhTrang;
      }
      if (item.tenFile) {
        params.tenFile = item.tenFile;
      }
      if (item.duongDan) {
        params.duongDan = item.duongDan;
      }
      if (item.required) {
        params.required = true;
      }
      if (stcdId) {
        params.soTiepCongDan = {
          id: stcdId
        };
      }
      if (item.taiLieuBangChungId) {
        params.id = item.taiLieuBangChungId;
      }
      return params;
    }
  }, {
    key: 'createDonCongDan',
    value: function createDonCongDan(cdData, donID, plusData, loaiCD) {
      var param = {
        phanLoaiCongDan: loaiCD,
        don: {
          id: donID
        }
      };
      if (cdData) {
        param = Object.assign(param, cdData);
      }
      if (plusData) {
        param = Object.assign(param, plusData);
      }
      return param;
    }
  }, {
    key: 'createItemDoanDiCung',
    value: function createItemDoanDiCung(data, donId) {
      var params = {
        hoVaTen: data.hoVaTen,
        don: {
          id: donId
        }
      };
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.cmndHoChieu) {
        params.cmndHoChieu = data.cmndHoChieu;
      }
      if (data.doanDiCungId) {
        params.id = data.doanDiCungId;
      }
      return params;
    }
  }, {
    key: 'createCongDan',
    value: function createCongDan(data, type) {
      var params = {
        hoVaTen: data.hoVaTen
      };
      if (data.tinhThanhId) {
        params.tinhThanh = {
          id: data.tinhThanhId
        };
      }
      if (data.quanHuyenId) {
        params.quanHuyen = {
          id: data.quanHuyenId
        };
      }
      if (data.phuongXaId) {
        params.phuongXa = {
          id: data.phuongXaId
        };
      }
      if (data.toThon) {
        params.toThon = data.toThon;
      }
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.soCMNDHoChieu) {
        params.soCMNDHoChieu = data.soCMNDHoChieu;
      }
      if (data.noiCap) {
        params.noiCapCMND = {
          id: data.noiCap.value
        };
      }
      if (data.ngaySinh && data.ngaySinh != null) {
        params.ngaySinh = (0, _moment2.default)(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.ngayCap && data.ngaySinh != null) {
        params.ngayCap = (0, _moment2.default)(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.gioiTinh) {
        params.gioiTinh = data.gioiTinh == 'male' ? true : false;
      }
      if (data.quocTichId) {
        params.quocTich = {
          id: data.quocTichId
        };
      }
      if (data.danTocId) {
        params.danToc = {
          id: data.danTocId
        };
      }
      if (data.donCongDanId) {
        params.id = data.donCongDanId;
      }
      if (data.congDanId && type != 'NGUOI_DUOC_UY_QUYEN') {
        params.congDan = {
          id: data.congDanId
        };
      }
      return params;
    }
  }, {
    key: 'runDeleteTask',
    value: function runDeleteTask() {
      var ddnParams = [];
      this.state.taskDelete.map(function (item, i) {
        if (item.type == 'CONG_DAN') {
          _api.Reception.actions.deleteDonCongDan.request({
            id: item.id
          });
        } else if (item.type == 'DOAN_DI_CUNG') {
          ddnParams.push({
            id: item.id
          });
        }
      });
      this.state.thongTinDon.dsBangChungRemove.map(function (item) {
        _api.Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });

      this.state.thongTinDon.dsFileCoQuanRemove.map(function (item) {
        _api.Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });

      if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
        this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.map(function (item) {
          _api.Reception.actions.deleteTaiLieuBangChung.request({
            id: item
          });
        });
      }

      if (ddnParams.length) {
        _api.Reception.actions.deleteDoanDiCungMulti.request(null, {
          doanDiCungs: ddnParams
        });
      }
    }
  }, {
    key: 'xuLyDon',
    value: function xuLyDon() {
      var _this4 = this;

      this.setState({ isSave: false }, function () {
        if (_this4.validateSubmitForm()) {
          _this4.state.saveTmp = false;
          _this4.createDon(false);
        }
      });
    }
  }, {
    key: 'createDon',
    value: function createDon(onlySave) {
      var _this5 = this;

      this.setState({ isSave: onlySave }, function () {
        _this5.setState({
          btnSaving: onlySave
        });
        _this5.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var params = {
          coUyQuyen: _this5.state.flagUyQuyen,
          coThongTinCoQuanDaGiaiQuyet: _this5.state.thongTinDon.flagCQDaGiaiQuyet,
          noiDung: _this5.state.thongTinDon.noiDung,
          loaiVuViec: _this5.state.thongTinDon.loaiVuViecId,
          nguonTiepNhanDon: _this5.state.nguonDon || null,
          ngayTiepNhan: (0, _moment2.default)(_this5.state.ngayTiepNhan, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
          loaiNguoiDungDon: _this5.state.loaiNguoiDungDonId,
          thanhLapDon: true,
          canBoXuLy: { id: _this5.props.userInfo.id },
          soNguoi: _this5.props.nguoiDungDon.length
        };

        if (_this5.state.daLayThongTinDonId) {
          params.daLayThongTinDonId = _this5.state.daLayThongTinDonId;
        }

        if (_this5.state.nguonDon == 'KHAC') {
          params.nguonDonKhac = _this5.state.nguonDonKhac;
        }

        if (_this5.state.thongTinDon.loaiDoiTuongId) {
          params.loaiDoiTuong = _this5.state.thongTinDon.loaiDoiTuongId;
        }
        if (_this5.state.thongTinDon.loaiDonId) {
          params.loaiDon = _this5.state.thongTinDon.loaiDonId;
        }

        if (!_this5.state.saveTmp) {
          params.saveTmp = _this5.state.saveTmp;
        }
        if (_this5.state.thongTinDon.layVuViecCu) {
          params.layVuViecCu = _this5.state.thongTinDon.layVuViecCu;
        }

        if (_this5.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI') {
          params.soNguoi = _this5.state.soNguoi;
        }
        if (_this5.state.thongTinDon.linhVucCap1Id) {
          params.linhVucDonThu = { id: _this5.state.thongTinDon.linhVucCap1Id };
        }
        if (_this5.state.thongTinDon.linhVucCap2Id) {
          params.linhVucDonThuChiTiet = { id: _this5.state.thongTinDon.linhVucCap2Id };
        }
        if (_this5.state.thongTinDon.linhVucChiTietKhac) {
          params.linhVucChiTietKhac = _this5.state.thongTinDon.linhVucChiTietKhac;
        }

        if (_this5.state.thongTinDon.flagCQDaGiaiQuyet) {
          if (_this5.state.thongTinDon.coQuanDaGiaiQuyetDonThu) {
            params.coQuanDaGiaiQuyetDonThu = _this5.state.thongTinDon.coQuanDaGiaiQuyetDonThu;
          }
          if (_this5.state.thongTinDon.soVanBan) {
            params.soVanBanDaGiaiQuyet = _this5.state.thongTinDon.soVanBan;
          }
          if (_this5.state.thongTinDon.ngayBanHanh) {
            params.ngayBanHanhVanBanDaGiaiQuyet = (0, _moment2.default)(_this5.state.thongTinDon.ngayBanHanh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }
        }

        _this5.runDeleteTask();

        if (_this5.state.donId != 0) {
          params.tongSoLuotTCD = _this5.state.tongSoLuotTCD;
          _api.Reception.actions.updateDon.request({ id: _this5.state.donId }, params).then(function (res) {

            if (res.data) {

              _this5.setState({
                donId: res.data.donId
              });

              _this5.phanLoaiDonCongDan(res.data.donId, onlySave);
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this5.setState({
              loadingSave: false,
              loadingXLD: false
            });
          });
        } else {
          _api.Reception.actions.postDon.request(null, params).then(function (res) {
            if (res.data) {
              _this5.state.donId = res.data.donId;
              _this5.state.code = res.data.maHoSo;
              _this5.state.maTraCuuDialog = true;
              _this5.setState(_extends({}, _this5.state));

              _this5.phanLoaiDonCongDan(res.data.donId, onlySave);
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this5.setState({
              loadingSave: false,
              loadingXLD: false
            });
          });
        }
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (validator.props.checkValidate) {
          //do nothing
        } else {
          if (pass) {
            pass = validator.validate();
          } else {
            validator.validate();
          }
          if (!validator.validate() && (0, _lodash.get)(validator, 'props.checkValid')) {
            pass = true;
          }
        }
      });
      return pass;
    }

    /* XULYDON */

  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.push('/xu-ly-don');
    }
  }, {
    key: 'handleDataForm',
    value: function handleDataForm(state) {

      var noticeMsg = state.notice;
      delete state.messege;
      this.state.params = state;
      this.state.noticeMsg = noticeMsg;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleInitDataForm',
    value: function handleInitDataForm(state) {
      this.setState({
        params: state
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this6 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {

        if (res.data) {
          var info = res.data;

          _this6.props.dispatch({
            type: 'THONG_TIN_XU_LY_GIAI_QUYET',
            data: info.thongTinXuLyInfo
          });

          _this6.setState({
            alias: info.nextFormInfo.alias,
            thongTinXuLy: info.thongTinXuLyInfo
          });
        }
      }).catch(function (error) {
        if (error.response) {}
      });
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(donId) {
      var _this7 = this;

      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(function (res) {
        if (res.data) {
          _this7.setState({
            processType: res.data.currentForm.processType,
            alias: res.data.currentForm.alias,
            listNextStates: res.data.listNextStates
          });
        }
      }).catch(function (error) {
        _this7.setState({
          donDangXuLy: false
        });
      });
    }
  }, {
    key: 'postXuLyDon',
    value: function postXuLyDon(donId, params) {
      var _this8 = this;

      this.setState({
        btnLoading: true
      });
      params.don = {
        id: donId
      };
      this.saveTepDinhKem(donId, function () {
        if (!_this8.state.params.donViNgoaiHeThongId && _this8.state.params.donViNgoaiHeThong) {
          _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this8.state.params.donViNgoaiHeThong.trim() }).then(function (res1) {
            if (res1.data) {
              params.donViNgoaiHeThong = { id: res1.data.donViNgoaiHeThongId };
              _api.LetterProcessingWorkFlow.actions.postXuLyDon.request(null, params).then(function (res) {
                if (!_this8.state.maTraCuuDialog) {
                  _this8.onClickClose();
                }
                (0, _toastr.Toastr)(_this8.state.noticeMsg, 'success');
              }).catch(function (error) {

                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        } else {
          if (_this8.state.params.donViNgoaiHeThongId) {
            params.donViNgoaiHeThong = { id: _this8.state.params.donViNgoaiHeThongId };
          } else {
            params.donViNgoaiHeThong = null;
          }
          _api.LetterProcessingWorkFlow.actions.postXuLyDon.request(null, params).then(function (res) {
            if (!_this8.state.maTraCuuDialog) {
              _this8.onClickClose();
            }
            (0, _toastr.Toastr)(_this8.state.noticeMsg, 'success');
          }).catch(function (error) {

            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      });
    }
  }, {
    key: 'patchXuLyDon',
    value: function patchXuLyDon(donId, params) {
      var _this9 = this;

      params.don = {
        id: donId
      };
      this.saveTepDinhKem(donId, function () {
        if (!_this9.state.params.donViNgoaiHeThongId && _this9.state.params.donViNgoaiHeThong) {
          _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this9.state.params.donViNgoaiHeThong.trim() }).then(function (res1) {
            if (res1.data) {
              params.donViNgoaiHeThong = { id: res1.data.donViNgoaiHeThongId };
              _api.LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: donId }, params).then(function (res) {
                if (!_this9.state.maTraCuuDialog) {
                  _this9.onClickClose();
                }
                (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        } else {
          if (_this9.state.params.donViNgoaiHeThongId) {
            params.donViNgoaiHeThong = { id: _this9.state.params.donViNgoaiHeThongId };
          } else {
            params.donViNgoaiHeThong = null;
          }
          _api.LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: donId }, params).then(function (res) {
            if (!_this9.state.maTraCuuDialog) {
              _this9.onClickClose();
            }
            (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      });
    }
  }, {
    key: 'getMoreDonInfo',
    value: function getMoreDonInfo(donData) {
      var _this10 = this;

      _api.Reception.actions.getDonInfo.request({ id: donData.donId }).then(function (res) {
        if (res.data) {
          donData = _extends({}, donData, res.data);
        }
        _this10.setState({
          listTaiLieuVanThu: donData.listTaiLieuVanThu
        });

        var info = donData;
        info.listNguoiDungDon.map(function (item, i) {
          _this10.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: item,
            donCongDanId: item.donCongDanId,
            index: i
          });
        });

        if (info.coUyQuyen) {
          _this10.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: info.nguoiDuocUyQuyen,
            donCongDanId: info.nguoiDuocUyQuyen.donCongDanId,
            index: -1
          });
        }

        var newState = _extends({}, _this10.state);

        newState.donId = info.donId;

        newState.ngayTiepNhan = (0, _moment2.default)(info.ngayTiepNhan);
        newState.nguonDon = info.nguonTiepNhanDonInfo.giaTri;
        newState.nguonDonKhac = info.nguonTiepNhanDonInfo.giaTri == 'KHAC' ? info.nguonDonKhac : '';
        newState.loaiNguoiDungDonId = info.loaiNguoiDungDonInfo.giaTri;
        newState.daLayThongTinDonId = info.daLayThongTinDonId || '';

        _this10.setState(_extends({}, newState));

        _this10.props.dispatch({
          type: 'INIT_EDIT_FORM',
          data: donData
        });
      });
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(donId) {
      var _this11 = this;

      _api.LetterProcessingWorkFlow.actions.getDonDetail.request({ id: donId }).then(function (res) {
        if (res.data) {
          _this11.getMoreDonInfo(res.data);
          _this11.setState({
            canBoDangXuLy: res.data.canBoDangXuLyInfo
          });
        }
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }

    // In phieu

  }, {
    key: 'inPhieu',
    value: function inPhieu(loaiPhieu) {
      var _this12 = this;

      this.setState({
        isSave: true,
        checkValidate: true
      }, function () {
        if (_this12.validateSubmitForm()) {
          _this12.setState({ checkValidate: false });
          var URL = String(_config.API_URL);
          var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
          var loaiDon = _this12.state.thongTinDon.loaiDonId == "DON_KHIEU_NAI" ? "khiếu nại" : _this12.state.thongTinDon.loaiDonId == "DON_TO_CAO" ? "tố cáo" : _this12.state.thongTinDon.loaiDonId == "DON_KIEN_NGHI_PHAN_ANH" ? "kiến nghị, phản ánh" : _this12.state.thongTinDon.loaiDonId == "DON_TRANH_CHAP_DAT" ? "tranh chấp đất" : "";
          var ngayTiepNhan = (0, _moment2.default)(new Date(_this12.state.ngayTiepNhan)).format('DD/MM/YYYY');
          var nguoiDungDon = _this12.props.nguoiDungDon[0];
          var noiCapCMND = nguoiDungDon.noiCapCMNDInfo ? nguoiDungDon.noiCapCMNDInfo : { ten: '' };
          if (nguoiDungDon.noiCap) {
            noiCapCMND = _this12.state.noiCapCMNDList.filter(function (item) {
              return item.coQuanQuanLyId === nguoiDungDon.noiCap.value;
            });
            if (noiCapCMND.length) {
              noiCapCMND = noiCapCMND[0];
            }
          }
          var cqTiepNhan = '';
          var donViTiepNhanDonId = '';
          if (loaiPhieu == 'CHUYEN_DON' && _this12.state.params.thamQuyenGiaiQuyet) {
            if (_this12.state.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId) {
              cqTiepNhan = _this12.state.params.coQuanTiepNhan.ten;
              donViTiepNhanDonId = _this12.state.params.coQuanTiepNhan.id;
            } else {
              cqTiepNhan = _this12.state.params.donViNgoaiHeThong;
            }
          }

          var ngayCap = (0, _moment2.default)(nguoiDungDon.ngayCap).format('DD/MM/YYYY') == 'Invalid date' ? nguoiDungDon.ngayCap || '' : (0, _moment2.default)(nguoiDungDon.ngayCap).format('DD/MM/YYYY');
          var diaChiNguoiDungDon = '';
          var loaiDoiTuong = _this12.state.thongTinDon.loaiDoiTuongId == "CA_NHAN" ? "cá nhân" : _this12.state.thongTinDon.loaiDoiTuongId == "TO_CHUC" ? "tổ chức" : "";

          if (nguoiDungDon.diaChi) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.diaChi + ', ';

          if (nguoiDungDon.toThon) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.toThon + ', ';

          if (nguoiDungDon.phuongXaCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.phuongXaCongDan.ten + ', ';

          if (nguoiDungDon.quanHuyenCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.quanHuyenCongDan.ten + ', ';

          if (nguoiDungDon.tinhThanhCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.tinhThanhCongDan.ten + ', ';

          diaChiNguoiDungDon = diaChiNguoiDungDon.slice(0, diaChiNguoiDungDon.length - 2);

          var noiDung = _this12.state.thongTinDon.noiDung;
          switch (loaiPhieu) {

            case "THU_LY":

              URL = URL + "/xuLyDons/inPhieuDeXuatThuLy?" + "loaiDon=" + loaiDon + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChi=" + diaChiNguoiDungDon + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND.ten + "&noiDung=" + noiDung + "&coQuanTiepNhan=" + _this12.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "DU_THAO_THONG_BAO_THU_LY":

              if (_this12.state.thongTinDon.loaiDonId == 'DON_KHIEU_NAI') {
                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKhieuNai?" + "ngayTiepNhan=" + ngayTiepNhan + "&nguoiKhieuNai=" + nguoiDungDon.hoVaTen + "&diaChiNguoiKhieuNai=" + diaChiNguoiDungDon + "&SoCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + (nguoiDungDon.ngayCap ? (0, _moment2.default)(nguoiDungDon.ngayCap).format('DD/MM/YYYY') : '') + "&noiCap=" + noiCapCMND.ten + "&noiDungKhieuNai=" + noiDung + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&coQuanTiepNhan=" + _this12.props.userInfo.tenCoQuanQuanLy;
              } else if (_this12.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {

                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyGQTC?" + "doiTuongGiaiQuyet=" + _this12.props.userInfo.tenCoQuanQuanLy + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&doiTuongBiToCao=" + loaiDoiTuong + "&donId=" + _this12.state.donId + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&noiDungToCao=" + noiDung;
              } else if (_this12.state.thongTinDon.loaiDonId == 'DON_KIEN_NGHI_PHAN_ANH') {

                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKienNghi?" + "loaiDon=" + loaiDon + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&noiDung=" + noiDung + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&diaChi=" + diaChiNguoiDungDon;
              }
              window.open(URL, "_self");
              return;

            case "CHUYEN_DON":
              if (cqTiepNhan) {
                if (_this12.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {
                  URL = URL + "/xuLyDons/inPhieuChuyenDonToCao?" + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan + "&donViTiepNhanDonId=" + donViTiepNhanDonId + "&coQuanChuyenDon=" + _this12.props.userInfo.tenCoQuanQuanLy;
                } else if (_this12.state.thongTinDon.loaiDonId == 'DON_KIEN_NGHI_PHAN_ANH') {
                  URL = URL + "/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?" + "ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND.ten + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan + "&coQuanChuyenDon=" + _this12.props.userInfo.tenCoQuanQuanLy;
                }
                window.open(URL, "_self");
              } else {
                (0, _toastr.Toastr)('Vui lòng chọn cơ quan tiếp nhận', 'warning');
              }
              return;

            case "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI":
              var apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?";
              if (_this12.state.loaiDonGiaTri == 'DON_TO_CAO') {
                apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyToCao?";
              } else if (_this12.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
                apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKienNghi?";
              }

              URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&nguoiToCao=" + nguoiDungDon.hoVaTen + "&nguoiKienNghi=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&diaChiNguoiToCao=" + diaChiNguoiDungDon + "&diaChiNguoiKienNghi=" + diaChiNguoiDungDon + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND.ten + "&noiDung=" + noiDung + "&donId=" + _this12.state.donId + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&lyDo=" + _this12.state.params.yKienXuLy + "&lyDoDinhChi=" + _this12.state.params.yKienXuLy + "&coQuanTiepNhan=" + _this12.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "HUONG_DAN":
              apiPrint = "/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?";
              if (_this12.state.loaiDonGiaTri == 'DON_TO_CAO') {
                apiPrint = "/xuLyDons/inPhieuHuongDanToCao?";
              }
              URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&soCMND=" + nguoiDungDon.soCMNDHoChieu + "&hoVaTen=" + nguoiDungDon.hoVaTen + "&diaChi=" + diaChiNguoiDungDon + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND.ten + "&noiDung=" + noiDung + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&coQuanTiepNhan=" + _this12.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH":
              apiPrint = "/xuLyDons/inPhieuHuongDanKienNghi?";
              URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&hoVaTen=" + nguoiDungDon.hoVaTen + "&diaChi=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&donViXuLyId=" + _this12.props.userInfo.donViId;
              window.open(URL, "_self");
              return;

            case "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN":

              URL = URL + "/xuLyDons/inPhieuTraDonChuyenKhongDungThamQuyen?" + "&coQuanNhanDon=" + _this12.props.userInfo.tenCoQuanQuanLy + "&coQuanChuyenDon=" + _this12.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + "&hoTenNguoiCoDon=" + nguoiDungDon.hoVaTen + "&ngayTiepNhan=" + ngayTiepNhan + "&donViXuLyId=" + _this12.props.userInfo.donViId + "&noiDung=" + noiDung + "&diaChi=" + diaChiNguoiDungDon;
              window.open(URL, "_self");
              return;
          }
        }
      });
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'hiddenLetterHistory',
    value: function hiddenLetterHistory(value) {
      this.setState({
        showHistory: value
      });
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(donId, data, loaiQT, buocGQ) {
      var listAddNew = [];
      var listUpdate = [];

      data.map(function (item, i) {
        if (item.ten) {
          var params = {
            don: { id: donId },
            loaiQuyTrinh: loaiQT,
            loaiTepDinhKem: 'QUYET_DINH'
          };
          if (item.ten) {
            params.ten = item.ten;
          }
          if (buocGQ) {
            params.buocGiaiQuyet = buocGQ;
          }
          if (item.tenFile) {
            params.tenFile = item.tenFile;
          }
          if (item.duongDan) {
            params.duongDan = item.duongDan;
          }
          if (item.required) {
            params.required = true;
          }
          if (item.typeRequired) {
            params.typeRequired = item.typeRequired;
          }
          if (item.soQuyetDinh) {
            params.soQuyetDinh = item.soQuyetDinh;
          }
          if (item.ngayQuyetDinh) {
            params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
          }
          if (item.taiLieuVanThuId) {
            params.id = item.taiLieuVanThuId;
            listUpdate.push(params);
          } else {
            listAddNew.push(params);
          }
        }
      });
      if (listAddNew.length) {
        _api.Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
      if (listUpdate.length) {
        _api.Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
      }
    }
  }, {
    key: 'saveTepDinhKem',
    value: function saveTepDinhKem(donId, callback) {
      var _this13 = this;

      this.state.dataFileDinhKem.map(function (item, i) {
        if (item.taiLieuVanThuId) {
          _this13.state.taiLieuVanThuUpdate[_this13.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(donId)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          _this13.state.taiLieuVanThu[_this13.state.taiLieuVanThu.length] = {
            don: {
              id: Number(donId)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: _this13.state.loaiTepDinhKem,
            loaiQuyTrinh: _this13.state.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
        _this13.updateTaiLieuVanThu(_this13.state.taiLieuVanThuUpdate, function () {
          _this13.deleteTaiLieuVanThu(_this13.state.taiLieuVanThuDelete, function () {
            callback();
          });
        });
      });
    }
  }, {
    key: 'onChangeTepDinhKem',
    value: function onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
      this.setState({
        loaiQuyTrinh: loaiQuyTrinh,
        loaiTepDinhKem: loaiTepDinhKem,
        dataFileDinhKem: tepDinhKem,
        dataTaiLieuVanThuDelete: deleteTepDinhKem
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'closeMaTraCuuDialog',
    value: function closeMaTraCuuDialog() {
      this.setState({ maTraCuuDialog: false });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var valid = function valid(current) {
        return current.isBefore((0, _moment2.default)());
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_dialog.MaTraCuuDialog, { open: this.state.maTraCuuDialog, code: this.state.code, onClose: this.closeMaTraCuuDialog.bind(this) }),
        _react2.default.createElement(_reception.SearchFullNamePopup, { self: this.state }),
        _react2.default.createElement(_reception.ListInfoDocumentDialog, { self: this.state }),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { id: 'page', className: 'add-reception panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleBack.bind(this, false), title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-add' },
                this.props.params.type == 'them-moi' ? 'THÊM MỚI ĐƠN/ VỤ VIỆC' : '',
                this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA ĐƠN/ VỤ VIỆC' : ''
              )
            ),
            this.state.dataLoading ? _react2.default.createElement(_LoadingData2.default, null) : _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'form',
                { className: 'form' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward ' },
                      _react2.default.createElement(
                        'div',
                        { className: 'container-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form' },
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl10 pr10 box-top' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(_common.DatePicker, {
                                  className: 'col-input mb0-18',
                                  label: 'Ng\xE0y ti\u1EBFp nh\u1EADn',
                                  name: 'ngayTiep',
                                  dateFormat: 'DD/MM/YYYY -',
                                  timeFormat: 'HH:mm',
                                  value: this.state.ngayTiepNhan,
                                  onChange: this.handleChangeDate.bind(this, 'ngayTiepNhan'),
                                  maxLength: 18,
                                  isValidDate: valid }),
                                _react2.default.createElement(_ttForms.DropDownChonNguonDon, {
                                  selectedValue: this.state.nguonDon,
                                  bindValidator: this,
                                  require: true,
                                  exceptNguonDon: 'GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH',
                                  onChange: this.onChange.bind(this, 'nguonDon'),
                                  className: 'col-input mb0-18'
                                }),
                                this.state.nguonDon == 'KHAC' && _react2.default.createElement(_common.Input, { className: 'col-input mb0-18 mt21', name: 'nguonDonKhac', placeholder: 'Nh\u1EADp ngu\u1ED3n \u0111\u01A1n kh\xE1c...', maxLength: 255, value: this.state.nguonDonKhac, onChange: this.onChange.bind(this, 'nguonDonKhac') })
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_reception.ThongTinNguoiDungDon, {
                    onChange: this.onChangeData.bind(this),
                    onInit: this.onInitComponent.bind(this),
                    bindValidator: this,
                    onSave: this.state.isSave,
                    onRemove: this.handleRemove.bind(this) }),
                  _react2.default.createElement(_reception.ThongTinDon, {
                    checkValidate: this.state.checkValidate,
                    onChange: this.onChangeData.bind(this),
                    onInit: this.onInitComponent.bind(this),
                    onSave: this.state.isSave,
                    bindValidator: this,
                    isTraCuu: true,
                    isDonCu: false,
                    xuLyDon: true }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showHistory && this.state.donId != 0 },
                    _react2.default.createElement(_letterHistory2.default, { pageType: 'THEM_MOI_VA_CHINH_SUA_DON', donId: this.state.donId, onChange: this.hiddenLetterHistory.bind(this) })
                  ),
                  this.props.params && this.props.params.type !== 'chinh-sua' && _react2.default.createElement(_xuLyDon.FormXuLyHoacGiaiQuyet, {
                    checkValidate: this.state.checkValidate,
                    thongTinDon: this.state.thongTinDon,
                    loaiDonKhongQuyTrinh: this.state.params,
                    loaiDonGiaTri: this.state.thongTinDon ? this.state.thongTinDon.loaiDonId : '',
                    onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this),
                    thongTinXuLyGiaiQuyet: this.state.thongTinXuLy,
                    title: this.state.title,
                    alias: this.state.alias,
                    donId: this.state.donId,
                    listNextStates: this.state.listNextStates,
                    onChange: this.handleDataForm.bind(this),
                    onInit: this.handleInitDataForm.bind(this),
                    validate: this.state.validate,
                    donDangXuLy: this.state.donDangXuLy,
                    processType: this.state.processType,
                    inPhieu: this.inPhieu.bind(this),
                    trangThaiDonDonVi: {},
                    bindValidator: this,
                    onSave: this.state.isSave,
                    action: 'them-moi',
                    listTaiLieuVanThu: this.state.listTaiLieuVanThu,
                    pageType: 'THEM_MOI_VA_CHINH_SUA_DON' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt30 mb30' },
                  _react2.default.createElement(_buttonGroup2.default, {
                    canBoDangXuLy: this.state.canBoDangXuLy,
                    pageType: 'THEM_MOI_VA_CHINH_SUA_DON',
                    alias: this.state.alias,
                    donId: this.state.donId,
                    lanhDaoDuyet: this.state.lanhDaoDuyet,
                    params: this.state.params,
                    donDangXuLy: this.state.donDangXuLy,
                    processType: this.state.processType,
                    onClose: this.handleBack.bind(this, false),
                    onSave: this.createDon.bind(this, true),
                    onClickXuLyDon: this.xuLyDon.bind(this),
                    btnLoading: this.state.btnLoading,
                    btnSaveLoading: this.state.btnSaveLoading,
                    onClickSaveFile: this.saveTepDinhKem.bind(this),
                    validateSubmitForm: this.validateSubmitForm.bind(this),
                    bindValidator: this,
                    trangThaiDonDonVi: {},
                    btnSaving: this.state.btnSaving })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddHandleLetter;
}(_react2.default.Component);

AddHandleLetter.defaultProps = {
  validators: {},
  noiCapCMNDList: []
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    noiCapCMNDList: state.duLieuHeThong.noiCapCMND,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(AddHandleLetter);

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddHandleLetter = undefined;

var _AddHandleLetter = __webpack_require__(1155);

var _AddHandleLetter2 = _interopRequireDefault(_AddHandleLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddHandleLetter = _AddHandleLetter2.default;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(1162);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_React$Component) {
  _inherits(ButtonGroup, _React$Component);

  function ButtonGroup(props, context) {
    _classCallCheck(this, ButtonGroup);

    var _this = _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call(this, props, context));

    _this.state = {
      hideBtn: false,
      haveDialog: false,
      openDialog: false,
      contentDialog: '',
      btnName: '',
      buttonShow: false,
      btnProccess: false
    };
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: 'onChange',
    value: function onChange(state) {

      this.props.onChange(state);
    }

    // Gan ten cho button theo quy trinh

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if (nextProps.alias && this.props.alias != nextProps.alias || this.props.params != nextProps.params) {
        var ttxmText = this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
        switch (nextProps.alias) {
          case 'WordProcessingOperatorAction':
            if (nextProps.params) {
              if (nextProps.params.nextState) {
                if (nextProps.params.nextState.type == _processType.processType.xuLyDon.processing.trinhLanhDao) {
                  this.setState({
                    btnName: 'Trình',
                    hideBtn: false
                  });

                  return;
                }

                if (nextProps.params.nextState.type == _processType.processType.xuLyDon.processing.trinhTruongPhong) {
                  this.setState({
                    btnName: 'Trình',
                    hideBtn: false
                  });

                  return;
                }

                if (nextProps.params.nextState.type == _processType.processType.xuLyDon.processing.yeuCauGapLanhDao) {
                  this.setState({
                    btnName: 'Chuyển yêu cầu',
                    hideBtn: false
                  });

                  return;
                }
              } else {
                this.setState({
                  hideBtn: true
                });
              }
            }
            break;
          case 'ManagerAction':
            if (nextProps.params) {
              if (nextProps.params.nextState) {
                this.setState({
                  btnName: 'Giao việc',
                  hideBtn: false
                });

                return;
              } else {
                this.setState({
                  hideBtn: true
                });
              }
            }
            break;
          case 'LeaderAction':
            if (nextProps.params) {
              if (nextProps.params.nextState && typeof nextProps.params.huongXuLy == 'undefined') {
                this.setState({
                  btnName: 'Giao việc',
                  hideBtn: false,
                  buttonShow: true,
                  haveDialog: false,
                  btnProccess: false
                });
                return;
              } else if (nextProps.params.huongXuLy) {

                switch (nextProps.params.huongXuLy) {
                  case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:
                    if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                      this.setState({
                        btnName: 'Chuyển giải quyết đơn',
                        haveDialog: true,
                        contentDialog: null,
                        btnProccess: true,
                        buttonShow: true,
                        hideBtn: false,
                        truongPhongXLD: true
                      });
                    } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {

                      this.setState({
                        btnName: 'Chuyển đơn vị ' + ttxmText,
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' ' + ttxmText + ' không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else {

                      this.setState({
                        btnProccess: true,
                        buttonShow: false
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.chuyenDon:
                    var tenCoQuan = '';
                    var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                    if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId && nextProps.params.coQuanTiepNhan) {
                      tenCoQuan = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                      this.setState({
                        btnName: 'Chuyển đơn',
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + tenCoQuan + ' giải quyết không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != thamQuyenHanhChinhId) {
                      this.setState({
                        btnName: 'Lưu hồ sơ',
                        haveDialog: true,
                        contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else {
                      this.setState({
                        hideBtn: true
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                    var noticeTraDon = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                    this.setState({
                      btnName: 'Trả đơn chuyển',
                      haveDialog: true,
                      contentDialog: noticeTraDon,
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                    this.setState({
                      haveDialog: false,
                      btnName: 'Gửi yêu cầu',
                      btnProccess: false,
                      hideBtn: false
                    });
                    break;
                  default:
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                }
              } else {
                this.setState({
                  hideBtn: true,
                  buttonShow: false
                });
              }
            }
            break;
          case 'XuLyDonTuXuLy':
          case 'WordProcessingSpecialistAction':
            if (nextProps.params) {
              if (nextProps.params.huongXuLy) {
                switch (nextProps.params.huongXuLy) {
                  case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:
                    if (nextProps.alias === 'WordProcessingSpecialistAction' || nextProps.alias === 'XuLyDonTuXuLy' || nextProps.alias === 'WordProcessingSpecialistActionNoProcess') {

                      if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                        this.setState({
                          btnName: 'Chuyển giải quyết đơn',
                          haveDialog: true,
                          contentDialog: null,
                          chuyenVienXLD: true,
                          btnProccess: true,
                          buttonShow: true,
                          hideBtn: false
                        });
                      } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {
                        this.setState({
                          btnName: 'Chuyển đơn vị ' + ttxmText,
                          haveDialog: true,
                          contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' ' + ttxmText + ' không?',
                          btnProccess: false,
                          buttonShow: false,
                          hideBtn: false
                        });
                      } else {
                        this.setState({
                          btnProccess: true,
                          buttonShow: false
                        });
                      }
                    } else {
                      this.setState({
                        haveDialog: false,
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.chuyenDon:
                    var _tenCoQuan = '';
                    var _thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                    if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == _thamQuyenHanhChinhId && nextProps.params.coQuanTiepNhan) {
                      _tenCoQuan = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                      this.setState({
                        btnName: 'Chuyển đơn',
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + _tenCoQuan + ' giải quyết không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != _thamQuyenHanhChinhId) {
                      this.setState({
                        btnName: 'Lưu hồ sơ',
                        haveDialog: true,
                        contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else {
                      this.setState({
                        hideBtn: true
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                    var _noticeTraDon = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                    this.setState({
                      btnName: 'Trả đơn chuyển',
                      haveDialog: true,
                      contentDialog: _noticeTraDon,
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                    this.setState({
                      haveDialog: false,
                      btnName: 'Gửi yêu cầu',
                      btnProccess: false,
                      hideBtn: false
                    });
                    break;
                  default:
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                }
              } else {
                this.setState({
                  hideBtn: true,
                  buttonShow: false
                });
              }
            }
            break;
          case 'WordProcessingSpecialistActionNoProcess':
            if (nextProps.params) {
              if (nextProps.params.huongXuLy) {
                switch (nextProps.params.huongXuLy) {
                  case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:
                    if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                      this.setState({
                        btnName: 'Chuyển giải quyết đơn',
                        haveDialog: false,
                        btnProccess: true,
                        buttonShow: true,
                        hideBtn: false
                      });
                    } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {
                      this.setState({
                        btnName: 'Chuyển đơn vị ' + ttxmText,
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' ' + ttxmText + ' không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else {
                      this.setState({
                        btnProccess: true,
                        buttonShow: false
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.chuyenDon:
                    var _tenCoQuan2 = '';
                    var _thamQuyenHanhChinhId2 = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                    if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == _thamQuyenHanhChinhId2 && nextProps.params.coQuanTiepNhan) {
                      _tenCoQuan2 = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                      this.setState({
                        btnName: 'Chuyển đơn',
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + _tenCoQuan2 + ' giải quyết không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != _thamQuyenHanhChinhId2) {
                      this.setState({
                        btnName: 'Lưu hồ sơ',
                        haveDialog: true,
                        contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      });
                    } else {
                      this.setState({
                        hideBtn: true
                      });
                    }
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                    var _noticeTraDon2 = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                    this.setState({
                      btnName: 'Trả đơn chuyển',
                      haveDialog: true,
                      contentDialog: _noticeTraDon2,
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                  case _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                    this.setState({
                      haveDialog: false,
                      btnName: 'Gửi yêu cầu',
                      btnProccess: false,
                      hideBtn: false
                    });
                    break;
                  default:
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                    break;
                }
              } else {
                this.setState({
                  hideBtn: true,
                  buttonShow: false
                });
              }
            }
            break;
          case 'CanBoNhapLieuGiaiQuyetDonAction':
            this.setState({
              btnName: 'Chuyển'
            });
            break;
          case 'CanBoNhapLieuTTXMAction':
            this.setState({
              btnName: 'Trình'
            });
            break;
          case 'LanhDaoTTXMAction':
            if (nextProps.params) {
              if (nextProps.params.paramsPost) {
                if (nextProps.params.paramsPost.nextState) {
                  this.setState({
                    btnName: 'Giao việc',
                    hideBtn: false
                  });
                } else {
                  this.setState({
                    hideBtn: true
                  });
                }
              } else {
                this.setState({
                  hideBtn: true
                });
              }
            } else {
              this.setState({
                hideBtn: true
              });
            }
            break;
          case 'vanThuKiemTraDeXuat':
            this.setState({
              btnName: 'Trình'
            });
            break;
          case 'lanhDaoKiemTraDeXuat':
            this.setState({
              btnName: 'Giao việc'
            });
            break;
          case 'CanBoTTXMKhongQuyTrinh':
          case 'CanBoTTXMAction':
            var noticeCanBoTTXMAction = 'Bạn có đồng ý chuyển cho ' + (this.props.thongTinXuLyGiaiQuyet.donViGiaoThamTraXacMinhInfo ? this.props.thongTinXuLyGiaiQuyet.donViGiaoThamTraXacMinhInfo.ten : '') + ' báo cáo ' + ttxmText + ' của đơn/vụ việc này không?';
            var lb1 = this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
            this.setState({
              btnName: 'Gửi báo cáo ' + lb1 + ' cho đơn vị giao',
              haveDialog: true,
              contentDialog: noticeCanBoTTXMAction,
              btnProccess: false,
              buttonShow: false,
              hideBtn: false
            });
            break;
          default:
            break;
        }
      }
    }

    // Mo confirm dialog

  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.props.validateSubmitForm()) {

        this.setState({
          openDialog: true
        });
      }
    }

    // Dong confirm dialog

  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }

    // Di den chinh sua don/vu viec

  }, {
    key: 'goEdit',
    value: function goEdit(donId) {
      _reactRouter.browserHistory.push('/xu-ly-don/chinh-sua/' + donId);
    }
  }, {
    key: 'postProcess',
    value: function postProcess() {
      if (this.props.processType === 'XU_LY_DON' || this.props.alias === 'XuLyDonTuXuLy') {
        if (this.state.haveDialog && (this.props.alias === 'XuLyDonTuXuLy' || this.props.alias === 'WordProcessingSpecialistAction' || (this.props.alias === 'WordProcessingSpecialistActionNoProcess' || this.props.alias === 'LeaderAction') && this.props.params.huongXuLy === _processType.processType.xuLyDon.huongXuLy.deXuatThuLy || (this.props.alias === 'WordProcessingSpecialistActionNoProcess' || this.props.alias === 'LeaderAction') && this.props.params.huongXuLy === _processType.processType.xuLyDon.huongXuLy.chuyenDon)) {
          if (this.props.validateSubmitForm()) {
            this.openDialog();
          }
        } else {
          if (this.props.alias === 'XuLyDonTuXuLy') {
            this.props.onClickTuXuLy('BC_XLD');
          } else if (this.props.alias === 'LeaderAction') {
            this.props.onClickXuLyDon('BC_XLD');
          } else {
            this.props.onClickXuLyDon();
          }
        }
      } else if (this.props.processType === 'THAM_TRA_XAC_MINH' || this.props.processType === 'KIEM_TRA_DE_XUAT') {
        this.props.onClickGiaiQuyet();
      }
    }
  }, {
    key: 'onClickXuLyDon',
    value: function onClickXuLyDon() {
      if (this.props.alias === 'XuLyDonTuXuLy' || this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
        this.props.onClickXuLyDon('BC_XLD');
      } else if (this.props.alias === 'LeaderAction') {
        this.props.onClickXuLyDon('BC_XLD');
      } else {
        this.props.onClickXuLyDon();
      }
    }
  }, {
    key: 'onClickTuXuLy',
    value: function onClickTuXuLy() {
      if (this.props.alias === 'XuLyDonTuXuLy' || this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
        this.props.onClickTuXuLy('BC_XLD');
      } else {
        this.props.onClickTuXuLy();
      }
    }
  }, {
    key: 'patchProcess',
    value: function patchProcess(isLuutam) {
      if (this.props.alias === 'XuLyDonTuXuLy') {
        if (this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
          this.props.patchTuXuLy('BC_XLD');
        } else {
          this.props.patchTuXuLy();
        }
      } else if (this.props.processType === 'XU_LY_DON') {
        if (this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
          this.props.patchXuLyDon('BC_XLD');
        } else if (this.props.alias === 'LeaderAction') {
          this.props.patchXuLyDon('BC_XLD');
        } else {
          this.props.patchXuLyDon();
        }
      } else if (this.props.processType === 'THAM_TRA_XAC_MINH' || this.props.processType === 'KIEM_TRA_DE_XUAT') {
        this.props.patchGiaiQuyetDon(!isLuutam);
      } else if (this.props.processType === 'XULYDONCU') {
        this.props.onSave();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'action-form-wrap no-gutter' },
        _react2.default.createElement(
          'div',
          { className: 'box-bottom' },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', name: 'closebt', className: 'btn-action btn-close action-todo', onClick: this.props.onClose },
            '\u0110\xF3ng'
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.pageType === 'THEM_MOI_VA_CHINH_SUA_DON' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.props.lanhDaoDuyet },
              _react2.default.createElement(
                _core.Button,
                {
                  type: 'button',
                  className: this.props.btnLoading ? this.props.btnSaveLoading && this.props.btnSaving ? "btn-action btn-save btn-green btn-loading-inline" : 'btn-action btn-save btn-green btn-disable' : "btn-action btn-save btn-green",
                  onClick: this.props.onSave },
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.alias != 'WordProcessingSpecialistActionNoProcess' || this.props.alias === 'WordProcessingSpecialistActionNoProcess' && this.props.params.huongXuLy != _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.donDangXuLy && !this.state.hideBtn },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: this.props.btnLoading ? this.props.btnSaveLoading && this.props.btnSaving ? "btn-action btn-move btn-green btn-disable" : 'btn-action btn-move btn-green btn-loading-inline' : "btn-action btn-move btn-green right", onClick: this.props.onClickXuLyDon },
                  this.state.btnName
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.alias === 'WordProcessingSpecialistActionNoProcess' && this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.donDangXuLy && !this.state.hideBtn && !this.state.btnProccess },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: this.props.btnLoading ? this.props.btnSaveLoading ? "btn-action btn-move btn-green btn-disable right" : 'btn-action btn-move btn-green btn-loading-inline right' : "btn-action btn-move btn-green right",
                    onClick: this.postProcess.bind(this) },
                  this.state.btnName
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.donDangXuLy && !this.state.hideBtn && this.state.btnProccess },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: this.props.btnLoading ? this.props.btnSaveLoading ? "btn-action btn-move btn-green btn-disable right" : 'btn-action btn-move btn-green btn-loading-inline right' : "btn-action btn-move btn-green right",
                    onClick: this.props.onClickXuLyDon },
                  this.state.btnName
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.haveDialog },
                _react2.default.createElement(_dialog.ConfirmDialog, {
                  alias: this.props.alias,
                  title: 'X\xE1c nh\u1EADn',
                  params: this.props.params,
                  open: this.state.openDialog,
                  onClose: this.closeDialog.bind(this),
                  onSuccess: this.onClickXuLyDon.bind(this),
                  content: this.state.contentDialog,
                  bindValidator: this,
                  btnSaveLoading: this.props.btnSaveLoading,
                  btnLoading: this.props.btnLoading,
                  onChange: this.onChange.bind(this),
                  type: 'XLD',
                  buttonShow: this.state.buttonShow,
                  validateSubmitForm: this.props.validateSubmitForm
                })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.alias === 'DONCU' },
            _react2.default.createElement(
              _core.Button,
              { type: 'button', className: (0, _classnames2.default)('btn-action btn-save btn-green', { 'btn-loading-inline': this.props.btnSaveLoading, 'btn-disable': this.props.btnLoading }),
                onClick: this.patchProcess.bind(this, true) },
              'L\u01B0u'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.canBoDangXuLy) || this.props.alias === 'XuLyDonTuXuLy' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.pageType === 'CHI_TIET_DON' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.lanhDaoDuyet && this.props.trangThaiDonDonVi !== undefined && this.props.trangThaiDonDonVi.ketQuaType !== 'DINH_CHI' && !this.props.donInfo.hoanThanhDon && this.props.donInfo.thongTinGiaiQuyetDonInfo && !this.props.donInfo.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-edit btn-green', onClick: this.goEdit.bind(this, this.props.donId) },
                  'S\u1EEDa'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.donDangXuLy || this.props.alias === 'XuLyDonTuXuLy' },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-save btn-green ' + (this.props.btnSaveLoading ? 'btn-loading-inline' : this.props.btnLoading ? 'btn-disable' : ''),
                    onClick: this.patchProcess.bind(this, true) },
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: (this.props.alias === 'XuLyDonTuXuLy' || this.props.donDangXuLy) && !this.state.hideBtn && !this.state.btnProccess },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-move btn-green right ' + (this.props.btnLoading ? 'btn-loading-inline' : this.props.btnSaveLoading ? 'btn-disable' : ''), onClick: this.postProcess.bind(this) },
                  this.state.btnName
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.buttonShow && this.props.alias === 'WordProcessingSpecialistActionNoProcess' },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-move btn-green right ' + (this.props.btnLoading ? 'btn-loading-inline' : this.props.btnSaveLoading ? 'btn-disable' : ''), onClick: this.onClickXuLyDon.bind(this) },
                  'Chuy\u1EC3n gi\u1EA3i quy\u1EBFt \u0111\u01A1n'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.donDangXuLy && this.props.trangThaiDonDonVi && this.props.trangThaiDonDonVi.trangThaiDonType === 'DANG_XU_LY' },
                _react2.default.createElement(
                  _core.Button,
                  { type: 'button', className: 'btn-action btn-edit btn-green', onClick: this.goEdit.bind(this, this.props.donId) },
                  'S\u1EEDa'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.haveDialog },
                _react2.default.createElement(_dialog.ConfirmDialog, {
                  alias: this.props.alias,
                  title: 'X\xE1c nh\u1EADn',
                  params: this.props.params,
                  open: this.state.openDialog,
                  onClose: this.closeDialog.bind(this),
                  onSuccess: this.onClickXuLyDon.bind(this),
                  onTuXuLy: this.onClickTuXuLy.bind(this),
                  content: this.state.contentDialog,
                  bindValidator: this,
                  btnSaveLoading: this.props.btnSaveLoading,
                  btnLoading: this.props.btnLoading,
                  onChange: this.onChange.bind(this),
                  type: 'XLD',
                  truongPhongXLD: this.state.truongPhongXLD,
                  chuyenVienXLD: this.state.chuyenVienXLD,
                  buttonShow: this.state.buttonShow,
                  validateSubmitForm: this.props.validateSubmitForm,
                  onClickSaveFile: this.props.onClickSaveFile
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ButtonGroup;
}(_react2.default.Component);

ButtonGroup.defaultProps = {
  donInfo: {}
};

exports.default = (0, _utils.validatable)(ButtonGroup);

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _CheckPermission = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _CheckCanBoThuHoi = __webpack_require__(1235);

var _CheckQuyenTuXuLy = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListHandleLetters = function (_React$Component) {
  _inherits(RowItemListHandleLetters, _React$Component);

  function RowItemListHandleLetters(props, context) {
    _classCallCheck(this, RowItemListHandleLetters);

    var _this = _possibleConstructorReturn(this, (RowItemListHandleLetters.__proto__ || Object.getPrototypeOf(RowItemListHandleLetters)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: ''
    };
    return _this;
  }

  _createClass(RowItemListHandleLetters, [{
    key: 'getListData',
    value: function getListData() {
      this.props.getListData();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.item.trangThaiDonInfo) {
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == _this2.props.userInfo.donViId;
        }).map(function (child, i) {
          if (!_this2.props.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Rút đơn',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else {
            _this2.setState({
              ketQuaStr: child.ketQuaStr,
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          }
        });
      }

      if (this.props.item.canBoDangXuLyInfo) {
        this.props.item.canBoDangXuLyInfo.filter(function (item) {
          return item.donViId == _this2.props.userInfo.donViId;
        }).map(function (child, i) {
          if (child.hoVaTen != "") _this2.setState({
            canBoXuLy: child.hoVaTen
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.type && this.props.type != nextProps.type) {
        this.setState({
          type: nextProps.type
        });
      }
      if (nextProps.item.trangThaiDonInfo) {
        nextProps.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == nextProps.userInfo.donViId;
        }).map(function (child, i) {
          if (!nextProps.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this3.setState({
              ketQuaStr: 'Rút đơn',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else {
            _this3.setState({
              ketQuaStr: child.ketQuaStr,
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          }
        });
      }
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;
      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this4 = this;

      var ketQuaType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


      var thoiHanXuLy = {};
      if (this.checkDonViTTXM() && this.state.ketQuaType === 'DANG_LAP_DU_THAO') {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      } else if (ketQuaType != null && ketQuaType === 'DANG_TTXM') {
        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == _this4.props.userInfo.donViId;
          }).map(function (child, i) {

            if (child.trangThaiDonType === 'DANG_XU_LY') thoiHanXuLy = _this4.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType === 'DANG_GIAI_QUYET') thoiHanXuLy = _this4.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type === 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type === 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showCanBoDangXuLy',
    value: function showCanBoDangXuLy() {
      var _this5 = this;

      var state = this.state;
      this.props.item.canBoDangXuLyInfo.filter(function (item) {
        return item.donViId == _this5.props.userInfo.donViId;
      }).map(function (child, i) {
        state.canBoXuLy = child.hoVaTen || '';
      });
      this.setState(state);
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo && this.props.item.nguonDonInfo.length > 0) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type === 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type === 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type === 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'showThoiHanLapDuThao',
    value: function showThoiHanLapDuThao() {
      var thoiHanXuLy = null;
      if (_typeof(this.props.item) === 'object' && this.props.item.thoiHanGiaoLapDuThaoInfo) {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      }
      if (thoiHanXuLy && thoiHanXuLy.type === 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy && thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy && thoiHanXuLy.type === 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      if (data) {
        if (data.diaChi) {
          address.push(data.diaChi);
        }
        if (data.toThon) {
          address.push(data.toThon);
        }
        if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
          address.push(data.phuongXaCongDan.ten);
        }
        if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
          address.push(data.quanHuyenCongDan.ten);
        }
        if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
          address.push(data.tinhThanhCongDan.ten);
        }
      }
      return address.join(", ");
    }
  }, {
    key: 'checkDonKTDX',
    value: function checkDonKTDX() {
      if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkQuyenBoSungThongTin',
    value: function checkQuyenBoSungThongTin() {
      var data = [].concat(_toConsumableArray(this.props.item.listLichSuCanBoXuLy));
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataCheck = data.filter(function (state) {
        return state.congChucId == userInfo.id;
      });

      if (dataCheck.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(previewProps) {
      if (previewProps.item !== this.props.item) {
        this.showCanBoDangXuLy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var donId = this.props.item.donId;
      var linkToDetailPage = '/chi-tiet-xu-ly-don/xem/' + (this.props.type == 'DANG_XU_LY' ? 'dang/' : 'da/') + donId;
      var linkToProcessPage = '/chi-tiet-xu-ly-don/xu-ly/' + (this.props.type == 'DANG_XU_LY' ? 'dang/' : 'da/') + donId;
      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      var nguonDontype = this.checkNguonDon('nguonDontype');
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var showDelete = this.props.item.nguoiTaoId === userInfo.id;
      var trangThaiDon = '';
      if (_typeof(this.props.item) === 'object' && this.props.item.trangThaiDonInfo) {
        trangThaiDon = this.props.item.trangThaiDonInfo.filter(function (state) {
          return state.donViId == userInfo.donViId;
        });
      }
      var ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
      var CQQLBanTiepCongDan = ThamSo.find(function (item) {
        return item.ten === 'CQQL_BAN_TIEP_CONG_DAN';
      });
      var CQQLPhongNoiChinh = ThamSo.find(function (item) {
        return item.ten === 'CQQL_BAN_NOI_CHINH_THANH_UY';
      });

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma || this.props.item.maHoSo
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !(0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.item.canBoDangXuLyInfo) },
                this.props.donTreHanTaiDiaBan ? _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                }) : _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    className: 'txt-underline',
                    to: linkToDetailPage },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 3,
                    truncateText: '\u2026',
                    text: this.props.item.noiDung
                  })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.item.canBoDangXuLyInfo) },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    className: 'txt-underline',
                    to: linkToDetailPage },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 3,
                    truncateText: '\u2026',
                    text: this.props.item.noiDung
                  })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (!this.checkDonViTTXM() || trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM' && trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM_LAI') && (!this.checkDonViTTXM() || trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO') && trangThaiDon && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'LUU_HO_SO' },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanXuLyDon()
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.lyDoQuaHan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: nguonDonDonVi != '' && nguonDonDonVi != null },
              _react2.default.createElement(
                'li',
                { className: 'txt-italic' },
                nguonDonDonVi
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.trangThaiDonText != null && this.state.trangThaiDonText != '' },
              _react2.default.createElement(
                'li',
                null,
                this.state.trangThaiDonText
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaStr != null && this.state.ketQuaStr != '' },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: this.state.ketQuaStr || '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType === 'DANG_TTXM' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'p',
                  { className: '' },
                  this.showThoiHanXuLyDon(this.state.ketQuaType)
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType === 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanLapDuThao()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.state.canBoXuLy
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.tuXuLy && (0, _CheckPermission.CheckPermission)('XULYDON_SUA') && this.props.type === 'DA_XU_LY' && (0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(this.props.item.quyenTuXuLyInfo) },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: linkToProcessPage },
                  'T\u1EF1 x\u1EED l\xFD'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('XULYDON_SUA') && this.props.type === 'DANG_XU_LY' && (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.item.canBoDangXuLyInfo) },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: linkToProcessPage },
                  'X\u1EED l\xFD'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (CQQLBanTiepCongDan.giaTri === userInfo.coQuanQuanLyId || CQQLPhongNoiChinh.giaTri === userInfo.coQuanQuanLyId) && this.props.item.huongXuLyXLD === "CHUYEN_DON" && this.props.type === 'DA_XU_LY' && userInfo.isBoSungThongTin === true },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: '/bo-sung-thong-tin-chuyen-don/' + this.props.item.donId },
                  'B\u1ED5 sung'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckCanBoThuHoi.CheckCanBoThuHoi)(this.props.item.canBoCoTheThuHoiInfo) },
              _react2.default.createElement(_dialog.ThuHoiDialog, {
                title: 'Xác nhận',
                redux: this.props.parent,
                donId: this.props.item.donId,
                thongTinGiaiQuyetDonId: this.props.item.thongTinGiaiQuyetDonId || '',
                getListData: this.getListData.bind(this)
              })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.huongXuLyXLD != 'DINH_CHI' && nguonDontype != 'GIAO_TTXM' && !this.props.item.dangGiaoKTDX && !this.props.item.hoanThanhDon && !this.props.item.daGiaiQuyet && !this.checkDonKTDX() && this.props.item.loaiDon == 'DON_TO_CAO' && this.props.item.processType != null && this.props.item.processType != 'XU_LY_DON' && this.state.trangThaiDonType != 'DA_GIAI_QUYET' && this.props.item.donViXuLyGiaiQuyetInfo && userInfo.donViId == this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId },
              _react2.default.createElement(_dialog.GiaHanDialog, { id: donId,
                thongTinGiaiQuyetDonId: this.props.item.thongTinGiaiQuyetDonId,
                loaiDon: this.props.item.loaiDon,
                getListData: this.getListData.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('XULYDON_SUA') && !this.props.item.hoanThanhDon && !this.props.item.daGiaiQuyet && !this.checkDonKTDX() && nguonDontype != 'GIAO_TTXM' && !this.props.item.dangGiaoKTDX && this.props.item.processType != 'THEO_DOI_THUC_HIEN' && this.props.item.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH' && !this.props.item.ma && !this.props.donTreHanTaiDiaBan },
              _react2.default.createElement(_dialog.SuspendedDialog, { loaiDon: this.props.item.loaiDon, trangThaiDon: this.state.trangThaiDonType, type: 'XU_LY_DON', id: donId, getListData: this.getListData.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('XULYDON_XOA') && showDelete },
              _react2.default.createElement(_dialog.DeleteDialog, {
                title: 'Xoá đơn thư',
                content: 'Bạn có đồng ý xóa đơn thư này không?',
                redux: this.props.parent,
                deleteId: this.props.item.donId
              })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type === 'DA_XU_LY' && this.props.item.huongXuLyXLD != 'DINH_CHI' && this.checkQuyenBoSungThongTin && this.state.ketQuaType == 'LUU_HO_SO' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: '/bo-sung-thong-tin-xu-ly-don/' + this.props.item.donId },
                  'B\u1ED5 sung th\xF4ng tin'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemListHandleLetters;
}(_react2.default.Component);

RowItemListHandleLetters.defaultProps = {
  dataLoaiDonThu: [],
  tuXuLy: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemListHandleLetters);

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _letterHistory = __webpack_require__(236);

var _letterHistory2 = _interopRequireDefault(_letterHistory);

var _letterInformation = __webpack_require__(485);

var _letterInformation2 = _interopRequireDefault(_letterInformation);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _utils = __webpack_require__(4);

var _xuLyDon = __webpack_require__(312);

var _config = __webpack_require__(16);

var _buttonGroup = __webpack_require__(234);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _CheckPermission = __webpack_require__(20);

var _GetTrangThaiDonTheoDonVi = __webpack_require__(314);

var _subView = __webpack_require__(33);

var _formGiaiQuyet = __webpack_require__(310);

var _formKiemTraDeXuat = __webpack_require__(311);

var _CheckQuyenTuXuLy = __webpack_require__(193);

var _ParamsGiaiQuyetDon = __webpack_require__(482);

var _dialog = __webpack_require__(18);

var _giaiQuyetDon = __webpack_require__(142);

var _layout = __webpack_require__(9);

var _loading = __webpack_require__(313);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLettersDetails = function (_React$Component) {
  _inherits(HandleLettersDetails, _React$Component);

  function HandleLettersDetails(props, context) {
    _classCallCheck(this, HandleLettersDetails);

    var _this = _possibleConstructorReturn(this, (HandleLettersDetails.__proto__ || Object.getPrototypeOf(HandleLettersDetails)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      pageLoading: false,
      // URL param
      typePage: _this.props.params.typePage,
      donDangXuLy: _this.props.params.trangThaiDon == 'dang' ? true : false,

      title: '',
      huongXuLy: '',
      donId: _this.props.params.id,
      alias: '',
      listNextStates: [],
      params: [],
      data: [],
      processTypeValue: '',
      thongTinXuLyGiaiQuyet: {},

      // Thong tin don
      ma: '',
      ngayTiepNhan: '',

      // Trang thai don
      trangThaiDonDonVi: [],

      // Thong tin nguoi xu ly
      canBoDangXuLy: [],

      // Thong tin nguoi dung don
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],

      // Thong tin nguoi duoc uy quyen
      coUyQuyen: false,
      dataNguoiDuocUyQuyen: [],
      listTepUyQuyen: [],
      luatSu: false,
      listTepChungChiHanhNghe: [],

      // ThongTinDonVuViec
      nguonDon: '',
      noiDung: '',
      loaiDon: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      linhVucChiTietKhac: '',
      // Tai lieu kem theo
      listTaiLieuVanThu: [],
      listTaiLieuBangChung: [],
      listTaiLieuVanThuKiemTraDeXuat: [],
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],

      listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: [],
      listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: [],
      listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: [],
      listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: [],

      // Thong tin co quan dang giai quyet
      coThongTinCoQuanDangGiaiQuyet: false,
      dataCoQuanDangGiaiQuyet: {},

      // Thong tin co quan da giai quyet
      coThongTinCoQuanDaGiaiQuyet: false,
      dataCoQuanDaGiaiQuyet: {},
      lanhDaoDuyet: true,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      initTaiLieuVanThu: [],

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',
      tongSoLuotTCD: '',

      // Thong tin giai quyet don cua don
      thongTinGiaiQuyetDonId: '',
      thongTinGiaiQuyetDonPlus: {},

      // Danh sach tai lieu giai quyet don sau khi ttxm
      listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: [],
      dataKetQuaXuLyDon: {},

      noticeMsg: '',
      backConfirm: false,
      dialogConfirm: false,
      dialogConfirmContent: '',
      hasChange: false,
      openConfirmDialog: false,
      isSave: false,
      displayXuLyDon: true,
      thoiHanBaoCaoKetQuaTTXM: ''
    };
    return _this;
  }

  _createClass(HandleLettersDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetail(this.props.params.id);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.id != this.props.params.id) {
        this.getDetail(nextProps.params.id);
        this.setState({ donDangXuLy: nextProps.params.trangThaiDon == 'dang' ? true : false });
      }
    }
  }, {
    key: 'getTrangThaiDonHienTai',
    value: function getTrangThaiDonHienTai(donId, processType) {
      // Letter.actions.getTrangThaiDon.request({id: donId}, {quyTrinh: processType}).then(res => {
      //   if (res.data) {
      //     this.setState({donDangXuLy: res.data.trangThaiDon == 'DANG_XU_LY' ? true : false});
      //   }
      this.renderForm(donId);
      // });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      if (this.props.route.name == 'theodoi') {
        _reactRouter.browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
      } else {
        _reactRouter.browserHistory.goBack();
      }
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }

    // Gan du lieu xu ly don hoac giai quyet don

  }, {
    key: 'handleDataForm',
    value: function handleDataForm(state) {
      var noticeMsg = state.notice;
      delete state.messege;

      this.setState({
        params: state,
        noticeMsg: noticeMsg,
        hasChange: true
      });
    }
  }, {
    key: 'handleInitForm',
    value: function handleInitForm(state) {

      var noticeMsg = state.notice;
      delete state.messege;

      this.setState({
        params: state,
        noticeMsg: noticeMsg
      });
    }

    // An hien Qua Trinh Xu Ly

  }, {
    key: 'hiddenLetterHistory',
    value: function hiddenLetterHistory(value) {
      this.setState({
        showHistory: value
      });
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(donData) {
      var _this2 = this;

      _api.Reception.actions.getDonInfo.request({ id: donData.donId }).then(function (res) {
        if (res.data) {
          donData = _extends({}, donData, res.data);
        }
        _this2.getTrangThaiDonHienTai(donData.donId, donData.processType);
        _this2.setState({

          data: donData,

          // Quyen tu xu ly
          quyenTuXuLy: donData.quyenTuXuLyInfo,

          // Dinh chi
          lyDoDinhChi: donData.lyDoDinhChi ? donData.lyDoDinhChi : '',

          // Thong tin nguoi xu ly
          canBoDangXuLy: donData.canBoDangXuLyInfo,

          // Thong tin don
          ma: donData.ma,
          trangThaiDonDonVi: (0, _GetTrangThaiDonTheoDonVi.GetTrangThaiDonTheoDonVi)(donData.trangThaiDonInfo),
          ngayTiepNhan: donData.ngayTiepNhan,

          // Thong tin nguoi dung don
          loaiNguoiDungDon: donData.loaiNguoiDungDon ? donData.loaiNguoiDungDon : '',
          dataNguoiDungDon: donData.listNguoiDungDon ? donData.listNguoiDungDon : [],
          dataDoanDiCung: donData.loaiNguoiDungDon == 'DOAN_DONG_NGUOI' ? donData.listDoanDiCung ? donData.listDoanDiCung : [] : [],

          // Thong tin nguoi duoc uy quyen
          coUyQuyen: donData.coUyQuyen,
          dataNguoiDuocUyQuyen: donData.coUyQuyen ? donData.nguoiDuocUyQuyen : [],

          luatSu: donData.coUyQuyen && donData.nguoiDuocUyQuyen ? donData.nguoiDuocUyQuyen.luatSu : false,

          // ThongTinDonVuViec
          loaiDonGiaTri: donData.loaiDon ? donData.loaiDon : '',
          tongSoLuotTCD: donData.tongSoLuotTCD ? donData.tongSoLuotTCD : '',
          nguonDon: donData.nguonDonText ? donData.nguonDonText : '',
          noiDung: donData.noiDung ? donData.noiDung : '',
          loaiDon: donData.loaiDonText ? donData.loaiDonText : '',
          loaiDoiTuong: donData.loaiDoiTuongInfo ? donData.loaiDoiTuongInfo : '',
          linhVuc: donData.linhVucDonThuDon ? donData.linhVucDonThuDon.ten : '',
          linhVucChiTiet: donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon ? donData.linhVucDonThuChiTietDon.ten : '',
          linhVucChiTietSub: donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon && donData.chiTietLinhVucDonThuChiTietDon ? donData.chiTietLinhVucDonThuChiTietDon.ten : '',
          linhVucChiTietKhac: donData.linhVucChiTietKhac ? donData.linhVucChiTietKhac : '',
          // Tai lieu kem theo
          // HuongXuLy.jsx
          listTaiLieuVanThu: donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [],
          initTaiLieuVanThu: donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [],
          listTaiLieuVanThuBlockCoQuanDaGiaiQuyet: donData.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet ? donData.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet : [],
          // form-giai-quyet
          listTaiLieuVanThuGiaiQuyetDon: donData.listTaiLieuVanThuGiaiQuyetDon ? donData.listTaiLieuVanThuGiaiQuyetDon : [],
          listTaiLieuVanThuGiaiQuyetDonView: donData.listTaiLieuVanThuGiaiQuyetDonView || [],
          listTaiLieuBangChung: [].concat(_toConsumableArray(donData.listTaiLieuBangChung), _toConsumableArray(donData.listTaiLieuBangChungLuatSu)),
          listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: donData.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM || [],
          listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: donData.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ || [],
          listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: donData.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra || [],
          listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: donData.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ || [],
          // TrinhLanhDaoView
          listTaiLieuVanThuChuyenDonBoSungHoSo: donData.listTaiLieuVanThuChuyenDonBoSungHoSo || [],
          // form-kiem-tra-de-xuat
          listTaiLieuVanThuKiemTraDeXuat: donData.listTaiLieuVanThuKiemTraDeXuat ? donData.listTaiLieuVanThuKiemTraDeXuat : [],

          listTaiLieuVanThuBoSungHoSo: donData.listTaiLieuVanThuBoSungHoSo ? donData.listTaiLieuVanThuBoSungHoSo : [],
          // form TTXM
          listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM || [],
          listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView ? donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView : [],

          // Thong tin co quan dang giai quyet
          coThongTinCoQuanDangGiaiQuyet: donData.coQuanDangQuyetInfo ? true : false,
          dataCoQuanDangGiaiQuyet: donData.coQuanDangQuyetInfo ? donData.coQuanDangQuyetInfo : {},

          // Thong tin co quan da giai quyet
          coThongTinCoQuanDaGiaiQuyet: donData.coThongTinCoQuanDaGiaiQuyet,
          dataCoQuanDaGiaiQuyet: donData.coThongTinCoQuanDaGiaiQuyet && donData.coQuanDaGiaiQuyetDon ? donData.coQuanDaGiaiQuyetDon : {},
          lanhDaoDuyet: donData.lanhDaoDuyet,

          // Thong tin giai quyet don get ID
          thongTinGiaiQuyetDonId: donData.thongTinGiaiQuyetDonId,

          dataKetQuaXuLyDon: {
            thamQuyenGiaiQuyet: donData.thamQuyenGiaiQuyetInfo ? donData.thamQuyenGiaiQuyetInfo.ten : ''
          },
          pageLoading: false
        });
        if (donData.thongTinGiaiQuyetDonId) {
          // Lay thong tin giai quyet don Id neu co
          _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: donData.thongTinGiaiQuyetDonId }).then(function (dataGiaiQuyetDon) {
            if (dataGiaiQuyetDon.data) _this2.setState({
              thongTinGiaiQuyetDonPlus: dataGiaiQuyetDon.data
            });
          });
        }
      }).catch(function (e) {
        _this2.setState({ pageLoading: false });
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(inputId) {
      var _this3 = this;

      this.setState({ pageLoading: true });
      _api.Letter.actions.getDonDetail.request({ id: inputId }).then(function (res) {
        if (res.data) {
          if ((0, _CheckPermission.CheckViewPermission)(res.data)) {
            _this3.getDonInfo(res.data);
          } else {
            _reactRouter.browserHistory.push('/page-403');
          }
        }
      });
    }

    // Hien thi view NhiemVuTTXM hoac ThongTinYeuCauKTDX

  }, {
    key: 'viewInfomationWork',
    value: function viewInfomationWork() {
      if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH') {
        switch (this.state.alias) {
          case 'CanBoNhapLieuTTXMAction':
          case 'LanhDaoTTXMAction':
            return _react2.default.createElement(
              'div',
              { className: 'page-wrapper' },
              _react2.default.createElement(_formGiaiQuyet.NhiemVuTTXM, {
                thongTinGiaiQuyetDonPlus: this.state.thongTinGiaiQuyetDonPlus,
                thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
                listTaiLieuVanThuGiaiQuyetDon: this.state.listTaiLieuVanThuGiaiQuyetDon,
                donInfo: this.state.data
              })
            );
        }
      } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
        if (this.state.alias == 'canBoKiemTraDeXuat') {
          return _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_formKiemTraDeXuat.ThongTinYeuCauKTDX, {
              thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
              listTaiLieuVanThuKiemTraDeXuat: this.state.listTaiLieuVanThuKiemTraDeXuat,
              showTable: this.state.alias == 'vanThuKiemTraDeXuat' || this.state.alias == 'lanhDaoKiemTraDeXuat' || this.state.donDangXuLy && this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh'
            })
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_formKiemTraDeXuat.ThongTinYeuCauKTDX, {
              thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
              listTaiLieuVanThuKiemTraDeXuat: this.state.listTaiLieuVanThuKiemTraDeXuat,
              showTable: false })
          );
        }
      }
    }
  }, {
    key: 'renderForm',
    value: function renderForm(donId) {
      // Don dang xu ly thi goi API Current Form
      if (this.state.donDangXuLy) {
        this.getCurrentForm(donId);
      }

      this.getThongTinXuLyHoacGiaiQuyet(donId);
    }

    // Lay thong tin xu ly hoac giai quyet don
    // (1) Neu thong tin xu ly api tra ve khong co thi lay thong tin giai quyet api tra ve

  }, {
    key: 'getThongTinXuLyHoacGiaiQuyet',
    value: function getThongTinXuLyHoacGiaiQuyet(donId) {
      var _this4 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {

        if (res.data) {

          var info = res.data;
          var title = '';

          // Set title cho form xu ly
          if (_this4.state.donDangXuLy) title = 'Thông tin xử lý';else {

            // Kiem tra dieu kien hien thi form TU XU LY
            if ((0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(_this4.state.quyenTuXuLy) && _this4.state.typePage == 'xu-ly') {
              title = 'Thông tin xử lý';
            } else {
              title = 'Thông tin đã xử lý';
            }
          }

          _this4.setState({
            title: title,
            thongTinXuLyGiaiQuyet: info.thongTinXuLyInfo,
            thoiHanBaoCaoKetQuaTTXM: info.thongTinXuLyInfo.thoiHanBaoCaoKetQuaTTXM || ''
          });

          if (!_this4.state.donDangXuLy) {
            if ((0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(_this4.state.quyenTuXuLy) && _this4.state.typePage == 'xu-ly') {
              _this4.setState({
                alias: 'XuLyDonTuXuLy'
              });
            } else {
              _this4.setState({
                alias: info.nextFormInfo.alias
              });
            }
          }
        }
      }).catch(function (error) {

        if (error.response) {
          if ((0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(_this4.state.quyenTuXuLy) && _this4.state.typePage == 'xu-ly') {
            _this4.setState({ displayXuLyDon: false });
          } else if (error.response.data.errors[0].code == 'DATA_NOT_FOUND') {
            _this4.getThongTinGiaiQuyetDon(donId);
          }
        }
      });
    }

    // Neu (1) loi thi lay

  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(donId) {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request({ id: donId }).then(function (res) {
        if (res.data) {

          var info = res.data;
          var title = '';
          var alias = '';
          var processType = '';

          // Set title cho form giai quyet hoac kiem tra de xuat
          if (_this5.state.donDangXuLy) {

            if (_this5.state.processTypeValue == 'THAM_TRA_XAC_MINH' || _this5.state.processTypeValue == 'GIAI_QUYET_DON') {
              if (_this5.state.alias == 'CanBoTTXMAction') title = 'Báo cáo thẩm tra xác minh';else title = 'Thông tin giải quyết';
            } else if (_this5.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
              if (_this5.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {
                title = 'Báo cáo kết quả kiểm tra';
              } else {
                title = 'Thông tin đề xuất';
              }
            }
            alias = _this5.state.alias;
            processType = _this5.state.processTypeValue;
          } else {

            if (info.processType.type == 'KIEM_TRA_DE_XUAT') {

              title = 'Thông tin đã đề xuất';

              if (info.nextFormInfo.alias == 'canBoKiemTraDeXuat' || info.nextFormInfo.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {

                title = 'Báo cáo kết quả kiểm tra';
              }
            } else {

              if (info.nextFormInfo.alias == 'CanBoGiaiQuyetDonAction' || info.nextFormInfo.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' || info.nextFormInfo.alias == 'CanBoTTXMAction') {
                var lb2 = _this5.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
                title = 'Báo cáo kết quả xác minh' + lb2;
              }
            }

            processType = info.processType.type;
            alias = info.nextFormInfo.alias;
          }
          _this5.setState({
            alias: alias,
            title: title,
            processTypeValue: processType,
            thongTinXuLyGiaiQuyet: info
          });

          _this5.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
          _this5.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
          _this5.setState(_extends({}, _this5.state));
        }
      }).catch(function (error) {
        if (error.response) {}
      });
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(donId) {
      var _this6 = this;

      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(function (res) {
        if (res.data) {

          var info = res.data;

          _this6.setState({
            alias: info.currentForm.alias,
            processTypeValue: info.currentForm.processTypeInfo.giaTri,
            listNextStates: info.listNextStates
          });
        }
      }).catch(function (error) {
        if (error.response) {}
      });
    }
  }, {
    key: 'postTuXuLyDon',
    value: function postTuXuLyDon(type) {
      var _this7 = this;

      this.setState({ isSave: false }, function () {
        if (_this7.validateSubmitForm()) {
          _this7.setState({
            btnLoading: true
          });
          _this7.saveTepDinhKem(type, '', function () {
            if (!_this7.state.params.donViNgoaiHeThongId && _this7.state.params.donViNgoaiHeThong) {
              _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this7.state.params.donViNgoaiHeThong.trim() }).then(function (res) {
                if (res.data) {
                  _this7.state.params.donViNgoaiHeThong = { id: res.data.donViNgoaiHeThongId };
                  _api.LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', _this7.state.params).then(function (res) {
                    _this7.onClickClose();
                    (0, _toastr.Toastr)(_this7.state.noticeMsg, 'success');
                  }).catch(function (error) {
                    if (error.response) {
                      (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                    }
                    _this7.setState({
                      btnLoading: false
                    });
                  });
                }
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  _this7.setState({ btnLoading: false });
                }
              });
            } else {
              if (_this7.state.params.donViNgoaiHeThongId) {
                _this7.state.params.donViNgoaiHeThong = { id: _this7.state.params.donViNgoaiHeThongId };
              } else {
                _this7.state.params.donViNgoaiHeThong = null;
              }
              _api.LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', _this7.state.params).then(function (res) {
                _this7.onClickClose();
                (0, _toastr.Toastr)(_this7.state.noticeMsg, 'success');
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                }
                _this7.setState({
                  btnLoading: false
                });
              });
            }
          });
        }
      });
    }
  }, {
    key: 'patchTuXuLyDon',
    value: function patchTuXuLyDon(type) {
      var _this8 = this;

      this.setState({ isSave: true }, function () {

        _this8.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        _this8.saveTepDinhKem(type, 'save', function () {
          if (!_this8.state.params.donViNgoaiHeThongId && _this8.state.params.donViNgoaiHeThong) {
            _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this8.state.params.donViNgoaiHeThong.trim() }).then(function (res) {
              if (res.data) {
                _this8.state.params.donViNgoaiHeThong = { id: res.data.donViNgoaiHeThongId };
                _api.LetterProcessingWorkFlow.actions.patchTuXuLy.request({ id: _this8.state.donId }, _this8.state.params).then(function (res) {
                  _this8.onClickClose();
                  (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
                }).catch(function (error) {
                  if (error.response) {
                    (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  }
                });
              }
            }).catch(function (error) {
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                _this8.setState({ btnLoading: false });
              }
            });
          } else {
            if (_this8.state.params.donViNgoaiHeThongId) {
              _this8.state.params.donViNgoaiHeThong = { id: _this8.state.params.donViNgoaiHeThongId };
            } else {
              _this8.state.params.donViNgoaiHeThong = null;
            }
            _api.LetterProcessingWorkFlow.actions.patchTuXuLy.request({ id: _this8.state.donId }, _this8.state.params).then(function (res) {
              _this8.onClickClose();
              (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
            }).catch(function (error) {
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              }
            });
          }
        });
      });
    }
  }, {
    key: 'postXuLyDon',
    value: function postXuLyDon(type) {
      var _this9 = this;

      this.setState({ isSave: false }, function () {
        if (_this9.validateSubmitForm()) {
          _this9.setState({
            btnLoading: true
          });
          _this9.saveTepDinhKem(type, 'postXuLyDon', function () {
            if (!_this9.state.params.donViNgoaiHeThongId && _this9.state.params.donViNgoaiHeThong) {
              _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this9.state.params.donViNgoaiHeThong.trim() }).then(function (res) {
                if (res.data) {
                  _this9.state.params.donViNgoaiHeThong = { id: res.data.donViNgoaiHeThongId };
                  _api.LetterProcessingWorkFlow.actions.postXuLyDon.request('', _this9.state.params).then(function (res) {
                    _this9.onClickClose();
                    (0, _toastr.Toastr)(_this9.state.noticeMsg, 'success');
                  }).catch(function (error) {
                    if (error.response) {
                      (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                    }
                    _this9.setState({
                      btnLoading: false
                    });
                  });
                }
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  _this9.setState({ btnLoading: false });
                }
              });
            } else {
              if (_this9.state.params.donViNgoaiHeThongId) {
                _this9.state.params.donViNgoaiHeThong = { id: _this9.state.params.donViNgoaiHeThongId };
              } else {
                _this9.state.params.donViNgoaiHeThong = null;
              }
              _api.LetterProcessingWorkFlow.actions.postXuLyDon.request('', _this9.state.params).then(function (res) {
                _this9.onClickClose();
                (0, _toastr.Toastr)(_this9.state.noticeMsg, 'success');
              }).catch(function (error) {
                if (error.response) {
                  (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                }
                _this9.setState({
                  btnLoading: false
                });
              });
            }
          });
        }
      });
    }
  }, {
    key: 'patchXuLyDon',
    value: function patchXuLyDon(type) {
      var _this10 = this;

      this.setState({ isSave: true }, function () {
        _this10.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        _this10.saveTepDinhKem(type, 'save', function () {
          if (!_this10.state.params.donViNgoaiHeThongId && _this10.state.params.donViNgoaiHeThong) {
            _api.Danhmuc.actions.postDonViNgoai.request(null, { ten: _this10.state.params.donViNgoaiHeThong.trim() }).then(function (res) {
              if (res.data) {
                _this10.state.params.donViNgoaiHeThong = { id: res.data.donViNgoaiHeThongId };
                _api.LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: _this10.state.donId }, _this10.state.params).then(function (res) {
                  _this10.onClickClose();
                  (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
                }).catch(function (error) {
                  if (error.response) {
                    (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  }
                });
              }
            });
          } else {
            if (_this10.state.params.donViNgoaiHeThongId) {
              _this10.state.params.donViNgoaiHeThong = { id: _this10.state.params.donViNgoaiHeThongId };
            } else {
              _this10.state.params.donViNgoaiHeThong = null;
            }
            _api.LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: _this10.state.donId }, _this10.state.params).then(function (res) {
              _this10.onClickClose();
              (0, _toastr.Toastr)(_message.msg.xldLuu, 'success');
            }).catch(function (error) {
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              }
            });
          }
        });
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon() {
      var _this11 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });

        var paramsPost = this.state.params.paramsPost;

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.state.data.thongTinGiaiQuyetDonId

          // if (this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh')
        };this.saveTepDinhKem('', '', function () {
          _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', paramsPost).then(function (res) {
            _this11.onClickClose();
            (0, _toastr.Toastr)(_this11.state.noticeMsg, 'success');
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        });
      }
    }
  }, {
    key: 'patchGiaiQuyetDon',
    value: function patchGiaiQuyetDon() {
      var _this12 = this;

      var isPost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState({ isSave: !isPost }, function () {
        if (!isPost || _this12.validateSubmitForm()) {
          if (!isPost) {
            _this12.setState({
              btnSaveLoading: true
            });
          }

          var paramsPatch = (0, _ParamsGiaiQuyetDon.ConvertParams)(_this12.state.params.paramsPatch, _this12.state.donId);

          // if (this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh')
          _this12.saveTepDinhKem('', '', function () {
            _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: _this12.state.thongTinGiaiQuyetDonId }, paramsPatch).then(function (res) {
              if (!isPost) {
                _this12.onClickClose();
                (0, _toastr.Toastr)(_message.msg.gqdLuu, 'success');
              } else {
                _this12.postGiaiQuyetDon();
              }
            }).catch(function (error) {
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              }
            });
          });
        }
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'saveTepDinhKem',
    value: function saveTepDinhKem(type, action, callback) {
      var _this13 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });

      this.state.dataFileDinhKem.map(function (item, i) {

        if (item.taiLieuVanThuId) {
          _this13.state.taiLieuVanThuUpdate[_this13.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(_this13.state.donId)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          _this13.state.taiLieuVanThu[_this13.state.taiLieuVanThu.length] = {
            don: {
              id: Number(_this13.state.donId)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: _this13.state.loaiTepDinhKem,
            loaiQuyTrinh: _this13.state.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (type == 'BC_XLD') {
        var dataFilter = [];
        var dataInit = [].concat(_toConsumableArray(this.state.initTaiLieuVanThu));
        var data = [];
        if (this.state.data.ngayTraTTXMKhongDungThamQuyen) {
          data = dataInit.filter(function (state) {
            return _this13.compareDate(new Date(state.ngayTao), new Date(_this13.state.data.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
        } else if (this.state.data.ngayNhanDon) {
          data = dataInit.filter(function (state) {
            return _this13.compareDate(new Date(state.ngayTao), new Date(_this13.state.data.ngayNhanDon), 'action');
          });
        } else {
          data = [].concat(_toConsumableArray(dataInit));
        }
        if (this.state.params && this.state.params.huongXuLy == 'DE_XUAT_THU_LY') {
          if (this.state.params && this.state.params.trangThaiTTXM == 'GIAO_TTXM') {
            if (this.state.data.donGocId) {
              dataFilter = data.filter(function (item) {
                return item.required && item.typeRequired != 'XLD_PCD' && item.typeRequired != 'XLD_GTTXM' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null;
              });
            } else {
              dataFilter = data.filter(function (item) {
                return item.required && item.typeRequired != 'XLD_GTTXM' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null;
              });
            }
          } else {
            if (this.state.data.donGocId) {
              dataFilter = data.filter(function (item) {
                return item.required && item.typeRequired != 'XLD_PCD' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null;
              });
            } else {
              dataFilter = data.filter(function (item) {
                return item.required && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null;
              });
            }
          }
        } else if (this.state.params && this.state.params.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY') {
          dataFilter = data.filter(function (item) {
            return item.required && item.typeRequired != 'XLD_KDDKTL' && item.typeRequired != '' && item.typeRequired != null || !item.required && item.typeRequired == 'XLD_PDXTL';
          });
        } else if (this.state.params && this.state.params.huongXuLy == 'CHUYEN_DON') {
          dataFilter = data.filter(function (item) {
            return item.required && item.typeRequired != 'XLD_PCD' && item.typeRequired != '' && item.typeRequired != null || !item.required && item.typeRequired == 'XLD_PDXTL';
          });
        } else if (this.state.params && this.state.params.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
          dataFilter = data.filter(function (item) {
            return item.required && item.typeRequired != 'XLD_TDHD' && item.typeRequired != '' && item.typeRequired != null || !item.required && item.typeRequired == 'XLD_PDXTL';
          });
        } else if (this.state.params && this.state.params.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
          dataFilter = data.filter(function (item) {
            return item.required && item.typeRequired != 'XLD_TDKDTQ' && item.typeRequired != '' && item.typeRequired != null || !item.required && item.typeRequired == 'XLD_PDXTL';
          });
        } else {
          dataFilter = data.filter(function (item) {
            return item.required && (item.typeRequired != '' || item.typeRequired != null) || !item.required && item.typeRequired == 'XLD_PDXTL';
          });
        }
        if (dataFilter.length > 0) {
          if ((this.state.params.huongXuLy === 'DE_XUAT_THU_LY' || this.state.params.huongXuLy === 'CHUYEN_DON') && (action === 'save' || action === 'postXuLyDon')) {
            var listIdDelete = [];
            if (!(0, _lodash.isEmpty)(this.state.taiLieuVanThu)) {
              dataFilter.forEach(function (item) {
                _this13.state.taiLieuVanThu.forEach(function (taiLieu) {
                  if (item.donId === taiLieu.don.id) {
                    listIdDelete.push({
                      id: item.taiLieuVanThuId
                    });
                  }
                });
              });
            }
            this.setState({
              taiLieuVanThuDelete: listIdDelete
            });
          } else {
            dataFilter.map(function (item) {
              _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this13.updateTaiLieuVanThu(_this13.state.taiLieuVanThuUpdate, function () {
            _this13.deleteTaiLieuVanThu(_this13.state.taiLieuVanThuDelete, function () {
              callback();
            });
          });
        });
      } else {
        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this13.state.taiLieuVanThuDelete[_this13.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this13.updateTaiLieuVanThu(_this13.state.taiLieuVanThuUpdate, function () {
            _this13.deleteTaiLieuVanThu(_this13.state.taiLieuVanThuDelete, function () {
              callback();
            });
          });
        });
      }
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Thay doi tep dinh kem

  }, {
    key: 'onChangeTepDinhKem',
    value: function onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
      this.setState({
        loaiQuyTrinh: loaiQuyTrinh,
        loaiTepDinhKem: loaiTepDinhKem,
        dataFileDinhKem: tepDinhKem,
        dataTaiLieuVanThuDelete: deleteTepDinhKem
      });
    }

    // In phieu

  }, {
    key: 'inPhieu',
    value: function inPhieu(loaiPhieu) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var URL = String(_config.API_URL);
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      var loaiDon = this.state.loaiDon;
      var ngayTiepNhan = (0, _moment2.default)(this.state.ngayTiepNhan).format('DD/MM/YYYY');
      var nguoiDungDon = this.state.dataNguoiDungDon[0];
      var diaChiNguoiDungDon = '';
      var ngayCap = (0, _moment2.default)(nguoiDungDon.ngayCap).format('DD/MM/YYYY') == 'Invalid date' ? nguoiDungDon.ngayCap || '' : (0, _moment2.default)(nguoiDungDon.ngayCap).format('DD/MM/YYYY');
      var noiCapCMND = nguoiDungDon.noiCapCMNDInfo ? nguoiDungDon.noiCapCMNDInfo.ten : '';
      var cqTiepNhan = userInfo.tenCoQuanQuanLy;
      var donViTiepNhanDonId = '';
      if (loaiPhieu == 'CHUYEN_DON') {
        if (this.state.params.thamQuyenGiaiQuyet) {
          if (this.state.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId) {
            cqTiepNhan = this.state.params.coQuanTiepNhan.ten;
            donViTiepNhanDonId = this.state.params.coQuanTiepNhan.id;
          } else {
            cqTiepNhan = this.state.params.donViNgoaiHeThong;
          }
        } else {
          cqTiepNhan = '';
        }
      }
      if (nguoiDungDon.diaChi) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.diaChi + ', ';

      if (nguoiDungDon.toThon) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.toThon + ', ';

      if (nguoiDungDon.phuongXaCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.phuongXaCongDan.ten + ', ';

      if (nguoiDungDon.quanHuyenCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.quanHuyenCongDan.ten + ', ';

      if (nguoiDungDon.tinhThanhCongDan) diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.tinhThanhCongDan.ten + ', ';

      diaChiNguoiDungDon = diaChiNguoiDungDon.slice(0, diaChiNguoiDungDon.length - 2);

      var noiDung = this.state.noiDung;
      var coQuanChuyenDon = this.state.thongTinXuLyGiaiQuyet && this.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon ? this.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten : '';
      switch (loaiPhieu) {
        case "THU_LY":

          URL = URL + "/xuLyDons/inPhieuDeXuatThuLy?" + "loaiDon=" + loaiDon + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChi=" + diaChiNguoiDungDon + "&donViXuLyId=" + userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND + "&noiDung=" + noiDung;
          window.open(URL, "_self");
          return;

        case "DU_THAO_THONG_BAO_THU_LY":

          if (this.state.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKhieuNai?" + "ngayTiepNhan=" + ngayTiepNhan + "&nguoiKhieuNai=" + nguoiDungDon.hoVaTen + "&diaChiNguoiKhieuNai=" + diaChiNguoiDungDon + "&SoCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND + "&noiDungKhieuNai=" + noiDung + "&donViXuLyId=" + userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan;
          } else if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {

            URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyGQTC?" + "doiTuongGiaiQuyet=" + this.state.dataCoQuanDangGiaiQuyet.ten + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&donId=" + this.state.donId + "&donViXuLyId=" + userInfo.donViId + "&doiTuongBiToCao=" + this.state.loaiDoiTuong.ten + "&noiDungToCao=" + noiDung;
          }
          window.open(URL, "_self");
          return;

        case "CHUYEN_DON":
          if (cqTiepNhan) {
            this.setState({ isSave: true });
            if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
              URL = URL + "/xuLyDons/inPhieuChuyenDonToCao?" + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&donViXuLyId=" + userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan + "&donViTiepNhanDonId=" + donViTiepNhanDonId + "&coQuanChuyenDon=" + userInfo.tenCoQuanQuanLy;
            } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              URL = URL + "/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?" + "ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND + "&donViXuLyId=" + userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan + "&coQuanChuyenDon=" + userInfo.tenCoQuanQuanLy;
            }
            window.open(URL, "_self");
          } else {
            (0, _toastr.Toastr)('Vui lòng chọn cơ quan tiếp nhận', 'warning');
          }

          return;

        case "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI":
          var apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?";
          if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
            apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyToCao?";
          } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKienNghi?";
          }

          URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&nguoiToCao=" + nguoiDungDon.hoVaTen + "&nguoiKienNghi=" + nguoiDungDon.hoVaTen + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon + "&diaChiNguoiToCao=" + diaChiNguoiDungDon + "&diaChiNguoiKienNghi=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&donId=" + this.state.donId + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND + "&donViXuLyId=" + userInfo.donViId + "&lyDo=" + this.state.params.yKienXuLy + "&lyDoDinhChi=" + this.state.params.yKienXuLy + "&coQuanTiepNhan=" + cqTiepNhan;

          window.open(URL, "_self");
          return;

        case "HUONG_DAN":
          apiPrint = "/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?";
          if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
            apiPrint = "/xuLyDons/inPhieuHuongDanToCao?";
          }
          URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&nguoiDungDon=" + nguoiDungDon.hoVaTen + "&hoVaTen=" + nguoiDungDon.hoVaTen + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu + "&soCMND=" + nguoiDungDon.soCMNDHoChieu + "&diaChi=" + diaChiNguoiDungDon + "&ngayCap=" + ngayCap + "&noiCap=" + noiCapCMND + "&noiDung=" + noiDung + "&donViXuLyId=" + userInfo.donViId + "&coQuanTiepNhan=" + cqTiepNhan;
          window.open(URL, "_self");
          return;

        case "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH":
          apiPrint = "/xuLyDons/inPhieuHuongDanKienNghi?";
          URL = URL + apiPrint + "&ngayTiepNhan=" + ngayTiepNhan + "&hoVaTen=" + nguoiDungDon.hoVaTen + "&diaChi=" + diaChiNguoiDungDon + "&noiDung=" + noiDung + "&donViXuLyId=" + userInfo.donViId;
          window.open(URL, "_self");
          return;

        case "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN":

          URL = URL + "/xuLyDons/inPhieuTraDonChuyenKhongDungThamQuyen?" + "loaiDon=" + loaiDon + "&coQuanNhanDon=" + this.state.dataCoQuanDangGiaiQuyet.ten + "&coQuanChuyenDon=" + coQuanChuyenDon + "&hoTenNguoiCoDon=" + nguoiDungDon.hoVaTen + "&ngayTiepNhan=" + ngayTiepNhan + "&noiDung=" + noiDung + "&donViXuLyId=" + userInfo.donViId + "&diaChi=" + diaChiNguoiDungDon;
          window.open(URL, "_self");
          return;

        case "PHIEU_GIAO_NHIEM_VU_TTXM":
          apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?";
          if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
            apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?";
          } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKienNghi?";
          }

          URL = URL + apiPrint + "tenCoQuanThuLyGQKN=" + (this.state.dataCoQuanDangGiaiQuyet ? this.state.dataCoQuanDangGiaiQuyet.ten : '') + "&tenCoQuan=" + this.state.dataCoQuanDangGiaiQuyet.ten + "&ngayTiepNhan=" + ngayTiepNhan + "&diaChi=" + diaChiNguoiDungDon + "&tenCoQuanDuocGiaoNhiemVuXM=" + (this.state.params.donViThamTraXacMinhTen ? this.state.params.donViThamTraXacMinhTen : '..........') + "&hoTenNguoiKhieuNai=" + nguoiDungDon.hoVaTen + "&hoTenNguoiKienNghi=" + nguoiDungDon.hoVaTen + "&thoiGianBaoCaoKetQuaTTXM=" + (this.state.params.thoiHanBaoCaoKetQuaTTXM ? (0, _moment2.default)(this.state.params.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '') + "&donViXuLyId=" + userInfo.donViId + "&donId=" + this.state.donId + "&noiDungDonThu=" + noiDung + "&noiDungTTXM=" + noiDung;
          window.open(URL, "_self");
          return;
      }
    }
  }, {
    key: 'validateThongTinNguoiDungDon',
    value: function validateThongTinNguoiDungDon() {
      var dataDon = this.state.data;
      if (dataDon.nguonTiepNhanDonInfo && dataDon.listNguoiDungDon && dataDon.listNguoiDungDon.length) {
        return true;
      }
      return false;
    }
  }, {
    key: 'validateThongTinDon',
    value: function validateThongTinDon() {
      var dataDon = this.state.data;
      var noiDung = dataDon.noiDung;
      if (typeof noiDung === 'string' || noiDung instanceof String) {
        noiDung = noiDung.trim();
      }
      if (dataDon.loaiDonInfo && dataDon.linhVucDonThuDon && noiDung && dataDon.listTaiLieuBangChung && dataDon.listTaiLieuBangChung.length) {
        return true;
      }
      return false;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (this.validateThongTinNguoiDungDon() === false || this.validateThongTinDon() === false) {
        this.setState({
          dialogConfirm: true,
          dialogConfirmContent: 'Vui lòng kiểm tra lại thông tin đơn.'
        });
        pass = false;
      }

      if (typeof this.props.validators['formTaoDon'] != 'undefined') {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else {
            validator.validate();
          }
          if (!validator.validate() && (0, _lodash.get)(validator, 'props.checkValid')) {
            pass = true;
          }
        });
      }
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        this.onClickClose();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.onClickClose();
        }
      }
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      this.setState(_defineProperty({}, name, status));
    }
  }, {
    key: 'onConfirmDelete',
    value: function onConfirmDelete() {
      var linkToProcessPage = '/xu-ly-don/chinh-sua/' + this.state.donId;
      _reactRouter.browserHistory.push(linkToProcessPage);
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          null,
          this.state.displayXuLyDon ? _react2.default.createElement(
            'div',
            { id: 'page', className: 'panel-page document-detail-page' },
            _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.dialogConfirm, onClose: this.toggleDialog.bind(this, 'dialogConfirm', false), onSuccess: this.onConfirmDelete.bind(this), title: this.state.dialogConfirmContent }),
            _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true), title: _message.msg.confirmBack }),
            this.state.pageLoading ? _react2.default.createElement(_loading.Loading, null) : '',
            _react2.default.createElement(
              'div',
              { className: 'center ' + (this.state.pageLoading ? 'hidden' : '') },
              _react2.default.createElement(
                'div',
                { className: 'back-foward' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.handleBack.bind(this, false), title: '' },
                  'V\u1EC1 trang tr\u01B0\u1EDBc'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'heading' },
                _react2.default.createElement(
                  'h2',
                  { className: 'heading-title icon-detail' },
                  'Chi ti\u1EBFt \u0111\u01A1n/ v\u1EE5 vi\u1EC7c'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'page-wrapper' },
                _react2.default.createElement(_letterInformation2.default, {
                  parent: this.state,
                  donId: this.state.donId,
                  typePage: this.state.typePage,
                  thongTinGiaiQuyetDonId: this.state.thongTinGiaiQuyetDonId,
                  thongTinGiaiQuyetDonPlus: this.state.thongTinGiaiQuyetDonPlus })
              ),
              _react2.default.createElement(_letterHistory2.default, { donId: this.props.params.id, ma: this.state.ma }),
              this.state.alias == 'CanBoGiaiQuyetDonAction' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' ? _react2.default.createElement(
                'div',
                { className: 'page-wrapper' },
                _react2.default.createElement(_subView.KetQuaXuLyDon, _extends({ status: false
                }, this.state.dataKetQuaXuLyDon, {
                  donInfo: this.state.data,
                  dataGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
                  hideBorder: true
                }))
              ) : '',
              this.viewInfomationWork(),
              this.state.donDangXuLy && (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.state.canBoDangXuLy) || !this.state.donDangXuLy && (this.state.alias || this.state.trangThaiDonDonVi.ketQuaType == 'DINH_CHI') ? _react2.default.createElement(
                'div',
                { className: 'page-wrapper' },
                _react2.default.createElement(_xuLyDon.FormXuLyHoacGiaiQuyet, {
                  ma: this.state.ma,
                  lyDoDinhChi: this.state.lyDoDinhChi,
                  loaiDonGiaTri: this.state.loaiDonGiaTri,
                  onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this),
                  thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
                  thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
                  title: this.state.title,
                  alias: this.state.alias,
                  donId: this.props.params.id,
                  listNextStates: this.state.listNextStates,
                  onChange: this.handleDataForm.bind(this),
                  onInit: this.handleInitForm.bind(this),
                  donDangXuLy: this.state.donDangXuLy,
                  tongSoLuotTCD: this.state.tongSoLuotTCD,
                  thongTinGiaiQuyetDonId: this.state.thongTinGiaiQuyetDonId,
                  processType: this.state.processTypeValue,
                  listTaiLieuVanThu: this.state.listTaiLieuVanThu,
                  listTaiLieuVanThuKiemTraDeXuat: this.state.listTaiLieuVanThuKiemTraDeXuat,
                  listTaiLieuVanThuGiaiQuyetDon: this.state.listTaiLieuVanThuGiaiQuyetDon,
                  listTaiLieuVanThuGiaiQuyetDonView: this.state.listTaiLieuVanThuGiaiQuyetDonView,
                  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: this.state.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: this.state.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.state.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.state.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.state.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.state.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  listTaiLieuVanThuBoSungHoSo: this.state.listTaiLieuVanThuBoSungHoSo,
                  thongTinGiaiQuyetDonPlus: this.state.thongTinGiaiQuyetDonPlus,
                  listTaiLieuVanThuChuyenDonBoSungHoSo: this.state.listTaiLieuVanThuChuyenDonBoSungHoSo,
                  inPhieu: this.inPhieu.bind(this),
                  trangThaiDonDonVi: this.state.trangThaiDonDonVi,
                  bindValidator: this,
                  donInfo: this.state.data,
                  onSave: this.state.isSave,
                  data: this.state.data,
                  thuHoi: this.props.thuHoi,
                  pageType: 'CHI_TIET_DON' })
              ) : ''
            ),
            _react2.default.createElement(
              'div',
              { className: (this.state.alias == 'canBoTDTHKhongQuyTrinh' || this.state.alias == 'LanhDaoTDTHAction' || this.state.alias == 'CanBoNhapLieuTDTHAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh' || this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoTTXMChuyenDuThaoKhongQuyTrinh' || this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' && (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.state.canBoDangXuLy)) && this.state.donDangXuLy ? "center mb100 mt30" : "center mb30 mt30" },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.alias != 'canBoTDTHKhongQuyTrinh' && this.state.alias != 'LanhDaoTDTHAction' && this.state.alias != 'CanBoNhapLieuTDTHAction' && this.state.alias != 'CanBoTTXMKhongQuyTrinh' && this.state.alias != 'CanBoTTXMAction' && this.state.alias != 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh' && this.state.alias != 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' && this.state.alias != 'CanBoGiaiQuyetDonKhongQuyTrinh' && this.state.alias != 'canBoKiemTraDeXuatKhongQuyTrinh' && this.state.alias != 'CanBoTTXMChuyenDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' && !(0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.state.canBoDangXuLy) || !this.state.donDangXuLy },
                _react2.default.createElement(_buttonGroup2.default, {
                  canBoDangXuLy: this.state.canBoDangXuLy,
                  trangThaiDonDonVi: this.state.trangThaiDonDonVi,
                  pageType: 'CHI_TIET_DON',
                  alias: this.state.alias,
                  donId: this.state.donId,
                  lanhDaoDuyet: this.state.lanhDaoDuyet,
                  donInfo: this.state.data,
                  onClose: this.handleBack.bind(this, false),
                  onClickXuLyDon: this.postXuLyDon.bind(this),
                  onClickGiaiQuyet: this.patchGiaiQuyetDon.bind(this, true),
                  onClickSaveFile: this.saveTepDinhKem.bind(this, ''),
                  onClickTuXuLy: this.postTuXuLyDon.bind(this),
                  patchTuXuLy: this.patchTuXuLyDon.bind(this),
                  patchXuLyDon: this.patchXuLyDon.bind(this),
                  patchGiaiQuyetDon: this.patchGiaiQuyetDon.bind(this, false),
                  params: this.state.params,
                  donDangXuLy: this.state.donDangXuLy,
                  processType: this.state.processTypeValue,
                  btnLoading: this.state.btnLoading,
                  btnSaveLoading: this.state.btnSaveLoading,
                  validateSubmitForm: this.validateSubmitForm.bind(this),
                  bindValidator: this,
                  thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
                  onChange: this.handleDataForm.bind(this) })
              )
            )
          ) : _react2.default.createElement(_giaiQuyetDon.TuGiaiQuyetDon, { params: { id: this.props.params.id }, fromXLD: true })
        )
      );
    }
  }]);

  return HandleLettersDetails;
}(_react2.default.Component);

HandleLettersDetails.defaultProps = {
  validators: []
};

exports.default = (0, _reactRedux.connect)()(HandleLettersDetails);

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleLettersDetails = undefined;

var _HandleLettersDetails = __webpack_require__(1159);

var _HandleLettersDetails2 = _interopRequireDefault(_HandleLettersDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HandleLettersDetails = _HandleLettersDetails2.default;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _processType = __webpack_require__(57);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var ConfirmDialog = function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  function ConfirmDialog(props, context) {
    _classCallCheck(this, ConfirmDialog);

    var _this = _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this, props, context));

    _this.state = {
      loading: false,

      phongBanGiaiQuyet: '',
      canBoChiDinh: '',
      openDialog: false,
      dataComboboxTuXuLyTruongPhong: [{ type: 'TU_GIAI_QUYET', name: 'Tự giải quyết' }, { type: 'CHUYEN_PHONG_BAN_KHAC', name: 'Chuyển phòng ban khác' }, { type: 'GIAO_VIEC_PHO_PHONG', name: 'Giao việc phó phòng' }, { type: 'GIAO_VIEC_CHUYEN_VIEN', name: 'Giao việc chuyên viên' }],
      dataComboboxTuXuLyChuyenVien: [{ type: 'TU_GIAI_QUYET', name: 'Tự giải quyết' }, { type: 'CHUYEN_PHONG_BAN_KHAC', name: 'Chuyển phòng ban khác' }],
      statusKetThucXLD: 'TU_GIAI_QUYET'
    };
    return _this;
  }

  _createClass(ConfirmDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.chuyenVienXLD === true) {
        this.setState({
          canBoChiDinh: this.props.userInfo.id
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name === 'statusKetThucXLD' && e.target.value === 'TU_GIAI_QUYET') {
        newState = _extends({}, newState, {
          canBoChiDinh: this.props.userInfo.id
        });
      }

      if (name === 'statusKetThucXLD' && e.target.value === 'CHUYEN_PHONG_BAN_KHAC') {
        newState = _extends({}, newState, {
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState));
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      if (!this.props.buttonShow) {
        this.props.onClose();
      }
      this.setState({ openDialog: false });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      if (this.props.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      var _this2 = this;

      if (this.props.type === 'XLD') {

        if (this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === "TU_TTXM") {

          if (this.props.validateSubmitForm()) {
            var params = this.getParams();
            var noticeMsg = params.notice;

            this.setState({
              loading: true
            });

            if (this.props.alias === 'XuLyDonTuXuLy') {
              this.props.onClickSaveFile('BC_XLD', function () {
                _api.LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', params).then(function (res) {
                  _reactRouter.browserHistory.push('/xu-ly-don');
                  (0, _toastr.Toastr)(noticeMsg, 'success');
                }).catch(function (error) {
                  if (error.response) {
                    (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  }
                  _this2.setState({
                    loading: false
                  });
                });
              });
            } else {
              this.props.onClickSaveFile('BC_XLD', function () {
                _api.LetterProcessingWorkFlow.actions.postXuLyDon.request('', params).then(function (res) {
                  _reactRouter.browserHistory.push('/xu-ly-don');
                  (0, _toastr.Toastr)(noticeMsg, 'success');
                }).catch(function (error) {
                  if (error.response) {
                    (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                  }
                  _this2.setState({
                    loading: false
                  });
                });
              });
            }
          }
        } else {
          if (this.props.alias === 'XuLyDonTuXuLy') {
            this.props.onTuXuLy();
          } else {
            this.props.onSuccess();
          }
        }
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = _extends({}, this.props.params);

      delete params.messege;

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      }

      if (this.state.statusKetThucXLD !== 'CHUYEN_PHONG_BAN_KHAC') {
        params.phongBanGiaiQuyet = {
          id: Number(this.props.userInfo.coQuanQuanLyId)
        };
      }
      if (this.state.statusKetThucXLD !== 'GIAO_VIEC_CHUYEN_VIEN' && this.props.truongPhongXLD) {
        params.huongGiaiQuyetThuLy = 'CHUYEN_PHONG_BAN';
      } else if (this.props.truongPhongXLD) {
        params.huongGiaiQuyetThuLy = 'CHUYEN_CHUYEN_VIEN';
      }

      if (this.state.statusKetThucXLD !== 'TU_GIAI_QUYET' && this.props.chuyenVienXLD) {
        params.huongGiaiQuyetThuLy = 'CHUYEN_PHONG_BAN';
      } else if (this.props.chuyenVienXLD) {
        params.huongGiaiQuyetThuLy = 'CHUYEN_CHUYEN_VIEN';
      }

      if (this.state.canBoChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoChiDinh)
        };
      }
      return params;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (this.props.userInfo && this.props.alias != 'XuLyDonTuXuLy' && this.props.alias === 'LeaderAction') {
        this.setState({
          canBoChiDinh: this.props.userInfo.id
        });
      }
    }
  }, {
    key: 'trigger',
    value: function trigger() {

      var params = _extends({}, this.props.params);

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      } else {
        params.phongBanGiaiQuyet = null;
      }

      if (this.state.canBoChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoChiDinh)
        };
      } else {
        params.canBoXuLyChiDinh = null;
      }
      this.props.onChange(params);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.btnSaveLoading == true) {
        this.setState({ loading: nextProps.btnSaveLoading });
      }
      if (nextProps.btnLoading == true) {
        this.setState({ loading: nextProps.btnLoading });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['reception-dialog-text'];

      if (this.props.type === 'XLD' && this.props.params && this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM') {
        classes.push('txt-left');
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.buttonShow && this.props.alias !== 'WordProcessingSpecialistActionNoProcess' },
          _react2.default.createElement(
            _core.Button,
            { type: 'button', className: 'btn-action btn-move btn-green right',
              onClick: this.openDialog.bind(this) },
            'Chuy\u1EC3n gi\u1EA3i quy\u1EBFt \u0111\u01A1n'
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.props.buttonShow ? this.state.openDialog : this.props.open,
            onClose: this.closeDialog.bind(this),
            title: this.props.title,
            className: 'reception-dialog delete-dialog wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: classNames(classes) },
              this.props.content
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.type === 'XLD' && (this.props.chuyenVienXLD !== true || !this.props.params.trangThaiTTXM === 'TU_TTXM') && (this.props.truongPhongXLD !== true || !this.props.params.trangThaiTTXM === 'TU_TTXM') },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pb10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.params && this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM' },
                _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
                  selectedValue: this.state.phongBanGiaiQuyet,
                  label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt',
                  className: 'col-50',
                  onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
                  bindValidator: this,
                  name: 'dropdownChonPhongBanThuocCoQuan' }),
                _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                  bindValidator: this,
                  className: 'col-50',
                  label: 'C\xF4ng ch\u1EE9c x\u1EED l\xFD',
                  vaiTro: 'CHUYEN_VIEN',
                  selectedValue: this.state.canBoChiDinh,
                  phongBanId: this.state.phongBanGiaiQuyet,
                  onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                  name: 'dropdownChonCanBoXuLy' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pt5 pb10' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.type === 'XLD' && this.props.chuyenVienXLD !== true && this.props.truongPhongXLD === true && this.props.params.trangThaiTTXM === 'TU_TTXM' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pb10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.params && this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.DropDown, { require: true,
                    selectedValue: this.state.statusKetThucXLD,
                    options: this.state.dataComboboxTuXuLyTruongPhong,
                    label: 'H\u01B0\u1EDBng chuy\u1EC3n gi\u1EA3i quy\u1EBFt \u0111\u01A1n',
                    className: 'col-50',
                    keyName: 'type',
                    valueName: 'name',
                    onChange: this.handleChange.bind(this, 'statusKetThucXLD'),
                    bindValidator: this,
                    name: 'statusKetThucXLD' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'TU_GIAI_QUYET' && this.props.chonTruongPhong },
                    _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                      bindValidator: this,
                      className: 'col-50',
                      label: 'Tr\u01B0\u1EDFng ph\xF2ng x\u1EED l\xFD',
                      vaiTro: 'TRUONG_PHONG',
                      selectedValue: this.state.canBoChiDinh,
                      phongBanId: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                      name: 'dropdownChonCanBoXuLy' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'CHUYEN_PHONG_BAN_KHAC' },
                    _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
                      selectedValue: this.state.phongBanGiaiQuyet,
                      label: 'Ph\xF2ng ban ti\u1EBFp nh\u1EADn',
                      className: 'col-50',
                      isOther: true,
                      phongBanGiaiQuyet: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
                      bindValidator: this,
                      name: 'dropdownChonPhongBanThuocCoQuan' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'GIAO_VIEC_PHO_PHONG' },
                    _react2.default.createElement(_ttForms.DropDownChonPhoPhong, { require: true,
                      bindValidator: this,
                      className: 'col-50',
                      label: 'Ph\xF3 ph\xF2ng x\u1EED l\xFD',
                      vaiTro: 'PHO_PHONG',
                      selectedValue: this.state.canBoChiDinh,
                      phongBanId: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                      name: 'DropDownChonPhoPhong' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'GIAO_VIEC_CHUYEN_VIEN' },
                    _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                      bindValidator: this,
                      className: 'col-50',
                      label: 'C\xF4ng ch\u1EE9c x\u1EED l\xFD',
                      vaiTro: 'CHUYEN_VIEN',
                      selectedValue: this.state.canBoChiDinh,
                      phongBanId: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                      name: 'dropdownChonCanBoXuLy' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pt5 pb10' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.type === 'XLD' && this.props.chuyenVienXLD === true && this.props.truongPhongXLD !== true && this.props.params.trangThaiTTXM === 'TU_TTXM' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30 pb10' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.params && this.props.params.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.props.params.trangThaiTTXM === 'TU_TTXM' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.DropDown, { require: true,
                    selectedValue: this.state.statusKetThucXLD,
                    options: this.state.dataComboboxTuXuLyChuyenVien,
                    label: 'H\u01B0\u1EDBng chuy\u1EC3n gi\u1EA3i quy\u1EBFt \u0111\u01A1n',
                    className: 'col-50',
                    keyName: 'type',
                    valueName: 'name',
                    onChange: this.handleChange.bind(this, 'statusKetThucXLD'),
                    bindValidator: this,
                    name: 'statusKetThucXLD' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'TU_GIAI_QUYET' && this.props.chonChuyenVien },
                    _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                      bindValidator: this,
                      className: 'col-50',
                      label: 'C\xF4ng ch\u1EE9c x\u1EED l\xFD',
                      vaiTro: 'CHUYEN_VIEN',
                      selectedValue: this.state.canBoChiDinh,
                      phongBanId: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                      name: 'dropdownChonCanBoXuLy' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.statusKetThucXLD === 'CHUYEN_PHONG_BAN_KHAC' },
                    _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
                      selectedValue: this.state.phongBanGiaiQuyet,
                      label: 'Ph\xF2ng ban ti\u1EBFp nh\u1EADn',
                      className: 'col-50',
                      isOther: true,
                      phongBanGiaiQuyet: this.props.userInfo.coQuanQuanLyId,
                      onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
                      bindValidator: this,
                      name: 'dropdownChonPhongBanThuocCoQuan' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pt5 pb10' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green ' + (this.state.loading ? 'btn-loading-inline' : ''), onClick: this.onSuccess.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.defaultProps = {
  buttonShow: false,
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function onSuccess() {
    console.log('Need to assign onSuccess method');
  },
  validate: false,
  onClose: function onClose() {
    console.log('Need to assign onClose method');
  },
  chonTruongPhong: false,
  chonChuyenVien: true
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ConfirmDialog));

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmDialog = undefined;

var _ConfirmDialog = __webpack_require__(1161);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfirmDialog = _ConfirmDialog2.default;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var FormSearch = function (_React$Component) {
  _inherits(FormSearch, _React$Component);

  function FormSearch(props, context) {
    _classCallCheck(this, FormSearch);

    var _this = _possibleConstructorReturn(this, (FormSearch.__proto__ || Object.getPrototypeOf(FormSearch)).call(this, props, context));

    _this.state = {
      tuKhoa: '',
      maDon: '',
      isSaveTemp: false,
      startDate: '',
      endDate: '',
      nguonDon: '',
      phanLoaiDon: '',
      tinhTrangXuLy: '',
      ketQuaXuLy: '',
      searching: _this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(FormSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      this.state.tuKhoa = data.tuKhoa || '';
      if (data.advanceSearch) {
        this.state.isSaveTemp = data.isSaveTemp;
        this.state.maDon = data.maDon || '';
        this.state.nguonDon = data.nguonDon || '';
        this.state.phanLoaiDon = data.phanLoaiDon || '';
        this.state.tinhTrangXuLy = data.trangThaiDonToanHT || '';
        this.state.ketQuaXuLy = data.ketQuaToanHT || '';
        this.state.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      if (!this.props.advanceSearch) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      } else {
        if (this.validateSubmitForm()) {
          this.setState({
            doSearch: true
          });
          this.props.handleSearch(this.state, e);
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      // if (!this.refs.containerFileDinhKem.validate()) {
      //   pass = false;
      // }
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      if (name === "isSaveTemp") {
        this.setState({ isSaveTemp: !this.state.isSaveTemp });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });

      if (nextProps.resetForm) {
        this.resetData();
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        tuKhoa: '',
        isSaveTemp: false,
        maDon: '',
        nguonDon: '',
        phanLoaiDon: '',
        startDate: '',
        endDate: '',

        tinhTrangXuLy: '',
        ketQuaXuLy: '',

        spSearch: false,
        search: false,
        doSearch: false,
        searchLoading: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');
      }
      if (this.state.doSearch) {
        classes.push('btn-loading');
      }

      var classesInput = [];

      if (this.props.advanceSearch) {

        classesInput.push('input-20');
      } else {
        classesInput.push('input-show-group');
      }

      var inputClasses = classNames(classesInput);

      var btnClasses = classNames(classes);

      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        !this.props.searchEmail && _react2.default.createElement(_common.InputTuKhoa, {
          onChange: this.handleChange.bind(this, 'tuKhoa'),
          value: this.state.tuKhoa,
          channel: 'formTaoDon', className: inputClasses }),
        this.props.searchEmail && _react2.default.createElement(_common.InputTuKhoa, {
          label: 'Email ng\u01B0\u1EDDi d\xF9ng',
          onChange: this.handleChange.bind(this, 'tenEmail'),
          value: this.state.tenEmail,
          channel: 'formTaoDon',
          require: true,
          bindValidator: this,
          className: inputClasses,
          placeholder: 'Nh\u1EADp email ng\u01B0\u1EDDi d\xF9ng...'
        }),
        _react2.default.createElement(_common.DatePicker, { className: 'input-20', label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.endDate, value: this.state.startDate, onChange: this.handleChangeDate.bind(this, 'startDate') }),
        _react2.default.createElement(_common.DatePicker, { className: 'input-20', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.startDate, value: this.state.endDate, onChange: this.handleChangeDate.bind(this, 'endDate') }),
        _react2.default.createElement(_common.Input, { label: 'M\xE3 \u0111\u01A1n', placeholder: 'Nh\u1EADp m\xE3 \u0111\u01A1n...', value: this.state.maDon, onChange: this.handleChange.bind(this, 'maDon'), className: 'input-20' }),
        _react2.default.createElement(
          'div',
          { className: 'btn-wrap-20' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'clear-left' },
          _react2.default.createElement(_ttForms.DropDownChonNguonDon, { selectedValue: this.state.nguonDon, onChange: this.handleChange.bind(this, 'nguonDon'), className: 'input-20' })
        ),
        _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, onChange: this.handleChange.bind(this, 'phanLoaiDon'), className: 'input-20' }),
        _react2.default.createElement(_ttForms.DropDownTinhTrangGiaiQuyet, { label: 'T\xECnh tr\u1EA1ng x\u1EED l\xFD', selectedValue: this.state.tinhTrangXuLy, className: 'input-20', onChange: this.handleChange.bind(this, 'tinhTrangXuLy') }),
        _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyet, { label: 'K\u1EBFt qu\u1EA3 x\u1EED l\xFD', selectedValue: this.state.ketQuaXuLy, className: 'input-20', onChange: this.handleChange.bind(this, 'ketQuaXuLy') }),
        _react2.default.createElement(
          'div',
          { className: 'input-20' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.cancel.bind(this) },
            _react2.default.createElement('i', { className: 'tt tt-delete' }),
            'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
          )
        ),
        this.props.onStatus === 'DANG_XU_LY' && _react2.default.createElement(
          'div',
          { className: 'input-20 checkbox-luutam' },
          _react2.default.createElement(
            _core.Checkbox,
            { className: 'pt-large', checked: this.state.isSaveTemp, onChange: this.handleChange.bind(this, 'isSaveTemp'), name: 'donLuuTam' },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u01A1n \u0111\xE3 l\u01B0u t\u1EA1m'
            )
          )
        )
      );
    }
  }]);

  return FormSearch;
}(_react2.default.Component);

FormSearch.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
};

exports.default = FormSearch;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: "onChange",
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: this.props.className },
        _react2.default.createElement(
          "label",
          { className: "ip-label" },
          this.props.title
        ),
        _react2.default.createElement("input", { type: "text", name: this.props.name, placeholder: this.props.placehoderText, className: "search-input", onChange: this.onChange.bind(this) })
      );
    }
  }]);

  return Input;
}(_react2.default.Component);

Input.defaultProps = {
  title: 'Từ khóa',
  className: 'input-group-show',
  name: 'searchKey',
  placehoderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function onChange() {
    console.log('Please assign onChange function');
  }
};

exports.default = Input;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.FormSearch = undefined;

var _FormSearch = __webpack_require__(1163);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _Input = __webpack_require__(1164);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FormSearch = _FormSearch2.default;
exports.Input = _Input2.default;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _message = __webpack_require__(10);

var _CheckPermission = __webpack_require__(20);

var _CheckQuyenBatDauQuyTrinh = __webpack_require__(1236);

var _listHandleLettersSearch = __webpack_require__(1165);

var _list = __webpack_require__(481);

var _ttForms = __webpack_require__(19);

var _formSort = __webpack_require__(128);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLetters = function (_React$Component) {
  _inherits(HandleLetters, _React$Component);

  function HandleLetters(props, context) {
    _classCallCheck(this, HandleLetters);

    var _this = _possibleConstructorReturn(this, (HandleLetters.__proto__ || Object.getPrototypeOf(HandleLetters)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      trangThaiXuLyDon: 'DANG_XU_LY',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepNhan,desc',
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,

      searchData: {},
      search: false,
      tableLoading: false,
      searchLoading: false,
      resetFormSearch: false
    };
    return _this;
  }

  _createClass(HandleLetters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.scroll(0, 0);
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      this.state.trangThaiXuLyDon = data.trangThaiDon || 'DANG_XU_LY';
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.searchData.tuKhoa = data.tuKhoa || '';
      if (this.state.advanceSearch) {
        this.state.searchData.isSaveTemp = data.isSaveTemp;
        this.state.searchData.nguonDon = data.nguonDon || '';
        this.state.searchData.maDon = data.maDon || '';
        this.state.searchData.phanLoaiDon = data.phanLoaiDon || '';
        this.state.searchData.tinhTrangXuLy = data.trangThaiDonToanHT || '';
        this.state.searchData.ketQuaXuLy = data.ketQuaToanHT || '';
        this.state.searchData.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.searchData.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('xldData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('xldData', JSON.stringify(data));
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(donId) {
      var _this2 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.deleteLetterSucess, 'success');
        _this2.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        _this2.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listXLD',
          idKey: 'donId',
          id: donId
        });
        _this2.getListData();
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.map(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }

    // Note: ThuHoiDon

  }, {
    key: 'handleThuHoi',
    value: function handleThuHoi(donId) {
      var _this3 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.thuHoiDon, 'success');
        _this3.getListData();
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sortBy) {
        var _this4 = this;

        var state, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = this.state;
                params = {
                  thanhLapDon: true,
                  trangThaiDon: state.trangThaiXuLyDon,
                  page: state.pageData.number,
                  size: state.pageData.size,
                  sort: sortBy
                };
                _context2.next = 4;
                return this.setState({
                  searching: true,
                  tableLoading: true,
                  searchLoading: true,
                  resetFormSearch: false
                });

              case 4:
                if (state.searchData.isSaveTemp) {
                  params.isSaveTemp = state.searchData.isSaveTemp;
                }
                if (state.searchData.tuKhoa) {
                  params.tuKhoa = state.searchData.tuKhoa;
                }

                if (state.advanceSearch) {
                  if (state.searchData.nguonDon) {
                    params.nguonDon = state.searchData.nguonDon;
                  }

                  if (state.searchData.maDon) {
                    params.maDon = state.searchData.maDon;
                  }

                  if (state.searchData.phanLoaiDon) {
                    params.phanLoaiDon = state.searchData.phanLoaiDon;
                  }

                  if (state.searchData.tinhTrangXuLy) {
                    params.trangThaiDonToanHT = state.searchData.tinhTrangXuLy;
                  }

                  if (state.searchData.ketQuaXuLy) {
                    params.ketQuaToanHT = state.searchData.ketQuaXuLy;
                  }

                  if (state.searchData.startDate) {
                    params.tiepNhanTuNgay = (0, _moment2.default)(state.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                  }

                  if (state.searchData.endDate) {
                    params.tiepNhanDenNgay = (0, _moment2.default)(state.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                  }
                }
                _context2.next = 9;
                return localStorage.setItem('xldData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));

              case 9:
                _context2.next = 11;
                return _api.LetterProcessing.actions.getListXuLyDon.request(params).then(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    var Data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!_this4.refs.listXLD) {
                              _context.next = 6;
                              break;
                            }

                            Data = [];

                            if (res.data._embedded) {
                              Data = res.data._embedded.dons;
                              _this4.setState({ pageData: res.data.page });
                            } else {
                              state = {
                                pageData: {
                                  number: 0,
                                  size: 10,
                                  totalElements: 0
                                }
                              };
                            }
                            state = {
                              tableLoading: false,
                              searchLoading: false,
                              searching: false,
                              search: false
                            };
                            _context.next = 6;
                            return _this4.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this4);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  state = {
                    tableLoading: false,
                    searchLoading: false,
                    searching: false,
                    search: false
                  };
                });

              case 11:
                _context2.next = 13;
                return this.setState(state);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSort(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSort;
    }()
  }, {
    key: 'handleChangeTrangThaiXuLyDon',
    value: function handleChangeTrangThaiXuLyDon(e) {
      var _this5 = this;

      this.setState({
        trangThaiXuLyDon: e.target.value,
        advanceSearch: false,
        searchData: {},
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        },
        resetFormSearch: true
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      var _this6 = this;

      this.state.search = true;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      if (!this.state.advanceSearch) {

        searchData = {
          tuKhoa: searchData.tuKhoa,
          trangThaiXuLyDon: searchData.trangThaiXuLyDon
        };
      }

      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
        return;
      }

      this.setState({ searchData: searchData }, function () {
        _this6.getListData();
      });
    }
  }, {
    key: 'getListData',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this7 = this;

        var state, params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = this.state;
                params = {
                  thanhLapDon: true,
                  trangThaiDon: state.trangThaiXuLyDon,
                  page: state.pageData.number,
                  size: state.pageData.size,
                  sort: this.state.sortBy
                };

                state = _extends({}, state, {
                  searching: true,
                  tableLoading: true,
                  searchLoading: true,
                  resetFormSearch: false
                });
                _context4.next = 5;
                return this.setState(state);

              case 5:
                if (state.searchData.isSaveTemp) {
                  params.isSaveTemp = state.searchData.isSaveTemp;
                }

                if (state.searchData.tuKhoa) {
                  params.tuKhoa = state.searchData.tuKhoa;
                }

                if (state.advanceSearch) {
                  if (state.searchData.nguonDon) {
                    params.nguonDon = state.searchData.nguonDon;
                  }

                  if (state.searchData.maDon) {
                    params.maDon = state.searchData.maDon;
                  }

                  if (state.searchData.phanLoaiDon) {
                    params.phanLoaiDon = state.searchData.phanLoaiDon;
                  }

                  if (state.searchData.tinhTrangXuLy) {
                    params.trangThaiDonToanHT = state.searchData.tinhTrangXuLy;
                  }

                  if (state.searchData.ketQuaXuLy) {
                    params.ketQuaToanHT = state.searchData.ketQuaXuLy;
                  }

                  if (state.searchData.startDate) {
                    params.tiepNhanTuNgay = (0, _moment2.default)(state.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                  }

                  if (state.searchData.endDate) {
                    params.tiepNhanDenNgay = (0, _moment2.default)(state.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                  }
                }
                _context4.next = 10;
                return localStorage.setItem('xldData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));

              case 10:
                _context4.next = 12;
                return _api.LetterProcessing.actions.getListXuLyDon.request(params).then(function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    var Data;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!_this7.refs.listXLD) {
                              _context3.next = 6;
                              break;
                            }

                            Data = [];

                            if (res.data._embedded) {
                              Data = res.data._embedded.dons;
                              _this7.setState({ pageData: res.data.page });
                            } else {
                              state = _extends({}, state, {
                                pageData: {
                                  number: 0,
                                  size: 10,
                                  totalElements: 0
                                }
                              });
                            }
                            state = {
                              tableLoading: false,
                              searchLoading: false,
                              searching: false,
                              search: false
                            };
                            _context3.next = 6;
                            return _this7.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });

                          case 6:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this7);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  state = {
                    tableLoading: false,
                    searchLoading: false,
                    searching: false,
                    search: false
                  };
                });

              case 12:
                _context4.next = 14;
                return this.setState(state);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getListData() {
        return _ref3.apply(this, arguments);
      }

      return getListData;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: 'listXLD' },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(_ttForms.RadioButtonChonTrangThaiXuLyDon, { disable: this.state.tableLoading, selectedValue: this.state.trangThaiXuLyDon, onChange: this.handleChangeTrangThaiXuLyDon.bind(this) }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('XULYDON_THEM') && (0, _CheckQuyenBatDauQuyTrinh.CheckQuyenBatDauQuyTrinh)() },
              _react2.default.createElement(
                'div',
                { className: 'right-content' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-green', to: '/xu-ly-don/them-moi' },
                  _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                  'Th\xEAm m\u1EDBi'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_listHandleLettersSearch.FormSearch, { onStatus: this.state.trangThaiXuLyDon, advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, resetForm: this.state.resetFormSearch }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'soXuLyDon',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              { header: _table.header.listXLD,
                dataList: this.state.data,
                searchData: this.state.searchData,
                exporttext: 'Xu\u1EA5t s\u1ED5 x\u1EED l\xFD \u0111\u01A1n',
                sortBy: this.state.sortBy,
                typeExport: 'XU_LY_DON',
                pageData: this.state.pageData,
                parent: this,
                search: this.state.search,
                redux: this,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_list.RowItemListHandleLetters, {
                type: this.state.trangThaiXuLyDon,
                getListData: this.getListData.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return HandleLetters;
}(_react2.default.Component);

HandleLetters.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(HandleLetters);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HandleLetters = undefined;

var _HandleLetters = __webpack_require__(1166);

var _HandleLetters2 = _interopRequireDefault(_HandleLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HandleLetters = _HandleLetters2.default;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _message = __webpack_require__(10);

var _list = __webpack_require__(481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHop = function (_React$Component) {
  _inherits(TongHop, _React$Component);

  function TongHop(props, context) {
    _classCallCheck(this, TongHop);

    var _this = _possibleConstructorReturn(this, (TongHop.__proto__ || Object.getPrototypeOf(TongHop)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      trangThaiXuLyDon: 'DON_TRE_HAN_GIAI_QUYET',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      startDateValid: true,
      endDateValid: true,
      tableLoading: false
    };
    return _this;
  }

  _createClass(TongHop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
      this.setState({
        pageData: {
          number: data.page || 0,
          size: data.size || 10
        }
      }, function () {
        _this2.getListData();
        _this2.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(donId) {
      var _this3 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.deleteLetterSucess, 'success');
        _this3.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        _this3.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listXLD',
          idKey: 'donId',
          id: donId
        });
        _this3.getListData();
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.forEach(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }

    // Note: ThuHoiDon

  }, {
    key: 'handleThuHoi',
    value: function handleThuHoi(donId) {
      var _this4 = this;

      _api.LetterProcessing.actions.deleteDon.request({
        id: donId
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.thuHoiDon, 'success');
        _this4.getListData();
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleChangeTrangThaiXuLyDon',
    value: function handleChangeTrangThaiXuLyDon(e) {
      var _this5 = this;

      this.setState({
        trangThaiXuLyDon: e.target.value,
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        }
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this6 = this;

      var params = {
        size: this.state.pageData.size,
        page: this.state.pageData.number
      };
      localStorage.setItem('xldData', JSON.stringify(_extends({}, params)));
      if (this.props.routerName === 'dontrehanxulytaidonvi') {
        return _api.LetterProcessing.actions.getListDonTreHanXuLy.request(params).then(function (res) {
          if (_this6.refs.listXLD) {
            var Data = [];
            if (res.data._embedded) {
              Data = res.data._embedded.dons, _this6.setState({
                pageData: res.data.page
              });
            } else {
              _this6.setState({
                pageData: {
                  number: 0,
                  size: 10,
                  totalElements: 0
                }
              });
            }
            _this6.setState({
              tableLoading: false
            }, function () {
              _this6.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
            });
          }
        }).catch(function (err) {
          _this6.setState({
            tableLoading: false
          });
        });
      } else if (this.props.routerName === 'dontrehanxulytaidiaban') {
        return _api.LetterProcessing.actions.getListDonTreHanXuLyTaiDiaBan.request(params).then(function (res) {
          if (_this6.refs.listXLD) {
            var Data = [];
            if (res.data._embedded) {
              Data = res.data._embedded.dons, _this6.setState({
                pageData: res.data.page
              });
            } else {
              _this6.setState({
                pageData: {
                  number: 0,
                  size: 10,
                  totalElements: 0
                }
              });
            }
            _this6.setState({
              tableLoading: false
            }, function () {
              _this6.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
            });
          }
        }).catch(function (err) {
          _this6.setState({
            tableLoading: false
          });
        });
      } else if (this.props.routerName === 'dontrehangiaiquyettaidiaban') {
        return _api.LetterProcessing.actions.getListDonTreHanGiaiQuyetTaiDiaBan.request(params).then(function (res) {
          if (_this6.refs.listXLD) {
            var Data = [];
            if (res.data._embedded) {
              Data = res.data._embedded.dons, _this6.setState({
                pageData: res.data.page
              });
            } else {
              _this6.setState({
                pageData: {
                  number: 0,
                  size: 10,
                  totalElements: 0
                }
              });
            }
            _this6.setState({
              tableLoading: false
            }, function () {
              _this6.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
            });
          }
        }).catch(function (err) {
          _this6.setState({
            tableLoading: false
          });
        });
      } else {
        return _api.LetterProcessing.actions.getListDonTreHanGiaiQuyet.request(params).then(function (res) {
          if (_this6.refs.listXLD) {
            var Data = [];
            if (res.data._embedded) {
              Data = res.data._embedded.dons, _this6.setState({
                pageData: res.data.page
              });
            } else {
              _this6.setState({
                pageData: {
                  number: 0,
                  size: 10,
                  totalElements: 0
                }
              });
            }
            _this6.setState({
              tableLoading: false
            }, function () {
              _this6.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
            });
          }
        }).catch(function (err) {
          _this6.setState({
            tableLoading: false
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var params = {
        size: 10,
        page: 0
      };
      localStorage.setItem('xldData', JSON.stringify(_extends({}, params)));
    }
  }, {
    key: 'render',
    value: function render() {
      var donTreHanTaiDiaBan = this.props.routerName === 'dontrehanxulytaidiaban' || this.props.routerName === 'dontrehangiaiquyettaidiaban' ? true : false;
      return _react2.default.createElement(
        'div',
        { ref: 'listXLD' },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement('div', { className: 'top-content' }),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              _dataTable2.default,
              { header: _table.header.listXLD,
                dataList: this.state.data,
                pageData: this.state.pageData,
                hideButtonExport: true,
                parent: this,
                redux: this,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_list.RowItemListHandleLetters, {
                donTreHanTaiDiaBan: donTreHanTaiDiaBan,
                type: this.state.trangThaiXuLyDon,
                getListData: this.getListData.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return TongHop;
}(_react2.default.Component);

TongHop.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TongHop);

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TongHop = undefined;

var _TongHop = __webpack_require__(1168);

var _TongHop2 = _interopRequireDefault(_TongHop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TongHop = _TongHop2.default;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _formXuLy = __webpack_require__(483);

var _formGiaiQuyet = __webpack_require__(310);

var _subView = __webpack_require__(33);

var _formKiemTraDeXuat = __webpack_require__(311);

var _formDinhChi = __webpack_require__(1172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var FormXuLyHoacGiaiQuyet = function (_React$Component) {
  _inherits(FormXuLyHoacGiaiQuyet, _React$Component);

  function FormXuLyHoacGiaiQuyet() {
    _classCallCheck(this, FormXuLyHoacGiaiQuyet);

    return _possibleConstructorReturn(this, (FormXuLyHoacGiaiQuyet.__proto__ || Object.getPrototypeOf(FormXuLyHoacGiaiQuyet)).apply(this, arguments));
  }

  _createClass(FormXuLyHoacGiaiQuyet, [{
    key: 'onChange',
    value: function onChange(state, isInit) {
      if (this.props.processType === 'XU_LY_DON' || this.props.alias === 'XuLyDonTuXuLy') {
        state.don = {
          id: Number(this.props.donId)
        };
      }
      if (isInit) {
        this.props.onInit(state);
      } else {
        this.props.onChange(state);
      }
    }
  }, {
    key: 'onChangeTepDinhKem',
    value: function onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {

      this.props.onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'getState',
    value: function getState(listNextStates, type) {

      var stateId = null;

      listNextStates.map(function (item, i) {

        if (item.type == type) {

          stateId = item.stateId;
          return stateId;
        }
      });
      return stateId;
    }
  }, {
    key: 'viewComponent',
    value: function viewComponent() {
      if (this.props.trangThaiDonDonVi.ketQuaType != 'DINH_CHI') {
        switch (this.props.alias) {
          case 'WordProcessingOperatorAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formXuLy.TrinhLanhDao, {
                donId: this.props.donId,
                thongTinDon: this.props.thongTinDon,
                onChange: this.onChange.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                bindValidator: this,
                data: this.props.data });
            } else {
              return _react2.default.createElement(_formXuLy.TrinhLanhDaoView, {
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                listTaiLieuVanThuChuyenDonBoSungHoSo: this.props.listTaiLieuVanThuChuyenDonBoSungHoSo
              });
            }

          case 'TruongPhongTDTHAction':
          case 'CanBoTDTHAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_formGiaiQuyet.CanBoNhanYeuCauTheoDoiThucHien, {
                  id: this.props.donId,
                  tuGiaiQuyet: true,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  dataNextStates: this.props.listNextStates,
                  loaiDon: this.props.loaiDonGiaTri
                })
              );
            } else {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  loaiDon: this.props.loaiDonGiaTri,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  lanhDaoView: true
                }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo }))
              );
            }

          case 'canBoTDTHKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.CanBoNhanYeuCauTheoDoiThucHien, {
                id: this.props.donId,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                dataNextStates: this.props.listNextStates,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                loaiDon: this.props.loaiDonGiaTri
              });
            } else {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_subView.KetQuaTheoDoiThucHien, _extends({
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  loaiDon: this.props.loaiDonGiaTri,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  lanhDaoView: true
                }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo }))
              );
            }

          case 'LanhDaoTDTHAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.LanhDaoGiaoViecTheoDoiGiamSat, {
                id: this.props.donId,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                dataNextStates: this.props.listNextStates,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                loaiDon: this.props.loaiDonGiaTri
              });
            } else {
              return _react2.default.createElement(_formGiaiQuyet.LanhDaoGiaoViecTheoDoiGiamSatView, {
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDon: this.props.loaiDonGiaTri,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet });
            }

          case 'CanBoNhapLieuTDTHAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.TrinhLanhDaoTheoDoiThucHien, {
                id: this.props.donId,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                dataNextStates: this.props.listNextStates,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                loaiDon: this.props.loaiDonGiaTri
              });
            } else {
              return _react2.default.createElement(_formGiaiQuyet.TrinhLanhDaoTheoDoiThucHienView, {
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDon: this.props.loaiDonGiaTri,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet });
            }

          case 'ManagerAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formXuLy.LanhDaoGiaoViec, {
                donId: this.props.donId,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                bindValidator: this });
            } else {
              return _react2.default.createElement(_formXuLy.LanhDaoGiaoViecView, {
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet });
            }

          case 'LeaderAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formXuLy.TruongPhongGiaoViec, {
                ngayNhanDon: this.props.data.ngayNhanDon,
                ngayTraTTXMKhongDungThamQuyen: this.props.data.ngayTraTTXMKhongDungThamQuyen,
                donId: this.props.donId,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                truongPhongThuHoi: this.props.thuHoi,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                onSave: this.props.onSave,
                inPhieu: this.props.inPhieu.bind(this),
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this)
              });
            } else {
              return _react2.default.createElement(_formXuLy.HuongXuLyView, {
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                inPhieu: this.props.inPhieu.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu });
            }

          case 'WordProcessingSpecialistAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formXuLy.HuongXuLy, {
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                donId: this.props.donId,
                onSave: this.props.onSave,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                ngayNhanDon: this.props.data.ngayNhanDon,
                ngayTraTTXMKhongDungThamQuyen: this.props.data.ngayTraTTXMKhongDungThamQuyen,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                inPhieu: this.props.inPhieu.bind(this),
                bindValidator: this,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
            } else {
              return _react2.default.createElement(_formXuLy.HuongXuLyView, {
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                inPhieu: this.props.inPhieu.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu });
            }

          case 'WordProcessingSpecialistActionNoProcess':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formXuLy.KhongCoQuyTrinh, {
                checkValidate: this.props.checkValidate,
                thongTinDon: this.props.thongTinDon,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                donId: this.props.donId,
                tongSoLuotTCD: this.props.tongSoLuotTCD,
                onChange: this.onChange.bind(this),
                ngayNhanDon: this.props.data.ngayNhanDon,
                ngayTraTTXMKhongDungThamQuyen: this.props.data.ngayTraTTXMKhongDungThamQuyen,
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                inPhieu: this.props.inPhieu.bind(this),
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onSave: this.props.onSave,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this),
                action: this.props.action });
            } else {
              return _react2.default.createElement(_formXuLy.HuongXuLyView, {
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                inPhieu: this.props.inPhieu.bind(this),
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThu: this.props.listTaiLieuVanThu });
            }

          case 'CanBoGiaiQuyetDonKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.GiaiQuyetDonCanBo, _extends({
                donId: this.props.donId,
                onSave: this.props.onSave,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                listTaiLieuVanThuGiaiQuyetDonView: this.props.listTaiLieuVanThuGiaiQuyetDonView,
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                listNextStates: this.props.listNextStates,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId
              }, this.props.data));
            } else {
              return _react2.default.createElement(_formGiaiQuyet.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({
                loaiDon: this.props.loaiDonGiaTri,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo
              }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonView
              }));
            }

          case 'CanBoNhapLieuTTXMAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.TrinhLanhDaoTTXM, {
                donId: this.props.donId,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onSave: this.props.onSave,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
            } else {
              return _react2.default.createElement(_formGiaiQuyet.TrinhLanhDaoTTXMView, {
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon
              });
            }

          case 'LanhDaoTTXMAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.LanhDaoGiaoViecTTXM, {
                donId: this.props.donId,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
            } else {
              return _react2.default.createElement(_formGiaiQuyet.LanhDaoGiaoViecTTXMView, {
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                thongTinGiaiQuyetDonPlus: this.props.thongTinGiaiQuyetDonPlus });
            }

          case 'CanBoTTXMKhongQuyTrinh':
          case 'TruongPhongTTXMAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.NhapThongTinToTTXM, {
                id: this.props.donId,
                dataNextStates: this.props.listNextStates,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : '',
                donInfo: this.props.donInfo,
                loaiDon: this.props.loaiDonGiaTri,
                alias: this.props.alias
              });
            } else {
              var thongTinGiaiQuyetDonInfo = this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo;
              return _react2.default.createElement(_formGiaiQuyet.NhapThongTinToTTXMView, _extends({}, thongTinGiaiQuyetDonInfo, {
                thongTinGiaiQuyetDonPlus: this.props.thongTinGiaiQuyetDonPlus,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : '',
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDonGiaTri: this.props.loaiDonGiaTri
              }));
            }
          case 'CanBoTTXMAction':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formGiaiQuyet.NhapThongTinToTTXM, {
                id: this.props.donId,
                dataNextStates: this.props.listNextStates,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                loaiDon: this.props.loaiDonGiaTri,
                alias: this.props.alias
              });
            } else {
              return _react2.default.createElement(_formGiaiQuyet.NhapThongTinToTTXMView, _extends({}, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                thongTinGiaiQuyetDonPlus: this.props.thongTinGiaiQuyetDonPlus,
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDonGiaTri: this.props.loaiDonGiaTri
              }));
            }

          case 'CanBoGiaiQuyetDonAction':
            return _react2.default.createElement(_formGiaiQuyet.KetQuaHoanThanhGiaiQuyetDonCanBo, _extends({
              loaiDon: this.props.loaiDonGiaTri,
              listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo
            }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
              thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
              donInfo: this.props.donInfo,
              listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonView,
              lanhDaoView: true
            }));
          case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
          case 'CanBoGiaiQuyetDonLapDuThaoAction':
          case 'TruongPhongNhanDuThaoVaGiaoViec':
          case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
            // if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {
            //   return (
            //     <div className='container-filedinhkem'>
            //       <KetQuaLapDuThaoDonKhieuNaiCanBo
            //         listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            //         {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //         loaiDon={this.props.loaiDonGiaTri}
            //         thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
            //         donInfo = {this.props.donInfo}
            //         lanhDaoView={true}
            //       />
            //     </div>
            //   )

            // } else {
            return _react2.default.createElement(
              'div',
              { className: 'container-filedinhkem' },
              _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
              }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                loaiDon: this.props.loaiDonGiaTri,
                donInfo: this.props.donInfo,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo,
                lanhDaoView: true
              }))
            );
          // }
          case 'TruongPhongTTXMNhanYeuCauVaGiaoViecAction':
          case 'CanBoTTXMChuyenDuThaoAction':
            return _react2.default.createElement(
              'div',
              { className: 'container-filedinhkem' },
              _react2.default.createElement(_subView.KetQuaCanBoGiaiQuyetYeuCauLapDuThao, _extends({}, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                loaiDon: this.props.loaiDonGiaTri,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                lanhDaoView: true
              }))
            );

          case 'vanThuKiemTraDeXuat':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formKiemTraDeXuat.TrinhLanhDaoKTDX, {
                donId: this.props.donId,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
            } else {
              return _react2.default.createElement(_formKiemTraDeXuat.TrinhLanhDaoKTDXView, {
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon });
            }

          case 'lanhDaoKiemTraDeXuat':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formKiemTraDeXuat.LanhDaoGiaoViecKTDX, {
                donId: this.props.donId,
                onChange: this.onChange.bind(this),
                listNextStates: this.props.listNextStates,
                getState: this.getState.bind(this),
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                bindValidator: this,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
            } else {
              return _react2.default.createElement(_formKiemTraDeXuat.LanhDaoGiaoViecKTDXView, {
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon });
            }

          case 'canBoKiemTraDeXuat':
            return _react2.default.createElement(_formKiemTraDeXuat.CanBoKiemTraDeXuatView, _extends({
              thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet
            }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
              thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
              donInfo: this.props.donInfo,
              listTaiLieuVanThuKiemTraDeXuat: this.props.listTaiLieuVanThuKiemTraDeXuat,
              listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo
            }));

          case 'canBoKiemTraDeXuatKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(_formKiemTraDeXuat.CanBoKiemTraDeXuat, _extends({
                donId: this.props.donId,
                thongTinYeuCauKiemTraDeXuat: this.props.thongTinYeuCauKiemTraDeXuat,
                listTaiLieuVanThuKiemTraDeXuat: this.props.listTaiLieuVanThuKiemTraDeXuat,
                loaiDonGiaTri: this.props.loaiDonGiaTri,
                listNextStates: this.props.listNextStates,
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                onSave: this.props.onSave,
                thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId
              }, this.props.data));
            } else {
              return _react2.default.createElement(_formKiemTraDeXuat.CanBoKiemTraDeXuatView, _extends({
                thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet
              }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                donInfo: this.props.donInfo,
                listTaiLieuVanThuKiemTraDeXuat: this.props.listTaiLieuVanThuKiemTraDeXuat,
                listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo
              }));
            }

          case 'CanBoTTXMChuyenDuThaoKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_formGiaiQuyet.CanBoGiaiQuyetYeuCauLapDuThao, {
                  id: this.props.donId,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  dataNextStates: this.props.listNextStates,
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                  lanhDaoView: true,
                  loaiDon: this.props.loaiDonGiaTri })
              );
            } else {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_subView.KetQuaCanBoGiaiQuyetYeuCauLapDuThao, _extends({}, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
                  loaiDon: this.props.loaiDonGiaTri,
                  lanhDaoView: true }))
              );
            }
          case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {

                return _react2.default.createElement(
                  'div',
                  { className: 'container-filedinhkem' },
                  _react2.default.createElement(_formGiaiQuyet.LapDuThaoDonKhieuNaiCanBo, {
                    id: this.props.donId,
                    dataNextStates: this.props.listNextStates,
                    thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                    donInfo: this.props.donInfo,
                    listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                    listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                    listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                    listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                    listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                    thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                    loaiDon: this.props.loaiDonGiaTri })
                );
              } else {
                return _react2.default.createElement(
                  'div',
                  { className: 'container-filedinhkem' },
                  _react2.default.createElement(_formGiaiQuyet.LapDuThaoCanBo, {
                    id: this.props.donId,
                    thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                    donInfo: this.props.donInfo,
                    dataNextStates: this.props.listNextStates,
                    listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                    listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                    listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                    listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                    listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                    thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                    loaiDon: this.props.loaiDonGiaTri })
                );
              }
              // } else if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {
              //   return (
              //     <div className='container-filedinhkem'>
              //       <KetQuaLapDuThaoDonKhieuNaiCanBo
              //         listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              //         {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //         loaiDon={this.props.loaiDonGiaTri}
              //         thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              //         donInfo = {this.props.donInfo}
              //         listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
              //         lanhDaoView={true}
              //         />
              //       </div>
              //   )
            } else {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
                }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  loaiDon: this.props.loaiDonGiaTri,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo,
                  lanhDaoView: true
                }))
              );
            }

          case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
            if (this.props.donDangXuLy) {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_formGiaiQuyet.LapDuThaoDonKhieuNaiCanBo, {
                  id: this.props.donId,
                  nhanDuThao: true,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  dataNextStates: this.props.listNextStates,
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
                  thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
                  loaiDon: this.props.loaiDonGiaTri })
              );
            } else {
              return _react2.default.createElement(
                'div',
                { className: 'container-filedinhkem' },
                _react2.default.createElement(_subView.KetQuaLapDuThaoCanBo, _extends({
                  nhanDuThao: true,
                  listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView
                }, this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo, {
                  loaiDon: this.props.loaiDonGiaTri,
                  thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
                  donInfo: this.props.donInfo,
                  listTaiLieuVanThuBoSungHoSo: this.props.listTaiLieuVanThuBoSungHoSo,
                  lanhDaoView: true
                }))
              );
            }

          // Tu xu ly
          case 'XuLyDonTuXuLy':
            return _react2.default.createElement(_formXuLy.TuXuLy, {
              loaiDonGiaTri: this.props.loaiDonGiaTri,
              ngayNhanDon: this.props.data.ngayNhanDon,
              ngayTraTTXMKhongDungThamQuyen: this.props.data.ngayTraTTXMKhongDungThamQuyen,
              donId: this.props.donId,
              onSave: this.props.onSave,
              onChange: this.onChange.bind(this),
              listNextStates: this.props.listNextStates,
              getState: this.getState.bind(this),
              thongTinXuLyGiaiQuyet: this.props.thongTinXuLyGiaiQuyet,
              inPhieu: this.props.inPhieu.bind(this),
              bindValidator: this,
              listTaiLieuVanThu: this.props.listTaiLieuVanThu,
              onChangeTepDinhKem: this.onChangeTepDinhKem.bind(this) });
          default:
            break;
        }
      } else {
        return _react2.default.createElement(_formDinhChi.DinhChiView, {
          donId: this.props.donId,
          lyDoDinhChi: this.props.lyDoDinhChi,
          processType: this.props.processType,
          thongTinGQD: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo,
          donInfo: this.props.donInfo,
          listTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
          listTaiLieuVanThu: this.props.listTaiLieuVanThu,
          ma: this.props.ma });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['box-items', 'mb0-18'];
      var classBox = ['group-box'];

      if (this.props.pageType === "THEM_MOI_VA_CHINH_SUA_DON") {
        classBox.push('pl5');
        classBox.push('pr5');
        classBox.push('mt20');
      }

      var inputClasses = classNames(classes);
      var boxClasses = classNames(classBox);
      var alias = this.props.alias;

      var viewGQD = false;
      var showTitle = true;
      if (alias == 'CanBoGiaiQuyetDonLapDuThaoAction' || alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction' || alias == 'CanBoTTXMChuyenDuThaoAction' || alias == 'CanBoNhapLieuTDTHAction' || alias == 'LanhDaoTDTHAction' || alias == 'CanBoTDTHAction' || alias == 'canBoTDTHKhongQuyTrinh' || alias == 'CanBoGiaiQuyetDonAction') {
        viewGQD = true;
      }
      if (alias == 'CanBoTTXMKhongQuyTrinh' || alias == 'CanBoTTXMAction' || alias == 'CanBoTDTHAction' || alias == 'canBoTDTHKhongQuyTrinh' || alias == 'CanBoNhapLieuTDTHAction' || alias == 'LanhDaoTDTHAction' || alias == 'TruongPhongTDTHAction' || alias == 'CanBoTTXMChuyenDuThaoKhongQuyTrinh' || alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' || alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh') {
        showTitle = false;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !viewGQD },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: inputClasses },
              _react2.default.createElement(
                'div',
                { className: 'box-forward' },
                _react2.default.createElement(
                  'div',
                  { className: 'container-box' },
                  _react2.default.createElement(
                    'div',
                    { className: boxClasses },
                    showTitle && _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl15 pr15' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          this.props.title
                        )
                      )
                    ),
                    this.viewComponent()
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: viewGQD },
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem' },
            this.viewComponent()
          )
        )
      );
    }
  }]);

  return FormXuLyHoacGiaiQuyet;
}(_react2.default.Component);

FormXuLyHoacGiaiQuyet.defaultProps = {
  title: 'Thông tin xử lý',
  alias: 'WordProcessingOperatorAction',
  donId: 0,
  onInit: function onInit() {},
  inPhieu: function inPhieu() {},
  onSave: false,
  data: {},
  donInfo: {}
};

exports.default = (0, _utils.validatable)(FormXuLyHoacGiaiQuyet);

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DinhChiView = function (_React$Component) {
  _inherits(DinhChiView, _React$Component);

  function DinhChiView() {
    _classCallCheck(this, DinhChiView);

    return _possibleConstructorReturn(this, (DinhChiView.__proto__ || Object.getPrototypeOf(DinhChiView)).apply(this, arguments));
  }

  _createClass(DinhChiView, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'row pl15 pr15 pt10 wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'txt-bold text-14 mb15 txt-blue txt-upper' },
          this.props.ma == '' ? 'Rút đơn' : 'Đình chỉ'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mb10' },
          _react2.default.createElement(_common.Text, { className: 'col-100 mb5', label: this.props.ma == '' ? 'Lý do rút đơn' : 'Lý do đình chỉ', value: this.props.lyDoDinhChi }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5 container-filedinhkem' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this,
              dataShow: this.props.processType == 'XU_LY_DON' ? this.props.listTaiLieuVanThu : this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          )
        )
      );
    }
  }]);

  return DinhChiView;
}(_react2.default.Component);

exports.default = DinhChiView;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DinhChiView = undefined;

var _DinhChiView = __webpack_require__(1171);

var _DinhChiView2 = _interopRequireDefault(_DinhChiView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DinhChiView = _DinhChiView2.default;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhiemVuTTXM = function (_React$Component) {
  _inherits(NhiemVuTTXM, _React$Component);

  function NhiemVuTTXM() {
    _classCallCheck(this, NhiemVuTTXM);

    return _possibleConstructorReturn(this, (NhiemVuTTXM.__proto__ || Object.getPrototypeOf(NhiemVuTTXM)).apply(this, arguments));
  }

  _createClass(NhiemVuTTXM, [{
    key: 'render',
    value: function render() {
      var ngayChuyen = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauTTXM).format('DD/MM/YYYY') : '';
      var tgBaoCao = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
      var yKien = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.yKienCuaDonViGiaoTTXM : '';
      if (this.props.donInfo.laTTXMLai) {
        tgBaoCao = this.props.donInfo.ngayHetHanGiaiQuyetLanDau ? (0, _moment2.default)(this.props.donInfo.ngayHetHanGiaiQuyetLanDau).format('DD/MM/YYYY') : '';
        ngayChuyen = this.props.donInfo.ngayBatDauTTXMLanDau ? (0, _moment2.default)(this.props.donInfo.ngayBatDauTTXMLanDau).format('DD/MM/YYYY') : '';
        yKien = this.props.donInfo.noiDungYeuCauTTXMLanDau || '';
      }
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'box-items mb0' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Nhi\u1EC7m v\u1EE5 th\u1EA9m tra x\xE1c minh',
                  lb2
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'items-form mb0' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 mb10' },
              _react2.default.createElement(_common.Text, {
                className: 'col-25',
                label: 'Ng\xE0y chuy\u1EC3n:',
                value: ngayChuyen }),
              _react2.default.createElement(_common.Text, {
                className: 'col-25',
                label: 'Đơn vị giao ' + lb1 + ':',
                value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViGiaoThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, {
                red: true,
                className: 'col-25',
                label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:',
                value: tgBaoCao })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.TextMessage, {
                className: 'col-12',
                value: yKien,
                label: 'Ý kiến xử lý của đơn vị giao ' + lb1 + ':' })
            )
          )
        ),
        this.props.donInfo.laTTXMLai ? _react2.default.createElement(
          'div',
          { className: 'box-items mb0 mt10' },
          _react2.default.createElement(
            'div',
            { className: 'pt5 pb15' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Nhi\u1EC7m v\u1EE5 th\u1EA9m tra x\xE1c minh',
                  lb2,
                  ' l\u1EA1i'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'items-form mb0' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 mb10' },
              _react2.default.createElement(_common.Text, {
                className: 'col-25',
                label: 'Ng\xE0y chuy\u1EC3n:',
                value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, {
                className: 'col-25',
                label: 'Đơn vị giao ' + lb1 + ':',
                value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViGiaoThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, {
                red: true,
                className: 'col-25',
                label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:',
                value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.TextMessage, {
                className: 'col-12',
                value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.yKienCuaDonViGiaoTTXM : '',
                label: 'Ý kiến xử lý của đơn vị giao ' + lb1 + ':' })
            )
          )
        ) : ''
      );
    }
  }]);

  return NhiemVuTTXM;
}(_react2.default.Component);

NhiemVuTTXM.defaultProps = {
  donInfo: {}
};

exports.default = NhiemVuTTXM;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _processType = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.trinhLanhDao];

var TrinhLanhDaoTTXM = function (_React$Component) {
  _inherits(TrinhLanhDaoTTXM, _React$Component);

  function TrinhLanhDaoTTXM(props, context) {
    _classCallCheck(this, TrinhLanhDaoTTXM);

    var _this = _possibleConstructorReturn(this, (TrinhLanhDaoTTXM.__proto__ || Object.getPrototypeOf(TrinhLanhDaoTTXM)).call(this, props, context));

    _this.state = {
      form_TrinhLanhDaoTTXM: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      noiDung: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: []
    };
    return _this;
  }

  _createClass(TrinhLanhDaoTTXM, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.trinhLanhDao:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TrinhLanhDaoTTXM: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataGiaiQuyetDon: res.data,
            lanhDaoChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      if (newState.form_TrinhLanhDaoTTXM) {

        var stateId = this.props.getState(this.props.listNextStates, 'TRINH_LANH_DAO');

        var paramsPatch = this.state.dataGiaiQuyetDon;

        if (newState.lanhDaoChiDinh) paramsPatch.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };
        paramsPatch.yKienGiaiQuyet = newState.noiDung;

        paramsPatch.nextState = {
          id: Number(stateId),
          type: this.state.onlyState
        };

        var paramsPost = {};

        paramsPost.nextState = {
          id: Number(stateId),
          type: this.state.onlyState
        };

        if (newState.lanhDaoChiDinh) paramsPost.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };

        paramsPost.yKienGiaiQuyet = newState.noiDung;

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.gqdTrinhLanhDao
        };
        this.props.onChange(params, isInit);
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {

      var temp = {
        dataFileDinhKem: data,
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      };

      this.setState({
        temp: temp
      });

      this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });

      this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId == _this4.state.donViId;
      });

      var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this4.state.donViId;
      });
      if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
        ListTaiLieuVanThuShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView;
      }
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.form_TrinhLanhDaoTTXM },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.DropDown, {
              label: 'Ban l\xE3nh \u0111\u1EA1o',
              options: this.props.lanhDaoList,
              keyName: 'congChucId',
              valueName: 'hoVaTen',
              bindValidator: this,
              require: !this.props.onSave,
              channel: 'formTaoDon',
              selectedValue: this.state.lanhDaoChiDinh,
              onChange: this.handleChange.bind(this, 'lanhDaoChiDinh'),
              placeholder: this.props.placeholder,
              name: 'chonBanlanhDaoTTXM' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              value: this.state.noiDung,
              onChange: this.handleChange.bind(this, 'noiDung'),
              name: 'textareaBanLanhDaoTTXM' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: ListTaiLieuVanThuShow, data: ListTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), onSave: this.props.onSave })
          )
        )
      );
    }
  }]);

  return TrinhLanhDaoTTXM;
}(_react2.default.Component);

TrinhLanhDaoTTXM.defaultProps = {
  listNextStates: [],
  validators: {
    formTaoDon: []
  },
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TrinhLanhDaoTTXM));

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrinhLanhDaoTTXMView = function (_React$Component) {
  _inherits(TrinhLanhDaoTTXMView, _React$Component);

  function TrinhLanhDaoTTXMView() {
    _classCallCheck(this, TrinhLanhDaoTTXMView);

    return _possibleConstructorReturn(this, (TrinhLanhDaoTTXMView.__proto__ || Object.getPrototypeOf(TrinhLanhDaoTTXMView)).apply(this, arguments));
  }

  _createClass(TrinhLanhDaoTTXMView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb5' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mb10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'Ban l\xE3nh \u0111\u1EA1o:',
            value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'col-input',
            value: this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet : '',
            label: '\xDD ki\u1EBFn x\u1EED l\xFD:' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon })
        )
      );
    }
  }]);

  return TrinhLanhDaoTTXMView;
}(_react2.default.Component);

exports.default = TrinhLanhDaoTTXMView;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _GetParams = __webpack_require__(47);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrinhLanhDaoTheoDoiThucHien = function (_React$Component) {
  _inherits(TrinhLanhDaoTheoDoiThucHien, _React$Component);

  function TrinhLanhDaoTheoDoiThucHien(props, context) {
    _classCallCheck(this, TrinhLanhDaoTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (TrinhLanhDaoTheoDoiThucHien.__proto__ || Object.getPrototypeOf(TrinhLanhDaoTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      loaiDon: _this.props.loaiDon,

      dataDetail: [],

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      yKienGiaiQuyet: ''
    };
    return _this;
  }

  _createClass(TrinhLanhDaoTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        loaiDon: nextProps.loaiDon,
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
      });
      if (this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
        this.checkOnlyState(nextProps.dataNextStates);
      }
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          _this2.setState({
            dataDetail: res.data,
            canBoXuLyChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        if (_this2.props.dataNextStates && _this2.props.dataNextStates.length > 0) {
          _this2.checkOnlyState(_this2.props.dataNextStates);
        }
      });
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState(dataNextStates) {
      this.setState({
        nextState: dataNextStates[0].type
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataDetail;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      if (this.state.canBoXuLyChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoXuLyChiDinh)
        };
      } else {
        params.canBoXuLyChiDinh = null;
      }
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet ? this.state.yKienGiaiQuyet : '';

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });

      var params = this.getParams();
      this.saveGiaiQuyetDon(params, 'gqdLuu');
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this3 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var selectedState = this.props.dataNextStates.filter(function (state) {
          return state.type == _this3.state.nextState;
        });
        var params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.props.thongTinGiaiQuyetDonId)
          },
          canBoXuLyChiDinh: {
            id: Number(this.state.canBoXuLyChiDinh)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          },
          yKienGiaiQuyet: this.state.yKienGiaiQuyet
        };
        this.postGiaiQuyetDon(params, 'gqdTrinhLanhDao');
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this4.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this5.props.dispatch({ type: 'REFRESH_MENU', value: true });
        _this5.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.state.dataDetail;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataDetail }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(_subView.BlockBanHanhQuyetDinhView, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataDetail, dataKetLuanNoiDungKhieuNai: this.props.dataKetLuanNoiDungKhieuNai }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb15' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.DropDown, {
              label: 'Ban l\xE3nh \u0111\u1EA1o',
              options: this.props.lanhDaoList,
              keyName: 'congChucId',
              valueName: 'hoVaTen',
              bindValidator: this,
              require: true,
              channel: 'formTaoDon',
              selectedValue: this.state.canBoXuLyChiDinh,
              onChange: this.handleChange.bind(this, 'canBoXuLyChiDinh'),
              placeholder: this.props.placeholder,
              name: 'chonBanlanhDaoTTXM' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              value: this.state.yKienGiaiQuyet,
              onChange: this.handleChange.bind(this, 'yKienGiaiQuyet'),
              name: 'textareaBanLanhDaoTTXM' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom gqd-wrap pt35 mt20' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.handleKetThuc.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Tr\xECnh'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TrinhLanhDaoTheoDoiThucHien;
}(_react2.default.Component);

TrinhLanhDaoTheoDoiThucHien.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TrinhLanhDaoTheoDoiThucHien));

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrinhLanhDaoTheoDoiThucHienView = function (_React$Component) {
  _inherits(TrinhLanhDaoTheoDoiThucHienView, _React$Component);

  function TrinhLanhDaoTheoDoiThucHienView(props, context) {
    _classCallCheck(this, TrinhLanhDaoTheoDoiThucHienView);

    var _this = _possibleConstructorReturn(this, (TrinhLanhDaoTheoDoiThucHienView.__proto__ || Object.getPrototypeOf(TrinhLanhDaoTheoDoiThucHienView)).call(this, props, context));

    _this.state = {
      DataDetail: _this.props.thongTinXuLyGiaiQuyet && _this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? _this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : [],
      DataGiaiQuyet: _this.props.thongTinXuLyGiaiQuyet
    };
    return _this;
  }

  _createClass(TrinhLanhDaoTheoDoiThucHienView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        DataGiaiQuyet: nextProps.thongTinXuLyGiaiQuyet,
        DataDetail: nextProps.thongTinXuLyGiaiQuyet && nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var DataGiaiQuyet = this.props.thongTinXuLyGiaiQuyet;
      var DataDetail = this.state.DataDetail;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.props.thongTinGQD }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(_subView.BlockBanHanhQuyetDinhView, { donInfo: this.props.donInfo, thongTinGQD: this.props.thongTinGQD, dataKetLuanNoiDungKhieuNai: this.props.dataKetLuanNoiDungKhieuNai }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb15' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, { label: 'Ban l\xE3nh \u0111\u1EA1o:', className: 'col-25 mb10', value: DataGiaiQuyet.canBoXuLyChiDinhInfo ? DataGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextMessage, { label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: DataGiaiQuyet.yKienGiaiQuyet ? DataGiaiQuyet.yKienGiaiQuyet : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        )
      );
    }
  }]);

  return TrinhLanhDaoTheoDoiThucHienView;
}(_react2.default.Component);

TrinhLanhDaoTheoDoiThucHienView.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TrinhLanhDaoTheoDoiThucHienView));

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NhiemVuTTXM = __webpack_require__(1187);

var _NhiemVuTTXM2 = _interopRequireDefault(_NhiemVuTTXM);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var CanBoGiaiQuyetYeuCauLapDuThao = function (_React$Component) {
  _inherits(CanBoGiaiQuyetYeuCauLapDuThao, _React$Component);

  function CanBoGiaiQuyetYeuCauLapDuThao(props, context) {
    _classCallCheck(this, CanBoGiaiQuyetYeuCauLapDuThao);

    var _this = _possibleConstructorReturn(this, (CanBoGiaiQuyetYeuCauLapDuThao.__proto__ || Object.getPrototypeOf(CanBoGiaiQuyetYeuCauLapDuThao)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: _this.props.id,
      role: _this.props.role,
      loaiDon: _this.props.loaiDon,
      validate: false,
      showAttach: false,
      yKienGiaiQuyet: '',
      noiDungKetLuanDuThao: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: _this.props.coQuanQuanLyNguoiDung,
      nextState: 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      hasChange: false,
      backConfirm: false
    };
    return _this;
  }

  _createClass(CanBoGiaiQuyetYeuCauLapDuThao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        loaiDon: nextProps.loaiDon
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.hasChange();
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'nextState') {}
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this2.setState({
              dataGiaiQuyetDon: res.data,
              canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
              noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX) : ''
            }, function () {
              _this2.renderAttachFile();
            });
          }
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose(type) {
      if (type == true) {
        _reactRouter.browserHistory.goBack();
      } else if (this.state.hasChange) {
        this.setState({
          backConfirm: true
        });
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'hasChange',
    value: function hasChange() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.hasChange();
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.hasChange();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = (0, _GetParams.getParams)(this.state.dataGiaiQuyetDon, this.state.id);

      params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao ? this.state.noiDungKetLuanDuThao : '';
      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this3 = this;

      this.setState({
        onSave: true
      }, function () {
        if (_this3.validateSubmitForm()) {
          _this3.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          var dataFileDinhKem = _this3.getListDataFileDinhKem();
          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this3.state.taiLieuVanThuUpdate[_this3.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this3.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this3.state.taiLieuVanThu[_this3.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this3.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this3.state.dataTaiLieuVanThuDelete.length > 0) {
            _this3.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this3.state.taiLieuVanThuDelete[_this3.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var params = _this3.getParams();

          params.noiDungKetLuanDuThao = _this3.state.noiDungKetLuanDuThao;

          _this3.postTaiLieuVanThu(_this3.state.taiLieuVanThu, function () {
            _this3.updateTaiLieuVanThu(_this3.state.taiLieuVanThuUpdate, function () {
              _this3.deleteTaiLieuVanThu(_this3.state.taiLieuVanThuDelete, function () {
                _this3.saveGiaiQuyetDon(params);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon(type) {
      var _this4 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this4.validateSubmitForm()) {
          _this4.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this4.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this4.state.taiLieuVanThuUpdate[_this4.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this4.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this4.state.taiLieuVanThu[_this4.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this4.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this4.state.dataTaiLieuVanThuDelete.length > 0) {
            _this4.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this4.state.taiLieuVanThuDelete[_this4.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this4.getParams();
          var params = {};

          if (_this4.props.tuGiaiQuyet == true) {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this4.state.thongTinGiaiQuyetDonId)
              },
              actionType: 'TTXM_GUI_DU_THAO',
              yKienGiaiQuyet: _this4.state.noiDungKetLuanDuThao
            };
          } else {
            var selectedState = _this4.props.dataNextStates.filter(function (state) {
              return state.type == _this4.state.nextState;
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this4.state.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              },
              yKienGiaiQuyet: _this4.state.noiDungKetLuanDuThao
            };
          }
          _this4.postTaiLieuVanThu(_this4.state.taiLieuVanThu, function () {
            _this4.updateTaiLieuVanThu(_this4.state.taiLieuVanThuUpdate, function () {
              _this4.deleteTaiLieuVanThu(_this4.state.taiLieuVanThuDelete, function () {
                _this4.updateGiaiQuyetDon(_params, params, 'gqdGuiDuThao');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.hasChange();
      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      }
      this.hasChange();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.hasChange();
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'GIA_HAN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
      this.hasChange();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this5 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this5.compareDate(new Date(state.ngayTao), new Date(_this5.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this5.compareDate(new Date(_this5.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
      });

      var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
      var dataCheck = data.filter(function (item) {
        return item.required && item.typeRequired == 'DT_KL_GQKN';
      });
      if (dataCheck.length > 0) {
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        });
      } else {
        var DT_KL = {
          ten: 'Dự thảo quyết định về việc giải quyết khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        };
        var TT_KL = {
          ten: 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DT_KL_GQKN',
          newFile: true
        };
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDon), [TT_KL, DT_KL]),
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          showAttach: true
        });
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon();
    }
    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this6.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this7.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this8.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_NhiemVuTTXM2.default, {
          donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM,
          donInfo: this.props.donInfo,
          lanhDaoView: this.props.lanhDaoView
        }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
                'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                lb2
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 mb15 no-gutter' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: "Đơn vị " + lb1 + ":", value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDung ? this.state.dataGiaiQuyetDon.noiDung : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    '\u0110\u1ED1i tho\u1EA1i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : '' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', red: true, value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : '' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
        ),
        _react2.default.createElement(
          'form',
          { className: 'form-action' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, { value: this.state.noiDungKetLuanDuThao, className: 'areal-wrap col-100', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'noiDungKetLuanDuThao'), name: 'textareaChonCanBoGiaiQuyet' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showAttach },
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, data: this.state.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'G\u1EEDi d\u1EF1 th\u1EA3o'
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " dự thảo của đơn/vụ việc này không?" })
            )
          )
        ),
        _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.backConfirm,
          onClose: this.closeConfirmBack.bind(this),
          onSuccess: this.onClickClose.bind(this, true),
          title: 'X\xE1c nh\u1EADn',
          content: _message.msg.confirmBack })
      );
    }
  }]);

  return CanBoGiaiQuyetYeuCauLapDuThao;
}(_react2.default.Component);

CanBoGiaiQuyetYeuCauLapDuThao.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CanBoGiaiQuyetYeuCauLapDuThao);

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var CanBoNhanYeuCauTheoDoiThucHien = function (_React$Component) {
  _inherits(CanBoNhanYeuCauTheoDoiThucHien, _React$Component);

  function CanBoNhanYeuCauTheoDoiThucHien(props, context) {
    _classCallCheck(this, CanBoNhanYeuCauTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (CanBoNhanYeuCauTheoDoiThucHien.__proto__ || Object.getPrototypeOf(CanBoNhanYeuCauTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      dataDetail: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      id: _this.props.id,
      loaiDon: _this.props.loaiDon,
      nextState: '',
      khoiTo: false,
      openDialog: false,
      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,
      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',
      ketQuaThucHienKhac: '',
      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0
    };
    return _this;
  }

  _createClass(CanBoNhanYeuCauTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanTheoDoiEnumn();
      if (this.props.dataNextStates && this.props.dataNextStates.length > 0) {
        this.checkOnlyState(this.props.dataNextStates);
      }
      this.getDetail(this.state.thongTinGiaiQuyetDonId);
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/CanBoNhanYeuCauTheoDoiThucHien');
      }
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this2 = this;

      if (typeof id != 'undefined') {
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: id }).then(function (res) {
          if (res.data) {
            _this2.setState({
              dataDetail: res.data,
              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
              showFile: false
            }, function () {
              _this2.checkFileDinhKem();
              if (_this2.props.dataNextStates && _this2.props.dataNextStates.length > 0) {
                _this2.checkOnlyState(_this2.props.dataNextStates);
              }
            });
          }
        });
      }
    }
  }, {
    key: 'checkFileDinhKem',
    value: function checkFileDinhKem() {
      var _this3 = this;

      var data = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var dataView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var listTaiLieuVanThuGiaiQuyetDon = data.filter(function (state) {
        return _this3.compareDate(new Date(state.ngayTao), new Date(_this3.state.dataDetail.ngayChuyenTheoDoiThucHien), 'show');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(function (state) {
        return _this3.compareDate(new Date(_this3.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
      });
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
      }, function () {
        _this3.setState({
          showFile: true
        });
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState(dataNextStates) {
      this.setState({
        nextState: dataNextStates[0].type
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        loaiDon: nextProps.loaiDon
      });
      if (this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
        this.checkOnlyState(nextProps.dataNextStates);
      }
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleKetThuc();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataDetail;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (params.giaoCoQuanDieuTra && this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      params.theoDoiThucHien = true;
      params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
      if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
        params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
      } else {
        params.coQuanTheoDoi = null;
      }
      params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
      params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

      params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
      params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
      params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
      params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

      params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
      params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
      params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
      params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;

      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this5 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });

        var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this5.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var _params = this.getParams();
        var params = {};
        if (this.props.tuGiaiQuyet == true) {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            actionType: 'LANH_DAO_TU_TDTH'
          };
        } else {
          var selectedState = this.props.dataNextStates.filter(function (state) {
            return state.type == _this5.state.nextState;
          });
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            }
          };
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
            _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
              if (_this5.props.tuGiaiQuyet == true) {
                _this5.postGiaiQuyetDon(params, 'gqdLuuHoSo');
              } else {
                _this5.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
              }
            });
          });
        });
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this6 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });

      var dataFileDinhKem = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this6.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      var params = this.getParams();
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
        _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
          _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
            _this6.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.props.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this7.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.props.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this8.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this9.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.setState({
        dataFileDinhKem: data
      });
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      this.setState({
        dataFileDinhKem: data
      });

      this.props.handleChangeData();
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.state.dataDetail;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == DataDetail.ketLuanNoiDungKhieuNai;
      });

      var lb1 = this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block container-filedinhkem' },
        _react2.default.createElement('div', { className: 'wrap-big-line pt15' }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
              'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
              lb2
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.huongThuLyGiaiQuyet != 'TU_TTXM' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mb15 no-gutter' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: "Đơn vị " + lb1 + ":", value: DataDetail.donViThamTraXacMinhInfo ? DataDetail.donViThamTraXacMinhInfo.ten : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: DataDetail.ngayHetHanTTXM ? (0, _moment2.default)(DataDetail.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: DataDetail.ngayTraBaoCaoTTXM ? (0, _moment2.default)(DataDetail.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: DataDetail.noiDung ? DataDetail.noiDung : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.loaiDon == 'DON_TO_CAO' && DataDetail.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o:'
                  )
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n:', value: DataDetail.soQuyetDinhGiaHanGiaiQuyet ? DataDetail.soQuyetDinhGiaHanGiaiQuyet : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet ? (0, _moment2.default)(DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', red: true, label: 'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u1EBFn ng\xE0y:', value: DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'L\xFD do gia h\u1EA1n:', value: DataDetail.lyDoGiaHanGiaiQuyet ? DataDetail.lyDoGiaHanGiaiQuyet : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.doiThoai == true && this.state.loaiDon == 'DON_KHIEU_NAI' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      '\u0110\u1ED1i tho\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.thoiGianDoiThoai ? (0, _moment2.default)(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: DataDetail.diaDiemDoiThoai ? DataDetail.diaDiemDoiThoai : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', red: true, value: this.props && DataDetail.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props && DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      ' D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y tr\xECnh d\u1EF1 th\u1EA3o:', value: DataDetail.ngayKetThucGiaoLapDuThao ? (0, _moment2.default)(DataDetail.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.noiDungKetLuanDuThao ? DataDetail.noiDungKetLuanDuThao : '' })
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 mt5 no-gutter' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb10' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.ketQuaXLDGiaiQuyet == 'DOI_THOAI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  '\u0110\u1ED1i tho\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.thoiGianDoiThoai ? (0, _moment2.default)(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: DataDetail.diaDiemDoiThoai }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : '' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', value: DataDetail.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : '' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter pt5 pb15' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.loaiDon == 'DON_TO_CAO' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.loaiDon == 'DON_KHIEU_NAI' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.loaiDon != 'DON_TO_CAO' && this.state.loaiDon != 'DON_KHIEU_NAI' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper col-100 no-gutter title-12 mt0 mb15' },
              'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mb15' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(DataDetail.soVuGiaiQuyetKhieuNai) }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.loaiDon == 'DON_KHIEU_NAI' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.loaiDon == 'DON_TO_CAO' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung t\u1ED1 c\xE1o:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.loaiDon != 'DON_TO_CAO' && this.state.loaiDon != 'DON_KHIEU_NAI' },
              _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung ki\u1EBFn ngh\u1ECB ph\u1EA3n \xE1nh:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' })
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: DataDetail.ketQuaGiaiQuyetKhac ? DataDetail.ketQuaGiaiQuyetKhac : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mb5' },
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(DataDetail.tienPhaiThuNhaNuocQDGQ) }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(DataDetail.datPhaiThuNhaNuocQDGQ) })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-50 no-gutter mb20' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(DataDetail.tienPhaiTraCongDanQDGQ) }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(DataDetail.datPhaiTraCongDanQDGQ) })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'p',
                { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                'X\u1EED l\xFD h\xE0nh ch\xEDnh'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(DataDetail.tongSoNguoiXuLyHanhChinh) }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(DataDetail.soNguoiDaBiXuLyHanhChinh) }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(DataDetail.soNguoiDuocTraLaiQuyenLoi) })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb15' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb15' },
              'Theo d\xF5i th\u1EF1c hi\u1EC7n'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter pt5 pb15' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(DataDetail.soVuGiaoCoQuanDieuTra) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(DataDetail.soDoiTuongGiaoCoQuanDieuTra) })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb20' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Kh\u1EDFi t\u1ED1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soVuBiKhoiTo', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', name: 'soDoiTuongBiKhoiTo', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mt5 pb20' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb15' },
                'N\u1ED9i dung Theo d\xF5i th\u1EF1c hi\u1EC7n'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb20' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), name: 'coQuanTheoDoi', data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb20' },
                _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac'), name: 'ketQuaThucHienKhac' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc'), name: 'tienPhaiThuTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc'), name: 'datPhaiThuTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc'), name: 'tienDaThuTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc'), name: 'datDaThuTheoDoiThucHien' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan'), name: 'tienPhaiTraTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan'), name: 'datPhaiTraTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan'), name: 'tienDaTraTheoDoiThucHien' }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan'), name: 'datDaTraTheoDoiThucHien' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, {
                name: 'GiaoCQDT',
                label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView,
                data: this.state.listTaiLieuVanThuGiaiQuyetDon,
                onSave: this.state.onSave,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom gqd-wrap pt35' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'luuHoSo') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                ),
                _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' })
              )
            )
          )
        )
      );
    }
  }]);

  return CanBoNhanYeuCauTheoDoiThucHien;
}(_react2.default.Component);

CanBoNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CanBoNhanYeuCauTheoDoiThucHien);

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var _core = __webpack_require__(7);

var _GetParams = __webpack_require__(47);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var GiaiQuyetDonCanBo = function (_React$Component) {
  _inherits(GiaiQuyetDonCanBo, _React$Component);

  function GiaiQuyetDonCanBo(props, context) {
    _classCallCheck(this, GiaiQuyetDonCanBo);

    var _this = _possibleConstructorReturn(this, (GiaiQuyetDonCanBo.__proto__ || Object.getPrototypeOf(GiaiQuyetDonCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.donId,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogGiaoTTXM: false,
      openDialogLuuHoSo: false,
      isValid: false,
      loaiDon: _this.props.loaiDonGiaTri,
      gqText: _this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Ban hành văn bản giải quyết' : _this.props.loaiDonGiaTri == 'DON_TO_CAO' ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết',
      tTXMRequired: false,
      open: false,
      showFile: false,

      lapToDoanXacMinh: false,
      giaHanGiaiQuyet: false,
      giaHanTTXM: false,
      doiThoai: false,
      giaoCoQuanDieuTra: false,
      quyetDinhGiaiQuyetKhieuNai: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      valueKetQua: '',

      donViThamTraXacMinh: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        baoCaoKetQuaTTXM: [],
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      dataCoQuanTheoDoi: [],
      nextState: '',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNai: '',
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',

      //DON_KHIEU_NAI
      soQuyetDinhGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanGia: '',

      //DON_TO_CAO
      soQuyetDinhGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      soVuGiaiQuyetKhieuNai: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      yKienGiaiQuyet: '',

      tienPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      soNguoiDuocTraLaiQuyenLoi: '',

      soLanGiaiQuyetLai: '',
      ketQuaThucHienKhac: '',
      ketQuaKhac: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',
      listTaiLieuVanThuGiaiQuyetDonView: _this.props.listTaiLieuVanThuGiaiQuyetDonView,

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,
      hasChange: false,
      backConfirm: false,
      thoiHanBaoCaoKetQuaTTXM: '',
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      dataKetQuaGiaiQuyetDon: [],
      tienDoDoiThoai: '',
      message: 'Chọn "' + _this.gqText + '" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      tenCoQuan: _this.props.tenCoQuan
    };
    return _this;
  }

  _createClass(GiaiQuyetDonCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getCoQuanTheoDoiEnumn();
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/GiaiQuyetDonCanBo');
      }
      if (this.props.tenCoQuan.length == 0) {
        _api.DuLieuHeThong.actions.getDonViTTXM.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViTTXM',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.tenCoQuan != this.props.tenCoQuan) {
        this.state.tenCoQuan = nextProps.tenCoQuan;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this3 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDonGiaTri
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'checkTypeComponent',
    value: function checkTypeComponent() {
      this.setState({
        nextState: 'KET_THUC',
        tTXMRequired: true
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose(type) {
      if (type == true) {
        _reactRouter.browserHistory.goBack();
      } else if (this.state.hasChange) {
        this.setState({
          backConfirm: true
        });
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'hasChange',
    value: function hasChange() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this5 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this5.setState({
              dataGiaiQuyetDon: res.data,
              soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
              truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
              ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',

              giaHanTTXM: res.data.giaHanTTXM,
              soQuyetDinhGiaHanTTXM: res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
              ngayRaQuyetDinhGiaHanTTXM: res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',
              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? new Date(res.data.ngayHetHanSauKhiGiaHanTTXM) : '',
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',

              giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,
              soQuyetDinhGiaHanGiaiQuyet: res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
              ngayRaQuyetDinhGiaHanGiaiQuyet: res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',
              ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? new Date(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet) : '',
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',

              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              lapToDoanXacMinh: res.data.lapToDoanXacMinh,
              doiThoai: res.data.doiThoai,
              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,
              lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
              lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

              donViThamTraXacMinh: res.data.donViThamTraXacMinhInfo ? res.data.donViThamTraXacMinhInfo.coQuanQuanLyId : '',
              ngayHetHanTTXM: res.data.ngayHetHanTTXM ? new Date(res.data.ngayHetHanTTXM) : '',
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ? res.data.ketQuaXLDGiaiQuyet : '',
              tienDoDoiThoai: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet == 'DOI_THOAI' ? 'DOI_THOAI' : 'KHONG_DOI_THOAI' : _this5.props.loaiDon != 'DON_KHIEU_NAI' ? 'KHONG_DOI_THOAI' : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? true : false,
              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,

              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
              showFile: true,
              allowAttach: true
            }, function () {
              _this5.checkFileCoQuanDieuTra();
            });
          }
          _this5.checkTypeComponent();
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this6 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this6.state.giaoCoQuanDieuTra == false) {
          _this6.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired === 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this6.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this6.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.hasChange();
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.hasChange();
      if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.state.message = 'Ch\u1ECDn "' + this.state.gqText + '" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else if (name === 'ketQuaXLDGiaiQuyet' && e.target.value === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
        this.state.open = true;
        this.state.valueKetQua = e.target.value;
        this.setState(_extends({}, this.state));
      } else {

        this.setState(_defineProperty({}, name, e.target.value));

        if (name === 'tienDoDoiThoai' && e.target.value != 'KHONG_DOI_THOAI') {
          this.state.ketQuaXLDGiaiQuyet = '';
          this.state.tienDoDoiThoai = e.target.value;
          this.setState(_extends({}, this.state));
        }

        if (name === 'ketQuaXLDGiaiQuyet' || name === 'nextState' || name === 'hinhThucTheoDoi' || name === 'soLanGiaiQuyetLai' || name === 'ketQuaGiaiQuyetLan2') {}

        if (name === 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          this.setState({
            ketQuaGiaiQuyetLan2: ''
          });
        }

        if (name === 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }

        if (name === 'nextState' && e.target.value === 'CAN_BO_CHUYEN_DON_VI_TTXM') {
          this.setState({
            tTXMRequired: false
          });
        }
      }
    }
  }, {
    key: 'sheckFileRequired',
    value: function sheckFileRequired(data) {
      this.setState({
        showFile: false
      });
      var listTaiLieuVanThuGiaiQuyetDonView = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView));

      var dataCheckFileRequired = listTaiLieuVanThuGiaiQuyetDonView.filter(function (state) {
        return state.required && state.typeRequired === 'QD_GTTXM';
      });

      if (dataCheckFileRequired.length > 0) {
        // do nothing
        this.setState({
          nextState: data ? data : this.state.nextState,
          showFile: true
        });
      } else {
        var fileRequired = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'QD_GTTXM'
        };
        if (this.state.loaiDon === 'DON_KHIEU_NAI') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
        } else if (this.state.loaiDon === 'DON_TO_CAO') {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung tố cáo';
        } else {
          fileRequired.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung kiến nghị phản ánh';
        }
        this.setState({
          listTaiLieuVanThuGiaiQuyetDonView: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaiQuyetDonView), [fileRequired]),
          nextState: data ? data : this.state.nextState,
          showFile: true
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.hasChange();
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type === 'BAO_CAO_KET_QUA_TTXM') {
        dataFileDinhKem.baoCaoKetQuaTTXM = data;
      } else if (type === 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_TTT';
        });
        this.setState({ ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
      } else if (type === 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type === 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem(type) {
      if (type === 'GIAO_TTXM') {
        return this.state.dataFileDinhKem.data;
      } else {
        var dataFileDinhKem = [];
        var Data = this.state.dataFileDinhKem;

        if (Data.baoCaoKetQuaTTXM.length > 0) {
          Data.baoCaoKetQuaTTXM.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.data.length > 0) {
          Data.data.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
          Data.quyetDinhGiaiQuyet.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
          Data.giaoCoQuanDieuTra.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
          Data.giaHan.map(function (state) {
            dataFileDinhKem[dataFileDinhKem.length] = state;
          });
        }

        return dataFileDinhKem;
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
          params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
      if (this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
        params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

        if (this.props.loaiDon === 'DON_KHIEU_NAI') {
          params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

          if (Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
          } else {
            params.ketQuaGiaiQuyetLan2 = null;
          }

          if (this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
          } else {
            params.noiDungKetLuanGiaiQuyetLai = '';
          }
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
        params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;
      }

      if (this.state.theoDoiThucHien) {
        params.theoDoiThucHien = true;
        params.hinhThucTheoDoi = this.state.hinhThucTheoDoi;
        if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
          params.coQuanTheoDoi = this.state.coQuanTheoDoi;
        } else {
          params.coQuanTheoDoi = null;
        }
        params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi;
        params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac;

        params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
        params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
        params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
        params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

        params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
        params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
        params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
        params.datDaTraCongDan = Number(this.state.datDaTraCongDan);
      } else {
        params.theoDoiThucHien = false;
        params.ketQuaThucHienKhac = '';
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;

        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;
      }

      params.ketQuaXLDGiaiQuyet = this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' && this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

      if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO') {
        if (this.state.doiThoai) {
          params.doiThoai = true;
          params.thoiGianDoiThoai = (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString();
          params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
          params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        } else {
          params.doiThoai = false;
          params.thoiGianDoiThoai = null;
          params.diaDiemDoiThoai = '';
          params.noiDungDoiThoai = '';
        }
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }

      params.donViThamTraXacMinh = null;
      params.ngayHetHanTTXM = null;
      params.yKienGiaiQuyet = '';

      params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM ? this.state.ketLuanNoiDungKhieuNaiGiaoTTXM : null;

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this7 = this;

      this.setState({
        onSave: true
      }, function () {

        _this7.setState({
          btnLoading: true,
          btnSaveLoading: true
        });

        var dataFileDinhKem = _this7.getListDataFileDinhKem('KET_THUC');

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this7.state.taiLieuVanThuUpdate[_this7.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this7.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this7.state.taiLieuVanThu[_this7.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this7.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (_this7.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this7.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          var dataFile = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
          dataFile.map(function (item) {
            _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (!_this7.state.giaoCoQuanDieuTra) {
          var _dataFile = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          _dataFile.map(function (item) {
            _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (_this7.state.dataTaiLieuVanThuDelete.length > 0) {
          _this7.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = _this7.getParams();
        _this7.postTaiLieuVanThu(_this7.state.taiLieuVanThu, function () {
          _this7.updateTaiLieuVanThu(_this7.state.taiLieuVanThuUpdate, function () {
            _this7.deleteTaiLieuVanThu(_this7.state.taiLieuVanThuDelete, function () {
              _this7.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this8 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this8.validateSubmitForm()) {
          _this8.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this8.getListDataFileDinhKem('KET_THUC');

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this8.state.taiLieuVanThuUpdate[_this8.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this8.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this8.state.taiLieuVanThu[_this8.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this8.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this8.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && _this8.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            var dataFile = [].concat(_toConsumableArray(_this8.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this8.state.giaoCoQuanDieuTra) {
            var _dataFile2 = [].concat(_toConsumableArray(_this8.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile2.map(function (item) {
              _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this8.state.dataTaiLieuVanThuDelete.length > 0) {
            _this8.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this8.state.taiLieuVanThuDelete[_this8.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this8.getParams();
          var selectedState = _this8.props.listNextStates.filter(function (state) {
            return state.type == _this8.state.nextState;
          });

          var params = {
            thongTinGiaiQuyetDon: {
              id: Number(_this8.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            }
          };
          _this8.postTaiLieuVanThu(_this8.state.taiLieuVanThu, function () {
            _this8.updateTaiLieuVanThu(_this8.state.taiLieuVanThuUpdate, function () {
              _this8.deleteTaiLieuVanThu(_this8.state.taiLieuVanThuDelete, function () {
                _this8.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.hasChange();
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.hasChange();
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type === 'BAO_CAO_KET_QUA_TTXM') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.baoCaoKetQuaTTXM = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type === 'QUYET_DINH_GIAI_QUYET') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type === 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else if (type === 'GIA_HAN') {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      } else {
        var _dataFileDinhKem4 = this.state.dataFileDinhKem;

        _dataFileDinhKem4.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem4
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'inPhieuGiaoTTXMKhieuNai',
    value: function inPhieuGiaoTTXMKhieuNai() {
      var _this9 = this;

      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId == _this9.state.donViThamTraXacMinh;
      });
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?" + "tenCoQuanThuLyGQKN=" + (this.props.coQuanDangQuyetInfo ? this.props.coQuanDangQuyetInfo.ten : '') + "&tenCoQuanDuocGiaoNhiemVuXM=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&hoTenNguoiKhieuNai=" + (this.props.listNguoiDungDon ? this.props.listNguoiDungDon[0].hoVaTen : '') + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') + "&donViXuLyId=" + userInfo.donViId + "&noiDungTTXM=" + this.props.noiDungDonThu;
      window.open(URL, "_self");
    }
  }, {
    key: 'inPhieuGiaoTTXMToCao',
    value: function inPhieuGiaoTTXMToCao() {
      var _this10 = this;

      var tenCoQuan = this.state.tenCoQuan.filter(function (state) {
        return state.coQuanQuanLyId == _this10.state.donViThamTraXacMinh;
      });
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var URL = String(_config.API_URL) + "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?" + "tenCoQuan=" + (tenCoQuan.length > 0 ? tenCoQuan[0].ten : '') + "&donViXuLyId=" + userInfo.donViId + "&thoiGianBaoCaoKetQuaTTXM=" + (0, _moment2.default)(this.state.ngayHetHanTTXM).format('DD/MM/YYYY') + "&noiDungDonThu=" + this.props.noiDungDonThu;
      window.open(URL, "_self");
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        if (name === 'giaoTTXM') {
          this.setState({
            openDialogGiaoTTXM: true
          });
        } else {
          this.setState({
            openDialogLuuHoSo: true
          });
        }
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialogGiaoTTXM: false,
        openDialogLuuHoSo: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialogLuuHoSo: false
      });
      this.handleKetThuc();
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this11 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this11.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this12 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this12.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this13 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this13.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this14.state.ketQuaXLDGiaiQuyet;
      });
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block container-filedinhkem' },
        _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.backConfirm,
          onClose: this.closeConfirmBack.bind(this),
          onSuccess: this.onClickClose.bind(this, true),
          title: 'X\xE1c nh\u1EADn',
          content: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === 'KET_THUC' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                  lb2
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pb5' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttach },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, loaiDon: this.props.loaiDon, phanLoaiQuyTrinh: 'BAO_CAO_KET_QUA_TTXM', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', tTXMText: 'TTXM_TTT', tTXMRequired: true, bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.loaiDon === 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mt5' },
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 pb15' },
                          _react2.default.createElement('span', { className: 'line-border' })
                        ),
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                        _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 pb5' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { phanLoaiQuyTrinh: 'GIA_HAN', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), onSave: this.props.onSave })
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'KET_THUC' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'p',
                      { className: 'attach-file-description mb10 pl5 pr5' },
                      'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: !this.state.showTienDoGiaiQuyet },
                      this.props.loaiDon == 'DON_KHIEU_NAI' && _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { name: 'tienDoDoiThoai', disable: this.state.ketQuaXLDGiaiQuyet != '' ? true : false, className: 'col-25', selectedValue: this.state.tienDoDoiThoai, onChange: this.onChange.bind(this, 'tienDoDoiThoai'), loaiDon: this.props.loaiDonGiaTri, isTTXMLai: this.props.donViThamTraXacMinhInfo == null }),
                      this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI' && _react2.default.createElement(_ttForms.DropDownMulipleUse, { disable: this.state.ketQuaXLDGiaiQuyet ? true : false, name: 'tienDoGiaiQuyet', confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.showTienDoGiaiQuyet },
                      _react2.default.createElement(_common.Text, { className: 'col-25', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: /*this.props.loaiDon == 'DON_TO_CAO' ||*/this.props.loaiDon === 'DON_KHIEU_NAI' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        _utils.ShowIfCheck,
                        { label: '\u0110\u1ED1i tho\u1EA1i', onChange: this.handleCheck.bind(this, 'doiThoai'), checked: this.state.doiThoai },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter mt5 pb20' },
                          _react2.default.createElement(
                            'h2',
                            { className: 'title-12 mb15' },
                            '\u0110\u1ED1i tho\u1EA1i'
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'row pl10 pr10' },
                            _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                            _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                            _react2.default.createElement(_common.TextArea, { className: 'col-100', require: true, bindValidator: this, channel: 'formTaoDon', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pt5 pb15' },
                      _react2.default.createElement('span', { className: 'line-border' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mb5 mt5' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon === 'DON_KHIEU_NAI' && this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh \u0111\xECnh ch\u1EC9'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon === 'DON_TO_CAO' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(_common.Input, { triggeOnBlur: true, name: 'inputSoVanBan', className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                        _react2.default.createElement(_common.DatePicker, { className: 'col-25', name: 'inputNgayBanHanh', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh') }),
                        _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                        this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhGiaiQuyet, className: 'areal-wrap col-100', label: 'N\u1ED9i dung ' + this.state.gqText, placeholder: 'Nh\u1EADp ...', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet'), name: 'lyDoBanHanhQuyetDinhGiaiQuyet' }),
                        this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' && _react2.default.createElement(_common.TextArea, { value: this.state.lyDoBanHanhQuyetDinhDinhChi, bindValidator: this, channel: 'formTaoDon', require: true, className: 'areal-wrap col-100', label: 'L\xFD do \u0111\xECnh ch\u1EC9', placeholder: 'Nh\u1EADp l\xFD do', onChange: this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi'), name: 'lyDoBanHanhQuyetDinhDinhChi', maxLength: 1000 }),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.allowAttach },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100' },
                            _react2.default.createElement(_upload.ContainerFileDinhKem, { quyetDinh: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false, loaiVanBanSuggest: 'QDGQ_TTT', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_TTT', qDGQRequired: this.state.tTXMRequired, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pt10 pb20' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuGiaiQuyetKhieuNai, onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai') }),
                          _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                          _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter mb20' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ') }),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter mb20' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                            ),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ') }),
                            _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ') })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-100 no-gutter' },
                            _react2.default.createElement(
                              'p',
                              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                              'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                            ),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi') })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter pt5 pb15' },
                          _react2.default.createElement('span', { className: 'line-border' })
                        )
                      )
                    )
                  )
                )
              ),
              this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' && _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Theo d\xF5i th\u1EF1c hi\u1EC7n', onChange: this.handleCheck.bind(this, 'theoDoiThucHien'), checked: this.state.theoDoiThucHien },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb20' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.hinhThucTheoDoi === 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb20' },
                      _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mb20' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc') })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan') }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan') })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { className: 'col-25', label: 'T\xEAn c\u01A1 quan', bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongGiaoCoQuanDieuTra, onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter pb5' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Kh\u1EDFi t\u1ED1'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter mb20' },
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === 'KET_THUC' && this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { phanLoaiQuyTrinh: '', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), onSave: this.state.onSave })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState === 'KET_THUC' },
                _react2.default.createElement(
                  'span',
                  { className: 'wrap-link' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u t\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' || this.state.tienDoDoiThoai === 'DOI_THOAI' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'luuHoSo') },
                      _react2.default.createElement(
                        'span',
                        null,
                        'L\u01B0u h\u1ED3 s\u01A1'
                      )
                    )
                  ),
                  _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this, 'luuHoSo'), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return GiaiQuyetDonCanBo;
}(_react2.default.Component);

GiaiQuyetDonCanBo.defaultProps = {
  validators: {},
  tenCoQuan: [],
  ketQuaGiaiQuyetDon: [],
  onSave: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    tenCoQuan: state.duLieuHeThong.donViTTXM,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(GiaiQuyetDonCanBo);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaHoanThanhGiaiQuyetDonCanBo = function (_React$Component) {
  _inherits(KetQuaHoanThanhGiaiQuyetDonCanBo, _React$Component);

  function KetQuaHoanThanhGiaiQuyetDonCanBo(props, context) {
    _classCallCheck(this, KetQuaHoanThanhGiaiQuyetDonCanBo);

    var _this = _possibleConstructorReturn(this, (KetQuaHoanThanhGiaiQuyetDonCanBo.__proto__ || Object.getPrototypeOf(KetQuaHoanThanhGiaiQuyetDonCanBo)).call(this, props, context));

    _this.state = {
      donViThamTraXacMinhInfo: _this.props.donViThamTraXacMinhInfo,
      ngayHetHanTTXM: _this.props.ngayHetHanTTXM,
      dataKetQuaGiaiQuyetDon: []
    };
    return _this;
  }

  _createClass(KetQuaHoanThanhGiaiQuyetDonCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getKetQuaGiaiQuyetDon();
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaHoanThanhGiaiQuyetDonCanBo');
      }
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this2 = this;

      var params = {
        banHanhQuyetDinh: true,
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this2.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == _this3.props.ketLuanNoiDungKhieuNai;
      });
      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == _this3.props.ketQuaThucHienTheoDoi;
      });
      var ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this3.props.ketQuaXLDGiaiQuyet;
      });
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block container-filedinhkem' },
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15 mt10' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
          lb2
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_TO_CAO' && this.props.giaHanGiaiQuyet },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15 pl5 pr5' },
                      'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n:', value: this.props.soQuyetDinhGiaHanGiaiQuyet }),
                    _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: this.props.ngayRaQuyetDinhGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u1EBFn ng\xE0y:', value: this.props.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'L\xFD do gia h\u1EA1n:', value: this.props.lyDoGiaHanGiaiQuyet })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: ketQuaGiaiQuyetDon.length > 0 },
              _react2.default.createElement(
                'div',
                { className: 'col-100 mt5 no-gutter' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'p',
                    { className: 'attach-file-description mb10 pl5 pr5' },
                    'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_KHIEU_NAI' && this.props.doiThoai },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    '\u0110\u1ED1i tho\u1EA1i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.props.thoiGianDoiThoai ? (0, _moment2.default)(this.props.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.props.diaDiemDoiThoai }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.props.noiDungDoiThoai ? this.props.noiDungDoiThoai : '' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.quyetDinhGiaiQuyetKhieuNai },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon == 'DON_TO_CAO' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10 mb15' },
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaiQuyetKhieuNai) }),
                        _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' }),
                        _react2.default.createElement(_common.Text, { label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', className: 'col-25', value: this.props.ketQuaGiaiQuyetKhac })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-50 no-gutter mb20' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuocQDGQ) }),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuocQDGQ) })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-50 no-gutter mb20' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDanQDGQ) }),
                          _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDanQDGQ) })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 no-gutter' },
                          _react2.default.createElement(
                            'p',
                            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                            'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                          ),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.tongSoNguoiXuLyHanhChinh) }),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(this.props.soNguoiDaBiXuLyHanhChinh) }),
                          _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(this.props.soNguoiDuocTraLaiQuyenLoi) })
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.theoDoiThucHien },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10 mb15' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.ketQuaThucHienKhac })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter mb15' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.datPhaiThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.tienDaThuNhaNuoc) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.datDaThuNhaNuoc) })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datPhaiTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.tienDaTraCongDan) }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.datDaTraCongDan) })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.giaoCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuGiaoCoQuanDieuTra) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongGiaoCoQuanDieuTra) })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.khoiTo },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5 pb5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    'Kh\u1EDFi t\u1ED1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.soVuBiKhoiTo) }),
                      _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.soDoiTuongBiKhoiTo) })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true, hideDescription: true })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'DSVanBanBS', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaHoanThanhGiaiQuyetDonCanBo;
}(_react2.default.Component);

KetQuaHoanThanhGiaiQuyetDonCanBo.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaHoanThanhGiaiQuyetDonCanBo);

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaLapDuThaoCanBo = function (_React$Component) {
  _inherits(KetQuaLapDuThaoCanBo, _React$Component);

  function KetQuaLapDuThaoCanBo() {
    _classCallCheck(this, KetQuaLapDuThaoCanBo);

    return _possibleConstructorReturn(this, (KetQuaLapDuThaoCanBo.__proto__ || Object.getPrototypeOf(KetQuaLapDuThaoCanBo)).apply(this, arguments));
  }

  _createClass(KetQuaLapDuThaoCanBo, [{
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaLapDuThaoCanBo');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(function (state) {
        return state.giaTri == _this2.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketLuanNoiDungKhieuNai;
      });

      var ketQuaThucHien = this.props.dataKetQuaThucHien.filter(function (state) {
        return state.giaTri == _this2.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienTheoDoi;
      });
      var ketQuaGiaiQuyetDon = this.props.ketQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this2.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
              'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
              lb2
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(_common.Text, { className: 'col-25', label: "Đơn vị " + lb1 + ":", value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayTraBaoCaoTTXM ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDonGiaTri == 'DON_TO_CAO' && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n x\xE1c minh n\u1ED9i dung t\u1ED1 c\xE1o:'
                  )
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh gia h\u1EA1n:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soQuyetDinhGiaHanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soQuyetDinhGiaHanGiaiQuyet : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayRaQuyetDinhGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb15', label: 'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt \u0111\u1EBFn ng\xE0y:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: 'L\xFD do gia h\u1EA1n:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.lyDoGiaHanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.lyDoGiaHanGiaiQuyet : '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri != 'DON_TO_CAO' && this.props.loaiDonGiaTri != 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb15' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuGiaiQuyetKhieuNai) }),
                _react2.default.createElement(_common.Text, { label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i:', className: 'col-25', value: ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaGiaiQuyetKhac ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaGiaiQuyetKhac : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiThuNhaNuocQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiThuNhaNuocQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiTraCongDanQDGQ) }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiTraCongDanQDGQ) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tongSoNguoiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soNguoiDaBiXuLyHanhChinh) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soNguoiDuocTraLaiQuyenLoi) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.theoDoiThucHien },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb15' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n:', value: ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienKhac ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienKhac : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienDaThuNhaNuoc) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datDaThuNhaNuoc) })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienDaTraCongDan) }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2):', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datDaTraCongDan) })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.giaoCoQuanDieuTra },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan:', value: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.coQuanDieuTraInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.coQuanDieuTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuGiaoCoQuanDieuTra) }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soDoiTuongGiaoCoQuanDieuTra) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.khoiTo },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Kh\u1EDFi t\u1ED1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuBiKhoiTo) }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soDoiTuongBiKhoiTo) })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: ketQuaGiaiQuyetDon.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'col-100 mt5 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb10' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'p',
                  { className: 'attach-file-description mb10 pl5 pr5' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
          )
        )
      );
    }
  }]);

  return KetQuaLapDuThaoCanBo;
}(_react2.default.Component);

KetQuaLapDuThaoCanBo.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaLapDuThaoCanBo);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _message = __webpack_require__(10);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _toastr = __webpack_require__(11);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var LapDuThaoCanBo = function (_React$Component) {
  _inherits(LapDuThaoCanBo, _React$Component);

  function LapDuThaoCanBo(props, context) {
    _classCallCheck(this, LapDuThaoCanBo);

    var _this = _possibleConstructorReturn(this, (LapDuThaoCanBo.__proto__ || Object.getPrototypeOf(LapDuThaoCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      open: false,
      onSave: false,
      loaiDon: _this.props.loaiDon,

      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',
      noiDungDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataCoQuanTheoDoi: [],

      hasChange: false,
      backConfirm: false,
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: ''
    };
    return _this;
  }

  _createClass(LapDuThaoCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/LapDuThaoCanBo');
      }
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          role: nextProps.role,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose(type) {
      if (type == true) {
        _reactRouter.browserHistory.goBack();
      } else if (this.state.hasChange) {
        this.setState({
          backConfirm: true
        });
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'hasChange',
    value: function hasChange() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this4 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this4.setState({
              dataGiaiQuyetDon: res.data,
              nextState: 'KET_THUC',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM,

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false,

              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',

              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : ''
            }, function () {
              _this4.renderAttachFile();
              _this4.checkFileCoQuanDieuTra();
            });
          }
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this5 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this5.state.giaoCoQuanDieuTra == false) {
          _this5.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this5.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this5.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this5.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this5.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.hasChange();
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.hasChange();
      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.setState({
          open: true,
          valueKetQua: e.target.value
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));

        if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi' || name == 'soLanGiaiQuyetLai' || name == 'ketQuaGiaiQuyetLan2') {}

        if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          this.setState({
            ketQuaGiaiQuyetLan2: ''
          });
        }

        if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.hasChange();
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({ ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && prevState.loaiDon != 'DON_KHIEU_NAI') {
        this.setState({
          ketQuaXLDGiaiQuyet: 'DA_CO_QUYET_DINH_GIAI_QUYET'
        });
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.hasChange();
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;

        if (this.props.loaiDon == 'DON_KHIEU_NAI') {
          params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

          if (Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
          } else {
            params.ketQuaGiaiQuyetLan2 = null;
          }

          if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
            params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
          } else {
            params.noiDungKetLuanGiaiQuyetLai = '';
          }
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }

      if (this.state.theoDoiThucHien) {
        params.theoDoiThucHien = true;
        params.hinhThucTheoDoi = this.state.hinhThucTheoDoi;
        if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
          params.coQuanTheoDoi = this.state.coQuanTheoDoi;
        } else {
          params.coQuanTheoDoi = null;
        }

        params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
        params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
        params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
        params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
        params.datDaTraCongDan = Number(this.state.datDaTraCongDan);

        params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
        params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
        params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
        params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

        params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac;
      } else {
        params.theoDoiThucHien = false;
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;

        params.ketQuaThucHienKhac = '';
      }

      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai;
      params.soVuGiaiQuyetKhieuNai = this.state.soVuGiaiQuyetKhieuNai;

      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
        if (this.state.doiThoai) {
          params.doiThoai = true;
          params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
          params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
          params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        } else {
          params.doiThoai = false;
          params.thoiGianDoiThoai = null;
          params.diaDiemDoiThoai = '';
          params.noiDungDoiThoai = '';
        }
      } else {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
      }

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this6 = this;

      this.setState({
        onSave: true
      }, function () {
        if (_this6.validateSubmitForm()) {
          _this6.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          var dataFileDinhKem = _this6.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this6.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            var dataFile = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this6.state.giaoCoQuanDieuTra) {
            var _dataFile = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile.map(function (item) {
              _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this6.state.dataTaiLieuVanThuDelete.length > 0) {
            _this6.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var params = _this6.getParams();

          _this6.postTaiLieuVanThu(_this6.state.taiLieuVanThu, function () {
            _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
              _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
                _this6.saveGiaiQuyetDon(params, 'gqdLuu');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this7 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this7.validateSubmitForm()) {
          _this7.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this7.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this7.state.taiLieuVanThuUpdate[_this7.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this7.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this7.state.taiLieuVanThu[_this7.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this7.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this7.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            var dataFile = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this7.state.giaoCoQuanDieuTra) {
            var _dataFile2 = [].concat(_toConsumableArray(_this7.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile2.map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this7.state.dataTaiLieuVanThuDelete.length > 0) {
            _this7.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this7.state.taiLieuVanThuDelete[_this7.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this7.getParams();
          var params = {};

          if (_this7.props.tuGiaiQuyet) {
            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this7.props.thongTinGiaiQuyetDonId)
              },
              actionType: 'GQD_NHAN_BAO_CAO_TTXM'
            };
          } else {
            var selectedState = _this7.props.dataNextStates.filter(function (state) {
              return state.type == _this7.state.nextState;
            });

            params = {
              thongTinGiaiQuyetDon: {
                id: Number(_this7.props.thongTinGiaiQuyetDonId)
              },
              nextState: {
                id: Number(selectedState[0].stateId)
              }
            };
          }
          _this7.postTaiLieuVanThu(_this7.state.taiLieuVanThu, function () {
            _this7.updateTaiLieuVanThu(_this7.state.taiLieuVanThuUpdate, function () {
              _this7.deleteTaiLieuVanThu(_this7.state.taiLieuVanThuDelete, function () {
                _this7.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this8.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this9.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this10 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this10.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.hasChange();
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.hasChange();
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      this.setState({
        openDialog: false
      });
      this.handleKetThuc();
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this11 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
        return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
      });

      var listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
        return _this11.compareDate(new Date(_this11.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
      });

      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var ketQuaGiaiQuyetDon = this.props.ketQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this12.state.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.backConfirm,
          onClose: this.closeConfirmBack.bind(this),
          onSuccess: this.onClickClose.bind(this, true),
          title: 'X\xE1c nh\u1EADn',
          content: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
              'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
              lb2
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 mb15 no-gutter' },
              _react2.default.createElement(_common.Text, { className: 'col-25', label: "Đơn vị " + lb1 + ":", value: this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon.ngayHetHanTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.loaiDon == 'DON_KHIEU_NAI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mt5' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb10' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'p',
                  { className: 'attach-file-description mb10 pl5 pr5' },
                  'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: !this.state.showTienDoGiaiQuyet },
                  _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { confirm: true, className: 'col-25', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet'),
                    loaiDon: this.props.loaiDon })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showTienDoGiaiQuyet },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: /*this.props.loaiDon == 'DON_TO_CAO'*/false },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { label: '\u0110\u1ED1i tho\u1EA1i', onChange: this.handleCheck.bind(this, 'doiThoai'), checked: this.state.doiThoai },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb15' },
                    '\u0110\u1ED1i tho\u1EA1i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                    _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', require: true, bindValidator: this, channel: 'formTaoDon', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_TO_CAO' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon == 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDon != 'DON_TO_CAO' && this.props.loaiDon != 'DON_KHIEU_NAI' },
                _react2.default.createElement(
                  'h3',
                  { className: 'txt-upper title-14 mt0 mb15' },
                  'V\u0103n b\u1EA3n gi\u1EA3i quy\u1EBFt ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Input, { triggeOnBlur: true, name: 'inputSoVanBan', className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', name: 'inputNgayBanHanh', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh') }),
                _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.allowAttach },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt10 pb20' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              _utils.ShowIfCheck,
              { label: 'Theo d\xF5i th\u1EF1c hi\u1EC7n', onChange: this.handleCheck.bind(this, 'theoDoiThucHien'), checked: this.state.theoDoiThucHien, name: 'checkboxTheoDoiThucHien' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, selectedValue: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), data: this.state.dataCoQuanTheoDoi, keyName: 'giaTri', valueName: 'ten' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb20' },
                  _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                  _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac') })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mb20' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc'), name: 'tienPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc'), name: 'datPhaiThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc'), name: 'tienDaThuTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc'), name: 'datDaThuTheoDoiThucHien' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan'), name: 'tienPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan'), name: 'datPhaiTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan'), name: 'tienDaTraTheoDoiThucHien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan'), name: 'datDaTraTheoDoiThucHien' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter pt5 pb15' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              _utils.ShowIfCheck,
              { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 pt15' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Kh\u1EDFi t\u1ED1'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.allowAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, bindValidator: this, data: this.state.listTaiLieuVanThuGiaiQuyetDon, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' })
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              'Ch\u1ECDn "\u0110\xE3 c\xF3 quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return LapDuThaoCanBo;
}(_react2.default.Component);

LapDuThaoCanBo.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LapDuThaoCanBo);

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _ttForms = __webpack_require__(19);

var _message = __webpack_require__(10);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _toastr = __webpack_require__(11);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'GIAI_QUYET_DON';

var LapDuThaoDonKhieuNaiCanBo = function (_React$Component) {
  _inherits(LapDuThaoDonKhieuNaiCanBo, _React$Component);

  function LapDuThaoDonKhieuNaiCanBo(props, context) {
    _classCallCheck(this, LapDuThaoDonKhieuNaiCanBo);

    var _this = _possibleConstructorReturn(this, (LapDuThaoDonKhieuNaiCanBo.__proto__ || Object.getPrototypeOf(LapDuThaoDonKhieuNaiCanBo)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      open: false,
      onSave: false,
      loaiDon: _this.props.loaiDon,

      valueKetQua: '',

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuGiaoCoQuanDieuTra: [],
      nextState: 'KET_THUC',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataDonViTheoDoi: [],
      dataKetQuaGiaiQuyetDon: [],
      dataCoQuanTheoDoi: [],

      hasChange: false,
      backConfirm: false,
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: ''
    };
    return _this;
  }

  _createClass(LapDuThaoDonKhieuNaiCanBo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.getDonViTheoDoi();
      this.getCoQuanTheoDoiEnumn();
      if (this.props.nhanDuThao == true) {
        this.getKetQuaGiaiQuyetDon();
      }
      if (window.debug) {
        console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/LapDuThaoDonKhieuNaiCanBo');
      }
    }
  }, {
    key: 'getCoQuanTheoDoiEnumn',
    value: function getCoQuanTheoDoiEnumn() {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            dataCoQuanTheoDoi: res.data
          });
        }
      });
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this3 = this;

      var params = {
        khongCoDoiThoai: true,
        loaiDon: this.props.loaiDon
      };
      _api.GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataKetQuaGiaiQuyetDon: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViTheoDoi',
    value: function getDonViTheoDoi() {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getCoQuanTheoDoi.request().then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dataDonViTheoDoi: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          role: nextProps.role,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose(type) {
      if (type == true) {
        _reactRouter.browserHistory.goBack();
      } else if (this.state.hasChange) {
        this.setState({
          backConfirm: true
        });
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'hasChange',
    value: function hasChange() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this5 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this5.setState({
              dataGiaiQuyetDon: res.data,
              nextState: 'KET_THUC',

              ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : res.data.ketLuanNoiDungKhieuNaiGiaoTTXM,

              doiThoai: res.data.doiThoai,
              thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
              diaDiemDoiThoai: res.data.diaDiemDoiThoai,

              coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
              soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
              soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

              tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
              datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
              tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
              datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
              tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
              soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

              hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
              coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
              ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

              khoiTo: res.data.khoiTo,
              soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
              soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

              tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
              datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
              tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
              datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

              giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
              quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
              theoDoiThucHien: res.data.theoDoiThucHien,

              soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
              ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
              nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

              tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
              tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
              datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
              datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
              soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

              soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
              ketQuaXLDGiaiQuyet: res.data.ketQuaXLDGiaiQuyet ? res.data.ketQuaXLDGiaiQuyet : '',
              showTienDoGiaiQuyet: res.data.ketQuaXLDGiaiQuyet && res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false,

              soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
              ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
              noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',

              ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
              ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
              noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
              noiDungGiaoLapDuThao: res.data.noiDungGiaoLapDuThao ? res.data.noiDungGiaoLapDuThao : ''
            }, function () {
              _this5.renderAttachFile();
              _this5.getNgayHetHanLapDuThao();
              _this5.checkFileCoQuanDieuTra();
            });
          }
        });
      }
    }
  }, {
    key: 'checkFileCoQuanDieuTra',
    value: function checkFileCoQuanDieuTra() {
      var _this6 = this;

      this.setState({
        allowAttachGiaoCoQuanDieuTra: false
      }, function () {
        if (_this6.state.giaoCoQuanDieuTra == false) {
          _this6.setState({
            allowAttachGiaoCoQuanDieuTra: true
          });
        } else {
          var taiLieuVanThuGiaoCoQuanDieuTra = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var data = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
          var dataCheck = data.filter(function (state) {
            return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA';
          });

          if (dataCheck.length > 0) {
            _this6.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
              allowAttachGiaoCoQuanDieuTra: true
            });
          } else {
            var newItem = {
              ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
              newFile: true
            };
            _this6.setState({
              taiLieuVanThuGiaoCoQuanDieuTra: [].concat(_toConsumableArray(taiLieuVanThuGiaoCoQuanDieuTra), [newItem]),
              allowAttachGiaoCoQuanDieuTra: true
            });
          }
        }
      });
    }
  }, {
    key: 'getNgayHetHanLapDuThao',
    value: function getNgayHetHanLapDuThao() {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.getNgayHetHanLapDuThao.request().then(function (res) {
        if (res.data) {
          _this7.setState({
            ngayHetHanGiaoLapDuThao: res.data
          });
        } else {
          _this7.setState({
            ngayHetHanGiaoLapDuThao: ''
          });
        }
      });
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this8 = this;

      this.setState({
        thoiGianDoiThoai: '',
        diaDiemDoiThoai: '',

        coQuanDieuTra: '',
        soVuGiaoCoQuanDieuTra: 0,
        soDoiTuongGiaoCoQuanDieuTra: 0,

        tienPhaiThuNhaNuoc: 0,
        datPhaiThuNhaNuoc: 0,
        tienPhaiTraCongDan: 0,
        datPhaiTraCongDan: 0,
        tongSoNguoiXuLyHanhChinh: 0,
        soNguoiDaBiXuLyHanhChinh: 0,

        hinhThucTheoDoi: '',
        coQuanTheoDoi: '',
        ketQuaThucHienTheoDoi: '',

        soVanBan: '',
        ngayBanHanh: '',
        nguoiBanHanh: '',

        khoiTo: false,
        soVuBiKhoiTo: 0,
        soDoiTuongBiKhoiTo: 0,

        tienDaThuNhaNuoc: 0,
        datDaThuNhaNuoc: 0,
        tienDaTraCongDan: 0,
        datDaTraCongDan: 0,

        giaoCoQuanDieuTra: false,
        quyetDinhGiaiQuyetKhieuNai: false,
        theoDoiThucHien: false,

        tienPhaiThuNhaNuocQDGQ: 0,
        tienPhaiTraCongDanQDGQ: 0,
        datPhaiThuNhaNuocQDGQ: 0,
        datPhaiTraCongDanQDGQ: 0,
        soNguoiDuocTraLaiQuyenLoi: 0,

        soVuGiaiQuyetKhieuNai: 0,

        soLanGiaiQuyetLai: 0,
        ketQuaGiaiQuyetLan2: '',
        noiDungKetLuanGiaiQuyetLai: '',

        ketQuaGiaiQuyetKhac: '',
        ketQuaThucHienKhac: '',
        noiDungDoiThoai: '',
        noiDungGiaoLapDuThao: ''
      }, function () {
        _this8.renderAttachFile();
        _this8.getNgayHetHanLapDuThao();
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.hasChange();
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this9 = this;

      this.hasChange();
      if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        this.setState({
          open: true,
          allowAttach: false,
          valueKetQua: e.target.value
        });
        this.resetData();
      } else {
        var _setState3;

        this.setState((_setState3 = {}, _defineProperty(_setState3, name, e.target.value), _defineProperty(_setState3, 'valueKetQua', ''), _setState3));

        if (name == 'ketQuaXLDGiaiQuyet') {
          this.resetData();
        }

        if (name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi' || name == 'soLanGiaiQuyetLai' || name == 'ketQuaGiaiQuyetLan2') {}

        if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
          this.setState({
            ketQuaGiaiQuyetLan2: ''
          });
        }

        if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
          this.setState({
            noiDungKetLuanGiaiQuyetLai: ''
          });
        }
      }
      if (name == 'ketQuaXLDGiaiQuyet') {
        this.setState({
          allowAttach: false
        }, function () {
          _this9.renderAttachFile();
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.hasChange();
      var dataFileDinhKem = _extends({}, this.state.dataFileDinhKem);
      if (type == 'QUYET_DINH_GIAI_QUYET') {
        dataFileDinhKem.quyetDinhGiaiQuyet = data;
        var fileQD = data.filter(function (item) {
          return item.typeRequired == 'QDGQ_LDT';
        });
        this.setState({ ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '' });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        dataFileDinhKem.giaoCoQuanDieuTra = data;
      } else if (type == 'GIA_HAN') {
        dataFileDinhKem.giaHan = data;
      } else {
        dataFileDinhKem.data = data;
      }
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.hasChange();
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'QUYET_DINH_GIAI_QUYET') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.quyetDinhGiaiQuyet = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaoCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);

      if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
        params.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
        params.nguoiBanHanh = this.state.nguoiBanHanh ? { id: this.state.nguoiBanHanh } : null;

        if (this.state.giaoCoQuanDieuTra) {
          params.giaoCoQuanDieuTra = true;
          if (this.state.coQuanDieuTra) {
            params.coQuanDieuTra = {
              id: Number(this.state.coQuanDieuTra)
            };
          }
          params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
          params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);

          if (this.state.khoiTo) {
            params.khoiTo = true;
            params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
            params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
          } else {
            params.khoiTo = false;
            params.soVuBiKhoiTo = 0;
            params.soDoiTuongBiKhoiTo = 0;
          }
        } else {
          params.giaoCoQuanDieuTra = false;
          params.coQuanDieuTra = null;
          params.soVuGiaoCoQuanDieuTra = 0;
          params.soDoiTuongGiaoCoQuanDieuTra = 0;

          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }

        if (this.state.theoDoiThucHien) {
          params.theoDoiThucHien = true;
          params.hinhThucTheoDoi = this.state.hinhThucTheoDoi;
          if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
            params.coQuanTheoDoi = this.state.coQuanTheoDoi;
          } else {
            params.coQuanTheoDoi = null;
          }

          params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi;
          params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
          params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
          params.tienDaThuNhaNuoc = Number(this.state.tienDaThuNhaNuoc);
          params.datDaThuNhaNuoc = Number(this.state.datDaThuNhaNuoc);
          params.tienDaTraCongDan = Number(this.state.tienDaTraCongDan);
          params.datDaTraCongDan = Number(this.state.datDaTraCongDan);

          params.tienPhaiThuNhaNuoc = Number(this.state.tienPhaiThuNhaNuoc);
          params.datPhaiThuNhaNuoc = Number(this.state.datPhaiThuNhaNuoc);
          params.tienPhaiTraCongDan = Number(this.state.tienPhaiTraCongDan);
          params.datPhaiTraCongDan = Number(this.state.datPhaiTraCongDan);

          params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac;
        } else {
          params.theoDoiThucHien = false;
          params.hinhThucTheoDoi = null;
          params.coQuanTheoDoi = null;
          params.ketQuaThucHienTheoDoi = null;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
          params.tienDaThuNhaNuoc = 0;
          params.datDaThuNhaNuoc = 0;
          params.tienDaTraCongDan = 0;
          params.datDaTraCongDan = 0;

          params.tienPhaiThuNhaNuoc = 0;
          params.datPhaiThuNhaNuoc = 0;
          params.tienPhaiTraCongDan = 0;
          params.datPhaiTraCongDan = 0;

          params.ketQuaThucHienKhac = '';
        }

        params.quyetDinhGiaiQuyetKhieuNai = true;
        params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

        params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

        if (Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
        } else {
          params.ketQuaGiaiQuyetLan2 = null;
        }

        if (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && Number(this.state.soLanGiaiQuyetLai) > 1) {
          params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
        } else {
          params.noiDungKetLuanGiaiQuyetLai = '';
        }

        params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
        params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
        params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
        params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

        params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
        params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
        params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
        params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
        params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.theoDoiThucHien = false;
        params.hinhThucTheoDoi = null;
        params.coQuanTheoDoi = null;
        params.ketQuaThucHienTheoDoi = null;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
        params.tienDaThuNhaNuoc = 0;
        params.datDaThuNhaNuoc = 0;
        params.tienDaTraCongDan = 0;
        params.datDaTraCongDan = 0;

        params.tienPhaiThuNhaNuoc = 0;
        params.datPhaiThuNhaNuoc = 0;
        params.tienPhaiTraCongDan = 0;
        params.datPhaiTraCongDan = 0;

        params.ketQuaThucHienKhac = '';

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;

        params.quyetDinhGiaiQuyetKhieuNai = false;

        params.soLanGiaiQuyetLai = 0;
        params.ketQuaGiaiQuyetKhac = '';

        params.ketQuaGiaiQuyetLan2 = null;
        params.noiDungKetLuanGiaiQuyetLai = '';

        params.tienPhaiThuNhaNuocQDGQ = 0;
        params.tienPhaiTraCongDanQDGQ = 0;
        params.datPhaiThuNhaNuocQDGQ = 0;
        params.datPhaiTraCongDanQDGQ = 0;

        params.soVuGiaiQuyetKhieuNai = 0;
        params.ketLuanNoiDungKhieuNai = null;
        params.tongSoNguoiXuLyHanhChinh = 0;
        params.soNguoiDaBiXuLyHanhChinh = 0;

        params.soNguoiDuocTraLaiQuyenLoi = 0;
      }

      params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : null;

      if (this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI') {
        params.doiThoai = true;
        params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? (0, _moment2.default)(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
        params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
        params.noiDungDoiThoai = this.state.noiDungDoiThoai;
        params.noiDungGiaoLapDuThao = this.state.noiDungGiaoLapDuThao;
        params.ngayHetHanGiaoLapDuThao = this.state.ngayHetHanGiaoLapDuThao;
      } else if (this.props.nhanDuThao != true) {
        params.doiThoai = false;
        params.thoiGianDoiThoai = null;
        params.diaDiemDoiThoai = '';
        params.noiDungDoiThoai = '';
        params.noiDungGiaoLapDuThao = '';
        params.ngayHetHanGiaoLapDuThao = null;
      }

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this10 = this;

      this.setState({
        onSave: true
      }, function () {
        if (_this10.validateSubmitForm()) {
          _this10.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          var dataFileDinhKem = _this10.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this10.state.taiLieuVanThuUpdate[_this10.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this10.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this10.state.taiLieuVanThu[_this10.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this10.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this10.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            var dataFile = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this10.state.taiLieuVanThuDelete[_this10.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this10.state.giaoCoQuanDieuTra) {
            var _dataFile = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile.map(function (item) {
              _this10.state.taiLieuVanThuDelete[_this10.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this10.state.dataTaiLieuVanThuDelete.length > 0) {
            _this10.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this10.state.taiLieuVanThuDelete[_this10.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var params = _this10.getParams();
          _this10.postTaiLieuVanThu(_this10.state.taiLieuVanThu, function () {
            _this10.updateTaiLieuVanThu(_this10.state.taiLieuVanThuUpdate, function () {
              _this10.deleteTaiLieuVanThu(_this10.state.taiLieuVanThuDelete, function () {
                _this10.saveGiaiQuyetDon(params, 'gqdLuu');
              });
            });
          });
        }
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc(type) {
      var _this11 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this11.validateSubmitForm()) {
          _this11.setState({
            btnLoading: true
          });
          var dataFileDinhKem = _this11.getListDataFileDinhKem();

          if (dataFileDinhKem.length > 0) {
            dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this11.state.taiLieuVanThuUpdate[_this11.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this11.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this11.state.taiLieuVanThu[_this11.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this11.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });
          }

          if (_this11.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            var dataFile = [].concat(_toConsumableArray(_this11.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ));
            dataFile.map(function (item) {
              _this11.state.taiLieuVanThuDelete[_this11.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (!_this11.state.giaoCoQuanDieuTra) {
            var _dataFile2 = [].concat(_toConsumableArray(_this11.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra));
            _dataFile2.map(function (item) {
              _this11.state.taiLieuVanThuDelete[_this11.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          if (_this11.state.dataTaiLieuVanThuDelete.length > 0) {
            _this11.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this11.state.taiLieuVanThuDelete[_this11.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          var _params = _this11.getParams();
          var params = {};
          var msgName = '';

          if (_this11.props.tuGiaiQuyet == true) {
            if (_this11.props.nhanDuThao == true) {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this11.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'GQD_NHAN_DU_THAO'
              };
              msgName = 'gqdLuuHoSo';
            } else {
              if (type == 'luuHoSo') {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this11.props.thongTinGiaiQuyetDonId)
                  },
                  actionType: 'GQD_NHAN_BAO_CAO_TTXM'
                };
                msgName = 'gqdLuuHoSo';
                _this11.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
              } else {
                params = {
                  thongTinGiaiQuyetDon: {
                    id: Number(_this11.props.thongTinGiaiQuyetDonId)
                  },
                  actionType: 'GQD_NHAN_BAO_CAO_TTXM_GUI_DU_THAO'
                };
                msgName = 'gqdGuiDuThao';
              }
            }
          } else {
            if (type == 'luuHoSo') {
              var selectedState = _this11.props.dataNextStates.filter(function (state) {
                return state.type == 'KET_THUC';
              });

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this11.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                }
              };
              msgName = 'gqdLuuHoSo';
            } else {
              var _selectedState = _this11.props.dataNextStates.filter(function (state) {
                return state.type == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO';
              });

              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this11.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(_selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this11.state.noiDungGiaoLapDuThao ? _this11.state.noiDungGiaoLapDuThao : ''
              };
              msgName = 'gqdGuiDuThao';
            }
          }
          _this11.postTaiLieuVanThu(_this11.state.taiLieuVanThu, function () {
            _this11.updateTaiLieuVanThu(_this11.state.taiLieuVanThuUpdate, function () {
              _this11.deleteTaiLieuVanThu(_this11.state.taiLieuVanThuDelete, function () {
                _this11.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        }
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this12 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this12.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this13 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this13.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this14 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this14.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.quyetDinhGiaiQuyet.length > 0 && this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
        Data.quyetDinhGiaiQuyet.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
        Data.giaoCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0 && this.state.giaHanGiaiQuyet) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.hasChange();
      this.setState(_defineProperty({}, name, e));
      if (name == 'giaoCoQuanDieuTra') {
        this.checkFileCoQuanDieuTra();
      }
      if (!e) {}
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.hasChange();
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'openDialog',
    value: function openDialog(type) {
      if (this.validateSubmitForm()) {
        if (type == 'luuHoSo') {
          this.setState({
            openDialogLuuHoSo: true
          });
        } else {
          this.setState({
            openDialogGiaoDoiThoai: true
          });
        }
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(type) {
      if (type == 'luuHoSo') {
        this.setState({
          openDialogLuuHoSo: false
        });
      } else {
        this.setState({
          openDialogGiaoDoiThoai: false
        });
      }
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(type) {
      if (type == 'luuHoSo') {
        this.setState({
          openDialogLuuHoSo: false
        });
        this.handleKetThuc('luuHoSo');
      } else {
        this.setState({
          openDialogGiaoDoiThoai: false
        });
        this.handleKetThuc('giaoDoiThoai');
      }
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      var _this15 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.ketQuaXLDGiaiQuyet
      }, function () {
        _this15.renderAttachFile();
      });
    }
  }, {
    key: 'onSuccessDialogConfirm',
    value: function onSuccessDialogConfirm() {
      var _this16 = this;

      this.setState({
        open: false,
        ketQuaXLDGiaiQuyet: this.state.valueKetQua
      }, function () {
        _this16.renderAttachFile();
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this17 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.props.listTaiLieuVanThuGiaiQuyetDon));

      var listTaiLieuVanThuGiaiQuyetDon = [];

      var listTaiLieuVanThuGiaiQuyetDonView = [];

      if (this.props.nhanDuThao == true) {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this17.compareDate(new Date(state.ngayTao), new Date(_this17.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this17.compareDate(new Date(_this17.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), new Date(state.ngayTao), 'show');
        });
      } else {
        listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(function (state) {
          return _this17.compareDate(new Date(state.ngayTao), new Date(_this17.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
        });

        listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(function (state) {
          return _this17.compareDate(new Date(_this17.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
        });
      }

      if (this.props.nhanDuThao != true) {
        if (this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET') {
          var data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
          var dataCheck = data.filter(function (item) {
            return item.required && item.typeRequired == 'BB_DOI_THOAI';
          });
          if (dataCheck.length > 0) {
            //Do nothing
          } else {
            listTaiLieuVanThuGiaiQuyetDon[listTaiLieuVanThuGiaiQuyetDon.length] = {
              ten: 'Biên bản đối thoại',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'BB_DOI_THOAI',
              newFile: true
            };
          }
          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            allowAttach: true
          });
        } else {
          this.setState({
            allowAttach: false
          });
          var _data = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));
          var dataForFillter = [].concat(_toConsumableArray(listTaiLieuVanThuGiaiQuyetDon));

          var dataFillter = dataForFillter.filter(function (item) {
            return item.typeRequired != 'BB_DOI_THOAI';
          });

          var _dataCheck = _data.filter(function (item) {
            return item.taiLieuVanThuId && item.typeRequired == 'BB_DOI_THOAI';
          });
          if (_dataCheck.length > 0) {
            _dataCheck.map(function (item) {
              _this17.state.taiLieuVanThuDelete[_this17.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          this.setState({
            listTaiLieuVanThuGiaiQuyetDon: dataFillter,
            listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
            allowAttach: true
          });
        }
      } else {
        this.setState({
          listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
          listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
          allowAttach: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this18 = this;

      var ketQuaGiaiQuyetDon = this.props.ketQuaGiaiQuyetDon.filter(function (state) {
        return state.giaTri == _this18.state.ketQuaXLDGiaiQuyet;
      });
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.backConfirm,
          onClose: this.closeConfirmBack.bind(this),
          onSuccess: this.onClickClose.bind(this, true),
          title: 'X\xE1c nh\u1EADn',
          content: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'h3',
              { className: 'txt-upper title-14 mt0 mb15 pl5 pr5' },
              'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
              lb2
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 mb15 no-gutter' },
              _react2.default.createElement(_common.Text, { className: 'col-25', label: "Đơn vị " + lb1 + ":", value: this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon.ngayHetHanTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanTTXM).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'text-12 txt-upper txt-bold mb10 mt0' },
                    'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                  )
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.nhanDuThao == true },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      '\u0110\u1ED1i tho\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-75 mb10', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : '' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', red: true, value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : '', name: 'noiDungGiaoLapDuThao' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pt5 pb15' },
                  _react2.default.createElement('span', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb10' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      ' D\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y tr\xECnh d\u1EF1 th\u1EA3o:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao ? (0, _moment2.default)(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb0-18', label: 'T\xF3m t\u1EAFt n\u1ED9i dung k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i:', value: this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao ? this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao : '' })
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-big-line pt5 pb20' },
            _react2.default.createElement('span', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mb10' },
              'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt'
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'p',
                { className: 'attach-file-description mb10 pl5 pr5' },
                'Ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt cho bi\u1EBFt giai \u0111o\u1EA1n gi\u1EA3i quy\u1EBFt hi\u1EC7n t\u1EA1i c\u1EE7a \u0111\u01A1n'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true },
                _react2.default.createElement(_ttForms.DropDownKetQuaGiaiQuyetDon, { confirm: true, className: 'col-25', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet'), loaiDon: this.props.loaiDon })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.showTienDoGiaiQuyet && this.props.nhanDuThao == true },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { confirm: true, label: '', className: 'col-25', data: this.state.dataKetQuaGiaiQuyetDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ketQuaXLDGiaiQuyet, onChange: this.onChange.bind(this, 'ketQuaXLDGiaiQuyet') })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showTienDoGiaiQuyet },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '', value: ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : '' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  '\u0110\u1ED1i tho\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.DatePicker, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Th\u1EDDi gian \u0111\u1ED1i tho\u1EA1i', value: this.state.thoiGianDoiThoai, onChange: this.handleChangeDate.bind(this, 'thoiGianDoiThoai'), name: 'datepickerThoiGianDoiThoai' }),
                  _react2.default.createElement(_common.Input, { className: 'col-75', require: true, bindValidator: this, channel: 'formTaoDon', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemDoiThoai, onChange: this.onChange.bind(this, 'diaDiemDoiThoai'), name: 'inputDiaDiem' }),
                  _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', require: true, bindValidator: this, channel: 'formTaoDon', label: 'N\u1ED9i dung, k\u1EBFt qu\u1EA3 \u0111\u1ED1i tho\u1EA1i', value: this.state.noiDungDoiThoai, onChange: this.onChange.bind(this, 'noiDungDoiThoai') })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5 pb15' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5 pb20' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb15' },
                  'Giao d\u1EF1 th\u1EA3o quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian tr\xECnh d\u1EF1 th\u1EA3o:', value: this.state.ngayHetHanGiaoLapDuThao ? (0, _moment2.default)(this.state.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : '', red: true }),
                  _react2.default.createElement(_common.TextArea, { className: 'col-100 mb0-18', label: '\xDD ki\u1EBFn x\u1EED l\xFD', value: this.state.noiDungGiaoLapDuThao, onChange: this.onChange.bind(this, 'noiDungGiaoLapDuThao') })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                { className: 'txt-upper title-14 mt0 mb15' },
                'Quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Input, { triggeOnBlur: true, name: 'inputSoVanBan', className: 'col-25', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, channel: 'formTaoDon', require: true, value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Ng\xE0y ban h\xE0nh', bindValidator: this, endDate: new Date(), channel: 'formTaoDon', require: true, value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), name: 'inputNgayBanHanh' }),
                _react2.default.createElement(_ttForms.DropDownNguoiKy, { selected: this.state.nguoiBanHanh, onChange: this.onChange.bind(this, 'nguoiBanHanh') }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.allowAttach },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 pt15' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'QDGQ_LDT', ngayQuyetDinhSuggest: this.state.ngayBanHanh, soVanBanSuggest: this.state.soVanBan, onSave: this.state.onSave, loaiDon: this.state.loaiDon, phanLoaiQuyTrinh: 'QUYET_DINH_GIAI_QUYET', qDGQText: 'QDGQ_LDT', qDGQRequired: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt10 pb20' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaiQuyetKhieuNai), onChange: this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai'), name: 'soVuDonToCao' }),
                _react2.default.createElement(_ttForms.DropDownChonKetLuanNoiDungKhieuNai, { require: true, bindValidator: this, channel: 'formTaoDon', loaiDon: this.state.loaiDon, label: 'K\u1EBFt lu\u1EADn n\u1ED9i dung khi\u1EBFu n\u1EA1i', className: 'col-25', selectedValue: this.state.ketLuanNoiDungKhieuNai, onChange: this.onChange.bind(this, 'ketLuanNoiDungKhieuNai') }),
                _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 kh\xE1c', name: 'ketQuaKhac', value: this.state.ketQuaGiaiQuyetKhac, onChange: this.onChange.bind(this, 'ketQuaGiaiQuyetKhac') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10 mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ'), name: 'tienPhaiThuDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuocQDGQ, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ'), name: 'datPhaiThuDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter mb20' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                  ),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ'), name: 'tienPhaiTraDonToCao' }),
                  _react2.default.createElement(_common.Input, { className: 'col-50 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDanQDGQ, onChange: this.onChange.bind(this, 'datPhaiTraCongDanQDGQ'), name: 'datPhaiTraDonToCao' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                    'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'T\u1ED5ng s\u1ED1 ng\u01B0\u1EDDi', value: Number(this.state.tongSoNguoiXuLyHanhChinh), onChange: this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh'), name: 'tongSoNguoiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\xE3 b\u1ECB x\u1EED l\xFD', value: Number(this.state.soNguoiDaBiXuLyHanhChinh), onChange: this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh'), name: 'soNguoiDaBiXuLyDonToCao' }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c tr\u1EA3 l\u1EA1i quy\u1EC1n l\u1EE3i', value: this.state.soNguoiDuocTraLaiQuyenLoi, onChange: this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi'), name: 'inputnumberSoNguoiTraQuyenLoi' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Theo d\xF5i th\u1EF1c hi\u1EC7n', onChange: this.handleCheck.bind(this, 'theoDoiThucHien'), checked: this.state.theoDoiThucHien, name: 'checkboxTheoDoiThucHien' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Theo d\xF5i th\u1EF1c hi\u1EC7n'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb20' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI' },
                        _react2.default.createElement(_common.DropDownTreeSelectOneElement, { className: 'col-25 mb0-18', label: 'C\u01A1 quan theo d\xF5i', bindValidator: this, channel: 'formTaoDon', require: true, dataOptions: this.state.dataDonViTheoDoi, value: this.state.coQuanTheoDoi, onChange: this.onChange.bind(this, 'coQuanTheoDoi'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb20' },
                      _react2.default.createElement(_ttForms.DropDownChonKetQuaThucHien, { className: 'col-25 mb0-18', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.ketQuaThucHienTheoDoi, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoi') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n kh\xE1c', value: this.state.ketQuaThucHienKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mb20' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Thu h\u1ED3i cho nh\xE0 n\u01B0\u1EDBc'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'tienPhaiThuNhaNuoc'), name: 'tienPhaiThuTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datPhaiThuNhaNuoc, onChange: this.onChange.bind(this, 'datPhaiThuNhaNuoc'), name: 'datPhaiThuTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu ti\u1EC1n (\u0111)', value: this.state.tienDaThuNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuNhaNuoc'), name: 'tienDaThuTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 thu \u0111\u1EA5t (m2)', value: this.state.datDaThuNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuNhaNuoc'), name: 'datDaThuTheoDoiThucHien' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Tr\u1EA3 l\u1EA1i cho c\xF4ng d\xE2n'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienPhaiTraCongDan, onChange: this.onChange.bind(this, 'tienPhaiTraCongDan'), name: 'tienPhaiTraTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datPhaiTraCongDan, onChange: this.onChange.bind(this, 'datPhaiTraCongDan'), name: 'datPhaiTraTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienDaTraCongDan, onChange: this.onChange.bind(this, 'tienDaTraCongDan'), name: 'tienDaTraTheoDoiThucHien' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25 mb0-18', type: 'sdt', align: 'right', label: '\u0110\xE3 tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datDaTraCongDan, onChange: this.onChange.bind(this, 'datDaTraCongDan'), name: 'datDaTraTheoDoiThucHien' })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)', onChange: this.handleCheck.bind(this, 'giaoCoQuanDieuTra'), checked: this.state.giaoCoQuanDieuTra },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5 pb5' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb15' },
                      'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra(N\u1EBFu c\xF3)'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_ttForms.DropDownChonCoQuanDieuTra, { className: 'col-25 mb0-18', label: 'T\xEAn c\u01A1 quan', isValid: this.state.isValid, bindValidator: this, require: true, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 v\u1EE5', value: Number(this.state.soVuGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: Number(this.state.soDoiTuongGiaoCoQuanDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra'), maxLength: 255 }),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: this.state.allowAttachGiaoCoQuanDieuTra },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-100 pt15' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, phanLoaiQuyTrinh: 'GIAO_CO_QUAN_DIEU_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.taiLieuVanThuGiaoCoQuanDieuTra, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter pt5 pb15' },
                    _react2.default.createElement('span', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      _utils.ShowIfCheck,
                      { label: 'Kh\u1EDFi t\u1ED1', onChange: this.handleCheck.bind(this, 'khoiTo'), checked: this.state.khoiTo },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter mt5 pb20' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'title-12 mb15' },
                          'Kh\u1EDFi t\u1ED1'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'row pl10 pr10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-50 no-gutter' },
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 v\u1EE5', value: this.state.soVuBiKhoiTo, onChange: this.onChange.bind(this, 'soVuBiKhoiTo') }),
                            _react2.default.createElement(_common.InputNumber, { className: 'col-50 mb0-18', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', value: this.state.soDoiTuongBiKhoiTo, onChange: this.onChange.bind(this, 'soDoiTuongBiKhoiTo'), maxLength: 255 })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.allowAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, bindValidator: this, data: this.state.listTaiLieuVanThuGiaiQuyetDon, dataShow: this.state.listTaiLieuVanThuGiaiQuyetDonView, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'luuHoSo') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.ketQuaXLDGiaiQuyet == 'DOI_THOAI' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this, 'giaoDoiThoai') },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Chuy\u1EC3n \u0111\u01A1n v\u1ECB ',
                    lb1
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogLuuHoSo, onClose: this.closeDialog.bind(this, 'luuHoSo'), onSuccess: this.onSuccess.bind(this, 'luuHoSo'), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogGiaoDoiThoai, onClose: this.closeDialog.bind(this, 'giaoDoiThoai'), onSuccess: this.onSuccess.bind(this, 'giaoDoiThoai'), title: 'X\xE1c nh\u1EADn', content: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '') + ' lập dự thảo không?' })
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.open,
            onClose: this.closeDialogConfirm.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              'Ch\u1ECDn "\u0110\xE3 c\xF3 quy\u1EBFt \u0111\u1ECBnh gi\u1EA3i quy\u1EBFt" s\u1EBD k\u1EBFt th\xFAc qu\xE1 tr\xECnh gi\u1EA3i quy\u1EBFt \u0111\u01A1n v\xE0 b\u1EA1n kh\xF4ng thao t\xE1c \u0111\u01B0\u1EE3c v\u1EDBi tr\u01B0\u1EDDng ti\u1EBFn \u0111\u1ED9 gi\u1EA3i quy\u1EBFt n\u1EEFa. B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD?'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.onSuccessDialogConfirm.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return LapDuThaoDonKhieuNaiCanBo;
}(_react2.default.Component);

LapDuThaoDonKhieuNaiCanBo.defaultProps = {
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LapDuThaoDonKhieuNaiCanBo);

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _subView = __webpack_require__(33);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _message = __webpack_require__(10);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _toastr = __webpack_require__(11);

var _ConfirmDialog = __webpack_require__(167);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _GetParams = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
var buocGiaiQuyet = null;

var NhapThongTinToTTXM = function (_React$Component) {
  _inherits(NhapThongTinToTTXM, _React$Component);

  function NhapThongTinToTTXM(props, context) {
    _classCallCheck(this, NhapThongTinToTTXM);

    var _this = _possibleConstructorReturn(this, (NhapThongTinToTTXM.__proto__ || Object.getPrototypeOf(NhapThongTinToTTXM)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      loaiDon: _this.props.loaiDon,
      isValid: false,
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTraDon: false,
      onSave: false,

      lapToDoanXacMinh: false,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      nextState: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      soQuyetDinhThanhLapDTXM: '',
      truongDoanTTXM: '',

      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',

      ngayHetHanSauKhiGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',
      lyDoQuaHan: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',

      donViId: '',
      giaHanTTXM: false,
      giaHanGiaiQuyet: false,

      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      showAttach: false,
      dataNextStatesTXL: [],
      hasChange: false,
      backConfirm: false,
      dataNextState: []
    };
    return _this;
  }

  _createClass(NhapThongTinToTTXM, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.initHuongXuLyData(this.props.dataNextStates, 'dataNextState');
      if (this.props.tuGiaiQuyet == true && !this.props.donInfo.laTTXMLai) {
        this.initHuongXuLyData(this.props.dataNextStatesTXL, 'dataNextStatesTXL');
      }
    }
  }, {
    key: 'initHuongXuLyData',
    value: function initHuongXuLyData(inputData, name) {
      var ttxmText = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var ttxmText1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ttxmText + ' và dự thảo văn bản GQ' : ttxmText;
      var outputData = [].concat(_toConsumableArray(inputData));
      outputData = outputData.map(function (item) {
        if (item.type == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          return item = _extends({}, item, {
            tenVietTat: 'Gửi báo cáo ' + ttxmText1,
            ten: 'Gửi báo cáo ' + ttxmText1
          });
        }
        if (item.type == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
          return item = _extends({}, item, {
            tenVietTat: 'Trả đơn do chuyển ' + ttxmText + ' không đúng',
            ten: 'Trả đơn do chuyển ' + ttxmText + ' không đúng'
          });
        }
        return item;
      });
      this.setState(_defineProperty({}, name, outputData));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.thongTinGiaiQuyetDonId != nextProps.thongTinGiaiQuyetDonId && nextProps.thongTinGiaiQuyetDonId) {
        this.setState({
          id: nextProps.id,
          thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
        });
        this.getThongTinGiaiQuyetDon(nextProps.thongTinGiaiQuyetDonId);
      }
      if (nextProps.dataNextStates != this.props.dataNextStates) {
        this.initHuongXuLyData(nextProps.dataNextStates, 'dataNextState');
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this2 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            var _noiDung = res.data.noiDung || '';
            if (_this2.props.donInfo && _this2.props.donInfo.laTTXMLai) {
              _noiDung = res.data.noiDungTraBaoCaoTTXMLan2 || '';
            }
            _this2.setState({
              dataGiaiQuyetDon: res.data,

              lapToDoanXacMinh: res.data.lapToDoanXacMinh,
              soQuyetDinhThanhLapDTXM: res.data.soQuyetDinhThanhLapDTXM,
              truongDoanTTXM: res.data.truongDoanTTXMInfo ? res.data.truongDoanTTXMInfo.congChucId : '',

              ketLuanNoiDungKhieuNaiGiaoTTXM: res.data.ketLuanNoiDungKhieuNaiGiaoTTXM ? res.data.ketLuanNoiDungKhieuNaiGiaoTTXM : '',

              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
              noiDung: _noiDung,

              giaHanTTXM: res.data.giaHanTTXM,
              giaHanGiaiQuyet: res.data.giaHanGiaiQuyet,

              nextState: res.data.nextStateInfo ? res.data.nextStateInfo.type : 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',

              ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM,
              lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM,
              ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet,
              lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet
            }, function () {
              if (_this2.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
                _this2.checkFileRequired();
              }
              if (_this2.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
                _this2.filterFileRequired();
              }
            });
          }
        });
      }
    }
  }, {
    key: 'filterFileRequired',
    value: function filterFileRequired() {
      var _this3 = this;

      var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this3.state.donViId;
      });

      var dataFilter = ListTaiLieuVanThuShow.filter(function (state) {
        return state.typeRequired != 'BC_KQTTXM';
      });
      var dataFilter2 = this.state.ListTaiLieuVanThu.filter(function (state) {
        return state.typeRequired != 'BC_KQTTXM' && state.typeRequired != 'KQTTXM_DTVBGQ';
      });

      this.setState({
        ListTaiLieuVanThuShow: dataFilter,
        ListTaiLieuVanThu: dataFilter2,
        showAttach: true
      });
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this4 = this;

      var data = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM.filter(function (state) {
        return state.nguoiTaoInfo.donViId == _this4.state.donViId;
      });

      var dataShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(function (state) {
        return state.nguoiTaoInfo.donViId != _this4.state.donViId;
      });

      if (this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO' || this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
        var isTTXML = this.props.donInfo && this.props.donInfo.laTTXMLai ? true : false;
        if (isTTXML == true) {
          dataShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView.filter(function (item) {
            return item.typeRequired != 'BC_KQTTXM_L';
          });
          data = data.filter(function (item) {
            return item.typeRequired != 'BC_KQTTXM' && item.typeRequired != 'KQTTXM_DTVBGQ';
          });
        }
        var checkKQTTXM = data.filter(function (item) {
          if (isTTXML == true) return item.typeRequired == 'BC_KQTTXM_L';else return item.typeRequired == 'BC_KQTTXM';
        });
        if (checkKQTTXM.length == 0) {
          var itemKQTTXM = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: isTTXML == true ? 'BC_KQTTXM_L' : 'BC_KQTTXM',
            newFile: true
          };
          if (this.props.loaiDon == 'DON_TO_CAO') {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo' + (isTTXML == true ? ' (Lần 2)' : '');
          } else if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
            itemKQTTXM.ten = 'Văn bản xác minh đề xuất' + (isTTXML == true ? ' (Lần 2)' : '');
          } else {
            itemKQTTXM.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại' + (isTTXML == true ? ' (Lần 2)' : '');
          }
          data = [].concat(_toConsumableArray(data), [itemKQTTXM]);
        }

        if ((this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' || this.props.loaiDon == 'DON_TO_CAO') && this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
          var checkDTVBGQ = data.filter(function (item) {
            if (isTTXML == true) return item.typeRequired == 'KQTTXM_DTVBGQ_L';else return item.typeRequired == 'KQTTXM_DTVBGQ';
          });
          if (checkDTVBGQ.length == 0) {
            var itemDTVBGQ = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              ten: this.props.loaiDon == 'DON_TO_CAO' ? 'Dự thảo kết luận nội dung tố cáo' : 'Dự thảo văn bản giải quyết',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: isTTXML == true ? 'KQTTXM_DTVBGQ_L' : 'KQTTXM_DTVBGQ',
              newFile: true
            };
            data = [].concat(_toConsumableArray(data), [itemDTVBGQ]);
          }
        }
      }
      this.setState({
        ListTaiLieuVanThu: data,
        ListTaiLieuVanThuShow: dataShow,
        showAttach: true
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose(type) {
      if (type == true) {
        _reactRouter.browserHistory.push('/xu-ly-don');
      } else if (this.state.hasChange) {
        this.setState({
          backConfirm: true
        });
      } else {
        _reactRouter.browserHistory.push('/xu-ly-don');
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'hasChange',
    value: function hasChange() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      this.setState({
        onSave: true
      }, function () {
        if (true) {
          _this5.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          var dataFileDelete = [];
          if (_this5.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            _this5.state.dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this5.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this5.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (_this5.state.dataTaiLieuVanThuDelete.length > 0) {
              _this5.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          } else {
            var data = [].concat(_toConsumableArray(_this5.props.listTaiLieuVanThuGiaiQuyetDon));
            data.filter(function (state) {
              return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
            }).map(function (item) {
              dataFileDelete[dataFileDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          var params = _this5.getParams();
          if (_this5.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            _this5.postTaiLieuVanThu(_this5.state.taiLieuVanThu, function () {
              _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
                _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
                  _this5.saveGiaiQuyetDon(params, 'gqdLuu');
                });
              });
            });
          } else {
            _this5.deleteTaiLieuVanThu(dataFileDelete, function () {
              _this5.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          }
        }
      });
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this6 = this;

      this.setState({
        onSave: false
      }, function () {
        if (_this6.validateSubmitForm()) {
          _this6.setState({
            btnLoading: true
          });
          var dataFileDelete = [];
          if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            _this6.state.dataFileDinhKem.map(function (item, i) {
              if (item.taiLieuVanThuId) {
                _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  id: item.taiLieuVanThuId,
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: item.loaiTepDinhKem,
                  loaiQuyTrinh: item.loaiQuyTrinh,
                  buocGiaiQuyet: item.buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              } else {
                _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
                  don: {
                    id: Number(_this6.state.id)
                  },
                  ten: item.ten,
                  soQuyetDinh: item.soQuyetDinh,
                  ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                  tenFile: item.tenFile,
                  duongDan: item.duongDan,
                  loaiTepDinhKem: loaiTepDinhKem,
                  loaiQuyTrinh: loaiQuyTrinh,
                  buocGiaiQuyet: buocGiaiQuyet,
                  required: item.required,
                  typeRequired: item.typeRequired ? item.typeRequired : ''
                };
              }
            });

            if (_this6.state.dataTaiLieuVanThuDelete.length > 0) {
              _this6.state.dataTaiLieuVanThuDelete.map(function (item) {
                _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                  id: item
                };
              });
            }
          } else {
            var data = [].concat(_toConsumableArray(_this6.props.listTaiLieuVanThuGiaiQuyetDon));
            data.filter(function (state) {
              return state.required && state.typeRequired == 'BC_KQTTXM_GQKN';
            }).map(function (item) {
              dataFileDelete[dataFileDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }

          var _params = _this6.getParams();
          var params = {};
          var msgName = '';

          if (_this6.props.tuGiaiQuyet) {
            if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'TTXM_GUI_DON_VI_GIAI_QUYET',
                yKienGiaiQuyet: _this6.state.noiDung
              };
              msgName = 'gqdTraBaoCao';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                actionType: 'TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
                yKienGiaiQuyet: _this6.state.yKienGiaiQuyet
              };
              msgName = 'gqdTraDonThanhCong';
            }
          } else {
            var selectedState = _this6.props.dataNextStates.filter(function (state) {
              return state.type == _this6.state.nextState;
            });
            if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this6.state.noiDung
              };
              msgName = 'gqdTraBaoCao';
            } else {
              params = {
                thongTinGiaiQuyetDon: {
                  id: Number(_this6.props.thongTinGiaiQuyetDonId)
                },
                nextState: {
                  id: Number(selectedState[0].stateId)
                },
                yKienGiaiQuyet: _this6.state.yKienGiaiQuyet
              };
              msgName = 'gqdTraDonThanhCong';
            }
          }
          if (_this6.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
            _this6.postTaiLieuVanThu(_this6.state.taiLieuVanThu, function () {
              _this6.updateTaiLieuVanThu(_this6.state.taiLieuVanThuUpdate, function () {
                _this6.deleteTaiLieuVanThu(_this6.state.taiLieuVanThuDelete, function () {
                  _this6.updateGiaiQuyetDon(_params, params, msgName);
                });
              });
            });
          } else {
            _this6.deleteTaiLieuVanThu(dataFileDelete, function () {
              _this6.updateGiaiQuyetDon(_params, params, msgName);
            });
          }
        }
      });
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this7.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this8.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this9 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this9.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      this.hasChange();
      if (!e) {}
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this10 = this;

      if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET') {
        this.setState(_defineProperty({
          showAttach: false,
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: ''
        }, name, e.target.value), function () {
          _this10.checkFileRequired();
        });
      } else if (name == 'nextState' && e.target.value == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN') {
        this.setState(_defineProperty({
          yKienGiaiQuyet: '',
          canBoGiaiQuyet: '',
          noiDung: '',
          ketLuanNoiDungKhieuNaiGiaoTTXM: '',
          showAttach: false
        }, name, e.target.value), function () {
          _this10.filterFileRequired();
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      if (name == 'nextState') {}
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.hasChange();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      this.setState({
        dataFileDinhKem: data
      });
      this.hasChange();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this11 = this;

      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      params.ketLuanNoiDungKhieuNaiGiaoTTXM = this.state.ketLuanNoiDungKhieuNaiGiaoTTXM || null;
      if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
        params.noiDungTraBaoCaoTTXMLan2 = this.state.noiDung;
      } else {
        params.noiDung = this.state.noiDung || '';
      }
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet || '';
      params.lyDoQuaHan = this.state.lyDoQuaHan || '';
      if (this.props.tuGiaiQuyet != true) {
        if (this.state.nextState) {
          var selectedState = this.props.dataNextStates.filter(function (state) {
            return state.type == _this11.state.nextState;
          });
          params.nextState = {
            id: selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
      } else {
        if (this.state.nextState) {
          var _selectedState = this.props.dataNextStatesTXL.filter(function (state) {
            return state.type == _this11.state.nextState;
          });
          params.nextState = {
            id: _selectedState[0].stateId
          };
        } else {
          params.nextState = null;
        }
      }

      return params;
    }
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState(_defineProperty({}, name, true));
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState(_defineProperty({}, name, false));
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      var lb3 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      var lbGuiTTXM = 'Gửi báo cáo ' + lb1;
      var lbTraTTXM = 'Trả đơn do chuyển ' + lb1 + ' không đúng';
      var alias = this.props.alias;

      var isQuaHan = this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block container-filedinhkem' },
        _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.backConfirm,
          onClose: this.closeConfirmBack.bind(this),
          onSuccess: this.onClickClose.bind(this, true),
          title: 'X\xE1c nh\u1EADn',
          content: _message.msg.confirmBack }),
        _react2.default.createElement(_subView.NhiemVuTTXM, {
          donViGiaoThamTraXacMinh: this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.state.dataGiaiQuyetDon.ngayBatDauTTXM,
          yKienCuaDonViGiaoTTXM: this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM,
          donInfo: this.props.donInfo,
          ngayHetHanTTXM: this.state.dataGiaiQuyetDon.ngayHetHanTTXM }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 mb15' },
                'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
                lb2
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDon == 'DON_TO_CAO' && this.state.giaHanGiaiQuyet },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter mt5' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Gia h\u1EA1n gi\u1EA3i quy\u1EBFt t\u1ED1 c\xE1o'
                      ),
                      _react2.default.createElement(_common.Text, { red: true, className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y:', value: this.state.ngayHetHanSauKhiGiaHanGiaiQuyet ? (0, _moment2.default)(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb15', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDoGiaHanGiaiQuyet }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 pb15' },
                        _react2.default.createElement('span', { className: 'line-border' })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.dataNextState.length > 1 },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      onRef: function onRef(select) {
                        return _this12.select = select;
                      },
                      className: 'col-25',
                      donId: this.state.id,
                      isValid: this.state.validate,
                      data: this.state.dataNextState,
                      placeholder: null,
                      keyName: 'type',
                      valueName: 'tenVietTat',
                      label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                      name: 'huongGiaiQuyet',
                      selectedValue: this.state.nextState,
                      onChange: this.onChange.bind(this, 'nextState') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.tuGiaiQuyet == true },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      onRef: function onRef(select) {
                        return _this12.select = select;
                      },
                      className: 'col-25',
                      donId: this.state.id,
                      isValid: this.state.validate,
                      data: this.state.dataNextStatesTXL,
                      placeholder: null,
                      keyName: 'type',
                      valueName: 'tenVietTat',
                      label: 'H\u01B0\u1EDBng gi\u1EA3i quy\u1EBFt',
                      name: 'huongGiaiQuyet',
                      selectedValue: this.state.nextState,
                      onChange: this.onChange.bind(this, 'nextState') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', value: this.state.noiDung, placeholder: 'Nh\u1EADp...', onChange: this.onChange.bind(this, 'noiDung'), name: 'textareaCanBoKetLuanNoiDung' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                    _react2.default.createElement(_common.TextArea, { bindValidator: this, channel: 'formTaoDon', require: true, className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.yKienGiaiQuyet, onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: 'textareaCanBoKetLuanNoiDung', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: alias === 'CanBoTTXMKhongQuyTrinh' && isQuaHan },
                    _react2.default.createElement(_common.TextArea, { bindValidator: this, channel: 'formTaoDon', require: true, className: 'col-100', label: 'L\xFDd do tr\u1EC5 h\u1EA1n', placeholder: 'Nh\u1EADp...', value: this.state.lyDoQuaHan, onChange: this.onChange.bind(this, 'lyDoQuaHan'), name: 'textareaCanBoKetLuanNoiDung' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, bindValidator: this, dataShow: this.state.ListTaiLieuVanThuShow, data: this.state.ListTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showAttach },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { dataShow: this.state.ListTaiLieuVanThuShow, hideDescription: true, disableAttachFile: true })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialog') },
                  _react2.default.createElement(
                    'span',
                    null,
                    lbGuiTTXM
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.nextState == 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this, 'openDialogTraDon') },
                  _react2.default.createElement(
                    'span',
                    null,
                    lbTraTTXM
                  )
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this, 'openDialog'), onSuccess: this.onSuccess.bind(this, 'openDialog'), title: 'X\xE1c nh\u1EADn', content: "Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + " báo cáo " + lb3 + " của đơn/vụ việc này không?" }),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialogTraDon, onClose: this.closeDialog.bind(this, 'openDialogTraDon'), onSuccess: this.onSuccess.bind(this, 'openDialogTraDon'), title: 'X\xE1c nh\u1EADn', content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD tr\u1EA3 \u0111\u01A1n/v\u1EE5 vi\u1EC7c chuy\u1EC3n ' + lb1 + ' kh\xF4ng \u0111\xFAng n\xE0y cho ' + (this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') + ' kh\xF4ng?' })
            )
          )
        )
      );
    }
  }]);

  return NhapThongTinToTTXM;
}(_react2.default.Component);

NhapThongTinToTTXM.defaultProps = {
  validators: {},
  dataNextStatesTXL: [{
    type: 'CAN_BO_TTXM_TRA_DON_KHONG_DUNG_THAM_QUYEN',
    stateId: 39,
    tenVietTat: 'Trả đơn do chuyển TTXM không đúng'
  }, {
    type: 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET',
    stateId: 15,
    tenVietTat: 'Gửi báo cáo TTXM'
  }]
};

exports.default = NhapThongTinToTTXM;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _subView = __webpack_require__(33);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhapThongTinToTTXMView = function (_React$Component) {
  _inherits(NhapThongTinToTTXMView, _React$Component);

  function NhapThongTinToTTXMView() {
    _classCallCheck(this, NhapThongTinToTTXMView);

    return _possibleConstructorReturn(this, (NhapThongTinToTTXMView.__proto__ || Object.getPrototypeOf(NhapThongTinToTTXMView)).apply(this, arguments));
  }

  _createClass(NhapThongTinToTTXMView, [{
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      var isQuaHan = this.props.donInfo && this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0 ? true : false;
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(_subView.NhiemVuTTXM, {
          donViGiaoThamTraXacMinh: this.props.donViGiaoThamTraXacMinhInfo,
          ngayBatDauTTXM: this.props.ngayBatDauTTXM,
          donInfo: this.props.donInfo,
          yKienCuaDonViGiaoTTXM: this.props.yKienCuaDonViGiaoTTXM,
          ngayHetHanTTXM: this.props.ngayHetHanTTXM }),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt10 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'B\xE1o c\xE1o k\u1EBFt qu\u1EA3 x\xE1c minh',
          lb2
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter mb15' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 no-gutter', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.props.noiDungTraBaoCaoTTXMLan2 ? this.props.noiDungTraBaoCaoTTXMLan2 : this.props.noiDungTraBaoCaoTTXMLan1 })
              )
            ),
            isQuaHan && _react2.default.createElement(_common.TextMessage, { className: 'col-100 no-gutter', label: 'L\xFD do qu\xE1 h\u1EA1n:', value: this.props.donInfo.lyDoQuaHan || '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem mt5' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
        )
      );
    }
  }]);

  return NhapThongTinToTTXMView;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(NhapThongTinToTTXMView);

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhiemVuTTXM = function (_React$Component) {
  _inherits(NhiemVuTTXM, _React$Component);

  function NhiemVuTTXM(props, context) {
    _classCallCheck(this, NhiemVuTTXM);

    var _this = _possibleConstructorReturn(this, (NhiemVuTTXM.__proto__ || Object.getPrototypeOf(NhiemVuTTXM)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(NhiemVuTTXM, [{
    key: 'render',
    value: function render() {
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      var lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Nhi\u1EC7m v\u1EE5 th\u1EA9m tra x\xE1c minh',
          lb2
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mb15' },
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y chuy\u1EC3n:', value: this.props.ngayBatDauTTXM ? (0, _moment2.default)(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', label: "Đơn vị giao " + lb1 + ":", value: this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', red: true, label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:', value: this.props.ngayHetHanTTXM ? (0, _moment2.default)(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(_common.TextMessage, { className: 'col-100', label: "Ý kiến của đơn vị giao " + lb1 + ":", value: this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : '' })
          )
        )
      );
    }
  }]);

  return NhiemVuTTXM;
}(_react2.default.Component);

NhiemVuTTXM.defaultProps = {
  donViGiaoThamTraXacMinh: {
    ten: ''
  },
  ngayHetHanTTXM: '',
  yKienCuaDonViGiaoTTXM: '',
  ngayBatDauTTXM: ''
};

exports.default = NhiemVuTTXM;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = ['LANH_DAO_GIAO_VIEC_TRUONG_PHONG', 'LANH_DAO_GIAO_VIEC_CAN_BO'];

var LanhDaoGiaoViecTTXM = function (_React$Component) {
  _inherits(LanhDaoGiaoViecTTXM, _React$Component);

  function LanhDaoGiaoViecTTXM(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecTTXM);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecTTXM.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecTTXM)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhong: false,
      form_GiaoViecCanBo: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      noiDung: '',
      phongBanGiaiQuyet: '',
      canBoChiDinh: ''
    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecTTXM, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhong: true
              });
              break;

            case 'LANH_DAO_GIAO_VIEC_CAN_BO':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBo: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {

          var info = res.data;

          _this3.setState({
            dataGiaiQuyetDon: info,
            nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
            phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : ''
          }, function () {
            _this3.onlyOneState();
          });
        }
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      var _this4 = this;

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), function () {
          _this4.trigger(newState, true);
        });
      } else {
        this.trigger(this.state, true);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanGiaiQuyet: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {
      var paramsPatch = this.state.dataGiaiQuyetDon;
      var paramsPost = {};
      if (newState.nextState) {
        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);
        paramsPatch.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };
      }

      paramsPatch.yKienGiaiQuyet = newState.noiDung;
      paramsPost.yKienGiaiQuyet = newState.noiDung;

      if (newState.phongBanGiaiQuyet) {

        paramsPatch.phongBanGiaiQuyet = {
          id: Number(newState.phongBanGiaiQuyet)
        };
        paramsPost.phongBanGiaiQuyet = {
          id: Number(newState.phongBanGiaiQuyet)
        };
      }

      if (newState.form_GiaoViecCanBo && newState.nextState === 'LANH_DAO_GIAO_VIEC_CAN_BO') {
        if (newState.canBoChiDinh) {
          paramsPatch.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          };
          paramsPost.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          };
        }
      }

      var params = {
        paramsPatch: paramsPatch,
        paramsPost: paramsPost,
        notice: _message.msg.gqdLanhDaoGiaoViec
      };

      this.props.onChange(params, isInit);
    }
  }, {
    key: 'render',
    value: function render() {
      var fileShow = this.props.listTaiLieuVanThuGiaiQuyetDon;
      if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
        fileShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView;
      }
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhong && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              bindValidator: this,
              selectedValue: this.state.phongBanGiaiQuyet,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              bindValidator: this,
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, {
            label: '\xDD ki\u1EBFn x\u1EED l\xFD',
            value: this.state.noiDung,
            onChange: this.handleChange.bind(this, 'noiDung'),
            name: 'textareaYKienLanhDao' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, dataShow: fileShow })
        )
      );
    }
  }]);

  return LanhDaoGiaoViecTTXM;
}(_react2.default.Component);

LanhDaoGiaoViecTTXM.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecTTXM));

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanhDaoGiaoViecTTXM = function (_React$Component) {
  _inherits(LanhDaoGiaoViecTTXM, _React$Component);

  function LanhDaoGiaoViecTTXM() {
    _classCallCheck(this, LanhDaoGiaoViecTTXM);

    return _possibleConstructorReturn(this, (LanhDaoGiaoViecTTXM.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecTTXM)).apply(this, arguments));
  }

  _createClass(LanhDaoGiaoViecTTXM, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'Ph\xF2ng ban:',
            value: this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo ? this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo.ten : '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt:',
            value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'ccol-12',
            value: this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.yKienGiaiQuyet : '',
            label: 'Ghi ch\xFA:' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem mt15' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon })
        )
      );
    }
  }]);

  return LanhDaoGiaoViecTTXM;
}(_react2.default.Component);

exports.default = LanhDaoGiaoViecTTXM;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _GetParams = __webpack_require__(47);

var _ttForms = __webpack_require__(19);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanhDaoGiaoViecTheoDoiGiamSat = function (_React$Component) {
  _inherits(LanhDaoGiaoViecTheoDoiGiamSat, _React$Component);

  function LanhDaoGiaoViecTheoDoiGiamSat(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecTheoDoiGiamSat);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecTheoDoiGiamSat.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecTheoDoiGiamSat)).call(this, props, context));

    _this.state = {
      id: _this.props.id,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      loaiDon: _this.props.loaiDon,

      dataDetail: [],

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      yKienGiaiQuyet: ''
    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecTheoDoiGiamSat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        loaiDon: nextProps.loaiDon,
        thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId
      });

      if (this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
        this.checkOnlyState(nextProps.dataNextStates);
      }
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          _this2.setState({
            dataDetail: res.data,
            nextState: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
            canBoXuLyChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        if (_this2.props.dataNextStates && _this2.props.dataNextStates.length > 0) {
          _this2.checkOnlyState(_this2.props.dataNextStates);
        }
      });
    }
  }, {
    key: 'checkOnlyState',
    value: function checkOnlyState(dataNextStates) {
      if (this.state.nextState) {
        //do nothing
      } else {
        this.setState({
          nextState: dataNextStates[0].type
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'nextState') {
        this.setState({
          canBoXuLyChiDinh: '',
          phongBanGiaiQuyet: ''
        });
      }
      if (name == 'phongBanGiaiQuyet') {
        this.setState({
          canBoXuLyChiDinh: ''
        });
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var _this3 = this;

      var dataGiaiQuyetDon = this.state.dataDetail;
      var params = (0, _GetParams.getParams)(dataGiaiQuyetDon, this.state.id);
      if (this.state.canBoXuLyChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoXuLyChiDinh)
        };
      } else {
        params.canBoXuLyChiDinh = null;
      }

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        };
      } else {
        params.phongBanGiaiQuyet = null;
      }

      var selectedState = this.props.dataNextStates.filter(function (state) {
        return state.type == _this3.state.nextState;
      });

      if (selectedState.length > 0) {
        params.nextState = {
          id: Number(selectedState[0].stateId)
        };
      } else {
        params.nextState = null;
      }

      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet ? this.state.yKienGiaiQuyet : '';

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });

      var params = this.getParams();
      this.saveGiaiQuyetDon(params, 'gqdLuu');
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this4 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        var selectedState = this.props.dataNextStates.filter(function (state) {
          return state.type == _this4.state.nextState;
        });
        var params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.props.thongTinGiaiQuyetDonId)
          },
          phongBanGiaiQuyet: {
            id: Number(this.state.phongBanGiaiQuyet)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          },
          yKienGiaiQuyet: this.state.yKienGiaiQuyet
        };
        if (this.state.canBoXuLyChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoXuLyChiDinh)
          };
        }
        this.postGiaiQuyetDon(params, 'gqdLanhDaoGiaoViec');
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this5 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this5.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this6.props.dispatch({ type: 'REFRESH_MENU', value: true });
        _this6.onClickClose(true);
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var DataDetail = this.state.dataDetail;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataDetail }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(_subView.BlockBanHanhQuyetDinhView, { donInfo: this.props.donInfo, thongTinGQD: this.state.dataDetail, dataKetLuanNoiDungKhieuNai: this.props.dataKetLuanNoiDungKhieuNai }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb15' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.hideDropdown },
              _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                require: true,
                selectedValue: this.state.nextState,
                label: 'Giao x\u1EED l\xFD',
                onChange: this.handleChange.bind(this, 'nextState'),
                data: this.props.dataNextStates,
                bindValidator: this,
                keyName: 'type',
                valueName: 'tenVietTat',
                name: 'dropdownHuongXuLy' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
              _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
                bindValidator: this,
                selectedValue: this.state.phongBanGiaiQuyet,
                isValid: this.props.validate,
                onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
                name: 'dropdownChonPhongBanThuocCoQuan' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
              _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                bindValidator: this,
                vaiTro: 'CHUYEN_VIEN',
                selectedValue: this.state.canBoXuLyChiDinh,
                phongBanId: this.state.phongBanGiaiQuyet,
                onChange: this.handleChange.bind(this, 'canBoXuLyChiDinh'),
                name: 'dropdownChonCanBoXuLyChuyenVien' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              value: this.state.yKienGiaiQuyet,
              onChange: this.handleChange.bind(this, 'yKienGiaiQuyet'),
              name: 'textareaBanLanhDaoTTXM' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom gqd-wrap pt35 mt20' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.handleKetThuc.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Giao vi\u1EC7c'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LanhDaoGiaoViecTheoDoiGiamSat;
}(_react2.default.Component);

LanhDaoGiaoViecTheoDoiGiamSat.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecTheoDoiGiamSat));

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanhDaoGiaoViecTheoDoiGiamSatView = function (_React$Component) {
  _inherits(LanhDaoGiaoViecTheoDoiGiamSatView, _React$Component);

  function LanhDaoGiaoViecTheoDoiGiamSatView(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecTheoDoiGiamSatView);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecTheoDoiGiamSatView.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecTheoDoiGiamSatView)).call(this, props, context));

    _this.state = {
      DataDetail: _this.props.thongTinXuLyGiaiQuyet && _this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? _this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : [],
      DataGiaiQuyet: _this.props.thongTinXuLyGiaiQuyet
    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecTheoDoiGiamSatView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        DataGiaiQuyet: nextProps.thongTinXuLyGiaiQuyet,
        DataDetail: nextProps.thongTinXuLyGiaiQuyet && nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var DataGiaiQuyet = this.props.thongTinXuLyGiaiQuyet;
      var DataDetail = this.state.DataDetail;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(_subView.BlockGiaiQuyetDonInfo, { donInfo: this.props.donInfo, thongTinGQD: this.state.DataDetail }),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement(_subView.BlockBanHanhQuyetDinhView, { donInfo: this.props.donInfo, thongTinGQD: this.state.DataDetail, dataKetLuanNoiDungKhieuNai: this.props.dataKetLuanNoiDungKhieuNai }),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter mt5' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 mb15' },
              'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, { value: DataGiaiQuyet.nextStateInfo.tenVietTat, label: 'Giao x\u1EED l\xFD:', className: 'col-25 mb10' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
              _react2.default.createElement(_common.Text, { value: DataGiaiQuyet.phongBanGiaiQuyetInfo ? DataGiaiQuyet.phongBanGiaiQuyetInfo.ten : '', label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt:', className: 'col-25 mb10' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && this.state.phongBanGiaiQuyet != '' },
              _react2.default.createElement(_common.Text, { value: DataGiaiQuyet.canBoXuLyChiDinhInfo ? DataGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '', label: 'Tr\u01B0\u1EDFng ph\xF2ng:', className: 'col-25 mb10' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
              _react2.default.createElement(_common.Text, { value: DataGiaiQuyet.canBoXuLyChiDinhInfo ? DataGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '', label: 'C\xF4ng ch\u1EE9c:', className: 'col-25 mb10' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextMessage, { label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: DataGiaiQuyet.yKienGiaiQuyet ? DataGiaiQuyet.yKienGiaiQuyet : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5 no-gutter' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'GiaoCQDT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuGiaiQuyetDon, disableAttachFile: true })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !DataDetail.boSungThongTin && DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line pt5 pb15' },
                _react2.default.createElement('span', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter mt5' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 mb15' },
                  'B\u1ED4 SUNG TH\xD4NG TIN'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(DataDetail.noiDungBoSungHoSo) })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb5 no-gutter' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, dataShow: DataDetail.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
              )
            )
          )
        )
      );
    }
  }]);

  return LanhDaoGiaoViecTheoDoiGiamSatView;
}(_react2.default.Component);

LanhDaoGiaoViecTheoDoiGiamSatView.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecTheoDoiGiamSatView));

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinYeuCauKTDX = function (_React$Component) {
  _inherits(ThongTinYeuCauKTDX, _React$Component);

  function ThongTinYeuCauKTDX() {
    _classCallCheck(this, ThongTinYeuCauKTDX);

    return _possibleConstructorReturn(this, (ThongTinYeuCauKTDX.__proto__ || Object.getPrototypeOf(ThongTinYeuCauKTDX)).apply(this, arguments));
  }

  _createClass(ThongTinYeuCauKTDX, [{
    key: 'render',
    value: function render() {

      var donViPhoiHop = '';
      if (this.props.thongTinYeuCauKiemTraDeXuat) {
        this.props.thongTinYeuCauKiemTraDeXuat.donViPhoiHops.map(function (item) {
          donViPhoiHop = donViPhoiHop + item.ten + ', ';
        });
      }

      donViPhoiHop = donViPhoiHop.slice(0, donViPhoiHop.length - 2);

      return _react2.default.createElement(
        'div',
        { className: 'box-items' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Th\xF4ng tin y\xEAu c\u1EA7u ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form mb0-18' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 mb10' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-25',
                    label: '\u0110\u01A1n v\u1ECB giao ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t:',
                    value: this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.donViDuocGiaoTTXM ? this.props.thongTinYeuCauKiemTraDeXuat.donViDuocGiaoTTXM.ten : '' }),
                  _react2.default.createElement(_common.Text, {
                    red: true,
                    className: 'col-25',
                    label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:',
                    value: this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.ngayBaoCaoKQ ? (0, _moment2.default)(this.props.thongTinYeuCauKiemTraDeXuat.ngayBaoCaoKQ).format('DD/MM/YYYY') : '' })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.showTable },
                _react2.default.createElement(
                  'div',
                  { className: 'container-filedinhkem' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuKiemTraDeXuat })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinYeuCauKTDX;
}(_react2.default.Component);

ThongTinYeuCauKTDX.defaultProps = {};

exports.default = ThongTinYeuCauKTDX;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _message = __webpack_require__(10);

var _processType = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.trinhLanhDao];

var TrinhLanhDaoKTDX = function (_React$Component) {
  _inherits(TrinhLanhDaoKTDX, _React$Component);

  function TrinhLanhDaoKTDX(props, context) {
    _classCallCheck(this, TrinhLanhDaoKTDX);

    var _this = _possibleConstructorReturn(this, (TrinhLanhDaoKTDX.__proto__ || Object.getPrototypeOf(TrinhLanhDaoKTDX)).call(this, props, context));

    _this.state = {
      form_TrinhLanhDaoKTDX: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      noiDung: ''
    };
    return _this;
  }

  _createClass(TrinhLanhDaoKTDX, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case 'TRINH_LANH_DAO':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TrinhLanhDaoKTDX: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataGiaiQuyetDon: res.data,
            lanhDaoChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState));
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState);
        }
      }

      this.setState(_extends({}, newState), this.trigger(newState));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState) {

      if (newState.nextState) {
        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var paramsPatch = this.state.dataGiaiQuyetDon;
        var paramsPost = {};

        paramsPatch.nextState = {
          id: Number(stateId),
          type: this.state.onlyState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: this.state.onlyState
        };

        if (newState.form_TrinhLanhDaoKTDX && newState.nextState == 'TRINH_LANH_DAO') {

          if (newState.lanhDaoChiDinh) {
            paramsPatch.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };
            paramsPost.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };
          }

          paramsPatch.yKienGiaiQuyet = newState.noiDung;
          paramsPost.yKienGiaiQuyet = newState.noiDung;
        }

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.ktdxTrinhLanhDao
        };

        this.props.onChange(params);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.hideDropdown },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'H\u01B0\u1EDBng x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              name: 'dropdownChonXuLy' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.form_TrinhLanhDaoKTDX },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.DropDown, {
              label: 'Ban l\xE3nh \u0111\u1EA1o',
              options: this.props.lanhDaoList,
              keyName: 'congChucId',
              valueName: 'hoVaTen',
              selectedValue: this.state.lanhDaoChiDinh,
              onChange: this.handleChange.bind(this, 'lanhDaoChiDinh'),
              placeholder: this.props.placeholder,
              name: 'chonBanlanhDaoTTXM' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              value: this.state.noiDung,
              onChange: this.handleChange.bind(this, 'noiDung'),
              name: 'textareaYKien' })
          )
        )
      );
    }
  }]);

  return TrinhLanhDaoKTDX;
}(_react2.default.Component);

TrinhLanhDaoKTDX.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TrinhLanhDaoKTDX);

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrinhLanhDaoKTDXView = function (_React$Component) {
  _inherits(TrinhLanhDaoKTDXView, _React$Component);

  function TrinhLanhDaoKTDXView() {
    _classCallCheck(this, TrinhLanhDaoKTDXView);

    return _possibleConstructorReturn(this, (TrinhLanhDaoKTDXView.__proto__ || Object.getPrototypeOf(TrinhLanhDaoKTDXView)).apply(this, arguments));
  }

  _createClass(TrinhLanhDaoKTDXView, [{
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'div',
        { className: 'items-form mb5' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mb10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'Ban l\xE3nh \u0111\u1EA1o:',
            value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'col-12',
            value: this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : '',
            label: 'N\u1ED9i dung:' })
        )
      );
    }
  }]);

  return TrinhLanhDaoKTDXView;
}(_react2.default.Component);

exports.default = TrinhLanhDaoKTDXView;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _ConfirmDialog = __webpack_require__(1197);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'KIEM_TRA_DE_XUAT';

var CanBoKiemTraDeXuat = function (_React$Component) {
  _inherits(CanBoKiemTraDeXuat, _React$Component);

  function CanBoKiemTraDeXuat(props, context) {
    _classCallCheck(this, CanBoKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (CanBoKiemTraDeXuat.__proto__ || Object.getPrototypeOf(CanBoKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      showAttachFile: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      id: _this.props.donId,
      donViId: '',
      yKienGiaiQuyet: '',
      dataGiaiQuyetDon: [],
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,
      nextState: 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataKiemTraDeXuat: _this.props.dataKiemTraDeXuat
    };
    return _this;
  }

  _createClass(CanBoKiemTraDeXuat, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
      });
      this.checkFileRequired();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
      this.checkFileRequired();
    }
  }, {
    key: 'checkFileRequired',
    value: function checkFileRequired() {
      var _this2 = this;

      if (this.props.listTaiLieuVanThuKiemTraDeXuat) {
        var ListTaiLieuVanThu = this.props.listTaiLieuVanThuKiemTraDeXuat.filter(function (state) {
          return state.nguoiTaoInfo.donViId == _this2.state.donViId;
        });
        var ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuKiemTraDeXuat.filter(function (state) {
          return state.nguoiTaoInfo.donViId != _this2.state.donViId;
        });

        if (ListTaiLieuVanThuShow.length > 0) {
          this.setState({
            listTaiLieuVanThuShow: ListTaiLieuVanThuShow
          });
        }

        var newArray = [].concat(_toConsumableArray(ListTaiLieuVanThu));
        if (newArray.length == 0) {
          var newItem = {
            ten: 'Báo cáo kết quả KTĐX',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BC_KTDX'
          };
          this.setState({
            listTaiLieuVanThu: [].concat(_toConsumableArray(ListTaiLieuVanThu), [newItem])
          }, function () {
            _this2.setState({
              showAttachFile: true
            });
          });
        } else {
          var dataCheck = newArray.filter(function (state) {
            return state.required && state.typeRequired == 'BC_KTDX';
          });
          if (dataCheck.length == 0) {
            var _newItem = {
              ten: 'Báo cáo kết quả KTĐX',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'BC_KTDX'
            };
            this.setState({
              listTaiLieuVanThu: [].concat(_toConsumableArray(ListTaiLieuVanThu), [_newItem])
            }, function () {
              _this2.setState({
                showAttachFile: true
              });
            });
          } else {
            this.setState({
              listTaiLieuVanThu: ListTaiLieuVanThu
            }, function () {
              _this2.setState({
                showAttachFile: true
              });
            });
          }
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(id) {
      var _this3 = this;

      if (typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
        var params = {
          id: id
        };
        _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(function (res) {
          if (res.data) {
            _this3.setState({
              dataGiaiQuyetDon: res.data,
              yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
            });
          }
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;

      if (dataGiaiQuyetDon.donViThamTraXacMinhInfo) {
        dataGiaiQuyetDon.donViThamTraXacMinh = {
          id: dataGiaiQuyetDon.donViThamTraXacMinhInfo.coQuanQuanLyId
        };
      } else {
        dataGiaiQuyetDon.donViThamTraXacMinh = null;
      }

      if (dataGiaiQuyetDon.canBoGiaiQuyetInfo) {
        dataGiaiQuyetDon.canBoGiaiQuyet = {
          id: dataGiaiQuyetDon.canBoGiaiQuyetInfo.congChucId
        };
      } else {
        dataGiaiQuyetDon.canBoGiaiQuyet = null;
      }

      if (dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo) {
        dataGiaiQuyetDon.donViGiaoThamTraXacMinh = {
          id: dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId
        };
      } else {
        dataGiaiQuyetDon.donViGiaoThamTraXacMinh = null;
      }

      if (dataGiaiQuyetDon.canBoThamTraXacMinhInfo) {
        dataGiaiQuyetDon.canBoThamTraXacMinh = {
          id: dataGiaiQuyetDon.canBoThamTraXacMinhInfo.congChucId
        };
      } else {
        dataGiaiQuyetDon.canBoThamTraXacMinh = null;
      }

      if (dataGiaiQuyetDon.coQuanDieuTraInfo) {
        dataGiaiQuyetDon.coQuanDieuTra = {
          id: dataGiaiQuyetDon.coQuanDieuTraInfo.coQuanQuanLyId
        };
      } else {
        dataGiaiQuyetDon.coQuanDieuTra = null;
      }

      // if(dataGiaiQuyetDon.coQuanTheoDoiInfo) {
      //   dataGiaiQuyetDon.coQuanTheoDoi = {
      //     id: dataGiaiQuyetDon.coQuanTheoDoiInfo.coQuanQuanLyId
      //   }
      // } else {
      //   dataGiaiQuyetDon.coQuanTheoDoi = null
      // }

      if (dataGiaiQuyetDon.truongDoanTTXMInfo) {
        dataGiaiQuyetDon.truongDoanTTXM = {
          id: dataGiaiQuyetDon.truongDoanTTXMInfo.congChucId
        };
      } else {
        dataGiaiQuyetDon.truongDoanTTXM = null;
      }

      if (dataGiaiQuyetDon.canBoXuLyChiDinhInfo) {
        dataGiaiQuyetDon.canBoXuLyChiDinh = {
          id: dataGiaiQuyetDon.canBoXuLyChiDinhInfo.congChucId
        };
      } else {
        dataGiaiQuyetDon.canBoXuLyChiDinh = null;
      }

      if (dataGiaiQuyetDon.nextStateInfo) {
        dataGiaiQuyetDon.nextState = {
          id: dataGiaiQuyetDon.nextStateInfo.id
        };
      } else {
        dataGiaiQuyetDon.nextState = null;
      }

      if (dataGiaiQuyetDon.phongBanGiaiQuyetInfo) {
        dataGiaiQuyetDon.phongBanGiaiQuyet = {
          id: dataGiaiQuyetDon.phongBanGiaiQuyetInfo.coQuanQuanLyId
        };
      } else {
        dataGiaiQuyetDon.phongBanGiaiQuyet = null;
      }

      delete dataGiaiQuyetDon['_links'];
      delete dataGiaiQuyetDon['nguoiSuaInfo'];
      delete dataGiaiQuyetDon['nguoiTaoInfo'];
      delete dataGiaiQuyetDon['ngaySua'];
      delete dataGiaiQuyetDon['ngayTao'];
      delete dataGiaiQuyetDon['donViThamTraXacMinhInfo'];
      delete dataGiaiQuyetDon['donViGiaoThamTraXacMinhInfo'];
      delete dataGiaiQuyetDon['canBoGiaiQuyetInfo'];
      delete dataGiaiQuyetDon['canBoThamTraXacMinhInfo'];
      delete dataGiaiQuyetDon['coQuanDieuTraInfo'];
      delete dataGiaiQuyetDon['coQuanTheoDoiInfo'];
      delete dataGiaiQuyetDon['nguoiBanHanhInfo'];
      delete dataGiaiQuyetDon['truongDoanTTXMInfo'];
      delete dataGiaiQuyetDon['donId'];
      delete dataGiaiQuyetDon['phongBanGiaiQuyetInfo'];
      delete dataGiaiQuyetDon['canBoXuLyChiDinhInfo'];
      delete dataGiaiQuyetDon['nextStateInfo'];

      dataGiaiQuyetDon['don'] = {
        id: this.state.id
      };

      return dataGiaiQuyetDon;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this4 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        this.state.dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this4.state.taiLieuVanThuUpdate[_this4.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this4.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this4.state.taiLieuVanThu[_this4.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this4.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this4.state.taiLieuVanThuDelete[_this4.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var params = this.getParams();

        params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this4.updateTaiLieuVanThu(_this4.state.taiLieuVanThuUpdate, function () {
            _this4.deleteTaiLieuVanThu(_this4.state.taiLieuVanThuDelete, function () {
              _this4.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      }
    }
  }, {
    key: 'handleGiaiQuyetDon',
    value: function handleGiaiQuyetDon() {
      var _this5 = this;

      if (this.validateSubmitForm()) {
        this.state.dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(_this5.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
              don: {
                id: Number(_this5.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(function (item) {
            _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        var selectedState = this.props.listNextStates.filter(function (state) {
          return state.type == _this5.state.nextState;
        });

        var params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.state.thongTinGiaiQuyetDonId)
          },
          nextState: {
            id: Number(selectedState[0].stateId)
          },
          yKienGiaiQuyet: this.state.yKienGiaiQuyet
        };
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, function () {
          _this5.updateTaiLieuVanThu(_this5.state.taiLieuVanThuUpdate, function () {
            _this5.deleteTaiLieuVanThu(_this5.state.taiLieuVanThuDelete, function () {
              _this5.postGiaiQuyetDon(params, 'ktdxTraBaoCao');
            });
          });
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
    }

    // Cap nhat tep dinh kem

  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Them tep dinh kem

  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }

    // Xoa tep dinh kem

  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(fileList, callback) {
      if (fileList && fileList.length) {
        var params = {
          taiLieuVanThus: fileList
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {
          callback();
        }).catch(function (error) {
          if (error.response) {}
          callback();
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      this.setState({
        dataFileDinhKem: data
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (this.state.dataFileDinhKem.length > 0) {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else {
            validator.validate();
          }
        });
      }
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'openDialog',
    value: function openDialog(name) {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(name) {
      this.setState({
        openDialog: false
      });
      this.handleGiaiQuyetDon();
    }
  }, {
    key: 'updateGiaiQuyetDon',
    value: function updateGiaiQuyetDon(params, _params, message) {
      var _this6 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this6.postGiaiQuyetDon(_params, message);
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'saveGiaiQuyetDon',
    value: function saveGiaiQuyetDon(params, message) {
      var _this7 = this;

      _api.GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, params).then(function (res) {
        _this7.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postGiaiQuyetDon',
    value: function postGiaiQuyetDon(params, message) {
      var _this8 = this;

      _api.GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(function (res) {
        _this8.onClickClose();
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.giaiQuyetDon, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var tenCoQuan = this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.donViGiaoKTDX ? this.props.thongTinYeuCauKiemTraDeXuat.donViGiaoKTDX.ten : '';
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, { value: this.state.yKienGiaiQuyet, className: 'areal-wrap col-100', label: '\xDD ki\u1EBFn x\u1EED l\xFD', placeholder: 'Nh\u1EADp \xFD ki\u1EBFn', onChange: this.onChange.bind(this, 'yKienGiaiQuyet'), name: '' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.showAttachFile },
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem pb5' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.props.onSave, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, dataShow: this.state.listTaiLieuVanThuShow, data: this.state.listTaiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-gqd-kqt' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom gqd-wrap col-100 mt20 pt30' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline' : "btn-action btn-move action-todo", onClick: this.openDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Chuy\u1EC3n \u0111\u01A1n v\u1ECB gi\u1EA3i quy\u1EBFt'
                )
              ),
              _react2.default.createElement(_ConfirmDialog2.default, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.onSuccess.bind(this), title: "Xác nhận giao " + lb1, content: 'Bạn có đồng ý chuyển cho ' + tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?' })
            )
          )
        )
      );
    }
  }]);

  return CanBoKiemTraDeXuat;
}(_react2.default.Component);

CanBoKiemTraDeXuat.defaultProps = {
  validators: {},
  onSave: false
};

exports.default = CanBoKiemTraDeXuat;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _upload = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CanBoKiemTraDeXuatView = function (_React$Component) {
  _inherits(CanBoKiemTraDeXuatView, _React$Component);

  function CanBoKiemTraDeXuatView() {
    _classCallCheck(this, CanBoKiemTraDeXuatView);

    return _possibleConstructorReturn(this, (CanBoKiemTraDeXuatView.__proto__ || Object.getPrototypeOf(CanBoKiemTraDeXuatView)).apply(this, arguments));
  }

  _createClass(CanBoKiemTraDeXuatView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextMessage, {
              className: 'col-12',
              value: this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : '',
              label: '\xDD ki\u1EBFn x\u1EED l\xFD:' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuKiemTraDeXuat })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.boSungThongTin && this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-big-line pt5 pb15' },
                  _react2.default.createElement('span', { className: 'big-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter mt5' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-14 mb15' },
                    'B\u1ED4 SUNG TH\xD4NG TIN'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(_common.TextMessage, { className: 'col-50 mb0-18', label: 'L\xFD do b\u1ED5 sung:', value: String(this.props.noiDungBoSungHoSo) })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5 no-gutter container-filedinhkem' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'BoSungTT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n b\u1ED5 sung', hideDescription: true, bindValidator: this, dataShow: this.props.listTaiLieuVanThuBoSungHoSo, disableAttachFile: true })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CanBoKiemTraDeXuatView;
}(_react2.default.Component);

CanBoKiemTraDeXuatView.defaultProps = {
  validators: {}
};

exports.default = CanBoKiemTraDeXuatView;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    _classCallCheck(this, ConfirmDialog);

    return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).apply(this, arguments));
  }

  _createClass(ConfirmDialog, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.onClose();
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      this.props.onSuccess();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.open,
          onClose: this.closeDialog.bind(this),
          title: this.props.title,
          className: 'reception-dialog delete-dialog wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'p',
            { className: 'reception-dialog-text' },
            this.props.content
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom col-100' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              'Kh\xF4ng'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'btn-green', onClick: this.onSuccess.bind(this) },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\u1ED3ng \xFD'
            )
          )
        )
      );
    }
  }]);

  return ConfirmDialog;
}(_react2.default.Component);

ConfirmDialog.defaultProps = {
  title: 'Xác nhận chuyển',
  content: 'Bạn có muốn chuyển giải quyết đơn?',
  onSuccess: function onSuccess() {
    console.log('Need to assign onSuccess method');
  },
  onClose: function onClose() {
    console.log('Need to assign onClose method');
  }
};

exports.default = ConfirmDialog;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = ['LANH_DAO_GIAO_VIEC_TRUONG_PHONG', 'LANH_DAO_GIAO_VIEC_CAN_BO'];

var LanhDaoGiaoViecKTDX = function (_React$Component) {
  _inherits(LanhDaoGiaoViecKTDX, _React$Component);

  function LanhDaoGiaoViecKTDX(props, context) {
    _classCallCheck(this, LanhDaoGiaoViecKTDX);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViecKTDX.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecKTDX)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhongKTDX: false,
      form_GiaoViecCanBoKTDX: false,

      donId: _this.props.donId,
      thongTinGiaiQuyetDonId: _this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      noiDung: '',
      phongBanGiaiQuyet: '',
      truongPhongChiDinh: '',
      canBoChiDinh: ''

    };
    return _this;
  }

  _createClass(LanhDaoGiaoViecKTDX, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhongKTDX: true
              });
              break;

            case 'LANH_DAO_GIAO_VIEC_CAN_BO':
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBoKTDX: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(function (res) {
        if (res.data) {
          var info = res.data;

          _this3.setState({
            dataGiaiQuyetDon: info,
            nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
            phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : ''
          });
        }
      }).then(function () {
        _this3.onlyOneState();
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState));
      } else {
        this.trigger(this.state);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanGiaiQuyet: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState));
    }
  }, {
    key: 'trigger',
    value: function trigger(newState) {

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);

        var paramsPatch = this.state.dataGiaiQuyetDon;
        var paramsPost = {};

        paramsPatch.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPost.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        paramsPatch.yKienGiaiQuyet = newState.noiDung;
        paramsPost.yKienGiaiQuyet = newState.noiDung;

        if (newState.phongBanGiaiQuyet) {

          paramsPatch.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
          paramsPost.phongBanGiaiQuyet = {
            id: Number(newState.phongBanGiaiQuyet)
          };
        }

        if (newState.form_GiaoViecTruongPhongKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG') {

          if (newState.truongPhongChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
          }
        } else if (newState.form_GiaoViecCanBoKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO') {

          if (newState.canBoChiDinh) {
            paramsPatch.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
            paramsPost.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        }

        paramsPost.thongTinGiaiQuyetDon = {
          id: this.props.thongTinGiaiQuyetDonId
        };

        var params = {
          paramsPatch: paramsPatch,
          paramsPost: paramsPost,
          notice: _message.msg.ktdxLanhDaoGiaoViec
        };

        this.props.onChange(params);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              isValid: this.props.validate,
              bindValidator: this,
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhongKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              bindValidator: this,
              selectedValue: this.state.phongBanGiaiQuyet,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanGiaiQuyet'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBoKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              bindValidator: this,
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanGiaiQuyet,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, {
            label: '\xDD ki\u1EBFn x\u1EED l\xFD',
            value: this.state.noiDung,
            onChange: this.handleChange.bind(this, 'noiDung'),
            name: 'textareaYKienLanhDao' })
        )
      );
    }
  }]);

  return LanhDaoGiaoViecKTDX;
}(_react2.default.Component);

LanhDaoGiaoViecKTDX.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViecKTDX));

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanhDaoGiaoViecKTDXView = function (_React$Component) {
  _inherits(LanhDaoGiaoViecKTDXView, _React$Component);

  function LanhDaoGiaoViecKTDXView() {
    _classCallCheck(this, LanhDaoGiaoViecKTDXView);

    return _possibleConstructorReturn(this, (LanhDaoGiaoViecKTDXView.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViecKTDXView)).apply(this, arguments));
  }

  _createClass(LanhDaoGiaoViecKTDXView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb5' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mb10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'Giao x\u1EED l\xFD:',
            value: this.props.thongTinXuLyGiaiQuyet.nextStateInfo ? this.props.thongTinXuLyGiaiQuyet.nextStateInfo.tenVietTat : '' }),
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'Ph\xF2ng ban:',
            value: this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo ? this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo.ten : '' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.nextStateInfo != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo != null && this.props.thongTinXuLyGiaiQuyet.nextStateInfo.type == "LANH_DAO_GIAO_VIEC_TRUONG_PHONG" && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen != '' },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'Tr\u01B0\u1EDFng ph\xF2ng:',
              value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.nextStateInfo != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo != null && this.props.thongTinXuLyGiaiQuyet.nextStateInfo.type == "LANH_DAO_GIAO_VIEC_CAN_BO" && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen != '' },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt:',
              value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mb10' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'col-12',
            value: this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : '',
            label: 'N\u1ED9i dung giao vi\u1EC7c:' })
        )
      );
    }
  }]);

  return LanhDaoGiaoViecKTDXView;
}(_react2.default.Component);

exports.default = LanhDaoGiaoViecKTDXView;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _processType = __webpack_require__(57);

var _message = __webpack_require__(10);

var _upload = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.trinhLanhDao, _processType.processType.xuLyDon.processing.yeuCauGapLanhDao, _processType.processType.xuLyDon.processing.trinhTruongPhong];

var TrinhLanhDao = function (_React$Component) {
  _inherits(TrinhLanhDao, _React$Component);

  function TrinhLanhDao(props, context) {
    _classCallCheck(this, TrinhLanhDao);

    var _this = _possibleConstructorReturn(this, (TrinhLanhDao.__proto__ || Object.getPrototypeOf(TrinhLanhDao)).call(this, props, context));

    _this.state = {
      form_TrinhLanhDao: false,
      form_YeuCauGapLanhDao: false,

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',
      nextState: '',

      hideDropdown: false,

      thoiHanXuLy: '',
      noiDung: '',
      lanhDaoChiDinh: '',
      dataShow: [],
      dataTruongPhong: []
    };
    return _this;
  }

  _createClass(TrinhLanhDao, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
      this.getDataTruongPhong();
    }
  }, {
    key: 'getDataTruongPhong',
    value: function getDataTruongPhong() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_BAN_TIEP_CONG_DAN' }).then(function (res) {
        if (res.data && res.data._embedded && res.data._embedded.thamSoes.length) {
          _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request({ coQuanQuanLyId: res.data._embedded.thamSoes[0].giaTri, vaiTro: 'TRUONG_PHONG' }).then(function (res) {
            if (res.data._embedded) {
              _this2.setState({
                dataTruongPhong: res.data._embedded.congChucs
              });
            }
          });
        }
      });
    }
  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this3 = this;

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this3.state.donId;
      });
      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this4 = this;

      var numberState = 0;
      var onlyState = '';
      process.map(function (item, i) {

        if (_this4.props.getState(_this4.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.trinhLanhDao:
              _this4.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TrinhLanhDao: true
              });
              break;

            case _processType.processType.xuLyDon.processing.trinhTruongPhong:
              _this4.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TrinhLanhDao: true
              });
              break;

            case _processType.processType.xuLyDon.processing.yeuCauGapLanhDao:
              _this4.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_YeuCauGapLanhDao: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onlyOneState();
      if (this.state.donId) {
        this.getThongTinXuLy(this.state.donId);
      }
      this.getListDocument();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(np) {
      if (np.thongTinDon != this.props.thongTinDon && this.props.thongTinDon.loaiDonId != np.thongTinDon.loaiDonId) {
        this.getThoiHanXuLyMacDinh(np.thongTinDon.loaiDonId);
      }
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'getThoiHanXuLyMacDinh',
    value: function getThoiHanXuLyMacDinh(loaiDon) {
      var _this5 = this;

      var params = {
        type: loaiDon
      };
      _api.DuLieuHeThong.actions.getThoiHanXuLyMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this5.setState({
          thoiHanXuLy: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this6 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          var info = res.data.thongTinXuLyInfo;
          var newState = _extends({}, _this6.state);
          newState.thoiHanXuLy = info.thoiHanXuLy ? (0, _moment2.default)(info.thoiHanXuLy).format('DD/MM/YYYY') : '';
          newState.lanhDaoChiDinh = info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '';
          newState.noiDung = info.yKienXuLy;
          newState.nextState = info.nextState ? info.nextState.type : '';
          _this6.setState(_extends({}, newState), function () {
            _this6.trigger(newState, true);
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        newState = _extends({}, newState, {
          noiDung: ''
        });

        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            lanhDaoChiDinh: '',
            noiDung: ''
          });
        }
      }

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (typeof e.format == 'function') {
        var newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));

        this.setState(_extends({}, newState), this.trigger(newState, false));
      } else {

        var _newState = _extends({}, this.state, _defineProperty({}, name, e));

        this.setState(_extends({}, _newState), this.trigger(_newState, false));
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      var params = {
        thoiHanXuLy: (0, _moment2.default)(newState.thoiHanXuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        yKienXuLy: newState.noiDung
      };

      if (newState.nextState) {
        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);
        params.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };

        if (newState.form_TrinhLanhDao && newState.nextState == _processType.processType.xuLyDon.processing.trinhLanhDao) {
          params.notice = _message.msg.xldTrinhLanhDao;
          if (newState.lanhDaoChiDinh) params.canBoXuLyChiDinh = {
            id: Number(newState.lanhDaoChiDinh)
          };
        }
        if (newState.form_TrinhLanhDao && newState.nextState == _processType.processType.xuLyDon.processing.trinhTruongPhong) {
          params.notice = _message.msg.xldTrinhLanhDao;
          if (newState.lanhDaoChiDinh) params.canBoXuLyChiDinh = {
            id: Number(newState.lanhDaoChiDinh)
          };
        }
        if (newState.form_YeuCauGapLanhDao && newState.nextState == _processType.processType.xuLyDon.processing.yeuCauGapLanhDao) {
          params.notice = _message.msg.xldYeuCauGapLanhDao;
        }
      }

      this.props.onChange(params, isInit);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'H\u01B0\u1EDBng x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              name: 'dropdownChonXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_TrinhLanhDao && (this.state.nextState == _processType.processType.xuLyDon.processing.trinhLanhDao || this.state.nextState == _processType.processType.xuLyDon.processing.trinhTruongPhong) },
            _react2.default.createElement(_common.DatePicker, { require: true,
              value: this.state.thoiHanXuLy,
              label: 'H\u1EA1n x\u1EED l\xFD',
              name: 'thoiHanXuLy',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'thoiHanXuLy'),
              isValid: this.props.validate,
              bindValidator: this,
              channel: 'formTaoDon' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == _processType.processType.xuLyDon.processing.trinhLanhDao },
              _react2.default.createElement(_common.DropDown, {
                label: 'L\xE3nh \u0111\u1EA1o',
                options: this.props.lanhDaoList,
                keyName: 'congChucId',
                valueName: 'hoVaTen',
                bindValidator: this,
                require: true,
                channel: 'formTaoDon',
                selectedValue: this.state.lanhDaoChiDinh,
                onChange: this.handleChange.bind(this, 'lanhDaoChiDinh'),
                placeholder: true,
                name: 'dropdownChonLanhDao' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.nextState == _processType.processType.xuLyDon.processing.trinhTruongPhong },
              _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                label: 'L\xE3nh \u0111\u1EA1o',
                bindValidator: this,
                require: true,
                channel: 'formTaoDon',
                selectedValue: this.state.lanhDaoChiDinh,
                onChange: this.handleChange.bind(this, 'lanhDaoChiDinh'),
                keyName: 'congChucId',
                valueName: 'hoVaTen',
                data: this.state.dataTruongPhong,
                name: 'dropdownChonCanBoXuLyTruongPhong' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_TrinhLanhDao || this.state.form_YeuCauGapLanhDao },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              value: this.state.noiDung || '',
              onChange: this.handleChange.bind(this, 'noiDung'),
              name: 'textareaYKien' })
          )
        ),
        this.state.dataShow.length ? _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, dataShow: this.state.dataShow })
        ) : ''
      );
    }
  }]);

  return TrinhLanhDao;
}(_react2.default.Component);

TrinhLanhDao.defaultProps = {
  data: {},
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  thongTinDon: {}
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TrinhLanhDao));

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrinhLanhDaoView = function (_React$Component) {
  _inherits(TrinhLanhDaoView, _React$Component);

  function TrinhLanhDaoView() {
    _classCallCheck(this, TrinhLanhDaoView);

    return _possibleConstructorReturn(this, (TrinhLanhDaoView.__proto__ || Object.getPrototypeOf(TrinhLanhDaoView)).apply(this, arguments));
  }

  _createClass(TrinhLanhDaoView, [{
    key: 'render',
    value: function render() {
      var taiLieuDinhKem = this.props.listTaiLieuVanThu;
      if ((0, _lodash.isArray)(this.props.listTaiLieuVanThuChuyenDonBoSungHoSo) && !(0, _lodash.isEmpty)(this.props.listTaiLieuVanThuChuyenDonBoSungHoSo)) {
        this.props.listTaiLieuVanThuChuyenDonBoSungHoSo.forEach(function (item) {
          taiLieuDinhKem.push(item);
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb5' },
        _react2.default.createElement(
          'div',
          { className: 'row pr10 pl10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'H\u01B0\u1EDBng x\u1EED l\xFD:',
            value: this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy ? this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : '' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.nextState.type == _processType.processType.xuLyDon.processing.trinhLanhDao },
            _react2.default.createElement(_common.Text, {
              red: true,
              className: 'col-input',
              label: 'H\u1EA1n x\u1EED l\xFD:',
              value: this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'L\xE3nh \u0111\u1EA1o:',
              value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pr10 pl10' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'col-12',
            value: this.props.thongTinXuLyGiaiQuyet.yKienXuLy || '',
            label: 'N\u1ED9i dung:' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: taiLieuDinhKem })
        )
      );
    }
  }]);

  return TrinhLanhDaoView;
}(_react2.default.Component);

exports.default = TrinhLanhDaoView;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _ttForms = __webpack_require__(19);

var _processType = __webpack_require__(57);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _InPhieu = __webpack_require__(235);

var _InPhieu2 = _interopRequireDefault(_InPhieu);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _autoComplete = __webpack_require__(190);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'XU_LY_DON';
var Promise = __webpack_require__(136).Promise;
// Du lieu huong xu ly
var process = [_processType.processType.xuLyDon.processing.ketThuc, _processType.processType.xuLyDon.processing.deXuatGiaoViecLai];

var HuongXuLy = function (_React$Component) {
  _inherits(HuongXuLy, _React$Component);

  function HuongXuLy(props, context) {
    _classCallCheck(this, HuongXuLy);

    var _this = _possibleConstructorReturn(this, (HuongXuLy.__proto__ || Object.getPrototypeOf(HuongXuLy)).call(this, props, context));

    _this.state = {
      form_HuongXuLy: false,
      form_DeXuatGiaoViecLai: false,
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},

      renderContainer: true,
      requireText: false,
      lblTextArea: 'Ý kiến xử lý',

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',
      noiDung: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: '',

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataDonViTTXM: [],
      ngayRaThongBaoThuLy: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(HuongXuLy, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.huongXuLy != prevState.huongXuLy) {

        switch (this.state.huongXuLy) {

          case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:

            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

            this.setState({
              lblTextArea: 'Lý do lưu đơn',
              requireText: true
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
            this.setState({
              lblTextArea: 'Lý do',
              requireText: true
            });
            return;
          default:
            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
      this.getListDocument();
    }

    // Add component Util

  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this2 = this;

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this2.state.donId;
      });

      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this3 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this3.props.getState(_this3.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.ketThuc:
              _this3.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_HuongXuLy: true
              });
              break;

            case _processType.processType.xuLyDon.processing.deXuatGiaoViecLai:
              _this3.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_DeXuatGiaoViecLai: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onlyOneState();

      if (this.state.donId != 0) {
        this.getThongTinXuLy(this.state.donId);
      }
      this.getDonViTTXM();
    }
  }, {
    key: 'getDonViTTXM',
    value: function getDonViTTXM() {
      var _this4 = this;

      var params = {
        loaiDon: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : null
      };
      _api.DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(function (res) {
        if (res.data._embedded && _this4.refs.huongXL) {
          _this4.setState({
            dataDonViTTXM: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      var _this5 = this;

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), function () {
          _this5.trigger(newState, true);
        });
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this6 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
        params.ngayRaThongBaoGiaiQuyet = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this6.setState({
          hanGiaiQuyet: thoiHanXuLyMacDinh
        }, function () {
          _this6.trigger(_this6.state, false);
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this7 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoTTXM && this.state.trangThaiTTXM == 'GIAO_TTXM') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this7.setState({
          thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
        }, function () {
          _this7.trigger(_this7.state, false);
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this8 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data && _this8.refs.huongXL) {
          var info = res.data.thongTinXuLyInfo;
          var newState = _extends({}, _this8.state);
          // Xac dinh co luu du lieu hay chua
          if (info.hanGiaiQuyet == null) {
            _this8.getThoiHanGQDonMacDinh();
          }

          if (info.thoiHanBaoCaoKetQuaTTXM == null) {
            _this8.getThoiHanTTXMMacDinh();
          }
          // Xac dinh co luu du lieu hay chua
          if (info.nextState == null) {
            _this8.getThoiHanGQDonMacDinh();
            _this8.getThoiHanTTXMMacDinh();
          } else {

            newState.noiDung = info.yKienXuLy;
            newState.huongXuLy = info.huongXuLy ? info.huongXuLy.giaTri : '';
            newState.thamQuyenGiaiQuyet = info.thamQuyenGiaiQuyet ? info.thamQuyenGiaiQuyet.id : '';
            newState.phongBanGiaiQuyet = info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '';
            newState.coQuanTiepNhan = info.coQuanTiepNhan ? info.coQuanTiepNhan.id : null;
            newState.coQuanTiepNhanTen = info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '';
            newState.truongPhongChiDinh = info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '';
            newState.nextState = info.nextState ? info.nextState.type : '';
            newState.trangThaiTTXM = info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.mapTrangThaiTTXM ? info.mapTrangThaiTTXM.enum : '';
            newState.hanGiaiQuyet = info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.hanGiaiQuyet ? (0, _moment2.default)(info.hanGiaiQuyet).format('DD/MM/YYYY') : '';
            newState.donViThamTraXacMinh = info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.id : '';
            newState.donViThamTraXacMinhTen = info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.ten : '';
            newState.thoiHanBaoCaoKetQuaTTXM = info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? (0, _moment2.default)(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '';
            newState.donViNgoaiHeThong = info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten : '';
            newState.donViNgoaiHeThongId = info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : '';
          }

          _this8.setState(_extends({}, newState), function () {
            _this8.checkFileHuongXuLy();
          });
          _this8.trigger(_this8.state, true);
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this9 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      var index = name == 'coQuanTiepNhan' ? 0 : e.nativeEvent.target.selectedIndex;

      if (name === 'huongXuLy') {
        if (e.target.value === 'DE_XUAT_THU_LY') {
          if (this.state.dataDonViTTXM.length == 0) {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: 'TU_TTXM'
            });
          } else {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: ''
            });
          }
        } else {
          newState = _extends({}, newState, {
            noiDung: '',
            thamQuyenGiaiQuyet: '',
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          });
        }
        if (this.state.hasFileChange) {
          this.state.prepareData = newState;
          this.state.popupConfirmHXL = true;
          this.setState(_extends({}, this.state));
          return;
        }
      }

      // if (name == 'trangThaiTTXM') {

      //   newState = {
      //     ...newState
      //   }
      // }

      if (name == 'donViThamTraXacMinh') {

        newState = _extends({}, newState, {
          donViThamTraXacMinhTen: e.nativeEvent.target[index].text
        });
      }

      if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
      }

      if (name == 'coQuanTiepNhan') {
        newState = _extends({}, newState, {
          coQuanTiepNhanTen: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
        this.props.coQuanTiepNhanList.map(function (item) {
          if (item.coQuanQuanLyId == e.target.value) {
            newState.coQuanTiepNhanTen = item.ten;
          }
        });
      }
      this.setState(_extends({}, newState), function () {
        if (name == 'huongXuLy') {
          _this9.checkFileHuongXuLy();
        }
        if (name == 'trangThaiTTXM') {
          _this9.checkFileTTXM();
        }

        _this9.trigger(newState, false);
      });
    }
  }, {
    key: 'confirmChangeHuongXuLy',
    value: function confirmChangeHuongXuLy(next) {
      var _this10 = this;

      if (next) {
        this.setState(_extends({}, this.state.prepareData, {
          hasFileChange: false
        }), function () {
          _this10.checkFileHuongXuLy();
          _this10.trigger(_this10.state.prepareData, false);
        });
      } else {
        this.state.popupConfirmHXL = false;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'checkFileHuongXuLy',
    value: function checkFileHuongXuLy() {
      var _this11 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var DataInit = [].concat(_toConsumableArray(_this11.props.listTaiLieuVanThu));
        var dataFileDinhKem = [];
        var dataShow = [];
        if (_this11.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else if (_this11.props.ngayNhanDon) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayNhanDon), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayNhanDon), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this11.state.donId;
          });
        }
        var typeRequired = '';
        var name = '';
        if (_this11.state.huongXuLy == 'DE_XUAT_THU_LY') {

          var data = [].concat(_toConsumableArray(dataFileDinhKem));

          var dataExist = data.filter(function (item) {
            return item.typeRequired == 'XLD_PDXTL';
          });
          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this11.trigger(_this11.state, false);
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
            var ItemDTTL = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
            }
            var _listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem), [ItemDTTL]);
            var _dataFilter = _listTaiLieuVanThu.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var ItemTL = {
              ten: 'Phiếu đề xuất thụ lý',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              checkValid: true,
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            var _listTaiLieuVanThu2 = [].concat(_toConsumableArray(dataFileDinhKem), [ItemTL]);
            var _dataFilter2 = _listTaiLieuVanThu2.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter2
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          }
        } else if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this11.props.loaiDonGiaTri == 'DON_TO_CAO') || _this11.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO' && _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this11.state.huongXuLy == 'CHUYEN_DON' || _this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (_this11.props.loaiDonGiaTri == 'DON_TO_CAO' || _this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') || _this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (_this11.props.loaiDonGiaTri == 'DON_TO_CAO' || _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && _this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
          if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' || _this11.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO') {
            typeRequired = 'XLD_KDDKTL';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Thông báo về việc không thụ lý giải quyết tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết ';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh';
            }
          } else if (_this11.state.huongXuLy == 'CHUYEN_DON') {
            typeRequired = 'XLD_PCD';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc chuyển đơn tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh';
            } else {
              name = 'Văn bản chuyển đơn';
            }
          } else if (_this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
            typeRequired = 'XLD_TDHD';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc hướng dẫn người tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Văn bản về việc hướng dẫn người khiếu nại';
            }
          } else if (_this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
            typeRequired = 'XLD_TDHD';
            if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết';
            }
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
            typeRequired = 'XLD_TDKDTQ';
            name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
            typeRequired = 'XLD_TDKDTQLD';
            name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
          }

          var _data = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataExist = _data.filter(function (item) {
            return item.required && item.typeRequired == typeRequired;
          });

          if (_dataExist.length > 0) {
            var _listTaiLieuVanThu3 = [].concat(_toConsumableArray(dataFileDinhKem));
            var _dataFilter3 = _listTaiLieuVanThu3.filter(function (item) {
              return item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: _dataFilter3
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var newItem = {
              ten: name,
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: typeRequired,
              newFile: true
            };

            var _listTaiLieuVanThu4 = [].concat(_toConsumableArray(dataFileDinhKem), [newItem]);
            var _dataFilter4 = _listTaiLieuVanThu4.filter(function (item) {
              return item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: _dataFilter4
            }, function () {
              _this11.setState({
                renderContainer: true
              });
            });
          }
        } else {

          var _listTaiLieuVanThu5 = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataFilter5 = _listTaiLieuVanThu5.filter(function (item) {
            return !item.newFile && (item.typeRequired == '' || item.typeRequired == null);
          });
          _this11.setState({
            listTaiLieuVanThu: _dataFilter5
          }, function () {
            _this11.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkFileTTXM',
    value: function checkFileTTXM() {
      var _this12 = this;

      this.setState({
        renderContainer: false
      }, function () {

        var dataFileDinhKem = [];
        var DataInit = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThu));

        if (_this12.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this12.compareDate(new Date(state.ngayTao), new Date(_this12.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this12.state.donId;
          });
        }

        if (_this12.state.trangThaiTTXM == 'GIAO_TTXM' && (_this12.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this12.props.loaiDonGiaTri == 'DON_TO_CAO' || _this12.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.required && item.typeRequired == 'XLD_GTTXM';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return (item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired || !item.newFile && item.typeRequired == 'XLD_GTTXM';
            });
            _this12.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoTTXM: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this12.trigger(_this12.state, false);
              _this12.setState({
                renderContainer: true
              });
            });
          } else {
            var newItem = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_GTTXM',
              newFile: true
            };
            if (_this12.props.loaiDonGiaTri == 'DON_TO_CAO') {
              newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo';
            } else if (_this12.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
            } else if (_this12.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh';
            }

            var _listTaiLieuVanThu6 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu), [newItem]);
            var newPDXItem = _this12.state.dataFileDinhKem.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL';
            });
            if (newPDXItem.length) {
              _listTaiLieuVanThu6 = _listTaiLieuVanThu6.map(function (item) {
                return item.typeRequired == 'XLD_PDXTL' ? newPDXItem[0] : item;
              });
            }
            _this12.setState({
              listTaiLieuVanThu: _listTaiLieuVanThu6
            }, function () {
              _this12.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu7 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu));
          var _dataFilter6 = _listTaiLieuVanThu7.filter(function (item) {
            return item.typeRequired != 'XLD_GTTXM';
          });
          _this12.setState({
            listTaiLieuVanThu: _dataFilter6
          }, function () {
            _this12.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this13 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e));
      if (typeof e.format == 'function') {
        newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'ngayRaThongBaoThuLy') {
          var newFileArr = [].concat(_toConsumableArray(_this13.state.listTaiLieuVanThu));
          newFileArr = newFileArr.map(function (item) {
            if (item.typeRequired == 'XLD_PDXTL') {
              return item = _extends({}, item, {
                ngayQuyetDinh: _this13.state.ngayRaThongBaoThuLy
              });
            } else {
              return item;
            }
          });
          _this13.setState({
            loaiVanBanSuggest: 'XLD_PDXTL',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoThuLy,
            listTaiLieuVanThu: newFileArr
          });
          _this13.getThoiHanGQDonMacDinh();
        }
        if (name == 'ngayRaThongBaoTTXM') {
          _this13.setState({
            loaiVanBanSuggest: 'XLD_GTTXM',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoTTXM
          });
          _this13.getThoiHanTTXMMacDinh();
        }
        if (name == 'hanGiaiQuyet') {
          _this13.checkHanGiaiQuyet();
        }
        _this13.trigger(newState, false);
      });
    }
  }, {
    key: 'checkHanGiaiQuyet',
    value: function checkHanGiaiQuyet() {
      var params = {
        loaiDon: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
        params.ngayBatDau = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        if (this.state.hanGiaiQuyet) {
          params.ngayKetThuc = (0, _moment2.default)(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      _api.DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {
      var params = {
        yKienXuLy: newState.noiDung
      };
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;

      if (newState.nextState) {

        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);
        params.nextState = {
          id: Number(stateId)
        };

        if (newState.form_HuongXuLy && newState.nextState == 'KET_THUC') {
          params.huongXuLy = newState.huongXuLy || null;

          if (newState.thamQuyenGiaiQuyet && newState.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' && newState.huongXuLy != 'LUU_DON_VA_THEO_DOI') params.thamQuyenGiaiQuyet = {
            id: Number(newState.thamQuyenGiaiQuyet)
          };

          if (newState.huongXuLy == 'DE_XUAT_THU_LY') {

            params.notice = _message.msg.xldChuyenGiaiQuyetDon;
            params.hanGiaiQuyet = (0, _moment2.default)(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            params.trangThaiTTXM = newState.trangThaiTTXM || null;

            if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoThuLy) {
              params.ngayRaThongBaoThuLy = (0, _moment2.default)(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }

            if (newState.trangThaiTTXM == "TU_TTXM") {

              if (newState.phongBanGiaiQuyet) params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };

              if (newState.truongPhongChiDinh) params.canBoXuLyChiDinh = { id: Number(newState.truongPhongChiDinh) };
            } else if (newState.trangThaiTTXM == "GIAO_TTXM") {

              if (newState.donViThamTraXacMinh) {
                params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
                params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
              }

              if (newState.thoiHanBaoCaoKetQuaTTXM) {
                params.thoiHanBaoCaoKetQuaTTXM = (0, _moment2.default)(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }

              if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoTTXM) {
                params.ngayRaThongBaoTTXM = (0, _moment2.default)(newState.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }
            }
          } else if (newState.huongXuLy == 'CHUYEN_DON') {
            if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
              params.notice = _message.msg.xldChuyenDon;
              params.coQuanTiepNhan = {
                id: Number(newState.coQuanTiepNhan),
                ten: newState.coQuanTiepNhanTen
              };
            } else {
              params.notice = _message.msg.xldLuuHoSo;
              params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
              params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
            }
          } else if (newState.huongXuLy == 'YEU_CAU_GAP_LANH_DAO') {

            params.notice = _message.msg.xldYeuCauGapLanhDao;
          } else if (newState.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {

            params.notice = _message.msg.xldTraDon;
          } else if (newState.huongXuLy != 'DE_XUAT_THU_LY' && newState.huongXuLy != 'CHUYEN_DON' && newState.huongXuLy != 'YEU_CAU_GAP_LANH_DAO') {

            params.notice = _message.msg.xldLuuHoSo;
          }
        } else if (newState.form_DeXuatGiaoViecLai && newState.nextState == 'DE_XUAT_GIAO_VIEC_LAI') {
          params.notice = _message.msg.xldTruongPhongGiaoViec;
        }
      }
      this.props.onChange(params, isInit);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      var temp = {
        dataFileDinhKem: data,
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      };
      this.setState(_extends({}, temp));
      this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {

      var oldData = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      var tbtlDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbtlOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbTTXMDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      var tbTTXMOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      if (tbTTXMDate.length > 0) {
        if (tbTTXMOldDate.length > 0 && (0, _moment2.default)(tbTTXMOldDate[0].ngayQuyetDinh).isSame(tbTTXMDate[0].ngayQuyetDinh) == false || tbTTXMOldDate.length == 0) {
          this.state.ngayRaThongBaoTTXM = tbTTXMDate[0].ngayQuyetDinh;
          this.getThoiHanTTXMMacDinh();
          if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' && this.state.ngayRaThongBaoTTXM) {
            this.state.ngayRaThongBaoThuLy = tbTTXMDate[0].ngayQuyetDinh;
            this.getThoiHanGQDonMacDinh();
          }
        }
      }
      if (tbtlDate.length > 0 && this.props.loaiDonGiaTri != 'DON_KIEN_NGHI_PHAN_ANH') {
        if (tbtlOldDate.length > 0 && (0, _moment2.default)(tbtlOldDate[0].ngayQuyetDinh).isSame(tbtlDate[0].ngayQuyetDinh) == false || tbtlOldDate.length == 0) {
          this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
          this.getThoiHanGQDonMacDinh();
        }
      }
      this.setState({
        dataFileDinhKem: data,
        hasFileChange: true
      });

      this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'searchDonVi',
    value: function searchDonVi(tuKhoa) {
      var inputParams = {
        size: 5,
        page: 0
      };

      inputParams.ten = tuKhoa;

      return _api.Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          return Promise.resolve({
            result: res.data._embedded.donViNgoaiHeThongs,
            page: res.data.page
          });
        } else {
          return Promise.resolve(null);
        }
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'onChangeSuggest',
    value: function onChangeSuggest(name, value) {
      this.state[name] = value;
      this.state.donViNgoaiHeThongId = '';
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'onSelectedSuggest',
    value: function onSelectedSuggest(item) {
      this.state.donViNgoaiHeThong = item.ten;
      this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      var lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb0-18', ref: 'huongXL' },
        _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChange, open: this.state.popupConfirmHXL, onClose: this.confirmChangeHuongXuLy.bind(this, false), onSuccess: this.confirmChangeHuongXuLy.bind(this, true) }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.form_HuongXuLy },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mt10' },
            _react2.default.createElement(_ttForms.DropDownChonHuongXuLyTheoDon, { require: true,
              selectedValue: this.state.huongXuLy,
              donId: this.props.donId,
              loaiDon: this.props.loaiDonGiaTri,
              label: 'H\u01B0\u1EDBng x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'huongXuLy'),
              className: 'col-3',
              bindValidator: this,
              name: 'dropdownChonHuongXuLyTheoDon' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy !== 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy !== 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' },
              _react2.default.createElement(_ttForms.DropDownChonNhomThamQuyenGiaiQuyet, { require: true,
                selectedValue: this.state.thamQuyenGiaiQuyet,
                filterThamQuyenGiaiQuyet: this.state.huongXuLy === 'CHUYEN_DON',
                label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt',
                className: 'col-3',
                onChange: this.handleChange.bind(this, 'thamQuyenGiaiQuyet'),
                bindValidator: this,
                name: 'dropdownChonNhomThamQuyenGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  endDate: new Date(),
                  value: this.state.ngayRaThongBaoThuLy,
                  label: 'Ng\xE0y ra th\xF4ng b\xE1o th\u1EE5 l\xFD',
                  name: 'ngayRaThongBaoThuLy',
                  onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy'),
                  bindValidator: this,
                  channel: 'formTaoDon' })
              ),
              _react2.default.createElement(_common.DatePicker, { require: true,
                className: 'col-25',
                value: this.state.hanGiaiQuyet,
                label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
                name: 'hanGiaiQuyet',
                startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                onChange: this.handleChangeDate.bind(this, 'hanGiaiQuyet'),
                bindValidator: this,
                channel: 'formTaoDon' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == 'CHUYEN_DON' && this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId },
              _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: 'C\u01A1 quan ti\u1EBFp nh\u1EADn', className: 'tree-selected', placeholder: true, dataOptions: this.props.coQuanTiepNhanList, value: this.state.coQuanTiepNhan, onChange: this.handleChange.bind(this, 'coQuanTiepNhan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', name: 'dropdownChonCoQuanTiepNhan', bindValidator: this, channel: 'formTaoDon', require: true })
            ),
            this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ? _react2.default.createElement(_autoComplete.AutoSuggest, {
              label: '\u0110\u01A1n v\u1ECB',
              className: 'col-3 mb18',
              placeholder: 'Nh\u1EADp...',
              onSearch: this.searchDonVi,
              onChange: this.onChangeSuggest.bind(this, 'donViNgoaiHeThong'),
              onSelected: this.onSelectedSuggest.bind(this),
              value: this.state.donViNgoaiHeThong,
              maxLength: 40
            }) : ''
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_ttForms.DropDownChonQuyTrinhGiaiQuyetDon, {
                className: 'col-25',
                donId: this.props.donId,
                bindValidator: this,
                require: true,
                loaiDon: this.props.loaiDonGiaTri,
                isValid: this.props.validate,
                selectedValue: this.state.trangThaiTTXM,
                onChange: this.handleChange.bind(this, 'trangThaiTTXM'),
                name: 'dropdownChonTrangThaiTTXM' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.trangThaiTTXM == 'GIAO_TTXM' },
                _react2.default.createElement(_ttForms.DropDownChonDonViTTXM, {
                  className: 'col-25',
                  bindValidator: this,
                  require: true,
                  loaiDon: this.props.loaiDonGiaTri,
                  isValid: this.props.validate,
                  selectedValue: this.state.donViThamTraXacMinh,
                  onChange: this.handleChange.bind(this, 'donViThamTraXacMinh'),
                  name: 'dropdownChonDonViTTXM' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                  _react2.default.createElement(_common.DatePicker, { require: true,
                    className: 'col-25',
                    endDate: new Date(),
                    value: this.state.ngayRaThongBaoTTXM,
                    label: 'Ngày ra QĐ giao nhiệm vụ ' + lb1,
                    name: 'ngayRaThongBaoTTXM',
                    onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
                    bindValidator: this,
                    channel: 'formTaoDon' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title mb0' },
                      'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content pt17 txt-danger' },
                      this.state.thoiHanBaoCaoKetQuaTTXM
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              require: this.state.requireText,
              label: this.state.lblTextArea,
              rows: '3',
              value: this.state.noiDung ? this.state.noiDung : '',
              onChange: this.handleChange.bind(this, 'noiDung'),
              bindValidator: this,
              channel: 'formTaoDon',
              name: 'textareaYKienCanBoXuLyDon' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_InPhieu2.default, { inPhieu: this.props.inPhieu.bind(this),
              huongXuLy: this.state.huongXuLy,
              loaiDonGiaTri: this.props.loaiDonGiaTri,
              trangThaiTTXM: this.state.trangThaiTTXM || null })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.renderContainer },
            _react2.default.createElement(
              'div',
              { className: 'container-filedinhkem mt15' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                data: this.state.listTaiLieuVanThu,
                dataShow: this.state.dataShow,
                onSave: this.props.onSave,
                loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          )
        )
      );
    }
  }]);

  return HuongXuLy;
}(_react2.default.Component);

HuongXuLy.defaultProps = {
  listNextStates: [],
  coQuanTiepNhanList: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(HuongXuLy));

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _processType = __webpack_require__(57);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HuongXuLyView = function (_React$Component) {
  _inherits(HuongXuLyView, _React$Component);

  function HuongXuLyView() {
    _classCallCheck(this, HuongXuLyView);

    return _possibleConstructorReturn(this, (HuongXuLyView.__proto__ || Object.getPrototypeOf(HuongXuLyView)).apply(this, arguments));
  }

  _createClass(HuongXuLyView, [{
    key: 'render',
    value: function render() {
      var lblTextArea = 'Ý kiến xử lý';
      var dataTaiLieu = this.props.listTaiLieuVanThu;
      if (this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.huongXuLy) {
        if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy) {
          lblTextArea = 'Ý kiến xử lý';
        } else if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi) {
          lblTextArea = 'Lý do lưu đơn';
        } else if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo) {
          lblTextArea = 'Lý do';
        } else {
          lblTextArea = 'Ý kiến xử lý';
        }
      }
      if ((0, _lodash.isArray)(dataTaiLieu) && dataTaiLieu.length > 0) {
        dataTaiLieu = dataTaiLieu.filter(function (item) {
          return item.buocGiaiQuyet !== 'BO_SUNG_SAU_KHI_CHUYEN_DON_LUU_HO_SO';
        });
      }
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb5' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, {
            className: 'col-input',
            label: 'H\u01B0\u1EDBng x\u1EED l\xFD:',
            value: this.props.thongTinXuLyGiaiQuyet.huongXuLy === null ? this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : this.props.thongTinXuLyGiaiQuyet.huongXuLy && this.props.thongTinXuLyGiaiQuyet.huongXuLy.ten || '' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy != null && this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao && this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri != _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt:',
              value: this.props.thongTinXuLyGiaiQuyet.thamQuyenGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thamQuyenGiaiQuyet.ten : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy === null && this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy !== '' },
            _react2.default.createElement(
              'div',
              { className: 'col-input' },
              _react2.default.createElement(
                'label',
                { className: 'pt-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'val-title-bold' },
                  'Ph\xF2ng ban ti\u1EBFp nh\u1EADn:'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'val-content' },
                  this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh && this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten ? this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten : ''
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy != null && this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt:',
              red: true,
              value: this.props.thongTinXuLyGiaiQuyet.hanGiaiQuyet ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.hanGiaiQuyet).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy != null && this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.chuyenDon },
            _react2.default.createElement(
              'div',
              { className: 'col-input' },
              _react2.default.createElement(
                'label',
                { className: 'pt-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'val-title-bold' },
                  'C\u01A1 quan ti\u1EBFp nh\u1EADn:'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'val-content' },
                  this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan && this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan.id ? this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan.ten : this.props.thongTinXuLyGiaiQuyet.donViNgoaiHeThong ? this.props.thongTinXuLyGiaiQuyet.donViNgoaiHeThong.ten : ''
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy != null && this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao },
            _react2.default.createElement(
              'div',
              { className: 'col-input' },
              _react2.default.createElement(
                'label',
                { className: 'pt-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'val-title-bold' },
                  'Ng\xE0y h\u1EB9n:'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'val-content' },
                  this.props.thongTinXuLyGiaiQuyet.ngayHenGapLanhDao ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.ngayHenGapLanhDao).format('DD/MM/YYYY') : ''
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-input' },
              _react2.default.createElement(
                'label',
                { className: 'pt-label' },
                _react2.default.createElement(
                  'span',
                  { className: 'val-title-bold' },
                  '\u0110\u1ECBa \u0111i\u1EC3m:'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'val-content' },
                  this.props.thongTinXuLyGiaiQuyet.diaDiem ? this.props.thongTinXuLyGiaiQuyet.diaDiem : ''
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.thongTinXuLyGiaiQuyet.huongXuLy != null && this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null && (this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'TU_TTXM' || this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'GIAO_TTXM') },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'Quy tr\xECnh gi\u1EA3i quy\u1EBFt:',
              value: this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null ? this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.ten : '' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null && this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'TU_TTXM' },
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                label: 'Ph\xF2ng ban gi\u1EA3i quy\u1EBFt:',
                value: this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyet.ten : '' }),
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                label: 'C\xF4ng ch\u1EE9c gi\u1EA3i quy\u1EBFt:',
                value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null && this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'GIAO_TTXM' },
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                label: "Đơn vị " + lb1 + ":",
                value: this.props.thongTinXuLyGiaiQuyet.donViThamTraXacMinh ? this.props.thongTinXuLyGiaiQuyet.donViThamTraXacMinh.ten : '' }),
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                red: true,
                label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:',
                value: this.props.thongTinXuLyGiaiQuyet.thoiHanBaoCaoKetQuaTTXM ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 mt15' },
          _react2.default.createElement(_common.TextMessage, {
            className: 'col-12',
            value: this.props.thongTinXuLyGiaiQuyet.yKienXuLy || '',
            label: lblTextArea })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, bindValidator: this, dataShow: dataTaiLieu })
        )
      );
    }
  }]);

  return HuongXuLyView;
}(_react2.default.Component);

exports.default = HuongXuLyView;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _reactRedux = __webpack_require__(6);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _InPhieu = __webpack_require__(235);

var _InPhieu2 = _interopRequireDefault(_InPhieu);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _processType = __webpack_require__(57);

var _autoComplete = __webpack_require__(190);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'XU_LY_DON';
var Promise = __webpack_require__(136).Promise;
// Du lieu huong xu ly
var process = [_processType.processType.xuLyDon.processing.ketThuc];

var KhongCoQuyTrinh = function (_React$Component) {
  _inherits(KhongCoQuyTrinh, _React$Component);

  function KhongCoQuyTrinh(props, context) {
    _classCallCheck(this, KhongCoQuyTrinh);

    var _this = _possibleConstructorReturn(this, (KhongCoQuyTrinh.__proto__ || Object.getPrototypeOf(KhongCoQuyTrinh)).call(this, props, context));

    _this.state = {
      form_HuongXuLy: false,
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},

      renderContainer: true,

      // get LOAI DON theo them moi hay chinh sua
      requireText: false,
      lblTextArea: 'Ý kiến xử lý',

      donId: _this.props.donId,
      loaiDon: _this.props.thongTinDon && _this.props.thongTinDon.loaiDonId ? _this.props.thongTinDon.loaiDonId : '',
      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,
      hanGiaiQuyetChange: false,

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',
      noiDung: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: _this.props.userInfo.coQuanQuanLyId,

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      canBoChiDinh: _this.props.userInfo.id,

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataDonViTTXM: [],
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: '',
      ngayRaThongBaoThuLy: ''
    };
    return _this;
  }

  _createClass(KhongCoQuyTrinh, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.huongXuLy != prevState.huongXuLy) {

        switch (this.state.huongXuLy) {

          case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:

            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

            this.setState({
              lblTextArea: 'Lý do lưu đơn',
              requireText: true
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
            this.setState({
              lblTextArea: 'Lý do',
              requireText: true
            });
            return;
          default:
            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
      this.getListDocument();
    }

    // Add component Util

  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this2 = this;

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this2.state.donId;
      });

      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this3 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {
        if (_this3.props.getState(_this3.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.ketThuc:
              _this3.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_HuongXuLy: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.donId != 0) {
        this.getThongTinXuLy(this.state.donId);
        this.onlyOneState();
      } else {
        this.getThoiHanGQDonMacDinh();
        this.getThoiHanTTXMMacDinh();
        this.onlyOneState();
      }
      this.getDonViTTXM();
    }
  }, {
    key: 'getDonViTTXM',
    value: function getDonViTTXM() {
      var _this4 = this;

      var params = {
        loaiDon: this.state.loaiDon ? this.state.loaiDon : null
      };
      _api.DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dataDonViTTXM: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this5 = this;

      var params = {
        type: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : this.state.loaiDon
      };
      if ((params.type == 'DON_KHIEU_NAI' || params.type == 'DON_TO_CAO' || params.type == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
        params.ngayRaThongBaoGiaiQuyet = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(function (res) {
        _this5.setState({
          hanGiaiQuyet: new Date(res.data)
        }, function () {
          var newState = _extends({}, _this5.state);
          _this5.trigger(newState, true);
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this6 = this;

      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, { type: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : this.state.loaiDon }).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this6.setState({
          thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
        }, function () {
          _this6.trigger(_this6.state, false);
        });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this7 = this;

      if (nextProps.thongTinDon && nextProps.thongTinDon.loaiDonId && this.state.loaiDon != nextProps.thongTinDon.loaiDonId) {
        this.setState({
          loaiDon: nextProps.thongTinDon.loaiDonId
        }, function () {
          _this7.checkFileHuongXuLy();
          _this7.getThoiHanGQDonMacDinh();
          _this7.getThoiHanTTXMMacDinh();
          _this7.getDonViTTXM();
        });
      }
      if (this.props.loaiDonGiaTri != nextProps.loaiDonGiaTri) {
        this.setState({
          huongXuLy: ''
        });
      }
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this8 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {

        _this8.setState({
          loaiDon: _this8.props.loaiDonGiaTri
        });

        if (res.data) {
          var info = res.data.thongTinXuLyInfo;
          // Xac dinh co luu du lieu hay chua
          if (info.hanGiaiQuyet == null) {
            _this8.getThoiHanGQDonMacDinh();
          }
          if (info.thoiHanBaoCaoKetQuaTTXM == null) {
            _this8.getThoiHanTTXMMacDinh();
          }
          if (info.nextState == null) {
            _this8.getThoiHanGQDonMacDinh();
            _this8.getThoiHanTTXMMacDinh();
            _this8.trigger(_this8.state, true);
          } else {

            var newState = _extends({}, _this8.state, {
              noiDung: info.yKienXuLy,
              huongXuLy: info.huongXuLy ? info.huongXuLy.giaTri : '',
              thamQuyenGiaiQuyet: info.thamQuyenGiaiQuyet.id,
              phongBanGiaiQuyet: info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '',
              coQuanTiepNhan: info.coQuanTiepNhan ? info.coQuanTiepNhan.id : null,
              coQuanTiepNhanTen: info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '',
              nextState: info.nextState ? info.nextState.type : '',
              truongPhongChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
              trangThaiTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.mapTrangThaiTTXM ? info.mapTrangThaiTTXM.enum : '',
              hanGiaiQuyet: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.hanGiaiQuyet ? (0, _moment2.default)(info.hanGiaiQuyet).format('DD/MM/YYYY') : '',
              donViThamTraXacMinh: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.id : '',
              donViThamTraXacMinhTen: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.ten : '',
              thoiHanBaoCaoKetQuaTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? (0, _moment2.default)(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '',
              donViNgoaiHeThong: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten : '',
              donViNgoaiHeThongId: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : ''
            });

            _this8.setState(_extends({}, newState), function () {
              _this8.checkFileHuongXuLy();
            });

            _this8.trigger(newState, true);
          }
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this9 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      var index = name === 'coQuanTiepNhan' ? 0 : e.nativeEvent.target.selectedIndex;

      if (name === 'huongXuLy') {
        if (e.target.value === 'DE_XUAT_THU_LY') {
          if (this.state.dataDonViTTXM.length == 0) {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: 'TU_TTXM'
            });
          } else {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: ''
            });
          }
        } else {
          newState = _extends({}, newState, {
            noiDung: '',
            thamQuyenGiaiQuyet: '',
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          });
        }
        if (this.state.hasFileChange) {
          this.state.prepareData = newState;
          this.state.popupConfirmHXL = true;
          this.setState(_extends({}, this.state));
          return;
        }
      }

      if (name == 'hanGiaiQuyet') {
        this.setState({
          hanGiaiQuyetChange: true
        });
      }

      if (name == 'donViThamTraXacMinh') {
        newState = _extends({}, newState, {
          donViThamTraXacMinhTen: e.nativeEvent.target[index].text
        });
      }

      if (name == 'phongBanGiaiQuyet') {
        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
      }

      if (name == 'coQuanTiepNhan') {
        newState = _extends({}, newState, {
          coQuanTiepNhanTen: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
        this.props.coQuanTiepNhanList.map(function (item) {
          if (item.coQuanQuanLyId == e.target.value) {
            newState.coQuanTiepNhanTen = item.ten;
          }
        });
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'huongXuLy') {
          _this9.checkFileHuongXuLy();
        }
        if (name == 'trangThaiTTXM') {
          _this9.checkFileTTXM();
        }
        _this9.trigger(newState, false);
      });
    }
  }, {
    key: 'confirmChangeHuongXuLy',
    value: function confirmChangeHuongXuLy(next) {
      var _this10 = this;

      if (next) {
        this.setState(_extends({}, this.state.prepareData, {
          hasFileChange: false
        }), function () {
          _this10.checkFileHuongXuLy();
          _this10.trigger(_this10.state.prepareData, false);
        });
      } else {
        this.state.popupConfirmHXL = false;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkFileHuongXuLy',
    value: function checkFileHuongXuLy() {
      var _this11 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var DataInit = [].concat(_toConsumableArray(_this11.props.listTaiLieuVanThu));
        var dataFileDinhKem = [];
        var dataShow = [];
        if (_this11.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else if (_this11.props.ngayNhanDon) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayNhanDon), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayNhanDon), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this11.state.donId;
          });
        }

        var typeRequired = '';
        var name = '';
        if (_this11.state.huongXuLy == 'DE_XUAT_THU_LY') {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.typeRequired == 'XLD_PDXTL';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this11.trigger(_this11.state, false);
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else if (_this11.state.loaiDon == 'DON_KHIEU_NAI' || _this11.state.loaiDon == 'DON_TO_CAO') {
            var ItemDTTL = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            if (_this11.state.loaiDon == 'DON_TO_CAO') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
            } else if (_this11.state.loaiDon == 'DON_KHIEU_NAI') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
            }
            var _listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem), [ItemDTTL]);
            var _dataFilter = _listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var ItemTL = {
              ten: 'Phiếu đề xuất thụ lý',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: 'XLD_PDXTL',
              newFile: true,
              resetRequired: true,
              checkValid: true
            };
            var _listTaiLieuVanThu2 = [
            // ...dataFileDinhKem,
            ItemTL];
            var _dataFilter2 = _listTaiLieuVanThu2.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter2
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          }
        } else if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (_this11.state.loaiDon == 'DON_KHIEU_NAI' || _this11.state.loaiDon == 'DON_TO_CAO' || _this11.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') || _this11.state.huongXuLy == 'CHUYEN_DON' || _this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (_this11.state.loaiDon == 'DON_TO_CAO' || _this11.state.loaiDon == 'DON_KHIEU_NAI') || _this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && _this11.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (_this11.state.loaiDon == 'DON_TO_CAO' || _this11.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && _this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
          if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY') {
            typeRequired = 'XLD_KDDKTL';
            if (_this11.state.loaiDon == 'DON_TO_CAO') {
              name = 'Thông báo về việc không thụ lý giải quyết tố cáo';
            } else if (_this11.state.loaiDon == 'DON_KHIEU_NAI') {
              name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết ';
            } else if (_this11.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh';
            }
          } else if (_this11.state.huongXuLy == 'CHUYEN_DON') {
            typeRequired = 'XLD_CD';
            if (_this11.state.loaiDon == 'DON_TO_CAO') {
              name = 'Văn bản về việc chuyển đơn tố cáo';
            } else if (_this11.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh';
            } else {
              name = 'Văn bản chuyển đơn';
            }
          } else if (_this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
            typeRequired = 'XLD_TDHD';
            if (_this11.state.loaiDon == 'DON_TO_CAO') {
              name = 'Văn bản về việc hướng dẫn người tố cáo';
            } else if (_this11.state.loaiDon == 'DON_KHIEU_NAI') {
              name = 'Văn bản về việc hướng dẫn người khiếu nại';
            }
          } else if (_this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
            typeRequired = 'XLD_TDHD';
            if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết';
            }
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
            typeRequired = 'XLD_TDKDTQ';
            name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
            typeRequired = 'XLD_TDKDTQLD';
            name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
          }
          var _data = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataExist = _data.filter(function (item) {
            return item.required && item.typeRequired == typeRequired;
          });
          if (_dataExist.length > 0 && _this11.state.huongXuLy !== 'CHUYEN_DON') {
            var _listTaiLieuVanThu3 = [].concat(_toConsumableArray(dataFileDinhKem));
            var _dataFilter3 = _listTaiLieuVanThu3.filter(function (item) {
              return item.newFile && item.typeRequired == typeRequired || !item.newFile && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: _dataFilter3
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var newItem = {
              ten: name,
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: typeRequired,
              newFile: true
            };
            var _listTaiLieuVanThu4 = [].concat(_toConsumableArray(dataFileDinhKem), [newItem]);
            var _dataFilter4 = [];
            if (_this11.state.huongXuLy === 'CHUYEN_DON') {
              _dataFilter4 = [newItem];
            } else {
              _dataFilter4 = _listTaiLieuVanThu4.filter(function (item) {
                return item.newFile && item.typeRequired == typeRequired || !item.newFile && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
              });
            }
            _this11.setState({
              listTaiLieuVanThu: _dataFilter4
            }, function () {
              _this11.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu5 = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataFilter5 = _listTaiLieuVanThu5.filter(function (item) {
            return !item.newFile && (item.typeRequired == '' || item.typeRequired == null);
          });
          _this11.setState({
            listTaiLieuVanThu: _dataFilter5
          }, function () {
            _this11.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'checkFileTTXM',
    value: function checkFileTTXM() {
      var _this12 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var dataFileDinhKem = _this12.props.listTaiLieuVanThu.filter(function (item) {
          return item.donId == _this12.state.donId;
        });
        if (_this12.state.trangThaiTTXM == 'GIAO_TTXM' && (_this12.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this12.props.loaiDonGiaTri == 'DON_TO_CAO' || _this12.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.required && item.typeRequired == 'XLD_GTTXM';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired || !item.newFile && item.typeRequired == 'XLD_GTTXM';
            });
            _this12.setState({
              listTaiLieuVanThu: dataFilter
            }, function () {
              _this12.setState({
                renderContainer: true
              });
            });
          } else {
            var newItem = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_GTTXM',
              newFile: true
            };
            if (_this12.state.loaiDonGiaTri == 'DON_TO_CAO') {
              newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo';
            } else if (_this12.state.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
            } else if (_this12.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh';
            }
            var _listTaiLieuVanThu6 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu), [newItem]);
            var newPDXItem = _this12.state.dataFileDinhKem.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL';
            });
            if (newPDXItem.length) {
              _listTaiLieuVanThu6 = _listTaiLieuVanThu6.map(function (item) {
                return item.typeRequired == 'XLD_PDXTL' ? newPDXItem[0] : item;
              });
            }
            _this12.setState({
              listTaiLieuVanThu: _listTaiLieuVanThu6
            }, function () {
              _this12.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu7 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu));
          var _dataFilter6 = _listTaiLieuVanThu7.filter(function (item) {
            return item.typeRequired != 'XLD_GTTXM';
          });
          _this12.setState({
            listTaiLieuVanThu: _dataFilter6
          }, function () {
            _this12.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'checkHanGiaiQuyet',
    value: function checkHanGiaiQuyet() {
      var params = {
        loaiDon: this.state.loaiDon
      };
      if ((this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
        params.ngayBatDau = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        if (this.state.hanGiaiQuyet) {
          params.ngayKetThuc = (0, _moment2.default)(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      _api.DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this13 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e));
      if (typeof e.format == 'function') {
        newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'ngayRaThongBaoThuLy') {
          var newFileArr = [].concat(_toConsumableArray(_this13.state.listTaiLieuVanThu));
          newFileArr = newFileArr.map(function (item) {
            if (item.typeRequired == 'XLD_PDXTL') {
              return item = _extends({}, item, {
                ngayQuyetDinh: _this13.state.ngayRaThongBaoThuLy
              });
            } else {
              return item;
            }
          });
          _this13.setState({
            loaiVanBanSuggest: 'XLD_PDXTL',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoThuLy,
            listTaiLieuVanThu: newFileArr
          });
          _this13.getThoiHanGQDonMacDinh();
        }

        if (name == 'hanGiaiQuyet') {
          _this13.checkHanGiaiQuyet();
        }
        _this13.trigger(newState, false);
      });
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {

      var stateId = this.props.getState(this.props.listNextStates, newState.nextState);
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      var params = {
        yKienXuLy: newState.noiDung,
        nextState: {
          id: Number(stateId)
        }
      };

      params.huongXuLy = newState.huongXuLy || null;

      if (newState.thamQuyenGiaiQuyet && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi) params.thamQuyenGiaiQuyet = {
        id: Number(newState.thamQuyenGiaiQuyet)
      };

      if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy) {

        params.notice = _message.msg.xldChuyenGiaiQuyetDon;

        if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO') && newState.ngayRaThongBaoThuLy) {
          params.ngayRaThongBaoThuLy = (0, _moment2.default)(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.hanGiaiQuyetChange) {
          params.hanGiaiQuyet = (0, _moment2.default)(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours');
        } else {
          params.hanGiaiQuyet = (0, _moment2.default)(newState.hanGiaiQuyet, 'DD/MM/YYYY');
        }
        params.trangThaiTTXM = newState.trangThaiTTXM || null;

        if (newState.trangThaiTTXM == "TU_TTXM") {

          if (newState.phongBanGiaiQuyet) params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };
          var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

          params.canBoXuLyChiDinh = { id: Number(userInfo.id) };
        } else if (newState.trangThaiTTXM == "GIAO_TTXM") {

          if (newState.donViThamTraXacMinh) {

            params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
            params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
          }

          if (newState.thoiHanBaoCaoKetQuaTTXM) params.thoiHanBaoCaoKetQuaTTXM = (0, _moment2.default)(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY');
        }
      } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.chuyenDon) {

        if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
          params.notice = _message.msg.xldChuyenDon;
          params.coQuanTiepNhan = {
            id: Number(newState.coQuanTiepNhan),
            ten: newState.coQuanTiepNhanTen
          };
        } else {
          params.notice = _message.msg.xldLuuHoSo;
          params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
          params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
        }
      } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

        params.notice = _message.msg.xldYeuCauGapLanhDao;
      } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen) {

        params.notice = _message.msg.xldTraDon;
      } else if (newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.chuyenDon && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

        params.notice = _message.msg.xldLuuHoSo;
      }

      this.props.onChange(params, isInit);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {

      var temp = {
        dataFileDinhKem: data,
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      };

      this.setState(_extends({}, temp));

      this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      var tbtlDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      if (tbtlDate.length) {
        this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
        this.getThoiHanGQDonMacDinh();
      }
      this.setState({
        dataFileDinhKem: data
      });

      this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'searchDonVi',
    value: function searchDonVi(tuKhoa) {
      var inputParams = {
        size: 5,
        page: 0
      };

      inputParams.ten = tuKhoa;

      return _api.Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          return Promise.resolve({
            result: res.data._embedded.donViNgoaiHeThongs,
            page: res.data.page
          });
        } else {
          return Promise.resolve(null);
        }
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'onChangeSuggest',
    value: function onChangeSuggest(name, value) {
      this.state[name] = value;
      this.state.donViNgoaiHeThongId = '';
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'onSelectedSuggest',
    value: function onSelectedSuggest(item) {
      this.state.donViNgoaiHeThong = item.ten;
      this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChange, open: this.state.popupConfirmHXL, onClose: this.confirmChangeHuongXuLy.bind(this, false), onSuccess: this.confirmChangeHuongXuLy.bind(this, true) }),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_ttForms.DropDownChonHuongXuLyTheoDon, { require: true,
            selectedValue: this.state.huongXuLy,
            donId: this.props.donId,
            loaiDon: this.props.loaiDonGiaTri,
            label: 'H\u01B0\u1EDBng x\u1EED l\xFD',
            onChange: this.handleChange.bind(this, 'huongXuLy'),
            className: 'col-3',
            bindValidator: this,
            name: 'dropdownChonHuongXuLyTheoDon' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy !== 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy !== 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' },
            _react2.default.createElement(_ttForms.DropDownChonNhomThamQuyenGiaiQuyet, { require: true,
              selectedValue: this.state.thamQuyenGiaiQuyet,
              checkValidate: this.props.checkValidate,
              filterThamQuyenGiaiQuyet: this.state.huongXuLy === 'CHUYEN_DON',
              label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt',
              className: 'col-3',
              onChange: this.handleChange.bind(this, 'thamQuyenGiaiQuyet'),
              bindValidator: this,
              name: 'dropdownChonNhomThamQuyenGiaiQuyet' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
              _react2.default.createElement(_common.DatePicker, { require: true,
                className: 'col-25',
                checkValidate: this.props.checkValidate,
                value: this.state.ngayRaThongBaoThuLy,
                label: 'Ng\xE0y ra th\xF4ng b\xE1o th\u1EE5 l\xFD',
                name: 'ngayRaThongBaoThuLy',
                onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy'),
                bindValidator: this,
                channel: 'formTaoDon' })
            ),
            _react2.default.createElement(_common.DatePicker, { require: true,
              className: 'col-25',
              value: this.state.hanGiaiQuyet,
              label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
              name: 'hanGiaiQuyet',
              startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
              onChange: this.handleChangeDate.bind(this, 'hanGiaiQuyet'),
              bindValidator: this,
              channel: 'formTaoDon' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy == 'CHUYEN_DON' && this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId },
            _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: 'C\u01A1 quan ti\u1EBFp nh\u1EADn', className: 'tree-selected', placeholder: true, dataOptions: this.props.coQuanTiepNhanList, value: this.state.coQuanTiepNhan, onChange: this.handleChange.bind(this, 'coQuanTiepNhan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', name: 'dropdownChonCoQuanTiepNhan', bindValidator: this, channel: 'formTaoDon', require: true })
          ),
          this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ? _react2.default.createElement(_autoComplete.AutoSuggest, {
            label: '\u0110\u01A1n v\u1ECB',
            className: 'col-3',
            placeholder: 'Nh\u1EADp...',
            onSearch: this.searchDonVi,
            onChange: this.onChangeSuggest.bind(this, 'donViNgoaiHeThong'),
            onSelected: this.onSelectedSuggest.bind(this),
            value: this.state.donViNgoaiHeThong,
            maxLength: 40
          }) : ''
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0 },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_ttForms.DropDownChonQuyTrinhGiaiQuyetDon, {
              className: 'col-25',
              donId: this.props.donId,
              bindValidator: this,
              require: true,
              loaiDon: this.props.loaiDonGiaTri,
              isValid: this.props.validate,
              selectedValue: this.state.trangThaiTTXM,
              onChange: this.handleChange.bind(this, 'trangThaiTTXM'),
              name: 'dropdownChonTrangThaiTTXM' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.trangThaiTTXM == 'GIAO_TTXM' },
              _react2.default.createElement(_ttForms.DropDownChonDonViTTXM, {
                className: 'col-25',
                bindValidator: this,
                require: true,
                loaiDon: this.props.loaiDonGiaTri,
                isValid: this.props.validate,
                selectedValue: this.state.donViThamTraXacMinh,
                onChange: this.handleChange.bind(this, 'donViThamTraXacMinh'),
                name: 'dropdownChonDonViTTXM' }),
              _react2.default.createElement(
                'div',
                { className: 'col-25' },
                _react2.default.createElement(
                  'label',
                  { className: 'pt-label' },
                  _react2.default.createElement(
                    'span',
                    { className: 'val-title mb0' },
                    'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'val-content pt17 txt-danger' },
                    this.state.thoiHanBaoCaoKetQuaTTXM
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, {
            require: this.state.requireText,
            label: this.state.lblTextArea,
            rows: '3',
            value: this.state.noiDung ? this.state.noiDung : '',
            onChange: this.handleChange.bind(this, 'noiDung'),
            bindValidator: this,
            channel: 'formTaoDon',
            name: 'textareaYKienCanBoXuLyDon' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.action === undefined || this.props.action === "them-moi" && this.state.huongXuLy !== "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON" },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_InPhieu2.default, { inPhieu: this.props.inPhieu.bind(this),
              huongXuLy: this.state.huongXuLy,
              loaiDonGiaTri: this.state.loaiDon,
              trangThaiTTXM: this.state.trangThaiTTXM || null })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.renderContainer },
          _react2.default.createElement(
            'div',
            { className: 'container-filedinhkem mt15' },
            _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
              checkValidate: this.props.checkValidate,
              bindValidator: this,
              data: this.state.listTaiLieuVanThu,
              dataShow: this.state.dataShow,
              onSave: this.props.onSave,
              loaiVanBanSuggest: this.state.loaiVanBanSuggest,
              ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest,
              onFileRemove: this.onFileRemove.bind(this),
              onFileChange: this.onFileChange.bind(this)
            })
          )
        )
      );
    }
  }]);

  return KhongCoQuyTrinh;
}(_react2.default.Component);

KhongCoQuyTrinh.defaultProps = {
  listNextStates: [],
  tongSoLuotTCD: 0,
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(KhongCoQuyTrinh));

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _processType = __webpack_require__(57);

var _message = __webpack_require__(10);

var _upload = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = [_processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

var LanhDaoGiaoViec = function (_React$Component) {
  _inherits(LanhDaoGiaoViec, _React$Component);

  function LanhDaoGiaoViec(props, context) {
    _classCallCheck(this, LanhDaoGiaoViec);

    var _this = _possibleConstructorReturn(this, (LanhDaoGiaoViec.__proto__ || Object.getPrototypeOf(LanhDaoGiaoViec)).call(this, props, context));

    _this.state = {
      form_GiaoViecTruongPhong: false,
      form_GiaoViecCanBo: false,
      donId: _this.props.donId,
      numberState: 0,
      onlyState: '',
      nextState: '',
      hideDropdown: false,
      thoiHanXuLy: new Date(),
      noiDung: '',
      phongBanChiDinh: '',
      truongPhongChiDinh: '',
      canBoChiDinh: '',
      dataShow: []
    };
    return _this;
  }

  _createClass(LanhDaoGiaoViec, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';

      process.map(function (item, i) {

        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecTruongPhong: true
              });
              break;

            case _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_GiaoViecCanBo: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this3 = this;

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this3.state.donId;
      });
      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.onlyOneState();
      if (this.state.donId == 0) {
        this.getThoiHanXuLyMacDinh();
      } else {
        this.getThongTinXuLy(this.state.donId);
      }
      this.getListDocument();
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {

      if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });
        this.setState(_extends({}, newState), this.trigger(newState, true));
      }
    }
  }, {
    key: 'getThoiHanXuLyMacDinh',
    value: function getThoiHanXuLyMacDinh() {
      var _this4 = this;

      _api.DuLieuHeThong.actions.getThoiHanXuLyMacDinh.request(null, { type: this.props.loaiDonGiaTri }).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this4.setState({
          thoiHanXuLy: thoiHanXuLyMacDinh
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this5 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          var info = res.data.thongTinXuLyInfo;
          var newState = _extends({}, _this5.state);
          newState.thoiHanXuLy = info.thoiHanXuLy ? (0, _moment2.default)(info.thoiHanXuLy).format('DD/MM/YYYY') : '';
          newState.nextState = info.nextState ? info.nextState.type : '';
          newState.phongBanChiDinh = info.phongBanXuLyChiDinh ? info.phongBanXuLyChiDinh.id : '';
          newState.noiDung = info.yKienXuLy;
          // newState.truongPhongChiDinh = info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ? info.canBoXuLyChiDinh.id : '';
          newState.canBoChiDinh = info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' ? info.canBoXuLyChiDinh.id : '';

          _this5.setState(_extends({}, newState));

          _this5.trigger(newState, true);
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      if (name == 'nextState') {

        newState.noiDung = '';
        if (this.state.donId == 0) {
          newState = _extends({}, newState, {
            phongBanChiDinh: '',
            truongPhongChiDinh: '',
            canBoChiDinh: ''
          });
        }
      } else if (name == 'phongBanChiDinh') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        });
      }

      this.setState(_extends({}, newState), this.trigger(newState, false));
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {

      if (typeof e.format == 'function') {
        var newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));

        this.setState(_extends({}, newState), this.trigger(newState));
      } else {

        var _newState = _extends({}, this.state, _defineProperty({}, name, e));

        this.setState(_extends({}, _newState), this.trigger(_newState));
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {
      var params = {
        thoiHanXuLy: (0, _moment2.default)(newState.thoiHanXuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        noiDungYeuCauXuLy: newState.noiDung
      };

      if (newState.nextState) {
        var stateId = this.props.getState(this.props.listNextStates, newState.nextState);
        params.nextState = {
          id: Number(stateId),
          type: newState.nextState
        };
        if (newState.phongBanChiDinh) {
          params.phongBanXuLyChiDinh = {
            id: Number(newState.phongBanChiDinh)
          };
        }
        // Them param theo dieu kien huong xu ly
        if (newState.form_GiaoViecTruongPhong && newState.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong) {
          params.notice = _message.msg.xldLanhDaoGiaoViec;
          if (newState.truongPhongChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.truongPhongChiDinh)
            };
          }
        } else if (newState.form_GiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien) {
          params.notice = _message.msg.xldLanhDaoGiaoViec;
          if (newState.canBoChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        }
      }
      this.props.onChange(params, isInit);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'row pr10 pl10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.hideDropdown },
            _react2.default.createElement(_ttForms.DropDownChonStateXuLyDon, { require: true,
              value: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'nextState'),
              data: this.props.listNextStates,
              bindValidator: this,
              name: 'dropdownHuongXuLy' })
          ),
          _react2.default.createElement(_common.DatePicker, { require: true,
            bindValidator: this,
            channel: 'formTaoDon',
            isValid: this.props.validate,
            label: 'H\u1EA1n x\u1EED l\xFD',
            name: 'hanXuLy',
            value: this.state.thoiHanXuLy,
            startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
            onChange: this.handleChangeDate.bind(this, 'thoiHanXuLy') }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecTruongPhong && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong || this.state.form_GiaoViecCanBo && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, { require: true,
              bindValidator: this,
              selectedValue: this.state.phongBanChiDinh,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanChiDinh'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.form_GiaoViecCanBo && this.state.nextState == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien && this.state.phongBanChiDinh != '' },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              bindValidator: this,
              vaiTro: 'CHUYEN_VIEN',
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBanChiDinh,
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownChonCanBoXuLyChuyenVien' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pr10 pl10' },
          _react2.default.createElement(_common.TextArea, {
            label: '\xDD ki\u1EBFn x\u1EED l\xFD',
            value: this.state.noiDung ? this.state.noiDung : '',
            onChange: this.handleChange.bind(this, 'noiDung'),
            name: 'textareaYKienLanhDao' })
        ),
        this.state.dataShow.length ? _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, dataShow: this.state.dataShow })
        ) : ''
      );
    }
  }]);

  return LanhDaoGiaoViec;
}(_react2.default.Component);

LanhDaoGiaoViec.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(LanhDaoGiaoViec));

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _processType = __webpack_require__(57);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagerView = function (_React$Component) {
  _inherits(ManagerView, _React$Component);

  function ManagerView() {
    _classCallCheck(this, ManagerView);

    return _possibleConstructorReturn(this, (ManagerView.__proto__ || Object.getPrototypeOf(ManagerView)).apply(this, arguments));
  }

  _createClass(ManagerView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'items-form mb5' },
          _react2.default.createElement(
            'div',
            { className: 'row pr10 pl10' },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'Giao x\u1EED l\xFD:',
              value: this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy ? this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : '' }),
            _react2.default.createElement(_common.Text, {
              red: true,
              className: 'col-input',
              label: 'H\u1EA1n x\u1EED l\xFD:',
              value: this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy ? (0, _moment2.default)(this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'Ph\xF2ng ban:',
              value: this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten : '' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thongTinXuLyGiaiQuyet.nextState != null && this.props.thongTinXuLyGiaiQuyet.nextState.type == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten != '' },
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                label: 'Tr\u01B0\u1EDFng ph\xF2ng:',
                value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : '' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.thongTinXuLyGiaiQuyet.nextState != null && this.props.thongTinXuLyGiaiQuyet.nextState.type == _processType.processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten != '' },
              _react2.default.createElement(_common.Text, {
                className: 'col-input',
                label: 'C\xF4ng ch\u1EE9c x\u1EED l\xFD:',
                value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : '' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'row pr10 pl10' },
            _react2.default.createElement(_common.TextMessage, {
              className: 'col-12',
              value: this.props.thongTinXuLyGiaiQuyet.yKienXuLy || '',
              label: 'N\u1ED9i dung giao vi\u1EC7c:' })
          )
        )
      );
    }
  }]);

  return ManagerView;
}(_react2.default.Component);

exports.default = ManagerView;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _ttForms = __webpack_require__(19);

var _processType = __webpack_require__(57);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _InPhieu = __webpack_require__(235);

var _InPhieu2 = _interopRequireDefault(_InPhieu);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _autoComplete = __webpack_require__(190);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Promise = __webpack_require__(136).Promise;
var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'XU_LY_DON';

var process = [_processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien, _processType.processType.xuLyDon.processing.ketThuc, _processType.processType.xuLyDon.processing.deXuatGiaoViecLai];

var TruongPhongGiaoViec = function (_React$Component) {
  _inherits(TruongPhongGiaoViec, _React$Component);

  function TruongPhongGiaoViec(props, context) {
    _classCallCheck(this, TruongPhongGiaoViec);

    var _this = _possibleConstructorReturn(this, (TruongPhongGiaoViec.__proto__ || Object.getPrototypeOf(TruongPhongGiaoViec)).call(this, props, context));

    _this.state = {
      form_TruongPhongGiaoViecCanBo: false,
      form_DeXuatGiaoViecLai: false,

      donId: _this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,
      focused: false,
      lblTextArea: 'Ý kiến xử lý',
      phongBan: _this.props.userInfo.coQuanQuanLyId,
      noiDung: '',
      canBoChiDinh: '',
      phongBanXuLyChiDinh: '',
      // can bo

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: '',

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataNexstate: [],
      dataDonViTTXM: [],
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},
      ngayRaThongBaoThuLy: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(TruongPhongGiaoViec, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.huongXuLy != prevState.huongXuLy) {

        switch (this.state.huongXuLy) {

          case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:

            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

            this.setState({
              lblTextArea: 'Lý do lưu đơn',
              requireText: true
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
            this.setState({
              lblTextArea: 'Lý do',
              requireText: true
            });
            return;
          default:
            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
        }
      }
      if (prevProps.truongPhongThuHoi == true) {
        if (this.select && prevState.focused == false) {
          this.setState({
            focused: true
          });
          this.select.focus();
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.checkState();
    }
  }, {
    key: 'checkState',
    value: function checkState() {
      var _this2 = this;

      var numberState = 0;
      var onlyState = '';
      process.map(function (item, i) {
        if (_this2.props.getState(_this2.props.listNextStates, item)) {

          onlyState = item;
          numberState++;

          switch (item) {

            case _processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_TruongPhongGiaoViecCanBo: true
              });
              break;

            case _processType.processType.xuLyDon.processing.deXuatGiaoViecLai:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_DeXuatGiaoViecLai: true
              });
              break;

            case _processType.processType.xuLyDon.processing.ketThuc:
              _this2.setState({
                onlyState: onlyState,
                numberState: numberState,
                form_DeXuatGiaoViecLai: true
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.donId != 0) {
        this.getThongTinXuLy(this.state.donId);
      }
      this.getListDocument();
      var getPhongBan = [].concat(_toConsumableArray(this.props.listNextStates)).filter(function (item) {
        return item.type === "XLD_GIAO_PHONG_CUNG_CAP";
      });
      if (getPhongBan.length) {
        var phoPhong = {
          stateId: getPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        this.props.listNextStates.push(phoPhong);
      }
      var dataNexstate = [].concat(_toConsumableArray(this.props.listNextStates));
      var dataNexstateFilter = [];
      dataNexstate.map(function (item) {
        var newItem = item;
        if (item.type == 'KET_THUC') {
          newItem.tenVietTat = 'Tự xử lý';
          newItem.ten = 'Trưởng phòng tự xử lý';
        }
        dataNexstateFilter[dataNexstateFilter.length] = newItem;
      });
      this.setState({
        dataNexstate: dataNexstateFilter
      });
      this.getDonViTTXM();
    }
  }, {
    key: 'getDonViTTXM',
    value: function getDonViTTXM() {
      var _this3 = this;

      var params = {
        loaiDon: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : null
      };
      _api.DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            dataDonViTTXM: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dataNexstate = [].concat(_toConsumableArray(nextProps.listNextStates));
      var dataNexstateFilter = [];
      var getPhongBan = [].concat(_toConsumableArray(dataNexstate)).filter(function (item) {
        return item.type === "XLD_GIAO_PHONG_CUNG_CAP" || item.type === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP";
      });
      var getPhoPhong = [].concat(_toConsumableArray(dataNexstate)).filter(function (item) {
        return item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG";
      });
      if (!getPhoPhong.length && getPhongBan.length) {
        var phoPhong = {
          stateId: getPhongBan[0].stateId,
          ten: "Trưởng phòng giao việc phó phòng",
          tenVietTat: "Giao việc phó phòng",
          type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
        };
        dataNexstate.push(phoPhong);
      }
      dataNexstate.map(function (item) {
        var newItem = item;
        if (item.type == 'KET_THUC') {
          newItem.tenVietTat = 'Tự xử lý';
          newItem.ten = 'Trưởng phòng tự xử lý';
        }
        dataNexstateFilter[dataNexstateFilter.length] = newItem;
      });
      this.setState({
        dataNexstate: dataNexstateFilter
      });
    }

    // Add component Util

  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this4 = this;

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this4.state.donId;
      });

      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'onlyOneState',
    value: function onlyOneState() {
      var _this5 = this;

      if (this.state.nextState) {
        //do nothing
        this.trigger(this.state, true);
      } else if (this.state.numberState == 1) {
        var newState = _extends({}, this.state, {
          nextState: this.state.onlyState,
          hideDropdown: true
        });

        this.setState(_extends({}, newState), this.trigger(newState, true));
      } else {
        var _newState = _extends({}, this.state);
        if (this.state.huongXuLy || this.props.truongPhongThuHoi == true) {
          _newState = _extends({}, this.newState, {
            nextState: 'KET_THUC'
          });
        } else {
          _newState = _extends({}, this.newState);
        }

        this.setState(_extends({}, _newState), function () {
          _this5.trigger(_this5.state, true);
        });
      }
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this6 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
        params.ngayRaThongBaoGiaiQuyet = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this6.setState({
          hanGiaiQuyet: thoiHanXuLyMacDinh
        }, function () {
          _this6.trigger(_this6.state, false);
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this7 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoTTXM && this.state.trangThaiTTXM == 'GIAO_TTXM') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this7.setState({
          thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
        }, function () {
          _this7.trigger(_this7.state, false);
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this8 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          var info = res.data.thongTinXuLyInfo;

          var newState = _extends({}, _this8.state);

          if (info.hanGiaiQuyet == null) {
            _this8.getThoiHanGQDonMacDinh();
          }

          if (info.thoiHanBaoCaoKetQuaTTXM == null) {
            _this8.getThoiHanTTXMMacDinh();
          }
          if (info.nextState && info.nextState.type == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
            newState = _extends({}, _this8.state, {
              canBoChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
              noiDung: info.yKienXuLy ? info.yKienXuLy : ''
            });
          } else {
            newState = _extends({}, _this8.state, {
              noiDung: info.yKienXuLy ? info.yKienXuLy : '',
              phongBanXuLyChiDinh: info.phongBanXuLyChiDinh && info.phongBanXuLyChiDinh.id ? info.phongBanXuLyChiDinh.id : '',
              canBoChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
              huongXuLy: info.huongXuLy ? info.huongXuLy.giaTri : '',
              thamQuyenGiaiQuyet: info.thamQuyenGiaiQuyet ? info.thamQuyenGiaiQuyet.id : '',
              phongBanGiaiQuyet: info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '',
              donViNgoaiHeThong: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten : '',
              donViNgoaiHeThongId: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : '',
              coQuanTiepNhan: info.coQuanTiepNhan ? info.coQuanTiepNhan.id : '',
              coQuanTiepNhanTen: info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '',
              truongPhongChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
              nextState: res.data.phoPhongTemp ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : info.nextState ? info.nextState.type : '',
              trangThaiTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.mapTrangThaiTTXM ? info.mapTrangThaiTTXM.enum : '',
              hanGiaiQuyet: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.hanGiaiQuyet ? (0, _moment2.default)(info.hanGiaiQuyet).format('DD/MM/YYYY') : '',
              donViThamTraXacMinh: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.id : '',
              donViThamTraXacMinhTen: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.ten : '',
              thoiHanBaoCaoKetQuaTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? (0, _moment2.default)(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : ''
            });
          }
          _this8.setState(_extends({}, newState), function () {
            _this8.onlyOneState();
            _this8.checkFileHuongXuLy();
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this9 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));
      var index = name == 'coQuanTiepNhan' ? 0 : e.nativeEvent.target.selectedIndex;

      if (name === 'huongXuLy') {
        if (e.target.value === 'DE_XUAT_THU_LY') {
          if (this.state.dataDonViTTXM.length == 0) {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: 'TU_TTXM'
            });
          } else {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: ''
            });
          }
        } else {
          newState = _extends({}, newState, {
            noiDung: '',
            thamQuyenGiaiQuyet: '',
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          });
        }
        if (this.state.hasFileChange) {
          this.state.prepareData = newState;
          this.state.popupConfirmHXL = true;
          this.setState(_extends({}, this.state));
          return;
        }
      }

      if (name == 'donViThamTraXacMinh') {

        newState = _extends({}, newState, {
          donViThamTraXacMinhTen: e.nativeEvent.target[index].text
        });
      }

      if (name == 'phongBanGiaiQuyet') {

        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
      }

      if (name == 'coQuanTiepNhan') {
        newState = _extends({}, newState, {
          coQuanTiepNhanTen: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
        this.props.coQuanTiepNhanList.map(function (item) {
          if (item.coQuanQuanLyId == e.target.value) {
            newState.coQuanTiepNhanTen = item.ten;
          }
        });
      }

      if (name == 'nextState' && e.target.value == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO') {
        newState = _extends({}, newState, {
          noiDung: '',
          thamQuyenGiaiQuyet: '',
          truongPhongChiDinh: '',
          trangThaiTTXM: '',
          huongXuLy: ''
        });
      } else if (name == 'nextState') {
        newState = _extends({}, newState, {
          canBoChiDinh: '',
          noiDung: ''
        });
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'huongXuLy' || name == 'nextState' && _this9.state.nextState == 'KET_THUC') {
          _this9.checkFileHuongXuLy();
        }

        if (name == 'trangThaiTTXM') {
          _this9.checkFileTTXM();
        }
        _this9.trigger(newState, false);
      });
    }
  }, {
    key: 'confirmChangeHuongXuLy',
    value: function confirmChangeHuongXuLy(next) {
      var _this10 = this;

      if (next) {
        this.setState(_extends({}, this.state.prepareData, {
          hasFileChange: false
        }), function () {
          _this10.checkFileHuongXuLy();
          _this10.trigger(_this10.state.prepareData, false);
        });
      } else {
        this.state.popupConfirmHXL = false;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkFileHuongXuLy',
    value: function checkFileHuongXuLy() {
      var _this11 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var DataInit = [].concat(_toConsumableArray(_this11.props.listTaiLieuVanThu));
        var dataFileDinhKem = [];
        var dataShow = [];
        if (_this11.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else if (_this11.props.ngayNhanDon) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(state.ngayTao), new Date(_this11.props.ngayNhanDon), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this11.compareDate(new Date(_this11.props.ngayNhanDon), new Date(state.ngayTao), 'show');
          });
          _this11.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this11.state.donId;
          });
        }
        var typeRequired = '';
        var name = '';
        if (_this11.state.huongXuLy == 'DE_XUAT_THU_LY') {

          var data = [].concat(_toConsumableArray(dataFileDinhKem));

          var dataExist = data.filter(function (item) {
            return item.typeRequired == 'XLD_PDXTL';
          });
          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return (item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this11.trigger(_this11.state, false);
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
            var ItemDTTL = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
            }
            var _listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem), [ItemDTTL]);
            var _dataFilter = _listTaiLieuVanThu.filter(function (item) {
              return (item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var ItemTL = {
              ten: 'Phiếu đề xuất thụ lý',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              checkValid: true,
              required: false,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            var _listTaiLieuVanThu2 = [].concat(_toConsumableArray(dataFileDinhKem), [ItemTL]);
            var _dataFilter2 = _listTaiLieuVanThu2.filter(function (item) {
              return (item.newFile || !item.newFile) && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this11.setState({
              listTaiLieuVanThu: _dataFilter2
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          }
        } else if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this11.props.loaiDonGiaTri == 'DON_TO_CAO') || _this11.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO' && _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this11.state.huongXuLy == 'CHUYEN_DON' && (_this11.props.loaiDonGiaTri == 'DON_TO_CAO' || _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || _this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (_this11.props.loaiDonGiaTri == 'DON_TO_CAO' || _this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') || _this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (_this11.props.loaiDonGiaTri == 'DON_TO_CAO' || _this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || _this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && _this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
          if (_this11.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' || _this11.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO') {
            typeRequired = 'XLD_KDDKTL';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Thông báo về việc không thụ lý giải quyết tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết ';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh';
            }
          } else if (_this11.state.huongXuLy == 'CHUYEN_DON') {
            typeRequired = 'XLD_PCD';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc chuyển đơn tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh';
            }
          } else if (_this11.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
            typeRequired = 'XLD_TDHD';
            if (_this11.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc hướng dẫn người tố cáo';
            } else if (_this11.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Văn bản về việc hướng dẫn người khiếu nại';
            }
          } else if (_this11.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
            typeRequired = 'XLD_TDHD';
            if (_this11.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết';
            }
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
            typeRequired = 'XLD_TDKDTQ';
            name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
          } else if (_this11.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
            typeRequired = 'XLD_TDKDTQLD';
            name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
          }

          var _data = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataExist = _data.filter(function (item) {
            return item.required && item.typeRequired == typeRequired;
          });

          if (_dataExist.length > 0 && _this11.state.huongXuLy !== 'CHUYEN_DON') {
            var _listTaiLieuVanThu3 = [].concat(_toConsumableArray(dataFileDinhKem));
            var _dataFilter3 = _listTaiLieuVanThu3.filter(function (item) {
              return (item.newFile || !item.newFile) && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this11.setState({
              listTaiLieuVanThu: _dataFilter3
            }, function () {
              _this11.setState({
                renderContainer: true
              }, function () {
                _this11.checkFileTTXM();
              });
            });
          } else {
            var newItem = {
              ten: name,
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: typeRequired,
              newFile: true
            };

            var _listTaiLieuVanThu4 = [].concat(_toConsumableArray(dataFileDinhKem), [newItem]);
            var _dataFilter4 = [];
            if (_this11.state.huongXuLy === 'CHUYEN_DON') {
              _dataFilter4 = [newItem];
            } else {
              _dataFilter4 = _listTaiLieuVanThu4.filter(function (item) {
                return (item.newFile || !item.newFile) && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
              });
            }
            _this11.setState({
              listTaiLieuVanThu: _dataFilter4
            }, function () {
              _this11.setState({
                renderContainer: true
              });
            });
          }
        } else {

          var _listTaiLieuVanThu5 = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataFilter5 = _listTaiLieuVanThu5.filter(function (item) {
            return !item.newFile && (item.typeRequired == '' || item.typeRequired == null);
          });
          _this11.setState({
            listTaiLieuVanThu: _dataFilter5
          }, function () {
            _this11.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'checkFileTTXM',
    value: function checkFileTTXM() {
      var _this12 = this;

      this.setState({
        renderContainer: false
      }, function () {

        var dataFileDinhKem = [];
        var DataInit = [].concat(_toConsumableArray(_this12.props.listTaiLieuVanThu));

        if (_this12.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this12.compareDate(new Date(state.ngayTao), new Date(_this12.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this12.state.donId;
          });
        }

        if (_this12.state.trangThaiTTXM == 'GIAO_TTXM' && (_this12.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this12.props.loaiDonGiaTri == 'DON_TO_CAO' || _this12.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.required && item.typeRequired == 'XLD_GTTXM';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired || !item.newFile && item.typeRequired == 'XLD_GTTXM';
            });
            _this12.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoTTXM: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this12.trigger(_this12.state, false);
              _this12.setState({
                renderContainer: true
              });
            });
          } else {
            var newItem = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_GTTXM',
              newFile: true
            };
            if (_this12.props.loaiDonGiaTri == 'DON_TO_CAO') {
              newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo';
            } else if (_this12.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
            } else if (_this12.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh';
            }
            var _listTaiLieuVanThu6 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu), [newItem]);
            var newPDXItem = _this12.state.dataFileDinhKem.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL';
            });
            if (newPDXItem.length) {
              _listTaiLieuVanThu6 = _listTaiLieuVanThu6.map(function (item) {
                return item.typeRequired == 'XLD_PDXTL' ? newPDXItem[0] : item;
              });
            }
            _this12.setState({
              listTaiLieuVanThu: _listTaiLieuVanThu6
            }, function () {
              _this12.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu7 = [].concat(_toConsumableArray(_this12.state.listTaiLieuVanThu));
          var _dataFilter6 = _listTaiLieuVanThu7.filter(function (item) {
            return item.typeRequired != 'XLD_GTTXM';
          });
          _this12.setState({
            listTaiLieuVanThu: _dataFilter6
          }, function () {
            _this12.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this13 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e));
      if (typeof e.format == 'function') {
        newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'ngayRaThongBaoThuLy') {
          var newFileArr = [].concat(_toConsumableArray(_this13.state.listTaiLieuVanThu));
          newFileArr = newFileArr.map(function (item) {
            if (item.typeRequired == 'XLD_PDXTL') {
              return item = _extends({}, item, {
                ngayQuyetDinh: _this13.state.ngayRaThongBaoThuLy
              });
            }
            return item;
          });
          _this13.setState({
            loaiVanBanSuggest: 'XLD_PDXTL',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoThuLy
            // listTaiLieuVanThu: newFileArr
          });
          _this13.getThoiHanGQDonMacDinh();
        }
        if (name == 'ngayRaThongBaoTTXM') {
          _this13.setState({
            loaiVanBanSuggest: 'XLD_GTTXM',
            ngayQuyetDinhSuggest: _this13.state.ngayRaThongBaoTTXM
          });

          _this13.getThoiHanTTXMMacDinh();
        }
        if (name == 'hanGiaiQuyet') {
          _this13.checkHanGiaiQuyet();
        }
        _this13.trigger(newState, false);
      });
    }
  }, {
    key: 'checkHanGiaiQuyet',
    value: function checkHanGiaiQuyet() {
      var params = {
        loaiDon: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
        params.ngayBatDau = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        if (this.state.hanGiaiQuyet) {
          params.ngayKetThuc = (0, _moment2.default)(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      _api.DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {
      var params = {
        yKienXuLy: newState.noiDung
      };
      if (newState.nextState == "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
        params.phoPhong = true;
        params.phoPhongTemp = true;
        params.phongBanXuLyChiDinh = {
          id: Number(this.state.phongBan)
        };
        if (this.state.canBoChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(this.state.canBoChiDinh)
          };
        }
        params.noiDungYeuCauXuLy = this.state.noiDung;
      }

      if (newState.nextState === "XLD_GIAO_PHONG_CUNG_CAP") {
        if (this.state.phongBanXuLyChiDinh) {
          params.phongBanXuLyChiDinh = {
            id: this.state.phongBanXuLyChiDinh
          };
        }
        params.noiDungYeuCauXuLy = this.state.noiDung;
        params.notice = _message.msg.xldTruongPhongGiaoViec;
      }
      if (newState.nextState === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP") {
        params.phongBanXuLyChiDinh = {
          id: this.state.phongBanXuLyChiDinh
        };
        params.noiDungYeuCauXuLy = this.state.noiDung;
        params.notice = _message.msg.xldTruongPhongGiaoViec;
      }

      if (newState.nextState) {
        var selectState = newState.dataNexstate.find(function (state) {
          return state.type === newState.nextState;
        });
        // let stateId = this.props.getState(this.props.listNextStates, newState.nextState);
        var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
        if (selectState && selectState.stateId) {
          params.nextState = {
            id: Number(selectState.stateId)
          };
        }
        if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien) {
          params.notice = _message.msg.xldTruongPhongGiaoViec;

          if (newState.canBoChiDinh) {
            params.canBoXuLyChiDinh = {
              id: Number(newState.canBoChiDinh)
            };
          }
        } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.ketThuc) {
          params.huongXuLy = newState.huongXuLy || null;

          if (newState.thamQuyenGiaiQuyet && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi) params.thamQuyenGiaiQuyet = {
            id: Number(newState.thamQuyenGiaiQuyet)
          };

          if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy) {

            params.notice = _message.msg.xldChuyenGiaiQuyetDon;
            params.hanGiaiQuyet = (0, _moment2.default)(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours');
            params.trangThaiTTXM = newState.trangThaiTTXM || null;

            if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoThuLy) {
              params.ngayRaThongBaoThuLy = (0, _moment2.default)(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }

            if (newState.trangThaiTTXM == "TU_TTXM") {

              if (newState.phongBanGiaiQuyet) params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };

              if (newState.truongPhongChiDinh) params.canBoXuLyChiDinh = { id: Number(newState.truongPhongChiDinh) };
            } else if (newState.trangThaiTTXM == "GIAO_TTXM") {
              if (newState.donViThamTraXacMinh) {
                params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
                params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
              }

              if (newState.thoiHanBaoCaoKetQuaTTXM) {
                params.thoiHanBaoCaoKetQuaTTXM = (0, _moment2.default)(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }

              if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoTTXM) {
                params.ngayRaThongBaoTTXM = (0, _moment2.default)(newState.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }
            }
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.chuyenDon) {
            if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
              params.notice = _message.msg.xldChuyenDon;
              params.coQuanTiepNhan = {
                id: Number(newState.coQuanTiepNhan),
                ten: newState.coQuanTiepNhanTen
              };
            } else {
              params.notice = _message.msg.xldLuuHoSo;
              params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
              params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
            }
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {
            params.notice = _message.msg.xldYeuCauGapLanhDao;
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen) {
            params.notice = _message.msg.xldTraDon;
          } else if (newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.chuyenDon && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

            params.notice = _message.msg.xldLuuHoSo;
          }
        } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.deXuatGiaoViecLai) {
          params.notice = _message.msg.xldTruongPhongGiaoViec;
        } else if (newState.form_TruongPhongGiaoViecCanBo && newState.nextState == _processType.processType.xuLyDon.processing.truongPhongGiaoViecPhoPhong) {
          params.notice = _message.msg.xldTruongPhongGiaoViec;
        }
      } else {
        params.nextState = null;
      }
      this.props.onChange(params, isInit);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {

      var temp = {
        dataFileDinhKem: data,
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      };

      this.setState(_extends({}, temp));

      this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      var oldData = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      var tbtlDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbtlOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbTTXMDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      var tbTTXMOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      if (tbTTXMDate.length > 0) {
        if (tbTTXMOldDate.length > 0 && (0, _moment2.default)(tbTTXMOldDate[0].ngayQuyetDinh).isSame(tbTTXMDate[0].ngayQuyetDinh) == false || tbTTXMOldDate.length == 0) {
          this.state.ngayRaThongBaoTTXM = tbTTXMDate[0].ngayQuyetDinh;
          this.getThoiHanTTXMMacDinh();
          if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' && this.state.ngayRaThongBaoTTXM) {
            this.state.ngayRaThongBaoThuLy = tbTTXMDate[0].ngayQuyetDinh;
            this.getThoiHanGQDonMacDinh();
          }
        }
      }
      if (tbtlDate.length > 0 && this.props.loaiDonGiaTri != 'DON_KIEN_NGHI_PHAN_ANH') {
        if (tbtlOldDate.length > 0 && (0, _moment2.default)(tbtlOldDate[0].ngayQuyetDinh).isSame(tbtlDate[0].ngayQuyetDinh) == false || tbtlOldDate.length == 0) {
          this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
          this.getThoiHanGQDonMacDinh();
        }
      }

      this.setState({
        dataFileDinhKem: data
      });

      this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'searchDonVi',
    value: function searchDonVi(tuKhoa) {
      var inputParams = {
        size: 5,
        page: 0
      };

      inputParams.ten = tuKhoa;

      return _api.Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          return Promise.resolve({
            result: res.data._embedded.donViNgoaiHeThongs,
            page: res.data.page
          });
        } else {
          return Promise.resolve(null);
        }
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'onChangeSuggest',
    value: function onChangeSuggest(name, value) {
      this.state[name] = value;
      this.state.donViNgoaiHeThongId = '';
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'onSelectedSuggest',
    value: function onSelectedSuggest(item) {
      this.state.donViNgoaiHeThong = item.ten;
      this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      var lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb0-18' },
        _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChange, open: this.state.popupConfirmHXL, onClose: this.confirmChangeHuongXuLy.bind(this, false), onSuccess: this.confirmChangeHuongXuLy.bind(this, true) }),
        _react2.default.createElement(
          'div',
          { className: 'row pr10 pl10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.listNextStates.length > 1 },
            _react2.default.createElement(_ttForms.DropDownMulipleUse, {
              className: 'col-20',
              onRef: function onRef(select) {
                return _this14.select = select;
              },
              require: true,
              data: this.state.dataNexstate,
              bindValidator: this,
              selectedValue: this.state.nextState,
              label: 'Giao x\u1EED l\xFD',
              keyName: 'type',
              name: 'huongXuLy',
              valueName: 'tenVietTat',
              onChange: this.handleChange.bind(this, 'nextState') })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" },
            _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
              label: 'Ch\u1ECDn ph\xF3 ph\xF2ng',
              bindValidator: this,
              isValid: this.props.validate,
              selectedValue: this.state.canBoChiDinh,
              phongBanId: this.state.phongBan,
              vaiTro: 'PHO_PHONG',
              onChange: this.handleChange.bind(this, 'canBoChiDinh'),
              name: 'dropdownTruongPhongChonCanBoXuLy' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === "XLD_UBNDTP_GIAO_PHONG_CUNG_CAP" },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
              require: true,
              bindValidator: this,
              selectedValue: this.state.phongBanXuLyChiDinh,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanXuLyChiDinh'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === "XLD_GIAO_PHONG_CUNG_CAP" },
            _react2.default.createElement(_ttForms.DropDownChonPhongBanThuocCoQuan, {
              require: true,
              bindValidator: this,
              selectedValue: this.state.phongBanXuLyChiDinh,
              isValid: this.props.validate,
              onChange: this.handleChange.bind(this, 'phongBanXuLyChiDinh'),
              name: 'dropdownChonPhongBanThuocCoQuan' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_CAN_BO" },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.form_TruongPhongGiaoViecCanBo && this.state.nextState == _processType.processType.xuLyDon.processing.truongPhongGiaoViecChuyenVien },
              _react2.default.createElement(_ttForms.DropDownChonCanBoXuLy, { require: true,
                bindValidator: this,
                isValid: this.props.validate,
                selectedValue: this.state.canBoChiDinh,
                phongBanId: this.state.phongBan,
                vaiTro: 'CHUYEN_VIEN',
                onChange: this.handleChange.bind(this, 'canBoChiDinh'),
                name: 'dropdownTruongPhongChonCanBoXuLy' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.nextState !== "KET_THUC" },
            _react2.default.createElement(_common.TextArea, {
              label: '\xDD ki\u1EBFn x\u1EED l\xFD',
              rows: '3',
              className: 'col-100 mb0-18',
              value: this.state.noiDung,
              onChange: this.handleChange.bind(this, 'noiDung'),
              name: 'textareaYKienTruongPhong' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.nextState == 'KET_THUC' },
          _react2.default.createElement(
            'div',
            { className: 'row pr15 pl10 mt10' },
            _react2.default.createElement(_ttForms.DropDownChonHuongXuLyTheoDon, { require: true,
              selectedValue: this.state.huongXuLy,
              donId: this.props.donId,
              loaiDon: this.props.loaiDonGiaTri,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'huongXuLy'),
              className: 'col-3',
              bindValidator: this,
              name: 'dropdownChonHuongXuLyTheoDon' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy !== 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy !== 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' },
              _react2.default.createElement(_ttForms.DropDownChonNhomThamQuyenGiaiQuyet, { require: true,
                filterThamQuyenGiaiQuyet: this.state.huongXuLy === 'CHUYEN_DON',
                selectedValue: this.state.thamQuyenGiaiQuyet,
                label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt',
                className: 'col-3',
                onChange: this.handleChange.bind(this, 'thamQuyenGiaiQuyet'),
                bindValidator: this,
                name: 'dropdownChonNhomThamQuyenGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayRaThongBaoThuLy,
                  label: 'Ng\xE0y ra th\xF4ng b\xE1o th\u1EE5 l\xFD',
                  name: 'ngayRaThongBaoThuLy',
                  endDate: new Date(),
                  onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy'),
                  bindValidator: this,
                  channel: 'formTaoDon' })
              ),
              _react2.default.createElement(_common.DatePicker, { require: true,
                className: 'col-25',
                value: this.state.hanGiaiQuyet,
                label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
                name: 'hanGiaiQuyet',
                startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                onChange: this.handleChangeDate.bind(this, 'hanGiaiQuyet'),
                bindValidator: this,
                channel: 'formTaoDon' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == 'CHUYEN_DON' && this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId },
              _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: 'C\u01A1 quan ti\u1EBFp nh\u1EADn', className: 'tree-selected', placeholder: true, dataOptions: this.props.coQuanTiepNhanList, value: this.state.coQuanTiepNhan, onChange: this.handleChange.bind(this, 'coQuanTiepNhan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', name: 'dropdownChonCoQuanTiepNhan', bindValidator: this, channel: 'formTaoDon', require: true })
            ),
            this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ? _react2.default.createElement(_autoComplete.AutoSuggest, {
              label: '\u0110\u01A1n v\u1ECB',
              className: 'col-3',
              placeholder: 'Nh\u1EADp...',
              onSearch: this.searchDonVi,
              onChange: this.onChangeSuggest.bind(this, 'donViNgoaiHeThong'),
              onSelected: this.onSelectedSuggest.bind(this),
              value: this.state.donViNgoaiHeThong,
              maxLength: 40
            }) : ''
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'row pr15 pl10' },
              _react2.default.createElement(_ttForms.DropDownChonQuyTrinhGiaiQuyetDon, {
                className: 'col-25',
                donId: this.props.donId,
                bindValidator: this,
                require: true,
                loaiDon: this.props.loaiDonGiaTri,
                isValid: this.props.validate,
                selectedValue: this.state.trangThaiTTXM,
                onChange: this.handleChange.bind(this, 'trangThaiTTXM'),
                name: 'dropdownChonTrangThaiTTXM' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.trangThaiTTXM == 'GIAO_TTXM' },
                _react2.default.createElement(_ttForms.DropDownChonDonViTTXM, {
                  className: 'col-25',
                  bindValidator: this,
                  require: true,
                  loaiDon: this.props.loaiDonGiaTri,
                  isValid: this.props.validate,
                  selectedValue: this.state.donViThamTraXacMinh,
                  onChange: this.handleChange.bind(this, 'donViThamTraXacMinh'),
                  name: 'dropdownChonDonViTTXM' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                  _react2.default.createElement(_common.DatePicker, { require: true,
                    className: 'col-25',
                    value: this.state.ngayRaThongBaoTTXM,
                    label: 'Ngày ra QĐ giao nhiệm vụ ' + lb1,
                    name: 'ngayRaThongBaoTTXM',
                    endDate: new Date(),
                    onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
                    bindValidator: this,
                    channel: 'formTaoDon' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title mb0' },
                      'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content pt17 txt-danger' },
                      this.state.thoiHanBaoCaoKetQuaTTXM
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pr15 pl10' },
            _react2.default.createElement(_common.TextArea, {
              require: this.state.requireText,
              label: this.state.lblTextArea,
              rows: '3',
              value: this.state.noiDung ? this.state.noiDung : '',
              onChange: this.handleChange.bind(this, 'noiDung'),
              bindValidator: this,
              channel: 'formTaoDon',
              name: 'textareaYKienCanBoXuLyDon' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pr15 pl10' },
            _react2.default.createElement(_InPhieu2.default, { inPhieu: this.props.inPhieu.bind(this),
              huongXuLy: this.state.huongXuLy,
              loaiDonGiaTri: this.props.loaiDonGiaTri,
              trangThaiTTXM: this.state.trangThaiTTXM || null })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.renderContainer },
            _react2.default.createElement(
              'div',
              { className: 'container-filedinhkem mt15' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                data: this.state.listTaiLieuVanThu,
                dataShow: this.state.dataShow,
                onSave: this.props.onSave,
                loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          )
        ),
        this.state.dataShow.length && this.state.nextState != 'KET_THUC' ? _react2.default.createElement(
          'div',
          { className: 'container-filedinhkem' },
          _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', disableAttachFile: true, dataShow: this.state.dataShow })
        ) : ''
      );
    }
  }]);

  return TruongPhongGiaoViec;
}(_react2.default.Component);

TruongPhongGiaoViec.defaultProps = {
  listNextStates: [],
  coQuanTiepNhanList: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  }
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TruongPhongGiaoViec));

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TruongPhongGiaoViecView = function (_React$Component) {
  _inherits(TruongPhongGiaoViecView, _React$Component);

  function TruongPhongGiaoViecView() {
    _classCallCheck(this, TruongPhongGiaoViecView);

    return _possibleConstructorReturn(this, (TruongPhongGiaoViecView.__proto__ || Object.getPrototypeOf(TruongPhongGiaoViecView)).apply(this, arguments));
  }

  _createClass(TruongPhongGiaoViecView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'items-form mb5' },
          _react2.default.createElement(
            'div',
            { className: 'row pr15 pl15' },
            _react2.default.createElement(_common.Text, {
              className: 'col-input',
              label: 'C\xF4ng ch\u1EE9c x\u1EED l\xFD:',
              value: this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'row pr15 pl15' },
            _react2.default.createElement(_common.TextMessage, {
              className: 'col-12',
              value: this.props.thongTinXuLyGiaiQuyet.yKienXuLy || '',
              label: '\xDD ki\u1EBFn x\u1EED l\xFD:' })
          )
        )
      );
    }
  }]);

  return TruongPhongGiaoViecView;
}(_react2.default.Component);

exports.default = TruongPhongGiaoViecView;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var CONFIG = _interopRequireWildcard(_config);

var _ttForms = __webpack_require__(19);

var _processType = __webpack_require__(57);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _InPhieu = __webpack_require__(235);

var _InPhieu2 = _interopRequireDefault(_InPhieu);

var _api = __webpack_require__(5);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _autoComplete = __webpack_require__(190);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'XU_LY_DON';
var Promise = __webpack_require__(136).Promise;

var TuXuLy = function (_React$Component) {
  _inherits(TuXuLy, _React$Component);

  function TuXuLy(props, context) {
    _classCallCheck(this, TuXuLy);

    var _this = _possibleConstructorReturn(this, (TuXuLy.__proto__ || Object.getPrototypeOf(TuXuLy)).call(this, props, context));

    _this.state = {
      form_HuongXuLy: true,
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},
      renderContainer: true,

      loaiDonGiaTri: _this.props.loaiDonGiaTri,
      requireText: false,
      lblTextArea: 'Ý kiến xử lý',

      donId: _this.props.donId,

      nextState: 8,

      hideDropdown: false,

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',
      noiDung: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: '',

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataDonViTTXM: [],
      ngayRaThongBaoThuLy: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: ''
    };
    return _this;
  }

  _createClass(TuXuLy, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.huongXuLy != prevState.huongXuLy) {

        switch (this.state.huongXuLy) {

          case _processType.processType.xuLyDon.huongXuLy.deXuatThuLy:

            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

            this.setState({
              lblTextArea: 'Lý do lưu đơn',
              requireText: true
            });
            return;
          case _processType.processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
            this.setState({
              lblTextArea: 'Lý do',
              requireText: true
            });
            return;
          default:
            this.setState({
              lblTextArea: 'Ý kiến xử lý',
              requireText: false
            });
            return;
        }
      }
    }

    // Add component Util

  }, {
    key: 'getListDocument',
    value: function getListDocument() {
      var _this2 = this;

      // let dataFileDinhKem = this.props.listTaiLieuVanThu.filter((item) => {
      //   return item.donId == this.state.donId
      // })

      var dataShow = this.props.listTaiLieuVanThu.filter(function (item) {
        return item.donId != _this2.state.donId;
      });

      this.setState({
        dataShow: dataShow
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      if (this.state.donId != 0) {
        this.getThongTinXuLy(this.state.donId);
      }
      this.getListDocument();
      this.getDonViTTXM();
    }
  }, {
    key: 'getDonViTTXM',
    value: function getDonViTTXM() {
      var _this3 = this;

      var params = {
        loaiDon: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : null
      };
      _api.DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            dataDonViTTXM: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getThoiHanGQDonMacDinh',
    value: function getThoiHanGQDonMacDinh() {
      var _this4 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
        params.ngayRaThongBaoGiaiQuyet = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this4.setState({
          hanGiaiQuyet: thoiHanXuLyMacDinh
        }, function () {
          _this4.trigger(_this4.state, false);
        });
      });
    }
  }, {
    key: 'getThoiHanTTXMMacDinh',
    value: function getThoiHanTTXMMacDinh() {
      var _this5 = this;

      var params = {
        type: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoTTXM && this.state.trangThaiTTXM == 'GIAO_TTXM') {
        params.ngayRaThongBaoTTXM = (0, _moment2.default)(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(function (res) {
        var thoiHanXuLyMacDinh = (0, _moment2.default)(res.data).format('DD/MM/YYYY');
        _this5.setState({
          thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
        }, function () {
          _this5.trigger(_this5.state, false);
        });
      });
    }
  }, {
    key: 'getThongTinXuLy',
    value: function getThongTinXuLy(donId) {
      var _this6 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {

        if (res.data) {
          var info = res.data.thongTinXuLyInfo;

          // Xac dinh co luu du lieu hay chua
          if (info.hanGiaiQuyet == null) {
            _this6.getThoiHanGQDonMacDinh();
          }
          if (info.thoiHanBaoCaoKetQuaTTXM == null) {
            _this6.getThoiHanTTXMMacDinh();
          }

          if (info.nextState == null) {
            _this6.getThoiHanGQDonMacDinh();
            _this6.getThoiHanTTXMMacDinh();
            _this6.trigger(_this6.state, true);
          } else {

            var newState = _extends({}, _this6.state, {
              noiDung: info.yKienXuLy,
              huongXuLy: info.huongXuLy && info.huongXuLy.giaTri ? info.huongXuLy.giaTri : '',
              thamQuyenGiaiQuyet: info.thamQuyenGiaiQuyet ? info.thamQuyenGiaiQuyet.id : '',
              phongBanGiaiQuyet: info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '',
              coQuanTiepNhan: info.coQuanTiepNhan ? info.coQuanTiepNhan.id : null,
              coQuanTiepNhanTen: info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '',
              truongPhongChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
              trangThaiTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.mapTrangThaiTTXM ? info.mapTrangThaiTTXM.enum : '',
              hanGiaiQuyet: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.hanGiaiQuyet ? (0, _moment2.default)(info.hanGiaiQuyet).format('DD/MM/YYYY') : '',
              donViThamTraXacMinh: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.id : '',
              donViThamTraXacMinhTen: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? info.donViThamTraXacMinh.ten : '',
              thoiHanBaoCaoKetQuaTTXM: info.huongXuLy && info.huongXuLy.giaTri == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM' ? (0, _moment2.default)(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '',
              donViNgoaiHeThong: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten : '',
              donViNgoaiHeThongId: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : ''
            });

            _this6.setState(_extends({}, newState), function () {
              _this6.checkFileHuongXuLy();
            });

            _this6.trigger(newState, true);
          }
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this7 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e.target.value));

      var index = name == 'coQuanTiepNhan' ? 0 : e.nativeEvent.target.selectedIndex;

      if (name == 'huongXuLy') {
        if (e.target.value == 'DE_XUAT_THU_LY') {
          if (this.state.dataDonViTTXM.length == 0) {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: 'TU_TTXM'
            });
          } else {
            newState = _extends({}, newState, {
              noiDung: '',
              thamQuyenGiaiQuyet: 1,
              truongPhongChiDinh: '',
              trangThaiTTXM: ''
            });
          }
        } else {
          newState = _extends({}, newState, {
            noiDung: '',
            thamQuyenGiaiQuyet: '',
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          });
        }
        if (this.state.hasFileChange) {
          this.state.prepareData = newState;
          this.state.popupConfirmHXL = true;
          this.setState(_extends({}, this.state));
          return;
        }
      }

      if (name == 'donViThamTraXacMinh') {
        newState = _extends({}, newState, {
          donViThamTraXacMinhTen: e.nativeEvent.target[index].text
        });
      }

      if (name == 'phongBanGiaiQuyet') {
        newState = _extends({}, newState, {
          truongPhongChiDinh: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
      }

      if (name == 'coQuanTiepNhan') {

        newState = _extends({}, newState, {
          coQuanTiepNhanTen: '',
          dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete
        });
        this.props.coQuanTiepNhanList.map(function (item) {
          if (item.coQuanQuanLyId == e.target.value) {
            newState.coQuanTiepNhanTen = item.ten;
          }
        });
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'huongXuLy') {
          _this7.checkFileHuongXuLy();
        }
        if (name == 'trangThaiTTXM') {
          _this7.checkFileTTXM();
        }

        _this7.trigger(newState, false);
      });
    }
  }, {
    key: 'confirmChangeHuongXuLy',
    value: function confirmChangeHuongXuLy(next) {
      var _this8 = this;

      if (next) {
        this.setState(_extends({}, this.state.prepareData, {
          hasFileChange: false
        }), function () {
          _this8.checkFileHuongXuLy();
          _this8.trigger(_this8.state.prepareData, false);
        });
      } else {
        this.state.popupConfirmHXL = false;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime > secondTime || firstTime == secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkFileHuongXuLy',
    value: function checkFileHuongXuLy() {
      var _this9 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var DataInit = [].concat(_toConsumableArray(_this9.props.listTaiLieuVanThu));
        var dataFileDinhKem = [];
        var dataShow = [];
        if (_this9.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this9.compareDate(new Date(state.ngayTao), new Date(_this9.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this9.compareDate(new Date(_this9.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
          });
          _this9.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else if (_this9.props.ngayNhanDon) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this9.compareDate(new Date(state.ngayTao), new Date(_this9.props.ngayNhanDon), 'action');
          });
          dataShow = DataInit.filter(function (state) {
            return _this9.compareDate(new Date(_this9.props.ngayNhanDon), new Date(state.ngayTao), 'show');
          });
          _this9.setState({
            dataShow: [].concat(_toConsumableArray(dataShow))
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this9.state.donId;
          });
        }
        var typeRequired = '';
        var name = '';
        if (_this9.state.huongXuLy == 'DE_XUAT_THU_LY') {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.typeRequired == 'XLD_PDXTL';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });
            _this9.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this9.trigger(_this9.state, false);
              _this9.setState({
                renderContainer: true
              }, function () {
                _this9.checkFileTTXM();
              });
            });
          } else if (_this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this9.props.loaiDonGiaTri == 'DON_TO_CAO') {
            var ItemDTTL = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            if (_this9.props.loaiDonGiaTri == 'DON_TO_CAO') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
            } else if (_this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
            }
            var _listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem), [ItemDTTL]);
            var _dataFilter = _listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this9.setState({
              listTaiLieuVanThu: _dataFilter
            }, function () {
              _this9.setState({
                renderContainer: true
              }, function () {
                _this9.checkFileTTXM();
              });
            });
          } else {
            var ItemTL = {
              ten: 'Phiếu đề xuất thụ lý',
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: false,
              typeRequired: 'XLD_PDXTL',
              newFile: true
            };
            var _listTaiLieuVanThu2 = [].concat(_toConsumableArray(dataFileDinhKem), [ItemTL]);
            var _dataFilter2 = _listTaiLieuVanThu2.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired;
            });

            _this9.setState({
              listTaiLieuVanThu: _dataFilter2
            }, function () {
              _this9.setState({
                renderContainer: true
              }, function () {
                _this9.checkFileTTXM();
              });
            });
          }
        } else if (_this9.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (_this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this9.props.loaiDonGiaTri == 'DON_TO_CAO') || _this9.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO' && _this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this9.state.huongXuLy == 'CHUYEN_DON' && (_this9.props.loaiDonGiaTri == 'DON_TO_CAO' || _this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || _this9.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (_this9.props.loaiDonGiaTri == 'DON_TO_CAO' || _this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI') || _this9.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && _this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' || _this9.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (_this9.props.loaiDonGiaTri == 'DON_TO_CAO' || _this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') || _this9.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && _this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
          if (_this9.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' || _this9.state.huongXuLy == 'KHONG_XU_LY_NEU_LY_DO') {
            typeRequired = 'XLD_KDDKTL';
            if (_this9.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Thông báo về việc không thụ lý giải quyết tố cáo';
            } else if (_this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết ';
            } else if (_this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh';
            }
          } else if (_this9.state.huongXuLy == 'CHUYEN_DON') {
            typeRequired = 'XLD_PCD';
            if (_this9.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc chuyển đơn tố cáo';
            } else if (_this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh';
            }
          } else if (_this9.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
            typeRequired = 'XLD_TDHD';
            if (_this9.props.loaiDonGiaTri == 'DON_TO_CAO') {
              name = 'Văn bản về việc hướng dẫn người tố cáo';
            } else if (_this9.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              name = 'Văn bản về việc hướng dẫn người khiếu nại';
            }
          } else if (_this9.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
            typeRequired = 'XLD_TDHD';
            if (_this9.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết';
            }
          } else if (_this9.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
            typeRequired = 'XLD_TDKDTQ';
            name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
          } else if (_this9.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
            typeRequired = 'XLD_TDKDTQLD';
            name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
          }

          var _data = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataExist = _data.filter(function (item) {
            return item.required && item.typeRequired == typeRequired;
          });

          if (_dataExist.length > 0) {
            var _listTaiLieuVanThu3 = [].concat(_toConsumableArray(dataFileDinhKem));
            var _dataFilter3 = _listTaiLieuVanThu3.filter(function (item) {
              return item.newFile && item.typeRequired == typeRequired || !item.newFile && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this9.setState({
              listTaiLieuVanThu: _dataFilter3
            }, function () {
              _this9.setState({
                renderContainer: true
              }, function () {
                _this9.checkFileTTXM();
              });
            });
          } else {
            var newItem = {
              ten: name,
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: typeRequired,
              newFile: true
            };
            var _listTaiLieuVanThu4 = [].concat(_toConsumableArray(dataFileDinhKem), [newItem]);
            var _dataFilter4 = _listTaiLieuVanThu4.filter(function (item) {
              return item.newFile && item.typeRequired == typeRequired || !item.newFile && item.typeRequired == typeRequired || !item.newFile && !item.typeRequired;
            });
            _this9.setState({
              listTaiLieuVanThu: _dataFilter4
            }, function () {
              _this9.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu5 = [].concat(_toConsumableArray(dataFileDinhKem));
          var _dataFilter5 = _listTaiLieuVanThu5.filter(function (item) {
            return !item.newFile && (item.typeRequired == '' || item.typeRequired == null);
          });
          _this9.setState({
            listTaiLieuVanThu: _dataFilter5
          }, function () {
            _this9.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'checkFileTTXM',
    value: function checkFileTTXM() {
      var _this10 = this;

      this.setState({
        renderContainer: false
      }, function () {
        var dataFileDinhKem = [];
        var DataInit = [].concat(_toConsumableArray(_this10.props.listTaiLieuVanThu));

        if (_this10.props.ngayTraTTXMKhongDungThamQuyen) {
          dataFileDinhKem = DataInit.filter(function (state) {
            return _this10.compareDate(new Date(state.ngayTao), new Date(_this10.props.ngayTraTTXMKhongDungThamQuyen), 'action');
          });
        } else {
          dataFileDinhKem = DataInit.filter(function (item) {
            return item.donId == _this10.state.donId;
          });
        }

        if (_this10.state.trangThaiTTXM == 'GIAO_TTXM' && (_this10.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || _this10.props.loaiDonGiaTri == 'DON_TO_CAO' || _this10.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
          var data = [].concat(_toConsumableArray(dataFileDinhKem));
          var dataExist = data.filter(function (item) {
            return item.required && item.typeRequired == 'XLD_GTTXM';
          });

          if (dataExist.length > 0) {
            var listTaiLieuVanThu = [].concat(_toConsumableArray(dataFileDinhKem));
            var dataFilter = listTaiLieuVanThu.filter(function (item) {
              return item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && item.typeRequired == 'XLD_PDXTL' || !item.newFile && !item.typeRequired || !item.newFile && item.typeRequired == 'XLD_GTTXM';
            });
            _this10.setState({
              listTaiLieuVanThu: dataFilter,
              ngayRaThongBaoTTXM: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
            }, function () {
              _this10.trigger(_this10.state, false);
              _this10.setState({
                renderContainer: true
              });
            });
          } else {
            var newItem = {
              loaiTepDinhKem: '',
              soQuyetDinh: '',
              ngayQuyetDinh: '',
              tenFile: '',
              duongDan: '',
              progress: 0,
              required: true,
              typeRequired: 'XLD_GTTXM',
              newFile: true
            };
            if (_this10.props.loaiDonGiaTri == 'DON_TO_CAO') {
              newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo';
            } else if (_this10.props.loaiDonGiaTri == 'DON_KHIEU_NAI') {
              newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại';
            } else if (_this10.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
              newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh';
            }
            var _listTaiLieuVanThu6 = [].concat(_toConsumableArray(_this10.state.listTaiLieuVanThu), [newItem]);
            var newPDXItem = _this10.state.dataFileDinhKem.filter(function (item) {
              return item.typeRequired == 'XLD_PDXTL';
            });
            if (newPDXItem.length) {
              _listTaiLieuVanThu6 = _listTaiLieuVanThu6.map(function (item) {
                return item.typeRequired == 'XLD_PDXTL' ? newPDXItem[0] : item;
              });
            }
            _this10.setState({
              listTaiLieuVanThu: _listTaiLieuVanThu6
            }, function () {
              _this10.setState({
                renderContainer: true
              });
            });
          }
        } else {
          var _listTaiLieuVanThu7 = [].concat(_toConsumableArray(_this10.state.listTaiLieuVanThu));
          var _dataFilter6 = _listTaiLieuVanThu7.filter(function (item) {
            return item.typeRequired != 'XLD_GTTXM';
          });
          _this10.setState({
            listTaiLieuVanThu: _dataFilter6
          }, function () {
            _this10.setState({
              renderContainer: true
            });
          });
        }
      });
    }
  }, {
    key: 'checkHanGiaiQuyet',
    value: function checkHanGiaiQuyet() {
      var params = {
        loaiDon: this.props.loaiDonGiaTri
      };
      if ((this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
        params.ngayBatDau = (0, _moment2.default)(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        if (this.state.hanGiaiQuyet) {
          params.ngayKetThuc = (0, _moment2.default)(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      _api.DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this11 = this;

      var newState = _extends({}, this.state, _defineProperty({}, name, e));
      if (typeof e.format == 'function') {
        newState = _extends({}, this.state, _defineProperty({}, name, e.format(CONFIG.DateFormat)));
      }

      this.setState(_extends({}, newState), function () {
        if (name == 'ngayRaThongBaoThuLy') {
          var newFileArr = [].concat(_toConsumableArray(_this11.state.listTaiLieuVanThu));
          newFileArr = newFileArr.map(function (item) {
            if (item.typeRequired == 'XLD_PDXTL') {
              return item = _extends({}, item, {
                ngayQuyetDinh: _this11.state.ngayRaThongBaoThuLy
              });
            } else {
              return item;
            }
          });
          _this11.setState({
            loaiVanBanSuggest: 'XLD_PDXTL',
            ngayQuyetDinhSuggest: _this11.state.ngayRaThongBaoThuLy,
            listTaiLieuVanThu: newFileArr
          });
          _this11.getThoiHanGQDonMacDinh();
        }
        if (name == 'ngayRaThongBaoTTXM') {
          _this11.setState({
            loaiVanBanSuggest: 'XLD_GTTXM',
            ngayQuyetDinhSuggest: _this11.state.ngayRaThongBaoTTXM
          });
          _this11.getThoiHanTTXMMacDinh();
        }
        if (name == 'hanGiaiQuyet') {
          _this11.checkHanGiaiQuyet();
        }
        _this11.trigger(newState, false);
      });
    }
  }, {
    key: 'trigger',
    value: function trigger(newState, isInit) {
      if (newState.nextState) {
        var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
        var params = {
          yKienXuLy: newState.noiDung,
          nextState: {
            id: Number(newState.nextState)
          }
        };

        if (newState.form_HuongXuLy) {
          params.huongXuLy = newState.huongXuLy || null;

          if (newState.thamQuyenGiaiQuyet && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.luuDonVaTheoDoi) params.thamQuyenGiaiQuyet = {
            id: Number(newState.thamQuyenGiaiQuyet)
          };

          if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy) {

            params.notice = _message.msg.xldChuyenGiaiQuyetDon;
            params.hanGiaiQuyet = (0, _moment2.default)(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours');
            params.trangThaiTTXM = newState.trangThaiTTXM || null;

            if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoThuLy) {
              params.ngayRaThongBaoThuLy = (0, _moment2.default)(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
            }

            if (newState.trangThaiTTXM == "TU_TTXM") {

              if (newState.phongBanGiaiQuyet) params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };

              if (newState.truongPhongChiDinh) params.canBoXuLyChiDinh = { id: Number(newState.truongPhongChiDinh) };
            } else if (newState.trangThaiTTXM == "GIAO_TTXM") {

              if (newState.donViThamTraXacMinh) {
                params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
                params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
              }

              if (newState.thoiHanBaoCaoKetQuaTTXM) {
                params.thoiHanBaoCaoKetQuaTTXM = (0, _moment2.default)(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }

              if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') && newState.ngayRaThongBaoTTXM) {
                params.ngayRaThongBaoTTXM = (0, _moment2.default)(newState.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
              }
            }
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.chuyenDon) {

            if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
              params.notice = _message.msg.xldChuyenDon;
              params.coQuanTiepNhan = {
                id: Number(newState.coQuanTiepNhan),
                ten: newState.coQuanTiepNhanTen
              };
            } else {
              params.notice = _message.msg.xldLuuHoSo;
              params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
              params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
            }
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

            params.notice = _message.msg.xldYeuCauGapLanhDao;
          } else if (newState.huongXuLy == _processType.processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen) {

            params.notice = _message.msg.xldTraDon;
          } else if (newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.chuyenDon && newState.huongXuLy != _processType.processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

            params.notice = _message.msg.xldLuuHoSo;
          }
        }
        this.props.onChange(params, isInit);
      } else {

        var _params = {
          yKienXuLy: newState.noiDung
        };
        this.props.onChange(_params, isInit);
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      var temp = {
        dataFileDinhKem: data,
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      };
      this.setState(_extends({}, temp));
      this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      var oldData = [].concat(_toConsumableArray(this.state.dataFileDinhKem));
      var tbtlDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbtlOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_PDXTL';
      });
      var tbTTXMDate = data.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      var tbTTXMOldDate = oldData.filter(function (item) {
        return item.typeRequired == 'XLD_GTTXM';
      });
      if (tbtlDate.length > 0 && this.props.loaiDonGiaTri != 'DON_KIEN_NGHI_PHAN_ANH') {
        if (tbtlOldDate.length > 0 && (0, _moment2.default)(tbtlOldDate[0].ngayQuyetDinh).isSame(tbtlDate[0].ngayQuyetDinh) == false || tbtlOldDate.length == 0) {
          this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
          this.getThoiHanGQDonMacDinh();
        }
      }
      if (tbTTXMDate.length > 0) {
        if (tbTTXMOldDate.length > 0 && (0, _moment2.default)(tbTTXMOldDate[0].ngayQuyetDinh).isSame(tbTTXMDate[0].ngayQuyetDinh) == false || tbTTXMOldDate.length == 0) {
          this.state.ngayRaThongBaoTTXM = tbTTXMDate[0].ngayQuyetDinh;
          this.getThoiHanTTXMMacDinh();
          if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' && this.state.ngayRaThongBaoTTXM) {
            this.state.ngayRaThongBaoThuLy = tbTTXMDate[0].ngayQuyetDinh;
            this.getThoiHanGQDonMacDinh();
          }
        }
      }
      this.setState({
        dataFileDinhKem: data
      });

      this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
    }
  }, {
    key: 'searchDonVi',
    value: function searchDonVi(tuKhoa) {
      var inputParams = {
        size: 5,
        page: 0
      };

      inputParams.ten = tuKhoa;

      return _api.Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          return Promise.resolve({
            result: res.data._embedded.donViNgoaiHeThongs,
            page: res.data.page
          });
        } else {
          return Promise.resolve(null);
        }
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'onChangeSuggest',
    value: function onChangeSuggest(name, value) {
      this.state[name] = value;
      this.state.donViNgoaiHeThongId = '';
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'onSelectedSuggest',
    value: function onSelectedSuggest(item) {
      this.state.donViNgoaiHeThong = item.ten;
      this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
      this.setState(_extends({}, this.state));
      this.trigger(this.state, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
      var lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'div',
        { className: 'items-form mb0-18' },
        _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChange, open: this.state.popupConfirmHXL, onClose: this.confirmChangeHuongXuLy.bind(this, false), onSuccess: this.confirmChangeHuongXuLy.bind(this, true) }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.form_HuongXuLy },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 mt10' },
            _react2.default.createElement(_ttForms.DropDownChonHuongXuLyTheoDon, { require: true,
              selectedValue: this.state.huongXuLy,
              donId: this.props.donId,
              loaiDon: this.props.loaiDonGiaTri,
              label: 'Giao x\u1EED l\xFD',
              onChange: this.handleChange.bind(this, 'huongXuLy'),
              className: 'col-3',
              bindValidator: this,
              name: 'dropdownChonHuongXuLyTheoDon' }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy != 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy != 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' },
              _react2.default.createElement(_ttForms.DropDownChonNhomThamQuyenGiaiQuyet, { require: true,
                selectedValue: this.state.thamQuyenGiaiQuyet,
                label: 'Nh\xF3m th\u1EA9m quy\u1EC1n gi\u1EA3i quy\u1EBFt',
                className: 'col-3',
                onChange: this.handleChange.bind(this, 'thamQuyenGiaiQuyet'),
                bindValidator: this,
                name: 'dropdownChonNhomThamQuyenGiaiQuyet' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                _react2.default.createElement(_common.DatePicker, { require: true,
                  className: 'col-25',
                  value: this.state.ngayRaThongBaoThuLy,
                  label: 'Ng\xE0y ra th\xF4ng b\xE1o th\u1EE5 l\xFD',
                  name: 'ngayRaThongBaoThuLy',
                  onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy'),
                  bindValidator: this,
                  channel: 'formTaoDon' })
              ),
              _react2.default.createElement(_common.DatePicker, { require: true,
                className: 'col-25',
                value: this.state.hanGiaiQuyet,
                label: 'H\u1EA1n gi\u1EA3i quy\u1EBFt',
                name: 'hanGiaiQuyet',
                startDate: (0, _moment2.default)(new Date()).subtract(1, "days"),
                onChange: this.handleChangeDate.bind(this, 'hanGiaiQuyet'),
                bindValidator: this,
                channel: 'formTaoDon' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huongXuLy == 'CHUYEN_DON' && this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId },
              _react2.default.createElement(_common.DropDownTreeSelectOneElement, { label: 'C\u01A1 quan ti\u1EBFp nh\u1EADn', className: 'tree-selected', placeholder: true, dataOptions: this.props.coQuanTiepNhanList, value: this.state.coQuanTiepNhan, onChange: this.handleChange.bind(this, 'coQuanTiepNhan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', name: 'dropdownChonCoQuanTiepNhan', bindValidator: this, channel: 'formTaoDon', require: true })
            ),
            this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ? _react2.default.createElement(_autoComplete.AutoSuggest, {
              label: '\u0110\u01A1n v\u1ECB',
              className: 'col-3',
              placeholder: 'Nh\u1EADp...',
              onSearch: this.searchDonVi,
              onChange: this.onChangeSuggest.bind(this, 'donViNgoaiHeThong'),
              onSelected: this.onSelectedSuggest.bind(this),
              value: this.state.donViNgoaiHeThong,
              maxLength: 40
            }) : ''
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.huongXuLy == _processType.processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_ttForms.DropDownChonQuyTrinhGiaiQuyetDon, {
                className: 'col-25',
                donId: this.props.donId,
                bindValidator: this,
                require: true,
                loaiDon: this.props.loaiDonGiaTri,
                isValid: this.props.validate,
                selectedValue: this.state.trangThaiTTXM,
                onChange: this.handleChange.bind(this, 'trangThaiTTXM'),
                name: 'dropdownChonTrangThaiTTXM' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.trangThaiTTXM == 'GIAO_TTXM' },
                _react2.default.createElement(_ttForms.DropDownChonDonViTTXM, {
                  className: 'col-25',
                  bindValidator: this,
                  require: true,
                  loaiDon: this.props.loaiDonGiaTri,
                  isValid: this.props.validate,
                  selectedValue: this.state.donViThamTraXacMinh,
                  onChange: this.handleChange.bind(this, 'donViThamTraXacMinh'),
                  name: 'dropdownChonDonViTTXM' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' },
                  _react2.default.createElement(_common.DatePicker, { require: true,
                    className: 'col-25',
                    value: this.state.ngayRaThongBaoTTXM,
                    label: 'Ngày ra QĐ giao nhiệm vụ ' + lb1,
                    name: 'ngayRaThongBaoTTXM',
                    onChange: this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM'),
                    bindValidator: this,
                    channel: 'formTaoDon' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title mb0' },
                      'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content pt17 txt-danger' },
                      this.state.thoiHanBaoCaoKetQuaTTXM
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.TextArea, {
              require: this.state.requireText,
              label: this.state.lblTextArea,
              rows: '3',
              value: this.state.noiDung ? this.state.noiDung : '',
              onChange: this.handleChange.bind(this, 'noiDung'),
              bindValidator: this,
              channel: 'formTaoDon',
              name: 'textareaYKienCanBoXuLyDon' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_InPhieu2.default, { inPhieu: this.props.inPhieu.bind(this),
              huongXuLy: this.state.huongXuLy,
              loaiDonGiaTri: this.props.loaiDonGiaTri,
              trangThaiTTXM: this.state.trangThaiTTXM || null })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.renderContainer },
            _react2.default.createElement(
              'div',
              { className: 'container-filedinhkem mt15' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                bindValidator: this,
                data: this.state.listTaiLieuVanThu,
                dataShow: this.state.dataShow,
                onSave: this.props.onSave,
                loaiVanBanSuggest: this.state.loaiVanBanSuggest,
                ngayQuyetDinhSuggest: this.state.ngayQuyetDinhSuggest,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this)
              })
            )
          )
        )
      );
    }
  }]);

  return TuXuLy;
}(_react2.default.Component);

TuXuLy.defaultProps = {
  listNextStates: [],
  coQuanTiepNhanList: [],
  validate: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  getState: function getState() {
    console.log('Need to assign getState method');
  },
  onSave: false
};

function bindStateToProps(state) {
  return {
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(TuXuLy));

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Card = function (_React$Component) {
  _inherits(Card, _React$Component);

  function Card(props) {
    _classCallCheck(this, Card);

    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          titleColor = _props.titleColor,
          icon = _props.icon,
          bgColor = _props.bgColor,
          bgIcon = _props.bgIcon,
          total = _props.total,
          totalColor = _props.totalColor,
          extend = _props.extend,
          totalDone = _props.totalDone,
          totalInprogress = _props.totalInprogress;


      return _react2.default.createElement(
        'div',
        { className: 'card', style: { backgroundColor: bgColor } },
        _react2.default.createElement(
          'div',
          { className: 'card-left', style: { backgroundColor: bgIcon } },
          _react2.default.createElement('span', { className: icon })
        ),
        _react2.default.createElement(
          'div',
          { className: 'card-right' },
          _react2.default.createElement(
            'span',
            { className: 'card-right__title', style: { color: titleColor } },
            title
          ),
          _react2.default.createElement(
            'span',
            { className: 'card-right__total', style: { color: totalColor } },
            total
          )
        ),
        extend && _react2.default.createElement(
          'div',
          { className: 'extend' },
          _react2.default.createElement(
            'span',
            { className: 'extend__done' },
            totalDone,
            ' ho\xE0n th\xE0nh'
          ),
          _react2.default.createElement(
            'span',
            { className: 'extend__inprogress' },
            totalInprogress,
            ' \u0111ang thanh tra'
          )
        )
      );
    }
  }]);

  return Card;
}(_react2.default.Component);

exports.default = Card;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _recharts = __webpack_require__(426);

var _ttForms = __webpack_require__(19);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderCustomizedLabel = function renderCustomizedLabel(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      midAngle = _ref.midAngle,
      innerRadius = _ref.innerRadius,
      outerRadius = _ref.outerRadius,
      percent = _ref.percent,
      index = _ref.index;

  return (percent * 100).toFixed(0) + '%';
};

var CircleChart = function (_React$Component) {
  _inherits(CircleChart, _React$Component);

  function CircleChart(props, context) {
    _classCallCheck(this, CircleChart);

    var _this = _possibleConstructorReturn(this, (CircleChart.__proto__ || Object.getPrototypeOf(CircleChart)).call(this, props, context));

    _this.state = {
      isOpen: true,
      dataColor: [{ color: '#fd9c35' }, { color: '#fec42c' }, { color: '#5578c2' }, { color: '#5793f3' }, { color: '#37c93c' }, { color: '#ff0000' }, { color: '#ffff00' }, { color: '#00ffff' }, { color: '#bf00ff' }, { color: '#bfff00' }],
      data: _this.props.data,
      loaiLinhVucDon: _this.props.loaiLinhVucDon,
      title: _this.props.title,
      hasDropDown: _this.props.hasDropDown
    };
    return _this;
  }

  _createClass(CircleChart, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        hasDropDown: nextProps.hasDropDown,
        title: nextProps.title,
        data: nextProps.data,
        loaiLinhVucDon: nextProps.loaiLinhVucDon
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        loaiLinhVucDon: e.target.value
      });
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-collapse col-6' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-shadow' },
          _react2.default.createElement(
            'h2',
            { className: this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close" },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleCollapse.bind(this) },
              this.state.title
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { className: 'letter-count-wrap', isOpen: this.state.isOpen },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.hasDropDown },
              _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { page: this.props.page, label: null, selectedValue: this.state.loaiLinhVucDon, placeholder: null, className: 'input-20 dropdown-collapses', onChange: this.onChange.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.data.length > 0 },
              _react2.default.createElement(
                _recharts.ResponsiveContainer,
                { width: '100%', height: 400 },
                _react2.default.createElement(
                  _recharts.PieChart,
                  null,
                  _react2.default.createElement(_recharts.Legend, { iconType: 'circle', iconSize: 10, margin: { top: 40 } }),
                  _react2.default.createElement(_recharts.Tooltip, null),
                  _react2.default.createElement(
                    _recharts.Pie,
                    {
                      data: this.state.data,
                      dataKey: 'value',
                      nameKey: 'name',
                      startAngle: 90,
                      endAngle: 450,
                      innerRadius: 50,
                      labelLine: true,
                      label: renderCustomizedLabel,
                      fill: '#82ca9d' },
                    this.state.data.map(function (entry, index) {
                      return _react2.default.createElement(_recharts.Cell, { key: index, fill: _this2.state.dataColor[index].color });
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.data.length == 0 },
              _react2.default.createElement(
                'div',
                { className: 'pl15 pt35 pr15 pb45 txt-center' },
                _react2.default.createElement(
                  'i',
                  { className: 'text-13' },
                  'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CircleChart;
}(_react2.default.Component);

CircleChart.defaultProps = {
  title: '',
  hasDropDown: false,
  loaiDon: 'DON_KHIEU_NAI',
  data: []
};

exports.default = CircleChart;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _api = __webpack_require__(5);

var _htmlToDraftjs = __webpack_require__(631);

var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);

var _draftJs = __webpack_require__(265);

var _reactDraftWysiwyg = __webpack_require__(820);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Help = function (_React$Component) {
  _inherits(Help, _React$Component);

  function Help(props, context) {
    _classCallCheck(this, Help);

    var _this = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this, props, context));

    _this.state = {
      label: '',
      content: ''
    };
    return _this;
  }

  _createClass(Help, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this2 = this;

      _api.Danhmuc.actions.getHuongDanSuDung.request().then(function (res) {
        if (res.data && res.data._embedded && res.data._embedded.huongDanSuDungs) {
          var contentBlock = (0, _htmlToDraftjs2.default)(res.data._embedded.huongDanSuDungs[0].noiDung);
          var contentState = _draftJs.ContentState.createFromBlockArray(contentBlock.contentBlocks);
          var editorState = _draftJs.EditorState.createWithContent(contentState);
          _this2.setState({
            label: res.data._embedded.huongDanSuDungs[0].ten,
            content: editorState
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                this.state.label
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'section',
              { className: 'page-wrapper', style: { padding: '0px 20px' } },
              _react2.default.createElement(_reactDraftWysiwyg.Editor, {
                readOnly: true,
                editorState: this.state.content,
                wrapperClassName: 'wrapper-editor mb18',
                editorClassName: 'container-editor',
                editorStyle: {
                  minHeight: 350,
                  border: "none",
                  height: "auto"
                },
                toolbarHidden: true
              })
            )
          )
        )
      );
    }
  }]);

  return Help;
}(_react2.default.Component);

exports.default = Help;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _layout = __webpack_require__(9);

var _lodash = __webpack_require__(14);

var _home = __webpack_require__(484);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRouter = __webpack_require__(2);

var _recharts = __webpack_require__(426);

__webpack_require__(1979);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_React$Component) {
  _inherits(Home, _React$Component);

  function Home(props, context) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props, context));

    _this.state = {
      dataOptions: [],
      coQuanQuanLyID: null,
      countKeHoachThanhTra: null,
      countDanhMucCuocThanhTra: null,
      countTheoDoiCuocThanhTra: null,
      countTheoDoiCuocThanhTraTheoNam: [],
      isShowComboxboxDonVi: false,
      listNamThanhTra: [],
      namThanhTra: new Date().getFullYear()
    };
    return _this;
  }

  _createClass(Home, [{
    key: 'getListDV',
    value: function getListDV() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      _api.DuLieuHeThong.actions.getDonViThongKe.request().then(function (res) {
        if (res.data._embedded) {
          var dataDonVi = [].concat(_toConsumableArray(res.data._embedded.coQuanQuanLies));
          var DonVi = dataDonVi.filter(function (state) {
            return state.coQuanQuanLyId == userInfo.donViId;
          });
          _this2.setState({
            dataSelected: [{ value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }],
            dataOptions: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'DonVi') {
        this.setState({
          coQuanQuanLyID: e.target.value
        });
      }
      if (name == 'namThanhTra') {
        this.setState({
          namThanhTra: e.target.value
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      this.setState({ coQuanQuanLyID: userInfo.donViId || null });
      if (typeof _reactCookie2.default.load('accessToken') === 'undefined') {
        _reactRouter.browserHistory.push('/dang-nhap');
      } else {
        this.getCheckLuaChonDonVi();
        this.getListDV();
        this.getCountKeHoachThanhTra();
        this.getCountDanhMucCuocThanhTra();
        this.getCountTheoDoiCuocThanhTra();
        this.getCountTheoDoiCuocThanhTraTheoNam();
        this.getNamThanhTra();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.coQuanQuanLyID !== this.state.coQuanQuanLyID || prevState.namThanhTra !== this.state.namThanhTra) {
        this.getCheckLuaChonDonVi();
        this.getCountKeHoachThanhTra();
        this.getCountDanhMucCuocThanhTra();
        this.getCountTheoDoiCuocThanhTra();
        this.getCountTheoDoiCuocThanhTraTheoNam();
      }
    }
  }, {
    key: 'getCountKeHoachThanhTra',
    value: function getCountKeHoachThanhTra() {
      var _this3 = this;

      _api.TrangChu.actions.getCountKeHoachThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this3.setState({
            countKeHoachThanhTra: data
          });
        }
      });
    }
  }, {
    key: 'getCountDanhMucCuocThanhTra',
    value: function getCountDanhMucCuocThanhTra() {
      var _this4 = this;

      _api.TrangChu.actions.getCountDanhMucCuocThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this4.setState({
            countDanhMucCuocThanhTra: data
          });
        }
      });
    }
  }, {
    key: 'getCountTheoDoiCuocThanhTra',
    value: function getCountTheoDoiCuocThanhTra() {
      var _this5 = this;

      _api.TrangChu.actions.getCountTheoDoiCuocThanhTra.request(null, { donViId: this.state.coQuanQuanLyID, namThanhTra: this.state.namThanhTra }).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this5.setState({
            countTheoDoiCuocThanhTra: data
          });
        }
      });
    }
  }, {
    key: 'getCountTheoDoiCuocThanhTraTheoNam',
    value: function getCountTheoDoiCuocThanhTraTheoNam() {
      var _this6 = this;

      _api.TrangChu.actions.getCountTheoDoiCuocThanhTraTheoNam.request(null, { donViId: this.state.coQuanQuanLyID }).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this6.setState({
            countTheoDoiCuocThanhTraTheoNam: data.map(function (item) {
              return {
                'Số cuộc Thanh Tra': item.totalCountCuocThanhTra,
                name: item.namThanhTra
              };
            })
          });
        }
      });
    }
  }, {
    key: 'getCheckLuaChonDonVi',
    value: function getCheckLuaChonDonVi() {
      var _this7 = this;

      _api.TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(function (res) {
        var data = res.data;

        _this7.setState(_extends({}, _this7.state, {
          isShowComboxboxDonVi: data
        }));
      });
    }
  }, {
    key: 'getNamThanhTra',
    value: function getNamThanhTra() {
      var _this8 = this;

      _api.DuLieuHeThong.actions.getNamThanhTra.request(null, {}).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this8.setState({
            listNamThanhTra: data
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          countKeHoachThanhTra = _state.countKeHoachThanhTra,
          countDanhMucCuocThanhTra = _state.countDanhMucCuocThanhTra,
          countTheoDoiCuocThanhTra = _state.countTheoDoiCuocThanhTra,
          countTheoDoiCuocThanhTraTheoNam = _state.countTheoDoiCuocThanhTraTheoNam;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'home-page', ref: 'home' },
          _react2.default.createElement(
            'div',
            { className: 'home-header' },
            _react2.default.createElement(
              'h2',
              { className: 'home-header__title' },
              'Trang ch\u1EE7'
            ),
            _react2.default.createElement(
              'div',
              { className: 'home-search' },
              _react2.default.createElement(
                'div',
                { className: 'home-search-group' },
                _react2.default.createElement(
                  'span',
                  { className: 'home-search-group__label' },
                  'N\u0103m'
                ),
                _react2.default.createElement(_common.DropDown, { className: 'combobox-nam-thanh-tra', label: '', selectedValue: this.state.namThanhTra, placeholder: null, onChange: this.onChange.bind(this, 'namThanhTra'), options: this.state.listNamThanhTra, valueName: 'ten', keyName: 'giaTri' })
              ),
              this.state.isShowComboxboxDonVi && _react2.default.createElement(
                'div',
                { className: 'home-search-group' },
                _react2.default.createElement(
                  'span',
                  { className: 'home-search-group__label' },
                  '\u0110\u01A1n v\u1ECB'
                ),
                _react2.default.createElement(_common.DropDownTreeSelectOneElement, { className: 'col-6 mb0-18 tree-selected', dataOptions: this.state.dataOptions, value: this.state.coQuanQuanLyID, onChange: this.onChange.bind(this, 'DonVi'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'home-content' },
            _react2.default.createElement(
              'h3',
              { className: 'home-content__title' },
              'K\u1EBF ho\u1EA1ch thanh tra'
            ),
            _react2.default.createElement(
              'div',
              { className: 'cards' },
              _react2.default.createElement(_home.Card, { title: 'T\u1ED5ng k\u1EBF ho\u1EA1ch thanh tra',
                titleColor: '#fff',
                icon: 'tt-documentation',
                bgIcon: '#80b7e3',
                total: (0, _lodash.get)(countKeHoachThanhTra, 'totalCount', 0) || 0,
                totalColor: '#fff',
                bgColor: '#016FC6'
              }),
              _react2.default.createElement(_home.Card, { title: '\u0110\xE3 c\xF3 quy\u1EBFt \u0111\u1ECBnh',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-document-check',
                bgIcon: '#05C1B2',
                total: (0, _lodash.get)(countKeHoachThanhTra, 'countDaCoQuyetDinh', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff'
              }),
              _react2.default.createElement(_home.Card, { title: 'Ch\u01B0a c\xF3 quy\u1EBFt \u0111\u1ECBnh',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-document-time',
                bgIcon: '#3C47BB',
                total: (0, _lodash.get)(countKeHoachThanhTra, 'countChoRaQuyetDinh', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff'
              })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'home-content__title' },
              'Danh m\u1EE5c cu\u1ED9c thanh tra'
            ),
            _react2.default.createElement(
              'div',
              { className: 'cards' },
              _react2.default.createElement(_home.Card, { title: 'T\u1ED5ng cu\u1ED9c thanh tra',
                titleColor: '#fff',
                icon: 'tt-document-search',
                bgIcon: '#88c3fc',
                total: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTra', 0) || 0,
                totalColor: '#fff',
                bgColor: '#1187F8'
              }),
              _react2.default.createElement(_home.Card, { title: 'Theo k\u1EBF ho\u1EA1ch',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-calendar',
                bgIcon: '#05C1B2',
                total: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoach', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff',
                extend: true,
                totalDone: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoachDaHoanThanh', 0) || 0,
                totalInprogress: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraKeHoachDangThanhTra', 0) || 0
              }),
              _react2.default.createElement(_home.Card, { title: '\u0110\u1ED9t xu\u1EA5t',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-deadline',
                bgIcon: '#FD6114',
                total: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuat', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff',
                extend: true,
                totalDone: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuatDaThanhTra', 0) || 0,
                totalInprogress: (0, _lodash.get)(countDanhMucCuocThanhTra, 'totalCountCuocThanhTraDotXuatDangThanhTra', 0) || 0
              })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'home-content__title' },
              'Theo d\xF5i cu\u1ED9c thanh tra'
            ),
            _react2.default.createElement(
              'div',
              { className: 'cards' },
              _react2.default.createElement(_home.Card, { title: 'T\u1ED5ng cu\u1ED9c thanh tra',
                titleColor: '#fff',
                icon: 'tt-document-duplicate',
                bgIcon: '#82e0d8',
                total: (0, _lodash.get)(countTheoDoiCuocThanhTra, 'totalCount', 0) || 0,
                totalColor: '#fff',
                bgColor: '#05C1B2'
              }),
              _react2.default.createElement(_home.Card, { title: 'Ho\xE0n th\xE0nh',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-check-list',
                bgIcon: '#016FC6',
                total: (0, _lodash.get)(countTheoDoiCuocThanhTra, 'totalCountCuocThanhTra', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff'
              }),
              _react2.default.createElement(_home.Card, { title: '\u0110ang theo d\xF5i',
                titleColor: 'rgba(25, 40, 47, 0.6)',
                icon: 'tt-clipboard',
                bgIcon: '#D42991',
                total: (0, _lodash.get)(countTheoDoiCuocThanhTra, 'totalCountCuocThanhTraTheoDoi', 0) || 0,
                totalColor: '#19282F',
                bgColor: '#fff'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'chart', style: { width: '100%', height: "432px" } },
              _react2.default.createElement(
                'h3',
                { className: 'chart__title' },
                'Bi\u1EC3u \u0111\u1ED3 T\u1ED5ng s\u1ED1 cu\u1ED9c thanh tra theo n\u0103m'
              ),
              _react2.default.createElement(
                _recharts.ResponsiveContainer,
                null,
                _react2.default.createElement(
                  _recharts.BarChart,
                  { width: 900, height: 432, data: countTheoDoiCuocThanhTraTheoNam, barSize: 37, margin: {
                      top: 0,
                      right: 0,
                      left: 0,
                      bottom: 30
                    } },
                  _react2.default.createElement(_recharts.XAxis, { dataKey: 'name' }),
                  _react2.default.createElement(_recharts.YAxis, null),
                  _react2.default.createElement(_recharts.Tooltip, null),
                  _react2.default.createElement(_recharts.Bar, { dataKey: 'S\u1ED1 cu\u1ED9c Thanh Tra', fill: '#016FC6' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Home;
}(_react2.default.Component);

exports.default = Home;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LettersCount = function (_React$Component) {
  _inherits(LettersCount, _React$Component);

  function LettersCount(props, context) {
    _classCallCheck(this, LettersCount);

    var _this = _possibleConstructorReturn(this, (LettersCount.__proto__ || Object.getPrototypeOf(LettersCount)).call(this, props, context));

    _this.state = {
      isOpen: true,
      data: _this.props.data,
      title: _this.props.title
    };
    return _this;
  }

  _createClass(LettersCount, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.data,
        title: nextProps.title
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isDonViCha = this.props.isDonViCha;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var getStyle = this.props.isTotal || !this.props.isDonViCon ? { width: '100%', paddingBottom: 0 } : {};
      var getLinkDonViCha = function getLinkDonViCha(value, type) {
        var trangThaiDon = '';
        var quyenLanhDao = '&chiThuocQuyenLanhDao=true';
        if (type === 'DA_XU_LY') {
          trangThaiDon = '&trangThaiDon=DA_XU_LY&trangThaiDon=DA_GIAI_QUYET';
        }
        if (type === 'DANG_XU_LY') {
          trangThaiDon = '&trangThaiDon=DANG_XU_LY&trangThaiDon=DANG_GIAI_QUYET';
        }
        if (type === 'TRONGKY') {
          trangThaiDon = '&ky=' + type;
        }
        if (type === 'KYTRUOC') {
          trangThaiDon = '&ky=' + type;
        }
        if (_this2.props.link) {
          var currentYear = (0, _moment2.default)().year();
          localStorage.setItem('tdgstk.year', currentYear);
          return _react2.default.createElement(
            _reactRouter.Link,
            { to: '/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=' + userInfo.donViId + trangThaiDon + quyenLanhDao, className: 'txt-underline' },
            value
          );
        }
        return value;
      };
      return _react2.default.createElement(
        'section',
        {
          style: getStyle,
          className: 'wrap-collapse pt30 col-6'
        },
        _react2.default.createElement(
          'div',
          { className: 'wrap-shadow' },
          _react2.default.createElement(
            'h2',
            { className: this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close" },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleCollapse.bind(this) },
              this.state.title
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { className: 'row pl15 pr15 pb20', isOpen: this.state.isOpen },
            isDonViCha && _react2.default.createElement(
              'div',
              { className: 'row d-flex' },
              _react2.default.createElement(
                'div',
                { className: 'col-8' },
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('sum-default col-6 mb5', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })
                  },
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-title' },
                    'Ti\u1EBFp nh\u1EADn trong k\u1EF3'
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-val' },
                    this.state.data.trongKy ? getLinkDonViCha(this.state.data.trongKy, 'TRONGKY') : 0
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('sum-default col-6 mb5', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })
                  },
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-title' },
                    'K\u1EF3 tr\u01B0\u1EDBc chuy\u1EC3n sang'
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-val' },
                    this.state.data.kyTruoc ? getLinkDonViCha(this.state.data.kyTruoc, 'KYTRUOC') : 0
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('sum-default col-6', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })
                  },
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-title' },
                    '\u0110\u01A1n \u0111ang XL\u0110, GQ\u0110'
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-val' },
                    this.state.data.donDangXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDangXuLyGiaiQuyet, 'DANG_XU_LY') : 0
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('sum-default col-6', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })
                  },
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-title' },
                    '\u0110\u01A1n \u0111\xE3 XL\u0110, GQ\u0110'
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-val' },
                    this.state.data.donDaXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDaXuLyGiaiQuyet, 'DA_XU_LY') : 0
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-4' },
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)('sum-default donvicha', {
                      'total-letter': this.props.isTotal,
                      'sum-letter': !this.props.isTotal
                    })
                  },
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-title' },
                    'T\u1ED5ng \u0111\u01A1n '
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'sum-val' },
                    this.state.data.tongSoDon ? getLinkDonViCha(this.state.data.tongSoDon) : 0
                  )
                )
              )
            ),
            !isDonViCha && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                    'sum-letter col-4': !this.props.isTotal
                  })
                },
                _react2.default.createElement(
                  'p',
                  { className: 'sum-title' },
                  'T\u1ED5ng \u0111\u01A1n '
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'sum-val' },
                  this.state.data.tongSoDon ? getLinkDonViCha(this.state.data.tongSoDon) : 0
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                    'sum-letter col-4': !this.props.isTotal
                  })
                },
                _react2.default.createElement(
                  'p',
                  { className: 'sum-title' },
                  '\u0110\u01A1n \u0111ang XL\u0110, GQ\u0110'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'sum-val' },
                  this.state.data.donDangXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDangXuLyGiaiQuyet, 'DANG_XU_LY') : 0
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                    'sum-letter col-4': !this.props.isTotal
                  })
                },
                _react2.default.createElement(
                  'p',
                  { className: 'sum-title' },
                  '\u0110\u01A1n \u0111\xE3 XL\u0110, GQ\u0110'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'sum-val' },
                  this.state.data.donDaXuLyGiaiQuyet ? getLinkDonViCha(this.state.data.donDaXuLyGiaiQuyet, 'DA_XU_LY') : 0
                )
              ),
              this.props.isTotal && _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('sum-default', {
                    'total-letter col-3': this.props.isTotal,
                    'sum-letter col-4': !this.props.isTotal
                  })
                },
                _react2.default.createElement(
                  'p',
                  { className: 'sum-title' },
                  '\u0110\u01A1n chuy\u1EC3n \u0111\u01A1n v\u1ECB ngo\xE0i'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'sum-val' },
                  this.state.data.donChuyenDonViNgoai || 0
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LettersCount;
}(_react2.default.Component);

LettersCount.defaultProps = {
  title: '',
  data: []
};

exports.default = LettersCount;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _dataTable3 = __webpack_require__(1219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LettersTable = function (_React$Component) {
  _inherits(LettersTable, _React$Component);

  function LettersTable(props, context) {
    _classCallCheck(this, LettersTable);

    var _this = _possibleConstructorReturn(this, (LettersTable.__proto__ || Object.getPrototypeOf(LettersTable)).call(this, props, context));

    _this.state = {
      isOpen: true
    };
    return _this;
  }

  _createClass(LettersTable, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-collapse col-6 pb30 collapse-table' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-shadow' },
          _react2.default.createElement(
            'h2',
            { className: this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close" },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleCollapse.bind(this) },
              this.props.title
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { className: 'letter-collapse-wrap', isOpen: this.state.isOpen },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  dataList: this.props.data,
                  header: _table.header.home.letterTable,
                  hidePagination: true },
                _react2.default.createElement(_dataTable3.RowItemLetterTable, { type: this.props.type, onClickDetail: this.props.onClickDetail })
              )
            )
          )
        )
      );
    }
  }]);

  return LettersTable;
}(_react2.default.Component);

exports.default = LettersTable;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _recharts = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultipleChart = function (_React$Component) {
  _inherits(MultipleChart, _React$Component);

  function MultipleChart(props, context) {
    _classCallCheck(this, MultipleChart);

    var _this = _possibleConstructorReturn(this, (MultipleChart.__proto__ || Object.getPrototypeOf(MultipleChart)).call(this, props, context));

    _this.state = {
      isOpen: true
    };
    return _this;
  }

  _createClass(MultipleChart, [{
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-collapse-100' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-shadow' },
          _react2.default.createElement(
            'h2',
            { className: this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close" },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleCollapse.bind(this) },
              this.props.title
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { isOpen: this.state.isOpen },
            _react2.default.createElement(
              _recharts.ResponsiveContainer,
              { width: '95%', height: 400 },
              _react2.default.createElement(
                _recharts.ComposedChart,
                { data: this.props.data },
                _react2.default.createElement(_recharts.XAxis, { dataKey: 'name' }),
                _react2.default.createElement(_recharts.YAxis, { allowDecimals: false }),
                _react2.default.createElement(_recharts.Legend, null),
                _react2.default.createElement(_recharts.Tooltip, null),
                _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: '3 3' }),
                _react2.default.createElement(_recharts.Bar, { dataKey: 'Khi\u1EBFu n\u1EA1i', barSize: 20, fill: '#fd9c35' }),
                _react2.default.createElement(_recharts.Bar, { dataKey: 'T\u1ED1 c\xE1o', barSize: 20, fill: '#fec42c' }),
                _react2.default.createElement(_recharts.Bar, { dataKey: 'Ki\u1EBFn ngh\u1ECB, ph\u1EA3n \xE1nh', barSize: 20, fill: '#5578c2' }),
                _react2.default.createElement(_recharts.Bar, { dataKey: 'Tranh ch\u1EA5p \u0111\u1EA5t', barSize: 20, fill: '#5793f3' }),
                _react2.default.createElement(_recharts.Line, { dataKey: 'T\u1ED5ng s\u1ED1 \u0111\u01A1n', stroke: '#1d89f2' }),
                _react2.default.createElement(_recharts.Line, { dataKey: '\u0110\u01A1n tr\u1EC5 h\u1EA1n x\u1EED l\xFD', stroke: '#e56900' }),
                _react2.default.createElement(_recharts.Line, { dataKey: '\u0110\u01A1n tr\u1EC5 h\u1EA1n gi\u1EA3i quy\u1EBFt', stroke: '#e50000' })
              )
            )
          )
        )
      );
    }
  }]);

  return MultipleChart;
}(_react2.default.Component);

exports.default = MultipleChart;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nfIcon = __webpack_require__(624);

var Page403 = function (_React$Component) {
  _inherits(Page403, _React$Component);

  function Page403() {
    _classCallCheck(this, Page403);

    return _possibleConstructorReturn(this, (Page403.__proto__ || Object.getPrototypeOf(Page403)).apply(this, arguments));
  }

  _createClass(Page403, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'div',
                { className: 'wrapper_box tc-box not-found' },
                _react2.default.createElement(
                  'div',
                  { className: 'box' },
                  _react2.default.createElement('img', { src: nfIcon, alt: 'not-found' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'B\u1EA1n kh\xF4ng c\xF3 quy\u1EC1n xem chi ti\u1EBFt \u0111\u01A1n n\xE0y'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Page403;
}(_react2.default.Component);

exports.default = Page403;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLetterTable = function (_React$Component) {
  _inherits(RowItemLetterTable, _React$Component);

  function RowItemLetterTable() {
    _classCallCheck(this, RowItemLetterTable);

    return _possibleConstructorReturn(this, (RowItemLetterTable.__proto__ || Object.getPrototypeOf(RowItemLetterTable)).apply(this, arguments));
  }

  _createClass(RowItemLetterTable, [{
    key: 'userAddress',
    value: function userAddress() {
      var user = this.props.item.listNguoiDungDon.length > 0 ? this.props.item.listNguoiDungDon[0] : [];
      var userAddress = '';
      if (user.diaChi) {
        userAddress = userAddress + user.diaChi;
      }
      if (user.toThon && userAddress == '') {
        userAddress = userAddress + user.toThon;
      } else if (user.toThon && userAddress != '') {
        userAddress = userAddress + ", " + user.toThon;
      }
      if (user.phuongXaCongDan && userAddress == '') {
        userAddress = userAddress + user.phuongXaCongDan.ten;
      } else if (user.phuongXaCongDan && userAddress != '') {
        userAddress = userAddress + ", " + user.phuongXaCongDan.ten;
      }
      if (user.quanHuyenCongDan && userAddress == '') {
        userAddress = userAddress + user.quanHuyenCongDan.ten;
      } else if (user.quanHuyenCongDan && userAddress != '') {
        userAddress = userAddress + ", " + user.quanHuyenCongDan.ten;
      }
      if (user.tinhThanhCongDan && userAddress == '') {
        userAddress = userAddress + user.tinhThanhCongDan.ten;
      } else if (user.tinhThanhCongDan && userAddress != '') {
        userAddress = userAddress + ", " + user.tinhThanhCongDan.ten;
      }

      return userAddress;
    }
  }, {
    key: 'handleClickDetail',
    value: function handleClickDetail() {
      this.props.onClickDetail(this.props.item, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-bold' },
              this.props.item.listNguoiDungDon.length ? this.props.item.listNguoiDungDon[0].hoVaTen : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.userAddress()
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.listNguoiDungDon.length ? this.props.item.listNguoiDungDon[0].soDienThoai : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: this.handleClickDetail.bind(this) },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'DON_TRE_HAN' },
              _react2.default.createElement(
                'li',
                { className: 'txt-danger' },
                "Đã trễ: " + (this.props.item.treHanGiaiQuyetDonInfo ? this.props.item.treHanGiaiQuyetDonInfo.value : '') + ' ngày'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemLetterTable;
}(_react2.default.Component);

exports.default = RowItemLetterTable;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemLetterTable = undefined;

var _RowItemLetterTable = __webpack_require__(1218);

var _RowItemLetterTable2 = _interopRequireDefault(_RowItemLetterTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemLetterTable = _RowItemLetterTable2.default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var LetterHistory = function (_React$Component) {
  _inherits(LetterHistory, _React$Component);

  function LetterHistory(props, context) {
    _classCallCheck(this, LetterHistory);

    var _this = _possibleConstructorReturn(this, (LetterHistory.__proto__ || Object.getPrototypeOf(LetterHistory)).call(this, props, context));

    _this.state = {
      DataLichSuQuaTrinhXuLy: [],
      isOpen: true
    };
    return _this;
  }

  _createClass(LetterHistory, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getQuyTrinhXuLyHistory(this.props.donId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.donId != this.props.donId) {
        this.getQuyTrinhXuLyHistory(nextProps.donId);
      }
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory(inputId) {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: inputId }).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({ DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuQuaTrinhXuLies });
        } else {
          _this2.setState({ DataLichSuQuaTrinhXuLy: [] });
        }
      });
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var listLichSuQuyTrinhXuLy = this.state.DataLichSuQuaTrinhXuLy.map(function (item, i) {

        var ngayXuLy = (0, _moment2.default)(item.ngayXuLy).format('DD/MM/YYYY - HH:mm');
        return _react2.default.createElement(
          'div',
          { key: i, className: 'history-items' },
          _react2.default.createElement(
            'div',
            { className: 'radio-column' },
            _react2.default.createElement(_core.Radio, { defaultChecked: true })
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-val' },
            _react2.default.createElement(
              'span',
              { className: 'txt-bold txt-upper' },
              item.ten == 'Đình chỉ' ? _this3.props.ma != '' ? 'Đình chỉ' : 'Rút đơn' : item.ten
            ),
            _react2.default.createElement(
              'span',
              { className: 'val-content' },
              ngayXuLy
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-val' },
            _react2.default.createElement(
              'span',
              { className: 'txt-bold' },
              'Ng\u01B0\u1EDDi x\u1EED l\xFD:'
            ),
            _react2.default.createElement(
              'span',
              { className: 'val-content' },
              item.nguoiXuLyText
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-val' },
            _react2.default.createElement(
              'span',
              { className: 'txt-bold' },
              'N\u1ED9i dung:'
            ),
            _react2.default.createElement(_common.TextMessage, {
              className: 'val-content',
              value: item.noiDung || '' })
          )
        );
      });

      var classTitle = ['rows'];
      var classHistory = ['wrap-history'];

      if (this.props.pageType == 'THEM_MOI_VA_CHINH_SUA_DON') {
        classTitle.push(['pl5', 'pr5']);
        classHistory.push(['pl5', 'pr5']);
      }

      return _react2.default.createElement(
        _utils.ShowIf,
        { condition: this.state.DataLichSuQuaTrinhXuLy.length > 0 },
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'box-items' },
            _react2.default.createElement(
              'div',
              { className: 'box-forward' },
              _react2.default.createElement(
                'div',
                { className: 'container-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'group-box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: classNames(classTitle) },
                      _react2.default.createElement(
                        'h3',
                        { className: this.state.isOpen ? " collapse-title collapse-open" : "collapse-title collapse-close" },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'title-14', onClick: this.handleCollapse.bind(this) },
                          'Qu\xE1 tr\xECnh x\u1EED l\xFD'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _core.Collapse,
                    { className: classNames(classHistory), isOpen: this.state.isOpen },
                    listLichSuQuyTrinhXuLy
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LetterHistory;
}(_react2.default.Component);

LetterHistory.defaultProps = {
  pageType: 'CHI_TIET_DON',
  donId: ''
};

exports.default = LetterHistory;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _letterDetail = __webpack_require__(168);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LetterDetail = function (_React$Component) {
  _inherits(LetterDetail, _React$Component);

  function LetterDetail() {
    _classCallCheck(this, LetterDetail);

    return _possibleConstructorReturn(this, (LetterDetail.__proto__ || Object.getPrototypeOf(LetterDetail)).apply(this, arguments));
  }

  _createClass(LetterDetail, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-blocks' },
        _react2.default.createElement(
          _core.Collapse,
          { isOpen: this.props.isOpen },
          _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
            title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
            parent: this.props.parent
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.parent.coUyQuyen && this.props.isOpen },
          _react2.default.createElement(
            'div',
            { className: 'pl5 pr5 pt0 mb15' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: this.props.isOpen ? "box-items" : "box-items no-margin" },
            _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
              title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
              isOpen: this.props.isOpen,
              parent: this.props.parent
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pl5 pr5 pt0 mb15' },
            _react2.default.createElement('div', { className: 'line-border' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.isOpen ? "box-items" : "box-items no-margin" },
          _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
            checkXLDC: this.props.checkXLDC,
            title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
            isOpen: this.props.isOpen,
            parent: this.props.parent
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.parent.coThongTinCoQuanDaGiaiQuyet && this.props.isOpen },
          _react2.default.createElement(
            'div',
            { className: 'pl5 pr5 pt0 mb15' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: this.props.isOpen ? "box-items" : "box-items no-margin" },
            _react2.default.createElement(_letterDetail.ThongTinCoQuanDaGiaiQuyet, {
              title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt',
              isOpen: this.props.isOpen,
              parent: this.props.parent
            })
          )
        )
      );
    }
  }]);

  return LetterDetail;
}(_react2.default.Component);

exports.default = LetterDetail;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _core = __webpack_require__(7);

var _LetterDetail = __webpack_require__(1221);

var _LetterDetail2 = _interopRequireDefault(_LetterDetail);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LetterInformation = function (_React$Component) {
  _inherits(LetterInformation, _React$Component);

  function LetterInformation(props, context) {
    _classCallCheck(this, LetterInformation);

    var _this = _possibleConstructorReturn(this, (LetterInformation.__proto__ || Object.getPrototypeOf(LetterInformation)).call(this, props, context));

    _this.state = {
      isOpen: true,
      role: '',
      tinhTrang: ''
    };
    return _this;
  }

  _createClass(LetterInformation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      if (this.props.typePage == 'xu-ly') this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'showHanXuLy',
    value: function showHanXuLy() {

      var hanXuLy = '';
      if (this.props.thongTinGiaiQuyetDonId) {

        if (this.props.thongTinGiaiQuyetDonPlus.ngayBatDauKTDX) {

          hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanKTDX;
        } else {

          if (this.props.thongTinGiaiQuyetDonPlus.donViThamTraXacMinhInfo && this.props.thongTinGiaiQuyetDonPlus.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

            if (this.props.parent.loaiDonGiaTri == 'DON_KHIEU_NAI') {

              if (this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanTTXM) {

                hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanTTXM;
              } else {

                hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanTTXM;
              }
            } else {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanTTXM;
            }
          }

          if (this.props.parent.data.donViXuLyGiaiQuyetInfo && this.props.parent.data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

            if (this.props.parent.loaiDonGiaTri == 'DON_TO_CAO') {

              if (this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanGiaiQuyet) {

                hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanSauKhiGiaHanGiaiQuyet;
              } else {

                hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanGiaiQuyet;
              }
            } else {

              hanXuLy = this.props.thongTinGiaiQuyetDonPlus.ngayHetHanGiaiQuyet;
            }
          }
        }
      } else {

        hanXuLy = this.props.parent.data.thoiHanXuLyXLD;
      }

      var hanXuLyResult = hanXuLy ? (0, _moment2.default)(hanXuLy).format('DD/MM/YYYY') : '';
      return hanXuLyResult;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.parent.data.trangThaiDonInfo && nextProps.userInfo) {

        nextProps.parent.data.trangThaiDonInfo.filter(function (item) {
          return item.donViId == nextProps.userInfo.donViId;
        }).map(function (child, i) {
          _this2.setState({
            tinhTrang: child.trangThaiDonText
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'content-wrap content-gqd background-detail panel-page' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.checkDonCu === undefined },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)({
                'header-redirect background-detail': this.state.isOpen,
                'background-detail header-redirect no-border-bottom': !this.state.isOpen
              }) },
            _react2.default.createElement(
              'div',
              { className: 'row-col' },
              _react2.default.createElement(_common.Text, {
                className: 'header-col pl15',
                label: 'M\xE3 h\u1ED3 s\u01A1:',
                value: this.props.parent.data.maHoSo }),
              _react2.default.createElement(_common.Text, {
                className: (0, _classnames2.default)({
                  'header-col': this.props.parent.ma !== '',
                  'header-col pl15': this.props.parent.ma === ''
                }),
                label: this.props.parent.data.donChuyen ? 'Ngày chuyển:' : 'Ngày tiếp nhận:',
                value: this.props.parent.ngayTiepNhan ? (0, _moment2.default)(this.props.parent.ngayTiepNhan).format('DD/MM/YYYY') : '' }),
              _react2.default.createElement(_common.Text, {
                className: 'header-col',
                label: 'Tr\u1EA1ng th\xE1i x\u1EED l\xFD:',
                value: this.state.tinhTrang }),
              _react2.default.createElement(_common.Text, {
                className: 'header-col',
                label: 'H\u1EA1n x\u1EED l\xFD:',
                value: this.showHanXuLy() }),
              _react2.default.createElement(
                'div',
                { className: 'header-col' },
                _react2.default.createElement(_dialog.HistoryDialog, { donId: this.props.donId, ma: this.props.parent.ma })
              ),
              _react2.default.createElement(
                'div',
                { className: 'header-col pl0 pr15' },
                _react2.default.createElement(_core.Button, { onClick: this.handleClick.bind(this), className: this.state.isOpen ? "btn-collap active" : "btn-collap" })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-block pl10 pr10 pt10' },
          _react2.default.createElement(_LetterDetail2.default, { checkXLDC: this.props.checkXLDC, isOpen: this.state.isOpen, parent: this.props.parent })
        )
      );
    }
  }]);

  return LetterInformation;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LetterInformation);

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachBangChung = function (_React$Component) {
  _inherits(DanhSachBangChung, _React$Component);

  function DanhSachBangChung() {
    _classCallCheck(this, DanhSachBangChung);

    return _possibleConstructorReturn(this, (DanhSachBangChung.__proto__ || Object.getPrototypeOf(DanhSachBangChung)).apply(this, arguments));
  }

  _createClass(DanhSachBangChung, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'DANH S\xC1CH T\xC0I LI\u1EC6U K\xC8M THEO'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form white-table mb10' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.giaiQuyetDon.danhSachBangChung,
                  dataList: this.props.parent,
                  type: 'handle-letter-detail', hidePagination: true,
                  hiddenButtonExport: true },
                _react2.default.createElement(_rowItem.DetailTaiLieuRowItem, null)
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachBangChung;
}(_react2.default.Component);

DanhSachBangChung.defaultProps = {
  listTaiLieuBangChung: []
};

exports.default = DanhSachBangChung;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachTaiLieuDinhKem = function (_React$Component) {
  _inherits(DanhSachTaiLieuDinhKem, _React$Component);

  function DanhSachTaiLieuDinhKem() {
    _classCallCheck(this, DanhSachTaiLieuDinhKem);

    return _possibleConstructorReturn(this, (DanhSachTaiLieuDinhKem.__proto__ || Object.getPrototypeOf(DanhSachTaiLieuDinhKem)).apply(this, arguments));
  }

  _createClass(DanhSachTaiLieuDinhKem, [{
    key: 'render',
    value: function render() {
      var getFilter = null;
      var arrTitleFile = ['Báo cáo kết quả xác minh nội dung khiếu nại', 'Quyết định về việc giải quyết khiếu nại', 'Báo cáo kết quả xác minh nội dung tố cáo', 'Quyết định về việc giải quyết tố cáo', 'Quyết định giải quyết khiếu nại', 'Văn bản xác minh đề xuất', 'Văn bản xử lý kiến nghị, phản ánh', 'Văn bản giải quyết kiến nghị, phản ánh', 'Văn bản kết luận, giải quyết tố cáo', 'Thông báo kết quả giải quyết tố cáo', 'Báo cáo xác minh', 'Văn bản giải quyết'];
      getFilter = this.props.parent.filter(function (item) {
        return item.ten !== '' && !arrTitleFile.includes(item.ten) || item.soQuyetDinh !== '' || item.ngayQuyetDinh !== null || item.duongDan !== '';
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                this.props.title || 'DANH SÁCH TÀI LIỆU ĐÍNH KÈM'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form white-table mb10' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.giaiQuyetDon.danhSachTaiLieuDinhKemDC,
                  dataList: getFilter,
                  type: 'handle-letter-detail', hidePagination: true,
                  hiddenButtonExport: true },
                _react2.default.createElement(_rowItem.ListAttachTaiLieuRowItem, null)
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachTaiLieuDinhKem;
}(_react2.default.Component);

DanhSachTaiLieuDinhKem.defaultProps = {
  listTaiLieuDinhKem: []
};

exports.default = DanhSachTaiLieuDinhKem;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _detail = __webpack_require__(238);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPeople = function (_React$Component) {
  _inherits(GroupPeople, _React$Component);

  function GroupPeople(props, context) {
    _classCallCheck(this, GroupPeople);

    var _this = _possibleConstructorReturn(this, (GroupPeople.__proto__ || Object.getPrototypeOf(GroupPeople)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(GroupPeople, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'Danh s\xE1ch \u0111o\xE0n'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form white-table' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.detailReception.groupMember,
                  dataList: this.props.doanDiCung,
                  hidePagination: true,
                  hideExport: true },
                _react2.default.createElement(_detail.RowItemListGroupPeoPleDetailReception, null)
              )
            )
          )
        )
      );
    }
  }]);

  return GroupPeople;
}(_react2.default.Component);

exports.default = GroupPeople;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _GroupPeople = __webpack_require__(1225);

var _GroupPeople2 = _interopRequireDefault(_GroupPeople);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListSinglePerson = function (_React$Component) {
  _inherits(ListSinglePerson, _React$Component);

  function ListSinglePerson() {
    _classCallCheck(this, ListSinglePerson);

    return _possibleConstructorReturn(this, (ListSinglePerson.__proto__ || Object.getPrototypeOf(ListSinglePerson)).apply(this, arguments));
  }

  _createClass(ListSinglePerson, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ListNguoiDungDon = '';

      if (this.props.parent.loaiNguoiDungDon && this.props.parent.dataNguoiDungDon) {
        ListNguoiDungDon = this.props.parent.dataNguoiDungDon.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { key: i },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: _this2.props.parent.loaiNguoiDungDon == "CA_NHAN" },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n ',
                          _this2.props.parent.dataNguoiDungDon.length > 1 ? i + 1 : ''
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: _this2.props.parent.loaiNguoiDungDon == "DOAN_DONG_NGUOI" || _this2.props.parent.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n ',
                          _this2.props.parent.dataNguoiDungDon.length > 1 ? i + 1 : ''
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'H\u1ECD v\xE0 t\xEAn:',
                    value: item.hoVaTen ? item.hoVaTen : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Ng\xE0y sinh:',
                    value: item.ngaySinh ? (0, _moment2.default)(item.ngaySinh).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:',
                    value: item.soDienThoai || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Gi\u1EDBi t\xEDnh:',
                    value: item.gioiTinh ? 'Nam' : 'Nữ' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu:',
                    value: item.soCMNDHoChieu ? item.soCMNDHoChieu : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Ng\xE0y c\u1EA5p:',
                    value: item.ngayCap ? (0, _moment2.default)(item.ngayCap).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'N\u01A1i c\u1EA5p:',
                    value: item.noiCapCMNDInfo ? item.noiCapCMNDInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Qu\u1ED1c t\u1ECBch:',
                    value: item.quocTichCongDan ? item.quocTichCongDan.ten : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'D\xE2n t\u1ED9c:',
                    value: item.danTocCongDan ? item.danTocCongDan.ten : '' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'T\u1EC9nh:',
                    value: item.tinhThanhCongDan ? item.tinhThanhCongDan.ten : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: item.quanHuyenCongDan != null || item.phuongXaCongDan != null || item.toThon != '' && item.toThon != null },
                    _react2.default.createElement(_common.Text, {
                      className: 'col-input',
                      label: 'Qu\u1EADn/Huy\u1EC7n:',
                      value: item.quanHuyenCongDan ? item.quanHuyenCongDan.ten : '' }),
                    _react2.default.createElement(_common.Text, {
                      className: 'col-input',
                      label: 'Ph\u01B0\u1EDDng/X\xE3:',
                      value: item.phuongXaCongDan ? item.phuongXaCongDan.ten : '' })
                  ),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-w40',
                    label: '\u0110\u1ECBa ch\u1EC9 (S\u1ED1 nh\xE0 /T\xEAn \u0111\u01B0\u1EDDng /T\u1ED5, th\xF4n):',
                    value: item.diaChi ? item.diaChi : '' })
                )
              )
            )
          );
        });
      } else {
        ListNguoiDungDon = _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'div',
        null,
        ListNguoiDungDon,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.parent.loaiNguoiDungDon == "DOAN_DONG_NGUOI" },
          _react2.default.createElement(_GroupPeople2.default, { doanDiCung: this.props.parent.dataDoanDiCung })
        )
      );
    }
  }]);

  return ListSinglePerson;
}(_react2.default.Component);

exports.default = ListSinglePerson;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _detail = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinCoQuanDaGiaiQuyet = function (_React$Component) {
  _inherits(ThongTinCoQuanDaGiaiQuyet, _React$Component);

  function ThongTinCoQuanDaGiaiQuyet() {
    _classCallCheck(this, ThongTinCoQuanDaGiaiQuyet);

    return _possibleConstructorReturn(this, (ThongTinCoQuanDaGiaiQuyet.__proto__ || Object.getPrototypeOf(ThongTinCoQuanDaGiaiQuyet)).apply(this, arguments));
  }

  _createClass(ThongTinCoQuanDaGiaiQuyet, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'group-box' },
          _react2.default.createElement(
            _core.Collapse,
            { isOpen: this.props.isOpen },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    this.props.title
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt:',
                  value: this.props.parent.data.coQuanDaGiaiQuyetDonThu || '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'S\u1ED1 v\u0103n b\u1EA3n:',
                  value: this.props.parent.data.soVanBanDaGiaiQuyet ? this.props.parent.data.soVanBanDaGiaiQuyet : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Ng\xE0y ban h\xE0nh:',
                  value: this.props.parent.data.ngayBanHanhVanBanDaGiaiQuyet ? (0, _moment2.default)(this.props.parent.data.ngayBanHanhVanBanDaGiaiQuyet).format("DD/MM/YYYY") : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12 pt15' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form white-table' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.detailReceptionPeriodical.attach,
                      dataList: this.props.parent.data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet,
                      hidePagination: true },
                    _react2.default.createElement(_detail.RowItemListAttachReceptionPeriodical, null)
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinCoQuanDaGiaiQuyet;
}(_react2.default.Component);

ThongTinCoQuanDaGiaiQuyet.defaultProps = {
  parent: {
    listTaiLieuVanThuBlockCoQuanDaGiaiQuyet: []
  }
};

exports.default = ThongTinCoQuanDaGiaiQuyet;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _DanhSachBangChung = __webpack_require__(1223);

var _DanhSachBangChung2 = _interopRequireDefault(_DanhSachBangChung);

var _DanhSachTaiLieuDinhKem = __webpack_require__(1224);

var _DanhSachTaiLieuDinhKem2 = _interopRequireDefault(_DanhSachTaiLieuDinhKem);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinDon = function (_React$Component) {
  _inherits(ThongTinDon, _React$Component);

  function ThongTinDon() {
    _classCallCheck(this, ThongTinDon);

    return _possibleConstructorReturn(this, (ThongTinDon.__proto__ || Object.getPrototypeOf(ThongTinDon)).apply(this, arguments));
  }

  _createClass(ThongTinDon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'group-box' },
          _react2.default.createElement(
            _core.Collapse,
            { isOpen: this.props.isOpen },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    this.props.title
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0:',
                  value: this.props.parent.loaiDon }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.parent.loaiDonGiaTri == "DON_KHIEU_NAI" },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: this.props.parent.loaiDoiTuong ? this.props.parent.loaiDoiTuong.ten : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.parent.loaiDonGiaTri == "DON_TO_CAO" },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: '\u0110\u1ED1i t\u01B0\u1EE3ng b\u1ECB t\u1ED1 c\xE1o:',
                    value: this.props.parent.loaiDoiTuong ? this.props.parent.loaiDoiTuong.ten : '' })
                ),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'L\u0129nh v\u1EF1c:',
                  value: this.props.parent.linhVuc }),
                this.props.parent.linhVucChiTiet && _react2.default.createElement(
                  'div',
                  { className: 'col-input' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'L\u0129nh v\u1EF1c chi ti\u1EBFt:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: this.props.parent.linhVucChiTietSub ? 'val-content arrow-to-dispute' : 'val-content' },
                      this.props.parent.linhVucChiTiet
                    )
                  )
                ),
                this.props.parent.linhVucChiTietKhac && _react2.default.createElement(
                  'div',
                  { className: 'col-input' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      'L\u0129nh v\u1EF1c chi ti\u1EBFt kh\xE1c:'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: '\'val-content' },
                      this.props.parent.linhVucChiTietKhac
                    )
                  )
                ),
                this.props.parent.linhVucChiTiet && this.props.parent.linhVucChiTietSub && _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: '\xA0\xA0\xA0',
                  value: this.props.parent.linhVucChiTietSub ? this.props.parent.linhVucChiTietSub : '' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'items-form' },
            _react2.default.createElement(
              'div',
              { className: 'rows mb10' },
              _react2.default.createElement(_common.TextMessage, { label: 'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0:', value: this.props.parent.noiDung, className: 'col-12' })
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { isOpen: this.props.isOpen },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.parent && this.props.parent.data && this.props.parent.data.loaiVuViecInfo !== undefined },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Lo\u1EA1i v\u1EE5 vi\u1EC7c:',
                    value: this.props.parent.data.loaiVuViecInfo ? this.props.parent.data.loaiVuViecInfo.ten : '' })
                )
              )
            ),
            this.props.parent && this.props.parent.listTaiLieuBangChung && this.props.parent.listTaiLieuBangChung.length > 0 ? _react2.default.createElement(_DanhSachBangChung2.default, { parent: this.props.parent.listTaiLieuBangChung }) : '',
            this.props.checkXLDC === true && this.props.parent && this.props.parent.listTaiLieuVanThu && this.props.parent.listTaiLieuVanThu.length > 0 && _react2.default.createElement(_DanhSachTaiLieuDinhKem2.default, { title: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', parent: this.props.parent.listTaiLieuVanThu })
          )
        )
      );
    }
  }]);

  return ThongTinDon;
}(_react2.default.Component);

exports.default = ThongTinDon;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ListSinglePerson = __webpack_require__(1226);

var _ListSinglePerson2 = _interopRequireDefault(_ListSinglePerson);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinNguoiDungDon = function (_React$Component) {
  _inherits(ThongTinNguoiDungDon, _React$Component);

  function ThongTinNguoiDungDon() {
    _classCallCheck(this, ThongTinNguoiDungDon);

    return _possibleConstructorReturn(this, (ThongTinNguoiDungDon.__proto__ || Object.getPrototypeOf(ThongTinNguoiDungDon)).apply(this, arguments));
  }

  _createClass(ThongTinNguoiDungDon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  { className: 'mb15' },
                  this.props.title
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'items-form mb10' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:', value: this.props.parent.data.loaiNguoiDungDonInfo ? this.props.parent.data.loaiNguoiDungDonInfo.ten : '' }),
                this.props.parent.data.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'T\xEAn c\u01A1 quan/T\u1ED5 ch\u1EE9c:', value: this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].tenCoQuan : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: '\u0110\u1ECBa ch\u1EC9 c\u01A1 quan:', value: this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].diaChiCoQuan : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: '\u0110i\u1EC7n tho\u1EA1i c\u01A1 quan:', value: this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].soDienThoaiCoQuan : '' })
                ) : null,
                this.props.parent.data.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'S\u1ED1 ng\u01B0\u1EDDi:', value: this.props.parent.data ? String(this.props.parent.data.soNguoi) : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'S\u1ED1 ng\u01B0\u1EDDi \u0111\u1EA1i di\u1EC7n:', value: String(this.props.parent.data.listNguoiDungDon.length) })
                ) : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5 mb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(_ListSinglePerson2.default, { parent: this.props.parent })
        )
      );
    }
  }]);

  return ThongTinNguoiDungDon;
}(_react2.default.Component);

function bindStateToProp(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProp)(ThongTinNguoiDungDon);

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinNguoiDungDon = function (_React$Component) {
  _inherits(ThongTinNguoiDungDon, _React$Component);

  function ThongTinNguoiDungDon() {
    _classCallCheck(this, ThongTinNguoiDungDon);

    return _possibleConstructorReturn(this, (ThongTinNguoiDungDon.__proto__ || Object.getPrototypeOf(ThongTinNguoiDungDon)).apply(this, arguments));
  }

  _createClass(ThongTinNguoiDungDon, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'box-forward' },
        _react2.default.createElement(
          'div',
          { className: 'container-box' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  null,
                  this.props.title
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'H\u1ECD v\xE0 t\xEAn:',
                  value: this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.hoVaTen : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Ng\xE0y sinh:',
                  value: this.props.parent.dataNguoiDuocUyQuyen.ngaySinh ? (0, _moment2.default)(this.props.parent.dataNguoiDuocUyQuyen.ngaySinh).format("DD/MM/YYYY") : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Gi\u1EDBi t\xEDnh:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.gioiTinh ? 'Nam' : "Nữ" })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu:',
                  value: this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.soCMNDHoChieu : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Ng\xE0y c\u1EA5p:',
                  value: this.props.parent.dataNguoiDuocUyQuyen.ngayCap ? (0, _moment2.default)(this.props.parent.dataNguoiDuocUyQuyen.ngayCap).format("DD/MM/YYYY") : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'N\u01A1i c\u1EA5p:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.noiCapCMNDInfo ? this.props.parent.dataNguoiDuocUyQuyen.noiCapCMNDInfo.ten : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'D\xE2n t\u1ED9c:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.danTocCongDan ? this.props.parent.dataNguoiDuocUyQuyen.danTocCongDan.ten : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Qu\u1ED1c t\u1ECBch:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.quocTichCongDan ? this.props.parent.dataNguoiDuocUyQuyen.quocTichCongDan.ten : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'T\u1EC9nh:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.tinhThanhCongDan ? this.props.parent.dataNguoiDuocUyQuyen.tinhThanhCongDan.ten : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Qu\u1EADn/Huy\u1EC7n:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.quanHuyenCongDan ? this.props.parent.dataNguoiDuocUyQuyen.quanHuyenCongDan.ten : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-input',
                  label: 'Ph\u01B0\u1EDDng/X\xE3:',
                  value: this.props.parent.dataNguoiDuocUyQuyen && this.props.parent.dataNguoiDuocUyQuyen.phuongXaCongDan ? this.props.parent.dataNguoiDuocUyQuyen.phuongXaCongDan.ten : '' }),
                _react2.default.createElement(_common.Text, {
                  className: 'col-w40',
                  label: '\u0110\u1ECBa ch\u1EC9:',
                  value: this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.diaChi : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.parent.listTepUyQuyen.length > 0 },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-label' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'Gi\u1EA5y \u1EE7y quy\u1EC1n: '
                      )
                    ),
                    this.props.parent.listTepUyQuyen.map(function (item, i) {
                      return _react2.default.createElement(
                        'p',
                        { className: 'info-document mb5', key: i },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: !_config.checkServerLive },
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile), className: 'name_upload txt-blue' },
                            item.tenFile
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: _config.checkServerLive },
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { onClick: function onClick() {
                                (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                              }, className: 'name_upload txt-blue' },
                            item.tenFile
                          )
                        )
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.parent.dataNguoiDuocUyQuyen.luatSu },
              _react2.default.createElement(
                'div',
                { className: 'items-form title mb5' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-input' },
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-label' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Lu\u1EADt s\u01B0'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'S\u1ED1 th\u1EBB:',
                    value: this.props.parent.dataNguoiDuocUyQuyen.soTheLuatSu ? this.props.parent.dataNguoiDuocUyQuyen.soTheLuatSu : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Ng\xE0y c\u1EA5p:',
                    value: this.props.parent.dataNguoiDuocUyQuyen ? this.props.parent.dataNguoiDuocUyQuyen.ngayCapTheLuatSu == null ? '' : (0, _moment2.default)(this.props.parent.dataNguoiDuocUyQuyen.ngayCapTheLuatSu).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'N\u01A1i c\u1EA5p:',
                    value: this.props.parent.dataNguoiDuocUyQuyen.noiCapTheLuatSu ? this.props.parent.dataNguoiDuocUyQuyen.noiCapTheLuatSu : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-input',
                    label: 'Th\xF4ng tin gi\u1EDBi thi\u1EC7u:',
                    value: this.props.parent.dataNguoiDuocUyQuyen.thongTinGioiThieu ? this.props.parent.dataNguoiDuocUyQuyen.thongTinGioiThieu : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.parent.listTepChungChiHanhNghe.length > 0 },
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-label' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'Ch\u1EE9ng ch\u1EC9 h\xE0nh ngh\u1EC1:'
                      )
                    ),
                    this.props.parent.listTepChungChiHanhNghe.map(function (item, i) {
                      return _react2.default.createElement(
                        'p',
                        { className: 'info-document mb5', key: i },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: !_config.checkServerLive },
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'name_upload txt-blue', onClick: _jsFileDownload2.default.bind(_this2, item.urlFile, item.tenFile) },
                            item.tenFile
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: _config.checkServerLive },
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'name_upload txt-blue', onClick: function onClick() {
                                (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                              } },
                            item.tenFile
                          )
                        )
                      );
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinNguoiDungDon;
}(_react2.default.Component);

exports.default = ThongTinNguoiDungDon;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_React$Component) {
  _inherits(Loading, _React$Component);

  function Loading() {
    _classCallCheck(this, Loading);

    return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
  }

  _createClass(Loading, [{
    key: "render",
    value: function render() {
      var ItemLoading = _react2.default.createElement(
        "div",
        { className: "loading-content" },
        _react2.default.createElement("span", { className: "shape1" }),
        _react2.default.createElement("span", { className: "shape2" }),
        _react2.default.createElement("span", { className: "shape3" }),
        _react2.default.createElement("span", { className: "shape4" }),
        _react2.default.createElement("span", { className: "shape5" }),
        _react2.default.createElement("span", { className: "shape6" }),
        _react2.default.createElement("span", { className: "shape7" }),
        _react2.default.createElement("span", { className: "shape8" }),
        _react2.default.createElement("span", { className: "shape9" }),
        _react2.default.createElement("span", { className: "shape10" }),
        _react2.default.createElement("span", { className: "shape11" }),
        _react2.default.createElement("span", { className: "shape12" }),
        _react2.default.createElement("span", { className: "shape13" })
      );
      return _react2.default.createElement(
        "div",
        { className: "center" },
        _react2.default.createElement(
          "div",
          { className: "page-wrapper" },
          _react2.default.createElement(
            "div",
            { className: "loading-container" },
            ItemLoading,
            ItemLoading,
            ItemLoading
          ),
          _react2.default.createElement(
            "div",
            { className: "loading-container" },
            ItemLoading,
            ItemLoading,
            ItemLoading
          ),
          _react2.default.createElement(
            "div",
            { className: "loading-container" },
            ItemLoading,
            ItemLoading,
            ItemLoading
          )
        )
      );
    }
  }]);

  return Loading;
}(_react2.default.Component);

exports.default = Loading;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _toastr = __webpack_require__(11);

var _queryString = __webpack_require__(219);

var _queryString2 = _interopRequireDefault(_queryString);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginSSO = function (_React$Component) {
  _inherits(LoginSSO, _React$Component);

  function LoginSSO(props, context) {
    _classCallCheck(this, LoginSSO);

    var _this = _possibleConstructorReturn(this, (LoginSSO.__proto__ || Object.getPrototypeOf(LoginSSO)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(LoginSSO, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var parsed = _queryString2.default.parse(window.location.search);
      var error = (0, _lodash.get)(parsed, 'error');
      var errorDescription = (0, _lodash.get)(parsed, 'error_description');
      var accessToken = (0, _lodash.get)(parsed, 'access_token');

      if (error !== 'false') {
        (0, _toastr.Toastr)(decodeURIComponent(errorDescription), 'error');
        this.changePage('/dang-nhap');
      }

      if (accessToken) {
        _reactCookie2.default.save('accessToken', accessToken);
        _api.User.actions.loginSSO.request(null, {}).then(function (res) {
          var attributes = (0, _lodash.get)(res, 'data.attributes');
          if (res && res.data) {
            localStorage.clear();
            var userData = {
              id: (0, _lodash.get)(attributes, 'congChucId'),
              name: (0, _lodash.get)(attributes, 'hoVaTen'),
              chucVu: (0, _lodash.get)(attributes, 'chucVu'),
              tenVaiTro: (0, _lodash.get)(attributes, 'tenVaiTro'),
              coQuanQuanLyId: (0, _lodash.get)(attributes, 'coQuanQuanLyId'),
              vaiTroMacDinhId: (0, _lodash.get)(attributes, 'vaiTroMacDinhId'),
              loaiVaiTroMacDinh: (0, _lodash.get)(attributes, 'loaiVaiTroMacDinh'),
              roles: (0, _lodash.get)(attributes, 'roles').map(function (item) {
                return {
                  loaiVaiTro: item.loaiVaiTro,
                  vaiTroId: item.vaiTroId,
                  ten: item.ten,
                  quyen: item.quyen
                };
              }),
              quyenBatDauQuyTrinh: (0, _lodash.get)(attributes, 'quyenBatDauQuyTrinh'),
              donViId: (0, _lodash.get)(attributes, 'donViId'),
              donViChaId: (0, _lodash.get)(attributes, 'donViChaId'),
              tenCoQuanQuanLy: (0, _lodash.get)(attributes, 'tenCoQuanQuanLy'),
              capCoQuanQuanLyId: (0, _lodash.get)(attributes, 'capCoQuanQuanLyId'),
              capCoQuanQuanLyCuaDonViId: (0, _lodash.get)(attributes, 'capCoQuanQuanLyCuaDonViId'),
              capCoQuanQuanLyCuaDonViChaId: (0, _lodash.get)(attributes, 'capCoQuanQuanLyCuaDonViChaId'),
              isBoSungThongTin: (0, _lodash.get)(attributes, 'isBoSungThongTin'),
              sso: (0, _lodash.get)(attributes, 'SSO'),
              ssoIdToken: (0, _lodash.get)(attributes, 'ssoIdToken')
            };
            localStorage.setItem('userInfo', JSON.stringify(userData));
            _this2.props.dispatch({
              type: 'INIT_DULIEU',
              value: true
            });
            _reactRouter.browserHistory.push('/');
          }
        }).catch(function (error) {
          if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            _this2.clearAllCookie();
            _this2.changePage('/dang-nhap');
          }
        });
      }
    }
  }, {
    key: 'clearAllCookie',
    value: function clearAllCookie() {
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    }
  }, {
    key: 'changePage',
    value: function changePage(name) {
      _reactRouter.browserHistory.push(name);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);

  return LoginSSO;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(LoginSSO);

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginSSO = __webpack_require__(1232);

var _LoginSSO2 = _interopRequireDefault(_LoginSSO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LoginSSO2.default;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoLogin = function (_React$Component) {
  _inherits(AutoLogin, _React$Component);

  function AutoLogin() {
    _classCallCheck(this, AutoLogin);

    return _possibleConstructorReturn(this, (AutoLogin.__proto__ || Object.getPrototypeOf(AutoLogin)).apply(this, arguments));
  }

  _createClass(AutoLogin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.location.query.token) {
        _reactRouter.browserHistory.push('/');
      } else {
        var expiresParams = { path: '/' };
        _reactCookie2.default.save('accessToken', this.props.location.query.token, expiresParams);
      }
      this.handleLogin();
    }
  }, {
    key: 'handleLogin',
    value: function handleLogin() {
      _api.User.actions.getInfoFromToken.request().then(function (res) {
        if (res && res.data) {
          localStorage.clear();
          var userData = {
            id: res.data.congChucId,
            name: res.data.hoVaTen,
            tenVaiTro: res.data.tenVaiTro,
            coQuanQuanLyId: res.data.coQuanQuanLyId,
            vaiTroMacDinhId: res.data.vaiTroMacDinhId,
            loaiVaiTroMacDinh: res.data.loaiVaiTroMacDinh,
            roles: [],
            quyenBatDauQuyTrinh: res.data.quyenBatDauQuyTrinh,
            donViId: res.data.donViId,
            tenCoQuanQuanLy: res.data.tenCoQuanQuanLy,
            capCoQuanQuanLyId: res.data.capCoQuanQuanLyId,
            capCoQuanQuanLyCuaDonViId: res.data.capCoQuanQuanLyCuaDonViId,
            isBoSungThongTin: res.data.isBoSungThongTin
          };
          res.data.roles.map(function (item, i) {
            userData.roles.push({
              loaiVaiTro: item.loaiVaiTro,
              vaiTroId: item.vaiTroId,
              ten: item.ten,
              quyen: item.quyen
            });
          });
          var expiresParams = { path: '/' };
          _reactCookie2.default.save('accessToken', res.data.token, expiresParams);
          localStorage.setItem('userInfo', JSON.stringify(userData));
          _reactRouter.browserHistory.push('/');
        }
      }).catch(function (error) {
        _reactCookie2.default.remove('accessToken', { path: '/' });
        _reactRouter.browserHistory.push('/');
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);

  return AutoLogin;
}(_react2.default.Component);

exports.default = AutoLogin;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CheckCanBoThuHoi = function CheckCanBoThuHoi(canBoCoTheThuHoiInfo) {

  var check = false;

  if (canBoCoTheThuHoiInfo && localStorage.getItem('userInfo')) {

    var data = JSON.parse(localStorage.getItem('userInfo'));

    if (canBoCoTheThuHoiInfo.giaTri == data.id) {
      check = true;
    }
  }
  return check;
};

exports.CheckCanBoThuHoi = CheckCanBoThuHoi;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CheckQuyenBatDauQuyTrinh = function CheckQuyenBatDauQuyTrinh() {
  var check = false;

  if (localStorage.getItem('userInfo')) {

    var data = JSON.parse(localStorage.getItem('userInfo'));
    check = data.quyenBatDauQuyTrinh;
  }

  return check;
};

exports.CheckQuyenBatDauQuyTrinh = CheckQuyenBatDauQuyTrinh;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _validate = __webpack_require__(199);

var _CheckPermission = __webpack_require__(20);

var _config = __webpack_require__(16);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loginBg = __webpack_require__(378);

var Login = function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login(props, context) {
    _classCallCheck(this, Login);

    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props, context));

    _this.state = {
      Username: '',
      Password: '',
      ghiNho: false,
      loading: false,
      isSubmit: false,
      emailValid: true
    };
    return _this;
  }
  // componentWillMount() {
  //   if (typeof cookie.load('accessToken') == 'undefined') {
  //     if (!sessionStorage.getItem("checkLoginGov")) {
  //       sessionStorage.setItem("checkLoginGov", true);
  //       window.location.replace('http://dev.api.thanhtratp.greenglobal.vn:8088/cas/login');
  //     }
  //   }
  // }


  _createClass(Login, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof _reactCookie2.default.load('accessToken') !== 'undefined') {
        _reactRouter.browserHistory.push('/');
      }

      if (this.props.route.type == 'SSO' && typeof _reactCookie2.default.load('SESSION') !== 'undefined') {
        _reactCookie2.default.remove('SESSION', { path: '/' });
        this.handleLoginSSO();
      }
      if (this.props.route.type == 'SSOERR') {
        this.clearAllCookie();
      }
    }
  }, {
    key: 'clearAllCookie',
    value: function clearAllCookie() {
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, e.target.name, e.target.value), _defineProperty(_setState, 'isSubmit', false), _defineProperty(_setState, 'emailValid', true), _setState));
    }
  }, {
    key: 'handleLogin',
    value: function handleLogin(e) {
      var _this2 = this;

      e.preventDefault();
      if (this.handleValidate()) {
        var params = {
          Email: this.state.Username.trim(),
          Password: this.state.Password
        };
        this.setState({ loading: true });
        _api.User.actions.signin.request(null, params).then(function (res) {
          if (res && res.data) {
            localStorage.clear();
            var userData = {
              id: res.data.congChucId,
              name: res.data.hoVaTen,
              chucVu: res.data.chucVu,
              tenVaiTro: res.data.tenVaiTro,
              coQuanQuanLyId: res.data.coQuanQuanLyId,
              vaiTroMacDinhId: res.data.vaiTroMacDinhId,
              loaiVaiTroMacDinh: res.data.loaiVaiTroMacDinh,
              roles: [],
              quyenBatDauQuyTrinh: res.data.quyenBatDauQuyTrinh,
              donViId: res.data.donViId,
              donViChaId: res.data.donViChaId,
              tenCoQuanQuanLy: res.data.tenCoQuanQuanLy,
              capCoQuanQuanLyId: res.data.capCoQuanQuanLyId,
              capCoQuanQuanLyCuaDonViId: res.data.capCoQuanQuanLyCuaDonViId,
              capCoQuanQuanLyCuaDonViChaId: res.data.capCoQuanQuanLyCuaDonViChaId,
              isBoSungThongTin: res.data.isBoSungThongTin
            };
            res.data.roles.map(function (item, i) {
              userData.roles.push({
                loaiVaiTro: item.loaiVaiTro,
                vaiTroId: item.vaiTroId,
                ten: item.ten,
                quyen: item.quyen
              });
            });
            var expiresParams = { path: '/' };
            if (_this2.state.ghiNho) {
              expiresParams = { path: '/', maxAge: 3600 * 24 * 365 };
            }
            _reactCookie2.default.save('accessToken', res.data.token, expiresParams);
            localStorage.setItem('userInfo', JSON.stringify(userData));
            _this2.props.dispatch({
              type: 'INIT_DULIEU',
              value: true
            });
            (0, _CheckPermission.CheckPermission)('GIAM_SAT_TRA_CUU_LIETKE') ? _reactRouter.browserHistory.push('/giam-sat-tra-cuu') : _reactRouter.browserHistory.push('/');
            var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
            var TTTW = 19;
            if ((0, _lodash.get)(userInfo, 'capCoQuanQuanLyId') === TTTW) {
              _reactRouter.browserHistory.push('/thanh-tra');
            }
            if ((0, _lodash.get)(userInfo, 'loaiVaiTroMacDinh') === 'NHAP_LIEU_DON_CU') {
              _reactRouter.browserHistory.push('/xu-ly-don-cu');
            }
          }
        }).catch(function (error) {
          setTimeout(function () {
            _this2.setState({ loading: false });
            if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          }, 1000);
        });
      }
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate() {
      this.setState({ isSubmit: true });
      var pass = true;
      if (!this.state.Username) {
        pass = false;
      } else if (!(0, _validate.checkEmail)(this.state.Username.trim())) {
        pass = false;
        this.setState({ emailValid: false });
      } else if (!this.state.Password) {
        pass = false;
      }
      return pass;
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(e) {
      this.setState({
        ghiNho: !this.state.ghiNho
      });
    }
  }, {
    key: 'handleLoginSSO',
    value: function handleLoginSSO() {
      window.location.href = _config.API_URL_SSO + '?client_id=' + _config.CLIENT_ID + '&response_type=code&scope=openid&state=true&redirect_uri=' + _config.REDIRECT_URI;
    }
  }, {
    key: 'changePage',
    value: function changePage(name) {
      _reactRouter.browserHistory.push(name);
    }
  }, {
    key: 'render',
    value: function render() {
      var logoImg = __webpack_require__(379);
      return _react2.default.createElement(
        'div',
        { className: 'login', style: { backgroundImage: 'url(' + loginBg + ')' } },
        _react2.default.createElement(
          'div',
          { className: 'login-block' },
          _react2.default.createElement(
            'h1',
            { className: 'logo-login' },
            _react2.default.createElement('img', { src: logoImg, alt: '', className: 'login-logo-image' }),
            _react2.default.createElement(
              'span',
              { className: 'login-logo-caption' },
              'Ph\u1EA7n m\u1EC1m v\xE0 x\xE2y d\u1EF1ng c\u01A1 s\u1EDF d\u1EEF li\u1EC7u ho\u1EA1t \u0111\u1ED9ng thanh tra tr\xEAn \u0111\u1ECBa b\xE0n T\u1EC9nh Qu\u1EA3ng Ng\xE3i'
            )
          ),
          this.props.route.type == 'NORMAL' && _react2.default.createElement(
            'form',
            { className: 'login-form', onSubmit: this.handleLogin.bind(this) },
            _react2.default.createElement(
              'h2',
              { className: 'title-login txt-blue' },
              '\u0110\u0103ng nh\u1EADp'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement('span', { className: 'tt-login-mail' }),
              _react2.default.createElement('input', { className: 'login-input pt-input ' + (this.state.isSubmit && !this.state.Username ? 'pt-intent-danger' : ''),
                type: 'text', placeholder: '\u0110\u1ECBa ch\u1EC9 th\u01B0 \u0111i\u1EC7n t\u1EED', name: 'Username', value: this.state.Username,
                onChange: this.handleChange.bind(this), autoFocus: true, autoComplete: 'off',
                maxLength: 40 }),
              this.state.isSubmit && !this.state.Username ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.messageDefault
              ) : null,
              this.state.isSubmit && !this.state.emailValid ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.emailInvalid
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group mb20' },
              _react2.default.createElement('span', { className: 'tt-login-password' }),
              _react2.default.createElement('input', { className: 'login-input pt-input ' + (this.state.isSubmit && !this.state.Password ? 'pt-intent-danger' : ''),
                type: 'password', placeholder: 'M\u1EADt kh\u1EA9u', name: 'Password', value: this.state.Password,
                onChange: this.handleChange.bind(this), autoComplete: 'off',
                maxLength: 40 }),
              this.state.isSubmit && !this.state.Password ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.messageDefault
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group group-space-between' },
              _react2.default.createElement(
                _core.Checkbox,
                { className: 'pt-large', name: 'ghiNho', checked: this.state.ghiNho, onChange: this.handleCheck.bind(this) },
                _react2.default.createElement(
                  'span',
                  { className: 'span-checkbox' },
                  'Ghi nh\u1EDB'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: 'quen-mat-khau', className: 'forgot-password' },
                ' Qu\xEAn m\u1EADt kh\u1EA9u? '
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-login ' + (this.state.loading ? 'btn-loading-inline' : ''), text: '\u0110\u0103ng nh\u1EADp' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(_core.Button, { type: 'button', className: 'btn-login', onClick: this.handleLoginSSO.bind(this), text: '\u0110\u0103ng nh\u1EADp SSO' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'a',
              {
                href: 'https://tinnhiemmang.vn/danh-ba-tin-nhiem/quanlythanhtraquangngaigovvn-1710902160',
                title: 'Chung nhan Tin Nhiem Mang', target: '_blank', rel: 'noreferrer'
              },
              _react2.default.createElement('img', { src: 'https://tinnhiemmang.vn/handle_cert?id=quanlythanhtra.quangngai.gov.vn', width: '150px', height: 'auto', alt: 'Chung nhan Tin Nhiem Mang' })
            )
          )
        )
      );
    }
  }]);

  return Login;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(Login);

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(1237);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Login2.default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _datatable = __webpack_require__(315);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(14);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietQuanLyHoSo = function (_React$Component) {
  _inherits(ChiTietQuanLyHoSo, _React$Component);

  function ChiTietQuanLyHoSo(props, context) {
    _classCallCheck(this, ChiTietQuanLyHoSo);

    var _this = _possibleConstructorReturn(this, (ChiTietQuanLyHoSo.__proto__ || Object.getPrototypeOf(ChiTietQuanLyHoSo)).call(this, props, context));

    _this.state = {
      listCanCuCuocThanhTra: [],
      listNhomHoSo: []
    };
    return _this;
  }

  _createClass(ChiTietQuanLyHoSo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.params && this.props.params.id) {
        this.getDetailQuanLyHoSo(this.props.params.id);
      }
    }
  }, {
    key: "getDetailQuanLyHoSo",
    value: function getDetailQuanLyHoSo(id) {
      var _this2 = this;

      _api.QuanLyHoSo.actions.getChiTietQuanLyHoSo.request({ id: id }).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this2.setState(_extends({}, _this2.state, {
            listCanCuCuocThanhTra: res.data.cuocThanhTra.danhMucVanBans,
            listNhomHoSo: res.data.listNhomHoSo
          }));
        }
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: "renderListNhomHoSo",
    value: function renderListNhomHoSo() {
      var _this3 = this;

      var result = !(0, _lodash.isEmpty)(this.state.listNhomHoSo) ? this.state.listNhomHoSo.map(function (item, index) {
        return _react2.default.createElement(
          "section",
          { className: "wrap-block" },
          _react2.default.createElement(
            "div",
            { className: "row pl10 pr10 heading-addnew-dttt" },
            _react2.default.createElement(
              "h2",
              { className: "title-13 col-100 pl20 pr20 mt10" },
              index + 2 + ". " + item.ten
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row pl10 pr10 " },
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyHoSo.dsVanBanXuLy,
                dataList: item.listTaiLieuVanThu,
                hideButtonExport: true,
                hidePagination: true,
                pageData: _this3.state.pageData,
                parent: _this3,
                search: _this3.state.search,
                tableLoading: _this3.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemVanBanXuLy, null)
            )
          )
        );
      }) : '';
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          "div",
          { className: "center reception-container" },
          _react2.default.createElement(
            "div",
            { className: "back-foward" },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleClose.bind(this), title: "" },
              "V\u1EC1 trang tr\u01B0\u1EDBc"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "heading" },
            _react2.default.createElement(
              "h2",
              { className: "heading-title icon-add" },
              "Th\xF4ng tin chi ti\u1EBFt h\u1ED3 s\u01A1"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "bottom-content" },
            _react2.default.createElement(
              "section",
              { className: "wrap-block" },
              _react2.default.createElement(
                "div",
                { className: "row pl10 pr10 heading-addnew-dttt" },
                _react2.default.createElement(
                  "h2",
                  { className: "title-13 col-100 pl20 pr20 mt10" },
                  "1. C\u0103n c\u1EE9 cu\u1ED9c thanh tra"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "row pl10 pr10 " },
                _react2.default.createElement(
                  _dataTable2.default,
                  {
                    header: _table.header.dsCanCuCuocThanhTra,
                    dataList: this.state.listCanCuCuocThanhTra,
                    hideButtonExport: true,
                    hidePagination: true,
                    pageData: this.state.pageData,
                    parent: this,
                    search: this.state.search,
                    tableLoading: this.state.tableLoading
                  },
                  _react2.default.createElement(_datatable.RowItemCanCuCuocThanhTra, null)
                )
              )
            ),
            this.renderListNhomHoSo()
          ),
          _react2.default.createElement(
            "div",
            { className: "action-form-wrap pt35 pb5" },
            _react2.default.createElement(
              "div",
              { className: "box-bottom" },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: "btn-action btn-close",
                  onClick: this.handleClose.bind(this)
                },
                _react2.default.createElement(
                  "span",
                  null,
                  "\u0110\xF3ng"
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietQuanLyHoSo;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(ChiTietQuanLyHoSo);

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _lodash = __webpack_require__(14);

var _datatable = __webpack_require__(315);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachQuanLyHoSo = function (_Component) {
  _inherits(DanhSachQuanLyHoSo, _Component);

  function DanhSachQuanLyHoSo(props) {
    _classCallCheck(this, DanhSachQuanLyHoSo);

    var _this = _possibleConstructorReturn(this, (DanhSachQuanLyHoSo.__proto__ || Object.getPrototypeOf(DanhSachQuanLyHoSo)).call(this, props));

    _this.state = {
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      dataQuanLyHoSo: [],
      keyword: "",
      donViId: "",
      startDate: "",
      endDate: "",
      dataOptions: [],
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      search: false,
      isThanhTraTinh: false
    };
    return _this;
  }

  _createClass(DanhSachQuanLyHoSo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getListDV();
      this.getCheckThanhTraTinh();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if ((0, _lodash.isEmpty)(this.state.dataOptions)) {
        this.getListDV();
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(e) {
      e.preventDefault();
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: "getListData",
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({ tableLoading: true });

      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.keyword) {
        params.keyword = this.state.keyword.trim();
      }
      if (this.state.donViId) {
        params.donViId = this.state.donViId;
      }
      if (this.state.startDate) {
        params.startDate = (0, _moment2.default)(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (this.state.endDate) {
        params.endDate = (0, _moment2.default)(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      _api.QuanLyHoSo.actions.getDsQuanLyHoSo.request(null, params).then(function (res) {
        if (res.data) {
          var data = res.data.contents;
          _this2.setState(_extends({}, _this2.state, {
            dataQuanLyHoSo: data,
            tableLoading: false,
            searchLoading: false,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            }
          }));
        } else {
          _this2.setState(_extends({}, _this2.state, {
            dataQuanLyHoSo: [],
            tableLoading: false,
            loading: false,
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          }));
        }
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: "onChange",
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: "handleChangePageSize",
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: "handlePageClick",
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: "handleExport",
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/ho-so-thanh-tra";
      (0, _exportExcel.exportExcel)(URL, 'hosothanhtra.xlsx');
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.key === 'Enter') {
        this.getListData(true);
      }
    }
  }, {
    key: "handleChangeDate",
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: "getListDV",
    value: function getListDV() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getDonViThongKe.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataOptions: (0, _lodash.get)(res.data, '_embedded.coQuanQuanLies')
          });
        }
      });
    }
  }, {
    key: "getCheckThanhTraTinh",
    value: function getCheckThanhTraTinh() {
      var _this4 = this;

      _api.TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(function (res) {
        var data = res.data;

        var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        _this4.setState(_extends({}, _this4.state, {
          isThanhTraTinh: data,
          donViId: !data ? userInfo.donViId : undefined
        }), function () {
          _this4.getListData();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var dataCoQuanQuanLyList = this.state.dataOptions;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          "div",
          { className: "center reception-container", ref: "qlhs" },
          _react2.default.createElement(
            "div",
            { className: "top-content" },
            _react2.default.createElement(
              "div",
              { className: "left-content" },
              _react2.default.createElement(
                "p",
                { className: "title-18" },
                _react2.default.createElement("i", { className: "tt tt-thanh-tra" }),
                "Danh s\xE1ch h\u1ED3 s\u01A1"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "bottom-content" },
            _react2.default.createElement(
              "div",
              { className: "wrap-block search_form_lichsu" },
              _react2.default.createElement(
                "div",
                { className: "row plr10" },
                _react2.default.createElement(
                  "div",
                  { className: "col-100 no-gutter" },
                  _react2.default.createElement(
                    "div",
                    { className: "search_form_ttt" },
                    _react2.default.createElement(_common.Input, {
                      className: "col-30",
                      placeholder: "Nh\u1EADp m\xE3 h\u1ED3 s\u01A1 t\xECm ki\u1EBFm",
                      value: this.state.keyword,
                      onChange: this.onChange.bind(this, "keyword"),
                      name: "keyword",
                      onKeyDown: this.onKeyDown.bind(this)
                    }),
                    _react2.default.createElement(_common.DropDown, {
                      className: "col-20",
                      label: "C\u01A1 quan l\u01B0u tr\u1EEF",
                      options: dataCoQuanQuanLyList,
                      keyName: "coQuanQuanLyId",
                      valueName: "ten",
                      placeholder: "Ch\u1ECDn",
                      selectedValue: this.state.donViId,
                      onChange: this.onChange.bind(this, 'donViId'),
                      disabled: !this.state.isThanhTraTinh
                    }),
                    _react2.default.createElement(_common.DatePicker, {
                      className: "col-20",
                      label: "T\u1EEB ng\xE0y",
                      onChange: this.handleChangeDate.bind(this, 'startDate'),
                      value: this.state.startDate,
                      endDate: new Date(this.state.endDate)
                    }),
                    _react2.default.createElement(_common.DatePicker, {
                      className: "col-20",
                      label: "\u0110\u1EBFn ng\xE0y",
                      onChange: this.handleChangeDate.bind(this, 'endDate'),
                      value: this.state.endDate,
                      startDate: new Date(this.state.startDate)
                    }),
                    _react2.default.createElement(_core.Button, {
                      className: "btn-green ttt-search",
                      text: "T\xECm ki\u1EBFm",
                      onClick: this.handleSearch.bind(this),
                      disabled: this.state.searching ? "disabled" : ""
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyHoSo.dsQuanLyHoSo,
                dataList: this.state.dataQuanLyHoSo,
                handleExport: this.handleExport.bind(this),
                exporttext: "Xu\u1EA5t Excel",
                thanhTra: true,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemDSQuanLyHoSo, null)
            )
          )
        )
      );
    }
  }]);

  return DanhSachQuanLyHoSo;
}(_react.Component);

exports.default = (0, _reactRedux.connect)()(DanhSachQuanLyHoSo);

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _SearchNhomHoSo = __webpack_require__(1242);

var _SearchNhomHoSo2 = _interopRequireDefault(_SearchNhomHoSo);

var _datatable = __webpack_require__(315);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NhomHoSo = function (_React$Component) {
  _inherits(NhomHoSo, _React$Component);

  function NhomHoSo(props, context) {
    _classCallCheck(this, NhomHoSo);

    var _this = _possibleConstructorReturn(this, (NhomHoSo.__proto__ || Object.getPrototypeOf(NhomHoSo)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      isValid: true,
      moTa: '',
      id: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenNhomFile: '',
      search: false
    };
    return _this;
  }

  _createClass(NhomHoSo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.tenNhomFile) {
        params.ten = this.state.tenNhomFile.trim();
      }
      _api.QuanLyVanBan.actions.getNhomHoSo.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.contents,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            },
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          ten: this.state.ten.trim(),
          moTa: this.state.moTa.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.QuanLyVanBan.actions.putNhomHoSo.request({ id: this.state.id }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.QuanLyVanBan.actions.postNhomHoSo.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(idNhomHoSo) {
      var _this4 = this;

      if (idNhomHoSo) {
        this.setState({ buttonLoading: true });
        _api.QuanLyVanBan.actions.deleteNhomHoSo.request({ id: idNhomHoSo }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].description, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        ten: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        id: item.id,
        ten: item.ten,
        moTa: item.moTa || '',
        isValid: true
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/nhom-ho-so";
      (0, _exportExcel.exportExcel)(URL, 'danhmucnhomhoso.xlsx');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh m\u1EE5c nh\xF3m h\u1ED3 s\u01A1'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_SearchNhomHoSo2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyVanBan.dsNhomHoSo,
                dataList: this.state.data,
                pageData: this.state.pageData,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemNhomHoSo, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa nhóm hồ sơ' : 'Thêm mới nhóm hồ sơ',
              iconName: 'add-new',
              className: 'panel-popup category medium' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', placeholder: 'Nh\u1EADp t\xEAn nh\xF3m h\u1ED3 s\u01A1', label: 'T\xEAn nh\xF3m h\u1ED3 s\u01A1', value: this.state.ten, require: true, maxLength: 255, onChange: this.onChange.bind(this, 'ten'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { placeholder: 'Nh\u1EADp m\xF4 t\u1EA3', label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NhomHoSo;
}(_react2.default.Component);

NhomHoSo.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(NhomHoSo);

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchNhomHoSo = function (_React$Component) {
  _inherits(SearchNhomHoSo, _React$Component);

  function SearchNhomHoSo(props, context) {
    _classCallCheck(this, SearchNhomHoSo);

    var _this = _possibleConstructorReturn(this, (SearchNhomHoSo.__proto__ || Object.getPrototypeOf(SearchNhomHoSo)).call(this, props, context));

    _this.state = {
      tenNhomFile: _this.props.parents.state.tenNhomFile
    };
    return _this;
  }

  _createClass(SearchNhomHoSo, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tenNhomFile: e.target.value
      });
      var data = {
        target: {
          name: 'tenNhomFile',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tenNhomFile',
            placeholder: 'Nh\u1EADp',
            className: 'search-input',
            value: this.state.tenNhomFile,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return SearchNhomHoSo;
}(_react2.default.Component);

exports.default = SearchNhomHoSo;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCanCuCuocThanhTra = function (_Component) {
  _inherits(RowItemCanCuCuocThanhTra, _Component);

  function RowItemCanCuCuocThanhTra() {
    _classCallCheck(this, RowItemCanCuCuocThanhTra);

    return _possibleConstructorReturn(this, (RowItemCanCuCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemCanCuCuocThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemCanCuCuocThanhTra, [{
    key: "render",
    value: function render() {
      var _ref = this.props.item || [],
          ten = _ref.ten,
          coQuanBanHanh = _ref.coQuanBanHanh,
          documentMetaData = _ref.documentMetaData,
          loaiVanBan = _ref.loaiVanBan,
          linhVucVanBan = _ref.linhVucVanBan;

      return _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "td",
          null,
          this.props.count
        ),
        _react2.default.createElement(
          "td",
          null,
          ten || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          coQuanBanHanh.tenCoQuan || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          loaiVanBan.tenLoaiVanBan || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          linhVucVanBan.tenLinhVuc || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              onClick: _jsFileDownload2.default.bind(this, documentMetaData.id, documentMetaData.name),
              className: "txt-underline txt-blue"
            },
            documentMetaData.name || ""
          )
        )
      );
    }
  }]);

  return RowItemCanCuCuocThanhTra;
}(_react.Component);

exports.default = RowItemCanCuCuocThanhTra;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDSQuanLyHoSo = function (_Component) {
  _inherits(RowItemDSQuanLyHoSo, _Component);

  function RowItemDSQuanLyHoSo() {
    _classCallCheck(this, RowItemDSQuanLyHoSo);

    return _possibleConstructorReturn(this, (RowItemDSQuanLyHoSo.__proto__ || Object.getPrototypeOf(RowItemDSQuanLyHoSo)).apply(this, arguments));
  }

  _createClass(RowItemDSQuanLyHoSo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/quan-ly-ho-so/danh-sach-ho-so/' + (0, _lodash.get)(this.props.item, 'cuocThanhTra.id'), className: 'txt-underline txt-blue' },
            (0, _lodash.get)(this.props.item, 'maHoSo') || ''
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'nguoiLuu.hoVaTen') || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'cuocThanhTra.tenDonVi') || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'createdDate') ? (0, _moment2.default)((0, _lodash.get)(this.props.item, 'createdDate')).format('DD/MM/YYYY') : ''
        )
      );
    }
  }]);

  return RowItemDSQuanLyHoSo;
}(_react.Component);

exports.default = RowItemDSQuanLyHoSo;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialog = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemNhomHoSo = function (_React$Component) {
  _inherits(RowItemNhomHoSo, _React$Component);

  function RowItemNhomHoSo() {
    _classCallCheck(this, RowItemNhomHoSo);

    return _possibleConstructorReturn(this, (RowItemNhomHoSo.__proto__ || Object.getPrototypeOf(RowItemNhomHoSo)).apply(this, arguments));
  }

  _createClass(RowItemNhomHoSo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ten
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.id
            })
          )
        )
      );
    }
  }]);

  return RowItemNhomHoSo;
}(_react2.default.Component);

exports.default = RowItemNhomHoSo;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemVanBanXuLy = function (_Component) {
  _inherits(RowItemVanBanXuLy, _Component);

  function RowItemVanBanXuLy() {
    _classCallCheck(this, RowItemVanBanXuLy);

    return _possibleConstructorReturn(this, (RowItemVanBanXuLy.__proto__ || Object.getPrototypeOf(RowItemVanBanXuLy)).apply(this, arguments));
  }

  _createClass(RowItemVanBanXuLy, [{
    key: "render",
    value: function render() {
      var _ref = this.props.item || [],
          ten = _ref.ten,
          soQuyetDinh = _ref.soQuyetDinh,
          ngayQuyetDinh = _ref.ngayQuyetDinh,
          tenFile = _ref.tenFile,
          duongDan = _ref.duongDan;

      return _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "td",
          null,
          this.props.count
        ),
        _react2.default.createElement(
          "td",
          null,
          ten || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          soQuyetDinh || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          ngayQuyetDinh ? (0, _moment2.default)(ngayQuyetDinh).format("DD/MM/YYYY") : ""
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              onClick: _jsFileDownload2.default.bind(this, duongDan, tenFile),
              className: "txt-underline txt-blue"
            },
            tenFile || ""
          )
        )
      );
    }
  }]);

  return RowItemVanBanXuLy;
}(_react.Component);

exports.default = RowItemVanBanXuLy;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _SearchCoQuanBanHanhVanBan = __webpack_require__(1250);

var _SearchCoQuanBanHanhVanBan2 = _interopRequireDefault(_SearchCoQuanBanHanhVanBan);

var _datatable = __webpack_require__(237);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoQuanBanHanhVanBan = function (_React$Component) {
  _inherits(CoQuanBanHanhVanBan, _React$Component);

  function CoQuanBanHanhVanBan(props, context) {
    _classCallCheck(this, CoQuanBanHanhVanBan);

    var _this = _possibleConstructorReturn(this, (CoQuanBanHanhVanBan.__proto__ || Object.getPrototypeOf(CoQuanBanHanhVanBan)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      tenCoQuanBanHanh: '',
      isValid: true,
      moTa: '',
      idLoaiVanBan: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenCoQuan: '',
      search: false
    };
    return _this;
  }

  _createClass(CoQuanBanHanhVanBan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.tenCoQuan) {
        params.tenCoQuan = this.state.tenCoQuan.trim();
      }
      _api.QuanLyVanBan.actions.getCoQuanBanHanhVanBan.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.contents,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            },
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          tenCoQuanBanHanh: this.state.tenCoQuanBanHanh.trim(),
          moTa: this.state.moTa.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.QuanLyVanBan.actions.putCoQuanBanHanhVanBan.request({ id: this.state.idLoaiVanBan }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.QuanLyVanBan.actions.postCoQuanBanHanhVanBan.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(idLoaiVanBan) {
      var _this4 = this;

      if (idLoaiVanBan) {
        this.setState({ buttonLoading: true });
        _api.QuanLyVanBan.actions.deleteCoQuanBanHanhVanBan.request({ id: idLoaiVanBan }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].description, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        tenCoQuanBanHanh: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        idLoaiVanBan: item.id,
        tenCoQuanBanHanh: item.tenCoQuanBanHanh,
        moTa: item.moTa || '',
        isValid: true
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/co-quan-ban-hanh";
      (0, _exportExcel.exportExcel)(URL, 'coquanbanhanhvanban.xlsx');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'C\u01A1 quan ban h\xE0nh v\u0103n b\u1EA3n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_SearchCoQuanBanHanhVanBan2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyVanBan.dsCoQuanBanHanhVanBan,
                dataList: this.state.data,
                pageData: this.state.pageData,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemCoQuanBanHanhVanBan, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa cơ quan ban hành văn bản' : 'Thêm mới cơ quan ban hành văn bản',
              iconName: 'add-new',
              className: 'panel-popup category medium' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', placeholder: 'Nh\u1EADp t\xEAn c\u01A1 quan ban h\xE0nh', label: 'C\u01A1 quan ban h\xE0nh', value: this.state.tenCoQuanBanHanh, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'tenCoQuanBanHanh'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { placeholder: 'Nh\u1EADp m\xF4 t\u1EA3', label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CoQuanBanHanhVanBan;
}(_react2.default.Component);

CoQuanBanHanhVanBan.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CoQuanBanHanhVanBan);

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _SearchDanhMucVanBan = __webpack_require__(1251);

var _SearchDanhMucVanBan2 = _interopRequireDefault(_SearchDanhMucVanBan);

var _datatable = __webpack_require__(237);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucVanBan = function (_React$Component) {
  _inherits(DanhMucVanBan, _React$Component);

  function DanhMucVanBan(props, context) {
    _classCallCheck(this, DanhMucVanBan);

    var _this = _possibleConstructorReturn(this, (DanhMucVanBan.__proto__ || Object.getPrototypeOf(DanhMucVanBan)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenVanBan: '',
      search: false
    };
    return _this;
  }

  _createClass(DanhMucVanBan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.tenVanBan) {
        params.tenVanBan = this.state.tenVanBan.trim();
      }
      _api.QuanLyVanBan.actions.getDanhMucVanBan.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.contents,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            },
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(idLoaiVanBan) {
      var _this3 = this;

      if (idLoaiVanBan) {
        this.setState({ buttonLoading: true });
        _api.QuanLyVanBan.actions.deleteDanhMucVanBan.request({ id: idLoaiVanBan }).then(function (res) {
          _this3.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this3.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].description, 'error');
            _this3.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/danh-muc-van-ban";
      (0, _exportExcel.exportExcel)(URL, 'danhmucvanban.xlsx');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Qu\u1EA3n l\xFD danh m\u1EE5c v\u0103n b\u1EA3n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', to: '/quan-ly-van-ban/danh-sach-van-ban/them-moi' },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_SearchDanhMucVanBan2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyVanBan.dsQuanLyDanhMucVanBan,
                dataList: this.state.data,
                pageData: this.state.pageData,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemDanhMucVanBan, null)
            )
          )
        )
      );
    }
  }]);

  return DanhMucVanBan;
}(_react2.default.Component);

DanhMucVanBan.defaultProps = {};

exports.default = (0, _reactRedux.connect)()(DanhMucVanBan);

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _SearchLinhVucVanBan = __webpack_require__(1252);

var _SearchLinhVucVanBan2 = _interopRequireDefault(_SearchLinhVucVanBan);

var _datatable = __webpack_require__(237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinhVucVanBan = function (_React$Component) {
  _inherits(LinhVucVanBan, _React$Component);

  function LinhVucVanBan(props, context) {
    _classCallCheck(this, LinhVucVanBan);

    var _this = _possibleConstructorReturn(this, (LinhVucVanBan.__proto__ || Object.getPrototypeOf(LinhVucVanBan)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      tenLinhVucVanBan: '',
      isValid: true,
      moTa: '',
      idLinhVucVanBan: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenLinhVuc: '',
      search: false
    };
    return _this;
  }

  _createClass(LinhVucVanBan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.tenLinhVuc) {
        params.tenLinhVuc = this.state.tenLinhVuc.trim();
      }
      _api.QuanLyVanBan.actions.getLinhVucVanBan.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.contents,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            },
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          tenLinhVucVanBan: this.state.tenLinhVucVanBan.trim(),
          moTa: this.state.moTa.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.QuanLyVanBan.actions.putLinhVucVanBan.request({ id: this.state.idLinhVucVanBan }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.QuanLyVanBan.actions.postLinhVucVanBan.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(idLinhVucVanBan) {
      var _this4 = this;

      if (idLinhVucVanBan) {
        this.setState({ buttonLoading: true });
        _api.QuanLyVanBan.actions.deleteLinhVucVanBan.request({ id: idLinhVucVanBan }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].description, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        tenLinhVucVanBan: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        idLinhVucVanBan: item.id,
        tenLinhVucVanBan: item.tenLinhVucVanBan,
        moTa: item.moTa || '',
        isValid: true
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/linh-vuc-van-ban";
      (0, _exportExcel.exportExcel)(URL, 'linhvucvanban.xlsx');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'L\u0129nh v\u1EF1c v\u0103n b\u1EA3n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_SearchLinhVucVanBan2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyVanBan.dsLinhVucVanBan,
                dataList: this.state.data,
                pageData: this.state.pageData,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading, pRowItemLinhVucVanBan: true
              },
              _react2.default.createElement(_datatable.RowItemLinhVucVanBan, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa lĩnh vực văn bản' : 'Thêm mới lĩnh vực văn bản',
              iconName: 'add-new',
              className: 'panel-popup category medium' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', placeholder: 'Nh\u1EADp t\xEAn l\u0129nh v\u1EF1c v\u0103n b\u1EA3n', label: 'T\xEAn l\u0129nh v\u1EF1c v\u0103n b\u1EA3n', value: this.state.tenLinhVucVanBan, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'tenLinhVucVanBan'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { placeholder: 'Nh\u1EADp m\xF4 t\u1EA3', label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LinhVucVanBan;
}(_react2.default.Component);

LinhVucVanBan.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(LinhVucVanBan);

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchCoQuanBanHanhVanBan = function (_React$Component) {
  _inherits(SearchCoQuanBanHanhVanBan, _React$Component);

  function SearchCoQuanBanHanhVanBan(props, context) {
    _classCallCheck(this, SearchCoQuanBanHanhVanBan);

    var _this = _possibleConstructorReturn(this, (SearchCoQuanBanHanhVanBan.__proto__ || Object.getPrototypeOf(SearchCoQuanBanHanhVanBan)).call(this, props, context));

    _this.state = {
      tenCoQuan: _this.props.parents.state.tenCoQuan
    };
    return _this;
  }

  _createClass(SearchCoQuanBanHanhVanBan, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tenCoQuan: e.target.value
      });
      var data = {
        target: {
          name: 'tenCoQuan',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tenCoQuan',
            placeholder: 'Nh\u1EADp',
            className: 'search-input',
            value: this.state.tenCoQuan,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return SearchCoQuanBanHanhVanBan;
}(_react2.default.Component);

exports.default = SearchCoQuanBanHanhVanBan;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchDanhMucVanBan = function (_React$Component) {
  _inherits(SearchDanhMucVanBan, _React$Component);

  function SearchDanhMucVanBan(props, context) {
    _classCallCheck(this, SearchDanhMucVanBan);

    var _this = _possibleConstructorReturn(this, (SearchDanhMucVanBan.__proto__ || Object.getPrototypeOf(SearchDanhMucVanBan)).call(this, props, context));

    _this.state = {
      tenVanBan: _this.props.parents.state.tenVanVan
    };
    return _this;
  }

  _createClass(SearchDanhMucVanBan, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tenVanBan: e.target.value
      });
      var data = {
        target: {
          name: 'tenVanBan',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tenVanBan',
            placeholder: 'Nh\u1EADp',
            className: 'search-input',
            value: this.state.tenVanBan,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return SearchDanhMucVanBan;
}(_react2.default.Component);

exports.default = SearchDanhMucVanBan;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchLinhVucVanBan = function (_React$Component) {
  _inherits(SearchLinhVucVanBan, _React$Component);

  function SearchLinhVucVanBan(props, context) {
    _classCallCheck(this, SearchLinhVucVanBan);

    var _this = _possibleConstructorReturn(this, (SearchLinhVucVanBan.__proto__ || Object.getPrototypeOf(SearchLinhVucVanBan)).call(this, props, context));

    _this.state = {
      tenLinhVuc: _this.props.parents.state.tenLinhVuc
    };
    return _this;
  }

  _createClass(SearchLinhVucVanBan, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tenLinhVuc: e.target.value
      });
      var data = {
        target: {
          name: 'tenLinhVuc',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tenLinhVuc',
            placeholder: 'Nh\u1EADp',
            className: 'search-input',
            value: this.state.tenLinhVuc,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return SearchLinhVucVanBan;
}(_react2.default.Component);

exports.default = SearchLinhVucVanBan;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchTheLoaiVanBan = function (_React$Component) {
  _inherits(SearchTheLoaiVanBan, _React$Component);

  function SearchTheLoaiVanBan(props, context) {
    _classCallCheck(this, SearchTheLoaiVanBan);

    var _this = _possibleConstructorReturn(this, (SearchTheLoaiVanBan.__proto__ || Object.getPrototypeOf(SearchTheLoaiVanBan)).call(this, props, context));

    _this.state = {
      tenVanBan: _this.props.parents.state.tenVanVan
    };
    return _this;
  }

  _createClass(SearchTheLoaiVanBan, [{
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.parents.handleSearch();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        tenVanBan: e.target.value
      });
      var data = {
        target: {
          name: 'tenVanBan',
          value: e.target.value
        }
      };
      this.props.parents.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block search-container' },
        _react2.default.createElement(
          'form',
          { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
          _react2.default.createElement('input', {
            type: 'text',
            name: 'tenVanBan',
            placeholder: 'Nh\u1EADp',
            className: 'search-input',
            value: this.state.tenVanBan,
            onChange: this.handleChange.bind(this)
          }),
          _react2.default.createElement(_core.Button, {
            type: 'submit',
            text: 'T\xECm ki\u1EBFm',
            className: this.props.parents.state.tableLoading ? this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
          })
        )
      );
    }
  }]);

  return SearchTheLoaiVanBan;
}(_react2.default.Component);

exports.default = SearchTheLoaiVanBan;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _SearchTheLoaiVanBan = __webpack_require__(1253);

var _SearchTheLoaiVanBan2 = _interopRequireDefault(_SearchTheLoaiVanBan);

var _datatable = __webpack_require__(237);

var _config = __webpack_require__(16);

var _exportExcel = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheLoaiVanBan = function (_React$Component) {
  _inherits(TheLoaiVanBan, _React$Component);

  function TheLoaiVanBan(props, context) {
    _classCallCheck(this, TheLoaiVanBan);

    var _this = _possibleConstructorReturn(this, (TheLoaiVanBan.__proto__ || Object.getPrototypeOf(TheLoaiVanBan)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      tenLoaiVanBan: '',
      isValid: true,
      moTa: '',
      idLoaiVanBan: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenVanBan: '',
      search: false
    };
    return _this;
  }

  _createClass(TheLoaiVanBan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.setState({
        search: true
      });
      this.getListData(true);
    }
  }, {
    key: 'getListData',
    value: function getListData(isSearch) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });
      if (isSearch) {
        this.setState({
          searchLoading: true
        });
      }
      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.tenVanBan) {
        params.tenVanBan = this.state.tenVanBan.trim();
      }
      _api.QuanLyVanBan.actions.getLoaiVanBan.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.contents,
            pageData: {
              number: res.data.pageNumber,
              size: res.data.pageSize,
              totalElements: res.data.totalElements,
              totalPages: res.data.totalPages
            },
            tableLoading: false,
            searchLoading: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            searchLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'createCategory',
    value: function createCategory() {
      var _this3 = this;

      if (this.checkValidate()) {
        var params = {
          tenLoaiVanBan: this.state.tenLoaiVanBan.trim(),
          moTa: this.state.moTa.trim()
        };

        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          _api.QuanLyVanBan.actions.putLoaiVanBan.request({ id: this.state.idLoaiVanBan }, params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.QuanLyVanBan.actions.postLoaiVanBan.request('', params).then(function (res) {
            _this3.getListData();
            _this3.toggleDialog();
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this3.setState({ buttonLoading: false });
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this3.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(idLoaiVanBan) {
      var _this4 = this;

      if (idLoaiVanBan) {
        this.setState({ buttonLoading: true });
        _api.QuanLyVanBan.actions.deleteLoaiVanBan.request({ id: idLoaiVanBan }).then(function (res) {
          _this4.getListData();
          (0, _toastr.Toastr)(_message.msg.delCategorySucess, 'success');
          _this4.setState({ buttonLoading: false });
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].description, 'error');
            _this4.setState({ buttonLoading: false });
          }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ popupAddCategory: !this.state.popupAddCategory });
      this.props.validators['danhMuc'] = [];
    }
  }, {
    key: 'openAddNewCategory',
    value: function openAddNewCategory() {
      this.toggleDialog();
      this.setState({
        addType: 0,
        tenLoaiVanBan: '',
        moTa: '',
        isValid: true
      });
    }
  }, {
    key: 'openUpdateCategory',
    value: function openUpdateCategory(item) {
      this.toggleDialog();
      this.setState({
        addType: 2,
        idLoaiVanBan: item.id,
        tenLoaiVanBan: item.tenLoaiVanBan,
        moTa: item.moTa || '',
        isValid: true
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + "/loai-van-ban";
      (0, _exportExcel.exportExcel)(URL, 'theloaivanban.xlsx');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Th\u1EC3 lo\u1EA1i v\u0103n b\u1EA3n'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openAddNewCategory.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(_SearchTheLoaiVanBan2.default, { parents: this }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.quanLyVanBan.dsTheLoaiVanBan,
                dataList: this.state.data,
                pageData: this.state.pageData,
                handleExport: this.handleExport.bind(this),
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: true,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_datatable.RowItemTheLoaiVanBan, null)
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.popupAddCategory,
              onClose: this.toggleDialog.bind(this),
              title: this.state.addType == 2 ? 'Chỉnh sửa loại văn bản' : 'Thêm mới loại văn bản',
              iconName: 'add-new',
              className: 'panel-popup category medium' },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              _react2.default.createElement(_common.Input, { className: '', placeholder: 'Nh\u1EADp t\xEAn th\u1EC3 lo\u1EA1i v\u0103n b\u1EA3n', label: 'T\xEAn th\u1EC3 lo\u1EA1i v\u0103n b\u1EA3n', value: this.state.tenLoaiVanBan, require: true, maxLength: 40, onChange: this.onChange.bind(this, 'tenLoaiVanBan'),
                bindValidator: this, channel: 'danhMuc' }),
              _react2.default.createElement(_common.TextArea, { placeholder: 'Nh\u1EADp m\xF4 t\u1EA3', label: 'M\xF4 t\u1EA3', maxLength: 255, rows: 5, value: this.state.moTa, onChange: this.onChange.bind(this, 'moTa'), className: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialog.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save", onClick: this.createCategory.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TheLoaiVanBan;
}(_react2.default.Component);

TheLoaiVanBan.defaultProps = {
  validators: {}
};

function bindStateToProps(state) {
  return {};
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TheLoaiVanBan);

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _message = __webpack_require__(10);

var _layout = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemMoiVanBan = function (_React$Component) {
  _inherits(ThemMoiVanBan, _React$Component);

  function ThemMoiVanBan(props, context) {
    _classCallCheck(this, ThemMoiVanBan);

    var _this = _possibleConstructorReturn(this, (ThemMoiVanBan.__proto__ || Object.getPrototypeOf(ThemMoiVanBan)).call(this, props, context));

    _this.state = {
      dataComboboxCoQuanBanHanh: [],
      dataComboboxTheLoaiVanBan: [],
      dataComboboxLinhVucVanBan: [],
      btnSaveLoading: false,
      dataForm: {
        tenVanBan: '',
        coQuanBanHanhId: '',
        linhVucVanBanId: '',
        loaiVanBanId: '',
        soVanBan: '',
        ngayRaVanBan: '',
        documentId: '',
        fileName: ''
      },
      validFile: true,
      isErrorUploadFile: false
    };
    return _this;
  }

  _createClass(ThemMoiVanBan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListLoaiVanBan();
      this.getListCoQuanBanHanh();
      this.getListLinhVucVanBan();
      if (this.props.params.id) {
        this.getDetail(this.props.params.id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.params.id != nextProps.params.id && nextProps.params.id) {
        this.getDetail(nextProps.params.id);
      }
    }
  }, {
    key: 'handleBack',
    value: function handleBack() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['danhMuc'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      if (!this.state.dataForm.fileName) {
        pass = false;
        this.setState(_extends({}, this.state, { validFile: false
        }));
      }
      return pass;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this2 = this;

      if (this.checkValidate()) {
        var dataForm = this.state.dataForm;
        var payload = {
          id: this.props.params.id || undefined,
          tenVanBan: dataForm.tenVanBan.trim(),
          coQuanBanHanhId: dataForm.coQuanBanHanhId,
          linhVucVanBanId: dataForm.linhVucVanBanId,
          loaiVanBanId: dataForm.loaiVanBanId,
          soVanBan: dataForm.soVanBan.trim(),
          ngayRaVanBan: (0, _moment2.default)(dataForm.ngayRaVanBan).add(7, 'hours').toISOString(),
          documentId: dataForm.documentId
        };
        if (this.props.params.id) {
          _api.QuanLyVanBan.actions.putDanhMucVanBan.request({ id: this.props.params.id }, payload).then(function (res) {
            (0, _toastr.Toastr)(_message.msg.updateCategorySucess, 'success');
            _this2.setState({ buttonLoading: false });
            _this2.handleBack();
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this2.setState({ buttonLoading: false });
            }
          });
        } else {
          _api.QuanLyVanBan.actions.postDanhMucVanBan.request('', payload).then(function (res) {
            (0, _toastr.Toastr)(_message.msg.addCategorySucess, 'success');
            _this2.setState({ buttonLoading: false });
            _this2.handleBack();
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              _this2.setState({ buttonLoading: false });
            }
          });
        }
      }
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this3 = this;

      _api.QuanLyVanBan.actions.getChiTietDanhMucVanBan.request({ id: id }).then(function (res) {
        if (res.data) {
          var data = res.data;
          _this3.setState(_extends({}, _this3.state, {
            dataForm: {
              tenVanBan: data.tenVanBan,
              coQuanBanHanhId: data.coQuanBanHanh.id,
              linhVucVanBanId: data.linhVucVanBan.id,
              loaiVanBanId: data.loaiVanBan.id,
              soVanBan: data.soVanBan,
              ngayRaVanBan: data.ngayRaVanBan ? new Date(data.ngayRaVanBan) : '',
              documentId: data.documentMetaData.id,
              fileName: data.documentMetaData.name
            }
          }));
        }
      });
    }
  }, {
    key: 'getListLoaiVanBan',
    value: function getListLoaiVanBan() {
      var _this4 = this;

      _api.QuanLyVanBan.actions.getListLoaiVanBan.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataComboboxTheLoaiVanBan: res.data
          });
        }
      });
    }
  }, {
    key: 'getListCoQuanBanHanh',
    value: function getListCoQuanBanHanh() {
      var _this5 = this;

      _api.QuanLyVanBan.actions.getListCoQuanBanHanh.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            dataComboboxCoQuanBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'getListLinhVucVanBan',
    value: function getListLinhVucVanBan() {
      var _this6 = this;

      _api.QuanLyVanBan.actions.getListLinhVucVanBan.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataComboboxLinhVucVanBan: res.data
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState({
        dataForm: _extends({}, this.state.dataForm, _defineProperty({}, name, e.target.value))
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState({
          dataForm: _extends({}, this.state.dataForm, _defineProperty({}, name, e._d))
        });
      } else {
        this.setState({
          dataForm: _extends({}, this.state.dataForm, _defineProperty({}, name, e))
        });
      }
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this7 = this;

      if (e.target.files[0]) {
        this.setState(_extends({}, this.state, { validFile: true
        }));
        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (!_config.LimitFileType2.includes(ext)) {
          (0, _toastr.Toastr)(_message.msg.fileTypeErr2, 'warning');
        } else {
          var params = { field: 'file', file: e.target.files[0] };

          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var data = res.data;
            var newState = _extends({}, _this7.state, {
              dataForm: _extends({}, _this7.state.dataForm, {
                documentId: data.id,
                fileName: data.name
              }),
              isError: false
            });
            _this7.setState(_extends({}, newState));
          }).catch(function (error) {
            _this7.setState({
              isError: true
            });
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.handleBack.bind(this), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              this.props.params.id ? 'Chỉnh sửa văn bản' : 'Thêm mới văn bản'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'mt10' },
                _react2.default.createElement('div', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '1. Th\xF4ng tin v\u0103n b\u1EA3n'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement(_common.Input, {
                    label: 'T\xEAn v\u0103n b\u1EA3n',
                    className: 'col-25',
                    value: this.state.dataForm.tenVanBan,
                    onChange: this.onChange.bind(this, 'tenVanBan'),
                    name: 'tenVanBan',
                    require: true,
                    bindValidator: this,
                    channel: 'danhMuc',
                    placeholder: 'Nh\u1EADp t\xEAn v\u0103n b\u1EA3n',
                    maxLength: 128
                  }),
                  _react2.default.createElement(_common.DropDown, {
                    className: 'col-25',
                    label: 'C\u01A1 quan ban h\xE0nh',
                    options: this.state.dataComboboxCoQuanBanHanh,
                    keyName: 'giaTri',
                    valueName: 'ten',
                    placeholder: 'Ch\u1ECDn',
                    selectedValue: this.state.dataForm.coQuanBanHanhId,
                    onChange: this.onChange.bind(this, 'coQuanBanHanhId'),
                    bindValidator: this,
                    require: true,
                    channel: 'danhMuc'
                  }),
                  _react2.default.createElement(_common.DropDown, {
                    className: 'col-25',
                    label: 'Th\u1EC3 lo\u1EA1i v\u0103n b\u1EA3n',
                    options: this.state.dataComboboxTheLoaiVanBan,
                    keyName: 'giaTri',
                    valueName: 'ten',
                    placeholder: 'Ch\u1ECDn',
                    selectedValue: this.state.dataForm.loaiVanBanId,
                    onChange: this.onChange.bind(this, 'loaiVanBanId'),
                    bindValidator: this,
                    require: true,
                    channel: 'danhMuc'
                  }),
                  _react2.default.createElement(_common.DropDown, {
                    className: 'col-25',
                    label: 'L\u0129nh v\u1EF1c v\u0103n b\u1EA3n',
                    options: this.state.dataComboboxLinhVucVanBan,
                    keyName: 'giaTri',
                    valueName: 'ten',
                    placeholder: 'Ch\u1ECDn',
                    selectedValue: this.state.dataForm.linhVucVanBanId,
                    onChange: this.onChange.bind(this, 'linhVucVanBanId'),
                    bindValidator: this,
                    require: true,
                    channel: 'danhMuc'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30 pb30' },
                  _react2.default.createElement(_common.Input, {
                    label: 'S\u1ED1 v\u0103n b\u1EA3n',
                    className: 'col-25',
                    value: this.state.dataForm.soVanBan,
                    onChange: this.onChange.bind(this, 'soVanBan'),
                    name: 'soVanBan',
                    require: true,
                    bindValidator: this,
                    channel: 'danhMuc',
                    placeholder: 'Nh\u1EADp s\u1ED1 v\u0103n b\u1EA3n',
                    maxLength: 255
                  }),
                  _react2.default.createElement(_common.DatePicker, {
                    label: 'Ng\xE0y ra v\u0103n b\u1EA3n',
                    className: 'col-25',
                    value: this.state.dataForm.ngayRaVanBan,
                    onChange: this.handleChangeDate.bind(this, 'ngayRaVanBan'),
                    name: 'ngayRaVanBan',
                    require: true,
                    bindValidator: this,
                    channel: 'danhMuc',
                    placeholder: 'Ch\u1ECDn ng\xE0y ra v\u0103n b\u1EA3n'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100' },
                    _react2.default.createElement(
                      'label',
                      { className: 'ip-label' },
                      '\u0110\xEDnh k\xE8m v\u0103n b\u1EA3n',
                      _react2.default.createElement(
                        'span',
                        { className: 'text-required' },
                        '*'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'upload_file_content ml5' },
                    _react2.default.createElement('input', { type: 'file', className: 'upload', onChange: this.uploadFile.bind(this) }),
                    _react2.default.createElement(
                      'span',
                      { htmlFor: 'file', className: 'mb5' },
                      'T\u1EA3i l\xEAn t\u1EADp tin'
                    )
                  ),
                  !this.state.validFile && _react2.default.createElement(
                    'span',
                    { className: 'pt-form-helper-text ml5' },
                    _message.msg.messageDefault
                  ),
                  this.state.dataForm.fileName && _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'txt-underline txt-blue ml5', onClick: function onClick() {
                        (0, _utils.downloadFile)(_this8.state.dataForm.documentId, _this8.state.dataForm.fileName);
                      } },
                    this.state.dataForm.fileName ? this.state.dataForm.fileName : '',
                    ' '
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pl0 pr0 pt35 pb5' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false, 'close') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo",
                  onClick: this.handleSave.bind(this)
                },
                _react2.default.createElement(
                  'span',
                  null,
                  this.props.params.id ? 'Cập nhật' : 'Thêm mới'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThemMoiVanBan;
}(_react2.default.Component);

ThemMoiVanBan.defaultProps = {
  validators: {},
  params: {
    id: ''
  }
};

exports.default = ThemMoiVanBan;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialog = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCoQuanBanHanhVanBan = function (_Component) {
  _inherits(RowItemCoQuanBanHanhVanBan, _Component);

  function RowItemCoQuanBanHanhVanBan() {
    _classCallCheck(this, RowItemCoQuanBanHanhVanBan);

    return _possibleConstructorReturn(this, (RowItemCoQuanBanHanhVanBan.__proto__ || Object.getPrototypeOf(RowItemCoQuanBanHanhVanBan)).apply(this, arguments));
  }

  _createClass(RowItemCoQuanBanHanhVanBan, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tenCoQuanBanHanh
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.id
            })
          )
        )
      );
    }
  }]);

  return RowItemCoQuanBanHanhVanBan;
}(_react.Component);

exports.default = RowItemCoQuanBanHanhVanBan;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialog = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhMucVanBan = function (_React$Component) {
  _inherits(RowItemDanhMucVanBan, _React$Component);

  function RowItemDanhMucVanBan() {
    _classCallCheck(this, RowItemDanhMucVanBan);

    return _possibleConstructorReturn(this, (RowItemDanhMucVanBan.__proto__ || Object.getPrototypeOf(RowItemDanhMucVanBan)).apply(this, arguments));
  }

  _createClass(RowItemDanhMucVanBan, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tenVanBan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.coQuanBanHanh.tenCoQuanBanHanh
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.loaiVanBan.tenLoaiVanBan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.linhVucVanBan.tenLinhVucVanBan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/quan-ly-van-ban/danh-sach-van-ban/chinh-sua/' + this.props.item.id, className: 'itt-edit' },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.id
            })
          )
        )
      );
    }
  }]);

  return RowItemDanhMucVanBan;
}(_react2.default.Component);

exports.default = RowItemDanhMucVanBan;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialog = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLinhVucVanBan = function (_Component) {
  _inherits(RowItemLinhVucVanBan, _Component);

  function RowItemLinhVucVanBan() {
    _classCallCheck(this, RowItemLinhVucVanBan);

    return _possibleConstructorReturn(this, (RowItemLinhVucVanBan.__proto__ || Object.getPrototypeOf(RowItemLinhVucVanBan)).apply(this, arguments));
  }

  _createClass(RowItemLinhVucVanBan, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tenLinhVucVanBan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.id
            })
          )
        )
      );
    }
  }]);

  return RowItemLinhVucVanBan;
}(_react.Component);

exports.default = RowItemLinhVucVanBan;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialog = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTheLoaiVanBan = function (_React$Component) {
  _inherits(RowItemTheLoaiVanBan, _React$Component);

  function RowItemTheLoaiVanBan() {
    _classCallCheck(this, RowItemTheLoaiVanBan);

    return _possibleConstructorReturn(this, (RowItemTheLoaiVanBan.__proto__ || Object.getPrototypeOf(RowItemTheLoaiVanBan)).apply(this, arguments));
  }

  _createClass(RowItemTheLoaiVanBan, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tenLoaiVanBan
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.moTa
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-edit',
                onClick: this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item) },
              'Ch\u1EC9nh s\u1EEDa'
            ),
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá danh mục',
              content: 'Bạn chắc chắn muốn xoá danh mục này?',
              redux: this.props.parent,
              deleteId: this.props.item.id
            })
          )
        )
      );
    }
  }]);

  return RowItemTheLoaiVanBan;
}(_react2.default.Component);

exports.default = RowItemTheLoaiVanBan;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _add = __webpack_require__(1264);

var _table = __webpack_require__(12);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(16);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _dialog = __webpack_require__(18);

var _layout = __webpack_require__(9);

var _popupDetail = __webpack_require__(487);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddReceptionPeriodical = function (_React$Component) {
  _inherits(AddReceptionPeriodical, _React$Component);

  function AddReceptionPeriodical(props, context) {
    _classCallCheck(this, AddReceptionPeriodical);

    var _this = _possibleConstructorReturn(this, (AddReceptionPeriodical.__proto__ || Object.getPrototypeOf(AddReceptionPeriodical)).call(this, props, context));

    _this.state = {
      isSubmit: false,
      selectedDate: Date,
      closeOnSelection: true,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tableLoading: false,
      isEnabled: false,
      DataLanhDao: [],
      DataDon: [],
      DataLoaiDonThu: [],
      dsCoQuanToChucTiepDan: [],
      hoSoTuNgay: (0, _moment2.default)().startOf('month'),
      hoSoDenNgay: (0, _moment2.default)().endOf('month'),
      diaDiemTiep: '',
      donViTiepDan: '',
      saveLoading: false,
      selectAll: false,
      loadData: false,
      ngayTiepNhan: (0, _moment2.default)(),
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,
      ngayTiepValid: true,
      loaiDonId: '',
      linhVucCap1Id: '',
      linhVucCap2Id: '',
      linhVucCap3Id: '',
      donDaChon: [],
      backConfirm: false,
      hasChange: false,
      detailPopupStatus: false,
      detailPopupInfo: { noiDung: '' }
    };
    return _this;
  }

  _createClass(AddReceptionPeriodical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getSelectLanhDaoTiep();
      this.getListHoSo();
      this.getListLoaiDonThu();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'loaiDonId') {
        this.state.linhVucCap1Id = '';
        this.state.linhVucCap2Id = '';
        this.state.linhVucCap3Id = '';
      }
      if (name == 'linhVucCap1Id') {
        this.state.linhVucCap2Id = '';
        this.state.linhVucCap3Id = '';
      }
      if (name == 'linhVucCap2Id') {
        this.state.linhVucCap3Id = '';
      }

      this.state[name] = e.target.value;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'getSelectLanhDaoTiep',
    value: function getSelectLanhDaoTiep() {
      var _this2 = this;

      _api.Reception.actions.getListLanhDao.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            DataLanhDao: res.data._embedded.congChucs
          });
        }
      });
    }
  }, {
    key: 'getListHoSo',
    value: function getListHoSo(type) {
      var _this3 = this;

      if (this.validateForm()) {
        var params = {
          tuNgay: (0, _moment2.default)().startOf('month').format(),
          denNgay: (0, _moment2.default)().endOf('month').format(),
          page: this.state.pageData.number,
          size: this.state.pageData.size
        };

        if (type == "search") {
          this.setState({
            search: true
          });
          if (this.state.hoSoTuNgay) {
            params.tuNgay = (0, _moment2.default)(this.state.hoSoTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }
          if (this.state.hoSoDenNgay) {
            params.denNgay = (0, _moment2.default)(this.state.hoSoDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }
          if (this.state.linhVucCap1Id) {
            params.linhVucId = this.state.linhVucCap1Id;
          }
          if (this.state.linhVucCap2Id) {
            params.linhVucChiTietChaId = this.state.linhVucCap2Id;
          }
          if (this.state.linhVucCap3Id) {
            params.linhVucChiTietConId = this.state.linhVucCap3Id;
          }
          if (this.state.loaiDonId) {
            params.loaiDon = this.state.loaiDonId;
          }
        }

        this.setState({
          loadData: true
        });
        _api.Reception.actions.gethoSoVuViec.request(params).then(function (res) {
          if (res.data._embedded) {
            res.data._embedded.dons.map(function (item, i) {
              if (_this3.state.donDaChon.indexOf(item.donId) != -1) {
                item.checked = true;
              } else {
                item.checked = false;
              }
            });
            _this3.setState({
              DataDon: res.data._embedded.dons,
              pageData: res.data.page
            });
          } else {
            _this3.setState({
              DataDon: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this3.setState({
            search: false,
            selectAll: false,
            loadData: false,
            searchSubmit: false
          });
        });
      }
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      this.setState({ searchSubmit: true });
      var pass = true;
      if (this.state.hoSoTuNgay) {
        this.state.startDateValid = (0, _moment2.default)(this.state.hoSoTuNgay, 'DD/MM/YYYY').isValid();
        if (pass) pass = this.state.startDateValid;
        this.setState({ startDateValid: this.state.startDateValid });
      }
      if (this.state.hoSoDenNgay) {
        this.state.endDateValid = (0, _moment2.default)(this.state.hoSoDenNgay, 'DD/MM/YYYY').isValid();
        if (pass) pass = this.state.endDateValid;
        this.setState({ endDateValid: this.state.endDateValid });
      }
      return pass;
    }
  }, {
    key: 'createData',
    value: function createData() {
      var _this4 = this;

      var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      if (this.checkValidate()) {
        this.setState({ saveLoading: true });
        var params = {
          canBoTiepDan: { id: this.state.congChucId },
          loaiTiepDan: 'DINH_KY'
        };

        if (userInfo) {
          params.donViId = userInfo.donViId;
          params.congChucId = userInfo.id;
        }

        if (this.state.diaDiemTiep) {
          params.diaDiemGapLanhDao = this.state.diaDiemTiep;
        }

        if (this.state.ngayTiepNhan) {
          params.ngayTiepDan = (0, _moment2.default)(this.state.ngayTiepNhan).add(7, 'hours').toISOString();
        }

        if (this.state.dsCoQuanToChucTiepDan.length > 0) {
          params.coQuanToChucTiepDans = [];
          this.state.dsCoQuanToChucTiepDan.map(function (item, i) {
            var cqData = {
              chucVu: item.chucVu,
              nguoiDaiDien: item.nguoiDaiDien,
              coQuanDonVi: { id: item.tencoquan }
            };
            params.coQuanToChucTiepDans.push(cqData);
          });
        }

        this.state.DataLanhDao.map(function (item, i) {
          if (item.congChucId == _this4.state.congChucId) {
            params.donViTiepDan = { id: item.donViCongChuc.coQuanQuanLyId };
          }
        });
        this.processCreateTCD(this.state.donDaChon, 0, params);
      }
    }
  }, {
    key: 'processCreateTCD',
    value: function processCreateTCD(list, index, params) {
      var _this5 = this;

      params.don = { id: list[index] };
      _axios2.default.post(_config.API_URL + '/soTiepCongDans', params).then(function (res) {
        if (index < list.length - 1) {
          _this5.processCreateTCD(list, index + 1, params);
        } else {
          (0, _toastr.Toastr)(_message.msg.createSuccess, 'success');
          setTimeout(function () {
            _reactRouter.browserHistory.goBack();
          }, 1000);
        }
      }).catch(function (error) {
        if (index < list.length - 1) {
          _this5.processCreateTCD(list, index + 1, params);
        } else {
          _this5.setState({ saveLoading: false });
          (0, _toastr.Toastr)('Đã có lỗi xảy ra, vui lòng thử lại!', 'error');
        }
      });
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      if (pass) {
        pass = (0, _moment2.default)(this.state.ngayTiepNhan, 'DD/MM/YYYY').isValid();
      }

      var isCheck = this.state.donDaChon.length > 0;

      if (!isCheck) {
        (0, _toastr.Toastr)(_message.msg.datDonPeriodical, 'warning');
        pass = false;
      }
      return pass;
    }
  }, {
    key: 'getListLoaiDonThu',
    value: function getListLoaiDonThu() {
      var _this6 = this;

      _api.Reception.actions.getLoaiDonThu.request().then(function (res) {
        if (res.data) {
          _this6.setState({ DataLoaiDonThu: res.data });
        }
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index, name) {

      this.state[name].splice(index, 1);
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeEditableTLBS',
    value: function handleChangeEditableTLBS(index, name, value) {
      this.state.dsCoQuanToChucTiepDan[index][name] = value;
      this.setState({ dsCoQuanToChucTiepDan: this.state.dsCoQuanToChucTiepDan, hasChange: true });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListHoSo();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListHoSo();
    }
  }, {
    key: 'handleChangeCheckbox',
    value: function handleChangeCheckbox(item, e) {
      item.checked = !item.checked;
      if (item.checked) {
        this.state.donDaChon.push(item.donId);
      } else {
        this.state.donDaChon.splice(this.state.donDaChon.indexOf(item.donId), 1);
      }
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeCheckboxAll',
    value: function handleChangeCheckboxAll(index, e) {
      var _this7 = this;

      this.state.isEnabled = !this.state.isEnabled;
      this.setState(_extends({}, this.state));
      this.state.DataDon.map(function (item, i) {
        item.checked = _this7.state.isEnabled;
        _this7.setState(_extends({}, _this7.state));
      });
    }
  }, {
    key: 'addCoQuan',
    value: function addCoQuan() {
      var arrLength = this.state.dsCoQuanToChucTiepDan.length;
      if (arrLength == 0 || arrLength > 0 && this.state.dsCoQuanToChucTiepDan[arrLength - 1].tencoquan != '') {
        this.state.dsCoQuanToChucTiepDan[this.state.dsCoQuanToChucTiepDan.length] = {
          tencoquan: null,
          nguoiDaiDien: '',
          chucVu: ''
        };
        this.setState({
          dsCoQuanToChucTiepDan: this.state.dsCoQuanToChucTiepDan,
          hasChange: true
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.state.hasChange = true;
      this.setState(_extends({}, newData));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {

      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleClickDetail',
    value: function handleClickDetail(item, status) {
      this.setState({
        detailPopupStatus: status,
        detailPopupInfo: item
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'panel-page add-reception-periodical' },
          _react2.default.createElement(_popupDetail.DetailReception, {
            noiDung: this.state.detailPopupInfo.noiDung,
            item: this.state.detailPopupInfo,
            isOpen: this.state.detailPopupStatus,
            onClose: this.handleClickDetail.bind(this, {}, false)
          }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.handleBack.bind(this, false), title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-add' },
                'Th\xEAm m\u1EDBi cu\u1ED9c ti\u1EBFp \u0111\u1ECBnh k\u1EF3 c\u1EE7a l\xE3nh \u0111\u1EA1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'form',
                { className: 'form' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items mb0' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward' },
                      _react2.default.createElement(
                        'div',
                        { className: 'container-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form inline-bottom' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(_common.DropDown, { className: 'col-input', label: 'L\xE3nh \u0111\u1EA1o ti\u1EBFp', selectedValue: this.state.congChucId, require: true, options: this.state.DataLanhDao, keyName: 'congChucId', valueName: 'hoVaTen', placeholder: true,
                                onChange: this.onChange.bind(this, 'congChucId'), bindValidator: this, channel: 'formTaoDon', name: 'dropdownChonLanhDaoTiep' }),
                              _react2.default.createElement(_common.DatePicker, { className: 'col-input', label: 'Ng\xE0y ti\u1EBFp', bindValidator: this, channel: 'formTaoDon', timeFormat: 'HH:mm', onChange: this.handleChangeDate.bind(this, 'ngayTiepNhan'), value: this.state.ngayTiepNhan, maxLength: 18, dateFormat: 'DD/MM/YYYY -' }),
                              _react2.default.createElement(_common.Input, { className: 'col-w60', label: '\u0110\u1ECBa \u0111i\u1EC3m', value: this.state.diaDiemTiep, onChange: this.onChange.bind(this, 'diaDiemTiep'), name: 'inputDiaDiem' })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  'h3',
                                  null,
                                  'Danh s\xE1ch c\u01A1 quan, c\xE1c \u0111\u01A1n v\u1ECB c\xF9ng tham gia ti\u1EBFp c\xF4ng d\xE2n'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form pb15' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12 white-table row-center' },
                                _react2.default.createElement(
                                  _dataTable2.default,
                                  {
                                    header: _table.header.receptionPeriodical.add,
                                    dataList: this.state.dsCoQuanToChucTiepDan,
                                    hidePagination: true,
                                    hideExport: true,
                                    showAddMore: true,
                                    addMore: this.addCoQuan.bind(this),
                                    parent: this },
                                  _react2.default.createElement(_add.RowItemAddReceptionPeriodical, { bindValidator: this })
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward' },
                      _react2.default.createElement(
                        'div',
                        { className: 'container-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  'h3',
                                  null,
                                  'Ch\u1ECDn \u0111\u01A1n/v\u1EE5 vi\u1EC7c \u0111\u01B0\u1EE3c l\xE3nh \u0111\u1EA1o ti\u1EBFp'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form wrap-block' },
                            _react2.default.createElement(
                              'div',
                              { className: 'row pl15 pr15' },
                              _react2.default.createElement(_common.DatePicker, { className: 'col-16 input-inside', label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.hoSoDenNgay,
                                onChange: this.handleChangeDate.bind(this, 'hoSoTuNgay'), value: this.state.hoSoTuNgay, name: 'dinhKyTuNgay' }),
                              _react2.default.createElement(_common.DatePicker, { className: 'col-16 input-inside', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.hoSoTuNgay,
                                onChange: this.handleChangeDate.bind(this, 'hoSoDenNgay'), value: this.state.hoSoDenNgay, name: 'dinhKyDenNgay' }),
                              _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { className: 'col-16 input-inside', name: 'loaiDonThu', selectedValue: this.state.loaiDonId, label: 'Lo\u1EA1i \u0111\u01A1n', onChange: this.onChange.bind(this, 'loaiDonId') }),
                              _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThu, { className: 'col-16 input-inside', name: 'linhVucDonThu', selectedValue: this.state.linhVucCap1Id, loaiDonThuID: this.state.loaiDonId, onChange: this.onChange.bind(this, 'linhVucCap1Id') }),
                              _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThuChiTiet, { className: 'col-16 input-inside', loaiDonThuID: this.state.loaiDonId, selectedValue: this.state.linhVucCap2Id, linhVucDonThuID: this.state.linhVucCap1Id, onChange: this.onChange.bind(this, 'linhVucCap2Id'), name: 'linhVucDonThuChiTiet' }),
                              _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThuChiTiet, { className: 'col-16 input-inside', loaiDonThuID: this.state.loaiDonId, selectedValue: this.state.linhVucCap3Id, label: '\xA0', linhVucDonThuID: this.state.linhVucCap2Id, onChange: this.onChange.bind(this, 'linhVucCap3Id'), name: 'linhVucDonThuChiTietCon' }),
                              _react2.default.createElement(
                                'div',
                                { className: 'col-100 mb18 txt-center' },
                                _react2.default.createElement(_core.Button, {
                                  className: 'btn-green tt-search ' + (this.state.search ? 'btn-loading-inline' : this.state.loadData ? 'btn-disable' : ''),
                                  text: 'L\u1EA5y danh s\xE1ch',
                                  onClick: this.getListHoSo.bind(this, 'search')
                                })
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'col-100 pb20' },
                                _react2.default.createElement('span', { className: 'line-border' })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'group-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  'h3',
                                  null,
                                  'Danh s\xE1ch \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form add-periodical-custom-table' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  _dataTable2.default,
                                  {
                                    header: _table.header.receptionPeriodical.listBriefJob,
                                    dataList: this.state.DataDon,
                                    pageData: this.state.pageData,
                                    parent: this,
                                    tableLoading: this.state.loadData,
                                    search: this.state.search,
                                    hideExport: true },
                                  _react2.default.createElement(_add.RowItemListBriefJob, { onClickDetail: this.handleClickDetail.bind(this) })
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'box-bottom' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u0110\xF3ng'
                    )
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-save ' + (this.state.loadData ? 'btn-disable' : this.state.saveLoading ? 'btn-loading-inline' : ''), onClick: this.createData.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddReceptionPeriodical;
}(_react2.default.Component);

AddReceptionPeriodical.defaultProps = {
  validators: []
};

exports.default = AddReceptionPeriodical;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddReceptionPeriodical = undefined;

var _AddReceptionPeriodical = __webpack_require__(1260);

var _AddReceptionPeriodical2 = _interopRequireDefault(_AddReceptionPeriodical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddReceptionPeriodical = _AddReceptionPeriodical2.default;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemAddReceptionPeriodical = function (_React$Component) {
  _inherits(RowItemAddReceptionPeriodical, _React$Component);

  function RowItemAddReceptionPeriodical(props, context) {
    _classCallCheck(this, RowItemAddReceptionPeriodical);

    var _this = _possibleConstructorReturn(this, (RowItemAddReceptionPeriodical.__proto__ || Object.getPrototypeOf(RowItemAddReceptionPeriodical)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(RowItemAddReceptionPeriodical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getCoQuanTiepDan.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'coQuanTiepDanList',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.props.parent.handleChangeEditableTLBS(this.props.count - 1, name, e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { width: 45, minWidth: 45, maxWidth: 45 } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 300, minWidth: 300, maxWidth: 250, padding: 10 } },
          _react2.default.createElement(_common.DropDownTreeSelectOneElement, { className: 'col-100 mb0-18', bindValidator: this, channel: 'formTaoDon', placeholder: true, require: true, dataOptions: this.state.data, value: this.props.item.tencoquan, onChange: this.onChange.bind(this, 'tencoquan'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId', name: 'cqCungTiepDan' + this.props.count })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 200, padding: 10 } },
          _react2.default.createElement(_common.Input, { className: 'col-100 mb0-18', value: this.props.item.nguoiDaiDien, onChange: this.onChange.bind(this, 'nguoiDaiDien'), name: 'nguoiDaiDien' + this.props.count })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 200, padding: 10 } },
          _react2.default.createElement(_common.Input, { className: 'col-100 mb0-18', value: this.props.item.chucVu, onChange: this.onChange.bind(this, 'chucVu'), name: 'chucVu' + this.props.count })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 110, textAlign: 'left' } },
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap' },
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xác nhận',
              content: 'Bạn chắc chắn muốn xoá cơ quan này?',
              onSuccess: this.props.parent.handleRemove.bind(this.props.parent, this.props.count - 1, 'dsCoQuanToChucTiepDan'),
              index: this.props.count - 1
            })
          )
        )
      );
    }
  }]);

  return RowItemAddReceptionPeriodical;
}(_react2.default.Component);

RowItemAddReceptionPeriodical.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanTiepDanList
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(RowItemAddReceptionPeriodical));

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListBriefJob = function (_React$Component) {
  _inherits(RowItemListBriefJob, _React$Component);

  function RowItemListBriefJob() {
    _classCallCheck(this, RowItemListBriefJob);

    return _possibleConstructorReturn(this, (RowItemListBriefJob.__proto__ || Object.getPrototypeOf(RowItemListBriefJob)).apply(this, arguments));
  }

  _createClass(RowItemListBriefJob, [{
    key: 'handleClickDetail',
    value: function handleClickDetail() {
      this.props.onClickDetail(this.props.item, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var tenloaidon = this.props.parent.state.DataLoaiDonThu.map(function (item, i) {
        if (_this2.props.item.loaiDon == item.giaTri) {
          return _react2.default.createElement(
            'li',
            { value: item.giaTri, key: i },
            item.ten
          );
        }
      });
      return _react2.default.createElement(
        'tr',
        { className: this.props.item.checked ? "active_checkbox" : '' },
        _react2.default.createElement(
          'td',
          { className: 'middle-content' },
          _react2.default.createElement(_core.Checkbox, { checked: this.props.item.checked, className: 'pt-large', onChange: this.props.parent.handleChangeCheckbox.bind(this.props.parent, this.props.item), name: 'checkboxDanhSachDon' })
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _moment2.default)(this.props.item.ngayLapDonGapLanhDaoTmp).format('DD/MM/YYYY'),
          _react2.default.createElement('br', null),
          (0, _moment2.default)(this.props.item.ngayLapDonGapLanhDaoTmp).format('HH:mm')
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.listNguoiDungDon.length ? _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-bold' },
              this.props.item.listNguoiDungDon[0].hoVaTen
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.listNguoiDungDon[0].diaChi
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.listNguoiDungDon[0].soDienThoai
            )
          ) : null
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline', onClick: this.handleClickDetail.bind(this) },
            _react2.default.createElement(_reactTextTruncate2.default, {
              line: 3,
              truncateText: '\u2026',
              text: this.props.item.noiDung
            })
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            tenloaidon,
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi,
              '\xA0Ng\u01B0\u1EDDi'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDon ? this.props.item.coQuanDaGiaiQuyetDon.ten : ''
        )
      );
    }
  }]);

  return RowItemListBriefJob;
}(_react2.default.Component);

exports.default = RowItemListBriefJob;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListBriefJob = exports.RowItemAddReceptionPeriodical = undefined;

var _RowItemAddReceptionPeriodical = __webpack_require__(1262);

var _RowItemAddReceptionPeriodical2 = _interopRequireDefault(_RowItemAddReceptionPeriodical);

var _RowItemListBriefJob = __webpack_require__(1263);

var _RowItemListBriefJob2 = _interopRequireDefault(_RowItemListBriefJob);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemAddReceptionPeriodical = _RowItemAddReceptionPeriodical2.default;
exports.RowItemListBriefJob = _RowItemListBriefJob2.default;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListAttachReceptionPeriodical = function (_React$Component) {
  _inherits(RowItemListAttachReceptionPeriodical, _React$Component);

  function RowItemListAttachReceptionPeriodical() {
    _classCallCheck(this, RowItemListAttachReceptionPeriodical);

    return _possibleConstructorReturn(this, (RowItemListAttachReceptionPeriodical.__proto__ || Object.getPrototypeOf(RowItemListAttachReceptionPeriodical)).apply(this, arguments));
  }

  _createClass(RowItemListAttachReceptionPeriodical, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soQuyetDinh
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayQuyetDinh ? (0, _moment2.default)(this.props.item.ngayQuyetDinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: _jsFileDownload2.default.bind(this, this.props.item.duongDan, this.props.item.tenFile) },
              this.props.item.tenFile
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: function onClick() {
                  (0, _utils.downloadFile)(_this2.props.item.duongDan, _this2.props.item.tenFile);
                } },
              this.props.item.tenFile
            )
          )
        )
      );
    }
  }]);

  return RowItemListAttachReceptionPeriodical;
}(_react2.default.Component);

exports.default = RowItemListAttachReceptionPeriodical;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListOrganizationPeriodical = function (_React$Component) {
  _inherits(RowItemListOrganizationPeriodical, _React$Component);

  function RowItemListOrganizationPeriodical() {
    _classCallCheck(this, RowItemListOrganizationPeriodical);

    return _possibleConstructorReturn(this, (RowItemListOrganizationPeriodical.__proto__ || Object.getPrototypeOf(RowItemListOrganizationPeriodical)).apply(this, arguments));
  }

  _createClass(RowItemListOrganizationPeriodical, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDonViInfo ? this.props.item.coQuanDonViInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.nguoiDaiDien
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.chucVu
        )
      );
    }
  }]);

  return RowItemListOrganizationPeriodical;
}(_react2.default.Component);

exports.default = RowItemListOrganizationPeriodical;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListProofReceptionPeriodical = function (_React$Component) {
  _inherits(RowItemListProofReceptionPeriodical, _React$Component);

  function RowItemListProofReceptionPeriodical() {
    _classCallCheck(this, RowItemListProofReceptionPeriodical);

    return _possibleConstructorReturn(this, (RowItemListProofReceptionPeriodical.__proto__ || Object.getPrototypeOf(RowItemListProofReceptionPeriodical)).apply(this, arguments));
  }

  _createClass(RowItemListProofReceptionPeriodical, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tinhTrangTaiLieuStr ? this.props.item.tinhTrangTaiLieuStr : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-blue', onClick: _jsFileDownload2.default.bind(this, this.props.item.duongDan, this.props.item.tenFile) },
              this.props.item.tenFile
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: function onClick() {
                  (0, _utils.downloadFile)(_this2.props.item.duongDan, _this2.props.item.tenFile);
                } },
              this.props.item.tenFile
            )
          )
        )
      );
    }
  }]);

  return RowItemListProofReceptionPeriodical;
}(_react2.default.Component);

exports.default = RowItemListProofReceptionPeriodical;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemReception = function (_React$Component) {
  _inherits(RowItemReception, _React$Component);

  function RowItemReception(props, context) {
    _classCallCheck(this, RowItemReception);

    var _this = _possibleConstructorReturn(this, (RowItemReception.__proto__ || Object.getPrototypeOf(RowItemReception)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(RowItemReception, [{
    key: 'getLocal',
    value: function getLocal(diachi) {
      if (this.props.item.donSTCD.listNguoiDungDon.length) {
        var dungDon = [];
        if (diachi.diaChi) {
          dungDon.push(diachi.diaChi);
        }
        if (diachi.toThon) {
          dungDon.push(diachi.toThon);
        }
        if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
          dungDon.push(diachi.phuongXaCongDan.ten);
        }
        if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
          dungDon.push(diachi.quanHuyenCongDan.ten);
        }
        if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
          dungDon.push(diachi.tinhThanhCongDan.ten);
        }
        return dungDon.join(", ");
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('DD/MM/YYYY') : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('HH:mm') : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-bold' },
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.getLocal(this.props.item.donSTCD.listNguoiDungDon[0])
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].soDienThoai : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET' || this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? null : _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/dinh-ky/chi-tiet/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ),
              this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET' ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/hoan-thanh/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ) : null,
              this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.loaiDonText || ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.soNguoi,
              ' Ng\u01B0\u1EDDi'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.donSTCD.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.canBoTiepDanInfo.hoVaTen
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.huongGiaiQuyetTCDLanhDaoStr ? this.props.item.huongGiaiQuyetTCDLanhDaoStr : ''
        ),
        _react2.default.createElement(
          'td',
          { className: this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? 'txt-warning' : '' },
          this.props.item.tinhTrangXuLyLanhDaoStr ? this.props.item.tinhTrangXuLyLanhDaoStr : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao !== 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' && !this.props.item.donSTCD.dangGiaoKTDX ? _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-edit', to: '/tiep-cong-dan/lanh-dao/dinh-ky-chinh-sua/' + this.props.item.soTiepCongDanId },
                'X\u1EED l\xFD'
              )
            ) : null,
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-redirect', to: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/' + this.props.item.soTiepCongDanId },
                'X\u1EED l\xFD'
              )
            ) : null,
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_XOA') && !this.props.item.hoanThanhTCDLanhDao && !this.props.item.donSTCD.dangGiaoKTDX ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá đơn thư',
              labelButton: 'H\u1EE7y',
              content: 'Bạn chắc chắn muốn xoá đơn thư này?',
              redux: this.props.parent,
              deleteId: this.props.item.soTiepCongDanId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemReception;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemReception);

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _reactRedux = __webpack_require__(6);

var _CheckPermission = __webpack_require__(20);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemYeuCau = function (_React$Component) {
  _inherits(RowItemYeuCau, _React$Component);

  function RowItemYeuCau(props, context) {
    _classCallCheck(this, RowItemYeuCau);

    var _this = _possibleConstructorReturn(this, (RowItemYeuCau.__proto__ || Object.getPrototypeOf(RowItemYeuCau)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: '',
      dialogXuly: false
    };
    return _this;
  }

  _createClass(RowItemYeuCau, [{
    key: 'getListData',
    value: function getListData() {
      this.props.getListData();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.item.trangThaiDonInfo) {
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == _this2.props.userInfo.donViId;
        }).map(function (child, i) {
          if (_this2.props.item.ma && child.ketQuaType === 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Đình chỉ',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else if (!_this2.props.item.ma && child.ketQuaType === 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Rút đơn',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else {
            _this2.setState({
              ketQuaStr: child.ketQuaStr,
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          }
        });
      }

      if (this.props.item.canBoDangXuLyInfo) {
        this.props.item.canBoDangXuLyInfo.filter(function (item) {
          return item.donViId == _this2.props.userInfo.donViId;
        }).map(function (child, i) {
          if (child.hoVaTen != "") _this2.setState({
            canBoXuLy: child.hoVaTen
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.type && this.props.type != nextProps.type) {
        this.setState({
          type: nextProps.type
        });
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(diachi) {
      var dungDon = [];
      if (diachi.diaChi) {
        dungDon.push(diachi.diaChi);
      }
      if (diachi.toThon) {
        dungDon.push(diachi.toThon);
      }
      if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
        dungDon.push(diachi.phuongXaCongDan.ten);
      }
      if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
        dungDon.push(diachi.quanHuyenCongDan.ten);
      }
      if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
        dungDon.push(diachi.tinhThanhCongDan.ten);
      }
      return dungDon.join(", ");
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;
      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this3 = this;

      var thoiHanXuLy = {};

      if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == _this3.props.userInfo.donViId;
          }).map(function (child, i) {

            if (child.trangThaiDonType === 'DANG_XU_LY') thoiHanXuLy = _this3.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType === 'DANG_GIAI_QUYET') thoiHanXuLy = _this3.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type === 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type === 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type === 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type === 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type === 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'openPopupXuLy',
    value: function openPopupXuLy(status) {
      this.setState({ dialogXuly: status });
    }
  }, {
    key: 'handleClickDetail',
    value: function handleClickDetail() {
      this.props.onClickDetail(this.props.item, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _moment2.default)(this.props.item.ngayLapDonGapLanhDaoTmp).format('DD/MM/YYYY')
            ),
            _react2.default.createElement(
              'li',
              null,
              (0, _moment2.default)(this.props.item.ngayLapDonGapLanhDaoTmp).format('HH:mm')
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: this.handleClickDetail.bind(this) },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              this.showThoiHanXuLyDon()
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-italic' },
              nguonDonDonVi
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.trangThaiYeuCauGapLanhDaoInfo ? this.props.item.trangThaiYeuCauGapLanhDaoInfo.ten : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_XOA') && (!this.props.item.soTiepCongDanYCGLD || this.props.item.soTiepCongDanYCGLD && !this.props.item.soTiepCongDanYCGLD.hoanThanhTCDLanhDao) && !this.props.item.dangGiaoKTDX && this.props.item.trangThaiYeuCauGapLanhDao !== 'DONG_Y' ? _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-redirect', onClick: this.openPopupXuLy.bind(this, true) },
                'X\u1EED l\xFD'
              ),
              _react2.default.createElement(_dialog.XuLyYeuCau, { trangThaiList: this.props.trangThaiList, open: this.state.dialogXuly, onClose: this.openPopupXuLy.bind(this, false), data: this.props.item, onSuccess: this.props.parent.getListData.bind(this.props.parent) })
            ) : ''
          )
        )
      );
    }
  }]);

  return RowItemYeuCau;
}(_react2.default.Component);

RowItemYeuCau.defaultProps = {
  dataLoaiDonThu: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemYeuCau);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _detail = __webpack_require__(194);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _config = __webpack_require__(16);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _letterDetail = __webpack_require__(168);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailReceptionPeriodical = function (_React$Component) {
  _inherits(DetailReceptionPeriodical, _React$Component);

  function DetailReceptionPeriodical(props, context) {
    _classCallCheck(this, DetailReceptionPeriodical);

    var _this = _possibleConstructorReturn(this, (DetailReceptionPeriodical.__proto__ || Object.getPrototypeOf(DetailReceptionPeriodical)).call(this, props, context));

    _this.state = {
      donViPhoiHopStr: '',
      closeOnSelection: true,
      tenLoaiDonThu: '',
      tenHuongGiaiQuyet: '',
      tenLoaiDoiTuong: '',
      tenLoaiDoiTuongKT: '',
      dataLoaiNguoiDD: [],
      hinhThucGiaiQuyetData: [],
      tableLoading: true,
      detail: {
        canBoTiepDanInfo: {
          hoVaTen: ''
        },
        coQuanToChucTiepDanSTCD: [],
        donSTCD: {
          listNguoiDungDon: [],
          nguoiDuocUyQuyen: {
            chucVu: '',
            diaChiCoQuan: '',
            luatSu: '',
            ngayCapTheLuatSu: '',
            noiCapTheLuatSu: '',
            phanLoaiCongDan: '',
            soDienThoai: '',
            soTheLuatSu: '',
            tenCoQuan: '',
            coUyQuyen: false,
            danTocCongDan: {
              ten: ''
            },
            diaChi: '',
            gioiTinh: true,
            hoVaTen: '',
            ngayCap: '',
            ngaySinh: '',
            noiCapCMNDInfo: {
              ten: ''
            },
            phuongXaCongDan: {
              ten: ''
            },
            quanHuyenCongDan: {
              ten: ''
            },
            quocTichCongDan: {
              ten: ''
            },
            soCMNDHoChieu: '',
            tinhThanhCongDan: {
              ten: ''
            },
            toThon: ''
          },
          listTaiLieuBangChung: [],
          listTaiLieuBangChungLuatSu: [],
          listTaiLieuVanThu: [],
          loaiDon: '',
          loaiDoiTuong: '',
          loaiNguoiDungDon: '',
          linhVucDonThuDon: {
            ten: ''
          },
          linhVucDonThuChiTietDon: {
            ten: ''
          },
          chiTietLinhVucDonThuChiTietDon: {
            ten: ''
          },
          noiDung: '',
          coQuanDaGiaiQuyetDon: {
            ten: '',
            capCoQuanQuanLyInfo: {
              ten: ''
            }
          },
          thamQuyenGiaiQuyetInfo: {
            ten: ''
          },
          lanGiaiQuyet: '',
          hinhThucDaGiaiQuyet: '',
          huongGiaiQuyetDaThucHien: '',
          coThongTinCoQuanDaGiaiQuyet: true
        },
        ghiChuXuLy: '',
        huongGiaiQuyetTCDLanhDao: '',
        huongXuLy: '',
        huongXuLyText: '',
        ketQuaGiaiQuyet: '',
        loaiTiepDan: '',
        ngayTiepDan: new Date(),
        noiDungTiepCongDan: '',
        thoiHan: '',
        trangThaiKetQua: '',
        yKienXuLy: '',
        donViChuTriInfo: {
          ten: ''
        },
        danhSachDonViPhoiHops: []
      },
      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: [],
      listTaiLieuVanThu: []
    };
    return _this;
  }

  _createClass(DetailReceptionPeriodical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetail();
      this.getSoTiepCongDanInfo(this.props.params.id);
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(inputId) {
      var _this2 = this;

      _api.Reception.actions.getDonInfo.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this2.setState({
            listTaiLieuBangChung: [].concat(_toConsumableArray(res.data.listTaiLieuBangChung), _toConsumableArray(res.data.listTaiLieuBangChungLuatSu)),
            dataDoanDiCung: res.data.listDoanDiCung,
            dataNguoiDuocUyQuyen: res.data.nguoiDuocUyQuyen || []
          });
        }
      });
    }
  }, {
    key: 'getSoTiepCongDanInfo',
    value: function getSoTiepCongDanInfo(inputId) {
      var _this3 = this;

      _api.Reception.actions.getSoTiepCongDanInfo.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this3.setState({
            listTaiLieuVanThu: res.data.listTaiLieuVanThu
          });
        }
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail() {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      _api.Reception.actions.getDetailReception.request({ id: this.props.params.id }).then(function (res) {
        if (res.data) {
          var state = _this4.state;
          _this4.getDonInfo(res.data.donSTCD.donId);
          state.detail = res.data;
          state.data = res.data.donSTCD;
          state.loaiNguoiDungDon = res.data.donSTCD.loaiNguoiDungDon || '';
          state.dataNguoiDungDon = res.data.donSTCD.listNguoiDungDon || [];
          state.loaiDon = res.data.donSTCD.loaiDonText || '';
          state.loaiDonGiaTri = res.data.donSTCD.loaiDon || '';
          state.loaiDoiTuong = res.data.donSTCD.loaiDoiTuongInfo || '';
          state.linhVuc = res.data.donSTCD.linhVucDonThuDon.ten || '';
          state.linhVucChiTiet = res.data.donSTCD.linhVucDonThuDon && res.data.donSTCD.linhVucDonThuChiTietDon ? res.data.donSTCD.linhVucDonThuChiTietDon.ten : '';
          state.linhVucChiTietSub = res.data.donSTCD.linhVucDonThuDon && res.data.donSTCD.linhVucDonThuChiTietDon && res.data.donSTCD.chiTietLinhVucDonThuChiTietDon ? res.data.donSTCD.chiTietLinhVucDonThuChiTietDon.ten : '';
          state.noiDung = res.data.donSTCD.noiDung || '';
          state.dataCoQuanDaGiaiQuyet = res.data.donSTCD.coThongTinCoQuanDaGiaiQuyet && res.data.donSTCD.coQuanDaGiaiQuyetDon ? res.data.donSTCD.coQuanDaGiaiQuyetDon : {};

          state.tableLoading = false;
          if (res.data.danhSachDonViPhoiHops) {
            var names = [];
            res.data.danhSachDonViPhoiHops.map(function (item) {
              names.push(item.ten);
            });
            state.donViPhoiHopStr = names.join(', ');
          }
          state.linhVucChiTietKhac = res.data.donSTCD && res.data.donSTCD.linhVucChiTietKhac ? res.data.donSTCD.linhVucChiTietKhac : '';
          _this4.setState(_extends({}, state));
        }
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var diaChi = '';
      var data = this.state.detail.donSTCD.listNguoiDungDon[0];

      if (data.diaChi) {
        diaChi = diaChi + data.diaChi;
      }
      if (data && data.toThon) {
        if (data.diaChi) {
          diaChi = diaChi + ", " + data.toThon;
        } else {
          diaChi = diaChi + data.toThon;
        }
      }
      if (data && data.phuongXaCongDan) {
        if (data.diaChi || data.toThon) {
          diaChi = diaChi + ", " + data.phuongXaCongDan.ten;
        } else {
          diaChi = diaChi + data.phuongXaCongDan.ten;
        }
      }
      if (data && data.quanHuyenCongDan) {
        if (data.diaChi || data.phuongXaCongDan) {
          diaChi = diaChi + ", " + data.quanHuyenCongDan.ten;
        } else {
          diaChi = diaChi + data.quanHuyenCongDan.ten;
        }
      }
      if (data && data.tinhThanhCongDan) {
        if (data.diaChi || data.quanHuyenCongDan) {
          diaChi = diaChi + ", " + data.tinhThanhCongDan.ten;
        } else {
          diaChi = diaChi + data.tinhThanhCongDan.ten;
        }
      }

      var URL = String(_config.API_URL) + "/soTiepCongDans/inPhieuHen?" + "hoVaTen=" + (data.hoVaTen ? data.hoVaTen : '...') + "&chucVu=" + (this.props.userInfo.chucVu ? this.props.userInfo.chucVu : '...') + "&soCMNDHoChieu=" + (data.soCMNDHoChieu ? data.soCMNDHoChieu : '...') + "&ngayCap=" + (data.ngayCap ? (0, _moment2.default)(data.ngayCap).format('DD/MM/YYYY') : "...") + "&noiCap=" + (data.noiCapCMNDInfo ? data.noiCapCMNDInfo.ten : "...") + "&diaChi=" + (diaChi ? diaChi : '...') + "&donViXuLyId=" + this.props.userInfo.donViId + "&noiDung=" + this.state.detail.donSTCD.noiDung + "&diaDiemTiepCongDan=" + (this.state.detail.diaDiemGapLanhDao || '...') + "&thoiGianTiepCongDan=" + (this.state.detail.ngayTiepDan ? (0, _moment2.default)(this.state.detail.ngayTiepDan).format('HH:mm') : "...") + "&ngayHenTiepCongDan=" + (this.state.detail.ngayTiepDan ? (0, _moment2.default)(this.state.detail.ngayTiepDan).format('DD/MM/YYYY') : "...");
      window.open(URL, "_self");
    }
  }, {
    key: 'render',
    value: function render() {
      var isDinhKy = this.props.route.type == 'dinhKy' ? true : false;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { id: 'page', className: 'detail-reception-periodical panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: _reactRouter.browserHistory.goBack, title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-detail' },
                isDinhKy ? 'Chi tiết cuộc tiếp định kỳ của lãnh đạo' : 'CHI TIẾT CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'form',
                { className: 'form' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper mt0' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'L\xE3nh \u0111\u1EA1o ti\u1EBFp:', value: this.state.detail.canBoTiepDanInfo.hoVaTen }),
                        _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'Ng\xE0y ti\u1EBFp:', value: (0, _moment2.default)(this.state.detail.ngayTiepDan).format('DD/MM/YYYY - HH:mm') }),
                        _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: '\u0110\u1ECBa \u0111i\u1EC3m:', value: this.state.detail.diaDiemGapLanhDao })
                      )
                    )
                  ),
                  this.state.detail.coQuanToChucTiepDanSTCD.length ? _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper pb5 pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12 pl15' },
                            _react2.default.createElement(
                              'h3',
                              null,
                              'Danh s\xE1ch c\u01A1 quan, c\xE1c \u0111\u01A1n v\u1ECB c\xF9ng tham gia ti\u1EBFp c\xF4ng d\xE2n'
                            )
                          ),
                          _react2.default.createElement(
                            _dataTable2.default,
                            {
                              header: _table.header.detailReceptionPeriodical.organization,
                              dataList: this.state.detail.coQuanToChucTiepDanSTCD,
                              hidePagination: true,
                              tableLoading: this.state.tableLoading },
                            _react2.default.createElement(_detail.RowItemListOrganizationPeriodical, null)
                          )
                        )
                      )
                    )
                  ) : '',
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
                      title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                      parent: this.state
                    })
                  ),
                  this.state.data.coUyQuyen ? _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
                        title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
                        parent: this.state
                      })
                    )
                  ) : '',
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
                        title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                        isOpen: true,
                        parent: this.state
                      })
                    )
                  ),
                  this.state.data.coThongTinCoQuanDaGiaiQuyet ? _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(_letterDetail.ThongTinCoQuanDaGiaiQuyet, {
                        title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt',
                        isOpen: true,
                        parent: this.state
                      })
                    )
                  ) : '',
                  this.state.data.trangThaiYeuCauGapLanhDao ? _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                              'h3',
                              null,
                              '\xDD ki\u1EBFn l\xE3nh \u0111\u1EA1o'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'items-form' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(_common.Text, {
                            className: 'col-input',
                            label: 'Th\u1EDDi gian:',
                            value: this.state.data.ngayTao ? (0, _moment2.default)(this.state.data.ngayTao).format('DD/MM/YYYY') : '' }),
                          _react2.default.createElement(_common.Text, {
                            className: 'col-input',
                            label: '\xDD ki\u1EBFn l\xE3nh \u0111\u1EA1o:',
                            value: this.state.data.trangThaiYeuCauGapLanhDaoInfo ? this.state.data.trangThaiYeuCauGapLanhDaoInfo.ten : '' }),
                          _react2.default.createElement(_common.Text, {
                            className: 'col-100',
                            label: 'L\xFD do:',
                            value: this.state.data.lyDoThayDoiTTYeuCauGapLanhDao || '' })
                        )
                      )
                    )
                  ) : '',
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12 title pl15' },
                          _react2.default.createElement(
                            'h3',
                            null,
                            'Th\xF4ng tin x\u1EED l\xFD l\u01B0\u1EE3t ti\u1EBFp c\xF4ng d\xE2n'
                          )
                        ),
                        _react2.default.createElement(_common.TextMessage, { className: 'col-12 pl15', label: 'H\u01B0\u1EDBng x\u1EED l\xFD:', value: this.state.detail.huongGiaiQuyetTCDLanhDaoStr }),
                        _react2.default.createElement(_common.TextMessage, { className: 'col-12 pl15', label: '\xDD ki\u1EBFn x\u1EED l\xFD:', value: this.state.detail.yKienXuLy }),
                        this.state.detail.huongGiaiQuyetTCDLanhDao == 'CHO_GIAI_QUYET' ? _react2.default.createElement(
                          'div',
                          { className: 'pl10' },
                          _react2.default.createElement(_common.Text, { label: 'H\u1EA1n x\u1EED l\xFD:', red: true, value: this.state.detail.ngayBaoCaoKetQua ? (0, _moment2.default)(this.state.detail.ngayBaoCaoKetQua).format('DD/MM/YYYY') : '' })
                        ) : null,
                        this.state.listTaiLieuVanThu.length ? _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12 pl15' },
                            _react2.default.createElement(
                              'h3',
                              null,
                              'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD'
                            )
                          ),
                          _react2.default.createElement(
                            _dataTable2.default,
                            {
                              header: _table.header.detailReceptionPeriodical.attach,
                              dataList: this.state.listTaiLieuVanThu,
                              hidePagination: true,
                              tableLoading: this.state.tableLoading },
                            _react2.default.createElement(_detail.RowItemListAttachReceptionPeriodical, null)
                          )
                        ) : null
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'box-bottom' },
                  !this.state.detail.hoanThanhTCDLanhDao && !isDinhKy && _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-print btn-print-left', onClick: this.handleExport.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'T\u1EA3i gi\u1EA5y bi\xEAn nh\u1EADn'
                    )
                  ),
                  isDinhKy ? _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/tiep-cong-dan/dinh-ky/', className: 'btn-action btn-close' },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u0110\xF3ng'
                    )
                  ) : _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/tiep-cong-dan/dot-xuat/', className: 'btn-action btn-close' },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u0110\xF3ng'
                    )
                  ),
                  (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.state.detail.hoanThanhTCDLanhDao && !this.state.detail.donSTCD.dangGiaoKTDX ? isDinhKy ? _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-edit', to: '/tiep-cong-dan/lanh-dao/dinh-ky-chinh-sua/' + this.props.params.id },
                    _react2.default.createElement(
                      'span',
                      null,
                      'S\u1EEDa'
                    )
                  ) : _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-edit', to: '/tiep-cong-dan/lanh-dao/dot-xuat-chinh-sua/' + this.props.params.id },
                    _react2.default.createElement(
                      'span',
                      null,
                      'S\u1EEDa'
                    )
                  ) : null
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DetailReceptionPeriodical;
}(_react2.default.Component);

DetailReceptionPeriodical.defaultProps = {
  loaiDonThu: [],
  loaiDoiTuong: []
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuong: state.duLieuHeThong.loaiDoiTuong
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DetailReceptionPeriodical);

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailReceptionPeriodical = undefined;

var _DetailReceptionPeriodical = __webpack_require__(1270);

var _DetailReceptionPeriodical2 = _interopRequireDefault(_DetailReceptionPeriodical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DetailReceptionPeriodical = _DetailReceptionPeriodical2.default;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formTimkiem = __webpack_require__(100);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var TimKiemYeuCau = function (_React$Component) {
  _inherits(TimKiemYeuCau, _React$Component);

  function TimKiemYeuCau(props, context) {
    _classCallCheck(this, TimKiemYeuCau);

    var _this = _possibleConstructorReturn(this, (TimKiemYeuCau.__proto__ || Object.getPrototypeOf(TimKiemYeuCau)).call(this, props, context));

    _this.state = {
      tuKhoa: '',
      trangThai: '',
      nguonDon: '',
      phanLoai: '',
      trangThaiList: [],

      tuNgay: '',
      denNgay: '',

      searching: _this.props.searching,

      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false,
      nguonDonList: _this.props.nguonDonList
    };
    return _this;
  }

  _createClass(TimKiemYeuCau, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.nguonDonList.length == 0) {
        _api.LetterProcessingWorkFlow.actions.getNguonDon.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'nguonDon',
              data: res.data
            }]
          });
        });
      }
      var data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
      this.state.tuKhoa = data.tuKhoa || '';
      if (data.advanceSearch) {
        this.state.trangThai = data.trangThai || '';
        this.state.nguonDon = data.nguonDon || '';
        this.state.phanLoai = data.phanLoai || '';
        this.state.tuNgay = data.tuNgay ? new Date(data.tuNgay) : '';
        this.state.denNgay = data.denNgay ? new Date(data.denNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.getTrangThai();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();

      if (!this.props.advanceSearch) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      } else {
        if (this.validateSubmitForm()) {
          this.setState({
            doSearch: true
          });
          this.props.handleSearch(this.state, e);
        }
      }

      return;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'getTrangThai',
    value: function getTrangThai() {
      var _this3 = this;

      _api.Reception.actions.getTrangThaiYeuCau.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            trangThaiList: res.data
          });
        } else {
          _this3.setState({
            trangThaiList: []
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
      if (nextProps.nguonDonList != this.props.nguonDonList) {
        this.setState({
          nguonDonList: nextProps.nguonDonList
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');

        if (this.state.doSearch) {
          classes.push('btn-loading');
        }
      }

      var btnClasses = classNames(classes);
      // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'rows' },
          _react2.default.createElement(
            'div',
            { className: 'col-9 no-gutter' },
            _react2.default.createElement(_formTimkiem.InputTuKhoa, { onChange: this.handleChange.bind(this, 'tuKhoa'), value: this.state.tuKhoa }),
            _react2.default.createElement(_common.DatePicker, { label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', bindValidator: this, value: this.state.tuNgay, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay') }),
            _react2.default.createElement(_common.DatePicker, { label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, value: this.state.denNgay, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay') }),
            _react2.default.createElement(
              'div',
              { className: 'clear-left' },
              _react2.default.createElement(_common.DropDown, { label: 'Ph\xE2n lo\u1EA1i',
                className: 'input-group col-25',
                selectedValue: this.state.phanLoai,
                options: this.props.phanLoaiList,
                keyName: 'giaTri', valueName: 'ten',
                onChange: this.handleChangeData.bind(this, 'phanLoai'),
                placeholder: true })
            ),
            _react2.default.createElement(_common.DropDown, { label: 'Ngu\u1ED3n \u0111\u01A1n',
              className: 'input-group col-25',
              selectedValue: this.state.nguonDon,
              options: this.state.nguonDonList,
              keyName: 'giaTri', valueName: 'ten',
              onChange: this.handleChangeData.bind(this, 'nguonDon'),
              placeholder: true }),
            _react2.default.createElement(_common.DropDown, { label: 'Tr\u1EA1ng th\xE1i',
              className: 'input-group col-25',
              selectedValue: this.state.trangThai,
              options: this.state.trangThaiList,
              keyName: 'giaTri', valueName: 'ten',
              onChange: this.handleChangeData.bind(this, 'trangThai'),
              placeholder: true })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-3 padding-button' },
            _react2.default.createElement(
              'div',
              { className: 'btn-wrap full-input-seacrh' },
              _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'input-group full-input-seacrh' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search",
                  onClick: this.cancel.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-delete' }),
                'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
              )
            )
          )
        )
      );
    }
  }]);

  return TimKiemYeuCau;
}(_react2.default.Component);

TimKiemYeuCau.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false,
  nguonDonList: []
};

function bindStateToProps(state) {
  return {
    nguonDonList: state.duLieuHeThong.nguonDon,
    phanLoaiList: state.duLieuHeThong.loaiDonThu
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(TimKiemYeuCau);

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formTimkiem = __webpack_require__(100);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var FormTimKiemNangCao = function (_React$Component) {
  _inherits(FormTimKiemNangCao, _React$Component);

  function FormTimKiemNangCao(props, context) {
    _classCallCheck(this, FormTimKiemNangCao);

    var _this = _possibleConstructorReturn(this, (FormTimKiemNangCao.__proto__ || Object.getPrototypeOf(FormTimKiemNangCao)).call(this, props, context));

    _this.state = {
      searchKey: '',
      receptionType: '',
      tinhTrangXuLy: '',
      ketQuaTiepDan: '',
      lanhDaoTiepDan: '',
      listKetQuaTiepDan: [],
      tinhTrangXuLyList: [],
      startDate: '',
      endDate: '',
      searching: _this.props.searching,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(FormTimKiemNangCao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var key = 'dk';
      if (this.props.type === 'DOT_XUAT') {
        key = 'dx';
      }
      var data = localStorage.getItem(key + 'Data') ? JSON.parse(localStorage.getItem(key + 'Data')) : {};
      this.state.searchKey = data.tuKhoa || '';
      if (data.advanceSearch) {
        this.state.receptionType = data.phanLoaiDon || '';
        this.state.tinhTrangXuLy = data.tinhTrangXuLy || '';
        this.state.ketQuaTiepDan = data.ketQuaTiepDan || '';
        this.state.lanhDaoTiepDan = data.lanhDaoId || '';
        this.state.startDate = data.startDate ? new Date(data.startDate) : '';
        this.state.endDate = data.endDate ? new Date(data.endDate) : '';
      }
      this.setState(_extends({}, this.state));
      this.getKetQuaTiepDan();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();

      if (!this.props.advanceSearch) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      } else {
        if (this.validateSubmitForm()) {
          this.setState({
            doSearch: true
          });
          this.props.handleSearch(this.state, e);
        }
      }

      return;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.getTinhTrangXuLy(e.target.value);
      if (name === 'ketQuaTiepDan') {
        this.setState({ tinhTrangXuLy: '' });
      }
    }
  }, {
    key: 'getTinhTrangXuLy',
    value: function getTinhTrangXuLy(id) {
      var _this2 = this;

      _api.Reception.actions.getTinhTrangXuLy.request(null, {
        ketQuaTiepDan: id
      }).then(function (res) {
        if (res.data) {
          _this2.setState({
            tinhTrangXuLyList: res.data
          });
        } else {
          _this2.setState({
            tinhTrangXuLyList: []
          });
        }
      });
    }
  }, {
    key: 'getKetQuaTiepDan',
    value: function getKetQuaTiepDan() {
      var _this3 = this;

      _api.Reception.actions.getKetQuaTiepDanSearch.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            listKetQuaTiepDan: res.data
          });
        } else {
          _this3.setState({
            listKetQuaTiepDan: []
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');

        if (this.state.doSearch) {
          classes.push('btn-loading');
        }
      }

      var btnClasses = classNames(classes);
      // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'rows' },
          _react2.default.createElement(
            'div',
            { className: 'col-9 no-gutter' },
            _react2.default.createElement(_formTimkiem.InputTuKhoa, { onChange: this.handleChange.bind(this, 'searchKey'), value: this.state.searchKey }),
            _react2.default.createElement(_common.DatePicker, { label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', bindValidator: this, value: this.state.startDate, channel: 'formTaoDon', endDate: this.state.endDate, onChange: this.handleChangeDate.bind(this, 'startDate') }),
            _react2.default.createElement(_common.DatePicker, { label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, value: this.state.endDate, channel: 'formTaoDon', startDate: this.state.startDate, onChange: this.handleChangeDate.bind(this, 'endDate') }),
            _react2.default.createElement(
              'div',
              { className: 'clear-left' },
              _react2.default.createElement(_common.DropDown, { label: 'L\xE3nh \u0111\u1EA1o ti\u1EBFp d\xE2n', selectedValue: this.state.lanhDaoTiepDan, options: this.props.lanhDaoList, valueName: 'hoVaTen', keyName: 'congChucId', placeholder: { key: '', text: '--Chọn--' }, className: 'input-group col-25', onChange: this.handleChange.bind(this, 'lanhDaoTiepDan') })
            ),
            _react2.default.createElement(_common.DropDown, { className: 'input-group col-25', onChange: this.handleChangeData.bind(this, 'ketQuaTiepDan'), options: this.state.listKetQuaTiepDan, placeholder: { key: '', text: '--Chọn--' }, valueName: 'ten', keyName: 'giaTri', label: 'K\u1EBFt qu\u1EA3 ti\u1EBFp d\xE2n', selectedValue: this.state.ketQuaTiepDan }),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaTiepDan },
              _react2.default.createElement(_common.DropDown, { selectedValue: this.state.tinhTrangXuLy, valueName: 'ten', keyName: 'giaTri', className: 'input-group col-25', options: this.state.tinhTrangXuLyList, onChange: this.handleChange.bind(this, 'tinhTrangXuLy'), label: 'T\xECnh tr\u1EA1ng x\u1EED l\xFD', placeholder: { key: '', text: '--Chọn--' } })
            ),
            _react2.default.createElement(_common.DropDown, { selectedValue: this.state.receptionType, valueName: 'ten', keyName: 'giaTri', className: 'input-group col-25', options: this.props.loaiDonThu, onChange: this.handleChange.bind(this, 'receptionType'), label: 'Ph\xE2n lo\u1EA1i \u0111\u01A1n', placeholder: { key: '', text: '--Chọn--' } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-3 padding-button' },
            _react2.default.createElement(
              'div',
              { className: 'btn-wrap full-input-seacrh' },
              _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'input-group full-input-seacrh' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search",
                  onClick: this.cancel.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-delete' }),
                'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
              )
            )
          )
        )
      );
    }
  }]);

  return FormTimKiemNangCao;
}(_react2.default.Component);

FormTimKiemNangCao.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false,
  loaiDonThu: []
};

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    loaiDonThu: state.duLieuHeThong.loaiDonThu
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(FormTimKiemNangCao);

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputTuKhoa = function (_React$Component) {
  _inherits(InputTuKhoa, _React$Component);

  function InputTuKhoa() {
    _classCallCheck(this, InputTuKhoa);

    return _possibleConstructorReturn(this, (InputTuKhoa.__proto__ || Object.getPrototypeOf(InputTuKhoa)).apply(this, arguments));
  }

  _createClass(InputTuKhoa, [{
    key: "onChange",
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "input-group-show" },
        _react2.default.createElement(
          "label",
          { className: "ip-label" },
          "T\u1EEB kho\xE1"
        ),
        _react2.default.createElement("input", { type: "text", name: "searchKey", placeholder: this.props.placehoderText, className: "search-input", onChange: this.onChange.bind(this) })
      );
    }
  }]);

  return InputTuKhoa;
}(_react2.default.Component);

InputTuKhoa.defaultProps = {
  placehoderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function onChange() {
    console.log('Please assign onChange function');
  }
};

exports.default = InputTuKhoa;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhSachYeuCau = exports.DetailReceptionPeriodical = exports.ReceptionPeriodical = exports.ListProofReceptionPeriodical = exports.ListBriefJob = exports.AddReceptionPeriodical = undefined;

var _addReceptionPeriodical = __webpack_require__(1261);

var _listReceptionPeriodical = __webpack_require__(1278);

var _detailReceptionPeriodical = __webpack_require__(1271);

/*------------------------list-reception-periodical-------------------------*/
exports.AddReceptionPeriodical = _addReceptionPeriodical.AddReceptionPeriodical;
exports.ListBriefJob = _addReceptionPeriodical.ListBriefJob;
exports.ListProofReceptionPeriodical = _detailReceptionPeriodical.ListProofReceptionPeriodical;
exports.ReceptionPeriodical = _listReceptionPeriodical.ReceptionPeriodical;
exports.DetailReceptionPeriodical = _detailReceptionPeriodical.DetailReceptionPeriodical;
exports.DanhSachYeuCau = _listReceptionPeriodical.DanhSachYeuCau;

/*------------------------detail-reception-periodical-------------------------*/
/*------------------------add-reception-periodical-------------------------*/

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _formTimkiem = __webpack_require__(316);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(486);

var _layout = __webpack_require__(9);

var _popupDetail = __webpack_require__(487);

var _formSort = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachYeuCau = function (_React$Component) {
  _inherits(DanhSachYeuCau, _React$Component);

  function DanhSachYeuCau(props, context) {
    _classCallCheck(this, DanhSachYeuCau);

    var _this = _possibleConstructorReturn(this, (DanhSachYeuCau.__proto__ || Object.getPrototypeOf(DanhSachYeuCau)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      sortBy: 'ngayLapDonGapLanhDaoTmp,desc',
      trangThaiList: [],
      search: false,
      tableLoading: false,
      searchLoading: false,
      tuKhoa: '',
      trangThai: '',
      nguonDon: '',
      phanLoai: '',
      tuNgay: '',
      denNgay: '',
      detailPopupStatus: false,
      detailPopupInfo: { noiDung: '' }
    };
    return _this;
  }

  _createClass(DanhSachYeuCau, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.tuKhoa = data.tuKhoa || '';
      if (this.state.advanceSearch) {
        this.state.trangThai = data.trangThai || '';
        this.state.nguonDon = data.nguonDon || '';
        this.state.phanLoai = data.phanLoai || '';
        this.state.tuNgay = data.tuNgay ? new Date(data.tuNgay) : '';
        this.state.denNgay = data.denNgay ? new Date(data.denNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
      this.getTrangThai();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('dsycData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('dsycData', JSON.stringify(data));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this2 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };
      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa;
      }

      if (this.state.advanceSearch) {
        if (this.state.trangThai) {
          params.trangThai = this.state.trangThai;
        }

        if (this.state.phanLoai) {
          params.phanLoai = this.state.phanLoai;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tuNgay) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.tuNgay)).add(7, 'hours').toISOString();
        }

        if (this.state.denNgay) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.denNgay)).add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('dsycData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getDanhSachYeuCau.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.dons;
          _this2.state.pageData = res.data.page;
        } else {
          _this2.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this2.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDYC', data: Data });
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      }).catch(function (err) {
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.tuNgay, searchData.denNgay].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this3 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa;
      }

      if (this.state.advanceSearch) {
        if (this.state.trangThai) {
          params.trangThai = this.state.trangThai;
        }

        if (this.state.phanLoai) {
          params.phanLoai = this.state.phanLoai;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tuNgay) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.tuNgay)).add(7, 'hours').toISOString();
        }

        if (this.state.denNgay) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.denNgay)).add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('dsycData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getDanhSachYeuCau.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.dons;
          _this3.state.pageData = res.data.page;
        } else {
          _this3.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this3.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDYC', data: Data });

        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      }).catch(function (err) {
        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
      this.getTrangThai();
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this4 = this;

      this.props.Reception.deleteTiepCongDanDinhKy({ id: sID }).then(function (res) {
        _this4.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listTCDYC',
          idKey: 'soTiepCongDanId',
          id: sID
        });
        _this4.getListData();
        (0, _toastr.Toastr)(_message.msg.dTCDTX, 'success');
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.map(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }
  }, {
    key: 'getTrangThai',
    value: function getTrangThai() {
      var _this5 = this;

      _api.Reception.actions.getTrangThaiYeuCau.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            trangThaiList: res.data
          });
        } else {
          _this5.setState({
            trangThaiList: []
          });
        }
      });
    }
  }, {
    key: 'handleClickDetail',
    value: function handleClickDetail(item, status) {
      var _this6 = this;

      if (status) {
        _api.Reception.actions.getDonInfo.request({ id: item.donId }).then(function (res) {
          if (res.data) {
            _this6.setState({
              detailPopupInfo: _extends({}, item, res.data)
            });
          }
        });
      }
      this.setState({
        detailPopupStatus: status
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(_popupDetail.DetailReception, {
            noiDung: this.state.detailPopupInfo.noiDung,
            item: this.state.detailPopupInfo,
            isOpen: this.state.detailPopupStatus,
            onClose: this.handleClickDetail.bind(this, {}, false)
          }),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'Danh s\xE1ch \u0111\u0103ng k\xFD g\u1EB7p l\xE3nh \u0111\u1EA1o'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_formTimkiem.TimKiemYeuCau, { advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'dangKiGapLanhDao',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.receptionPeriodical.listYeuCau,
                dataList: this.state.data,
                exporttext: 'Xu\u1EA5t s\u1ED5 \u0111\u0103ng k\xFD g\u1EB7p l\xE3nh \u0111\u1EA1o',
                pageData: this.state.pageData,
                sortBy: this.state.sortBy,
                parent: this,
                type: 'DINH_KY',
                typeExport: 'DS_YEU_CAU',
                search: this.state.search,
                tableLoading: this.state.tableLoading
              },
              _react2.default.createElement(_list.RowItemYeuCau, { trangThaiList: this.state.trangThaiList, onClickDetail: this.handleClickDetail.bind(this) })
            )
          )
        )
      );
    }
  }]);

  return DanhSachYeuCau;
}(_react2.default.Component);

DanhSachYeuCau.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDYC
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DanhSachYeuCau);

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _table = __webpack_require__(12);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CheckPermission = __webpack_require__(20);

var _formTimkiem = __webpack_require__(316);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(486);

var _layout = __webpack_require__(9);

var _formSort = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var type = 'DINH_KY';

var ReceptionPeriodical = function (_React$Component) {
  _inherits(ReceptionPeriodical, _React$Component);

  function ReceptionPeriodical(props, context) {
    _classCallCheck(this, ReceptionPeriodical);

    var _this = _possibleConstructorReturn(this, (ReceptionPeriodical.__proto__ || Object.getPrototypeOf(ReceptionPeriodical)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      dataLoaiDonThu: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepDan,desc',
      advanceSearch: false,
      HuongGiaiQuyetLD: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false,
      searchKey: '',
      receptionType: '',
      tinhTrangXuLy: '',
      ketQuaTiepDan: '',
      lanhDaoTiepDan: '',
      startDate: '',
      endDate: ''
    };
    return _this;
  }

  _createClass(ReceptionPeriodical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('dkData') ? JSON.parse(localStorage.getItem('dkData')) : {};
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.searchKey = data.tuKhoa || '';
      if (this.state.advanceSearch) {
        this.state.receptionType = data.phanLoaiDon || '';
        this.state.tinhTrangXuLy = data.tinhTrangXuLy || '';
        this.state.ketQuaTiepDan = data.ketQuaTiepDan || '';
        this.state.lanhDaoTiepDan = data.lanhDaoId || '';
        this.state.startDate = data.startDate ? new Date(data.startDate) : '';
        this.state.endDate = data.endDate ? new Date(data.endDate) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('dkData') ? JSON.parse(localStorage.getItem('dkData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('dkData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('dkData') ? JSON.parse(localStorage.getItem('dkData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('dkData', JSON.stringify(data));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this2 = this;

      var params = {
        loaiTiepCongDan: type,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });
      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }

      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.tinhTrangXuLy) {
          params.tinhTrangXuLy = this.state.tinhTrangXuLy;
        }

        if (this.state.lanhDaoTiepDan) {
          params.lanhDaoId = this.state.lanhDaoTiepDan;
        }

        if (this.state.ketQuaTiepDan) {
          params.ketQuaTiepDan = this.state.ketQuaTiepDan;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.startDate)).add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.endDate)).add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('dkData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));

      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this2.state.pageData = res.data.page;
        } else {
          _this2.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this2.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDDK', data: Data });
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      }).catch(function (err) {
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this3 = this;

      var params = {
        loaiTiepCongDan: type,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }

      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.tinhTrangXuLy) {
          params.tinhTrangXuLy = this.state.tinhTrangXuLy;
        }

        if (this.state.lanhDaoTiepDan) {
          params.lanhDaoId = this.state.lanhDaoTiepDan;
        }

        if (this.state.ketQuaTiepDan) {
          params.ketQuaTiepDan = this.state.ketQuaTiepDan;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.startDate)).add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.endDate)).add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('dkData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this3.state.pageData = res.data.page;
        } else {
          _this3.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this3.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDDK', data: Data });
        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      }).catch(function (err) {
        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this4 = this;

      _api.Reception.actions.deleteTiepCongDanDinhKy.request({ id: sID }).then(function (res) {
        _this4.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listTCDDK',
          idKey: 'soTiepCongDanId',
          id: sID
        });
        _this4.getListData();
        (0, _toastr.Toastr)(_message.msg.dTCDTX, 'success');
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.map(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'S\u1ED5 ti\u1EBFp \u0111\u1ECBnh k\u1EF3 c\u1EE7a l\xE3nh \u0111\u1EA1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', to: '/tiep-cong-dan/dinh-ky/them-moi' },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_formTimkiem.FormTimKiemNangCao, { advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, type: 'DINH_KY' }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'soTiepDinhKy',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.receptionPeriodical.listHome,
                dataList: this.state.data,
                exporttext: 'Xu\u1EA5t s\u1ED5 ti\u1EBFp \u0111\u1ECBnh k\u1EF3',
                pageData: this.state.pageData,
                parent: this,
                type: 'DINH_KY',
                search: this.state.search,
                tableLoading: this.state.tableLoading,
                sortBy: this.state.sortBy
              },
              _react2.default.createElement(_list.RowItemReception, null)
            )
          )
        )
      );
    }
  }]);

  return ReceptionPeriodical;
}(_react2.default.Component);

ReceptionPeriodical.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDDK
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ReceptionPeriodical);

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhSachYeuCau = exports.ReceptionPeriodical = undefined;

var _ReceptionPeriodical = __webpack_require__(1277);

var _ReceptionPeriodical2 = _interopRequireDefault(_ReceptionPeriodical);

var _DanhSachYeuCau = __webpack_require__(1276);

var _DanhSachYeuCau2 = _interopRequireDefault(_DanhSachYeuCau);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ReceptionPeriodical = _ReceptionPeriodical2.default;
exports.DanhSachYeuCau = _DanhSachYeuCau2.default;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _letterDetail = __webpack_require__(168);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailReception = function (_React$Component) {
  _inherits(DetailReception, _React$Component);

  function DetailReception(props, context) {
    _classCallCheck(this, DetailReception);

    var _this = _possibleConstructorReturn(this, (DetailReception.__proto__ || Object.getPrototypeOf(DetailReception)).call(this, props, context));

    _this.state = {
      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: []
    };
    return _this;
  }

  _createClass(DetailReception, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.item) {
        this.setState({
          data: nextProps.item,
          loaiNguoiDungDon: nextProps.item.loaiNguoiDungDon ? nextProps.item.loaiNguoiDungDon : '',
          dataNguoiDungDon: nextProps.item.listNguoiDungDon ? nextProps.item.listNguoiDungDon : [],
          dataNguoiDuocUyQuyen: nextProps.item.coUyQuyen ? nextProps.item.nguoiDuocUyQuyen : [],
          loaiDon: nextProps.item.loaiDonText ? nextProps.item.loaiDonText : '',
          loaiDonGiaTri: nextProps.item.loaiDon ? nextProps.item.loaiDon : '',
          loaiDoiTuong: nextProps.item.loaiDoiTuongInfo ? nextProps.item.loaiDoiTuongInfo : '',
          linhVuc: nextProps.item.linhVucDonThuDon ? nextProps.item.linhVucDonThuDon.ten : '',
          linhVucChiTiet: nextProps.item.linhVucDonThuDon && nextProps.item.linhVucDonThuChiTietDon ? nextProps.item.linhVucDonThuChiTietDon.ten : '',
          linhVucChiTietSub: nextProps.item.linhVucDonThuDon && nextProps.item.linhVucDonThuChiTietDon && nextProps.item.chiTietLinhVucDonThuChiTietDon ? nextProps.item.chiTietLinhVucDonThuChiTietDon.ten : '',
          noiDung: nextProps.item.noiDung ? nextProps.item.noiDung : '',
          listTaiLieuBangChung: nextProps.item.listTaiLieuBangChung ? [].concat(_toConsumableArray(nextProps.item.listTaiLieuBangChung), _toConsumableArray(nextProps.item.listTaiLieuBangChungLuatSu)) : [],
          dataDoanDiCung: nextProps.item.loaiNguoiDungDon == 'DOAN_DONG_NGUOI' ? nextProps.item.listDoanDiCung ? nextProps.item.listDoanDiCung : [] : [],
          dataCoQuanDaGiaiQuyet: nextProps.item.coThongTinCoQuanDaGiaiQuyet && nextProps.item.coQuanDaGiaiQuyetDon ? nextProps.item.coQuanDaGiaiQuyetDon : {}
        });
      }
    }
  }, {
    key: 'handleOnClose',
    value: function handleOnClose() {
      this.props.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.isOpen,
          onClose: this.handleOnClose.bind(this),
          title: this.props.title,
          className: 'handle-letter-dialog'
        },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'div',
            { id: 'page', className: 'panel-page document-detail-page' },
            _react2.default.createElement(
              'div',
              { className: 'center-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'heading no-margin' },
                _react2.default.createElement(
                  'h2',
                  { className: 'heading-title icon-detail' },
                  'Th\xF4ng tin chi ti\u1EBFt \u0111\u01A1n th\u01B0/v\u1EE5 vi\u1EC7c'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrapper_box mt15 mb15' },
                _react2.default.createElement(
                  'div',
                  { className: 'box-items' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-forward ' },
                    _react2.default.createElement(
                      'div',
                      { className: 'container-box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'group-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows box-top' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-6' },
                              _react2.default.createElement(
                                'label',
                                { className: 'pt-label pt-inline' },
                                'Ng\xE0y ti\u1EBFp: ',
                                _react2.default.createElement(
                                  'span',
                                  { className: 'info-document' },
                                  this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY - HH:mm') : this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('DD/MM/YYYY - HH:mm') : ''
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
                  title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                  parent: this.state
                }),
                this.state.data.coUyQuyen ? _react2.default.createElement(
                  'div',
                  { className: 'box-items mt20 mb0' },
                  _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
                    title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
                    parent: this.state
                  })
                ) : '',
                _react2.default.createElement(
                  'div',
                  { className: 'box-items mt20' },
                  _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
                    title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                    isOpen: true,
                    parent: this.state
                  })
                ),
                this.state.data.coThongTinCoQuanDaGiaiQuyet ? _react2.default.createElement(
                  'div',
                  { className: 'box-items' },
                  _react2.default.createElement(_letterDetail.ThongTinCoQuanDaGiaiQuyet, {
                    title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt',
                    isOpen: true,
                    parent: this.state
                  })
                ) : '',
                this.state.data.trangThaiYeuCauGapLanhDao ? _react2.default.createElement(
                  'div',
                  { className: 'box-items pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          '\xDD ki\u1EBFn l\xE3nh \u0111\u1EA1o'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_common.Text, {
                        className: 'col-input',
                        label: 'Th\u1EDDi gian:',
                        value: this.state.data.ngayTao ? (0, _moment2.default)(this.state.data.ngayTao).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, {
                        className: 'col-input',
                        label: '\xDD ki\u1EBFn l\xE3nh \u0111\u1EA1o:',
                        value: this.state.data.trangThaiYeuCauGapLanhDaoInfo ? this.state.data.trangThaiYeuCauGapLanhDaoInfo.ten : '' }),
                      _react2.default.createElement(_common.Text, {
                        className: 'col-100 mt10',
                        label: 'L\xFD do:',
                        value: this.state.data.lyDoThayDoiTTYeuCauGapLanhDao || '' })
                    )
                  )
                ) : ''
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-bottom' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleOnClose.bind(this), className: 'btn-action btn-close' },
            _react2.default.createElement(
              'span',
              null,
              '\u0110\xF3ng'
            )
          )
        )
      );
    }
  }]);

  return DetailReception;
}(_react2.default.Component);

exports.default = DetailReception;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _CheckPermission = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListReceptionUnexpectedly = function (_React$Component) {
  _inherits(RowItemListReceptionUnexpectedly, _React$Component);

  function RowItemListReceptionUnexpectedly(props, context) {
    _classCallCheck(this, RowItemListReceptionUnexpectedly);

    var _this = _possibleConstructorReturn(this, (RowItemListReceptionUnexpectedly.__proto__ || Object.getPrototypeOf(RowItemListReceptionUnexpectedly)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(RowItemListReceptionUnexpectedly, [{
    key: 'getLocal',
    value: function getLocal(diachi) {
      if (this.props.item.donSTCD.listNguoiDungDon.length) {
        var dungDon = [];
        if (diachi.diaChi) {
          dungDon.push(diachi.diaChi);
        }
        if (diachi.toThon) {
          dungDon.push(diachi.toThon);
        }
        if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
          dungDon.push(diachi.phuongXaCongDan.ten);
        }
        if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
          dungDon.push(diachi.quanHuyenCongDan.ten);
        }
        if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
          dungDon.push(diachi.tinhThanhCongDan.ten);
        }
        return dungDon.join(", ");
      }
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('DD/MM/YYYY') : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('HH:mm') : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-bold' },
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.getLocal(this.props.item.donSTCD.listNguoiDungDon[0])
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].soDienThoai : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET' || this.props.item.tinhTrangXuLyTCDLanhDao == 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? null : _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/dot-xuat/chi-tiet/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ),
              this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET' ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/hoan-thanh/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ) : null,
              this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: "/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/" + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.loaiDonText || ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.soNguoi,
              ' Ng\u01B0\u1EDDi'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.donSTCD.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.canBoTiepDanInfo.hoVaTen
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.huongGiaiQuyetTCDLanhDaoStr ? this.props.item.huongGiaiQuyetTCDLanhDaoStr : ''
        ),
        _react2.default.createElement(
          'td',
          { className: this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? 'txt-warning' : '' },
          this.props.item.tinhTrangXuLyLanhDaoStr ? this.props.item.tinhTrangXuLyLanhDaoStr : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao !== 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' && !this.props.item.donSTCD.dangGiaoKTDX ? _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-edit', to: '/tiep-cong-dan/lanh-dao/dot-xuat-chinh-sua/' + this.props.item.soTiepCongDanId },
                'Ch\u1EC9nh s\u1EEDa'
              )
            ) : null,
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao == 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-redirect', to: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/' + this.props.item.soTiepCongDanId },
                'X\u1EED l\xFD'
              )
            ) : null,
            (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_XOA') && !this.props.item.hoanThanhTCDLanhDao && !this.props.item.donSTCD.dangGiaoKTDX ? _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xoá đơn thư',
              content: 'Bạn chắc chắn muốn xoá đơn thư này?',
              redux: this.props.parent,
              deleteId: this.props.item.soTiepCongDanId
            }) : null
          )
        )
      );
    }
  }]);

  return RowItemListReceptionUnexpectedly;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemListReceptionUnexpectedly);

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowItemListReceptionUnexpectedly = undefined;

var _RowItemListReceptionUnexpectedly = __webpack_require__(1280);

var _RowItemListReceptionUnexpectedly2 = _interopRequireDefault(_RowItemListReceptionUnexpectedly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemListReceptionUnexpectedly = _RowItemListReceptionUnexpectedly2.default;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchReception = exports.ReceptionUnexpectedly = undefined;

var _listReceptionUnexpectedly = __webpack_require__(1284);

exports.ReceptionUnexpectedly = _listReceptionUnexpectedly.ReceptionUnexpectedly;
exports.SearchReception = _listReceptionUnexpectedly.SearchReception;
/*------------------------list-reception-unexpectedly-------------------------*/

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _list = __webpack_require__(1281);

var _layout = __webpack_require__(9);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _message = __webpack_require__(10);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _formSort = __webpack_require__(128);

var _CheckPermission = __webpack_require__(20);

var _formTimkiem = __webpack_require__(316);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var type = 'DOT_XUAT';

var ReceptionUnexpectedly = function (_React$Component) {
  _inherits(ReceptionUnexpectedly, _React$Component);

  function ReceptionUnexpectedly(props, context) {
    _classCallCheck(this, ReceptionUnexpectedly);

    var _this = _possibleConstructorReturn(this, (ReceptionUnexpectedly.__proto__ || Object.getPrototypeOf(ReceptionUnexpectedly)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      dataLoaiDonThu: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepDan,desc',
      advanceSearch: false,
      HuongGiaiQuyetLD: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false,
      searchKey: '',
      receptionType: '',
      tinhTrangXuLy: '',
      ketQuaTiepDan: '',
      lanhDaoTiepDan: '',
      startDate: '',
      endDate: ''
    };
    return _this;
  }

  _createClass(ReceptionUnexpectedly, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.searchKey = data.tuKhoa || '';
      if (this.state.advanceSearch) {
        this.state.receptionType = data.phanLoaiDon || '';
        this.state.tinhTrangXuLy = data.tinhTrangXuLy || '';
        this.state.ketQuaTiepDan = data.ketQuaTiepDan || '';
        this.state.lanhDaoTiepDan = data.lanhDaoId || '';
        this.state.startDate = data.startDate ? new Date(data.startDate) : '';
        this.state.endDate = data.endDate ? new Date(data.endDate) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('dxData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('dxData') ? JSON.parse(localStorage.getItem('dxData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('dxData', JSON.stringify(data));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this2 = this;

      var params = {
        loaiTiepCongDan: type,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }

      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.tinhTrangXuLy) {
          params.tinhTrangXuLy = this.state.tinhTrangXuLy;
        }

        if (this.state.lanhDaoTiepDan) {
          params.lanhDaoId = this.state.lanhDaoTiepDan;
        }

        if (this.state.ketQuaTiepDan) {
          params.ketQuaTiepDan = this.state.ketQuaTiepDan;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.startDate)).add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.endDate)).add(7, 'hours').toISOString();
        }
      }

      localStorage.setItem('dxData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));

      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this2.state.pageData = res.data.page;
        } else {
          _this2.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this2.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDDX', data: Data });
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      }).catch(function (err) {
        _this2.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this3 = this;

      var searchTerms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


      var params = {
        loaiTiepCongDan: type,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }

      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.tinhTrangXuLy) {
          params.tinhTrangXuLy = this.state.tinhTrangXuLy;
        }

        if (this.state.lanhDaoTiepDan) {
          params.lanhDaoId = this.state.lanhDaoTiepDan;
        }

        if (this.state.ketQuaTiepDan) {
          params.ketQuaTiepDan = this.state.ketQuaTiepDan;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(new Date(this.state.startDate)).add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(new Date(this.state.endDate)).add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('dxData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this3.state.pageData = res.data.page;
        } else {
          _this3.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this3.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDDX', data: Data });
        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      }).catch(function (err) {
        _this3.state.tableLoading = false;
        _this3.state.searchLoading = false;
        _this3.state.searching = false;
        _this3.state.search = false;
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this4 = this;

      _api.Reception.actions.deleteTiepCongDanDinhKy.request({ id: sID }).then(function (res) {
        _this4.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listTCDDX',
          idKey: 'soTiepCongDanId',
          id: sID
        });
        (0, _toastr.Toastr)(_message.msg.dTCDTX, 'success');
        _this4.getListData();
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.map(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'S\u1ED5 ti\u1EBFp \u0111\u1ED9t xu\u1EA5t c\u1EE7a l\xE3nh \u0111\u1EA1o'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', to: '/tiep-cong-dan/lanh-dao/dot-xuat-them-moi' },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_formTimkiem.FormTimKiemNangCao, { advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, type: 'DOT_XUAT' }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'soTiepDotXuat',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.listTCDDX,
                dataList: this.state.data,
                exporttext: 'Xu\u1EA5t s\u1ED5 ti\u1EBFp \u0111\u1ED9t xu\u1EA5t',
                pageData: this.state.pageData,
                sortBy: this.state.sortBy,
                parent: this,
                search: this.state.search,
                tableLoading: this.state.tableLoading,
                type: 'DOT_XUAT'
              },
              _react2.default.createElement(_list.RowItemListReceptionUnexpectedly, null)
            )
          )
        )
      );
    }
  }]);

  return ReceptionUnexpectedly;
}(_react2.default.Component);

ReceptionUnexpectedly.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDDX
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ReceptionUnexpectedly);

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceptionUnexpectedly = undefined;

var _ReceptionUnexpectedly = __webpack_require__(1283);

var _ReceptionUnexpectedly2 = _interopRequireDefault(_ReceptionUnexpectedly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ReceptionUnexpectedly = _ReceptionUnexpectedly2.default;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _subView = __webpack_require__(33);

var _api = __webpack_require__(5);

var _reactRouter = __webpack_require__(2);

var _ThongTinYeuCauKiemTraDeXuat = __webpack_require__(1292);

var _ThongTinYeuCauKiemTraDeXuat2 = _interopRequireDefault(_ThongTinYeuCauKiemTraDeXuat);

var _ThongTinGiaiQuyet = __webpack_require__(1288);

var _ThongTinGiaiQuyet2 = _interopRequireDefault(_ThongTinGiaiQuyet);

var _KetQuaThongTinGiaiQuyet = __webpack_require__(1286);

var _KetQuaThongTinGiaiQuyet2 = _interopRequireDefault(_KetQuaThongTinGiaiQuyet);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CanBoNhanKetQuaKiemTraDeXuat = function (_React$Component) {
  _inherits(CanBoNhanKetQuaKiemTraDeXuat, _React$Component);

  function CanBoNhanKetQuaKiemTraDeXuat(props, context) {
    _classCallCheck(this, CanBoNhanKetQuaKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (CanBoNhanKetQuaKiemTraDeXuat.__proto__ || Object.getPrototypeOf(CanBoNhanKetQuaKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      isOpen: true,
      id: _this.props.params.id,
      donId: '',
      data: [],
      dataLichSuGiaiQuyet: [],
      dataThongTinYeuCauKiemTraDeXuat: [],
      dataTaiLieuVanThu: [],
      yKienXuLy: '',
      dataLichSuQuaTrinhXuLy: [],
      coQuanToChucTiepDan: [],
      listTLBC: []
    };
    return _this;
  }

  _createClass(CanBoNhanKetQuaKiemTraDeXuat, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetailReception();
      this.getSoTiepCongDanInfo(this.props.params.id);
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory(id) {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: id }).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
        }
      });
    }
  }, {
    key: 'getSoTiepCongDanInfo',
    value: function getSoTiepCongDanInfo(inputId) {
      var _this3 = this;

      _api.Reception.actions.getSoTiepCongDanInfo.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataTaiLieuVanThu: res.data.listTaiLieuVanThu
          });
        }
      });
    }
  }, {
    key: 'getDetailReception',
    value: function getDetailReception() {
      var _this4 = this;

      _api.Reception.actions.getDetailReception.request({ id: this.state.id }).then(function (res) {
        if (res && res.data) {
          var getDonId = '';
          if (res.data.donSTCD && res.data.donSTCD.donId) {
            getDonId = res.data.donSTCD.donId;
          }
          _api.Reception.actions.getDonInfo.request({ id: getDonId }).then(function (resTLBC) {
            if (resTLBC && resTLBC.data && resTLBC.data.listTaiLieuBangChung && resTLBC.data.listTaiLieuBangChung.length > 0) {
              _this4.setState({ listTLBC: resTLBC.data.listTaiLieuBangChung });
            }
          });
          _this4.setState({
            dataThongTinYeuCauKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo,
            yKienXuLy: res.data.yKienXuLy,
            donId: getDonId,
            data: res.data.donSTCD,
            coQuanToChucTiepDan: res.data.coQuanToChucTiepDanSTCD
          });
          _this4.getQuyTrinhXuLyHistory(getDonId);
        } else {
          _this4.setState({
            dataThongTinYeuCauKiemTraDeXuat: [],
            yKienXuLy: '',
            donId: '',
            data: [],
            coQuanToChucTiepDan: []
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'center' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-detail' },
            'Gi\u1EA3i quy\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c c\u1EA7n ki\u1EC3m tra'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-wrapper mb30' },
          _react2.default.createElement(_subView.ChiTietDon, { isOpen: this.state.isOpen, donId: this.state.id, dataGiaiQuyet: this.state.dataLichSuGiaiQuyet, listTLBC: this.state.listTLBC, data: this.state.data, coQuanToChucTiepDan: this.state.coQuanToChucTiepDan }),
          _react2.default.createElement(_subView.QuaTrinhXuLy, { parents: this }),
          _react2.default.createElement(_ThongTinYeuCauKiemTraDeXuat2.default, { data: this.state.dataThongTinYeuCauKiemTraDeXuat, donInfo: this.state.data }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.props.viewOnly },
            _react2.default.createElement(_ThongTinGiaiQuyet2.default, { id: this.state.id, donId: this.state.donId })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.viewOnly },
            _react2.default.createElement(_KetQuaThongTinGiaiQuyet2.default, { id: this.state.id, donId: this.state.donId })
          )
        )
      );
    }
  }]);

  return CanBoNhanKetQuaKiemTraDeXuat;
}(_react2.default.Component);

exports.default = CanBoNhanKetQuaKiemTraDeXuat;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaThongTinGiaiQuyet = function (_React$Component) {
  _inherits(KetQuaThongTinGiaiQuyet, _React$Component);

  function KetQuaThongTinGiaiQuyet(props, context) {
    _classCallCheck(this, KetQuaThongTinGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (KetQuaThongTinGiaiQuyet.__proto__ || Object.getPrototypeOf(KetQuaThongTinGiaiQuyet)).call(this, props, context));

    _this.state = {
      data: [],
      id: _this.props.id,
      donId: _this.props.donId,
      listTaiLieuVanThu: [],
      yKienXuLyKetQuaGiaiQuyet: '',
      showAttach: false
    };
    return _this;
  }

  _createClass(KetQuaThongTinGiaiQuyet, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.id,
        donId: nextProps.donId
      });
      this.getDetailReception(nextProps.id);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetailReception(this.props.id);
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(inputId) {
      var _this2 = this;

      _api.Reception.actions.getDonInfo.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this2.setState({
            listTaiLieuVanThu: res.data.listTaiLieuVanThu
          });
        }
      });
    }
  }, {
    key: 'getDetailReception',
    value: function getDetailReception(id) {
      var _this3 = this;

      _api.Reception.actions.getDetailReception.request({ id: id }).then(function (res) {
        if (res.data) {
          _this3.getDonInfo(res.data.donSTCD.donId);
          _this3.setState({
            yKienXuLyKetQuaGiaiQuyet: res.data.yKienXuLyKetQuaGiaiQuyet,
            showAttach: true
          });
        } else {
          _this3.setState({
            yKienXuLyKetQuaGiaiQuyet: '',
            showAttach: true
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextMessage, { className: 'col-100', value: this.state.yKienXuLyKetQuaGiaiQuyet, label: '\xDD ki\u1EBFn x\u1EED l\xFD' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: this.state.listTaiLieuVanThu, disableAttachFile: true, hideDescription: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom gqd-wrap col-100' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line mt10 mb20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaThongTinGiaiQuyet;
}(_react2.default.Component);

KetQuaThongTinGiaiQuyet.defaultProps = {
  dataTaiLieuVanThu: '',
  yKienXuLyKetQuaGiaiQuyet: '',
  validators: {}
};

exports.default = KetQuaThongTinGiaiQuyet;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaTiepCongDan = function (_React$Component) {
  _inherits(KetQuaTiepCongDan, _React$Component);

  function KetQuaTiepCongDan(props, context) {
    _classCallCheck(this, KetQuaTiepCongDan);

    var _this = _possibleConstructorReturn(this, (KetQuaTiepCongDan.__proto__ || Object.getPrototypeOf(KetQuaTiepCongDan)).call(this, props, context));

    _this.state = {
      require: false,
      huongXuLy: 'GIAI_QUYET_NGAY',
      ghiChuXuLy: '',
      // CHO_GIAI_QUYET
      donViChuTriId: '',
      donViPhoiHopId: [],
      thoiHan: '',
      dataDonViPhoiHop: [],
      dsTepDinhKemInput: [],
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      showTableUpload: false,
      donViChuTri: _this.props.donViChuTri
    };
    return _this;
  }

  _createClass(KetQuaTiepCongDan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.dsTepDinhKemInput.length == 0) {
        var item = {
          taiLieuVanThuId: '',
          ten: 'Văn bản thông báo kết luận',
          required: true,
          tenFile: '',
          duongDan: '',
          ngayQuyetDinh: '',
          soQuyetDinh: '',
          loaiTepDinhKem: 'QUYET_DINH'
        };
        this.state.dsTepDinhKemInput.push(item);
        this.state.dsTepDinhKem.push(item);
        this.props.onInit(this.state);
      }
      if (this.props.type == 'dot-xuat-them-moi') {
        this.setState({ showTableUpload: true });
      }
      if (this.props.donViChuTri.length == 0) {
        _api.DuLieuHeThong.actions.getDonViChuTri.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViChuTri',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _this3 = this;

      if (name == 'donViPhoiHopId') {
        this.state.donViPhoiHopId = e;
      } else {
        this.state[name] = e.target.value;
      }
      if (name == 'huongXuLy') {
        this.state.ghiChuXuLy = '';
      }
      if (name == 'donViChuTriId') {
        this.state.dataDonViPhoiHop = [];
        this.state.donViPhoiHopId = [];
        if (e.target.value != '') {
          this.state.donViChuTri.map(function (item) {
            if (item.coQuanQuanLyId != e.target.value) {
              _this3.state.dataDonViPhoiHop.push({ value: item.coQuanQuanLyId, label: item.ten });
            }
          });
        }
      }

      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onChangeItem',
    value: function onChangeItem(data, index) {
      this.state.dsTepDinhKem[index] = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      if (this.state.searching != nextProps.searching) {
        this.setState({
          searching: nextProps.searching
        });

        this.setState({
          doSearch: nextProps.searching
        });
      }

      if (nextProps.soTiepCongDan != this.props.soTiepCongDan) {
        var data = nextProps.soTiepCongDan;
        this.state.huongXuLy = data.huongGiaiQuyetTCDLanhDao == 'KHOI_TAO' ? 'GIAI_QUYET_NGAY' : data.huongGiaiQuyetTCDLanhDao;
        this.state.ghiChuXuLy = data.yKienXuLy;
        if (data.huongGiaiQuyetTCDLanhDao == 'CHO_GIAI_QUYET') {
          this.state.donViChuTriId = data.donViChuTriInfo ? data.donViChuTriInfo.coQuanQuanLyId : '';
          if (data.danhSachDonViPhoiHops) {
            data.danhSachDonViPhoiHops.map(function (item) {
              _this4.state.donViPhoiHopId.push({ value: item.coQuanQuanLyId, label: item.ten });
            });
          }
          this.state.thoiHan = data.ngayBaoCaoKetQua ? (0, _moment2.default)(data.ngayBaoCaoKetQua) : '';
        }

        data.listTaiLieuVanThu.map(function (item, i) {
          _this4.state.dsTepDinhKemInput[i] = _this4.state.dsTepDinhKem[i] = {
            taiLieuVanThuId: item.taiLieuVanThuId,
            ten: item.ten,
            tenFile: item.tenFile,
            required: item.required || false,
            duongDan: item.duongDan,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh) : '',
            soQuyetDinh: item.soQuyetDinh || '',
            loaiTepDinhKem: item.loaiTepDinhKem
          };
        });
        this.state.showTableUpload = true;
        this.state.donViChuTri.map(function (item) {
          if (item.coQuanQuanLyId != _this4.state.donViChuTriId) {
            _this4.state.dataDonViPhoiHop.push({ value: item.coQuanQuanLyId, label: item.ten });
          }
        });

        this.setState(_extends({}, this.state));
        this.props.onInit(this.state);
      }
      if (nextProps.donViChuTri != this.props.donViChuTri) {
        this.state.donViChuTri = nextProps.donViChuTri;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dsTepDinhKemRemove = [].concat(_toConsumableArray(this.state.dsTepDinhKemRemove), [id]);
      this.state.dsTepDinhKem = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.state.dsTepDinhKem = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.setState(_extends({}, newData));
      this.props.onChange(newData);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0-18' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12 mt15' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Th\xF4ng tin x\u1EED l\xFD l\u01B0\u1EE3t ti\u1EBFp c\xF4ng d\xE2n'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_ttForms.DropDownChonHuongXuLyLanhDao, { selected: this.state.huongXuLy, onChange: this.handleChange.bind(this, 'huongXuLy'), name: 'dropdownChonHuongXuLyLanhDao' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.huongXuLy != '' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(_common.TextArea, { label: '\xDD ki\u1EBFn x\u1EED l\xFD', rows: 3, maxLength: 9999, value: this.state.ghiChuXuLy, onChange: this.handleChange.bind(this, 'ghiChuXuLy'), name: 'textareaYKienXuLy' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.huongXuLy == 'CHO_GIAI_QUYET' },
                      _react2.default.createElement(_ttForms.DropDownChonDonViChuTri, { bindValidator: this, selectedValue: this.state.donViChuTriId, except: this.state.donViPhoiHopId, label: '\u0110\u01A1n v\u1ECB ch\u1EE7 tr\xEC', onChange: this.handleChange.bind(this, 'donViChuTriId'), require: true, name: 'dropdownDonViChuTri' }),
                      _react2.default.createElement(_common.DropDownMultipleSelect, { name: 'dropdownDonViPhoiHop', className: 'col-25', label: '\u0110\u01A1n v\u1ECB ph\u1ED1i h\u1EE3p', options: this.state.dataDonViPhoiHop, placeholder: { key: '', text: '--Chọn--' }, value: this.state.donViPhoiHopId, onChange: this.handleChange.bind(this, 'donViPhoiHopId') }),
                      _react2.default.createElement(_common.DatePicker, { label: 'H\u1EA1n x\u1EED l\xFD', require: true, bindValidator: this, channel: 'formTaoDon', startDate: (0, _moment2.default)(new Date()), value: this.state.thoiHan, onChange: this.handleChangeDate.bind(this, 'thoiHan'), name: 'datepickerHanXuLy' })
                    )
                  ),
                  this.state.showTableUpload ? _react2.default.createElement(
                    'div',
                    { className: 'items-form container-filedinhkem' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', reload: true, bindValidator: this, data: this.state.dsTepDinhKemInput, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), name: 'fileDinhKemTCDDinhKy', onSave: this.props.onSave })
                      )
                    )
                  ) : ''
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaTiepCongDan;
}(_react2.default.Component);

KetQuaTiepCongDan.defaultProps = {
  yKienCheck: false,
  isValid: false,
  donViChuTri: [],
  lyDoList: [],
  onSave: false,
  type: ''
};

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    donViChuTri: state.duLieuHeThong.donViChuTri
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(KetQuaTiepCongDan));

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _subView = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiTepDinhKem = 'QUYET_DINH';
var loaiQuyTrinh = 'TIEP_CONG_DAN';

var ThongTinGiaiQuyet = function (_React$Component) {
  _inherits(ThongTinGiaiQuyet, _React$Component);

  function ThongTinGiaiQuyet(props, context) {
    _classCallCheck(this, ThongTinGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (ThongTinGiaiQuyet.__proto__ || Object.getPrototypeOf(ThongTinGiaiQuyet)).call(this, props, context));

    _this.state = {
      data: [],
      id: _this.props.id,
      donId: _this.props.donId,
      listTaiLieuVanThu: [],
      yKienXuLyKetQuaGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      btnLoading: false,
      btnSaveLoading: false,
      showAttach: false,
      donViId: '',
      listTaiLieuVanThuAction: [],
      listTaiLieuVanThuView: [],
      openDialog: false,
      isSave: false
    };
    return _this;
  }

  _createClass(ThongTinGiaiQuyet, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViId: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.setState({
        id: nextProps.id,
        donId: nextProps.donId
      }, function () {
        _this2.getDetailReception(nextProps.id);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetailReception(this.props.id);
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(inputId) {
      var _this3 = this;

      _api.Reception.actions.getDonInfo.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this3.setState({
            listTaiLieuVanThu: res.data.listTaiLieuVanThu
          }, function () {
            _this3.renderAttachFile();
          });
        }
      });
    }
  }, {
    key: 'getDetailReception',
    value: function getDetailReception(id) {
      var _this4 = this;

      _api.Reception.actions.getDetailReception.request({ id: id }).then(function (res) {
        if (res.data) {
          _this4.getDonInfo(res.data.donSTCD.donId);
          _this4.setState({
            data: res.data,
            yKienXuLyKetQuaGiaiQuyet: res.data.yKienXuLyKetQuaGiaiQuyet
          });
        } else {
          _this4.setState({
            data: [],
            yKienXuLyKetQuaGiaiQuyet: ''
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        yKienXuLyKetQuaGiaiQuyet: e.target.value
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      this.setState({ isSave: true }, function () {

        if (_this5.validateSubmitForm()) {
          _this5.setState({
            btnLoading: true,
            btnSaveLoading: true
          });
          _this5.state.dataFileDinhKem.map(function (item, i) {
            if (item.taiLieuVanThuId) {
              _this5.state.taiLieuVanThuUpdate[_this5.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(_this5.state.donId)
                },
                soTiepCongDan: {
                  id: Number(_this5.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              _this5.state.taiLieuVanThu[_this5.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(_this5.state.donId)
                },
                soTiepCongDan: {
                  id: Number(_this5.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (_this5.state.dataTaiLieuVanThuDelete.length > 0) {
            _this5.state.dataTaiLieuVanThuDelete.map(function (item) {
              _this5.state.taiLieuVanThuDelete[_this5.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }

          if (_this5.state.taiLieuVanThu.length > 0) {
            var _params = {
              taiLieuVanThus: _this5.state.taiLieuVanThu
            };
            _this5.postTaiLieuVanThu(_params);
          }

          if (_this5.state.taiLieuVanThuUpdate.length > 0) {
            var _params2 = {
              taiLieuVanThus: _this5.state.taiLieuVanThuUpdate
            };
            _this5.updateTaiLieuVanThu(_params2);
          }

          if (_this5.state.taiLieuVanThuDelete.length > 0) {

            var _params3 = {
              taiLieuVanThus: _this5.state.taiLieuVanThuDelete
            };
            _this5.deleteTaiLieuVanThu(_params3);
          }

          var params = _this5.getParams();

          params.yKienXuLyKetQuaGiaiQuyet = _this5.state.yKienXuLyKetQuaGiaiQuyet;
          _this5.updateTiepCongDan(params, 'gqdLuu');
        }
      });
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var Data = this.state.data;

      var donViPhoiHops = [];
      if (Data.danhSachDonViPhoiHops.length > 0) {
        Data.danhSachDonViPhoiHops.map(function (state) {
          var item = {
            id: state.coQuanQuanLyId
          };
          donViPhoiHops[donViPhoiHops.length] = item;
        });
      }
      var coQuanToChucTiepDans = [];
      if (Data.coQuanToChucTiepDanSTCD.length > 0) {
        Data.coQuanToChucTiepDanSTCD.map(function (state) {
          var item = {
            chucVu: state.chucVu,
            nguoiDaiDien: state.nguoiDaiDien,
            coQuanDonVi: {
              id: state.coQuanDonViInfo.coQuanQuanLyId
            }
          };
          coQuanToChucTiepDans[coQuanToChucTiepDans.length] = item;
        });
      }
      var Params = {
        canBoTiepDan: {
          id: Data.canBoTiepDanInfo.congChucId
        },
        donViTiepDan: {
          id: this.state.donViId
        },
        don: {
          id: this.state.donId
        },
        loaiTiepDan: Data.loaiTiepDan,
        ngayTiepDan: Data.ngayTiepDan,
        noiDungTiepCongDan: Data.noiDungTiepCongDan,
        diaDiemGapLanhDao: Data.diaDiemGapLanhDao,
        ketQuaGiaiQuyet: Data.ketQuaGiaiQuyet,
        huongXuLy: Data.huongXuLy,
        huongGiaiQuyetTCDLanhDao: Data.huongGiaiQuyetTCDLanhDao,
        donViChuTri: {
          id: Data.donViChuTriInfo.coQuanQuanLyId
        },
        soThuTuLuotTiep: Data.soThuTuLuotTiep,
        donViPhoiHops: donViPhoiHops,
        coQuanToChucTiepDans: coQuanToChucTiepDans,
        ngayBaoCaoKetQua: Data.ngayBaoCaoKetQua,
        ngayGuiKetQua: Data.ngayGuiKetQua,
        noiDungBaoCaoKetQuaKiemTra: Data.noiDungBaoCaoKetQuaKiemTra,
        yKienXuLy: Data.yKienXuLy
      };

      return Params;
    }
  }, {
    key: 'handleComplete',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var _params4, _params5, _params6, params;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.validateSubmitForm()) {
                  _context.next = 12;
                  break;
                }

                this.setState({
                  btnLoading: true,
                  openDialog: false
                });
                this.state.dataFileDinhKem.map(function (item, i) {
                  if (item.taiLieuVanThuId) {
                    _this6.state.taiLieuVanThuUpdate[_this6.state.taiLieuVanThuUpdate.length] = {
                      don: {
                        id: Number(_this6.state.donId)
                      },
                      soTiepCongDan: {
                        id: Number(_this6.state.id)
                      },
                      id: item.taiLieuVanThuId,
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: item.loaiTepDinhKem,
                      loaiQuyTrinh: item.loaiQuyTrinh,
                      required: item.required,
                      typeRequired: item.typeRequired ? item.typeRequired : ''
                    };
                  } else {
                    _this6.state.taiLieuVanThu[_this6.state.taiLieuVanThu.length] = {
                      don: {
                        id: Number(_this6.state.donId)
                      },
                      soTiepCongDan: {
                        id: Number(_this6.state.id)
                      },
                      ten: item.ten,
                      soQuyetDinh: item.soQuyetDinh,
                      ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      loaiTepDinhKem: loaiTepDinhKem,
                      loaiQuyTrinh: loaiQuyTrinh,
                      required: item.required,
                      typeRequired: item.typeRequired ? item.typeRequired : ''
                    };
                  }
                });

                if (this.state.dataTaiLieuVanThuDelete.length > 0) {
                  this.state.dataTaiLieuVanThuDelete.map(function (item) {
                    _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
                      id: item
                    };
                  });
                }

                if (this.state.taiLieuVanThu.length > 0) {
                  _params4 = {
                    taiLieuVanThus: this.state.taiLieuVanThu
                  };

                  this.postTaiLieuVanThu(_params4);
                }

                if (this.state.taiLieuVanThuUpdate.length > 0) {
                  _params5 = {
                    taiLieuVanThus: this.state.taiLieuVanThuUpdate
                  };

                  this.updateTaiLieuVanThu(_params5);
                }

                if (this.state.taiLieuVanThuDelete.length > 0) {
                  _params6 = {
                    taiLieuVanThus: this.state.taiLieuVanThuDelete
                  };

                  this.deleteTaiLieuVanThu(_params6);
                }

                params = this.getParams();


                params.yKienXuLyKetQuaGiaiQuyet = this.state.yKienXuLyKetQuaGiaiQuyet;
                params.hoanThanhTCDLanhDao = true;
                _context.next = 12;
                return this.updateTiepCongDan(params, 'gqdLuuHoSo');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleComplete() {
        return _ref.apply(this, arguments);
      }

      return handleComplete;
    }()
  }, {
    key: 'updateTiepCongDan',
    value: function updateTiepCongDan(params, message) {
      var _this7 = this;

      _api.Reception.actions.updateSoTiepCongDan.request({ id: this.state.id }, params).then(function (res) {
        _this7.onClickClose();
        _this7.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        (0, _toastr.Toastr)(message ? _message.msg[message] : _message.msg.luuGiaiQuyetDonThanhCong, 'success');
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      this.setState({
        dataFileDinhKem: data
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      if (this.state.dataFileDinhKem.length > 0) {
        this.props.validators['formTaoDon'].map(function (validator) {
          if (pass) {
            pass = validator.validate();
          } else {
            validator.validate();
          }
        });
      }
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'renderAttachFile',
    value: function renderAttachFile() {
      var _this8 = this;

      var DataTaiLieuVanThu = [].concat(_toConsumableArray(this.state.listTaiLieuVanThu));
      var DataTaiLieuVanThuView = [].concat(_toConsumableArray(this.state.listTaiLieuVanThu));

      var listTaiLieuVanThu = DataTaiLieuVanThu.filter(function (state) {
        return _this8.compareDate(new Date(state.ngayTao), new Date(_this8.state.data.thongTinYeuCauKiemTraDeXuatInfo.ngayGuiKQ), 'action');
      });

      var listTaiLieuVanThuView = DataTaiLieuVanThuView.filter(function (state) {
        return _this8.compareDate(new Date(_this8.state.data.thongTinYeuCauKiemTraDeXuatInfo.ngayGuiKQ), new Date(state.ngayTao), 'show');
      });
      this.setState({
        listTaiLieuVanThuAction: listTaiLieuVanThu,
        listTaiLieuVanThuView: listTaiLieuVanThuView,
        showAttach: true
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      var _this9 = this;

      this.setState({ isSave: false }, function () {
        if (_this9.validateSubmitForm()) {
          _this9.setState({
            openDialog: true
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin gi\u1EA3i quy\u1EBFt'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, { className: 'col-100', value: this.state.yKienXuLyKetQuaGiaiQuyet, label: '\xDD ki\u1EBFn x\u1EED l\xFD', onChange: this.handleChange.bind(this) }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showAttach },
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb5' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuAction, dataShow: this.state.listTaiLieuVanThuView, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), onSave: this.state.isSave })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom gqd-wrap col-100' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-big-line mt10 mb20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u h\u1ED3 s\u01A1'
              )
            )
          )
        ),
        _react2.default.createElement(_subView.ConfirmDialog, { open: this.state.openDialog, onClose: this.closeDialog.bind(this), onSuccess: this.handleComplete.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' })
      );
    }
  }]);

  return ThongTinGiaiQuyet;
}(_react2.default.Component);

ThongTinGiaiQuyet.defaultProps = {
  dataTaiLieuVanThu: '',
  yKienXuLyKetQuaGiaiQuyet: '',
  validators: {}
};

exports.default = (0, _reactRedux.connect)()(ThongTinGiaiQuyet);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinLuatSu = function (_React$Component) {
  _inherits(ThongTinLuatSu, _React$Component);

  function ThongTinLuatSu(props, context) {
    _classCallCheck(this, ThongTinLuatSu);

    var _this = _possibleConstructorReturn(this, (ThongTinLuatSu.__proto__ || Object.getPrototypeOf(ThongTinLuatSu)).call(this, props, context));

    _this.state = {
      soTheLuatSu: '',
      ngayCapTheLuatSu: '',
      noiCapTheLuatSu: '',
      thongTinGioiThieu: '',
      dsGiayUyQuyen: [],
      dsGiayUyQuyenRemove: [],
      dsGiayUyQuyenLuatSu: [],
      received: false
    };
    return _this;
  }

  _createClass(ThongTinLuatSu, [{
    key: 'handleChange',
    value: function handleChange(name, e) {
      var state = this.state;
      state[name] = e.target.value;
      this.setState({ state: state });
      this.props.onChange(state);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.setState(_extends({}, newData));

      this.props.onChange(newData);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.state.dsGiayUyQuyenRemove = [].concat(_toConsumableArray(this.state.dsGiayUyQuyenRemove), [id]);
      this.state.dsGiayUyQuyen = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      var state = this.state;
      state.dsGiayUyQuyen = data;
      this.props.onChange(this.state);
      this.setState(state);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var state = this.state;
      if (this.props.data.donId || this.props.data.donCuId && this.props.data.nguoiDuocUyQuyen) {
        state.soTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.soTheLuatSu ? this.props.data.nguoiDuocUyQuyen.soTheLuatSu : '';
        state.ngayCapTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.ngayCapTheLuatSu ? (0, _moment2.default)(this.props.data.nguoiDuocUyQuyen.ngayCapTheLuatSu) : '';
        state.noiCapTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.noiCapTheLuatSu ? this.props.data.nguoiDuocUyQuyen.noiCapTheLuatSu : '';
        state.thongTinGioiThieu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.thongTinGioiThieu ? this.props.data.nguoiDuocUyQuyen.thongTinGioiThieu : '';
        if (state.received !== true) {
          //loi o day, don cu chua co list tai lieu luat su
          this.props.data.listTaiLieuBangChungLuatSu.map(function (item, i) {
            state.dsGiayUyQuyenLuatSu[i] = {
              ten: item.ten,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              required: item.required || false,
              tinhTrang: item.tinhTrangTaiLieu || '',
              taiLieuBangChungId: item.taiLieuBangChungId
            };
          });
          state.received = true;
        }
      }

      if (state.dsGiayUyQuyenLuatSu.length === 0) {
        state.dsGiayUyQuyenLuatSu[0] = {
          ten: 'Giấy ủy quyền',
          required: true,
          tenFile: '',
          duongDan: '',
          tinhTrang: '',
          taiLieuBangChungId: ''
        };
      }

      this.setState(state);
      this.props.onChange(state, true);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'items-form' },
        _react2.default.createElement(
          'div',
          { className: 'rows' },
          _react2.default.createElement(_common.Input, { label: 'S\u1ED1 th\u1EBB', value: this.state.soTheLuatSu, onChange: this.handleChange.bind(this, 'soTheLuatSu') }),
          _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\u1EA5p', value: this.state.ngayCapTheLuatSu, endDate: new Date(), onChange: this.handleChangeDate.bind(this, 'ngayCapTheLuatSu') }),
          _react2.default.createElement(_common.Input, { label: 'N\u01A1i c\u1EA5p', value: this.state.noiCapTheLuatSu, onChange: this.handleChange.bind(this, 'noiCapTheLuatSu') }),
          _react2.default.createElement(_common.Input, { className: 'col-40', value: this.state.thongTinGioiThieu, label: 'Th\xF4ng tin gi\u1EDBi thi\u1EC7u', onChange: this.handleChange.bind(this, 'thongTinGioiThieu') })
        ),
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows pl5 pr5' },
            _react2.default.createElement(
              'h3',
              null,
              'Danh s\xE1ch t\xE0i li\u1EC7u k\xE8m theo'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form container-filedinhkem' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', type: 'TAI_LIEU_BO_SUNG', header: _table.header.addReception.danhSachBangChung, data: this.state.dsGiayUyQuyenLuatSu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), bindValidator: this, onSave: this.props.onSave })
            )
          )
        )
      );
    }
  }]);

  return ThongTinLuatSu;
}(_react2.default.Component);

ThongTinLuatSu.defaultProps = {
  onSave: false
};

exports.default = (0, _utils.validatable)(ThongTinLuatSu);

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinTiepCongDan = function (_React$Component) {
  _inherits(ThongTinTiepCongDan, _React$Component);

  function ThongTinTiepCongDan(props, context) {
    _classCallCheck(this, ThongTinTiepCongDan);

    var _this = _possibleConstructorReturn(this, (ThongTinTiepCongDan.__proto__ || Object.getPrototypeOf(ThongTinTiepCongDan)).call(this, props, context));

    _this.state = {
      lbl_textArea: 'Ý kiến xử lý',
      require: false,
      enableDropDown: true,
      enableHuongXuLy: false,
      huongXuLy: '',
      ghiChuXuLy: '',
      popupConfirmSaveLoaiDon: props.popupConfirmSaveLoaiDon,
      hasFileChange: false,
      // BO_SUNG_THONG_TIN
      dsTaiLieuBoSung: [],
      dsTaiLieuBoSungRemove: [],
      dataHuongXuLy: [],
      dsTepDinhKem: [],
      dsTepDinhKemInputTuChoi: [{
        taiLieuVanThuId: '',
        ten: 'Thông báo từ chối tiếp công dân',
        required: false,
        tenFile: '',
        duongDan: '',
        ngayQuyetDinh: '',
        soQuyetDinh: '',
        loaiTepDinhKem: 'QUYET_DINH',
        typeRequired: 'TU_CHOI'
      }],
      dsTepDinhKemInputTraDon: [{
        taiLieuVanThuId: '',
        ten: _this.props.loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo',
        required: true,
        tenFile: '',
        duongDan: '',
        ngayQuyetDinh: '',
        soQuyetDinh: '',
        loaiTepDinhKem: 'QUYET_DINH',
        typeRequired: 'TRA_DON_VA_HUONG_DAN'
      }],
      dsTepDinhKemRemove: [],
      fileTuChoi: [],
      fileHuongDan: [],
      loaiDonValue: '',
      tarGetValue: '',
      tarGetText: ''
    };
    return _this;
  }

  _createClass(ThongTinTiepCongDan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        enableHuongXuLy: false,
        enableDropDown: true
      });
    }
  }, {
    key: 'createTaiLieuDinhKem',
    value: function createTaiLieuDinhKem(loaiDon) {
      if (this.state.huongXuLy === 'TU_CHOI') {
        if (this.state.dsTepDinhKemInputTuChoi.length > 0) {
          var getItem = [];
          if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
            getItem = this.props.soTiepCongDan.listTaiLieuVanThu.filter(function (item) {
              return item.typeRequired === 'TU_CHOI';
            });
            this.setState({ dsTepDinhKemInputTuChoi: getItem });
          } else {
            this.props.dispatch({
              type: 'CHANGE_STATE_LOAIDON',
              data: false
            });
            this.props.dispatch({
              type: 'CHANGE_STATE_HUONGXULY',
              data: false
            });
            this.setState({
              dsTepDinhKemInputTuChoi: [{
                taiLieuVanThuId: '',
                ten: 'Thông báo từ chối tiếp công dân',
                required: false,
                tenFile: '',
                duongDan: '',
                ngayQuyetDinh: '',
                soQuyetDinh: '',
                loaiTepDinhKem: 'QUYET_DINH',
                typeRequired: 'TU_CHOI'
              }]
            });
          }
        } else {
          this.setState({
            dsTepDinhKemInputTuChoi: [{
              taiLieuVanThuId: '',
              ten: 'Thông báo từ chối tiếp công dân',
              required: false,
              tenFile: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiTepDinhKem: 'QUYET_DINH',
              typeRequired: 'TU_CHOI'
            }]
          });
        }
      } else if (this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' && (loaiDon === 'DON_KHIEU_NAI' || loaiDon === 'DON_TO_CAO')) {
        if (this.state.dsTepDinhKemInputTraDon.length > 0) {
          this.state.dsTepDinhKemInputTraDon[0].ten = loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo';
        }
        if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
          var _getItem = [];
          _getItem = this.props.soTiepCongDan.listTaiLieuVanThu.filter(function (item) {
            return item.typeRequired === 'TRA_DON_VA_HUONG_DAN';
          });
          this.setState({ dsTepDinhKemInputTraDon: _getItem });
        } else {
          this.props.dispatch({
            type: 'CHANGE_STATE_LOAIDON',
            data: false
          });
          this.props.dispatch({
            type: 'CHANGE_STATE_HUONGXULY',
            data: false
          });
          this.setState({
            dsTepDinhKemInputTraDon: [{
              taiLieuVanThuId: '',
              ten: loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo',
              required: true,
              tenFile: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiTepDinhKem: 'QUYET_DINH',
              typeRequired: 'TRA_DON_VA_HUONG_DAN'
            }]
          });
        }
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      if (name === 'huongXuLy') {
        this.state[name] = e.target.value;
        this.state.ghiChuXuLy = '';
        this.createTaiLieuDinhKem(this.props.loaiDon);
        this.setHuongXuLy(this.state.huongXuLy);
        this.props.onChange(this.state);
      } else {
        this.state[name] = e.target.value;
        this.setState(_extends({}, this.state));
        this.props.onChange(this.state);
      }
    }
  }, {
    key: 'setHuongXuLy',
    value: function setHuongXuLy(name) {
      switch (name) {
        case 'TRA_DON_VA_HUONG_DAN':
          this.state.lbl_textArea = 'Nội dung hướng dẫn';
          this.state.require = false;
          break;
        case 'TU_CHOI':
          this.state.lbl_textArea = 'Lý do từ chối tiếp công dân';
          this.state.require = true;
          break;
        case 'BO_SUNG_THONG_TIN':
          this.state.lbl_textArea = 'Nội dung bổ sung';
          this.state.require = true;
          break;
        case 'TIEP_NHAN_DON':
        case 'YEU_CAU_GAP_LANH_DAO':
          this.state.lbl_textArea = 'Ý kiến xử lý';
          this.state.require = false;
          break;
        default:
          this.state.lbl_textArea = 'Ghi chú';
          this.state.require = false;
          break;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nextProps) {
        var _this2 = this;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.searching != nextProps.searching) {
                  this.setState({
                    searching: nextProps.searching
                  });

                  this.setState({
                    doSearch: nextProps.searching
                  });
                }

                if (!(this.props.loaiDon != nextProps.loaiDon)) {
                  _context.next = 13;
                  break;
                }

                if (!(this.props.popupConfirmSaveLoaiDon === true || this.props.popupConfirmSaveHuongXuLy === true)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 5;
                return this.props.dispatch({
                  type: 'CHANGE_STATE_LOAIDON',
                  data: false
                });

              case 5:
                _context.next = 7;
                return this.props.dispatch({
                  type: 'CHANGE_STATE_HUONGXULY',
                  data: false
                });

              case 7:
                _context.next = 9;
                return this.props.dispatch({
                  type: 'REMOVE_LOAIDON_EDIT_FORM',
                  data: []
                });

              case 9:
                _context.next = 11;
                return this.props.soTiepCongDan.listTaiLieuVanThu.forEach(function (item) {
                  _api.Reception.actions.deleteTepDinhKem.request({
                    id: item.taiLieuVanThuId
                  });
                });

              case 11:
                _context.next = 13;
                return this.createTaiLieuDinhKem(nextProps.loaiDon);

              case 13:
                if (this.props.thongTinTiepCongDan != nextProps.thongTinTiepCongDan) {
                  this.createTaiLieuDinhKem(nextProps.thongTinTiepCongDan);
                }

                if (!(nextProps.soTiepCongDan != this.props.soTiepCongDan)) {
                  _context.next = 32;
                  break;
                }

                data = nextProps.soTiepCongDan;

                if (!this.state.tarGetValue) {
                  _context.next = 21;
                  break;
                }

                _context.next = 19;
                return this.setState({ huongXuLy: this.state.tarGetValue });

              case 19:
                _context.next = 23;
                break;

              case 21:
                _context.next = 23;
                return this.setState({ huongXuLy: data.huongXuLy || '' });

              case 23:
                _context.next = 25;
                return this.setState({ ghiChuXuLy: data.noiDungTiepCongDan });

              case 25:
                if (data.taiLieuBangChungBoSungs && data.taiLieuBangChungBoSungs.length > 0) {
                  data.taiLieuBangChungBoSungs.forEach(function (item, i) {
                    _this2.state.dsTaiLieuBoSung[i] = {
                      ten: item.ten,
                      tenFile: item.tenFile,
                      duongDan: item.duongDan,
                      tinhTrang: item.tinhTrangTaiLieu || '',
                      taiLieuBangChungId: item.taiLieuBangChungId
                    };
                  });
                }
                if (data.soThuTuLuotTiep == 1 && data.donSTCD.thanhLapDon) {
                  this.state.enableDropDown = false;
                  this.state.enableHuongXuLy = false;
                }

                if (data.soThuTuLuotTiep > 1 && data.donSTCD.thanhLapDon || this.props.type && this.props.type == 'them-luot') {
                  this.state.dataHuongXuLy = [{
                    giaTri: 'BO_SUNG_THONG_TIN',
                    ten: 'Bổ sung thông tin'
                  }];
                  this.state.ghiChuXuLy = '';
                  this.state.huongXuLy = 'BO_SUNG_THONG_TIN';
                  this.state.enableHuongXuLy = true;
                  this.state.enableDropDown = false;
                }
                if (!data || data.soThuTuLuotTiep == 1 && !data.donSTCD.thanhLapDon || data.soThuTuLuotTiep > 1 && !data.donSTCD.thanhLapDon) {
                  this.state.enableDropDown = true;
                  this.state.enableHuongXuLy = false;
                }
                this.setHuongXuLy(this.state.huongXuLy);

                this.setState(_extends({}, this.state));
                this.props.onInit(this.state);

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillReceiveProps(_x) {
        return _ref.apply(this, arguments);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.setState(_extends({}, newData));

      this.props.onChange(newData);
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      if (this.state.huongXuLy == 'BO_SUNG_THONG_TIN') {
        this.state.dsTaiLieuBoSungRemove = [].concat(_toConsumableArray(this.state.dsTaiLieuBoSungRemove), [id]);
        this.state.dsTaiLieuBoSung = data;
      } else {
        this.state.dsTepDinhKemRemove = [].concat(_toConsumableArray(this.state.dsTepDinhKemRemove), [id]);
        this.state.dsTepDinhKem = data;
      }
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      if (this.state.huongXuLy == 'BO_SUNG_THONG_TIN') {
        this.state.dsTaiLieuBoSung = data;
      } else {
        this.state.dsTepDinhKem = data;
      }
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'confirmSaveLoaiDons',
    value: function confirmSaveLoaiDons(next) {
      if (next) {
        if (this.state.loaiDonValue === 'huongXuLy') {
          var oldState = this.state.loaiDonValue;
          this.state[oldState] = this.state.tarGetValue;
          this.state.ghiChuXuLy = '';
          this.setHuongXuLy(this.state.huongXuLy);
          this.props.dispatch({
            type: 'REMOVE_LOAIDON_EDIT_FORM',
            data: []
          });
          this.props.dispatch({
            type: 'CHANGE_STATE_HUONGXULY',
            data: false
          });
          this.props.soTiepCongDan.listTaiLieuVanThu.forEach(function (item) {
            _api.Reception.actions.deleteTepDinhKem.request({
              id: item.taiLieuVanThuId
            });
          });
        }
      } else {
        this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: false
        });
      }
    }
  }, {
    key: 'onOpen',
    value: function onOpen(name, e) {
      if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
        this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: true
        });
      } else {
        this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: false
        });
      }
      this.setState({
        loaiDonValue: name,
        tarGetValue: e.target.value,
        tarGetText: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0-18' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12 mt15' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Th\xF4ng tin x\u1EED l\xFD l\u01B0\u1EE3t ti\u1EBFp c\xF4ng d\xE2n'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0 },
                  _react2.default.createElement(_dialog.ConfirmDialog, { title: _message.msg.confirmChangeSaveHXL, open: this.props.popupConfirmSaveHuongXuLy, onClose: this.confirmSaveLoaiDons.bind(this, false), onSuccess: this.confirmSaveLoaiDons.bind(this, true) }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.enableDropDown },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_ttForms.DropDownChonHuongXuLy, { type: this.props.type, selected: this.state.huongXuLy, bindValidator: this, onChange: this.onOpen.bind(this, 'huongXuLy'), require: true, placeholder: true })
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.popupConfirmSaveHuongXuLy === false && this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length === 0 },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.enableDropDown },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_ttForms.DropDownChonHuongXuLy, { type: this.props.type, selected: this.state.huongXuLy, bindValidator: this, onChange: this.handleChange.bind(this, 'huongXuLy'), require: true, placeholder: true })
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.enableHuongXuLy },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(_common.DropDown, { label: 'H\u01B0\u1EDBng x\u1EED l\xFD', options: this.state.dataHuongXuLy,
                      keyName: 'giaTri', valueName: 'ten',
                      onChange: this.handleChange.bind(this, 'huongXuLy'),
                      placeholder: null,
                      require: true,
                      bindValidator: this,
                      channel: 'formTaoDon',
                      selectedValue: this.state.huongXuLy,
                      name: 'dropdownChonXuLy' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.TextArea, { label: this.state.lbl_textArea, className: 'col-12', bindValidator: this, channel: 'formTaoDon', rows: 3, onChange: this.handleChange.bind(this, 'ghiChuXuLy'), maxLength: 1000, value: this.state.ghiChuXuLy, require: this.state.require, name: 'textareaYKien' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.huongXuLy == 'BO_SUNG_THONG_TIN' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows pl5 pr5' },
                        _react2.default.createElement(
                          'h3',
                          { className: 'mb0-18' },
                          'T\xE0i li\u1EC7u b\u1ED5 sung'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form container-filedinhkem' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', label: 'T\xE0i li\u1EC7u b\u1ED5 sung', type: 'TAI_LIEU_BO_SUNG', header: _table.header.addReception.danhSachBangChung, data: this.state.dsTaiLieuBoSung, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), onSave: this.props.onSave })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.huongXuLy === 'TU_CHOI' },
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form container-filedinhkem' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.dsTepDinhKemInputTuChoi, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), name: 'fileDinhKemTuChoi', onSave: this.props.onSave })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' && (this.props.loaiDon === 'DON_KHIEU_NAI' || this.props.loaiDon === 'DON_TO_CAO') },
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form container-filedinhkem' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12' },
                          _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.dsTepDinhKemInputTraDon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), name: 'fileDinhKemTraDon', onSave: this.props.onSave })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinTiepCongDan;
}(_react2.default.Component);

ThongTinTiepCongDan.defaultProps = {
  soTiepCongDan: {},
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  type: '',
  onSave: false,
  loaiDon: ''
};

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    popupConfirmSaveLoaiDon: state.formDataTiepCongDan.popupConfirmSaveLoaiDon,
    popupConfirmSaveHuongXuLy: state.formDataTiepCongDan.popupConfirmSaveHuongXuLy
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinTiepCongDan));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _common = __webpack_require__(3);

var _ThongTinCaNhan = __webpack_require__(488);

var _ThongTinCaNhan2 = _interopRequireDefault(_ThongTinCaNhan);

var _ThongTinLuatSu = __webpack_require__(1289);

var _ThongTinLuatSu2 = _interopRequireDefault(_ThongTinLuatSu);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinUyQuyen = function (_React$Component) {
  _inherits(ThongTinUyQuyen, _React$Component);

  function ThongTinUyQuyen(props, context) {
    _classCallCheck(this, ThongTinUyQuyen);

    var _this = _possibleConstructorReturn(this, (ThongTinUyQuyen.__proto__ || Object.getPrototypeOf(ThongTinUyQuyen)).call(this, props, context));

    _this.state = {
      flagLuatSu: false
    };
    return _this;
  }

  _createClass(ThongTinUyQuyen, [{
    key: 'onChangeCheckBox',
    value: function onChangeCheckBox(name, e) {
      this.state[name] = !this.state[name];
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onChangeLuatSu',
    value: function onChangeLuatSu(data, isInit) {
      var newState = _extends({}, this.state, {
        luatSu: data
      });
      this.setState(_extends({}, newState));
      this.props.onChange(newState, isInit);
    }
  }, {
    key: 'getThongTinCaNhan',
    value: function getThongTinCaNhan(thongTinCaNhan) {
      this.props.dispatch({
        type: 'CAP_NHAT_THONG_TIN_CA_NHAN',
        data: thongTinCaNhan,
        index: -1
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(data) {
      this.props.onRemove('CONG_DAN', data);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var state = this.state;
      if (this.props.data.donId || this.props.data.donCuId && this.props.data.nguoiDuocUyQuyen) {
        if (this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.luatSu) {
          state.flagLuatSu = this.props.data.nguoiDuocUyQuyen.luatSu;
        }
        this.setState(state);
        this.props.onChange(this.state, true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n'
              )
            )
          )
        ),
        _react2.default.createElement(_ThongTinCaNhan2.default, {
          index: -1,
          data: this.props.nguoiUyQuyen,
          onChange: this.getThongTinCaNhan.bind(this),
          isRemoveable: false,
          handleRemove: this.handleRemove.bind(this),
          bindValidator: this,
          uyQuyen: true
        }),
        _react2.default.createElement(_common.CheckBox, {
          ten: 'Lu\u1EADt s\u01B0',
          isChecked: this.state.flagLuatSu,
          onChange: this.onChangeCheckBox.bind(this, 'flagLuatSu'),
          componentFill: _react2.default.createElement(_ThongTinLuatSu2.default, { isDonCu: this.props.isDonCu, onChange: this.onChangeLuatSu.bind(this), bindValidator: this, data: this.props.data, onSave: this.props.onSave }) })
      );
    }
  }]);

  return ThongTinUyQuyen;
}(_react2.default.Component);

ThongTinUyQuyen.defaultProps = {
  onSave: false
};

function bindStateToProps(state) {
  return {
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinUyQuyen));

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinYeuCauKiemTraDeXuat = function (_React$Component) {
  _inherits(ThongTinYeuCauKiemTraDeXuat, _React$Component);

  function ThongTinYeuCauKiemTraDeXuat(props, context) {
    _classCallCheck(this, ThongTinYeuCauKiemTraDeXuat);

    var _this = _possibleConstructorReturn(this, (ThongTinYeuCauKiemTraDeXuat.__proto__ || Object.getPrototypeOf(ThongTinYeuCauKiemTraDeXuat)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(ThongTinYeuCauKiemTraDeXuat, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ data: nextProps.data });
    }
  }, {
    key: 'getDonViPhoiHop',
    value: function getDonViPhoiHop() {
      var dataReturn = [];
      this.state.data.donViPhoiHops.map(function (state, i) {
        dataReturn.push(state.ten);
      });
      return dataReturn.join(', ');
    }
  }, {
    key: 'render',
    value: function render() {
      var Data = this.state.data;
      var lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block mt15' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line pt5 pb20' },
          _react2.default.createElement('span', { className: 'big-border' })
        ),
        _react2.default.createElement(
          'h2',
          { className: 'title-14 mb15' },
          'Th\xF4ng tin y\xEAu c\u1EA7u ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', value: Data && Data.donViDuocGiaoTTXM ? Data.donViDuocGiaoTTXM.ten : '', label: 'Đơn vị được giao ' + lb1 + ':' }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', red: true, value: Data && Data.ngayBaoCaoKQ ? (0, _moment2.default)(Data.ngayBaoCaoKQ).format("DD/MM/YYYY") : '', label: 'Th\u1EDDi gian b\xE1o c\xE1o k\u1EBFt qu\u1EA3:' }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', value: Data && Data.ngayGuiKQ ? (0, _moment2.default)(Data.ngayGuiKQ).format("DD/MM/YYYY") : '', label: 'Th\u1EDDi gian \u0111\u01A1n v\u1ECB g\u1EEDi k\u1EBFt qu\u1EA3:' }),
          _react2.default.createElement(_common.TextMessage, { className: 'col-100', value: Data && Data.yKienXuLy ? Data.yKienXuLy : '', label: '\xDD ki\u1EBFn x\u1EED l\xFD:' })
        )
      );
    }
  }]);

  return ThongTinYeuCauKiemTraDeXuat;
}(_react2.default.Component);

ThongTinYeuCauKiemTraDeXuat.defaultProps = {
  data: []
};

exports.default = ThongTinYeuCauKiemTraDeXuat;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _letterHistory = __webpack_require__(236);

var _letterHistory2 = _interopRequireDefault(_letterHistory);

var _utils = __webpack_require__(4);

var _subView = __webpack_require__(33);

var _api = __webpack_require__(5);

var _GetTrangThaiDonTheoDonVi = __webpack_require__(314);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _xuLyDon = __webpack_require__(312);

var _formGiaiQuyet = __webpack_require__(310);

var _formKiemTraDeXuat = __webpack_require__(311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinhTrangDon = function (_React$Component) {
  _inherits(TinhTrangDon, _React$Component);

  function TinhTrangDon(props, context) {
    _classCallCheck(this, TinhTrangDon);

    var _this = _possibleConstructorReturn(this, (TinhTrangDon.__proto__ || Object.getPrototypeOf(TinhTrangDon)).call(this, props, context));

    _this.state = {
      donId: '',
      trangThaiDonDonVi: {},
      alias: '',
      thongTinXuLyGiaiQuyet: {},
      title: '',
      processType: '',
      thongTinGiaiQuyetDonPlus: {},
      dataKetQuaXuLyDon: {},
      donDangXuLy: false
    };
    return _this;
  }

  _createClass(TinhTrangDon, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.data != this.props.data) {
        this.state.dataKetQuaXuLyDon.thamQuyenGiaiQuyet = nextProps.data.thamQuyenGiaiQuyetInfo ? nextProps.data.thamQuyenGiaiQuyetInfo.ten : '';
        this.state.trangThaiDonDonVi = (0, _GetTrangThaiDonTheoDonVi.GetTrangThaiDonTheoDonVi)(nextProps.data.trangThaiDonInfo);
        this.state.donId = nextProps.data.donId;
        this.setState(_extends({}, this.state));

        this.getThongTinXuLyHoacGiaiQuyet(nextProps.data.donId);
        if (nextProps.data.thongTinGiaiQuyetDonId) {
          // Lay thong tin giai quyet don Id neu co
          _api.GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: nextProps.data.thongTinGiaiQuyetDonId }).then(function (dataGiaiQuyetDon) {
            if (dataGiaiQuyetDon.data) _this2.setState({
              thongTinGiaiQuyetDonPlus: dataGiaiQuyetDon.data
            });
          });
        }
      }
    }
  }, {
    key: 'getThongTinXuLyHoacGiaiQuyet',
    value: function getThongTinXuLyHoacGiaiQuyet(donId) {
      var _this3 = this;

      _api.LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(function (res) {
        if (res.data) {
          _this3.state.thongTinXuLyGiaiQuyet = res.data.thongTinXuLyInfo;
          _this3.state.alias = res.data.nextFormInfo.alias;
          if (_this3.state.alias) {
            _this3.state.title = 'Thông tin đã xử lý';
          }
          _this3.setState(_extends({}, _this3.state));
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data.errors[0].code == 'DATA_NOT_FOUND') {
            _this3.getThongTinGiaiQuyetDon(donId);
          }
        }
      });
    }
  }, {
    key: 'getThongTinGiaiQuyetDon',
    value: function getThongTinGiaiQuyetDon(donId) {
      var _this4 = this;

      _api.GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request({ id: donId }).then(function (res) {
        if (res.data) {

          var info = res.data;
          var title = '';
          var alias = '';
          var processType = '';

          // Set title cho form giai quyet hoac kiem tra de xuat
          if (_this4.state.donDangXuLy) {

            if (_this4.state.processTypeValue == 'THAM_TRA_XAC_MINH' || _this4.state.processTypeValue == 'GIAI_QUYET_DON') {
              if (_this4.state.alias == 'CanBoTTXMAction') title = 'Báo cáo thẩm tra xác minh';else title = 'Thông tin giải quyết';
            } else if (_this4.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
              if (_this4.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {
                title = 'Báo cáo kết quả kiểm tra';
              } else {
                title = 'Thông tin đề xuất';
              }
            }
            alias = _this4.state.alias;
            processType = _this4.state.processTypeValue;
          } else {

            if (info.processType.type == 'KIEM_TRA_DE_XUAT') {

              title = 'Thông tin đã đề xuất';

              if (info.nextFormInfo.alias == 'canBoKiemTraDeXuat' || info.nextFormInfo.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {

                title = 'Báo cáo kết quả kiểm tra';
              }
            } else {

              if (info.nextFormInfo.alias == 'CanBoGiaiQuyetDonAction' || info.nextFormInfo.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' || info.nextFormInfo.alias == 'CanBoTTXMAction') {
                var lb2 = _this4.props.data.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
                title = 'Báo cáo kết quả xác minh' + lb2;
              } else {

                title = 'Thông tin đã giải quyết';
              }
            }

            processType = info.processType.type;
            alias = info.nextFormInfo.alias;
          }

          _this4.setState({
            alias: alias,
            title: title,
            processTypeValue: processType,
            thongTinXuLyGiaiQuyet: info
          });

          _this4.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
          _this4.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
          _this4.setState(_extends({}, _this4.state));
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data.errors[0].detail);
        }
      });
    }
  }, {
    key: 'viewInfomationWork',
    value: function viewInfomationWork() {
      if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH') {
        switch (this.state.alias) {
          case 'CanBoNhapLieuTTXMAction':
          case 'LanhDaoTTXMAction':
            return _react2.default.createElement(
              'div',
              { className: 'page-wrapper' },
              _react2.default.createElement(_formGiaiQuyet.NhiemVuTTXM, {
                thongTinGiaiQuyetDonPlus: this.state.thongTinGiaiQuyetDonPlus,
                thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
                listTaiLieuVanThuGiaiQuyetDon: this.props.data.listTaiLieuVanThuGiaiQuyetDon,
                donInfo: this.props.data
              })
            );
        }
      } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
        if (this.state.alias == 'canBoKiemTraDeXuat') {
          return _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_formKiemTraDeXuat.ThongTinYeuCauKTDX, {
              thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
              listTaiLieuVanThuKiemTraDeXuat: this.props.data.listTaiLieuVanThuKiemTraDeXuat,
              showTable: this.state.alias == 'vanThuKiemTraDeXuat' || this.state.alias == 'lanhDaoKiemTraDeXuat' || this.state.donDangXuLy && this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh' })
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_formKiemTraDeXuat.ThongTinYeuCauKTDX, {
              thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
              listTaiLieuVanThuKiemTraDeXuat: this.props.data.listTaiLieuVanThuKiemTraDeXuat,
              showTable: false })
          );
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.data.donId ? _react2.default.createElement(_letterHistory2.default, { donId: this.props.data.donId, onChange: function onChange() {}, ma: this.props.data.ma }) : '',
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.alias == 'CanBoGiaiQuyetDonAction' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' },
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_subView.KetQuaXuLyDon, _extends({ status: false
            }, this.state.dataKetQuaXuLyDon, {
              donInfo: this.props.data,
              dataGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
              hideBorder: true
            }))
          )
        ),
        this.viewInfomationWork(),
        this.state.donDangXuLy && (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.state.canBoDangXuLy) || !this.state.donDangXuLy && (this.state.alias || this.state.trangThaiDonDonVi.ketQuaType == 'DINH_CHI') ? _react2.default.createElement(
          'div',
          { className: 'page-wrapper' },
          _react2.default.createElement(_xuLyDon.FormXuLyHoacGiaiQuyet, {
            ma: this.props.data.ma,
            lyDoDinhChi: this.props.data.lyDoDinhChi,
            loaiDonGiaTri: this.props.data.loaiDon,
            thongTinXuLyGiaiQuyet: this.state.thongTinXuLyGiaiQuyet,
            thongTinYeuCauKiemTraDeXuat: this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo,
            title: this.state.title,
            alias: this.state.alias,
            donId: this.props.data.donId,
            listNextStates: [],
            donDangXuLy: this.state.donDangXuLy,
            tongSoLuotTCD: this.props.data.tongSoLuotTCD,
            thongTinGiaiQuyetDonId: this.props.data.thongTinGiaiQuyetDonId,
            processType: this.state.processTypeValue,
            listTaiLieuVanThu: this.props.data.listTaiLieuVanThu,
            listTaiLieuVanThuKiemTraDeXuat: this.props.data.listTaiLieuVanThuKiemTraDeXuat,
            listTaiLieuVanThuGiaiQuyetDon: this.props.data.listTaiLieuVanThuGiaiQuyetDon,
            listTaiLieuVanThuGiaiQuyetDonView: this.props.data.listTaiLieuVanThuGiaiQuyetDonView,
            listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: this.props.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM,
            listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: this.props.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView,
            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: this.props.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM,
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: this.props.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: this.props.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra,
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: this.props.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ,
            listTaiLieuVanThuBoSungHoSo: this.props.data.listTaiLieuVanThuBoSungHoSo,
            thongTinGiaiQuyetDonPlus: this.state.thongTinGiaiQuyetDonPlus,
            trangThaiDonDonVi: this.state.trangThaiDonDonVi,
            bindValidator: this,
            donInfo: this.props.data,
            data: this.props.data,
            pageType: 'CHI_TIET_DON' })
        ) : ''
      );
    }
  }]);

  return TinhTrangDon;
}(_react2.default.Component);

TinhTrangDon.defaultProps = {
  data: {}
};

exports.default = TinhTrangDon;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reception = __webpack_require__(129);

var _reactRouter = __webpack_require__(2);

var _message = __webpack_require__(10);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _ThongTinNguoiDungDon = __webpack_require__(490);

var _ThongTinNguoiDungDon2 = _interopRequireDefault(_ThongTinNguoiDungDon);

var _ThongTinDon = __webpack_require__(489);

var _ThongTinDon2 = _interopRequireDefault(_ThongTinDon);

var _ThongTinCoQuanTiepDan = __webpack_require__(1298);

var _ThongTinCoQuanTiepDan2 = _interopRequireDefault(_ThongTinCoQuanTiepDan);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingData = __webpack_require__(306);

var _LoadingData2 = _interopRequireDefault(_LoadingData);

var _common = __webpack_require__(3);

var _dialog = __webpack_require__(18);

var _layout = __webpack_require__(9);

var _utils = __webpack_require__(4);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddReception = function (_React$Component) {
  _inherits(AddReception, _React$Component);

  function AddReception(props, context) {
    _classCallCheck(this, AddReception);

    var _this = _possibleConstructorReturn(this, (AddReception.__proto__ || Object.getPrototypeOf(AddReception)).call(this, props, context));

    _this.state = {
      dataLoading: false,
      loadingDialog: false,
      thoiHan: '',
      donId: 0,
      maHoSo: '',
      ngayTiepNhan: (0, _moment2.default)(),
      taskDelete: [],
      doanDongNguoi: [],
      listDoanDiCung: [],
      dsTepDinhKem: [],
      soTiepCongDanId: 0,
      loadingSave: false,
      loadingXLD: false,
      thanhLapDon: false,
      soThuTuLuotTiep: 1,
      tongSoLuotTCD: 1,
      huongXuLy: '',
      loaiNguoiDungDonId: 'CA_NHAN',
      diaDiemGapLanhDao: '',
      lanhDaoId: 0,
      dsTaiLieuBoSung: [],
      dsTaiLieuBoSungRemove: [],
      dsTepDinhKemRemove: [],
      isFinish: false,
      isValid: true,
      isChuyenXLD: false,
      xacNhanChuyen: false,
      chuyenKiemTraDeXuatTitle: '',
      chuyenKiemTra: false,
      dsCoQuanToChucTiepDan: [],
      backConfirm: false,
      hasChange: false,
      dataView: {},
      isSave: false,
      guiYeuCauGapLanhDao: false,
      thongTinDon: {},
      fileTuChoi: {},
      fileHuongDan: {},
      yKienCheck: false,
      saveTmp: true,
      maTraCuuDialog: false,
      maTraCuu: '',
      confirmLuuHoSo: false,
      thucHienTaiGiayBienNhanTitle: '',
      daLayThongTinDonId: '',
      donViChuTri: _this.props.donViChuTri
    };
    return _this;
  }

  _createClass(AddReception, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua') {
        this.setState({ huongXuLy: 'GIAI_QUYET_NGAY' });
      }
      if (this.props.params.id) {
        this.getSoTiepCongDanInfo(this.props.params.id);
      }
      if (this.props.lanhDaoList && this.props.lanhDaoList.length) {
        this.state.lanhDaoId = this.props.lanhDaoList[0].congChucId;
        this.setState(_extends({}, this.state));
      }
      if (this.props.donViChuTri.length == 0) {
        _api.DuLieuHeThong.actions.getDonViChuTri.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViChuTri',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
      if (this.props.donViChuTri.length == 0) {
        _api.DuLieuHeThong.actions.getDonViHanhChinh.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViHanhChinh',
              data: res.data && res.data._embedded && res.data._embedded.donViHanhChinhs ? res.data._embedded.donViHanhChinhs : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {

      this.props.dispatch({
        type: 'RESET_FORM'
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.removeDonCongDanId) {
        this.state.taskDelete.push({
          type: 'CONG_DAN',
          id: nextProps.removeDonCongDanId
        });
      }
      if (this.props.lanhDaoList != nextProps.lanhDaoList && nextProps.lanhDaoList.length && this.state.lanhDaoId == 0) {
        this.state.lanhDaoId = nextProps.lanhDaoList[0].congChucId;
        this.setState(_extends({}, this.state));
      }
      if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
        this.setState({ daLayThongTinDonId: nextProps.thongTinDon.donId });
      }
      if (nextProps.donViChuTri != this.props.donViChuTri) {
        this.state.donViChuTri = nextProps.donViChuTri;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChangeData',
    value: function onChangeData(data) {

      var newData = _extends({}, this.state, data);
      this.state = newData;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onInitComponent',
    value: function onInitComponent(data) {
      var newData = _extends({}, this.state, data);
      this.state = newData;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'hasChange', true), _setState));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.state[e.target.name] = e.target.value;
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
      if (e.target.name == 'huongXuLy') {
        this.setState({
          ghiChuXuLy: ''
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var newData = _extends({}, this.state);
      if (e && e._d) {
        newData[name] = e._d;
      } else {
        newData[name] = e;
      }
      this.state.hasChange = true;
      this.setState(_extends({}, newData));
    }
  }, {
    key: 'runDeleteTask',
    value: function runDeleteTask() {
      var ddnParams = [];
      this.state.taskDelete.map(function (item, i) {
        if (item.type == 'CONG_DAN') {
          _api.Reception.actions.deleteDonCongDan.request({
            id: item.id
          });
        } else if (item.type == 'DOAN_DI_CUNG') {
          ddnParams.push({
            id: item.id
          });
        }
      });
      this.state.dsTepDinhKemRemove.map(function (item) {
        _api.Reception.actions.deleteTepDinhKem.request({
          id: item
        });
      });

      if (this.state.fileTuChoi.taiLieuVanThuId) {
        _api.Reception.actions.deleteTepDinhKem.request({
          id: this.state.fileTuChoi.taiLieuVanThuId
        });
      }
      if (this.state.fileHuongDan.taiLieuVanThuId) {
        _api.Reception.actions.deleteTepDinhKem.request({
          id: this.state.fileHuongDan.taiLieuVanThuId
        });
      }
      this.state.thongTinDon.dsBangChungRemove.map(function (item) {
        _api.Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
      this.state.thongTinDon.dsFileCoQuanRemove.map(function (item) {
        _api.Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
      this.state.dsTaiLieuBoSungRemove.map(function (item) {
        _api.Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
      if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
        this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.map(function (item) {
          _api.Reception.actions.deleteTaiLieuBangChung.request({
            id: item
          });
        });
      }
      if (ddnParams.length) {
        _api.Reception.actions.deleteDoanDiCungMulti.request(null, {
          doanDiCungs: ddnParams
        });
      }
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(name, data) {
      if (name == 'DOAN_DI_CUNG' && data.doanDiCungId) {
        this.state.taskDelete.push({
          type: 'DOAN_DI_CUNG',
          id: data.doanDiCungId
        });
      } else if (name == 'CONG_DAN' && data.donCongDanId) {
        this.state.taskDelete.push({
          type: 'CONG_DAN',
          id: data.donCongDanId
        });
      }
      this.state.hasChange = true;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'createTaiLieuBangChung',
    value: function createTaiLieuBangChung(item, donID, stcdId) {
      var buocGQ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'TAI_LIEU_KEM_THEO';

      var params = {
        don: {
          id: donID
        },
        buocGiaiQuyet: buocGQ
      };
      if (item.ten) {
        params.ten = item.ten;
      }

      if (item.tinhTrang) {
        params.tinhTrangTaiLieu = item.tinhTrang;
      }
      if (item.tenFile) {
        params.tenFile = item.tenFile;
      }
      if (item.duongDan) {
        params.duongDan = item.duongDan;
      }
      if (item.required) {
        params.required = true;
      }
      if (stcdId) {
        params.soTiepCongDan = {
          id: stcdId
        };
      }
      if (item.taiLieuBangChungId) {
        params.id = item.taiLieuBangChungId;
      }
      return params;
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(donId, data, loaiQT, buocGQ, stcdId, huongxl) {
      var listAddNew = [];
      var listUpdate = [];
      data.map(function (item, i) {
        if (item.ten) {
          var params = {
            don: { id: donId },
            loaiQuyTrinh: loaiQT,
            loaiTepDinhKem: 'QUYET_DINH'
          };
          if (item.ten) {
            params.ten = item.ten;
          }
          if (buocGQ) {
            params.buocGiaiQuyet = buocGQ;
          }
          if (stcdId) {
            params.soTiepCongDan = { id: stcdId };
          }
          if (item.tenFile) {
            params.tenFile = item.tenFile;
          }
          if (item.duongDan) {
            params.duongDan = item.duongDan;
          }
          if (item.required) {
            params.required = true;
          }
          if (huongxl) {
            params.typeRequired = huongxl;
          }
          if (item.soQuyetDinh) {
            params.soQuyetDinh = item.soQuyetDinh;
          }
          if (item.ngayQuyetDinh) {
            params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
          }
          if (item.taiLieuVanThuId) {
            params.id = item.taiLieuVanThuId;
            listUpdate.push(params);
          } else {
            listAddNew.push(params);
          }
        }
      });

      if (listAddNew.length) {
        _api.Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
      if (listUpdate.length) {
        _api.Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
      }
    }
  }, {
    key: 'createTaiLieuBoSung',
    value: function createTaiLieuBoSung(data) {
      var _this3 = this;

      var AddNewTLList = [];
      var UpdateTLList = [];

      this.state.dsTaiLieuBoSung.map(function (item, i) {
        var tlParams = _this3.createTaiLieuBangChung(item, data.donSTCD.donId, data.soTiepCongDanId);
        if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
      });
      if (AddNewTLList.length) {
        _api.Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
      }
      if (UpdateTLList.length) {
        _api.Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
      }
    }
  }, {
    key: 'createDonCongDan',
    value: function createDonCongDan(cdData, donID, plusData, loaiCD) {
      var param = {
        phanLoaiCongDan: loaiCD,
        don: { id: donID }
      };
      if (cdData) {
        param = Object.assign(param, cdData);
      }
      if (plusData) {
        param = Object.assign(param, plusData);
      }
      return param;
    }
  }, {
    key: 'createItemDoanDiCung',
    value: function createItemDoanDiCung(data, donId) {
      var params = {
        hoVaTen: data.hoVaTen,
        don: { id: donId }
      };
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.cmndHoChieu) {
        params.cmndHoChieu = data.cmndHoChieu;
      }
      if (data.doanDiCungId) {
        params.id = data.doanDiCungId;
      }
      return params;
    }
  }, {
    key: 'createCongDan',
    value: function createCongDan(data, type) {
      var params = { hoVaTen: data.hoVaTen };
      if (data.tinhThanhId) {
        params.tinhThanh = { id: data.tinhThanhId };
      }
      if (data.quanHuyenId) {
        params.quanHuyen = { id: data.quanHuyenId };
      }
      if (data.phuongXaId) {
        params.phuongXa = { id: data.phuongXaId };
      }
      if (data.toThon) {
        params.toThon = data.toThon;
      }
      if (data.diaChi) {
        params.diaChi = data.diaChi;
      }
      if (data.soDienThoai) {
        params.soDienThoai = data.soDienThoai;
      }
      if (data.soCMNDHoChieu) {
        params.soCMNDHoChieu = data.soCMNDHoChieu;
      }
      if (data.noiCap) {
        params.noiCapCMND = { id: data.noiCap.value };
      }
      if (data.ngaySinh && data.ngaySinh != null) {
        params.ngaySinh = (0, _moment2.default)(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.ngayCap && data.ngaySinh != null) {
        params.ngayCap = (0, _moment2.default)(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (data.gioiTinh) {
        params.gioiTinh = data.gioiTinh == 'male' ? true : false;
      }
      if (data.quocTichId) {
        params.quocTich = { id: data.quocTichId };
      }
      if (data.danTocId) {
        params.danToc = { id: data.danTocId };
      }
      if (data.donCongDanId) {
        params.id = data.donCongDanId;
      }
      if (data.congDanId && type != 'NGUOI_DUOC_UY_QUYEN') {
        params.congDan = { id: data.congDanId };
      }
      return params;
    }
  }, {
    key: 'hoanThanhDon',
    value: function hoanThanhDon() {
      var _this4 = this;

      this.setState({ isSave: false }, function () {
        if (_this4.validateSubmitForm()) {
          _this4.setState({ confirmLuuHoSo: true });
        }
      });
    }
  }, {
    key: 'hoanThanhDonConfirmed',
    value: function hoanThanhDonConfirmed() {
      this.state.isFinish = true;
      this.state.saveTmp = false;
      this.createDon();
    }
  }, {
    key: 'closeXacNhanLuuHoSo',
    value: function closeXacNhanLuuHoSo() {
      this.setState({ confirmLuuHoSo: false });
    }
  }, {
    key: 'createDon',
    value: function createDon() {
      var _this5 = this;

      var params = {
        coUyQuyen: this.state.flagUyQuyen,
        coThongTinCoQuanDaGiaiQuyet: this.state.thongTinDon ? this.state.thongTinDon.flagCQDaGiaiQuyet : false,
        noiDung: this.state.thongTinDon.noiDung,
        loaiVuViec: this.state.thongTinDon.loaiVuViecId,
        nguonTiepNhanDon: 'TRUC_TIEP',
        loaiNguoiDungDon: this.state.loaiNguoiDungDonId,
        thanhLapDon: this.state.thanhLapDon ? this.state.thanhLapDon : false,
        canBoXuLy: { id: this.props.userInfo.id },
        soNguoi: this.props.nguoiDungDon.length
      };

      if (this.state.daLayThongTinDonId) {
        params.daLayThongTinDonId = this.state.daLayThongTinDonId;
      }

      if (!this.state.saveTmp) {
        params.saveTmp = this.state.saveTmp;
      }

      if (this.state.thongTinDon.loaiDonId) {
        params.loaiDon = this.state.thongTinDon.loaiDonId;
      }

      if (this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI') {
        params.soNguoi = this.state.soNguoi;
      }

      if (this.state.thongTinDon.loaiDoiTuongId) {
        params.loaiDoiTuong = this.state.thongTinDon.loaiDoiTuongId;
      }

      if (this.state.thongTinDon.linhVucCap1Id) {
        params.linhVucDonThu = { id: this.state.thongTinDon.linhVucCap1Id };
      }

      if (this.state.thongTinDon.layVuViecCu) {
        params.layVuViecCu = this.state.thongTinDon.layVuViecCu;
      }

      if (this.state.thongTinDon.linhVucCap2Id) {
        params.linhVucDonThuChiTiet = { id: this.state.thongTinDon.linhVucCap2Id };
      }
      if (this.state.thongTinDon.linhVucChiTietKhac) {
        params.linhVucChiTietKhac = this.state.thongTinDon.linhVucChiTietKhac;
      }

      if (this.state.thongTinDon.flagCQDaGiaiQuyet) {
        if (this.state.thongTinDon.coQuanDaGiaiQuyetDonThu) {
          params.coQuanDaGiaiQuyetDonThu = this.state.thongTinDon.coQuanDaGiaiQuyetDonThu;
        }
        if (this.state.thongTinDon.soVanBan) {
          params.soVanBanDaGiaiQuyet = this.state.thongTinDon.soVanBan;
        }
        if (this.state.thongTinDon.ngayBanHanh) {
          params.ngayBanHanhVanBanDaGiaiQuyet = (0, _moment2.default)(this.state.thongTinDon.ngayBanHanh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }

      if (this.state.huongXuLy == 'GIAI_QUYET_NGAY') {
        params.thanhLapDon = false;
      }

      if (this.state.isChuyenXLD) {
        params.thanhLapDon = true;
        this.setState({ loadingXLD: true });
      } else {
        this.setState({ loadingSave: true });
      }
      this.runDeleteTask();
      if (this.state.donId != 0) {
        params.tongSoLuotTCD = this.state.tongSoLuotTCD;
        _api.Reception.actions.updateDon.request({ id: this.state.donId }, params).then(function (res) {
          if (res.data) {
            _this5.state.maHoSo = res.data.maHoSo;
            _this5.phanLoaiDonCongDan(res.data.donId);
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this5.setState({
            loadingSave: false,
            loadingXLD: false
          });
        });
      } else {
        _api.Reception.actions.postDon.request(null, params).then(function (res) {
          if (res.data) {
            _this5.state.maHoSo = res.data.maHoSo;
            _this5.phanLoaiDonCongDan(res.data.donId);
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this5.setState({
            loadingSave: false,
            loadingXLD: false
          });
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'phanLoaiDonCongDan',
    value: function phanLoaiDonCongDan(donId) {
      var _this6 = this;

      var plusData = {};
      var AddNewDCDList = [];
      var UpdateDCDList = [];
      var AddNewTLList = [];
      var UpdateTLList = [];
      var AddNewDDCList = [];
      var UpdateDDCList = [];

      if (this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC') {
        plusData = {
          tenCoQuan: this.state.tenCoQuan,
          diaChiCoQuan: this.state.diaChiCoQuan,
          soDienThoaiCoQuan: this.state.soDienThoai
        };
      }
      this.props.nguoiDungDon.map(function (item, i) {
        if (item.hoVaTen) {
          var nddData = _this6.createCongDan(item, 'NGUOI_DUNG_DON');
          var donCdData = _this6.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
          if (donCdData.id) UpdateDCDList.push(donCdData);else AddNewDCDList.push(donCdData);
        }
      });
      this.state.doanDongNguoi.map(function (item, i) {
        if (item.hoVaTen) {
          var ddcData = _this6.createItemDoanDiCung(item, donId);
          if (ddcData.id) {
            UpdateDDCList.push(ddcData);
          } else {
            AddNewDDCList.push(ddcData);
          }
        }
      });

      if (this.state.flagUyQuyen) {
        if (this.state.uyQuyen && this.state.uyQuyen.flagLuatSu) {
          plusData.luatSu = this.state.uyQuyen.flagLuatSu;
          if (this.state.uyQuyen.luatSu.soTheLuatSu) {
            plusData.soTheLuatSu = this.state.uyQuyen.luatSu.soTheLuatSu;
          }
          if (this.state.uyQuyen.luatSu.ngayCapTheLuatSu) {
            plusData.ngayCapTheLuatSu = (0, _moment2.default)(this.state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
          }
          if (this.state.uyQuyen.luatSu.noiCapTheLuatSu) {
            plusData.noiCapTheLuatSu = this.state.uyQuyen.luatSu.noiCapTheLuatSu;
          }
          if (this.state.uyQuyen.luatSu.thongTinGioiThieu) {
            plusData.thongTinGioiThieu = this.state.uyQuyen.luatSu.thongTinGioiThieu;
          }

          this.state.uyQuyen.luatSu.dsGiayUyQuyen.map(function (item, i) {
            var tlParams = _this6.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
            if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
          });
        } else {
          plusData.luatSu = false;
        }
        var nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
        var donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');
        if (donCdData.id) UpdateDCDList.push(donCdData);else AddNewDCDList.push(donCdData);
      }
      this.state.thongTinDon.dsBangChung.map(function (item, i) {
        var tlParams = _this6.createTaiLieuBangChung(item, donId);
        if (tlParams.id) UpdateTLList.push(tlParams);else AddNewTLList.push(tlParams);
      });

      if (AddNewDCDList.length) {
        _api.Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(function (res) {
          if (!UpdateDCDList.length) {
            _this6.createSoTiepCongDan(donId);
          }
        });
      }
      if (UpdateDCDList.length) {
        _api.Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(function (res) {
          _this6.createSoTiepCongDan(donId);
        });
      }
      if (!AddNewDCDList.length && !UpdateDCDList.length) {
        this.createSoTiepCongDan(donId);
      }
      if (AddNewTLList.length) {
        _api.Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
      }
      if (UpdateTLList.length) {
        _api.Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
      }
      if (AddNewDDCList.length) {
        _api.Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
      }
      if (UpdateDDCList.length) {
        _api.Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
      }
    }
  }, {
    key: 'createSoTiepCongDan',
    value: function createSoTiepCongDan(donID) {
      var _this7 = this;

      var params = {
        canBoTiepDan: { id: this.props.userInfo.id },
        donViTiepDan: { id: this.props.userInfo.donViId },
        don: { id: donID },
        taiLieuVanThus: [],
        loaiTiepDan: 'THUONG_XUYEN',
        ngayTiepDan: this.state.ngayTiepNhan ? (0, _moment2.default)(this.state.ngayTiepNhan, 'DD/MM/YYYY').add(7, 'hours').toISOString() : (0, _moment2.default)().add(7, 'hours').toISOString(),
        noiDungTiepCongDan: this.state.ghiChuXuLy
      };

      if (this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi') {
        params.loaiTiepDan = this.props.params.type == 'dinh-ky-chinh-sua' ? 'DINH_KY' : 'DOT_XUAT';

        if (this.state.dsCoQuanToChucTiepDan.length) {
          params.coQuanToChucTiepDans = [];
          this.state.dsCoQuanToChucTiepDan.map(function (item, i) {
            params.coQuanToChucTiepDans[i] = {
              chucVu: item.chucVu,
              nguoiDaiDien: item.nguoiDaiDien,
              coQuanDonVi: { id: item.ten }
            };
            if (item.coQuanToChucTiepDanId) {
              params.coQuanToChucTiepDans[i].id = item.coQuanToChucTiepDanId;
            }
          });
        }

        if (this.state.isFinish) {
          params.hoanThanhTCDLanhDao = true;
        }
        this.props.lanhDaoList.map(function (item, i) {
          if (item.congChucId == _this7.state.lanhDaoId) {
            params.canBoTiepDan = { id: item.congChucId };
            params.donViTiepDan = { id: item.donViCongChuc.coQuanQuanLyId };
          }
        });
        if (this.state.diaDiemGapLanhDao) {
          params.diaDiemGapLanhDao = this.state.diaDiemGapLanhDao;
        }
        params.yKienXuLy = this.state.ghiChuXuLy;
        params.huongGiaiQuyetTCDLanhDao = this.state.huongXuLy;
        if (this.state.huongXuLy == 'CHO_GIAI_QUYET') {
          if (this.state.donViChuTriId) {
            params.donViChuTri = { id: this.state.donViChuTriId };
          }
          if (this.state.donViPhoiHopId) {
            params.donViPhoiHops = [];
            this.state.donViPhoiHopId.map(function (item) {
              params.donViPhoiHops.push({ id: item.value });
            });
          }
          if (this.state.thoiHan) {
            params.ngayBaoCaoKetQua = (0, _moment2.default)(this.state.thoiHan, 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }
          if (this.state.chuyenKiemTra) {
            params.chuyenDonViKiemTra = true;
            params.yKienGiaiQuyet = this.state.ghiChuXuLy;
          }
        }
      } else {
        if (this.state.huongXuLy) {
          params.huongXuLy = this.state.huongXuLy;
        }
        if (this.state.isFinish) {
          params.hoanThanhTCDThuongXuyen = true;
        }
      }

      if (this.state.guiYeuCauGapLanhDao) {
        params.guiYeuCauGapLanhDao = true;
      }

      if (this.state.soTiepCongDanId && this.props.params.type != 'them-luot') {
        params.soThuTuLuotTiep = this.state.soThuTuLuotTiep;
        _api.Reception.actions.updateSoTiepCongDan.request({ id: this.state.soTiepCongDanId }, params).then(function (res) {
          if (res.data) {
            _this7.createDSTepDinhKem(donID, _this7.state.dsTepDinhKem, 'TIEP_CONG_DAN', '', res.data.soTiepCongDanId, res.data.huongXuLy);
            _this7.createDSTepDinhKem(donID, _this7.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET', res.data.soTiepCongDanId, '');
            _this7.createTaiLieuBoSung(res.data);
            _this7.props.dispatch({
              type: 'REFRESH_MENU',
              value: true
            });
            if (_this7.state.isChuyenXLD) {
              (0, _toastr.Toastr)(_message.msg.chuyenXLDSucess, 'success');
              _this7.state.thucHienTaiGiayBienNhanTitle = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD t\u1EA3i xu\u1ED1ng Gi\u1EA5y bi\xEAn nh\u1EADn c\u1EE7a \u0111\u01A1n v\u1EDBi M\xE3 \u0111\u01A1n ' + _this7.state.maHoSo + ' kh\xF4ng?';
              _this7.state.maTraCuuDialog = true;
              _this7.setState(_extends({}, _this7.state));
              return;
            } else if (_this7.state.chuyenKiemTra) {
              (0, _toastr.Toastr)(_message.msg.chuyenKTDX, 'success');
            } else {
              (0, _toastr.Toastr)(_message.msg.updateSuccess, 'success');
            }
            setTimeout(function () {
              _reactRouter.browserHistory.goBack();
            }, 1000);
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this7.setState({
            loadingSave: false,
            loadingXLD: false,
            xacNhanChuyen: false
          });
        });
      } else {
        _api.Reception.actions.postSoTiepCongDan.request('', params).then(function (res) {
          if (res.data) {
            _this7.createDSTepDinhKem(donID, _this7.state.dsTepDinhKem, 'TIEP_CONG_DAN', '', res.data.soTiepCongDanId, res.data.huongXuLy);
            _this7.createDSTepDinhKem(donID, _this7.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET', res.data.soTiepCongDanId, '');
            _this7.createTaiLieuBoSung(res.data);
            _this7.props.dispatch({
              type: 'REFRESH_MENU',
              value: true
            });
            if (_this7.state.isChuyenXLD) {
              (0, _toastr.Toastr)(_message.msg.chuyenXLDSucess, 'success');
              _this7.state.thucHienTaiGiayBienNhanTitle = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD t\u1EA3i xu\u1ED1ng Gi\u1EA5y bi\xEAn nh\u1EADn c\u1EE7a \u0111\u01A1n v\u1EDBi M\xE3 \u0111\u01A1n ' + _this7.state.maHoSo + ' kh\xF4ng?';
              _this7.state.maTraCuuDialog = true;
              _this7.setState(_extends({}, _this7.state, {
                donId: donID
              }));
              return;
            } else if (_this7.state.chuyenKiemTra) {
              (0, _toastr.Toastr)(_message.msg.chuyenKTDX, 'success');
            } else {
              if (_this7.props.params.type == 'them-luot') {
                (0, _toastr.Toastr)(_message.msg.addTurnSucess, 'success');
              } else {
                (0, _toastr.Toastr)(_message.msg.createSuccess, 'success');
              }
            }
            setTimeout(function () {
              _reactRouter.browserHistory.goBack();
            }, 1000);
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this7.setState({
            loadingSave: false,
            loadingXLD: false,
            xacNhanChuyen: false
          });
        });
      }
    }
  }, {
    key: 'getSoTiepCongDanInfo',
    value: function getSoTiepCongDanInfo(stcdId) {
      var _this8 = this;

      _api.Reception.actions.getSoTiepCongDanDetail.request({ id: stcdId }).then(function (res) {
        if (res.data) {
          _this8.getSoTiepCongDanMoreInfo(res.data);
          var info = res.data;
          info.donSTCD.listNguoiDungDon.map(function (item, i) {
            _this8.props.dispatch({
              type: 'CHON_CONG_DAN',
              data: item,
              donCongDanId: item.donCongDanId,
              index: i
            });
          });

          var newState = _extends({}, _this8.state);

          if (_this8.props.params.type == 'them-luot') {
            newState.ngayTiepNhan = (0, _moment2.default)();
          } else {
            newState.ngayTiepNhan = (0, _moment2.default)(info.ngayTiepDan);
          }
          newState.donId = info.donSTCD.donId;
          newState.soTiepCongDanId = info.soTiepCongDanId;
          newState.soThuTuLuotTiep = info.soThuTuLuotTiep;
          newState.tongSoLuotTCD = info.donSTCD.tongSoLuotTCD;
          newState.loaiNguoiDungDonId = info.donSTCD.loaiNguoiDungDon;
          newState.thanhLapDon = info.donSTCD.thanhLapDon;
          newState.diaDiemGapLanhDao = info.diaDiemGapLanhDao;
          newState.lanhDaoId = info.canBoTiepDanInfo ? info.canBoTiepDanInfo.congChucId : 0;
          newState.maHoSo = info.donSTCD.maHoSo ? info.donSTCD.maHoSo : '';
          newState.dataView = info.donSTCD;
          newState.daLayThongTinDonId = info.donSTCD.daLayThongTinDonId || '';

          _this8.setState(newState);
        }
      });
    }
  }, {
    key: 'getSoTiepCongDanMoreInfo',
    value: function getSoTiepCongDanMoreInfo(stcdData) {
      var _this9 = this;

      _api.Reception.actions.getSoTiepCongDanInfo.request({ id: stcdData.soTiepCongDanId }).then(function (res) {
        if (res.data) {
          stcdData = _extends({}, stcdData, res.data);
        }
        _this9.getDonInfo(stcdData);
      });
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(stcdData) {
      var _this10 = this;

      _api.Reception.actions.getDonInfo.request({ id: stcdData.donSTCD.donId }).then(function (res) {
        if (res.data) {
          _this10.state.listDoanDiCung = res.data.listDoanDiCung;
          if (res.data.nguoiDuocUyQuyen) {
            _this10.props.dispatch({
              type: 'CHON_CONG_DAN',
              data: res.data.nguoiDuocUyQuyen,
              donCongDanId: res.data.nguoiDuocUyQuyen.donCongDanId,
              index: -1
            });
          }
          stcdData.donSTCD = _extends({}, stcdData.donSTCD, res.data);
          _this10.props.dispatch({
            type: 'INIT_EDIT_FORM',
            data: stcdData.donSTCD,
            STCD: stcdData
          });
        }
      });
    }
  }, {
    key: 'chuyenXuLyDon',
    value: function chuyenXuLyDon() {
      var _this11 = this;

      this.setState({ isSave: false }, function () {
        if (_this11.validateSubmitForm()) {
          _this11.state.isChuyenXLD = true;
          _this11.state.saveTmp = false;
          _this11.createDon();
        }
      });
    }
  }, {
    key: 'luuDon',
    value: function luuDon() {
      var _this12 = this;

      this.setState({ isSave: true }, function () {
        _this12.createDon();
      });
    }
  }, {
    key: 'handleInPhieu',
    value: function handleInPhieu() {
      var _this13 = this;

      var diaChi = '';
      var data = this.props.nguoiDungDon[0];
      var noiCap = data.noiCap ? data.noiCap.label : '...';
      var ngayCap = data.ngayCap ? (0, _moment2.default)(new Date(data.ngayCap)).format('DD/MM/YYYY') : '';
      var ngayTiepNhan = this.state.ngayTiepNhan ? (0, _moment2.default)(new Date(this.state.ngayTiepNhan)).format('DD/MM/YYYY') : '';
      if (data) {
        diaChi = diaChi + data.diaChi;
      }
      if (data && data.toThon) {
        if (data.diaChi) {
          diaChi = diaChi + ", " + data.toThon;
        } else {
          diaChi = diaChi + data.toThon;
        }
      }
      if (data && data.phuongXaCongDan) {
        if (data.diaChi || data.toThon) {
          diaChi = diaChi + ", " + data.phuongXaCongDan.ten;
        } else {
          diaChi = diaChi + data.phuongXaCongDan.ten;
        }
      }
      if (data && data.quanHuyenCongDan) {
        if (data.diaChi || data.phuongXaCongDan) {
          diaChi = diaChi + ", " + data.quanHuyenCongDan.ten;
        } else {
          diaChi = diaChi + data.quanHuyenCongDan.ten;
        }
      }
      if (data && data.tinhThanhCongDan) {
        if (data.diaChi || data.quanHuyenCongDan) {
          diaChi = diaChi + ", " + data.tinhThanhCongDan.ten;
        } else {
          diaChi = diaChi + data.tinhThanhCongDan.ten;
        }
      }

      var apiUrl = "/soTiepCongDans/inPhieuHen?";
      var name = "giay_bien_nhan.doc";
      if (this.state.huongXuLy == 'TU_CHOI') {
        apiUrl = "/soTiepCongDans/inPhieuTuChoi?";
        name = "phieu_tu_choi.doc";
      }
      if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && this.state.thongTinDon.loaiDonId == 'DON_KHIEU_NAI') {
        apiUrl = "/soTiepCongDans/inPhieuHuongDanKhieuNai?";
        name = "phieu_huong_dan_khieu_nai.doc";
      }
      if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && this.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {
        apiUrl = "/soTiepCongDans/inPhieuHuongDanToCao?";
        name = "phieu_huong_dan_to_cao.doc";
      }

      var URL = String(_config.API_URL) + apiUrl + "donId=" + this.state.donId + "&hoVaTen=" + (data.hoVaTen ? data.hoVaTen : '...') + "&canBoTiepNhan=" + (this.props.userInfo && this.props.userInfo.name ? this.props.userInfo.name : '...') + "&chucVu=" + (this.props.userInfo.chucVu ? this.props.userInfo.chucVu : '...') + "&maHoSo=" + (this.state.maHoSo ? this.state.maHoSo : '') + "&soCMNDHoChieu=" + (data.soCMNDHoChieu || '...') + "&ngayCap=" + ngayCap + "&loaiDon=" + (this.state.thongTinDon.loaiDonText || '') + "&noiCap=" + noiCap + "&diaChi=" + (diaChi ? diaChi : '...') + "&noiDung=" + this.state.thongTinDon.noiDung + "&diaDiemTiepCongDan=..." + "&donViXuLyId=" + this.props.userInfo.donViId + "&ngayTiepNhan=" + ngayTiepNhan + "&thoiGianTiepCongDan=..." + "&ngayHenTiepCongDan=...";
      // window.open(URL, "_self");
      (0, _utils.downloadFile)(URL, name, function () {
        if (name === 'giay_bien_nhan.doc') {
          _this13.closeMaTraCuuDialog();
        } else {
          _this13.closeDialogSauKhiDownFile();
        }
      }, true);
    }
  }, {
    key: 'chuyenKiemTraDeXuat',
    value: function chuyenKiemTraDeXuat() {
      var _this14 = this;

      this.setState({
        isSave: false,
        yKienCheck: this.props.params.type == 'dinh-ky-chinh-sua'
      }, function () {
        if (_this14.validateSubmitForm()) {
          var tenDonVi = 'đơn vị này';
          _this14.state.donViChuTri.map(function (item) {
            if (item.coQuanQuanLyId == _this14.state.donViChuTriId) {
              tenDonVi = item.ten;
            }
          });
          _this14.state.xacNhanChuyen = true;
          _this14.state.chuyenKiemTraDeXuatTitle = 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD chuy\u1EC3n qua ' + tenDonVi + ' ki\u1EC3m tra v\xE0 \u0111\u1EC1 xu\u1EA5t cho \u0111\u01A1n/v\u1EE5 vi\u1EC7c n\xE0y kh\xF4ng?';
          _this14.setState(_extends({}, _this14.state));
        }
      });
    }
  }, {
    key: 'closeDialogKiemTraDeXuat',
    value: function closeDialogKiemTraDeXuat() {
      this.setState({
        xacNhanChuyen: false
      });
    }
  }, {
    key: 'luuLuotTiep',
    value: function luuLuotTiep() {
      if (this.validateSubmitForm()) {
        this.createDon();
      }
    }
  }, {
    key: 'chuyenYeuCau',
    value: function chuyenYeuCau() {
      this.state.guiYeuCauGapLanhDao = true;
      if (this.validateSubmitForm()) {
        this.state.saveTmp = false;
        this.createDon();
      }
    }
  }, {
    key: 'thucHienChuyenKiemTraDeXuat',
    value: function thucHienChuyenKiemTraDeXuat() {
      var _this15 = this;

      this.setState({
        loadingDialog: true,
        chuyenKiemTra: true,
        saveTmp: false,
        xacNhanChuyen: false
      }, function () {
        _this15.createDon();
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'closeDialogSauKhiDownFile',
    value: function closeDialogSauKhiDownFile() {
      this.setState({ maTraCuuDialog: false, loadingDialog: false });
    }
  }, {
    key: 'closeMaTraCuuDialog',
    value: function closeMaTraCuuDialog() {
      this.setState({ maTraCuuDialog: false, loadingDialog: false });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'thucHienTaiGiayBienNhan',
    value: function thucHienTaiGiayBienNhan() {
      var _this16 = this;

      this.setState({
        loadingDialog: true
      }, function () {
        _this16.handleInPhieu();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var valid = function valid(current) {
        return current.isBefore((0, _moment2.default)());
      };
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.maTraCuuDialog, loading: this.state.loadingDialog, onClose: this.closeMaTraCuuDialog.bind(this), onSuccess: this.thucHienTaiGiayBienNhan.bind(this),
            title: this.state.thucHienTaiGiayBienNhanTitle }),
          _react2.default.createElement(_reception.SearchFullNamePopup, { self: this.state }),
          _react2.default.createElement(_reception.ListInfoDocumentDialog, { self: this.state }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.xacNhanChuyen, loading: this.state.loadingDialog, onClose: this.closeDialogKiemTraDeXuat.bind(this), onSuccess: this.thucHienChuyenKiemTraDeXuat.bind(this),
            title: this.state.chuyenKiemTraDeXuatTitle }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.confirmLuuHoSo, onClose: this.closeXacNhanLuuHoSo.bind(this), loading: this.state.loadingSave, onSuccess: this.hoanThanhDonConfirmed.bind(this), title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1', content: 'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?' }),
          _react2.default.createElement(
            'div',
            { id: 'page', className: 'add-reception panel-page' },
            _react2.default.createElement(
              'div',
              { className: 'center' },
              _react2.default.createElement(
                'div',
                { className: 'back-foward' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: this.handleBack.bind(this, false), title: '' },
                  'V\u1EC1 trang tr\u01B0\u1EDBc'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'heading' },
                _react2.default.createElement(
                  'h2',
                  { className: 'heading-title icon-add' },
                  this.props.params.type == 'them-moi' || this.props.params.type == 'them-luot' ? 'THÊM MỚI LƯỢT TIẾP CÔNG DÂN' : '',
                  this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA LƯỢT TIẾP CÔNG DÂN' : '',
                  this.props.params.type == 'dinh-ky-chinh-sua' ? 'CHI TIẾT CUỘC TIẾP CÔNG DÂN CỦA LÃNH ĐẠO' : '',
                  this.props.params.type == 'dot-xuat-them-moi' ? 'THÊM MỚI CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO' : '',
                  this.props.params.type == 'dot-xuat-chinh-sua' ? 'CHI TIẾT CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO' : ''
                )
              ),
              this.state.dataLoading ? _react2.default.createElement(_LoadingData2.default, null) : _react2.default.createElement(
                'div',
                { className: 'main_page' },
                _react2.default.createElement(
                  'form',
                  { className: 'form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrapper_box' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-forward ' },
                        _react2.default.createElement(
                          'div',
                          { className: 'container-box' },
                          _react2.default.createElement(
                            'div',
                            { className: 'group-box' },
                            _react2.default.createElement(
                              'div',
                              { className: 'items-form' },
                              _react2.default.createElement(
                                'div',
                                { className: 'rows box-top' },
                                this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(_common.DropDown, { label: 'L\xE3nh \u0111\u1EA1o ti\u1EBFp', className: 'col-input mb0-18', require: true, options: this.props.lanhDaoList, keyName: 'congChucId', valueName: 'hoVaTen', selectedValue: this.state.lanhDaoId, onChange: this.onChange.bind(this, 'lanhDaoId'), isValid: !this.state.isValid, name: 'dropdownChonLanhDaoTiep' }),
                                  _react2.default.createElement(_common.DatePicker, { className: 'col-input mb0-18', label: 'Ng\xE0y ti\u1EBFp', dateFormat: 'DD/MM/YYYY -', timeFormat: 'HH:mm', value: this.state.ngayTiepNhan, onChange: this.handleChangeDate.bind(this, 'ngayTiepNhan'), maxLength: 18, name: 'ngayTiep' }),
                                  _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa \u0111i\u1EC3m', className: 'col-w60 mb0-18', value: this.state.diaDiemGapLanhDao, onChange: this.onChange.bind(this, 'diaDiemGapLanhDao'), name: 'textDiaDiemGapLanhDao' })
                                ) : _react2.default.createElement(
                                  'div',
                                  { className: 'col-12' },
                                  _react2.default.createElement(_common.DatePicker, { className: 'col-input mb0-18', label: 'Ng\xE0y ti\u1EBFp', dateFormat: 'DD/MM/YYYY -', timeFormat: 'HH:mm', value: this.state.ngayTiepNhan, onChange: this.handleChangeDate.bind(this, 'ngayTiepNhan'), maxLength: 18, isValidDate: valid, name: 'ngayTiep' }),
                                  this.props.params.type == 'them-luot' ? _react2.default.createElement(
                                    'p',
                                    { className: 'pull-right reception-count' },
                                    'L\u01B0\u1EE3t ti\u1EBFp ',
                                    _react2.default.createElement(
                                      'span',
                                      null,
                                      this.state.soThuTuLuotTiep + 1 + '/' + (this.state.tongSoLuotTCD + 1)
                                    )
                                  ) : _react2.default.createElement(
                                    'p',
                                    { className: 'pull-right reception-count' },
                                    'L\u01B0\u1EE3t ti\u1EBFp ',
                                    _react2.default.createElement(
                                      'span',
                                      null,
                                      this.state.soThuTuLuotTiep + '/' + this.state.tongSoLuotTCD
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    ),
                    this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ? _react2.default.createElement(_ThongTinCoQuanTiepDan2.default, { onChange: this.onChangeData.bind(this), onInit: this.onInitComponent.bind(this), bindValidator: this }) : null,
                    _react2.default.createElement(_ThongTinNguoiDungDon2.default, { onChange: this.onChangeData.bind(this), bindValidator: this, onInit: this.onInitComponent.bind(this), onRemove: this.handleRemove.bind(this),
                      onSave: this.state.isSave || this.state.huongXuLy == 'KHAC' }),
                    _react2.default.createElement(_ThongTinDon2.default, { onChange: this.onChangeData.bind(this), isTraCuu: true, isDonCu: false, isKiemTraTCD: true, bindValidator: this, huongXuLy: this.state.huongXuLy, onInit: this.onInitComponent.bind(this), type: this.props.params.type, onSave: this.state.isSave || this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' || this.state.huongXuLy == 'YEU_CAU_GAP_LANH_DAO' || this.state.huongXuLy == 'TU_CHOI' || this.state.huongXuLy == 'KHAC' }),
                    this.props.params.type == 'chinh-sua' || this.props.params.type == 'them-luot' ? _react2.default.createElement(_reception.TinhTrangDon, { data: this.state.dataView }) : '',
                    this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ? _react2.default.createElement(_reception.KetQuaTiepCongDan, { type: this.props.params.type, yKienCheck: this.state.yKienCheck, onChange: this.onChangeData.bind(this), bindValidator: this, onInit: this.onInitComponent.bind(this), onSave: this.state.isSave }) : _react2.default.createElement(_reception.ThongTinTiepCongDan, { thongTinTiepCongDan: this.state.huongXuLy, loaiDon: this.state.thongTinDon.loaiDonId, onChange: this.onChangeData.bind(this), bindValidator: this, type: this.props.params.type, onInit: this.onInitComponent.bind(this),
                      onSave: this.state.isSave })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'box-bottom complete-wrap' },
                    this.state.thongTinDon.loaiDonId !== "DON_KIEN_NGHI_PHAN_ANH" && this.state.thongTinDon.loaiDonId !== "DON_TRANH_CHAP_DAT" && this.state.huongXuLy === "TRA_DON_VA_HUONG_DAN" && (!this.props.params.id && (this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' || this.state.huongXuLy === 'TU_CHOI') || this.props.params.id && this.props.params.type !== "them-luot" && this.props.params.type !== 'dinh-ky-chinh-sua') && _react2.default.createElement(
                      _reactRouter.Link,
                      { onClick: this.handleInPhieu.bind(this), className: 'btn-action btn-print btn-print-left' },
                      this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' ? _react2.default.createElement(
                        'span',
                        null,
                        'T\u1EA3i phi\u1EBFu tr\u1EA3 \u0111\u01A1n v\xE0 h\u01B0\u1EDBng d\u1EABn'
                      ) : this.state.huongXuLy === 'TU_CHOI' ? _react2.default.createElement(
                        'span',
                        null,
                        'T\u1EA3i phi\u1EBFu t\u1EEB ch\u1ED1i ti\u1EBFp c\xF4ng d\xE2n'
                      ) : _react2.default.createElement(
                        'span',
                        null,
                        'T\u1EA3i gi\u1EA5y bi\xEAn nh\u1EADn'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false) },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u0110\xF3ng'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-action btn-save ' + (this.state.loadingSave ? 'btn-loading-inline' : '') + ' ' + (this.state.loadingXLD ? 'btn-disable' : ''), onClick: this.luuDon.bind(this) },
                      this.props.params.type == 'them-luot' ? _react2.default.createElement(
                        'span',
                        null,
                        'Th\xEAm l\u01B0\u1EE3t'
                      ) : _react2.default.createElement(
                        'span',
                        null,
                        'L\u01B0u t\u1EA1m'
                      )
                    ),
                    this.state.huongXuLy == 'TIEP_NHAN_DON' && !this.state.thanhLapDon ? _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _classnames2.default)('btn-action btn-move right mt30', { 'btn-loading-inline': this.state.loadingXLD }, { 'btn-disable': this.state.loadingSave }), onClick: this.chuyenXuLyDon.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n x\u1EED l\xFD \u0111\u01A1n'
                      )
                    ) : null,
                    this.state.huongXuLy == 'YEU_CAU_GAP_LANH_DAO' && !this.state.dataView.yeuCauGapTrucTiepLanhDao ? _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _classnames2.default)('btn-action btn-complete right', { 'btn-loading-inline': this.state.loadingXLD }, { 'btn-disable': this.state.loadingSave }), onClick: this.chuyenYeuCau.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n y\xEAu c\u1EA7u'
                      )
                    ) : '',
                    this.state.huongXuLy != 'TIEP_NHAN_DON' && this.state.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy != 'BO_SUNG_THONG_TIN' && this.state.huongXuLy != '' && this.state.huongXuLy != 'CHO_GIAI_QUYET' && this.props.route.type == 'lanhDao' ? _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _classnames2.default)('btn-action btn-complete right', { 'btn-loading-inline': this.state.loadingXLD }, { 'btn-disable': this.state.loadingSave }), onClick: this.hoanThanhDon.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'L\u01B0u h\u1ED3 s\u01A1'
                      )
                    ) : null,
                    this.state.huongXuLy != 'TIEP_NHAN_DON' && this.state.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy != 'BO_SUNG_THONG_TIN' && this.state.huongXuLy != '' && this.state.huongXuLy != 'CHO_GIAI_QUYET' && this.props.route.type == 'thuongXuyen' ? _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _classnames2.default)('btn-action btn-complete right', { 'btn-loading-inline': this.state.loadingXLD }, { 'btn-disable': this.state.loadingSave }), onClick: this.luuLuotTiep.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'L\u01B0u l\u01B0\u1EE3t ti\u1EBFp'
                      )
                    ) : null,
                    this.state.huongXuLy == 'CHO_GIAI_QUYET' ? _react2.default.createElement(
                      _reactRouter.Link,
                      { className: (0, _classnames2.default)('btn-action btn-complete right', { 'btn-loading-inline': this.state.loadingXLD }, { 'btn-disable': this.state.loadingSave }), onClick: this.chuyenKiemTraDeXuat.bind(this) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Chuy\u1EC3n ki\u1EC3m tra \u0111\u1EC1 xu\u1EA5t'
                      )
                    ) : null
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddReception;
}(_react2.default.Component);

AddReception.defaultProps = {
  validators: {},
  donViHanhChinh: [],
  donViChuTri: []
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    donViHanhChinh: state.duLieuHeThong.donViHanhChinh,
    donViChuTri: state.duLieuHeThong.donViChuTri,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId,
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(AddReception);

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _add = __webpack_require__(317);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListGroupTypeReception = function (_React$Component) {
  _inherits(ListGroupTypeReception, _React$Component);

  function ListGroupTypeReception(props, context) {
    _classCallCheck(this, ListGroupTypeReception);

    var _this = _possibleConstructorReturn(this, (ListGroupTypeReception.__proto__ || Object.getPrototypeOf(ListGroupTypeReception)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(ListGroupTypeReception, [{
    key: 'addItem',
    value: function addItem() {
      var arrLength = this.state.data.length;
      if (arrLength == 0 || arrLength > 0 && this.state.data[arrLength - 1].hoVaTen != '') {
        this.state.data[this.state.data.length] = {
          hoVaTen: '',
          cmndHoChieu: '',
          diaChi: '',
          soDienThoai: '',
          doanDiCungId: ''
        };
        this.setState({
          data: this.state.data
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.data.donCuId || this.props.data.donId && this.props.data.listDoanDiCung) {
        this.state.data = this.props.data.listDoanDiCung;
        this.setState(_extends({}, this.state));
      }
      this.addItem();
    }
  }, {
    key: 'onChange',
    value: function onChange(index, data) {
      this.state.data[index] = data;
      this.setState({
        data: this.state.data
      });
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index) {
      var Array = this.state.data;
      this.props.onRemove('DOAN_DI_CUNG', Array[index]);
      Array.splice(index, 1);
      this.props.data.doanDongNguoi = Array;
      this.setState({
        data: Array
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = [];
      this.state.data.map(function (item, i) {
        item.type = 'doanDongNguoi';
        data.push(item);
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-6' },
              _react2.default.createElement(
                'h3',
                null,
                'Danh s\xE1ch \u0111o\xE0n \u0111i c\xF9ng'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form  inline-bottom' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12 row-center' },
              _react2.default.createElement(
                _dataTable2.default,
                { header: _table.header.addReception.groupMember, dataList: data, hidePagination: true, parent: this },
                _react2.default.createElement(_add.RowItemListGroupTypeReception, null)
              )
            )
          )
        )
      );
    }
  }]);

  return ListGroupTypeReception;
}(_react2.default.Component);

exports.default = ListGroupTypeReception;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _detail = __webpack_require__(238);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _dialog = __webpack_require__(18);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Promise = __webpack_require__(136).Promise;

var ListInfoDocumentDialog = function (_React$Component) {
  _inherits(ListInfoDocumentDialog, _React$Component);

  function ListInfoDocumentDialog(props, context) {
    _classCallCheck(this, ListInfoDocumentDialog);

    var _this = _possibleConstructorReturn(this, (ListInfoDocumentDialog.__proto__ || Object.getPrototypeOf(ListInfoDocumentDialog)).call(this, props, context));

    _this.state = {
      pageData: {
        number: 0,
        size: 10
      },
      data: [],
      congDanInfo: {},
      DanhSachDonCongDan: [],
      DanhSachTam: [],
      DanhSachDonCDId: [],
      itemNews: [],
      DanhSachDonCuCDId: []
    };
    return _this;
  }

  _createClass(ListInfoDocumentDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen != this.props.isOpen) {
        if (nextProps.isOpen) {
          this.getCongDanId(nextProps.congDanId);
          this.getDanhSachDonCD(nextProps.congDanId);
        }
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(index) {
      this.state.DanhSachDonCDId.map(function (item, i) {
        if (i == index) {
          item.isCollapse = !item.isCollapse;
        } else {
          item.isCollapse = false;
        }
      });
      this.setState({ DanhSachDonCDId: this.state.DanhSachDonCDId });
    }
  }, {
    key: 'getCongDanId',
    value: function getCongDanId(cdId) {
      var _this2 = this;

      _api.Reception.actions.getcongDan.request({ id: cdId }).then(function (res) {
        if (res.data) {
          _this2.setState({ congDanInfo: res.data });
        }
      });
    }
  }, {
    key: 'chonCongDan',
    value: function chonCongDan(item) {
      this.props.self.hasChange = true;
      this.props.dispatch({
        type: 'CHON_CONG_DAN',
        data: item,
        index: this.props.index
      });
      this.props.dispatch({
        type: 'DISPLAY_FIELD',
        value: true
      });
    }
  }, {
    key: 'layThongTinHoSo',
    value: function layThongTinHoSo(item, congdanInfo) {
      this.chonCongDan(congdanInfo);
      this.props.self.hasChange = true;
      this.props.dispatch({
        type: 'CHON_DON_THU',
        data: item
      });
    }
  }, {
    key: 'getDanhSachDonCD',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(cdId) {
        var _this3 = this;

        var DanhSachDonCuCDId, DanhSachDonCDId;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                DanhSachDonCuCDId = [];
                DanhSachDonCDId = [];
                _context6.next = 4;
                return _api.Reception.actions.getDanhSachDonCuCDId.request({ id: cdId }).then(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    var data;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!res.data._embedded) {
                              _context3.next = 5;
                              break;
                            }

                            data = res.data._embedded.donCus;
                            _context3.next = 4;
                            return Promise.all(data.map(function () {
                              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, i) {
                                var newItem;
                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        newItem = _extends({}, item);
                                        _context2.next = 3;
                                        return _api.Reception.actions.getDonCuInfo.request({ id: item.donCuId }).then(function () {
                                          var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(info) {
                                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                              while (1) {
                                                switch (_context.prev = _context.next) {
                                                  case 0:
                                                    if (info.data) {
                                                      newItem = _extends({}, newItem, info.data);
                                                      if (newItem.listTaiLieuBangChung) {
                                                        newItem.listTaiLieuBangChung = newItem.listTaiLieuBangChung.map(function (subItem) {
                                                          if (subItem && subItem.taiLieuBangChungId) {
                                                            delete subItem.taiLieuBangChungId;
                                                          }
                                                          return subItem;
                                                        });
                                                      }
                                                    }

                                                  case 1:
                                                  case 'end':
                                                    return _context.stop();
                                                }
                                              }
                                            }, _callee, _this3);
                                          }));

                                          return function (_x5) {
                                            return _ref4.apply(this, arguments);
                                          };
                                        }());

                                      case 3:
                                        return _context2.abrupt('return', newItem);

                                      case 4:
                                      case 'end':
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, _this3);
                              }));

                              return function (_x3, _x4) {
                                return _ref3.apply(this, arguments);
                              };
                            }()));

                          case 4:
                            DanhSachDonCuCDId = _context3.sent;

                          case 5:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
                _context6.next = 6;
                return _api.Reception.actions.getDanhSachDonCDId.request({ id: cdId }).then(function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
                    var data;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!res.data._embedded) {
                              _context5.next = 5;
                              break;
                            }

                            data = res.data._embedded.dons;
                            _context5.next = 4;
                            return Promise.all(data.map(function () {
                              var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(item, i) {
                                var newItem;
                                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        newItem = _extends({}, item);

                                        newItem.isCollapse = false;
                                        if (i === 0) {
                                          newItem.isCollapse = true;
                                        }
                                        _context4.next = 5;
                                        return _api.Reception.actions.getDonInfo.request({ id: item.donId }).then(function (info) {
                                          if (info.data) {
                                            newItem = _extends({}, newItem, info.data);
                                            if (newItem.listTaiLieuBangChung) {
                                              newItem.listTaiLieuBangChung = newItem.listTaiLieuBangChung.map(function (subItem) {
                                                if (subItem && subItem.taiLieuBangChungId) {
                                                  delete subItem.taiLieuBangChungId;
                                                }
                                                return subItem;
                                              });
                                            }
                                            if (newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet) {
                                              newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet = newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.map(function (subItem) {
                                                if (subItem && subItem.taiLieuBangChungId) {
                                                  delete subItem.taiLieuVanThuId;
                                                }
                                                return subItem;
                                              });
                                            }
                                          }
                                        });

                                      case 5:
                                        return _context4.abrupt('return', newItem);

                                      case 6:
                                      case 'end':
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4, _this3);
                              }));

                              return function (_x7, _x8) {
                                return _ref6.apply(this, arguments);
                              };
                            }()));

                          case 4:
                            DanhSachDonCDId = _context5.sent;

                          case 5:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x6) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 6:
                this.setState({ DanhSachDonCDId: DanhSachDonCDId, DanhSachDonCuCDId: DanhSachDonCuCDId });

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getDanhSachDonCD(_x) {
        return _ref.apply(this, arguments);
      }

      return getDanhSachDonCD;
    }()
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.dispatch({
        type: 'TOGGLE_DIALOG',
        data: {
          name: 'PopupChiTietCongDan',
          status: false
        },
        index: this.props.index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var DanhSachDonCongDan = this.state.DanhSachDonCDId.map(function (item, i) {
        return _react2.default.createElement(
          'div',
          { className: 'box-forward mb20', key: i },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'block-search-name' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: item.isCollapse ? "items-form header-redirect" : "items-form  header-redirect header-open" },
                  _react2.default.createElement(
                    'div',
                    { className: 'row-col' },
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col pl20 pr0 flex-column' },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold' },
                          'M\xE3 \u0111\u01A1n'
                        ),
                        item.maHoSo
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold' },
                        'Ng\xE0y ti\u1EBFp'
                      ),
                      item.ngayTiepNhan ? (0, _moment2.default)(item.ngayTiepNhan).format('DD/MM/YYYY') : ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold' },
                        'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt'
                      ),
                      item.coQuanDaGiaiQuyetDonThu || ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold' },
                        'C\u01A1 quan \u0111ang gi\u1EA3i quy\u1EBFt'
                      ),
                      item.coQuanDangQuyetInfo ? item.coQuanDangQuyetInfo.ten : ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold' },
                        'Tr\u1EA1ng th\xE1i x\u1EED l\xFD'
                      ),
                      item.trangThaiDonGiaiQuyetText ? item.trangThaiDonGiaiQuyetText : ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(_dialog.HistoryDialog, { donId: item.donId })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'header-col' },
                      _react2.default.createElement(_core.Button, { onClick: _this4.handleClick.bind(_this4, i), className: item.isCollapse ? "btn-collap active" : "btn-collap" })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: item.isCollapse },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-items' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Th\xF4ng tin \u0111\u01A1n'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'Lo\u1EA1i \u0111\u01A1n th\u01B0:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.loaiDonInfo ? item.loaiDonInfo.ten : ''
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: item.loaiDon === "DON_KHIEU_NAI" },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'span',
                            { className: 'val-title-bold' },
                            'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'val-content' },
                            item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: item.loaiDon === "DON_TO_CAO" },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'span',
                            { className: 'val-title-bold' },
                            'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng b\u1ECB t\u1ED1 c\xE1o:'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'val-content' },
                            item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'L\u0129nh v\u1EF1c:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.linhVucDonThuDon ? item.linhVucDonThuDon.ten : ''
                        )
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: item && item.linhVucDonThuChiTietDon !== null },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'span',
                            { className: 'val-title-bold' },
                            'L\u0129nh v\u1EF1c chi ti\u1EBFt:'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: (0, _classnames2.default)('val-content', { 'arrow-to-dispute': item.chiTietLinhVucDonThuChiTietDon }) },
                            item.linhVucDonThuChiTietDon ? item.linhVucDonThuChiTietDon.ten : ''
                          )
                        )
                      ),
                      item.chiTietLinhVucDonThuChiTietDon && _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          '\xA0\xA0\xA0'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.chiTietLinhVucDonThuChiTietDon ? item.chiTietLinhVucDonThuChiTietDon.ten : ''
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)({
                    'wrap-items pt10': item.isCollapse,
                    'wrap-items-content': !item.isCollapse
                  }) },
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.noiDung
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: item.isCollapse },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-items' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'Danh s\xE1ch t\xE0i li\u1EC7u'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'pl5 pr5' },
                    _react2.default.createElement(
                      _dataTable2.default,
                      {
                        header: _table.header.addReception.boSungTaiLieu,
                        dataList: item.listTaiLieuBangChung,
                        hidePagination: true,
                        pageData: _this4.state.pageData },
                      _react2.default.createElement(_detail.RowItemDocumentDetail, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl5 pr5 pt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  )
                ),
                item.thongTinGiaiQuyetDonInfo && item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo ? _react2.default.createElement(
                  'div',
                  { className: 'wrap-items' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                          'h3',
                          null,
                          'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows mb10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-25' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'C\u01A1 quan gi\u1EA3i quy\u1EBFt:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-25' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'S\u1ED1 v\u0103n b\u1EA3n:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.thongTinGiaiQuyetDonInfo.soVanBan
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-25' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'Ng\xE0y ban h\xE0nh:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.thongTinGiaiQuyetDonInfo.ngayBanHanh ? (0, _moment2.default)(item.thongTinGiaiQuyetDonInfo.ngayBanHanh).format('DD/MM/YYYY') : ''
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-25' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'Ng\u01B0\u1EDDi ban h\xE0nh:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo ? item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo.hoVaTen : ''
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'pl5 pr5' },
                    _react2.default.createElement(
                      _dataTable2.default,
                      {
                        header: _table.header.addReception.boSungTaiLieu,
                        dataList: item.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ,
                        hidePagination: true,
                        pageData: _this4.state.pageData
                      },
                      _react2.default.createElement(_detail.RowItemDocumentDetail, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl5 pr5 pt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  )
                ) : ''
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom mt15 mb15' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: _this4.layThongTinHoSo.bind(_this4, item, _this4.state.congDanInfo), className: 'btn-action btn-check-file', role: 'button' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u1EA5y th\xF4ng tin h\u1ED3 s\u01A1 v\u1EE5 vi\u1EC7c'
                  )
                )
              )
            )
          )
        );
      });
      var DanhSachDonCuCongDan = this.state.DanhSachDonCuCDId.map(function (item, i) {
        return _react2.default.createElement(
          'div',
          { className: 'box-forward mb20', key: i },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'block-search-name' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-items' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Th\xF4ng tin \u0111\u01A1n'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-input' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'Lo\u1EA1i \u0111\u01A1n th\u01B0:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.loaiDonInfo ? item.loaiDonInfo.ten : ''
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: item.loaiDon === "DON_KHIEU_NAI" },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: item.loaiDon === "DON_TO_CAO" },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng b\u1ECB t\u1ED1 c\xE1o:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'val-content' },
                          item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-input' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'L\u0129nh v\u1EF1c:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.linhVucDonThuDon ? item.linhVucDonThuDon.ten : ''
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: item && item.linhVucDonThuChiTietDon !== null },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-input' },
                        _react2.default.createElement(
                          'span',
                          { className: 'val-title-bold' },
                          'L\u0129nh v\u1EF1c chi ti\u1EBFt:'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: (0, _classnames2.default)('val-content', { 'arrow-to-dispute': item.chiTietLinhVucDonThuChiTietDon }) },
                          item.linhVucDonThuChiTietDon ? item.linhVucDonThuChiTietDon.ten : ''
                        )
                      )
                    ),
                    item.chiTietLinhVucDonThuChiTietDon && _react2.default.createElement(
                      'div',
                      { className: 'col-input' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        '\xA0\xA0\xA0'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.chiTietLinhVucDonThuChiTietDon ? item.chiTietLinhVucDonThuChiTietDon.ten : ''
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)({
                    'wrap-items pt10': item.isCollapse,
                    'wrap-items-content': !item.isCollapse
                  }) },
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'T\xF3m t\u1EAFt n\u1ED9i dung \u0111\u01A1n th\u01B0:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.noiDung
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap-items' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Danh s\xE1ch t\xE0i li\u1EC7u'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pl5 pr5' },
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.addReception.boSungTaiLieu,
                      dataList: item.listTaiLieuBangChung,
                      hidePagination: true,
                      pageData: _this4.state.pageData },
                    _react2.default.createElement(_detail.RowItemDocumentDetail, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl5 pr5 pt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                )
              ),
              item.thongTinGiaiQuyetDonInfo && item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo && _react2.default.createElement(
                'div',
                { className: 'wrap-items' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        null,
                        'K\u1EBFt qu\u1EA3 gi\u1EA3i quy\u1EBFt'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'items-form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows mb10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'S\u1ED1 v\u0103n b\u1EA3n:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.thongTinGiaiQuyetDonInfo.soVanBan
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'Ng\xE0y ban h\xE0nh:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.thongTinGiaiQuyetDonInfo.ngayBanHanh ? (0, _moment2.default)(item.thongTinGiaiQuyetDonInfo.ngayBanHanh).format('DD/MM/YYYY') : ''
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25' },
                      _react2.default.createElement(
                        'span',
                        { className: 'val-title-bold' },
                        'Ng\u01B0\u1EDDi ban h\xE0nh:'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'val-content' },
                        item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo ? item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo.hoVaTen : ''
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl5 pr5 pt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom mt15 mb15' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { onClick: _this4.layThongTinHoSo.bind(_this4, item, _this4.state.congDanInfo), className: 'btn-action btn-check-file', role: 'button' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u1EA5y th\xF4ng tin h\u1ED3 s\u01A1 v\u1EE5 vi\u1EC7c'
                  )
                )
              )
            )
          )
        );
      });
      return _react2.default.createElement(
        _core.Dialog,
        { className: 'panel-popup', inline: false, isOpen: this.props.isOpen, onClose: this.closeDialog.bind(this), title: 'K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm' },
        _react2.default.createElement(
          'div',
          { className: 'panel-page', id: 'page_result_search' },
          _react2.default.createElement(
            'div',
            { className: 'main_page' },
            _react2.default.createElement(
              'div',
              { className: 'box-content mb20' },
              _react2.default.createElement(
                'div',
                { className: 'box-forward' },
                _react2.default.createElement(
                  'div',
                  { className: 'container-box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-items style-box-top' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12' },
                          _react2.default.createElement(
                            'h3',
                            null,
                            'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-12 mb15' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-inline-bold mr5' },
                            'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng: '
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'val-content-inline' },
                            'C\xE1 nh\xE2n'
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows mb10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'H\u1ECD v\xE0 t\xEAn:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.hoVaTen
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'Ng\xE0y sinh:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.ngaySinh ? (0, _moment2.default)(this.state.congDanInfo.ngaySinh).format('DD/MM/YYYY') : ''
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.soDienThoai
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'Gi\u1EDBi T\xEDnh:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.gioiTinh ? 'Nam' : 'Nữ'
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows mb10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.soCMNDHoChieu
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'N\u01A1i c\u1EA5p:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.noiCapCMNDInfo ? this.state.congDanInfo.noiCapCMNDInfo.ten : ''
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'Ng\xE0y c\u1EA5p:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.ngayCap ? (0, _moment2.default)(this.state.congDanInfo.ngayCap).format('DD/MM/YYYY') : ''
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'D\xE2n t\u1ED9c:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.danTocCongDan ? this.state.congDanInfo.danTocCongDan.ten : ''
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'Qu\u1ED1c t\u1ECBch:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.quocTichCongDan ? this.state.congDanInfo.quocTichCongDan.ten : ''
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows mb10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'col-input' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            'T\u1EC9nh:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.tinhThanhCongDan ? this.state.congDanInfo.tinhThanhCongDan.ten : ''
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.congDanInfo.quanHuyenCongDan != null || this.state.congDanInfo.phuongXaCongDan != null || this.state.congDanInfo.toThon != '' && this.state.congDanInfo.toThon != null },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-input' },
                            _react2.default.createElement(
                              'label',
                              { className: 'val-title-bold' },
                              'Qu\u1EADn/Huy\u1EC7n:'
                            ),
                            _react2.default.createElement(
                              'p',
                              { className: 'val-content' },
                              this.state.congDanInfo.quanHuyenCongDan ? this.state.congDanInfo.quanHuyenCongDan.ten : ''
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'col-input' },
                            _react2.default.createElement(
                              'label',
                              { className: 'val-title-bold' },
                              'Ph\u01B0\u1EDDng/X\xE3:'
                            ),
                            _react2.default.createElement(
                              'p',
                              { className: 'val-content' },
                              this.state.congDanInfo.phuongXaCongDan ? this.state.congDanInfo.phuongXaCongDan.ten : ''
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'col-w40' },
                          _react2.default.createElement(
                            'label',
                            { className: 'val-title-bold' },
                            '\u0110\u1ECBa ch\u1EC9:'
                          ),
                          _react2.default.createElement(
                            'p',
                            { className: 'val-content' },
                            this.state.congDanInfo.diaChi
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mb5', style: { marginTop: '15px' } },
                _react2.default.createElement(
                  'div',
                  { className: 'box-bottom' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { onClick: this.chonCongDan.bind(this, this.state.congDanInfo), className: 'btn-action btn-check-file', role: 'button' },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u1EA5y th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15 pt5' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-content box-items none-boder-bt' },
              _react2.default.createElement(
                'div',
                { className: 'heading-box-show' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      this.state.DanhSachDonCDId.length + this.state.DanhSachDonCuCDId.length,
                      ' h\u1ED3 s\u01A1 v\u1EE5 vi\u1EC7c'
                    )
                  )
                )
              ),
              DanhSachDonCongDan,
              DanhSachDonCuCongDan
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ListInfoDocumentDialog;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    isOpen: state.formDataTiepCongDan.PopupChiTietCongDan,
    congDanId: state.formDataTiepCongDan.viewDetailCongDanId,
    loaiDonThuData: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuongData: state.duLieuHeThong.loaiDoiTuong,
    index: state.formDataTiepCongDan.index
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ListInfoDocumentDialog);

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _add = __webpack_require__(317);

var _table = __webpack_require__(12);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFullNamePopup = function (_React$Component) {
  _inherits(SearchFullNamePopup, _React$Component);

  function SearchFullNamePopup(props, context) {
    _classCallCheck(this, SearchFullNamePopup);

    var _this = _possibleConstructorReturn(this, (SearchFullNamePopup.__proto__ || Object.getPrototypeOf(SearchFullNamePopup)).call(this, props, context));

    _this.state = {
      pageData: {
        number: 0,
        size: 10
      },
      isOpen: false,
      tuKhoa: '',
      soCMNND: '',
      diaChi: '',
      loading: false,
      dataList: []
    };
    return _this;
  }

  _createClass(SearchFullNamePopup, [{
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.dispatch({
        type: 'TOGGLE_DIALOG',
        data: {
          name: 'PopupViewAllResult',
          status: false
        }
      });
      this.props.dispatch({
        type: 'DISPLAY_FORM',
        value: false
      });
      this.state.pageData.size = 10;
      this.state.pageData.number = 0;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.isViewAll != this.props.isViewAll) {
        this.setState({
          isOpen: nextProps.isViewAll,
          tuKhoa: nextProps.tuKhoa
        }, function () {
          if (nextProps.isViewAll) {
            _this2.state.pageData.size = 10;
            _this2.state.pageData.number = 0;
            _this2.timKiemCongDan();
          }
        });
      }
    }
  }, {
    key: 'timKiemCongDan',
    value: function timKiemCongDan() {
      var _this3 = this;

      this.setState({
        loading: true
      });
      var inputParams = {
        size: this.state.pageData.size,
        page: this.state.pageData.number
      };
      if (this.state.tuKhoa) {
        inputParams.tuKhoa = this.state.tuKhoa;
      }
      if (this.state.soCMNND) {
        inputParams.soCMNND = this.state.soCMNND;
      }
      if (this.state.diaChi) {
        inputParams.diaChi = this.state.diaChi;
      }
      _api.Reception.actions.searchCongDan.request('', inputParams).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({
            dataList: res.data._embedded.congDans,
            pageData: res.data.page
          });
          _this3.props.dispatch({
            type: 'DISPLAY_FORM',
            value: false
          });
        } else {
          _this3.setState({
            dataList: [],
            pageData: {
              number: 0,
              size: 10
            }
          });
        }
        _this3.setState({
          loading: false
        });
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.timKiemCongDan();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.timKiemCongDan();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        { className: 'panel-popup dialog-search-result', inline: false, isOpen: this.state.isOpen, onClose: this.closeDialog.bind(this), title: 'Danh s\xE1ch k\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm' },
        _react2.default.createElement(
          'div',
          { className: 'pt-dialog-body' },
          _react2.default.createElement(
            'div',
            { id: 'list-people-search', className: 'search-name-container' },
            _react2.default.createElement(
              'form',
              { className: 'items-form', onSubmit: this.timKiemCongDan.bind(this), action: 'javascript:void(0)' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Input, { label: 'H\u1ECD v\xE0 t\xEAn', className: 'col-w22', maxLength: 40, value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa') }),
                _react2.default.createElement(_common.Input, { label: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu', className: 'col-w22', type: 'cmnd', maxLength: 10, value: this.state.soCMNND, onChange: this.onChange.bind(this, 'soCMNND') }),
                _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa ch\u1EC9', className: 'col-w39', maxLength: 70, value: this.state.diaChi, onChange: this.onChange.bind(this, 'diaChi') }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-2' },
                  _react2.default.createElement(
                    'label',
                    { className: 'seacrh-people' },
                    _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-search', text: 'T\xECm ki\u1EBFm' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.addReception.searchName,
                dataList: this.state.dataList,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                tableLoading: this.state.loading },
              _react2.default.createElement(_add.RowItemListSearchPeople, { self: this.props.self })
            )
          )
        )
      );
    }
  }]);

  return SearchFullNamePopup;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    isViewAll: state.formDataTiepCongDan.PopupViewAllResult,
    tuKhoa: state.formDataTiepCongDan.tuKhoa,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(SearchFullNamePopup);

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _add = __webpack_require__(317);

var _table = __webpack_require__(12);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinCoQuanTiepDan = function (_React$Component) {
  _inherits(ThongTinCoQuanTiepDan, _React$Component);

  function ThongTinCoQuanTiepDan(props, context) {
    _classCallCheck(this, ThongTinCoQuanTiepDan);

    var _this = _possibleConstructorReturn(this, (ThongTinCoQuanTiepDan.__proto__ || Object.getPrototypeOf(ThongTinCoQuanTiepDan)).call(this, props, context));

    _this.state = {
      dsCoQuanToChucTiepDan: []
    };
    return _this;
  }

  _createClass(ThongTinCoQuanTiepDan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.soTiepCongDan != this.props.soTiepCongDan) {
        var data = nextProps.soTiepCongDan;
        data.coQuanToChucTiepDanSTCD.map(function (item, i) {
          _this2.state.dsCoQuanToChucTiepDan[i] = {
            coQuanToChucTiepDanId: item.coQuanToChucTiepDanId,
            ten: item.coQuanDonViInfo.coQuanQuanLyId,
            chucVu: item.chucVu,
            nguoiDaiDien: item.nguoiDaiDien
          };
        });

        this.setState(_extends({}, this.state));
        this.props.onInit(this.state);
      }
    }
  }, {
    key: 'addDsCoQuanCungTiepDan',
    value: function addDsCoQuanCungTiepDan() {
      var arrLength = this.state.dsCoQuanToChucTiepDan.length;
      if (arrLength == 0 || arrLength > 0 && this.state.dsCoQuanToChucTiepDan[arrLength - 1].ten != '') {
        this.state.dsCoQuanToChucTiepDan[this.state.dsCoQuanToChucTiepDan.length] = {
          coQuanToChucTiepDanId: 0,
          ten: null,
          nguoiDaiDien: '',
          chucVu: ''
        };
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChangeTable',
    value: function onChangeTable(data, index) {
      this.state.dsCoQuanToChucTiepDan[index] = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'onRemoveItem',
    value: function onRemoveItem(index) {
      this.state.dsCoQuanToChucTiepDan.splice(index, 1);
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items pb15' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'container-box' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Danh s\xE1ch c\u01A1 quan, c\xE1c \u0111\u01A1n v\u1ECB c\xF9ng tham gia ti\u1EBFp c\xF4ng d\xE2n'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-12 row-center' },
                    _react2.default.createElement(
                      _dataTable2.default,
                      {
                        header: _table.header.receptionPeriodical.add,
                        dataList: this.state.dsCoQuanToChucTiepDan,
                        hidePagination: true,
                        hideExport: true,
                        showAddMore: true,
                        addMore: this.addDsCoQuanCungTiepDan.bind(this),
                        tableLoading: false },
                      _react2.default.createElement(_add.RowItemCoQuanTiepDan, { onChange: this.onChangeTable.bind(this),
                        bindValidator: this,
                        onRemove: this.onRemoveItem.bind(this) })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinCoQuanTiepDan;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(ThongTinCoQuanTiepDan));

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThongTinNguoiDungDon = exports.ThongTinDon = exports.ListGroupTypeReception = exports.SearchFullNamePopup = exports.ListInfoDocumentDialog = exports.AddReception = undefined;

var _AddReception = __webpack_require__(1294);

var _AddReception2 = _interopRequireDefault(_AddReception);

var _ListInfoDocumentDialog = __webpack_require__(1296);

var _ListInfoDocumentDialog2 = _interopRequireDefault(_ListInfoDocumentDialog);

var _SearchFullNamePopup = __webpack_require__(1297);

var _SearchFullNamePopup2 = _interopRequireDefault(_SearchFullNamePopup);

var _ListGroupTypeReception = __webpack_require__(1295);

var _ListGroupTypeReception2 = _interopRequireDefault(_ListGroupTypeReception);

var _ThongTinDon = __webpack_require__(489);

var _ThongTinDon2 = _interopRequireDefault(_ThongTinDon);

var _ThongTinNguoiDungDon = __webpack_require__(490);

var _ThongTinNguoiDungDon2 = _interopRequireDefault(_ThongTinNguoiDungDon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddReception = _AddReception2.default;
exports.ListInfoDocumentDialog = _ListInfoDocumentDialog2.default;
exports.SearchFullNamePopup = _SearchFullNamePopup2.default;
exports.ListGroupTypeReception = _ListGroupTypeReception2.default;
exports.ThongTinDon = _ThongTinDon2.default;
exports.ThongTinNguoiDungDon = _ThongTinNguoiDungDon2.default;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCoQuanTiepDan = function (_React$Component) {
  _inherits(RowItemCoQuanTiepDan, _React$Component);

  function RowItemCoQuanTiepDan(props, context) {
    _classCallCheck(this, RowItemCoQuanTiepDan);

    var _this = _possibleConstructorReturn(this, (RowItemCoQuanTiepDan.__proto__ || Object.getPrototypeOf(RowItemCoQuanTiepDan)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(RowItemCoQuanTiepDan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getCoQuanTiepDan.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'coQuanTiepDanList',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var newData = {
        coQuanToChucTiepDanId: this.props.item.coQuanToChucTiepDanId,
        ten: this.props.item.ten,
        nguoiDaiDien: this.props.item.nguoiDaiDien,
        chucVu: this.props.item.chucVu
      };
      newData[name] = e.target.value || '';
      this.props.onChange(newData, this.props.count - 1);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove() {
      this.props.onRemove(this.props.count - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { width: 45, minWidth: 45, maxWidth: 45, padding: 10 } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 300, minWidth: 300, maxWidth: 250, padding: 10 } },
          _react2.default.createElement(_common.DropDownTreeSelectOneElement, { className: 'col-100 mb0-18', bindValidator: this, channel: 'formTaoDon', placeholder: true, require: true, dataOptions: this.state.data, value: this.props.item.ten, onChange: this.onChange.bind(this, 'ten'), propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 200, padding: 10 } },
          _react2.default.createElement(_common.Input, { className: 'col-100 mb0-18', value: this.props.item.nguoiDaiDien, onChange: this.onChange.bind(this, 'nguoiDaiDien') })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 200, padding: 10 } },
          _react2.default.createElement(_common.Input, { className: 'col-100 mb0-18', value: this.props.item.chucVu, onChange: this.onChange.bind(this, 'chucVu') })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 110, textAlign: 'left' } },
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap' },
            _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xác nhận',
              content: 'Bạn chắc chắn muốn xoá cơ quan này?',
              onSuccess: this.handleRemove.bind(this)
            })
          )
        )
      );
    }
  }]);

  return RowItemCoQuanTiepDan;
}(_react2.default.Component);

RowItemCoQuanTiepDan.defaultProps = {
  item: {
    ten: '',
    nguoiDaiDien: '',
    chucVu: ''
  },
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanTiepDanList
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(RowItemCoQuanTiepDan));

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDocumentDetail = function (_React$Component) {
  _inherits(RowItemDocumentDetail, _React$Component);

  function RowItemDocumentDetail() {
    _classCallCheck(this, RowItemDocumentDetail);

    return _possibleConstructorReturn(this, (RowItemDocumentDetail.__proto__ || Object.getPrototypeOf(RowItemDocumentDetail)).apply(this, arguments));
  }

  _createClass(RowItemDocumentDetail, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.documentname
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.countpage
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.doucmenttype
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            null,
            this.props.item.fileattach
          )
        )
      );
    }
  }]);

  return RowItemDocumentDetail;
}(_react2.default.Component);

exports.default = RowItemDocumentDetail;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListDocumentSearchPopup = function (_React$Component) {
  _inherits(RowItemListDocumentSearchPopup, _React$Component);

  function RowItemListDocumentSearchPopup() {
    _classCallCheck(this, RowItemListDocumentSearchPopup);

    return _possibleConstructorReturn(this, (RowItemListDocumentSearchPopup.__proto__ || Object.getPrototypeOf(RowItemListDocumentSearchPopup)).apply(this, arguments));
  }

  _createClass(RowItemListDocumentSearchPopup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soTrang
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.loaiTaiLieuTLBC.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tinhTrangTaiLieu
        ),
        _react2.default.createElement(
          'td',
          { className: 'none-boder underline-name' },
          _react2.default.createElement(
            _reactRouter.Link,
            null,
            this.props.item.fileattach
          )
        )
      );
    }
  }]);

  return RowItemListDocumentSearchPopup;
}(_react2.default.Component);

exports.default = RowItemListDocumentSearchPopup;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _validate = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListGroupTypeReception = function (_React$Component) {
  _inherits(RowItemListGroupTypeReception, _React$Component);

  function RowItemListGroupTypeReception(props, context) {
    _classCallCheck(this, RowItemListGroupTypeReception);

    var _this = _possibleConstructorReturn(this, (RowItemListGroupTypeReception.__proto__ || Object.getPrototypeOf(RowItemListGroupTypeReception)).call(this, props, context));

    _this.state = {
      hoVaTen: _this.props.item.hoVaTen,
      cmndHoChieu: _this.props.item.cmndHoChieu,
      diaChi: _this.props.item.diaChi,
      soDienThoai: _this.props.item.soDienThoai,
      doanDiCungId: _this.props.item.doanDiCungId
    };
    return _this;
  }

  _createClass(RowItemListGroupTypeReception, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        hoVaTen: nextProps.item.hoVaTen,
        cmndHoChieu: nextProps.item.cmndHoChieu,
        diaChi: nextProps.item.diaChi,
        soDienThoai: nextProps.item.soDienThoai,
        doanDiCungId: this.props.item.doanDiCungId
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, type, e) {
      if (type == 'sdt') {
        e = (0, _validate.PhoneNumber)(e);
      }
      if (type == 'cmnd') {
        e = (0, _validate.CMNDNumber)(e);
      }
      this.state[name] = e;
      this.setState(_extends({}, this.state));
      this.props.parent.onChange(this.props.count - 1, this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { width: 45, minWidth: 45, maxWidth: 45, textAlign: 'center' } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 185, minWidth: 185, maxWidth: 185 } },
          _react2.default.createElement(_core.EditableText, {
            placeholder: 'H\u1ECD v\xE0 t\xEAn...', value: this.state.hoVaTen, maxLength: 40,
            onConfirm: this.props.parent.addItem.bind(this.props.parent),
            onChange: this.onChange.bind(this, 'hoVaTen', '')
          })
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 145, minWidth: 145, maxWidth: 145 } },
          _react2.default.createElement(_core.EditableText, {
            placeholder: 'S\u1ED1 CMND/ H\u1ED9 chi\u1EBFu...', value: this.state.cmndHoChieu, maxLength: 10,
            onChange: this.onChange.bind(this, 'cmndHoChieu', 'cmnd')
          })
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 340, minWidth: 340, maxWidth: 340 } },
          _react2.default.createElement(_core.EditableText, {
            placeholder: '\u0110\u1ECBa ch\u1EC9...', maxLength: 70, value: this.state.diaChi,
            onChange: this.onChange.bind(this, 'diaChi', '')
          })
        ),
        _react2.default.createElement(
          'td',
          { style: { width: 160, minWidth: 160, maxWidth: 160 } },
          _react2.default.createElement(_core.EditableText, {
            placeholder: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i...', value: this.state.soDienThoai, maxLength: 15,
            onChange: this.onChange.bind(this, 'soDienThoai', 'sdt')
          })
        ),
        _react2.default.createElement(
          'td',
          { style: { minWidth: 110 } },
          this.state.hoVaTen ? _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-delete', onClick: this.props.parent.handleRemove.bind(this.props.parent, this.props.count - 1) },
              'X\xF3a'
            )
          ) : null
        )
      );
    }
  }]);

  return RowItemListGroupTypeReception;
}(_react2.default.Component);

exports.default = RowItemListGroupTypeReception;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListSearchPeople = function (_React$Component) {
  _inherits(RowItemListSearchPeople, _React$Component);

  function RowItemListSearchPeople() {
    _classCallCheck(this, RowItemListSearchPeople);

    return _possibleConstructorReturn(this, (RowItemListSearchPeople.__proto__ || Object.getPrototypeOf(RowItemListSearchPeople)).apply(this, arguments));
  }

  _createClass(RowItemListSearchPeople, [{
    key: 'chonCongDan',
    value: function chonCongDan(item) {
      this.props.self.hasChange = true;
      this.props.dispatch({
        type: 'CHON_CONG_DAN',
        data: item,
        index: this.props.index
      });
      this.props.dispatch({
        type: 'DISPLAY_FIELD',
        value: true
      });
    }
  }, {
    key: 'xemChiTietCongDan',
    value: function xemChiTietCongDan(item) {
      this.props.dispatch({
        type: 'TOGGLE_DIALOG',
        data: {
          name: 'PopupChiTietCongDan',
          status: true
        },
        viewDetailCongDanId: item.congDanId,
        index: this.props.index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'name_popup', onClick: this.xemChiTietCongDan.bind(this, this.props.item) },
            this.props.item.hoVaTen
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soCMNDHoChieu
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.diaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soDienThoai
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soDonThu
        ),
        _react2.default.createElement(
          'td',
          { className: 'action-center' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'icon-check-file', onClick: this.chonCongDan.bind(this, this.props.item) },
            'L\u1EA5y th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n'
          )
        )
      );
    }
  }]);

  return RowItemListSearchPeople;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    index: state.formDataTiepCongDan.index
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemListSearchPeople);

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDocumentDetail = function (_React$Component) {
  _inherits(RowItemDocumentDetail, _React$Component);

  function RowItemDocumentDetail() {
    _classCallCheck(this, RowItemDocumentDetail);

    return _possibleConstructorReturn(this, (RowItemDocumentDetail.__proto__ || Object.getPrototypeOf(RowItemDocumentDetail)).apply(this, arguments));
  }

  _createClass(RowItemDocumentDetail, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tinhTrangTaiLieuStr ? this.props.item.tinhTrangTaiLieuStr : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'none-boder underline-name' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: _jsFileDownload2.default.bind(this, this.props.item.duongDan, this.props.item.tenFile) },
              this.props.item.tenFile
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: function onClick() {
                  (0, _utils.downloadFile)(_this2.props.item.duongDan, _this2.props.item.tenFile);
                } },
              this.props.item.tenFile
            )
          )
        )
      );
    }
  }]);

  return RowItemDocumentDetail;
}(_react2.default.Component);

exports.default = RowItemDocumentDetail;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemListGroupPeoPleDetailReception = function (_React$Component) {
  _inherits(RowItemListGroupPeoPleDetailReception, _React$Component);

  function RowItemListGroupPeoPleDetailReception() {
    _classCallCheck(this, RowItemListGroupPeoPleDetailReception);

    return _possibleConstructorReturn(this, (RowItemListGroupPeoPleDetailReception.__proto__ || Object.getPrototypeOf(RowItemListGroupPeoPleDetailReception)).apply(this, arguments));
  }

  _createClass(RowItemListGroupPeoPleDetailReception, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { textAlign: 'center' } },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.hoVaTen
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.cmndHoChieu
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.diaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soDienThoai
        )
      );
    }
  }]);

  return RowItemListGroupPeoPleDetailReception;
}(_react2.default.Component);

exports.default = RowItemListGroupPeoPleDetailReception;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _CheckPermission = __webpack_require__(20);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemReception = function (_React$Component) {
  _inherits(RowItemReception, _React$Component);

  function RowItemReception(props, context) {
    _classCallCheck(this, RowItemReception);

    var _this = _possibleConstructorReturn(this, (RowItemReception.__proto__ || Object.getPrototypeOf(RowItemReception)).call(this, props, context));

    _this.state = {
      enableAddmore: true,
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: ''
    };
    return _this;
  }

  _createClass(RowItemReception, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var LetterInfor = this.props.item;
      if (LetterInfor.donSTCD.hoanThanhDon || LetterInfor.donSTCD.thanhLapTiepDanGapLanhDao || LetterInfor.hoanThanhTCDThuongXuyen) {
        this.setState({
          enableAddmore: false
        });
      } else {
        this.setState({
          enableAddmore: true
        });
      }

      if (this.props.item.donSTCD.trangThaiDonInfo) {
        this.props.item.donSTCD.trangThaiDonInfo.filter(function (item) {
          return item.donViId == _this2.props.userInfo.donViId;
        }).map(function (child, i) {
          if (_this2.props.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Đình chỉ',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else if (!_this2.props.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Rút đơn',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else {
            _this2.setState({
              ketQuaStr: child.ketQuaStr,
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          }
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var LetterInfor = nextProps.item;
      if (LetterInfor.donSTCD.hoanThanhDon || LetterInfor.donSTCD.thanhLapTiepDanGapLanhDao || LetterInfor.hoanThanhTCDThuongXuyen) {
        this.setState({
          enableAddmore: false
        });
      } else {
        this.setState({
          enableAddmore: true
        });
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      if (data) {
        if (data.diaChi) {
          address.push(data.diaChi);
        }
        if (data.toThon) {
          address.push(data.toThon);
        }
        if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
          address.push(data.phuongXaCongDan.ten);
        }
        if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
          address.push(data.quanHuyenCongDan.ten);
        }
        if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
          address.push(data.tinhThanhCongDan.ten);
        }
      }
      return address.join(", ");
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('DD/MM/YYYY') : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayTiepDan ? (0, _moment2.default)(this.props.item.ngayTiepDan).format('HH:mm') : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              { className: 'txt-bold' },
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.getLocal(this.props.item.donSTCD.listNguoiDungDon[0])
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].soDienThoai : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', to: '/tiep-cong-dan/chi-tiet-don/' + this.props.item.soTiepCongDanId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.donSTCD.noiDung
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.loaiDonInfo ? this.props.item.donSTCD.loaiDonInfo.ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.donSTCD.soNguoi,
              ' Ng\u01B0\u1EDDi'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.donSTCD.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.canBoTiepDanInfo.hoVaTen
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soLuotTiepStr
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.huongXuLyText || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.state.trangThaiDonText
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: this.state.ketQuaStr || '' })
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.userInfo.id === this.props.item.nguoiTaoId ? _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_THEM') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen && this.state.enableAddmore && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-add', to: '/tiep-cong-dan/thuong-xuyen/them-luot/' + this.props.item.soTiepCongDanId },
                  'Th\xEAm L\u01B0\u1EE3t'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen && this.state.enableAddmore && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-edit', to: '/tiep-cong-dan/thuong-xuyen/chinh-sua/' + this.props.item.soTiepCongDanId },
                  'Ch\u1EC9nh s\u1EEDa'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_XOA') && !this.props.item.donSTCD.thanhLapTiepDanGapLanhDao && !this.props.item.hoanThanhTCDThuongXuyen && this.props.item.donSTCD.tongSoLuotTCD == this.props.item.soThuTuLuotTiep && !this.props.item.donSTCD.hoanThanhDon && !this.props.item.donSTCD.lanhDaoDuyet && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.props.item.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' && !this.props.item.donSTCD.thanhLapDon },
              _react2.default.createElement(_dialog.DeleteDialog, {
                title: 'Xác nhận',
                content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a th\xF4ng tin v\u1EC1 l\u01B0\u1EE3t ti\u1EBFp ' + (this.props.item.donSTCD.listNguoiDungDon.length ? 'công dân "' + this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen + '"' : 'này') + ' kh\xF4ng?',
                redux: this.props.parent,
                deleteId: this.props.item.soTiepCongDanId
              })
            )
          ) : _react2.default.createElement('div', { className: 'todo-wrap two-item' })
        )
      );
    }
  }]);

  return RowItemReception;
}(_react2.default.Component);

RowItemReception.defaultProps = {
  dataLoaiDonThu: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemReception);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RowItemReception = undefined;

var _RowItemReception = __webpack_require__(1307);

var _RowItemReception2 = _interopRequireDefault(_RowItemReception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RowItemReception = _RowItemReception2.default;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _detail = __webpack_require__(238);

var _reactRedux = __webpack_require__(6);

var _message = __webpack_require__(10);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CheckPermission = __webpack_require__(20);

var _common = __webpack_require__(3);

var _letterDetail = __webpack_require__(168);

var _reception = __webpack_require__(129);

var _utils = __webpack_require__(4);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailReception = function (_React$Component) {
  _inherits(DetailReception, _React$Component);

  function DetailReception(props, context) {
    _classCallCheck(this, DetailReception);

    var _this = _possibleConstructorReturn(this, (DetailReception.__proto__ || Object.getPrototypeOf(DetailReception)).call(this, props, context));

    _this.state = {
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      ngayTiepNhan: '',

      dsTaiLieuBoSung: [],
      TongLuotTiep: '',

      YeuCauGapLanhDao: false,
      HuongXuLy: '',
      GhiChuXuLy: '',
      LoaiHuongXuLyTCD: '',
      DanhSachHuongXuLy: '',
      DiaDiemGapLanhDao: '',
      NgayHenGapLanhDao: '',
      TenDonThu: '',
      idSoTiepCongDan: '',
      soTiepCongDan: '',
      idDonTCD: '',
      taiLieuBangChungId: '',
      NgayTiepDan: '',
      NoiDungBoSung: '',
      detail: {
        canBoTiepDanInfo: {
          hoVaTen: ''
        },
        coQuanToChucTiepDanSTCD: [],
        donSTCD: {
          listNguoiDungDon: [],
          nguoiDuocUyQuyen: {
            chucVu: '',
            diaChiCoQuan: '',
            luatSu: '',
            ngayCapTheLuatSu: '',
            noiCapTheLuatSu: '',
            phanLoaiCongDan: '',
            soTheLuatSu: '',
            tenCoQuan: '',
            coUyQuyen: false,
            danTocCongDan: {
              ten: ''
            },
            diaChi: '',
            gioiTinh: true,
            hoVaTen: '',
            ngayCap: '',
            ngaySinh: '',
            noiCapCMNDInfo: {
              ten: ''
            },
            phuongXaCongDan: {
              ten: ''
            },
            quanHuyenCongDan: {
              ten: ''
            },
            quocTichCongDan: {
              ten: ''
            },
            soCMNDHoChieu: '',
            soDienThoai: '',
            tinhThanhCongDan: {
              ten: ''
            },
            toThon: ''
          },
          listTaiLieuBangChung: [],
          listTaiLieuBangChungLuatSu: [],
          loaiDon: '',
          loaiDoiTuong: '',
          loaiNguoiDungDon: '',
          linhVucDonThuDon: {
            ten: ''
          },
          linhVucDonThuChiTietDon: {
            ten: ''
          },
          chiTietLinhVucDonThuChiTietDon: {
            ten: ''
          },
          noiDung: '',
          coQuanDaGiaiQuyetDon: {
            ten: '',
            capCoQuanQuanLyInfo: {
              ten: ''
            }
          },
          thamQuyenGiaiQuyetInfo: {
            ten: ''
          },
          lanGiaiQuyet: '',
          hinhThucDaGiaiQuyet: '',
          huongGiaiQuyetDaThucHien: '',
          coThongTinCoQuanDaGiaiQuyet: true
        },
        taiLieuBangChungBoSungs: [],
        ghiChuXuLy: '',
        huongGiaiQuyetTCDLanhDao: '',
        huongXuLy: '',
        huongXuLyText: '',
        ketQuaGiaiQuyet: '',
        listTaiLieuVanThu: [],
        loaiTiepDan: '',
        ngayTiepDan: new Date(),
        noiDungTiepCongDan: '',
        thoiHan: '',
        trangThaiKetQua: '',
        yKienXuLy: '',
        tableLoading: true,
        loadingSave: false
      },

      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: [],
      linhVucChiTietKhac: ''
    };
    return _this;
  }

  _createClass(DetailReception, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCongChucUser(this.state.userInfo.id);
      this.getListDetailReception(this.props.params.id);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.id != this.props.params.id) {
        this.getListDetailReception(nextProps.param.id);
      }
    }
  }, {
    key: 'getCongChucUser',
    value: function getCongChucUser(uid) {
      var _this2 = this;

      _api.Reception.actions.getCongchucOfUser.request({ id: uid }).then(function (res) {
        if (res.data) {
          _this2.state.userInfo.coQuanQuanLyId = res.data.donViCongChuc.coQuanQuanLyId;
        }
      });
    }
  }, {
    key: 'getDonInfo',
    value: function getDonInfo(resData) {
      var _this3 = this;

      _api.Reception.actions.getDonInfo.request({ id: resData.donSTCD.donId }).then(function (res) {
        if (res.data) {
          resData.donSTCD = _extends({}, resData.donSTCD, res.data);
          _this3.setState({
            detail: resData,
            listTaiLieuBangChung: [].concat(_toConsumableArray(res.data.listTaiLieuBangChung), _toConsumableArray(res.data.listTaiLieuBangChungLuatSu)),
            dataDoanDiCung: res.data.listDoanDiCung,
            dataNguoiDuocUyQuyen: res.data.nguoiDuocUyQuyen || [],
            data: resData.donSTCD,
            loaiNguoiDungDon: resData.donSTCD.loaiNguoiDungDon ? resData.donSTCD.loaiNguoiDungDon : '',
            dataNguoiDungDon: resData.donSTCD.listNguoiDungDon ? resData.donSTCD.listNguoiDungDon : [],
            loaiDon: resData.donSTCD.loaiDonText ? resData.donSTCD.loaiDonText : '',
            loaiDonGiaTri: resData.donSTCD.loaiDon ? resData.donSTCD.loaiDon : '',
            loaiDoiTuong: resData.donSTCD.loaiDoiTuongInfo ? resData.donSTCD.loaiDoiTuongInfo : '',
            linhVuc: resData.donSTCD.linhVucDonThuDon ? resData.donSTCD.linhVucDonThuDon.ten : '',
            linhVucChiTiet: resData.donSTCD.linhVucDonThuDon && resData.donSTCD.linhVucDonThuChiTietDon ? resData.donSTCD.linhVucDonThuChiTietDon.ten : '',
            linhVucChiTietSub: resData.donSTCD.linhVucDonThuDon && resData.donSTCD.linhVucDonThuChiTietDon && resData.donSTCD.chiTietLinhVucDonThuChiTietDon ? resData.donSTCD.chiTietLinhVucDonThuChiTietDon.ten : '',
            noiDung: resData.donSTCD.noiDung ? resData.donSTCD.noiDung : '',
            dataCoQuanDaGiaiQuyet: resData.donSTCD.coThongTinCoQuanDaGiaiQuyet && resData.donSTCD.coQuanDaGiaiQuyetDon ? resData.donSTCD.coQuanDaGiaiQuyetDon : {},
            idDonTCD: resData.donSTCD.donId,
            idSoTiepCongDan: resData.soTiepCongDanId,
            ngayTiepNhan: resData.ngayTiepDan ? (0, _moment2.default)(resData.ngayTiepDan).format('DD/MM/YYYY - HH:mm') : '',
            NgayTiepDan: resData.donSTCD.ngayTiepDan ? (0, _moment2.default)(resData.donSTCD.ngayTiepDan).format('DD/MM/YYYY') : '',
            TongLuotTiep: resData.soLuotTiepStr,
            HuongXuLy: resData.huongXuLy,
            GhiChuXuLy: resData.noiDungTiepCongDan,
            DiaDiemGapLanhDao: resData.diaDiemGapLanhDao,
            YeuCauGapLanhDao: resData.donSTCD.yeuCauGapTrucTiepLanhDao,
            NgayHenGapLanhDao: resData.ngayHenGapLanhDao ? (0, _moment2.default)(resData.ngayHenGapLanhDao).format('DD/MM/YYYY') : '',
            linhVucChiTietKhac: resData.donSTCD.linhVucChiTietKhac || ''
          });
        }
      });
    }
  }, {
    key: 'getListDetailReception',
    value: function getListDetailReception(inputId) {
      var _this4 = this;

      _api.Reception.actions.getDetailReception.request({ id: inputId }).then(function (res) {
        if (res.data) {
          _this4.getDonInfo(res.data);
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'checkBienBanTCD',
    value: function checkBienBanTCD() {
      var pass = true;
      this.state.listTaiLieuBangChung.map(function (item) {
        if (item.ten == 'Đơn công dân/Biên bản TCD' && !item.duongDan) {
          pass = false;
        }
      });
      return pass;
    }
  }, {
    key: 'updateDon',
    value: function updateDon() {
      var _this5 = this;

      if (!this.checkBienBanTCD()) {
        (0, _toastr.Toastr)('Vui lòng đính kèm Đơn công dân/Biên bản TCD trước khi chuyển xử lý đơn', 'warning');
      } else {
        this.setState({ loadingSave: true });
        var params = {
          coUyQuyen: this.state.detail.donSTCD.coUyQuyen,
          coThongTinCoQuanDaGiaiQuyet: this.state.detail.donSTCD.coThongTinCoQuanDaGiaiQuyet,
          noiDung: this.state.detail.donSTCD.noiDung,
          loaiDon: this.state.detail.donSTCD.loaiDon,
          loaiDoiTuong: this.state.detail.donSTCD.loaiDoiTuong,
          loaiVuViec: this.state.detail.donSTCD.loaiVuViec,
          nguonTiepNhanDon: 'TRUC_TIEP',
          loaiNguoiDungDon: this.state.detail.donSTCD.loaiNguoiDungDon,
          linhVucDonThu: { id: this.state.detail.donSTCD.linhVucDonThuDon.linhVucDonThuId },
          thanhLapDon: true,
          canBoXuLy: { id: this.state.detail.canBoTiepDanInfo.congChucId },
          soNguoi: this.state.detail.donSTCD.soNguoi,
          tongSoLuotTCD: this.state.detail.donSTCD.tongSoLuotTCD
        };

        if (this.state.detail.donSTCD.linhVucDonThuChiTietDon) {
          params.linhVucDonThuChiTiet = { id: this.state.detail.donSTCD.linhVucDonThuChiTietDon.linhVucDonThuId };
        }
        if (this.state.detail.donSTCD.chiTietLinhVucDonThuChiTietDon) {
          params.chiTietLinhVucDonThuChiTiet = { id: this.state.detail.donSTCD.chiTietLinhVucDonThuChiTietDon.linhVucDonThuId };
        } else {
          params.chiTietLinhVucDonThuChiTiet = null;
        }

        if (this.state.detail.donSTCD.coThongTinCoQuanDaGiaiQuyet) {
          params.coQuanDaGiaiQuyetDonThu = this.state.detail.donSTCD.coQuanDaGiaiQuyetDonThu;
          params.soVanBanDaGiaiQuyet = this.state.detail.donSTCD.soVanBanDaGiaiQuyet;
          params.ngayBanHanhVanBanDaGiaiQuyet = this.state.detail.donSTCD.ngayBanHanhVanBanDaGiaiQuyet ? (0, _moment2.default)(new Date(this.state.detail.donSTCD.ngayBanHanhVanBanDaGiaiQuyet), 'DD/MM/YYYY').add(7, 'hours').toISOString() : '';
        }

        _api.Reception.actions.updateDon.request({ id: this.state.detail.donSTCD.donId }, params).then(function (res) {
          if (res.data) {
            _reactRouter.browserHistory.push('/tiep-cong-dan');
            (0, _toastr.Toastr)(_message.msg.chuyenXLDSucess, 'success');
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this5.setState({ loadingSave: false });
        });
      }
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index, name) {
      this.state[name].splice(index, 1);
      this.setState(_defineProperty({}, name, this.state[name]));
    }
  }, {
    key: 'handleChangeEditableTLBS',
    value: function handleChangeEditableTLBS(index, name, value) {
      this.state.dsTaiLieuBoSung[index][name] = value;
      this.setState({ dsTaiLieuBoSung: this.state.dsTaiLieuBoSung });
    }
  }, {
    key: 'handleChangeSelectTLBS',
    value: function handleChangeSelectTLBS(index, e) {
      this.state.dsTaiLieuBoSung[index][e.target.name] = e.target.value;
      this.setState({ dsTaiLieuBoSung: this.state.dsTaiLieuBoSung });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { id: 'page', className: 'panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: _reactRouter.browserHistory.goBack, title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-detail' },
                'Th\xF4ng tin chi ti\u1EBFt \u0111\u01A1n th\u01B0/v\u1EE5 vi\u1EC7c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'div',
                { className: 'wrapper_box' },
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper mt0' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items no-border' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_common.TextMessage, { className: 'col-6', labelClass: 'pt-inline', label: 'Ng\xE0y ti\u1EBFp:', value: this.state.ngayTiepNhan }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-6' },
                        _react2.default.createElement(
                          'p',
                          { className: 'pull-right reception-count' },
                          'L\u01B0\u1EE3t ti\u1EBFp ',
                          _react2.default.createElement(
                            'span',
                            null,
                            this.state.TongLuotTiep
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
                    title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                    parent: this.state
                  })
                ),
                this.state.data.coUyQuyen ? _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items no-border' },
                    _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
                      title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
                      parent: this.state
                    })
                  )
                ) : '',
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items no-border' },
                    _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
                      title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                      isOpen: true,
                      parent: this.state
                    })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.data.coThongTinCoQuanDaGiaiQuyet == true },
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(_letterDetail.ThongTinCoQuanDaGiaiQuyet, {
                        title: 'Th\xF4ng tin c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt',
                        isOpen: true,
                        parent: this.state
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward' },
                      _react2.default.createElement(
                        'div',
                        { className: 'group-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-12' },
                              _react2.default.createElement(
                                'h3',
                                null,
                                'Th\xF4ng tin x\u1EED l\xFD l\u01B0\u1EE3t ti\u1EBFp c\xF4ng d\xE2n'
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form mb10' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(_common.TextMessage, { className: 'col-12', label: 'H\u01B0\u1EDBng x\u1EED l\xFD:', value: this.state.detail.huongXuLyText })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(_common.TextMessage, { className: 'col-12', label: this.state.HuongXuLy == 'TRA_DON_VA_HUONG_DAN' ? 'Nội dung hướng dẫn:' : this.state.HuongXuLy == 'TU_CHOI' ? 'Lý do từ chối:' : this.state.HuongXuLy == 'BO_SUNG_THONG_TIN' ? 'Nội dung bổ sung:' : 'Ghi chú:', value: this.state.GhiChuXuLy })
                          )
                        )
                      )
                    )
                  )
                ),
                this.state.HuongXuLy == 'BO_SUNG_THONG_TIN' ? _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-items mb0-18' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-forward' },
                      _react2.default.createElement(
                        'div',
                        { className: 'group-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-12' },
                              _react2.default.createElement(
                                'h3',
                                null,
                                'T\xE0i li\u1EC7u b\u1ED5 sung'
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-12' },
                              _react2.default.createElement(
                                _dataTable2.default,
                                {
                                  header: _table.header.detailReception.proof,
                                  dataList: this.state.detail.taiLieuBangChungBoSungs,
                                  hidePagination: true,
                                  hideExport: true,
                                  parent: this,
                                  tableLoading: this.state.tableLoading },
                                _react2.default.createElement(_detail.RowItemDocumentDetail, null)
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                ) : '',
                _react2.default.createElement(_reception.TinhTrangDon, { data: this.state.data })
              ),
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', to: '/tiep-cong-dan' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && !this.state.detail.donSTCD.thanhLapTiepDanGapLanhDao && !this.state.detail.hoanThanhTCDThuongXuyen && this.state.detail.donSTCD.tongSoLuotTCD == this.state.detail.soThuTuLuotTiep && this.state.detail.donSTCD.trangThaiYeuCauGapLanhDao != 'DONG_Y' && this.state.detail.donSTCD.trangThaiYeuCauGapLanhDao != 'KHONG_DONG_Y' && !this.state.detail.donSTCD.hoanThanhDon && !this.state.detail.donSTCD.lanhDaoDuyet && this.state.detail.nguoiTaoId === this.props.userInfo.id ? _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-edit', to: '/tiep-cong-dan/thuong-xuyen/chinh-sua/' + this.state.idSoTiepCongDan },
                  _react2.default.createElement(
                    'span',
                    null,
                    'S\u1EEDa'
                  )
                ) : null,
                (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_SUA') && this.state.detail && this.props.userInfo && this.state.detail.donSTCD && this.state.detail.nguoiTaoId === this.props.userInfo.id && !this.state.detail.donSTCD.thanhLapDon && !this.state.detail.donSTCD.thanhLapTiepDanGapLanhDao && !this.state.detail.hoanThanhTCDThuongXuyen && this.state.detail.huongXuLy == 'TIEP_NHAN_DON' && this.state.detail.donSTCD.tongSoLuotTCD == this.state.detail.soThuTuLuotTiep && _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-move ' + (this.state.loadingSave ? 'btn-loading-inline' : ''), onClick: this.updateDon.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Chuy\u1EC3n x\u1EED l\xFD \u0111\u01A1n'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DetailReception;
}(_react2.default.Component);

DetailReception.defaultProps = {
  loaiDonThu: [],
  loaiDoiTuong: []
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuong: state.duLieuHeThong.loaiDoiTuong
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DetailReception);

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DetailReception = undefined;

var _DetailReception = __webpack_require__(1309);

var _DetailReception2 = _interopRequireDefault(_DetailReception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DetailReception = _DetailReception2.default;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ttForms = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormSort = function (_Component) {
  _inherits(FormSort, _Component);

  function FormSort(props, context) {
    _classCallCheck(this, FormSort);

    var _this = _possibleConstructorReturn(this, (FormSort.__proto__ || Object.getPrototypeOf(FormSort)).call(this, props, context));

    _this.state = {
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      }
    };
    return _this;
  }

  _createClass(FormSort, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var pageData = this.props.pageDetail;
      var newState = this.state;
      this.setState(_extends({}, newState, {
        pageData: pageData
      }));
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pageData = nextProps.pageDetail;
      var newState = this.state;
      this.setState(_extends({}, newState, {
        pageData: pageData
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'sort-container' },
        _react2.default.createElement(
          'div',
          { className: 'sort-by' },
          _react2.default.createElement(_ttForms.DropDownSort, {
            type: this.props.type,
            className: 'col',
            selectedValue: this.props.selectedValue,
            onChange: this.onChange.bind(this),
            name: 'sortBy' })
        )
      );
    }
  }]);

  return FormSort;
}(_react.Component);

exports.default = FormSort;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formTimkiem = __webpack_require__(100);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var FormTimKiemNangCao = function (_React$Component) {
  _inherits(FormTimKiemNangCao, _React$Component);

  function FormTimKiemNangCao(props, context) {
    _classCallCheck(this, FormTimKiemNangCao);

    var _this = _possibleConstructorReturn(this, (FormTimKiemNangCao.__proto__ || Object.getPrototypeOf(FormTimKiemNangCao)).call(this, props, context));

    _this.state = {
      searchKey: '',
      receptionType: '',
      handleRedirect: '',
      startDate: '',
      endDate: '',

      searching: _this.props.disabled,

      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(FormTimKiemNangCao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
      this.state.searchKey = data.tuKhoa || '';
      if (data.advanceSearch) {
        this.state.receptionType = data.phanLoaiDon || '';
        this.state.handleRedirect = data.huongXuLy || '';
        this.state.startDate = data.startDate ? new Date(data.startDate) : '';
        this.state.endDate = data.endDate ? new Date(data.endDate) : '';
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();

      if (!this.props.advanceSearch) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      } else {
        if (this.validateSubmitForm()) {
          this.setState({
            doSearch: true
          });
          this.props.handleSearch(this.state, e);
        }
      }

      return;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');

        if (this.state.doSearch) {
          classes.push('btn-loading');
        }
      }

      var btnClasses = classNames(classes);
      // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(_formTimkiem.InputTuKhoa, { onChange: this.handleChange.bind(this, 'searchKey'), value: this.state.searchKey }),
        _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.receptionType, onChange: this.handleChange.bind(this, 'receptionType') }),
        _react2.default.createElement(
          'div',
          { className: 'btn-wrap' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(
          'div',
          { className: ' clear-left' },
          _react2.default.createElement(_common.DatePicker, { label: 'Ti\u1EBFp nh\u1EADn t\u1EEB ng\xE0y', value: this.state.startDate, bindValidator: this, channel: 'formTaoDon', endDate: this.state.endDate, onChange: this.handleChangeDate.bind(this, 'startDate') })
        ),
        _react2.default.createElement(_common.DatePicker, { label: '\u0110\u1EBFn ng\xE0y', value: this.state.endDate, bindValidator: this, channel: 'formTaoDon', startDate: this.state.startDate, onChange: this.handleChangeDate.bind(this, 'endDate') }),
        _react2.default.createElement(_ttForms.DropDownChonHuongXuLy, { selected: this.state.handleRedirect, onChange: this.handleChange.bind(this, 'handleRedirect') }),
        _react2.default.createElement(
          'div',
          { className: 'input-group' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search", onClick: this.cancel.bind(this) },
            _react2.default.createElement('i', { className: 'tt tt-delete' }),
            'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
          )
        )
      );
    }
  }]);

  return FormTimKiemNangCao;
}(_react2.default.Component);

FormTimKiemNangCao.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
};

exports.default = FormTimKiemNangCao;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputTuKhoa = function (_React$Component) {
  _inherits(InputTuKhoa, _React$Component);

  function InputTuKhoa(props, context) {
    _classCallCheck(this, InputTuKhoa);

    var _this = _possibleConstructorReturn(this, (InputTuKhoa.__proto__ || Object.getPrototypeOf(InputTuKhoa)).call(this, props, context));

    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  _createClass(InputTuKhoa, [{
    key: "onChange",
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });
      this.props.onChange(e);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "input-group-show" },
        _react2.default.createElement(
          "label",
          { className: "ip-label" },
          "T\u1EEB kho\xE1"
        ),
        _react2.default.createElement("input", { type: "text", name: "searchKey", placeholder: this.props.placeholderText, className: "search-input", onChange: this.onChange.bind(this),
          value: this.state.value })
      );
    }
  }]);

  return InputTuKhoa;
}(_react2.default.Component);

InputTuKhoa.defaultProps = {
  placeholderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  value: '',
  onChange: function onChange() {
    console.log('Please assign onChange function');
  }
};

exports.default = InputTuKhoa;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _message = __webpack_require__(10);

var _toastr = __webpack_require__(11);

var _CheckPermission = __webpack_require__(20);

var _formTimkiem = __webpack_require__(100);

var _formSort = __webpack_require__(128);

var _list = __webpack_require__(1308);

var _layout = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReceptionPage = function (_React$Component) {
  _inherits(ReceptionPage, _React$Component);

  function ReceptionPage(props, context) {
    _classCallCheck(this, ReceptionPage);

    var _this = _possibleConstructorReturn(this, (ReceptionPage.__proto__ || Object.getPrototypeOf(ReceptionPage)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      dataLoaiDonThu: [],
      dataHuongXuLy: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepDan,desc',
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,
      search: false,
      tableLoading: false,
      searchLoading: false,
      searchKey: '',
      receptionType: '',
      handleRedirect: '',
      startDate: '',
      endDate: ''
    };
    return _this;
  }

  _createClass(ReceptionPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.searchKey = data.tuKhoa || '';
      if (this.state.advanceSearch) {
        this.state.receptionType = data.phanLoaiDon || '';
        this.state.handleRedirect = data.huongXuLy || '';
        this.state.startDate = data.startDate ? new Date(data.startDate) : '';
        this.state.endDate = data.endDate ? new Date(data.endDate) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({ advanceSearch: true });
      var data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
      data.advanceSearch = true;
      localStorage.setItem('tcdtxData', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({ advanceSearch: false });
      var data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
      data.advanceSearch = false;
      localStorage.setItem('tcdtxData', JSON.stringify(data));
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this2 = this;

      _api.Reception.actions.deleteTiepCongDan.request({
        id: sID
      }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.dTCDTX, 'success');
        _this2.props.dispatch({
          type: 'REFRESH_MENU',
          value: true
        });
        _this2.props.dispatch({
          type: 'DELETE_ITEM_DATALIST',
          key: 'listTCDTX',
          idKey: 'soTiepCongDanId',
          id: sID
        });
        _this2.getListData();
      }).catch(function (err) {
        var Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
        Data.map(function (item) {
          (0, _toastr.Toastr)(item.description, 'error');
        });
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this3 = this;

      var params = {
        loaiTiepCongDan: 'THUONG_XUYEN',
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };
      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }
      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.handleRedirect) {
          params.huongXuLy = this.state.handleRedirect;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('tcdtxData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this3.state.pageData = res.data.page;
        } else {
          _this3.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this3.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
        _this3.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDTX', data: Data });
        if (_this3.refs.tcdTX) {
          _this3.setState(_extends({}, _this3.state));
        }
      }).catch(function (err) {
        _this3.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        });
        if (_this3.refs.tcdTX) {
          _this3.setState(_extends({}, _this3.state));
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this4 = this;

      var params = {
        loaiTiepCongDan: 'THUONG_XUYEN',
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.searchKey) {
        params.tuKhoa = this.state.searchKey;
      }
      if (this.state.advanceSearch) {
        if (this.state.receptionType) {
          params.phanLoaiDon = this.state.receptionType;
        }

        if (this.state.handleRedirect) {
          params.huongXuLy = this.state.handleRedirect;
        }

        if (this.state.startDate) {
          params.tuNgay = (0, _moment2.default)(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.endDate) {
          params.denNgay = (0, _moment2.default)(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('tcdtxData', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.Reception.actions.getTiepCongDan.request(null, params).then(function (res) {
        var Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.soTiepCongDans;
          _this4.state.pageData = res.data.page;
        } else {
          _this4.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        _this4.state.tableLoading = false;
        _this4.state.searchLoading = false;
        _this4.state.searching = false;
        _this4.state.search = false;
        _this4.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listTCDTX', data: Data });
        if (_this4.refs.tcdTX) {
          _this4.setState(_extends({}, _this4.state));
        }
      }).catch(function (err) {
        _this4.state.tableLoading = false;
        _this4.state.searchLoading = false;
        _this4.state.searching = false;
        _this4.state.search = false;
        if (_this4.refs.tcdTX) {
          _this4.setState(_extends({}, _this4.state));
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container', ref: 'tcdTX' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-reception' }),
                'S\u1ED5 ti\u1EBFp c\xF4ng d\xE2n th\u01B0\u1EDDng xuy\xEAn'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-content' },
              (0, _CheckPermission.CheckPermission)('SOTIEPCONGDAN_THEM') ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', to: '/tiep-cong-dan/thuong-xuyen/them-moi' },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
              _react2.default.createElement(_formTimkiem.FormTimKiemNangCao, { advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                'T\xECm ki\u1EBFm n\xE2ng cao'
              )
            ),
            _react2.default.createElement(_formSort.FormSort, {
              type: 'tiepCongDanThuongXuyen',
              pageDetail: this.state.pageData,
              selectedValue: this.state.sortBy,
              onChange: this.handleChange.bind(this, 'sortBy')
            }),
            _react2.default.createElement(
              _dataTable2.default,
              { header: _table.header.listTCD, dataList: this.state.data, exporttext: 'Xu\u1EA5t S\u1ED5 ti\u1EBFp c\xF4ng d\xE2n', pageData: this.state.pageData, parent: this, search: this.state.advanceSearch,
                tableLoading: this.state.tableLoading, sortBy: this.state.sortBy },
              _react2.default.createElement(_list.RowItemReception, null)
            )
          )
        )
      );
    }
  }]);

  return ReceptionPage;
}(_react2.default.Component);

ReceptionPage.defaultProps = {
  data: []
};

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDTX
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ReceptionPage);

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListReception = undefined;

var _ListReception = __webpack_require__(1314);

var _ListReception2 = _interopRequireDefault(_ListReception);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ListReception = _ListReception2.default;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loginBg = __webpack_require__(378);

var ResetPassword = function (_React$Component) {
  _inherits(ResetPassword, _React$Component);

  function ResetPassword(props, context) {
    _classCallCheck(this, ResetPassword);

    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props, context));

    _this.state = {
      loading: false,
      isSubmit: false,
      password: '',
      passwordConfirmation: '',
      isConfirmPasswordCorrectly: true,
      isCodeExpire: false
    };
    return _this;
  }

  _createClass(ResetPassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof _reactCookie2.default.load('accessToken') != 'undefined') {
        _reactRouter.browserHistory.push('/');
      }
      this.checkCode();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'isSubmit', false), _defineProperty(_setState, 'isConfirmPasswordCorrectly', true), _setState));
    }
  }, {
    key: 'handleResetPassword',
    value: function handleResetPassword(e) {
      var _this2 = this;

      e.preventDefault();
      this.checkCode().then(function () {
        if (!_this2.state.isCodeExpire) {
          if (_this2.handleValidate()) {
            _this2.setState({ loading: true });

            var params = {
              code: _this2.props.params.code,
              password: _this2.state.password,
              passwordAgain: _this2.state.passwordConfirmation
            };
            _api.User.actions.resetPassword.request(null, params).then(function (res) {
              _this2.setState({ loading: false });
              (0, _toastr.Toastr)('Bạn đã đổi mật khẩu thành công', 'success');
            }).catch(function (error) {
              _this2.setState({ loading: false });
              if (error.response) {
                (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
              }
            });
          }
        }
      });
    }
  }, {
    key: 'checkCode',
    value: function checkCode() {
      var _this3 = this;

      var params = {
        code: this.props.params.code
      };
      return _api.User.actions.confirmCode.request(null, params).then(function (res) {
        _this3.setState({
          isCodeExpire: false
        });
      }).catch(function (error) {
        _this3.setState({
          isCodeExpire: true
        });
      });
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate() {
      this.setState({ isSubmit: true });
      var pass = true;
      if (!this.state.password) {
        pass = false;
      } else if (!this.state.passwordConfirmation) {
        pass = false;
      } else if (this.state.password != this.state.passwordConfirmation) {
        pass = false;
        this.setState({
          isConfirmPasswordCorrectly: false
        });
      }
      return pass;
    }
  }, {
    key: 'handleForgotPassword',
    value: function handleForgotPassword() {
      _reactRouter.browserHistory.push('/quen-mat-khau');
    }
  }, {
    key: 'render',
    value: function render() {
      var logoImg = __webpack_require__(379);
      return _react2.default.createElement(
        'div',
        { className: 'login', style: { backgroundImage: 'url(' + loginBg + ')' } },
        _react2.default.createElement(
          'div',
          { className: 'login-block' },
          _react2.default.createElement(
            'h1',
            { className: 'logo-login' },
            _react2.default.createElement('img', { src: logoImg, alt: '', className: 'login-logo-image' }),
            _react2.default.createElement(
              'span',
              { className: 'login-logo-caption' },
              'Ph\u1EA7n m\u1EC1m v\xE0 x\xE2y d\u1EF1ng c\u01A1 s\u1EDF d\u1EEF li\u1EC7u ho\u1EA1t \u0111\u1ED9ng thanh tra tr\xEAn \u0111\u1ECBa b\xE0n T\u1EC9nh Qu\u1EA3ng Ng\xE3i'
            )
          ),
          this.state.isCodeExpire ? _react2.default.createElement(
            'form',
            { className: 'login-form', noValidate: true },
            _react2.default.createElement(
              'h2',
              { className: 'title-login txt-blue' },
              'L\u1ED7i x\xE1c nh\u1EADn'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group sub-title-login text-danger' },
              'M\xE3 x\xE1c th\u1EF1c n\xE0y kh\xF4ng h\u1EE3p l\u1EC7 ho\u1EB7c \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng. Vui l\xF2ng ch\u1ECDn "Qu\xEAn m\u1EADt kh\u1EA9u" \u0111\u1EC3 nh\u1EADn \u0111\u01B0\u1EE3c m\xE3 x\xE1c th\u1EF1c m\u1EDBi'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(_core.Button, { type: 'button', onClick: this.handleForgotPassword.bind(this), className: 'btn-login ' + (this.state.loading ? 'btn-loading-inline' : ''), text: 'Qu\xEAn m\u1EADt kh\u1EA9u' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(
                'p',
                { className: 'txt-center' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'dang-nhap', className: 'text-14 txt-blue' },
                  '\u0110\u0103ng nh\u1EADp'
                )
              )
            )
          ) : _react2.default.createElement(
            'form',
            { className: 'login-form', onSubmit: this.handleResetPassword.bind(this), noValidate: true },
            _react2.default.createElement(
              'h2',
              { className: 'title-login txt-blue' },
              'T\u1EA1o m\u1EADt kh\u1EA9u m\u1EDBi'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group sub-title-login' },
              'Vui l\xF2ng \u0111i\u1EC1n \u0111\u1EA7y \u0111\u1EE7 th\xF4ng tin \u0111\u1EC3 t\u1EA1o m\u1EADt kh\u1EA9u m\u1EDBi'
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement('span', { className: 'tt-login-password' }),
              _react2.default.createElement('input', { className: 'login-input pt-input ' + (this.state.isSubmit && !this.state.password ? 'pt-intent-danger' : ''),
                type: 'password', placeholder: 'Nh\u1EADp m\u1EADt kh\u1EA9u m\u1EDBi', name: 'Password', value: this.state.password,
                onChange: this.handleChange.bind(this, 'password'), autoComplete: 'off',
                maxLength: 40 }),
              this.state.isSubmit && !this.state.password ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.messageDefault
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement('span', { className: 'tt-login-password' }),
              _react2.default.createElement('input', { className: 'login-input pt-input ' + (this.state.isSubmit && (!this.state.passwordConfirmation || !this.state.isConfirmPasswordCorrectly) ? 'pt-intent-danger' : ''),
                type: 'password', placeholder: 'X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u', name: 'Password', value: this.state.passwordConfirmation,
                onChange: this.handleChange.bind(this, 'passwordConfirmation'), autoComplete: 'off',
                maxLength: 40 }),
              this.state.isSubmit && !this.state.passwordConfirmation ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                _message.msg.messageDefault
              ) : null,
              this.state.isSubmit && !this.state.isConfirmPasswordCorrectly ? _react2.default.createElement(
                'div',
                { className: 'pt-form-helper-text' },
                'X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u kh\xF4ng \u0111\xFAng'
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(_core.Button, { type: 'submit', className: 'btn-login ' + (this.state.loading ? 'btn-loading-inline' : ''), text: '\u0110\u1ED5i m\u1EADt kh\u1EA9u' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'login-group' },
              _react2.default.createElement(
                'p',
                { className: 'txt-center' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'dang-nhap', className: 'text-14 txt-blue' },
                  '\u0110\u0103ng nh\u1EADp'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ResetPassword;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(ResetPassword);

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResetPassword = __webpack_require__(1316);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResetPassword2.default;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _DataTableTTT = __webpack_require__(318);

var _DataTableTTT2 = _interopRequireDefault(_DataTableTTT);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(130);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietNoiDungXuLy = function (_Component) {
  _inherits(ChiTietNoiDungXuLy, _Component);

  function ChiTietNoiDungXuLy(props) {
    _classCallCheck(this, ChiTietNoiDungXuLy);

    var _this = _possibleConstructorReturn(this, (ChiTietNoiDungXuLy.__proto__ || Object.getPrototypeOf(ChiTietNoiDungXuLy)).call(this, props));

    _this.state = {
      data: [],
      tableLoading: false,
      id: _this.props.params.id
    };
    return _this;
  }

  _createClass(ChiTietNoiDungXuLy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLichSuXuLyCTTTrung();
      this.getChiTietCuocTrung();
    }
  }, {
    key: 'getLichSuXuLyCTTTrung',
    value: function getLichSuXuLyCTTTrung() {
      var _this2 = this;

      this.setState({ tableLoading: true });
      _api.ThanhTra.actions.getLichSuXuLyCTTTrung.request().then(function (res) {
        if (res.data._embedded) {
          var lichSuXuLyCTTTrung = res.data._embedded.lichSuXuLyCTTTrungs;
          var dataLichSuXuLyTTT = lichSuXuLyCTTTrung.find(function (item) {
            if (item.lichSuXuLyCTTId === Number(_this2.state.id)) {
              return item;
            }
          });
          _this2.setState(_extends({}, dataLichSuXuLyTTT, {
            tableLoading: false
          }));
        }
      });
    }
  }, {
    key: 'getChiTietCuocTrung',
    value: function getChiTietCuocTrung() {
      var _this3 = this;

      this.setState({
        tableLoading: true
      });
      _api.ThanhTra.actions.getLichSuXuLyCTTTrungChiTiet.request({ id: this.state.id }).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var dataDetails = (0, _lodash.get)(res, 'data._embedded.medial_CuocThanhTraTrungInfoes');
          _this3.setState({
            data: dataDetails,
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          lanXuLy = _state.lanXuLy,
          ngayBanHanh = _state.ngayBanHanh,
          soQuyetDinh = _state.soQuyetDinh,
          thoiGianXuLy = _state.thoiGianXuLy,
          namThanhTra = _state.namThanhTra;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.onClickClose.bind(this, 'close'), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'Th\xF4ng tin chi ti\u1EBFt n\u1ED9i dung x\u1EED l\xFD'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'box-items mb0' },
              _react2.default.createElement(
                'div',
                { className: 'box-forward' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-12' },
                      _react2.default.createElement(
                        'h3',
                        { className: 'mb15 tt-title' },
                        '1. Th\xF4ng tin x\u1EED l\xFD'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'group-box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form mb20' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_common.Text, { label: 'L\u1EA7n x\u1EED l\xFD:', className: 'col-20', value: lanXuLy }),
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', className: 'col-20', value: soQuyetDinh }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh:', className: 'col-20', value: ngayBanHanh ? (0, _moment2.default)(ngayBanHanh).format('DD/MM/YYYY') : '' })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form mb20' },
                    _react2.default.createElement(
                      'div',
                      { className: 'rows' },
                      _react2.default.createElement(_common.Text, { label: 'N\u0103m thanh tra/ki\u1EC3m tra:', className: 'col-20', value: namThanhTra }),
                      _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi gian x\u1EED l\xFD:', className: 'col-20', value: (0, _moment2.default)(thoiGianXuLy).format('DD/MM/YYYY') })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'items-form mb20' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: this.state.listTaiLieuVanThus })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-12' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'mb15 tt-title' },
                    '2. N\u1ED9i dung x\u1EED l\xFD'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'ttt-wrapper-table' },
              _react2.default.createElement(
                _DataTableTTT2.default,
                {
                  onDisableCheck: true,
                  header: _table.header.thanhTraTrung.CNNDXLCT,
                  dataList: this.state.data,
                  thanhTra: true,
                  hidePagination: true,
                  parent: this,
                  search: true,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.RowItemChiTietNoiDungTTT, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietNoiDungXuLy;
}(_react.Component);

exports.default = ChiTietNoiDungXuLy;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DataTableTTT = __webpack_require__(318);

var _DataTableTTT2 = _interopRequireDefault(_DataTableTTT);

var _table = __webpack_require__(12);

var _common = __webpack_require__(3);

var _datatable = __webpack_require__(130);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _config = __webpack_require__(16);

var _core = __webpack_require__(7);

var _lodash = __webpack_require__(14);

var _reactRedux = __webpack_require__(6);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucCuocThanhTraTrung = function (_Component) {
  _inherits(DanhMucCuocThanhTraTrung, _Component);

  function DanhMucCuocThanhTraTrung(props, context) {
    _classCallCheck(this, DanhMucCuocThanhTraTrung);

    var _this = _possibleConstructorReturn(this, (DanhMucCuocThanhTraTrung.__proto__ || Object.getPrototypeOf(DanhMucCuocThanhTraTrung)).call(this, props, context));

    _this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      data: [],
      dataLichSuCu: [],
      doiTuongThannhTra: '',
      dsNamThanhTra: [],
      ttXuLyTTTCuaDonVi: [],
      trangThaiXuLyCuaDonVi: '',
      dataLichSuXuLy: [],
      listNhomDoiTuong: [],
      listNamThanhTra: [],
      selectListItem: [],
      tableLoading: false,
      donViIds: [],
      dataXuLy: [],
      checkAll: false,
      listSelected: [],
      namThanhTraXuLy: ''
    };
    return _this;
  }

  _createClass(DanhMucCuocThanhTraTrung, [{
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'donViThanhTra') {
        var dataListDonVi = this.state.dataListDonVi;

        var donViIds = [].concat(_toConsumableArray(this.state.donViIds));
        var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
        var checkItem = selectListItem.findIndex(function (item) {
          return Number(item.coQuanQuanLyId) === Number(e.target.value);
        });
        if (checkItem === -1) {
          var selectItem = dataListDonVi.find(function (item) {
            return Number(item.coQuanQuanLyId) === Number(e.target.value);
          });
          selectListItem.push(selectItem);
          donViIds.push(selectItem.coQuanQuanLyId);
        }
        this.setState({
          donViIds: donViIds,
          selectListItem: selectListItem
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var URL = String(_config.API_URL) + '/cuocThanhTraTrungDoiTuong/xuatExcel?tenDoiTuongThanhTra=' + this.state.doiTuongThannhTra;
      if (this.state.soQuyetDinh) {
        URL = URL + '&soQuyetDinhPheDuyetKHTT=' + this.state.soQuyetDinh;
      }
      if (this.state.nhomDoiTuong) {
        URL = URL + '&nhomDoiTuongId=' + this.state.nhomDoiTuong;
      }
      if (this.state.trangThaiXuLyCuaDonVi) {
        URL = URL + '&trangThaiXuLyCuaDonVi=' + this.state.trangThaiXuLyCuaDonVi;
      }
      if (!(0, _lodash.isEmpty)(this.state.donViIds)) {
        URL = URL + '&donViIds=' + this.state.donViIds;
      }
      window.open(URL, "_self");
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getlichSuXuLyCTTTrungCurrent();

              case 2:
                _context.next = 4;
                return this.getDataList();

              case 4:
                this.getNamThanhTraList();
                this.getTTXuLyTrungTaiDV();
                this.getLichSuXuLyCTTT();
                this.getNhomDoiTuong();
                this.getDonVi();
                this.getCuocThanhTraTrung();
                this.checkNamThanhTraXuLy();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'checkNamThanhTraXuLy',
    value: function checkNamThanhTraXuLy() {
      var _this2 = this;

      _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this2.setState({
            namThanhTraXuLy: (0, _lodash.get)(res, 'data.namThanhTra')
          });
        }
      });
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this3 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this3.setState({
            listNamThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getCuocThanhTraTrung',
    value: function getCuocThanhTraTrung() {
      var _this4 = this;

      var params = {};
      this.setState({
        tableLoading: true
      });
      _api.ThanhTra.actions.getCuocThanhTraTrungXuLy.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = (0, _lodash.get)(res, 'data._embedded.medial_CuocThanhTraTrungInfoes') || [];
          var tableLoading = false;
          _this4.setState({
            dataXuLy: data,
            tableLoading: tableLoading
          });
        } else {
          var _tableLoading = false;
          _this4.setState({
            dataXuLy: [],
            tableLoading: _tableLoading
          });
        }
      });
    }
  }, {
    key: 'getTTXuLyTrungTaiDV',
    value: function getTTXuLyTrungTaiDV() {
      var _this5 = this;

      _api.ThanhTra.actions.getTrangThaoXuLyTrungTaiDV.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var newData = res.data.filter(function (item) {
            return item.giaTri !== "DA_XOA";
          });
          _this5.setState({
            ttXuLyTTTCuaDonVi: newData
          });
        }
      });
    }
  }, {
    key: 'getNhomDoiTuong',
    value: function getNhomDoiTuong() {
      var _this6 = this;

      _api.ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(function (res) {
        var listNhomDoiTuong = (0, _lodash.get)(res, 'data._embedded.nhomDoiTuongThanhTras') || [];
        _this6.setState({ listNhomDoiTuong: listNhomDoiTuong });
      });
    }
  }, {
    key: 'getDataList',
    value: function getDataList() {
      var _this7 = this;

      var isSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.doiTuongThannhTra) {
        params.tenDoiTuongThanhTra = this.state.doiTuongThannhTra;
      }
      if (this.state.soQuyetDinh) {
        params.soQuyetDinhPheDuyetKHTT = this.state.soQuyetDinh;
      }
      if (this.state.nhomDoiTuong) {
        params.nhomDoiTuongId = Number(this.state.nhomDoiTuong);
      }
      if (this.state.trangThaiXuLyCuaDonVi) {
        params.trangThaiXuLyCuaDonVi = this.state.trangThaiXuLyCuaDonVi;
      }
      if (!(0, _lodash.isEmpty)(this.state.namThanhTra)) {
        params.namThanhTra = this.state.namThanhTra;
      }
      if (!(0, _lodash.isEmpty)(this.state.selectListItem)) {
        var selectListItem = this.state.selectListItem;

        var arrDonVis = selectListItem.map(function (item) {
          return (0, _lodash.get)(item, 'coQuanQuanLyId');
        });
        params.donViIds = arrDonVis.join(',');
      }
      this.setState({
        tableLoading: true
      });
      _api.ThanhTra.actions.getDSCuocThanhTraTrung.request(null, params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = (0, _lodash.get)(res, 'data._embedded.medial_CuocThanhTraTrungInfoes');
          var pageData = (0, _lodash.get)(res, 'data.page');
          var tableLoading = false;
          var selectData = data.map(function (item) {
            if (_this7.state.listSelected.includes((0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'))) {
              return _extends({}, item, {
                selected: true
              });
            }
            return item;
          });
          if (_this7.state.dataSave && !isSearch) {
            _this7.props.dispatch({
              type: 'ADD_DANH_SACH_TTT_SELECTED',
              data: _this7.state.listSelected
            });
          }
          _this7.setState({
            data: _this7.state.dataSave ? selectData : data,
            pageData: pageData,
            tableLoading: tableLoading
          });
        } else {
          var _tableLoading2 = false;
          _this7.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: _tableLoading2
          });
        }
      });
    }
  }, {
    key: 'getlichSuXuLyCTTTrungCurrent',
    value: function getlichSuXuLyCTTTrungCurrent() {
      var _this8 = this;

      _api.ThanhTra.actions.getlichSuXuLyCTTTrungCurrent.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this8.setState({
            listSelected: res.data.idDoiTuongXuLys,
            dataSave: res.data
          });
          _this8.props.dispatch({
            type: 'ADD_DANH_SACH_TTT_SELECTED',
            data: res.data.idDoiTuongXuLys
          });
        }
      });
    }
  }, {
    key: 'getLichSuXuLyCTTT',
    value: function getLichSuXuLyCTTT() {
      var _this9 = this;

      _api.ThanhTra.actions.getLichSuXuLyCTTTrung.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = res.data._embedded;
          _this9.setState({
            dataLichSuXuLy: data.lichSuXuLyCTTTrungs,
            lanXuly: (0, _lodash.get)(data, 'lichSuXuLyCTTTrungs[0].lanXuLy')
          });
        }
      });
    }
  }, {
    key: 'getDonVi',
    value: function getDonVi() {
      var _this10 = this;

      _api.ThanhTra.actions.getKHTTDonVi.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var dataListDonVi = (0, _lodash.get)(res, 'data._embedded.coQuanQuanLies');
          _this10.setState({ dataListDonVi: dataListDonVi });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this11 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this11.getDataList(true);
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this12 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this12.getDataList(true);
      });
    }
  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var _this13 = this;

      var data = this.state.data;

      var listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung')) || [];
      var newListSelected = [].concat(_toConsumableArray(listSelectTTT));
      var listData = data.map(function (item) {
        var checkSelected = listSelectTTT.includes(item.doiTuongThanhTraTrung.doiTuongThanhTraId);
        var statusSelected = function statusSelected() {
          if (item.namThanhTra === _this13.state.namThanhTraXuLy) {
            return checkSelected ? true : !_this13.state.checkAll;
          }
          return false;
        };
        if (!_this13.state.checkAll && !checkSelected && item.namThanhTra === _this13.state.namThanhTraXuLy) {
          newListSelected.push(item.doiTuongThanhTraTrung.doiTuongThanhTraId);
        }
        return _extends({}, item, {
          selected: statusSelected()
        });
      });
      this.setState({
        data: listData,
        checkAll: !this.state.checkAll,
        listSelected: newListSelected
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      if (!(0, _lodash.isEmpty)(this.state.listSelected)) {
        this.props.dispatch({
          type: 'ADD_DANH_SACH_TTT_SELECTED',
          data: this.state.listSelected
        });
        if (!(0, _lodash.isEmpty)(this.state.dataLichSuXuLy)) {
          this.setState({
            openDialog: true
          });
        } else {
          _reactRouter.browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly");
        }
      } else {
        (0, _toastr.Toastr)('Chưa chọn đối tượng trùng', 'warning');
      }
    }
  }, {
    key: 'handleContinue',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.dispatch({
                  type: 'ADD_DANH_SACH_TTT_SELECTED',
                  data: this.state.listSelected
                });

              case 2:
                _reactRouter.browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/tiep-tuc-xu-ly");

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleContinue() {
        return _ref2.apply(this, arguments);
      }

      return handleContinue;
    }()
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.getDataList(true);
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      if (name === 'dongY') {
        _reactRouter.browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly");
      }
      if (name === 'khong') {
        localStorage.removeItem('listSelectThanhTraTrung');
      }
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
      var donViIds = [].concat(_toConsumableArray(this.state.donViIds));
      selectListItem.splice(index, 1);
      donViIds.splice(index, 1);
      this.setState({
        donViIds: donViIds,
        selectListItem: selectListItem
      });
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        var _state, data, listSelected, newListData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                item.selected = !item.selected;
                _state = this.state, data = _state.data, listSelected = _state.listSelected;
                newListData = data.map(function (state) {
                  if ((0, _lodash.get)(state, 'doiTuongThanhTraTrung.doiTuongThanhTraId') === (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
                    if (item.selected) {
                      listSelected.push(state.doiTuongThanhTraTrung.doiTuongThanhTraId);
                    } else {
                      var index = listSelected.indexOf(state.doiTuongThanhTraTrung.doiTuongThanhTraId);
                      if (index > -1) {
                        listSelected.splice(index, 1);
                      }
                    }
                    return state = _extends({}, state, {
                      selected: item.selected
                    });
                  }
                  return state;
                });

                this.setState({
                  data: newListData,
                  listSelected: listSelected
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref3.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var showXuLy = !(0, _lodash.isEmpty)(this.state.dataXuLy);
      var btnTiepTuc = !!this.state.dataSave;
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container', ref: 'dskhtt' },
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.openDialog,
            onClose: this.closeDialog.bind(this),
            title: 'Th\xF4ng b\xE1o',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0 xuLyDialog' },
            _react2.default.createElement(
              'div',
              { className: 'pt10 pb20 txt-center' },
              'B\u1EA1n ch\u1EAFc ch\u1EAFn t\u1EA5t c\u1EA3 c\xE1c \u0111\u01A1n v\u1ECB \u0111\xE3 x\u1EED l\xFD tr\xF9ng l\u1EB7p ' + this.state.lanXuly + ' v\xE0 mu\u1ED1n ti\u1EBFp t\u1EE5c x\u1EED l\xFD tr\xF9ng l\u1EB7p !'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this, 'khong') },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-green action-todo', onClick: this.closeDialog.bind(this, 'dongY') },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'Danh m\u1EE5c cu\u1ED9c thanh tra/ki\u1EC3m tra tr\xF9ng'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'div',
                { className: 'col-83 no-gutter' },
                _react2.default.createElement(_common.Input, { className: 'col-25', label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra/ki\u1EC3m tra', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...', value: this.state.doiTuongThannhTra, onChange: this.onChange.bind(this, 'doiTuongThannhTra'), name: 'doiTuongThannhTra' }),
                _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT/KHKT', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 }),
                _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng', options: this.state.listNhomDoiTuong, keyName: 'nhomDoiTuongThanhTraId', valueName: 'ten', selectedValue: this.state.nhomDoiTuong, onChange: this.onChange.bind(this, 'nhomDoiTuong'), placeholder: true }),
                _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18', label: 'Tr\u1EA1ng th\xE1i x\u1EED l\xFD tr\xF9ng t\u1EA1i \u0111\u01A1n v\u1ECB', options: this.state.ttXuLyTTTCuaDonVi, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.trangThaiXuLyCuaDonVi, onChange: this.onChange.bind(this, 'trangThaiXuLyCuaDonVi'), placeholder: true })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-16 mb0-18 search-thanh-tra' },
                _react2.default.createElement(
                  'button',
                  { className: 'btn-green', onClick: this.handleSearch.bind(this) },
                  _react2.default.createElement('i', { className: 'tt-search' }),
                  'T\xECm ki\u1EBFm'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap-tt-dvph col-83 no-gutter' },
                _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.state.listNamThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true }),
                _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18', label: '\u0110\u01A1n v\u1ECB thanh tra/ki\u1EC3m tra', options: this.state.dataListDonVi, keyName: 'coQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this, 'donViThanhTra'), placeholder: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 mb18' },
                  _react2.default.createElement(
                    'div',
                    { className: 'ds-tt-dvph' },
                    this.state.selectListItem.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'tt-dvph-item', key: index },
                        _react2.default.createElement(
                          'span',
                          { className: 'tt-dvph-icon', onClick: _this14.removeDonVi.bind(_this14, index) },
                          '\xD7'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tt-dvph-value' },
                          item.ten
                        )
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _DataTableTTT2.default,
            {
              header: _table.header.thanhTraTrung.DMCTTT,
              handleExport: this.handleExport.bind(this),
              dataList: this.state.data,
              exporttext: 'Xu\u1EA5t Excel',
              thanhTra: true,
              showXuLy: showXuLy,
              openDialog: this.openDialog.bind(this),
              btnTiepTuc: btnTiepTuc,
              hideButtonExport: true,
              pageData: this.state.pageData,
              parent: this,
              search: true,
              handleContinue: this.handleContinue.bind(this),
              selectAllStatus: this.state.checkAll,
              onCheck: this.handleSelectedAll.bind(this),
              namThanhTra: this.state.namThanhTra,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhMucCuocThanhTraTrung, { namThanhTraXuLy: this.state.namThanhTraXuLy, listSelected: this.state.listSelected })
          )
        )
      );
    }
  }]);

  return DanhMucCuocThanhTraTrung;
}(_react.Component);

exports.default = (0, _reactRedux.connect)()(DanhMucCuocThanhTraTrung);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _config = __webpack_require__(16);

var _common = __webpack_require__(3);

var _datatable = __webpack_require__(130);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

var _downloadExcel = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucTongHopThanhTra = function (_Component) {
  _inherits(DanhMucTongHopThanhTra, _Component);

  function DanhMucTongHopThanhTra(props, context) {
    _classCallCheck(this, DanhMucTongHopThanhTra);

    var _this = _possibleConstructorReturn(this, (DanhMucTongHopThanhTra.__proto__ || Object.getPrototypeOf(DanhMucTongHopThanhTra)).call(this, props, context));

    _this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      loading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      denNgay: '',
      tuNgay: '',
      data: [],
      type: '',
      selectListItem: [],
      listNamThanhTra: [],
      listloaiHinhThanhTra: [{
        giaTri: "THANH_TRA",
        ten: "Thanh tra"
      }, {
        giaTri: "KIEM_TRA",
        ten: "Kiểm tra"
      }]
    };
    return _this;
  }

  _createClass(DanhMucTongHopThanhTra, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.checkNamThanhTraXuLy();

              case 2:
                this.getDSCuocThanhTra();
                this.getDonVi();
                // this.getLoaiHinhThanhTra();
                this.getPhanLoaiHinhThucCTT();
                this.getNamThanhTraList();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()

    // getLoaiHinhThanhTra() {
    //   ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
    //     if (!isEmpty(res.data)) {
    //       const listloaiHinhThanhTra = get(res, 'data') || [];
    //       this.setState({ listloaiHinhThanhTra });
    //     } else {
    //       this.setState({ listloaiHinhThanhTra: [] });
    //     }
    //   });
    // }

  }, {
    key: 'checkNamThanhTraXuLy',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if ((0, _lodash.isEmpty)(res.data)) {
                              _context2.next = 3;
                              break;
                            }

                            _context2.next = 3;
                            return _this2.setState({
                              namThanhTra: (0, _lodash.get)(res, 'data.namThanhTra')
                            });

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkNamThanhTraXuLy() {
        return _ref2.apply(this, arguments);
      }

      return checkNamThanhTraXuLy;
    }()
  }, {
    key: 'getPhanLoaiHinhThucCTT',
    value: function getPhanLoaiHinhThucCTT() {
      var _this3 = this;

      _api.ThanhTra.actions.nhomHinhThucCuocThanhTraPhanLoai.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var listphanLoai = (0, _lodash.get)(res, 'data') || [];
          _this3.setState({ listphanLoai: listphanLoai });
        } else {
          _this3.setState({ listphanLoai: [] });
        }
      });
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this4 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this4.setState({
            listNamThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDSCuocThanhTra',
    value: function getDSCuocThanhTra() {
      var _this5 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        isTatCaDonVi: true
      };

      if (this.state.tenDoiTuongThanhTra) {
        params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
      }

      if (this.state.phanLoai) {
        params.phanLoai = this.state.phanLoai;
      }

      if (this.state.soQuyetDinh) {
        params.soQuyetDinh = this.state.soQuyetDinh;
      }

      if (this.state.loaiHinhThanhTra) {
        params.loaiKeHoach = this.state.loaiHinhThanhTra;
      }

      if (this.state.quyetDinhPheDuyetKHTT) {
        params.quyetDinhPheDuyetKHTT = this.state.quyetDinhPheDuyetKHTT;
      }

      if (this.state.tienDoThanhTra) {
        params.tienDoThanhTra = this.state.tienDoThanhTra;
      }

      if (this.state.tuNgay) {
        params.tuNgay = (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.denNgay) {
        params.denNgay = (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.soKetLuanThanhTra) {
        params.soKetLuanThanhTra = this.state.soKetLuanThanhTra;
      }

      if (this.state.soQuyetDinhXL) {
        params.soQuyetDinhXL = this.state.soQuyetDinhXL;
      }

      if (!(0, _lodash.isEmpty)(this.state.namThanhTra)) {
        params.namThanhTra = this.state.namThanhTra;
      }

      if (!(0, _lodash.isEmpty)(this.state.selectListItem)) {
        var selectListItem = this.state.selectListItem || [];
        var arrDonVis = selectListItem.map(function (item) {
          return (0, _lodash.get)(item, 'coQuanQuanLyId');
        });
        params.donViIds = arrDonVis.join(',');
      }
      this.setState({
        tableLoading: true
      });
      _api.ThanhTra.actions.getCuocThanhTra.request(null, params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {

          var data = (0, _lodash.get)(res, 'data._embedded.cuocThanhTras') || [];
          var pageData = (0, _lodash.get)(res, 'data.page');
          var tableLoading = false;
          var search = false;
          _this5.setState({
            data: data,
            pageData: pageData,
            tableLoading: tableLoading,
            search: search
          });
        } else {
          var _tableLoading = false;
          var _search = false;
          _this5.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: _tableLoading,
            search: _search
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this6 = this;

      this.setState({
        type: nextProps.type
      }, function () {
        _this6.getDSCuocThanhTra();
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.getDSCuocThanhTra();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'donViThanhTra') {
        var dataListDonVi = this.state.dataListDonVi;

        var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
        var checkItem = selectListItem.findIndex(function (item) {
          return Number(item.coQuanQuanLyId) === Number(e.target.value);
        });
        if (checkItem === -1) {
          var selectItem = dataListDonVi.find(function (item) {
            return Number(item.coQuanQuanLyId) === Number(e.target.value);
          });
          selectListItem.push(selectItem);
        }
        this.setState({
          selectListItem: selectListItem
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var name = 'danh-muc-cuoc-thanh-tra-kiem-tra-cua-cac-don-vi';
      var apiUrl = '/cuocThanhTras/export-excel';
      var donViIds = this.state.selectListItem.map(function (item) {
        return item.coQuanQuanLyId;
      }).join(',');
      // eslint-disable-next-line no-useless-concat
      var URL = String(_config.API_URL) + '/' + apiUrl + "?soQuyetDinh=" + this.state.soQuyetDinh + "&tuNgay=" + (this.state.tuNgay ? (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&denNgay=" + (this.state.denNgay ? (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '') + "&tenDoiTuongThanhTra=" + (this.state.tenDoiTuongThanhTra ? this.state.tenDoiTuongThanhTra : '') + "&donViIds=" + (donViIds ? donViIds : []) + "&phanLoai=" + (this.state.phanLoai ? this.state.phanLoai : '') + "&loaiKeHoach=" + (this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : '') + "&tienDoThanhTra=" + (this.state.tienDoThanhTra ? this.state.tienDoThanhTra : '') + "&soKetLuanThanhTra=" + (this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '') + "&soQuyetDinhXL=" + (this.state.soQuyetDinhXL ? this.state.soQuyetDinhXL : '') + "&isTatCaDonVi=true";

      (0, _downloadExcel.downloadExcel)(URL, name, true);
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
      selectListItem.splice(index, 1);
      this.setState({
        selectListItem: selectListItem
      });
    }
  }, {
    key: 'getDonVi',
    value: function getDonVi() {
      var _this7 = this;

      _api.ThanhTra.actions.getKHTTDonVi.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = (0, _lodash.get)(res, 'data._embedded.coQuanQuanLies');
          _this7.setState({
            dataListDonVi: data
          });
        } else {
          _this7.setState({ dataListDonVi: [] });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this8 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this8.getDSCuocThanhTra();
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this9 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this9.getDSCuocThanhTra();
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      return _react2.default.createElement(
        'div',
        { className: 'center reception-container', ref: 'dskhtt' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'DANH M\u1EE4C T\u1ED4NG H\u1EE2P CU\u1ED8C THANH TRA, KI\u1EC2M TRA C\u1EE6A C\xC1C \u0110\u01A0N V\u1ECA'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'form',
              { onSubmit: this.handleSearch.bind(this) },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(_common.Input, { className: 'col-60', label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra/ki\u1EC3m tra', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra t\xECm ki\u1EBFm...', value: this.state.tenDoiTuongThanhTra, onChange: this.onChange.bind(this, 'tenDoiTuongThanhTra'), name: 'tenDoiTuongThanhTra' }),
                  _react2.default.createElement(_common.DropDown, { className: 'col-20 mb18', label: 'Lo\u1EA1i h\xECnh thanh tra, ki\u1EC3m tra', options: this.state.listloaiHinhThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.loaiHinhThanhTra, onChange: this.onChange.bind(this, 'loaiHinhThanhTra'), placeholder: true }),
                  _react2.default.createElement(_common.Input, { className: 'col-20', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-16 mb0-18 search-thanh-tra' },
                  _react2.default.createElement(
                    'button',
                    { className: 'btn-green' },
                    _react2.default.createElement('i', { className: 'tt-search' }),
                    'T\xECm ki\u1EBFm'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: '\u0110\u1EBFn ng\xE0y', bindVaidator: this, channel: 'formTaoDon', onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
                  _react2.default.createElement(_common.Input, { className: 'col-20', label: 'S\u1ED1 k\u1EBFt lu\u1EADn thanh tra, ki\u1EC3m tra', placeholder: 'Nh\u1EADp...', value: this.state.soKetLuanThanhTra, onChange: this.onChange.bind(this, 'soKetLuanThanhTra'), name: 'soKetLuanThanhTra', maxLength: 255 }),
                  _react2.default.createElement(_common.Input, { className: 'col-20', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh XL', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinhXL, onChange: this.onChange.bind(this, 'soQuyetDinhXL'), name: 'soQuyetDinhXL', maxLength: 255 }),
                  _react2.default.createElement(_common.DropDown, { className: 'col-20', label: 'Ph\xE2n lo\u1EA1i', options: this.state.listphanLoai, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.phanLoai, onChange: this.onChange.bind(this, 'phanLoai'), placeholder: true })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-tt-dvph col-83 no-gutter' },
                  _react2.default.createElement(_common.DropDown, { className: 'col-20 mb18', label: 'N\u0103m thanh tra, ki\u1EC3m tra', options: this.state.listNamThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true }),
                  _react2.default.createElement(_common.DropDown, { className: 'col-20 mb18', label: '\u0110\u01A1n v\u1ECB', options: this.state.dataListDonVi, keyName: 'coQuanQuanLyId', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'donViThanhTra'), placeholder: true }),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-60 mb18' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ds-tt-dvph' },
                      this.state.selectListItem.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'tt-dvph-item', key: index },
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-icon', onClick: _this10.removeDonVi.bind(_this10, index) },
                            '\xD7'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-value' },
                            item.ten
                          )
                        );
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.thanhTraTrung.DMTHCTTCDV,
              handleExport: this.handleExport.bind(this),
              dataList: this.state.data,
              exporttext: 'Xu\u1EA5t Excel',
              thanhTra: true,
              hideButtonExport: false,
              pageData: this.state.pageData,
              parent: this,
              search: true,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhMucTongHopThanhTra, null)
          )
        )
      );
    }
  }]);

  return DanhMucTongHopThanhTra;
}(_react.Component);

exports.default = DanhMucTongHopThanhTra;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _common = __webpack_require__(3);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _reactRouter = __webpack_require__(2);

var _datatable = __webpack_require__(130);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _core = __webpack_require__(7);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachLichSuXuLyTTT = function (_Component) {
  _inherits(DanhSachLichSuXuLyTTT, _Component);

  function DanhSachLichSuXuLyTTT(props) {
    _classCallCheck(this, DanhSachLichSuXuLyTTT);

    var _this = _possibleConstructorReturn(this, (DanhSachLichSuXuLyTTT.__proto__ || Object.getPrototypeOf(DanhSachLichSuXuLyTTT)).call(this, props));

    _this.state = {
      namThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      dataLichSuXuLy: [],
      dsNamThanhTra: [],
      soQuyetDinh: ''
    };
    return _this;
  }

  _createClass(DanhSachLichSuXuLyTTT, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.checkNamThanhTraXuLy();

              case 2:
                this.getNamThanhTra();
                this.getLichSuXuLyCTTT();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'checkNamThanhTraXuLy',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if ((0, _lodash.isEmpty)(res.data)) {
                              _context2.next = 3;
                              break;
                            }

                            _context2.next = 3;
                            return _this2.setState({
                              namThanhTra: (0, _lodash.get)(res, 'data.namThanhTra')
                            });

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkNamThanhTraXuLy() {
        return _ref2.apply(this, arguments);
      }

      return checkNamThanhTraXuLy;
    }()
  }, {
    key: 'getNamThanhTra',
    value: function getNamThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dsNamThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getLichSuXuLyCTTT',
    value: function getLichSuXuLyCTTT() {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.namThanhTra) {
        params.namThanhTra = this.state.namThanhTra;
      }

      if (this.state.soQuyetDinh) {
        params.soQuyetDinhPheDuyet = this.state.soQuyetDinh;
      }
      _api.ThanhTra.actions.getLichSuXuLyCTTTrung.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = res.data._embedded;
          _this4.setState({
            dataLichSuXuLy: data.lichSuXuLyCTTTrungs,
            tableLoading: false
          });
        } else {
          _this4.setState({
            dataLichSuXuLy: [],
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.getLichSuXuLyCTTT();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              'span',
              { className: 'arrow-left txt-blue txt-underline', onClick: this.goBack.bind(this) },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'Danh s\xE1ch l\u1ECBch s\u1EED x\u1EED l\xFD thanh tra/ki\u1EC3m tra tr\xF9ng'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-block search_form_lichsu' },
              _react2.default.createElement(
                'div',
                { className: 'row plr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'search_form_ttt' },
                    _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.state.dsNamThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT/KHKT', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 }),
                    _react2.default.createElement(_core.Button, { className: 'btn-green ttt-search', text: 'T\xECm ki\u1EBFm', onClick: this.handleSearch.bind(this), disabled: this.state.searching ? 'disabled' : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.thanhTraTrung.DSLSXLTTT,
                dataList: this.state.dataLichSuXuLy,
                thanhTra: true,
                hideButtonExport: true,
                hidePagination: true,
                pageData: this.state.pageData,
                parent: this,
                search: true,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_datatable.RowItemLichSuXuLy, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.goBack.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachLichSuXuLyTTT;
}(_react.Component);

DanhSachLichSuXuLyTTT.defaultProps = {
  namThanhTra: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DanhSachLichSuXuLyTTT);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _common = __webpack_require__(3);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(130);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachThongBao = function (_Component) {
  _inherits(DanhSachThongBao, _Component);

  function DanhSachThongBao(props) {
    _classCallCheck(this, DanhSachThongBao);

    var _this = _possibleConstructorReturn(this, (DanhSachThongBao.__proto__ || Object.getPrototypeOf(DanhSachThongBao)).call(this, props));

    _this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      dataDSThongBao: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      }
    };
    return _this;
  }

  _createClass(DanhSachThongBao, [{
    key: 'onChange',
    value: function onChange() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getNotify();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this2 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this2.getNotify();
      });
    }
  }, {
    key: 'getNotify',
    value: function getNotify() {
      var _this3 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };
      _api.TrangChu.actions.getThongBao.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            dataDSThongBao: res.data._embedded.thongBaos,
            pageData: res.data.page
          });
        } else {
          _this3.setState({
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            }
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getNotify();
    }
  }, {
    key: 'getDanhSachThongBao',
    value: function getDanhSachThongBao() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container', ref: 'dstb' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'Danh s\xE1ch th\xF4ng b\xE1o'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-block pl15 pr15 pt20' },
              _react2.default.createElement(
                'form',
                { onSubmit: this.getDanhSachThongBao.bind(this, true) },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-83 no-gutter' },
                    _react2.default.createElement(_common.Input, { className: 'col-40', label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra t\xECm ki\u1EBFm...', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-20 mb0-18 search-thanh-tra' },
                      _react2.default.createElement(
                        'button',
                        { className: 'btn-green' },
                        _react2.default.createElement('i', { className: 'tt-search' }),
                        'T\xECm ki\u1EBFm'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.thanhTraTrung.DSTB,
                dataList: this.state.dataDSThongBao,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                search: true,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_datatable.RowItemDSThongBao, null)
            )
          )
        )
      );
    }
  }]);

  return DanhSachThongBao;
}(_react.Component);

exports.default = DanhSachThongBao;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _config = __webpack_require__(16);

var _common = __webpack_require__(3);

var _datatable = __webpack_require__(130);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _downloadExcel = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachTongHopKHTT = function (_Component) {
  _inherits(DanhSachTongHopKHTT, _Component);

  function DanhSachTongHopKHTT(props, context) {
    _classCallCheck(this, DanhSachTongHopKHTT);

    var _this = _possibleConstructorReturn(this, (DanhSachTongHopKHTT.__proto__ || Object.getPrototypeOf(DanhSachTongHopKHTT)).call(this, props, context));

    _this.state = {
      loading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      namThanhTra: '',
      dsNamTT: [],
      dataKeHoachThanhTra: [],
      dataListDonVi: [],
      selectListItem: [],
      listNamThanhTra: [],
      loaiHinhThanhTraList: [{
        giaTri: "THANH_TRA",
        ten: "Thanh tra"
      }, {
        giaTri: "KIEM_TRA",
        ten: "Kiểm tra"
      }]
    };
    return _this;
  }

  _createClass(DanhSachTongHopKHTT, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getKeHoachThanhTraList();
      this.getDonVi();
      this.getNamThanhTraList();
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this2 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this2.setState({
            listNamThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'getKeHoachThanhTraList',
    value: function getKeHoachThanhTraList(isSearch) {
      var _this3 = this;

      var params = {
        page: isSearch ? 0 : this.state.pageData.number,
        size: isSearch ? 10 : this.state.pageData.size,
        isTatCaDonVi: true
      };

      if (this.state.loaiKeHoach) {
        params.loaiKeHoach = this.state.loaiKeHoach;
      }

      if (!(0, _lodash.isEmpty)(this.state.selectListItem)) {
        var selectListItem = this.state.selectListItem || [];
        var arrDonVis = selectListItem.map(function (item) {
          return (0, _lodash.get)(item, 'coQuanQuanLyId');
        });
        params.donViIds = arrDonVis.join(',');
      }

      if (this.state.tuNgay) {
        params.tuNgay = (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (this.state.denNgay) {
        params.denNgay = (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
      if (!(0, _lodash.isEmpty)(this.state.namThanhTra)) {
        params.namThanhTra = this.state.namThanhTra;
      }
      this.setState({
        tableLoading: true
      });
      _api.ThanhTra.actions.getKeHoachThanhTra.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var dataKeHoachThanhTra = (0, _lodash.get)(res, 'data._embedded.medial_KeHoachThanhTra_DanhSaches') || [];
          var pageData = (0, _lodash.get)(res, 'data.page');
          var tableLoading = false;
          _this3.setState({
            dataKeHoachThanhTra: dataKeHoachThanhTra,
            pageData: pageData,
            tableLoading: tableLoading
          });
        } else {
          var _tableLoading = false;
          _this3.setState({
            dataKeHoachThanhTra: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: _tableLoading
          });
        }
      });
    }
  }, {
    key: 'getDonVi',
    value: function getDonVi() {
      var _this4 = this;

      _api.ThanhTra.actions.getKHTTDonVi.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data._embedded)) {
          var data = (0, _lodash.get)(res, 'data._embedded.coQuanQuanLies');
          _this4.setState({
            dataListDonVi: data
          });
        } else {
          _this4.setState({
            dataListDonVi: []
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'donViThanhTra') {
        var dataListDonVi = this.state.dataListDonVi;

        var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
        var checkItem = selectListItem.findIndex(function (item) {
          return Number(item.coQuanQuanLyId) === Number(e.target.value);
        });
        if (checkItem === -1) {
          var selectItem = dataListDonVi.find(function (item) {
            return Number(item.coQuanQuanLyId) === Number(e.target.value);
          });
          selectListItem.push(selectItem);
        }
        this.setState({
          selectListItem: selectListItem
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {}
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: 0,
          size: size
        })
      }, function () {
        _this5.getKeHoachThanhTraList();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this6 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this6.getKeHoachThanhTraList();
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.getKeHoachThanhTraList(true);
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var selectListItem = [].concat(_toConsumableArray(this.state.selectListItem));
      selectListItem.splice(index, 1);
      this.setState({
        selectListItem: selectListItem
      });
    }
  }, {
    key: 'exportExcel',
    value: function exportExcel() {
      var name = 'danh-sach-tong-hop-khtt-cua-cac-don-vi.xlsx';
      var apiUrl = 'keHoachThanhTras/export-excel';
      var donViIds = this.state.selectListItem.map(function (item) {
        return item.coQuanQuanLyId;
      }).join(',');
      var URL = String(_config.API_URL) + '/' + apiUrl + '?&tuNgay=' + (this.state.tuNgay ? (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&denNgay=" + (this.state.denNgay ? (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '') + "&donViIds=" + (donViIds ? donViIds : []) + "&isTatCaDonVi=true";

      (0, _downloadExcel.downloadExcel)(URL, name, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container', ref: 'dskhtt' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'Danh s\xE1ch t\u1ED5ng h\u1EE3p KHTT/KHKT c\u1EE7a c\xE1c \u0111\u01A1n v\u1ECB'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-block pl15 pr15 pt20' },
              _react2.default.createElement(
                'form',
                { onSubmit: this.handleSearch.bind(this) },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-83 no-gutter' },
                    _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
                    _react2.default.createElement(_common.DropDown, { className: 'col-20 mb18', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.state.listNamThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, "namThanhTra"), placeholder: true }),
                    _react2.default.createElement(_common.DropDown, { label: 'Lo\u1EA1i h\xECnh thanh tra/ki\u1EC3m tra', selectedValue: this.state.loaiKeHoach, placeholder: true, className: 'col-25', onChange: this.handleChange.bind(this, 'loaiKeHoach'), name: 'loaiKeHoach',
                      options: this.state.loaiHinhThanhTraList, keyName: 'giaTri', valueName: 'ten' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-16 mb0-18 search-thanh-tra' },
                    _react2.default.createElement(
                      'button',
                      { className: 'btn-green' },
                      _react2.default.createElement('i', { className: 'tt-search' }),
                      'T\xECm ki\u1EBFm'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-tt-dvph col-83 no-gutter' },
                    _react2.default.createElement(_common.DropDown, { className: 'col-20 mb18', label: '\u0110\u01A1n v\u1ECB', options: this.state.dataListDonVi, keyName: 'coQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this, 'donViThanhTra'), placeholder: true }),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-80 mb18' },
                      _react2.default.createElement(
                        'div',
                        { className: 'ds-tt-dvph' },
                        this.state.selectListItem.map(function (item, index) {
                          return _react2.default.createElement(
                            'div',
                            { className: 'tt-dvph-item', key: index },
                            _react2.default.createElement(
                              'span',
                              { className: 'tt-dvph-icon', onClick: _this7.removeDonVi.bind(_this7, index) },
                              '\xD7'
                            ),
                            _react2.default.createElement(
                              'span',
                              { className: 'tt-dvph-value' },
                              item.ten
                            )
                          );
                        })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.thanhTraTrung.DSTHKHTT,
                dataList: this.state.dataKeHoachThanhTra,
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                hideButtonExport: false,
                handleExport: this.exportExcel.bind(this),
                pageData: this.state.pageData,
                parent: this,
                search: true,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_datatable.RowItemDSTongHopKHTTDonVi, null)
            )
          )
        )
      );
    }
  }]);

  return DanhSachTongHopKHTT;
}(_react.Component);

exports.default = DanhSachTongHopKHTT;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _reactRouter = __webpack_require__(2);

var _ThongTinChungView = __webpack_require__(1329);

var _ThongTinChungView2 = _interopRequireDefault(_ThongTinChungView);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(130);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeHoachThanhTraDetails = function (_Component) {
  _inherits(KeHoachThanhTraDetails, _Component);

  function KeHoachThanhTraDetails(props) {
    _classCallCheck(this, KeHoachThanhTraDetails);

    var _this = _possibleConstructorReturn(this, (KeHoachThanhTraDetails.__proto__ || Object.getPrototypeOf(KeHoachThanhTraDetails)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(KeHoachThanhTraDetails, [{
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params && this.props.params.id) {
        this.getDetailKHTT(this.props.params.id);
      }
    }
  }, {
    key: 'getDetailKHTT',
    value: function getDetailKHTT(idKH) {
      var _this2 = this;

      _api.ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(function (res) {
        if (res.data) {
          var state = _this2.state;
          state.detail = res.data;
          state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
          state.sendToThanhTra = res.data.saveTamKeHoachTT;
          state.enableEdit = res.data.cuocThanhTras.length == 0;
          res.data.cuocThanhTras.map(function (item2) {
            if (item2.tienDoThanhTraInfo == null) {
              state.enableEdit = true;
            }
          });
          _this2.setState(_extends({}, state));
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var type = (0, _lodash.get)(this.state.detail, 'loaiKeHoach.value') === 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra';
      var dataCuocThanhTra = this.state.detail && this.state.detail.cuocThanhTras;
      var namThanhTra = this.state.detail && this.state.detail.namThanhTra;
      var dataTepDinhKem = this.state.detail && this.state.detail.taiLieuVanThus;
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.onClickClose.bind(this, 'close'), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'K\u1EBF ho\u1EA1ch ' + type + ' n\u0103m ' + namThanhTra
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_ThongTinChungView2.default, { details: this.state.detail, type: type })
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'div',
                  { className: 'col' },
                  _react2.default.createElement(
                    'h3',
                    { className: 'mb15 tt-title' },
                    '2. Danh m\u1EE5c ',
                    type
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'ttt-wrapper-table' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.thanhTraTrung.KHTTD,
                  dataList: dataCuocThanhTra,
                  hideButtonExport: true,
                  hidePagination: true,
                  parent: this,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.RowItemDanhMucCuocThanhTra, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { disableTopLine: true, labelClass: 'tt-title', label: '3. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: dataTepDinhKem })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return KeHoachThanhTraDetails;
}(_react.Component);

exports.default = KeHoachThanhTraDetails;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingThongBao = function (_Component) {
  _inherits(LoadingThongBao, _Component);

  function LoadingThongBao() {
    _classCallCheck(this, LoadingThongBao);

    return _possibleConstructorReturn(this, (LoadingThongBao.__proto__ || Object.getPrototypeOf(LoadingThongBao)).apply(this, arguments));
  }

  _createClass(LoadingThongBao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _reactRouter.browserHistory.push('/thanh-tra/chi-tiet-thong-bao/' + this.props.params.id);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'wrap-loading' },
          _react2.default.createElement('img', { src: __webpack_require__(623) })
        )
      );
    }
  }]);

  return LoadingThongBao;
}(_react.Component);

exports.default = LoadingThongBao;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationDetails = function (_Component) {
  _inherits(NotificationDetails, _Component);

  function NotificationDetails(props) {
    _classCallCheck(this, NotificationDetails);

    var _this = _possibleConstructorReturn(this, (NotificationDetails.__proto__ || Object.getPrototypeOf(NotificationDetails)).call(this, props));

    _this.state = {
      content: '',
      ngayTao: ''
    };
    return _this;
  }

  _createClass(NotificationDetails, [{
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.push('/thanh-tra/danh-sach-thong-bao');
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.params && this.props.params.id) {
        this.getThongBao(this.props.params.id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.params && this.props.params.id;
      var newId = nextProps.params && nextProps.params.id;
      if (newId !== oldId) {
        this.getThongBao(newId);
      }
    }
  }, {
    key: 'getThongBao',
    value: function getThongBao(id) {
      var _this2 = this;

      _api.TrangChu.actions.getChiTietThongBao.request({ id: id }).then(function (res) {
        if (res.data) {
          _this2.setState(_extends({}, res.data));
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.onClickClose.bind(this), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'Th\xF4ng tin chi ti\u1EBFt th\xF4ng b\xE1o'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'group-box' },
              _react2.default.createElement(
                'div',
                { className: 'items-form mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, { label: 'Ng\xE0y th\xF4ng b\xE1o:', className: 'col-20', value: this.state.ngayTao ? (0, _moment2.default)(this.state.ngayTao).format('DD/MM/YYYY') : "" })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'items-form mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, { label: 'N\u1ED9i dung th\xF4ng b\xE1o:', className: 'col-60', value: this.state.content })
                )
              ),
              !(0, _lodash.isEmpty)(this.state.typeDetail) && _react2.default.createElement(
                'div',
                { className: 'items-form mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(_common.Text, { label: 'N\u1ED9i dung \u0111\u1EC1 xu\u1EA5t:', className: 'col-60', value: this.state.contentDetail })
                )
              ),
              !(0, _lodash.isEmpty)(this.state.typeDetail) && _react2.default.createElement(
                'div',
                { className: 'items-form mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows pl-5' },
                  'Vui l\xF2ng v\xE0o menu Thanh tra c\u1EADp nh\u1EADt \u0111\u1EC3 tr\xE1nh ch\u1ED3ng ch\xE9o.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return NotificationDetails;
}(_react.Component);

exports.default = NotificationDetails;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bellIcon = __webpack_require__(2006);

var NotificationTTT = function (_React$Component) {
  _inherits(NotificationTTT, _React$Component);

  function NotificationTTT(props, context) {
    _classCallCheck(this, NotificationTTT);

    var _this = _possibleConstructorReturn(this, (NotificationTTT.__proto__ || Object.getPrototypeOf(NotificationTTT)).call(this, props, context));

    _this.state = {
      notifyCount: 0,
      data: [],
      page: 0,
      hasMore: false,
      onOpen: false
    };
    return _this;
  }

  _createClass(NotificationTTT, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getNotify();
      this.getUnreadNotify();
    }
  }, {
    key: 'getUnreadNotify',
    value: function getUnreadNotify() {
      var _this2 = this;

      _api.TrangChu.actions.getUnreadNotify.request().then(function (res) {
        if (_this2.refs.notify) {
          if (res.data) {
            _this2.setState({ notifyCount: res.data });
          }
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'getNotify',
    value: function getNotify() {
      var _this3 = this;

      _api.TrangChu.actions.getThongBao.request(null, { size: 3, page: this.state.page }).then(function (res) {
        if (_this3.refs.notify) {
          var state = _this3.state;
          if (res.data && res.data._embedded) {
            state.data = [].concat(_toConsumableArray(res.data._embedded.thongBaos));
            state.totalElements = res.data.page.totalElements;
          } else {
            state.data = [];
            state.notifyCount = 0;
          }
          _this3.setState(_extends({}, state));
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'openNoiti',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState(function (prevState) {
                  return {
                    onOpen: !prevState.onOpen
                  };
                });

              case 2:
                if (this.state.onOpen) {
                  this.getNotify();
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openNoiti() {
        return _ref.apply(this, arguments);
      }

      return openNoiti;
    }()
  }, {
    key: 'handleClickNoti',
    value: function handleClickNoti(id) {
      _reactRouter.browserHistory.push('/thanh-tra/chi-tiet-thong-bao/' + id);
    }
  }, {
    key: 'checkCountNoti',
    value: function checkCountNoti() {
      if (this.state.notifyCount > 0 && this.state.notifyCount < 100) {
        return _react2.default.createElement(
          'span',
          { className: 'menu-notification bell' },
          this.state.notifyCount
        );
      } else if (this.state.notifyCount > 99) {
        return _react2.default.createElement(
          'span',
          { className: 'menu-notification bell' },
          '99',
          _react2.default.createElement(
            'sup',
            null,
            '+'
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { ref: 'notify' },
        _react2.default.createElement(
          _core.Popover,
          {
            interactionKind: _core.PopoverInteractionKind.CLICK,
            popoverClassName: (0, _classnames2.default)('pt-popover-content-sizing notify-box', {
              'arrow-unread': this.state.data.length && !this.state.data[0].daXem
            }),
            position: _core.Position.BOTTOM,
            className: 'mt10'
          },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'notification-wrap', onClick: this.openNoiti.bind(this) },
            _react2.default.createElement('img', { src: bellIcon, alt: 'bell-icon', className: 'bell-ico' }),
            this.checkCountNoti()
          ),
          _react2.default.createElement(
            'div',
            { className: 'notify-content' },
            _react2.default.createElement(
              'ul',
              null,
              this.state.data && this.state.data.length > 0 ? _react2.default.createElement(
                'div',
                null,
                this.state.data.map(function (item, index) {
                  return _react2.default.createElement(
                    'li',
                    { className: (0, _classnames2.default)('ttt-notification', { 'unread': item.daXem === false }), key: index },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'notification-item', onClick: _this4.handleClickNoti.bind(_this4, item.thongBaoId) },
                      _react2.default.createElement(
                        'div',
                        { className: 'pd10' },
                        _react2.default.createElement(_reactTextTruncate2.default, {
                          line: 3,
                          truncateText: '\u2026',
                          text: item.content
                        })
                      )
                    )
                  );
                }),
                this.state.totalElements > 3 && _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/thanh-tra/danh-sach-thong-bao', className: 'btn-action btn-green jt-center col-100' },
                  'Xem t\u1EA5t c\u1EA3 th\xF4ng b\xE1o',
                  _react2.default.createElement('span', { className: 'tt-arrow-right' })
                )
              ) : _react2.default.createElement(
                'li',
                { className: 'unlink', key: 1 },
                'Ch\u01B0a c\xF3 th\xF4ng b\xE1o m\u1EDBi n\xE0o!'
              )
            )
          )
        )
      );
    }
  }]);

  return NotificationTTT;
}(_react2.default.Component);

function bindStateToProps(state) {
  return {
    notifyData: state.duLieuHeThong.notify
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(NotificationTTT);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _ThongTinKeHoachThanhTra = __webpack_require__(1331);

var _ThongTinKeHoachThanhTra2 = _interopRequireDefault(_ThongTinKeHoachThanhTra);

var _ThongTinCuocThanhTra = __webpack_require__(1330);

var _ThongTinCuocThanhTra2 = _interopRequireDefault(_ThongTinCuocThanhTra);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinChiTietCuocThanhTra = function (_Component) {
  _inherits(ThongTinChiTietCuocThanhTra, _Component);

  function ThongTinChiTietCuocThanhTra(props) {
    _classCallCheck(this, ThongTinChiTietCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (ThongTinChiTietCuocThanhTra.__proto__ || Object.getPrototypeOf(ThongTinChiTietCuocThanhTra)).call(this, props));

    _this.state = {
      type: ''
    };
    return _this;
  }

  _createClass(ThongTinChiTietCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var id = this.props.params && this.props.params.id;
      this.getChiTietCuocThanhTra(id);
      if (this.props.route.type) {
        this.setState({
          type: this.props.route.type
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.params && this.props.params.id;
      var newId = nextProps.params && nextProps.params.id;
      if (newId !== oldId) {
        this.getChiTietCuocThanhTra(newId);
      }
      if (nextProps.route.type) {
        this.setState({
          type: nextProps.route.type
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'getChiTietCuocThanhTra',
    value: function getChiTietCuocThanhTra(id) {
      var _this2 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this2.setState({
            dataDetail: res.data
          }, function () {
            _this2.getChiTietLienQuanCuocThanhTra(id);
          });
        }
      });
    }
  }, {
    key: 'getChiTietLienQuanCuocThanhTra',
    value: function getChiTietLienQuanCuocThanhTra(id) {
      var _this3 = this;

      _api.ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this3.setState({
            listTaiLieuVanThuThongTinCuocThanhTra: res.data.listTaiLieuVanThuThongTinCuocThanhTra
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dataDetail = this.state.dataDetail;
      var keHoachThanhTraInfo = dataDetail && dataDetail.keHoachThanhTraInfo ? dataDetail.keHoachThanhTraInfo : {};
      // alias = ChiTietThanhTraTrung thì sẽ hiển thị form của thanh tra trùng
      var isKiemTra = (0, _lodash.get)(dataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
      var loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
      var keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center wrap-block' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.onClickClose.bind(this, 'close'), title: '' },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-detail' },
              'Th\xF4ng tin chi ti\u1EBFt cu\u1ED9c ',
              loaiCuocText
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_ThongTinKeHoachThanhTra2.default, { data: keHoachThanhTraInfo, loaiCuocText: loaiCuocText, keHoachText: keHoachText })
          ),
          _react2.default.createElement(
            'div',
            { className: 'page-wrapper' },
            _react2.default.createElement(_ThongTinCuocThanhTra2.default, { type: this.state.type, dataCuocThanhTra: this.state, loaiCuocText: loaiCuocText })
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.onClickClose.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinChiTietCuocThanhTra;
}(_react.Component);

exports.default = ThongTinChiTietCuocThanhTra;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinChungView = function (_Component) {
  _inherits(ThongTinChungView, _Component);

  function ThongTinChungView(props) {
    _classCallCheck(this, ThongTinChungView);

    var _this = _possibleConstructorReturn(this, (ThongTinChungView.__proto__ || Object.getPrototypeOf(ThongTinChungView)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ThongTinChungView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(_extends({}, nextProps.details));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  { className: 'mb15 tt-title' },
                  '1. Th\xF4ng tin chung'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + (this.props.type || 'thanh tra') + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + (this.props.type || 'thanh tra') + ' n\u0103m ' + this.state.namThanhTra }),
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT:', className: 'col-20', value: this.state.quyetDinhPheDuyetKTTT }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: this.state.ngayRaQuyetDinh ? (0, _moment2.default)(this.state.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'T\xF3m t\u1EAFt k\u1EBF ho\u1EA1ch:', className: 'col-100', value: this.state.ghiChu })
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinChungView;
}(_react.Component);

exports.default = ThongTinChungView;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _dialog = __webpack_require__(18);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinCuocThanhTra = function (_Component) {
  _inherits(ThongTinCuocThanhTra, _Component);

  function ThongTinCuocThanhTra(props) {
    _classCallCheck(this, ThongTinCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (ThongTinCuocThanhTra.__proto__ || Object.getPrototypeOf(ThongTinCuocThanhTra)).call(this, props));

    _this.state = {
      chiTietDT: false
    };
    return _this;
  }

  _createClass(ThongTinCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.dataCuocThanhTra && this.props.dataCuocThanhTra.dataDetail) {
        this.setState(_extends({}, this.props.dataCuocThanhTra.dataDetail));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataCuocThanhTra && nextProps.dataCuocThanhTra.dataDetail) {
        this.setState(_extends({}, nextProps.dataCuocThanhTra.dataDetail));
      }
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        chiTietDT: true
      });
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({
        chiTietDT: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var DoiTuongThanhTra = '';
      var TenDTTheoKeHoach = '';
      if (this.state.cuocThanhTraNhieuDoiTuong === false && this.state.listDoiTuongThanhTra && this.state.listDoiTuongThanhTra.length > 0) {
        TenDTTheoKeHoach = this.state.listDoiTuongThanhTra[0].ten;
      } else if (this.state.cuocThanhTraNhieuDoiTuong && this.state.listDoiTuongThanhTra.length > 0) {
        TenDTTheoKeHoach = this.state.listDoiTuongThanhTra.length + ' \u0111\u1ED1i t\u01B0\u1EE3ng';
      }
      if (this.state.listDoiTuongThanhTra && this.state.listDoiTuongThanhTra.length > 0) {
        this.state.listDoiTuongThanhTra.map(function (state, index) {
          if (index == 0) {
            DoiTuongThanhTra = DoiTuongThanhTra + ' ' + state.ten;
          } else {
            DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
          }
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  { className: 'mb15 tt-title' },
                  '2. Th\xF4ng tin cu\u1ED9c ',
                  this.props.loaiCuocText
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + this.props.loaiCuocText + ':', className: 'col pl-5', value: this.state.ten || '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(
                  'label',
                  { className: 'col-20 pt-label' },
                  _react2.default.createElement(
                    'span',
                    { className: 'val-title-bold' },
                    '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                    this.props.loaiCuocText,
                    ':'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'val-content txt-blue txt-underline cursor-pointer txt-inline-block', onClick: this.onOpenDialog.bind(this) },
                    TenDTTheoKeHoach
                  )
                ),
                _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.state, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'Ho\u1EA1t \u0111\u1ED9ng ' + this.props.loaiCuocText + ':', className: 'col-20', value: (0, _lodash.get)(this.state.chucNangCuocThanhTraInfo, 'text') || '' }),
                (0, _lodash.get)(this.state.chucNangCuocThanhTraInfo, 'type') === "CHUYEN_NGANH" && _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + this.props.loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25', value: (0, _lodash.get)(this.state.hinhThucThanhTraChuyenNganhInfo, 'text') || '' }),
                (0, _lodash.get)(this.state.chucNangCuocThanhTraInfo, 'type') === "HANH_CHINH" && _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + this.props.loaiCuocText + ':', className: 'col-20', value: !(0, _lodash.isEmpty)(this.state, 'linhVucThanhTraList') ? (0, _lodash.get)(this.state, 'linhVucThanhTraList', []).map(function (item) {
                    return item.text;
                  }).join(', ') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ho\u1EA1t \u0111\u1ED9ng:', className: 'col-20', value: (0, _lodash.get)(this.state, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + this.props.loaiCuocText + ':', className: 'col-20', value: this.state.kyThanhTra || '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n l\xE0m vi\u1EC7c(ng\xE0y):', className: 'col-20', value: this.state.thoiHanThanhTra || '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi gian ti\u1EBFn h\xE0nh:', className: 'col-20', value: this.state.thoiGianTienHanh || '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'N\u1ED9i dung ' + this.props.loaiCuocText + ':', className: 'col pl-5', value: this.state.noiDungThanhTra || '' })
              )
            ),
            this.props.type !== 'thanhtratrung' && _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: this.props.dataCuocThanhTra.listTaiLieuVanThuThongTinCuocThanhTra })
            )
          )
        )
      );
    }
  }]);

  return ThongTinCuocThanhTra;
}(_react.Component);

exports.default = ThongTinCuocThanhTra;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinKeHoachThanhTra = function (_Component) {
  _inherits(ThongTinKeHoachThanhTra, _Component);

  function ThongTinKeHoachThanhTra(props) {
    _classCallCheck(this, ThongTinKeHoachThanhTra);

    var _this = _possibleConstructorReturn(this, (ThongTinKeHoachThanhTra.__proto__ || Object.getPrototypeOf(ThongTinKeHoachThanhTra)).call(this, props));

    _this.state = {
      quyetDinhPheDuyet: '',
      ngayBanHanh: ''
    };
    return _this;
  }

  _createClass(ThongTinKeHoachThanhTra, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data) {
        var dataInfo = nextProps.data;
        this.setState({
          quyetDinhPheDuyet: dataInfo.quyetDinhPheDuyetKTTT,
          ngayBanHanh: dataInfo.ngayRaQuyetDinh ? (0, _moment2.default)(dataInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'box-items mb0' },
        _react2.default.createElement(
          'div',
          { className: 'box-forward' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              'div',
              { className: 'rows' },
              _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                  'h3',
                  { className: 'mb15 tt-title' },
                  '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch ',
                  this.props.loaiCuocText
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'group-box' },
            _react2.default.createElement(
              'div',
              { className: 'items-form mb20' },
              _react2.default.createElement(
                'div',
                { className: 'rows' },
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + this.props.keHoachText + ':', className: 'col-20', value: this.state.quyetDinhPheDuyet }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y Ban H\xE0nh:', className: 'col-20', value: this.state.ngayBanHanh })
              )
            )
          )
        )
      );
    }
  }]);

  return ThongTinKeHoachThanhTra;
}(_react.Component);

exports.default = ThongTinKeHoachThanhTra;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _upload = __webpack_require__(17);

var _DataTableTTT = __webpack_require__(318);

var _DataTableTTT2 = _interopRequireDefault(_DataTableTTT);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(130);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(14);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiQuyTrinh = "THANH_TRA";
var buocGiaiQuyet = "XU_LY_CUOC_THANH_TRA_TRUNG";

var XuLyThanhTraTrung = function (_Component) {
  _inherits(XuLyThanhTraTrung, _Component);

  function XuLyThanhTraTrung(props) {
    _classCallCheck(this, XuLyThanhTraTrung);

    var _this = _possibleConstructorReturn(this, (XuLyThanhTraTrung.__proto__ || Object.getPrototypeOf(XuLyThanhTraTrung)).call(this, props));

    _this.state = {
      id: '',
      ngayBanHanh: '',
      soQuyetDinh: '',
      listTaiLieu: [],
      onSave: true,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      data: [],
      paramsHeThongDeXuat: [],
      // dataDeXuat: {},
      isContinue: false,
      yKienXuLy: [],
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      taiLieuVanThu: [],
      dataFileDinhKem: [],
      backConfirm: false,
      hasChange: false,
      loading: false,
      dataSelectTT: [],
      trangThaiXuLyTrung: '',
      nhomDoiTuong: '',
      tableLoading: false
    };
    return _this;
  }

  _createClass(XuLyThanhTraTrung, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getCuocThanhTraTrung();

              case 2:
                this.getTrangThaiXuLyTTT();
                this.getNhomDoiTuong();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'getNhomDoiTuong',
    value: function getNhomDoiTuong() {
      var _this2 = this;

      _api.ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(function (res) {
        var listNhomDoiTuong = (0, _lodash.get)(res, 'data._embedded.nhomDoiTuongThanhTras') || [];
        _this2.setState({ listNhomDoiTuong: listNhomDoiTuong });
      });
    }
  }, {
    key: 'getlichSuXuLyCTTTrungCurrent',
    value: function getlichSuXuLyCTTTrungCurrent() {
      var _this3 = this;

      _api.ThanhTra.actions.getlichSuXuLyCTTTrungCurrent.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var data = res.data;
          _this3.setState({
            isContinue: !!res.data,
            listChiTietXuLyCTTT: data.listChiTietXuLyCTTT,
            taiLieuVanThu: data.listTaiLieuVanThus || [],
            lanXuLy: data.lanXuLy || '',
            soQuyetDinh: data.soQuyetDinh || '',
            ngayBanHanh: data.ngayBanHanh ? new Date(data.ngayBanHanh) : '',
            lichSuXuLyCTTId: data.lichSuXuLyCTTId
          });
        }
      });
    }
  }, {
    key: 'getCuocThanhTraTrung',
    value: function getCuocThanhTraTrung() {
      var _this4 = this;

      this.setState({
        tableLoading: true
      });
      var listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung'));
      var params = {
        idDoiTuongThanhTras: !(0, _lodash.isEmpty)(listSelectTTT) ? listSelectTTT.join() : undefined
      };
      if (this.state.nhomDoiTuong) {
        params.nhomDoiTuongId = Number(this.state.nhomDoiTuong);
      }
      _api.ThanhTra.actions.getCuocThanhTraTrungXuLy.request('', params).then(function (res) {
        if (res.data._embedded) {
          var data = (0, _lodash.get)(res, 'data._embedded.medial_CuocThanhTraTrungInfoes') || [];
          _this4.getlichSuXuLyCTTTrungCurrent();
          var newYKienXuLy = [].concat(_toConsumableArray(_this4.state.yKienXuLy));
          if ((0, _lodash.isEmpty)(newYKienXuLy)) {
            if (!(0, _lodash.isEmpty)(data)) {
              newYKienXuLy = data.map(function (item) {
                var idDoiTuongThanhTra = (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId') || 0;
                return item = {
                  doiTuongId: idDoiTuongThanhTra,
                  noiDung: (0, _lodash.get)(item, 'noiDungChuyenVienDeXuat', ''),
                  dahoanThanh: (0, _lodash.get)(item, 'hoanThanh', 'false')
                };
              });
            }
          }
          _this4.props.dispatch({
            type: 'UPDATE_XULYTRUNG',
            data: data
          });
          _this4.setState({
            data: data,
            yKienXuLy: newYKienXuLy
          });
        } else {
          _this4.setState({
            data: []
          });
        }
      }).finally(function () {
        _this4.setState({
          tableLoading: false
        });
      });
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      if (!this.state.isContinue) {
        this.props.dispatch({
          type: 'RESET_LIST_SELECT_TTT'
        });
      }
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'onChangeData',
    value: function onChangeData(yKienXuLy) {
      var _this5 = this;

      var data = this.state.data;

      var updateYKien = data.map(function (item) {
        yKienXuLy.map(function (yKienItem) {
          if (yKienItem.doiTuongId === (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
            item.hoanThanh = yKienItem.dahoanThanh;
            item.noiDungChuyenVienDeXuat = yKienItem.noiDung;
          }
        });
        return item;
      });
      if (!(0, _lodash.isEmpty)(this.props.dataXuLyTrung)) {
        var updateYKienXuLy = this.props.dataXuLyTrung.map(function (item) {
          yKienXuLy.map(function (yKienItem) {
            if (yKienItem.doiTuongId === (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
              item.hoanThanh = yKienItem.dahoanThanh;
              item.noiDungChuyenVienDeXuat = yKienItem.noiDung;
            }
          });
          return item;
        });
        this.props.dispatch({
          type: 'UPDATE_XULYTRUNG',
          data: updateYKienXuLy
        });
      }
      this.setState({
        hasChange: true,
        yKienXuLy: yKienXuLy,
        data: updateYKien
      }, function () {
        _this5.handleSearch();
      });
    }
  }, {
    key: 'onSaveFileDinhKiem',
    value: function onSaveFileDinhKiem(id) {
      var _this6 = this;

      this.state.dataFileDinhKem.map(function (item, i) {
        if (item.duongDan === '') {
          // DO nothing
        } else if (item.taiLieuVanThuId) {
          var state = _this6.state;
          state.taiLieuVanThuUpdate[state.taiLieuVanThuUpdate.length] = {
            lichSuXuLyCTTTrung: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : null
          };
          _this6.setState({ state: state });
        } else {
          var _state = _this6.state;
          _state.taiLieuVanThu[_state.taiLieuVanThu.length] = {
            lichSuXuLyCTTTrung: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            buocGiaiQuyet: buocGiaiQuyet,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : null
          };
          _this6.setState({ state: _state });
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this6.state.taiLieuVanThuDelete[_this6.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }
      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }
      if (this.state.taiLieuVanThuDelete.length > 0) {
        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
    }
  }, {
    key: 'genData',
    value: function genData() {
      var _this7 = this;

      var data = [];
      this.state.data.map(function (item) {
        var yKienXuLy = _this7.state.yKienXuLy.find(function (yKien) {
          return yKien.doiTuongId === item.doiTuongThanhTraTrung.doiTuongThanhTraId;
        }) || {};
        for (var i = 0; i < item.cuocThanhTras.length; i++) {
          var info = item.cuocThanhTras[i];
          var dataC = {
            cuocThanhTra_id: (0, _lodash.get)(info, 'idCuocThanhTra'),
            dahoanThanh: yKienXuLy.dahoanThanh,
            doiTuongThanhTra_id: (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'),
            donViThanhTra_id: (0, _lodash.get)(info, 'donViInfo.coQuanQuanLyId'),
            keHoachThanhTra_id: (0, _lodash.get)(info, 'keHoachThanhTraId'),
            namThanhTra: (0, _lodash.get)(info, 'namThanhTra'),
            noiDung: (0, _lodash.get)(info, 'noiDungThanhTra') || '',
            noiDungChuyenVienDeXuat: yKienXuLy.noiDung,
            soQuyetDinhKeHoachThanhTra: (0, _lodash.get)(info, 'quyetDinhPheDuyetKTTT'),
            tenDoiTuongThanhTra: item.doiTuongThanhTraTrung.ten,
            tenDonViThanhTra: (0, _lodash.get)(info, 'donViInfo.ten')
          };
          data.push(dataC);
        }
      });
      return data;
    }
  }, {
    key: 'postDeXuatXuLyTTTrung',
    value: function postDeXuatXuLyTTTrung() {
      var _this8 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          loading: true
        });
        var dataChiTietXuLyCTTT = this.state.lichSuXuLyCTTId ? this.dataForSave() : this.genData();
        var params = {
          lichSuXuLyCTTTrung: {
            namThanhTra: (0, _moment2.default)().add(1, 'years').format('YYYY'),
            ngayBanHanh: '',
            soQuyetDinh: '',
            thoiGianXuLy: (0, _moment2.default)().toISOString()
          },
          listChiTietXuLyCTTT: [].concat(_toConsumableArray(dataChiTietXuLyCTTT))
        };
        if (this.state.ngayBanHanh) {
          params.lichSuXuLyCTTTrung.ngayBanHanh = (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString();
        }
        if (this.state.soQuyetDinh) {
          params.lichSuXuLyCTTTrung.soQuyetDinh = this.state.soQuyetDinh;
        }
        if (this.state.lichSuXuLyCTTId) {
          params.lichSuXuLyCTTTrung.lanXuLy = this.state.lanXuLy || '';
          _api.ThanhTra.actions.patchXuLyTTT.request({ id: this.state.lichSuXuLyCTTId }, params).then(function (res) {
            if (res.data) {
              _this8.setState({
                loading: false
              });
              _this8.onSaveFileDinhKiem(_this8.state.lichSuXuLyCTTId);
              (0, _toastr.Toastr)(_message.msg.tttGui, 'success');
              _this8.props.dispatch({
                type: 'RESETDATA_XULYTRUNG'
              });
              _this8.goBack();
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        } else {
          _api.ThanhTra.actions.postXuLyTTT.request('', params).then(function (res) {
            if (res.data) {
              _this8.setState({
                loading: false
              });
              _this8.onSaveFileDinhKiem(res.data.lichSuXuLyCTTId);
              (0, _toastr.Toastr)(_message.msg.tttGui, 'success');
              _this8.props.dispatch({
                type: 'RESETDATA_XULYTRUNG'
              });
              _this8.goBack();
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this9 = this;

      var hasChange = true;
      if (name === 'trangThaiXuLyTrung') {
        hasChange = false;
      }
      this.setState(_defineProperty({
        hasChange: hasChange
      }, name, e.target.value), function () {
        if (name === 'trangThaiXuLyTrung') {
          _this9.handleSearch();
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id]),
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data) {
      this.setState({
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var accessToken = _reactCookie2.default.load('accessToken');
      var dataDeXuat = this.state.data.map(function (item) {
        return {
          daHoanThanh: (0, _lodash.get)(item, 'hoanThanh'),
          idDoiTuongThanhTra: (0, _lodash.get)(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'),
          noiDungChuyenVienDeXuat: (0, _lodash.get)(item, 'noiDungChuyenVienDeXuat')
        };
      });
      fetch(_config.API_URL + '/danhSachDeXuatXuLyCuocThanhTraTrung/xuatExcel', {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
          'Origin': '*'
        },
        body: JSON.stringify(dataDeXuat)
      }).then(function (response) {
        var fileName = response.headers.get('content-disposition').split('filename=')[1].replace('"', '').replace('"', '');
        response.blob().then(function (blob) {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        });
      });
    }
  }, {
    key: 'dataForSave',
    value: function dataForSave() {
      var _this10 = this;

      var data = [];
      var listChiTietXuLyCTTT = this.state.listChiTietXuLyCTTT;

      (0, _lodash.isArray)(this.state.data) && this.state.data.map(function (item) {
        var yKienXuLy = _this10.state.yKienXuLy.find(function (yKien) {
          if (yKien.doiTuongId === item.doiTuongThanhTraTrung.doiTuongThanhTraId) {
            return {
              yKien: yKien.noiDung,
              dahoanThanh: yKien.dahoanThanh
            };
          }
        });

        var _loop = function _loop(i) {
          var info = item.cuocThanhTras[i];
          var id = '';
          (0, _lodash.isArray)(listChiTietXuLyCTTT) && listChiTietXuLyCTTT.find(function (state) {
            if (state.cuocThanhTra_id === (0, _lodash.get)(info, 'cuocThanhTra.cuocThanhTraId') && state.doiTuongThanhTra_id === (item.doiTuongThanhTraTrung && item.doiTuongThanhTraTrung.doiTuongThanhTraId)) {
              return id = state.id;
            }
          });
          var dataC = {
            cuocThanhTra_id: (0, _lodash.get)(info, 'idCuocThanhTra'),
            dahoanThanh: (0, _lodash.get)(yKienXuLy, 'dahoanThanh', false),
            doiTuongThanhTra_id: item.doiTuongThanhTraTrung && item.doiTuongThanhTraTrung.doiTuongThanhTraId,
            donViThanhTra_id: (0, _lodash.get)(info, 'donViInfo.coQuanQuanLyId'),
            keHoachThanhTra_id: (0, _lodash.get)(info, 'keHoachThanhTraId'),
            namThanhTra: info.namThanhTra,
            noiDung: (0, _lodash.get)(info, 'noiDungThanhTra') || '',
            noiDungChuyenVienDeXuat: (0, _lodash.get)(yKienXuLy, 'noiDung', ''),
            soQuyetDinhKeHoachThanhTra: (0, _lodash.get)(info, 'quyetDinhPheDuyetKTTT'),
            tenDoiTuongThanhTra: item.doiTuongThanhTraTrung.ten,
            tenDonViThanhTra: (0, _lodash.get)(info, 'donViInfo.ten'),
            id: (0, _lodash.get)(info, 'idChiTietXuLyTrung')
          };
          if (id !== '') {
            dataC.id = id;
          }
          data.push(dataC);
        };

        for (var i = 0; i < item.cuocThanhTras.length; i++) {
          _loop(i);
        }
      });
      return data;
    }
  }, {
    key: 'handleSave',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this11 = this;

        var dataChiTietXuLyCTTT, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataChiTietXuLyCTTT = this.state.lichSuXuLyCTTId ? this.dataForSave() : this.genData();
                _context2.next = 3;
                return this.setState({
                  loading: true
                });

              case 3:
                params = {
                  lichSuXuLyCTTTrung: {
                    namThanhTra: (0, _moment2.default)().add(1, 'years').format('YYYY'),
                    ngayBanHanh: '',
                    soQuyetDinh: ''
                  },
                  listChiTietXuLyCTTT: [].concat(_toConsumableArray(dataChiTietXuLyCTTT))
                };

                if (this.state.ngayBanHanh) {
                  params.lichSuXuLyCTTTrung.ngayBanHanh = (0, _moment2.default)(this.state.ngayBanHanh).add(7, 'hours').toISOString();
                }
                if (this.state.soQuyetDinh) {
                  params.lichSuXuLyCTTTrung.soQuyetDinh = this.state.soQuyetDinh;
                }
                if (this.state.lichSuXuLyCTTId) {
                  params.lichSuXuLyCTTTrung.lanXuLy = this.state.lanXuLy || '';
                  _api.ThanhTra.actions.patchXuLyTTT.request({ id: this.state.lichSuXuLyCTTId }, params).then(function (res) {
                    if (res.data) {
                      _this11.setState({
                        loading: false
                      });
                      _this11.onSaveFileDinhKiem(_this11.state.lichSuXuLyCTTId);
                      (0, _toastr.Toastr)(_message.msg.gqdLuu, 'success');
                      _this11.goBack();
                    }
                  }).catch(function (error) {
                    if (error.response) {
                      (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                    }
                  });
                } else {
                  _api.ThanhTra.actions.postXuLyTTT.request('', params).then(function (res) {
                    if (res.data) {
                      _this11.setState({
                        loading: false
                      });
                      _this11.onSaveFileDinhKiem(res.data.lichSuXuLyCTTId);
                      (0, _toastr.Toastr)(_message.msg.gqdLuu, 'success');
                      _this11.goBack();
                    }
                  }).catch(function (error) {
                    if (error.response) {
                      (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
                    }
                  });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSave() {
        return _ref2.apply(this, arguments);
      }

      return handleSave;
    }()
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.setState({
        backConfirm: false
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack) {
        this.props.dispatch({
          type: 'RESET_LIST_SELECT_TTT'
        });
        _reactRouter.browserHistory.goBack();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.props.dispatch({
            type: 'RESET_LIST_SELECT_TTT'
          });
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'getTrangThaiXuLyTTT',
    value: function getTrangThaiXuLyTTT() {
      var _this12 = this;

      _api.ThanhTra.actions.getTrangThaiXuLyTTT.request('').then(function (res) {
        if (res.data) {
          _this12.setState({
            dataSelectTT: res.data
          });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      var _this13 = this;

      if (!(0, _lodash.isEmpty)(this.state.trangThaiXuLyTrung)) {
        var data = this.props.dataXuLyTrung;
        var isHoanThanh = this.state.trangThaiXuLyTrung === 'DA_HOAN_THANH';
        var filterData = data.filter(function (item) {
          return isHoanThanh === item.hoanThanh;
        });
        if ((0, _lodash.isEmpty)(filterData) && this.state.trangThaiXuLyTrung !== 'DA_HOAN_THANH') {
          this.setState({
            trangThaiXuLyTrung: ''
          }, function () {
            _this13.handleSearch();
          });
        }
        this.setState({
          data: filterData
        });
      } else {
        this.setState({
          data: this.props.dataXuLyTrung
        });
      }
    }
  }, {
    key: 'hiddenGoiTatCa',
    value: function hiddenGoiTatCa() {
      var yKienXuLy = this.state.yKienXuLy;

      var newData = (0, _lodash.map)(yKienXuLy, 'dahoanThanh');
      var isCheck = (0, _lodash.includes)(newData, false);
      return isCheck;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true), title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'back-foward mb0' },
            _react2.default.createElement(
              'span',
              { className: 'arrow-left txt-blue txt-underline', onClick: this.goBack.bind(this) },
              'V\u1EC1 trang tr\u01B0\u1EDBc'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'left-content' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'C\u1EADp nh\u1EADt n\u1ED9i dung \u0111\u1EC1 xu\u1EA5t x\u1EED l\xFD thanh tra tr\xF9ng'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-block pl15 pr15 pt20' },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(_common.Input, { bindValidator: this, require: true, channel: 'formTaoDon', className: 'col-20', label: 'S\u1ED1 v\u0103n b\u1EA3n', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { bindValidator: this, require: true, channel: 'formTaoDon', className: 'col-20', label: 'Ng\xE0y ban h\xE0nh', endDate: new Date(), onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), value: this.state.ngayBanHanh, name: 'ngayBanHanh' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb5' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { onSave: this.state.onSave, label: 'V\u0103n b\u1EA3n \u0111\xEDnh k\xE8m', bindValidator: this, data: this.state.taiLieuVanThu, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'wrap-block pl15 pr15 pt20' },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18 pull-right', label: 'Tr\u1EA1ng th\xE1i x\u1EED l\xFD tr\xF9ng', options: this.state.dataSelectTT, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.trangThaiXuLyTrung, onChange: this.onChange.bind(this, 'trangThaiXuLyTrung'), placeholder: true })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              _DataTableTTT2.default,
              {
                header: _table.header.thanhTraTrung.CNNDXL,
                handleExport: this.handleExport.bind(this),
                dataList: this.state.data,
                exporttext: 'Xu\u1EA5t Excel',
                thanhTra: true,
                onDisableCheck: true,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                search: true,
                tableLoading: this.state.tableLoading },
              _react2.default.createElement(_datatable.RowItemXuLyThanhTraTrung, {
                maxLength: this.state.data.length,
                yKienXuLy: this.state.yKienXuLy,
                bindValidator: this,
                onChange: this.onChangeData.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom complete-wrap ttt-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', role: 'button', onClick: this.handleBack.bind(this, false) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: (0, _classnames2.default)('btn-action btn-save', {
                  'btn-loading-inline': this.state.loading
                }), onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            !(0, _lodash.isEmpty)(this.state.data) && _react2.default.createElement(
              _core.Button,
              { className: (0, _classnames2.default)('btn-action btn-complete right custom-btn', {
                  'btn-loading-inline': this.state.loading
                }), role: 'button', disabled: this.hiddenGoiTatCa(), onClick: this.postDeXuatXuLyTTTrung.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'G\u1EEDi t\u1EA5t c\u1EA3'
              )
            )
          )
        )
      );
    }
  }]);

  return XuLyThanhTraTrung;
}(_react.Component);

XuLyThanhTraTrung.defaultProps = {
  validators: {},
  dataXuLyTrung: [],
  listSelectTTT: []
};

function bindStatetoProps(state) {
  return {
    dataXuLyTrung: state.xuLyTrung.data,
    listSelectTTT: state.xuLyTrung.listSelected
  };
}

exports.default = (0, _reactRedux.connect)(bindStatetoProps)(XuLyThanhTraTrung);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemChiTietNoiDungTTT = function (_Component) {
  _inherits(RowItemChiTietNoiDungTTT, _Component);

  function RowItemChiTietNoiDungTTT(props) {
    _classCallCheck(this, RowItemChiTietNoiDungTTT);

    var _this = _possibleConstructorReturn(this, (RowItemChiTietNoiDungTTT.__proto__ || Object.getPrototypeOf(RowItemChiTietNoiDungTTT)).call(this, props));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemChiTietNoiDungTTT, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var count = this.props.count;
      var _props$item = this.props.item,
          cuocThanhTras = _props$item.cuocThanhTras,
          doiTuongThanhTraTrung = _props$item.doiTuongThanhTraTrung,
          namThanhTra = _props$item.namThanhTra;

      var LisData = cuocThanhTras.map(function (item, index) {
        if (index === 0) {
          return _react2.default.createElement(
            'tr',
            { key: index },
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              count
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length, className: 'txt-underline' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', onClick: _this2.onOpenDialog.bind(_this2) },
                doiTuongThanhTraTrung.ten || ''
              ),
              _react2.default.createElement(
                _core.Dialog,
                {
                  isOpen: _this2.state.isOpen,
                  onClose: _this2.closeDialog.bind(_this2),
                  title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra',
                  className: 'dialog-default wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30 pt20' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: doiTuongThanhTraTrung.ten || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'nhomDoiTuongThanhTraInfo.ten') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Huy\u1EC7n/TP:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'quanHuyenInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ph\u01B0\u1EDDng/X\xE3:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'phuongXaInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: '\u0110\u1ECBa ch\u1EC9:',
                    value: doiTuongThanhTraTrung.diaChi || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:',
                    value: doiTuongThanhTraTrung.soDienThoai || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ghi ch\xFA:',
                    value: doiTuongThanhTraTrung.ghiChu || ''
                  })
                )
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'donViInfo.ten') || ''
            ),
            _react2.default.createElement(
              'td',
              { className: 'txt-center' },
              (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              namThanhTra || ''
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline text-color-default', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + (0, _lodash.get)(item, 'idCuocThanhTra') },
                !(0, _lodash.isEmpty)(item.tenCuocThanhTra) && _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: (0, _lodash.get)(item, 'tenCuocThanhTra') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'mt10' },
                (0, _lodash.get)(item, 'soDoiTuong'),
                ' \u0111\u1ED1i t\u01B0\u1EE3ng'
              )
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              _react2.default.createElement(
                'div',
                { className: 'mgbt10' },
                '\u0110\u1EC1 xu\u1EA5t chuy\xEAn vi\xEAn x\u1EED l\xFD: '
              ),
              _react2.default.createElement(_common.Text, { className: 'col-100 mb10', value: (0, _lodash.get)(_this2.props.item, 'noiDungChuyenVienDeXuat') || '' })
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'kyThanhTra') || ''
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text')
            )
          );
        }
        return _react2.default.createElement(
          'tr',
          { key: index },
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-left' },
            (0, _lodash.get)(item, 'donViInfo.ten') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-center' },
            (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline text-color-default', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + (0, _lodash.get)(item, 'idCuocThanhTra') },
              !(0, _lodash.isEmpty)(item.tenCuocThanhTra) && _react2.default.createElement(_reactTextTruncate2.default, {
                line: 3,
                truncateText: '\u2026',
                text: (0, _lodash.get)(item, 'tenCuocThanhTra') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              (0, _lodash.get)(item, 'soDoiTuong'),
              ' \u0111\u1ED1i t\u01B0\u1EE3ng'
            )
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-left' },
            (0, _lodash.get)(item, 'kyThanhTra') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-left' },
            (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text')
          )
        );
      });
      return _react2.default.createElement(
        'tbody',
        { className: 'table-body' },
        LisData
      );
    }
  }]);

  return RowItemChiTietNoiDungTTT;
}(_react.Component);

exports.default = RowItemChiTietNoiDungTTT;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDSThongBao = function (_Component) {
  _inherits(RowItemDSThongBao, _Component);

  function RowItemDSThongBao() {
    _classCallCheck(this, RowItemDSThongBao);

    return _possibleConstructorReturn(this, (RowItemDSThongBao.__proto__ || Object.getPrototypeOf(RowItemDSThongBao)).apply(this, arguments));
  }

  _createClass(RowItemDSThongBao, [{
    key: 'render',
    value: function render() {
      var count = this.props.count;
      var _props$item = this.props.item,
          content = _props$item.content,
          ngayTao = _props$item.ngayTao;

      var phanHe = this.props.item.type === "TB_THANH_TRA" ? 'Thanh tra' : '';
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          count
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _moment2.default)(ngayTao).format('DD/MM/YYYY')
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_reactTextTruncate2.default, {
            line: 1,
            truncateText: '\u2026',
            text: content
          })
        ),
        _react2.default.createElement(
          'td',
          null,
          phanHe
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'wrap-link-todo' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/thanh-tra/chi-tiet-thong-bao/' + this.props.item.thongBaoId },
              _react2.default.createElement('span', { className: 'tt-xem-chi-tiet' }),
              'Chi ti\u1EBFt'
            )
          )
        )
      );
    }
  }]);

  return RowItemDSThongBao;
}(_react.Component);

exports.default = RowItemDSThongBao;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDSTongHopKHTTDonVi = function (_Component) {
  _inherits(RowItemDSTongHopKHTTDonVi, _Component);

  function RowItemDSTongHopKHTTDonVi() {
    _classCallCheck(this, RowItemDSTongHopKHTTDonVi);

    return _possibleConstructorReturn(this, (RowItemDSTongHopKHTTDonVi.__proto__ || Object.getPrototypeOf(RowItemDSTongHopKHTTDonVi)).apply(this, arguments));
  }

  _createClass(RowItemDSTongHopKHTTDonVi, [{
    key: 'render',
    value: function render() {
      var data = this.props.item;
      var _props$item = this.props.item,
          namThanhTra = _props$item.namThanhTra,
          ngayRaQuyetDinh = _props$item.ngayRaQuyetDinh,
          quyetDinhPheDuyetKTTT = _props$item.quyetDinhPheDuyetKTTT,
          keHoachThanhTraId = _props$item.keHoachThanhTraId;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thanh-tra/ke-hoach-thanh-tra/chi-tiet/' + keHoachThanhTraId },
            'K\u1EBF ho\u1EA1ch ' + ((0, _lodash.get)(data, 'loaiKeHoach.value') === 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + namThanhTra
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          quyetDinhPheDuyetKTTT || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          ngayRaQuyetDinh ? (0, _moment2.default)(ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(data, 'donViInfo.ten')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(data, 'soCuocThanhTra')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(data, 'loaiKeHoach.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(data, 'trangThaiKeHoachThanhTraInfo.text')
        )
      );
    }
  }]);

  return RowItemDSTongHopKHTTDonVi;
}(_react.Component);

exports.default = RowItemDSTongHopKHTTDonVi;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhMucCuocThanhTra = function (_Component) {
  _inherits(RowItemDanhMucCuocThanhTra, _Component);

  function RowItemDanhMucCuocThanhTra(props) {
    _classCallCheck(this, RowItemDanhMucCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemDanhMucCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemDanhMucCuocThanhTra)).call(this, props));

    _this.state = {
      chiTietDT: false
    };
    return _this;
  }

  _createClass(RowItemDanhMucCuocThanhTra, [{
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        chiTietDT: true
      });
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({
        chiTietDT: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          noiDungThanhTra = _props$item.noiDungThanhTra,
          listDoiTuongThanhTra = _props$item.listDoiTuongThanhTra,
          thoiHanThanhTra = _props$item.thoiHanThanhTra,
          kyThanhTra = _props$item.kyThanhTra,
          thoiGianTienHanh = _props$item.thoiGianTienHanh;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'mgbt10' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-regular', onClick: this.onOpenDialog.bind(this) },
              this.props.item.ten
            ),
            _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this) })
          ),
          _react2.default.createElement(
            'div',
            null,
            listDoiTuongThanhTra.length + ' \u0111\u1ED1i t\u01B0\u1EE3ng'
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + this.props.item.id },
            _react2.default.createElement(_reactTextTruncate2.default, {
              line: 3,
              truncateText: '\u2026',
              text: noiDungThanhTra })
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          thoiHanThanhTra !== 0 ? thoiHanThanhTra : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          kyThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          thoiGianTienHanh
        )
      );
    }
  }]);

  return RowItemDanhMucCuocThanhTra;
}(_react.Component);

exports.default = RowItemDanhMucCuocThanhTra;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import TextTruncate from 'react-text-truncate';

var RowItemDanhMucCuocThanhTraTrung = function (_Component) {
  _inherits(RowItemDanhMucCuocThanhTraTrung, _Component);

  function RowItemDanhMucCuocThanhTraTrung(props) {
    _classCallCheck(this, RowItemDanhMucCuocThanhTraTrung);

    var _this = _possibleConstructorReturn(this, (RowItemDanhMucCuocThanhTraTrung.__proto__ || Object.getPrototypeOf(RowItemDanhMucCuocThanhTraTrung)).call(this, props));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemDanhMucCuocThanhTraTrung, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          count = _props.count,
          namThanhTraXuLy = _props.namThanhTraXuLy;

      var listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung')) || [];
      var _props$item = this.props.item,
          doiTuongThanhTraTrung = _props$item.doiTuongThanhTraTrung,
          cuocThanhTras = _props$item.cuocThanhTras,
          namThanhTra = _props$item.namThanhTra;

      var onCheckDisable = function onCheckDisable() {
        var onCheck = false;
        cuocThanhTras.map(function (item) {
          if ((0, _lodash.isEmpty)(item.trangThaiXuLyTaiDonVi)) {
            onCheck = true;
          }
        });
        return onCheck;
      };
      var ListData = cuocThanhTras.map(function (item, index) {
        if (index === 0) {
          return _react2.default.createElement(
            'tr',
            { key: index },
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length, className: 'table-checkbox' },
              namThanhTra === namThanhTraXuLy && _react2.default.createElement(
                'label',
                { className: 'pt-control pt-checkbox pt-large' },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  disabled: !(0, _lodash.isEmpty)(listSelectTTT) && listSelectTTT.includes(doiTuongThanhTraTrung.doiTuongThanhTraId) || !onCheckDisable(),
                  checked: !!_this2.props.item.selected,
                  className: 'pt-large',
                  onChange: _this2.props.parent.handleSelectedDoiTuong.bind(_this2.props.parent, _this2.props.item),
                  name: 'checkboxKetQua'
                }),
                _react2.default.createElement('span', { className: 'pt-control-indicator' })
              )
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              count
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', onClick: _this2.onOpenDialog.bind(_this2) },
                doiTuongThanhTraTrung.ten || ''
              ),
              _react2.default.createElement(
                _core.Dialog,
                {
                  isOpen: _this2.state.isOpen,
                  onClose: _this2.closeDialog.bind(_this2),
                  title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra',
                  className: 'dialog-default wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30 pt20' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: doiTuongThanhTraTrung.ten || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'nhomDoiTuongThanhTraInfo.ten') || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Huy\u1EC7n/TP:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'quanHuyenInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ph\u01B0\u1EDDng/X\xE3:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'phuongXaInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: '\u0110\u1ECBa ch\u1EC9:',
                    value: doiTuongThanhTraTrung.diaChi || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:',
                    value: doiTuongThanhTraTrung.soDienThoai || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ghi ch\xFA:',
                    value: doiTuongThanhTraTrung.ghiChu || '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'action-form-wrap pt20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-bottom' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-action btn-close', onClick: _this2.closeDialog.bind(_this2) },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u0110\xF3ng'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'donViInfo.ten') || ''
            ),
            _react2.default.createElement(
              'td',
              { className: 'txt-center' },
              (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              namThanhTra || ''
            ),
            _react2.default.createElement(
              'td',
              { className: 'bg-white' },
              (0, _lodash.get)(item, 'noiDungThanhTra') || ""
            ),
            _react2.default.createElement(
              'td',
              { className: 'bg-white' },
              (0, _lodash.get)(item, 'loaiCuoc.value') == 'KIEM_TRA' ? 'Kiểm tra' : "Thanh tra"
            ),
            _react2.default.createElement(
              'td',
              { className: 'bg-white' },
              (0, _lodash.get)(item, 'kyThanhTra') || ""
            ),
            _react2.default.createElement(
              'td',
              { className: 'bg-white' },
              (0, _lodash.get)(item, 'thoiGianTienHanh') || ""
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'p',
                null,
                (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')
              ),
              _react2.default.createElement(
                'p',
                { className: 'txt-danger mt10' },
                (0, _lodash.get)(item, 'uuTien.label') ? '(' + (0, _lodash.get)(item, 'uuTien.label') + ')' : ''
              )
            )
          );
        }
        return _react2.default.createElement(
          'tr',
          { key: index },
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-left' },
            (0, _lodash.get)(item, 'donViInfo.ten') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-center' },
            (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'noiDungThanhTra') || ""
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'loaiCuoc.value') == 'KIEM_TRA' ? 'Kiểm tra' : "Thanh tra"
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'kyThanhTra') || ""
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'thoiGianTienHanh') || ""
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            _react2.default.createElement(
              'p',
              null,
              (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')
            ),
            _react2.default.createElement(
              'p',
              { className: 'txt-danger mt10' },
              (0, _lodash.get)(item, 'uuTien.label') ? '(' + (0, _lodash.get)(item, 'uuTien.label') + ')' : ''
            )
          )
        );
      });
      return _react2.default.createElement(
        'tbody',
        { className: 'table-body' },
        ListData
      );
    }
  }]);

  return RowItemDanhMucCuocThanhTraTrung;
}(_react.Component);

exports.default = RowItemDanhMucCuocThanhTraTrung;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhMucTongHopThanhTra = function (_Component) {
  _inherits(RowItemDanhMucTongHopThanhTra, _Component);

  function RowItemDanhMucTongHopThanhTra(props) {
    _classCallCheck(this, RowItemDanhMucTongHopThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemDanhMucTongHopThanhTra.__proto__ || Object.getPrototypeOf(RowItemDanhMucTongHopThanhTra)).call(this, props));

    _this.state = {
      chiTietDT: false,
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemDanhMucTongHopThanhTra, [{
    key: 'toggleDialog',
    value: function toggleDialog(status) {
      this.state.chiTietDT = status;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'toggleDialogOpen',
    value: function toggleDialogOpen() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.item;
      var _props$item = this.props.item,
          noiDungThanhTra = _props$item.noiDungThanhTra,
          donViInfo = _props$item.donViInfo,
          namThanhTra = _props$item.namThanhTra,
          keHoachThanhTraInfo = _props$item.keHoachThanhTraInfo,
          listDoiTuongThanhTra = _props$item.listDoiTuongThanhTra;

      var getTen = '';
      if (data && data.doiTuongThanhTras && data.doiTuongThanhTras.length > 0 && data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = data.doiTuongThanhTras[0].ten;
      } else if (data && data.listDoiTuongThanhTra && data.listDoiTuongThanhTra.length > 0 && data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = data.listDoiTuongThanhTra[0].ten;
      } else if (data.tenNhieuDoiTuongThanhTra && data.cuocThanhTraNhieuDoiTuong === true) {
        getTen = this.props.item.tenNhieuDoiTuongThanhTra;
      }
      var quyetDinhPheDuyetKTTT = keHoachThanhTraInfo && keHoachThanhTraInfo.quyetDinhPheDuyetKTTT;
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'mgbt10' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline txt-regular', name: 'abc', onClick: this.toggleDialog.bind(this, true) },
              this.props.item.ten || ''
            ),
            _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this, false) })
          ),
          _react2.default.createElement(
            'div',
            null,
            (listDoiTuongThanhTra.length || '') + ' \u0111\u1ED1i t\u01B0\u1EE3ng '
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline text-color-default', to: '/thanh-tra/cuoc-thanh-tra/chi-tiet/' + data.cuocThanhTraId },
            noiDungThanhTra && _react2.default.createElement(_reactTextTruncate2.default, {
              line: 3,
              truncateText: '\u2026',
              text: noiDungThanhTra })
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          donViInfo.ten || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          namThanhTra || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          quyetDinhPheDuyetKTTT || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          !(0, _lodash.isEmpty)((0, _lodash.get)(data, 'keHoachThanhTraInfo.ngayGuiTTTP')) ? (0, _moment2.default)(data.keHoachThanhTraInfo.ngayGuiTTTP).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(data, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'tienDoThanhTraInfo.text') || ''
        )
      );
    }
  }]);

  return RowItemDanhMucTongHopThanhTra;
}(_react.Component);

exports.default = RowItemDanhMucTongHopThanhTra;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemLichSuXuLy = function (_Component) {
  _inherits(RowItemLichSuXuLy, _Component);

  function RowItemLichSuXuLy() {
    _classCallCheck(this, RowItemLichSuXuLy);

    return _possibleConstructorReturn(this, (RowItemLichSuXuLy.__proto__ || Object.getPrototypeOf(RowItemLichSuXuLy)).apply(this, arguments));
  }

  _createClass(RowItemLichSuXuLy, [{
    key: 'getTaiLieu',
    value: function getTaiLieu() {
      var _this2 = this;

      var _ref = this.props.item || [],
          listTaiLieuVanThus = _ref.listTaiLieuVanThus;

      var tenFile = listTaiLieuVanThus.length > 0 && listTaiLieuVanThus.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { className: 'pd5', key: index },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _jsFileDownload2.default.bind(_this2, item.duongDan, item.tenFile), className: 'txt-underline txt-blue' },
            item.tenFile || ''
          )
        );
      });
      return tenFile;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          lanXuLy = _props$item.lanXuLy,
          soQuyetDinh = _props$item.soQuyetDinh,
          ngayBanHanh = _props$item.ngayBanHanh,
          namThanhTra = _props$item.namThanhTra,
          thoiGianXuLy = _props$item.thoiGianXuLy,
          listTaiLieuVanThus = _props$item.listTaiLieuVanThus;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          lanXuLy || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          soQuyetDinh || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          ngayBanHanh ? (0, _moment2.default)(ngayBanHanh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          namThanhTra || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _moment2.default)(thoiGianXuLy).format('DD/MM/YYYY') || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.getTaiLieu()
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/thanh-tra/noi-dung-xu-ly/chi-tiet/' + this.props.item.lichSuXuLyCTTId, className: 'txt-underline txt-blue' },
            'Xem chi ti\u1EBFt'
          )
        )
      );
    }
  }]);

  return RowItemLichSuXuLy;
}(_react.Component);

exports.default = RowItemLichSuXuLy;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _core = __webpack_require__(7);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemXuLyThanhTraTrung = function (_Component) {
  _inherits(RowItemXuLyThanhTraTrung, _Component);

  function RowItemXuLyThanhTraTrung(props) {
    _classCallCheck(this, RowItemXuLyThanhTraTrung);

    var _this = _possibleConstructorReturn(this, (RowItemXuLyThanhTraTrung.__proto__ || Object.getPrototypeOf(RowItemXuLyThanhTraTrung)).call(this, props));

    _this.state = {
      isOpen: false,
      noiDung: '',
      openDoiTuong: false,
      isHoanThanh: false,
      yKienXuLy: []
    };
    return _this;
  }

  _createClass(RowItemXuLyThanhTraTrung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.yKienXuLy) {
        var state = this.state;
        var yKienXuLy = this.props.yKienXuLy.find(function (item) {
          return item.doiTuongId === _this2.props.item.doiTuongThanhTraTrung.doiTuongThanhTraId;
        }) || {};
        state.noiDung = yKienXuLy.noiDung;
        state.isHoanThanh = yKienXuLy.dahoanThanh;
        this.setState({
          yKienXuLy: this.props.yKienXuLy
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.yKienXuLy) {
        var state = this.state;
        var yKienXuLy = nextProps.yKienXuLy.find(function (item) {
          return item.doiTuongId === nextProps.item.doiTuongThanhTraTrung.doiTuongThanhTraId;
        }) || {};
        state.noiDung = yKienXuLy.noiDung;
        state.isHoanThanh = yKienXuLy.dahoanThanh;
        this.setState({
          yKienXuLy: nextProps.yKienXuLy
        });
      }
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formDeXuat'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'onChange',
    value: function onChange(count, doiTuongThanhTraId, e) {
      var yKienXuLy = [].concat(_toConsumableArray(this.state.yKienXuLy));
      var newYKien = yKienXuLy.map(function (item) {
        if (item.doiTuongId === doiTuongThanhTraId) {
          item.noiDung = e.target.value;
        }
        return item;
      });
      this.setState({
        yKienXuLy: newYKien
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name, doiTuongThanhTraId) {
      var _this3 = this;

      var newYKienXuLy = [].concat(_toConsumableArray(this.state.yKienXuLy)).map(function (item) {
        if (item.doiTuongId === doiTuongThanhTraId) {
          item.noiDung = _this3.state.noiDung;
        }
        return item;
      });
      this.setState({
        yKienXuLy: newYKienXuLy,
        isOpen: false,
        openDoiTuong: false
      });
    }
  }, {
    key: 'handleView',
    value: function handleView() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        openDoiTuong: true
      });
    }
  }, {
    key: 'handleSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, doiTuongId) {
        var newYKienXuLy;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(type === 'hoanthanh')) {
                  _context.next = 8;
                  break;
                }

                if (!this.validateSubmitForm()) {
                  _context.next = 8;
                  break;
                }

                if (!this.state.yKienXuLy) {
                  _context.next = 6;
                  break;
                }

                newYKienXuLy = [].concat(_toConsumableArray(this.state.yKienXuLy)).map(function (item) {
                  if (item.doiTuongId === doiTuongId) {
                    item.dahoanThanh = true;
                  }
                  return item;
                });
                _context.next = 6;
                return this.setState({
                  yKienXuLy: newYKienXuLy,
                  isHoanThanh: true
                });

              case 6:
                this.props.onChange(this.state.yKienXuLy);
                this.closeDialog();

              case 8:
                if (type === 'luu') {
                  this.props.onChange(this.state.yKienXuLy);
                  this.closeDialog();
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      var count = this.props.count;
      var _props$item = this.props.item,
          cuocThanhTras = _props$item.cuocThanhTras,
          doiTuongThanhTraTrung = _props$item.doiTuongThanhTraTrung,
          namThanhTra = _props$item.namThanhTra,
          loaiCuoc = _props$item.loaiCuoc;

      var LisData = cuocThanhTras.map(function (item, index) {
        if (index === 0) {
          return _react2.default.createElement(
            'tr',
            { key: index },
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              count
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length, className: 'txt-underline' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', onClick: _this4.onOpenDialog.bind(_this4) },
                doiTuongThanhTraTrung.ten || ''
              ),
              _react2.default.createElement(
                _core.Dialog,
                {
                  isOpen: _this4.state.openDoiTuong,
                  onClose: _this4.closeDialog.bind(_this4),
                  title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra',
                  className: 'dialog-default wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30 pt20' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: doiTuongThanhTraTrung.ten || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:',
                    value: doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo && doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo.text ? doiTuongThanhTraTrung.loaiDoiTuongThanhTraInfo.text : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ng\xE0nh/L\u0129nh v\u1EF1c:',
                    value: doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo && doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo.ten ? doiTuongThanhTraTrung.linhVucDoiTuongThanhTraInfo.ten : '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Huy\u1EC7n/TP:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'quanHuyenInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ph\u01B0\u1EDDng/X\xE3:',
                    value: (0, _lodash.get)(doiTuongThanhTraTrung, 'phuongXaInfo.name') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: '\u0110\u1ECBa ch\u1EC9:',
                    value: doiTuongThanhTraTrung.diaChi || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:',
                    value: doiTuongThanhTraTrung.soDienThoai || '' }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Ghi ch\xFA:',
                    value: doiTuongThanhTraTrung.ghiChu || '' })
                )
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'donViInfo.ten') || ''
            ),
            _react2.default.createElement(
              'td',
              { className: 'txt-center' },
              (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              namThanhTra || ''
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline text-color-default', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + (0, _lodash.get)(item, 'idCuocThanhTra') },
                !(0, _lodash.isEmpty)(item.tenCuocThanhTra) && _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: (0, _lodash.get)(item, 'tenCuocThanhTra') })
              ),
              _react2.default.createElement(
                'div',
                { className: 'mt10' },
                (0, _lodash.get)(item, 'soDoiTuong'),
                ' \u0111\u1ED1i t\u01B0\u1EE3ng'
              )
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              _react2.default.createElement(
                'div',
                { className: 'mgbt10' },
                '\u0110\u1EC1 xu\u1EA5t chuy\xEAn vi\xEAn x\u1EED l\xFD: '
              ),
              _this4.state.noiDung ? _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: _this4.handleView.bind(_this4) },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: _this4.state.noiDung })
              ) : _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline', onClick: _this4.handleView.bind(_this4) },
                'Nh\u1EADp'
              ),
              _react2.default.createElement(
                _core.Dialog,
                {
                  isOpen: _this4.state.isOpen,
                  onClose: _this4.closeDialog.bind(_this4, 'isClose', count, doiTuongThanhTraTrung.doiTuongThanhTraId),
                  title: '\u0110\u1EC1 Xu\u1EA5t X\u1EED L\xFD',
                  className: 'dialog-default wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30 pt20' },
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Th\u1EDDi gian ph\u1EA3n h\u1ED3i',
                    value: (0, _moment2.default)().format('DD/MM/YYYY') }),
                  _react2.default.createElement(_common.Text, {
                    className: 'col-50 mb10',
                    label: 'Chuy\xEAn vi\xEAn ph\u1EA3n h\u1ED3i:',
                    value: userInfo.name }),
                  _react2.default.createElement(_common.TextArea, { bindValidator: _this4, require: true, channel: 'formDeXuat', className: 'col-100 mb5', label: 'N\u1ED9i dung \u0111\u1EC1 xu\u1EA5t:', value: _this4.state.noiDung, onChange: _this4.onChange.bind(_this4, count, doiTuongThanhTraTrung.doiTuongThanhTraId), name: 'yKienDeXuat', maxLength: 2000 })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt10' },
                  _react2.default.createElement('div', { className: 'big-border' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'action-form-wrap pt20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box-bottom' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-action btn-close', onClick: _this4.closeDialog.bind(_this4, 'close', doiTuongThanhTraTrung.doiTuongThanhTraId) },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u0110\xF3ng'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'btn-action btn-complete position-default', role: 'button', onClick: _this4.handleSubmit.bind(_this4, 'hoanthanh', doiTuongThanhTraTrung.doiTuongThanhTraId) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Ho\xE0n th\xE0nh'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'kyThanhTra') || ''
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')
            ),
            _react2.default.createElement(
              'td',
              { rowSpan: cuocThanhTras.length },
              _this4.state.isHoanThanh ? 'Đã hoàn thành' : 'Đang xử lý'
            )
          );
        }
        return _react2.default.createElement(
          'tr',
          { key: index },
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-left' },
            (0, _lodash.get)(item, 'donViInfo.ten') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white txt-center' },
            (0, _lodash.get)(item, 'quyetDinhPheDuyetKTTT') || ''
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-underline text-color-default', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + (0, _lodash.get)(item, 'idCuocThanhTra') },
              !(0, _lodash.isEmpty)(item.tenCuocThanhTra) && _react2.default.createElement(_reactTextTruncate2.default, {
                line: 3,
                truncateText: '\u2026',
                text: (0, _lodash.get)(item, 'tenCuocThanhTra') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              (0, _lodash.get)(item, 'soDoiTuong'),
              ' \u0111\u1ED1i t\u01B0\u1EE3ng'
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _lodash.get)(item, 'loaiCuoc.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'kyThanhTra') || '',
            ' '
          ),
          _react2.default.createElement(
            'td',
            { className: 'bg-white' },
            (0, _lodash.get)(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')
          )
        );
      });
      return _react2.default.createElement(
        'tbody',
        { className: 'table-body' },
        LisData
      );
    }
  }]);

  return RowItemXuLyThanhTraTrung;
}(_react.Component);

exports.default = (0, _utils.validatable)(RowItemXuLyThanhTraTrung);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(169);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(52);

var _core = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietCuocThanhTra = function (_React$Component) {
  _inherits(ChiTietCuocThanhTra, _React$Component);

  function ChiTietCuocThanhTra(props, context) {
    _classCallCheck(this, ChiTietCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (ChiTietCuocThanhTra.__proto__ || Object.getPrototypeOf(ChiTietCuocThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      dataDetail: [],
      id: _this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      dataCanCuThanhTraLai: [],
      type: _this.props.type,
      showDoiTuongThanhTra: false,
      tienDoThanhTra: false
    };
    return _this;
  }

  _createClass(ChiTietCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDataCanCuThanhTraLai();
      this.getDetail(this.state.id);
      this.getDonViBanHanh();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.tienDoThanhTra !== prevState.tienDoThanhTra) {
        this.setState(_extends({}, this.state, {
          tienDoThanhTra: this.state.tienDoThanhTra
        }));
      }
    }
  }, {
    key: 'getDataCanCuThanhTraLai',
    value: function getDataCanCuThanhTraLai() {
      var _this2 = this;

      _api.ThanhTra.actions.getCanCuThanhTraLai.request().then(function (res) {
        if (res.data) {
          _this2.state.dataCanCuThanhTraLai = res.data;
          _this2.setState(_extends({}, _this2.state));
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.params.id,
        type: nextProps.type
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this3 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataDetail: res.data,
            tienDoThanhTra: res.data.tienDoThanhTra
          }, function () {
            _this3.checkListDoiTuongViPham();
            _this3.getChiTietLienQuanCuocThanhTra(id);
          });
        }
      });
    }
  }, {
    key: 'getChiTietLienQuanCuocThanhTra',
    value: function getChiTietLienQuanCuocThanhTra(id) {
      var _this4 = this;

      _api.ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var data = res.data;
          _this4.setState({
            dataDetail: _extends({}, _this4.state.dataDetail, {
              listTaiLieuVanThu: data.listTaiLieuVanThu || [],
              listTaiLieuVanThuGiaHan: data.listTaiLieuVanThuGiaHan || [],
              listTaiLieuVanThuKetLuanThanhTra: data.listTaiLieuVanThuKetLuanThanhTra || [],
              listTaiLieuVanThuThongBaoKetThucTTTT: data.listTaiLieuVanThuThongBaoKetThucTTTT || [],
              listTaiLieuVanThuThongTinCuocThanhTra: data.listTaiLieuVanThuThongTinCuocThanhTra || [],
              listTaiLieuKetLuanThanhTraRutGon: data.listTaiLieuKetLuanThanhTraRutGon || [],
              listTaiLieuVanThuQuyetDinhGiamSat: data.listTaiLieuVanThuQuyetDinhGiamSat || []
            })
          }, function () {
            _this4.setState({
              showFile: true
            });
          });
        }
      });
    }
  }, {
    key: 'getDonViBanHanh',
    value: function getDonViBanHanh() {
      var _this5 = this;

      _api.ThanhTra.actions.getListDonViBanHanh.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            dataDonViBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'checkListDoiTuongViPham',
    value: function checkListDoiTuongViPham() {
      var Data = this.state.dataDetail;
      var listDoiTuongViPham = [];
      var doiTuongThanhTraLienQuan = [];
      var doiTuongThanhTras = [].concat(_toConsumableArray(Data.listDoiTuongThanhTra));
      var doiTuongThanhTra = Data.doiTuongThanhTraInfo;
      var data = Data.doiTuongThanhTraLienQuan.split('; ');
      if (data.length > 0) {
        data.map(function (state) {
          if (state) {
            doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
              ten: state
            };
          }
        });
      }
      if (doiTuongThanhTraLienQuan.length > 0) {
        doiTuongThanhTraLienQuan.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTras.length > 0) {
        doiTuongThanhTras.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTra) {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: doiTuongThanhTra.ten,
          giaTri: doiTuongThanhTra.ten
        };
      }
      this.setState({
        listDoiTuongViPham: listDoiTuongViPham
      });
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      this.props.dispatch({ type: 'DSTT_GO_BACK' });
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'showDoiTuongThanhTra',
    value: function showDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: true
      });
    }
  }, {
    key: 'hideDoiTuongThanhTra',
    value: function hideDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: false
      });
    }
  }, {
    key: 'getCanCuThanhTraLai',
    value: function getCanCuThanhTraLai(value) {
      if (this.state.dataCanCuThanhTraLai.length > 0) {
        return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(function (x) {
          return x.giaTri == value;
        })].ten;
      } else {
        return;
      }
    }
  }, {
    key: 'getTitleNoiDungThamNhung',
    value: function getTitleNoiDungThamNhung() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      var isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
      var titleNoiDungThamNhung = '';
      if (isTTTW) {
        if (this.state.type === 'KE_HOACH') {
          titleNoiDungThamNhung = '6. Nội dung tham nhũng';
        } else {
          titleNoiDungThamNhung = '5. Nội dung tham nhũng';
        }
      } else {
        if (this.state.type === 'KE_HOACH') {
          titleNoiDungThamNhung = '5. Nội dung tham nhũng';
        } else {
          titleNoiDungThamNhung = '4. Nội dung tham nhũng';
        }
      }
      return titleNoiDungThamNhung;
    }
  }, {
    key: 'getTitleNoiDungKienNghi',
    value: function getTitleNoiDungKienNghi() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      var isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
      var titleNoiDungKienNghi = '';
      if (isTTTW) {
        if (this.state.type === 'KE_HOACH') {
          titleNoiDungKienNghi = '5. Nội dung kiến nghị';
        } else {
          titleNoiDungKienNghi = '4. Nội dung kiến nghị';
        }
      } else {
        if (this.state.type === 'KE_HOACH') {
          titleNoiDungKienNghi = '4. Nội dung kiến nghị';
        } else {
          titleNoiDungKienNghi = '3. Nội dung kiến nghị';
        }
      }
      return titleNoiDungKienNghi;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      var isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
      var Data = this.state.dataDetail;
      var textTrangThai = '';
      if (Data.trangThaiThanhTraRutGon === 'DANG_THUC_HIEN') {
        textTrangThai = "Đang thực hiện";
      } else if (Data.trangThaiThanhTraRutGon === 'DA_THUC_HIEN') {
        textTrangThai = "Đã thực hiện";
      } else if (Data.trangThaiThanhTraRutGon === 'CHUA_THUC_HIEN') {
        textTrangThai = "Chưa thực hiện";
      }
      var DataDetail = this.state.dataDetail;
      var DoiTuongThanhTra = '';
      var TenDTTheoKeHoach = '';
      var chiTietDTTTTheoKeHoach = {};
      var chiTietMotDoiTuong = {};
      if (DataDetail && DataDetail.doiTuongThanhTraInfo) {
        chiTietMotDoiTuong = DataDetail && DataDetail.doiTuongThanhTraInfo;
      } else if (DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
        chiTietMotDoiTuong = DataDetail.listDoiTuongThanhTra[0];
      }
      if (DataDetail.cuocThanhTraNhieuDoiTuong === false && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
        TenDTTheoKeHoach = DataDetail.listDoiTuongThanhTra[0].ten;
      } else if (DataDetail.cuocThanhTraNhieuDoiTuong && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
        TenDTTheoKeHoach = DataDetail.listDoiTuongThanhTra.length + ' \u0111\u1ED1i t\u01B0\u1EE3ng';
      }
      if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && DataDetail.hinhThucThanhTra == "THEO_KE_HOACH") {
        chiTietDTTTTheoKeHoach = Data.listDoiTuongThanhTra[0] || {};
      } else {
        chiTietDTTTTheoKeHoach = Data.doiTuongThanhTraInfo || {};
      }

      if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        Data.listDoiTuongThanhTra.map(function (state, index) {
          if (index == 0) {
            DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
          } else {
            DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
          }
        });
      }
      var dataFilter = this.state.dataDonViBanHanh.filter(function (state) {
        return state.giaTri == Data.donViBanHanh;
      });
      var donViBanHanh = '';
      if (dataFilter.length > 0) {
        donViBanHanh = dataFilter[0].ten;
      }
      if (Data.chucNangCuocThanhTra == null) {
        Data.chucNangCuocThanhTra = DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo.type : '';
        Data.chucNangCuocThanhTraInfo = DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo : {};
      }
      var titleKetLuanThanhTra = this.state.type === 'KE_HOACH' ? '3. Kết luận thanh tra' : '2. Kết luận thanh tra';
      var titleKetLuanThanhTraDayDu = this.state.type === 'KE_HOACH' ? '4. Kết luận thanh tra đầy đủ' : '3. Kết luận thanh tra đầy đủ';
      var isKiemTra = (0, _lodash.get)(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
      var loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
      var keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.onClickClose.bind(this, 'close'), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading with-right-content' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-add' },
            'Th\xF4ng tin chi ti\u1EBFt cu\u1ED9c ',
            loaiCuocText
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (0, _lodash.get)(this.state, 'tienDoThanhTra') == 'LUU_HO_SO' },
            _react2.default.createElement(
              'p',
              { className: 'heading-code', onClick: function onClick() {
                  navigator.clipboard.writeText((0, _lodash.get)(DataDetail, 'hoSoThanhTra.maHoSo') || '');
                  (0, _toastr.Toastr)('Copy mã hồ sơ thành công.', 'success');
                } },
              (0, _lodash.get)(DataDetail, 'hoSoThanhTra.maHoSo'),
              _react2.default.createElement('span', { className: 'tt-copy' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.type === 'KE_HOACH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + loaiCuocText + ' n\u0103m ' + (DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : '') }),
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + keHoachText + ':', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? (0, _moment2.default)(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              _react2.default.createElement('div', { className: 'big-border' })
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'DOT_XUAT' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '1. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.namThanhTra ? Data.namThanhTra : '' }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mb10' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                      loaiCuocText,
                      ':'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content txt-blue txt-underline cursor-pointer txt-inline-block', onClick: this.showDoiTuongThanhTra.bind(this) },
                      TenDTTheoKeHoach
                    )
                  )
                ),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ti\u1EBFn \u0111\u1ED9 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : '', red: true }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c:', className: 'col-25 mb10', value: Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.hinhThucThanhTra === 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' }),
                _react2.default.createElement(_common.Text, { label: 'Lo\u1EA1i h\xECnh:', value: Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : '', className: 'col-25 mb10' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.loaiHinhThanhTra === 'THANH_TRA_LAI' },
                  _react2.default.createElement(_common.Text, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' l\u1EA1i:', value: Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : '', className: 'col-100 mb10' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra === 'HANH_CHINH' },
                  _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: !(0, _lodash.isEmpty)(Data, 'linhVucThanhTraList') ? (0, _lodash.get)(Data, 'linhVucThanhTraList', []).map(function (item) {
                      return item.text;
                    }).join(', ') : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                  _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '2. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mb15' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                      loaiCuocText,
                      ':'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content txt-blue txt-underline cursor-pointer txt-inline-block', onClick: this.showDoiTuongThanhTra.bind(this) },
                      TenDTTheoKeHoach
                    )
                  )
                ),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ti\u1EBFn \u0111\u1ED9 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : '', red: true }),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block mb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.chucNangCuocThanhTraInfo && Data.chucNangCuocThanhTraInfo.text ? Data.chucNangCuocThanhTraInfo.text : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.type === 'KE_HOACH' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra !== 'CHUYEN_NGANH' },
                  _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: !(0, _lodash.isEmpty)(Data, 'linhVucThanhTraList') ? (0, _lodash.get)(Data, 'linhVucThanhTraList', []).map(function (item) {
                      return item.text;
                    }).join(', ') : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                  _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.hinhThucThanhTra === 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                )
              ),
              _react2.default.createElement(_common.Text, { label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ' li\xEAn quan:', className: 'col-100 mb10', value: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien === false },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: Data.listTaiLieuVanThuThongTinCuocThanhTra ? Data.listTaiLieuVanThuThongTinCuocThanhTra : [] })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'section',
                { className: 'row pl35 pr35 mb10' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.thanhVienDoan },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb10' },
                      this.state.type === 'KE_HOACH' ? "2.1 Thành viên đoàn" : '1.1 Thành viên đoàn'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-table-show-oncheck white-table' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.thanhTra.TMTVCTTV,
                          dataList: Data.listThanhVienDoan ? Data.listThanhVienDoan : [],
                          pageData: this.state.pageData,
                          parent: this,
                          hideButtonExport: true,
                          hidePagination: true,
                          search: this.state.search,
                          tableLoading: this.state.tableLoading },
                        _react2.default.createElement(_datatable.RowItemChiTietThanhVienCuocThanhTraView, { linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '' })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pl20 pb20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: Data.giaHan },
            _react2.default.createElement(
              'section',
              { className: 'pl35 pr35 row' },
              _react2.default.createElement(
                'h2',
                { className: 'title-12 mb15' },
                this.state.type === 'KE_HOACH' ? Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.2 Gia hạn' : '2.1 Gia hạn' : Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.2 Gia hạn' : '1.1 Gia hạn'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: Data.ngayRaQuyetDinhGiaHan ? (0, _moment2.default)(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: Data.lyDonGiaHan ? Data.lyDonGiaHan : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == false },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuVanThuGiaHan ? Data.listTaiLieuVanThuGiaHan : [] })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter pt10 pb20' },
                _react2.default.createElement('div', { className: 'line-border' })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 heading-addnew-dttt' },
              _react2.default.createElement(
                'h2',
                { className: 'title-13 col-100 pl20 pr20 mt10 mb15' },
                this.state.type === 'KE_HOACH' ? Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.3 C\u0103n c\u1EE9 cu\u1ED9c ' + loaiCuocText : '2.2 C\u0103n c\u1EE9 cu\u1ED9c ' + loaiCuocText : Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.3 C\u0103n c\u1EE9 cu\u1ED9c ' + loaiCuocText : '1.2 C\u0103n c\u1EE9 cu\u1ED9c ' + loaiCuocText
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 ' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.dsCanCuCuocThanhTraView,
                  dataList: this.state.dataDetail.danhMucVanBans,
                  hidePagination: true,
                  parent: this
                },
                _react2.default.createElement(_datatable.RowItemCanCuCuocThanhTraView, null)
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 heading-addnew-dttt' },
              _react2.default.createElement(
                'h2',
                { className: 'title-13 col-100 pl20 pr20 mt10 mb15' },
                this.state.type === 'KE_HOACH' ? Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.4 Quyết định giám sát' : '2.3 Quyết định giám sát' : Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.4 Quyết định giám sát' : '1.3 Quyết định giám sát'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl20 pr20' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuVanThuQuyetDinhGiamSat ? Data.listTaiLieuVanThuQuyetDinhGiamSat : [] })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: Data && Data.tienDoThanhTraInfo && _typeof(Data.tienDoThanhTraInfo) === 'object' && (Data.tienDoThanhTraInfo.type === 'DANG_THEO_DOI_THUC_HIEN' || Data.tienDoThanhTraInfo.type === 'LUU_HO_SO' || Data.tienDoThanhTraInfo.type === 'DANG_TIEN_HANH' || Data.tienDoThanhTraInfo.type === 'KET_THUC_THANH_TRA_TRUC_TIEP' || Data.tienDoThanhTraInfo.type === 'DA_BAN_HANH_KET_LUAN') },
            !isTTTW && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 pl20 pr20 pb15' },
                  this.state.type === 'KE_HOACH' ? Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' ? '2.4. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + loaiCuocText + ' tr\u1EF1c ti\u1EBFp' : '2.3. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + loaiCuocText + ' tr\u1EF1c ti\u1EBFp' : Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' ? '1.4. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + loaiCuocText + ' tr\u1EF1c ti\u1EBFp' : '1.3. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + loaiCuocText + ' tr\u1EF1c ti\u1EBFp'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_common.Text, { label: 'S\u1ED1 th\xF4ng b\xE1o:', className: 'col-25 mb10', value: Data.soThongBaoKetThucTTTT || '' }),
                  _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhThongBaoKetThucTTTT ? (0, _moment2.default)(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : '' })
                ),
                _react2.default.createElement(_common.TextMessage, { label: 'Ghi ch\xFA:', className: 'col-100 mb10', value: Data.ghiChu || '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == false },
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pr20' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuVanThuThongBaoKetThucTTTT ? Data.listTaiLieuVanThuThongBaoKetThucTTTT : [] })
                )
              )
            )
          ),
          isTTTW && _react2.default.createElement(
            'section',
            { className: 'wrap-block pb10' },
            _react2.default.createElement('div', { className: 'big-border' }),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                this.state.type === 'KE_HOACH' ? '3. K\u1EBFt lu\u1EADn ' + loaiCuocText + ' r\xFAt g\u1ECDn' : '2. K\u1EBFt lu\u1EADn ' + loaiCuocText + ' r\xFAt g\u1ECDn'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(_common.Text, { label: 'Tr\u1EA1ng th\xE1i:', className: 'col-25 mb10', value: textTrangThai }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y th\u1EF1c hi\u1EC7n:', className: 'col-25 mb10', value: Data.ngayThucHienThanhTraRutGon ? (0, _moment2.default)(Data.ngayThucHienThanhTraRutGon).format('DD/MM/YYYY') : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl20 pr20' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuKetLuanThanhTraRutGon || [] })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: Data && Data.tienDoThanhTraInfo && _typeof(Data.tienDoThanhTraInfo) === 'object' && (Data.tienDoThanhTraInfo.type === 'DANG_THEO_DOI_THUC_HIEN' || Data.tienDoThanhTraInfo.type === 'LUU_HO_SO' || Data.tienDoThanhTraInfo.type === 'KET_THUC_THANH_TRA_TRUC_TIEP' || Data.tienDoThanhTraInfo.type === 'DA_BAN_HANH_KET_LUAN') },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: Data && Data.soKetLuanThanhTra },
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-14 p20' },
                      isTTTW ? titleKetLuanThanhTraDayDu : titleKetLuanThanhTra
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl30 pr30' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soKetLuanThanhTra || '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { label: '\u0110\u01A1n v\u1ECB ban h\xE0nh:', className: 'col-25 mb10', value: donViBanHanh })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD:', className: 'col-25 mb10', value: Data.soQuyetDinhXuLy || '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhQuyetDinhXuLy ? (0, _moment2.default)(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(_common.TextMessage, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.tomTatKetLuanThanhTra || '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien != true },
                    _react2.default.createElement(
                      'div',
                      { className: 'pl20 pr20' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : [] })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: Data.noiDungKienNghi },
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pr20' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-big-line' },
                    _react2.default.createElement('div', { className: 'big-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'mb10 pt20 title-14' },
                    this.getTitleNoiDungKienNghi()
                  ),
                  _react2.default.createElement(
                    'section',
                    { className: 'wrap-block pb10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl15 pr15' },
                      _react2.default.createElement(_subView.NoiDungKienNghi, { isTTTW: isTTTW, view: true, linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '', chucNangCuocThanhTra: Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '', listDoiTuongViPham: this.state.listDoiTuongViPham, onRef: function onRef(noiDungKienNghi) {
                          return _this6.noiDungKienNghi = noiDungKienNghi;
                        }, type: this.state.type, id: this.state.id })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: Data.noiDungThamNhung },
                _react2.default.createElement(
                  'section',
                  { className: 'row pl35 pr35 pb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-big-line mb20' },
                    _react2.default.createElement('div', { className: 'big-border' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-14 mb10' },
                      this.getTitleNoiDungThamNhung()
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5:', value: Data.soVuThamNhung ? Data.soVuThamNhung : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : '' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'T\xE0i s\u1EA3n tham nh\u0169ng'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ti\u1EC1n (Tr\u0111):', value: Data.tienThamNhung ? Data.tienThamNhung : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111):', value: Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\u1EA5t (m2):', value: Data.datThamNhung ? Data.datThamNhung : '' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ti\u1EC1n (Tr\u0111):', value: Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111):', value: Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\u1EA5t (m2):', value: Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : '' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter clear-left' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          '\u0110\xE3 thu'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ti\u1EC1n (Tr\u0111):', value: Data.tienDaThu ? Data.tienDaThu : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111):', value: Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\u1EA5t (m2):', value: Data.datDaThu ? Data.datDaThu : '' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\u1ED5 ch\u1EE9c:', value: Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'C\xE1 nh\xE2n:', value: Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : '' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'X\u1EED l\xFD tr\xE1ch nhi\u1EC7m ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u1EA7u'
                        ),
                        _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'S\u1ED1 ng\u01B0\u1EDDi:', value: Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : '' }),
                        _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\xEAn ng\u01B0\u1EDDi:', value: Data.tenNguoi ? Data.tenNguoi : '' })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == true },
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pr20' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { hideDescription: true, disableAttachFile: true, label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', dataShow: Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : [] })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt35 pb5' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: this.onClickClose.bind(this, 'close') },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'KE_HOACH' && DataDetail.chuyenTheoDoiThucHien !== true && DataDetail.tienDoThanhTra !== 'LUU_HO_SO' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-edit', to: '/thanh-tra/chinh-sua-cuoc-thanh-tra/' + this.state.id },
                _react2.default.createElement(
                  'span',
                  null,
                  'Ch\u1EC9nh s\u1EEDa'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'DOT_XUAT' && DataDetail.chuyenTheoDoiThucHien !== true && DataDetail.tienDoThanhTra !== 'LUU_HO_SO' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-edit', to: '/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/' + this.state.id },
                _react2.default.createElement(
                  'span',
                  null,
                  'Ch\u1EC9nh s\u1EEDa'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.showDoiTuongThanhTra,
            onClose: this.hideDoiTuongThanhTra.bind(this),
            title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText,
            className: 'reception-dialog delete-dialog full-dialog'
          },
          DataDetail.cuocThanhTraNhieuDoiTuong === true ? _react2.default.createElement(
            'table',
            { className: 'blueTable' },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  { style: { width: '35px' } },
                  'STT'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '300px' } },
                  'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '165px' } },
                  'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '165px' } },
                  'Huy\u1EC7n/TP'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '165px' } },
                  'Ph\u01B0\u1EDDng/X\xE3'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '375px' } },
                  '\u0110\u1ECBa ch\u1EC9'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '135px' } },
                  'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.map(function (item, index) {
                return _react2.default.createElement(
                  'tr',
                  { key: index },
                  _react2.default.createElement(
                    'td',
                    null,
                    index + 1
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.ten
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _lodash.get)(item, 'quanHuyenInfo.name')
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _lodash.get)(item, 'phuongXaInfo.name')
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.diaChi
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.soDienThoai || ''
                  )
                );
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:', value: chiTietMotDoiTuong.ten || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:', value: chiTietMotDoiTuong && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten : '' }),
              _react2.default.createElement(_common.Text, {
                className: 'col-50 mb10',
                label: 'Huy\u1EC7n/TP:',
                value: (0, _lodash.get)(chiTietMotDoiTuong, 'quanHuyenInfo.name') }),
              _react2.default.createElement(_common.Text, {
                className: 'col-50 mb10',
                label: 'Ph\u01B0\u1EDDng/X\xE3:',
                value: (0, _lodash.get)(chiTietMotDoiTuong, 'phuongXaInfo.name') }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\u1ECBa ch\u1EC9:', value: chiTietMotDoiTuong.diaChi || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:', value: chiTietMotDoiTuong && chiTietMotDoiTuong.soDienThoai ? chiTietMotDoiTuong.soDienThoai : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.hideDoiTuongThanhTra.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietCuocThanhTra;
}(_react2.default.Component);

ChiTietCuocThanhTra.defaultProps = {
  validators: {},
  type: 'DOT_XUAT'
};

exports.default = (0, _reactRedux.connect)()(ChiTietCuocThanhTra);

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(169);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _upload = __webpack_require__(17);

var _rowItem = __webpack_require__(110);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(52);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _dialog = __webpack_require__(18);

var _lodash = __webpack_require__(14);

var _common2 = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiQuyTrinh = 'THANH_TRA';
var temp = 1;

var ChinhSuaCuocThanhTra = function (_React$Component) {
  _inherits(ChinhSuaCuocThanhTra, _React$Component);

  function ChinhSuaCuocThanhTra(props, context) {
    _classCallCheck(this, ChinhSuaCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (ChinhSuaCuocThanhTra.__proto__ || Object.getPrototypeOf(ChinhSuaCuocThanhTra)).call(this, props, context));

    _this.state = {
      isKiemTra: false,
      data: [],
      nhomDoiTuongThanhTraId: '',
      nhomDTList: [],
      isOpenDT: false,
      getTenDoiTuong: [],
      idPushCoQuan: [],
      kyTruocChuyenSang: false,
      dataDetail: [],
      tuKhoa: '',
      maSoThue: '',
      isOpenThanhTra: false,
      loading: false,
      isOpen: false,
      isOpenXL: false,
      linhVucId: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      keHoachThanhTra: '',
      tenMotDoiTuongThanhTra: '',
      tenNhieuDoiTuongThanhTra: '',
      cuocThanhTraNhieuDoiTuong: false,
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      countDoiTuongViPham: 0,
      enableGetThoiHanThanhTra: true,
      showDoiTuongThanhTra: false,
      passPatch: false,
      passPost: false,
      passDelete: false,
      openDialog: false,
      openDialogLuuHoSo: false,
      getDetail: false,
      backConfirm: false,
      hasChange: false,
      textConfirm: '',
      id: _this.props.params.id,
      cuocThanhTraId: _this.props.params.id,
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        thongTinCuocThanhTra: [],
        giaHan: [],
        ketThucTTTT: [],
        ketLuanTranhTra: [],
        rutGon: [],
        ThayTheCTT: [],
        BoSungCTT: []
      },
      type: _this.props.type,
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuKetLuanThanhTra: [],
      listTaiLieuVanThu: [],

      //sugget value
      open: false,
      valueKetQuaLinhVucThanhTra: '',
      valueKetQuaChucNangCuocThanhTra: '',

      dataThanhTraLai: [],
      dataLinhVucThanhTra: [],
      dataDonViChuTri: [],
      dataCoQuanDieuTra: [],
      dataDonViBanHanh: [],
      dataDonViViPham: [],
      dataLoaiHinhThanhTra: [],
      dataHinhThucThanhTra: [],
      dataThanhVienDoan: [],
      dataVaiTroThanhVienDoan: [],
      dataNamThanhTra: [],
      dataChucNangCuocThanhTra: [],
      dataDoiTuongViPhamHienTai: [],

      danhSachCanCuThanhTraLai: [],
      danhSachDonViThanhTra: [],
      danhSachDonViThanhTraLienQuan: [],
      danhSachDonViViPham: [],

      dataDoiTuongViPham: [],

      listDoiTuongViPham: [],
      listtrangThaiRutGon: [],

      //list tai lieu

      listTaiLieuVanThuGiaHan: [],
      listTaiLieuVanThuThongBaoKetThucTTTT: [],
      listTaiLieuVanThuThongTinCuocThanhTra: [],
      listTaiLieuVanThuThayTheCTT: [],
      listTaiLieuVanThuBoSungCTT: [],
      listTaiLieuKetLuanThanhTraRutGon: [],

      //Info

      keHoachThanhTraInfo: null,
      doiTuongThanhTraInfo: null,

      // State value
      namThanhTra: '',
      namThanhTraQĐ: '',
      ten: '',
      doiTuongThanhTra: '',
      kyThanhTra: '',
      tienDoThanhTra: '',
      tienDoThanhTraType: null,
      noiDungThanhTra: '',
      soQuyetDinhVeViecThanhTra: '',
      ngayRaQuyetDinh: '',
      hinhThucThanhTra: 'DOT_XUAT',
      canCuThanhTraDotXuat: '',
      ngayCongBoQuyetDinhThanhTra: '',
      thoiHanThanhTra: 0,
      ngayHetHanThanhTra: '',
      loaiHinhThanhTra: '',
      canCuThanhTraLai: '',
      chucNangCuocThanhTra: 'HANH_CHINH',
      linhVucThanhTraList: [],
      donViChuTri: '',

      donViPhoiHop: '',
      doiTuongThanhTras: [],
      listThanhVienDoan: [],
      thanhVienDoans: [],
      donViThanhTraLienQuan: '',

      soQuyetDinhGiaHan: '',
      ngayRaQuyetDinhGiaHan: '',
      lyDonGiaHan: '',

      ngayQuyetDinhThayTheCTT: '',
      soCongVanThayTheCTT: '',
      lyDoThayTheCTT: '',

      ngayQuyetDinhBoSungCTT: '',
      soCongVanBoSungCTT: '',
      lyDoBoSungCTT: '',

      soQuyetDinhThanhLapDoan: '',
      ngayRaQuyetDinhThanhLapDoan: '',

      soThongBaoKetThucTTTT: '',
      ngayBanHanhThongBaoKetThucTTTT: '',
      nguoiBanHanhThongBaoKetThucTTTT: '',
      ghiChu: '',

      soKetLuanThanhTra: '',
      ngayBanHanhKetLuanThanhTra: '',
      donViBanHanh: '',
      soQuyetDinhXuLy: '',
      ngayBanHanhQuyetDinhXuLy: '',
      tomTatKetLuanThanhTra: '',

      soVuThamNhung: 0,
      soDoiTuongThamNhung: 0,
      tienThamNhung: 0,
      taiSanKhacThamNhung: 0,
      datThamNhung: 0,
      tienKienNghiThuHoi: 0,
      taiSanKhacKienNghiThuHoi: 0,
      datKienNghiThuHoi: 0,
      tienDaThu: 0,
      taiSanKhacDaThu: 0,
      datDaThu: 0,
      toChucXuLyHanhChinhThamNhung: 0,
      caNhanXuLyHanhChinhThamNhung: 0,
      soNguoiXuLyTrachNhiemDungDau: 0,
      tenNguoi: '',
      trangThaiRutGon: '',
      ngayThucHien: '',

      //Tài liệu đính kèm
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      // state các checkbox
      giaHan: false,
      noiDungKienNghi: false,
      coQuyetDinhGiamSat: false,
      noiDungKienNghiInit: false,
      noiDungThamNhung: false,
      thanhVienDoan: false,

      ngayHetHanThanhTraISO: '',
      getThoiHanThanhTra: false,
      showFile: false,
      showFileGiaHan: false,
      dataSuggest: [],
      isSearch: false,
      confirmState: false,

      checkKetThucThanhTraTrucTiep: null,
      checkKetLuanThanhTra: null,
      hinhThucThanhTraChuyenNganhList: [],
      hinhThucThanhTraChuyenNganh: '',

      //confirm
      confirmDoiTuongViPham: false,
      tenDoiTuongViPhamConfirm: '',
      confirmDoiTuongLienQuan: false,
      tenDoiTuongLienQuanConfirm: '',
      thucHienPhapLuatVeThanhTraListCombobox: [],
      thucHienPhapLuatVeThanhTraList: [],
      chiTietLinhVuc: '',
      DataLichSuQuaTrinhXuLy: [],
      dataSelectDoiTuongCurrent: [],
      doiTuongThanhTraId: '',
      listDanhMucVanBan: [],
      danhMucVanBanCanCu: [],
      soVanBanQuyetDinhGiamSat: '',
      ngayBanHanhQuyetDinhGiamSat: '',
      listTaiLieuQuyetDinhGiamSat: [],
      validLinhVucThanhTra: true
    };
    return _this;
  }

  _createClass(ChinhSuaCuocThanhTra, [{
    key: 'addNewVanBanCanCu',
    value: function addNewVanBanCanCu() {
      this.setState(_extends({}, this.state, {
        danhMucVanBanCanCu: [].concat(_toConsumableArray(this.state.danhMucVanBanCanCu), [{
          vanBanId: '',
          coQuanBanHanh: '',
          theLoaiVanBan: '',
          linhVucVanBan: '',
          tenFile: '',
          duongDan: ''
        }])
      }));
    }
  }, {
    key: 'removeVanBanCanCu',
    value: function removeVanBanCanCu(indexRemove) {
      var result = this.state.danhMucVanBanCanCu.filter(function (item, index) {
        return index !== indexRemove;
      });
      this.setState(_extends({}, this.state, {
        danhMucVanBanCanCu: result
      }));
    }
  }, {
    key: 'suggesttion',
    value: function suggesttion(dataSearch) {
      var _this2 = this;

      this.setState({
        isSearch: true
      }, function () {
        var params = {
          tuKhoa: dataSearch
        };

        if (_this2.state.doiTuongThanhTra) {
          params.doiTuongIds = _this2.state.doiTuongThanhTra;
        }
        _api.Danhmuc.actions.getDoiTuongThanhTra.request(params).then(function (res) {
          if (res.data._embedded) {
            _this2.setState({
              dataSuggest: res.data._embedded.doiTuongThanhTras,
              isSearch: false
            });
          } else {
            _this2.setState({
              dataSuggest: [],
              isSearch: false
            });
          }
        });
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
      if (window.debug) {
        console.log('modules/thanh-tra/ChinhSuaCuocThanhTra');
      }
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViChuTri: userInfo.donViId
        });
      }
    }
  }, {
    key: 'getQuanHuyen',
    value: function getQuanHuyen() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getQuanHuyen.request().then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            dsQuanHuyen: res.data._embedded.donViHanhChinhs
          });
        }
      });
    }
  }, {
    key: 'getPhuongXa',
    value: function getPhuongXa() {
      var _this4 = this;

      var quanHuyenId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (quanHuyenId) {
        _api.DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(function (res) {
          _this4.setState({
            dsPhuongXa: (0, _lodash.get)(res, 'data._embedded.donViHanhChinhs') || []
          });
        });
      }
    }
  }, {
    key: 'getListDanhMucVanBan',
    value: function getListDanhMucVanBan() {
      var _this5 = this;

      _api.QuanLyVanBan.actions.getListDanhMucVanBan.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            listDanhMucVanBan: res.data
          });
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCanCuThanhTraLai();
      this.getNhomDoiTuong();
      this.getLinhVucThanhTra();
      this.getLinhVuc();
      this.getDonViChuTri();
      this.getTienDoThanhTra();
      this.getCoQuanDieuTra();
      this.getDonViBanHanh();
      this.getLoaiHinhThanhTra();
      this.getDoiTuongThanhTra();
      this.getHinhThucThanhTra();
      this.getVaiTroThanhVienDoan();
      this.getNamThanhTra();
      this.getChucNangCuocThanhTra();
      this.getHinhThucThanhTraChuyenNganh();
      this.getThucHienPhapLuatVeTT();
      this.getTrangThaiThanhTraRutGon();
      this.getQuyTrinhXuLyHistory();
      this.getListDanhMucVanBan();
      this.getQuanHuyen();
      if (this.state.id) {
        this.getDetail(this.state.id);
      } else {
        this.checkFileRequire();
        this.setState({
          getDetail: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this6 = this;

      this.setState({
        type: nextProps.type
      });
      if (this.props.params.id != nextProps.params.id && nextProps.params.id) {
        this.setState({
          id: nextProps.params.id
        }, function () {
          _this6.getDetail(_this6.state.id);
        });
      }
    }
  }, {
    key: 'getThucHienPhapLuatVeTT',
    value: function getThucHienPhapLuatVeTT() {
      var _this7 = this;

      _api.ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(function (res) {
        if (res.data) {
          _this7.setState({
            thucHienPhapLuatVeThanhTraListCombobox: res.data
          });
        }
      });
    }
  }, {
    key: 'getTrangThaiThanhTraRutGon',
    value: function getTrangThaiThanhTraRutGon() {
      var _this8 = this;

      _api.ThanhTra.actions.getTrangThaiThanhTraRutGon.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this8.setState({
            listtrangThaiRutGon: res.data
          });
        }
      });
    }
  }, {
    key: 'getChucNangCuocThanhTra',
    value: function getChucNangCuocThanhTra() {
      var _this9 = this;

      _api.ThanhTra.actions.getChucNangCuocThanhTra.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataChucNangCuocThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThanhTraChuyenNganh',
    value: function getHinhThucThanhTraChuyenNganh() {
      var _this10 = this;

      _api.ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(function (res) {
        if (res.data) {
          _this10.setState({
            hinhThucThanhTraChuyenNganhList: res.data
          });
        }
      });
    }
  }, {
    key: 'getNhomDoiTuong',
    value: function getNhomDoiTuong() {
      var _this11 = this;

      _api.ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(function (res) {
        var nhomDTList = [];
        if (res.data && res.data._embedded) {
          nhomDTList = res.data._embedded.nhomDoiTuongThanhTras;
        }
        _this11.setState({ nhomDTList: nhomDTList });
      });
    }
  }, {
    key: 'getNamThanhTra',
    value: function getNamThanhTra() {
      var _this12 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (res.data) {
          _this12.setState({
            dataNamThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getCanCuThanhTraLai',
    value: function getCanCuThanhTraLai() {
      var _this13 = this;

      _api.ThanhTra.actions.getCanCuThanhTraLai.request().then(function (res) {
        var dataThanhTraLai = {};
        if (res.data) {
          dataThanhTraLai = res.data;
        }
        _this13.setState({ dataThanhTraLai: dataThanhTraLai });
      });
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this14 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this14.setState({
            dataLinhVucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this15 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data._embedded) {
          _this15.setState({
            dataDonViChuTri: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getTienDoThanhTra',
    value: function getTienDoThanhTra() {
      var _this16 = this;

      _api.ThanhTra.actions.getTienDoThanhTra.request().then(function (res) {
        if (res.data) {
          _this16.setState({
            dataTienDoThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getCoQuanDieuTra',
    value: function getCoQuanDieuTra() {
      var _this17 = this;

      _api.ThanhTra.actions.getCoQuanDieuTra.request().then(function (res) {
        if (res.data._embedded) {
          _this17.setState({
            dataCoQuanDieuTra: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDonViBanHanh',
    value: function getDonViBanHanh() {
      var _this18 = this;

      _api.ThanhTra.actions.getListDonViBanHanh.request().then(function (res) {
        if (res.data) {
          _this18.setState({
            dataDonViBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiHinhThanhTra',
    value: function getLoaiHinhThanhTra() {
      var _this19 = this;

      _api.ThanhTra.actions.getLoaiHinhThanhTra.request().then(function (res) {
        if (res.data) {
          _this19.setState({
            dataLoaiHinhThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDoiTuongThanhTra',
    value: function getDoiTuongThanhTra() {
      var _this20 = this;

      var params = {};
      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      if (this.state.doiTuongThanhTras.length > 0) {
        var listDoiTuongThanhTra = '';
        this.state.doiTuongThanhTras.map(function (item, i) {
          if (i == 0) {
            listDoiTuongThanhTra = item.id;
          } else {
            listDoiTuongThanhTra = listDoiTuongThanhTra + ',' + item.id;
          }
        });
        params.doiTuongIds = listDoiTuongThanhTra;
        params.namThanhTra = getNamTT;
      }

      _api.ThanhTra.actions.getDoiTuongThanhTra.request({ doiTuongIds: params.doiTuongIds, namThanhTra: getNamTT }).then(function (res) {
        if (res.data._embedded) {
          _this20.setState({
            dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThanhTra',
    value: function getHinhThucThanhTra() {
      var _this21 = this;

      _api.ThanhTra.actions.getHinhThucThanhTra.request().then(function (res) {
        if (res.data) {
          _this21.setState({
            dataHinhThucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getVaiTroThanhVienDoan',
    value: function getVaiTroThanhVienDoan() {
      var _this22 = this;

      _api.ThanhTra.actions.getVaiTroThanhVienDoan.request().then(function (res) {
        if (res.data) {
          _this22.setState({
            dataVaiTroThanhVienDoan: res.data
          });
        }
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this23 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          var dataDonViThanhTraLienQuan = [];
          var dataDoiTuongThanhTra = [];
          var dataCanCuThanhTraLai = [];
          var dataSelectDonViViPham = [];
          var danhMucVanBansDetail = [];

          if (Data.danhMucVanBans) {
            danhMucVanBansDetail = Data.danhMucVanBans.map(function (item) {
              return {
                vanBanId: item.danhMucVanBanId,
                coQuanBanHanh: item.coQuanBanHanhInfo.ten,
                theLoaiVanBan: item.loaiVanBanInfo.ten,
                linhVucVanBan: item.linhVucVanBanInfo.ten,
                tenFile: item.documentMetaDataInfo.ten,
                duongDan: item.documentMetaDataInfo.documentId
              };
            });
          }

          if (Data.doiTuongThanhTraLienQuan) {
            var data = Data.doiTuongThanhTraLienQuan.split('; ');
            data.map(function (state) {
              dataDonViThanhTraLienQuan[dataDonViThanhTraLienQuan.length] = {
                ten: state
              };
            });
          }
          /* Tao lai mang list dua vao 2 phan tu tu Data.listDoiTuongThanhTra */
          if (Data.listDoiTuongThanhTra) {
            var _data = [].concat(_toConsumableArray(Data.listDoiTuongThanhTra));
            _data.map(function (state) {
              dataDoiTuongThanhTra[dataDoiTuongThanhTra.length] = {
                id: state.doiTuongThanhTraId,
                ten: state.ten
              };
            });
          }
          if (dataDonViThanhTraLienQuan.length > 0) {
            dataDonViThanhTraLienQuan.map(function (state) {
              dataSelectDonViViPham[dataSelectDonViViPham.length] = {
                giaTri: state.ten,
                ten: state.ten
              };
            });
          }

          var chucNangCuocThanhTra = '';
          if (_this23.state.type !== 'KE_HOACH') {
            chucNangCuocThanhTra = Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '';
          } else {
            chucNangCuocThanhTra = Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '';
          }

          _this23.setState({
            dataDetail: Data,
            dataDonViViPham: dataSelectDonViViPham,
            danhSachDonViThanhTra: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',
            danhSachDonViViPham: Data.doiTuongViPham ? Data.doiTuongViPham : '',
            ten: Data.ten ? Data.ten : '',
            kyTruocChuyenSang: Data.kyTruocChuyenSang ? Data.kyTruocChuyenSang : false,
            cuocThanhTraNhieuDoiTuong: Data.cuocThanhTraNhieuDoiTuong ? Data.cuocThanhTraNhieuDoiTuong : false,
            tenNhieuDoiTuongThanhTra: Data.tenNhieuDoiTuongThanhTra ? Data.tenNhieuDoiTuongThanhTra : '',
            tenMotDoiTuongThanhTra: Data.tenMotDoiTuongThanhTra ? Data.tenMotDoiTuongThanhTra : '',
            namThanhTra: Data.namThanhTra ? Data.namThanhTra : '',
            doiTuongThanhTraInfo: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo : null,
            doiTuongThanhTra: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.doiTuongThanhTraId : '',
            kyThanhTra: Data.kyThanhTra ? Data.kyThanhTra : '',
            tienDoThanhTra: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : '',
            tienDoThanhTraType: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.type : null,
            noiDungThanhTra: Data.noiDungThanhTra ? Data.noiDungThanhTra : '',

            soQuyetDinhVeViecThanhTra: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '',
            ngayRaQuyetDinh: Data.ngayRaQuyetDinh ? new Date(Data.ngayRaQuyetDinh) : '',
            hinhThucThanhTra: Data.hinhThucThanhTra ? Data.hinhThucThanhTra : '',
            canCuThanhTraDotXuat: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '',

            ngayCongBoQuyetDinhThanhTra: Data.ngayCongBoQuyetDinhThanhTra ? new Date(Data.ngayCongBoQuyetDinhThanhTra) : '',
            thoiHanThanhTra: Data.thoiHanThanhTra ? Data.thoiHanThanhTra : '',
            ngayHetHanThanhTra: Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '',
            ngayHetHanThanhTraISO: Data.ngayHetHanThanhTra ? Data.ngayHetHanThanhTra : '',
            loaiHinhThanhTra: Data.loaiHinhThanhTra ? Data.loaiHinhThanhTra : '',
            dataCanCuThanhTraLai: dataCanCuThanhTraLai,
            canCuThanhTraLai: Data.canCuThanhTraLai,

            chucNangCuocThanhTra: chucNangCuocThanhTra ? chucNangCuocThanhTra : '',
            linhVucThanhTraList: Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(function (item) {
              return item.giaTri;
            }) : [],
            donViChuTri: Data.donViChuTriInfo ? Data.donViChuTriInfo.coQuanQuanLyId : '',

            dataDonViPhoiHop: Data.donViPhoiHop ? Data.donViPhoiHop : '',
            DoiTuongThanhTras: Data.listDoiTuongThanhTra ? Data.listDoiTuongThanhTra : '',
            dataDoiTuongThanhTraLienQuan: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',

            dataDoiTuongViPham: Data.listDoiTuongViPham ? Data.listDoiTuongViPham : [],

            donViPhoiHop: Data.donViPhoiHop ? Data.donViPhoiHop : '',
            doiTuongThanhTras: dataDoiTuongThanhTra.length > 0 ? dataDoiTuongThanhTra : [],
            doiTuongThanhTraLienQuan: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',
            hinhThucThanhTraChuyenNganh: Data.hinhThucThanhTraChuyenNganh || '',
            thucHienPhapLuatVeThanhTraList: Data.thucHienPhapLuatVeThanhTraList ? Data.thucHienPhapLuatVeThanhTraList.map(function (item) {
              return item.giaTri;
            }) : [],
            chiTietLinhVuc: Data.chiTietLinhVuc || '',
            giaHan: Data.giaHan,
            soQuyetDinhGiaHan: Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : '',
            ngayRaQuyetDinhGiaHan: Data.ngayRaQuyetDinhGiaHan ? new Date(Data.ngayRaQuyetDinhGiaHan) : '',
            lyDonGiaHan: Data.lyDonGiaHan ? Data.lyDonGiaHan : '',

            ngayQuyetDinhThayTheCTT: Data.ngayQuyetDinhThayTheCTT ? new Date(Data.ngayQuyetDinhThayTheCTT) : '',
            soCongVanThayTheCTT: Data.soCongVanThayTheCTT ? Data.soCongVanThayTheCTT : '',
            lyDoThayTheCTT: Data.lyDoThayTheCTT ? Data.lyDoThayTheCTT : '',

            soQuyetDinhThanhLapDoan: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '',
            ngayRaQuyetDinhThanhLapDoan: Data.ngayRaQuyetDinhThanhLapDoan ? new Date(Data.ngayRaQuyetDinhThanhLapDoan) : '',

            soThongBaoKetThucTTTT: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : '',
            ngayBanHanhThongBaoKetThucTTTT: Data.ngayBanHanhThongBaoKetThucTTTT ? new Date(Data.ngayBanHanhThongBaoKetThucTTTT) : '',
            nguoiBanHanhThongBaoKetThucTTTT: Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.congChucId : '',
            ghiChu: Data.ghiChu ? Data.ghiChu : '',

            trangThaiRutGon: Data.trangThaiThanhTraRutGon ? Data.trangThaiThanhTraRutGon : '',
            ngayThucHien: Data.ngayThucHienThanhTraRutGon ? new Date(Data.ngayThucHienThanhTraRutGon) : '',

            soKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '',
            ngayBanHanhKetLuanThanhTra: Data.ngayBanHanhKetLuanThanhTra ? new Date(Data.ngayBanHanhKetLuanThanhTra) : '',
            donViBanHanh: Data.donViBanHanh ? Data.donViBanHanh : '',
            soQuyetDinhXuLy: Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : '',
            ngayBanHanhQuyetDinhXuLy: Data.ngayBanHanhQuyetDinhXuLy ? new Date(Data.ngayBanHanhQuyetDinhXuLy) : '',
            tomTatKetLuanThanhTra: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '',

            noiDungKienNghi: Data.noiDungKienNghi,
            noiDungKienNghiInit: Data.noiDungKienNghi,
            coQuyetDinhGiamSat: Data.coQuyetDinhGiamSat,

            noiDungThamNhung: Data.noiDungThamNhung,

            thanhVienDoan: Data.thanhVienDoan,

            thanhVienDoans: Data.listThanhVienDoan,

            soVuThamNhung: Data.soVuThamNhung ? Data.soVuThamNhung : 0,
            soDoiTuongThamNhung: Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : 0,

            tienThamNhung: Data.tienThamNhung ? Data.tienThamNhung : 0,
            taiSanKhacThamNhung: Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : 0,
            datThamNhung: Data.datThamNhung ? Data.datThamNhung : 0,

            tienKienNghiThuHoi: Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : 0,
            taiSanKhacKienNghiThuHoi: Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : 0,
            datKienNghiThuHoi: Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : 0,

            tienDaThu: Data.tienDaThu ? Data.tienDaThu : 0,
            taiSanKhacDaThu: Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : 0,
            datDaThu: Data.datDaThu ? Data.datDaThu : 0,

            toChucXuLyHanhChinhThamNhung: Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : 0,
            caNhanXuLyHanhChinhThamNhung: Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : 0,
            soNguoiXuLyTrachNhiemDungDau: Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : 0,
            tenNguoi: Data.tenNguoi ? Data.tenNguoi : '',

            checkKetThucThanhTraTrucTiep: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : null,
            checkKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : null,
            isKiemTra: Data.loaiCuoc.value === 'KIEM_TRA',
            danhMucVanBanCanCu: danhMucVanBansDetail
          }, function () {
            _this23.checkListDoiTuongViPham();
          });
        }
      });
      this.getChiTietLienQuanCuocThanhTra(id);
    }
  }, {
    key: 'getChiTietLienQuanCuocThanhTra',
    value: function getChiTietLienQuanCuocThanhTra(id) {
      var _this24 = this;

      _api.ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          _this24.setState({
            listTaiLieuVanThu: Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : [],
            listTaiLieuVanThuGiaHan: Data.listTaiLieuVanThuGiaHan ? Data.listTaiLieuVanThuGiaHan : [],
            listTaiLieuVanThuKetLuanThanhTra: Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : [],
            listTaiLieuVanThuThongBaoKetThucTTTT: Data.listTaiLieuVanThuThongBaoKetThucTTTT ? Data.listTaiLieuVanThuThongBaoKetThucTTTT : [],
            listTaiLieuQuyetDinhGiamSat: Data.listTaiLieuVanThuQuyetDinhGiamSat ? Data.listTaiLieuVanThuQuyetDinhGiamSat : [],
            listTaiLieuVanThuThongTinCuocThanhTra: Data.listTaiLieuVanThuThongTinCuocThanhTra ? Data.listTaiLieuVanThuThongTinCuocThanhTra : [],
            listTaiLieuVanThuThayTheCTT: Data.listTaiLieuVanThuThayTheCTT ? Data.listTaiLieuVanThuThayTheCTT : [],
            listTaiLieuVanThuBoSungCTT: Data.listTaiLieuVanThuBoSungCTT ? Data.listTaiLieuVanThuBoSungCTT : [],
            listTaiLieuKetLuanThanhTraRutGon: Data.listTaiLieuKetLuanThanhTraRutGon || [],
            getDetail: true
          }, function () {
            _this24.checkFileRequire();
          });
        }
      });
    }
  }, {
    key: 'checkListDoiTuongViPham',
    value: function checkListDoiTuongViPham() {
      var listDoiTuongViPham = [];
      var doiTuongThanhTraLienQuan = [];
      var doiTuongThanhTras = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
      var doiTuongThanhTra = this.state.doiTuongThanhTraInfo;
      var data = this.state.dataDoiTuongThanhTraLienQuan.split('; ');

      if (data.length > 0) {
        data.map(function (state) {
          if (state) {
            doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
              ten: state
            };
          }
        });
      }
      if (doiTuongThanhTraLienQuan.length > 0) {
        doiTuongThanhTraLienQuan.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTras.length > 0) {
        doiTuongThanhTras.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTra) {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: doiTuongThanhTra.ten,
          giaTri: doiTuongThanhTra.ten
        };
      }
      this.setState({
        listDoiTuongViPham: listDoiTuongViPham
      });
    }
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      var dataTaiLieuVanThu = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThongTinCuocThanhTra));
      var dataTaiLieuVanThuFilter = dataTaiLieuVanThu.filter(function (state) {
        return state.typeRequired == 'TT_QUYET_DINH_THANH_TRA';
      });
      if (dataTaiLieuVanThuFilter.length > 0) {
        // do nothing
      } else {
        var newItem = {
          ten: 'Quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_QUYET_DINH_THANH_TRA',
          newFile: true,
          nhomHoSo: null
        };
        this.state.listTaiLieuVanThuThongTinCuocThanhTra = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThongTinCuocThanhTra), [newItem]);
      }

      var dataTaiLieuVanThuThongBaoKetThucTTTT = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThongBaoKetThucTTTT));
      var dataTaiLieuQuyetDinhGiamSat = [].concat(_toConsumableArray(this.state.listTaiLieuQuyetDinhGiamSat));
      var dataTaiLieuVanThuThongBaoKetThucTTTTFilter = dataTaiLieuVanThuThongBaoKetThucTTTT.filter(function (state) {
        return state.typeRequired == 'TT_THONG_BAO_KT_TTTT';
      });
      var dataTaiLieuQuyetDinhGiamSatFilter = dataTaiLieuQuyetDinhGiamSat.filter(function (state) {
        return state.typeRequired == 'TT_THONG_BAO_KT_TTTT';
      });
      if (dataTaiLieuVanThuThongBaoKetThucTTTTFilter.length > 0) {
        // do nothing
      } else {
        var _newItem = {
          ten: 'Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' tr\u1EF1c ti\u1EBFp',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_THONG_BAO_KT_TTTT',
          newFile: true,
          nhomHoSo: null
        };
        this.state.listTaiLieuVanThuThongBaoKetThucTTTT = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThongBaoKetThucTTTT), [_newItem]);
      }

      if (dataTaiLieuQuyetDinhGiamSatFilter.length > 0) {} else {
        var _newItem2 = {
          ten: 'Quyết định giám sát',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_THONG_BAO_KT_TTTT',
          newFile: false,
          nhomHoSo: null
        };
        this.state.listTaiLieuQuyetDinhGiamSat = [].concat(_toConsumableArray(this.state.listTaiLieuQuyetDinhGiamSat), [_newItem2]);
      }

      var dataTaiLieuVanThuKetLuanThanhTra = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuKetLuanThanhTra));
      var dataTaiLieuVanThuKetLuanThanhTraFilter = dataTaiLieuVanThuKetLuanThanhTra.filter(function (state) {
        return state.typeRequired == 'TT_KET_LUAN_THANH_TRA';
      });
      if (dataTaiLieuVanThuKetLuanThanhTraFilter.length > 0) {
        // do nothing
      } else {
        var _newItem3 = {
          ten: 'K\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_KET_LUAN_THANH_TRA',
          newFile: true,
          nhomHoSo: null
        };
        this.state.listTaiLieuVanThuKetLuanThanhTra = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuKetLuanThanhTra), [_newItem3]);
      }
      var dataTaiLieuVanThuTT = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThayTheCTT));
      if (dataTaiLieuVanThuTT.length > 0) {
        // do nothing
      } else {
        var _newItem4 = {
          ten: 'Văn bản đính kèm khác',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          newFile: true,
          nhomHoSo: null
        };
        this.setState({
          listTaiLieuVanThuThayTheCTT: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThayTheCTT), [_newItem4])
        });
      }

      if (this.state.giaHan) {
        var data = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaHan));
        var dataFilter = data.filter(function (state) {
          return state.typeRequired == 'TT_GIA_HAN';
        });
        if (dataFilter.length > 0) {
          // do nothing
        } else {
          var _newItem5 = {
            ten: 'Quyết định gia hạn',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'TT_GIA_HAN',
            newFile: true,
            nhomHoSo: null
          };
          this.state.listTaiLieuVanThuGiaHan = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaHan), [_newItem5]);
        }
      }
      this.setState(_extends({}, this.state, {
        showFile: true,
        showFileGiaHan: true
      }));
    }
  }, {
    key: 'checkFileGiaHan',
    value: function checkFileGiaHan() {
      if (this.state.giaHan) {
        var data = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaHan));
        var dataFilter = data.filter(function (state) {
          return state.typeRequired == 'TT_GIA_HAN';
        });
        if (dataFilter.length > 0) {
          // do nothing
        } else {
          var newItem = {
            ten: 'Quyết định gia hạn',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'TT_GIA_HAN',
            newFile: true,
            nhomHoSo: null
          };
          this.state.listTaiLieuVanThuGiaHan = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuGiaHan), [newItem]);
        }
      }
      this.setState(_extends({}, this.state, {
        showFileGiaHan: true
      }));
    }
  }, {
    key: 'checkNoiDungKienNghi',
    value: function checkNoiDungKienNghi() {
      if (this.state.noiDungKienNghiInit == false && this.state.id) {
        this.clearData();
      }
    }
  }, {
    key: 'onFileChangeDK',
    value: function onFileChangeDK(data) {
      var state = this.state;
      if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
        state.dsTaiLieuBoSung = data;
      } else {
        state.dsTepDinhKem = data;
      }
      this.setState(state);
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(cuocId, keHoachId, data, loaiQT, buocGQ) {
      var listAddNew = [];
      var listUpdate = [];
      data.forEach(function (item, i) {
        var params = {
          cuocThanhTra: { id: parseInt(cuocId) },
          keHoachThanhTra: { id: keHoachId },
          nhomHoSo: { id: item.nhomHoSo },
          loaiQuyTrinh: loaiQT,
          buocGiaiQuyet: buocGQ
        };
        if (item.ten) {
          params.ten = item.ten;
          params.tenFileds = item.ten;
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (item.typeRequired) {
          params.typeRequired = item.typeRequired;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
        }
        if (item.taiLieuVanThuId) {
          params.id = item.taiLieuVanThuId;
          listUpdate.push(params);
        } else {
          listAddNew.push(params);
        }
      });
      if (listAddNew.length) {
        _api.ThanhTra.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
      if (listUpdate.length) {
        _api.ThanhTra.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'THONG_TIN_CUOC_THANH_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.thongTinCuocThanhTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else if (type == 'THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP') {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.ketThucTTTT = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      } else if (type === 'KET_LUAN_THANH_TRA_RUT_GON') {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.rutGon = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      } else {
        var _dataFileDinhKem4 = this.state.dataFileDinhKem;
        _dataFileDinhKem4.ketLuanTranhTra = data;
        this.setState({
          dataFileDinhKem: _dataFileDinhKem4
        });
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      if (type == 'THONG_TIN_CUOC_THANH_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.thongTinCuocThanhTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type === 'THAY_THE_CUOC_THANH_TRA') {
        var _dataFileDinhKem5 = this.state.dataFileDinhKem;
        _dataFileDinhKem5.ThayTheCTT = data;
        this.setState({
          dataFileDinhKem: _dataFileDinhKem5
        });
      } else if (type === 'BO_SUNG_CUOC_THANH_TRA') {
        var _dataFileDinhKem6 = this.state.dataFileDinhKem;
        _dataFileDinhKem6.BoSungCTT = data;
        this.setState({
          dataFileDinhKem: _dataFileDinhKem6
        });
      } else if (type == 'GIA_HAN') {
        var _dataFileDinhKem7 = this.state.dataFileDinhKem;

        _dataFileDinhKem7.giaHan = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem7
        });
      } else if (type == 'THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP') {
        var _dataFileDinhKem8 = this.state.dataFileDinhKem;

        _dataFileDinhKem8.ketThucTTTT = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem8
        });
      } else if (type === 'KET_LUAN_THANH_TRA_RUT_GON') {
        var _dataFileDinhKem9 = this.state.dataFileDinhKem;
        _dataFileDinhKem9.rutGon = data;
        this.setState({
          dataFileDinhKem: _dataFileDinhKem9
        });
      } else {
        var _dataFileDinhKem10 = this.state.dataFileDinhKem;

        _dataFileDinhKem10.ketLuanTranhTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem10
        });
      }
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this25 = this;

      var startDate = (0, _moment2.default)(this.state.ngayRaQuyetDinh, 'MM/DD/YYYY').valueOf();
      var endDate = (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra, 'MM/DD/YYYY').valueOf();
      var checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
      var checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
      var checKH = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item;
      if (startDate && endDate && startDate <= endDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0 || !startDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0 || !endDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0) {
        this.setState({
          enableGetThoiHanThanhTra: false,
          btnLoading: true,
          btnSaveLoading: true
        });
        var params = this.getParams();
        params.thayDoiTienDo = false;
        params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
        params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(function (item) {
          return !!item.vanBanId;
        }).map(function (item) {
          return { id: item.vanBanId };
        });
        if (this.state.id) {
          this.pushTaiLieu(this.state.id);
          _api.ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
            if (res.data) {
              _this25.handleBack(true);
              (0, _toastr.Toastr)(_this25.checkIsKiemTra() ? _message.msg.saveCuocKTSuccess : _message.msg.saveCuocTTSuccess, 'success');
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this25.setState({
              btnLoading: false,
              btnSaveLoading: false
            });
          });
        } else {
          _api.ThanhTra.actions.postCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
            if (res.data) {
              _this25.pushTaiLieu(res.data.cuocThanhTraId);
              if (checKH && checKH.hinhThucThanhTraInfo && checKH.hinhThucThanhTraInfo.type === 'THEO_KE_HOACH') {
                if (checkLayoutBoSung === true) {
                  if (checkInfoTTKHTT && checkInfoTTKHTT.keHoachThanhTraId) {
                    var loaiQT = 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA';
                    var buocGQ = 'BO_SUNG_CUOC_THANH_TRA';
                    _this25.createDSTepDinhKem(res.data.cuocThanhTraId, checkInfoTTKHTT.keHoachThanhTraId, _this25.state.dsTepDinhKem, loaiQT, buocGQ);
                  }
                }
              }
              _this25.handleBack(true);
              (0, _toastr.Toastr)(_this25.checkIsKiemTra() ? _message.msg.saveCuocKTSuccess : _message.msg.saveCuocTTSuccess, 'success');
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      } else if (this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0) {
        (0, _toastr.Toastr)('Ngày ra quyết định phải nhỏ hơn hoặc bằng Ngày công bố quyết định', 'warning');
      } else {
        (0, _toastr.Toastr)('Phải chọn ít nhất một đối tượng thanh tra', 'error');
      }
    }
  }, {
    key: 'postProcess',
    value: function postProcess() {
      var _this26 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          enableGetThoiHanThanhTra: false,
          btnLoading: true
        });
        var params = this.getParams();
        params.thayDoiTienDo = true;
        params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
        params.listDanhMucVanBan = undefined;
        params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(function (item) {
          return !!item.vanBanId;
        }).map(function (item) {
          return { id: item.vanBanId };
        });
        if (this.state.id) {
          this.pushTaiLieu(this.state.id);
          _api.ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
            if (res.data) {
              _this26.handleBack(true);
              if (_this26.state.tienDoThanhTraType !== 'DANG_TIEN_HANH' && _this26.state.tienDoThanhTraType !== 'KET_THUC_THANH_TRA_TRUC_TIEP' && _this26.state.tienDoThanhTraType !== 'DA_BAN_HANH_KET_LUAN') {
                (0, _toastr.Toastr)(_this26.checkIsKiemTra() ? _message.msg.ttTienHanhKiemTra : _message.msg.ttTienHanhThanhTra, 'success');
              } else if (_this26.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
                (0, _toastr.Toastr)(_this26.checkIsKiemTra() ? _message.msg.ttKetThucKiemTra : _message.msg.ttKetThucThanhTra, 'success');
              }
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this26.setState({
              btnLoading: false
            });
          });
        } else {
          _api.ThanhTra.actions.postCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
            if (res.data) {
              _this26.pushTaiLieu(res.data.cuocThanhTraId);
              _this26.handleBack(true);
              if (_this26.state.tienDoThanhTraType !== 'DANG_TIEN_HANH' && _this26.state.tienDoThanhTraType !== 'KET_THUC_THANH_TRA_TRUC_TIEP' && _this26.state.tienDoThanhTraType !== 'DA_BAN_HANH_KET_LUAN') {
                (0, _toastr.Toastr)(_this26.checkIsKiemTra() ? _message.msg.ttTienHanhKiemTra : _message.msg.ttTienHanhThanhTra, 'success');
              } else if (_this26.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
                (0, _toastr.Toastr)(_this26.checkIsKiemTra() ? _message.msg.ttKetThucKiemTra : _message.msg.ttKetThucThanhTra, 'success');
              }
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this26.setState({
              btnLoading: false
            });
          });
        }
      }
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      this.setState({
        enableGetThoiHanThanhTra: false,
        btnLoading: true
      });
      this.pushTaiLieu(this.state.id, 'KET_THUC');
    }
  }, {
    key: 'handleKetThucThanhTra',
    value: function handleKetThucThanhTra() {
      var params = this.getParams();
      params.thayDoiTienDo = true;
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      if (this.state.noiDungKienNghi == true && !this.checkIsKiemTra()) params.chuyenTheoDoiThucHien = true;else params.chuyenTheoDoiThucHien = false;
      if (this.state.coQuyetDinhGiamSat == true) {
        params.coQuyetDinhGiamSat = true;
      }

      var self = this;
      setTimeout(function () {
        _api.ThanhTra.actions.patchCuocThanhTra.request({ id: self.state.id }, params).then(function (res) {
          self.handleBack(true);
          if (res.data.chuyenTheoDoiThucHien == true) (0, _toastr.Toastr)(_message.msg.ttChuyenTheoDoi, 'success');else (0, _toastr.Toastr)(_message.msg.ttLuuHoSo, 'success');
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          self.setState({
            btnLoading: false
          });
        });
      }, 500);
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var d = new Date();
      var getNam = d.getFullYear() + 1;
      var params = {};
      var checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
      var checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
      var keHoach = params.keHoachThanhTraGocInfo && params.keHoachThanhTraGocInfo.keHoachThanhTraId ? params.keHoachThanhTraGocInfo.keHoachThanhTraId : null;
      var dateNow = new Date();
      var hinhThucThanhTra = this.state.hinhThucThanhTra || null;
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      if (this.state.id) {
        params = this.state.dataDetail;
      }
      params.kyTruocChuyenSang = this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : false;
      params.namThanhTra = getNam;
      params.ten = this.state.ten ? this.state.ten : '';
      if (this.state.ngayRaQuyetDinh && this.state.ngayCongBoQuyetDinhThanhTra) {
        this.checkDate(this.state.ngayRaQuyetDinh, this.state.ngayCongBoQuyetDinhThanhTra);
      }
      if (this.state.type != 'DOT_XUAT') {
        if (params.doiTuongThanhTraInfo) {
          params.doiTuongThanhTra = {
            id: params.doiTuongThanhTraInfo.doiTuongThanhTraId
          };
        } else {
          params.doiTuongThanhTra = null;
        }
      } else {
        if (this.state.doiTuongThanhTra) {
          params.doiTuongThanhTra = {
            id: Number(this.state.doiTuongThanhTra)
          };
        } else {
          params.doiTuongThanhTra = null;
        }
      }
      params.kyTruocChuyenSang = this.state.kyTruocChuyenSang || false;
      params.cuocThanhTraNhieuDoiTuong = this.state.cuocThanhTraNhieuDoiTuong;
      params.tenMotDoiTuongThanhTra = this.state.tenMotDoiTuongThanhTra;
      params.tenNhieuDoiTuongThanhTra = this.state.tenNhieuDoiTuongThanhTra;
      params.kyThanhTra = this.state.kyThanhTra ? this.state.kyThanhTra : '';
      params.noiDungThanhTra = this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '';
      params.soQuyetDinhVeViecThanhTra = this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '';
      params.ngayRaQuyetDinh = this.state.ngayRaQuyetDinh ? (0, _moment2.default)(this.state.ngayRaQuyetDinh).add(7, 'hours').toISOString() : null;
      params.hinhThucThanhTra = hinhThucThanhTra;
      if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
        params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
      } else {
        params.canCuThanhTraDotXuat = '';
      }

      params.ngayCongBoQuyetDinhThanhTra = this.state.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString() : null;
      params.thoiHanThanhTra = this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0;
      params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;
      params.loaiHinhThanhTra = this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null;
      params.chiTietLinhVuc = this.state.chiTietLinhVuc ? this.state.chiTietLinhVuc : null;

      if (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' && this.state.hinhThucThanhTraChuyenNganh) {
        params.hinhThucThanhTraChuyenNganh = this.state.hinhThucThanhTraChuyenNganh;
      }

      if (this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') && this.state.thucHienPhapLuatVeThanhTraList) {
        params.thucHienPhapLuatVeThanhTraList = this.state.thucHienPhapLuatVeThanhTraList;
      } else {
        params.thucHienPhapLuatVeThanhTraList = null;
      }

      if (this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
        params.canCuThanhTraLai = this.state.canCuThanhTraLai;
      }

      params.chucNangCuocThanhTra = this.state.chucNangCuocThanhTra ? this.state.chucNangCuocThanhTra : null;
      if (this.state.chucNangCuocThanhTra == 'HANH_CHINH') {
        params.linhVucThanhTraList = this.state.linhVucThanhTraList ? this.state.linhVucThanhTraList : null;
      } else {
        params.linhVucThanhTraList = null;
      }

      if (this.state.donViChuTri) {
        params.donViChuTri = {
          id: Number(this.state.donViChuTri)
        };
      } else {
        params.donViChuTri = null;
      }

      params.donViPhoiHop = this.state.donViPhoiHop ? this.state.donViPhoiHop : '';

      params.doiTuongThanhTras = !(0, _lodash.isEmpty)(this.state.doiTuongThanhTras) ? this.state.doiTuongThanhTras.map(function (item) {
        return { id: item.id };
      }) : undefined;

      params.doiTuongThanhTraLienQuan = this.state.doiTuongThanhTraLienQuan ? this.state.doiTuongThanhTraLienQuan : '';

      params.lyDoThayTheCTT = this.state.lyDoThayTheCTT ? this.state.lyDoThayTheCTT : '';

      params.ngayQuyetDinhThayTheCTT = this.state.ngayQuyetDinhThayTheCTT ? (0, _moment2.default)(this.state.ngayQuyetDinhThayTheCTT).add(7, 'hours').toISOString() : null;

      params.soCongVanThayTheCTT = this.state.soCongVanThayTheCTT ? this.state.soCongVanThayTheCTT : '';

      params.lyDoBoSungCTT = this.state.lyDoBoSungCTT ? this.state.lyDoBoSungCTT : '';

      params.ngayQuyetDinhBoSungCTT = this.state.ngayQuyetDinhBoSungCTT ? (0, _moment2.default)(this.state.ngayQuyetDinhBoSungCTT).add(7, 'hours').toISOString() : null;

      params.soCongVanBoSungCTT = this.state.soCongVanBoSungCTT ? this.state.soCongVanBoSungCTT : '';
      if (this.state.type === 'KE_HOACH') {
        if (keHoach) {
          var loaiQT = 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA';
          var buocGQ = 'THAY_THE_CUOC_THANH_TRA';
          this.createDSTepDinhKem(this.state.cuocThanhTraId, keHoach, this.state.dsTepDinhKem, loaiQT, buocGQ);
        }
      }

      if (checkLayoutBoSung === true) {
        params.hinhThucThanhTra = 'THEO_KE_HOACH';
        params.keHoachThanhTra = checkInfoTTKHTT && checkInfoTTKHTT.keHoachThanhTraId;
      }

      if (this.state.giaHan) {
        params.giaHan = true;
        params.soQuyetDinhGiaHan = this.state.soQuyetDinhGiaHan ? this.state.soQuyetDinhGiaHan : '';
        params.ngayRaQuyetDinhGiaHan = this.state.ngayRaQuyetDinhGiaHan ? (0, _moment2.default)(this.state.ngayRaQuyetDinhGiaHan).add(7, 'hours').toISOString() : null;
        params.lyDonGiaHan = this.state.lyDonGiaHan ? this.state.lyDonGiaHan : '';
      } else {
        params.giaHan = false;
        params.soQuyetDinhGiaHan = '';
        params.ngayRaQuyetDinhGiaHan = null;
        params.lyDonGiaHan = '';
      }

      if (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' && this.state.thanhVienDoan) {
        var thanhVienDoans = [];
        if (this.state.thanhVienDoans.length > 0) {
          this.state.thanhVienDoans.map(function (state) {
            var newItem = {
              chucVu: state.chucVu ? state.chucVu : '',
              donVi: state.donVi ? state.donVi : '',
              hoVaTen: state.hoVaTen ? state.hoVaTen : '',
              ngaySinh: state.ngaySinh ? (0, _moment2.default)(new Date(state.ngaySinh)).add(7, 'hours').toISOString() : '',
              vaiTroThanhVienDoan: state.vaiTroThanhVienDoan ? state.vaiTroThanhVienDoan : null
            };
            if (state.thanhVienDoanId) {
              newItem.id = Number(state.thanhVienDoanId);
            }
            thanhVienDoans[thanhVienDoans.length] = newItem;
          });
        }
        params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
        params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : null;

        params.thanhVienDoan = true;
        params.thanhVienDoans = thanhVienDoans;
      } else {
        params.soQuyetDinhThanhLapDoan = '';
        params.ngayRaQuyetDinhThanhLapDoan = null;

        params.thanhVienDoan = false;
        params.thanhVienDoans = [];
      }

      if (userInfo.capCoQuanQuanLyId === TTTrungUong) {
        params.ngayBanHanhThongBaoKetThucTTTT = (0, _moment2.default)(dateNow).add(7, 'hours').toISOString() || null;
      } else {
        params.ngayBanHanhThongBaoKetThucTTTT = this.state.ngayBanHanhThongBaoKetThucTTTT ? (0, _moment2.default)(this.state.ngayBanHanhThongBaoKetThucTTTT).add(7, 'hours').toISOString() : null;
      }
      params.soThongBaoKetThucTTTT = this.state.soThongBaoKetThucTTTT ? this.state.soThongBaoKetThucTTTT : '';
      params.nguoiBanHanhThongBaoKetThucTTTT = this.state.nguoiBanHanhThongBaoKetThucTTTT ? { id: this.state.nguoiBanHanhThongBaoKetThucTTTT } : null;
      params.ghiChu = this.state.ghiChu ? this.state.ghiChu : '';

      params.trangThaiThanhTraRutGon = this.state.trangThaiRutGon || null;
      params.ngayThucHienThanhTraRutGon = this.state.ngayThucHien ? (0, _moment2.default)(this.state.ngayThucHien).add(7, 'hours').toISOString() : null;

      params.soKetLuanThanhTra = this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '';
      params.ngayBanHanhKetLuanThanhTra = this.state.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(this.state.ngayBanHanhKetLuanThanhTra).add(7, 'hours').toISOString() : null;
      params.donViBanHanh = this.state.donViBanHanh ? this.state.donViBanHanh : null;
      params.soQuyetDinhXuLy = this.state.soQuyetDinhXuLy ? this.state.soQuyetDinhXuLy : '';
      params.ngayBanHanhQuyetDinhXuLy = this.state.ngayBanHanhQuyetDinhXuLy ? (0, _moment2.default)(this.state.ngayBanHanhQuyetDinhXuLy).add(7, 'hours').toISOString() : null;
      params.tomTatKetLuanThanhTra = this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '';

      params.noiDungKienNghi = this.state.noiDungKienNghi;

      if (this.state.noiDungKienNghi == false && this.state.id) {
        this.clearData();
      }

      params.coQuyetDinhGiamSat = this.state.coQuyetDinhGiamSat;

      if (params.tienDoThanhTraInfo) {
        if (this.state.noiDungKienNghi === true) {
          params.tienDoThanhTra = params.tienDoThanhTraInfo.type;
        } else if (this.state.openDialogLuuHoSo === true && this.state.noiDungKienNghi === false && this.state.tienDoThanhTraType === 'KET_THUC_THANH_TRA_TRUC_TIEP') {
          params.tienDoThanhTra = 'LUU_HO_SO';
        }
      } else {
        params.tienDoThanhTra = null;
      }

      if (this.state.openDialogLuuHoSo === true && !!this.state.id && this.checkIsKiemTra() && this.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
        params.tienDoThanhTra = 'LUU_HO_SO';
      }

      if (this.state.noiDungThamNhung) {
        params.noiDungThamNhung = true;
        params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
        params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
        params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
        params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
        params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
        params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
        params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
        params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
        params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
        params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
        params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
        params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
        params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
        params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
        params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
      } else {
        params.noiDungThamNhung = false;
        params.soVuThamNhung = 0;
        params.soDoiTuongThamNhung = 0;
        params.tienThamNhung = 0;
        params.taiSanKhacThamNhung = 0;
        params.datThamNhung = 0;
        params.tienKienNghiThuHoi = 0;
        params.taiSanKhacKienNghiThuHoi = 0;
        params.datKienNghiThuHoi = 0;
        params.tienDaThu = 0;
        params.taiSanKhacDaThu = 0;
        params.datDaThu = 0;
        params.toChucXuLyHanhChinhThamNhung = 0;
        params.caNhanXuLyHanhChinhThamNhung = 0;
        params.soNguoiXuLyTrachNhiemDungDau = 0;
        params.tenNguoi = '';
      }

      if (params.danhMucVanBans) {
        params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(function (item) {
          return !!item.vanBanId;
        }).map(function (item) {
          return { id: item.vanBanId };
        });
      }

      if (params.keHoachThanhTraInfo) {
        params.keHoachThanhTra = {
          id: params.keHoachThanhTraInfo.keHoachThanhTraId
        };
      } else {
        params.keHoachThanhTra = null;
      }
      if (params.keHoachThanhTraSearchInfo) {
        params.keHoachThanhTraSearchInfo = {
          id: params.keHoachThanhTraSearchInfo.keHoachThanhTraId
        };
      } else {
        params.keHoachThanhTraSearchInfo = null;
      }

      if (params.keHoachThanhTraCuInfo) {
        params.keHoachThanhTraCu = {
          id: params.keHoachThanhTraCuInfo.keHoachThanhTraId
        };
      } else {
        params.keHoachThanhTraCu = null;
      }
      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['coQuanDieuTraInfo'];
      delete params['doiTuongThanhTraInfo'];
      delete params['donViChuTriInfo'];
      delete params['keHoachThanhTraInfo'];
      delete params['donViInfo'];
      delete params['hinhThucThanhTraInfo'];
      delete params['linhVucThanhTraInfo'];
      delete params['loaiHinhThanhTraInfo'];
      delete params['listTaiLieuVanThu'];
      delete params['listTaiLieuVanThuGiaHan'];
      delete params['listTaiLieuVanThuKetLuanThanhTra'];
      delete params['cuocThanhTraId'];
      delete params['listThanhVienDoan'];
      delete params['tienDoThanhTraInfo'];
      delete params['thoiHanThanhTraInfo'];
      delete params['listTaiLieuVanThuThongBaoKetThucTTTT'];
      delete params['listTaiLieuVanThuThongTinCuocThanhTra'];
      delete params['listTaiLieuVanThuThayTheCTT'];
      delete params['listTaiLieuVanThuBoSungCTT'];
      delete params['listDoiTuongThanhTra'];
      delete params['chucNangCuocThanhTraInfo'];
      delete params['listDoiTuongViPham'];
      delete params['thucHienPhapLuatVeThanhTraInfo'];
      delete params['keHoachThanhTraCuInfo'];
      delete params['keHoachThanhTraGocInfo'];
      delete params['nguoiBanHanhThongBaoKetThucTTTTInfo'];
      delete params['keHoachThanhTraSearchInfo'];
      delete params['linhVucThanhTraChiTietInfo'];
      delete params['hinhThucThanhTraChuyenNganhInfo'];
      delete params['thucHienPhapLuatVeThanhTraInfo'];
      delete params['listTaiLieuXuLyCuocThanhTra'];
      delete params['listTaiLieuKetQuaThucHienKetLuanThanhTra'];
      delete params['listTaiLieuChiDaoCuaCapTren'];

      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else {
          validator.validate();
        }
      });
      if (this.state.doiTuongThanhTras.length === 0) {
        (0, _toastr.Toastr)('Phải chọn ít nhất một đối tượng thanh tra', 'error');
        pass = false;
      }
      if (this.state.chucNangCuocThanhTra == 'HANH_CHINH' && (0, _lodash.isEmpty)(this.state.linhVucThanhTraList)) {
        this.setState({ validLinhVucThanhTra: false });
        pass = false;
      }

      return pass;
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      _api.ThanhTra.actions.getDoiTuongViPham.request({ cuocThanhTraId: this.state.cuocThanhTraId }).then(function (res) {
        if (res.data._embedded) {
          var dataDoiTuongViPham = res.data._embedded.doiTuongViPhams;
          var params = { doiTuongViPhams: [] };
          dataDoiTuongViPham.map(function (item) {
            params.doiTuongViPhams[params.doiTuongViPhams.length] = {
              id: item.doiTuongViPhamId
            };
          });
          _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {});
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChangeDiaChi',
    value: function onChangeDiaChi(e) {
      this.state.diaChi = e.target.value;
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this27 = this;

      if (name == 'nhomDoiTuongThanhTraId') {
        this.setState({
          nhomDoiTuongThanhTraId: e.target.value
        });
      }
      if (name == 'quanHuyenId') {
        if (!e.target.value) {
          this.setState({
            quanHuyenId: e.target.value,
            phuongXaId: '',
            dsPhuongXa: []
          });
        } else {
          this.getPhuongXa(e.target.value);
          this.setState({
            quanHuyenId: e.target.value
          });
        }
      }
      if (name == 'phuongXaId') {
        this.setState({
          phuongXaId: e.target.value
        });
      }
      if (name == 'linhVucThanhTraList') {
        this.setState({
          validLinhVucThanhTra: true,
          linhVucThanhTraList: e.map(function (item) {
            return item.value;
          })
        });
      } else if (name == 'thucHienPhapLuatVeThanhTraList') {
        this.setState({
          thucHienPhapLuatVeThanhTraList: e.map(function (item) {
            return item.value;
          })
        });
      } else if (name == 'thoiHanThanhTra') {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          _this27.getThoiHanThanhTra();
        });
      } else if (name == 'doiTuongThanhTras') {
        if (this.props.params.id) {
          if (e.target.value[e.target.value.length - 1] && temp > 1) {
            this.kiemTraTenDoiTuong(e.target.value[e.target.value.length - 1].id);
          }
          temp++;
        } else {
          if (e.target.value[e.target.value.length - 1]) {
            this.kiemTraTenDoiTuong(e.target.value[e.target.value.length - 1].id);
          }
        }

        this.setState(_defineProperty({}, name, e.target.value), function () {
          _this27.getDoiTuongThanhTra();
        });
      } else if (name == 'doiTuongThanhTra') {
        if (this.state.namThanhTra) this.kiemTraTenDoiTuong(parseInt(e.target.value));
        this.setState(_defineProperty({}, name, e.target.value));
      } else if (name === 'soQuyetDinhVeViecThanhTra') {
        var _setState4;

        var listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map(function (item, index) {
          if (index === 0) {
            return _extends({}, item, {
              soQuyetDinh: e.target.value
            });
          }return item;
        });
        this.setState((_setState4 = {}, _defineProperty(_setState4, name, e.target.value), _defineProperty(_setState4, 'listTaiLieuVanThuThongTinCuocThanhTra', listTaiLieuVanThuThongTinCuocThanhTraNew), _defineProperty(_setState4, 'dataFileDinhKem', _extends({}, this.state.dataFileDinhKem, {
          thongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew
        })), _setState4));
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
      this.handleChangeData();
    }
  }, {
    key: 'onChangeTenVanBan',
    value: function onChangeTenVanBan(value, count) {
      var itemSelected = this.state.listDanhMucVanBan.filter(function (item) {
        return item.id == value;
      })[0];
      var result = this.state.danhMucVanBanCanCu.map(function (item, index) {
        if (count === index + 1) {
          return _extends({}, item, {
            vanBanId: itemSelected.id,
            coQuanBanHanh: itemSelected.coQuanBanHanh.tenCoQuanBanHanh,
            theLoaiVanBan: itemSelected.loaiVanBan.tenLoaiVanBan,
            linhVucVanBan: itemSelected.linhVucVanBan.tenLinhVucVanBan,
            tenFile: itemSelected.documentMetaData.name,
            duongDan: (0, _lodash.get)(itemSelected, 'documentMetaData.id')
          });
        } else {
          return item;
        }
      });
      this.setState(_extends({}, this.state, {
        danhMucVanBanCanCu: result
      }));
    }
  }, {
    key: 'setCountDoiTuongViPham',
    value: function setCountDoiTuongViPham(count) {
      this.setState({
        countDoiTuongViPham: Number(count)
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this28 = this;

      if (e && e._d) {
        if (name == 'ngayCongBoQuyetDinhThanhTra') {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this28.getThoiHanThanhTra();
          });
        } else if (name === "ngayRaQuyetDinh") {
          var _setState7;

          var listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map(function (item, index) {
            if (index === 0) {
              return _extends({}, item, {
                ngayQuyetDinh: e._d
              });
            }return item;
          });
          this.setState((_setState7 = {}, _defineProperty(_setState7, name, e._d), _defineProperty(_setState7, 'listTaiLieuVanThuThongTinCuocThanhTra', listTaiLieuVanThuThongTinCuocThanhTraNew), _defineProperty(_setState7, 'dataFileDinhKem', _extends({}, this.state.dataFileDinhKem, {
            thongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew
          })), _setState7));
        } else {
          this.setState(_defineProperty({}, name, e._d));
        }
      } else {
        if (name == 'ngayCongBoQuyetDinhThanhTra') {
          this.setState(_defineProperty({}, name, e), function () {
            _this28.getThoiHanThanhTra();
          });
        } else if (name === "ngayRaQuyetDinh") {
          var _setState10;

          var _listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map(function (item, index) {
            if (index === 0) {
              return _extends({}, item, {
                ngayQuyetDinh: e
              });
            }return item;
          });
          this.setState((_setState10 = {}, _defineProperty(_setState10, name, e), _defineProperty(_setState10, 'listTaiLieuVanThuThongTinCuocThanhTra', _listTaiLieuVanThuThongTinCuocThanhTraNew), _defineProperty(_setState10, 'dataFileDinhKem', _extends({}, this.state.dataFileDinhKem, {
            thongTinCuocThanhTra: _listTaiLieuVanThuThongTinCuocThanhTraNew
          })), _setState10));
        } else {
          this.setState(_defineProperty({}, name, e));
        }
      }
      this.handleChangeData();
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(arr, value, e) {
      var _this29 = this;

      if (typeof e != 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == _this29.state[value];
      });

      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState13;

          if (arr == 'danhSachDonViThanhTra') {
            var Item = {
              giaTri: this.state[value],
              ten: this.state[value]
            };
            this.setState({
              dataDonViViPham: [].concat(_toConsumableArray(this.state.dataDonViViPham), [Item])
            });
          }
          var newItem = {
            ten: this.state[value]
          };
          this.setState((_setState13 = {}, _defineProperty(_setState13, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState13, value, ''), _setState13));
        }
      }
      this.handleChangeData();
      return;
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(arr, index) {
      var _this30 = this;

      var newData = [].concat(_toConsumableArray(this.state[arr]));
      newData.splice(index, 1);
      if (arr === 'doiTuongThanhTras' && newData.length > 1) {
        this.state.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.cuocThanhTraNhieuDoiTuong = false;
      }
      this.setState(_defineProperty({}, arr, newData));
      if (arr == 'danhSachDonViThanhTra') {
        var data = [].concat(_toConsumableArray(this.state.dataDonViViPham));

        var dataCheck = data.filter(function (state) {
          return state.giaTri != _this30.state.danhSachDonViThanhTra[index].ten;
        });

        var dataSelected = [].concat(_toConsumableArray(this.state.danhSachDonViViPham));

        var newDataSelected = dataSelected.filter(function (state) {
          return state.ten != _this30.state.danhSachDonViThanhTra[index].ten;
        });

        this.setState({
          dataDonViViPham: [].concat(_toConsumableArray(dataCheck)),
          danhSachDonViViPham: [].concat(_toConsumableArray(newDataSelected))
        });
      }
      this.handleChangeData();
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      var _this31 = this;

      this.setState(_defineProperty({}, name, e));
      if (e && name == 'giaHan') {
        this.setState({
          showFileGiaHan: false
        }, function () {
          _this31.checkFileGiaHan();
        });
      }
      if (!e) {}
      this.handleChangeData();
    }
  }, {
    key: 'kiemTraTenDoiTuong',
    value: function kiemTraTenDoiTuong(idDoiTuong, check) {
      var _this32 = this;

      var d = new Date();
      var getNam = d.getFullYear() + 1;
      var getTenDoiTuong = '';
      var params = {
        doiTuongThanhTraId: idDoiTuong,
        namThanhTra: getNam,
        thaoTac: this.state.hinhThucThanhTra !== 'THEO_KE_HOACH' ? 'CUOC_THANH_TRA_DOT_XUAT' : undefined
      };
      _api.ThanhTra.actions.getKiemTraDoiTuongTT.request(params).then(function (res) {
        if (res && res.data) {
          var idPushCoQuan = [];
          res.data._embedded.coQuanQuanLies.map(function (items) {
            idPushCoQuan.push(items.ten);
          });
          var tenDoiTuong = _this32.state.ketQuaTimKiemList.find(function (items) {
            return items.doiTuongThanhTraId === idDoiTuong;
          });
          if (_this32.state.checked && check) {
            _this32.setState({
              isOpenDT: true,
              getTenDoiTuong: (0, _lodash.get)(tenDoiTuong, 'ten'),
              idPushCoQuan: idPushCoQuan
            });
          }
          if (check === false) {
            var msgWarning = 'Đối tượng thanh tra ' + getTenDoiTuong + ' đã được chọn làm đối tượng thanh tra tại đơn vị: ' + idPushCoQuan;
            (0, _toastr.Toastr)(msgWarning, 'thongbao');
          }
        }
      });
      return 0;
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id, type) {
      var _this33 = this;

      var dataFileDinhKem = this.getListDataFileDinhKem();
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this33.state.taiLieuVanThuUpdate[_this33.state.taiLieuVanThuUpdate.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.phanLoaiQuyTrinh === 'QUYET_DINH_GIAM_SAT' ? 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA' : item.loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh === "KET_LUAN_THANH_TRA_RUT_GON" ? "KET_LUAN_THANH_TRA_RUT_GON" : item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          } else {
            _this33.state.taiLieuVanThu[_this33.state.taiLieuVanThu.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.phanLoaiQuyTrinh === 'QUYET_DINH_GIAM_SAT' ? 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA' : loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this33.state.taiLieuVanThuDelete[_this33.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };

        _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {
          if (type === 'KET_THUC') {
            _this33.handleKetThucThanhTra();
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      } else {
        if (type === 'KET_THUC') {
          this.handleKetThucThanhTra();
        }
      }

      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', _params).then(function (res) {}).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }

      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', _params2).then(function (res) {}).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.thongTinCuocThanhTra.length > 0) {
        Data.thongTinCuocThanhTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.giaHan.length > 0) {
        Data.giaHan.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.ketThucTTTT.length > 0) {
        Data.ketThucTTTT.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.ketLuanTranhTra.length > 0) {
        Data.ketLuanTranhTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (!(0, _lodash.isEmpty)(Data.rutGon)) {
        dataFileDinhKem = (0, _lodash.concat)(dataFileDinhKem, Data.rutGon);
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'addItem',
    value: function addItem() {
      var newItem = {
        hoVaTen: '',
        donVi: '',
        chucVu: '',
        ngaySinh: '',
        vaiTroThanhVienDoan: ''
      };

      this.setState({
        thanhVienDoans: [].concat(_toConsumableArray(this.state.thanhVienDoans), [newItem])
      });
      this.handleChangeData();
    }
  }, {
    key: 'onItemChange',
    value: function onItemChange(data, index) {

      this.state.thanhVienDoans[index] = data;
      this.setState({
        thanhVienDoans: this.state.thanhVienDoans
      });
      this.handleChangeData();
    }
  }, {
    key: 'onItemRemove',
    value: function onItemRemove(index) {
      var thanhVienDoans = [].concat(_toConsumableArray(this.state.thanhVienDoans));
      thanhVienDoans.splice(index, 1);
      this.setState({
        thanhVienDoans: thanhVienDoans
      });
      this.handleChangeData();
    }
  }, {
    key: 'getThoiHanThanhTra',
    value: function getThoiHanThanhTra() {
      var _this34 = this;

      if (this.state.enableGetThoiHanThanhTra == true) {
        if (this.state.ngayCongBoQuyetDinhThanhTra) {
          this.setState({
            getThoiHanThanhTra: true
          });
          var params = {
            thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
            ngayCongBoQD: (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString()
          };
          _api.ThanhTra.actions.getThoiHanThanhTra.request('', params).then(function (res) {
            if (res.data) {
              _this34.setState({
                ngayHetHanThanhTra: (0, _moment2.default)(new Date(res.data)).format('DD/MM/YYYY'),
                ngayHetHanThanhTraISO: res.data
              }, function () {
                _this34.setState({
                  getThoiHanThanhTra: false
                });
              });
            }
          }).catch(function (error) {
            if (error.response) {
              (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
            }
            _this34.setState({
              getThoiHanThanhTra: false
            });
          });
        } else {
          this.setState({
            ngayHetHanThanhTra: '',
            ngayHetHanThanhTraISO: null
          });
        }
      }
    }
  }, {
    key: 'showDoiTuongThanhTra',
    value: function showDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: true
      });
    }
  }, {
    key: 'hideDoiTuongThanhTra',
    value: function hideDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: false
      });
    }
  }, {
    key: 'setDoiTuongViPhamHienTai',
    value: function setDoiTuongViPhamHienTai(data) {
      this.setState({
        dataDoiTuongViPhamHienTai: data
      });
    }
  }, {
    key: 'handleConfirmDoiTuongViPham',
    value: function handleConfirmDoiTuongViPham(state) {
      var data = [].concat(_toConsumableArray(this.state.dataDoiTuongViPhamHienTai));
      var dataFilter = data.filter(function (item) {
        return state.ten == item.ten;
      });

      if (dataFilter.length > 0) {
        this.setState({
          confirmDoiTuongViPham: true,
          tenDoiTuongViPhamConfirm: state.ten
        });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'closeConfirmDoiTuongViPham',
    value: function closeConfirmDoiTuongViPham() {
      this.setState({
        confirmDoiTuongViPham: false
      });
    }
  }, {
    key: 'accessConfirmDoiTuongViPham',
    value: function accessConfirmDoiTuongViPham() {
      this.doiTuongThanhTras.removeDonViConfirm();
      this.noiDungKienNghi.clearDataContain(this.state.tenDoiTuongViPhamConfirm);
      this.setState({
        confirmDoiTuongViPham: false
      });
    }
  }, {
    key: 'handleConfirmDoiTuongLienQuan',
    value: function handleConfirmDoiTuongLienQuan(state) {
      var data = [].concat(_toConsumableArray(this.state.dataDoiTuongViPhamHienTai));
      var dataFilter = data.filter(function (item) {
        return state.ten == item.ten;
      });

      if (dataFilter.length > 0) {
        this.setState({
          confirmDoiTuongLienQuan: true,
          tenDoiTuongLienQuanConfirm: state.ten
        });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'closeConfirmDoiTuongLienQuan',
    value: function closeConfirmDoiTuongLienQuan() {
      this.setState({
        confirmDoiTuongLienQuan: false
      });
    }
  }, {
    key: 'accessConfirmDoiTuongLienQuan',
    value: function accessConfirmDoiTuongLienQuan() {
      this.doiTuongThanhTraLienQuan.removeDonViConfirm();
      this.noiDungKienNghi.clearDataContain(this.state.tenDoiTuongLienQuanConfirm);
      this.setState({
        confirmDoiTuongLienQuan: false
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      if (this.validateSubmitForm()) {
        this.setState({
          openDialog: true,
          openDialogLuuHoSo: true
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false,
        openDialogLuuHoSo: false,
        isOpen: false,
        isOpenXL: false
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack, type) {
      if (allowBack) {
        if (type == 'close') {
          this.checkNoiDungKienNghi();
          _reactRouter.browserHistory.goBack();
        } else {
          _reactRouter.browserHistory.goBack();
        }
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onChangeInput',
    value: function onChangeInput(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'timKiem',
    value: function timKiem(statusTimKiem) {
      var _this35 = this;

      this.state.checkAll = false;
      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      var pageData = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      var params = {
        pageData: pageData,
        namThanhTra: getNamTT
      };

      if (statusTimKiem) {
        params.pageData.page = 0;
      }

      if (!(0, _lodash.isEmpty)(this.state.doiTuongThanhTras)) {
        var idsDoiTuong = this.state.doiTuongThanhTras.map(function (item) {
          return item.id;
        });
        this.state.doiTuongSelectedList.forEach(function (item) {
          idsDoiTuong.push(item.doiTuongThanhTraId);
        });
        params.idDoiTuongDaCoCuocs = idsDoiTuong;
      } else {
        var _idsDoiTuong = [];
        this.state.doiTuongSelectedList.forEach(function (item) {
          _idsDoiTuong.push(item.doiTuongThanhTraId);
        });
        params.idDoiTuongDaCoCuocs = _idsDoiTuong;
      }

      if (this.state.tuKhoa) {
        params.tenDoiTuong = this.state.tuKhoa;
      }
      if (this.state.linhVucId) {
        params.linhVucId = this.state.linhVucId;
      }
      if (this.state.nhomDoiTuongThanhTraId) {
        params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
      }
      if (this.state.quanHuyenId) {
        params.quanHuyenId = this.state.quanHuyenId;
      }
      if (this.state.phuongXaId) {
        params.phuongXaId = this.state.phuongXaId;
      }
      if (this.state.diaChi) {
        params.tuKhoa = this.state.diaChi;
      }
      if (!(0, _lodash.isEmpty)(this.state.maSoThue)) {
        params.maSoThue = this.state.maSoThue;
      }
      params.approved = true;
      this.setState({ tableLoading: true });
      _api.Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(function (res) {
        if (res.data._embedded) {
          var data = (0, _lodash.get)(res, 'data._embedded.doiTuongThanhTras');
          if (!(0, _lodash.isEmpty)(_this35.state.totalSelectedList) && (0, _lodash.isArray)(_this35.state.totalSelectedList)) {
            var newData = data.map(function (item) {
              _this35.state.totalSelectedList.forEach(function (itemDoiTuong) {
                if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                  item.selected = true;
                }
              });
              return item;
            });
            data = newData;
          }
          _this35.setState({
            ketQuaTimKiemList: data,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this35.setState({
            ketQuaTimKiemList: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var _this36 = this;

      var check = false;
      this.state.checkAll = !this.state.checkAll;
      this.state.ketQuaTimKiemList.forEach(function (item) {
        item.selected = _this36.state.checkAll;
        if (_this36.state.checkAll) {
          _this36.state.totalSelectedList.push(item);
          _this36.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
        } else {
          _this36.state.totalSelectedList = [];
          (0, _toastr.Toastr)(null, 'resetclear');
        }
      });
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.timKiem();
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.timKiem();
    }
  }, {
    key: 'hanldeRemove',
    value: function hanldeRemove(index) {
      this.state.doiTuongSelectedList.splice(index, 1);
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var check, newtotalSelectedList, _newtotalSelectedList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                check = true;

                item.selected = !item.selected;

                if (!item.selected) {
                  _context.next = 11;
                  break;
                }

                newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));

                if (item.daTrung === true) {
                  this.setState({
                    doiTuongThanhTraId: item.doiTuongThanhTraId
                  });
                }
                newtotalSelectedList.push(item);
                _context.next = 8;
                return this.setState({
                  checked: item.selected,
                  totalSelectedList: newtotalSelectedList
                });

              case 8:
                this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
                _context.next = 14;
                break;

              case 11:
                _newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));

                _newtotalSelectedList.map(function (value, index) {
                  if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
                    _newtotalSelectedList.splice(index, 1);
                  }
                });
                // Toastr(null,'newtotalSelectedList');
                this.setState({
                  totalSelectedList: _newtotalSelectedList
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()
  }, {
    key: 'themVaoCuocTT',
    value: function themVaoCuocTT() {
      this.state.doiTuongSelectedList = [].concat(_toConsumableArray(this.state.doiTuongSelectedList), _toConsumableArray(this.state.totalSelectedList));
      this.state.totalSelectedList = [];
      this.setState(_extends({}, this.state));
      this.timKiem();
    }
  }, {
    key: 'openDialogThanhTra',
    value: function openDialogThanhTra() {
      this.timKiem();
      this.state.totalSelectedList = [];
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'handleSaveThanhTra',
    value: function handleSaveThanhTra() {
      var newItem = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
      this.state.doiTuongSelectedList.forEach(function (items) {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });
      if (newItem.length > 1) {
        this.state.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.cuocThanhTraNhieuDoiTuong = false;
      }
      // dataDoiTuongThanhTras
      this.setState({
        doiTuongThanhTras: newItem,
        isOpen: false,
        nhomDoiTuongThanhTraId: ''
      });
      this.state.doiTuongSelectedList = [];
    }
  }, {
    key: 'getLinhVuc',
    value: function getLinhVuc() {
      var _this37 = this;

      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this37.state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
        } else {
          _this37.state.linhVucList = [];
        }
        _this37.setState(_extends({}, _this37.state));
      });
    }
  }, {
    key: 'checkDate',
    value: function checkDate(stD, endD) {
      var startDate = (0, _moment2.default)(stD, 'MM/DD/YYYY').valueOf();
      var endDate = (0, _moment2.default)(endD, 'MM/DD/YYYY').valueOf();
      if (startDate > endDate) {
        (0, _toastr.Toastr)('Ngày ra quyết định phải nhỏ hơn hoặc bằng Ngày công bố quyết định', 'warning');
      }
    }
  }, {
    key: 'changeCheckbox',
    value: function changeCheckbox(e) {
      var state = this.state;
      state[e.target.name] = e.target.checked;
      this.setState(state);
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({ isOpenXL: !this.state.isOpenXL, showDetail: false });
    }
  }, {
    key: 'handleViewDetail',
    value: function handleViewDetail(item) {
      this.setState({ itemSelected: item, showDetail: true });
    }
  }, {
    key: 'getQuyTrinhXuLyHistory',
    value: function getQuyTrinhXuLyHistory() {
      var _this38 = this;

      _api.Letter.actions.getLichSuDon.request({ id: this.props.donId }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this38.setState({ DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuThayDois });
        } else {
          _this38.setState({ DataLichSuQuaTrinhXuLy: [] });
        }
      });
    }
  }, {
    key: 'closeDialogDT',
    value: function closeDialogDT(name) {
      var _this39 = this;

      var state = this.state;
      var newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));
      var data = [].concat(_toConsumableArray(this.state.dataSelectDoiTuongCurrent));
      var newketQuaTimKiemList = [].concat(_toConsumableArray(this.state.ketQuaTimKiemList));
      if (this.state.doiTuongThanhTraId) {
        newtotalSelectedList.map(function (value, index) {
          if (value.doiTuongThanhTraId == _this39.state.doiTuongThanhTraId) {
            newtotalSelectedList.splice(index, 1);
            data.splice(index, 1);
          }
        });
      }
      newketQuaTimKiemList.map(function (item) {
        if (item.doiTuongThanhTraId === _this39.state.doiTuongThanhTraId) {
          item.selected = false;
        }
      });
      data.map(function (item) {
        if (item.doiTuongThanhTraId === _this39.state.doiTuongThanhTraId) {
          item.selected = false;
        }
      });
      state.isOpenDT = false;
      this.setState({
        totalSelectedList: newtotalSelectedList,
        ketQuaTimKiemList: newketQuaTimKiemList,
        dataSelectDoiTuongCurrent: data,
        isOpenDT: false
      });
    }
  }, {
    key: 'openDialogDT',
    value: function openDialogDT() {
      this.setState({
        isOpenDT: true
      });
    }
  }, {
    key: 'onCloseDT',
    value: function onCloseDT() {
      this.setState({
        isOpenDT: false
      });
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra;
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this40 = this;

      var checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
      var checkLayout = this.props.check && this.props.check.state && this.props.check.state.fromNotifications;
      var checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
      var Data = this.state;
      var DataDetail = this.state.dataDetail;
      var chiTietMotDoiTuong = {};
      if (DataDetail && DataDetail.doiTuongThanhTraInfo) {
        chiTietMotDoiTuong = DataDetail && DataDetail.doiTuongThanhTraInfo;
      } else if (DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
        chiTietMotDoiTuong = DataDetail.listDoiTuongThanhTra[0];
      }
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      var showTienDoThanhTra = '';
      var title = 'C\u1EADp nh\u1EADt th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra');
      if (checkLayout) {
        title = 'Thay th\u1EBF cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra');
      } else if (checkLayoutBoSung) {
        title = 'B\u1ED5 sung cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra');
      }

      if (userInfo.capCoQuanQuanLyId === TTTrungUong && (0, _lodash.get)(Data, 'tienDoThanhTraType') === "KET_THUC_THANH_TRA_TRUC_TIEP") {
        showTienDoThanhTra = 'Đang tiến hành';
      } else {
        showTienDoThanhTra = (0, _lodash.get)(Data, 'tienDoThanhTra');
      }
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'reception-container' },
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.isOpenDT,
              onClose: this.closeDialogDT.bind(this, 'isOpenDT'),
              title: 'Th\xF4ng b\xE1o',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body mb0 hlDialog' },
              _react2.default.createElement(
                'div',
                { className: 'pt10 txt-center' },
                '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                _react2.default.createElement(
                  'h2',
                  null,
                  ' "' + this.state.getTenDoiTuong + '" '
                ),
                '\u0111\xE3 \u0111\u01B0\u1EE3c ch\u1ECDn l\xE0m \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' c\u1EE7a',
                ' ',
                ' ',
                this.state.idPushCoQuan.join(', ')
              ),
              _react2.default.createElement(
                'div',
                { className: 'pb20 txt-center' },
                'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD th\xEAm',
                _react2.default.createElement(
                  'h2',
                  null,
                  ' "' + this.state.getTenDoiTuong + '" '
                ),
                'v\xE0o ',
                this.state.type === "DOT_XUAT" ? 'cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' \u0111\u1ED9t xu\u1EA5t' : 'k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                ' kh\xF4ng?'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogDT.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-green action-todo', onClick: this.onCloseDT.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.isOpen,
              onClose: this.closeDialog.bind(this, 'isOpen'),
              title: 'C\u1EADp nh\u1EADt th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
              className: 'dialog-them-moi-dttt dialog-default wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 pt20 pb15' },
                  '1. T\xECm ki\u1EBFm \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ED1i t\u01B0\u1EE3ng', value: this.state.tuKhoa, onChange: this.onChangeInput.bind(this, 'tuKhoa'), name: 'tuKhoa', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...' }),
              _react2.default.createElement(_common.Input, { className: 'col-28', label: 'M\xE3 s\u1ED1 thu\u1EBF', value: this.state.maSoThue, onChange: this.onChangeInput.bind(this, 'maSoThue'), name: 'maSoThue', placeholder: 'Nh\u1EADp m\xE3 s\u1ED1 thu\u1EBF...' }),
              _react2.default.createElement(_common.DropDown, { className: 'col-28', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng', selectedValue: this.state.nhomDoiTuongThanhTraId, onChange: this.onChange.bind(this, 'nhomDoiTuongThanhTraId'), name: 'nhomDoiTuongThanhTraId', placeholder: true,
                options: this.state.nhomDTList, keyName: 'nhomDoiTuongThanhTraId', valueName: 'ten' }),
              _react2.default.createElement(_common.DropDown, {
                className: 'col-28',
                label: 'Huy\u1EC7n/TP',
                selectedValue: this.state.quanHuyenId,
                onChange: this.onChange.bind(this, 'quanHuyenId'),
                name: 'quanHuyenId',
                placeholder: true,
                options: this.state.dsQuanHuyen, keyName: 'donViHanhChinhId', valueName: 'ten'
              }),
              _react2.default.createElement(_common.DropDown, {
                className: 'col-28',
                label: 'Ph\u01B0\u1EDDng/X\xE3',
                selectedValue: this.state.phuongXaId,
                onChange: this.onChange.bind(this, 'phuongXaId'),
                name: 'phuongXaId',
                placeholder: true,
                options: this.state.dsPhuongXa, keyName: 'donViHanhChinhId', valueName: 'ten'
              }),
              _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ECBa ch\u1EC9', value: this.state.diaChi, onChange: this.onChangeDiaChi.bind(this), name: 'diaChi', placeholder: 'Nh\u1EADp' }),
              _react2.default.createElement(
                'div',
                { className: 'col-15 mt22' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-green ml10', onClick: this.timKiem.bind(this, true) },
                  _react2.default.createElement('i', { className: 'tt-search' }),
                  'T\xECm ki\u1EBFm'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 ' },
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 pt15 pb15 pr20 pl20' },
                  '1.1 K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pl5 pr5' },
                _react2.default.createElement(
                  _datatable.DataTableMultipleSelect,
                  { onDisableCheck: true, onCheck: this.handleSelectedAll.bind(this), selectAllStatus: this.state.checkAll, header: _table.header.thanhTra.KQTKTMDTTT2, dataList: this.state.ketQuaTimKiemList, tableLoading: this.state.tableLoading, pageData: this.state.pageData, parent: this },
                  _react2.default.createElement(_datatable.RowItemKetQuaTimKiemThanhTra, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb20 pt10 txt-center' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-green', onClick: this.themVaoCuocTT.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                  'Th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 ' },
              _react2.default.createElement(
                'div',
                { className: 'row pl40 pr40' },
                _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 pt15 pb15 pr20 pl20' },
                  '1.2 Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng s\u1EBD \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pl5 pr5' },
                _react2.default.createElement(
                  _dataTable2.default,
                  { header: _table.header.thanhTra.TMDTTT2, dataList: this.state.doiTuongSelectedList, hideButtonExport: true, hidePagination: true, parent: this, emptyMsg: 'Ch\u01B0a c\xF3 \u0111\u1ED1i t\u01B0\u1EE3ng \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') },
                  _react2.default.createElement(_datatable.RowItemDanhSachThemMoiThanhTra, null)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'action-form-wrap pt20' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpen') },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-save', onClick: this.handleSaveThanhTra.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleBack.bind(this, false, 'close'), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-add' },
            title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.type == 'KE_HOACH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + (DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : '') }),
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + (this.checkIsKiemTra() ? 'KHKT' : 'KHTT') + ':', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? (0, _moment2.default)(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(
                  _core.Dialog,
                  {
                    isOpen: this.state.isOpenXL,
                    onClose: this.toggleDialog.bind(this),
                    title: 'L\u1ECBch s\u1EED x\u1EED l\xFD',
                    className: 'dialog-history wrap-block panel-popup'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'body-dialog-gh' },
                    this.state.showDetail && _react2.default.createElement(
                      'div',
                      { className: 'back-foward pl25 mb0' },
                      _react2.default.createElement(
                        _reactRouter.Link,
                        { onClick: this.handleBack.bind(this) },
                        'V\u1EC1 trang tr\u01B0\u1EDBc'
                      )
                    ),
                    !this.state.showDetail ? _react2.default.createElement(
                      'div',
                      { className: 'row pl20 pr20' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.dialogHistoryXL,
                          dataList: this.state.DataLichSuQuaTrinhXuLy,
                          hidePagination: true,
                          ma: this.props.ma
                        },
                        _react2.default.createElement(_rowItem.ListHistoryRowItem, { handleViewDetail: this.handleViewDetail.bind(this) })
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'row pl20 pr20' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.dialogHistoryDetail,
                          dataList: this.state.itemSelected.listThongTinThayDoi,
                          hidePagination: true
                        },
                        _react2.default.createElement(_rowItem.ListHistoryDetailRowItem, null)
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'box-bottom col-100 mt5' },
                      _react2.default.createElement(
                        _reactRouter.Link,
                        { className: 'btn-action btn-close action-todo', onClick: this.toggleDialog.bind(this) },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u0110\xF3ng'
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              _react2.default.createElement('div', { className: 'big-border' })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: checkLayout == true, titleClass: 'title-12 lable-title-custom', className: 'pl35 pr35 mb10 row', name: 'thayThe', label: 'Th\xF4ng tin thay th\u1EBF cu\u1ED9c thanh tra' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  '2. Th\xF4ng tin thay th\u1EBF cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 c\xF4ng v\u0103n', placeholder: 'Nh\u1EADp...', value: this.state.soCongVanThayTheCTT, onChange: this.onChange.bind(this, 'soCongVanThayTheCTT'), name: 'soCongVanThayTheCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', value: this.state.ngayQuyetDinhThayTheCTT, onChange: this.handleChangeDate.bind(this, 'ngayQuyetDinhThayTheCTT'), name: 'ngayQuyetDinhThayTheCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                _react2.default.createElement(_common.TextArea, { className: 'col-100 mb5', label: 'L\xFD do:', value: this.state.lyDoThayTheCTT, onChange: this.onChange.bind(this, 'lyDoThayTheCTT'), name: 'lyDoThayTheCTT', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 1000 })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl35 pr35' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', name: 'fileDinhKemDon', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuThayTheCTT, disableTopLine: true, phanLoaiQuyTrinh: 'THAY_THE_CUOC_THANH_TRA', onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChangeDK.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10' },
              _react2.default.createElement('div', { className: 'big-border' })
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type == 'DOT_XUAT' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: checkLayoutBoSung === true },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-14 p20' },
                    '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch th\xEAm m\u1EDBi'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl25 pr25' },
                  _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + (this.checkIsKiemTra() ? 'KHKT' : 'KHTT'), className: 'col-20', value: checkInfoTTKHTT && checkInfoTTKHTT.quyetDinhPheDuyetKTTT ? checkInfoTTKHTT.quyetDinhPheDuyetKTTT : '' }),
                  _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t', className: 'col-20', value: checkInfoTTKHTT && checkInfoTTKHTT.ngayRaQuyetDinh ? (0, _moment2.default)(checkInfoTTKHTT.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + (checkInfoTTKHTT && checkInfoTTKHTT.namThanhTra ? checkInfoTTKHTT.namThanhTra : '') })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mt10' },
                  _react2.default.createElement('div', { className: 'big-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-14 p20' },
                      '2. Th\xF4ng tin b\u1ED5 sung cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl30 pr30' },
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 c\xF4ng v\u0103n', placeholder: 'Nh\u1EADp...', value: this.state.soCongVanBoSungCTT, onChange: this.onChange.bind(this, 'soCongVanBoSungCTT'), name: 'soCongVanBoSungCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', value: this.state.ngayQuyetDinhBoSungCTT, onChange: this.handleChangeDate.bind(this, 'ngayQuyetDinhBoSungCTT'), name: 'ngayQuyetDinhBoSungCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100 mb5', label: 'L\xFD do:', value: this.state.lyDoBoSungCTT, onChange: this.onChange.bind(this, 'lyDoBoSungCTT'), name: 'lyDoBoSungCTT', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.showFileGiaHan },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl35 pr35' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', name: 'fileDinhKemDon', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuBoSungCTT, disableTopLine: true, phanLoaiQuyTrinh: 'BO_SUNG_CUOC_THANH_TRA', onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChangeDK.bind(this) })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'mt10' },
                _react2.default.createElement('div', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  checkLayoutBoSung === true ? '3. Th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : '1. Th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'form',
                    { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'doiTuongThanhTras') },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-25 mrt22' },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'col-100 no-gutter btn-green btn-pullleft', onClick: this.openDialogThanhTra.bind(this) },
                          _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                          '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                          this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.doiTuongThanhTras.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this40.removeDonVi.bind(_this40, 'doiTuongThanhTras', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(_common.TextArea, { triggerOnblur: true, label: 'T\xEAn cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', value: this.state.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 500 }),
                _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi k\u1EF3 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.kyThanhTra, onChange: this.onChange.bind(this, 'kyThanhTra'), name: 'kyThanhTra', require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(_common.Text, { label: 'Ti\u1EBFn \u0111\u1ED9 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-25', value: Data.tienDoThanhTra, red: true }),
                _react2.default.createElement(
                  _core.Checkbox,
                  { className: 'col-25 pt-large pt-dvph', name: 'kyTruocChuyenSang', checked: this.state.kyTruocChuyenSang || false, onChange: this.changeCheckbox.bind(this) },
                  _react2.default.createElement(
                    'span',
                    { className: 'span-checkbox span-position-label' },
                    'K\u1EF3 tr\u01B0\u1EDBc chuy\u1EC3n sang'
                  )
                ),
                _react2.default.createElement(_common.TextArea, { triggerOnblur: true, label: 'N\u1ED9i dung ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', value: this.state.noiDungThanhTra, onChange: this.onChange.bind(this, 'noiDungThanhTra'), name: 'noiDungThanhTra', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 500 })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-25', value: this.state.soQuyetDinhVeViecThanhTra, onChange: this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra'), name: 'soQuyetDinhVeViecThanhTra', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', className: 'col-25', value: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh'), name: 'ngayRaQuyetDinh', require: true, bindValidator: this, channel: 'formTaoDon', endDate: new Date() }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.hinhThucThanhTra == 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextArea, { label: 'C\u0103n c\u1EE9 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' \u0111\u1ED9t xu\u1EA5t', className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.canCuThanhTraDotXuat, onChange: this.onChange.bind(this, 'canCuThanhTraDotXuat'), name: 'canCuThanhTraDotXuat', maxLength: 500 })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-25', startDate: this.state.ngayRaQuyetDinh, value: this.state.ngayCongBoQuyetDinhThanhTra, onChange: this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra'), name: 'ngayCongBoQuyetDinhThanhTra', require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-thoihan col-25' },
                  _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' (ng\xE0y)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra'), name: 'thoiHanThanhTra' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'thoihan-value' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: !this.state.getThoiHanThanhTra },
                      _react2.default.createElement(
                        'span',
                        null,
                        this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.getThoiHanThanhTra },
                      _react2.default.createElement('span', { className: 'icon-loader' })
                    )
                  )
                ),
                _react2.default.createElement(_ttForms.DropDownChonLoaiHinhThanhTra, { label: 'Lo\u1EA1i h\xECnh', data: this.state.dataLoaiHinhThanhTra, className: 'col-25', selectedValue: this.state.loaiHinhThanhTra, onChange: this.onChange.bind(this, 'loaiHinhThanhTra'), name: 'loaiHinhThanhTra' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.loaiHinhThanhTra == 'THANH_TRA_LAI' },
                  _react2.default.createElement(_ttForms.DropDownChonCanCuThanhTraLai, { label: 'C\u0103n c\u1EE9 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' l\u1EA1i', data: this.state.dataThanhTraLai, className: 'col-25', selectedValue: this.state.canCuThanhTraLai, onChange: this.onChange.bind(this, 'canCuThanhTraLai'), name: 'canCuThanhTraLai' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Ho\u1EA1t \u0111\u1ED9ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), keyName: 'giaTri', confirm: true, placeholder: null, valueName: 'ten', className: 'col-25', data: this.state.dataChucNangCuocThanhTra, selectedValue: this.state.chucNangCuocThanhTra, onChange: this.onChange.bind(this, 'chucNangCuocThanhTra'), name: 'chucNangCuocThanhTra' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' },
                  _react2.default.createElement(_ttForms.DropDownChonLinhVucThanhTraMultiple, {
                    label: 'L\u0129nh v\u1EF1c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                    confirm: true,
                    placeholder: null,
                    className: 'col-25',
                    data: this.state.dataLinhVucThanhTra.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    selectedValue: this.state.linhVucThanhTraList,
                    onChange: this.onChange.bind(this, 'linhVucThanhTraList'),
                    name: 'linhVucThanhTraList',
                    require: true,
                    validLinhVucThanhTra: this.state.validLinhVucThanhTra
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' && this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') },
                  _react2.default.createElement(_common2.DropDownMultipleSelect, {
                    label: ' ',
                    className: 'col-25 mt16',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    value: this.state.thucHienPhapLuatVeThanhTraList,
                    options: this.state.thucHienPhapLuatVeThanhTraListCombobox.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    onChange: this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList'),
                    placeholder: '',
                    closeMenuOnSelect: false
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' },
                  _react2.default.createElement(_common.Input, {
                    className: 'col-25',
                    label: 'Chi ti\u1EBFt l\u0129nh v\u1EF1c',
                    placeholder: 'Nh\u1EADp...',
                    value: this.state.chiTietLinhVuc,
                    onChange: this.onChange.bind(this, 'chiTietLinhVuc'),
                    name: 'chiTietLinhVuc',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    maxLength: 255
                  })
                ),
                this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' && _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'H\xECnh th\u1EE9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' chuy\xEAn ng\xE0nh', placeholder: true, options: this.state.hinhThucThanhTraChuyenNganhList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.hinhThucThanhTraChuyenNganh, onChange: this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh'), name: 'hinhThucThanhTraChuyenNganh', bindValidator: this, channel: 'formTaoDon', require: true })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type == 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 p20' },
                  checkLayout === true ? '3. Th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : '2. Th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                this.state.namThanhTra && _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'form',
                    { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'doiTuongThanhTras') },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-20 mrt22' },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'col-100 no-gutter btn-green btn-pullleft', onClick: this.openDialogThanhTra.bind(this) },
                          _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                          '\u0110\u1ED1i t\u01B0\u1EE3ng ',
                          this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.doiTuongThanhTras.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this40.removeDonVi.bind(_this40, 'doiTuongThanhTras', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mb15' },
                  _react2.default.createElement(
                    'label',
                    { className: 'pt-label' },
                    _react2.default.createElement(
                      'span',
                      { className: 'val-title-bold' },
                      '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'val-content txt-blue txt-underline cursor-pointer txt-inline-block', onClick: this.showDoiTuongThanhTra.bind(this) },
                      DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0 && !DataDetail.tenNhieuDoiTuongThanhTra ? DataDetail.listDoiTuongThanhTra[0].ten : DataDetail.tenNhieuDoiTuongThanhTra
                    )
                  )
                ),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-25 mb15', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ti\u1EBFn \u0111\u1ED9 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-25 mb15', value: showTienDoThanhTra, red: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'col-25 mb15' },
                  _react2.default.createElement(
                    _core.Checkbox,
                    { className: 'pt-large pt-dvph', name: 'kyTruocChuyenSang', checked: this.state.kyTruocChuyenSang || false, onChange: this.changeCheckbox.bind(this) },
                    _react2.default.createElement(
                      'span',
                      { className: 'span-checkbox span-position-label' },
                      'K\u1EF3 tr\u01B0\u1EDBc chuy\u1EC3n sang'
                    )
                  )
                ),
                _react2.default.createElement(_common.TextArea, { triggerOnblur: true, label: 'T\xEAn cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', value: this.state.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 500 }),
                _react2.default.createElement(_common.TextArea, { label: 'N\u1ED9i dung ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-100 mb15', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '', onChange: this.onChange.bind(this, 'noiDungThanhTra'), name: 'noiDungThanhTra', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 500 })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block mb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type == 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-25', value: this.state.soQuyetDinhVeViecThanhTra, onChange: this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra'), name: 'soQuyetDinhVeViecThanhTra', require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', className: 'col-25', value: this.state.ngayRaQuyetDinh, endDate: new Date(), onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh'), name: 'ngayRaQuyetDinh', require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-25', value: this.state.ngayCongBoQuyetDinhThanhTra, startDate: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra'), name: 'ngayCongBoQuyetDinhThanhTra', require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-thoihan col-25' },
                  _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' (ng\xE0y)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra'), name: 'thoiHanThanhTra' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'thoihan-value' },
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: !this.state.getThoiHanThanhTra },
                      _react2.default.createElement(
                        'span',
                        null,
                        this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''
                      )
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.getThoiHanThanhTra },
                      _react2.default.createElement('span', { className: 'icon-loader' })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.type == 'KE_HOACH' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Ho\u1EA1t \u0111\u1ED9ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), keyName: 'giaTri', confirm: true, placeholder: null, valueName: 'ten', className: 'col-25', data: this.state.dataChucNangCuocThanhTra, selectedValue: this.state.chucNangCuocThanhTra, onChange: this.onChange.bind(this, 'chucNangCuocThanhTra'), name: 'chucNangCuocThanhTra' }),
                this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'H\xECnh th\u1EE9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' chuy\xEAn ng\xE0nh', placeholder: true, options: this.state.hinhThucThanhTraChuyenNganhList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.hinhThucThanhTraChuyenNganh, onChange: this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh'), name: 'hinhThucThanhTraChuyenNganh', bindValidator: this, channel: 'formTaoDon', require: true }) : _react2.default.createElement(_ttForms.DropDownChonLinhVucThanhTraMultiple, {
                  label: 'L\u0129nh v\u1EF1c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                  confirm: true,
                  placeholder: null,
                  className: 'col-25',
                  data: this.state.dataLinhVucThanhTra.map(function (item) {
                    return {
                      label: item.ten,
                      value: item.giaTri
                    };
                  }),
                  selectedValue: this.state.linhVucThanhTraList,
                  onChange: this.onChange.bind(this, 'linhVucThanhTraList'),
                  name: 'linhVucThanhTraList',
                  require: true,
                  validLinhVucThanhTra: this.state.validLinhVucThanhTra
                }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' && this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') },
                  _react2.default.createElement(_common2.DropDownMultipleSelect, {
                    className: 'col-25 mt16',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    value: this.state.thucHienPhapLuatVeThanhTraList,
                    options: this.state.thucHienPhapLuatVeThanhTraListCombobox.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    onChange: this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList'),
                    placeholder: '',
                    closeMenuOnSelect: false
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' },
                  _react2.default.createElement(_common.Input, {
                    className: 'col-25',
                    label: 'Chi ti\u1EBFt l\u0129nh v\u1EF1c',
                    placeholder: 'Nh\u1EADp...',
                    value: this.state.chiTietLinhVuc,
                    onChange: this.onChange.bind(this, 'chiTietLinhVuc'),
                    name: 'chiTietLinhVuc',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    maxLength: 255
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.hinhThucThanhTra == 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextArea, { label: 'C\u0103n c\u1EE9 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' \u0111\u1ED9t xu\u1EA5t', className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.canCuThanhTraDotXuat, onChange: this.onChange.bind(this, 'canCuThanhTraDotXuat'), name: 'canCuThanhTraDotXuat', maxLength: 500 })
                )
              ),
              _react2.default.createElement(_common.InputList, {
                onRef: function onRef(doiTuongThanhTraLienQuan) {
                  return _this40.doiTuongThanhTraLienQuan = doiTuongThanhTraLienQuan;
                },
                confirm: true,
                handleConfirm: this.handleConfirmDoiTuongLienQuan.bind(this),
                label: 'C\u01A1 quan \u0111\u01A1n v\u1ECB c\xF3 li\xEAn quan',
                data: this.state.dataDoiTuongThanhTraLienQuan,
                onChange: this.onChange.bind(this, 'doiTuongThanhTraLienQuan'),
                name: 'doiTuongThanhTraLienQuan',
                countUnit: '\u0111\u1ED1i t\u01B0\u1EE3ng',
                hasCount: true
              }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: Data.showFile },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'tienHanh', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', phanLoaiQuyTrinh: 'THONG_TIN_CUOC_THANH_TRA', bindValidator: this, data: this.state.listTaiLieuVanThuThongTinCuocThanhTra, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 heading-addnew-dttt' },
              _react2.default.createElement(
                'h2',
                { className: 'title-13 col-100 pl20 pr20 mt10' },
                '1.1 C\u0103n c\u1EE9 cu\u1ED9c ',
                this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 ' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.dsCanCuCuocThanhTra,
                  dataList: this.state.danhMucVanBanCanCu,
                  hidePagination: true,
                  parent: this,
                  addNewVanBanCanCu: this.addNewVanBanCanCu.bind(this),
                  isTableCanCuCuocThanhTra: true
                },
                _react2.default.createElement(_datatable.RowItemCanCuCuocThanhTra, { listDanhMucVanBan: this.state.listDanhMucVanBan, onChange: this.onChangeTenVanBan.bind(this), removeVanBanCanCu: this.removeVanBanCanCu.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'pl20 pb20 pr20' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pl20 pr20 mb10' },
                  _react2.default.createElement(
                    _utils.ShowIfCheck,
                    { titleClass: 'title-12 lable-title-custom', className: 'row pl15 pr15', label: this.state.type == 'KE_HOACH' ? "2.1 Thành viên đoàn" : '1.1 Thành viên đoàn', onChange: this.handleCheck.bind(this, 'thanhVienDoan'), name: 'thanhVienDoan', checked: this.state.thanhVienDoan },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'div',
                        { className: 'row pl10 pr10 mb10' },
                        _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', className: 'col-25 mb0-18', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soQuyetDinhThanhLapDoan, onChange: this.onChange.bind(this, 'soQuyetDinhThanhLapDoan'), name: 'soQuyetDinhThanhLapDoan', maxLength: 255 }),
                        _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', className: 'col-25 mb0-18', value: this.state.ngayRaQuyetDinhThanhLapDoan, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinhThanhLapDoan'), name: 'ngayRaQuyetDinhThanhLapDoan', require: true, bindValidator: this, channel: 'formTaoDon' })
                      ),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: Data.showFile },
                        _react2.default.createElement(
                          'div',
                          { className: 'wrap-table-show-oncheck white-table' },
                          _react2.default.createElement(
                            _datatable.DataTableAttachElement,
                            { addItem: this.addItem.bind(this), header: _table.header.thanhTra.TMTVCTT, dataList: this.state.thanhVienDoans, hideButtonExport: true, hidePagination: true, pageData: this.state.pageData, parent: this, search: this.state.search,
                              tableLoading: this.state.tableLoading },
                            _react2.default.createElement(_datatable.RowItemChiTietThanhVienCuocThanhTra, { dataVaiTroThanhVienDoan: this.state.dataVaiTroThanhVienDoan, onItemRemove: this.onItemRemove.bind(this), onItemChange: this.onItemChange.bind(this) })
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pb20 pr20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: checkLayout !== true && checkLayoutBoSung !== true },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { titleClass: 'title-12 lable-title-custom', className: 'pl35 pr35 mb10 row pt20', onChange: this.handleCheck.bind(this, 'coQuyetDinhGiamSat'), name: 'coQuyetDinhGiamSat', checked: this.state.coQuyetDinhGiamSat, label: this.state.type == 'KE_HOACH' ? this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.4. Quy\u1EBFt \u0111\u1ECBnh gi\xE1m s\xE1t' : '2.3. Quy\u1EBFt \u0111\u1ECBnh gi\xE1m s\xE1t' : this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.4. Quy\u1EBFt \u0111\u1ECBnh gi\xE1m s\xE1t' : '1.2. Quy\u1EBFt \u0111\u1ECBnh gi\xE1m s\xE1t' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showFile },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { hidenTopTitle: true, name: 'quyetDinhGiamSat', loaiVanBanSuggest: 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA', soVanBanSuggest: this.state.soVanBanQuyetDinhGiamSat, ngayQuyetDinhSuggest: this.state.ngayBanHanhQuyetDinhGiamSat, phanLoaiQuyTrinh: 'QUYET_DINH_GIAM_SAT', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuQuyetDinhGiamSat, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { titleClass: 'title-12 lable-title-custom', className: 'pl35 pr35 mb10 row', onChange: this.handleCheck.bind(this, 'giaHan'), name: 'giaHan', checked: this.state.giaHan, label: this.state.type == 'KE_HOACH' ? this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.2 Gia hạn' : '2.1 Gia hạn' : this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.3 Gia hạn' : '1.3 Gia hạn' },
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block ' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinhGiaHan, onChange: this.onChange.bind(this, 'soQuyetDinhGiaHan'), name: 'soQuyetDinhGiaHan', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', value: this.state.ngayRaQuyetDinhGiaHan, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinhGiaHan'), name: 'ngayRaQuyetDinhGiaHan', bindValidator: this, channel: 'formTaoDon', require: true, endDate: new Date() }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDonGiaHan, onChange: this.onChange.bind(this, 'lyDonGiaHan'), name: 'lyDonGiaHan', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.showFileGiaHan },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'giaHan', loaiVanBanSuggest: 'TT_GIA_HAN', soVanBanSuggest: this.state.soQuyetDinhGiaHan, ngayQuyetDinhSuggest: this.state.ngayRaQuyetDinhGiaHan, phanLoaiQuyTrinh: 'GIA_HAN', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuGiaHan, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' || this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN') && userInfo.capCoQuanQuanLyId !== TTTrungUong },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'pl20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  this.state.type == 'KE_HOACH' ? this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.3. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' tr\u1EF1c ti\u1EBFp' : '2.2. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' tr\u1EF1c ti\u1EBFp' : this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.3. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' tr\u1EF1c ti\u1EBFp' : '1.2. Th\xF4ng b\xE1o k\u1EBFt th\xFAc ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' tr\u1EF1c ti\u1EBFp'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(_common.Input, { require: true, bindValidator: this, triggeOnBlur: true, channel: 'formTaoDon', label: 'S\u1ED1 th\xF4ng b\xE1o', placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soThongBaoKetThucTTTT, onChange: this.onChange.bind(this, 'soThongBaoKetThucTTTT'), name: 'soThongBaoKetThucTTTT', maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { require: true, bindValidator: this, triggeOnBlur: true, endDate: new Date(), channel: 'formTaoDon', label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', value: this.state.ngayBanHanhThongBaoKetThucTTTT, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhThongBaoKetThucTTTT'), name: 'ngayBanHanhThongBaoKetThucTTTT' })
                ),
                _react2.default.createElement(_common.TextArea, { label: 'Ghi ch\xFA', className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), name: 'ghiChu', maxLength: 1000 })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile },
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pr20' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'ketThucTTTT', loaiVanBanSuggest: 'TT_THONG_BAO_KT_TTTT', soVanBanSuggest: this.state.soThongBaoKetThucTTTT, ngayQuyetDinhSuggest: this.state.ngayBanHanhThongBaoKetThucTTTT, phanLoaiQuyTrinh: 'THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuThongBaoKetThucTTTT, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN' || this.checkIsKiemTra() && this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' }),
              userInfo.capCoQuanQuanLyId === TTTrungUong && _react2.default.createElement(
                'section',
                { className: 'wrap-block pb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-14 p20' },
                    this.state.type === 'KE_HOACH' ? '3. K\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' r\xFAt g\u1ECDn' : '2. K\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' r\xFAt g\u1ECDn'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_common.DropDown, { require: true, bindValidator: this, channel: 'formTaoDon', className: 'col-25', label: 'Tr\u1EA1ng th\xE1i', selectedValue: this.state.trangThaiRutGon, onChange: this.onChange.bind(this, 'trangThaiRutGon'), name: 'trangThaiRutGon', placeholder: true, options: this.state.listtrangThaiRutGon, keyName: 'giaTri', valueName: 'ten' }),
                    _react2.default.createElement(_common.DatePicker, { require: true, bindValidator: this, triggeOnBlur: true, endDate: new Date(), channel: 'formTaoDon', label: 'Ng\xE0y th\u1EF1c hi\u1EC7n', className: 'col-25', value: this.state.ngayThucHien, onChange: this.handleChangeDate.bind(this, 'ngayThucHien'), name: 'ngayThucHien' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl35 pr35' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { disableTopLine: true, onSave: this.state.onSave, label: 'V\u0103n b\u1EA3n \u0111\xEDnh k\xE8m', bindValidator: this, data: this.state.listTaiLieuKetLuanThanhTraRutGon, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this), phanLoaiQuyTrinh: 'KET_LUAN_THANH_TRA_RUT_GON' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pl15 pr15' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { titleClass: 'title-14 lable-title-custom', className: 'pl35 pr35 mb10 row pt20', onChange: this.handleCheck.bind(this, 'ketLuanThanhTra'), name: 'ketLuanThanhTra', checked: this.state.ketLuanThanhTra, label: this.state.type === 'KE_HOACH' ? '3.1 Kết luận thanh tra đầy đủ' : '2.1 Kết luận thanh tra đầy đủ' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Input, { require: true, bindValidator: this, triggeOnBlur: true, channel: 'formTaoDon', label: 'S\u1ED1 k\u1EBFt lu\u1EADn thanh tra', placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soKetLuanThanhTra, onChange: this.onChange.bind(this, 'soKetLuanThanhTra'), name: 'soKetLuanThanhTra', maxLength: 255 }),
                      _react2.default.createElement(_common.DatePicker, { require: true, bindValidator: this, triggeOnBlur: true, endDate: new Date(), channel: 'formTaoDon', label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', value: this.state.ngayBanHanhKetLuanThanhTra, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra'), name: 'ngayBanHanhKetLuanThanhTra' }),
                      _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                        label: '\u0110\u01A1n v\u1ECB ban h\xE0nh',
                        className: 'col-25',
                        selectedValue: this.state.donViBanHanh,
                        onChange: this.onChange.bind(this, 'donViBanHanh'),
                        name: 'donViBanHanh',
                        data: this.state.dataDonViBanHanh,
                        keyName: 'giaTri',
                        valueName: 'ten'
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Input, { bindValidator: this, channel: 'formTaoDon', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD', placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soQuyetDinhXuLy, onChange: this.onChange.bind(this, 'soQuyetDinhXuLy'), name: 'soQuyetDinhXuLy', maxLength: 255 }),
                      _react2.default.createElement(_common.DatePicker, { bindValidator: this, channel: 'formTaoDon', endDate: new Date(), label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', value: this.state.ngayBanHanhQuyetDinhXuLy, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhQuyetDinhXuLy'), name: 'ngayBanHanhQuyetDinhXuLy' })
                    ),
                    _react2.default.createElement(_common.TextArea, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.tomTatKetLuanThanhTra, onChange: this.onChange.bind(this, 'tomTatKetLuanThanhTra'), name: 'tomTatKetLuanThanhTra', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showFile },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'TT_KET_LUAN_THANH_TRA', soVanBanSuggest: this.state.soKetLuanThanhTra, ngayQuyetDinhSuggest: this.state.ngayBanHanhKetLuanThanhTra, name: 'ketLuanTranhTra', phanLoaiQuyTrinh: 'KET_LUAN_THANH_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuKetLuanThanhTra, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  )
                )
              ),
              userInfo.capCoQuanQuanLyId !== TTTrungUong && _react2.default.createElement(
                'section',
                { className: 'wrap-block pb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-14 p20' },
                    this.state.type === 'KE_HOACH' ? '3. K\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : '2. K\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_common.Input, { require: true, bindValidator: this, triggeOnBlur: true, channel: 'formTaoDon', label: 'S\u1ED1 k\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soKetLuanThanhTra, onChange: this.onChange.bind(this, 'soKetLuanThanhTra'), name: 'soKetLuanThanhTra', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { require: true, bindValidator: this, triggeOnBlur: true, endDate: new Date(), channel: 'formTaoDon', label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', value: this.state.ngayBanHanhKetLuanThanhTra, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra'), name: 'ngayBanHanhKetLuanThanhTra' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, {
                      label: '\u0110\u01A1n v\u1ECB ban h\xE0nh',
                      className: 'col-25',
                      selectedValue: this.state.donViBanHanh,
                      onChange: this.onChange.bind(this, 'donViBanHanh'),
                      name: 'donViBanHanh',
                      data: this.state.dataDonViBanHanh,
                      keyName: 'giaTri',
                      valueName: 'ten'
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_common.Input, { bindValidator: this, channel: 'formTaoDon', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD', placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soQuyetDinhXuLy, onChange: this.onChange.bind(this, 'soQuyetDinhXuLy'), name: 'soQuyetDinhXuLy', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { bindValidator: this, channel: 'formTaoDon', endDate: new Date(), label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', value: this.state.ngayBanHanhQuyetDinhXuLy, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhQuyetDinhXuLy'), name: 'ngayBanHanhQuyetDinhXuLy' })
                  ),
                  _react2.default.createElement(_common.TextArea, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.tomTatKetLuanThanhTra, onChange: this.onChange.bind(this, 'tomTatKetLuanThanhTra'), name: 'tomTatKetLuanThanhTra', maxLength: 1000 })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(
                    'div',
                    { className: 'pl20 pr20' },
                    _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'TT_KET_LUAN_THANH_TRA', soVanBanSuggest: this.state.soKetLuanThanhTra, ngayQuyetDinhSuggest: this.state.ngayBanHanhKetLuanThanhTra, name: 'ketLuanTranhTra', phanLoaiQuyTrinh: 'KET_LUAN_THANH_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuKetLuanThanhTra, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                  )
                )
              ),
              _react2.default.createElement('div', { className: 'big-border' }),
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { titleClass: 'title-14 lable-title-custom', className: 'pl35 pr35 mb10 row pt20', onChange: this.handleCheck.bind(this, 'noiDungKienNghi'), name: 'noiDungKienNghi', checked: this.state.noiDungKienNghi, label: this.state.type == 'KE_HOACH' ? '4. Nội dung kiến nghị' : '3. Nội dung kiến nghị' },
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(_subView.NoiDungKienNghi, { doiTuongThanhTraLienQuan: this.state.doiTuongThanhTraLienQuan, handleChangeData: this.handleChangeData.bind(this), setDoiTuongViPhamHienTai: this.setDoiTuongViPhamHienTai.bind(this), onRef: function onRef(noiDungKienNghi) {
                        return _this40.noiDungKienNghi = noiDungKienNghi;
                      }, setCountDoiTuongViPham: this.setCountDoiTuongViPham.bind(this), type: this.state.type, dataDoiTuongViPham: this.state.dataDoiTuongViPham, chucNangCuocThanhTra: this.state.chucNangCuocThanhTra, id: this.state.id, listDoiTuongViPham: this.state.listDoiTuongViPham, linhVucThanhTra: this.state.linhVucThanhTraList })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pb20' },
                _react2.default.createElement('div', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'section',
                { className: 'wrap-block pl20 pr20 pb10' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { titleClass: 'title-14 lable-title-custom', className: 'row pl15 pr15', label: this.state.type == 'KE_HOACH' ? '5. Nội dung tham nhũng' : '4. Nội dung tham nhũng', onChange: this.handleCheck.bind(this, 'noiDungThamNhung'), name: 'noiDungThamNhung', checked: this.state.noiDungThamNhung },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soVuThamNhung, onChange: this.onChange.bind(this, 'soVuThamNhung'), name: 'soVuThamNhung' }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soDoiTuongThamNhung, onChange: this.onChange.bind(this, 'soDoiTuongThamNhung'), name: 'soDoiTuongThamNhung', maxLength: 255 }),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'T\xE0i s\u1EA3n tham nh\u0169ng'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (Tr\u0111)', value: this.state.tienThamNhung, onChange: this.onChange.bind(this, 'tienThamNhung'), name: 'tienThamNhung' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111)', value: this.state.taiSanKhacThamNhung, onChange: this.onChange.bind(this, 'taiSanKhacThamNhung'), name: 'taiSanKhacThamNhung' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datThamNhung, onChange: this.onChange.bind(this, 'datThamNhung'), name: 'datThamNhung' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (Tr\u0111)', value: this.state.tienKienNghiThuHoi, onChange: this.onChange.bind(this, 'tienKienNghiThuHoi'), name: 'tienKienNghiThuHoi' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111)', value: this.state.taiSanKhacKienNghiThuHoi, onChange: this.onChange.bind(this, 'taiSanKhacKienNghiThuHoi'), name: 'taiSanKhacKienNghiThuHoi' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datKienNghiThuHoi, onChange: this.onChange.bind(this, 'datKienNghiThuHoi'), name: 'datKienNghiThuHoi' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100 no-gutter clear-left' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          '\u0110\xE3 thu'
                        ),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (Tr\u0111)', value: this.state.tienDaThu, onChange: this.onChange.bind(this, 'tienDaThu'), name: 'tienDaThu' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (Tr\u0111)', value: this.state.taiSanKhacDaThu, onChange: this.onChange.bind(this, 'taiSanKhacDaThu'), name: 'taiSanKhacDaThu' }),
                        _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datDaThu, onChange: this.onChange.bind(this, 'datDaThu'), name: 'datDaThu' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                        ),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'T\u1ED5 ch\u1EE9c', value: this.state.toChucXuLyHanhChinhThamNhung, onChange: this.onChange.bind(this, 'toChucXuLyHanhChinhThamNhung'), name: 'toChucXuLyHanhChinhThamNhung' }),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'C\xE1 nh\xE2n', value: this.state.caNhanXuLyHanhChinhThamNhung, onChange: this.onChange.bind(this, 'caNhanXuLyHanhChinhThamNhung'), name: 'caNhanXuLyHanhChinhThamNhung' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-50 no-gutter' },
                        _react2.default.createElement(
                          'p',
                          { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                          'X\u1EED l\xFD tr\xE1ch nhi\u1EC7m ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u1EA7u'
                        ),
                        _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'S\u1ED1 ng\u01B0\u1EDDi', value: this.state.soNguoiXuLyTrachNhiemDungDau, onChange: this.onChange.bind(this, 'soNguoiXuLyTrachNhiemDungDau'), name: 'soNguoiXuLyTrachNhiemDungDau' }),
                        _react2.default.createElement(_common.Input, { className: 'col-50', label: 'T\xEAn ng\u01B0\u1EDDi', placeholder: 'Nh\u1EADp...', value: this.state.tenNguoi, onChange: this.onChange.bind(this, 'tenNguoi'), name: 'tenNguoi', maxLength: 255 })
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.getDetail === true },
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pl0 pr0 pt35 pb5' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false, 'close') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u t\u1EA1m'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tienDoThanhTraType != 'DANG_TIEN_HANH' && this.state.tienDoThanhTraType != 'KET_THUC_THANH_TRA_TRUC_TIEP' && this.state.tienDoThanhTraType != 'DA_BAN_HANH_KET_LUAN' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.postProcess.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Ti\u1EBFn h\xE0nh ',
                    this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' && !this.checkIsKiemTra() },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.postProcess.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'K\u1EBFt th\xFAc ',
                    this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra',
                    ' tr\u1EF1c ti\u1EBFp'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: (this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN') && !this.checkIsKiemTra() },
                this.state.noiDungKienNghi === true && userInfo.capCoQuanQuanLyId !== TTTrungUong && !this.checkIsKiemTra() ? _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Chuy\u1EC3n theo d\xF5i th\u1EF1c hi\u1EC7n'
                  )
                ) : _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' && this.checkIsKiemTra() },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u h\u1ED3 s\u01A1'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.showDoiTuongThanhTra,
            onClose: this.hideDoiTuongThanhTra.bind(this),
            title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
            className: 'reception-dialog delete-dialog full-dialog'
          },
          DataDetail.cuocThanhTraNhieuDoiTuong == true ? _react2.default.createElement(
            'table',
            { className: 'blueTable' },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  { style: { width: '35px' } },
                  'STT'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '300px' } },
                  'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '165px' } },
                  'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '375px' } },
                  '\u0110\u1ECBa ch\u1EC9'
                ),
                _react2.default.createElement(
                  'th',
                  { style: { width: '135px' } },
                  'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.map(function (item, index) {
                return _react2.default.createElement(
                  'tr',
                  { key: index },
                  _react2.default.createElement(
                    'td',
                    null,
                    index + 1
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.ten
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.diaChi
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    item.soDienThoai || ''
                  )
                );
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:', value: chiTietMotDoiTuong.ten || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:', value: chiTietMotDoiTuong && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\u1ECBa ch\u1EC9:', value: chiTietMotDoiTuong.diaChi || '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:', value: chiTietMotDoiTuong && chiTietMotDoiTuong.soDienThoai ? chiTietMotDoiTuong.soDienThoai : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.hideDoiTuongThanhTra.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.confirmDoiTuongViPham,
            onClose: this.closeConfirmDoiTuongViPham.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              '\u0110\u1ED1i t\u01B0\u1EE3ng n\xE0y \u0111ang \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng, x\xE1c nh\u1EADn x\xF3a'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeConfirmDoiTuongViPham.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.accessConfirmDoiTuongViPham.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.confirmDoiTuongLienQuan,
            onClose: this.closeConfirmDoiTuongLienQuan.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              '\u0110\u1ED1i t\u01B0\u1EE3ng n\xE0y \u0111ang \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng, x\xE1c nh\u1EADn x\xF3a'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeConfirmDoiTuongLienQuan.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.accessConfirmDoiTuongLienQuan.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.openDialog,
            onClose: this.closeDialog.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              this.state.noiDungKienNghi === true && userInfo.capCoQuanQuanLyId !== TTTrungUong && !this.checkIsKiemTra() ? "Xác nhận chuyển theo dõi thực hiện" : "Xác nhận lưu hồ sơ"
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green', onClick: this.handleKetThuc.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return ChinhSuaCuocThanhTra;
}(_react2.default.Component);

ChinhSuaCuocThanhTra.defaultProps = {
  validators: {
    formTaoDon: []
  },
  params: {
    id: ''
  }
};

exports.default = ChinhSuaCuocThanhTra;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _CheckPermission = __webpack_require__(20);

var _datatable = __webpack_require__(52);

var _config = __webpack_require__(16);

var _subView = __webpack_require__(169);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _lodash = __webpack_require__(14);

var _utils = __webpack_require__(4);

var _downloadExcel = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachCuocThanhTra = function (_React$Component) {
  _inherits(DanhSachCuocThanhTra, _React$Component);

  function DanhSachCuocThanhTra(props, context) {
    _classCallCheck(this, DanhSachCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (DanhSachCuocThanhTra.__proto__ || Object.getPrototypeOf(DanhSachCuocThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      search: false,
      showDropdownCreate: false
    };
    return _this;
  }

  _createClass(DanhSachCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDataList();
    }
  }, {
    key: 'checkDate',
    value: function checkDate(stD, endD) {
      var startDate = (0, _moment2.default)(stD, 'MM/DD/YYYY').valueOf();
      var endDate = (0, _moment2.default)(endD, 'MM/DD/YYYY').valueOf();
      if (startDate > endDate) {
        (0, _toastr.Toastr)('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
      }
    }
  }, {
    key: 'toggleDropdownCreate',
    value: function toggleDropdownCreate() {
      this.setState(_extends({}, this.state, {
        showDropdownCreate: !this.state.showDropdownCreate
      }));
    }
  }, {
    key: 'getDataList',
    value: function getDataList() {
      var _this2 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (this.state.tenDoiTuongThanhTra) {
        params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
      }

      if (this.state.phanLoai) {
        params.phanLoai = this.state.phanLoai;
      }

      if (this.state.soQuyetDinh) {
        params.soQuyetDinh = this.state.soQuyetDinh;
      }

      if (this.state.loaiHinhThanhTra) {
        params.loaiKeHoach = this.state.loaiHinhThanhTra;
      }

      if (this.state.linhVucThanhTra) {
        params.linhVucThanhTra = this.state.linhVucThanhTra;
      }

      if (this.state.quyetDinhPheDuyetKHTT) {
        params.quyetDinhPheDuyetKHTT = this.state.quyetDinhPheDuyetKHTT;
      }

      if (this.state.tienDoThanhTra) {
        params.tienDoThanhTra = this.state.tienDoThanhTra;
      }

      if (this.state.tuNgay) {
        params.tuNgay = (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.denNgay) {
        params.denNgay = (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.tuNgay && this.state.denNgay) {
        this.checkDate(this.state.tuNgay, this.state.denNgay);
      }

      if (this.state.soKetLuanThanhTra) {
        params.soKetLuanThanhTra = this.state.soKetLuanThanhTra;
      }

      if (this.state.soQuyetDinhXL) {
        params.soQuyetDinhXL = this.state.soQuyetDinhXL;
      }

      if (!(0, _lodash.isEmpty)(this.state.namThanhTra)) {
        params.namThanhTra = this.state.namThanhTra;
      }
      _api.ThanhTra.actions.getCuocThanhTra.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.cuocThanhTras,
            pageData: res.data.page,
            tableLoading: false,
            search: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getDataList();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getDataList();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({
        advanceSearch: true
      });
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({
        advanceSearch: false
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this3 = this;

      _api.ThanhTra.actions.deleteCuocThanhTra.request({ id: sID }).then(function (res) {
        (0, _toastr.Toastr)('Xóa cuộc thanh tra thành công', 'success');
        _this3.getDataList();
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(data) {
      if (this.validateSubmitForm()) {
        this.state = _extends({}, this.state, data, {
          search: true
        });
        this.setState(_extends({}, this.state));
        this.getDataList();
      }
    }
  }, {
    key: 'exportExcel',
    value: function exportExcel() {
      var name = 'danh-muc-cuoc-thanh-tra-kiem-tra';
      var apiUrl = 'cuocThanhTras/export-excel';
      // eslint-disable-next-line no-useless-concat
      var URL = String(_config.API_URL) + '/' + apiUrl + "?soQuyetDinh=" + this.state.soQuyetDinh + "&tuNgay=" + (this.state.tuNgay ? (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&denNgay=" + (this.state.denNgay ? (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '') + "&tenDoiTuongThanhTra=" + (this.state.tenDoiTuongThanhTra ? this.state.tenDoiTuongThanhTra : '') + "&phanLoai=" + (this.state.phanLoai ? this.state.phanLoai : '') + "&loaiKeHoach=" + (this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : '') + "&tienDoThanhTra=" + (this.state.tienDoThanhTra ? this.state.tienDoThanhTra : '') + "&soKetLuanThanhTra=" + (this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '') + "&soQuyetDinhXL=" + (this.state.soQuyetDinhXL ? this.state.soQuyetDinhXL : '');
      (0, _downloadExcel.downloadExcel)(URL, name, true);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'Danh m\u1EE5c cu\u1ED9c thanh tra, ki\u1EC3m tra'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right-content dropdown-create-wrap' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('THANHTRA_THEM') },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green btn-dropdown', onClick: this.toggleDropdownCreate.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi cu\u1ED9c \u0111\u1ED9t xu\u1EA5t'
              ),
              this.state.showDropdownCreate && _react2.default.createElement(
                'div',
                { className: 'dropdown-create' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'dropdown-item', to: '/thanh-tra/them-moi-cuoc-thanh-tra' },
                  'Cu\u1ED9c thanh tra \u0111\u1ED9t xu\u1EA5t'
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'dropdown-item', to: '/thanh-tra/them-moi-cuoc-kiem-tra' },
                  'Cu\u1ED9c ki\u1EC3m tra \u0111\u1ED9t xu\u1EA5t'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content thanh-tra-search' },
          _react2.default.createElement(
            'div',
            { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container show-label' },
            _react2.default.createElement(_subView.Search, { ref: 'listSearch', advanceSearch: this.state.advanceSearch, bindValidator: this, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search }),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
              _react2.default.createElement('i', { className: 'tt tt-super-search' }),
              'T\xECm ki\u1EBFm n\xE2ng cao'
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.thanhTra.DSCTT,
              dataList: this.state.data,
              thanhTra: true,
              hideButtonExport: false,
              pageData: this.state.pageData,
              exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
              handleExport: this.exportExcel.bind(this),
              parent: this,
              search: this.state.search,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhSachCuocThanhTraPage, { getList: this.getDataList.bind(this) })
          )
        )
      );
    }
  }]);

  return DanhSachCuocThanhTra;
}(_react2.default.Component);

DanhSachCuocThanhTra.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = DanhSachCuocThanhTra;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _reactRedux = __webpack_require__(6);

var _config = __webpack_require__(16);

var _datatable = __webpack_require__(52);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDoiTuongTrung = function (_React$Component) {
  _inherits(DanhSachDoiTuongTrung, _React$Component);

  function DanhSachDoiTuongTrung(props, context) {
    _classCallCheck(this, DanhSachDoiTuongTrung);

    var _this = _possibleConstructorReturn(this, (DanhSachDoiTuongTrung.__proto__ || Object.getPrototypeOf(DanhSachDoiTuongTrung)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      namThanhTraList: [],
      namThanhTra: (new Date().getFullYear() + 1).toString(),
      tenDoiTuongThanhTra: '',
      donViId: '',
      donViChuTriList: [],
      loading: false,
      loadingSearch: false
    };
    return _this;
  }

  _createClass(DanhSachDoiTuongTrung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('dttData') ? JSON.parse(localStorage.getItem('dttData')) : {};
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.namThanhTra = this.props.goBack ? data.namThanhTra : (new Date().getFullYear() + 1).toString();
      this.state.tenDoiTuongThanhTra = data.tenDoiTuongThanhTra || '';
      this.getDataList();
      this.getNamThanhTraList();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.namThanhTra !== prevProps.namThanhTra) {
        this.forceUpdate();
      }
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this2 = this;

      _api.ThanhTra.actions.getDonViKHTT.request().then(function (res) {
        if (res.data && res.data._embedded) {
          res.data._embedded.coQuanQuanLies.map(function (item) {
            _this2.state.donViChuTriList.push({ value: item.coQuanQuanLyId, label: item.ten });
          });
        } else {
          _this2.state.donViChuTriList = [];
        }
        _this2.setState(_extends({}, _this2.state));
      });
    }
  }, {
    key: 'getDataList',
    value: function getDataList(isFirst) {
      var _this3 = this;

      if (isFirst) {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (this.state.namThanhTra) {
        params.namThanhTra = this.state.namThanhTra ? this.state.namThanhTra : new Date().getFullYear() + 1;
      }

      if (this.state.tenDoiTuongThanhTra) {
        params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
      }
      this.setState({ loading: true });
      localStorage.setItem('dttData', JSON.stringify(params));
      _api.ThanhTra.actions.getCuocThanhTraTrung.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            data: res.data._embedded.medial_CuocThanhTraTrungInfoes,
            pageData: res.data.page,
            loading: false
          });
        } else {
          _this3.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            loading: false
          });
        }
      });
      this.props.dispatch({ type: 'DSTT_RESET_GO_BACK' });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var value = e.target ? e.target.value : e;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getDataList();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getDataList();
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this4 = this;

      if (this.props.namThanhTra.length === 0) {
        _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
          if (res.data) {
            _this4.props.dispatch({ type: 'SET_NAM_THANH_TRA', data: res.data });
          }
        });
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      var URL = String(_config.API_URL) + "/cuocThanhTraTrungDoiTuong/xuatExcel?tenDoiTuongThanhTra=" + this.state.tenDoiTuongThanhTra + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '');

      window.open(URL, "_self");
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra tr\xF9ng'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_common.Input, { className: 'col-40 mb0-18', label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...', value: this.state.tenDoiTuongThanhTra, onChange: this.onChange.bind(this, 'tenDoiTuongThanhTra') }),
              _react2.default.createElement(_common.DropDown, { className: 'input-group mb0-18', label: 'N\u0103m thanh tra', options: this.props.namThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true }),
              _react2.default.createElement(
                'div',
                { className: 'input-group mb0-18 search-thanh-tra' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-green ' + (this.state.loadingSearch ? 'btn-loading-inline' : ''), onClick: this.getDataList.bind(this, true) },
                  _react2.default.createElement('i', { className: 'tt-search' }),
                  'T\xECm ki\u1EBFm'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pt20' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.thanhTra.DSDTT,
              handleExport: this.handleExport.bind(this),
              dataList: this.state.data,
              exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
              hideButtonExport: true,
              thanhTra: true,
              pageData: this.state.pageData,
              parent: this,
              search: true,
              tableLoading: this.state.loading },
            _react2.default.createElement(_datatable.RowItemDanhSachDoiTuongTrung, null)
          )
        )
      );
    }
  }]);

  return DanhSachDoiTuongTrung;
}(_react2.default.Component);

DanhSachDoiTuongTrung.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DanhSachDoiTuongTrung);

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _config = __webpack_require__(16);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _CheckPermission = __webpack_require__(20);

var _datatable = __webpack_require__(52);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

var _downloadFile = __webpack_require__(112);

__webpack_require__(1980);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachKeHoachThanhTra = function (_React$Component) {
  _inherits(DanhSachKeHoachThanhTra, _React$Component);

  function DanhSachKeHoachThanhTra(props, context) {
    _classCallCheck(this, DanhSachKeHoachThanhTra);

    var _this = _possibleConstructorReturn(this, (DanhSachKeHoachThanhTra.__proto__ || Object.getPrototypeOf(DanhSachKeHoachThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      isKHTTchecked: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      namThanhTra: '',
      nguoiKy: '',
      donViIds: [],
      donViChuTriList: [],
      donViSelected: [],
      loading: false,
      thanhTraQuanHuyenId: '',
      showDropdownCreate: false,
      loaiHinhThanhTraList: [{
        giaTri: "THANH_TRA",
        ten: "Thanh tra"
      }, {
        giaTri: "KIEM_TRA",
        ten: "Kiểm tra"
      }]
    };
    return _this;
  }

  _createClass(DanhSachKeHoachThanhTra, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = localStorage.getItem('khttData') ? JSON.parse(localStorage.getItem('khttData')) : {};

                this.getDonViChuTri(data.donViSelected);
                _context.next = 4;
                return this.checkNamThanhTraXuLy();

              case 4:
                _context.next = 6;
                return this.setState({
                  pageData: {
                    number: data.page || 0,
                    size: data.size || 10,
                    soQuyetDinh: data.soQuyetDinh || '',
                    nguoiKy: data.nguoiKy || '',
                    namThanhTra: this.props.goBack ? data.namThanhTra : this.state.namThanhTra,
                    donViSelected: data.donViSelected || [],
                    tuNgay: '',
                    denNgay: ''
                  }
                });

              case 6:
                this.kiemTraTonTaiKHTTTrongNamThanhTra();
                this.getKeHoachThanhTraList();
                this.checkDonVi();
                this.getNamThanhTraList();
                this.checkDonViQuanHuyen();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.namThanhTra !== prevProps.namThanhTra) {
        this.forceUpdate();
      }
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'checkDonViQuanHuyen',
    value: function checkDonViQuanHuyen() {
      var _this3 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CCQQL_UBND_QUAN_HUYEN' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ thanhTraQuanHuyenId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri(selectedItem) {
      var _this4 = this;

      _api.ThanhTra.actions.getDonViKHTT.request().then(function (res) {
        if (!_this4.refs.dskhtt) {
          return;
        }
        if (res.data && res.data._embedded) {
          _this4.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
          _this4.state.donViSelected = selectedItem || [];
        } else {
          _this4.state.donViChuTriList = [];
        }
        _this4.setState(_extends({}, _this4.state));
      });
    }
  }, {
    key: 'checkDate',
    value: function checkDate(stD, endD) {
      var startDate = (0, _moment2.default)(stD, 'MM/DD/YYYY').valueOf();
      var endDate = (0, _moment2.default)(endD, 'MM/DD/YYYY').valueOf();
      if (startDate > endDate) {
        (0, _toastr.Toastr)('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
      }
    }
  }, {
    key: 'getKeHoachThanhTraList',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(isFirst, e) {
        var _this5 = this;

        var state, params, idArr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = this.state;

                if (typeof e !== 'undefined') {
                  e.preventDefault();
                }

                if (!this.validateSubmitForm()) {
                  _context2.next = 21;
                  break;
                }

                if (isFirst) {
                  state.pageData = {
                    number: 0,
                    size: 10,
                    totalElements: 0
                  };
                }
                params = {
                  page: state.pageData.number,
                  size: state.pageData.size,
                  sort: 'namThanhTra,desc',
                  isTatCaDonVi: false
                };

                if (this.state.loaiKeHoach) {
                  params.loaiKeHoach = this.state.loaiKeHoach;
                }
                if (this.state.namThanhTra) {
                  params.namThanhTra = this.state.namThanhTra;
                }
                if (state.donViSelected.length) {
                  idArr = [];

                  state.donViSelected.map(function (item) {
                    idArr.push(item.value);
                  });
                  params.donViIds = idArr.join();
                }
                if (state.soQuyetDinh) {
                  params.soQuyetDinh = state.soQuyetDinh;
                }
                if (!(0, _lodash.isEmpty)(state.namThanhTra)) {
                  params.namThanhTra = state.namThanhTra;
                }
                if (state.tuNgay) {
                  params.tuNgay = (0, _moment2.default)(state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                }
                if (state.denNgay) {
                  params.denNgay = (0, _moment2.default)(state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                }
                if (state.tuNgay && state.denNgay && isFirst === true) {
                  this.checkDate(state.tuNgay, state.denNgay);
                }
                if (state.nguoiKy) {
                  params.nguoiKy = state.nguoiKy;
                }
                state.loading = true;
                _context2.next = 17;
                return this.setState({ loading: true });

              case 17:
                _context2.next = 19;
                return localStorage.setItem('khttData', JSON.stringify(_extends({}, params, { donViSelected: state.donViSelected })));

              case 19:
                _context2.next = 21;
                return _api.ThanhTra.actions.getKeHoachThanhTra.request(null, params).then(function (res) {
                  if (!_this5.refs.dskhtt) {
                    return;
                  }
                  if (res.data._embedded) {
                    var data = (0, _lodash.get)(res, 'data._embedded.medial_KeHoachThanhTra_DanhSaches');
                    state = _extends({}, state, {
                      data: data,
                      pageData: res.data.page,
                      tableLoading: false,
                      loading: false
                    });
                  } else {
                    state = _extends({}, state, {
                      data: [],
                      pageData: {
                        number: 0,
                        size: 10,
                        totalElements: 0
                      },
                      tableLoading: false,
                      loading: false
                    });
                  }
                });

              case 21:
                this.setState(state);
                this.props.dispatch({ type: 'DSTT_RESET_GO_BACK' });

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getKeHoachThanhTraList(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return getKeHoachThanhTraList;
    }()
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'DonVi') {
        this.setState({
          donViSelected: e
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getKeHoachThanhTraList();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getKeHoachThanhTraList();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this6 = this;

      _api.ThanhTra.actions.deleteKeHoachThanhTra.request({ id: sID }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.removeKHSuccess, 'success');
        _this6.getKeHoachThanhTraList();
      });
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this7 = this;

      if (this.props.namThanhTra.length === 0) {
        _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
          if (res && res.data) {
            _this7.props.dispatch({ type: 'SET_NAM_THANH_TRA', data: res.data });
          }
        });
      }
    }
  }, {
    key: 'kiemTraTonTaiKHTTTrongNamThanhTra',
    value: function kiemTraTonTaiKHTTTrongNamThanhTra() {
      var _this8 = this;

      _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          _this8.setState({
            isKHTTchecked: !!(0, _lodash.get)(res, 'data.isHienThiButtonThemMoiKHTT')
          });
        }
      });
    }
  }, {
    key: 'checkNamThanhTraXuLy',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this9 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if ((0, _lodash.isEmpty)(res.data)) {
                              _context3.next = 3;
                              break;
                            }

                            _context3.next = 3;
                            return _this9.setState({
                              namThanhTra: (0, _lodash.get)(res, 'data.namThanhTra')
                            });

                          case 3:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this9);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function checkNamThanhTraXuLy() {
        return _ref3.apply(this, arguments);
      }

      return checkNamThanhTraXuLy;
    }()
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      if (this.state.donViSelected.length) {
        var idArr = [];
        this.state.donViSelected.map(function (item) {
          idArr.push(item.value);
        });
        this.state.donViIds = idArr.join();
      }
      var URL = String(_config.API_URL) + "/danhMucCuocThanhTras/xuatExcel?soQuyetDinh=" + this.state.soQuyetDinh + "&tuNgay=" + (this.state.tuNgay ? (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&denNgay=" + (this.state.denNgay ? (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '') + "&nguoiKy=" + (this.state.nguoiKy ? this.state.nguoiKy : '') + "&donViIds=" + (this.state.donViIds ? this.state.donViIds : []) + "&loaiKeHoach=" + (this.state.loaiKeHoach ? this.state.loaiKeHoach : '');
      (0, _downloadFile.downloadFile)(URL);
    }
  }, {
    key: 'toggleDropdownCreate',
    value: function toggleDropdownCreate() {
      this.setState(_extends({}, this.state, {
        showDropdownCreate: !this.state.showDropdownCreate
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container', ref: 'dskhtt' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'Danh s\xE1ch k\u1EBF ho\u1EA1ch thanh tra, ki\u1EC3m tra'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right-content dropdown-create-wrap' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (0, _CheckPermission.CheckPermission)('THANHTRA_THEM') },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green btn-dropdown', onClick: this.toggleDropdownCreate.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm m\u1EDBi'
              ),
              this.state.showDropdownCreate && _react2.default.createElement(
                'div',
                { className: 'dropdown-create' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'dropdown-item', to: '/thanh-tra/them-moi-ke-hoach-thanh-tra' },
                  'K\u1EBF ho\u1EA1ch thanh tra'
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'dropdown-item', to: '/thanh-tra/them-moi-ke-hoach-kiem-tra' },
                  'K\u1EBF ho\u1EA1ch ki\u1EC3m tra'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'form',
              { onSubmit: this.getKeHoachThanhTraList.bind(this, true) },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT/KHKT', placeholder: 'Nh\u1EADp s\u1ED1 quy\u1EBFt \u0111\u1ECBnh', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
                  _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.props.namThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true }),
                  _react2.default.createElement(_common.DropDown, { label: 'Lo\u1EA1i h\xECnh thanh tra/ki\u1EC3m tra', selectedValue: this.state.loaiKeHoach, placeholder: true, className: 'col-25', onChange: this.handleChange.bind(this, 'loaiKeHoach'), name: 'loaiKeHoach',
                    options: this.state.loaiHinhThanhTraList, keyName: 'giaTri', valueName: 'ten' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-16 mb0-18 search-thanh-tra' },
                  _react2.default.createElement(
                    'button',
                    { className: 'btn-green ' + (this.state.loading ? 'btn-loading-inline' : '') },
                    _react2.default.createElement('i', { className: 'tt-search' }),
                    'T\xECm ki\u1EBFm'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.thanhTra.DSKHTT,
              handleExport: this.handleExport.bind(this),
              dataList: this.state.data,
              exporttext: 'Xu\u1EA5t Excel',
              thanhTra: true,
              hideButtonExport: true,
              pageData: this.state.pageData,
              parent: this,
              search: true,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhSachKeHoachThanhTra, { isTTTP: userInfo.donViId == this.state.thanhTraThanhPhoId })
          )
        )
      );
    }
  }]);

  return DanhSachKeHoachThanhTra;
}(_react2.default.Component);

DanhSachKeHoachThanhTra.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DanhSachKeHoachThanhTra);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(16);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(52);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _downloadFile = __webpack_require__(112);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachKeHoachThanhTraDaPheDuyet = function (_React$Component) {
  _inherits(DanhSachKeHoachThanhTraDaPheDuyet, _React$Component);

  function DanhSachKeHoachThanhTraDaPheDuyet(props, context) {
    _classCallCheck(this, DanhSachKeHoachThanhTraDaPheDuyet);

    var _this = _possibleConstructorReturn(this, (DanhSachKeHoachThanhTraDaPheDuyet.__proto__ || Object.getPrototypeOf(DanhSachKeHoachThanhTraDaPheDuyet)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      namThanhTra: '',
      nguoiKy: '',
      donViIds: [],
      donViChuTriList: [],
      donViSelected: [],
      loading: false,
      thanhTraQuanHuyenId: ''
    };
    return _this;
  }

  _createClass(DanhSachKeHoachThanhTraDaPheDuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var state = this.state;
      var data = localStorage.getItem('khttData') ? JSON.parse(localStorage.getItem('khttData')) : {};
      this.getDonViChuTri(data.donViSelected);
      state.pageData.number = data.page || 0;
      state.pageData.size = data.size || 10;
      state.soQuyetDinh = data.soQuyetDinh || '';
      state.nguoiKy = data.nguoiKy || '';
      state.namThanhTra = this.props.goBack ? data.namThanhTra : '';
      state.donViSelected = data.donViSelected || [];
      state.tuNgay = '';
      state.denNgay = '';
      this.getKeHoachThanhTraList();
      this.checkDonVi();
      this.getNamThanhTraList();
      this.checkDonViQuanHuyen();
      this.setState(state);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.namThanhTra !== prevProps.namThanhTra) {
        this.forceUpdate();
      }
    }
  }, {
    key: 'checkDonVi',
    value: function checkDonVi() {
      var _this2 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this2.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'checkDonViQuanHuyen',
    value: function checkDonViQuanHuyen() {
      var _this3 = this;

      _api.Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CCQQL_UBND_QUAN_HUYEN' }).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ thanhTraQuanHuyenId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
        }
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri(selectedItem) {
      var _this4 = this;

      _api.ThanhTra.actions.getDonViKHTT.request().then(function (res) {
        if (!_this4.refs.dskhtt) {
          return;
        }
        var donViChuTriList = [];
        var donViSelected = [];
        if (res.data && res.data._embedded) {
          donViChuTriList = res.data._embedded.coQuanQuanLies;
          donViSelected = selectedItem || [];
        } else {
          donViChuTriList = [];
        }
        _this4.setState({ donViChuTriList: donViChuTriList, donViSelected: donViSelected });
      });
    }
  }, {
    key: 'checkDate',
    value: function checkDate(stD, endD) {
      var startDate = (0, _moment2.default)(stD, 'MM/DD/YYYY').valueOf();
      var endDate = (0, _moment2.default)(endD, 'MM/DD/YYYY').valueOf();
      if (startDate > endDate) {
        (0, _toastr.Toastr)('Từ ngày phải nhỏ hơn Đến ngày', 'warning');
      }
    }
  }, {
    key: 'getKeHoachThanhTraList',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isFirst, e) {
        var _this5 = this;

        var state, params, idArr;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = this.state;

                if (typeof e !== 'undefined') {
                  e.preventDefault();
                }

                if (!this.validateSubmitForm()) {
                  _context.next = 19;
                  break;
                }

                if (isFirst) {
                  state.pageData = {
                    number: 0,
                    size: 10,
                    totalElements: 0
                  };
                }
                params = {
                  page: state.pageData.number,
                  size: state.pageData.size,
                  sort: 'namThanhTra,desc',
                  isTatCaDonVi: false,
                  isPheDuyet: true
                };

                if (state.donViSelected.length) {
                  idArr = [];

                  state.donViSelected.map(function (item) {
                    idArr.push(item.value);
                  });
                  params.donViIds = idArr.join();
                }
                if (state.soQuyetDinh) {
                  params.soQuyetDinh = state.soQuyetDinh;
                }
                if (state.tuNgay) {
                  params.tuNgay = (0, _moment2.default)(state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                }
                if (state.denNgay) {
                  params.denNgay = (0, _moment2.default)(state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
                }
                if (state.tuNgay && state.denNgay && isFirst === true) {
                  this.checkDate(state.tuNgay, state.denNgay);
                }
                if (state.nguoiKy) {
                  params.nguoiKy = state.nguoiKy;
                }
                if (!(0, _lodash.isEmpty)(state.namThanhTra)) {
                  params.namThanhTra = state.namThanhTra;
                }
                state.loading = true;
                _context.next = 15;
                return this.setState({ loading: true });

              case 15:
                _context.next = 17;
                return localStorage.setItem('khttData', JSON.stringify(_extends({}, params, { donViSelected: state.donViSelected })));

              case 17:
                _context.next = 19;
                return _api.ThanhTra.actions.getKeHoachThanhTra.request(null, params).then(function (res) {
                  if (!_this5.refs.dskhtt) {
                    return;
                  }
                  if (res.data._embedded) {
                    state = _extends({}, state, {
                      data: res.data._embedded.medial_KeHoachThanhTra_DanhSaches,
                      pageData: res.data.page,
                      tableLoading: false,
                      loading: false
                    });
                  } else {
                    state = _extends({}, state, {
                      data: [],
                      pageData: {
                        number: 0,
                        size: 10,
                        totalElements: 0
                      },
                      tableLoading: false,
                      loading: false
                    });
                  }
                });

              case 19:
                this.setState(state);
                this.props.dispatch({ type: 'DSTT_RESET_GO_BACK' });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getKeHoachThanhTraList(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getKeHoachThanhTraList;
    }()
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'DonVi') {
        this.setState({
          donViSelected: e
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getKeHoachThanhTraList();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var state = this.state;
      state.pageData.size = size;
      state.pageData.number = 0;
      this.getKeHoachThanhTraList();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this6 = this;

      _api.ThanhTra.actions.deleteKeHoachThanhTra.request({ id: sID }).then(function (res) {
        (0, _toastr.Toastr)(_message.msg.removeKHSuccess, 'success');
        _this6.getKeHoachThanhTraList();
      });
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this7 = this;

      if (this.props.namThanhTra.length === 0) {
        _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
          if (res && res.data) {
            _this7.props.dispatch({ type: 'SET_NAM_THANH_TRA', data: res.data });
          }
        });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      // if (this.state.donViSelected.length) {
      // let idArr = [];
      var donViSelected = this.state.donViSelected || [];
      var idArr = donViSelected.map(function (item) {
        return item.value;
      });
      var donViIds = idArr.join();
      var URL = String(_config.API_URL) + "/danhMucCuocThanhTras/xuatExcel?soQuyetDinh=" + this.state.soQuyetDinh + "&tuNgay=" + (this.state.tuNgay ? (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&denNgay=" + (this.state.denNgay ? (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString() : '') + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '') + "&nguoiKy=" + (this.state.nguoiKy ? this.state.nguoiKy : '') + "&donViIds=" + (donViIds ? this.state.donViIds : []);

      (0, _downloadFile.downloadFile)(URL);
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container', ref: 'dskhtt' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
              'Danh s\xE1ch k\u1EBF ho\u1EA1ch thanh tra, ki\u1EC3m tra \u0111\xE3 ph\xEA duy\u1EC7t'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'form',
              { onSubmit: this.getKeHoachThanhTraList.bind(this, true) },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-83 no-gutter' },
                  _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT/KHKT', placeholder: 'Nh\u1EADp s\u1ED1 quy\u1EBFt \u0111\u1ECBnh', value: this.state.soQuyetDinh, onChange: this.onChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', maxLength: 255 }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
                  _react2.default.createElement(_common.DatePicker, { className: 'col-20', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
                  _react2.default.createElement(_common.DropDown, { className: 'col-25 mb18', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.props.namThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), placeholder: true })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-16 mb0-18 search-thanh-tra' },
                  _react2.default.createElement(
                    'button',
                    { className: (0, _classnames2.default)('btn-green', { 'btn-loading-inline': this.state.loading }) },
                    _react2.default.createElement('i', { className: 'tt-search' }),
                    'T\xECm ki\u1EBFm'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.thanhTra.DSKHTTDPD,
              handleExport: this.handleExport.bind(this),
              dataList: this.state.data,
              exporttext: 'Xu\u1EA5t Excel',
              thanhTra: true,
              hideButtonExport: true,
              pageData: this.state.pageData,
              parent: this,
              search: true,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhSachKeHoachThanhTraDaPheDuyet, { isTTTP: userInfo.donViId === this.state.thanhTraThanhPhoId })
          )
        )
      );
    }
  }]);

  return DanhSachKeHoachThanhTraDaPheDuyet;
}(_react2.default.Component);

DanhSachKeHoachThanhTraDaPheDuyet.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DanhSachKeHoachThanhTraDaPheDuyet);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(52);

var _ttForms = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiQuyTrinh = 'THANH_TRA';

var ThemMoiCuocThanhTra = function (_React$Component) {
  _inherits(ThemMoiCuocThanhTra, _React$Component);

  function ThemMoiCuocThanhTra(props, context) {
    _classCallCheck(this, ThemMoiCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (ThemMoiCuocThanhTra.__proto__ || Object.getPrototypeOf(ThemMoiCuocThanhTra)).call(this, props, context));

    _this.state = {
      dotXuat: _this.props.dotXuat,
      id: _this.props.params.id,
      data: [],
      dataDetail: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        ketLuanTranhTra: [],
        data: []
      },

      listTaiLieuVanThuKetLuanThanhTra: [],
      listTaiLieuVanThu: [],

      dataThanhTraLai: [],
      dataLinhVucThanhTra: [],
      dataDonViChuTri: [],
      dataCoQuanDieuTra: [],
      dataDonViBanHanh: [],
      dataDonViViPham: [],
      dataLoaiHinhThanhTra: [],
      dataHinhThucThanhTra: [],

      dataThanhVienDoan: [],
      dataVaiTroThanhVienDoan: [],

      dataTaiLieuVanThuDelete: [],
      value: '',
      ngayCongBoKQThanhTra: '',
      thoiHanThanhTra: 0,
      ngayHetHanThanhTra: '',

      danhSachDonViPhoiHop: [],
      donViPhoiHop: '',
      danhSachDonViThanhTra: [],
      donViThanhTra: '',
      danhSachDonViViPham: [],
      donViViPham: '',
      danhSachCanCuThanhTraLai: [],
      CanCuThanhTraLai: '',

      // new

      soQuyetDinhThanhLapDoan: '',
      ngayRaQuyetDinhThanhLapDoan: '',

      chuyenCoQuanDieuTra: false,
      phatHienThamNhung: false,
      viPham: false,
      showFile: false,

      caNhanXuLyHanhChinhThamNhung: 0,
      caNhanXuLyHanhChinhViPham: 0,
      canCuThanhTraDotXuat: '',
      canCuThanhTraLai: '',

      coQuanDieuTra: '',
      datDaThu: 0,
      datKhongDungMDSaiQD: 0,
      datKienNghiThuHoi: 0,
      datLanChiem: 0,
      datThamNhung: 0,
      datThuTrongQuaTrinhThanhTra: 0,
      datThuViPham: 0,
      datTraKienNghiKhac: 0,
      datTraKienNghiThuHoi: 0,
      doiTuongThanhTra: '',
      doiTuongThanhTraLienQuan: '',
      doiTuongViPham: '',
      donViBanHanh: '',
      donViChuTri: '',
      hinhThucThanhTra: '',
      kyThanhTra: '',
      linhVucThanhTra: 'HANH_CHINH',
      loaiHinhThanhTra: '',
      ngayBanHanhKetLuanThanhTra: '',
      ngayCongBoQuyetDinhThanhTra: '',
      ngayHetHanGiaHanThanhTra: '',
      ngayRaQuyetDinh: '',
      noiDungThanhTra: '',

      soDoiTuongDieuTra: 0,
      soDoiTuongThamNhung: 0,
      soKetLuanThanhTra: '',
      soNguoiXuLyTrachNhiemDungDau: 0,
      soQuyetDinhVeViecThanhTra: '',
      soTienXuPhatViPham: 0,
      soVuDieuTra: 0,
      soVuThamNhung: 0,
      taiSanKhacDaThu: 0,
      taiSanKhacKienNghiThuHoi: 0,
      taiSanKhacThamNhung: 0,
      ten: '',
      tenNguoi: '',
      thongBaoKetThuc: '',
      tienDaThu: 0,
      tienDoThanhTra: '',
      tienKienNghiThuHoi: 0,
      tienThamNhung: 0,
      tienThuTrongQuaTrinhThanhTra: 0,
      tienThuViPham: 0,
      tienTraKienNghiKhac: 0,
      tienTraKienNghiThuHoi: 0,
      toChucXuLyHanhChinhThamNhung: 0,
      toChucXuLyHanhChinhViPham: 0,
      tomTatKetLuanThanhTra: '',
      giaoDatCapDatSaiDoiTuong: 0,
      capBanDatTraiThamQuyen: 0,
      capGCNQSDDatSai: 0,
      choThueKhongDungQD: 0,
      boHoangHoa: 0,
      viPhamKhac: 0,
      soViPham: 0,
      soQDXuPhatHCDuocBanHanh: 0,
      soTienViPham: 0,
      soTienKienNghiThuHoi: 0,
      soTienTichThuXuLyTaiSanViPham: 0,
      soTienTieuHuyXuLyTaiSanViPham: 0,
      ngayHetHanThanhTraISO: '',
      getThoiHanThanhTra: false,
      isKiemTra: false
    };
    return _this;
  }

  _createClass(ThemMoiCuocThanhTra, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.determinativeVaiTro();
    }
  }, {
    key: 'determinativeVaiTro',
    value: function determinativeVaiTro() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (typeof userInfo == 'undefined') {
        _reactRouter.browserHistory.push('/');
      } else {
        this.setState({
          donViChuTri: userInfo.donViId
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCanCuThanhTraLai();
      this.getLinhVucThanhTra();
      this.getDonViChuTri();
      this.getTienDoThanhTra();
      this.getCoQuanDieuTra();
      this.getDonViBanHanh();
      this.getLoaiHinhThanhTra();
      this.getDoiTuongThanhTra();
      this.getHinhThucThanhTra();
      this.getVaiTroThanhVienDoan();
      if (this.state.dotXuat) {
        this.getDetail(this.state.id);
      } else {
        this.setState({
          showFile: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dotXuat: nextProps.dotXuat,
        id: nextProps.params.id
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this2 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          var dataCanCuThanhTraLai = [];
          var dataDonViThanhTraLienQuan = [];
          var dataDonViPhoiHop = [];
          var dataDonViViPham = [];
          var dataSelectDonViViPham = [];
          if (Data.canCuThanhTraLai) {
            var data = Data.canCuThanhTraLai.split('; ');
            data.map(function (state) {
              dataCanCuThanhTraLai[dataCanCuThanhTraLai.length] = {
                ten: state
              };
            });
          }
          if (Data.doiTuongViPham) {
            var _data2 = Data.doiTuongViPham.split('; ');
            _data2.map(function (state) {
              dataDonViViPham[dataDonViViPham.length] = {
                ten: state
              };
            });
          }
          if (Data.doiTuongThanhTraLienQuan) {
            var _data3 = Data.doiTuongThanhTraLienQuan.split('; ');
            _data3.map(function (state) {
              dataDonViThanhTraLienQuan[dataDonViThanhTraLienQuan.length] = {
                ten: state
              };
            });
          }
          if (Data.donViPhoiHop) {
            var _data4 = Data.donViPhoiHop.split('; ');
            _data4.map(function (state) {
              dataDonViPhoiHop[dataDonViPhoiHop.length] = {
                ten: state
              };
            });
          }
          if (dataDonViThanhTraLienQuan.length > 0) {
            dataDonViThanhTraLienQuan.map(function (state) {
              dataSelectDonViViPham[dataSelectDonViViPham.length] = {
                giaTri: state.ten,
                ten: state.ten
              };
            });
          }
          _this2.setState({
            dataDetail: Data,
            ten: Data.ten ? Data.ten : '',
            doiTuongThanhTra: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.doiTuongThanhTraId : '',
            kyThanhTra: Data.kyThanhTra ? Data.kyThanhTra : '',
            noiDungThanhTra: Data.noiDungThanhTra ? Data.noiDungThanhTra : '',
            soQuyetDinhVeViecThanhTra: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '',
            ngayRaQuyetDinh: Data.ngayRaQuyetDinh ? new Date(Data.ngayRaQuyetDinh) : '',
            loaiHinhThanhTra: Data.loaiHinhThanhTra ? Data.loaiHinhThanhTra : '',
            danhSachCanCuThanhTraLai: dataCanCuThanhTraLai,
            phatHienThamNhung: Data.phatHienThamNhung,
            viPham: Data.viPham,

            ngayCongBoQuyetDinhThanhTra: Data.ngayCongBoQuyetDinhThanhTra ? new Date(Data.ngayCongBoQuyetDinhThanhTra) : '',
            thoiHanThanhTra: Data.thoiHanThanhTra ? Data.thoiHanThanhTra : '',
            hinhThucThanhTra: Data.hinhThucThanhTra ? Data.hinhThucThanhTra : '',
            linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '',
            canCuThanhTraDotXuat: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '',
            donViChuTri: Data.donViChuTriInfo ? Data.donViChuTriInfo.coQuanQuanLyId : '',
            danhSachDonViPhoiHop: dataDonViPhoiHop,

            danhSachDonViThanhTra: dataDonViThanhTraLienQuan,
            tienDoThanhTra: Data.tienDoThanhTra ? Data.tienDoThanhTra : '',
            soKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '',
            ngayBanHanhKetLuanThanhTra: Data.ngayBanHanhKetLuanThanhTra ? new Date(Data.ngayBanHanhKetLuanThanhTra) : '',
            donViBanHanh: Data.donViBanHanh ? Data.donViBanHanh : '',
            tomTatKetLuanThanhTra: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '',

            listTaiLieuVanThuKetLuanThanhTra: Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : [],
            listTaiLieuVanThu: Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : [],

            chuyenCoQuanDieuTra: Data.chuyenCoQuanDieuTra,
            coQuanDieuTra: Data.coQuanDieuTraInfo ? Data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuDieuTra: Data.soVuDieuTra ? Data.soVuDieuTra : 0,
            soDoiTuongDieuTra: Data.soDoiTuongDieuTra ? Data.soDoiTuongDieuTra : 0,

            tienThuViPham: Data.tienThuViPham ? Data.tienThuViPham : 0,
            datThuViPham: Data.datThuViPham ? Data.datThuViPham : 0,
            tienTraKienNghiThuHoi: Data.tienTraKienNghiThuHoi ? Data.tienTraKienNghiThuHoi : 0,
            datTraKienNghiThuHoi: Data.datTraKienNghiThuHoi ? Data.datTraKienNghiThuHoi : 0,
            tienTraKienNghiKhac: Data.tienTraKienNghiKhac ? Data.tienTraKienNghiKhac : 0,
            datTraKienNghiKhac: Data.datTraKienNghiKhac ? Data.datTraKienNghiKhac : 0,
            toChucXuLyHanhChinhViPham: Data.toChucXuLyHanhChinhViPham ? Data.toChucXuLyHanhChinhViPham : 0,
            caNhanXuLyHanhChinhViPham: Data.caNhanXuLyHanhChinhViPham ? Data.caNhanXuLyHanhChinhViPham : 0,
            tienThuTrongQuaTrinhThanhTra: Data.tienThuTrongQuaTrinhThanhTra ? Data.tienThuTrongQuaTrinhThanhTra : 0,
            datThuTrongQuaTrinhThanhTra: Data.datThuTrongQuaTrinhThanhTra ? Data.datThuTrongQuaTrinhThanhTra : 0,
            danhSachDonViViPham: dataDonViViPham,
            dataDonViViPham: dataSelectDonViViPham,

            soVuThamNhung: Data.soVuThamNhung ? Data.soVuThamNhung : 0,
            soDoiTuongThamNhung: Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : 0,
            tienThamNhung: Data.tienThamNhung ? Data.tienThamNhung : 0,
            taiSanKhacThamNhung: Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : 0,
            datThamNhung: Data.datThamNhung ? Data.datThamNhung : 0,
            tienKienNghiThuHoi: Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : 0,
            taiSanKhacKienNghiThuHoi: Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : 0,
            datKienNghiThuHoi: Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : 0,
            tienDaThu: Data.tienDaThu ? Data.tienDaThu : 0,
            taiSanKhacDaThu: Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : 0,
            datDaThu: Data.datDaThu ? Data.datDaThu : 0,
            toChucXuLyHanhChinhThamNhung: Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : 0,
            caNhanXuLyHanhChinhThamNhung: Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : 0,
            soNguoiXuLyTrachNhiemDungDau: Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : 0,
            tenNguoi: Data.tenNguoi ? Data.tenNguoi : '',
            showFile: true,
            ngayHetHanThanhTra: Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '',
            ngayHetHanThanhTraISO: Data.ngayHetHanThanhTra ? Data.ngayHetHanThanhTra : null,

            thanhLapDoan: Data.thanhLapDoan,
            soQuyetDinhThanhLapDoan: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '',
            ngayRaQuyetDinhThanhLapDoan: Data.ngayRaQuyetDinhThanhLapDoan ? new Date(Data.ngayRaQuyetDinhThanhLapDoan) : '',
            dataThanhVienDoan: Data.listThanhVienDoan ? Data.listThanhVienDoan : [],

            datLanChiem: Data.datLanChiem ? Data.datLanChiem : 0,
            giaoDatCapDatSaiDoiTuong: Data.giaoDatCapDatSaiDoiTuong ? Data.giaoDatCapDatSaiDoiTuong : 0,
            capBanDatTraiThamQuyen: Data.capBanDatTraiThamQuyen ? Data.capBanDatTraiThamQuyen : 0,
            capGCNQSDDatSai: Data.capGCNQSDDatSai ? Data.capGCNQSDDatSai : 0,
            choThueKhongDungQD: Data.choThueKhongDungQD ? Data.choThueKhongDungQD : 0,
            datKhongDungMDSaiQD: Data.datKhongDungMDSaiQD ? Data.datKhongDungMDSaiQD : 0,
            boHoangHoa: Data.boHoangHoa ? Data.boHoangHoa : 0,
            viPhamKhac: Data.viPhamKhac ? Data.viPhamKhac : 0,
            soViPham: Data.soViPham ? Data.soViPham : 0,
            soQDXuPhatHCDuocBanHanh: Data.soQDXuPhatHCDuocBanHanh ? Data.soQDXuPhatHCDuocBanHanh : 0,
            soTienViPham: Data.soTienViPham ? Data.soTienViPham : 0,
            soTienXuPhatViPham: Data.soTienXuPhatViPham ? Data.soTienXuPhatViPham : 0,
            soTienKienNghiThuHoi: Data.soTienKienNghiThuHoi ? Data.soTienKienNghiThuHoi : 0,
            soTienTichThuXuLyTaiSanViPham: Data.soTienTichThuXuLyTaiSanViPham ? Data.soTienTichThuXuLyTaiSanViPham : 0,
            soTienTieuHuyXuLyTaiSanViPham: Data.soTienTieuHuyXuLyTaiSanViPham ? Data.soTienTieuHuyXuLyTaiSanViPham : 0,
            isKiemTra: Data.loaiCuoc.value === 'KIEM_TRA'
          });
        }
      });
    }
  }, {
    key: 'getCanCuThanhTraLai',
    value: function getCanCuThanhTraLai() {
      var _this3 = this;

      _api.ThanhTra.actions.getCanCuThanhTraLai.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataThanhTraLai: res.data
          });
        }
      });
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this4 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataLinhVucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this5 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data._embedded) {
          _this5.setState({
            dataDonViChuTri: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getTienDoThanhTra',
    value: function getTienDoThanhTra() {
      var _this6 = this;

      _api.ThanhTra.actions.getTienDoThanhTra.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            dataTienDoThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getCoQuanDieuTra',
    value: function getCoQuanDieuTra() {
      var _this7 = this;

      _api.ThanhTra.actions.getCoQuanDieuTra.request().then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            dataCoQuanDieuTra: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getDonViBanHanh',
    value: function getDonViBanHanh() {
      var _this8 = this;

      _api.ThanhTra.actions.getListDonViBanHanh.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            dataDonViBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiHinhThanhTra',
    value: function getLoaiHinhThanhTra() {
      var _this9 = this;

      _api.ThanhTra.actions.getLoaiHinhThanhTra.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataLoaiHinhThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getDoiTuongThanhTra',
    value: function getDoiTuongThanhTra() {
      var _this10 = this;

      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      _api.ThanhTra.actions.getDoiTuongThanhTra.request({ namThanhTra: getNamTT }).then(function (res) {
        if (res.data._embedded) {
          _this10.setState({
            dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThanhTra',
    value: function getHinhThucThanhTra() {
      var _this11 = this;

      _api.ThanhTra.actions.getHinhThucThanhTra.request().then(function (res) {
        if (res.data) {
          _this11.setState({
            dataHinhThucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getVaiTroThanhVienDoan',
    value: function getVaiTroThanhVienDoan() {
      var _this12 = this;

      _api.ThanhTra.actions.getVaiTroThanhVienDoan.request().then(function (res) {
        if (res.data) {
          _this12.setState({
            dataVaiTroThanhVienDoan: res.data
          });
        }
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this13 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var params = this.getParams();
        _api.ThanhTra.actions.postCuocThanhTra.request('', params).then(function (res) {
          if (res.data) {
            var idCuocThanhTra = res.data.cuocThanhTraId;
            _this13.pushTaiLieu(idCuocThanhTra);
            _this13.onClickClose();
            (0, _toastr.Toastr)(_message.msg.saveCuocTTSuccess, 'success');
          }
        }).catch(function (error) {
          if (error.response.data.errors) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this13.setState({
            btnLoading: false,
            btnSaveLoading: false
          });
        });
      }
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id) {
      var _this14 = this;

      var dataFileDinhKem = this.getListDataFileDinhKem();

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this14.state.taiLieuVanThuUpdate[_this14.state.taiLieuVanThuUpdate.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this14.state.taiLieuVanThu[_this14.state.taiLieuVanThu.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this14.state.taiLieuVanThuDelete[_this14.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }

      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }

      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var donViPhoiHop = '';
      var donViThanhTra = '';
      var donViViPham = '';
      var canCuThanhTraLai = '';

      if (this.state.danhSachDonViPhoiHop.length > 0) {
        this.state.danhSachDonViPhoiHop.map(function (state, index) {
          if (index == 0) {
            donViPhoiHop = donViPhoiHop + state.ten;
          } else {
            donViPhoiHop = donViPhoiHop + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachDonViThanhTra.length > 0) {
        this.state.danhSachDonViThanhTra.map(function (state, index) {
          if (index == 0) {
            donViThanhTra = donViThanhTra + state.ten;
          } else {
            donViThanhTra = donViThanhTra + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachDonViViPham.length > 0) {
        this.state.danhSachDonViViPham.map(function (state, index) {
          if (index == 0) {
            donViViPham = donViViPham + state.ten;
          } else {
            donViViPham = donViViPham + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachCanCuThanhTraLai.length > 0) {
        this.state.danhSachCanCuThanhTraLai.map(function (state, index) {
          if (index == 0) {
            canCuThanhTraLai = canCuThanhTraLai + state.ten;
          } else {
            canCuThanhTraLai = canCuThanhTraLai + '; ' + state.ten;
          }
        });
      }

      var params = {
        ten: this.state.ten ? this.state.ten : '',
        doiTuongThanhTra: {
          id: Number(this.state.doiTuongThanhTra)
        },
        kyThanhTra: this.state.kyThanhTra ? this.state.kyThanhTra : '',
        noiDungThanhTra: this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '',
        soQuyetDinhVeViecThanhTra: this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '',
        ngayRaQuyetDinh: this.state.ngayRaQuyetDinh ? (0, _moment2.default)(this.state.ngayRaQuyetDinh).add(7, 'hours').toISOString() : null,
        loaiHinhThanhTra: this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null,
        ngayCongBoQuyetDinhThanhTra: this.state.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString() : null,
        thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
        hinhThucThanhTra: this.state.hinhThucThanhTra ? this.state.hinhThucThanhTra : null,
        linhVucThanhTra: this.state.linhVucThanhTra ? this.state.linhVucThanhTra : null,
        donViPhoiHop: donViPhoiHop,
        doiTuongThanhTraLienQuan: donViThanhTra,
        tienDoThanhTra: this.state.tienDoThanhTra ? this.state.tienDoThanhTra : null,
        soKetLuanThanhTra: this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '',
        tomTatKetLuanThanhTra: this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '',
        ngayBanHanhKetLuanThanhTra: this.state.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(this.state.ngayBanHanhKetLuanThanhTra).add(7, 'hours').toISOString() : null,
        donViBanHanh: this.state.donViBanHanh ? this.state.donViBanHanh : null
      };

      params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;

      if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
        params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
      } else {
        params.canCuThanhTraDotXuat = '';
      }

      if (this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
        params.canCuThanhTraLai = canCuThanhTraLai;
      } else {
        params.canCuThanhTraLai = '';
      }

      if (this.state.donViChuTri) {
        params.donViChuTri = {
          id: Number(this.state.donViChuTri)
        };
      } else {
        params.donViChuTri = null;
      }

      if (this.state.chuyenCoQuanDieuTra) {
        params.chuyenCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        } else {
          params.coQuanDieuTra = null;
        }
        params.soVuDieuTra = this.state.soVuDieuTra ? Number(this.state.soVuDieuTra) : 0;
        params.soDoiTuongDieuTra = this.state.soDoiTuongDieuTra ? Number(this.state.soDoiTuongDieuTra) : 0;
      } else {
        params.chuyenCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuDieuTra = 0;
        params.soDoiTuongDieuTra = 0;
      }

      if (this.state.viPham) {
        params.viPham = true;
        params.tienThuViPham = this.state.tienThuViPham ? this.state.tienThuViPham : 0;
        params.datThuViPham = this.state.datThuViPham ? this.state.datThuViPham : 0;
        params.datLanChiem = this.state.datLanChiem ? this.state.datLanChiem : 0;
        params.giaoDatCapDatSaiDoiTuong = this.state.giaoDatCapDatSaiDoiTuong ? this.state.giaoDatCapDatSaiDoiTuong : 0;
        params.capBanDatTraiThamQuyen = this.state.capBanDatTraiThamQuyen ? this.state.capBanDatTraiThamQuyen : 0;
        params.capGCNQSDDatSai = this.state.capGCNQSDDatSai ? this.state.capGCNQSDDatSai : 0;
        params.choThueKhongDungQD = this.state.choThueKhongDungQD ? this.state.choThueKhongDungQD : 0;
        params.datKhongDungMDSaiQD = this.state.datKhongDungMDSaiQD ? this.state.datKhongDungMDSaiQD : 0;
        params.boHoangHoa = this.state.boHoangHoa ? this.state.boHoangHoa : 0;
        params.viPhamKhac = this.state.viPhamKhac ? this.state.viPhamKhac : 0;
        params.tienTraKienNghiThuHoi = this.state.tienTraKienNghiThuHoi ? this.state.tienTraKienNghiThuHoi : 0;
        params.datTraKienNghiThuHoi = this.state.datTraKienNghiThuHoi ? this.state.datTraKienNghiThuHoi : 0;
        params.tienTraKienNghiKhac = this.state.tienTraKienNghiKhac ? this.state.tienTraKienNghiKhac : 0;
        params.datTraKienNghiKhac = this.state.datTraKienNghiKhac ? this.state.datTraKienNghiKhac : 0;
        params.toChucXuLyHanhChinhViPham = this.state.toChucXuLyHanhChinhViPham ? this.state.toChucXuLyHanhChinhViPham : 0;
        params.caNhanXuLyHanhChinhViPham = this.state.caNhanXuLyHanhChinhViPham ? this.state.caNhanXuLyHanhChinhViPham : 0;
        params.tienThuTrongQuaTrinhThanhTra = this.state.tienThuTrongQuaTrinhThanhTra ? this.state.tienThuTrongQuaTrinhThanhTra : 0;
        params.datThuTrongQuaTrinhThanhTra = this.state.datThuTrongQuaTrinhThanhTra ? this.state.datThuTrongQuaTrinhThanhTra : 0;
        params.soViPham = this.state.soViPham ? this.state.soViPham : 0;
        params.soQDXuPhatHCDuocBanHanh = this.state.soQDXuPhatHCDuocBanHanh ? this.state.soQDXuPhatHCDuocBanHanh : 0;
        params.soTienViPham = this.state.soTienViPham ? this.state.soTienViPham : 0;
        params.soTienXuPhatViPham = this.state.soTienXuPhatViPham ? this.state.soTienXuPhatViPham : 0;
        params.soTienKienNghiThuHoi = this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0;
        params.soTienTichThuXuLyTaiSanViPham = this.state.soTienTichThuXuLyTaiSanViPham ? this.state.soTienTichThuXuLyTaiSanViPham : 0;
        params.soTienTieuHuyXuLyTaiSanViPham = this.state.soTienTieuHuyXuLyTaiSanViPham ? this.state.soTienTieuHuyXuLyTaiSanViPham : 0;
        params.doiTuongViPham = donViViPham;
      } else {
        params.viPham = false;
        params.tienThuViPham = 0;
        params.datThuViPham = 0;
        params.datLanChiem = 0;
        params.giaoDatCapDatSaiDoiTuong = 0;
        params.capBanDatTraiThamQuyen = 0;
        params.capGCNQSDDatSai = 0;
        params.choThueKhongDungQD = 0;
        params.datKhongDungMDSaiQD = 0;
        params.boHoangHoa = 0;
        params.viPhamKhac = 0;
        params.tienTraKienNghiThuHoi = 0;
        params.datTraKienNghiThuHoi = 0;
        params.tienTraKienNghiKhac = 0;
        params.datTraKienNghiKhac = 0;
        params.toChucXuLyHanhChinhViPham = 0;
        params.caNhanXuLyHanhChinhViPham = 0;
        params.tienThuTrongQuaTrinhThanhTra = 0;
        params.datThuTrongQuaTrinhThanhTra = 0;
        params.soViPham = 0;
        params.soQDXuPhatHCDuocBanHanh = 0;
        params.soTienViPham = 0;
        params.soTienXuPhatViPham = 0;
        params.soTienKienNghiThuHoi = 0;
        params.soTienTichThuXuLyTaiSanViPham = 0;
        params.soTienTieuHuyXuLyTaiSanViPham = 0;
        params.doiTuongViPham = '';
      }

      if (this.state.phatHienThamNhung) {
        params.phatHienThamNhung = true;
        params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
        params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
        params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
        params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
        params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
        params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
        params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
        params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
        params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
        params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
        params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
        params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
        params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
        params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
        params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
      } else {
        params.phatHienThamNhung = false;
        params.soVuThamNhung = 0;
        params.soDoiTuongThamNhung = 0;
        params.tienThamNhung = 0;
        params.taiSanKhacThamNhung = 0;
        params.datThamNhung = 0;
        params.tienKienNghiThuHoi = 0;
        params.taiSanKhacKienNghiThuHoi = 0;
        params.datKienNghiThuHoi = 0;
        params.tienDaThu = 0;
        params.taiSanKhacDaThu = 0;
        params.datDaThu = 0;
        params.toChucXuLyHanhChinhThamNhung = 0;
        params.caNhanXuLyHanhChinhThamNhung = 0;
        params.soNguoiXuLyTrachNhiemDungDau = 0;
        params.tenNguoi = '';
      }

      if (this.state.thanhLapDoan && this.state.linhVucThanhTra == 'CHUYEN_NGANH') {
        params.thanhLapDoan = true;
        params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
        params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : '';
        params.thanhVienDoans = this.state.dataThanhVienDoan;
      } else {
        params.thanhLapDoan = false;
        params.soQuyetDinhThanhLapDoan = '';
        params.ngayRaQuyetDinhThanhLapDoan = null;
        params.thanhVienDoans = [];
      }

      return params;
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra;
      return result;
    }
  }, {
    key: 'handleSaveExistElement',
    value: function handleSaveExistElement() {
      var _this15 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        var params = this.getParamsExistElement();
        params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
        _api.ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
          if (res.data) {
            _this15.pushTaiLieu(_this15.state.id);
            _this15.onClickClose();
            (0, _toastr.Toastr)(_message.msg.saveCuocTTSuccess, 'success');
          }
        }).catch(function (error) {
          if (error.response.data.errors) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this15.setState({
            btnLoading: false,
            btnSaveLoading: false
          });
        });
      }
    }
  }, {
    key: 'getParamsExistElement',
    value: function getParamsExistElement() {

      var donViPhoiHop = '';
      var donViThanhTra = '';
      var donViViPham = '';
      var canCuThanhTraLai = '';

      if (this.state.danhSachDonViPhoiHop.length > 0) {
        this.state.danhSachDonViPhoiHop.map(function (state, index) {
          if (index == 0) {
            donViPhoiHop = donViPhoiHop + state.ten;
          } else {
            donViPhoiHop = donViPhoiHop + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachDonViThanhTra.length > 0) {
        this.state.danhSachDonViThanhTra.map(function (state, index) {
          if (index == 0) {
            donViThanhTra = donViThanhTra + state.ten;
          } else {
            donViThanhTra = donViThanhTra + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachDonViViPham.length > 0) {
        this.state.danhSachDonViViPham.map(function (state, index) {
          if (index == 0) {
            donViViPham = donViViPham + state.ten;
          } else {
            donViViPham = donViViPham + '; ' + state.ten;
          }
        });
      }

      if (this.state.danhSachCanCuThanhTraLai.length > 0) {
        this.state.danhSachCanCuThanhTraLai.map(function (state, index) {
          if (index == 0) {
            canCuThanhTraLai = canCuThanhTraLai + state.ten;
          } else {
            canCuThanhTraLai = canCuThanhTraLai + '; ' + state.ten;
          }
        });
      }

      var params = this.state.dataDetail;

      params.ten = this.state.ten ? this.state.ten : '';
      params.doiTuongThanhTra = {
        id: Number(this.state.doiTuongThanhTra)
      };
      params.kyThanhTra = this.state.kyThanhTra ? this.state.kyThanhTra : '';
      params.noiDungThanhTra = this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '';
      params.soQuyetDinhVeViecThanhTra = this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '';
      params.ngayRaQuyetDinh = this.state.ngayRaQuyetDinh ? (0, _moment2.default)(this.state.ngayRaQuyetDinh).add(7, 'hours').toISOString() : null;
      params.loaiHinhThanhTra = this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null;
      params.ngayCongBoQuyetDinhThanhTra = this.state.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString() : null;
      params.thoiHanThanhTra = this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0;
      params.linhVucThanhTra = this.state.linhVucThanhTra ? this.state.linhVucThanhTra : null;
      params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
      params.donViPhoiHop = donViPhoiHop;
      params.doiTuongThanhTraLienQuan = donViThanhTra;
      params.tienDoThanhTra = this.state.tienDoThanhTra ? this.state.tienDoThanhTra : null;
      params.soKetLuanThanhTra = this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '';
      params.tomTatKetLuanThanhTra = this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '';
      params.ngayBanHanhKetLuanThanhTra = this.state.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(this.state.ngayBanHanhKetLuanThanhTra).add(7, 'hours').toISOString() : null;
      params.donViBanHanh = this.state.donViBanHanh ? this.state.donViBanHanh : null;

      params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;

      if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
        params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
      } else {
        params.canCuThanhTraDotXuat = '';
      }

      if (this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
        params.canCuThanhTraLai = canCuThanhTraLai;
      } else {
        params.canCuThanhTraLai = '';
      }

      if (this.state.donViChuTri) {
        params.donViChuTri = {
          id: Number(this.state.donViChuTri)
        };
      } else {
        params.donViChuTri = null;
      }

      if (this.state.chuyenCoQuanDieuTra) {
        params.chuyenCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra = {
            id: Number(this.state.coQuanDieuTra)
          };
        } else {
          params.coQuanDieuTra = null;
        }
        params.soVuDieuTra = this.state.soVuDieuTra ? Number(this.state.soVuDieuTra) : 0;
        params.soDoiTuongDieuTra = this.state.soDoiTuongDieuTra ? Number(this.state.soDoiTuongDieuTra) : 0;
      } else {
        params.chuyenCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuDieuTra = 0;
        params.soDoiTuongDieuTra = 0;
      }

      if (this.state.viPham) {
        params.viPham = true;
        params.tienThuViPham = this.state.tienThuViPham ? this.state.tienThuViPham : 0;
        params.datThuViPham = this.state.datThuViPham ? this.state.datThuViPham : 0;
        params.datLanChiem = this.state.datLanChiem ? this.state.datLanChiem : 0;
        params.giaoDatCapDatSaiDoiTuong = this.state.giaoDatCapDatSaiDoiTuong ? this.state.giaoDatCapDatSaiDoiTuong : 0;
        params.capBanDatTraiThamQuyen = this.state.capBanDatTraiThamQuyen ? this.state.capBanDatTraiThamQuyen : 0;
        params.capGCNQSDDatSai = this.state.capGCNQSDDatSai ? this.state.capGCNQSDDatSai : 0;
        params.choThueKhongDungQD = this.state.choThueKhongDungQD ? this.state.choThueKhongDungQD : 0;
        params.datKhongDungMDSaiQD = this.state.datKhongDungMDSaiQD ? this.state.datKhongDungMDSaiQD : 0;
        params.boHoangHoa = this.state.boHoangHoa ? this.state.boHoangHoa : 0;
        params.viPhamKhac = this.state.viPhamKhac ? this.state.viPhamKhac : 0;
        params.tienTraKienNghiThuHoi = this.state.tienTraKienNghiThuHoi ? this.state.tienTraKienNghiThuHoi : 0;
        params.datTraKienNghiThuHoi = this.state.datTraKienNghiThuHoi ? this.state.datTraKienNghiThuHoi : 0;
        params.tienTraKienNghiKhac = this.state.tienTraKienNghiKhac ? this.state.tienTraKienNghiKhac : 0;
        params.datTraKienNghiKhac = this.state.datTraKienNghiKhac ? this.state.datTraKienNghiKhac : 0;
        params.toChucXuLyHanhChinhViPham = this.state.toChucXuLyHanhChinhViPham ? this.state.toChucXuLyHanhChinhViPham : 0;
        params.caNhanXuLyHanhChinhViPham = this.state.caNhanXuLyHanhChinhViPham ? this.state.caNhanXuLyHanhChinhViPham : 0;
        params.tienThuTrongQuaTrinhThanhTra = this.state.tienThuTrongQuaTrinhThanhTra ? this.state.tienThuTrongQuaTrinhThanhTra : 0;
        params.datThuTrongQuaTrinhThanhTra = this.state.datThuTrongQuaTrinhThanhTra ? this.state.datThuTrongQuaTrinhThanhTra : 0;
        params.soViPham = this.state.soViPham ? this.state.soViPham : 0;
        params.soQDXuPhatHCDuocBanHanh = this.state.soQDXuPhatHCDuocBanHanh ? this.state.soQDXuPhatHCDuocBanHanh : 0;
        params.soTienViPham = this.state.soTienViPham ? this.state.soTienViPham : 0;
        params.soTienXuPhatViPham = this.state.soTienXuPhatViPham ? this.state.soTienXuPhatViPham : 0;
        params.soTienKienNghiThuHoi = this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0;
        params.soTienTichThuXuLyTaiSanViPham = this.state.soTienTichThuXuLyTaiSanViPham ? this.state.soTienTichThuXuLyTaiSanViPham : 0;
        params.soTienTieuHuyXuLyTaiSanViPham = this.state.soTienTieuHuyXuLyTaiSanViPham ? this.state.soTienTieuHuyXuLyTaiSanViPham : 0;
        params.doiTuongViPham = donViViPham;
      } else {
        params.viPham = false;
        params.tienThuViPham = 0;
        params.datThuViPham = 0;
        params.datLanChiem = 0;
        params.giaoDatCapDatSaiDoiTuong = 0;
        params.capBanDatTraiThamQuyen = 0;
        params.capGCNQSDDatSai = 0;
        params.choThueKhongDungQD = 0;
        params.datKhongDungMDSaiQD = 0;
        params.boHoangHoa = 0;
        params.viPhamKhac = 0;
        params.tienTraKienNghiThuHoi = 0;
        params.datTraKienNghiThuHoi = 0;
        params.tienTraKienNghiKhac = 0;
        params.datTraKienNghiKhac = 0;
        params.toChucXuLyHanhChinhViPham = 0;
        params.caNhanXuLyHanhChinhViPham = 0;
        params.tienThuTrongQuaTrinhThanhTra = 0;
        params.datThuTrongQuaTrinhThanhTra = 0;
        params.soViPham = 0;
        params.soQDXuPhatHCDuocBanHanh = 0;
        params.soTienViPham = 0;
        params.soTienXuPhatViPham = 0;
        params.soTienKienNghiThuHoi = 0;
        params.soTienTichThuXuLyTaiSanViPham = 0;
        params.soTienTieuHuyXuLyTaiSanViPham = 0;
        params.doiTuongViPham = '';
      }

      if (this.state.phatHienThamNhung) {
        params.phatHienThamNhung = true;
        params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
        params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
        params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
        params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
        params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
        params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
        params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
        params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
        params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
        params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
        params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
        params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
        params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
        params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
        params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
      } else {
        params.phatHienThamNhung = false;
        params.soVuThamNhung = 0;
        params.soDoiTuongThamNhung = 0;
        params.tienThamNhung = 0;
        params.taiSanKhacThamNhung = 0;
        params.datThamNhung = 0;
        params.tienKienNghiThuHoi = 0;
        params.taiSanKhacKienNghiThuHoi = 0;
        params.datKienNghiThuHoi = 0;
        params.tienDaThu = 0;
        params.taiSanKhacDaThu = 0;
        params.datDaThu = 0;
        params.toChucXuLyHanhChinhThamNhung = 0;
        params.caNhanXuLyHanhChinhThamNhung = 0;
        params.soNguoiXuLyTrachNhiemDungDau = 0;
        params.tenNguoi = '';
      }

      if (this.state.thanhLapDoan && this.state.linhVucThanhTra == 'CHUYEN_NGANH') {
        params.thanhLapDoan = true;
        params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
        params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : '';
        params.thanhVienDoans = this.state.dataThanhVienDoan;
      } else {
        params.thanhLapDoan = false;
        params.soQuyetDinhThanhLapDoan = '';
        params.ngayRaQuyetDinhThanhLapDoan = null;
        params.thanhVienDoans = [];
      }

      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['coQuanDieuTraInfo'];
      delete params['doiTuongThanhTraInfo'];
      delete params['donViChuTriInfo'];
      delete params['donViInfo'];
      delete params['hinhThucThanhTraInfo'];
      delete params['linhVucThanhTraInfo'];
      delete params['loaiHinhThanhTraInfo'];
      delete params['listTaiLieuVanThu'];
      delete params['listTaiLieuVanThuGiaHan'];
      delete params['listTaiLieuVanThuKetLuanThanhTra'];
      delete params['cuocThanhTraId'];
      delete params['listThanhVienDoan'];
      delete params['tienDoThanhTraInfo'];

      return params;
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.ketLuanTranhTra.length > 0) {
        Data.ketLuanTranhTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        tienThuViPham: 0,
        datThuViPham: 0,
        datLanChiem: 0,
        giaoDatCapDatSaiDoiTuong: 0,
        capBanDatTraiThamQuyen: 0,
        capGCNQSDDatSai: 0,
        choThueKhongDungQD: 0,
        datKhongDungMDSaiQD: 0,
        boHoangHoa: 0,
        viPhamKhac: 0,
        tienTraKienNghiThuHoi: 0,
        datTraKienNghiThuHoi: 0,
        tienTraKienNghiKhac: 0,
        datTraKienNghiKhac: 0,
        toChucXuLyHanhChinhViPham: 0,
        caNhanXuLyHanhChinhViPham: 0,
        tienThuTrongQuaTrinhThanhTra: 0,
        datThuTrongQuaTrinhThanhTra: 0,
        soViPham: 0,
        soQDXuPhatHCDuocBanHanh: 0,
        soTienViPham: 0,
        soTienXuPhatViPham: 0,
        soTienKienNghiThuHoi: 0,
        soTienTichThuXuLyTaiSanViPham: 0,
        soTienTieuHuyXuLyTaiSanViPham: 0,
        doiTuongViPham: ''
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this16 = this;

      if (name == 'thoiHanThanhTra') {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          _this16.getThoiHanThanhTra();
        });
      } else if (name == 'canCuThanhTraLai') {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          _this16.addCanCuThanhTra('danhSachCanCuThanhTraLai', 'canCuThanhTraLai', 'dataThanhTraLai');
        });
      } else if (name == 'donViViPham') {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          _this16.addCanCuThanhTra('danhSachDonViViPham', 'donViViPham', 'dataDonViViPham');
        });
      } else if (name == 'doiTuongThanhTra' || name == 'noiDungThanhTra') {
        this.setState(_defineProperty({}, name, e.target.value), function () {
          if (_this16.state.noiDungThanhTra && _this16.state.doiTuongThanhTra) {
            var data = [].concat(_toConsumableArray(_this16.state.dataDoiTuongThanhTra));

            var doiTuongThanhTra = data.filter(function (state) {
              return state.doiTuongThanhTraId == _this16.state.doiTuongThanhTra;
            });

            var tenCuocThanhTra = _this16.state.noiDungThanhTra + ' tại ' + doiTuongThanhTra[0].ten;
            _this16.setState({
              ten: tenCuocThanhTra
            });
          } else if (_this16.state.noiDungThanhTra == '' && _this16.state.doiTuongThanhTra) {
            var _data5 = [].concat(_toConsumableArray(_this16.state.dataDoiTuongThanhTra));

            var _doiTuongThanhTra = _data5.filter(function (state) {
              return state.doiTuongThanhTraId == _this16.state.doiTuongThanhTra;
            });

            var _tenCuocThanhTra = _doiTuongThanhTra[0].ten;
            _this16.setState({
              ten: _tenCuocThanhTra
            });
          } else if (_this16.state.noiDungThanhTra && _this16.state.doiTuongThanhTra == '') {
            var _tenCuocThanhTra2 = _this16.state.noiDungThanhTra;
            _this16.setState({
              ten: _tenCuocThanhTra2
            });
          } else if (_this16.state.noiDungThanhTra == '' && _this16.state.doiTuongThanhTra == '') {
            _this16.setState({
              ten: ''
            });
          }
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this17 = this;

      if (e && e._d) {
        if (name == 'ngayCongBoQuyetDinhThanhTra') {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this17.getThoiHanThanhTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e._d));
        }
      } else {
        if (name == 'ngayCongBoQuyetDinhThanhTra') {
          this.setState(_defineProperty({}, name, e), function () {
            _this17.getThoiHanThanhTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e));
        }
      }
    }
  }, {
    key: 'addCanCuThanhTra',
    value: function addCanCuThanhTra(arr, value, _data) {
      var _this18 = this;

      var data = [].concat(_toConsumableArray(this.state[_data]));

      var valueText = data.filter(function (state) {
        return state.giaTri == _this18.state[value];
      });

      var text = valueText.length > 0 ? valueText[0].ten : '';

      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == text;
      });

      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState11;

          var newItem = {
            ten: text
          };
          this.setState((_setState11 = {}, _defineProperty(_setState11, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState11, value, ''), _setState11));
        }
      }
      return;
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(arr, value, e) {
      var _this19 = this;

      if (typeof e != 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == _this19.state[value];
      });

      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState13;

          if (arr == 'danhSachDonViThanhTra') {
            var Item = {
              giaTri: this.state[value],
              ten: this.state[value]
            };
            this.setState({
              dataDonViViPham: [].concat(_toConsumableArray(this.state.dataDonViViPham), [Item])
            });
          }
          var newItem = {
            ten: this.state[value]
          };
          this.setState((_setState13 = {}, _defineProperty(_setState13, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState13, value, ''), _setState13));
        }
      }
      return;
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (!e) {}
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(arr, index) {
      var _this20 = this;

      var newData = [].concat(_toConsumableArray(this.state[arr]));
      newData.splice(index, 1);
      this.setState(_defineProperty({}, arr, newData));
      if (arr == 'danhSachDonViThanhTra') {
        var data = [].concat(_toConsumableArray(this.state.dataDonViViPham));

        var dataCheck = data.filter(function (state) {
          return state.giaTri != _this20.state.danhSachDonViThanhTra[index].ten;
        });

        var dataSelected = [].concat(_toConsumableArray(this.state.danhSachDonViViPham));

        var newDataSelected = dataSelected.filter(function (state) {
          return state.ten != _this20.state.danhSachDonViThanhTra[index].ten;
        });

        this.setState({
          dataDonViViPham: [].concat(_toConsumableArray(dataCheck)),
          danhSachDonViViPham: [].concat(_toConsumableArray(newDataSelected))
        });
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'KET_LUAN_THANH_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.ketLuanTranhTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      }
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type == 'KET_LUAN_THANH_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.ketLuanTranhTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
    }
  }, {
    key: 'addItem',
    value: function addItem() {
      var newItem = {
        hoVaTen: '',
        donVi: '',
        chucVu: '',
        ngaySinh: '',
        vaiTroThanhVienDoan: ''
      };

      this.setState({
        dataThanhVienDoan: [].concat(_toConsumableArray(this.state.dataThanhVienDoan), [newItem])
      });
    }
  }, {
    key: 'onItemChange',
    value: function onItemChange(data, index) {

      this.state.dataThanhVienDoan[index] = data;
      this.setState({
        dataThanhVienDoan: this.state.dataThanhVienDoan
      });
    }
  }, {
    key: 'onItemRemove',
    value: function onItemRemove(index) {
      var dataThanhVienDoan = [].concat(_toConsumableArray(this.state.dataThanhVienDoan));
      dataThanhVienDoan.splice(index, 1);
      this.setState({
        dataThanhVienDoan: dataThanhVienDoan
      });
    }
  }, {
    key: 'getThoiHanThanhTra',
    value: function getThoiHanThanhTra() {
      var _this21 = this;

      if (this.state.ngayCongBoQuyetDinhThanhTra) {
        this.setState({
          getThoiHanThanhTra: true
        });
        var params = {
          thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
          ngayCongBoQD: (0, _moment2.default)(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString()
        };
        _api.ThanhTra.actions.getThoiHanThanhTra.request('', params).then(function (res) {
          if (res.data) {
            _this21.setState({
              ngayHetHanThanhTra: (0, _moment2.default)(new Date(res.data)).format('DD/MM/YYYY'),
              ngayHetHanThanhTraISO: res.data
            });
            _this21.setState({
              getThoiHanThanhTra: false
            });
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this21.setState({
            getThoiHanThanhTra: false
          });
        });
      } else {
        this.setState({
          ngayHetHanThanhTra: '',
          ngayHetHanThanhTraISO: null
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this22 = this;

      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.dotXuat },
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'Th\xEAm m\u1EDBi cu\u1ED9c thanh tra'
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.dotXuat },
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            _react2.default.createElement(
              'h2',
              { className: 'heading-title icon-add' },
              'Ch\u1EC9nh s\u1EEDa cu\u1ED9c thanh tra'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                'Th\xF4ng tin cu\u1ED9c thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { disabled: true, label: 'T\xEAn cu\u1ED9c thanh tra', className: 'col-50', value: this.state.ten, onChange: this.onChange.bind(this, 'ten'), maxLength: 500 }),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra', data: this.state.dataDoiTuongThanhTra, className: 'col-30', selectedValue: this.state.doiTuongThanhTra, onChange: this.onChange.bind(this, 'doiTuongThanhTra'), require: true, bindValidator: this, keyName: 'doiTuongThanhTraId', valueName: 'ten' }),
              _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi k\u1EF3 thanh tra', placeholder: 'Nh\u1EADp...', className: 'col-20', value: this.state.kyThanhTra, onChange: this.onChange.bind(this, 'kyThanhTra'), maxLength: 255 }),
              _react2.default.createElement(_common.TextArea, { label: 'N\u1ED9i dung thanh tra', className: 'col-100', value: this.state.noiDungThanhTra, onChange: this.onChange.bind(this, 'noiDungThanhTra'), maxLength: 500 })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c thanh tra', className: 'col-25', value: this.state.soQuyetDinhVeViecThanhTra, onChange: this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra'), require: true, bindValidator: this, channel: 'formTaoDon', maxLength: 255 }),
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh', className: 'col-25', value: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh'), require: true, bindValidator: this, channel: 'formTaoDon' }),
              _react2.default.createElement(_ttForms.DropDownChonLoaiHinhThanhTra, { label: 'Lo\u1EA1i h\xECnh', data: this.state.dataLoaiHinhThanhTra, className: 'col-25', selectedValue: this.state.loaiHinhThanhTra, onChange: this.onChange.bind(this, 'loaiHinhThanhTra') }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.loaiHinhThanhTra == 'THANH_TRA_LAI' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachCanCuThanhTraLai', 'canCuThanhTraLai') },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25' },
                    _react2.default.createElement(_ttForms.DropDownChonCanCuThanhTraLai, { label: 'C\u0103n c\u1EE9 thanh tra l\u1EA1i', data: this.state.dataThanhTraLai, className: 'col-100 no-gutter', selectedValue: this.state.canCuThanhTraLai, onChange: this.onChange.bind(this, 'canCuThanhTraLai') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-75 mb18' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ds-tt-dvph' },
                      this.state.danhSachCanCuThanhTraLai.map(function (item, i) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'tt-dvph-item', key: i },
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachCanCuThanhTraLai', i) },
                            '\xD7'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-value' },
                            item.ten
                          )
                        );
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 thanh tra', className: 'col-25', value: this.state.ngayCongBoQuyetDinhThanhTra, onChange: this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra'), require: true, bindValidator: this, channel: 'formTaoDon' }),
              _react2.default.createElement(
                'div',
                { className: 'wrap-thoihan col-25' },
                _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n thanh tra (ng\xE0y)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra') }),
                _react2.default.createElement(
                  'span',
                  { className: 'thoihan-value' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !this.state.getThoiHanThanhTra },
                    _react2.default.createElement(
                      'span',
                      null,
                      this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.getThoiHanThanhTra },
                    _react2.default.createElement('span', { className: 'icon-loader' })
                  )
                )
              ),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'H\xECnh th\u1EE9c', className: 'col-25', data: this.state.dataHinhThucThanhTra, selectedValue: this.state.hinhThucThanhTra, onChange: this.onChange.bind(this, 'hinhThucThanhTra'), keyName: 'giaTri', valueName: 'ten' }),
              _react2.default.createElement(_ttForms.DropDownChonLinhVucThanhTra, { label: 'L\u0129nh v\u1EF1c thanh tra', placeholder: null, className: 'col-25', data: this.state.dataLinhVucThanhTra, selectedValue: this.state.linhVucThanhTra, onChange: this.onChange.bind(this, 'linhVucThanhTra'), require: true }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.hinhThucThanhTra == 'DOT_XUAT' },
                _react2.default.createElement(_common.TextArea, { label: 'C\u0103n c\u1EE9 thanh tra \u0111\u1ED9t xu\u1EA5t', className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.canCuThanhTraDotXuat, onChange: this.onChange.bind(this, 'canCuThanhTraDotXuat'), maxLength: 500 })
              ),
              _react2.default.createElement(
                'form',
                { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachDonViThanhTra', 'donViThanhTra') },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-input-tt-dvph col-25' },
                  _react2.default.createElement(_common.Input, { label: '\u0110\u01A1n v\u1ECB thanh tra li\xEAn quan', placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter', value: this.state.donViThanhTra, onChange: this.onChange.bind(this, 'donViThanhTra') }),
                  _react2.default.createElement('button', { className: 'btn-add-dvph', type: 'submit' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-60 mb18' },
                  _react2.default.createElement(
                    'div',
                    { className: 'ds-tt-dvph' },
                    this.state.danhSachDonViThanhTra.map(function (item, i) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'tt-dvph-item', key: i },
                        _react2.default.createElement(
                          'span',
                          { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachDonViThanhTra', i) },
                          '\xD7'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'tt-dvph-value' },
                          item.ten
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-15 mb18 count-dv' },
                  'T\u1ED5ng: ',
                  this.state.danhSachDonViThanhTra.length,
                  ' \u0111\u01A1n v\u1ECB'
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: false },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'pl20 pb20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'section',
                { className: 'wrap-block pl20 pr20 mb10' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'p',
                    { className: 'txt-bold txt-upper mb10' },
                    'Gia h\u1EA1n thanh tra'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Gia h\u1EA1n \u0111\u1EBFn ng\xE0y', value: this.state.ngayHetHanGiaHanThanhTra ? (0, _moment2.default)(this.state.ngayHetHanGiaHanThanhTra).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: this.state.lyDonGiaHan ? this.state.lyDonGiaHan : '' })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { phanLoaiQuyTrinh: 'GIA_HAN', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuGiaHan, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.linhVucThanhTra == 'CHUYEN_NGANH' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'pl20 pb20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'section',
                { className: 'wrap-block pl20 pr20 mb10' },
                _react2.default.createElement(
                  _utils.ShowIfCheck,
                  { className: 'row pl15 pr15', label: 'Th\xE0nh l\u1EADp \u0111o\xE0n', onChange: this.handleCheck.bind(this, 'thanhLapDoan'), checked: this.state.thanhLapDoan },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl15 pr15' },
                      _react2.default.createElement(
                        'h2',
                        { className: 'title-12 pb20' },
                        'Th\xE0nh vi\xEAn \u0111o\xE0n'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10 mb10' },
                      _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', className: 'col-25 mb0-18', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soQuyetDinhThanhLapDoan, onChange: this.onChange.bind(this, 'soQuyetDinhThanhLapDoan'), maxLength: 255 }),
                      _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', className: 'col-25 mb0-18', value: this.state.ngayRaQuyetDinhThanhLapDoan, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinhThanhLapDoan'), require: true, bindValidator: this, channel: 'formTaoDon' })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.showFile },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-table-show-oncheck' },
                        _react2.default.createElement(
                          _datatable.DataTableAttachElement,
                          { addItem: this.addItem.bind(this), header: _table.header.thanhTra.TMTVCTT, dataList: this.state.dataThanhVienDoan, hideButtonExport: true, hidePagination: true, pageData: this.state.pageData, parent: this, search: this.state.search,
                            tableLoading: this.state.tableLoading },
                          _react2.default.createElement(_datatable.RowItemChiTietThanhVienCuocThanhTra, { dataVaiTroThanhVienDoan: this.state.dataVaiTroThanhVienDoan, onItemRemove: this.onItemRemove.bind(this), onItemChange: this.onItemChange.bind(this) })
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10' },
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                'Ti\u1EBFn \u0111\u1ED9 thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_ttForms.DropDownChonTienDoThanhTra, { label: 'Ti\u1EBFn \u0111\u1ED9', className: 'col-25', data: this.state.dataTienDoThanhTra, require: true, bindValidator: this, selectedValue: this.state.tienDoThanhTra, onChange: this.onChange.bind(this, 'tienDoThanhTra') })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10' },
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                'K\u1EBFt lu\u1EADn thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 k\u1EBFt lu\u1EADn thanh tra', placeholder: 'Nh\u1EADp...', className: 'col-25', value: this.state.soKetLuanThanhTra, onChange: this.onChange.bind(this, 'soKetLuanThanhTra'), maxLength: 255 }),
              _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y ban h\xE0nh', className: 'col-25', endDate: new Date(), value: this.state.ngayBanHanhKetLuanThanhTra, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra') }),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u01A1n v\u1ECB ban h\xE0nh', className: 'col-25', selectedValue: this.state.donViBanHanh, onChange: this.onChange.bind(this, 'donViBanHanh'), data: this.state.dataDonViBanHanh, keyName: 'giaTri', valueName: 'ten' }),
              _react2.default.createElement(_common.TextArea, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn thanh tra', className: 'col-100', placeholder: 'Nh\u1EADp...', value: this.state.tomTatKetLuanThanhTra, onChange: this.onChange.bind(this, 'tomTatKetLuanThanhTra'), maxLength: 1000 })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showFile },
              _react2.default.createElement(
                'div',
                { className: 'pl20 pr20' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { phanLoaiQuyTrinh: 'KET_LUAN_THANH_TRA', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuKetLuanThanhTra, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10 pl20 pb20 pr20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block pl20 pr20' },
            _react2.default.createElement(
              _utils.ShowIfCheck,
              { className: 'row pl15 pr15', label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra', onChange: this.handleCheck.bind(this, 'chuyenCoQuanDieuTra'), checked: this.state.chuyenCoQuanDieuTra },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 pb20' },
                    'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'T\xEAn c\u01A1 quan', className: 'col-50', require: true, bindValidator: this, selectedValue: this.state.coQuanDieuTra, onChange: this.onChange.bind(this, 'coQuanDieuTra'), data: this.state.dataCoQuanDieuTra, keyName: 'coQuanQuanLyId', valueName: 'ten' }),
                  _react2.default.createElement(_common.InputNumber, { label: 'S\u1ED1 v\u1EE5', className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', value: Number(this.state.soVuDieuTra), onChange: this.onChange.bind(this, 'soVuDieuTra') }),
                  _react2.default.createElement(_common.InputNumber, { label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', value: Number(this.state.soDoiTuongDieuTra), onChange: this.onChange.bind(this, 'soDoiTuongDieuTra'), maxLength: 255 })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10 pl20 pb20 pr20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.linhVucThanhTra == 'XAY_DUNG_CO_BAN' || this.state.linhVucThanhTra == 'HANH_CHINH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block pl20 pr20 mb10' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { className: 'row pl15 pr15', label: 'Vi ph\u1EA1m', onChange: this.handleCheck.bind(this, 'viPham'), checked: this.state.viPham },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 pb20' },
                      'N\u1ED9i dung vi ph\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'T\u1ED5ng vi ph\u1EA1m'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuViPham, onChange: this.onChange.bind(this, 'tienThuViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datThuViPham, onChange: this.onChange.bind(this, 'datThuViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiThuHoi, onChange: this.onChange.bind(this, 'tienTraKienNghiThuHoi') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datTraKienNghiThuHoi, onChange: this.onChange.bind(this, 'datTraKienNghiThuHoi') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB kh\xE1c'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiKhac, onChange: this.onChange.bind(this, 'tienTraKienNghiKhac') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datTraKienNghiKhac, onChange: this.onChange.bind(this, 'datTraKienNghiKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                      ),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'T\u1ED5 ch\u1EE9c', value: this.state.toChucXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'toChucXuLyHanhChinhViPham') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'C\xE1 nh\xE2n', value: this.state.caNhanXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i trong qu\xE1 tr\xECnh thanh tra'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham') },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-25' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u01A1n v\u1ECB vi ph\u1EA1m', data: this.state.dataDonViViPham, className: 'col-100 no-gutter', selectedValue: this.state.donViViPham, onChange: this.onChange.bind(this, 'donViViPham'), keyName: 'giaTri', valueName: 'ten' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-60 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.danhSachDonViViPham.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachDonViViPham', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-15 mb18 count-dv' },
                        'T\u1ED5ng: ',
                        this.state.danhSachDonViViPham.length,
                        ' \u0111\u01A1n v\u1ECB'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.linhVucThanhTra == 'TAI_CHINH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block pl20 pr20 mb10' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { className: 'row pl15 pr15', label: 'Vi ph\u1EA1m', onChange: this.handleCheck.bind(this, 'viPham'), checked: this.state.viPham },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 pb20' },
                      'N\u1ED9i dung vi ph\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'T\u1ED5ng vi ph\u1EA1m'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-100', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuViPham, onChange: this.onChange.bind(this, 'tienThuViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-100', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiThuHoi, onChange: this.onChange.bind(this, 'tienTraKienNghiThuHoi') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-25 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB kh\xE1c'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-100', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiKhac, onChange: this.onChange.bind(this, 'tienTraKienNghiKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                      ),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'T\u1ED5 ch\u1EE9c', value: this.state.toChucXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'toChucXuLyHanhChinhViPham') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'C\xE1 nh\xE2n', value: this.state.caNhanXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i trong qu\xE1 tr\xECnh thanh tra'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham') },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-25' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u01A1n v\u1ECB vi ph\u1EA1m', data: this.state.dataDonViViPham, className: 'col-100 no-gutter', selectedValue: this.state.donViViPham, onChange: this.onChange.bind(this, 'donViViPham'), keyName: 'giaTri', valueName: 'ten' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-60 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.danhSachDonViViPham.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachDonViViPham', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-15 mb18 count-dv' },
                        'T\u1ED5ng: ',
                        this.state.danhSachDonViViPham.length,
                        ' \u0111\u01A1n v\u1ECB'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.linhVucThanhTra == 'DAT_DAI' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block pl20 pr20 mb10' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { className: 'row pl15 pr15', label: 'Vi ph\u1EA1m', onChange: this.handleCheck.bind(this, 'viPham'), checked: this.state.viPham },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 pb20' },
                      'N\u1ED9i dung vi ph\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'T\u1ED5ng vi ph\u1EA1m'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuViPham, onChange: this.onChange.bind(this, 'tienThuViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datThuViPham, onChange: this.onChange.bind(this, 'datThuViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'C\xE1c d\u1EA1ng vi ph\u1EA1m v\u1EC1 \u0111\u1EA5t'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t l\u1EA5n chi\u1EBFm (m2)', value: this.state.datLanChiem, onChange: this.onChange.bind(this, 'datLanChiem') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Giao \u0111\u1EA5t, c\u1EA5p \u0111\u1EA5t sai \u0111\u1ED1i t\u01B0\u1EE3ng Q\u0110 (m2)', value: this.state.giaoDatCapDatSaiDoiTuong, onChange: this.onChange.bind(this, 'giaoDatCapDatSaiDoiTuong') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'C\u1EA5p, b\xE1n \u0111\u1EA5t tr\xE1i th\u1EA9m quy\u1EC1n (m2)', value: this.state.capBanDatTraiThamQuyen, onChange: this.onChange.bind(this, 'capBanDatTraiThamQuyen') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'C\u1EA5p GCNQSD \u0111\u1EA5t sai (m2)', value: this.state.capGCNQSDDatSai, onChange: this.onChange.bind(this, 'capGCNQSDDatSai') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'CN, cho thu\xEA kh\xF4ng \u0111\xFAng Q\u0110 (m2)', value: this.state.choThueKhongDungQD, onChange: this.onChange.bind(this, 'choThueKhongDungQD') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'SD \u0111\u1EA5t kh\xF4ng \u0111\xFAng M\u0110, sai Q\u0110 (m2)', value: this.state.datKhongDungMDSaiQD, onChange: this.onChange.bind(this, 'datKhongDungMDSaiQD') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'B\u1ECF hoang h\xF3a (m2)', value: this.state.boHoangHoa, onChange: this.onChange.bind(this, 'boHoangHoa') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Vi ph\u1EA1m kh\xE1c (m2)', value: this.state.viPhamKhac, onChange: this.onChange.bind(this, 'viPhamKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiThuHoi, onChange: this.onChange.bind(this, 'tienTraKienNghiThuHoi') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datTraKienNghiThuHoi, onChange: this.onChange.bind(this, 'datTraKienNghiThuHoi') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Ki\u1EBFn ngh\u1ECB kh\xE1c'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 ti\u1EC1n (\u0111)', value: this.state.tienTraKienNghiKhac, onChange: this.onChange.bind(this, 'tienTraKienNghiKhac') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i tr\u1EA3 \u0111\u1EA5t (m2)', value: this.state.datTraKienNghiKhac, onChange: this.onChange.bind(this, 'datTraKienNghiKhac') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                      ),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'T\u1ED5 ch\u1EE9c', value: this.state.toChucXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'toChucXuLyHanhChinhViPham') }),
                      _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'C\xE1 nh\xE2n', value: this.state.caNhanXuLyHanhChinhViPham, onChange: this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 no-gutter' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'Thu h\u1ED3i trong qu\xE1 tr\xECnh thanh tra'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu ti\u1EC1n (\u0111)', value: this.state.tienThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra') }),
                      _react2.default.createElement(_common.Input, { className: 'col-50', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu \u0111\u1EA5t (m2)', value: this.state.datThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham') },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-25' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u01A1n v\u1ECB vi ph\u1EA1m', data: this.state.dataDonViViPham, className: 'col-100 no-gutter', selectedValue: this.state.donViViPham, onChange: this.onChange.bind(this, 'donViViPham'), keyName: 'giaTri', valueName: 'ten' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-60 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.danhSachDonViViPham.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachDonViViPham', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-15 mb18 count-dv' },
                        'T\u1ED5ng: ',
                        this.state.danhSachDonViViPham.length,
                        ' \u0111\u01A1n v\u1ECB'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.linhVucThanhTra == 'CHUYEN_NGANH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block pl20 pr20 mb10' },
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { className: 'row pl15 pr15', label: 'Vi ph\u1EA1m', onChange: this.handleCheck.bind(this, 'viPham'), checked: this.state.viPham },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 pb20' },
                      'N\u1ED9i dung vi ph\u1EA1m'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 vi ph\u1EA1m', value: this.state.soViPham, onChange: this.onChange.bind(this, 'soViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 Q\u0110 x\u1EED ph\u1EA1t HC \u0111\u01B0\u1EE3c ban h\xE0nh', placeholder: 'Nh\u1EADp...', value: this.state.soQDXuPhatHCDuocBanHanh, onChange: this.onChange.bind(this, 'soQDXuPhatHCDuocBanHanh') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter clear-left' },
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'S\u1ED1 ti\u1EC1n vi ph\u1EA1m (\u0111)', value: this.state.soTienViPham, onChange: this.onChange.bind(this, 'soTienViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'S\u1ED1 ti\u1EC1n x\u1EED ph\u1EA1t vi ph\u1EA1m (m2)', value: this.state.soTienXuPhatViPham, onChange: this.onChange.bind(this, 'soTienXuPhatViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'S\u1ED1 ti\u1EC1n ki\u1EBFn ngh\u1ECB thu h\u1ED3i (m2)', value: this.state.soTienKienNghiThuHoi, onChange: this.onChange.bind(this, 'soTienKienNghiThuHoi') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter clear-left' },
                      _react2.default.createElement(
                        'p',
                        { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                        'S\u1ED1 ti\u1EC1n x\u1EED l\xFD t\xE0i s\u1EA3n vi ph\u1EA1m'
                      ),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\u1ECBch thu (\u0111)', value: this.state.soTienTichThuXuLyTaiSanViPham, onChange: this.onChange.bind(this, 'soTienTichThuXuLyTaiSanViPham') }),
                      _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\xEAu h\u1EE7y (\u0111)', value: this.state.soTienTieuHuyXuLyTaiSanViPham, onChange: this.onChange.bind(this, 'soTienTieuHuyXuLyTaiSanViPham') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham') },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-input-tt-dvph col-25' },
                        _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '\u0110\u01A1n v\u1ECB vi ph\u1EA1m', data: this.state.dataDonViViPham, className: 'col-100 no-gutter', selectedValue: this.state.donViViPham, onChange: this.onChange.bind(this, 'donViViPham'), keyName: 'giaTri', valueName: 'ten' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-60 mb18' },
                        _react2.default.createElement(
                          'div',
                          { className: 'ds-tt-dvph' },
                          this.state.danhSachDonViViPham.map(function (item, i) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tt-dvph-item', key: i },
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-icon', onClick: _this22.removeDonVi.bind(_this22, 'danhSachDonViViPham', i) },
                                '\xD7'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'tt-dvph-value' },
                                item.ten
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'col-15 mb18 count-dv' },
                        'T\u1ED5ng: ',
                        this.state.danhSachDonViViPham.length,
                        ' \u0111\u01A1n v\u1ECB'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10 pl20 pb20 pr20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block pl20 pr20' },
            _react2.default.createElement(
              _utils.ShowIfCheck,
              { className: 'row pl15 pr15', label: 'C\xF3 ph\xE1t hi\u1EC7n tham nh\u0169ng', onChange: this.handleCheck.bind(this, 'phatHienThamNhung'), checked: this.state.phatHienThamNhung },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 pb20' },
                    'N\u1ED9i dung vi ph\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soVuThamNhung, onChange: this.onChange.bind(this, 'soVuThamNhung') }),
                  _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.soDoiTuongThamNhung, onChange: this.onChange.bind(this, 'soDoiTuongThamNhung'), maxLength: 255 }),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'T\xE0i s\u1EA3n tham nh\u0169ng'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (\u0111)', value: this.state.tienThamNhung, onChange: this.onChange.bind(this, 'tienThamNhung') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (\u0111)', value: this.state.taiSanKhacThamNhung, onChange: this.onChange.bind(this, 'taiSanKhacThamNhung') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datThamNhung, onChange: this.onChange.bind(this, 'datThamNhung') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (\u0111)', value: this.state.tienKienNghiThuHoi, onChange: this.onChange.bind(this, 'tienKienNghiThuHoi') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (\u0111)', value: this.state.taiSanKhacKienNghiThuHoi, onChange: this.onChange.bind(this, 'taiSanKhacKienNghiThuHoi') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datKienNghiThuHoi, onChange: this.onChange.bind(this, 'datKienNghiThuHoi') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter clear-left' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      '\u0110\xE3 thu'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ti\u1EC1n (\u0111)', value: this.state.tienDaThu, onChange: this.onChange.bind(this, 'tienDaThu') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\xE0i s\u1EA3n kh\xE1c (\u0111)', value: this.state.taiSanKhacDaThu, onChange: this.onChange.bind(this, 'taiSanKhacDaThu') }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\u1EA5t (m2)', value: this.state.datDaThu, onChange: this.onChange.bind(this, 'datDaThu') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'X\u1EED l\xFD h\xE0nh ch\xEDnh'
                    ),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'T\u1ED5 ch\u1EE9c', value: this.state.toChucXuLyHanhChinhThamNhung, onChange: this.onChange.bind(this, 'toChucXuLyHanhChinhThamNhung') }),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'C\xE1 nh\xE2n', value: this.state.caNhanXuLyHanhChinhThamNhung, onChange: this.onChange.bind(this, 'caNhanXuLyHanhChinhThamNhung') })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(
                      'p',
                      { className: 'txt-bold txt-upper mb10 pl5 pr5' },
                      'X\u1EED l\xFD tr\xE1ch nhi\u1EC7m ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u1EA7u'
                    ),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-50', label: 'S\u1ED1 ng\u01B0\u1EDDi', value: this.state.soNguoiXuLyTrachNhiemDungDau, onChange: this.onChange.bind(this, 'soNguoiXuLyTrachNhiemDungDau') }),
                    _react2.default.createElement(_common.Input, { className: 'col-50', label: 'T\xEAn ng\u01B0\u1EDDi', placeholder: 'Nh\u1EADp...', value: this.state.tenNguoi, onChange: this.onChange.bind(this, 'tenNguoi'), maxLength: 255 })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10 pb20' },
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(
              'div',
              { className: 'pl20 pr20 pb10' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThu, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt35 pb5' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: _reactRouter.browserHistory.goBack },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.dotXuat },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.dotXuat },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSaveExistElement.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThemMoiCuocThanhTra;
}(_react2.default.Component);

ThemMoiCuocThanhTra.defaultProps = {
  validators: {},
  dotXuat: false,
  params: {
    id: ''
  }
};

exports.default = ThemMoiCuocThanhTra;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTableAttachElement = function (_React$Component) {
  _inherits(DataTableAttachElement, _React$Component);

  function DataTableAttachElement() {
    _classCallCheck(this, DataTableAttachElement);

    return _possibleConstructorReturn(this, (DataTableAttachElement.__proto__ || Object.getPrototypeOf(DataTableAttachElement)).apply(this, arguments));
  }

  _createClass(DataTableAttachElement, [{
    key: 'addItem',
    value: function addItem() {
      this.props.addItem();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;

      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this2.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item
        });
      });

      var ItemLoading = _react2.default.createElement(
        'div',
        { className: 'loading-content' },
        _react2.default.createElement('span', { className: 'shape1' }),
        _react2.default.createElement('span', { className: 'shape2' }),
        _react2.default.createElement('span', { className: 'shape3' }),
        _react2.default.createElement('span', { className: 'shape4' }),
        _react2.default.createElement('span', { className: 'shape5' }),
        _react2.default.createElement('span', { className: 'shape6' }),
        _react2.default.createElement('span', { className: 'shape7' }),
        _react2.default.createElement('span', { className: 'shape8' }),
        _react2.default.createElement('span', { className: 'shape9' }),
        _react2.default.createElement('span', { className: 'shape10' }),
        _react2.default.createElement('span', { className: 'shape11' }),
        _react2.default.createElement('span', { className: 'shape12' }),
        _react2.default.createElement('span', { className: 'shape13' })
      );
      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table' },
        _react2.default.createElement(
          'div',
          { className: 'table-container' },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              'thead',
              { className: 'table-header' },
              _react2.default.createElement(
                'tr',
                null,
                this.props.header.map(function (item, i) {
                  return _react2.default.createElement(
                    'th',
                    { key: i, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                    item.name
                  );
                })
              )
            ),
            this.props.tableLoading ? _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              _react2.default.createElement(
                'tr',
                { className: 'table-loading' },
                _react2.default.createElement(
                  'td',
                  { colSpan: this.props.header.length },
                  ItemLoading,
                  ItemLoading,
                  ItemLoading
                )
              )
            ) : _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              dataListItem,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'multipe-column', colSpan: this.props.header.length },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.dataList.length == 0 },
                    _react2.default.createElement(
                      'span',
                      { className: 'attach-file-description' },
                      this.props.descriptions
                    )
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-addfile itt-Them-Moi', onClick: this.addItem.bind(this) },
                    'Th\xEAm m\u1EDBi'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DataTableAttachElement;
}(_react2.default.Component);

exports.default = DataTableAttachElement;

DataTableAttachElement.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: [],
  descriptions: 'Chưa có thành viên đoàn.'
};

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _reactRouter = __webpack_require__(2);

var _reactPaginate = __webpack_require__(413);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _datatable = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTableMultipleSelect = function (_React$Component) {
  _inherits(DataTableMultipleSelect, _React$Component);

  function DataTableMultipleSelect(props, context) {
    _classCallCheck(this, DataTableMultipleSelect);

    var _this = _possibleConstructorReturn(this, (DataTableMultipleSelect.__proto__ || Object.getPrototypeOf(DataTableMultipleSelect)).call(this, props, context));

    _this.state = {
      export: 'btn-green tt-export',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    };

    return _this;
  }

  _createClass(DataTableMultipleSelect, [{
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      if (this.props.parent && this.props.parent.handleChangePageSize) {
        this.props.parent.handleChangePageSize.bind(this.props.parent, size);
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      if (this.props.parent && this.props.parent.handlePageClick) {
        this.props.parent.handlePageClick.bind(this.props.parent, page);
      }
    }
  }, {
    key: 'onCheck',
    value: function onCheck() {
      this.props.onCheck();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;

      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this2.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item,
          parent: _this2.props.parent
        });
      });
      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table' },
        _react2.default.createElement(
          'div',
          { className: 'table-container' },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              'thead',
              { className: 'table-header' },
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  { className: 'table-header-col table-checkbox', style: { width: 40 } },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.props.onDisableCheck !== true },
                    _react2.default.createElement(
                      'label',
                      { className: 'pt-control pt-checkbox pt-large' },
                      _react2.default.createElement('input', { type: 'checkbox', className: 'pt-large', name: '', onChange: this.onCheck.bind(this), checked: this.props.selectAllStatus }),
                      _react2.default.createElement('span', { className: 'pt-control-indicator' })
                    )
                  )
                ),
                this.props.header.map(function (item, i) {
                  return _react2.default.createElement(
                    'th',
                    { key: i, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                    item.name
                  );
                })
              )
            ),
            this.props.tableLoading ? _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              _react2.default.createElement(
                'tr',
                { className: 'table-loading' },
                _react2.default.createElement(_datatable.LoadingDataTale, { countLoading: 12, colSpan: !this.props.ThongKeBaoCao ? this.props.header.length + 1 : this.props.numberColumnHeader })
              )
            ) : _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              dataListItem,
              !this.props.dataList.length && !this.props.showAddMore ? this.props.search ? _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + 1 },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ) : _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.header.length + 1 },
                    'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ) : null,
              !this.props.dataList.length && !this.props.showAddMore ? this.props.search ? _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ) : _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.ThongKeBaoCao },
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: this.props.numberColumnHeader },
                    'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                  )
                )
              ) : null
            )
          ),
          !this.props.hidePagination && this.props.dataList.length > 0 && !this.props.ThongKeBaoCao ? _react2.default.createElement(
            'div',
            { className: 'pagination-wrap' },
            this.props.pageData && this.props.pageData.totalElements && this.props.pageData.totalElements > this.props.pageData.size ? _react2.default.createElement(_reactPaginate2.default, {
              pageCount: this.props.pageData ? this.props.pageData.totalPages : 1,
              marginPagesDisplayed: 1, pageRangeDisplayed: 2, previousLabel: "<", nextLabel: ">",
              breakLabel: _react2.default.createElement(
                'a',
                { href: 'javascript:void(0)' },
                '...'
              ), breakClassName: "item",
              onPageChange: this.props.parent.handlePageClick.bind(this.props.parent),
              containerClassName: "pagination-list", pageClassName: 'item',
              subContainerClassName: "pages pagination", previousClassName: 'item',
              nextClassName: 'item', activeClassName: "active",
              forcePage: this.props.pageData ? this.props.pageData.number : 0 }) : null,
            '(' + (pageNumber * pageSize + 1) + '-' + (pageNumber == 0 ? this.props.pageData.totalElements : (pageNumber + 1) * pageSize) + '/' + this.props.pageData.totalElements + ') Tr\xEAn 1 trang: ',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 10 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 10) },
              '10'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 25 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 25) },
              '25'
            ),
            ',',
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.props.pageData.size == 50 ? 'disable-page' : 'page-number', onClick: this.props.parent.handleChangePageSize.bind(this.props.parent, 50) },
              '50'
            )
          ) : null
        )
      );
    }
  }]);

  return DataTableMultipleSelect;
}(_react2.default.Component);

exports.default = DataTableMultipleSelect;

DataTableMultipleSelect.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: [],
  selectAll: false,
  dataList: []
};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingDataTale = function (_Component) {
  _inherits(LoadingDataTale, _Component);

  function LoadingDataTale() {
    _classCallCheck(this, LoadingDataTale);

    return _possibleConstructorReturn(this, (LoadingDataTale.__proto__ || Object.getPrototypeOf(LoadingDataTale)).apply(this, arguments));
  }

  _createClass(LoadingDataTale, [{
    key: 'renderLoading',
    value: function renderLoading() {
      var tableLoading = [];
      var countLoading = this.props.countLoading;

      for (var i = 0; i < countLoading; i++) {
        tableLoading.push(_react2.default.createElement(
          'div',
          { key: i, className: 'loading-content' },
          _react2.default.createElement('span', { className: 'shape1' }),
          _react2.default.createElement('span', { className: 'shape2' }),
          _react2.default.createElement('span', { className: 'shape3' }),
          _react2.default.createElement('span', { className: 'shape4' }),
          _react2.default.createElement('span', { className: 'shape5' }),
          _react2.default.createElement('span', { className: 'shape6' }),
          _react2.default.createElement('span', { className: 'shape7' }),
          _react2.default.createElement('span', { className: 'shape8' }),
          _react2.default.createElement('span', { className: 'shape9' }),
          _react2.default.createElement('span', { className: 'shape10' }),
          _react2.default.createElement('span', { className: 'shape11' }),
          _react2.default.createElement('span', { className: 'shape12' }),
          _react2.default.createElement('span', { className: 'shape13' })
        ));
      }
      return tableLoading;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        { colSpan: this.props.colSpan },
        this.renderLoading()
      );
    }
  }]);

  return LoadingDataTale;
}(_react.Component);

exports.default = LoadingDataTale;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = __webpack_require__(3);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCanCuCuocThanhTra = function (_Component) {
  _inherits(RowItemCanCuCuocThanhTra, _Component);

  function RowItemCanCuCuocThanhTra() {
    _classCallCheck(this, RowItemCanCuCuocThanhTra);

    return _possibleConstructorReturn(this, (RowItemCanCuCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemCanCuCuocThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemCanCuCuocThanhTra, [{
    key: "handleRemove",
    value: function handleRemove(indexRemove) {
      this.props.removeVanBanCanCu(indexRemove);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.item || [],
          vanBanId = _ref.vanBanId,
          coQuanBanHanh = _ref.coQuanBanHanh,
          theLoaiVanBan = _ref.theLoaiVanBan,
          linhVucVanBan = _ref.linhVucVanBan,
          tenFile = _ref.tenFile,
          duongDan = _ref.duongDan;

      return _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "td",
          null,
          this.props.count
        ),
        _react2.default.createElement(
          "td",
          { style: { width: 300, minWidth: 300, maxWidth: 300 } },
          _react2.default.createElement(_common.DropDown, {
            className: "col-100",
            options: this.props.listDanhMucVanBan,
            keyName: "giaTri",
            valueName: "ten",
            placeholder: "Ch\u1ECDn",
            selectedValue: vanBanId,
            onChange: function onChange(e) {
              _this2.props.onChange(e.target.value, _this2.props.count);
            },
            bindValidator: this
          })
        ),
        _react2.default.createElement(
          "td",
          null,
          coQuanBanHanh || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          theLoaiVanBan || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          linhVucVanBan || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              onClick: _jsFileDownload2.default.bind(this, duongDan, tenFile),
              className: "txt-underline txt-blue"
            },
            tenFile || ""
          )
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: "itt-delete", onClick: this.handleRemove.bind(this, this.props.count - 1) },
            "X\xF3a"
          )
        )
      );
    }
  }]);

  return RowItemCanCuCuocThanhTra;
}(_react.Component);

exports.default = RowItemCanCuCuocThanhTra;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemCanCuCuocThanhTraView = function (_Component) {
  _inherits(RowItemCanCuCuocThanhTraView, _Component);

  function RowItemCanCuCuocThanhTraView() {
    _classCallCheck(this, RowItemCanCuCuocThanhTraView);

    return _possibleConstructorReturn(this, (RowItemCanCuCuocThanhTraView.__proto__ || Object.getPrototypeOf(RowItemCanCuCuocThanhTraView)).apply(this, arguments));
  }

  _createClass(RowItemCanCuCuocThanhTraView, [{
    key: "render",
    value: function render() {
      var _ref = this.props.item || [],
          tenVanBan = _ref.tenVanBan,
          coQuanBanHanhInfo = _ref.coQuanBanHanhInfo,
          loaiVanBanInfo = _ref.loaiVanBanInfo,
          linhVucVanBanInfo = _ref.linhVucVanBanInfo,
          documentMetaDataInfo = _ref.documentMetaDataInfo;

      return _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "td",
          null,
          this.props.count
        ),
        _react2.default.createElement(
          "td",
          null,
          tenVanBan || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          coQuanBanHanhInfo.ten || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          loaiVanBanInfo.ten || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          linhVucVanBanInfo.ten || ""
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              onClick: _jsFileDownload2.default.bind(this, documentMetaDataInfo.documentId, documentMetaDataInfo.ten),
              className: "txt-underline txt-blue"
            },
            documentMetaDataInfo.ten || ""
          )
        )
      );
    }
  }]);

  return RowItemCanCuCuocThanhTraView;
}(_react.Component);

exports.default = RowItemCanCuCuocThanhTraView;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _message = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemChiTietCuocThanhTra = function (_React$Component) {
  _inherits(RowItemChiTietCuocThanhTra, _React$Component);

  function RowItemChiTietCuocThanhTra(props, context) {
    _classCallCheck(this, RowItemChiTietCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemChiTietCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemChiTietCuocThanhTra)).call(this, props, context));

    _this.state = {
      chiTietDT: false,
      loaiPopup: ''
    };
    return _this;
  }

  _createClass(RowItemChiTietCuocThanhTra, [{
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      this.setState(_defineProperty({}, name, status));
    }
  }, {
    key: 'render',
    value: function render() {
      var Data = this.props.item || {};
      var dataItemNamThanhTra = Data && Data.keHoachThanhTraGocInfo ? Data.keHoachThanhTraGocInfo.namThanhTra : null;
      var getTen = '';

      if (Data && Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = Data.doiTuongThanhTras[0].ten;
      } else if (Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = Data.listDoiTuongThanhTra[0].ten;
      } else if (Data.tenNhieuDoiTuongThanhTra && Data.cuocThanhTraNhieuDoiTuong === true) {
        getTen = this.props.item.tenNhieuDoiTuongThanhTra;
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', name: 'abc', onClick: this.toggleDialog.bind(this, 'chiTietDT', true) },
            getTen
          ),
          _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this, 'chiTietDT', false) })
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.noiDungThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' ? _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                this.props.item.chucNangCuocThanhTraInfo.text + ' / ',
                this.props.item.hinhThucThanhTraChuyenNganhInfo ? this.props.item.hinhThucThanhTraChuyenNganhInfo.text : ''
              )
            ) : _react2.default.createElement(
              'li',
              null,
              this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.linhVucThanhTraInfo && this.props.item.linhVucThanhTraInfo.text && this.props.item.chucNangCuocThanhTraInfo.text + ' / ' + this.props.item.linhVucThanhTraInfo.text
            )
          ),
          this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && (this.props.item.linhVucThanhTraInfo == null || !this.props.item.linhVucThanhTraInfo.type) && this.props.isSubmit && _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageLinhVucTT
          ),
          this.props.item.chucNangCuocThanhTraInfo != null && this.props.item.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' && (this.props.item.hinhThucThanhTraChuyenNganhInfo == null || !this.props.item.hinhThucThanhTraChuyenNganhInfo.type) && this.props.isSubmit && _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageHinhThucTT
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.thoiHanThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.kyThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.thoiGianTienHanh
        )
      );
    }
  }]);

  return RowItemChiTietCuocThanhTra;
}(_react2.default.Component);

exports.default = RowItemChiTietCuocThanhTra;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemChiTietThanhVienCuocThanhTra = function (_React$Component) {
  _inherits(RowItemChiTietThanhVienCuocThanhTra, _React$Component);

  function RowItemChiTietThanhVienCuocThanhTra(props, context) {
    _classCallCheck(this, RowItemChiTietThanhVienCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemChiTietThanhVienCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemChiTietThanhVienCuocThanhTra)).call(this, props, context));

    _this.state = {
      hoVaTen: _this.props.item.hoVaTen,
      ngaySinh: _this.props.item.ngaySinh ? new Date(_this.props.item.ngaySinh) : '',
      donVi: _this.props.item.donVi,
      chucVu: _this.props.item.chucVu,
      vaiTroThanhVienDoan: _this.props.item.vaiTroThanhVienDoan ? _this.props.item.vaiTroThanhVienDoan : '',
      thanhVienDoanId: _this.props.item.thanhVienDoanId,
      dataVaiTroThanhVienDoan: _this.props.dataVaiTroThanhVienDoan
    };
    return _this;
  }

  _createClass(RowItemChiTietThanhVienCuocThanhTra, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        hoVaTen: nextProps.item.hoVaTen,
        ngaySinh: nextProps.item.ngaySinh ? new Date(nextProps.item.ngaySinh) : '',
        donVi: nextProps.item.donVi,
        chucVu: nextProps.item.chucVu,
        vaiTroThanhVienDoan: nextProps.item.vaiTroThanhVienDoan ? nextProps.item.vaiTroThanhVienDoan : '',
        thanhVienDoanId: nextProps.item.thanhVienDoanId,
        dataVaiTroThanhVienDoan: nextProps.dataVaiTroThanhVienDoan
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this2.pushData();
      });
    }
  }, {
    key: 'onItemRemove',
    value: function onItemRemove() {
      this.props.onItemRemove(this.props.count - 1);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this3 = this;

      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d), function () {
          _this3.pushData();
        });
      } else {
        this.setState(_defineProperty({}, name, e), function () {
          _this3.pushData();
        });
      }
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var data = {
        hoVaTen: this.state.hoVaTen ? this.state.hoVaTen : '',
        ngaySinh: this.state.ngaySinh ? (0, _moment2.default)(this.state.ngaySinh).toISOString() : '',
        donVi: this.state.donVi ? this.state.donVi : '',
        chucVu: this.state.chucVu ? this.state.chucVu : '',
        vaiTroThanhVienDoan: this.state.vaiTroThanhVienDoan ? this.state.vaiTroThanhVienDoan : ''
      };
      if (this.state.thanhVienDoanId) {
        data.thanhVienDoanId = Number(this.state.thanhVienDoanId);
      }
      this.props.onItemChange(data, this.props.count - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-100 mb0-18', value: this.state.hoVaTen, onChange: this.onChange.bind(this, 'hoVaTen') })
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_common.DatePicker, { className: 'col-100 mb0-18', value: this.state.ngaySinh, onChange: this.handleChangeDate.bind(this, 'ngaySinh') })
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-100 mb0-18', value: this.state.donVi, onChange: this.onChange.bind(this, 'donVi') })
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_common.Input, { triggeOnBlur: true, className: 'col-100 mb0-18', value: this.state.chucVu, onChange: this.onChange.bind(this, 'chucVu') })
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: '', className: 'col-100 mb0-18', data: this.state.dataVaiTroThanhVienDoan, selectedValue: this.state.vaiTroThanhVienDoan, onChange: this.onChange.bind(this, 'vaiTroThanhVienDoan'), valueName: 'ten', keyName: 'giaTri' })
        ),
        _react2.default.createElement(
          'td',
          { className: 'wrap-link-todo link-attach' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'itt-delete', onClick: this.onItemRemove.bind(this) },
            'X\xF3a'
          )
        )
      );
    }
  }]);

  return RowItemChiTietThanhVienCuocThanhTra;
}(_react2.default.Component);

RowItemChiTietThanhVienCuocThanhTra.defaultProps = {
  item: {
    hoVaTen: '',
    ngaySinh: '',
    donVi: '',
    chucVu: '',
    vaiTroThanhVienDoan: '',
    id: '',
    dataVaiTroThanhVienDoan: []
  }
};

exports.default = RowItemChiTietThanhVienCuocThanhTra;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemChiTietThanhVienCuocThanhTraView = function (_React$Component) {
  _inherits(RowItemChiTietThanhVienCuocThanhTraView, _React$Component);

  function RowItemChiTietThanhVienCuocThanhTraView() {
    _classCallCheck(this, RowItemChiTietThanhVienCuocThanhTraView);

    return _possibleConstructorReturn(this, (RowItemChiTietThanhVienCuocThanhTraView.__proto__ || Object.getPrototypeOf(RowItemChiTietThanhVienCuocThanhTraView)).apply(this, arguments));
  }

  _createClass(RowItemChiTietThanhVienCuocThanhTraView, [{
    key: 'render',
    value: function render() {
      var Data = this.props.item;
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.hoVaTen ? Data.hoVaTen : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.ngaySinh ? (0, _moment2.default)(Data.ngaySinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.donVi ? Data.donVi : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.chucVu ? Data.chucVu : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.vaiTroThanhVienDoanInfo ? Data.vaiTroThanhVienDoanInfo.text : ''
        )
      );
    }
  }]);

  return RowItemChiTietThanhVienCuocThanhTraView;
}(_react2.default.Component);

exports.default = RowItemChiTietThanhVienCuocThanhTraView;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _subView = __webpack_require__(169);

var _api = __webpack_require__(5);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachCuocThanhTra = function (_React$Component) {
  _inherits(RowItemDanhSachCuocThanhTra, _React$Component);

  function RowItemDanhSachCuocThanhTra(props, context) {
    _classCallCheck(this, RowItemDanhSachCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemDanhSachCuocThanhTra.__proto__ || Object.getPrototypeOf(RowItemDanhSachCuocThanhTra)).call(this, props, context));

    _this.state = {
      getDSDTDeXuatXuLys: [],
      dialog: false,
      chiTietDT: false,
      checkTrung: false
    };
    return _this;
  }

  _createClass(RowItemDanhSachCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDSDTDeXuatXuLy();
      this.checkTTTrung();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.item !== this.props.item) {
        this.getDSDTDeXuatXuLy();
        this.forceUpdate();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.checkTTTrung();
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog(name, status) {
      if (name == 'chiTietDT') {
        this.setState({ chiTietDT: status });
      } else this.setState({ dialog: status });
      this.getDSDTDeXuatXuLy();
    }
  }, {
    key: 'onSave',
    value: function onSave(data) {
      this.props.onSave(data, this.props.count - 1);
    }
  }, {
    key: 'getDSDTDeXuatXuLy',
    value: function getDSDTDeXuatXuLy() {
      var _this2 = this;

      _api.ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: this.props.item.id }).then(function (res) {
        var getDSDTDeXuatXuLys = [];
        if (!(0, _lodash.isEmpty)(res.data)) {
          res.data.map(function (item) {
            if (item) {
              getDSDTDeXuatXuLys.push(item.dttt.id);
            }
          });
        }
        _this2.setState({ getDSDTDeXuatXuLys: getDSDTDeXuatXuLys });
      });
    }
  }, {
    key: 'checkTTTrung',
    value: function checkTTTrung() {
      var _this3 = this;

      var checkTrung = false;
      if (!(0, _lodash.isEmpty)(this.props.totalDataDeXuat)) {
        var getDeXuat = this.props.totalDataDeXuat.find(function (item) {
          return item.id === _this3.props.item.id;
        });
        if (!(0, _lodash.isEmpty)(getDeXuat) && !(0, _lodash.isEmpty)(getDeXuat.dataDeXuat)) {
          checkTrung = true;
        } else {
          checkTrung = false;
        }
      }
      this.setState({ checkTrung: checkTrung });
    }
  }, {
    key: 'render',
    value: function render() {
      var Data = this.props.item || {};
      var countDT = '';
      var dataItemNamThanhTra = Data && Data.keHoachThanhTraGocInfo ? Data.keHoachThanhTraGocInfo.namThanhTra : null;
      var getTen = '';
      var iDCuocThanhTra = '';
      var checkKeHoach = this.props.keHoach;
      if (Data && Data.id) {
        iDCuocThanhTra = Data.id;
      }
      if (Data && Data.doiTuongThanhTras && Data.doiTuongThanhTras.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = Data.doiTuongThanhTras[0].ten;
        countDT = Data.doiTuongThanhTras.length;
      } else if (Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && Data.cuocThanhTraNhieuDoiTuong === false) {
        getTen = Data.listDoiTuongThanhTra[0].ten;
        countDT = Data.listDoiTuongThanhTra.length;
      } else if (Data.cuocThanhTraNhieuDoiTuong === true) {
        getTen = this.props.item.tenNhieuDoiTuongThanhTra;
        var countPre = Data.listDoiTuongThanhTra || [];
        var countNext = Data.doiTuongThanhTras || [];
        var countNext2 = Data.doiTuongThanhTrasList || [];
        if (countNext2.length > 0 || countNext.length > 0) {
          countDT = Data.doiTuongThanhTras.length || Data.doiTuongThanhTrasList.length;
        } else {
          countDT = countPre.length;
        }
      }

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'tt-doituong mgbt10' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: (0, _classnames2.default)('txt-underline txt-regular', {
                  'highlighttratrung': this.state.checkTrung
                }),
                name: 'abc', onClick: this.toggleDialog.bind(this, 'chiTietDT', true) },
              Data.ten
            ),
            _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this, 'chiTietDT', false) })
          ),
          _react2.default.createElement(
            'div',
            { className: 'tt-doituong' },
            countDT,
            ' \u0111\u1ED1i t\u01B0\u1EE3ng'
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          iDCuocThanhTra ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + iDCuocThanhTra },
            !(0, _lodash.isEmpty)(this.props.item.noiDungThanhTra) && _react2.default.createElement(_reactTextTruncate2.default, {
              line: 3,
              truncateText: '\u2026',
              text: (0, _lodash.get)(this.props.item, 'noiDungThanhTra') })
          ) : _react2.default.createElement(_reactTextTruncate2.default, {
            line: 3,
            truncateText: '\u2026',
            text: (0, _lodash.get)(this.props.item, 'noiDungThanhTra') })
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.thoiHanThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.kyThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.thoiGianTienHanh
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.checkCT !== true },
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'div',
              { className: 'todo-wrap two-item' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.allowEdit },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: (0, _classnames2.default)('itt-edit', { 'thaythe': checkKeHoach }), name: 'chinhSua', onClick: this.toggleDialog.bind(this, 'chinhSua', true) },
                    checkKeHoach ? 'Thay thế' : 'Chỉnh sửa'
                  ),
                  _react2.default.createElement(_subView.DialogChinhSuaCuocThanhTra, {
                    keHoach: this.props.keHoach,
                    idCS: this.props.item.id,
                    namKeHoachThanhTra: this.props.namKeHoachThanhTra ? this.props.namKeHoachThanhTra : dataItemNamThanhTra,
                    data: this.props.item,
                    isOpen: this.state.dialog,
                    onSave: this.onSave.bind(this),
                    onClose: this.toggleDialog.bind(this, 'chinhSua', false),
                    chucNangCuocThanhTra: this.props.item.chucNangCuocThanhTra
                  })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.allowDelete },
                _react2.default.createElement(_dialog.DeleteDialog, {
                  title: 'Xác nhận',
                  labelButton: checkKeHoach ? 'Huỷ' : 'Xoá',
                  content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a cu\u1ED9c thanh tra n\xE0y kh\xF4ng?',
                  onSuccess: this.props.parent.handleRemove.bind(this.props.parent, this.props.item, this.props.count - 1)
                })
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachCuocThanhTra;
}(_react2.default.Component);

RowItemDanhSachCuocThanhTra.defaultPops = {
  item: {},
  totalDataDeXuat: []
};

function bindStateToProps(state) {
  return {
    totalDataDeXuat: state.dataCuocThanhTra.totalDataDeXuat,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemDanhSachCuocThanhTra);

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _lodash = __webpack_require__(14);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachCuocThanhTraPage = function (_React$Component) {
  _inherits(RowItemDanhSachCuocThanhTraPage, _React$Component);

  function RowItemDanhSachCuocThanhTraPage(props, context) {
    _classCallCheck(this, RowItemDanhSachCuocThanhTraPage);

    var _this = _possibleConstructorReturn(this, (RowItemDanhSachCuocThanhTraPage.__proto__ || Object.getPrototypeOf(RowItemDanhSachCuocThanhTraPage)).call(this, props, context));

    _this.state = {
      chiTietDT: false,
      isOpen: false,
      listTaiLieuVanThuHuyCTT: [],
      dataFileDinhKem: {
        HuyCTT: []
      },
      ngayQuyetDinhHuyCTT: '',
      soCongVanHuyCTT: '',
      lyDoHuyCTT: '',
      keHoachThanhTraId: null,
      //Tài liệu đính kèm
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      dataTaiLieuVanThuDelete: []
    };
    return _this;
  }

  _createClass(RowItemDanhSachCuocThanhTraPage, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type === 'HUY_CUOC_THANH_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;
        dataFileDinhKem.HuyCTT = data;
        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      }
    }
  }, {
    key: 'onFileChangeDK',
    value: function onFileChangeDK(data) {
      var state = this.state;
      if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
        state.dsTaiLieuBoSung = data;
      } else {
        state.dsTepDinhKem = data;
      }
      this.setState(state);
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) pass = validator.validate();else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this2 = this;

      if (this.validateSubmitForm()) {
        var params = this.getParams();
        var idCTT = this.props && this.props.item && this.props.item.cuocThanhTraId ? this.props.item.cuocThanhTraId : null;
        _api.ThanhTra.actions.deleteCuocThanhTraHuy.request({ id: idCTT }, { params: params }).then(function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _toastr.Toastr)(_message.msg.huyCTT, 'success');

                  case 2:
                    _context.next = 4;
                    return _this2.props.getList();

                  case 4:
                    _context.next = 6;
                    return _this2.closeDialog();

                  case 6:
                    _this2.setState({
                      ngayQuyetDinhHuyCTT: '',
                      soCongVanHuyCTT: '',
                      lyDoHuyCTT: ''
                    });

                  case 7:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
        });
      };
    }
  }, {
    key: 'createDSTepDinhKem',
    value: function createDSTepDinhKem(cuocId, keHoachId, data) {
      var listAddNew = [];
      data.forEach(function (item, i) {
        var params = {
          cuocThanhTra: { id: parseInt(cuocId) },
          keHoachThanhTra: { id: keHoachId },
          loaiQuyTrinh: 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA',
          buocGiaiQuyet: 'HUY_CUOC_THANH_TRA'
        };
        if (item.ten) {
          params.ten = item.ten;
          params.tenFileds = item.ten;
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (item.typeRequired) {
          params.typeRequired = item.typeRequired;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = (0, _moment2.default)(item.ngayQuyetDinh).toISOString();
        }
        listAddNew.push(params);
      });

      if (listAddNew.length) {
        _api.ThanhTra.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = {};
      var khttId = this.props && this.props.item;
      if (this.state.id) {
        params = this.state.dataDetail;
      }

      params.lyDoHuyCTT = this.state.lyDoHuyCTT ? this.state.lyDoHuyCTT : '';

      params.ngayQuyetDinhHuyCTT = this.state.ngayQuyetDinhHuyCTT ? (0, _moment2.default)(this.state.ngayQuyetDinhHuyCTT).add(7, 'hours').toISOString() : null;

      params.soCongVanHuyCTT = this.state.soCongVanHuyCTT ? this.state.soCongVanHuyCTT : '';
      if (khttId.keHoachThanhTraInfo && khttId.keHoachThanhTraInfo.keHoachThanhTraId) {
        params.keHoachThanhTraId = khttId.keHoachThanhTraInfo.keHoachThanhTraId ? khttId.keHoachThanhTraInfo.keHoachThanhTraId : null;
        this.createDSTepDinhKem(khttId.cuocThanhTraId, params.keHoachThanhTraId, this.state.dsTepDinhKem);
      }

      delete params['listTaiLieuVanThuHuyCTT'];

      return params;
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      this.setState(_defineProperty({}, name, e));
      this.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.handleChangeData();
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'showThoiHan',
    value: function showThoiHan() {
      var thoiHan = this.props.item.thoiHanThanhTraInfo;
      if (thoiHan != {}) {
        if (thoiHan.type == 'DAY') {

          if (thoiHan.value == 0) {
            return _react2.default.createElement(
              'p',
              { style: { color: "#E9573F" } },
              'H\u1EBFt h\u1EA1n'
            );
          } else if (thoiHan.value > 0) {
            return _react2.default.createElement(
              'p',
              null,
              'C\xF2n ',
              thoiHan.value,
              ' ng\xE0y'
            );
          } else {
            return _react2.default.createElement(
              'p',
              { style: { color: "#E9573F" } },
              'Tr\u1EC5 ',
              Math.abs(thoiHan.value),
              ' ng\xE0y'
            );
          }
        } else if (thoiHan.type == 'TIME') {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'C\xF2n ',
            thoiHan.value
          );
        }
      } else {
        return _react2.default.createElement('p', null);
      }
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog(status) {
      this.state.chiTietDT = status;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'toggleDialogOpen',
    value: function toggleDialogOpen() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          tienDoThanhTraInfo = _props$item.tienDoThanhTraInfo,
          loaiCuoc = _props$item.loaiCuoc;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var TTTrungUong = 19;
      var textTienDoThanhTra = '';
      if (userInfo.capCoQuanQuanLyId === TTTrungUong && (0, _lodash.get)(tienDoThanhTraInfo, 'type') === "KET_THUC_THANH_TRA_TRUC_TIEP") {
        textTienDoThanhTra = 'Đang tiến hành';
      } else {
        textTienDoThanhTra = (0, _lodash.get)(tienDoThanhTraInfo, 'text');
      }
      var textHoatDong = (0, _lodash.get)(loaiCuoc, 'value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra';
      var Data = this.props.item || {};
      var countDT = Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length;
      // let tenNhieuDoiTuongThanhTra = Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text ? Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : Data.tenNhieuDoiTuongThanhTra;
      // let tenDoiTuongTheoKeHoach = Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 ? Data.listDoiTuongThanhTra[0].ten : tenNhieuDoiTuongThanhTra;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', style: { color: '#208DF4' }, name: 'abc', onClick: this.toggleDialog.bind(this, true) },
                this.props.item.ten
              ),
              _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this, false) })
            ),
            _react2.default.createElement(
              'li',
              null,
              countDT,
              ' \u0111\u1ED1i t\u01B0\u1EE3ng'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.hinhThucThanhTra !== 'THEO_KE_HOACH' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'txt-underline txt-regular', style: { color: '#208DF4' }, to: '/thanh-tra/chi-tiet-cuoc-thanh-tra/' + this.props.item.cuocThanhTraId },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 3,
                    truncateText: '\u2026',
                    text: (0, _lodash.get)(this.props.item, 'noiDungThanhTra') || ''
                  })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.hinhThucThanhTra === 'THEO_KE_HOACH' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'txt-underline txt-regular', style: { color: '#208DF4' }, to: '/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/' + this.props.item.cuocThanhTraId },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 3,
                    truncateText: '\u2026',
                    text: (0, _lodash.get)(this.props.item, 'noiDungThanhTra') || ''
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.hinhThucThanhTraInfo ? this.props.item.hinhThucThanhTraInfo.text : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.loaiHinhThanhTraInfo ? this.props.item.loaiHinhThanhTraInfo.text : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.keHoachThanhTraSearchInfo && this.props.item.keHoachThanhTraSearchInfo.quyetDinhPheDuyetKTTT ? this.props.item.keHoachThanhTraSearchInfo.quyetDinhPheDuyetKTTT : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soQuyetDinhVeViecThanhTra ? this.props.item.soQuyetDinhVeViecThanhTra : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayRaQuyetDinh ? (0, _moment2.default)(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soKetLuanThanhTra ? this.props.item.soKetLuanThanhTra : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soQuyetDinhXuLy ? this.props.item.soQuyetDinhXuLy : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayHetHanThanhTra ? (0, _moment2.default)(this.props.item.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.chuyenTheoDoiThucHien !== true && this.props.item.tienDoThanhTra !== 'LUU_HO_SO' },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHan()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          textTienDoThanhTra
        ),
        _react2.default.createElement(
          'td',
          null,
          textHoatDong
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.chuyenTheoDoiThucHien !== true && this.props.item.tienDoThanhTra != 'LUU_HO_SO' },
            _react2.default.createElement(
              'div',
              { className: 'todo-wrap two-item' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.keHoachThanhTraInfo == null },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'itt-edit', to: { pathname: '/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/' + this.props.item.cuocThanhTraId, state: { fromNotifications: false } } },
                    'Ch\u1EC9nh s\u1EEDa'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.keHoachThanhTraInfo != null },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'itt-edit', to: { pathname: '/thanh-tra/chinh-sua-cuoc-thanh-tra/' + this.props.item.cuocThanhTraId, state: { fromNotifications: false } } },
                    'Ch\u1EC9nh s\u1EEDa'
                  )
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.keHoachThanhTraInfo === null },
                _react2.default.createElement(_dialog.DeleteDialog, {
                  title: 'Xác nhận',
                  content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a cu\u1ED9c thanh tra n\xE0y kh\xF4ng?',
                  redux: this.props.parent,
                  deleteId: this.props.item.cuocThanhTraId,
                  textHuy: true
                })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.item.keHoachThanhTraInfo !== null },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-link-todo' },
                  _react2.default.createElement(
                    _core.Dialog,
                    {
                      isOpen: this.state.isOpen,
                      onClose: this.closeDialog.bind(this, 'isOpen'),
                      title: 'Hu\u1EF7 cu\u1ED9c thanh tra',
                      className: 'dialog-them-moi-dttt dialog-default wrap-block' },
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl30 pr30 pt20' },
                      _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 c\xF4ng v\u0103n', placeholder: 'Nh\u1EADp...', value: this.state.soCongVanHuyCTT, onChange: this.onChange.bind(this, 'soCongVanHuyCTT'), name: 'soCongVanHuyCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                      _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', value: this.state.ngayQuyetDinhHuyCTT, onChange: this.handleChangeDate.bind(this, 'ngayQuyetDinhHuyCTT'), name: 'ngayQuyetDinhHuyCTT', bindValidator: this, channel: 'formTaoDon', require: true }),
                      _react2.default.createElement(_common.TextArea, { className: 'col-100 mb5', label: 'L\xFD do:', value: this.state.lyDoHuyCTT, onChange: this.onChange.bind(this, 'lyDoHuyCTT'), name: 'lyDoHuyCTT', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 1000 })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl35 pr35' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { ref: 'containerFileDinhKem', name: 'fileDinhKemHuy', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', bindValidator: this, data: this.state.listTaiLieuVanThuHuyCTT, disableTopLine: true, phanLoaiQuyTrinh: 'HUY_CUOC_THANH_TRA', onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChangeDK.bind(this) })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'mt10' },
                      _react2.default.createElement('div', { className: 'big-border' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'action-form-wrap pt20' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-bottom' },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpen') },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u0110\xF3ng'
                          )
                        ),
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { className: 'btn-action btn-save', onClick: this.handleSave.bind(this) },
                          _react2.default.createElement(
                            'span',
                            null,
                            'L\u01B0u'
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachCuocThanhTraPage;
}(_react2.default.Component);

RowItemDanhSachCuocThanhTraPage.defaultProps = {
  validators: {
    formTaoDon: []
  }
};
exports.default = RowItemDanhSachCuocThanhTraPage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachDoiTuongTrung = function (_React$Component) {
  _inherits(RowItemDanhSachDoiTuongTrung, _React$Component);

  function RowItemDanhSachDoiTuongTrung() {
    _classCallCheck(this, RowItemDanhSachDoiTuongTrung);

    return _possibleConstructorReturn(this, (RowItemDanhSachDoiTuongTrung.__proto__ || Object.getPrototypeOf(RowItemDanhSachDoiTuongTrung)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachDoiTuongTrung, [{
    key: 'render',
    value: function render() {
      var Data = this.props.item || {};
      var UrlCTTTKH = '';
      if (Data.cuocThanhTra && Data.cuocThanhTra.cuocThanhTraId) {
        UrlCTTTKH = Data.cuocThanhTra.cuocThanhTraId;
      }
      var detailUrl = '/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/' + UrlCTTTKH;
      if (Data.cuocThanhTra && Data.cuocThanhTra.keHoachThanhTraInfo && Data.cuocThanhTra.keHoachThanhTraInfo.keHoachThanhTraId) {
        detailUrl = '/thanh-tra/chi-tiet-ke-hoach-trung/' + Data.cuocThanhTra.keHoachThanhTraInfo.keHoachThanhTraId;
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: detailUrl },
            Data.doiTuongThanhTraTrung ? Data.doiTuongThanhTraTrung.ten : ''
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.noiDungThanhTra ? Data.cuocThanhTra.noiDungThanhTra : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.hinhThucThanhTraChuyenNganhInfo !== null ? Data.cuocThanhTra.hinhThucThanhTraChuyenNganhInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.thoiHanThanhTra ? Data.cuocThanhTra.thoiHanThanhTra : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.kyThanhTra ? Data.cuocThanhTra.kyThanhTra : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.thoiGianTienHanh ? Data.cuocThanhTra.thoiGianTienHanh : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.donViInfo ? Data.cuocThanhTra.donViInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          Data.cuocThanhTra && Data.cuocThanhTra.keHoachThanhTraInfo ? Data.cuocThanhTra.keHoachThanhTraInfo.namThanhTra : Data.cuocThanhTra.namThanhTra || ''
        )
      );
    }
  }]);

  return RowItemDanhSachDoiTuongTrung;
}(_react2.default.Component);

exports.default = RowItemDanhSachDoiTuongTrung;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachKeHoachThanhTra = function (_React$Component) {
  _inherits(RowItemDanhSachKeHoachThanhTra, _React$Component);

  function RowItemDanhSachKeHoachThanhTra() {
    _classCallCheck(this, RowItemDanhSachKeHoachThanhTra);

    return _possibleConstructorReturn(this, (RowItemDanhSachKeHoachThanhTra.__proto__ || Object.getPrototypeOf(RowItemDanhSachKeHoachThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachKeHoachThanhTra, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thanh-tra/chi-tiet-ke-hoach/' + (0, _lodash.get)(this.props.item, 'keHoachThanhTraId') },
            'K\u1EBF ho\u1EA1ch ' + (this.props.item.loaiKeHoach.value === 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + (0, _lodash.get)(this.props.item, 'namThanhTra') + ' ' + (this.props.item && this.props.item.keHoacThanhTraCuInfo ? '(sửa đổi, bổ sung lần 1)' : '')
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          (0, _lodash.get)(this.props.item, 'quyetDinhPheDuyetKTTT')
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayRaQuyetDinh ? (0, _moment2.default)(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'soCuocThanhTra')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTraInfo.text')
        ),
        _react2.default.createElement(
          'td',
          null,
          !this.props.item.daCoKeHoachBoSung && this.props.item.choPhepChinhSua && _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            (0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTra') === 'DA_CO_QUYET_DINH' && _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-edit', to: { pathname: '/thanh-tra/dieu-chinh-ke-hoach-da-phe-duyet/' + this.props.item.keHoachThanhTraId, state: { data: this.props.item, keHoachDaCoQuyetDinh: true } } },
                '\u0110i\u1EC1u ch\u1EC9nh'
              )
            ),
            ((0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTra') === "DANG_SOAN" || (0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTra') === "CHO_RA_QUYET_DINH") && _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-edit', to: { pathname: '/thanh-tra/chinh-sua-ke-hoach/' + this.props.item.keHoachThanhTraId, state: { keHoachDaCoQuyetDinh: false } } },
                'Ch\u1EC9nh s\u1EEDa'
              )
            ),
            (0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTra') === "DANG_SOAN" && _react2.default.createElement(_dialog.DeleteDialog, {
              title: 'Xác nhận',
              content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a k\u1EBF ho\u1EA1ch n\xE0y kh\xF4ng?',
              redux: this.props.parent,
              deleteId: this.props.item.keHoachThanhTraId
            })
          )
        )
      );
    }
  }]);

  return RowItemDanhSachKeHoachThanhTra;
}(_react2.default.Component);

exports.default = RowItemDanhSachKeHoachThanhTra;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachKeHoachThanhTraDaPheDuyet = function (_React$Component) {
  _inherits(RowItemDanhSachKeHoachThanhTraDaPheDuyet, _React$Component);

  function RowItemDanhSachKeHoachThanhTraDaPheDuyet() {
    _classCallCheck(this, RowItemDanhSachKeHoachThanhTraDaPheDuyet);

    return _possibleConstructorReturn(this, (RowItemDanhSachKeHoachThanhTraDaPheDuyet.__proto__ || Object.getPrototypeOf(RowItemDanhSachKeHoachThanhTraDaPheDuyet)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachKeHoachThanhTraDaPheDuyet, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/thanh-tra/chi-tiet-ke-hoach-da-phe-duyet/' + this.props.item.keHoachThanhTraId },
            'K\u1EBF ho\u1EA1ch ' + (this.props.item.loaiKeHoach.value == 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + (0, _lodash.get)(this.props.item, 'namThanhTra') + ' ' + ((0, _lodash.get)(this.props.item, 'keHoacThanhTraCuInfo') ? '(sửa đổi, bổ sung lần 1)' : '')
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          (0, _lodash.get)(this.props.item, 'quyetDinhPheDuyetKTTT')
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayRaQuyetDinh ? (0, _moment2.default)(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'soCuocThanhTra')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'trangThaiKeHoachThanhTraInfo.text')
        )
      );
    }
  }]);

  return RowItemDanhSachKeHoachThanhTraDaPheDuyet;
}(_react2.default.Component);

exports.default = RowItemDanhSachKeHoachThanhTraDaPheDuyet;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachThemMoiThanhTra = function (_React$Component) {
  _inherits(RowItemDanhSachThemMoiThanhTra, _React$Component);

  function RowItemDanhSachThemMoiThanhTra() {
    _classCallCheck(this, RowItemDanhSachThemMoiThanhTra);

    return _possibleConstructorReturn(this, (RowItemDanhSachThemMoiThanhTra.__proto__ || Object.getPrototypeOf(RowItemDanhSachThemMoiThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachThemMoiThanhTra, [{
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          nhomDoiTuongThanhTraInfo = _props$item.nhomDoiTuongThanhTraInfo,
          ma = _props$item.ma,
          quanHuyenInfo = _props$item.quanHuyenInfo,
          phuongXaInfo = _props$item.phuongXaInfo,
          diaChi = _props$item.diaChi;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(nhomDoiTuongThanhTraInfo, 'ten')
        ),
        _react2.default.createElement(
          'td',
          null,
          ma
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(quanHuyenInfo, 'name')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(phuongXaInfo, 'name')
        ),
        _react2.default.createElement(
          'td',
          null,
          diaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap txt-center' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-remove', onClick: this.props.parent.hanldeRemove.bind(this.props.parent, this.props.count - 1) },
                'Lo\u1EA1i'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachThemMoiThanhTra;
}(_react2.default.Component);

exports.default = RowItemDanhSachThemMoiThanhTra;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDoiTuongThanhTra = function (_React$Component) {
  _inherits(RowItemDoiTuongThanhTra, _React$Component);

  function RowItemDoiTuongThanhTra() {
    _classCallCheck(this, RowItemDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (RowItemDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemDoiTuongThanhTra, [{
    key: 'handleEdit',
    value: function handleEdit() {
      this.props.handleEdit(this.props.item.doiTuongViPhamId);
    }
  }, {
    key: 'render',
    value: function render() {
      var titleButton = 'Chỉnh sửa';
      if (this.props.item.trangThaiDoiTuongViPhamInfo && this.props.item.trangThaiDoiTuongViPhamInfo.type == 'HOAN_THANH') {
        titleButton = 'Bổ sung thông tin';
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'linhVucKetQuaThanhTra.ten', '')
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.trangThaiDoiTuongViPhamInfo ? this.props.item.trangThaiDoiTuongViPhamInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-edit', onClick: this.handleEdit.bind(this) },
                titleButton
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.trangThaiDoiTuongViPhamInfo.type != 'HOAN_THANH' },
              _react2.default.createElement(_dialog.DeleteDialog, {
                title: 'Xác nhận',
                content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a \u0111\u1ED1i t\u01B0\u1EE3ng vi ph\u1EA1m n\xE0y kh\xF4ng?',
                redux: this.props.parent,
                deleteId: this.props.item.doiTuongViPhamId
              })
            )
          )
        )
      );
    }
  }]);

  return RowItemDoiTuongThanhTra;
}(_react2.default.Component);

RowItemDoiTuongThanhTra.defaultProps = {
  handleEdit: function handleEdit() {
    console.log('Need append handleEdit menthod');
  }
};

exports.default = RowItemDoiTuongThanhTra;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(169);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDoiTuongThanhTraView = function (_React$Component) {
  _inherits(RowItemDoiTuongThanhTraView, _React$Component);

  function RowItemDoiTuongThanhTraView(props, context) {
    _classCallCheck(this, RowItemDoiTuongThanhTraView);

    var _this = _possibleConstructorReturn(this, (RowItemDoiTuongThanhTraView.__proto__ || Object.getPrototypeOf(RowItemDoiTuongThanhTraView)).call(this, props, context));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemDoiTuongThanhTraView, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'handleView',
    value: function handleView() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.trangThaiDoiTuongViPhamInfo ? this.props.item.trangThaiDoiTuongViPhamInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'text-13 txt-blue', onClick: this.handleView.bind(this) },
                'Xem chi ti\u1EBFt'
              )
            ),
            _react2.default.createElement(
              _core.Dialog,
              {
                isOpen: this.state.isOpen,
                onClose: this.closeDialog.bind(this),
                title: 'Chi ti\u1EBFt \u0111\u1ED1i t\u01B0\u1EE3ng vi ph\u1EA1m',
                className: 'dialog-default wrap-block' },
              _react2.default.createElement(_subView.DoiTuongKienNghiView, { id: this.props.item.doiTuongViPhamId, closeDialog: this.closeDialog.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, linhVucThanhTra: this.props.linhVucThanhTra })
            )
          )
        )
      );
    }
  }]);

  return RowItemDoiTuongThanhTraView;
}(_react2.default.Component);

RowItemDoiTuongThanhTraView.defaultProps = {
  handleEdit: function handleEdit() {
    console.log('Need append handleEdit menthod');
  }
};

exports.default = RowItemDoiTuongThanhTraView;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaTimKiemThanhTra = function (_React$Component) {
  _inherits(RowItemKetQuaTimKiemThanhTra, _React$Component);

  function RowItemKetQuaTimKiemThanhTra() {
    _classCallCheck(this, RowItemKetQuaTimKiemThanhTra);

    return _possibleConstructorReturn(this, (RowItemKetQuaTimKiemThanhTra.__proto__ || Object.getPrototypeOf(RowItemKetQuaTimKiemThanhTra)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaTimKiemThanhTra, [{
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          nhomDoiTuongThanhTraInfo = _props$item.nhomDoiTuongThanhTraInfo,
          ma = _props$item.ma,
          phuongXaInfo = _props$item.phuongXaInfo,
          quanHuyenInfo = _props$item.quanHuyenInfo,
          diaChi = _props$item.diaChi;

      return _react2.default.createElement(
        'tr',
        { className: 'tr-select' },
        _react2.default.createElement(
          'td',
          { className: 'table-checkbox' },
          _react2.default.createElement(
            'label',
            { className: 'pt-control pt-checkbox pt-large' },
            _react2.default.createElement('input', {
              type: 'checkbox',
              checked: this.props.item.selected || false,
              className: 'pt-large',
              onChange: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item),
              name: 'checkboxKetQua'
            }),
            _react2.default.createElement('span', { className: 'pt-control-indicator' })
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center', onClick: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item) },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: (0, _classnames2.default)({ 'highlighttratrung': this.props.item.daTrung }), onClick: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item) },
          this.props.item.ten
        ),
        _react2.default.createElement(
          'td',
          { onClick: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item) },
          nhomDoiTuongThanhTraInfo && nhomDoiTuongThanhTraInfo.ten ? nhomDoiTuongThanhTraInfo.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { onClick: this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item) },
          ma
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(quanHuyenInfo, 'name')
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(phuongXaInfo, 'name')
        ),
        _react2.default.createElement(
          'td',
          null,
          diaChi
        )
      );
    }
  }]);

  return RowItemKetQuaTimKiemThanhTra;
}(_react2.default.Component);

exports.default = RowItemKetQuaTimKiemThanhTra;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemThanhTraDeXuat = function (_Component) {
  _inherits(RowItemThanhTraDeXuat, _Component);

  function RowItemThanhTraDeXuat() {
    _classCallCheck(this, RowItemThanhTraDeXuat);

    return _possibleConstructorReturn(this, (RowItemThanhTraDeXuat.__proto__ || Object.getPrototypeOf(RowItemThanhTraDeXuat)).apply(this, arguments));
  }

  _createClass(RowItemThanhTraDeXuat, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.doiTuong || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.yKien || ''
        )
      );
    }
  }]);

  return RowItemThanhTraDeXuat;
}(_react.Component);

exports.default = RowItemThanhTraDeXuat;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _datatable = __webpack_require__(52);

var _ThemMoiDoiTuongThanhTra = __webpack_require__(494);

var _ThemMoiDoiTuongThanhTra2 = _interopRequireDefault(_ThemMoiDoiTuongThanhTra);

var _lodash = __webpack_require__(14);

var _config = __webpack_require__(16);

var _core = __webpack_require__(7);

var _exportExcel = __webpack_require__(113);

var _reactRouter = __webpack_require__(2);

var _toastr = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachCuocThanhTra = function (_React$Component) {
  _inherits(DanhSachCuocThanhTra, _React$Component);

  function DanhSachCuocThanhTra(props, context) {
    _classCallCheck(this, DanhSachCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (DanhSachCuocThanhTra.__proto__ || Object.getPrototypeOf(DanhSachCuocThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      news: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucThanhTraList: [],
      chucNangCuocThanhTra: '',
      tenDonViChuTri: '',
      cuocThanhTraNhieuDoiTuong: '',
      donViChuTriList: [],
      allowDelete: true,
      donViChuTriDefault: {
        coQuanQuanLyId: '',
        ten: ''
      },
      noiDungThanhTra: '',
      showDialogDuLieuLoi: false,
      messageDuLieuLoi: '',
      paramsRequestListError: ''
    };
    return _this;
  }

  _createClass(DanhSachCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDonViChuTri();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var data = (0, _lodash.get)(nextProps, 'data.cuocThanhTras');
      if (!(0, _lodash.isEmpty)(nextProps.dataCuocThanhTra)) {
        data = (0, _lodash.get)(nextProps, 'dataCuocThanhTra');
      }
      if (this.props.data != nextProps.data) {
        this.state.data = [];
        data.map(function (item) {
          item.allowEdit = true;
          item.allowDelete = true;
          if ((0, _lodash.get)(item, 'tienDoThanhTraInfo.type') === "LUU_HO_SO") {
            item.allowDelete = false;
            item.allowEdit = false;
          }
          _this2.state.data.push(item);
        });
        this.setState(_extends({}, this.state));
      }

      if (this.props.oldData != nextProps.oldData && !this.state.data.length) {
        nextProps.oldData.cuocThanhTras.map(function (item) {
          item.allowEdit = true;
          item.allowDelete = true;
          if ((0, _lodash.get)(item, 'tienDoThanhTraInfo.type') === "LUU_HO_SO") {
            item.allowDelete = false;
            item.allowEdit = false;
          }
          _this2.state.data.push(item);
        });
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (!_this3.refs.dsctt) return;
        if (res.data) {
          _this3.state.linhVucThanhTraList = res.data;
        } else {
          _this3.state.linhVucThanhTraList = [];
        }
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this4 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (!_this4.refs.dsctt) return;
        var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        if (res.data && res.data._embedded) {
          _this4.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
          res.data._embedded.coQuanQuanLies.map(function (item) {
            if (item.coQuanQuanLyId == userInfo.donViId) {
              _this4.state.donViChuTriDefault = {
                coQuanQuanLyId: item.coQuanQuanLyId,
                ten: item.ten
              };
            }
          });
        } else {
          _this4.state.donViChuTriList = [];
        }
        _this4.setState(_extends({}, _this4.state));
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(item, index) {
      if (item.id) {
        this.props.onRemove(item.id);
      }
      this.state.data.splice(index, 1);
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'saveThanhTra',
    value: function saveThanhTra(data) {
      this.state.donViChuTriDefault = {
        coQuanQuanLyId: data.donViChuTriId,
        ten: data.tenDonViChuTriInfo
      };

      var newItem = _extends({}, data, {
        cuocThanhTraNhieuDoiTuong: data.cuocThanhTraNhieuDoiTuong,
        donViChuTriInfo: this.state.donViChuTriDefault,
        tenDonViChuTri: this.state.tenDonViChuTri
      });
      this.state.data.push(newItem);
      this.props.dispatch({
        type: 'LOAD_DATA',
        data: this.state.data
      });
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'handleExportData',
    value: function handleExportData(data) {
      var _this5 = this;

      var idList = [];
      this.state.data.map(function (item) {
        idList.push(item.doiTuongThanhTraId);
      });
      data.map(function (item) {
        if (idList.indexOf(item.doiTuongThanhTraId) == -1) {
          var newItem = {
            doiTuongThanhTraInfo: item,
            donViChuTriInfo: _this5.state.donViChuTriDefault,
            donViPhoiHop: '',
            kyThanhTra: '',
            linhVucThanhTraInfo: {
              text: '',
              type: ''
            },
            thoiHanThanhTra: ''
          };
          _this5.state.data.push(newItem);
        }
      });
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'onSave',
    value: function onSave(data, index) {
      this.state.data[index] = data;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra') || (0, _lodash.get)(this.props, 'isKiemTra');
      return result;
    }
  }, {
    key: 'handleExportExampleKiemTra',
    value: function handleExportExampleKiemTra() {
      var URL = String(_config.API_URL) + "/cuoc-thanh-kiem-tra/download-import-template";
      (0, _exportExcel.exportExcel)(URL, 'import-template-kiem-tra.xlsx');
    }
  }, {
    key: 'handleImportExampleKiemTra',
    value: function handleImportExampleKiemTra(res, params) {
      var _this6 = this;

      var result = [];
      var countDuLieuLoi = 0;
      if (!(0, _lodash.isEmpty)(res.data.dsCuocThanhTra)) {
        result = [].concat(_toConsumableArray(this.state.data), _toConsumableArray((0, _lodash.get)(res.data, 'dsCuocThanhTra')));
      } else {
        result = [].concat(_toConsumableArray(this.state.data));
      }

      if (!(0, _lodash.isEmpty)(res.data.duLieuLoi)) {
        countDuLieuLoi = (0, _lodash.get)(res.data, 'duLieuLoi').length;
        this.setState(_extends({}, this.state, {
          paramsRequestListError: params
        }));
      }
      this.setState(_extends({}, this.state, {
        data: result
      }));
      this.props.onChange(result);
      if (countDuLieuLoi > 0) {
        this.setState(_extends({}, this.state, {
          messageDuLieuLoi: 'Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra v\u1EEBa t\u1EA3i l\xEAn c\xF3 ' + countDuLieuLoi + ' \u0111\u1ED1i t\u01B0\u1EE3ng kh\xF4ng c\xF3 trong danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra. Vui l\xF2ng b\u1EA5m t\u1EA3i xu\u1ED1ng danh s\xE1ch l\u1ED7i \u0111\u1EC3 ki\u1EC3m tra l\u1EA1i'
        }), function () {
          _this6.toggleDialogDuLieuLoi();
        });
      }
    }
  }, {
    key: 'handleDownloadDuLieuLoi',
    value: function handleDownloadDuLieuLoi(dataError) {
      var a = document.createElement("a");
      var url = window.URL.createObjectURL(dataError);
      a.href = url;
      a.download = 'filedulieuloi.xlsx';
      a.click();
    }
  }, {
    key: 'handleDownloadListErrorFile',
    value: function handleDownloadListErrorFile() {
      var _this7 = this;

      _api.Reception.actions.postImportCuocKiemTra.request('', this.state.paramsRequestListError).then(function (res) {
        if (res.data) {
          _this7.handleDownloadDuLieuLoi(res.data);
        }
      }).catch(function (error) {
        (0, _toastr.Toastr)((0, _lodash.get)(error, 'response.data.errors[0].detail'), 'error');
      });
    }
  }, {
    key: 'toggleDialogDuLieuLoi',
    value: function toggleDialogDuLieuLoi() {
      this.setState(_extends({}, this.state, {
        showDialogDuLieuLoi: !this.state.showDialogDuLieuLoi
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var checkKeHoach = this.props.keHoach && this.props.keHoach.keHoachDaCoQuyetDinh;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block', ref: 'dsctt' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 heading-addnew-dttt' },
          _react2.default.createElement(
            'h2',
            { className: 'title-13 col-100 pt10 pl20 pr20 pb15' },
            '1.1 Danh m\u1EE5c cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
          ),
          _react2.default.createElement(_ThemMoiDoiTuongThanhTra2.default, { isKiemTra: this.checkIsKiemTra(), keHoach: checkKeHoach, namKeHoachThanhTra: this.props.namKeHoachThanhTra ? this.props.namKeHoachThanhTra : this.props.oldData.namThanhTra, saveThanhTra: this.saveThanhTra.bind(this), exportData: this.handleExportData.bind(this), importData: this.state.data })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 ' },
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: this.props.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? _table.header.thanhTra.DKKHTT2 : _table.header.thanhTra.DKKHTT,
              plusColum: 1,
              dataList: this.state.data,
              hideButtonExport: true,
              hidePagination: true,
              pageData: this.state.pageData, parent: this,
              tableLoading: this.state.tableLoading,
              isKiemTra: this.checkIsKiemTra(),
              handleExportExampleKiemTra: this.handleExportExampleKiemTra.bind(this),
              handleImportEmxampleKiemTra: this.handleImportExampleKiemTra.bind(this)
            },
            _react2.default.createElement(_datatable.RowItemDanhSachCuocThanhTra, { keHoach: checkKeHoach, onSave: this.onSave.bind(this), isSubmit: this.props.isSubmit, tenDonViChuTri: this.state.tenDonViChuTri, namKeHoachThanhTra: this.props.namKeHoachThanhTra })
          ),
          !(0, _lodash.isEmpty)(this.state.data) && _react2.default.createElement(
            'div',
            { className: 'pl20 pr20 pb10' },
            _react2.default.createElement(_core.Button, { className: 'btn-green tt-export', text: 'Xu\u1EA5t Excel', onClick: this.props.handleExport })
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.showDialogDuLieuLoi,
              onClose: this.toggleDialogDuLieuLoi.bind(this),
              title: 'Th\xF4ng b\xE1o',
              className: 'panel-popup category medium',
              style: { width: 350 }
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body' },
              this.state.messageDuLieuLoi
            ),
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-footer' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: this.toggleDialogDuLieuLoi.bind(this), className: 'btn-action btn-close' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: "btn-action btn-save", onClick: this.handleDownloadListErrorFile.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'T\u1EA3i xu\u1ED1ng danh s\xE1ch l\u1ED7i'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachCuocThanhTra;
}(_react2.default.Component);

DanhSachCuocThanhTra.defaultProps = {
  data: {},
  oldData: {},
  dataCuocThanhTra: []
};

function bindStateToProps(state) {
  return {
    dataCuocThanhTra: state.dataCuocThanhTra.data,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(DanhSachCuocThanhTra);

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _datatable = __webpack_require__(52);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _toastr = __webpack_require__(11);

var _utils = __webpack_require__(4);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _ttForms = __webpack_require__(19);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(14);

var _config = __webpack_require__(16);

var _downloadExcel = __webpack_require__(170);

var _message = __webpack_require__(10);

var _common2 = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogChinhSuaCuocThanhTra = function (_React$Component) {
  _inherits(DialogChinhSuaCuocThanhTra, _React$Component);

  function DialogChinhSuaCuocThanhTra(props, context) {
    _classCallCheck(this, DialogChinhSuaCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (DialogChinhSuaCuocThanhTra.__proto__ || Object.getPrototypeOf(DialogChinhSuaCuocThanhTra)).call(this, props, context));

    _this.state = {
      isOpen: false,
      isOpenDT: false,
      isOpenThongBao: false,
      checkDonViPhoiHop: false,
      namThanhTra: '',
      getTenDoiTuong: [],
      getDSDTDeXuatXuLy: [],
      getDSDTDeXuatXuLys: [],
      idPushCoQuan: [],
      loading: false,
      ketQuaTimKiemList: [],
      nhomDTList: [],
      dataLinhVucThanhTra: [],
      nhomDoiTuongThanhTraId: '',
      hinhThucKHTTList: [],
      chucNangCuocThanhTra: '',
      hinhThucThanhTraChuyenNganh: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucId: '',
      tuKhoa: '',
      tableLoading: false,
      doiTuongThanhTras: _this.props.data && _this.props.data.listDoiTuongThanhTra && _this.props.data.listDoiTuongThanhTra.length > 0 ? _this.props.data.listDoiTuongThanhTra : [],
      data: {
        tenMotDoiTuongThanhTra: '',
        doiTuongThanhTrasList: [],
        ten: '',
        doiTuongThanhTraInfo: [],
        tenNhieuDoiTuongThanhTra: '',
        thoiGianTienHanh: '',
        noiDungThanhTra: '',
        donViChuTriInfo: {
          coQuanQuanLyId: null,
          ten: ''
        },
        cuocThanhTraNhieuDoiTuong: _this.props.data.cuocThanhTraNhieuDoiTuong ? _this.props.data.cuocThanhTraNhieuDoiTuong : !_this.props.data.cuocThanhTraNhieuDoiTuong,
        cuocThanhTraNhieuDoiTuongList: {
          text: "",
          type: ''
        },
        donViPhoiHop: [],
        doiTuongThanhTraId: '',
        doiTuongThanhTras: [],
        kyThanhTra: '',
        linhVucThanhTraList: [],
        hinhThucThanhTraChuyenNganhInfo: {
          text: '',
          type: ''
        },
        thucHienPhapLuatVeThanhTraList: [],
        chiTietLinhVuc: '',
        chucNangCuocThanhTraInfo: {
          text: '',
          type: ''
        },
        thoiHanThanhTra: '',
        kyTruocChuyenSang: false,
        daCoKetQuaDeXuat: false,
        phoiHopXuLy: false

      },
      linhVucList: [],
      dataDonViChuTri: [],
      danhSachDonViPhoiHop: [],
      hinhThucThanhTraChuyenNganhList: [],
      thucHienPhapLuatVeThanhTraListCombobox: [],
      cuocThanhTraNhieuDoiTuongList: [{
        giaTri: 'true',
        ten: "Thanh tra nhiều đối tượng"
      }, {
        giaTri: 'false',
        ten: "Thanh tra một đối tượng"
      }],
      thucHienPhapLuatVeThanhTra: '',
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      dataSelectDoiTuongCurrent: [],
      tempDataSelectDoiTuongCurrent: [],
      arrThemMoiIds: [],
      arrXoaIds: [],
      hasDataDeXuat: false,
      loadingSave: false,
      numberUnsuccess: 0,
      loadingImport: false,
      base64Content: '',
      fileName: '',
      mineType: '',
      maSoThue: '',
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      validLinhVucThanhTra: true
    };
    return _this;
  }

  _createClass(DialogChinhSuaCuocThanhTra, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
        this.getDSDTDeXuatXuLy();
        this.getNhomDoiTuong();
        this.forceUpdate();
        this.getLinhVucThanhTra();
        this.getThucHienPhapLuatVeTT();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!(0, _lodash.isEmpty)(this.props.data.listDoiTuongThanhTra)) {
        var dataSelectDoiTuongCurrent = (0, _lodash.get)(this.props.data, 'listDoiTuongThanhTra');
        var newItem = [];
        var state = this.state;
        this.props.data.listDoiTuongThanhTra.forEach(function (items) {
          newItem.push({
            id: items.doiTuongThanhTraId,
            ten: items.ten
          });
        });
        state.dataSelectDoiTuongCurrent = dataSelectDoiTuongCurrent;
        this.setState({
          doiTuongThanhTras: newItem,
          ten: this.props.data.ten ? this.props.data.ten : '',
          tenNhieuDoiTuongThanhTra: this.props.data.tenNhieuDoiTuongThanhTra ? this.props.data.tenNhieuDoiTuongThanhTra : '',
          thoiGianTienHanh: this.props.data.thoiGianTienHanh,
          hinhThucThanhTraChuyenNganh: this.props.data.hinhThucThanhTraChuyenNganh,
          data: _extends({}, state, {
            linhVucThanhTraList: this.props.data.linhVucThanhTraList && this.props.data.linhVucThanhTraList.map(function (item) {
              return item.giaTri;
            }),
            chiTietLinhVuc: this.props.data.chiTietLinhVuc,
            thucHienPhapLuatVeThanhTraList: this.props.data.thucHienPhapLuatVeThanhTraList && this.props.data.thucHienPhapLuatVeThanhTraList.map(function (item) {
              return item.giaTri;
            })
          })
        });
      } else {
        var _dataSelectDoiTuongCurrent = (0, _lodash.get)(this.props.data, 'listDoiTuongThanhTra');
        var _state = this.state;
        _state.dataSelectDoiTuongCurrent = _dataSelectDoiTuongCurrent;

        this.setState({
          doiTuongThanhTras: this.props.data.doiTuongThanhTras,
          ten: this.props.data.ten ? this.props.data.ten : '',
          tenNhieuDoiTuongThanhTra: this.props.data.tenNhieuDoiTuongThanhTra ? this.props.data.tenNhieuDoiTuongThanhTra : '',
          thoiGianTienHanh: this.props.data.thoiGianTienHanh,
          hinhThucThanhTraChuyenNganh: this.props.data.hinhThucThanhTraChuyenNganh,
          data: _extends({}, _state, {
            linhVucThanhTraList: this.props.data.linhVucThanhTraList && this.props.data.linhVucThanhTraList.map(function (item) {
              return item.giaTri;
            }),
            chiTietLinhVuc: this.props.data.chiTietLinhVuc,
            thucHienPhapLuatVeThanhTraList: this.props.data.thucHienPhapLuatVeThanhTraList && this.props.data.thucHienPhapLuatVeThanhTraList.map(function (item) {
              return item.giaTri;
            })
          })
        });
      }

      this.getLinhVuc();
      this.getNhomDoiTuong();
      this.getDonViChuTri();
      this.getHinhThucThanhTraChuyenNganh();
      this.getThucHienPhapLuatVeTT();
      this.getHinhThucKeHoachThanhTra();
      this.getLinhVucThanhTra();
      this.getChucNangCuocThanhTra();
      this.getDoiTuongThanhTra();
      this.getDSDTDeXuatXuLy();
      this.getQuanHuyen();
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this2 = this;

      var state = this.state;
      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          state.dataLinhVucThanhTra = res.data;
        }
        _this2.setState(state);
      });
    }
  }, {
    key: 'getNhomDoiTuong',
    value: function getNhomDoiTuong() {
      var _this3 = this;

      _api.ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(function (res) {
        if (res.data._embedded) {
          _this3.setState({ nhomDTList: res.data._embedded.nhomDoiTuongThanhTras });
        }
      });
    }
  }, {
    key: 'getQuanHuyen',
    value: function getQuanHuyen() {
      var _this4 = this;

      _api.DuLieuHeThong.actions.getQuanHuyen.request().then(function (res) {
        if (res.data._embedded) {
          _this4.setState({
            dsQuanHuyen: res.data._embedded.donViHanhChinhs
          });
        }
      });
    }
  }, {
    key: 'getPhuongXa',
    value: function getPhuongXa() {
      var _this5 = this;

      var quanHuyenId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (quanHuyenId) {
        _api.DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(function (res) {
          _this5.setState({
            dsPhuongXa: (0, _lodash.get)(res, 'data._embedded.donViHanhChinhs') || []
          });
        });
      }
    }
  }, {
    key: 'getHinhThucKeHoachThanhTra',
    value: function getHinhThucKeHoachThanhTra() {
      var _this6 = this;

      _api.ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(function (res) {
        if (res.data) {
          _this6.state.hinhThucKHTTList = res.data;
        } else {
          _this6.state.hinhThucKHTTList = [];
        }
        _this6.setState(_extends({}, _this6.state));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data) {
        var getDSDTDeXuatXuLy = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLy));
        var getDSDTDeXuatXuLys = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLys));
        var dataSelectDoiTuongCurrent = [];
        var arrThemMoi = [].concat(_toConsumableArray(this.state.arrThemMoiIds));
        var state = this.state;
        if (!(0, _lodash.isEmpty)(nextProps.data.listDoiTuongThanhTra)) {
          dataSelectDoiTuongCurrent = (0, _lodash.get)(nextProps.data, 'listDoiTuongThanhTra');
        } else {
          dataSelectDoiTuongCurrent = (0, _lodash.get)(nextProps.data, 'doiTuongThanhTrasList');
        }
        state.dataSelectDoiTuongCurrent = dataSelectDoiTuongCurrent;
        if ((0, _lodash.isEmpty)(this.state.arrThemMoiIds) && (0, _lodash.isArray)(dataSelectDoiTuongCurrent)) {
          arrThemMoi = dataSelectDoiTuongCurrent && dataSelectDoiTuongCurrent.map(function (item) {
            return item.doiTuongThanhTraId;
          });
        }
        var arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(';') : [];
        var danhSachDonViPhoiHop = [];
        arrDv.map(function (item) {
          danhSachDonViPhoiHop.push({ ten: item });
        });
        if (!(0, _lodash.isEmpty)(nextProps.totalDataDeXuat)) {
          var getDeXuat = nextProps.totalDataDeXuat.find(function (item) {
            return item.id === nextProps.idCS;
          });
          if (!(0, _lodash.isEmpty)(getDeXuat)) {
            getDSDTDeXuatXuLy = getDeXuat.dataDeXuat;
            getDSDTDeXuatXuLys = getDeXuat.dataDeXuats;
          }
        }
        this.setState(_extends({}, this.state, {
          danhSachDonViPhoiHop: danhSachDonViPhoiHop,
          data: _extends({}, nextProps.data, {
            donViChuTriInfo: _extends({}, nextProps.data.donViChuTriInfo),
            linhVucThanhTraInfo: _extends({}, nextProps.data.linhVucThanhTraInfo),
            hinhThucThanhTraChuyenNganhInfo: _extends({}, nextProps.data.hinhThucThanhTraChuyenNganhInfo),
            thucHienPhapLuatVeThanhTraInfo: _extends({}, nextProps.data.thucHienPhapLuatVeThanhTraInfo),
            doiTuongThanhTras: nextProps.data.doiTuongThanhTras ? [].concat(_toConsumableArray(nextProps.data.doiTuongThanhTras)) : [],
            thucHienPhapLuatVeThanhTraList: nextProps.data.thucHienPhapLuatVeThanhTraList && nextProps.data.thucHienPhapLuatVeThanhTraList.map(function (item) {
              return (0, _lodash.isString)(item) ? item : item.giaTri;
            }),
            hinhThucThanhTraChuyenNganh: nextProps.data.hinhThucThanhTraChuyenNganh,
            linhVucThanhTraList: nextProps.data.linhVucThanhTraList && nextProps.data.linhVucThanhTraList.map(function (item) {
              return (0, _lodash.isString)(item) ? item : item.giaTri;
            }),
            chiTietLinhVuc: nextProps.data.chiTietLinhVuc
          }),
          getDSDTDeXuatXuLy: getDSDTDeXuatXuLy,
          getDSDTDeXuatXuLys: getDSDTDeXuatXuLys,
          arrThemMoiIds: arrThemMoi
        }));
      }
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this7 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data._embedded) {
          _this7.setState({
            dataDonViChuTri: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThanhTraChuyenNganh',
    value: function getHinhThucThanhTraChuyenNganh() {
      var state = this.state;
      _api.ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(function (res) {
        if (res.data) {
          state.hinhThucThanhTraChuyenNganhList = res.data;
        }
      });
      this.setState(state);
    }
  }, {
    key: 'getThucHienPhapLuatVeTT',
    value: function getThucHienPhapLuatVeTT() {
      var state = this.state;
      _api.ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(function (res) {
        if (res.data) {
          state.thucHienPhapLuatVeThanhTraListCombobox = res.data;
        }
      });
      this.setState(state);
    }
  }, {
    key: 'getLinhVuc',
    value: function getLinhVuc() {
      var _this8 = this;

      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(function (res) {
        var linhVucList = [];
        if (res.data && res.data._embedded) {
          linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
        } else {
          linhVucList = [];
        }
        _this8.setState({ linhVucList: linhVucList });
      });
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(arr, value, e) {
      var _this9 = this;

      if (arr === 'doiTuongThanhTras' && typeof value != 'undefined') {
        value.preventDefault();
      } else if (arr === 'danhSachDonViPhoiHop' && typeof e != 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == _this9.state[value];
      });
      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState2;

          var newItem = {
            ten: this.state[value]
          };
          this.setState((_setState2 = {}, _defineProperty(_setState2, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState2, value, ''), _setState2));
        }
      }
      return;
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(arr, index) {
      var _extends2;

      var newData = [].concat(_toConsumableArray(this.state[arr]));
      var getDSDTDeXuatXuLy = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLy));
      var getDSDTDeXuatXuLys = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLys));
      var doiTuongXoaIds = [].concat(_toConsumableArray(this.state.arrXoaIds));
      var doiTuongThanhTra = this.state.doiTuongThanhTras || {};
      newData.splice(index, 1);
      if (newData.length > 1) {
        this.state.data.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.data.cuocThanhTraNhieuDoiTuong = false;
      }
      var delItem = doiTuongThanhTra.find(function (item, i) {
        return i === index;
      });
      var delArr = getDSDTDeXuatXuLy.filter(function (item) {
        return item.id !== delItem.id;
      });
      var delArrs = getDSDTDeXuatXuLys.filter(function (item) {
        return item !== delItem.id;
      });
      var arrThemMoi = newData.map(function (item) {
        return item.id;
      });
      doiTuongXoaIds.push(delItem.id);
      this.setState(_extends({}, this.state, (_extends2 = {
        getDSDTDeXuatXuLy: delArr,
        getDSDTDeXuatXuLys: delArrs
      }, _defineProperty(_extends2, arr, newData), _defineProperty(_extends2, 'arrThemMoiIds', arrThemMoi), _defineProperty(_extends2, 'arrXoaIds', doiTuongXoaIds), _extends2)));
    }
  }, {
    key: 'checkDuplicate',
    value: function checkDuplicate(arr) {
      if ((0, _lodash.isArray)(arr)) {
        var checkDuplicateArr = (0, _lodash.uniqBy)(arr, 'doiTuongThanhTraId');
        return checkDuplicateArr;
      }
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra');
      return result;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this10 = this;

      if (this.validateSubmitForm()) {
        //DonViChuTri
        var checkDVCT = this.state.dataDonViChuTri.findIndex(function (item) {
          return item.coQuanQuanLyId === _this10.state.data.donViChuTriInfo.coQuanQuanLyId;
        });
        if (checkDVCT !== -1) this.state.data.donViChuTriInfo.ten = this.state.dataDonViChuTri[checkDVCT].ten;
        //ChucNangCuocThanhTra
        var checkCNCTT = this.state.dataChucNangCuocThanhTra.findIndex(function (item) {
          return item.giaTri === _this10.state.data.chucNangCuocThanhTraInfo.type;
        });
        if (checkCNCTT !== -1) this.state.data.chucNangCuocThanhTraInfo.text = this.state.dataChucNangCuocThanhTra[checkCNCTT].ten;
        //danhSachDonViPhoiHop
        var listDV = [];
        this.state.danhSachDonViPhoiHop.forEach(function (item) {
          listDV.push(item.ten);
        });
        this.state.data.donViPhoiHop = listDV.join('; ');
        //hinhThucThanhTraChuyenNganh
        var checkHTTTCN = this.state.hinhThucThanhTraChuyenNganhList.findIndex(function (item) {
          return item.giaTri === _this10.state.data.hinhThucThanhTraChuyenNganhInfo.type;
        });
        if (checkHTTTCN !== -1) this.state.data.hinhThucThanhTraChuyenNganhInfo.text = this.state.hinhThucThanhTraChuyenNganhList[checkHTTTCN].ten;
        //thucHienPhapLuatVeThanhTra
        // let checkTHPLTT = this.state.thucHienPhapLuatVeThanhTraList.findIndex(item => item.giaTri === this.state.data.thucHienPhapLuatVeThanhTraInfo.type);
        // if (checkTHPLTT !== -1) this.state.data.thucHienPhapLuatVeThanhTraInfo.text = this.state.thucHienPhapLuatVeThanhTraList[checkTHPLTT].ten;
        //get doiTuongThanhTra
        var newItem = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
        var newItems = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
        var getNewItems = [];
        var newListDoiTuong = [];
        var dataDoiTuong = [].concat(_toConsumableArray(this.state.dataSelectDoiTuongCurrent), _toConsumableArray(this.state.tempDataSelectDoiTuongCurrent));
        var idCuocThanhTra = (0, _lodash.get)(this.state.data, 'id') || (0, _lodash.get)(this.props.data, 'id');
        this.state.doiTuongSelectedList.forEach(function (items) {
          newItem.push({
            id: items.doiTuongThanhTraId,
            ten: items.ten
          });
        });
        if (!(0, _lodash.isEmpty)(newItem)) {
          dataDoiTuong.forEach(function (item) {
            newItem.forEach(function (newItem) {
              if (item.doiTuongThanhTraId === newItem.id) {
                newListDoiTuong.push(item);
              }
            });
          });
        }
        var data = this.checkDuplicate(newListDoiTuong);

        if (newItem && newItem.length > 1) {
          this.state.data.doiTuongThanhTraInfo = null;
          newItems.map(function (item) {
            var itemIndex = (0, _lodash.isArray)(_this10.state.dataDoiTuongThanhTra) && _this10.state.dataDoiTuongThanhTra.filter(function (tempItem) {
              return tempItem.doiTuongThanhTraId === item.id || tempItem.doiTuongThanhTraId === item.doiTuongThanhTraId;
            });
            if (itemIndex.length > 0) {
              getNewItems.push(itemIndex[0]);
            }
          });
        } else if (newItem && newItem.length === 1) {
          var indexItem = (0, _lodash.isArray)(this.state.dataDoiTuongThanhTra) && this.state.dataDoiTuongThanhTra.findIndex(function (item) {
            return (0, _lodash.get)(item, 'doiTuongThanhTraId') === (0, _lodash.get)(newItem, '[0].id');
          });
          if (indexItem !== -1) {
            this.state.data.doiTuongThanhTraInfo = this.state.dataDoiTuongThanhTra[indexItem];
            this.state.data.tenMotDoiTuongThanhTra = this.state.dataDoiTuongThanhTra[indexItem].ten;
          }
        }
        this.state.data.ten = this.state.ten;
        this.state.data.thoiGianTienHanh = this.state.thoiGianTienHanh;
        this.state.data.tenNhieuDoiTuongThanhTra = this.state.tenNhieuDoiTuongThanhTra;
        this.state.data.doiTuongThanhTras = newItem;
        this.state.data.doiTuongThanhTrasList = data;
        this.setState(_extends({}, this.state, {
          dataSelectDoiTuongCurrent: data
        }));
        this.props.dispatch({
          type: 'UPDATE_DEXUAT',
          dataDeXuat: this.state.getDSDTDeXuatXuLy,
          dataDeXuats: this.state.getDSDTDeXuatXuLys,
          idCTT: idCuocThanhTra,
          hasXuLy: false
        });
        this.props.dispatch({
          type: 'ADD_DOITUONGID',
          hasDeXuatXuLy: this.state.hasDataDeXuat,
          arrDoiTuongThemMoi: this.state.arrThemMoiIds,
          arrDoiTuongXoa: this.state.arrXoaIds,
          idCTT: idCuocThanhTra
        });
        this.props.onSave(this.state.data);
        this.props.onClose();
      }
    }
  }, {
    key: 'handleSaveDoiTuongThanhTra',
    value: function handleSaveDoiTuongThanhTra() {
      var _this11 = this;

      var newItem = [].concat(_toConsumableArray(this.state.doiTuongThanhTras));
      var getDSDTDeXuatXuLy = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLy));
      var getDSDTDeXuatXuLys = [].concat(_toConsumableArray(this.state.getDSDTDeXuatXuLys));
      var data = [].concat(_toConsumableArray(this.state.doiTuongSelectedList));
      var dataCurrentDoiTuong = [].concat(_toConsumableArray(this.state.tempDataSelectDoiTuongCurrent));
      var arrThemMoi = [].concat(_toConsumableArray(this.state.arrThemMoiIds));
      var arrXoaIds = [].concat(_toConsumableArray(this.state.arrXoaIds));

      data.map(function (item) {
        dataCurrentDoiTuong.push(item);
      });
      this.state.doiTuongSelectedList.forEach(function (items) {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });

      var selectDoiTuongIds = data.map(function (item) {
        return item.doiTuongThanhTraId;
      });

      var newArrXoa = arrXoaIds.filter(function (item) {
        if (selectDoiTuongIds.indexOf(item) === -1) {
          return item;
        }
      });
      // Gộp hai array
      arrThemMoi = (0, _lodash.union)(arrThemMoi, selectDoiTuongIds);
      var getDeXuatCurrent = this.props.dataDXOld.find(function (item) {
        return item.idDeXuatOld === _this11.props.idCS;
      });
      if (!(0, _lodash.isEmpty)(getDeXuatCurrent)) {
        // Lấy ra phần tử giống nhau
        var getDuplicate = (0, _lodash.intersection)(selectDoiTuongIds, getDeXuatCurrent.dataDeXuatsOld);
        if (!(0, _lodash.isEmpty)(getDuplicate)) {
          var deXuatDuplicate = getDeXuatCurrent.dataDeXuatOld.filter(function (item) {
            if (getDuplicate.indexOf(item.id) !== -1) {
              return item;
            }
          });
          var deXuatDuplicateIds = deXuatDuplicate.map(function (item) {
            return item.id;
          });
          // Nối 2 array với nhau
          getDSDTDeXuatXuLy = (0, _lodash.concat)(getDSDTDeXuatXuLy, deXuatDuplicate);
          getDSDTDeXuatXuLys = (0, _lodash.concat)(getDSDTDeXuatXuLys, deXuatDuplicateIds);
        }
      }

      if (newItem && newItem.length > 1) {
        this.state.data.cuocThanhTraNhieuDoiTuong = true;
      } else {
        this.state.data.cuocThanhTraNhieuDoiTuong = false;
      }
      this.setState({
        getDSDTDeXuatXuLy: getDSDTDeXuatXuLy,
        getDSDTDeXuatXuLys: getDSDTDeXuatXuLys,
        doiTuongThanhTras: newItem,
        isOpen: false,
        nhomDoiTuongThanhTraId: '',
        tempDataSelectDoiTuongCurrent: dataCurrentDoiTuong,
        arrThemMoiIds: arrThemMoi,
        arrXoaIds: newArrXoa
      });
      this.state.doiTuongSelectedList = [];
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['editCuocTT'].map(function (validator) {
        if (pass) pass = validator.validate();else {
          validator.validate();
        }
      });
      if (this.state.doiTuongThanhTras.length === 0) {
        (0, _toastr.Toastr)('Ph\u1EA3i ch\u1ECDn \xEDt nh\u1EA5t m\u1ED9t \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), 'error');
        pass = false;
      }
      if ((0, _lodash.isEmpty)(this.state.data.linhVucThanhTraList) && this.state.data.chucNangCuocThanhTraInfo.type !== "CHUYEN_NGANH") {
        this.setState({ validLinhVucThanhTra: false });
        pass = false;
      }
      return pass;
    }
  }, {
    key: 'changeCheckbox',
    value: function changeCheckbox(name, e) {
      this.setState({
        data: _extends({}, this.state.data, _defineProperty({}, name, e.target.checked))
      });
    }
  }, {
    key: 'onChangeTuKhoa',
    value: function onChangeTuKhoa(name, e) {
      this.state.tuKhoa = e.target.value;
    }
  }, {
    key: 'onChangeMaSoThue',
    value: function onChangeMaSoThue(e) {
      this.state.maSoThue = e.target.value;
    }
  }, {
    key: 'onChangeDiaChi',
    value: function onChangeDiaChi(e) {
      this.state.diaChi = e.target.value;
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var state = this.state;
      if (name == 'chiTietLinhVuc') {
        state.data.chiTietLinhVuc = e.target.value;
      } else if (name == 'ten') {
        state.ten = e.target.value;
      } else if (name == 'linhVucId') {
        state.linhVucId = e.target.value;
      } else if (name == 'nhomDoiTuongThanhTraId') {
        state.nhomDoiTuongThanhTraId = e.target.value;
      } else if (name == 'tenNhieuDoiTuongThanhTra') {
        state.tenNhieuDoiTuongThanhTra = e.target.value;
      } else if (name == 'doiTuongThanhTra') {
        state.doiTuongThanhTra = e.target.value;
      } else if (name == 'phamViThanhTra') {
        state.data.kyThanhTra = e.target.value;
      } else if (name == 'thoiHanThanhTra') {
        state.data.thoiHanThanhTra = e.target.value;
      } else if (name == 'thoiGianTienHanh') {
        state.thoiGianTienHanh = e.target.value;
      } else if (name == 'noiDungThanhTra') {
        state.data.noiDungThanhTra = e.target.value;
      } else if (name == 'donViChuTri') {
        state.data.donViChuTriInfo.coQuanQuanLyId = e.target.value;
      } else if (name == 'hinhThucThanhTraChuyenNganh') {
        state.data.hinhThucThanhTraChuyenNganhInfo.type = e.target.value;
      } else if (name == 'chucNangCuocThanhTra') {
        state.data.chucNangCuocThanhTraInfo.type = e.target.value;
      } else if (name == 'linhVucThanhTraList') {
        state.data.linhVucThanhTraList = e.map(function (item) {
          return item.value;
        });
        state.validLinhVucThanhTra = true;
      } else if (name == 'thucHienPhapLuatVeThanhTraList') {
        state.data.thucHienPhapLuatVeThanhTraList = e.map(function (item) {
          return item.value;
        });
      } else if (name == 'quanHuyenId') {
        if (!e.target.value) {
          state.quanHuyenId = e.target.value;
          state.phuongXaId = '';
          state.dsPhuongXa = [];
        } else {
          state.quanHuyenId = e.target.value;
          state.phuongXaId = '';
          this.getPhuongXa(e.target.value);
        }
      } else if (name == 'phuongXaId') {
        state.phuongXaId = e.target.value;
      } else {
        state[name] = e.target.value;
      }
      this.setState(state);
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.timKiem();
      this.state.totalSelectedList = [];
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'timKiem',
    value: function timKiem(statusTimKiem) {
      var _this12 = this;

      this.state.checkAll = false;
      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      var pageData = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      var params = {
        pageData: pageData,
        namThanhTra: getNamTT
      };

      if (statusTimKiem) {
        params.pageData.page = 0;
      }

      if (!(0, _lodash.isEmpty)(this.state.doiTuongThanhTras)) {
        var idsDoiTuong = this.state.doiTuongThanhTras.map(function (item) {
          return item.id;
        });
        this.state.doiTuongSelectedList.forEach(function (item) {
          idsDoiTuong.push(item.doiTuongThanhTraId);
        });
        params.idDoiTuongDaCoCuocs = idsDoiTuong;
      }

      if (this.state.tuKhoa) {
        params.tenDoiTuong = this.state.tuKhoa;
      }
      if (this.state.linhVucId) {
        params.linhVucId = this.state.linhVucId;
      }
      if (this.state.nhomDoiTuongThanhTraId) {
        params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
      }
      if (!(0, _lodash.isEmpty)(this.state.maSoThue)) {
        params.maSoThue = this.state.maSoThue;
      }
      if (this.state.diaChi) {
        params.tuKhoa = this.state.diaChi;
      }
      if (this.state.quanHuyenId) {
        params.quanHuyenId = Number(this.state.quanHuyenId);
      }
      if (this.state.phuongXaId) {
        params.phuongXaId = Number(this.state.phuongXaId);
      }
      this.setState({ tableLoading: true });
      _api.Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(function (res) {
        if (res.data._embedded) {
          var data = (0, _lodash.get)(res, 'data._embedded.doiTuongThanhTras');
          if (!(0, _lodash.isEmpty)(_this12.state.totalSelectedList) && (0, _lodash.isArray)(_this12.state.totalSelectedList)) {
            var newData = data.map(function (item) {
              _this12.state.totalSelectedList.forEach(function (itemDoiTuong) {
                if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                  item.selected = true;
                }
              });
              return item;
            });
            data = newData;
          }
          _this12.setState({
            ketQuaTimKiemList: data,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this12.setState({
            ketQuaTimKiemList: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'getDoiTuongThanhTra',
    value: function getDoiTuongThanhTra() {
      var _this13 = this;

      var d = new Date();
      var getNamTT = d.getFullYear() + 1;
      _api.ThanhTra.actions.getDoiTuongThanhTra.request({ namThanhTra: getNamTT }).then(function (res) {
        if (res.data._embedded) {
          _this13.setState({
            dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
          });
        }
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.timKiem();
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.timKiem();
    }
  }, {
    key: 'hanldeRemove',
    value: function hanldeRemove(index) {
      var _this14 = this;

      var arrThemMoiIds = [].concat(_toConsumableArray(this.state.arrThemMoiIds));
      var doiTuongSelectedList = [].concat(_toConsumableArray(this.state.doiTuongSelectedList));
      var itemDelete = doiTuongSelectedList.find(function (item, i) {
        return i === index;
      });
      var newArrThemMoiIds = arrThemMoiIds.filter(function (item) {
        return item !== itemDelete.doiTuongThanhTraId;
      });
      doiTuongSelectedList.splice(index, 1);
      this.setState(_extends({}, this.state, {
        doiTuongSelectedList: doiTuongSelectedList,
        arrThemMoiIds: newArrThemMoiIds
      }), function () {
        _this14.timKiem();
      });
    }
  }, {
    key: 'kiemTraTenDoiTuong',
    value: function kiemTraTenDoiTuong(idDoiTuong, check) {
      var _this15 = this;

      var d = new Date();
      var getNam = d.getFullYear() + 1;
      var getTenDoiTuong = '';
      _api.ThanhTra.actions.getKiemTraDoiTuongTT.request({
        doiTuongThanhTraId: idDoiTuong,
        namThanhTra: getNam
      }).then(function (res) {
        if (res && res.data) {
          var idPushCoQuan = [];
          res.data._embedded.coQuanQuanLies.map(function (items) {
            idPushCoQuan.push(items.ten);
          });
          var tenDoituong = _this15.state.ketQuaTimKiemList.find(function (items) {
            return items.doiTuongThanhTraId === idDoiTuong;
          });
          if (_this15.state.checked && check) {
            _this15.setState({
              isOpenDT: true,
              getTenDoiTuong: (0, _lodash.get)(tenDoituong, 'ten'),
              idPushCoQuan: idPushCoQuan
            });
          }
          if (check === false) {
            var msgWarning = '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (_this15.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' ' + getTenDoiTuong + (' \u0111\xE3 \u0111\u01B0\u1EE3c ch\u1ECDn l\xE0m \u0111\u1ED1i t\u01B0\u1EE3ng ' + (_this15.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' t\u1EA1i \u0111\u01A1n v\u1ECB: ') + idPushCoQuan;
            (0, _toastr.Toastr)(msgWarning, 'thongbao');
          }
        }
      });
      return 0;
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var check, newtotalSelectedList, _newtotalSelectedList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                check = true;

                item.selected = !item.selected;

                if (!item.selected) {
                  _context.next = 11;
                  break;
                }

                newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));

                if (item.daTrung === true) {
                  this.setState({
                    doiTuongThanhTraId: item.doiTuongThanhTraId
                  });
                }
                newtotalSelectedList.push(item);
                _context.next = 8;
                return this.setState({
                  checked: item.selected,
                  totalSelectedList: newtotalSelectedList
                });

              case 8:
                this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
                _context.next = 14;
                break;

              case 11:
                _newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));

                _newtotalSelectedList.map(function (value, index) {
                  if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
                    _newtotalSelectedList.splice(index, 1);
                  }
                });
                // Toastr(null,'newtotalSelectedList');
                this.setState({
                  totalSelectedList: _newtotalSelectedList
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectedDoiTuong(_x2) {
        return _ref.apply(this, arguments);
      }

      return handleSelectedDoiTuong;
    }()
  }, {
    key: 'suggesttion',
    value: function suggesttion(dataSearch) {
      var _this16 = this;

      this.setState({
        isSearch: true
      }, function () {
        var params = {
          tuKhoa: dataSearch
        };

        if (_this16.state.doiTuongThanhTra) {
          params.doiTuongIds = _this16.state.doiTuongThanhTra;
        }
        _api.Danhmuc.actions.getDoiTuongThanhTra.request(params).then(function (res) {
          if (res.data._embedded) {
            _this16.setState({
              dataSuggest: res.data._embedded.doiTuongThanhTras,
              isSearch: false
            });
          } else {
            _this16.setState({
              dataSuggest: [],
              isSearch: false
            });
          }
        });
      });
    }
  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var _this17 = this;

      var check = false;
      this.state.checkAll = !this.state.checkAll;
      this.state.ketQuaTimKiemList.map(function (item) {
        item.selected = _this17.state.checkAll;
        if (_this17.state.checkAll) {
          _this17.state.totalSelectedList.push(item);
          _this17.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
        } else {
          _this17.state.totalSelectedList = [];
          (0, _toastr.Toastr)(null, 'resetclear');
        }
      });
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'themVaoCuocTT',
    value: function themVaoCuocTT() {
      var _this18 = this;

      var doiTuongSelectedList = [].concat(_toConsumableArray(this.state.doiTuongSelectedList), _toConsumableArray(this.state.totalSelectedList));
      this.state.totalSelectedList = [];
      this.setState({
        doiTuongSelectedList: doiTuongSelectedList,
        totalSelectedList: []
      }, function () {
        _this18.timKiem();
      });
    }
  }, {
    key: 'getChucNangCuocThanhTra',
    value: function getChucNangCuocThanhTra() {
      var _this19 = this;

      _api.ThanhTra.actions.getChucNangCuocThanhTra.request().then(function (res) {
        if (res.data) {
          _this19.setState({
            dataChucNangCuocThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'closeDialogThongBao',
    value: function closeDialogThongBao() {
      this.setState({
        isOpenThongBao: false
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      var _setState3;

      var doiTuongSelectedList = [];
      var tempDataSelectDoiTuongCurrent = [];
      this.setState((_setState3 = {}, _defineProperty(_setState3, name, false), _defineProperty(_setState3, 'tempDataSelectDoiTuongCurrent', tempDataSelectDoiTuongCurrent), _defineProperty(_setState3, 'doiTuongSelectedList', doiTuongSelectedList), _setState3));
    }
  }, {
    key: 'closeDialogDT',
    value: function closeDialogDT(name) {
      var _this20 = this;

      var state = this.state;
      var newtotalSelectedList = [].concat(_toConsumableArray(this.state.totalSelectedList));
      var data = [].concat(_toConsumableArray(this.state.dataSelectDoiTuongCurrent));
      var newketQuaTimKiemList = [].concat(_toConsumableArray(this.state.ketQuaTimKiemList));

      if (this.state.doiTuongThanhTraId) {
        newtotalSelectedList.map(function (value, index) {
          if (value.doiTuongThanhTraId == _this20.state.doiTuongThanhTraId) {
            newtotalSelectedList.splice(index, 1);
            data.splice(index, 1);
          }
        });
      }
      newketQuaTimKiemList.map(function (item) {
        if (item.doiTuongThanhTraId === _this20.state.doiTuongThanhTraId) {
          item.selected = false;
        }
      });
      data.map(function (item) {
        if (item.doiTuongThanhTraId === _this20.state.doiTuongThanhTraId) {
          item.selected = false;
        }
      });
      state.isOpenDT = false;
      this.setState({
        totalSelectedList: newtotalSelectedList,
        ketQuaTimKiemList: newketQuaTimKiemList,
        dataSelectDoiTuongCurrent: data,
        isOpenDT: false
      });
    }
  }, {
    key: 'openDialogDT',
    value: function openDialogDT() {
      this.setState({
        isOpenDT: true
      });
    }
  }, {
    key: 'onCloseDT',
    value: function onCloseDT() {
      this.setState({
        isOpenDT: false
      });
    }
  }, {
    key: 'getDSDTDeXuatXuLy',
    value: function getDSDTDeXuatXuLy() {
      var _this21 = this;

      _api.ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: this.props.data.id }).then(function (res) {
        var getDSDTDeXuatXuLy = [];
        var getDSDTDeXuatXuLys = [];
        var hasDataDeXuat = false;
        if (!(0, _lodash.isEmpty)(res.data)) {
          hasDataDeXuat = true;
          res.data.map(function (item) {
            if (item) {
              getDSDTDeXuatXuLy.push({
                id: item.dttt && item.dttt.id ? item.dttt.id : null,
                doiTuong: item.dttt && item.dttt.ten ? item.dttt.ten : null,
                yKien: item.noiDungDeXuat || null
              });
              getDSDTDeXuatXuLys.push(item.dttt.id);
            }
          });
        }
        _this21.props.dispatch({
          type: 'ADD_DEXUAT',
          dataDeXuat: getDSDTDeXuatXuLy,
          dataDeXuats: getDSDTDeXuatXuLys,
          id: _this21.props.idCS,
          hasDataDeXuat: hasDataDeXuat
        });
        if (!_this21.props.hasXuLy) {
          _this21.setState({
            getDSDTDeXuatXuLys: getDSDTDeXuatXuLys,
            getDSDTDeXuatXuLy: getDSDTDeXuatXuLy
          }, function () {
            _this21.props.dispatch({
              type: 'UPDATE_DEXUAT',
              dataDeXuat: getDSDTDeXuatXuLy,
              dataDeXuats: getDSDTDeXuatXuLys,
              idCTT: _this21.props.idCS
            });
          });
        }
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      var _this22 = this;

      var doiTuongSelectedList = [];
      var tempDataSelectDoiTuongCurrent = [];
      this.setState({
        doiTuongSelectedList: doiTuongSelectedList,
        tempDataSelectDoiTuongCurrent: tempDataSelectDoiTuongCurrent
      }, function () {
        _this22.props.onClose();
      });
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(e) {
      var _this23 = this;

      if (this.refs.btnUpload.files[0]) {
        var fileName = this.refs.btnUpload.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        var listExcel = ['xls', 'xlsx'];
        if (!(0, _lodash.includes)(listExcel, ext)) {
          (0, _toastr.Toastr)(_message.msg.fileExcel, 'warning');
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {
          var params = { field: 'file', file: this.refs.btnUpload.files[0] };

          params.progress = function (progress) {
            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this23.setState({ progress: progressBar });
          };
          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {
            var checkURL = '';
            if (res && res.data && !_config.checkServerLive) {
              checkURL = res.data;
            } else if (res && res.data && _config.checkServerLive) {
              checkURL = res.data.id;
            }
            _this23.setState({
              data: _extends({}, _this23.state.data, {
                progress: 0,
                tenFile: fileName,
                duongDan: checkURL
              }),
              isError: false
            }, function () {
              _this23.addDoiTuongThanhTra(params);
            });
          }).catch(function (error) {
            _this23.setState({
              progress: 0,
              isError: true
            });
          });
        }
      }
    }
  }, {
    key: 'addDoiTuongThanhTra',
    value: function addDoiTuongThanhTra(params) {
      var _this24 = this;

      this.setState({
        loadingSave: true,
        loadingImport: true
      });
      _api.Reception.actions.importFileDoiTuong.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var _res$data = res.data,
              doiTuongThanhTraExists = _res$data.doiTuongThanhTraExists,
              numberUnsuccess = _res$data.numberUnsuccess,
              doiTuongThanhTraNotExists = _res$data.doiTuongThanhTraNotExists;

          _this24.setState({
            errorImport: false,
            data: _extends({}, _this24.state.data, {
              doiTuongThanhTraImport: doiTuongThanhTraExists.map(function (item) {
                return { id: item.id };
              }),
              cuocThanhTraNhieuDoiTuong: doiTuongThanhTraExists.length > 1 || _this24.state.data.cuocThanhTraNhieuDoiTuong
            }),
            base64Content: (0, _lodash.get)(doiTuongThanhTraNotExists, 'base64Content') || '',
            fileName: (0, _lodash.get)(doiTuongThanhTraNotExists, 'fileName') || '',
            mineType: (0, _lodash.get)(doiTuongThanhTraNotExists, 'mineType') || '',
            numberUnsuccess: numberUnsuccess
          });
        }
      }).catch(function (error) {
        var message = (0, _lodash.get)(error, 'response.data.errors[0].description');
        _this24.setState({
          errorImport: true,
          data: _extends({}, _this24.state.data, {
            duongDan: '',
            tenFile: '',
            cuocThanhTraNhieuDoiTuong: false
          })
        }, function () {
          (0, _toastr.Toastr)(message, 'error');
        });
      }).finally(function () {
        _this24.setState({
          loadingSave: false,
          loadingImport: false,
          isOpenThongBao: _this24.state.numberUnsuccess > 0
        });
      });
    }
  }, {
    key: 'convertEndCode',
    value: function convertEndCode(data) {
      var result = encodeURIComponent(data);
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this25 = this;

      var newItem = [];
      var showDonViPhoiHop = false;
      var countDTTT = this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length;
      var checkDSXL = this.state.getDSDTDeXuatXuLy && this.state.getDSDTDeXuatXuLy.length;
      if (this.props.isOpen === true) {
        if (this.state.doiTuongThanhTras.length > 0) {
          this.state.doiTuongThanhTras.forEach(function (items) {
            newItem.push({
              id: items.doiTuongThanhTraId || items.id,
              ten: items.ten
            });
          });
        }
      } else if (this.props.isOpen === false) {
        if (this.props.data && this.props.data.listDoiTuongThanhTra && this.props.data.listDoiTuongThanhTra.length > 0) {
          this.props.data.listDoiTuongThanhTra.forEach(function (items) {
            newItem.push({
              id: items.doiTuongThanhTraId || items.id,
              ten: items.ten
            });
          });
          if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
            newItem = this.props.data.doiTuongThanhTras;
          }
        } else if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
          newItem = this.props.data.doiTuongThanhTras;
        }
        if (newItem) {
          this.state.doiTuongThanhTras = newItem;
        } else if (this.props.data && this.props.data.doiTuongThanhTras && this.props.data.doiTuongThanhTras.length > 0) {
          this.state.doiTuongThanhTras = this.props.data.doiTuongThanhTras;
        } else {
          this.props.data.doiTuongThanhTras = [];
        }
      }

      var newItemIds = newItem.map(function (item) {
        return item.id;
      });
      var duplicateIds = (0, _lodash.intersection)(newItemIds, this.state.getDSDTDeXuatXuLys);
      showDonViPhoiHop = !(0, _lodash.isEmpty)(duplicateIds);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenDT,
            onClose: this.closeDialogDT.bind(this, 'isOpenDT'),
            title: 'Th\xF4ng b\xE1o',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0 hlDialog' },
            _react2.default.createElement(
              'div',
              { className: 'pt10 txt-center' },
              '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
              _react2.default.createElement(
                'h2',
                null,
                ' "' + this.state.getTenDoiTuong + '" '
              ),
              '\u0111\xE3 \u0111\u01B0\u1EE3c ch\u1ECDn l\xE0m \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' c\u1EE7a',
              ' ',
              ' ',
              this.state.idPushCoQuan.join(', ')
            ),
            _react2.default.createElement(
              'div',
              { className: 'pb20 txt-center' },
              'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD th\xEAm',
              _react2.default.createElement(
                'h2',
                null,
                ' "' + this.state.getTenDoiTuong + '" '
              ),
              _react2.default.createElement(
                'span',
                null,
                'v\xE0o k\u1EBF ho\u1EA1ch ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' kh\xF4ng?'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialogDT.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-green action-todo', onClick: this.onCloseDT.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.props.isOpen,
            onClose: this.onClose.bind(this),
            title: this.props.keHoach ? 'Thay th\u1EBF cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') : 'Ch\u1EC9nh s\u1EEDa cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
            className: 'dialog-them-moi-dttt dialog-default wrap-block'
          },
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                '1. Th\xF4ng tin cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(
                'form',
                { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this, 'doiTuongThanhTras') },
                _react2.default.createElement(_common.TextArea, { channel: 'editCuocTT', require: true, bindValidator: this, triggerOnblur: true, label: 'T\xEAn cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), className: 'col-100', value: this.state.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten', maxLength: 500 }),
                checkDSXL > 0 && _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.thanhTra.DMTTDX,
                      dataList: this.state.getDSDTDeXuatXuLy,
                      hideButtonExport: true,
                      hidePagination: true,
                      parent: this },
                    _react2.default.createElement(_datatable.RowItemThanhTraDeXuat, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25 mrt22' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'col-100 no-gutter btn-green btn-pullleft', onClick: this.openDialog.bind(this) },
                      _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                      '\u0110\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-15 mrt22' },
                    _react2.default.createElement(
                      'div',
                      { className: 'upload_file_content pt10' },
                      _react2.default.createElement('input', { type: 'file', name: 'uploadFile', className: 'upload btn-green btn-pullleft', ref: 'btnUpload', onChange: this.uploadFile.bind(this) }),
                      _react2.default.createElement(
                        'span',
                        { htmlFor: 'file' },
                        (0, _lodash.isEmpty)(this.state.data.duongDan) ? 'Tải lên tập tin' : 'Tải lại tập tin'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-input-tt-dvph col-25 mrt22' },
                    _config.checkServerLive && !(0, _lodash.isEmpty)(this.state.data.duongDan) && !this.state.loadingImport && _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: function onClick() {
                          (0, _utils.downloadFile)((0, _lodash.get)(_this25.state.data, 'duongDan'), (0, _lodash.get)(_this25.state.data, 'tenFile'));
                        } },
                      this.state.data.tenFile
                    ),
                    !_config.checkServerLive && !(0, _lodash.isEmpty)(this.state.data.duongDan) && !this.state.loadingImport && _react2.default.createElement(
                      _reactRouter.Link,
                      { className: 'txt-blue txt-underline', onClick: _downloadExcel.downloadExcel.bind(this, (0, _lodash.get)(this.state.data, 'duongDan'), (0, _lodash.get)(this.state.data, 'tenFile')) },
                      this.state.data.tenFile
                    ),
                    this.state.loadingImport && _react2.default.createElement('span', { className: 'icon-loader mt10' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 mb18' },
                    _react2.default.createElement(
                      'div',
                      { className: 'ds-tt-dvph' },
                      newItem && newItem.map(function (item, i) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'tt-dvph-item', key: i },
                          _react2.default.createElement(
                            'span',
                            { className: 'tt-dvph-icon', onClick: _this25.removeDonVi.bind(_this25, 'doiTuongThanhTras', i) },
                            '\xD7'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: (0, _classnames2.default)('tt-dvph-value', {
                                'highlighttratrung': _this25.state.getDSDTDeXuatXuLys.indexOf(item.id) !== -1
                              }) },
                            item.ten
                          )
                        );
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Ho\u1EA1t \u0111\u1ED9ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), keyName: 'giaTri', confirm: true, placeholder: null, valueName: 'ten', className: 'col-25', data: this.state.dataChucNangCuocThanhTra, selectedValue: this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo.type : '', onChange: this.onChange.bind(this, 'chucNangCuocThanhTra'), name: 'chucNangCuocThanhTra' }),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' },
                  _react2.default.createElement(_ttForms.DropDownChonLinhVucThanhTraMultiple, {
                    label: 'L\u0129nh v\u1EF1c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
                    confirm: true,
                    placeholder: null,
                    className: 'col-25',
                    data: this.state.dataLinhVucThanhTra.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    selectedValue: this.state.data.linhVucThanhTraList,
                    onChange: this.onChange.bind(this, 'linhVucThanhTraList'),
                    name: 'linhVucThanhTraList',
                    require: true,
                    validLinhVucThanhTra: this.state.validLinhVucThanhTra
                  })
                ),
                this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' && _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'H\xECnh th\u1EE9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' chuy\xEAn ng\xE0nh', placeholder: true, options: this.state.hinhThucThanhTraChuyenNganhList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo.type : '', onChange: this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh'), name: 'hinhThucThanhTraChuyenNganh', bindValidator: this, channel: 'editCuocTT', require: true }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && this.state.data.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') },
                  _react2.default.createElement(_common2.DropDownMultipleSelect, {
                    label: ' ',
                    className: 'col-25 mt16',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    value: this.state.data.thucHienPhapLuatVeThanhTraList,
                    options: this.state.thucHienPhapLuatVeThanhTraListCombobox.map(function (item) {
                      return {
                        label: item.ten,
                        value: item.giaTri
                      };
                    }),
                    onChange: this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList'),
                    placeholder: '',
                    closeMenuOnSelect: false
                  })
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.props.data.chucNangCuocThanhTraInfo && this.props.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' },
                  _react2.default.createElement(_common.Input, {
                    className: 'col-25',
                    label: 'Chi ti\u1EBFt l\u0129nh v\u1EF1c',
                    placeholder: 'Nh\u1EADp...',
                    value: this.state.data.chiTietLinhVuc,
                    onChange: this.onChange.bind(this, 'chiTietLinhVuc'),
                    name: 'chiTietLinhVuc',
                    bindValidator: this,
                    channel: 'formTaoDon',
                    maxLength: 255
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi k\u1EF3 ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), value: this.state.data.kyThanhTra, onChange: this.onChange.bind(this, 'phamViThanhTra'), name: 'phamViThanhTra', className: 'col-25', require: true, bindValidator: this, channel: 'editCuocTT' }),
              _react2.default.createElement(_common.InputNumber, { label: 'Th\u1EDDi h\u1EA1n (ng\xE0y)', value: this.state.data.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra'), name: 'thoiHanThanhTra', className: 'col-25', maxLength: 255 }),
              _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi gian ti\u1EBFn h\xE0nh', value: this.state.thoiGianTienHanh, onChange: this.onChange.bind(this, 'thoiGianTienHanh'), name: 'thoiGianTienHanh', className: 'col-25' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: countDTTT === 1 && showDonViPhoiHop ? true : false },
                _react2.default.createElement(
                  _core.Checkbox,
                  { className: 'col-100 pt-large pt-dvph', name: 'phoiHopXuLy', checked: this.state.data.phoiHopXuLy, onChange: this.changeCheckbox.bind(this, 'phoiHopXuLy') },
                  _react2.default.createElement(
                    'span',
                    { className: 'span-checkbox span-position-label' },
                    '\u0110\u01A1n v\u1ECB ph\u1ED1i h\u1EE3p'
                  )
                )
              ),
              _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'), value: this.state.data.noiDungThanhTra, onChange: this.onChange.bind(this, 'noiDungThanhTra'), name: 'noiDungThanhTra', rows: 3, placeholder: 'Nh\u1EADp...', require: true, bindValidator: this, channel: 'editCuocTT', maxLength: 500 })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.onClose.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: (0, _classnames2.default)('btn-action btn-save', {
                    'btn-loading-inline': this.state.loadingSave
                  }),
                  onClick: this.handleSave.bind(this)
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this, 'isOpen'),
            title: 'Th\xEAm m\u1EDBi cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'),
            className: 'dialog-them-moi-dttt dialog-default wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'row pl30 pr30' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt20 pb15' },
                '1. T\xECm ki\u1EBFm \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            ),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ED1i t\u01B0\u1EE3ng', value: this.state.tuKhoa, onChange: this.onChangeTuKhoa.bind(this, 'tuKhoa'), name: 'tuKhoa', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...' }),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: 'M\xE3 s\u1ED1 thu\u1EBF', value: this.state.maSoThue, onChange: this.onChangeMaSoThue.bind(this), name: 'maSoThue', placeholder: 'Nh\u1EADp m\xE3 s\u1ED1 thu\u1EBF...' }),
            _react2.default.createElement(_common.DropDown, { className: 'col-28', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng', selectedValue: this.state.nhomDoiTuongThanhTraId, onChange: this.onChange.bind(this, 'nhomDoiTuongThanhTraId'), name: 'nhomDoiTuongThanhTraId', placeholder: true, options: this.state.nhomDTList, keyName: 'nhomDoiTuongThanhTraId', valueName: 'ten' }),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-28',
              label: 'Huy\u1EC7n/TP',
              selectedValue: this.state.quanHuyenId,
              onChange: this.onChange.bind(this, 'quanHuyenId'),
              name: 'quanHuyenId',
              placeholder: true,
              options: this.state.dsQuanHuyen, keyName: 'donViHanhChinhId', valueName: 'ten'
            }),
            _react2.default.createElement(_common.DropDown, {
              className: 'col-28',
              label: 'Ph\u01B0\u1EDDng/X\xE3',
              selectedValue: this.state.phuongXaId,
              onChange: this.onChange.bind(this, 'phuongXaId'),
              name: 'phuongXaId',
              placeholder: true,
              options: (0, _lodash.get)(this.state, 'dsPhuongXa', []), keyName: 'donViHanhChinhId', valueName: 'ten'
            }),
            _react2.default.createElement(_common.Input, { className: 'col-28', label: '\u0110\u1ECBa ch\u1EC9', value: this.state.diaChi, onChange: this.onChangeDiaChi.bind(this), name: 'diaChi', placeholder: 'Nh\u1EADp' }),
            _react2.default.createElement(
              'div',
              { className: 'col-15 mt22' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green ml10', onClick: this.timKiem.bind(this, true) },
                _react2.default.createElement('i', { className: 'tt-search' }),
                'T\xECm ki\u1EBFm'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.1 K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _datatable.DataTableMultipleSelect,
                { onDisableCheck: true, onCheck: this.handleSelectedAll.bind(this), selectAllStatus: this.state.checkAll, header: _table.header.thanhTra.KQTKTMDTTT2, dataList: this.state.ketQuaTimKiemList, tableLoading: this.state.tableLoading, pageData: this.state.pageData, parent: this },
                _react2.default.createElement(_datatable.RowItemKetQuaTimKiemThanhTra, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb20 pt10 txt-center' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.themVaoCuocTT.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'row pl40 pr40' },
              _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.2 Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng s\u1EBD \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _dataTable2.default,
                { header: _table.header.thanhTra.TMDTTT2, dataList: this.state.doiTuongSelectedList, hideButtonExport: true, hidePagination: true, parent: this, emptyMsg: 'Ch\u01B0a c\xF3 \u0111\u1ED1i t\u01B0\u1EE3ng \u0111\u01B0\u1EE3c th\xEAm v\xE0o cu\u1ED9c ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') },
                _react2.default.createElement(_datatable.RowItemDanhSachThemMoiThanhTra, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpen') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-save', onClick: this.handleSaveDoiTuongThanhTra.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenThongBao,
            onClose: this.closeDialogThongBao.bind(this),
            title: 'Thông báo',
            className: 'panel-popup category' },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body' },
            'Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra') + ' v\u1EEBa t\u1EA3i l\xEAn c\xF3 ',
            _react2.default.createElement(
              'a',
              { className: 'txt-underline', download: this.state.fileName, href: 'data:' + this.state.mineType + ';base64,' + this.state.base64Content },
              ' ',
              this.state.numberUnsuccess,
              ' '
            ),
            '\u0111\u1ED1i t\u01B0\u1EE3ng ch\u01B0a c\xF3 trong h\u1EC7 th\u1ED1ng. Vui l\xF2ng b\u1EA5m v\xE0o link S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng \u0111\u1EC3 t\u1EA3i xu\u1ED1ng v\xE0 ki\u1EC3m tra l\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-footer' },
            _react2.default.createElement(
              _reactRouter.Link,
              { onClick: this.closeDialogThongBao.bind(this), className: 'btn-action btn-close' },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);

  return DialogChinhSuaCuocThanhTra;
}(_react2.default.Component);

DialogChinhSuaCuocThanhTra.defaultProps = {
  data: {},
  hasXuLy: false
};

function bindStateToProps(state) {
  return {
    hasXuLy: state.dataCuocThanhTra.hasXuLy,
    totalDataDeXuat: state.dataCuocThanhTra.totalDataDeXuat,
    dataDXOld: state.dataCuocThanhTra.dataDXOld
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DialogChinhSuaCuocThanhTra));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(372);
var loaiQuyTrinh = 'THANH_TRA';

var DoiTuongKienNghi = function (_React$Component) {
  _inherits(DoiTuongKienNghi, _React$Component);

  function DoiTuongKienNghi(props, context) {
    _classCallCheck(this, DoiTuongKienNghi);

    var _this = _possibleConstructorReturn(this, (DoiTuongKienNghi.__proto__ || Object.getPrototypeOf(DoiTuongKienNghi)).call(this, props, context));

    _this.state = {
      dataDetail: {},
      showFile: true,
      action: false,
      idCuocThanhTra: _this.props.idCuocThanhTra,
      id: _this.props.id,

      linhVucThanhTra: _this.props.linhVucThanhTra,
      listDoiTuongViPham: _this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: _this.props.chucNangCuocThanhTra,
      listLinhVucThanhTra: [],
      linhVucKetQuaThanhTra: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        chuyenCoQuanDieuTra: [],
        data: [],
        kienNghiHoanThienCoCheChinhSach: []
      },
      dataTaiLieuVanThuDelete: [],
      dataCoQuanDieuTraThanhTra: [],
      dataHinhThucKienNghi: [],

      listTaiLieuVanThuGiaHan: [],
      danhSachDonViPhoiHop: [],
      donViPhoiHop: '',
      trangThaiDoiTuongViPham: '',
      btnLoading: false,
      btnSaveLoading: false,
      //default

      ten: '',
      // 2. Thu hồi trong quá trình thanh tra
      tienDaThuHoiVeNganSachNhaNuoc: '',
      datDaThuHoiVeNganSachNhaNuoc: '',
      tienDaThuTrongQuaTrinhThanhTra: '',
      datDaThuTrongQuaTrinhThanhTra: '',
      toChucCoSaiPham: '',
      hinhThucKienNghiToChuc: '',
      kienNghiXuLyHanhChinhToChucBangTien: '',
      caNhanCoSaiPham: '',
      kienNghiXuLyHanhChinhCaNhanBangTien: '',
      hinhThucKienNghiCaNhan: '',

      saiPhamKhac: '',

      soVuViecKienNghiChuyenCoQuanDieuTra: 0,
      chuyenCoQuanDieuTra: false,

      soQuyetDinhChuyenCoQuanDieuTra: '',
      nguoiRaQuyetDinhChuyenCoQuanDieuTra: '',
      coQuanDieuTraThanhTra: '',
      coQuanDieuTraKhac: '',

      soVuChuyenCoQuanDieuTra: 0,

      tienKienNghiXuLyKhac: '',
      datKienNghiXuLyKhac: '',
      noiDungKienNghiXuLyKhac: '',

      //end

      //list tài liệu

      listTaiLieuVanThuChuyenCoQuanDieuTra: [],
      listTaiLieuVanThuChuyenCoQuanDieuTraInit: [],
      listTaiLieuVanThuKienNghiXuLyKhac: [],
      dsTaiLieuKienNghiHoanThienCoCheChinhSach: [],

      // Tài chính
      saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      //end


      // Xây dựng cơ bản
      saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',
      //end

      // vi phạm về đất đai

      quyetDinhGiaoDat: '',
      cNChoThueKhongDungQDKienNghiXuLyVeDat: '',
      capBanDatTraiThamQuyenKienNghiXuLyVeDat: '',
      datLanChiemKienNghiXuLyVeDat: '',
      capGCNQSDDatSaiKienNghiXuLyVeDat: '',
      giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat: '',
      sDDatKhongDungMDKienNghiXuLyVeDat: '',
      saiPhamKhacKienNghiXuLyVeDat: '',

      //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

      tongSoTienViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucViPhamKienNghiXuLyVeKinhTe: '',

      soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',

      tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',

      tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: '',

      //thu hồi trong quá trình thanh tra

      tongSoTienThuHoiTrongQuaTrinhThanhTra: '',
      caNhanTienThuHoiTrongQuaTrinhThanhTra: '',
      toChucTienThuHoiTrongQuaTrinhThanhTra: '',
      showLoaiDoiTuong: false,
      loaiDoiTuongThanhTra: 'TO_CHUC',
      loaiDoiTuongCombobox: []
    };
    return _this;
  }

  _createClass(DoiTuongKienNghi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListLinhVucThanhTra();
      this.getCoQuanDieuTraThanhTra();
      this.getHinhThucKienNghi();
      this.getListLoaiDoiTuong();
      this.props.onRef(this);
      if (this.state.id) {
        this.getChiTietDoiTuongTraThanhTra(this.state.id);
      }
    }
  }, {
    key: 'getChiTietDoiTuongTraThanhTra',
    value: function getChiTietDoiTuongTraThanhTra(id) {
      var _this2 = this;

      _api.ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          _this2.setState({
            dataDetail: Data,
            ten: Data.ten ? Data.ten : '',
            loaiDoiTuongThanhTra: Data.loaiDoiTuongThanhTra ? Data.loaiDoiTuongThanhTra : null,
            tienDaThuHoiVeNganSachNhaNuoc: Data.tienDaThuHoiVeNganSachNhaNuoc ? Data.tienDaThuHoiVeNganSachNhaNuoc : '',
            datDaThuHoiVeNganSachNhaNuoc: Data.datDaThuHoiVeNganSachNhaNuoc ? Data.datDaThuHoiVeNganSachNhaNuoc : '',
            tienDaThuTrongQuaTrinhThanhTra: Data.tienDaThuTrongQuaTrinhThanhTra ? Data.tienDaThuTrongQuaTrinhThanhTra : '',
            datDaThuTrongQuaTrinhThanhTra: Data.datDaThuTrongQuaTrinhThanhTra ? Data.datDaThuTrongQuaTrinhThanhTra : '',
            toChucCoSaiPham: Data.toChucCoSaiPham ? Data.toChucCoSaiPham : '',
            dataToChucCoSaiPham: Data.toChucCoSaiPham ? Data.toChucCoSaiPham : '',
            hinhThucKienNghiToChuc: Data.hinhThucKienNghiToChuc ? Data.hinhThucKienNghiToChuc : '',
            kienNghiXuLyHanhChinhToChucBangTien: Data.kienNghiXuLyHanhChinhToChucBangTien ? Data.kienNghiXuLyHanhChinhToChucBangTien : '',
            kienNghiXuLyHanhChinhCaNhanBangTien: Data.kienNghiXuLyHanhChinhCaNhanBangTien ? Data.kienNghiXuLyHanhChinhCaNhanBangTien : '',
            caNhanCoSaiPham: Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : '',
            dataCaNhanCoSaiPham: Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : '',
            hinhThucKienNghiCaNhan: Data.hinhThucKienNghiCaNhan ? Data.hinhThucKienNghiCaNhan : '',

            saiPhamKhac: Data.saiPhamKhac ? Data.saiPhamKhac : '',
            linhVucKetQuaThanhTra: Data.linhVucKetQuaThanhTra ? Data.linhVucKetQuaThanhTra.giaTri : '',

            soVuViecKienNghiChuyenCoQuanDieuTra: Data.soVuViecKienNghiChuyenCoQuanDieuTra ? Data.soVuViecKienNghiChuyenCoQuanDieuTra : 0,
            chuyenCoQuanDieuTra: Data.chuyenCoQuanDieuTra,
            trangThaiDoiTuongViPham: Data.trangThaiDoiTuongViPham ? Data.trangThaiDoiTuongViPham : '',

            soQuyetDinhChuyenCoQuanDieuTra: Data.soQuyetDinhChuyenCoQuanDieuTra ? Data.soQuyetDinhChuyenCoQuanDieuTra : '',
            nguoiRaQuyetDinhChuyenCoQuanDieuTra: Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra : '',
            coQuanDieuTraThanhTra: Data.coQuanDieuTraThanhTra ? Data.coQuanDieuTraThanhTra : '',
            coQuanDieuTraKhac: Data.coQuanDieuTraKhac ? Data.coQuanDieuTraKhac : '',

            soVuChuyenCoQuanDieuTra: Data.soVuChuyenCoQuanDieuTra ? Data.soVuChuyenCoQuanDieuTra : 0,

            tienKienNghiXuLyKhac: Data.tienKienNghiXuLyKhac ? Data.tienKienNghiXuLyKhac : '',
            datKienNghiXuLyKhac: Data.datKienNghiXuLyKhac ? Data.datKienNghiXuLyKhac : '',
            noiDungKienNghiXuLyKhac: Data.noiDungKienNghiXuLyKhac ? Data.noiDungKienNghiXuLyKhac : '',

            //end
            boHoanHoaKienNghiXuLyVeDat: Data.boHoanHoaKienNghiXuLyVeDat ? Data.boHoanHoaKienNghiXuLyVeDat : '',
            cNChoThueKhongDungQDKienNghiXuLyVeDat: Data.cNChoThueKhongDungQDKienNghiXuLyVeDat ? Data.cNChoThueKhongDungQDKienNghiXuLyVeDat : '',
            capBanDatTraiThamQuyenKienNghiXuLyVeDat: Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat ? Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat : '',
            datLanChiemKienNghiXuLyVeDat: Data.datLanChiemKienNghiXuLyVeDat ? Data.datLanChiemKienNghiXuLyVeDat : '',
            capGCNQSDDatSaiKienNghiXuLyVeDat: Data.capGCNQSDDatSaiKienNghiXuLyVeDat ? Data.capGCNQSDDatSaiKienNghiXuLyVeDat : '',
            giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat: Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat ? Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat : '',
            sDDatKhongDungMDKienNghiXuLyVeDat: Data.sDDatKhongDungMDKienNghiXuLyVeDat ? Data.sDDatKhongDungMDKienNghiXuLyVeDat : '',
            saiPhamKhacKienNghiXuLyVeDat: Data.saiPhamKhacKienNghiXuLyVeDat ? Data.saiPhamKhacKienNghiXuLyVeDat : '',

            //list tài liệu
            listTaiLieuVanThuChuyenCoQuanDieuTra: Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : [],
            listTaiLieuVanThuChuyenCoQuanDieuTraInit: Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : [],
            listTaiLieuVanThuKienNghiXuLyKhac: Data.listTaiLieuVanThuKienNghiXuLyKhac ? Data.listTaiLieuVanThuKienNghiXuLyKhac : [],
            dsTaiLieuKienNghiHoanThienCoCheChinhSach: Data.dsTaiLieuKienNghiHoanThienCoCheChinhSach ? Data.dsTaiLieuKienNghiHoanThienCoCheChinhSach : [],

            // Tài chính
            saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
            saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
            //end


            // Xây dựng cơ bản
            saiPhamVeTienKienNghiKhacXuLyVeKinhTe: Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '',
            saiPhamVeDatKienNghiKhacXuLyVeKinhTe: Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '',
            //end

            // vi phạm về đất đai

            quyetDinhGiaoDat: Data.quyetDinhGiaoDat ? Data.quyetDinhGiaoDat : '',

            //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

            tongSoTienViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienViPhamKienNghiXuLyVeKinhTe : '',
            tienCaNhanViPhamKienNghiXuLyVeKinhTe: Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe : '',
            tienToChucViPhamKienNghiXuLyVeKinhTe: Data.tienToChucViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucViPhamKienNghiXuLyVeKinhTe : '',

            soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '',

            tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',
            tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',
            tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',

            tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : '',
            tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : '',
            tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : '',

            //thu hồi trong quá trình thanh tra

            tongSoTienThuHoiTrongQuaTrinhThanhTra: Data.tongSoTienThuHoiTrongQuaTrinhThanhTra ? Data.tongSoTienThuHoiTrongQuaTrinhThanhTra : '',
            caNhanTienThuHoiTrongQuaTrinhThanhTra: Data.caNhanTienThuHoiTrongQuaTrinhThanhTra ? Data.caNhanTienThuHoiTrongQuaTrinhThanhTra : '',
            toChucTienThuHoiTrongQuaTrinhThanhTra: Data.toChucTienThuHoiTrongQuaTrinhThanhTra ? Data.toChucTienThuHoiTrongQuaTrinhThanhTra : '',

            showFile: false
          }, function () {
            _this2.checkFileRequire();
          });
        }
      });
    }
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      if (this.state.chuyenCoQuanDieuTra) {
        var data = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuChuyenCoQuanDieuTra));
        var dataFilter = data.filter(function (state) {
          return state.typeRequired == 'DTTT_CHUYEN_CO_QUAN_DIEU_TRA';
        });
        if (dataFilter.length > 0) {
          // do nothing
        } else {
          var newItem = {
            ten: 'Quyết định chuyển cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'DTTT_CHUYEN_CO_QUAN_DIEU_TRA',
            newFile: true,
            nhomHoSo: null
          };
          this.state.listTaiLieuVanThuChuyenCoQuanDieuTra = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuChuyenCoQuanDieuTra), [newItem]);
        }
      }
      this.setState(_extends({}, this.state, {
        showFile: true
      }));
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = {};
      if (this.state.id) {
        params = this.state.dataDetail;
        params.id = params.doiTuongViPhamId;
      }
      params.loaiDoiTuongViPham = 'DOI_TUONG_THEO_DOI';
      params.ten = this.state.ten ? this.state.ten : '';
      params.toChucCoSaiPham = this.state.toChucCoSaiPham ? this.state.toChucCoSaiPham : '';
      params.hinhThucKienNghiToChuc = this.state.hinhThucKienNghiToChuc ? this.state.hinhThucKienNghiToChuc : '';
      params.kienNghiXuLyHanhChinhToChucBangTien = this.state.kienNghiXuLyHanhChinhToChucBangTien ? this.state.kienNghiXuLyHanhChinhToChucBangTien : '';
      params.kienNghiXuLyHanhChinhCaNhanBangTien = this.state.kienNghiXuLyHanhChinhCaNhanBangTien ? this.state.kienNghiXuLyHanhChinhCaNhanBangTien : '';
      params.caNhanCoSaiPham = this.state.caNhanCoSaiPham ? this.state.caNhanCoSaiPham : '';
      params.hinhThucKienNghiCaNhan = this.state.hinhThucKienNghiCaNhan ? this.state.hinhThucKienNghiCaNhan : '';

      params.saiPhamKhac = this.state.saiPhamKhac ? this.state.saiPhamKhac : '';
      params.linhVucKetQuaThanhTra = this.state.linhVucKetQuaThanhTra ? this.state.linhVucKetQuaThanhTra : '';
      params.loaiDoiTuongThanhTra = this.showLoaiDoiTuong() && this.state.loaiDoiTuongThanhTra ? this.state.loaiDoiTuongThanhTra : null;

      if (this.state.chuyenCoQuanDieuTra) {
        params.chuyenCoQuanDieuTra = true;
        params.soQuyetDinhChuyenCoQuanDieuTra = this.state.soQuyetDinhChuyenCoQuanDieuTra ? this.state.soQuyetDinhChuyenCoQuanDieuTra : '';
        params.nguoiRaQuyetDinhChuyenCoQuanDieuTra = this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra : '';
        params.coQuanDieuTraThanhTra = this.state.coQuanDieuTraThanhTra ? this.state.coQuanDieuTraThanhTra : null;
        params.soVuChuyenCoQuanDieuTra = this.state.soVuChuyenCoQuanDieuTra ? this.state.soVuChuyenCoQuanDieuTra : 0;

        if (this.state.coQuanDieuTraThanhTra == 'KHAC') {
          params.coQuanDieuTraKhac = this.state.coQuanDieuTraKhac ? this.state.coQuanDieuTraKhac : '';
        } else {
          params.coQuanDieuTraKhac = '';
        }
      } else {
        params.chuyenCoQuanDieuTra = false;
        params.soQuyetDinhChuyenCoQuanDieuTra = '';
        params.nguoiRaQuyetDinhChuyenCoQuanDieuTra = '';
        params.coQuanDieuTraThanhTra = null;
        params.coQuanDieuTraKhac = '';
        params.soVuChuyenCoQuanDieuTra = 0;
      }

      params.soVuViecKienNghiChuyenCoQuanDieuTra = this.state.soVuViecKienNghiChuyenCoQuanDieuTra ? this.state.soVuViecKienNghiChuyenCoQuanDieuTra : 0;
      params.tienDaThuHoiVeNganSachNhaNuoc = this.state.tienDaThuHoiVeNganSachNhaNuoc ? this.state.tienDaThuHoiVeNganSachNhaNuoc : 0;
      params.datDaThuHoiVeNganSachNhaNuoc = this.state.datDaThuHoiVeNganSachNhaNuoc ? this.state.datDaThuHoiVeNganSachNhaNuoc : 0;
      params.tienDaThuTrongQuaTrinhThanhTra = this.state.tienDaThuTrongQuaTrinhThanhTra ? this.state.tienDaThuTrongQuaTrinhThanhTra : 0;
      params.datDaThuTrongQuaTrinhThanhTra = this.state.datDaThuTrongQuaTrinhThanhTra ? this.state.datDaThuTrongQuaTrinhThanhTra : 0;
      params.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;
      params.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;
      params.datKienNghiXuLyKhac = this.state.datKienNghiXuLyKhac ? this.state.datKienNghiXuLyKhac : 0;
      params.noiDungKienNghiXuLyKhac = this.state.noiDungKienNghiXuLyKhac ? this.state.noiDungKienNghiXuLyKhac : '';

      params.tienKienNghiXuLyKhac = this.state.tienKienNghiXuLyKhac ? this.state.tienKienNghiXuLyKhac : 0;

      params.saiPhamVeTienKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : 0;
      params.saiPhamVeDatKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : 0;
      params.quyetDinhGiaoDatThuHoiTrongQuaTrinhThanhTra = 0;
      params.soQuyetDinhKienNghiXuLyHanhChinhCaNhan = '';
      params.soQuyetDinhKienNghiXuLyHanhChinhToChuc = '';

      //end

      params.tongSoTienViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienCaNhanViPhamKienNghiXuLyVeKinhTe = this.state.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? this.state.tienCaNhanViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienToChucViPhamKienNghiXuLyVeKinhTe = this.state.tienToChucViPhamKienNghiXuLyVeKinhTe ? this.state.tienToChucViPhamKienNghiXuLyVeKinhTe : 0;

      params.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;

      params.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;

      params.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : 0;
      params.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : 0;

      params.tongSoTienThuHoiTrongQuaTrinhThanhTra = this.state.tongSoTienThuHoiTrongQuaTrinhThanhTra ? this.state.tongSoTienThuHoiTrongQuaTrinhThanhTra : 0;
      params.caNhanTienThuHoiTrongQuaTrinhThanhTra = this.state.caNhanTienThuHoiTrongQuaTrinhThanhTra ? this.state.caNhanTienThuHoiTrongQuaTrinhThanhTra : 0;
      params.toChucTienThuHoiTrongQuaTrinhThanhTra = this.state.toChucTienThuHoiTrongQuaTrinhThanhTra ? this.state.toChucTienThuHoiTrongQuaTrinhThanhTra : 0;
      params.loaiDoiTuongThanhTraInfo = undefined;

      params.cuocThanhTra = {
        id: Number(this.state.idCuocThanhTra)
      };

      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['cuocThanhTraId'];
      delete params['doiTuongViPhamId'];
      delete params['listTaiLieuVanThuChuyenCoQuanDieuTra'];
      delete params['listTaiLieuVanThuKienNghiXuLyKhac'];
      delete params['dsTaiLieuKienNghiHoanThienCoCheChinhSach'];
      delete params['trangThaiDoiTuongViPhamInfo'];
      delete params['coQuanDieuTraThanhTraInfo'];

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
        (0, _toastr.Toastr)('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
      } else {
        this.setState({ btnSaveLoading: true });
        var params = this.getParams();
        if (params.trangThaiDoiTuongViPham != 'HOAN_THANH') {
          params.trangThaiDoiTuongViPham = 'DANG_SOAN';
        }
        if (this.state.id) {
          this.pushTaiLieu(this.state.id);
          this.updateDoiTuongViPham(params);
        } else {
          this.postDoiTuongViPham(params);
        }
      }
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
        (0, _toastr.Toastr)('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
      } else {
        if (this.validateSubmitForm()) {
          this.setState({ btnLoading: true });
          var params = this.getParams();
          params.trangThaiDoiTuongViPham = 'HOAN_THANH';
          if (this.state.id) {
            this.pushTaiLieu(this.state.id);
            this.updateDoiTuongViPham(params);
          } else {
            this.postDoiTuongViPham(params);
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'postDoiTuongViPham',
    value: function postDoiTuongViPham(data) {
      var _this3 = this;

      var params = {
        doiTuongViPhams: [data]
      };
      _api.ThanhTra.actions.postDoiTuongViPham.request('', params).then(function (res) {
        //do something
        _this3.pushTaiLieu(res.data.doiTuongViPhams[0].doiTuongViPhamId);
        (0, _toastr.Toastr)(_message.msg.addDoiTuongTTSuccess, 'success');
        _this3.setState({ btnLoading: false, btnSaveLoading: false });
        _this3.props.closeDialog(true);
        _this3.props.getListDaTa();
      }).catch(function (e) {
        _this3.setState({ btnLoading: false, btnSaveLoading: false });
      });
    }
  }, {
    key: 'updateDoiTuongViPham',
    value: function updateDoiTuongViPham(data) {
      var _this4 = this;

      var params = {
        doiTuongViPhams: [data]
      };
      _api.ThanhTra.actions.updateDoiTuongViPham.request('', params).then(function (res) {
        //do something
        (0, _toastr.Toastr)(_message.msg.saveDoiTuongTTSuccess, 'success');
        _this4.setState({ btnLoading: false, btnSaveLoading: false });
        _this4.props.closeDialog(true);
        _this4.props.getListDaTa();
      }).catch(function (e) {
        _this4.setState({ btnLoading: false, btnSaveLoading: false });
      });
    }
  }, {
    key: 'getCoQuanDieuTraThanhTra',
    value: function getCoQuanDieuTraThanhTra() {
      var _this5 = this;

      _api.ThanhTra.actions.getCoQuanDieuTraThanhTra.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            dataCoQuanDieuTraThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getListLinhVucThanhTra',
    value: function getListLinhVucThanhTra() {
      var _this6 = this;

      _api.ThanhTra.actions.getDsLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this6.setState({
            listLinhVucThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getListLoaiDoiTuong',
    value: function getListLoaiDoiTuong() {
      var _this7 = this;

      _api.ThanhTra.actions.getDsLoaiDoiTuong.request().then(function (res) {
        if (res.data) {
          _this7.setState({
            loaiDoiTuongCombobox: res.data.reverse()
          });
        }
      });
    }
  }, {
    key: 'getHinhThucKienNghi',
    value: function getHinhThucKienNghi() {
      var _this8 = this;

      _api.ThanhTra.actions.getHinhThucKienNghi.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            dataHinhThucKienNghi: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        linhVucThanhTra: nextProps.linhVucThanhTra,
        listDoiTuongViPham: nextProps.listDoiTuongViPham,
        idCuocThanhTra: nextProps.idCuocThanhTra,
        chucNangCuocThanhTra: nextProps.chucNangCuocThanhTra,
        id: nextProps.id
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      if (name == 'coQuanDieuTraThanhTra') {}
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'CHUYEN_CO_QUAN_DIEU_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.chuyenCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type === "KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH") {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.kienNghiHoanThienCoCheChinhSach = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
      this.props.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type == 'CHUYEN_CO_QUAN_DIEU_TRA') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.chuyenCoQuanDieuTra = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type === 'KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH') {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.kienNghiHoanThienCoCheChinhSach = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      } else {
        var _dataFileDinhKem4 = this.state.dataFileDinhKem;

        _dataFileDinhKem4.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem4
        });
      }

      this.props.handleChangeData();
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id) {
      var _this9 = this;

      var dataFileDinhKem = this.getListDataFileDinhKem();

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this9.state.taiLieuVanThuUpdate[_this9.state.taiLieuVanThuUpdate.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo && (0, _lodash.isString)(item.nhomHoSo) ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          } else {
            _this9.state.taiLieuVanThu[_this9.state.taiLieuVanThu.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : '',
              nhomHoSo: item.nhomHoSo && (0, _lodash.isString)(item.nhomHoSo) ? {
                id: Number(item.nhomHoSo)
              } : (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: (0, _lodash.get)(item, 'nhomHoSoInfo.nhomHoSoId') } : null
            };
          }
        });
      }

      if (this.state.chuyenCoQuanDieuTra != true && this.state.listTaiLieuVanThuChuyenCoQuanDieuTraInit.length > 0) {
        var dataFile = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuChuyenCoQuanDieuTraInit));
        dataFile.map(function (item) {
          _this9.state.taiLieuVanThuDelete[_this9.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this9.state.taiLieuVanThuDelete[_this9.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }

      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }

      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem() {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.chuyenCoQuanDieuTra.length > 0) {
        Data.chuyenCoQuanDieuTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.kienNghiHoanThienCoCheChinhSach.length > 0) {
        Data.kienNghiHoanThienCoCheChinhSach.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      var _setState2,
          _this10 = this;

      this.setState((_setState2 = {}, _defineProperty(_setState2, name, e), _defineProperty(_setState2, 'showFile', false), _setState2), function () {
        _this10.checkFileRequire();
      });
      if (!e) {}
      this.props.handleChangeData();
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.closeDialog();
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        idCuocThanhTra: '',
        id: '',
        linhVucThanhTra: '',
        listDoiTuongViPham: [],
        chucNangCuocThanhTra: '',
        ten: '',
        loaiDoiTuongThanhTra: '',
        tienDaThuHoiVeNganSachNhaNuoc: '',
        datDaThuHoiVeNganSachNhaNuoc: '',
        tienDaThuTrongQuaTrinhThanhTra: '',
        datDaThuTrongQuaTrinhThanhTra: '',
        toChucCoSaiPham: '',
        hinhThucKienNghiToChuc: '',
        kienNghiXuLyHanhChinhToChucBangTien: '',
        kienNghiXuLyHanhChinhCaNhanBangTien: '',
        caNhanCoSaiPham: '',
        hinhThucKienNghiCaNhan: '',

        saiPhamKhac: '',

        soVuViecKienNghiChuyenCoQuanDieuTra: 0,
        chuyenCoQuanDieuTra: false,

        soQuyetDinhChuyenCoQuanDieuTra: '',
        nguoiRaQuyetDinhChuyenCoQuanDieuTra: '',
        coQuanDieuTraThanhTra: '',
        coQuanDieuTraKhac: '',

        soVuChuyenCoQuanDieuTra: '',

        tienKienNghiXuLyKhac: '',
        datKienNghiXuLyKhac: '',
        noiDungKienNghiXuLyKhac: '',

        //end

        // Tài chính
        saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
        saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
        //end


        // Xây dựng cơ bản
        saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
        saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',
        //end

        // vi phạm về đất đai

        quyetDinhGiaoDat: '',

        //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

        tongSoTienViPhamKienNghiXuLyVeKinhTe: '',
        tienCaNhanViPhamKienNghiXuLyVeKinhTe: '',
        tienToChucViPhamKienNghiXuLyVeKinhTe: '',

        soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',

        tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
        tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
        tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',

        tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: '',
        tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: '',
        tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: '',

        //thu hồi trong quá trình thanh tra

        tongSoTienThuHoiTrongQuaTrinhThanhTra: '',
        caNhanTienThuHoiTrongQuaTrinhThanhTra: '',
        toChucTienThuHoiTrongQuaTrinhThanhTra: ''
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'showLoaiDoiTuong',
    value: function showLoaiDoiTuong() {
      var result = false;
      if (this.props.doiTuongThanhTraLienQuan.split('; ').includes(this.state.ten)) {
        result = true;
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-dtkn' },
        _react2.default.createElement(
          'div',
          { className: 'content-dtkn' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-items-content' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb5' },
                '1. \u0110\u1ED1i t\u01B0\u1EE3ng vi ph\u1EA1m'
              ),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng', className: 'col-50', data: this.state.listDoiTuongViPham, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.ten, onChange: this.onChange.bind(this, 'ten'), name: 'ten' }),
              this.showLoaiDoiTuong() && _react2.default.createElement(_ttForms.DropDownMulipleUse, { placeholder: null, label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng', className: 'col-25', data: this.state.loaiDoiTuongCombobox, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.loaiDoiTuongThanhTra, onChange: this.onChange.bind(this, 'loaiDoiTuongThanhTra'), name: 'loaiDoiTuongThanhTra' }),
              _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: 'Lo\u1EA1i l\u0129nh v\u1EF1c vi ph\u1EA1m', className: 'col-25', data: this.state.listLinhVucThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.linhVucKetQuaThanhTra, onChange: this.onChange.bind(this, 'linhVucKetQuaThanhTra'), name: 'linhVucKetQuaThanhTra' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '2. Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-50 pl0 pr0' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-group-input' },
                  'THU H\u1ED2I V\u1EC0 NSNN'
                ),
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 ti\u1EC1n (\u0111)', value: this.state.tienDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'tienDaThuHoiVeNganSachNhaNuoc'), name: 'tienDaThuHoiVeNganSachNhaNuoc' }),
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 \u0111\u1EA5t (m2)', value: this.state.datDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'datDaThuHoiVeNganSachNhaNuoc'), name: 'datDaThuHoiVeNganSachNhaNuoc' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-50 pl0 pr0' },
                _react2.default.createElement(
                  'p',
                  { className: 'title-group-input' },
                  'THU H\u1ED2I V\u1EC0 T\u1ED4 CH\u1EE8C, \u0110\u01A0N V\u1ECA'
                ),
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 ti\u1EC1n (\u0111)', value: this.state.tienDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'tienDaThuTrongQuaTrinhThanhTra'), name: 'tienDaThuTrongQuaTrinhThanhTra' }),
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 \u0111\u1EA5t (m2)', value: this.state.datDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'datDaThuTrongQuaTrinhThanhTra'), name: 'datDaThuTrongQuaTrinhThanhTra' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb15' },
                '3. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD v\u1EC1 kinh t\u1EBF'
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-50 no-gutter' },
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', label: 'V\u1EC1 ti\u1EC1n (\u0111)', value: this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe'), name: 'saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe' }),
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', label: 'V\u1EC1 \u0111\u1EA5t (m2)', value: this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe'), name: 'saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '4. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD v\u1EC1 h\xE0nh ch\xEDnh'
              ),
              _react2.default.createElement(_common.InputList, { label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m', data: this.state.dataToChucCoSaiPham, onChange: this.onChange.bind(this, 'toChucCoSaiPham'), name: 'toChucCoSaiPham', countUnit: 't\u1ED5 ch\u1EE9c', hasCount: true }),
              _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.kienNghiXuLyHanhChinhToChucBangTien, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhToChucBangTien'), name: 'kienNghiXuLyHanhChinhToChucBangTien' }),
              _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.hinhThucKienNghiToChuc, onChange: this.onChange.bind(this, 'hinhThucKienNghiToChuc'), name: 'hinhThucKienNghiToChuc', maxLength: 255 }),
              _react2.default.createElement(_common.InputList, { label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m', data: this.state.dataCaNhanCoSaiPham, onChange: this.onChange.bind(this, 'caNhanCoSaiPham'), name: 'caNhanCoSaiPham', countUnit: 'c\xE1 nh\xE2n', hasCount: true }),
              _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.kienNghiXuLyHanhChinhCaNhanBangTien, onChange: this.onChange.bind(this, 'kienNghiXuLyHanhChinhCaNhanBangTien'), name: 'kienNghiXuLyHanhChinhCaNhanBangTien' }),
              _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.hinhThucKienNghiCaNhan, onChange: this.onChange.bind(this, 'hinhThucKienNghiCaNhan'), name: 'hinhThucKienNghiCaNhan', maxLength: 255 })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '5. Ki\u1EBFn ngh\u1ECB chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
              ),
              _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c', value: this.state.soVuViecKienNghiChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuViecKienNghiChuyenCoQuanDieuTra'), name: 'soVuViecKienNghiChuyenCoQuanDieuTra' }),
              _react2.default.createElement(
                _utils.ShowIfCheck,
                { titleClass: 'title-attach lable-title-custom', className: 'col-100', onChange: this.handleCheck.bind(this, 'chuyenCoQuanDieuTra'), name: 'chuyenCoQuanDieuTra', checked: this.state.chuyenCoQuanDieuTra, label: 'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra' },
                _react2.default.createElement(
                  'div',
                  { className: 'wrap-showif-check' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinhChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soQuyetDinhChuyenCoQuanDieuTra'), name: 'soQuyetDinhChuyenCoQuanDieuTra', maxLength: 255 }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'Ng\u01B0\u1EDDi ra quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'nguoiRaQuyetDinhChuyenCoQuanDieuTra'), name: 'nguoiRaQuyetDinhChuyenCoQuanDieuTra', maxLength: 255 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-50', require: true, bindValidator: this, channel: 'formTaoDon', label: 'T\xEAn c\u01A1 quan', placeholder: 'Nh\u1EADp...', selectedValue: this.state.coQuanDieuTraThanhTra, onChange: this.onChange.bind(this, 'coQuanDieuTraThanhTra'), name: 'coQuanDieuTraThanhTra', data: this.state.dataCoQuanDieuTraThanhTra, keyName: 'giaTri', valueName: 'ten' }),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: this.state.coQuanDieuTraThanhTra == 'KHAC' },
                      _react2.default.createElement(_common.Input, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'C\u01A1 quan \u0111i\u1EC1u tra kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.coQuanDieuTraKhac, onChange: this.onChange.bind(this, 'coQuanDieuTraKhac'), name: 'coQuanDieuTraKhac' })
                    ),
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25', require: true, bindValidator: this, channel: 'formTaoDon', label: 'S\u1ED1 v\u1EE5', placeholder: 'Nh\u1EADp...', value: this.state.soVuChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'soVuChuyenCoQuanDieuTra'), name: 'soVuChuyenCoQuanDieuTra' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.showFile },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100' },
                      _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'chuyenCoQuanDieuTra', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', phanLoaiQuyTrinh: 'CHUYEN_CO_QUAN_DIEU_TRA', bindValidator: this, data: this.state.listTaiLieuVanThuChuyenCoQuanDieuTra, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '6. Ki\u1EBFn ngh\u1ECB ho\xE0n thi\u1EC7n c\u01A1 ch\u1EBF ch\xEDnh s\xE1ch'
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100' },
                _react2.default.createElement(_upload.ContainerFileDinhKem, { hidenTopTitle: true, name: 'dsTaiLieuKienNghiHoanThienCoCheChinhSach', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', phanLoaiQuyTrinh: 'KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH', bindValidator: this, data: this.state.dsTaiLieuKienNghiHoanThienCoCheChinhSach, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '7. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kh\xE1c'
              ),
              _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-25', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111)', value: this.state.tienKienNghiXuLyKhac, onChange: this.onChange.bind(this, 'tienKienNghiXuLyKhac'), name: 'tienKienNghiXuLyKhac' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
                _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-25', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2)', value: this.state.datKienNghiXuLyKhac, onChange: this.onChange.bind(this, 'datKienNghiXuLyKhac'), name: 'datKienNghiXuLyKhac' }),
                _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung ki\u1EBFn ngh\u1ECB kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.noiDungKienNghiXuLyKhac, onChange: this.onChange.bind(this, 'noiDungKienNghiXuLyKhac'), name: 'noiDungKienNghiXuLyKhac', maxLength: 1000 })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.showFile },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { name: 'kienNghiXuLyKhac', label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', phanLoaiQuyTrinh: 'KIEN_NGHI_XU_LY_KHAC', bindValidator: this, data: this.state.listTaiLieuVanThuKienNghiXuLyKhac, disableTopLine: true, onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChange.bind(this) })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt15 pb5' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.trangThaiDoiTuongViPham != 'HOAN_THANH' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-save action-todo ' + (this.state.btnSaveLoading ? "btn-loading-inline" : this.state.btnLoading && 'btn-disable'), onClick: this.handleSave.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.trangThaiDoiTuongViPham != 'HOAN_THANH' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-complete btn-right-position action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : this.state.btnLoading && 'btn-loading-inline'), onClick: this.handleKetThuc.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Ho\xE0n Th\xE0nh'
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.trangThaiDoiTuongViPham == 'HOAN_THANH' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'btn-action btn-complete action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : this.state.btnLoading && 'btn-loading-inline'), onClick: this.handleSave.bind(this) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'L\u01B0u'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DoiTuongKienNghi;
}(_react2.default.Component);

DoiTuongKienNghi.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: [],
  listDoiTuongViPham: []
};

exports.default = (0, _utils.validatable)(DoiTuongKienNghi);

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _upload = __webpack_require__(17);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(372);

var DoiTuongKienNghiView = function (_React$Component) {
  _inherits(DoiTuongKienNghiView, _React$Component);

  function DoiTuongKienNghiView(props, context) {
    _classCallCheck(this, DoiTuongKienNghiView);

    var _this = _possibleConstructorReturn(this, (DoiTuongKienNghiView.__proto__ || Object.getPrototypeOf(DoiTuongKienNghiView)).call(this, props, context));

    _this.state = {
      dataDetail: {},
      id: _this.props.id,

      linhVucThanhTra: _this.props.linhVucThanhTra,
      listDoiTuongViPham: _this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: _this.props.chucNangCuocThanhTra
    };
    return _this;
  }

  _createClass(DoiTuongKienNghiView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getChiTietDoiTuongTraThanhTra(this.state.id);
    }
  }, {
    key: 'getChiTietDoiTuongTraThanhTra',
    value: function getChiTietDoiTuongTraThanhTra(id) {
      var _this2 = this;

      _api.ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          _this2.setState({
            dataDetail: Data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        linhVucThanhTra: nextProps.linhVucThanhTra
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.closeDialog();
    }
  }, {
    key: 'render',
    value: function render() {
      var Data = this.state.dataDetail;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-dtkn' },
        _react2.default.createElement(
          'div',
          { className: 'content-dtkn' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-items-content' },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb5' },
                '1. T\xEAn c\u1EE7a \u0111\u1ED1i t\u01B0\u1EE3ng'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', value: Data.ten ? Data.ten : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                '2. Thu h\u1ED3i trong qu\xE1 tr\xECnh thanh tra'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: Data.tienDaThuTrongQuaTrinhThanhTra ? Data.tienDaThuTrongQuaTrinhThanhTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: Data.datDaThuTrongQuaTrinhThanhTra ? Data.datDaThuTrongQuaTrinhThanhTra : '' })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5ng s\u1ED1 (\u0111):', value: Data.tongSoTienThuHoiTrongQuaTrinhThanhTra ? Data.tongSoTienThuHoiTrongQuaTrinhThanhTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\xE1 nh\xE2n (\u0111):', value: Data.caNhanTienThuHoiTrongQuaTrinhThanhTra ? Data.caNhanTienThuHoiTrongQuaTrinhThanhTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c (\u0111):', value: Data.toChucTienThuHoiTrongQuaTrinhThanhTra ? Data.toChucTienThuHoiTrongQuaTrinhThanhTra : '' })
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.linhVucThanhTra.includes('DAT_DAI') },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 pb15' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 col-100 mb10' },
                  '3. Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD \u0111\u1EA5t'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\u1EA5t l\u1EA5n chi\u1EBFm (m2):', value: Data.datLanChiemKienNghiXuLyVeDat ? Data.datLanChiemKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Giao, c\u1EA5p \u0111\u1EA5t sai \u0111\u1ED1i t\u01B0\u1EE3ng Q\u0110 (m2):', value: Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat ? Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u1EA5p, b\xE1n \u0111\u1EA5t tr\xE1i th\u1EA9m quy\u1EC1n (m2):', value: Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat ? Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u1EA5p GCNQSD \u0111\u1EA5t sai (m2):', value: Data.capGCNQSDDatSaiKienNghiXuLyVeDat ? Data.capGCNQSDDatSaiKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'CN, cho thu\xEA kh\xF4ng \u0111\xFAng Q\u0110 (m2):', value: Data.cNChoThueKhongDungQDKienNghiXuLyVeDat ? Data.cNChoThueKhongDungQDKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'SD \u0111\u1EA5t kh\xF4ng \u0111\xFAng M\u0110, sai Q\u0110 (m2):', value: Data.sDDatKhongDungMDKienNghiXuLyVeDat ? Data.sDDatKhongDungMDKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1ECF hoang h\xF3a (m2):', value: Data.boHoanHoaKienNghiXuLyVeDat ? Data.boHoanHoaKienNghiXuLyVeDat : '' }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m kh\xE1c (m2):', value: Data.saiPhamKhacKienNghiXuLyVeDat ? Data.saiPhamKhacKienNghiXuLyVeDat : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                this.state.linhVucThanhTra.includes('DAT_DAI') ? '4. Kiến nghị xử lý về hành chính' : '3. Kiến nghị xử lý về hành chính'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m:', value: Data.toChucCoSaiPham ? Data.toChucCoSaiPham : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'H\xECnh th\u1EE9c ki\u1EBFn ngh\u1ECB:', value: Data.hinhThucKienNghiToChuc ? Data.hinhThucKienNghiToChuc : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m:', value: Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'H\xECnh th\u1EE9c ki\u1EBFn ngh\u1ECB:', value: Data.hinhThucKienNghiCaNhan ? Data.hinhThucKienNghiCaNhan : '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb15' },
                this.state.linhVucThanhTra.includes('DAT_DAI') ? '5. Kiến nghị xử lý về kinh tế' : '4. Kiến nghị xử lý về kinh tế'
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.linhVucThanhTra.includes('DAT_DAI') },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t (m2):', value: Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Quy\u1EBFt \u0111\u1ECBnh giao \u0111\u1EA5t:', value: Data.quyetDinhGiaoDat ? Data.quyetDinhGiaoDat : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'Ki\u1EBFn ngh\u1ECB kh\xE1c'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t (m2):', value: Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '' })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.linhVucThanhTra.includes('XAY_DUNG_CO_BAN') },
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t (m2):', value: Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-50 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'Ki\u1EBFn ngh\u1ECB kh\xE1c'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t (m2):', value: Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '' })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.linhVucThanhTra.includes('TAI_CHINH') || this.state.linhVucThanhTra.includes('THANH_TRA_TRACH_NHIEM') },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'Ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t (m2):', value: Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '' })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'S\u1ED1 ti\u1EC1n vi ph\u1EA1m'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5ng s\u1ED1 (\u0111):', value: Data.tongSoTienViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\xE1 nh\xE2n (\u0111):', value: Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c (\u0111):', value: Data.tienToChucViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucViPhamKienNghiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb5' },
                    'S\u1ED1 ti\u1EC1n ki\u1EBFn ngh\u1ECB thu h\u1ED3i (\u0111)'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: null, value: Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'S\u1ED1 ti\u1EC1n x\u1EED l\xFD t\xE0i s\u1EA3n vi ph\u1EA1m'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5ng s\u1ED1 (\u0111):', value: Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ECBch thu (\u0111):', value: Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ti\xEAu h\u1EE7y (\u0111):', value: Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-bold txt-upper col-100 mb10' },
                    'S\u1ED1 ti\u1EC1n x\u1EED ph\u1EA1t vi ph\u1EA1m'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5ng s\u1ED1 (\u0111):', value: Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\xE1 nh\xE2n (\u0111):', value: Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c (\u0111):', value: Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Sai ph\u1EA1m kh\xE1c:', value: Data.saiPhamKhac ? Data.saiPhamKhac : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
                _react2.default.createElement(
                  'h2',
                  { className: 'txt-bold txt-upper col-100 mb5' },
                  'Sai ph\u1EA1m kh\xE1c'
                ),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: null, value: Data.saiPhamKhac ? Data.saiPhamKhac : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb15' },
              _react2.default.createElement('div', { className: 'line-border' })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
              _react2.default.createElement(
                'div',
                { className: 'col-100 no-gutter' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-14 col-100 mb10' },
                  this.state.linhVucThanhTra.includes('DAT_DAI') ? '6. Kiến nghị chuyển cơ quan điều tra' : '5. Kiến nghị chuyển cơ quan điều tra'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: Data.soVuViecKienNghiChuyenCoQuanDieuTra ? Data.soVuViecKienNghiChuyenCoQuanDieuTra : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.chuyenCoQuanDieuTra },
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-showif-check col-100 no-gutterer' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-attach mb15 col-100' },
                      'Chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: Data.soQuyetDinhChuyenCoQuanDieuTra ? Data.soQuyetDinhChuyenCoQuanDieuTra : '' }),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\u01B0\u1EDDi ra quy\u1EBFt \u0111\u1ECBnh:', value: Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra : '' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\xEAn c\u01A1 quan:', value: Data.coQuanDieuTraThanhTraInfo ? Data.coQuanDieuTraThanhTraInfo.text : '' }),
                      _react2.default.createElement(
                        _utils.ShowIf,
                        { condition: Data.coQuanDieuTraThanhTra == 'KHAC' },
                        _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan \u0111i\u1EC1u tra kh\xE1c:', value: Data.coQuanDieuTraKhac ? Data.coQuanDieuTraKhac : '' })
                      ),
                      _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5', value: Data.soVuChuyenCoQuanDieuTra ? Data.soVuChuyenCoQuanDieuTra : '' })
                    ),
                    _react2.default.createElement(
                      _utils.ShowIf,
                      { condition: true },
                      _react2.default.createElement(
                        'div',
                        { className: 'col-100' },
                        _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : [] })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-100 pb15' },
                _react2.default.createElement('div', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 col-100 mb10' },
                this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' ? this.state.linhVucThanhTra.includes('DAT_DAI') ? '7. Kiến nghị xử lý khác' : '6. Kiến nghị xử lý khác' : '5. Kiến nghị xử lý khác'
              ),
              _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111)', value: Data.tienKienNghiXuLyKhac ? Data.tienKienNghiXuLyKhac : '' }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2)', value: Data.datKienNghiXuLyKhac ? Data.datKienNghiXuLyKhac : '' }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'N\u1ED9i dung ki\u1EBFn ngh\u1ECB kh\xE1c', value: Data.noiDungKienNghiXuLyKhac ? Data.noiDungKienNghiXuLyKhac : '' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: true },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, { label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD', hideDescription: true, disableAttachFile: true, dataShow: Data.listTaiLieuVanThuKienNghiXuLyKhac ? Data.listTaiLieuVanThuKienNghiXuLyKhac : [] })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt15 pb5' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DoiTuongKienNghiView;
}(_react2.default.Component);

DoiTuongKienNghiView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: [],
  listDoiTuongViPham: []
};

exports.default = (0, _utils.validatable)(DoiTuongKienNghiView);

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _DoiTuongKienNghi = __webpack_require__(1368);

var _DoiTuongKienNghi2 = _interopRequireDefault(_DoiTuongKienNghi);

var _datatable = __webpack_require__(52);

var _core = __webpack_require__(7);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoiDungKienNghi = function (_React$Component) {
  _inherits(NoiDungKienNghi, _React$Component);

  function NoiDungKienNghi(props, context) {
    _classCallCheck(this, NoiDungKienNghi);

    var _this = _possibleConstructorReturn(this, (NoiDungKienNghi.__proto__ || Object.getPrototypeOf(NoiDungKienNghi)).call(this, props, context));

    _this.state = {
      isOpen: false,

      backConfirm: false,
      hasChange: false,

      type: _this.props.type,
      id: _this.props.id,
      idEdit: '',
      editDialogTitle: '',
      tongToChucKienNghiXuLyHanhChinh: 0,
      tongCaNhanKienNghiXuLyHanhChinh: 0,
      tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
      tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
      tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
      tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
      tongSaiPhamVeTienKienNghiXuLyKhac: 0,
      tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0,
      listDoiTuongThanhTra: _this.props.listDoiTuongThanhTra,
      dataDoiTuongViPham: []
    };
    return _this;
  }

  _createClass(NoiDungKienNghi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListDaTa();
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'getListDaTa',
    value: function getListDaTa() {
      var _this2 = this;

      var params = {
        cuocThanhTraId: this.state.id
      };
      if (this.props.view) {
        params.loaiDoiTuongTheoDoi = 'DOI_TUONG_THEO_DOI';
      }
      _api.ThanhTra.actions.getDoiTuongViPham.request(params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataDoiTuongViPham: res.data._embedded.doiTuongViPhams
          }, function () {
            _this2.checkSum();
            _this2.setCountDoiTuongViPham();
            _this2.setDoiTuongViPhamHienTai();
          });
        } else {
          _this2.setState({
            dataDoiTuongViPham: []
          }, function () {
            _this2.checkSum();
            _this2.setCountDoiTuongViPham();
            _this2.setDoiTuongViPhamHienTai();
          });
        }
      });
    }
  }, {
    key: 'clearDataContain',
    value: function clearDataContain(name) {
      var _this3 = this;

      var data = [].concat(_toConsumableArray(this.state.dataDoiTuongViPham));
      var dataFilter = data.filter(function (item) {
        return name == item.ten;
      });

      if (dataFilter.length > 0) {
        var params = { doiTuongViPhams: [] };
        dataFilter.map(function (item) {
          params.doiTuongViPhams[params.doiTuongViPhams.length] = {
            id: item.doiTuongViPhamId
          };
        });
        _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
          (0, _toastr.Toastr)('Xóa đối tượng vi phạm thành công', 'success');
          _this3.getListDaTa();
        });
      } else {
        (0, _toastr.Toastr)('Dữ liệu không tồn tại', 'error');
      }
    }
  }, {
    key: 'setDoiTuongViPhamHienTai',
    value: function setDoiTuongViPhamHienTai() {
      this.props.setDoiTuongViPhamHienTai(this.state.dataDoiTuongViPham);
    }
  }, {
    key: 'setCountDoiTuongViPham',
    value: function setCountDoiTuongViPham() {
      this.props.setCountDoiTuongViPham(this.state.dataDoiTuongViPham.length);
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this4 = this;

      var params = { doiTuongViPhams: [] };
      this.state.dataDoiTuongViPham.map(function (item) {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        };
      });
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
        (0, _toastr.Toastr)('Xóa tất cả đối tượng vi phạm thành công', 'success');
        _this4.getListDaTa();
      });
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      var params = {
        doiTuongViPhams: []
      };
      this.state.dataDoiTuongViPham.map(function (item) {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        };
      });
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params);
    }
  }, {
    key: 'checkSum',
    value: function checkSum() {
      if (this.state.dataDoiTuongViPham.length > 0) {
        var tongToChucKienNghiXuLyHanhChinh = 0;
        var tongCaNhanKienNghiXuLyHanhChinh = 0;
        var tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
        var tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
        var tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
        var tongSaiPhamVeTienKienNghiXuLyKhac = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
        this.state.dataDoiTuongViPham.map(function (item) {
          var toChucCoSaiPham = item.toChucCoSaiPham;
          var dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
          if (dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
            tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length;
          }
          var caNhanCoSaiPham = item.caNhanCoSaiPham;
          var dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
          if (dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
            tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length;
          }
          tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecKienNghiChuyenCoQuanDieuTra;
          tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.tienKienNghiXuLyKhac;
          tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.datKienNghiXuLyKhac;
          tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + item.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeTienKienNghiKhacXuLyVeKinhTe;
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeDatKienNghiKhacXuLyVeKinhTe;
          if (item.chuyenCoQuanDieuTra) {
            tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + 1;
          }
        });
        this.setState({
          tongToChucKienNghiXuLyHanhChinh: tongToChucKienNghiXuLyHanhChinh,
          tongCaNhanKienNghiXuLyHanhChinh: tongCaNhanKienNghiXuLyHanhChinh,
          tongSaiPhamVeTienKienNghiXuLyKinhTe: tongSaiPhamVeTienKienNghiXuLyKinhTe,
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: tongSaiPhamVeDatDaiKienNghiXuLyKinhTe,
          tongVuViecKienNghiChuyenCoQuanDieuTra: tongVuViecKienNghiChuyenCoQuanDieuTra,
          tongDoiTuongKienNghiChuyenCoQuanDieuTra: tongDoiTuongKienNghiChuyenCoQuanDieuTra,
          tongSaiPhamVeTienKienNghiXuLyKhac: tongSaiPhamVeTienKienNghiXuLyKhac,
          tongSaiPhamVeDatDaiKienNghiXuLyKhac: tongSaiPhamVeDatDaiKienNghiXuLyKhac
        });
      } else {
        this.setState({
          tongToChucKienNghiXuLyHanhChinh: 0,
          tongCaNhanKienNghiXuLyHanhChinh: 0,
          tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
          tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
          tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
          tongSaiPhamVeTienKienNghiXuLyKhac: 0,
          tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.type != nextProps.type) {
        this.setState({
          type: nextProps.type
        });
      }
    }
  }, {
    key: 'handleEditDoiTuongKienNghi',
    value: function handleEditDoiTuongKienNghi(id) {
      var _this5 = this;

      this.setState({
        idEdit: id,
        editDialogTitle: 'Chỉnh sửa đối tượng vi phạm'
      }, function () {
        _this5.setState({
          isOpen: true
        });
      });
    }
  }, {
    key: 'handleAddMore',
    value: function handleAddMore() {
      var _this6 = this;

      this.setState({
        idEdit: null,
        editDialogTitle: 'Thêm mới đối tượng vi phạm'
      }, function () {
        _this6.setState({
          isOpen: true
        });
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this7 = this;

      var params = {
        doiTuongViPhams: [{
          id: sID
        }]
      };
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
        (0, _toastr.Toastr)('Xóa đối tượng vi phạm thành công', 'success');
        _this7.getListDaTa();
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack == true) {
        this.setState({
          isOpen: false,
          backConfirm: false,
          hasChange: false
        });
        this.DoiTuongKienNghi.resetData();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.setState({
            isOpen: false,
            backConfirm: false,
            hasChange: false
          });
          this.DoiTuongKienNghi.resetData();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'getTitleDanhSach',
    value: function getTitleDanhSach() {
      var titleDanhSach = "";
      if (this.props.isTTTW) {
        if (this.state.type === 'KE_HOACH') {
          titleDanhSach = '5.1 Danh sách đối tượng vi phạm';
        } else {
          titleDanhSach = '4.1 Danh sách đối tượng vi phạm';
        }
      } else {
        if (this.state.type === 'KE_HOACH') {
          titleDanhSach = '4.1 Danh sách đối tượng vi phạm';
        } else {
          titleDanhSach = '3.1 Danh sách đối tượng vi phạm';
        }
      }
      return titleDanhSach;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { className: 'row pl10 pr10' },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'col-50 no-gutter clear-left mb10' },
          _react2.default.createElement(
            'p',
            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
            'T\u1ED5ng vi ph\u1EA1m'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-100', label: 'S\u1ED1 \u0111\u01A1n v\u1ECB vi ph\u1EA1m/\u0111\u01A1n v\u1ECB li\xEAn quan:', value: this.state.dataDoiTuongViPham.length + '/' + this.props.listDoiTuongViPham.length })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-50 no-gutter mb10' },
          _react2.default.createElement(
            'p',
            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
            'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD h\xE0nh ch\xEDnh'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng t\u1ED5 ch\u1EE9c:', value: this.state.tongToChucKienNghiXuLyHanhChinh ? String(this.state.tongToChucKienNghiXuLyHanhChinh) : '0' }),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng c\xE1 nh\xE2n:', value: this.state.tongCaNhanKienNghiXuLyHanhChinh ? String(this.state.tongCaNhanKienNghiXuLyHanhChinh) : '0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-50 no-gutter clear-left mb10' },
          _react2.default.createElement(
            'p',
            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
            'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kinh t\u1EBF'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: this.state.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(this.state.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0' }),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: this.state.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(this.state.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-50 no-gutter mb10' },
          _react2.default.createElement(
            'p',
            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
            'Ki\u1EBFn ngh\u1ECB chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: this.state.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(this.state.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0' }),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: '\u0110\u1ED1i t\u01B0\u1EE3ng:', value: this.state.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(this.state.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-50 no-gutter clear-left mb10' },
          _react2.default.createElement(
            'p',
            { className: 'txt-bold txt-upper mb10 pl5 pr5' },
            'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kh\xE1c'
          ),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: this.state.tongSaiPhamVeTienKienNghiXuLyKhac ? String(this.state.tongSaiPhamVeTienKienNghiXuLyKhac) : '0' }),
          _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: this.state.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(this.state.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100' },
          _react2.default.createElement('div', { className: 'line-border mb15' }),
          _react2.default.createElement(
            'h2',
            { className: 'title-12' },
            this.getTitleDanhSach()
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view != true },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'row white-table' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.thanhTra.danhSachDoiTuongViPham,
                  dataList: this.state.dataDoiTuongViPham,
                  pageData: this.state.pageData,
                  parent: this,
                  hideButtonExport: true,
                  titleAddmore: 'Th\xEAm m\u1EDBi \u0111\u1ED1i t\u01B0\u1EE3ng vi ph\u1EA1m',
                  hidePagination: true,
                  addMore: this.handleAddMore.bind(this),
                  showAddMore: true,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.RowItemDoiTuongThanhTra, { handleEdit: this.handleEditDoiTuongKienNghi.bind(this) })
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view == true },
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'row white-table' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.thanhTra.danhSachDoiTuongViPhamView,
                  dataList: this.state.dataDoiTuongViPham,
                  pageData: this.state.pageData,
                  parent: this,
                  hideButtonExport: true,
                  hidePagination: true,
                  showAddMore: false,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.RowItemDoiTuongThanhTraView, { chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, linhVucThanhTra: this.props.linhVucThanhTra })
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.handleBack.bind(this),
            title: this.state.editDialogTitle,
            className: 'dialog-default wrap-block' },
          _react2.default.createElement(_DoiTuongKienNghi2.default, { doiTuongThanhTraLienQuan: this.props.doiTuongThanhTraLienQuan, onRef: function onRef(DoiTuongKienNghi) {
              return _this8.DoiTuongKienNghi = DoiTuongKienNghi;
            }, handleChangeData: this.handleChangeData.bind(this), id: this.state.idEdit, getListDaTa: this.getListDaTa.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, idCuocThanhTra: this.props.id, listDoiTuongViPham: this.props.listDoiTuongViPham, closeDialog: this.handleBack.bind(this), linhVucThanhTra: this.props.linhVucThanhTra })
        )
      );
    }
  }]);

  return NoiDungKienNghi;
}(_react2.default.Component);

NoiDungKienNghi.defaultProps = {
  listDoiTuongThanhTra: [],
  listDoiTuongViPham: [],
  dataDoiTuongViPham: [],
  setDoiTuongViPhamHienTai: function setDoiTuongViPhamHienTai() {},
  view: false,
  setCountDoiTuongViPham: function setCountDoiTuongViPham() {}
};

exports.default = NoiDungKienNghi;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props, context) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));

    _this.state = {
      tenDoiTuongThanhTra: '',
      soQuyetDinh: '',
      loaiHinhThanhTra: '',
      phanLoai: '',
      linhVucThanhTra: '',
      tienDoThanhTra: '',
      soKetLuanThanhTra: '',
      soQuyetDinhXL: '',
      quyetDinhPheDuyetKHTT: '',
      tuNgay: '',
      denNgay: '',
      namThanhTra: '',
      searching: _this.props.disabled,
      spSearch: false,
      doSearch: false,
      loaiHinhThanhTraList: [{
        giaTri: "THANH_TRA",
        ten: "Thanh tra"
      }, {
        giaTri: "KIEM_TRA",
        ten: "Kiểm tra"
      }],
      phanLoaiHinhThucCTTList: [],
      tienDoList: [],
      linhVucThanhTraList: [],
      listNamThanhTra: []
    };
    return _this;
  }

  _createClass(Search, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getNamThanhTraList();

              case 2:
                _context.next = 4;
                return this.checkNamThanhTraXuLy();

              case 4:
                this.getLinhVucThanhTra();
                this.getPhanLoaiHinhThucCTT();
                this.getTienDo();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()

    // getLoaiHinhThanhTra() {
    //   ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
    //     if (res.data) {
    //       this.state.loaiHinhThanhTraList = res.data;
    //     } else {
    //       this.state.loaiHinhThanhTraList = [];
    //     }
    //     this.setState({...this.state});
    //   });
    // }

  }, {
    key: 'getPhanLoaiHinhThucCTT',
    value: function getPhanLoaiHinhThucCTT() {
      var _this2 = this;

      var state = this.state;
      _api.ThanhTra.actions.nhomHinhThucCuocThanhTraPhanLoai.request().then(function (res) {
        if (res && res.data) {
          state.phanLoaiHinhThucCTTList = res.data;
        } else {
          state.phanLoaiHinhThucCTTList = [];
        }
        _this2.setState(state);
      });
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.state.linhVucThanhTraList = res.data;
        } else {
          _this3.state.linhVucThanhTraList = [];
        }
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'getTienDo',
    value: function getTienDo() {
      var _this4 = this;

      _api.ThanhTra.actions.getTienDoThanhTra.request().then(function (res) {
        if (res.data) {
          _this4.state.tienDoList = res.data;
        } else {
          _this4.state.tienDoList = [];
        }
        _this4.setState(_extends({}, _this4.state));
      });
    }
  }, {
    key: 'checkNamThanhTraXuLy',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _api.ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if ((0, _lodash.isEmpty)(res.data)) {
                              _context2.next = 3;
                              break;
                            }

                            _context2.next = 3;
                            return _this5.setState({
                              namThanhTra: (0, _lodash.get)(res, 'data.namThanhTra')
                            });

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this5);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkNamThanhTraXuLy() {
        return _ref2.apply(this, arguments);
      }

      return checkNamThanhTraXuLy;
    }()
  }, {
    key: 'getNamThanhTraList',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
                  if (!(0, _lodash.isEmpty)(res.data)) {
                    _this6.setState({
                      listNamThanhTra: (0, _lodash.get)(res, 'data')
                    });
                  }
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getNamThanhTraList() {
        return _ref4.apply(this, arguments);
      }

      return getNamThanhTraList;
    }()
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.handleSearch(this.state, e);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
      this.resetData();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var state = this.state;
      state.tenDoiTuongThanhTra = '';
      state.soQuyetDinh = '';
      state.loaiHinhThanhTra = '';
      state.phanLoai = '';
      state.linhVucThanhTra = '';
      state.tienDoThanhTra = '';
      state.soKetLuanThanhTra = '';
      state.soQuyetDinhXL = '';
      state.quyetDinhPheDuyetKHTT = '';
      state.tuNgay = '';
      state.denNgay = '';
      state.searching = false;
      state.spSearch = false;
      state.doSearch = false;
      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');
      }
      if (this.state.doSearch) {
        classes.push('btn-loading');
      }

      var btnClasses = classNames(classes);
      return _react2.default.createElement(
        'form',
        { className: this.props.advanceSearch ? "search-form" : "search-form-default", onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(
          'div',
          { className: this.props.advanceSearch ? 'col-83' : 'col-80' },
          _react2.default.createElement(_common.Input, { className: 'col-60', label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra/ki\u1EC3m tra', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra...', value: this.state.tenDoiTuongThanhTra, onChange: this.handleChange.bind(this, 'tenDoiTuongThanhTra'), name: 'tenDoiTuongThanhTra' }),
          _react2.default.createElement(_common.DropDown, { className: 'col-40', label: 'N\u0103m thanh tra/ki\u1EC3m tra', options: this.state.listNamThanhTra, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.handleChange.bind(this, 'namThanhTra'), placeholder: true }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.advanceSearch },
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter' },
              _react2.default.createElement(_common.DropDown, { label: 'Lo\u1EA1i h\xECnh thanh tra/ki\u1EC3m tra', selectedValue: this.state.loaiHinhThanhTra, placeholder: true, className: 'col-25', onChange: this.handleChange.bind(this, 'loaiHinhThanhTra'), name: 'loaiHinhThanhTra',
                options: this.state.loaiHinhThanhTraList, keyName: 'giaTri', valueName: 'ten' }),
              _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', value: this.state.soQuyetDinh, className: 'col-25', onChange: this.handleChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', placeholder: 'Nh\u1EADp...', maxLength: 255 }),
              _react2.default.createElement(_common.DropDown, { label: 'Ph\xE2n lo\u1EA1i', selectedValue: this.state.phanLoai, placeholder: true, className: 'col-25', onChange: this.handleChange.bind(this, 'phanLoai'), name: 'phanLoai',
                options: this.state.phanLoaiHinhThucCTTList, keyName: 'giaTri', valueName: 'ten' }),
              _react2.default.createElement(_common.DropDown, { label: 'Ti\u1EBFn \u0111\u1ED9', placeholder: true, selectedValue: this.state.tienDoThanhTra, className: 'col-25', onChange: this.handleChange.bind(this, 'tienDoThanhTra'), name: 'tienDoThanhTra', options: this.state.tienDoList, keyName: 'giaTri', valueName: 'ten' })
            )
          )
        ),
        this.props.advanceSearch ? _react2.default.createElement(
          'div',
          { className: 'col-16 mt25' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ) : _react2.default.createElement(
          'div',
          { className: 'btn-wrap-default' },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.advanceSearch },
          _react2.default.createElement(
            'div',
            { className: 'col-83' },
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
            _react2.default.createElement(_common.Input, { label: 'S\u1ED1 k\u1EBFt lu\u1EADn TT/KT', value: this.state.soKetLuanThanhTra, className: 'col-25', onChange: this.handleChange.bind(this, 'soKetLuanThanhTra'), name: 'soKetLuanThanhTra', placeholder: 'Nh\u1EADp...', maxLength: 255 }),
            _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh XL', value: this.state.soQuyetDinhXL, className: 'col-25', onChange: this.handleChange.bind(this, 'soQuyetDinhXL'), name: 'soQuyetDinhXL', placeholder: 'Nh\u1EADp...', maxLength: 255 })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-16' },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search",
                onClick: this.cancel.bind(this) },
              _react2.default.createElement('i', { className: 'tt tt-delete' }),
              'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
            )
          )
        )
      );
    }
  }]);

  return Search;
}(_react2.default.Component);

Search.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
};

exports.default = (0, _utils.validatable)(Search);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _reactRedux = __webpack_require__(6);

var _upload = __webpack_require__(17);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinChung = function (_React$Component) {
  _inherits(ThongTinChung, _React$Component);

  function ThongTinChung(props, context) {
    _classCallCheck(this, ThongTinChung);

    var _this = _possibleConstructorReturn(this, (ThongTinChung.__proto__ || Object.getPrototypeOf(ThongTinChung)).call(this, props, context));

    _this.state = {
      ngayRaQuyetDinh: '',
      namThanhTraList: [],
      namThanhTra: '',
      quyetDinhPheDuyetKTTT: '',
      chucNangKeHoachThanhTra: '',
      nguoiKy: '',
      ghiChu: '',
      listTaiLieuVanThuThayTheCTT: [],
      soVanBanDieuChinh: '',
      ngayQuyetDinhDieuChinh: '',
      lyDoDieuChinh: ''
    };
    return _this;
  }

  _createClass(ThongTinChung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getNamThanhTraList();
      this.getDetails(this.props.bindValidator.props.params.id);
    }
  }, {
    key: 'getDetails',
    value: function getDetails(idKH) {
      var _this2 = this;

      _api.ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var data = res.data;
          _this2.setState({
            listTaiLieuVanThuThayTheCTT: data.listVanBanDieuChinh || [],
            soVanBanDieuChinh: data.soVanBanDieuChinh || '',
            ngayQuyetDinhDieuChinh: data.ngayQuyetDinhDieuChinh ? new Date(data.ngayQuyetDinhDieuChinh) : '',
            lyDoDieuChinh: data.lyDoDieuChinh || ''
          }, function () {
            _this2.checkFileRequire();
          });
        }
      });
    }
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      var dataTaiLieuVanThu = [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThayTheCTT));
      var dataTaiLieuVanThuFilter = dataTaiLieuVanThu.filter(function (taiLieu) {
        return (0, _lodash.get)(taiLieu, 'loaiQuyTrinh') === 'DIEU_CHINH_KE_HOACH_THANH_TRA';
      });
      if ((0, _lodash.isEmpty)(dataTaiLieuVanThuFilter)) {
        var newItem = {
          ten: 'Văn bản điều chỉnh',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          phanLoaiQuyTrinh: 'DIEU_CHINH_KE_HOACH_THANH_TRA',
          loaiQuyTrinh: 'DIEU_CHINH_KE_HOACH_THANH_TRA',
          newFile: true,
          typeRequired: 'VBDC'
        };
        this.setState({
          listTaiLieuVanThuThayTheCTT: [].concat(_toConsumableArray(this.state.listTaiLieuVanThuThayTheCTT), [newItem])
        });
      }
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this3 = this;

      if (this.props.namThanhTra.length === 0) {
        _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
          if (res.data) {
            _this3.props.dispatch({ type: 'SET_NAM_THANH_TRA', data: res.data });
          }
        });
      }
    }
  }, {
    key: 'onFileChangeDK',
    value: function onFileChangeDK(data, type) {
      this.props.onFileChange(data, type);
      this.updateData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.props.onFileRemove(id, data, type);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.data != nextProps.data) {
        this.state.namThanhTra = nextProps.data.namThanhTra || '';
        this.state.quyetDinhPheDuyetKTTT = nextProps.data.quyetDinhPheDuyetKTTT || '';
        this.state.ngayRaQuyetDinh = nextProps.data.ngayRaQuyetDinh ? new Date(nextProps.data.ngayRaQuyetDinh) : '';
        this.state.chucNangKeHoachThanhTra = nextProps.data.chucNangKeHoachThanhTra || '';
        this.state.nguoiKy = nextProps.data.nguoiKy || '';
        this.state.ghiChu = nextProps.data.ghiChu || '';
        this.setState(_extends({}, this.state));
      }

      if (this.props.tabType != nextProps.tabType) {
        this.updateData(nextProps.tabType, true);
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(newType, isInit) {
      var type = newType || this.props.tabType;
      if (type == 'old') {
        this.props.onChangeBS(this.state, isInit);
      } else {
        this.props.onChange(this.state);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this4 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        _this4.updateData();
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this5 = this;

      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d), function () {
          _this5.updateData();
        });
      } else {
        this.setState(_defineProperty({}, name, e), function () {
          _this5.updateData();
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var getTTKH = this.props.keHoach || {};
      var isKiemTra = (0, _lodash.get)(this.props, 'isKiemTra');
      var checkQD = false;
      if (getTTKH && getTTKH.keHoachDaCoQuyetDinh) {
        checkQD = true;
      }
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          this.props.tabType == 'old' ? _react2.default.createElement(
            'h2',
            { className: 'title-14 col-100 pt20 pl20 pr20 pb15' },
            '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch s\u1EEDa \u0111\u1ED5i, b\u1ED5 sung'
          ) : checkQD ? _react2.default.createElement(
            'h2',
            { className: 'title-14 p20' },
            '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch'
          ) : _react2.default.createElement(
            'h2',
            { className: 'title-14 col-100 pt20 pl20 pr20 pb15' },
            '1. Th\xF4ng tin k\u1EBF ho\u1EA1ch th\xEAm m\u1EDBi'
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: checkQD },
          _react2.default.createElement(
            'div',
            { className: 'row pl30 pr30' },
            _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + (isKiemTra ? 'kiểm tra' : 'thanh tra') + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + (isKiemTra ? 'kiểm tra' : 'thanh tra') + ' n\u0103m ' + (getTTKH && getTTKH.data && getTTKH.data.namThanhTra ? getTTKH.data.namThanhTra : '') }),
            _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT:', className: 'col-20', value: getTTKH && getTTKH.data && getTTKH.data.quyetDinhPheDuyetKTTT ? getTTKH.data.quyetDinhPheDuyetKTTT : '' }),
            _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: getTTKH && getTTKH.data && getTTKH.data.ngayRaQuyetDinh ? (0, _moment2.default)(getTTKH.data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt10' },
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 p20' },
                '2. Th\xF4ng tin \u0111i\u1EC1u ch\u1EC9nh'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl30 pr30' },
              _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n', placeholder: 'Nh\u1EADp...', value: this.state.soVanBanDieuChinh, onChange: this.onChange.bind(this, 'soVanBanDieuChinh'), name: 'soVanBanDieuChinh', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 255 }),
              _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh', value: this.state.ngayQuyetDinhDieuChinh, onChange: this.handleChangeDate.bind(this, 'ngayQuyetDinhDieuChinh'), name: 'ngayQuyetDinhDieuChinh', bindValidator: this, channel: 'formTaoDon', require: true, endDate: new Date() }),
              _react2.default.createElement(_common.TextArea, { className: 'col-100 mb5', label: 'L\xFD do:', value: this.state.lyDoDieuChinh, onChange: this.onChange.bind(this, 'lyDoDieuChinh'), name: 'lyDoDieuChinh', bindValidator: this, channel: 'formTaoDon', require: true, maxLength: 1000 })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row pl35 pr35' },
              _react2.default.createElement(_upload.ContainerFileDinhKem, { loaiVanBanSuggest: 'VBDC', soVanBanSuggest: this.state.soVanBanDieuChinh, ngayQuyetDinhSuggest: this.state.ngayQuyetDinhDieuChinh, ref: 'containerFileDinhKem', name: 'fileDinhKemDon', label: 'Danh s\xE1ch v\u0103n b\u1EA3n \u0111\xEDnh k\xE8m', bindValidator: this, data: this.state.listTaiLieuVanThuThayTheCTT, disableTopLine: true, phanLoaiQuyTrinh: 'DIEU_CHINH_KE_HOACH_THANH_TRA', onFileRemove: this.onFileRemove.bind(this), onFileChange: this.onFileChangeDK.bind(this), allowExcelFile: true })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !checkQD },
          this.props.isTTTW ? _react2.default.createElement(
            'div',
            { className: 'row pl25 pr25' },
            (this.props.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' || this.props.data.trangThaiKeHoachThanhTra === 'CHO_RA_QUYET_DINH') && _react2.default.createElement(_common.Input, { className: 'col-input', label: this.props.tabType === 'old' ? 'Số quyết định SĐ, BS' : 'Quyết định phê duyệt KHTT', placeholder: 'Nh\u1EADp...', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.quyetDinhPheDuyetKTTT, onChange: this.onChange.bind(this, 'quyetDinhPheDuyetKTTT'), name: 'quyetDinhPheDuyetKTTT', maxLength: 255 }),
            (this.props.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' || this.props.data.trangThaiKeHoachThanhTra === 'CHO_RA_QUYET_DINH') && _react2.default.createElement(_common.DatePicker, { className: 'col-input', label: 'Ng\xE0y ph\xEA duy\u1EC7t', endDate: new Date(), bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh'), name: 'ngayRaQuyetDinh' }),
            _react2.default.createElement(_common.TextArea, { className: 'col-100', label: this.props.tabType === 'old' ? 'Lý do sửa đổi, bổ sung' : 'Tóm tắt kế hoạch', bindValidator: this, require: this.props.tabType === 'old' ? true : false, channel: 'formTaoDon', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), name: 'ghiChu', rows: 3, placeholder: 'Nh\u1EADp...', maxLength: 1000 })
          ) : _react2.default.createElement(
            'div',
            { className: 'row pl25 pr25' },
            (0, _lodash.get)(this.props.data, 'trangThaiKeHoachThanhTra') === 'CHO_RA_QUYET_DINH' && _react2.default.createElement(_common.Input, { className: 'col-input', label: this.props.tabType === 'old' ? 'Số quyết định SĐ, BS' : 'Quyết định phê duyệt KHTT', placeholder: 'Nh\u1EADp...', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.quyetDinhPheDuyetKTTT, onChange: this.onChange.bind(this, 'quyetDinhPheDuyetKTTT'), name: 'quyetDinhPheDuyetKTTT', maxLength: 255 }),
            (0, _lodash.get)(this.props.data, 'trangThaiKeHoachThanhTra') === 'CHO_RA_QUYET_DINH' && _react2.default.createElement(_common.DatePicker, { className: 'col-input', label: 'Ng\xE0y ph\xEA duy\u1EC7t', endDate: new Date(), bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh'), name: 'ngayRaQuyetDinh' }),
            _react2.default.createElement(_common.TextArea, { className: 'col-100', label: this.props.tabType === 'old' ? 'Lý do sửa đổi, bổ sung' : 'Tóm tắt kế hoạch', bindValidator: this, require: this.props.tabType == 'old' ? true : false, channel: 'formTaoDon', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), name: 'ghiChu', rows: 3, placeholder: 'Nh\u1EADp...', maxLength: 1000 })
          )
        )
      );
    }
  }]);

  return ThongTinChung;
}(_react2.default.Component);

ThongTinChung.defaultProps = {
  data: {},
  dataBS: {},
  namThanhTra: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _utils.validatable)(ThongTinChung));

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(195);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _queryString = __webpack_require__(219);

var _queryString2 = _interopRequireDefault(_queryString);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(16);

var _downloadFile = __webpack_require__(112);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDon = function (_React$Component) {
  _inherits(DanhSachDon, _React$Component);

  function DanhSachDon(props, context) {
    _classCallCheck(this, DanhSachDon);

    var _this = _possibleConstructorReturn(this, (DanhSachDon.__proto__ || Object.getPrototypeOf(DanhSachDon)).call(this, props, context));

    var parsed = _queryString2.default.parse(window.location.search);
    _this.state = {
      data: [],
      tinhTrangXuLy: parsed.tinhTrangXuLy || '',
      trangThaiDon: parsed.trangThaiDon || '',
      state: _this.props.state || '',
      id: _this.props.id || '',
      donChuaChuyen: parsed.isPhongBanChuaChuyenDon || '',
      tuKhoa: '',
      tieuDe: '',
      tiepNhanTuNgay: localStorage.getItem('tdgs.tiepNhanTuNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanTuNgay')) : '',
      tiepNhanDenNgay: localStorage.getItem('tdgs.tiepNhanDenNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanDenNgay')) : '',
      year: localStorage.getItem('tdgs.year') || '',
      month: localStorage.getItem('tdgs.month') || '',
      phanHe: localStorage.getItem('tdgs.phanHe') || 'XU_LY_DON',
      loaiDonThu: localStorage.getItem('tdgs.loaiDonThu') || '',
      timKiemTheo: localStorage.getItem('tdgs.timKiemTheo') || 'day',
      nguonDon: localStorage.getItem('tdgs.nguonDon') || '',
      tableLoading: false,
      searchLoading: false,
      search: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tenDonVi: ''
    };
    return _this;
  }

  _createClass(DanhSachDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getTenDonVi();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'getTenDonVi',
    value: function getTenDonVi() {
      var _this2 = this;

      var params = {
        donViId: this.props.id,
        tinhTrangXuLy: this.state.tinhTrangXuLy,
        isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined
      };
      _api.TheoDoiGiamSat.actions.getTenDonViTaiDanhSachDungHanTreHan.request('', params).then(function (res) {
        if (res.data) {
          _this2.setState({
            tieuDe: res.data.tieuDe,
            tenDonVi: (0, _lodash.get)(res, 'data.donVi.ten', '')
          });
        }
      });
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this3 = this;

      var params = this.createParams();

      this.setState({
        tableLoading: true,
        searchLoading: true
      });

      _api.TheoDoiGiamSat.actions.getDanhSachDonDungHanTreHanTaiDonVi.request('', params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            data: res.data._embedded.dons,
            pageData: res.data.page
          });
        } else {
          _this3.setState({
            data: [],
            pageData: res.data.page
          });
        }
        _this3.setState({
          tableLoading: false,
          searchLoading: false
        });
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        tuKhoa: e.target.value
      });
    }
  }, {
    key: 'createParams',
    value: function createParams() {
      var params = {
        quyTrinh: this.state.phanHe,
        phanLoaiDon: this.state.loaiDonThu,
        donViId: this.props.id,
        tinhTrangXuLy: this.state.tinhTrangXuLy,
        isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined,
        trangThaiDon: this.state.trangThaiDon,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        nguonDon: this.state.nguonDon || undefined
      };

      if (this.state.search) {
        params.tuKhoa = this.state.tuKhoa;
      }

      if (this.state.tiepNhanTuNgay) {
        params.tuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
      }

      if (this.state.tiepNhanDenNgay) {
        params.denNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
      }

      if (this.state.month) {
        params.month = this.state.month;
      }

      if (this.state.year) {
        params.year = this.state.year;
      }

      return params;
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      var _this4 = this;

      this.setState({
        search: true
      }, function () {
        _this4.getListData();
      });
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {
      var URL = String(_config.API_URL) + "/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi/xuatExcel?" + "month=" + this.state.month + "&year=" + this.state.year + "&donViId=" + this.state.id + "&quyTrinh=" + this.state.phanHe + "&phanLoaiDon=" + this.state.loaiDonThu + "&trangThaiDon=" + this.state.trangThaiDon + "&tinhTrangXuLy=" + this.state.tinhTrangXuLy;
      if (this.state.nguonDon) {
        URL = URL + "&nguonDon=" + this.state.nguonDon;
      }
      if (this.state.donChuaChuyen) {
        URL = URL + "&isPhongBanChuaChuyenDon=" + this.state.donChuaChuyen;
      }
      if (this.state.tiepNhanTuNgay) {
        URL = URL + "&tuNgay=" + (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
      }
      if (this.state.tiepNhanDenNgay) {
        URL = URL + "&denNgay=" + (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
      }
      (0, _downloadFile.downloadFile)(URL);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-theo-doi' }),
              this.state.tieuDe,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tiepNhanTuNgay != '' },
                _react2.default.createElement(
                  'span',
                  null,
                  ' t\u1EEB ng\xE0y ',
                  (0, _moment2.default)(this.state.tiepNhanTuNgay).format('DD/MM/YYYY')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.tiepNhanDenNgay != '' },
                _react2.default.createElement(
                  'span',
                  null,
                  ' \u0111\u1EBFn ng\xE0y ',
                  (0, _moment2.default)(this.state.tiepNhanDenNgay).format('DD/MM/YYYY')
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.month != '' },
                _react2.default.createElement(
                  'span',
                  null,
                  ' th\xE1ng ',
                  this.state.month
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.year != '' },
                _react2.default.createElement(
                  'span',
                  null,
                  ' n\u0103m ',
                  this.state.year
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 pb20 theo-doi' },
              _react2.default.createElement(
                'section',
                { className: 'wrap-block search-container col-80' },
                _react2.default.createElement(
                  'form',
                  { className: 'search-form', action: 'javascript:void(0)', onSubmit: this.handleSearch.bind(this) },
                  _react2.default.createElement('input', {
                    type: 'text',
                    placeholder: 'Nh\u1EADp t\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n ho\u1EB7c s\u1ED1 CMND \u0111\u1EC3 t\xECm ki\u1EBFm...',
                    className: 'search-input',
                    value: this.state.tuKhoa,
                    onChange: this.onChange.bind(this)
                  }),
                  _react2.default.createElement(_core.Button, {
                    type: 'submit',
                    text: 'T\xECm ki\u1EBFm',
                    className: this.state.tableLoading ? this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-20 search-thanh-tra mt0' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'col-100 no-gutter btn-green tt-export', onClick: this.handleExportExcel.bind(this) },
                  'Xu\u1EA5t \u0111\u01A1n ',
                  this.state.tinhTrangXuLy == "DUNG_HAN" ? "đúng hạn" : "trễ hạn"
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.theoDoi.danhSachDonTreHan,
              dataList: this.state.data,
              pageData: this.state.pageData,
              parent: this,
              hideButtonExport: true,
              search: this.state.search,
              tableLoading: this.state.tableLoading
            },
            _react2.default.createElement(_datatable.RowItemDanhSachDon, { tenDonVi: this.state.tenDonVi })
          )
        )
      );
    }
  }]);

  return DanhSachDon;
}(_react2.default.Component);

DanhSachDon.defaultProps = {
  validators: {}
};

exports.default = (0, _reactRouter.withRouter)(DanhSachDon);

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(195);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _core = __webpack_require__(7);

var _queryString = __webpack_require__(219);

var _queryString2 = _interopRequireDefault(_queryString);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__(16);

var _downloadFile = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDonTheoKy = function (_Component) {
  _inherits(DanhSachDonTheoKy, _Component);

  function DanhSachDonTheoKy(props, context) {
    _classCallCheck(this, DanhSachDonTheoKy);

    var _this = _possibleConstructorReturn(this, (DanhSachDonTheoKy.__proto__ || Object.getPrototypeOf(DanhSachDonTheoKy)).call(this, props, context));

    var parsed = _queryString2.default.parse(window.location.search);
    var filterTheoKyData = JSON.parse(localStorage.getItem("tdgstk"));
    _this.state = {
      data: [],
      trangThaiDon: (0, _lodash.get)(parsed, 'trangThaiDon', ''),
      id: (0, _lodash.get)(parsed, 'donViId', ''),
      ky: (0, _lodash.get)(parsed, 'ky', ''),
      chiThuocQuyenLanhDao: (0, _lodash.get)(parsed, 'chiThuocQuyenLanhDao', ''),
      donChuaChuyen: parsed.isPhongBanChuaChuyenDon || '',
      tuKhoa: '',
      tiepNhanTuNgay: (0, _lodash.get)(filterTheoKyData, 'tiepNhanTuNgay') ? new Date(filterTheoKyData.tiepNhanTuNgay) : '',
      tiepNhanDenNgay: (0, _lodash.get)(filterTheoKyData, 'tiepNhanDenNgay') ? new Date(filterTheoKyData.tiepNhanDenNgay) : '',
      year: (0, _lodash.get)(filterTheoKyData, 'year', (0, _moment2.default)().format('YYYY')),
      month: (0, _lodash.get)(filterTheoKyData, 'month', ''),
      kyBaoCao: (0, _lodash.get)(filterTheoKyData, 'selectedTheoKy', ''),
      loaiDonThu: (0, _lodash.get)(filterTheoKyData, 'loaiDonThu', ''),
      timKiemTheo: (0, _lodash.get)(filterTheoKyData, 'timKiemTheo', 'year'),
      nguonDon: (0, _lodash.get)(filterTheoKyData, 'nguonDon', ''),
      tableLoading: false,
      searchLoading: false,
      search: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tenDonVi: ''
    };
    return _this;
  }

  _createClass(DanhSachDonTheoKy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
      this.getTenDonVi();
    }
  }, {
    key: 'getTheoKy',
    value: function getTheoKy() {
      if (!(0, _lodash.isEmpty)(this.state.ky)) {
        return this.state.ky;
      }
      return this.state.kyBaoCao;
    }
  }, {
    key: 'getTenDonVi',
    value: function getTenDonVi() {
      var _this2 = this;

      var params = {
        donViId: this.state.id,
        tinhTrangXuLy: 'DUNG_HAN'
      };
      _api.TheoDoiGiamSat.actions.getTenDonViTaiDanhSachDungHanTreHan.request('', params).then(function (res) {
        if (res.data) {
          _this2.setState({
            tenDonVi: (0, _lodash.get)(res, 'data.donVi.ten', '')
          });
        }
      });
    }
  }, {
    key: 'getListData',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var tuKhoa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  tableLoading: true,
                  searchLoading: true
                });
                params = {
                  phanLoaiDon: this.state.loaiDonThu || undefined,
                  ky: this.getTheoKy() || undefined,
                  nguonDon: this.state.nguonDon || undefined,
                  trangThaiDon: !(0, _lodash.isEmpty)(this.state.trangThaiDon) ? this.state.trangThaiDon.join(',') : undefined,
                  donViId: this.state.id || undefined,
                  chiThuocQuyenLanhDao: this.state.chiThuocQuyenLanhDao || undefined,
                  isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined,
                  page: this.state.pageData.number,
                  size: this.state.pageData.size
                };

                if (this.state.timKiemTheo === 'day') {
                  params.tuNgay = this.state.tiepNhanTuNgay ? (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString() : undefined;
                  params.denNgay = this.state.tiepNhanDenNgay ? (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString() : undefined;
                }
                if (this.state.timKiemTheo === 'month') {
                  params.month = this.state.month;
                  params.year = this.state.year;
                }
                if (this.state.timKiemTheo === 'year') {
                  params.year = this.state.year;
                }
                if (!(0, _lodash.isEmpty)(tuKhoa)) {
                  params.tuKhoa = tuKhoa;
                }
                if (this.state.chiThuocQuyenLanhDao) {
                  params = {
                    trangThaiDon: !(0, _lodash.isEmpty)(this.state.trangThaiDon) ? this.state.trangThaiDon.join(',') : undefined,
                    donViId: this.state.id || undefined,
                    chiThuocQuyenLanhDao: this.state.chiThuocQuyenLanhDao || undefined,
                    year: (0, _moment2.default)().format('YYYY'),
                    ky: this.getTheoKy() || undefined,
                    page: this.state.pageData.number,
                    size: this.state.pageData.size
                  };
                }
                _context.next = 9;
                return _api.TheoDoiGiamSat.actions.getDanhSachDonTaiDonVi.request('', params).then(function (res) {
                  _this3.setState({
                    data: !(0, _lodash.isEmpty)(res.data._embedded) ? res.data._embedded.dons : [],
                    pageData: res.data.page
                  });
                }).catch(function (error) {
                  console.error("Error :" + error);
                  _this3.setState({
                    tableLoading: false,
                    searchLoading: false
                  });
                }).finally(function () {
                  _this3.setState({
                    tableLoading: false,
                    searchLoading: false
                  });
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getListData() {
        return _ref.apply(this, arguments);
      }

      return getListData;
    }()
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      this.getListData(this.state.tuKhoa);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var value = e.target.value;

      this.setState({
        tuKhoa: value
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this4 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this4.getListData();
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: 0,
          size: size
        })
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {
      this.setState({
        loadingExport: true
      });
      try {
        var URL = String(_config.API_URL) + "/theoDoiGiamSatTheoKys/danhSachDonTaiDonVi/xuatExcel?" + "donViId=" + this.state.id;
        if (!(0, _lodash.isEmpty)(this.state.tuKhoa)) {
          URL = URL + "&tuKhoa=" + this.state.tuKhoa;
        }
        if (this.state.loaiDonThu) {
          URL = URL + "&phanLoaiDon=" + this.state.loaiDonThu;
        }
        if (!(0, _lodash.isEmpty)(this.state.ky) || !(0, _lodash.isEmpty)(this.state.kyBaoCao)) {
          URL = URL + "&ky=" + this.getTheoKy();
        }
        if (!(0, _lodash.isEmpty)(this.state.trangThaiDon)) {
          URL = URL + "&trangThaiDon=" + this.state.trangThaiDon.join(',');
        }
        if (this.state.chiThuocQuyenLanhDao) {
          URL = URL + "&year=" + (0, _moment2.default)().format('YYYY');
          URL = URL + "&chiThuocQuyenLanhDao=" + this.state.chiThuocQuyenLanhDao;
        } else {
          if (this.state.timKiemTheo === 'day') {
            if ((0, _lodash.get)(this.state, 'tiepNhanTuNgay')) {
              URL = URL + "&tuNgay=" + (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
            }
            if ((0, _lodash.get)(this.state.filterTheoKy, 'tiepNhanDenNgay')) {
              URL = URL + "&denNgay=" + (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
            }
          }
          if (this.state.timKiemTheo === 'month') {
            URL = URL + "&month=" + this.state.month;
            URL = URL + "&year=" + this.state.year;
          }
          if (this.state.timKiemTheo === 'year') {
            URL = URL + "&year=" + this.state.year;
          }
          if (this.state.donChuaChuyen) {
            URL = URL + "&isPhongBanChuaChuyenDon=" + this.state.donChuaChuyen;
          }
        }
        (0, _downloadFile.downloadFile)(URL);
      } catch (error) {} finally {
        setTimeout(function () {
          this.setState({
            loadingExport: false
          });
        }.bind(this), 3000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var getTitle = function getTitle() {
        var title = 'Danh sách đơn thuộc thẩm quyền lãnh đạo đơn vị';
        if (_this6.state.chiThuocQuyenLanhDao && (0, _lodash.includes)(_this6.state.trangThaiDon, 'DA_XU_LY')) {
          title = 'Danh sách đơn đã xử lý, giải quyết thuộc thẩm quyền lãnh đạo đơn vị';
        }
        if (_this6.state.chiThuocQuyenLanhDao && (0, _lodash.includes)(_this6.state.trangThaiDon, 'DANG_XU_LY')) {
          title = 'Danh sách đơn đang xử lý, giải quyết thuộc thẩm quyền lãnh đạo đơn vị';
        }
        return title;
      };
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-theo-doi' }),
              this.state.chiThuocQuyenLanhDao ? getTitle() : 'Danh sách theo dõi đôn đốc theo kỳ'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 pb20 theo-doi' },
              _react2.default.createElement(
                'section',
                { className: 'wrap-block search-container col-80' },
                _react2.default.createElement(
                  'form',
                  { className: 'search-form', action: 'javascript:void(0)', onSubmit: this.handleSearch.bind(this) },
                  _react2.default.createElement('input', {
                    type: 'text',
                    placeholder: 'Nh\u1EADp t\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n ho\u1EB7c s\u1ED1 CMND \u0111\u1EC3 t\xECm ki\u1EBFm...',
                    className: 'search-input',
                    value: this.state.tuKhoa,
                    onChange: this.onChange.bind(this)
                  }),
                  _react2.default.createElement(_core.Button, {
                    type: 'submit',
                    text: 'T\xECm ki\u1EBFm',
                    className: this.state.tableLoading ? this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-20 text-right' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    className: (0, _classnames2.default)('btn-green tt-export', { 'btn-loading-inline': this.state.loadingExport }),
                    onClick: this.handleExportExcel.bind(this)
                  },
                  'Xu\u1EA5t danh s\xE1ch'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.theoDoi.danhSachDonTreHan,
              dataList: this.state.data,
              pageData: this.state.pageData,
              parent: this,
              hideButtonExport: true,
              search: this.state.search,
              tableLoading: this.state.tableLoading
            },
            _react2.default.createElement(_datatable.RowItemDanhSachDon, { tenDonVi: this.state.tenDonVi })
          )
        )
      );
    }
  }]);

  return DanhSachDonTheoKy;
}(_react.Component);

exports.default = DanhSachDonTheoKy;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _core = __webpack_require__(7);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(195);

var _lodash = __webpack_require__(14);

var _api = __webpack_require__(5);

var _queryString = __webpack_require__(219);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachThongKeGiamSatDonCu = function (_Component) {
  _inherits(DanhSachThongKeGiamSatDonCu, _Component);

  function DanhSachThongKeGiamSatDonCu(props) {
    _classCallCheck(this, DanhSachThongKeGiamSatDonCu);

    var _this = _possibleConstructorReturn(this, (DanhSachThongKeGiamSatDonCu.__proto__ || Object.getPrototypeOf(DanhSachThongKeGiamSatDonCu)).call(this, props));

    _this.state = {
      tenDonvi: (0, _lodash.get)(_this.props, 'params.tenDonVi'),
      tuKhoa: '',
      tableLoading: false,
      search: false,
      danhsachDon: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      }
    };
    return _this;
  }

  _createClass(DanhSachThongKeGiamSatDonCu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this2 = this;

      this.setState({
        search: true,
        tableLoading: true
      });
      var parsed = _queryString2.default.parse(window.location.search);
      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        idDonViHienTai: (0, _lodash.get)(this.props, 'params.idDonVi') || undefined,
        tuKhoa: this.state.tuKhoa.trim() || undefined,
        loaiThongTinDon: (0, _lodash.get)(this.props, 'params.loaiThongTinDon') || undefined,
        phanLoaiDon: parsed.phanLoaiDon || undefined,
        nguonDon: parsed.nguonDon || undefined
      };
      _api.ThongKeBaoCao.actions.getDanhSachDonCuThongKe.request(params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var data = (0, _lodash.get)(res, 'data._embedded.donCus');
          _this2.setState({
            danhsachDon: data,
            pageData: (0, _lodash.get)(res, 'data.page')
          });
        }
      }).finally(function () {
        _this2.setState({
          search: false,
          tableLoading: false
        });
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      var _this3 = this;

      this.setState({
        search: true
      }, function () {
        _this3.getListData();
      });
    }
  }, {
    key: 'onChangeKeyWord',
    value: function onChangeKeyWord(e) {
      this.setState({
        tuKhoa: e.target.value
      });
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this4 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this4.getListData();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this5.getListData();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-theo-doi' }),
              'Danh s\xE1ch \u0110\u01A1n nh\u1EADp li\u1EC7u c\u0169 t\u1EA1i ' + this.state.tenDonvi
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'div',
            { className: 'wrap-block pl15 pr15 pt20' },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10 pb20 theo-doi' },
              _react2.default.createElement(
                'section',
                { className: 'wrap-block search-container col-80' },
                _react2.default.createElement(
                  'form',
                  { className: 'search-form', action: 'javascript:void(0)', onSubmit: this.handleSearch.bind(this) },
                  _react2.default.createElement('input', {
                    type: 'text',
                    placeholder: 'Nh\u1EADp t\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n ho\u1EB7c s\u1ED1 CMND \u0111\u1EC3 t\xECm ki\u1EBFm...',
                    className: 'search-input',
                    value: this.state.tuKhoa,
                    onChange: this.onChangeKeyWord.bind(this)
                  }),
                  _react2.default.createElement(_core.Button, {
                    type: 'submit',
                    text: 'T\xECm ki\u1EBFm',
                    className: this.state.tableLoading ? this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable" : "btn-green tt-search"
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            {
              header: _table.header.theoDoi.danhSachThongKeGiamSatDonCu,
              dataList: this.state.danhsachDon,
              pageData: this.state.pageData,
              parent: this,
              hideButtonExport: true,
              search: this.state.search,
              tableLoading: this.state.tableLoading
            },
            _react2.default.createElement(_datatable.RowItemDanhSachThongKeGiamSatDonCu, null)
          )
        )
      );
    }
  }]);

  return DanhSachThongKeGiamSatDonCu;
}(_react.Component);

exports.default = DanhSachThongKeGiamSatDonCu;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(195);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongKeGiamSatNhapDonCu = function (_Component) {
  _inherits(ThongKeGiamSatNhapDonCu, _Component);

  function ThongKeGiamSatNhapDonCu(props, context) {
    _classCallCheck(this, ThongKeGiamSatNhapDonCu);

    var _this = _possibleConstructorReturn(this, (ThongKeGiamSatNhapDonCu.__proto__ || Object.getPrototypeOf(ThongKeGiamSatNhapDonCu)).call(this, props, context));

    _this.state = {
      data: [],
      id: _this.props.id,
      sum: {
        tongSoDon: 0,
        tongSoDonDonGian: 0,
        tongSoDonPhucTap: 0
      },
      pageData: {
        number: 0,
        size: 10,
        totalElements: 50
      },
      tableLoading: false,
      searchLoading: false,
      search: false,
      phanLoaiDon: '',
      nguonDon: ''
    };
    return _this;
  }

  _createClass(ThongKeGiamSatNhapDonCu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData(this.props.id);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.id !== nextProps.id) {
        this.getListData(nextProps.id);
      }
    }
  }, {
    key: 'getListData',
    value: function getListData(id) {
      var _this2 = this;

      var params = {
        nguonDon: this.state.nguonDon,
        phanLoaiDon: this.state.phanLoaiDon,
        donViId: id
      };
      this.setState({
        tableLoading: true,
        searchLoading: true
      });
      if (id) {
        return _api.TheoDoiGiamSat.actions.getThongKeSoLieuDonCuTheoDonViCon.request('', params).then(function (res) {
          if (res.data) {
            _this2.setState({
              data: res.data.donVis,
              sum: {
                tongSoDon: res.data.tongSoDon
              },
              tableLoading: false,
              searchLoading: false,
              search: false
            });
          }
        });
      }
      return _api.TheoDoiGiamSat.actions.getThongKeSoLieuDonCuTheoDonVi.request('', params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data.donVis,
            sum: {
              tongSoDon: res.data.tongSoDon,
              tongSoDonDonGian: res.data.tongSoDonDonGian,
              tongSoDonPhucTap: res.data.tongSoDonPhucTap
            },
            tableLoading: false,
            searchLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this3 = this;

      e.preventDefault();
      this.setState({
        search: true
      }, function () {
        _this3.getListData(_this3.props.id);
      });
      return;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        this.props.id && _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-theo-doi' }),
              'Th\u1ED1ng k\xEA gi\xE1m s\xE1t nh\u1EADp \u0111\u01A1n c\u0169'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'form',
            { className: 'wrap-block pl15 pr15 pt20', onSubmit: this.handleSearch.bind(this) },
            _react2.default.createElement(
              'div',
              { className: 'row pl10 pr10' },
              _react2.default.createElement(_ttForms.DropDownChonNguonDon, { selectedValue: this.state.nguonDon, onChange: this.handleChange.bind(this, 'nguonDon'), className: 'col-25' }),
              _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, onChange: this.handleChange.bind(this, 'phanLoaiDon'), className: 'col-25' }),
              _react2.default.createElement(
                'div',
                { className: 'col' },
                _react2.default.createElement(
                  'div',
                  { className: 'rows' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-16 mb0-18 search-thanh-tra clear-right' },
                    _react2.default.createElement(
                      'button',
                      { className: (0, _classnames2.default)('btn-green', { 'btn-loading-inline': this.state.searchLoading, 'btn-disable': this.state.search }), type: 'submit', disabled: this.state.searchLoading ? 'disabled' : '' },
                      _react2.default.createElement('i', { className: 'tt-search' }),
                      'Xem k\u1EBFt qu\u1EA3'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            _extends({
              header: _table.header.theoDoi.thongKeGiamSatNhapDonCu,
              dataList: this.state.data,
              hidePagination: true,
              pageData: this.state.pageData,
              parent: this,
              search: this.state.search,
              tableLoading: this.state.tableLoading,
              thongKeDonCu: true
            }, this.state.sum),
            _react2.default.createElement(_datatable.RowItemThongKeGiamSatNhapDonCu, { phanLoaiDon: this.state.phanLoaiDon, nguonDon: this.state.nguonDon })
          )
        )
      );
    }
  }]);

  return ThongKeGiamSatNhapDonCu;
}(_react.Component);

ThongKeGiamSatNhapDonCu.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = ThongKeGiamSatNhapDonCu;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(195);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _config = __webpack_require__(16);

var _downloadFile = __webpack_require__(112);

var _lodash = __webpack_require__(14);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinhHinhXuLyDonTaiDonVi = function (_React$Component) {
  _inherits(TinhHinhXuLyDonTaiDonVi, _React$Component);

  function TinhHinhXuLyDonTaiDonVi(props, context) {
    _classCallCheck(this, TinhHinhXuLyDonTaiDonVi);

    var _this = _possibleConstructorReturn(this, (TinhHinhXuLyDonTaiDonVi.__proto__ || Object.getPrototypeOf(TinhHinhXuLyDonTaiDonVi)).call(this, props, context));

    var filterTheoKyData = JSON.parse(localStorage.getItem("tdgstk"));
    _this.state = {
      data: [],
      id: _this.props.id,
      title: 'Tình hình xử lý đơn tại các đơn vị',
      dataPhanHe: [],
      dataTimKiem: [],
      dataLoaiDonThu: [],
      dataListTheoKy: [],
      sum: {
        tongDonDangDaXL: 0,
        tongDonDungHanDaXL: 0,
        tongDonDungHanDangXL: 0,
        tongDonTreHanDaXL: 0,
        tongDonTreHanDangXL: 0
      },
      sumTheoKy: {
        tongDon: 0,
        tongDonDaXLGQ: 0,
        tongDonDangXLGQ: 0,
        tongDonKyTruoc: 0,
        tongDonTrongKy: 0
      },
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      pageDataTheoKy: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      theoDoiDonDoc: localStorage.getItem('tdgs.theoDoiDonDoc') || 'TDDD_XLD_GQD',
      tiepNhanTuNgay: localStorage.getItem('tdgs.tiepNhanTuNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanTuNgay')) : '',
      tiepNhanDenNgay: localStorage.getItem('tdgs.tiepNhanDenNgay') ? new Date(localStorage.getItem('tdgs.tiepNhanDenNgay')) : '',
      year: localStorage.getItem('tdgs.year') || (0, _moment2.default)().format('YYYY'),
      month: localStorage.getItem('tdgs.month') || '',
      phanHe: localStorage.getItem('tdgs.phanHe') || 'XU_LY_DON',
      loaiDonThu: localStorage.getItem('tdgs.loaiDonThu') || '',
      timKiemTheo: localStorage.getItem('tdgs.timKiemTheo') || 'year',
      nguonDon: localStorage.getItem('tdgs.nguonDon') || '',
      coQuanQuanLyFilter: JSON.parse(localStorage.getItem('tdgs.coQuanQuanLyFilter')) || [],
      filterTheoKy: {
        timKiemTheo: (0, _lodash.get)(filterTheoKyData, 'timKiemTheo', 'year'),
        year: (0, _lodash.get)(filterTheoKyData, 'year', (0, _moment2.default)().format('YYYY')),
        month: (0, _lodash.get)(filterTheoKyData, 'month', ''),
        tiepNhanTuNgay: (0, _lodash.get)(filterTheoKyData, 'tiepNhanTuNgay') ? new Date(filterTheoKyData.tiepNhanTuNgay) : '',
        tiepNhanDenNgay: (0, _lodash.get)(filterTheoKyData, 'tiepNhanDenNgay') ? new Date(filterTheoKyData.tiepNhanDenNgay) : '',
        loaiDonThu: (0, _lodash.get)(filterTheoKyData, 'loaiDonThu', ''),
        nguonDon: (0, _lodash.get)(filterTheoKyData, 'nguonDon', ''),
        selectedTheoKy: (0, _lodash.get)(filterTheoKyData, 'selectedTheoKy', ''),
        coQuanQuanLyFilter: (0, _lodash.get)(filterTheoKyData, 'coQuanQuanLyFilter', [])
      },
      tableLoading: false,
      searchLoading: false,
      search: false,
      coQuanQuanLyList: [],
      listCoQuanQuanLyTheoKy: [],
      listNguonDon: [],
      acceptDataLoad: true,
      acceptDataLoadTheoKy: true,
      loadingExport: false,
      isSearchDonVi: false,
      isSearchDonViTheoKy: false
    };
    return _this;
  }

  _createClass(TinhHinhXuLyDonTaiDonVi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getPhanHe();
      this.getLoaiDonThu();
      this.getListDaTa(this.props.id);
      this.getTypeTimKiem();
      this.getDataTheoKy();
      this.getDataNguonDon();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.id != nextProps.id) {
        this.getListDaTa(nextProps.id);
        this.getDataTheoKy(nextProps.id);
      }
    }
  }, {
    key: 'getDataNguonDon',
    value: function getDataNguonDon() {
      var _this2 = this;

      _api.LetterProcessingWorkFlow.actions.getNguonDon.request().then(function (res) {
        if (res.data) {
          var result = res.data.filter(function (item) {
            return item.giaTri !== "GIAO_TTXM" && item.giaTri !== "GIAO_KTDX" && item.giaTri !== "GIAO_TDTH";
          });
          _this2.setState({
            listNguonDon: result
          });
        }
      });
    }
  }, {
    key: 'setDataFilterCoQuanQuanLy',
    value: function setDataFilterCoQuanQuanLy(data) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (this.state.acceptDataLoad && name !== 'theoKy') {
        this.setState({
          coQuanQuanLyList: data
        });
      }
      if (this.state.acceptDataLoadTheoKy && name === 'theoKy') {
        this.setState({
          listCoQuanQuanLyTheoKy: data
        });
      }
    }
  }, {
    key: 'getListDaTa',
    value: function getListDaTa(id) {
      var _this3 = this;

      var params = {
        quyTrinh: this.state.phanHe,
        phanLoaiDon: this.state.loaiDonThu,
        tiepNhanTuNgay: this.state.tiepNhanTuNgay,
        tiepNhanDenNgay: this.state.tiepNhanDenNgay,
        year: this.state.year,
        month: this.state.month,
        nguonDon: this.state.nguonDon || undefined
      };
      if (!(0, _lodash.isEmpty)(this.state.coQuanQuanLyFilter) && !id) {
        var ids2 = [];
        this.state.coQuanQuanLyFilter.map(function (item) {
          ids2.push(item.value);
        });
        params.listCoQuanQuanLys = ids2.join();
      }
      if (id) {
        params.donViId = id;
      }
      localStorage.setItem('tdgs.phanHe', this.state.phanHe);
      localStorage.setItem('tdgs.loaiDonThu', this.state.loaiDonThu);
      localStorage.setItem('tdgs.timKiemTheo', this.state.timKiemTheo);
      localStorage.setItem('tdgs.tiepNhanTuNgay', this.state.tiepNhanTuNgay);
      localStorage.setItem('tdgs.tiepNhanDenNgay', this.state.tiepNhanDenNgay);
      localStorage.setItem('tdgs.year', this.state.year);
      localStorage.setItem('tdgs.month', this.state.month);
      localStorage.setItem('tdgs.theoDoiDonDoc', this.state.theoDoiDonDoc);
      localStorage.setItem('tdgs.nguonDon', this.state.nguonDon);
      localStorage.setItem('tdgs.coQuanQuanLyFilter', JSON.stringify(this.state.coQuanQuanLyFilter));

      if (this.state.search) {
        if (this.state.tiepNhanTuNgay) {
          params.tuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
          localStorage.setItem('tdgs.tiepNhanTuNgay', params.tuNgay);
        }

        if (this.state.tiepNhanDenNgay) {
          params.denNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
          localStorage.setItem('tdgs.tiepNhanDenNgay', params.denNgay);
        }

        if (this.state.month) {
          params.month = this.state.month;
          localStorage.setItem('tdgs.month', this.state.month);
        }

        if (this.state.year) {
          params.year = this.state.year;
          localStorage.setItem('tdgs.year', this.state.year);
        }

        if (params.tuNgay && params.denNgay && params.tuNgay > params.denNgay) {
          return (0, _toastr.Toastr)('Bạn không được nhập Đến ngày bé hơn Từ ngày', 'error');
        }
      }

      this.setState({
        tableLoading: true,
        searchLoading: true
      });
      if (id) {
        _api.TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonViCon.request('', params).then(function (res) {
          if (res.data) {
            var _res$data = res.data,
                donViCha = _res$data.donViCha,
                donVis = _res$data.donVis;

            if (!(0, _lodash.isEmpty)(donViCha)) {
              donVis.unshift(_extends({}, donViCha, {
                isDonViCha: true
              }));
            }
            _this3.setState({
              data: donVis,

              title: 'T\xECnh h\xECnh ' + (localStorage.getItem('tdgs.phanHe') == 'XU_LY_DON' ? 'xử lý đơn' : localStorage.getItem('tdgs.phanHe') == 'GIAI_QUYET_DON' ? 'giải quyết đơn' : localStorage.getItem('tdgs.phanHe') == 'KIEM_TRA_DE_XUAT' ? 'kiểm tra đề xuất' : localStorage.getItem('tdgs.phanHe') == 'THAM_TRA_XAC_MINH' ? 'thẩm tra xác minh' : 'xử lý đơn') + ' tr\xEAn \u0111\u1ECBa b\xE0n ' + (0, _lodash.get)(res, 'data.donViCha.donVi.tenDonVi'),
              sum: {
                tongDonDangDaXL: res.data.tongDonDangDaXL ? res.data.tongDonDangDaXL : 0,
                tongDonDungHanDaXL: res.data.tongDonDungHanDaXL ? res.data.tongDonDungHanDaXL : 0,
                tongDonDungHanDangXL: res.data.tongDonDungHanDangXL ? res.data.tongDonDungHanDangXL : 0,
                tongDonTreHanDaXL: res.data.tongDonTreHanDaXL ? res.data.tongDonTreHanDaXL : 0,
                tongDonTreHanDangXL: res.data.tongDonTreHanDangXL ? res.data.tongDonTreHanDangXL : 0
              },
              tableLoading: false,
              searchLoading: false,
              search: false
            });
          }
        }).catch(function (error) {
          if (error.response.data.errors) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this3.setState({
            tableLoading: false,
            searchLoading: false,
            search: false
          });
        });
      } else {
        _api.TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonVi.request('', params).then(function (res) {
          if (res.data) {
            var _res$data2 = res.data,
                donViCha = _res$data2.donViCha,
                donVis = _res$data2.donVis;

            var listDataDonVi = [].concat(_toConsumableArray(donVis));
            var newDataOption = [];
            listDataDonVi.forEach(function (item) {
              if (item.donVi.tenDonVi === "Đơn chưa chuyển phòng ban") {
                // Do notthing
              } else {
                newDataOption.push({
                  giaTri: (0, _lodash.get)(item, 'donVi.id') || '',
                  ten: (0, _lodash.get)(item, 'donVi.tenDonVi') || ''
                });
              }
            });
            if (!(0, _lodash.isEmpty)(donViCha)) {
              donVis.unshift(_extends({}, donViCha, {
                isDonViCha: true
              }));
            }
            _this3.setDataFilterCoQuanQuanLy(newDataOption);
            _this3.setState({
              data: donVis,
              acceptDataLoad: false,
              isSearchDonVi: (0, _lodash.isEmpty)(donViCha),
              title: 'T\xECnh h\xECnh ' + (localStorage.getItem('tdgs.phanHe') == 'XU_LY_DON' ? 'xử lý đơn' : localStorage.getItem('tdgs.phanHe') == 'GIAI_QUYET_DON' ? 'giải quyết đơn' : localStorage.getItem('tdgs.phanHe') == 'KIEM_TRA_DE_XUAT' ? 'kiểm tra đề xuất' : localStorage.getItem('tdgs.phanHe') == 'THAM_TRA_XAC_MINH' ? 'thẩm tra xác minh' : 'xử lý đơn') + ' t\u1EA1i c\xE1c \u0111\u01A1n v\u1ECB',
              sum: {
                tongDonDangDaXL: res.data.tongDonDangDaXL ? res.data.tongDonDangDaXL : 0,
                tongDonDungHanDaXL: res.data.tongDonDungHanDaXL ? res.data.tongDonDungHanDaXL : 0,
                tongDonDungHanDangXL: res.data.tongDonDungHanDangXL ? res.data.tongDonDungHanDangXL : 0,
                tongDonTreHanDaXL: res.data.tongDonTreHanDaXL ? res.data.tongDonTreHanDaXL : 0,
                tongDonTreHanDangXL: res.data.tongDonTreHanDangXL ? res.data.tongDonTreHanDangXL : 0
              },
              tableLoading: false,
              searchLoading: false,
              search: false
            });
          }
        }).catch(function (error) {
          if (error.response.data.errors) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this3.setState({
            tableLoading: false,
            searchLoading: false,
            search: false
          });
        });
      }
    }
  }, {
    key: 'getDataTheoKy',
    value: function getDataTheoKy() {
      var _this4 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.setState({
        tableTheoKyLoading: true
      });
      var params = {
        phanLoaiDon: this.state.filterTheoKy.loaiDonThu,
        tuNgay: this.state.filterTheoKy.tiepNhanTuNgay || undefined,
        denNgay: this.state.filterTheoKy.tiepNhanDenNgay || undefined,
        year: this.state.filterTheoKy.year || undefined,
        month: this.state.filterTheoKy.month || undefined,
        nguonDon: this.state.filterTheoKy.nguonDon || undefined,
        ky: this.state.filterTheoKy.selectedTheoKy || undefined
      };
      if (!(0, _lodash.isEmpty)(this.state.filterTheoKy.coQuanQuanLyFilter) && !id) {
        var ids2 = [];
        this.state.filterTheoKy.coQuanQuanLyFilter.map(function (item) {
          ids2.push(item.value);
        });
        params.listCoQuanQuanLys = ids2.join();
      }
      if (id) {
        params.listCoQuanQuanLys = id;
      }
      var dataLocal = {
        loaiDonThu: this.state.filterTheoKy.loaiDonThu,
        timKiemTheo: this.state.filterTheoKy.timKiemTheo,
        tiepNhanTuNgay: this.state.filterTheoKy.tiepNhanTuNgay,
        tiepNhanDenNgay: this.state.filterTheoKy.tiepNhanDenNgay,
        year: this.state.filterTheoKy.year,
        month: this.state.filterTheoKy.month,
        selectedTheoKy: this.state.filterTheoKy.selectedTheoKy,
        nguonDon: this.state.filterTheoKy.nguonDon,
        coQuanQuanLyFilter: this.state.filterTheoKy.coQuanQuanLyFilter
      };
      localStorage.setItem('tdgstk', JSON.stringify(dataLocal));
      if (this.state.filterTheoKy.timKiemTheo === 'day') {
        if (this.state.filterTheoKy.tiepNhanTuNgay) {
          params.tuNgay = (0, _moment2.default)(this.state.filterTheoKy.tiepNhanTuNgay).add(7, 'hours').toISOString();
        }
        if (this.state.filterTheoKy.tiepNhanDenNgay) {
          params.denNgay = (0, _moment2.default)(this.state.filterTheoKy.tiepNhanDenNgay).add(7, 'hours').toISOString();
        }
        params.month = undefined;
        params.year = undefined;
      }
      if (this.state.filterTheoKy.timKiemTheo === 'month') {
        params.tuNgay = undefined;
        params.denNgay = undefined;
        if (this.state.filterTheoKy.month) {
          params.month = this.state.filterTheoKy.month;
        }
      }
      if (this.state.filterTheoKy.timKiemTheo === 'year') {
        params.tuNgay = undefined;
        params.denNgay = undefined;
        params.month = undefined;
        if (this.state.filterTheoKy.year) {
          params.year = this.state.filterTheoKy.year;
        }
      }

      if (params.tuNgay && params.denNgay && params.tuNgay > params.denNgay) {
        return (0, _toastr.Toastr)('Bạn không được nhập Đến ngày bé hơn Từ ngày', 'error');
      }

      _api.TheoDoiGiamSat.actions.getTinhHinhXuLyDonCacDonViTheoKy.request('', params).then(function (res) {
        if (!(0, _lodash.isEmpty)(res.data)) {
          var _res$data3 = res.data,
              donViCha = _res$data3.donViCha,
              donVis = _res$data3.donVis;

          var listDataDonVi = [].concat(_toConsumableArray(donVis));
          var newDataOption = [];
          listDataDonVi.forEach(function (item) {
            if (item.donVi.tenDonVi === "Đơn chưa chuyển phòng ban") {
              // Do notthing
            } else {
              newDataOption.push({
                giaTri: (0, _lodash.get)(item, 'donVi.id') || '',
                ten: (0, _lodash.get)(item, 'donVi.tenDonVi') || ''
              });
            }
          });
          if (!(0, _lodash.isEmpty)(donViCha)) {
            donVis.unshift(_extends({}, donViCha, {
              isDonViCha: true
            }));
          }
          _this4.setDataFilterCoQuanQuanLy(newDataOption, 'theoKy');
          _this4.setState({
            dataListTheoKy: donVis,
            acceptDataLoadTheoKy: false,
            isSearchDonViTheoKy: (0, _lodash.isEmpty)(donViCha),
            sumTheoKy: {
              tongDon: res.data.tongDon || 0,
              tongDonDaXLGQ: res.data.tongDonDaXLGQ || 0,
              tongDonDangXLGQ: res.data.tongDonDangXLGQ || 0,
              tongDonKyTruoc: res.data.tongDonKyTruoc || 0,
              tongDonTrongKy: res.data.tongDonTrongKy || 0
            }
          });
        }
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this4.setState({
          tableTheoKyLoading: false
        });
      });
    }
  }, {
    key: 'getPhanHe',
    value: function getPhanHe() {
      var _this5 = this;

      _api.TheoDoiGiamSat.actions.getPhanHe.request('').then(function (res) {
        if (res.data) {
          _this5.setState({
            dataPhanHe: res.data
          });
        }
      });
    }
  }, {
    key: 'getLoaiDonThu',
    value: function getLoaiDonThu() {
      var _this6 = this;

      _api.TheoDoiGiamSat.actions.getLoaiDonThu.request('').then(function (res) {
        if (res.data) {
          var listData = res.data.filter(function (item) {
            return item.giaTri !== "DON_TO_CAO";
          });
          _this6.setState({
            dataLoaiDonThu: listData
          });
        }
      });
    }
  }, {
    key: 'getTypeTimKiem',
    value: function getTypeTimKiem() {
      var _this7 = this;

      _api.TheoDoiGiamSat.actions.getTypeTimKiem.request('').then(function (res) {
        if (res.data) {
          _this7.setState({
            dataTimKiem: res.data
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'timKiemTheo') {
        this.resetParams();
      }
      if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
        this.setState(_defineProperty({}, name, name === 'coQuanQuanLyFilter' ? e : e.target.value));
      } else {
        this.setState({
          filterTheoKy: _extends({}, this.state.filterTheoKy, _defineProperty({}, name, name === 'coQuanQuanLyFilter' ? e : e.target.value))
        });
      }
    }
  }, {
    key: 'resetParams',
    value: function resetParams() {
      localStorage.removeItem('tdgstk');
      this.setState({
        tiepNhanTuNgay: '',
        tiepNhanDenNgay: '',
        year: '',
        month: '',
        phanHe: 'XU_LY_DON',
        loaiDonThu: 'DON_KHIEU_NAI',
        filterTheoKy: _extends({}, this.state.filterTheoKy, {
          tiepNhanTuNgay: '',
          tiepNhanDenNgay: '',
          year: '',
          month: '',
          loaiDonThu: 'DON_KHIEU_NAI'
        })
      });
      localStorage.removeItem('tdgs.tiepNhanTuNgay');
      localStorage.removeItem('tdgs.tiepNhanDenNgay');
      localStorage.removeItem('tdgs.year');
      localStorage.removeItem('tdgs.month');
      localStorage.removeItem('tdgs.phanHe');
      localStorage.removeItem('tdgs.loaiDonThu');
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      var _this8 = this;

      e.preventDefault();
      if (this.validateSubmitForm()) {
        this.setState({
          search: true
        }, function () {
          if (_this8.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
            _this8.getListDaTa(_this8.props.id);
          } else {
            _this8.getDataTheoKy();
          }
        });
      }
      return;
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
          this.setState(_defineProperty({}, name, e._d));
        } else {
          this.setState({
            filterTheoKy: _extends({}, this.state.filterTheoKy, _defineProperty({}, name, e._d))
          });
        }
      } else {
        if (this.state.theoDoiDonDoc === 'TDDD_XLD_GQD') {
          this.setState(_defineProperty({}, name, e));
        } else {
          this.setState({
            filterTheoKy: _extends({}, this.state.filterTheoKy, _defineProperty({}, name, e))
          });
        }
      }
    }
  }, {
    key: 'handleExportExcel',
    value: function handleExportExcel() {
      this.setState({
        loadingExport: true
      });
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.state.theoDoiDonDoc === 'TDDD_KY') {
        try {
          var URL = String(_config.API_URL) + "/theoDoiGiamSatTheoKys/tinhHinhXuLyDonTaiCacDonVi/xuatExcel?" + "phanLoaiDon=" + this.state.filterTheoKy.loaiDonThu;

          if (this.state.filterTheoKy.selectedTheoKy) {
            URL = URL + "&ky=" + this.state.filterTheoKy.selectedTheoKy;
          }
          if (!(0, _lodash.isEmpty)(this.state.filterTheoKy.nguonDon)) {
            URL = URL + "&nguonDon=" + this.state.filterTheoKy.nguonDon;
          }
          if (this.state.filterTheoKy.timKiemTheo === 'day') {
            if ((0, _lodash.get)(this.state.filterTheoKy, 'tiepNhanTuNgay')) {
              URL = URL + "&tuNgay=" + (0, _moment2.default)(this.state.filterTheoKy.tiepNhanTuNgay).add(7, 'hours').toISOString();
            }
            if ((0, _lodash.get)(this.state.filterTheoKy, 'tiepNhanDenNgay')) {
              URL = URL + "&denNgay=" + (0, _moment2.default)(this.state.filterTheoKy.tiepNhanDenNgay).add(7, 'hours').toISOString();
            }
          }
          if (this.state.filterTheoKy.timKiemTheo === 'month') {
            URL = URL + "&month=" + this.state.filterTheoKy.month;
            URL = URL + "&year=" + this.state.filterTheoKy.year;
          }
          if (this.state.filterTheoKy.timKiemTheo === 'year') {
            URL = URL + "&year=" + this.state.filterTheoKy.year;
          }
          if (!(0, _lodash.isEmpty)(this.state.filterTheoKy.coQuanQuanLyFilter)) {
            var ids2 = [];
            this.state.filterTheoKy.coQuanQuanLyFilter.map(function (item) {
              ids2.push(item.value);
            });
            URL = URL + "&listCoQuanQuanLys=" + ids2.join();
          }
          (0, _downloadFile.downloadFile)(URL);
          return;
        } catch (error) {} finally {
          setTimeout(function () {
            this.setState({
              loadingExport: false
            });
          }.bind(this), 3000);
        }
      }
      if (this.props.id) {
        try {
          var _URL = String(_config.API_URL) + "/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonViCon/xuatExcel?" + "month=" + this.state.month + "&year=" + this.state.year + "&donViId=" + this.props.id + "&phanLoaiDon=" + this.state.loaiDonThu + "&quyTrinh=" + this.state.phanHe;

          if (this.state.tiepNhanTuNgay) {
            _URL = _URL + "&tuNgay=" + (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
          }
          if (this.state.tiepNhanDenNgay) {
            _URL = _URL + "&denNgay=" + (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
          }
          (0, _downloadFile.downloadFile)(_URL);
          return;
        } catch (error) {} finally {
          setTimeout(function () {
            this.setState({
              loadingExport: false
            });
          }.bind(this), 3000);
        }
      } else {
        try {
          var _URL2 = String(_config.API_URL) + "/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonVi/xuatExcel?" + "month=" + this.state.month + "&year=" + this.state.year + "&quyTrinh=" + this.state.phanHe + "&phanLoaiDon=" + this.state.loaiDonThu + "&capCoQuanQuanLyId=" + userInfo.capCoQuanQuanLyId + "&coQuanQuanLyId=" + userInfo.coQuanQuanLyId + "&donViId=" + userInfo.donViId;

          if (!(0, _lodash.isEmpty)(this.state.coQuanQuanLyFilter)) {
            var _ids = [];
            this.state.coQuanQuanLyFilter.map(function (item) {
              _ids.push(item.value);
            });
            _URL2 = _URL2 + "&listCoQuanQuanLys=" + _ids.join();
          }
          if (this.state.nguonDon) {
            _URL2 = _URL2 + "&nguonDon=" + this.state.nguonDon;
          }
          if (this.state.tiepNhanTuNgay) {
            _URL2 = _URL2 + "&tuNgay=" + (0, _moment2.default)(this.state.tiepNhanTuNgay).add(7, 'hours').toISOString();
          }
          if (this.state.tiepNhanDenNgay) {
            _URL2 = _URL2 + "&denNgay=" + (0, _moment2.default)(this.state.tiepNhanDenNgay).add(7, 'hours').toISOString();
          }
          (0, _downloadFile.downloadFile)(_URL2);
          return;
        } catch (error) {} finally {
          setTimeout(function () {
            this.setState({
              loadingExport: false
            });
          }.bind(this), 3000);
        }
      }
    }
  }, {
    key: 'onChangeSelectedRadio',
    value: function onChangeSelectedRadio(e) {
      var value = e.target.value;

      this.setState({
        theoDoiDonDoc: value
      });
      localStorage.setItem('tdgs.theoDoiDonDoc', value);
    }
  }, {
    key: 'getStateTheoDoiDonDoc',
    value: function getStateTheoDoiDonDoc(name) {
      var state = this.state;
      if (this.state.theoDoiDonDoc === 'TDDD_KY') {
        state = this.state.filterTheoKy;
      }
      return state[name];
    }
  }, {
    key: 'render',
    value: function render() {
      var dataSelectTheoKy = [{
        ten: "Tất cả",
        giaTri: ''
      }, {
        ten: "Trong kỳ",
        giaTri: 'TRONGKY'
      }, {
        ten: "Kỳ trước chuyển sang",
        giaTri: 'KYTRUOC'
      }];
      var data = [{
        ten: 'THEO DÕI ĐÔN ĐỐC THEO XLĐ, GQĐ',
        giaTri: 'TDDD_XLD_GQD'
      }, {
        ten: 'THEO DÕI ĐÔN ĐỐC THEO KỲ',
        giaTri: 'TDDD_KY'
      }];
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        this.props.id ? _react2.default.createElement(
          'div',
          { className: 'back-foward mb0' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: _reactRouter.browserHistory.goBack, title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(_common.RadioButton, {
              options: data,
              selectedValue: this.state.theoDoiDonDoc,
              keyName: 'giaTri',
              valueName: 'ten',
              onChange: this.onChangeSelectedRadio.bind(this) })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'form',
            { className: (0, _classnames2.default)('wrap-block pl15 pr15 pt20', { 'wrap-block-xldtdv': this.getStateTheoDoiDonDoc('timKiemTheo') !== 'year' }), onSubmit: this.handleSearch.bind(this) },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-60' },
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-4', placeholder: null, label: 'T\xECm ki\u1EBFm theo', data: this.state.dataTimKiem, keyName: 'giaTri', valueName: 'ten', selectedValue: this.getStateTheoDoiDonDoc('timKiemTheo'), onChange: this.onChange.bind(this, 'timKiemTheo') }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.getStateTheoDoiDonDoc('timKiemTheo') == 'day' },
                    _react2.default.createElement(_common.DatePicker, { require: true, className: 'col-4', label: 'T\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.getStateTheoDoiDonDoc('tiepNhanDenNgay'), onChange: this.handleChangeDate.bind(this, 'tiepNhanTuNgay'), value: this.getStateTheoDoiDonDoc('tiepNhanTuNgay') }),
                    _react2.default.createElement(_common.DatePicker, { require: true, className: 'col-4', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.getStateTheoDoiDonDoc('tiepNhanTuNgay'), onChange: this.handleChangeDate.bind(this, 'tiepNhanDenNgay'), value: this.getStateTheoDoiDonDoc('tiepNhanDenNgay') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.getStateTheoDoiDonDoc('timKiemTheo') == 'month' },
                    _react2.default.createElement(_ttForms.DropDownChonLoaiThangThongKe, { require: true, bindValidator: this, className: 'col-4', onChange: this.onChange.bind(this, 'month'), selectedValue: this.getStateTheoDoiDonDoc('month') }),
                    _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { require: true, bindValidator: this, className: 'col-4', onChange: this.onChange.bind(this, 'year'), selectedValue: this.getStateTheoDoiDonDoc('year') })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.getStateTheoDoiDonDoc('timKiemTheo') == 'year' },
                    _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { require: true, bindValidator: this, className: 'col-4', onChange: this.onChange.bind(this, 'year'), selectedValue: this.getStateTheoDoiDonDoc('year') })
                  ),
                  this.state.theoDoiDonDoc === "TDDD_XLD_GQD" && _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-4', placeholder: null, label: 'Ph\xE2n h\u1EC7', data: this.state.dataPhanHe, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.phanHe, onChange: this.onChange.bind(this, 'phanHe') }),
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-4', placeholder: null, label: 'Lo\u1EA1i \u0111\u01A1n th\u01B0', data: this.state.dataLoaiDonThu, keyName: 'giaTri', valueName: 'ten', selectedValue: this.getStateTheoDoiDonDoc('loaiDonThu'), onChange: this.onChange.bind(this, 'loaiDonThu') }),
                  this.state.theoDoiDonDoc !== "TDDD_XLD_GQD" && _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-4', placeholder: null, label: 'K\u1EF3 b\xE1o c\xE1o', data: dataSelectTheoKy, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.filterTheoKy.selectedTheoKy, onChange: this.onChange.bind(this, 'selectedTheoKy') }),
                  _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-4', label: 'Ngu\u1ED3n \u0111\u01A1n', data: this.state.listNguonDon, keyName: 'giaTri', valueName: 'ten', selectedValue: this.getStateTheoDoiDonDoc('nguonDon'), onChange: this.onChange.bind(this, 'nguonDon') }),
                  !this.props.id && _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'col-8', label: '\u0110\u01A1n v\u1ECB', dataOptions: this.state.theoDoiDonDoc === 'TDDD_XLD_GQD' ? this.state.coQuanQuanLyList : this.state.listCoQuanQuanLyTheoKy, dataSelected: this.getStateTheoDoiDonDoc('coQuanQuanLyFilter'), onChange: this.onChange.bind(this, 'coQuanQuanLyFilter'), propertyParent: 'giaTri' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-40' },
                  _react2.default.createElement(
                    'div',
                    { className: 'rows' },
                    _react2.default.createElement(
                      'div',
                      { className: 'search-thanh-tra col-6' },
                      _react2.default.createElement(
                        'button',
                        {
                          className: this.state.searchLoading ? this.state.search ? 'btn-loading-inline btn-disable btn-green' : 'btn-disable btn-green' : 'btn-green',
                          type: 'submit',
                          disabled: this.state.searchLoading ? 'disabled' : ''
                        },
                        _react2.default.createElement('i', { className: 'tt-search' }),
                        'Xem k\u1EBFt qu\u1EA3'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-6 search-thanh-tra' },
                      _react2.default.createElement(
                        _reactRouter.Link,
                        {
                          className: (0, _classnames2.default)('btn-green tt-export', { 'btn-loading-inline': this.state.loadingExport }),
                          onClick: this.handleExportExcel.bind(this)
                        },
                        'Xu\u1EA5t danh s\xE1ch'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('span', { className: 'line-border' })
            )
          ),
          this.state.theoDoiDonDoc === 'TDDD_XLD_GQD' ? _react2.default.createElement(
            _datatable.DataTable,
            _extends({ hiddenSum: true, header: _table.header.theoDoi.tinhHinhXLDDonVi, numberColumnHeader: 7, theoDoiGiamSat: true, dataList: this.state.data, hidePagination: true, hideButtonExport: true, pageData: this.state.pageData, parent: this, search: this.state.search,
              tableLoading: this.state.tableLoading }, this.state.sum),
            _react2.default.createElement(_datatable.RowItemTinhHinhXuLyDonTaiDonVi, { isSearchDonVi: this.state.isSearchDonVi })
          ) : _react2.default.createElement(
            _datatable.DataTable,
            _extends({
              hiddenSum: true,
              header: _table.header.theoDoi.theoDoiDonDocTheoKy,
              numberColumnHeader: 7,
              theoDoiGiamSat: true,
              dataList: this.state.dataListTheoKy,
              hidePagination: true,
              hideButtonExport: true,
              theoDoiDonDocTheoKy: true,
              pageData: this.state.pageData,
              parent: this,
              search: this.state.search,
              tableLoading: this.state.tableTheoKyLoading
            }, this.state.sumTheoKy),
            _react2.default.createElement(_datatable.RowItemTheoDoiDonDocTheoKy, { isSearchDonVi: this.state.isSearchDonViTheoKy })
          )
        )
      );
    }
  }]);

  return TinhHinhXuLyDonTaiDonVi;
}(_react2.default.Component);

TinhHinhXuLyDonTaiDonVi.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = TinhHinhXuLyDonTaiDonVi;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTable = function (_React$Component) {
  _inherits(DataTable, _React$Component);

  function DataTable() {
    _classCallCheck(this, DataTable);

    return _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).apply(this, arguments));
  }

  _createClass(DataTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pageNumber = this.props.pageData ? this.props.pageData.number : 0;
      var pageSize = this.props.pageData ? this.props.pageData.size : 0;
      var dataListItem = this.props.dataList.map(function (item, i) {
        return _react2.default.cloneElement(_this2.props.children, {
          key: i,
          count: pageNumber * pageSize + i + 1,
          item: item,
          parent: _this2.props.parent
        });
      });

      var ItemLoading = _react2.default.createElement(
        'div',
        { className: 'loading-content' },
        _react2.default.createElement('span', { className: 'shape1' }),
        _react2.default.createElement('span', { className: 'shape2' }),
        _react2.default.createElement('span', { className: 'shape3' }),
        _react2.default.createElement('span', { className: 'shape4' }),
        _react2.default.createElement('span', { className: 'shape5' }),
        _react2.default.createElement('span', { className: 'shape6' }),
        _react2.default.createElement('span', { className: 'shape7' }),
        _react2.default.createElement('span', { className: 'shape8' }),
        _react2.default.createElement('span', { className: 'shape9' }),
        _react2.default.createElement('span', { className: 'shape10' }),
        _react2.default.createElement('span', { className: 'shape11' }),
        _react2.default.createElement('span', { className: 'shape12' }),
        _react2.default.createElement('span', { className: 'shape13' })
      );
      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table wrap-table wrap-theo-doi' },
        _react2.default.createElement(
          'div',
          { className: 'table-container' },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              'thead',
              { className: 'table-header' },
              this.props.header.map(function (headerItems, i) {
                var items = [];
                items = [].concat(_toConsumableArray(headerItems));
                return _react2.default.createElement(
                  'tr',
                  { key: i },
                  items.map(function (item, j) {
                    return _react2.default.createElement(
                      'th',
                      { key: j, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, rowSpan: item.rowSpan, style: { maxWidth: item.maxWidth, width: item.width, minWidth: item.minWidth } },
                      item.name
                    );
                  })
                );
              })
            ),
            this.props.tableLoading ? _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              _react2.default.createElement(
                'tr',
                { className: 'table-loading' },
                _react2.default.createElement(
                  'td',
                  { colSpan: this.props.numberColumnHeader },
                  ItemLoading,
                  ItemLoading,
                  ItemLoading
                )
              )
            ) : _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              dataListItem,
              !this.props.dataList.length && !this.props.showAddMore ? this.props.search ? _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: this.props.numberColumnHeader },
                  'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
                )
              ) : _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: this.props.numberColumnHeader },
                  'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                )
              ) : null,
              this.props.dataList.length > 0 && !this.props.hiddenSum ? _react2.default.createElement(
                'tr',
                { className: 'bottom-value' },
                _react2.default.createElement(
                  'td',
                  { colSpan: 2, className: 'txt-left' },
                  _react2.default.createElement(
                    'span',
                    { className: 'title-12' },
                    'T\u1ED5ng \u0111\u01A1n'
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'txt-center black-val' },
                  this.props.theoDoiDonDocTheoKy ? this.props.tongDonTrongKy : this.props.tongDonDungHanDangXL
                ),
                _react2.default.createElement(
                  'td',
                  {
                    className: (0, _classnames2.default)('txt-center', {
                      "red-val": !this.props.theoDoiDonDocTheoKy,
                      "black-val": this.props.theoDoiDonDocTheoKy
                    })
                  },
                  this.props.theoDoiDonDocTheoKy ? this.props.tongDonKyTruoc : this.props.tongDonTreHanDangXL
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'txt-center black-val' },
                  this.props.theoDoiDonDocTheoKy ? this.props.tongDon : this.props.tongDonDungHanDaXL
                ),
                _react2.default.createElement(
                  'td',
                  {
                    className: (0, _classnames2.default)('txt-center', {
                      "red-val": !this.props.theoDoiDonDocTheoKy,
                      "black-val": this.props.theoDoiDonDocTheoKy
                    })
                  },
                  this.props.theoDoiDonDocTheoKy ? this.props.tongDonDangXLGQ : this.props.tongDonTreHanDaXL
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'txt-center black-val' },
                  this.props.theoDoiDonDocTheoKy ? this.props.tongDonDaXLGQ : this.props.tongDonDangDaXL
                )
              ) : null
            )
          )
        ),
        this.props.ThongKeBaoCao ? _react2.default.createElement(
          'div',
          { className: 'pagination-wrap' },
          _react2.default.createElement(_core.Button, { className: this.state.export, text: this.props.exporttext, onClick: this.handleExport.bind(this) })
        ) : _react2.default.createElement('div', null)
      );
    }
  }]);

  return DataTable;
}(_react2.default.Component);

exports.default = DataTable;

DataTable.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: []
};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachDon = function (_React$Component) {
  _inherits(RowItemDanhSachDon, _React$Component);

  function RowItemDanhSachDon(props, context) {
    _classCallCheck(this, RowItemDanhSachDon);

    var _this = _possibleConstructorReturn(this, (RowItemDanhSachDon.__proto__ || Object.getPrototypeOf(RowItemDanhSachDon)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: ''
    };
    return _this;
  }

  _createClass(RowItemDanhSachDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.item.trangThaiDonInfo) {
        var donViDangXLGQId = this.props.item.donViXuLyGiaiQuyetInfo ? this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId : '';
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == donViDangXLGQId;
        }).map(function (child, i) {
          if (_this2.props.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Đình chỉ',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else if (!_this2.props.item.ma && child.ketQuaType == 'DINH_CHI') {
            _this2.setState({
              ketQuaStr: 'Rút đơn',
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          } else {
            _this2.setState({
              ketQuaStr: child.ketQuaStr,
              ketQuaType: child.ketQuaType,
              trangThaiDonText: child.trangThaiDonText,
              trangThaiDonType: child.trangThaiDonType
            });
          }
        });
      }
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;
      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this3 = this;

      var ketQuaType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var thoiHanXuLy = {};
      var donViDangXLGQId = this.props.item.donViXuLyGiaiQuyetInfo ? this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId : '';
      if (this.checkDonViTTXM() && this.state.ketQuaType === 'DANG_LAP_DU_THAO') {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      } else if (ketQuaType != null && ketQuaType === 'DANG_TTXM') {
        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == donViDangXLGQId) {

          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == donViDangXLGQId;
          }).map(function (child, i) {

            if (child.trangThaiDonType === 'DANG_XU_LY') thoiHanXuLy = _this3.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType === 'DANG_GIAI_QUYET') thoiHanXuLy = _this3.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type === 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type === 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showThoiHanLapDuThao',
    value: function showThoiHanLapDuThao() {
      var thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      if (data) {
        if (data.diaChi) {
          address.push(data.diaChi);
        }
        if (data.toThon) {
          address.push(data.toThon);
        }
        if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
          address.push(data.phuongXaCongDan.ten);
        }
        if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
          address.push(data.quanHuyenCongDan.ten);
        }
        if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
          address.push(data.tinhThanhCongDan.ten);
        }
      }
      return address.join(", ");
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';

      var loaiDonThu = this.props.dataLoaiDonThu.filter(function (state) {
        return state.giaTri == _this4.props.item.loaiDon;
      });
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.maHoSo ? this.props.item.maHoSo : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_dialog.ChiTietDonDialog, { checkTDGS: true, item: this.props.item, trangThaiDonText: this.state.trangThaiDonText, hanGiaiQuyet: this.showThoiHanXuLyDon() })
            ),
            _react2.default.createElement(
              'li',
              { className: 'list-items-table' },
              this.showThoiHanXuLyDon()
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.get)(this.props.item, 'donViXuLyGiaiQuyetInfo.ten', '')
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachDon;
}(_react2.default.Component);

RowItemDanhSachDon.defaultProps = {
  dataLoaiDonThu: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemDanhSachDon);

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _lodash = __webpack_require__(14);

var _reactRouter = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachThongKeGiamSatDonCu = function (_Component) {
  _inherits(RowItemDanhSachThongKeGiamSatDonCu, _Component);

  function RowItemDanhSachThongKeGiamSatDonCu() {
    _classCallCheck(this, RowItemDanhSachThongKeGiamSatDonCu);

    return _possibleConstructorReturn(this, (RowItemDanhSachThongKeGiamSatDonCu.__proto__ || Object.getPrototypeOf(RowItemDanhSachThongKeGiamSatDonCu)).apply(this, arguments));
  }

  _createClass(RowItemDanhSachThongKeGiamSatDonCu, [{
    key: 'getLocal',
    value: function getLocal(data) {
      var address = [];
      var checkAddressData = function checkAddressData(addressData) {
        if (!(0, _lodash.isEmpty)(addressData)) {
          address.push(addressData);
        }
      };
      checkAddressData((0, _lodash.get)(data, 'diaChi'));
      checkAddressData((0, _lodash.get)(data, 'toThon'));
      checkAddressData((0, _lodash.get)(data, 'phuongXaCongDan.ten'));
      checkAddressData((0, _lodash.get)(data, 'quanHuyenCongDan.ten'));
      checkAddressData((0, _lodash.get)(data, 'tinhThanhCongDan.ten'));
      return address.join(", ");
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = '';
      var listNguoiDungDon = this.props.item.listNguoiDungDon;

      if (!(0, _lodash.isEmpty)(listNguoiDungDon)) {
        size = listNguoiDungDon.length;
      }
      if (!size) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'li',
          { className: 'txt-bold' },
          (0, _lodash.get)(listNguoiDungDon, '[0].hoVaTen')
        ),
        _react2.default.createElement(
          'li',
          null,
          this.getLocal((0, _lodash.get)(listNguoiDungDon, '[0]'))
        ),
        _react2.default.createElement(
          'li',
          null,
          (0, _lodash.get)(listNguoiDungDon, '[0].soDienThoai')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          nguonDonInfo = _props$item.nguonDonInfo,
          soNguoi = _props$item.soNguoi,
          loaiDonInfo = _props$item.loaiDonInfo,
          noiDung = _props$item.noiDung,
          donCuId = _props$item.donCuId;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            this.showThongTinCongDan()
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: '/chi-tiet-don-cu/' + donCuId },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: noiDung
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(loaiDonInfo, 'ten')
            ),
            _react2.default.createElement(
              'li',
              null,
              soNguoi + ' ng\u01B0\u1EDDi'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(nguonDonInfo, 'ten')
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachThongKeGiamSatDonCu;
}(_react.Component);

exports.default = RowItemDanhSachThongKeGiamSatDonCu;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTheoDoiDonDocTheoKy = function (_Component) {
  _inherits(RowItemTheoDoiDonDocTheoKy, _Component);

  function RowItemTheoDoiDonDocTheoKy() {
    _classCallCheck(this, RowItemTheoDoiDonDocTheoKy);

    return _possibleConstructorReturn(this, (RowItemTheoDoiDonDocTheoKy.__proto__ || Object.getPrototypeOf(RowItemTheoDoiDonDocTheoKy)).apply(this, arguments));
  }

  _createClass(RowItemTheoDoiDonDocTheoKy, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var paramsDonViChuaChuyenPhongBan = function paramsDonViChuaChuyenPhongBan() {
        if (_this2.props.item.donVi.tenDonVi === 'Đơn chưa chuyển phòng ban') {
          return '&isPhongBanChuaChuyenDon=true';
        }
        return '';
      };
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('', {
                'ml20': !this.props.item.isDonViCha,
                'ml40': (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 2 && !this.props.isSearchDonVi || (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 1 && this.props.isSearchDonVi,
                'ml60': (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 2 && this.props.isSearchDonVi
              }) },
            this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.trongKy > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=' + (0, _lodash.get)(this.props.item, 'donVi.id') + '&ky=TRONGKY' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.trongKy || 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.trongKy || 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.kyTruoc > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=' + (0, _lodash.get)(this.props.item, 'donVi.id') + '&ky=KYTRUOC' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.kyTruoc || 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.kyTruoc || 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.tongSo || 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.dangXuLy && this.props.item.dangXuLy.tong > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=' + (0, _lodash.get)(this.props.item, 'donVi.id') + '&trangThaiDon=DANG_XU_LY&trangThaiDon=DANG_GIAI_QUYET' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.dangXuLy && this.props.item.dangXuLy.tong || 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.dangXuLy && this.props.item.dangXuLy.tong || 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.daXuLy && this.props.item.daXuLy.tong > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don-theo-ky?donViId=' + (0, _lodash.get)(this.props.item, 'donVi.id') + '&trangThaiDon=DA_XU_LY&trangThaiDon=DA_GIAI_QUYET' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.daXuLy && this.props.item.daXuLy.tong || 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.daXuLy && this.props.item.daXuLy.tong || 0
          )
        )
      );
    }
  }]);

  return RowItemTheoDoiDonDocTheoKy;
}(_react.Component);

exports.default = RowItemTheoDoiDonDocTheoKy;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemThongKeGiamSatNhapDonCu = function (_Component) {
  _inherits(RowItemThongKeGiamSatNhapDonCu, _Component);

  function RowItemThongKeGiamSatNhapDonCu() {
    _classCallCheck(this, RowItemThongKeGiamSatNhapDonCu);

    return _possibleConstructorReturn(this, (RowItemThongKeGiamSatNhapDonCu.__proto__ || Object.getPrototypeOf(RowItemThongKeGiamSatNhapDonCu)).apply(this, arguments));
  }

  _createClass(RowItemThongKeGiamSatNhapDonCu, [{
    key: 'getLinkRedirect',
    value: function getLinkRedirect(type) {
      var donVi = this.props.item.donVi;
      var _props = this.props,
          phanLoaiDon = _props.phanLoaiDon,
          nguonDon = _props.nguonDon;

      var result = '/theo-doi-giam-sat/danh-sach-thong-ke-giam-sat-don-cu/' + (0, _lodash.get)(donVi, 'id') + '/' + (0, _lodash.get)(this.props.item, 'donVi.tenDonVi') + '/' + type;
      if (!(0, _lodash.isEmpty)(phanLoaiDon) && !(0, _lodash.isEmpty)(nguonDon)) {
        result = result + ('?phanLoaiDon=' + phanLoaiDon + '&nguonDon=' + nguonDon);
      } else if (!(0, _lodash.isEmpty)(phanLoaiDon) && (0, _lodash.isEmpty)(nguonDon)) {
        result = result + ('?phanLoaiDon=' + phanLoaiDon);
      } else if ((0, _lodash.isEmpty)(phanLoaiDon) && !(0, _lodash.isEmpty)(nguonDon)) {
        result = result + ('?nguonDon=' + nguonDon);
      } else {
        return result;
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          soDonDonGian = _props$item.soDonDonGian,
          soDonPhucTap = _props$item.soDonPhucTap,
          soDon = _props$item.soDon;

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          this.props.item && this.props.item.coDonViCon === true ? _react2.default.createElement(
            _reactRouter.Link,
            { to: '/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu/' + this.props.item.donVi.id },
            this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''
          ) : _react2.default.createElement(
            'span',
            null,
            this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          soDonDonGian > 0 ? _react2.default.createElement(
            _reactRouter.Link,
            { to: this.getLinkRedirect('DON_GIAN') },
            soDonDonGian
          ) : soDonDonGian
        ),
        _react2.default.createElement(
          'td',
          null,
          soDonPhucTap > 0 ? _react2.default.createElement(
            _reactRouter.Link,
            { to: this.getLinkRedirect('PHUC_TAP') },
            soDonPhucTap
          ) : soDonPhucTap
        ),
        _react2.default.createElement(
          'td',
          null,
          soDon
        )
      );
    }
  }]);

  return RowItemThongKeGiamSatNhapDonCu;
}(_react.Component);

exports.default = RowItemThongKeGiamSatNhapDonCu;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTinhHinhXuLyDonTaiDonVi = function (_React$Component) {
  _inherits(RowItemTinhHinhXuLyDonTaiDonVi, _React$Component);

  function RowItemTinhHinhXuLyDonTaiDonVi() {
    _classCallCheck(this, RowItemTinhHinhXuLyDonTaiDonVi);

    return _possibleConstructorReturn(this, (RowItemTinhHinhXuLyDonTaiDonVi.__proto__ || Object.getPrototypeOf(RowItemTinhHinhXuLyDonTaiDonVi)).apply(this, arguments));
  }

  _createClass(RowItemTinhHinhXuLyDonTaiDonVi, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var paramsDonViChuaChuyenPhongBan = function paramsDonViChuaChuyenPhongBan() {
        if (_this2.props.item.donVi.tenDonVi === 'Đơn chưa chuyển phòng ban') {
          return '&isPhongBanChuaChuyenDon=true';
        }
        return '';
      };
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('', {
                'ml20': !this.props.item.isDonViCha,
                'ml40': (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 2 && !this.props.isSearchDonVi || (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 1 && this.props.isSearchDonVi,
                'ml60': (0, _lodash.get)(this.props.item, 'donVi.capHienThi') === 2 && this.props.isSearchDonVi
              }) },
            this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.dangXuLy && this.props.item.dangXuLy.dungHan > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don/' + this.props.item.donVi.id + '?trangThaiDon=' + (localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DANG_GIAI_QUYET' : 'DANG_XU_LY') + '&tinhTrangXuLy=DUNG_HAN' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.dangXuLy ? this.props.item.dangXuLy.dungHan : 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.dangXuLy ? this.props.item.dangXuLy.dungHan : 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.dangXuLy && this.props.item.dangXuLy.treHan > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'red-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don/' + this.props.item.donVi.id + '?trangThaiDon=' + (localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DANG_GIAI_QUYET' : 'DANG_XU_LY') + '&tinhTrangXuLy=TRE_HAN' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.dangXuLy ? this.props.item.dangXuLy.treHan : 0
          ) : _react2.default.createElement(
            'span',
            { className: 'red-val' },
            this.props.item.dangXuLy ? this.props.item.dangXuLy.treHan : 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.daXuLy && this.props.item.daXuLy.dungHan > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'black-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don/' + this.props.item.donVi.id + '?trangThaiDon=' + (localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DA_GIAI_QUYET' : 'DA_XU_LY') + '&tinhTrangXuLy=DUNG_HAN' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.daXuLy ? this.props.item.daXuLy.dungHan : 0
          ) : _react2.default.createElement(
            'span',
            { className: 'black-val' },
            this.props.item.daXuLy ? this.props.item.daXuLy.dungHan : 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          this.props.item.daXuLy && this.props.item.daXuLy.treHan > 0 && !this.props.item.isDonViCha ? _react2.default.createElement(
            _reactRouter.Link,
            { className: 'red-val txt-underline', to: '/theo-doi-giam-sat/danh-sach-don/' + this.props.item.donVi.id + '?trangThaiDon=' + (localStorage.getItem('tdgs.phanHe') != 'XU_LY_DON' ? 'DA_GIAI_QUYET' : 'DA_XU_LY') + '&tinhTrangXuLy=TRE_HAN' + paramsDonViChuaChuyenPhongBan() },
            this.props.item.daXuLy ? this.props.item.daXuLy.treHan : 0
          ) : _react2.default.createElement(
            'span',
            { className: 'red-val' },
            this.props.item.daXuLy ? this.props.item.daXuLy.treHan : 0
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center black-val txt-bold' },
          this.props.item.tongSo ? this.props.item.tongSo : 0
        )
      );
    }
  }]);

  return RowItemTinhHinhXuLyDonTaiDonVi;
}(_react2.default.Component);

exports.default = RowItemTinhHinhXuLyDonTaiDonVi;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(495);

var _subView = __webpack_require__(197);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachTheoDoiThucHien = function (_React$Component) {
  _inherits(DanhSachTheoDoiThucHien, _React$Component);

  function DanhSachTheoDoiThucHien(props, context) {
    _classCallCheck(this, DanhSachTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (DanhSachTheoDoiThucHien.__proto__ || Object.getPrototypeOf(DanhSachTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      search: false
    };
    return _this;
  }

  _createClass(DanhSachTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDataList();
    }
  }, {
    key: 'getDataList',
    value: function getDataList() {
      var _this2 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };

      if (this.state.tenDoiTuongThanhTra) {
        params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
      }

      if (this.state.soQuyetDinh) {
        params.soQuyetDinh = this.state.soQuyetDinh;
      }

      if (this.state.linhVucThanhTra) {
        params.linhVucThanhTra = this.state.linhVucThanhTra;
      }

      if (this.state.tuNgay) {
        params.tuNgay = (0, _moment2.default)(this.state.tuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.denNgay) {
        params.denNgay = (0, _moment2.default)(this.state.denNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      _api.ThanhTra.actions.getCuocThanhTraTheoDoi.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded.cuocThanhTras,
            pageData: res.data.page,
            tableLoading: false,
            search: false
          });
        } else {
          _this2.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getDataList();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getDataList();
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.setState({
        advanceSearch: true
      });
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.setState({
        advanceSearch: false
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(data) {
      if (this.validateSubmitForm()) {
        this.state = _extends({}, this.state, data, {
          search: true
        });
        this.setState(_extends({}, this.state));
        this.getDataList();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              'p',
              { className: 'title-18' },
              _react2.default.createElement('i', { className: 'tt tt-theo-doi' }),
              'Danh s\xE1ch theo d\xF5i th\u1EF1c hi\u1EC7n sau thanh tra/ki\u1EC3m tra'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content thanh-tra-search' },
          _react2.default.createElement(
            'div',
            { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
            _react2.default.createElement(_subView.Search, { ref: 'listSearch', advanceSearch: this.state.advanceSearch, bindValidator: this, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search }),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
              _react2.default.createElement('i', { className: 'tt tt-super-search' }),
              'T\xECm ki\u1EBFm n\xE2ng cao'
            )
          ),
          _react2.default.createElement(
            _dataTable2.default,
            { header: _table.header.theoDoiThucHien.danhSach, dataList: this.state.data, hideExport: true, pageData: this.state.pageData, parent: this, search: this.state.search,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhSachTheoDoiThucHien, null)
          )
        )
      );
    }
  }]);

  return DanhSachTheoDoiThucHien;
}(_react2.default.Component);

DanhSachTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  }
};

exports.default = DanhSachTheoDoiThucHien;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(197);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(52);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

var _toastr = __webpack_require__(11);

var _datatable2 = __webpack_require__(52);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaTheoDoiThucHien = function (_React$Component) {
  _inherits(KetQuaTheoDoiThucHien, _React$Component);

  function KetQuaTheoDoiThucHien(props, context) {
    _classCallCheck(this, KetQuaTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (KetQuaTheoDoiThucHien.__proto__ || Object.getPrototypeOf(KetQuaTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      data: [],
      dataDetail: [],
      id: _this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      type: _this.props.type,
      showDoiTuongThanhTra: false,
      showThongTinThanhTra: true,
      showThongTinTheoDoi: true,
      enableKetThuc: false,
      // value
      soVanBanChiDaoCuaCapTren: '',
      coQuanBanHanhChiDaoCuaCapTren: '',
      ghiChuVanBanChiDaoCuaCapTren: '',
      ngayBanHanhVanBanChiDaoCuaCapTren: '',

      soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: '',

      // list tai lieu

      listTaiLieuChiDaoCuaCapTren: [],
      listTaiLieuKetQuaThucHienKetLuanThanhTra: [],
      listTaiLieuXuLyCuocThanhTra: [],
      dataCanCuThanhTraLai: [],

      listTaiLieuVanThuThanhTra: [],
      listTaiLieuVanThuThanhTraView: [],
      chiTietDT: false
    };
    return _this;
  }

  _createClass(KetQuaTheoDoiThucHien, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetail(this.state.id);
      this.getDonViBanHanh();
      this.getDataCanCuThanhTraLai();
    }
  }, {
    key: 'getDataCanCuThanhTraLai',
    value: function getDataCanCuThanhTraLai() {
      var _this2 = this;

      _api.ThanhTra.actions.getCanCuThanhTraLai.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            dataCanCuThanhTraLai: res.data
          });
        }
      });
    }
  }, {
    key: 'getCanCuThanhTraLai',
    value: function getCanCuThanhTraLai(value) {
      if (this.state.dataCanCuThanhTraLai.length > 0) {
        return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(function (x) {
          return x.giaTri == value;
        })].ten;
      } else {
        return;
      }
    }
  }, {
    key: 'checkListDoiTuongViPham',
    value: function checkListDoiTuongViPham() {
      var Data = this.state.dataDetail;
      var listDoiTuongViPham = [];
      var doiTuongThanhTraLienQuan = [];
      var doiTuongThanhTras = [].concat(_toConsumableArray(Data.listDoiTuongThanhTra));
      var doiTuongThanhTra = Data.doiTuongThanhTraInfo;
      var data = Data.doiTuongThanhTraLienQuan.split('; ');
      if (data.length > 0) {
        data.map(function (state) {
          if (state) {
            doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
              ten: state
            };
          }
        });
      }
      if (doiTuongThanhTraLienQuan.length > 0) {
        doiTuongThanhTraLienQuan.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTras.length > 0) {
        doiTuongThanhTras.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTra) {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: doiTuongThanhTra.ten,
          giaTri: doiTuongThanhTra.ten
        };
      }
      this.setState({
        listDoiTuongViPham: listDoiTuongViPham
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.params.id,
        type: nextProps.type
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this3 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this3.setState({
            dataDetail: res.data,
            soVanBanChiDaoCuaCapTren: res.data.soVanBanChiDaoCuaCapTren ? res.data.soVanBanChiDaoCuaCapTren : '',
            coQuanBanHanhChiDaoCuaCapTren: res.data.coQuanBanHanhChiDaoCuaCapTren ? res.data.coQuanBanHanhChiDaoCuaCapTren : '',
            ghiChuVanBanChiDaoCuaCapTren: res.data.ghiChuVanBanChiDaoCuaCapTren ? res.data.ghiChuVanBanChiDaoCuaCapTren : '',
            ngayBanHanhVanBanChiDaoCuaCapTren: res.data.ngayBanHanhVanBanChiDaoCuaCapTren ? (0, _moment2.default)(res.data.ngayBanHanhVanBanChiDaoCuaCapTren).format('DD/MM/YYYY') : '',

            soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? (0, _moment2.default)(res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT).format('DD/MM/YYYY') : ''
          }, function () {
            _this3.checkListDoiTuongViPham();
          });
        }
      });
      this.getChiTietLienQuanCuocThanhTra(id);
    }
  }, {
    key: 'getChiTietLienQuanCuocThanhTra',
    value: function getChiTietLienQuanCuocThanhTra(id) {
      var _this4 = this;

      _api.ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          _this4.state.listTaiLieuChiDaoCuaCapTren = Data.listTaiLieuChiDaoCuaCapTren ? Data.listTaiLieuChiDaoCuaCapTren : [];
          _this4.state.listTaiLieuKetQuaThucHienKetLuanThanhTra = Data.listTaiLieuKetQuaThucHienKetLuanThanhTra ? Data.listTaiLieuKetQuaThucHienKetLuanThanhTra : [];
          _this4.state.listTaiLieuXuLyCuocThanhTra = Data.listTaiLieuXuLyCuocThanhTra ? Data.listTaiLieuXuLyCuocThanhTra : [];
          _this4.setState(_extends({}, _this4.state), function () {
            _this4.setState({
              showFile: true
            });
          });
        }
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getDonViBanHanh',
    value: function getDonViBanHanh() {
      var _this5 = this;

      _api.ThanhTra.actions.getListDonViBanHanh.request().then(function (res) {
        if (res.data) {
          _this5.setState({
            dataDonViBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse(name) {
      this.setState(_defineProperty({}, name, !this.state[name]));
    }
  }, {
    key: 'onClickClose',
    value: function onClickClose() {
      _reactRouter.browserHistory.goBack();
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        chiTietDT: true
      });
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({
        chiTietDT: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var Data = this.state.dataDetail;
      var DataDetail = this.state.dataDetail;

      var DoiTuongThanhTra = '';
      var tenDoiTuongThanhTraTKH = '';
      var CountDoiTuongThanhTra = 0;
      var CountDonViPhoiHop = 0;
      var CountDoiTuongThanhTraLienQuan = 0;
      if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra[0].ten;
      } else if (Data && Data.cuocThanhTraNhieuDoiTuong && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra.length + ' \u0111\u1ED1i t\u01B0\u1EE3ng';
      }
      if (Data.donViPhoiHop) {
        CountDonViPhoiHop = Data.donViPhoiHop.split('; ').length;
      }
      if (Data.doiTuongThanhTraLienQuan) {
        CountDoiTuongThanhTraLienQuan = Data.doiTuongThanhTraLienQuan.split('; ').length;
      }

      if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        Data.listDoiTuongThanhTra.map(function (state, index) {
          if (index == 0) {
            DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
          } else {
            DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
          }
        });
        CountDoiTuongThanhTra = Data.listDoiTuongThanhTra.length;
      }
      var data = [].concat(_toConsumableArray(this.state.dataDonViBanHanh));
      var dataFilter = data.filter(function (state) {
        return state.giaTri == Data.donViBanHanh;
      });
      var donViBanHanh = '';
      if (dataFilter.length > 0) {
        donViBanHanh = dataFilter[0].ten;
      }

      var dataVanBanChiDao = [].concat(_toConsumableArray(this.state.dataDonViBanHanh));
      var dataVanBanChiDaoFilter = dataVanBanChiDao.filter(function (state) {
        return state.giaTri == Data.coQuanBanHanhChiDaoCuaCapTren;
      });
      var donViBanHanhVanBanChiDao = '';
      if (dataVanBanChiDaoFilter.length > 0) {
        donViBanHanhVanBanChiDao = dataVanBanChiDaoFilter[0].ten;
      }

      var dataVanBanBaoCao = [].concat(_toConsumableArray(this.state.dataDonViBanHanh));
      var dataVanBanBaoCaoFilter = dataVanBanBaoCao.filter(function (state) {
        return state.giaTri == Data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra;
      });
      var donViBanHanhVanBanBaoCao = '';
      if (dataVanBanBaoCaoFilter.length > 0) {
        donViBanHanhVanBanBaoCao = dataVanBanBaoCaoFilter[0].ten;
      }
      var isKiemTra = (0, _lodash.get)(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
      var loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
      var keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.onClickClose.bind(this, 'close'), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading with-right-content' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-add' },
            'Th\xF4ng tin chi ti\u1EBFt theo d\xF5i th\u1EF1c hi\u1EC7n sau ',
            loaiCuocText
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: (0, _lodash.get)(DataDetail, 'tienDoThanhTra') == 'LUU_HO_SO' },
            _react2.default.createElement(
              'p',
              { className: 'heading-code', onClick: function onClick() {
                  navigator.clipboard.writeText((0, _lodash.get)(DataDetail, 'hoSoThanhTra.maHoSo') || '');
                  (0, _toastr.Toastr)('Copy mã hồ sơ thành công.', 'success');
                } },
              (0, _lodash.get)(DataDetail, 'hoSoThanhTra.maHoSo'),
              _react2.default.createElement('span', { className: 'tt-copy' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'h2',
            { className: 'collapse-title pl20 pr20 pt20 ' + (this.state.showThongTinThanhTra ? "collapse-open" : "collapse-close") },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showThongTinThanhTra') },
              '1. Th\xF4ng tin ',
              loaiCuocText
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pl20 pr20 pt20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: DataDetail.keHoachThanhTraInfo !== null },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.1. Th\xF4ng tin k\u1EBF ho\u1EA1ch ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch thanh tra/ki\u1EC3m tra n\u0103m ' + (DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : '') }),
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + keHoachText + ':', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? (0, _moment2.default)(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\u01B0\u1EDDi k\xFD:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.nguoiKy : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10 pl20 pr20' },
              _react2.default.createElement('div', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.keHoachThanhTraInfo === null },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.1. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.namThanhTra ? Data.namThanhTra : '' }),
                _react2.default.createElement(_common.Text, { link: true, label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-75 mb10', onClick: this.onOpenDialog.bind(this), value: tenDoiTuongThanhTraTKH }),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Lo\u1EA1i h\xECnh:', value: Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : '', className: 'col-25 mb10' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.loaiHinhThanhTra == 'THANH_TRA_LAI' },
                  _react2.default.createElement(_common.Text, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' l\u1EA1i:', value: Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : '', className: 'col-100 mb10' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' }),
                _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c:', className: 'col-25 mb10', value: Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.hinhThucThanhTra == 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.chucNangCuocThanhTra == 'HANH_CHINH' },
                    _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: !(0, _lodash.isEmpty)(Data, 'linhVucThanhTraList') ? (0, _lodash.get)(Data, 'linhVucThanhTraList', []).map(function (item) {
                        return item.text;
                      }).join(', ') : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.keHoachThanhTraInfo !== null },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.2. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { link: true, label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-25 mb10', onClick: this.onOpenDialog.bind(this), value: tenDoiTuongThanhTraTKH }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block mb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: DataDetail.keHoachThanhTraInfo !== null },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' })
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: DataDetail.keHoachThanhTraInfo !== null },
                  _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: DataDetail.chucNangCuocThanhTraInfo && DataDetail.chucNangCuocThanhTraInfo.text ? DataDetail.chucNangCuocThanhTraInfo.text : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: DataDetail.chucNangCuocThanhTra !== 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: !(0, _lodash.isEmpty)(Data, 'linhVucThanhTraList') ? (0, _lodash.get)(Data, 'linhVucThanhTraList', []).map(function (item) {
                        return item.text;
                      }).join(', ') : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.hinhThucThanhTra === 'DOT_XUAT' },
                    _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                  )
                ),
                _react2.default.createElement(_common.Text, { label: 'T\u1ED5ng s\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-100 mb10', value: CountDoiTuongThanhTra }),
                _react2.default.createElement(_common.Text, { label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ' li\xEAn quan:', className: 'col-100 mb10', value: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '' }),
                _react2.default.createElement(_common.Text, { label: 'T\u1ED5ng s\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ' li\xEAn quan:', className: 'col-100 mb10', value: CountDoiTuongThanhTraLienQuan })
              ),
              _react2.default.createElement(
                'section',
                { className: 'wrap-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 heading-addnew-dttt' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-13 col-100 pl20 pr20 mt10 mb15' },
                    '1.3 C\u0103n c\u1EE9 cu\u1ED9c ',
                    loaiCuocText
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10 ' },
                  _react2.default.createElement(
                    _dataTable2.default,
                    {
                      header: _table.header.dsCanCuCuocThanhTraView,
                      dataList: Data.danhMucVanBans,
                      hidePagination: true,
                      parent: this
                    },
                    _react2.default.createElement(_datatable2.RowItemCanCuCuocThanhTraView, null)
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' && Data.thanhVienDoan },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pb20 pr20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'row pl35 pr35 mb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb10' },
                      DataDetail.keHoachThanhTraInfo != {} && DataDetail.keHoachThanhTraInfo != null ? "1.2.1 Thành viên đoàn" : '1.1.1 Thành viên đoàn'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-table-show-oncheck white-table' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.thanhTra.TMTVCTTV,
                          dataList: Data.listThanhVienDoan ? Data.listThanhVienDoan : [],
                          pageData: this.state.pageData,
                          parent: this,
                          hideButtonExport: true,
                          hidePagination: true,
                          search: this.state.search,
                          tableLoading: this.state.tableLoading },
                        _react2.default.createElement(_datatable.RowItemChiTietThanhVienCuocThanhTraView, { linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '' })
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: Data.giaHan },
              _react2.default.createElement(
                'div',
                { className: 'pl20 pb20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'section',
                { className: 'pl35 pr35 row mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 block-gray p10 pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-12 txt-bold txt-upper pt10 mb15' },
                    'Gia h\u1EA1n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: Data.ngayRaQuyetDinhGiaHan ? (0, _moment2.default)(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: Data.lyDonGiaHan ? Data.lyDonGiaHan : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: true },
              _react2.default.createElement(
                'div',
                { className: 'row pl35 pr35 pb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 block-gray p10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl20 pr20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'txt-12 txt-bold txt-upper pt10 pb15' },
                      'Th\xF4ng b\xE1o k\u1EBFt th\xFAc ',
                      loaiCuocText,
                      ' tr\u1EF1c ti\u1EBFp'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 th\xF4ng b\xE1o:', className: 'col-25 mb10', value: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhThongBaoKetThucTTTT ? (0, _moment2.default)(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\u01B0\u1EDDi ban h\xE0nh:', className: 'col-25 mb10', value: Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.hoVaTen : '' })
                    ),
                    _react2.default.createElement(_common.TextMessage, { label: 'Ghi ch\xFA:', className: 'col-100', value: Data.ghiChu ? Data.ghiChu : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: true },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pl20 pr20 pb20' },
                      _react2.default.createElement('div', { className: 'line-border' })
                    ),
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 p20' },
                      DataDetail.keHoachThanhTraInfo != {} && DataDetail.keHoachThanhTraInfo != null ? '1.4 K\u1EBFt lu\u1EADn ' + loaiCuocText : '1.2 K\u1EBFt lu\u1EADn ' + loaiCuocText
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl30 pr30' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { label: '\u0110\u01A1n v\u1ECB ban h\xE0nh:', className: 'col-25 mb10', value: donViBanHanh })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD:', className: 'col-25 mb10', value: Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhQuyetDinhXuLy ? (0, _moment2.default)(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(_common.TextMessage, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: true },
            _react2.default.createElement(
              'div',
              { className: 'pl20 pr20' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line' },
                _react2.default.createElement('div', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pt15 pb15 ' + (this.state.showThongTinTheoDoi ? "collapse-open" : "collapse-close") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showThongTinTheoDoi') },
                  '2. Th\xF4ng tin theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { className: 'wrap-collapses', isOpen: this.state.showThongTinTheoDoi },
                _react2.default.createElement(
                  'div',
                  { className: 'mb15' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.1. V\u0103n b\u1EA3n ch\u1EC9 \u0111\u1EA1o c\u1EE7a c\u1EA5p tr\xEAn'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.state.soVanBanChiDaoCuaCapTren }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.state.ngayBanHanhVanBanChiDaoCuaCapTren }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh:', value: donViBanHanhVanBanChiDao }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Ghi ch\xFA:', value: this.state.ghiChuVanBanChiDaoCuaCapTren })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile && DataDetail.tienDoThanhTra != 'LUU_HO_SO' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    labelClass: 'title-12',
                    label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    hideDescription: true, disableAttachFile: true,
                    dataShow: this.state.listTaiLieuChiDaoCuaCapTren })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pt10 pb20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.2. V\u0103n b\u1EA3n b\xE1o c\xE1o k\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn ',
                    loaiCuocText
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh:', value: donViBanHanhVanBanBaoCao }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Ghi ch\xFA:', value: this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile && DataDetail.tienDoThanhTra != 'LUU_HO_SO' },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    labelClass: 'title-12',
                    label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    hideDescription: true, disableAttachFile: true,
                    dataShow: this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pt10 pb20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.3. K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn ',
                    loaiCuocText
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(_subView.NoiDungKienNghi, { view: true, linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '', chucNangCuocThanhTra: Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '', listDoiTuongViPham: this.state.listDoiTuongViPham, onRef: function onRef(noiDungKienNghi) {
                        return _this6.noiDungKienNghi = noiDungKienNghi;
                      }, type: this.state.type, id: this.state.id })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    labelClass: 'title-12',
                    label: '2.4. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    hideDescription: true, disableAttachFile: true,
                    dataShow: this.state.listTaiLieuXuLyCuocThanhTra })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt35 pb5' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: this.onClickClose.bind(this, 'close') },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        ),
        _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: DataDetail, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this) })
      );
    }
  }]);

  return KetQuaTheoDoiThucHien;
}(_react2.default.Component);

KetQuaTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'DOT_XUAT'
};

exports.default = KetQuaTheoDoiThucHien;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _core = __webpack_require__(7);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _subView = __webpack_require__(33);

var _RowItemTDTHGQD = __webpack_require__(1391);

var _RowItemTDTHGQD2 = _interopRequireDefault(_RowItemTDTHGQD);

var _layout = __webpack_require__(9);

var _formSort = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheoDoiThucHienGQD = function (_React$Component) {
  _inherits(TheoDoiThucHienGQD, _React$Component);

  function TheoDoiThucHienGQD(props, context) {
    _classCallCheck(this, TheoDoiThucHienGQD);

    var _this = _possibleConstructorReturn(this, (TheoDoiThucHienGQD.__proto__ || Object.getPrototypeOf(TheoDoiThucHienGQD)).call(this, props, context));

    _this.state = {
      vaiTro: '',
      trangThaiGiaiQuyetDon: 'DANG_GIAI_QUYET',
      advanceSearch: false,
      tuKhoa: '',
      maDon: '',
      nguonDon: '',
      phanLoaiDon: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      tinhTrangGiaiQuyet: '',
      ketQuaGiaiQuyet: '',
      phongBanXuLyXLD: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepNhan,desc',
      data: [],
      spSearch: false,
      search: false,
      tableLoading: false,
      searchLoading: false
    };
    return _this;
  }

  _createClass(TheoDoiThucHienGQD, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
      this.state.trangThaiGiaiQuyetDon = data.trangThaiDon || 'DANG_GIAI_QUYET';
      this.state.advanceSearch = data.advanceSearch || false;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.tuKhoa = data.hoTen || '';
      if (this.state.advanceSearch) {
        this.state.isSaveTemp = data.isSaveTemp;
        this.state.nguonDon = data.nguonDon || '';
        this.state.maDon = data.maDon || '';
        this.state.phanLoaiDon = data.phanLoaiDon || '';
        this.state.tinhTrangGiaiQuyet = data.trangThaiDonToanHT || '';
        this.state.ketQuaGiaiQuyet = data.ketQuaToanHT || '';
        this.state.tiepNhanTuNgay = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
        this.state.tiepNhanDenNgay = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
      }
      this.setState(_extends({}, this.state));
      this.getListData();
    }
  }, {
    key: 'openSearchForm',
    value: function openSearchForm() {
      this.state.advanceSearch = true;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
      data.advanceSearch = true;
      localStorage.setItem('tdthGQD', JSON.stringify(data));
    }
  }, {
    key: 'closeSearchForm',
    value: function closeSearchForm() {
      this.state.advanceSearch = false;
      this.setState(_extends({}, this.state));
      var data = localStorage.getItem('tdthGQD') ? JSON.parse(localStorage.getItem('tdthGQD')) : {};
      data.advanceSearch = false;
      localStorage.setItem('tdthGQD', JSON.stringify(data));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(searchData, e) {
      // Dung ung dung neu ngay nhap khong hop le
      if ([searchData.tiepNhanTuNgay, searchData.tiepNhanDenNgay].indexOf('INVALID') != -1) {
        return;
      }
      this.state.search = true;
      var newData = _extends({}, this.state, searchData);
      this.state = newData;
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
      this.setState(_extends({}, this.state));

      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      var _this2 = this;

      var params = {
        trangThaiDon: this.state.trangThaiGiaiQuyetDon,
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: this.state.sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });

      if (this.state.isSaveTemp) {
        params.isSaveTemp = this.state.isSaveTemp;
      }

      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('tdthGQD', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getListTheoDoiThucHienGQD.request(params).then(function (res) {
        if (_this2.refs.listGQD) {
          if (res.data._embedded) {
            _this2.setState({
              data: res.data._embedded.dons,
              pageData: res.data.page
            });
          } else {
            _this2.setState({
              data: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this2.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
      if (name === 'sortBy') {
        this.handleSort(e.target.value);
      }
    }
  }, {
    key: 'handleSort',
    value: function handleSort(sortBy) {
      var _this3 = this;

      var params = {
        trangThaiDon: this.state.trangThaiGiaiQuyetDon,
        thanhLapDon: true,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: sortBy
      };

      this.setState({
        searching: true,
        tableLoading: true,
        searchLoading: true
      });
      if (this.state.isSaveTemp) {
        params.isSaveTemp = this.state.isSaveTemp;
      }

      if (this.state.tuKhoa) {
        params.hoTen = this.state.tuKhoa;
      }
      if (this.state.advanceSearch) {
        if (this.state.maDon) {
          params.maDon = this.state.maDon;
        }

        if (this.state.phanLoaiDon) {
          params.phanLoaiDon = this.state.phanLoaiDon;
        }

        if (this.state.nguonDon) {
          params.nguonDon = this.state.nguonDon;
        }

        if (this.state.tinhTrangGiaiQuyet) {
          params.trangThaiDonToanHT = this.state.tinhTrangGiaiQuyet;
        }

        if (this.state.ketQuaGiaiQuyet) {
          params.ketQuaToanHT = this.state.ketQuaGiaiQuyet;
        }

        if (this.state.tiepNhanTuNgay) {
          params.tiepNhanTuNgay = (0, _moment2.default)(this.state.tiepNhanTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }

        if (this.state.tiepNhanDenNgay) {
          params.tiepNhanDenNgay = (0, _moment2.default)(this.state.tiepNhanDenNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }
      localStorage.setItem('tdthGQD', JSON.stringify(_extends({}, params, { advanceSearch: this.state.advanceSearch })));
      _api.GiaiQuyetDonThu.actions.getListTheoDoiThucHienGQD.request(params).then(function (res) {
        if (_this3.refs.listGQD) {
          if (res.data._embedded) {
            _this3.setState({
              data: res.data._embedded.dons,
              pageData: res.data.page
            });
          } else {
            _this3.setState({
              data: [],
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              }
            });
          }
          _this3.setState({
            tableLoading: false,
            searchLoading: false,
            searching: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handleChangeTrangThaiGiaiQuyet',
    value: function handleChangeTrangThaiGiaiQuyet(e) {
      var _this4 = this;

      if (e.target.name == 'trangThaiGiaiQuyetDon') {
        var _setState2;

        localStorage.setItem('gqd.currentTab', e.target.value);
        this.setState((_setState2 = {}, _defineProperty(_setState2, e.target.name, e.target.value), _defineProperty(_setState2, 'advanceSearch', false), _defineProperty(_setState2, 'pageData', {
          number: 0,
          size: 10,
          totalElements: 0
        }), _setState2), function () {
          _this4.getListData();
        });
        this.refs.listSearch.resetData();
      } else {
        this.setState(_defineProperty({}, e.target.name, e.target.value));
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({ data: nextProps.data });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { ref: 'listGQD' },
          _react2.default.createElement(
            'div',
            { className: 'center reception-container gqd-container' },
            _react2.default.createElement(
              'div',
              { className: 'top-content' },
              _react2.default.createElement(
                'div',
                { className: 'left-content' },
                _react2.default.createElement(
                  _core.RadioGroup,
                  {
                    name: 'trangThaiGiaiQuyetDon',
                    className: 'radio-gender',
                    onChange: this.handleChangeTrangThaiGiaiQuyet.bind(this),
                    selectedValue: this.state.trangThaiGiaiQuyetDon },
                  _react2.default.createElement(_core.Radio, { label: 'C\xD4NG VI\u1EC6C \u0110ANG THEO D\xD5I', value: 'DANG_GIAI_QUYET', className: 'pt-large txt-bold radio-header' }),
                  _react2.default.createElement(_core.Radio, { label: 'C\xD4NG VI\u1EC6C \u0110\xC3 HO\xC0N TH\xC0NH', value: 'DA_GIAI_QUYET', className: 'pt-large txt-bold radio-header' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'bottom-content' },
              _react2.default.createElement(
                'div',
                { className: this.state.advanceSearch ? 'search-container super-search' : 'search-container' },
                _react2.default.createElement(_subView.ListSearch, { onStatus: this.state.trangThaiGiaiQuyetDon, ref: 'listSearch', advanceSearch: this.state.advanceSearch, onCancel: this.closeSearchForm.bind(this), handleSearch: this.handleSearch.bind(this), disabled: this.state.searching, search: this.state.search, cookieName: 'tdthGQD' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'rearch-text', onClick: this.openSearchForm.bind(this) },
                  _react2.default.createElement('i', { className: 'tt tt-super-search' }),
                  'T\xECm ki\u1EBFm n\xE2ng cao'
                )
              ),
              _react2.default.createElement(_formSort.FormSort, {
                type: 'theoDoiThucHien',
                pageDetail: this.state.pageData,
                selectedValue: this.state.sortBy,
                onChange: this.handleChange.bind(this, 'sortBy')
              }),
              _react2.default.createElement(
                _dataTable2.default,
                {
                  header: _table.header.giaiQuyetDon.listGQD,
                  dataList: this.state.data,
                  pageData: this.state.pageData,
                  parent: this,
                  hideButtonExport: true,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_RowItemTDTHGQD2.default, { type: this.state.trangThaiGiaiQuyetDon, getListData: this.getListData.bind(this) })
              )
            )
          )
        )
      );
    }
  }]);

  return TheoDoiThucHienGQD;
}(_react2.default.Component);

exports.default = TheoDoiThucHienGQD;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(197);

var _core = __webpack_require__(7);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _upload = __webpack_require__(17);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _table = __webpack_require__(12);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _datatable = __webpack_require__(52);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiQuyTrinh = 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA';

var XuLyTheoDoiThucHien = function (_React$Component) {
  _inherits(XuLyTheoDoiThucHien, _React$Component);

  function XuLyTheoDoiThucHien(props, context) {
    _classCallCheck(this, XuLyTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (XuLyTheoDoiThucHien.__proto__ || Object.getPrototypeOf(XuLyTheoDoiThucHien)).call(this, props, context));

    _this.state = {
      data: [],
      dataDetail: [],
      id: _this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      type: _this.props.type,
      showDoiTuongThanhTra: false,
      showThongTinThanhTra: true,
      showThongTinTheoDoi: true,
      enableKetThuc: false,
      isOpenConfirm: false,
      backConfirm: false,
      hasChange: false,
      doiTuongThanhTras: [],
      soVanBanChiDaoCuaCapTren: '',
      coQuanBanHanhChiDaoCuaCapTren: '',
      ghiChuVanBanChiDaoCuaCapTren: '',
      ngayBanHanhVanBanChiDaoCuaCapTren: '',

      soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: '',

      // list tai lieu

      listTaiLieuChiDaoCuaCapTren: [],
      listTaiLieuKetQuaThucHienKetLuanThanhTra: [],
      listTaiLieuXuLyCuocThanhTra: [],

      listTaiLieuVanThuThanhTra: [],
      listTaiLieuVanThuThanhTraView: [],

      // data tai lieu dinh kem
      dataCanCuThanhTraLai: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        chiDaoCapTren: [],
        ketLuanThanhTra: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      isKiemTra: false,

      danhMucVanBans: [],
      chiTietDT: false
    };
    return _this;
  }

  _createClass(XuLyTheoDoiThucHien, [{
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      if (type == 'CHI_DAO_CAP_TREN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.chiDaoCapTren = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA') {
        var _dataFileDinhKem = this.state.dataFileDinhKem;

        _dataFileDinhKem.ketLuanThanhTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem
        });
      } else {
        var _dataFileDinhKem2 = this.state.dataFileDinhKem;

        _dataFileDinhKem2.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem2
        });
      }
      this.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });
      if (type == 'CHI_DAO_CAP_TREN') {
        var dataFileDinhKem = this.state.dataFileDinhKem;

        dataFileDinhKem.chiDaoCapTren = data;

        this.setState({
          dataFileDinhKem: dataFileDinhKem
        });
      } else if (type == 'KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA') {
        var _dataFileDinhKem3 = this.state.dataFileDinhKem;

        _dataFileDinhKem3.ketLuanThanhTra = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem3
        });
      } else {
        var _dataFileDinhKem4 = this.state.dataFileDinhKem;

        _dataFileDinhKem4.data = data;

        this.setState({
          dataFileDinhKem: _dataFileDinhKem4
        });
      }

      this.handleChangeData();
    }
  }, {
    key: 'getListDataFileDinhKem',
    value: function getListDataFileDinhKem(type) {
      var dataFileDinhKem = [];
      var Data = this.state.dataFileDinhKem;

      if (Data.chiDaoCapTren.length > 0) {
        Data.chiDaoCapTren.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.ketLuanThanhTra.length > 0) {
        Data.ketLuanThanhTra.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      if (Data.data.length > 0) {
        Data.data.map(function (state) {
          dataFileDinhKem[dataFileDinhKem.length] = state;
        });
      }

      return dataFileDinhKem;
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id) {
      var _this2 = this;

      var dataFileDinhKem = this.getListDataFileDinhKem();

      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            _this2.state.taiLieuVanThuUpdate[_this2.state.taiLieuVanThuUpdate.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            _this2.state.taiLieuVanThu[_this2.state.taiLieuVanThu.length] = {
              cuocThanhTra: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          _this2.state.taiLieuVanThuDelete[_this2.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if (this.state.taiLieuVanThu.length > 0) {
        var params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        };
        this.postTaiLieuVanThu(params);
      }

      if (this.state.taiLieuVanThuUpdate.length > 0) {
        var _params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        };
        this.updateTaiLieuVanThu(_params);
      }

      if (this.state.taiLieuVanThuDelete.length > 0) {

        var _params2 = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        };
        this.deleteTaiLieuVanThu(_params2);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDetail(this.state.id);
      this.getDonViBanHanh();
      this.getDataCanCuThanhTraLai();
    }
  }, {
    key: 'getDataCanCuThanhTraLai',
    value: function getDataCanCuThanhTraLai() {
      var _this3 = this;

      _api.ThanhTra.actions.getCanCuThanhTraLai.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataCanCuThanhTraLai: res.data
          });
        }
      });
    }
  }, {
    key: 'getCanCuThanhTraLai',
    value: function getCanCuThanhTraLai(value) {
      if (this.state.dataCanCuThanhTraLai.length > 0) {
        return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(function (x) {
          return x.giaTri == value;
        })].ten;
      } else {
        return;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        id: nextProps.params.id,
        type: nextProps.type
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(id) {
      var _this4 = this;

      _api.ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this4.setState({
            dataDetail: res.data,
            soVanBanChiDaoCuaCapTren: res.data.soVanBanChiDaoCuaCapTren ? res.data.soVanBanChiDaoCuaCapTren : '',
            coQuanBanHanhChiDaoCuaCapTren: res.data.coQuanBanHanhChiDaoCuaCapTren ? res.data.coQuanBanHanhChiDaoCuaCapTren : '',
            ghiChuVanBanChiDaoCuaCapTren: res.data.ghiChuVanBanChiDaoCuaCapTren ? res.data.ghiChuVanBanChiDaoCuaCapTren : '',
            ngayBanHanhVanBanChiDaoCuaCapTren: res.data.ngayBanHanhVanBanChiDaoCuaCapTren ? new Date(res.data.ngayBanHanhVanBanChiDaoCuaCapTren) : '',

            soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
            ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? new Date(res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT) : '',
            danhMucVanBans: res.data.danhMucVanBans ? res.data.danhMucVanBans : []

          }, function () {
            _this4.checkListDoiTuongViPham();
            _this4.checkTypeCuocThanhTra();
          });
        }
      });
      this.getChiTietLienQuanCuocThanhTra(id);
    }
  }, {
    key: 'getChiTietLienQuanCuocThanhTra',
    value: function getChiTietLienQuanCuocThanhTra(id) {
      var _this5 = this;

      _api.ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          var Data = res.data;
          _this5.state.listTaiLieuChiDaoCuaCapTren = Data.listTaiLieuChiDaoCuaCapTren ? Data.listTaiLieuChiDaoCuaCapTren : [];
          _this5.state.listTaiLieuKetQuaThucHienKetLuanThanhTra = Data.listTaiLieuKetQuaThucHienKetLuanThanhTra ? Data.listTaiLieuKetQuaThucHienKetLuanThanhTra : [];
          _this5.state.listTaiLieuXuLyCuocThanhTra = Data.listTaiLieuXuLyCuocThanhTra ? Data.listTaiLieuXuLyCuocThanhTra : [];
          _this5.state.showFile = false;
          _this5.setState(_extends({}, _this5.state), function () {
            _this5.checkFileRequire();
          });
        }
      });
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = this.state.dataDetail;
      if (params.doiTuongThanhTraInfo) {
        params.doiTuongThanhTra = {
          id: params.doiTuongThanhTraInfo.doiTuongThanhTraId
        };
      } else {
        params.doiTuongThanhTra = null;
      }

      var getItems = [];
      if (params.listDoiTuongThanhTra) {
        params.listDoiTuongThanhTra.forEach(function (item) {
          getItems.push({
            id: item.doiTuongThanhTraId,
            ten: item.ten
          });
        });
      }
      params.doiTuongThanhTras = getItems;

      if (params.donViChuTriInfo) {
        params.donViChuTri = {
          id: Number(params.donViChuTriInfo.coQuanQuanLyId)
        };
      } else {
        params.donViChuTri = null;
      }

      if (params.thanhVienDoan == true && params.listThanhVienDoan.length > 0) {
        var data = [].concat(_toConsumableArray(params.listThanhVienDoan));
        var thanhVienDoans = [];
        data.map(function (state) {
          var newItem = {
            chucVu: state.chucVu ? state.chucVu : '',
            donVi: state.donVi ? state.donVi : '',
            hoVaTen: state.hoVaTen ? state.hoVaTen : '',
            ngaySinh: state.ngaySinh ? (0, _moment2.default)(new Date(state.ngaySinh)).add(7, 'hours').toISOString() : '',
            vaiTroThanhVienDoan: state.vaiTroThanhVienDoan ? state.vaiTroThanhVienDoan : null
          };
          if (state.thanhVienDoanId) {
            newItem.id = Number(state.thanhVienDoanId);
          }
          thanhVienDoans[thanhVienDoans.length] = newItem;
        });
        params.thanhVienDoans = thanhVienDoans;
      }

      if (params.linhVucThanhTra) {
        params.linhVucThanhTra = params.linhVucThanhTra.giaTri;
      }

      if (params.tienDoThanhTraInfo) {
        params.tienDoThanhTra = params.tienDoThanhTraInfo.type;
      } else {
        params.tienDoThanhTra = null;
      }

      if (params.keHoachThanhTraInfo) {
        params.keHoachThanhTra = {
          id: params.keHoachThanhTraInfo.keHoachThanhTraId
        };
      } else {
        params.keHoachThanhTra = null;
      }

      // field xu ly
      params.soVanBanChiDaoCuaCapTren = this.state.soVanBanChiDaoCuaCapTren ? this.state.soVanBanChiDaoCuaCapTren : '';
      params.coQuanBanHanhChiDaoCuaCapTren = this.state.coQuanBanHanhChiDaoCuaCapTren ? this.state.coQuanBanHanhChiDaoCuaCapTren : null;
      params.ghiChuVanBanChiDaoCuaCapTren = this.state.ghiChuVanBanChiDaoCuaCapTren ? this.state.ghiChuVanBanChiDaoCuaCapTren : '';
      params.ngayBanHanhVanBanChiDaoCuaCapTren = this.state.ngayBanHanhVanBanChiDaoCuaCapTren ? (0, _moment2.default)(this.state.ngayBanHanhVanBanChiDaoCuaCapTren).add(7, 'hours').toISOString() : null;

      params.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '';
      params.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : null;
      params.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '';
      params.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT = this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? (0, _moment2.default)(this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT).add(7, 'hours').toISOString() : null;

      params.danhMucVanBans = this.state.danhMucVanBans.filter(function (item) {
        return !!item.danhMucVanBanId;
      }).map(function (item) {
        return { id: item.danhMucVanBanId };
      });
      params.linhVucThanhTraList = params.linhVucThanhTraList ? params.linhVucThanhTraList.map(function (item) {
        return item.giaTri;
      }) : null;

      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['coQuanDieuTraInfo'];
      delete params['doiTuongThanhTraInfo'];
      delete params['donViChuTriInfo'];
      delete params['keHoachThanhTraInfo'];
      delete params['donViInfo'];
      delete params['hinhThucThanhTraInfo'];
      delete params['linhVucThanhTraInfo'];
      delete params['loaiHinhThanhTraInfo'];
      delete params['listTaiLieuVanThu'];
      delete params['listTaiLieuVanThuGiaHan'];
      delete params['listTaiLieuVanThuKetLuanThanhTra'];
      delete params['linhVucThanhTraChiTietInfo'];
      delete params['cuocThanhTraId'];
      delete params['listThanhVienDoan'];
      delete params['tienDoThanhTraInfo'];
      delete params['thoiHanThanhTraInfo'];
      delete params['listTaiLieuVanThuThongBaoKetThucTTTT'];
      delete params['listTaiLieuVanThuThongTinCuocThanhTra'];
      delete params['listDoiTuongThanhTra'];
      delete params['chucNangCuocThanhTraInfo'];
      delete params['listDoiTuongViPham'];
      delete params['thucHienPhapLuatVeThanhTraInfo'];
      delete params['listTaiLieuChiDaoCuaCapTren'];
      delete params['listTaiLieuKetQuaThucHienKetLuanThanhTra'];
      delete params['listTaiLieuXuLyCuocThanhTra'];
      delete params['listCoQuanToChucLienQuan'];
      delete params['keHoachThanhTraCuInfo'];
      delete params['keHoachThanhTraGocInfo'];
      delete params['keHoachThanhTraSearchInfo'];
      delete params['hinhThucThanhTraChuyenNganhInfo'];
      delete params['nguoiBanHanhThongBaoKetThucTTTTInfo'];

      return params;
    }
  }, {
    key: 'checkIsKiemTra',
    value: function checkIsKiemTra() {
      var result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra || (0, _lodash.get)(this.state, 'dataDetail.loaiCuoc.value') === 'KIEM_TRA';
      return result;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this6 = this;

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      var params = this.getParams();
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      this.pushTaiLieu(this.state.id);
      _api.ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
        if (res.data) {
          _this6.handleBack(true);
          (0, _toastr.Toastr)(_message.msg.saveCuocTTSuccess, 'success');
        }
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this6.setState({
          btnLoading: false,
          btnSaveLoading: false
        });
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'checkFileRequire',
    value: function checkFileRequire() {
      var _this7 = this;

      // check file chi dao cap tren

      var dataChiDaoCuaCapTren = [].concat(_toConsumableArray(this.state.listTaiLieuChiDaoCuaCapTren));
      var dataChiDaoCuaCapTrenCheck = dataChiDaoCuaCapTren.filter(function (state) {
        return state.required && state.typeRequired == 'CHI_DAO_CAP_TREN';
      });

      if (dataChiDaoCuaCapTrenCheck.length > 0) {
        this.setState({
          listTaiLieuChiDaoCuaCapTren: dataChiDaoCuaCapTren,
          showFile: true
        });
      } else {
        var newItem = {
          ten: 'Văn bản chỉ đạo',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'CHI_DAO_CAP_TREN',
          newFile: true
        };
        this.setState({
          listTaiLieuChiDaoCuaCapTren: [].concat(_toConsumableArray(dataChiDaoCuaCapTren), [newItem]),
          showFile: true
        });
      }

      //check file thanh tra chuyen qua
      var data = [].concat(_toConsumableArray(this.state.listTaiLieuXuLyCuocThanhTra));
      var dataView = [].concat(_toConsumableArray(this.state.listTaiLieuXuLyCuocThanhTra));

      var listTaiLieuVanThuThanhTra = data.filter(function (state) {
        return _this7.compareDate(new Date(state.ngayTao), new Date(_this7.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
      });

      var listTaiLieuVanThuThanhTraView = dataView.filter(function (state) {
        return _this7.compareDate(new Date(_this7.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
      });
      this.setState({
        listTaiLieuVanThuThanhTra: listTaiLieuVanThuThanhTra,
        listTaiLieuVanThuThanhTraView: listTaiLieuVanThuThanhTraView
      }, function () {
        _this7.setState({
          showFile: true
        });
      });
    }
  }, {
    key: 'compareDate',
    value: function compareDate(firstDate, secondDate, type) {
      var firstTime = firstDate.getTime();
      var secondTime = secondDate.getTime();

      if (firstTime >= secondTime && type == 'show') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkTypeCuocThanhTra',
    value: function checkTypeCuocThanhTra() {
      if (this.state.dataDetail.keHoachThanhTraInfo == null) {
        this.setState({
          type: 'DOT_XUAT'
        });
      } else {
        this.setState({
          type: 'KE_HOACH'
        });
      }
    }
  }, {
    key: 'getDonViBanHanh',
    value: function getDonViBanHanh() {
      var _this8 = this;

      _api.ThanhTra.actions.getListDonViBanHanh.request().then(function (res) {
        if (res.data) {
          _this8.setState({
            dataDonViBanHanh: res.data
          });
        }
      });
    }
  }, {
    key: 'checkListDoiTuongViPham',
    value: function checkListDoiTuongViPham() {
      var Data = this.state.dataDetail;
      var listDoiTuongViPham = [];
      var doiTuongThanhTraLienQuan = [];
      var doiTuongThanhTras = [].concat(_toConsumableArray(Data.listDoiTuongThanhTra));
      var doiTuongThanhTra = Data.doiTuongThanhTraInfo;
      var data = Data.doiTuongThanhTraLienQuan.split('; ');
      if (data.length > 0) {
        data.map(function (state) {
          if (state) {
            doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
              ten: state
            };
          }
        });
      }
      if (doiTuongThanhTraLienQuan.length > 0) {
        doiTuongThanhTraLienQuan.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTras.length > 0) {
        doiTuongThanhTras.map(function (state) {
          listDoiTuongViPham[listDoiTuongViPham.length] = {
            ten: state.ten,
            giaTri: state.ten
          };
        });
      }
      if (doiTuongThanhTra) {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: doiTuongThanhTra.ten,
          giaTri: doiTuongThanhTra.ten
        };
      }
      this.setState({
        listDoiTuongViPham: listDoiTuongViPham
      });
    }
  }, {
    key: 'showDoiTuongThanhTra',
    value: function showDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: true
      });
    }
  }, {
    key: 'hideDoiTuongThanhTra',
    value: function hideDoiTuongThanhTra() {
      this.setState({
        showDoiTuongThanhTra: false
      });
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse(name) {
      this.setState(_defineProperty({}, name, !this.state[name]));
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
      this.handleChangeData();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
      this.handleChangeData();
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'setEnableKetThuc',
    value: function setEnableKetThuc(state) {
      this.setState({
        enableKetThuc: state
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      var _this9 = this;

      if (this.state.showThongTinTheoDoi == true) {
        if (this.validateSubmitForm()) {
          this.setState({
            isOpenConfirm: true
          });
        }
      } else {

        this.setState({
          showThongTinTheoDoi: true
        }, function () {
          var self = _this9;
          setTimeout(function () {
            if (self.validateSubmitForm()) {
              self.setState({
                isOpenConfirm: true
              });
            }
          }, 100);
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpenConfirm: false
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this10 = this;

      this.setState({
        isOpenConfirm: false,
        btnLoading: true,
        btnSaveLoading: true
      });
      var params = this.getParams();
      params.tienDoThanhTra = 'LUU_HO_SO';
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      this.pushTaiLieu(this.state.id);
      _api.ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(function (res) {
        if (res.data) {
          _this10.handleBack(true);
          (0, _toastr.Toastr)(_message.msg.tdthLuuHoSo, 'success');
        }
      }).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
        _this10.setState({
          btnLoading: false,
          btnSaveLoading: false
        });
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack, type) {
      if (allowBack) {
        if (type == 'close') {
          this.checkNoiDungKienNghi();
          _reactRouter.browserHistory.goBack();
        } else {
          _reactRouter.browserHistory.goBack();
        }
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          _reactRouter.browserHistory.goBack();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'onOpenDialog',
    value: function onOpenDialog() {
      this.setState({
        chiTietDT: true
      });
    }
  }, {
    key: 'toggleDialog',
    value: function toggleDialog() {
      this.setState({
        chiTietDT: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var Data = this.state.dataDetail;
      var DataDetail = this.state.dataDetail;
      var DoiTuongThanhTra = '';
      var tenDoiTuongThanhTraTKH = '';
      var CountDoiTuongThanhTra = 0;
      var CountDonViPhoiHop = 0;
      var CountDoiTuongThanhTraLienQuan = 0;
      var chucNangThanhTra = '';
      if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra[0].ten;
      } else if (Data && Data.cuocThanhTraNhieuDoiTuong && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra.length + ' \u0111\u1ED1i t\u01B0\u1EE3ng';
      }
      if (DataDetail && DataDetail.chucNangCuocThanhTraInfo && DataDetail.chucNangCuocThanhTraInfo.text) {
        chucNangThanhTra = DataDetail.chucNangCuocThanhTraInfo.text;
      }
      if (Data.donViPhoiHop) {
        CountDonViPhoiHop = Data.donViPhoiHop.split('; ').length;
      }
      if (Data.doiTuongThanhTraLienQuan) {
        CountDoiTuongThanhTraLienQuan = Data.doiTuongThanhTraLienQuan.split('; ').length;
      }

      if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        Data.listDoiTuongThanhTra.map(function (state, index) {
          if (index == 0) {
            DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
          } else {
            DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
          }
        });
        CountDoiTuongThanhTra = Data.listDoiTuongThanhTra.length;
      }
      var data = [].concat(_toConsumableArray(this.state.dataDonViBanHanh));
      var dataFilter = data.filter(function (state) {
        return state.giaTri == Data.donViBanHanh;
      });
      var donViBanHanh = '';
      if (dataFilter.length > 0) {
        donViBanHanh = dataFilter[0].ten;
      }
      var isKiemTra = (0, _lodash.get)(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
      var loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
      var keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block custom-collapse' },
        _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
          title: _message.msg.confirmBack }),
        _react2.default.createElement(
          'div',
          { className: 'back-foward' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleBack.bind(this, false, 'close'), title: '' },
            'V\u1EC1 trang tr\u01B0\u1EDBc'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'heading' },
          _react2.default.createElement(
            'h2',
            { className: 'heading-title icon-add' },
            'Theo d\xF5i th\u1EF1c hi\u1EC7n sau ',
            loaiCuocText
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          _react2.default.createElement(
            'h2',
            { className: 'collapse-title pl20 pr20 pt20 ' + (this.state.showThongTinThanhTra ? "collapse-open" : "collapse-close") },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showThongTinThanhTra') },
              '1. Th\xF4ng tin ',
              loaiCuocText
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pl20 pr20 pt20' },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: Data && Data.hinhThucThanhTra === 'THEO_KE_HOACH' },
            _react2.default.createElement(
              'section',
              { className: 'wrap-block' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.1. Th\xF4ng tin k\u1EBF ho\u1EA1ch ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-20', value: 'K\u1EBF ho\u1EA1ch ' + loaiCuocText + ' n\u0103m ' + (DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : '') }),
                _react2.default.createElement(_common.Text, { label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t ' + keHoachText + ':', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ph\xEA duy\u1EC7t:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? (0, _moment2.default)(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\u01B0\u1EDDi k\xFD:', className: 'col-20', value: DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.nguoiKy : '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mt10 pl20 pr20' },
              _react2.default.createElement('div', { className: 'line-border' })
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'DOT_XUAT' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.1. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'N\u0103m ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.namThanhTra ? Data.namThanhTra : '' }),
                _react2.default.createElement(_common.Text, { link: true, label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-75 mb10', onClick: this.onOpenDialog.bind(this), value: tenDoiTuongThanhTraTKH }),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Lo\u1EA1i h\xECnh:', value: Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : '', className: 'col-25 mb10' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.loaiHinhThanhTra === 'THANH_TRA_LAI' },
                  _react2.default.createElement(_common.Text, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' l\u1EA1i:', value: Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : '', className: 'col-100 mb10' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' }),
                _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c:', className: 'col-25 mb10', value: Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : '' }),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: Data.hinhThucThanhTra === 'DOT_XUAT' },
                  _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl30 pr30' },
                  _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.chucNangCuocThanhTra === 'HANH_CHINH' },
                    _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(function (item) {
                        return item.ten;
                      }).join(', ') : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl15 pr15' },
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 p20' },
                  '1.2. Th\xF4ng tin cu\u1ED9c ',
                  loaiCuocText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { link: true, label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-25 mb10', onClick: this.onOpenDialog.bind(this), value: tenDoiTuongThanhTraTKH }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi k\u1EF3 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.kyThanhTra ? Data.kyThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'T\xEAn cu\u1ED9c ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.ten ? Data.ten : '' }),
                _react2.default.createElement(_common.TextMessage, { label: 'N\u1ED9i dung ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.noiDungThanhTra ? Data.noiDungThanhTra : '' })
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'wrap-block mb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.type === 'KE_HOACH' },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb10', value: Data.ngayRaQuyetDinh ? (0, _moment2.default)(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Ng\xE0y c\xF4ng b\u1ED1 Q\u0110 ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.ngayCongBoQuyetDinhThanhTra ? (0, _moment2.default)(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : '' }),
                _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ' + loaiCuocText + ' (ng\xE0y l\xE0m vi\u1EC7c):', type: 'sdt', className: 'col-25 mb10', value: (Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0) + ' ng\xE0y (' + (Data.ngayHetHanThanhTra ? (0, _moment2.default)(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '') + ')' })
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
              _react2.default.createElement(
                'div',
                { className: 'row pl30 pr30' },
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.type === 'KE_HOACH' },
                  _react2.default.createElement(_common.Text, { label: 'Ch\u1EE9c n\u0103ng ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : '' }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.chucNangCuocThanhTra !== 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'L\u0129nh v\u1EF1c ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(function (item) {
                        return item.ten;
                      }).join(', ') : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH' },
                    _react2.default.createElement(_common.Text, { label: 'H\xECnh th\u1EE9c ' + loaiCuocText + ' chuy\xEAn ng\xE0nh:', className: 'col-25 mb10', value: Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : '' })
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: Data.hinhThucThanhTra === 'DOT_XUAT' },
                    _react2.default.createElement(_common.TextMessage, { label: 'C\u0103n c\u1EE9 ' + loaiCuocText + ' \u0111\u1ED9t xu\u1EA5t:', className: 'col-100 mb10', value: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '' })
                  )
                ),
                _react2.default.createElement(_common.Text, { label: 'T\u1ED5ng s\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ':', className: 'col-100 mb10', value: CountDoiTuongThanhTra }),
                _react2.default.createElement(_common.Text, { label: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ' li\xEAn quan:', className: 'col-100 mb10', value: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '' }),
                _react2.default.createElement(_common.Text, { label: 'T\u1ED5ng s\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText + ' li\xEAn quan:', className: 'col-100 mb10', value: CountDoiTuongThanhTraLienQuan })
              )
            )
          ),
          _react2.default.createElement(
            _core.Collapse,
            { className: 'wrap-collapses', isOpen: this.state.showThongTinThanhTra },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' && Data.thanhVienDoan },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'pl20 pb20 pr20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'row pl35 pr35 mb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb10' },
                      this.state.type === 'KE_HOACH' ? "1.2.1 Thành viên đoàn" : '1.1.1 Thành viên đoàn'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'row pl10 pr10' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y quy\u1EBFt \u0111\u1ECBnh:', className: 'col-25 mb0-18', value: Data.ngayRaQuyetDinhThanhLapDoan ? (0, _moment2.default)(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-table-show-oncheck white-table' },
                      _react2.default.createElement(
                        _dataTable2.default,
                        {
                          header: _table.header.thanhTra.TMTVCTTV,
                          dataList: Data.listThanhVienDoan ? Data.listThanhVienDoan : [],
                          pageData: this.state.pageData,
                          parent: this,
                          hideButtonExport: true,
                          hidePagination: true,
                          search: this.state.search,
                          tableLoading: this.state.tableLoading },
                        _react2.default.createElement(_datatable.RowItemChiTietThanhVienCuocThanhTraView, { linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '' })
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: Data.giaHan },
              _react2.default.createElement(
                'div',
                { className: 'pl20 pb20 pr20' },
                _react2.default.createElement('div', { className: 'line-border' })
              ),
              _react2.default.createElement(
                'section',
                { className: 'pl35 pr35 row mb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 block-gray p10 pl15 pr15' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'txt-12 txt-bold txt-upper pt10 mb15' },
                    'Gia h\u1EA1n'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : '' }),
                    _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ra quy\u1EBFt \u0111\u1ECBnh:', value: Data.ngayRaQuyetDinhGiaHan ? (0, _moment2.default)(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : '' }),
                    _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb5', label: 'L\xFD do gia h\u1EA1n:', value: Data.lyDonGiaHan ? Data.lyDonGiaHan : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: true },
              _react2.default.createElement(
                'div',
                { className: 'row pl35 pr35 pb20' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 block-gray p10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl20 pr20' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'txt-12 txt-bold txt-upper pt10 pb15' },
                      'Th\xF4ng b\xE1o k\u1EBFt th\xFAc ',
                      loaiCuocText,
                      ' tr\u1EF1c ti\u1EBFp'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 th\xF4ng b\xE1o:', className: 'col-25 mb10', value: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhThongBaoKetThucTTTT ? (0, _moment2.default)(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\u01B0\u1EDDi ban h\xE0nh:', className: 'col-25 mb10', value: Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.hoVaTen : '' })
                    ),
                    _react2.default.createElement(_common.TextMessage, { label: 'Ghi ch\xFA:', className: 'col-100', value: Data.ghiChu ? Data.ghiChu : '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: true },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter pl20 pr20 pb20' },
                      _react2.default.createElement('div', { className: 'line-border' })
                    ),
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 p20' },
                      this.state.type === 'KE_HOACH' ? '1.3 K\u1EBFt lu\u1EADn ' + loaiCuocText : '1.2 K\u1EBFt lu\u1EADn ' + loaiCuocText
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl30 pr30' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-25 mb10', value: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhKetLuanThanhTra ? (0, _moment2.default)(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : '' }),
                      _react2.default.createElement(_common.Text, { label: '\u0110\u01A1n v\u1ECB ban h\xE0nh:', className: 'col-25 mb10', value: donViBanHanh })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-100 no-gutter' },
                      _react2.default.createElement(_common.Text, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD:', className: 'col-25 mb10', value: Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : '' }),
                      _react2.default.createElement(_common.Text, { label: 'Ng\xE0y ban h\xE0nh:', className: 'col-25 mb10', value: Data.ngayBanHanhQuyetDinhXuLy ? (0, _moment2.default)(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : '' })
                    ),
                    _react2.default.createElement(_common.TextMessage, { label: 'T\xF3m t\u1EAFt k\u1EBFt lu\u1EADn ' + loaiCuocText + ':', className: 'col-100 mb10', value: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: true },
            _react2.default.createElement(
              'div',
              { className: 'pl20 pr20' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-big-line' },
                _react2.default.createElement('div', { className: 'big-border' })
              ),
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pt15 pb15 ' + (this.state.showThongTinTheoDoi ? "collapse-open" : "collapse-close") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showThongTinTheoDoi') },
                  '2. Th\xF4ng tin theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { className: 'wrap-collapses', isOpen: this.state.showThongTinTheoDoi },
                _react2.default.createElement(
                  'div',
                  { className: 'mb15' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.1. V\u0103n b\u1EA3n ch\u1EC9 \u0111\u1EA1o c\u1EE7a c\u1EA5p tr\xEAn'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n', triggeOnBlur: true, bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.soVanBanChiDaoCuaCapTren, onChange: this.onChange.bind(this, 'soVanBanChiDaoCuaCapTren'), name: 'soVanBanChiDaoCuaCapTren', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh', triggeOnBlur: true, bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.ngayBanHanhVanBanChiDaoCuaCapTren, endDate: new Date(), onChange: this.handleChangeDate.bind(this, 'ngayBanHanhVanBanChiDaoCuaCapTren'), name: 'ngayBanHanhVanBanChiDaoCuaCapTren' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh', data: this.state.dataDonViBanHanh, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.coQuanBanHanhChiDaoCuaCapTren, onChange: this.onChange.bind(this, 'coQuanBanHanhChiDaoCuaCapTren'), name: 'coQuanBanHanhChiDaoCuaCapTren' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100 mb10', label: 'Ghi ch\xFA', value: this.state.ghiChuVanBanChiDaoCuaCapTren, onChange: this.onChange.bind(this, 'ghiChuVanBanChiDaoCuaCapTren'), name: 'ghiChuVanBanChiDaoCuaCapTren', maxLength: 1000 })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    phanLoaiQuyTrinh: 'CHI_DAO_CAP_TREN',
                    name: 'vanBanChiDaoCuaCapTren',
                    labelClass: 'title-12',
                    loaiVanBanSuggest: 'CHI_DAO_CAP_TREN',
                    soVanBanSuggest: this.state.soVanBanChiDaoCuaCapTren,
                    ngayQuyetDinhSuggest: this.state.ngayBanHanhVanBanChiDaoCuaCapTren,
                    label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    bindValidator: this,
                    data: this.state.listTaiLieuChiDaoCuaCapTren,
                    onFileRemove: this.onFileRemove.bind(this),
                    onFileChange: this.onFileChange.bind(this) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pt10 pb20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.2. V\u0103n b\u1EA3n b\xE1o c\xE1o k\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn ',
                    loaiCuocText
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n', bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra, onChange: this.onChange.bind(this, 'soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra'), name: 'soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh', bindValidator: this, endDate: new Date(), require: true, channel: 'formTaoDon', value: this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT'), name: 'ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh', data: this.state.dataDonViBanHanh, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra, onChange: this.onChange.bind(this, 'coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra'), name: 'coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100 mb10', label: 'Ghi ch\xFA', value: this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra, onChange: this.onChange.bind(this, 'ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra'), name: 'ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra', maxLength: 1000 })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    name: 'ketQuaThucHienKetLuanThanhTra',
                    phanLoaiQuyTrinh: 'KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA',
                    labelClass: 'title-12',
                    label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    bindValidator: this,
                    data: this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra,
                    onFileRemove: this.onFileRemove.bind(this),
                    onFileChange: this.onFileChange.bind(this) })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pt10 pb20' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'section',
                  { className: 'wrap-block pb10' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.3. K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn ',
                    loaiCuocText
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl15 pr15' },
                    _react2.default.createElement(_subView.NoiDungKienNghi, { setEnableKetThuc: this.setEnableKetThuc.bind(this), linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '', chucNangCuocThanhTra: Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '', listDoiTuongViPham: this.state.listDoiTuongViPham, onRef: function onRef(noiDungKienNghi) {
                        return _this11.noiDungKienNghi = noiDungKienNghi;
                      }, type: this.state.type, id: this.state.id })
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.showFile },
                  _react2.default.createElement(_upload.ContainerFileDinhKem, {
                    labelClass: 'title-12',
                    name: 'taiLieuVanThuThanhTra',
                    label: '2.4. Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                    bindValidator: this,
                    data: this.state.listTaiLieuVanThuThanhTra,
                    dataShow: this.state.listTaiLieuVanThuThanhTraView,
                    onFileRemove: this.onFileRemove.bind(this),
                    onFileChange: this.onFileChange.bind(this) })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pl0 pr0 pt35 pb5' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: this.handleBack.bind(this, false, 'close') },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable' : "btn-action btn-save action-todo", onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u t\u1EA1m'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.enableKetThuc },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: this.state.btnLoading ? this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline' : "btn-action btn-complete action-todo", onClick: this.openDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u h\u1ED3 s\u01A1'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.showDoiTuongThanhTra,
            onClose: this.hideDoiTuongThanhTra.bind(this),
            title: 'Th\xF4ng tin \u0111\u1ED1i t\u01B0\u1EE3ng ' + loaiCuocText,
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0' },
            _react2.default.createElement(
              'div',
              { className: 'row pl15 pr15' },
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:', value: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Nh\xF3m \u0111\u1ED1i t\u01B0\u1EE3ng:', value: Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo.ten ? Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\u1ECBa ch\u1EC9:', value: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.diaChi : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Ghi ch\xFA:', value: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.ghiChu : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:', value: Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'Ng\xE0nh/L\u0129nh v\u1EF1c:', value: Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo.ten : '' }),
              _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i:', value: Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.soDienThoai ? Data.doiTuongThanhTraInfo.soDienThoai : '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.hideDoiTuongThanhTra.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpenConfirm,
            onClose: this.closeDialog.bind(this),
            title: 'X\xE1c nh\u1EADn l\u01B0u h\u1ED3 s\u01A1',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0' },
            _react2.default.createElement(
              'p',
              { className: 'reception-dialog-text' },
              'B\u1EA1n c\xF3 mu\u1ED1n l\u01B0u h\u1ED3 s\u01A1 n\xE0y?'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100 mt20' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-green action-todo', onClick: this.handleKetThuc.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        ),
        _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: Data, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this) })
      );
    }
  }]);

  return XuLyTheoDoiThucHien;
}(_react2.default.Component);

XuLyTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'DOT_XUAT'
};

exports.default = XuLyTheoDoiThucHien;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _CheckPermission = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(14);

var _dialog = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDanhSachTheoDoiThucHien = function (_React$Component) {
  _inherits(RowItemDanhSachTheoDoiThucHien, _React$Component);

  function RowItemDanhSachTheoDoiThucHien(props) {
    _classCallCheck(this, RowItemDanhSachTheoDoiThucHien);

    var _this = _possibleConstructorReturn(this, (RowItemDanhSachTheoDoiThucHien.__proto__ || Object.getPrototypeOf(RowItemDanhSachTheoDoiThucHien)).call(this, props));

    _this.state = {
      chiTietDT: false
    };
    return _this;
  }

  _createClass(RowItemDanhSachTheoDoiThucHien, [{
    key: 'toggleDialog',
    value: function toggleDialog(status) {
      this.setState({ chiTietDT: status });
    }
  }, {
    key: 'render',
    value: function render() {
      var Data = this.props.item || {};
      var tenCuocThanhTra = '';
      if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenCuocThanhTra = Data.listDoiTuongThanhTra[0].ten;
      } else if (Data && Data.tenNhieuDoiTuongThanhTra) {
        tenCuocThanhTra = Data.tenNhieuDoiTuongThanhTra;
      }
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'list-items-table' },
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'txt-underline txt-regular', onClick: this.toggleDialog.bind(this, true) },
                this.props.item.ten
              ),
              _react2.default.createElement(_dialog.ChiTietDoiTuongThanhTraDialog, { name: 'chiTietDT', data: this.props.item, open: this.state.chiTietDT, onClose: this.toggleDialog.bind(this, false) })
            ),
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(Data, 'listDoiTuongThanhTra.length'),
              ' \u0111\u1ED1i t\u01B0\u1EE3ng'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'txt-underline txt-regular', to: '/theo-doi-thuc-hien/chi-tiet/' + (0, _lodash.get)(Data, 'cuocThanhTraId') },
            (0, _lodash.get)(Data, 'noiDungThanhTra')
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(Data, 'hinhThucThanhTraInfo.text')
            ),
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(Data, 'loaiHinhThanhTraInfo.text')
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              (0, _lodash.get)(Data, 'soQuyetDinhVeViecThanhTra')
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.ngayRaQuyetDinh ? (0, _moment2.default)(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ngayChuyenTheoDoiThucHien ? (0, _moment2.default)(this.props.item.ngayChuyenTheoDoiThucHien).format('DD/MM/YYYY') : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.soKetLuanThanhTra ? this.props.item.soKetLuanThanhTra : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tienDoThanhTraInfo ? this.props.item.tienDoThanhTraInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: ((0, _CheckPermission.CheckPermission)('THEO_DOI_THUC_HIEN_SUA') || (0, _CheckPermission.CheckPermission)('THEO_DOI_THUC_HIEN_LIETKE')) && (0, _lodash.get)(Data, 'tienDoThanhTra') !== 'LUU_HO_SO' },
            _react2.default.createElement(
              'div',
              { className: 'todo-wrap two-item' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-redirect', to: '/theo-doi-thuc-hien/xu-ly/' + (0, _lodash.get)(Data, 'cuocThanhTraId') },
                'X\u1EED l\xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDanhSachTheoDoiThucHien;
}(_react2.default.Component);

exports.default = RowItemDanhSachTheoDoiThucHien;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _dialog = __webpack_require__(18);

var _core = __webpack_require__(7);

var _subView = __webpack_require__(197);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDoiTuongThanhTra = function (_React$Component) {
  _inherits(RowItemDoiTuongThanhTra, _React$Component);

  function RowItemDoiTuongThanhTra(props, context) {
    _classCallCheck(this, RowItemDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (RowItemDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(RowItemDoiTuongThanhTra)).call(this, props, context));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemDoiTuongThanhTra, [{
    key: 'handleEdit',
    value: function handleEdit() {
      this.props.handleEdit(this.props.item.doiTuongViPhamId);
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'handleView',
    value: function handleView() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'getThoiHan',
    value: function getThoiHan() {
      var thoiHanXuLy = this.props.item.tinhTrangThoiHanInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'span',
            { className: 'txt-bold', style: { color: "#E9573F" } },
            '\u0110\xE3 h\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'span',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'span',
            { className: 'txt-bold', style: { color: "#E9573F" } },
            '\u0110\xE3 h\u1EBFt h\u1EA1n'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'span',
          { className: 'txt-bold', style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.linhVucKetQuaThanhTra.ten ? this.props.item.linhVucKetQuaThanhTra.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.tienDo != 'HOAN_THANH' },
            _react2.default.createElement(
              'p',
              null,
              this.props.item.ngayHetHanTheoTienDo ? (0, _moment2.default)(this.props.item.ngayHetHanTheoTienDo).format('DD/MM/YYYY') : '',
              '(',
              this.getThoiHan(),
              ')'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tienDoInfo ? this.props.item.tienDoInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.tienDo != 'HOAN_THANH' && this.props.view != true },
            _react2.default.createElement(
              'div',
              { className: 'todo-wrap two-item' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', onClick: this.handleEdit.bind(this) },
                  'X\u1EED l\xFD'
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.props.enableDelete == true },
                _react2.default.createElement(_dialog.DeleteDialog, {
                  title: 'Xác nhận',
                  content: 'B\u1EA1n c\xF3 \u0111\u1ED3ng \xFD x\xF3a \u0111\u1ED1i t\u01B0\u1EE3ng vi ph\u1EA1m n\xE0y kh\xF4ng?',
                  redux: this.props.parent,
                  deleteId: this.props.item.doiTuongViPhamId
                })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.tienDo == 'HOAN_THANH' || this.props.view == true },
            _react2.default.createElement(
              'div',
              { className: 'todo-wrap two-item' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'text-13 txt-blue', onClick: this.handleView.bind(this) },
                  'Xem chi ti\u1EBFt'
                )
              ),
              _react2.default.createElement(
                _core.Dialog,
                {
                  isOpen: this.state.isOpen,
                  onClose: this.closeDialog.bind(this),
                  title: 'Chi ti\u1EBFt \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.props.item.ten ? this.props.item.ten : ''),
                  className: 'dialog-default wrap-block' },
                _react2.default.createElement(_subView.DoiTuongKienNghiView, { toChucLienQuan: this.props.toChucLienQuan, data: this.props.item, type: this.props.type, closeDialog: this.closeDialog.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, linhVucThanhTra: this.props.linhVucThanhTra })
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemDoiTuongThanhTra;
}(_react2.default.Component);

RowItemDoiTuongThanhTra.defaultProps = {
  handleEdit: function handleEdit() {
    console.log('Need append handleEdit menthod');
  },
  enableDelete: false
};

exports.default = RowItemDoiTuongThanhTra;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _subView = __webpack_require__(197);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemDoiTuongThanhTraView = function (_React$Component) {
  _inherits(RowItemDoiTuongThanhTraView, _React$Component);

  function RowItemDoiTuongThanhTraView(props, context) {
    _classCallCheck(this, RowItemDoiTuongThanhTraView);

    var _this = _possibleConstructorReturn(this, (RowItemDoiTuongThanhTraView.__proto__ || Object.getPrototypeOf(RowItemDoiTuongThanhTraView)).call(this, props, context));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(RowItemDoiTuongThanhTraView, [{
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'handleView',
    value: function handleView() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'getThoiHan',
    value: function getThoiHan() {
      var thoiHanXuLy = this.props.item.tinhTrangThoiHanInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'span',
            { className: 'txt-bold', style: { color: "#E9573F" } },
            '\u0110\xE3 h\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'span',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'span',
            { className: 'txt-bold', style: { color: "#E9573F" } },
            '\u0110\xE3 h\u1EBFt h\u1EA1n'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'span',
          { className: 'txt-bold', style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ten ? this.props.item.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.linhVucKetQuaThanhTra.ten ? this.props.item.linhVucKetQuaThanhTra.ten : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.item.tienDo != 'HOAN_THANH' },
            _react2.default.createElement(
              'p',
              null,
              this.props.item.ngayHetHanTheoTienDo ? (0, _moment2.default)(this.props.item.ngayHetHanTheoTienDo).format('DD/MM/YYYY') : '',
              '(',
              this.getThoiHan(),
              ')'
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.tienDoInfo ? this.props.item.tienDoInfo.text : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              'div',
              { className: 'wrap-link-todo' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'text-13 txt-blue', onClick: this.handleView.bind(this) },
                'Xem chi ti\u1EBFt'
              )
            ),
            _react2.default.createElement(
              _core.Dialog,
              {
                isOpen: this.state.isOpen,
                onClose: this.closeDialog.bind(this),
                title: 'Chi ti\u1EBFt \u0111\u1ED1i t\u01B0\u1EE3ng ' + (this.props.item.ten ? this.props.item.ten : ''),
                className: 'dialog-default wrap-block' },
              _react2.default.createElement(_subView.DoiTuongKienNghiView, { toChucLienQuan: this.props.toChucLienQuan, data: this.props.item, type: this.props.type, closeDialog: this.closeDialog.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, linhVucThanhTra: this.props.linhVucThanhTra })
            )
          )
        )
      );
    }
  }]);

  return RowItemDoiTuongThanhTraView;
}(_react2.default.Component);

RowItemDoiTuongThanhTraView.defaultProps = {
  handleEdit: function handleEdit() {
    console.log('Need append handleEdit menthod');
  }
};

exports.default = RowItemDoiTuongThanhTraView;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _dialog = __webpack_require__(18);

var _reactTextTruncate = __webpack_require__(50);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _CheckQuyenThaoTacXuLy = __webpack_require__(111);

var _CheckQuyenTuXuLy = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemTDTHGQD = function (_React$Component) {
  _inherits(RowItemTDTHGQD, _React$Component);

  function RowItemTDTHGQD(props, context) {
    _classCallCheck(this, RowItemTDTHGQD);

    var _this = _possibleConstructorReturn(this, (RowItemTDTHGQD.__proto__ || Object.getPrototypeOf(RowItemTDTHGQD)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: '',
      alias: ''
    };
    return _this;
  }

  _createClass(RowItemTDTHGQD, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (this.props.item.trangThaiDonInfo) {
        this.props.item.trangThaiDonInfo.filter(function (item) {
          return item.donViId == userInfo.donViId;
        }).map(function (child, i) {
          _this2.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType
          });
        });
      }
      this.getCurrentForm(this.props.item.donId);
    }
  }, {
    key: 'getLocal',
    value: function getLocal(diachi) {
      var dungDon = [];
      if (diachi.diaChi) {
        dungDon.push(diachi.diaChi);
      }
      if (diachi.toThon) {
        dungDon.push(diachi.toThon);
      }
      if (diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
        dungDon.push(diachi.phuongXaCongDan.ten);
      }
      if (diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
        dungDon.push(diachi.quanHuyenCongDan.ten);
      }
      if (diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
        dungDon.push(diachi.tinhThanhCongDan.ten);
      }
      return dungDon.join(", ");
    }
  }, {
    key: 'showThongTinCongDan',
    value: function showThongTinCongDan() {
      var size = this.props.item.listNguoiDungDon.length;

      if (size) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'li',
            { className: 'txt-bold' },
            this.props.item.listNguoiDungDon[0].hoVaTen
          ),
          _react2.default.createElement(
            'li',
            null,
            this.getLocal(this.props.item.listNguoiDungDon[0])
          ),
          _react2.default.createElement(
            'li',
            null,
            this.props.item.listNguoiDungDon[0].soDienThoai
          )
        );
      }
    }
  }, {
    key: 'showThoiHanXuLyDon',
    value: function showThoiHanXuLyDon() {
      var _this3 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var thoiHanXuLy = {};
      if (this.checkDonViTTXM() && this.state.ketQuaType == 'DANG_LAP_DU_THAO') {
        thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {
        thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
      } else {
        if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
          thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
        } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userInfo.donViId) {

          this.props.item.trangThaiDonInfo.filter(function (item) {
            return item.donViId == userInfo.donViId;
          }).map(function (child, i) {

            if (child.trangThaiDonType == 'DANG_XU_LY') thoiHanXuLy = _this3.props.item.thoiHanXuLyInfo;
            if (child.trangThaiDonType == 'DANG_GIAI_QUYET') thoiHanXuLy = _this3.props.item.thoiHanGiaiQuyetInfo;
          });
        }
      }

      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'showThoiHanLapDuThao',
    value: function showThoiHanLapDuThao() {
      var thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm(donId) {
      var _this4 = this;

      _api.LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(function (res) {
        if (res.data) {
          var info = res.data;
          _this4.setState({
            alias: info.currentForm.alias
          });
        }
      });
    }
  }, {
    key: 'getListData',
    value: function getListData() {
      this.props.getListData();
    }
  }, {
    key: 'checkNguonDon',
    value: function checkNguonDon(type) {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var nguonDonText = '';
      var nguonDonDonVi = '';
      var nguonDontype = '';
      var Return = '';
      if (this.props.item.nguonDonInfo) {
        var dataNguonDon = this.props.item.nguonDonInfo.filter(function (nguonDon) {
          return nguonDon.idDonVi == userInfo.donViId;
        });

        if (dataNguonDon.length > 0) {
          nguonDonText = dataNguonDon[0].nguonDonText;
          nguonDonDonVi = dataNguonDon[0].donViChuyenText;
          nguonDontype = dataNguonDon[0].type;
        } else {
          nguonDonText = this.props.item.nguonDonText;
          nguonDonDonVi = '';
          nguonDontype = '';
        }
      }
      if (type == 'nguonDonText') {
        Return = nguonDonText;
      }
      if (type == 'nguonDonDonVi') {
        Return = nguonDonDonVi;
      }
      if (type == 'nguonDontype') {
        Return = nguonDontype;
      }
      return Return;
    }
  }, {
    key: 'checkAllowHandle',
    value: function checkAllowHandle() {
      var pass = (0, _CheckQuyenThaoTacXuLy.CheckQuyenThaoTacXuLy)(this.props.item.canBoDangXuLyInfo);
      return pass;
    }
  }, {
    key: 'getThoiHanThamTraXacMinh',
    value: function getThoiHanThamTraXacMinh() {
      var thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      if (thoiHanXuLy.type == 'DAY') {

        if (thoiHanXuLy.value == 0) {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'H\u1EBFt h\u1EA1n'
          );
        } else if (thoiHanXuLy.value > 0) {
          return _react2.default.createElement(
            'p',
            null,
            'C\xF2n ',
            thoiHanXuLy.value,
            ' ng\xE0y'
          );
        } else {
          return _react2.default.createElement(
            'p',
            { style: { color: "#E9573F" } },
            'Tr\u1EC5 ',
            Math.abs(thoiHanXuLy.value),
            ' ng\xE0y'
          );
        }
      } else if (thoiHanXuLy.type == 'TIME') {
        return _react2.default.createElement(
          'p',
          { style: { color: "#E9573F" } },
          'C\xF2n ',
          thoiHanXuLy.value
        );
      }
    }
  }, {
    key: 'checkQuyenXuLy',
    value: function checkQuyenXuLy() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var pass = false;

      var dataCheck = this.props.item.quyenTuXuLyInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });

      if (dataCheck.length > 0) {
        pass = dataCheck[0].quyenTuXuLy;
      }

      return pass;
    }
  }, {
    key: 'checkQuyenBoSungThongTin',
    value: function checkQuyenBoSungThongTin() {
      var data = [].concat(_toConsumableArray(this.props.item.listLichSuCanBoXuLy));
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataCheck = data.filter(function (state) {
        return state.congChucId == userInfo.id;
      });

      if (dataCheck.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'checkDonViTTXM',
    value: function checkDonViTTXM() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var dataNguonDon = this.props.item.trangThaiDonInfo.filter(function (nguonDon) {
        return nguonDon.donViId == userInfo.donViId;
      });
      var allowHandle = this.checkAllowHandle();
      var donId = this.props.item.donId;
      var nextPage = '/theo-doi-thuc-hien-giai-quyet-don/' + (this.props.type == 'DA_GIAI_QUYET' ? 'da' : 'dang') + '/' + donId;
      if (this.state.alias == 'LanhDaoTDTHAction' || this.state.alias == 'CanBoNhapLieuTDTHAction' || this.state.alias == 'ThuHoiDonTDTHaction' || this.state.alias == '') {
        nextPage = '/theo-doi-thuc-hien-xu-ly-don/xem/' + (this.props.type == 'DA_GIAI_QUYET' ? 'da' : 'dang') + '/' + donId;
      }
      var donDate = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
      var donTime = this.props.item.ngayTiepNhan ? (0, _moment2.default)(this.props.item.ngayTiepNhan).format('HH:mm') : '';
      var thongTinCongDan = this.showThongTinCongDan();
      var nguonDonText = this.checkNguonDon('nguonDonText');
      var nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
      // let nguonDontype = this.checkNguonDon('nguonDontype');

      var loaiDonThu = this.props.dataLoaiDonThu.filter(function (state) {
        return state.giaTri == _this5.props.item.loaiDon;
      });

      var listCanBoGiaiQuyet = this.props.item.canBoDangXuLyInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });

      var trangThaiDon = this.props.item.trangThaiDonInfo.filter(function (state) {
        return state.donViId == userInfo.donViId;
      });
      return _react2.default.createElement(
        'tr',
        { ref: 'itemGQD' },
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ma ? this.props.item.ma : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              donDate
            ),
            _react2.default.createElement(
              'li',
              null,
              donTime
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            thongTinCongDan
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'txt-underline',
                  to: nextPage },
                _react2.default.createElement(_reactTextTruncate2.default, {
                  line: 3,
                  truncateText: '\u2026',
                  text: this.props.item.noiDung
                })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: (!this.checkDonViTTXM() || trangThaiDon[0].ketQuaType != 'DA_CO_KET_QUA_TTXM') && (!this.checkDonViTTXM() || trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DA_LAP_DU_THAO') && trangThaiDon[0].ketQuaType != 'LUU_HO_SO' },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanXuLyDon()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              'li',
              null,
              loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''
            ),
            _react2.default.createElement(
              'li',
              null,
              this.props.item.soNguoi ? this.props.item.soNguoi + ' người' : ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: nguonDonDonVi != '' && nguonDonDonVi != null },
              _react2.default.createElement(
                'li',
                { className: 'txt-italic' },
                nguonDonDonVi
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              nguonDonText
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.coQuanDaGiaiQuyetDonThu || ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'list-items-table' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                dataNguonDon.length > 0 ? dataNguonDon[0].trangThaiDonText : ''
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: dataNguonDon.length > 0 },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_common.TextMessage, { className: 'txt-italic col-100 no-gutter txt-left', value: dataNguonDon.length > 0 ? dataNguonDon[0].ketQuaType == 'DINH_CHI' ? 'Đình chỉ' : dataNguonDon[0].ketQuaStr : '' })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_TTXM' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.getThoiHanThamTraXacMinh()
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.ketQuaType == 'DANG_LAP_DU_THAO' && !this.checkDonViTTXM() },
              _react2.default.createElement(
                'li',
                null,
                this.showThoiHanLapDuThao()
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          listCanBoGiaiQuyet.length > 0 ? listCanBoGiaiQuyet[0].hoVaTen : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'todo-wrap two-item' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: allowHandle && this.props.type != 'DA_GIAI_QUYET' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: nextPage },
                  'X\u1EED l\xFD'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.tuGiaiQuyet && this.props.type == 'DA_GIAI_QUYET' && (0, _CheckQuyenTuXuLy.CheckQuyenTuXuLy)(this.props.item.quyenTuXuLyInfo) },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: '/tu-giai-quyet-theo-doi-thuc-hien/' + this.props.item.donId },
                  'T\u1EF1 x\u1EED l\xFD'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'DA_GIAI_QUYET' && this.props.item.canBoCoTheThuHoiInfo != null && this.props.item.canBoCoTheThuHoiInfo.giaTri == userInfo.id },
              _react2.default.createElement(_dialog.TruongPhongThuHoiDialog, { id: donId, thongTinGiaiQuyetDonId: this.props.item.thongTinGiaiQuyetDonId, loaiDon: this.props.item.loaiDon, getListData: this.getListData.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.item.huongXuLyXLD != 'DINH_CHI' && this.checkQuyenBoSungThongTin() && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType == 'LUU_HO_SO' && trangThaiDon.length > 0 && trangThaiDon[0].ketQuaType != 'DINH_CHI' },
              _react2.default.createElement(
                'div',
                { className: 'wrap-link-todo' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'itt-redirect', to: '/bo-sung-thong-tin-giai-quyet-don/' + this.props.item.donId },
                  'B\u1ED5 sung th\xF4ng tin'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RowItemTDTHGQD;
}(_react2.default.Component);

RowItemTDTHGQD.defaultProps = {
  dataLoaiDonThu: [],
  tuGiaiQuyet: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemTDTHGQD);

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _datatable = __webpack_require__(52);

var _ThemMoiDoiTuongThanhTra = __webpack_require__(1401);

var _ThemMoiDoiTuongThanhTra2 = _interopRequireDefault(_ThemMoiDoiTuongThanhTra);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachCuocThanhTra = function (_React$Component) {
  _inherits(DanhSachCuocThanhTra, _React$Component);

  function DanhSachCuocThanhTra(props, context) {
    _classCallCheck(this, DanhSachCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (DanhSachCuocThanhTra.__proto__ || Object.getPrototypeOf(DanhSachCuocThanhTra)).call(this, props, context));

    _this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucThanhTraList: [],
      donViChuTriList: [],
      allowDelete: true
    };
    return _this;
  }

  _createClass(DanhSachCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVucThanhTra();
      this.getDonViChuTri();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.data !== nextProps.data) {
        nextProps.data.cuocThanhTras.map(function (item) {
          if (item.tienDoThanhTraInfo !== null) {
            _this2.state.allowDelete = false;
          }
          _this2.state.data.push(item);
        });
        this.setState(_extends({}, this.state));
        this.props.onChange(this.state.data);
      }
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.state.linhVucThanhTraList = res.data;
        } else {
          _this3.state.linhVucThanhTraList = [];
        }
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this4 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data && res.data._embedded) {
          _this4.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
        } else {
          _this4.state.donViChuTriList = [];
        }
        _this4.setState(_extends({}, _this4.state));
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(item, index) {
      if (item.id) {
        this.props.onRemove(item.id);
      }
      this.state.data.splice(index, 1);
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'handleExportData',
    value: function handleExportData(data) {
      var _this5 = this;

      var idList = [];
      this.state.data.map(function (item) {
        idList.push(item.doiTuongThanhTraId);
      });
      data.map(function (item) {
        if (idList.indexOf(item.doiTuongThanhTraId) === -1) {
          var newItem = {
            doiTuongThanhTraInfo: item,
            noiDungThanhTra: '',
            donViChuTriInfo: {
              coQuanQuanLyId: '',
              ten: ''
            },
            donViPhoiHop: '',
            kyThanhTra: '',
            linhVucThanhTraInfo: {
              text: '',
              type: ''
            },
            thoiHanThanhTra: ''
          };
          _this5.state.data.push(newItem);
        }
        return;
      });
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'onSave',
    value: function onSave(data) {
      this.state.data.map(function (item) {
        if (item.doiTuongThanhTraInfo.doiTuongThanhTraId === data.doiTuongThanhTraInfo.doiTuongThanhTraId) {
          item = data;
        }
      });
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state.data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 heading-addnew-dttt' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 col-100 pt10 pl20 pr20 pb15' },
            '2. Danh s\xE1ch cu\u1ED9c thanh tra'
          ),
          _react2.default.createElement(_ThemMoiDoiTuongThanhTra2.default, { exportData: this.handleExportData.bind(this), importData: this.state.data, namThanhTra: this.props.namThanhTra })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10 ' },
          _react2.default.createElement(
            _dataTable2.default,
            { header: _table.header.thanhTra.DKKHTT, plusColum: 1, dataList: this.state.data, hideButtonExport: true, hidePagination: true, pageData: this.state.pageData, parent: this,
              tableLoading: this.state.tableLoading },
            _react2.default.createElement(_datatable.RowItemDanhSachCuocThanhTra, { allowDelete: this.state.allowDelete, onSave: this.onSave.bind(this) })
          )
        )
      );
    }
  }]);

  return DanhSachCuocThanhTra;
}(_react2.default.Component);

DanhSachCuocThanhTra.defaultProps = {
  data: {}
};

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(DanhSachCuocThanhTra);

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogChinhSuaCuocThanhTra = function (_React$Component) {
  _inherits(DialogChinhSuaCuocThanhTra, _React$Component);

  function DialogChinhSuaCuocThanhTra(props, context) {
    _classCallCheck(this, DialogChinhSuaCuocThanhTra);

    var _this = _possibleConstructorReturn(this, (DialogChinhSuaCuocThanhTra.__proto__ || Object.getPrototypeOf(DialogChinhSuaCuocThanhTra)).call(this, props, context));

    _this.state = {
      data: {
        doiTuongThanhTraInfo: {},
        noiDungThanhTra: '',
        donViChuTriInfo: {
          coQuanQuanLyId: '',
          ten: ''
        },
        donViPhoiHop: '',
        kyThanhTra: '',
        linhVucThanhTraInfo: {
          text: '',
          type: ''
        },
        thoiHanThanhTra: ''
      },
      linhVucList: [],
      dataDonViChuTri: [],
      danhSachDonViPhoiHop: [],
      donViPhoiHop: ''
    };
    return _this;
  }

  _createClass(DialogChinhSuaCuocThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVuc();
      this.getDonViChuTri();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data) {
        var arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(',') : [];
        var danhSachDonViPhoiHop = [];
        arrDv.map(function (item) {
          danhSachDonViPhoiHop.push({ ten: item });
          return item;
        });
        this.setState({
          data: nextProps.data,
          danhSachDonViPhoiHop: danhSachDonViPhoiHop
        });
      }
    }
  }, {
    key: 'getDonViChuTri',
    value: function getDonViChuTri() {
      var _this2 = this;

      _api.ThanhTra.actions.getDonViChuTri.request().then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            dataDonViChuTri: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getLinhVuc',
    value: function getLinhVuc() {
      var _this3 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.setState({ linhVucList: res.data });
        } else {
          _this3.setState({ linhVucList: [] });
        }
      });
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(arr, value, e) {
      var _this4 = this;

      if (typeof e !== 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state[arr]));

      var arrCheck = newArr.filter(function (state) {
        return state.ten === _this4.state[value];
      });

      if (this.state[value]) {
        if (arrCheck.length > 0) {
          this.setState(_defineProperty({}, value, ''));
        } else {
          var _setState2;

          var newItem = {
            ten: this.state[value]
          };
          this.setState((_setState2 = {}, _defineProperty(_setState2, arr, [].concat(_toConsumableArray(this.state[arr]), [newItem])), _defineProperty(_setState2, value, ''), _setState2));
        }
      }
      return;
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(arr, index) {
      var newData = [].concat(_toConsumableArray(this.state[arr]));
      newData.splice(index, 1);
      this.setState(_defineProperty({}, arr, newData));
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      this.state.dataDonViChuTri.map(function (item) {
        if (item.coQuanQuanLyId === _this5.state.data.donViChuTriInfo.coQuanQuanLyId) {
          _this5.setState({
            data: { donViChuTriInfo: { ten: item.ten } }
          });
        }
        return item.coQuanQuanLyId;
      });
      this.state.linhVucList.map(function (item) {
        if (item.giaTri === _this5.state.data.linhVucThanhTraInfo.type) {
          _this5.setState({
            data: { linhVucThanhTraInfo: { text: item.ten } }
          });
        }
        return item.giaTri;
      });
      var listDV = [];
      this.state.danhSachDonViPhoiHop.map(function (item) {
        listDV.push(item.ten);
        return item.ten;
      });
      this.setState({
        data: { donViPhoiHop: listDV.join(', ') }
      });
      this.props.onSave(this.state.data);
      this.props.onClose();
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name === 'linhVucThanhTra') {
        this.setState({
          data: { linhVucThanhTraInfo: { type: e.target.value } }
        });
      } else if (name === 'phamViThanhTra') {
        this.setState({
          data: { kyThanhTra: e.target.value }
        });
      } else if (name === 'thoiHanThanhTra') {
        this.setState({
          data: { thoiHanThanhTra: e.target.value }
        });
      } else if (name === 'noiDungThanhTra') {
        this.setState({
          data: { noiDungThanhTra: e.target.value }
        });
      } else if (name === 'donViChuTri') {
        this.setState({
          data: { donViChuTriInfo: { coQuanQuanLyId: e.target.value } }
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.props.isOpen,
          onClose: this.props.onClose,
          title: 'Ch\u1EC9nh s\u1EEDa cu\u1ED9c thanh tra',
          className: 'dialog-them-moi-dttt dialog-default wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 pt20 pb15' },
              '1. \u0110\u1ED1i t\u01B0\u1EE3ng thanh tra'
            )
          ),
          _react2.default.createElement(_common.TextMessage, { label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng:', className: 'col-40', value: this.state.data.doiTuongThanhTraInfo.ten || '' }),
          _react2.default.createElement(_common.TextMessage, { label: 'Lo\u1EA1i \u0111\u1ED1i t\u01B0\u1EE3ng:', className: 'col-20', value: this.state.data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : '' }),
          _react2.default.createElement(_common.TextMessage, { label: '\u0110\u1ECBa ch\u1EC9:', className: 'col-40', value: this.state.data.doiTuongThanhTraInfo.diaChi || '' }),
          _react2.default.createElement(_common.TextMessage, { label: 'Ng\xE0nh/L\u0129nh v\u1EF1c:', className: 'col-100 mt10', value: this.state.data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo.ten : '' }),
          _react2.default.createElement(_common.TextMessage, { label: 'Ghi ch\xFA:', className: 'col-100 mt10', value: this.state.data.doiTuongThanhTraInfo.ghiChu || '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement('span', { className: 'big-border mt10 mb20' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl30 pr30' },
          _react2.default.createElement(
            'div',
            { className: 'col-100' },
            _react2.default.createElement(
              'h2',
              { className: 'title-14 pb15' },
              '2. Th\xF4ng tin cu\u1ED9c thanh tra/ki\u1EC3m tra'
            )
          ),
          _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'L\u0129nh v\u1EF1c thanh tra', selectedValue: this.state.data.linhVucThanhTraInfo.type, onChange: this.onChange.bind(this, 'linhVucThanhTra'), name: 'linhVucThanhTra', placeholder: true,
            options: this.state.linhVucList, keyName: 'giaTri', valueName: 'ten', require: true }),
          _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi k\u1EF3 thanh tra', value: this.state.data.kyThanhTra, onChange: this.onChange.bind(this, 'phamViThanhTra'), name: 'phamViThanhTra', className: 'col-25', maxLength: 255 }),
          _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n l\xE0m vi\u1EC7c (ng\xE0y)', value: this.state.data.thoiHanThanhTra, onChange: this.onChange.bind(this, 'thoiHanThanhTra'), name: 'thoiHanThanhTra', className: 'col-25' }),
          _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung thanh tra', value: this.state.data.noiDungThanhTra, onChange: this.onChange.bind(this, 'noiDungThanhTra'), name: 'noiDungThanhTra', rows: 3, placeholder: 'Nh\u1EADp...', maxLength: 500 })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl15 pr15' },
          _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt20' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close', onClick: this.props.onClose },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\xF3ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-save', onClick: this.handleSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u01B0u'
              )
            )
          )
        )
      );
    }
  }]);

  return DialogChinhSuaCuocThanhTra;
}(_react2.default.Component);

DialogChinhSuaCuocThanhTra.defaultProps = {
  data: {}
};

exports.default = DialogChinhSuaCuocThanhTra;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _dialog = __webpack_require__(18);

var _toastr = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _ListDonDoc = __webpack_require__(319);

var _ListDonDoc2 = _interopRequireDefault(_ListDonDoc);

var _ListLanNopTien = __webpack_require__(320);

var _ListLanNopTien2 = _interopRequireDefault(_ListLanNopTien);

var _NoiDungKienNghiDoiTuongThanhTra = __webpack_require__(496);

var _NoiDungKienNghiDoiTuongThanhTra2 = _interopRequireDefault(_NoiDungKienNghiDoiTuongThanhTra);

var _style = __webpack_require__(269);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loaiQuyTrinh = 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA';

var DoiTuongKienNghi = function (_React$Component) {
  _inherits(DoiTuongKienNghi, _React$Component);

  function DoiTuongKienNghi(props, context) {
    _classCallCheck(this, DoiTuongKienNghi);

    var _this = _possibleConstructorReturn(this, (DoiTuongKienNghi.__proto__ || Object.getPrototypeOf(DoiTuongKienNghi)).call(this, props, context));

    _this.state = {
      dataDetail: {},
      style: _style2.default,
      showFile: true,
      action: false,
      isOpen: _this.props.isOpen,
      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      getThoiHanKiemTra: false,
      donDocChange: false,
      confirmDonDoc: false,
      showDialogConfirm: false,
      btnLoading: false,
      btnSaveLoading: false,
      enableTheoDoi: false,
      enableDonDoc: false,
      enableKiemTra: false,
      backConfirm: false,
      hasChange: false,

      idCuocThanhTra: _this.props.idCuocThanhTra,
      id: _this.props.id,

      ten: '',

      linhVucThanhTra: _this.props.linhVucThanhTra,
      listDoiTuongViPham: _this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: _this.props.chucNangCuocThanhTra,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataCoQuanDieuTraThanhTra: [],
      dataHinhThucKienNghi: [],

      listTaiLieuVanThuGiaHan: [],
      danhSachDonViPhoiHop: [],
      listTaiLieuVanThu: [],
      donViPhoiHop: '',
      trangThaiDoiTuongViPham: '',

      //data option

      dataKetQuaTheoDoiSaiPham: [],
      dataKetQuaChuyenCoQuanDieuTra: [],
      dataKetLuanVeNoiDungKiemTra: [],

      //Theo doi thuc hien
      theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiDatDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
      theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

      soQuyetDinhTheoDoiXuLyHanhChinh: '',

      theoDoiToChucCoSaiPham: '',
      theoDoiToChucCoSaiPhamInit: '',
      toChucTheoDoiSaiPham: '',

      theoDoiCaNhanCoSaiPham: '',
      theoDoiCaNhanCoSaiPhamInit: '',
      caNhanTheoDoiSaiPham: '',

      // xử lý về kinh tế

      tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

      listTheoDoiLanNopTien: [],

      lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

      lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamKhacTheoDoiXuLyVeKinhTe: '',

      // xử lý về hành chính
      theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',

      // xử lý về hình sự
      vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
      ketQuaChuyenCoQuanDieuTra: '',
      soVuViecTheoDoiXuLyHinhSu: '',

      soDoiTuongTheoDoiXuLyHinhSuInit: '',
      soDoiTuongTheoDoiXuLyHinhSu: '',

      ghiChuTheoDoiXuLyHinhSu: '',

      kienNghiTienTheoDoiXuLyKhac: '',
      kienNghiDatTheoDoiXuLyKhac: '',
      ketQuaThucHienTheoDoiXuLyKhac: '',
      // end theo dõi thực hiện

      // Kết quả kiểm tra

      soQuyetDinhKiemTra: '',
      ngayBanHanhKiemTra: '',
      ngayBatDauKiemTra: '',
      thoiHanKiemTra: '',
      ngayHetHanKiemTra: '',
      ngayHetHanKiemTraISO: '',
      canCuKiemTra: '',
      tinhHinhKiemTra: '',
      ketQuaKiemTra: '',
      linhVucKetQuaThanhTra: '',
      soKienNghiDaThucHienXong: null
      // end kết quả kiểm tra
    };
    return _this;
  }

  _createClass(DoiTuongKienNghi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCoQuanDieuTraThanhTra();
      this.getHinhThucKienNghi();
      this.ketQuaTheoDoiSaiPham();
      this.ketQuaChuyenCoQuanDieuTra();
      this.getKetLuanVeNoiDungKiemTra();
      if (this.state.id) {
        this.getChiTietDoiTuongTraThanhTra(this.state.id);
      }
    }
  }, {
    key: 'ketQuaChuyenCoQuanDieuTra',
    value: function ketQuaChuyenCoQuanDieuTra() {
      var _this2 = this;

      _api.ThanhTra.actions.ketQuaChuyenCoQuanDieuTra.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            dataKetQuaChuyenCoQuanDieuTra: res.data
          });
        }
      });
    }
  }, {
    key: 'ketQuaTheoDoiSaiPham',
    value: function ketQuaTheoDoiSaiPham() {
      var _this3 = this;

      _api.ThanhTra.actions.ketQuaTheoDoiSaiPham.request().then(function (res) {
        if (res.data) {
          _this3.setState({
            dataKetQuaTheoDoiSaiPham: res.data
          });
        }
      });
    }
  }, {
    key: 'getChiTietDoiTuongTraThanhTra',
    value: function getChiTietDoiTuongTraThanhTra(id) {
      var _this4 = this;

      _api.ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(function (res) {
        if (res.data) {
          _this4.setState({
            dataDetail: res.data,
            doiTuongViPhamId: res.data.doiTuongViPhamId,

            ten: res.data.ten,
            // theo doi thuc hien
            theoDoiTienDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '',
            theoDoiDatDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '',
            theoDoiTienDaThuTrongQuaTrinhThanhTra: res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra : '',
            theoDoiDatDaThuTrongQuaTrinhThanhTra: res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra : '',

            soQuyetDinhTheoDoiXuLyHanhChinh: res.data.soQuyetDinhTheoDoiXuLyHanhChinh ? res.data.soQuyetDinhTheoDoiXuLyHanhChinh : '',

            theoDoiToChucCoSaiPham: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
            theoDoiToChucCoSaiPhamInit: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
            toChucTheoDoiSaiPham: res.data.toChucTheoDoiSaiPham ? res.data.toChucTheoDoiSaiPham : '',

            theoDoiCaNhanCoSaiPham: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
            theoDoiCaNhanCoSaiPhamInit: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
            caNhanTheoDoiSaiPham: res.data.caNhanTheoDoiSaiPham ? res.data.caNhanTheoDoiSaiPham : '',

            listTheoDoiLanNopTien: res.data.listTheoDoiLanNopTien ? res.data.listTheoDoiLanNopTien : [],

            tongSoTienThuHoiTheoDoiXuLyVeKinhTe: res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '',

            lyDoThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe : '',

            saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '',
            saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '',
            saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '',

            lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '',

            saiPhamKhacTheoDoiXuLyVeKinhTe: res.data.saiPhamKhacTheoDoiXuLyVeKinhTe ? res.data.saiPhamKhacTheoDoiXuLyVeKinhTe : '',

            vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '',
            ketQuaChuyenCoQuanDieuTra: res.data.ketQuaChuyenCoQuanDieuTra ? res.data.ketQuaChuyenCoQuanDieuTra : '',

            soVuViecTheoDoiXuLyHinhSu: res.data.soVuViecTheoDoiXuLyHinhSu ? res.data.soVuViecTheoDoiXuLyHinhSu : '',

            soDoiTuongTheoDoiXuLyHinhSu: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',
            soDoiTuongTheoDoiXuLyHinhSuInit: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',

            ghiChuTheoDoiXuLyHinhSu: res.data.ghiChuTheoDoiXuLyHinhSu ? res.data.ghiChuTheoDoiXuLyHinhSu : '',

            kienNghiTienTheoDoiXuLyKhac: res.data.kienNghiTienTheoDoiXuLyKhac ? res.data.kienNghiTienTheoDoiXuLyKhac : '',
            kienNghiDatTheoDoiXuLyKhac: res.data.kienNghiDatTheoDoiXuLyKhac ? res.data.kienNghiDatTheoDoiXuLyKhac : '',
            ketQuaThucHienTheoDoiXuLyKhac: res.data.ketQuaThucHienTheoDoiXuLyKhac ? res.data.ketQuaThucHienTheoDoiXuLyKhac : '',

            listTaiLieuVanThu: res.data.listTaiLieuVanThu,

            //end theo doi

            // ket qua kiem tra
            soQuyetDinhKiemTra: res.data.soQuyetDinhKiemTra ? res.data.soQuyetDinhKiemTra : '',
            ngayBanHanhKiemTra: res.data.ngayBanHanhKiemTra ? new Date(res.data.ngayBanHanhKiemTra) : '',
            ngayBatDauKiemTra: res.data.ngayBatDauKiemTra ? new Date(res.data.ngayBatDauKiemTra) : '',
            thoiHanKiemTra: res.data.thoiHanKiemTra ? res.data.thoiHanKiemTra : 0,
            ngayHetHanKiemTra: res.data.ngayHetHanKiemTra ? (0, _moment2.default)(res.data.ngayHetHanKiemTra).format('DD/MM/YYYY') : '',
            ngayHetHanKiemTraISO: res.data.ngayHetHanKiemTra ? res.data.ngayHetHanKiemTra : null,
            canCuKiemTra: res.data.canCuKiemTra ? res.data.canCuKiemTra : '',
            tinhHinhKiemTra: res.data.tinhHinhKiemTra ? res.data.tinhHinhKiemTra : '',
            ketQuaKiemTra: res.data.ketQuaKiemTra ? res.data.ketQuaKiemTra : '',
            linhVucKetQuaThanhTra: res.data.linhVucKetQuaThanhTra ? res.data.linhVucKetQuaThanhTra.giaTri : '',

            // Kiến nghị xử lý hành chính
            theoDoiKienNghiXuLyHanhChinhToChucBangTien: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '',
            theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '',
            theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '',
            theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '',
            soKienNghiDaThucHienXong: res.data.soKienNghiDaThucHienXong ? res.data.soKienNghiDaThucHienXong : null
          }, function () {
            _this4.checkTienDo();
          });
        }
      });
    }
  }, {
    key: 'checkTienDo',
    value: function checkTienDo() {
      var DataDetail = _extends({}, this.state.dataDetail);
      if (DataDetail.tinhTrangThoiHanInfo && DataDetail.tinhTrangThoiHanInfo.type === 'DAY' && DataDetail.tinhTrangThoiHanInfo.value < 1) {
        switch (DataDetail.tienDo) {
          case 'THEO_DOI':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: false
            });
            break;
          case 'DON_DOC':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
          case 'HOAN_THANH':
          case 'KIEM_TRA':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
        }
      } else {
        switch (DataDetail.tienDo) {
          case 'THEO_DOI':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: false,
              enableKiemTra: false
            });
            break;
          case 'DON_DOC':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: false
            });
            break;
          case 'HOAN_THANH':
          case 'KIEM_TRA':
            this.setState({
              enableTheoDoi: true,
              enableDonDoc: true,
              enableKiemTra: true
            });
            break;
        }
      }
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      var params = this.state.dataDetail;
      if (this.state.listTheoDoiLanNopTien.length > 0) {
        var listTheoDoiLanNopTien = [];
        this.state.listTheoDoiLanNopTien.map(function (state) {
          var item = {
            ngayNopTien: state.ngayNopTien ? (0, _moment2.default)(new Date(state.ngayNopTien)).add(7, 'hours').toISOString() : null,
            soTien: state.soTien ? state.soTien : '',
            tongCong: state.tongCong ? state.tongCong : '',
            conPhaiThu: state.conPhaiThu ? state.conPhaiThu : ''
          };

          listTheoDoiLanNopTien[listTheoDoiLanNopTien.length] = item;
        });
        params.listTheoDoiLanNopTien = listTheoDoiLanNopTien;
      } else {
        params.listTheoDoiLanNopTien = [];
      }

      params.id = this.state.id;

      params.cuocThanhTra = {
        id: Number(this.state.idCuocThanhTra)
      };
      params.theoDoiTienDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '';
      params.theoDoiDatDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '';

      params.theoDoiTienDaThuTrongQuaTrinhThanhTra = this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra : '';
      params.theoDoiDatDaThuTrongQuaTrinhThanhTra = this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra : '';

      params.soQuyetDinhTheoDoiXuLyHanhChinh = this.state.soQuyetDinhTheoDoiXuLyHanhChinh ? this.state.soQuyetDinhTheoDoiXuLyHanhChinh : '';

      params.theoDoiToChucCoSaiPham = this.state.theoDoiToChucCoSaiPham ? this.state.theoDoiToChucCoSaiPham : '';
      params.toChucTheoDoiSaiPham = this.state.toChucTheoDoiSaiPham ? this.state.toChucTheoDoiSaiPham : null;

      params.theoDoiCaNhanCoSaiPham = this.state.theoDoiCaNhanCoSaiPham ? this.state.theoDoiCaNhanCoSaiPham : '';
      params.caNhanTheoDoiSaiPham = this.state.caNhanTheoDoiSaiPham ? this.state.caNhanTheoDoiSaiPham : null;

      // xử lý về kinh tế

      params.tongSoTienThuHoiTheoDoiXuLyVeKinhTe = this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '';

      params.lyDoThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe : '';

      params.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '';
      params.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '';
      params.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '';

      params.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '';

      params.saiPhamKhacTheoDoiXuLyVeKinhTe = this.state.saiPhamKhacTheoDoiXuLyVeKinhTe ? this.state.saiPhamKhacTheoDoiXuLyVeKinhTe : '';

      // xử lý về hình sự
      params.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu = this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '';
      params.ketQuaChuyenCoQuanDieuTra = this.state.ketQuaChuyenCoQuanDieuTra ? this.state.ketQuaChuyenCoQuanDieuTra : null;

      params.soVuViecTheoDoiXuLyHinhSu = this.state.soVuViecTheoDoiXuLyHinhSu ? this.state.soVuViecTheoDoiXuLyHinhSu : '';

      params.soDoiTuongTheoDoiXuLyHinhSu = this.state.soDoiTuongTheoDoiXuLyHinhSu ? this.state.soDoiTuongTheoDoiXuLyHinhSu : '';

      params.ghiChuTheoDoiXuLyHinhSu = this.state.ghiChuTheoDoiXuLyHinhSu ? this.state.ghiChuTheoDoiXuLyHinhSu : '';

      params.kienNghiTienTheoDoiXuLyKhac = this.state.kienNghiTienTheoDoiXuLyKhac ? this.state.kienNghiTienTheoDoiXuLyKhac : '';
      params.kienNghiDatTheoDoiXuLyKhac = this.state.kienNghiDatTheoDoiXuLyKhac ? this.state.kienNghiDatTheoDoiXuLyKhac : '';
      params.ketQuaThucHienTheoDoiXuLyKhac = this.state.ketQuaThucHienTheoDoiXuLyKhac ? this.state.ketQuaThucHienTheoDoiXuLyKhac : '';

      // ket qua kiem tra

      params.soQuyetDinhKiemTra = this.state.soQuyetDinhKiemTra ? this.state.soQuyetDinhKiemTra : '';
      params.ngayBanHanhKiemTra = this.state.ngayBanHanhKiemTra ? (0, _moment2.default)(this.state.ngayBanHanhKiemTra).add(7, 'hours').toISOString() : null;
      params.ngayBatDauKiemTra = this.state.ngayBatDauKiemTra ? (0, _moment2.default)(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString() : null;
      params.thoiHanKiemTra = this.state.thoiHanKiemTra ? this.state.thoiHanKiemTra : 0;
      params.ngayHetHanKiemTra = this.state.ngayHetHanKiemTraISO ? this.state.ngayHetHanKiemTraISO : null;
      params.canCuKiemTra = this.state.canCuKiemTra ? this.state.canCuKiemTra : '';
      params.tinhHinhKiemTra = this.state.tinhHinhKiemTra ? this.state.tinhHinhKiemTra : '';
      params.ketQuaKiemTra = this.state.ketQuaKiemTra ? this.state.ketQuaKiemTra : null;
      params.linhVucKetQuaThanhTra = this.state.linhVucKetQuaThanhTra ? this.state.linhVucKetQuaThanhTra : '';

      // Xử lý về hành chính
      params.theoDoiKienNghiXuLyHanhChinhToChucBangTien = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '';
      params.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '';
      params.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '';
      params.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '';
      params.soKienNghiDaThucHienXong = this.state.soKienNghiDaThucHienXong ? this.state.soKienNghiDaThucHienXong : null;

      delete params['_links'];
      delete params['nguoiSuaInfo'];
      delete params['nguoiTaoInfo'];
      delete params['ngaySua'];
      delete params['ngayTao'];
      delete params['cuocThanhTraId'];
      delete params['doiTuongViPhamId'];
      delete params['listTaiLieuVanThuChuyenCoQuanDieuTra'];
      delete params['listTaiLieuVanThuKienNghiXuLyKhac'];
      delete params['trangThaiDoiTuongViPhamInfo'];
      delete params['coQuanDieuTraThanhTraInfo'];
      delete params['loaiDoiTuongInfo'];
      delete params['tienDoInfo'];
      delete params['tinhTrangThoiHanInfo'];
      delete params['toChucTheoDoiSaiPhamInfo'];
      delete params['caNhanTheoDoiSaiPhamInfo'];
      delete params['coQuanDieuTraInfo'];
      delete params['ketQuaChuyenCoQuanDieuTraInfo'];
      delete params['ketQuaKiemTraInfo'];
      delete params['donDocDoiTuongs'];
      delete params['listTaiLieuVanThu'];
      delete params['theoDoiLanNopTien'];

      return params;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this5 = this;

      var params = this.getParams();
      this.pushTaiLieu(this.state.doiTuongViPhamId);
      this.setState({
        showNoiDungKienNghi: true,
        showNoiDungTheoDoi: true,
        showNoiDungDonDoc: true,
        showNoiDungKiemTra: true,
        btnLoading: true,
        btnSaveLoading: true
      }, function () {
        if (_this5.state.enableDonDoc) {
          _this5.donDoc.handleSave(function () {
            _this5.updateDoiTuongViPham(params);
          });
        } else {
          _this5.updateDoiTuongViPham(params);
        }
      });
    }
  }, {
    key: 'handleKetThuc',
    value: function handleKetThuc() {
      var _this6 = this;

      this.setState({
        showNoiDungKienNghi: true,
        showNoiDungTheoDoi: true,
        showNoiDungDonDoc: true,
        showNoiDungKiemTra: true
      }, function () {
        var self = _this6;
        setTimeout(function () {
          if (self.validateSubmitForm()) {
            self.setState({
              showDialogConfirm: true
            });
          }
        }, 100);
      });
    }
  }, {
    key: 'closeDialogConfirm',
    value: function closeDialogConfirm() {
      this.setState({
        showDialogConfirm: false
      });
    }
  }, {
    key: 'onClickConfirmKetThuc',
    value: function onClickConfirmKetThuc() {
      var _this7 = this;

      this.setState({
        showDialogConfirm: false,
        btnLoading: true
      }, function () {
        var params = _this7.getParams();
        params.tienDo = 'HOAN_THANH';
        _this7.pushTaiLieu(_this7.state.doiTuongViPhamId);
        if (_this7.state.enableDonDoc) {
          _this7.donDoc.handleSave(function () {
            var message = 'Hoàn thành theo dõi thực hiện đối với ' + _this7.state.ten;
            _this7.updateDoiTuongViPham(params, message);
          });
        } else {
          var message = 'Hoàn thành theo dõi thực hiện đối với ' + _this7.state.ten;
          _this7.updateDoiTuongViPham(params, message);
        }
      });
    }
  }, {
    key: 'updateDoiTuongViPham',
    value: function updateDoiTuongViPham(data, message) {
      var _this8 = this;

      var params = {
        doiTuongViPhams: [data]
      };
      _api.ThanhTra.actions.updateDoiTuongViPham.request('', params).then(function (res) {
        //do something
        (0, _toastr.Toastr)(message ? message : _message.msg.saveDoiTuongTTSuccess, 'success');
        _this8.handleBack(true);
        _this8.props.getListDaTa('getList');
      });
    }
  }, {
    key: 'getCoQuanDieuTraThanhTra',
    value: function getCoQuanDieuTraThanhTra() {
      var _this9 = this;

      _api.ThanhTra.actions.getCoQuanDieuTraThanhTra.request().then(function (res) {
        if (res.data) {
          _this9.setState({
            dataCoQuanDieuTraThanhTra: res.data
          });
        }
      });
    }
  }, {
    key: 'getHinhThucKienNghi',
    value: function getHinhThucKienNghi() {
      var _this10 = this;

      _api.ThanhTra.actions.getHinhThucKienNghi.request().then(function (res) {
        if (res.data) {
          _this10.setState({
            dataHinhThucKienNghi: res.data
          });
        }
      });
    }
  }, {
    key: 'getKetLuanVeNoiDungKiemTra',
    value: function getKetLuanVeNoiDungKiemTra() {
      var _this11 = this;

      _api.ThanhTra.actions.ketLuanVeNoiDungKiemTra.request().then(function (res) {
        if (res.data) {
          _this11.setState({
            dataKetLuanVeNoiDungKiemTra: res.data
          });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this12 = this;

      this.setState({
        linhVucThanhTra: nextProps.linhVucThanhTra,
        listDoiTuongViPham: nextProps.listDoiTuongViPham,
        idCuocThanhTra: nextProps.idCuocThanhTra,
        chucNangCuocThanhTra: nextProps.chucNangCuocThanhTra,
        id: nextProps.id,
        isOpen: nextProps.isOpen
      }, function () {
        if (_this12.state.id && _this12.state.isOpen === true) {
          _this12.getChiTietDoiTuongTraThanhTra(_this12.state.id);
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this13 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        if (name === 'thoiHanKiemTra') {
          _this13.getThoiHanKiemTra();
        }
      });
      if (name === 'coQuanDieuTraThanhTra') {}
      this.handleChangeData();
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(data, type) {
      this.setState({
        dataFileDinhKem: data
      });
      this.handleChangeData();
    }
  }, {
    key: 'onFileRemove',
    value: function onFileRemove(id, data, type) {
      this.setState({
        dataTaiLieuVanThuDelete: [].concat(_toConsumableArray(this.state.dataTaiLieuVanThuDelete), [id])
      });

      this.setState({
        dataFileDinhKem: data
      });

      this.handleChangeData();
    }
  }, {
    key: 'pushTaiLieu',
    value: function pushTaiLieu(id) {

      var dataFileDinhKem = this.state.dataFileDinhKem;

      if (dataFileDinhKem.length > 0) {
        var taiLieuVanThu = [];
        var taiLieuVanThuUpdate = [];
        dataFileDinhKem.map(function (item, i) {
          if (item.taiLieuVanThuId) {
            taiLieuVanThuUpdate[taiLieuVanThuUpdate.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            taiLieuVanThu[taiLieuVanThu.length] = {
              doiTuongViPham: {
                id: Number(id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? (0, _moment2.default)(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
        if (taiLieuVanThu.length > 0) {
          var params = {
            taiLieuVanThus: taiLieuVanThu
          };
          this.postTaiLieuVanThu(params);
        }
        if (taiLieuVanThuUpdate.length > 0) {
          var _params = {
            taiLieuVanThus: taiLieuVanThuUpdate
          };
          this.updateTaiLieuVanThu(_params);
        }
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        var taiLieuVanThuDelete = [];
        this.state.dataTaiLieuVanThuDelete.map(function (item) {
          taiLieuVanThuDelete[taiLieuVanThuDelete.length] = { id: item };
        });
        if (taiLieuVanThuDelete.length > 0) {

          var _params2 = {
            taiLieuVanThus: taiLieuVanThuDelete
          };
          this.deleteTaiLieuVanThu(_params2);
        }
      }
    }
  }, {
    key: 'updateTaiLieuVanThu',
    value: function updateTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'postTaiLieuVanThu',
    value: function postTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'deleteTaiLieuVanThu',
    value: function deleteTaiLieuVanThu(params) {
      _api.GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(function (res) {}).catch(function (error) {
        if (error.response) {
          (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      this.setState(_defineProperty({}, name, e));
      if (!e) {}
      this.handleChangeData();
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this14 = this;

      this.setState({
        idCuocThanhTra: '',
        id: '',

        taiLieuVanThu: [],
        taiLieuVanThuUpdate: [],
        taiLieuVanThuDelete: [],
        dataFileDinhKem: [],
        dataTaiLieuVanThuDelete: [],
        listTaiLieuVanThu: [],

        btnLoading: false,
        btnSaveLoading: false,

        enableTheoDoi: false,
        enableDonDoc: false,
        enableKiemTra: false,
        hasChange: false,
        backConfirm: false,

        ten: '',
        theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
        theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

        soQuyetDinhTheoDoiXuLyHanhChinh: '',

        theoDoiToChucCoSaiPham: '',
        theoDoiToChucCoSaiPhamInit: '',
        toChucTheoDoiSaiPham: '',
        theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
        theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
        theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
        theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',

        theoDoiCaNhanCoSaiPham: '',
        theoDoiCaNhanCoSaiPhamInit: '',
        caNhanTheoDoiSaiPham: '',

        // xử lý về kinh tế

        tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

        listTheoDoiLanNopTien: [],

        lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

        saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
        saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
        saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

        lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

        saiPhamKhacTheoDoiXuLyVeKinhTe: '',

        // xử lý về hình sự
        vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
        ketQuaChuyenCoQuanDieuTra: '',
        soVuViecTheoDoiXuLyHinhSu: '',

        soDoiTuongTheoDoiXuLyHinhSuInit: '',
        soDoiTuongTheoDoiXuLyHinhSu: '',

        ghiChuTheoDoiXuLyHinhSu: '',

        kienNghiTienTheoDoiXuLyKhac: '',
        kienNghiDatTheoDoiXuLyKhac: '',
        ketQuaThucHienTheoDoiXuLyKhac: '',

        soQuyetDinhKiemTra: '',
        ngayBanHanhKiemTra: '',
        ngayBatDauKiemTra: '',
        thoiHanKiemTra: '',
        ngayHetHanKiemTra: '',
        ngayHetHanKiemTraISO: '',
        canCuKiemTra: '',
        tinhHinhKiemTra: '',
        ketQuaKiemTra: '',
        soKienNghiDaThucHienXong: '',
        theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
        theoDoiDatDaThuHoiVeNganSachNhaNuoc: ''
      }, function () {
        _this14.props.closeDialog();
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });

      return pass;
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse(name) {
      if (name === 'showNoiDungDonDoc' && this.state.donDocChange === true) {
        this.setState({
          confirmDonDoc: true
        });
      } else {
        this.setState(_defineProperty({}, name, !this.state[name]));
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this15 = this;

      if (e && e._d) {
        if (name === 'ngayBatDauKiemTra') {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this15.getThoiHanKiemTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e._d));
        }
      } else {
        if (name === 'ngayBatDauKiemTra') {
          this.setState(_defineProperty({}, name, e), function () {
            _this15.getThoiHanKiemTra();
          });
        } else {
          this.setState(_defineProperty({}, name, e));
        }
      }
      this.handleChangeData();
    }
  }, {
    key: 'getThoiHanKiemTra',
    value: function getThoiHanKiemTra() {
      var _this16 = this;

      if (this.state.ngayBatDauKiemTra) {
        this.setState({
          getThoiHanKiemTra: true
        });
        var params = {
          thoiHanThanhTra: this.state.thoiHanKiemTra ? Number(this.state.thoiHanKiemTra) : 0,
          ngayCongBoQD: (0, _moment2.default)(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString()
        };
        _api.ThanhTra.actions.getThoiHanThanhTra.request('', params).then(function (res) {
          if (res.data) {
            _this16.setState({
              ngayHetHanKiemTra: (0, _moment2.default)(new Date(res.data)).format('DD/MM/YYYY'),
              ngayHetHanKiemTraISO: res.data
            }, function () {
              _this16.setState({
                getThoiHanKiemTra: false
              });
              _this16.pushData();
            });
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this16.setState({
            getThoiHanKiemTra: false
          });
        });
      } else {
        this.setState({
          ngayHetHanKiemTra: '',
          ngayHetHanKiemTraISO: null
        });
      }
    }
  }, {
    key: 'onChangeDataDonDoc',
    value: function onChangeDataDonDoc() {
      this.setState({
        donDocChange: true
      });
      this.handleChangeData();
    }
  }, {
    key: 'confirmDonDoc',
    value: function confirmDonDoc() {
      this.setState({
        confirmDonDoc: false,
        showNoiDungDonDoc: false,
        donDocChange: false
      });
    }
  }, {
    key: 'closeDialogDonDoc',
    value: function closeDialogDonDoc() {
      this.setState({
        confirmDonDoc: false
      });
    }
  }, {
    key: 'handleBack',
    value: function handleBack(allowBack) {
      if (allowBack == true) {
        this.resetData();
      } else {
        if (this.state.hasChange) {
          this.state.backConfirm = true;
          this.setState(_extends({}, this.state));
        } else {
          this.resetData();
        }
      }
    }
  }, {
    key: 'closeConfirmBack',
    value: function closeConfirmBack() {
      this.state.backConfirm = false;
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleChangeData',
    value: function handleChangeData() {
      this.setState({
        hasChange: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this;

      var DataDetail = this.state.dataDetail;
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.state.isOpen,
          onClose: this.handleBack.bind(this),
          title: '\u0110\u1ED1i t\u01B0\u1EE3ng ' + this.state.ten,
          className: 'dialog-default wrap-block' },
        _react2.default.createElement(
          'section',
          { className: 'wrap-dtkn' },
          _react2.default.createElement(_dialog.ConfirmDialog, { open: this.state.backConfirm, onClose: this.closeConfirmBack.bind(this), onSuccess: this.handleBack.bind(this, true),
            title: _message.msg.confirmBack }),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn' },
            _react2.default.createElement(
              'h2',
              { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungKienNghi ? "collapse-open" : "collapse-close pb20") },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungKienNghi') },
                '1. N\u1ED9i dung ki\u1EBFn ngh\u1ECB'
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.showNoiDungKienNghi },
              _react2.default.createElement(_NoiDungKienNghiDoiTuongThanhTra2.default, _extends({ linhVucThanhTra: this.state.linhVucThanhTra, chucNangCuocThanhTra: this.state.chucNangCuocThanhTra }, DataDetail))
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableTheoDoi },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungTheoDoi ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungTheoDoi') },
                  '2. Theo d\xF5i th\u1EF1c hi\u1EC7n'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungTheoDoi },
                _react2.default.createElement(
                  'div',
                  { className: 'pl15 pr15' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-100 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'title-12 mb10 mt15' },
                      '2.1 X\u1EED l\xFD thu h\u1ED3i'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 pl0 pr0' },
                      _react2.default.createElement(
                        'p',
                        { className: 'title-group-input' },
                        'THU H\u1ED2I V\u1EC0 NSNN'
                      ),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 ti\u1EC1n (\u0111)', value: this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'theoDoiTienDaThuHoiVeNganSachNhaNuoc'), name: 'theoDoiTienDaThuHoiVeNganSachNhaNuoc' }),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 \u0111\u1EA5t (m2)', value: this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc, onChange: this.onChange.bind(this, 'theoDoiDatDaThuHoiVeNganSachNhaNuoc'), name: 'theoDoiDatDaThuHoiVeNganSachNhaNuoc' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-50 pl0 pr0' },
                      _react2.default.createElement(
                        'p',
                        { className: 'title-group-input' },
                        'THU H\u1ED2I V\u1EC0 T\u1ED4 CH\u1EE8C, \u0110\u01A0N V\u1ECA'
                      ),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 ti\u1EC1n (\u0111)', value: this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'theoDoiTienDaThuTrongQuaTrinhThanhTra'), name: 'theoDoiTienDaThuTrongQuaTrinhThanhTra' }),
                      _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-50', placeholder: 'Nh\u1EADp...', label: 'V\u1EC1 \u0111\u1EA5t (m2)', value: this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra, onChange: this.onChange.bind(this, 'theoDoiDatDaThuTrongQuaTrinhThanhTra'), name: 'theoDoiDatDaThuTrongQuaTrinhThanhTra' })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.2. X\u1EED l\xFD v\u1EC1 kinh t\u1EBF'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'T\u1ED5ng s\u1ED1 ti\u1EC1n ph\u1EA3i thu h\u1ED3i (\u0111)', placeholder: 'Nh\u1EADp...', value: this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'tongSoTienThuHoiTheoDoiXuLyVeKinhTe'), name: 'tongSoTienThuHoiTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_ListLanNopTien2.default, { data: this.state.listTheoDoiLanNopTien, onChange: this.onChange.bind(this, 'listTheoDoiLanNopTien'), name: 'listTheoDoiLanNopTien' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'lyDoThuHoiTheoDoiXuLyVeKinhTe'), name: 'lyDoThuHoiTheoDoiXuLyVeKinhTe', maxLength: 1000 }),
                    _react2.default.createElement(
                      'h2',
                      { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                      'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                    ),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ph\u1EA3i thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: '\u0110\xE3 thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'C\xF2n ph\u1EA3i thu (m2)', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe'), name: 'saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'L\xFD do', placeholder: 'Nh\u1EADp...', value: this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe'), name: 'lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe', maxLength: 1000 }),
                    _react2.default.createElement(
                      'h2',
                      { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                      'Sai ph\u1EA1m kh\xE1c'
                    ),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'N\u1ED9i dung sai ph\u1EA1m kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.saiPhamKhacTheoDoiXuLyVeKinhTe, onChange: this.onChange.bind(this, 'saiPhamKhacTheoDoiXuLyVeKinhTe'), name: 'saiPhamKhacTheoDoiXuLyVeKinhTe', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.3. X\u1EED l\xFD v\u1EC1 h\xE0nh ch\xEDnh'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD h\xE0nh ch\xEDnh', placeholder: 'Nh\u1EADp...', bindValidator: this, channel: 'formTaoDon', value: this.state.soQuyetDinhTheoDoiXuLyHanhChinh, onChange: this.onChange.bind(this, 'soQuyetDinhTheoDoiXuLyHanhChinh'), name: 'soQuyetDinhTheoDoiXuLyHanhChinh', maxLength: 255 }),
                    _react2.default.createElement(_common.InputList, { label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m', hasCount: true, countUnit: 't\u1ED5 ch\u1EE9c', data: this.state.theoDoiToChucCoSaiPhamInit, onChange: this.onChange.bind(this, 'theoDoiToChucCoSaiPham'), name: 'theoDoiToChucCoSaiPham' }),
                    _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangTien'), name: 'theoDoiKienNghiXuLyHanhChinhToChucBangTien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac'), name: 'theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac', maxLength: 255 }),
                    _react2.default.createElement(_common.InputList, { label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m', hasCount: true, countUnit: 'c\xE1 nh\xE2n', data: this.state.theoDoiCaNhanCoSaiPhamInit, onChange: this.onChange.bind(this, 'theoDoiCaNhanCoSaiPham'), name: 'theoDoiCaNhanCoSaiPham' }),
                    _react2.default.createElement(_common.Input, { type: 'sdt', className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'B\u1EB1ng ti\u1EC1n (\u0111)', value: this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangTien'), name: 'theoDoiKienNghiXuLyHanhChinhCaNhanBangTien' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac, onChange: this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac'), name: 'theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac', maxLength: 255 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.4. X\u1EED l\xFD v\u1EC1 h\xECnh s\u1EF1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', label: 'V\u0103n b\u1EA3n \u0111\xF4n \u0111\u1ED1c c\u01A1 quan \u0111i\u1EC1u tra', placeholder: 'Nh\u1EADp...', value: this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu, onChange: this.onChange.bind(this, 'vanBanDonDocCoQuanDieuTraTheoDoiHinhSu'), name: 'vanBanDonDocCoQuanDieuTraTheoDoiHinhSu', maxLength: 255 }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataKetQuaChuyenCoQuanDieuTra, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'K\u1EBFt qu\u1EA3 chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra', selectedValue: this.state.ketQuaChuyenCoQuanDieuTra, onChange: this.onChange.bind(this, 'ketQuaChuyenCoQuanDieuTra'), name: 'ketQuaChuyenCoQuanDieuTra' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.InputNumber, { className: 'col-25', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c', placeholder: 'Nh\u1EADp...', value: this.state.soVuViecTheoDoiXuLyHinhSu, onChange: this.onChange.bind(this, 'soVuViecTheoDoiXuLyHinhSu'), name: 'soVuViecTheoDoiXuLyHinhSu' }),
                    _react2.default.createElement(_common.InputList, { label: 'T\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng', hasCount: true, countUnit: '\u0111\u1ED1i t\u01B0\u1EE3ng', data: this.state.soDoiTuongTheoDoiXuLyHinhSuInit, onChange: this.onChange.bind(this, 'soDoiTuongTheoDoiXuLyHinhSu'), name: 'soDoiTuongTheoDoiXuLyHinhSu' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'Ghi ch\xFA', placeholder: 'Nh\u1EADp...', value: this.state.ghiChuTheoDoiXuLyHinhSu, onChange: this.onChange.bind(this, 'ghiChuTheoDoiXuLyHinhSu'), name: 'ghiChuTheoDoiXuLyHinhSu', maxLength: 1000 })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mb20 mt5' },
                    _react2.default.createElement('div', { className: 'line-border' })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.5. Ki\u1EBFn ngh\u1ECB ho\xE0n thi\u1EC7n c\u01A1 ch\u1EBF ch\xEDnh s\xE1ch'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', label: 'S\u1ED1 ki\u1EBFn ngh\u1ECB \u0111\xE3 th\u1EF1c hi\u1EC7n xong', placeholder: 'Nh\u1EADp...', value: this.state.soKienNghiDaThucHienXong, onChange: this.onChange.bind(this, 'soKienNghiDaThucHienXong'), name: 'soKienNghiDaThucHienXong', maxLength: 255 })
                  ),
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10' },
                    '2.6. X\u1EED l\xFD kh\xE1c'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111)', placeholder: 'Nh\u1EADp...', value: this.state.kienNghiTienTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'kienNghiTienTheoDoiXuLyKhac'), name: 'kienNghiTienTheoDoiXuLyKhac' }),
                    _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2)', placeholder: 'Nh\u1EADp...', value: this.state.kienNghiDatTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'kienNghiDatTheoDoiXuLyKhac'), name: 'kienNghiDatTheoDoiXuLyKhac' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n ki\u1EBFn ngh\u1ECB kh\xE1c', placeholder: 'Nh\u1EADp...', value: this.state.ketQuaThucHienTheoDoiXuLyKhac, onChange: this.onChange.bind(this, 'ketQuaThucHienTheoDoiXuLyKhac'), name: 'ketQuaThucHienTheoDoiXuLyKhac', maxLength: 1000 })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableDonDoc },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn custom-collapse' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungDonDoc ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungDonDoc') },
                  '3. \u0110\xF4n \u0111\u1ED1c'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungDonDoc },
                _react2.default.createElement(_ListDonDoc2.default, { bindValidator: this, id: this.state.id, onChangeData: this.onChangeDataDonDoc.bind(this), onRef: function onRef(donDoc) {
                    return _this17.donDoc = donDoc;
                  } })
              )
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.enableKiemTra },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'big-border' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-dtkn custom-collapse' },
              _react2.default.createElement(
                'h2',
                { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungKiemTra ? "collapse-open" : "collapse-close pb20") },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungKiemTra') },
                  '4. Ki\u1EC3m Tra'
                )
              ),
              _react2.default.createElement(
                _core.Collapse,
                { isOpen: this.state.showNoiDungKiemTra },
                _react2.default.createElement(
                  'div',
                  { className: 'pl15 pr15 pt15' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row pl10 pr10' },
                    _react2.default.createElement(_common.Input, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', require: true, label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', placeholder: 'Nh\u1EADp...', value: this.state.soQuyetDinhKiemTra, onChange: this.onChange.bind(this, 'soQuyetDinhKiemTra'), name: 'soQuyetDinhKiemTra', maxLength: 255 }),
                    _react2.default.createElement(_common.DatePicker, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', endDate: new Date(), require: true, label: 'Ng\xE0y ban h\xE0nh', value: this.state.ngayBanHanhKiemTra, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhKiemTra'), name: 'ngayBanHanhKiemTra' }),
                    _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u', className: 'col-25', value: this.state.ngayBatDauKiemTra, onChange: this.handleChangeDate.bind(this, 'ngayBatDauKiemTra'), name: 'ngayBatDauKiemTra', require: true, bindValidator: this, channel: 'formTaoDon' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-thoihan col-25' },
                      _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n ki\u1EC3m tra (ng\xE0y l\xE0m vi\u1EC7c)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanKiemTra, onChange: this.onChange.bind(this, 'thoiHanKiemTra'), name: 'thoiHanKiemTra' }),
                      _react2.default.createElement(
                        'span',
                        { className: 'thoihan-value' },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: !this.state.getThoiHanKiemTra },
                          _react2.default.createElement(
                            'span',
                            null,
                            this.state.ngayHetHanKiemTra ? this.state.ngayHetHanKiemTra : ''
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.getThoiHanKiemTra },
                          _react2.default.createElement('span', { className: 'icon-loader' })
                        )
                      )
                    ),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'C\u0103n c\u1EE9 ki\u1EC3m tra', value: this.state.canCuKiemTra, onChange: this.onChange.bind(this, 'canCuKiemTra'), name: 'canCuKiemTra' }),
                    _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'T\xECnh h\xECnh ki\u1EC3m tra', value: this.state.tinhHinhKiemTra, onChange: this.onChange.bind(this, 'tinhHinhKiemTra'), name: 'tinhHinhKiemTra' }),
                    _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataKetLuanVeNoiDungKiemTra, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'K\u1EBFt lu\u1EADn v\u1EC1 n\u1ED9i dung ki\u1EC3m tra', selectedValue: this.state.ketQuaKiemTra, onChange: this.onChange.bind(this, 'ketQuaKiemTra'), name: 'ketQuaKiemTra' })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn pl15 pr15 pb10' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.showFile },
              _react2.default.createElement(_upload.ContainerFileDinhKem, {
                label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
                name: 'taiLieuVanThuDoiTuongKienNghi',
                bindValidator: this,
                data: this.state.listTaiLieuVanThu,
                onFileRemove: this.onFileRemove.bind(this),
                onFileChange: this.onFileChange.bind(this) })
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'pr10 pl10' },
              _react2.default.createElement(
                'div',
                { className: 'box-bottom' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-close', onClick: this.handleBack.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u0110\xF3ng'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-save action-todo ' + (this.state.btnSaveLoading ? "btn-loading-inline" : this.state.btnLoading && 'btn-disable'), onClick: this.handleSave.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'L\u01B0u t\u1EA1m'
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'btn-action btn-complete btn-right-position action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : this.state.btnLoading && 'btn-loading-inline'), onClick: this.handleKetThuc.bind(this) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Ho\xE0n Th\xE0nh'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.confirmDonDoc,
              onClose: this.closeDialogDonDoc.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body mb0' },
              _react2.default.createElement(
                'p',
                { className: 'pt10 pb20 txt-center' },
                _message.msg.confirmDonDoc
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogDonDoc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-green action-todo', onClick: this.confirmDonDoc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          ),
          _react2.default.createElement(
            _core.Dialog,
            {
              isOpen: this.state.showDialogConfirm,
              onClose: this.closeDialogConfirm.bind(this),
              title: 'X\xE1c nh\u1EADn',
              className: 'reception-dialog delete-dialog wrap-block'
            },
            _react2.default.createElement(
              'div',
              { className: 'pt-dialog-body mb0' },
              _react2.default.createElement(
                'p',
                { className: 'pt10 pb20 txt-center' },
                'Sau khi ho\xE0n th\xE0nh theo d\xF5i th\u1EF1c hi\u1EC7n, b\u1EA1n s\u1EBD kh\xF4ng c\u1EADp nh\u1EADt \u0111\u01B0\u1EE3c th\xF4ng tin cho ' + this.state.ten
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'box-bottom col-100' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close action-todo', onClick: this.closeDialogConfirm.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Kh\xF4ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-green action-todo', onClick: this.onClickConfirmKetThuc.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\u1ED3ng \xFD'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DoiTuongKienNghi;
}(_react2.default.Component);

DoiTuongKienNghi.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: '',
  listDoiTuongViPham: []
};

exports.default = (0, _utils.validatable)(DoiTuongKienNghi);

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _common = __webpack_require__(3);

var _upload = __webpack_require__(17);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _ListDonDoc = __webpack_require__(319);

var _ListDonDoc2 = _interopRequireDefault(_ListDonDoc);

var _ListLanNopTien = __webpack_require__(320);

var _ListLanNopTien2 = _interopRequireDefault(_ListLanNopTien);

var _NoiDungKienNghiDoiTuongThanhTra = __webpack_require__(496);

var _NoiDungKienNghiDoiTuongThanhTra2 = _interopRequireDefault(_NoiDungKienNghiDoiTuongThanhTra);

var _style = __webpack_require__(269);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DoiTuongKienNghiView = function (_React$Component) {
  _inherits(DoiTuongKienNghiView, _React$Component);

  function DoiTuongKienNghiView(props, context) {
    _classCallCheck(this, DoiTuongKienNghiView);

    var _this = _possibleConstructorReturn(this, (DoiTuongKienNghiView.__proto__ || Object.getPrototypeOf(DoiTuongKienNghiView)).call(this, props, context));

    _this.state = {
      dataDetail: {},
      id: _this.props.id,
      style: _style2.default,

      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      enableTheoDoi: false,
      enableDonDoc: false,
      enableKiemTra: false,

      linhVucThanhTra: _this.props.linhVucThanhTra,
      listDoiTuongViPham: _this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: _this.props.chucNangCuocThanhTra
    };
    return _this;
  }

  _createClass(DoiTuongKienNghiView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkProcess(this.props.data);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        linhVucThanhTra: nextProps.linhVucThanhTra
      });
      if (nextProps.data != this.props.data) {
        this.checkProcess(nextProps.data);
      }
    }
  }, {
    key: 'checkProcess',
    value: function checkProcess(data) {
      var DataDetail = data;
      if (DataDetail.ngayBatDauKiemTra != null) {
        this.setState({
          enableTheoDoi: true,
          enableDonDoc: true,
          enableKiemTra: true
        });
      } else if (DataDetail.donDocDoiTuongs.length > 0) {
        this.setState({
          enableTheoDoi: true,
          enableDonDoc: true,
          enableKiemTra: false
        });
      } else {
        this.setState({
          enableTheoDoi: true,
          enableDonDoc: false,
          enableKiemTra: false
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.props.closeDialog();
    }
  }, {
    key: 'handleCollapse',
    value: function handleCollapse(name) {
      this.setState(_defineProperty({}, name, !this.state[name]));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var DataDetail = this.props.data;
      return _react2.default.createElement(
        'section',
        { className: 'wrap-dtkn' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.toChucLienQuan != true },
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn' },
            _react2.default.createElement(
              'h2',
              { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungKienNghi ? "collapse-open" : "collapse-close pb20") },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungKienNghi') },
                '1. N\u1ED9i dung ki\u1EBFn ngh\u1ECB'
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.showNoiDungKienNghi },
              _react2.default.createElement(_NoiDungKienNghiDoiTuongThanhTra2.default, _extends({ linhVucThanhTra: this.state.linhVucThanhTra, chucNangCuocThanhTra: this.state.chucNangCuocThanhTra }, DataDetail))
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.enableTheoDoi },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn' },
            _react2.default.createElement(
              'h2',
              { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungTheoDoi ? "collapse-open" : "collapse-close pb20") },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungTheoDoi') },
                (this.props.toChucLienQuan == true ? '1' : '2') + '. Theo d\xF5i th\u1EF1c hi\u1EC7n'
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.showNoiDungTheoDoi },
              _react2.default.createElement(
                'div',
                { className: 'pl15 pr15' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-100 no-gutter' },
                  _react2.default.createElement(
                    'h2',
                    { className: 'title-12 mb10 mt15' },
                    (this.props.toChucLienQuan == true ? '1' : '2') + '.1. X\u1EED l\xFD thu h\u1ED3i'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'txt-bold txt-upper col-100 mb10' },
                      'Thu h\u1ED3i v\u1EC1 NSNN'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: DataDetail.theoDoiTienDaThuHoiVeNganSachNhaNuoc }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\xE3 thu \u0111\u1EA5t \u0111\u1EA5t (m2):', value: DataDetail.theoDoiDatDaThuHoiVeNganSachNhaNuoc })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-50 no-gutter' },
                    _react2.default.createElement(
                      'h2',
                      { className: 'txt-bold txt-upper col-100 mb10' },
                      'Thu h\u1ED3i v\u1EC1 t\u1ED5 ch\u1EE9c, \u0111\u01A1n v\u1ECB'
                    ),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\xE3 thu ti\u1EC1n (\u0111):', value: DataDetail.theoDoiTienDaThuTrongQuaTrinhThanhTra }),
                    _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: '\u0110\xE3 thu \u0111\u1EA5t (m2):', value: DataDetail.theoDoiDatDaThuTrongQuaTrinhThanhTra })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mb20 mt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  (this.props.toChucLienQuan == true ? '1' : '2') + '.2. X\u1EED l\xFD v\u1EC1 kinh t\u1EBF'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5ng s\u1ED1 ti\u1EC1n ph\u1EA3i thu h\u1ED3i (\u0111):', value: DataDetail.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_ListLanNopTien2.default, { data: DataDetail.listTheoDoiLanNopTien, view: true }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'L\xFD do', value: DataDetail.lyDoThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.lyDoThuHoiTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(
                    'h2',
                    { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                    'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai ki\u1EBFn ngh\u1ECB thu h\u1ED3i'
                  ),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ph\u1EA3i thu (m2):', value: DataDetail.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: '\u0110\xE3 thu (m2):', value: DataDetail.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\xF2n ph\u1EA3i thu (m2):', value: DataDetail.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'L\xFD do:', value: DataDetail.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '' }),
                  _react2.default.createElement(
                    'h2',
                    { className: 'col-100 mb10 mt5 txt-bold txt-upper txt-12' },
                    'Sai ph\u1EA1m kh\xE1c'
                  ),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'N\u1ED9i dung sai ph\u1EA1m kh\xE1c:', value: DataDetail.saiPhamKhacTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamKhacTheoDoiXuLyVeKinhTe : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mb20 mt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  (this.props.toChucLienQuan == true ? '1' : '2') + '.3. X\u1EED l\xFD v\u1EC1 h\xE0nh ch\xEDnh'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh x\u1EED l\xFD h\xE0nh ch\xEDnh:', value: DataDetail.soQuyetDinhTheoDoiXuLyHanhChinh ? DataDetail.soQuyetDinhTheoDoiXuLyHanhChinh : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c c\xF3 sai ph\u1EA1m:', value: DataDetail.theoDoiToChucCoSaiPham ? DataDetail.theoDoiToChucCoSaiPham : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng ti\u1EC1n:', value: DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c:', value: DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\xE1 nh\xE2n c\xF3 sai ph\u1EA1m:', value: DataDetail.theoDoiCaNhanCoSaiPham ? DataDetail.theoDoiCaNhanCoSaiPham : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'B\u1EB1ng ti\u1EC1n:', value: DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-50 mb10', label: 'B\u1EB1ng h\xECnh th\u1EE9c kh\xE1c:', value: DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mb20 mt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  (this.props.toChucLienQuan == true ? '1' : '2') + '.4. X\u1EED l\xFD v\u1EC1 h\xECnh s\u1EF1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'V\u0103n b\u1EA3n \u0111\xF4n \u0111\u1ED1c c\u01A1 quan \u0111i\u1EC1u tra:', value: DataDetail.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? DataDetail.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'K\u1EBFt qu\u1EA3 chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra:', value: DataDetail.ketQuaChuyenCoQuanDieuTraInfo ? DataDetail.ketQuaChuyenCoQuanDieuTraInfo.text : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: DataDetail.soVuViecTheoDoiXuLyHinhSu ? DataDetail.soVuViecTheoDoiXuLyHinhSu : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-100 mb10', label: 'S\u1ED1 \u0111\u1ED1i t\u01B0\u1EE3ng:', value: DataDetail.soDoiTuongTheoDoiXuLyHinhSu ? DataDetail.soDoiTuongTheoDoiXuLyHinhSu : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Ghi ch\xFA:', value: DataDetail.ghiChuTheoDoiXuLyHinhSu ? DataDetail.ghiChuTheoDoiXuLyHinhSu : '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mb20 mt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  (this.props.toChucLienQuan == true ? '1' : '2') + '.5. Ki\u1EBFn ngh\u1ECB ho\xE0n thi\u1EC7n c\u01A1 ch\u1EBF ch\xEDnh s\xE1ch'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-30 mb10', label: 'S\u1ED1 ki\u1EBFn ngh\u1ECB \u0111\xE3 th\u1EF1c hi\u1EC7n xong:', value: DataDetail.soKienNghiDaThucHienXong })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'mb20 mt5' },
                  _react2.default.createElement('div', { className: 'line-border' })
                ),
                _react2.default.createElement(
                  'h2',
                  { className: 'title-12 mb10' },
                  (this.props.toChucLienQuan == true ? '1' : '2') + '.6. X\u1EED l\xFD kh\xE1c'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB ti\u1EC1n (\u0111):', value: DataDetail.kienNghiTienTheoDoiXuLyKhac ? DataDetail.kienNghiTienTheoDoiXuLyKhac : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ki\u1EBFn ngh\u1ECB \u0111\u1EA5t (m2):', value: DataDetail.kienNghiDatTheoDoiXuLyKhac ? DataDetail.kienNghiDatTheoDoiXuLyKhac : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n ki\u1EBFn ngh\u1ECB kh\xE1c:', value: DataDetail.ketQuaThucHienTheoDoiXuLyKhac ? DataDetail.ketQuaThucHienTheoDoiXuLyKhac : '' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.enableDonDoc },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn custom-collapse' },
            _react2.default.createElement(
              'h2',
              { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungDonDoc ? "collapse-open" : "collapse-close pb20") },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungDonDoc') },
                (this.props.toChucLienQuan == true ? '2' : '3') + '. \u0110\xF4n \u0111\u1ED1c'
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.showNoiDungDonDoc },
              _react2.default.createElement(_ListDonDoc2.default, { toChucLienQuan: this.props.toChucLienQuan, bindValidator: this, view: true, id: DataDetail.doiTuongViPhamId, onRef: function onRef(donDoc) {
                  return _this2.donDoc = donDoc;
                } })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.enableKiemTra },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', { className: 'big-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'content-dtkn custom-collapse' },
            _react2.default.createElement(
              'h2',
              { className: 'collapse-title pl15 pr15 pt20 ' + (this.state.showNoiDungKiemTra ? "collapse-open" : "collapse-close pb20") },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'title-14', onClick: this.handleCollapse.bind(this, 'showNoiDungKiemTra') },
                (this.props.toChucLienQuan == true ? '3' : '4') + '. Ki\u1EC3m Tra'
              )
            ),
            _react2.default.createElement(
              _core.Collapse,
              { isOpen: this.state.showNoiDungKiemTra },
              _react2.default.createElement(
                'div',
                { className: 'pl15 pr15 pt15' },
                _react2.default.createElement(
                  'div',
                  { className: 'row pl10 pr10' },
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh:', value: DataDetail.soQuyetDinhKiemTra ? DataDetail.soQuyetDinhKiemTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: DataDetail.ngayBanHanhKiemTra ? (0, _moment2.default)(DataDetail.ngayBanHanhKiemTra).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u', className: 'col-25 mb10:', value: DataDetail.ngayBatDauKiemTra ? (0, _moment2.default)(DataDetail.ngayBatDauKiemTra).format('DD/MM/YYYY') : '' }),
                  _react2.default.createElement(_common.Text, { label: 'Th\u1EDDi h\u1EA1n ki\u1EC3m tra (ng\xE0y l\xE0m vi\u1EC7c):', className: 'col-25 mb10', value: (DataDetail.thoiHanKiemTra ? DataDetail.thoiHanKiemTra : 0) + ' ng\xE0y (' + (DataDetail.ngayHetHanKiemTra ? (0, _moment2.default)(DataDetail.ngayHetHanKiemTra).format('DD/MM/YYYY') : '') + ')' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'C\u0103n c\u1EE9 ki\u1EC3m tra:', value: DataDetail.canCuKiemTra ? DataDetail.canCuKiemTra : '' }),
                  _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'T\xECnh h\xECnh ki\u1EC3m tra:', value: DataDetail.tinhHinhKiemTra ? DataDetail.tinhHinhKiemTra : '' }),
                  _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'K\u1EBFt lu\u1EADn v\u1EC1 n\u1ED9i dung ki\u1EC3m tra:', value: DataDetail.ketQuaKiemTraInfo ? DataDetail.ketQuaKiemTraInfo.text : '' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-dtkn pl15 pr15 pb10' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.showFile },
            _react2.default.createElement(_upload.ContainerFileDinhKem, {
              hideDescription: true,
              disableAttachFile: true,
              label: 'Danh s\xE1ch v\u0103n b\u1EA3n x\u1EED l\xFD',
              dataShow: DataDetail.listTaiLieuVanThu })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'pr10 pl10' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DoiTuongKienNghiView;
}(_react2.default.Component);

DoiTuongKienNghiView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: '',
  listDoiTuongViPham: []
};

exports.default = (0, _utils.validatable)(DoiTuongKienNghiView);

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _ttForms = __webpack_require__(19);

var _reactRouter = __webpack_require__(2);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DonDocDoiTuong = function (_React$Component) {
  _inherits(DonDocDoiTuong, _React$Component);

  function DonDocDoiTuong(props, context) {
    _classCallCheck(this, DonDocDoiTuong);

    var _this = _possibleConstructorReturn(this, (DonDocDoiTuong.__proto__ || Object.getPrototypeOf(DonDocDoiTuong)).call(this, props, context));

    _this.state = {
      //bool
      dataDetail: _this.props.dataDetail,
      getThoiHanDonDoc: false,
      openDialog: false,
      enableDelete: _this.props.enableDelete,

      coQuanBanHanhCuongChe: _this.props.coQuanBanHanhCuongChe ? _this.props.coQuanBanHanhCuongChe : '',
      coQuanBanHanhHuyCuongChe: _this.props.coQuanBanHanhHuyCuongChe ? _this.props.coQuanBanHanhHuyCuongChe : '',
      doiTuongViPham: _this.props.doiTuongViPham ? _this.props.doiTuongViPham : '',
      ghiChu: _this.props.ghiChu ? _this.props.ghiChu : '',
      hinhThucCuongChe: _this.props.hinhThucCuongChe ? _this.props.hinhThucCuongChe : '',
      hinhThucDonDoc: _this.props.hinhThucDonDoc ? _this.props.hinhThucDonDoc : '',
      huyCuongChe: _this.props.huyCuongChe ? _this.props.huyCuongChe : '',
      id: _this.props.donDocDoiTuongId ? _this.props.donDocDoiTuongId : '',
      ketQuaThucHien: _this.props.ketQuaThucHien ? _this.props.ketQuaThucHien : '',
      ngayBanHanh: _this.props.ngayBanHanh ? new Date(_this.props.ngayBanHanh) : '',
      ngayBanHanhCuongChe: _this.props.ngayBanHanhCuongChe ? new Date(_this.props.ngayBanHanhCuongChe) : '',
      ngayBanHanhHuyCuongChe: _this.props.ngayBanHanhHuyCuongChe ? new Date(_this.props.ngayBanHanhHuyCuongChe) : '',
      ngayBatDauDonDoc: _this.props.ngayBatDauDonDoc ? new Date(_this.props.ngayBatDauDonDoc) : '',
      ngayHetHanDonDoc: _this.props.ngayHetHanDonDoc ? (0, _moment2.default)(_this.props.ngayHetHanDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDocISO: _this.props.ngayHetHanDonDoc ? _this.props.ngayHetHanDonDoc : '',
      soQuyetDinhCuongChe: _this.props.soQuyetDinhCuongChe ? _this.props.soQuyetDinhCuongChe : '',
      soQuyetDinhHuyCuongChe: _this.props.soQuyetDinhHuyCuongChe ? _this.props.soQuyetDinhHuyCuongChe : '',
      soTienCuongChe: _this.props.soTienCuongChe ? _this.props.soTienCuongChe : '',
      soVanBan: _this.props.soVanBan ? _this.props.soVanBan : '',
      thoiGianThucHienCuongChe: _this.props.thoiGianThucHienCuongChe ? new Date(_this.props.thoiGianThucHienCuongChe) : '',
      thoiGianThucHienHuyCuongChe: _this.props.thoiGianThucHienHuyCuongChe ? new Date(_this.props.thoiGianThucHienHuyCuongChe) : '',
      thoiHanDonDoc: _this.props.thoiHanDonDoc ? _this.props.thoiHanDonDoc : '',
      thoiHanNgayLamViecDonDoc: _this.props.thoiHanNgayLamViecDonDoc ? _this.props.thoiHanNgayLamViecDonDoc : '',
      tinhHinhTienDoThucHienCuongChe: _this.props.tinhHinhTienDoThucHienCuongChe ? _this.props.tinhHinhTienDoThucHienCuongChe : '',
      tinhHinhTienDoThucHienKetLuan: _this.props.tinhHinhTienDoThucHienKetLuan ? _this.props.tinhHinhTienDoThucHienKetLuan : '',
      toChucTinDungThucHienCuongChe: _this.props.toChucTinDungThucHienCuongChe ? _this.props.toChucTinDungThucHienCuongChe : '',
      toChucTinDungThucHienHuyCuongChe: _this.props.toChucTinDungThucHienHuyCuongChe ? _this.props.toChucTinDungThucHienHuyCuongChe : '',

      dataKetQuaThucHienDonDoc: _this.props.dataKetQuaThucHienDonDoc,
      dataHinhThucDonDoc: _this.props.dataHinhThucDonDoc
    };
    return _this;
  }

  _createClass(DonDocDoiTuong, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataKetQuaThucHienDonDoc != this.props.dataKetQuaThucHienDonDoc) {
        this.setState({
          dataKetQuaThucHienDonDoc: nextProps.dataKetQuaThucHienDonDoc
        });
      }
      if (nextProps.dataHinhThucDonDoc != this.props.dataHinhThucDonDoc) {
        this.setState({
          dataHinhThucDonDoc: nextProps.dataHinhThucDonDoc
        });
      }
      if (nextProps.enableDelete != this.props.enableDelete) {
        this.setState({
          enableDelete: nextProps.enableDelete
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        if (name == 'thoiHanDonDoc') {
          _this2.getThoiHanDonDoc();
        } else {
          _this2.pushData();
        }
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this3 = this;

      if (e && e._d) {
        if (name == 'ngayBatDauDonDoc') {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this3.getThoiHanDonDoc();
          });
        } else {
          this.setState(_defineProperty({}, name, e._d), function () {
            _this3.pushData();
          });
        }
      } else {
        if (name == 'ngayBatDauDonDoc') {
          this.setState(_defineProperty({}, name, e), function () {
            _this3.getThoiHanDonDoc();
          });
        } else {
          this.setState(_defineProperty({}, name, e), function () {
            _this3.pushData();
          });
        }
      }
    }
  }, {
    key: 'handleCheck',
    value: function handleCheck(name, e) {
      var _this4 = this;

      this.setState(_defineProperty({}, name, e), function () {
        _this4.reSetData();
      });
      if (!e) {}
    }
  }, {
    key: 'reSetData',
    value: function reSetData() {
      var _this5 = this;

      this.setState({
        soQuyetDinhHuyCuongChe: '',
        ngayBanHanhHuyCuongChe: '',
        coQuanBanHanhHuyCuongChe: '',
        thoiGianThucHienHuyCuongChe: '',
        toChucTinDungThucHienHuyCuongChe: '',
        ghiChu: ''
      }, function () {
        _this5.pushData();
      });
    }
  }, {
    key: 'getThoiHanDonDoc',
    value: function getThoiHanDonDoc() {
      var _this6 = this;

      if (this.state.ngayBatDauDonDoc) {
        this.setState({
          getThoiHanDonDoc: true
        });
        var params = {
          thoiHanThanhTra: this.state.thoiHanDonDoc ? Number(this.state.thoiHanDonDoc) : 0,
          ngayCongBoQD: (0, _moment2.default)(this.state.ngayBatDauDonDoc).add(7, 'hours').toISOString()
        };
        _api.ThanhTra.actions.getThoiHanThanhTra.request('', params).then(function (res) {
          if (res.data) {
            _this6.setState({
              ngayHetHanDonDoc: (0, _moment2.default)(new Date(res.data)).format('DD/MM/YYYY'),
              ngayHetHanDonDocISO: res.data
            }, function () {
              _this6.setState({
                getThoiHanDonDoc: false
              });
              _this6.pushData();
            });
          }
        }).catch(function (error) {
          if (error.response) {
            (0, _toastr.Toastr)(error.response.data.errors[0].detail, 'error');
          }
          _this6.setState({
            getThoiHanDonDoc: false
          });
        });
      } else {
        this.setState({
          ngayHetHanDonDoc: '',
          ngayHetHanDonDocISO: null
        }, function () {
          _this6.pushData();
        });
      }
    }
  }, {
    key: 'pushData',
    value: function pushData() {
      var item = this.state.dataDetail;
      item.hinhThucDonDoc = this.state.hinhThucDonDoc ? this.state.hinhThucDonDoc : null;
      item.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      item.ngayBanHanh = this.state.ngayBanHanh ? (0, _moment2.default)(this.state.ngayBanHanh).toISOString() : null;
      item.ngayBatDauDonDoc = this.state.ngayBatDauDonDoc ? (0, _moment2.default)(this.state.ngayBatDauDonDoc).toISOString() : null;
      item.thoiHanDonDoc = this.state.thoiHanDonDoc ? this.state.thoiHanDonDoc : '';
      item.tinhHinhTienDoThucHienKetLuan = this.state.tinhHinhTienDoThucHienKetLuan ? this.state.tinhHinhTienDoThucHienKetLuan : '';

      item.ketQuaThucHien = this.state.ketQuaThucHien ? this.state.ketQuaThucHien : null;
      item.thoiHanNgayLamViecDonDoc = this.state.thoiHanNgayLamViecDonDoc ? this.state.thoiHanNgayLamViecDonDoc : '';
      item.ngayHetHanDonDoc = this.state.ngayHetHanDonDocISO ? this.state.ngayHetHanDonDocISO : null;
      item.doiTuongViPham = {
        id: Number(this.props.doiTuongViPhamId)
      };

      if (this.state.id) {
        item.id = this.state.id;
      }
      if (this.state.ketQuaThucHien == 'CHUA_THUC_HIEN') {
        item.soQuyetDinhCuongChe = this.state.soQuyetDinhCuongChe ? this.state.soQuyetDinhCuongChe : '';
        item.ngayBanHanhCuongChe = this.state.ngayBanHanhCuongChe ? (0, _moment2.default)(this.state.ngayBanHanhCuongChe).toISOString() : null;

        item.coQuanBanHanhCuongChe = this.state.coQuanBanHanhCuongChe ? this.state.coQuanBanHanhCuongChe : '';
        item.soTienCuongChe = this.state.soTienCuongChe ? this.state.soTienCuongChe : '';
        item.thoiGianThucHienCuongChe = this.state.thoiGianThucHienCuongChe ? (0, _moment2.default)(this.state.thoiGianThucHienCuongChe).toISOString() : null;
        item.toChucTinDungThucHienCuongChe = this.state.toChucTinDungThucHienCuongChe ? this.state.toChucTinDungThucHienCuongChe : '';
        item.tinhHinhTienDoThucHienCuongChe = this.state.tinhHinhTienDoThucHienCuongChe ? this.state.tinhHinhTienDoThucHienCuongChe : '';
        item.hinhThucCuongChe = this.state.hinhThucCuongChe ? this.state.hinhThucCuongChe : '';
      } else {
        item.soQuyetDinhCuongChe = '';
        item.ngayBanHanhCuongChe = null;

        item.coQuanBanHanhCuongChe = '';
        item.soTienCuongChe = '';
        item.thoiGianThucHienCuongChe = null;
        item.toChucTinDungThucHienCuongChe = '';
        item.tinhHinhTienDoThucHienCuongChe = '';
        item.hinhThucCuongChe = '';
      }
      if (this.state.huyCuongChe) {
        item.huyCuongChe = true;
        item.soQuyetDinhHuyCuongChe = this.state.soQuyetDinhHuyCuongChe ? this.state.soQuyetDinhHuyCuongChe : '';
        item.ngayBanHanhHuyCuongChe = this.state.ngayBanHanhHuyCuongChe ? (0, _moment2.default)(this.state.ngayBanHanhHuyCuongChe).toISOString() : null;
        item.coQuanBanHanhHuyCuongChe = this.state.coQuanBanHanhHuyCuongChe ? this.state.coQuanBanHanhHuyCuongChe : '';
        item.thoiGianThucHienHuyCuongChe = this.state.thoiGianThucHienHuyCuongChe ? (0, _moment2.default)(this.state.thoiGianThucHienHuyCuongChe).toISOString() : null;
        item.toChucTinDungThucHienHuyCuongChe = this.state.toChucTinDungThucHienHuyCuongChe ? this.state.toChucTinDungThucHienHuyCuongChe : '';
        item.ghiChu = this.state.ghiChu ? this.state.ghiChu : '';
      } else {
        item.huyCuongChe = false;
        item.soQuyetDinhHuyCuongChe = '';
        item.ngayBanHanhHuyCuongChe = null;
        item.coQuanBanHanhHuyCuongChe = '';
        item.thoiGianThucHienHuyCuongChe = null;
        item.toChucTinDungThucHienHuyCuongChe = '';
        item.ghiChu = '';
      }

      delete item['_links'];
      delete item['nguoiSuaInfo'];
      delete item['nguoiTaoInfo'];
      delete item['ngaySua'];
      delete item['ngayTao'];

      delete item['hinhThucDonDocInfo'];
      delete item['ketQuaThucHienInfo'];
      delete item['listTaiLieuDonDoc'];
      delete item['donDocDoiTuongId'];

      if (this.state.id) {
        this.props.onChange(item, this.state.id);
      } else {
        this.props.onChange(item, this.props.indexItem);
      }
    }
  }, {
    key: 'onRemove',
    value: function onRemove() {
      this.setState({
        openDialog: false
      });
      if (this.state.id) {
        this.props.onRemove(this.props.indexItem, this.state.id);
      } else {
        this.props.onRemove(this.props.indexItem);
      }
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        openDialog: true
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.setState({
        openDialog: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.countItem <= 1 },
          _react2.default.createElement(
            'div',
            { className: 'justify-content mb15' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mt15' },
              (this.props.toChucLienQuan ? '2' : '3') + '.1. \u0110\xF4n \u0111\u1ED1c'
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.countItem > 1 },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.index > 0 },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt15 justify-content mb15' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12' },
              (this.props.toChucLienQuan ? '2' : '3') + '.' + (this.props.index + 1) + '. L\u1EA7n \u0111\xF4n \u0111\u1ED1c s\u1ED1 ' + (this.props.index + 1)
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.enableDelete },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'itt-delete', onClick: this.openDialog.bind(this) },
                'X\xF3a'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataHinhThucDonDoc, bindValidator: this, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'H\xECnh th\u1EE9c \u0111\xF4n \u0111\u1ED1c', selectedValue: this.state.hinhThucDonDoc, onChange: this.onChange.bind(this, 'hinhThucDonDoc'), name: 'hinhThucDonDoc' }),
          _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', bindValidator: this, channel: 'formTaoDon', label: 'S\u1ED1 v\u0103n b\u1EA3n', value: this.state.soVanBan, onChange: this.onChange.bind(this, 'soVanBan'), name: 'soVanBan', maxLength: 255 }),
          _react2.default.createElement(_common.DatePicker, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', label: 'Ng\xE0y ban h\xE0nh', value: this.state.ngayBanHanh, onChange: this.handleChangeDate.bind(this, 'ngayBanHanh'), endDate: new Date(), name: 'ngayBanHanh' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.DatePicker, { label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u', className: 'col-25', value: this.state.ngayBatDauDonDoc, onChange: this.handleChangeDate.bind(this, 'ngayBatDauDonDoc'), name: 'ngayBatDauDonDoc', bindValidator: this, channel: 'formTaoDon' }),
          _react2.default.createElement(
            'div',
            { className: 'wrap-thoihan col-25' },
            _react2.default.createElement(_common.Input, { label: 'Th\u1EDDi h\u1EA1n \u0111\xF4n \u0111\u1ED1c (ng\xE0y l\xE0m vi\u1EC7c)', type: 'sdt', className: 'col-100 no-gutter', value: this.state.thoiHanDonDoc, onChange: this.onChange.bind(this, 'thoiHanDonDoc'), name: 'thoiHanDonDoc' }),
            _react2.default.createElement(
              'span',
              { className: 'thoihan-value' },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.state.getThoiHanDonDoc },
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.ngayHetHanDonDoc ? this.state.ngayHetHanDonDoc : ''
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.getThoiHanDonDoc },
                _react2.default.createElement('span', { className: 'icon-loader' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'T\xECnh h\xECnh, ti\u1EBFn \u0111\u1ED9 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn', placeholder: 'Nh\u1EADp...', value: this.state.tinhHinhTienDoThucHienKetLuan, onChange: this.onChange.bind(this, 'tinhHinhTienDoThucHienKetLuan'), name: 'tinhHinhTienDoThucHienKetLuan' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_ttForms.DropDownMulipleUse, { data: this.state.dataKetQuaThucHienDonDoc, keyName: 'giaTri', valueName: 'ten', className: 'col-25', label: 'K\u1EBFt qu\u1EA3 \u0111\xF4n \u0111\u1ED1c', selectedValue: this.state.ketQuaThucHien, onChange: this.onChange.bind(this, 'ketQuaThucHien'), name: 'ketQuaThucHien' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.ketQuaThucHien == 'CHUA_THUC_HIEN' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'h2',
              { className: 'col-100 txt-bold txt-upper mb15 text-14' },
              'C\u01B0\u1EE1ng ch\u1EBF'
            ),
            _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', bindValidator: this, channel: 'formTaoDon', require: true, label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh c\u01B0\u1EE1ng ch\u1EBF', value: this.state.soQuyetDinhCuongChe, onChange: this.onChange.bind(this, 'soQuyetDinhCuongChe'), name: 'soQuyetDinhCuongChe', maxLength: 255 }),
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', bindValidator: this, endDate: new Date(), channel: 'formTaoDon', require: true, label: 'Ng\xE0y ban h\xE0nh', value: this.state.ngayBanHanhCuongChe, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhCuongChe'), name: 'ngayBanHanhCuongChe' }),
            _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'C\u01A1 quan ban h\xE0nh', value: this.state.coQuanBanHanhCuongChe, onChange: this.onChange.bind(this, 'coQuanBanHanhCuongChe'), name: 'coQuanBanHanhCuongChe' }),
            _react2.default.createElement(_common.Input, { className: 'col-25', type: 'sdt', align: 'right', placeholder: 'Nh\u1EADp...', label: 'S\u1ED1 ti\u1EC1n (\u0111)', value: this.state.soTienCuongChe, onChange: this.onChange.bind(this, 'soTienCuongChe'), name: 'soTienCuongChe' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Th\u1EDDi gian th\u1EF1c hi\u1EC7n', value: this.state.thoiGianThucHienCuongChe, onChange: this.handleChangeDate.bind(this, 'thoiGianThucHienCuongChe'), name: 'thoiGianThucHienCuongChe' }),
            _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'T\u1ED5 ch\u1EE9c t\xEDn d\u1EE5ng th\u1EF1c hi\u1EC7n', value: this.state.toChucTinDungThucHienCuongChe, onChange: this.onChange.bind(this, 'toChucTinDungThucHienCuongChe'), name: 'toChucTinDungThucHienCuongChe' }),
            _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'T\xECnh h\xECnh ti\u1EBFn \u0111\u1ED9 th\u1EF1c hi\u1EC7n', value: this.state.tinhHinhTienDoThucHienCuongChe, onChange: this.onChange.bind(this, 'tinhHinhTienDoThucHienCuongChe'), name: 'tinhHinhTienDoThucHienCuongChe' }),
            _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'H\xECnh th\u1EE9c c\u01B0\u1EE1ng ch\u1EBF', value: this.state.hinhThucCuongChe, onChange: this.onChange.bind(this, 'hinhThucCuongChe'), name: 'hinhThucCuongChe' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement(
              _utils.ShowIfCheck,
              { titleClass: 'txt-black txt-bold txt-upper mb10 text-14 lable-title-custom', className: 'row pl15 pr15', label: 'H\u1EE7y c\u01B0\u1EE1ng ch\u1EBF', onChange: this.handleCheck.bind(this, 'huyCuongChe'), name: 'huyCuongChe', checked: this.state.huyCuongChe },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', bindValidator: this, channel: 'formTaoDon', require: true, label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh h\u1EE7y c\u01B0\u1EE1ng ch\u1EBF', value: this.state.soQuyetDinhHuyCuongChe, onChange: this.onChange.bind(this, 'soQuyetDinhHuyCuongChe'), name: 'soQuyetDinhHuyCuongChe', maxLength: 255 }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', bindValidator: this, channel: 'formTaoDon', endDate: new Date(), require: true, label: 'Ng\xE0y ban h\xE0nh', value: this.state.ngayBanHanhHuyCuongChe, onChange: this.handleChangeDate.bind(this, 'ngayBanHanhHuyCuongChe'), name: 'ngayBanHanhHuyCuongChe' }),
                _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'C\u01A1 quan ban h\xE0nh', value: this.state.coQuanBanHanhHuyCuongChe, onChange: this.onChange.bind(this, 'coQuanBanHanhHuyCuongChe'), name: 'coQuanBanHanhHuyCuongChe' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Th\u1EDDi gian th\u1EF1c hi\u1EC7n', value: this.state.thoiGianThucHienHuyCuongChe, onChange: this.handleChangeDate.bind(this, 'thoiGianThucHienHuyCuongChe'), name: 'thoiGianThucHienHuyCuongChe' }),
                _react2.default.createElement(_common.Input, { className: 'col-25', placeholder: 'Nh\u1EADp...', label: 'T\u1ED5 ch\u1EE9c t\xEDn d\u1EE5ng th\u1EF1c hi\u1EC7n', value: this.state.toChucTinDungThucHienHuyCuongChe, onChange: this.onChange.bind(this, 'toChucTinDungThucHienHuyCuongChe'), name: 'toChucTinDungThucHienHuyCuongChe' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'Ghi ch\xFA', placeholder: 'Nh\u1EADp...', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), name: 'ghiChu', maxLength: 1000 })
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.openDialog,
            onClose: this.closeDialog.bind(this),
            title: 'X\xE1c nh\u1EADn',
            className: 'reception-dialog delete-dialog wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'pt-dialog-body mb0' },
            _react2.default.createElement(
              'p',
              { className: 'pt10 pb20 txt-center' },
              'B\u1EA1n c\xF3 mu\u1ED1n x\xF3a l\u1EA7n \u0111\xF4n \u0111\u1ED1c n\xE0y?'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'box-bottom col-100' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-close action-todo', onClick: this.closeDialog.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'Kh\xF4ng'
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-action btn-green action-todo', onClick: this.onRemove.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                '\u0110\u1ED3ng \xFD'
              )
            )
          )
        )
      );
    }
  }]);

  return DonDocDoiTuong;
}(_react2.default.Component);

DonDocDoiTuong.defaultProps = {
  validators: {
    formTaoDon: []
  },
  enableDelete: false,
  dataDetail: []
};

exports.default = (0, _utils.validatable)(DonDocDoiTuong);

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DonDocDoiTuongView = function (_React$Component) {
  _inherits(DonDocDoiTuongView, _React$Component);

  function DonDocDoiTuongView(props, context) {
    _classCallCheck(this, DonDocDoiTuongView);

    var _this = _possibleConstructorReturn(this, (DonDocDoiTuongView.__proto__ || Object.getPrototypeOf(DonDocDoiTuongView)).call(this, props, context));

    _this.state = {
      //bool
      dataDetail: _this.props.dataDetail,
      getThoiHanDonDoc: false,
      enableDelete: _this.props.enableDelete,

      coQuanBanHanhCuongChe: _this.props.coQuanBanHanhCuongChe ? _this.props.coQuanBanHanhCuongChe : '',
      coQuanBanHanhHuyCuongChe: _this.props.coQuanBanHanhHuyCuongChe ? _this.props.coQuanBanHanhHuyCuongChe : '',
      doiTuongViPham: _this.props.doiTuongViPham ? _this.props.doiTuongViPham : '',
      ghiChu: _this.props.ghiChu ? _this.props.ghiChu : '',
      hinhThucCuongChe: _this.props.hinhThucCuongChe ? _this.props.hinhThucCuongChe : '',
      hinhThucDonDoc: _this.props.hinhThucDonDocInfo ? _this.props.hinhThucDonDocInfo.text : '',
      huyCuongChe: _this.props.huyCuongChe ? _this.props.huyCuongChe : false,
      id: _this.props.donDocDoiTuongId ? _this.props.donDocDoiTuongId : '',
      ketQuaThucHien: _this.props.ketQuaThucHienInfo ? _this.props.ketQuaThucHienInfo.text : '',
      ngayBanHanh: _this.props.ngayBanHanh ? (0, _moment2.default)(_this.props.ngayBanHanh).format('DD/MM/YYYY') : '',
      ngayBanHanhCuongChe: _this.props.ngayBanHanhCuongChe ? (0, _moment2.default)(_this.props.ngayBanHanhCuongChe).format('DD/MM/YYYY') : '',
      ngayBanHanhHuyCuongChe: _this.props.ngayBanHanhHuyCuongChe ? (0, _moment2.default)(_this.props.ngayBanHanhHuyCuongChe).format('DD/MM/YYYY') : '',
      ngayBatDauDonDoc: _this.props.ngayBatDauDonDoc ? (0, _moment2.default)(_this.props.ngayBatDauDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDoc: _this.props.ngayHetHanDonDoc ? (0, _moment2.default)(_this.props.ngayHetHanDonDoc).format('DD/MM/YYYY') : '',
      ngayHetHanDonDocISO: _this.props.ngayHetHanDonDoc ? _this.props.ngayHetHanDonDoc : '',
      soQuyetDinhCuongChe: _this.props.soQuyetDinhCuongChe ? _this.props.soQuyetDinhCuongChe : '',
      soQuyetDinhHuyCuongChe: _this.props.soQuyetDinhHuyCuongChe ? _this.props.soQuyetDinhHuyCuongChe : '',
      soTienCuongChe: _this.props.soTienCuongChe ? _this.props.soTienCuongChe : '',
      soVanBan: _this.props.soVanBan ? _this.props.soVanBan : '',
      thoiGianThucHienCuongChe: _this.props.thoiGianThucHienCuongChe ? (0, _moment2.default)(_this.props.thoiGianThucHienCuongChe).format('DD/MM/YYYY') : '',
      thoiGianThucHienHuyCuongChe: _this.props.thoiGianThucHienHuyCuongChe ? (0, _moment2.default)(_this.props.thoiGianThucHienHuyCuongChe).format('DD/MM/YYYY') : '',
      thoiHanDonDoc: _this.props.thoiHanDonDoc ? _this.props.thoiHanDonDoc : 0,
      thoiHanNgayLamViecDonDoc: _this.props.thoiHanNgayLamViecDonDoc ? _this.props.thoiHanNgayLamViecDonDoc : '',
      tinhHinhTienDoThucHienCuongChe: _this.props.tinhHinhTienDoThucHienCuongChe ? _this.props.tinhHinhTienDoThucHienCuongChe : '',
      tinhHinhTienDoThucHienKetLuan: _this.props.tinhHinhTienDoThucHienKetLuan ? _this.props.tinhHinhTienDoThucHienKetLuan : '',
      toChucTinDungThucHienCuongChe: _this.props.toChucTinDungThucHienCuongChe ? _this.props.toChucTinDungThucHienCuongChe : '',
      toChucTinDungThucHienHuyCuongChe: _this.props.toChucTinDungThucHienHuyCuongChe ? _this.props.toChucTinDungThucHienHuyCuongChe : '',

      dataKetQuaThucHienDonDoc: _this.props.dataKetQuaThucHienDonDoc,
      dataHinhThucDonDoc: _this.props.dataHinhThucDonDoc
    };
    return _this;
  }

  _createClass(DonDocDoiTuongView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.countItem <= 1 },
          _react2.default.createElement(
            'div',
            { className: 'justify-content mb15' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12 mt15' },
              (this.props.toChucLienQuan ? '2' : '3') + '.1. \u0110\xF4n \u0111\u1ED1c'
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.countItem > 1 },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.index > 0 },
            _react2.default.createElement('div', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt15 justify-content mb15' },
            _react2.default.createElement(
              'h2',
              { className: 'title-12' },
              (this.props.toChucLienQuan ? '2' : '3') + '.' + (this.props.index + 1) + '. L\u1EA7n \u0111\xF4n \u0111\u1ED1c s\u1ED1 ' + (this.props.index + 1)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'H\xECnh th\u1EE9c \u0111\xF4n \u0111\u1ED1c:', value: this.state.hinhThucDonDoc }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 v\u0103n b\u1EA3n:', value: this.state.soVanBan }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.state.ngayBanHanh })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y b\u1EAFt \u0111\u1EA7u:', value: this.state.ngayBatDauDonDoc }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi h\u1EA1n \u0111\xF4n \u0111\u1ED1c (ng\xE0y l\xE0m vi\u1EC7c):', value: this.state.thoiHanDonDoc + ' ng\xE0y (' + this.state.ngayHetHanDonDoc + ')' }),
          _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'T\xECnh h\xECnh, ti\u1EBFn \u0111\u1ED9 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn:', value: this.state.tinhHinhTienDoThucHienKetLuan }),
          _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'K\u1EBFt qu\u1EA3 \u0111\xF4n \u0111\u1ED1c:', value: this.state.ketQuaThucHien })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.ketQuaThucHien == 'CHUA_THUC_HIEN' },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(
              'h2',
              { className: 'col-100 txt-bold txt-upper mb15 text-14 mt5' },
              'C\u01B0\u1EE1ng ch\u1EBF'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh c\u01B0\u1EE1ng ch\u1EBF:', value: this.state.soQuyetDinhCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.state.ngayBanHanhCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh:', value: this.state.coQuanBanHanhCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 ti\u1EC1n (\u0111):', value: this.state.soTienCuongChe })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian th\u1EF1c hi\u1EC7n:', value: this.state.thoiGianThucHienCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c t\xEDn d\u1EE5ng th\u1EF1c hi\u1EC7n:', value: this.state.toChucTinDungThucHienCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\xECnh h\xECnh ti\u1EBFn \u0111\u1ED9 th\u1EF1c hi\u1EC7n:', value: this.state.tinhHinhTienDoThucHienCuongChe }),
            _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'H\xECnh th\u1EE9c c\u01B0\u1EE1ng ch\u1EBF:', value: this.state.hinhThucCuongChe })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.huyCuongChe },
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(
                  'h2',
                  { className: 'col-100 txt-bold txt-upper mb15 text-14 mt5' },
                  'H\u1EE7y c\u01B0\u1EE1ng ch\u1EBF'
                ),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh h\u1EE7y c\u01B0\u1EE1ng ch\u1EBF:', value: this.state.soQuyetDinhHuyCuongChe }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Ng\xE0y ban h\xE0nh:', value: this.state.ngayBanHanhHuyCuongChe }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'C\u01A1 quan ban h\xE0nh:', value: this.state.coQuanBanHanhHuyCuongChe }),
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Ghi ch\xFA:', value: this.state.ghiChu })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'Th\u1EDDi gian th\u1EF1c hi\u1EC7n:', value: this.state.thoiGianThucHienHuyCuongChe }),
                _react2.default.createElement(_common.Text, { className: 'col-25 mb10', label: 'T\u1ED5 ch\u1EE9c t\xEDn d\u1EE5ng th\u1EF1c hi\u1EC7n:', value: this.state.toChucTinDungThucHienHuyCuongChe })
              ),
              _react2.default.createElement(
                'div',
                { className: 'row pl10 pr10' },
                _react2.default.createElement(_common.TextMessage, { className: 'col-100 mb10', label: 'Ghi ch\xFA:', value: this.state.ghiChu })
              )
            )
          )
        )
      );
    }
  }]);

  return DonDocDoiTuongView;
}(_react2.default.Component);

DonDocDoiTuongView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  enableDelete: false,
  dataDetail: []
};

exports.default = DonDocDoiTuongView;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRouter = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanNopTien = function (_React$Component) {
  _inherits(LanNopTien, _React$Component);

  function LanNopTien(props, context) {
    _classCallCheck(this, LanNopTien);

    var _this = _possibleConstructorReturn(this, (LanNopTien.__proto__ || Object.getPrototypeOf(LanNopTien)).call(this, props, context));

    _this.state = {
      index: _this.props.index,
      id: _this.props.theoDoiLanNopTienId ? _this.props.theoDoiLanNopTienId : '',
      ngayNopTien: _this.props.ngayNopTien ? new Date(_this.props.ngayNopTien) : '',
      soTien: _this.props.soTien ? _this.props.soTien : '',
      tongCong: _this.props.tongCong ? _this.props.tongCong : '',
      conPhaiThu: _this.props.conPhaiThu ? _this.props.conPhaiThu : ''
    };
    return _this;
  }

  _createClass(LanNopTien, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps != this.props) {
        this.setState({
          index: nextProps.index,
          id: nextProps.theoDoiLanNopTienId ? nextProps.theoDoiLanNopTienId : '',
          ngayNopTien: nextProps.ngayNopTien ? new Date(nextProps.ngayNopTien) : '',
          soTien: nextProps.soTien ? nextProps.soTien : '',
          tongCong: nextProps.tongCong ? nextProps.tongCong : '',
          conPhaiThu: nextProps.conPhaiThu ? nextProps.conPhaiThu : ''
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      var _this2 = this;

      this.setState(_defineProperty({}, name, e.target.value), function () {
        var data = {
          ngayNopTien: _this2.state.ngayNopTien ? (0, _moment2.default)(_this2.state.ngayNopTien).toISOString() : null,
          soTien: _this2.state.soTien ? _this2.state.soTien : '',
          tongCong: _this2.state.tongCong ? _this2.state.tongCong : '',
          conPhaiThu: _this2.state.conPhaiThu ? _this2.state.conPhaiThu : ''
        };
        if (_this2.state.id) {
          data.id = _this2.state.id;
        }
        _this2.props.onChange(data, _this2.state.index - 1);
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      var _this3 = this;

      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d), function () {
          var data = {
            ngayNopTien: _this3.state.ngayNopTien ? (0, _moment2.default)(_this3.state.ngayNopTien).toISOString() : null,
            soTien: _this3.state.soTien ? _this3.state.soTien : '',
            tongCong: _this3.state.tongCong ? _this3.state.tongCong : '',
            conPhaiThu: _this3.state.conPhaiThu ? _this3.state.conPhaiThu : ''
          };
          if (_this3.state.id) {
            data.id = _this3.state.id;
          }
          _this3.props.onChange(data, _this3.state.index - 1);
        });
      } else {
        this.setState(_defineProperty({}, name, e), function () {
          var data = {
            ngayNopTien: _this3.state.ngayNopTien ? (0, _moment2.default)(_this3.state.ngayNopTien).toISOString() : null,
            soTien: _this3.state.soTien ? _this3.state.soTien : '',
            tongCong: _this3.state.tongCong ? _this3.state.tongCong : '',
            conPhaiThu: _this3.state.conPhaiThu ? _this3.state.conPhaiThu : ''
          };
          if (_this3.state.id) {
            data.id = _this3.state.id;
          }
          _this3.props.onChange(data, _this3.state.index - 1);
        });
      }
    }
  }, {
    key: 'onRemove',
    value: function onRemove() {
      this.props.onRemove(this.state.index - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'col-100 block-gray p15 mb15' },
        _react2.default.createElement(
          'div',
          { className: 'justify-content mb15' },
          _react2.default.createElement(
            'h2',
            { className: 'txt-bold txt-upper txt-12' },
            'L\u1EA7n n\u1ED9p s\u1ED1 ' + this.state.index
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.view != true },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'itt-delete', onClick: this.onRemove.bind(this) },
              'X\xF3a'
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view != true },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.DatePicker, { className: 'col-25 mb0-18', label: 'Ng\xE0y n\u1ED9p ti\u1EC1n', value: this.state.ngayNopTien, onChange: this.handleChangeDate.bind(this, 'ngayNopTien'), name: 'ngayNopTien' }),
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-25 mb0-18', label: 'S\u1ED1 ti\u1EC1n (\u0111)', value: this.state.soTien, onChange: this.onChange.bind(this, 'soTien'), name: 'soTien' }),
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-25 mb0-18', label: 'T\u1ED5ng c\u1ED9ng (\u0111)', value: this.state.tongCong, onChange: this.onChange.bind(this, 'tongCong'), name: 'tongCong' }),
            _react2.default.createElement(_common.Input, { type: 'sdt', align: 'right', className: 'col-25 mb0-18', label: 'C\xF2n ph\u1EA3i thu (\u0111)', value: this.state.conPhaiThu, onChange: this.onChange.bind(this, 'conPhaiThu'), name: 'conPhaiThu' })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.view === true },
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10' },
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'Ng\xE0y n\u1ED9p ti\u1EC1n:', value: this.props.ngayNopTien ? (0, _moment2.default)(this.props.ngayNopTien).format('DD/MM/YYYY') : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'S\u1ED1 ti\u1EC1n (\u0111):', value: this.props.soTien ? this.props.soTien : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'T\u1ED5ng c\u1ED9ng (\u0111):', value: this.props.tongCong ? this.props.tongCong : '' }),
            _react2.default.createElement(_common.Text, { className: 'col-25', label: 'C\xF2n ph\u1EA3i thu (\u0111):', value: this.props.conPhaiThu ? this.props.conPhaiThu : '' })
          )
        )
      );
    }
  }]);

  return LanNopTien;
}(_react2.default.Component);

exports.default = LanNopTien;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _DoiTuongKienNghi = __webpack_require__(1394);

var _DoiTuongKienNghi2 = _interopRequireDefault(_DoiTuongKienNghi);

var _ToChucLienQuan = __webpack_require__(497);

var _ToChucLienQuan2 = _interopRequireDefault(_ToChucLienQuan);

var _datatable = __webpack_require__(495);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { ShowIf} from 'components/utils';


var NoiDungKienNghi = function (_React$Component) {
  _inherits(NoiDungKienNghi, _React$Component);

  function NoiDungKienNghi(props, context) {
    _classCallCheck(this, NoiDungKienNghi);

    var _this = _possibleConstructorReturn(this, (NoiDungKienNghi.__proto__ || Object.getPrototypeOf(NoiDungKienNghi)).call(this, props, context));

    _this.state = {
      showDoiTuongKienNghi: false,
      showToChucLienQuan: false,
      type: _this.props.type,
      id: _this.props.id,
      idEdit: '',
      titleDialog: '',

      kienNghi: {
        tongToChucKienNghiXuLyHanhChinh: 0,
        tongCaNhanKienNghiXuLyHanhChinh: 0,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
        tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
        tongSaiPhamVeTienKienNghiXuLyKhac: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
      },

      theoDoi: {
        tongToChucKienNghiXuLyHanhChinh: 0,
        tongCaNhanKienNghiXuLyHanhChinh: 0,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
        tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
        tongSaiPhamVeTienKienNghiXuLyKhac: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
      },

      listDoiTuongThanhTra: _this.props.listDoiTuongThanhTra,
      dataDoiTuongViPham: [],
      dataCoQuanToChuc: []
    };
    return _this;
  }

  _createClass(NoiDungKienNghi, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListDaTaDoiTuongViPham();
      this.getListDaTaCoQuanToChuc();
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'getListDaTaDoiTuongViPham',
    value: function getListDaTaDoiTuongViPham(type) {
      var _this2 = this;

      _api.ThanhTra.actions.getDoiTuongViPham.request({ cuocThanhTraId: this.state.id, loaiDoiTuongTheoDoi: 'DOI_TUONG_THEO_DOI' }).then(function (res) {
        if (res.data._embedded) {
          _this2.state.dataDoiTuongViPham = res.data._embedded.doiTuongViPhams;
          _this2.setState(_extends({}, _this2.state), function () {
            _this2.checkSumTheoDoi();
            _this2.checkSumKienNghi();
            _this2.checkAllowKetThucTheoDoi();
          });
        } else {
          _this2.state.dataDoiTuongViPham = [];
          _this2.setState(_extends({}, _this2.state), function () {
            _this2.checkSumTheoDoi();
            _this2.checkSumKienNghi();
            _this2.checkAllowKetThucTheoDoi();
          });
        }
      });
    }
  }, {
    key: 'getListDaTaCoQuanToChuc',
    value: function getListDaTaCoQuanToChuc() {
      var _this3 = this;

      _api.ThanhTra.actions.getDoiTuongViPham.request({ cuocThanhTraId: this.state.id, loaiDoiTuongTheoDoi: 'CO_QUAN_TO_CHUC_LIEN_QUAN' }).then(function (res) {
        if (res.data._embedded) {
          _this3.state.dataCoQuanToChuc = res.data._embedded.doiTuongViPhams;
          _this3.setState(_extends({}, _this3.state), function () {
            _this3.checkSumTheoDoi();
            _this3.checkAllowKetThucTheoDoi();
          });
        } else {
          _this3.state.dataCoQuanToChuc = [];
          _this3.setState(_extends({}, _this3.state), function () {
            _this3.checkSumTheoDoi();
            _this3.checkAllowKetThucTheoDoi();
          });
        }
      });
    }
  }, {
    key: 'checkAllowKetThucTheoDoi',
    value: function checkAllowKetThucTheoDoi() {
      var dataDoiTuongViPham = [].concat(_toConsumableArray(this.state.dataDoiTuongViPham));
      var dataCoQuanToChuc = [].concat(_toConsumableArray(this.state.dataCoQuanToChuc));
      var dataDoiTuongViPhamFilter = dataDoiTuongViPham.filter(function (state) {
        return state.tienDo != 'HOAN_THANH';
      });
      var dataCoQuanToChucFilter = dataCoQuanToChuc.filter(function (state) {
        return state.tienDo != 'HOAN_THANH';
      });

      if (dataCoQuanToChucFilter.length === 0 & dataDoiTuongViPhamFilter.length === 0) {
        this.props.setEnableKetThuc(true);
      } else {
        this.props.setEnableKetThuc(false);
      }
    }
  }, {
    key: 'clearDataContain',
    value: function clearDataContain(name) {
      var _this4 = this;

      var data = [].concat(_toConsumableArray(this.state.dataDoiTuongViPham));
      var dataFilter = data.filter(function (item) {
        return name == item.ten;
      });

      if (dataFilter.length > 0) {
        var params = { doiTuongViPhams: [] };
        dataFilter.map(function (item) {
          params.doiTuongViPhams[params.doiTuongViPhams.length] = {
            id: item.doiTuongViPhamId
          };
        });
        _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
          (0, _toastr.Toastr)('Xóa đối tượng vi phạm thành công', 'success');
          _this4.getListDaTa();
        });
      } else {
        (0, _toastr.Toastr)('Dữ liệu không tồn tại', 'error');
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      var _this5 = this;

      var params = { doiTuongViPhams: [] };
      this.state.dataDoiTuongViPham.map(function (item) {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        };
      });
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
        (0, _toastr.Toastr)('Xóa tất cả đối tượng vi phạm thành công', 'success');
        _this5.getListDaTa();
      });
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      var params = { doiTuongViPhams: [] };
      this.state.dataDoiTuongViPham.map(function (item) {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        };
      });
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params);
    }
  }, {
    key: 'checkSumKienNghi',
    value: function checkSumKienNghi() {
      if (this.state.dataDoiTuongViPham.length > 0) {
        var tongToChucKienNghiXuLyHanhChinh = 0;
        var tongCaNhanKienNghiXuLyHanhChinh = 0;
        var tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
        var tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
        var tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
        var tongSaiPhamVeTienKienNghiXuLyKhac = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
        this.state.dataDoiTuongViPham.map(function (item) {
          var toChucCoSaiPham = item.toChucCoSaiPham;
          var dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
          if (dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
            tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length;
          }
          var caNhanCoSaiPham = item.caNhanCoSaiPham;
          var dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
          if (dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
            tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length;
          }
          tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecKienNghiChuyenCoQuanDieuTra;
          tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.tienKienNghiXuLyKhac;
          tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.datKienNghiXuLyKhac;
          tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + item.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeTienKienNghiKhacXuLyVeKinhTe;
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeDatKienNghiKhacXuLyVeKinhTe;
          if (item.chuyenCoQuanDieuTra) {
            tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + 1;
          }
        });
        this.setState({
          kienNghi: {
            tongToChucKienNghiXuLyHanhChinh: tongToChucKienNghiXuLyHanhChinh,
            tongCaNhanKienNghiXuLyHanhChinh: tongCaNhanKienNghiXuLyHanhChinh,
            tongSaiPhamVeTienKienNghiXuLyKinhTe: tongSaiPhamVeTienKienNghiXuLyKinhTe,
            tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: tongSaiPhamVeDatDaiKienNghiXuLyKinhTe,
            tongVuViecKienNghiChuyenCoQuanDieuTra: tongVuViecKienNghiChuyenCoQuanDieuTra,
            tongDoiTuongKienNghiChuyenCoQuanDieuTra: tongDoiTuongKienNghiChuyenCoQuanDieuTra,
            tongSaiPhamVeTienKienNghiXuLyKhac: tongSaiPhamVeTienKienNghiXuLyKhac,
            tongSaiPhamVeDatDaiKienNghiXuLyKhac: tongSaiPhamVeDatDaiKienNghiXuLyKhac
          }
        });
      } else {
        this.setState({
          kienNghi: {
            tongToChucKienNghiXuLyHanhChinh: 0,
            tongCaNhanKienNghiXuLyHanhChinh: 0,
            tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
            tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
            tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
            tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
            tongSaiPhamVeTienKienNghiXuLyKhac: 0,
            tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
          }
        });
      }
    }
  }, {
    key: 'checkSumTheoDoi',
    value: function checkSumTheoDoi() {
      var _this6 = this;

      if (this.state.dataDoiTuongViPham.length > 0) {
        var tongToChucKienNghiXuLyHanhChinh = 0;
        var tongCaNhanKienNghiXuLyHanhChinh = 0;
        var tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
        var tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
        var tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
        var tongSaiPhamVeTienKienNghiXuLyKhac = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
        this.state.dataDoiTuongViPham.map(function (item) {
          var toChucCoSaiPham = item.theoDoiToChucCoSaiPham ? item.theoDoiToChucCoSaiPham : '';
          var dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
          if (dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
            tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length;
          }
          var caNhanCoSaiPham = item.theoDoiCaNhanCoSaiPham ? item.theoDoiCaNhanCoSaiPham : '';
          var dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
          if (dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
            tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length;
          }

          var tongDoiTuongKienNghi = item.soDoiTuongTheoDoiXuLyHinhSu ? item.soDoiTuongTheoDoiXuLyHinhSu : '';
          var dataDoiTuongKienNghi = tongDoiTuongKienNghi.split('; ');
          if (dataDoiTuongKienNghi.length > 0 && dataDoiTuongKienNghi[0] != '') {
            tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + dataDoiTuongKienNghi.length;
          }

          var saiPhamVeTienKienNghiXuLyKinhTe = 0;
          if (item.listTheoDoiLanNopTien.length > 0) {
            item.listTheoDoiLanNopTien.map(function (items) {
              saiPhamVeTienKienNghiXuLyKinhTe = saiPhamVeTienKienNghiXuLyKinhTe + items.soTien;
            });
          }

          tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecTheoDoiXuLyHinhSu;
          tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.kienNghiTienTheoDoiXuLyKhac;
          tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.kienNghiDatTheoDoiXuLyKhac;
          tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + saiPhamVeTienKienNghiXuLyKinhTe;
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe;
        });
        this.state.theoDoi.tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh;
        this.state.theoDoi.tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh;
        this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe;
        this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe;
        this.state.theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra;
        this.state.theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra;
        this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac;
        this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac;
        this.setState(_extends({}, this.state), function () {
          _this6.checkSumTheoDoiCoQuan();
        });
      } else {
        this.state.theoDoi.tongToChucKienNghiXuLyHanhChinh = 0;
        this.state.theoDoi.tongCaNhanKienNghiXuLyHanhChinh = 0;
        this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
        this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
        this.state.theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
        this.state.theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
        this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac = 0;
        this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
        this.setState(_extends({}, this.state), function () {
          _this6.checkSumTheoDoiCoQuan();
        });
      }
    }
  }, {
    key: 'checkSumTheoDoiCoQuan',
    value: function checkSumTheoDoiCoQuan() {
      if (this.state.dataCoQuanToChuc.length > 0) {
        var tongToChucKienNghiXuLyHanhChinh = 0;
        var tongCaNhanKienNghiXuLyHanhChinh = 0;
        var tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
        var tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
        var tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
        var tongSaiPhamVeTienKienNghiXuLyKhac = 0;
        var tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
        this.state.dataCoQuanToChuc.map(function (item) {
          var toChucCoSaiPham = item.theoDoiToChucCoSaiPham ? item.theoDoiToChucCoSaiPham : '';
          var dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
          if (dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
            tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length;
          }
          var caNhanCoSaiPham = item.theoDoiCaNhanCoSaiPham ? item.theoDoiCaNhanCoSaiPham : '';
          var dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
          if (dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
            tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length;
          }

          var tongDoiTuongKienNghi = item.soDoiTuongTheoDoiXuLyHinhSu ? item.soDoiTuongTheoDoiXuLyHinhSu : '';
          var dataDoiTuongKienNghi = tongDoiTuongKienNghi.split('; ');
          if (dataDoiTuongKienNghi.length > 0 && dataDoiTuongKienNghi[0] != '') {
            tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + dataDoiTuongKienNghi.length;
          }

          var saiPhamVeTienKienNghiXuLyKinhTe = 0;
          if (item.listTheoDoiLanNopTien.length > 0) {
            item.listTheoDoiLanNopTien.map(function (items) {
              saiPhamVeTienKienNghiXuLyKinhTe = saiPhamVeTienKienNghiXuLyKinhTe + items.soTien;
            });
          }

          tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecTheoDoiXuLyHinhSu;
          tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.kienNghiTienTheoDoiXuLyKhac;
          tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.kienNghiDatTheoDoiXuLyKhac;
          tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + saiPhamVeTienKienNghiXuLyKinhTe;
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe;
        });
        var theoDoi = this.state.theoDoi;
        this.setState({
          theoDoi: {
            tongToChucKienNghiXuLyHanhChinh: Number(theoDoi.tongToChucKienNghiXuLyHanhChinh + tongToChucKienNghiXuLyHanhChinh),
            tongCaNhanKienNghiXuLyHanhChinh: Number(theoDoi.tongCaNhanKienNghiXuLyHanhChinh + tongCaNhanKienNghiXuLyHanhChinh),
            tongSaiPhamVeTienKienNghiXuLyKinhTe: Number(theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe + tongSaiPhamVeTienKienNghiXuLyKinhTe),
            tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: Number(theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + tongSaiPhamVeDatDaiKienNghiXuLyKinhTe),
            tongVuViecKienNghiChuyenCoQuanDieuTra: Number(theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra + tongVuViecKienNghiChuyenCoQuanDieuTra),
            tongDoiTuongKienNghiChuyenCoQuanDieuTra: Number(theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra + tongDoiTuongKienNghiChuyenCoQuanDieuTra),
            tongSaiPhamVeTienKienNghiXuLyKhac: Number(theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac + tongSaiPhamVeTienKienNghiXuLyKhac),
            tongSaiPhamVeDatDaiKienNghiXuLyKhac: Number(theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac + tongSaiPhamVeDatDaiKienNghiXuLyKhac)
          }
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.type != nextProps.type) {
        this.setState({
          type: nextProps.type
        });
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false));
    }
  }, {
    key: 'handleEditDoiTuongKienNghi',
    value: function handleEditDoiTuongKienNghi(id) {
      var _this7 = this;

      this.setState({
        idEdit: id
      }, function () {
        _this7.setState({
          showDoiTuongKienNghi: true
        });
      });
    }
  }, {
    key: 'handleEditToChucLienQuan',
    value: function handleEditToChucLienQuan(id) {
      var _this8 = this;

      this.setState({
        idEdit: id,
        titleDialog: 'Chỉnh sửa cơ quan, tổ chức có liên quan'
      }, function () {
        _this8.setState({
          showToChucLienQuan: true
        });
      });
    }
  }, {
    key: 'handleAddMore',
    value: function handleAddMore() {
      var _this9 = this;

      this.setState({
        idEdit: null,
        titleDialog: 'Thêm mới cơ quan, tổ chức có liên quan'
      }, function () {
        _this9.setState({
          showToChucLienQuan: true
        });
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(sID) {
      var _this10 = this;

      var params = {
        doiTuongViPhams: [{
          id: sID
        }]
      };
      _api.ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(function (res) {
        (0, _toastr.Toastr)('Xóa đối tượng vi phạm thành công', 'success');
        _this10.getListDaTaCoQuanToChuc();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var KienNghi = this.state.kienNghi;
      var TheoDoi = this.state.theoDoi;
      return _react2.default.createElement(
        'div',
        { className: 'row pl10 pr10' },
        _react2.default.createElement(
          'div',
          { className: 'block-gray col-100 p15 pb0 mb20' },
          _react2.default.createElement(
            'h2',
            { className: 'col-100 mb10 title-12' },
            'K\u1EBFt qu\u1EA3 ki\u1EBFn ngh\u1ECB'
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'T\u1ED5ng vi ph\u1EA1m'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-100', label: 'S\u1ED1 \u0111\u01A1n v\u1ECB vi ph\u1EA1m/\u0111\u01A1n v\u1ECB li\xEAn quan:', value: this.state.dataDoiTuongViPham.length + '/' + this.props.listDoiTuongViPham.length })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD h\xE0nh ch\xEDnh'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng t\u1ED5 ch\u1EE9c:', value: KienNghi.tongToChucKienNghiXuLyHanhChinh ? String(KienNghi.tongToChucKienNghiXuLyHanhChinh) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng c\xE1 nh\xE2n:', value: KienNghi.tongCaNhanKienNghiXuLyHanhChinh ? String(KienNghi.tongCaNhanKienNghiXuLyHanhChinh) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kinh t\u1EBF'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: KienNghi.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(KienNghi.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: KienNghi.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(KienNghi.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: '\u0110\u1ED1i t\u01B0\u1EE3ng:', value: KienNghi.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(KienNghi.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kh\xE1c'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: KienNghi.tongSaiPhamVeTienKienNghiXuLyKhac ? String(KienNghi.tongSaiPhamVeTienKienNghiXuLyKhac) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'block-gray col-100 p15 pb0 mb20' },
          _react2.default.createElement(
            'h2',
            { className: 'col-100 mb10 title-12' },
            'K\u1EBFt qu\u1EA3 theo d\xF5i'
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'T\u1ED5ng vi ph\u1EA1m'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-100', label: 'S\u1ED1 \u0111\u01A1n v\u1ECB vi ph\u1EA1m/\u0111\u01A1n v\u1ECB li\xEAn quan:', value: this.state.dataCoQuanToChuc.length + this.state.dataDoiTuongViPham.length + '/' + (this.props.listDoiTuongViPham.length + this.state.dataCoQuanToChuc.length) })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD h\xE0nh ch\xEDnh'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng t\u1ED5 ch\u1EE9c:', value: TheoDoi.tongToChucKienNghiXuLyHanhChinh ? String(TheoDoi.tongToChucKienNghiXuLyHanhChinh) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'T\u1ED5ng c\xE1 nh\xE2n:', value: TheoDoi.tongCaNhanKienNghiXuLyHanhChinh ? String(TheoDoi.tongCaNhanKienNghiXuLyHanhChinh) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kinh t\u1EBF'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: TheoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(TheoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB chuy\u1EC3n c\u01A1 quan \u0111i\u1EC1u tra'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'S\u1ED1 v\u1EE5 vi\u1EC7c:', value: TheoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(TheoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: '\u0110\u1ED1i t\u01B0\u1EE3ng:', value: TheoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(TheoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-50 no-gutter clear-left mb10' },
            _react2.default.createElement(
              'p',
              { className: 'txt-bold txt-upper mb10 pl5 pr5' },
              'Ki\u1EBFn ngh\u1ECB x\u1EED l\xFD kh\xE1c'
            ),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 ti\u1EC1n (\u0111):', value: TheoDoi.tongSaiPhamVeTienKienNghiXuLyKhac ? String(TheoDoi.tongSaiPhamVeTienKienNghiXuLyKhac) : '0' }),
            _react2.default.createElement(_common.Text, { className: 'col-50', label: 'Sai ph\u1EA1m v\u1EC1 \u0111\u1EA5t \u0111ai (m2):', value: TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100' },
          _react2.default.createElement(
            'h2',
            { className: 'txt-bold txt-upper' },
            '\u0110\u1ED1i t\u01B0\u1EE3ng'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'row white-table' },
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.theoDoiThucHien.danhSachDoiTuongViPham,
                dataList: this.state.dataDoiTuongViPham,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                hidePagination: true,
                showAddMore: false,
                search: true,
                tableLoading: this.state.tableLoading },
              this.props.view === true ? _react2.default.createElement(_datatable.RowItemDoiTuongThanhTraView, { chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, toChucLienQuan: false, linhVucThanhTra: this.props.linhVucThanhTra, handleEdit: this.handleEditToChucLienQuan.bind(this) }) : _react2.default.createElement(_datatable.RowItemDoiTuongThanhTra, { handleEdit: this.handleEditDoiTuongKienNghi.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100' },
          _react2.default.createElement(
            'h2',
            { className: 'txt-bold txt-upper' },
            'C\u01A1 quan t\u1ED5 ch\u1EE9c li\xEAn quan'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter' },
          _react2.default.createElement(
            'div',
            { className: 'row white-table' },
            _react2.default.createElement(
              _dataTable2.default,
              {
                header: _table.header.theoDoiThucHien.danhSachDoiTuongViPham,
                dataList: this.state.dataCoQuanToChuc,
                pageData: this.state.pageData,
                parent: this,
                hideButtonExport: true,
                hidePagination: true,
                titleAddmore: 'Th\xEAm m\u1EDBi c\u01A1 quan, t\u1ED5 ch\u1EE9c c\xF3 li\xEAn quan',
                addMore: this.handleAddMore.bind(this),
                showAddMore: this.props.view ? false : true,
                search: this.props.view ? true : this.state.search,
                tableLoading: this.state.tableLoading },
              this.props.view === true ? _react2.default.createElement(_datatable.RowItemDoiTuongThanhTraView, { chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, linhVucThanhTra: this.props.linhVucThanhTra, toChucLienQuan: true, handleEdit: this.handleEditToChucLienQuan.bind(this) }) : _react2.default.createElement(_datatable.RowItemDoiTuongThanhTra, { enableDelete: true, toChucLienQuan: true, handleEdit: this.handleEditToChucLienQuan.bind(this) })
            )
          )
        ),
        _react2.default.createElement(_DoiTuongKienNghi2.default, { onClose: this.closeDialog.bind(this, 'showDoiTuongKienNghi'), isOpen: this.state.showDoiTuongKienNghi, id: this.state.idEdit, getListDaTa: this.getListDaTaDoiTuongViPham.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, idCuocThanhTra: this.props.id, listDoiTuongViPham: this.props.listDoiTuongViPham, closeDialog: this.closeDialog.bind(this, 'showDoiTuongKienNghi'), linhVucThanhTra: this.props.linhVucThanhTra }),
        _react2.default.createElement(_ToChucLienQuan2.default, { title: this.state.titleDialog, onClose: this.closeDialog.bind(this, 'showToChucLienQuan'), isOpen: this.state.showToChucLienQuan, id: this.state.idEdit, getListDaTa: this.getListDaTaCoQuanToChuc.bind(this), chucNangCuocThanhTra: this.props.chucNangCuocThanhTra, idCuocThanhTra: this.props.id, listDoiTuongViPham: this.props.listDoiTuongViPham, closeDialog: this.closeDialog.bind(this, 'showToChucLienQuan'), linhVucThanhTra: this.props.linhVucThanhTra })
      );
    }
  }]);

  return NoiDungKienNghi;
}(_react2.default.Component);

NoiDungKienNghi.defaultProps = {
  listDoiTuongThanhTra: [],
  listDoiTuongViPham: [],
  dataDoiTuongViPham: [],
  setDoiTuongViPhamHienTai: function setDoiTuongViPhamHienTai() {},
  view: false,
  setCountDoiTuongViPham: function setCountDoiTuongViPham() {}
};

exports.default = NoiDungKienNghi;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = __webpack_require__(13);

var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props, context) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));

    _this.state = {
      linhVucThanhTra: '',
      tienDoThanhTra: '',
      tuNgay: '',
      denNgay: '',
      soQuyetDinh: '',
      searching: _this.props.disabled,
      spSearch: false,
      doSearch: false,
      linhVucThanhTraList: []
    };
    return _this;
  }

  _createClass(Search, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVucThanhTra();
    }
  }, {
    key: 'getLinhVucThanhTra',
    value: function getLinhVucThanhTra() {
      var _this2 = this;

      _api.ThanhTra.actions.getLinhVucThanhTra.request().then(function (res) {
        if (res.data) {
          _this2.setState({ linhVucThanhTraList: res.data });
        } else {
          _this2.setState({ linhVucThanhTraList: [] });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.handleSearch(this.state, e);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'cancel',
    value: function cancel(e) {
      this.props.onCancel(e);
      this.resetData();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.setState({
        linhVucThanhTra: '',
        tienDoThanhTra: '',
        soQuyetDinh: '',
        tuNgay: '',
        denNgay: '',
        searching: false,
        spSearch: false,
        doSearch: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = ['btn-green', 'tt-search'];

      if (this.state.searching) {
        classes.push('btn-disable');
      }
      if (this.state.doSearch) {
        classes.push('btn-loading');
      }

      var btnClasses = classNames(classes);

      return _react2.default.createElement(
        'form',
        { className: 'search-form', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(
          'div',
          { className: this.props.advanceSearch ? 'col-80 mb15' : '' },
          _react2.default.createElement(_common.InputTuKhoa, {
            label: '\u0110\u1ED1i t\u01B0\u1EE3ng thanh tra/ki\u1EC3m tra',
            className: this.props.advanceSearch ? 'col-100' : 'input-show',
            value: this.state.tenDoiTuongThanhTra,
            onChange: this.handleChange.bind(this, 'tenDoiTuongThanhTra'),
            name: 'tenDoiTuongThanhTra',
            placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra, ki\u1EC3m tra \u0111\u1EC3 t\xECm ki\u1EBFm...' })
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.advanceSearch ? 'col-20 mt25 mb15' : "btn-wrap-20" },
          _react2.default.createElement(_core.Button, { className: btnClasses, text: 'T\xECm ki\u1EBFm', type: 'submit', disabled: this.state.searching ? 'disabled' : '' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.advanceSearch },
          _react2.default.createElement(
            'div',
            { className: 'col-80' },
            _react2.default.createElement(_common.DropDown, { label: 'L\u0129nh v\u1EF1c', placeholder: true, selectedValue: this.state.linhVucThanhTra, className: 'col-25', onChange: this.handleChange.bind(this, 'linhVucThanhTra'), name: 'linhVucThanhTra', options: this.state.linhVucThanhTraList, keyName: 'giaTri', valueName: 'ten' }),
            _react2.default.createElement(_common.Input, { label: 'S\u1ED1 quy\u1EBFt \u0111\u1ECBnh', value: this.state.soQuyetDinh, className: 'col-25', onChange: this.handleChange.bind(this, 'soQuyetDinh'), name: 'soQuyetDinh', placeholder: 'Nh\u1EADp...', maxLength: 255 }),
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'Quy\u1EBFt \u0111\u1ECBnh ra t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.handleChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay }),
            _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.handleChangeDate.bind(this, 'denNgay'), value: this.state.denNgay })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-20' },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                className: this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search",
                onClick: this.cancel.bind(this) },
              _react2.default.createElement('i', { className: 'tt tt-delete' }),
              'H\u1EE7y t\xECm ki\u1EBFm n\xE2ng cao'
            )
          )
        )
      );
    }
  }]);

  return Search;
}(_react2.default.Component);

Search.defaultProps = {
  validators: {},
  handleSearch: function handleSearch() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
};

exports.default = (0, _utils.validatable)(Search);

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _core = __webpack_require__(7);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _datatable = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemMoiDoiTuongThanhTra = function (_React$Component) {
  _inherits(ThemMoiDoiTuongThanhTra, _React$Component);

  function ThemMoiDoiTuongThanhTra(props, context) {
    _classCallCheck(this, ThemMoiDoiTuongThanhTra);

    var _this = _possibleConstructorReturn(this, (ThemMoiDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(ThemMoiDoiTuongThanhTra)).call(this, props, context));

    _this.state = {
      isOpen: false,

      linhVucList: [],
      linhVucId: '',
      tuKhoa: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      idSelectedList: [],
      totalSelectedList: [],
      doiTuongTrungList: [],
      popupTrung: false
    };
    return _this;
  }

  _createClass(ThemMoiDoiTuongThanhTra, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLinhVuc();
    }
  }, {
    key: 'getLinhVuc',
    value: function getLinhVuc() {
      var _this2 = this;

      var state = this.state;
      _api.Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(function (res) {
        if (res.data && res.data._embedded) {
          state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
        } else {
          state.linhVucList = [];
        }
        _this2.setState(state);
      });
    }
  }, {
    key: 'timKiem',
    value: function timKiem() {
      var _this3 = this;

      var params = {
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngaySua,desc'
      };
      if (this.state.tuKhoa) {
        params.tuKhoa = this.state.tuKhoa;
      }
      if (this.state.linhVucId) {
        params.linhVucId = this.state.linhVucId;
      }
      var idList = [];
      this.props.importData.map(function (item) {
        if (item.doiTuongThanhTraInfo) {
          idList.push(item.doiTuongThanhTraInfo.doiTuongThanhTraId);
        }
      });
      this.state.doiTuongSelectedList.map(function (item) {
        idList.push(item.doiTuongThanhTraId);
      });
      if (idList.length) {
        params.doiTuongIds = idList.join();
      }
      _api.Danhmuc.actions.getDoiTuongThanhTra.request(null, params).then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            ketQuaTimKiemList: res.data._embedded.doiTuongThanhTras,
            pageData: res.data.page,
            tableLoading: false
          });
        } else {
          _this3.setState({
            ketQuaTimKiemList: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            tableLoading: false
          });
        }
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false), function () {
        if (name === 'popupTrung') {
          document.body.className += ' pt-overlay-open';
        }
      });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.timKiem();
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.props.validators['thanhTra'] = [];
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'checkValidate',
    value: function checkValidate() {
      var pass = true;
      this.props.validators['thanhTra'].map(function (validator) {
        if (pass) pass = validator.validate();else validator.validate();
      });
      return pass;
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      var _this4 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          size: size,
          number: 0
        })
      }, function () {
        _this4.timKiem();
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      var _this5 = this;

      this.setState({
        pageData: _extends({}, this.state.pageData, {
          number: page.selected
        })
      }, function () {
        _this5.timKiem();
      });
    }
  }, {
    key: 'hanldeRemove',
    value: function hanldeRemove(index) {
      var _this6 = this;

      this.setState({ doiTuongSelectedList: [].concat(_toConsumableArray(this.state.doiTuongSelectedList.splice(index, 1))) }, function () {
        _this6.timKiem();
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      this.props.exportData(this.state.doiTuongSelectedList);
      this.setState({
        isOpen: false,
        linhVucId: '',
        tuKhoa: '',
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        },
        ketQuaTimKiemList: [],
        tableLoading: false,
        doiTuongSelectedList: [],
        checkAll: false,
        idSelectedList: [],
        totalSelectedList: []
      });
    }
  }, {
    key: 'handleSelectedDoiTuong',
    value: function handleSelectedDoiTuong(item) {
      var _this7 = this;

      item.selected = !item.selected;
      if (item.selected) {
        this.state.idSelectedList.push(item.doiTuongThanhTraId);
        this.state.totalSelectedList.push(item);
      } else {
        this.state.idSelectedList.splice(this.state.idSelectedList.indexOf(item.doiTuongThanhTraId), 1);
        this.state.totalSelectedList.map(function (value, index) {
          if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
            _this7.state.totalSelectedList.splice(index, 1);
          }
        });
      }
      this.setState(_extends({}, this.state));
    }
  }, {
    key: 'handleSelectedAll',
    value: function handleSelectedAll() {
      var newState = _extends({}, this.state);
      newState.checkAll = !newState.checkAll;
      newState.ketQuaTimKiemList.map(function (item) {
        item.selected = newState.checkAll;
        if (newState.checkAll) {
          if (newState.idSelectedList.indexOf(item.doiTuongThanhTraId) == -1) {
            newState.idSelectedList.push(item.doiTuongThanhTraId);
            newState.totalSelectedList.push(item);
          }
        } else {
          newState.idSelectedList = [];
          newState.totalSelectedList = [];
        }
      });

      this.setState(_extends({}, newState));
    }
  }, {
    key: 'themVaoCuocTT',
    value: function themVaoCuocTT() {
      var _this8 = this;

      var newState = _extends({}, this.state);
      newState.doiTuongTrungList = [];
      newState.totalSelectedList.map(function (item) {
        newState.doiTuongSelectedList.push(item);
      });
      newState.totalSelectedList = [];
      newState.idSelectedList = [];

      newState.doiTuongSelectedList.map(function (item, index) {
        var params = {
          doiTuongThanhTraId: item.doiTuongThanhTraId,
          namThanhTra: _this8.props.namThanhTra
        };
        _api.ThanhTra.actions.getKiemTraDoiTuongTT.request(null, params).then(function (res) {
          if (res.data && res.data._embedded) {
            var itemData = {
              tenDoiTuong: item.ten,
              coQuanList: res.data._embedded.coQuanQuanLies
            };
            newState.doiTuongTrungList.push(itemData);
          }
          if (index == newState.doiTuongSelectedList.length - 1 && newState.doiTuongTrungList.length) {
            newState.popupTrung = true;
          }
        });
      });
      this.setState(_extends({}, newState));
      this.timKiem();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'reception-container' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'btn-green btn-pullright', onClick: this.openDialog.bind(this) },
          _react2.default.createElement('i', { className: 'tt tt-addfile' }),
          'Th\xEAm m\u1EDBi cu\u1ED9c thanh tra'
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.isOpen,
            onClose: this.closeDialog.bind(this, 'isOpen'),
            title: 'Th\xEAm m\u1EDBi cu\u1ED9c thanh tra',
            className: 'dialog-them-moi-dttt dialog-default wrap-block'
          },
          _react2.default.createElement(
            'div',
            { className: 'row pl30 pr30' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt20 pb15' },
                '1. T\xECm ki\u1EBFm \u0111\u1ED1i t\u01B0\u1EE3ng thanh tra'
              )
            ),
            _react2.default.createElement(_common.Input, { className: 'col-60', label: '\u0110\u1ED1i t\u01B0\u1EE3ng', value: this.state.tuKhoa, onChange: this.onChange.bind(this, 'tuKhoa'), name: 'tuKhoa', placeholder: 'Nh\u1EADp t\xEAn \u0111\u1ED1i t\u01B0\u1EE3ng...' }),
            _react2.default.createElement(_common.DropDown, { className: 'col-25', label: 'Ng\xE0nh/L\u0129nh v\u1EF1c', selectedValue: this.state.linhVucId, onChange: this.onChange.bind(this, 'linhVucId'), name: 'linhVucId', placeholder: true,
              options: this.state.linhVucList, keyName: 'linhVucDoiTuongThanhTraId', valueName: 'ten' }),
            _react2.default.createElement(
              'div',
              { className: 'col-15 mt22' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green ml10', onClick: this.timKiem.bind(this) },
                _react2.default.createElement('i', { className: 'tt-search' }),
                'T\xECm ki\u1EBFm'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.1 K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _datatable.DataTableMultipleSelect,
                { onCheck: this.handleSelectedAll.bind(this), selectAllStatus: this.state.checkAll, header: _table.header.thanhTra.KQTKTMDTTT, dataList: this.state.ketQuaTimKiemList, tableLoading: this.state.tableLoading, pageData: this.state.pageData, parent: this },
                _react2.default.createElement(_datatable.RowItemKetQuaTimKiemThanhTra, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100 pb20 pt10 txt-center' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.themVaoCuocTT.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-addfile' }),
                'Th\xEAm v\xE0o cu\u1ED9c thanh tra'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl10 pr10 ' },
            _react2.default.createElement(
              'div',
              { className: 'row pl40 pr40' },
              _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              _react2.default.createElement(
                'h2',
                { className: 'title-14 pt15 pb15 pr20 pl20' },
                '1.2 Danh s\xE1ch \u0111\u1ED1i t\u01B0\u1EE3ng s\u1EBD \u0111\u01B0\u1EE3c th\xEAm v\xE0o thanh tra'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pl5 pr5' },
              _react2.default.createElement(
                _dataTable2.default,
                { header: _table.header.thanhTra.TMDTTT, dataList: this.state.doiTuongSelectedList, hideButtonExport: true, hidePagination: true, parent: this },
                _react2.default.createElement(_datatable.RowItemDanhSachThemMoiThanhTra, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'isOpen') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-save', onClick: this.handleSave.bind(this) },
                _react2.default.createElement(
                  'span',
                  null,
                  'L\u01B0u'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Dialog,
          {
            isOpen: this.state.popupTrung,
            onClose: this.closeDialog.bind(this, 'popupTrung'),
            title: 'Th\xF4ng b\xE1o',
            className: 'dialog-default wrap-block medium'
          },
          _react2.default.createElement(
            'div',
            { className: 'row pl30 pr30 pt20' },
            this.state.doiTuongTrungList.map(function (item, i) {
              return _react2.default.createElement(
                'ul',
                { key: i },
                _react2.default.createElement(
                  'li',
                  { className: 'title-text pb14' },
                  '\u0110\u1ED1i t\u01B0\u1EE3ng "',
                  item.tenDoiTuong,
                  '" \u0111\xE3 thu\u1ED9c k\u1EBF ho\u1EA1ch/ cu\u1ED9c thanh tra c\u1EE7a c\xE1c \u0111\u01A1n v\u1ECB sau:'
                ),
                item.coQuanList.map(function (coQuanItem, index) {
                  return _react2.default.createElement(
                    'li',
                    { className: 'content-text bt pt14 pb14', key: index },
                    index + 1,
                    '. ',
                    coQuanItem.ten
                  );
                })
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row pl15 pr15' },
            _react2.default.createElement('span', { className: 'line-border mt5 mb0' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'action-form-wrap pt20' },
            _react2.default.createElement(
              'div',
              { className: 'box-bottom' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-action btn-close', onClick: this.closeDialog.bind(this, 'popupTrung') },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u0110\xF3ng'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThemMoiDoiTuongThanhTra;
}(_react2.default.Component);

ThemMoiDoiTuongThanhTra.defaultProps = {
  validators: []
};

exports.default = ThemMoiDoiTuongThanhTra;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongTinChung = function (_React$Component) {
  _inherits(ThongTinChung, _React$Component);

  function ThongTinChung(props, context) {
    _classCallCheck(this, ThongTinChung);

    var _this = _possibleConstructorReturn(this, (ThongTinChung.__proto__ || Object.getPrototypeOf(ThongTinChung)).call(this, props, context));

    _this.state = {
      ngayRaQuyetDinh: (0, _moment2.default)().format('DD/MM/YYYY'),
      namThanhTraList: [],
      namThanhTra: '',
      quyetDinhPheDuyetKTTT: '',
      hinhThucKHTTList: [],
      hinhThucKHTT: '',
      nguoiKy: '',
      ghiChu: ''
    };
    return _this;
  }

  _createClass(ThongTinChung, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getNamThanhTraList();
      this.getHinhThucKeHoachThanhTra();
    }
  }, {
    key: 'getNamThanhTraList',
    value: function getNamThanhTraList() {
      var _this2 = this;

      _api.ThanhTra.actions.getNamThanhTra.request().then(function (res) {
        if (res.data) {
          _this2.state.namThanhTraList = res.data;
          _this2.state.namThanhTra = res.data[0].giaTri;
        } else {
          _this2.state.namThanhTraList = [];
        }
        _this2.setState(_extends({}, _this2.state));
        _this2.props.onChange(_this2.state);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.data != nextProps.data) {
        this.state.namThanhTra = nextProps.data.namThanhTra;
        this.state.quyetDinhPheDuyetKTTT = nextProps.data.quyetDinhPheDuyetKTTT;
        this.state.ngayRaQuyetDinh = nextProps.data.ngayRaQuyetDinh ? (0, _moment2.default)(nextProps.data.ngayRaQuyetDinh).format('DD/MM/YYYY') : '';
        this.state.hinhThucKHTT = nextProps.data.chucNangKeHoachThanhTra;
        this.state.nguoiKy = nextProps.data.nguoiKy;
        this.state.ghiChu = nextProps.data.ghiChu;
        this.setState(_extends({}, this.state));
        this.props.onChange(this.state);
      }
    }
  }, {
    key: 'getHinhThucKeHoachThanhTra',
    value: function getHinhThucKeHoachThanhTra() {
      var _this3 = this;

      _api.ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(function (res) {
        if (res.data) {
          _this3.state.hinhThucKHTTList = res.data;
          _this3.state.hinhThucKHTT = res.data[0].giaTri;
        } else {
          _this3.state.hinhThucKHTTList = [];
        }
        _this3.setState(_extends({}, _this3.state));
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.state[name] = e.target.value;
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.state[name] = e._d;
      } else {
        this.state[name] = e;
      }
      this.setState(_extends({}, this.state));
      this.props.onChange(this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'wrap-block' },
        _react2.default.createElement(
          'div',
          { className: 'row pl10 pr10' },
          _react2.default.createElement(
            'h2',
            { className: 'title-14 col-100 pt20 pl20 pr20 pb15' },
            '1. Th\xF4ng tin chung'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row pl25 pr25' },
          _react2.default.createElement(_common.DropDown, { className: 'col-input', label: 'N\u0103m thanh tra', options: this.state.namThanhTraList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.namThanhTra, onChange: this.onChange.bind(this, 'namThanhTra'), name: 'namThanhTra', bindValidator: this, require: true, channel: 'formTaoDon' }),
          _react2.default.createElement(_common.Input, { className: 'col-input', label: 'Quy\u1EBFt \u0111\u1ECBnh ph\xEA duy\u1EC7t KHTT', placeholder: 'Nh\u1EADp...', require: true, bindValidator: this, channel: 'formTaoDon', value: this.state.quyetDinhPheDuyetKTTT, onChange: this.onChange.bind(this, 'quyetDinhPheDuyetKTTT'), name: 'quyetDinhPheDuyetKTTT', maxLength: 255 }),
          _react2.default.createElement(_common.DatePicker, { className: 'col-input', label: 'Ng\xE0y ph\xEA duy\u1EC7t', bindValidator: this, require: true, channel: 'formTaoDon', value: this.state.ngayRaQuyetDinh, onChange: this.handleChangeDate.bind(this, 'ngayRaQuyetDinh') }),
          _react2.default.createElement(_common.DropDown, { className: 'col-input', label: 'Ch\u1EE9c n\u0103ng thanh tra', options: this.state.hinhThucKHTTList, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.hinhThucKHTT, onChange: this.onChange.bind(this, 'hinhThucKHTT'), name: 'hinhThucKHTT', bindValidator: this, require: true, channel: 'formTaoDon' }),
          _react2.default.createElement(_common.Input, { className: 'col-input', label: 'Ng\u01B0\u1EDDi k\xFD', value: this.state.nguoiKy, onChange: this.onChange.bind(this, 'nguoiKy'), name: 'nguoiKy', placeholder: 'Nh\u1EADp...' }),
          _react2.default.createElement(_common.TextArea, { className: 'col-100', label: 'T\xF3m t\u1EAFt k\u1EBF ho\u1EA1ch', value: this.state.ghiChu, onChange: this.onChange.bind(this, 'ghiChu'), name: 'ghiChu', rows: 3, placeholder: 'Nh\u1EADp...', maxLength: 1000 })
        )
      );
    }
  }]);

  return ThongTinChung;
}(_react2.default.Component);

ThongTinChung.defaultProps = {
  data: {}
};

exports.default = (0, _utils.validatable)(ThongTinChung);

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _ttForms = __webpack_require__(19);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _config = __webpack_require__(16);

var _downloadFile = __webpack_require__(112);

var _downloadExcel = __webpack_require__(170);

var _table = __webpack_require__(12);

var _datatable = __webpack_require__(498);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _datatable2 = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQua = function (_React$Component) {
  _inherits(TongHopKetQua, _React$Component);

  function TongHopKetQua(props, context) {
    _classCallCheck(this, TongHopKetQua);

    var _this = _possibleConstructorReturn(this, (TongHopKetQua.__proto__ || Object.getPrototypeOf(TongHopKetQua)).call(this, props, context));

    _this.state = {
      search: false,
      searchLoading: true,
      data: [],
      dataSum: [],
      dataDonTrung: [],
      dataOptions: [],
      dataSelected: [],
      dataCapCoQuanThongKe: [],
      dataHinhThucThongKe: [],
      dataValueListFilter: {
        statisticType: 'YEAR',
        startDate: null,
        endDate: null,
        quarter: '',
        year: '',
        month: '',
        dsDonViId: ''
      },
      statisticType: 'YEAR',
      nguonDon: '',
      startDate: '',
      endDate: '',
      quarter: '',
      year: '',
      month: '',
      dsDonViId: '',
      dsDonViIdKQ: (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}).donViId,
      donViCon: false,
      donViChonDon: '',
      hinhThucThongKe: 'DON_VI',
      capCoQuanThongKe: '',
      init: true,
      isThanhTraTinh: false
    };
    return _this;
  }

  _createClass(TongHopKetQua, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCheckLuaChonDonVi();
      this.getListData();
      this.getListDV();
      this.getCapCoQuanThongKe();
      this.getHinhThucThongKe();
    }
  }, {
    key: 'getCheckLuaChonDonVi',
    value: function getCheckLuaChonDonVi() {
      var _this2 = this;

      _api.TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(function (res) {
        var data = res.data;

        _this2.setState(_extends({}, _this2.state, {
          isThanhTraTinh: data
        }));
      });
    }
  }, {
    key: 'getCapCoQuanThongKe',
    value: function getCapCoQuanThongKe() {
      var _this3 = this;

      _api.ThongKeBaoCao.actions.getCapCoQuanThongKe.request().then(function (res) {
        if (res.data._embedded) {
          _this3.setState({
            dataCapCoQuanThongKe: res.data._embedded.capCoQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'getHinhThucThongKe',
    value: function getHinhThucThongKe() {
      var _this4 = this;

      _api.ThongKeBaoCao.actions.getHinhThucThongKe.request().then(function (res) {
        if (res.data) {
          _this4.setState({
            dataHinhThucThongKe: res.data.map(function (item) {
              return {
                giaTri: item.value,
                ten: item.label
              };
            })
          });
        }
      });
    }
  }, {
    key: 'getKiemTraChiTietDoanhNghiep',
    value: function getKiemTraChiTietDoanhNghiep(params) {
      var _this5 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getKiemTraChiTietDoanhNghiep.request(null, params).then(function (res) {
        if (res.data) {
          _this5.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getKiemTraTheoKeHoachDoanhNghiep',
    value: function getKiemTraTheoKeHoachDoanhNghiep(params) {
      var _this6 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getKiemTraTheoKeHoachDoanhNghiep.request(null, params).then(function (res) {
        if (res.data) {
          _this6.setState({
            data: res.data.map(function (item, i) {
              return _extends({}, item, { rootLevel: i < res.data.length - 1 });
            }),
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getKiemTraDotXuat',
    value: function getKiemTraDotXuat(params) {
      var _this7 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getKiemTraDotXuat.request(null, params).then(function (res) {
        if (res.data) {
          _this7.setState({
            data: res.data.map(function (item, i) {
              return _extends({}, item, { rootLevel: i < res.data.length - 1 });
            }),
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getTongHopKetQuaThanhTra',
    value: function getTongHopKetQuaThanhTra(params) {
      var _this8 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getTongHopKetQuaThanhTra.request(null, params).then(function (res) {
        if (res.data) {
          _this8.setState({
            data: res.data.map(function (item, i) {
              return _extends({}, item, { rootLevel: i < res.data.length - 1 });
            }),
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.getListData();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.size = size;
      this.state.pageData.number = 0;
      this.getListData();
    }
  }, {
    key: 'getListData',
    value: function getListData(dataSearch) {

      var params = {
        statisticType: this.state.statisticType,
        hinhThucThongKe: this.state.hinhThucThongKe
      };

      if (dataSearch && dataSearch.quarter && dataSearch.statisticType == 'QUARTER') {
        params.quarter = dataSearch.quarter;
      }

      if (dataSearch && dataSearch.hinhThucThongKe) {
        params.hinhThucThongKe = dataSearch.hinhThucThongKe;
      }

      if (dataSearch && dataSearch.nguonDon) {
        params.nguonDon = dataSearch.nguonDon;
      }

      if (dataSearch && dataSearch.year && dataSearch.statisticType != 'OPTION') {
        params.year = dataSearch.year;
      }

      if (dataSearch && dataSearch.month && dataSearch.statisticType == 'MONTH') {
        params.month = dataSearch.month;
      }

      if (dataSearch && dataSearch.startDate && dataSearch.statisticType == 'OPTION') {
        params.startDate = (0, _moment2.default)(dataSearch.startDate).add(7, 'hours').toISOString();
      }

      if (dataSearch && dataSearch.endDate && dataSearch.statisticType == 'OPTION') {
        params.endDate = (0, _moment2.default)(dataSearch.endDate).add(7, 'hours').toISOString();
      }

      if (dataSearch && dataSearch.hinhThucThongKe == 'DON_VI' && dataSearch.dsDonViId) {
        params.dsDonViId = dataSearch.dsDonViId;
      }

      if (dataSearch && dataSearch.hinhThucThongKe == 'CAP_DON_VI' && dataSearch.capDonViId) {
        params.capDonViId = dataSearch.capDonViId;
      }

      if (params && params.hinhThucThongKe == 'DON_VI' && !params.dsDonViId && this.state.init == true) {
        var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        params.dsDonViId = String(userInfo.donViId);
      }

      if (this.props.type == 'TIEP_CONG_DAN') {
        this.getThongKeTiepCongDan(params);
      } else if (this.props.type == 'GIAI_QUYET_KHIEU_NAI') {
        this.getThongKeGQDKN(params);
      } else if (this.props.type == 'GIAI_QUYET_TO_CAO') {
        this.getThongKeGQDTC(params);
      } else if (this.props.type == 'XU_LY_DON') {
        this.getThongKeXuLyDon(params);
      } else if (this.props.type == 'THANH_TRA_HANH_CHINH') {
        this.getThongKeThanhTraHanhChinh(params);
      } else if (this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH') {
        this.getKetQuaThucHienKetLuanThanhTraHanhChinh(params);
      } else if (this.props.type == 'THANH_TRA_DAT_DAI') {
        this.getThongKeThanhTraDatDai(params);
      } else if (this.props.type == 'THANH_TRA_CHUYEN_NGANH') {
        this.getThongKeThanhTraChuyenNganh(params);
      } else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
        this.getThongKeThanhTraXayDungCoBan(params);
      } else if (this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH') {
        this.getKiemTraChuyenNganh(params);
      } else if (this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH') {
        this.getXuPhatKiemTraChuyenNganh(params);
      } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
        this.getThongKeThanhTraTaiChinhNganSach(params);
      } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
        this.getThongKePhatHienThamNhungQuaThanhTra(params);
      } else if (this.props.type == 'THANH_TRA_LAI') {
        this.getThongKeKetQuaThanhTraLai(params);
      } else if (this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP') {
        this.getKiemTraChiTietDoanhNghiep(_extends({}, params, { dsDonViId: this.state.dsDonViIdKQ }));
      } else if (this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP') {
        this.getKiemTraTheoKeHoachDoanhNghiep(_extends({}, params, { dsDonViId: this.state.dsDonViIdKQ }));
      } else if (this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP') {
        this.getKiemTraDotXuat(_extends({}, params, { dsDonViId: this.state.dsDonViIdKQ }));
      } else if (this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA') {
        this.getTongHopKetQuaThanhTra(_extends({}, params, { dsDonViId: this.state.dsDonViIdKQ }));
      }
    }
  }, {
    key: 'getThongKeGQDKN',
    value: function getThongKeGQDKN(params) {
      var _this9 = this;

      this.setState({
        tableLoading: true
      });

      _api.ThongKeBaoCao.actions.getThongKeGQDKN.request(null, params).then(function (res) {
        if (res.data && _this9.refs.thongKeBaoCao) {
          _this9.setState({
            data: res.data.maSos,
            dataSum: res.data.tongCongs,
            pageData: res.data.page,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeThanhTraHanhChinh',
    value: function getThongKeThanhTraHanhChinh(params) {
      var _this10 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getTongHopKetQuaThanhTraHanhChinh.request(null, params).then(function (res) {
        if (res.data && _this10.refs.thongKeBaoCao) {
          _this10.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getKetQuaThucHienKetLuanThanhTraHanhChinh',
    value: function getKetQuaThucHienKetLuanThanhTraHanhChinh(params) {
      var _this11 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getKetQuaThucHienKetLuanThanhTraHanhChinh.request(null, params).then(function (res) {
        if (res.data && _this11.refs.thongKeBaoCao) {
          _this11.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeThanhTraDatDai',
    value: function getThongKeThanhTraDatDai(params) {
      var _this12 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getThongKeThanhTraDatDai.request(null, params).then(function (res) {
        if (res.data && _this12.refs.thongKeBaoCao) {
          _this12.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeThanhTraChuyenNganh',
    value: function getThongKeThanhTraChuyenNganh(params) {
      var _this13 = this;

      this.setState({
        tableLoading: true
      });

      _api.ThongKeBaoCao.actions.getThongKeThanhTraChuyenNganh.request(null, params).then(function (res) {
        if (res.data && _this13.refs.thongKeBaoCao) {
          _this13.setState({
            data: res.data.maSos,
            dataSum: res.data.tongCongs,
            pageData: res.data.page,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeThanhTraXayDungCoBan',
    value: function getThongKeThanhTraXayDungCoBan(params) {
      var _this14 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getThongKeThanhTraXayDungCoBan.request(null, params).then(function (res) {
        if (res.data && _this14.refs.thongKeBaoCao) {
          _this14.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getKiemTraChuyenNganh',
    value: function getKiemTraChuyenNganh(params) {
      var _this15 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getKiemTraChuyenNganh.request(null, params).then(function (res) {
        if (res.data && _this15.refs.thongKeBaoCao) {
          _this15.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getXuPhatKiemTraChuyenNganh',
    value: function getXuPhatKiemTraChuyenNganh(params) {
      var _this16 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getXuPhatKiemTraChuyenNganh.request(null, params).then(function (res) {
        if (res.data && _this16.refs.thongKeBaoCao) {
          _this16.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeThanhTraTaiChinhNganSach',
    value: function getThongKeThanhTraTaiChinhNganSach(params) {
      var _this17 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getThongKeThanhTraTaiChinhNganSach.request(null, params).then(function (res) {
        if (res.data && _this17.refs.thongKeBaoCao) {
          _this17.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKePhatHienThamNhungQuaThanhTra',
    value: function getThongKePhatHienThamNhungQuaThanhTra(params) {
      var _this18 = this;

      this.setState({
        tableLoading: true
      });

      _api.ThongKeBaoCao.actions.getThongKePhatHienThamNhungQuaThanhTra.request(null, params).then(function (res) {
        if (res.data) {
          _this18.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'getThongKeKetQuaThanhTraLai',
    value: function getThongKeKetQuaThanhTraLai(params) {
      var _this19 = this;

      this.setState({
        tableLoading: true
      });

      _api.ThongKeBaoCao.actions.getThongKeKetQuaThanhTraLai.request(null, params).then(function (res) {
        if (res.data && _this19.refs.thongKeBaoCao) {
          _this19.setState({
            data: res.data.maSos,
            dataSum: res.data.tongCongs,
            pageData: res.data.page,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'DonVi') {
        this.setState({
          dataSelected: e
        });
      } else if (name == 'statisticType') {
        var _setState;

        this.setState((_setState = {}, _defineProperty(_setState, name, e.target.value), _defineProperty(_setState, 'startDate', ''), _defineProperty(_setState, 'endDate', ''), _defineProperty(_setState, 'year', ''), _defineProperty(_setState, 'month', ''), _defineProperty(_setState, 'quarter', ''), _setState));
      } else if (name == 'donViCon') {
        this.setState({
          donViCon: !this.state.donViCon
        });
      } else {
        this.setState(_defineProperty({}, name, e.target.value));
      }

      if (name == 'hinhThucThongKe' || name == 'statisticType') {}
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'hanldeSearch',
    value: function hanldeSearch() {
      var _this20 = this;

      if (this.validateSubmitForm()) {
        this.setState({
          search: true
        });

        var dataSearch = {};

        if (this.state.statisticType == 'QUARTER') {
          dataSearch = {
            statisticType: this.state.statisticType,
            quarter: this.state.quarter,
            year: this.state.year
          };
        } else if (this.state.statisticType == 'SAU_THANG_CUOI_NAM' || this.state.statisticType == 'FIRST_SIX_MONTH' || this.state.statisticType == 'FIRST_NINE_MONTH' || this.state.statisticType == 'YEAR') {
          dataSearch = {
            statisticType: this.state.statisticType,
            year: this.state.year
          };
        } else if (this.state.statisticType == 'MONTH') {
          dataSearch = {
            statisticType: this.state.statisticType,
            year: this.state.year,
            month: this.state.month
          };
        } else if (this.state.statisticType == 'OPTION') {
          dataSearch = {
            statisticType: this.state.statisticType,
            startDate: this.state.startDate,
            endDate: this.state.endDate
          };
        }

        if (this.state.hinhThucThongKe) {
          dataSearch.hinhThucThongKe = this.state.hinhThucThongKe;
        }

        if (this.state.nguonDon) {
          dataSearch.nguonDon = this.state.nguonDon;
        }

        if (this.state.hinhThucThongKe == 'CAP_DON_VI') {
          dataSearch.dsDonViId = '';
          dataSearch.capDonViId = this.state.capCoQuanThongKe;
        } else {
          var self = this;
          var dsDonViId = '';
          if (this.state.dataSelected.length > 0) {
            this.state.dataSelected.map(function (item, index) {
              if (index == 0) {
                dsDonViId = dsDonViId + self.state.dataSelected[index].value;
              }
              if (index > 0) {
                dsDonViId = dsDonViId + ',' + self.state.dataSelected[index].value;
              }
            });
          }

          dataSearch.dsDonViId = dsDonViId;
          dataSearch.capDonViId = '';
        }

        this.setState({
          dataValueListFilter: dataSearch,
          init: false
        }, function () {
          _this20.getListData(dataSearch);
        });
      }
    }
  }, {
    key: 'downloadExcelReport',
    value: function downloadExcelReport(_ref) {
      var name = _ref.name,
          apiUrl = _ref.apiUrl;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      var qs = _extends({}, this.state.dataValueListFilter, {
        hinhThucThongKe: this.state.dataValueListFilter.hinhThucThongKe || 'DON_VI',
        dsDonViId: this.state.dataValueListFilter.dsDonViId || String(userInfo.donViId)
      }, this.state.startDate ? { startDate: (0, _moment2.default)(this.state.startDate).format('YYYY-MM-DD') } : {}, this.state.endDate ? { endDate: (0, _moment2.default)(this.state.endDate).format('YYYY-MM-DD') } : {});

      var qsFunction = function qsFunction(input) {
        return Object.entries(input).filter(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          return value;
        }).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return key + '=' + value;
        }).join('&');
      };

      var URL = String(_config.API_URL) + '/' + apiUrl + '?' + qsFunction(qs);
      (0, _downloadExcel.downloadExcel)(URL, name, true);
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      if (this.props.type == 'THANH_TRA_HANH_CHINH') {
        this.downloadExcelReport({ name: 'bao-cao-thanh-tra-hanh-chinh', apiUrl: 'thong-ke-bao-cao/01-TT' });
      } else if (this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH') {
        this.downloadExcelReport({ name: 'bao-cao-thuc-hien-ket-luan-thanh-tra-hanh-chinh', apiUrl: 'thong-ke-bao-cao/02-TT' });
      } else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
        this.downloadExcelReport({ name: 'bao-cao-thanh-tra-xay-dung-co-ban', apiUrl: 'thong-ke-bao-cao/03-TT' });
      } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
        this.downloadExcelReport({ name: 'bao-cao-thanh-tra-tai-chinh-ngan-sach', apiUrl: 'thong-ke-bao-cao/04-TT' });
      } else if (this.props.type == 'THANH_TRA_DAT_DAI') {
        this.downloadExcelReport({ name: 'bao-cao-thanh-tra-dat-dai', apiUrl: 'thong-ke-bao-cao/05-TT' });
      } else if (this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH') {
        this.downloadExcelReport({ name: 'bao-cao-thanh-tra-kiem-tra-chuyen-nganh', apiUrl: 'thong-ke-bao-cao/06-TT' });
      } else if (this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH') {
        this.downloadExcelReport({ name: 'bao-cao-xu-phat-kiem-tra-chuyen-nganh', apiUrl: 'thong-ke-bao-cao/07-TT' });
      } else if (this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP') {
        this.downloadExcelReport({ name: 'bao-cao-kiem-tra-chi-tiet-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/01-KQTKT' });
      } else if (this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP') {
        this.downloadExcelReport({ name: 'bao-cao-kiem-tra-theo-ke-hoach-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/02-KQTKT' });
      } else if (this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP') {
        this.downloadExcelReport({ name: 'bao-cao-kiem-tra-dot-xuat-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/03-KQTKT' });
      } else if (this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA') {
        this.downloadExcelReport({ name: 'bao-cao-tong-hop-ket-qua-thanh-tra', apiUrl: 'thong-ke-bao-cao/04-KQTKT' });
      } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
        this.downloadExcelReport({ name: 'bao-cao-tong-hop-tham-nhung', apiUrl: 'thong-ke-bao-cao/BCTN' });
      } else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
        var URL = String(_config.API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDauTuXayDungCoBan/xuatExcel?statisticType=" + this.state.statisticType + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '') + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '') + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '') + "&startDate=" + (this.state.dataValueListFilter.startDate ? (0, _moment2.default)(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '') + "&endDate=" + (this.state.dataValueListFilter.endDate ? (0, _moment2.default)(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '') + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI') + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId)) + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

        (0, _downloadFile.downloadFile)(URL);
      } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
        var _URL = String(_config.API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraTheoTaiChinhNganSach/xuatExcel?statisticType=" + this.state.statisticType + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '') + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '') + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '') + "&startDate=" + (this.state.dataValueListFilter.startDate ? (0, _moment2.default)(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '') + "&endDate=" + (this.state.dataValueListFilter.endDate ? (0, _moment2.default)(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '') + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI') + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId)) + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

        (0, _downloadFile.downloadFile)(_URL);
      } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
        var _URL2 = String(_config.API_URL) + "/thongKeBaoCaos/tongHopKetQuaPhatHienThamNhungQuaThanhTra/xuatExcel?statisticType=" + this.state.statisticType + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '') + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '') + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '') + "&startDate=" + (this.state.dataValueListFilter.startDate ? (0, _moment2.default)(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '') + "&endDate=" + (this.state.dataValueListFilter.endDate ? (0, _moment2.default)(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '') + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI') + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId)) + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

        (0, _downloadFile.downloadFile)(_URL2);
      } else if (this.props.type == 'THANH_TRA_LAI') {
        var _URL3 = String(_config.API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraLai/xuatExcel?statisticType=" + this.state.statisticType + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '') + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '') + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '') + "&startDate=" + (this.state.dataValueListFilter.startDate ? (0, _moment2.default)(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '') + "&endDate=" + (this.state.dataValueListFilter.endDate ? (0, _moment2.default)(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '') + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI') + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId)) + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

        (0, _downloadFile.downloadFile)(_URL3);
      }
    }
  }, {
    key: 'getListDV',
    value: function getListDV() {
      var _this21 = this;

      var userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      _api.DuLieuHeThong.actions.getDonViThongKe.request().then(function (res) {
        if (res.data._embedded) {
          var dataDonVi = [].concat(_toConsumableArray(res.data._embedded.coQuanQuanLies));
          var DonVi = dataDonVi.filter(function (state) {
            return state.coQuanQuanLyId == userInfo.donViId;
          });
          _this21.setState({
            dataSelected: [{ value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }],
            dataOptions: res.data._embedded.coQuanQuanLies
          });
        }
      });
    }
  }, {
    key: 'validateSubmitForm',
    value: function validateSubmitForm() {
      var pass = true;
      this.props.validators['formTaoDon'].map(function (validator) {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
      return pass;
    }
  }, {
    key: 'render',
    value: function render() {
      var isResultReport = this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP' || this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' || this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP' || this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA';

      return _react2.default.createElement(
        'div',
        { className: 'center reception-container wrap-block', ref: 'thongKeBaoCao' },
        _react2.default.createElement(
          'div',
          { className: 'top-content' },
          _react2.default.createElement(
            'div',
            { className: 'left-content' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_HANH_CHINH' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[01-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra h\xE0nh ch\xEDnh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[02-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn thanh tra h\xE0nh ch\xEDnh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[03-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra h\xE0nh ch\xEDnh trong l\u0129nh v\u1EF1c \u0111\u1EA7u t\u01B0 x\xE2y d\u1EF1ng c\u01A1 b\u1EA3n'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[04-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra trong l\u0129nh v\u1EF1c t\xE0i ch\xEDnh ng\xE2n s\xE1ch'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_DAT_DAI' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[05-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra trong l\u0129nh v\u1EF1c \u0111\u1EA5t \u0111ai'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[06-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra, ki\u1EC3m tra chuy\xEAn ng\xE0nh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                '[07-TT] T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n k\u1EBFt lu\u1EADn, quy\u1EBFt \u0111\u1ECBnh x\u1EED ph\u1EA1t qua thanh tra, ki\u1EC3m tra chuy\xEAn ng\xE0nh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'K\u1EBFt qu\u1EA3 thanh tra, ki\u1EC3m tra chi ti\u1EBFt doanh nghi\u1EC7p,  c\u01A1 s\u1EDF s\u1EA3n xu\u1EA5t kinh doanh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'K\u1EBFt qu\u1EA3 thanh tra, ki\u1EC3m tra theo k\u1EBF ho\u1EA1ch doanh nghi\u1EC7p, c\u01A1 s\u1EDF s\u1EA3n xu\u1EA5t kinh doanh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'K\u1EBFt qu\u1EA3 thanh tra, ki\u1EC3m tra \u0111\u1ED9t xu\u1EA5t doanh nghi\u1EC7p, c\u01A1 s\u1EDF s\u1EA3n xu\u1EA5t kinh doanh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
                'T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 thanh tra, ki\u1EC3m tra doanh nghi\u1EC7p, c\u01A1 s\u1EDF s\u1EA3n xu\u1EA5t kinh doanh'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_THAM_NHUNG' },
              _react2.default.createElement(
                'p',
                { className: 'title-18' },
                _react2.default.createElement('i', { className: 'tt tt-thongke' }),
                'T\u1ED5ng h\u1EE3p k\u1EBFt qu\u1EA3 ph\xE1t hi\u1EC7n, x\u1EED l\xFD tham nh\u0169ng ph\xE1t hi\u1EC7n qua c\xF4ng t\xE1c thanh tra, ki\u1EC3m tra'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom-content thongke-content' },
          _react2.default.createElement(
            'div',
            { className: 'row pl25 pr25 pt15 super-search' },
            _react2.default.createElement(
              'div',
              { className: 'col-83 no-gutter' },
              _react2.default.createElement(_ttForms.DropDownChonLoaiKyThongKe, { className: 'col-25', placeholder: null, onChange: this.onChange.bind(this, 'statisticType'), selectedValue: this.state.statisticType }),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.statisticType == 'QUARTER' },
                _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', onChange: this.onChange.bind(this, 'year'), selectedValue: this.state.year, require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(_ttForms.DropDownChonLoaiQuyThongKe, { className: 'col-25', onChange: this.onChange.bind(this, 'quarter'), selectedValue: this.state.quarter, require: true, bindValidator: this, channel: 'formTaoDon' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.statisticType == 'SAU_THANG_CUOI_NAM' || this.state.statisticType == 'FIRST_SIX_MONTH' || this.state.statisticType == 'FIRST_NINE_MONTH' || this.state.statisticType == 'YEAR' },
                _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', onChange: this.onChange.bind(this, 'year'), selectedValue: this.state.year ? this.state.year : (0, _moment2.default)().format('YYYY'), require: true, bindValidator: this, channel: 'formTaoDon' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.statisticType == 'MONTH' },
                _react2.default.createElement(_ttForms.DropDownChonLoaiNamThongKe, { className: 'col-25', onChange: this.onChange.bind(this, 'year'), selectedValue: this.state.year, require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(_ttForms.DropDownChonLoaiThangThongKe, { className: 'col-25', onChange: this.onChange.bind(this, 'month'), selectedValue: this.state.month, require: true, bindValidator: this, channel: 'formTaoDon' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: this.state.statisticType == 'OPTION' },
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: 'T\u1EEB ng\xE0y', endDate: this.state.endDate, onChange: this.handleChangeDate.bind(this, 'startDate'), value: this.state.startDate, require: true, bindValidator: this, channel: 'formTaoDon' }),
                _react2.default.createElement(_common.DatePicker, { className: 'col-25', label: '\u0110\u1EBFn ng\xE0y', startDate: this.state.startDate, onChange: this.handleChangeDate.bind(this, 'endDate'), value: this.state.endDate, require: true, bindValidator: this, channel: 'formTaoDon' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !isResultReport },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25', placeholder: null, label: 'H\xECnh th\u1EE9c th\u1ED1ng k\xEA', onChange: this.onChange.bind(this, 'hinhThucThongKe'), selectedValue: this.state.hinhThucThongKe, data: this.state.dataHinhThucThongKe, keyName: 'giaTri', valueName: 'ten' })
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: isResultReport },
                _react2.default.createElement(_ttForms.DropDownChonDonViThongKe, { className: 'col-25', placeholder: null, label: '\u0110\u01A1n v\u1ECB', onChange: this.onChange.bind(this, 'dsDonViIdKQ'), selectedValue: this.state.dsDonViIdKQ, isAll: true, disabled: !this.state.isThanhTraTinh })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-16 btn-thongke clear-right' },
              _react2.default.createElement(_core.Button, { className: this.state.tableLoading ? this.state.search ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable' : 'btn-green tt-search', text: 'Xem k\u1EBFt qu\u1EA3', onClick: this.hanldeSearch.bind(this) })
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.hinhThucThongKe === 'DON_VI' && !isResultReport },
              _react2.default.createElement(
                'div',
                { className: 'col-83 no-gutter clear-left' },
                _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'col-min-25 col-max-83', label: '\u0110\u01A1n v\u1ECB', dataOptions: this.state.dataOptions, dataSelected: this.state.dataSelected, onChange: this.onChange.bind(this, 'DonVi'), selectAllChildren: this.state.donViCon, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
                _react2.default.createElement(
                  'label',
                  { className: 'col-16 pt-control pt-checkbox checkbox-thong-ke' },
                  _react2.default.createElement('input', { type: 'checkbox', checked: this.state.donViCon, value: this.state.donViCon, onChange: this.onChange.bind(this, 'donViCon') }),
                  _react2.default.createElement('span', { className: 'pt-control-indicator' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'val-checkbox' },
                    'Ch\u1ECDn \u0111\u01A1n v\u1ECB con'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.state.hinhThucThongKe == 'CAP_DON_VI' },
              _react2.default.createElement(
                'div',
                { className: 'col-83 no-gutter' },
                _react2.default.createElement(_ttForms.DropDownMulipleUse, { className: 'col-25', label: 'C\u1EA5p \u0111\u01A1n v\u1ECB b\xE1o c\xE1o', onChange: this.onChange.bind(this, 'capCoQuanThongKe'), selectedValue: this.state.capCoQuanThongKe, data: this.state.dataCapCoQuanThongKe, keyName: 'capCoQuanQuanLyId', valueName: 'ten' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-100 no-gutter pt5' },
            _react2.default.createElement('span', { className: 'line-border' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'wrap-table clear-left' },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_HANH_CHINH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThanhTraHanhChinh,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 20,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraHanhChinh, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThucHienKetLuanThanhTraHanhchinh,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 24,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemKetQuaThucHienKetLuanThanhTraHanhChinh, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThanhTraXayDungCoBan,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 20,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayDungCoBan, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThanhTraTaiChinhNganSach,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 20,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraXayTaiChinhNganSach, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_DAT_DAI' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThanhTraDatDai,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 20,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemThongKeThanhTraDatDai, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 29,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoQuyetDinhXuPhatKiemTraChuyenNganh,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 16,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable.ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'THANH_TRA_THAM_NHUNG' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  isReport: true,
                  touchMove: true,
                  header: _table.header.thongKeBaoCaoThanhTraThamNhung,
                  dataSum: this.state.dataSum,
                  handleExport: this.handleExport.bind(this),
                  hidePagination: true,
                  numberColumnHeader: 26,
                  ThongKeBaoCao: true,
                  dataList: this.state.data,
                  exporttext: 'Xu\u1EA5t b\xE1o c\xE1o',
                  pageData: this.state.pageData,
                  parent: this,
                  search: this.state.search,
                  tableLoading: this.state.tableLoading },
                _react2.default.createElement(_datatable2.ListItemThongKeThanhTraThamNhung, null)
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP' },
              _react2.default.createElement(
                _dataTable.DataTableKetQua,
                {
                  touchMove: true,
                  header: _table.header.ketQuaKiemTraChiTietDoanhNghiep,
                  tableLoading: this.state.tableLoading,
                  handleExport: this.handleExport.bind(this),
                  exportText: 'Xu\u1EA5t b\xE1o c\xE1o'
                },
                _react2.default.createElement(_datatable.ListItemKetQuaKiemTraChiTiet, { dataList: this.state.data, totalCol: 14 })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' },
              _react2.default.createElement(
                _dataTable.DataTableKetQua,
                {
                  touchMove: true,
                  header: _table.header.ketQuaKiemTraTheoKeHoachDoanhNghiep,
                  numberColumnHeader: 27,
                  tableLoading: this.state.tableLoading,
                  handleExport: this.handleExport.bind(this),
                  exportText: 'Xu\u1EA5t b\xE1o c\xE1o'
                },
                _react2.default.createElement(_datatable.ListItemKetQuaKiemTraTheoKeHoach, { dataList: this.state.data, totalCol: 27 })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP' },
              _react2.default.createElement(
                _dataTable.DataTableKetQua,
                {
                  touchMove: true,
                  header: _table.header.ketQuaKiemTraDotXuatDoanhNghiep,
                  numberColumnHeader: 19,
                  tableLoading: this.state.tableLoading,
                  handleExport: this.handleExport.bind(this),
                  exportText: 'Xu\u1EA5t b\xE1o c\xE1o'
                },
                _react2.default.createElement(_datatable.ListItemKetQuaKiemTraDotXuat, { dataList: this.state.data, totalCol: 19 })
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA' },
              _react2.default.createElement(
                _dataTable.DataTableKetQua,
                {
                  touchMove: true,
                  header: _table.header.tongHopKetQuaThanhTra,
                  numberColumnHeader: 29,
                  tableLoading: this.state.tableLoading,
                  handleExport: this.handleExport.bind(this),
                  exportText: 'Xu\u1EA5t b\xE1o c\xE1o'
                },
                _react2.default.createElement(_datatable.ListItemKetQuaTongHopKetQuaThanhTra, { dataList: this.state.data, totalCol: 29 })
              )
            )
          )
        )
      );
    }
  }]);

  return TongHopKetQua;
}(_react2.default.Component);

TongHopKetQua.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'TIEP_CONG_DAN'
};

exports.default = (0, _reactRedux.connect)()(TongHopKetQua);

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemKetQuaKiemTraChiTiet = function (_React$Component) {
  _inherits(ListItemKetQuaKiemTraChiTiet, _React$Component);

  function ListItemKetQuaKiemTraChiTiet(props, context) {
    _classCallCheck(this, ListItemKetQuaKiemTraChiTiet);

    var _this = _possibleConstructorReturn(this, (ListItemKetQuaKiemTraChiTiet.__proto__ || Object.getPrototypeOf(ListItemKetQuaKiemTraChiTiet)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemKetQuaKiemTraChiTiet, [{
    key: 'renderData',
    value: function renderData(arrayKey) {
      return arrayKey.map(function (item, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            null,
            i + 1
          ),
          _react2.default.createElement(
            'td',
            null,
            item.tenDoanhNghiep
          ),
          _react2.default.createElement(
            'td',
            null,
            item.noiDung
          ),
          _react2.default.createElement(
            'td',
            null,
            item.thoiHan
          ),
          _react2.default.createElement(
            'td',
            null,
            item.tomTatViPham
          ),
          _react2.default.createElement(
            'td',
            null,
            item.tongTienViPham
          ),
          _react2.default.createElement(
            'td',
            null,
            item.tienKienNghiThuHoi
          ),
          _react2.default.createElement(
            'td',
            null,
            item.kienNghiXuLyKhac
          ),
          _react2.default.createElement(
            'td',
            null,
            item.soToChucViPhamHanhChinh
          ),
          _react2.default.createElement(
            'td',
            null,
            item.soCaNhanViPhamHanhChinh
          ),
          _react2.default.createElement(
            'td',
            null,
            item.tongTienViPhamHanhChinh
          ),
          _react2.default.createElement(
            'td',
            null,
            item.ketQuaThucHien
          ),
          _react2.default.createElement(
            'td',
            null,
            item.soVuChuyenCoQuanDieuTra
          ),
          _react2.default.createElement(
            'td',
            null,
            item.soDoiTuongChuyenCoQuanDieuTra
          )
        );
      });
    }
  }, {
    key: 'renderTheoKeHoach',
    value: function renderTheoKeHoach() {
      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { color: '#0077EE', fontWeight: '700' } },
            'A'
          ),
          _react2.default.createElement(
            'td',
            {
              style: { color: '#0077EE', fontWeight: '700' },
              colSpan: this.props.totalCol - 1
            },
            'Theo k\u1EBF ho\u1EA1ch'
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' } },
            'I'
          ),
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' }, colSpan: this.props.totalCol - 1 },
            'Doanh nghi\u1EC7p \u0111\u01B0\u1EE3c thanh tra theo k\u1EBF ho\u1EA1ch'
          )
        ),
        this.renderData((0, _lodash.get)(this.props.dataList, 'thanhTraTheoKeHoach', [])),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' } },
            'II'
          ),
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' }, colSpan: this.props.totalCol - 1 },
            'Doanh nghi\u1EC7p \u0111\u01B0\u1EE3c ki\u1EC3m tra theo k\u1EBF ho\u1EA1ch'
          )
        ),
        this.renderData((0, _lodash.get)(this.props.dataList, 'kiemTraTheoKeHoach', []))
      );
    }
  }, {
    key: 'renderDotXuat',
    value: function renderDotXuat() {
      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { color: '#0077EE', fontWeight: '700' } },
            'B'
          ),
          _react2.default.createElement(
            'td',
            {
              style: { color: '#0077EE', fontWeight: '700' },
              colSpan: this.props.totalCol - 1
            },
            '\u0110\u1ED9t xu\u1EA5t'
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' } },
            'I'
          ),
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' }, colSpan: this.props.totalCol - 1 },
            'Doanh nghi\u1EC7p \u0111\u01B0\u1EE3c thanh tra \u0111\u1ED9t xu\u1EA5t'
          )
        ),
        this.renderData((0, _lodash.get)(this.props.dataList, 'thanhTraDotXuat', [])),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' } },
            'II'
          ),
          _react2.default.createElement(
            'td',
            { style: { fontWeight: 'bold' }, colSpan: this.props.totalCol - 1 },
            'Doanh nghi\u1EC7p \u0111\u01B0\u1EE3c ki\u1EC3m tra \u0111\u1ED9t xu\u1EA5t'
          )
        ),
        this.renderData((0, _lodash.get)(this.props.dataList, 'kiemTraDotXuat', []))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        this.renderTheoKeHoach(),
        this.renderDotXuat()
      );
    }
  }]);

  return ListItemKetQuaKiemTraChiTiet;
}(_react2.default.Component);

exports.default = ListItemKetQuaKiemTraChiTiet;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

var _function = __webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemKetQuaKiemTraDotXuat = function (_React$Component) {
  _inherits(ListItemKetQuaKiemTraDotXuat, _React$Component);

  function ListItemKetQuaKiemTraDotXuat(props, context) {
    _classCallCheck(this, ListItemKetQuaKiemTraDotXuat);

    var _this = _possibleConstructorReturn(this, (ListItemKetQuaKiemTraDotXuat.__proto__ || Object.getPrototypeOf(ListItemKetQuaKiemTraDotXuat)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemKetQuaKiemTraDotXuat, [{
    key: 'renderData',
    value: function renderData(_ref) {
      var data = _ref.data,
          totalCol = _ref.totalCol;

      var rootStyle = { color: '#0077EE', fontWeight: 'bold' };

      return data.map(function (item, i) {
        return _react2.default.createElement(
          'span',
          { style: { display: 'contents' } },
          _react2.default.createElement(
            'tr',
            { key: i },
            _react2.default.createElement(
              'td',
              { style: item.rootLevel ? rootStyle : {} },
              item.rootLevel ? (0, _function.generateRomanNumeralsObject)(100)[i + 1] : null
            ),
            _react2.default.createElement(
              'td',
              {
                style: item.rootLevel ? rootStyle : { fontWeight: 'bold' },
                colSpan: (0, _lodash.isEmpty)(item.children) && item.rootLevel ? totalCol - 1 : 1
              },
              item.model.name
            ),
            item.statistics.map(function (sta, idx) {
              return _react2.default.createElement(
                'td',
                { key: idx },
                sta
              );
            })
          ),
          item.children.map(function (child, idx) {
            return _react2.default.createElement(
              'tr',
              { key: idx },
              _react2.default.createElement(
                'td',
                null,
                idx + 1
              ),
              _react2.default.createElement(
                'td',
                null,
                child.model.name
              ),
              child.statistics.map(function (sta, j) {
                return _react2.default.createElement(
                  'td',
                  { key: j },
                  sta
                );
              })
            );
          })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        this.renderData({
          data: (0, _lodash.get)(this.props, 'dataList', []),
          totalCol: this.props.totalCol
        })
      );
    }
  }]);

  return ListItemKetQuaKiemTraDotXuat;
}(_react2.default.Component);

exports.default = ListItemKetQuaKiemTraDotXuat;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

var _function = __webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemKetQuaKiemTraTheoKeHoach = function (_React$Component) {
  _inherits(ListItemKetQuaKiemTraTheoKeHoach, _React$Component);

  function ListItemKetQuaKiemTraTheoKeHoach(props, context) {
    _classCallCheck(this, ListItemKetQuaKiemTraTheoKeHoach);

    var _this = _possibleConstructorReturn(this, (ListItemKetQuaKiemTraTheoKeHoach.__proto__ || Object.getPrototypeOf(ListItemKetQuaKiemTraTheoKeHoach)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemKetQuaKiemTraTheoKeHoach, [{
    key: 'renderData',
    value: function renderData(_ref) {
      var data = _ref.data,
          totalCol = _ref.totalCol;

      var rootStyle = { color: '#0077EE', fontWeight: 'bold' };

      return data.map(function (item, i) {
        return _react2.default.createElement(
          'span',
          { style: { display: 'contents' } },
          _react2.default.createElement(
            'tr',
            { key: i },
            _react2.default.createElement(
              'td',
              { style: item.rootLevel ? rootStyle : {} },
              item.rootLevel ? (0, _function.generateRomanNumeralsObject)(100)[i + 1] : null
            ),
            _react2.default.createElement(
              'td',
              {
                style: item.rootLevel ? rootStyle : { fontWeight: 'bold' },
                colSpan: (0, _lodash.isEmpty)(item.children) && item.rootLevel ? totalCol - 1 : 1
              },
              item.model.name
            ),
            item.statistics.map(function (sta, idx) {
              return _react2.default.createElement(
                'td',
                { key: idx },
                sta
              );
            })
          ),
          item.children.map(function (child, idx) {
            return _react2.default.createElement(
              'tr',
              { key: idx },
              _react2.default.createElement(
                'td',
                null,
                idx + 1
              ),
              _react2.default.createElement(
                'td',
                null,
                child.model.name
              ),
              child.statistics.map(function (sta, j) {
                return _react2.default.createElement(
                  'td',
                  { key: j },
                  sta
                );
              })
            );
          })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      console.log(this.props.dataList);

      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        this.renderData({
          data: (0, _lodash.get)(this.props, 'dataList', []),
          totalCol: this.props.totalCol
        })
      );
    }
  }]);

  return ListItemKetQuaKiemTraTheoKeHoach;
}(_react2.default.Component);

exports.default = ListItemKetQuaKiemTraTheoKeHoach;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemKetQuaThucHienKetLuanThanhTraHanhChinh = function (_React$Component) {
  _inherits(ListItemKetQuaThucHienKetLuanThanhTraHanhChinh, _React$Component);

  function ListItemKetQuaThucHienKetLuanThanhTraHanhChinh(props, context) {
    _classCallCheck(this, ListItemKetQuaThucHienKetLuanThanhTraHanhChinh);

    var _this = _possibleConstructorReturn(this, (ListItemKetQuaThucHienKetLuanThanhTraHanhChinh.__proto__ || Object.getPrototypeOf(ListItemKetQuaThucHienKetLuanThanhTraHanhChinh)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemKetQuaThucHienKetLuanThanhTraHanhChinh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemKetQuaThucHienKetLuanThanhTraHanhChinh;
}(_react2.default.Component);

exports.default = ListItemKetQuaThucHienKetLuanThanhTraHanhChinh;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

var _function = __webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemKetQuaTongHopKetQuaThanhTra = function (_React$Component) {
  _inherits(ListItemKetQuaTongHopKetQuaThanhTra, _React$Component);

  function ListItemKetQuaTongHopKetQuaThanhTra(props, context) {
    _classCallCheck(this, ListItemKetQuaTongHopKetQuaThanhTra);

    var _this = _possibleConstructorReturn(this, (ListItemKetQuaTongHopKetQuaThanhTra.__proto__ || Object.getPrototypeOf(ListItemKetQuaTongHopKetQuaThanhTra)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemKetQuaTongHopKetQuaThanhTra, [{
    key: 'renderData',
    value: function renderData(_ref) {
      var data = _ref.data,
          totalCol = _ref.totalCol;

      var rootStyle = { color: '#0077EE', fontWeight: 'bold' };

      return data.map(function (item, i) {
        return _react2.default.createElement(
          'span',
          { style: { display: 'contents' } },
          _react2.default.createElement(
            'tr',
            { key: i },
            _react2.default.createElement(
              'td',
              { style: item.rootLevel ? rootStyle : {} },
              item.rootLevel ? (0, _function.generateRomanNumeralsObject)(100)[i + 1] : null
            ),
            _react2.default.createElement(
              'td',
              {
                style: item.rootLevel ? rootStyle : { fontWeight: 'bold' },
                colSpan: (0, _lodash.isEmpty)(item.children) && item.rootLevel ? totalCol - 1 : 1
              },
              item.model.name
            ),
            item.statistics.map(function (sta, idx) {
              return _react2.default.createElement(
                'td',
                { key: idx },
                sta
              );
            })
          ),
          item.children.map(function (child, idx) {
            return _react2.default.createElement(
              'tr',
              { key: idx },
              _react2.default.createElement(
                'td',
                null,
                idx + 1
              ),
              _react2.default.createElement(
                'td',
                null,
                child.model.name
              ),
              child.statistics.map(function (sta, j) {
                return _react2.default.createElement(
                  'td',
                  { key: j },
                  sta
                );
              })
            );
          })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      console.log(this.props.dataList);

      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        this.renderData({
          data: (0, _lodash.get)(this.props, 'dataList', []),
          totalCol: this.props.totalCol
        })
      );
    }
  }]);

  return ListItemKetQuaTongHopKetQuaThanhTra;
}(_react2.default.Component);

exports.default = ListItemKetQuaTongHopKetQuaThanhTra;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeGQDKN = function (_React$Component) {
  _inherits(ListItemThongKeGQDKN, _React$Component);

  function ListItemThongKeGQDKN(props, context) {
    _classCallCheck(this, ListItemThongKeGQDKN);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeGQDKN.__proto__ || Object.getPrototypeOf(ListItemThongKeGQDKN)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeGQDKN, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNai ? Item.tongSoDonKhieuNai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donNhanTrongKyBaoCao ? Item.donNhanTrongKyBaoCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donTonKyTruocChuyenSang ? Item.donTonKyTruocChuyenSang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoVuViec ? Item.tongSoVuViec : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDonThuocThamQuyen ? Item.soDonThuocThamQuyen : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecThuocThamQuyen ? Item.soVuViecThuocThamQuyen : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecGiaiQuyetBangQDHanhChinh ? Item.soVuViecGiaiQuyetBangQDHanhChinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? Item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.khieuNaiDung ? Item.khieuNaiDung : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.khieuNaiSai ? Item.khieuNaiSai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.khieuNaiDungMotPhan ? Item.khieuNaiDungMotPhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.giaiQuyetLan1 ? Item.giaiQuyetLan1 : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.congNhanQuyetDinhGiaiQuyetLan1 ? Item.congNhanQuyetDinhGiaiQuyetLan1 : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.huySuaQuyetDinhGiaiQuyetLan1 ? Item.huySuaQuyetDinhGiaiQuyetLan1 : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiChoNhaNuocTien ? Item.kienNghiThuHoiChoNhaNuocTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiChoNhaNuocDat ? Item.kienNghiThuHoiChoNhaNuocDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.traLaiChoCongDanTien ? Item.traLaiChoCongDanTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.traLaiChoCongDanDat ? Item.traLaiChoCongDanDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soNguoiDuocTraLaiQuyenLoi ? Item.soNguoiDuocTraLaiQuyenLoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.kienNghiXuLyHanhChinhTongSoNguoi ? Item.kienNghiXuLyHanhChinhTongSoNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuChuyenCoQuanDieuTra ? Item.soVuChuyenCoQuanDieuTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDoiTuongChuyenCoQuanDieuTra ? Item.soDoiTuongChuyenCoQuanDieuTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuDaKhoiTo ? Item.soVuDaKhoiTo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDoiTuongDaKhoiTo ? Item.soDoiTuongDaKhoiTo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecGiaiQuyetDungThoiHan ? Item.soVuViecGiaiQuyetDungThoiHan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecGiaiQuyetQuaThoiHan ? Item.soVuViecGiaiQuyetQuaThoiHan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoQuyetDinhPhaiToChucThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienPhaiThuChoNhaNuoc ? Item.tienPhaiThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datPhaiThuChoNhaNuoc ? Item.datPhaiThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienDaThuChoNhaNuoc ? Item.tienDaThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datDaThuChoNhaNuoc ? Item.datDaThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienPhaiTraChoCongDan ? Item.tienPhaiTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datPhaiTraChoCongDan ? Item.datPhaiTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienDaTraChoCongDan ? Item.tienDaTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datDaTraChoCongDan ? Item.datDaTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeGQDKN;
}(_react2.default.Component);

exports.default = ListItemThongKeGQDKN;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeGQDTC = function (_React$Component) {
  _inherits(ListItemThongKeGQDTC, _React$Component);

  function ListItemThongKeGQDTC(props, context) {
    _classCallCheck(this, ListItemThongKeGQDTC);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeGQDTC.__proto__ || Object.getPrototypeOf(ListItemThongKeGQDTC)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeGQDTC, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCao ? Item.tongSoDonToCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donNhanTrongKyBaoCao ? Item.donNhanTrongKyBaoCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donTonKyTruocChuyenSang ? Item.donTonKyTruocChuyenSang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoVuViec ? Item.tongSoVuViec : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDonThuocThamQuyen ? Item.soDonThuocThamQuyen : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecThuocThamQuyen ? Item.soVuViecThuocThamQuyen : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.toCaoDung ? Item.toCaoDung : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.toCaoSai ? Item.toCaoSai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.toCaoDungMotPhan ? Item.toCaoDungMotPhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiChoNhaNuocTien ? Item.kienNghiThuHoiChoNhaNuocTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiChoNhaNuocDat ? Item.kienNghiThuHoiChoNhaNuocDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.traLaiChoCongDanTien ? Item.traLaiChoCongDanTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.traLaiChoCongDanDat ? Item.traLaiChoCongDanDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soNguoiDuocTraLaiQuyenLoi ? Item.soNguoiDuocTraLaiQuyenLoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.kienNghiXuLyHanhChinhTongSoNguoi ? Item.kienNghiXuLyHanhChinhTongSoNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuChuyenCoQuanDieuTra ? Item.soVuChuyenCoQuanDieuTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDoiTuongChuyenCoQuanDieuTra ? Item.soDoiTuongChuyenCoQuanDieuTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuDaKhoiTo ? Item.soVuDaKhoiTo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDoiTuongDaKhoiTo ? Item.soDoiTuongDaKhoiTo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecGiaiQuyetDungThoiHan ? Item.soVuViecGiaiQuyetDungThoiHan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soVuViecGiaiQuyetQuaThoiHan ? Item.soVuViecGiaiQuyetQuaThoiHan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoQuyetDinhPhaiToChucThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienPhaiThuChoNhaNuoc ? Item.tienPhaiThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datPhaiThuChoNhaNuoc ? Item.datPhaiThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienDaThuChoNhaNuoc ? Item.tienDaThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datDaThuChoNhaNuoc ? Item.datDaThuChoNhaNuoc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienPhaiTraChoCongDan ? Item.tienPhaiTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datPhaiTraChoCongDan ? Item.datPhaiTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.tienDaTraChoCongDan ? Item.tienDaTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.datDaTraChoCongDan ? Item.datDaTraChoCongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeGQDTC;
}(_react2.default.Component);

exports.default = ListItemThongKeGQDTC;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh = function (_React$Component) {
  _inherits(ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh, _React$Component);

  function ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh(props, context) {
    _classCallCheck(this, ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh.__proto__ || Object.getPrototypeOf(ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh;
}(_react2.default.Component);

exports.default = ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraChuyenNganh = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraChuyenNganh, _React$Component);

  function ListItemThongKeThanhTraChuyenNganh(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraChuyenNganh);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraChuyenNganh.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraChuyenNganh)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraChuyenNganh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSo ? Item.tongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.thanhLapDoan ? Item.thanhLapDoan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.thanhTraDocLap ? Item.thanhTraDocLap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.caNhanDuocThanhTra ? Item.caNhanDuocThanhTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.caNhanDuocKiemTra ? Item.caNhanDuocKiemTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.toChucDuocThanhTra ? Item.toChucDuocThanhTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.toChucDuocKiemTra ? Item.toChucDuocKiemTra : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soCoViPhamTongSo ? Item.soCoViPhamTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soCoViPhamCaNhan ? Item.soCoViPhamCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soCoViPhanToChuc ? Item.soCoViPhanToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soQDXuPhatHanhChinhTongSo ? Item.soQDXuPhatHanhChinhTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soQDXuPhatHanhChinhCaNhan ? Item.soQDXuPhatHanhChinhCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soQDXuPhatHanhChinhToChuc ? Item.soQDXuPhatHanhChinhToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienViPhamTongSo ? Item.soTienViPhamTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienViPhamCaNhan ? Item.soTienViPhamCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienViPhamToChuc ? Item.soTienViPhamToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienKienNghiThuHoi ? Item.soTienKienNghiThuHoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyTaiSanTongSo ? Item.soTienXuLyTaiSanTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyTaiSanTichThu ? Item.soTienXuLyTaiSanTichThu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyTaiSanTieuHuy ? Item.soTienXuLyTaiSanTieuHuy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyViPhamTongSo ? Item.soTienXuLyViPhamTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyViPhamCaNhan ? Item.soTienXuLyViPhamCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienXuLyViPhamToChuc ? Item.soTienXuLyViPhamToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienDaThuTongSo ? Item.soTienDaThuTongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienDaThuCaNhan ? Item.soTienDaThuCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.soTienDaThuToChuc ? Item.soTienDaThuToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraChuyenNganh;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraChuyenNganh;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraDatDai = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraDatDai, _React$Component);

  function ListItemThongKeThanhTraDatDai(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraDatDai);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraDatDai.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraDatDai)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraDatDai, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeThanhTraDatDai;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraDatDai;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraHanhChinh = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraHanhChinh, _React$Component);

  function ListItemThongKeThanhTraHanhChinh(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraHanhChinh);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraHanhChinh.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraHanhChinh)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraHanhChinh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeThanhTraHanhChinh;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraHanhChinh;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraLai = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraLai, _React$Component);

  function ListItemThongKeThanhTraLai(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraLai);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraLai.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraLai)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraLai, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSo ? Item.tongSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.kyTruocChuyenSang ? Item.kyTruocChuyenSang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.trienKhaiTrongKyBaoCao ? Item.trienKhaiTrongKyBaoCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketThucThanhTraTrucTiep ? Item.ketThucThanhTraTrucTiep : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.daBanHanhKetLuan ? Item.daBanHanhKetLuan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.viPhamTrinhTu ? Item.viPhamTrinhTu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketLuanKhongPhuHop ? Item.ketLuanKhongPhuHop : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.saiLamApDungPhapLuat ? Item.saiLamApDungPhapLuat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.coYLamSaiLechHoSo ? Item.coYLamSaiLechHoSo : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.viPhamNghiemTrong ? Item.viPhamNghiemTrong : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDonViDaThanhTraLai ? Item.soDonViDaThanhTraLai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.soDonViCoViPham ? Item.soDonViCoViPham : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.viPhamVeKinhTeTien ? Item.viPhamVeKinhTeTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.viPhamVeKinhTeDat ? Item.viPhamVeKinhTeDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiTien ? Item.kienNghiThuHoiTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiThuHoiDat ? Item.kienNghiThuHoiDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiKhacTien ? Item.kienNghiKhacTien : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.kienNghiKhacDat ? Item.kienNghiKhacDat : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.hanhChinhToChuc ? Item.hanhChinhToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.hanhChinhCaNhan ? Item.hanhChinhCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.chuyenCoQuanDieuTraVu ? Item.chuyenCoQuanDieuTraVu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.chuyenCoQuanDieuTraDoiTuong ? Item.chuyenCoQuanDieuTraDoiTuong : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.ketQuaThucHienTienDaThu ? Item.ketQuaThucHienTienDaThu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-right' },
          Item.ketQuaThucHienDatDaThu ? Item.ketQuaThucHienDatDaThu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketQuaThucHienToChuc ? Item.ketQuaThucHienToChuc : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketQuaThucHienCaNhan ? Item.ketQuaThucHienCaNhan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketQuaThucHienVu ? Item.ketQuaThucHienVu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.ketQuaThucHienDoiTuong ? Item.ketQuaThucHienDoiTuong : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeThanhTraLai;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraLai;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraThamNhung = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraThamNhung, _React$Component);

  function ListItemThongKeThanhTraThamNhung(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraThamNhung);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraThamNhung.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraThamNhung)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraThamNhung, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeThanhTraThamNhung;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraThamNhung;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraXayDungCoBan = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraXayDungCoBan, _React$Component);

  function ListItemThongKeThanhTraXayDungCoBan(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraXayDungCoBan);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraXayDungCoBan.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraXayDungCoBan)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraXayDungCoBan, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: (typeof this.props.item === 'undefined' ? 'row-set-height' : '') + ' ' + (this.props.sum ? 'txt-bold' : '') },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed txt-bold' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeThanhTraXayDungCoBan;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraXayDungCoBan;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeThanhTraXayTaiChinhNganSach = function (_React$Component) {
  _inherits(ListItemThongKeThanhTraXayTaiChinhNganSach, _React$Component);

  function ListItemThongKeThanhTraXayTaiChinhNganSach(props, context) {
    _classCallCheck(this, ListItemThongKeThanhTraXayTaiChinhNganSach);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeThanhTraXayTaiChinhNganSach.__proto__ || Object.getPrototypeOf(ListItemThongKeThanhTraXayTaiChinhNganSach)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeThanhTraXayTaiChinhNganSach, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemThongKeThanhTraXayTaiChinhNganSach;
}(_react2.default.Component);

exports.default = ListItemThongKeThanhTraXayTaiChinhNganSach;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeTiepCongDan = function (_React$Component) {
  _inherits(ListItemThongKeTiepCongDan, _React$Component);

  function ListItemThongKeTiepCongDan(props, context) {
    _classCallCheck(this, ListItemThongKeTiepCongDan);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeTiepCongDan.__proto__ || Object.getPrototypeOf(ListItemThongKeTiepCongDan)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeTiepCongDan, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenLuot ? Item.tiepCongDanThuongXuyenLuot : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenNguoi ? Item.tiepCongDanThuongXuyenNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenVuViecCu ? Item.tiepCongDanThuongXuyenVuViecCu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? Item.tiepCongDanThuongXuyenVuViecMoiPhatSinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? Item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? Item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongVuViecDonKhieuNaiLinhVucHanhChinh ? Item.tongVuViecDonKhieuNaiLinhVucHanhChinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? Item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? Item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? Item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? Item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucTuPhap ? Item.donKhieuNaiLinhVucTuPhap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donKhieuNaiLinhVucVeDang ? Item.donKhieuNaiLinhVucVeDang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongVuViecDonToCao ? Item.tongVuViecDonToCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donToCaoLinhVucHanhChinh ? Item.donToCaoLinhVucHanhChinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donToCaoLinhVucTuPhap ? Item.donToCaoLinhVucTuPhap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donToCaoLinhVucThamNhung ? Item.donToCaoLinhVucThamNhung : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donToCaoLinhVucVeDang ? Item.donToCaoLinhVucVeDang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.donToCaoLinhVucKhac ? Item.donToCaoLinhVucKhac : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.phanAnhKienNghiKhac ? Item.phanAnhKienNghiKhac : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.chuaDuocGiaiQuyet ? Item.chuaDuocGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.chuaCoQuyetDinhGiaiQuyet ? Item.chuaCoQuyetDinhGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.daCoQuyetDinhGiaiQuyet ? Item.daCoQuyetDinhGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.daCoBanAnCuaToa ? Item.daCoBanAnCuaToa : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeTiepCongDan;
}(_react2.default.Component);

exports.default = ListItemThongKeTiepCongDan;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKeXuLyDon = function (_React$Component) {
  _inherits(ListItemThongKeXuLyDon, _React$Component);

  function ListItemThongKeXuLyDon(props, context) {
    _classCallCheck(this, ListItemThongKeXuLyDon);

    var _this = _possibleConstructorReturn(this, (ListItemThongKeXuLyDon.__proto__ || Object.getPrototypeOf(ListItemThongKeXuLyDon)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKeXuLyDon, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-name-fixed' },
          Item.donVi ? Item.donVi.ten : Item.capDonVi ? Item.capDonVi.ten : ''
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTiepNhanXLDTCD ? Item.tongSoDonTiepNhanXLDTCD : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy ? Item.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? Item.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang ? Item.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonDuDieuKienThuLy ? Item.tongSoDonDuDieuKienThuLy : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucHanhChinh ? Item.tongSoDonKhieuNaiLinhVucHanhChinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? Item.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan ? Item.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC ? Item.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac ? Item.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucTuPhap ? Item.tongSoDonKhieuNaiLinhVucTuPhap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonKhieuNaiLinhVucVeDang ? Item.tongSoDonKhieuNaiLinhVucVeDang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonLinhVucToCao ? Item.tongSoDonLinhVucToCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCaoLinhVucHanhChinh ? Item.tongSoDonToCaoLinhVucHanhChinh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCaoLinhVucTuPhap ? Item.tongSoDonToCaoLinhVucTuPhap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCaoLinhVucThamNhung ? Item.tongSoDonToCaoLinhVucThamNhung : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCaoLinhVucVeDang ? Item.tongSoDonToCaoLinhVucVeDang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonToCaoLinhVucKhac ? Item.tongSoDonToCaoLinhVucKhac : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap ? Item.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap ? Item.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTheoTQGQCuaCoQuanDang ? Item.tongSoDonTheoTQGQCuaCoQuanDang : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet ? Item.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet ? Item.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonXLDDonKienNghiPhanAnh ? Item.tongSoDonXLDDonKienNghiPhanAnh : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonXLDSoVanBanHuongDan ? Item.tongSoDonXLDSoVanBanHuongDan : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonChuyenCQCoThamQuyen ? Item.tongSoDonChuyenCQCoThamQuyen : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet ? Item.tongSoDonCoSoCongVanDonDocViecGiaiQuyet : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonThuocThamQuyenKhieuNai ? Item.tongSoDonThuocThamQuyenKhieuNai : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'txt-center' },
          Item.tongSoDonThuocThamQuyenToCao ? Item.tongSoDonThuocThamQuyenToCao : 0
        ),
        _react2.default.createElement(
          'td',
          { className: 'ghi-chu' },
          Item.ghiChu ? Item.ghiChu : ''
        )
      );
    }
  }]);

  return ListItemThongKeXuLyDon;
}(_react2.default.Component);

exports.default = ListItemThongKeXuLyDon;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh = function (_React$Component) {
  _inherits(ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh, _React$Component);

  function ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh(props, context) {
    _classCallCheck(this, ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh);

    var _this = _possibleConstructorReturn(this, (ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh.__proto__ || Object.getPrototypeOf(ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh, [{
    key: 'render',
    value: function render() {
      var Item = this.props.item || {};
      return _react2.default.createElement(
        'tr',
        { className: this.props.sum ? 'txt-bold' : '' },
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          { className: 'column-stt-fixed' },
          (0, _lodash.get)(Item, 'model.name')
        ),
        (0, _lodash.get)(Item, 'statistics').map(function (item) {
          return _react2.default.createElement(
            'td',
            { className: 'txt-center' },
            item
          );
        })
      );
    }
  }]);

  return ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh;
}(_react2.default.Component);

exports.default = ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItemThongKe = function (_React$Component) {
  _inherits(ListItemThongKe, _React$Component);

  function ListItemThongKe(props, context) {
    _classCallCheck(this, ListItemThongKe);

    var _this = _possibleConstructorReturn(this, (ListItemThongKe.__proto__ || Object.getPrototypeOf(ListItemThongKe)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ListItemThongKe, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { display: 'contents' } },
        (0, _lodash.get)(this.props, 'dataList', []).map(function (item, i) {
          return _react2.default.createElement(
            'tr',
            { key: i },
            _react2.default.createElement(
              'td',
              null,
              i + 1
            ),
            _react2.default.createElement(
              'td',
              null,
              item.model.code
            ),
            _react2.default.createElement(
              'td',
              null,
              item.model.name
            ),
            item.statistics.map(function (sta, idx) {
              return _react2.default.createElement(
                'td',
                { className: 'txt-center', key: i + '-' + idx },
                sta
              );
            })
          );
        })
      );
    }
  }]);

  return ListItemThongKe;
}(_react2.default.Component);

exports.default = ListItemThongKe;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Statistical = undefined;

var _statistical = __webpack_require__(1424);

var _statistical2 = _interopRequireDefault(_statistical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Statistical = _statistical2.default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _dataTable = __webpack_require__(15);

var _common = __webpack_require__(3);

var _table = __webpack_require__(12);

var _layout = __webpack_require__(9);

var _lodash = __webpack_require__(14);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ListItemThongKe = __webpack_require__(1422);

var _ListItemThongKe2 = _interopRequireDefault(_ListItemThongKe);

var _config = __webpack_require__(16);

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Statistical = function (_React$Component) {
  _inherits(Statistical, _React$Component);

  function Statistical(props, context) {
    _classCallCheck(this, Statistical);

    var _this = _possibleConstructorReturn(this, (Statistical.__proto__ || Object.getPrototypeOf(Statistical)).call(this, props, context));

    _this.state = {
      data: [],
      listNamThanhTra: [],
      namThanhTra: new Date().getFullYear()
    };
    return _this;
  }

  _createClass(Statistical, [{
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'namThanhTra') {
        this.setState({
          namThanhTra: e.target.value
        });
      }
    }
  }, {
    key: 'getThongKe',
    value: function getThongKe(params) {
      var _this2 = this;

      this.setState({
        tableLoading: true
      });

      _api.BaoCaoThanhTra.actions.getThongKe.request(null, params).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: res.data,
            tableLoading: false,
            search: false
          });
        }
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      var params = {
        year: this.state.namThanhTra,
        statisticType: 'YEAR'
      };
      this.getThongKe(params);
    }
  }, {
    key: 'handleExport',
    value: function handleExport() {
      var url = _config.API_URL + '/thong-ke-bao-cao/KHTH?year=' + this.state.namThanhTra + '&statisticType=YEAR';
      _axios2.default.get(url, {
        headers: {
          'Content-Type': 'application/octet-stream',
          Accept: 'application/octet-stream'
        },
        responseType: 'blob'
      }).then(function (response) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = 'thong-ke-bao-cao';
        a.click();
      }).catch(function (err) {
        console.error('error', err);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getNamThanhTra();
      this.handleSearch();
    }
  }, {
    key: 'getNamThanhTra',
    value: function getNamThanhTra() {
      var _this3 = this;

      _api.DuLieuHeThong.actions.getNamThanhTra.request(null, {}).then(function (res) {
        var data = res.data;

        if (!(0, _lodash.isEmpty)(data)) {
          _this3.setState({
            listNamThanhTra: data
          });
        }
      });
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      return _react2.default.createElement(
        'div',
        { className: 'top-content' },
        _react2.default.createElement(
          'div',
          { className: 'left-content' },
          _react2.default.createElement(
            'p',
            { className: 'title-18' },
            _react2.default.createElement('i', { className: 'tt tt-thanh-tra' }),
            'Th\u1ED1ng k\xEA k\u1EBF ho\u1EA1ch, th\u1EF1c hi\u1EC7n thanh tra, ki\u1EC3m tra'
          )
        )
      );
    }
  }, {
    key: 'renderFilter',
    value: function renderFilter() {
      return _react2.default.createElement(
        'div',
        { className: 'row pl25 pr25 pt15 super-search' },
        _react2.default.createElement(
          'div',
          { className: 'col-20 no-gutter home-search-group' },
          _react2.default.createElement(_common.DropDown, {
            className: 'combobox-nam-thanh-tra pl5 pr5',
            label: 'N\u0103m k\u1EBF ho\u1EA1ch',
            selectedValue: this.state.namThanhTra,
            placeholder: null,
            onChange: this.onChange.bind(this, 'namThanhTra'),
            options: this.state.listNamThanhTra,
            valueName: 'ten',
            keyName: 'giaTri'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-16 btn-thongke' },
          _react2.default.createElement(_core.Button, {
            className: this.state.tableLoading ? this.state.search ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable' : 'btn-green tt-search',
            text: 'T\xECm ki\u1EBFm',
            onClick: this.handleSearch.bind(this)
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-100' },
          _react2.default.createElement(
            'div',
            { className: 'col-90 p0 mb15' },
            _react2.default.createElement(_core.Button, {
              className: 'btn-green tt-export',
              text: 'Xu\u1EA5t Excel',
              onClick: this.handleExport.bind(this)
            })
          )
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      return _react2.default.createElement(
        'div',
        { className: 'wrap-table clear-left' },
        _react2.default.createElement(
          _dataTable.DataTableKetQua,
          {
            touchMove: true,
            header: _table.header.thongKe,
            tableLoading: this.state.tableLoading
          },
          _react2.default.createElement(_ListItemThongKe2.default, { dataList: this.state.data })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          {
            className: 'center reception-container wrap-block',
            ref: 'thongKeBaoCao'
          },
          this.renderTitle(),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content thongke-content' },
            this.renderFilter(),
            _react2.default.createElement(
              'div',
              { className: 'col-100 no-gutter pt5' },
              _react2.default.createElement('span', { className: 'line-border' })
            ),
            this.renderTable()
          )
        )
      );
    }
  }]);

  return Statistical;
}(_react2.default.Component);

exports.default = Statistical;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _core = __webpack_require__(7);

var OurToaster = _core.Toaster.create({
	className: "my-toaster",
	position: _core.Position.TOP_CENTER
});

var timeShow = 2000;

var Toastr = function Toastr(msg, type) {
	switch (type) {
		case 'success':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: _core.Intent.SUCCESS, timeout: timeShow, iconName: 'tick' });
			break;
		case 'error':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: _core.Intent.DANGER, timeout: timeShow, iconName: 'warning-sign' });
			break;
		case 'primary':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: _core.Intent.PRIMARY, timeout: timeShow });
			break;
		case 'warning':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: _core.Intent.WARNING, timeout: timeShow, iconName: 'warning-sign' });
			break;
		case 'thongbao':
			OurToaster.show({ message: msg, intent: _core.Intent.WARNING, timeout: timeShow, iconName: 'warning-sign' });
			break;
		case 'resetclear':
			OurToaster.clear();
			break;
		default:
			OurToaster.clear();
			OurToaster.show({ message: msg, timeout: timeShow });
			break;
	}
};

exports.default = Toastr;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _RowItemKetQuaTraCuu = __webpack_require__(500);

var _RowItemKetQuaTraCuu2 = _interopRequireDefault(_RowItemKetQuaTraCuu);

var _RowItemKetQuaTTCP = __webpack_require__(1432);

var _RowItemKetQuaTTCP2 = _interopRequireDefault(_RowItemKetQuaTTCP);

var _lodash = __webpack_require__(14);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CanBoTraCuu = function (_React$Component) {
  _inherits(CanBoTraCuu, _React$Component);

  function CanBoTraCuu(props, context) {
    _classCallCheck(this, CanBoTraCuu);

    var _this = _possibleConstructorReturn(this, (CanBoTraCuu.__proto__ || Object.getPrototypeOf(CanBoTraCuu)).call(this, props, context));

    _this.state = {
      value: '',
      phamVi: 'ALL',
      maDon: '',
      hoTen: '',
      diaChi: '',
      donViTiepNhanData: [],
      listDonViTiepNhan: [],
      listTinhTrangXuLy: [],
      phanLoaiDon: '',
      linhVucId: '',
      linhVucChiTietId: '',
      nguonDon: '',
      loading: false,
      data: [],
      soDinhDanhCaNhan: '',
      maTinh: '',
      maHuyen: '',
      maXa: '',
      noiDung: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      firstLoad: false,
      listLoaiTraCuu: [],
      loaiTraCuu: 'DON_THEO_QUY_TRINH',
      isDonCu: false,
      search: false
    };
    return _this;
  }

  _createClass(CanBoTraCuu, [{
    key: 'getLoaiDonTraCuu',
    value: function getLoaiDonTraCuu() {
      var _this2 = this;

      _api.ThongKeBaoCao.actions.getLoaiDonTraCuu.request().then(function (res) {
        if (res.data) {
          _this2.setState({ listLoaiTraCuu: res.data });
        } else {
          _this2.setState({ listLoaiTraCuu: [] });
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getTinhTrangTraCuu();
      this.getLoaiDonTraCuu();
      var arrData = [].concat(_toConsumableArray(this.state.donViTiepNhanData));
      this.props.dvTiepNhanList.map(function (item) {
        return arrData = [].concat(_toConsumableArray(arrData), [{ value: item.coQuanQuanLyId, label: item.ten }]);
      });
      var data = localStorage.getItem('tcData') ? JSON.parse(localStorage.getItem('tcData')) : {};
      this.state.donViTiepNhanData = arrData;
      this.state.pageData.number = data.page || 0;
      this.state.pageData.size = data.size || 10;
      this.state.phamVi = data.taiDonVi == 'TTCP' ? data.taiDonVi : data.taiDonVi ? 'SCOPE' : 'ALL';
      this.state.maDon = data.maDon || data.maVuViec || '';
      this.state.hoTen = data.hoTen || data.tenNguoiKhieuNai || '';
      this.state.soDinhDanhCaNhan = data.soDinhDanhCaNhan || '';
      this.state.maTinh = data.maTinh || '';
      this.state.maHuyen = data.maHuyen || '';
      this.state.maXa = data.maXa || '';
      this.state.noiDung = data.noiDung || '';
      this.state.diaChi = data.diaChi || '';
      this.state.listDonViTiepNhan = data.listDVTN && data.listDVTN.length ? data.listDVTN : [];
      this.state.phanLoaiDon = data.phanLoaiDon || '';
      this.state.linhVucId = data.linhVucId || '';
      this.state.linhVucChiTietId = data.linhVucChiTietId || '';
      this.state.nguonDon = data.nguonDon || '';

      if (Object.keys(data).length > 1) {
        this.handleSearch();
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'phamVi') {
        this.setState(_defineProperty({ data: [], pageData: { number: 0, size: 10, totalElements: 0 } }, name, e.target.value));
      } else if (name == 'listDonViTiepNhan') {
        this.setState({ listDonViTiepNhan: e });
      } else {
        if (name == 'phanLoaiDon') {
          this.setState({ linhVucId: '', linhVucChiTietId: '' });
        }

        if (name == 'maTinh' || name == 'maHuyen') {
          this.state.maXa = '';
          if (name == 'maTinh') {
            this.state.maHuyen = '';
          }
        }
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(isFirst) {
      var _this3 = this;

      if (this.state.phamVi != 'TTCP') {
        if (isFirst) {
          this.state.pageData = {
            number: 0,
            size: 10,
            totalElements: 0
          };
        }
        var params = {
          taiDonVi: this.state.phamVi === 'SCOPE' ? true : false,
          page: this.state.pageData.number,
          size: this.state.pageData.size,
          nguonDon: this.state.nguonDon || undefined,
          loaiDonTraCuu: this.state.loaiTraCuu || undefined,
          maDon: this.state.maDon && this.state.maDon.trim() || undefined,
          hoTen: this.state.hoTen && this.state.hoTen.trim() || undefined,
          diaChi: this.state.diaChi && this.state.diaChi.trim() || undefined,
          phanLoaiDon: this.state.phanLoaiDon || undefined,
          linhVucId: this.state.linhVucId || undefined,
          linhVucChiTietId: this.state.linhVucChiTietId || undefined
        };
        if (this.state.listDonViTiepNhan.length) {
          var strId = [];
          this.state.listDonViTiepNhan.map(function (item) {
            strId.push(item.value);
          });
          params.listDonViTiepNhan = strId.join();
        }
        this.setState({ loading: true });
        localStorage.setItem('tcData', JSON.stringify(params));
        _api.TrangChu.actions.getTraCuuDonCanBo.request(null, params).then(function (res) {
          if (res.data && res.data._embedded) {
            var newData = [];
            var isDonCu = false;
            if (_this3.state.loaiTraCuu === 'DON_CU_NHAP_LIEU') {
              newData = (0, _lodash.get)(res, 'data._embedded.donCus');
              isDonCu = true;
            } else {
              newData = (0, _lodash.get)(res, 'data._embedded.medial_DonTraCuus');
            }
            _this3.setState({
              data: newData,
              isDonCu: isDonCu
            });
          } else {
            _this3.setState({ data: [] });
          }
          _this3.setState({
            loading: false,
            pageData: res.data.page,
            firstLoad: true
          });
        }).catch(function (error) {
          _this3.setState({
            data: [],
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
            firstLoad: true,
            loading: false
          });
        });
      } else {
        var _params = { taiDonVi: this.state.phamVi };
        if (this.state.maDon) {
          _params.maVuViec = this.state.maDon.trim();
        }
        if (this.state.hoTen) {
          _params.tenNguoiKhieuNai = this.state.hoTen.trim();
        }
        if (this.state.soDinhDanhCaNhan) {
          _params.soDinhDanhCaNhan = this.state.soDinhDanhCaNhan.trim();
        }
        if (this.state.noiDung) {
          _params.noiDung = this.state.noiDung.trim();
        }
        if (this.state.maTinh) {
          _params.maTinh = this.state.maTinh;
        }
        if (this.state.maHuyen) {
          _params.maHuyen = this.state.maHuyen;
        }
        if (this.state.maXa) {
          _params.maXa = this.state.maXa;
        }
        this.setState({ loading: true, pageData: { number: 0, size: 10, totalElements: 0 } });
        localStorage.setItem('tcData', JSON.stringify(_params));
        _api.TrangChu.actions.getTraCuuDonTTCP.request(null, _params).then(function (res) {
          if (res.data) {
            _this3.setState({ data: res.data, loading: false, pageData: { number: 0, size: 10, totalElements: res.data.length } });
          } else {
            _this3.setState({ data: [], loading: false });
            _this3.setState({ loading: false });
          }
        }).catch(function (error) {
          _this3.setState({
            data: [],
            loading: false
          });
        });
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.handleSearch();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.number = 0;
      this.state.pageData.size = size;
      this.handleSearch();
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'getTinhTrangTraCuu',
    value: function getTinhTrangTraCuu() {
      var _this4 = this;

      _api.TrangChu.actions.getTinhTrangTraCuuDon.request().then(function (res) {
        if (res.data) {
          _this4.setState({ listTinhTrangXuLy: res.data });
        } else {
          _this4.setState({ listTinhTrangXuLy: [] });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dvTiepNhanList != this.props.dvTiepNhanList) {
        var arrData = [].concat(_toConsumableArray(this.state.donViTiepNhanData));
        nextProps.dvTiepNhanList.map(function (item) {
          arrData = [].concat(_toConsumableArray(arrData), [{ value: item.coQuanQuanLyId, label: item.ten }]);
        });
        this.setState({ donViTiepNhanData: arrData });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var data = [{
        ten: 'Tra cứu trong đơn vị',
        giaTri: 'SCOPE'
      }, {
        ten: 'Tra cứu toàn hệ thống',
        giaTri: 'ALL'
        /* {
           ten: 'Tra cứu tại TTCP',
           giaTri: 'TTCP'
        } */
      }];
      var getHeader = function getHeader() {
        if (_this5.state.phamVi == 'TTCP') {
          return _table.header.listTraCuuTTCP;
        }
        return _this5.state.isDonCu ? _table.header.listTraCuuDonCu : _table.header.listTraCuuDon;
      };
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'heading', style: { marginBottom: '0px' } },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-search', style: { display: 'inline-block', marginRight: '40px' } },
                'Tra c\u1EE9u \u0111\u01A1n'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-block' } },
                _react2.default.createElement(_common.RadioButton, { options: data,
                  selectedValue: this.state.phamVi,
                  keyName: 'giaTri',
                  valueName: 'ten',
                  onChange: this.onChange.bind(this, 'phamVi') })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'form',
              { onSubmit: this.handleSearch.bind(this, true), action: 'javascript:void(0)', noValidate: true },
              _react2.default.createElement(
                'div',
                { className: 'search-container super-search' },
                _react2.default.createElement(_common.DropDown, { className: 'input-20', label: 'Lo\u1EA1i tra c\u1EE9u', options: this.state.listLoaiTraCuu, keyName: 'giaTri', valueName: 'ten', selectedValue: this.state.loaiTraCuu, placeholder: null, onChange: this.onChange.bind(this, 'loaiTraCuu') }),
                _react2.default.createElement(_common.Input, { label: 'M\xE3 \u0111\u01A1n', name: 'maDon', placeholder: 'Nh\u1EADp...', value: this.state.maDon, onChange: this.onChange.bind(this, 'maDon'), className: 'input-20' }),
                _react2.default.createElement(_common.Input, { label: 'T\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n', name: 'hoTen', placeholder: 'Nh\u1EADp...', value: this.state.hoTen, onChange: this.onChange.bind(this, 'hoTen'), className: 'input-20', maxLength: 255 }),
                this.state.phamVi == 'TTCP' && _react2.default.createElement(_common.Input, { label: 'S\u1ED1 CMND', name: 'scmnd', placeholder: 'Nh\u1EADp...', value: this.state.soDinhDanhCaNhan, onChange: this.onChange.bind(this, 'soDinhDanhCaNhan'), className: 'input-20' }),
                this.state.phamVi != 'TTCP' && _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa ch\u1EC9', placeholder: 'Nh\u1EADp...', name: 'diaChi', value: this.state.diaChi, onChange: this.onChange.bind(this, 'diaChi'), className: 'input-20' }),
                _react2.default.createElement(
                  'div',
                  { className: 'btn-wrap-20' },
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'submit',
                      className: (0, _classnames2.default)('pt-button btn-green tt-search', {
                        'btn-loading-inline': this.state.loading
                      }) },
                    _react2.default.createElement(
                      'span',
                      null,
                      'Xem k\u1EBFt qu\u1EA3'
                    )
                  )
                ),
                this.state.phamVi == 'TTCP' && _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(_common.Input, { label: 'N\u1ED9i dung', name: 'noidung', placeholder: 'Nh\u1EADp...', value: this.state.noiDung, onChange: this.onChange.bind(this, 'noiDung'), className: 'input-20' })
                ),
                this.state.phamVi != 'TTCP' && _react2.default.createElement(
                  'div',
                  { className: 'clear-left' },
                  _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, className: 'input-20', label: 'Lo\u1EA1i \u0111\u01A1n', onChange: this.onChange.bind(this, 'phanLoaiDon'), name: 'dropdownChonLoaiDonThu', isTraCuu: true })
                ),
                this.state.phamVi != 'TTCP' && _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThu, { selectedValue: this.state.linhVucId, allowHidden: false, className: 'input-20', label: 'L\u0129nh v\u1EF1c', loaiDonThuID: this.state.phanLoaiDon, onChange: this.onChange.bind(this, 'linhVucId'), name: 'dropdownChonLinhVucDonThu' }),
                this.state.phamVi != 'TTCP' && _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThuChiTiet, { label: 'L\u0129nh v\u1EF1c chi ti\u1EBFt (n\u1EBFu c\xF3)', allowHidden: false, className: 'input-20', loaiDonThuID: this.state.phanLoaiDon, selectedValue: this.state.linhVucChiTietId, linhVucDonThuID: this.state.linhVucId, onChange: this.onChange.bind(this, 'linhVucChiTietId'), name: 'dropdownChonLinhVucCap2Id' }),
                this.state.phamVi != 'TTCP' && _react2.default.createElement(_ttForms.DropDownChonNguonDon, {
                  selectedValue: this.state.nguonDon,
                  onChange: this.onChange.bind(this, 'nguonDon'),
                  className: 'input-20' }),
                this.state.phamVi == 'TTCP' && _react2.default.createElement(_common.Input, { label: 'M\xE3 t\u1EC9nh', placeholder: 'Nh\u1EADp...', name: 'maTinh', value: this.state.maTinh, onChange: this.onChange.bind(this, 'maTinh'), className: 'input-20' }),
                this.state.phamVi == 'TTCP' && _react2.default.createElement(_common.Input, { label: 'M\xE3 huy\u1EC7n', placeholder: 'Nh\u1EADp...', name: 'maHuyen', value: this.state.maHuyen, onChange: this.onChange.bind(this, 'maHuyen'), className: 'input-20' }),
                this.state.phamVi == 'TTCP' && _react2.default.createElement(_common.Input, { label: 'M\xE3 x\xE3', placeholder: 'Nh\u1EADp...', name: 'maXa', value: this.state.maXa, onChange: this.onChange.bind(this, 'maXa'), className: 'input-20' }),
                this.state.phamVi != 'TTCP' && this.state.phamVi !== "SCOPE" && _react2.default.createElement(_common.DropDownMultipleSelect, { name: 'listDonViTiepNhan', className: 'input-20', label: '\u0110\u1ECBa b\xE0n (\u0110\u01A1n v\u1ECB) ti\u1EBFp nh\u1EADn', options: this.state.donViTiepNhanData, placeholder: { key: '', text: '--Chọn--' }, value: this.state.listDonViTiepNhan, onChange: this.onChange.bind(this, 'listDonViTiepNhan') })
              )
            ),
            this.state.data.length || this.state.firstLoad ? _react2.default.createElement(
              _dataTable2.default,
              { header: getHeader(),
                dataList: this.state.data,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                displayCount: true,
                search: this.state.search,
                tableLoading: this.state.loading },
              this.state.phamVi == 'TTCP' ? _react2.default.createElement(_RowItemKetQuaTTCP2.default, { isDonCu: this.state.isDonCu }) : _react2.default.createElement(_RowItemKetQuaTraCuu2.default, { phamVi: this.state.phamVi, isDonCu: this.state.isDonCu })
            ) : ''
          )
        )
      );
    }
  }]);

  return CanBoTraCuu;
}(_react2.default.Component);

CanBoTraCuu.defaultProps = {
  dvTiepNhanList: []
};

function bindStateToProps(state) {
  return {
    dvTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

exports.default = (0, _reactRedux.connect)(bindStateToProps)(CanBoTraCuu);

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _layout = __webpack_require__(9);

var _bind = __webpack_require__(240);

var _bind2 = _interopRequireDefault(_bind);

var _core = __webpack_require__(7);

var _reactRouter = __webpack_require__(2);

var _RowItemDocumentDetail = __webpack_require__(499);

var _RowItemDocumentDetail2 = _interopRequireDefault(_RowItemDocumentDetail);

var _DanhSachBangChung = __webpack_require__(1429);

var _DanhSachBangChung2 = _interopRequireDefault(_DanhSachBangChung);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _table = __webpack_require__(12);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

var _letterDetail = __webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietTraCuu = function (_React$Component) {
  _inherits(ChiTietTraCuu, _React$Component);

  function ChiTietTraCuu(props, context) {
    _classCallCheck(this, ChiTietTraCuu);

    var _this = _possibleConstructorReturn(this, (ChiTietTraCuu.__proto__ || Object.getPrototypeOf(ChiTietTraCuu)).call(this, props, context));

    _this.state = {
      data: {},
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],
      loaiDonGiaTri: '',
      loaiDon: '',
      loaiDoiTuong: {},
      listTaiLieuBangChung: [],
      listTepChungChiHanhNghe: [],
      listTepUyQuyen: [],
      lichSuTrangThaiXLGQDons: '',
      isOpen: false,
      loading: false
    };
    return _this;
  }

  _createClass(ChiTietTraCuu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.searchData(this.props.params.maDon);
      localStorage.setItem('tc.enableSearch', 1);
    }
  }, {
    key: 'getlichSuTrangThaiXLGQDon',
    value: function getlichSuTrangThaiXLGQDon(donId) {
      var _this2 = this;

      var phamVi = this.props.location.state.phamVi;

      if (phamVi === 'SCOPE') {
        _api.TrangChu.actions.getLichSuTrangThaiXLGQDonTaiDonVis.request(null, { donId: donId }).then(function (res) {
          if (res.data && res.data._embedded) {
            _this2.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
          }
        });
      } else {
        _api.TrangChu.actions.getlichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs.request(null, { donId: donId }).then(function (res) {
          if (res.data && res.data._embedded) {
            _this2.setState({ lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons });
          }
        });
      }
    }
  }, {
    key: 'searchData',
    value: function searchData(key) {
      var _this3 = this;

      _api.TrangChu.actions.getTraCuuDonCongDan.request(null, { maDon: key }).then(function (res) {
        if (res.data) {
          var donId = res.data.donId;
          var newState = _extends({}, _this3.state);
          newState.data = res.data;
          newState.data.loaiNguoiDungDon = res.data.loaiNguoiDungDonInfo.giaTri;
          newState.data.loaiVuViecInfo = { ten: res.data.loaiVuViec };
          newState.loaiNguoiDungDon = res.data.loaiNguoiDungDonInfo.giaTri;
          newState.dataNguoiDungDon = res.data.listNguoiDungDon;
          newState.dataDoanDiCung = res.data.listDoanDiCung;
          newState.loaiDon = res.data.loaiDonThuInfo.ten;
          newState.loaiDonGiaTri = res.data.loaiDonThuInfo.giaTri;
          newState.loaiDoiTuong = { ten: res.data.loaiDoiTuong };
          newState.linhVuc = res.data.linhVucDonThu;
          newState.linhVucChiTiet = res.data.linhVucDonThuChiTiet;
          newState.linhVucChiTietSub = res.data.linhVucChiTietKhac;
          newState.noiDung = res.data.noiDung;
          newState.dataNguoiDuocUyQuyen = res.data.nguoiDuocUyQuyen;
          _this3.setState(_extends({}, newState));
          _this3.getlichSuTrangThaiXLGQDon(donId);
        }
      }).catch(function (error) {});
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name, type: this.props.route.type },
        _react2.default.createElement(
          'div',
          { className: 'panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'back-foward' },
              _react2.default.createElement(
                _reactRouter.Link,
                { onClick: _reactRouter.browserHistory.goBack, title: '' },
                'V\u1EC1 trang tr\u01B0\u1EDBc'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-detail' },
                'Chi ti\u1EBFt \u0111\u01A1n/v\u1EE5 vi\u1EC7c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              this.state.loaiDon ? _react2.default.createElement(
                'div',
                { className: 'wrapper_box mb30' },
                _react2.default.createElement(
                  'div',
                  { className: 'page-wrapper mt0' },
                  _react2.default.createElement(
                    'div',
                    { className: 'content-wrap content-gqd background-detail panel-page' },
                    _react2.default.createElement(
                      'div',
                      { className: 'header-redirect background-detail' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-items no-border' },
                        _react2.default.createElement(
                          'div',
                          { className: 'row-col' },
                          _react2.default.createElement(_common.TextMessage, { className: 'header-col pl15', label: 'M\xE3 \u0111\u01A1n:', value: this.state.data.maHoSo || '' }),
                          _react2.default.createElement(_common.TextMessage, { className: 'header-col', label: 'Ng\xE0y ti\u1EBFp nh\u1EADn:', value: this.state.data.ngayTao ? (0, _moment2.default)(this.state.data.ngayTao).format('DD/MM/YYYY') : '' }),
                          _react2.default.createElement(_common.TextMessage, { className: 'header-col', label: 'Ngu\u1ED3n \u0111\u01A1n:', value: this.state.data.nguonDon }),
                          _react2.default.createElement('div', { className: 'header-col' }),
                          _react2.default.createElement(
                            'div',
                            { className: 'pull-right pr15' },
                            _react2.default.createElement(_core.Button, { onClick: this.handleClick.bind(this), className: (0, _bind2.default)('btn-collap', { 'active': this.state.isOpen }) })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap-block pl10 pr10 pt10' },
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-blocks' },
                        _react2.default.createElement(
                          _core.Collapse,
                          { isOpen: this.state.isOpen },
                          _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
                            title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                            parent: this.state
                          })
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.data.coUyQuyen },
                          _react2.default.createElement(
                            _core.Collapse,
                            { isOpen: this.state.isOpen },
                            _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
                              title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
                              parent: this.state
                            })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: (0, _bind2.default)('box-items', { 'no-margin': !this.state.isOpen }) },
                          _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
                            title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                            isOpen: this.state.isOpen,
                            parent: this.state
                          }),
                          this.state.data && this.state.data.listTaiLieuBangChung && this.state.data.listTaiLieuBangChung.length > 0 && _react2.default.createElement(_DanhSachBangChung2.default, { parent: this.state.data.listTaiLieuBangChung })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _utils.ShowIf,
                  { condition: this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length },
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-forward' },
                        _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-12' },
                              _react2.default.createElement(
                                'h3',
                                null,
                                'Qu\xE1 tr\xECnh x\u1EED l\xFD'
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'items-form' },
                          _react2.default.createElement(
                            'div',
                            { className: 'rows' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-12' },
                              _react2.default.createElement(
                                _dataTable2.default,
                                {
                                  header: _table.header.listTTXLGQD,
                                  dataList: this.state.lichSuTrangThaiXLGQDons,
                                  hidePagination: true },
                                _react2.default.createElement(_RowItemDocumentDetail2.default, null)
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'wrapper_box tc-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'box-items' },
                  _react2.default.createElement(
                    'div',
                    { className: 'container-box' },
                    _react2.default.createElement(
                      'div',
                      { className: 'items-form' },
                      _react2.default.createElement(
                        'div',
                        { className: 'rows' },
                        'Kh\xF4ng t\xECm th\u1EA5y \u0111\u01A1n n\xE0y.'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ChiTietTraCuu;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(ChiTietTraCuu);

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _reactRecaptchaGoogle = __webpack_require__(821);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CongDanTraCuu = function (_React$Component) {
  _inherits(CongDanTraCuu, _React$Component);

  function CongDanTraCuu(props, context) {
    _classCallCheck(this, CongDanTraCuu);

    var _this = _possibleConstructorReturn(this, (CongDanTraCuu.__proto__ || Object.getPrototypeOf(CongDanTraCuu)).call(this, props, context));

    _this.state = {
      value: '',
      ready: false,
      onOffForm: false
    };

    _this.onLoadRecaptcha = _this.onLoadRecaptcha.bind(_this);
    _this.verifyCallback = _this.verifyCallback.bind(_this);
    return _this;
  }

  _createClass(CongDanTraCuu, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _reactRecaptchaGoogle.loadReCaptcha)();
    }
  }, {
    key: 'onLoadRecaptcha',
    value: function onLoadRecaptcha() {}
  }, {
    key: 'verifyCallback',
    value: function verifyCallback(response) {
      if (response) {
        this.setState({
          ready: true,
          onOffForm: true
        });
      }
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      if (this.state.ready && this.state.value) {
        _reactRouter.browserHistory.push('/ket-qua-cong-dan-tra-cuu/' + this.state.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(
          'div',
          { className: 'tc-search-box' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            'Tra c\u1EE9u \u0111\u01A1n'
          ),
          _react2.default.createElement(
            'form',
            { onSubmit: this.handleSearch.bind(this) },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { type: 'text', name: 'searchKey', placeholder: 'Nh\u1EADp m\xE3 \u0111\u01A1n...', className: 'tc-input', onChange: this.onChange.bind(this),
                value: this.state.value, disabled: this.state.onOffForm === false ? 'disabled' : '' }),
              _react2.default.createElement(_reactRecaptchaGoogle.ReCaptcha, {
                render: 'explicit',
                sitekey: _config.siteKey,
                verifyCallback: this.verifyCallback,
                onloadCallback: this.onLoadRecaptcha,
                onSuccess: function onSuccess(token) {
                  return console.log(token);
                },
                onError: console.error.bind(console),
                hl: 'vi'
              }),
              _react2.default.createElement(
                'button',
                { type: 'submit', className: (0, _classnames2.default)('tc-bt button-tracuu', {
                    'no-drop': !this.state.onOffForm
                  }) },
                _react2.default.createElement(
                  'span',
                  null,
                  'Tra c\u1EE9u'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CongDanTraCuu;
}(_react2.default.Component);

exports.default = CongDanTraCuu;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _rowItem = __webpack_require__(110);

var _table = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachBangChung = function (_React$Component) {
  _inherits(DanhSachBangChung, _React$Component);

  function DanhSachBangChung() {
    _classCallCheck(this, DanhSachBangChung);

    return _possibleConstructorReturn(this, (DanhSachBangChung.__proto__ || Object.getPrototypeOf(DanhSachBangChung)).apply(this, arguments));
  }

  _createClass(DanhSachBangChung, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                'h3',
                null,
                'DANH S\xC1CH T\xC0I LI\u1EC6U K\xC8M THEO'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form white-table mb10' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _dataTable2.default,
                {
                  checkTraCuu: true,
                  header: _table.header.giaiQuyetDon.danhSachBangChung,
                  dataList: this.props.parent,
                  type: 'handle-letter-detail', hidePagination: true,
                  hiddenButtonExport: true },
                _react2.default.createElement(_rowItem.DetailTaiLieuRowItem, null)
              )
            )
          )
        )
      );
    }
  }]);

  return DanhSachBangChung;
}(_react2.default.Component);

DanhSachBangChung.defaultProps = {
  listTaiLieuBangChung: []
};

exports.default = DanhSachBangChung;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRedux = __webpack_require__(6);

var _table = __webpack_require__(12);

var _reactRouter = __webpack_require__(2);

var _api = __webpack_require__(5);

var _bind = __webpack_require__(240);

var _bind2 = _interopRequireDefault(_bind);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _common = __webpack_require__(3);

var _ttForms = __webpack_require__(19);

var _RowItemKetQuaTraCuu = __webpack_require__(500);

var _RowItemKetQuaTraCuu2 = _interopRequireDefault(_RowItemKetQuaTraCuu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiamSatTraCuu = function (_React$Component) {
  _inherits(GiamSatTraCuu, _React$Component);

  function GiamSatTraCuu(props, context) {
    _classCallCheck(this, GiamSatTraCuu);

    var _this = _possibleConstructorReturn(this, (GiamSatTraCuu.__proto__ || Object.getPrototypeOf(GiamSatTraCuu)).call(this, props, context));

    _this.state = {
      value: '',
      phamVi: 'ALL',
      hoTen: '',
      diaChi: '',
      maDon: '',
      linhVucId: '',
      phanLoaiDon: '',
      linhVucChiTietId: '',
      nguonDon: '',
      data: [],
      loading: false,
      donViTiepNhanData: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      firstLoad: false
    };
    return _this;
  }

  _createClass(GiamSatTraCuu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var arrData = [].concat(_toConsumableArray(this.state.donViTiepNhanData));
      this.props.dvTiepNhanList.forEach(function (item) {
        arrData.push(item);
      });
      var data = localStorage.getItem('tcData') ? JSON.parse(localStorage.getItem('tcData')) : {};
      this.setState({
        donViTiepNhanData: arrData,
        pageData: {
          number: data.page || 0,
          size: data.size || 10
        },
        maDon: data.maDon || data.maVuViec || '',
        hoTen: data.hoTen || data.tenNguoiKhieuNai || '',
        soDinhDanhCaNhan: data.soDinhDanhCaNhan || '',
        maTinh: data.maTinh || '',
        maHuyen: data.maHuyen || '',
        maXa: data.maXa || '',
        noiDung: data.noiDung || '',
        diaChi: data.diaChi || '',
        listDonViTiepNhan: data.listDVTN && data.listDVTN.length ? data.listDVTN : [],
        phanLoaiDon: data.phanLoaiDon || '',
        linhVucId: data.linhVucId || '',
        linhVucChiTietId: data.linhVucChiTietId || '',
        nguonDon: data.nguonDon || ''
      }, function () {
        if (Object.keys(data).length > 1) {
          _this2.handleSearch();
        }
      });
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(page) {
      this.state.pageData.number = page.selected;
      this.handleSearch();
    }
  }, {
    key: 'handleChangePageSize',
    value: function handleChangePageSize(size) {
      this.state.pageData.number = 0;
      this.state.pageData.size = size;
      this.handleSearch();
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(isFirst) {
      var _this3 = this;

      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (isFirst) {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      var params = {
        taiDonVi: userInfo.donViChaId ? true : false,
        page: this.state.pageData.number,
        size: this.state.pageData.size
      };
      if (this.state.maDon) {
        params.maDon = this.state.maDon.trim();
      }
      if (this.state.hoTen) {
        params.hoTen = this.state.hoTen.trim();
      }
      if (this.state.diaChi) {
        params.diaChi = this.state.diaChi.trim();
      }
      if (this.state.listDonViTiepNhan && this.state.listDonViTiepNhan.length) {
        var strId = this.state.listDonViTiepNhan.map(function (item) {
          return item.value;
        });
        params.listDonViTiepNhan = strId.join();
        // params.listDVTN = this.state.listDonViTiepNhan;
      }
      if (this.state.phanLoaiDon) {
        params.phanLoaiDon = this.state.phanLoaiDon;
      }
      if (this.state.linhVucId) {
        params.linhVucId = this.state.linhVucId;
      }
      if (this.state.linhVucChiTietId) {
        params.linhVucChiTietId = this.state.linhVucChiTietId;
      }
      if (this.state.nguonDon) {
        params.nguonDon = this.state.nguonDon;
      }
      this.setState({ loading: true });
      localStorage.setItem('tcData', JSON.stringify(params));
      _api.TrangChu.actions.getTraCuuDonCanBo.request(null, params).then(function (res) {
        if (res.data && res.data._embedded) {
          _this3.setState({ data: res.data._embedded.medial_DonTraCuus });
        } else {
          _this3.setState({ data: [] });
        }
        _this3.setState({
          loading: false,
          pageData: res.data.page,
          firstLoad: true
        });
      }).catch(function (error) {
        _this3.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          firstLoad: true,
          loading: false
        });
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      if (name == 'listDonViTiepNhan') {
        this.setState({ listDonViTiepNhan: e });
      } else {
        if (name == 'phanLoaiDon') {
          this.setState({ linhVucId: '', linhVucChiTietId: '' });
        }
        if (name == 'maTinh' || name == 'maHuyen') {
          this.setState({ maXa: '' });
          if (name == 'maTinh') {
            this.setState({ maHuyen: '' });
          }
        }
        this.setState(_defineProperty({}, name, e.target.value));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dvTiepNhanList !== this.props.dvTiepNhanList) {
        var arrData = [];
        nextProps.dvTiepNhanList.forEach(function (item) {
          arrData.push(item);
        });
        this.setState({ donViTiepNhanData: arrData });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name, type: this.props.route.type },
        _react2.default.createElement(
          'div',
          { className: 'center reception-container' },
          _react2.default.createElement(
            'div',
            { className: 'top-content' },
            _react2.default.createElement(
              'div',
              { className: 'heading', style: { marginBottom: '0px' } },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-search', style: { display: 'inline-block', marginRight: '40px' } },
                'Gi\xE1m s\xE1t tra c\u1EE9u'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-content' },
            _react2.default.createElement(
              'form',
              { onSubmit: this.handleSearch.bind(this, true), action: 'javascript:void(0)', noValidate: true },
              _react2.default.createElement(
                'div',
                { className: 'search-container super-search' },
                _react2.default.createElement(_common.Input, { label: 'M\xE3 \u0111\u01A1n', name: 'maDon', placeholder: 'Nh\u1EADp...', value: this.state.maDon, onChange: this.onChange.bind(this, 'maDon'), className: 'input-group' }),
                _react2.default.createElement(_common.Input, { label: 'T\xEAn ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n', name: 'hoTen', placeholder: 'Nh\u1EADp...', value: this.state.hoTen, onChange: this.onChange.bind(this, 'hoTen'), className: 'input-group', maxLength: 255 }),
                _react2.default.createElement(_common.Input, { label: '\u0110\u1ECBa ch\u1EC9', placeholder: 'Nh\u1EADp...', name: 'diaChi', value: this.state.diaChi, onChange: this.onChange.bind(this, 'diaChi'), className: 'input-group' }),
                _react2.default.createElement(_common.DropDownTreeMultipleSelect, { className: 'input-group tree-selected', label: '\u0110\u1ECBa b\xE0n (\u0110\u01A1n v\u1ECB) ti\u1EBFp nh\u1EADn', dataOptions: this.state.donViTiepNhanData, dataSelected: this.state.listDonViTiepNhan, onChange: this.onChange.bind(this, 'listDonViTiepNhan'), selectAllChildren: false, propertyChildren: 'coQuanQuanLyCha', propertyParent: 'coQuanQuanLyId' }),
                _react2.default.createElement(_ttForms.DropDownChonLoaiDonThu, { selectedValue: this.state.phanLoaiDon, className: 'input-group', label: 'Lo\u1EA1i \u0111\u01A1n', onChange: this.onChange.bind(this, 'phanLoaiDon'), name: 'dropdownChonLoaiDonThu', isTraCuu: true }),
                _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThu, { selectedValue: this.state.linhVucId, allowHidden: false, className: 'input-group', label: 'L\u0129nh v\u1EF1c', loaiDonThuID: this.state.phanLoaiDon, onChange: this.onChange.bind(this, 'linhVucId'), name: 'dropdownChonLinhVucDonThu' }),
                _react2.default.createElement(_ttForms.DropDownChonLinhVucDonThuChiTiet, { label: 'L\u0129nh v\u1EF1c chi ti\u1EBFt (n\u1EBFu c\xF3)', allowHidden: false, className: 'input-group', loaiDonThuID: this.state.phanLoaiDon, selectedValue: this.state.linhVucChiTietId, linhVucDonThuID: this.state.linhVucId, onChange: this.onChange.bind(this, 'linhVucChiTietId'), name: 'dropdownChonLinhVucCap2Id' }),
                _react2.default.createElement(_ttForms.DropDownChonNguonDon, {
                  selectedValue: this.state.nguonDon,
                  onChange: this.onChange.bind(this, 'nguonDon'),
                  className: 'input-group' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'search-container super-search', style: { paddingBottom: '18px', paddingLeft: '20px', paddingRight: '20px' } },
                _react2.default.createElement(
                  'button',
                  { type: 'submit', className: (0, _bind2.default)('pt-button btn-green tt-search', { 'btn-loading-inline': this.state.loading }) },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Xem k\u1EBFt qu\u1EA3'
                  )
                )
              )
            ),
            (this.state.data && this.state.data.length || this.state.firstLoad) && _react2.default.createElement(
              _dataTable2.default,
              { header: _table.header.listTraCuuDon,
                dataList: this.state.data,
                hideButtonExport: true,
                pageData: this.state.pageData,
                parent: this,
                displayCount: true,
                tableLoading: this.state.loading },
              _react2.default.createElement(_RowItemKetQuaTraCuu2.default, { phamVi: this.state.phamVi })
            )
          )
        )
      );
    }
  }]);

  return GiamSatTraCuu;
}(_react2.default.Component);

GiamSatTraCuu.defaultProps = {
  dvTiepNhanList: []
};

function bindStateToProps(state) {
  return {
    dvTiepNhanList: state.duLieuHeThong.diaBanTiepNhan
  };
}
exports.default = (0, _reactRedux.connect)(bindStateToProps)(GiamSatTraCuu);

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _layout = __webpack_require__(9);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _core = __webpack_require__(7);

var _api = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _reactRouter = __webpack_require__(2);

var _common = __webpack_require__(3);

var _RowItemDocumentDetail = __webpack_require__(499);

var _RowItemDocumentDetail2 = _interopRequireDefault(_RowItemDocumentDetail);

var _dataTable = __webpack_require__(15);

var _dataTable2 = _interopRequireDefault(_dataTable);

var _utils = __webpack_require__(4);

var _letterDetail = __webpack_require__(168);

var _reactRecaptchaGoogle = __webpack_require__(821);

var _config = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nfIcon = __webpack_require__(624);

var KetQuaCongDanTraCuu = function (_React$Component) {
  _inherits(KetQuaCongDanTraCuu, _React$Component);

  function KetQuaCongDanTraCuu(props, context) {
    _classCallCheck(this, KetQuaCongDanTraCuu);

    var _this = _possibleConstructorReturn(this, (KetQuaCongDanTraCuu.__proto__ || Object.getPrototypeOf(KetQuaCongDanTraCuu)).call(this, props, context));

    _this.state = {
      searchKey: _this.props.params.keySearch,
      data: {},
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],
      loaiDonGiaTri: '',
      loaiDon: '',
      loaiDoiTuong: {},
      listTaiLieuBangChung: [],
      listTepChungChiHanhNghe: [],
      lichSuTrangThaiXLGQDons: '',
      listTepUyQuyen: [],
      loading: false,
      ready: false,
      onOffForm: false,
      isOpen: false
    };
    _this.onLoadRecaptcha = _this.onLoadRecaptcha.bind(_this);
    _this.verifyCallback = _this.verifyCallback.bind(_this);
    return _this;
  }

  _createClass(KetQuaCongDanTraCuu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.searchData(this.props.params.keySearch);
      (0, _reactRecaptchaGoogle.loadReCaptcha)();
    }
  }, {
    key: 'onLoadRecaptcha',
    value: function onLoadRecaptcha() {}
  }, {
    key: 'verifyCallback',
    value: function verifyCallback(response) {
      if (response) {
        this.setState({
          ready: true,
          onOffForm: true
        });
      }
      this.searchData(this.state.searchKey);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      e.preventDefault();
      if (this.state.ready && this.state.searchKey) {
        this.searchData(this.state.searchKey);
      }
    }
  }, {
    key: 'searchData',
    value: function searchData(key) {
      var _this2 = this;

      if (typeof key !== 'string') return;
      var searchKey = key.trim();
      _reactRouter.browserHistory.push({
        pathname: '/ket-qua-cong-dan-tra-cuu/' + searchKey
      });
      this.setState({
        loading: true
      });
      _api.TrangChu.actions.getTraCuuDonCongDan.request(null, { maDon: searchKey }).then(function (res) {
        if (res.data) {
          _this2.setState({
            data: _extends({}, res.data, {
              loaiNguoiDungDon: res.data.loaiNguoiDungDonInfo.giaTri,
              loaiVuViecInfo: { ten: res.data.loaiVuViec }
            }),
            loaiNguoiDungDon: res.data.loaiNguoiDungDonInfo.giaTri,
            dataNguoiDungDon: res.data.listNguoiDungDon,
            dataDoanDiCung: res.data.listDoanDiCung,
            loaiDon: res.data.loaiDonThuInfo.ten,
            loaiDonGiaTri: res.data.loaiDonThuInfo.giaTri,
            loaiDoiTuong: { ten: res.data.loaiDoiTuong },
            linhVuc: res.data.linhVucDonThu,
            linhVucChiTiet: res.data.linhVucDonThuChiTiet,
            linhVucChiTietSub: res.data.linhVucChiTietKhac,
            noiDung: res.data.noiDung,
            dataNguoiDuocUyQuyen: res.data.nguoiDuocUyQuyen,
            loading: false
          });
          if (res.data.trangThaiDonType === 'DA_XU_LY' || res.data.trangThaiDonType === 'DA_GIAI_QUYET') {
            _api.TrangChu.actions.getLichSuTrangThaiXLGQDons.request(null, { maDon: searchKey }).then(function (res) {
              if (res.data && res.data._embedded) {
                _this2.setState({
                  lichSuTrangThaiXLGQDons: res.data._embedded.lichSuTrangThaiXLGQDons
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this2.setState({
          loading: false,
          loaiDon: ''
        });
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name, type: this.props.route.type },
        _react2.default.createElement(
          'div',
          { className: 'panel-page' },
          _react2.default.createElement(
            'div',
            { className: 'center' },
            _react2.default.createElement(
              'div',
              { className: 'main_page' },
              _react2.default.createElement(
                'div',
                { className: 'wrapper_box tc-box tc-style-search' },
                _react2.default.createElement(
                  'form',
                  { onSubmit: this.handleSearch.bind(this) },
                  _react2.default.createElement(
                    'div',
                    { className: 'search-group' },
                    _react2.default.createElement('input', { type: 'text', name: 'searchKey', placeholder: 'Nh\u1EADp m\xE3 \u0111\u01A1n...', className: 'tc-input full no-shadow', onChange: this.onChange.bind(this, 'searchKey'),
                      value: this.state.searchKey, disabled: this.state.onOffForm === false ? 'disabled' : '' }),
                    _react2.default.createElement(_reactRecaptchaGoogle.ReCaptcha, {
                      render: 'explicit',
                      sitekey: _config.siteKey,
                      verifyCallback: this.verifyCallback,
                      onloadCallback: this.onLoadRecaptcha,
                      onSuccess: function onSuccess(token) {
                        return console.log(token);
                      },
                      onError: console.error.bind(console),
                      hl: 'vi'
                    }),
                    _react2.default.createElement(
                      'button',
                      { type: 'submit', className: (0, _classnames2.default)('tc-bt margin-bt-kqtr no-shadow', {
                          'btn-loading-inline': this.state.loading,
                          'no-drop': !this.state.onOffForm
                        }) },
                      _react2.default.createElement(
                        'span',
                        null,
                        'Tra c\u1EE9u'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'heading' },
              _react2.default.createElement(
                'h2',
                { className: 'heading-title icon-search' },
                'K\u1EBFt qu\u1EA3 t\xECm ki\u1EBFm'
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.state.loading },
              _react2.default.createElement(
                'div',
                { className: 'main_page' },
                this.state.loaiDon ? _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box mb30' },
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper mt0' },
                    _react2.default.createElement(
                      'div',
                      { className: 'content-wrap content-gqd background-detail panel-page' },
                      _react2.default.createElement(
                        'div',
                        { className: 'header-redirect background-detail' },
                        _react2.default.createElement(
                          'div',
                          { className: 'box-items no-border' },
                          _react2.default.createElement(
                            'div',
                            { className: 'row-col' },
                            _react2.default.createElement(_common.TextMessage, { className: 'header-col pl15', label: 'M\xE3 \u0111\u01A1n:', value: this.state.data.maHoSo || '' }),
                            _react2.default.createElement(_common.TextMessage, { className: 'header-col', label: 'Ng\xE0y ti\u1EBFp nh\u1EADn:', value: this.state.data.ngayTao ? (0, _moment2.default)(this.state.data.ngayTao).format('DD/MM/YYYY') : '' }),
                            _react2.default.createElement(_common.TextMessage, { className: 'header-col', label: 'Ngu\u1ED3n \u0111\u01A1n:', value: this.state.data.nguonDon }),
                            _react2.default.createElement('div', { className: 'header-col' }),
                            _react2.default.createElement(
                              'div',
                              { className: 'pull-right pr15' },
                              _react2.default.createElement(_core.Button, { onClick: this.handleClick.bind(this), className: (0, _classnames2.default)('btn-collap', { 'active': this.state.isOpen }) })
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'wrap-block pl10 pr10 pt10' },
                        _react2.default.createElement(
                          'div',
                          { className: 'wrap-blocks' },
                          _react2.default.createElement(
                            _core.Collapse,
                            { isOpen: this.state.isOpen },
                            _react2.default.createElement(_letterDetail.ThongTinNguoiDungDon, {
                              title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u1EE9ng \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                              parent: this.state
                            })
                          ),
                          _react2.default.createElement(
                            _utils.ShowIf,
                            { condition: this.state.data.coUyQuyen },
                            _react2.default.createElement(
                              _core.Collapse,
                              { isOpen: this.state.isOpen },
                              _react2.default.createElement(_letterDetail.ThongTinNguoiUyQuyen, {
                                title: 'Th\xF4ng tin ng\u01B0\u1EDDi \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n',
                                parent: this.state
                              })
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)('box-items', { 'no-margin': !this.state.isOpen }) },
                            _react2.default.createElement(_letterDetail.ThongTinDonVuViec, {
                              title: 'Th\xF4ng tin \u0111\u01A1n/V\u1EE5 vi\u1EC7c',
                              isOpen: this.state.isOpen,
                              parent: this.state
                            })
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'box-items no-border' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                              'h3',
                              null,
                              'T\xECnh tr\u1EA1ng'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'items-form' },
                        _react2.default.createElement(
                          'div',
                          { className: 'rows' },
                          _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'Tr\u1EA1ng th\xE1i \u0111\u01A1n:', value: this.state.data.trangThaiDon || '' }),
                          _react2.default.createElement(_common.TextMessage, { className: 'col-input', label: 'C\u01A1 quan x\u1EED l\xFD:', value: this.state.data.tenDonViGiuDenHienTai || '' })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.lichSuTrangThaiXLGQDons && this.state.lichSuTrangThaiXLGQDons.length },
                    _react2.default.createElement(
                      'div',
                      { className: 'page-wrapper' },
                      _react2.default.createElement(
                        'div',
                        { className: 'box-items no-border' },
                        _react2.default.createElement(
                          'div',
                          { className: 'box-forward' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  'h3',
                                  null,
                                  'Qu\xE1 tr\xECnh x\u1EED l\xFD'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'items-form' },
                            _react2.default.createElement(
                              'div',
                              { className: 'rows' },
                              _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                  _dataTable2.default,
                                  {
                                    header: _table.header.listTTXLGQD,
                                    dataList: this.state.lichSuTrangThaiXLGQDons,
                                    hidePagination: true },
                                  _react2.default.createElement(_RowItemDocumentDetail2.default, null)
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                ) : _react2.default.createElement(
                  'div',
                  { className: 'wrapper_box tc-box not-found' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    _react2.default.createElement('img', { src: nfIcon, alt: 'not-found' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'content' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'Kh\xF4ng t\xECm th\u1EA5y k\u1EBFt qu\u1EA3 n\xE0o ph\xF9 h\u1EE3p v\u1EDBi m\xE3 \u0111\u01A1n tra c\u1EE9u ',
                        _react2.default.createElement(
                          'span',
                          null,
                          '"',
                          this.state.searchKey,
                          '"'
                        )
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'Vui l\xF2ng tra c\u1EE9u l\u1EA1i.'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KetQuaCongDanTraCuu;
}(_react2.default.Component);

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(KetQuaCongDanTraCuu);

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemKetQuaTTCP = function (_React$Component) {
  _inherits(RowItemKetQuaTTCP, _React$Component);

  function RowItemKetQuaTTCP() {
    _classCallCheck(this, RowItemKetQuaTTCP);

    return _possibleConstructorReturn(this, (RowItemKetQuaTTCP.__proto__ || Object.getPrototypeOf(RowItemKetQuaTTCP)).apply(this, arguments));
  }

  _createClass(RowItemKetQuaTTCP, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.props.count
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.ChuDon
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.CMTND
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.DiaChi
        ),
        _react2.default.createElement(
          'td',
          null,
          this.props.item.NoiDung
        )
      );
    }
  }]);

  return RowItemKetQuaTTCP;
}(_react2.default.Component);

exports.default = RowItemKetQuaTTCP;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _boSungThongTin = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoSungChuyenDonPage = function (_React$Component) {
  _inherits(BoSungChuyenDonPage, _React$Component);

  function BoSungChuyenDonPage() {
    _classCallCheck(this, BoSungChuyenDonPage);

    return _possibleConstructorReturn(this, (BoSungChuyenDonPage.__proto__ || Object.getPrototypeOf(BoSungChuyenDonPage)).apply(this, arguments));
  }

  _createClass(BoSungChuyenDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_boSungThongTin.BoSungThongTinChuyenDon, { params: this.props.params, lanhDao: true })
      );
    }
  }]);

  return BoSungChuyenDonPage;
}(_react2.default.Component);

exports.default = BoSungChuyenDonPage;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _boSungThongTin = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoSungThongTinLanhDaoPage = function (_React$Component) {
  _inherits(BoSungThongTinLanhDaoPage, _React$Component);

  function BoSungThongTinLanhDaoPage() {
    _classCallCheck(this, BoSungThongTinLanhDaoPage);

    return _possibleConstructorReturn(this, (BoSungThongTinLanhDaoPage.__proto__ || Object.getPrototypeOf(BoSungThongTinLanhDaoPage)).apply(this, arguments));
  }

  _createClass(BoSungThongTinLanhDaoPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_boSungThongTin.BoSungThongTin, { params: this.props.params, lanhDao: true })
      );
    }
  }]);

  return BoSungThongTinLanhDaoPage;
}(_react2.default.Component);

exports.default = BoSungThongTinLanhDaoPage;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _boSungThongTin = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoSungThongTinPage = function (_React$Component) {
  _inherits(BoSungThongTinPage, _React$Component);

  function BoSungThongTinPage() {
    _classCallCheck(this, BoSungThongTinPage);

    return _possibleConstructorReturn(this, (BoSungThongTinPage.__proto__ || Object.getPrototypeOf(BoSungThongTinPage)).apply(this, arguments));
  }

  _createClass(BoSungThongTinPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_boSungThongTin.BoSungThongTin, { params: this.props.params })
      );
    }
  }]);

  return BoSungThongTinPage;
}(_react2.default.Component);

exports.default = BoSungThongTinPage;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoSungChuyenDonPage = exports.BoSungThongTinLanhDaoPage = exports.BoSungThongTinPage = undefined;

var _BoSungThongTinPage = __webpack_require__(1435);

var _BoSungThongTinPage2 = _interopRequireDefault(_BoSungThongTinPage);

var _BoSungThongTinLanhDaoPage = __webpack_require__(1434);

var _BoSungThongTinLanhDaoPage2 = _interopRequireDefault(_BoSungThongTinLanhDaoPage);

var _BoSungChuyenDonPage = __webpack_require__(1433);

var _BoSungChuyenDonPage2 = _interopRequireDefault(_BoSungChuyenDonPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BoSungThongTinPage = _BoSungThongTinPage2.default;
exports.BoSungThongTinLanhDaoPage = _BoSungThongTinLanhDaoPage2.default;
exports.BoSungChuyenDonPage = _BoSungChuyenDonPage2.default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _giaiQuyetDon = __webpack_require__(142);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _config = __webpack_require__(16);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiaiQuyetDonPage = function (_React$Component) {
  _inherits(GiaiQuyetDonPage, _React$Component);

  function GiaiQuyetDonPage(props, context) {
    _classCallCheck(this, GiaiQuyetDonPage);

    var _this = _possibleConstructorReturn(this, (GiaiQuyetDonPage.__proto__ || Object.getPrototypeOf(GiaiQuyetDonPage)).call(this, props, context));

    _this.state = {
      dataThamSo: []
    };
    return _this;
  }

  _createClass(GiaiQuyetDonPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof _reactCookie2.default.load('accessToken') === 'undefined') {
        _reactRouter.browserHistory.push('/dang-nhap');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_giaiQuyetDon.ListGiaiQuyetDon, null)
      );
    }
  }]);

  return GiaiQuyetDonPage;
}(_react2.default.Component);

exports.default = GiaiQuyetDonPage;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _giaiQuyetDon = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import {MasterLayout} from 'layout';


var TruongPhongThuHoiPage = function (_React$Component) {
  _inherits(TruongPhongThuHoiPage, _React$Component);

  function TruongPhongThuHoiPage() {
    _classCallCheck(this, TruongPhongThuHoiPage);

    return _possibleConstructorReturn(this, (TruongPhongThuHoiPage.__proto__ || Object.getPrototypeOf(TruongPhongThuHoiPage)).apply(this, arguments));
  }

  _createClass(TruongPhongThuHoiPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_giaiQuyetDon.XuLyGiaiQuyetDon, { status: 'DANG_GIAI_QUYET', truongPhongThuHoi: true, params: this.props.params, route: this.props.route });
    }
  }]);

  return TruongPhongThuHoiPage;
}(_react2.default.Component);

exports.default = TruongPhongThuHoiPage;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _giaiQuyetDon = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TuGiaiQuyetDonPage = function (_React$Component) {
  _inherits(TuGiaiQuyetDonPage, _React$Component);

  function TuGiaiQuyetDonPage() {
    _classCallCheck(this, TuGiaiQuyetDonPage);

    return _possibleConstructorReturn(this, (TuGiaiQuyetDonPage.__proto__ || Object.getPrototypeOf(TuGiaiQuyetDonPage)).apply(this, arguments));
  }

  _createClass(TuGiaiQuyetDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_giaiQuyetDon.TuGiaiQuyetDon, { params: this.props.params, fromTDTHGQD: this.props.route.name == 'theodoi' })
      );
    }
  }]);

  return TuGiaiQuyetDonPage;
}(_react2.default.Component);

exports.default = TuGiaiQuyetDonPage;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _giaiQuyetDon = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XuLyGiaiQuyetDonPage = function (_React$Component) {
  _inherits(XuLyGiaiQuyetDonPage, _React$Component);

  function XuLyGiaiQuyetDonPage() {
    _classCallCheck(this, XuLyGiaiQuyetDonPage);

    return _possibleConstructorReturn(this, (XuLyGiaiQuyetDonPage.__proto__ || Object.getPrototypeOf(XuLyGiaiQuyetDonPage)).apply(this, arguments));
  }

  _createClass(XuLyGiaiQuyetDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_giaiQuyetDon.XuLyGiaiQuyetDon, { status: 'DANG_GIAI_QUYET', params: this.props.params })
      );
    }
  }]);

  return XuLyGiaiQuyetDonPage;
}(_react2.default.Component);

exports.default = XuLyGiaiQuyetDonPage;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruongPhongThuHoiPage = exports.TuGiaiQuyetDonPage = exports.XuLyGiaiQuyetDonPage = exports.GiaiQuyetDonPage = undefined;

var _GiaiQuyetDonPage = __webpack_require__(1437);

var _GiaiQuyetDonPage2 = _interopRequireDefault(_GiaiQuyetDonPage);

var _XuLyGiaiQuyetDonPage = __webpack_require__(1440);

var _XuLyGiaiQuyetDonPage2 = _interopRequireDefault(_XuLyGiaiQuyetDonPage);

var _TuGiaiQuyetDonPage = __webpack_require__(1439);

var _TuGiaiQuyetDonPage2 = _interopRequireDefault(_TuGiaiQuyetDonPage);

var _TruongPhongThuHoiPage = __webpack_require__(1438);

var _TruongPhongThuHoiPage2 = _interopRequireDefault(_TruongPhongThuHoiPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GiaiQuyetDonPage = _GiaiQuyetDonPage2.default;
exports.XuLyGiaiQuyetDonPage = _XuLyGiaiQuyetDonPage2.default;
exports.TuGiaiQuyetDonPage = _TuGiaiQuyetDonPage2.default;
exports.TruongPhongThuHoiPage = _TruongPhongThuHoiPage2.default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _handleLettersOld = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddHandleLettersOldPage = function (_React$Component) {
  _inherits(AddHandleLettersOldPage, _React$Component);

  function AddHandleLettersOldPage() {
    _classCallCheck(this, AddHandleLettersOldPage);

    return _possibleConstructorReturn(this, (AddHandleLettersOldPage.__proto__ || Object.getPrototypeOf(AddHandleLettersOldPage)).apply(this, arguments));
  }

  _createClass(AddHandleLettersOldPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLettersOld.AddHandleLetterOld, { params: this.props.params })
      );
    }
  }]);

  return AddHandleLettersOldPage;
}(_react2.default.Component);

exports.default = AddHandleLettersOldPage;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _handleLettersOld = __webpack_require__(309);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLettersOldPage = function (_React$Component) {
  _inherits(HandleLettersOldPage, _React$Component);

  function HandleLettersOldPage(props, context) {
    _classCallCheck(this, HandleLettersOldPage);

    var _this = _possibleConstructorReturn(this, (HandleLettersOldPage.__proto__ || Object.getPrototypeOf(HandleLettersOldPage)).call(this, props, context));

    _this.state = {
      dataThamSo: []
    };
    return _this;
  }

  _createClass(HandleLettersOldPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof _reactCookie2.default.load('accessToken') === 'undefined') {
        _reactRouter.browserHistory.push('/dang-nhap');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLettersOld.HandleLettersOld, { param: this.props.params })
      );
    }
  }]);

  return HandleLettersOldPage;
}(_react2.default.Component);

exports.default = HandleLettersOldPage;
;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _handleLetters = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThuHoiXuLyDonPage = function (_React$Component) {
  _inherits(ThuHoiXuLyDonPage, _React$Component);

  function ThuHoiXuLyDonPage() {
    _classCallCheck(this, ThuHoiXuLyDonPage);

    return _possibleConstructorReturn(this, (ThuHoiXuLyDonPage.__proto__ || Object.getPrototypeOf(ThuHoiXuLyDonPage)).apply(this, arguments));
  }

  _createClass(ThuHoiXuLyDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_handleLetters.HandleLettersDetails, { params: this.props.params, thuHoi: true, route: this.props.route });
    }
  }]);

  return ThuHoiXuLyDonPage;
}(_react2.default.Component);

exports.default = ThuHoiXuLyDonPage;
;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThuHoiXuLyDonOldPage = exports.HandleLettersOldPage = exports.AddHandleLettersOldPage = undefined;

var _AddHandleLettersOldPage = __webpack_require__(1442);

var _AddHandleLettersOldPage2 = _interopRequireDefault(_AddHandleLettersOldPage);

var _HandleLettersOldPage = __webpack_require__(1443);

var _HandleLettersOldPage2 = _interopRequireDefault(_HandleLettersOldPage);

var _ThuHoiXuLyDonOldPage = __webpack_require__(1444);

var _ThuHoiXuLyDonOldPage2 = _interopRequireDefault(_ThuHoiXuLyDonOldPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddHandleLettersOldPage = _AddHandleLettersOldPage2.default;
exports.HandleLettersOldPage = _HandleLettersOldPage2.default;
exports.ThuHoiXuLyDonOldPage = _ThuHoiXuLyDonOldPage2.default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _handleLetters = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddHandleLettersPage = function (_React$Component) {
  _inherits(AddHandleLettersPage, _React$Component);

  function AddHandleLettersPage() {
    _classCallCheck(this, AddHandleLettersPage);

    return _possibleConstructorReturn(this, (AddHandleLettersPage.__proto__ || Object.getPrototypeOf(AddHandleLettersPage)).apply(this, arguments));
  }

  _createClass(AddHandleLettersPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLetters.AddHandleLetter, { params: this.props.params })
      );
    }
  }]);

  return AddHandleLettersPage;
}(_react2.default.Component);

exports.default = AddHandleLettersPage;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reactRouter = __webpack_require__(2);

var _handleLetters = __webpack_require__(143);

var _reactCookie = __webpack_require__(60);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _config = __webpack_require__(16);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleLettersPage = function (_React$Component) {
  _inherits(HandleLettersPage, _React$Component);

  function HandleLettersPage(props, context) {
    _classCallCheck(this, HandleLettersPage);

    var _this = _possibleConstructorReturn(this, (HandleLettersPage.__proto__ || Object.getPrototypeOf(HandleLettersPage)).call(this, props, context));

    _this.state = {
      dataThamSo: []
    };
    return _this;
  }

  _createClass(HandleLettersPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof _reactCookie2.default.load('accessToken') === 'undefined') {
        _reactRouter.browserHistory.push('/dang-nhap');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLetters.HandleLetters, { param: this.props.params })
      );
    }
  }]);

  return HandleLettersPage;
}(_react2.default.Component);

exports.default = HandleLettersPage;
;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _handleLetters = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThuHoiXuLyDonPage = function (_React$Component) {
  _inherits(ThuHoiXuLyDonPage, _React$Component);

  function ThuHoiXuLyDonPage() {
    _classCallCheck(this, ThuHoiXuLyDonPage);

    return _possibleConstructorReturn(this, (ThuHoiXuLyDonPage.__proto__ || Object.getPrototypeOf(ThuHoiXuLyDonPage)).apply(this, arguments));
  }

  _createClass(ThuHoiXuLyDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_handleLetters.HandleLettersDetails, { params: this.props.params, thuHoi: true, route: this.props.route });
    }
  }]);

  return ThuHoiXuLyDonPage;
}(_react2.default.Component);

exports.default = ThuHoiXuLyDonPage;
;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThuHoiXuLyDonPage = exports.HandleLettersPage = exports.AddHandleLettersPage = undefined;

var _AddHandleLettersPage = __webpack_require__(1446);

var _AddHandleLettersPage2 = _interopRequireDefault(_AddHandleLettersPage);

var _HandleLettersPage = __webpack_require__(1447);

var _HandleLettersPage2 = _interopRequireDefault(_HandleLettersPage);

var _ThuHoiXuLyDonPage = __webpack_require__(1448);

var _ThuHoiXuLyDonPage2 = _interopRequireDefault(_ThuHoiXuLyDonPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AddHandleLettersPage = _AddHandleLettersPage2.default;
exports.HandleLettersPage = _HandleLettersPage2.default;
exports.ThuHoiXuLyDonPage = _ThuHoiXuLyDonPage2.default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TongHopKetQuaThanhTraThamNhungPage = exports.DanhMucTongHopThanhTraPage = exports.DanhMucCuocThanhTraTrungPage = exports.KetQuaXuLyTheoDoiThucHienPage = exports.XuLyTheoDoiThucHienPage = exports.DanhSachTheoDoiThucHienPage = exports.BoSungChuyenDonPage = exports.BoSungThongTinLanhDaoPage = exports.BoSungThongTinPage = exports.DanhSachThongKeGiamSatDonCuPage = exports.ThongKeGiamSatNhapDonCuPage = exports.DanhSachDonTheoKyPage = exports.DanhSachDonPage = exports.TinhHinhXuLyDonTaiDonViConPage = exports.TinhHinhXuLyDonTaiDonViPage = exports.ChiTietCuocThanhTraKeHoachPage = exports.ChinhSuaCuocThanhTraDotXuatPage = exports.ThayTheCuocThanhTraPage = exports.ChinhSuaCuocThanhTraPage = exports.ChiTietCuocThanhTraPage = exports.ThemMoiCuocThanhTraPage = exports.DanhSachDoiTuongTrungPage = exports.DanhSachCuocThanhTraPage = exports.ThemMoiDanhSachThanhTraPage = exports.DanhSachThanhTraDaPheDuyetPage = exports.DanhSachThanhTraPage = exports.TongHopKetQuaThanhTraPage = exports.KetQuaKiemTraDotXuatDoanhNghiepPage = exports.KetQuaKiemTraTheoKeHoachDoanhNghiepPage = exports.KetQuaKiemTraChiTietDoanhNghiepPage = exports.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = exports.TongHopKetQuaThanhTraLaiPage = exports.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = exports.TongHopKetQuaThanhTraTaiChinhNganSachPage = exports.TongHopKetQuaThanhTraXayDungCoBanPage = exports.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = exports.TongHopKetQuaThanhTraChuyenNganhPage = exports.TongHopKetQuaThanhTraDatDaiPage = exports.TongHopKetQuaThanhTraHanhChinhPage = exports.TongHopKetQuaXuLyDonPage = exports.TongHopKetQuaGQDKNPage = exports.TongHopKetQuaTiepCongDanPage = exports.TongHopKetQuaGQDTCPage = exports.TongHopDonTreHanGiaiQuyet = exports.TongHopDonTreHanXuLy = exports.TruongPhongThuHoiPage = exports.TuGiaiQuyetDonPage = exports.XuLyGiaiQuyetDonPage = exports.GiaiQuyetDonPage = exports.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = exports.CanBoNhanKetQuaKiemTraDeXuatPage = exports.ThuHoiXuLyDonPage = exports.AddHandleLettersPage = exports.HandleLettersPage = exports.ThuHoiXuLyDonOldPage = exports.AddHandleLettersOldPage = exports.HandleLettersOldPage = undefined;

var _reception = __webpack_require__(1453);

var _handleLetters = __webpack_require__(1449);

var _handleLettersOld = __webpack_require__(1445);

var _giaiQuyetDon = __webpack_require__(1441);

var _thongKeBaoCao = __webpack_require__(1498);

var _thanhTra = __webpack_require__(1467);

var _theoDoiGiamSat = __webpack_require__(1473);

var _theoDoiThucHien = __webpack_require__(1477);

var _boSungThongTin = __webpack_require__(1436);

var _thanhTraTrung = __webpack_require__(1456);

/*------------End Import Bo Sung Thong Tin-----------------*/

/*------------End Import Theo dõi thực hiện-----------------*/

/*------------ Begin Bo Sung Thong Tin-----------------*/


/*------------End Import Thanh tra-----------------*/

/*------------ Begin Import Theo Gioi Giam Sat-----------------*/

/*------------End Import Giai Quyet Don-----------------*/

/*------------ Begin Import Thống kê báo cáo-----------------*/

/*------------ Begin Import handle-letters-old-----------------*/
/*------------ Begin Import Reception-----------------*/
exports.HandleLettersOldPage = _handleLettersOld.HandleLettersOldPage;
exports.AddHandleLettersOldPage = _handleLettersOld.AddHandleLettersOldPage;
exports.ThuHoiXuLyDonOldPage = _handleLettersOld.ThuHoiXuLyDonOldPage;
exports.HandleLettersPage = _handleLetters.HandleLettersPage;
exports.AddHandleLettersPage = _handleLetters.AddHandleLettersPage;
exports.ThuHoiXuLyDonPage = _handleLetters.ThuHoiXuLyDonPage;
exports.CanBoNhanKetQuaKiemTraDeXuatPage = _reception.CanBoNhanKetQuaKiemTraDeXuatPage;
exports.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = _reception.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage;
exports.GiaiQuyetDonPage = _giaiQuyetDon.GiaiQuyetDonPage;
exports.XuLyGiaiQuyetDonPage = _giaiQuyetDon.XuLyGiaiQuyetDonPage;
exports.TuGiaiQuyetDonPage = _giaiQuyetDon.TuGiaiQuyetDonPage;
exports.TruongPhongThuHoiPage = _giaiQuyetDon.TruongPhongThuHoiPage;
exports.TongHopDonTreHanXuLy = _thongKeBaoCao.TongHopDonTreHanXuLy;
exports.TongHopDonTreHanGiaiQuyet = _thongKeBaoCao.TongHopDonTreHanGiaiQuyet;
exports.TongHopKetQuaGQDTCPage = _thongKeBaoCao.TongHopKetQuaGQDTCPage;
exports.TongHopKetQuaTiepCongDanPage = _thongKeBaoCao.TongHopKetQuaTiepCongDanPage;
exports.TongHopKetQuaGQDKNPage = _thongKeBaoCao.TongHopKetQuaGQDKNPage;
exports.TongHopKetQuaXuLyDonPage = _thongKeBaoCao.TongHopKetQuaXuLyDonPage;
exports.TongHopKetQuaThanhTraHanhChinhPage = _thongKeBaoCao.TongHopKetQuaThanhTraHanhChinhPage;
exports.TongHopKetQuaThanhTraDatDaiPage = _thongKeBaoCao.TongHopKetQuaThanhTraDatDaiPage;
exports.TongHopKetQuaThanhTraChuyenNganhPage = _thongKeBaoCao.TongHopKetQuaThanhTraChuyenNganhPage;
exports.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = _thongKeBaoCao.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage;
exports.TongHopKetQuaThanhTraXayDungCoBanPage = _thongKeBaoCao.TongHopKetQuaThanhTraXayDungCoBanPage;
exports.TongHopKetQuaThanhTraTaiChinhNganSachPage = _thongKeBaoCao.TongHopKetQuaThanhTraTaiChinhNganSachPage;
exports.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = _thongKeBaoCao.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage;
exports.TongHopKetQuaThanhTraLaiPage = _thongKeBaoCao.TongHopKetQuaThanhTraLaiPage;
exports.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = _thongKeBaoCao.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage;
exports.KetQuaKiemTraChiTietDoanhNghiepPage = _thongKeBaoCao.KetQuaKiemTraChiTietDoanhNghiepPage;
exports.KetQuaKiemTraTheoKeHoachDoanhNghiepPage = _thongKeBaoCao.KetQuaKiemTraTheoKeHoachDoanhNghiepPage;
exports.KetQuaKiemTraDotXuatDoanhNghiepPage = _thongKeBaoCao.KetQuaKiemTraDotXuatDoanhNghiepPage;
exports.TongHopKetQuaThanhTraPage = _thongKeBaoCao.TongHopKetQuaThanhTraPage;
exports.DanhSachThanhTraPage = _thanhTra.DanhSachThanhTraPage;
exports.DanhSachThanhTraDaPheDuyetPage = _thanhTra.DanhSachThanhTraDaPheDuyetPage;
exports.ThemMoiDanhSachThanhTraPage = _thanhTra.ThemMoiDanhSachThanhTraPage;
exports.DanhSachCuocThanhTraPage = _thanhTra.DanhSachCuocThanhTraPage;
exports.DanhSachDoiTuongTrungPage = _thanhTra.DanhSachDoiTuongTrungPage;
exports.ThemMoiCuocThanhTraPage = _thanhTra.ThemMoiCuocThanhTraPage;
exports.ChiTietCuocThanhTraPage = _thanhTra.ChiTietCuocThanhTraPage;
exports.ChinhSuaCuocThanhTraPage = _thanhTra.ChinhSuaCuocThanhTraPage;
exports.ThayTheCuocThanhTraPage = _thanhTra.ThayTheCuocThanhTraPage;
exports.ChinhSuaCuocThanhTraDotXuatPage = _thanhTra.ChinhSuaCuocThanhTraDotXuatPage;
exports.ChiTietCuocThanhTraKeHoachPage = _thanhTra.ChiTietCuocThanhTraKeHoachPage;
exports.TinhHinhXuLyDonTaiDonViPage = _theoDoiGiamSat.TinhHinhXuLyDonTaiDonViPage;
exports.TinhHinhXuLyDonTaiDonViConPage = _theoDoiGiamSat.TinhHinhXuLyDonTaiDonViConPage;
exports.DanhSachDonPage = _theoDoiGiamSat.DanhSachDonPage;
exports.DanhSachDonTheoKyPage = _theoDoiGiamSat.DanhSachDonTheoKyPage;
exports.ThongKeGiamSatNhapDonCuPage = _theoDoiGiamSat.ThongKeGiamSatNhapDonCuPage;
exports.DanhSachThongKeGiamSatDonCuPage = _theoDoiGiamSat.DanhSachThongKeGiamSatDonCuPage;
exports.BoSungThongTinPage = _boSungThongTin.BoSungThongTinPage;
exports.BoSungThongTinLanhDaoPage = _boSungThongTin.BoSungThongTinLanhDaoPage;
exports.BoSungChuyenDonPage = _boSungThongTin.BoSungChuyenDonPage;
exports.DanhSachTheoDoiThucHienPage = _theoDoiThucHien.DanhSachTheoDoiThucHienPage;
exports.XuLyTheoDoiThucHienPage = _theoDoiThucHien.XuLyTheoDoiThucHienPage;
exports.KetQuaXuLyTheoDoiThucHienPage = _theoDoiThucHien.KetQuaXuLyTheoDoiThucHienPage;
exports.DanhMucCuocThanhTraTrungPage = _thanhTraTrung.DanhMucCuocThanhTraTrungPage;
exports.DanhMucTongHopThanhTraPage = _thanhTraTrung.DanhMucTongHopThanhTraPage;
exports.TongHopKetQuaThanhTraThamNhungPage = _thongKeBaoCao.TongHopKetQuaThanhTraThamNhungPage;

/*------------End Import Theo Gioi Giam Sat-----------------*/

/*------------ Begin Import Theo dõi thực hiện-----------------*/

/*------------End Import Thống kê báo cáo-----------------*/

/*------------ Begin Import Thanh tra-----------------*/

/*------------End Import handle-letters-----------------*/

/*------------ Begin Import Giai Quyet Don-----------------*/

/*------------ End Import Reception-----------------*/

/*------------ Begin Import handle-letters-----------------*/

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reception = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CanBoNhanKetQuaKiemTraDeXuatPage = function (_React$Component) {
  _inherits(CanBoNhanKetQuaKiemTraDeXuatPage, _React$Component);

  function CanBoNhanKetQuaKiemTraDeXuatPage() {
    _classCallCheck(this, CanBoNhanKetQuaKiemTraDeXuatPage);

    return _possibleConstructorReturn(this, (CanBoNhanKetQuaKiemTraDeXuatPage.__proto__ || Object.getPrototypeOf(CanBoNhanKetQuaKiemTraDeXuatPage)).apply(this, arguments));
  }

  _createClass(CanBoNhanKetQuaKiemTraDeXuatPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_reception.CanBoNhanKetQuaKiemTraDeXuat, { params: this.props.params, viewOnly: false })
      );
    }
  }]);

  return CanBoNhanKetQuaKiemTraDeXuatPage;
}(_react2.default.Component);

exports.default = CanBoNhanKetQuaKiemTraDeXuatPage;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _reception = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = function (_React$Component) {
  _inherits(KetQuaCanBoNhanKetQuaKiemTraDeXuatPage, _React$Component);

  function KetQuaCanBoNhanKetQuaKiemTraDeXuatPage() {
    _classCallCheck(this, KetQuaCanBoNhanKetQuaKiemTraDeXuatPage);

    return _possibleConstructorReturn(this, (KetQuaCanBoNhanKetQuaKiemTraDeXuatPage.__proto__ || Object.getPrototypeOf(KetQuaCanBoNhanKetQuaKiemTraDeXuatPage)).apply(this, arguments));
  }

  _createClass(KetQuaCanBoNhanKetQuaKiemTraDeXuatPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_reception.CanBoNhanKetQuaKiemTraDeXuat, { params: this.props.params, viewOnly: true })
      );
    }
  }]);

  return KetQuaCanBoNhanKetQuaKiemTraDeXuatPage;
}(_react2.default.Component);

exports.default = KetQuaCanBoNhanKetQuaKiemTraDeXuatPage;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = exports.CanBoNhanKetQuaKiemTraDeXuatPage = undefined;

var _CanBoNhanKetQuaKiemTraDeXuatPage = __webpack_require__(1451);

var _CanBoNhanKetQuaKiemTraDeXuatPage2 = _interopRequireDefault(_CanBoNhanKetQuaKiemTraDeXuatPage);

var _KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = __webpack_require__(1452);

var _KetQuaCanBoNhanKetQuaKiemTraDeXuatPage2 = _interopRequireDefault(_KetQuaCanBoNhanKetQuaKiemTraDeXuatPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CanBoNhanKetQuaKiemTraDeXuatPage = _CanBoNhanKetQuaKiemTraDeXuatPage2.default;
exports.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage = _KetQuaCanBoNhanKetQuaKiemTraDeXuatPage2.default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTraTrung = __webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucCuocThanhTraTrungPage = function (_Component) {
  _inherits(DanhMucCuocThanhTraTrungPage, _Component);

  function DanhMucCuocThanhTraTrungPage() {
    _classCallCheck(this, DanhMucCuocThanhTraTrungPage);

    return _possibleConstructorReturn(this, (DanhMucCuocThanhTraTrungPage.__proto__ || Object.getPrototypeOf(DanhMucCuocThanhTraTrungPage)).apply(this, arguments));
  }

  _createClass(DanhMucCuocThanhTraTrungPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTraTrung.DanhMucCuocThanhTraTrung, null)
      );
    }
  }]);

  return DanhMucCuocThanhTraTrungPage;
}(_react.Component);

exports.default = DanhMucCuocThanhTraTrungPage;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTraTrung = __webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhMucTongHopThanhTraPage = function (_Component) {
  _inherits(DanhMucTongHopThanhTraPage, _Component);

  function DanhMucTongHopThanhTraPage() {
    _classCallCheck(this, DanhMucTongHopThanhTraPage);

    return _possibleConstructorReturn(this, (DanhMucTongHopThanhTraPage.__proto__ || Object.getPrototypeOf(DanhMucTongHopThanhTraPage)).apply(this, arguments));
  }

  _createClass(DanhMucTongHopThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTraTrung.DanhMucTongHopThanhTra, { type: this.props.route.type })
      );
    }
  }]);

  return DanhMucTongHopThanhTraPage;
}(_react.Component);

exports.default = DanhMucTongHopThanhTraPage;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhMucTongHopThanhTraPage = exports.DanhMucCuocThanhTraTrungPage = undefined;

var _DanhMucCuocThanhTraTrungPage = __webpack_require__(1454);

var _DanhMucCuocThanhTraTrungPage2 = _interopRequireDefault(_DanhMucCuocThanhTraTrungPage);

var _DanhMucTongHopThanhTraPage = __webpack_require__(1455);

var _DanhMucTongHopThanhTraPage2 = _interopRequireDefault(_DanhMucTongHopThanhTraPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhMucCuocThanhTraTrungPage = _DanhMucCuocThanhTraTrungPage2.default;
exports.DanhMucTongHopThanhTraPage = _DanhMucTongHopThanhTraPage2.default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietCuocThanhTraKeHoachPage = function (_React$Component) {
  _inherits(ChiTietCuocThanhTraKeHoachPage, _React$Component);

  function ChiTietCuocThanhTraKeHoachPage() {
    _classCallCheck(this, ChiTietCuocThanhTraKeHoachPage);

    return _possibleConstructorReturn(this, (ChiTietCuocThanhTraKeHoachPage.__proto__ || Object.getPrototypeOf(ChiTietCuocThanhTraKeHoachPage)).apply(this, arguments));
  }

  _createClass(ChiTietCuocThanhTraKeHoachPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChiTietCuocThanhTra, { params: this.props.params, type: 'KE_HOACH' })
      );
    }
  }]);

  return ChiTietCuocThanhTraKeHoachPage;
}(_react2.default.Component);

exports.default = ChiTietCuocThanhTraKeHoachPage;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChiTietCuocThanhTraPage = function (_React$Component) {
  _inherits(ChiTietCuocThanhTraPage, _React$Component);

  function ChiTietCuocThanhTraPage() {
    _classCallCheck(this, ChiTietCuocThanhTraPage);

    return _possibleConstructorReturn(this, (ChiTietCuocThanhTraPage.__proto__ || Object.getPrototypeOf(ChiTietCuocThanhTraPage)).apply(this, arguments));
  }

  _createClass(ChiTietCuocThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChiTietCuocThanhTra, { params: this.props.params, type: 'DOT_XUAT' })
      );
    }
  }]);

  return ChiTietCuocThanhTraPage;
}(_react2.default.Component);

exports.default = ChiTietCuocThanhTraPage;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChinhSuaCuocThanhTraDotXuatPage = function (_React$Component) {
  _inherits(ChinhSuaCuocThanhTraDotXuatPage, _React$Component);

  function ChinhSuaCuocThanhTraDotXuatPage() {
    _classCallCheck(this, ChinhSuaCuocThanhTraDotXuatPage);

    return _possibleConstructorReturn(this, (ChinhSuaCuocThanhTraDotXuatPage.__proto__ || Object.getPrototypeOf(ChinhSuaCuocThanhTraDotXuatPage)).apply(this, arguments));
  }

  _createClass(ChinhSuaCuocThanhTraDotXuatPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChinhSuaCuocThanhTra, { check: this.props.location, params: this.props.params, type: 'DOT_XUAT' })
      );
    }
  }]);

  return ChinhSuaCuocThanhTraDotXuatPage;
}(_react2.default.Component);

exports.default = ChinhSuaCuocThanhTraDotXuatPage;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChinhSuaCuocThanhTraPage = function (_React$Component) {
  _inherits(ChinhSuaCuocThanhTraPage, _React$Component);

  function ChinhSuaCuocThanhTraPage() {
    _classCallCheck(this, ChinhSuaCuocThanhTraPage);

    return _possibleConstructorReturn(this, (ChinhSuaCuocThanhTraPage.__proto__ || Object.getPrototypeOf(ChinhSuaCuocThanhTraPage)).apply(this, arguments));
  }

  _createClass(ChinhSuaCuocThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChinhSuaCuocThanhTra, { check: this.props.location, params: this.props.params, type: 'KE_HOACH' })
      );
    }
  }]);

  return ChinhSuaCuocThanhTraPage;
}(_react2.default.Component);

exports.default = ChinhSuaCuocThanhTraPage;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachCuocThanhTraPage = function (_React$Component) {
  _inherits(DanhSachCuocThanhTraPage, _React$Component);

  function DanhSachCuocThanhTraPage() {
    _classCallCheck(this, DanhSachCuocThanhTraPage);

    return _possibleConstructorReturn(this, (DanhSachCuocThanhTraPage.__proto__ || Object.getPrototypeOf(DanhSachCuocThanhTraPage)).apply(this, arguments));
  }

  _createClass(DanhSachCuocThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.DanhSachCuocThanhTra, null)
      );
    }
  }]);

  return DanhSachCuocThanhTraPage;
}(_react2.default.Component);

exports.default = DanhSachCuocThanhTraPage;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDoiTuongTrungPage = function (_React$Component) {
  _inherits(DanhSachDoiTuongTrungPage, _React$Component);

  function DanhSachDoiTuongTrungPage() {
    _classCallCheck(this, DanhSachDoiTuongTrungPage);

    return _possibleConstructorReturn(this, (DanhSachDoiTuongTrungPage.__proto__ || Object.getPrototypeOf(DanhSachDoiTuongTrungPage)).apply(this, arguments));
  }

  _createClass(DanhSachDoiTuongTrungPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.DanhSachDoiTuongTrung, null)
      );
    }
  }]);

  return DanhSachDoiTuongTrungPage;
}(_react2.default.Component);

exports.default = DanhSachDoiTuongTrungPage;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachThanhTraDaPheDuyetPage = function (_React$Component) {
  _inherits(DanhSachThanhTraDaPheDuyetPage, _React$Component);

  function DanhSachThanhTraDaPheDuyetPage() {
    _classCallCheck(this, DanhSachThanhTraDaPheDuyetPage);

    return _possibleConstructorReturn(this, (DanhSachThanhTraDaPheDuyetPage.__proto__ || Object.getPrototypeOf(DanhSachThanhTraDaPheDuyetPage)).apply(this, arguments));
  }

  _createClass(DanhSachThanhTraDaPheDuyetPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.DanhSachKeHoachThanhTraDaPheDuyet, null)
      );
    }
  }]);

  return DanhSachThanhTraDaPheDuyetPage;
}(_react2.default.Component);

exports.default = DanhSachThanhTraDaPheDuyetPage;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachThanhTraPage = function (_React$Component) {
  _inherits(DanhSachThanhTraPage, _React$Component);

  function DanhSachThanhTraPage() {
    _classCallCheck(this, DanhSachThanhTraPage);

    return _possibleConstructorReturn(this, (DanhSachThanhTraPage.__proto__ || Object.getPrototypeOf(DanhSachThanhTraPage)).apply(this, arguments));
  }

  _createClass(DanhSachThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.DanhSachKeHoachThanhTra, null)
      );
    }
  }]);

  return DanhSachThanhTraPage;
}(_react2.default.Component);

exports.default = DanhSachThanhTraPage;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThayTheCuocThanhTraPage = function (_React$Component) {
  _inherits(ThayTheCuocThanhTraPage, _React$Component);

  function ThayTheCuocThanhTraPage() {
    _classCallCheck(this, ThayTheCuocThanhTraPage);

    return _possibleConstructorReturn(this, (ThayTheCuocThanhTraPage.__proto__ || Object.getPrototypeOf(ThayTheCuocThanhTraPage)).apply(this, arguments));
  }

  _createClass(ThayTheCuocThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChinhSuaCuocThanhTra, { check: this.props.location, params: this.props.params, type: 'KE_HOACH' })
      );
    }
  }]);

  return ThayTheCuocThanhTraPage;
}(_react2.default.Component);

exports.default = ThayTheCuocThanhTraPage;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thanhTra = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemMoiCuocThanhTraPage = function (_React$Component) {
  _inherits(ThemMoiCuocThanhTraPage, _React$Component);

  function ThemMoiCuocThanhTraPage() {
    _classCallCheck(this, ThemMoiCuocThanhTraPage);

    return _possibleConstructorReturn(this, (ThemMoiCuocThanhTraPage.__proto__ || Object.getPrototypeOf(ThemMoiCuocThanhTraPage)).apply(this, arguments));
  }

  _createClass(ThemMoiCuocThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thanhTra.ChinhSuaCuocThanhTra, { checkBS: this.props.location, type: 'DOT_XUAT' })
      );
    }
  }]);

  return ThemMoiCuocThanhTraPage;
}(_react2.default.Component);

exports.default = ThemMoiCuocThanhTraPage;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChiTietCuocThanhTraKeHoachPage = exports.ChinhSuaCuocThanhTraDotXuatPage = exports.ThayTheCuocThanhTraPage = exports.ChinhSuaCuocThanhTraPage = exports.ChiTietCuocThanhTraPage = exports.ThemMoiCuocThanhTraPage = exports.DanhSachDoiTuongTrungPage = exports.DanhSachCuocThanhTraPage = exports.DanhSachThanhTraDaPheDuyetPage = exports.DanhSachThanhTraPage = undefined;

var _DanhSachThanhTraPage = __webpack_require__(1464);

var _DanhSachThanhTraPage2 = _interopRequireDefault(_DanhSachThanhTraPage);

var _DanhSachThanhTraDaPheDuyetPage = __webpack_require__(1463);

var _DanhSachThanhTraDaPheDuyetPage2 = _interopRequireDefault(_DanhSachThanhTraDaPheDuyetPage);

var _DanhSachCuocThanhTraPage = __webpack_require__(1461);

var _DanhSachCuocThanhTraPage2 = _interopRequireDefault(_DanhSachCuocThanhTraPage);

var _DanhSachDoiTuongTrungPage = __webpack_require__(1462);

var _DanhSachDoiTuongTrungPage2 = _interopRequireDefault(_DanhSachDoiTuongTrungPage);

var _ThemMoiCuocThanhTraPage = __webpack_require__(1466);

var _ThemMoiCuocThanhTraPage2 = _interopRequireDefault(_ThemMoiCuocThanhTraPage);

var _ChiTietCuocThanhTraPage = __webpack_require__(1458);

var _ChiTietCuocThanhTraPage2 = _interopRequireDefault(_ChiTietCuocThanhTraPage);

var _ChinhSuaCuocThanhTraPage = __webpack_require__(1460);

var _ChinhSuaCuocThanhTraPage2 = _interopRequireDefault(_ChinhSuaCuocThanhTraPage);

var _ThayTheCuocThanhTraPage = __webpack_require__(1465);

var _ThayTheCuocThanhTraPage2 = _interopRequireDefault(_ThayTheCuocThanhTraPage);

var _ChinhSuaCuocThanhTraDotXuatPage = __webpack_require__(1459);

var _ChinhSuaCuocThanhTraDotXuatPage2 = _interopRequireDefault(_ChinhSuaCuocThanhTraDotXuatPage);

var _ChiTietCuocThanhTraKeHoachPage = __webpack_require__(1457);

var _ChiTietCuocThanhTraKeHoachPage2 = _interopRequireDefault(_ChiTietCuocThanhTraKeHoachPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhSachThanhTraPage = _DanhSachThanhTraPage2.default;
exports.DanhSachThanhTraDaPheDuyetPage = _DanhSachThanhTraDaPheDuyetPage2.default;
exports.DanhSachCuocThanhTraPage = _DanhSachCuocThanhTraPage2.default;
exports.DanhSachDoiTuongTrungPage = _DanhSachDoiTuongTrungPage2.default;
exports.ThemMoiCuocThanhTraPage = _ThemMoiCuocThanhTraPage2.default;
exports.ChiTietCuocThanhTraPage = _ChiTietCuocThanhTraPage2.default;
exports.ChinhSuaCuocThanhTraPage = _ChinhSuaCuocThanhTraPage2.default;
exports.ThayTheCuocThanhTraPage = _ThayTheCuocThanhTraPage2.default;
exports.ChinhSuaCuocThanhTraDotXuatPage = _ChinhSuaCuocThanhTraDotXuatPage2.default;
exports.ChiTietCuocThanhTraKeHoachPage = _ChiTietCuocThanhTraKeHoachPage2.default;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiGiamSat = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDonPage = function (_React$Component) {
  _inherits(DanhSachDonPage, _React$Component);

  function DanhSachDonPage() {
    _classCallCheck(this, DanhSachDonPage);

    return _possibleConstructorReturn(this, (DanhSachDonPage.__proto__ || Object.getPrototypeOf(DanhSachDonPage)).apply(this, arguments));
  }

  _createClass(DanhSachDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiGiamSat.DanhSachDon, { id: this.props.params.id })
      );
    }
  }]);

  return DanhSachDonPage;
}(_react2.default.Component);

exports.default = DanhSachDonPage;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiGiamSat = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachDonTheoKyPage = function (_React$Component) {
  _inherits(DanhSachDonTheoKyPage, _React$Component);

  function DanhSachDonTheoKyPage() {
    _classCallCheck(this, DanhSachDonTheoKyPage);

    return _possibleConstructorReturn(this, (DanhSachDonTheoKyPage.__proto__ || Object.getPrototypeOf(DanhSachDonTheoKyPage)).apply(this, arguments));
  }

  _createClass(DanhSachDonTheoKyPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiGiamSat.DanhSachDonTheoKy, null)
      );
    }
  }]);

  return DanhSachDonTheoKyPage;
}(_react2.default.Component);

exports.default = DanhSachDonTheoKyPage;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiGiamSat = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachThongKeGiamSatDonCuPage = function (_React$Component) {
  _inherits(DanhSachThongKeGiamSatDonCuPage, _React$Component);

  function DanhSachThongKeGiamSatDonCuPage() {
    _classCallCheck(this, DanhSachThongKeGiamSatDonCuPage);

    return _possibleConstructorReturn(this, (DanhSachThongKeGiamSatDonCuPage.__proto__ || Object.getPrototypeOf(DanhSachThongKeGiamSatDonCuPage)).apply(this, arguments));
  }

  _createClass(DanhSachThongKeGiamSatDonCuPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiGiamSat.DanhSachThongKeGiamSatDonCu, { params: this.props.params })
      );
    }
  }]);

  return DanhSachThongKeGiamSatDonCuPage;
}(_react2.default.Component);

exports.default = DanhSachThongKeGiamSatDonCuPage;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiGiamSat = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThongKeGiamSatNhapDonCuPage = function (_Component) {
  _inherits(ThongKeGiamSatNhapDonCuPage, _Component);

  function ThongKeGiamSatNhapDonCuPage() {
    _classCallCheck(this, ThongKeGiamSatNhapDonCuPage);

    return _possibleConstructorReturn(this, (ThongKeGiamSatNhapDonCuPage.__proto__ || Object.getPrototypeOf(ThongKeGiamSatNhapDonCuPage)).apply(this, arguments));
  }

  _createClass(ThongKeGiamSatNhapDonCuPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiGiamSat.ThongKeGiamSatNhapDonCu, { id: this.props.params.id })
      );
    }
  }]);

  return ThongKeGiamSatNhapDonCuPage;
}(_react.Component);

exports.default = ThongKeGiamSatNhapDonCuPage;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiGiamSat = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinhHinhXuLyDonTaiDonViPage = function (_React$Component) {
  _inherits(TinhHinhXuLyDonTaiDonViPage, _React$Component);

  function TinhHinhXuLyDonTaiDonViPage() {
    _classCallCheck(this, TinhHinhXuLyDonTaiDonViPage);

    return _possibleConstructorReturn(this, (TinhHinhXuLyDonTaiDonViPage.__proto__ || Object.getPrototypeOf(TinhHinhXuLyDonTaiDonViPage)).apply(this, arguments));
  }

  _createClass(TinhHinhXuLyDonTaiDonViPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiGiamSat.TinhHinhXuLyDonTaiDonVi, { id: this.props.params.id })
      );
    }
  }]);

  return TinhHinhXuLyDonTaiDonViPage;
}(_react2.default.Component);

exports.default = TinhHinhXuLyDonTaiDonViPage;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DanhSachThongKeGiamSatDonCuPage = exports.ThongKeGiamSatNhapDonCuPage = exports.DanhSachDonTheoKyPage = exports.DanhSachDonPage = exports.TinhHinhXuLyDonTaiDonViPage = undefined;

var _TinhHinhXuLyDonTaiDonViPage = __webpack_require__(1472);

var _TinhHinhXuLyDonTaiDonViPage2 = _interopRequireDefault(_TinhHinhXuLyDonTaiDonViPage);

var _DanhSachDonPage = __webpack_require__(1468);

var _DanhSachDonPage2 = _interopRequireDefault(_DanhSachDonPage);

var _DanhSachDonTheoKyPage = __webpack_require__(1469);

var _DanhSachDonTheoKyPage2 = _interopRequireDefault(_DanhSachDonTheoKyPage);

var _ThongKeGiamSatNhapDonCuPage = __webpack_require__(1471);

var _ThongKeGiamSatNhapDonCuPage2 = _interopRequireDefault(_ThongKeGiamSatNhapDonCuPage);

var _DanhSachThongKeGiamSatDonCuPage = __webpack_require__(1470);

var _DanhSachThongKeGiamSatDonCuPage2 = _interopRequireDefault(_DanhSachThongKeGiamSatDonCuPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TinhHinhXuLyDonTaiDonViPage = _TinhHinhXuLyDonTaiDonViPage2.default;
exports.DanhSachDonPage = _DanhSachDonPage2.default;
exports.DanhSachDonTheoKyPage = _DanhSachDonTheoKyPage2.default;
exports.ThongKeGiamSatNhapDonCuPage = _ThongKeGiamSatNhapDonCuPage2.default;
exports.DanhSachThongKeGiamSatDonCuPage = _DanhSachThongKeGiamSatDonCuPage2.default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiThucHien = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DanhSachTheoDoiThucHienPage = function (_React$Component) {
  _inherits(DanhSachTheoDoiThucHienPage, _React$Component);

  function DanhSachTheoDoiThucHienPage(props, context) {
    _classCallCheck(this, DanhSachTheoDoiThucHienPage);

    var _this = _possibleConstructorReturn(this, (DanhSachTheoDoiThucHienPage.__proto__ || Object.getPrototypeOf(DanhSachTheoDoiThucHienPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(DanhSachTheoDoiThucHienPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiThucHien.DanhSachTheoDoiThucHien, null)
      );
    }
  }]);

  return DanhSachTheoDoiThucHienPage;
}(_react2.default.Component);

exports.default = DanhSachTheoDoiThucHienPage;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiThucHien = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaXuLyTheoDoiThucHienPage = function (_React$Component) {
  _inherits(KetQuaXuLyTheoDoiThucHienPage, _React$Component);

  function KetQuaXuLyTheoDoiThucHienPage(props, context) {
    _classCallCheck(this, KetQuaXuLyTheoDoiThucHienPage);

    var _this = _possibleConstructorReturn(this, (KetQuaXuLyTheoDoiThucHienPage.__proto__ || Object.getPrototypeOf(KetQuaXuLyTheoDoiThucHienPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(KetQuaXuLyTheoDoiThucHienPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiThucHien.KetQuaTheoDoiThucHien, { params: this.props.params })
      );
    }
  }]);

  return KetQuaXuLyTheoDoiThucHienPage;
}(_react2.default.Component);

exports.default = KetQuaXuLyTheoDoiThucHienPage;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _theoDoiThucHien = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XuLyTheoDoiThucHienPage = function (_React$Component) {
  _inherits(XuLyTheoDoiThucHienPage, _React$Component);

  function XuLyTheoDoiThucHienPage(props, context) {
    _classCallCheck(this, XuLyTheoDoiThucHienPage);

    var _this = _possibleConstructorReturn(this, (XuLyTheoDoiThucHienPage.__proto__ || Object.getPrototypeOf(XuLyTheoDoiThucHienPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(XuLyTheoDoiThucHienPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_theoDoiThucHien.XuLyTheoDoiThucHien, { params: this.props.params })
      );
    }
  }]);

  return XuLyTheoDoiThucHienPage;
}(_react2.default.Component);

exports.default = XuLyTheoDoiThucHienPage;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetQuaXuLyTheoDoiThucHienPage = exports.XuLyTheoDoiThucHienPage = exports.DanhSachTheoDoiThucHienPage = undefined;

var _DanhSachTheoDoiThucHienPage = __webpack_require__(1474);

var _DanhSachTheoDoiThucHienPage2 = _interopRequireDefault(_DanhSachTheoDoiThucHienPage);

var _XuLyTheoDoiThucHienPage = __webpack_require__(1476);

var _XuLyTheoDoiThucHienPage2 = _interopRequireDefault(_XuLyTheoDoiThucHienPage);

var _KetQuaXuLyTheoDoiThucHienPage = __webpack_require__(1475);

var _KetQuaXuLyTheoDoiThucHienPage2 = _interopRequireDefault(_KetQuaXuLyTheoDoiThucHienPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DanhSachTheoDoiThucHienPage = _DanhSachTheoDoiThucHienPage2.default;
exports.XuLyTheoDoiThucHienPage = _XuLyTheoDoiThucHienPage2.default;
exports.KetQuaXuLyTheoDoiThucHienPage = _KetQuaXuLyTheoDoiThucHienPage2.default;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaKiemTraChiTietDoanhNghiepPage = function (_React$Component) {
  _inherits(KetQuaKiemTraChiTietDoanhNghiepPage, _React$Component);

  function KetQuaKiemTraChiTietDoanhNghiepPage(props, context) {
    _classCallCheck(this, KetQuaKiemTraChiTietDoanhNghiepPage);

    var _this = _possibleConstructorReturn(this, (KetQuaKiemTraChiTietDoanhNghiepPage.__proto__ || Object.getPrototypeOf(KetQuaKiemTraChiTietDoanhNghiepPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(KetQuaKiemTraChiTietDoanhNghiepPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP' })
      );
    }
  }]);

  return KetQuaKiemTraChiTietDoanhNghiepPage;
}(_react2.default.Component);

exports.default = KetQuaKiemTraChiTietDoanhNghiepPage;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaKiemTraDotXuatDoanhNghiepPage = function (_React$Component) {
  _inherits(KetQuaKiemTraDotXuatDoanhNghiepPage, _React$Component);

  function KetQuaKiemTraDotXuatDoanhNghiepPage(props, context) {
    _classCallCheck(this, KetQuaKiemTraDotXuatDoanhNghiepPage);

    var _this = _possibleConstructorReturn(this, (KetQuaKiemTraDotXuatDoanhNghiepPage.__proto__ || Object.getPrototypeOf(KetQuaKiemTraDotXuatDoanhNghiepPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(KetQuaKiemTraDotXuatDoanhNghiepPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP' })
      );
    }
  }]);

  return KetQuaKiemTraDotXuatDoanhNghiepPage;
}(_react2.default.Component);

exports.default = KetQuaKiemTraDotXuatDoanhNghiepPage;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KetQuaKiemTraTheoKeHoachDoanhNghiepPage = function (_React$Component) {
  _inherits(KetQuaKiemTraTheoKeHoachDoanhNghiepPage, _React$Component);

  function KetQuaKiemTraTheoKeHoachDoanhNghiepPage(props, context) {
    _classCallCheck(this, KetQuaKiemTraTheoKeHoachDoanhNghiepPage);

    var _this = _possibleConstructorReturn(this, (KetQuaKiemTraTheoKeHoachDoanhNghiepPage.__proto__ || Object.getPrototypeOf(KetQuaKiemTraTheoKeHoachDoanhNghiepPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(KetQuaKiemTraTheoKeHoachDoanhNghiepPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' })
      );
    }
  }]);

  return KetQuaKiemTraTheoKeHoachDoanhNghiepPage;
}(_react2.default.Component);

exports.default = KetQuaKiemTraTheoKeHoachDoanhNghiepPage;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = function (_React$Component) {
  _inherits(TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage, _React$Component);

  function TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage(props, context) {
    _classCallCheck(this, TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage);

    var _this = _possibleConstructorReturn(this, (TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage.__proto__ || Object.getPrototypeOf(TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH' })
      );
    }
  }]);

  return TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage;
}(_react2.default.Component);

exports.default = TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _handleLetters = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopDonTreHanGiaiQuyet = function (_React$Component) {
  _inherits(TongHopDonTreHanGiaiQuyet, _React$Component);

  function TongHopDonTreHanGiaiQuyet(props, context) {
    _classCallCheck(this, TongHopDonTreHanGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (TongHopDonTreHanGiaiQuyet.__proto__ || Object.getPrototypeOf(TongHopDonTreHanGiaiQuyet)).call(this, props, context));

    _this.state = {
      dataThamSo: []
    };
    return _this;
  }

  _createClass(TongHopDonTreHanGiaiQuyet, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLetters.TongHop, { routerName: this.props.route.name, param: this.props.params })
      );
    }
  }]);

  return TongHopDonTreHanGiaiQuyet;
}(_react2.default.Component);

exports.default = TongHopDonTreHanGiaiQuyet;
;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _handleLetters = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopDonTreHanXuLy = function (_React$Component) {
  _inherits(TongHopDonTreHanXuLy, _React$Component);

  function TongHopDonTreHanXuLy(props, context) {
    _classCallCheck(this, TongHopDonTreHanXuLy);

    var _this = _possibleConstructorReturn(this, (TongHopDonTreHanXuLy.__proto__ || Object.getPrototypeOf(TongHopDonTreHanXuLy)).call(this, props, context));

    _this.state = {
      dataThamSo: []
    };
    return _this;
  }

  _createClass(TongHopDonTreHanXuLy, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_handleLetters.TongHop, { routerName: this.props.route.name, param: this.props.params })
      );
    }
  }]);

  return TongHopDonTreHanXuLy;
}(_react2.default.Component);

exports.default = TongHopDonTreHanXuLy;
;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaGQDKNPage = function (_React$Component) {
  _inherits(TongHopKetQuaGQDKNPage, _React$Component);

  function TongHopKetQuaGQDKNPage(props, context) {
    _classCallCheck(this, TongHopKetQuaGQDKNPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaGQDKNPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaGQDKNPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaGQDKNPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'GIAI_QUYET_KHIEU_NAI' })
      );
    }
  }]);

  return TongHopKetQuaGQDKNPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaGQDKNPage;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaGQDTCPage = function (_React$Component) {
  _inherits(TongHopKetQuaGQDTCPage, _React$Component);

  function TongHopKetQuaGQDTCPage(props, context) {
    _classCallCheck(this, TongHopKetQuaGQDTCPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaGQDTCPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaGQDTCPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaGQDTCPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'GIAI_QUYET_TO_CAO' })
      );
    }
  }]);

  return TongHopKetQuaGQDTCPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaGQDTCPage;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = function (_React$Component) {
  _inherits(TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage, _React$Component);

  function TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage(props, context) {
    _classCallCheck(this, TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH' })
      );
    }
  }]);

  return TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraPage, _React$Component);

  function TongHopKetQuaThanhTraPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'TONG_HOP_KET_QUA_THANH_TRA' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraPage;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraChuyenNganhPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraChuyenNganhPage, _React$Component);

  function TongHopKetQuaThanhTraChuyenNganhPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraChuyenNganhPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraChuyenNganhPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraChuyenNganhPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraChuyenNganhPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_CHUYEN_NGANH' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraChuyenNganhPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraChuyenNganhPage;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraDatDaiPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraDatDaiPage, _React$Component);

  function TongHopKetQuaThanhTraDatDaiPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraDatDaiPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraDatDaiPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraDatDaiPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraDatDaiPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_DAT_DAI' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraDatDaiPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraDatDaiPage;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraHanhChinhPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraHanhChinhPage, _React$Component);

  function TongHopKetQuaThanhTraHanhChinhPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraHanhChinhPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraHanhChinhPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraHanhChinhPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraHanhChinhPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_HANH_CHINH' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraHanhChinhPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraHanhChinhPage;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraLaiPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraLaiPage, _React$Component);

  function TongHopKetQuaThanhTraLaiPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraLaiPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraLaiPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraLaiPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraLaiPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_LAI' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraLaiPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraLaiPage;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraTaiChinhNganSachPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraTaiChinhNganSachPage, _React$Component);

  function TongHopKetQuaThanhTraTaiChinhNganSachPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraTaiChinhNganSachPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraTaiChinhNganSachPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraTaiChinhNganSachPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraTaiChinhNganSachPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_TAI_CHINH_NGAN_SACH' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraTaiChinhNganSachPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraTaiChinhNganSachPage;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraThamNhungPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraThamNhungPage, _React$Component);

  function TongHopKetQuaThanhTraThamNhungPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraThamNhungPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraThamNhungPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraThamNhungPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraThamNhungPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_THAM_NHUNG' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraThamNhungPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraThamNhungPage;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThanhTraXayDungCoBanPage = function (_React$Component) {
  _inherits(TongHopKetQuaThanhTraXayDungCoBanPage, _React$Component);

  function TongHopKetQuaThanhTraXayDungCoBanPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThanhTraXayDungCoBanPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThanhTraXayDungCoBanPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThanhTraXayDungCoBanPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThanhTraXayDungCoBanPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THANH_TRA_XAY_DUNG_CO_BAN' })
      );
    }
  }]);

  return TongHopKetQuaThanhTraXayDungCoBanPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThanhTraXayDungCoBanPage;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = function (_React$Component) {
  _inherits(TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage, _React$Component);

  function TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage(props, context) {
    _classCallCheck(this, TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH' })
      );
    }
  }]);

  return TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaTiepCongDanPage = function (_React$Component) {
  _inherits(TongHopKetQuaTiepCongDanPage, _React$Component);

  function TongHopKetQuaTiepCongDanPage(props, context) {
    _classCallCheck(this, TongHopKetQuaTiepCongDanPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaTiepCongDanPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaTiepCongDanPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaTiepCongDanPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'TIEP_CONG_DAN' })
      );
    }
  }]);

  return TongHopKetQuaTiepCongDanPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaTiepCongDanPage;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _layout = __webpack_require__(9);

var _thongKeBaoCao = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TongHopKetQuaXuLyDonPage = function (_React$Component) {
  _inherits(TongHopKetQuaXuLyDonPage, _React$Component);

  function TongHopKetQuaXuLyDonPage(props, context) {
    _classCallCheck(this, TongHopKetQuaXuLyDonPage);

    var _this = _possibleConstructorReturn(this, (TongHopKetQuaXuLyDonPage.__proto__ || Object.getPrototypeOf(TongHopKetQuaXuLyDonPage)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(TongHopKetQuaXuLyDonPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout.MasterLayout,
        { routerName: this.props.route.name },
        _react2.default.createElement(_thongKeBaoCao.TongHopKetQua, { type: 'XU_LY_DON' })
      );
    }
  }]);

  return TongHopKetQuaXuLyDonPage;
}(_react2.default.Component);

exports.default = TongHopKetQuaXuLyDonPage;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TongHopKetQuaThanhTraThamNhungPage = exports.TongHopKetQuaThanhTraPage = exports.KetQuaKiemTraDotXuatDoanhNghiepPage = exports.KetQuaKiemTraTheoKeHoachDoanhNghiepPage = exports.KetQuaKiemTraChiTietDoanhNghiepPage = exports.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = exports.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = exports.TongHopKetQuaThanhTraLaiPage = exports.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = exports.TongHopKetQuaThanhTraTaiChinhNganSachPage = exports.TongHopKetQuaThanhTraXayDungCoBanPage = exports.TongHopKetQuaThanhTraChuyenNganhPage = exports.TongHopKetQuaThanhTraDatDaiPage = exports.TongHopKetQuaThanhTraHanhChinhPage = exports.TongHopKetQuaXuLyDonPage = exports.TongHopKetQuaGQDKNPage = exports.TongHopKetQuaTiepCongDanPage = exports.TongHopKetQuaGQDTCPage = exports.TongHopDonTreHanGiaiQuyet = exports.TongHopDonTreHanXuLy = undefined;

var _TongHopDonTreHanXuLy = __webpack_require__(1483);

var _TongHopDonTreHanXuLy2 = _interopRequireDefault(_TongHopDonTreHanXuLy);

var _TongHopDonTreHanGiaiQuyet = __webpack_require__(1482);

var _TongHopDonTreHanGiaiQuyet2 = _interopRequireDefault(_TongHopDonTreHanGiaiQuyet);

var _TongHopKetQuaGQDTCPage = __webpack_require__(1485);

var _TongHopKetQuaGQDTCPage2 = _interopRequireDefault(_TongHopKetQuaGQDTCPage);

var _TongHopKetQuaTiepCongDanPage = __webpack_require__(1496);

var _TongHopKetQuaTiepCongDanPage2 = _interopRequireDefault(_TongHopKetQuaTiepCongDanPage);

var _TongHopKetQuaGQDKNPage = __webpack_require__(1484);

var _TongHopKetQuaGQDKNPage2 = _interopRequireDefault(_TongHopKetQuaGQDKNPage);

var _TongHopKetQuaXuLyDonPage = __webpack_require__(1497);

var _TongHopKetQuaXuLyDonPage2 = _interopRequireDefault(_TongHopKetQuaXuLyDonPage);

var _TongHopKetQuaThanhTraHanhChinhPage = __webpack_require__(1490);

var _TongHopKetQuaThanhTraHanhChinhPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraHanhChinhPage);

var _TongHopKetQuaThanhTraDatDaiPage = __webpack_require__(1489);

var _TongHopKetQuaThanhTraDatDaiPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraDatDaiPage);

var _TongHopKetQuaThanhTraChuyenNganhPage = __webpack_require__(1488);

var _TongHopKetQuaThanhTraChuyenNganhPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraChuyenNganhPage);

var _TongHopKetQuaThanhTraXayDungCoBanPage = __webpack_require__(1494);

var _TongHopKetQuaThanhTraXayDungCoBanPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraXayDungCoBanPage);

var _TongHopKetQuaThanhTraTaiChinhNganSachPage = __webpack_require__(1492);

var _TongHopKetQuaThanhTraTaiChinhNganSachPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraTaiChinhNganSachPage);

var _TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = __webpack_require__(1481);

var _TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage2 = _interopRequireDefault(_TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage);

var _TongHopKetQuaThanhTraLaiPage = __webpack_require__(1491);

var _TongHopKetQuaThanhTraLaiPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraLaiPage);

var _TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = __webpack_require__(1495);

var _TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage2 = _interopRequireDefault(_TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage);

var _TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = __webpack_require__(1486);

var _TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage2 = _interopRequireDefault(_TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage);

var _KetQuaKiemTraChiTietDoanhNghiep = __webpack_require__(1478);

var _KetQuaKiemTraChiTietDoanhNghiep2 = _interopRequireDefault(_KetQuaKiemTraChiTietDoanhNghiep);

var _KetQuaKiemTraTheoKeHoachDoanhNghiep = __webpack_require__(1480);

var _KetQuaKiemTraTheoKeHoachDoanhNghiep2 = _interopRequireDefault(_KetQuaKiemTraTheoKeHoachDoanhNghiep);

var _KetQuaKiemTraDotXuatDoanhNghiep = __webpack_require__(1479);

var _KetQuaKiemTraDotXuatDoanhNghiep2 = _interopRequireDefault(_KetQuaKiemTraDotXuatDoanhNghiep);

var _TongHopKetQuaThanhTra = __webpack_require__(1487);

var _TongHopKetQuaThanhTra2 = _interopRequireDefault(_TongHopKetQuaThanhTra);

var _TongHopKetQuaThanhTraThamNhungPage = __webpack_require__(1493);

var _TongHopKetQuaThanhTraThamNhungPage2 = _interopRequireDefault(_TongHopKetQuaThanhTraThamNhungPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TongHopDonTreHanXuLy = _TongHopDonTreHanXuLy2.default;
exports.TongHopDonTreHanGiaiQuyet = _TongHopDonTreHanGiaiQuyet2.default;
exports.TongHopKetQuaGQDTCPage = _TongHopKetQuaGQDTCPage2.default;
exports.TongHopKetQuaTiepCongDanPage = _TongHopKetQuaTiepCongDanPage2.default;
exports.TongHopKetQuaGQDKNPage = _TongHopKetQuaGQDKNPage2.default;
exports.TongHopKetQuaXuLyDonPage = _TongHopKetQuaXuLyDonPage2.default;
exports.TongHopKetQuaThanhTraHanhChinhPage = _TongHopKetQuaThanhTraHanhChinhPage2.default;
exports.TongHopKetQuaThanhTraDatDaiPage = _TongHopKetQuaThanhTraDatDaiPage2.default;
exports.TongHopKetQuaThanhTraChuyenNganhPage = _TongHopKetQuaThanhTraChuyenNganhPage2.default;
exports.TongHopKetQuaThanhTraXayDungCoBanPage = _TongHopKetQuaThanhTraXayDungCoBanPage2.default;
exports.TongHopKetQuaThanhTraTaiChinhNganSachPage = _TongHopKetQuaThanhTraTaiChinhNganSachPage2.default;
exports.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage = _TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage2.default;
exports.TongHopKetQuaThanhTraLaiPage = _TongHopKetQuaThanhTraLaiPage2.default;
exports.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage = _TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage2.default;
exports.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage = _TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage2.default;
exports.KetQuaKiemTraChiTietDoanhNghiepPage = _KetQuaKiemTraChiTietDoanhNghiep2.default;
exports.KetQuaKiemTraTheoKeHoachDoanhNghiepPage = _KetQuaKiemTraTheoKeHoachDoanhNghiep2.default;
exports.KetQuaKiemTraDotXuatDoanhNghiepPage = _KetQuaKiemTraDotXuatDoanhNghiep2.default;
exports.TongHopKetQuaThanhTraPage = _TongHopKetQuaThanhTra2.default;
exports.TongHopKetQuaThanhTraThamNhungPage = _TongHopKetQuaThanhTraThamNhungPage2.default;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCanCuThanhTraLai = function (_React$Component) {
  _inherits(DropDownChonCanCuThanhTraLai, _React$Component);

  function DropDownChonCanCuThanhTraLai() {
    _classCallCheck(this, DropDownChonCanCuThanhTraLai);

    return _possibleConstructorReturn(this, (DropDownChonCanCuThanhTraLai.__proto__ || Object.getPrototypeOf(DropDownChonCanCuThanhTraLai)).apply(this, arguments));
  }

  _createClass(DropDownChonCanCuThanhTraLai, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonCanCuThanhTraLai;
}(_react2.default.Component);

DropDownChonCanCuThanhTraLai.defaultProps = {
  label: 'Căn cứ thanh tra lại',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'Đang tiến hành', ten: 'Đang tiến hành' }, { giaTri: 'Hoàn thành', ten: 'Hoàn thành' }]
};

exports.default = (0, _utils.validatable)(DropDownChonCanCuThanhTraLai);

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCoQuanDieuTra = function (_React$Component) {
  _inherits(DropDownChonCoQuanDieuTra, _React$Component);

  function DropDownChonCoQuanDieuTra(props, context) {
    _classCallCheck(this, DropDownChonCoQuanDieuTra);

    var _this = _possibleConstructorReturn(this, (DropDownChonCoQuanDieuTra.__proto__ || Object.getPrototypeOf(DropDownChonCoQuanDieuTra)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonCoQuanDieuTra, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.data != this.props.data) {
        var newData = [].concat(_toConsumableArray(nextProps.data));
        newData = newData.filter(function (item) {
          return item.coQuanQuanLyId != _this2.props.except;
        });

        this.setState({
          data: newData
        });
      }
      if (nextProps.except != this.props.except) {
        var _newData = [].concat(_toConsumableArray(this.props.data));
        _newData = _newData.filter(function (item) {
          return item.coQuanQuanLyId != nextProps.except;
        });

        this.setState({
          data: _newData
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getCoQuanDieuTra.request().then(function (res) {
          _this3.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'coQuanDieuTra',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        label: this.props.label,
        options: this.state.data,
        require: this.props.require,
        keyName: 'coQuanQuanLyId',
        valueName: 'ten',
        className: this.props.className,
        onChange: this.onChange.bind(this),
        selectedValue: this.props.selectedValue,
        placeholder: this.props.placeholder,
        isValid: this.props.isValid,
        bindValidator: this,
        channel: 'formTaoDon',
        name: this.props.name });
    }
  }]);

  return DropDownChonCoQuanDieuTra;
}(_react2.default.Component);

DropDownChonCoQuanDieuTra.defaultProps = {
  isValid: false,
  require: false,
  label: 'Đơn vị chủ trì',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  except: '',
  name: '',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanDieuTra
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonCoQuanDieuTra));

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonDonViChuTriThanhTra = function (_React$Component) {
  _inherits(DropDownChonDonViChuTriThanhTra, _React$Component);

  function DropDownChonDonViChuTriThanhTra() {
    _classCallCheck(this, DropDownChonDonViChuTriThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonDonViChuTriThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonDonViChuTriThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonDonViChuTriThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'coQuanQuanLyId', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonDonViChuTriThanhTra;
}(_react2.default.Component);

DropDownChonDonViChuTriThanhTra.defaultProps = {
  label: 'Đơn vị chủ trì',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
};

exports.default = (0, _utils.validatable)(DropDownChonDonViChuTriThanhTra);

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonHinhThucThanhTra = function (_React$Component) {
  _inherits(DropDownChonHinhThucThanhTra, _React$Component);

  function DropDownChonHinhThucThanhTra() {
    _classCallCheck(this, DropDownChonHinhThucThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonHinhThucThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonHinhThucThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonHinhThucThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonHinhThucThanhTra;
}(_react2.default.Component);

DropDownChonHinhThucThanhTra.defaultProps = {
  label: 'Hình thức',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: [{ giaTri: 'Cũ', ten: 'Cũ' }, { giaTri: 'Mới', ten: 'Mới' }]
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonHinhThucThanhTra));

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLinhVucThanhTra = function (_React$Component) {
  _inherits(DropDownChonLinhVucThanhTra, _React$Component);

  function DropDownChonLinhVucThanhTra() {
    _classCallCheck(this, DropDownChonLinhVucThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonLinhVucThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonLinhVucThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonLinhVucThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        label: this.props.label,
        bindValidator: this,
        name: this.props.name,
        confirm: this.props.confirm,
        channel: 'formTaoDon',
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        options: this.props.data,
        keyName: 'giaTri',
        valueName: 'ten',
        className: this.props.className,
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder
      });
    }
  }]);

  return DropDownChonLinhVucThanhTra;
}(_react2.default.Component);

DropDownChonLinhVucThanhTra.defaultProps = {
  label: 'Lĩnh vực thanh tra',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'Hành chính', ten: 'Hành chính' }, { giaTri: 'Đất đai', ten: 'Đất đai' }, { giaTri: 'XDCB', ten: 'XDCB' }, { giaTri: 'Chuyên ngành', ten: 'Chuyên ngành' }]
};

exports.default = (0, _utils.validatable)(DropDownChonLinhVucThanhTra);

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLinhVucThanhTraMultiple = function (_React$Component) {
  _inherits(DropDownChonLinhVucThanhTraMultiple, _React$Component);

  function DropDownChonLinhVucThanhTraMultiple() {
    _classCallCheck(this, DropDownChonLinhVucThanhTraMultiple);

    return _possibleConstructorReturn(this, (DropDownChonLinhVucThanhTraMultiple.__proto__ || Object.getPrototypeOf(DropDownChonLinhVucThanhTraMultiple)).apply(this, arguments));
  }

  _createClass(DropDownChonLinhVucThanhTraMultiple, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDownMultipleSelect, {
        label: this.props.label,
        bindValidator: this,
        channel: 'formTaoDon',
        require: this.props.require,
        value: this.props.selectedValue,
        options: this.props.data,
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        closeMenuOnSelect: false,
        className: this.props.className,
        validLinhVucThanhTra: this.props.validLinhVucThanhTra
      });
    }
  }]);

  return DropDownChonLinhVucThanhTraMultiple;
}(_react2.default.Component);

DropDownChonLinhVucThanhTraMultiple.defaultProps = {
  label: 'Lĩnh vực thanh tra',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'Hành chính', ten: 'Hành chính' }, { giaTri: 'Đất đai', ten: 'Đất đai' }, { giaTri: 'XDCB', ten: 'XDCB' }, { giaTri: 'Chuyên ngành', ten: 'Chuyên ngành' }],
  className: '',
  validLinhVucThanhTra: true
};

exports.default = (0, _utils.validatable)(DropDownChonLinhVucThanhTraMultiple);

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiHinhThanhTra = function (_React$Component) {
  _inherits(DropDownChonLoaiHinhThanhTra, _React$Component);

  function DropDownChonLoaiHinhThanhTra() {
    _classCallCheck(this, DropDownChonLoaiHinhThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonLoaiHinhThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonLoaiHinhThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonLoaiHinhThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, name: this.props.name, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonLoaiHinhThanhTra;
}(_react2.default.Component);

DropDownChonLoaiHinhThanhTra.defaultProps = {
  label: 'Loại hình thanh tra',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'Cũ', ten: 'Cũ' }, { giaTri: 'Mới', ten: 'Mới' }]
};

exports.default = (0, _utils.validatable)(DropDownChonLoaiHinhThanhTra);

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonPhoPhong = function (_React$Component) {
  _inherits(DropDownChonPhoPhong, _React$Component);

  function DropDownChonPhoPhong(props, context) {
    _classCallCheck(this, DropDownChonPhoPhong);

    var _this = _possibleConstructorReturn(this, (DropDownChonPhoPhong.__proto__ || Object.getPrototypeOf(DropDownChonPhoPhong)).call(this, props, context));

    _this.state = {
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonPhoPhong, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.phongBanId) this.loadData(this.props.phongBanId);
    }
  }, {
    key: 'loadData',
    value: function loadData(phongBanId) {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request({ coQuanQuanLyId: phongBanId, vaiTro: this.props.vaiTro, isPhoPhong: true }).then(function (res) {
        if (typeof res.data._embedded != "undefined") {

          _this2.setState({
            data: res.data._embedded.congChucs
          });
        } else {
          _this2.setState({
            data: []
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.phongBanId != nextProps.phongBanId) {
        if (nextProps.phongBanId) {
          if (typeof this.state.allData[nextProps.phongBanId] != "undefined") {
            this.setState({
              data: this.props.data[nextProps.phongBanId]
            });
          } else {
            this.loadData(nextProps.phongBanId);
          }
        } else {
          this.setState({
            data: []
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        label: this.props.label,
        className: this.props.className,
        options: this.state.data,
        keyName: 'congChucId',
        valueName: 'hoVaTen',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        selectedValue: this.props.selectedValue,
        name: this.props.name });
    }
  }]);

  return DropDownChonPhoPhong;
}(_react2.default.Component);

DropDownChonPhoPhong.defaultProps = {
  label: 'Công chức xử lý',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonPhoPhong);

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonTienDoThanhTra = function (_React$Component) {
  _inherits(DropDownChonTienDoThanhTra, _React$Component);

  function DropDownChonTienDoThanhTra() {
    _classCallCheck(this, DropDownChonTienDoThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonTienDoThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonTienDoThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonTienDoThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonTienDoThanhTra;
}(_react2.default.Component);

DropDownChonTienDoThanhTra.defaultProps = {
  label: 'Tiến độ',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'Đang tiến hành', ten: 'Đang tiến hành' }, { giaTri: 'Hoàn thành', ten: 'Hoàn thành' }]
};

exports.default = (0, _utils.validatable)(DropDownChonTienDoThanhTra);

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownMulipleUse = function (_React$Component) {
  _inherits(DropDownMulipleUse, _React$Component);

  function DropDownMulipleUse() {
    _classCallCheck(this, DropDownMulipleUse);

    return _possibleConstructorReturn(this, (DropDownMulipleUse.__proto__ || Object.getPrototypeOf(DropDownMulipleUse)).apply(this, arguments));
  }

  _createClass(DropDownMulipleUse, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.select) {
        this.select.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disable, onRef: function onRef(select) {
          return _this2.select = select;
        }, label: this.props.label, confirm: this.props.confirm, bindValidator: this, channel: this.props.channel, require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: this.props.keyName, valueName: this.props.valueName, className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: this.props.name });
    }
  }]);

  return DropDownMulipleUse;
}(_react2.default.Component);

DropDownMulipleUse.defaultProps = {
  label: 'Text label',
  disable: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  onRef: function onRef() {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  keyName: '',
  valueName: '',
  channel: 'formTaoDon',
  options: [],
  data: [],
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownMulipleUse);

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownNguoiKy = function (_React$Component) {
  _inherits(DropDownNguoiKy, _React$Component);

  function DropDownNguoiKy(props, context) {
    _classCallCheck(this, DropDownNguoiKy);

    var _this = _possibleConstructorReturn(this, (DropDownNguoiKy.__proto__ || Object.getPrototypeOf(DropDownNguoiKy)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(DropDownNguoiKy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isCuocThanhTra) {
        this.getNguoiBanHanhKTTT();
      } else {
        this.getData();
      }
    }
  }, {
    key: 'getData',
    value: function getData() {
      var _this2 = this;

      _api.GiaiQuyetDonThu.actions.getListNguoiBanHanh.request().then(function (res) {
        if (_this2.refs.chonNguoiKy) {
          if (res.data && res.data._embedded) {
            _this2.setState({ data: res.data._embedded.congChucs });
          } else {
            _this2.setState({ data: [] });
          }
        }
      });
    }
  }, {
    key: 'getNguoiBanHanhKTTT',
    value: function getNguoiBanHanhKTTT() {
      var _this3 = this;

      _api.GiaiQuyetDonThu.actions.getListNguoiBanHanhKTTT.request().then(function (res) {
        if (_this3.refs.chonNguoiKy) {
          if (res.data && res.data._embedded) {
            _this3.setState({ data: res.data._embedded.congChucs });
          } else {
            _this3.setState({ data: [] });
          }
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        label: 'Ng\u01B0\u1EDDi k\xFD', options: this.state.data,
        keyName: 'congChucId', valueName: 'hoVaTen',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        selectedValue: this.props.selected,
        ref: 'chonNguoiKy',
        name: 'dropdownNguoiKy' });
    }
  }]);

  return DropDownNguoiKy;
}(_react2.default.Component);

DropDownNguoiKy.defaultProps = {
  selected: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  isCuocThanhTra: false
};

exports.default = DropDownNguoiKy;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownQuyTrinh = function (_React$Component) {
  _inherits(DropDownQuyTrinh, _React$Component);

  function DropDownQuyTrinh() {
    _classCallCheck(this, DropDownQuyTrinh);

    return _possibleConstructorReturn(this, (DropDownQuyTrinh.__proto__ || Object.getPrototypeOf(DropDownQuyTrinh)).apply(this, arguments));
  }

  _createClass(DropDownQuyTrinh, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownQuyTrinh;
}(_react2.default.Component);

DropDownQuyTrinh.defaultProps = {
  label: 'Quy trình',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [{ giaTri: 'UBND_TP', ten: 'uỷ ban nhân dân Tỉnh' }, { giaTri: 'SO_BAN_NGANH', ten: 'Sở ban ngành' }]
};

exports.default = (0, _utils.validatable)(DropDownQuyTrinh);

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBox = function (_React$Component) {
  _inherits(CheckBox, _React$Component);

  function CheckBox(props, context) {
    _classCallCheck(this, CheckBox);

    var _this = _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).call(this, props, context));

    _this.state = {
      checked: _this.props.isChecked
    };
    return _this;
  }

  _createClass(CheckBox, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        checked: !this.state.checked
      });
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ checked: nextProps.isChecked });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-12' },
              _react2.default.createElement(
                _core.Checkbox,
                { className: 'pt-large', checked: this.state.checked, onChange: this.onChange.bind(this), name: this.props.name, disabled: this.props.disabled },
                _react2.default.createElement(
                  'span',
                  { className: 'name_checkbox' },
                  this.props.ten
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'items-form' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.checked },
            this.props.componentFill
          )
        )
      );
    }
  }]);

  return CheckBox;
}(_react2.default.Component);

CheckBox.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  isChecked: false,
  name: '',
  disabled: false
};

exports.default = CheckBox;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDown = function (_React$Component) {
  _inherits(DropDown, _React$Component);

  function DropDown(props, context) {
    _classCallCheck(this, DropDown);

    var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props, context));

    _this.state = {
      value: _this.props.selectedValue,
      isValid: true
    };
    return _this;
  }

  _createClass(DropDown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.state.value = e.target.value;
      this.setState(_extends({}, this.state));
      this.props.onChange(e);
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (!this.state.value && this.props.require) {
        this.setState({
          isValid: false
        });
        this.select.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      this.setState({
        value: nextProps.selectedValue
      });

      // if (nextProps.confirm) {
      //   this.setState({
      //     value: nextProps.selectedValue
      //   });
      // }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (!this.state.isValid && !this.state.value) {
        return 'pt-intent-danger';
      } else {
        return '';
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.select.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require == true },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt-select' },
          _react2.default.createElement(
            'select',
            { disabled: this.props.disabled, className: this.classNames(), value: this.state.value, onChange: this.onChange.bind(this), ref: function ref(select) {
                _this2.select = select;
              }, name: this.props.name },
            this.props.placeholder != null ? _react2.default.createElement(
              'option',
              { value: '' },
              '--Ch\u1ECDn--'
            ) : '',
            this.props.options.map(function (item, i) {
              return _react2.default.createElement(
                'option',
                { key: i, value: item[_this2.props.keyName] },
                item[_this2.props.valueName]
              );
            })
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && !this.state.value },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return DropDown;
}(_react2.default.Component);

DropDown.defaultProps = {
  className: 'input-group',
  disabled: false,
  label: '',
  options: [],
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  onRef: function onRef() {},
  selectedValue: '',
  keyName: 'key',
  valueName: 'value',
  placeholder: null,
  require: false,
  name: ''
};

exports.default = (0, _utils.validatable)(DropDown);

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _reactSelect = __webpack_require__(2278);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownMultipleSelect = function (_React$Component) {
  _inherits(DropDownMultipleSelect, _React$Component);

  function DropDownMultipleSelect(props, context) {
    _classCallCheck(this, DropDownMultipleSelect);

    var _this = _possibleConstructorReturn(this, (DropDownMultipleSelect.__proto__ || Object.getPrototypeOf(DropDownMultipleSelect)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      isValid: true
    };
    return _this;
  }

  _createClass(DropDownMultipleSelect, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        value: e
      });

      this.props.onChange(e);
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.state.value.length == 0 && this.props.require) {
        this.setState({
          isValid: false
        });
        this.select.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
      if (nextProps.value && nextProps.value.length > 0) {
        this.setState({
          isValid: true
        });
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (!this.state.isValid && this.state.value.length == 0) {
        return 'pt-multiple-danger';
      } else {
        return '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require == true },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { name: this.props.name },
          _react2.default.createElement(_reactSelect2.default, {
            className: this.classNames(),
            ref: function ref(select) {
              _this2.select = select;
            },
            value: this.state.value,
            options: this.props.options,
            isSearchable: this.props.isSearchable,
            onChange: this.onChange.bind(this),
            placeholder: '--Ch\u1ECDn--',
            multi: this.props.multi,
            joinValues: true,
            noResultsText: 'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u n\xE0y',
            loadingPlaceholder: '\u0110ang l\u1EA5y d\u1EEF li\u1EC7u...',
            disabled: this.props.disabled,
            isLoading: this.props.loading,
            closeMenuOnSelect: this.props.closeMenuOnSelect
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid || !this.props.validLinhVucThanhTra },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return DropDownMultipleSelect;
}(_react2.default.Component);

DropDownMultipleSelect.defaultProps = {
  className: 'input-group',
  name: '',
  label: '',
  options: [],
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  value: [],
  keyName: 'key',
  valueName: 'value',
  require: false,
  multi: true,
  disabled: false,
  isSearchable: false,
  loading: false,
  closeMenuOnSelect: false,
  validLinhVucThanhTra: true
};

exports.default = (0, _utils.validatable)(DropDownMultipleSelect);

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _reactTreeSelect = __webpack_require__(506);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownTreeMultipleSelect = function (_React$Component) {
  _inherits(DropDownTreeMultipleSelect, _React$Component);

  function DropDownTreeMultipleSelect(props, context) {
    _classCallCheck(this, DropDownTreeMultipleSelect);

    var _this = _possibleConstructorReturn(this, (DropDownTreeMultipleSelect.__proto__ || Object.getPrototypeOf(DropDownTreeMultipleSelect)).call(this, props, context));

    _this.state = {
      dataOptions: _this.props.dataOptions,
      dataSelected: _this.props.dataSelected,
      propertyChildren: _this.props.propertyChildren,
      thanhTraCQQL: _this.props.thanhTraCQQL,
      propertyParent: _this.props.propertyParent,
      isValid: true
    };
    return _this;
  }

  _createClass(DropDownTreeMultipleSelect, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        dataSelected: e,
        isValid: true
      });
      this.props.onChange(e);
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.state.dataSelected.length == 0 && this.props.require) {
        this.setState({
          isValid: false
        });
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dataOptions: nextProps.dataOptions || [],
        dataSelected: nextProps.dataSelected || [],
        propertyChildren: nextProps.propertyChildren,
        thanhTraCQQL: nextProps.thanhTraCQQL,
        propertyParent: nextProps.propertyParent
      });
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (!this.state.isValid && this.state.dataSelected.length == 0) {
        return 'rs-multiple-danger';
      } else {
        return '';
      }
    }
  }, {
    key: 'unCheckSelectAllChildren',
    value: function unCheckSelectAllChildren() {
      this.props.unCheckSelectAllChildren();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require == true },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.classNames() },
          _react2.default.createElement(_reactTreeSelect.ReactTreeSelect, {
            data: this.state.dataOptions,
            name: this.props.name,
            dataOptions: this.props.dataOptions,
            dataSelected: this.state.dataSelected,
            onChange: this.onChange.bind(this),
            propertyChildren: this.state.propertyChildren,
            thanhTraCQQL: this.props.thanhTraCQQL,
            propertyParent: this.state.propertyParent,
            optionOpened: this.state.optionOpened,
            selectAllChildren: this.props.selectAllChildren
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && this.state.dataSelected.length == 0 },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return DropDownTreeMultipleSelect;
}(_react2.default.Component);

DropDownTreeMultipleSelect.defaultProps = {
  className: 'input-group',
  label: '',
  dataOptions: [],
  dataSelected: [],

  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  value: [],
  keyName: 'key',
  propertyChildren: '',
  propertyParent: '',
  require: false
};

exports.default = (0, _utils.validatable)(DropDownTreeMultipleSelect);

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _reactTreeSelect = __webpack_require__(506);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownTreeSelectOneElement = function (_React$Component) {
  _inherits(DropDownTreeSelectOneElement, _React$Component);

  function DropDownTreeSelectOneElement(props, context) {
    _classCallCheck(this, DropDownTreeSelectOneElement);

    var _this = _possibleConstructorReturn(this, (DropDownTreeSelectOneElement.__proto__ || Object.getPrototypeOf(DropDownTreeSelectOneElement)).call(this, props, context));

    _this.state = {
      dataOptions: _this.props.dataOptions,
      value: _this.props.value,
      propertyChildren: _this.props.propertyChildren,
      propertyParent: _this.props.propertyParent,
      isValid: true
    };
    return _this;
  }

  _createClass(DropDownTreeSelectOneElement, [{
    key: 'onChange',
    value: function onChange(e) {
      var dataPush = {
        target: {
          value: e
        }
      };
      this.setState({
        value: e ? e : '',
        isValid: true
      });
      this.props.onChange(dataPush);
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.state.value != 0 && !this.state.value && this.props.require) {
        this.setState({
          isValid: false
        });
        this.input.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dataOptions: nextProps.dataOptions,
        value: nextProps.value,
        propertyChildren: nextProps.propertyChildren,
        propertyParent: nextProps.propertyParent
      });
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (!this.state.isValid && !this.state.value) {
        return 'rs-multiple-danger';
      } else {
        return '';
      }
    }
  }, {
    key: 'unCheckSelectAllChildren',
    value: function unCheckSelectAllChildren() {
      this.props.unCheckSelectAllChildren();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.label != '' },
          _react2.default.createElement(
            'label',
            { className: 'ip-label' },
            this.props.label,
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.require == true },
              _react2.default.createElement(
                'span',
                { className: 'text-required' },
                '\xA0*'
              )
            )
          )
        ),
        _react2.default.createElement('input', { className: 'hidden-input', ref: function ref(input) {
            _this2.input = input;
          } }),
        _react2.default.createElement(
          'div',
          { className: this.classNames() },
          _react2.default.createElement(_reactTreeSelect.ReactTreeSelectOneElement, {
            data: this.state.dataOptions,
            value: this.state.value,
            onChange: this.onChange.bind(this),
            propertyChildren: this.state.propertyChildren,
            propertyParent: this.state.propertyParent,
            optionOpened: this.state.optionOpened,
            name: this.props.name,
            selectAllChildren: this.props.selectAllChildren
          })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && !this.state.value },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return DropDownTreeSelectOneElement;
}(_react2.default.Component);

DropDownTreeSelectOneElement.defaultProps = {
  className: 'input-group',
  label: '',
  dataOptions: [],

  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  value: '',
  keyName: 'key',
  propertyChildren: '',
  propertyParent: '',
  require: false,
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownTreeSelectOneElement);

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputList = function (_React$Component) {
  _inherits(InputList, _React$Component);

  function InputList(props, context) {
    _classCallCheck(this, InputList);

    var _this = _possibleConstructorReturn(this, (InputList.__proto__ || Object.getPrototypeOf(InputList)).call(this, props, context));

    _this.state = {
      data: [],
      value: '',
      indexConfirm: ''
    };
    return _this;
  }

  _createClass(InputList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.convertValueToData(nextProps.data);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.convertValueToData(this.props.data);
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'handleConfirm',
    value: function handleConfirm(data) {
      if (this.props.handleConfirm(data)) {
        //do nothing
      } else {
        this.removeDonViConfirm();
      }
    }
  }, {
    key: 'convertValueToData',
    value: function convertValueToData(data) {
      var dataResult = [];
      var newCheck = data;
      if (newCheck) {
        var newData = newCheck.split('; ');
        newData.map(function (state) {
          dataResult[dataResult.length] = {
            ten: state
          };
        });
        this.setState({
          data: [].concat(dataResult)
        });
      } else {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'convertDataToValue',
    value: function convertDataToValue() {
      var e = {
        target: {
          value: '',
          count: this.state.data.length
        }
      };
      this.state.data.map(function (state, i) {
        if (i == 0) {
          e.target.value = e.target.value + state.ten;
        } else {
          e.target.value = e.target.value + '; ' + state.ten;
        }
      });
      this.props.onChange(e);
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target.value));
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(e) {
      var _this2 = this;

      if (typeof e != 'undefined') {
        e.preventDefault();
      }
      var newArr = [].concat(_toConsumableArray(this.state.data));

      var arrCheck = newArr.filter(function (state) {
        return state.ten == _this2.state.value;
      });

      if (this.state.value.trim()) {
        if (arrCheck.length > 0) {
          this.setState({
            value: ''
          });
        } else {
          var newItem = {
            ten: this.state.value
          };
          this.setState({
            data: [].concat(_toConsumableArray(this.state.data), [newItem]),
            value: ''
          }, function () {
            _this2.convertDataToValue();
          });
        }
      } else {
        this.setState({
          value: ''
        });
      }
      return;
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var _this3 = this;

      if (this.props.confirm) {
        this.setState({
          indexConfirm: index
        }, function () {
          _this3.handleConfirm(_this3.state.data[index]);
        });
      } else {
        var newData = [].concat(_toConsumableArray(this.state.data));
        newData.splice(index, 1);
        this.setState({
          data: newData
        }, function () {
          _this3.convertDataToValue();
        });
      }
    }
  }, {
    key: 'removeDonViConfirm',
    value: function removeDonViConfirm() {
      var _this4 = this;

      var newData = [].concat(_toConsumableArray(this.state.data));
      newData.splice(this.state.indexConfirm, 1);
      this.setState({
        data: newData
      }, function () {
        _this4.convertDataToValue();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'form',
        { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.addDonVi.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'wrap-input-tt-dvph col-25' },
          _react2.default.createElement(_common.Input, { label: this.props.label, name: this.props.name, placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter', value: this.state.value, onChange: this.onChange.bind(this, 'value'), maxLength: 1000 }),
          _react2.default.createElement('button', { className: 'btn-add-dvph', name: this.props.name, type: 'submit' })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-75 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this5.removeDonVi.bind(_this5, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item.ten
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-60 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this5.removeDonVi.bind(_this5, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item.ten
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-15 mb18 count-dv' },
            'T\u1ED5ng: ',
            this.state.data.length,
            '\xA0',
            this.props.countUnit
          )
        )
      );
    }
  }]);

  return InputList;
}(_react2.default.Component);

InputList.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  confirm: false,
  onRef: function onRef() {},
  countUnit: 'đơn vị',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

exports.default = InputList;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _ttForms = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputListDropDown = function (_React$Component) {
  _inherits(InputListDropDown, _React$Component);

  function InputListDropDown(props, context) {
    _classCallCheck(this, InputListDropDown);

    var _this = _possibleConstructorReturn(this, (InputListDropDown.__proto__ || Object.getPrototypeOf(InputListDropDown)).call(this, props, context));

    _this.state = {
      data: [],
      value: '',
      outputItem: '',
      indexConfirm: ''
    };
    return _this;
  }

  _createClass(InputListDropDown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.convertValueToData(nextProps.data);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.convertValueToData(this.props.data);
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'handleConfirm',
    value: function handleConfirm(data) {
      if (this.props.handleConfirm(data)) {
        //do nothing
      } else {
        this.removeDonViConfirm();
      }
    }
  }, {
    key: 'convertValueToData',
    value: function convertValueToData(data) {
      var _this2 = this;

      var dataResult = [];
      var newCheck = data;
      if (newCheck) {
        newCheck.map(function (state) {
          dataResult[dataResult.length] = {
            ten: state[_this2.props.valueName],
            giaTri: state[_this2.props.keyName]
          };
        });
        this.setState({
          data: [].concat(dataResult)
        });
      } else {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'convertDataToValue',
    value: function convertDataToValue() {
      var e = {
        target: {
          value: [],
          count: this.state.data.length
        }
      };
      this.state.data.map(function (state, i) {
        e.target.value[e.target.value.length] = {
          id: Number(state.giaTri)
        };
      });
      this.props.onChange(e);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var _this3 = this;

      var index = e.nativeEvent.target.selectedIndex;

      var newArr = [].concat(_toConsumableArray(this.state.data));

      var arrCheck = newArr.filter(function (state) {
        return state.giaTri == e.target.value;
      });

      if (arrCheck.length > 0) {
        this.setState({
          value: ''
        });
      } else {
        var newItem = {
          giaTri: e.target.value,
          ten: e.nativeEvent.target[index].text
        };
        this.setState({
          data: [].concat(_toConsumableArray(this.state.data), [newItem]),
          value: '',
          outputItem: e.target.value
        }, function () {
          _this3.convertDataToValue();
          _this3.props.onAddItem(_this3.state.outputItem);
        });
      }
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var _this4 = this;

      if (this.props.confirm) {
        this.setState({
          indexConfirm: index
        }, function () {
          _this4.handleConfirm(_this4.state.data[index]);
        });
      } else {
        var newData = [].concat(_toConsumableArray(this.state.data));
        var itemDelete = this.state.data[index];
        this.props.onRemoveItem(itemDelete.giaTri);
        newData.splice(index, 1);
        this.setState({
          data: newData
        }, function () {
          _this4.convertDataToValue();
        });
      }
    }
  }, {
    key: 'removeDonViConfirm',
    value: function removeDonViConfirm() {
      var _this5 = this;

      var newData = [].concat(_toConsumableArray(this.state.data));
      newData.splice(this.state.indexConfirm, 1);
      this.setState({
        data: newData
      }, function () {
        _this5.convertDataToValue();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'form',
        { className: 'wrap-tt-dvph col-100 no-gutter' },
        _react2.default.createElement(
          'div',
          { className: 'wrap-input-tt-dvph col-25' },
          _react2.default.createElement(_ttForms.DropDownMulipleUse, { label: this.props.label, data: this.props.dataOption, keyName: this.props.keyName, valueName: this.props.valueName, className: 'col-100 no-gutter', selectedValue: this.state.value, onChange: this.onChange.bind(this) })
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-75 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this6.removeDonVi.bind(_this6, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item.ten
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-60 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this6.removeDonVi.bind(_this6, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item.ten
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-15 mb18 count-dv' },
            'T\u1ED5ng: ',
            this.state.data.length,
            '\xA0',
            this.props.countUnit
          )
        )
      );
    }
  }]);

  return InputListDropDown;
}(_react2.default.Component);

InputListDropDown.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  confirm: false,
  onRef: function onRef() {},
  countUnit: 'đơn vị',
  onAddItem: function onAddItem() {},
  onRemoveItem: function onRemoveItem() {},
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

exports.default = InputListDropDown;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MsetTimeout = void 0;

var InputListHasSuggestions = function (_React$Component) {
  _inherits(InputListHasSuggestions, _React$Component);

  function InputListHasSuggestions(props, context) {
    _classCallCheck(this, InputListHasSuggestions);

    var _this = _possibleConstructorReturn(this, (InputListHasSuggestions.__proto__ || Object.getPrototypeOf(InputListHasSuggestions)).call(this, props, context));

    _this.state = {
      data: [],
      dataSuggest: _this.props.dataSuggest,
      value: '',
      valueName: _this.props.valueName,
      keyName: _this.props.keyName,
      isSearch: _this.props.isSearch,
      search: false,
      indexConfirm: ''
    };
    return _this;
  }

  _createClass(InputListHasSuggestions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.convertValueToData(nextProps.data);
      }
      this.setState({
        isSearch: nextProps.isSearch
      });

      if (nextProps.dataSuggest != this.props.dataSuggest) {
        this.setState({
          dataSuggest: nextProps.dataSuggest,
          search: true
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.convertValueToData(this.props.data);
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'handleConfirm',
    value: function handleConfirm(data) {
      if (this.props.handleConfirm(data)) {
        //do nothing
      } else {
        this.removeDonViConfirm();
      }
    }
  }, {
    key: 'convertValueToData',
    value: function convertValueToData(data) {
      var _this2 = this;

      var dataResult = [];
      var newCheck = data;
      if (newCheck) {
        newCheck.map(function (state) {
          var _dataResult$dataResul;

          dataResult[dataResult.length] = (_dataResult$dataResul = {}, _defineProperty(_dataResult$dataResul, _this2.state.keyName, state[_this2.state.keyName]), _defineProperty(_dataResult$dataResul, _this2.state.valueName, state[_this2.state.valueName]), _dataResult$dataResul);
        });
        this.setState({
          data: [].concat(dataResult)
        });
      } else {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'convertDataToValue',
    value: function convertDataToValue() {
      var _this3 = this;

      var e = {
        target: {
          value: [],
          count: this.state.data.length
        }
      };
      this.state.data.map(function (state) {
        e.target.value[e.target.value.length] = {
          id: state[_this3.state.keyName]
        };
      });
      this.props.onChange(e);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var _this4 = this;

      clearTimeout(MsetTimeout);
      this.setState({
        value: e.target.value
      }, function () {
        _this4.handleSuggest();
      });
    }
  }, {
    key: 'handleSuggest',
    value: function handleSuggest() {
      var _this5 = this;

      MsetTimeout = setTimeout(function () {
        if (_this5.state.value) {
          document.addEventListener('click', _this5.handleOutsideClick.bind(_this5), false);
          _this5.props.handleSuggest(_this5.state.value);
        }
      }, 1000);
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(e) {
      clearTimeout(MsetTimeout);
      if (typeof e != 'undefined') {
        e.preventDefault();
      }
      if (this.state.value) {
        document.addEventListener('click', this.handleOutsideClick.bind(this), false);
        this.props.handleSuggest(this.state.value);
      }
      return;
    }
  }, {
    key: 'addDonVi',
    value: function addDonVi(index, e) {
      var _this6 = this;

      var newArr = [].concat(_toConsumableArray(this.state.data));
      var dataSuggest = [].concat(_toConsumableArray(this.state.dataSuggest));

      var itemSelected = dataSuggest[index];

      var arrCheck = newArr.filter(function (state) {
        return state[_this6.state.keyName] == itemSelected[_this6.state.keyName];
      });

      if (arrCheck.length > 0) {} else {
        var _newItem;

        var newItem = (_newItem = {}, _defineProperty(_newItem, this.state.valueName, itemSelected[this.state.valueName]), _defineProperty(_newItem, this.state.keyName, itemSelected[this.state.keyName]), _newItem);
        this.setState({
          data: [].concat(_toConsumableArray(this.state.data), [newItem])
        }, function () {
          _this6.convertDataToValue();
        });
      }
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }
  }, {
    key: 'removeDonVi',
    value: function removeDonVi(index) {
      var _this7 = this;

      if (this.props.confirm) {
        this.setState({
          indexConfirm: index
        }, function () {
          _this7.handleConfirm(_this7.state.data[index]);
        });
      } else {
        var newData = [].concat(_toConsumableArray(this.state.data));
        newData.splice(index, 1);
        this.setState({
          data: newData
        }, function () {
          _this7.convertDataToValue();
        });
      }
    }
  }, {
    key: 'removeDonViConfirm',
    value: function removeDonViConfirm() {
      var _this8 = this;

      var newData = [].concat(_toConsumableArray(this.state.data));
      newData.splice(this.state.indexConfirm, 1);
      this.setState({
        data: newData
      }, function () {
        _this8.convertDataToValue();
      });
    }
  }, {
    key: 'closeOption',
    value: function closeOption() {
      this.setState({
        value: '',
        dataSuggest: [],
        search: false
      });
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }
  }, {
    key: 'handleOutsideClick',
    value: function handleOutsideClick(e) {
      if (this.node && this.node.contains(e.target)) {
        return;
      } else if (this.node && !this.node.contains(e.target)) {
        this.closeOption();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      return _react2.default.createElement(
        'form',
        { className: 'wrap-tt-dvph col-100 no-gutter', onSubmit: this.handleSearch.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'wrap-input-tt-dvph col-25', id: 'node', ref: function ref(node) {
              _this9.node = node;
            } },
          _react2.default.createElement(_common.Input, { label: this.props.label, name: this.props.name, placeholder: 'Nh\u1EADp...', className: 'col-100 no-gutter', value: this.state.value, onChange: this.onChange.bind(this) }),
          _react2.default.createElement('button', { className: this.props.isSearch ? 'btn-search-dvph searching' : 'btn-search-dvph', name: this.props.name, type: 'submit' }),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.dataSuggest.length > 0 },
            _react2.default.createElement(
              'div',
              { className: 'wrap-suggestions' },
              this.state.dataSuggest.map(function (item, i) {
                return _react2.default.createElement(
                  'p',
                  { key: i, className: 'suggestions-item', onClick: _this9.addDonVi.bind(_this9, i) },
                  item[_this9.state.valueName]
                );
              })
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.dataSuggest.length == 0 && this.state.search == true },
            _react2.default.createElement(
              'div',
              { className: 'wrap-suggestions' },
              _react2.default.createElement(
                'p',
                { className: 'suggestions-item' },
                'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
              )
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-75 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this9.removeDonVi.bind(_this9, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item[_this9.state.valueName]
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.hasCount },
          _react2.default.createElement(
            'div',
            { className: 'col-60 mb18' },
            _react2.default.createElement(
              'div',
              { className: 'ds-tt-dvph' },
              this.state.data.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tt-dvph-item', key: i },
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-icon', onClick: _this9.removeDonVi.bind(_this9, i) },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'tt-dvph-value' },
                    item[_this9.state.valueName]
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-15 mb18 count-dv' },
            'T\u1ED5ng: ',
            this.state.data.length,
            '\xA0',
            this.props.countUnit
          )
        )
      );
    }
  }]);

  return InputListHasSuggestions;
}(_react2.default.Component);

InputListHasSuggestions.defaultProps = {
  data: '',
  label: 'This is label',
  hasCount: false,
  dataSuggest: [],
  countUnit: 'đơn vị',
  valueName: '',
  keyName: '',
  confirm: false,
  isSearch: false,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  handleSuggest: function handleSuggest() {
    console.log('Need to assign handleSuggest method');
  }
};

exports.default = InputListHasSuggestions;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

var _validate = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputNumber = function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  function InputNumber(props, context) {
    _classCallCheck(this, InputNumber);

    var _this = _possibleConstructorReturn(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call(this, props, context));

    _this.state = {
      isValid: true,
      value: _this.props.value
    };
    return _this;
  }

  _createClass(InputNumber, [{
    key: 'onChange',
    value: function onChange(e) {
      e.target.value = (0, _validate.PhoneNumber)(e.target.value);

      if (Number(e.target.value) > 99999) {
        e.target.value = this.state.value;
        this.setState({
          value: e.target.value
        });
      } else {
        this.setState({
          value: e.target.value
        });
      }

      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
        if (nextProps.require && nextProps.value != 0 && nextProps.require && nextProps.value != '0') {
          this.setState({
            isValid: true
          });
        }
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (this.state.isValid) {
        return 'pt-input';
      } else {
        return 'pt-input pt-intent-danger';
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      e.target.select();
    }
  }, {
    key: 'nextValue',
    value: function nextValue() {
      if (Number(this.state.value) >= 99999) {
        this.setState({
          value: this.state.value
        });
        var e = {
          target: {
            value: ''
          }
        };
        e.target.value = this.state.value;
        this.props.onChange(e);
      } else {
        var value = Number(this.state.value);
        value = value + 1;
        this.setState({
          value: value
        });
        var _e = {
          target: {
            value: ''
          }
        };
        _e.target.value = value;
        this.props.onChange(_e);
      }
    }
  }, {
    key: 'prevValue',
    value: function prevValue() {
      if (Number(this.state.value) == 0) {
        this.setState({
          value: 0
        });
        var e = {
          target: {
            value: ''
          }
        };
        e.target.value = 0;
        this.props.onChange(e);
      } else {
        var value = Number(this.state.value);
        value = value - 1;
        this.setState({
          value: value
        });
        var _e2 = {
          target: {
            value: ''
          }
        };
        _e2.target.value = value;
        this.props.onChange(_e2);
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if ((this.state.value == 0 || typeof this.state.value == 'string' && this.state.value.trim() == '' || this.props.type == 'sdt' && this.state.value == 0) && this.props.require) {
        this.setState({
          isValid: false
        });
        this.input.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          'label',
          { className: 'ip-label' },
          this.props.label,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.require },
            _react2.default.createElement(
              'span',
              { className: 'text-required' },
              '\xA0*'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-input-number' },
          _react2.default.createElement('span', { className: 'next-value', onClick: this.nextValue.bind(this) }),
          _react2.default.createElement('input', { onFocus: this.handleFocus.bind(this), type: 'text', min: 0, className: this.classNames(), ref: function ref(input) {
              _this2.input = input;
            }, value: this.state.value, onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: this.props.name }),
          _react2.default.createElement(
            'span',
            { className: 'prev-value', onClick: this.prevValue.bind(this) },
            ' '
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.props.require && !this.state.isValid },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return InputNumber;
}(_react2.default.Component);

InputNumber.defaultProps = {
  className: 'input-group',
  label: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: null,
  require: false,
  isValid: false,
  value: 0,
  name: ''
};

exports.default = (0, _utils.validatable)(InputNumber);

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputPassword = function (_React$Component) {
  _inherits(InputPassword, _React$Component);

  function InputPassword(props, context) {
    _classCallCheck(this, InputPassword);

    var _this = _possibleConstructorReturn(this, (InputPassword.__proto__ || Object.getPrototypeOf(InputPassword)).call(this, props, context));

    _this.state = {
      newPassword: _this.props.newPassword || '',
      passwordConfirmation: _this.props.passwordConfirmation || '',
      value: _this.props.value,
      isValid: true
    };
    return _this;
  }

  _createClass(InputPassword, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });

      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
        if (nextProps.require && nextProps.value.trim()) {
          this.setState({
            isValid: true
          });
        }
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (this.state.isValid) {
        return 'pt-input';
      } else {
        return 'pt-input pt-intent-danger';
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.state.value.trim() == '' && this.props.require) {
        this.setState({
          isValid: false
        });
        this.input.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          'label',
          { className: 'ip-label' },
          this.props.label,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.require },
            _react2.default.createElement(
              'span',
              { className: 'text-required' },
              '\xA0*'
            )
          )
        ),
        _react2.default.createElement('input', { type: 'password', className: this.classNames(), ref: function ref(input) {
            _this2.input = input;
          }, maxLength: this.props.maxLength, value: this.state.value, onChange: this.onChange.bind(this), placeholder: this.props.placeholder }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid && this.state.value.trim() == '' },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return InputPassword;
}(_react2.default.Component);

InputPassword.defaultProps = {
  type: '',
  className: 'input-group',
  label: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: null,
  require: false,
  maxLength: 255
};

exports.default = (0, _utils.validatable)(InputPassword);

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputTuKhoa = function (_React$Component) {
  _inherits(InputTuKhoa, _React$Component);

  function InputTuKhoa(props, context) {
    _classCallCheck(this, InputTuKhoa);

    var _this = _possibleConstructorReturn(this, (InputTuKhoa.__proto__ || Object.getPrototypeOf(InputTuKhoa)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      className: _this.props.className
    };
    return _this;
  }

  _createClass(InputTuKhoa, [{
    key: "onChange",
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });
      this.props.onChange(e);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value,
        className: nextProps.className
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      e.target.select();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: this.state.className },
        _react2.default.createElement(
          "label",
          { className: "ip-label" },
          this.props.label
        ),
        _react2.default.createElement("input", { onFocus: this.handleFocus.bind(this), value: this.state.value, type: "text", name: "searchKey", placeholder: this.props.placeholder, className: "search-input", onChange: this.onChange.bind(this) })
      );
    }
  }]);

  return InputTuKhoa;
}(_react2.default.Component);

InputTuKhoa.defaultProps = {
  value: '',
  label: 'Từ khoá',
  placeholder: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function onChange() {
    console.log('Please assign onChange function');
  },
  className: 'input-group-show'
};

exports.default = InputTuKhoa;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton(props, context) {
    _classCallCheck(this, RadioButton);

    var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call(this, props, context));

    _this.state = {
      value: _this.props.selectedValue
    };
    return _this;
  }

  _createClass(RadioButton, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });

      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.selectedValue != nextProps.selectedValue) {
        this.setState({ value: nextProps.selectedValue });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _core.RadioGroup,
        { className: 'radio-gender', onChange: this.onChange.bind(this), selectedValue: this.state.value, disabled: this.props.disable },
        this.props.options.map(function (item, i) {
          return _react2.default.createElement(_core.Radio, { key: i, label: item[_this2.props.valueName],
            value: item[_this2.props.keyName],
            className: _this2.props.itemClass });
        })
      );
    }
  }]);

  return RadioButton;
}(_react2.default.Component);

RadioButton.defaultProps = {
  options: [],
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  selectedValue: '',
  keyName: 'key',
  valueName: 'value',
  itemClass: 'pt-large txt-bold radio-header'
};

exports.default = RadioButton;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = function (_React$Component) {
  _inherits(Text, _React$Component);

  function Text(props, context) {
    _classCallCheck(this, Text);

    var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, props, context));

    _this.state = {
      label: _this.props.label,
      value: _this.props.value,
      red: _this.props.red,
      link: _this.props.link
    };
    return _this;
  }

  _createClass(Text, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.props.onClick();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'label',
          { className: 'pt-label' },
          _react2.default.createElement(
            'span',
            { className: 'val-title-bold' },
            this.props.label
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !this.state.link },
            _react2.default.createElement(
              'span',
              { className: this.state.red ? "val-content-red" : "val-content" },
              String(this.state.value)
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.state.link },
            _react2.default.createElement(
              'span',
              { className: 'val-content txt-blue txt-underline pointer', onClick: this.onClick.bind(this) },
              String(this.state.value)
            )
          )
        )
      );
    }
  }]);

  return Text;
}(_react2.default.Component);

Text.defaultProps = {
  className: 'col-input',
  label: '',
  onClick: function onClick() {},
  value: '',
  red: false,
  link: false
};

exports.default = Text;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _message = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props, context) {
    _classCallCheck(this, TextArea);

    var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props, context));

    _this.state = {
      value: _this.props.value,
      isValid: true
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        value: e.target.value
      });
      if (this.props.triggerOnblur != true) {
        this.props.onChange(e);
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (!this.state.value.trim() && this.props.require) {
        this.setState({
          isValid: false
        });
        this.textarea.focus();
        return false;
      } else {
        this.setState({
          isValid: true
        });
        return true;
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      if (this.props.triggerOnblur == true) {
        this.setState({
          value: e.target.value
        });
        this.props.onChange(e);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
      if (!nextProps.require || nextProps.value) {
        this.setState({
          isValid: true
        });
      }
    }
  }, {
    key: 'classNames',
    value: function classNames() {
      if (!this.state.isValid && !this.state.value.trim() && this.props.require) {
        return 'pt-input pt-intent-danger';
      } else {
        return 'pt-input';
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      e.target.select();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' mb18' },
        _react2.default.createElement(
          'label',
          { className: 'val-title' },
          this.props.label,
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: this.props.require },
            _react2.default.createElement(
              'span',
              { className: 'text-required' },
              '\xA0*'
            )
          )
        ),
        _react2.default.createElement('textarea', { onFocus: this.handleFocus.bind(this), rows: this.props.rows, maxLength: this.props.maxLength,
          ref: function ref(textarea) {
            _this2.textarea = textarea;
          },
          onBlur: this.handleBlur.bind(this),
          className: this.classNames(), value: this.state.value,
          onChange: this.onChange.bind(this), placeholder: this.props.placeholder,
          name: this.props.name }),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.isValid },
          _react2.default.createElement(
            'div',
            { className: 'pt-form-helper-text' },
            _message.msg.messageDefault
          )
        )
      );
    }
  }]);

  return TextArea;
}(_react2.default.Component);

TextArea.defaultProps = {
  className: 'col-100',
  label: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: '',
  require: false,
  triggerOnblur: false,
  rows: 5,
  maxLength: '',
  value: '',
  name: ''
};

exports.default = (0, _utils.validatable)(TextArea);

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};

var TextMessage = function (_React$Component) {
  _inherits(TextMessage, _React$Component);

  function TextMessage(props, context) {
    _classCallCheck(this, TextMessage);

    var _this = _possibleConstructorReturn(this, (TextMessage.__proto__ || Object.getPrototypeOf(TextMessage)).call(this, props, context));

    _this.state = {
      label: _this.props.label,
      value: _this.props.value
    };
    return _this;
  }

  _createClass(TextMessage, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.value != nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
      if (this.state.label != nextProps.label) {
        this.setState({
          label: nextProps.label
        });
      }
    }
  }, {
    key: 'replaceTag',
    value: function replaceTag(tag) {
      return tagsToReplace[tag] || tag;
    }
  }, {
    key: 'safe_tags_replace',
    value: function safe_tags_replace(str) {
      return String(str).replace(/[&<>]/g, this.replaceTag);
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.state.value ? this.safe_tags_replace(this.state.value) : '';
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: 'pt-label' },
          _react2.default.createElement(
            'p',
            { className: 'val-title-bold ' + this.props.labelClass },
            this.state.label
          ),
          _react2.default.createElement('p', { className: 'val-content ' + this.props.contentClass, dangerouslySetInnerHTML: { __html: content.replace(/\n/gi, '<br/>') } })
        )
      );
    }
  }]);

  return TextMessage;
}(_react2.default.Component);

TextMessage.defaultProps = {
  className: 'col-input',
  label: '',
  value: '',
  contentClass: '',
  labelClass: '',
  inline: false
};

exports.default = TextMessage;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCanBoGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonCanBoGiaiQuyet, _React$Component);

  function DropDownChonCanBoGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonCanBoGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonCanBoGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonCanBoGiaiQuyet)).call(this, props, context));

    _this.state = {
      data: [],
      coQuanQuanLyId: _this.props.coQuanQuanLyId,
      vaiTro: _this.props.vaiTro
    };
    return _this;
  }

  _createClass(DropDownChonCanBoGiaiQuyet, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCongChucPhongBan(this.state.coQuanQuanLyId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.coQuanQuanLyId != nextProps.coQuanQuanLyId && nextProps.coQuanQuanLyId) {
        this.setState({
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          vaiTro: nextProps.vaiTro
        });

        this.getCongChucPhongBan(nextProps.coQuanQuanLyId);
      }
    }
  }, {
    key: 'getCongChucPhongBan',
    value: function getCongChucPhongBan(id) {
      var _this2 = this;

      var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      var params = {
        coQuanQuanLyId: id,
        vaiTro: this.state.vaiTro,
        page: 0,
        size: 1000,
        sort: 'ten,desc'
      };
      if (this.props.vaiTro === "CHUYEN_VIEN") {
        params.vaiTro = "CHUYEN_VIEN";
      }
      if (this.props.vaiTro === "PHO_PHONG") {
        params.vaiTro = "TRUONG_PHONG";
        params.congChucHienTaiId = userInfo.id;
        params.isTruongPhong = false;
      }
      if (this.props.vaiTro === "TRUONG_PHONG") {
        params.vaiTro = "TRUONG_PHONG";
        params.isTruongPhong = true;
      }
      _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(function (res) {
        if (_this2.refs.DropDownChonCanBoGiaiQuyet) {
          if (res.data._embedded) {
            _this2.setState({
              data: res.data._embedded.congChucs
            }, function () {
              _this2.props.checkCongChucPhongBan();
            });
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        ref: 'DropDownChonCanBoGiaiQuyet',
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        className: this.props.className,
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        label: this.props.label,
        options: this.state.data,
        keyName: 'congChucId',
        valueName: 'hoVaTen',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        name: this.props.name });
    }
  }]);

  return DropDownChonCanBoGiaiQuyet;
}(_react2.default.Component);

DropDownChonCanBoGiaiQuyet.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  checkCongChucPhongBan: function checkCongChucPhongBan() {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  label: 'Công chức giải quyết',
  coQuanQuanLyId: '',
  vaiTro: 'CHUYEN_VIEN',
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonCanBoGiaiQuyet);

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCanBoXuLy = function (_React$Component) {
  _inherits(DropDownChonCanBoXuLy, _React$Component);

  function DropDownChonCanBoXuLy(props, context) {
    _classCallCheck(this, DropDownChonCanBoXuLy);

    var _this = _possibleConstructorReturn(this, (DropDownChonCanBoXuLy.__proto__ || Object.getPrototypeOf(DropDownChonCanBoXuLy)).call(this, props, context));

    _this.state = {
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonCanBoXuLy, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.phongBanId) this.loadData(this.props.phongBanId);
    }
  }, {
    key: 'loadData',
    value: function loadData(phongBanId) {
      var _this2 = this;

      var getUserInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      var params = {
        coQuanQuanLyId: phongBanId
      };
      if (this.props.vaiTro === "CHUYEN_VIEN") {
        params.vaiTro = "CHUYEN_VIEN";
      }
      if (this.props.vaiTro === "PHO_PHONG") {
        params.vaiTro = "TRUONG_PHONG";
        params.congChucHienTaiId = getUserInfo.id;
        params.isTruongPhong = false;
      }
      if (this.props.vaiTro === "TRUONG_PHONG") {
        params.vaiTro = "TRUONG_PHONG";
        params.isTruongPhong = true;
      }

      _api.DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(function (res) {
        if (typeof res.data._embedded != "undefined") {

          _this2.setState({
            data: res.data._embedded.congChucs
          });
        } else {
          _this2.setState({
            data: []
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.phongBanId != nextProps.phongBanId) {
        if (nextProps.phongBanId) {
          if (typeof this.state.allData[nextProps.phongBanId] != "undefined") {
            this.setState({
              data: this.props.data[nextProps.phongBanId]
            });
          } else {
            this.loadData(nextProps.phongBanId);
          }
        } else {
          this.setState({
            data: []
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        label: this.props.label,
        className: this.props.className,
        options: this.state.data,
        keyName: 'congChucId',
        valueName: 'hoVaTen',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        selectedValue: this.props.selectedValue,
        name: this.props.name });
    }
  }]);

  return DropDownChonCanBoXuLy;
}(_react2.default.Component);

DropDownChonCanBoXuLy.defaultProps = {
  label: 'Công chức xử lý',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonCanBoXuLy);

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCapCoQuanDaGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonCapCoQuanDaGiaiQuyet, _React$Component);

  function DropDownChonCapCoQuanDaGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonCapCoQuanDaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonCapCoQuanDaGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonCapCoQuanDaGiaiQuyet)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonCapCoQuanDaGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getCapCoQuanDaGiaiQuyet.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'capCoQuanDaGiaiQuyet',
              data: res.data && res.data._embedded && res.data._embedded.capCoQuanQuanLies ? res.data._embedded.capCoQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'C\u1EA5p c\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt', selectedValue: this.props.selectedValue, options: this.state.data, keyName: 'capCoQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonCapCoQuanDaGiaiQuyet;
}(_react2.default.Component);

DropDownChonCapCoQuanDaGiaiQuyet.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.capCoQuanDaGiaiQuyet
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonCapCoQuanDaGiaiQuyet);

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCoQuanDaGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonCoQuanDaGiaiQuyet, _React$Component);

  function DropDownChonCoQuanDaGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonCoQuanDaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonCoQuanDaGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonCoQuanDaGiaiQuyet)).call(this, props, context));

    _this.state = {
      loaiCapCoQuanDaGiaiQuyetID: null,
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonCoQuanDaGiaiQuyet, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'loadData',
    value: function loadData(loaiCapCoQuanDaGiaiQuyetID) {
      var _this2 = this;

      var params = {
        capCoQuanQuanLy: loaiCapCoQuanDaGiaiQuyetID
      };
      _api.DuLieuHeThong.actions.getCoQuanDaGiaiQuyet.request(params).then(function (res) {
        if (typeof res.data._embedded != "undefined") {
          // TODO: Use Redux

          _this2.setState({
            data: res.data._embedded.coQuanQuanLies
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.loaiCapCoQuanDaGiaiQuyetID) {
        this.loadData(this.props.loaiCapCoQuanDaGiaiQuyetID);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loaiCapCoQuanDaGiaiQuyetID && this.props.loaiCapCoQuanDaGiaiQuyetID != nextProps.loaiCapCoQuanDaGiaiQuyetID) {
        if (typeof this.state.allData[nextProps.loaiCapCoQuanDaGiaiQuyetID] != "undefined") {
          this.setState({
            data: this.props.data[nextProps.loaiCapCoQuanDaGiaiQuyetID]
          });
        } else {
          this.loadData(nextProps.loaiCapCoQuanDaGiaiQuyetID);
        }
      } else if (nextProps.loaiCapCoQuanDaGiaiQuyetID == '') {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { className: 'col-input ' + (this.state.data.length == 0 ? ' hidden' : ''), selectedValue: this.props.selectedValue, label: 'C\u01A1 quan \u0111\xE3 gi\u1EA3i quy\u1EBFt', require: this.props.require, options: this.state.data, keyName: 'coQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownChonCoQuanDaGiaiQuyet;
}(_react2.default.Component);

DropDownChonCoQuanDaGiaiQuyet.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  selectedValue: ''
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanDaGiaiQuyet
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonCoQuanDaGiaiQuyet);

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonCoQuanTiepNhan = function (_React$Component) {
  _inherits(DropDownChonCoQuanTiepNhan, _React$Component);

  function DropDownChonCoQuanTiepNhan() {
    _classCallCheck(this, DropDownChonCoQuanTiepNhan);

    return _possibleConstructorReturn(this, (DropDownChonCoQuanTiepNhan.__proto__ || Object.getPrototypeOf(DropDownChonCoQuanTiepNhan)).apply(this, arguments));
  }

  _createClass(DropDownChonCoQuanTiepNhan, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        className: this.props.className,
        label: 'C\u01A1 quan ti\u1EBFp nh\u1EADn',
        options: this.props.data,
        keyName: 'coQuanQuanLyId',
        valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        name: this.props.name });
    }
  }]);

  return DropDownChonCoQuanTiepNhan;
}(_react2.default.Component);

DropDownChonCoQuanTiepNhan.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: ''
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.coQuanTiepNhan
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonCoQuanTiepNhan));

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonDanToc = function (_React$Component) {
  _inherits(DropDownChonDanToc, _React$Component);

  function DropDownChonDanToc(props, context) {
    _classCallCheck(this, DropDownChonDanToc);

    var _this = _possibleConstructorReturn(this, (DropDownChonDanToc.__proto__ || Object.getPrototypeOf(DropDownChonDanToc)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonDanToc, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getDanToc.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'danToc',
              data: res.data && res.data._embedded && res.data._embedded.danTocs ? res.data._embedded.danTocs : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _utils.ShowIf,
        { condition: this.props.quocTichID == 1 },
        _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, label: 'D\xE2n t\u1ED9c', options: this.state.data, className: this.props.className, selectedValue: this.props.selectedValue, keyName: 'danTocId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: 'danToc' })
      );
    }
  }]);

  return DropDownChonDanToc;
}(_react2.default.Component);

DropDownChonDanToc.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  quocTichID: '',
  className: 'col-input',
  data: [],
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.danToc
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonDanToc);

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonDonViTTXM = function (_React$Component) {
  _inherits(DropDownChonDonViTTXM, _React$Component);

  function DropDownChonDonViTTXM(props, context) {
    _classCallCheck(this, DropDownChonDonViTTXM);

    var _this = _possibleConstructorReturn(this, (DropDownChonDonViTTXM.__proto__ || Object.getPrototypeOf(DropDownChonDonViTTXM)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(DropDownChonDonViTTXM, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getData(this.props.loaiDon);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loaiDon != nextProps.loaiDon) {
        this.getData(nextProps.loaiDon);
      }
    }
  }, {
    key: 'getData',
    value: function getData(loaiDon) {
      var _this2 = this;

      var params = {
        loaiDon: loaiDon ? loaiDon : null
      };
      _api.DuLieuHeThong.actions.getDonViTTXMNew.request('', params).then(function (res) {
        if (res.data._embedded) {
          _this2.setState({
            data: res.data._embedded ? res.data._embedded.coQuanQuanLies : []
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      return _react2.default.createElement(_common.DropDown, {
        label: "Đơn vị " + lb1,
        bindValidator: this,
        channel: 'formTaoDon',
        selectedValue: this.props.selectedValue,
        require: this.props.require,
        isValid: this.props.isValid,
        options: this.state.data,
        keyName: 'coQuanQuanLyId', valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonDonViTTXM;
}(_react2.default.Component);

DropDownChonDonViTTXM.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonDonViTTXM);

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonDonViChuTri = function (_React$Component) {
  _inherits(DropDownChonDonViChuTri, _React$Component);

  function DropDownChonDonViChuTri(props, context) {
    _classCallCheck(this, DropDownChonDonViChuTri);

    var _this = _possibleConstructorReturn(this, (DropDownChonDonViChuTri.__proto__ || Object.getPrototypeOf(DropDownChonDonViChuTri)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonDonViChuTri, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getDonViChuTri.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViChuTri',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.data != this.props.data) {
        var newData = [].concat(_toConsumableArray(nextProps.data));
        newData = newData.filter(function (item) {
          return item.coQuanQuanLyId != _this3.props.except;
        });

        this.setState({
          data: newData
        });
      }
      if (nextProps.except != this.props.except) {
        var _newData = [].concat(_toConsumableArray(this.props.data));
        _newData = _newData.filter(function (item) {
          return item.coQuanQuanLyId != nextProps.except;
        });

        this.setState({
          data: _newData
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        label: this.props.label,
        options: this.state.data,
        require: this.props.require,
        keyName: 'coQuanQuanLyId',
        valueName: 'ten',
        className: this.props.className,
        onChange: this.onChange.bind(this),
        selectedValue: this.props.selectedValue,
        placeholder: this.props.placeholder,
        isValid: this.props.isValid,
        bindValidator: this,
        channel: 'formTaoDon',
        name: this.props.name });
    }
  }]);

  return DropDownChonDonViChuTri;
}(_react2.default.Component);

DropDownChonDonViChuTri.defaultProps = {
  isValid: false,
  require: false,
  label: 'Đơn vị chủ trì',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  except: '',
  name: '',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.donViChuTri
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonDonViChuTri));

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonDonViThongKe = function (_React$Component) {
  _inherits(DropDownChonDonViThongKe, _React$Component);

  function DropDownChonDonViThongKe(props, context) {
    _classCallCheck(this, DropDownChonDonViThongKe);

    var _this = _possibleConstructorReturn(this, (DropDownChonDonViThongKe.__proto__ || Object.getPrototypeOf(DropDownChonDonViThongKe)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonDonViThongKe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getDonViThongKe.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'donViThongKe',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var dataOptions = this.props.isAll ? [{ coQuanQuanLyId: 0, ten: 'Chọn tất cả' }].concat(_toConsumableArray(this.state.data)) : [].concat(_toConsumableArray(this.state.data));

      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: dataOptions, keyName: 'coQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonDonViThongKe;
}(_react2.default.Component);

DropDownChonDonViThongKe.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: '',
  label: 'Đơn vị',
  data: [],
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.donViThongKe
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonDonViThongKe));

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonHinhThucDaGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonHinhThucDaGiaiQuyet, _React$Component);

  function DropDownChonHinhThucDaGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonHinhThucDaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonHinhThucDaGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonHinhThucDaGiaiQuyet)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonHinhThucDaGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getHinhThucDaGiaiQuyet.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'hinhThucDaGiaiQuyet',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'H\xECnh th\u1EE9c \u0111\xE3 gi\u1EA3i quy\u1EBFt', require: this.props.require, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, selectedValue: this.props.selectedValue });
    }
  }]);

  return DropDownChonHinhThucDaGiaiQuyet;
}(_react2.default.Component);

DropDownChonHinhThucDaGiaiQuyet.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.hinhThucDaGiaiQuyet
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonHinhThucDaGiaiQuyet);

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonHuongXuLy = function (_React$Component) {
  _inherits(DropDownChonHuongXuLy, _React$Component);

  function DropDownChonHuongXuLy(props, context) {
    _classCallCheck(this, DropDownChonHuongXuLy);

    var _this = _possibleConstructorReturn(this, (DropDownChonHuongXuLy.__proto__ || Object.getPrototypeOf(DropDownChonHuongXuLy)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(DropDownChonHuongXuLy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getData();
    }
  }, {
    key: 'getData',
    value: function getData() {
      var _this2 = this;

      _api.Reception.actions.getHuongXuLyTCD.request(null, {}).then(function (res) {
        if (_this2.refs.chonHXL) {
          if (res.data) {
            if (_this2.props.type == 'them-moi' || _this2.props.type == 'chinh-sua') {
              res.data = res.data.filter(function (item) {
                return item.giaTri != 'BO_SUNG_THONG_TIN';
              });
            }
            _this2.setState({ data: res.data });
          } else {
            _this2.setState({ data: [] });
          }
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'H\u01B0\u1EDBng x\u1EED l\xFD', options: this.state.data,
        keyName: 'giaTri', valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        require: this.props.require,
        selectedValue: this.props.selected,
        bindValidator: this,
        channel: 'formTaoDon',
        ref: 'chonHXL',
        isValid: this.props.isValid,
        name: 'dropdownChonXuLy' });
    }
  }]);

  return DropDownChonHuongXuLy;
}(_react2.default.Component);

DropDownChonHuongXuLy.defaultProps = {
  type: '',
  isValid: false,
  require: false,
  selected: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonHuongXuLy));

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonHuongXuLyLanhDaoRequire = function (_React$Component) {
  _inherits(DropDownChonHuongXuLyLanhDaoRequire, _React$Component);

  function DropDownChonHuongXuLyLanhDaoRequire(props, context) {
    _classCallCheck(this, DropDownChonHuongXuLyLanhDaoRequire);

    var _this = _possibleConstructorReturn(this, (DropDownChonHuongXuLyLanhDaoRequire.__proto__ || Object.getPrototypeOf(DropDownChonHuongXuLyLanhDaoRequire)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonHuongXuLyLanhDaoRequire, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getHuongGiaiQuyetLD.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'huongGiaiQuyetCuaLanhDao',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      if (this.props.require) {} else {
        this.props.onChange(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'H\u01B0\u1EDBng x\u1EED l\xFD', options: this.state.data, keyName: 'giaTri', valueName: 'ten',
        onChange: this.onChange.bind(this),
        require: this.props.require,
        selectedValue: this.props.selected,
        isValid: this.props.isValid,
        name: this.props.name });
    }
  }]);

  return DropDownChonHuongXuLyLanhDaoRequire;
}(_react2.default.Component);

DropDownChonHuongXuLyLanhDaoRequire.defaultProps = {
  selected: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  name: '',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.huongGiaiQuyetCuaLanhDao
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonHuongXuLyLanhDaoRequire);

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonHuongXuLyTheoDon = function (_React$Component) {
  _inherits(DropDownChonHuongXuLyTheoDon, _React$Component);

  function DropDownChonHuongXuLyTheoDon(props, context) {
    _classCallCheck(this, DropDownChonHuongXuLyTheoDon);

    var _this = _possibleConstructorReturn(this, (DropDownChonHuongXuLyTheoDon.__proto__ || Object.getPrototypeOf(DropDownChonHuongXuLyTheoDon)).call(this, props, context));

    _this.state = {
      updated: false,
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonHuongXuLyTheoDon, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadData(this.props.donId, this.props.loaiDon);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loaiDon != nextProps.loaiDon) {
        this.loadData(nextProps.donId, nextProps.loaiDon);
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(donId, loaiDon) {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getHuongXuLyTheoDon.request({ donId: donId, loaiDon: loaiDon }).then(function (res) {

        if (typeof res.data != "undefined") {
          // TODO: Use Redux

          _this2.setState({
            data: res.data
          });
        } else {
          _this2.setState({
            data: []
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        label: 'H\u01B0\u1EDBng x\u1EED l\xFD',
        options: this.state.data,
        keyName: 'giaTri',
        valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        className: this.props.className,
        name: this.props.name });
    }
  }]);

  return DropDownChonHuongXuLyTheoDon;
}(_react2.default.Component);

DropDownChonHuongXuLyTheoDon.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonHuongXuLyTheoDon);

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonKetLuanNoiDungKhieuNai = function (_React$Component) {
  _inherits(DropDownChonKetLuanNoiDungKhieuNai, _React$Component);

  function DropDownChonKetLuanNoiDungKhieuNai(props, context) {
    _classCallCheck(this, DropDownChonKetLuanNoiDungKhieuNai);

    var _this = _possibleConstructorReturn(this, (DropDownChonKetLuanNoiDungKhieuNai.__proto__ || Object.getPrototypeOf(DropDownChonKetLuanNoiDungKhieuNai)).call(this, props, context));

    _this.state = {
      data: [],
      loaiDon: _this.props.loaiDon
    };
    return _this;
  }

  _createClass(DropDownChonKetLuanNoiDungKhieuNai, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getListData(this.state.loaiDon);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loaiDon != nextProps.loaiDon) {
        this.getListData(nextProps.loaiDon);
      }
    }
  }, {
    key: 'getListData',
    value: function getListData(loaiDon) {
      var _this2 = this;

      var params = {
        loaiDon: loaiDon
      };
      _api.DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request(params).then(function (res) {
        if (_this2.refs.DropDownChonKetLuanNoiDungKhieuNai && res.data) {
          _this2.setState({
            data: res.data
          });
        };
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { ref: 'DropDownChonKetLuanNoiDungKhieuNai', label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonKetLuanNoiDungKhieuNai;
}(_react2.default.Component);

DropDownChonKetLuanNoiDungKhieuNai.defaultProps = {
  className: 'input-group',
  loaiDon: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: "Kết luận nội dung khiếu nại",
  name: 'dropdownChonKetLuanNoiDungGiaoTTXM'
};

exports.default = (0, _utils.validatable)(DropDownChonKetLuanNoiDungKhieuNai);

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonKetQuaGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonKetQuaGiaiQuyet, _React$Component);

  function DropDownChonKetQuaGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonKetQuaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonKetQuaGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonKetQuaGiaiQuyet)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonKetQuaGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getKetQuaGiaiQuyetLanHai.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'ketQuaGiaiQuyetLanHai',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, isValid: this.props.isValid, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className });
    }
  }]);

  return DropDownChonKetQuaGiaiQuyet;
}(_react2.default.Component);

DropDownChonKetQuaGiaiQuyet.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  label: 'Kết quả giải quyết',
  isValid: false,
  require: false,
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.ketQuaGiaiQuyetLanHai
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonKetQuaGiaiQuyet));

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonKetQuaThucHien = function (_React$Component) {
  _inherits(DropDownChonKetQuaThucHien, _React$Component);

  function DropDownChonKetQuaThucHien() {
    _classCallCheck(this, DropDownChonKetQuaThucHien);

    return _possibleConstructorReturn(this, (DropDownChonKetQuaThucHien.__proto__ || Object.getPrototypeOf(DropDownChonKetQuaThucHien)).apply(this, arguments));
  }

  _createClass(DropDownChonKetQuaThucHien, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'K\u1EBFt qu\u1EA3 th\u1EF1c hi\u1EC7n', isValid: this.props.isValid, bindValidator: this, channel: 'formTaoDon', require: this.props.require, selectedValue: this.props.selectedValue, options: this.props.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: 'dropdownChonKetQuaThucHien' });
    }
  }]);

  return DropDownChonKetQuaThucHien;
}(_react2.default.Component);

DropDownChonKetQuaThucHien.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.ketQuaThucHien
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonKetQuaThucHien));

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonKetQuaXuLy = function (_React$Component) {
  _inherits(DropDownChonKetQuaXuLy, _React$Component);

  function DropDownChonKetQuaXuLy() {
    _classCallCheck(this, DropDownChonKetQuaXuLy);

    return _possibleConstructorReturn(this, (DropDownChonKetQuaXuLy.__proto__ || Object.getPrototypeOf(DropDownChonKetQuaXuLy)).apply(this, arguments));
  }

  _createClass(DropDownChonKetQuaXuLy, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, options: this.props.data, keyName: 'giaTri', valueName: 'ten',
        onChange: this.onChange.bind(this), placeholder: true, className: this.props.className });
    }
  }]);

  return DropDownChonKetQuaXuLy;
}(_react2.default.Component);

DropDownChonKetQuaXuLy.defaultProps = {
  label: 'Tình trạng xử lý',
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.huongXuLyDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonKetQuaXuLy);

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonKyThanhTra = function (_React$Component) {
  _inherits(DropDownChonKyThanhTra, _React$Component);

  function DropDownChonKyThanhTra() {
    _classCallCheck(this, DropDownChonKyThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonKyThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonKyThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonKyThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.props.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonKyThanhTra;
}(_react2.default.Component);

DropDownChonKyThanhTra.defaultProps = {
  className: 'input-group',
  label: 'Kỳ thanh tra',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: ''
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: [{ giaTri: 2015, ten: '2015' }, { giaTri: 2016, ten: '2016' }, { giaTri: 2017, ten: '2017' }, { giaTri: 2018, ten: '2018' }, { giaTri: 2019, ten: '2019' }, { giaTri: 2020, ten: '2020' }]
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonKyThanhTra));

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLinhVucDonThu = function (_React$Component) {
  _inherits(DropDownChonLinhVucDonThu, _React$Component);

  function DropDownChonLinhVucDonThu(props, context) {
    _classCallCheck(this, DropDownChonLinhVucDonThu);

    var _this = _possibleConstructorReturn(this, (DropDownChonLinhVucDonThu.__proto__ || Object.getPrototypeOf(DropDownChonLinhVucDonThu)).call(this, props, context));

    _this.state = {
      loaiDonThuID: null,
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonLinhVucDonThu, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'loadData',
    value: function loadData(loaiDonThuID) {
      var _this2 = this;

      var params = {
        cha: 'null',
        loaiDon: loaiDonThuID
      };
      _api.DuLieuHeThong.actions.getLinhVucDonThu.request(params).then(function (res) {
        if (typeof res.data._embedded != "undefined") {
          // TODO: Use Redux

          _this2.setState({
            data: res.data._embedded.linhVucDonThus
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loaiDonThuID != nextProps.loaiDonThuID) {
        if (nextProps.loaiDonThuID) {
          this.loadData(nextProps.loaiDonThuID);
        } else {
          this.setState({
            data: []
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { className: this.props.className + ('' + (this.state.data.length == 0 && this.props.allowHidden ? ' hidden' : '')), selectedValue: this.props.selectedValue, label: 'L\u0129nh v\u1EF1c', require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'linhVucDonThuId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, bindValidator: this, channel: 'formTaoDon', name: this.props.name });
    }
  }]);

  return DropDownChonLinhVucDonThu;
}(_react2.default.Component);

DropDownChonLinhVucDonThu.defaultProps = {
  allowHidden: true,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...',
    name: ''
  },
  className: "col-input"
};

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLinhVucDonThu));

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLinhVucDonThuChiTiet = function (_React$Component) {
  _inherits(DropDownChonLinhVucDonThuChiTiet, _React$Component);

  function DropDownChonLinhVucDonThuChiTiet(props, context) {
    _classCallCheck(this, DropDownChonLinhVucDonThuChiTiet);

    var _this = _possibleConstructorReturn(this, (DropDownChonLinhVucDonThuChiTiet.__proto__ || Object.getPrototypeOf(DropDownChonLinhVucDonThuChiTiet)).call(this, props, context));

    _this.state = {
      linhVucDonThuID: null,
      loaiDonThuID: null,
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonLinhVucDonThuChiTiet, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'loadData',
    value: function loadData(linhVucDonThuID, loaiDonThuID) {
      var _this2 = this;

      var params = {
        cha: linhVucDonThuID,
        loaiDon: loaiDonThuID
      };
      _api.DuLieuHeThong.actions.getLinhVucDonThu.request(params).then(function (res) {
        if (typeof res.data._embedded != "undefined") {
          // TODO: Use Redux

          _this2.setState({
            data: res.data._embedded.linhVucDonThus
          });
        } else {
          _this2.setState({
            data: []
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.linhVucDonThuID && this.props.linhVucDonThuID != nextProps.linhVucDonThuID) {
        if (typeof this.state.allData[nextProps.linhVucDonThuID] != "undefined") {
          this.setState({
            data: this.props.data[nextProps.linhVucDonThuID]
          });
        } else {
          this.loadData(nextProps.linhVucDonThuID, nextProps.loaiDonThuID);
        }
      } else if (nextProps.linhVucDonThuID == '' || nextProps.loaiDonThuID == '') {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.state.data.length > 0 || !this.props.allowHidden ? _react2.default.createElement(_common.DropDown, {
          className: this.props.className,
          selectedValue: this.props.selectedValue,
          label: this.props.label,
          bindValidator: this,
          channel: 'formTaoDon',
          require: this.props.require,
          options: this.state.data,
          keyName: 'linhVucDonThuId',
          valueName: 'ten',
          onChange: this.onChange.bind(this),
          placeholder: this.props.placeholder,
          name: this.props.name
        }) : ''
      );
    }
  }]);

  return DropDownChonLinhVucDonThuChiTiet;
}(_react2.default.Component);

DropDownChonLinhVucDonThuChiTiet.defaultProps = {
  allowHidden: true,
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  label: 'Lĩnh vực chi tiết',
  className: "col-input",
  name: ''
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.capQuanHuyen
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLinhVucDonThuChiTiet));

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiDoiTuong = function (_React$Component) {
  _inherits(DropDownChonLoaiDoiTuong, _React$Component);

  function DropDownChonLoaiDoiTuong(props, context) {
    _classCallCheck(this, DropDownChonLoaiDoiTuong);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiDoiTuong.__proto__ || Object.getPrototypeOf(DropDownChonLoaiDoiTuong)).call(this, props, context));

    _this.state = {
      loaiDonThuID: null,
      data: []
    };
    return _this;
  }

  _createClass(DropDownChonLoaiDoiTuong, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'loadData',
    value: function loadData(loaiDonThuID) {
      var _this2 = this;

      var params = {
        loaiDonThu: loaiDonThuID
      };
      _api.DuLieuHeThong.actions.getLoaiDoiTuong.request(params).then(function (res) {
        if (res.data) {
          // TODO: Use Redux

          _this2.setState({
            data: res.data
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loaiDonThuID != nextProps.loaiDonThuID) {
        if (nextProps.loaiDonThuID) {
          this.loadData(nextProps.loaiDonThuID);
        } else {
          this.setState({
            data: []
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.loaiDonThuID == 'DON_TO_CAO' ? 'Đối tượng bị tố cáo' : 'Loại đối tượng', require: this.props.require, selectedValue: this.props.selectedValue, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'input-group ' + this.props.className, bindValidator: this, channel: 'formTaoDon', name: this.props.name });
    }
  }]);

  return DropDownChonLoaiDoiTuong;
}(_react2.default.Component);

DropDownChonLoaiDoiTuong.defaultProps = {
  className: '',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...',
    name: ''
  }
};

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiDoiTuong));

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiDoiTuongThanhTra = function (_React$Component) {
  _inherits(DropDownChonLoaiDoiTuongThanhTra, _React$Component);

  function DropDownChonLoaiDoiTuongThanhTra() {
    _classCallCheck(this, DropDownChonLoaiDoiTuongThanhTra);

    return _possibleConstructorReturn(this, (DropDownChonLoaiDoiTuongThanhTra.__proto__ || Object.getPrototypeOf(DropDownChonLoaiDoiTuongThanhTra)).apply(this, arguments));
  }

  _createClass(DropDownChonLoaiDoiTuongThanhTra, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.props.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonLoaiDoiTuongThanhTra;
}(_react2.default.Component);

DropDownChonLoaiDoiTuongThanhTra.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: "Kết luận nội dung khiếu nại",
  name: 'dropdownChonKetLuanNoiDungGiaoTTXM'
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: [{ giaTri: 'Tổ chức', ten: 'Tổ chức' }, { giaTri: 'Cá nhân', ten: 'Cá nhân' }]
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiDoiTuongThanhTra));

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiDonThu = function (_React$Component) {
  _inherits(DropDownChonLoaiDonThu, _React$Component);

  function DropDownChonLoaiDonThu(props, context) {
    _classCallCheck(this, DropDownChonLoaiDonThu);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiDonThu.__proto__ || Object.getPrototypeOf(DropDownChonLoaiDonThu)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(DropDownChonLoaiDonThu, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isTraCuu === true) {
        this.getNewLoaiDonThu();
      } else if (this.props.isDonCu === true) {
        this.getNewLoaiDonThuCu();
      } else {
        this.setState({ data: this.props.data });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data && this.props.isTraCuu === false) {
        this.getNewLoaiDonThuCu();
      }
    }
  }, {
    key: 'getNewLoaiDonThu',
    value: function getNewLoaiDonThu() {
      var _this2 = this;

      var state = this.state;
      _api.Reception.actions.getLoaiDonThu.request(null, { isTraCuu: this.props.isTraCuu }).then(function (res) {
        if (res.data) {
          var loaiDon = res.data;
          // loaiDon = loaiDon.filter(item => item.giaTri !== "DON_TO_CAO");
          state.data = loaiDon;
        } else {
          state.data = [];
        }
        _this2.setState({ state: state });
      });
    }
  }, {
    key: 'getNewLoaiDonThuCu',
    value: function getNewLoaiDonThuCu() {
      var _this3 = this;

      var state = this.state;
      _api.Reception.actions.getLoaiDonThu.request(null, { isDonCu: this.props.isDonCu }).then(function (res) {
        if (res.data) {
          var loaiDonThu = res.data;
          if (_this3.props.page === 'trangChu') {
            loaiDonThu = loaiDonThu.filter(function (item) {
              return item.giaTri !== 'DON_TRANH_CHAP_DAT' && item.giaTri !== "DON_KIEN_NGHI_PHAN_ANH";
            });
          }
          state.data = loaiDonThu;
        } else {
          state.data = [];
        }
        _this3.setState({ state: state });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        label: this.props.label,
        selectedValue: this.props.selectedValue,
        require: this.props.require,
        isValid: this.props.isValid,
        options: this.state.data,
        keyName: 'giaTri',
        valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        className: this.props.className,
        bindValidator: this, channel: 'formTaoDon',
        name: this.props.name });
    }
  }]);

  return DropDownChonLoaiDonThu;
}(_react2.default.Component);

DropDownChonLoaiDonThu.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  label: 'Phân loại đơn',
  selectedValue: '',
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: '',
  data: [],
  isTraCuu: false,
  isDonCu: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.loaiDonThu
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiDonThu));

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiKyThongKe = function (_React$Component) {
  _inherits(DropDownChonLoaiKyThongKe, _React$Component);

  function DropDownChonLoaiKyThongKe(props, context) {
    _classCallCheck(this, DropDownChonLoaiKyThongKe);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiKyThongKe.__proto__ || Object.getPrototypeOf(DropDownChonLoaiKyThongKe)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonLoaiKyThongKe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getLoaiThongKe.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'loaiKyThongKe',
              data: res.data.map(function (item) {
                return {
                  giaTri: item.value,
                  ten: item.label
                };
              }) || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonLoaiKyThongKe;
}(_react2.default.Component);

DropDownChonLoaiKyThongKe.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: '',
  label: 'Kỳ báo cáo',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.loaiKyThongKe
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiKyThongKe));

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiNamThongKe = function (_React$Component) {
  _inherits(DropDownChonLoaiNamThongKe, _React$Component);

  function DropDownChonLoaiNamThongKe(props, context) {
    _classCallCheck(this, DropDownChonLoaiNamThongKe);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiNamThongKe.__proto__ || Object.getPrototypeOf(DropDownChonLoaiNamThongKe)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonLoaiNamThongKe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getNamThongKe.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'namThongKe',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonLoaiNamThongKe;
}(_react2.default.Component);

DropDownChonLoaiNamThongKe.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: '',
  label: 'Năm',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.namThongKe
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiNamThongKe));

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiQuyThongKe = function (_React$Component) {
  _inherits(DropDownChonLoaiQuyThongKe, _React$Component);

  function DropDownChonLoaiQuyThongKe(props, context) {
    _classCallCheck(this, DropDownChonLoaiQuyThongKe);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiQuyThongKe.__proto__ || Object.getPrototypeOf(DropDownChonLoaiQuyThongKe)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonLoaiQuyThongKe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getLoaiQuyThongKe.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'loaiQuyThongKe',
              data: res.data.map(function (item) {
                return {
                  giaTri: item.value,
                  ten: item.label
                };
              }) || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonLoaiQuyThongKe;
}(_react2.default.Component);

DropDownChonLoaiQuyThongKe.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: '',
  label: 'Quý',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.loaiQuyThongKe
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiQuyThongKe));

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonLoaiThangThongKe = function (_React$Component) {
  _inherits(DropDownChonLoaiThangThongKe, _React$Component);

  function DropDownChonLoaiThangThongKe(props, context) {
    _classCallCheck(this, DropDownChonLoaiThangThongKe);

    var _this = _possibleConstructorReturn(this, (DropDownChonLoaiThangThongKe.__proto__ || Object.getPrototypeOf(DropDownChonLoaiThangThongKe)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonLoaiThangThongKe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getThangThongKe.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'thangThongKe',
              data: res.data.map(function (item) {
                return {
                  giaTri: item.value,
                  ten: item.label
                };
              }) || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonLoaiThangThongKe;
}(_react2.default.Component);

DropDownChonLoaiThangThongKe.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: '',
  label: 'Tháng',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.thangThongKe
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonLoaiThangThongKe));

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonNganhLinhVuc = function (_React$Component) {
  _inherits(DropDownChonNganhLinhVuc, _React$Component);

  function DropDownChonNganhLinhVuc() {
    _classCallCheck(this, DropDownChonNganhLinhVuc);

    return _possibleConstructorReturn(this, (DropDownChonNganhLinhVuc.__proto__ || Object.getPrototypeOf(DropDownChonNganhLinhVuc)).apply(this, arguments));
  }

  _createClass(DropDownChonNganhLinhVuc, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, bindValidator: this, channel: 'formTaoDon', selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.props.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonNganhLinhVuc;
}(_react2.default.Component);

DropDownChonNganhLinhVuc.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: "Kết luận nội dung khiếu nại",
  name: 'dropdownChonKetLuanNoiDungGiaoTTXM'
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: [{ giaTri: 'Dệt may', ten: 'Dệt may' }, { giaTri: 'Điện', ten: 'Điện' }, { giaTri: 'Vui chơi, giải trí', ten: 'Vui chơi, giải trí' }, { giaTri: 'Thể thao', ten: 'Thể thao' }]
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonNganhLinhVuc));

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonNguonDon = function (_React$Component) {
  _inherits(DropDownChonNguonDon, _React$Component);

  function DropDownChonNguonDon(props, context) {
    _classCallCheck(this, DropDownChonNguonDon);

    var _this = _possibleConstructorReturn(this, (DropDownChonNguonDon.__proto__ || Object.getPrototypeOf(DropDownChonNguonDon)).call(this, props, context));

    _this.state = {
      dataNguonDon: []
    };
    return _this;
  }

  _createClass(DropDownChonNguonDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.LetterProcessingWorkFlow.actions.getNguonDon.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'nguonDon',
              data: res.data
            }]
          });
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data && nextProps.data.length) {
        var data = [];
        if (this.props.exceptNguonDon) {
          var arrExceptNguonDon = this.props.exceptNguonDon.split(",").map(String);
          this.state.dataNguonDon = [];
          nextProps.data.map(function (item, i) {

            var exist = false;

            arrExceptNguonDon.map(function (child) {
              if (child == item.giaTri) exist = true;
            });

            if (!exist) data.push(item);
          });
        } else {
          data = nextProps.data;
        }

        this.setState({ dataNguonDon: data });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'Ngu\u1ED3n \u0111\u01A1n',
        name: this.props.name,
        bindValidator: this,
        channel: 'formTaoDon',
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        options: this.state.dataNguonDon,
        keyName: 'giaTri', valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: true,
        className: this.props.className });
    }
  }]);

  return DropDownChonNguonDon;
}(_react2.default.Component);

DropDownChonNguonDon.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  name: 'nguonDon',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.nguonDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonNguonDon));

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonNhomThamQuyenGiaiQuyet = function (_React$Component) {
  _inherits(DropDownChonNhomThamQuyenGiaiQuyet, _React$Component);

  function DropDownChonNhomThamQuyenGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownChonNhomThamQuyenGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownChonNhomThamQuyenGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownChonNhomThamQuyenGiaiQuyet)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonNhomThamQuyenGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getNhomThamQuyenCombobox.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'nhomThamQuyenGiaiQuyet',
              data: res.data && res.data._embedded && res.data._embedded.thamQuyenGiaiQuyets ? res.data._embedded.thamQuyenGiaiQuyets : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var filterDataThamQuyen = function filterDataThamQuyen(data) {
        if (_this3.props.filterThamQuyenGiaiQuyet) {
          var newData = data.filter(function (item) {
            return item.ten === 'Khác' || item.ten === 'Hành chính';
          });
          var result = newData.map(function (item) {
            if (item.ten === 'Hành chính') {
              return _extends({}, item, {
                ten: 'Đơn vị trong hệ thống',
                moTa: 'Đơn vị trong hệ thống'
              });
            }
            return item;
          });
          return result;
        }
        return data;
      };
      var getLabel = function getLabel() {
        if (_this3.props.filterThamQuyenGiaiQuyet) {
          return 'Đơn vị nhận';
        }
        return _this3.props.label;
      };
      return _react2.default.createElement(_common.DropDown, {
        checkValidate: this.props.checkValidate,
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        selectedValue: this.props.selectedValue,
        label: getLabel(),
        options: filterDataThamQuyen(this.state.data),
        keyName: 'thamQuyenGiaiQuyetId',
        valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        className: this.props.className,
        name: this.props.name
      });
    }
  }]);

  return DropDownChonNhomThamQuyenGiaiQuyet;
}(_react2.default.Component);

DropDownChonNhomThamQuyenGiaiQuyet.defaultProps = {
  label: "Nhóm thẩm quyền đã giải quyết",
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: '',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.nhomThamQuyenGiaiQuyet
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonNhomThamQuyenGiaiQuyet));

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonPhongBanThuocCoQuan = function (_React$Component) {
  _inherits(DropDownChonPhongBanThuocCoQuan, _React$Component);

  function DropDownChonPhongBanThuocCoQuan(props, context) {
    _classCallCheck(this, DropDownChonPhongBanThuocCoQuan);

    var _this = _possibleConstructorReturn(this, (DropDownChonPhongBanThuocCoQuan.__proto__ || Object.getPrototypeOf(DropDownChonPhongBanThuocCoQuan)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonPhongBanThuocCoQuan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        var userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
        var params = {
          phongBanHienTaiId: userInfo.coQuanQuanLyId
        };
        _api.DuLieuHeThong.actions.getPhongBanThuocCoQuan.request(params).then(function (res) {
          var data = res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : [];
          if (_this2.props.isOther === true) {
            data = data.filter(function (item) {
              return item.coQuanQuanLyId !== _this2.props.phongBanGiaiQuyet;
            });
          }
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'phongBanThuocCoQuan',
              data: data
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        require: this.props.require,
        className: this.props.className,
        label: this.props.label,
        options: this.state.data,
        keyName: 'coQuanQuanLyId',
        valueName: 'ten',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        selectedValue: this.props.selectedValue,
        name: this.props.name });
    }
  }]);

  return DropDownChonPhongBanThuocCoQuan;
}(_react2.default.Component);

DropDownChonPhongBanThuocCoQuan.defaultProps = {
  label: "Phòng ban",
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: '',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.phongBanThuocCoQuan
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonPhongBanThuocCoQuan));

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonQuyTrinhGiaiQuyetDon = function (_React$Component) {
  _inherits(DropDownChonQuyTrinhGiaiQuyetDon, _React$Component);

  function DropDownChonQuyTrinhGiaiQuyetDon(props, context) {
    _classCallCheck(this, DropDownChonQuyTrinhGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (DropDownChonQuyTrinhGiaiQuyetDon.__proto__ || Object.getPrototypeOf(DropDownChonQuyTrinhGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      data: [],
      id: _this.props.donId,
      selectedValue: _this.props.selectedValue
    };
    return _this;
  }

  _createClass(DropDownChonQuyTrinhGiaiQuyetDon, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCurrentForm();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.id != nextProps.donId && nextProps.donId) {
        this.setState({
          id: nextProps.donId,
          selectedValue: nextProps.selectedValue
        });
      }
    }
  }, {
    key: 'getCurrentForm',
    value: function getCurrentForm() {
      var _this2 = this;

      var params = {};
      if (this.props.loaiDon) {
        params.loaiDon = this.props.loaiDon;
      }
      _api.LetterProcessingWorkFlow.actions.getTrangThaiTTXM.request(null, params).then(function (res) {
        _this2.setState({
          data: res.data || []
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _utils.ShowIf,
        { condition: this.state.data.length > 1 },
        _react2.default.createElement(_common.DropDown, { bindValidator: this,
          className: this.props.className,
          channel: 'formTaoDon',
          label: 'Quy tr\xECnh gi\u1EA3i quy\u1EBFt',
          selectedValue: this.props.selectedValue,
          require: this.props.require,
          isValid: this.props.isValid,
          options: this.state.data,
          keyName: 'giaTri',
          valueName: 'ten',
          onChange: this.onChange.bind(this),
          placeholder: this.props.placeholder,
          name: this.props.name })
      );
    }
  }]);

  return DropDownChonQuyTrinhGiaiQuyetDon;
}(_react2.default.Component);

DropDownChonQuyTrinhGiaiQuyetDon.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonQuyTrinhGiaiQuyetDon);

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonStateXuLyDon = function (_React$Component) {
  _inherits(DropDownChonStateXuLyDon, _React$Component);

  function DropDownChonStateXuLyDon(props, context) {
    _classCallCheck(this, DropDownChonStateXuLyDon);

    var _this = _possibleConstructorReturn(this, (DropDownChonStateXuLyDon.__proto__ || Object.getPrototypeOf(DropDownChonStateXuLyDon)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonStateXuLyDon, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.coQuanQuanLyId != nextProps.coQuanQuanLyId && nextProps.coQuanQuanLyId) {
        this.setState({
          coQuanQuanLyId: nextProps.coQuanQuanLyId,
          vaiTro: nextProps.vaiTro
        });

        this.getCongChucPhongBan(nextProps.coQuanQuanLyId);
      }
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formTaoDon',
        isValid: this.props.isValid,
        className: this.props.className,
        require: this.props.require,
        selectedValue: this.props.value,
        label: this.props.label,
        options: this.state.data,
        keyName: 'type',
        valueName: 'tenVietTat',
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        name: this.props.name });
    }
  }]);

  return DropDownChonStateXuLyDon;
}(_react2.default.Component);

DropDownChonStateXuLyDon.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  label: 'Hướng xử lý',
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownChonStateXuLyDon);

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonTinhTrangTaiLieu = function (_React$Component) {
  _inherits(DropDownChonTinhTrangTaiLieu, _React$Component);

  function DropDownChonTinhTrangTaiLieu(props, context) {
    _classCallCheck(this, DropDownChonTinhTrangTaiLieu);

    var _this = _possibleConstructorReturn(this, (DropDownChonTinhTrangTaiLieu.__proto__ || Object.getPrototypeOf(DropDownChonTinhTrangTaiLieu)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonTinhTrangTaiLieu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'tinhTrangTaiLieuList',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, selectedValue: this.props.selectedValue, require: this.props.require, isValid: this.props.isValid, options: this.state.data, keyName: 'giaTri', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, className: 'col-input ' + this.props.className, name: this.props.name });
    }
  }]);

  return DropDownChonTinhTrangTaiLieu;
}(_react2.default.Component);

DropDownChonTinhTrangTaiLieu.defaultProps = {
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: '',
  name: 'tinhTrangTaiLieu'
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.tinhTrangTaiLieuList
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonTinhTrangTaiLieu);

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownKetQuaGiaiQuyet = function (_React$Component) {
  _inherits(DropDownKetQuaGiaiQuyet, _React$Component);

  function DropDownKetQuaGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownKetQuaGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownKetQuaGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownKetQuaGiaiQuyet)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownKetQuaGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getKetQuaGiaiQuyet.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'ketQuaGiaiQuyet',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, selectedValue: this.props.selectedValue, options: this.state.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownKetQuaGiaiQuyet;
}(_react2.default.Component);

DropDownKetQuaGiaiQuyet.defaultProps = {
  label: 'Kết quả xử lý',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.ketQuaGiaiQuyet
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownKetQuaGiaiQuyet);

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownKetQuaGiaiQuyetDon = function (_React$Component) {
  _inherits(DropDownKetQuaGiaiQuyetDon, _React$Component);

  function DropDownKetQuaGiaiQuyetDon(props, context) {
    _classCallCheck(this, DropDownKetQuaGiaiQuyetDon);

    var _this = _possibleConstructorReturn(this, (DropDownKetQuaGiaiQuyetDon.__proto__ || Object.getPrototypeOf(DropDownKetQuaGiaiQuyetDon)).call(this, props, context));

    _this.state = {
      selectedValue: _this.props.selectedValue,
      data: []
    };
    return _this;
  }

  _createClass(DropDownKetQuaGiaiQuyetDon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getKetQuaGiaiQuyetDon();
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'getKetQuaGiaiQuyetDon',
    value: function getKetQuaGiaiQuyetDon() {
      var _this2 = this;

      var params = {
        khongCoDoiThoai: false,
        loaiDon: this.props.loaiDon
      };
      _api.DuLieuHeThong.actions.getKetQuaGiaiQuyetDon.request(params).then(function (res) {
        if (res.data) {
          if (_this2.props.isTTXMLai) {
            res.data = res.data.filter(function (item) {
              return item.giaTri != 'GIAO_THAM_TRA_XAC_MINH_LAI';
            });
          }
          _this2.setState({ data: res.data });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isTTXMLai) {
        var newData = this.state.data.filter(function (item) {
          return item.giaTri != 'GIAO_THAM_TRA_XAC_MINH_LAI';
        });
        this.setState({ data: newData });
      }
      this.setState({
        selectedValue: nextProps.selectedValue
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: '', disabled: this.props.disable, confirm: this.props.confirm, selectedValue: this.state.selectedValue, options: this.state.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: this.props.name });
    }
  }]);

  return DropDownKetQuaGiaiQuyetDon;
}(_react2.default.Component);

DropDownKetQuaGiaiQuyetDon.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  disable: false,
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  selectedValue: '',
  confirm: false,
  name: '',
  isTTXMLai: false,
  loaiDon: ''
};

exports.default = DropDownKetQuaGiaiQuyetDon;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownKetQuaTiepDan = function (_React$Component) {
  _inherits(DropDownKetQuaTiepDan, _React$Component);

  function DropDownKetQuaTiepDan() {
    _classCallCheck(this, DropDownKetQuaTiepDan);

    return _possibleConstructorReturn(this, (DropDownKetQuaTiepDan.__proto__ || Object.getPrototypeOf(DropDownKetQuaTiepDan)).apply(this, arguments));
  }

  _createClass(DropDownKetQuaTiepDan, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'K\u1EBFt qu\u1EA3 ti\u1EBFp d\xE2n', selectedValue: this.props.selectedValue, options: this.props.data, className: this.props.className, keyName: 'giaTri',
        valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownKetQuaTiepDan;
}(_react2.default.Component);

DropDownKetQuaTiepDan.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  selectedValue: ''
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.ketQuaTiepDan
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownKetQuaTiepDan);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonNoiCapCMND = function (_React$Component) {
  _inherits(DropDownChonNoiCapCMND, _React$Component);

  function DropDownChonNoiCapCMND(props, context) {
    _classCallCheck(this, DropDownChonNoiCapCMND);

    var _this = _possibleConstructorReturn(this, (DropDownChonNoiCapCMND.__proto__ || Object.getPrototypeOf(DropDownChonNoiCapCMND)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonNoiCapCMND, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getNoiCap.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'noiCapCMND',
              data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { className: this.props.className, selectedValue: this.props.selectedValue, label: 'N\u01A1i c\u1EA5p', options: this.state.data, keyName: 'coQuanQuanLyId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: 'noiCapCMND' });
    }
  }]);

  return DropDownChonNoiCapCMND;
}(_react2.default.Component);

DropDownChonNoiCapCMND.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.noiCapCMND
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonNoiCapCMND);

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonPhuongXa = function (_React$Component) {
  _inherits(DropDownChonPhuongXa, _React$Component);

  function DropDownChonPhuongXa(props, context) {
    _classCallCheck(this, DropDownChonPhuongXa);

    var _this = _possibleConstructorReturn(this, (DropDownChonPhuongXa.__proto__ || Object.getPrototypeOf(DropDownChonPhuongXa)).call(this, props, context));

    _this.state = {
      data: [],
      allData: []
    };
    return _this;
  }

  _createClass(DropDownChonPhuongXa, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.quanHuyenId) this.loadData(this.props.quanHuyenId);
    }
  }, {
    key: 'loadData',
    value: function loadData(quanHuyenId) {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getCapPhuongXa.request({ id: quanHuyenId }).then(function (res) {
        if (typeof res.data._embedded != "undefined") {
          // TODO: Use Redux

          _this2.setState({
            data: res.data._embedded.donViHanhChinhs
          });
        } else {
          _this2.setState({
            data: []
          });
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.quanHuyenId != nextProps.quanHuyenId) {
        if (nextProps.quanHuyenId) {
          if (typeof this.state.allData[nextProps.quanHuyenId] != "undefined") {
            this.setState({
              data: this.props.data[nextProps.quanHuyenId]
            });
          } else {
            this.loadData(nextProps.quanHuyenId);
          }
        } else {
          this.setState({
            data: []
          });
        }
      }
      if (this.props.thanhPhoID != nextProps.thanhPhoID) {
        this.setState({
          data: []
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, className: this.props.className, selectedValue: this.props.selectedValue,
        label: 'Ph\u01B0\u1EDDng/X\xE3', options: this.state.data, keyName: 'donViHanhChinhId', valueName: 'ten',
        onChange: this.onChange.bind(this), placeholder: this.props.placeholder,
        bindValidator: this, channel: 'danhMuc', require: this.props.require,
        name: 'phuongXa'
      });
    }
  }]);

  return DropDownChonPhuongXa;
}(_react2.default.Component);

DropDownChonPhuongXa.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  isValid: false,
  require: false,
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.capPhuongXa
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonPhuongXa));

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonQuanHuyen = function (_React$Component) {
  _inherits(DropDownChonQuanHuyen, _React$Component);

  function DropDownChonQuanHuyen(props, context) {
    _classCallCheck(this, DropDownChonQuanHuyen);

    var _this = _possibleConstructorReturn(this, (DropDownChonQuanHuyen.__proto__ || Object.getPrototypeOf(DropDownChonQuanHuyen)).call(this, props, context));

    _this.state = {
      data: [],
      allData: [],
      mounted: false
    };
    return _this;
  }

  _createClass(DropDownChonQuanHuyen, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
      if (this.props.thanhPhoID) this.loadData(this.props.thanhPhoID);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ mounted: false });
    }
  }, {
    key: 'loadData',
    value: function loadData(thanhphoID) {
      var _this2 = this;

      _api.DuLieuHeThong.actions.getCapQuanHuyen.request({ id: thanhphoID }).then(function (res) {
        if (_this2.state.mounted) {
          if (typeof res.data._embedded != "undefined") {
            // TODO: Use Redux
            _this2.setState({
              data: res.data._embedded.donViHanhChinhs
            });
          } else {
            _this2.setState({
              data: []
            });
          }
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.thanhPhoID != nextProps.thanhPhoID) {
        if (nextProps.thanhPhoID) {
          if (typeof this.state.allData[nextProps.thanhPhoID] != "undefined") {
            this.setState({
              data: this.props.data[nextProps.thanhPhoID]
            });
          } else {
            this.loadData(nextProps.thanhPhoID);
          }
        } else {
          this.setState({
            data: []
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, className: this.props.className, selectedValue: this.props.selectedValue, label: 'Qu\u1EADn/Huy\u1EC7n',
        options: this.state.data, keyName: 'donViHanhChinhId', valueName: 'ten', onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder, require: this.props.require, bindValidator: this, channel: 'danhMuc', name: 'quanHuyen' });
    }
  }]);

  return DropDownChonQuanHuyen;
}(_react2.default.Component);

DropDownChonQuanHuyen.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  require: false,
  isValid: false,
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.capQuanHuyen
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonQuanHuyen));

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _api = __webpack_require__(5);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonQuocTich = function (_React$Component) {
  _inherits(DropDownChonQuocTich, _React$Component);

  function DropDownChonQuocTich(props, context) {
    _classCallCheck(this, DropDownChonQuocTich);

    var _this = _possibleConstructorReturn(this, (DropDownChonQuocTich.__proto__ || Object.getPrototypeOf(DropDownChonQuocTich)).call(this, props));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonQuocTich, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getQuocTich.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'quocTich',
              data: res.data && res.data._embedded && res.data._embedded.quocTiches ? res.data._embedded.quocTiches : []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, className: this.props.className, selectedValue: this.props.selectedValue, label: 'Qu\u1ED1c t\u1ECBch', options: this.state.data, keyName: 'quocTichId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, name: 'quocTich' });
    }
  }]);

  return DropDownChonQuocTich;
}(_react2.default.Component);

DropDownChonQuocTich.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  data: [],
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.quocTich
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownChonQuocTich);

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownSort = function (_Component) {
  _inherits(DropDownSort, _Component);

  function DropDownSort(props, context) {
    _classCallCheck(this, DropDownSort);

    var _this = _possibleConstructorReturn(this, (DropDownSort.__proto__ || Object.getPrototypeOf(DropDownSort)).call(this, props, context));

    _this.state = {
      data: []
    };
    return _this;
  }

  _createClass(DropDownSort, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var sortData = [];
      var ngayTiepDanGiamDan = {
        ten: 'Ngày tiếp dân - giảm dần',
        value: 'ngayTiepDan,desc'
      };
      var ngayTiepDanTangDan = {
        ten: 'Ngày tiếp dân - tăng dần',
        value: 'ngayTiepDan,asc'
      };
      var ngayTiepNhanGiamDan = {
        ten: 'Ngày tiếp nhận - giảm dần',
        value: 'ngayTiepNhan,desc'
      };
      var ngayTiepNhanTangDan = {
        ten: 'Ngày tiếp nhận - tăng dần',
        value: 'ngayTiepNhan,asc'
      };
      var ngaySuaGiamDan = {
        ten: 'Ngày sửa - giảm dần',
        value: 'ngaySua,desc'
      };
      var ngaySuaTangDan = {
        ten: 'Ngày sửa - tăng dần',
        value: 'ngaySua,asc'
      };
      var ngayLapDonGapLanhDaoGiamDan = {
        ten: 'Ngày đăng kí gặp lãnh đạo - giảm dần',
        value: 'ngayLapDonGapLanhDaoTmp,desc'
      };
      var ngayLapDonGapLanhDaoTangDan = {
        ten: 'Ngày đăng kí gặp lãnh đạo - tăng dần',
        value: 'ngayLapDonGapLanhDaoTmp,asc'
      };
      var sortItem1 = [ngayTiepDanTangDan, ngayTiepDanGiamDan, ngaySuaTangDan, ngaySuaGiamDan];
      var sortItem2 = [ngayLapDonGapLanhDaoTangDan, ngayLapDonGapLanhDaoGiamDan, ngaySuaTangDan, ngaySuaGiamDan];
      var sortItem3 = [ngayTiepNhanTangDan, ngayTiepNhanGiamDan, ngaySuaTangDan, ngaySuaGiamDan];
      if (this.props.type === 'tiepCongDanThuongXuyen' || this.props.type === 'soTiepDinhKy' || this.props.type === 'soTiepDotXuat') {
        sortData.push.apply(sortData, sortItem1);
      }
      if (this.props.type === 'dangKiGapLanhDao') {
        sortData.push.apply(sortData, sortItem2);
      }
      if (this.props.type === 'soXuLyDon' || this.props.type === 'giaiQuyetDon' || this.props.type === 'theoDoiThucHien' || this.props.type === 'donDaGiaiQuyet') {
        sortData.push.apply(sortData, sortItem3);
      }
      this.setState({
        data: sortData
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, {
        bindValidator: this,
        channel: 'formSort',
        isValid: this.props.isValid,
        require: this.props.require,
        label: this.props.label,
        className: this.props.className,
        keyName: 'value',
        valueName: 'ten',
        options: this.state.data,
        onChange: this.onChange.bind(this),
        placeholder: this.props.placeholder,
        selectedValue: this.props.selectedValue,
        name: this.props.name });
    }
  }]);

  return DropDownSort;
}(_react.Component);

DropDownSort.defaultProps = {
  label: 'Sắp xếp theo:',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  name: ''
};

exports.default = (0, _utils.validatable)(DropDownSort);

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _utils = __webpack_require__(4);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownChonTinhThanh = function (_React$Component) {
  _inherits(DropDownChonTinhThanh, _React$Component);

  function DropDownChonTinhThanh(props, context) {
    _classCallCheck(this, DropDownChonTinhThanh);

    var _this = _possibleConstructorReturn(this, (DropDownChonTinhThanh.__proto__ || Object.getPrototypeOf(DropDownChonTinhThanh)).call(this, props, context));

    _this.state = {
      value: _this.props.selectedValue,
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownChonTinhThanh, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getCapTinhThanhPho.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'capTinhThanhPho',
              data: res.data && res.data._embedded && res.data._embedded.donViHanhChinhs ? res.data._embedded.donViHanhChinhs : []
            }]
          });
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedValue && this.props.selectedValue != nextProps.selectedValue) {
        this.setState({
          value: nextProps.selectedValue
        });
      }
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { disabled: this.props.disabled, className: this.props.className, selectedValue: this.props.selectedValue, label: 'T\u1EC9nh', options: this.state.data, keyName: 'donViHanhChinhId', valueName: 'ten', onChange: this.onChange.bind(this), placeholder: this.props.placeholder, require: this.props.require, bindValidator: this, channel: 'danhMuc', name: 'tinhThanh' });
    }
  }]);

  return DropDownChonTinhThanh;
}(_react2.default.Component);

DropDownChonTinhThanh.defaultProps = {
  className: 'col-input',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  selectedValue: '',
  isValid: false,
  require: false,
  data: [],
  disabled: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.capTinhThanhPho
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)((0, _utils.validatable)(DropDownChonTinhThanh));

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownTinhTrangGiaiQuyet = function (_React$Component) {
  _inherits(DropDownTinhTrangGiaiQuyet, _React$Component);

  function DropDownTinhTrangGiaiQuyet(props, context) {
    _classCallCheck(this, DropDownTinhTrangGiaiQuyet);

    var _this = _possibleConstructorReturn(this, (DropDownTinhTrangGiaiQuyet.__proto__ || Object.getPrototypeOf(DropDownTinhTrangGiaiQuyet)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownTinhTrangGiaiQuyet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.data.length == 0) {
        _api.DuLieuHeThong.actions.getTrangThaiDon.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'trangThaiDon',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data != this.props.data) {
        this.state.data = nextProps.data;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: this.props.label, selectedValue: this.props.selectedValue, options: this.state.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownTinhTrangGiaiQuyet;
}(_react2.default.Component);

DropDownTinhTrangGiaiQuyet.defaultProps = {
  label: 'Tình trạng giải quyết',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    data: state.duLieuHeThong.trangThaiDon
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownTinhTrangGiaiQuyet);

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDownTinhTrangXuLy = function (_React$Component) {
  _inherits(DropDownTinhTrangXuLy, _React$Component);

  function DropDownTinhTrangXuLy(props, context) {
    _classCallCheck(this, DropDownTinhTrangXuLy);

    var _this = _possibleConstructorReturn(this, (DropDownTinhTrangXuLy.__proto__ || Object.getPrototypeOf(DropDownTinhTrangXuLy)).call(this, props, context));

    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(DropDownTinhTrangXuLy, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.data != nextProps.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_common.DropDown, { label: 'T\xECnh tr\u1EA1ng x\u1EED l\xFD', options: this.state.data, keyName: 'giaTri', valueName: 'ten', className: this.props.className, onChange: this.onChange.bind(this), placeholder: this.props.placeholder });
    }
  }]);

  return DropDownTinhTrangXuLy;
}(_react2.default.Component);

DropDownTinhTrangXuLy.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  options: []
};

var bindStateToProps = function bindStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(DropDownTinhTrangXuLy);

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButtonChonTrangThaiKHTT = function (_Component) {
  _inherits(RadioButtonChonTrangThaiKHTT, _Component);

  function RadioButtonChonTrangThaiKHTT() {
    _classCallCheck(this, RadioButtonChonTrangThaiKHTT);

    return _possibleConstructorReturn(this, (RadioButtonChonTrangThaiKHTT.__proto__ || Object.getPrototypeOf(RadioButtonChonTrangThaiKHTT)).apply(this, arguments));
  }

  _createClass(RadioButtonChonTrangThaiKHTT, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var data = [{
        ten: 'Nhập dự thảo KHTT',
        giaTri: 'NHAP_DU_THAO'
      }, {
        ten: 'Nhập KHTT đã được phê duyệt',
        giaTri: 'NHAP_KHTT_PHE_DUYET'
      }];
      return _react2.default.createElement(_common.RadioButton, { options: data, disable: this.props.disable,
        selectedValue: this.props.selectedValue,
        keyName: 'giaTri',
        valueName: 'ten',
        onChange: this.onChange.bind(this) });
    }
  }]);

  return RadioButtonChonTrangThaiKHTT;
}(_react.Component);

RadioButtonChonTrangThaiKHTT.defaultProps = {
  selectedValue: 'NHAP_DU_THAO',
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

exports.default = RadioButtonChonTrangThaiKHTT;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButtonChonTrangThaiXuLyDon = function (_React$Component) {
  _inherits(RadioButtonChonTrangThaiXuLyDon, _React$Component);

  function RadioButtonChonTrangThaiXuLyDon() {
    _classCallCheck(this, RadioButtonChonTrangThaiXuLyDon);

    return _possibleConstructorReturn(this, (RadioButtonChonTrangThaiXuLyDon.__proto__ || Object.getPrototypeOf(RadioButtonChonTrangThaiXuLyDon)).apply(this, arguments));
  }

  _createClass(RadioButtonChonTrangThaiXuLyDon, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {

      var data = [{
        ten: 'CÔNG VIỆC ĐANG XỬ LÝ',
        giaTri: 'DANG_XU_LY'
      }, {
        ten: 'CÔNG VIỆC ĐÃ XỬ LÝ',
        giaTri: 'DA_XU_LY'
      }];

      return _react2.default.createElement(_common.RadioButton, { options: data, disable: this.props.disable,
        selectedValue: this.props.selectedValue,
        keyName: 'giaTri',
        valueName: 'ten',
        onChange: this.onChange.bind(this) });
    }
  }]);

  return RadioButtonChonTrangThaiXuLyDon;
}(_react2.default.Component);

RadioButtonChonTrangThaiXuLyDon.defaultProps = {
  selectedValue: 'DANG_XU_LY',
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

exports.default = RadioButtonChonTrangThaiXuLyDon;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemSelected = function (_React$Component) {
  _inherits(ItemSelected, _React$Component);

  function ItemSelected(props, context) {
    _classCallCheck(this, ItemSelected);

    var _this = _possibleConstructorReturn(this, (ItemSelected.__proto__ || Object.getPrototypeOf(ItemSelected)).call(this, props, context));

    _this.state = {
      label: _this.props.label,
      value: _this.props.value,
      capQuanHuyen: _this.props.capQuanHuyen
    };
    return _this;
  }

  _createClass(ItemSelected, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        label: nextProps.label,
        value: nextProps.value,
        capQuanHuyen: nextProps.capQuanHuyen
      });
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.props.removeSelected();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: 'rs-item-selected' },
        _react2.default.createElement(
          'span',
          { className: 'rs-item-close', onClick: this.onClick.bind(this) },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          { className: 'rs-item-name' },
          this.state.label + this.props.capQuanHuyen
        )
      );
    }
  }]);

  return ItemSelected;
}(_react2.default.Component);

ItemSelected.defaultProps = {
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  },
  label: '',
  value: ''
};

exports.default = ItemSelected;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _DataSelected = __webpack_require__(503);

var _DataSelected2 = _interopRequireDefault(_DataSelected);

var _ItemChildren = __webpack_require__(504);

var _ItemChildren2 = _interopRequireDefault(_ItemChildren);

var _ItemParents = __webpack_require__(505);

var _ItemParents2 = _interopRequireDefault(_ItemParents);

var _method = __webpack_require__(322);

var _ShowIf = __webpack_require__(198);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(612);

var ReactTreeSelect = function (_React$Component) {
  _inherits(ReactTreeSelect, _React$Component);

  function ReactTreeSelect(props, context) {
    _classCallCheck(this, ReactTreeSelect);

    var _this = _possibleConstructorReturn(this, (ReactTreeSelect.__proto__ || Object.getPrototypeOf(ReactTreeSelect)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      dataOptions: _this.props.dataOptions,
      dataSelected: _this.props.dataSelected,
      optionOpened: false,
      propertyChildren: _this.props.propertyChildren,
      thanhTraCQQL: _this.props.thanhTraCQQL,
      propertyParent: _this.props.propertyParent,
      selectAllChildren: false
    };
    return _this;
  }

  _createClass(ReactTreeSelect, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.data,
        dataOptions: nextProps.dataOptions,
        dataSelected: nextProps.dataSelected,
        propertyChildren: nextProps.propertyChildren,
        thanhTraCQQL: nextProps.thanhTraCQQL,
        propertyParent: nextProps.propertyParent
      });
      if (this.props.selectAllChildren != nextProps.selectAllChildren) {
        this.selectAllChildren(nextProps.selectAllChildren);
      }
    }
  }, {
    key: 'getParents',
    value: function getParents(data) {
      var _this2 = this;

      var DataFillter = [].concat(_toConsumableArray(data));

      var DataParents = [];

      DataFillter.map(function (state, i) {
        var draf = [].concat(_toConsumableArray(data));
        if (state[_this2.state.propertyChildren] != null) {
          var dataCheck = draf.filter(function (item) {
            return item[_this2.state.propertyParent] == state[_this2.state.propertyChildren][_this2.state.propertyParent];
          });
          if (dataCheck.length > 0) {
            // Do nothing
          } else {
            DataParents[DataParents.length] = DataFillter[i];
          }
        } else {
          DataParents[DataParents.length] = DataFillter[i];
        }
      });

      var dataRender = DataParents.map(function (item, i) {
        return _react2.default.createElement(
          _ItemParents2.default,
          { key: i, dataSelected: _this2.state.dataSelected, label: item.ten, value: item[_this2.state.propertyParent], selectedOption: _this2.selectedOption.bind(_this2), removeOption: _this2.removeOption.bind(_this2) },
          _this2.getChildren(item[_this2.state.propertyParent], data)
        );
      });

      return dataRender;
    }
  }, {
    key: 'getChildren',
    value: function getChildren(id, data) {
      var _this3 = this;

      var DataFillter = [].concat(_toConsumableArray(data));

      var DataChildren = DataFillter.filter(function (state) {
        return state[_this3.state.propertyChildren] && state[_this3.state.propertyChildren][_this3.state.propertyParent] == id;
      });

      var dataRender = '';
      if (DataChildren.length > 0) {
        dataRender = DataChildren.map(function (item, i) {
          return _react2.default.createElement(
            _ItemChildren2.default,
            { key: i, dataQuan: item.coQuanQuanLyCha, dataSelected: _this3.state.dataSelected, label: item.ten, value: item[_this3.state.propertyParent], selectedOption: _this3.selectedOption.bind(_this3), removeOption: _this3.removeOption.bind(_this3) },
            _this3.getChildren(item[_this3.state.propertyParent], data)
          );
        });
      }

      return dataRender;
    }
  }, {
    key: 'selectedOption',
    value: function selectedOption(data) {
      var _this4 = this;

      var dataSelected = [].concat(_toConsumableArray(this.state.dataSelected));
      dataSelected[dataSelected.length] = {
        label: data.label,
        value: data.value
      };
      this.state.dataSelected = dataSelected;
      this.setState({
        dataSelected: this.state.dataSelected
      }, function () {
        _this4.props.onChange(_this4.state.dataSelected);
      });
    }
  }, {
    key: 'removeOption',
    value: function removeOption(data) {
      var _this5 = this;

      var dataSelected = [].concat(_toConsumableArray(this.state.dataSelected));
      var index = (0, _method.arrayObjectIndexOf)(dataSelected, data.value, "value");
      dataSelected.splice(index, 1);
      this.state.dataSelected = dataSelected;
      this.setState({
        dataSelected: this.state.dataSelected
      }, function () {
        _this5.props.onChange(_this5.state.dataSelected);
      });
    }
  }, {
    key: 'removeSelected',
    value: function removeSelected(data) {
      var _this6 = this;

      var dataSelected = [].concat(_toConsumableArray(this.state.dataSelected));
      var index = (0, _method.arrayObjectIndexOf)(dataSelected, data.value, "value");
      dataSelected.splice(index, 1);
      this.state.dataSelected = dataSelected;
      this.setState({
        dataSelected: this.state.dataSelected
      }, function () {
        _this6.props.onChange(_this6.state.dataSelected);
      });
    }
  }, {
    key: 'selectAllChildren',
    value: function selectAllChildren(isCheck) {
      var _this7 = this;

      var dataSelected = [];
      if (isCheck) {
        dataSelected = (0, _method.getAllChildren)(this.state.data, this.state.dataSelected, this.state.propertyParent, this.state.propertyChildren);
      } else {
        dataSelected = (0, _method.removeAllChildren)(this.state.dataSelected);
      }
      this.setState({
        dataSelected: dataSelected,
        selectAllChildren: isCheck
      }, function () {
        _this7.props.onChange(_this7.state.dataSelected);
      });
    }
  }, {
    key: 'toggleOption',
    value: function toggleOption(e) {

      if (!this.state.optionOpened) {
        document.addEventListener('click', this.handleOutsideClick.bind(this), false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
      }

      this.setState({
        optionOpened: !this.state.optionOpened
      });
    }
  }, {
    key: 'closeOption',
    value: function closeOption() {
      this.setState({
        optionOpened: false
      });
    }
  }, {
    key: 'handleOutsideClick',
    value: function handleOutsideClick(e) {
      if (this.node && this.node.contains(e.target)) {
        return;
      } else if (this.node && !this.node.contains(e.target)) {
        this.closeOption();
      }
    }
  }, {
    key: 'clearSelected',
    value: function clearSelected() {
      var _this8 = this;

      this.setState({
        dataSelected: []
      }, function () {
        _this8.props.onChange(_this8.state.dataSelected);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var dataRender = this.getParents(this.state.data);
      return _react2.default.createElement(
        'section',
        { className: this.state.optionOpened ? 'rs-wrapper open' : 'rs-wrapper', id: 'node', ref: function ref(node) {
            _this9.node = node;
          } },
        _react2.default.createElement(_DataSelected2.default, { toggleOption: this.toggleOption.bind(this), dataOptions: this.props.dataOptions, thanhTraCQQL: this.props.thanhTraCQQL, removeSelected: this.removeSelected.bind(this), dataSelected: this.state.dataSelected }),
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: this.state.dataSelected.length > 1 },
          _react2.default.createElement(
            'span',
            { className: 'rs-clear-all', onClick: this.clearSelected.bind(this) },
            '\xD7'
          )
        ),
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: this.state.dataSelected.length == 0 },
          _react2.default.createElement(
            'span',
            { className: 'rs-place-holder' },
            this.props.placeHolder
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.state.optionOpened ? 'rs-wrap-options' : 'rs-wrap-options hidden' },
          dataRender
        )
      );
    }
  }]);

  return ReactTreeSelect;
}(_react2.default.Component);

ReactTreeSelect.defaultProps = {
  data: [],
  dataSelected: [],
  selectAllChildren: false,
  placeHolder: '--Chọn--',
  propertyChildren: '',
  propertyParent: ''
};

exports.default = (0, _utils.validatable)(ReactTreeSelect);

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(4);

var _DataSelected = __webpack_require__(503);

var _DataSelected2 = _interopRequireDefault(_DataSelected);

var _ItemChildren = __webpack_require__(504);

var _ItemChildren2 = _interopRequireDefault(_ItemChildren);

var _ItemParents = __webpack_require__(505);

var _ItemParents2 = _interopRequireDefault(_ItemParents);

var _ShowIf = __webpack_require__(198);

var _ShowIf2 = _interopRequireDefault(_ShowIf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(612);

var ReactTreeSelectOneElement = function (_React$Component) {
  _inherits(ReactTreeSelectOneElement, _React$Component);

  function ReactTreeSelectOneElement(props, context) {
    _classCallCheck(this, ReactTreeSelectOneElement);

    var _this = _possibleConstructorReturn(this, (ReactTreeSelectOneElement.__proto__ || Object.getPrototypeOf(ReactTreeSelectOneElement)).call(this, props, context));

    _this.state = {
      data: _this.props.data,
      value: _this.props.value,
      optionOpened: false,
      propertyChildren: _this.props.propertyChildren,
      propertyParent: _this.props.propertyParent,
      selectAllChildren: false
    };
    return _this;
  }

  _createClass(ReactTreeSelectOneElement, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.data,
        value: nextProps.value,
        propertyChildren: nextProps.propertyChildren,
        propertyParent: nextProps.propertyParent
      });
    }
  }, {
    key: 'getParents',
    value: function getParents(data) {
      var _this2 = this;

      var DataFillter = [].concat(_toConsumableArray(data));

      var DataParents = [];

      DataFillter.map(function (state, i) {
        var draf = [].concat(_toConsumableArray(data));
        if (state[_this2.state.propertyChildren] != null) {
          var dataCheck = draf.filter(function (item) {
            return item[_this2.state.propertyParent] == state[_this2.state.propertyChildren][_this2.state.propertyParent];
          });
          if (dataCheck.length > 0) {
            // Do nothing
          } else {
            DataParents[DataParents.length] = DataFillter[i];
          }
        } else {
          DataParents[DataParents.length] = DataFillter[i];
        }
      });

      var dataRender = DataParents.map(function (item, i) {
        return _react2.default.createElement(
          _ItemParents2.default,
          { key: i, only: true, label: item.ten, itemSelected: _this2.state.value, value: item[_this2.state.propertyParent], selectedOption: _this2.selectedOption.bind(_this2) },
          _this2.getChildren(item[_this2.state.propertyParent], data)
        );
      });

      return dataRender;
    }
  }, {
    key: 'getChildren',
    value: function getChildren(id, data) {
      var _this3 = this;

      var DataFillter = [].concat(_toConsumableArray(data));

      var DataChildren = DataFillter.filter(function (state) {
        return state[_this3.state.propertyChildren] && state[_this3.state.propertyChildren][_this3.state.propertyParent] == id;
      });

      var dataRender = '';
      if (DataChildren.length > 0) {
        dataRender = DataChildren.map(function (item, i) {
          return _react2.default.createElement(
            _ItemChildren2.default,
            { key: i, only: true, label: item.ten, itemSelected: _this3.state.value, value: item[_this3.state.propertyParent], selectedOption: _this3.selectedOption.bind(_this3) },
            _this3.getChildren(item[_this3.state.propertyParent], data)
          );
        });
      }

      return dataRender;
    }
  }, {
    key: 'selectedOption',
    value: function selectedOption(e) {
      var _this4 = this;

      var value = e;
      this.setState({
        value: value
      }, function () {
        _this4.props.onChange(e);
        _this4.toggleOption(_this4);
      });
    }
  }, {
    key: 'toggleOption',
    value: function toggleOption(e) {
      if (!this.state.optionOpened) {
        document.addEventListener('click', this.handleOutsideClick.bind(this), false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
      }

      this.setState({
        optionOpened: !this.state.optionOpened
      });
    }
  }, {
    key: 'closeOption',
    value: function closeOption() {
      this.setState({
        optionOpened: false
      });
    }
  }, {
    key: 'handleOutsideClick',
    value: function handleOutsideClick(e) {
      if (this.node && this.node.contains(e.target)) {
        return;
      } else if (this.node && !this.node.contains(e.target)) {
        this.closeOption();
      }
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      var _this5 = this;

      this.setState({
        value: null
      }, function () {
        _this5.props.onChange(_this5.state.value);
        _this5.toggleOption(_this5);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var dataRender = this.getParents(this.state.data);
      return _react2.default.createElement(
        'section',
        { className: this.state.optionOpened ? 'rs-wrapper rs-one-element open' : 'rs-wrapper rs-one-element', id: 'node', ref: function ref(node) {
            _this6.node = node;
          } },
        _react2.default.createElement(_DataSelected2.default, { name: this.props.name, toggleOption: this.toggleOption.bind(this), dataOptions: this.state.data, keyName: this.state.propertyParent, only: true, value: this.state.value }),
        _react2.default.createElement(
          _ShowIf2.default,
          { condition: !this.state.value || this.state.value === null },
          _react2.default.createElement(
            'span',
            { className: 'rs-place-holder' },
            this.props.placeholder
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.state.optionOpened ? 'rs-wrap-options' : 'rs-wrap-options hidden' },
          _react2.default.createElement(
            'div',
            { className: 'rs-children pl5' },
            _react2.default.createElement(
              'span',
              { className: 'rs-label', onClick: this.clearData.bind(this) },
              this.props.placeholder
            )
          ),
          dataRender
        )
      );
    }
  }]);

  return ReactTreeSelectOneElement;
}(_react2.default.Component);

ReactTreeSelectOneElement.defaultProps = {
  data: [],
  value: [],
  selectAllChildren: false,
  placeholder: '--Chọn--',
  propertyChildren: '',
  propertyParent: '',
  name: ''
};

exports.default = (0, _utils.validatable)(ReactTreeSelectOneElement);

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _config = __webpack_require__(16);

var _api = __webpack_require__(5);

var _lodash = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowItemFileDinhKem = function (_React$Component) {
  _inherits(RowItemFileDinhKem, _React$Component);

  function RowItemFileDinhKem(props, context) {
    _classCallCheck(this, RowItemFileDinhKem);

    var _this = _possibleConstructorReturn(this, (RowItemFileDinhKem.__proto__ || Object.getPrototypeOf(RowItemFileDinhKem)).call(this, props, context));

    _this.state = {
      type: _this.props.type,
      taiLieuVanThuId: _this.props.taiLieuVanThuId,
      ten: _this.props.ten,
      tenFile: _this.props.tenFile,
      ngayQuyetDinh: _this.props.ngayQuyetDinh ? new Date(_this.props.ngayQuyetDinh) : '',
      soQuyetDinh: _this.props.soQuyetDinh,
      progress: 0,
      duongDan: _this.props.duongDan,
      isValid: true,
      tinhTrang: _this.props.tinhTrang,
      taiLieuBangChungId: _this.props.taiLieuBangChungId,

      disableAttachFile: _this.props.disableAttachFile,
      dataTinhTrangTaiLieu: _this.props.dataTinhTrangTaiLieu,
      nhomHoSoInfo: _this.props.nhomHoSoInfo
    };
    return _this;
  }

  _createClass(RowItemFileDinhKem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.dataTinhTrangTaiLieu.length == 0) {
        _api.DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(function (res) {
          _this2.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'tinhTrangTaiLieuList',
              data: res.data || []
            }]
          });
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.type == 'TAI_LIEU_DINH_KEM') {
        this.setState({
          ten: nextProps.ten,
          tenFile: nextProps.tenFile,
          soQuyetDinh: nextProps.soQuyetDinh,
          taiLieuVanThuId: nextProps.taiLieuVanThuId,
          progress: 0,
          duongDan: nextProps.duongDan,
          disableAttachFile: nextProps.disableAttachFile
        });
      } else {
        this.setState({
          ten: nextProps.ten,
          tenFile: nextProps.tenFile,
          tinhTrang: nextProps.tinhTrang,
          taiLieuVanThuId: nextProps.taiLieuVanThuId,
          duongDan: nextProps.duongDan,
          taiLieuBangChungId: nextProps.taiLieuBangChungId,
          progress: 0,
          disableAttachFile: nextProps.disableAttachFile
        });
      }
      if (nextProps.dataTinhTrangTaiLieu != this.props.dataTinhTrangTaiLieu) {
        this.state.dataTinhTrangTaiLieu = nextProps.dataTinhTrangTaiLieu;
        this.setState(_extends({}, this.state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var TinhTrangTaiLieu = this.state.dataTinhTrangTaiLieu.filter(function (state) {
        return state.giaTri == _this3.state.tinhTrang;
      });

      return _react2.default.createElement(
        'tr',
        { className: 'tr-middle-content attach-file-rows show-items' },
        _react2.default.createElement(
          'td',
          { style: { width: 45, minWidth: 45, maxWidth: 45 } },
          this.props.index + 1
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 200, minWidth: 200, maxWidth: 200 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              this.state.ten
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type != 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 165, minWidth: 165, maxWidth: 165 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              this.state.ten
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type != 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 180, minWidth: 180, maxWidth: 180 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              TinhTrangTaiLieu.length > 0 ? TinhTrangTaiLieu[0].ten : ''
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 130, minWidth: 130, maxWidth: 130 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              this.state.soQuyetDinh
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 201, minWidth: 201, maxWidth: 201 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              this.state.ngayQuyetDinh ? (0, _moment2.default)(this.state.ngayQuyetDinh).format('DD/MM/YYYY') : ''
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' },
          _react2.default.createElement(
            'td',
            { style: { width: 201, minWidth: 201, maxWidth: 201 } },
            _react2.default.createElement(
              'p',
              { className: 'text-13' },
              (0, _lodash.get)(this.state, 'nhomHoSoInfo.ten') || ''
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'none-boder' },
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: !_config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-blue txt-underline', onClick: _jsFileDownload2.default.bind(this, this.state.duongDan, this.state.tenFile) },
              this.state.tenFile
            )
          ),
          _react2.default.createElement(
            _utils.ShowIf,
            { condition: _config.checkServerLive },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'txt-blue txt-underline', onClick: function onClick() {
                  (0, _utils.downloadFile)(_this3.state.duongDan, _this3.state.tenFile);
                } },
              this.state.tenFile
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: !this.state.disableAttachFile },
          _react2.default.createElement('td', { style: { width: 110 } })
        )
      );
    }
  }]);

  return RowItemFileDinhKem;
}(_react2.default.Component);

RowItemFileDinhKem.defaultProps = {
  index: null,
  type: 'TAI_LIEU_DINH_KEM',
  dataTinhTrangTaiLieu: [],
  disableAttachFile: false
};

var bindStateToProps = function bindStateToProps(state) {
  return {
    dataTinhTrangTaiLieu: state.duLieuHeThong.tinhTrangTaiLieuList
  };
};

exports.default = (0, _reactRedux.connect)(bindStateToProps)(RowItemFileDinhKem);

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rowitemFiledinhkem = __webpack_require__(507);

var _rowitemFiledinhkem2 = _interopRequireDefault(_rowitemFiledinhkem);

var _RowItemShowFileDinhKem = __webpack_require__(1576);

var _RowItemShowFileDinhKem2 = _interopRequireDefault(_RowItemShowFileDinhKem);

var _reactRouter = __webpack_require__(2);

var _utils = __webpack_require__(4);

var _core = __webpack_require__(7);

var _Input = __webpack_require__(502);

var _Input2 = _interopRequireDefault(_Input);

var _DatePicker = __webpack_require__(501);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _table = __webpack_require__(12);

var _lodash = __webpack_require__(14);

var _emptyFolder = __webpack_require__(2007);

var _emptyFolder2 = _interopRequireDefault(_emptyFolder);

var _api = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContainerFileDinhKem = function (_React$Component) {
  _inherits(ContainerFileDinhKem, _React$Component);

  function ContainerFileDinhKem(props, context) {
    _classCallCheck(this, ContainerFileDinhKem);

    var _this = _possibleConstructorReturn(this, (ContainerFileDinhKem.__proto__ || Object.getPrototypeOf(ContainerFileDinhKem)).call(this, props, context));

    _this.state = {
      items: _this.props.data,
      itemsShow: _this.props.dataShow,
      header: _this.props.header,
      validating: _this.props.isValid,
      type: _this.props.type,
      disableAttachFile: _this.props.disableAttachFile,
      tTXMRequired: _this.props.tTXMRequired,
      qDGQRequired: _this.props.qDGQRequired,
      resetRequired: false,
      loaiDon: _this.props.loaiDon,
      onSave: _this.props.onSave,
      loaiVanBanSuggest: _this.props.loaiVanBanSuggest,
      ngayQuyetDinhSuggest: _this.props.ngayQuyetDinhSuggest,
      soVanBanSuggest: _this.props.soVanBanSuggest,
      isDsVanBanXuLy: _this.props.isDsVanBanXuLy,
      isUploading: false,
      addSuggestions: false,
      isOpen: false,
      loaiVanBan: 'VAN_BAN_DEN',
      tuNgay: '',
      denNgay: '',
      soKyHieu: '',
      loading: false,
      dataTable: [],
      listNhomHoSo: []
    };
    return _this;
  }

  _createClass(ContainerFileDinhKem, [{
    key: 'getListNhomHoSo',
    value: function getListNhomHoSo() {
      var _this2 = this;

      _api.QuanLyVanBan.actions.getListNhomHoSo.request().then(function (res) {
        if (res.data) {
          _this2.setState({
            listNhomHoSo: res.data
          });
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.getListNhomHoSo();
      this.setState({
        items: this.props.data,
        itemsShow: this.props.dataShow
      }, function () {
        if (!_this3.state.isDsVanBanXuLy) {
          _this3.addSuggestions();
        }
      });
      if (this.props.tTXMRequired) {
        this.addTTXMRequired(this.props.tTXMText);
      }

      if (this.props.tTXMText && !this.props.tTXMRequired) {
        this.removeTTXMRequired(this.props.tTXMText);
      }

      if (this.props.qDGQRequired) {
        this.addQDGQRequired(this.props.qDGQText);
      }

      if (this.props.qDGQText && !this.props.qDGQRequired) {
        this.removeQDGQRequired(this.props.qDGQText);
      }
      if (this.state.type == 'TAI_LIEU_DINH_KEM' && this.state.disableAttachFile) {
        this.setState({
          header: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 300 }, { name: 'Số văn bản' }, { name: 'Ngày ra văn bản' }, { name: 'Nhóm hồ sơ' }, { name: 'Tài liệu đính kèm' }]
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      this.setState({
        tTXMRequired: nextProps.tTXMRequired,
        qDGQRequired: nextProps.qDGQRequired,
        onSave: nextProps.onSave,
        ngayQuyetDinhSuggest: nextProps.ngayQuyetDinhSuggest,
        soVanBanSuggest: nextProps.soVanBanSuggest,
        loaiVanBanSuggest: nextProps.loaiVanBanSuggest,
        disableAttachFile: nextProps.disableAttachFile
      });

      if (nextProps.tTXMRequired) {
        this.addTTXMRequired(nextProps.tTXMText);
      }

      if (nextProps.tTXMText && !nextProps.tTXMRequired) {
        this.removeTTXMRequired(nextProps.tTXMText);
      }

      if (nextProps.qDGQRequired) {
        this.addQDGQRequired(nextProps.qDGQText);
      }

      if (nextProps.qDGQText && !nextProps.qDGQRequired) {
        this.removeQDGQRequired(nextProps.qDGQText);
      }

      if (this.props.dataShow != nextProps.dataShow) {
        this.setState({
          itemsShow: nextProps.dataShow
        });
      }

      if (this.props.data != nextProps.data) {
        this.setState({
          items: nextProps.data
        }, function () {
          if (!_this4.state.isDsVanBanXuLy) {
            _this4.addSuggestions();
          }
        });
      }
      if (this.props.oldData != nextProps.oldData) {
        this.setState({
          items: nextProps.oldData
        }, function () {
          if (!_this4.state.isDsVanBanXuLy) {
            _this4.addSuggestions();
          }
        });
      }
    }
  }, {
    key: 'addSuggestions',
    value: function addSuggestions() {
      if (!this.state.disableAttachFile) {
        var data = [].concat(_toConsumableArray(this.state.items));
        var dataFilter = data.filter(function (state) {
          return state.ten == 'Văn bản đính kèm khác' && state.duongDan == '';
        });

        if (dataFilter.length > 0) {
          return;
        } else {
          var newItems = {
            ten: 'Văn bản đính kèm khác',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            tenFileds: '',
            duongDan: '',
            progress: '',
            open: false,
            newFile: true
          };
          this.setState({
            // addSuggestions: true,
            items: [].concat(_toConsumableArray(this.state.items), [newItems])
          });
        }
      }
    }
  }, {
    key: 'onFileChange',
    value: function onFileChange(index, data) {
      var newItems = [].concat(_toConsumableArray(this.state.items));

      newItems[index] = data;

      this.state.items = newItems;
      this.setState({
        items: this.state.items,
        resetRequired: false
      });
      this.filterFileChange(newItems, this.props.phanLoaiQuyTrinh);
    }
  }, {
    key: 'filterFileChange',
    value: function filterFileChange(data, type) {
      var newData = [].concat(_toConsumableArray(data));
      var dataFilter = newData.filter(function (state) {
        return state.ten != 'Văn bản đính kèm khác' || state.duongDan != '';
      });
      this.props.onFileChange(dataFilter, type);
    }
  }, {
    key: 'addFileDinhKem',
    value: function addFileDinhKem() {
      var newFile = {};
      if (this.state.isDsVanBanXuLy) {
        if (this.state.type == 'TAI_LIEU_DINH_KEM') {
          newFile = {
            ten: '',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            tenFileds: '',
            duongDan: '',
            progress: '',
            open: true,
            required: true
          };
        } else {
          newFile = {
            ten: '',
            tenFile: '',
            tenFileds: '',
            tinhTrang: '',
            duongDan: '',
            taiLieuBangChungId: '',
            open: true,
            required: true
          };
        }
      } else {
        if (this.state.type == 'TAI_LIEU_DINH_KEM') {
          newFile = {
            ten: '',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            tenFileds: '',
            duongDan: '',
            progress: '',
            open: true
          };
        } else {
          newFile = {
            ten: '',
            tenFile: '',
            tenFileds: '',
            tinhTrang: '',
            duongDan: '',
            taiLieuBangChungId: '',
            open: true
          };
        }
      }

      this.setState({
        items: [].concat(_toConsumableArray(this.state.items), [newFile])
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index) {
      var newItems = [].concat(_toConsumableArray(this.state.items));
      var idItem = newItems[index].taiLieuVanThuId || newItems[index].taiLieuBangChungId || newItems[index].taiLieuBaoCaoId;
      newItems.splice(index, 1);
      this.state.items = newItems;
      this.setState({
        items: this.state.items,
        resetRequired: true
      });
      if (idItem) {
        newItems = newItems.filter(function (state) {
          return state.ten != 'Văn bản đính kèm khác' || state.duongDan != '';
        });
        this.props.onFileRemove(idItem, newItems, this.props.phanLoaiQuyTrinh);
      } else {
        this.filterFileChange(newItems, this.props.phanLoaiQuyTrinh);
      }
    }
  }, {
    key: 'checkDataTTXM',
    value: function checkDataTTXM(type, typeText) {
      var data = [].concat(_toConsumableArray(this.state.items));
      var dataCheck = [];
      if (type == 'add') {
        dataCheck = data.filter(function (state) {
          return state.required == true && state.typeRequired == typeText;
        });
      }

      if (type == 'remove') {
        dataCheck = data.filter(function (state) {
          return state.required == true && state.typeRequired == typeText && (typeof state.newFile == 'undefined' || state.newFile != true);
        });
      }

      var result = '';
      if (dataCheck.length > 0) {
        result = true;
      } else {
        result = false;
      }

      return result;
    }
  }, {
    key: 'addTTXMRequired',
    value: function addTTXMRequired(typeText) {
      if (this.checkDataTTXM('add', typeText)) {
        //DO Nothing
      } else if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
        var itemRequired = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          tenFileds: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: typeText,
          newFile: true
        };
        if (this.state.loaiDon == 'DON_KHIEU_NAI') {
          itemRequired.ten = 'Báo cáo Kết quả xác minh nội dung khiếu nại';
        } else if (this.state.loaiDon == 'DON_TO_CAO') {
          itemRequired.ten = 'Báo cáo Kết quả xác minh nội dung tố cáo';
        }
        this.setState({
          items: [].concat(_toConsumableArray(this.state.items), [itemRequired])
        });
      }
    }
  }, {
    key: 'removeTTXMRequired',
    value: function removeTTXMRequired(typeText) {
      if (this.checkDataTTXM('remove', typeText)) {
        //DO Nothing
      } else {
        var data = [].concat(_toConsumableArray(this.state.items));
        var newItems = data.filter(function (state) {
          return state.required != true && state.newFile != true;
        });
        this.setState({
          items: newItems
        });
      }
    }
  }, {
    key: 'checkDataQDGQ',
    value: function checkDataQDGQ(type, typeText) {
      var data = [].concat(_toConsumableArray(this.state.items));
      var dataCheck = [];
      if (type == 'add') {
        dataCheck = data.filter(function (state) {
          return state.required == true && state.typeRequired == typeText;
        });
      }

      if (type == 'remove') {
        dataCheck = data.filter(function (state) {
          return state.required == true && state.typeRequired == typeText && (typeof state.newFile == 'undefined' || state.newFile != true);
        });
      }

      var result = '';
      if (dataCheck.length > 0) {
        result = true;
      } else {
        result = false;
      }

      return result;
    }
  }, {
    key: 'addQDGQRequired',
    value: function addQDGQRequired(typeText) {
      if (this.checkDataQDGQ('add', typeText)) {
        //DO Nothing
      } else if (this.state.loaiDon === 'DON_KHIEU_NAI' || this.state.loaiDon === 'DON_TO_CAO' || this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || this.state.loaiDon === 'DON_TRANH_CHAP_DAT') {
        var itemRequired = {
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          tenFileds: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: typeText,
          newFile: true
        };
        if (this.state.loaiDon === 'DON_KHIEU_NAI') {
          if (this.props.quyetDinh === false) {
            itemRequired.ten = 'Quyết định đình chỉ';
          } else {
            itemRequired.ten = 'Quyết định về việc giải quyết khiếu nại';
          }
        } else if (this.state.loaiDon === 'DON_TO_CAO') {
          if (this.props.quyetDinh === false) {
            itemRequired.ten = 'Quyết định đình chỉ';
          } else {
            itemRequired.ten = 'Quyết định về việc giải quyết tố cáo';
          }
        } else if (this.state.loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
          if (this.props.quyetDinh === false) {
            itemRequired.ten = 'Quyết định đình chỉ';
          } else {
            itemRequired.ten = 'Văn bản xử lý kiến nghị, phản ánh';
          }
        }
        if (this.state.loaiDon === 'DON_TRANH_CHAP_DAT') {
          if (this.props.quyetDinh === false) {
            itemRequired.ten = 'Văn bản đình chỉ';
          } else {
            itemRequired.ten = 'Văn bản giải quyết';
          }
        }
        this.setState({
          items: [].concat(_toConsumableArray(this.state.items), [itemRequired])
        });
      }
    }
  }, {
    key: 'removeQDGQRequired',
    value: function removeQDGQRequired(typeText) {
      if (this.checkDataQDGQ('remove', typeText)) {
        //DO Nothing
      } else {
        var data = [].concat(_toConsumableArray(this.state.items));
        var newItems = data.filter(function (state) {
          return state.required != true && state.newFile != true;
        });
        this.setState({
          items: newItems
        });
      }
    }
  }, {
    key: 'handleReset',
    value: function handleReset() {
      this.setState({
        resetRequired: false
      });
    }
  }, {
    key: 'handleUpdateUploading',
    value: function handleUpdateUploading(isUploading) {
      var result = !this.state.isUploading;
      if (typeof isUploading === 'boolean') {
        result = isUploading;
      }
      this.setState({ isUploading: result });
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog(name) {
      this.setState(_defineProperty({}, name, false), function () {
        if (name === 'popupTrung') {
          document.body.className += ' pt-overlay-open';
        }
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(name, e) {
      this.setState(_defineProperty({}, name, e.target ? e.target.value : e));
    }
  }, {
    key: 'onChangeDate',
    value: function onChangeDate(name, e) {
      if (e && e._d) {
        this.setState(_defineProperty({}, name, e._d));
      } else {
        this.setState(_defineProperty({}, name, e));
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var _this5 = this;

      var _state = this.state,
          loaiVanBan = _state.loaiVanBan,
          tuNgay = _state.tuNgay,
          denNgay = _state.denNgay,
          soKyHieu = _state.soKyHieu;


      var payload = {
        loaiVanBan: loaiVanBan,
        tuNgay: (0, _moment2.default)(tuNgay).format('YYYY-MM-DD'),
        denNgay: (0, _moment2.default)(denNgay).format('YYYY-MM-DD'),
        soKyHieu: soKyHieu
      };

      this.setState({
        loading: true
      });

      setTimeout(function () {
        _this5.setState({
          loading: false
        });
      }, 1000);
    }
  }, {
    key: 'onSave',
    value: function onSave() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _state2 = this.state,
          dataTable = _state2.dataTable,
          loading = _state2.loading;

      var styles = function styles(fw, fs, lh) {
        return {
          fontWeight: fw,
          fontSize: fs,
          lineHeight: lh
        };
      };

      var bodyLoading = _react2.default.createElement(
        'tr',
        { className: 'table-loading' },
        _react2.default.createElement(
          'td',
          { colSpan: '6' },
          _react2.default.createElement(
            'div',
            { className: 'loading-content' },
            _react2.default.createElement('span', { className: 'shape1' }),
            _react2.default.createElement('span', { className: 'shape2' }),
            _react2.default.createElement('span', { className: 'shape3' }),
            _react2.default.createElement('span', { className: 'shape4' }),
            _react2.default.createElement('span', { className: 'shape5' }),
            _react2.default.createElement('span', { className: 'shape6' }),
            _react2.default.createElement('span', { className: 'shape7' }),
            _react2.default.createElement('span', { className: 'shape8' }),
            _react2.default.createElement('span', { className: 'shape9' }),
            _react2.default.createElement('span', { className: 'shape10' }),
            _react2.default.createElement('span', { className: 'shape11' }),
            _react2.default.createElement('span', { className: 'shape12' }),
            _react2.default.createElement('span', { className: 'shape13' })
          )
        )
      );

      var bodyEmpty = _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { colSpan: '6' },
          _react2.default.createElement(
            'div',
            { style: {
                margin: '20px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '7px'
              } },
            _react2.default.createElement('img', { src: _emptyFolder2.default, alt: 'emptyFolder' }),
            _react2.default.createElement(
              'p',
              { style: styles(400, '13px', '18px') },
              'B\u1EA1n ch\u01B0a nh\u1EADp d\u1EEF li\u1EC7u t\xECm ki\u1EBFm'
            ),
            _react2.default.createElement(
              'p',
              { style: styles(700, '13px', '18px') },
              'Vui l\xF2ng nh\u1EADp th\xF4ng tin \u0111\u1EC3 t\xECm ki\u1EBFm v\u0103n b\u1EA3n \u1EDF tr\xEAn'
            )
          )
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'wrapper-table' },
        _react2.default.createElement(
          'div',
          { className: 'table-container', style: { overflowY: 'clip' } },
          _react2.default.createElement(
            'table',
            { className: 'table-content' },
            _react2.default.createElement(
              'thead',
              { className: 'table-header' },
              _react2.default.createElement(
                'tr',
                null,
                _table.header.taiLieuTrenQLVBDH.map(function (item, index) {
                  return _react2.default.createElement(
                    'th',
                    { key: index, className: 'table-header-col', style: { width: item.width } },
                    item.name
                  );
                })
              )
            ),
            _react2.default.createElement(
              'tbody',
              { className: 'table-body' },
              loading && (0, _lodash.isEmpty)(dataTable) && bodyLoading,
              !loading && (0, _lodash.isEmpty)(dataTable) && bodyEmpty
            )
          )
        )
      );
    }
  }, {
    key: 'renderDialog',
    value: function renderDialog() {
      return _react2.default.createElement(
        _core.Dialog,
        {
          isOpen: this.state.isOpen,
          onClose: this.closeDialog.bind(this, 'isOpen'),
          title: 'T\xECm ki\u1EBFm t\xE0i li\u1EC7u tr\xEAn QLVBDH',
          className: 'dialog-them-moi-dttt dialog-default wrap-block'
        },
        _react2.default.createElement(
          'div',
          { className: 'row ml0 mr0' },
          _react2.default.createElement(
            'div',
            { className: 'rows p20' },
            _react2.default.createElement(
              'div',
              { className: 'radio-gender col-100' },
              _react2.default.createElement(
                _core.RadioGroup,
                { name: 'loaiVanBan', onChange: this.onChange.bind(this, 'loaiVanBan'), selectedValue: this.state.loaiVanBan },
                _react2.default.createElement(_core.Radio, { label: 'V\u0103n b\u1EA3n \u0111\u1EBFn', value: 'VAN_BAN_DEN', className: 'pt-large small-title mb0' }),
                _react2.default.createElement(_core.Radio, { label: 'V\u0103n b\u1EA3n \u0111i', value: 'VAN_BAN_DI', className: 'pt-large small-title mb0' })
              )
            )
          ),
          _react2.default.createElement('span', { className: 'line-border' }),
          _react2.default.createElement(
            'div',
            { className: 'rows p20' },
            _react2.default.createElement(
              'div',
              { className: 'col-83 no-gutter' },
              _react2.default.createElement(_DatePicker2.default, { className: 'col-33', label: 'Ng\xE0y ban h\xE0nh t\u1EEB ng\xE0y', bindValidator: this, channel: 'formTaoDon', endDate: this.state.denNgay, onChange: this.onChangeDate.bind(this, 'tuNgay'), value: this.state.tuNgay, name: 'tuNgay' }),
              _react2.default.createElement(_DatePicker2.default, { className: 'col-33', label: '\u0110\u1EBFn ng\xE0y', bindValidator: this, channel: 'formTaoDon', startDate: this.state.tuNgay, onChange: this.onChangeDate.bind(this, 'denNgay'), value: this.state.denNgay, name: 'denNgay' }),
              _react2.default.createElement(_Input2.default, { className: 'col-33', label: 'S\u1ED1 k\xFD hi\u1EC7u', placeholder: 'Nh\u1EADp s\u1ED1 k\xFD hi\u1EC7u', value: this.state.soKyHieu, onChange: this.onChange.bind(this, 'soKyHieu'), name: 'soKyHieu' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-16 mb0-18 search-thanh-tra' },
              _react2.default.createElement(
                'button',
                { className: 'btn-green ' + (this.state.loading ? 'btn-loading-inline' : ''), onClick: this.onSearch.bind(this) },
                'T\xECm ki\u1EBFm'
              )
            )
          ),
          _react2.default.createElement('span', { className: 'line-border' }),
          _react2.default.createElement(
            'div',
            { className: 'rows' },
            _react2.default.createElement(
              'div',
              { className: 'col-100' },
              this.renderTable()
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-form-wrap pt20' },
          _react2.default.createElement(
            'div',
            { className: 'box-bottom' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn-green-no-bd', onClick: this.onSave.bind(this) },
              _react2.default.createElement(
                'span',
                null,
                'L\u1EA5y d\u1EEF li\u1EC7u'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'section',
        { className: 'wrap-block row-center', id: this.props.name },
        this.renderDialog(),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.type == 'TAI_LIEU_DINH_KEM' && !this.props.hidenTopTitle },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: !this.props.disableTopLine },
              _react2.default.createElement(
                'div',
                { className: 'pt5 pb15' },
                _react2.default.createElement('span', { className: 'line-border' })
              )
            ),
            _react2.default.createElement(
              'h2',
              { className: 'title-attach ' + this.props.labelClass },
              this.props.label,
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: !this.props.hideDescription && !this.state.disableAttachFile },
                _react2.default.createElement(
                  'span',
                  { className: 'attach-file-description' },
                  ' (\u0110\u1ECBnh d\u1EA1ng t\u1EADp tin \u0111\xEDnh k\xE8m: .doc, .docx, .pdf, .xls, .xlsx, .rar, .zip, .jpg, .png. Dung l\u01B0\u1EE3ng t\u1ED1i \u0111a: ',
                  this.props.capacity,
                  ' MB)'
                )
              )
            ),
            _react2.default.createElement(
              _utils.ShowIf,
              { condition: this.props.searchButton && !this.state.disableAttachFile },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn-green', onClick: this.openDialog.bind(this) },
                _react2.default.createElement('i', { className: 'tt tt-search' }),
                'T\xECm ki\u1EBFm v\u0103n b\u1EA3n \u0111i\u1EC1u h\xE0nh'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-big-line white-table' },
          _react2.default.createElement(
            'div',
            { className: 'table-container ' + (this.props.hidenTopTitle ? 'pt0' : '') },
            _react2.default.createElement(
              'div',
              { className: 'wrapper-table' },
              _react2.default.createElement(
                'table',
                { className: 'table-content' },
                _react2.default.createElement(
                  'thead',
                  { className: 'table-header' },
                  _react2.default.createElement(
                    'tr',
                    null,
                    this.state.header.map(function (item, i) {
                      return _react2.default.createElement(
                        'th',
                        { key: i, className: "table-header-col " + (item.className ? item.className : ''), colSpan: item.colSpan, style: { width: item.width, minWidth: item.minWidth } },
                        item.name
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  { className: 'table-body' },
                  this.state.itemsShow.map(function (item, index) {
                    return _react2.default.createElement(_RowItemShowFileDinhKem2.default, _extends({ key: index, disableAttachFile: _this6.state.disableAttachFile, type: _this6.state.type, index: index }, item));
                  }),
                  this.state.items.map(function (item, index) {
                    return _react2.default.createElement(_rowitemFiledinhkem2.default, _extends({
                      unSetNgayBanHanh: _this6.props.unSetNgayBanHanh,
                      checkValidate: _this6.props.checkValidate,
                      ngayQuyetDinhSuggest: _this6.state.ngayQuyetDinhSuggest,
                      loaiVanBanSuggest: _this6.state.loaiVanBanSuggest,
                      soVanBanSuggest: _this6.state.soVanBanSuggest,
                      key: index,
                      onSave: _this6.state.onSave,
                      handleReset: _this6.handleReset.bind(_this6),
                      resetRequired: _this6.state.resetRequired,
                      phanLoaiQuyTrinh: _this6.props.phanLoaiQuyTrinh,
                      count: _this6.state.itemsShow.length,
                      isTiepNhanDon: _this6.props.isTiepNhanDon,
                      bindValidator: _this6,
                      channel: 'formTaoDon',
                      type: _this6.state.type,
                      index: index,
                      onFileChange: _this6.onFileChange.bind(_this6, index),
                      onRemove: _this6.handleRemove.bind(_this6, index)
                    }, item, {
                      name: _this6.props.name,
                      allowExcelFile: true,
                      disabled: _this6.state.isUploading,
                      onUpdateUploading: _this6.handleUpdateUploading.bind(_this6),
                      isDsVanBanXuLy: _this6.state.isDsVanBanXuLy,
                      listNhomHoSo: _this6.state.listNhomHoSo
                    }));
                  }),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !this.state.disableAttachFile },
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { className: 'multipe-column', colSpan: this.props.header.length },
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.items.length == 0 && this.state.itemsShow.length == 0 },
                          _react2.default.createElement(
                            'span',
                            { className: 'attach-file-description' },
                            'Ch\u01B0a c\xF3 v\u0103n b\u1EA3n x\u1EED l\xFD \u0111\u01B0\u1EE3c \u0111\xEDnh k\xE8m. '
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: !this.state.isUploading },
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { className: 'btn-addfile itt-Them-Moi', onClick: this.addFileDinhKem.bind(this), name: this.props.name },
                            'Th\xEAm m\u1EDBi v\u0103n b\u1EA3n'
                          )
                        ),
                        _react2.default.createElement(
                          _utils.ShowIf,
                          { condition: this.state.isUploading },
                          _react2.default.createElement(
                            'span',
                            { className: 'btn-addfile itt-Them-Moi disabled-element' },
                            'Th\xEAm m\u1EDBi v\u0103n b\u1EA3n'
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: this.state.disableAttachFile && this.state.itemsShow.length == 0 },
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { className: 'multipe-column', colSpan: this.props.header.length },
                        _react2.default.createElement(
                          'span',
                          { className: 'text-13' },
                          'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ContainerFileDinhKem;
}(_react2.default.Component);

ContainerFileDinhKem.defaultProps = {
  label: 'Danh sách Tài liệu đính kèm',
  labelClass: '',
  allowExcelFile: false,
  capacity: 50,
  ngayQuyetDinhSuggest: '',
  soVanBanSuggest: '',
  loaiVanBanSuggest: '',
  items: [],
  dataShow: [],
  data: [],
  oldData: [],
  header: [{ name: 'Stt', width: 45 }, { name: 'Tên tài liệu', width: 300 }, { name: 'Số văn bản' }, { name: 'Ngày ra văn bản' }, { name: 'Tài liệu đính kèm' }, { name: 'Nhóm hồ sơ' }, { name: 'Thao tác', width: 110, minWidth: 110 }],
  hideDescription: false,
  type: 'TAI_LIEU_DINH_KEM',
  disableAttachFile: false,
  tTXMRequired: false,
  qDGQRequired: false,
  phanLoaiQuyTrinh: '',
  disableTopLine: false,
  onSave: false,
  onFileChange: function onFileChange() {
    console.log("Please implement 'onFileChange' method");
  },
  name: 'taiLieuDinhKem',
  reload: false,
  isDsVanBanXuLy: false
};

exports.default = (0, _utils.validatable)(ContainerFileDinhKem);

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _toastr = __webpack_require__(11);

var _api = __webpack_require__(5);

var _message = __webpack_require__(10);

var _reactRouter = __webpack_require__(2);

var _config = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _jsFileDownload = __webpack_require__(49);

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadNonTable = function (_React$Component) {
  _inherits(UploadNonTable, _React$Component);

  function UploadNonTable(props, context) {
    _classCallCheck(this, UploadNonTable);

    var _this = _possibleConstructorReturn(this, (UploadNonTable.__proto__ || Object.getPrototypeOf(UploadNonTable)).call(this, props, context));

    _this.state = {
      arrayFile: _this.props.arrayFileUpload,
      type: _this.props.typeArrayUpload
    };
    return _this;
  }

  _createClass(UploadNonTable, [{
    key: 'uploadFile',
    value: function uploadFile(index, e) {
      var _this2 = this;

      if (e.target.files[0]) {

        var fileName = e.target.files[0].name;
        var ext = fileName.split('.').pop().toLowerCase();
        var fileSize = e.target.files[0].size;
        if (_config.LimitFileType.indexOf(ext) == -1) {
          (0, _toastr.Toastr)(_message.msg.fileTypeErr, 'warning');
        } else if (fileSize > _config.LimitFileSize * 1024 * 1024) {
          (0, _toastr.Toastr)(_message.msg.fileSizeErr, 'warning');
        } else if (fileSize == 0) {
          (0, _toastr.Toastr)(_message.msg.fileSizeNull, 'warning');
        } else {

          var params = {
            field: 'file',
            file: e.target.files[0]
          };

          if (index == this.state.arrayFile.length) {
            this.addArrayFile(this.state.type);
          }

          params.progress = function (progress) {

            var progressBar = Math.round(progress.loaded * 100 / progress.total);

            _this2.state.arrayFile[index].progress = progressBar;

            _this2.setState({
              arrayFile: _this2.state.arrayFile
            });
          };

          _api.Reception.actions.postFileUpload.request('', params).then(function (res) {

            _this2.state.arrayFile[index].progress = 0;
            _this2.state.arrayFile[index].tenFile = fileName;
            _this2.state.arrayFile[index].urlFile = res.data ? res.data.id : '';

            _this2.setState({
              arrayFile: _this2.state.arrayFile
            }, function () {
              _this2.props.onChange(_this2.state.arrayFile);
            });
          });
        }
      }
    }
  }, {
    key: 'addArrayFile',
    value: function addArrayFile(typeArrayUpload) {

      var arrLength = this.state.arrayFile.length;
      this.state.arrayFile[arrLength] = {

        loaiFileDinhKem: typeArrayUpload,
        tenFile: '',
        urlFile: '',
        progress: 1,
        id: 0
      };
      this.setState({
        arrayFile: this.state.arrayFile
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(index) {
      var _this3 = this;

      var newData = [].concat(_toConsumableArray(this.state.arrayFile));

      newData.splice(index, 1);
      this.setState({
        arrayFile: newData
      }, function () {
        _this3.props.onChange(newData);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { className: 'txt-12 txt-bold txt-upper mb10 mt0' },
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          { className: 'desc mb10' },
          _react2.default.createElement(
            'p',
            { style: { marginLeft: 0 } },
            this.props.note
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'result-upload mb20' },
          this.state.arrayFile.map(function (item, i) {
            return _react2.default.createElement(
              'div',
              { className: 'items-upload mb10', key: i },
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: item.progress > 0 },
                _react2.default.createElement(
                  'div',
                  { className: 'pt-progress-bar progress-upload pt-intent-primary' },
                  _react2.default.createElement('div', { className: 'pt-progress-meter',
                    style: { width: item.progress + '%' } })
                )
              ),
              _react2.default.createElement(
                _utils.ShowIf,
                { condition: item.progress <= 0 },
                _react2.default.createElement(
                  'div',
                  { className: 'item-upload' },
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: !_config.checkServerLive },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { onClick: _jsFileDownload2.default.bind(_this4, item.urlFile, item.tenFile), className: 'txt-blue txt-underline mr20 name-file-upload' },
                      item.tenFile
                    )
                  ),
                  _react2.default.createElement(
                    _utils.ShowIf,
                    { condition: _config.checkServerLive },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { onClick: function onClick() {
                          (0, _utils.downloadFile)(item.urlFile, item.tenFile);
                        }, className: 'txt-blue txt-underline mr20 name-file-upload' },
                      item.tenFile
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wrap-upload-item mr15' },
                    'T\u1EA3i l\u1EA1i',
                    _react2.default.createElement('input', { type: 'file', className: 'btn-reupload', onChange: _this4.uploadFile.bind(_this4, i) })
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: 'itt-delete', onClick: _this4.handleRemove.bind(_this4, i) },
                    'X\xF3a'
                  )
                )
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrap-upload mb20' },
          _react2.default.createElement(
            'span',
            { className: 'btn-upload' },
            'T\u1EA3i l\xEAn',
            _react2.default.createElement('input', { type: 'file', name: 'giayUyQuyen', className: 'upload', onChange: this.uploadFile.bind(this, this.state.arrayFile.length) })
          )
        )
      );
    }
  }]);

  return UploadNonTable;
}(_react2.default.Component);

UploadNonTable.defaultProps = {
  typeArrayUpload: 'UY_QUYEN',
  arrayFileUpload: [],
  title: 'DANH SÁCH GIẤY ỦY QUYỀN',
  note: 'Định dạng tập tin đính kèm: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung lượng tối đa: 50mb',
  className: 'input-group',
  onChange: function onChange() {
    console.log('Need to assign onChange method');
  }
};

exports.default = UploadNonTable;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowIf = function (_React$Component) {
  _inherits(ShowIf, _React$Component);

  function ShowIf() {
    _classCallCheck(this, ShowIf);

    return _possibleConstructorReturn(this, (ShowIf.__proto__ || Object.getPrototypeOf(ShowIf)).apply(this, arguments));
  }

  _createClass(ShowIf, [{
    key: "render",
    value: function render() {
      if (this.props.condition) {
        if (typeof this.props.children.length != "undefined") {
          return _react2.default.createElement(
            "div",
            null,
            this.props.children
          );
        } else return this.props.children;
      } else {
        return null;
      }
    }
  }]);

  return ShowIf;
}(_react2.default.Component);

ShowIf.defaultProps = {
  condition: true
};

exports.default = ShowIf;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(7);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowIfCheck = function (_React$Component) {
  _inherits(ShowIfCheck, _React$Component);

  function ShowIfCheck(props, context) {
    _classCallCheck(this, ShowIfCheck);

    var _this = _possibleConstructorReturn(this, (ShowIfCheck.__proto__ || Object.getPrototypeOf(ShowIfCheck)).call(this, props, context));

    _this.state = {
      checked: _this.props.checked
    };
    return _this;
  }

  _createClass(ShowIfCheck, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(!this.state.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: 'col-100 no-gutter mb10 mt5' },
          _react2.default.createElement(
            _core.Checkbox,
            { className: 'pt-large', checked: this.state.checked, onChange: this.onChange.bind(this), name: this.props.name },
            _react2.default.createElement(
              'span',
              { className: this.props.titleClass },
              this.props.label
            )
          )
        ),
        _react2.default.createElement(
          _utils.ShowIf,
          { condition: this.state.checked },
          this.props.children
        )
      );
    }
  }]);

  return ShowIfCheck;
}(_react2.default.Component);

ShowIfCheck.defaultProps = {
  titleClass: 'name-checkbox',
  checked: false,
  className: '',
  name: ''
};

exports.default = ShowIfCheck;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (URL, filename, callback) {
  var isFull = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var withoutToken = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var urlDownload = '/api/download/files/' + URL;
  if (withoutToken === true) {
    urlDownload = '/api/download/withoutToken/files/' + URL;
  }
  if (isFull === true) {
    urlDownload = URL;
  }
  (0, _axios2.default)({
    url: urlDownload,
    method: 'GET',
    responseType: 'blob' // important
  }).then(function (response) {
    var url = window.URL.createObjectURL(new Blob([response.data]));
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    if (typeof callback === 'function') {
      callback();
    }
  });
};

var _axios = __webpack_require__(166);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (WrappedComponent) {
  var HOC = function (_React$Component) {
    _inherits(HOC, _React$Component);

    function HOC(props, context) {
      _classCallCheck(this, HOC);

      var _this = _possibleConstructorReturn(this, (HOC.__proto__ || Object.getPrototypeOf(HOC)).call(this, props, context));

      _this.validators = {};

      if (_this.props.bindValidator && _this.props.bindValidator.props.validators) {
        _this.validators = _this.props.bindValidator.props.validators;
      }
      return _this;
    }

    _createClass(HOC, [{
      key: 'validate',
      value: function validate() {
        if (typeof this.validator.validate != "function") {
          return true;
        } else {
          return this.validator.validate();
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.validator = this.refs.wrappedComponent;

        if (this.props.channel) {
          if (!this.validators[this.props.channel]) {
            this.validators[this.props.channel] = [];
          }
          this.validators[this.props.channel].unshift(this);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // this.validator = this.refs.wrappedComponent;

        // if (nextProps.channel) {
        //   if (!this.validators[nextProps.channel]) {
        //     this.validators[nextProps.channel] = [];
        //   }
        //   this.validators[this.props.channel].push(this);

        // }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.validator = {};
      }
    }, {
      key: 'render',
      value: function render() {
        // ... and renders the wrapped component with the fresh data!
        // Notice that we pass through any additional props
        return _react2.default.createElement(WrappedComponent, _extends({ ref: 'wrappedComponent' }, this.props, { validators: this.validators }));
      }
    }]);

    return HOC;
  }(_react2.default.Component);

  ;

  HOC.defaultProps = {
    validators: {}
  };

  return HOC;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLimitFile = checkLimitFile;

var _lodash = __webpack_require__(14);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkLimitFile(fileType, allowExcel) {
  var listType = ['doc', 'docx', 'pdf', 'rar', 'zip', 'jpg', 'png'];
  if (allowExcel) {
    return _lodash2.default.includes([].concat(listType, ['xls', 'xlsx']), fileType);
  }
  return _lodash2.default.includes(listType, fileType);
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  quanLyDanhMuc: [
  //   {
  //   path: '/quan-ly-danh-muc/tham-quyen',
  //   name: 'Thẩm quyền giải quyết',
  //   key: 'THAMQUYENGIAIQUYET_LIETKE'
  // },
  {
    path: '/quan-ly-danh-muc/don-thu',
    name: 'Lĩnh vực đơn thư',
    key: 'LINHVUCDONTHU_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/linh-vuc-doi-tuong-thanh-tra',
    name: 'Lĩnh vực đối tượng thanh tra',
    key: 'LINHVUCDOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/doi-tuong-thanh-tra',
    name: 'Đối tượng thanh tra',
    key: 'DOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/nhom-doi-tuong-thanh-tra',
    name: 'Nhóm đối tượng thanh tra',
    key: 'NHOMDOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/danh-muc-video',
    name: 'Danh mục Video',
    key: 'DANHMUCVIDEO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/huong-dan-su-dung',
    name: 'Hướng dẫn sử dụng',
    key: 'HUONGDANSUDUNG_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/video',
    name: 'Video',
    key: 'VIDEO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/thanh-tra-trung-uong',
    name: 'Cơ quan TTTW tại Tỉnh',
    key: 'COQUANQUANLY_LIETKE'
  }],

  quanLyDonVi: [{
    path: '/quan-ly-danh-muc/cap-hanh-chinh',
    name: 'Cấp đơn vị hành chính',
    key: 'CAPDONVIHANHCHINH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/hanh-chinh',
    name: 'Đơn vị hành chính',
    key: 'DONVIHANHCHINH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/don-vi-ngoai-he-thong',
    name: 'Đơn vị ngoài hệ thống',
    key: 'DONVINGOAIHETHONG_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/loai-cap-co-quan',
    name: 'Loại cơ quan quản lý',
    key: 'LOAICOQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/cap-co-quan',
    name: 'Cấp cơ quan quản lý',
    key: 'CAPCOQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/co-quan',
    name: 'Cơ quan quản lý',
    key: 'COQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/danh-sach-don-theo-don-vi',
    name: 'Xóa đơn trong đơn vị',
    key: 'THAYDOIDONTRONGDONVI_LIETKE'
  }],

  quanLyNguoiDung: [{
    path: '/quan-ly-danh-muc/cong-chuc',
    name: 'Danh sách người dùng',
    key: 'CONGCHUC_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/quoc-tich',
    name: 'Quốc tịch',
    key: 'QUOCTICH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/dan-toc',
    name: 'Dân tộc',
    key: 'DANTOC_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/chuc-vu',
    name: 'Chức vụ',
    key: 'CHUCVU_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/vai-tro',
    name: 'Nhóm vai trò',
    key: 'VAITRO_LIETKE'
  }],

  cauHinhHeThong: [{
    path: '/quan-ly-danh-muc/tham-so',
    name: 'Tham số',
    key: 'THAMSO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/tu-dong-bao-cao',
    name: 'Cấu hình báo cáo',
    key: 'CAUHINHBAOCAO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/quan-ly-quy-trinh',
    name: 'Quản lý quy trình',
    key: 'PROCESS_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/cau-hinh-ke-hoach-thanh-tra',
    name: 'Cấu hình kế hoạch thanh tra',
    key: 'CAUHINHKEHOACHTHANHTRA_SUA'
  }],

  thongKeBaoCaoDon: [{
    path: '/thong-ke-bao-cao/tong-hop-tiep-cong-dan',
    name: '2a - Tổng hợp kết quả tiếp công dân',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-xu-ly-don',
    name: '2b - Tổng hợp kết quả xử lý đơn',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-gqd-khieu-nai',
    name: '2c - Tổng hợp kết quả GQD KN',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-gqd-to-cao',
    name: '2d - Tổng hợp kết quả GQD TC',
    key: 'TONGHOPBAOCAO_LIETKE'
  }],

  thongKeBaoCaoThanhTra: [{
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-hanh-chinh',
    name: '[01-TT] Tổng hợp kết quả thanh tra hành chính',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-ket-luan-thanh-tra-hanh-chinh',
    name: '[02-TT] Tổng hợp kết quả thực hiện kết luận thanh tra hành chính',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-xay-dung-co-ban',
    name: '[03-TT] Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đầu tư xây dựng cơ bản',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-tai-chinh',
    name: '[04-TT] Tổng hợp kết quả thanh tra trong lĩnh vực tài chính ngân sách',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-dat-dai',
    name: '[05-TT] Tổng hợp kết quả thanh tra trong lĩnh vực đất đai',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
    name: '[06-TT] Tổng hợp kết quả thanh tra, kiểm tra chuyên ngành',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-quyet-dinh-xu-phat-qua-thanh-tra-kiem-tra-chuyen-nganh',
    name: '[07-TT] Tổng hợp kết quả thực hiện kết luận, quyết định xử phạt qua thanh tra, kiểm tra chuyên ngành',
    key: 'TONGHOPBAOCAO_LIETKE'
  }],

  baoCaoKiemTra: [{
    path: '/thong-ke-bao-cao/kiem-tra-chi-tiet-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra chi tiết doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/kiem-tra-theo-ke-hoach-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra theo kế hoạch doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/kiem-tra-dot-xuat-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra đột xuất doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra',
    name: 'Tổng hợp kết quả thanh tra, kiểm tra doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }]
};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  dataSearch: {},
  goBack: false
};

function baoCaoDinhKy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'BCDK_UPDATE_DATA_SEARCH':
      newState.dataSearch = action.dataSearch;
      return newState;
    case 'BCDK_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'BCDK_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

exports.baoCaoDinhKy = baoCaoDinhKy;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  dataSearch: {},
  goBack: false
};

function baoCaoTongHop() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'BCTH_UPDATE_DATA_SEARCH':
      newState.dataSearch = action.dataSearch;
      return newState;
    case 'BCTH_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'BCTH_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

exports.baoCaoTongHop = baoCaoTongHop;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  dataSearch: {},
  goBack: false,
  namThanhTra: []
};

function danhSachKHThanhTra() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'SET_NAM_THANH_TRA':
      newState.namThanhTra = action.data;
      return newState;
    case 'DSTT_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'DSTT_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

exports.danhSachKHThanhTra = danhSachKHThanhTra;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCuocThanhTra = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(14);

var initialState = {
  data: {},
  dataDoiTuong: [],
  dataDXOld: [],
  totalDataDeXuat: []
};

function dataCuocThanhTra() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'LOAD_DATA':
      newState.data = action.data;
      return newState;
    case 'RESET_DATA':
      newState.data = [];
      return newState;
    case 'ADD_DEXUAT':
      var dataDX = {
        idDeXuatOld: action.id,
        dataDeXuatOld: action.dataDeXuat,
        dataDeXuatsOld: action.dataDeXuats,
        hasDeXuatXuLy: action.hasDataDeXuat
      };
      if ((0, _lodash.isEmpty)(newState.dataDXOld)) {
        newState.dataDXOld.push(dataDX);
      } else {
        newState.dataDXOld.forEach(function (item, index) {
          if (item.idDeXuatOld === action.id) {
            newState.dataDXOld.splice(index, 1);
          }
        });
        newState.dataDXOld.push(dataDX);
      }
      return newState;
    case 'UPDATE_DEXUAT':
      var dataTemp = {
        dataDeXuat: action.dataDeXuat,
        dataDeXuats: action.dataDeXuats,
        id: action.idCTT
      };
      if ((0, _lodash.isEmpty)(newState.totalDataDeXuat)) {
        newState.totalDataDeXuat.push(dataTemp);
      } else {
        newState.totalDataDeXuat.forEach(function (item, index) {
          if (item.id === action.idCTT) {
            newState.totalDataDeXuat.splice(index, 1);
          }
        });
        newState.totalDataDeXuat.push(dataTemp);
      }
      if (action.hasXuLy) {
        newState.hasXuLy = action.hasXuLy;
      }
      return newState;
    case 'RESET_DEXUAT':
      if (!(0, _lodash.isEmpty)(newState.dataDXOld) && !(0, _lodash.isEmpty)(newState.totalDataDeXuat)) {
        // Set đề xuất bằng đề xuất cũ
        var resetDeXuat = newState.totalDataDeXuat.map(function (item) {
          newState.dataDXOld.forEach(function (e) {
            if (e.idDeXuatOld === item.id) {
              return item = {
                dataDeXuat: e.dataDeXuatOld,
                dataDeXuats: e.dataDeXuatsOld,
                id: e.idDeXuatOld
              };
            }
          });
          return item;
        });
        newState.totalDataDeXuat = resetDeXuat;
      }
      return newState;
    case 'ADD_DOITUONGID':
      var id = action.idCTT;
      var data = {
        arrDoiTuongThemMoi: action.arrDoiTuongThemMoi,
        arrDoiTuongXoa: action.arrDoiTuongXoa,
        idCTT: action.idCTT
      };
      if ((0, _lodash.isEmpty)(newState.dataDoiTuong)) {
        newState.dataDoiTuong.push(data);
      } else {
        newState.dataDoiTuong.forEach(function (item, index) {
          if (item.idCTT === id) {
            newState.dataDoiTuong.splice(index, 1);
          }
        });
        newState.dataDoiTuong.push(data);
      }
      return newState;
    default:
      return newState;
  }
}

exports.dataCuocThanhTra = dataCuocThanhTra;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  data: {}
};

function dataList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'UPDATE_DATALIST':
      newState.data[action.key] = action.data;
      return newState;
    case 'DELETE_ITEM_DATALIST':
      var Data = newState.data[action.key];
      Data = Data.filter(function (item) {
        return item[action.idKey] != action.id;
      });
      newState.data[action.key] = Data;
      return newState;
    default:
      return newState;
  }
}

exports.dataList = dataList;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loaiDonThu: [],
  huongXuLy: [],
  huongXuLyDon: [],
  nguonDon: [],
  loaiTaiLieuList: [],
  tinhTrangTaiLieuList: [],
  phanLoaiNguoiDungDonList: [],
  loaiTepDinhKemList: [],
  notifyTongXLD: { tongSoDon: 0 },
  notifyTongDonDK: { tongSoDon: 0 },
  notifyTongGQD: { tongSoDon: 0 },
  notifyTongDonDX: { tongSoDon: 0 },
  notifyTongDonYC: { tongSoDon: 0 },
  notifyTongDonTDTH: { tongSoDon: 0 },
  notify: {},
  initIDTP: false,
  showForm: false,
  init: false
};

function duLieuHeThong() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'CAPNHAT_DULIEUHETHONG':
      var newState = _extends({}, state);
      action.duLieuHeThong.map(function (dulieu, i) {
        newState[dulieu.key] = dulieu.data;
      });
      return newState;
    case 'INIT_DULIEU':
      newState = _extends({}, state, {
        init: action.value
      });
      return newState;
    case 'GET_TPID':
      newState = _extends({}, state, {
        initIDTP: action.value
      });
      return newState;
    case 'NEW_MSG':
      newState = _extends({}, state, {
        notify: action.data
      });
      return newState;
    case 'REFRESH_MENU':
      newState = _extends({}, state, {
        refreshMenu: action.value
      });
      return newState;
    case 'UPDATE_TONGDON':
      newState = _extends({}, state, _defineProperty({}, action.key, { tongSoDon: action.value }));
      return newState;
    case 'RESET_DLHT':
      newState = _extends({}, state, {
        huongXuLyDon: [],
        ketQuaTiepDan: [],
        coQuanTiepNhan: [],
        ketLuanNoiDungKhieuNai: [],
        ketQuaThucHien: [],
        lanhDaoList: [],
        thamSo: [],
        loaiDonThu: [],
        huongXuLy: [],
        nguonDon: [],
        loaiTaiLieuList: [],
        tinhTrangTaiLieuList: [],
        phanLoaiNguoiDungDonList: [],
        loaiTepDinhKemList: [],
        ketQuaGiaiQuyetDon: [],
        noiCapCMND: [],
        donViTTXM: [],
        coQuanTiepDanList: [],
        loaiDoiTuong: [],
        donViHanhChinh: [],
        donViChuTri: [],
        loaiVuViecList: [],
        capCoQuanDaGiaiQuyet: [],
        coQuanDaGiaiQuyet: [],
        danToc: [],
        donViThongKe: [],
        hinhThucDaGiaiQuyet: [],
        huongGiaiQuyetCuaLanhDao: [],
        ketQuaGiaiQuyetLanHai: [],
        capQuanHuyen: [],
        loaiKyThongKe: [],
        namThongKe: [],
        loaiQuyThongKe: [],
        thangThongKe: [],
        nhomThamQuyenGiaiQuyet: [],
        phongBanThuocCoQuan: [],
        capPhuongXa: [],
        quocTich: [],
        capTinhThanhPho: [],
        trangThaiDon: [],
        coQuanDieuTra: [],
        init: false
      });
      return newState;
    case 'DISPLAY_FORM':
      newState = _extends({}, state, {
        showForm: action.value
      });
      return newState;
    default:
      return state;
  }
}

exports.duLieuHeThong = duLieuHeThong;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formDataTiepCongDan = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _toastr = __webpack_require__(11);

var _message = __webpack_require__(10);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var nguoiDungDon = {
  hoVaTen: '',
  soDienThoai: '',
  soCMNDHoChieu: '',
  noiCap: '',
  ngaySinh: '',
  ngayCap: '',
  gioiTinh: 'male',
  diaChi: '',
  tinhThanhId: localStorage.getItem('tpdnId') || '',
  tinhThanhCongDan: {
    ten: ''
  },
  quanHuyenId: '',
  quanHuyenCongDan: {
    ten: ''
  },
  phuongXaId: '',
  phuongXaCongDan: {
    ten: ''
  },
  toThon: '',
  quocTichId: '',
  danTocId: '',
  donCongDanId: '',
  congDanId: ''
};

var initialState = {
  nguoiDungDon: [_extends({}, nguoiDungDon)],
  nguoiUyQuyen: _extends({}, nguoiDungDon),
  thongTinDonThu: {},
  editData: {},
  soTiepCongDan: {
    listTaiLieuVanThu: []
  },
  PopupViewAllResult: false,
  PopupChiTietCongDan: false,
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  thongTinXuLyGiaiQuyet: {},
  tuKhoa: '',
  index: '',
  showField: false
};

function formDataTiepCongDan() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'RESET_FORM':
      return _extends({}, state, initialState);
    case 'CHANGE_STATE_LOAIDON':
      return _extends({}, state, {
        popupConfirmSaveLoaiDon: action.data
      });
    case 'CHANGE_STATE_HUONGXULY':
      return _extends({}, state, {
        popupConfirmSaveHuongXuLy: action.data
      });
    case 'CAPNHAT_TPID':
      state.nguoiDungDon[0].tinhThanhId = nguoiDungDon.tinhThanhId = localStorage.getItem('tpdnId') || '';
      return _extends({}, state);
    case 'INIT_NGUOI_DAI_DIEN_CO_QUAN':
      state.nguoiDungDon.splice(1);
      return _extends({}, state);
    case 'INIT_EDIT_FORM':
      return _extends({}, state, {
        editData: action.data,
        soTiepCongDan: action.STCD
      });
    case 'REMOVE_LOAIDON_EDIT_FORM':
      return _extends({}, state, {
        soTiepCongDan: _extends({}, state.soTiepCongDan, {
          listTaiLieuVanThu: action.data
        })
      });
    case 'THEM_NGUOI_DUNG_DON':
      var newNguoiDungDon = _extends({}, nguoiDungDon);

      return _extends({}, state, {
        nguoiDungDon: [].concat(_toConsumableArray(state.nguoiDungDon), [newNguoiDungDon])
      });
    case 'DISPLAY_FIELD':
      newState = _extends({}, state, {
        showField: action.value
      });
      return newState;
    case 'CHON_CONG_DAN':
      var newState = {};
      var isExist = false;
      var newData = {};
      state.nguoiDungDon.map(function (item, i) {
        if (item.congDanId == action.data.congDanId) {
          isExist = true;
        }
      });
      if (state.nguoiUyQuyen.congDanId == action.data.congDanId) {
        isExist = true;
      }
      if (isExist) {
        (0, _toastr.Toastr)(_message.msg.congDanExist, 'warning');
        return _extends({}, state);
      } else {
        var removeDonCongDanId = '';
        newData = {
          hoVaTen: action.data.hoVaTen,
          soDienThoai: action.data.soDienThoai,
          soCMNDHoChieu: action.data.soCMNDHoChieu,
          diaChi: action.data.diaChi,
          congDanId: action.data.congDanId,
          noiCap: action.data.noiCapCMNDInfo ? { value: action.data.noiCapCMNDInfo.coQuanQuanLyId, label: action.data.noiCapCMNDInfo.ten } : '',
          ngaySinh: action.data.ngaySinh ? new Date(action.data.ngaySinh) : '',
          ngayCap: action.data.ngayCap ? new Date(action.data.ngayCap) : '',
          gioiTinh: action.data.gioiTinh ? 'male' : 'female',
          tinhThanhId: action.data.tinhThanhCongDan ? action.data.tinhThanhCongDan.donViHanhChinhId : '',
          tinhThanhCongDan: action.data.tinhThanhCongDan,
          quanHuyenId: action.data.quanHuyenCongDan ? action.data.quanHuyenCongDan.donViHanhChinhId : '',
          quanHuyenCongDan: action.data.quanHuyenCongDan ? action.data.quanHuyenCongDan : { ten: '' },
          phuongXaId: action.data.phuongXaCongDan ? action.data.phuongXaCongDan.donViHanhChinhId : '',
          phuongXaCongDan: action.data.phuongXaCongDan ? action.data.phuongXaCongDan : { ten: '' },
          toThon: action.data.toThon,
          quocTichId: action.data.quocTichCongDan ? action.data.quocTichCongDan.quocTichId : '',
          danTocId: action.data.danTocCongDan ? action.data.danTocCongDan.danTocId : ''
        };
        newData.donCongDanId = action.donCongDanId ? action.donCongDanId : '';
        if (state.nguoiDungDon[action.index] && state.nguoiDungDon[action.index].donCongDanId) {
          removeDonCongDanId = state.nguoiDungDon[action.index].donCongDanId;
        }
        if (action.index == -1) {
          newState = { nguoiUyQuyen: newData };
        } else {
          var nguoiDungDons = [].concat(_toConsumableArray(state.nguoiDungDon));
          nguoiDungDons[action.index] = newData;
          newState = { nguoiDungDon: nguoiDungDons };
        }
        return _extends({}, state, newState, {
          PopupViewAllResult: false,
          PopupChiTietCongDan: false,
          removeDonCongDanId: removeDonCongDanId
        });
      }
    case 'CHON_DON_THU':
      action.data.listTaiLieuBangChung.map(function (item) {
        item.tinhTrang = item.tinhTrangTaiLieu;
      });
      action.data.layVuViecCu = true;
      return _extends({}, state, {
        thongTinDonThu: action.data,
        PopupViewAllResult: false,
        PopupChiTietCongDan: false
      });
    case 'XOA_NGUOI_DUNG_DON':
      return _extends({}, state, {
        nguoiDungDon: state.nguoiDungDon.filter(function (item) {
          return item != action.data;
        })
      });
    case 'TOGGLE_DIALOG':
      newState = _extends({}, state, (_extends2 = {}, _defineProperty(_extends2, action.data.name, action.data.status), _defineProperty(_extends2, 'tuKhoa', action.keyword), _defineProperty(_extends2, 'index', action.index), _extends2));
      if (action.viewDetailCongDanId) {
        newState.viewDetailCongDanId = action.viewDetailCongDanId;
      }
      return newState;
    case 'CAP_NHAT_THONG_TIN_CA_NHAN':
      if (action.index == -1) {
        newState = { nguoiUyQuyen: action.data };
      } else {
        newData = [].concat(_toConsumableArray(state.nguoiDungDon));
        newData[action.index] = action.data;
        newState = { nguoiDungDon: newData };
      }
      return _extends({}, state, newState);
    case 'THONG_TIN_XU_LY_GIAI_QUYET':
      return _extends({}, state, {
        thongTinXuLyGiaiQuyet: action.data
      });
    default:
      return state;
  }
}

exports.formDataTiepCongDan = formDataTiepCongDan;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = undefined;

var _redux = __webpack_require__(63);

var _reactRouterRedux = __webpack_require__(827);

var _duLieuHeThong = __webpack_require__(1590);

var _baoCaoDinhKy = __webpack_require__(1585);

var _baoCaoTongHop = __webpack_require__(1586);

var _danhSachKHThanhTra = __webpack_require__(1587);

var _formDataTiepCongDan = __webpack_require__(1591);

var _dataList = __webpack_require__(1589);

var _dataCuocThanhTra = __webpack_require__(1588);

var _xuLyTrung = __webpack_require__(1593);

var rootReducer = (0, _redux.combineReducers)({
  duLieuHeThong: _duLieuHeThong.duLieuHeThong,
  baoCaoDinhKy: _baoCaoDinhKy.baoCaoDinhKy,
  baoCaoTongHop: _baoCaoTongHop.baoCaoTongHop,
  danhSachKHThanhTra: _danhSachKHThanhTra.danhSachKHThanhTra,
  dataList: _dataList.dataList,
  dataCuocThanhTra: _dataCuocThanhTra.dataCuocThanhTra,
  xuLyTrung: _xuLyTrung.xuLyTrung,
  formDataTiepCongDan: _formDataTiepCongDan.formDataTiepCongDan,
  routing: _reactRouterRedux.routerReducer
});

exports.rootReducer = rootReducer;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  data: {},
  listSelected: []
};

function xuLyTrung() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var newState = _extends({}, state);
  switch (action.type) {
    case 'UPDATE_XULYTRUNG':
      newState.data = action.data;
      return newState;
    case 'RESETDATA_XULYTRUNG':
      newState.data = [];
      return newState;
    case 'ADD_DANH_SACH_TTT_SELECTED':
      newState.listSelected = action.data;
      localStorage.setItem('listSelectThanhTraTrung', JSON.stringify(action.data));
      return newState;
    case 'RESET_LIST_SELECT_TTT':
      newState.listSelected = [];
      localStorage.removeItem('listSelectThanhTraTrung');
      return newState;
    default:
      return newState;
  }
}

exports.xuLyTrung = xuLyTrung;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;

var _app = __webpack_require__(956);

var _app2 = _interopRequireDefault(_app);

var _pages = __webpack_require__(1450);

var _Parameter = __webpack_require__(473);

var _Parameter2 = _interopRequireDefault(_Parameter);

var _TuDongBaoCao = __webpack_require__(1042);

var _TuDongBaoCao2 = _interopRequireDefault(_TuDongBaoCao);

var _CauHinhKHTT = __webpack_require__(472);

var _CauHinhKHTT2 = _interopRequireDefault(_CauHinhKHTT);

var _Process = __webpack_require__(474);

var _Process2 = _interopRequireDefault(_Process);

var _CongDanTraCuu = __webpack_require__(1428);

var _CongDanTraCuu2 = _interopRequireDefault(_CongDanTraCuu);

var _KetQuaCongDanTraCuu = __webpack_require__(1431);

var _KetQuaCongDanTraCuu2 = _interopRequireDefault(_KetQuaCongDanTraCuu);

var _GiamSatTraCuu = __webpack_require__(1430);

var _GiamSatTraCuu2 = _interopRequireDefault(_GiamSatTraCuu);

var _home = __webpack_require__(484);

var _thongKe = __webpack_require__(1423);

var _changePassword = __webpack_require__(1074);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _forgotPassword = __webpack_require__(1100);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _resetPassword = __webpack_require__(1317);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _CanBoTraCuu = __webpack_require__(1426);

var _CanBoTraCuu2 = _interopRequireDefault(_CanBoTraCuu);

var _ChiTietTraCuu = __webpack_require__(1427);

var _ChiTietTraCuu2 = _interopRequireDefault(_ChiTietTraCuu);

var _baoCaoDinhKy = __webpack_require__(993);

var _baoCaoDinhKy2 = _interopRequireDefault(_baoCaoDinhKy);

var _baoCaoTongHop = __webpack_require__(1018);

var _baoCaoTongHop2 = _interopRequireDefault(_baoCaoTongHop);

var _LapBaoCaoTongHop = __webpack_require__(999);

var _LapBaoCaoTongHop2 = _interopRequireDefault(_LapBaoCaoTongHop);

var _ChiTietDoiTuongTrung = __webpack_require__(492);

var _ChiTietDoiTuongTrung2 = _interopRequireDefault(_ChiTietDoiTuongTrung);

var _ThemMoiKeHoachThanhTra = __webpack_require__(493);

var _ThemMoiKeHoachThanhTra2 = _interopRequireDefault(_ThemMoiKeHoachThanhTra);

var _BaoCaoDinhKyChiTiet = __webpack_require__(973);

var _BaoCaoDinhKyChiTiet2 = _interopRequireDefault(_BaoCaoDinhKyChiTiet);

var _DanhSachDonViBCTH = __webpack_require__(998);

var _DanhSachDonViBCTH2 = _interopRequireDefault(_DanhSachDonViBCTH);

var _DanhSachBaoCaoBCTH = __webpack_require__(997);

var _DanhSachBaoCaoBCTH2 = _interopRequireDefault(_DanhSachBaoCaoBCTH);

var _ChiTietDonViBCTH = __webpack_require__(996);

var _ChiTietDonViBCTH2 = _interopRequireDefault(_ChiTietDonViBCTH);

var _ChiTietBaoCaoTaiDonVi = __webpack_require__(995);

var _ChiTietBaoCaoTaiDonVi2 = _interopRequireDefault(_ChiTietBaoCaoTaiDonVi);

var _LapBaoCaoDinhKy = __webpack_require__(974);

var _LapBaoCaoDinhKy2 = _interopRequireDefault(_LapBaoCaoDinhKy);

var _AutoLogin = __webpack_require__(1234);

var _AutoLogin2 = _interopRequireDefault(_AutoLogin);

var _ThongTinChiTietCuocThanhTra = __webpack_require__(1328);

var _ThongTinChiTietCuocThanhTra2 = _interopRequireDefault(_ThongTinChiTietCuocThanhTra);

var _KeHoachThanhTraDetails = __webpack_require__(1324);

var _KeHoachThanhTraDetails2 = _interopRequireDefault(_KeHoachThanhTraDetails);

var _NotificationDetails = __webpack_require__(1326);

var _NotificationDetails2 = _interopRequireDefault(_NotificationDetails);

var _LoadingThongBao = __webpack_require__(1325);

var _LoadingThongBao2 = _interopRequireDefault(_LoadingThongBao);

var _DanhSachThongBao = __webpack_require__(1322);

var _DanhSachThongBao2 = _interopRequireDefault(_DanhSachThongBao);

var _DanhSachQuanLyHoSo = __webpack_require__(1240);

var _DanhSachQuanLyHoSo2 = _interopRequireDefault(_DanhSachQuanLyHoSo);

var _ChiTietQuanLyHoSo = __webpack_require__(1239);

var _ChiTietQuanLyHoSo2 = _interopRequireDefault(_ChiTietQuanLyHoSo);

var _TheLoaiVanBan = __webpack_require__(1254);

var _TheLoaiVanBan2 = _interopRequireDefault(_TheLoaiVanBan);

var _LinhVucVanBan = __webpack_require__(1249);

var _LinhVucVanBan2 = _interopRequireDefault(_LinhVucVanBan);

var _CoQuanBanHanhVanBan = __webpack_require__(1247);

var _CoQuanBanHanhVanBan2 = _interopRequireDefault(_CoQuanBanHanhVanBan);

var _NhomHoSo = __webpack_require__(1241);

var _NhomHoSo2 = _interopRequireDefault(_NhomHoSo);

var _DanhMucVanBan = __webpack_require__(1248);

var _DanhMucVanBan2 = _interopRequireDefault(_DanhMucVanBan);

var _ThemMoiVanBan = __webpack_require__(1255);

var _ThemMoiVanBan2 = _interopRequireDefault(_ThemMoiVanBan);

var _reception = __webpack_require__(129);

var _category = __webpack_require__(1072);

var _receptionPeriodical = __webpack_require__(1275);

var _receptionUnexpectedly = __webpack_require__(1282);

var _handleLetters = __webpack_require__(143);

var _handleLettersOld = __webpack_require__(309);

var _login = __webpack_require__(1238);

var _login2 = _interopRequireDefault(_login);

var _giaiQuyetDon = __webpack_require__(142);

var _theoDoiThucHien = __webpack_require__(239);

var _donDaGiaiQuyet = __webpack_require__(1098);

var _DanhSachLichSuXuLyTTT = __webpack_require__(1321);

var _DanhSachLichSuXuLyTTT2 = _interopRequireDefault(_DanhSachLichSuXuLyTTT);

var _XuLyThanhTraTrung = __webpack_require__(1332);

var _XuLyThanhTraTrung2 = _interopRequireDefault(_XuLyThanhTraTrung);

var _ChiTietNoiDungXuLy = __webpack_require__(1318);

var _ChiTietNoiDungXuLy2 = _interopRequireDefault(_ChiTietNoiDungXuLy);

var _DanhSachTongHopKHTT = __webpack_require__(1323);

var _DanhSachTongHopKHTT2 = _interopRequireDefault(_DanhSachTongHopKHTT);

var _loginSso = __webpack_require__(1233);

var _loginSso2 = _interopRequireDefault(_loginSso);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import KetQuaKiemTraChiTietDoanhNghiepPage from '../components/pages/thong-ke-bao-cao/KetQuaKiemTraChiTietDoanhNghiep';


function routes(_ref) {
  var dispatch = _ref.dispatch;

  return [{
    path: "/",
    component: _app2.default,
    indexRoute: {
      component: _home.Home,
      name: 'home'
    },
    childRoutes: [{
      path: '/tiep-cong-dan',
      name: 'tiepcongdan',
      component: _reception.ListReception
    }, {
      path: '/tong-hop/don-tre-han-xu-ly-tai-don-vi',
      name: 'dontrehanxulytaidonvi',
      component: _pages.TongHopDonTreHanXuLy
    }, {
      path: '/tong-hop/don-tre-han-giai-quyet-tai-don-vi',
      name: 'dontrehangiaiquyettaidonvi',
      component: _pages.TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tong-hop/don-tre-han-xu-ly-tai-dia-ban',
      name: 'dontrehanxulytaidiaban',
      component: _pages.TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tong-hop/don-tre-han-giai-quyet-tai-dia-ban',
      name: 'dontrehangiaiquyettaidiaban',
      component: _pages.TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tiep-cong-dan/thuong-xuyen/:type(/:id)',
      name: 'tiepcongdan',
      type: 'thuongXuyen',
      component: _reception.AddReception
    }, {
      path: '/tiep-cong-dan/chi-tiet-don/:id',
      name: 'tiepcongdan',
      component: _reception.DetailReception
    }, {
      path: '/quan-ly-danh-muc/tham-quyen',
      name: 'danhmuc',
      component: _category.ThamQuyen
    }, {
      path: '/quan-ly-danh-muc/huong-dan-su-dung',
      name: 'danhmuc',
      component: _category.HuongDanSuDung
    }, {
      path: '/quan-ly-danh-muc/loai-tai-lieu',
      name: 'danhmuc',
      component: _category.LoaiTaiLieu
    }, {
      path: '/quan-ly-danh-muc/cap-co-quan',
      component: _category.OrganizationLevel,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/co-quan',
      component: _category.Organization,
      name: 'danhmuc',
      type: 'co-quan'
    }, {
      path: '/quan-ly-danh-muc/thanh-tra-trung-uong',
      component: _category.Organization,
      name: 'danhmuc',
      type: 'trung-uong'
    }, {
      path: '/quan-ly-danh-muc/cap-hanh-chinh',
      component: _category.CapDonViHanhChinh,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/chuc-vu',
      component: _category.Position,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/quoc-tich',
      component: _category.QuocTich,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/dan-toc',
      component: _category.DanToc,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/don-thu',
      component: _category.Letters,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/vai-tro',
      component: _category.Role,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/hanh-chinh',
      component: _category.Administrative,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/cong-chuc',
      name: 'danhmuc',
      component: _category.CongChuc
    }, {
      path: '/quan-ly-danh-muc/danh-muc-video',
      name: 'danhmuc',
      component: _category.DanhMucVideo
    }, {
      path: '/quan-ly-danh-muc/video',
      name: 'danhmuc',
      component: _category.Video
    }, {
      path: '/quan-ly-danh-muc/linh-vuc-doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: _category.LinhVucDoiTuongThanhTra
    }, {
      path: '/quan-ly-danh-muc/don-vi-ngoai-he-thong',
      name: 'danhmuc',
      component: _category.DonViNgoai
    }, {
      path: '/quan-ly-danh-muc/doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: _category.DoiTuongThanhTra
    }, {
      path: 'quan-ly-danh-muc/nhom-doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: _category.NhomDoiTuongThanhTra
    }, {
      path: '/quan-ly-danh-muc/tham-so',
      name: 'danhmuc',
      component: _Parameter2.default
    }, {
      path: '/quan-ly-danh-muc/tu-dong-bao-cao',
      name: 'danhmuc',
      component: _TuDongBaoCao2.default
    }, {
      path: '/quan-ly-danh-muc/quan-ly-quy-trinh',
      name: 'danhmuc',
      component: _Process2.default
    }, {
      // Cấu hình kế hoạch thanh tra
      path: '/quan-ly-danh-muc/cau-hinh-ke-hoach-thanh-tra',
      name: 'danhmuc',
      component: _CauHinhKHTT2.default
    }, {
      path: '/quan-ly-danh-muc/loai-cap-co-quan',
      name: 'danhmuc',
      component: _category.TypeOfOrganizationLevel
    }, {
      path: '/quan-ly-danh-muc/cap-nhat-nguoi-dung',
      name: 'danhmuc',
      component: _category.CapNhatNguoiDung
    }, {
      path: '/quan-ly-danh-muc/danh-sach-don-theo-cong-chuc',
      name: 'danhmuc',
      component: _category.DanhSachDonTheoCongChuc
    }, {
      path: '/quan-ly-danh-muc/danh-sach-don-theo-don-vi',
      name: 'danhmuc',
      component: _category.DanhSachDonTheoDonVi
    }, {
      path: '/tiep-cong-dan/dinh-ky',
      name: 'tiepcongdan',
      component: _receptionPeriodical.ReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/danh-sach-yeu-cau',
      name: 'tiepcongdan',
      component: _receptionPeriodical.DanhSachYeuCau
    }, {
      path: '/tiep-cong-dan/dinh-ky/them-moi',
      name: 'tiepcongdan',
      component: _receptionPeriodical.AddReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/dinh-ky/chi-tiet/:id',
      name: 'tiepcongdan',
      type: 'dinhKy',
      component: _receptionPeriodical.DetailReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/lanh-dao/:type(/:id)',
      name: 'tiepcongdan',
      type: 'lanhDao',
      component: _reception.AddReception
    }, {
      path: '/tiep-cong-dan/dot-xuat',
      name: 'tiepcongdan',
      component: _receptionUnexpectedly.ReceptionUnexpectedly
    }, {
      path: '/tiep-cong-dan/dot-xuat/chi-tiet/:id',
      name: 'tiepcongdan',
      type: 'dotXuat',
      component: _receptionPeriodical.DetailReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/:id',
      name: 'tiepcongdan',
      component: _pages.CanBoNhanKetQuaKiemTraDeXuatPage
    }, {
      path: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/hoan-thanh/:id',
      name: 'tiepcongdan',
      component: _pages.KetQuaCanBoNhanKetQuaKiemTraDeXuatPage
    }, {
      path: '/xu-ly-don-cu',
      name: 'xulydoncu',
      component: _pages.HandleLettersOldPage
    }, {
      path: '/chi-tiet-don-cu/:id',
      name: 'xulydoncu',
      component: _handleLettersOld.HandleLettersOldDetails
    }, {
      path: 'thu-hoi-xu-ly-don-cu/:typePage/:trangThaiDon/:id',
      name: 'xulydoncu',
      component: _pages.ThuHoiXuLyDonOldPage
    }, {
      path: '/xu-ly-don-cu/:type(/:id)',
      component: _pages.AddHandleLettersOldPage,
      name: 'xulydoncu'
    }, {
      path: '/xu-ly-don',
      name: 'xulydon',
      component: _pages.HandleLettersPage
    }, {
      path: '/chi-tiet-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'xulydon',
      component: _handleLetters.HandleLettersDetails
    }, {
      path: 'thu-hoi-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'xulydon',
      component: _pages.ThuHoiXuLyDonPage
    }, {
      path: '/xu-ly-don/:type(/:id)',
      component: _pages.AddHandleLettersPage,
      name: 'xulydon'
    }, {
      path: '/dang-nhap',
      type: 'NORMAL',
      component: _login2.default
    }, {
      path: '/login',
      type: 'NORMAL',
      component: _loginSso2.default
    }, {
      path: '/dang-nhap-sso',
      type: 'SSO',
      component: _login2.default
    }, {
      path: '/sso-error',
      type: 'SSOERR',
      component: _login2.default
    }, {
      path: '/quen-mat-khau',
      component: _forgotPassword2.default
    }, {
      path: '/tao-mat-khau-moi/:code',
      component: _resetPassword2.default
    }, {
      path: '/thay-doi-mat-khau',
      name: 'setting',
      component: _changePassword2.default
    }, {
      path: '/giai-quyet-don',
      component: _pages.GiaiQuyetDonPage,
      name: 'giaiquyet'
    }, {
      path: '/giai-quyet-don/:type/:id',
      name: 'giaiquyet',
      component: _giaiQuyetDon.XuLyGiaiQuyetDon
    }, {
      path: '/tpth-giai-quyet-don/:type/:id',
      name: 'giaiquyet',
      component: _pages.TruongPhongThuHoiPage
    }, {
      path: '/tu-giai-quyet-don/:id',
      name: 'giaiquyet',
      component: _pages.TuGiaiQuyetDonPage
    },
    // Thong ke bao cao
    {
      path: '/thong-ke-bao-cao/tong-hop-gqd-to-cao',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaGQDTCPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-tiep-cong-dan',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaTiepCongDanPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-gqd-khieu-nai',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaGQDKNPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-xu-ly-don',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaXuLyDonPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-hanh-chinh',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThanhTraHanhChinhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-xay-dung-co-ban',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThanhTraXayDungCoBanPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-tai-chinh',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThanhTraTaiChinhNganSachPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-dat-dai',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThanhTraDatDaiPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-luan-thanh-tra-hanh-chinh',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-quyet-dinh-xu-phat-qua-thanh-tra-kiem-tra-chuyen-nganh',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
      name: 'thongkebaocao',
      component: _pages.TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-chi-tiet-doanh-nghiep',
      name: 'thongkebaocao',
      component: _pages.KetQuaKiemTraChiTietDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-theo-ke-hoach-doanh-nghiep',
      name: 'thongkebaocao',
      component: _pages.KetQuaKiemTraTheoKeHoachDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-dot-xuat-doanh-nghiep',
      name: 'thongkebaocao',
      component: _pages.KetQuaKiemTraDotXuatDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra',
      name: 'thongkebaocao',
      component: _pages.TongHopKetQuaThanhTraPage
    }, {
      path: '/bao-cao-tham-nhung',
      name: 'baocaothamnhung',
      component: _pages.TongHopKetQuaThanhTraThamNhungPage
    }, {
      path: '/thong-ke-bao-cao/bao-cao-dinh-ky',
      name: 'thongkebaocao',
      component: _baoCaoDinhKy2.default
    }, {
      path: '/thong-ke-bao-cao/bao-cao-dinh-ky-chi-tiet/:id',
      name: 'thongkebaocao',
      component: _BaoCaoDinhKyChiTiet2.default
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop',
      name: 'thongkebaocao',
      component: _baoCaoTongHop2.default
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-don-vi/:id',
      name: 'thongkebaocao',
      component: _DanhSachDonViBCTH2.default
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-bao-cao/:id',
      name: 'thongkebaocao',
      component: _DanhSachBaoCaoBCTH2.default
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/chi-tiet-don-vi/:id',
      name: 'thongkebaocao',
      component: _ChiTietDonViBCTH2.default
    }, {
      path: '/chi-tiet-bao-cao-tong-hop-cua-don-vi/:id',
      name: 'thongkebaocao',
      component: _ChiTietBaoCaoTaiDonVi2.default
    }, {
      path: '/thong-ke-bao-cao/lap-bao-cao-tong-hop/:id',
      name: 'thongkebaocao',
      component: _LapBaoCaoTongHop2.default
    }, {
      path: '/thong-ke-bao-cao/lap-bao-cao-dinh-ky/:id',
      name: 'thongkebaocao',
      component: _LapBaoCaoDinhKy2.default
    }, {
      path: '/thanh-tra',
      name: 'thanhtra',
      component: _pages.DanhSachThanhTraPage
    }, {
      path: '/thanh-tra/them-moi-ke-hoach-thanh-tra',
      name: 'thanhtra',
      type: 'new',
      component: _ThemMoiKeHoachThanhTra2.default
    }, {
      path: '/thanh-tra/them-moi-ke-hoach-bo-sung/:id',
      name: 'thanhtra',
      type: 'old',
      component: _ThemMoiKeHoachThanhTra2.default
    }, {
      path: '/thanh-tra/chinh-sua-ke-hoach/:id',
      name: 'thanhtra',
      type: 'edit',
      component: _ThemMoiKeHoachThanhTra2.default
    }, {
      path: '/thanh-tra/them-moi-ke-hoach-kiem-tra',
      name: 'thanhtra',
      type: 'new',
      component: _ThemMoiKeHoachThanhTra2.default
    }, {
      path: '/thanh-tra/danh-sach-cuoc-thanh-tra',
      name: 'thanhtra',
      component: _pages.DanhSachCuocThanhTraPage
    }, {
      path: '/thanh-tra/danh-sach-doi-tuong-trung',
      name: 'thanhtra',
      component: _pages.DanhSachDoiTuongTrungPage
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach/:id',
      name: 'thanhtra',
      readonly: false,
      component: _ChiTietDoiTuongTrung2.default
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach-trung/:id',
      name: 'thanhtra',
      readonly: true,
      component: _ChiTietDoiTuongTrung2.default
    }, {
      path: '/thanh-tra/them-moi-cuoc-thanh-tra',
      name: 'thanhtra',
      component: _pages.ThemMoiCuocThanhTraPage
    }, {
      path: '/thanh-tra/them-moi-cuoc-kiem-tra',
      name: 'thanhtra',
      component: _pages.ThemMoiCuocThanhTraPage
    }, {
      path: '/thanh-tra/chi-tiet-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: _pages.ChiTietCuocThanhTraPage
    }, {
      path: '/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/:id',
      name: 'thanhtra',
      component: _pages.ChiTietCuocThanhTraKeHoachPage
    }, {
      path: '/thanh-tra/chinh-sua-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: _pages.ChinhSuaCuocThanhTraPage
    }, {
      path: '/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/:id',
      name: 'thanhtra',
      component: _pages.ChinhSuaCuocThanhTraDotXuatPage
    }, {
      path: '/thanh-tra/thay-the-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: _pages.ThayTheCuocThanhTraPage
    }, {
      path: '/thanh-tra-da-phe-duyet',
      name: 'thanhtra',
      component: _pages.DanhSachThanhTraDaPheDuyetPage
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach-da-phe-duyet/:id',
      name: 'thanhtra',
      readonly: false,
      component: _ChiTietDoiTuongTrung2.default
    }, {
      path: '/thanh-tra/dieu-chinh-ke-hoach-da-phe-duyet/:id',
      name: 'thanhtra',
      type: 'edit',
      component: _ThemMoiKeHoachThanhTra2.default
    },

    //Theo doi giam sat
    {
      path: '/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi',
      name: 'theodoi',
      component: _pages.TinhHinhXuLyDonTaiDonViPage
    }, {
      path: '/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi/:id',
      name: 'theodoi',
      component: _pages.TinhHinhXuLyDonTaiDonViPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-don/:id',
      name: 'theodoi',
      component: _pages.DanhSachDonPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-don-theo-ky',
      name: 'theodoi',
      component: _pages.DanhSachDonTheoKyPage
    }, {
      path: '/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu',
      name: 'theodoi',
      component: _pages.ThongKeGiamSatNhapDonCuPage
    }, {
      path: '/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu/:id',
      name: 'theodoi',
      component: _pages.ThongKeGiamSatNhapDonCuPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-thong-ke-giam-sat-don-cu/:idDonVi/:tenDonVi(/:loaiThongTinDon)',
      name: 'theodoi',
      component: _pages.DanhSachThongKeGiamSatDonCuPage
    },
    // Theo dõi thực hiện
    {
      path: '/danh-sach-theo-doi-thuc-hien',
      name: 'theodoi',
      component: _pages.DanhSachTheoDoiThucHienPage
    }, {
      path: '/theo-doi-thuc-hien/xu-ly/:id',
      name: 'theodoi',
      component: _pages.XuLyTheoDoiThucHienPage
    }, {
      path: '/theo-doi-thuc-hien/chi-tiet/:id',
      name: 'theodoi',
      component: _pages.KetQuaXuLyTheoDoiThucHienPage
    },
    //end
    {
      path: 'bo-sung-thong-tin-giai-quyet-don/:id',
      name: 'theodoi',
      component: _pages.BoSungThongTinPage
    }, {
      path: 'bo-sung-thong-tin-xu-ly-don/:id',
      name: 'xulydon',
      component: _pages.BoSungThongTinLanhDaoPage
    }, {
      path: 'bo-sung-thong-tin-chuyen-don/:id',
      name: 'chuyenxulydon',
      component: _pages.BoSungChuyenDonPage
    }, {
      path: '/cong-dan-tra-cuu',
      name: 'congDanTraCuu',
      component: _CongDanTraCuu2.default
    }, {
      path: '/ket-qua-cong-dan-tra-cuu/:keySearch',
      name: 'congDanTraCuu',
      type: 'ketQua',
      component: _KetQuaCongDanTraCuu2.default
    }, {
      path: '/giam-sat-tra-cuu',
      name: 'giamSatTraCuu',
      type: 'ketQua',
      component: _GiamSatTraCuu2.default
    }, {
      path: '/can-bo-tra-cuu',
      name: 'canBoTraCuu',
      component: _CanBoTraCuu2.default
    }, {
      path: '/chi-tiet-tra-cuu/:maDon',
      name: 'chiTietTraCuu',
      component: _ChiTietTraCuu2.default
    }, {
      path: '/theo-doi-thuc-hien-giai-quyet-don',
      name: 'theodoi',
      component: _theoDoiThucHien.TheoDoiThucHienGQD
    }, {
      path: '/tu-giai-quyet-theo-doi-thuc-hien/:id',
      name: 'theodoi',
      component: _pages.TuGiaiQuyetDonPage
    }, {
      path: '/theo-doi-thuc-hien-giai-quyet-don/:type/:id',
      name: 'theodoi',
      component: _giaiQuyetDon.XuLyGiaiQuyetDon
    }, {
      path: '/theo-doi-thuc-hien-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'theodoi',
      component: _handleLetters.HandleLettersDetails
    }, {
      path: '/don-da-giai-quyet',
      name: 'dagiaiquyet',
      component: _donDaGiaiQuyet.DonDaGiaiQuyet
    }, {
      path: '/don-da-giai-quyet/:type/:id',
      name: 'dagiaiquyet',
      component: _giaiQuyetDon.XuLyGiaiQuyetDon
    }, {
      path: '/page-403',
      name: 'page403',
      component: _home.Page403
    }, {
      path: '/huong-dan-su-dung',
      name: 'help',
      component: _home.Help
    },
    // Thanh tra trùng
    {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung',
      name: 'thanhtratrung',
      component: _pages.DanhMucCuocThanhTraTrungPage
    }, {
      path: 'thanh-tra/danh-muc-tong-hop-thanh-tra-cua-cac-don-vi',
      name: 'thanhtratrung',
      type: 'donvi',
      component: _pages.DanhMucTongHopThanhTraPage
    }, {
      path: 'thanh-tra/danh-sach-cuoc-thanh-tra-tai-tp',
      name: 'thanhtratrung',
      type: 'thanhpho',
      component: _pages.DanhMucTongHopThanhTraPage
    }, {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly',
      type: 'xuly',
      name: 'thanhtratrung',
      component: _XuLyThanhTraTrung2.default
    }, {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung/tiep-tuc-xu-ly',
      type: 'tieptucxuly',
      name: 'thanhtratrung',
      component: _XuLyThanhTraTrung2.default
    }, {
      path: 'thanh-tra/cuoc-thanh-tra/chi-tiet/:id',
      type: 'thanhtra',
      name: 'thanhtra',
      component: _ThongTinChiTietCuocThanhTra2.default
    }, {
      path: 'thanh-tra/cuoc-thanh-tra-trung/chi-tiet/:id',
      type: 'thanhtratrung',
      name: 'thanhtra',
      component: _ThongTinChiTietCuocThanhTra2.default
    }, {
      path: 'thanh-tra/ke-hoach-thanh-tra/chi-tiet/:id',
      name: 'thanhtra',
      component: _KeHoachThanhTraDetails2.default
    }, {
      path: 'thanh-tra/noi-dung-xu-ly/chi-tiet/:id',
      name: 'thanhtra',
      component: _ChiTietNoiDungXuLy2.default
    }, {
      path: 'thanh-tra/danh-sach-tong-hop-khtt-cua-cac-don-vi',
      name: 'thanhtra',
      component: _DanhSachTongHopKHTT2.default
    }, {
      path: 'thanh-tra/danh-sach-lich-su-ttt',
      name: 'thanhtratrung',
      component: _DanhSachLichSuXuLyTTT2.default
    }, {
      path: 'thanh-tra/chi-tiet-thong-bao/:id',
      name: 'thanhtra',
      component: _NotificationDetails2.default
    }, {
      path: 'thanh-tra/danh-sach-thong-bao',
      name: 'thanhtra',
      component: _DanhSachThongBao2.default
    }, {
      path: 'thanh-tra/thong-bao-loading/:id',
      name: 'thanhtra',
      component: _LoadingThongBao2.default
    }, {
      path: '/quan-ly-ho-so/danh-sach-ho-so',
      name: 'quanlyhoso',
      component: _DanhSachQuanLyHoSo2.default
    }, {
      path: '/quan-ly-ho-so/danh-sach-ho-so/:id',
      name: 'quanlyhoso',
      component: _ChiTietQuanLyHoSo2.default
    }, {
      path: '/quan-ly-ho-so/danh-muc-nhom-ho-so',
      name: 'quanlyhoso',
      component: _NhomHoSo2.default
    }, {
      path: '/quan-ly-van-ban/the-loai-van-ban',
      name: 'quanlyvanban',
      component: _TheLoaiVanBan2.default
    }, {
      path: '/quan-ly-van-ban/linh-vuc-van-ban',
      name: 'linhvucvanban',
      component: _LinhVucVanBan2.default
    }, {
      path: '/quan-ly-van-ban/co-quan-ban-hanh-van-ban',
      name: 'coquanbanhanh',
      component: _CoQuanBanHanhVanBan2.default
    }, {
      path: '/quan-ly-van-ban/danh-sach-van-ban',
      name: 'danhsachvanban',
      component: _DanhMucVanBan2.default
    }, {
      path: 'quan-ly-van-ban/danh-sach-van-ban/them-moi',
      name: 'danhsachvanban',
      component: _ThemMoiVanBan2.default
    }, {
      path: 'quan-ly-van-ban/danh-sach-van-ban/chinh-sua/:id',
      name: 'danhsachvanban',
      component: _ThemMoiVanBan2.default
    }, {
      path: '/thong-ke',
      name: 'thongke',
      component: _thongKe.Statistical
    }]
  }, {
    path: "/redirect",
    component: _AutoLogin2.default
  }];
}
//DetailReceptionUnexpectedly

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1800);

__webpack_require__(2366);

__webpack_require__(1601);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    if(a===b) {
      return [ai, bi];
    }
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(158);

var callBind = __webpack_require__(1598);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(380);
var GetIntrinsic = __webpack_require__(158);
var setFunctionLength = __webpack_require__(2367);

var $TypeError = GetIntrinsic('%TypeError%');
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 1599 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(2374);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1608);
module.exports = __webpack_require__(94).RegExp.escape;


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var isArray = __webpack_require__(244);
var SPECIES = __webpack_require__(43)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(34);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(105);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(148);
var gOPS = __webpack_require__(248);
var pIE = __webpack_require__(202);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(203)('native-function-to-string', Function.toString);


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(8);
var $re = __webpack_require__(1607)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { copyWithin: __webpack_require__(509) });

__webpack_require__(131)('copyWithin');


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $every = __webpack_require__(102)(4);

$export($export.P + $export.F * !__webpack_require__(96)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { fill: __webpack_require__(325) });

__webpack_require__(131)('fill');


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $filter = __webpack_require__(102)(2);

$export($export.P + $export.F * !__webpack_require__(96)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(102)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(131)(KEY);


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(102)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(131)(KEY);


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $forEach = __webpack_require__(102)(0);
var STRICT = __webpack_require__(96)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(95);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var call = __webpack_require__(520);
var isArrayIter = __webpack_require__(333);
var toLength = __webpack_require__(45);
var createProperty = __webpack_require__(327);
var getIterFn = __webpack_require__(349);

$export($export.S + $export.F * !__webpack_require__(246)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $indexOf = __webpack_require__(241)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(96)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(8);

$export($export.S, 'Array', { isArray: __webpack_require__(244) });


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(8);
var toIObject = __webpack_require__(87);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(201) != Object || !__webpack_require__(96)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(87);
var toInteger = __webpack_require__(97);
var toLength = __webpack_require__(45);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(96)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $map = __webpack_require__(102)(1);

$export($export.P + $export.F * !__webpack_require__(96)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var createProperty = __webpack_require__(327);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(34)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(511);

$export($export.P + $export.F * !__webpack_require__(96)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(511);

$export($export.P + $export.F * !__webpack_require__(96)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var html = __webpack_require__(331);
var cof = __webpack_require__(93);
var toAbsoluteIndex = __webpack_require__(152);
var toLength = __webpack_require__(45);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(34)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $some = __webpack_require__(102)(3);

$export($export.P + $export.F * !__webpack_require__(96)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var aFunction = __webpack_require__(68);
var toObject = __webpack_require__(58);
var fails = __webpack_require__(34);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(96)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151)('Array');


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(8);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(8);
var toISOString = __webpack_require__(1603);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(105);

$export($export.P + $export.F * __webpack_require__(34)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(43)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(77)(proto, TO_PRIMITIVE, __webpack_require__(1604));


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(78)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(8);

$export($export.P, 'Function', { bind: __webpack_require__(512) });


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(86);
var HAS_INSTANCE = __webpack_require__(43)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(53).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(53).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(48) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(8);
var log1p = __webpack_require__(523);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(8);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(8);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(8);
var sign = __webpack_require__(337);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(8);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(8);
var $expm1 = __webpack_require__(336);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { fround: __webpack_require__(522) });


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(8);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(8);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(34)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { log1p: __webpack_require__(523) });


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { sign: __webpack_require__(337) });


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(336);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(34)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(336);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var has = __webpack_require__(84);
var cof = __webpack_require__(93);
var inheritIfRequired = __webpack_require__(332);
var toPrimitive = __webpack_require__(105);
var fails = __webpack_require__(34);
var gOPN = __webpack_require__(147).f;
var gOPD = __webpack_require__(85).f;
var dP = __webpack_require__(53).f;
var $trim = __webpack_require__(174).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(146)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(48) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(78)(global, NUMBER, $Number);
}


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(8);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(8);
var _isFinite = __webpack_require__(30).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', { isInteger: __webpack_require__(519) });


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(8);
var isInteger = __webpack_require__(519);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(531);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(532);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toInteger = __webpack_require__(97);
var aNumberValue = __webpack_require__(508);
var repeat = __webpack_require__(344);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(34)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $fails = __webpack_require__(34);
var aNumberValue = __webpack_require__(508);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(525) });


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(146) });


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperties: __webpack_require__(526) });


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperty: __webpack_require__(53).f });


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(36);
var meta = __webpack_require__(133).onFreeze;

__webpack_require__(104)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(87);
var $getOwnPropertyDescriptor = __webpack_require__(85).f;

__webpack_require__(104)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(104)('getOwnPropertyNames', function () {
  return __webpack_require__(527).f;
});


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(58);
var $getPrototypeOf = __webpack_require__(86);

__webpack_require__(104)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(36);

__webpack_require__(104)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(36);

__webpack_require__(104)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(36);

__webpack_require__(104)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { is: __webpack_require__(535) });


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(58);
var $keys = __webpack_require__(148);

__webpack_require__(104)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(36);
var meta = __webpack_require__(133).onFreeze;

__webpack_require__(104)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(36);
var meta = __webpack_require__(133).onFreeze;

__webpack_require__(104)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(341).set });


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(171);
var test = {};
test[__webpack_require__(43)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(78)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(531);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(532);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(132);
var global = __webpack_require__(30);
var ctx = __webpack_require__(95);
var classof = __webpack_require__(171);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(36);
var aFunction = __webpack_require__(68);
var anInstance = __webpack_require__(144);
var forOf = __webpack_require__(145);
var speciesConstructor = __webpack_require__(204);
var task = __webpack_require__(346).set;
var microtask = __webpack_require__(338)();
var newPromiseCapabilityModule = __webpack_require__(339);
var perform = __webpack_require__(533);
var userAgent = __webpack_require__(254);
var promiseResolve = __webpack_require__(534);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(43)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(150)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(173)($Promise, PROMISE);
__webpack_require__(151)(PROMISE);
Wrapper = __webpack_require__(94)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(246)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(68);
var anObject = __webpack_require__(27);
var rApply = (__webpack_require__(30).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(34)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(8);
var create = __webpack_require__(146);
var aFunction = __webpack_require__(68);
var anObject = __webpack_require__(27);
var isObject = __webpack_require__(36);
var fails = __webpack_require__(34);
var bind = __webpack_require__(512);
var rConstruct = (__webpack_require__(30).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(53);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(105);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(34)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(8);
var gOPD = __webpack_require__(85).f;
var anObject = __webpack_require__(27);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(27);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(334)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(85);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(27);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(8);
var getProto = __webpack_require__(86);
var anObject = __webpack_require__(27);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(85);
var getPrototypeOf = __webpack_require__(86);
var has = __webpack_require__(84);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(36);
var anObject = __webpack_require__(27);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(27);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(530) });


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(27);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(8);
var setProto = __webpack_require__(341);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(53);
var gOPD = __webpack_require__(85);
var getPrototypeOf = __webpack_require__(86);
var has = __webpack_require__(84);
var $export = __webpack_require__(8);
var createDesc = __webpack_require__(149);
var anObject = __webpack_require__(27);
var isObject = __webpack_require__(36);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var inheritIfRequired = __webpack_require__(332);
var dP = __webpack_require__(53).f;
var gOPN = __webpack_require__(147).f;
var isRegExp = __webpack_require__(245);
var $flags = __webpack_require__(200);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(48) && (!CORRECT_NEW || __webpack_require__(34)(function () {
  re2[__webpack_require__(43)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(78)(global, 'RegExp', $RegExp);
}

__webpack_require__(151)('RegExp');


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(27);
var toLength = __webpack_require__(45);
var advanceStringIndex = __webpack_require__(324);
var regExpExec = __webpack_require__(249);

// @@match logic
__webpack_require__(243)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(27);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(45);
var toInteger = __webpack_require__(97);
var advanceStringIndex = __webpack_require__(324);
var regExpExec = __webpack_require__(249);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(243)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(27);
var sameValue = __webpack_require__(535);
var regExpExec = __webpack_require__(249);

// @@search logic
__webpack_require__(243)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(245);
var anObject = __webpack_require__(27);
var speciesConstructor = __webpack_require__(204);
var advanceStringIndex = __webpack_require__(324);
var toLength = __webpack_require__(45);
var callRegExpExec = __webpack_require__(249);
var regexpExec = __webpack_require__(340);
var fails = __webpack_require__(34);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(243)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(541);
var anObject = __webpack_require__(27);
var $flags = __webpack_require__(200);
var DESCRIPTORS = __webpack_require__(48);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(78)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(34)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(79)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(79)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(79)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(79)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $at = __webpack_require__(252)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(45);
var context = __webpack_require__(343);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(330)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(79)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(79)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(79)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(152);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(8);
var context = __webpack_require__(343);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(330)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(79)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(252)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(335)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(79)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(87);
var toLength = __webpack_require__(45);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(344)
});


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(79)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(45);
var context = __webpack_require__(343);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(330)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(79)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(79)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(79)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(174)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(30);
var has = __webpack_require__(84);
var DESCRIPTORS = __webpack_require__(48);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(78);
var META = __webpack_require__(133).KEY;
var $fails = __webpack_require__(34);
var shared = __webpack_require__(203);
var setToStringTag = __webpack_require__(173);
var uid = __webpack_require__(153);
var wks = __webpack_require__(43);
var wksExt = __webpack_require__(538);
var wksDefine = __webpack_require__(348);
var enumKeys = __webpack_require__(1605);
var isArray = __webpack_require__(244);
var anObject = __webpack_require__(27);
var isObject = __webpack_require__(36);
var toObject = __webpack_require__(58);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(105);
var createDesc = __webpack_require__(149);
var _create = __webpack_require__(146);
var gOPNExt = __webpack_require__(527);
var $GOPD = __webpack_require__(85);
var $GOPS = __webpack_require__(248);
var $DP = __webpack_require__(53);
var $keys = __webpack_require__(148);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(147).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(202).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(132)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(77)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $typed = __webpack_require__(253);
var buffer = __webpack_require__(347);
var anObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(152);
var toLength = __webpack_require__(45);
var isObject = __webpack_require__(36);
var ArrayBuffer = __webpack_require__(30).ArrayBuffer;
var speciesConstructor = __webpack_require__(204);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(34)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(151)(ARRAY_BUFFER);


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
$export($export.G + $export.W + $export.F * !__webpack_require__(253).ABV, {
  DataView: __webpack_require__(347).DataView
});


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(515);
var validate = __webpack_require__(154);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(242)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(516);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(45);
var aFunction = __webpack_require__(68);
var arraySpeciesCreate = __webpack_require__(326);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(131)('flatMap');


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(516);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(45);
var toInteger = __webpack_require__(97);
var arraySpeciesCreate = __webpack_require__(326);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(131)('flatten');


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(8);
var $includes = __webpack_require__(241)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(131)('includes');


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(8);
var microtask = __webpack_require__(338)();
var process = __webpack_require__(30).process;
var isNode = __webpack_require__(93)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(8);
var cof = __webpack_require__(93);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.G, { global: __webpack_require__(30) });


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(250)('Map');


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(251)('Map');


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(514)('Map') });


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var scale = __webpack_require__(524);
var fround = __webpack_require__(522);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { scale: __webpack_require__(524) });


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(8);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var aFunction = __webpack_require__(68);
var $defineProperty = __webpack_require__(53);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(48) && $export($export.P + __webpack_require__(247), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var aFunction = __webpack_require__(68);
var $defineProperty = __webpack_require__(53);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(48) && $export($export.P + __webpack_require__(247), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $entries = __webpack_require__(529)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(8);
var ownKeys = __webpack_require__(530);
var toIObject = __webpack_require__(87);
var gOPD = __webpack_require__(85);
var createProperty = __webpack_require__(327);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(105);
var getPrototypeOf = __webpack_require__(86);
var getOwnPropertyDescriptor = __webpack_require__(85).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(48) && $export($export.P + __webpack_require__(247), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(105);
var getPrototypeOf = __webpack_require__(86);
var getOwnPropertyDescriptor = __webpack_require__(85).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(48) && $export($export.P + __webpack_require__(247), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $values = __webpack_require__(529)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(8);
var global = __webpack_require__(30);
var core = __webpack_require__(94);
var microtask = __webpack_require__(338)();
var OBSERVABLE = __webpack_require__(43)('observable');
var aFunction = __webpack_require__(68);
var anObject = __webpack_require__(27);
var anInstance = __webpack_require__(144);
var redefineAll = __webpack_require__(150);
var hide = __webpack_require__(77);
var forOf = __webpack_require__(145);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(151)('Observable');


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(8);
var core = __webpack_require__(94);
var global = __webpack_require__(30);
var speciesConstructor = __webpack_require__(204);
var promiseResolve = __webpack_require__(534);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(339);
var perform = __webpack_require__(533);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(542);
var from = __webpack_require__(510);
var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(86);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(86);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(86);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(114);
var anObject = __webpack_require__(27);
var aFunction = __webpack_require__(68);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(250)('Set');


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(251)('Set');


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(514)('Set') });


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(8);
var $at = __webpack_require__(252)(true);
var $fails = __webpack_require__(34);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(8);
var defined = __webpack_require__(103);
var toLength = __webpack_require__(45);
var isRegExp = __webpack_require__(245);
var getFlags = __webpack_require__(200);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(334)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(536);
var userAgent = __webpack_require__(254);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(536);
var userAgent = __webpack_require__(254);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(174)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(174)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348)('asyncIterator');


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348)('observable');


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.S, 'System', { global: __webpack_require__(30) });


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(250)('WeakMap');


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(251)('WeakMap');


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(250)('WeakSet');


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(251)('WeakSet');


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(350);
var getKeys = __webpack_require__(148);
var redefine = __webpack_require__(78);
var global = __webpack_require__(30);
var hide = __webpack_require__(77);
var Iterators = __webpack_require__(172);
var wks = __webpack_require__(43);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $task = __webpack_require__(346);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(30);
var $export = __webpack_require__(8);
var userAgent = __webpack_require__(254);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1728);
__webpack_require__(1667);
__webpack_require__(1669);
__webpack_require__(1668);
__webpack_require__(1671);
__webpack_require__(1673);
__webpack_require__(1678);
__webpack_require__(1672);
__webpack_require__(1670);
__webpack_require__(1680);
__webpack_require__(1679);
__webpack_require__(1675);
__webpack_require__(1676);
__webpack_require__(1674);
__webpack_require__(1666);
__webpack_require__(1677);
__webpack_require__(1681);
__webpack_require__(1682);
__webpack_require__(1634);
__webpack_require__(1636);
__webpack_require__(1635);
__webpack_require__(1684);
__webpack_require__(1683);
__webpack_require__(1654);
__webpack_require__(1664);
__webpack_require__(1665);
__webpack_require__(1655);
__webpack_require__(1656);
__webpack_require__(1657);
__webpack_require__(1658);
__webpack_require__(1659);
__webpack_require__(1660);
__webpack_require__(1661);
__webpack_require__(1662);
__webpack_require__(1663);
__webpack_require__(1637);
__webpack_require__(1638);
__webpack_require__(1639);
__webpack_require__(1640);
__webpack_require__(1641);
__webpack_require__(1642);
__webpack_require__(1643);
__webpack_require__(1644);
__webpack_require__(1645);
__webpack_require__(1646);
__webpack_require__(1647);
__webpack_require__(1648);
__webpack_require__(1649);
__webpack_require__(1650);
__webpack_require__(1651);
__webpack_require__(1652);
__webpack_require__(1653);
__webpack_require__(1715);
__webpack_require__(1720);
__webpack_require__(1727);
__webpack_require__(1718);
__webpack_require__(1710);
__webpack_require__(1711);
__webpack_require__(1716);
__webpack_require__(1721);
__webpack_require__(1723);
__webpack_require__(1706);
__webpack_require__(1707);
__webpack_require__(1708);
__webpack_require__(1709);
__webpack_require__(1712);
__webpack_require__(1713);
__webpack_require__(1714);
__webpack_require__(1717);
__webpack_require__(1719);
__webpack_require__(1722);
__webpack_require__(1724);
__webpack_require__(1725);
__webpack_require__(1726);
__webpack_require__(1629);
__webpack_require__(1631);
__webpack_require__(1630);
__webpack_require__(1633);
__webpack_require__(1632);
__webpack_require__(1618);
__webpack_require__(1616);
__webpack_require__(1622);
__webpack_require__(1619);
__webpack_require__(1625);
__webpack_require__(1627);
__webpack_require__(1615);
__webpack_require__(1621);
__webpack_require__(1612);
__webpack_require__(1626);
__webpack_require__(1610);
__webpack_require__(1624);
__webpack_require__(1623);
__webpack_require__(1617);
__webpack_require__(1620);
__webpack_require__(1609);
__webpack_require__(1611);
__webpack_require__(1614);
__webpack_require__(1613);
__webpack_require__(1628);
__webpack_require__(350);
__webpack_require__(1700);
__webpack_require__(540);
__webpack_require__(1705);
__webpack_require__(541);
__webpack_require__(1701);
__webpack_require__(1702);
__webpack_require__(1703);
__webpack_require__(1704);
__webpack_require__(1685);
__webpack_require__(539);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(1740);
__webpack_require__(1729);
__webpack_require__(1730);
__webpack_require__(1735);
__webpack_require__(1738);
__webpack_require__(1739);
__webpack_require__(1733);
__webpack_require__(1736);
__webpack_require__(1734);
__webpack_require__(1737);
__webpack_require__(1731);
__webpack_require__(1732);
__webpack_require__(1686);
__webpack_require__(1687);
__webpack_require__(1688);
__webpack_require__(1689);
__webpack_require__(1690);
__webpack_require__(1693);
__webpack_require__(1691);
__webpack_require__(1692);
__webpack_require__(1694);
__webpack_require__(1695);
__webpack_require__(1696);
__webpack_require__(1697);
__webpack_require__(1699);
__webpack_require__(1698);
__webpack_require__(1743);
__webpack_require__(1741);
__webpack_require__(1742);
__webpack_require__(1784);
__webpack_require__(1787);
__webpack_require__(1786);
__webpack_require__(1788);
__webpack_require__(1789);
__webpack_require__(1785);
__webpack_require__(1790);
__webpack_require__(1791);
__webpack_require__(1765);
__webpack_require__(1768);
__webpack_require__(1764);
__webpack_require__(1762);
__webpack_require__(1763);
__webpack_require__(1766);
__webpack_require__(1767);
__webpack_require__(1749);
__webpack_require__(1783);
__webpack_require__(1748);
__webpack_require__(1782);
__webpack_require__(1794);
__webpack_require__(1796);
__webpack_require__(1747);
__webpack_require__(1781);
__webpack_require__(1793);
__webpack_require__(1795);
__webpack_require__(1746);
__webpack_require__(1792);
__webpack_require__(1745);
__webpack_require__(1750);
__webpack_require__(1751);
__webpack_require__(1752);
__webpack_require__(1753);
__webpack_require__(1754);
__webpack_require__(1756);
__webpack_require__(1755);
__webpack_require__(1757);
__webpack_require__(1758);
__webpack_require__(1759);
__webpack_require__(1761);
__webpack_require__(1760);
__webpack_require__(1770);
__webpack_require__(1771);
__webpack_require__(1772);
__webpack_require__(1773);
__webpack_require__(1775);
__webpack_require__(1774);
__webpack_require__(1777);
__webpack_require__(1776);
__webpack_require__(1778);
__webpack_require__(1779);
__webpack_require__(1780);
__webpack_require__(1744);
__webpack_require__(1769);
__webpack_require__(1799);
__webpack_require__(1798);
__webpack_require__(1797);
module.exports = __webpack_require__(94);


/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(551);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(553);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["b" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(205);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(351);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(175);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(351);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(548);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(555);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(1820);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(1821);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(1819);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(1822);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(1817);
/* unused harmony reexport entries */








/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(352);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(352);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(557);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(557);




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* deg2rad */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));


/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(561);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__ = __webpack_require__(1828);




/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* default */],
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__["b" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(255);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(255);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(255);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(176);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(176);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(176);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(176);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__color_js__["b" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(176);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
});


/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(1846);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose_js__ = __webpack_require__(1844);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(571);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(206);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(570);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(260);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(260);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(155);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(208);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(206);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])();

/* harmony default export */ __webpack_exports__["a"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(208);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(155);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(560);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(364);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(209);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function asin(x) {
  return x >= 1 ? __WEBPACK_IMPORTED_MODULE_2__math__["d" /* halfPi */] : x <= -1 ? -__WEBPACK_IMPORTED_MODULE_2__math__["d" /* halfPi */] : Math.asin(x);
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["d" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["d" /* halfPi */],
        da = Math.abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = asin(rp / r0 * Math.sin(ap)),
            p1 = asin(rp / r1 * Math.sin(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Math.cos(a01),
          y01 = r1 * Math.sin(a01),
          x10 = r0 * Math.cos(a10),
          y10 = r0 * Math.sin(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * Math.cos(a11),
            y11 = r1 * Math.sin(a11),
            x00 = r0 * Math.cos(a00),
            y00 = r0 * Math.sin(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] / 2;
    return [Math.cos(a) * r, Math.sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(261);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(261);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(261);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(360);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(360);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(264);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(362);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["b" /* default */])(series).reverse();
});


/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(362);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(211);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(209);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radialLine__ = __webpack_require__(578);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__radialLine__["a" /* radialLine */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__radialLine__["a" /* radialLine */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__radialLine__["a" /* radialLine */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__radialLine__["a" /* radialLine */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(211);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(177);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat_js__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__ = __webpack_require__(363);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat_js__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */] - date.getMinutes() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(117);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(70);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(626)();

var GetIntrinsic = __webpack_require__(158);

var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var gopd = __webpack_require__(625);

/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(299);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1906));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(299);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(589));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(299);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(589));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

/*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function(window){'use strict';
  /* jshint loopfunc: true, noempty: false*/
  // http://www.w3.org/TR/dom/#element

  function createDocumentFragment() {
    return document.createDocumentFragment();
  }

  function createElement(nodeName) {
    return document.createElement(nodeName);
  }

  function enoughArguments(length, name) {
    if (!length) throw new Error(
      'Failed to construct ' +
        name +
      ': 1 argument required, but only 0 present.'
    );
  }

  function mutationMacro(nodes) {
    if (nodes.length === 1) {
      return textNodeIfString(nodes[0]);
    }
    for (var
      fragment = createDocumentFragment(),
      list = slice.call(nodes),
      i = 0; i < nodes.length; i++
    ) {
      fragment.appendChild(textNodeIfString(list[i]));
    }
    return fragment;
  }

  function textNodeIfString(node) {
    return typeof node === 'string' ? document.createTextNode(node) : node;
  }

  for(var
    head,
    property,
    TemporaryPrototype,
    TemporaryTokenList,
    wrapVerifyToken,
    document = window.document,
    hOP = Object.prototype.hasOwnProperty,
    defineProperty = Object.defineProperty || function (object, property, descriptor) {
      if (hOP.call(descriptor, 'value')) {
        object[property] = descriptor.value;
      } else {
        if (hOP.call(descriptor, 'get'))
          object.__defineGetter__(property, descriptor.get);
        if (hOP.call(descriptor, 'set'))
          object.__defineSetter__(property, descriptor.set);
      }
      return object;
    },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    // http://www.w3.org/TR/domcore/#domtokenlist
    verifyToken = function (token) {
      if (!token) {
        throw 'SyntaxError';
      } else if (spaces.test(token)) {
        throw 'InvalidCharacterError';
      }
      return token;
    },
    DOMTokenList = function (node) {
      var
        noClassName = typeof node.className === 'undefined',
        className = noClassName ?
          (node.getAttribute('class') || '') : node.className,
        isSVG = noClassName || typeof className === 'object',
        value = (isSVG ?
          (noClassName ? className : className.baseVal) :
          className
        ).replace(trim, '')
      ;
      if (value.length) {
        properties.push.apply(
          this,
          value.split(spaces)
        );
      }
      this._isSVG = isSVG;
      this._ = node;
    },
    classListDescriptor = {
      get: function get() {
        return new DOMTokenList(this);
      },
      set: function(){}
    },
    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
    trim = /^\s+|\s+$/g,
    spaces = /\s+/,
    SPACE = '\x20',
    CLASS_LIST = 'classList',
    toggle = function toggle(token, force) {
      if (this.contains(token)) {
        if (!force) {
          // force is not true (either false or omitted)
          this.remove(token);
        }
      } else if(force === undefined || force) {
        force = true;
        this.add(token);
      }
      return !!force;
    },
    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
    Node = window.Node,
    NodePrototype = (Node || Element).prototype,
    CharacterData = window.CharacterData || Node,
    CharacterDataPrototype = CharacterData && CharacterData.prototype,
    DocumentType = window.DocumentType,
    DocumentTypePrototype = DocumentType && DocumentType.prototype,
    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
    selectRemove = HTMLSelectElement.prototype.remove,
    ShadowRoot = window.ShadowRoot,
    SVGElement = window.SVGElement,
    // normalizes multiple ids as CSS query
    idSpaceFinder = / /g,
    idSpaceReplacer = '\\ ',
    createQueryMethod = function (methodName) {
      var createArray = methodName === 'querySelectorAll';
      return function (css) {
        var a, i, id, query, nl, selectors, node = this.parentNode;
        if (node) {
          for (
            id = this.getAttribute('id') || uid,
            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
            selectors = css.split(','),
            i = 0; i < selectors.length; i++
          ) {
            selectors[i] = '#' + query + ' ' + selectors[i];
          }
          css = selectors.join(',');
        }
        if (id === uid) this.setAttribute('id', id);
        nl = (node || this)[methodName](css);
        if (id === uid) this.removeAttribute('id');
        // return a list
        if (createArray) {
          i = nl.length;
          a = new Array(i);
          while (i--) a[i] = nl[i];
        }
        // return node or null
        else {
          a = nl;
        }
        return a;
      };
    },
    addQueryAndAll = function (where) {
      if (!('query' in where)) {
        where.query = ElementPrototype.query;
      }
      if (!('queryAll' in where)) {
        where.queryAll = ElementPrototype.queryAll;
      }
    },
    properties = [
      'matches', (
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.khtmlMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.oMatchesSelector ||
        function matches(selector) {
          var parentNode = this.parentNode;
          return !!parentNode && -1 < indexOf.call(
            parentNode.querySelectorAll(selector),
            this
          );
        }
      ),
      'closest', function closest(selector) {
        var parentNode = this, matches;
        while (
          // document has no .matches
          (matches = parentNode && parentNode.matches) &&
          !parentNode.matches(selector)
        ) {
          parentNode = parentNode.parentNode;
        }
        return matches ? parentNode : null;
      },
      'prepend', function prepend() {
        var firstChild = this.firstChild,
            node = mutationMacro(arguments);
        if (firstChild) {
          this.insertBefore(node, firstChild);
        } else {
          this.appendChild(node);
        }
      },
      'append', function append() {
        this.appendChild(mutationMacro(arguments));
      },
      'before', function before() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.insertBefore(
            mutationMacro(arguments), this
          );
        }
      },
      'after', function after() {
        var parentNode = this.parentNode,
            nextSibling = this.nextSibling,
            node = mutationMacro(arguments);
        if (parentNode) {
          if (nextSibling) {
            parentNode.insertBefore(node, nextSibling);
          } else {
            parentNode.appendChild(node);
          }
        }
      },
      // WARNING - DEPRECATED - use .replaceWith() instead
      'replace', function replace() {
        this.replaceWith.apply(this, arguments);
      },
      'replaceWith', function replaceWith() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.replaceChild(
            mutationMacro(arguments),
            this
          );
        }
      },
      'remove', function remove() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.removeChild(this);
        }
      },
      'query', createQueryMethod('querySelector'),
      'queryAll', createQueryMethod('querySelectorAll')
    ],
    slice = properties.slice,
    i = properties.length; i; i -= 2
  ) {
    property = properties[i - 2];
    if (!(property in ElementPrototype)) {
      ElementPrototype[property] = properties[i - 1];
    }
    if (property === 'remove') {
      // see https://github.com/WebReflection/dom4/issues/19
      HTMLSelectElement.prototype[property] = function () {
        return 0 < arguments.length ?
          selectRemove.apply(this, arguments) :
          ElementPrototype.remove.call(this);
      };
    }
    // see https://github.com/WebReflection/dom4/issues/18
    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
      if (CharacterData && !(property in CharacterDataPrototype)) {
        CharacterDataPrototype[property] = properties[i - 1];
      }
      if (DocumentType && !(property in DocumentTypePrototype)) {
        DocumentTypePrototype[property] = properties[i - 1];
      }
    }
    // see https://github.com/WebReflection/dom4/pull/26
    if (/^(?:append|prepend)$/.test(property)) {
      if (DocumentFragmentPrototype) {
        if (!(property in DocumentFragmentPrototype)) {
          DocumentFragmentPrototype[property] = properties[i - 1];
        }
      } else {
        try {
          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
        } catch(o_O) {}
      }
    }
  }

  // bring query and queryAll to the document too
  addQueryAndAll(document);

  // brings query and queryAll to fragments as well
  if (DocumentFragmentPrototype) {
    addQueryAndAll(DocumentFragmentPrototype);
  } else {
    try {
      addQueryAndAll(createDocumentFragment().constructor.prototype);
    } catch(o_O) {}
  }

  // bring query and queryAll to the ShadowRoot too
  if (ShadowRoot) {
    addQueryAndAll(ShadowRoot.prototype);
  }

  // most likely an IE9 only issue
  // see https://github.com/WebReflection/dom4/issues/6
  if (!createElement('a').matches('a')) {
    ElementPrototype[property] = function(matches){
      return function (selector) {
        return matches.call(
          this.parentNode ?
            this :
            createDocumentFragment().appendChild(this),
          selector
        );
      };
    }(ElementPrototype[property]);
  }

  // used to fix both old webkit and SVG
  DOMTokenList.prototype = {
    length: 0,
    add: function add() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(!this.contains(token)) {
          properties.push.call(this, property);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    contains: (function(indexOf){
      return function contains(token) {
        i = indexOf.call(this, property = verifyToken(token));
        return -1 < i;
      };
    }([].indexOf || function (token) {
      i = this.length;
      while(i-- && this[i] !== token){}
      return i;
    })),
    item: function item(i) {
      return this[i] || null;
    },
    remove: function remove() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(this.contains(token)) {
          properties.splice.call(this, i, 1);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    toggle: toggle,
    toString: function toString() {
      return properties.join.call(this, SPACE);
    }
  };

  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
  }

  // http://www.w3.org/TR/dom/#domtokenlist
  // iOS 5.1 has completely screwed this property
  // classList in ElementPrototype is false
  // but it's actually there as getter
  if (!(CLASS_LIST in document.documentElement)) {
    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
  } else {
    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
    // trying to detect and fix that in here
    TemporaryTokenList = createElement('div')[CLASS_LIST];
    TemporaryTokenList.add('a', 'b', 'a');
    if ('a\x20b' != TemporaryTokenList) {
      // no other way to reach original methods in iOS 5.1
      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
      if (!('add' in TemporaryPrototype)) {
        // ASHA double fails in here
        TemporaryPrototype = window.TemporaryTokenList.prototype;
      }
      wrapVerifyToken = function (original) {
        return function () {
          var i = 0;
          while (i < arguments.length) {
            original.call(this, arguments[i++]);
          }
        };
      };
      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
      // toggle is broken too ^_^ ... let's fix it
      TemporaryPrototype.toggle = toggle;
    }
  }

  if (!('contains' in NodePrototype)) {
    defineProperty(NodePrototype, 'contains', {
      value: function (el) {
        while (el && el !== this) el = el.parentNode;
        return this === el;
      }
    });
  }

  if (!('head' in document)) {
    defineProperty(document, 'head', {
      get: function () {
        return head || (
          head = document.getElementsByTagName('head')[0]
        );
      }
    });
  }

  // requestAnimationFrame partial polyfill
  (function () {
    for (var
      raf,
      rAF = window.requestAnimationFrame,
      cAF = window.cancelAnimationFrame,
      prefixes = ['o', 'ms', 'moz', 'webkit'],
      i = prefixes.length;
      !cAF && i--;
    ) {
      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
            window[prefixes[i] + 'CancelRequestAnimationFrame'];
    }
    if (!cAF) {
      // some FF apparently implemented rAF but no cAF 
      if (rAF) {
        raf = rAF;
        rAF = function (callback) {
          var goOn = true;
          raf(function () {
            if (goOn) callback.apply(this, arguments);
          });
          return function () {
            goOn = false;
          };
        };
        cAF = function (id) {
          id();
        };
      } else {
        rAF = function (callback) {
          return setTimeout(callback, 15, 15);
        };
        cAF = function (id) {
          clearTimeout(id);
        };
      }
    }
    window.requestAnimationFrame = rAF;
    window.cancelAnimationFrame = cAF;
  }());

  // http://www.w3.org/TR/dom/#customevent
  try{new window.CustomEvent('?');}catch(o_O){
    window.CustomEvent = function(
      eventName,
      defaultInitDict
    ){

      // the infamous substitute
      function CustomEvent(type, eventInitDict) {
        /*jshint eqnull:true */
        var event = document.createEvent(eventName);
        if (typeof type != 'string') {
          throw new Error('An event name must be provided');
        }
        if (eventName == 'Event') {
          event.initCustomEvent = initCustomEvent;
        }
        if (eventInitDict == null) {
          eventInitDict = defaultInitDict;
        }
        event.initCustomEvent(
          type,
          eventInitDict.bubbles,
          eventInitDict.cancelable,
          eventInitDict.detail
        );
        return event;
      }

      // attached at runtime
      function initCustomEvent(
        type, bubbles, cancelable, detail
      ) {
        /*jshint validthis:true*/
        this.initEvent(type, bubbles, cancelable);
        this.detail = detail;
      }

      // that's it
      return CustomEvent;
    }(
      // is this IE9 or IE10 ?
      // where CustomEvent is there
      // but not usable as construtor ?
      window.CustomEvent ?
        // use the CustomEvent interface in such case
        'CustomEvent' : 'Event',
        // otherwise the common compatible one
      {
        bubbles: false,
        cancelable: false,
        detail: null
      }
    );
  }

  // window.Event as constructor
  try { new Event('_'); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($Event) {
      function Event(type, init) {
        enoughArguments(arguments.length, 'Event');
        var out = document.createEvent('Event');
        if (!init) init = {};
        out.initEvent(
          type,
          !!init.bubbles,
          !!init.cancelable
        );
        return out;
      }
      Event.prototype = $Event.prototype;
      return Event;
    }(window.Event || function Event() {}));
    defineProperty(window, 'Event', {value: o_O});
    // Android 4 gotcha
    if (Event !== o_O) Event = o_O;
  }

  // window.KeyboardEvent as constructor
  try { new KeyboardEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($KeyboardEvent) {
      // code inspired by https://gist.github.com/termi/4654819
      var
        initType = 0,
        defaults = {
          char: '',
          key: '',
          location: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          altGraphKey: false,
          repeat: false,
          locale: navigator.language,
          detail: 0,
          bubbles: false,
          cancelable: false,
          keyCode: 0,
          charCode: 0,
          which: 0
        },
        eventType
      ;
      try {
        var e = document.createEvent('KeyboardEvent');
        e.initKeyboardEvent(
          'keyup', false, false, window, '+', 3,
          true, false, true, false, false
        );
        initType = (
          (e.keyIdentifier || e.key) == '+' &&
          (e.keyLocation || e.location) == 3
        ) && (
          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
        ) || 9;
      } catch(o_O) {}
      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

      function getModifier(init) {
        for (var
          out = [],
          keys = [
            'ctrlKey',
            'Control',
            'shiftKey',
            'Shift',
            'altKey',
            'Alt',
            'metaKey',
            'Meta',
            'altGraphKey',
            'AltGraph'
          ],
          i = 0; i < keys.length; i += 2
        ) {
          if (init[keys[i]])
            out.push(keys[i + 1]);
        }
        return out.join(' ');
      }

      function withDefaults(target, source) {
        for (var key in source) {
          if (
            source.hasOwnProperty(key) &&
            !source.hasOwnProperty.call(target, key)
          ) target[key] = source[key];
        }
        return target;
      }

      function withInitValues(key, out, init) {
        try {
          out[key] = init[key];
        } catch(o_O) {}
      }

      function KeyboardEvent(type, init) {
        enoughArguments(arguments.length, 'KeyboardEvent');
        init = withDefaults(init || {}, defaults);
        var
          out = document.createEvent(eventType),
          ctrlKey = init.ctrlKey,
          shiftKey = init.shiftKey,
          altKey = init.altKey,
          metaKey = init.metaKey,
          altGraphKey = init.altGraphKey,
          modifiers = initType > 3 ? getModifier(init) : null,
          key = String(init.key),
          chr = String(init.char),
          location = init.location,
          keyCode = init.keyCode || (
            (init.keyCode = key) &&
            key.charCodeAt(0)
          ) || 0,
          charCode = init.charCode || (
            (init.charCode = chr) &&
            chr.charCodeAt(0)
          ) || 0,
          bubbles = init.bubbles,
          cancelable = init.cancelable,
          repeat = init.repeat,
          locale = init.locale,
          view = init.view || window,
          args
        ;
        if (!init.which) init.which = init.keyCode;
        if ('initKeyEvent' in out) {
          out.initKeyEvent(
            type, bubbles, cancelable, view,
            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
          );
        } else if (0 < initType && 'initKeyboardEvent' in out) {
          args = [type, bubbles, cancelable, view];
          switch (initType) {
            case 1:
              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
              break;
            case 2:
              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
              break;
            case 3:
              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
              break;
            case 4:
              args.push(key, location, modifiers, repeat, locale);
              break;
            default:
              args.push(char, key, location, modifiers, repeat, locale);
          }
          out.initKeyboardEvent.apply(out, args);
        } else {
          out.initEvent(type, bubbles, cancelable);
        }
        for (key in out) {
          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
            withInitValues(key, out, init);
          }
        }
        return out;
      }
      KeyboardEvent.prototype = $KeyboardEvent.prototype;
      return KeyboardEvent;
    }(window.KeyboardEvent || function KeyboardEvent() {}));
    defineProperty(window, 'KeyboardEvent', {value: o_O});
    // Android 4 gotcha
    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
  }

  // window.MouseEvent as constructor
  try { new MouseEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($MouseEvent) {
      function MouseEvent(type, init) {
        enoughArguments(arguments.length, 'MouseEvent');
        var out = document.createEvent('MouseEvent');
        if (!init) init = {};
        out.initMouseEvent(
          type,
          !!init.bubbles,
          !!init.cancelable,
          init.view || window,
          init.detail || 1,
          init.screenX || 0,
          init.screenY || 0,
          init.clientX || 0,
          init.clientY || 0,
          !!init.ctrlKey,
          !!init.altKey,
          !!init.shiftKey,
          !!init.metaKey,
          init.button || 0,
          init.relatedTarget || null
        );
        return out;
      }
      MouseEvent.prototype = $MouseEvent.prototype;
      return MouseEvent;
    }(window.MouseEvent || function MouseEvent() {}));
    defineProperty(window, 'MouseEvent', {value: o_O});
    // Android 4 gotcha
    if (MouseEvent !== o_O) MouseEvent = o_O;
  }

}(window));(function (global){'use strict';

  // a WeakMap fallback for DOM nodes only used as key
  var DOMMap = global.WeakMap || (function () {

    var
      counter = 0,
      dispatched = false,
      drop = false,
      value
    ;

    function dispatch(key, ce, shouldDrop) {
      drop = shouldDrop;
      dispatched = false;
      value = undefined;
      key.dispatchEvent(ce);
    }

    function Handler(value) {
      this.value = value;
    }

    Handler.prototype.handleEvent = function handleEvent(e) {
      dispatched = true;
      if (drop) {
        e.currentTarget.removeEventListener(e.type, this, false);
      } else {
        value = this.value;
      }
    };

    function DOMMap() {
      counter++;  // make id clashing highly improbable
      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
    }

    DOMMap.prototype = {
      'constructor': DOMMap,
      'delete': function del(key) {
        return dispatch(key, this.__ce__, true), dispatched;
      },
      'get': function get(key) {
        dispatch(key, this.__ce__, false);
        var v = value;
        value = undefined;
        return v;
      },
      'has': function has(key) {
        return dispatch(key, this.__ce__, false), dispatched;
      },
      'set': function set(key, value) {
        dispatch(key, this.__ce__, true);
        key.addEventListener(this.__ce__.type, new Handler(value), false);
        return this;
      },
    };

    return DOMMap;

  }());

  function Dict() {}
  Dict.prototype = (Object.create || Object)(null);

  // https://dom.spec.whatwg.org/#interface-eventtarget

  function createEventListener(type, callback, options) {
    function eventListener(e) {
      if (eventListener.once) {
        e.currentTarget.removeEventListener(
          e.type,
          callback,
          eventListener
        );
        eventListener.removed = true;
      }
      if (eventListener.passive) {
        e.preventDefault = createEventListener.preventDefault;
      }
      if (typeof eventListener.callback === 'function') {
        /* jshint validthis: true */
        eventListener.callback.call(this, e);
      } else if (eventListener.callback) {
        eventListener.callback.handleEvent(e);
      }
      if (eventListener.passive) {
        delete e.preventDefault;
      }
    }
    eventListener.type = type;
    eventListener.callback = callback;
    eventListener.capture = !!options.capture;
    eventListener.passive = !!options.passive;
    eventListener.once = !!options.once;
    // currently pointless but specs say to use it, so ...
    eventListener.removed = false;
    return eventListener;
  }

  createEventListener.preventDefault = function preventDefault() {};

  var
    Event = global.CustomEvent,
    hOP = Object.prototype.hasOwnProperty,
    dE = global.dispatchEvent,
    aEL = global.addEventListener,
    rEL = global.removeEventListener,
    counter = 0,
    increment = function () { counter++; },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    getListenerKey = function (options) {
      return ''.concat(
        options.capture ? '1' : '0',
        options.passive ? '1' : '0',
        options.once ? '1' : '0'
      );
    },
    augment, proto
  ;

  try {
    aEL('_', increment, {once: true});
    dE(new Event('_'));
    dE(new Event('_'));
    rEL('_', increment, {once: true});
  } catch(o_O) {}

  if (counter !== 1) {
    (function () {
      var dm = new DOMMap();
      function createAEL(aEL) {
        return function addEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key = getListenerKey(options),
              i, tmp, wrap
            ;
            if (!info) dm.set(this, (info = new Dict()));
            if (!(type in info)) info[type] = {
              handler: [],
              wrap: []
            };
            tmp = info[type];
            i = indexOf.call(tmp.handler, handler);
            if (i < 0) {
              i = tmp.handler.push(handler) - 1;
              tmp.wrap[i] = (wrap = new Dict());
            } else {
              wrap = tmp.wrap[i];
            }
            if (!(key in wrap)) {
              wrap[key] = createEventListener(type, handler, options);
              aEL.call(this, type, wrap[key], wrap[key].capture);
            }
          } else {
            aEL.call(this, type, handler, options);
          }
        };
      }
      function createREL(rEL) {
        return function removeEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key, i, tmp, wrap
            ;
            if (info && (type in info)) {
              tmp = info[type];
              i = indexOf.call(tmp.handler, handler);
              if (-1 < i) {
                key = getListenerKey(options);
                wrap = tmp.wrap[i];
                if (key in wrap) {
                  rEL.call(this, type, wrap[key], wrap[key].capture);
                  delete wrap[key];
                  // return if there are other wraps
                  for (key in wrap) return;
                  // otherwise remove all the things
                  tmp.handler.splice(i, 1);
                  tmp.wrap.splice(i, 1);
                  // if there are no other handlers
                  if (tmp.handler.length === 0)
                    // drop the info[type] entirely
                    delete info[type];
                }
              }
            }
          } else {
            rEL.call(this, type, handler, options);
          }
        };
      }

      augment = function (Constructor) {
        if (!Constructor) return;
        var proto = Constructor.prototype;
        proto.addEventListener = createAEL(proto.addEventListener);
        proto.removeEventListener = createREL(proto.removeEventListener);
      };

      if (global.EventTarget) {
        augment(EventTarget);
      } else {
        augment(global.Text);
        augment(global.Element || global.HTMLElement);
        augment(global.HTMLDocument);
        augment(global.Window || {prototype:global});
        augment(global.XMLHttpRequest);
      }

    }());
  }

}(self));

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BlockMapBuilder = __webpack_require__(212);
var CharacterMetadata = __webpack_require__(80);
var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var DraftFeatureFlags = __webpack_require__(135);
var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var Immutable = __webpack_require__(35);
var SelectionState = __webpack_require__(178);

var generateRandomKey = __webpack_require__(118);
var moveBlockInContentState = __webpack_require__(1971);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _extends({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'move-block');
  }
};

module.exports = AtomicBlockUtils;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Immutable = __webpack_require__(35);

var List = Immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(80);

var _require = __webpack_require__(35),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @format
 * 
 * @preventMunge
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(366);
var DefaultDraftInlineStyle = __webpack_require__(591);
var DraftEditorCompositionHandler = __webpack_require__(1915);
var DraftEditorContents = __webpack_require__(1917);
var DraftEditorDragHandler = __webpack_require__(1918);
var DraftEditorEditHandler = __webpack_require__(1919);
var DraftEditorPlaceholder = __webpack_require__(1921);
var EditorState = __webpack_require__(39);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(61);
var Scroll = __webpack_require__(615);
var Style = __webpack_require__(374);
var UserAgent = __webpack_require__(106);

var cx = __webpack_require__(179);
var emptyFunction = __webpack_require__(71);
var generateRandomKey = __webpack_require__(118);
var getDefaultKeyBinding = __webpack_require__(598);
var getScrollPosition = __webpack_require__(377);
var invariant = __webpack_require__(21);
var nullthrows = __webpack_require__(98);

var isIE = UserAgent.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck(this, DraftEditor);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React.createElement(
        'div',
        {
          className: cx('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React.createElement(DraftEditorContents, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: emptyFunction.thatReturnsNull,
  blockStyleFn: emptyFunction.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


module.exports = DraftEditor;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(135);
var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var Keys = __webpack_require__(373);

var getEntityKeyForSelection = __webpack_require__(369);
var isEventHandled = __webpack_require__(214);
var isSelectionAtLeafStart = __webpack_require__(608);

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents-core.react
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(592);
var DraftOffsetKey = __webpack_require__(267);
var EditorState = __webpack_require__(39);
var React = __webpack_require__(0);

var cx = __webpack_require__(179);
var joinClasses = __webpack_require__(1999);
var nullthrows = __webpack_require__(98);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck(this, DraftEditorContents);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */



var DraftEditorContents = __webpack_require__(1916);

module.exports = DraftEditorContents;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @format
 * 
 */



var DataTransfer = __webpack_require__(613);
var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);

var findAncestorOffsetKey = __webpack_require__(368);
var getTextContentFromFiles = __webpack_require__(605);
var getUpdatedSelectionState = __webpack_require__(606);
var isEventHandled = __webpack_require__(214);
var nullthrows = __webpack_require__(98);

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));

  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * @format
 * 
 */



var onBeforeInput = __webpack_require__(1938);
var onBlur = __webpack_require__(1939);
var onCompositionStart = __webpack_require__(1940);
var onCopy = __webpack_require__(1941);
var onCut = __webpack_require__(1942);
var onDragOver = __webpack_require__(1943);
var onDragStart = __webpack_require__(1944);
var onFocus = __webpack_require__(1945);
var onInput = __webpack_require__(1946);
var onKeyDown = __webpack_require__(1947);
var onPaste = __webpack_require__(1948);
var onSelect = __webpack_require__(1949);

var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect
};

module.exports = DraftEditorEditHandler;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @format
 * 
 */



var _assign = __webpack_require__(29);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorTextNode = __webpack_require__(1922);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(61);

var invariant = __webpack_require__(21);
var setDraftEditorSelection = __webpack_require__(1973);

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck(this, DraftEditorLeaf);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = ReactDOM.findDOMNode(this);
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React.createElement(
        DraftEditorTextNode,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(179);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        'div',
        {
          className: cx('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(61);
var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(21);

// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */



/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

module.exports = DraftEntitySegments;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */



var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

module.exports = DraftFeatureFlags;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */



module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CharacterMetadata = __webpack_require__(80);
var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var DraftFeatureFlags = __webpack_require__(135);
var Immutable = __webpack_require__(35);

var convertFromHTMLtoContentBlocks = __webpack_require__(597);
var generateRandomKey = __webpack_require__(118);
var getSafeBodyFromHTML = __webpack_require__(603);
var sanitizeDraftText = __webpack_require__(371);

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));

      return acc;
    }, []);
  }
};

module.exports = DraftPasteProcessor;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var invariant = __webpack_require__(21);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

module.exports = DraftTreeAdapter;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @format
 * 
 */



var Immutable = __webpack_require__(35);
var UnicodeBidiService = __webpack_require__(1985);

var nullthrows = __webpack_require__(98);

var OrderedMap = Immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

module.exports = EditorBidiService;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);

var getContentStateFragment = __webpack_require__(268);
var nullthrows = __webpack_require__(98);

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange);
    clipboard = getContentStateFragment(content, targetRange);

    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};

module.exports = SecondaryClipboard;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */



function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(80);

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(35);

var applyEntityToContentBlock = __webpack_require__(1931);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var DraftStringKey = __webpack_require__(595);

var encodeEntityRanges = __webpack_require__(1950);
var encodeInlineStyleRanges = __webpack_require__(1951);
var invariant = __webpack_require__(21);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * @format
 * 
 */



var _assign = __webpack_require__(29);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(156);
var ContentBlockNode = __webpack_require__(88);
var ContentState = __webpack_require__(365);
var DraftEntity = __webpack_require__(266);
var DraftFeatureFlags = __webpack_require__(135);
var DraftTreeAdapter = __webpack_require__(1927);
var Immutable = __webpack_require__(35);
var SelectionState = __webpack_require__(178);

var createCharacterList = __webpack_require__(1935);
var decodeEntityRanges = __webpack_require__(1936);
var decodeInlineStyleRanges = __webpack_require__(1937);
var generateRandomKey = __webpack_require__(118);
var invariant = __webpack_require__(21);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends({}, block, {
    key: block.key || generateRandomKey()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());

  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(80);
var Immutable = __webpack_require__(35);

var List = Immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({ style: style, entity: entity });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(157);

var substr = UnicodeUtils.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @format
 * 
 */



var _require = __webpack_require__(35),
    OrderedSet = _require.OrderedSet;

var UnicodeUtils = __webpack_require__(157);

var substr = UnicodeUtils.substr;


var EMPTY_SET = OrderedSet();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * @format
 * 
 */



var BlockTree = __webpack_require__(590);
var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var UserAgent = __webpack_require__(106);

var getEntityKeyForSelection = __webpack_require__(369);
var isEventHandled = __webpack_require__(214);
var isSelectionAtLeafStart = __webpack_require__(608);
var nullthrows = __webpack_require__(98);
var setImmediate = __webpack_require__(2001);

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = global.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

var containsNode = __webpack_require__(270);
var getActiveElement = __webpack_require__(271);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement() === document.body) {
    var _selection = global.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * @format
 * 
 */



var getFragmentFromSelection = __webpack_require__(600);

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var Style = __webpack_require__(374);

var getFragmentFromSelection = __webpack_require__(600);
var getScrollPosition = __webpack_require__(377);

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition(Style.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */



/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */



/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * @format
 * 
 */



var EditorState = __webpack_require__(39);
var UserAgent = __webpack_require__(106);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(135);
var DraftModifier = __webpack_require__(75);
var DraftOffsetKey = __webpack_require__(267);
var EditorState = __webpack_require__(39);
var UserAgent = __webpack_require__(106);

var findAncestorOffsetKey = __webpack_require__(368);
var nullthrows = __webpack_require__(98);

var isGecko = UserAgent.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = global.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);
var KeyBindingUtil = __webpack_require__(367);
var Keys = __webpack_require__(373);
var SecondaryClipboard = __webpack_require__(1929);
var UserAgent = __webpack_require__(106);

var isEventHandled = __webpack_require__(214);
var keyCommandBackspaceToStartOfLine = __webpack_require__(1960);
var keyCommandBackspaceWord = __webpack_require__(1961);
var keyCommandDeleteWord = __webpack_require__(1962);
var keyCommandInsertNewline = __webpack_require__(1963);
var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1964);
var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1965);
var keyCommandPlainBackspace = __webpack_require__(1966);
var keyCommandPlainDelete = __webpack_require__(1967);
var keyCommandTransposeCharacters = __webpack_require__(1968);
var keyCommandUndo = __webpack_require__(1969);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;

var isChrome = UserAgent.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete(editorState);
    case 'delete-word':
      return keyCommandDeleteWord(editorState);
    case 'backspace':
      return keyCommandPlainBackspace(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState);
    case 'split-block':
      return keyCommandInsertNewline(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(212);
var CharacterMetadata = __webpack_require__(80);
var DataTransfer = __webpack_require__(613);
var DraftModifier = __webpack_require__(75);
var DraftPasteProcessor = __webpack_require__(1926);
var EditorState = __webpack_require__(39);
var RichTextEditorUtil = __webpack_require__(596);

var getEntityKeyForSelection = __webpack_require__(369);
var getTextContentFromFiles = __webpack_require__(605);
var isEventHandled = __webpack_require__(214);
var splitTextIntoTextBlocks = __webpack_require__(1975);

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);

        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * @format
 * 
 */



var EditorState = __webpack_require__(39);
var ReactDOM = __webpack_require__(61);

var getDraftEditorSelection = __webpack_require__(1954);
var invariant = __webpack_require__(21);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @format
 * 
 */



var DraftStringKey = __webpack_require__(595);
var UnicodeUtils = __webpack_require__(157);

var strlen = UnicodeUtils.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(157);

var findRangesImmutable = __webpack_require__(213);

var areEqual = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable(filteredInlines, areEqual,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

var UnicodeUtils = __webpack_require__(157);

var getRangeClientRects = __webpack_require__(602);
var invariant = __webpack_require__(21);

/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @format
 * 
 */



var DraftEntitySegments = __webpack_require__(1923);

var getRangesForDraftEntity = __webpack_require__(1956);
var invariant = __webpack_require__(21);

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @format
 * 
 */



var getDraftEditorSelectionWithNodes = __webpack_require__(599);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = global.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

module.exports = getDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @format
 * 
 */



var getRangeClientRects = __webpack_require__(602);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @format
 * 
 */



var invariant = __webpack_require__(21);

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;

  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @format
 * 
 */



var getRangeBoundingClientRect = __webpack_require__(1955);

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(212);
var ContentBlockNode = __webpack_require__(88);
var Immutable = __webpack_require__(35);

var insertIntoList = __webpack_require__(607);
var invariant = __webpack_require__(21);
var randomizeBlockMapKeys = __webpack_require__(610);

var List = Immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(35);

var insertIntoList = __webpack_require__(607);
var invariant = __webpack_require__(21);

var Repeat = Immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

var expandRangeToStartOfLine = __webpack_require__(1952);
var getDraftEditorSelectionWithNodes = __webpack_require__(599);
var moveSelectionBackward = __webpack_require__(370);
var removeTextWithStrategy = __webpack_require__(215);

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var domSelection = global.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);

    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(594);
var EditorState = __webpack_require__(39);

var moveSelectionBackward = __webpack_require__(370);
var removeTextWithStrategy = __webpack_require__(215);

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(594);
var EditorState = __webpack_require__(39);

var moveSelectionForward = __webpack_require__(609);
var removeTextWithStrategy = __webpack_require__(215);

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * @format
 * 
 */



var EditorState = __webpack_require__(39);
var UnicodeUtils = __webpack_require__(157);

var moveSelectionBackward = __webpack_require__(370);
var removeTextWithStrategy = __webpack_require__(215);

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * @format
 * 
 */



var EditorState = __webpack_require__(39);
var UnicodeUtils = __webpack_require__(157);

var moveSelectionForward = __webpack_require__(609);
var removeTextWithStrategy = __webpack_require__(215);

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * @format
 * 
 */



var DraftModifier = __webpack_require__(75);
var EditorState = __webpack_require__(39);

var getContentStateFragment = __webpack_require__(268);

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');

  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * @format
 * 
 */



var EditorState = __webpack_require__(39);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(35);

var Map = Immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(88);
var Immutable = __webpack_require__(35);

var getNextDelimiterBlockKey = __webpack_require__(601);
var invariant = __webpack_require__(21);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(88);
var Immutable = __webpack_require__(35);

var getNextDelimiterBlockKey = __webpack_require__(601);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @format
 * 
 */



var DraftJsDebugLogging = __webpack_require__(1925);

var containsNode = __webpack_require__(270);
var getActiveElement = __webpack_require__(271);
var invariant = __webpack_require__(21);

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode(document.documentElement, node)) {
    return;
  }

  var selection = global.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  if (selection.extend && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

module.exports = setDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(88);
var Immutable = __webpack_require__(35);

var generateRandomKey = __webpack_require__(118);
var invariant = __webpack_require__(21);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update original next block
    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;

    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */



var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.draftjsToHtml = factory());
}(this, (function () { 'use strict';

/**
* Utility function to execute callback for eack key->value pair.
*/
function forEach(obj, callback) {
  if (obj) {
    for (var key in obj) {
      // eslint-disable-line no-restricted-syntax
      if ({}.hasOwnProperty.call(obj, key)) {
        callback(key, obj[key]);
      }
    }
  }
}

/**
* The function returns true if the string passed to it has no content.
*/
function isEmptyString(str) {
  if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
    return true;
  }
  return false;
}

/**
* Mapping block-type to corresponding html tag.
*/
var blockTypesMapping = {
  unstyled: 'p',
  'header-one': 'h1',
  'header-two': 'h2',
  'header-three': 'h3',
  'header-four': 'h4',
  'header-five': 'h5',
  'header-six': 'h6',
  'unordered-list-item': 'ul',
  'ordered-list-item': 'ol',
  blockquote: 'blockquote',
  code: 'pre'
};

/**
* Function will return HTML tag for a block.
*/
function getBlockTag(type) {
  return type && blockTypesMapping[type];
}

/**
* Function will return style string for a block.
*/
function getBlockStyle(data) {
  var styles = '';
  forEach(data, function (key, value) {
    if (value) {
      styles += key + ':' + value + ';';
    }
  });
  return styles;
}

/**
* The function returns an array of hashtag-sections in blocks.
* These will be areas in block which have hashtags applicable to them.
*/
function getHashtagRanges(blockText, hashtagConfig) {
  var sections = [];
  if (hashtagConfig) {
    var counter = 0;
    var startIndex = 0;
    var text = blockText;
    var trigger = hashtagConfig.trigger || '#';
    var separator = hashtagConfig.separator || ' ';
    for (; text.length > 0 && startIndex >= 0;) {
      if (text[0] === trigger) {
        startIndex = 0;
        counter = 0;
        text = text.substr(trigger.length);
      } else {
        startIndex = text.indexOf(separator + trigger);
        if (startIndex >= 0) {
          text = text.substr(startIndex + (separator + trigger).length);
          counter += startIndex + separator.length;
        }
      }
      if (startIndex >= 0) {
        var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
        var hashtag = text.substr(0, endIndex);
        if (hashtag && hashtag.length > 0) {
          sections.push({
            offset: counter,
            length: hashtag.length + trigger.length,
            type: 'HASHTAG'
          });
        }
        counter += trigger.length;
      }
    }
  }
  return sections;
}

/**
* The function returns an array of entity-sections in blocks.
* These will be areas in block which have same entity or no entity applicable to them.
*/
function getSections(block, hashtagConfig) {
  var sections = [];
  var lastOffset = 0;
  var sectionRanges = block.entityRanges.map(function (range) {
    var offset = range.offset,
        length = range.length,
        key = range.key;

    return {
      offset: offset,
      length: length,
      key: key,
      type: 'ENTITY'
    };
  });
  sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
  sectionRanges = sectionRanges.sort(function (s1, s2) {
    return s1.offset - s2.offset;
  });
  sectionRanges.forEach(function (r) {
    if (r.offset > lastOffset) {
      sections.push({
        start: lastOffset,
        end: r.offset
      });
    }
    sections.push({
      start: r.offset,
      end: r.offset + r.length,
      entityKey: r.key,
      type: r.type
    });
    lastOffset = r.offset + r.length;
  });
  if (lastOffset < block.text.length) {
    sections.push({
      start: lastOffset,
      end: block.text.length
    });
  }
  return sections;
}

/**
* Function to check if the block is an atomic entity block.
*/
function isAtomicEntityBlock(block) {
  if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
    return true;
  }
  return false;
}

/**
* The function will return array of inline styles applicable to the block.
*/
function getStyleArrayForBlock(block) {
  var text = block.text,
      inlineStyleRanges = block.inlineStyleRanges;

  var inlineStyles = {
    BOLD: new Array(text.length),
    ITALIC: new Array(text.length),
    UNDERLINE: new Array(text.length),
    STRIKETHROUGH: new Array(text.length),
    CODE: new Array(text.length),
    SUPERSCRIPT: new Array(text.length),
    SUBSCRIPT: new Array(text.length),
    COLOR: new Array(text.length),
    BGCOLOR: new Array(text.length),
    FONTSIZE: new Array(text.length),
    FONTFAMILY: new Array(text.length),
    length: text.length
  };
  if (inlineStyleRanges && inlineStyleRanges.length > 0) {
    inlineStyleRanges.forEach(function (range) {
      var offset = range.offset;

      var length = offset + range.length;
      for (var i = offset; i < length; i += 1) {
        if (range.style.indexOf('color-') === 0) {
          inlineStyles.COLOR[i] = range.style.substring(6);
        } else if (range.style.indexOf('bgcolor-') === 0) {
          inlineStyles.BGCOLOR[i] = range.style.substring(8);
        } else if (range.style.indexOf('fontsize-') === 0) {
          inlineStyles.FONTSIZE[i] = range.style.substring(9);
        } else if (range.style.indexOf('fontfamily-') === 0) {
          inlineStyles.FONTFAMILY[i] = range.style.substring(11);
        } else if (inlineStyles[range.style]) {
          inlineStyles[range.style][i] = true;
        }
      }
    });
  }
  return inlineStyles;
}

/**
* The function will return inline style applicable at some offset within a block.
*/
function getStylesAtOffset(inlineStyles, offset) {
  var styles = {};
  if (inlineStyles.COLOR[offset]) {
    styles.COLOR = inlineStyles.COLOR[offset];
  }
  if (inlineStyles.BGCOLOR[offset]) {
    styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
  }
  if (inlineStyles.FONTSIZE[offset]) {
    styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
  }
  if (inlineStyles.FONTFAMILY[offset]) {
    styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
  }
  if (inlineStyles.UNDERLINE[offset]) {
    styles.UNDERLINE = true;
  }
  if (inlineStyles.ITALIC[offset]) {
    styles.ITALIC = true;
  }
  if (inlineStyles.BOLD[offset]) {
    styles.BOLD = true;
  }
  if (inlineStyles.STRIKETHROUGH[offset]) {
    styles.STRIKETHROUGH = true;
  }
  if (inlineStyles.CODE[offset]) {
    styles.CODE = true;
  }
  if (inlineStyles.SUBSCRIPT[offset]) {
    styles.SUBSCRIPT = true;
  }
  if (inlineStyles.SUPERSCRIPT[offset]) {
    styles.SUPERSCRIPT = true;
  }
  return styles;
}

/**
* Function returns true for a set of styles if the value of these styles at an offset
* are same as that on the previous offset.
*/
function sameStyleAsPrevious(inlineStyles, styles, index) {
  var sameStyled = true;
  if (index > 0 && index < inlineStyles.length) {
    styles.forEach(function (style) {
      sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
    });
  } else {
    sameStyled = false;
  }
  return sameStyled;
}

/**
* Function returns html for text depending on inline style tags applicable to it.
*/
function addInlineStyleMarkup(style, content) {
  if (style === 'BOLD') {
    return '<strong>' + content + '</strong>';
  } else if (style === 'ITALIC') {
    return '<em>' + content + '</em>';
  } else if (style === 'UNDERLINE') {
    return '<ins>' + content + '</ins>';
  } else if (style === 'STRIKETHROUGH') {
    return '<del>' + content + '</del>';
  } else if (style === 'CODE') {
    return '<code>' + content + '</code>';
  } else if (style === 'SUPERSCRIPT') {
    return '<sup>' + content + '</sup>';
  } else if (style === 'SUBSCRIPT') {
    return '<sub>' + content + '</sub>';
  }
  return content;
}

/**
* The function returns text for given section of block after doing required character replacements.
*/
function getSectionText(text) {
  if (text && text.length > 0) {
    var chars = text.map(function (ch) {
      switch (ch) {
        case '\n':
          return '<br>';
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        default:
          return ch;
      }
    });
    return chars.join('');
  }
  return '';
}

/**
* Function returns html for text depending on inline style tags applicable to it.
*/
function addStylePropertyMarkup(styles, text) {
  if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
    var styleString = 'style="';
    if (styles.COLOR) {
      styleString += 'color: ' + styles.COLOR + ';';
    }
    if (styles.BGCOLOR) {
      styleString += 'background-color: ' + styles.BGCOLOR + ';';
    }
    if (styles.FONTSIZE) {
      styleString += 'font-size: ' + styles.FONTSIZE + (/^\d+$/.test(styles.FONTSIZE) ? 'px' : '') + ';';
    }
    if (styles.FONTFAMILY) {
      styleString += 'font-family: ' + styles.FONTFAMILY + ';';
    }
    styleString += '"';
    return '<span ' + styleString + '>' + text + '</span>';
  }
  return text;
}

/**
* Function will return markup for Entity.
*/
function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
  var entity = entityMap[entityKey];
  if (typeof customEntityTransform === 'function') {
    var html = customEntityTransform(entity, text);
    if (html) {
      return html;
    }
  }
  if (entity.type === 'MENTION') {
    return '<a href="' + entity.data.url + '" class="wysiwyg-mention" data-mention data-value="' + entity.data.value + '">' + text + '</a>';
  }
  if (entity.type === 'LINK') {
    var targetOption = entity.data.targetOption || '_self';
    return '<a href="' + entity.data.url + '" target="' + targetOption + '">' + text + '</a>';
  }
  if (entity.type === 'IMAGE') {
    return '<img src="' + entity.data.src + '" alt="' + entity.data.alt + '" style="float:' + (entity.data.alignment || 'none') + ';height: ' + entity.data.height + ';width: ' + entity.data.width + '"/>';
  }
  if (entity.type === 'EMBEDDED_LINK') {
    return '<iframe width="' + entity.data.width + '" height="' + entity.data.height + '" src="' + entity.data.src + '" frameBorder="0"></iframe>';
  }
  return text;
}

/**
* For a given section in a block the function will return a further list of sections,
* with similar inline styles applicable to them.
*/
function getInlineStyleSections(block, styles, start, end) {
  var styleSections = [];
  var text = block.text;

  if (text.length > 0) {
    var inlineStyles = getStyleArrayForBlock(block);
    var section = void 0;
    for (var i = start; i < end; i += 1) {
      if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
        section.text.push(text[i]);
        section.end = i + 1;
      } else {
        section = {
          styles: getStylesAtOffset(inlineStyles, i),
          text: [text[i]],
          start: i,
          end: i + 1
        };
        styleSections.push(section);
      }
    }
  }
  return styleSections;
}

/**
* Replace leading blank spaces by &nbsp;
*/
function trimLeadingZeros(sectionText) {
  if (sectionText) {
    var replacedText = sectionText;
    for (var i = 0; i < replacedText.length; i += 1) {
      if (sectionText[i] === ' ') {
        replacedText = replacedText.replace(' ', '&nbsp;');
      } else {
        break;
      }
    }
    return replacedText;
  }
  return sectionText;
}

/**
* Replace trailing blank spaces by &nbsp;
*/
function trimTrailingZeros(sectionText) {
  if (sectionText) {
    var replacedText = sectionText;
    for (var i = replacedText.length - 1; i >= 0; i -= 1) {
      if (replacedText[i] === ' ') {
        replacedText = replacedText.substring(0, i) + '&nbsp;' + replacedText.substring(i + 1);
      } else {
        break;
      }
    }
    return replacedText;
  }
  return sectionText;
}

/**
* The method returns markup for section to which inline styles
* like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
*/
function getStyleTagSectionMarkup(styleSection) {
  var styles = styleSection.styles,
      text = styleSection.text;

  var content = getSectionText(text);
  forEach(styles, function (style, value) {
    content = addInlineStyleMarkup(style, content, value);
  });
  return content;
}

/**
* The method returns markup for section to which inline styles
like color, background-color, font-size are applicable.
*/
function getInlineStyleSectionMarkup(block, styleSection) {
  var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
  var styleSectionText = '';
  styleTagSections.forEach(function (stylePropertySection) {
    styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
  });
  styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
  return styleSectionText;
}

/*
* The method returns markup for an entity section.
* An entity section is a continuous section in a block
* to which same entity or no entity is applicable.
*/
function getSectionMarkup(block, entityMap, section, customEntityTransform) {
  var entityInlineMarkup = [];
  var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
  inlineStyleSections.forEach(function (styleSection) {
    entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
  });
  var sectionText = entityInlineMarkup.join('');
  if (section.type === 'ENTITY') {
    if (section.entityKey !== undefined && section.entityKey !== null) {
      sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
    }
  } else if (section.type === 'HASHTAG') {
    sectionText = '<a href="' + sectionText + '" class="wysiwyg-hashtag">' + sectionText + '</a>';
  }
  return sectionText;
}

/**
* Function will return the markup for block preserving the inline styles and
* special characters like newlines or blank spaces.
*/
function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
  var blockMarkup = [];
  var sections = getSections(block, hashtagConfig);
  sections.forEach(function (section, index) {
    var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);
    if (index === 0) {
      sectionText = trimLeadingZeros(sectionText);
    }
    if (index === sections.length - 1) {
      sectionText = trimTrailingZeros(sectionText);
    }
    blockMarkup.push(sectionText);
  });
  return blockMarkup.join('');
}

/**
* Function will return html for the block.
*/
function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
  var blockHtml = [];
  if (isAtomicEntityBlock(block)) {
    blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
  } else {
    var blockTag = getBlockTag(block.type);
    if (blockTag) {
      blockHtml.push('<' + blockTag);
      var blockStyle = getBlockStyle(block.data);
      if (blockStyle) {
        blockHtml.push(' style="' + blockStyle + '"');
      }
      if (directional) {
        blockHtml.push(' dir = "auto"');
      }
      blockHtml.push('>');
      blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
      blockHtml.push('</' + blockTag + '>');
    }
  }
  blockHtml.push('\n');
  return blockHtml.join('');
}

/**
* Function to check if a block is of type list.
*/
function isList(blockType) {
  return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
}

/**
* Function will return html markup for a list block.
*/
function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
  var listHtml = [];
  var nestedListBlock = [];
  var previousBlock = void 0;
  listBlocks.forEach(function (block) {
    var nestedBlock = false;
    if (!previousBlock) {
      listHtml.push('<' + getBlockTag(block.type) + '>\n');
    } else if (previousBlock.type !== block.type) {
      listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
      listHtml.push('<' + getBlockTag(block.type) + '>\n');
    } else if (previousBlock.depth === block.depth) {
      if (nestedListBlock && nestedListBlock.length > 0) {
        listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
        nestedListBlock = [];
      }
    } else {
      nestedBlock = true;
      nestedListBlock.push(block);
    }
    if (!nestedBlock) {
      listHtml.push('<li');
      var blockStyle = getBlockStyle(block.data);
      if (blockStyle) {
        listHtml.push(' style="' + blockStyle + '"');
      }
      if (directional) {
        listHtml.push(' dir = "auto"');
      }
      listHtml.push('>');
      listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
      listHtml.push('</li>\n');
      previousBlock = block;
    }
  });
  if (nestedListBlock && nestedListBlock.length > 0) {
    listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
  }
  listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
  return listHtml.join('');
}

/**
* The function will generate html markup for given draftjs editorContent.
*/
function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
  var html = [];
  if (editorContent) {
    var blocks = editorContent.blocks,
        entityMap = editorContent.entityMap;

    if (blocks && blocks.length > 0) {
      var listBlocks = [];
      blocks.forEach(function (block) {
        if (isList(block.type)) {
          listBlocks.push(block);
        } else {
          if (listBlocks.length > 0) {
            var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len
            html.push(listHtml);
            listBlocks = [];
          }
          var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
          html.push(blockHtml);
        }
      });
      if (listBlocks.length > 0) {
        var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len
        html.push(listHtml);
        listBlocks = [];
      }
    }
  }
  return html.join('');
}

return draftToHtml;

})));


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports = fastApply;

function fastApply(fn, context, args) {
    
    switch (args ? args.length : 0) {
        case 0:
            return context ? fn.call(context) : fn();
        case 1:
            return context ? fn.call(context, args[0]) : fn(args[0]);
        case 2:
            return context ? fn.call(context, args[0], args[1]) : fn(args[0], args[1]);
        case 3:
            return context ? fn.call(context, args[0], args[1], args[2]) : fn(args[0], args[1], args[2]);
        case 4:
            return context ? fn.call(context, args[0], args[1], args[2], args[3]) : fn(args[0], args[1], args[2], args[3]);
        case 5:
            return context ? fn.call(context, args[0], args[1], args[2], args[3], args[4]) : fn(args[0], args[1], args[2], args[3], args[4]);
        default:
            return fn.apply(context, args);
    }
    
}

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */



// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnicodeBidi = __webpack_require__(616);
var UnicodeBidiDirection = __webpack_require__(375);

var invariant = __webpack_require__(21);

var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */



var UAParser = __webpack_require__(2375);

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new UAParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

module.exports = uaData;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var invariant = __webpack_require__(21);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

module.exports = VersionRange;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(617);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(76);

var createArrayFromMixed = __webpack_require__(618);
var getMarkupWrap = __webpack_require__(1993);
var invariant = __webpack_require__(21);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getElementRect = __webpack_require__(1992);

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var containsNode = __webpack_require__(270);

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(76);

var invariant = __webpack_require__(21);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var camelize = __webpack_require__(617);
var hyphenate = __webpack_require__(621);

function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name)]);
  }
  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(621);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1997);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(868);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5c62f9aca3f5647e776981a3012becc7.svg";

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e1bf609bf111e24494cbca6d83ff1e15.svg";

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "683beb2a5d0ab654005fc6d2f4fc621c.svg";

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4923321b4e0e827344f53f0b30f9e0f4.png";

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee46ad87773747da14a09837b3a147cd.png";

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "582d551cfe2b60b28e0b9636ff88e3c0.svg";

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4601954f35041029432d96319f2958f5.png";

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e482beab3013262af56b49ee9f95403.png";

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce77f36df6503d014cae1242748d294b.png";

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f98a2a692789a506d47bd324b82066c.png";

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4e38bc731b909534a0a7d9e52117c17.png";

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc1812b5a9145428ef733769589a6748.png";

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "40e2e9753eec721d9bc586ed9ae3c712.png";

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ca9c72a6b5eff913902048b7b9e2241.png";

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce494d5be7e464b5f6a77049fe4fb665.png";

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57e44f0c7266f6cc7792310aac844410.png";

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0be14c56554d2d9d9bc7a6abcb9e35a1.png";

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e77ef8e2268c551b689d80d21693de6.png";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(2023);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(380);

/** @type {(o: {}, p: PropertyKey) => p is keyof o} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(381);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(180);

var _DOMUtils = __webpack_require__(274);

var _DOMStateStorage = __webpack_require__(627);

var _PathUtils = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(381);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(180);

var _PathUtils = __webpack_require__(137);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(382);

var _BrowserProtocol = __webpack_require__(381);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(2027);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(274);

var _createHistory = __webpack_require__(383);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(382);

var _DOMUtils = __webpack_require__(274);

var _HashProtocol = __webpack_require__(2026);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(383);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(125);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(180);

var _PathUtils = __webpack_require__(137);

var _createHistory = __webpack_require__(383);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md


exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(2037);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(2038);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(632);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(2034);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159),
    root = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2101),
    hashDelete = __webpack_require__(2102),
    hashGet = __webpack_require__(2103),
    hashHas = __webpack_require__(2104),
    hashSet = __webpack_require__(2105);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159),
    root = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159),
    root = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(107);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159),
    root = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2047 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2060);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 2049 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2080),
    isArguments = __webpack_require__(393),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(652),
    isIndex = __webpack_require__(390),
    isTypedArray = __webpack_require__(657);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 2051 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(638);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 2053 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(637),
    isFlattenable = __webpack_require__(2106);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2088);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(2055),
    keys = __webpack_require__(395);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(637),
    isArray = __webpack_require__(51);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 2058 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 2059 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2053),
    baseIsNaN = __webpack_require__(2065),
    strictIndexOf = __webpack_require__(2136);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(634),
    arrayIncludes = __webpack_require__(2048),
    arrayIncludesWith = __webpack_require__(2049),
    arrayMap = __webpack_require__(276),
    baseUnary = __webpack_require__(389),
    cacheHas = __webpack_require__(641);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(635),
    equalArrays = __webpack_require__(643),
    equalByTag = __webpack_require__(2091),
    equalObjects = __webpack_require__(2092),
    getTag = __webpack_require__(2098),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(652),
    isTypedArray = __webpack_require__(657);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(635),
    baseIsEqual = __webpack_require__(388);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2065 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isMasked = __webpack_require__(2108),
    isObject = __webpack_require__(139),
    toSource = __webpack_require__(649);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(138),
    isLength = __webpack_require__(394),
    isObjectLike = __webpack_require__(119);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(2109),
    nativeKeys = __webpack_require__(2122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2069 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(638),
    isArrayLike = __webpack_require__(218);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2064),
    getMatchData = __webpack_require__(2094),
    matchesStrictComparable = __webpack_require__(647);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(388),
    get = __webpack_require__(651),
    hasIn = __webpack_require__(2141),
    isKey = __webpack_require__(391),
    isStrictComparable = __webpack_require__(646),
    matchesStrictComparable = __webpack_require__(647),
    toKey = __webpack_require__(281);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(276),
    baseGet = __webpack_require__(387),
    baseIteratee = __webpack_require__(278),
    baseMap = __webpack_require__(2070),
    baseSortBy = __webpack_require__(2078),
    baseUnary = __webpack_require__(389),
    compareMultiple = __webpack_require__(2085),
    identity = __webpack_require__(217),
    isArray = __webpack_require__(51);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 2074 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(387);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2076 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2139),
    defineProperty = __webpack_require__(2090),
    identity = __webpack_require__(217);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2078 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 2079 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 2080 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    arrayMap = __webpack_require__(276),
    isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(181);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(2138);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(2143);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(181);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(2084);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(107);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(218);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2088 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(2076),
    isIterateeCall = __webpack_require__(645),
    toFinite = __webpack_require__(2153);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(159);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    Uint8Array = __webpack_require__(2045),
    eq = __webpack_require__(392),
    equalArrays = __webpack_require__(643),
    mapToArray = __webpack_require__(2120),
    setToArray = __webpack_require__(2128);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2093);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2057),
    getSymbols = __webpack_require__(2097),
    keys = __webpack_require__(395);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(646),
    keys = __webpack_require__(395);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(648);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(636),
    stubArray = __webpack_require__(2149);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2041),
    Map = __webpack_require__(385),
    Promise = __webpack_require__(2043),
    Set = __webpack_require__(2044),
    WeakMap = __webpack_require__(2046),
    baseGetTag = __webpack_require__(138),
    toSource = __webpack_require__(649);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 2099 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(642),
    isArguments = __webpack_require__(393),
    isArray = __webpack_require__(51),
    isIndex = __webpack_require__(390),
    isLength = __webpack_require__(394),
    toKey = __webpack_require__(281);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(280);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2102 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(280);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(280);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(280);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(216),
    isArguments = __webpack_require__(393),
    isArray = __webpack_require__(51);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2107 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2086);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2109 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 2110 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(277);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(277);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(277);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(277);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2042),
    ListCache = __webpack_require__(275),
    Map = __webpack_require__(385);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(279);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(279);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(279);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(279);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2120 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2145);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(648);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(644);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module)))

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2047);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2126 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2127 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2128 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2077),
    shortOut = __webpack_require__(2130);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2130 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(275);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2132 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2133 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2134 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(275),
    Map = __webpack_require__(385),
    MapCache = __webpack_require__(386);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2136 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2121);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2138 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 2139 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(636),
    baseFilter = __webpack_require__(2052),
    baseIteratee = __webpack_require__(278),
    isArray = __webpack_require__(51);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2059),
    hasPath = __webpack_require__(2100);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(276),
    baseIntersection = __webpack_require__(2061),
    baseRest = __webpack_require__(640),
    castArrayLikeObject = __webpack_require__(2083);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(218),
    isObjectLike = __webpack_require__(119);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(654);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(386);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(639),
    baseLt = __webpack_require__(2069),
    identity = __webpack_require__(217);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(107);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2074),
    basePropertyDeep = __webpack_require__(2075),
    isKey = __webpack_require__(391),
    toKey = __webpack_require__(281);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2149 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 2150 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(278),
    baseSum = __webpack_require__(2079);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(650),
    isObject = __webpack_require__(139);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(660);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2081);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(2159);
Mexp.prototype.formulaEval = function () {
	"use strict";
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1||arr[i].type===3){
			disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
		}
		else if(arr[i].type===13){
			disp.push({value:arr[i].show,type:1});
		}
		else if(arr[i].type===0){
			disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
		}
		else if(arr[i].type===7){
			disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
		}
		else if(arr[i].type===10){
			pop1=disp.pop();
			pop2=disp.pop();
			if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
			else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=disp.pop();
			pop2=disp.pop();
			disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
		}
		else if(arr[i].type===12){
			pop1=disp.pop();
			pop2=disp.pop();
			pop3=disp.pop();
			disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
		}
	}
	return disp[0].value;
};
module.exports=Mexp;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Mexp = __webpack_require__(2157)
function inc(arr, val) {
	for (var i = 0; i < arr.length; i++) {
		arr[i] += val
	}
	return arr
}
var tokens = [
	{ token: 'sin', show: 'sin', type: 0, value: Mexp.math.sin },
	{ token: 'cos', show: 'cos', type: 0, value: Mexp.math.cos },
	{ token: 'tan', show: 'tan', type: 0, value: Mexp.math.tan },
	{ token: 'pi', show: '&pi;', type: 3, value: 'PI' },
	{ token: '(', show: '(', type: 4, value: '(' },
	{ token: ')', show: ')', type: 5, value: ')' },
	{ token: 'P', show: 'P', type: 10, value: Mexp.math.P },
	{ token: 'C', show: 'C', type: 10, value: Mexp.math.C },
	{ token: ' ', show: ' ', type: 14, value: ' '.anchor },
	{ token: 'asin', show: 'asin', type: 0, value: Mexp.math.asin },
	{ token: 'acos', show: 'acos', type: 0, value: Mexp.math.acos },
	{ token: 'atan', show: 'atan', type: 0, value: Mexp.math.atan },
	{ token: '7', show: '7', type: 1, value: '7' },
	{ token: '8', show: '8', type: 1, value: '8' },
	{ token: '9', show: '9', type: 1, value: '9' },
	{ token: 'int', show: 'Int', type: 0, value: Math.floor },
	{ token: 'cosh', show: 'cosh', type: 0, value: Mexp.math.cosh },
	{ token: 'acosh', show: 'acosh', type: 0, value: Mexp.math.acosh },
	{ token: 'ln', show: ' ln', type: 0, value: Math.log },
	{ token: '^', show: '^', type: 10, value: Math.pow },
	{ token: 'root', show: 'root', type: 0, value: Math.sqrt },
	{ token: '4', show: '4', type: 1, value: '4' },
	{ token: '5', show: '5', type: 1, value: '5' },
	{ token: '6', show: '6', type: 1, value: '6' },
	{ token: '/', show: '&divide;', type: 2, value: Mexp.math.div },
	{ token: '!', show: '!', type: 7, value: Mexp.math.fact },
	{ token: 'tanh', show: 'tanh', type: 0, value: Mexp.math.tanh },
	{ token: 'atanh', show: 'atanh', type: 0, value: Mexp.math.atanh },
	{ token: 'Mod', show: ' Mod ', type: 2, value: Mexp.math.mod },
	{ token: '1', show: '1', type: 1, value: '1' },
	{ token: '2', show: '2', type: 1, value: '2' },
	{ token: '3', show: '3', type: 1, value: '3' },
	{ token: '*', show: '&times;', type: 2, value: Mexp.math.mul },
	{ token: 'sinh', show: 'sinh', type: 0, value: Mexp.math.sinh },
	{ token: 'asinh', show: 'asinh', type: 0, value: Mexp.math.asinh },
	{ token: 'e', show: 'e', type: 3, value: 'E' },
	{ token: 'log', show: ' log', type: 0, value: Mexp.math.log },
	{ token: '0', show: '0', type: 1, value: '0' },
	{ token: '.', show: '.', type: 6, value: '.' },
	{ token: '+', show: '+', type: 9, value: Mexp.math.add },
	{ token: '-', show: '-', type: 9, value: Mexp.math.sub },
	{ token: ',', show: ',', type: 11, value: ',' },
	{ token: 'Sigma', show: '&Sigma;', type: 12, value: Mexp.math.sigma },
	{ token: 'n', show: 'n', type: 13, value: 'n' },
	{ token: 'Pi', show: '&Pi;', type: 12, value: Mexp.math.Pi },
	{ token: 'pow', show: 'pow', type: 8, value: Math.pow, numberOfArguments: 2 },
	{ token: '&', show: '&', type: 9, value: Mexp.math.and },
]
var preced = {
	0: 11,
	1: 0,
	2: 3,
	3: 0,
	4: 0,
	5: 0,
	6: 0,
	7: 11,
	8: 11,
	9: 1,
	10: 10,
	11: 0,
	12: 11,
	13: 0,
	14: -1,
	15: 11, // will be filtered after lexer
} // stores precedence by types
for (var i = 0; i < tokens.length; i++) {
	tokens[i].precedence = preced[tokens[i].type]
}
var type0 = {
	0: true,
	1: true,
	3: true,
	4: true,
	6: true,
	8: true,
	9: true,
	12: true,
	13: true,
	14: true,
	15: true,
} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
var type1 = {
	0: true,
	1: true,
	2: true,
	3: true,
	4: true,
	5: true,
	6: true,
	7: true,
	8: true,
	9: true,
	10: true,
	11: true,
	12: true,
	13: true,
	15: true,
} // type3:true,type5:true,type7:true,type23
var type1Asterick = {
	0: true,
	3: true,
	4: true,
	8: true,
	12: true,
	13: true,
	15: true,
}
var empty = {}
var type3Asterick = {
	0: true,
	1: true,
	3: true,
	4: true,
	6: true,
	8: true,
	12: true,
	13: true,
	15: true,
} // type_5:true,type_7:true,type_23
var type6 = {
	1: true,
}
var newAr = [
	[],
	[
		'1',
		'2',
		'3',
		'7',
		'8',
		'9',
		'4',
		'5',
		'6',
		'+',
		'-',
		'*',
		'/',
		'(',
		')',
		'^',
		'!',
		'P',
		'C',
		'e',
		'0',
		'.',
		',',
		'n',
		' ',
		'&',
	],
	['pi', 'ln', 'Pi'],
	['sin', 'cos', 'tan', 'Del', 'int', 'Mod', 'log', 'pow'],
	['asin', 'acos', 'atan', 'cosh', 'root', 'tanh', 'sinh'],
	['acosh', 'atanh', 'asinh', 'Sigma'],
]

function match(str1, str2, i, x) {
	for (var f = 0; f < x; f++) {
		if (str1[i + f] !== str2[f]) {
			return false
		}
	}
	return true
}
Mexp.tokenTypes = {
	FUNCTION_WITH_ONE_ARG: 0,
	NUMBER: 1,
	BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
	CONSTANT: 3,
	OPENING_PARENTHESIS: 4,
	CLOSING_PARENTHESIS: 5,
	DECIMAL: 6,
	POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
	FUNCTION_WITH_N_ARGS: 8,
	BINARY_OPERATOR_LOW_PRECENDENCE: 9,
	BINARY_OPERATOR_PERMUTATION: 10,
	COMMA: 11,
	EVALUATED_FUNCTION: 12,
	EVALUATED_FUNCTION_PARAMETER: 13,
	SPACE: 14,
}
/**
  
  0 : function with syntax function_name(Maths_exp)
  1 : numbers
  2 : binary operators like * / Mod left associate and same precedence
  3 : Math constant values like e,pi,Cruncher ans
  4 : opening bracket
  5 : closing bracket
  6 : decimal
  7 : function with syntax (Math_exp)function_name
  8: function with syntax function_name(Math_exp1,Math_exp2)
  9 : binary operator like +,-
  10: binary operator like P C or ^
  11: ,
  12: function with , seperated three parameters and third parameter is a string that will be mexp string
  13: variable of Sigma function
 */
Mexp.addToken = function (newTokens) {
	for (var i = 0; i < newTokens.length; i++) {
		var x = newTokens[i].token.length
		var temp = -1
		if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) {
			newTokens[i].numberOfArguments = 2
		}

		// newAr is a specially designed data structure index of 1d array = length of tokens
		newAr[x] = newAr[x] || []
		for (var y = 0; y < newAr[x].length; y++) {
			if (newTokens[i].token === newAr[x][y]) {
				temp = indexOfToken(newAr[x][y], tokens)
				break
			}
		}
		if (temp === -1) {
			tokens.push(newTokens[i])
			newTokens[i].precedence = preced[newTokens[i].type]
			if (newAr.length <= newTokens[i].token.length) {
				newAr[newTokens[i].token.length] = []
			}
			newAr[newTokens[i].token.length].push(newTokens[i].token)
		} else {
			// overwrite
			tokens[temp] = newTokens[i]
			newTokens[i].precedence = preced[newTokens[i].type]
		}
	}
}

function indexOfToken(key, tokens) {
	for (var search = 0; search < tokens.length; search++) {
		if (tokens[search].token === key) return search
	}
	return -1
}
function tokenize(string) {
	var nodes = []
	var length = string.length
	var key, x, y
	for (var i = 0; i < length; i++) {
		if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') {
			continue
		}
		key = ''
		for (x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--) {
			if (newAr[x] === undefined) continue
			for (y = 0; y < newAr[x].length; y++) {
				if (match(string, newAr[x][y], i, x)) {
					key = newAr[x][y]
					y = newAr[x].length
					x = 0
				}
			}
		}
		i += key.length - 1
		if (key === '') {
			throw new Mexp.Exception("Can't understand after " + string.slice(i))
		}
		nodes.push(tokens[indexOfToken(key, tokens)])
	}
	return nodes
}

var changeSignObj = {
	value: Mexp.math.changeSign,
	type: 0,
	pre: 21,
	show: '-',
}
var closingParObj = {
	value: ')',
	show: ')',
	type: 5,
	pre: 0,
}
var openingParObj = {
	value: '(',
	type: 4,
	pre: 0,
	show: '(',
}
Mexp.lex = function (inp, tokens) {
	'use strict'

	var str = [openingParObj]

	var ptc = [] // Parenthesis to close at the beginning is after one token
	var inpStr = inp
	var allowed = type0
	var bracToClose = 0
	var asterick = empty
	var prevKey = ''
	var i
	if (typeof tokens !== 'undefined') {
		Mexp.addToken(tokens)
	}
	var obj = {}
	var nodes = tokenize(inpStr)
	for (i = 0; i < nodes.length; i++) {
		var node = nodes[i]
		if (node.type === 14) {
			if (
				i > 0 &&
				i < nodes.length - 1 &&
				nodes[i + 1].type === 1 &&
				(nodes[i - 1].type === 1 || nodes[i - 1].type === 6)
			) {
				throw new Mexp.Exception('Unexpected Space')
			}
			continue
		}
		var cToken = node.token
		var cType = node.type
		var cEv = node.value
		var cPre = node.precedence
		var cShow = node.show
		var pre = str[str.length - 1]
		var j
		for (j = ptc.length; j--; ) {
			// loop over ptc
			if (ptc[j] === 0) {
				if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
					if (allowed[cType] !== true) {
						throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
					}
					str.push(closingParObj)
					allowed = type1
					asterick = type3Asterick
					ptc.pop()
				}
			} else break
		}
		if (allowed[cType] !== true) {
			throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
		}
		if (asterick[cType] === true) {
			cType = 2
			cEv = Mexp.math.mul
			cShow = '&times;'
			cPre = 3
			i = i - 1
		}
		obj = {
			value: cEv,
			type: cType,
			pre: cPre,
			show: cShow,
			numberOfArguments: node.numberOfArguments,
		}
		if (cType === 0) {
			allowed = type0
			asterick = empty
			inc(ptc, 2)
			str.push(obj)
			if (nodes[i + 1].type !== 4) {
				str.push(openingParObj)
				ptc.push(2)
			}
			// bracToClose++
		} else if (cType === 1) {
			if (pre.type === 1) {
				pre.value += cEv
				inc(ptc, 1)
			} else {
				str.push(obj)
			}
			allowed = type1
			asterick = type1Asterick
		} else if (cType === 2) {
			allowed = type0
			asterick = empty
			inc(ptc, 2)
			str.push(obj)
		} else if (cType === 3) {
			// constant
			str.push(obj)
			allowed = type1
			asterick = type3Asterick
		} else if (cType === 4) {
			inc(ptc, 1)
			bracToClose++
			allowed = type0
			asterick = empty
			str.push(obj)
		} else if (cType === 5) {
			if (!bracToClose) {
				throw new Mexp.Exception('Closing parenthesis are more than opening one, wait What!!!')
			}
			bracToClose--
			allowed = type1
			asterick = type3Asterick
			str.push(obj)
			inc(ptc, 1)
		} else if (cType === 6) {
			if (pre.hasDec) {
				throw new Mexp.Exception('Two decimals are not allowed in one number')
			}
			if (pre.type !== 1) {
				pre = {
					value: 0,
					type: 1,
					pre: 0,
				} // pre needs to be changed as it will the last value now to be safe in later code
				str.push(pre)
				// inc(ptc, 1)
			}
			allowed = type6
			inc(ptc, 1)
			asterick = empty
			pre.value += cEv
			pre.hasDec = true
		} else if (cType === 7) {
			allowed = type1
			asterick = type3Asterick
			inc(ptc, 1)
			str.push(obj)
		}
		if (cType === 8) {
			allowed = type0
			asterick = empty
			inc(ptc, node.numberOfArguments + 2)
			str.push(obj)
			// str.push(openingParObj)
			if (nodes[i + 1].type !== 4) {
				str.push(openingParObj)
				ptc.push(node.numberOfArguments + 2)
			}
		} else if (cType === 9) {
			if (pre.type === 9) {
				if (pre.value === Mexp.math.add) {
					pre.value = cEv
					pre.show = cShow
					inc(ptc, 1)
				} else if (pre.value === Mexp.math.sub && cShow === '-') {
					pre.value = Mexp.math.add
					pre.show = '+'
					inc(ptc, 1)
				}
			} else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
				// changesign only when negative is found
				if (cToken === '-') {
					// do nothing for + token
					// don't add with the above if statement as that will run the else statement of parent if on Ctoken +
					allowed = type0
					asterick = empty
					inc(ptc, 2).push(2)
					str.push(changeSignObj)
					str.push(openingParObj)
				}
			} else {
				str.push(obj)
				inc(ptc, 2)
			}
			allowed = type0
			asterick = empty
		} else if (cType === 10) {
			allowed = type0
			asterick = empty
			inc(ptc, 2)
			str.push(obj)
		} else if (cType === 11) {
			allowed = type0
			asterick = empty
			str.push(obj)
		} else if (cType === 12) {
			allowed = type0
			asterick = empty
			inc(ptc, 6)
			str.push(obj)
			if (nodes[i + 1].type !== 4) {
				str.push(openingParObj)
				ptc.push(6)
			}
		} else if (cType === 13) {
			allowed = type1
			asterick = type3Asterick
			str.push(obj)
		}

		inc(ptc, -1)
		prevKey = cToken
	}
	for (j = ptc.length; j--; ) {
		// loop over ptc
		str.push(closingParObj)
	}
	if (allowed[5] !== true) {
		throw new Mexp.Exception('complete the expression')
	}
	while (bracToClose--) {
		str.push(closingParObj)
	}

	str.push(closingParObj)
	//        console.log(str);
	return new Mexp(str)
}
module.exports = Mexp


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Mexp = function (parsed) {
  this.value = parsed
}

Mexp.math = {
  isDegree: true, // mode of calculator
  acos: function (x) {
    return (Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x))
  },
  add: function (a, b) {
    return a + b
  },
  asin: function (x) {
    return (Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x))
  },
  atan: function (x) {
    return (Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x))
  },
  acosh: function (x) {
    return Math.log(x + Math.sqrt(x * x - 1))
  },
  asinh: function (x) {
    return Math.log(x + Math.sqrt(x * x + 1))
  },
  atanh: function (x) {
    return Math.log((1 + x) / (1 - x))
  },
  C: function (n, r) {
    var pro = 1
    var other = n - r
    var choice = r
    if (choice < other) {
      choice = other
      other = r
    }
    for (var i = choice + 1; i <= n; i++) {
      pro *= i
    }
    return pro / Mexp.math.fact(other)
  },
  changeSign: function (x) {
    return -x
  },
  cos: function (x) {
    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
    return Math.cos(x)
  },
  cosh: function (x) {
    return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2
  },
  div: function (a, b) {
    return a / b
  },
  fact: function (n) {
    if (n % 1 !== 0) return 'NaN'
    var pro = 1
    for (var i = 2; i <= n; i++) {
      pro *= i
    }
    return pro
  },
  inverse: function (x) {
    return 1 / x
  },
  log: function (i) {
    return Math.log(i) / Math.log(10)
  },
  mod: function (a, b) {
    return a % b
  },
  mul: function (a, b) {
    return a * b
  },
  P: function (n, r) {
    var pro = 1
    for (var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++) {
      pro *= i
    }
    return pro
  },
  Pi: function (low, high, ex) {
    var pro = 1
    for (var i = low; i <= high; i++) {
      pro *= Number(ex.postfixEval({
        n: i
      }))
    }
    return pro
  },
  pow10x: function (e) {
    var x = 1
    while (e--) {
      x *= 10
    }
    return x
  },
  sigma: function (low, high, ex) {
    var sum = 0
    for (var i = low; i <= high; i++) {
      sum += Number(ex.postfixEval({
        n: i
      }))
    }
    return sum
  },
  sin: function (x) {
    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
    return Math.sin(x)
  },
  sinh: function (x) {
    return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2
  },
  sub: function (a, b) {
    return a - b
  },
  tan: function (x) {
    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
    return Math.tan(x)
  },
  tanh: function (x) {
    return Mexp.sinha(x) / Mexp.cosha(x)
  },
  toRadian: function (x) {
    return x * Math.PI / 180
  },
  and: function (a, b) {
    return a & b
  }
}
Mexp.Exception = function (message) {
  this.message = message
}
module.exports = Mexp


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {


var Mexp = __webpack_require__(2156);

Mexp.prototype.toPostfix = function () {
	'use strict';
	var post = [], elem, popped, prep, pre, ele;
	var stack = [{ value: "(", type: 4, pre: 0 }];
	var arr = this.value;
	for (var i = 1; i < arr.length; i++) {
		if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {	//if token is number,constant,or n(which is also a special constant in our case)
			if (arr[i].type === 1)
				arr[i].value = Number(arr[i].value);
			post.push(arr[i]);
		}
		else if (arr[i].type === 4) {
			stack.push(arr[i]);
		}
		else if (arr[i].type === 5) {
			while ((popped = stack.pop()).type !== 4) {
				post.push(popped);
			}
		}
		else if (arr[i].type === 11) {
			while ((popped = stack.pop()).type !== 4) {
				post.push(popped);
			}
			stack.push(popped);
		}
		else {
			elem = arr[i];
			pre = elem.pre;
			ele = stack[stack.length - 1];
			prep = ele.pre;
			var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
			if (pre > prep) stack.push(elem);
			else {
				while (prep >= pre && !flag || flag && pre < prep) {
					popped = stack.pop();
					ele = stack[stack.length - 1];
					post.push(popped);
					prep = ele.pre;
					flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
				}
				stack.push(elem);
			}
		}
	}
	return new Mexp(post);
};
module.exports = Mexp;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp = __webpack_require__(2158)
Mexp.prototype.postfixEval = function (UserDefined) {
	'use strict'
	UserDefined = UserDefined || {}
	UserDefined.PI = Math.PI
	UserDefined.E = Math.E
	var stack = [],
		pop1,
		pop2,
		pop3
	var disp = []
	var temp = ''
	var arr = this.value
	var bool = typeof UserDefined.n !== 'undefined'
	for (var i = 0; i < arr.length; i++) {
		if (arr[i].type === 1) {
			stack.push({ value: arr[i].value, type: 1 })
		} else if (arr[i].type === 3) {
			stack.push({ value: UserDefined[arr[i].value], type: 1 })
		} else if (arr[i].type === 0) {
			if (typeof stack[stack.length - 1].type === 'undefined') {
				stack[stack.length - 1].value.push(arr[i])
			} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
		} else if (arr[i].type === 7) {
			if (typeof stack[stack.length - 1].type === 'undefined') {
				stack[stack.length - 1].value.push(arr[i])
			} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
		} else if (arr[i].type === 8) {
			var popped = []
			for (var x = 0; x < arr[i].numberOfArguments; x++) {
				popped.push(stack.pop().value)
			}
			stack.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) })
		} else if (arr[i].type === 10) {
			pop1 = stack.pop()
			pop2 = stack.pop()
			if (typeof pop2.type === 'undefined') {
				pop2.value = pop2.concat(pop1)
				pop2.value.push(arr[i])
				stack.push(pop2)
			} else if (typeof pop1.type === 'undefined') {
				pop1.unshift(pop2)
				pop1.push(arr[i])
				stack.push(pop1)
			} else {
				stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
			}
		} else if (arr[i].type === 2 || arr[i].type === 9) {
			pop1 = stack.pop()
			pop2 = stack.pop()
			if (typeof pop2.type === 'undefined') {
				pop2 = pop2.concat(pop1)
				pop2.push(arr[i])
				stack.push(pop2)
			} else if (typeof pop1.type === 'undefined') {
				pop1.unshift(pop2)
				pop1.push(arr[i])
				stack.push(pop1)
			} else {
				stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
			}
		} else if (arr[i].type === 12) {
			pop1 = stack.pop()
			if (typeof pop1.type !== 'undefined') {
				pop1 = [pop1]
			}
			pop2 = stack.pop()
			pop3 = stack.pop()
			stack.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1)) })
		} else if (arr[i].type === 13) {
			if (bool) {
				stack.push({ value: UserDefined[arr[i].value], type: 3 })
			} else stack.push([arr[i]])
		}
	}
	if (stack.length > 1) {
		throw new Mexp.Exception('Uncaught Syntax error')
	}
	return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15))
}
Mexp.eval = function (str, tokens, obj) {
	if (typeof tokens === 'undefined') {
		return this.lex(str).toPostfix().postfixEval()
	} else if (typeof obj === 'undefined') {
		if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval()
		else return this.lex(str).toPostfix().postfixEval(tokens)
	} else return this.lex(str, tokens).toPostfix().postfixEval(obj)
}
module.exports = Mexp


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 661,
	"./af.js": 661,
	"./ar": 668,
	"./ar-dz": 662,
	"./ar-dz.js": 662,
	"./ar-kw": 663,
	"./ar-kw.js": 663,
	"./ar-ly": 664,
	"./ar-ly.js": 664,
	"./ar-ma": 665,
	"./ar-ma.js": 665,
	"./ar-sa": 666,
	"./ar-sa.js": 666,
	"./ar-tn": 667,
	"./ar-tn.js": 667,
	"./ar.js": 668,
	"./az": 669,
	"./az.js": 669,
	"./be": 670,
	"./be.js": 670,
	"./bg": 671,
	"./bg.js": 671,
	"./bm": 672,
	"./bm.js": 672,
	"./bn": 674,
	"./bn-bd": 673,
	"./bn-bd.js": 673,
	"./bn.js": 674,
	"./bo": 675,
	"./bo.js": 675,
	"./br": 676,
	"./br.js": 676,
	"./bs": 677,
	"./bs.js": 677,
	"./ca": 678,
	"./ca.js": 678,
	"./cs": 679,
	"./cs.js": 679,
	"./cv": 680,
	"./cv.js": 680,
	"./cy": 681,
	"./cy.js": 681,
	"./da": 682,
	"./da.js": 682,
	"./de": 685,
	"./de-at": 683,
	"./de-at.js": 683,
	"./de-ch": 684,
	"./de-ch.js": 684,
	"./de.js": 685,
	"./dv": 686,
	"./dv.js": 686,
	"./el": 687,
	"./el.js": 687,
	"./en-au": 688,
	"./en-au.js": 688,
	"./en-ca": 689,
	"./en-ca.js": 689,
	"./en-gb": 690,
	"./en-gb.js": 690,
	"./en-ie": 691,
	"./en-ie.js": 691,
	"./en-il": 692,
	"./en-il.js": 692,
	"./en-in": 693,
	"./en-in.js": 693,
	"./en-nz": 694,
	"./en-nz.js": 694,
	"./en-sg": 695,
	"./en-sg.js": 695,
	"./eo": 696,
	"./eo.js": 696,
	"./es": 700,
	"./es-do": 697,
	"./es-do.js": 697,
	"./es-mx": 698,
	"./es-mx.js": 698,
	"./es-us": 699,
	"./es-us.js": 699,
	"./es.js": 700,
	"./et": 701,
	"./et.js": 701,
	"./eu": 702,
	"./eu.js": 702,
	"./fa": 703,
	"./fa.js": 703,
	"./fi": 704,
	"./fi.js": 704,
	"./fil": 705,
	"./fil.js": 705,
	"./fo": 706,
	"./fo.js": 706,
	"./fr": 709,
	"./fr-ca": 707,
	"./fr-ca.js": 707,
	"./fr-ch": 708,
	"./fr-ch.js": 708,
	"./fr.js": 709,
	"./fy": 710,
	"./fy.js": 710,
	"./ga": 711,
	"./ga.js": 711,
	"./gd": 712,
	"./gd.js": 712,
	"./gl": 713,
	"./gl.js": 713,
	"./gom-deva": 714,
	"./gom-deva.js": 714,
	"./gom-latn": 715,
	"./gom-latn.js": 715,
	"./gu": 716,
	"./gu.js": 716,
	"./he": 717,
	"./he.js": 717,
	"./hi": 718,
	"./hi.js": 718,
	"./hr": 719,
	"./hr.js": 719,
	"./hu": 720,
	"./hu.js": 720,
	"./hy-am": 721,
	"./hy-am.js": 721,
	"./id": 722,
	"./id.js": 722,
	"./is": 723,
	"./is.js": 723,
	"./it": 725,
	"./it-ch": 724,
	"./it-ch.js": 724,
	"./it.js": 725,
	"./ja": 726,
	"./ja.js": 726,
	"./jv": 727,
	"./jv.js": 727,
	"./ka": 728,
	"./ka.js": 728,
	"./kk": 729,
	"./kk.js": 729,
	"./km": 730,
	"./km.js": 730,
	"./kn": 731,
	"./kn.js": 731,
	"./ko": 732,
	"./ko.js": 732,
	"./ku": 733,
	"./ku.js": 733,
	"./ky": 734,
	"./ky.js": 734,
	"./lb": 735,
	"./lb.js": 735,
	"./lo": 736,
	"./lo.js": 736,
	"./lt": 737,
	"./lt.js": 737,
	"./lv": 738,
	"./lv.js": 738,
	"./me": 739,
	"./me.js": 739,
	"./mi": 740,
	"./mi.js": 740,
	"./mk": 741,
	"./mk.js": 741,
	"./ml": 742,
	"./ml.js": 742,
	"./mn": 743,
	"./mn.js": 743,
	"./mr": 744,
	"./mr.js": 744,
	"./ms": 746,
	"./ms-my": 745,
	"./ms-my.js": 745,
	"./ms.js": 746,
	"./mt": 747,
	"./mt.js": 747,
	"./my": 748,
	"./my.js": 748,
	"./nb": 749,
	"./nb.js": 749,
	"./ne": 750,
	"./ne.js": 750,
	"./nl": 752,
	"./nl-be": 751,
	"./nl-be.js": 751,
	"./nl.js": 752,
	"./nn": 753,
	"./nn.js": 753,
	"./oc-lnc": 754,
	"./oc-lnc.js": 754,
	"./pa-in": 755,
	"./pa-in.js": 755,
	"./pl": 756,
	"./pl.js": 756,
	"./pt": 758,
	"./pt-br": 757,
	"./pt-br.js": 757,
	"./pt.js": 758,
	"./ro": 759,
	"./ro.js": 759,
	"./ru": 760,
	"./ru.js": 760,
	"./sd": 761,
	"./sd.js": 761,
	"./se": 762,
	"./se.js": 762,
	"./si": 763,
	"./si.js": 763,
	"./sk": 764,
	"./sk.js": 764,
	"./sl": 765,
	"./sl.js": 765,
	"./sq": 766,
	"./sq.js": 766,
	"./sr": 768,
	"./sr-cyrl": 767,
	"./sr-cyrl.js": 767,
	"./sr.js": 768,
	"./ss": 769,
	"./ss.js": 769,
	"./sv": 770,
	"./sv.js": 770,
	"./sw": 771,
	"./sw.js": 771,
	"./ta": 772,
	"./ta.js": 772,
	"./te": 773,
	"./te.js": 773,
	"./tet": 774,
	"./tet.js": 774,
	"./tg": 775,
	"./tg.js": 775,
	"./th": 776,
	"./th.js": 776,
	"./tk": 777,
	"./tk.js": 777,
	"./tl-ph": 778,
	"./tl-ph.js": 778,
	"./tlh": 779,
	"./tlh.js": 779,
	"./tr": 780,
	"./tr.js": 780,
	"./tzl": 781,
	"./tzl.js": 781,
	"./tzm": 783,
	"./tzm-latn": 782,
	"./tzm-latn.js": 782,
	"./tzm.js": 783,
	"./ug-cn": 784,
	"./ug-cn.js": 784,
	"./uk": 785,
	"./uk.js": 785,
	"./ur": 786,
	"./ur.js": 786,
	"./uz": 788,
	"./uz-latn": 787,
	"./uz-latn.js": 787,
	"./uz.js": 788,
	"./vi": 396,
	"./vi.js": 396,
	"./x-pseudo": 789,
	"./x-pseudo.js": 789,
	"./yo": 790,
	"./yo.js": 790,
	"./zh-cn": 791,
	"./zh-cn.js": 791,
	"./zh-hk": 792,
	"./zh-hk.js": 792,
	"./zh-mo": 793,
	"./zh-mo.js": 793,
	"./zh-tw": 794,
	"./zh-tw.js": 794
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2160;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(2381);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === global) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(796);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(288);
var assign = __webpack_require__(29);

var ReactPropTypesSecret = __webpack_require__(796);
var has = __webpack_require__(2166);
var checkPropTypes = __webpack_require__(2163);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2166 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module), __webpack_require__(56)))

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var React = __webpack_require__(0);

var REACT_ELEMENT_TYPE =
  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
  0xeac7;

var emptyFunction = __webpack_require__(71);
var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

var didWarnAboutMaps = false;

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

function getIteratorFn(maybeIterable) {
  var iteratorFn =
    maybeIterable &&
    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
      maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function(match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function traverseAllChildrenImpl(
  children,
  nameSoFar,
  callback,
  traverseContext
) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (
    children === null ||
    type === 'string' ||
    type === 'number' ||
    // The following is inlined from ReactElement. This means we can optimize
    // some checks. React Fiber also inlines this logic for similar purposes.
    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
  ) {
    callback(
      traverseContext,
      children,
      // If it's the only child, treat the name as if it was wrapped in an array
      // so that it's consistent if the number of children grows.
      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
    );
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(
        child,
        nextName,
        callback,
        traverseContext
      );
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      if (false) {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          warning(
            didWarnAboutMaps,
            'Using Maps as children is unsupported and will likely yield ' +
              'unexpected results. Convert it to a sequence/iterable of keyed ' +
              'ReactElements instead.'
          );
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(
          child,
          nextName,
          callback,
          traverseContext
        );
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum =
          ' If you meant to render a collection of children, use an array ' +
          'instead or wrap the object using createFragment(object) from the ' +
          'React add-ons.';
      }
      var childrenString = '' + children;
      invariant(
        false,
        'Objects are not valid as a React child (found: %s).%s',
        childrenString === '[object Object]'
          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
          : childrenString,
        addendum
      );
    }
  }

  return subtreeCount;
}

function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

function cloneAndReplaceKey(oldElement, newKey) {
  return React.cloneElement(
    oldElement,
    {key: newKey},
    oldElement.props !== undefined ? oldElement.props.children : undefined
  );
}

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

var oneArgumentPooler = function(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  invariant(
    instance instanceof Klass,
    'Trying to release an instance into a pool of a different type.'
  );
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function() {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(
      mappedChild,
      result,
      childKey,
      emptyFunction.thatReturnsArgument
    );
  } else if (mappedChild != null) {
    if (React.isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(
        mappedChild,
        // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        keyPrefix +
          (mappedChild.key && (!child || child.key !== mappedChild.key)
            ? escapeUserProvidedKey(mappedChild.key) + '/'
            : '') +
          childKey
      );
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(
    array,
    escapedPrefix,
    func,
    context
  );
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

function createReactFragment(object) {
  if (typeof object !== 'object' || !object || Array.isArray(object)) {
    warning(
      false,
      'React.addons.createFragment only accepts a single object. Got: %s',
      object
    );
    return object;
  }
  if (React.isValidElement(object)) {
    warning(
      false,
      'React.addons.createFragment does not accept a ReactElement ' +
        'without a wrapper object.'
    );
    return object;
  }

  invariant(
    object.nodeType !== 1,
    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
      'elements are not valid children of React components.'
  );

  var result = [];

  for (var key in object) {
    if (false) {
      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
        warning(
          false,
          'React.addons.createFragment(...): Child objects should have ' +
            'non-numeric keys so ordering is preserved.'
        );
        warnedAboutNumeric = true;
      }
    }
    mapIntoWithKeyPrefixInternal(
      object[key],
      result,
      key,
      emptyFunction.thatReturnsArgument
    );
  }

  return result;
}

module.exports = createReactFragment;


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(2285);


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(839);


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(798),
	PropTypes = __webpack_require__(54),
	createClass = __webpack_require__(69),
	moment = __webpack_require__(1),
	React = __webpack_require__(0),
	CalendarContainer = __webpack_require__(2173),
	onClickOutside = __webpack_require__(2243).default
	;

var viewModes = Object.freeze({
	YEARS: 'years',
	MONTHS: 'months',
	DAYS: 'days',
	TIME: 'time',
});

var TYPES = PropTypes;
var Datetime = createClass({
	displayName: 'DateTime',
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		// viewDate: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		onNavigateBack: TYPES.func,
		onNavigateForward: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		displayTimeZone: TYPES.string,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getInitialState: function() {
		this.checkTZ( this.props );
		
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ?
			(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;

		return state;
	},

	parseDate: function (date, formats) {
		var parsedDate;

		if (date && typeof date === 'string')
			parsedDate = this.localMoment(date, formats.datetime);
		else if (date)
			parsedDate = this.localMoment(date);

		if (parsedDate && !parsedDate.isValid())
			parsedDate = null;

		return parsedDate;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		selectedDate = this.parseDate(date, formats);

		viewDate = this.parseDate(props.viewDate, formats);

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return viewModes.DAYS;
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return viewModes.MONTHS;
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return viewModes.YEARS;
		}

		return viewModes.DAYS;
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else if ( nextProps.displayTimeZone ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
					updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}

		if ( nextProps.viewDate !== this.props.viewDate ) {
			updatedState.viewDate = moment(nextProps.viewDate);
		}

		this.checkTZ( nextProps );

		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: viewModes.DAYS,
				year: viewModes.MONTHS,
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	subtractTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateBack( amount, type );
			me.updateTime( 'subtract', amount, type, toSelected );
		};
	},

	addTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateForward( amount, type );
			me.updateTime( 'add', amount, type, toSelected );
		};
	},

	updateTime: function( op, amount, type, toSelected ) {
		var update = {},
			date = toSelected ? 'selectedDate' : 'viewDate';

		update[ date ] = this.state[ date ].clone()[ op ]( amount, type );

		this.setState( update );
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.currentTarget,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var m = null;

		if (props.utc) {
			m = moment.utc(date, format, props.strictParsing);
		} else if (props.displayTimeZone) {
			m = moment.tz(date, format, props.displayTimeZone);
		} else {
			m = moment(date, format, props.strictParsing);
		}

		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	checkTZ: function( props ) {
		var con = console;

		if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
			this.tzWarning = true;
			con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
		}
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	overrideEvent: function( handler, action ) {
		if ( !this.overridenEvents ) {
			this.overridenEvents = {};
		}

		if ( !this.overridenEvents[handler] ) {
			var me = this;
			this.overridenEvents[handler] = function( e ) {
				var result;
				if ( me.props.inputProps && me.props.inputProps[handler] ) {
					result = me.props.inputProps[handler]( e );
				}
				if ( result !== false ) {
					action( e );
				}
			};
		}

		return this.overridenEvents[handler];
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
									( Array.isArray( this.props.className ) ?
									' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign(
				{ type: 'text', className: 'form-control', value: this.state.inputValue },
				this.props.inputProps,
				{
					onClick: this.overrideEvent( 'onClick', this.openCalendar ),
					onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
					onChange: this.overrideEvent( 'onChange', this.onInputChange ),
					onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
				}
			);

			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.props.open || (this.props.open === undefined && this.state.open ) )
			className += ' rdtOpen';

		return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
			)
		));
	}
});

var ClickableWrapper = onClickOutside( createClass({
	render: function() {
		return React.createElement( 'div', { className: this.props.className }, this.props.children );
	},
	handleClickOutside: function( e ) {
		this.props.onClickOut( e );
	}
}));

Datetime.defaultProps = {
	className: '',
	defaultValue: '',
	inputProps: {},
	input: true,
	onFocus: function() {},
	onBlur: function() {},
	onChange: function() {},
	onViewModeChange: function() {},
	onNavigateBack: function() {},
	onNavigateForward: function() {},
	timeFormat: true,
	timeConstraints: {},
	dateFormat: true,
	strictParsing: true,
	closeOnSelect: false,
	closeOnTab: true,
	utc: false
};

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(69),
	DaysView = __webpack_require__(2174),
	MonthsView = __webpack_require__(2175),
	YearsView = __webpack_require__(2177),
	TimeView = __webpack_require__(2176)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(69),
	moment = __webpack_require__(1)
	;

var DateTimePickerDays = createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	}
});

module.exports = DateTimePickerDays;


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(69)
;

var DateTimePickerMonths = createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(69),
	assign = __webpack_require__(798)
	;

var DateTimePickerTime = createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );

		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				document.body.removeEventListener( 'touchend', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
			document.body.addEventListener( 'touchend', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},
});

module.exports = DateTimePickerTime;


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(69)
;

var DateTimePickerYears = createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

module.exports = DateTimePickerYears;


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(55);

var focusNode = __webpack_require__(619);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(221);
var ExecutionEnvironment = __webpack_require__(76);
var FallbackCompositionState = __webpack_require__(2186);
var SyntheticCompositionEvent = __webpack_require__(2223);
var SyntheticInputEvent = __webpack_require__(2226);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(799);
var ExecutionEnvironment = __webpack_require__(76);
var ReactInstrumentation = __webpack_require__(99);

var camelizeStyleName = __webpack_require__(1988);
var dangerousStyleValue = __webpack_require__(2232);
var hyphenateStyleName = __webpack_require__(1996);
var memoizeStringOnly = __webpack_require__(622);
var warning = __webpack_require__(37);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(220);
var EventPropagators = __webpack_require__(221);
var ExecutionEnvironment = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactUpdates = __webpack_require__(108);
var SyntheticEvent = __webpack_require__(121);

var inputValueTracking = __webpack_require__(815);
var getEventTarget = __webpack_require__(409);
var isEventSupported = __webpack_require__(410);
var isTextInputElement = __webpack_require__(817);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var DOMLazyTree = __webpack_require__(182);
var ExecutionEnvironment = __webpack_require__(76);

var createNodesFromMarkup = __webpack_require__(1989);
var emptyFunction = __webpack_require__(71);
var invariant = __webpack_require__(21);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(221);
var ReactDOMComponentTree = __webpack_require__(55);
var SyntheticMouseEvent = __webpack_require__(284);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var PooledClass = __webpack_require__(160);

var getTextContentAccessor = __webpack_require__(814);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(183);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(184);

var instantiateReactComponent = __webpack_require__(816);
var KeyEscapeUtils = __webpack_require__(401);
var shouldUpdateReactComponent = __webpack_require__(411);
var traverseAllChildren = __webpack_require__(819);
var warning = __webpack_require__(37);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(842);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(397);
var ReactDOMIDOperations = __webpack_require__(2196);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var React = __webpack_require__(187);
var ReactComponentEnvironment = __webpack_require__(403);
var ReactCurrentOwner = __webpack_require__(122);
var ReactErrorUtils = __webpack_require__(404);
var ReactInstanceMap = __webpack_require__(222);
var ReactInstrumentation = __webpack_require__(99);
var ReactNodeTypes = __webpack_require__(809);
var ReactReconciler = __webpack_require__(184);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(376);
var invariant = __webpack_require__(21);
var shallowEqual = __webpack_require__(272);
var shouldUpdateReactComponent = __webpack_require__(411);
var warning = __webpack_require__(37);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(55);
var ReactDefaultInjection = __webpack_require__(2204);
var ReactMount = __webpack_require__(808);
var ReactReconciler = __webpack_require__(184);
var ReactUpdates = __webpack_require__(108);
var ReactVersion = __webpack_require__(2217);

var findDOMNode = __webpack_require__(2233);
var getHostComponentFromComposite = __webpack_require__(813);
var renderSubtreeIntoContainer = __webpack_require__(2240);
var warning = __webpack_require__(37);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var AutoFocusUtils = __webpack_require__(2179);
var CSSPropertyOperations = __webpack_require__(2181);
var DOMLazyTree = __webpack_require__(182);
var DOMNamespaces = __webpack_require__(398);
var DOMProperty = __webpack_require__(183);
var DOMPropertyOperations = __webpack_require__(801);
var EventPluginHub = __webpack_require__(220);
var EventPluginRegistry = __webpack_require__(399);
var ReactBrowserEventEmitter = __webpack_require__(283);
var ReactDOMComponentFlags = __webpack_require__(802);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactDOMInput = __webpack_require__(2197);
var ReactDOMOption = __webpack_require__(2198);
var ReactDOMSelect = __webpack_require__(803);
var ReactDOMTextarea = __webpack_require__(2201);
var ReactInstrumentation = __webpack_require__(99);
var ReactMultiChild = __webpack_require__(2210);
var ReactServerRenderingTransaction = __webpack_require__(2215);

var emptyFunction = __webpack_require__(71);
var escapeTextContentForBrowser = __webpack_require__(286);
var invariant = __webpack_require__(21);
var isEventSupported = __webpack_require__(410);
var shallowEqual = __webpack_require__(272);
var inputValueTracking = __webpack_require__(815);
var validateDOMNesting = __webpack_require__(412);
var warning = __webpack_require__(37);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(412);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var DOMLazyTree = __webpack_require__(182);
var ReactDOMComponentTree = __webpack_require__(55);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(397);
var ReactDOMComponentTree = __webpack_require__(55);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var DOMPropertyOperations = __webpack_require__(801);
var LinkedValueUtils = __webpack_require__(402);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactUpdates = __webpack_require__(108);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var React = __webpack_require__(187);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactDOMSelect = __webpack_require__(803);

var warning = __webpack_require__(37);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);

var getNodeForCharacterOffset = __webpack_require__(2237);
var getTextContentAccessor = __webpack_require__(814);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var DOMChildrenOperations = __webpack_require__(397);
var DOMLazyTree = __webpack_require__(182);
var ReactDOMComponentTree = __webpack_require__(55);

var escapeTextContentForBrowser = __webpack_require__(286);
var invariant = __webpack_require__(21);
var validateDOMNesting = __webpack_require__(412);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38),
    _assign = __webpack_require__(29);

var LinkedValueUtils = __webpack_require__(402);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactUpdates = __webpack_require__(108);

var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var ReactUpdates = __webpack_require__(108);
var Transaction = __webpack_require__(285);

var emptyFunction = __webpack_require__(71);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(2178);
var BeforeInputEventPlugin = __webpack_require__(2180);
var ChangeEventPlugin = __webpack_require__(2182);
var DefaultEventPluginOrder = __webpack_require__(2184);
var EnterLeaveEventPlugin = __webpack_require__(2185);
var HTMLDOMPropertyConfig = __webpack_require__(2187);
var ReactComponentBrowserEnvironment = __webpack_require__(2189);
var ReactDOMComponent = __webpack_require__(2192);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactDOMEmptyComponent = __webpack_require__(2194);
var ReactDOMTreeTraversal = __webpack_require__(2202);
var ReactDOMTextComponent = __webpack_require__(2200);
var ReactDefaultBatchingStrategy = __webpack_require__(2203);
var ReactEventListener = __webpack_require__(2207);
var ReactInjection = __webpack_require__(2208);
var ReactReconcileTransaction = __webpack_require__(2213);
var SVGDOMPropertyConfig = __webpack_require__(2218);
var SelectEventPlugin = __webpack_require__(2219);
var SimpleEventPlugin = __webpack_require__(2220);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(220);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var EventListener = __webpack_require__(614);
var ExecutionEnvironment = __webpack_require__(76);
var PooledClass = __webpack_require__(160);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactUpdates = __webpack_require__(108);

var getEventTarget = __webpack_require__(409);
var getUnboundedScrollPosition = __webpack_require__(620);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(183);
var EventPluginHub = __webpack_require__(220);
var EventPluginUtils = __webpack_require__(400);
var ReactComponentEnvironment = __webpack_require__(403);
var ReactEmptyComponent = __webpack_require__(804);
var ReactBrowserEventEmitter = __webpack_require__(283);
var ReactHostComponent = __webpack_require__(806);
var ReactUpdates = __webpack_require__(108);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(2231);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactComponentEnvironment = __webpack_require__(403);
var ReactInstanceMap = __webpack_require__(222);
var ReactInstrumentation = __webpack_require__(99);

var ReactCurrentOwner = __webpack_require__(122);
var ReactReconciler = __webpack_require__(184);
var ReactChildReconciler = __webpack_require__(2188);

var emptyFunction = __webpack_require__(71);
var flattenChildren = __webpack_require__(2234);
var invariant = __webpack_require__(21);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var invariant = __webpack_require__(21);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var CallbackQueue = __webpack_require__(800);
var PooledClass = __webpack_require__(160);
var ReactBrowserEventEmitter = __webpack_require__(283);
var ReactInputSelection = __webpack_require__(807);
var ReactInstrumentation = __webpack_require__(99);
var Transaction = __webpack_require__(285);
var ReactUpdateQueue = __webpack_require__(405);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(2211);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(29);

var PooledClass = __webpack_require__(160);
var Transaction = __webpack_require__(285);
var ReactInstrumentation = __webpack_require__(99);
var ReactServerUpdateQueue = __webpack_require__(2216);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(405);

var warning = __webpack_require__(37);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(221);
var ExecutionEnvironment = __webpack_require__(76);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactInputSelection = __webpack_require__(807);
var SyntheticEvent = __webpack_require__(121);

var getActiveElement = __webpack_require__(271);
var isTextInputElement = __webpack_require__(817);
var shallowEqual = __webpack_require__(272);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(38);

var EventListener = __webpack_require__(614);
var EventPropagators = __webpack_require__(221);
var ReactDOMComponentTree = __webpack_require__(55);
var SyntheticAnimationEvent = __webpack_require__(2221);
var SyntheticClipboardEvent = __webpack_require__(2222);
var SyntheticEvent = __webpack_require__(121);
var SyntheticFocusEvent = __webpack_require__(2225);
var SyntheticKeyboardEvent = __webpack_require__(2227);
var SyntheticMouseEvent = __webpack_require__(284);
var SyntheticDragEvent = __webpack_require__(2224);
var SyntheticTouchEvent = __webpack_require__(2228);
var SyntheticTransitionEvent = __webpack_require__(2229);
var SyntheticUIEvent = __webpack_require__(223);
var SyntheticWheelEvent = __webpack_require__(2230);

var emptyFunction = __webpack_require__(71);
var getEventCharCode = __webpack_require__(407);
var invariant = __webpack_require__(21);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(284);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(223);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(223);

var getEventCharCode = __webpack_require__(407);
var getEventKey = __webpack_require__(2235);
var getEventModifierState = __webpack_require__(408);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(223);

var getEventModifierState = __webpack_require__(408);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(284);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(799);
var warning = __webpack_require__(37);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(38);

var ReactCurrentOwner = __webpack_require__(122);
var ReactDOMComponentTree = __webpack_require__(55);
var ReactInstanceMap = __webpack_require__(222);

var getHostComponentFromComposite = __webpack_require__(813);
var invariant = __webpack_require__(21);
var warning = __webpack_require__(37);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(401);
var traverseAllChildren = __webpack_require__(819);
var warning = __webpack_require__(37);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(842);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(407);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(76);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(286);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(808);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreakView = function BreakView(props) {
  var label = props.breakLabel;
  var className = props.breakClassName || 'break';

  return _react2.default.createElement(
    'li',
    { className: className },
    label
  );
};

exports.default = BreakView;
//# sourceMappingURL=BreakView.js.map

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageView = function PageView(props) {
  var cssClassName = props.pageClassName;
  var linkClassName = props.pageLinkClassName;
  var onClick = props.onClick;
  var href = props.href;
  var ariaLabel = 'Page ' + props.page + (props.extraAriaContext ? ' ' + props.extraAriaContext : '');
  var ariaCurrent = null;

  if (props.selected) {
    ariaCurrent = 'page';
    ariaLabel = 'Page ' + props.page + ' is your current page';
    if (typeof cssClassName !== 'undefined') {
      cssClassName = cssClassName + ' ' + props.activeClassName;
    } else {
      cssClassName = props.activeClassName;
    }
  }

  return _react2.default.createElement(
    'li',
    { className: cssClassName },
    _react2.default.createElement(
      'a',
      { onClick: onClick,
        className: linkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick },
      props.page
    )
  );
};

exports.default = PageView;
//# sourceMappingURL=PageView.js.map

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCreateFragment = __webpack_require__(2168);

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _PageView = __webpack_require__(2245);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(2244);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));

    _this.handlePreviousPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected > 0) {
        _this.handlePageSelected(_this.state.selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected < _this.props.pageCount - 1) {
        _this.handlePageSelected(_this.state.selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = {};

      if (_this.props.pageCount <= _this.props.pageRangeDisplayed) {

        for (var index = 0; index < _this.props.pageCount; index++) {
          items['key' + index] = _this.getPageElement(index);
        }
      } else {

        var leftSide = _this.props.pageRangeDisplayed / 2;
        var rightSide = _this.props.pageRangeDisplayed - leftSide;

        if (_this.state.selected > _this.props.pageCount - _this.props.pageRangeDisplayed / 2) {
          rightSide = _this.props.pageCount - _this.state.selected;
          leftSide = _this.props.pageRangeDisplayed - rightSide;
        } else if (_this.state.selected < _this.props.pageRangeDisplayed / 2) {
          leftSide = _this.state.selected;
          rightSide = _this.props.pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;
        var createPageView = function createPageView(index) {
          return _this.getPageElement(index);
        };

        for (_index = 0; _index < _this.props.pageCount; _index++) {

          page = _index + 1;

          if (page <= _this.props.marginPagesDisplayed) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          if (page > _this.props.pageCount - _this.props.marginPagesDisplayed) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          if (_index >= _this.state.selected - leftSide && _index <= _this.state.selected + rightSide) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          var keys = Object.keys(items);
          var breakLabelKey = keys[keys.length - 1];
          var breakLabelValue = items[breakLabelKey];

          if (_this.props.breakLabel && breakLabelValue !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              breakLabel: _this.props.breakLabel,
              breakClassName: _this.props.breakClassName
            });

            items['key' + _index] = breakView;
          }
        }
      }

      return items;
    };

    _this.state = {
      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the callback with the initialPage item:
      if (typeof this.props.initialPage !== 'undefined' && !this.props.disableInitialCallback) {
        this.callCallback(this.props.initialPage);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      if (this.props.hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < this.props.pageCount) {
        return this.props.hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      return _react2.default.createElement(_PageView2.default, {
        onClick: this.handlePageSelected.bind(null, index),
        selected: this.state.selected === index,
        pageClassName: this.props.pageClassName,
        pageLinkClassName: this.props.pageLinkClassName,
        activeClassName: this.props.activeClassName,
        extraAriaContext: this.props.extraAriaContext,
        href: this.hrefBuilder(index),
        page: index + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var disabled = this.props.disabledClassName;

      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, _defineProperty({}, disabled, this.state.selected === 0));

      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, _defineProperty({}, disabled, this.state.selected === this.props.pageCount - 1));

      return _react2.default.createElement(
        'ul',
        { className: this.props.containerClassName },
        _react2.default.createElement(
          'li',
          { className: previousClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handlePreviousPage,
              className: this.props.previousLinkClassName,
              href: this.hrefBuilder(this.state.selected - 1),
              tabIndex: '0',
              onKeyPress: this.handlePreviousPage },
            this.props.previousLabel
          )
        ),
        (0, _reactAddonsCreateFragment2.default)(this.pagination()),
        _react2.default.createElement(
          'li',
          { className: nextClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handleNextPage,
              className: this.props.nextLinkClassName,
              href: this.hrefBuilder(this.state.selected + 1),
              tabIndex: '0',
              onKeyPress: this.handleNextPage },
            this.props.nextLabel
          )
        )
      );
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _propTypes2.default.number.isRequired,
  pageRangeDisplayed: _propTypes2.default.number.isRequired,
  marginPagesDisplayed: _propTypes2.default.number.isRequired,
  previousLabel: _propTypes2.default.node,
  nextLabel: _propTypes2.default.node,
  breakLabel: _propTypes2.default.node,
  hrefBuilder: _propTypes2.default.func,
  onPageChange: _propTypes2.default.func,
  initialPage: _propTypes2.default.number,
  forcePage: _propTypes2.default.number,
  disableInitialCallback: _propTypes2.default.bool,
  containerClassName: _propTypes2.default.string,
  pageClassName: _propTypes2.default.string,
  pageLinkClassName: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  previousClassName: _propTypes2.default.string,
  nextClassName: _propTypes2.default.string,
  previousLinkClassName: _propTypes2.default.string,
  nextLinkClassName: _propTypes2.default.string,
  disabledClassName: _propTypes2.default.string,
  breakClassName: _propTypes2.default.string
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: "selected",
  previousClassName: "previous",
  nextClassName: "next",
  previousLabel: "Previous",
  nextLabel: "Next",
  breakLabel: "...",
  disabledClassName: "disabled",
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(414);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(2252);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(823);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(823);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(825);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(2253);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(414);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _resizeDetectorStyles = __webpack_require__(2258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResizeDetector = function (_Component) {
  _inherits(ResizeDetector, _Component);

  function ResizeDetector() {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));

    _this.state = {
      expandChildHeight: 0,
      expandChildWidth: 0,
      expandScrollLeft: 0,
      expandScrollTop: 0,
      shrinkScrollTop: 0,
      shrinkScrollLeft: 0,
      lastWidth: 0,
      lastHeight: 0
    };

    _this.reset = _this.reset.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _containerSize = this.containerSize();

      var _containerSize2 = _slicedToArray(_containerSize, 2);

      var width = _containerSize2[0];
      var height = _containerSize2[1];

      this.reset(width, height);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.expand.scrollLeft = this.expand.scrollWidth;
      this.expand.scrollTop = this.expand.scrollHeight;

      this.shrink.scrollLeft = this.shrink.scrollWidth;
      this.shrink.scrollTop = this.shrink.scrollHeight;
    }
  }, {
    key: 'containerSize',
    value: function containerSize() {
      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
    }
  }, {
    key: 'reset',
    value: function reset(containerWidth, containerHeight) {
      if (typeof window === 'undefined') {
        return;
      }

      var parent = this.container.parentElement;

      var position = 'static';
      if (parent.currentStyle) {
        position = parent.currentStyle.position;
      } else if (window.getComputedStyle) {
        position = window.getComputedStyle(parent).position;
      }
      if (position === 'static') {
        parent.style.position = 'relative';
      }

      this.setState({
        expandChildHeight: this.expand.offsetHeight + 10,
        expandChildWidth: this.expand.offsetWidth + 10,
        lastWidth: containerWidth,
        lastHeight: containerHeight
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (typeof window === 'undefined') {
        return;
      }

      var state = this.state;

      var _containerSize3 = this.containerSize();

      var _containerSize4 = _slicedToArray(_containerSize3, 2);

      var width = _containerSize4[0];
      var height = _containerSize4[1];

      if (width !== state.lastWidth || height !== state.lastHeight) {
        this.props.onResize(width, height);
      }

      this.reset(width, height);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var state = this.state;


      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
        width: state.expandChildWidth,
        height: state.expandChildHeight
      });

      return _react2.default.createElement(
        'div',
        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
            _this2.container = e;
          } },
        _react2.default.createElement(
          'div',
          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
              _this2.expand = e;
            } },
          _react2.default.createElement('div', { style: expandStyle })
        ),
        _react2.default.createElement(
          'div',
          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
              _this2.shrink = e;
            } },
          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
        )
      );
    }
  }]);

  return ResizeDetector;
}(_react.Component);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _react.PropTypes.bool,
  handleHeight: _react.PropTypes.bool,
  onResize: _react.PropTypes.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var parentStyle = exports.parentStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  overflow: 'scroll',
  zIndex: -1,
  visibility: 'hidden'
};

var shrinkChildStyle = exports.shrinkChildStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '200%',
  height: '200%'
};

var expandChildStyle = exports.expandChildStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(2257);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(826);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(828);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(829);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(224);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(224);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(224);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(186);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== 'undefined';

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(415);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(186);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(834);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(185);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(830);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(185);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(834);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(185);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(832);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(417);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsTransitionGroup = __webpack_require__(2170);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _AnimateGroupChild = __webpack_require__(2280);

var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimateGroup = (_temp = _class = function (_Component) {
  _inherits(AnimateGroup, _Component);

  function AnimateGroup() {
    _classCallCheck(this, AnimateGroup);

    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
  }

  _createClass(AnimateGroup, [{
    key: 'wrapChild',
    value: function wrapChild(child) {
      var _props = this.props,
          appear = _props.appear,
          leave = _props.leave,
          enter = _props.enter;


      return _react2.default.createElement(
        _AnimateGroupChild2.default,
        {
          appear: appear,
          leave: leave,
          enter: enter
        },
        child
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          children = _props2.children;


      return _react2.default.createElement(
        _reactAddonsTransitionGroup2.default,
        {
          component: component,
          childFactory: this.wrapChild.bind(this)
        },
        children
      );
    }
  }]);

  return AnimateGroup;
}(_react.Component), _class.propTypes = {
  appear: _react.PropTypes.object,
  leave: _react.PropTypes.object,
  enter: _react.PropTypes.object,
  children: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.element]),
  component: _react.PropTypes.any
}, _class.defaultProps = {
  component: 'span'
}, _temp);
exports.default = AnimateGroup;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Animate = __webpack_require__(837);

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimateGroupChild = (_temp2 = _class = function (_Component) {
  _inherits(AnimateGroupChild, _Component);

  function AnimateGroupChild() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AnimateGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AnimateGroupChild, [{
    key: 'handleStyleActive',
    value: function handleStyleActive(style, done) {
      if (style) {
        var onAnimationEnd = style.onAnimationEnd ? function () {
          style.onAnimationEnd();
          done();
        } : done;

        this.setState(_extends({}, style, {
          onAnimationEnd: onAnimationEnd,
          isActive: true
        }));
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      this.handleStyleActive(this.props.appear, done);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      this.handleStyleActive(this.props.enter, done);
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      this.handleStyleActive(this.props.leave, done);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Animate2.default,
        this.state,
        _react.Children.only(this.props.children)
      );
    }
  }]);

  return AnimateGroupChild;
}(_react.Component), _class.propTypes = {
  appear: _react.PropTypes.object,
  leave: _react.PropTypes.object,
  enter: _react.PropTypes.object,
  children: _react.PropTypes.element
}, _temp2);
exports.default = AnimateGroupChild;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = createAnimateManager;

var _setRafTimeout = __webpack_require__(2284);

var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange() {
    return null;
  };
  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;

      var _styles = _toArray(styles),
          curr = _styles[0],
          restStyles = _styles.slice(1);

      if (typeof curr === 'number') {
        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);

        return;
      }

      setStyle(curr);
      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
      return;
    }

    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;

      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallowEqual = undefined;

var _isPlainObject2 = __webpack_require__(655);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isEqual2 = __webpack_require__(653);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _isArray2 = __webpack_require__(51);

var _isArray3 = _interopRequireDefault(_isArray2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    var keyA = keysA[i];

    if (objA[keyA] === objB[keyA]) {
      continue;
    }

    // special diff with Array or Object
    if ((0, _isArray3.default)(objA[keyA])) {
      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
        return false;
      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

function shouldComponentUpdate(nextProps, nextState) {
  return shallowCompare(this, nextProps, nextState);
}
/* eslint-disable no-param-reassign */
function pureRenderDecorator(component) {
  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}
exports.shallowEqual = shallowEqual;
exports.default = pureRenderDecorator;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(2140);

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _raf = __webpack_require__(797);

var _raf2 = _interopRequireDefault(_raf);

var _util = __webpack_require__(289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};

/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */
var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = (0, _util.mapObject)(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          _easing2 = _slicedToArray(_easing, 2),
          newX = _easing2[0],
          newV = _easing2[1];

      return _extends({}, val, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return (0, _util.mapObject)(function (key, val) {
      if (needContinue(val)) {
        return _extends({}, val, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
};

// configure update function

exports.default = function (from, to, easing, duration, render) {
  var interKeys = (0, _util.getIntersectionKeys)(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
  }, {});

  var stepperStyle = interKeys.reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime = void 0;
  var beginTime = void 0;
  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return (0, _util.mapObject)(function (key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation() {
    return !(0, _filter3.default)(stepperStyle, needContinue).length;
  };

  // stepper timing function like spring
  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;

    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    // get union set and add compatible prefix
    render(_extends({}, from, to, getCurrStyle(stepperStyle)));

    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = (0, _raf2.default)(update);
    }
  };

  // t => val timing function like cubic-bezier
  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = (0, _util.mapObject)(function (key, val) {
      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
    }, timingStyle);

    // get union set and add compatible prefix
    render(_extends({}, from, to, currStyle));

    if (t < 1) {
      cafId = (0, _raf2.default)(update);
    } else {
      var finalStyle = (0, _util.mapObject)(function (key, val) {
        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
      }, timingStyle);

      render(_extends({}, from, to, finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate;

  // return start animation method
  return function () {
    (0, _raf2.default)(update);

    // return stop animation method
    return function () {
      (0, _raf.cancel)(cafId);
    };
  };
};

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setRafTimeout;

var _raf = __webpack_require__(797);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      (0, _raf2.default)(shouldUpdate);
    }
  };

  (0, _raf2.default)(shouldUpdate);
}

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(839);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(2286);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(840);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(1905);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1907);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1909);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1908);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(61);

var _PropTypes = __webpack_require__(840);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(225);

var invariant = __webpack_require__(21);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(2289);
var ReactElement = __webpack_require__(188);

var emptyFunction = __webpack_require__(71);
var traverseAllChildren = __webpack_require__(2299);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(188);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(188),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(795);

module.exports = factory(isValidElement);

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(841),
    Component = _require.Component;

var _require2 = __webpack_require__(188),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(844);
var factory = __webpack_require__(544);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(225);

var ReactElement = __webpack_require__(188);

var invariant = __webpack_require__(21);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(225);

var ReactCurrentOwner = __webpack_require__(122);
var REACT_ELEMENT_TYPE = __webpack_require__(843);

var getIteratorFn = __webpack_require__(2295);
var invariant = __webpack_require__(21);
var KeyEscapeUtils = __webpack_require__(2288);
var warning = __webpack_require__(37);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _utils = __webpack_require__(847);

var _arithmetic = __webpack_require__(2301);

var _arithmetic2 = _interopRequireDefault(_arithmetic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max;

  // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}

/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Number}  roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Number}  The step which is easy to understand between two ticks
 */
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep <= 0) {
    return 0;
  }

  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
  // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step
  var stepRatio = roughStep / Math.pow(10, digitCount);
  // When an integer and a float multiplied, the accuracy of result may be wrong
  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);

  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));

  return allowDecimals ? formatStep : Math.ceil(formatStep);
}

/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */
function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var isFlt = _arithmetic2.default.isFloat(value);
  var step = 1;
  // calculate the middle value of ticks
  var middle = value;

  if (isFlt && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);

      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = Math.floor(value);
    }
  } else if (value === 0) {
    middle = Math.floor((tickCount - 1) / 2);
  } else if (!allowDecimals) {
    middle = Math.floor(value);
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);

  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
  }), _utils.range);

  return fn(0, tickCount);
}

/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */
function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // The step which is easy to understand between two ticks
  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
  // A medial value of ticks
  var middle = void 0;

  // When 0 is inside the interval, 0 should be a tick
  if (min <= 0 && max >= 0) {
    middle = 0;
  } else {
    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
  }

  var belowCount = Math.ceil((middle - min) / step);
  var upCount = Math.ceil((max - middle) / step);
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  } else if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
  };
}
/**
 * Calculate the ticks of an interval
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */
function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  // Get the step between two ticks

  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);

  return min > max ? (0, _utils.reverse)(values) : values;
}

function getTickValuesFn(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      min = _ref6[0],
      max = _ref6[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval3 = getValidInterval([min, max]),
      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
      cormin = _getValidInterval4[0],
      cormax = _getValidInterval4[1];

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);

  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return cormin + n * step;
  }), _utils.range);

  var values = fn(0, count).filter(function (entry) {
    return entry >= cormin && entry <= cormax;
  });

  return min > max ? (0, _utils.reverse)(values) : values;
}

function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);

  return min > max ? (0, _utils.reverse)(values) : values;
}

var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(847);

/**
 * 判断数据是否为浮点类型
 *
 * @param {Number} num 输入值
 * @return {Boolean} 是否是浮点类型
 */
function isFloat(num) {
  return (/^([+-]?)\d*\.\d+$/.test(num)
  );
}

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */
function getDigitCount(value) {
  var abs = Math.abs(value);
  var result = void 0;

  if (value === 0) {
    result = 1;
  } else if (abs < 1) {
    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
  } else {
    var str = '' + value;
    var ary = str.split('.');

    result = ary[0].length;
  }

  return result;
}
/**
 * 计算数值的小数点后的位数
 * @param  {Number} a 数值，可能为整数，也可能为浮点数
 * @return {Integer}   位数
 */
function getDecimalDigitCount(a) {
  var str = a ? '' + a : '';
  var ary = str.split('.');

  return ary.length > 1 ? ary[1].length : 0;
}
/**
 * 乘法运算，解决了js运算的精度问题
 * @param  {Number} a 被乘数
 * @param  {Number} b 乘数
 * @return {Number}   积
 */
function multiply(a, b) {
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);
  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);

  return intA * intB / Math.pow(10, count);
}
/**
 * 加法运算，解决了js运算的精度问题
 * @param  {Number} a 被加数
 * @param  {Number} b 加数
 * @return {Number}   和
 */
function sum(a, b) {
  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));

  count = Math.pow(10, count);

  return (multiply(a, count) + multiply(b, count)) / count;
}
/**
 * 减法运算，解决了js运算的精度问题
 * @param  {Number} a 被减数
 * @param  {Number} b 减数
 * @return {Number}   差
 */
function minus(a, b) {
  return sum(a, -b);
}
/**
 * 除法运算，解决了js运算的精度问题
 * @param  {Number} a 被除数
 * @param  {Number} b 除数
 * @return {Number}   结果
 */
function divide(a, b) {
  var ca = getDecimalDigitCount(a);
  var cb = getDecimalDigitCount(b);
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);

  return intA / intB * Math.pow(10, cb - ca);
}

function modulo(a, b) {
  var mod = Math.abs(b);

  if (b <= 0) {
    return a;
  }

  var cnt = Math.floor(a / mod);

  return minus(a, multiply(mod, cnt));
}

/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Number} start 起点
 * @param  {Number} end   终点，不包含该值
 * @param  {Number} step  步长
 * @return {Array}        若干数值
 */
function rangeStep(start, end, step) {
  var num = start;
  var result = [];

  while (num < end) {
    result.push(num);

    num = sum(num, step);
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */
var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
  var newA = +a;
  var newB = +b;

  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */
var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */
var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return Math.max(0, Math.min(1, (x - a) / diff));
});

exports.default = {
  rangeStep: rangeStep,
  isFloat: isFloat,
  getDigitCount: getDigitCount,
  getDecimalDigitCount: getDecimalDigitCount,

  sum: sum,
  minus: minus,
  multiply: multiply,
  divide: divide,
  modulo: modulo,

  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cartesian_Line__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesian_Bar__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartesian_Area__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AreaChart__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineChart__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BarChart__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ComposedDataDecorator__ = __webpack_require__(227);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Composed Chart
 */


















var GRAPHICAL_TYPES = ['Area', 'Bar', 'Line'];
var GRAPHICAL_MAP = { Area: __WEBPACK_IMPORTED_MODULE_13__AreaChart__["b" /* AreaChart */], Bar: __WEBPACK_IMPORTED_MODULE_15__BarChart__["b" /* BarChart */], Line: __WEBPACK_IMPORTED_MODULE_14__LineChart__["b" /* LineChart */] };

var ComposedChart = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ComposedDataDecorator__["a" /* default */])({}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_PureRender__["a" /* default */])(_class = _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ComposedChart, _Component);

  function ComposedChart() {
    _classCallCheck(this, ComposedChart);

    return _possibleConstructorReturn(this, (ComposedChart.__proto__ || Object.getPrototypeOf(ComposedChart)).apply(this, arguments));
  }

  _createClass(ComposedChart, [{
    key: 'filterGraphicalItems',
    value: function filterGraphicalItems() {
      var graphicalItems = this.props.graphicalItems;

      var record = {};
      var result = [];

      for (var i = 0, len = graphicalItems.length; i < len; i++) {
        var item = graphicalItems[i];
        var displayName = item.type.displayName;

        if (GRAPHICAL_TYPES.indexOf(displayName) >= 0) {
          if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(record[displayName])) {
            var index = record[displayName];

            result[index].items = [].concat(_toConsumableArray(result[index].items), [item]);
          } else {
            record[displayName] = result.length;
            result.push({ items: [item], type: displayName });
          }
        }
      }

      return result;
    }
  }, {
    key: 'renderCursor',
    value: function renderCursor(_ref) {
      var xAxisMap = _ref.xAxisMap,
          yAxisMap = _ref.yAxisMap,
          offset = _ref.offset;
      var _props = this.props,
          children = _props.children,
          isTooltipActive = _props.isTooltipActive,
          layout = _props.layout,
          activeTooltipIndex = _props.activeTooltipIndex,
          axisTicks = _props.axisTicks;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__["a" /* default */]);
      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
        return null;
      }

      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
      var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["a" /* getAnyElementOfObject */])(axisMap);
      var ticks = axisTicks;

      if (!ticks || !ticks[activeTooltipIndex]) {
        return null;
      }

      var bandSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["b" /* getBandSizeOfAxis */])(axis);
      var start = ticks[activeTooltipIndex].coordinate;
      var cursorProps = _extends({
        fill: '#f1f1f1'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(tooltipItem.props.cursor), {
        x: layout === 'horizontal' ? start : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : start,
        width: layout === 'horizontal' ? bandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : bandSize
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(tooltipItem.props.cursor) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(tooltipItem.props.cursor, cursorProps) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], cursorProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          xAxisMap = _props2.xAxisMap,
          yAxisMap = _props2.yAxisMap,
          offset = _props2.offset;

      var filteredItems = this.filterGraphicalItems();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */],
        { className: 'recharts-composed' },
        this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
        filteredItems.map(function (_ref2) {
          var items = _ref2.items,
              type = _ref2.type;

          var Chart = GRAPHICAL_MAP[type];

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Chart, _extends({ key: type }, _this2.props, { graphicalItems: items, isComposed: true }));
        })
      );
    }
  }]);

  return ComposedChart;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ComposedChart', _class2.propTypes = {
  allComposedData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  axisTicks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  dataStartIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  dataEndIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  isTooltipActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  activeTooltipIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  xAxisMap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxisMap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  graphicalItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  stackGroups: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node])
}, _temp)) || _class) || _class);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__generateCategoricalChart__["a" /* default */])(ComposedChart, [__WEBPACK_IMPORTED_MODULE_5__cartesian_Line__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__cartesian_Area__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cartesian_Bar__["a" /* default */]]));

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Legend__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polar_Pie__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Cell__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ComposedDataDecorator__ = __webpack_require__(227);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Pie Chart
 */













var getComposedData = function getComposedData(_ref) {
  var item = _ref.item;
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;

  var presentationProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["b" /* getPresentationAttributes */])(item.props);
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _extends({
        payload: entry
      }, presentationProps, entry, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _extends({}, presentationProps, cell.props);
    });
  }

  return [];
};

var PieChart = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ComposedDataDecorator__["a" /* default */])({ getComposedData: getComposedData, ChildComponent: __WEBPACK_IMPORTED_MODULE_6__polar_Pie__["a" /* default */] }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(PieChart, _Component);

  function PieChart() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, PieChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      activeTooltipLabel: '',
      activeTooltipCoord: { x: 0, y: 0 },
      activeTooltipPayload: [],
      isTooltipActive: false
    }, _this.handleMouseEnter = function (el) {
      var children = _this.props.children;
      var cx = el.cx,
          cy = el.cy,
          outerRadius = el.outerRadius,
          midAngle = el.midAngle;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: true,
          activeTooltipCoord: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, midAngle),
          activeTooltipPayload: [el]
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PieChart, [{
    key: 'renderLegend',

    /**
     * Draw legend
     * @param  {Array} items             The instances of Pie
     * @return {ReactElement}            The instance of Legend
     */
    value: function renderLegend(items) {
      var _props = this.props,
          children = _props.children,
          allComposedData = _props.allComposedData;

      var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_4__component_Legend__["a" /* default */]);
      if (!legendItem) {
        return null;
      }

      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          margin = _props2.margin;

      var legendData = legendItem.props && legendItem.props.payload || items.reduce(function (result, child, i) {
        var nameKey = child.props.nameKey;

        var data = allComposedData[i];

        return result.concat(data.map(function (entry) {
          return {
            type: legendItem.props.iconType || child.props.legendType,
            value: entry[nameKey],
            color: entry.fill,
            payload: entry
          };
        }));
      }, []);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(legendItem, _extends({}, __WEBPACK_IMPORTED_MODULE_4__component_Legend__["a" /* default */].getWithHeight(legendItem, width), {
        payload: legendData,
        chartWidth: width,
        chartHeight: height,
        margin: margin
      }));
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var children = this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_5__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height;
      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeTooltipLabel = _state.activeTooltipLabel,
          activeTooltipCoord = _state.activeTooltipCoord,
          activeTooltipPayload = _state.activeTooltipPayload;

      var viewBox = { x: 0, y: 0, width: width, height: height };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        label: activeTooltipLabel,
        payload: activeTooltipPayload,
        coordinate: activeTooltipCoord
      });
    }

    /**
     * Draw the main part of bar chart
     * @param  {Array} items    All the instance of Pie
     * @return {ReactComponent} All the instance of Pie
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items) {
      var _this2 = this;

      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height,
          margin = _props4.margin,
          allComposedData = _props4.allComposedData,
          onMouseEnter = _props4.onMouseEnter,
          onMouseLeave = _props4.onMouseLeave,
          onClick = _props4.onClick;


      return items.map(function (child, i) {
        var _child$props = child.props,
            innerRadius = _child$props.innerRadius,
            outerRadius = _child$props.outerRadius,
            childOnMouseEnter = _child$props.onMouseEnter,
            childOnMouseLeave = _child$props.onMouseLeave,
            childOnClick = _child$props.onClick;

        var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["l" /* getPercentValue */])(child.props.cx, width, width / 2);
        var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["l" /* getPercentValue */])(child.props.cy, height, height / 2);
        var maxRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["b" /* getMaxRadius */])(width, height, margin);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          key: child.key || 'recharts-pie-' + i,
          cx: cx,
          cy: cy,
          maxRadius: child.props.maxRadius || Math.sqrt(width * width + height * height) / 2,
          innerRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["l" /* getPercentValue */])(innerRadius, maxRadius, 0),
          outerRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["l" /* getPercentValue */])(outerRadius, maxRadius, maxRadius * 0.8),
          composedData: allComposedData[i],
          onMouseEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* combineEventHandlers */])(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
          onMouseLeave: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* combineEventHandlers */])(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
          onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* combineEventHandlers */])(null, onClick, childOnClick)
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props5 = this.props,
          style = _props5.style,
          children = _props5.children,
          className = _props5.className,
          width = _props5.width,
          height = _props5.height,
          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_6__polar_Pie__["a" /* default */]);
      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderItems(items),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderLegend(items),
        this.renderTooltip()
      );
    }
  }]);

  return PieChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'PieChart', _class2.propTypes = {
  allComposedData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  style: {},
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
}, _temp2)) || _class);

/* harmony default export */ __webpack_exports__["a"] = (PieChart);

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recharts_scale__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recharts_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recharts_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Legend__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__polar_Radar__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__polar_PolarGrid__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__polar_PolarAngleAxis__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__polar_PolarRadiusAxis__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_DOMUtils__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_AnimationDecorator__ = __webpack_require__(189);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Radar Chart
 */






















var RadarChart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_AnimationDecorator__["a" /* default */])(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(RadarChart, _Component);

  function RadarChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (itemProps, e) {
      var children = _this.props.children;
      var points = itemProps.points;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_8__component_Tooltip__["a" /* default */]);

      if (tooltipItem && points.length) {
        var container = _this.container;
        var containerOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DOMUtils__["a" /* getOffset */])(container);
        var ne = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_DOMUtils__["b" /* calculateChartCoordinate */])(e, containerOffset);

        _this.setState({
          isTooltipActive: true,
          activeTooltipLabel: itemProps.name || itemProps.dataKey,
          activeTooltipCoord: { x: ne.chartX, y: ne.chartY },
          activeTooltipPayload: _this.getTooltipContent(itemProps)
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_8__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadarChart, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState(this.createDefaultState());
      }
    }
  }, {
    key: 'getTooltipContent',
    value: function getTooltipContent(itemProps) {
      var points = itemProps.points,
          dataKey = itemProps.dataKey,
          unit = itemProps.unit;


      return points.map(function (entry) {
        var name = entry.name,
            value = entry.value,
            payload = entry.payload;


        return _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(itemProps), {
          dataKey: dataKey, unit: unit, name: name, value: value, payload: payload
        });
      });
    }
  }, {
    key: 'getRadiusAxisCfg',
    value: function getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius) {
      var props = radiusAxis ? radiusAxis.props : __WEBPACK_IMPORTED_MODULE_12__polar_PolarRadiusAxis__["a" /* default */].defaultProps;
      var domain = void 0,
          tickCount = void 0,
          ticks = void 0;

      if (radiusAxis && radiusAxis.props.ticks) {
        ticks = radiusAxis.props.ticks;

        tickCount = ticks.length;
        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
      } else {
        tickCount = Math.max(radiusAxis && radiusAxis.props.tickCount || __WEBPACK_IMPORTED_MODULE_12__polar_PolarRadiusAxis__["a" /* default */].defaultProps.tickCount, 2);
        ticks = this.getTicksByItems(radiusAxis, tickCount);

        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
      }

      return {
        tickCount: tickCount,
        ticks: ticks,
        scale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* parseScale */])(props).domain(domain).range([innerRadius, outerRadius])
      };
    }
  }, {
    key: 'getTicksByItems',
    value: function getTicksByItems(axisItem, tickCount) {
      var _props = this.props,
          data = _props.data,
          children = _props.children;

      var _ref2 = axisItem ? axisItem.props : __WEBPACK_IMPORTED_MODULE_12__polar_PolarRadiusAxis__["a" /* default */].defaultProps,
          domain = _ref2.domain,
          allowDataOverflow = _ref2.allowDataOverflow;

      var radarItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_9__polar_Radar__["a" /* default */]);
      var dataKeys = radarItems.map(function (item) {
        return item.props.dataKey;
      });
      var extent = data.reduce(function (prev, current) {
        var values = dataKeys.map(function (v) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* getValueByDataKey */])(current, v, 0);
        });
        var currentMax = Math.max.apply(null, values);
        var currentMin = Math.min.apply(null, values);

        return [Math.min(prev[0], currentMin), Math.max(prev[1], currentMax)];
      }, [Infinity, -Infinity]);
      var finalDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["e" /* parseSpecifiedDomain */])(domain, extent, allowDataOverflow);

      if (domain && (domain[0] === 'auto' || domain[1] === 'auto')) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_recharts_scale__["getNiceTickValues"])(finalDomain, tickCount);
      }

      return finalDomain;
    }
  }, {
    key: 'getGridRadius',
    value: function getGridRadius(gridCount, innerRadius, outerRadius) {
      var domain = __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, gridCount);
      var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["scalePoint"])().domain(domain).range([innerRadius, outerRadius]);

      return domain.map(function (v) {
        return scale(v);
      });
    }
  }, {
    key: 'getAngle',
    value: function getAngle(index, dataLength, startAngle, clockWise) {
      var sign = clockWise ? -1 : 1;
      var angleInterval = 360 / dataLength;

      return startAngle + index * sign * angleInterval;
    }
  }, {
    key: 'getAngleTicks',
    value: function getAngleTicks(dataLength, startAngle, clockWise) {
      var angles = [];

      for (var i = 0; i < dataLength; i++) {
        angles.push(this.getAngle(i, dataLength, startAngle, clockWise));
      }

      return angles;
    }
  }, {
    key: 'getRadiusTicks',
    value: function getRadiusTicks(axisCfg) {
      var ticks = axisCfg.ticks,
          scale = axisCfg.scale;


      if (ticks && ticks.length) {
        return ticks.map(function (entry) {
          return {
            radius: scale(entry),
            value: entry
          };
        });
      }
      var tickCount = axisCfg.tickCount;

      var domain = scale.domain();

      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, tickCount).map(function (v, i) {
        var value = domain[0] + i * (domain[1] - domain[0]) / (tickCount - 1);
        return {
          value: value,
          radius: scale(value)
        };
      });
    }
  }, {
    key: 'getComposedData',
    value: function getComposedData(item, scale, cx, cy) {
      var _this2 = this;

      var dataKey = item.props.dataKey;
      var _props2 = this.props,
          data = _props2.data,
          startAngle = _props2.startAngle,
          clockWise = _props2.clockWise,
          children = _props2.children;

      var angleAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__polar_PolarAngleAxis__["a" /* default */]);
      var nameKey = angleAxis && angleAxis.props.dataKey;
      var len = data.length;

      return data.map(function (entry, i) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey, 0);
        var angle = _this2.getAngle(i, len, startAngle, clockWise);
        var radius = scale(value);

        return _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, angle), {
          value: value,
          name: nameKey ? entry[nameKey] || i : i,
          cx: cx, cy: cy, radius: radius, angle: angle,
          payload: entry
        });
      });
    }
    /**
     * Returns default, reset state for the radar chart.
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState() {
      return {
        activeTooltipLabel: '',
        activeTooltipCoord: { x: 0, y: 0 },
        isTooltipActive: false
      };
    }
  }, {
    key: 'renderRadars',
    value: function renderRadars(items, scale, cx, cy) {
      var _this3 = this;

      if (!items || !items.length) {
        return null;
      }

      var _props3 = this.props,
          onMouseEnter = _props3.onMouseEnter,
          onMouseLeave = _props3.onMouseLeave,
          onClick = _props3.onClick;

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props);

      return items.map(function (el, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(el, _extends({}, baseProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(el), {
          animationId: _this3.props.animationId,
          points: _this3.getComposedData(el, scale, cx, cy),
          key: el.key || 'radar-' + index,
          onMouseEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["i" /* combineEventHandlers */])(_this3.handleMouseEnter, onMouseEnter, el.props.onMouseEnter),
          onMouseLeave: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["i" /* combineEventHandlers */])(_this3.handleMouseLeave, onMouseLeave, el.props.onMouseLeave),
          onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["i" /* combineEventHandlers */])(null, onClick, el.props.onClick)
        }));
      });
    }
  }, {
    key: 'renderGrid',
    value: function renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius) {
      var children = this.props.children;

      var grid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__polar_PolarGrid__["a" /* default */]);

      if (!grid) {
        return null;
      }

      var _props4 = this.props,
          startAngle = _props4.startAngle,
          clockWise = _props4.clockWise,
          data = _props4.data;

      var len = data.length;
      var gridCount = radiusAxisCfg.tickCount;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(grid, {
        polarAngles: this.getAngleTicks(len, startAngle, clockWise),
        polarRadius: this.getGridRadius(gridCount, innerRadius, outerRadius),
        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
        key: 'layer-grid'
      });
    }
  }, {
    key: 'renderAngleAxis',
    value: function renderAngleAxis(cx, cy, outerRadius, maxRadius) {
      var _this4 = this;

      var children = this.props.children;

      var angleAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__polar_PolarAngleAxis__["a" /* default */]);

      if (!angleAxis || angleAxis.props.hide) {
        return null;
      }

      var _props5 = this.props,
          data = _props5.data,
          startAngle = _props5.startAngle,
          clockWise = _props5.clockWise;

      var len = data.length;
      var grid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__polar_PolarGrid__["a" /* default */]);
      var radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["l" /* getPercentValue */])(angleAxis.props.radius, maxRadius, outerRadius);
      var dataKey = angleAxis.props.dataKey;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(angleAxis, {
        ticks: data.map(function (v, i) {
          return {
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["h" /* getValueByDataKey */])(v, dataKey, i),
            angle: _this4.getAngle(i, len, startAngle, clockWise)
          };
        }),
        cx: cx, cy: cy, radius: radius,
        axisLineType: grid && grid.props && grid.props.gridType || __WEBPACK_IMPORTED_MODULE_10__polar_PolarGrid__["a" /* default */].defaultProps.gridType,
        key: 'layer-angle-axis'
      });
    }
  }, {
    key: 'renderRadiusAxis',
    value: function renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy) {
      if (!radiusAxis || radiusAxis.props.hide) {
        return null;
      }

      var startAngle = this.props.startAngle;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(radiusAxis, {
        angle: radiusAxis.props.angle || startAngle,
        ticks: this.getRadiusTicks(radiusAxisCfg),
        cx: cx, cy: cy
      });
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var children = this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_8__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _props6 = this.props,
          width = _props6.width,
          height = _props6.height;
      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeTooltipLabel = _state.activeTooltipLabel,
          activeTooltipCoord = _state.activeTooltipCoord,
          activeTooltipPayload = _state.activeTooltipPayload;

      var viewBox = { x: 0, y: 0, width: width, height: height };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        label: activeTooltipLabel,
        payload: activeTooltipPayload,
        coordinate: activeTooltipCoord
      });
    }

    /**
     * Draw legend
     * @param  {Array} items             The instances of item
     * @return {ReactElement}            The instance of Legend
     */

  }, {
    key: 'renderLegend',
    value: function renderLegend(items) {
      var children = this.props.children;

      var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Legend__["a" /* default */]);
      if (!legendItem) {
        return null;
      }

      var _props7 = this.props,
          width = _props7.width,
          height = _props7.height,
          margin = _props7.margin;

      var legendData = legendItem.props && legendItem.props.payload || items.map(function (child) {
        var _child$props = child.props,
            dataKey = _child$props.dataKey,
            name = _child$props.name,
            legendType = _child$props.legendType;


        return {
          dataKey: dataKey,
          type: legendItem.props.iconType || legendType || 'square',
          color: child.props.stroke || child.props.fill,
          value: name || dataKey,
          payload: child.props
        };
      }, this);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(legendItem, _extends({}, __WEBPACK_IMPORTED_MODULE_7__component_Legend__["a" /* default */].getWithHeight(legendItem, width), {
        payload: legendData,
        chartWidth: width,
        chartHeight: height,
        margin: margin
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["e" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props8 = this.props,
          className = _props8.className,
          data = _props8.data,
          width = _props8.width,
          height = _props8.height,
          margin = _props8.margin,
          children = _props8.children,
          style = _props8.style,
          others = _objectWithoutProperties(_props8, ['className', 'data', 'width', 'height', 'margin', 'children', 'style']);

      var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["l" /* getPercentValue */])(this.props.cx, width, width / 2);
      var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["l" /* getPercentValue */])(this.props.cy, height, height / 2);
      var maxRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_PolarUtils__["b" /* getMaxRadius */])(width, height, margin);
      var innerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["l" /* getPercentValue */])(this.props.innerRadius, maxRadius, 0);
      var outerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["l" /* getPercentValue */])(this.props.outerRadius, maxRadius, maxRadius * 0.8);

      if (outerRadius <= 0 || !data || !data.length) {
        return null;
      }

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_9__polar_Radar__["a" /* default */]);
      var radiusAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__polar_PolarRadiusAxis__["a" /* default */]);
      var radiusAxisCfg = this.getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius);
      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height }),
          ref: function ref(node) {
            _this5.container = node;
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius),
          this.renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy),
          this.renderAngleAxis(cx, cy, outerRadius, maxRadius),
          this.renderRadars(items, radiusAxisCfg.scale, cx, cy),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderLegend(items),
        this.renderTooltip()
      );
    }
  }]);

  return RadarChart;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'RadarChart', _class2.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  margin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),

  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  startAngle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  clockWise: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class2.defaultProps = {
  width: 0,
  height: 0,
  cx: '50%',
  cy: '50%',
  innerRadius: 0,
  outerRadius: '80%',

  startAngle: 90,
  clockWise: true,
  data: [],
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
}, _temp2)) || _class) || _class;

/* harmony default export */ __webpack_exports__["a"] = (RadarChart);

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polar_RadialBar__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Cell__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Legend__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_PureRender__ = __webpack_require__(28);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Radar Bar Chart
 */















var RadialBarChart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(RadialBarChart, _Component);

  function RadialBarChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadialBarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBarChart.__proto__ || Object.getPrototypeOf(RadialBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (el) {
      var children = _this.props.children;
      var cx = el.cx,
          cy = el.cy,
          endAngle = el.endAngle,
          outerRadius = el.outerRadius;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: true,
          activeTooltipCoord: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, endAngle),
          activeTooltipPayload: [el.payload]
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadialBarChart, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState(this.createDefaultState());
      }
    }
    /**
     * Compose the data of each group
     * @param  {Object} item        An instance of RadialBar
     * @param  {Array}  barPosition The offset and size of each bar
     * @param  {Object} radiusScale The scale function of radius of bars
     * @param  {Object} center      The coordinate of center
     * @param  {String} dataKey     The unique key of a group
     * @return {Array}              Composed data
     */

  }, {
    key: 'getComposedData',
    value: function getComposedData(item, barPosition, radiusScale, center, dataKey) {
      var data = this.props.data;

      var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["m" /* findPositionOfBar */])(barPosition, item);
      var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["d" /* findAllByType */])(item.props.children, __WEBPACK_IMPORTED_MODULE_8__component_Cell__["a" /* default */]);

      return data.map(function (entry, index) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey);
        var radius = radiusScale(index);

        return _extends({}, entry, center, {
          value: value,
          innerRadius: radius - pos.offset,
          outerRadius: radius - pos.offset + pos.radius,
          payload: entry
        }, cells && cells[index] && cells[index].props);
      });
    }
    /**
     * Calculate the size of all groups
     * @param  {Array} items All the instance of RadialBar
     * @return {Object} The size of all groups
     */

  }, {
    key: 'getRadiusList',
    value: function getRadiusList(items) {
      var barSize = this.props.barSize;


      return items.map(function (child) {
        return _extends({}, child.props, {
          item: child,
          barSize: child.props.barSize || barSize
        });
      });
    }

    /**
     * Calculate the scale function of radius
     * @param {Number} innerRadius The outer radius
     * @param {Number} outerRadius The inner radius
     * @return {Object}            A scale function
     */

  }, {
    key: 'getRadiusScale',
    value: function getRadiusScale(innerRadius, outerRadius) {
      var data = this.props.data;

      var bandCount = Math.max(data.length, 1);
      var range = [outerRadius, innerRadius];
      var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["scaleBand"])().domain(__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, bandCount)).range(range);

      return scale;
    }

    /**
     * Calculate the size of each bar and the gap between two bars
     * @param  {Number} bandRadius  The radius of each category
     * @param  {Array} radiusList   The radius of all groups
     * @return {Number} The size of each bar and the gap between two bars
     */

  }, {
    key: 'getBarPosition',
    value: function getBarPosition(bandRadius, radiusList) {
      var _props = this.props,
          barGap = _props.barGap,
          barCategoryGap = _props.barCategoryGap;

      var len = radiusList.length;
      var result = void 0;

      // whether or not is barSize setted by user
      if (len && radiusList[0].barSize === +radiusList[0].barSize) {
        (function () {
          var sum = radiusList.reduce(function (res, entry) {
            return res + entry.barSize;
          }, 0);
          sum += (len - 1) * barGap;
          var offset = -sum / 2 >> 0;
          var prev = { offset: offset - barGap, radius: 0 };

          result = radiusList.reduce(function (res, entry) {
            prev = {
              offset: prev.offset + prev.radius + barGap,
              radius: entry.barSize
            };

            return [].concat(_toConsumableArray(res), [{ item: entry.item, position: prev }]);
          }, []);
        })();
      } else {
        (function () {
          var offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["l" /* getPercentValue */])(barCategoryGap, bandRadius);
          var radius = (bandRadius - 2 * offset - (len - 1) * barGap) / len >> 0;
          offset = -Math.max((radius * len + (len - 1) * barGap) / 2 >> 0, 0);

          result = radiusList.reduce(function (res, entry, i) {
            return [].concat(_toConsumableArray(res), [{
              item: entry.item,
              position: {
                offset: offset + (radius + barGap) * i,
                radius: radius
              }
            }]);
          }, []);
        })();
      }

      return result;
    }
    /**
     * Returns default, reset state for the radial bar chart.
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState() {
      return {
        activeTooltipLabel: '',
        activeTooltipPayload: [],
        activeTooltipCoord: { x: 0, y: 0 },
        isTooltipActive: false
      };
    }
  }, {
    key: 'renderLegend',


    /**
     * Draw legend
     * @param  {ReactElement} legendItem The instance of Legend
     * @return {ReactElement}            The instance of Legend
     */
    value: function renderLegend() {
      var children = this.props.children;

      var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Legend__["a" /* default */]);
      if (!legendItem) {
        return null;
      }

      var _props2 = this.props,
          data = _props2.data,
          width = _props2.width,
          height = _props2.height,
          margin = _props2.margin;


      var legendData = legendItem.props && legendItem.props.payload || data.map(function (entry) {
        return {
          type: legendItem.props.iconType || 'square',
          color: entry.fill || '#000',
          value: entry.name,
          payload: entry
        };
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(legendItem, _extends({}, __WEBPACK_IMPORTED_MODULE_9__component_Legend__["a" /* default */].getWithHeight(legendItem, width), {
        payload: legendData,
        chartWidth: width,
        chartHeight: height,
        margin: margin
      }));
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var children = this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height;
      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeTooltipLabel = _state.activeTooltipLabel,
          activeTooltipCoord = _state.activeTooltipCoord,
          activeTooltipPayload = _state.activeTooltipPayload;

      var viewBox = { x: 0, y: 0, width: width, height: height };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        label: activeTooltipLabel,
        payload: activeTooltipPayload,
        coordinate: activeTooltipCoord
      });
    }

    /**
     * Draw the main part of bar chart
     * @param  {Array} items     All the instance of RadialBar
     * @param  {Object} radiusScale The scale function of radius of bars
     * @param  {Object} center      The coordinate of center
     * @return {ReactComponent}  All the instances of RadialBar
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items, radiusScale, center) {
      var _this2 = this;

      if (!items || !items.length) {
        return null;
      }

      var _props4 = this.props,
          onMouseEnter = _props4.onMouseEnter,
          onMouseLeave = _props4.onMouseLeave,
          onClick = _props4.onClick;

      var radiusList = this.getRadiusList(items);
      var bandRadius = radiusScale.bandwidth();
      var barPosition = this.getBarPosition(bandRadius, radiusList);

      return items.map(function (child, i) {
        var _child$props = child.props,
            dataKey = _child$props.dataKey,
            childOnMouseEnter = _child$props.onMouseEnter,
            childOnMouseLeave = _child$props.onMouseLeave,
            childOnClick = _child$props.onClick;


        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(child, _extends({}, center, {
          key: child.key || 'radial-bar-' + i,
          onMouseEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["i" /* combineEventHandlers */])(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
          onMouseLeave: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["i" /* combineEventHandlers */])(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
          onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["i" /* combineEventHandlers */])(null, onClick, childOnClick),
          data: _this2.getComposedData(child, barPosition, radiusScale, center, dataKey)
        }));
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["e" /* validateWidthHeight */])(this) || !data || !data.length) {
        return null;
      }

      var _props5 = this.props,
          style = _props5.style,
          children = _props5.children,
          className = _props5.className,
          width = _props5.width,
          height = _props5.height,
          margin = _props5.margin,
          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height', 'margin']);

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_6__polar_RadialBar__["a" /* default */]);
      var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["l" /* getPercentValue */])(this.props.cx, width, width / 2);
      var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["l" /* getPercentValue */])(this.props.cy, height, height / 2);
      var maxRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_PolarUtils__["b" /* getMaxRadius */])(width, height, margin);
      var innerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["l" /* getPercentValue */])(this.props.innerRadius, maxRadius, 0);
      var outerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["l" /* getPercentValue */])(this.props.outerRadius, maxRadius, maxRadius * 0.8);
      var radiusScale = this.getRadiusScale(innerRadius, outerRadius);
      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { cursor: 'default', position: 'relative', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderItems(items, radiusScale, { cx: cx, cy: cy }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderLegend(),
        this.renderTooltip(items)
      );
    }
  }]);

  return RadialBarChart;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'RadialBarChart', _class2.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  margin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  innerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  // The offset radius between two categorys
  barCategoryGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  // The gap radius of two radial bar in one category
  barGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  // The radius of each radial bar
  barSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
}, _class2.defaultProps = {
  cx: '50%',
  cy: '50%',
  innerRadius: '30%',
  outerRadius: '90%',
  barGap: 2,
  barCategoryGap: '10%',
  style: {},
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (RadialBarChart);

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_DataUtils__ = __webpack_require__(32);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TreemapChart
 */












var defaultCoordinateOfTooltip = { x: 0, y: 0 };

var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};
var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];

    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];

    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};
var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};

var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];

  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];

    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }

    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }

  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
};

var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;

  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];

    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);

      updateDepthOfTargets(tree, target);
    }
  }
};

var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
      links = _ref.links;

  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);

    return _extends({}, entry, result, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }
  var maxDepth = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(tree, function (entry) {
    return entry.depth;
  }).depth;

  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;
    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];

      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }
      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }

  return { tree: tree, maxDepth: maxDepth };
};

var getDepthTree = function getDepthTree(tree) {
  var result = [];

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!result[node.depth]) {
      result[node.depth] = [];
    }

    result[node.depth].push(node);
  }

  return result;
};

var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = __WEBPACK_IMPORTED_MODULE_2_lodash_min___default()(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(nodes, getValue);
  }));

  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];

      node.y = i;
      node.dy = node.value * yRatio;
    }
  }

  return links.map(function (link) {
    return _extends({}, link, { dy: getValue(link) * yRatio });
  });
};

var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length;

    // Sort by the value of y
    nodes.sort(ascendingY);

    var y0 = 0;
    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;

      if (dy > 0) {
        node.y += dy;
      }

      y0 = node.y + node.dy + nodePadding;
    }

    y0 = height + nodePadding;
    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];
      var _dy = _node2.y + _node2.dy + nodePadding - y0;

      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};

var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;

    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });

    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];

      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }

    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];

      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};

var computeData = function computeData(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      iterations = _ref2.iterations,
      nodeWidth = _ref2.nodeWidth,
      nodePadding = _ref2.nodePadding;
  var links = data.links;

  var _getNodesTree = getNodesTree(data, width, nodeWidth),
      tree = _getNodesTree.tree;

  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);

  resolveCollisions(depthTree, height, nodePadding);

  var alpha = 1;
  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);

    resolveCollisions(depthTree, height, nodePadding);

    relaxLeftToRight(tree, depthTree, newLinks, alpha);

    resolveCollisions(depthTree, height, nodePadding);
  }

  updateYOfLinks(tree, newLinks);

  return { nodes: tree, links: newLinks };
};

var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
  }

  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};

var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;

  if (type === 'node') {
    return [{
      payload: el,
      name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["h" /* getValueByDataKey */])(payload, nameKey, ''),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["h" /* getValueByDataKey */])(payload, 'value')
    }];
  }
  if (payload.source && payload.target) {
    var sourceName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["h" /* getValueByDataKey */])(payload.source, nameKey, '');
    var targetName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["h" /* getValueByDataKey */])(payload.target, nameKey, '');

    return [{
      payload: el,
      name: sourceName + ' - ' + targetName,
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["h" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  return [];
};

var Sankey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Sankey, _Component);

  function Sankey(props) {
    _classCallCheck(this, Sankey);

    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));

    _this.state = _this.createDefaultState(props);
    return _this;
  }

  _createClass(Sankey, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          data = _props.data,
          width = _props.width,
          height = _props.height,
          margin = _props.margin,
          iterations = _props.iterations,
          nodeWidth = _props.nodeWidth,
          nodePadding = _props.nodePadding,
          nameKey = _props.nameKey;

      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["b" /* shallowEqual */])(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
        this.setState(this.createDefaultState(this.props));
      }
    }
    /**
     * Returns default, reset state for the sankey chart.
     * @param  {Object} props The latest props
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState(props) {
      var data = props.data,
          width = props.width,
          height = props.height,
          margin = props.margin,
          iterations = props.iterations,
          nodeWidth = props.nodeWidth,
          nodePadding = props.nodePadding;

      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);

      var _computeData = computeData({
        data: data,
        width: contentWidth,
        height: contentHeight,
        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
      }),
          links = _computeData.links,
          nodes = _computeData.nodes;

      return {
        activeElement: null,
        activeElementType: null,
        isTooltipActive: false,
        nodes: nodes, links: links
      };
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(el, type, e) {
      var _props2 = this.props,
          onMouseEnter = _props2.onMouseEnter,
          children = _props2.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          activeElement: el,
          activeElementType: type,
          isTooltipActive: true
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(el, type, e);
      }
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(el, type, e) {
      var _props3 = this.props,
          onMouseLeave = _props3.onMouseLeave,
          children = _props3.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(el, type, e);
      }
    }
  }, {
    key: 'renderLinkItem',
    value: function renderLinkItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      var sourceX = props.sourceX,
          sourceY = props.sourceY,
          sourceControlX = props.sourceControlX,
          targetX = props.targetX,
          targetY = props.targetY,
          targetControlX = props.targetControlX,
          linkWidth = props.linkWidth,
          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path', _extends({
        className: 'recharts-sankey-link',
        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
        fill: 'none',
        stroke: '#333',
        strokeWidth: linkWidth,
        strokeOpacity: '0.2'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(others)));
    }
  }, {
    key: 'renderLinks',
    value: function renderLinks(links, nodes) {
      var _this2 = this;

      var _props4 = this.props,
          linkCurvature = _props4.linkCurvature,
          linkContent = _props4.link,
          margin = _props4.margin;

      var top = margin.top || 0;
      var left = margin.left || 0;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
        links.map(function (link, i) {
          var sourceRelativeY = link.sy,
              targetRelativeY = link.ty,
              linkWidth = link.dy;

          var source = nodes[link.source];
          var target = nodes[link.target];
          var sourceX = source.x + source.dx + left;
          var targetX = target.x + left;
          var interpolationFunc = interpolationGenerator(sourceX, targetX);
          var sourceControlX = interpolationFunc(linkCurvature);
          var targetControlX = interpolationFunc(1 - linkCurvature);
          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;

          var linkProps = _extends({
            sourceX: sourceX, targetX: targetX,
            sourceY: sourceY, targetY: targetY,
            sourceControlX: sourceControlX, targetControlX: targetControlX,
            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
            linkWidth: linkWidth,
            index: i,
            payload: _extends({}, link, { source: source, target: target })
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(linkContent));
          var events = {
            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
          };

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({ key: 'link' + i }, events),
            _this2.renderLinkItem(linkContent, linkProps)
          );
        })
      );
    }
  }, {
    key: 'renderNodeItem',
    value: function renderNodeItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        className: 'recharts-sankey-node',
        fill: '#0088fe',
        fillOpacity: '0.8'
      }, props));
    }
  }, {
    key: 'renderNodes',
    value: function renderNodes(nodes) {
      var _this3 = this;

      var _props5 = this.props,
          nodeContent = _props5.node,
          margin = _props5.margin;

      var top = margin.top || 0;
      var left = margin.left || 0;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
        nodes.map(function (node, i) {
          var x = node.x,
              y = node.y,
              dx = node.dx,
              dy = node.dy;

          var nodeProps = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(nodeContent), {
            x: x + left,
            y: y + top,
            width: dx,
            height: dy,
            index: i,
            payload: node
          });
          var events = {
            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
          };

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({ key: 'node' + i }, events),
            _this3.renderNodeItem(nodeContent, nodeProps)
          );
        })
      );
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props6 = this.props,
          children = _props6.children,
          width = _props6.width,
          height = _props6.height,
          nameKey = _props6.nameKey;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeElement = _state.activeElement,
          activeElementType = _state.activeElementType;

      var viewBox = { x: 0, y: 0, width: width, height: height };
      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["e" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props7 = this.props,
          width = _props7.width,
          height = _props7.height,
          className = _props7.className,
          style = _props7.style,
          children = _props7.children,
          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);

      var _state2 = this.state,
          links = _state2.links,
          nodes = _state2.nodes;

      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["g" /* filterSvgElements */])(children),
          this.renderLinks(links, nodes),
          this.renderNodes(nodes)
        ),
        this.renderTooltip()
      );
    }
  }]);

  return Sankey;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {

  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    nodes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
    links: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      source: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    }))
  }),

  nodePadding: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  linkCurvature: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  iterations: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  node: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  link: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),

  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  margin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
}), _class2.defaultProps = {
  nodePadding: 10,
  nodeWidth: 10,
  nameKey: 'name',
  dataKey: 'value',
  linkCurvature: 0.5,
  iterations: 32,
  margin: { top: 5, right: 5, bottom: 5, left: 5 }
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Sankey);

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Cell__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Legend__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Cross__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cartesian_CartesianGrid__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cartesian_Scatter__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cartesian_XAxis__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cartesian_YAxis__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cartesian_ZAxis__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cartesian_ReferenceLine__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceDot__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceArea__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_LogUtils__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Scatter Chart
 */
























var ScatterChart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(ScatterChart, _Component);

  function ScatterChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScatterChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScatterChart.__proto__ || Object.getPrototypeOf(ScatterChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeTooltipCoord: { x: 0, y: 0 },
      isTooltipActive: false,
      activeItem: null
    }, _this.handleLegendBBoxUpdate = function (box) {
      if (box && _this.legendInstance) {
        _this.forceUpdate();
      }
    }, _this.handleScatterMouseEnter = function (el) {
      _this.setState({
        isTooltipActive: true,
        activeItem: el,
        activeTooltipCoord: { x: el.cx, y: el.cy }
      });
    }, _this.handleScatterMouseLeave = function () {
      _this.setState({
        isTooltipActive: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScatterChart, [{
    key: 'getComposedData',

    /**
     * Compose the data of each group
     * @param  {Object} item        An instance of Scatter
     * @param  {Array}  data        The original data
     * @param  {Object} xAxis       The configuration of x-axis
     * @param  {Object} yAxis       The configuration of y-axis
     * @param  {Object} zAxis       The configuration of z-axis
     * @return {Array} Composed data
     */
    value: function getComposedData(item, data, xAxis, yAxis, zAxis) {
      var children = item.props.children;

      var xAxisDataKey = xAxis.dataKey;
      var yAxisDataKey = yAxis.dataKey;
      var zAxisDataKey = zAxis.dataKey;
      var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_5__component_Cell__["a" /* default */]);

      return data.map(function (entry, index) {
        return _extends({}, entry, {
          cx: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["j" /* isNumber */])(entry[xAxisDataKey]) ? xAxis.scale(entry[xAxisDataKey]) : null,
          cy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["j" /* isNumber */])(entry[yAxisDataKey]) ? yAxis.scale(entry[yAxisDataKey]) : null,
          size: zAxisDataKey !== undefined && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["j" /* isNumber */])(entry[zAxisDataKey]) ? zAxis.scale(entry[zAxisDataKey]) : zAxis.range[0],
          node: {
            x: entry[xAxisDataKey],
            y: entry[yAxisDataKey],
            z: zAxisDataKey !== undefined && entry[zAxisDataKey] || '-'
          },
          payload: entry
        }, cells && cells[index] && cells[index].props);
      });
    }
  }, {
    key: 'getDomain',
    value: function getDomain(items, dataKey, axisId, axisType) {
      var domain = items.reduce(function (result, item) {
        return result.concat(item.props.data.map(function (entry) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["h" /* getValueByDataKey */])(entry, dataKey);
        }));
      }, []);

      if (axisType === 'xAxis' || axisType === 'yAxis') {
        domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["g" /* detectReferenceElementsDomain */])(this.props.children, domain, axisId, axisType);
      }

      return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
    }

    /**
     * Get the configuration of x-axis or y-axis
     * @param  {String} axisType The type of axis
     * @param  {Array} items     The instances of item
     * @return {Object}          Configuration
     */

  }, {
    key: 'getAxis',
    value: function getAxis() {
      var axisType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xAxis';
      var items = arguments[1];
      var children = this.props.children;

      var Axis = axisType === 'xAxis' ? __WEBPACK_IMPORTED_MODULE_12__cartesian_XAxis__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_13__cartesian_YAxis__["a" /* default */];
      var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, Axis);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__util_LogUtils__["a" /* warn */])(axis, 'recharts: ScatterChart must has %s', Axis.displayName);

      if (axis) {
        var domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["e" /* parseSpecifiedDomain */])(axis.props.domain, this.getDomain(items, axis.props.dataKey, axis.props[axisType + 'Id'], axisType), axis.props.allowDataOverflow);

        return _extends({}, axis.props, {
          axisType: axisType,
          domain: domain,
          type: 'number',
          originalDomain: axis.props.domain
        });
      }

      return null;
    }

    /**
     * Get the configuration of z-axis
     * @param  {Array} items The instances of item
     * @return {Object}      Configuration
     */

  }, {
    key: 'getZAxis',
    value: function getZAxis(items) {
      var children = this.props.children;

      var axisItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_14__cartesian_ZAxis__["a" /* default */]);
      var axisProps = axisItem && axisItem.props || __WEBPACK_IMPORTED_MODULE_14__cartesian_ZAxis__["a" /* default */].defaultProps;
      var domain = axisProps.dataKey ? this.getDomain(items, axisProps.dataKey) : [-1, 1];

      return _extends({}, axisProps, {
        domain: domain,
        scale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["f" /* parseScale */])(axisProps).domain(domain).range(axisProps.range)
      });
    }
  }, {
    key: 'getOffset',
    value: function getOffset(items, xAxis, yAxis) {
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          margin = _props.margin,
          children = _props.children;

      var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_6__component_Legend__["a" /* default */]);

      var offset = {
        left: margin.left || 0, right: margin.right || 0,
        top: margin.top || 0, bottom: margin.bottom || 0
      };

      if (!xAxis.hide && !xAxis.mirror) {
        offset[xAxis.orientation] += xAxis.height;
      }
      if (!yAxis.hide && !yAxis.mirror) {
        offset[yAxis.orientation] += yAxis.width;
      }

      if (legendItem && this.legendInstance) {
        var legendBox = this.legendInstance.getBBox();
        offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["l" /* appendOffsetOfLegend */])(offset, items, this.props, legendBox);
      }

      return _extends({}, offset, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
      });
    }
    /**
     * Calculate the scale function, position, width, height of axes
     * @param  {Object} axis     The configuration of axis
     * @param  {Object} offset   The offset of main part in the svg element
     * @param  {Object} axisType The type of axis, x-axis or y-axis
     * @return {Object} Configuration
     */

  }, {
    key: 'getFormatAxis',
    value: function getFormatAxis(axis, offset, axisType) {
      var orientation = axis.orientation,
          domain = axis.domain,
          mirror = axis.mirror,
          tickFormat = axis.tickFormat,
          _axis$padding = axis.padding,
          padding = _axis$padding === undefined ? {} : _axis$padding;

      var position = {
        left: offset.left,
        right: offset.left + offset.width,
        top: offset.top,
        bottom: offset.top + offset.height
      };
      var range = axisType === 'xAxis' ? [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)] : [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)];

      var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_DataUtils__["f" /* parseScale */])(axis).domain(domain).range(range);
      var ticks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["h" /* getTicksOfScale */])(scale, axis);
      if (tickFormat) {
        scale.tickFormat(tickFormat);
      }

      var x = void 0,
          y = void 0;

      if (axisType === 'xAxis') {
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        x = offset.left;
        y = position[orientation] - needSpace * axis.height;
      } else {
        var _needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        x = position[orientation] - _needSpace * axis.width;
        y = offset.top;
      }

      return _extends({}, axis, ticks, {
        scale: scale,
        width: axisType === 'xAxis' ? offset.width : axis.width,
        height: axisType === 'yAxis' ? offset.height : axis.height,
        x: x, y: y
      });
    }

    /**
     * Get the content to be displayed in the tooltip
     * @param  {Object} data  The data of active item
     * @param  {Object} xAxis The configuration of x-axis
     * @param  {Object} yAxis The configuration of y-axis
     * @param  {Object} zAxis The configuration of z-axis
     * @return {Array}        The content of tooltip
     */

  }, {
    key: 'getTooltipContent',
    value: function getTooltipContent(data, xAxis, yAxis, zAxis) {
      if (!data) {
        return null;
      }

      var payload = data.payload,
          node = data.node;


      var content = [{
        name: xAxis.name || xAxis.dataKey,
        unit: xAxis.unit || '',
        value: node.x,
        payload: payload
      }, {
        name: yAxis.name || yAxis.dataKey,
        unit: yAxis.unit || '',
        value: node.y,
        payload: payload
      }];

      if (node.z && node.z !== '-') {
        content.push({
          name: zAxis.name || zAxis.dataKey,
          unit: zAxis.unit || '',
          value: node.z,
          payload: payload
        });
      }

      return content;
    }
    /**
     * The handler of mouse entering a scatter
     * @param {Object} el The active scatter
     * @param {Object} e  Event object
     * @return {Object} no return
     */


    /**
     * The handler of mouse leaving a scatter
     * @return {Object} no return
     */

  }, {
    key: 'renderTooltip',


    /**
     * Draw Tooltip
     * @param  {Array} items   The instances of Scatter
     * @param  {Object} xAxis  The configuration of x-axis
     * @param  {Object} yAxis  The configuration of y-axis
     * @param  {Object} zAxis  The configuration of z-axis
     * @param  {Object} offset The offset of main part in the svg element
     * @return {ReactElement}  The instance of Tooltip
     */
    value: function renderTooltip(items, xAxis, yAxis, zAxis, offset) {
      var children = this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeItem = _state.activeItem,
          activeTooltipCoord = _state.activeTooltipCoord;

      var viewBox = {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        label: '',
        payload: this.getTooltipContent(activeItem, xAxis, yAxis, zAxis),
        coordinate: activeTooltipCoord
      });
    }

    /**
     * Draw grid
     * @param  {Object} xAxis  The configuration of x-axis
     * @param  {Object} yAxis  The configuration of y-axis
     * @param  {Object} offset The offset of main part in the svg element
     * @return {ReactElement} The instance of grid
     */

  }, {
    key: 'renderGrid',
    value: function renderGrid(xAxis, yAxis, offset) {
      var _props2 = this.props,
          children = _props2.children,
          width = _props2.width,
          height = _props2.height;

      var gridItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__cartesian_CartesianGrid__["a" /* default */]);

      if (!gridItem) {
        return null;
      }

      var verticalPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["a" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__["a" /* default */].defaultProps, xAxis, {
        ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["b" /* getTicksOfAxis */])(xAxis, true),
        viewBox: { x: 0, y: 0, width: width, height: height }
      })), offset.left, offset.left + offset.width);

      var horizontalPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["a" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__["a" /* default */].defaultProps, yAxis, {
        ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["b" /* getTicksOfAxis */])(yAxis, true),
        viewBox: { x: 0, y: 0, width: width, height: height }
      })), offset.top, offset.top + offset.height);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(gridItem, {
        key: 'grid',
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height,
        verticalPoints: verticalPoints,
        horizontalPoints: horizontalPoints
      });
    }
    /**
     * Draw legend
     * @param  {Array} items     The instances of Scatters
     * @return {ReactElement}    The instance of Legend
     */

  }, {
    key: 'renderLegend',
    value: function renderLegend(items) {
      var _this2 = this;

      var _props3 = this.props,
          children = _props3.children,
          width = _props3.width,
          height = _props3.height,
          margin = _props3.margin;

      var legendWidth = width - (margin.left || 0) - (margin.right || 0);
      var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
      var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["m" /* getLegendProps */])(children, items, legendWidth, legendHeight);

      if (!props) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__component_Legend__["a" /* default */], _extends({}, props, {
        chartWidth: width,
        chartHeight: height,
        margin: margin,
        ref: function ref(legend) {
          _this2.legendInstance = legend;
        },
        onBBoxUpdate: this.handleLegendBBoxUpdate
      }));
    }

    /**
     * Draw axis
     * @param {Object} axis     The configuration of axis
     * @param {String} layerKey The key of layer
     * @return {ReactElement}   The instance of axis
     */

  }, {
    key: 'renderAxis',
    value: function renderAxis(axis, layerKey) {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height;


      if (axis && !axis.hide) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
          { key: layerKey, className: layerKey },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__cartesian_CartesianAxis__["a" /* default */], _extends({}, axis, {
            viewBox: { x: 0, y: 0, width: width, height: height },
            ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_CartesianUtils__["b" /* getTicksOfAxis */])(axis, true)
          }))
        );
      }

      return null;
    }
  }, {
    key: 'renderCursor',
    value: function renderCursor(xAxis, yAxis, offset) {
      var children = this.props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_7__component_Tooltip__["a" /* default */]);

      if (!tooltipItem || !tooltipItem.props.cursor || !this.state.isTooltipActive) {
        return null;
      }
      var activeItem = this.state.activeItem;


      var cursorProps = _extends({
        stroke: '#ccc',
        strokeDasharray: '5 5'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["b" /* getPresentationAttributes */])(tooltipItem.props.cursor), offset, {
        x: activeItem.cx,
        y: activeItem.cy,
        payload: activeItem
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(tooltipItem.props.cursor) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(tooltipItem.props.cursor, cursorProps) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Cross__["a" /* default */], cursorProps);
    }

    /**
     * Draw the main part of scatter chart
     * @param  {Array} items   All the instance of Scatter
     * @param  {Object} xAxis  The configuration of all x-axis
     * @param  {Object} yAxis  The configuration of all y-axis
     * @param  {Object} zAxis  The configuration of all z-axis
     * @param  {Object} offset The offset of main part in the svg element
     * @return {ReactComponent}  All the instances of Scatter
     */

  }, {
    key: 'renderItems',
    value: function renderItems(items, xAxis, yAxis, zAxis, offset) {
      var _this3 = this;

      var activeGroupId = this.state.activeGroupId;

      return items.map(function (child, i) {
        var _child$props = child.props,
            strokeWidth = _child$props.strokeWidth,
            data = _child$props.data;


        var finalStrokeWidth = strokeWidth === +strokeWidth ? strokeWidth : 1;
        finalStrokeWidth = activeGroupId === 'scatter-' + i ? finalStrokeWidth + 2 : finalStrokeWidth;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({
          key: child.key || 'scatter-' + i,
          groupId: 'scatter-' + i,
          strokeWidth: finalStrokeWidth,
          onMouseLeave: _this3.handleScatterMouseLeave,
          onMouseEnter: _this3.handleScatterMouseEnter,
          points: _this3.getComposedData(child, data, xAxis, yAxis, zAxis)
        }, offset, {
          xAxis: xAxis,
          yAxis: yAxis
        }));
      }, this);
    }
  }, {
    key: 'renderReferenceElements',
    value: function renderReferenceElements(xAxis, yAxis, offset, isFront, Compt) {
      var children = this.props.children;

      var elements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["d" /* findAllByType */])(children, Compt);

      if (!elements || !elements.length) {
        return null;
      }

      var keyPrefix = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["f" /* getDisplayName */])(Compt) + '-' + (isFront ? 'front' : 'back');

      return elements.filter(function (entry) {
        return isFront === entry.props.isFront;
      }).map(function (entry, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(entry, {
          key: keyPrefix + '-' + i,
          xAxis: xAxis, yAxis: yAxis,
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["e" /* validateWidthHeight */])(this)) {
        return null;
      }

      // eslint-disable-next-line no-unused-vars

      var _props5 = this.props,
          style = _props5.style,
          children = _props5.children,
          className = _props5.className,
          width = _props5.width,
          height = _props5.height,
          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["d" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__cartesian_Scatter__["a" /* default */]);
      var zAxis = this.getZAxis(items);
      var xAxis = this.getAxis('xAxis', items);
      var yAxis = this.getAxis('yAxis', items);

      var offset = this.getOffset(items, xAxis, yAxis);
      xAxis = this.getFormatAxis(xAxis, offset, 'xAxis');
      yAxis = this.getFormatAxis(yAxis, offset, 'yAxis');
      var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* filterEventAttributes */])(this.props);
      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-wrapper', className),
          style: { position: 'relative', cursor: 'default', width: width, height: height }
        }, events),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderGrid(xAxis, yAxis, offset),
          this.renderReferenceElements(xAxis, yAxis, offset, false, __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceArea__["a" /* default */]),
          this.renderReferenceElements(xAxis, yAxis, offset, false, __WEBPACK_IMPORTED_MODULE_15__cartesian_ReferenceLine__["a" /* default */]),
          this.renderReferenceElements(xAxis, yAxis, offset, false, __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceDot__["a" /* default */]),
          this.renderAxis(xAxis, 'recharts-x-axis'),
          this.renderAxis(yAxis, 'recharts-y-axis'),
          this.renderCursor(xAxis, yAxis, offset),
          this.renderItems(items, xAxis, yAxis, zAxis, offset),
          this.renderReferenceElements(xAxis, yAxis, offset, true, __WEBPACK_IMPORTED_MODULE_17__cartesian_ReferenceArea__["a" /* default */]),
          this.renderReferenceElements(xAxis, yAxis, offset, true, __WEBPACK_IMPORTED_MODULE_15__cartesian_ReferenceLine__["a" /* default */]),
          this.renderReferenceElements(xAxis, yAxis, offset, true, __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceDot__["a" /* default */]),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderLegend(items),
        this.renderTooltip(items, xAxis, yAxis, zAxis, offset)
      );
    }
  }]);

  return ScatterChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'ScatterChart', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["j" /* EVENT_ATTRIBUTES */], {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  margin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}), _class2.defaultProps = {
  style: {},
  margin: { top: 5, right: 5, bottom: 5, left: 5 }
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ScatterChart);

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Rectangle__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DataUtils__ = __webpack_require__(32);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview TreemapChart
 */













var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
      node = _ref.node,
      index = _ref.index,
      valueKey = _ref.valueKey;
  var children = node.children;

  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
  }) : null;
  var value = void 0;

  if (children && children.length) {
    value = computedChildren.reduce(function (result, child) {
      return result + child.value;
    }, 0);
  } else {
    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }

  return _extends({}, node, {
    children: computedChildren,
    value: value, depth: depth, index: index
  });
};

var filterRect = function filterRect(node) {
  return { x: node.x, y: node.y, width: node.width, height: node.height };
};

// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;

  return children.map(function (child) {
    var area = child.value * ratio;

    return _extends({}, child, {
      area: isNaN(area) || area <= 0 ? 0 : area
    });
  });
};

// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;

  var _row$reduce = row.reduce(function (result, child) {
    return {
      min: Math.min(result.min, child.area),
      max: Math.max(result.max, child.area)
    };
  }, { min: Infinity, max: 0 }),
      min = _row$reduce.min,
      max = _row$reduce.max;

  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};

var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }

  var curX = parentRect.x;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  }
  // what's z
  child.z = true;
  // add the remain x to the last one of row
  child.width += parentRect.x + parentRect.width - curX;

  return _extends({}, parentRect, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};

var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }

  var curY = parentRect.y;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }
  child.z = false;
  child.height += parentRect.y + parentRect.height - curY;

  return _extends({}, parentRect, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};

var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }

  return verticalPosition(row, parentSize, parentRect, isFlush);
};

// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
  var children = node.children;

  if (children && children.length) {
    var rect = filterRect(node);
    var row = [];
    var best = Infinity; // the best row score so far
    var child = void 0,
        score = void 0; // the current row score
    var size = Math.min(rect.width, rect.height); // initial orientation
    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
    var tempChildren = scaleChildren.slice();

    row.area = 0;

    while (tempChildren.length > 0) {
      // row first
      row.push(child = tempChildren[0]);
      row.area += child.area;

      score = getWorstScore(row, size, aspectRatio);
      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }

    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }

    return _extends({}, node, { children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      }) });
  }

  return node;
};

var Treemap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Treemap, _Component);

  function Treemap() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Treemap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Treemap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState(this.createDefaultState());
      }
    }
    /**
     * Returns default, reset state for the treemap chart.
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState() {
      return {
        isTooltipActive: false,
        activeNode: null
      };
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(node, e) {
      var _props = this.props,
          onMouseEnter = _props.onMouseEnter,
          children = _props.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: true,
          activeNode: node
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(node, e);
      }
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(node, e) {
      var _props2 = this.props,
          onMouseLeave = _props2.onMouseLeave,
          children = _props2.children;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false,
          activeNode: null
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(node, e);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(node) {
      var onClick = this.props.onClick;


      if (onClick) {
        onClick(node);
      }
    }
  }, {
    key: 'renderAnimatedItem',
    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
      var _this2 = this;

      var _props3 = this.props,
          isAnimationActive = _props3.isAnimationActive,
          animationBegin = _props3.animationBegin,
          animationDuration = _props3.animationDuration,
          animationEasing = _props3.animationEasing,
          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
      var width = nodeProps.width,
          height = nodeProps.height,
          x = nodeProps.x,
          y = nodeProps.y;

      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
      var event = {};

      if (isLeaf) {
        event = {
          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
          onClick: this.handleClick.bind(this, nodeProps)
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
        {
          from: { x: x, y: y, width: width, height: height },
          to: { x: x, y: y, width: width, height: height },
          duration: animationDuration,
          easing: animationEasing,
          isActive: isUpdateAnimationActive
        },
        function (_ref3) {
          var currX = _ref3.x,
              currY = _ref3.y,
              currWidth = _ref3.width,
              currHeight = _ref3.height;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
            {
              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
              to: 'translate(0, 0)',
              attributeName: 'transform',
              begin: animationBegin,
              easing: animationEasing,
              isActive: isAnimationActive,
              duration: animationDuration
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
              event,
              _this2.renderContentItem(content, _extends({}, nodeProps, {
                isAnimationActive: isAnimationActive,
                isUpdateAnimationActive: !isUpdateAnimationActive,
                width: currWidth,
                height: currHeight,
                x: currX,
                y: currY
              }))
            )
          );
        }
      );
    }
  }, {
    key: 'renderContentItem',
    value: function renderContentItem(content, nodeProps) {
      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(content)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(content, nodeProps);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
        return content(nodeProps);
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Rectangle__["a" /* default */], _extends({
        fill: '#fff',
        stroke: '#000'
      }, nodeProps));
    }
  }, {
    key: 'renderNode',
    value: function renderNode(root, node, i) {
      var _this3 = this;

      var content = this.props.content;

      var nodeProps = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(this.props), node, { root: root });
      var isLeaf = !node.children || !node.children.length;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
        this.renderAnimatedItem(content, nodeProps, isLeaf),
        node.children && node.children.length ? node.children.map(function (child, index) {
          return _this3.renderNode(node, child, index);
        }) : null
      );
    }
  }, {
    key: 'renderAllNodes',
    value: function renderAllNodes() {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height,
          data = _props4.data,
          dataKey = _props4.dataKey,
          aspectRatio = _props4.aspectRatio;


      var root = computeNode({
        depth: 0,
        node: { children: data, x: 0, y: 0, width: width, height: height },
        index: 0,
        valueKey: dataKey
      });

      var formatRoot = squarify(root, aspectRatio);

      return this.renderNode(formatRoot, formatRoot, 0);
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props5 = this.props,
          children = _props5.children,
          nameKey = _props5.nameKey;

      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _props6 = this.props,
          width = _props6.width,
          height = _props6.height,
          dataKey = _props6.dataKey;
      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeNode = _state.activeNode;

      var viewBox = { x: 0, y: 0, width: width, height: height };
      var coordinate = activeNode ? {
        x: activeNode.x + activeNode.width / 2,
        y: activeNode.y + activeNode.height / 2
      } : null;
      var payload = isTooltipActive && activeNode ? [{
        payload: activeNode,
        name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["h" /* getValueByDataKey */])(activeNode, nameKey, ''),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_DataUtils__["h" /* getValueByDataKey */])(activeNode, dataKey)
      }] : [];

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["e" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props7 = this.props,
          width = _props7.width,
          height = _props7.height,
          className = _props7.className,
          style = _props7.style,
          children = _props7.children,
          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);

      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderAllNodes(),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderTooltip()
      );
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Treemap', _class2.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  aspectRatio: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  fill: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  nameKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}, _class2.defaultProps = {
  dataKey: 'value',
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["h" /* isSsr */])(),
  isUpdateAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Treemap);

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Surface__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shape_Symbols__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Default Legend Content
 */







var SIZE = 32;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["m" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var DefaultLegendContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(DefaultLegendContent, _Component);

  function DefaultLegendContent() {
    _classCallCheck(this, DefaultLegendContent);

    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
  }

  _createClass(DefaultLegendContent, [{
    key: 'renderIcon',


    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    value: function renderIcon(data) {
      var color = data.color;

      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;

      if (data.type === 'line') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          strokeWidth: 4,
          fill: 'none',
          stroke: color,
          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
          className: 'recharts-legend-icon'
        });
      } else if (data.type === 'rect') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          stroke: 'none',
          fill: color,
          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
          className: 'recharts-legend-icon'
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shape_Symbols__["a" /* default */], {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: 'diameter',
        type: data.type
      });
    }

    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */

  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _this2 = this;

      var _props = this.props,
          payload = _props.payload,
          iconSize = _props.iconSize,
          layout = _props.layout,
          formatter = _props.formatter;

      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };

      return payload.map(function (entry, i) {
        var finalFormatter = entry.formatter || formatter;

        if (entry.type === 'none') {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          _extends({
            className: 'recharts-legend-item legend-item-' + i,
            style: itemStyle,
            key: 'legend-item-' + i
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["l" /* filterEventsOfChild */])(_this2.props, entry, i)),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__container_Surface__["a" /* default */],
            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
            _this2.renderIcon(entry, iconSize)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'recharts-legend-item-text' },
            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          payload = _props2.payload,
          layout = _props2.layout,
          align = _props2.align;


      if (!payload || !payload.length) {
        return null;
      }

      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'recharts-default-legend', style: finalStyle },
        this.renderItems()
      );
    }
  }]);

  return DefaultLegendContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Legend', _class2.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["m" /* LEGEND_TYPES */])
  })),
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (DefaultLegendContent);

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(32);

 /**
                                        * @fileOverview Default Tooltip Content
                                        */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var defaultFormatter = function defaultFormatter(value) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["k" /* isNumOrStr */])(value[0]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["k" /* isNumOrStr */])(value[1]) ? value.join(' ~ ') : value;
};

var DefaultTooltipContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(DefaultTooltipContent, _Component);

  function DefaultTooltipContent() {
    _classCallCheck(this, DefaultTooltipContent);

    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
  }

  _createClass(DefaultTooltipContent, [{
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          payload = _props.payload,
          separator = _props.separator,
          formatter = _props.formatter,
          itemStyle = _props.itemStyle,
          itemSorter = _props.itemSorter;


      if (payload && payload.length) {
        var listStyle = { padding: 0, margin: 0 };

        var items = payload.filter(function (entry) {
          return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry.value);
        }).sort(itemSorter).map(function (entry, i) {
          var finalItemStyle = _extends({
            display: 'block',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000'
          }, itemStyle);
          var finalFormatter = entry.formatter || formatter || defaultFormatter;

          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'li',
            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
            entry.name ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-name' },
              entry.name
            ) : null,
            entry.name ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-separator' },
              separator
            ) : null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-value' },
              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-unit' },
              entry.unit || ''
            )
          );
        });

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'ul',
          { className: 'recharts-tooltip-item-list', style: listStyle },
          items
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          labelStyle = _props2.labelStyle,
          label = _props2.label,
          labelFormatter = _props2.labelFormatter,
          wrapperStyle = _props2.wrapperStyle;

      var finalStyle = _extends({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
      }, wrapperStyle);
      var finalLabelStyle = _extends({
        margin: 0
      }, labelStyle);
      var hasLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["k" /* isNumOrStr */])(label);
      var finalLabel = hasLabel ? label : '';

      if (hasLabel && labelFormatter) {
        finalLabel = labelFormatter(label);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'recharts-default-tooltip', style: finalStyle },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'p',
          { className: 'recharts-tooltip-label', style: finalLabelStyle },
          finalLabel
        ),
        this.renderContent()
      );
    }
  }]);

  return DefaultTooltipContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
  separator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  itemStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
  })),
  itemSorter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
}, _class2.defaultProps = {
  separator: ' : ',
  itemStyle: {},
  labelStyle: {}
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (DefaultTooltipContent);

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resize_detector__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_LogUtils__ = __webpack_require__(430);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */







var ResponsiveContainer = (_temp = _class = function (_Component) {
  _inherits(ResponsiveContainer, _Component);

  function ResponsiveContainer(props) {
    _classCallCheck(this, ResponsiveContainer);

    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));

    _this.updateDimensionsImmediate = function () {
      if (!_this.mounted) {
        return;
      }

      var newSize = _this.getContainerSize();

      if (newSize) {
        var _this$state = _this.state,
            oldWidth = _this$state.containerWidth,
            oldHeight = _this$state.containerHeight;
        var containerWidth = newSize.containerWidth,
            containerHeight = newSize.containerHeight;


        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
        }
      }
    };

    _this.state = {
      containerWidth: -1,
      containerHeight: -1
    };

    _this.handleResize = props.debounce > 0 ? __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
    return _this;
  }

  /* eslint-disable  react/no-did-mount-set-state */


  _createClass(ResponsiveContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;

      var size = this.getContainerSize();

      if (size) {
        this.setState(size);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'getContainerSize',
    value: function getContainerSize() {
      if (!this.container) {
        return null;
      }

      return {
        containerWidth: this.container.clientWidth,
        containerHeight: this.container.clientHeight
      };
    }
  }, {
    key: 'renderChart',
    value: function renderChart() {
      var _state = this.state,
          containerWidth = _state.containerWidth,
          containerHeight = _state.containerHeight;


      if (containerWidth < 0 || containerHeight < 0) {
        return null;
      }

      var _props = this.props,
          aspect = _props.aspect,
          width = _props.width,
          height = _props.height,
          minWidth = _props.minWidth,
          minHeight = _props.minHeight,
          maxHeight = _props.maxHeight,
          children = _props.children;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_LogUtils__["a" /* warn */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["p" /* isPercent */])(width) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["p" /* isPercent */])(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_LogUtils__["a" /* warn */])(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);

      var calculatedWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["p" /* isPercent */])(width) ? containerWidth : width;
      var calculatedHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["p" /* isPercent */])(height) ? containerHeight : height;

      if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight > maxHeight) {
          calculatedHeight = maxHeight;
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_LogUtils__["a" /* warn */])(calculatedWidth > 0 && calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        width: calculatedWidth,
        height: calculatedHeight
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          minWidth = _props2.minWidth,
          minHeight = _props2.minHeight,
          width = _props2.width,
          height = _props2.height,
          maxHeight = _props2.maxHeight;

      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: 'recharts-responsive-container',
          style: style,
          ref: function ref(node) {
            _this2.container = node;
          }
        },
        this.renderChart(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_resize_detector___default.a, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
      );
    }
  }]);

  return ResponsiveContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
  aspect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  minWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  maxHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  debounce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
}, _class.defaultProps = {
  width: '100%',
  height: '100%',
  debounce: 0
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ResponsiveContainer);

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__);

/* eslint no-proto: 0 */
var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  (function () {
    var nativeGetPrototypeOf = Object.getPrototypeOf;

    Object.getPrototypeOf = function (object) {
      if (object.__proto__) {
        return object.__proto__;
      }

      return nativeGetPrototypeOf.call(Object, object);
    };
  })();
}

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYNC_EVENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);


var eventCenter = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}


var SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2326);
__webpack_require__(2327);
__webpack_require__(2328);
__webpack_require__(2329);
__webpack_require__(2330);
__webpack_require__(2331);
__webpack_require__(2332);
__webpack_require__(2333);
__webpack_require__(2334);
__webpack_require__(2335);
__webpack_require__(2336);
__webpack_require__(2337);
__webpack_require__(2338);
__webpack_require__(2339);
__webpack_require__(2340);
__webpack_require__(2341);
__webpack_require__(2342);
module.exports = __webpack_require__(431).Math;

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(434);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(2315);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(434)
  , document = __webpack_require__(433).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(432) && !__webpack_require__(296)(function(){
  return Object.defineProperty(__webpack_require__(2318)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(2316)
  , IE8_DOM_DEFINE = __webpack_require__(2320)
  , toPrimitive    = __webpack_require__(2324)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(432) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(433)
  , hide      = __webpack_require__(861)
  , has       = __webpack_require__(2319)
  , SRC       = __webpack_require__(2325)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(431).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(434);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(62)
  , log1p   = __webpack_require__(862)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(62)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(62)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(62)
  , sign    = __webpack_require__(436);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(62)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(62)
  , $expm1  = __webpack_require__(435);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(62)
  , sign      = __webpack_require__(436)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(62)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(62)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(296)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {log1p: __webpack_require__(862)});

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {sign: __webpack_require__(436)});

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(62)
  , expm1   = __webpack_require__(435)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(296)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(62)
  , expm1   = __webpack_require__(435)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(62);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(71);
var invariant = __webpack_require__(21);
var ReactPropTypesSecret = __webpack_require__(2344);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */
var balanced = __webpack_require__(2346)
var reduceFunctionCall = __webpack_require__(2347)
var mexp = __webpack_require__(2155)

/**
 * Constantes
 */
var MAX_STACK = 100 // should be enough for a single calc()...
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g

/**
 * Global variables
 */
var stack

/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */
module.exports = reduceCSSCalc

/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */
function reduceCSSCalc(value, decimalPrecision) {
  stack = 0
  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)

  // Allow calc() on multiple lines
  value = value.replace(/\n+/g, " ")

  /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateExpression (expression, functionIdentifier, call) {
    if (stack++ > MAX_STACK) {
      stack = 0
      throw new Error("Call stack overflow for " + call)
    }

    if (expression === "") {
      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
    }

    expression = evaluateNestedExpression(expression, call)

    var units = getUnitsInExpression(expression)

    // If the expression contains multiple units or CSS variables,
    // then let the expression be (i.e. browser calc())
    if (units.length > 1 || expression.indexOf("var(") > -1) {
      return functionIdentifier + "(" + expression + ")"
    }

    var unit = units[0] || ""

    if (unit === "%") {
      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
      // console.log(expression)
      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
        return parseFloat(percent.slice(0, -1)) * 0.01
      })
    }

    // Remove units in expression:
    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
    var result

    try {
      result = mexp.eval(toEvaluate)
    }
    catch (e) {
      return functionIdentifier + "(" + expression + ")"
    }

    // Transform back to a percentage result:
    if (unit === "%") {
      result *= 100
    }

    // adjust rounding shit
    // (0.1 * 0.2 === 0.020000000000000004)
    if (functionIdentifier.length || unit === "%") {
      result = Math.round(result * decimalPrecision) / decimalPrecision
    }

    // Add unit
    result += unit

    return result
  }

  /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateNestedExpression(expression, call) {
    // Remove the calc part from nested expressions to ensure
    // better browser compatibility
    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
    var evaluatedPart = ""
    var nonEvaluatedPart = expression
    var matches
    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
      if (matches[0].index > 0) {
        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
      }

      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
      if (balancedExpr.body === "") {
        throw new Error("'" + expression + "' must contain a non-whitespace string")
      }

      var evaluated = evaluateExpression(balancedExpr.body, "", call)

      evaluatedPart += balancedExpr.pre + evaluated
      nonEvaluatedPart = balancedExpr.post
    }

    return evaluatedPart + nonEvaluatedPart
  }

  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
}

/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */

function getUnitsInExpression(expression) {
  var uniqueUnits = []
  var uniqueLowerCaseUnits = []
  var unitRegEx = /[\.0-9]([%a-z]+)/gi
  var matches = unitRegEx.exec(expression)

  while (matches) {
    if (!matches || !matches[1]) {
      continue
    }

    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
      uniqueUnits.push(matches[1])
      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
    }

    matches = unitRegEx.exec(expression)
  }

  return uniqueUnits
}


/***/ }),
/* 2346 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Module dependencies
 */
var balanced = __webpack_require__(1596)

/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */
module.exports = reduceFunctionCall

/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */

function reduceFunctionCall(string, functionRE, callback) {
  var call = string
  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
  }, string)
}

/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */

function getFunctionCalls(call, functionRE) {
  var expressions = []

  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
  do {
    var searchMatch = fnRE.exec(call)
    if (!searchMatch) {
      return expressions
    }
    if (searchMatch[1] === undefined) {
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
    }
    var fn = searchMatch[1]
    var startIndex = searchMatch.index
    var matches = balanced("(", ")", call.substring(startIndex))

    if (!matches || matches.start !== searchMatch[0].length - 1) {
      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
    }

    expressions.push({matches: matches, functionIdentifier: fn})
    call = matches.post
  }
  while (fnRE.test(call))

  return expressions
}

/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */

function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
  // allow recursivity
  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
}


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PubSub = function () {
  function PubSub() {
    _classCallCheck(this, PubSub);

    this.container = [];
  }

  _createClass(PubSub, [{
    key: "push",
    value: function push(cb) {
      cb instanceof Function && this.container.push(cb);
    }
  }, {
    key: "resolve",
    value: function resolve(data) {
      var container = this.container;
      this.container = [];
      container.forEach(function (cb) {
        return cb(null, data);
      });
    }
  }, {
    key: "reject",
    value: function reject(err) {
      var container = this.container;
      this.container = [];
      container.forEach(function (cb) {
        return cb(err);
      });
    }
  }]);

  return PubSub;
}();

exports.default = PubSub;
module.exports = exports["default"];
//# sourceMappingURL=PubSub.js.map

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = actionFn;

var _fastApply = __webpack_require__(1981);

var _fastApply2 = _interopRequireDefault(_fastApply);

var _url = __webpack_require__(870);

var _url2 = _interopRequireDefault(_url);

var _urlTransform = __webpack_require__(2356);

var _urlTransform2 = _interopRequireDefault(_urlTransform);

var _merge = __webpack_require__(863);

var _merge2 = _interopRequireDefault(_merge);

var _get = __webpack_require__(2357);

var _get2 = _interopRequireDefault(_get);

var _fetchResolver = __webpack_require__(2352);

var _fetchResolver2 = _interopRequireDefault(_fetchResolver);

var _PubSub = __webpack_require__(2348);

var _PubSub2 = _interopRequireDefault(_PubSub);

var _createHolder = __webpack_require__(2351);

var _createHolder2 = _interopRequireDefault(_createHolder);

var _helpers = __webpack_require__(2353);

var _cache = __webpack_require__(437);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constructor for create action
 * @param  {String} url          endpoint's url
 * @param  {String} name         action name
 * @param  {Object} options      action configuration
 * @param  {Object} ACTIONS      map of actions
 * @param  {[type]} fetchAdapter adapter for fetching data
 * @return {Function+Object}     action function object
 */
function actionFn(url, name, options) {
  var ACTIONS = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var meta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var actionFetch = ACTIONS.actionFetch,
      actionSuccess = ACTIONS.actionSuccess,
      actionFail = ACTIONS.actionFail,
      actionReset = ACTIONS.actionReset,
      actionCache = ACTIONS.actionCache,
      actionAbort = ACTIONS.actionAbort;

  var pubsub = new _PubSub2.default();
  var requestHolder = (0, _createHolder2.default)();

  function getOptions(urlT, params, getState) {
    var globalOptions = !meta.holder ? {} : meta.holder.options instanceof Function ? meta.holder.options(urlT, params, getState) : meta.holder.options;
    var baseOptions = !(options instanceof Function) ? options : options(urlT, params, getState);
    return (0, _merge2.default)({}, globalOptions, baseOptions, params);
  }

  function getUrl(pathvars, params, getState) {
    var resultUrlT = (0, _urlTransform2.default)(url, pathvars, meta.urlOptions);
    var urlT = resultUrlT;
    var rootUrl = (0, _get2.default)(meta, "holder", "rootUrl");
    rootUrl = !(rootUrl instanceof Function) ? rootUrl : rootUrl(urlT, params, getState);
    if (rootUrl) {
      var rootUrlObject = _url2.default.parse(rootUrl);
      var urlObject = _url2.default.parse(urlT);
      if (!urlObject.host) {
        var urlPath = (rootUrlObject.path ? rootUrlObject.path.replace(/\/$/, "") : "") + "/" + (urlObject.path ? urlObject.path.replace(/^\//, "") : "");
        urlT = rootUrlObject.protocol + "//" + rootUrlObject.host + urlPath;
      }
    }
    return urlT;
  }

  function fetch(pathvars, params) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _helpers.none;
    var dispatch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _helpers.none;

    var urlT = getUrl(pathvars, params, getState);
    var opts = getOptions(urlT, params, getState);
    var id = meta.reducerName || "";
    var cacheManager = (0, _cache.getCacheManager)(options.expire, meta.cache);

    if (cacheManager && getState !== _helpers.none) {
      var state = getState();
      var cache = (0, _get2.default)(state, meta.prefix, meta.reducerName, "cache");
      id += "_" + cacheManager.id(pathvars, params);
      var data = cacheManager.getData(cache && id && cache[id] !== undefined && cache[id]);
      if (data !== undefined) {
        return Promise.resolve(data);
      }
    }
    var response = meta.fetch(urlT, opts);
    if (cacheManager && dispatch !== _helpers.none && id) {
      response.then(function (data) {
        dispatch({ type: actionCache, id: id, data: data, expire: cacheManager.expire });
      });
    }
    return response;
  }

  function abort() {
    var defer = requestHolder.pop();
    var err = new Error("Application abort request");
    defer && defer.reject(err);
    return err;
  }

  /**
   * Fetch data from server
   * @param  {Object}   pathvars    path vars for url
   * @param  {Object}   params      fetch params
   * @param  {Function} getState    helper meta function
  */
  function request(pathvars, params, options) {
    var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _helpers.none;
    var dispatch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _helpers.none;

    var response = fetch(pathvars, params, options, getState, dispatch);
    var result = !meta.validation ? response : response.then(function (data) {
      return new Promise(function (resolve, reject) {
        return meta.validation(data, function (err) {
          return err ? reject(err) : resolve(data);
        });
      });
    });
    var ret = result;
    var responseHandler = (0, _get2.default)(meta, "holder", "responseHandler");
    if (responseHandler) {
      if (result && result.then) {
        ret = result.then(function (data) {
          var res = responseHandler(null, data);
          if (res === undefined) {
            return data;
          } else {
            return res;
          }
        }, function (err) {
          return responseHandler(err);
        });
      } else {
        ret = responseHandler(result);
      }
    }
    ret && ret.catch && ret.catch(_helpers.none);
    return ret;
  }

  /**
   * Fetch data from server
   * @param  {Object}   pathvars    path vars for url
   * @param  {Object}   params      fetch params
   * @param  {Function} callback)   callback execute after end request
   */
  function fn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _extractArgs = (0, _helpers.extractArgs)(args),
        _extractArgs2 = _slicedToArray(_extractArgs, 3),
        pathvars = _extractArgs2[0],
        params = _extractArgs2[1],
        callback = _extractArgs2[2];

    var syncing = params ? !!params.syncing : false;
    params && delete params.syncing;
    pubsub.push(callback);
    return function () {
      var middlewareParser = (0, _get2.default)(meta, "holder", "middlewareParser") || _helpers.defaultMiddlewareArgsParser;

      var _middlewareParser = middlewareParser.apply(undefined, arguments),
          dispatch = _middlewareParser.dispatch,
          getState = _middlewareParser.getState;

      var state = getState();
      var isLoading = (0, _get2.default)(state, meta.prefix, meta.reducerName, "loading");
      if (isLoading) {
        return Promise.reject("isLoading");
      }
      var requestOptions = { pathvars: pathvars, params: params };
      var prevData = (0, _get2.default)(state, meta.prefix, meta.reducerName, "data");
      dispatch({ type: actionFetch, syncing: syncing, request: requestOptions });
      var fetchResolverOpts = {
        dispatch: dispatch,
        getState: getState,
        request: requestOptions,
        actions: meta.actions,
        prefetch: meta.prefetch
      };
      if (Object.defineProperty) {
        Object.defineProperty(fetchResolverOpts, "requestOptions", {
          get: function get() {
            /* eslint no-console: 0 */
            console.warn("Deprecated option, use `request` option");
            return requestOptions;
          }
        });
      } else {
        fetchResolverOpts.requestOptions = requestOptions;
      }

      var result = new Promise(function (done, fail) {
        (0, _fetchResolver2.default)(0, fetchResolverOpts, function (err) {
          if (err) {
            pubsub.reject(err);
            return fail(err);
          }
          new Promise(function (resolve, reject) {
            requestHolder.set({
              resolve: resolve,
              reject: reject,
              promise: request(pathvars, params, {}, getState, dispatch).then(resolve, reject)
            });
          }).then(function (d) {
            requestHolder.pop();
            var data = meta.transformer(d, prevData, {
              type: actionSuccess, request: requestOptions
            });
            dispatch({
              data: data,
              origData: d,
              type: actionSuccess,
              syncing: false,
              request: requestOptions
            });
            if (meta.broadcast) {
              meta.broadcast.forEach(function (type) {
                dispatch({ type: type, data: data, origData: d, request: requestOptions });
              });
            }
            if (meta.postfetch) {
              meta.postfetch.forEach(function (postfetch) {
                postfetch instanceof Function && postfetch({
                  data: data, getState: getState, dispatch: dispatch, actions: meta.actions, request: requestOptions
                });
              });
            }
            pubsub.resolve(data);
            done(data);
          }, function (error) {
            dispatch({
              error: error,
              type: actionFail,
              loading: false,
              syncing: false,
              request: requestOptions
            });
            pubsub.reject(error);
            fail(error);
          });
        });
      });
      result.catch(_helpers.none);
      return result;
    };
  }

  /*
    Pure rest request
   */
  fn.request = function (pathvars, params, options) {
    return request(pathvars, params, options || {});
  };

  /**
   * Reset store to initial state
   */
  fn.reset = function (mutation) {
    abort();
    return mutation === "sync" ? { type: actionReset, mutation: mutation } : { type: actionReset };
  };

  /*
    Abort request
   */
  fn.abort = function () {
    var error = abort();
    return { type: actionAbort, error: error };
  };

  fn.force = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return function (dispatch, getState) {
      var state = getState();
      var isLoading = (0, _get2.default)(state, meta.prefix, meta.reducerName, "loading");
      if (isLoading) {
        dispatch(fn.abort());
      }
      return fn.apply(undefined, args)(dispatch, getState);
    };
  };

  /**
   * Sync store with server. In server mode works as usual method.
   * If data have already synced, data would not fetch after call this method.
   * @param  {Object} pathvars    path vars for url
   * @param  {Object} params      fetch params
   * @param  {Function} callback) callback execute after end request
   */
  fn.sync = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var _extractArgs3 = (0, _helpers.extractArgs)(args),
        _extractArgs4 = _slicedToArray(_extractArgs3, 3),
        pathvars = _extractArgs4[0],
        params = _extractArgs4[1],
        callback = _extractArgs4[2];

    var isServer = meta.holder ? meta.holder.server : false;
    return function (dispatch, getState) {
      var state = getState();
      var store = state[name];
      if (!isServer && store && store.sync) {
        callback(null, store.data);
        return;
      }
      var modifyParams = _extends({}, params, { syncing: true });
      return fn(pathvars, modifyParams, callback)(dispatch, getState);
    };
  };

  var helpers = meta.helpers || {};
  if (meta.crud) {
    helpers = _extends({}, _helpers.CRUD, helpers);
  }
  var fnHelperCallback = function fnHelperCallback(memo, func, helpername) {
    if (memo[helpername]) {
      throw new Error("Helper name: \"" + helpername + "\" for endpoint \"" + name + "\" has been already reserved");
    }

    var _ref = func instanceof Function ? { call: func } : func,
        sync = _ref.sync,
        call = _ref.call;

    memo[helpername] = function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return function (dispatch, getState) {
        var index = args.length - 1;
        var callbackFn = args[index] instanceof Function ? args[index] : _helpers.none;
        var helpersResult = (0, _fastApply2.default)(call, { getState: getState, dispatch: dispatch, actions: meta.actions }, args);
        var result = new Promise(function (resolve, reject) {
          var callback = function callback(err, data) {
            err ? reject(err) : resolve(data);
            callbackFn(err, data);
          };
          // If helper alias using async functionality
          if (helpersResult instanceof Function) {
            helpersResult(function (error) {
              var newArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

              if (error) {
                callback(error);
              } else {
                (0, _fastApply2.default)(sync ? fn.sync : fn, null, newArgs.concat(callback))(dispatch, getState);
              }
            });
          } else {
            // if helper alias is synchronous
            var _helpersResult = _slicedToArray(helpersResult, 2),
                pathvars = _helpersResult[0],
                params = _helpersResult[1];

            (0, _fastApply2.default)(sync ? fn.sync : fn, null, [pathvars, params, callback])(dispatch, getState);
          }
        });
        result.catch(_helpers.none);
        return result;
      };
    };
    return memo;
  };

  return Object.keys(helpers).reduce(function (memo, key) {
    return fnHelperCallback(memo, helpers[key], key, helpers);
  }, fn);
}
module.exports = exports["default"];
//# sourceMappingURL=actionFn.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = async;
/**
 *
 * @param  {[type]}    dispatch [description]
 * @param  {...[type]} args     [description]
 * @return {[type]}             [description]
 * @example
 * async(dispatch,
 *   cb=> actions.test(1, cb),
 *   actions.test2
 * ).then(()=> async(dispatch, actions.test3))
 */
function async(dispatch) {
  for (var _len = arguments.length, restFunctions = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    restFunctions[_key - 2] = arguments[_key];
  }

  var currentFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return new Promise(function (resolve, reject) {
    if (!currentFunction) {
      reject("no chain function");
    } else {
      dispatch(currentFunction(function (err, data) {
        err ? reject(err) : resolve(data);
      }) || {});
    }
  }).then(function (data) {
    if (restFunctions.length) {
      return async.apply(undefined, [dispatch].concat(restFunctions));
    } else {
      return data;
    }
  });
}
module.exports = exports["default"];
//# sourceMappingURL=async.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var data = void 0;
  var hasData = false;
  return {
    set: function set(val) {
      if (!hasData) {
        data = val;
        hasData = true;
        return true;
      }
      return false;
    },
    empty: function empty() {
      return !hasData;
    },
    pop: function pop() {
      if (hasData) {
        hasData = false;
        var result = data;
        data = null;
        return result;
      }
    }
  };
};

module.exports = exports["default"];
//# sourceMappingURL=createHolder.js.map

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchResolver;
function none() {}

function fetchResolver() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : none;

  if (!opts.prefetch || index >= opts.prefetch.length) {
    cb();
  } else {
    opts.prefetch[index](opts, function (err) {
      return err ? cb(err) : fetchResolver(index + 1, opts, cb);
    });
  }
}
module.exports = exports["default"];
//# sourceMappingURL=fetchResolver.js.map

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.none = none;
exports.extractArgs = extractArgs;
exports.helperCrudFunction = helperCrudFunction;
exports.defaultMiddlewareArgsParser = defaultMiddlewareArgsParser;
function none() {}

function extractArgs(args) {
  var pathvars = void 0;
  var params = {};
  var callback = void 0;
  if (args[0] instanceof Function) {
    callback = args[0];
  } else if (args[1] instanceof Function) {
    pathvars = args[0];
    callback = args[1];
  } else {
    pathvars = args[0];
    params = args[1];
    callback = args[2] || none;
  }
  return [pathvars, params, callback];
}

function helperCrudFunction(name) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _extractArgs = extractArgs(args),
        _extractArgs2 = _slicedToArray(_extractArgs, 3),
        pathvars = _extractArgs2[0],
        params = _extractArgs2[1],
        cb = _extractArgs2[2];

    return [pathvars, _extends({}, params, { method: name.toUpperCase() }), cb];
  };
}

function defaultMiddlewareArgsParser(dispatch, getState) {
  return { dispatch: dispatch, getState: getState };
}

var CRUD = exports.CRUD = ["get", "post", "put", "delete", "patch"].reduce(function (memo, name) {
  memo[name] = helperCrudFunction(name);
  return memo;
}, {});
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-case-declarations: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducerFn;

var _cache = __webpack_require__(437);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Reducer contructor
 * @param  {Object}   initialState default initial state
 * @param  {Object}   actions      actions map
 * @param  {Function} reducer      custom reducer function
 * @return {Function}              reducer function
 */
function reducerFn(initialState) {
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reducer = arguments[2];
  var actionFetch = actions.actionFetch,
      actionSuccess = actions.actionSuccess,
      actionFail = actions.actionFail,
      actionReset = actions.actionReset,
      actionCache = actions.actionCache,
      actionAbort = actions.actionAbort;

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var params = action.params || {};
    switch (action.type) {
      case actionFetch:
        return _extends({}, state, {
          pathvars: action.pathvars || {},
          body: params.body || {},
          loading: true,
          error: null,
          syncing: !!action.syncing
        });
      case actionSuccess:
        return _extends({}, state, {
          loading: false,
          sync: true,
          syncing: false,
          error: null,
          data: action.data
        });
      case actionFail:
        return _extends({}, state, {
          loading: false,
          error: action.error,
          syncing: false
        });
      case actionReset:
        var mutation = action.mutation;

        return mutation === "sync" ? _extends({}, state, {
          pathvars: {},
          body: {},
          sync: false }) : _extends({}, initialState);
      case actionAbort:
        return _extends({}, state, {
          pathvars: {},
          body: {},
          loading: false,
          syncing: false,
          error: action.error
        });
      case actionCache:
        var id = action.id,
            data = action.data;

        var cacheExpire = state.cache[id] ? state.cache[id].expire : null;
        var expire = (0, _cache.setExpire)(action.expire, cacheExpire);
        return _extends({}, state, {
          cache: _extends({}, state.cache, _defineProperty({}, id, { expire: expire, data: data }))
        });
      default:
        return reducer ? reducer(state, action) : state;
    }
  };
}
module.exports = exports["default"];
//# sourceMappingURL=reducerFn.js.map

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toString = Object.prototype.toString;
var OBJECT = "[object Object]";

/**
 * Default responce transformens
 */
exports.default = {
  array: function array(data) {
    return !data ? [] : Array.isArray(data) ? data : [data];
  },
  object: function object(data) {
    if (!data) {
      return {};
    }
    return toString.call(data) === OBJECT ? data : { data: data };
  }
};
module.exports = exports["default"];
//# sourceMappingURL=transformers.js.map

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = urlTransform;

var _qs = __webpack_require__(2359);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(870);

var _omit = __webpack_require__(2358);

var _omit2 = _interopRequireDefault(_omit);

var _merge = __webpack_require__(863);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-useless-escape: 0 */
var rxClean = /(\(:[^\)]+\)|:[^\/]+\/?)/g;

/**
 * Url modification
 * @param  {String} url     url template
 * @param  {Object} params  params for url template
 * @param  {Object} options transformation options, accepts +delimiter+, +arrayFormat+,
 *                          +qsStringifyOptions+ and +qsParseOptions+
 * @return {String}         result url
 */
function urlTransform(url, params, options) {
  if (!url) {
    return "";
  }
  params || (params = {});
  var usedKeys = {};
  var urlWithParams = Object.keys(params).reduce(function (url, key) {
    var value = params[key];
    var rx = new RegExp("(\\(:" + key + "\\)|:" + key + ")(/?)", "g");
    return url.replace(rx, function (_, _1, slash) {
      usedKeys[key] = value;
      return value ? value + slash : value;
    });
  }, url);

  if (!urlWithParams) {
    return urlWithParams;
  }

  var _parse = (0, _url.parse)(urlWithParams),
      protocol = _parse.protocol,
      host = _parse.host,
      path = _parse.path;

  var cleanURL = host ? protocol + "//" + host + path.replace(rxClean, "") : path.replace(rxClean, "");
  var usedKeysArray = Object.keys(usedKeys);
  if (usedKeysArray.length !== Object.keys(params).length) {
    var urlObject = cleanURL.split("?");
    options || (options = {});
    var _options = options,
        arrayFormat = _options.arrayFormat,
        delimiter = _options.delimiter;

    var qsParseOptions = _extends({
      arrayFormat: arrayFormat,
      delimiter: delimiter
    }, options.qsParseOptions);
    var mergeParams = (0, _merge2.default)(urlObject[1] && _qs2.default.parse(urlObject[1], qsParseOptions), (0, _omit2.default)(params, usedKeysArray));
    var qsStringifyOptions = _extends({
      arrayFormat: arrayFormat,
      delimiter: delimiter
    }, options.qsStringifyOptions);
    var urlStringParams = _qs2.default.stringify(mergeParams, qsStringifyOptions);
    return urlObject[0] + "?" + urlStringParams;
  }
  return cleanURL;
}
module.exports = exports["default"];
//# sourceMappingURL=urlTransform.js.map

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-void: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function isEmpty(name) {
  return name === "" || name === null || name === void 0;
}

function get(obj) {
  for (var _len = arguments.length, path = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    path[_key - 1] = arguments[_key];
  }

  return path.reduce(function (memo, name) {
    return Array.isArray(name) ? get.apply(undefined, [memo].concat(_toConsumableArray(name))) : isEmpty(name) ? memo : memo && memo[name];
  }, obj);
}

exports.default = get;
module.exports = exports["default"];
//# sourceMappingURL=get.js.map

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (object, props) {
  if (!Array.isArray(props)) {
    return _extends({}, object);
  }

  return Object.keys(object || {}).reduce(function (memo, key) {
    if (props.indexOf(key) === -1) {
      memo[key] = object[key];
    }
    return memo;
  }, {});
};

module.exports = exports["default"];
//# sourceMappingURL=omit.js.map

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Stringify = __webpack_require__(2361);
var Parse = __webpack_require__(2360);


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(864);


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';

            if (options.strictNullHandling) {
                obj[Utils.decode(part)] = null;
            }
        }
        else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = val;
            }
            else {
                obj[key] = [].concat(obj[key]).concat(val);
            }
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(864);


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(865);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(867);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Promise) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(26)))

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(158);
var define = __webpack_require__(1904);
var hasDescriptors = __webpack_require__(626)();
var gOPD = __webpack_require__(625);

var $TypeError = GetIntrinsic('%TypeError%');
var $floor = GetIntrinsic('%Math.floor%');

module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(fn, 'length', length, true, true);
		} else {
			define(fn, 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(158);
var callBound = __webpack_require__(1597);
var inspect = __webpack_require__(2161);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(2371);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56), __webpack_require__(2380)(module)))

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.7 */

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Tether = factory();
  }
}(this, function() {

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = undefined;
if (typeof TetherBase === 'undefined') {
  TetherBase = { modules: [] };
}

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  try {
    if (node.ownerDocument !== document) {
      var _frameElement = node.ownerDocument.defaultView.frameElement;
      if (_frameElement) {
        var frameRect = getActualBoundingClientRect(_frameElement);
        rect.top += frameRect.top;
        rect.bottom += frameRect.top;
        rect.left += frameRect.left;
        rect.right += frameRect.left;
      }
    }
  } catch (err) {
    // Ignore "Access is denied" in IE11/Edge
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node || !document.body.contains(node)) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

var _scrollBarSize = null;
function getScrollBarSize() {
  if (_scrollBarSize) {
    return _scrollBarSize;
  }
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  _scrollBarSize = { width: width, height: width };
  return _scrollBarSize;
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};
/* globals TetherBase, performance */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof TetherBase === 'undefined') {
  throw new Error('You must include the utils.js file before tether.js');
}

var _TetherBase$Utils = TetherBase.Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    TetherBase.modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < TetherBase.modules.length; ++i) {
        var _module2 = TetherBase.modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (win.innerHeight > doc.documentElement.clientHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (win.innerWidth > doc.documentElement.clientWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          if (typeof window.devicePixelRatio === 'number' && devicePixelRatio % 1 === 0) {
            xPos = Math.round(xPos * devicePixelRatio) / devicePixelRatio;
            yPos = Math.round(yPos * devicePixelRatio) / devicePixelRatio;
          }

          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        if (this.options.bodyElement) {
          if (this.element.parentNode !== this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          }
        } else {
          var isFullscreenElement = function isFullscreenElement(e) {
            var d = e.ownerDocument;
            var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
            return fe === e;
          };

          var offsetParentIsBody = true;

          var currentNode = this.element.parentNode;
          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY' && !isFullscreenElement(currentNode)) {
            if (getComputedStyle(currentNode).position !== 'static') {
              offsetParentIsBody = false;
              break;
            }

            currentNode = currentNode.parentNode;
          }

          if (!offsetParentIsBody) {
            this.element.parentNode.removeChild(this.element);
            this.element.ownerDocument.body.appendChild(this.element);
          }
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

TetherBase.position = position;

var Tether = extend(TetherClass, TetherBase);
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});
/* globals TetherBase */

'use strict';

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

TetherBase.modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});
return Tether;

}));


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(868);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2374 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.37',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(2379)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(2378);
var parse = __webpack_require__(2377);
var formats = __webpack_require__(438);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(869);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(2368);
var utils = __webpack_require__(869);
var formats = __webpack_require__(438);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 2379 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 2381 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(871);
__webpack_require__(874);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(439);
module.exports = __webpack_require__(875);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle1785210165087.js